import './facade.css';
var Z6e = Object.defineProperty;
var y3e = (e) => {
  throw TypeError(e);
};
var Q6e = (e, t, i) => t in e ? Z6e(e, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[t] = i;
var Zi = (e, t, i) => Q6e(e, typeof t != "symbol" ? t + "" : t, i), kue = (e, t, i) => t.has(e) || y3e("Cannot " + i);
var S = (e, t, i) => (kue(e, t, "read from private field"), i ? i.call(e) : t.get(e)), xe = (e, t, i) => t.has(e) ? y3e("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, i), be = (e, t, i, n) => (kue(e, t, "write to private field"), n ? n.call(e, i) : t.set(e, i), i), _e = (e, t, i) => (kue(e, t, "access private method"), i);
var hp = (e, t, i, n) => ({
  set _(s) {
    be(e, t, s, i);
  },
  get _() {
    return S(e, t, n);
  }
});
import Ms, { forwardRef as cE, useState as Is, useRef as io, useEffect as vr, useMemo as Vu, useCallback as On, useId as Z4e, createContext as J6e, useContext as X6e, Fragment as Q4e, useReducer as eDe, useImperativeHandle as tDe, isValidElement as iDe, useLayoutEffect as J4e } from "react";
const zs = (e) => typeof e == "string", hZ = () => {
  let e, t;
  const i = new Promise((n, s) => {
    e = n, t = s;
  });
  return i.resolve = e, i.reject = t, i;
}, E3e = (e) => e == null ? "" : "" + e, nDe = (e, t, i) => {
  e.forEach((n) => {
    t[n] && (i[n] = t[n]);
  });
}, sDe = /###/g, g3e = (e) => e && e.indexOf("###") > -1 ? e.replace(sDe, ".") : e, w3e = (e) => !e || zs(e), EJ = (e, t, i) => {
  const n = zs(t) ? t.split(".") : t;
  let s = 0;
  for (; s < n.length - 1; ) {
    if (w3e(e)) return {};
    const o = g3e(n[s]);
    !e[o] && i && (e[o] = new i()), Object.prototype.hasOwnProperty.call(e, o) ? e = e[o] : e = {}, ++s;
  }
  return w3e(e) ? {} : {
    obj: e,
    k: g3e(n[s])
  };
}, T3e = (e, t, i) => {
  const {
    obj: n,
    k: s
  } = EJ(e, t, Object);
  if (n !== void 0 || t.length === 1) {
    n[s] = i;
    return;
  }
  let o = t[t.length - 1], r = t.slice(0, t.length - 1), l = EJ(e, r, Object);
  for (; l.obj === void 0 && r.length; )
    o = `${r[r.length - 1]}.${o}`, r = r.slice(0, r.length - 1), l = EJ(e, r, Object), l != null && l.obj && typeof l.obj[`${l.k}.${o}`] < "u" && (l.obj = void 0);
  l.obj[`${l.k}.${o}`] = i;
}, oDe = (e, t, i, n) => {
  const {
    obj: s,
    k: o
  } = EJ(e, t, Object);
  s[o] = s[o] || [], s[o].push(i);
}, Ure = (e, t) => {
  const {
    obj: i,
    k: n
  } = EJ(e, t);
  if (i && Object.prototype.hasOwnProperty.call(i, n))
    return i[n];
}, rDe = (e, t, i) => {
  const n = Ure(e, i);
  return n !== void 0 ? n : Ure(t, i);
}, X4e = (e, t, i) => {
  for (const n in t)
    n !== "__proto__" && n !== "constructor" && (n in e ? zs(e[n]) || e[n] instanceof String || zs(t[n]) || t[n] instanceof String ? i && (e[n] = t[n]) : X4e(e[n], t[n], i) : e[n] = t[n]);
  return e;
}, Mk = (e) => e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var lDe = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const aDe = (e) => zs(e) ? e.replace(/[&<>"'\/]/g, (t) => lDe[t]) : e;
class uDe {
  constructor(t) {
    this.capacity = t, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(t) {
    const i = this.regExpMap.get(t);
    if (i !== void 0)
      return i;
    const n = new RegExp(t);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(t, n), this.regExpQueue.push(t), n;
  }
}
const dDe = [" ", ",", "?", "!", ";"], cDe = new uDe(20), hDe = (e, t, i) => {
  t = t || "", i = i || "";
  const n = dDe.filter((r) => t.indexOf(r) < 0 && i.indexOf(r) < 0);
  if (n.length === 0) return !0;
  const s = cDe.getRegExp(`(${n.map((r) => r === "?" ? "\\?" : r).join("|")})`);
  let o = !s.test(e);
  if (!o) {
    const r = e.indexOf(i);
    r > 0 && !s.test(e.substring(0, r)) && (o = !0);
  }
  return o;
}, f0e = (e, t, i = ".") => {
  if (!e) return;
  if (e[t])
    return Object.prototype.hasOwnProperty.call(e, t) ? e[t] : void 0;
  const n = t.split(i);
  let s = e;
  for (let o = 0; o < n.length; ) {
    if (!s || typeof s != "object")
      return;
    let r, l = "";
    for (let c = o; c < n.length; ++c)
      if (c !== o && (l += i), l += n[c], r = s[l], r !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof r) > -1 && c < n.length - 1)
          continue;
        o += c - o + 1;
        break;
      }
    s = r;
  }
  return s;
}, eX = (e) => e == null ? void 0 : e.replace("_", "-"), fDe = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    var i, n;
    (n = (i = console == null ? void 0 : console[e]) == null ? void 0 : i.apply) == null || n.call(i, console, t);
  }
};
class Bre {
  constructor(t, i = {}) {
    this.init(t, i);
  }
  init(t, i = {}) {
    this.prefix = i.prefix || "i18next:", this.logger = t || fDe, this.options = i, this.debug = i.debug;
  }
  log(...t) {
    return this.forward(t, "log", "", !0);
  }
  warn(...t) {
    return this.forward(t, "warn", "", !0);
  }
  error(...t) {
    return this.forward(t, "error", "");
  }
  deprecate(...t) {
    return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, i, n, s) {
    return s && !this.debug ? null : (zs(t[0]) && (t[0] = `${n}${this.prefix} ${t[0]}`), this.logger[i](t));
  }
  create(t) {
    return new Bre(this.logger, {
      prefix: `${this.prefix}:${t}:`,
      ...this.options
    });
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new Bre(this.logger, t);
  }
}
var uN = new Bre();
class uae {
  constructor() {
    this.observers = {};
  }
  on(t, i) {
    return t.split(" ").forEach((n) => {
      this.observers[n] || (this.observers[n] = /* @__PURE__ */ new Map());
      const s = this.observers[n].get(i) || 0;
      this.observers[n].set(i, s + 1);
    }), this;
  }
  off(t, i) {
    if (this.observers[t]) {
      if (!i) {
        delete this.observers[t];
        return;
      }
      this.observers[t].delete(i);
    }
  }
  emit(t, ...i) {
    this.observers[t] && Array.from(this.observers[t].entries()).forEach(([s, o]) => {
      for (let r = 0; r < o; r++)
        s(...i);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach(([s, o]) => {
      for (let r = 0; r < o; r++)
        s.apply(s, [t, ...i]);
    });
  }
}
class R3e extends uae {
  constructor(t, i = {
    ns: ["translation"],
    defaultNS: "translation"
  }) {
    super(), this.data = t || {}, this.options = i, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const i = this.options.ns.indexOf(t);
    i > -1 && this.options.ns.splice(i, 1);
  }
  getResource(t, i, n, s = {}) {
    var h, I;
    const o = s.keySeparator !== void 0 ? s.keySeparator : this.options.keySeparator, r = s.ignoreJSONStructure !== void 0 ? s.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let l;
    t.indexOf(".") > -1 ? l = t.split(".") : (l = [t, i], n && (Array.isArray(n) ? l.push(...n) : zs(n) && o ? l.push(...n.split(o)) : l.push(n)));
    const c = Ure(this.data, l);
    return !c && !i && !n && t.indexOf(".") > -1 && (t = l[0], i = l[1], n = l.slice(2).join(".")), c || !r || !zs(n) ? c : f0e((I = (h = this.data) == null ? void 0 : h[t]) == null ? void 0 : I[i], n, o);
  }
  addResource(t, i, n, s, o = {
    silent: !1
  }) {
    const r = o.keySeparator !== void 0 ? o.keySeparator : this.options.keySeparator;
    let l = [t, i];
    n && (l = l.concat(r ? n.split(r) : n)), t.indexOf(".") > -1 && (l = t.split("."), s = i, i = l[1]), this.addNamespaces(i), T3e(this.data, l, s), o.silent || this.emit("added", t, i, n, s);
  }
  addResources(t, i, n, s = {
    silent: !1
  }) {
    for (const o in n)
      (zs(n[o]) || Array.isArray(n[o])) && this.addResource(t, i, o, n[o], {
        silent: !0
      });
    s.silent || this.emit("added", t, i, n);
  }
  addResourceBundle(t, i, n, s, o, r = {
    silent: !1,
    skipCopy: !1
  }) {
    let l = [t, i];
    t.indexOf(".") > -1 && (l = t.split("."), s = n, n = i, i = l[1]), this.addNamespaces(i);
    let c = Ure(this.data, l) || {};
    r.skipCopy || (n = JSON.parse(JSON.stringify(n))), s ? X4e(c, n, o) : c = {
      ...c,
      ...n
    }, T3e(this.data, l, c), r.silent || this.emit("added", t, i, n);
  }
  removeResourceBundle(t, i) {
    this.hasResourceBundle(t, i) && delete this.data[t][i], this.removeNamespaces(i), this.emit("removed", t, i);
  }
  hasResourceBundle(t, i) {
    return this.getResource(t, i) !== void 0;
  }
  getResourceBundle(t, i) {
    return i || (i = this.options.defaultNS), this.getResource(t, i);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const i = this.getDataByLanguage(t);
    return !!(i && Object.keys(i) || []).find((s) => i[s] && Object.keys(i[s]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var eTe = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, i, n, s) {
    return e.forEach((o) => {
      var r;
      t = ((r = this.processors[o]) == null ? void 0 : r.process(t, i, n, s)) ?? t;
    }), t;
  }
};
const tTe = Symbol("i18next/PATH_KEY");
function IDe() {
  const e = [], t = /* @__PURE__ */ Object.create(null);
  let i;
  return t.get = (n, s) => {
    var o;
    return (o = i == null ? void 0 : i.revoke) == null || o.call(i), s === tTe ? e : (e.push(s), i = Proxy.revocable(n, t), i.proxy);
  }, Proxy.revocable(/* @__PURE__ */ Object.create(null), t).proxy;
}
function I0e(e, t) {
  const {
    [tTe]: i
  } = e(IDe());
  return i.join((t == null ? void 0 : t.keySeparator) ?? ".");
}
const v3e = {}, Vue = (e) => !zs(e) && typeof e != "boolean" && typeof e != "number";
class Fre extends uae {
  constructor(t, i = {}) {
    super(), nDe(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = i, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = uN.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t, i = {
    interpolation: {}
  }) {
    const n = {
      ...i
    };
    if (t == null) return !1;
    const s = this.resolve(t, n);
    if ((s == null ? void 0 : s.res) === void 0) return !1;
    const o = Vue(s.res);
    return !(n.returnObjects === !1 && o);
  }
  extractFromKey(t, i) {
    let n = i.nsSeparator !== void 0 ? i.nsSeparator : this.options.nsSeparator;
    n === void 0 && (n = ":");
    const s = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator;
    let o = i.ns || this.options.defaultNS || [];
    const r = n && t.indexOf(n) > -1, l = !this.options.userDefinedKeySeparator && !i.keySeparator && !this.options.userDefinedNsSeparator && !i.nsSeparator && !hDe(t, n, s);
    if (r && !l) {
      const c = t.match(this.interpolator.nestingRegexp);
      if (c && c.length > 0)
        return {
          key: t,
          namespaces: zs(o) ? [o] : o
        };
      const h = t.split(n);
      (n !== s || n === s && this.options.ns.indexOf(h[0]) > -1) && (o = h.shift()), t = h.join(s);
    }
    return {
      key: t,
      namespaces: zs(o) ? [o] : o
    };
  }
  translate(t, i, n) {
    let s = typeof i == "object" ? {
      ...i
    } : i;
    if (typeof s != "object" && this.options.overloadTranslationOptionHandler && (s = this.options.overloadTranslationOptionHandler(arguments)), typeof s == "object" && (s = {
      ...s
    }), s || (s = {}), t == null) return "";
    typeof t == "function" && (t = I0e(t, {
      ...this.options,
      ...s
    })), Array.isArray(t) || (t = [String(t)]);
    const o = s.returnDetails !== void 0 ? s.returnDetails : this.options.returnDetails, r = s.keySeparator !== void 0 ? s.keySeparator : this.options.keySeparator, {
      key: l,
      namespaces: c
    } = this.extractFromKey(t[t.length - 1], s), h = c[c.length - 1];
    let I = s.nsSeparator !== void 0 ? s.nsSeparator : this.options.nsSeparator;
    I === void 0 && (I = ":");
    const p = s.lng || this.language, y = s.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if ((p == null ? void 0 : p.toLowerCase()) === "cimode")
      return y ? o ? {
        res: `${h}${I}${l}`,
        usedKey: l,
        exactUsedKey: l,
        usedLng: p,
        usedNS: h,
        usedParams: this.getUsedParamsDetails(s)
      } : `${h}${I}${l}` : o ? {
        res: l,
        usedKey: l,
        exactUsedKey: l,
        usedLng: p,
        usedNS: h,
        usedParams: this.getUsedParamsDetails(s)
      } : l;
    const m = this.resolve(t, s);
    let A = m == null ? void 0 : m.res;
    const C = (m == null ? void 0 : m.usedKey) || l, O = (m == null ? void 0 : m.exactUsedKey) || l, R = ["[object Number]", "[object Function]", "[object RegExp]"], F = s.joinArrays !== void 0 ? s.joinArrays : this.options.joinArrays, L = !this.i18nFormat || this.i18nFormat.handleAsObject, P = s.count !== void 0 && !zs(s.count), z = Fre.hasDefaultValue(s), W = P ? this.pluralResolver.getSuffix(p, s.count, s) : "", re = s.ordinal && P ? this.pluralResolver.getSuffix(p, s.count, {
      ordinal: !1
    }) : "", ce = P && !s.ordinal && s.count === 0, te = ce && s[`defaultValue${this.options.pluralSeparator}zero`] || s[`defaultValue${W}`] || s[`defaultValue${re}`] || s.defaultValue;
    let ee = A;
    L && !A && z && (ee = te);
    const Ne = Vue(ee), Ae = Object.prototype.toString.apply(ee);
    if (L && ee && Ne && R.indexOf(Ae) < 0 && !(zs(F) && Array.isArray(ee))) {
      if (!s.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const Oe = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(C, ee, {
          ...s,
          ns: c
        }) : `key '${l} (${this.language})' returned an object instead of string.`;
        return o ? (m.res = Oe, m.usedParams = this.getUsedParamsDetails(s), m) : Oe;
      }
      if (r) {
        const Oe = Array.isArray(ee), pe = Oe ? [] : {}, je = Oe ? O : C;
        for (const Ve in ee)
          if (Object.prototype.hasOwnProperty.call(ee, Ve)) {
            const $e = `${je}${r}${Ve}`;
            z && !A ? pe[Ve] = this.translate($e, {
              ...s,
              defaultValue: Vue(te) ? te[Ve] : void 0,
              joinArrays: !1,
              ns: c
            }) : pe[Ve] = this.translate($e, {
              ...s,
              joinArrays: !1,
              ns: c
            }), pe[Ve] === $e && (pe[Ve] = ee[Ve]);
          }
        A = pe;
      }
    } else if (L && zs(F) && Array.isArray(A))
      A = A.join(F), A && (A = this.extendTranslation(A, t, s, n));
    else {
      let Oe = !1, pe = !1;
      !this.isValidLookup(A) && z && (Oe = !0, A = te), this.isValidLookup(A) || (pe = !0, A = l);
      const Ve = (s.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && pe ? void 0 : A, $e = z && te !== A && this.options.updateMissing;
      if (pe || Oe || $e) {
        if (this.logger.log($e ? "updateKey" : "missingKey", p, h, l, $e ? te : A), r) {
          const mt = this.resolve(l, {
            ...s,
            keySeparator: !1
          });
          mt && mt.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let vt = [];
        const Rt = this.languageUtils.getFallbackCodes(this.options.fallbackLng, s.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && Rt && Rt[0])
          for (let mt = 0; mt < Rt.length; mt++)
            vt.push(Rt[mt]);
        else this.options.saveMissingTo === "all" ? vt = this.languageUtils.toResolveHierarchy(s.lng || this.language) : vt.push(s.lng || this.language);
        const ze = (mt, Et, it) => {
          var Ct;
          const Dt = z && it !== A ? it : Ve;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(mt, h, Et, Dt, $e, s) : (Ct = this.backendConnector) != null && Ct.saveMissing && this.backendConnector.saveMissing(mt, h, Et, Dt, $e, s), this.emit("missingKey", mt, h, Et, A);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && P ? vt.forEach((mt) => {
          const Et = this.pluralResolver.getSuffixes(mt, s);
          ce && s[`defaultValue${this.options.pluralSeparator}zero`] && Et.indexOf(`${this.options.pluralSeparator}zero`) < 0 && Et.push(`${this.options.pluralSeparator}zero`), Et.forEach((it) => {
            ze([mt], l + it, s[`defaultValue${it}`] || te);
          });
        }) : ze(vt, l, te));
      }
      A = this.extendTranslation(A, t, s, m, n), pe && A === l && this.options.appendNamespaceToMissingKey && (A = `${h}${I}${l}`), (pe || Oe) && this.options.parseMissingKeyHandler && (A = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${h}${I}${l}` : l, Oe ? A : void 0, s));
    }
    return o ? (m.res = A, m.usedParams = this.getUsedParamsDetails(s), m) : A;
  }
  extendTranslation(t, i, n, s, o) {
    var c, h;
    if ((c = this.i18nFormat) != null && c.parse)
      t = this.i18nFormat.parse(t, {
        ...this.options.interpolation.defaultVariables,
        ...n
      }, n.lng || this.language || s.usedLng, s.usedNS, s.usedKey, {
        resolved: s
      });
    else if (!n.skipInterpolation) {
      n.interpolation && this.interpolator.init({
        ...n,
        interpolation: {
          ...this.options.interpolation,
          ...n.interpolation
        }
      });
      const I = zs(t) && (((h = n == null ? void 0 : n.interpolation) == null ? void 0 : h.skipOnVariables) !== void 0 ? n.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let p;
      if (I) {
        const m = t.match(this.interpolator.nestingRegexp);
        p = m && m.length;
      }
      let y = n.replace && !zs(n.replace) ? n.replace : n;
      if (this.options.interpolation.defaultVariables && (y = {
        ...this.options.interpolation.defaultVariables,
        ...y
      }), t = this.interpolator.interpolate(t, y, n.lng || this.language || s.usedLng, n), I) {
        const m = t.match(this.interpolator.nestingRegexp), A = m && m.length;
        p < A && (n.nest = !1);
      }
      !n.lng && s && s.res && (n.lng = this.language || s.usedLng), n.nest !== !1 && (t = this.interpolator.nest(t, (...m) => (o == null ? void 0 : o[0]) === m[0] && !n.context ? (this.logger.warn(`It seems you are nesting recursively key: ${m[0]} in key: ${i[0]}`), null) : this.translate(...m, i), n)), n.interpolation && this.interpolator.reset();
    }
    const r = n.postProcess || this.options.postProcess, l = zs(r) ? [r] : r;
    return t != null && (l != null && l.length) && n.applyPostProcessor !== !1 && (t = eTe.handle(l, t, i, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...s,
        usedParams: this.getUsedParamsDetails(n)
      },
      ...n
    } : n, this)), t;
  }
  resolve(t, i = {}) {
    let n, s, o, r, l;
    return zs(t) && (t = [t]), t.forEach((c) => {
      if (this.isValidLookup(n)) return;
      const h = this.extractFromKey(c, i), I = h.key;
      s = I;
      let p = h.namespaces;
      this.options.fallbackNS && (p = p.concat(this.options.fallbackNS));
      const y = i.count !== void 0 && !zs(i.count), m = y && !i.ordinal && i.count === 0, A = i.context !== void 0 && (zs(i.context) || typeof i.context == "number") && i.context !== "", C = i.lngs ? i.lngs : this.languageUtils.toResolveHierarchy(i.lng || this.language, i.fallbackLng);
      p.forEach((O) => {
        var R, F;
        this.isValidLookup(n) || (l = O, !v3e[`${C[0]}-${O}`] && ((R = this.utils) != null && R.hasLoadedNamespace) && !((F = this.utils) != null && F.hasLoadedNamespace(l)) && (v3e[`${C[0]}-${O}`] = !0, this.logger.warn(`key "${s}" for languages "${C.join(", ")}" won't get resolved as namespace "${l}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), C.forEach((L) => {
          var W;
          if (this.isValidLookup(n)) return;
          r = L;
          const P = [I];
          if ((W = this.i18nFormat) != null && W.addLookupKeys)
            this.i18nFormat.addLookupKeys(P, I, L, O, i);
          else {
            let re;
            y && (re = this.pluralResolver.getSuffix(L, i.count, i));
            const ce = `${this.options.pluralSeparator}zero`, te = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (y && (i.ordinal && re.indexOf(te) === 0 && P.push(I + re.replace(te, this.options.pluralSeparator)), P.push(I + re), m && P.push(I + ce)), A) {
              const ee = `${I}${this.options.contextSeparator || "_"}${i.context}`;
              P.push(ee), y && (i.ordinal && re.indexOf(te) === 0 && P.push(ee + re.replace(te, this.options.pluralSeparator)), P.push(ee + re), m && P.push(ee + ce));
            }
          }
          let z;
          for (; z = P.pop(); )
            this.isValidLookup(n) || (o = z, n = this.getResource(L, O, z, i));
        }));
      });
    }), {
      res: n,
      usedKey: s,
      exactUsedKey: o,
      usedLng: r,
      usedNS: l
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, i, n, s = {}) {
    var o;
    return (o = this.i18nFormat) != null && o.getResource ? this.i18nFormat.getResource(t, i, n, s) : this.resourceStore.getResource(t, i, n, s);
  }
  getUsedParamsDetails(t = {}) {
    const i = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], n = t.replace && !zs(t.replace);
    let s = n ? t.replace : t;
    if (n && typeof t.count < "u" && (s.count = t.count), this.options.interpolation.defaultVariables && (s = {
      ...this.options.interpolation.defaultVariables,
      ...s
    }), !n) {
      s = {
        ...s
      };
      for (const o of i)
        delete s[o];
    }
    return s;
  }
  static hasDefaultValue(t) {
    const i = "defaultValue";
    for (const n in t)
      if (Object.prototype.hasOwnProperty.call(t, n) && i === n.substring(0, i.length) && t[n] !== void 0)
        return !0;
    return !1;
  }
}
class A3e {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = uN.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = eX(t), !t || t.indexOf("-") < 0) return null;
    const i = t.split("-");
    return i.length === 2 || (i.pop(), i[i.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(i.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = eX(t), !t || t.indexOf("-") < 0) return t;
    const i = t.split("-");
    return this.formatLanguageCode(i[0]);
  }
  formatLanguageCode(t) {
    if (zs(t) && t.indexOf("-") > -1) {
      let i;
      try {
        i = Intl.getCanonicalLocales(t)[0];
      } catch {
      }
      return i && this.options.lowerCaseLng && (i = i.toLowerCase()), i || (this.options.lowerCaseLng ? t.toLowerCase() : t);
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t) return null;
    let i;
    return t.forEach((n) => {
      if (i) return;
      const s = this.formatLanguageCode(n);
      (!this.options.supportedLngs || this.isSupportedCode(s)) && (i = s);
    }), !i && this.options.supportedLngs && t.forEach((n) => {
      if (i) return;
      const s = this.getScriptPartFromCode(n);
      if (this.isSupportedCode(s)) return i = s;
      const o = this.getLanguagePartFromCode(n);
      if (this.isSupportedCode(o)) return i = o;
      i = this.options.supportedLngs.find((r) => {
        if (r === o) return r;
        if (!(r.indexOf("-") < 0 && o.indexOf("-") < 0) && (r.indexOf("-") > 0 && o.indexOf("-") < 0 && r.substring(0, r.indexOf("-")) === o || r.indexOf(o) === 0 && o.length > 1))
          return r;
      });
    }), i || (i = this.getFallbackCodes(this.options.fallbackLng)[0]), i;
  }
  getFallbackCodes(t, i) {
    if (!t) return [];
    if (typeof t == "function" && (t = t(i)), zs(t) && (t = [t]), Array.isArray(t)) return t;
    if (!i) return t.default || [];
    let n = t[i];
    return n || (n = t[this.getScriptPartFromCode(i)]), n || (n = t[this.formatLanguageCode(i)]), n || (n = t[this.getLanguagePartFromCode(i)]), n || (n = t.default), n || [];
  }
  toResolveHierarchy(t, i) {
    const n = this.getFallbackCodes((i === !1 ? [] : i) || this.options.fallbackLng || [], t), s = [], o = (r) => {
      r && (this.isSupportedCode(r) ? s.push(r) : this.logger.warn(`rejecting language code not found in supportedLngs: ${r}`));
    };
    return zs(t) && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && o(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && o(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && o(this.getLanguagePartFromCode(t))) : zs(t) && o(this.formatLanguageCode(t)), n.forEach((r) => {
      s.indexOf(r) < 0 && o(this.formatLanguageCode(r));
    }), s;
  }
}
const S3e = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, b3e = {
  select: (e) => e === 1 ? "one" : "other",
  resolvedOptions: () => ({
    pluralCategories: ["one", "other"]
  })
};
class pDe {
  constructor(t, i = {}) {
    this.languageUtils = t, this.options = i, this.logger = uN.create("pluralResolver"), this.pluralRulesCache = {};
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(t, i = {}) {
    const n = eX(t === "dev" ? "en" : t), s = i.ordinal ? "ordinal" : "cardinal", o = JSON.stringify({
      cleanedCode: n,
      type: s
    });
    if (o in this.pluralRulesCache)
      return this.pluralRulesCache[o];
    let r;
    try {
      r = new Intl.PluralRules(n, {
        type: s
      });
    } catch {
      if (!Intl)
        return this.logger.error("No Intl support, please use an Intl polyfill!"), b3e;
      if (!t.match(/-|_/)) return b3e;
      const c = this.languageUtils.getLanguagePartFromCode(t);
      r = this.getRule(c, i);
    }
    return this.pluralRulesCache[o] = r, r;
  }
  needsPlural(t, i = {}) {
    let n = this.getRule(t, i);
    return n || (n = this.getRule("dev", i)), (n == null ? void 0 : n.resolvedOptions().pluralCategories.length) > 1;
  }
  getPluralFormsOfKey(t, i, n = {}) {
    return this.getSuffixes(t, n).map((s) => `${i}${s}`);
  }
  getSuffixes(t, i = {}) {
    let n = this.getRule(t, i);
    return n || (n = this.getRule("dev", i)), n ? n.resolvedOptions().pluralCategories.sort((s, o) => S3e[s] - S3e[o]).map((s) => `${this.options.prepend}${i.ordinal ? `ordinal${this.options.prepend}` : ""}${s}`) : [];
  }
  getSuffix(t, i, n = {}) {
    const s = this.getRule(t, n);
    return s ? `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${s.select(i)}` : (this.logger.warn(`no plural rule found for: ${t}`), this.getSuffix("dev", i, n));
  }
}
const N3e = (e, t, i, n = ".", s = !0) => {
  let o = rDe(e, t, i);
  return !o && s && zs(i) && (o = f0e(e, i, n), o === void 0 && (o = f0e(t, i, n))), o;
}, zue = (e) => e.replace(/\$/g, "$$$$");
class D3e {
  constructor(t = {}) {
    var i;
    this.logger = uN.create("interpolator"), this.options = t, this.format = ((i = t == null ? void 0 : t.interpolation) == null ? void 0 : i.format) || ((n) => n), this.init(t);
  }
  init(t = {}) {
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const {
      escape: i,
      escapeValue: n,
      useRawValueToEscape: s,
      prefix: o,
      prefixEscaped: r,
      suffix: l,
      suffixEscaped: c,
      formatSeparator: h,
      unescapeSuffix: I,
      unescapePrefix: p,
      nestingPrefix: y,
      nestingPrefixEscaped: m,
      nestingSuffix: A,
      nestingSuffixEscaped: C,
      nestingOptionsSeparator: O,
      maxReplaces: R,
      alwaysFormat: F
    } = t.interpolation;
    this.escape = i !== void 0 ? i : aDe, this.escapeValue = n !== void 0 ? n : !0, this.useRawValueToEscape = s !== void 0 ? s : !1, this.prefix = o ? Mk(o) : r || "{{", this.suffix = l ? Mk(l) : c || "}}", this.formatSeparator = h || ",", this.unescapePrefix = I ? "" : p || "-", this.unescapeSuffix = this.unescapePrefix ? "" : I || "", this.nestingPrefix = y ? Mk(y) : m || Mk("$t("), this.nestingSuffix = A ? Mk(A) : C || Mk(")"), this.nestingOptionsSeparator = O || ",", this.maxReplaces = R || 1e3, this.alwaysFormat = F !== void 0 ? F : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = (i, n) => (i == null ? void 0 : i.source) === n ? (i.lastIndex = 0, i) : new RegExp(n, "g");
    this.regexp = t(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = t(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = t(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
  }
  interpolate(t, i, n, s) {
    var m;
    let o, r, l;
    const c = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, h = (A) => {
      if (A.indexOf(this.formatSeparator) < 0) {
        const F = N3e(i, c, A, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(F, void 0, n, {
          ...s,
          ...i,
          interpolationkey: A
        }) : F;
      }
      const C = A.split(this.formatSeparator), O = C.shift().trim(), R = C.join(this.formatSeparator).trim();
      return this.format(N3e(i, c, O, this.options.keySeparator, this.options.ignoreJSONStructure), R, n, {
        ...s,
        ...i,
        interpolationkey: O
      });
    };
    this.resetRegExp();
    const I = (s == null ? void 0 : s.missingInterpolationHandler) || this.options.missingInterpolationHandler, p = ((m = s == null ? void 0 : s.interpolation) == null ? void 0 : m.skipOnVariables) !== void 0 ? s.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (A) => zue(A)
    }, {
      regex: this.regexp,
      safeValue: (A) => this.escapeValue ? zue(this.escape(A)) : zue(A)
    }].forEach((A) => {
      for (l = 0; o = A.regex.exec(t); ) {
        const C = o[1].trim();
        if (r = h(C), r === void 0)
          if (typeof I == "function") {
            const R = I(t, o, s);
            r = zs(R) ? R : "";
          } else if (s && Object.prototype.hasOwnProperty.call(s, C))
            r = "";
          else if (p) {
            r = o[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${C} for interpolating ${t}`), r = "";
        else !zs(r) && !this.useRawValueToEscape && (r = E3e(r));
        const O = A.safeValue(r);
        if (t = t.replace(o[0], O), p ? (A.regex.lastIndex += r.length, A.regex.lastIndex -= o[0].length) : A.regex.lastIndex = 0, l++, l >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, i, n = {}) {
    let s, o, r;
    const l = (c, h) => {
      const I = this.nestingOptionsSeparator;
      if (c.indexOf(I) < 0) return c;
      const p = c.split(new RegExp(`${I}[ ]*{`));
      let y = `{${p[1]}`;
      c = p[0], y = this.interpolate(y, r);
      const m = y.match(/'/g), A = y.match(/"/g);
      (((m == null ? void 0 : m.length) ?? 0) % 2 === 0 && !A || A.length % 2 !== 0) && (y = y.replace(/'/g, '"'));
      try {
        r = JSON.parse(y), h && (r = {
          ...h,
          ...r
        });
      } catch (C) {
        return this.logger.warn(`failed parsing options string in nesting for key ${c}`, C), `${c}${I}${y}`;
      }
      return r.defaultValue && r.defaultValue.indexOf(this.prefix) > -1 && delete r.defaultValue, c;
    };
    for (; s = this.nestingRegexp.exec(t); ) {
      let c = [];
      r = {
        ...n
      }, r = r.replace && !zs(r.replace) ? r.replace : r, r.applyPostProcessor = !1, delete r.defaultValue;
      const h = /{.*}/.test(s[1]) ? s[1].lastIndexOf("}") + 1 : s[1].indexOf(this.formatSeparator);
      if (h !== -1 && (c = s[1].slice(h).split(this.formatSeparator).map((I) => I.trim()).filter(Boolean), s[1] = s[1].slice(0, h)), o = i(l.call(this, s[1].trim(), r), r), o && s[0] === t && !zs(o)) return o;
      zs(o) || (o = E3e(o)), o || (this.logger.warn(`missed to resolve ${s[1]} for nesting ${t}`), o = ""), c.length && (o = c.reduce((I, p) => this.format(I, p, n.lng, {
        ...n,
        interpolationkey: s[1].trim()
      }), o.trim())), t = t.replace(s[0], o), this.regexp.lastIndex = 0;
    }
    return t;
  }
}
const mDe = (e) => {
  let t = e.toLowerCase().trim();
  const i = {};
  if (e.indexOf("(") > -1) {
    const n = e.split("(");
    t = n[0].toLowerCase().trim();
    const s = n[1].substring(0, n[1].length - 1);
    t === "currency" && s.indexOf(":") < 0 ? i.currency || (i.currency = s.trim()) : t === "relativetime" && s.indexOf(":") < 0 ? i.range || (i.range = s.trim()) : s.split(";").forEach((r) => {
      if (r) {
        const [l, ...c] = r.split(":"), h = c.join(":").trim().replace(/^'+|'+$/g, ""), I = l.trim();
        i[I] || (i[I] = h), h === "false" && (i[I] = !1), h === "true" && (i[I] = !0), isNaN(h) || (i[I] = parseInt(h, 10));
      }
    });
  }
  return {
    formatName: t,
    formatOptions: i
  };
}, C3e = (e) => {
  const t = {};
  return (i, n, s) => {
    let o = s;
    s && s.interpolationkey && s.formatParams && s.formatParams[s.interpolationkey] && s[s.interpolationkey] && (o = {
      ...o,
      [s.interpolationkey]: void 0
    });
    const r = n + JSON.stringify(o);
    let l = t[r];
    return l || (l = e(eX(n), s), t[r] = l), l(i);
  };
}, yDe = (e) => (t, i, n) => e(eX(i), n)(t);
class EDe {
  constructor(t = {}) {
    this.logger = uN.create("formatter"), this.options = t, this.init(t);
  }
  init(t, i = {
    interpolation: {}
  }) {
    this.formatSeparator = i.interpolation.formatSeparator || ",";
    const n = i.cacheInBuiltFormats ? C3e : yDe;
    this.formats = {
      number: n((s, o) => {
        const r = new Intl.NumberFormat(s, {
          ...o
        });
        return (l) => r.format(l);
      }),
      currency: n((s, o) => {
        const r = new Intl.NumberFormat(s, {
          ...o,
          style: "currency"
        });
        return (l) => r.format(l);
      }),
      datetime: n((s, o) => {
        const r = new Intl.DateTimeFormat(s, {
          ...o
        });
        return (l) => r.format(l);
      }),
      relativetime: n((s, o) => {
        const r = new Intl.RelativeTimeFormat(s, {
          ...o
        });
        return (l) => r.format(l, o.range || "day");
      }),
      list: n((s, o) => {
        const r = new Intl.ListFormat(s, {
          ...o
        });
        return (l) => r.format(l);
      })
    };
  }
  add(t, i) {
    this.formats[t.toLowerCase().trim()] = i;
  }
  addCached(t, i) {
    this.formats[t.toLowerCase().trim()] = C3e(i);
  }
  format(t, i, n, s = {}) {
    const o = i.split(this.formatSeparator);
    if (o.length > 1 && o[0].indexOf("(") > 1 && o[0].indexOf(")") < 0 && o.find((l) => l.indexOf(")") > -1)) {
      const l = o.findIndex((c) => c.indexOf(")") > -1);
      o[0] = [o[0], ...o.splice(1, l)].join(this.formatSeparator);
    }
    return o.reduce((l, c) => {
      var p;
      const {
        formatName: h,
        formatOptions: I
      } = mDe(c);
      if (this.formats[h]) {
        let y = l;
        try {
          const m = ((p = s == null ? void 0 : s.formatParams) == null ? void 0 : p[s.interpolationkey]) || {}, A = m.locale || m.lng || s.locale || s.lng || n;
          y = this.formats[h](l, A, {
            ...I,
            ...s,
            ...m
          });
        } catch (m) {
          this.logger.warn(m);
        }
        return y;
      } else
        this.logger.warn(`there was no format function for ${h}`);
      return l;
    }, t);
  }
}
const gDe = (e, t) => {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
};
class wDe extends uae {
  constructor(t, i, n, s = {}) {
    var o, r;
    super(), this.backend = t, this.store = i, this.services = n, this.languageUtils = n.languageUtils, this.options = s, this.logger = uN.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = s.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = s.maxRetries >= 0 ? s.maxRetries : 5, this.retryTimeout = s.retryTimeout >= 1 ? s.retryTimeout : 350, this.state = {}, this.queue = [], (r = (o = this.backend) == null ? void 0 : o.init) == null || r.call(o, n, s.backend, s);
  }
  queueLoad(t, i, n, s) {
    const o = {}, r = {}, l = {}, c = {};
    return t.forEach((h) => {
      let I = !0;
      i.forEach((p) => {
        const y = `${h}|${p}`;
        !n.reload && this.store.hasResourceBundle(h, p) ? this.state[y] = 2 : this.state[y] < 0 || (this.state[y] === 1 ? r[y] === void 0 && (r[y] = !0) : (this.state[y] = 1, I = !1, r[y] === void 0 && (r[y] = !0), o[y] === void 0 && (o[y] = !0), c[p] === void 0 && (c[p] = !0)));
      }), I || (l[h] = !0);
    }), (Object.keys(o).length || Object.keys(r).length) && this.queue.push({
      pending: r,
      pendingCount: Object.keys(r).length,
      loaded: {},
      errors: [],
      callback: s
    }), {
      toLoad: Object.keys(o),
      pending: Object.keys(r),
      toLoadLanguages: Object.keys(l),
      toLoadNamespaces: Object.keys(c)
    };
  }
  loaded(t, i, n) {
    const s = t.split("|"), o = s[0], r = s[1];
    i && this.emit("failedLoading", o, r, i), !i && n && this.store.addResourceBundle(o, r, n, void 0, void 0, {
      skipCopy: !0
    }), this.state[t] = i ? -1 : 2, i && n && (this.state[t] = 0);
    const l = {};
    this.queue.forEach((c) => {
      oDe(c.loaded, [o], r), gDe(c, t), i && c.errors.push(i), c.pendingCount === 0 && !c.done && (Object.keys(c.loaded).forEach((h) => {
        l[h] || (l[h] = {});
        const I = c.loaded[h];
        I.length && I.forEach((p) => {
          l[h][p] === void 0 && (l[h][p] = !0);
        });
      }), c.done = !0, c.errors.length ? c.callback(c.errors) : c.callback());
    }), this.emit("loaded", l), this.queue = this.queue.filter((c) => !c.done);
  }
  read(t, i, n, s = 0, o = this.retryTimeout, r) {
    if (!t.length) return r(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: i,
        fcName: n,
        tried: s,
        wait: o,
        callback: r
      });
      return;
    }
    this.readingCalls++;
    const l = (h, I) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const p = this.waitingReads.shift();
        this.read(p.lng, p.ns, p.fcName, p.tried, p.wait, p.callback);
      }
      if (h && I && s < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, i, n, s + 1, o * 2, r);
        }, o);
        return;
      }
      r(h, I);
    }, c = this.backend[n].bind(this.backend);
    if (c.length === 2) {
      try {
        const h = c(t, i);
        h && typeof h.then == "function" ? h.then((I) => l(null, I)).catch(l) : l(null, h);
      } catch (h) {
        l(h);
      }
      return;
    }
    return c(t, i, l);
  }
  prepareLoading(t, i, n = {}, s) {
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), s && s();
    zs(t) && (t = this.languageUtils.toResolveHierarchy(t)), zs(i) && (i = [i]);
    const o = this.queueLoad(t, i, n, s);
    if (!o.toLoad.length)
      return o.pending.length || s(), null;
    o.toLoad.forEach((r) => {
      this.loadOne(r);
    });
  }
  load(t, i, n) {
    this.prepareLoading(t, i, {}, n);
  }
  reload(t, i, n) {
    this.prepareLoading(t, i, {
      reload: !0
    }, n);
  }
  loadOne(t, i = "") {
    const n = t.split("|"), s = n[0], o = n[1];
    this.read(s, o, "read", void 0, void 0, (r, l) => {
      r && this.logger.warn(`${i}loading namespace ${o} for language ${s} failed`, r), !r && l && this.logger.log(`${i}loaded namespace ${o} for language ${s}`, l), this.loaded(t, r, l);
    });
  }
  saveMissing(t, i, n, s, o, r = {}, l = () => {
  }) {
    var c, h, I, p, y;
    if ((h = (c = this.services) == null ? void 0 : c.utils) != null && h.hasLoadedNamespace && !((p = (I = this.services) == null ? void 0 : I.utils) != null && p.hasLoadedNamespace(i))) {
      this.logger.warn(`did not save key "${n}" as the namespace "${i}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(n == null || n === "")) {
      if ((y = this.backend) != null && y.create) {
        const m = {
          ...r,
          isUpdate: o
        }, A = this.backend.create.bind(this.backend);
        if (A.length < 6)
          try {
            let C;
            A.length === 5 ? C = A(t, i, n, s, m) : C = A(t, i, n, s), C && typeof C.then == "function" ? C.then((O) => l(null, O)).catch(l) : l(null, C);
          } catch (C) {
            l(C);
          }
        else
          A(t, i, n, s, l, m);
      }
      !t || !t[0] || this.store.addResource(t[0], i, n, s);
    }
  }
}
const jue = () => ({
  debug: !1,
  initAsync: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (e) => {
    let t = {};
    if (typeof e[1] == "object" && (t = e[1]), zs(e[1]) && (t.defaultValue = e[1]), zs(e[2]) && (t.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
      const i = e[3] || e[2];
      Object.keys(i).forEach((n) => {
        t[n] = i[n];
      });
    }
    return t;
  },
  interpolation: {
    escapeValue: !0,
    format: (e) => e,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  },
  cacheInBuiltFormats: !0
}), O3e = (e) => {
  var t, i;
  return zs(e.ns) && (e.ns = [e.ns]), zs(e.fallbackLng) && (e.fallbackLng = [e.fallbackLng]), zs(e.fallbackNS) && (e.fallbackNS = [e.fallbackNS]), ((i = (t = e.supportedLngs) == null ? void 0 : t.indexOf) == null ? void 0 : i.call(t, "cimode")) < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), typeof e.initImmediate == "boolean" && (e.initAsync = e.initImmediate), e;
}, tne = () => {
}, TDe = (e) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((i) => {
    typeof e[i] == "function" && (e[i] = e[i].bind(e));
  });
};
class gJ extends uae {
  constructor(t = {}, i) {
    if (super(), this.options = O3e(t), this.services = {}, this.logger = uN, this.modules = {
      external: []
    }, TDe(this), i && !this.isInitialized && !t.isClone) {
      if (!this.options.initAsync)
        return this.init(t, i), this;
      setTimeout(() => {
        this.init(t, i);
      }, 0);
    }
  }
  init(t = {}, i) {
    this.isInitializing = !0, typeof t == "function" && (i = t, t = {}), t.defaultNS == null && t.ns && (zs(t.ns) ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
    const n = jue();
    this.options = {
      ...n,
      ...this.options,
      ...O3e(t)
    }, this.options.interpolation = {
      ...n.interpolation,
      ...this.options.interpolation
    }, t.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = t.keySeparator), t.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = t.nsSeparator), typeof this.options.overloadTranslationOptionHandler != "function" && (this.options.overloadTranslationOptionHandler = n.overloadTranslationOptionHandler), this.options.debug === !0 && typeof console < "u" && console.warn("i18next is maintained with support from locize.com — consider powering your project with managed localization (AI, CDN, integrations): https://locize.com");
    const s = (h) => h ? typeof h == "function" ? new h() : h : null;
    if (!this.options.isClone) {
      this.modules.logger ? uN.init(s(this.modules.logger), this.options) : uN.init(null, this.options);
      let h;
      this.modules.formatter ? h = this.modules.formatter : h = EDe;
      const I = new A3e(this.options);
      this.store = new R3e(this.options.resources, this.options);
      const p = this.services;
      p.logger = uN, p.resourceStore = this.store, p.languageUtils = I, p.pluralResolver = new pDe(I, {
        prepend: this.options.pluralSeparator,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), this.options.interpolation.format && this.options.interpolation.format !== n.interpolation.format && this.logger.deprecate("init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting"), h && (!this.options.interpolation.format || this.options.interpolation.format === n.interpolation.format) && (p.formatter = s(h), p.formatter.init && p.formatter.init(p, this.options), this.options.interpolation.format = p.formatter.format.bind(p.formatter)), p.interpolator = new D3e(this.options), p.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, p.backendConnector = new wDe(s(this.modules.backend), p.resourceStore, p, this.options), p.backendConnector.on("*", (m, ...A) => {
        this.emit(m, ...A);
      }), this.modules.languageDetector && (p.languageDetector = s(this.modules.languageDetector), p.languageDetector.init && p.languageDetector.init(p, this.options.detection, this.options)), this.modules.i18nFormat && (p.i18nFormat = s(this.modules.i18nFormat), p.i18nFormat.init && p.i18nFormat.init(this)), this.translator = new Fre(this.services, this.options), this.translator.on("*", (m, ...A) => {
        this.emit(m, ...A);
      }), this.modules.external.forEach((m) => {
        m.init && m.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, i || (i = tne), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const h = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      h.length > 0 && h[0] !== "dev" && (this.options.lng = h[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((h) => {
      this[h] = (...I) => this.store[h](...I);
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((h) => {
      this[h] = (...I) => (this.store[h](...I), this);
    });
    const l = hZ(), c = () => {
      const h = (I, p) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), l.resolve(p), i(I, p);
      };
      if (this.languages && !this.isInitialized) return h(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, h);
    };
    return this.options.resources || !this.options.initAsync ? c() : setTimeout(c, 0), l;
  }
  loadResources(t, i = tne) {
    var o, r;
    let n = i;
    const s = zs(t) ? t : this.language;
    if (typeof t == "function" && (n = t), !this.options.resources || this.options.partialBundledLanguages) {
      if ((s == null ? void 0 : s.toLowerCase()) === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return n();
      const l = [], c = (h) => {
        if (!h || h === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(h).forEach((p) => {
          p !== "cimode" && l.indexOf(p) < 0 && l.push(p);
        });
      };
      s ? c(s) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((I) => c(I)), (r = (o = this.options.preload) == null ? void 0 : o.forEach) == null || r.call(o, (h) => c(h)), this.services.backendConnector.load(l, this.options.ns, (h) => {
        !h && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), n(h);
      });
    } else
      n(null);
  }
  reloadResources(t, i, n) {
    const s = hZ();
    return typeof t == "function" && (n = t, t = void 0), typeof i == "function" && (n = i, i = void 0), t || (t = this.languages), i || (i = this.options.ns), n || (n = tne), this.services.backendConnector.reload(t, i, (o) => {
      s.resolve(), n(o);
    }), s;
  }
  use(t) {
    if (!t) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && eTe.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1)) {
      for (let i = 0; i < this.languages.length; i++) {
        const n = this.languages[i];
        if (!(["cimode", "dev"].indexOf(n) > -1) && this.store.hasLanguageSomeTranslations(n)) {
          this.resolvedLanguage = n;
          break;
        }
      }
      !this.resolvedLanguage && this.languages.indexOf(t) < 0 && this.store.hasLanguageSomeTranslations(t) && (this.resolvedLanguage = t, this.languages.unshift(t));
    }
  }
  changeLanguage(t, i) {
    this.isLanguageChangingTo = t;
    const n = hZ();
    this.emit("languageChanging", t);
    const s = (l) => {
      this.language = l, this.languages = this.services.languageUtils.toResolveHierarchy(l), this.resolvedLanguage = void 0, this.setResolvedLanguage(l);
    }, o = (l, c) => {
      c ? this.isLanguageChangingTo === t && (s(c), this.translator.changeLanguage(c), this.isLanguageChangingTo = void 0, this.emit("languageChanged", c), this.logger.log("languageChanged", c)) : this.isLanguageChangingTo = void 0, n.resolve((...h) => this.t(...h)), i && i(l, (...h) => this.t(...h));
    }, r = (l) => {
      var I, p;
      !t && !l && this.services.languageDetector && (l = []);
      const c = zs(l) ? l : l && l[0], h = this.store.hasLanguageSomeTranslations(c) ? c : this.services.languageUtils.getBestMatchFromCodes(zs(l) ? [l] : l);
      h && (this.language || s(h), this.translator.language || this.translator.changeLanguage(h), (p = (I = this.services.languageDetector) == null ? void 0 : I.cacheUserLanguage) == null || p.call(I, h)), this.loadResources(h, (y) => {
        o(y, h);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? r(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(r) : this.services.languageDetector.detect(r) : r(t), n;
  }
  getFixedT(t, i, n) {
    const s = (o, r, ...l) => {
      let c;
      typeof r != "object" ? c = this.options.overloadTranslationOptionHandler([o, r].concat(l)) : c = {
        ...r
      }, c.lng = c.lng || s.lng, c.lngs = c.lngs || s.lngs, c.ns = c.ns || s.ns, c.keyPrefix !== "" && (c.keyPrefix = c.keyPrefix || n || s.keyPrefix);
      const h = this.options.keySeparator || ".";
      let I;
      return c.keyPrefix && Array.isArray(o) ? I = o.map((p) => (typeof p == "function" && (p = I0e(p, {
        ...this.options,
        ...r
      })), `${c.keyPrefix}${h}${p}`)) : (typeof o == "function" && (o = I0e(o, {
        ...this.options,
        ...r
      })), I = c.keyPrefix ? `${c.keyPrefix}${h}${o}` : o), this.t(I, c);
    };
    return zs(t) ? s.lng = t : s.lngs = t, s.ns = i, s.keyPrefix = n, s;
  }
  t(...t) {
    var i;
    return (i = this.translator) == null ? void 0 : i.translate(...t);
  }
  exists(...t) {
    var i;
    return (i = this.translator) == null ? void 0 : i.exists(...t);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t, i = {}) {
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const n = i.lng || this.resolvedLanguage || this.languages[0], s = this.options ? this.options.fallbackLng : !1, o = this.languages[this.languages.length - 1];
    if (n.toLowerCase() === "cimode") return !0;
    const r = (l, c) => {
      const h = this.services.backendConnector.state[`${l}|${c}`];
      return h === -1 || h === 0 || h === 2;
    };
    if (i.precheck) {
      const l = i.precheck(this, r);
      if (l !== void 0) return l;
    }
    return !!(this.hasResourceBundle(n, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || r(n, t) && (!s || r(o, t)));
  }
  loadNamespaces(t, i) {
    const n = hZ();
    return this.options.ns ? (zs(t) && (t = [t]), t.forEach((s) => {
      this.options.ns.indexOf(s) < 0 && this.options.ns.push(s);
    }), this.loadResources((s) => {
      n.resolve(), i && i(s);
    }), n) : (i && i(), Promise.resolve());
  }
  loadLanguages(t, i) {
    const n = hZ();
    zs(t) && (t = [t]);
    const s = this.options.preload || [], o = t.filter((r) => s.indexOf(r) < 0 && this.services.languageUtils.isSupportedCode(r));
    return o.length ? (this.options.preload = s.concat(o), this.loadResources((r) => {
      n.resolve(), i && i(r);
    }), n) : (i && i(), Promise.resolve());
  }
  dir(t) {
    var s, o;
    if (t || (t = this.resolvedLanguage || (((s = this.languages) == null ? void 0 : s.length) > 0 ? this.languages[0] : this.language)), !t) return "rtl";
    try {
      const r = new Intl.Locale(t);
      if (r && r.getTextInfo) {
        const l = r.getTextInfo();
        if (l && l.direction) return l.direction;
      }
    } catch {
    }
    const i = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], n = ((o = this.services) == null ? void 0 : o.languageUtils) || new A3e(jue());
    return t.toLowerCase().indexOf("-latn") > 1 ? "ltr" : i.indexOf(n.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance(t = {}, i) {
    const n = new gJ(t, i);
    return n.createInstance = gJ.createInstance, n;
  }
  cloneInstance(t = {}, i = tne) {
    const n = t.forkResourceStore;
    n && delete t.forkResourceStore;
    const s = {
      ...this.options,
      ...t,
      isClone: !0
    }, o = new gJ(s);
    if ((t.debug !== void 0 || t.prefix !== void 0) && (o.logger = o.logger.clone(t)), ["store", "services", "language"].forEach((l) => {
      o[l] = this[l];
    }), o.services = {
      ...this.services
    }, o.services.utils = {
      hasLoadedNamespace: o.hasLoadedNamespace.bind(o)
    }, n) {
      const l = Object.keys(this.store.data).reduce((c, h) => (c[h] = {
        ...this.store.data[h]
      }, c[h] = Object.keys(c[h]).reduce((I, p) => (I[p] = {
        ...c[h][p]
      }, I), c[h]), c), {});
      o.store = new R3e(l, s), o.services.resourceStore = o.store;
    }
    if (t.interpolation) {
      const c = {
        ...jue().interpolation,
        ...this.options.interpolation,
        ...t.interpolation
      }, h = {
        ...s,
        interpolation: c
      };
      o.services.interpolator = new D3e(h);
    }
    return o.translator = new Fre(o.services, s), o.translator.on("*", (l, ...c) => {
      o.emit(l, ...c);
    }), o.init(s, i), o.translator.options = s, o.translator.backendConnector.services.utils = {
      hasLoadedNamespace: o.hasLoadedNamespace.bind(o)
    }, o;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const Sf = gJ.createInstance();
Sf.createInstance;
Sf.dir;
Sf.init;
Sf.loadResources;
Sf.reloadResources;
Sf.use;
Sf.changeLanguage;
Sf.getFixedT;
Sf.t;
Sf.exists;
Sf.setDefaultNamespace;
Sf.hasLoadedNamespace;
Sf.loadNamespaces;
Sf.loadLanguages;
const RDe = { error: { loading: "Error en carregar l'arxiu IFC:" }, loading: { downloading: "Descarregant arxiu IFC...", loading_model: "Carregant model...", complete: "Completat" }, warning: { large_file: "Els arxius IFC grans poden trigar un temps a carregar-se. Podria ser més ràpid descarregar l'arxiu i obrir-lo localment." } }, vDe = { title: "Calendari", views: { day: "Dia", week: "Setmana", month: "Mes" }, navigation: { today: "Avui", previous: "Anterior", next: "Següent" }, weekdays: { sun: "Dg", mon: "Dl", tue: "Dt", wed: "Dc", thu: "Dj", fri: "Dv", sat: "Ds" }, "view-titles": { daily: "Horari Diari", weekly: "Horari Setmanal", monthly: "Calendari Mensual" }, "event-details": { title: "Detalls de la Reunió", description: "Descripció", duration: "Durada", minutes: "minuts", attendees: "assistents", attendee: "assistent", close: "Tancar modal" }, "empty-states": { "no-meetings-today": "No hi ha reunions programades per avui", "schedule-clear": "El teu horari està lliure!", "more-events": "més" } }, ADe = { beta: "Beta" }, SDe = {
  ifc: RDe,
  calendar: vDe,
  common: ADe
}, bDe = { error: { loading: "Fehler beim Laden der IFC-Datei:" }, loading: { downloading: "IFC-Datei wird heruntergeladen...", loading_model: "Modell wird geladen...", complete: "Abgeschlossen" }, warning: { large_file: "Große IFC-Dateien können eine Weile dauern. Es könnte schneller sein, die Datei herunterzuladen und lokal zu öffnen." } }, NDe = { title: "Kalender", views: { day: "Tag", week: "Woche", month: "Monat" }, navigation: { today: "Heute", previous: "Vorherige", next: "Nächste" }, weekdays: { sun: "So", mon: "Mo", tue: "Di", wed: "Mi", thu: "Do", fri: "Fr", sat: "Sa" }, "view-titles": { daily: "Tagesplan", weekly: "Wochenplan", monthly: "Monatskalender" }, "event-details": { title: "Besprechungsdetails", description: "Beschreibung", duration: "Dauer", minutes: "Minuten", attendees: "Teilnehmer", attendee: "Teilnehmer", close: "Modal schließen" }, "empty-states": { "no-meetings-today": "Keine Besprechungen für heute geplant", "schedule-clear": "Ihr Terminplan ist frei!", "more-events": "weitere" } }, DDe = { beta: "Beta" }, CDe = {
  ifc: bDe,
  calendar: NDe,
  common: DDe
}, ODe = { error: { loading: "Error loading IFC file:" }, loading: { downloading: "Downloading IFC file...", loading_model: "Loading model...", complete: "Complete" }, warning: { large_file: "Large IFC files could take a while to load. It might be faster to download the file and open it locally." } }, LDe = { title: "Calendar", views: { day: "Day", week: "Week", month: "Month" }, navigation: { today: "Today", previous: "Previous", next: "Next" }, weekdays: { sun: "Sun", mon: "Mon", tue: "Tue", wed: "Wed", thu: "Thu", fri: "Fri", sat: "Sat" }, "view-titles": { daily: "Daily Schedule", weekly: "Weekly Schedule", monthly: "Monthly Calendar" }, "event-details": { title: "Meeting Details", description: "Description", duration: "Duration", minutes: "minutes", attendees: "attendees", attendee: "attendee", close: "Close modal" }, "empty-states": { "no-meetings-today": "No meetings scheduled for this day", "schedule-clear": "Your schedule is clear!", "more-events": "more" } }, _De = { beta: "Beta" }, xDe = {
  ifc: ODe,
  calendar: LDe,
  common: _De
}, PDe = { error: { loading: "Error al cargar el archivo IFC:" }, loading: { downloading: "Descargando archivo IFC...", loading_model: "Cargando modelo...", complete: "Completado" }, warning: { large_file: "Los archivos IFC grandes pueden tardar un tiempo en cargarse. Podría ser más rápido descargar el archivo y abrirlo localmente." } }, MDe = { title: "Calendario", views: { day: "Día", week: "Semana", month: "Mes" }, navigation: { today: "Hoy", previous: "Anterior", next: "Siguiente" }, weekdays: { sun: "Dom", mon: "Lun", tue: "Mar", wed: "Mié", thu: "Jue", fri: "Vie", sat: "Sáb" }, "view-titles": { daily: "Horario Diario", weekly: "Horario Semanal", monthly: "Calendario Mensual" }, "event-details": { title: "Detalles de la Reunión", description: "Descripción", duration: "Duración", minutes: "minutos", attendees: "asistentes", attendee: "asistente", close: "Cerrar modal" }, "empty-states": { "no-meetings-today": "No hay reuniones programadas para hoy", "schedule-clear": "¡Tu horario está libre!", "more-events": "más" } }, UDe = { beta: "Beta" }, BDe = {
  ifc: PDe,
  calendar: MDe,
  common: UDe
}, FDe = { error: { loading: "Erreur lors du chargement du fichier IFC :" }, loading: { downloading: "Téléchargement du fichier IFC...", loading_model: "Chargement du modèle...", complete: "Terminé" }, warning: { large_file: "Les gros fichiers IFC peuvent prendre du temps à charger. Il pourrait être plus rapide de télécharger le fichier et de l'ouvrir localement." } }, HDe = { title: "Calendrier", views: { day: "Jour", week: "Semaine", month: "Mois" }, navigation: { today: "Aujourd'hui", previous: "Précédent", next: "Suivant" }, weekdays: { sun: "Dim", mon: "Lun", tue: "Mar", wed: "Mer", thu: "Jeu", fri: "Ven", sat: "Sam" }, "view-titles": { daily: "Horaire Quotidien", weekly: "Horaire Hebdomadaire", monthly: "Calendrier Mensuel" }, "event-details": { title: "Détails de la Réunion", description: "Description", duration: "Durée", minutes: "minutes", attendees: "participants", attendee: "participant", close: "Fermer la modal" }, "empty-states": { "no-meetings-today": "Aucune réunion prévue pour aujourd'hui", "schedule-clear": "Votre emploi du temps est libre !", "more-events": "plus" } }, GDe = { beta: "Beta" }, kDe = {
  ifc: FDe,
  calendar: HDe,
  common: GDe
}, VDe = { error: { loading: "IFCファイルの読み込みエラー：" }, loading: { downloading: "IFCファイルをダウンロード中...", loading_model: "モデルを読み込み中...", complete: "完了" }, warning: { large_file: "大きなIFCファイルの読み込みには時間がかかる場合があります。ファイルをダウンロードしてローカルで開く方が速い場合があります。" } }, zDe = { title: "カレンダー", views: { day: "日", week: "週", month: "月" }, navigation: { today: "今日", previous: "前", next: "次" }, weekdays: { sun: "日", mon: "月", tue: "火", wed: "水", thu: "木", fri: "金", sat: "土" }, "view-titles": { daily: "日次スケジュール", weekly: "週次スケジュール", monthly: "月次カレンダー" }, "event-details": { title: "会議詳細", description: "説明", duration: "時間", minutes: "分", attendees: "参加者", attendee: "参加者", close: "モーダルを閉じる" }, "empty-states": { "no-meetings-today": "今日の会議はありません", "schedule-clear": "スケジュールは空いています！", "more-events": "他" } }, jDe = { beta: "ベータ" }, WDe = {
  ifc: VDe,
  calendar: zDe,
  common: jDe
}, YDe = { error: { loading: "Feil ved lasting av IFC-fil:" }, loading: { downloading: "Laster ned IFC-fil...", loading_model: "Laster modell...", complete: "Fullført" }, warning: { large_file: "Store IFC-filer kan ta lang tid å laste. Det kan være raskere å laste ned filen og åpne den lokalt." } }, qDe = { title: "Kalender", views: { day: "Dag", week: "Uke", month: "Måned" }, navigation: { today: "I dag", previous: "Forrige", next: "Neste" }, weekdays: { sun: "Søn", mon: "Man", tue: "Tir", wed: "Ons", thu: "Tor", fri: "Fre", sat: "Lør" }, "view-titles": { daily: "Dagsplan", weekly: "Ukesplan", monthly: "Månedskalender" }, "event-details": { title: "Møtedetaljer", description: "Beskrivelse", duration: "Varighet", minutes: "minutter", attendees: "deltakere", attendee: "deltaker", close: "Lukk modal" }, "empty-states": { "no-meetings-today": "Ingen møter planlagt for i dag", "schedule-clear": "Terminlisten din er ledig!", "more-events": "flere" } }, $De = { beta: "Beta" }, KDe = {
  ifc: YDe,
  calendar: qDe,
  common: $De
}, ZDe = { error: { loading: "Feil ved lasting av IFC-fil:" }, loading: { downloading: "Lastar ned IFC-fil...", loading_model: "Lastar modell...", complete: "Fullført" }, warning: { large_file: "Store IFC-filer kan ta lang tid å lasta. Det kan vera raskare å lasta ned fila og opna ho lokalt." } }, QDe = { title: "Kalender", views: { day: "Dag", week: "Veke", month: "Månad" }, navigation: { today: "I dag", previous: "Førre", next: "Neste" }, weekdays: { sun: "Søn", mon: "Mån", tue: "Tys", wed: "Ons", thu: "Tor", fri: "Fre", sat: "Lau" }, "view-titles": { daily: "Dagsplan", weekly: "Vekeplan", monthly: "Månadskalender" }, "event-details": { title: "Møtedetaljar", description: "Skildring", duration: "Varigheit", minutes: "minutt", attendees: "deltakarar", attendee: "deltakar", close: "Lukk modal" }, "empty-states": { "no-meetings-today": "Ingen møte planlagde for i dag", "schedule-clear": "Terminlista di er ledig!", "more-events": "fleire" } }, JDe = { beta: "Beta" }, XDe = {
  ifc: ZDe,
  calendar: QDe,
  common: JDe
}, eCe = { error: { loading: "Fel vid laddning av IFC-fil:" }, loading: { downloading: "Laddar ner IFC-fil...", loading_model: "Laddar modell...", complete: "Slutförd" }, warning: { large_file: "Stora IFC-filer kan ta lång tid att ladda. Det kan vara snabbare att ladda ner filen och öppna den lokalt." } }, tCe = { title: "Kalender", views: { day: "Dag", week: "Vecka", month: "Månad" }, navigation: { today: "Idag", previous: "Föregående", next: "Nästa" }, weekdays: { sun: "Sön", mon: "Mån", tue: "Tis", wed: "Ons", thu: "Tor", fri: "Fre", sat: "Lör" }, "view-titles": { daily: "Dagsschema", weekly: "Veckoschema", monthly: "Månadskalender" }, "event-details": { title: "Mötesdetaljer", description: "Beskrivning", duration: "Varaktighet", minutes: "minuter", attendees: "deltagare", attendee: "deltagare", close: "Stäng modal" }, "empty-states": { "no-meetings-today": "Inga möten planerade för idag", "schedule-clear": "Ditt schema är ledigt!", "more-events": "fler" } }, iCe = { beta: "Beta" }, nCe = {
  ifc: eCe,
  calendar: tCe,
  common: iCe
}, sCe = { error: { loading: "Lỗi khi tải tệp IFC:" }, loading: { downloading: "Đang tải xuống tệp IFC...", loading_model: "Đang tải mô hình...", complete: "Hoàn thành" }, warning: { large_file: "Các tệp IFC lớn có thể mất thời gian để tải. Có thể nhanh hơn nếu tải xuống tệp và mở cục bộ." } }, oCe = { title: "Lịch", views: { day: "Ngày", week: "Tuần", month: "Tháng" }, navigation: { today: "Hôm nay", previous: "Trước", next: "Tiếp theo" }, weekdays: { sun: "CN", mon: "T2", tue: "T3", wed: "T4", thu: "T5", fri: "T6", sat: "T7" }, "view-titles": { daily: "Lịch Trình Hàng Ngày", weekly: "Lịch Trình Hàng Tuần", monthly: "Lịch Hàng Tháng" }, "event-details": { title: "Chi Tiết Cuộc Họp", description: "Mô tả", duration: "Thời gian", minutes: "phút", attendees: "người tham dự", attendee: "người tham dự", close: "Đóng modal" }, "empty-states": { "no-meetings-today": "Không có cuộc họp nào được lên lịch cho hôm nay", "schedule-clear": "Lịch trình của bạn đang trống!", "more-events": "thêm" } }, rCe = { beta: "Beta" }, lCe = {
  ifc: sCe,
  calendar: oCe,
  common: rCe
}, aCe = { error: { loading: "加载 IFC 文件时出错：" }, loading: { downloading: "正在下载 IFC 文件...", loading_model: "正在加载模型...", complete: "完成" }, warning: { large_file: "大型 IFC 文件可能需要一段时间加载，下载文件并在本地打开可能更快。" } }, uCe = { title: "日历", views: { day: "日", week: "周", month: "月" }, navigation: { today: "今天", previous: "上一个", next: "下一个" }, weekdays: { sun: "周日", mon: "周一", tue: "周二", wed: "周三", thu: "周四", fri: "周五", sat: "周六" }, "view-titles": { daily: "日程安排", weekly: "周程安排", monthly: "月历" }, "event-details": { title: "会议详情", description: "描述", duration: "时长", minutes: "分钟", attendees: "与会者", attendee: "与会者", close: "关闭弹窗" }, "empty-states": { "no-meetings-today": "今天没有安排会议", "schedule-clear": "您的日程是空的！", "more-events": "更多" } }, dCe = { beta: "测试版" }, cCe = {
  ifc: aCe,
  calendar: uCe,
  common: dCe
}, hCe = () => {
  if (typeof window > "u") return "en";
  try {
    const e = localStorage.getItem("i18nextLng");
    return e || navigator.language.split("-")[0] || "en";
  } catch {
    return "en";
  }
};
Sf.init({
  lng: hCe(),
  fallbackLng: "en",
  initImmediate: !1,
  resources: {
    ca: { translation: SDe },
    de: { translation: CDe },
    en: { translation: xDe },
    es: { translation: BDe },
    fr: { translation: kDe },
    ja: { translation: WDe },
    nb: { translation: KDe },
    nn: { translation: XDe },
    sv: { translation: nCe },
    vi: { translation: lCe },
    zh: { translation: cCe }
  },
  interpolation: {
    escapeValue: !1
  }
});
if (typeof window < "u") {
  const e = (t) => {
    t.key === "i18nextLng" && t.newValue && Sf.changeLanguage(t.newValue);
  };
  window.addEventListener("storage", e);
}
const Ult = (e, t) => Sf.t(e, t);
function rie(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ine = { exports: {} }, fZ = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var L3e;
function fCe() {
  if (L3e) return fZ;
  L3e = 1;
  var e = Ms, t = Symbol.for("react.element"), i = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, s = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function r(l, c, h) {
    var I, p = {}, y = null, m = null;
    h !== void 0 && (y = "" + h), c.key !== void 0 && (y = "" + c.key), c.ref !== void 0 && (m = c.ref);
    for (I in c) n.call(c, I) && !o.hasOwnProperty(I) && (p[I] = c[I]);
    if (l && l.defaultProps) for (I in c = l.defaultProps, c) p[I] === void 0 && (p[I] = c[I]);
    return { $$typeof: t, type: l, key: y, ref: m, props: p, _owner: s.current };
  }
  return fZ.Fragment = i, fZ.jsx = r, fZ.jsxs = r, fZ;
}
var IZ = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _3e;
function ICe() {
  return _3e || (_3e = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ms, t = Symbol.for("react.element"), i = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), r = Symbol.for("react.provider"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), h = Symbol.for("react.suspense"), I = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), A = Symbol.iterator, C = "@@iterator";
    function O(Gt) {
      if (Gt === null || typeof Gt != "object")
        return null;
      var Vi = A && Gt[A] || Gt[C];
      return typeof Vi == "function" ? Vi : null;
    }
    var R = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function F(Gt) {
      {
        for (var Vi = arguments.length, _i = new Array(Vi > 1 ? Vi - 1 : 0), $n = 1; $n < Vi; $n++)
          _i[$n - 1] = arguments[$n];
        L("error", Gt, _i);
      }
    }
    function L(Gt, Vi, _i) {
      {
        var $n = R.ReactDebugCurrentFrame, Os = $n.getStackAddendum();
        Os !== "" && (Vi += "%s", _i = _i.concat([Os]));
        var Ai = _i.map(function(As) {
          return String(As);
        });
        Ai.unshift("Warning: " + Vi), Function.prototype.apply.call(console[Gt], console, Ai);
      }
    }
    var P = !1, z = !1, W = !1, re = !1, ce = !1, te;
    te = Symbol.for("react.module.reference");
    function ee(Gt) {
      return !!(typeof Gt == "string" || typeof Gt == "function" || Gt === n || Gt === o || ce || Gt === s || Gt === h || Gt === I || re || Gt === m || P || z || W || typeof Gt == "object" && Gt !== null && (Gt.$$typeof === y || Gt.$$typeof === p || Gt.$$typeof === r || Gt.$$typeof === l || Gt.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Gt.$$typeof === te || Gt.getModuleId !== void 0));
    }
    function Ne(Gt, Vi, _i) {
      var $n = Gt.displayName;
      if ($n)
        return $n;
      var Os = Vi.displayName || Vi.name || "";
      return Os !== "" ? _i + "(" + Os + ")" : _i;
    }
    function Ae(Gt) {
      return Gt.displayName || "Context";
    }
    function Oe(Gt) {
      if (Gt == null)
        return null;
      if (typeof Gt.tag == "number" && F("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof Gt == "function")
        return Gt.displayName || Gt.name || null;
      if (typeof Gt == "string")
        return Gt;
      switch (Gt) {
        case n:
          return "Fragment";
        case i:
          return "Portal";
        case o:
          return "Profiler";
        case s:
          return "StrictMode";
        case h:
          return "Suspense";
        case I:
          return "SuspenseList";
      }
      if (typeof Gt == "object")
        switch (Gt.$$typeof) {
          case l:
            var Vi = Gt;
            return Ae(Vi) + ".Consumer";
          case r:
            var _i = Gt;
            return Ae(_i._context) + ".Provider";
          case c:
            return Ne(Gt, Gt.render, "ForwardRef");
          case p:
            var $n = Gt.displayName || null;
            return $n !== null ? $n : Oe(Gt.type) || "Memo";
          case y: {
            var Os = Gt, Ai = Os._payload, As = Os._init;
            try {
              return Oe(As(Ai));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var pe = Object.assign, je = 0, Ve, $e, vt, Rt, ze, mt, Et;
    function it() {
    }
    it.__reactDisabledLog = !0;
    function Dt() {
      {
        if (je === 0) {
          Ve = console.log, $e = console.info, vt = console.warn, Rt = console.error, ze = console.group, mt = console.groupCollapsed, Et = console.groupEnd;
          var Gt = {
            configurable: !0,
            enumerable: !0,
            value: it,
            writable: !0
          };
          Object.defineProperties(console, {
            info: Gt,
            log: Gt,
            warn: Gt,
            error: Gt,
            group: Gt,
            groupCollapsed: Gt,
            groupEnd: Gt
          });
        }
        je++;
      }
    }
    function Ct() {
      {
        if (je--, je === 0) {
          var Gt = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: pe({}, Gt, {
              value: Ve
            }),
            info: pe({}, Gt, {
              value: $e
            }),
            warn: pe({}, Gt, {
              value: vt
            }),
            error: pe({}, Gt, {
              value: Rt
            }),
            group: pe({}, Gt, {
              value: ze
            }),
            groupCollapsed: pe({}, Gt, {
              value: mt
            }),
            groupEnd: pe({}, Gt, {
              value: Et
            })
          });
        }
        je < 0 && F("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Kt = R.ReactCurrentDispatcher, Zt;
    function Xt(Gt, Vi, _i) {
      {
        if (Zt === void 0)
          try {
            throw Error();
          } catch (Os) {
            var $n = Os.stack.trim().match(/\n( *(at )?)/);
            Zt = $n && $n[1] || "";
          }
        return `
` + Zt + Gt;
      }
    }
    var gi = !1, Wt;
    {
      var Di = typeof WeakMap == "function" ? WeakMap : Map;
      Wt = new Di();
    }
    function ni(Gt, Vi) {
      if (!Gt || gi)
        return "";
      {
        var _i = Wt.get(Gt);
        if (_i !== void 0)
          return _i;
      }
      var $n;
      gi = !0;
      var Os = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ai;
      Ai = Kt.current, Kt.current = null, Dt();
      try {
        if (Vi) {
          var As = function() {
            throw Error();
          };
          if (Object.defineProperty(As.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(As, []);
            } catch (ai) {
              $n = ai;
            }
            Reflect.construct(Gt, [], As);
          } else {
            try {
              As.call();
            } catch (ai) {
              $n = ai;
            }
            Gt.call(As.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ai) {
            $n = ai;
          }
          Gt();
        }
      } catch (ai) {
        if (ai && $n && typeof ai.stack == "string") {
          for (var Es = ai.stack.split(`
`), mr = $n.stack.split(`
`), Je = Es.length - 1, no = mr.length - 1; Je >= 1 && no >= 0 && Es[Je] !== mr[no]; )
            no--;
          for (; Je >= 1 && no >= 0; Je--, no--)
            if (Es[Je] !== mr[no]) {
              if (Je !== 1 || no !== 1)
                do
                  if (Je--, no--, no < 0 || Es[Je] !== mr[no]) {
                    var It = `
` + Es[Je].replace(" at new ", " at ");
                    return Gt.displayName && It.includes("<anonymous>") && (It = It.replace("<anonymous>", Gt.displayName)), typeof Gt == "function" && Wt.set(Gt, It), It;
                  }
                while (Je >= 1 && no >= 0);
              break;
            }
        }
      } finally {
        gi = !1, Kt.current = Ai, Ct(), Error.prepareStackTrace = Os;
      }
      var Qt = Gt ? Gt.displayName || Gt.name : "", ci = Qt ? Xt(Qt) : "";
      return typeof Gt == "function" && Wt.set(Gt, ci), ci;
    }
    function Ci(Gt, Vi, _i) {
      return ni(Gt, !1);
    }
    function Se(Gt) {
      var Vi = Gt.prototype;
      return !!(Vi && Vi.isReactComponent);
    }
    function si(Gt, Vi, _i) {
      if (Gt == null)
        return "";
      if (typeof Gt == "function")
        return ni(Gt, Se(Gt));
      if (typeof Gt == "string")
        return Xt(Gt);
      switch (Gt) {
        case h:
          return Xt("Suspense");
        case I:
          return Xt("SuspenseList");
      }
      if (typeof Gt == "object")
        switch (Gt.$$typeof) {
          case c:
            return Ci(Gt.render);
          case p:
            return si(Gt.type, Vi, _i);
          case y: {
            var $n = Gt, Os = $n._payload, Ai = $n._init;
            try {
              return si(Ai(Os), Vi, _i);
            } catch {
            }
          }
        }
      return "";
    }
    var Mt = Object.prototype.hasOwnProperty, ft = {}, rt = R.ReactDebugCurrentFrame;
    function Tt(Gt) {
      if (Gt) {
        var Vi = Gt._owner, _i = si(Gt.type, Gt._source, Vi ? Vi.type : null);
        rt.setExtraStackFrame(_i);
      } else
        rt.setExtraStackFrame(null);
    }
    function jt(Gt, Vi, _i, $n, Os) {
      {
        var Ai = Function.call.bind(Mt);
        for (var As in Gt)
          if (Ai(Gt, As)) {
            var Es = void 0;
            try {
              if (typeof Gt[As] != "function") {
                var mr = Error(($n || "React class") + ": " + _i + " type `" + As + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof Gt[As] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw mr.name = "Invariant Violation", mr;
              }
              Es = Gt[As](Vi, As, $n, _i, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Je) {
              Es = Je;
            }
            Es && !(Es instanceof Error) && (Tt(Os), F("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", $n || "React class", _i, As, typeof Es), Tt(null)), Es instanceof Error && !(Es.message in ft) && (ft[Es.message] = !0, Tt(Os), F("Failed %s type: %s", _i, Es.message), Tt(null));
          }
      }
    }
    var Jt = Array.isArray;
    function $t(Gt) {
      return Jt(Gt);
    }
    function ht(Gt) {
      {
        var Vi = typeof Symbol == "function" && Symbol.toStringTag, _i = Vi && Gt[Symbol.toStringTag] || Gt.constructor.name || "Object";
        return _i;
      }
    }
    function Me(Gt) {
      try {
        return gt(Gt), !1;
      } catch {
        return !0;
      }
    }
    function gt(Gt) {
      return "" + Gt;
    }
    function yt(Gt) {
      if (Me(Gt))
        return F("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ht(Gt)), gt(Gt);
    }
    var Ut = R.ReactCurrentOwner, Ht = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, wi, bi;
    function Hi(Gt) {
      if (Mt.call(Gt, "ref")) {
        var Vi = Object.getOwnPropertyDescriptor(Gt, "ref").get;
        if (Vi && Vi.isReactWarning)
          return !1;
      }
      return Gt.ref !== void 0;
    }
    function Wi(Gt) {
      if (Mt.call(Gt, "key")) {
        var Vi = Object.getOwnPropertyDescriptor(Gt, "key").get;
        if (Vi && Vi.isReactWarning)
          return !1;
      }
      return Gt.key !== void 0;
    }
    function hi(Gt, Vi) {
      typeof Gt.ref == "string" && Ut.current;
    }
    function Ji(Gt, Vi) {
      {
        var _i = function() {
          wi || (wi = !0, F("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Vi));
        };
        _i.isReactWarning = !0, Object.defineProperty(Gt, "key", {
          get: _i,
          configurable: !0
        });
      }
    }
    function Sn(Gt, Vi) {
      {
        var _i = function() {
          bi || (bi = !0, F("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Vi));
        };
        _i.isReactWarning = !0, Object.defineProperty(Gt, "ref", {
          get: _i,
          configurable: !0
        });
      }
    }
    var nn = function(Gt, Vi, _i, $n, Os, Ai, As) {
      var Es = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: Gt,
        key: Vi,
        ref: _i,
        props: As,
        // Record the component responsible for creating this element.
        _owner: Ai
      };
      return Es._store = {}, Object.defineProperty(Es._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Es, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $n
      }), Object.defineProperty(Es, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Os
      }), Object.freeze && (Object.freeze(Es.props), Object.freeze(Es)), Es;
    };
    function Yi(Gt, Vi, _i, $n, Os) {
      {
        var Ai, As = {}, Es = null, mr = null;
        _i !== void 0 && (yt(_i), Es = "" + _i), Wi(Vi) && (yt(Vi.key), Es = "" + Vi.key), Hi(Vi) && (mr = Vi.ref, hi(Vi, Os));
        for (Ai in Vi)
          Mt.call(Vi, Ai) && !Ht.hasOwnProperty(Ai) && (As[Ai] = Vi[Ai]);
        if (Gt && Gt.defaultProps) {
          var Je = Gt.defaultProps;
          for (Ai in Je)
            As[Ai] === void 0 && (As[Ai] = Je[Ai]);
        }
        if (Es || mr) {
          var no = typeof Gt == "function" ? Gt.displayName || Gt.name || "Unknown" : Gt;
          Es && Ji(As, no), mr && Sn(As, no);
        }
        return nn(Gt, Es, mr, Os, $n, Ut.current, As);
      }
    }
    var Pi = R.ReactCurrentOwner, kt = R.ReactDebugCurrentFrame;
    function sn(Gt) {
      if (Gt) {
        var Vi = Gt._owner, _i = si(Gt.type, Gt._source, Vi ? Vi.type : null);
        kt.setExtraStackFrame(_i);
      } else
        kt.setExtraStackFrame(null);
    }
    var Fi;
    Fi = !1;
    function tn(Gt) {
      return typeof Gt == "object" && Gt !== null && Gt.$$typeof === t;
    }
    function Gi() {
      {
        if (Pi.current) {
          var Gt = Oe(Pi.current.type);
          if (Gt)
            return `

Check the render method of \`` + Gt + "`.";
        }
        return "";
      }
    }
    function yi(Gt) {
      return "";
    }
    var bn = {};
    function ln(Gt) {
      {
        var Vi = Gi();
        if (!Vi) {
          var _i = typeof Gt == "string" ? Gt : Gt.displayName || Gt.name;
          _i && (Vi = `

Check the top-level render call using <` + _i + ">.");
        }
        return Vi;
      }
    }
    function No(Gt, Vi) {
      {
        if (!Gt._store || Gt._store.validated || Gt.key != null)
          return;
        Gt._store.validated = !0;
        var _i = ln(Vi);
        if (bn[_i])
          return;
        bn[_i] = !0;
        var $n = "";
        Gt && Gt._owner && Gt._owner !== Pi.current && ($n = " It was passed a child from " + Oe(Gt._owner.type) + "."), sn(Gt), F('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', _i, $n), sn(null);
      }
    }
    function Bs(Gt, Vi) {
      {
        if (typeof Gt != "object")
          return;
        if ($t(Gt))
          for (var _i = 0; _i < Gt.length; _i++) {
            var $n = Gt[_i];
            tn($n) && No($n, Vi);
          }
        else if (tn(Gt))
          Gt._store && (Gt._store.validated = !0);
        else if (Gt) {
          var Os = O(Gt);
          if (typeof Os == "function" && Os !== Gt.entries)
            for (var Ai = Os.call(Gt), As; !(As = Ai.next()).done; )
              tn(As.value) && No(As.value, Vi);
        }
      }
    }
    function os(Gt) {
      {
        var Vi = Gt.type;
        if (Vi == null || typeof Vi == "string")
          return;
        var _i;
        if (typeof Vi == "function")
          _i = Vi.propTypes;
        else if (typeof Vi == "object" && (Vi.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Vi.$$typeof === p))
          _i = Vi.propTypes;
        else
          return;
        if (_i) {
          var $n = Oe(Vi);
          jt(_i, Gt.props, "prop", $n, Gt);
        } else if (Vi.PropTypes !== void 0 && !Fi) {
          Fi = !0;
          var Os = Oe(Vi);
          F("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Os || "Unknown");
        }
        typeof Vi.getDefaultProps == "function" && !Vi.getDefaultProps.isReactClassApproved && F("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function vl(Gt) {
      {
        for (var Vi = Object.keys(Gt.props), _i = 0; _i < Vi.length; _i++) {
          var $n = Vi[_i];
          if ($n !== "children" && $n !== "key") {
            sn(Gt), F("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", $n), sn(null);
            break;
          }
        }
        Gt.ref !== null && (sn(Gt), F("Invalid attribute `ref` supplied to `React.Fragment`."), sn(null));
      }
    }
    var zl = {};
    function Wu(Gt, Vi, _i, $n, Os, Ai) {
      {
        var As = ee(Gt);
        if (!As) {
          var Es = "";
          (Gt === void 0 || typeof Gt == "object" && Gt !== null && Object.keys(Gt).length === 0) && (Es += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var mr = yi();
          mr ? Es += mr : Es += Gi();
          var Je;
          Gt === null ? Je = "null" : $t(Gt) ? Je = "array" : Gt !== void 0 && Gt.$$typeof === t ? (Je = "<" + (Oe(Gt.type) || "Unknown") + " />", Es = " Did you accidentally export a JSX literal instead of a component?") : Je = typeof Gt, F("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Je, Es);
        }
        var no = Yi(Gt, Vi, _i, Os, Ai);
        if (no == null)
          return no;
        if (As) {
          var It = Vi.children;
          if (It !== void 0)
            if ($n)
              if ($t(It)) {
                for (var Qt = 0; Qt < It.length; Qt++)
                  Bs(It[Qt], Gt);
                Object.freeze && Object.freeze(It);
              } else
                F("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Bs(It, Gt);
        }
        if (Mt.call(Vi, "key")) {
          var ci = Oe(Gt), ai = Object.keys(Vi).filter(function(mn) {
            return mn !== "key";
          }), ei = ai.length > 0 ? "{key: someKey, " + ai.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!zl[ci + ei]) {
            var Si = ai.length > 0 ? "{" + ai.join(": ..., ") + ": ...}" : "{}";
            F(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, ei, ci, Si, ci), zl[ci + ei] = !0;
          }
        }
        return Gt === n ? vl(no) : os(no), no;
      }
    }
    function jl(Gt, Vi, _i) {
      return Wu(Gt, Vi, _i, !0);
    }
    function Yu(Gt, Vi, _i) {
      return Wu(Gt, Vi, _i, !1);
    }
    var bd = Yu, I0 = jl;
    IZ.Fragment = n, IZ.jsx = bd, IZ.jsxs = I0;
  })()), IZ;
}
var x3e;
function pCe() {
  return x3e || (x3e = 1, process.env.NODE_ENV === "production" ? ine.exports = fCe() : ine.exports = ICe()), ine.exports;
}
var He = pCe();
function iTe(e) {
  var t, i, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var s = e.length;
    for (t = 0; t < s; t++) e[t] && (i = iTe(e[t])) && (n && (n += " "), n += i);
  } else for (i in e) e[i] && (n && (n += " "), n += i);
  return n;
}
function Gn() {
  for (var e, t, i = 0, n = "", s = arguments.length; i < s; i++) (e = arguments[i]) && (t = iTe(e)) && (n && (n += " "), n += t);
  return n;
}
var bP = /* @__PURE__ */ ((e) => (e.LEFT = "LEFT", e.RIGHT = "RIGHT", e))(bP || {});
const P3e = ({
  iconOnly: e = !1,
  icon: t = null,
  iconSize: i = 16,
  iconColor: n = "fc:black",
  primary: s = !1,
  secondary: o = !1,
  tertiary: r = !1,
  link: l = !1,
  ghost: c = !1,
  warning: h = !1,
  error: I = !1,
  success: p = !1,
  rounded: y = !1,
  disabled: m,
  type: A = "button",
  children: C,
  iconPosition: O = "LEFT",
  ...R
}) => {
  const F = t ?? (() => /* @__PURE__ */ He.jsx(He.Fragment, {})), L = Gn(
    R.className,
    // Base styles for all buttons
    "fc:flex fc:items-center fc:justify-center fc:gap-2 fc:text-base fc:whitespace-nowrap fc:font-semibold fc:text-day-neutral-dark",
    "fc:focus:outline-hidden fc:cs-outline-hidden fc:cursor-pointer",
    "fc:transition-all fc:duration-200 fc:ease-in-out",
    e ? "fc:px-1 fc:py-1" : "fc:px-4 fc:py-2",
    {
      // Ghost variant: transparent background, inherits text color, no hover background
      "fc:!bg-transparent fc:!p-0 fc:!text-inherit hover:fc:opacity-80": c,
      // Link variant overrides: left-aligned, full-width, different text styling
      "fc:w-full fc:!justify-start fc:!text-sm fc:!text-day-primary fc:!px-3 fc:!py-2 fc:rounded": l,
      "fc:hover:bg-day-light-3": !m && l,
      "fc:text-neutral-on-brand fc:bg-brand-default fc:hover:bg-brand-hover fc:hover:text-neutral-on-brand fc:hover:shadow-lg fc:hover:shadow-brand-default/25": !m && s,
      "fc:bg-day-light-4 fc:hover:bg-day-light-3 fc:border-day-secondary": !m && o,
      "fc:border-2": o,
      "fc:hover:bg-day-light-5 fc:focus:bg-day-light-2": !m && r,
      "fc:bg-warning-light fc:hover:bg-warning-dark": !m && h,
      "fc:bg-error-light fc:hover:bg-error-dark": !m && I,
      "fc:bg-success-light fc:hover:bg-success-dark": !m && p,
      "fc:border-none fc:border-4 fc:hover:bg-day-light-5 fc:focus:bg-day-light-5": !m && r,
      "fc:rounded-lg": y,
      "fc:bg-day-disabled fc:cursor-not-allowed fc:text-night-neutral-dark": m && !l,
      "fc:opacity-50 fc:cursor-not-allowed": m && l
    },
    R.className
  );
  return /* @__PURE__ */ He.jsxs("button", { disabled: m, type: A, ...R, className: L, children: [
    O === "LEFT" && /* @__PURE__ */ He.jsx(F, { color: n, fontSize: i }),
    C,
    O === "RIGHT" && /* @__PURE__ */ He.jsx(F, { color: n, fontSize: i })
  ] });
}, Blt = ({ children: e, className: t }) => /* @__PURE__ */ He.jsx("div", { className: Gn("fc:flex fc:flex-row fc:flex-nowrap fc:gap-2", t), children: e });
var nTe = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, M3e = Ms.createContext && /* @__PURE__ */ Ms.createContext(nTe), mCe = ["attr", "size", "title"];
function yCe(e, t) {
  if (e == null) return {};
  var i = ECe(e, t), n, s;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (s = 0; s < o.length; s++)
      n = o[s], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
  }
  return i;
}
function ECe(e, t) {
  if (e == null) return {};
  var i = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      i[n] = e[n];
    }
  return i;
}
function Hre() {
  return Hre = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = arguments[t];
      for (var n in i)
        Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
    }
    return e;
  }, Hre.apply(this, arguments);
}
function U3e(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function Gre(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? U3e(Object(i), !0).forEach(function(n) {
      gCe(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : U3e(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
function gCe(e, t, i) {
  return t = wCe(t), t in e ? Object.defineProperty(e, t, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = i, e;
}
function wCe(e) {
  var t = TCe(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function TCe(e, t) {
  if (typeof e != "object" || !e) return e;
  var i = e[Symbol.toPrimitive];
  if (i !== void 0) {
    var n = i.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function sTe(e) {
  return e && e.map((t, i) => /* @__PURE__ */ Ms.createElement(t.tag, Gre({
    key: i
  }, t.attr), sTe(t.child)));
}
function Sd(e) {
  return (t) => /* @__PURE__ */ Ms.createElement(RCe, Hre({
    attr: Gre({}, e.attr)
  }, t), sTe(e.child));
}
function RCe(e) {
  var t = (i) => {
    var {
      attr: n,
      size: s,
      title: o
    } = e, r = yCe(e, mCe), l = s || i.size || "1em", c;
    return i.className && (c = i.className), e.className && (c = (c ? c + " " : "") + e.className), /* @__PURE__ */ Ms.createElement("svg", Hre({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, i.attr, n, r, {
      className: c,
      style: Gre(Gre({
        color: e.color || i.color
      }, i.style), e.style),
      height: l,
      width: l,
      xmlns: "http://www.w3.org/2000/svg"
    }), o && /* @__PURE__ */ Ms.createElement("title", null, o), e.children);
  };
  return M3e !== void 0 ? /* @__PURE__ */ Ms.createElement(M3e.Consumer, null, (i) => t(i)) : t(nTe);
}
function vCe(e) {
  return Sd({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z" }, child: [] }] })(e);
}
function ACe(e) {
  return Sd({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z" }, child: [] }] })(e);
}
const SCe = ({
  onClick: e,
  ariaLabel: t = "Close",
  size: i = 20,
  className: n
}) => /* @__PURE__ */ He.jsx(
  "button",
  {
    type: "button",
    onClick: e,
    className: Gn(
      "fc:text-day-neutral-subtle fc:hover:text-day-neutral-default fc:transition-colors fc:cursor-pointer",
      n
    ),
    "aria-label": t,
    children: /* @__PURE__ */ He.jsx(vCe, { size: i })
  }
), Flt = ({
  options: e,
  value: t,
  onChange: i
}) => /* @__PURE__ */ He.jsx("div", { className: "fc:flex fc:gap-2 fc:flex-wrap", children: e.map((n) => /* @__PURE__ */ He.jsx(
  "button",
  {
    type: "button",
    disabled: n.disabled,
    onClick: () => i(n.value),
    className: Gn(
      "fc:px-4 fc:py-2 fc:rounded-full fc:border fc:text-sm fc:font-medium fc:transition-colors",
      n.disabled ? "fc:cursor-not-allowed fc:opacity-50 fc:bg-white fc:text-day-neutral-subtle fc:border-day-light-2" : t === n.value ? "fc:cursor-pointer fc:bg-day-neutral-dark fc:text-white fc:border-day-neutral-dark" : "fc:cursor-pointer fc:bg-white fc:text-day-neutral-subtle fc:border-day-light-2 hover:fc:border-day-neutral-dark"
    ),
    children: n.label
  },
  n.value
)) }), jF = ({ className: e, size: t = "medium", ...i }) => /* @__PURE__ */ He.jsx(
  "div",
  {
    ...i,
    className: Gn(
      "fc:border-2 fc:border-solid fc:border-day-primary",
      "fc:rounded-full fc:border-r-transparent fc:border-t-transparent",
      "fc:[animation:spin_500ms_linear_infinite]",
      {
        "fc:w-5 fc:h-5": t === "xsmall",
        "fc:w-7 fc:h-7": t === "small",
        "fc:w-12 fc:h-12": t === "medium",
        "fc:w-20 fc:h-20": t === "large"
      },
      e
    )
  }
), s6 = cE(function({ text: t, children: i, className: n, ...s }, o) {
  return t != null ? /* @__PURE__ */ He.jsxs("label", { ...s, ref: o, className: Gn("fc:inline-flex fc:flex-col", n), children: [
    /* @__PURE__ */ He.jsx(
      "span",
      {
        className: Gn(
          "fc:text-base fc:font-semibold fc:text-day-neutral-subtle",
          t && "fc:mb-2",
          {}
        ),
        children: t
      }
    ),
    i
  ] }) : /* @__PURE__ */ He.jsx("div", { children: i });
}), Hlt = cE(function({ label: t, className: i, disabled: n, value: s, ...o }, r) {
  return /* @__PURE__ */ He.jsx(s6, { text: t, className: "fc:w-full", children: /* @__PURE__ */ He.jsx(
    "input",
    {
      ...o,
      type: "text",
      value: s,
      ref: r,
      disabled: n,
      className: Gn(
        "fc:w-full fc:border fc:border-day-light-2 fc:rounded fc:px-3 fc:py-1 fc:focus:outline-hidden fc:focus:ring-1 fc:bg-day-light-5 fc:ring-day-secondary fc:focus:ring-day-secondary fc:text-day-neutral-dark",
        {
          "fc:cursor-not-allowed": n,
          "fc:hover:border-day-primary": !n,
          "fc:text-day-neutral-dark": n
        },
        i
      )
    }
  ) });
}), Glt = cE(function({ label: t, className: i, disabled: n, ...s }, o) {
  return /* @__PURE__ */ He.jsx(s6, { text: t, children: /* @__PURE__ */ He.jsx(
    "input",
    {
      ...s,
      type: "number",
      ref: o,
      disabled: n,
      className: Gn(
        "fc:border fc:rounded fc:px-3 fc:py-2",
        {
          "fc:cursor-not-allowed": n,
          "fc:border-day-primary fc:hover:border-day-secondary": !n,
          "fc:border-day-primary fc:text-day-neutral-dark": n
        },
        i
      )
    }
  ) });
}), klt = cE(function({ label: t, className: i, disabled: n, value: s, error: o, variant: r = "default", ...l }, c) {
  const h = r === "compact", I = /* @__PURE__ */ He.jsx(
    "input",
    {
      ...l,
      type: "date",
      value: s,
      ref: c,
      disabled: n,
      "aria-invalid": !!o || void 0,
      className: Gn(
        "fc:border fc:rounded fc:focus:outline-hidden fc:focus:ring-1 fc:bg-day-light-5 fc:ring-day-secondary fc:focus:ring-day-secondary fc:text-day-neutral-dark",
        h ? "fc:w-auto fc:px-1 fc:py-0.5 fc:text-sm fc:border-day-light-2" : "fc:w-full fc:px-3 fc:py-1 fc:border-day-light-2",
        {
          "fc:cursor-not-allowed": n,
          "fc:hover:border-day-primary": !n,
          "fc:text-day-neutral-dark": n,
          "fc:border-red-500 fc:focus:ring-red-500": o
        },
        i
      )
    }
  );
  return h ? I : /* @__PURE__ */ He.jsxs(s6, { text: t, className: "fc:w-full", children: [
    I,
    o && /* @__PURE__ */ He.jsx("p", { className: "fc:text-red-500 fc:text-xs fc:mt-1", children: o })
  ] });
});
var bCe = /* @__PURE__ */ ((e) => (e.Native = "native", e.QuarterHour = "quarter-hour", e))(bCe || {});
const NCe = () => Array.from({ length: 24 }, (e, t) => t.toString().padStart(2, "0")), DCe = (e, t) => e === "quarter-hour" || t === 900 || t === "900" ? ["00", "15", "30", "45"] : Array.from({ length: 60 }, (i, n) => n.toString().padStart(2, "0")), Vlt = cE(function({ label: t, className: i, disabled: n, value: s, error: o, variant: r, step: l, onChange: c, ...h }, I) {
  const [p, y] = Is("09"), [m, A] = Is("00"), [C, O] = Is(!1), R = io(null);
  vr(() => {
    if (s) {
      const [ce, te] = s.split(":");
      y(ce || "09"), A(te || "00");
    }
  }, [s]), vr(() => {
    const ce = (te) => {
      R.current && !R.current.contains(te.target) && O(!1);
    };
    return document.addEventListener("mousedown", ce), () => document.removeEventListener("mousedown", ce);
  }, []);
  const F = (ce, te) => {
    const ee = `${ce}:${te}`;
    if (c) {
      const Ne = {
        target: { value: ee, name: h.name },
        currentTarget: { value: ee, name: h.name }
      };
      c(Ne);
    }
  }, L = (ce) => {
    y(ce), F(ce, m);
  }, P = (ce) => {
    A(ce), F(p, ce);
  }, z = () => {
    n || O(!C);
  }, W = NCe(), re = DCe(r, l);
  return r === "quarter-hour" || r !== "native" && (l === 900 || l === "900") ? /* @__PURE__ */ He.jsxs(s6, { text: t, className: "fc:w-full", children: [
    /* @__PURE__ */ He.jsxs("div", { ref: R, className: "fc:relative", children: [
      /* @__PURE__ */ He.jsxs(
        "div",
        {
          onClick: z,
          onKeyDown: (ce) => {
            (ce.key === "Enter" || ce.key === " ") && (ce.preventDefault(), z());
          },
          role: "button",
          tabIndex: n ? -1 : 0,
          "aria-expanded": C,
          "aria-haspopup": "listbox",
          className: Gn(
            "fc:w-full fc:border fc:rounded fc:px-3 fc:py-1 fc:bg-day-light-5 fc:cursor-pointer fc:flex fc:items-center fc:justify-between",
            {
              "fc:border-day-light-2 fc:hover:border-day-primary": !o && !n,
              "fc:border-red-500": o,
              "fc:cursor-not-allowed fc:opacity-50": n
            }
          ),
          children: [
            /* @__PURE__ */ He.jsx("span", { className: "fc:text-day-neutral-dark", children: `${p}:${m}` }),
            /* @__PURE__ */ He.jsx("div", { className: "fc:text-day-neutral-subtle", children: /* @__PURE__ */ He.jsxs(
              "svg",
              {
                width: "16",
                height: "16",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                children: [
                  /* @__PURE__ */ He.jsx("circle", { cx: "12", cy: "12", r: "10" }),
                  /* @__PURE__ */ He.jsx("polyline", { points: "12,6 12,12 16,14" })
                ]
              }
            ) })
          ]
        }
      ),
      C && /* @__PURE__ */ He.jsxs("div", { className: "fc:absolute fc:top-full fc:left-0 fc:mt-1 fc:bg-white fc:border fc:border-gray-300 fc:shadow-lg fc:z-50 fc:flex fc:w-full", children: [
        /* @__PURE__ */ He.jsx("div", { className: "fc:flex-1 fc:border-r fc:border-gray-300", children: /* @__PURE__ */ He.jsx("div", { className: "fc:h-48 fc:overflow-y-auto", style: { scrollbarWidth: "none" }, children: W.map((ce) => /* @__PURE__ */ He.jsx(
          "div",
          {
            onClick: () => L(ce),
            onKeyDown: (te) => {
              (te.key === "Enter" || te.key === " ") && (te.preventDefault(), L(ce));
            },
            role: "option",
            tabIndex: 0,
            "aria-selected": ce === p,
            className: Gn(
              "fc:px-2 fc:py-1 fc:cursor-pointer fc:text-center fc:text-sm",
              {
                "fc:bg-blue-500 fc:text-white": ce === p,
                "fc:hover:bg-gray-100": ce !== p
              }
            ),
            children: ce
          },
          ce
        )) }) }),
        /* @__PURE__ */ He.jsx("div", { className: "fc:flex-1", children: /* @__PURE__ */ He.jsx("div", { className: "fc:h-48 fc:overflow-y-auto", style: { scrollbarWidth: "thin" }, children: re.map((ce) => /* @__PURE__ */ He.jsx(
          "div",
          {
            onClick: () => P(ce),
            onKeyDown: (te) => {
              (te.key === "Enter" || te.key === " ") && (te.preventDefault(), P(ce));
            },
            role: "option",
            tabIndex: 0,
            "aria-selected": ce === m,
            className: Gn(
              "fc:px-2 fc:py-1 fc:cursor-pointer fc:text-center fc:text-sm",
              {
                "fc:bg-blue-500 fc:text-white": ce === m,
                "fc:hover:bg-gray-100": ce !== m
              }
            ),
            children: ce
          },
          ce
        )) }) })
      ] })
    ] }),
    /* @__PURE__ */ He.jsx("input", { ...h, type: "hidden", value: `${p}:${m}`, ref: I }),
    o && /* @__PURE__ */ He.jsx("p", { className: "fc:text-red-500 fc:text-xs fc:mt-1", children: o })
  ] }) : /* @__PURE__ */ He.jsxs(s6, { text: t, className: "fc:w-full", children: [
    /* @__PURE__ */ He.jsx(
      "input",
      {
        ...h,
        ref: I,
        type: "time",
        value: s,
        onChange: c,
        disabled: n,
        step: l,
        className: Gn(
          "fc:w-full fc:border fc:border-day-light-2 fc:rounded fc:px-3 fc:py-1 fc:focus:outline-hidden fc:focus:ring-1 fc:bg-day-light-5 fc:ring-day-secondary fc:focus:ring-day-secondary fc:text-day-neutral-dark",
          {
            "fc:cursor-not-allowed": n,
            "fc:hover:border-day-primary": !n,
            "fc:text-day-neutral-dark": n,
            "fc:border-red-500 fc:focus:ring-red-500": o
          },
          i
        )
      }
    ),
    o && /* @__PURE__ */ He.jsx("p", { className: "fc:text-red-500 fc:text-xs fc:mt-1", children: o })
  ] });
}), zlt = cE(
  function({ label: t, className: i, disabled: n, value: s, error: o, ...r }, l) {
    return /* @__PURE__ */ He.jsxs(s6, { text: t, className: "fc:w-full", children: [
      /* @__PURE__ */ He.jsx(
        "input",
        {
          ...r,
          type: "number",
          value: s,
          ref: l,
          disabled: n,
          className: Gn(
            "fc:w-full fc:border fc:border-day-light-2 fc:rounded fc:px-3 fc:py-1 fc:focus:outline-hidden fc:focus:ring-1 fc:bg-day-light-5 fc:ring-day-secondary fc:focus:ring-day-secondary fc:text-day-neutral-dark",
            {
              "fc:cursor-not-allowed": n,
              "fc:hover:border-day-primary": !n,
              "fc:text-day-neutral-dark": n,
              "fc:border-red-500 fc:focus:ring-red-500": o
            },
            i
          )
        }
      ),
      o && /* @__PURE__ */ He.jsx("p", { className: "fc:text-red-500 fc:text-xs fc:mt-1", children: o })
    ] });
  }
), lie = ({
  ref: e,
  onClickOutside: t,
  enabled: i = !0
}) => {
  vr(() => {
    if (!i) return;
    const n = (s) => {
      e.current && !e.current.contains(s.target) && t();
    };
    return document.addEventListener("mousedown", n), () => document.removeEventListener("mousedown", n);
  }, [e, t, i]);
}, CCe = () => /* @__PURE__ */ He.jsx("svg", { className: "fc:w-4 fc:h-4", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: /* @__PURE__ */ He.jsx(
  "path",
  {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
  }
) }), OCe = () => /* @__PURE__ */ He.jsx("svg", { className: "fc:w-3 fc:h-3", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: /* @__PURE__ */ He.jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M6 18L18 6M6 6l12 12" }) }), LCe = ({ suggestions: e, highlightedIndex: t, onSelect: i }) => /* @__PURE__ */ He.jsx("ul", { className: "fc:absolute fc:z-50 fc:w-full fc:bg-white fc:border fc:border-day-light-2 fc:rounded fc:shadow-lg fc:max-h-48 fc:overflow-y-auto fc:top-full fc:-mt-2", children: e.map((n, s) => /* @__PURE__ */ He.jsx("li", { children: /* @__PURE__ */ He.jsx(
  "button",
  {
    type: "button",
    onMouseDown: (o) => o.preventDefault(),
    onClick: () => i(n.email),
    className: Gn(
      "fc:w-full fc:text-left fc:px-3 fc:py-2 fc:text-sm fc:transition-colors",
      s === t ? "fc:bg-day-light-3 fc:text-day-primary" : "fc:hover:bg-day-light-4 fc:text-day-neutral-dark"
    ),
    children: n.name ? /* @__PURE__ */ He.jsxs("span", { children: [
      /* @__PURE__ */ He.jsx("span", { className: "fc:font-medium", children: n.name }),
      /* @__PURE__ */ He.jsxs("span", { className: "fc:text-day-neutral fc:ml-1", children: [
        "(",
        n.email,
        ")"
      ] })
    ] }) : /* @__PURE__ */ He.jsx("span", { children: n.email })
  }
) }, n.email)) }), _Ce = ({ attendees: e, disabled: t, onRemove: i }) => /* @__PURE__ */ He.jsx("div", { className: "fc:flex fc:flex-wrap fc:gap-2 fc:mb-2", children: e.map((n) => /* @__PURE__ */ He.jsxs(
  "span",
  {
    className: "fc:inline-flex fc:items-center fc:gap-2 fc:px-3 fc:py-1 fc:bg-day-light-3 fc:text-day-primary fc:rounded-full fc:text-sm",
    children: [
      n,
      /* @__PURE__ */ He.jsx(
        "button",
        {
          type: "button",
          onClick: () => i(n),
          disabled: t,
          className: "fc:text-day-primary hover:fc:text-day-secondary fc:transition-colors disabled:fc:cursor-not-allowed",
          children: /* @__PURE__ */ He.jsx(OCe, {})
        }
      )
    ]
  },
  n
)) }), jlt = cE(
  function({
    label: t,
    value: i = [],
    onChange: n,
    disabled: s = !1,
    placeholder: o = "Enter email address",
    error: r,
    className: l,
    suggestions: c = []
  }, h) {
    const [I, p] = Is(""), [y, m] = Is(!1), [A, C] = Is(-1), O = io(null), R = (ce) => i.some((te) => te.toLowerCase() === ce.trim().toLowerCase()), F = Vu(() => {
      const ce = I.trim().toLowerCase();
      return c.filter(
        (te) => {
          var ee;
          return !i.some((Ne) => Ne.toLowerCase() === te.email.toLowerCase()) && (ce.length === 0 || te.email.toLowerCase().includes(ce) || (((ee = te.name) == null ? void 0 : ee.toLowerCase().includes(ce)) ?? !1));
        }
      );
    }, [I, c, i]), L = On(() => m(!1), []);
    lie({ ref: O, onClickOutside: L, enabled: y });
    const P = (ce) => {
      const te = ce.trim();
      te && !R(te) && (n == null || n([...i, te])), p(""), m(!0), C(-1);
    }, z = () => {
      P(I);
    }, W = (ce) => {
      n == null || n(i.filter((te) => te !== ce));
    }, re = (ce) => {
      if (!y || F.length === 0) {
        ce.key === "Enter" && (ce.preventDefault(), z());
        return;
      }
      ce.key === "ArrowDown" ? (ce.preventDefault(), C((te) => Math.min(te + 1, F.length - 1))) : ce.key === "ArrowUp" ? (ce.preventDefault(), C((te) => Math.max(te - 1, 0))) : ce.key === "Enter" ? (ce.preventDefault(), A >= 0 && A < F.length ? P(F[A].email) : z()) : ce.key === "Escape" && (m(!1), C(-1));
    };
    return /* @__PURE__ */ He.jsxs(s6, { text: t, className: Gn("fc:w-full", l), children: [
      /* @__PURE__ */ He.jsxs("div", { className: "fc:relative", ref: O, children: [
        /* @__PURE__ */ He.jsxs("div", { className: "fc:flex fc:gap-2 fc:mb-3", children: [
          /* @__PURE__ */ He.jsx(
            "input",
            {
              ref: h,
              type: "email",
              value: I,
              onChange: (ce) => {
                p(ce.target.value), m(!0), C(-1);
              },
              onKeyDown: re,
              onFocus: () => m(!0),
              placeholder: o,
              disabled: s,
              autoComplete: "off",
              className: Gn(
                "fc:flex-1 fc:border fc:border-day-light-2 fc:rounded fc:px-3 fc:py-1 fc:focus:outline-hidden fc:focus:ring-1 fc:bg-day-light-5 fc:ring-day-secondary fc:focus:ring-day-secondary fc:text-day-neutral-dark",
                {
                  "fc:cursor-not-allowed": s,
                  "fc:hover:border-day-primary": !s,
                  "fc:text-day-neutral-dark": s,
                  "fc:border-red-500 fc:focus:ring-red-500": r
                }
              )
            }
          ),
          /* @__PURE__ */ He.jsx(
            "button",
            {
              type: "button",
              onMouseDown: (ce) => ce.preventDefault(),
              onClick: z,
              disabled: s || !I.trim(),
              className: Gn(
                "fc:px-3 fc:py-1 fc:bg-day-primary fc:text-white fc:rounded fc:text-sm fc:transition-colors fc:flex fc:items-center fc:justify-center fc:min-w-[44px]",
                {
                  "fc:hover:bg-day-secondary": !s && I.trim(),
                  "fc:cursor-not-allowed fc:opacity-50": s || !I.trim()
                }
              ),
              children: /* @__PURE__ */ He.jsx(CCe, {})
            }
          )
        ] }),
        y && F.length > 0 && /* @__PURE__ */ He.jsx(
          LCe,
          {
            suggestions: F,
            highlightedIndex: A,
            onSelect: P
          }
        )
      ] }),
      i.length > 0 && /* @__PURE__ */ He.jsx(_Ce, { attendees: i, disabled: s, onRemove: W }),
      r && /* @__PURE__ */ He.jsx("p", { className: "fc:text-red-500 fc:text-xs fc:mt-1", children: r }),
      i.length === 0 && !r && /* @__PURE__ */ He.jsx("p", { className: "fc:text-red-500 fc:text-xs fc:mt-1", children: "At least one attendee is required" })
    ] });
  }
);
function xCe(e) {
  return Sd({ attr: { viewBox: "0 0 320 512" }, child: [{ tag: "path", attr: { d: "M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z" }, child: [] }] })(e);
}
function PCe(e) {
  return Sd({ attr: { viewBox: "0 0 256 512" }, child: [{ tag: "path", attr: { d: "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z" }, child: [] }] })(e);
}
function MCe(e) {
  return Sd({ attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z" }, child: [] }] })(e);
}
function UCe(e) {
  return Sd({ attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z" }, child: [] }] })(e);
}
function BCe(e) {
  return Sd({ attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z" }, child: [] }] })(e);
}
function FCe(e) {
  return Sd({ attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z" }, child: [] }] })(e);
}
const Wlt = cE(function({ className: t, children: i = "Upload file", title: n, disabled: s, ...o }, r) {
  const l = Z4e();
  return /* @__PURE__ */ He.jsxs(
    "div",
    {
      title: n,
      className: Gn(
        "fc:border fc:rounded fc:px-3 fc:py-2 fc:inline-flex",
        {
          "fc:cursor-not-allowed": s,
          "fc:border-day-secondary fc:hover:border-day-primary": !s,
          "fc:border-day-secondary fc:text-day-primary": s
        },
        t
      ),
      children: [
        /* @__PURE__ */ He.jsx("input", { ...o, type: "file", ref: r, id: l, disabled: s, hidden: !0 }),
        /* @__PURE__ */ He.jsxs(
          "label",
          {
            htmlFor: l,
            className: "fc:cursor-pointer fc:truncate fc:flex fc:flex-row fc:gap-2 fc:items-center",
            children: [
              /* @__PURE__ */ He.jsx(FCe, {}),
              i
            ]
          }
        )
      ]
    }
  );
}), Ylt = cE(function({ label: t, className: i, disabled: n, ...s }, o) {
  return /* @__PURE__ */ He.jsx(s6, { text: t, className: "fc:w-full", children: /* @__PURE__ */ He.jsx(
    "textarea",
    {
      ...s,
      ref: o,
      disabled: n,
      className: Gn(
        "fc:w-full fc:border fc:border-cadet-grey fc:border-solid fc:focus:outline-hidden fc:focus:ring-1 bg-day-light-5 ring-day-secondary focus:ring-day-secondary text-day-neutral-dark fc:text-day-neutral-dark fc:bg-day-light-5",
        "fc:px-2 fc:py-1 fc:rounded-md",
        {
          "fc:cursor-not-allowed": n,
          "fc:border-cadet-grey-7 fc:hover:border-day-primary": !n,
          "fc:border-cadet-grey-7 fc:text-day-neutral-dark": n
        },
        i
      )
    }
  ) });
}), p0e = cE(
  (e, t) => {
    const {
      id: i,
      className: n,
      value: s,
      onChange: o,
      checked: r,
      label: l,
      disabled: c,
      labelPosition: h = bP.RIGHT,
      partiallySelected: I = !1,
      ariaLabel: p
    } = e, y = io(null), m = t || y;
    return vr(() => {
      m.current && (m.current.indeterminate = I);
    }, [I]), /* @__PURE__ */ He.jsxs("div", { className: "fc:flex fc:items-center fc:my-1 fc:text-day-neutral-dark", children: [
      h === bP.LEFT && l && /* @__PURE__ */ He.jsx("label", { className: Gn("fc:text-sm", l && "fc:mx-4"), htmlFor: i, children: l }),
      /* @__PURE__ */ He.jsx(
        "input",
        {
          type: "checkbox",
          id: i,
          value: s,
          checked: r,
          className: Gn(
            "fc:appearance-none fc:min-w-6 fc:min-h-6 fc:rounded fc:border fc:outline-hidden fc:focus:ring-1 fc:font-semibold fc:bg-day-light-4 fc:border-day-secondary fc:focus:ring-day-primary",
            r && !I && [
              "fc:relative fc:bg-night-dark-1",
              "fc:before:text-xl fc:before:content-['✓'] fc:before:absolute fc:before:top-[-3px] fc:before:right-[4px]",
              "fc:before:text-night-neutral-dark"
            ],
            I && [
              "fc:relative fc:bg-night-dark-1",
              "fc:before:text-xl fc:before:content-['−'] fc:before:absolute fc:before:top-[-3px] fc:before:right-[4px]",
              "fc:before:text-night-neutral-dark"
            ],
            c && "fc:opacity-50 fc:cursor-not-allowed",
            !c && "fc:cursor-pointer fc:hover:border-day-primary",
            n
          ),
          onChange: o,
          disabled: c,
          ref: m,
          "aria-label": p
        }
      ),
      h === bP.RIGHT && l && /* @__PURE__ */ He.jsx("label", { className: Gn("fc:text-sm", l && "fc:mx-4"), htmlFor: i, children: l })
    ] });
  }
);
p0e.displayName = "Checkbox";
const oTe = cE(
  (e, t) => {
    const {
      label: i,
      value: n,
      onChange: s,
      checked: o,
      disabled: r,
      name: l,
      labelPosition: c = bP.RIGHT,
      ...h
    } = e;
    return /* @__PURE__ */ He.jsx("div", { className: "fc:flex", children: /* @__PURE__ */ He.jsxs(
      "label",
      {
        htmlFor: n,
        className: Gn(
          "fc:flex fc:items-center fc:my-1",
          r && "fc:opacity-50 fc:cursor-not-allowed"
        ),
        children: [
          c === bP.LEFT && i && /* @__PURE__ */ He.jsx("span", { className: Gn("fc:text-sm fc:text-day-neutral-dark", i && "fc:mr-4"), children: i }),
          /* @__PURE__ */ He.jsx(
            "input",
            {
              ...h,
              type: "radio",
              id: n,
              value: n,
              name: l,
              ref: t,
              onChange: s,
              disabled: r,
              className: Gn(
                "fc:appearance-none fc:w-4 fc:h-4 fc:border-2 fc:border-brand fc:rounded-full fc:transition-all fc:duration-200 fc:linear fc:relative fc:outline-hidden fc:focus:ring-2 fc:focus:ring-brand",
                o && "fc:border-[6px] fc:border-brand",
                {
                  "fc:cursor-not-allowed": r,
                  "fc:hover:border-day-primary": !r
                }
              )
            }
          ),
          c === bP.RIGHT && i && /* @__PURE__ */ He.jsx("span", { className: Gn("fc:text-sm fc:text-day-neutral-dark", i && "fc:mx-4"), children: i })
        ]
      },
      n
    ) });
  }
);
oTe.displayName = "RadioButton";
const rTe = ({
  containerRef: e,
  isOpen: t,
  dropdownHeight: i = 300
}) => {
  const [n, s] = Is("down"), o = On(() => {
    if (!e.current) return;
    const r = e.current.getBoundingClientRect(), l = r.top, h = window.innerHeight - r.bottom < i && l >= i;
    s(h ? "up" : "down");
  }, [e, i]);
  return vr(() => {
    t ? o() : s("down");
  }, [t, o]), n;
}, qlt = ({
  options: e,
  value: t = [],
  onChange: i,
  placeholder: n = "Select...",
  label: s,
  noOptionsMessage: o = "No options available",
  isMulti: r = !1,
  isClearable: l = !1,
  isDisabled: c = !1,
  className: h,
  borderedOptions: I = !1
}) => {
  const [p, y] = Is(!1), [m, A] = Is(""), [C, O] = Is(!1), R = io(null), F = io(null), L = io(null), P = rTe({
    containerRef: R,
    isOpen: p,
    dropdownHeight: 250
    // matches fc:max-h-[250px]
  }), z = e.filter((Ve) => {
    if (!m.trim())
      return r ? !(t != null && t.some((Rt) => Rt.value === Ve.value)) : !0;
    const $e = Ve.label.normalize("NFD").toLowerCase(), vt = m.trim().normalize("NFD").toLowerCase();
    return $e.includes(vt) && (r ? !(t != null && t.some((Rt) => Rt.value === Ve.value)) : !0);
  }), W = On(() => {
    y(!1), O(!1), A("");
  }, []);
  lie({
    ref: R,
    onClickOutside: W,
    enabled: p
  }), vr(() => {
    p && L.current && (L.current.focus(), r || O(!0));
  }, [p, r]);
  const re = On(() => {
    c || y((Ve) => !Ve);
  }, [c]), ce = On(
    (Ve) => {
      i(r ? [...t || [], Ve] : [Ve]), y(!1), O(!1), A(""), r && L.current && setTimeout(() => {
        var $e;
        return ($e = L.current) == null ? void 0 : $e.focus();
      }, 0);
    },
    [i, t, r]
  ), te = On(
    (Ve, $e) => {
      $e.stopPropagation(), i((t == null ? void 0 : t.filter((vt) => vt.value !== Ve.value)) || []), L.current && setTimeout(() => {
        var vt;
        return (vt = L.current) == null ? void 0 : vt.focus();
      }, 0);
    },
    [i, t]
  ), ee = On(
    (Ve) => {
      Ve.stopPropagation(), i([]), A(""), L.current && setTimeout(() => {
        var $e;
        return ($e = L.current) == null ? void 0 : $e.focus();
      }, 0);
    },
    [i]
  ), Ne = On(
    (Ve) => {
      const $e = Ve.target.value;
      A($e), p || y(!0);
    },
    [p]
  ), Ae = On(
    (Ve) => {
      Ve.stopPropagation(), p || y(!0), r || O(!0);
    },
    [p, r]
  ), Oe = On(() => {
    r || O(!0);
  }, [r]), pe = !(t != null && t.length) || !r && C, je = r && (t == null ? void 0 : t.length) > 0 || !r && (t == null ? void 0 : t.length) > 0 && !C;
  return /* @__PURE__ */ He.jsxs("div", { className: Gn("fc:relative fc:w-full", h), ref: R, children: [
    s && /* @__PURE__ */ He.jsx(s6, { text: s, className: "fc:mb-1" }),
    /* @__PURE__ */ He.jsxs(
      "div",
      {
        role: "combobox",
        "aria-expanded": p,
        "aria-haspopup": "listbox",
        "aria-controls": "select-dropdown",
        "aria-disabled": c,
        tabIndex: 0,
        className: Gn(
          "fc:flex fc:items-center fc:justify-between fc:border fc:rounded fc:px-1.5 fc:py-1.5 fc:bg-white fc:w-full",
          c ? "fc:cursor-not-allowed fc:bg-gray-100 fc:opacity-60" : "fc:cursor-pointer fc:hover:border-day-primary",
          p ? "fc:border-day-primary fc:ring-1 fc:ring-day-secondary" : "fc:border-day-secondary"
        ),
        onClick: re,
        onKeyDown: (Ve) => {
          c || (Ve.key === "Enter" || Ve.key === " ") && (Ve.preventDefault(), re());
        },
        children: [
          /* @__PURE__ */ He.jsx("div", { className: "fc:flex fc:items-center fc:flex-1 fc:overflow-hidden fc:w-full", children: /* @__PURE__ */ He.jsxs("div", { className: "fc:flex fc:flex-wrap fc:gap-1 fc:items-center fc:w-full fc:max-h-[45px] fc:overflow-y-auto fc:min-w-0", children: [
            r && (t == null ? void 0 : t.length) > 0 && t.map((Ve) => /* @__PURE__ */ He.jsxs(
              "div",
              {
                className: "fc:bg-day-light-2 fc:text-day-neutral-dark fc:rounded fc:text-xs fc:flex fc:items-center fc:flex-shrink-0 fc:overflow-hidden",
                children: [
                  /* @__PURE__ */ He.jsx(
                    "span",
                    {
                      className: "fc:px-2 fc:py-0.5 fc:truncate fc:max-w-[150px]",
                      title: Ve.label,
                      children: Ve.label
                    }
                  ),
                  /* @__PURE__ */ He.jsx(
                    "button",
                    {
                      type: "button",
                      className: "fc:flex fc:items-center fc:justify-center fc:h-full fc:aspect-square fc:min-w-[1.5rem] fc:text-day-neutral-dark fc:hover:text-white fc:hover:bg-red-300 fc:cursor-pointer",
                      onClick: ($e) => te(Ve, $e),
                      "aria-label": `Remove ${Ve.label}`,
                      children: "×"
                    }
                  )
                ]
              },
              Ve.value
            )),
            !r && (t == null ? void 0 : t.length) > 0 && !C && /* @__PURE__ */ He.jsx(
              "div",
              {
                className: "fc:text-day-neutral-dark fc:text-sm fc:px-1 fc:truncate fc:max-w-full",
                title: t[0].label,
                children: t[0].label
              }
            ),
            /* @__PURE__ */ He.jsx(
              "div",
              {
                className: Gn(
                  "fc:flex-1 fc:min-w-[2rem] fc:flex",
                  je ? "fc:pl-1" : ""
                ),
                children: /* @__PURE__ */ He.jsx(
                  "input",
                  {
                    ref: L,
                    type: "text",
                    className: "fc:border-none fc:p-0 fc:outline-none fc:text-sm fc:bg-transparent fc:w-full fc:min-w-0 fc:py-0.5",
                    placeholder: pe ? n : "",
                    value: m,
                    onChange: Ne,
                    onClick: Ae,
                    onFocus: Oe,
                    disabled: c,
                    onKeyDown: (Ve) => {
                      Ve.key === "Enter" && z.length > 0 && ce(z[0]), Ve.stopPropagation();
                    }
                  }
                )
              }
            )
          ] }) }),
          l && (t == null ? void 0 : t.length) > 0 && /* @__PURE__ */ He.jsx(
            "button",
            {
              type: "button",
              className: "fc:flex fc:items-center fc:justify-center fc:h-5 fc:w-5 fc:text-day-neutral-subtle fc:hover:text-day-neutral-dark fc:cursor-pointer fc:mr-1",
              onClick: ee,
              "aria-label": "Clear all",
              children: /* @__PURE__ */ He.jsxs(
                "svg",
                {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "16",
                  height: "16",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  strokeWidth: "2",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  children: [
                    /* @__PURE__ */ He.jsx("line", { x1: "18", y1: "6", x2: "6", y2: "18" }),
                    /* @__PURE__ */ He.jsx("line", { x1: "6", y1: "6", x2: "18", y2: "18" })
                  ]
                }
              )
            }
          ),
          /* @__PURE__ */ He.jsx("div", { className: "fc:self-stretch fc:w-px fc:bg-day-light-1 fc:mx-2" }),
          /* @__PURE__ */ He.jsx("div", { className: "fc:text-day-light-1", children: /* @__PURE__ */ He.jsx(
            "svg",
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "20",
              height: "20",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              strokeWidth: "2.5",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              children: /* @__PURE__ */ He.jsx("polyline", { points: p ? "18 15 12 9 6 15" : "6 9 12 15 18 9" })
            }
          ) })
        ]
      }
    ),
    p && /* @__PURE__ */ He.jsx(
      "div",
      {
        ref: F,
        id: "select-dropdown",
        className: Gn(
          "fc:absolute fc:z-50 fc:w-full fc:bg-white fc:border fc:border-day-secondary fc:rounded fc:shadow-lg",
          P === "up" ? "fc:bottom-full fc:mb-1" : "fc:top-full fc:mt-1"
        ),
        children: /* @__PURE__ */ He.jsx("div", { className: "fc:overflow-y-auto fc:max-h-[250px]", children: z.length > 0 ? z.map((Ve) => /* @__PURE__ */ He.jsx(
          "button",
          {
            type: "button",
            className: Gn(
              "fc:px-3 fc:py-2 fc:cursor-pointer fc:text-sm fc:hover:bg-day-light-3 fc:w-full fc:text-left",
              !r && (t != null && t.some(($e) => $e.value === Ve.value)) ? "fc:bg-day-light-1" : ""
            ),
            onClick: () => ce(Ve),
            onKeyDown: ($e) => {
              ($e.key === "Enter" || $e.key === " ") && ($e.preventDefault(), ce(Ve));
            },
            role: "option",
            "aria-selected": t == null ? void 0 : t.some(($e) => $e.value === Ve.value),
            children: /* @__PURE__ */ He.jsx("div", { className: "fc:flex fc:items-center", children: I ? /* @__PURE__ */ He.jsx(
              "span",
              {
                className: "fc:truncate fc:text-xs fc:px-1 fc:py-0.5 fc:border fc:border-day-light-1 fc:rounded-sm fc:overflow-hidden fc:whitespace-nowrap fc:text-ellipsis fc:max-w-full fc:inline-block fc:bg-white",
                title: Ve.label,
                children: Ve.label
              }
            ) : /* @__PURE__ */ He.jsx("span", { className: "fc:truncate fc:w-full", title: Ve.label, children: Ve.label }) })
          },
          Ve.value
        )) : /* @__PURE__ */ He.jsx("div", { className: "fc:px-3 fc:py-2 fc:text-sm fc:text-day-neutral-subtle", children: o }) })
      }
    )
  ] });
};
var HCe = (e) => e.type === "checkbox", JZ = (e) => e instanceof Date, ppe = (e) => e == null;
const lTe = (e) => typeof e == "object";
var WF = (e) => !ppe(e) && !Array.isArray(e) && lTe(e) && !JZ(e), GCe = (e) => WF(e) && e.target ? HCe(e.target) ? e.target.checked : e.target.value : e, kCe = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, VCe = (e, t) => e.has(kCe(t)), zCe = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return WF(t) && t.hasOwnProperty("isPrototypeOf");
}, jCe = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function aTe(e) {
  if (e instanceof Date)
    return new Date(e);
  const t = typeof FileList < "u" && e instanceof FileList;
  if (jCe && (e instanceof Blob || t))
    return e;
  const i = Array.isArray(e);
  if (!i && !(WF(e) && zCe(e)))
    return e;
  const n = i ? [] : Object.create(Object.getPrototypeOf(e));
  for (const s in e)
    Object.prototype.hasOwnProperty.call(e, s) && (n[s] = aTe(e[s]));
  return n;
}
var uTe = (e) => /^\w*$/.test(e), m0e = (e) => e === void 0, WCe = (e) => Array.isArray(e) ? e.filter(Boolean) : [], dTe = (e) => WCe(e.replace(/["|']|\]/g, "").split(/\.|\[/)), ag = (e, t, i) => {
  if (!t || !WF(e))
    return i;
  const n = (uTe(t) ? [t] : dTe(t)).reduce((s, o) => ppe(s) ? s : s[o], e);
  return m0e(n) || n === e ? m0e(e[t]) ? i : e[t] : n;
}, Wue = (e) => typeof e == "boolean", nne = (e) => typeof e == "function", B3e = (e, t, i) => {
  let n = -1;
  const s = uTe(t) ? [t] : dTe(t), o = s.length, r = o - 1;
  for (; ++n < o; ) {
    const l = s[n];
    let c = i;
    if (n !== r) {
      const h = e[l];
      c = WF(h) || Array.isArray(h) ? h : isNaN(+s[n + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = c, e = e[l];
  }
};
const F3e = {
  BLUR: "blur",
  CHANGE: "change"
}, H3e = {
  all: "all"
}, cTe = Ms.createContext(null);
cTe.displayName = "HookFormControlContext";
const mpe = () => Ms.useContext(cTe);
var YCe = (e, t, i, n = !0) => {
  const s = {
    defaultValues: t._defaultValues
  };
  for (const o in e)
    Object.defineProperty(s, o, {
      get: () => {
        const r = o;
        return t._proxyFormState[r] !== H3e.all && (t._proxyFormState[r] = !n || H3e.all), i && (i[r] = !0), e[r];
      }
    });
  return s;
};
const hTe = typeof window < "u" ? Ms.useLayoutEffect : Ms.useEffect;
function qCe(e) {
  const t = mpe(), { control: i = t, disabled: n, name: s, exact: o } = e || {}, [r, l] = Ms.useState(i._formState), c = Ms.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  });
  return hTe(() => i._subscribe({
    name: s,
    formState: c.current,
    exact: o,
    callback: (h) => {
      !n && l({
        ...i._formState,
        ...h
      });
    }
  }), [s, n, o]), Ms.useEffect(() => {
    c.current.isValid && i._setValid(!0);
  }, [i]), Ms.useMemo(() => YCe(r, i, c.current, !1), [r, i]);
}
var $Ce = (e) => typeof e == "string", G3e = (e, t, i, n, s) => $Ce(e) ? ag(i, e, s) : Array.isArray(e) ? e.map((o) => ag(i, o)) : i, k3e = (e) => ppe(e) || !lTe(e);
function Yse(e, t, i = /* @__PURE__ */ new WeakSet()) {
  if (k3e(e) || k3e(t))
    return Object.is(e, t);
  if (JZ(e) && JZ(t))
    return Object.is(e.getTime(), t.getTime());
  const n = Object.keys(e), s = Object.keys(t);
  if (n.length !== s.length)
    return !1;
  if (i.has(e) || i.has(t))
    return !0;
  i.add(e), i.add(t);
  for (const o of n) {
    const r = e[o];
    if (!s.includes(o))
      return !1;
    if (o !== "ref") {
      const l = t[o];
      if (JZ(r) && JZ(l) || WF(r) && WF(l) || Array.isArray(r) && Array.isArray(l) ? !Yse(r, l, i) : !Object.is(r, l))
        return !1;
    }
  }
  return !0;
}
function KCe(e) {
  const t = mpe(), { control: i = t, name: n, defaultValue: s, disabled: o, exact: r, compute: l } = e || {}, c = Ms.useRef(s), h = Ms.useRef(l), I = Ms.useRef(void 0), p = Ms.useRef(i), y = Ms.useRef(n);
  h.current = l;
  const [m, A] = Ms.useState(() => {
    const P = i._getWatch(n, c.current);
    return h.current ? h.current(P) : P;
  }), C = Ms.useCallback((P) => {
    const z = G3e(n, i._names, P || i._formValues, !1, c.current);
    return h.current ? h.current(z) : z;
  }, [i._formValues, i._names, n]), O = Ms.useCallback((P) => {
    if (!o) {
      const z = G3e(n, i._names, P || i._formValues, !1, c.current);
      if (h.current) {
        const W = h.current(z);
        Yse(W, I.current) || (A(W), I.current = W);
      } else
        A(z);
    }
  }, [i._formValues, i._names, o, n]);
  hTe(() => ((p.current !== i || !Yse(y.current, n)) && (p.current = i, y.current = n, O()), i._subscribe({
    name: n,
    formState: {
      values: !0
    },
    exact: r,
    callback: (P) => {
      O(P.values);
    }
  })), [i, r, n, O]), Ms.useEffect(() => i._removeUnmounted());
  const R = p.current !== i, F = y.current, L = Ms.useMemo(() => {
    if (o)
      return null;
    const P = !R && !Yse(F, n);
    return R || P ? C() : null;
  }, [o, R, n, F, C]);
  return L !== null ? L : m;
}
function fTe(e) {
  const t = mpe(), { name: i, disabled: n, control: s = t, shouldUnregister: o, defaultValue: r, exact: l = !0 } = e, c = VCe(s._names.array, i), h = Ms.useMemo(() => ag(s._formValues, i, ag(s._defaultValues, i, r)), [s, i, r]), I = KCe({
    control: s,
    name: i,
    defaultValue: h,
    exact: l
  }), p = qCe({
    control: s,
    name: i,
    exact: l
  }), y = Ms.useRef(e), m = Ms.useRef(void 0), A = Ms.useRef(s.register(i, {
    ...e.rules,
    value: I,
    ...Wue(e.disabled) ? { disabled: e.disabled } : {}
  }));
  y.current = e;
  const C = Ms.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!ag(p.errors, i)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!ag(p.dirtyFields, i)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!ag(p.touchedFields, i)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!ag(p.validatingFields, i)
    },
    error: {
      enumerable: !0,
      get: () => ag(p.errors, i)
    }
  }), [p, i]), O = Ms.useCallback((P) => A.current.onChange({
    target: {
      value: GCe(P),
      name: i
    },
    type: F3e.CHANGE
  }), [i]), R = Ms.useCallback(() => A.current.onBlur({
    target: {
      value: ag(s._formValues, i),
      name: i
    },
    type: F3e.BLUR
  }), [i, s._formValues]), F = Ms.useCallback((P) => {
    const z = ag(s._fields, i);
    z && z._f && P && (z._f.ref = {
      focus: () => nne(P.focus) && P.focus(),
      select: () => nne(P.select) && P.select(),
      setCustomValidity: (W) => nne(P.setCustomValidity) && P.setCustomValidity(W),
      reportValidity: () => nne(P.reportValidity) && P.reportValidity()
    });
  }, [s._fields, i]), L = Ms.useMemo(() => ({
    name: i,
    value: I,
    ...Wue(n) || p.disabled ? { disabled: p.disabled || n } : {},
    onChange: O,
    onBlur: R,
    ref: F
  }), [i, n, p.disabled, O, R, F, I]);
  return Ms.useEffect(() => {
    const P = s._options.shouldUnregister || o, z = m.current;
    z && z !== i && !c && s.unregister(z), s.register(i, {
      ...y.current.rules,
      ...Wue(y.current.disabled) ? { disabled: y.current.disabled } : {}
    });
    const W = (re, ce) => {
      const te = ag(s._fields, re);
      te && te._f && (te._f.mount = ce);
    };
    if (W(i, !0), P) {
      const re = aTe(ag(s._options.defaultValues, i, y.current.defaultValue));
      B3e(s._defaultValues, i, re), m0e(ag(s._formValues, i)) && B3e(s._formValues, i, re);
    }
    return !c && s.register(i), m.current = i, () => {
      (c ? P && !s._state.action : P) ? s.unregister(i) : W(i, !1);
    };
  }, [i, s, c, o]), Ms.useEffect(() => {
    s._setDisabledField({
      disabled: n,
      name: i
    });
  }, [n, i, s]), Ms.useMemo(() => ({
    field: L,
    formState: p,
    fieldState: C
  }), [L, p, C]);
}
const ZCe = (e) => e.render(fTe(e)), QCe = Ms.createContext(null);
QCe.displayName = "HookFormContext";
const $lt = (e) => {
  var p;
  const { data: t, control: i, errors: n, id: s, label: o, getValues: r, setValue: l, errorMessage: c } = e, h = On(
    (y) => {
      l(s, y.target.value, { shouldValidate: !0 });
    },
    [l, s]
  ), I = io([]);
  return vr(() => {
    I.current[0] && I.current[0].focus();
  }, []), /* @__PURE__ */ He.jsxs("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ He.jsx("div", { className: "text-base font-semibold mb-2 text-day-neutral-subtle", children: o }),
    /* @__PURE__ */ He.jsx("div", { className: "flex flex-col", children: /* @__PURE__ */ He.jsx(
      ZCe,
      {
        name: s,
        control: i,
        defaultValue: "",
        rules: { required: c },
        render: ({ field: y }) => /* @__PURE__ */ He.jsx(He.Fragment, { children: t.map((m, A) => /* @__PURE__ */ He.jsx("span", { className: "mr-4", children: /* @__PURE__ */ He.jsx(
          oTe,
          {
            name: y.name,
            value: m.value,
            label: m.label,
            checked: m.value === r(s),
            onChange: (C) => {
              h(C);
            },
            ref: (C) => I.current[A] = C
          }
        ) }, m.value)) })
      }
    ) }),
    n && /* @__PURE__ */ He.jsx("div", { className: "text-sm text-error-dark fc:text-red-700", children: (p = n[s]) == null ? void 0 : p.message })
  ] });
}, JCe = ({ title: e, message: t, className: i }) => /* @__PURE__ */ He.jsxs(
  "div",
  {
    className: Gn(
      "fc:w-full fc:h-full fc:flex fc:justify-center fc:items-center fc:flex-col fc:gap-4",
      i
    ),
    children: [
      /* @__PURE__ */ He.jsx(jF, { size: "large", title: e }),
      e && /* @__PURE__ */ He.jsx("h2", { className: "fc:text-3xl fc:font-bold fc:text-day-neutral-dark", children: e }),
      t && /* @__PURE__ */ He.jsx("p", { className: "fc:text-day-neutral-subtle", children: t })
    ]
  }
), Klt = ({ title: e, message: t, className: i }) => /* @__PURE__ */ He.jsxs(
  "div",
  {
    className: Gn(
      "fc:w-full fc:h-full fc:flex fc:justify-center fc:items-center fc:flex-col fc:gap-4",
      i
    ),
    children: [
      e && /* @__PURE__ */ He.jsx("h2", { className: "fc:text-3xl fc:font-bold", children: e }),
      t && /* @__PURE__ */ He.jsx("p", { className: "fc:text-day-neutral-dark", children: t })
    ]
  }
), V3e = J6e(null), Zlt = (e) => {
  const t = e((r, l) => ({ name: r, component: l })), i = () => {
    const r = X6e(V3e);
    if (r === null)
      throw new Error("Called useStepContext without StepContext in tree");
    const l = r.step + 1 < t.length, c = r.step > 0, h = () => l && r.setStep((p) => p + 1), I = () => c && r.setStep((p) => p - 1);
    return { step: r.step, next: h, previous: I, hasNext: l, hasPrevious: c };
  };
  return { StepOutlet: () => {
    const { step: r } = i(), { component: l } = t[r];
    return /* @__PURE__ */ He.jsx(l, { useStepContext: i });
  }, StepIndicator: () => {
    const { step: r } = i(), l = (h) => h === 0, c = (h) => h === t.length - 1;
    return /* @__PURE__ */ He.jsx("div", { className: "fc:hidden fc:mb-2 sm:fc:flex fc:w-full fc:gap-2 fc:items-center fc:justify-center", children: t.map(({ name: h }, I) => /* @__PURE__ */ He.jsx(Q4e, { children: /* @__PURE__ */ He.jsx(
      "div",
      {
        className: Gn(
          "fc:flex fc:items-center fc:h-[32px] fc:border-2 fc:relative fc:box-border fc:py-0 fc:px-8 after:fc:z-50 fc:text-xs fc:font-semibold fc:text-0.7",
          {
            'fc:border-r-0  fc:rounded-l-lg fc:mr-[.1rem] after:fc:content-[""] after:fc:absolute after:fc:w-[22px] after:fc:h-[22px] after:fc:right-[-11px] after:fc:top-[3px] after:fc:rotate-45 after:fc:border-t-2 after:fc:border-r-2': l(I),
            'fc:border-l-0 fc:rounded-r-lg fc:before:content-[""] fc:before:absolute fc:before:w-[22px] fc:before:h-[22px] fc:before:left-[-10px] fc:before:top-[3px] fc:before:rotate-[135deg] fc:before:border-t-2 fc:before:border-l-2 fc:before:bg-day-light-5': c(I),
            'fc:border-r-0 fc:border-l-0 fc:mr-[.1rem] after:fc:content-[""] after:fc:absolute after:fc:w-[22px] after:fc:h-[22px] after:fc:right-[-11px] after:fc:top-[3px] after:fc:rotate-45 after:fc:border-t-2 after:fc:border-r-2 fc:before:content-[""] fc:before:absolute fc:before:w-[22px] fc:before:h-[22px] fc:before:left-[-10px] fc:before:top-[3px] fc:before:rotate-[135deg] fc:before:border-t-2 fc:before:border-l-2 fc:before:bg-day-light-5': !l(I) && !c(I),
            "fc:bg-day-dark-1 fc:border-day-dark-1 after:fc:bg-day-dark-1 after:fc:border-day-dark-1 fc:text-day-light-5 fc:before:border-day-dark-1": r === I
          }
        ),
        children: h
      }
    ) }, h)) });
  }, withStep: (r) => {
    const [l, c] = Is(0);
    return /* @__PURE__ */ He.jsx(V3e.Provider, { value: { step: l, setStep: c }, children: /* @__PURE__ */ He.jsx("div", { className: "fc:w-full", children: /* @__PURE__ */ He.jsx(r, {}) }) });
  }, useStepContext: i };
}, Qlt = ({ children: e, className: t, ...i }) => {
  const n = Gn("fc:w-full fc:table-auto", t);
  return /* @__PURE__ */ He.jsx("table", { className: n, ...i, children: e });
}, Jlt = ({ children: e, className: t, ...i }) => {
  const n = Gn(t);
  return /* @__PURE__ */ He.jsx("tbody", { className: n, ...i, children: e });
}, Xlt = ({
  children: e,
  className: t,
  align: i = "left",
  ...n
}) => {
  const s = Gn(
    "fc:font-display fc:p-1 fc:align-middle",
    {
      "fc:text-left": i === "left",
      "fc:text-center": i === "center",
      "fc:text-right": i === "right"
    },
    t
  );
  return /* @__PURE__ */ He.jsx("td", { className: s, ...n, children: e });
}, eat = ({ children: e, className: t, ...i }) => {
  const n = Gn("fc:z-10 fc:border-b-1 fc:border-day-secondary", t);
  return /* @__PURE__ */ He.jsx("thead", { className: n, ...i, children: e });
}, tat = ({
  children: e,
  className: t,
  align: i = "left",
  ...n
}) => {
  const s = Gn(
    "fc:font-bold fc:font-display fc:px-1 fc:py-2",
    {
      "fc:text-left": i === "left",
      "fc:text-center": i === "center",
      "fc:text-right": i === "right"
    },
    t
  );
  return /* @__PURE__ */ He.jsx("th", { className: s, ...n, children: e });
}, XCe = cE(
  ({ children: e, className: t, ...i }, n) => {
    const s = Gn("fc:border-b fc:border-day-secondary", t);
    return /* @__PURE__ */ He.jsx("tr", { ref: n, className: s, ...i, children: e });
  }
);
XCe.displayName = "TableRow";
const iat = (e) => {
  const { label: t, selected: i, onClick: n, count: s, icon: o } = e, r = o ?? (() => /* @__PURE__ */ He.jsx(He.Fragment, {}));
  return /* @__PURE__ */ He.jsxs(
    "span",
    {
      className: Gn(
        "fc:flex fc:items-center fc:mt-4 fc:pb-4 fc:px-4 fc:text-sm fc:border-b-2 fc:cursor-pointer fc:font-medium fc:first-letter:capitalize",
        i ? "fc:font-semibold fc:border-b-2 fc:border-day-primary" : "fc:border-day-secondary",
        "fc:transition-colors fc:duration-300 fc:ease-in-out hover:fc:border-b-2 fc:text-day-neutral-dark"
      ),
      onClick: n,
      "aria-hidden": !0,
      children: [
        /* @__PURE__ */ He.jsx("div", { className: "fc:mr-2", title: t, children: /* @__PURE__ */ He.jsx(r, { fontSize: 20 }) }),
        /* @__PURE__ */ He.jsx("span", { children: t }),
        /* @__PURE__ */ He.jsx("span", { children: s ? ` (${s}) ` : "" })
      ]
    }
  );
};
function eOe(e) {
  return Sd({ attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm19 304h-38.2V207.9H275V352zm-19.1-159.8c-11.3 0-20.5-8.6-20.5-20s9.3-19.9 20.5-19.9c11.4 0 20.7 8.5 20.7 19.9s-9.3 20-20.7 20z" }, child: [] }] })(e);
}
function tOe(e) {
  return Sd({ attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M443.5 420.2L336.7 312.4c20.9-26.2 33.5-59.4 33.5-95.5 0-84.5-68.5-153-153.1-153S64 132.5 64 217s68.5 153 153.1 153c36.6 0 70.1-12.8 96.5-34.2l106.1 107.1c3.2 3.4 7.6 5.1 11.9 5.1 4.1 0 8.2-1.5 11.3-4.5 6.6-6.3 6.8-16.7.6-23.3zm-226.4-83.1c-32.1 0-62.3-12.5-85-35.2-22.7-22.7-35.2-52.9-35.2-84.9 0-32.1 12.5-62.3 35.2-84.9 22.7-22.7 52.9-35.2 85-35.2s62.3 12.5 85 35.2c22.7 22.7 35.2 52.9 35.2 84.9 0 32.1-12.5 62.3-35.2 84.9-22.7 22.7-52.9 35.2-85 35.2z" }, child: [] }] })(e);
}
function ITe(e) {
  return Sd({ attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M228.9 79.9L51.8 403.1C40.6 423.3 55.5 448 78.9 448h354.3c23.3 0 38.2-24.7 27.1-44.9L283.1 79.9c-11.7-21.2-42.5-21.2-54.2 0zM273.6 214L270 336h-28l-3.6-122h35.2zM256 402.4c-10.7 0-19.1-8.1-19.1-18.4s8.4-18.4 19.1-18.4 19.1 8.1 19.1 18.4-8.4 18.4-19.1 18.4z" }, child: [] }] })(e);
}
function iOe(e) {
  return Sd({ attr: { viewBox: "0 0 15 15", fill: "none" }, child: [{ tag: "path", attr: { fillRule: "evenodd", clipRule: "evenodd", d: "M12.8536 2.85355C13.0488 2.65829 13.0488 2.34171 12.8536 2.14645C12.6583 1.95118 12.3417 1.95118 12.1464 2.14645L7.5 6.79289L2.85355 2.14645C2.65829 1.95118 2.34171 1.95118 2.14645 2.14645C1.95118 2.34171 1.95118 2.65829 2.14645 2.85355L6.79289 7.5L2.14645 12.1464C1.95118 12.3417 1.95118 12.6583 2.14645 12.8536C2.34171 13.0488 2.65829 13.0488 2.85355 12.8536L7.5 8.20711L12.1464 12.8536C12.3417 13.0488 12.6583 13.0488 12.8536 12.8536C13.0488 12.6583 13.0488 12.3417 12.8536 12.1464L8.20711 7.5L12.8536 2.85355Z", fill: "currentColor" }, child: [] }] })(e);
}
var y0e = /* @__PURE__ */ ((e) => (e.INFO = "INFO", e.WARNING = "WARNING", e.ERROR = "ERROR", e))(y0e || {});
const z3e = ({ type: e, children: t, onClose: i }) => {
  let n, s;
  const o = "fc:text-black";
  switch (e) {
    case "INFO":
      n = "fc:bg-day-secondary", s = /* @__PURE__ */ He.jsx(eOe, { color: "#7588a3", size: 28 });
      break;
    case "WARNING":
      n = "fc:bg-warning-light", s = /* @__PURE__ */ He.jsx(ITe, { color: "#F97316", size: 28 });
      break;
    case "ERROR":
      n = "fc:bg-error-light", s = /* @__PURE__ */ He.jsx(ACe, { color: "#EF4444", size: 28 });
      break;
    default:
      n = "fc:bg-day-secondary", s = /* @__PURE__ */ He.jsx(He.Fragment, {});
  }
  return /* @__PURE__ */ He.jsxs(
    "div",
    {
      className: `fc:m-2 fc:p-4 fc:flex fc:w-full fc:rounded-md fc:flex-row fc:items-center fc:justify-between ${n} ${o}`,
      children: [
        /* @__PURE__ */ He.jsxs("div", { className: "fc:flex fc:flex-row", children: [
          /* @__PURE__ */ He.jsx("div", { className: "fc:m-2", children: s }),
          /* @__PURE__ */ He.jsx("div", { className: "fc:flex fc:flex-col fc:justify-center fc:py-1", children: t })
        ] }),
        /* @__PURE__ */ He.jsx("button", { className: "fc:flex fc:justify-top fc:cursor-pointer", onClick: i, children: /* @__PURE__ */ He.jsx(iOe, {}) })
      ]
    }
  );
}, nat = ({ children: e }) => /* @__PURE__ */ He.jsx("div", { className: "fc:fixed fc:top-0 fc:left-0 fc:bottom-0 fc:right-0 fc:bg-black/20 fc:z-[65]", children: /* @__PURE__ */ He.jsx("div", { className: "fc:fixed fc:p-8 fc:bg-day-light-5 fc:text-day-neutral-dark fc:shadow-md fc:flex fc:flex-col fc:rounded-xl fc:top-1/2 fc:left-1/2 fc:transform fc:-translate-x-1/2 fc:-translate-y-1/2 fc:z-10 fc:max-w-[464px] fc:w-full", children: e }) }), sat = ({ children: e, className: t }) => e ? /* @__PURE__ */ He.jsx(
  "div",
  {
    className: Gn(
      "fc:fixed fc:p-4 fc:bg-day-light-4 fc:text-day-neutral-dark fc:shadow-md fc:flex fc:flex-col fc:rounded fc:left-1/2 fc:top-1/2 fc:transform fc:-translate-x-1/2 fc:-translate-y-1/2 fc:z-10",
      t
    ),
    children: e
  }
) : null, oat = (e) => {
  var L;
  const {
    options: t,
    control: i,
    errors: n,
    groupName: s,
    label: o,
    errorMessage: r,
    classNames: l,
    selectAllLabel: c,
    id: h,
    initialValues: I
  } = e, { field: p } = fTe({
    name: s,
    rules: {
      required: r
    },
    control: i
  }), y = io([]), [m, A] = Is(
    I || p.value || []
  ), [C, O] = Is(!1), R = On(
    (P) => {
      let z = [...m];
      z = z.includes(P.target.value) ? z.filter(function(W) {
        return W !== P.target.value;
      }) : [...z, P.target.value], p.onChange(z), A(z), C && O(!1);
    },
    [m, p, C]
  ), F = On(() => {
    if (O((P) => !P), C)
      p.onChange([]), A([]);
    else {
      const P = t.map((z) => z.value);
      p.onChange(P), A(P);
    }
  }, [p, t, C]);
  return vr(() => {
    const P = t.every((z) => m.includes(z.value));
    O(!!P);
  }, [t, m]), /* @__PURE__ */ He.jsxs(He.Fragment, { children: [
    /* @__PURE__ */ He.jsx(s6, { text: o }),
    /* @__PURE__ */ He.jsxs("div", { className: Gn("fc:flex fc:flex-col", o && "fc:mt-2"), children: [
      c && /* @__PURE__ */ He.jsx(
        p0e,
        {
          checked: C,
          label: c,
          value: "Select all",
          className: "fc:mb-1",
          id: h,
          labelPosition: bP.RIGHT,
          onChange: F
        }
      ),
      /* @__PURE__ */ He.jsx("div", { className: Gn("fc:grid fc:gap-1", l), children: t.map(({ label: P, value: z }, W) => /* @__PURE__ */ He.jsx(
        p0e,
        {
          onChange: (re) => {
            R(re);
          },
          ref: (re) => y.current[W] = re,
          value: z,
          label: P,
          id: W.toString(),
          checked: m.includes(z)
        },
        z
      )) })
    ] }),
    n && /* @__PURE__ */ He.jsx("div", { className: "fc:text-red-700 fc:text-sm fc:my-2", children: (L = n[s]) == null ? void 0 : L.message })
  ] });
}, rat = ({
  text: e,
  button: t,
  circle: i,
  placeholder: n,
  textSize: s,
  ...o
}) => {
  const r = Gn(
    "motion-safe:fc:animate-pulse fc:bg-day-light-2 fc:inline-flex fc:items-center fc:justify-center fc:box-border fc:text-left",
    i ? "fc:rounded-full" : "fc:rounded-md",
    t && "fc:h-10 fc:w-fit fc:px-4 fc:py-2 fc:h-auto",
    s && `fc:text-${s} fc:h-auto`,
    //size adjustments
    e && !s && "fc:h-4",
    !e && !t && !o.className && "fc:h-full ",
    !t && !n && "fc:w-full",
    n && "fc:w-fit",
    o.className
  );
  return /* @__PURE__ */ He.jsx("div", { className: r, children: (e || t) && /* @__PURE__ */ He.jsx("p", { className: "fc:invisible", children: n }) });
}, sne = ({ text: e, onClick: t, disabled: i, active: n }) => {
  const s = (o) => {
    (o.key === "Enter" || o.key === " ") && (o.preventDefault(), t && t(o));
  };
  return /* @__PURE__ */ He.jsx(
    "button",
    {
      onClick: t,
      onKeyDown: s,
      disabled: i,
      className: Gn(
        "fc:flex fc:flex-row fc:justify-center fc:items-center fc:select-none fc:border fc:border-day-primary fc:w-10 fc:h-10 fc:rounded-md fc:cursor-pointer fc:text-sm fc:font-medium",
        "fc:disabled:pointer-events-none fc:disabled:bg-day-disabled fc:border-day-secondary fc:disabled:text-day-light-4",
        { "fc:bg-day-dark-1 fc:text-white": n },
        { "fc:bg-day-light-4": !n }
      ),
      children: e
    }
  );
}, iz = "...", one = (e, t) => {
  const i = t - e + 1;
  return Array.from({ length: i }, (n, s) => s + e);
}, nOe = ({
  totalCount: e,
  pageSize: t,
  siblingCount: i = 1,
  currentPage: n
}) => Vu(() => {
  const o = Math.ceil(e / t);
  if (i + 5 >= o)
    return one(1, o);
  const l = Math.max(n - i, 1), c = Math.min(n + i, o), h = l > 2, I = c < o - 2, p = 1, y = o;
  if (!h && I) {
    const m = 3 + 2 * i;
    return [...one(1, m), iz, o];
  }
  if (h && !I) {
    const m = 3 + 2 * i, A = one(o - m + 1, o);
    return [p, iz, ...A];
  }
  if (h && I) {
    const m = one(l, c);
    return [p, iz, ...m, iz, y];
  }
  return null;
}, [e, t, i, n]), lat = 50, sOe = (e) => {
  const { onPageChange: t, totalCount: i, siblingCount: n = 1, currentPage: s, pageSize: o } = e, r = nOe({
    currentPage: s,
    totalCount: i,
    siblingCount: n,
    pageSize: o
  });
  if (s === 0 || !r || r.length < 2)
    return null;
  const l = (h) => {
    h.preventDefault(), t(s + 1);
  }, c = (h) => {
    h.preventDefault(), t(s - 1);
  };
  return /* @__PURE__ */ He.jsxs("div", { className: "fc:flex fc:flex-row fc:gap-2", children: [
    /* @__PURE__ */ He.jsx(
      sne,
      {
        text: "❮",
        disabled: s === r[0],
        onClick: c
      }
    ),
    r.map((h, I) => {
      const p = `${h}-${I}`;
      return h === iz ? /* @__PURE__ */ He.jsx(sne, { text: iz, disabled: !0 }, p) : /* @__PURE__ */ He.jsx(
        sne,
        {
          text: String(h),
          onClick: (y) => {
            y.preventDefault(), t(h);
          },
          active: s === h
        },
        p
      );
    }),
    /* @__PURE__ */ He.jsx(
      sne,
      {
        text: "❯",
        disabled: s === r[r.length - 1],
        onClick: l
      }
    )
  ] });
};
var rne = { exports: {} }, lne = { exports: {} }, hl = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var j3e;
function oOe() {
  if (j3e) return hl;
  j3e = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, i = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, s = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, r = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, I = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, y = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, A = e ? Symbol.for("react.lazy") : 60116, C = e ? Symbol.for("react.block") : 60121, O = e ? Symbol.for("react.fundamental") : 60117, R = e ? Symbol.for("react.responder") : 60118, F = e ? Symbol.for("react.scope") : 60119;
  function L(z) {
    if (typeof z == "object" && z !== null) {
      var W = z.$$typeof;
      switch (W) {
        case t:
          switch (z = z.type, z) {
            case c:
            case h:
            case n:
            case o:
            case s:
            case p:
              return z;
            default:
              switch (z = z && z.$$typeof, z) {
                case l:
                case I:
                case A:
                case m:
                case r:
                  return z;
                default:
                  return W;
              }
          }
        case i:
          return W;
      }
    }
  }
  function P(z) {
    return L(z) === h;
  }
  return hl.AsyncMode = c, hl.ConcurrentMode = h, hl.ContextConsumer = l, hl.ContextProvider = r, hl.Element = t, hl.ForwardRef = I, hl.Fragment = n, hl.Lazy = A, hl.Memo = m, hl.Portal = i, hl.Profiler = o, hl.StrictMode = s, hl.Suspense = p, hl.isAsyncMode = function(z) {
    return P(z) || L(z) === c;
  }, hl.isConcurrentMode = P, hl.isContextConsumer = function(z) {
    return L(z) === l;
  }, hl.isContextProvider = function(z) {
    return L(z) === r;
  }, hl.isElement = function(z) {
    return typeof z == "object" && z !== null && z.$$typeof === t;
  }, hl.isForwardRef = function(z) {
    return L(z) === I;
  }, hl.isFragment = function(z) {
    return L(z) === n;
  }, hl.isLazy = function(z) {
    return L(z) === A;
  }, hl.isMemo = function(z) {
    return L(z) === m;
  }, hl.isPortal = function(z) {
    return L(z) === i;
  }, hl.isProfiler = function(z) {
    return L(z) === o;
  }, hl.isStrictMode = function(z) {
    return L(z) === s;
  }, hl.isSuspense = function(z) {
    return L(z) === p;
  }, hl.isValidElementType = function(z) {
    return typeof z == "string" || typeof z == "function" || z === n || z === h || z === o || z === s || z === p || z === y || typeof z == "object" && z !== null && (z.$$typeof === A || z.$$typeof === m || z.$$typeof === r || z.$$typeof === l || z.$$typeof === I || z.$$typeof === O || z.$$typeof === R || z.$$typeof === F || z.$$typeof === C);
  }, hl.typeOf = L, hl;
}
var fl = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var W3e;
function rOe() {
  return W3e || (W3e = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, i = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, s = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, r = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, I = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, y = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, A = e ? Symbol.for("react.lazy") : 60116, C = e ? Symbol.for("react.block") : 60121, O = e ? Symbol.for("react.fundamental") : 60117, R = e ? Symbol.for("react.responder") : 60118, F = e ? Symbol.for("react.scope") : 60119;
    function L(ni) {
      return typeof ni == "string" || typeof ni == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      ni === n || ni === h || ni === o || ni === s || ni === p || ni === y || typeof ni == "object" && ni !== null && (ni.$$typeof === A || ni.$$typeof === m || ni.$$typeof === r || ni.$$typeof === l || ni.$$typeof === I || ni.$$typeof === O || ni.$$typeof === R || ni.$$typeof === F || ni.$$typeof === C);
    }
    function P(ni) {
      if (typeof ni == "object" && ni !== null) {
        var Ci = ni.$$typeof;
        switch (Ci) {
          case t:
            var Se = ni.type;
            switch (Se) {
              case c:
              case h:
              case n:
              case o:
              case s:
              case p:
                return Se;
              default:
                var si = Se && Se.$$typeof;
                switch (si) {
                  case l:
                  case I:
                  case A:
                  case m:
                  case r:
                    return si;
                  default:
                    return Ci;
                }
            }
          case i:
            return Ci;
        }
      }
    }
    var z = c, W = h, re = l, ce = r, te = t, ee = I, Ne = n, Ae = A, Oe = m, pe = i, je = o, Ve = s, $e = p, vt = !1;
    function Rt(ni) {
      return vt || (vt = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), ze(ni) || P(ni) === c;
    }
    function ze(ni) {
      return P(ni) === h;
    }
    function mt(ni) {
      return P(ni) === l;
    }
    function Et(ni) {
      return P(ni) === r;
    }
    function it(ni) {
      return typeof ni == "object" && ni !== null && ni.$$typeof === t;
    }
    function Dt(ni) {
      return P(ni) === I;
    }
    function Ct(ni) {
      return P(ni) === n;
    }
    function Kt(ni) {
      return P(ni) === A;
    }
    function Zt(ni) {
      return P(ni) === m;
    }
    function Xt(ni) {
      return P(ni) === i;
    }
    function gi(ni) {
      return P(ni) === o;
    }
    function Wt(ni) {
      return P(ni) === s;
    }
    function Di(ni) {
      return P(ni) === p;
    }
    fl.AsyncMode = z, fl.ConcurrentMode = W, fl.ContextConsumer = re, fl.ContextProvider = ce, fl.Element = te, fl.ForwardRef = ee, fl.Fragment = Ne, fl.Lazy = Ae, fl.Memo = Oe, fl.Portal = pe, fl.Profiler = je, fl.StrictMode = Ve, fl.Suspense = $e, fl.isAsyncMode = Rt, fl.isConcurrentMode = ze, fl.isContextConsumer = mt, fl.isContextProvider = Et, fl.isElement = it, fl.isForwardRef = Dt, fl.isFragment = Ct, fl.isLazy = Kt, fl.isMemo = Zt, fl.isPortal = Xt, fl.isProfiler = gi, fl.isStrictMode = Wt, fl.isSuspense = Di, fl.isValidElementType = L, fl.typeOf = P;
  })()), fl;
}
var Y3e;
function pTe() {
  return Y3e || (Y3e = 1, process.env.NODE_ENV === "production" ? lne.exports = oOe() : lne.exports = rOe()), lne.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Yue, q3e;
function lOe() {
  if (q3e) return Yue;
  q3e = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, i = Object.prototype.propertyIsEnumerable;
  function n(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function s() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var r = {}, l = 0; l < 10; l++)
        r["_" + String.fromCharCode(l)] = l;
      var c = Object.getOwnPropertyNames(r).map(function(I) {
        return r[I];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var h = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(I) {
        h[I] = I;
      }), Object.keys(Object.assign({}, h)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Yue = s() ? Object.assign : function(o, r) {
    for (var l, c = n(o), h, I = 1; I < arguments.length; I++) {
      l = Object(arguments[I]);
      for (var p in l)
        t.call(l, p) && (c[p] = l[p]);
      if (e) {
        h = e(l);
        for (var y = 0; y < h.length; y++)
          i.call(l, h[y]) && (c[h[y]] = l[h[y]]);
      }
    }
    return c;
  }, Yue;
}
var que, $3e;
function ype() {
  if ($3e) return que;
  $3e = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return que = e, que;
}
var $ue, K3e;
function mTe() {
  return K3e || (K3e = 1, $ue = Function.call.bind(Object.prototype.hasOwnProperty)), $ue;
}
var Kue, Z3e;
function aOe() {
  if (Z3e) return Kue;
  Z3e = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ ype(), i = {}, n = /* @__PURE__ */ mTe();
    e = function(o) {
      var r = "Warning: " + o;
      typeof console < "u" && console.error(r);
      try {
        throw new Error(r);
      } catch {
      }
    };
  }
  function s(o, r, l, c, h) {
    if (process.env.NODE_ENV !== "production") {
      for (var I in o)
        if (n(o, I)) {
          var p;
          try {
            if (typeof o[I] != "function") {
              var y = Error(
                (c || "React class") + ": " + l + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw y.name = "Invariant Violation", y;
            }
            p = o[I](r, I, c, l, null, t);
          } catch (A) {
            p = A;
          }
          if (p && !(p instanceof Error) && e(
            (c || "React class") + ": type specification of " + l + " `" + I + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof p + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), p instanceof Error && !(p.message in i)) {
            i[p.message] = !0;
            var m = h ? h() : "";
            e(
              "Failed " + l + " type: " + p.message + (m ?? "")
            );
          }
        }
    }
  }
  return s.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (i = {});
  }, Kue = s, Kue;
}
var Zue, Q3e;
function uOe() {
  if (Q3e) return Zue;
  Q3e = 1;
  var e = pTe(), t = lOe(), i = /* @__PURE__ */ ype(), n = /* @__PURE__ */ mTe(), s = /* @__PURE__ */ aOe(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(l) {
    var c = "Warning: " + l;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function r() {
    return null;
  }
  return Zue = function(l, c) {
    var h = typeof Symbol == "function" && Symbol.iterator, I = "@@iterator";
    function p(ze) {
      var mt = ze && (h && ze[h] || ze[I]);
      if (typeof mt == "function")
        return mt;
    }
    var y = "<<anonymous>>", m = {
      array: R("array"),
      bigint: R("bigint"),
      bool: R("boolean"),
      func: R("function"),
      number: R("number"),
      object: R("object"),
      string: R("string"),
      symbol: R("symbol"),
      any: F(),
      arrayOf: L,
      element: P(),
      elementType: z(),
      instanceOf: W,
      node: ee(),
      objectOf: ce,
      oneOf: re,
      oneOfType: te,
      shape: Ae,
      exact: Oe
    };
    function A(ze, mt) {
      return ze === mt ? ze !== 0 || 1 / ze === 1 / mt : ze !== ze && mt !== mt;
    }
    function C(ze, mt) {
      this.message = ze, this.data = mt && typeof mt == "object" ? mt : {}, this.stack = "";
    }
    C.prototype = Error.prototype;
    function O(ze) {
      if (process.env.NODE_ENV !== "production")
        var mt = {}, Et = 0;
      function it(Ct, Kt, Zt, Xt, gi, Wt, Di) {
        if (Xt = Xt || y, Wt = Wt || Zt, Di !== i) {
          if (c) {
            var ni = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw ni.name = "Invariant Violation", ni;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Ci = Xt + ":" + Zt;
            !mt[Ci] && // Avoid spamming the console because they are often not actionable except for lib authors
            Et < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + Wt + "` prop on `" + Xt + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), mt[Ci] = !0, Et++);
          }
        }
        return Kt[Zt] == null ? Ct ? Kt[Zt] === null ? new C("The " + gi + " `" + Wt + "` is marked as required " + ("in `" + Xt + "`, but its value is `null`.")) : new C("The " + gi + " `" + Wt + "` is marked as required in " + ("`" + Xt + "`, but its value is `undefined`.")) : null : ze(Kt, Zt, Xt, gi, Wt);
      }
      var Dt = it.bind(null, !1);
      return Dt.isRequired = it.bind(null, !0), Dt;
    }
    function R(ze) {
      function mt(Et, it, Dt, Ct, Kt, Zt) {
        var Xt = Et[it], gi = Ve(Xt);
        if (gi !== ze) {
          var Wt = $e(Xt);
          return new C(
            "Invalid " + Ct + " `" + Kt + "` of type " + ("`" + Wt + "` supplied to `" + Dt + "`, expected ") + ("`" + ze + "`."),
            { expectedType: ze }
          );
        }
        return null;
      }
      return O(mt);
    }
    function F() {
      return O(r);
    }
    function L(ze) {
      function mt(Et, it, Dt, Ct, Kt) {
        if (typeof ze != "function")
          return new C("Property `" + Kt + "` of component `" + Dt + "` has invalid PropType notation inside arrayOf.");
        var Zt = Et[it];
        if (!Array.isArray(Zt)) {
          var Xt = Ve(Zt);
          return new C("Invalid " + Ct + " `" + Kt + "` of type " + ("`" + Xt + "` supplied to `" + Dt + "`, expected an array."));
        }
        for (var gi = 0; gi < Zt.length; gi++) {
          var Wt = ze(Zt, gi, Dt, Ct, Kt + "[" + gi + "]", i);
          if (Wt instanceof Error)
            return Wt;
        }
        return null;
      }
      return O(mt);
    }
    function P() {
      function ze(mt, Et, it, Dt, Ct) {
        var Kt = mt[Et];
        if (!l(Kt)) {
          var Zt = Ve(Kt);
          return new C("Invalid " + Dt + " `" + Ct + "` of type " + ("`" + Zt + "` supplied to `" + it + "`, expected a single ReactElement."));
        }
        return null;
      }
      return O(ze);
    }
    function z() {
      function ze(mt, Et, it, Dt, Ct) {
        var Kt = mt[Et];
        if (!e.isValidElementType(Kt)) {
          var Zt = Ve(Kt);
          return new C("Invalid " + Dt + " `" + Ct + "` of type " + ("`" + Zt + "` supplied to `" + it + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return O(ze);
    }
    function W(ze) {
      function mt(Et, it, Dt, Ct, Kt) {
        if (!(Et[it] instanceof ze)) {
          var Zt = ze.name || y, Xt = Rt(Et[it]);
          return new C("Invalid " + Ct + " `" + Kt + "` of type " + ("`" + Xt + "` supplied to `" + Dt + "`, expected ") + ("instance of `" + Zt + "`."));
        }
        return null;
      }
      return O(mt);
    }
    function re(ze) {
      if (!Array.isArray(ze))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), r;
      function mt(Et, it, Dt, Ct, Kt) {
        for (var Zt = Et[it], Xt = 0; Xt < ze.length; Xt++)
          if (A(Zt, ze[Xt]))
            return null;
        var gi = JSON.stringify(ze, function(Di, ni) {
          var Ci = $e(ni);
          return Ci === "symbol" ? String(ni) : ni;
        });
        return new C("Invalid " + Ct + " `" + Kt + "` of value `" + String(Zt) + "` " + ("supplied to `" + Dt + "`, expected one of " + gi + "."));
      }
      return O(mt);
    }
    function ce(ze) {
      function mt(Et, it, Dt, Ct, Kt) {
        if (typeof ze != "function")
          return new C("Property `" + Kt + "` of component `" + Dt + "` has invalid PropType notation inside objectOf.");
        var Zt = Et[it], Xt = Ve(Zt);
        if (Xt !== "object")
          return new C("Invalid " + Ct + " `" + Kt + "` of type " + ("`" + Xt + "` supplied to `" + Dt + "`, expected an object."));
        for (var gi in Zt)
          if (n(Zt, gi)) {
            var Wt = ze(Zt, gi, Dt, Ct, Kt + "." + gi, i);
            if (Wt instanceof Error)
              return Wt;
          }
        return null;
      }
      return O(mt);
    }
    function te(ze) {
      if (!Array.isArray(ze))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), r;
      for (var mt = 0; mt < ze.length; mt++) {
        var Et = ze[mt];
        if (typeof Et != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + vt(Et) + " at index " + mt + "."
          ), r;
      }
      function it(Dt, Ct, Kt, Zt, Xt) {
        for (var gi = [], Wt = 0; Wt < ze.length; Wt++) {
          var Di = ze[Wt], ni = Di(Dt, Ct, Kt, Zt, Xt, i);
          if (ni == null)
            return null;
          ni.data && n(ni.data, "expectedType") && gi.push(ni.data.expectedType);
        }
        var Ci = gi.length > 0 ? ", expected one of type [" + gi.join(", ") + "]" : "";
        return new C("Invalid " + Zt + " `" + Xt + "` supplied to " + ("`" + Kt + "`" + Ci + "."));
      }
      return O(it);
    }
    function ee() {
      function ze(mt, Et, it, Dt, Ct) {
        return pe(mt[Et]) ? null : new C("Invalid " + Dt + " `" + Ct + "` supplied to " + ("`" + it + "`, expected a ReactNode."));
      }
      return O(ze);
    }
    function Ne(ze, mt, Et, it, Dt) {
      return new C(
        (ze || "React class") + ": " + mt + " type `" + Et + "." + it + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Dt + "`."
      );
    }
    function Ae(ze) {
      function mt(Et, it, Dt, Ct, Kt) {
        var Zt = Et[it], Xt = Ve(Zt);
        if (Xt !== "object")
          return new C("Invalid " + Ct + " `" + Kt + "` of type `" + Xt + "` " + ("supplied to `" + Dt + "`, expected `object`."));
        for (var gi in ze) {
          var Wt = ze[gi];
          if (typeof Wt != "function")
            return Ne(Dt, Ct, Kt, gi, $e(Wt));
          var Di = Wt(Zt, gi, Dt, Ct, Kt + "." + gi, i);
          if (Di)
            return Di;
        }
        return null;
      }
      return O(mt);
    }
    function Oe(ze) {
      function mt(Et, it, Dt, Ct, Kt) {
        var Zt = Et[it], Xt = Ve(Zt);
        if (Xt !== "object")
          return new C("Invalid " + Ct + " `" + Kt + "` of type `" + Xt + "` " + ("supplied to `" + Dt + "`, expected `object`."));
        var gi = t({}, Et[it], ze);
        for (var Wt in gi) {
          var Di = ze[Wt];
          if (n(ze, Wt) && typeof Di != "function")
            return Ne(Dt, Ct, Kt, Wt, $e(Di));
          if (!Di)
            return new C(
              "Invalid " + Ct + " `" + Kt + "` key `" + Wt + "` supplied to `" + Dt + "`.\nBad object: " + JSON.stringify(Et[it], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(ze), null, "  ")
            );
          var ni = Di(Zt, Wt, Dt, Ct, Kt + "." + Wt, i);
          if (ni)
            return ni;
        }
        return null;
      }
      return O(mt);
    }
    function pe(ze) {
      switch (typeof ze) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !ze;
        case "object":
          if (Array.isArray(ze))
            return ze.every(pe);
          if (ze === null || l(ze))
            return !0;
          var mt = p(ze);
          if (mt) {
            var Et = mt.call(ze), it;
            if (mt !== ze.entries) {
              for (; !(it = Et.next()).done; )
                if (!pe(it.value))
                  return !1;
            } else
              for (; !(it = Et.next()).done; ) {
                var Dt = it.value;
                if (Dt && !pe(Dt[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function je(ze, mt) {
      return ze === "symbol" ? !0 : mt ? mt["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && mt instanceof Symbol : !1;
    }
    function Ve(ze) {
      var mt = typeof ze;
      return Array.isArray(ze) ? "array" : ze instanceof RegExp ? "object" : je(mt, ze) ? "symbol" : mt;
    }
    function $e(ze) {
      if (typeof ze > "u" || ze === null)
        return "" + ze;
      var mt = Ve(ze);
      if (mt === "object") {
        if (ze instanceof Date)
          return "date";
        if (ze instanceof RegExp)
          return "regexp";
      }
      return mt;
    }
    function vt(ze) {
      var mt = $e(ze);
      switch (mt) {
        case "array":
        case "object":
          return "an " + mt;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + mt;
        default:
          return mt;
      }
    }
    function Rt(ze) {
      return !ze.constructor || !ze.constructor.name ? y : ze.constructor.name;
    }
    return m.checkPropTypes = s, m.resetWarningCache = s.resetWarningCache, m.PropTypes = m, m;
  }, Zue;
}
var Que, J3e;
function dOe() {
  if (J3e) return Que;
  J3e = 1;
  var e = /* @__PURE__ */ ype();
  function t() {
  }
  function i() {
  }
  return i.resetWarningCache = t, Que = function() {
    function n(r, l, c, h, I, p) {
      if (p !== e) {
        var y = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw y.name = "Invariant Violation", y;
      }
    }
    n.isRequired = n;
    function s() {
      return n;
    }
    var o = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: s,
      element: n,
      elementType: n,
      instanceOf: s,
      node: n,
      objectOf: s,
      oneOf: s,
      oneOfType: s,
      shape: s,
      exact: s,
      checkPropTypes: i,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, Que;
}
var X3e;
function cOe() {
  if (X3e) return rne.exports;
  if (X3e = 1, process.env.NODE_ENV !== "production") {
    var e = pTe(), t = !0;
    rne.exports = /* @__PURE__ */ uOe()(e.isElement, t);
  } else
    rne.exports = /* @__PURE__ */ dOe()();
  return rne.exports;
}
var hOe = /* @__PURE__ */ cOe();
const Bl = /* @__PURE__ */ rie(hOe);
function DH(e, t, i, n) {
  function s(o) {
    return o instanceof i ? o : new i(function(r) {
      r(o);
    });
  }
  return new (i || (i = Promise))(function(o, r) {
    function l(I) {
      try {
        h(n.next(I));
      } catch (p) {
        r(p);
      }
    }
    function c(I) {
      try {
        h(n.throw(I));
      } catch (p) {
        r(p);
      }
    }
    function h(I) {
      I.done ? o(I.value) : s(I.value).then(l, c);
    }
    h((n = n.apply(e, t || [])).next());
  });
}
const fOe = /* @__PURE__ */ new Map([
  // https://github.com/guzzle/psr7/blob/2d9260799e713f1c475d3c5fdc3d6561ff7441b2/src/MimeType.php
  ["1km", "application/vnd.1000minds.decision-model+xml"],
  ["3dml", "text/vnd.in3d.3dml"],
  ["3ds", "image/x-3ds"],
  ["3g2", "video/3gpp2"],
  ["3gp", "video/3gp"],
  ["3gpp", "video/3gpp"],
  ["3mf", "model/3mf"],
  ["7z", "application/x-7z-compressed"],
  ["7zip", "application/x-7z-compressed"],
  ["123", "application/vnd.lotus-1-2-3"],
  ["aab", "application/x-authorware-bin"],
  ["aac", "audio/x-acc"],
  ["aam", "application/x-authorware-map"],
  ["aas", "application/x-authorware-seg"],
  ["abw", "application/x-abiword"],
  ["ac", "application/vnd.nokia.n-gage.ac+xml"],
  ["ac3", "audio/ac3"],
  ["acc", "application/vnd.americandynamics.acc"],
  ["ace", "application/x-ace-compressed"],
  ["acu", "application/vnd.acucobol"],
  ["acutc", "application/vnd.acucorp"],
  ["adp", "audio/adpcm"],
  ["aep", "application/vnd.audiograph"],
  ["afm", "application/x-font-type1"],
  ["afp", "application/vnd.ibm.modcap"],
  ["ahead", "application/vnd.ahead.space"],
  ["ai", "application/pdf"],
  ["aif", "audio/x-aiff"],
  ["aifc", "audio/x-aiff"],
  ["aiff", "audio/x-aiff"],
  ["air", "application/vnd.adobe.air-application-installer-package+zip"],
  ["ait", "application/vnd.dvb.ait"],
  ["ami", "application/vnd.amiga.ami"],
  ["amr", "audio/amr"],
  ["apk", "application/vnd.android.package-archive"],
  ["apng", "image/apng"],
  ["appcache", "text/cache-manifest"],
  ["application", "application/x-ms-application"],
  ["apr", "application/vnd.lotus-approach"],
  ["arc", "application/x-freearc"],
  ["arj", "application/x-arj"],
  ["asc", "application/pgp-signature"],
  ["asf", "video/x-ms-asf"],
  ["asm", "text/x-asm"],
  ["aso", "application/vnd.accpac.simply.aso"],
  ["asx", "video/x-ms-asf"],
  ["atc", "application/vnd.acucorp"],
  ["atom", "application/atom+xml"],
  ["atomcat", "application/atomcat+xml"],
  ["atomdeleted", "application/atomdeleted+xml"],
  ["atomsvc", "application/atomsvc+xml"],
  ["atx", "application/vnd.antix.game-component"],
  ["au", "audio/x-au"],
  ["avi", "video/x-msvideo"],
  ["avif", "image/avif"],
  ["aw", "application/applixware"],
  ["azf", "application/vnd.airzip.filesecure.azf"],
  ["azs", "application/vnd.airzip.filesecure.azs"],
  ["azv", "image/vnd.airzip.accelerator.azv"],
  ["azw", "application/vnd.amazon.ebook"],
  ["b16", "image/vnd.pco.b16"],
  ["bat", "application/x-msdownload"],
  ["bcpio", "application/x-bcpio"],
  ["bdf", "application/x-font-bdf"],
  ["bdm", "application/vnd.syncml.dm+wbxml"],
  ["bdoc", "application/x-bdoc"],
  ["bed", "application/vnd.realvnc.bed"],
  ["bh2", "application/vnd.fujitsu.oasysprs"],
  ["bin", "application/octet-stream"],
  ["blb", "application/x-blorb"],
  ["blorb", "application/x-blorb"],
  ["bmi", "application/vnd.bmi"],
  ["bmml", "application/vnd.balsamiq.bmml+xml"],
  ["bmp", "image/bmp"],
  ["book", "application/vnd.framemaker"],
  ["box", "application/vnd.previewsystems.box"],
  ["boz", "application/x-bzip2"],
  ["bpk", "application/octet-stream"],
  ["bpmn", "application/octet-stream"],
  ["bsp", "model/vnd.valve.source.compiled-map"],
  ["btif", "image/prs.btif"],
  ["buffer", "application/octet-stream"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["c", "text/x-c"],
  ["c4d", "application/vnd.clonk.c4group"],
  ["c4f", "application/vnd.clonk.c4group"],
  ["c4g", "application/vnd.clonk.c4group"],
  ["c4p", "application/vnd.clonk.c4group"],
  ["c4u", "application/vnd.clonk.c4group"],
  ["c11amc", "application/vnd.cluetrust.cartomobile-config"],
  ["c11amz", "application/vnd.cluetrust.cartomobile-config-pkg"],
  ["cab", "application/vnd.ms-cab-compressed"],
  ["caf", "audio/x-caf"],
  ["cap", "application/vnd.tcpdump.pcap"],
  ["car", "application/vnd.curl.car"],
  ["cat", "application/vnd.ms-pki.seccat"],
  ["cb7", "application/x-cbr"],
  ["cba", "application/x-cbr"],
  ["cbr", "application/x-cbr"],
  ["cbt", "application/x-cbr"],
  ["cbz", "application/x-cbr"],
  ["cc", "text/x-c"],
  ["cco", "application/x-cocoa"],
  ["cct", "application/x-director"],
  ["ccxml", "application/ccxml+xml"],
  ["cdbcmsg", "application/vnd.contact.cmsg"],
  ["cda", "application/x-cdf"],
  ["cdf", "application/x-netcdf"],
  ["cdfx", "application/cdfx+xml"],
  ["cdkey", "application/vnd.mediastation.cdkey"],
  ["cdmia", "application/cdmi-capability"],
  ["cdmic", "application/cdmi-container"],
  ["cdmid", "application/cdmi-domain"],
  ["cdmio", "application/cdmi-object"],
  ["cdmiq", "application/cdmi-queue"],
  ["cdr", "application/cdr"],
  ["cdx", "chemical/x-cdx"],
  ["cdxml", "application/vnd.chemdraw+xml"],
  ["cdy", "application/vnd.cinderella"],
  ["cer", "application/pkix-cert"],
  ["cfs", "application/x-cfs-compressed"],
  ["cgm", "image/cgm"],
  ["chat", "application/x-chat"],
  ["chm", "application/vnd.ms-htmlhelp"],
  ["chrt", "application/vnd.kde.kchart"],
  ["cif", "chemical/x-cif"],
  ["cii", "application/vnd.anser-web-certificate-issue-initiation"],
  ["cil", "application/vnd.ms-artgalry"],
  ["cjs", "application/node"],
  ["cla", "application/vnd.claymore"],
  ["class", "application/octet-stream"],
  ["clkk", "application/vnd.crick.clicker.keyboard"],
  ["clkp", "application/vnd.crick.clicker.palette"],
  ["clkt", "application/vnd.crick.clicker.template"],
  ["clkw", "application/vnd.crick.clicker.wordbank"],
  ["clkx", "application/vnd.crick.clicker"],
  ["clp", "application/x-msclip"],
  ["cmc", "application/vnd.cosmocaller"],
  ["cmdf", "chemical/x-cmdf"],
  ["cml", "chemical/x-cml"],
  ["cmp", "application/vnd.yellowriver-custom-menu"],
  ["cmx", "image/x-cmx"],
  ["cod", "application/vnd.rim.cod"],
  ["coffee", "text/coffeescript"],
  ["com", "application/x-msdownload"],
  ["conf", "text/plain"],
  ["cpio", "application/x-cpio"],
  ["cpp", "text/x-c"],
  ["cpt", "application/mac-compactpro"],
  ["crd", "application/x-mscardfile"],
  ["crl", "application/pkix-crl"],
  ["crt", "application/x-x509-ca-cert"],
  ["crx", "application/x-chrome-extension"],
  ["cryptonote", "application/vnd.rig.cryptonote"],
  ["csh", "application/x-csh"],
  ["csl", "application/vnd.citationstyles.style+xml"],
  ["csml", "chemical/x-csml"],
  ["csp", "application/vnd.commonspace"],
  ["csr", "application/octet-stream"],
  ["css", "text/css"],
  ["cst", "application/x-director"],
  ["csv", "text/csv"],
  ["cu", "application/cu-seeme"],
  ["curl", "text/vnd.curl"],
  ["cww", "application/prs.cww"],
  ["cxt", "application/x-director"],
  ["cxx", "text/x-c"],
  ["dae", "model/vnd.collada+xml"],
  ["daf", "application/vnd.mobius.daf"],
  ["dart", "application/vnd.dart"],
  ["dataless", "application/vnd.fdsn.seed"],
  ["davmount", "application/davmount+xml"],
  ["dbf", "application/vnd.dbf"],
  ["dbk", "application/docbook+xml"],
  ["dcr", "application/x-director"],
  ["dcurl", "text/vnd.curl.dcurl"],
  ["dd2", "application/vnd.oma.dd2+xml"],
  ["ddd", "application/vnd.fujixerox.ddd"],
  ["ddf", "application/vnd.syncml.dmddf+xml"],
  ["dds", "image/vnd.ms-dds"],
  ["deb", "application/x-debian-package"],
  ["def", "text/plain"],
  ["deploy", "application/octet-stream"],
  ["der", "application/x-x509-ca-cert"],
  ["dfac", "application/vnd.dreamfactory"],
  ["dgc", "application/x-dgc-compressed"],
  ["dic", "text/x-c"],
  ["dir", "application/x-director"],
  ["dis", "application/vnd.mobius.dis"],
  ["disposition-notification", "message/disposition-notification"],
  ["dist", "application/octet-stream"],
  ["distz", "application/octet-stream"],
  ["djv", "image/vnd.djvu"],
  ["djvu", "image/vnd.djvu"],
  ["dll", "application/octet-stream"],
  ["dmg", "application/x-apple-diskimage"],
  ["dmn", "application/octet-stream"],
  ["dmp", "application/vnd.tcpdump.pcap"],
  ["dms", "application/octet-stream"],
  ["dna", "application/vnd.dna"],
  ["doc", "application/msword"],
  ["docm", "application/vnd.ms-word.template.macroEnabled.12"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["dot", "application/msword"],
  ["dotm", "application/vnd.ms-word.template.macroEnabled.12"],
  ["dotx", "application/vnd.openxmlformats-officedocument.wordprocessingml.template"],
  ["dp", "application/vnd.osgi.dp"],
  ["dpg", "application/vnd.dpgraph"],
  ["dra", "audio/vnd.dra"],
  ["drle", "image/dicom-rle"],
  ["dsc", "text/prs.lines.tag"],
  ["dssc", "application/dssc+der"],
  ["dtb", "application/x-dtbook+xml"],
  ["dtd", "application/xml-dtd"],
  ["dts", "audio/vnd.dts"],
  ["dtshd", "audio/vnd.dts.hd"],
  ["dump", "application/octet-stream"],
  ["dvb", "video/vnd.dvb.file"],
  ["dvi", "application/x-dvi"],
  ["dwd", "application/atsc-dwd+xml"],
  ["dwf", "model/vnd.dwf"],
  ["dwg", "image/vnd.dwg"],
  ["dxf", "image/vnd.dxf"],
  ["dxp", "application/vnd.spotfire.dxp"],
  ["dxr", "application/x-director"],
  ["ear", "application/java-archive"],
  ["ecelp4800", "audio/vnd.nuera.ecelp4800"],
  ["ecelp7470", "audio/vnd.nuera.ecelp7470"],
  ["ecelp9600", "audio/vnd.nuera.ecelp9600"],
  ["ecma", "application/ecmascript"],
  ["edm", "application/vnd.novadigm.edm"],
  ["edx", "application/vnd.novadigm.edx"],
  ["efif", "application/vnd.picsel"],
  ["ei6", "application/vnd.pg.osasli"],
  ["elc", "application/octet-stream"],
  ["emf", "image/emf"],
  ["eml", "message/rfc822"],
  ["emma", "application/emma+xml"],
  ["emotionml", "application/emotionml+xml"],
  ["emz", "application/x-msmetafile"],
  ["eol", "audio/vnd.digital-winds"],
  ["eot", "application/vnd.ms-fontobject"],
  ["eps", "application/postscript"],
  ["epub", "application/epub+zip"],
  ["es", "application/ecmascript"],
  ["es3", "application/vnd.eszigno3+xml"],
  ["esa", "application/vnd.osgi.subsystem"],
  ["esf", "application/vnd.epson.esf"],
  ["et3", "application/vnd.eszigno3+xml"],
  ["etx", "text/x-setext"],
  ["eva", "application/x-eva"],
  ["evy", "application/x-envoy"],
  ["exe", "application/octet-stream"],
  ["exi", "application/exi"],
  ["exp", "application/express"],
  ["exr", "image/aces"],
  ["ext", "application/vnd.novadigm.ext"],
  ["ez", "application/andrew-inset"],
  ["ez2", "application/vnd.ezpix-album"],
  ["ez3", "application/vnd.ezpix-package"],
  ["f", "text/x-fortran"],
  ["f4v", "video/mp4"],
  ["f77", "text/x-fortran"],
  ["f90", "text/x-fortran"],
  ["fbs", "image/vnd.fastbidsheet"],
  ["fcdt", "application/vnd.adobe.formscentral.fcdt"],
  ["fcs", "application/vnd.isac.fcs"],
  ["fdf", "application/vnd.fdf"],
  ["fdt", "application/fdt+xml"],
  ["fe_launch", "application/vnd.denovo.fcselayout-link"],
  ["fg5", "application/vnd.fujitsu.oasysgp"],
  ["fgd", "application/x-director"],
  ["fh", "image/x-freehand"],
  ["fh4", "image/x-freehand"],
  ["fh5", "image/x-freehand"],
  ["fh7", "image/x-freehand"],
  ["fhc", "image/x-freehand"],
  ["fig", "application/x-xfig"],
  ["fits", "image/fits"],
  ["flac", "audio/x-flac"],
  ["fli", "video/x-fli"],
  ["flo", "application/vnd.micrografx.flo"],
  ["flv", "video/x-flv"],
  ["flw", "application/vnd.kde.kivio"],
  ["flx", "text/vnd.fmi.flexstor"],
  ["fly", "text/vnd.fly"],
  ["fm", "application/vnd.framemaker"],
  ["fnc", "application/vnd.frogans.fnc"],
  ["fo", "application/vnd.software602.filler.form+xml"],
  ["for", "text/x-fortran"],
  ["fpx", "image/vnd.fpx"],
  ["frame", "application/vnd.framemaker"],
  ["fsc", "application/vnd.fsc.weblaunch"],
  ["fst", "image/vnd.fst"],
  ["ftc", "application/vnd.fluxtime.clip"],
  ["fti", "application/vnd.anser-web-funds-transfer-initiation"],
  ["fvt", "video/vnd.fvt"],
  ["fxp", "application/vnd.adobe.fxp"],
  ["fxpl", "application/vnd.adobe.fxp"],
  ["fzs", "application/vnd.fuzzysheet"],
  ["g2w", "application/vnd.geoplan"],
  ["g3", "image/g3fax"],
  ["g3w", "application/vnd.geospace"],
  ["gac", "application/vnd.groove-account"],
  ["gam", "application/x-tads"],
  ["gbr", "application/rpki-ghostbusters"],
  ["gca", "application/x-gca-compressed"],
  ["gdl", "model/vnd.gdl"],
  ["gdoc", "application/vnd.google-apps.document"],
  ["geo", "application/vnd.dynageo"],
  ["geojson", "application/geo+json"],
  ["gex", "application/vnd.geometry-explorer"],
  ["ggb", "application/vnd.geogebra.file"],
  ["ggt", "application/vnd.geogebra.tool"],
  ["ghf", "application/vnd.groove-help"],
  ["gif", "image/gif"],
  ["gim", "application/vnd.groove-identity-message"],
  ["glb", "model/gltf-binary"],
  ["gltf", "model/gltf+json"],
  ["gml", "application/gml+xml"],
  ["gmx", "application/vnd.gmx"],
  ["gnumeric", "application/x-gnumeric"],
  ["gpg", "application/gpg-keys"],
  ["gph", "application/vnd.flographit"],
  ["gpx", "application/gpx+xml"],
  ["gqf", "application/vnd.grafeq"],
  ["gqs", "application/vnd.grafeq"],
  ["gram", "application/srgs"],
  ["gramps", "application/x-gramps-xml"],
  ["gre", "application/vnd.geometry-explorer"],
  ["grv", "application/vnd.groove-injector"],
  ["grxml", "application/srgs+xml"],
  ["gsf", "application/x-font-ghostscript"],
  ["gsheet", "application/vnd.google-apps.spreadsheet"],
  ["gslides", "application/vnd.google-apps.presentation"],
  ["gtar", "application/x-gtar"],
  ["gtm", "application/vnd.groove-tool-message"],
  ["gtw", "model/vnd.gtw"],
  ["gv", "text/vnd.graphviz"],
  ["gxf", "application/gxf"],
  ["gxt", "application/vnd.geonext"],
  ["gz", "application/gzip"],
  ["gzip", "application/gzip"],
  ["h", "text/x-c"],
  ["h261", "video/h261"],
  ["h263", "video/h263"],
  ["h264", "video/h264"],
  ["hal", "application/vnd.hal+xml"],
  ["hbci", "application/vnd.hbci"],
  ["hbs", "text/x-handlebars-template"],
  ["hdd", "application/x-virtualbox-hdd"],
  ["hdf", "application/x-hdf"],
  ["heic", "image/heic"],
  ["heics", "image/heic-sequence"],
  ["heif", "image/heif"],
  ["heifs", "image/heif-sequence"],
  ["hej2", "image/hej2k"],
  ["held", "application/atsc-held+xml"],
  ["hh", "text/x-c"],
  ["hjson", "application/hjson"],
  ["hlp", "application/winhlp"],
  ["hpgl", "application/vnd.hp-hpgl"],
  ["hpid", "application/vnd.hp-hpid"],
  ["hps", "application/vnd.hp-hps"],
  ["hqx", "application/mac-binhex40"],
  ["hsj2", "image/hsj2"],
  ["htc", "text/x-component"],
  ["htke", "application/vnd.kenameaapp"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["hvd", "application/vnd.yamaha.hv-dic"],
  ["hvp", "application/vnd.yamaha.hv-voice"],
  ["hvs", "application/vnd.yamaha.hv-script"],
  ["i2g", "application/vnd.intergeo"],
  ["icc", "application/vnd.iccprofile"],
  ["ice", "x-conference/x-cooltalk"],
  ["icm", "application/vnd.iccprofile"],
  ["ico", "image/x-icon"],
  ["ics", "text/calendar"],
  ["ief", "image/ief"],
  ["ifb", "text/calendar"],
  ["ifm", "application/vnd.shana.informed.formdata"],
  ["iges", "model/iges"],
  ["igl", "application/vnd.igloader"],
  ["igm", "application/vnd.insors.igm"],
  ["igs", "model/iges"],
  ["igx", "application/vnd.micrografx.igx"],
  ["iif", "application/vnd.shana.informed.interchange"],
  ["img", "application/octet-stream"],
  ["imp", "application/vnd.accpac.simply.imp"],
  ["ims", "application/vnd.ms-ims"],
  ["in", "text/plain"],
  ["ini", "text/plain"],
  ["ink", "application/inkml+xml"],
  ["inkml", "application/inkml+xml"],
  ["install", "application/x-install-instructions"],
  ["iota", "application/vnd.astraea-software.iota"],
  ["ipfix", "application/ipfix"],
  ["ipk", "application/vnd.shana.informed.package"],
  ["irm", "application/vnd.ibm.rights-management"],
  ["irp", "application/vnd.irepository.package+xml"],
  ["iso", "application/x-iso9660-image"],
  ["itp", "application/vnd.shana.informed.formtemplate"],
  ["its", "application/its+xml"],
  ["ivp", "application/vnd.immervision-ivp"],
  ["ivu", "application/vnd.immervision-ivu"],
  ["jad", "text/vnd.sun.j2me.app-descriptor"],
  ["jade", "text/jade"],
  ["jam", "application/vnd.jam"],
  ["jar", "application/java-archive"],
  ["jardiff", "application/x-java-archive-diff"],
  ["java", "text/x-java-source"],
  ["jhc", "image/jphc"],
  ["jisp", "application/vnd.jisp"],
  ["jls", "image/jls"],
  ["jlt", "application/vnd.hp-jlyt"],
  ["jng", "image/x-jng"],
  ["jnlp", "application/x-java-jnlp-file"],
  ["joda", "application/vnd.joost.joda-archive"],
  ["jp2", "image/jp2"],
  ["jpe", "image/jpeg"],
  ["jpeg", "image/jpeg"],
  ["jpf", "image/jpx"],
  ["jpg", "image/jpeg"],
  ["jpg2", "image/jp2"],
  ["jpgm", "video/jpm"],
  ["jpgv", "video/jpeg"],
  ["jph", "image/jph"],
  ["jpm", "video/jpm"],
  ["jpx", "image/jpx"],
  ["js", "application/javascript"],
  ["json", "application/json"],
  ["json5", "application/json5"],
  ["jsonld", "application/ld+json"],
  // https://jsonlines.org/
  ["jsonl", "application/jsonl"],
  ["jsonml", "application/jsonml+json"],
  ["jsx", "text/jsx"],
  ["jxr", "image/jxr"],
  ["jxra", "image/jxra"],
  ["jxrs", "image/jxrs"],
  ["jxs", "image/jxs"],
  ["jxsc", "image/jxsc"],
  ["jxsi", "image/jxsi"],
  ["jxss", "image/jxss"],
  ["kar", "audio/midi"],
  ["karbon", "application/vnd.kde.karbon"],
  ["kdb", "application/octet-stream"],
  ["kdbx", "application/x-keepass2"],
  ["key", "application/x-iwork-keynote-sffkey"],
  ["kfo", "application/vnd.kde.kformula"],
  ["kia", "application/vnd.kidspiration"],
  ["kml", "application/vnd.google-earth.kml+xml"],
  ["kmz", "application/vnd.google-earth.kmz"],
  ["kne", "application/vnd.kinar"],
  ["knp", "application/vnd.kinar"],
  ["kon", "application/vnd.kde.kontour"],
  ["kpr", "application/vnd.kde.kpresenter"],
  ["kpt", "application/vnd.kde.kpresenter"],
  ["kpxx", "application/vnd.ds-keypoint"],
  ["ksp", "application/vnd.kde.kspread"],
  ["ktr", "application/vnd.kahootz"],
  ["ktx", "image/ktx"],
  ["ktx2", "image/ktx2"],
  ["ktz", "application/vnd.kahootz"],
  ["kwd", "application/vnd.kde.kword"],
  ["kwt", "application/vnd.kde.kword"],
  ["lasxml", "application/vnd.las.las+xml"],
  ["latex", "application/x-latex"],
  ["lbd", "application/vnd.llamagraphics.life-balance.desktop"],
  ["lbe", "application/vnd.llamagraphics.life-balance.exchange+xml"],
  ["les", "application/vnd.hhe.lesson-player"],
  ["less", "text/less"],
  ["lgr", "application/lgr+xml"],
  ["lha", "application/octet-stream"],
  ["link66", "application/vnd.route66.link66+xml"],
  ["list", "text/plain"],
  ["list3820", "application/vnd.ibm.modcap"],
  ["listafp", "application/vnd.ibm.modcap"],
  ["litcoffee", "text/coffeescript"],
  ["lnk", "application/x-ms-shortcut"],
  ["log", "text/plain"],
  ["lostxml", "application/lost+xml"],
  ["lrf", "application/octet-stream"],
  ["lrm", "application/vnd.ms-lrm"],
  ["ltf", "application/vnd.frogans.ltf"],
  ["lua", "text/x-lua"],
  ["luac", "application/x-lua-bytecode"],
  ["lvp", "audio/vnd.lucent.voice"],
  ["lwp", "application/vnd.lotus-wordpro"],
  ["lzh", "application/octet-stream"],
  ["m1v", "video/mpeg"],
  ["m2a", "audio/mpeg"],
  ["m2v", "video/mpeg"],
  ["m3a", "audio/mpeg"],
  ["m3u", "text/plain"],
  ["m3u8", "application/vnd.apple.mpegurl"],
  ["m4a", "audio/x-m4a"],
  ["m4p", "application/mp4"],
  ["m4s", "video/iso.segment"],
  ["m4u", "application/vnd.mpegurl"],
  ["m4v", "video/x-m4v"],
  ["m13", "application/x-msmediaview"],
  ["m14", "application/x-msmediaview"],
  ["m21", "application/mp21"],
  ["ma", "application/mathematica"],
  ["mads", "application/mads+xml"],
  ["maei", "application/mmt-aei+xml"],
  ["mag", "application/vnd.ecowin.chart"],
  ["maker", "application/vnd.framemaker"],
  ["man", "text/troff"],
  ["manifest", "text/cache-manifest"],
  ["map", "application/json"],
  ["mar", "application/octet-stream"],
  ["markdown", "text/markdown"],
  ["mathml", "application/mathml+xml"],
  ["mb", "application/mathematica"],
  ["mbk", "application/vnd.mobius.mbk"],
  ["mbox", "application/mbox"],
  ["mc1", "application/vnd.medcalcdata"],
  ["mcd", "application/vnd.mcd"],
  ["mcurl", "text/vnd.curl.mcurl"],
  ["md", "text/markdown"],
  ["mdb", "application/x-msaccess"],
  ["mdi", "image/vnd.ms-modi"],
  ["mdx", "text/mdx"],
  ["me", "text/troff"],
  ["mesh", "model/mesh"],
  ["meta4", "application/metalink4+xml"],
  ["metalink", "application/metalink+xml"],
  ["mets", "application/mets+xml"],
  ["mfm", "application/vnd.mfmp"],
  ["mft", "application/rpki-manifest"],
  ["mgp", "application/vnd.osgeo.mapguide.package"],
  ["mgz", "application/vnd.proteus.magazine"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mie", "application/x-mie"],
  ["mif", "application/vnd.mif"],
  ["mime", "message/rfc822"],
  ["mj2", "video/mj2"],
  ["mjp2", "video/mj2"],
  ["mjs", "application/javascript"],
  ["mk3d", "video/x-matroska"],
  ["mka", "audio/x-matroska"],
  ["mkd", "text/x-markdown"],
  ["mks", "video/x-matroska"],
  ["mkv", "video/x-matroska"],
  ["mlp", "application/vnd.dolby.mlp"],
  ["mmd", "application/vnd.chipnuts.karaoke-mmd"],
  ["mmf", "application/vnd.smaf"],
  ["mml", "text/mathml"],
  ["mmr", "image/vnd.fujixerox.edmics-mmr"],
  ["mng", "video/x-mng"],
  ["mny", "application/x-msmoney"],
  ["mobi", "application/x-mobipocket-ebook"],
  ["mods", "application/mods+xml"],
  ["mov", "video/quicktime"],
  ["movie", "video/x-sgi-movie"],
  ["mp2", "audio/mpeg"],
  ["mp2a", "audio/mpeg"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mp4a", "audio/mp4"],
  ["mp4s", "application/mp4"],
  ["mp4v", "video/mp4"],
  ["mp21", "application/mp21"],
  ["mpc", "application/vnd.mophun.certificate"],
  ["mpd", "application/dash+xml"],
  ["mpe", "video/mpeg"],
  ["mpeg", "video/mpeg"],
  ["mpg", "video/mpeg"],
  ["mpg4", "video/mp4"],
  ["mpga", "audio/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["mpm", "application/vnd.blueice.multipass"],
  ["mpn", "application/vnd.mophun.application"],
  ["mpp", "application/vnd.ms-project"],
  ["mpt", "application/vnd.ms-project"],
  ["mpy", "application/vnd.ibm.minipay"],
  ["mqy", "application/vnd.mobius.mqy"],
  ["mrc", "application/marc"],
  ["mrcx", "application/marcxml+xml"],
  ["ms", "text/troff"],
  ["mscml", "application/mediaservercontrol+xml"],
  ["mseed", "application/vnd.fdsn.mseed"],
  ["mseq", "application/vnd.mseq"],
  ["msf", "application/vnd.epson.msf"],
  ["msg", "application/vnd.ms-outlook"],
  ["msh", "model/mesh"],
  ["msi", "application/x-msdownload"],
  ["msl", "application/vnd.mobius.msl"],
  ["msm", "application/octet-stream"],
  ["msp", "application/octet-stream"],
  ["msty", "application/vnd.muvee.style"],
  ["mtl", "model/mtl"],
  ["mts", "model/vnd.mts"],
  ["mus", "application/vnd.musician"],
  ["musd", "application/mmt-usd+xml"],
  ["musicxml", "application/vnd.recordare.musicxml+xml"],
  ["mvb", "application/x-msmediaview"],
  ["mvt", "application/vnd.mapbox-vector-tile"],
  ["mwf", "application/vnd.mfer"],
  ["mxf", "application/mxf"],
  ["mxl", "application/vnd.recordare.musicxml"],
  ["mxmf", "audio/mobile-xmf"],
  ["mxml", "application/xv+xml"],
  ["mxs", "application/vnd.triscape.mxs"],
  ["mxu", "video/vnd.mpegurl"],
  ["n-gage", "application/vnd.nokia.n-gage.symbian.install"],
  ["n3", "text/n3"],
  ["nb", "application/mathematica"],
  ["nbp", "application/vnd.wolfram.player"],
  ["nc", "application/x-netcdf"],
  ["ncx", "application/x-dtbncx+xml"],
  ["nfo", "text/x-nfo"],
  ["ngdat", "application/vnd.nokia.n-gage.data"],
  ["nitf", "application/vnd.nitf"],
  ["nlu", "application/vnd.neurolanguage.nlu"],
  ["nml", "application/vnd.enliven"],
  ["nnd", "application/vnd.noblenet-directory"],
  ["nns", "application/vnd.noblenet-sealer"],
  ["nnw", "application/vnd.noblenet-web"],
  ["npx", "image/vnd.net-fpx"],
  ["nq", "application/n-quads"],
  ["nsc", "application/x-conference"],
  ["nsf", "application/vnd.lotus-notes"],
  ["nt", "application/n-triples"],
  ["ntf", "application/vnd.nitf"],
  ["numbers", "application/x-iwork-numbers-sffnumbers"],
  ["nzb", "application/x-nzb"],
  ["oa2", "application/vnd.fujitsu.oasys2"],
  ["oa3", "application/vnd.fujitsu.oasys3"],
  ["oas", "application/vnd.fujitsu.oasys"],
  ["obd", "application/x-msbinder"],
  ["obgx", "application/vnd.openblox.game+xml"],
  ["obj", "model/obj"],
  ["oda", "application/oda"],
  ["odb", "application/vnd.oasis.opendocument.database"],
  ["odc", "application/vnd.oasis.opendocument.chart"],
  ["odf", "application/vnd.oasis.opendocument.formula"],
  ["odft", "application/vnd.oasis.opendocument.formula-template"],
  ["odg", "application/vnd.oasis.opendocument.graphics"],
  ["odi", "application/vnd.oasis.opendocument.image"],
  ["odm", "application/vnd.oasis.opendocument.text-master"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogex", "model/vnd.opengex"],
  ["ogg", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["omdoc", "application/omdoc+xml"],
  ["onepkg", "application/onenote"],
  ["onetmp", "application/onenote"],
  ["onetoc", "application/onenote"],
  ["onetoc2", "application/onenote"],
  ["opf", "application/oebps-package+xml"],
  ["opml", "text/x-opml"],
  ["oprc", "application/vnd.palm"],
  ["opus", "audio/ogg"],
  ["org", "text/x-org"],
  ["osf", "application/vnd.yamaha.openscoreformat"],
  ["osfpvg", "application/vnd.yamaha.openscoreformat.osfpvg+xml"],
  ["osm", "application/vnd.openstreetmap.data+xml"],
  ["otc", "application/vnd.oasis.opendocument.chart-template"],
  ["otf", "font/otf"],
  ["otg", "application/vnd.oasis.opendocument.graphics-template"],
  ["oth", "application/vnd.oasis.opendocument.text-web"],
  ["oti", "application/vnd.oasis.opendocument.image-template"],
  ["otp", "application/vnd.oasis.opendocument.presentation-template"],
  ["ots", "application/vnd.oasis.opendocument.spreadsheet-template"],
  ["ott", "application/vnd.oasis.opendocument.text-template"],
  ["ova", "application/x-virtualbox-ova"],
  ["ovf", "application/x-virtualbox-ovf"],
  ["owl", "application/rdf+xml"],
  ["oxps", "application/oxps"],
  ["oxt", "application/vnd.openofficeorg.extension"],
  ["p", "text/x-pascal"],
  ["p7a", "application/x-pkcs7-signature"],
  ["p7b", "application/x-pkcs7-certificates"],
  ["p7c", "application/pkcs7-mime"],
  ["p7m", "application/pkcs7-mime"],
  ["p7r", "application/x-pkcs7-certreqresp"],
  ["p7s", "application/pkcs7-signature"],
  ["p8", "application/pkcs8"],
  ["p10", "application/x-pkcs10"],
  ["p12", "application/x-pkcs12"],
  ["pac", "application/x-ns-proxy-autoconfig"],
  ["pages", "application/x-iwork-pages-sffpages"],
  ["pas", "text/x-pascal"],
  ["paw", "application/vnd.pawaafile"],
  ["pbd", "application/vnd.powerbuilder6"],
  ["pbm", "image/x-portable-bitmap"],
  ["pcap", "application/vnd.tcpdump.pcap"],
  ["pcf", "application/x-font-pcf"],
  ["pcl", "application/vnd.hp-pcl"],
  ["pclxl", "application/vnd.hp-pclxl"],
  ["pct", "image/x-pict"],
  ["pcurl", "application/vnd.curl.pcurl"],
  ["pcx", "image/x-pcx"],
  ["pdb", "application/x-pilot"],
  ["pde", "text/x-processing"],
  ["pdf", "application/pdf"],
  ["pem", "application/x-x509-user-cert"],
  ["pfa", "application/x-font-type1"],
  ["pfb", "application/x-font-type1"],
  ["pfm", "application/x-font-type1"],
  ["pfr", "application/font-tdpfr"],
  ["pfx", "application/x-pkcs12"],
  ["pgm", "image/x-portable-graymap"],
  ["pgn", "application/x-chess-pgn"],
  ["pgp", "application/pgp"],
  ["php", "application/x-httpd-php"],
  ["php3", "application/x-httpd-php"],
  ["php4", "application/x-httpd-php"],
  ["phps", "application/x-httpd-php-source"],
  ["phtml", "application/x-httpd-php"],
  ["pic", "image/x-pict"],
  ["pkg", "application/octet-stream"],
  ["pki", "application/pkixcmp"],
  ["pkipath", "application/pkix-pkipath"],
  ["pkpass", "application/vnd.apple.pkpass"],
  ["pl", "application/x-perl"],
  ["plb", "application/vnd.3gpp.pic-bw-large"],
  ["plc", "application/vnd.mobius.plc"],
  ["plf", "application/vnd.pocketlearn"],
  ["pls", "application/pls+xml"],
  ["pm", "application/x-perl"],
  ["pml", "application/vnd.ctc-posml"],
  ["png", "image/png"],
  ["pnm", "image/x-portable-anymap"],
  ["portpkg", "application/vnd.macports.portpkg"],
  ["pot", "application/vnd.ms-powerpoint"],
  ["potm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  ["potx", "application/vnd.openxmlformats-officedocument.presentationml.template"],
  ["ppa", "application/vnd.ms-powerpoint"],
  ["ppam", "application/vnd.ms-powerpoint.addin.macroEnabled.12"],
  ["ppd", "application/vnd.cups-ppd"],
  ["ppm", "image/x-portable-pixmap"],
  ["pps", "application/vnd.ms-powerpoint"],
  ["ppsm", "application/vnd.ms-powerpoint.slideshow.macroEnabled.12"],
  ["ppsx", "application/vnd.openxmlformats-officedocument.presentationml.slideshow"],
  ["ppt", "application/powerpoint"],
  ["pptm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["pqa", "application/vnd.palm"],
  ["prc", "application/x-pilot"],
  ["pre", "application/vnd.lotus-freelance"],
  ["prf", "application/pics-rules"],
  ["provx", "application/provenance+xml"],
  ["ps", "application/postscript"],
  ["psb", "application/vnd.3gpp.pic-bw-small"],
  ["psd", "application/x-photoshop"],
  ["psf", "application/x-font-linux-psf"],
  ["pskcxml", "application/pskc+xml"],
  ["pti", "image/prs.pti"],
  ["ptid", "application/vnd.pvi.ptid1"],
  ["pub", "application/x-mspublisher"],
  ["pvb", "application/vnd.3gpp.pic-bw-var"],
  ["pwn", "application/vnd.3m.post-it-notes"],
  ["pya", "audio/vnd.ms-playready.media.pya"],
  ["pyv", "video/vnd.ms-playready.media.pyv"],
  ["qam", "application/vnd.epson.quickanime"],
  ["qbo", "application/vnd.intu.qbo"],
  ["qfx", "application/vnd.intu.qfx"],
  ["qps", "application/vnd.publishare-delta-tree"],
  ["qt", "video/quicktime"],
  ["qwd", "application/vnd.quark.quarkxpress"],
  ["qwt", "application/vnd.quark.quarkxpress"],
  ["qxb", "application/vnd.quark.quarkxpress"],
  ["qxd", "application/vnd.quark.quarkxpress"],
  ["qxl", "application/vnd.quark.quarkxpress"],
  ["qxt", "application/vnd.quark.quarkxpress"],
  ["ra", "audio/x-realaudio"],
  ["ram", "audio/x-pn-realaudio"],
  ["raml", "application/raml+yaml"],
  ["rapd", "application/route-apd+xml"],
  ["rar", "application/x-rar"],
  ["ras", "image/x-cmu-raster"],
  ["rcprofile", "application/vnd.ipunplugged.rcprofile"],
  ["rdf", "application/rdf+xml"],
  ["rdz", "application/vnd.data-vision.rdz"],
  ["relo", "application/p2p-overlay+xml"],
  ["rep", "application/vnd.businessobjects"],
  ["res", "application/x-dtbresource+xml"],
  ["rgb", "image/x-rgb"],
  ["rif", "application/reginfo+xml"],
  ["rip", "audio/vnd.rip"],
  ["ris", "application/x-research-info-systems"],
  ["rl", "application/resource-lists+xml"],
  ["rlc", "image/vnd.fujixerox.edmics-rlc"],
  ["rld", "application/resource-lists-diff+xml"],
  ["rm", "audio/x-pn-realaudio"],
  ["rmi", "audio/midi"],
  ["rmp", "audio/x-pn-realaudio-plugin"],
  ["rms", "application/vnd.jcp.javame.midlet-rms"],
  ["rmvb", "application/vnd.rn-realmedia-vbr"],
  ["rnc", "application/relax-ng-compact-syntax"],
  ["rng", "application/xml"],
  ["roa", "application/rpki-roa"],
  ["roff", "text/troff"],
  ["rp9", "application/vnd.cloanto.rp9"],
  ["rpm", "audio/x-pn-realaudio-plugin"],
  ["rpss", "application/vnd.nokia.radio-presets"],
  ["rpst", "application/vnd.nokia.radio-preset"],
  ["rq", "application/sparql-query"],
  ["rs", "application/rls-services+xml"],
  ["rsa", "application/x-pkcs7"],
  ["rsat", "application/atsc-rsat+xml"],
  ["rsd", "application/rsd+xml"],
  ["rsheet", "application/urc-ressheet+xml"],
  ["rss", "application/rss+xml"],
  ["rtf", "text/rtf"],
  ["rtx", "text/richtext"],
  ["run", "application/x-makeself"],
  ["rusd", "application/route-usd+xml"],
  ["rv", "video/vnd.rn-realvideo"],
  ["s", "text/x-asm"],
  ["s3m", "audio/s3m"],
  ["saf", "application/vnd.yamaha.smaf-audio"],
  ["sass", "text/x-sass"],
  ["sbml", "application/sbml+xml"],
  ["sc", "application/vnd.ibm.secure-container"],
  ["scd", "application/x-msschedule"],
  ["scm", "application/vnd.lotus-screencam"],
  ["scq", "application/scvp-cv-request"],
  ["scs", "application/scvp-cv-response"],
  ["scss", "text/x-scss"],
  ["scurl", "text/vnd.curl.scurl"],
  ["sda", "application/vnd.stardivision.draw"],
  ["sdc", "application/vnd.stardivision.calc"],
  ["sdd", "application/vnd.stardivision.impress"],
  ["sdkd", "application/vnd.solent.sdkm+xml"],
  ["sdkm", "application/vnd.solent.sdkm+xml"],
  ["sdp", "application/sdp"],
  ["sdw", "application/vnd.stardivision.writer"],
  ["sea", "application/octet-stream"],
  ["see", "application/vnd.seemail"],
  ["seed", "application/vnd.fdsn.seed"],
  ["sema", "application/vnd.sema"],
  ["semd", "application/vnd.semd"],
  ["semf", "application/vnd.semf"],
  ["senmlx", "application/senml+xml"],
  ["sensmlx", "application/sensml+xml"],
  ["ser", "application/java-serialized-object"],
  ["setpay", "application/set-payment-initiation"],
  ["setreg", "application/set-registration-initiation"],
  ["sfd-hdstx", "application/vnd.hydrostatix.sof-data"],
  ["sfs", "application/vnd.spotfire.sfs"],
  ["sfv", "text/x-sfv"],
  ["sgi", "image/sgi"],
  ["sgl", "application/vnd.stardivision.writer-global"],
  ["sgm", "text/sgml"],
  ["sgml", "text/sgml"],
  ["sh", "application/x-sh"],
  ["shar", "application/x-shar"],
  ["shex", "text/shex"],
  ["shf", "application/shf+xml"],
  ["shtml", "text/html"],
  ["sid", "image/x-mrsid-image"],
  ["sieve", "application/sieve"],
  ["sig", "application/pgp-signature"],
  ["sil", "audio/silk"],
  ["silo", "model/mesh"],
  ["sis", "application/vnd.symbian.install"],
  ["sisx", "application/vnd.symbian.install"],
  ["sit", "application/x-stuffit"],
  ["sitx", "application/x-stuffitx"],
  ["siv", "application/sieve"],
  ["skd", "application/vnd.koan"],
  ["skm", "application/vnd.koan"],
  ["skp", "application/vnd.koan"],
  ["skt", "application/vnd.koan"],
  ["sldm", "application/vnd.ms-powerpoint.slide.macroenabled.12"],
  ["sldx", "application/vnd.openxmlformats-officedocument.presentationml.slide"],
  ["slim", "text/slim"],
  ["slm", "text/slim"],
  ["sls", "application/route-s-tsid+xml"],
  ["slt", "application/vnd.epson.salt"],
  ["sm", "application/vnd.stepmania.stepchart"],
  ["smf", "application/vnd.stardivision.math"],
  ["smi", "application/smil"],
  ["smil", "application/smil"],
  ["smv", "video/x-smv"],
  ["smzip", "application/vnd.stepmania.package"],
  ["snd", "audio/basic"],
  ["snf", "application/x-font-snf"],
  ["so", "application/octet-stream"],
  ["spc", "application/x-pkcs7-certificates"],
  ["spdx", "text/spdx"],
  ["spf", "application/vnd.yamaha.smaf-phrase"],
  ["spl", "application/x-futuresplash"],
  ["spot", "text/vnd.in3d.spot"],
  ["spp", "application/scvp-vp-response"],
  ["spq", "application/scvp-vp-request"],
  ["spx", "audio/ogg"],
  ["sql", "application/x-sql"],
  ["src", "application/x-wais-source"],
  ["srt", "application/x-subrip"],
  ["sru", "application/sru+xml"],
  ["srx", "application/sparql-results+xml"],
  ["ssdl", "application/ssdl+xml"],
  ["sse", "application/vnd.kodak-descriptor"],
  ["ssf", "application/vnd.epson.ssf"],
  ["ssml", "application/ssml+xml"],
  ["sst", "application/octet-stream"],
  ["st", "application/vnd.sailingtracker.track"],
  ["stc", "application/vnd.sun.xml.calc.template"],
  ["std", "application/vnd.sun.xml.draw.template"],
  ["stf", "application/vnd.wt.stf"],
  ["sti", "application/vnd.sun.xml.impress.template"],
  ["stk", "application/hyperstudio"],
  ["stl", "model/stl"],
  ["stpx", "model/step+xml"],
  ["stpxz", "model/step-xml+zip"],
  ["stpz", "model/step+zip"],
  ["str", "application/vnd.pg.format"],
  ["stw", "application/vnd.sun.xml.writer.template"],
  ["styl", "text/stylus"],
  ["stylus", "text/stylus"],
  ["sub", "text/vnd.dvb.subtitle"],
  ["sus", "application/vnd.sus-calendar"],
  ["susp", "application/vnd.sus-calendar"],
  ["sv4cpio", "application/x-sv4cpio"],
  ["sv4crc", "application/x-sv4crc"],
  ["svc", "application/vnd.dvb.service"],
  ["svd", "application/vnd.svd"],
  ["svg", "image/svg+xml"],
  ["svgz", "image/svg+xml"],
  ["swa", "application/x-director"],
  ["swf", "application/x-shockwave-flash"],
  ["swi", "application/vnd.aristanetworks.swi"],
  ["swidtag", "application/swid+xml"],
  ["sxc", "application/vnd.sun.xml.calc"],
  ["sxd", "application/vnd.sun.xml.draw"],
  ["sxg", "application/vnd.sun.xml.writer.global"],
  ["sxi", "application/vnd.sun.xml.impress"],
  ["sxm", "application/vnd.sun.xml.math"],
  ["sxw", "application/vnd.sun.xml.writer"],
  ["t", "text/troff"],
  ["t3", "application/x-t3vm-image"],
  ["t38", "image/t38"],
  ["taglet", "application/vnd.mynfc"],
  ["tao", "application/vnd.tao.intent-module-archive"],
  ["tap", "image/vnd.tencent.tap"],
  ["tar", "application/x-tar"],
  ["tcap", "application/vnd.3gpp2.tcap"],
  ["tcl", "application/x-tcl"],
  ["td", "application/urc-targetdesc+xml"],
  ["teacher", "application/vnd.smart.teacher"],
  ["tei", "application/tei+xml"],
  ["teicorpus", "application/tei+xml"],
  ["tex", "application/x-tex"],
  ["texi", "application/x-texinfo"],
  ["texinfo", "application/x-texinfo"],
  ["text", "text/plain"],
  ["tfi", "application/thraud+xml"],
  ["tfm", "application/x-tex-tfm"],
  ["tfx", "image/tiff-fx"],
  ["tga", "image/x-tga"],
  ["tgz", "application/x-tar"],
  ["thmx", "application/vnd.ms-officetheme"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["tk", "application/x-tcl"],
  ["tmo", "application/vnd.tmobile-livetv"],
  ["toml", "application/toml"],
  ["torrent", "application/x-bittorrent"],
  ["tpl", "application/vnd.groove-tool-template"],
  ["tpt", "application/vnd.trid.tpt"],
  ["tr", "text/troff"],
  ["tra", "application/vnd.trueapp"],
  ["trig", "application/trig"],
  ["trm", "application/x-msterminal"],
  ["ts", "video/mp2t"],
  ["tsd", "application/timestamped-data"],
  ["tsv", "text/tab-separated-values"],
  ["ttc", "font/collection"],
  ["ttf", "font/ttf"],
  ["ttl", "text/turtle"],
  ["ttml", "application/ttml+xml"],
  ["twd", "application/vnd.simtech-mindmapper"],
  ["twds", "application/vnd.simtech-mindmapper"],
  ["txd", "application/vnd.genomatix.tuxedo"],
  ["txf", "application/vnd.mobius.txf"],
  ["txt", "text/plain"],
  ["u8dsn", "message/global-delivery-status"],
  ["u8hdr", "message/global-headers"],
  ["u8mdn", "message/global-disposition-notification"],
  ["u8msg", "message/global"],
  ["u32", "application/x-authorware-bin"],
  ["ubj", "application/ubjson"],
  ["udeb", "application/x-debian-package"],
  ["ufd", "application/vnd.ufdl"],
  ["ufdl", "application/vnd.ufdl"],
  ["ulx", "application/x-glulx"],
  ["umj", "application/vnd.umajin"],
  ["unityweb", "application/vnd.unity"],
  ["uoml", "application/vnd.uoml+xml"],
  ["uri", "text/uri-list"],
  ["uris", "text/uri-list"],
  ["urls", "text/uri-list"],
  ["usdz", "model/vnd.usdz+zip"],
  ["ustar", "application/x-ustar"],
  ["utz", "application/vnd.uiq.theme"],
  ["uu", "text/x-uuencode"],
  ["uva", "audio/vnd.dece.audio"],
  ["uvd", "application/vnd.dece.data"],
  ["uvf", "application/vnd.dece.data"],
  ["uvg", "image/vnd.dece.graphic"],
  ["uvh", "video/vnd.dece.hd"],
  ["uvi", "image/vnd.dece.graphic"],
  ["uvm", "video/vnd.dece.mobile"],
  ["uvp", "video/vnd.dece.pd"],
  ["uvs", "video/vnd.dece.sd"],
  ["uvt", "application/vnd.dece.ttml+xml"],
  ["uvu", "video/vnd.uvvu.mp4"],
  ["uvv", "video/vnd.dece.video"],
  ["uvva", "audio/vnd.dece.audio"],
  ["uvvd", "application/vnd.dece.data"],
  ["uvvf", "application/vnd.dece.data"],
  ["uvvg", "image/vnd.dece.graphic"],
  ["uvvh", "video/vnd.dece.hd"],
  ["uvvi", "image/vnd.dece.graphic"],
  ["uvvm", "video/vnd.dece.mobile"],
  ["uvvp", "video/vnd.dece.pd"],
  ["uvvs", "video/vnd.dece.sd"],
  ["uvvt", "application/vnd.dece.ttml+xml"],
  ["uvvu", "video/vnd.uvvu.mp4"],
  ["uvvv", "video/vnd.dece.video"],
  ["uvvx", "application/vnd.dece.unspecified"],
  ["uvvz", "application/vnd.dece.zip"],
  ["uvx", "application/vnd.dece.unspecified"],
  ["uvz", "application/vnd.dece.zip"],
  ["vbox", "application/x-virtualbox-vbox"],
  ["vbox-extpack", "application/x-virtualbox-vbox-extpack"],
  ["vcard", "text/vcard"],
  ["vcd", "application/x-cdlink"],
  ["vcf", "text/x-vcard"],
  ["vcg", "application/vnd.groove-vcard"],
  ["vcs", "text/x-vcalendar"],
  ["vcx", "application/vnd.vcx"],
  ["vdi", "application/x-virtualbox-vdi"],
  ["vds", "model/vnd.sap.vds"],
  ["vhd", "application/x-virtualbox-vhd"],
  ["vis", "application/vnd.visionary"],
  ["viv", "video/vnd.vivo"],
  ["vlc", "application/videolan"],
  ["vmdk", "application/x-virtualbox-vmdk"],
  ["vob", "video/x-ms-vob"],
  ["vor", "application/vnd.stardivision.writer"],
  ["vox", "application/x-authorware-bin"],
  ["vrml", "model/vrml"],
  ["vsd", "application/vnd.visio"],
  ["vsf", "application/vnd.vsf"],
  ["vss", "application/vnd.visio"],
  ["vst", "application/vnd.visio"],
  ["vsw", "application/vnd.visio"],
  ["vtf", "image/vnd.valve.source.texture"],
  ["vtt", "text/vtt"],
  ["vtu", "model/vnd.vtu"],
  ["vxml", "application/voicexml+xml"],
  ["w3d", "application/x-director"],
  ["wad", "application/x-doom"],
  ["wadl", "application/vnd.sun.wadl+xml"],
  ["war", "application/java-archive"],
  ["wasm", "application/wasm"],
  ["wav", "audio/x-wav"],
  ["wax", "audio/x-ms-wax"],
  ["wbmp", "image/vnd.wap.wbmp"],
  ["wbs", "application/vnd.criticaltools.wbs+xml"],
  ["wbxml", "application/wbxml"],
  ["wcm", "application/vnd.ms-works"],
  ["wdb", "application/vnd.ms-works"],
  ["wdp", "image/vnd.ms-photo"],
  ["weba", "audio/webm"],
  ["webapp", "application/x-web-app-manifest+json"],
  ["webm", "video/webm"],
  ["webmanifest", "application/manifest+json"],
  ["webp", "image/webp"],
  ["wg", "application/vnd.pmi.widget"],
  ["wgt", "application/widget"],
  ["wks", "application/vnd.ms-works"],
  ["wm", "video/x-ms-wm"],
  ["wma", "audio/x-ms-wma"],
  ["wmd", "application/x-ms-wmd"],
  ["wmf", "image/wmf"],
  ["wml", "text/vnd.wap.wml"],
  ["wmlc", "application/wmlc"],
  ["wmls", "text/vnd.wap.wmlscript"],
  ["wmlsc", "application/vnd.wap.wmlscriptc"],
  ["wmv", "video/x-ms-wmv"],
  ["wmx", "video/x-ms-wmx"],
  ["wmz", "application/x-msmetafile"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["word", "application/msword"],
  ["wpd", "application/vnd.wordperfect"],
  ["wpl", "application/vnd.ms-wpl"],
  ["wps", "application/vnd.ms-works"],
  ["wqd", "application/vnd.wqd"],
  ["wri", "application/x-mswrite"],
  ["wrl", "model/vrml"],
  ["wsc", "message/vnd.wfa.wsc"],
  ["wsdl", "application/wsdl+xml"],
  ["wspolicy", "application/wspolicy+xml"],
  ["wtb", "application/vnd.webturbo"],
  ["wvx", "video/x-ms-wvx"],
  ["x3d", "model/x3d+xml"],
  ["x3db", "model/x3d+fastinfoset"],
  ["x3dbz", "model/x3d+binary"],
  ["x3dv", "model/x3d-vrml"],
  ["x3dvz", "model/x3d+vrml"],
  ["x3dz", "model/x3d+xml"],
  ["x32", "application/x-authorware-bin"],
  ["x_b", "model/vnd.parasolid.transmit.binary"],
  ["x_t", "model/vnd.parasolid.transmit.text"],
  ["xaml", "application/xaml+xml"],
  ["xap", "application/x-silverlight-app"],
  ["xar", "application/vnd.xara"],
  ["xav", "application/xcap-att+xml"],
  ["xbap", "application/x-ms-xbap"],
  ["xbd", "application/vnd.fujixerox.docuworks.binder"],
  ["xbm", "image/x-xbitmap"],
  ["xca", "application/xcap-caps+xml"],
  ["xcs", "application/calendar+xml"],
  ["xdf", "application/xcap-diff+xml"],
  ["xdm", "application/vnd.syncml.dm+xml"],
  ["xdp", "application/vnd.adobe.xdp+xml"],
  ["xdssc", "application/dssc+xml"],
  ["xdw", "application/vnd.fujixerox.docuworks"],
  ["xel", "application/xcap-el+xml"],
  ["xenc", "application/xenc+xml"],
  ["xer", "application/patch-ops-error+xml"],
  ["xfdf", "application/vnd.adobe.xfdf"],
  ["xfdl", "application/vnd.xfdl"],
  ["xht", "application/xhtml+xml"],
  ["xhtml", "application/xhtml+xml"],
  ["xhvml", "application/xv+xml"],
  ["xif", "image/vnd.xiff"],
  ["xl", "application/excel"],
  ["xla", "application/vnd.ms-excel"],
  ["xlam", "application/vnd.ms-excel.addin.macroEnabled.12"],
  ["xlc", "application/vnd.ms-excel"],
  ["xlf", "application/xliff+xml"],
  ["xlm", "application/vnd.ms-excel"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsb", "application/vnd.ms-excel.sheet.binary.macroEnabled.12"],
  ["xlsm", "application/vnd.ms-excel.sheet.macroEnabled.12"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xlt", "application/vnd.ms-excel"],
  ["xltm", "application/vnd.ms-excel.template.macroEnabled.12"],
  ["xltx", "application/vnd.openxmlformats-officedocument.spreadsheetml.template"],
  ["xlw", "application/vnd.ms-excel"],
  ["xm", "audio/xm"],
  ["xml", "application/xml"],
  ["xns", "application/xcap-ns+xml"],
  ["xo", "application/vnd.olpc-sugar"],
  ["xop", "application/xop+xml"],
  ["xpi", "application/x-xpinstall"],
  ["xpl", "application/xproc+xml"],
  ["xpm", "image/x-xpixmap"],
  ["xpr", "application/vnd.is-xpr"],
  ["xps", "application/vnd.ms-xpsdocument"],
  ["xpw", "application/vnd.intercon.formnet"],
  ["xpx", "application/vnd.intercon.formnet"],
  ["xsd", "application/xml"],
  ["xsl", "application/xml"],
  ["xslt", "application/xslt+xml"],
  ["xsm", "application/vnd.syncml+xml"],
  ["xspf", "application/xspf+xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["xvm", "application/xv+xml"],
  ["xvml", "application/xv+xml"],
  ["xwd", "image/x-xwindowdump"],
  ["xyz", "chemical/x-xyz"],
  ["xz", "application/x-xz"],
  ["yaml", "text/yaml"],
  ["yang", "application/yang"],
  ["yin", "application/yin+xml"],
  ["yml", "text/yaml"],
  ["ymp", "text/x-suse-ymp"],
  ["z", "application/x-compress"],
  ["z1", "application/x-zmachine"],
  ["z2", "application/x-zmachine"],
  ["z3", "application/x-zmachine"],
  ["z4", "application/x-zmachine"],
  ["z5", "application/x-zmachine"],
  ["z6", "application/x-zmachine"],
  ["z7", "application/x-zmachine"],
  ["z8", "application/x-zmachine"],
  ["zaz", "application/vnd.zzazz.deck+xml"],
  ["zip", "application/zip"],
  ["zir", "application/vnd.zul"],
  ["zirz", "application/vnd.zul"],
  ["zmm", "application/vnd.handheld-entertainment+xml"],
  ["zsh", "text/x-scriptzsh"]
]);
function pW(e, t, i) {
  const n = IOe(e), { webkitRelativePath: s } = e, o = typeof t == "string" ? t : typeof s == "string" && s.length > 0 ? s : `./${e.name}`;
  return typeof n.path != "string" && eye(n, "path", o), eye(n, "relativePath", o), n;
}
function IOe(e) {
  const { name: t } = e;
  if (t && t.lastIndexOf(".") !== -1 && !e.type) {
    const n = t.split(".").pop().toLowerCase(), s = fOe.get(n);
    s && Object.defineProperty(e, "type", {
      value: s,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return e;
}
function eye(e, t, i) {
  Object.defineProperty(e, t, {
    value: i,
    writable: !1,
    configurable: !1,
    enumerable: !0
  });
}
const pOe = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  // macOs
  "Thumbs.db"
  // Windows
];
function mOe(e) {
  return DH(this, void 0, void 0, function* () {
    return kre(e) && yOe(e.dataTransfer) ? TOe(e.dataTransfer, e.type) : EOe(e) ? gOe(e) : Array.isArray(e) && e.every((t) => "getFile" in t && typeof t.getFile == "function") ? wOe(e) : [];
  });
}
function yOe(e) {
  return kre(e);
}
function EOe(e) {
  return kre(e) && kre(e.target);
}
function kre(e) {
  return typeof e == "object" && e !== null;
}
function gOe(e) {
  return E0e(e.target.files).map((t) => pW(t));
}
function wOe(e) {
  return DH(this, void 0, void 0, function* () {
    return (yield Promise.all(e.map((i) => i.getFile()))).map((i) => pW(i));
  });
}
function TOe(e, t) {
  return DH(this, void 0, void 0, function* () {
    if (e.items) {
      const i = E0e(e.items).filter((s) => s.kind === "file");
      if (t !== "drop")
        return i;
      const n = yield Promise.all(i.map(ROe));
      return tye(yTe(n));
    }
    return tye(E0e(e.files).map((i) => pW(i)));
  });
}
function tye(e) {
  return e.filter((t) => pOe.indexOf(t.name) === -1);
}
function E0e(e) {
  if (e === null)
    return [];
  const t = [];
  for (let i = 0; i < e.length; i++) {
    const n = e[i];
    t.push(n);
  }
  return t;
}
function ROe(e) {
  if (typeof e.webkitGetAsEntry != "function")
    return iye(e);
  const t = e.webkitGetAsEntry();
  return t && t.isDirectory ? ETe(t) : iye(e, t);
}
function yTe(e) {
  return e.reduce((t, i) => [
    ...t,
    ...Array.isArray(i) ? yTe(i) : [i]
  ], []);
}
function iye(e, t) {
  return DH(this, void 0, void 0, function* () {
    var i;
    if (globalThis.isSecureContext && typeof e.getAsFileSystemHandle == "function") {
      const o = yield e.getAsFileSystemHandle();
      if (o === null)
        throw new Error(`${e} is not a File`);
      if (o !== void 0) {
        const r = yield o.getFile();
        return r.handle = o, pW(r);
      }
    }
    const n = e.getAsFile();
    if (!n)
      throw new Error(`${e} is not a File`);
    return pW(n, (i = t == null ? void 0 : t.fullPath) !== null && i !== void 0 ? i : void 0);
  });
}
function vOe(e) {
  return DH(this, void 0, void 0, function* () {
    return e.isDirectory ? ETe(e) : AOe(e);
  });
}
function ETe(e) {
  const t = e.createReader();
  return new Promise((i, n) => {
    const s = [];
    function o() {
      t.readEntries((r) => DH(this, void 0, void 0, function* () {
        if (r.length) {
          const l = Promise.all(r.map(vOe));
          s.push(l), o();
        } else
          try {
            const l = yield Promise.all(s);
            i(l);
          } catch (l) {
            n(l);
          }
      }), (r) => {
        n(r);
      });
    }
    o();
  });
}
function AOe(e) {
  return DH(this, void 0, void 0, function* () {
    return new Promise((t, i) => {
      e.file((n) => {
        const s = pW(n, e.fullPath);
        t(s);
      }, (n) => {
        i(n);
      });
    });
  });
}
var ane = {}, nye;
function SOe() {
  return nye || (nye = 1, ane.__esModule = !0, ane.default = function(e, t) {
    if (e && t) {
      var i = Array.isArray(t) ? t : t.split(",");
      if (i.length === 0)
        return !0;
      var n = e.name || "", s = (e.type || "").toLowerCase(), o = s.replace(/\/.*$/, "");
      return i.some(function(r) {
        var l = r.trim().toLowerCase();
        return l.charAt(0) === "." ? n.toLowerCase().endsWith(l) : l.endsWith("/*") ? o === l.replace(/\/.*$/, "") : s === l;
      });
    }
    return !0;
  }), ane;
}
var bOe = SOe();
const Jue = /* @__PURE__ */ rie(bOe);
function sye(e) {
  return COe(e) || DOe(e) || wTe(e) || NOe();
}
function NOe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function DOe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function COe(e) {
  if (Array.isArray(e)) return g0e(e);
}
function oye(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function rye(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? oye(Object(i), !0).forEach(function(n) {
      gTe(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : oye(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
function gTe(e, t, i) {
  return t in e ? Object.defineProperty(e, t, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = i, e;
}
function tX(e, t) {
  return _Oe(e) || LOe(e, t) || wTe(e, t) || OOe();
}
function OOe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function wTe(e, t) {
  if (e) {
    if (typeof e == "string") return g0e(e, t);
    var i = Object.prototype.toString.call(e).slice(8, -1);
    if (i === "Object" && e.constructor && (i = e.constructor.name), i === "Map" || i === "Set") return Array.from(e);
    if (i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)) return g0e(e, t);
  }
}
function g0e(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var i = 0, n = new Array(t); i < t; i++)
    n[i] = e[i];
  return n;
}
function LOe(e, t) {
  var i = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (i != null) {
    var n = [], s = !0, o = !1, r, l;
    try {
      for (i = i.call(e); !(s = (r = i.next()).done) && (n.push(r.value), !(t && n.length === t)); s = !0)
        ;
    } catch (c) {
      o = !0, l = c;
    } finally {
      try {
        !s && i.return != null && i.return();
      } finally {
        if (o) throw l;
      }
    }
    return n;
  }
}
function _Oe(e) {
  if (Array.isArray(e)) return e;
}
var xOe = typeof Jue == "function" ? Jue : Jue.default, POe = "file-invalid-type", MOe = "file-too-large", UOe = "file-too-small", BOe = "too-many-files", FOe = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", i = t.split(","), n = i.length > 1 ? "one of ".concat(i.join(", ")) : i[0];
  return {
    code: POe,
    message: "File type must be ".concat(n)
  };
}, lye = function(t) {
  return {
    code: MOe,
    message: "File is larger than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, aye = function(t) {
  return {
    code: UOe,
    message: "File is smaller than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, HOe = {
  code: BOe,
  message: "Too many files"
};
function TTe(e, t) {
  var i = e.type === "application/x-moz-file" || xOe(e, t);
  return [i, i ? null : FOe(t)];
}
function RTe(e, t, i) {
  if (WU(e.size))
    if (WU(t) && WU(i)) {
      if (e.size > i) return [!1, lye(i)];
      if (e.size < t) return [!1, aye(t)];
    } else {
      if (WU(t) && e.size < t) return [!1, aye(t)];
      if (WU(i) && e.size > i) return [!1, lye(i)];
    }
  return [!0, null];
}
function WU(e) {
  return e != null;
}
function GOe(e) {
  var t = e.files, i = e.accept, n = e.minSize, s = e.maxSize, o = e.multiple, r = e.maxFiles, l = e.validator;
  return !o && t.length > 1 || o && r >= 1 && t.length > r ? !1 : t.every(function(c) {
    var h = TTe(c, i), I = tX(h, 1), p = I[0], y = RTe(c, n, s), m = tX(y, 1), A = m[0], C = l ? l(c) : null;
    return p && A && !C;
  });
}
function Vre(e) {
  return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : typeof e.cancelBubble < "u" ? e.cancelBubble : !1;
}
function une(e) {
  return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function(t) {
    return t === "Files" || t === "application/x-moz-file";
  }) : !!e.target && !!e.target.files;
}
function uye(e) {
  e.preventDefault();
}
function kOe(e) {
  return e.indexOf("MSIE") !== -1 || e.indexOf("Trident/") !== -1;
}
function VOe(e) {
  return e.indexOf("Edge/") !== -1;
}
function zOe() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return kOe(e) || VOe(e);
}
function sb() {
  for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
    t[i] = arguments[i];
  return function(n) {
    for (var s = arguments.length, o = new Array(s > 1 ? s - 1 : 0), r = 1; r < s; r++)
      o[r - 1] = arguments[r];
    return t.some(function(l) {
      return !Vre(n) && l && l.apply(void 0, [n].concat(o)), Vre(n);
    });
  };
}
function jOe() {
  return "showOpenFilePicker" in window;
}
function WOe(e) {
  if (WU(e)) {
    var t = Object.entries(e).filter(function(i) {
      var n = tX(i, 2), s = n[0], o = n[1], r = !0;
      return vTe(s) || (console.warn('Skipped "'.concat(s, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.')), r = !1), (!Array.isArray(o) || !o.every(ATe)) && (console.warn('Skipped "'.concat(s, '" because an invalid file extension was provided.')), r = !1), r;
    }).reduce(function(i, n) {
      var s = tX(n, 2), o = s[0], r = s[1];
      return rye(rye({}, i), {}, gTe({}, o, r));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: t
    }];
  }
  return e;
}
function YOe(e) {
  if (WU(e))
    return Object.entries(e).reduce(function(t, i) {
      var n = tX(i, 2), s = n[0], o = n[1];
      return [].concat(sye(t), [s], sye(o));
    }, []).filter(function(t) {
      return vTe(t) || ATe(t);
    }).join(",");
}
function qOe(e) {
  return e instanceof DOMException && (e.name === "AbortError" || e.code === e.ABORT_ERR);
}
function $Oe(e) {
  return e instanceof DOMException && (e.name === "SecurityError" || e.code === e.SECURITY_ERR);
}
function vTe(e) {
  return e === "audio/*" || e === "video/*" || e === "image/*" || e === "text/*" || e === "application/*" || /\w+\/[-+.\w]+/g.test(e);
}
function ATe(e) {
  return /^.*\.[\w]+$/.test(e);
}
var KOe = ["children"], ZOe = ["open"], QOe = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], JOe = ["refKey", "onChange", "onClick"];
function XOe(e) {
  return iLe(e) || tLe(e) || STe(e) || eLe();
}
function eLe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function tLe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function iLe(e) {
  if (Array.isArray(e)) return w0e(e);
}
function Xue(e, t) {
  return oLe(e) || sLe(e, t) || STe(e, t) || nLe();
}
function nLe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function STe(e, t) {
  if (e) {
    if (typeof e == "string") return w0e(e, t);
    var i = Object.prototype.toString.call(e).slice(8, -1);
    if (i === "Object" && e.constructor && (i = e.constructor.name), i === "Map" || i === "Set") return Array.from(e);
    if (i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)) return w0e(e, t);
  }
}
function w0e(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var i = 0, n = new Array(t); i < t; i++)
    n[i] = e[i];
  return n;
}
function sLe(e, t) {
  var i = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (i != null) {
    var n = [], s = !0, o = !1, r, l;
    try {
      for (i = i.call(e); !(s = (r = i.next()).done) && (n.push(r.value), !(t && n.length === t)); s = !0)
        ;
    } catch (c) {
      o = !0, l = c;
    } finally {
      try {
        !s && i.return != null && i.return();
      } finally {
        if (o) throw l;
      }
    }
    return n;
  }
}
function oLe(e) {
  if (Array.isArray(e)) return e;
}
function dye(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function ld(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? dye(Object(i), !0).forEach(function(n) {
      T0e(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : dye(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
function T0e(e, t, i) {
  return t in e ? Object.defineProperty(e, t, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = i, e;
}
function zre(e, t) {
  if (e == null) return {};
  var i = rLe(e, t), n, s;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (s = 0; s < o.length; s++)
      n = o[s], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
  }
  return i;
}
function rLe(e, t) {
  if (e == null) return {};
  var i = {}, n = Object.keys(e), s, o;
  for (o = 0; o < n.length; o++)
    s = n[o], !(t.indexOf(s) >= 0) && (i[s] = e[s]);
  return i;
}
var Epe = /* @__PURE__ */ cE(function(e, t) {
  var i = e.children, n = zre(e, KOe), s = v0e(n), o = s.open, r = zre(s, ZOe);
  return tDe(t, function() {
    return {
      open: o
    };
  }, [o]), /* @__PURE__ */ Ms.createElement(Q4e, null, i(ld(ld({}, r), {}, {
    open: o
  })));
});
Epe.displayName = "Dropzone";
var bTe = {
  disabled: !1,
  getFilesFromEvent: mOe,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !1,
  autoFocus: !1
};
Epe.defaultProps = bTe;
Epe.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: Bl.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: Bl.objectOf(Bl.arrayOf(Bl.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: Bl.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: Bl.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: Bl.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: Bl.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: Bl.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: Bl.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: Bl.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: Bl.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: Bl.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: Bl.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event|Array<FileSystemFileHandle>)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: Bl.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: Bl.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: Bl.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: Bl.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: Bl.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: Bl.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: Bl.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: Bl.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: Bl.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: Bl.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: Bl.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: Bl.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: Bl.func
};
var R0e = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  acceptedFiles: [],
  fileRejections: []
};
function v0e() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = ld(ld({}, bTe), e), i = t.accept, n = t.disabled, s = t.getFilesFromEvent, o = t.maxSize, r = t.minSize, l = t.multiple, c = t.maxFiles, h = t.onDragEnter, I = t.onDragLeave, p = t.onDragOver, y = t.onDrop, m = t.onDropAccepted, A = t.onDropRejected, C = t.onFileDialogCancel, O = t.onFileDialogOpen, R = t.useFsAccessApi, F = t.autoFocus, L = t.preventDropOnDocument, P = t.noClick, z = t.noKeyboard, W = t.noDrag, re = t.noDragEventsBubbling, ce = t.onError, te = t.validator, ee = Vu(function() {
    return YOe(i);
  }, [i]), Ne = Vu(function() {
    return WOe(i);
  }, [i]), Ae = Vu(function() {
    return typeof O == "function" ? O : cye;
  }, [O]), Oe = Vu(function() {
    return typeof C == "function" ? C : cye;
  }, [C]), pe = io(null), je = io(null), Ve = eDe(lLe, R0e), $e = Xue(Ve, 2), vt = $e[0], Rt = $e[1], ze = vt.isFocused, mt = vt.isFileDialogActive, Et = io(typeof window < "u" && window.isSecureContext && R && jOe()), it = function() {
    !Et.current && mt && setTimeout(function() {
      if (je.current) {
        var gt = je.current.files;
        gt.length || (Rt({
          type: "closeDialog"
        }), Oe());
      }
    }, 300);
  };
  vr(function() {
    return window.addEventListener("focus", it, !1), function() {
      window.removeEventListener("focus", it, !1);
    };
  }, [je, mt, Oe, Et]);
  var Dt = io([]), Ct = function(gt) {
    pe.current && pe.current.contains(gt.target) || (gt.preventDefault(), Dt.current = []);
  };
  vr(function() {
    return L && (document.addEventListener("dragover", uye, !1), document.addEventListener("drop", Ct, !1)), function() {
      L && (document.removeEventListener("dragover", uye), document.removeEventListener("drop", Ct));
    };
  }, [pe, L]), vr(function() {
    return !n && F && pe.current && pe.current.focus(), function() {
    };
  }, [pe, F, n]);
  var Kt = On(function(Me) {
    ce ? ce(Me) : console.error(Me);
  }, [ce]), Zt = On(function(Me) {
    Me.preventDefault(), Me.persist(), jt(Me), Dt.current = [].concat(XOe(Dt.current), [Me.target]), une(Me) && Promise.resolve(s(Me)).then(function(gt) {
      if (!(Vre(Me) && !re)) {
        var yt = gt.length, Ut = yt > 0 && GOe({
          files: gt,
          accept: ee,
          minSize: r,
          maxSize: o,
          multiple: l,
          maxFiles: c,
          validator: te
        }), Ht = yt > 0 && !Ut;
        Rt({
          isDragAccept: Ut,
          isDragReject: Ht,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), h && h(Me);
      }
    }).catch(function(gt) {
      return Kt(gt);
    });
  }, [s, h, Kt, re, ee, r, o, l, c, te]), Xt = On(function(Me) {
    Me.preventDefault(), Me.persist(), jt(Me);
    var gt = une(Me);
    if (gt && Me.dataTransfer)
      try {
        Me.dataTransfer.dropEffect = "copy";
      } catch {
      }
    return gt && p && p(Me), !1;
  }, [p, re]), gi = On(function(Me) {
    Me.preventDefault(), Me.persist(), jt(Me);
    var gt = Dt.current.filter(function(Ut) {
      return pe.current && pe.current.contains(Ut);
    }), yt = gt.indexOf(Me.target);
    yt !== -1 && gt.splice(yt, 1), Dt.current = gt, !(gt.length > 0) && (Rt({
      type: "setDraggedFiles",
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1
    }), une(Me) && I && I(Me));
  }, [pe, I, re]), Wt = On(function(Me, gt) {
    var yt = [], Ut = [];
    Me.forEach(function(Ht) {
      var wi = TTe(Ht, ee), bi = Xue(wi, 2), Hi = bi[0], Wi = bi[1], hi = RTe(Ht, r, o), Ji = Xue(hi, 2), Sn = Ji[0], nn = Ji[1], Yi = te ? te(Ht) : null;
      if (Hi && Sn && !Yi)
        yt.push(Ht);
      else {
        var Pi = [Wi, nn];
        Yi && (Pi = Pi.concat(Yi)), Ut.push({
          file: Ht,
          errors: Pi.filter(function(kt) {
            return kt;
          })
        });
      }
    }), (!l && yt.length > 1 || l && c >= 1 && yt.length > c) && (yt.forEach(function(Ht) {
      Ut.push({
        file: Ht,
        errors: [HOe]
      });
    }), yt.splice(0)), Rt({
      acceptedFiles: yt,
      fileRejections: Ut,
      isDragReject: Ut.length > 0,
      type: "setFiles"
    }), y && y(yt, Ut, gt), Ut.length > 0 && A && A(Ut, gt), yt.length > 0 && m && m(yt, gt);
  }, [Rt, l, ee, r, o, c, y, m, A, te]), Di = On(function(Me) {
    Me.preventDefault(), Me.persist(), jt(Me), Dt.current = [], une(Me) && Promise.resolve(s(Me)).then(function(gt) {
      Vre(Me) && !re || Wt(gt, Me);
    }).catch(function(gt) {
      return Kt(gt);
    }), Rt({
      type: "reset"
    });
  }, [s, Wt, Kt, re]), ni = On(function() {
    if (Et.current) {
      Rt({
        type: "openDialog"
      }), Ae();
      var Me = {
        multiple: l,
        types: Ne
      };
      window.showOpenFilePicker(Me).then(function(gt) {
        return s(gt);
      }).then(function(gt) {
        Wt(gt, null), Rt({
          type: "closeDialog"
        });
      }).catch(function(gt) {
        qOe(gt) ? (Oe(gt), Rt({
          type: "closeDialog"
        })) : $Oe(gt) ? (Et.current = !1, je.current ? (je.current.value = null, je.current.click()) : Kt(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : Kt(gt);
      });
      return;
    }
    je.current && (Rt({
      type: "openDialog"
    }), Ae(), je.current.value = null, je.current.click());
  }, [Rt, Ae, Oe, R, Wt, Kt, Ne, l]), Ci = On(function(Me) {
    !pe.current || !pe.current.isEqualNode(Me.target) || (Me.key === " " || Me.key === "Enter" || Me.keyCode === 32 || Me.keyCode === 13) && (Me.preventDefault(), ni());
  }, [pe, ni]), Se = On(function() {
    Rt({
      type: "focus"
    });
  }, []), si = On(function() {
    Rt({
      type: "blur"
    });
  }, []), Mt = On(function() {
    P || (zOe() ? setTimeout(ni, 0) : ni());
  }, [P, ni]), ft = function(gt) {
    return n ? null : gt;
  }, rt = function(gt) {
    return z ? null : ft(gt);
  }, Tt = function(gt) {
    return W ? null : ft(gt);
  }, jt = function(gt) {
    re && gt.stopPropagation();
  }, Jt = Vu(function() {
    return function() {
      var Me = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, gt = Me.refKey, yt = gt === void 0 ? "ref" : gt, Ut = Me.role, Ht = Me.onKeyDown, wi = Me.onFocus, bi = Me.onBlur, Hi = Me.onClick, Wi = Me.onDragEnter, hi = Me.onDragOver, Ji = Me.onDragLeave, Sn = Me.onDrop, nn = zre(Me, QOe);
      return ld(ld(T0e({
        onKeyDown: rt(sb(Ht, Ci)),
        onFocus: rt(sb(wi, Se)),
        onBlur: rt(sb(bi, si)),
        onClick: ft(sb(Hi, Mt)),
        onDragEnter: Tt(sb(Wi, Zt)),
        onDragOver: Tt(sb(hi, Xt)),
        onDragLeave: Tt(sb(Ji, gi)),
        onDrop: Tt(sb(Sn, Di)),
        role: typeof Ut == "string" && Ut !== "" ? Ut : "presentation"
      }, yt, pe), !n && !z ? {
        tabIndex: 0
      } : {}), nn);
    };
  }, [pe, Ci, Se, si, Mt, Zt, Xt, gi, Di, z, W, n]), $t = On(function(Me) {
    Me.stopPropagation();
  }, []), ht = Vu(function() {
    return function() {
      var Me = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, gt = Me.refKey, yt = gt === void 0 ? "ref" : gt, Ut = Me.onChange, Ht = Me.onClick, wi = zre(Me, JOe), bi = T0e({
        accept: ee,
        multiple: l,
        type: "file",
        style: {
          border: 0,
          clip: "rect(0, 0, 0, 0)",
          clipPath: "inset(50%)",
          height: "1px",
          margin: "0 -1px -1px 0",
          overflow: "hidden",
          padding: 0,
          position: "absolute",
          width: "1px",
          whiteSpace: "nowrap"
        },
        onChange: ft(sb(Ut, Di)),
        onClick: ft(sb(Ht, $t)),
        tabIndex: -1
      }, yt, je);
      return ld(ld({}, bi), wi);
    };
  }, [je, i, l, Di, n]);
  return ld(ld({}, vt), {}, {
    isFocused: ze && !n,
    getRootProps: Jt,
    getInputProps: ht,
    rootRef: pe,
    inputRef: je,
    open: ft(ni)
  });
}
function lLe(e, t) {
  switch (t.type) {
    case "focus":
      return ld(ld({}, e), {}, {
        isFocused: !0
      });
    case "blur":
      return ld(ld({}, e), {}, {
        isFocused: !1
      });
    case "openDialog":
      return ld(ld({}, R0e), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return ld(ld({}, e), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return ld(ld({}, e), {}, {
        isDragActive: t.isDragActive,
        isDragAccept: t.isDragAccept,
        isDragReject: t.isDragReject
      });
    case "setFiles":
      return ld(ld({}, e), {}, {
        acceptedFiles: t.acceptedFiles,
        fileRejections: t.fileRejections,
        isDragReject: t.isDragReject
      });
    case "reset":
      return ld({}, R0e);
    default:
      return e;
  }
}
function cye() {
}
function aLe(e) {
  return Sd({ attr: { fill: "none", viewBox: "0 0 24 24", strokeWidth: "2", stroke: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { strokeLinecap: "round", strokeLinejoin: "round", d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" }, child: [] }] })(e);
}
function uLe(e) {
  if (typeof document > "u") return;
  let t = document.head || document.getElementsByTagName("head")[0], i = document.createElement("style");
  i.type = "text/css", t.firstChild ? t.insertBefore(i, t.firstChild) : t.appendChild(i), i.styleSheet ? i.styleSheet.cssText = e : i.appendChild(document.createTextNode(e));
}
uLe(`:root{--toastify-color-light: #fff;--toastify-color-dark: #121212;--toastify-color-info: #3498db;--toastify-color-success: #07bc0c;--toastify-color-warning: #f1c40f;--toastify-color-error: hsl(6, 78%, 57%);--toastify-color-transparent: rgba(255, 255, 255, .7);--toastify-icon-color-info: var(--toastify-color-info);--toastify-icon-color-success: var(--toastify-color-success);--toastify-icon-color-warning: var(--toastify-color-warning);--toastify-icon-color-error: var(--toastify-color-error);--toastify-container-width: fit-content;--toastify-toast-width: 320px;--toastify-toast-offset: 16px;--toastify-toast-top: max(var(--toastify-toast-offset), env(safe-area-inset-top));--toastify-toast-right: max(var(--toastify-toast-offset), env(safe-area-inset-right));--toastify-toast-left: max(var(--toastify-toast-offset), env(safe-area-inset-left));--toastify-toast-bottom: max(var(--toastify-toast-offset), env(safe-area-inset-bottom));--toastify-toast-background: #fff;--toastify-toast-padding: 14px;--toastify-toast-min-height: 64px;--toastify-toast-max-height: 800px;--toastify-toast-bd-radius: 6px;--toastify-toast-shadow: 0px 4px 12px rgba(0, 0, 0, .1);--toastify-font-family: sans-serif;--toastify-z-index: 9999;--toastify-text-color-light: #757575;--toastify-text-color-dark: #fff;--toastify-text-color-info: #fff;--toastify-text-color-success: #fff;--toastify-text-color-warning: #fff;--toastify-text-color-error: #fff;--toastify-spinner-color: #616161;--toastify-spinner-color-empty-area: #e0e0e0;--toastify-color-progress-light: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);--toastify-color-progress-dark: #bb86fc;--toastify-color-progress-info: var(--toastify-color-info);--toastify-color-progress-success: var(--toastify-color-success);--toastify-color-progress-warning: var(--toastify-color-warning);--toastify-color-progress-error: var(--toastify-color-error);--toastify-color-progress-bgo: .2}.Toastify__toast-container{z-index:var(--toastify-z-index);-webkit-transform:translate3d(0,0,var(--toastify-z-index));position:fixed;width:var(--toastify-container-width);box-sizing:border-box;color:#fff;display:flex;flex-direction:column}.Toastify__toast-container--top-left{top:var(--toastify-toast-top);left:var(--toastify-toast-left)}.Toastify__toast-container--top-center{top:var(--toastify-toast-top);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--top-right{top:var(--toastify-toast-top);right:var(--toastify-toast-right);align-items:end}.Toastify__toast-container--bottom-left{bottom:var(--toastify-toast-bottom);left:var(--toastify-toast-left)}.Toastify__toast-container--bottom-center{bottom:var(--toastify-toast-bottom);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--bottom-right{bottom:var(--toastify-toast-bottom);right:var(--toastify-toast-right);align-items:end}.Toastify__toast{--y: 0;position:relative;touch-action:none;width:var(--toastify-toast-width);min-height:var(--toastify-toast-min-height);box-sizing:border-box;margin-bottom:1rem;padding:var(--toastify-toast-padding);border-radius:var(--toastify-toast-bd-radius);box-shadow:var(--toastify-toast-shadow);max-height:var(--toastify-toast-max-height);font-family:var(--toastify-font-family);z-index:0;display:flex;flex:1 auto;align-items:center;word-break:break-word}@media only screen and (max-width: 480px){.Toastify__toast-container{width:100vw;left:env(safe-area-inset-left);margin:0}.Toastify__toast-container--top-left,.Toastify__toast-container--top-center,.Toastify__toast-container--top-right{top:env(safe-area-inset-top);transform:translate(0)}.Toastify__toast-container--bottom-left,.Toastify__toast-container--bottom-center,.Toastify__toast-container--bottom-right{bottom:env(safe-area-inset-bottom);transform:translate(0)}.Toastify__toast-container--rtl{right:env(safe-area-inset-right);left:initial}.Toastify__toast{--toastify-toast-width: 100%;margin-bottom:0;border-radius:0}}.Toastify__toast-container[data-stacked=true]{width:var(--toastify-toast-width)}.Toastify__toast--stacked{position:absolute;width:100%;transform:translate3d(0,var(--y),0) scale(var(--s));transition:transform .3s}.Toastify__toast--stacked[data-collapsed] .Toastify__toast-body,.Toastify__toast--stacked[data-collapsed] .Toastify__close-button{transition:opacity .1s}.Toastify__toast--stacked[data-collapsed=false]{overflow:visible}.Toastify__toast--stacked[data-collapsed=true]:not(:last-child)>*{opacity:0}.Toastify__toast--stacked:after{content:"";position:absolute;left:0;right:0;height:calc(var(--g) * 1px);bottom:100%}.Toastify__toast--stacked[data-pos=top]{top:0}.Toastify__toast--stacked[data-pos=bot]{bottom:0}.Toastify__toast--stacked[data-pos=bot].Toastify__toast--stacked:before{transform-origin:top}.Toastify__toast--stacked[data-pos=top].Toastify__toast--stacked:before{transform-origin:bottom}.Toastify__toast--stacked:before{content:"";position:absolute;left:0;right:0;bottom:0;height:100%;transform:scaleY(3);z-index:-1}.Toastify__toast--rtl{direction:rtl}.Toastify__toast--close-on-click{cursor:pointer}.Toastify__toast-icon{margin-inline-end:10px;width:22px;flex-shrink:0;display:flex}.Toastify--animate{animation-fill-mode:both;animation-duration:.5s}.Toastify--animate-icon{animation-fill-mode:both;animation-duration:.3s}.Toastify__toast-theme--dark{background:var(--toastify-color-dark);color:var(--toastify-text-color-dark)}.Toastify__toast-theme--light,.Toastify__toast-theme--colored.Toastify__toast--default{background:var(--toastify-color-light);color:var(--toastify-text-color-light)}.Toastify__toast-theme--colored.Toastify__toast--info{color:var(--toastify-text-color-info);background:var(--toastify-color-info)}.Toastify__toast-theme--colored.Toastify__toast--success{color:var(--toastify-text-color-success);background:var(--toastify-color-success)}.Toastify__toast-theme--colored.Toastify__toast--warning{color:var(--toastify-text-color-warning);background:var(--toastify-color-warning)}.Toastify__toast-theme--colored.Toastify__toast--error{color:var(--toastify-text-color-error);background:var(--toastify-color-error)}.Toastify__progress-bar-theme--light{background:var(--toastify-color-progress-light)}.Toastify__progress-bar-theme--dark{background:var(--toastify-color-progress-dark)}.Toastify__progress-bar--info{background:var(--toastify-color-progress-info)}.Toastify__progress-bar--success{background:var(--toastify-color-progress-success)}.Toastify__progress-bar--warning{background:var(--toastify-color-progress-warning)}.Toastify__progress-bar--error{background:var(--toastify-color-progress-error)}.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error{background:var(--toastify-color-transparent)}.Toastify__close-button{color:#fff;position:absolute;top:6px;right:6px;background:transparent;outline:none;border:none;padding:0;cursor:pointer;opacity:.7;transition:.3s ease;z-index:1}.Toastify__toast--rtl .Toastify__close-button{left:6px;right:unset}.Toastify__close-button--light{color:#000;opacity:.3}.Toastify__close-button>svg{fill:currentColor;height:16px;width:14px}.Toastify__close-button:hover,.Toastify__close-button:focus{opacity:1}@keyframes Toastify__trackProgress{0%{transform:scaleX(1)}to{transform:scaleX(0)}}.Toastify__progress-bar{position:absolute;bottom:0;left:0;width:100%;height:100%;z-index:1;opacity:.7;transform-origin:left}.Toastify__progress-bar--animated{animation:Toastify__trackProgress linear 1 forwards}.Toastify__progress-bar--controlled{transition:transform .2s}.Toastify__progress-bar--rtl{right:0;left:initial;transform-origin:right;border-bottom-left-radius:initial}.Toastify__progress-bar--wrp{position:absolute;overflow:hidden;bottom:0;left:0;width:100%;height:5px;border-bottom-left-radius:var(--toastify-toast-bd-radius);border-bottom-right-radius:var(--toastify-toast-bd-radius)}.Toastify__progress-bar--wrp[data-hidden=true]{opacity:0}.Toastify__progress-bar--bg{opacity:var(--toastify-color-progress-bgo);width:100%;height:100%}.Toastify__spinner{width:20px;height:20px;box-sizing:border-box;border:2px solid;border-radius:100%;border-color:var(--toastify-spinner-color-empty-area);border-right-color:var(--toastify-spinner-color);animation:Toastify__spin .65s linear infinite}@keyframes Toastify__bounceInRight{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(3000px,0,0)}60%{opacity:1;transform:translate3d(-25px,0,0)}75%{transform:translate3d(10px,0,0)}90%{transform:translate3d(-5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutRight{20%{opacity:1;transform:translate3d(-20px,var(--y),0)}to{opacity:0;transform:translate3d(2000px,var(--y),0)}}@keyframes Toastify__bounceInLeft{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(-3000px,0,0)}60%{opacity:1;transform:translate3d(25px,0,0)}75%{transform:translate3d(-10px,0,0)}90%{transform:translate3d(5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutLeft{20%{opacity:1;transform:translate3d(20px,var(--y),0)}to{opacity:0;transform:translate3d(-2000px,var(--y),0)}}@keyframes Toastify__bounceInUp{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,3000px,0)}60%{opacity:1;transform:translate3d(0,-20px,0)}75%{transform:translate3d(0,10px,0)}90%{transform:translate3d(0,-5px,0)}to{transform:translateZ(0)}}@keyframes Toastify__bounceOutUp{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,-2000px,0)}}@keyframes Toastify__bounceInDown{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}to{transform:none}}@keyframes Toastify__bounceOutDown{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,2000px,0)}}.Toastify__bounce-enter--top-left,.Toastify__bounce-enter--bottom-left{animation-name:Toastify__bounceInLeft}.Toastify__bounce-enter--top-right,.Toastify__bounce-enter--bottom-right{animation-name:Toastify__bounceInRight}.Toastify__bounce-enter--top-center{animation-name:Toastify__bounceInDown}.Toastify__bounce-enter--bottom-center{animation-name:Toastify__bounceInUp}.Toastify__bounce-exit--top-left,.Toastify__bounce-exit--bottom-left{animation-name:Toastify__bounceOutLeft}.Toastify__bounce-exit--top-right,.Toastify__bounce-exit--bottom-right{animation-name:Toastify__bounceOutRight}.Toastify__bounce-exit--top-center{animation-name:Toastify__bounceOutUp}.Toastify__bounce-exit--bottom-center{animation-name:Toastify__bounceOutDown}@keyframes Toastify__zoomIn{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes Toastify__zoomOut{0%{opacity:1}50%{opacity:0;transform:translate3d(0,var(--y),0) scale3d(.3,.3,.3)}to{opacity:0}}.Toastify__zoom-enter{animation-name:Toastify__zoomIn}.Toastify__zoom-exit{animation-name:Toastify__zoomOut}@keyframes Toastify__flipIn{0%{transform:perspective(400px) rotateX(90deg);animation-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotateX(-20deg);animation-timing-function:ease-in}60%{transform:perspective(400px) rotateX(10deg);opacity:1}80%{transform:perspective(400px) rotateX(-5deg)}to{transform:perspective(400px)}}@keyframes Toastify__flipOut{0%{transform:translate3d(0,var(--y),0) perspective(400px)}30%{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(-20deg);opacity:1}to{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(90deg);opacity:0}}.Toastify__flip-enter{animation-name:Toastify__flipIn}.Toastify__flip-exit{animation-name:Toastify__flipOut}@keyframes Toastify__slideInRight{0%{transform:translate3d(110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInLeft{0%{transform:translate3d(-110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInUp{0%{transform:translate3d(0,110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInDown{0%{transform:translate3d(0,-110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideOutRight{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(110%,var(--y),0)}}@keyframes Toastify__slideOutLeft{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(-110%,var(--y),0)}}@keyframes Toastify__slideOutDown{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,500px,0)}}@keyframes Toastify__slideOutUp{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,-500px,0)}}.Toastify__slide-enter--top-left,.Toastify__slide-enter--bottom-left{animation-name:Toastify__slideInLeft}.Toastify__slide-enter--top-right,.Toastify__slide-enter--bottom-right{animation-name:Toastify__slideInRight}.Toastify__slide-enter--top-center{animation-name:Toastify__slideInDown}.Toastify__slide-enter--bottom-center{animation-name:Toastify__slideInUp}.Toastify__slide-exit--top-left,.Toastify__slide-exit--bottom-left{animation-name:Toastify__slideOutLeft;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-right,.Toastify__slide-exit--bottom-right{animation-name:Toastify__slideOutRight;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-center{animation-name:Toastify__slideOutUp;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--bottom-center{animation-name:Toastify__slideOutDown;animation-timing-function:ease-in;animation-duration:.3s}@keyframes Toastify__spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}
`);
var gpe = (e) => typeof e == "number" && !isNaN(e), iX = (e) => typeof e == "string", NTe = (e) => typeof e == "function", dLe = (e) => iX(e) || gpe(e), cLe = (e) => iDe(e) || iX(e) || NTe(e) || gpe(e), hLe = 1, DTe = () => `${hLe++}`, TN = /* @__PURE__ */ new Map(), A0e = [], hye = /* @__PURE__ */ new Set(), CTe = () => TN.size > 0, fLe = (e, { containerId: t }) => {
  var i;
  return (i = TN.get(t || 1)) == null ? void 0 : i.toasts.get(e);
};
function ILe(e, t) {
  var i;
  if (t) return !!((i = TN.get(t)) != null && i.isToastActive(e));
  let n = !1;
  return TN.forEach((s) => {
    s.isToastActive(e) && (n = !0);
  }), n;
}
function pLe(e) {
  if (!CTe()) {
    A0e = A0e.filter((t) => e != null && t.options.toastId !== e);
    return;
  }
  if (e == null || dLe(e)) TN.forEach((t) => {
    t.removeToast(e);
  });
  else if (e && ("containerId" in e || "id" in e)) {
    let t = TN.get(e.containerId);
    t ? t.removeToast(e.id) : TN.forEach((i) => {
      i.removeToast(e.id);
    });
  }
}
var mLe = (e = {}) => {
  TN.forEach((t) => {
    t.props.limit && (!e.containerId || t.id === e.containerId) && t.clearQueue();
  });
};
function yLe(e, t) {
  cLe(e) && (CTe() || A0e.push({ content: e, options: t }), TN.forEach((i) => {
    i.buildToast(e, t);
  }));
}
function OTe(e, t) {
  TN.forEach((i) => {
    (t == null || !(t != null && t.containerId) || (t == null ? void 0 : t.containerId) === i.id) && i.toggle(e, t == null ? void 0 : t.id);
  });
}
function ELe(e) {
  return hye.add(e), () => {
    hye.delete(e);
  };
}
function gLe(e) {
  return e && (iX(e.toastId) || gpe(e.toastId)) ? e.toastId : DTe();
}
function aie(e, t) {
  return yLe(e, t), t.toastId;
}
function dae(e, t) {
  return { ...t, type: t && t.type || e, toastId: gLe(t) };
}
function cae(e) {
  return (t, i) => aie(t, dae(e, i));
}
function Eu(e, t) {
  return aie(e, dae("default", t));
}
Eu.loading = (e, t) => aie(e, dae("default", { isLoading: !0, autoClose: !1, closeOnClick: !1, closeButton: !1, draggable: !1, ...t }));
function wLe(e, { pending: t, error: i, success: n }, s) {
  let o;
  t && (o = iX(t) ? Eu.loading(t, s) : Eu.loading(t.render, { ...s, ...t }));
  let r = { isLoading: null, autoClose: null, closeOnClick: null, closeButton: null, draggable: null }, l = (h, I, p) => {
    if (I == null) {
      Eu.dismiss(o);
      return;
    }
    let y = { type: h, ...r, ...s, data: p }, m = iX(I) ? { render: I } : I;
    return o ? Eu.update(o, { ...y, ...m }) : Eu(m.render, { ...y, ...m }), p;
  }, c = NTe(e) ? e() : e;
  return c.then((h) => l("success", n, h)).catch((h) => l("error", i, h)), c;
}
Eu.promise = wLe;
Eu.success = cae("success");
Eu.info = cae("info");
Eu.error = cae("error");
Eu.warning = cae("warning");
Eu.warn = Eu.warning;
Eu.dark = (e, t) => aie(e, dae("default", { theme: "dark", ...t }));
function TLe(e) {
  pLe(e);
}
Eu.dismiss = TLe;
Eu.clearWaitingQueue = mLe;
Eu.isActive = ILe;
Eu.update = (e, t = {}) => {
  let i = fLe(e, t);
  if (i) {
    let { props: n, content: s } = i, o = { delay: 100, ...n, ...t, toastId: t.toastId || e, updateId: DTe() };
    o.toastId !== e && (o.staleId = e);
    let r = o.render || s;
    delete o.render, aie(r, o);
  }
};
Eu.done = (e) => {
  Eu.update(e, { progress: 1 });
};
Eu.onChange = ELe;
Eu.play = (e) => OTe(!0, e);
Eu.pause = (e) => OTe(!1, e);
function RLe(e) {
  return Sd({ attr: { viewBox: "0 0 20 20", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { d: "M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" }, child: [] }] })(e);
}
const S0e = 1024, b0e = S0e * 1024, fye = b0e * 1024, vLe = (e) => e === 0 ? "0 B" : e < S0e ? `${e} B` : e < b0e ? `${(e / S0e).toFixed(1)} KB` : e < fye ? `${(e / b0e).toFixed(1)} MB` : `${(e / fye).toFixed(1)} GB`, ALe = ({ files: e, setFiles: t, uploadListText: i, maxFileSizeBytes: n, fileSizeWarningText: s }) => {
  const [o, r] = Is(1), l = 5, [c, h] = Is([]), I = On(
    (A) => n !== void 0 && A.size > n,
    [n]
  ), p = Vu(
    () => n ? [...e.filter(I), ...e.filter((A) => !I(A))] : e,
    [e, I, n]
  ), y = On(
    (A) => {
      t((C) => C.filter((O) => O !== A));
    },
    [t]
  ), m = On((A) => {
    r(A);
  }, []);
  return vr(() => {
    const A = (o - 1) * l, C = A + l;
    h(p.slice(A, C));
  }, [p, o]), e.length === 0 ? null : /* @__PURE__ */ He.jsxs("div", { className: "fc:pb-8 fc:text-day-neutral-dark fc:w-full", children: [
    /* @__PURE__ */ He.jsx("div", { className: "fc:mb-4", children: c.map((A) => /* @__PURE__ */ He.jsxs(
      "div",
      {
        className: "fc:border-b-day-secondary fc:border-b fc:flex fc:items-center",
        children: [
          /* @__PURE__ */ He.jsx("div", { className: "fc:py-4 fc:px-2 fc:pr-5", children: "." + A.name.split(".").slice(-1)[0] }),
          /* @__PURE__ */ He.jsx("div", { className: "fc:py-4 fc:px-2 fc:flex-1 fc:truncate", children: A.name }),
          I(A) && /* @__PURE__ */ He.jsx("div", { className: "fc:py-4 fc:px-2 fc:shrink-0", title: s, children: /* @__PURE__ */ He.jsx(ITe, { fontSize: 22, color: "#f97316" }) }),
          /* @__PURE__ */ He.jsx("div", { className: "fc:py-4 fc:px-2 fc:shrink-0 fc:text-sm fc:text-day-neutral-subtle", children: vLe(A.size) }),
          /* @__PURE__ */ He.jsx("div", { className: "fc:py-4 fc:px-2 fc:cursor-pointer", children: /* @__PURE__ */ He.jsx(RLe, { fontSize: 24, onClick: () => y(A) }) })
        ]
      },
      A.name + A.lastModified
    )) }),
    /* @__PURE__ */ He.jsx("div", { className: "fc:flex fc:justify-center", children: /* @__PURE__ */ He.jsx(
      sOe,
      {
        totalCount: e.length,
        pageSize: 5,
        currentPage: o,
        onPageChange: m
      }
    ) }),
    /* @__PURE__ */ He.jsx("div", { className: "fc:pt-4 fc:flex fc:flex-col md:fc:flex-row fc:justify-center fc:items-center fc:gap-8 fc:flex-wrap fc:text-day-neutral-dark", children: /* @__PURE__ */ He.jsx("div", { className: "fc:text-sm fc:font-semibold", children: `${(e == null ? void 0 : e.length) || 0} ${i}` }) })
  ] });
}, aat = ({
  files: e,
  setFiles: t,
  infoMessage: i,
  showMessagePanel: n,
  setShowMessagePanel: s,
  dropAreaClassName: o,
  dropAreaLabel: r = "Drag and drop files here",
  fileButtonLabel: l = "Upload File",
  folderButtonLabel: c = "Upload Folder",
  uploadListLabel: h = "Files uploaded",
  heading: I,
  alreadyUploadedMessage: p = "Files already uploaded",
  zeroByteFilesMessage: y = "Files are empty: ",
  zipErrorMessage: m = "Zip files are not allowed",
  hideFileList: A = !1,
  maxFileSizeBytes: C,
  fileSizeWarningText: O,
  children: R
}) => {
  const [F, L] = Is([]), P = On(
    async (Ae) => {
      const Oe = new Set(e.map(($e) => $e.name)), pe = Ae.filter(($e) => !Oe.has($e.name)), je = pe.filter(($e) => $e.size != 0), Ve = pe.filter(($e) => $e.size == 0);
      if (pe.length) {
        if (je.length) {
          je.filter((Rt) => Rt.name.toLowerCase().endsWith(".zip")).length && Eu.error(m);
          const vt = je.filter(
            (Rt) => !Rt.name.toLowerCase().endsWith(".zip")
          );
          vt.length && t((Rt) => [...Rt, ...vt]);
        }
        Ve.length && L(Ve);
      } else
        Eu.error(p);
    },
    [p, e, t, m]
  ), {
    getRootProps: z,
    getInputProps: W,
    inputRef: re
  } = v0e({
    onDrop: (Ae) => P(Ae)
  }), { getInputProps: ce, inputRef: te } = v0e({
    onDrop: (Ae) => P(Ae)
  }), ee = On(() => {
    var Ae;
    (Ae = re.current) == null || Ae.click();
  }, [re]), Ne = On(() => {
    var Ae;
    (Ae = te.current) == null || Ae.click();
  }, [te]);
  return /* @__PURE__ */ He.jsx("div", { className: "fc:flex fc:flex-col fc:items-center fc:w-full", children: /* @__PURE__ */ He.jsxs("div", { className: "fc:w-full", children: [
    /* @__PURE__ */ He.jsx("div", { className: "text-base font-semibold text-day-neutral-subtle", children: I }),
    n && s && i && /* @__PURE__ */ He.jsx(z3e, { type: y0e.INFO, onClose: () => s(!1), children: i }),
    /* @__PURE__ */ He.jsx("div", {}),
    /* @__PURE__ */ He.jsxs("div", { className: "fc:flex fc:flex-col fc:items-center fc:w-full", children: [
      /* @__PURE__ */ He.jsxs(
        "div",
        {
          className: Gn(
            "fc:flex fc:flex-col fc:gap-3 fc:w-2/5 fc:py-8 fc:items-center fc:justify-center fc:border-2 fc:border-dashed fc:border-day-primary fc:rounded-xl fc:relative fc:cursor-pointer",
            o
          ),
          ...z(),
          children: [
            /* @__PURE__ */ He.jsx(aLe, { fontSize: 48, className: "fc:text-day-neutral-dark" }),
            /* @__PURE__ */ He.jsx("span", { className: "fc:col-span-2 fc:text-base fc:text-center fc:text-day-neutral-dark", children: r })
          ]
        }
      ),
      /* @__PURE__ */ He.jsx(
        "input",
        {
          ...W(),
          onChange: (Ae) => P(Array.from(Ae.target.files ?? [])),
          type: "file",
          name: "file",
          multiple: !0
        }
      ),
      /* @__PURE__ */ He.jsx(
        "input",
        {
          ...ce(),
          onChange: (Ae) => P(Array.from(Ae.target.files ?? [])),
          type: "file",
          name: "file",
          multiple: !0,
          webkitdirectory: ""
        }
      ),
      /* @__PURE__ */ He.jsxs("div", { className: "fc:grid fc:grid-cols-2 fc:gap-4 fc:w-fit", children: [
        /* @__PURE__ */ He.jsx(
          P3e,
          {
            rounded: !0,
            secondary: !0,
            onClick: ee,
            className: "fc:mt-5 fc:mb-8 fc:col-span-1 fc:font-semibold",
            children: l
          }
        ),
        /* @__PURE__ */ He.jsx(
          P3e,
          {
            rounded: !0,
            secondary: !0,
            onClick: Ne,
            className: "fc:mt-5 fc:mb-8 fc:col-span-1 fc:font-semibold",
            children: c
          }
        )
      ] })
    ] }),
    F.length > 0 && /* @__PURE__ */ He.jsx("div", { className: "mb-6", children: /* @__PURE__ */ He.jsxs(z3e, { type: y0e.ERROR, onClose: () => L([]), children: [
      y,
      /* @__PURE__ */ He.jsx("ul", { children: F.map((Ae) => /* @__PURE__ */ He.jsxs("li", { children: [
        "- ",
        Ae.name
      ] }, Ae.name)) })
    ] }) }),
    !A && /* @__PURE__ */ He.jsx(
      ALe,
      {
        files: e,
        setFiles: t,
        uploadListText: h,
        maxFileSizeBytes: C,
        fileSizeWarningText: O
      }
    ),
    R
  ] }) });
}, uat = (e) => {
  const { text: t, placeholder: i, onChange: n, className: s, disabled: o } = e;
  return /* @__PURE__ */ He.jsxs("div", { className: "fc:group fc:relative", children: [
    /* @__PURE__ */ He.jsx(tOe, { className: "fc:absolute fc:left-4 fc:mt-2 fc:text-day-neutral-subtle", size: 20 }),
    /* @__PURE__ */ He.jsx(
      "input",
      {
        className: Gn(
          "fc:h-[2.3rem] fc:w-80 fc:bg-transparent fc:pl-12 fc:pr-2 fc:focus:outline-none fc:text-sm fc:border-b-2 fc:border-solid fc:border-day-light-2",
          " fc:text-day-neutral-dark fc:placeholder:text-day-neutral-subtle",
          {
            "fc:cursor-not-allowed fc:bg-day-light-2": o,
            "fc:bg-day-light-5": !o
          },
          s
        ),
        type: "search",
        placeholder: i,
        value: t,
        onChange: n,
        disabled: o
      }
    )
  ] });
}, SLe = (e) => e.split("_").reduce((i, n, s) => {
  if (s === 0)
    return n;
  const o = n.substring(0, 1), r = n.substring(1, n.length);
  return o === o.toUpperCase() ? i + "_" + o + r : i + o.toUpperCase() + r;
}), bLe = (e) => {
  let t = "";
  for (let i = 0; i < e.length; i++) {
    const n = e[i], s = n.codePointAt(0);
    if (s == null)
      throw new Error("Cannot convert to snake case when string is empty!");
    (s > 64 && s < 92 || s > 96 && s < 123) && n === n.toUpperCase() ? t += `_${n.toLowerCase()}` : t += n;
  }
  return t;
}, Ii = (e) => {
  if (Array.isArray(e))
    return e.map(Ii);
  if (typeof e == "object" && e !== null && e.constructor === Object) {
    const t = Object.entries(e).map(([i, n]) => [
      SLe(i),
      Ii(n)
    ]);
    return Object.fromEntries(t);
  }
  return e;
}, uL = (e) => {
  if (Array.isArray(e))
    return e.map(uL);
  if (typeof e == "object" && e !== null && e.constructor === Object) {
    const t = Object.entries(e).map(([i, n]) => [
      bLe(i),
      uL(n)
    ]);
    return Object.fromEntries(t);
  }
  return e;
};
var ede = { exports: {} }, Iye;
function NLe() {
  return Iye || (Iye = 1, (function(e, t) {
    (function(i) {
      e.exports = i();
    })(function(i) {
      var n = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
      function s(R, F) {
        var L = R[0], P = R[1], z = R[2], W = R[3];
        L += (P & z | ~P & W) + F[0] - 680876936 | 0, L = (L << 7 | L >>> 25) + P | 0, W += (L & P | ~L & z) + F[1] - 389564586 | 0, W = (W << 12 | W >>> 20) + L | 0, z += (W & L | ~W & P) + F[2] + 606105819 | 0, z = (z << 17 | z >>> 15) + W | 0, P += (z & W | ~z & L) + F[3] - 1044525330 | 0, P = (P << 22 | P >>> 10) + z | 0, L += (P & z | ~P & W) + F[4] - 176418897 | 0, L = (L << 7 | L >>> 25) + P | 0, W += (L & P | ~L & z) + F[5] + 1200080426 | 0, W = (W << 12 | W >>> 20) + L | 0, z += (W & L | ~W & P) + F[6] - 1473231341 | 0, z = (z << 17 | z >>> 15) + W | 0, P += (z & W | ~z & L) + F[7] - 45705983 | 0, P = (P << 22 | P >>> 10) + z | 0, L += (P & z | ~P & W) + F[8] + 1770035416 | 0, L = (L << 7 | L >>> 25) + P | 0, W += (L & P | ~L & z) + F[9] - 1958414417 | 0, W = (W << 12 | W >>> 20) + L | 0, z += (W & L | ~W & P) + F[10] - 42063 | 0, z = (z << 17 | z >>> 15) + W | 0, P += (z & W | ~z & L) + F[11] - 1990404162 | 0, P = (P << 22 | P >>> 10) + z | 0, L += (P & z | ~P & W) + F[12] + 1804603682 | 0, L = (L << 7 | L >>> 25) + P | 0, W += (L & P | ~L & z) + F[13] - 40341101 | 0, W = (W << 12 | W >>> 20) + L | 0, z += (W & L | ~W & P) + F[14] - 1502002290 | 0, z = (z << 17 | z >>> 15) + W | 0, P += (z & W | ~z & L) + F[15] + 1236535329 | 0, P = (P << 22 | P >>> 10) + z | 0, L += (P & W | z & ~W) + F[1] - 165796510 | 0, L = (L << 5 | L >>> 27) + P | 0, W += (L & z | P & ~z) + F[6] - 1069501632 | 0, W = (W << 9 | W >>> 23) + L | 0, z += (W & P | L & ~P) + F[11] + 643717713 | 0, z = (z << 14 | z >>> 18) + W | 0, P += (z & L | W & ~L) + F[0] - 373897302 | 0, P = (P << 20 | P >>> 12) + z | 0, L += (P & W | z & ~W) + F[5] - 701558691 | 0, L = (L << 5 | L >>> 27) + P | 0, W += (L & z | P & ~z) + F[10] + 38016083 | 0, W = (W << 9 | W >>> 23) + L | 0, z += (W & P | L & ~P) + F[15] - 660478335 | 0, z = (z << 14 | z >>> 18) + W | 0, P += (z & L | W & ~L) + F[4] - 405537848 | 0, P = (P << 20 | P >>> 12) + z | 0, L += (P & W | z & ~W) + F[9] + 568446438 | 0, L = (L << 5 | L >>> 27) + P | 0, W += (L & z | P & ~z) + F[14] - 1019803690 | 0, W = (W << 9 | W >>> 23) + L | 0, z += (W & P | L & ~P) + F[3] - 187363961 | 0, z = (z << 14 | z >>> 18) + W | 0, P += (z & L | W & ~L) + F[8] + 1163531501 | 0, P = (P << 20 | P >>> 12) + z | 0, L += (P & W | z & ~W) + F[13] - 1444681467 | 0, L = (L << 5 | L >>> 27) + P | 0, W += (L & z | P & ~z) + F[2] - 51403784 | 0, W = (W << 9 | W >>> 23) + L | 0, z += (W & P | L & ~P) + F[7] + 1735328473 | 0, z = (z << 14 | z >>> 18) + W | 0, P += (z & L | W & ~L) + F[12] - 1926607734 | 0, P = (P << 20 | P >>> 12) + z | 0, L += (P ^ z ^ W) + F[5] - 378558 | 0, L = (L << 4 | L >>> 28) + P | 0, W += (L ^ P ^ z) + F[8] - 2022574463 | 0, W = (W << 11 | W >>> 21) + L | 0, z += (W ^ L ^ P) + F[11] + 1839030562 | 0, z = (z << 16 | z >>> 16) + W | 0, P += (z ^ W ^ L) + F[14] - 35309556 | 0, P = (P << 23 | P >>> 9) + z | 0, L += (P ^ z ^ W) + F[1] - 1530992060 | 0, L = (L << 4 | L >>> 28) + P | 0, W += (L ^ P ^ z) + F[4] + 1272893353 | 0, W = (W << 11 | W >>> 21) + L | 0, z += (W ^ L ^ P) + F[7] - 155497632 | 0, z = (z << 16 | z >>> 16) + W | 0, P += (z ^ W ^ L) + F[10] - 1094730640 | 0, P = (P << 23 | P >>> 9) + z | 0, L += (P ^ z ^ W) + F[13] + 681279174 | 0, L = (L << 4 | L >>> 28) + P | 0, W += (L ^ P ^ z) + F[0] - 358537222 | 0, W = (W << 11 | W >>> 21) + L | 0, z += (W ^ L ^ P) + F[3] - 722521979 | 0, z = (z << 16 | z >>> 16) + W | 0, P += (z ^ W ^ L) + F[6] + 76029189 | 0, P = (P << 23 | P >>> 9) + z | 0, L += (P ^ z ^ W) + F[9] - 640364487 | 0, L = (L << 4 | L >>> 28) + P | 0, W += (L ^ P ^ z) + F[12] - 421815835 | 0, W = (W << 11 | W >>> 21) + L | 0, z += (W ^ L ^ P) + F[15] + 530742520 | 0, z = (z << 16 | z >>> 16) + W | 0, P += (z ^ W ^ L) + F[2] - 995338651 | 0, P = (P << 23 | P >>> 9) + z | 0, L += (z ^ (P | ~W)) + F[0] - 198630844 | 0, L = (L << 6 | L >>> 26) + P | 0, W += (P ^ (L | ~z)) + F[7] + 1126891415 | 0, W = (W << 10 | W >>> 22) + L | 0, z += (L ^ (W | ~P)) + F[14] - 1416354905 | 0, z = (z << 15 | z >>> 17) + W | 0, P += (W ^ (z | ~L)) + F[5] - 57434055 | 0, P = (P << 21 | P >>> 11) + z | 0, L += (z ^ (P | ~W)) + F[12] + 1700485571 | 0, L = (L << 6 | L >>> 26) + P | 0, W += (P ^ (L | ~z)) + F[3] - 1894986606 | 0, W = (W << 10 | W >>> 22) + L | 0, z += (L ^ (W | ~P)) + F[10] - 1051523 | 0, z = (z << 15 | z >>> 17) + W | 0, P += (W ^ (z | ~L)) + F[1] - 2054922799 | 0, P = (P << 21 | P >>> 11) + z | 0, L += (z ^ (P | ~W)) + F[8] + 1873313359 | 0, L = (L << 6 | L >>> 26) + P | 0, W += (P ^ (L | ~z)) + F[15] - 30611744 | 0, W = (W << 10 | W >>> 22) + L | 0, z += (L ^ (W | ~P)) + F[6] - 1560198380 | 0, z = (z << 15 | z >>> 17) + W | 0, P += (W ^ (z | ~L)) + F[13] + 1309151649 | 0, P = (P << 21 | P >>> 11) + z | 0, L += (z ^ (P | ~W)) + F[4] - 145523070 | 0, L = (L << 6 | L >>> 26) + P | 0, W += (P ^ (L | ~z)) + F[11] - 1120210379 | 0, W = (W << 10 | W >>> 22) + L | 0, z += (L ^ (W | ~P)) + F[2] + 718787259 | 0, z = (z << 15 | z >>> 17) + W | 0, P += (W ^ (z | ~L)) + F[9] - 343485551 | 0, P = (P << 21 | P >>> 11) + z | 0, R[0] = L + R[0] | 0, R[1] = P + R[1] | 0, R[2] = z + R[2] | 0, R[3] = W + R[3] | 0;
      }
      function o(R) {
        var F = [], L;
        for (L = 0; L < 64; L += 4)
          F[L >> 2] = R.charCodeAt(L) + (R.charCodeAt(L + 1) << 8) + (R.charCodeAt(L + 2) << 16) + (R.charCodeAt(L + 3) << 24);
        return F;
      }
      function r(R) {
        var F = [], L;
        for (L = 0; L < 64; L += 4)
          F[L >> 2] = R[L] + (R[L + 1] << 8) + (R[L + 2] << 16) + (R[L + 3] << 24);
        return F;
      }
      function l(R) {
        var F = R.length, L = [1732584193, -271733879, -1732584194, 271733878], P, z, W, re, ce, te;
        for (P = 64; P <= F; P += 64)
          s(L, o(R.substring(P - 64, P)));
        for (R = R.substring(P - 64), z = R.length, W = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], P = 0; P < z; P += 1)
          W[P >> 2] |= R.charCodeAt(P) << (P % 4 << 3);
        if (W[P >> 2] |= 128 << (P % 4 << 3), P > 55)
          for (s(L, W), P = 0; P < 16; P += 1)
            W[P] = 0;
        return re = F * 8, re = re.toString(16).match(/(.*?)(.{0,8})$/), ce = parseInt(re[2], 16), te = parseInt(re[1], 16) || 0, W[14] = ce, W[15] = te, s(L, W), L;
      }
      function c(R) {
        var F = R.length, L = [1732584193, -271733879, -1732584194, 271733878], P, z, W, re, ce, te;
        for (P = 64; P <= F; P += 64)
          s(L, r(R.subarray(P - 64, P)));
        for (R = P - 64 < F ? R.subarray(P - 64) : new Uint8Array(0), z = R.length, W = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], P = 0; P < z; P += 1)
          W[P >> 2] |= R[P] << (P % 4 << 3);
        if (W[P >> 2] |= 128 << (P % 4 << 3), P > 55)
          for (s(L, W), P = 0; P < 16; P += 1)
            W[P] = 0;
        return re = F * 8, re = re.toString(16).match(/(.*?)(.{0,8})$/), ce = parseInt(re[2], 16), te = parseInt(re[1], 16) || 0, W[14] = ce, W[15] = te, s(L, W), L;
      }
      function h(R) {
        var F = "", L;
        for (L = 0; L < 4; L += 1)
          F += n[R >> L * 8 + 4 & 15] + n[R >> L * 8 & 15];
        return F;
      }
      function I(R) {
        var F;
        for (F = 0; F < R.length; F += 1)
          R[F] = h(R[F]);
        return R.join("");
      }
      I(l("hello")), typeof ArrayBuffer < "u" && !ArrayBuffer.prototype.slice && (function() {
        function R(F, L) {
          return F = F | 0 || 0, F < 0 ? Math.max(F + L, 0) : Math.min(F, L);
        }
        ArrayBuffer.prototype.slice = function(F, L) {
          var P = this.byteLength, z = R(F, P), W = P, re, ce, te, ee;
          return L !== i && (W = R(L, P)), z > W ? new ArrayBuffer(0) : (re = W - z, ce = new ArrayBuffer(re), te = new Uint8Array(ce), ee = new Uint8Array(this, z, re), te.set(ee), ce);
        };
      })();
      function p(R) {
        return /[\u0080-\uFFFF]/.test(R) && (R = unescape(encodeURIComponent(R))), R;
      }
      function y(R, F) {
        var L = R.length, P = new ArrayBuffer(L), z = new Uint8Array(P), W;
        for (W = 0; W < L; W += 1)
          z[W] = R.charCodeAt(W);
        return F ? z : P;
      }
      function m(R) {
        return String.fromCharCode.apply(null, new Uint8Array(R));
      }
      function A(R, F, L) {
        var P = new Uint8Array(R.byteLength + F.byteLength);
        return P.set(new Uint8Array(R)), P.set(new Uint8Array(F), R.byteLength), P;
      }
      function C(R) {
        var F = [], L = R.length, P;
        for (P = 0; P < L - 1; P += 2)
          F.push(parseInt(R.substr(P, 2), 16));
        return String.fromCharCode.apply(String, F);
      }
      function O() {
        this.reset();
      }
      return O.prototype.append = function(R) {
        return this.appendBinary(p(R)), this;
      }, O.prototype.appendBinary = function(R) {
        this._buff += R, this._length += R.length;
        var F = this._buff.length, L;
        for (L = 64; L <= F; L += 64)
          s(this._hash, o(this._buff.substring(L - 64, L)));
        return this._buff = this._buff.substring(L - 64), this;
      }, O.prototype.end = function(R) {
        var F = this._buff, L = F.length, P, z = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], W;
        for (P = 0; P < L; P += 1)
          z[P >> 2] |= F.charCodeAt(P) << (P % 4 << 3);
        return this._finish(z, L), W = I(this._hash), R && (W = C(W)), this.reset(), W;
      }, O.prototype.reset = function() {
        return this._buff = "", this._length = 0, this._hash = [1732584193, -271733879, -1732584194, 271733878], this;
      }, O.prototype.getState = function() {
        return {
          buff: this._buff,
          length: this._length,
          hash: this._hash.slice()
        };
      }, O.prototype.setState = function(R) {
        return this._buff = R.buff, this._length = R.length, this._hash = R.hash, this;
      }, O.prototype.destroy = function() {
        delete this._hash, delete this._buff, delete this._length;
      }, O.prototype._finish = function(R, F) {
        var L = F, P, z, W;
        if (R[L >> 2] |= 128 << (L % 4 << 3), L > 55)
          for (s(this._hash, R), L = 0; L < 16; L += 1)
            R[L] = 0;
        P = this._length * 8, P = P.toString(16).match(/(.*?)(.{0,8})$/), z = parseInt(P[2], 16), W = parseInt(P[1], 16) || 0, R[14] = z, R[15] = W, s(this._hash, R);
      }, O.hash = function(R, F) {
        return O.hashBinary(p(R), F);
      }, O.hashBinary = function(R, F) {
        var L = l(R), P = I(L);
        return F ? C(P) : P;
      }, O.ArrayBuffer = function() {
        this.reset();
      }, O.ArrayBuffer.prototype.append = function(R) {
        var F = A(this._buff.buffer, R), L = F.length, P;
        for (this._length += R.byteLength, P = 64; P <= L; P += 64)
          s(this._hash, r(F.subarray(P - 64, P)));
        return this._buff = P - 64 < L ? new Uint8Array(F.buffer.slice(P - 64)) : new Uint8Array(0), this;
      }, O.ArrayBuffer.prototype.end = function(R) {
        var F = this._buff, L = F.length, P = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], z, W;
        for (z = 0; z < L; z += 1)
          P[z >> 2] |= F[z] << (z % 4 << 3);
        return this._finish(P, L), W = I(this._hash), R && (W = C(W)), this.reset(), W;
      }, O.ArrayBuffer.prototype.reset = function() {
        return this._buff = new Uint8Array(0), this._length = 0, this._hash = [1732584193, -271733879, -1732584194, 271733878], this;
      }, O.ArrayBuffer.prototype.getState = function() {
        var R = O.prototype.getState.call(this);
        return R.buff = m(R.buff), R;
      }, O.ArrayBuffer.prototype.setState = function(R) {
        return R.buff = y(R.buff, !0), O.prototype.setState.call(this, R);
      }, O.ArrayBuffer.prototype.destroy = O.prototype.destroy, O.ArrayBuffer.prototype._finish = O.prototype._finish, O.ArrayBuffer.hash = function(R, F) {
        var L = c(new Uint8Array(R)), P = I(L);
        return F ? C(P) : P;
      }, O;
    });
  })(ede)), ede.exports;
}
NLe();
var pye;
(function(e) {
  e.PROD = "https://solution-viewer.ai4eng.aecom.services", e.DEV = "https://solution-viewer.dev.ai4eng.aecom.team", e.TEST_ENV = "https://solution-viewer.test.ai4eng.aecom.team", e.SANDBOX = "https://solution-viewer-sandbox-b4dkhdb7bvcne3ek.z03.azurefd.net";
})(pye || (pye = {}));
var el;
(function(e) {
  e.assertEqual = (s) => {
  };
  function t(s) {
  }
  e.assertIs = t;
  function i(s) {
    throw new Error();
  }
  e.assertNever = i, e.arrayToEnum = (s) => {
    const o = {};
    for (const r of s)
      o[r] = r;
    return o;
  }, e.getValidEnumValues = (s) => {
    const o = e.objectKeys(s).filter((l) => typeof s[s[l]] != "number"), r = {};
    for (const l of o)
      r[l] = s[l];
    return e.objectValues(r);
  }, e.objectValues = (s) => e.objectKeys(s).map(function(o) {
    return s[o];
  }), e.objectKeys = typeof Object.keys == "function" ? (s) => Object.keys(s) : (s) => {
    const o = [];
    for (const r in s)
      Object.prototype.hasOwnProperty.call(s, r) && o.push(r);
    return o;
  }, e.find = (s, o) => {
    for (const r of s)
      if (o(r))
        return r;
  }, e.isInteger = typeof Number.isInteger == "function" ? (s) => Number.isInteger(s) : (s) => typeof s == "number" && Number.isFinite(s) && Math.floor(s) === s;
  function n(s, o = " | ") {
    return s.map((r) => typeof r == "string" ? `'${r}'` : r).join(o);
  }
  e.joinValues = n, e.jsonStringifyReplacer = (s, o) => typeof o == "bigint" ? o.toString() : o;
})(el || (el = {}));
var mye;
(function(e) {
  e.mergeShapes = (t, i) => ({
    ...t,
    ...i
    // second overwrites first
  });
})(mye || (mye = {}));
const Jn = el.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), q_ = (e) => {
  switch (typeof e) {
    case "undefined":
      return Jn.undefined;
    case "string":
      return Jn.string;
    case "number":
      return Number.isNaN(e) ? Jn.nan : Jn.number;
    case "boolean":
      return Jn.boolean;
    case "function":
      return Jn.function;
    case "bigint":
      return Jn.bigint;
    case "symbol":
      return Jn.symbol;
    case "object":
      return Array.isArray(e) ? Jn.array : e === null ? Jn.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? Jn.promise : typeof Map < "u" && e instanceof Map ? Jn.map : typeof Set < "u" && e instanceof Set ? Jn.set : typeof Date < "u" && e instanceof Date ? Jn.date : Jn.object;
    default:
      return Jn.unknown;
  }
}, pn = el.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class dL extends Error {
  get errors() {
    return this.issues;
  }
  constructor(t) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const i = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, i) : this.__proto__ = i, this.name = "ZodError", this.issues = t;
  }
  format(t) {
    const i = t || function(o) {
      return o.message;
    }, n = { _errors: [] }, s = (o) => {
      for (const r of o.issues)
        if (r.code === "invalid_union")
          r.unionErrors.map(s);
        else if (r.code === "invalid_return_type")
          s(r.returnTypeError);
        else if (r.code === "invalid_arguments")
          s(r.argumentsError);
        else if (r.path.length === 0)
          n._errors.push(i(r));
        else {
          let l = n, c = 0;
          for (; c < r.path.length; ) {
            const h = r.path[c];
            c === r.path.length - 1 ? (l[h] = l[h] || { _errors: [] }, l[h]._errors.push(i(r))) : l[h] = l[h] || { _errors: [] }, l = l[h], c++;
          }
        }
    };
    return s(this), n;
  }
  static assert(t) {
    if (!(t instanceof dL))
      throw new Error(`Not a ZodError: ${t}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, el.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (i) => i.message) {
    const i = {}, n = [];
    for (const s of this.issues)
      if (s.path.length > 0) {
        const o = s.path[0];
        i[o] = i[o] || [], i[o].push(t(s));
      } else
        n.push(t(s));
    return { formErrors: n, fieldErrors: i };
  }
  get formErrors() {
    return this.flatten();
  }
}
dL.create = (e) => new dL(e);
const N0e = (e, t) => {
  let i;
  switch (e.code) {
    case pn.invalid_type:
      e.received === Jn.undefined ? i = "Required" : i = `Expected ${e.expected}, received ${e.received}`;
      break;
    case pn.invalid_literal:
      i = `Invalid literal value, expected ${JSON.stringify(e.expected, el.jsonStringifyReplacer)}`;
      break;
    case pn.unrecognized_keys:
      i = `Unrecognized key(s) in object: ${el.joinValues(e.keys, ", ")}`;
      break;
    case pn.invalid_union:
      i = "Invalid input";
      break;
    case pn.invalid_union_discriminator:
      i = `Invalid discriminator value. Expected ${el.joinValues(e.options)}`;
      break;
    case pn.invalid_enum_value:
      i = `Invalid enum value. Expected ${el.joinValues(e.options)}, received '${e.received}'`;
      break;
    case pn.invalid_arguments:
      i = "Invalid function arguments";
      break;
    case pn.invalid_return_type:
      i = "Invalid function return type";
      break;
    case pn.invalid_date:
      i = "Invalid date";
      break;
    case pn.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (i = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (i = `${i} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? i = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? i = `Invalid input: must end with "${e.validation.endsWith}"` : el.assertNever(e.validation) : e.validation !== "regex" ? i = `Invalid ${e.validation}` : i = "Invalid";
      break;
    case pn.too_small:
      e.type === "array" ? i = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? i = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? i = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "bigint" ? i = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? i = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : i = "Invalid input";
      break;
    case pn.too_big:
      e.type === "array" ? i = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? i = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? i = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? i = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? i = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : i = "Invalid input";
      break;
    case pn.custom:
      i = "Invalid input";
      break;
    case pn.invalid_intersection_types:
      i = "Intersection results could not be merged";
      break;
    case pn.not_multiple_of:
      i = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case pn.not_finite:
      i = "Number must be finite";
      break;
    default:
      i = t.defaultError, el.assertNever(e);
  }
  return { message: i };
};
let DLe = N0e;
function CLe() {
  return DLe;
}
const OLe = (e) => {
  const { data: t, path: i, errorMaps: n, issueData: s } = e, o = [...i, ...s.path || []], r = {
    ...s,
    path: o
  };
  if (s.message !== void 0)
    return {
      ...s,
      path: o,
      message: s.message
    };
  let l = "";
  const c = n.filter((h) => !!h).slice().reverse();
  for (const h of c)
    l = h(r, { data: t, defaultError: l }).message;
  return {
    ...s,
    path: o,
    message: l
  };
};
function Bn(e, t) {
  const i = CLe(), n = OLe({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      // contextual error map is first priority
      e.schemaErrorMap,
      // then schema-bound map if available
      i,
      // then global override map
      i === N0e ? void 0 : N0e
      // then global default map
    ].filter((s) => !!s)
  });
  e.common.issues.push(n);
}
class uE {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, i) {
    const n = [];
    for (const s of i) {
      if (s.status === "aborted")
        return Ks;
      s.status === "dirty" && t.dirty(), n.push(s.value);
    }
    return { status: t.value, value: n };
  }
  static async mergeObjectAsync(t, i) {
    const n = [];
    for (const s of i) {
      const o = await s.key, r = await s.value;
      n.push({
        key: o,
        value: r
      });
    }
    return uE.mergeObjectSync(t, n);
  }
  static mergeObjectSync(t, i) {
    const n = {};
    for (const s of i) {
      const { key: o, value: r } = s;
      if (o.status === "aborted" || r.status === "aborted")
        return Ks;
      o.status === "dirty" && t.dirty(), r.status === "dirty" && t.dirty(), o.value !== "__proto__" && (typeof r.value < "u" || s.alwaysSet) && (n[o.value] = r.value);
    }
    return { status: t.value, value: n };
  }
}
const Ks = Object.freeze({
  status: "aborted"
}), XZ = (e) => ({ status: "dirty", value: e }), H5 = (e) => ({ status: "valid", value: e }), yye = (e) => e.status === "aborted", Eye = (e) => e.status === "dirty", mW = (e) => e.status === "valid", jre = (e) => typeof Promise < "u" && e instanceof Promise;
var rs;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t == null ? void 0 : t.message;
})(rs || (rs = {}));
class o6 {
  constructor(t, i, n, s) {
    this._cachedPath = [], this.parent = t, this.data = i, this._path = n, this._key = s;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const gye = (e, t) => {
  if (mW(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const i = new dL(e.common.issues);
      return this._error = i, this._error;
    }
  };
};
function xo(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: i, required_error: n, description: s } = e;
  if (t && (i || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: s } : { errorMap: (r, l) => {
    const { message: c } = e;
    return r.code === "invalid_enum_value" ? { message: c ?? l.defaultError } : typeof l.data > "u" ? { message: c ?? n ?? l.defaultError } : r.code !== "invalid_type" ? { message: l.defaultError } : { message: c ?? i ?? l.defaultError };
  }, description: s };
}
class pr {
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return q_(t.data);
  }
  _getOrReturnCtx(t, i) {
    return i || {
      common: t.parent.common,
      data: t.data,
      parsedType: q_(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new uE(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: q_(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const i = this._parse(t);
    if (jre(i))
      throw new Error("Synchronous parse encountered promise.");
    return i;
  }
  _parseAsync(t) {
    const i = this._parse(t);
    return Promise.resolve(i);
  }
  parse(t, i) {
    const n = this.safeParse(t, i);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(t, i) {
    const n = {
      common: {
        issues: [],
        async: (i == null ? void 0 : i.async) ?? !1,
        contextualErrorMap: i == null ? void 0 : i.errorMap
      },
      path: (i == null ? void 0 : i.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: q_(t)
    }, s = this._parseSync({ data: t, path: n.path, parent: n });
    return gye(n, s);
  }
  "~validate"(t) {
    var n, s;
    const i = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: q_(t)
    };
    if (!this["~standard"].async)
      try {
        const o = this._parseSync({ data: t, path: [], parent: i });
        return mW(o) ? {
          value: o.value
        } : {
          issues: i.common.issues
        };
      } catch (o) {
        (s = (n = o == null ? void 0 : o.message) == null ? void 0 : n.toLowerCase()) != null && s.includes("encountered") && (this["~standard"].async = !0), i.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: t, path: [], parent: i }).then((o) => mW(o) ? {
      value: o.value
    } : {
      issues: i.common.issues
    });
  }
  async parseAsync(t, i) {
    const n = await this.safeParseAsync(t, i);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(t, i) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: i == null ? void 0 : i.errorMap,
        async: !0
      },
      path: (i == null ? void 0 : i.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: q_(t)
    }, s = this._parse({ data: t, path: n.path, parent: n }), o = await (jre(s) ? s : Promise.resolve(s));
    return gye(n, o);
  }
  refine(t, i) {
    const n = (s) => typeof i == "string" || typeof i > "u" ? { message: i } : typeof i == "function" ? i(s) : i;
    return this._refinement((s, o) => {
      const r = t(s), l = () => o.addIssue({
        code: pn.custom,
        ...n(s)
      });
      return typeof Promise < "u" && r instanceof Promise ? r.then((c) => c ? !0 : (l(), !1)) : r ? !0 : (l(), !1);
    });
  }
  refinement(t, i) {
    return this._refinement((n, s) => t(n) ? !0 : (s.addIssue(typeof i == "function" ? i(n, s) : i), !1));
  }
  _refinement(t) {
    return new gW({
      schema: this,
      typeName: js.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (i) => this["~validate"](i)
    };
  }
  optional() {
    return NP.create(this, this._def);
  }
  nullable() {
    return wW.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return RN.create(this);
  }
  promise() {
    return Kre.create(this, this._def);
  }
  or(t) {
    return Yre.create([this, t], this._def);
  }
  and(t) {
    return qre.create(this, t, this._def);
  }
  transform(t) {
    return new gW({
      ...xo(this._def),
      schema: this,
      typeName: js.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const i = typeof t == "function" ? t : () => t;
    return new P0e({
      ...xo(this._def),
      innerType: this,
      defaultValue: i,
      typeName: js.ZodDefault
    });
  }
  brand() {
    return new XLe({
      typeName: js.ZodBranded,
      type: this,
      ...xo(this._def)
    });
  }
  catch(t) {
    const i = typeof t == "function" ? t : () => t;
    return new M0e({
      ...xo(this._def),
      innerType: this,
      catchValue: i,
      typeName: js.ZodCatch
    });
  }
  describe(t) {
    const i = this.constructor;
    return new i({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return wpe.create(this, t);
  }
  readonly() {
    return U0e.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const LLe = /^c[^\s-]{8,}$/i, _Le = /^[0-9a-z]+$/, xLe = /^[0-9A-HJKMNP-TV-Z]{26}$/i, PLe = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, MLe = /^[a-z0-9_-]{21}$/i, ULe = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, BLe = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, FLe = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, HLe = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let tde;
const GLe = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, kLe = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, VLe = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, zLe = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, jLe = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, WLe = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, LTe = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", YLe = new RegExp(`^${LTe}$`);
function _Te(e) {
  let t = "[0-5]\\d";
  e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision == null && (t = `${t}(\\.\\d+)?`);
  const i = e.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${t})${i}`;
}
function qLe(e) {
  return new RegExp(`^${_Te(e)}$`);
}
function $Le(e) {
  let t = `${LTe}T${_Te(e)}`;
  const i = [];
  return i.push(e.local ? "Z?" : "Z"), e.offset && i.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${i.join("|")})`, new RegExp(`^${t}$`);
}
function KLe(e, t) {
  return !!((t === "v4" || !t) && GLe.test(e) || (t === "v6" || !t) && VLe.test(e));
}
function ZLe(e, t) {
  if (!ULe.test(e))
    return !1;
  try {
    const [i] = e.split(".");
    if (!i)
      return !1;
    const n = i.replace(/-/g, "+").replace(/_/g, "/").padEnd(i.length + (4 - i.length % 4) % 4, "="), s = JSON.parse(atob(n));
    return !(typeof s != "object" || s === null || "typ" in s && (s == null ? void 0 : s.typ) !== "JWT" || !s.alg || t && s.alg !== t);
  } catch {
    return !1;
  }
}
function QLe(e, t) {
  return !!((t === "v4" || !t) && kLe.test(e) || (t === "v6" || !t) && zLe.test(e));
}
class TO extends pr {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== Jn.string) {
      const o = this._getOrReturnCtx(t);
      return Bn(o, {
        code: pn.invalid_type,
        expected: Jn.string,
        received: o.parsedType
      }), Ks;
    }
    const n = new uE();
    let s;
    for (const o of this._def.checks)
      if (o.kind === "min")
        t.data.length < o.value && (s = this._getOrReturnCtx(t, s), Bn(s, {
          code: pn.too_small,
          minimum: o.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: o.message
        }), n.dirty());
      else if (o.kind === "max")
        t.data.length > o.value && (s = this._getOrReturnCtx(t, s), Bn(s, {
          code: pn.too_big,
          maximum: o.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: o.message
        }), n.dirty());
      else if (o.kind === "length") {
        const r = t.data.length > o.value, l = t.data.length < o.value;
        (r || l) && (s = this._getOrReturnCtx(t, s), r ? Bn(s, {
          code: pn.too_big,
          maximum: o.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: o.message
        }) : l && Bn(s, {
          code: pn.too_small,
          minimum: o.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: o.message
        }), n.dirty());
      } else if (o.kind === "email")
        FLe.test(t.data) || (s = this._getOrReturnCtx(t, s), Bn(s, {
          validation: "email",
          code: pn.invalid_string,
          message: o.message
        }), n.dirty());
      else if (o.kind === "emoji")
        tde || (tde = new RegExp(HLe, "u")), tde.test(t.data) || (s = this._getOrReturnCtx(t, s), Bn(s, {
          validation: "emoji",
          code: pn.invalid_string,
          message: o.message
        }), n.dirty());
      else if (o.kind === "uuid")
        PLe.test(t.data) || (s = this._getOrReturnCtx(t, s), Bn(s, {
          validation: "uuid",
          code: pn.invalid_string,
          message: o.message
        }), n.dirty());
      else if (o.kind === "nanoid")
        MLe.test(t.data) || (s = this._getOrReturnCtx(t, s), Bn(s, {
          validation: "nanoid",
          code: pn.invalid_string,
          message: o.message
        }), n.dirty());
      else if (o.kind === "cuid")
        LLe.test(t.data) || (s = this._getOrReturnCtx(t, s), Bn(s, {
          validation: "cuid",
          code: pn.invalid_string,
          message: o.message
        }), n.dirty());
      else if (o.kind === "cuid2")
        _Le.test(t.data) || (s = this._getOrReturnCtx(t, s), Bn(s, {
          validation: "cuid2",
          code: pn.invalid_string,
          message: o.message
        }), n.dirty());
      else if (o.kind === "ulid")
        xLe.test(t.data) || (s = this._getOrReturnCtx(t, s), Bn(s, {
          validation: "ulid",
          code: pn.invalid_string,
          message: o.message
        }), n.dirty());
      else if (o.kind === "url")
        try {
          new URL(t.data);
        } catch {
          s = this._getOrReturnCtx(t, s), Bn(s, {
            validation: "url",
            code: pn.invalid_string,
            message: o.message
          }), n.dirty();
        }
      else o.kind === "regex" ? (o.regex.lastIndex = 0, o.regex.test(t.data) || (s = this._getOrReturnCtx(t, s), Bn(s, {
        validation: "regex",
        code: pn.invalid_string,
        message: o.message
      }), n.dirty())) : o.kind === "trim" ? t.data = t.data.trim() : o.kind === "includes" ? t.data.includes(o.value, o.position) || (s = this._getOrReturnCtx(t, s), Bn(s, {
        code: pn.invalid_string,
        validation: { includes: o.value, position: o.position },
        message: o.message
      }), n.dirty()) : o.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : o.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : o.kind === "startsWith" ? t.data.startsWith(o.value) || (s = this._getOrReturnCtx(t, s), Bn(s, {
        code: pn.invalid_string,
        validation: { startsWith: o.value },
        message: o.message
      }), n.dirty()) : o.kind === "endsWith" ? t.data.endsWith(o.value) || (s = this._getOrReturnCtx(t, s), Bn(s, {
        code: pn.invalid_string,
        validation: { endsWith: o.value },
        message: o.message
      }), n.dirty()) : o.kind === "datetime" ? $Le(o).test(t.data) || (s = this._getOrReturnCtx(t, s), Bn(s, {
        code: pn.invalid_string,
        validation: "datetime",
        message: o.message
      }), n.dirty()) : o.kind === "date" ? YLe.test(t.data) || (s = this._getOrReturnCtx(t, s), Bn(s, {
        code: pn.invalid_string,
        validation: "date",
        message: o.message
      }), n.dirty()) : o.kind === "time" ? qLe(o).test(t.data) || (s = this._getOrReturnCtx(t, s), Bn(s, {
        code: pn.invalid_string,
        validation: "time",
        message: o.message
      }), n.dirty()) : o.kind === "duration" ? BLe.test(t.data) || (s = this._getOrReturnCtx(t, s), Bn(s, {
        validation: "duration",
        code: pn.invalid_string,
        message: o.message
      }), n.dirty()) : o.kind === "ip" ? KLe(t.data, o.version) || (s = this._getOrReturnCtx(t, s), Bn(s, {
        validation: "ip",
        code: pn.invalid_string,
        message: o.message
      }), n.dirty()) : o.kind === "jwt" ? ZLe(t.data, o.alg) || (s = this._getOrReturnCtx(t, s), Bn(s, {
        validation: "jwt",
        code: pn.invalid_string,
        message: o.message
      }), n.dirty()) : o.kind === "cidr" ? QLe(t.data, o.version) || (s = this._getOrReturnCtx(t, s), Bn(s, {
        validation: "cidr",
        code: pn.invalid_string,
        message: o.message
      }), n.dirty()) : o.kind === "base64" ? jLe.test(t.data) || (s = this._getOrReturnCtx(t, s), Bn(s, {
        validation: "base64",
        code: pn.invalid_string,
        message: o.message
      }), n.dirty()) : o.kind === "base64url" ? WLe.test(t.data) || (s = this._getOrReturnCtx(t, s), Bn(s, {
        validation: "base64url",
        code: pn.invalid_string,
        message: o.message
      }), n.dirty()) : el.assertNever(o);
    return { status: n.value, value: t.data };
  }
  _regex(t, i, n) {
    return this.refinement((s) => t.test(s), {
      validation: i,
      code: pn.invalid_string,
      ...rs.errToObj(n)
    });
  }
  _addCheck(t) {
    return new TO({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...rs.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...rs.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...rs.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...rs.errToObj(t) });
  }
  nanoid(t) {
    return this._addCheck({ kind: "nanoid", ...rs.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...rs.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...rs.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...rs.errToObj(t) });
  }
  base64(t) {
    return this._addCheck({ kind: "base64", ...rs.errToObj(t) });
  }
  base64url(t) {
    return this._addCheck({
      kind: "base64url",
      ...rs.errToObj(t)
    });
  }
  jwt(t) {
    return this._addCheck({ kind: "jwt", ...rs.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...rs.errToObj(t) });
  }
  cidr(t) {
    return this._addCheck({ kind: "cidr", ...rs.errToObj(t) });
  }
  datetime(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      offset: (t == null ? void 0 : t.offset) ?? !1,
      local: (t == null ? void 0 : t.local) ?? !1,
      ...rs.errToObj(t == null ? void 0 : t.message)
    });
  }
  date(t) {
    return this._addCheck({ kind: "date", message: t });
  }
  time(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: t
    }) : this._addCheck({
      kind: "time",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      ...rs.errToObj(t == null ? void 0 : t.message)
    });
  }
  duration(t) {
    return this._addCheck({ kind: "duration", ...rs.errToObj(t) });
  }
  regex(t, i) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...rs.errToObj(i)
    });
  }
  includes(t, i) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: i == null ? void 0 : i.position,
      ...rs.errToObj(i == null ? void 0 : i.message)
    });
  }
  startsWith(t, i) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...rs.errToObj(i)
    });
  }
  endsWith(t, i) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...rs.errToObj(i)
    });
  }
  min(t, i) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...rs.errToObj(i)
    });
  }
  max(t, i) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...rs.errToObj(i)
    });
  }
  length(t, i) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...rs.errToObj(i)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(t) {
    return this.min(1, rs.errToObj(t));
  }
  trim() {
    return new TO({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new TO({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new TO({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((t) => t.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((t) => t.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((t) => t.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((t) => t.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((t) => t.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((t) => t.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((t) => t.kind === "base64url");
  }
  get minLength() {
    let t = null;
    for (const i of this._def.checks)
      i.kind === "min" && (t === null || i.value > t) && (t = i.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const i of this._def.checks)
      i.kind === "max" && (t === null || i.value < t) && (t = i.value);
    return t;
  }
}
TO.create = (e) => new TO({
  checks: [],
  typeName: js.ZodString,
  coerce: (e == null ? void 0 : e.coerce) ?? !1,
  ...xo(e)
});
function JLe(e, t) {
  const i = (e.toString().split(".")[1] || "").length, n = (t.toString().split(".")[1] || "").length, s = i > n ? i : n, o = Number.parseInt(e.toFixed(s).replace(".", "")), r = Number.parseInt(t.toFixed(s).replace(".", ""));
  return o % r / 10 ** s;
}
class yW extends pr {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== Jn.number) {
      const o = this._getOrReturnCtx(t);
      return Bn(o, {
        code: pn.invalid_type,
        expected: Jn.number,
        received: o.parsedType
      }), Ks;
    }
    let n;
    const s = new uE();
    for (const o of this._def.checks)
      o.kind === "int" ? el.isInteger(t.data) || (n = this._getOrReturnCtx(t, n), Bn(n, {
        code: pn.invalid_type,
        expected: "integer",
        received: "float",
        message: o.message
      }), s.dirty()) : o.kind === "min" ? (o.inclusive ? t.data < o.value : t.data <= o.value) && (n = this._getOrReturnCtx(t, n), Bn(n, {
        code: pn.too_small,
        minimum: o.value,
        type: "number",
        inclusive: o.inclusive,
        exact: !1,
        message: o.message
      }), s.dirty()) : o.kind === "max" ? (o.inclusive ? t.data > o.value : t.data >= o.value) && (n = this._getOrReturnCtx(t, n), Bn(n, {
        code: pn.too_big,
        maximum: o.value,
        type: "number",
        inclusive: o.inclusive,
        exact: !1,
        message: o.message
      }), s.dirty()) : o.kind === "multipleOf" ? JLe(t.data, o.value) !== 0 && (n = this._getOrReturnCtx(t, n), Bn(n, {
        code: pn.not_multiple_of,
        multipleOf: o.value,
        message: o.message
      }), s.dirty()) : o.kind === "finite" ? Number.isFinite(t.data) || (n = this._getOrReturnCtx(t, n), Bn(n, {
        code: pn.not_finite,
        message: o.message
      }), s.dirty()) : el.assertNever(o);
    return { status: s.value, value: t.data };
  }
  gte(t, i) {
    return this.setLimit("min", t, !0, rs.toString(i));
  }
  gt(t, i) {
    return this.setLimit("min", t, !1, rs.toString(i));
  }
  lte(t, i) {
    return this.setLimit("max", t, !0, rs.toString(i));
  }
  lt(t, i) {
    return this.setLimit("max", t, !1, rs.toString(i));
  }
  setLimit(t, i, n, s) {
    return new yW({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: i,
          inclusive: n,
          message: rs.toString(s)
        }
      ]
    });
  }
  _addCheck(t) {
    return new yW({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: rs.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: rs.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: rs.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: rs.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: rs.toString(t)
    });
  }
  multipleOf(t, i) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: rs.toString(i)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: rs.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: rs.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: rs.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const i of this._def.checks)
      i.kind === "min" && (t === null || i.value > t) && (t = i.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const i of this._def.checks)
      i.kind === "max" && (t === null || i.value < t) && (t = i.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && el.isInteger(t.value));
  }
  get isFinite() {
    let t = null, i = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (i === null || n.value > i) && (i = n.value) : n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    }
    return Number.isFinite(i) && Number.isFinite(t);
  }
}
yW.create = (e) => new yW({
  checks: [],
  typeName: js.ZodNumber,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...xo(e)
});
class nX extends pr {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce)
      try {
        t.data = BigInt(t.data);
      } catch {
        return this._getInvalidInput(t);
      }
    if (this._getType(t) !== Jn.bigint)
      return this._getInvalidInput(t);
    let n;
    const s = new uE();
    for (const o of this._def.checks)
      o.kind === "min" ? (o.inclusive ? t.data < o.value : t.data <= o.value) && (n = this._getOrReturnCtx(t, n), Bn(n, {
        code: pn.too_small,
        type: "bigint",
        minimum: o.value,
        inclusive: o.inclusive,
        message: o.message
      }), s.dirty()) : o.kind === "max" ? (o.inclusive ? t.data > o.value : t.data >= o.value) && (n = this._getOrReturnCtx(t, n), Bn(n, {
        code: pn.too_big,
        type: "bigint",
        maximum: o.value,
        inclusive: o.inclusive,
        message: o.message
      }), s.dirty()) : o.kind === "multipleOf" ? t.data % o.value !== BigInt(0) && (n = this._getOrReturnCtx(t, n), Bn(n, {
        code: pn.not_multiple_of,
        multipleOf: o.value,
        message: o.message
      }), s.dirty()) : el.assertNever(o);
    return { status: s.value, value: t.data };
  }
  _getInvalidInput(t) {
    const i = this._getOrReturnCtx(t);
    return Bn(i, {
      code: pn.invalid_type,
      expected: Jn.bigint,
      received: i.parsedType
    }), Ks;
  }
  gte(t, i) {
    return this.setLimit("min", t, !0, rs.toString(i));
  }
  gt(t, i) {
    return this.setLimit("min", t, !1, rs.toString(i));
  }
  lte(t, i) {
    return this.setLimit("max", t, !0, rs.toString(i));
  }
  lt(t, i) {
    return this.setLimit("max", t, !1, rs.toString(i));
  }
  setLimit(t, i, n, s) {
    return new nX({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: i,
          inclusive: n,
          message: rs.toString(s)
        }
      ]
    });
  }
  _addCheck(t) {
    return new nX({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: rs.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: rs.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: rs.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: rs.toString(t)
    });
  }
  multipleOf(t, i) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: rs.toString(i)
    });
  }
  get minValue() {
    let t = null;
    for (const i of this._def.checks)
      i.kind === "min" && (t === null || i.value > t) && (t = i.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const i of this._def.checks)
      i.kind === "max" && (t === null || i.value < t) && (t = i.value);
    return t;
  }
}
nX.create = (e) => new nX({
  checks: [],
  typeName: js.ZodBigInt,
  coerce: (e == null ? void 0 : e.coerce) ?? !1,
  ...xo(e)
});
class D0e extends pr {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== Jn.boolean) {
      const n = this._getOrReturnCtx(t);
      return Bn(n, {
        code: pn.invalid_type,
        expected: Jn.boolean,
        received: n.parsedType
      }), Ks;
    }
    return H5(t.data);
  }
}
D0e.create = (e) => new D0e({
  typeName: js.ZodBoolean,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...xo(e)
});
class Wre extends pr {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== Jn.date) {
      const o = this._getOrReturnCtx(t);
      return Bn(o, {
        code: pn.invalid_type,
        expected: Jn.date,
        received: o.parsedType
      }), Ks;
    }
    if (Number.isNaN(t.data.getTime())) {
      const o = this._getOrReturnCtx(t);
      return Bn(o, {
        code: pn.invalid_date
      }), Ks;
    }
    const n = new uE();
    let s;
    for (const o of this._def.checks)
      o.kind === "min" ? t.data.getTime() < o.value && (s = this._getOrReturnCtx(t, s), Bn(s, {
        code: pn.too_small,
        message: o.message,
        inclusive: !0,
        exact: !1,
        minimum: o.value,
        type: "date"
      }), n.dirty()) : o.kind === "max" ? t.data.getTime() > o.value && (s = this._getOrReturnCtx(t, s), Bn(s, {
        code: pn.too_big,
        message: o.message,
        inclusive: !0,
        exact: !1,
        maximum: o.value,
        type: "date"
      }), n.dirty()) : el.assertNever(o);
    return {
      status: n.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new Wre({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, i) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: rs.toString(i)
    });
  }
  max(t, i) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: rs.toString(i)
    });
  }
  get minDate() {
    let t = null;
    for (const i of this._def.checks)
      i.kind === "min" && (t === null || i.value > t) && (t = i.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const i of this._def.checks)
      i.kind === "max" && (t === null || i.value < t) && (t = i.value);
    return t != null ? new Date(t) : null;
  }
}
Wre.create = (e) => new Wre({
  checks: [],
  coerce: (e == null ? void 0 : e.coerce) || !1,
  typeName: js.ZodDate,
  ...xo(e)
});
class wye extends pr {
  _parse(t) {
    if (this._getType(t) !== Jn.symbol) {
      const n = this._getOrReturnCtx(t);
      return Bn(n, {
        code: pn.invalid_type,
        expected: Jn.symbol,
        received: n.parsedType
      }), Ks;
    }
    return H5(t.data);
  }
}
wye.create = (e) => new wye({
  typeName: js.ZodSymbol,
  ...xo(e)
});
class Tye extends pr {
  _parse(t) {
    if (this._getType(t) !== Jn.undefined) {
      const n = this._getOrReturnCtx(t);
      return Bn(n, {
        code: pn.invalid_type,
        expected: Jn.undefined,
        received: n.parsedType
      }), Ks;
    }
    return H5(t.data);
  }
}
Tye.create = (e) => new Tye({
  typeName: js.ZodUndefined,
  ...xo(e)
});
class Rye extends pr {
  _parse(t) {
    if (this._getType(t) !== Jn.null) {
      const n = this._getOrReturnCtx(t);
      return Bn(n, {
        code: pn.invalid_type,
        expected: Jn.null,
        received: n.parsedType
      }), Ks;
    }
    return H5(t.data);
  }
}
Rye.create = (e) => new Rye({
  typeName: js.ZodNull,
  ...xo(e)
});
class C0e extends pr {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return H5(t.data);
  }
}
C0e.create = (e) => new C0e({
  typeName: js.ZodAny,
  ...xo(e)
});
class O0e extends pr {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return H5(t.data);
  }
}
O0e.create = (e) => new O0e({
  typeName: js.ZodUnknown,
  ...xo(e)
});
class GP extends pr {
  _parse(t) {
    const i = this._getOrReturnCtx(t);
    return Bn(i, {
      code: pn.invalid_type,
      expected: Jn.never,
      received: i.parsedType
    }), Ks;
  }
}
GP.create = (e) => new GP({
  typeName: js.ZodNever,
  ...xo(e)
});
class vye extends pr {
  _parse(t) {
    if (this._getType(t) !== Jn.undefined) {
      const n = this._getOrReturnCtx(t);
      return Bn(n, {
        code: pn.invalid_type,
        expected: Jn.void,
        received: n.parsedType
      }), Ks;
    }
    return H5(t.data);
  }
}
vye.create = (e) => new vye({
  typeName: js.ZodVoid,
  ...xo(e)
});
class RN extends pr {
  _parse(t) {
    const { ctx: i, status: n } = this._processInputParams(t), s = this._def;
    if (i.parsedType !== Jn.array)
      return Bn(i, {
        code: pn.invalid_type,
        expected: Jn.array,
        received: i.parsedType
      }), Ks;
    if (s.exactLength !== null) {
      const r = i.data.length > s.exactLength.value, l = i.data.length < s.exactLength.value;
      (r || l) && (Bn(i, {
        code: r ? pn.too_big : pn.too_small,
        minimum: l ? s.exactLength.value : void 0,
        maximum: r ? s.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: s.exactLength.message
      }), n.dirty());
    }
    if (s.minLength !== null && i.data.length < s.minLength.value && (Bn(i, {
      code: pn.too_small,
      minimum: s.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.minLength.message
    }), n.dirty()), s.maxLength !== null && i.data.length > s.maxLength.value && (Bn(i, {
      code: pn.too_big,
      maximum: s.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.maxLength.message
    }), n.dirty()), i.common.async)
      return Promise.all([...i.data].map((r, l) => s.type._parseAsync(new o6(i, r, i.path, l)))).then((r) => uE.mergeArray(n, r));
    const o = [...i.data].map((r, l) => s.type._parseSync(new o6(i, r, i.path, l)));
    return uE.mergeArray(n, o);
  }
  get element() {
    return this._def.type;
  }
  min(t, i) {
    return new RN({
      ...this._def,
      minLength: { value: t, message: rs.toString(i) }
    });
  }
  max(t, i) {
    return new RN({
      ...this._def,
      maxLength: { value: t, message: rs.toString(i) }
    });
  }
  length(t, i) {
    return new RN({
      ...this._def,
      exactLength: { value: t, message: rs.toString(i) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
RN.create = (e, t) => new RN({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: js.ZodArray,
  ...xo(t)
});
function mV(e) {
  if (e instanceof x0) {
    const t = {};
    for (const i in e.shape) {
      const n = e.shape[i];
      t[i] = NP.create(mV(n));
    }
    return new x0({
      ...e._def,
      shape: () => t
    });
  } else return e instanceof RN ? new RN({
    ...e._def,
    type: mV(e.element)
  }) : e instanceof NP ? NP.create(mV(e.unwrap())) : e instanceof wW ? wW.create(mV(e.unwrap())) : e instanceof YF ? YF.create(e.items.map((t) => mV(t))) : e;
}
class x0 extends pr {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), i = el.objectKeys(t);
    return this._cached = { shape: t, keys: i }, this._cached;
  }
  _parse(t) {
    if (this._getType(t) !== Jn.object) {
      const h = this._getOrReturnCtx(t);
      return Bn(h, {
        code: pn.invalid_type,
        expected: Jn.object,
        received: h.parsedType
      }), Ks;
    }
    const { status: n, ctx: s } = this._processInputParams(t), { shape: o, keys: r } = this._getCached(), l = [];
    if (!(this._def.catchall instanceof GP && this._def.unknownKeys === "strip"))
      for (const h in s.data)
        r.includes(h) || l.push(h);
    const c = [];
    for (const h of r) {
      const I = o[h], p = s.data[h];
      c.push({
        key: { status: "valid", value: h },
        value: I._parse(new o6(s, p, s.path, h)),
        alwaysSet: h in s.data
      });
    }
    if (this._def.catchall instanceof GP) {
      const h = this._def.unknownKeys;
      if (h === "passthrough")
        for (const I of l)
          c.push({
            key: { status: "valid", value: I },
            value: { status: "valid", value: s.data[I] }
          });
      else if (h === "strict")
        l.length > 0 && (Bn(s, {
          code: pn.unrecognized_keys,
          keys: l
        }), n.dirty());
      else if (h !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const h = this._def.catchall;
      for (const I of l) {
        const p = s.data[I];
        c.push({
          key: { status: "valid", value: I },
          value: h._parse(
            new o6(s, p, s.path, I)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: I in s.data
        });
      }
    }
    return s.common.async ? Promise.resolve().then(async () => {
      const h = [];
      for (const I of c) {
        const p = await I.key, y = await I.value;
        h.push({
          key: p,
          value: y,
          alwaysSet: I.alwaysSet
        });
      }
      return h;
    }).then((h) => uE.mergeObjectSync(n, h)) : uE.mergeObjectSync(n, c);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return rs.errToObj, new x0({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (i, n) => {
          var o, r;
          const s = ((r = (o = this._def).errorMap) == null ? void 0 : r.call(o, i, n).message) ?? n.defaultError;
          return i.code === "unrecognized_keys" ? {
            message: rs.errToObj(t).message ?? s
          } : {
            message: s
          };
        }
      } : {}
    });
  }
  strip() {
    return new x0({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new x0({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new x0({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new x0({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: js.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, i) {
    return this.augment({ [t]: i });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new x0({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const i = {};
    for (const n of el.objectKeys(t))
      t[n] && this.shape[n] && (i[n] = this.shape[n]);
    return new x0({
      ...this._def,
      shape: () => i
    });
  }
  omit(t) {
    const i = {};
    for (const n of el.objectKeys(this.shape))
      t[n] || (i[n] = this.shape[n]);
    return new x0({
      ...this._def,
      shape: () => i
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return mV(this);
  }
  partial(t) {
    const i = {};
    for (const n of el.objectKeys(this.shape)) {
      const s = this.shape[n];
      t && !t[n] ? i[n] = s : i[n] = s.optional();
    }
    return new x0({
      ...this._def,
      shape: () => i
    });
  }
  required(t) {
    const i = {};
    for (const n of el.objectKeys(this.shape))
      if (t && !t[n])
        i[n] = this.shape[n];
      else {
        let o = this.shape[n];
        for (; o instanceof NP; )
          o = o._def.innerType;
        i[n] = o;
      }
    return new x0({
      ...this._def,
      shape: () => i
    });
  }
  keyof() {
    return xTe(el.objectKeys(this.shape));
  }
}
x0.create = (e, t) => new x0({
  shape: () => e,
  unknownKeys: "strip",
  catchall: GP.create(),
  typeName: js.ZodObject,
  ...xo(t)
});
x0.strictCreate = (e, t) => new x0({
  shape: () => e,
  unknownKeys: "strict",
  catchall: GP.create(),
  typeName: js.ZodObject,
  ...xo(t)
});
x0.lazycreate = (e, t) => new x0({
  shape: e,
  unknownKeys: "strip",
  catchall: GP.create(),
  typeName: js.ZodObject,
  ...xo(t)
});
class Yre extends pr {
  _parse(t) {
    const { ctx: i } = this._processInputParams(t), n = this._def.options;
    function s(o) {
      for (const l of o)
        if (l.result.status === "valid")
          return l.result;
      for (const l of o)
        if (l.result.status === "dirty")
          return i.common.issues.push(...l.ctx.common.issues), l.result;
      const r = o.map((l) => new dL(l.ctx.common.issues));
      return Bn(i, {
        code: pn.invalid_union,
        unionErrors: r
      }), Ks;
    }
    if (i.common.async)
      return Promise.all(n.map(async (o) => {
        const r = {
          ...i,
          common: {
            ...i.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await o._parseAsync({
            data: i.data,
            path: i.path,
            parent: r
          }),
          ctx: r
        };
      })).then(s);
    {
      let o;
      const r = [];
      for (const c of n) {
        const h = {
          ...i,
          common: {
            ...i.common,
            issues: []
          },
          parent: null
        }, I = c._parseSync({
          data: i.data,
          path: i.path,
          parent: h
        });
        if (I.status === "valid")
          return I;
        I.status === "dirty" && !o && (o = { result: I, ctx: h }), h.common.issues.length && r.push(h.common.issues);
      }
      if (o)
        return i.common.issues.push(...o.ctx.common.issues), o.result;
      const l = r.map((c) => new dL(c));
      return Bn(i, {
        code: pn.invalid_union,
        unionErrors: l
      }), Ks;
    }
  }
  get options() {
    return this._def.options;
  }
}
Yre.create = (e, t) => new Yre({
  options: e,
  typeName: js.ZodUnion,
  ...xo(t)
});
function L0e(e, t) {
  const i = q_(e), n = q_(t);
  if (e === t)
    return { valid: !0, data: e };
  if (i === Jn.object && n === Jn.object) {
    const s = el.objectKeys(t), o = el.objectKeys(e).filter((l) => s.indexOf(l) !== -1), r = { ...e, ...t };
    for (const l of o) {
      const c = L0e(e[l], t[l]);
      if (!c.valid)
        return { valid: !1 };
      r[l] = c.data;
    }
    return { valid: !0, data: r };
  } else if (i === Jn.array && n === Jn.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const s = [];
    for (let o = 0; o < e.length; o++) {
      const r = e[o], l = t[o], c = L0e(r, l);
      if (!c.valid)
        return { valid: !1 };
      s.push(c.data);
    }
    return { valid: !0, data: s };
  } else return i === Jn.date && n === Jn.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class qre extends pr {
  _parse(t) {
    const { status: i, ctx: n } = this._processInputParams(t), s = (o, r) => {
      if (yye(o) || yye(r))
        return Ks;
      const l = L0e(o.value, r.value);
      return l.valid ? ((Eye(o) || Eye(r)) && i.dirty(), { status: i.value, value: l.data }) : (Bn(n, {
        code: pn.invalid_intersection_types
      }), Ks);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([o, r]) => s(o, r)) : s(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
qre.create = (e, t, i) => new qre({
  left: e,
  right: t,
  typeName: js.ZodIntersection,
  ...xo(i)
});
class YF extends pr {
  _parse(t) {
    const { status: i, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Jn.array)
      return Bn(n, {
        code: pn.invalid_type,
        expected: Jn.array,
        received: n.parsedType
      }), Ks;
    if (n.data.length < this._def.items.length)
      return Bn(n, {
        code: pn.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), Ks;
    !this._def.rest && n.data.length > this._def.items.length && (Bn(n, {
      code: pn.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), i.dirty());
    const o = [...n.data].map((r, l) => {
      const c = this._def.items[l] || this._def.rest;
      return c ? c._parse(new o6(n, r, n.path, l)) : null;
    }).filter((r) => !!r);
    return n.common.async ? Promise.all(o).then((r) => uE.mergeArray(i, r)) : uE.mergeArray(i, o);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new YF({
      ...this._def,
      rest: t
    });
  }
}
YF.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new YF({
    items: e,
    typeName: js.ZodTuple,
    rest: null,
    ...xo(t)
  });
};
class $re extends pr {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: i, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Jn.object)
      return Bn(n, {
        code: pn.invalid_type,
        expected: Jn.object,
        received: n.parsedType
      }), Ks;
    const s = [], o = this._def.keyType, r = this._def.valueType;
    for (const l in n.data)
      s.push({
        key: o._parse(new o6(n, l, n.path, l)),
        value: r._parse(new o6(n, n.data[l], n.path, l)),
        alwaysSet: l in n.data
      });
    return n.common.async ? uE.mergeObjectAsync(i, s) : uE.mergeObjectSync(i, s);
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, i, n) {
    return i instanceof pr ? new $re({
      keyType: t,
      valueType: i,
      typeName: js.ZodRecord,
      ...xo(n)
    }) : new $re({
      keyType: TO.create(),
      valueType: t,
      typeName: js.ZodRecord,
      ...xo(i)
    });
  }
}
class Aye extends pr {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: i, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Jn.map)
      return Bn(n, {
        code: pn.invalid_type,
        expected: Jn.map,
        received: n.parsedType
      }), Ks;
    const s = this._def.keyType, o = this._def.valueType, r = [...n.data.entries()].map(([l, c], h) => ({
      key: s._parse(new o6(n, l, n.path, [h, "key"])),
      value: o._parse(new o6(n, c, n.path, [h, "value"]))
    }));
    if (n.common.async) {
      const l = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const c of r) {
          const h = await c.key, I = await c.value;
          if (h.status === "aborted" || I.status === "aborted")
            return Ks;
          (h.status === "dirty" || I.status === "dirty") && i.dirty(), l.set(h.value, I.value);
        }
        return { status: i.value, value: l };
      });
    } else {
      const l = /* @__PURE__ */ new Map();
      for (const c of r) {
        const h = c.key, I = c.value;
        if (h.status === "aborted" || I.status === "aborted")
          return Ks;
        (h.status === "dirty" || I.status === "dirty") && i.dirty(), l.set(h.value, I.value);
      }
      return { status: i.value, value: l };
    }
  }
}
Aye.create = (e, t, i) => new Aye({
  valueType: t,
  keyType: e,
  typeName: js.ZodMap,
  ...xo(i)
});
class sX extends pr {
  _parse(t) {
    const { status: i, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Jn.set)
      return Bn(n, {
        code: pn.invalid_type,
        expected: Jn.set,
        received: n.parsedType
      }), Ks;
    const s = this._def;
    s.minSize !== null && n.data.size < s.minSize.value && (Bn(n, {
      code: pn.too_small,
      minimum: s.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.minSize.message
    }), i.dirty()), s.maxSize !== null && n.data.size > s.maxSize.value && (Bn(n, {
      code: pn.too_big,
      maximum: s.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.maxSize.message
    }), i.dirty());
    const o = this._def.valueType;
    function r(c) {
      const h = /* @__PURE__ */ new Set();
      for (const I of c) {
        if (I.status === "aborted")
          return Ks;
        I.status === "dirty" && i.dirty(), h.add(I.value);
      }
      return { status: i.value, value: h };
    }
    const l = [...n.data.values()].map((c, h) => o._parse(new o6(n, c, n.path, h)));
    return n.common.async ? Promise.all(l).then((c) => r(c)) : r(l);
  }
  min(t, i) {
    return new sX({
      ...this._def,
      minSize: { value: t, message: rs.toString(i) }
    });
  }
  max(t, i) {
    return new sX({
      ...this._def,
      maxSize: { value: t, message: rs.toString(i) }
    });
  }
  size(t, i) {
    return this.min(t, i).max(t, i);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
sX.create = (e, t) => new sX({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: js.ZodSet,
  ...xo(t)
});
class Sye extends pr {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: i } = this._processInputParams(t);
    return this._def.getter()._parse({ data: i.data, path: i.path, parent: i });
  }
}
Sye.create = (e, t) => new Sye({
  getter: e,
  typeName: js.ZodLazy,
  ...xo(t)
});
class _0e extends pr {
  _parse(t) {
    if (t.data !== this._def.value) {
      const i = this._getOrReturnCtx(t);
      return Bn(i, {
        received: i.data,
        code: pn.invalid_literal,
        expected: this._def.value
      }), Ks;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
_0e.create = (e, t) => new _0e({
  value: e,
  typeName: js.ZodLiteral,
  ...xo(t)
});
function xTe(e, t) {
  return new EW({
    values: e,
    typeName: js.ZodEnum,
    ...xo(t)
  });
}
class EW extends pr {
  _parse(t) {
    if (typeof t.data != "string") {
      const i = this._getOrReturnCtx(t), n = this._def.values;
      return Bn(i, {
        expected: el.joinValues(n),
        received: i.parsedType,
        code: pn.invalid_type
      }), Ks;
    }
    if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(t.data)) {
      const i = this._getOrReturnCtx(t), n = this._def.values;
      return Bn(i, {
        received: i.data,
        code: pn.invalid_enum_value,
        options: n
      }), Ks;
    }
    return H5(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const i of this._def.values)
      t[i] = i;
    return t;
  }
  get Values() {
    const t = {};
    for (const i of this._def.values)
      t[i] = i;
    return t;
  }
  get Enum() {
    const t = {};
    for (const i of this._def.values)
      t[i] = i;
    return t;
  }
  extract(t, i = this._def) {
    return EW.create(t, {
      ...this._def,
      ...i
    });
  }
  exclude(t, i = this._def) {
    return EW.create(this.options.filter((n) => !t.includes(n)), {
      ...this._def,
      ...i
    });
  }
}
EW.create = xTe;
class x0e extends pr {
  _parse(t) {
    const i = el.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(t);
    if (n.parsedType !== Jn.string && n.parsedType !== Jn.number) {
      const s = el.objectValues(i);
      return Bn(n, {
        expected: el.joinValues(s),
        received: n.parsedType,
        code: pn.invalid_type
      }), Ks;
    }
    if (this._cache || (this._cache = new Set(el.getValidEnumValues(this._def.values))), !this._cache.has(t.data)) {
      const s = el.objectValues(i);
      return Bn(n, {
        received: n.data,
        code: pn.invalid_enum_value,
        options: s
      }), Ks;
    }
    return H5(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
x0e.create = (e, t) => new x0e({
  values: e,
  typeName: js.ZodNativeEnum,
  ...xo(t)
});
class Kre extends pr {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: i } = this._processInputParams(t);
    if (i.parsedType !== Jn.promise && i.common.async === !1)
      return Bn(i, {
        code: pn.invalid_type,
        expected: Jn.promise,
        received: i.parsedType
      }), Ks;
    const n = i.parsedType === Jn.promise ? i.data : Promise.resolve(i.data);
    return H5(n.then((s) => this._def.type.parseAsync(s, {
      path: i.path,
      errorMap: i.common.contextualErrorMap
    })));
  }
}
Kre.create = (e, t) => new Kre({
  type: e,
  typeName: js.ZodPromise,
  ...xo(t)
});
class gW extends pr {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === js.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: i, ctx: n } = this._processInputParams(t), s = this._def.effect || null, o = {
      addIssue: (r) => {
        Bn(n, r), r.fatal ? i.abort() : i.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (o.addIssue = o.addIssue.bind(o), s.type === "preprocess") {
      const r = s.transform(n.data, o);
      if (n.common.async)
        return Promise.resolve(r).then(async (l) => {
          if (i.value === "aborted")
            return Ks;
          const c = await this._def.schema._parseAsync({
            data: l,
            path: n.path,
            parent: n
          });
          return c.status === "aborted" ? Ks : c.status === "dirty" || i.value === "dirty" ? XZ(c.value) : c;
        });
      {
        if (i.value === "aborted")
          return Ks;
        const l = this._def.schema._parseSync({
          data: r,
          path: n.path,
          parent: n
        });
        return l.status === "aborted" ? Ks : l.status === "dirty" || i.value === "dirty" ? XZ(l.value) : l;
      }
    }
    if (s.type === "refinement") {
      const r = (l) => {
        const c = s.refinement(l, o);
        if (n.common.async)
          return Promise.resolve(c);
        if (c instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return l;
      };
      if (n.common.async === !1) {
        const l = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return l.status === "aborted" ? Ks : (l.status === "dirty" && i.dirty(), r(l.value), { status: i.value, value: l.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((l) => l.status === "aborted" ? Ks : (l.status === "dirty" && i.dirty(), r(l.value).then(() => ({ status: i.value, value: l.value }))));
    }
    if (s.type === "transform")
      if (n.common.async === !1) {
        const r = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!mW(r))
          return Ks;
        const l = s.transform(r.value, o);
        if (l instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: i.value, value: l };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((r) => mW(r) ? Promise.resolve(s.transform(r.value, o)).then((l) => ({
          status: i.value,
          value: l
        })) : Ks);
    el.assertNever(s);
  }
}
gW.create = (e, t, i) => new gW({
  schema: e,
  typeName: js.ZodEffects,
  effect: t,
  ...xo(i)
});
gW.createWithPreprocess = (e, t, i) => new gW({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: js.ZodEffects,
  ...xo(i)
});
class NP extends pr {
  _parse(t) {
    return this._getType(t) === Jn.undefined ? H5(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
NP.create = (e, t) => new NP({
  innerType: e,
  typeName: js.ZodOptional,
  ...xo(t)
});
class wW extends pr {
  _parse(t) {
    return this._getType(t) === Jn.null ? H5(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
wW.create = (e, t) => new wW({
  innerType: e,
  typeName: js.ZodNullable,
  ...xo(t)
});
class P0e extends pr {
  _parse(t) {
    const { ctx: i } = this._processInputParams(t);
    let n = i.data;
    return i.parsedType === Jn.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: i.path,
      parent: i
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
P0e.create = (e, t) => new P0e({
  innerType: e,
  typeName: js.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...xo(t)
});
class M0e extends pr {
  _parse(t) {
    const { ctx: i } = this._processInputParams(t), n = {
      ...i,
      common: {
        ...i.common,
        issues: []
      }
    }, s = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return jre(s) ? s.then((o) => ({
      status: "valid",
      value: o.status === "valid" ? o.value : this._def.catchValue({
        get error() {
          return new dL(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new dL(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
M0e.create = (e, t) => new M0e({
  innerType: e,
  typeName: js.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...xo(t)
});
class bye extends pr {
  _parse(t) {
    if (this._getType(t) !== Jn.nan) {
      const n = this._getOrReturnCtx(t);
      return Bn(n, {
        code: pn.invalid_type,
        expected: Jn.nan,
        received: n.parsedType
      }), Ks;
    }
    return { status: "valid", value: t.data };
  }
}
bye.create = (e) => new bye({
  typeName: js.ZodNaN,
  ...xo(e)
});
class XLe extends pr {
  _parse(t) {
    const { ctx: i } = this._processInputParams(t), n = i.data;
    return this._def.type._parse({
      data: n,
      path: i.path,
      parent: i
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class wpe extends pr {
  _parse(t) {
    const { status: i, ctx: n } = this._processInputParams(t);
    if (n.common.async)
      return (async () => {
        const o = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? Ks : o.status === "dirty" ? (i.dirty(), XZ(o.value)) : this._def.out._parseAsync({
          data: o.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const s = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return s.status === "aborted" ? Ks : s.status === "dirty" ? (i.dirty(), {
        status: "dirty",
        value: s.value
      }) : this._def.out._parseSync({
        data: s.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(t, i) {
    return new wpe({
      in: t,
      out: i,
      typeName: js.ZodPipeline
    });
  }
}
class U0e extends pr {
  _parse(t) {
    const i = this._def.innerType._parse(t), n = (s) => (mW(s) && (s.value = Object.freeze(s.value)), s);
    return jre(i) ? i.then((s) => n(s)) : n(i);
  }
  unwrap() {
    return this._def.innerType;
  }
}
U0e.create = (e, t) => new U0e({
  innerType: e,
  typeName: js.ZodReadonly,
  ...xo(t)
});
var js;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(js || (js = {}));
const Le = TO.create, Ft = yW.create, ts = D0e.create, XW = C0e.create, sB = O0e.create;
GP.create;
const Ri = RN.create, ti = x0.create, fh = Yre.create;
qre.create;
YF.create;
const Kp = $re.create, hE = _0e.create, GA = EW.create, ki = x0e.create;
Kre.create;
NP.create;
const e7e = wW.create, t7e = GA([
  "project_status_does_not_allow_charges",
  "project_dates_do_not_allow_charges",
  "task_is_not_chargeable",
  "task_passed_active_end_date",
  "transaction_control_does_not_allow_charges"
]), i7e = ti({
  project_number: Le(),
  project_name: Le(),
  project_type_class_code: Le().nullable(),
  customer_name: Le().nullable(),
  chargeable: ts(),
  unchargeable_reason: t7e.nullable()
}).transform(Ii);
ti({
  results: Ri(i7e)
});
function em(e) {
  return ti({
    count: Ft().int(),
    next: Le().nullable(),
    previous: Le().nullable(),
    results: Ri(e)
  }).strict().transform(Ii);
}
var B0e;
(function(e) {
  e.AUSTRALIA = "AUSTRALIA", e.CANADA = "CANADA", e.CHINA = "CHINA", e.DENMARK = "DENMARK", e.FINLAND = "FINLAND", e.FRANCE = "FRANCE", e.GERMANY = "GERMANY", e.HONG_KONG = "HONG_KONG", e.HUNGARY = "HUNGARY", e.ICELAND = "ICELAND", e.IRELAND = "IRELAND", e.JAPAN = "JAPAN", e.NETHERLANDS = "NETHERLANDS", e.NEW_ZEALAND = "NEW_ZEALAND", e.NORWAY = "NORWAY", e.SAUDI_ARABIA = "SAUDI_ARABIA", e.SINGAPORE = "SINGAPORE", e.SPAIN = "SPAIN", e.SWEDEN = "SWEDEN", e.UNITED_ARAB_EMIRATES = "UNITED_ARAB_EMIRATES", e.UNITED_KINGDOM = "UNITED_KINGDOM", e.UNITED_STATES = "UNITED_STATES", e.OTHER = "OTHER";
})(B0e || (B0e = {}));
var F0e;
(function(e) {
  e.BREEAM = "BREEAM", e.SKOK = "SKOK", e.CANTEEN = "CANTEEN", e.JCT = "JCT", e.FIDIC_SILVER_BOOK = "FIDIC_SILVER_BOOK", e.FIDIC_PINK_BOOK = "FIDIC_PINK_BOOK", e.FIDIC_RED_BOOK = "FIDIC_RED_BOOK", e.FIDIC_YELLOW_BOOK_1ST_EDITION_1999 = "FIDIC_YELLOW_BOOK_1ST_EDITION_1999", e.FIDIC_YELLOW_BOOK_2017 = "FIDIC_YELLOW_BOOK_2017";
})(F0e || (F0e = {}));
var Tz;
(function(e) {
  e.OFFICE_BUILDING = "OFFICE_BUILDING", e.RESIDENTIAL_BUILDING = "RESIDENTIAL_BUILDING", e.HOSPITAL = "HOSPITAL", e.DATA_CENTER = "DATA_CENTER", e.OTHER_BUILDING = "OTHER_BUILDING", e.BRIDGE = "BRIDGE", e.ROAD = "ROAD", e.HOTEL = "HOTEL", e.OTHER_INFRASTRUCTURE = "OTHER_INFRASTRUCTURE";
})(Tz || (Tz = {}));
Tz.OTHER_INFRASTRUCTURE, Tz.ROAD, Tz.BRIDGE;
var H0e;
(function(e) {
  e.ORGANIZATION = "ORGANIZATION", e.PROJECT = "PROJECT";
})(H0e || (H0e = {}));
var Zre;
(function(e) {
  e.ADMIN = "ADMIN", e.USER = "USER";
})(Zre || (Zre = {}));
var wr;
(function(e) {
  e.TENDER_DOCUMENTS = "tender-documents", e.OFFER = "offer", e.BID_REVIEW = "bid-review", e.TENANT_SPECIFICATION = "tenant-specification", e.TENANT_REQUIREMENTS = "tenant-requirements", e.DUE_DILIGENCE = "due-diligence", e.SITE_DUE_DILIGENCE = "site-due-diligence", e.MANAGEMENT_OPERATIONS_MAINTENANCE = "management-operations-maintenance", e.PLANT_ROOM = "plant-room", e.CEILING_PLAN = "ceiling-plan", e.FLOOR_PLAN = "floor-plan", e.SPACE_ANALYSIS = "space-analysis", e.PARKING = "parking", e.REPORTS = "reports", e.REPORT_GENERATION = "report-generation", e.STRUCTURAL = "structural", e.CEILING_GRID = "ceiling-grid", e.LOAD_CALCULATION = "load-calculation", e.MEETING_SECRETARY = "meeting-secretary", e.SCHEDULE_CHECK = "schedule-check", e.CONTRACT_REVIEW = "contract-review", e.SOLUTION_VIEWER = "solution-viewer", e.LUMINAIRE_SCHEDULE = "luminaire-schedule", e.RFP_RFQ_REVIEW = "rfp-rfq-review", e.DESIGN_PACKAGE_REVIEW = "design-package-review", e.QA_AGENT = "qa-agent", e.CODE_RESEARCH_AGENT = "code-research-agent", e.VERSION_COMPARE = "version-compare", e.WATER_PROCESS_SYSTEMS_AGENT = "water-process-systems-agent", e.GEOTECHNICAL_EXTRACTION_AGENT = "geotechnical-extraction-agent", e.ENVIRONMENT_REPORT_AGENT = "environment-report-agent", e.LIGHTNING_DESIGNER = "lightning-designer";
})(wr || (wr = {}));
var Uo;
(function(e) {
  e.TENDER_DOCUMENTS = "TENDER_DOCUMENTS", e.OFFER = "OFFER", e.BID_REVIEW = "BID_REVIEW", e.TENANT_SPECIFICATION = "TENANT_SPECIFICATION", e.TENANT_REQUIREMENTS = "TENANT_REQUIREMENTS", e.DUE_DILIGENCE = "DUE_DILIGENCE", e.SITE_DUE_DILIGENCE = "SITE_DUE_DILIGENCE", e.MANAGEMENT_OPERATIONS_MAINTENANCE = "MANAGEMENT_OPERATIONS_MAINTENANCE", e.PLANT_ROOM = "PLANT_ROOM", e.CEILING_PLAN = "CEILING_PLAN", e.FLOOR_PLAN = "FLOOR_PLAN", e.SPACE_ANALYSIS = "SPACE_ANALYSIS", e.PARKING = "PARKING", e.REPORTS = "REPORTS", e.REPORT_GENERATION = "REPORT_GENERATION", e.STRUCTURAL = "STRUCTURAL", e.CEILING_GRID = "CEILING_GRID", e.LOAD_CALCULATION = "LOAD_CALCULATION", e.MEETING_SECRETARY = "MEETING_SECRETARY", e.SOLUTION_VIEWER = "SOLUTION_VIEWER", e.DATA_CENTER = "DATA_CENTER", e.WASTEWATER_TREATMENT = "WASTEWATER_TREATMENT", e.SCHEDULE_CHECK = "SCHEDULE_CHECK", e.CONTRACT_REVIEW = "CONTRACT_REVIEW", e.LUMINAIRE_SCHEDULE = "LUMINAIRE_SCHEDULE", e.RFP_RFQ_REVIEW = "RFP_RFQ_REVIEW", e.DESIGN_PACKAGE_REVIEW = "DESIGN_PACKAGE_REVIEW", e.QA_AGENT = "QA_AGENT", e.CODE_RESEARCH_AGENT = "CODE_RESEARCH_AGENT", e.VERSION_COMPARE = "VERSION_COMPARE", e.WATER_PROCESS_SYSTEMS_AGENT = "WATER_PROCESS_SYSTEMS_AGENT", e.GEOTECHNICAL_EXTRACTION_AGENT = "GEOTECHNICAL_EXTRACTION_AGENT", e.ENVIRONMENT_REPORT_AGENT = "ENVIRONMENT_REPORT_AGENT", e.LIGHTNING_DESIGNER = "LIGHTNING_DESIGNER";
})(Uo || (Uo = {}));
var fr;
(function(e) {
  e.USE_TENDER_DOCUMENTS_SERVICE = "use_tender_documents_service", e.USE_OFFER_SERVICE = "use_offer_service", e.USE_TENANT_SPEC_SERVICE = "use_tenant_spec_service", e.USE_TENANT_REQ_SERVICE = "use_tenant_req_service", e.USE_DUE_DILIGENCE_SERVICE = "use_due_diligence_service", e.USE_SITE_DUE_DILIGENCE_SERVICE = "use_site_due_diligence_service", e.USE_MANAGE_OPERATE_SERVICE = "use_manage_operate_service", e.USE_PLANT_ROOM_SERVICE = "use_plant_room_service", e.USE_CEILING_PLAN_SERVICE = "use_ceiling_plan_service", e.USE_FLOOR_PLAN_SERVICE = "use_floor_plan_service", e.USE_SPACE_ANALYSIS_SERVICE = "use_space_analysis_service", e.USE_PARKING_SERVICE = "use_parking_service", e.USE_REPORTS_SERVICE = "use_reports_service", e.USE_REPORT_GENERATION_SERVICE = "use_report_generation_service", e.USE_STRUCTURAL_SERVICE = "use_structural_service", e.USE_CEILING_GRID_SERVICE = "use_ceiling_grid_service", e.USE_LOAD_CALCULATION_SERVICE = "use_load_calculation_service", e.USE_MEETING_SECRETARY_SERVICE = "use_meeting_secretary_service", e.USE_SCHEDULE_CHECK_SERVICE = "use_schedule_check_service", e.USE_CONTRACT_REVIEW_SERVICE = "use_contract_review_service", e.USE_SOLUTION_VIEWER_SERVICE = "use_solution_viewer_service", e.USE_LUMINAIRE_SCHEDULE_SERVICE = "use_luminaire_schedule_service", e.USE_RFP_RFQ_REVIEW_SERVICE = "use_rfp_rfq_review_service", e.USE_DESIGN_PACKAGE_REVIEW_SERVICE = "use_design_package_review_service", e.USE_QA_AGENT_SERVICE = "use_qa_agent_service", e.USE_CODE_RESEARCH_AGENT_SERVICE = "use_code_research_agent_service", e.USE_VERSION_COMPARE_SERVICE = "use_version_compare_service", e.USE_WATER_PROCESS_SYSTEMS_AGENT_SERVICE = "use_water_process_systems_agent_service", e.USE_GEOTECHNICAL_EXTRACTION_AGENT_SERVICE = "use_geotechnical_extraction_agent_service", e.USE_ENVIRONMENT_REPORT_AGENT_SERVICE = "use_environment_report_agent_service", e.USE_LIGHTNING_DESIGNER_SERVICE = "use_lightning_designer_service";
})(fr || (fr = {}));
var Eb;
(function(e) {
  e.INSIGHT = "INSIGHT", e.LAYOUT_OPTIMIZATION = "LAYOUT_OPTIMIZATION", e.STRUCTURAL_ENGINEERING = "STRUCTURAL_ENGINEERING", e.BUILDING_PACKAGE = "BUILDING_PACKAGE", e.MEETING_SECRETARY = "MEETING_SECRETARY", e.SCHEDULE_CHECK = "SCHEDULE_CHECK", e.LUMINAIRE_SCHEDULE = "LUMINAIRE_SCHEDULE", e.REPORT_GENERATION = "REPORT_GENERATION";
})(Eb || (Eb = {}));
Uo.TENDER_DOCUMENTS + "", Uo.OFFER + "", Uo.BID_REVIEW + "", Uo.TENANT_SPECIFICATION + "", Uo.TENANT_REQUIREMENTS + "", Uo.DUE_DILIGENCE + "", Uo.SITE_DUE_DILIGENCE + "", Uo.MANAGEMENT_OPERATIONS_MAINTENANCE + "", Uo.PLANT_ROOM + "", Uo.CEILING_PLAN + "", Uo.FLOOR_PLAN + "", Uo.SPACE_ANALYSIS + "", Uo.PARKING + "", Uo.REPORTS + "", Uo.REPORT_GENERATION + "", Uo.STRUCTURAL + "", Uo.CEILING_GRID + "", Uo.LOAD_CALCULATION + "", Uo.MEETING_SECRETARY + "", Uo.SOLUTION_VIEWER + "", Uo.DATA_CENTER + "", Uo.WASTEWATER_TREATMENT + "", Uo.SCHEDULE_CHECK + "", Uo.CONTRACT_REVIEW + "", Uo.LUMINAIRE_SCHEDULE + "", Uo.RFP_RFQ_REVIEW + "", Uo.DESIGN_PACKAGE_REVIEW + "", Uo.QA_AGENT + "", Uo.CODE_RESEARCH_AGENT + "", Uo.VERSION_COMPARE + "", Uo.WATER_PROCESS_SYSTEMS_AGENT + "", Uo.GEOTECHNICAL_EXTRACTION_AGENT + "", Uo.ENVIRONMENT_REPORT_AGENT + "", Uo.LIGHTNING_DESIGNER + "";
wr.TENDER_DOCUMENTS + "", wr.OFFER + "", wr.BID_REVIEW + "", wr.TENANT_SPECIFICATION + "", wr.TENANT_REQUIREMENTS + "", wr.DUE_DILIGENCE + "", wr.SITE_DUE_DILIGENCE + "", wr.MANAGEMENT_OPERATIONS_MAINTENANCE + "", wr.PLANT_ROOM + "", wr.CEILING_PLAN + "", wr.FLOOR_PLAN + "", wr.SPACE_ANALYSIS + "", wr.PARKING + "", wr.REPORTS + "", wr.REPORT_GENERATION + "", wr.STRUCTURAL + "", wr.CEILING_GRID + "", wr.LOAD_CALCULATION + "", wr.MEETING_SECRETARY + "", wr.SOLUTION_VIEWER + "", wr.SCHEDULE_CHECK + "", wr.CONTRACT_REVIEW + "", wr.LUMINAIRE_SCHEDULE + "", wr.RFP_RFQ_REVIEW + "", wr.DESIGN_PACKAGE_REVIEW + "", wr.QA_AGENT + "", wr.CODE_RESEARCH_AGENT + "", wr.VERSION_COMPARE + "", wr.WATER_PROCESS_SYSTEMS_AGENT + "", wr.GEOTECHNICAL_EXTRACTION_AGENT + "", wr.ENVIRONMENT_REPORT_AGENT + "", wr.LIGHTNING_DESIGNER + "";
fr.USE_TENDER_DOCUMENTS_SERVICE + "", fr.USE_OFFER_SERVICE + "", fr.USE_TENANT_SPEC_SERVICE + "", fr.USE_TENANT_REQ_SERVICE + "", fr.USE_DUE_DILIGENCE_SERVICE + "", fr.USE_SITE_DUE_DILIGENCE_SERVICE + "", fr.USE_MANAGE_OPERATE_SERVICE + "", fr.USE_PLANT_ROOM_SERVICE + "", fr.USE_CEILING_PLAN_SERVICE + "", fr.USE_FLOOR_PLAN_SERVICE + "", fr.USE_SPACE_ANALYSIS_SERVICE + "", fr.USE_PARKING_SERVICE + "", fr.USE_REPORTS_SERVICE + "", fr.USE_REPORT_GENERATION_SERVICE + "", fr.USE_STRUCTURAL_SERVICE + "", fr.USE_CEILING_GRID_SERVICE + "", fr.USE_LOAD_CALCULATION_SERVICE + "", fr.USE_MEETING_SECRETARY_SERVICE + "", fr.USE_SCHEDULE_CHECK_SERVICE + "", fr.USE_CONTRACT_REVIEW_SERVICE + "", fr.USE_SOLUTION_VIEWER_SERVICE + "", fr.USE_LUMINAIRE_SCHEDULE_SERVICE + "", fr.USE_RFP_RFQ_REVIEW_SERVICE + "", fr.USE_DESIGN_PACKAGE_REVIEW_SERVICE + "", fr.USE_QA_AGENT_SERVICE + "", fr.USE_CODE_RESEARCH_AGENT_SERVICE + "", fr.USE_VERSION_COMPARE_SERVICE + "", fr.USE_WATER_PROCESS_SYSTEMS_AGENT_SERVICE + "", fr.USE_GEOTECHNICAL_EXTRACTION_AGENT_SERVICE + "", fr.USE_ENVIRONMENT_REPORT_AGENT_SERVICE + "", fr.USE_LIGHTNING_DESIGNER_SERVICE + "";
Eb.INSIGHT + "", Eb.LAYOUT_OPTIMIZATION + "", Eb.STRUCTURAL_ENGINEERING + "", Eb.BUILDING_PACKAGE + "", Eb.MEETING_SECRETARY + "", Eb.SCHEDULE_CHECK + "", Eb.REPORT_GENERATION + "", Eb.LUMINAIRE_SCHEDULE + "";
var Nye;
(function(e) {
  e.SOLUTION_VIEWER = "SOLUTION_VIEWER";
})(Nye || (Nye = {}));
var Dye;
(function(e) {
  e.QA_AGENT = "QA_AGENT";
})(Dye || (Dye = {}));
var wJ;
(function(e) {
  e.BUILDING_PACKAGE = "BUILDING_PACKAGE", e.DOCUMENT_PACKAGE = "DOCUMENT_PACKAGE", e.LAYOUT_OPTIMIZATION = "LAYOUT_OPTIMIZATION";
})(wJ || (wJ = {}));
wJ.BUILDING_PACKAGE + "", wJ.DOCUMENT_PACKAGE + "", wJ.LAYOUT_OPTIMIZATION + "";
const n7e = ti({
  id: Ft().int(),
  name: Le(),
  role: ki(Zre),
  services: Ri(ki(fr))
}).strict().transform(Ii), PTe = ti({
  id: Le().uuid(),
  first_name: Le(),
  last_name: Le(),
  email: Le(),
  is_superuser: ts(),
  organization_id: Le().uuid().nullable(),
  organization_name: Le().nullable(),
  is_org_admin: ts(),
  project_access: Ri(n7e),
  terms_and_conditions_accepted: ts(),
  terms_and_conditions_accepted_at: Le().datetime().nullable(),
  data_processing_accepted: ts(),
  data_processing_accepted_at: Le().datetime().nullable(),
  sso_country: Le().nullable(),
  sso_business_line: Le().nullable(),
  solution_viewer_access: ts(),
  solution_viewer_datacenter_access: ts(),
  solution_viewer_water_treatment_access: ts(),
  debug_mode_access: ts(),
  // Null until the user first logs in.
  last_login: Le().datetime({ offset: !0 }).nullable(),
  aecom_employee_id: Le().nullable()
}).strict().transform(Ii);
ti({
  id: Le().uuid()
}).strict().transform(Ii);
em(PTe);
ti({
  page: fh([Ft().int(), hE("all")]),
  page_size: Ft().int().nullish(),
  search: Le().nullish(),
  org_ids: Ri(Le().uuid()).nullish(),
  project_ids: Ri(Ft().int()).nullish()
}).strict().transform(Ii);
ti({
  count: Ft().int()
}).strict().transform(Ii);
var oX;
(function(e) {
  e.NB = "NB", e.NN = "NN", e.EN = "EN", e.SV = "SV", e.VI = "VI", e.JA = "JA", e.DE = "DE", e.ES = "ES", e.FR = "FR", e.CA = "CA", e.ZH = "ZH";
})(oX || (oX = {}));
const uie = ki(oX);
var Qre;
(function(e) {
  e.PUBLIC_REAL_ESTATE_OWNER = "PUBLIC_REAL_ESTATE_OWNER", e.PRIVATE_REAL_ESTATE_OWNER = "PRIVATE_REAL_ESTATE_OWNER", e.CONTRACTOR = "CONTRACTOR", e.SUBCONTRACTOR = "SUBCONTRACTOR", e.CONSULTANT = "CONSULTANT";
})(Qre || (Qre = {}));
const s7e = ki(Qre);
var G0e;
(function(e) {
  e.ADMIN = "ADMIN", e.USER = "USER";
})(G0e || (G0e = {}));
var Tr;
(function(e) {
  e.TENDER_DOCUMENTS = "TENDER_DOCUMENTS", e.OFFER = "OFFER", e.TENANT_SPECIFICATION = "TENANT_SPECIFICATION", e.TENANT_REQUIREMENTS = "TENANT_REQUIREMENTS", e.DUE_DILIGENCE = "DUE_DILIGENCE", e.SITE_DUE_DILIGENCE = "SITE_DUE_DILIGENCE", e.MANAGEMENT_OPERATIONS_MAINTENANCE = "MANAGEMENT_OPERATIONS_MAINTENANCE", e.PLANT_ROOM = "PLANT_ROOM", e.CEILING_PLAN = "CEILING_PLAN", e.FLOOR_PLAN = "FLOOR_PLAN", e.SPACE_ANALYSIS = "SPACE_ANALYSIS", e.PARKING = "PARKING", e.REPORTS = "REPORTS", e.REPORT_GENERATION = "REPORT_GENERATION", e.STRUCTURAL = "STRUCTURAL", e.CEILING_GRID = "CEILING_GRID", e.LOAD_CALCULATION = "LOAD_CALCULATION", e.MEETING_SECRETARY = "MEETING_SECRETARY", e.SCHEDULE_CHECK = "SCHEDULE_CHECK", e.SOLUTION_VIEWER = "SOLUTION_VIEWER", e.CONTRACT_REVIEW = "CONTRACT_REVIEW", e.LUMINAIRE_SCHEDULE = "LUMINAIRE_SCHEDULE", e.RFP_RFQ_REVIEW = "RFP_RFQ_REVIEW", e.DESIGN_PACKAGE_REVIEW = "DESIGN_PACKAGE_REVIEW", e.QA_AGENT = "QA_AGENT", e.CODE_RESEARCH_AGENT = "CODE_RESEARCH_AGENT", e.VERSION_COMPARE = "VERSION_COMPARE", e.WATER_PROCESS_SYSTEMS_AGENT = "WATER_PROCESS_SYSTEMS_AGENT", e.GEOTECHNICAL_EXTRACTION_AGENT = "GEOTECHNICAL_EXTRACTION_AGENT", e.ENVIRONMENT_REPORT_AGENT = "ENVIRONMENT_REPORT_AGENT", e.LIGHTNING_DESIGNER = "LIGHTNING_DESIGNER";
})(Tr || (Tr = {}));
Tr.TENDER_DOCUMENTS + "", Tr.OFFER + "", Tr.TENANT_SPECIFICATION + "", Tr.TENANT_REQUIREMENTS + "", Tr.DUE_DILIGENCE + "", Tr.SITE_DUE_DILIGENCE + "", Tr.MANAGEMENT_OPERATIONS_MAINTENANCE + "", Tr.PLANT_ROOM + "", Tr.CEILING_PLAN + "", Tr.FLOOR_PLAN + "", Tr.SPACE_ANALYSIS + "", Tr.PARKING + "", Tr.REPORTS + "", Tr.REPORT_GENERATION + "", Tr.STRUCTURAL + "", Tr.CEILING_GRID + "", Tr.LOAD_CALCULATION + "", Tr.MEETING_SECRETARY + "", Tr.SCHEDULE_CHECK + "", Tr.SOLUTION_VIEWER + "", Tr.CONTRACT_REVIEW + "", Tr.LUMINAIRE_SCHEDULE + "", Tr.RFP_RFQ_REVIEW + "", Tr.DESIGN_PACKAGE_REVIEW + "", Tr.QA_AGENT + "", Tr.CODE_RESEARCH_AGENT + "", Tr.VERSION_COMPARE + "", Tr.WATER_PROCESS_SYSTEMS_AGENT + "", Tr.GEOTECHNICAL_EXTRACTION_AGENT + "", Tr.ENVIRONMENT_REPORT_AGENT + "", Tr.LIGHTNING_DESIGNER + "";
const Tpe = ti({
  id: Le().uuid(),
  name: Le().min(1),
  type: s7e,
  created_at: Le(),
  available_services: Ri(ki(Tr)).optional()
}).strict().transform(Ii);
Tpe.innerType().pick({
  name: !0,
  type: !0,
  available_services: !0
}).strict().transform(Ii);
Ri(Tpe).transform(Ii);
const o7e = ti({
  id: Le().uuid(),
  first_name: Le(),
  last_name: Le(),
  // Loose rather than .email(): '' is a real value in the database. See above
  // — nothing populates this.
  email: Le().optional()
}).transform(Ii), G5 = ti({
  id: Ft().int(),
  name: Le(),
  organization_id: Tpe.innerType().shape.id,
  organization_name: Le(),
  organization_type: ki(Qre),
  address: Le().nullable(),
  country: ki(B0e),
  specifications: Ri(ki(F0e)),
  construction_types: Ri(ki(Tz)),
  container_name: Le().uuid(),
  updated_at: Le().datetime(),
  created_at: Le().datetime(),
  billing_information: Le().nullable(),
  billing_address: Le().nullable(),
  org_number: Ft().int().nullable(),
  invoice_to: ki(H0e),
  oracle_id: Le().nullable(),
  famac_api_token: Le().nullish(),
  active_services: Ri(Le()),
  available_services: Ri(Le()),
  available_services_override: Ri(Le()),
  // External services (apps outside monoweb) recorded as used on the project.
  // Read-only, and optional so a core-api that does not send it yet still parses.
  used_external_services: Ri(Le()).optional(),
  effective_services: Ri(Le()),
  package_count: Ft().int(),
  // Serialised with isoformat(), so it ends in +00:00 rather than DRF's Z.
  last_uploaded_package: Le().datetime({ offset: !0 }).nullable(),
  unpublished_packages: ti({
    document_packages: Ri(Le()),
    layout_packages: Ri(Le())
  }),
  is_hidden: ts(),
  created_by: Le().uuid().nullable(),
  package_types: Ri(Le()).optional(),
  people: Ri(o7e).optional(),
  // Optional, like used_external_services, so a core-api that does not send
  // them yet still parses.
  project_manager_email: Le().nullish(),
  project_manager_name: Le().nullish()
}).strict().transform(Ii);
em(G5);
ti({
  page: fh([Ft().int(), hE("all")]),
  page_size: Ft().int().nullish(),
  search: Le().nullish(),
  is_hidden: ts().nullish(),
  ordering: Le().nullish(),
  package_types: Le().nullish(),
  // Comma-separated, like package_types: the backend filter is a
  // UUIDInFilter, so one creator and several share a wire format.
  created_by: Le().nullish(),
  // Comma-separated organization ids, a UUIDInFilter on the backend as well.
  organization: Le().nullish()
}).strict().transform(Ii);
G5.innerType().pick({
  name: !0,
  address: !0,
  country: !0,
  specifications: !0,
  construction_types: !0,
  organization_id: !0,
  billing_information: !0,
  billing_address: !0,
  org_number: !0,
  invoice_to: !0,
  oracle_id: !0,
  available_services_override: !0
}).strict().transform(Ii);
G5.innerType().pick({
  name: !0,
  address: !0,
  country: !0,
  construction_types: !0,
  oracle_id: !0,
  is_hidden: !0,
  available_services_override: !0
}).partial().strict().transform(Ii);
ti({
  projectId: Ft().int(),
  isHidden: ts().optional()
}).strict().transform(Ii);
var ro;
(function(e) {
  e.TENDER_DOCUMENTS = "TENDER_DOCUMENTS", e.OFFER = "OFFER", e.TENANT_SPECIFICATION = "TENANT_SPECIFICATION", e.DUE_DILIGENCE = "DUE_DILIGENCE", e.SITE_DUE_DILIGENCE = "SITE_DUE_DILIGENCE", e.MANAGEMENT_OPERATIONS_MAINTENANCE = "MANAGEMENT_OPERATIONS_MAINTENANCE", e.TENANT_REQUIREMENTS = "TENANT_REQUIREMENTS", e.SCHEDULE_CHECK = "SCHEDULE_CHECK", e.CONTRACT_REVIEW = "CONTRACT_REVIEW", e.REPORT_GENERATION = "REPORT_GENERATION", e.LUMINAIRE_SCHEDULE = "LUMINAIRE_SCHEDULE", e.RFP_RFQ_REVIEW = "RFP_RFQ_REVIEW", e.DESIGN_PACKAGE_REVIEW = "DESIGN_PACKAGE_REVIEW", e.VERSION_COMPARE = "VERSION_COMPARE", e.WATER_PROCESS_SYSTEMS_AGENT = "WATER_PROCESS_SYSTEMS_AGENT";
})(ro || (ro = {}));
ro.TENDER_DOCUMENTS + "", ro.OFFER + "", ro.TENANT_SPECIFICATION + "", ro.DUE_DILIGENCE + "", ro.SITE_DUE_DILIGENCE + "", ro.MANAGEMENT_OPERATIONS_MAINTENANCE + "", ro.TENANT_REQUIREMENTS + "", ro.SCHEDULE_CHECK + "", ro.CONTRACT_REVIEW + "", ro.REPORT_GENERATION + "", ro.LUMINAIRE_SCHEDULE + "", ro.RFP_RFQ_REVIEW + "", ro.DESIGN_PACKAGE_REVIEW + "", ro.VERSION_COMPARE + "", ro.WATER_PROCESS_SYSTEMS_AGENT + "";
var WT;
(function(e) {
  e.ANZ = "anz", e.ASIA = "asia", e.CANADA = "canada", e.CANADA_FRENCH = "canada_french", e.CM = "cm", e.ENTERPRISE = "enterprise", e.EUI = "eui", e.MEA = "mea", e.US_EAST = "us_east", e.US_WEST = "us_west";
})(WT || (WT = {}));
WT.ENTERPRISE + "", WT.CM + "", WT.ANZ + "", WT.ASIA + "", WT.CANADA + "", WT.CANADA_FRENCH + "", WT.EUI + "", WT.MEA + "", WT.US_EAST + "", WT.US_WEST + "";
var Cye;
(function(e) {
  e.DATA_CENTER = "DATA_CENTER", e.WASTE_WATER = "WASTE_WATER", e.LOGISTIC = "LOGISTIC", e.BRIDGE = "BRIDGE";
})(Cye || (Cye = {}));
var k0e;
(function(e) {
  e.CONTRACTOR = "CONTRACTOR", e.DEVELOPER = "DEVELOPER", e.PROJECT_DEVELOPER = "PROJECT_DEVELOPER", e.ENGINEER = "ENGINEER", e.CONSULTANT = "CONSULTANT";
})(k0e || (k0e = {}));
const kP = ti({
  id: Le().uuid(),
  name: Le(),
  project: G5.innerType().shape.id,
  type: ki(ro),
  external_famac_building_id: Le().uuid().nullable(),
  language: uie.optional(),
  created_by: Le().uuid().nullable(),
  published: ts(),
  needClassification: ts(),
  is_hidden: ts(),
  selected_conflict_types: Ri(Le()).optional().default([]),
  employer_role: ki(k0e).nullable().optional(),
  data: Kp(Le(), sB()).optional().default({})
}).strict().transform(Ii);
Ri(kP).transform(Ii);
var an;
(function(e) {
  e.AMBIGUITY_PROCESSOR = "ambiguity-processor", e.BID_COMPARISONS = "bid-comparisons", e.BID_GAPS = "bid-gaps", e.BREEAM_ENERGY_CHECK = "breeam-energy-check", e.BREEZE = "breeze", e.BUILDING_OPTIMIZER = "building-optimizer", e.BYG_DEADLINES = "byg-deadlines", e.BYG_MANDATORY_HEADER = "byg-mandatory-header", e.BYG_NAMES = "byg-names", e.BYG_TIME_PERIOD_DEADLINES = "byg-time-period-deadlines", e.CEILING_GRID_OPTIMIZER = "ceiling-grid-optimizer", e.CHECK_LIST = "check-list", e.CONTRACT_DEVIATION_CHECKER = "contract-deviation-checker", e.CONTRACT_EXTERNAL_DEVIATION = "contract-external-deviation", e.CONTRACT_INTERNAL_DEVIATION = "contract-internal-deviation", e.CONTRACT_RISK_PROCESSOR = "contract-risk-processor", e.CONTRADICTION_PROCESSOR = "contradiction-processor", e.DEADLINE_EXTRACTOR = "deadline-extractor", e.DELIVERABLE_PROCESSOR = "deliverable-processor", e.DOCUMENT_LABEL_ASSIGN = "document-label-assign", e.DOCUMENT_TO_PDF_CONVERTER = "document-to-pdf-converter", e.DRAWING_CLASSIFIER = "drawing-classifier", e.DUPLICATE_CHECKER = "duplicate-checker", e.EDITABLE_DOCUMENT = "editable-document", e.EXCEL_CONTENT_EXTRACTOR = "excel-content-extractor", e.FDV_CLASSIFIER = "fdv-classifier", e.FDV_MANDATORY = "fdv-mandatory", e.FDV_MISSING_DRAWINGS = "fdv-missing-drawings", e.FILENAME_CHECK = "filename-check", e.FILENAME_SUGGESTION = "filename-suggestion", e.FUNCTIONAL_DESCRIPTIONS = "functional-descriptions", e.GPT_DOCUMENT_CLASSIFIER = "gpt-document-classifier", e.HUMAN_INTELLIGENCE = "human-intelligence", e.IFC_EXPORT = "ifc-export", e.IFC_EXTRACTION = "ifc-extraction", e.KVALIFIKASJONSKRAV_CHECKER = "kvalifikasjonskrav-checker", e.LEGAL_CONTRACT_RISK = "legal-contract-risk", e.LOAD_CALCULATION_PROCESSOR = "load-calculation-processor", e.LUM_SCHEDULE_GENERATOR = "lum-schedule-generator", e.MISSING_REQUIREMENTS = "missing-requirements", e.MISSING_STANDARDS = "missing-standards", e.ORG_INFO = "org-info", e.PARSER_CONTENT_EXTRACTOR = "parser-content-extractor", e.PARSER_IMAGE_CONVERTER = "parser-image-converter", e.PARSER_OPENAI_EMBEDDINGS = "parser-openai-embeddings", e.PIDS_ANALYSER = "pids-analyser", e.PRE_PARSER_OCR = "pre-parser-ocr", e.PRODUCTS_COMPARE = "products-compare", e.PROJECT_SCOPE_RISK = "project-scope-risk", e.REFERENCE_FINDER = "reference-finder", e.REPORT_GEN_PRECHECK = "report-gen-precheck", e.REPORT_GEN_PROCESSOR = "report-gen-processor", e.REPORT_TEMPLATE_GENERATOR = "report-template-generator", e.RESERVATION_RISK = "reservation-risk", e.RESPONSIBILITY_RISK = "responsibility-risk", e.REVIT_GENERATOR = "revit-generator", e.RISK_PROCESSOR = "risk-processor", e.SCHEDULE_CHECK = "schedule-check", e.SFP = "sfp", e.SIMILAR_HEADERS = "similar-headers", e.SITE_DUE_DILIGENCE = "site-due-diligence", e.SITE_RISK_PROCESSOR = "site-risk-processor", e.SPACE_ANALYSIS = "space-analysis", e.ST_ANBEFALE = "st-anbefale", e.ST_COMPARE = "st-compare", e.ST_VALID_CHECKER = "st-valid-checker", e.SUMMARY_PROCESSOR = "summary-processor", e.TENDER_RFP_EXTRACTION = "tender-rfp-extraction", e.TEXT_PROCESSOR_ANBEFALE = "text-processor-anbefale", e.TEXT_PROCESSOR_GLIST = "text-processor-glist", e.TEXT_PROCESSOR_GLIST_DD = "text-processor-glist-dd", e.TEXT_PROCESSOR_GLIST_FDV = "text-processor-glist-fdv", e.TEXT_PROCESSOR_GLIST_FDV_UK = "text-processor-glist-fdv-uk", e.TEXT_PROCESSOR_GLIST_INF = "text-processor-glist-inf", e.TEXT_PROCESSOR_GLIST_LB_KG = "text-processor-glist-lb-kg", e.TEXT_PROCESSOR_GLIST_UK = "text-processor-glist-uk", e.TEXT_PROCESSOR_HIMLING = "text-processor-himling", e.TEXT_PROCESSOR_LYDKRAV = "text-processor-lydkrav", e.TEXT_PROCESSOR_PRICES = "text-processor-prices", e.TEXT_PROCESSOR_SAMSPILL = "text-processor-samspill", e.TEXT_PROCESSOR_SENTRALISERT = "text-processor-sentralisert", e.TEXT_PROCESSOR_SUBJECTS = "text-processor-subjects", e.TEXT_PROCESSOR_TEK17 = "text-processor-tek17", e.TEXT_PROCESSOR_VAGUE = "text-processor-vague", e.UNIT_CHECKER = "unit-checker", e.UNIT_OF_MEASURE_CHECKER = "unit-of-measure-checker", e.U_VALUE_CHECKER = "u-value-checker", e.UVALUE = "uvalue", e.VAGUE_WORDING_RISK = "vague-wording-risk", e.VENTILATION_SFP_CHECKER = "ventilation-sfp-checker", e.VERSION_COMPARE = "version-compare", e.SPEC_REQUIREMENTS_PROCESSOR = "spec-requirements-processor";
})(an || (an = {}));
ro.TENDER_DOCUMENTS + "", an.DEADLINE_EXTRACTOR, an.CONTRACT_EXTERNAL_DEVIATION, an.CONTRACT_INTERNAL_DEVIATION, an.REFERENCE_FINDER, an.KVALIFIKASJONSKRAV_CHECKER, an.MISSING_REQUIREMENTS, an.MISSING_STANDARDS, an.RISK_PROCESSOR, an.ST_ANBEFALE, an.ST_VALID_CHECKER, an.TEXT_PROCESSOR_ANBEFALE, an.TEXT_PROCESSOR_GLIST, an.TEXT_PROCESSOR_SUBJECTS, an.CHECK_LIST, an.CONTRADICTION_PROCESSOR, ro.OFFER + "", an.BID_COMPARISONS, an.DEADLINE_EXTRACTOR, an.CONTRACT_EXTERNAL_DEVIATION, an.CONTRACT_INTERNAL_DEVIATION, an.REFERENCE_FINDER, an.PRODUCTS_COMPARE, an.RISK_PROCESSOR, an.ST_COMPARE, an.ST_VALID_CHECKER, an.TEXT_PROCESSOR_GLIST, an.TEXT_PROCESSOR_PRICES, an.TEXT_PROCESSOR_SUBJECTS, an.TEXT_PROCESSOR_TEK17, an.CONTRADICTION_PROCESSOR, ro.TENANT_SPECIFICATION + "", an.DEADLINE_EXTRACTOR, an.REFERENCE_FINDER, an.PRODUCTS_COMPARE, an.RISK_PROCESSOR, an.ST_COMPARE, an.TEXT_PROCESSOR_GLIST, an.TEXT_PROCESSOR_HIMLING, an.TEXT_PROCESSOR_SENTRALISERT, an.TEXT_PROCESSOR_SUBJECTS, an.TEXT_PROCESSOR_TEK17, ro.TENANT_REQUIREMENTS + "", an.DEADLINE_EXTRACTOR, an.CONTRACT_DEVIATION_CHECKER, an.CONTRACT_EXTERNAL_DEVIATION, an.CONTRACT_INTERNAL_DEVIATION, an.REFERENCE_FINDER, an.PRODUCTS_COMPARE, an.RISK_PROCESSOR, an.ST_COMPARE, an.ST_VALID_CHECKER, an.TEXT_PROCESSOR_GLIST, an.TEXT_PROCESSOR_HIMLING, an.TEXT_PROCESSOR_SENTRALISERT, an.TEXT_PROCESSOR_SUBJECTS, an.TEXT_PROCESSOR_TEK17, an.CONTRADICTION_PROCESSOR, ro.CONTRACT_REVIEW + "", an.DEADLINE_EXTRACTOR, an.CONTRACT_EXTERNAL_DEVIATION, an.CONTRACT_INTERNAL_DEVIATION, an.REFERENCE_FINDER, an.KVALIFIKASJONSKRAV_CHECKER, an.MISSING_REQUIREMENTS, an.RISK_PROCESSOR, an.ST_VALID_CHECKER, an.TEXT_PROCESSOR_ANBEFALE, an.TEXT_PROCESSOR_SUBJECTS, an.CHECK_LIST, an.LEGAL_CONTRACT_RISK, an.CONTRADICTION_PROCESSOR, ro.MANAGEMENT_OPERATIONS_MAINTENANCE + "", an.EDITABLE_DOCUMENT, an.FDV_MANDATORY, an.FDV_MISSING_DRAWINGS, an.FILENAME_CHECK, an.FUNCTIONAL_DESCRIPTIONS, an.MISSING_REQUIREMENTS, an.TEXT_PROCESSOR_GLIST_FDV, an.TEXT_PROCESSOR_GLIST_FDV_UK, an.CHECK_LIST, ro.DUE_DILIGENCE + "", an.ORG_INFO, an.TEXT_PROCESSOR_GLIST_DD, ro.RFP_RFQ_REVIEW + "", an.DEADLINE_EXTRACTOR, ro.DESIGN_PACKAGE_REVIEW + "", an.AMBIGUITY_PROCESSOR, an.CONTRADICTION_PROCESSOR, an.FDV_MISSING_DRAWINGS, an.REFERENCE_FINDER, an.ST_VALID_CHECKER;
var TW;
(function(e) {
  e.NS3451_1 = "NS3451_1", e.NS3451_11 = "NS3451_11", e.NS3451_111 = "NS3451_111", e.NS3451_112 = "NS3451_112", e.NS3451_113 = "NS3451_113", e.NS3451_114 = "NS3451_114", e.NS3451_115 = "NS3451_115", e.NS3451_116 = "NS3451_116", e.NS3451_117 = "NS3451_117", e.NS3451_118 = "NS3451_118", e.NS3451_12 = "NS3451_12", e.NS3451_121 = "NS3451_121", e.NS3451_122 = "NS3451_122", e.NS3451_123 = "NS3451_123", e.NS3451_124 = "NS3451_124", e.NS3451_13 = "NS3451_13", e.NS3451_131 = "NS3451_131", e.NS3451_132 = "NS3451_132", e.NS3451_133 = "NS3451_133", e.NS3451_14 = "NS3451_14", e.NS3451_141 = "NS3451_141", e.NS3451_142 = "NS3451_142", e.NS3451_143 = "NS3451_143", e.NS3451_144 = "NS3451_144", e.NS3451_145 = "NS3451_145", e.NS3451_146 = "NS3451_146", e.NS3451_15 = "NS3451_15", e.NS3451_151 = "NS3451_151", e.NS3451_152 = "NS3451_152", e.NS3451_153 = "NS3451_153", e.NS3451_154 = "NS3451_154", e.NS3451_155 = "NS3451_155", e.NS3451_156 = "NS3451_156", e.NS3451_16 = "NS3451_16", e.NS3451_161 = "NS3451_161", e.NS3451_162 = "NS3451_162", e.NS3451_163 = "NS3451_163", e.NS3451_164 = "NS3451_164", e.NS3451_165 = "NS3451_165", e.NS3451_166 = "NS3451_166", e.NS3451_167 = "NS3451_167", e.NS3451_168 = "NS3451_168", e.NS3451_169 = "NS3451_169", e.NS3451_17 = "NS3451_17", e.NS3451_171 = "NS3451_171", e.NS3451_172 = "NS3451_172", e.NS3451_173 = "NS3451_173", e.NS3451_18 = "NS3451_18", e.NS3451_181 = "NS3451_181", e.NS3451_182 = "NS3451_182", e.NS3451_183 = "NS3451_183", e.NS3451_19 = "NS3451_19", e.NS3451_191 = "NS3451_191", e.NS3451_192 = "NS3451_192", e.NS3451_193 = "NS3451_193", e.NS3451_194 = "NS3451_194", e.NS3451_195 = "NS3451_195", e.NS3451_196 = "NS3451_196", e.NS3451_197 = "NS3451_197", e.NS3451_2 = "NS3451_2", e.NS3451_21 = "NS3451_21", e.NS3451_211 = "NS3451_211", e.NS3451_212 = "NS3451_212", e.NS3451_213 = "NS3451_213", e.NS3451_214 = "NS3451_214", e.NS3451_215 = "NS3451_215", e.NS3451_216 = "NS3451_216", e.NS3451_217 = "NS3451_217", e.NS3451_218 = "NS3451_218", e.NS3451_219 = "NS3451_219", e.NS3451_22 = "NS3451_22", e.NS3451_221 = "NS3451_221", e.NS3451_222 = "NS3451_222", e.NS3451_223 = "NS3451_223", e.NS3451_224 = "NS3451_224", e.NS3451_225 = "NS3451_225", e.NS3451_226 = "NS3451_226", e.NS3451_227 = "NS3451_227", e.NS3451_228 = "NS3451_228", e.NS3451_229 = "NS3451_229", e.NS3451_23 = "NS3451_23", e.NS3451_231 = "NS3451_231", e.NS3451_232 = "NS3451_232", e.NS3451_233 = "NS3451_233", e.NS3451_234 = "NS3451_234", e.NS3451_235 = "NS3451_235", e.NS3451_236 = "NS3451_236", e.NS3451_237 = "NS3451_237", e.NS3451_238 = "NS3451_238", e.NS3451_239 = "NS3451_239", e.NS3451_24 = "NS3451_24", e.NS3451_241 = "NS3451_241", e.NS3451_242 = "NS3451_242", e.NS3451_243 = "NS3451_243", e.NS3451_244 = "NS3451_244", e.NS3451_245 = "NS3451_245", e.NS3451_246 = "NS3451_246", e.NS3451_247 = "NS3451_247", e.NS3451_248 = "NS3451_248", e.NS3451_249 = "NS3451_249", e.NS3451_25 = "NS3451_25", e.NS3451_251 = "NS3451_251", e.NS3451_252 = "NS3451_252", e.NS3451_253 = "NS3451_253", e.NS3451_254 = "NS3451_254", e.NS3451_255 = "NS3451_255", e.NS3451_256 = "NS3451_256", e.NS3451_257 = "NS3451_257", e.NS3451_258 = "NS3451_258", e.NS3451_259 = "NS3451_259", e.NS3451_26 = "NS3451_26", e.NS3451_261 = "NS3451_261", e.NS3451_262 = "NS3451_262", e.NS3451_263 = "NS3451_263", e.NS3451_264 = "NS3451_264", e.NS3451_265 = "NS3451_265", e.NS3451_266 = "NS3451_266", e.NS3451_267 = "NS3451_267", e.NS3451_268 = "NS3451_268", e.NS3451_269 = "NS3451_269", e.NS3451_27 = "NS3451_27", e.NS3451_271 = "NS3451_271", e.NS3451_272 = "NS3451_272", e.NS3451_273 = "NS3451_273", e.NS3451_274 = "NS3451_274", e.NS3451_275 = "NS3451_275", e.NS3451_276 = "NS3451_276", e.NS3451_277 = "NS3451_277", e.NS3451_278 = "NS3451_278", e.NS3451_279 = "NS3451_279", e.NS3451_28 = "NS3451_28", e.NS3451_281 = "NS3451_281", e.NS3451_282 = "NS3451_282", e.NS3451_283 = "NS3451_283", e.NS3451_284 = "NS3451_284", e.NS3451_285 = "NS3451_285", e.NS3451_286 = "NS3451_286", e.NS3451_287 = "NS3451_287", e.NS3451_288 = "NS3451_288", e.NS3451_289 = "NS3451_289", e.NS3451_29 = "NS3451_29", e.NS3451_291 = "NS3451_291", e.NS3451_3 = "NS3451_3", e.NS3451_31 = "NS3451_31", e.NS3451_310 = "NS3451_310", e.NS3451_311 = "NS3451_311", e.NS3451_312 = "NS3451_312", e.NS3451_314 = "NS3451_314", e.NS3451_315 = "NS3451_315", e.NS3451_316 = "NS3451_316", e.NS3451_319 = "NS3451_319", e.NS3451_32 = "NS3451_32", e.NS3451_320 = "NS3451_320", e.NS3451_321 = "NS3451_321", e.NS3451_322 = "NS3451_322", e.NS3451_324 = "NS3451_324", e.NS3451_325 = "NS3451_325", e.NS3451_326 = "NS3451_326", e.NS3451_329 = "NS3451_329", e.NS3451_33 = "NS3451_33", e.NS3451_330 = "NS3451_330", e.NS3451_331 = "NS3451_331", e.NS3451_332 = "NS3451_332", e.NS3451_333 = "NS3451_333", e.NS3451_334 = "NS3451_334", e.NS3451_335 = "NS3451_335", e.NS3451_336 = "NS3451_336", e.NS3451_337 = "NS3451_337", e.NS3451_339 = "NS3451_339", e.NS3451_34 = "NS3451_34", e.NS3451_340 = "NS3451_340", e.NS3451_341 = "NS3451_341", e.NS3451_342 = "NS3451_342", e.NS3451_343 = "NS3451_343", e.NS3451_345 = "NS3451_345", e.NS3451_346 = "NS3451_346", e.NS3451_347 = "NS3451_347", e.NS3451_348 = "NS3451_348", e.NS3451_349 = "NS3451_349", e.NS3451_35 = "NS3451_35", e.NS3451_350 = "NS3451_350", e.NS3451_351 = "NS3451_351", e.NS3451_352 = "NS3451_352", e.NS3451_353 = "NS3451_353", e.NS3451_354 = "NS3451_354", e.NS3451_355 = "NS3451_355", e.NS3451_356 = "NS3451_356", e.NS3451_359 = "NS3451_359", e.NS3451_36 = "NS3451_36", e.NS3451_360 = "NS3451_360", e.NS3451_361 = "NS3451_361", e.NS3451_362 = "NS3451_362", e.NS3451_364 = "NS3451_364", e.NS3451_365 = "NS3451_365", e.NS3451_366 = "NS3451_366", e.NS3451_37 = "NS3451_37", e.NS3451_370 = "NS3451_370", e.NS3451_371 = "NS3451_371", e.NS3451_372 = "NS3451_372", e.NS3451_374 = "NS3451_374", e.NS3451_375 = "NS3451_375", e.NS3451_376 = "NS3451_376", e.NS3451_379 = "NS3451_379", e.NS3451_38 = "NS3451_38", e.NS3451_380 = "NS3451_380", e.NS3451_381 = "NS3451_381", e.NS3451_382 = "NS3451_382", e.NS3451_383 = "NS3451_383", e.NS3451_386 = "NS3451_386", e.NS3451_389 = "NS3451_389", e.NS3451_39 = "NS3451_39", e.NS3451_4 = "NS3451_4", e.NS3451_41 = "NS3451_41", e.NS3451_411 = "NS3451_411", e.NS3451_412 = "NS3451_412", e.NS3451_413 = "NS3451_413", e.NS3451_414 = "NS3451_414", e.NS3451_419 = "NS3451_419", e.NS3451_42 = "NS3451_42", e.NS3451_421 = "NS3451_421", e.NS3451_422 = "NS3451_422", e.NS3451_429 = "NS3451_429", e.NS3451_43 = "NS3451_43", e.NS3451_431 = "NS3451_431", e.NS3451_432 = "NS3451_432", e.NS3451_433 = "NS3451_433", e.NS3451_434 = "NS3451_434", e.NS3451_435 = "NS3451_435", e.NS3451_436 = "NS3451_436", e.NS3451_439 = "NS3451_439", e.NS3451_44 = "NS3451_44", e.NS3451_442 = "NS3451_442", e.NS3451_443 = "NS3451_443", e.NS3451_449 = "NS3451_449", e.NS3451_45 = "NS3451_45", e.NS3451_452 = "NS3451_452", e.NS3451_453 = "NS3451_453", e.NS3451_454 = "NS3451_454", e.NS3451_459 = "NS3451_459", e.NS3451_46 = "NS3451_46", e.NS3451_461 = "NS3451_461", e.NS3451_462 = "NS3451_462", e.NS3451_463 = "NS3451_463", e.NS3451_469 = "NS3451_469", e.NS3451_47 = "NS3451_47", e.NS3451_471 = "NS3451_471", e.NS3451_472 = "NS3451_472", e.NS3451_479 = "NS3451_479", e.NS3451_48 = "NS3451_48", e.NS3451_481 = "NS3451_481", e.NS3451_482 = "NS3451_482", e.NS3451_489 = "NS3451_489", e.NS3451_49 = "NS3451_49", e.NS3451_5 = "NS3451_5", e.NS3451_51 = "NS3451_51", e.NS3451_511 = "NS3451_511", e.NS3451_512 = "NS3451_512", e.NS3451_514 = "NS3451_514", e.NS3451_515 = "NS3451_515", e.NS3451_519 = "NS3451_519", e.NS3451_52 = "NS3451_52", e.NS3451_521 = "NS3451_521", e.NS3451_522 = "NS3451_522", e.NS3451_523 = "NS3451_523", e.NS3451_524 = "NS3451_524", e.NS3451_529 = "NS3451_529", e.NS3451_53 = "NS3451_53", e.NS3451_532 = "NS3451_532", e.NS3451_533 = "NS3451_533", e.NS3451_534 = "NS3451_534", e.NS3451_535 = "NS3451_535", e.NS3451_536 = "NS3451_536", e.NS3451_539 = "NS3451_539", e.NS3451_54 = "NS3451_54", e.NS3451_542 = "NS3451_542", e.NS3451_543 = "NS3451_543", e.NS3451_544 = "NS3451_544", e.NS3451_545 = "NS3451_545", e.NS3451_546 = "NS3451_546", e.NS3451_549 = "NS3451_549", e.NS3451_55 = "NS3451_55", e.NS3451_552 = "NS3451_552", e.NS3451_553 = "NS3451_553", e.NS3451_554 = "NS3451_554", e.NS3451_555 = "NS3451_555", e.NS3451_556 = "NS3451_556", e.NS3451_559 = "NS3451_559", e.NS3451_56 = "NS3451_56", e.NS3451_562 = "NS3451_562", e.NS3451_563 = "NS3451_563", e.NS3451_564 = "NS3451_564", e.NS3451_565 = "NS3451_565", e.NS3451_569 = "NS3451_569", e.NS3451_57 = "NS3451_57", e.NS3451_571 = "NS3451_571", e.NS3451_572 = "NS3451_572", e.NS3451_573 = "NS3451_573", e.NS3451_574 = "NS3451_574", e.NS3451_575 = "NS3451_575", e.NS3451_576 = "NS3451_576", e.NS3451_577 = "NS3451_577", e.NS3451_578 = "NS3451_578", e.NS3451_579 = "NS3451_579", e.NS3451_58 = "NS3451_58", e.NS3451_59 = "NS3451_59", e.NS3451_6 = "NS3451_6", e.NS3451_61 = "NS3451_61", e.NS3451_611 = "NS3451_611", e.NS3451_612 = "NS3451_612", e.NS3451_613 = "NS3451_613", e.NS3451_614 = "NS3451_614", e.NS3451_615 = "NS3451_615", e.NS3451_619 = "NS3451_619", e.NS3451_62 = "NS3451_62", e.NS3451_621 = "NS3451_621", e.NS3451_622 = "NS3451_622", e.NS3451_623 = "NS3451_623", e.NS3451_624 = "NS3451_624", e.NS3451_625 = "NS3451_625", e.NS3451_626 = "NS3451_626", e.NS3451_627 = "NS3451_627", e.NS3451_629 = "NS3451_629", e.NS3451_63 = "NS3451_63", e.NS3451_631 = "NS3451_631", e.NS3451_632 = "NS3451_632", e.NS3451_633 = "NS3451_633", e.NS3451_634 = "NS3451_634", e.NS3451_639 = "NS3451_639", e.NS3451_64 = "NS3451_64", e.NS3451_65 = "NS3451_65", e.NS3451_651 = "NS3451_651", e.NS3451_652 = "NS3451_652", e.NS3451_653 = "NS3451_653", e.NS3451_659 = "NS3451_659", e.NS3451_66 = "NS3451_66", e.NS3451_661 = "NS3451_661", e.NS3451_67 = "NS3451_67", e.NS3451_681 = "NS3451_681", e.NS3451_69 = "NS3451_69", e.NS3451_7 = "NS3451_7", e.NS3451_71 = "NS3451_71", e.NS3451_711 = "NS3451_711", e.NS3451_712 = "NS3451_712", e.NS3451_713 = "NS3451_713", e.NS3451_714 = "NS3451_714", e.NS3451_715 = "NS3451_715", e.NS3451_719 = "NS3451_719", e.NS3451_72 = "NS3451_72", e.NS3451_721 = "NS3451_721", e.NS3451_722 = "NS3451_722", e.NS3451_723 = "NS3451_723", e.NS3451_724 = "NS3451_724", e.NS3451_725 = "NS3451_725", e.NS3451_726 = "NS3451_726", e.NS3451_727 = "NS3451_727", e.NS3451_729 = "NS3451_729", e.NS3451_73 = "NS3451_73", e.NS3451_731 = "NS3451_731", e.NS3451_732 = "NS3451_732", e.NS3451_733 = "NS3451_733", e.NS3451_734 = "NS3451_734", e.NS3451_735 = "NS3451_735", e.NS3451_736 = "NS3451_736", e.NS3451_737 = "NS3451_737", e.NS3451_738 = "NS3451_738", e.NS3451_739 = "NS3451_739", e.NS3451_74 = "NS3451_74", e.NS3451_742 = "NS3451_742", e.NS3451_743 = "NS3451_743", e.NS3451_744 = "NS3451_744", e.NS3451_745 = "NS3451_745", e.NS3451_746 = "NS3451_746", e.NS3451_749 = "NS3451_749", e.NS3451_75 = "NS3451_75", e.NS3451_752 = "NS3451_752", e.NS3451_753 = "NS3451_753", e.NS3451_754 = "NS3451_754", e.NS3451_755 = "NS3451_755", e.NS3451_756 = "NS3451_756", e.NS3451_759 = "NS3451_759", e.NS3451_76 = "NS3451_76", e.NS3451_761 = "NS3451_761", e.NS3451_762 = "NS3451_762", e.NS3451_763 = "NS3451_763", e.NS3451_764 = "NS3451_764", e.NS3451_769 = "NS3451_769", e.NS3451_77 = "NS3451_77", e.NS3451_771 = "NS3451_771", e.NS3451_772 = "NS3451_772", e.NS3451_773 = "NS3451_773", e.NS3451_774 = "NS3451_774", e.NS3451_775 = "NS3451_775", e.NS3451_779 = "NS3451_779", e.NS3451_78 = "NS3451_78", e.NS3451_783 = "NS3451_783", e.NS3451_784 = "NS3451_784", e.NS3451_785 = "NS3451_785", e.NS3451_789 = "NS3451_789", e.NS3451_79 = "NS3451_79", e.UNCATEGORIZED = "UNCATEGORIZED";
})(TW || (TW = {}));
var V0e;
(function(e) {
  e.OMUK_1 = "OMUK_1", e.OMUK_1_1 = "OMUK_1_1", e.OMUK_1_1_1 = "OMUK_1_1_1", e.OMUK_1_1_2 = "OMUK_1_1_2", e.OMUK_1_2 = "OMUK_1_2", e.OMUK_1_2_1 = "OMUK_1_2_1", e.OMUK_1_2_2 = "OMUK_1_2_2", e.OMUK_1_2_3 = "OMUK_1_2_3", e.OMUK_1_2_4 = "OMUK_1_2_4", e.OMUK_1_2_5 = "OMUK_1_2_5", e.OMUK_1_2_6 = "OMUK_1_2_6", e.OMUK_1_3 = "OMUK_1_3", e.OMUK_1_4 = "OMUK_1_4", e.OMUK_1_4_1 = "OMUK_1_4_1", e.OMUK_1_4_2 = "OMUK_1_4_2", e.OMUK_1_4_3 = "OMUK_1_4_3", e.OMUK_1_5 = "OMUK_1_5", e.OMUK_1_5_1 = "OMUK_1_5_1", e.OMUK_1_5_2 = "OMUK_1_5_2", e.OMUK_1_5_3 = "OMUK_1_5_3", e.OMUK_1_5_4 = "OMUK_1_5_4", e.OMUK_1_5_5 = "OMUK_1_5_5", e.OMUK_2 = "OMUK_2", e.OMUK_2_1 = "OMUK_2_1", e.OMUK_2_2 = "OMUK_2_2", e.OMUK_2_3 = "OMUK_2_3", e.OMUK_2_4 = "OMUK_2_4", e.OMUK_2_5 = "OMUK_2_5", e.OMUK_2_6 = "OMUK_2_6", e.OMUK_2_7 = "OMUK_2_7", e.OMUK_3 = "OMUK_3", e.OMUK_3_1 = "OMUK_3_1", e.OMUK_3_2 = "OMUK_3_2", e.OMUK_3_3 = "OMUK_3_3", e.OMUK_3_4 = "OMUK_3_4", e.OMUK_3_5 = "OMUK_3_5", e.OMUK_3_6 = "OMUK_3_6", e.OMUK_3_7 = "OMUK_3_7", e.OMUK_3_8 = "OMUK_3_8", e.OMUK_4 = "OMUK_4", e.OMUK_4_1 = "OMUK_4_1", e.OMUK_4_1_1 = "OMUK_4_1_1", e.OMUK_4_1_2 = "OMUK_4_1_2", e.OMUK_4_1_3 = "OMUK_4_1_3", e.OMUK_4_1_4 = "OMUK_4_1_4", e.OMUK_4_2 = "OMUK_4_2", e.OMUK_4_2_1 = "OMUK_4_2_1", e.OMUK_4_2_2 = "OMUK_4_2_2", e.OMUK_4_2_3 = "OMUK_4_2_3", e.OMUK_4_2_4 = "OMUK_4_2_4", e.OMUK_4_3 = "OMUK_4_3", e.OMUK_4_3_1 = "OMUK_4_3_1", e.OMUK_4_3_2 = "OMUK_4_3_2", e.OMUK_4_3_3 = "OMUK_4_3_3", e.OMUK_4_3_4 = "OMUK_4_3_4", e.OMUK_4_4 = "OMUK_4_4", e.OMUK_4_4_1 = "OMUK_4_4_1", e.OMUK_4_4_2 = "OMUK_4_4_2", e.OMUK_4_4_3 = "OMUK_4_4_3", e.OMUK_4_4_4 = "OMUK_4_4_4", e.OMUK_4_5 = "OMUK_4_5", e.OMUK_4_5_1 = "OMUK_4_5_1", e.OMUK_4_5_2 = "OMUK_4_5_2", e.OMUK_4_5_3 = "OMUK_4_5_3", e.OMUK_4_5_4 = "OMUK_4_5_4", e.OMUK_4_6 = "OMUK_4_6", e.OMUK_4_6_1 = "OMUK_4_6_1", e.OMUK_4_6_2 = "OMUK_4_6_2", e.OMUK_4_6_3 = "OMUK_4_6_3", e.OMUK_4_6_4 = "OMUK_4_6_4", e.OMUK_4_7 = "OMUK_4_7", e.OMUK_4_7_1 = "OMUK_4_7_1", e.OMUK_4_7_2 = "OMUK_4_7_2", e.OMUK_4_7_3 = "OMUK_4_7_3", e.OMUK_4_7_4 = "OMUK_4_7_4", e.OMUK_4_8 = "OMUK_4_8", e.OMUK_4_8_1 = "OMUK_4_8_1", e.OMUK_5 = "OMUK_5", e.OMUK_5_1 = "OMUK_5_1", e.OMUK_5_1_1 = "OMUK_5_1_1", e.OMUK_5_1_2 = "OMUK_5_1_2", e.OMUK_5_1_3 = "OMUK_5_1_3", e.OMUK_5_1_4 = "OMUK_5_1_4", e.OMUK_5_2 = "OMUK_5_2", e.OMUK_5_2_1 = "OMUK_5_2_1", e.OMUK_5_2_2 = "OMUK_5_2_2", e.OMUK_5_2_3 = "OMUK_5_2_3", e.OMUK_5_2_4 = "OMUK_5_2_4", e.OMUK_5_3 = "OMUK_5_3", e.OMUK_5_3_1 = "OMUK_5_3_1", e.OMUK_5_3_2 = "OMUK_5_3_2", e.OMUK_5_3_3 = "OMUK_5_3_3", e.OMUK_5_3_4 = "OMUK_5_3_4", e.OMUK_5_4 = "OMUK_5_4", e.OMUK_5_4_1 = "OMUK_5_4_1", e.OMUK_5_4_2 = "OMUK_5_4_2", e.OMUK_5_4_3 = "OMUK_5_4_3", e.OMUK_5_4_4 = "OMUK_5_4_4", e.OMUK_5_5 = "OMUK_5_5", e.OMUK_5_5_1 = "OMUK_5_5_1", e.OMUK_5_5_2 = "OMUK_5_5_2", e.OMUK_5_5_3 = "OMUK_5_5_3", e.OMUK_5_5_4 = "OMUK_5_5_4", e.OMUK_5_6 = "OMUK_5_6", e.OMUK_5_6_1 = "OMUK_5_6_1", e.OMUK_5_6_2 = "OMUK_5_6_2", e.OMUK_5_6_3 = "OMUK_5_6_3", e.OMUK_5_7 = "OMUK_5_7", e.OMUK_5_7_1 = "OMUK_5_7_1", e.OMUK_5_7_2 = "OMUK_5_7_2", e.OMUK_5_7_3 = "OMUK_5_7_3", e.OMUK_5_8 = "OMUK_5_8", e.OMUK_5_8_1 = "OMUK_5_8_1", e.OMUK_5_8_2 = "OMUK_5_8_2", e.OMUK_5_8_3 = "OMUK_5_8_3", e.OMUK_5_9 = "OMUK_5_9", e.OMUK_5_9_1 = "OMUK_5_9_1", e.OMUK_5_9_2 = "OMUK_5_9_2", e.OMUK_5_9_3 = "OMUK_5_9_3", e.OMUK_5_9_4 = "OMUK_5_9_4", e.OMUK_5_9_5 = "OMUK_5_9_5", e.OMUK_5_10 = "OMUK_5_10", e.OMUK_5_10_1 = "OMUK_5_10_1", e.OMUK_5_10_2 = "OMUK_5_10_2", e.OMUK_5_10_3 = "OMUK_5_10_3", e.OMUK_5_10_4 = "OMUK_5_10_4", e.OMUK_5_10_5 = "OMUK_5_10_5", e.OMUK_5_11 = "OMUK_5_11", e.OMUK_5_11_1 = "OMUK_5_11_1", e.OMUK_5_11_2 = "OMUK_5_11_2", e.OMUK_5_11_3 = "OMUK_5_11_3", e.OMUK_5_11_4 = "OMUK_5_11_4", e.OMUK_5_12 = "OMUK_5_12", e.OMUK_5_12_1 = "OMUK_5_12_1", e.OMUK_5_12_2 = "OMUK_5_12_2", e.OMUK_5_12_3 = "OMUK_5_12_3", e.OMUK_5_12_4 = "OMUK_5_12_4", e.OMUK_5_13 = "OMUK_5_13", e.OMUK_5_13_1 = "OMUK_5_13_1", e.OMUK_5_13_2 = "OMUK_5_13_2", e.OMUK_5_13_3 = "OMUK_5_13_3", e.OMUK_5_13_4 = "OMUK_5_13_4", e.OMUK_5_14 = "OMUK_5_14", e.OMUK_5_14_1 = "OMUK_5_14_1", e.OMUK_5_14_2 = "OMUK_5_14_2", e.OMUK_5_14_3 = "OMUK_5_14_3", e.OMUK_5_14_4 = "OMUK_5_14_4", e.OMUK_5_15 = "OMUK_5_15", e.OMUK_5_15_1 = "OMUK_5_15_1", e.OMUK_5_15_2 = "OMUK_5_15_2", e.OMUK_5_15_3 = "OMUK_5_15_3", e.OMUK_5_15_4 = "OMUK_5_15_4", e.OMUK_5_15_5 = "OMUK_5_15_5", e.OMUK_5_16 = "OMUK_5_16", e.OMUK_5_16_1 = "OMUK_5_16_1", e.OMUK_5_16_2 = "OMUK_5_16_2", e.OMUK_5_16_3 = "OMUK_5_16_3", e.OMUK_5_16_4 = "OMUK_5_16_4", e.OMUK_5_17 = "OMUK_5_17", e.OMUK_5_17_1 = "OMUK_5_17_1", e.OMUK_5_17_2 = "OMUK_5_17_2", e.OMUK_5_17_3 = "OMUK_5_17_3", e.OMUK_5_17_4 = "OMUK_5_17_4", e.OMUK_5_18 = "OMUK_5_18", e.OMUK_5_18_1 = "OMUK_5_18_1", e.OMUK_5_18_2 = "OMUK_5_18_2", e.OMUK_5_18_3 = "OMUK_5_18_3", e.OMUK_5_18_4 = "OMUK_5_18_4", e.OMUK_5_19 = "OMUK_5_19", e.OMUK_5_19_1 = "OMUK_5_19_1", e.OMUK_5_19_2 = "OMUK_5_19_2", e.OMUK_5_19_3 = "OMUK_5_19_3", e.OMUK_5_19_4 = "OMUK_5_19_4", e.OMUK_5_20 = "OMUK_5_20", e.OMUK_5_20_1 = "OMUK_5_20_1", e.OMUK_5_20_2 = "OMUK_5_20_2", e.OMUK_5_20_3 = "OMUK_5_20_3", e.OMUK_5_20_4 = "OMUK_5_20_4", e.OMUK_5_21 = "OMUK_5_21", e.OMUK_5_21_1 = "OMUK_5_21_1", e.OMUK_5_21_2 = "OMUK_5_21_2", e.OMUK_5_21_3 = "OMUK_5_21_3", e.OMUK_5_21_4 = "OMUK_5_21_4", e.OMUK_5_21_5 = "OMUK_5_21_5", e.OMUK_5_21_6 = "OMUK_5_21_6", e.OMUK_5_21_7 = "OMUK_5_21_7", e.OMUK_5_21_8 = "OMUK_5_21_8", e.OMUK_5_21_9 = "OMUK_5_21_9", e.OMUK_5_21_10 = "OMUK_5_21_10", e.OMUK_5_21_11 = "OMUK_5_21_11", e.OMUK_6 = "OMUK_6", e.OMUK_6_1 = "OMUK_6_1", e.OMUK_6_2 = "OMUK_6_2", e.UNCATEGORIZED = "UNCATEGORIZED";
})(V0e || (V0e = {}));
var r6;
(function(e) {
  e.DRAWING = "DRAWING", e.FUNCTIONAL_DESCRIPTION = "FUNCTIONAL_DESCRIPTION", e.FLOORPLAN = "FLOORPLAN", e.SCHEMATIC_DRAWING = "SCHEMATIC_DRAWING", e.PRODUCT_DATA_SHEET = "PRODUCT_DATA_SHEET", e.PRODUCT_CATALOGUE = "PRODUCT_CATALOGUE", e.BUILDING_INFORMATION = "BUILDING_INFORMATION", e.CALCULATIONS_CAPACITY = "CALCULATIONS_CAPACITY", e.DESIGN_BASIS = "DESIGN_BASIS", e.CERTIFICATES = "CERTIFICATES", e.DECLARATION_OF_CONFORMITY = "DECLARATION_OF_CONFORMITY", e.CONTROL_DOCUMENT = "CONTROL_DOCUMENT", e.FIRE_DOCUMENTATION = "FIRE_DOCUMENTATION", e.NO_CATEGORY = "NO_CATEGORY", e.ADDRESS_AND_TELEPHONE_LIST = "ADDRESS_AND_TELEPHONE_LIST", e.DESCRIPTION = "DESCRIPTION", e.IMAGE = "IMAGE", e.USER_MANUAL = "USER_MANUAL", e.PRELIMINARY_INSPECTION = "PRELIMINARY_INSPECTION", e.MANAGEMENT_DOCUMENT = "MANAGEMENT_DOCUMENT", e.REQUIREMENT_ACHIEVEMENT = "REQUIREMENT_ACHIEVEMENT", e.OVERVIEWS_AND_LISTS = "OVERVIEWS_AND_LISTS", e.TAKEOVER_PROTOCOL = "TAKEOVER_PROTOCOL", e.PRODUCT_INFORMATION = "PRODUCT_INFORMATION", e.PROTOCOL = "PROTOCOL", e.REPORT = "REPORT", e.ADDITIONAL_ORDER = "ADDITIONAL_ORDER", e.COMPLETED_CHECKLISTS = "COMPLETED_CHECKLISTS", e.MAINTENANCE = "MAINTENANCE", e.NOTE = "NOTE", e.SCHEMA = "SCHEMA", e.CALCULATION = "CALCULATION", e.BUILDING_PRODUCT_DECLARATION = "BUILDING_PRODUCT_DECLARATION", e.DISASSEMBLY_ASSEMBLY_INSTRUCTION = "DISASSEMBLY_ASSEMBLY_INSTRUCTION", e.GUARANTEE = "GUARANTEE", e.SDS_DATASHEET = "SDS_DATASHEET", e.ELECTRICAL_CIRCUIT_DIRECTORY = "ELECTRICAL_CIRCUIT_DIRECTORY", e.LIGHT_FIXTURES = "LIGHT_FIXTURES", e.LOCKS_AND_FITTINGS = "LOCKS_AND_FITTINGS", e.LIST_OF_MATERIALS = "LIST_OF_MATERIALS", e.ENVIRONMENTAL_DECLARATION = "ENVIRONMENTAL_DECLARATION", e.ORDER_CONFIRMATION = "ORDER_CONFIRMATION", e.CHECKLIST = "CHECKLIST", e.ELECTRICAL_PANEL_DOCUMENTATION = "ELECTRICAL_PANEL_DOCUMENTATION", e.GUIDANCE = "GUIDANCE", e.PERFORMANCE_DECLARATION = "PERFORMANCE_DECLARATION", e.COMPLIANCES = "COMPLIANCES", e.COMPONENT_AND_INSTALLATION_DOCUMENTATION = "COMPONENT_AND_INSTALLATION_DOCUMENTATION";
})(r6 || (r6 = {}));
var $_;
(function(e) {
  e.PROCESSOR = "PROCESSOR", e.CONSIGLI = "CONSIGLI", e.CUSTOMER = "CUSTOMER";
})($_ || ($_ = {}));
var Oye;
(function(e) {
  e.PRIMARY_VERSION = "PRIMARY_VERSION", e.SECONDARY_VERSION = "SECONDARY_VERSION", e.COMMENT_VERSION = "COMMENT_VERSION";
})(Oye || (Oye = {}));
var VP;
(function(e) {
  e.PENDING = "PENDING", e.UPLOADING = "UPLOADING", e.UPLOADED = "UPLOADED", e.UPLOAD_FAILED = "UPLOAD_FAILED", e.UNPARSED = "UNPARSED", e.PARSED = "PARSED", e.PARSING_FAILED = "PARSING_FAILED", e.DUPLICATE = "DUPLICATE";
})(VP || (VP = {}));
var z0e;
(function(e) {
  e.SCHEDULE_FILE = "SCHEDULE_FILE", e.DRAWINGS = "DRAWINGS", e.SCHEMATIC_DRAWINGS = "SCHEMATIC_DRAWINGS";
})(z0e || (z0e = {}));
var j0e;
(function(e) {
  e.SCHEDULE = "SCHEDULE", e.PID = "PID", e.SPECS = "SPECS";
})(j0e || (j0e = {}));
const r7e = ki(VP), l7e = ki(z0e), a7e = ti({
  is_sample_report: ts().optional(),
  water_process_file_type: ki(j0e).optional()
}).passthrough().transform(Ii), u7e = ti({
  remaining_occurrences: Ft().int().optional(),
  data: Ri(ti({
    id: Ft().int(),
    content: Le()
  })).optional()
}).strict().transform(Ii), W0e = fh([ki(V0e), ki(TW)]), Rpe = ti({
  id: Le().uuid(),
  project: G5.innerType().shape.id,
  document_package: kP.innerType().shape.id,
  md5: Le().nullable(),
  name: Le(),
  name_suggestion: Le().nullable(),
  extension: Le(),
  parsed_status: r7e,
  file_url: Le(),
  download_url: Le(),
  parsed_data: u7e,
  is_drawing_index_list: ts(),
  is_checklist: ts(),
  schedule_check_file_type: l7e.nullable().optional(),
  original_file_id: Le().uuid(),
  converted_pdf_file_id: Le().uuid().nullable(),
  ocr_pdf_file_id: Le().uuid().nullable(),
  ns3451: Ri(ki(TW)),
  document_type: Ri(ki(r6)),
  labels_reused: ts(),
  external_famac_file_id: Le().nullable(),
  folder_structure: Ri(W0e),
  metadata: a7e.optional()
}).strict().transform(Ii);
em(Rpe);
ti({
  project_id: Ft().int(),
  package_id: Le().uuid(),
  page: fh([Ft().int(), hE("all")]),
  page_size: Ft().int().nullish(),
  search: Le().nullish(),
  search_parsed_data: Le().nullish(),
  status: Ri(ki(VP)).nullish(),
  suggestion: ts().nullish(),
  standard: Le().nullish(),
  document_type: Ri(ki(r6)).nullish(),
  blob_ids: Ri(Le().uuid()).nullish(),
  labels_reused: ts().nullish(),
  // Bid Review: scope to a single role via blob `metadata.reference`
  // (`primary_reference`, a contractor name, `bid_levelling`, or `__other__`).
  reference: Le().nullish()
}).strict().transform(Ii);
Rpe.innerType().pick({
  document_package: !0,
  // TODO: Remove once Blob is nested under packages in API
  name: !0,
  parsed_status: !0,
  original_file_id: !0,
  is_drawing_index_list: !0,
  is_checklist: !0,
  // it has to be one word checklist because in backend it is is_checklist
  schedule_check_file_type: !0,
  metadata: !0
}).required().partial({
  schedule_check_file_type: !0,
  metadata: !0
}).strict().transform(Ii);
ti({
  read_url: Le()
}).strict().transform(Ii);
ti({
  upload_url: Le()
}).strict().transform(Ii);
Ri(Rpe).transform(Ii);
ti({
  parsed: Ft().int(),
  unparsed: Ft().int(),
  duplicate: Ft().int(),
  corrupted: Ft().int(),
  suggestion: Ft().int()
}).strict().transform(Ii);
ti({
  project_id: Ft().int(),
  package_id: Le().uuid(),
  search_parsed_data: Le().nullish(),
  blob_ids: Ri(Le().uuid()).nullish(),
  search: Le().nullish()
}).strict().transform(Ii);
ti({
  project_id: Ft().int(),
  package_id: Le().uuid(),
  document_type: Ri(ki(r6)),
  search_parsed_data: Le().nullable(),
  blob_ids: Ri(Le().uuid()).nullish(),
  search: Le().nullable(),
  status: Ri(ki(VP)).nullish(),
  labels_reused: ts().nullish()
}).strict().transform(Ii);
Kp(Ft());
ti({
  project_id: Ft().int(),
  package_id: Le().uuid(),
  standard: Le().nullish(),
  search_parsed_data: Le().nullish(),
  documentType: Ri(ki(r6)).nullish(),
  blob_ids: Ri(Le().uuid()).nullish(),
  search: Le().nullish(),
  status: Ri(ki(VP)).nullish(),
  labels_reused: ts().nullish()
}).strict().transform(Ii);
Ri(ki(r6));
const d7e = ti({
  blob_id: Le().uuid(),
  blob_name: Le(),
  ns3451: ti({
    from: ti({
      value: Ri(ki(TW)),
      created_by: ki($_).nullable()
    }),
    to: ti({
      value: Ri(ki(TW)),
      created_by: ki($_).nullable()
    })
  }),
  document_type: ti({
    from: ti({
      value: Ri(ki(r6)),
      created_by: ki($_).nullable()
    }),
    to: ti({
      value: Ri(ki(r6)),
      created_by: ki($_).nullable()
    })
  }),
  folder_structure: ti({
    from: ti({
      value: Ri(W0e),
      created_by: ki($_).nullable()
    }),
    to: ti({
      value: Ri(W0e),
      created_by: ki($_).nullable()
    })
  })
}).strict().transform(Ii);
em(d7e);
ti({
  project_id: Ft().int(),
  package_id: Le().uuid(),
  page: fh([Ft().int(), hE("all")])
}).strict().transform(Ii);
Ri(ti({
  id: Le().uuid(),
  name: Le()
}).strict().transform(Ii));
ti({
  project_id: Ft().int(),
  package_id: Le().uuid(),
  search_parsed_data: Le().nullish(),
  status: Ri(ki(VP)).nullish(),
  document_type: Ri(ki(r6)).nullish(),
  standard: Le().nullish()
}).strict().transform(Ii);
Ri(Le());
ti({
  project_id: Ft().int(),
  package_id: Le().uuid()
}).strict().transform(Ii);
Kp(Ft());
ti({
  project_id: Ft().int(),
  package_id: Le().uuid(),
  status: Ri(ki(VP)).nullish()
}).strict().transform(Ii);
var rX;
(function(e) {
  e.PENDING = "PENDING", e.UPLOADING = "UPLOADING", e.UPLOADED = "UPLOADED";
})(rX || (rX = {}));
var lX;
(function(e) {
  e.IFC = "IFC", e.REVIT = "REVIT", e.REPORTS = "REPORTS", e.OTHERS = "OTHERS", e.DRAWINGS_2D = "DRAWINGS_2D", e.VENTILATION_RATES = "VENTILATION_RATES", e.STRATEGIES = "STRATEGIES", e.ACOUSTIC_REPORT = "ACOUSTIC_REPORT", e.COMMISSIONING_REPORT = "COMMISSIONING_REPORT", e.FIRE_REPORT = "FIRE_REPORT", e.LUMINAIRE = "LUMINAIRE";
})(lX || (lX = {}));
const wL = ti({
  id: Le().uuid(),
  project_id: Ft().int(),
  upload_status: ki(rX),
  url: Le().min(1),
  filename: Le(),
  filename_extension: Le(),
  original_filename: Le(),
  mime_type: Le().optional(),
  size_bytes: Ft().int().optional(),
  md5: Le().nullable(),
  uploaded_by: Le().uuid(),
  created_at: Le().datetime(),
  file_url: Le()
}).strict().transform(Ii);
ti({
  uploadUrl: Le()
});
ti({
  read_url: Le()
}).strict().transform(Ii);
ti({
  uploadStatus: ki(rX).optional(),
  mimeType: Le().optional(),
  sizeBytes: Ft().int().optional(),
  md5: Le().optional(),
  originalFilename: Le().optional()
}).strict().transform(Ii);
ti({
  uploadStatus: ki(rX).optional(),
  originalFilename: Le(),
  mimeType: Le().optional(),
  sizeBytes: Ft().int().optional()
}).strict().transform(Ii);
ti({
  original_filename: Le(),
  read_url: Le()
}).strict().transform(Ii);
var DP;
(function(e) {
  e.CEILING_GRID = "CEILING_GRID", e.LOAD_CALCULATION = "LOAD_CALCULATION", e.WASTEWATER_TREATMENT = "WASTEWATER_TREATMENT";
})(DP || (DP = {}));
DP.CEILING_GRID + "", DP.LOAD_CALCULATION + "", DP.WASTEWATER_TREATMENT + "";
var qF;
(function(e) {
  e.PROCESSING_SPEC_REQUIREMENTS_STEP = "PROCESSING_SPEC_REQUIREMENTS_STEP", e.USER_REVIEW_SPEC_REQUIREMENTS_STEP = "USER_REVIEW_SPEC_REQUIREMENTS_STEP", e.PROCESSING_LOAD_CALCULATION_STEP = "PROCESSING_LOAD_CALCULATION_STEP", e.PUBLISHED_LOAD_CALCULATION_STEP = "PUBLISHED_LOAD_CALCULATION_STEP";
})(qF || (qF = {}));
const hae = ti({
  id: Le().uuid(),
  project_id: G5.innerType().shape.id,
  name: Le().min(1),
  error_message: Ri(Le()).optional(),
  warning_message: Ri(Le()).optional(),
  health_check: ts().nullish(),
  updated_at: Le(),
  created_at: Le(),
  created_by: Le().uuid().nullable(),
  type: ki(DP),
  workflow_step: ki(qF).nullable(),
  is_hidden: ts()
}).strict().transform(Ii);
Ri(hae).transform(Ii);
em(hae);
hae.innerType().pick({
  name: !0
}).merge(ti({
  file_ids: Ri(wL.innerType().shape.id),
  type: ki(DP).optional(),
  language: ki(oX).optional(),
  workflow_step: ki(qF).optional()
})).strict().transform(uL);
ti({
  workflow_step: ki(qF)
}).partial().strict().transform(uL);
ti({
  project_id: Ft().int(),
  building_package_id: Le().uuid(),
  page: fh([Ft().int(), hE("all")]),
  page_size: Ft().int().nullish(),
  search: Le().nullish()
}).strict().transform(Ii);
em(wL);
ti({
  project_id: Ft().int(),
  type: ki(DP).optional(),
  page: fh([Ft().int(), hE("all")]),
  page_size: Ft().int().nullish()
}).strict().transform(Ii);
ti({
  id: Le().uuid(),
  building_package_id: hae.innerType().shape.id,
  data: ti({}).passthrough().nullable(),
  updated_at: Le(),
  created_at: Le()
}).strict().transform(Ii);
ti({
  data: ti({}).passthrough().nullable()
}).strict().transform(uL);
ti({}).passthrough();
ti({
  data: ti({}).passthrough().nullable()
}).partial().strict().transform(uL);
ti({}).passthrough();
const MTe = ti({
  id: Le().uuid(),
  building_package_id: Le().uuid(),
  file: wL,
  type: ki(lX),
  updated_at: Le().datetime(),
  created_at: Le().datetime()
}).strict().transform(Ii);
em(MTe);
Ri(MTe).transform(Ii);
ti({
  file_id: Le().uuid(),
  type: ki(lX)
}).strict().transform(Ii);
ti({
  project_id: Ft().int(),
  building_package_id: Le().uuid(),
  page: fh([Ft().int(), hE("all")]),
  page_size: Ft().int().nullish(),
  search: Le().nullish()
}).strict().transform(Ii);
qF.PROCESSING_LOAD_CALCULATION_STEP, qF.PUBLISHED_LOAD_CALCULATION_STEP;
const UTe = ti({
  id: Le().uuid(),
  document_package_id: Le().uuid(),
  file: wL,
  processor: ki(an),
  type: ki(Uo),
  updated_at: Le().datetime(),
  created_at: Le().datetime()
}).strict().transform(Ii);
em(UTe);
Ri(UTe).transform(Ii);
ti({
  file_id: Le().uuid(),
  processor: ki(an),
  type: ki(Uo)
}).strict().transform(Ii);
ti({
  project_id: Ft().int(),
  document_package_id: Le().uuid(),
  page: fh([Ft().int(), hE("all")]),
  page_size: Ft().int().nullish(),
  search: Le().nullish(),
  processor: ki(an).nullish(),
  type: ki(Uo).nullish()
}).strict().transform(Ii);
ti({
  project_id: Ft().int(),
  document_package_id: Le().uuid(),
  result_id: Le().uuid()
}).strict().transform(Ii);
const c7e = ti({
  id: Le().uuid(),
  category_type: Le(),
  heading: Le(),
  body: Le(),
  finding_ids: Ri(Ft())
}).strict().transform(Ii), h7e = ti({
  id: Le().uuid(),
  document_package_id: Ft(),
  description: Le(),
  created_at: Le(),
  sections: Ri(c7e)
}).strict().transform(Ii);
Ri(h7e);
var Y0e;
(function(e) {
  e.INITIALIZED = "INITIALIZED", e.DONE = "DONE", e.ERROR = "ERROR";
})(Y0e || (Y0e = {}));
var q0e;
(function(e) {
  e.FAMAC = "FAMAC";
})(q0e || (q0e = {}));
const f7e = ki(Y0e), I7e = ki(q0e), vpe = ti({
  id: Ft().int(),
  document_package_id: Le().uuid(),
  type: I7e,
  status: f7e,
  status_message: Le()
}).strict().transform(Ii);
vpe.innerType().omit({
  id: !0,
  document_package_id: !0,
  status_message: !0
}).strict().transform(uL);
vpe.transform(Ii);
Ri(vpe).transform(Ii);
const p7e = ti({
  sheet_name: Le(),
  row: Ri(Ft().int()).nullish(),
  col: Ri(Ft().int()).nullish(),
  column_name: Ri(Le()).nullish()
}), BTe = ti({
  blob_id: Le(),
  page: Ft().int(),
  label: Le().optional(),
  // Set when the cited blob lives in a different package than the bids (the
  // tender/reference document); the read URL is fetched against this package.
  document_package_id: Le().optional(),
  passage: Le().optional(),
  x0: Ft().optional(),
  y0: Ft().optional(),
  x1: Ft().optional(),
  y1: Ft().optional(),
  // The original blob file name, so the frontend can detect Excel files and
  // open the spreadsheet viewer instead of the PDF viewer.
  file_name: Le().optional(),
  // Cell coordinates for Excel highlighting (sheet, row, col).
  excel_metadata: p7e.nullish()
}), m7e = ti({
  contractor_id: Le(),
  value: Le(),
  // ADDRESSED or PARTIAL — drives the cell's color mark. Optional so a stale
  // payload without it still parses.
  conflict_type: Le().optional(),
  // The formatted amount when the bid provided a concrete value (number or
  // percentage). Present only when `value` was derived from the amount field.
  amount: Le().optional(),
  // The verbatim bid extract, carried alongside `value`.
  bid_extract: Le().optional(),
  // The bid-gaps narrative for the requirement, carried alongside `value`.
  bid_context: Le().optional(),
  citation: BTe.optional()
}), y7e = ti({
  id: Le(),
  name: Le()
}), E7e = ti({
  id: Le(),
  item: Le(),
  category: Le(),
  weight: Ft(),
  // AI sort-order priority for the requirement: 1 is the highest priority, 10
  // the lowest, with an unranked requirement defaulted to 10. 11 is the "not
  // comparable" bucket, which the Offer table hides.
  rank: Ft().int(),
  // The tender/requirement source document, opened from the Item column.
  reference: BTe.optional(),
  cells: Ri(m7e)
});
ti({
  summary: Le(),
  bids_compared: Ft().int(),
  items_leveled: Ft().int(),
  total_weighting: Ft(),
  contractors: Ri(y7e),
  rows: Ri(E7e)
}).strict().transform(Ii);
const _F = {
  SKILL: "SKILL",
  ERROR: "ERROR",
  GENERAL: "GENERAL"
};
_F.GENERAL + "", _F.SKILL + "", _F.ERROR + "";
ti({
  type: ki(_F),
  service: Le().optional(),
  message: Le()
}).strict();
ti({
  id: Le().uuid(),
  type: ki(_F),
  service: Le().nullable(),
  message: Le(),
  created_at: Le().datetime(),
  user_email: Le()
}).strict().transform(Ii);
const g7e = ti({
  id: Le().uuid(),
  type: ki(_F),
  service: Le().nullable(),
  message: Le(),
  created_at: Le().datetime(),
  user_email: Le()
}).strict().transform(Ii);
ti({
  page: Ft().int().optional(),
  pageSize: Ft().int().optional(),
  type: ki(_F).optional(),
  service: Le().optional(),
  createdAtFrom: Le().optional(),
  createdAtTo: Le().optional()
}).strict();
em(g7e);
var $0e;
(function(e) {
  e.USER_COMMENT = "USER_COMMENT", e.SYSTEM_COMMENT_FORWARDED = "SYSTEM_COMMENT_FORWARDED";
})($0e || ($0e = {}));
const FTe = ti({
  id: Ft().int(),
  authorId: PTe.innerType().shape.id.nullish(),
  authorName: Le().nullish(),
  findingId: Ft().int(),
  text: Le().nullish(),
  created_at: Le().nullish(),
  type: ki($0e)
}).strict().transform(Ii);
Ri(FTe).transform(Ii);
var $F;
(function(e) {
  e.NOT_RELEVANT = "NOT_RELEVANT", e.ACTIVE = "ACTIVE", e.PROCESSING = "PROCESSING", e.PROCESSED = "PROCESSED", e.DELETED = "DELETED";
})($F || ($F = {}));
var K0e;
(function(e) {
  e.MISSING = "MISSING", e.PARTIAL = "PARTIAL", e.COMPLETE = "COMPLETE";
})(K0e || (K0e = {}));
var zP;
(function(e) {
  e.RISK = "RISK", e.INSIGHT = "INSIGHT", e.PROPERTY = "PROPERTY", e.COMPANY = "COMPANY", e.RENTAL_AGREEMENT = "RENTAL_AGREEMENT", e.MISSING_DOCUMENTATION = "MISSING_DOCUMENTATION", e.GAPS = "GAPS";
})(zP || (zP = {}));
var jP;
(function(e) {
  e.REFERENCE_ERROR_BUILDING_PART_TABLE = "REFERENCE_ERROR_BUILDING_PART_TABLE", e.REFERENCE_ERROR_STANDARD = "REFERENCE_ERROR_STANDARD", e.REFERENCE_ERROR_STANDARD_DELETED = "REFERENCE_ERROR_STANDARD_DELETED", e.CHECKLIST = "CHECKLIST", e.OTHER_LANGUAGE = "OTHER_LANGUAGE", e.PRODUCT_SPECIFICATION = "PRODUCT_SPECIFICATION", e.UNCLEAR_WORDING = "UNCLEAR_WORDING", e.INCORRECT_WORDING = "INCORRECT_WORDING", e.PROJECT_RECOMMENDATION = "PROJECT_RECOMMENDATION", e.RECOMMENDATIONS = "RECOMMENDATIONS", e.RISK_INDUCING_TEXT = "RISK_INDUCING_TEXT", e.MISSING_REQUIREMENTS = "MISSING_REQUIREMENTS", e.SIMILAR_PARAGRAPH = "SIMILAR_PARAGRAPH", e.IDENTICAL_SENTENCE = "IDENTICAL_SENTENCE", e.TIME_PERIODS = "TIME_PERIODS", e.DEADLINES = "DEADLINES", e.UNDEFINED_DEADLINES = "UNDEFINED_DEADLINES", e.CONTRADICTIONS = "CONTRADICTIONS", e.FORMATTING = "FORMATTING", e.DEVIATION_PRODUCT_NAME = "DEVIATION_PRODUCT_NAME", e.PRICES = "PRICES", e.RESPONSIBILITY = "RESPONSIBILITY", e.REFERENCE_ERROR = "REFERENCE_ERROR", e.RESERVATIONS_AND_CLARIFICATIONS = "RESERVATIONS_AND_CLARIFICATIONS", e.DISCLAIMERS = "DISCLAIMERS", e.UNDEFINED_REQUIREMENTS = "UNDEFINED_REQUIREMENTS", e.CORPORATE_LAW_CONDITIONS = "CORPORATE_LAW_CONDITIONS", e.INFORMATION_SERVICE_AGREEMENT = "INFORMATION_SERVICE_AGREEMENT", e.INFORMATION_RENTAL_AGREEMENT = "INFORMATION_RENTAL_AGREEMENT", e.RISK_LEASE_AGREEMENT = "RISK_LEASE_AGREEMENT", e.DEVIATION_FROM_STANDARD_LEASE_AGREEMENT = "DEVIATION_FROM_STANDARD_LEASE_AGREEMENT", e.PROPERTY_RELATIONS = "PROPERTY_RELATIONS", e.TECHNICAL_INFORMATION = "TECHNICAL_INFORMATION", e.ENCUMBRANCES = "ENCUMBRANCES", e.REGULATORY_CONDITIONS = "REGULATORY_CONDITIONS", e.IMPROVEMENTS = "IMPROVEMENTS", e.REFERENCE_ERROR_STANDARD_ALT = "REFERENCE_ERROR_STANDARD_ALT", e.DEVIATION_CERTIFICATION = "DEVIATION_CERTIFICATION", e.DUPLICATED_DOCUMENTS = "DUPLICATED_DOCUMENTS", e.DOCUMENT_REFERENCES = "DOCUMENT_REFERENCES", e.SPECIFICATION_REQUIREMENTS = "SPECIFICATION_REQUIREMENTS", e.PROJECT_RECOMMENDATION_ALT = "PROJECT_RECOMMENDATION_ALT", e.LIMITATIONS_OF_LIABILITY = "LIMITATIONS_OF_LIABILITY", e.DURABILITY_PRODUCTS = "DURABILITY_PRODUCTS", e.OPERATIONAL_INFORMATION = "OPERATIONAL_INFORMATION", e.MAINTENANCE_INTERVAL = "MAINTENANCE_INTERVAL", e.SERVICE_AGREEMENT = "SERVICE_AGREEMENT", e.DEVIATION_INDOOR_REQUIREMENTS = "DEVIATION_INDOOR_REQUIREMENTS", e.DEVIATION_SOUND_REQUIREMENTS = "DEVIATION_SOUND_REQUIREMENTS", e.DEVIATION_CEILING_TYPE = "DEVIATION_CEILING_TYPE", e.COMPLAINT_RULES = "COMPLAINT_RULES", e.LIFESPAN_AND_DURABILITY = "LIFESPAN_AND_DURABILITY", e.SERVICE_AGREEMENT_RECOMMENDATION = "SERVICE_AGREEMENT_RECOMMENDATION", e.SERVICE_AGREEMENT_NECESSARY = "SERVICE_AGREEMENT_NECESSARY", e.SERVICE_AGREEMENT_AGREED = "SERVICE_AGREEMENT_AGREED", e.WARRANTY_CONDITIONS = "WARRANTY_CONDITIONS", e.WORKING_DRAWINGS = "WORKING_DRAWINGS", e.MISSING_DOCUMENTATION = "MISSING_DOCUMENTATION", e.UNDEFINED_CLEANING_INTERVALS = "UNDEFINED_CLEANING_INTERVALS", e.CLEANING_INTERVALS = "CLEANING_INTERVALS", e.WARRANTY_PERIOD = "WARRANTY_PERIOD", e.UNDEFINED_MAINTENANCE_INTERVAL = "UNDEFINED_MAINTENANCE_INTERVAL", e.DEVIATION_GENERAL_SPECIFICATIONS = "DEVIATION_GENERAL_SPECIFICATIONS", e.DEVIATION_ORG_NR = "DEVIATION_ORG_NR", e.LAWSUITS_AND_DISPUTES = "LAWSUITS_AND_DISPUTES", e.KEY_INFORMATION = "KEY_INFORMATION", e.GROUND_CONDITIONS = "GROUND_CONDITIONS", e.ENVIRONMENT = "ENVIRONMENT", e.GOVERNING_INTEREST = "GOVERNING_INTEREST", e.HISTORY = "HISTORY", e.DELETED_ORG = "DELETED_ORG", e.BANKRUPT_ORG = "BANKRUPT_ORG", e.ORGANIZATION_DISSOLUTION = "ORGANIZATION_DISSOLUTION", e.RENTAL_AGREEMENTS_OF_PROPERTY = "RENTAL_AGREEMENTS_OF_PROPERTY", e.ATTACHED_RENTAL_AGREEMENTS = "ATTACHED_RENTAL_AGREEMENTS", e.TRANSPORTED_RENTAL_AGREEMENTS = "TRANSPORTED_RENTAL_AGREEMENTS", e.MISSING_OM_DOCUMENTATION = "MISSING_OM_DOCUMENTATION", e.SIMILAR_PARAGRAPH_ALT = "SIMILAR_PARAGRAPH_ALT", e.DUPLICATED_REQUIREMENTS = "DUPLICATED_REQUIREMENTS", e.UNRESOLVED_ISSUES = "UNRESOLVED_ISSUES", e.MISSING_DRAWINGS = "MISSING_DRAWINGS", e.MISSING_CALLOUT = "MISSING_CALLOUT", e.MISSING_DETAIL = "MISSING_DETAIL", e.MISSING_INDEX = "MISSING_INDEX", e.MISSING_DRAWING_NAME_IN_INDEX = "MISSING_DRAWING_NAME_IN_INDEX", e.MISSING_TITLE = "MISSING_TITLE", e.MISSING_REVISION = "MISSING_REVISION", e.MISSING_INFORMATION = "MISSING_INFORMATION", e.MISSING_SCHEMATIC_DRAWINGS = "MISSING_SCHEMATIC_DRAWINGS", e.CONTRACT_TERMINOLOGY = "CONTRACT_TERMINOLOGY", e.DATES = "DATES", e.DEFICIENT_FUNCTIONAL_DESCRIPTIONS = "DEFICIENT_FUNCTIONAL_DESCRIPTIONS", e.EXCEPTIONS = "EXCEPTIONS", e.CLEANING_INSTRUCTIONS = "CLEANING_INSTRUCTIONS", e.IRREGULAR_TIME_PERIOD = "IRREGULAR_TIME_PERIOD", e.DEVIATION_ELECTRO_OG_AUTOMATION = "DEVIATION_ELECTRO_OG_AUTOMATION", e.DEVIATION_BATHROOM = "DEVIATION_BATHROOM", e.IDENTICAL_PARAGRAPH = "IDENTICAL_PARAGRAPH", e.SUGGESTED_FILENAME = "SUGGESTED_FILENAME", e.CONTRADICTIONS_OM = "CONTRADICTIONS_OM", e.CONTRADICTIONS_ENERGY_PERFORMANCE = "CONTRADICTIONS_ENERGY_PERFORMANCE", e.CONTRADICTION_TRIAL_PERIOD = "CONTRADICTION_TRIAL_PERIOD", e.FORCE_MAJEURE = "FORCE_MAJEURE", e.DEVIATION_FROM_STANDARD_LEASE_AGREEMENT_ALT = "DEVIATION_FROM_STANDARD_LEASE_AGREEMENT_ALT", e.PUBLIC_PROCUREMENT = "PUBLIC_PROCUREMENT", e.SITE_RISK = "SITE_RISK", e.CONTRACT_RISK = "CONTRACT_RISK", e.WITHDRAWN_STANDARD = "WITHDRAWN_STANDARD", e.INTERNATIONAL_STANDARD_REFERENCE = "INTERNATIONAL_STANDARD_REFERENCE", e.FIRE_SAFETY = "FIRE_SAFETY", e.UNCLEAR_WORDING_ALT = "UNCLEAR_WORDING_ALT", e.EDITABLE_DOCUMENTS = "EDITABLE_DOCUMENTS", e.MILESTONE = "MILESTONE", e.DELIVERABLE = "DELIVERABLE", e.SCALE_CITATION = "SCALE_CITATION", e.MISSING_UNITS = "MISSING_UNITS", e.MISSING_SCALE = "MISSING_SCALE", e.UNIT_DISPARITY = "UNIT_DISPARITY", e.MISSING_COUNTERPART_OR_ORPHAN = "MISSING_COUNTERPART_OR_ORPHAN", e.DUPLICATE_IDENTIFIER = "DUPLICATE_IDENTIFIER", e.ATTRIBUTE_CONFLICT = "ATTRIBUTE_CONFLICT", e.INCOMPLETE_DATA = "INCOMPLETE_DATA", e.INCOMPLETE_FUNCTION_OR_ASSEMBLY = "INCOMPLETE_FUNCTION_OR_ASSEMBLY", e.CONVENTION_NON_CONFORMANCE = "CONVENTION_NON_CONFORMANCE", e.SPECIFICATION_GAP = "SPECIFICATION_GAP", e.RATING_EXCEEDANCE = "RATING_EXCEEDANCE", e.REVISION_OR_CURRENCY = "REVISION_OR_CURRENCY", e.PARTIAL = "PARTIAL", e.MISSING = "MISSING", e.DEVIATION = "DEVIATION", e.ADDRESSED = "ADDRESSED";
})(jP || (jP = {}));
const fae = ti({
  id: Ft().int(),
  project_id: G5.innerType().shape.id,
  document_package_id: kP.innerType().shape.id,
  blob_id: Le().uuid().nullish(),
  file_name: Le().nullish(),
  // Generic passthrough of the source blob's `metadata.reference` role tag.
  // Bid Review (Offer) interprets it (contractor / tender / leveling template)
  // in `pages/offer/offer-references.ts`; null for services that don't set it.
  blob_reference: Le().nullish(),
  content: Le().nullish(),
  page_number: Ft().int().nullish(),
  status: ki($F),
  ref_document_package_id: Le().uuid().nullish(),
  ref_blob_id: Le().uuid().nullish(),
  ref_file_name: Le().nullish(),
  ref_blob_reference: Le().nullish(),
  ref_content: Le().nullish(),
  ref_page_number: Ft().int().nullish(),
  processor_name: ki(an),
  message_template: Le(),
  message_context: Kp(fh([Le(), Kp(sB()), Ri(sB())])),
  message_context_en: Kp(fh([Le(), Kp(sB()), Ri(sB())])),
  conflict_type: ki(jP),
  conflict_category: ki(zP),
  x0: Ft().nullish(),
  y0: Ft().nullish(),
  x1: Ft().nullish(),
  y1: Ft().nullish(),
  ref_x0: Ft().nullish(),
  ref_y0: Ft().nullish(),
  ref_x1: Ft().nullish(),
  ref_y1: Ft().nullish(),
  excel_metadata: ti({
    primary: ti({
      sheet_name: Le(),
      row: Ri(Ft().int()).nullish(),
      col: Ri(Ft().int()).nullish(),
      column_name: Ri(Le()).nullish()
    }).nullish(),
    ref: ti({
      sheet_name: Le(),
      row: Ri(Ft().int()).nullish(),
      col: Ri(Ft().int()).nullish(),
      column_name: Ri(Le()).nullish()
    }).nullish()
  }).nullish(),
  file_url: Le().nullable(),
  download_url: Le().nullable(),
  comments: Ri(FTe),
  labels: Ri(Le()).nullish()
}).strict().transform(Ii);
fae.innerType().omit({
  id: !0,
  project_id: !0,
  document_package_id: !0,
  file_name: !0,
  blob_reference: !0,
  ref_file_name: !0,
  ref_blob_reference: !0,
  comments: !0,
  file_url: !0,
  labels: !0
}).extend({
  conflict_message: Le()
}).strict().transform(uL);
fae.transform(Ii);
ti({
  project_id: Ft().int(),
  package_id: Le().uuid(),
  page: fh([Ft().int(), hE("all")]),
  page_size: Ft().int().nullish(),
  status: ki($F).nullish(),
  demo_view: ts().nullish(),
  conflict_type: ki(jP).nullish(),
  conflict_category: ki(zP).nullish(),
  blob_ids: Ri(Le()).nullish(),
  search: Le().nullish(),
  language: uie.nullish(),
  processor_name: ki(an).nullish(),
  commenters: Ri(Le()).nullish(),
  labels: Ri(Le()).nullish(),
  schedule_check_type: ki(K0e).nullish(),
  // Bid Review (Offer): scope findings to a single bid contractor.
  reference: Le().nullish(),
  // Bid Review (Offer): scope findings to bid documents only (all contractors),
  // resolved server-side instead of listing every bid blob id.
  bid_documents_only: ts().nullish()
}).strict().transform(Ii);
em(fae);
ti({
  project_id: Ft().int(),
  package_id: Le().uuid(),
  finding_id: Ft().int()
}).strict().transform(Ii);
Ri(fae).transform(Ii);
ti({ deleted_count: Ft().int() });
ti({
  project_id: Ft().int(),
  package_id: Le().uuid(),
  demo_view: ts().nullish(),
  status: ki($F).nullish(),
  conflict_type: ki(jP).nullish(),
  conflict_category: ki(zP).nullish(),
  commenters: Ri(Le()).nullish(),
  labels: Ri(Le()).nullish()
}).strict().transform(Ii);
Ri(ti({
  id: Le(),
  name: Le()
}).strict().transform(Ii));
ti({
  project_id: Ft().int(),
  package_id: Le().uuid(),
  demo_view: ts().nullish(),
  blob_ids: Ri(Le()).nullish(),
  commenters: Ri(Le()).nullish(),
  labels: Ri(Le()).nullish(),
  reference: Le().nullish(),
  bid_documents_only: ts().nullish()
}).strict().transform(Ii);
Kp(ti({
  count: Ft().int(),
  subcounts: Kp(Ft().int())
}).strict().transform(Ii));
ti({
  project_id: Ft().int(),
  package_id: Le().uuid(),
  demo_view: ts().nullish(),
  blob_ids: Ri(Le()).nullish(),
  conflict_type: ki(jP).nullish(),
  conflict_category: ki(zP).nullish(),
  commenters: Ri(Le()).nullish(),
  labels: Ri(Le()).nullish(),
  reference: Le().nullish(),
  bid_documents_only: ts().nullish(),
  processor_name: ki(an).nullish(),
  search: Le().nullish()
}).strict().transform(Ii);
Kp(Ft().int()).transform(Ii);
ti({
  project_id: Ft().int(),
  package_id: Le().uuid(),
  demo_view: ts().nullish(),
  blob_ids: Ri(Le()).nullish(),
  status: ki($F).nullish(),
  conflict_type: ki(jP).nullish(),
  conflict_category: ki(zP).nullish(),
  labels: Ri(Le()).nullish(),
  reference: Le().nullish()
}).strict().transform(Ii);
const w7e = ti({
  id: Le(),
  name: Le()
}).strict().transform(Ii);
Ri(w7e);
ti({
  project_id: Ft().int(),
  package_id: Le().uuid(),
  blob_ids: Ri(Le()).nullish(),
  demo_view: ts().nullish(),
  status: ki($F).nullish(),
  conflict_type: ki(jP).nullish(),
  conflict_category: ki(zP).nullish(),
  commenters: Ri(Le()).nullish(),
  bid_documents_only: ts().nullish()
}).strict().transform(Ii);
Ri(Le());
var Z0e;
(function(e) {
  e.ADDRESSED = "ADDRESSED", e.UNADDRESSED = "UNADDRESSED", e.INDETERMINATE = "INDETERMINATE", e.NA = "NA";
})(Z0e || (Z0e = {}));
var Q0e;
(function(e) {
  e.HIGH = "HIGH", e.MEDIUM = "MEDIUM", e.LOW = "LOW";
})(Q0e || (Q0e = {}));
var Jre;
(function(e) {
  e.UNREVIEWED = "UNREVIEWED", e.REVIEWED = "REVIEWED", e.RESOLVED = "RESOLVED", e.NOT_RELEVANT = "NOT_RELEVANT";
})(Jre || (Jre = {}));
const T7e = ti({
  id: Ft().int(),
  project_id: Ft().int(),
  document_package_id: Le().uuid(),
  processor_name: Le(),
  change_description: Le(),
  blob_id: Le().uuid().nullish(),
  blob_name: Le().nullish(),
  content: Le().nullish(),
  page_number: Ft().int().nullish(),
  x0: Ft().nullish(),
  y0: Ft().nullish(),
  x1: Ft().nullish(),
  y1: Ft().nullish(),
  // Only populated by the detail (retrieve) endpoint; the list omits it to avoid per-row SAS generation.
  file_url: Le().nullish(),
  ref_blob_id: Le().uuid().nullish(),
  ref_blob_name: Le().nullish(),
  ref_content: Le().nullish(),
  ref_page_number: Ft().int().nullish(),
  ref_x0: Ft().nullish(),
  ref_y0: Ft().nullish(),
  ref_x1: Ft().nullish(),
  ref_y1: Ft().nullish(),
  ref_file_url: Le().nullish(),
  comment_blob_id: Le().uuid().nullish(),
  comment_blob_name: Le().nullish(),
  comment_text: Le().nullish(),
  // Nothing is populated in comment_file_url from backend, just a placeholder.
  comment_file_url: Le().nullish(),
  reconciliation_status: ki(Z0e).nullish(),
  reconciliation_confidence: ki(Q0e).nullish(),
  // NOT NULL with a UNREVIEWED default on the backend, so every row carries it.
  review_status: ki(Jre).default(Jre.UNREVIEWED),
  // Page-pairing confidence (0-100) for the A->B page match this record came from.
  match_confidence: Ft().int().nullish(),
  created_at: Le(),
  updated_at: Le()
}).transform(Ii);
em(T7e);
ti({
  deleted_count: Ft().int()
});
Ri(ti({
  id: Le(),
  name: Le()
}).transform(Ii));
Kp(Ft().int());
ti({
  total_changes: Ft().int(),
  total_matched_changes: Ft().int(),
  total_comments: Ft().int(),
  total_addressed: Ft().int(),
  total_unaddressed: Ft().int(),
  total_indeterminate: Ft().int(),
  reconciliation_rate: Ft().int(),
  documents_analyzed: Ft().int(),
  documents_matched: Ft().int(),
  documents_unmatched: Ft().int(),
  // Defaulted so a summary response from an older backend (before these ship) still parses.
  pages_analyzed: Ft().int().default(0),
  pages_with_changes: Ft().int().default(0)
}).transform(Ii);
var Xre;
(function(e) {
  e.PENDING = "PENDING", e.ACCEPTED = "ACCEPTED", e.REJECTED = "REJECTED";
})(Xre || (Xre = {}));
const R7e = ti({
  id: Le().uuid(),
  role: ki(G0e)
}).strict().transform(Ii), v7e = ti({
  id: Ft().int(),
  name: Le().nullish(),
  role: ki(Zre),
  permissions: Ri(ki(fr))
}).strict().transform(Ii), Ape = ti({
  id: Le().uuid(),
  invited_by: Le().uuid(),
  invited_by_email: Le().email(),
  recipient: Le().email(),
  status: ki(Xre),
  language: ki(oX),
  organization: R7e.nullish(),
  projects: Ri(v7e).nullish(),
  expires_at: Le().datetime()
}).strict().transform(Ii);
ti({
  page: fh([Ft().int(), hE("all")]),
  page_size: Ft().int().nullish(),
  status: ki(Xre).nullish(),
  search: Le().nullish(),
  recipient: Le().email().nullish(),
  invited_by_email: Le().email().nullish()
}).strict().transform(Ii);
em(Ape);
Ape.innerType().pick({
  language: !0,
  organization: !0,
  projects: !0
}).extend({
  recipients: Ri(Le().email()).min(1)
}).strict().transform(Ii);
Ri(Ape);
ti({
  invited_by_email: Le().email().nullish()
}).strict().transform(Ii);
ti({
  count: Ft().int()
}).strict().transform(Ii);
var Kb;
(function(e) {
  e.FLOOR_PLAN = "FLOOR_PLAN", e.CEILING_PLAN = "CEILING_PLAN", e.PLANT_ROOM = "PLANT_ROOM", e.SPACE_ANALYSIS = "SPACE_ANALYSIS", e.PARKING = "PARKING", e.REPORTS = "REPORTS";
})(Kb || (Kb = {}));
Kb.FLOOR_PLAN + "", Kb.CEILING_PLAN + "", Kb.PLANT_ROOM + "", Kb.SPACE_ANALYSIS + "", Kb.PARKING + "", Kb.REPORTS + "";
const HTe = ti({
  id: Le().uuid(),
  project_id: G5.innerType().shape.id,
  name: Le().min(1),
  type: ki(Kb),
  data: XW(),
  language: uie.optional(),
  published: ts(),
  is_hidden: ts(),
  updated_at: Le(),
  created_at: Le(),
  created_by: Le().uuid().nullable()
}).strict().transform(Ii);
Ri(HTe).transform(Ii);
ti({
  project_id: Ft().int(),
  type: ki(Kb).optional()
}).strict().transform(Ii);
ti({
  project_id: Ft().int(),
  layout_id: Le().uuid(),
  page: fh([Ft().int(), hE("all")]),
  page_size: Ft().int().nullish(),
  search: Le().nullish()
}).strict().transform(Ii);
em(wL);
HTe.innerType().pick({
  name: !0,
  data: !0,
  type: !0,
  language: !0
}).merge(ti({ file_ids: Ri(wL.innerType().shape.id) })).strict().transform(uL);
const GTe = ti({
  id: Le().uuid(),
  layout_id: Le().uuid(),
  file: wL,
  updated_at: Le().datetime(),
  created_at: Le().datetime(),
  type: ki(lX)
}).strict().transform(Ii);
em(GTe);
Ri(GTe).transform(Ii);
ti({
  file_id: Le().uuid(),
  type: Le()
}).strict().transform(Ii);
ti({
  project_id: Ft().int(),
  layout_id: Le().uuid(),
  page: fh([Ft().int(), hE("all")]),
  page_size: Ft().int().nullish(),
  search: Le().nullish()
}).strict().transform(Ii);
const A7e = ti({
  id: Ft().int(),
  project_id: G5.innerType().shape.id,
  guid: Le().nullable(),
  file_name: Le().nullable(),
  el_number: Le().nullable(),
  content_type: Le().nullable(),
  paragraph_id: Le().nullable(),
  content: Le().nullable(),
  header_number: Le().nullable(),
  header_level: Ft().int().nullable(),
  document_package: kP.innerType().shape.id,
  page_number: Ft().int().nullable(),
  x0: Ft().nullable(),
  y0: Ft().nullable(),
  x1: Ft().nullable(),
  y1: Ft().nullable()
}).strict().transform(Ii);
Ri(A7e).transform(Ii);
var J0e;
(function(e) {
  e.STARTED = "STARTED";
})(J0e || (J0e = {}));
var RW;
(function(e) {
  e.DOCUMENT_PACKAGE = "DOCUMENT_PACKAGE", e.BUILDING_PACKAGE = "BUILDING_PACKAGE", e.LAYOUT_OPTIMIZATION = "LAYOUT_OPTIMIZATION";
})(RW || (RW = {}));
var as;
(function(e) {
  e.DEFAULT = "DEFAULT", e.VALIDATION_ONLY = "VALIDATION_ONLY", e.PRE_PARSING_ONLY = "PRE_PARSING_ONLY", e.PARSING_ONLY = "PARSING_ONLY", e.POST_PARSING_ONLY = "POST_PARSING_ONLY", e.TEXT_PROCESSING_ONLY = "TEXT_PROCESSING_ONLY", e.VALIDATION_TO_POST_PARSING = "VALIDATION_TO_POST_PARSING", e.VALIDATION_TO_TEXT_PROCESSING = "VALIDATION_TO_TEXT_PROCESSING", e.IFC_EXTRACTION_ONLY = "IFC_EXTRACTION_ONLY", e.IFC_EXPORT = "IFC_EXPORT", e.CEILING_GRID_OPTIMIZATION_ONLY = "CEILING_GRID_OPTIMIZATION_ONLY", e.DUCT_ROUTING_ONLY = "DUCT_ROUTING_ONLY", e.APARTMENT_ROUTING_ONLY = "APARTMENT_ROUTING_ONLY", e.CORRIDOR_ROUTING_ONLY = "CORRIDOR_ROUTING_ONLY", e.COMPARISON = "COMPARISON", e.REPORT_GENERATION_PRECHECK = "REPORT_GENERATION_PRECHECK", e.REPORT_TEMPLATE_CREATION = "REPORT_TEMPLATE_CREATION", e.REPORT_GENERATION = "REPORT_GENERATION", e.REPORT_GENERATION_ONLY = "REPORT_GENERATION_ONLY", e.PARKING = "PARKING", e.PLANT_ROOM = "PLANT_ROOM", e.ESCAPE_ROUTE = "ESCAPE_ROUTE", e.TEXT_COMPARISON_ONLY = "TEXT_COMPARISON_ONLY", e.LOAD_CALCULATION = "LOAD_CALCULATION", e.SCHEDULE_CHECK = "SCHEDULE_CHECK", e.SCHEDULE_CHECK_ONLY = "SCHEDULE_CHECK_ONLY", e.SPACE_ANALYSIS = "SPACE_ANALYSIS", e.POST_PROCESSING_ONLY = "POST_PROCESSING_ONLY", e.PACKAGE_COMPARISON = "PACKAGE_COMPARISON", e.PACKAGE_COMPARISON_ONLY = "PACKAGE_COMPARISON_ONLY", e.DOCUMENT_PACKAGE_REPORTS = "DOCUMENT_PACKAGE_REPORTS", e.LUMINAIRE_SCHEDULE = "LUMINAIRE_SCHEDULE", e.DOCUMENT_PACKAGE_REPORTS_ONLY = "DOCUMENT_PACKAGE_REPORTS_ONLY", e.REVIT_GENERATOR = "REVIT_GENERATOR", e.PARKING_REQUIREMENTS = "PARKING_REQUIREMENTS", e.APARTMENT_REQUIREMENTS = "APARTMENT_REQUIREMENTS", e.SPEC_REQUIREMENTS_EXTRACTION = "SPEC_REQUIREMENTS_EXTRACTION", e.SPEC_REQUIREMENTS_CATEGORIZATION = "SPEC_REQUIREMENTS_CATEGORIZATION", e.VERSION_COMPARE = "VERSION_COMPARE", e.BID_REVIEW = "BID_REVIEW", e.BID_REVIEW_MIRRORING_ONLY = "BID_REVIEW_MIRRORING_ONLY", e.METADATA_EXTRACTION_ONLY = "METADATA_EXTRACTION_ONLY", e.BID_REVIEW_TEXT_PROCESSING_ONLY = "BID_REVIEW_TEXT_PROCESSING_ONLY";
})(as || (as = {}));
const S7e = ki(as);
ti({
  status: ki(J0e),
  pipeline_job_id: Le().uuid()
}).strict().transform(Ii);
ti({
  pipelineName: S7e,
  projectId: G5.innerType().shape.id,
  packageId: kP.innerType().shape.id,
  secondaryPackageId: kP.innerType().shape.id.optional(),
  notify: ts().optional(),
  jobType: ki(RW),
  metadata: Kp(Le(), XW()).optional()
}).strict().transform(Ii);
var ele;
(function(e) {
  e.INITIALIZED = "INITIALIZED", e.STARTED = "STARTED", e.FAILED = "FAILED", e.COMPLETED = "COMPLETED", e.STOPPED = "STOPPED";
})(ele || (ele = {}));
const b7e = ki(ele), kTe = ti({
  id: Le().uuid(),
  project_id: G5.innerType().shape.id,
  package_id: kP.innerType().shape.id,
  job_type: ki(RW),
  package_type: ki(ro),
  secondary_package_id: kP.innerType().shape.id.nullish(),
  pipeline_name: Le(),
  type: Ft().int(),
  created_at: Le(),
  updated_at: Le(),
  status: b7e,
  language: uie,
  metadata: Kp(Le(), XW()).nullish()
}).strict().transform(Ii);
Ri(kTe).transform(Ii);
const N7e = ti({
  id: Le().uuid(),
  project_id: Ft().int(),
  package_id: Le().uuid(),
  job_type: Le(),
  pipeline_name: Le(),
  status: ki(ele),
  created_at: Le(),
  updated_at: Le(),
  current_stage: Le().nullable(),
  total_stages: Ft().int(),
  completed_stages: Ft().int(),
  total_tasks: Ft().int(),
  completed_tasks: Ft().int(),
  failed_tasks: Ft().int(),
  package_name: Le().nullable(),
  service_type: Le().nullable(),
  published: ts().nullable()
}).transform(Ii);
ti({
  count: Ft().int(),
  next: Le().nullable(),
  previous: Le().nullable(),
  results: Ri(N7e)
}).transform(Ii);
var X0e;
(function(e) {
  e.INITIALIZED = "INITIALIZED", e.STARTED = "STARTED", e.FAILED = "FAILED", e.COMPLETED = "COMPLETED";
})(X0e || (X0e = {}));
const D7e = ki(X0e), C7e = ti({
  job_id: kTe.innerType().shape.id,
  stage_name: Le(),
  status: D7e,
  status_description: Le().nullable(),
  created_at: Le(),
  updated_at: Le(),
  total_tasks: Ft(),
  total_failed_tasks: Ft(),
  completed_tasks: Ft(),
  is_all_tasks_complete: ts()
}).strict().transform(Ii);
Ri(C7e).transform(Ii);
var ehe;
(function(e) {
  e.INITIALIZED = "INITIALIZED", e.STARTED = "STARTED", e.FAILED = "FAILED", e.COMPLETED = "COMPLETED", e.SKIPPED = "SKIPPED";
})(ehe || (ehe = {}));
const VTe = ki(ehe), O7e = ti({
  id: Le().uuid(),
  processor_name: Le().nullable(),
  task_name: Le(),
  status: VTe,
  status_description: Le().nullable(),
  result_data: Kp(sB()).nullable(),
  created_at: Le(),
  updated_at: Le()
}).strict().transform(Ii);
em(O7e);
ti({
  projectId: Ft().int(),
  jobId: Le().uuid(),
  stageId: Le().uuid(),
  page: fh([Ft().int(), hE("all")]),
  page_size: Ft().int().nullish(),
  search: Le().nullish(),
  status: VTe.nullish()
}).strict().transform(Ii);
var aX;
(function(e) {
  e.STRUCTURAL = "STRUCTURAL";
})(aX || (aX = {}));
const L7e = ti({
  id: Le().uuid(),
  project_id: G5.innerType().shape.id,
  name: Le().min(1),
  type: ki(aX),
  data: XW(),
  is_hidden: ts(),
  updated_at: Le(),
  created_at: Le()
}).strict().transform(Ii);
Ri(L7e).transform(Ii);
ti({
  project_id: Ft().int(),
  type: ki(aX).optional()
}).strict().transform(Ii);
ti({
  name: Le().min(1),
  type: ki(aX),
  data: XW(),
  fileIds: Ri(Le().uuid()).optional()
}).strict().transform(Ii);
ti({
  structural_id: Le().uuid(),
  projectId: Ft().int(),
  page: fh([Ft().int(), hE("all")]),
  pageSize: Ft().int().optional(),
  search: Le().optional()
}).strict().transform(Ii);
em(wL);
var vW;
(function(e) {
  e.CAST_IN_PLACE = "CAST_IN_PLACE", e.STEEL_FRAME_WITH_HOLLOW_CORE_SLABS = "STEEL_FRAME_WITH_HOLLOW_CORE_SLABS", e.CONCRETE_COLUMNS_WITH_HOLLOW_CORE_SLABS = "CONCRETE_COLUMNS_WITH_HOLLOW_CORE_SLABS";
})(vW || (vW = {}));
const zTe = ti({
  id: Le().uuid(),
  structural_id: Le().uuid(),
  file: wL,
  concrete_volume: Ft().nullish(),
  steel_weight: Ft().nullish(),
  type: ki(vW),
  updated_at: Le().datetime(),
  created_at: Le().datetime()
}).strict().transform(Ii);
em(zTe);
Ri(zTe).transform(Ii);
ti({
  file_id: Le().uuid(),
  steel_weight: Ft().nullish(),
  concrete_volume: Ft().nullish(),
  type: ki(vW)
}).strict().transform(Ii);
ti({
  project_id: Ft().int(),
  structural_id: Le().uuid(),
  page: fh([Ft().int(), hE("all")]),
  page_size: Ft().int().nullish(),
  search: Le().nullish(),
  type: ki(vW).nullish()
}).strict().transform(Ii);
ti({
  project_id: Ft().int(),
  structural_id: Le().uuid()
}).strict().transform(Ii);
Kp(ki(vW), ti({ concrete_volume: Ft(), steel_weight: Ft() }).strict().transform(Ii));
const _7e = {
  question: Le(),
  language: uie
};
ti(_7e).strict().transform(Ii);
const x7e = ti({
  blob_id: Le().uuid(),
  content: Le()
}).strict().transform(Ii);
ti({
  answer: Le(),
  sources: Ri(x7e)
}).strict().transform(Ii);
ti({
  ready: ts()
}).strict().transform(Ii);
const P7e = ti({
  title: Le(),
  headers: Ri(Le()),
  data: Ri(Ri(fh([Le(), Ft()])))
}).strict().transform(Ii);
ti({
  project_id: Ft(),
  package_id: Le().uuid(),
  excel_export: P7e
}).strict().transform(Ii);
ti({
  base64_data: Le()
}).strict().transform(Ii);
const E_ = [
  as.DEFAULT,
  as.VALIDATION_ONLY,
  as.PRE_PARSING_ONLY,
  as.PARSING_ONLY,
  as.POST_PARSING_ONLY,
  as.TEXT_PROCESSING_ONLY,
  as.POST_PROCESSING_ONLY
], Lye = [
  as.VALIDATION_TO_TEXT_PROCESSING,
  as.VALIDATION_ONLY,
  as.PRE_PARSING_ONLY,
  as.PARSING_ONLY,
  as.POST_PARSING_ONLY,
  as.TEXT_PROCESSING_ONLY
], M7e = [
  ...E_,
  as.COMPARISON,
  as.TEXT_COMPARISON_ONLY,
  as.PACKAGE_COMPARISON,
  as.PACKAGE_COMPARISON_ONLY
];
ro.TENDER_DOCUMENTS + "", ro.TENANT_REQUIREMENTS + "", ro.OFFER + "", [
  ...E_,
  as.BID_REVIEW,
  as.BID_REVIEW_MIRRORING_ONLY,
  as.METADATA_EXTRACTION_ONLY,
  as.BID_REVIEW_TEXT_PROCESSING_ONLY
], ro.TENANT_SPECIFICATION + "", ro.MANAGEMENT_OPERATIONS_MAINTENANCE + "", ro.CONTRACT_REVIEW + "", ro.DUE_DILIGENCE + "", ro.DESIGN_PACKAGE_REVIEW + "", ro.RFP_RFQ_REVIEW + "", ro.LUMINAIRE_SCHEDULE + "", as.LUMINAIRE_SCHEDULE, ro.SITE_DUE_DILIGENCE + "", as.DOCUMENT_PACKAGE_REPORTS, as.DOCUMENT_PACKAGE_REPORTS_ONLY, as.VALIDATION_ONLY, as.PRE_PARSING_ONLY, ro.REPORT_GENERATION + "", as.REPORT_GENERATION_PRECHECK, as.REPORT_TEMPLATE_CREATION, as.REPORT_GENERATION, as.REPORT_GENERATION_ONLY, as.VALIDATION_ONLY, as.PRE_PARSING_ONLY, as.PARSING_ONLY, as.POST_PARSING_ONLY, ro.SCHEDULE_CHECK + "", as.SCHEDULE_CHECK, as.SCHEDULE_CHECK_ONLY, as.VALIDATION_ONLY, as.PRE_PARSING_ONLY, as.PARSING_ONLY, ro.VERSION_COMPARE + "", as.VERSION_COMPARE, ro.WATER_PROCESS_SYSTEMS_AGENT + "";
RW.BUILDING_PACKAGE + "", as.IFC_EXTRACTION_ONLY, as.IFC_EXPORT, as.LOAD_CALCULATION, as.CEILING_GRID_OPTIMIZATION_ONLY, as.DUCT_ROUTING_ONLY, as.APARTMENT_ROUTING_ONLY, as.CORRIDOR_ROUTING_ONLY, as.ESCAPE_ROUTE, as.REVIT_GENERATOR, as.VALIDATION_ONLY, as.PRE_PARSING_ONLY, as.PARSING_ONLY, as.POST_PARSING_ONLY, RW.LAYOUT_OPTIMIZATION + "", as.SPACE_ANALYSIS, as.PARKING, as.PLANT_ROOM;
const U7e = ti({
  id: Le(),
  name: Le(),
  report_type: Le(),
  project_type: Le(),
  location: Le(),
  file_url: Le(),
  file_name: Le(),
  file_extension: Le(),
  created_by: Le(),
  created_by_username: Le().optional(),
  updated_by: Le().nullable().optional(),
  updated_by_username: Le().nullable().optional(),
  created_at: Le(),
  updated_at: Le()
}).strict().transform(Ii);
ti({
  count: Ft(),
  next: Le().nullable(),
  previous: Le().nullable(),
  results: Ri(U7e)
});
var _ye;
(function(e) {
  e.FINDING = "FINDING", e.BLOB = "BLOB", e.FILE = "FILE", e.PARSED_DATA = "PARSED_DATA";
})(_ye || (_ye = {}));
var xye;
(function(e) {
  e.MEETING_SECRETARY = "MEETING_SECRETARY";
})(xye || (xye = {}));
const B7e = ti({
  id: Le().uuid(),
  title: Le(),
  description: Le().nullish(),
  created_at: Le(),
  updated_at: Le()
}).strict().transform(Ii), F7e = ti({
  id: Le().uuid(),
  email: Le(),
  name: Le().nullable().optional(),
  project_id: Ft(),
  consigli_user_id: Le().uuid().nullable().optional(),
  created_at: Le(),
  role: Le()
}), jTe = ti({
  id: Le().uuid(),
  consigli_user_id: Le().uuid().nullish(),
  title: Le(),
  description: Le().nullish(),
  scheduled_start_time: Le(),
  scheduled_end_time: Le(),
  location: Le().nullish(),
  organizer_email: Le().optional(),
  join_url: Le().url(),
  participants: Ri(F7e).optional(),
  document_package_id: Le().uuid().nullish(),
  project_id: Ft().nullish(),
  recording_completed: ts().nullish(),
  transcript_retrieval_completed: ts().nullish(),
  has_transcription: ts().nullish(),
  raw_ms_graph_meeting: Kp(XW()).optional(),
  created_at: Le(),
  updated_at: Le(),
  calendar_event_id: Le().nullish(),
  created_by_assistant: ts().nullish(),
  recurring_series_id: Le().uuid().nullish(),
  recurring_series: B7e.nullish(),
  recurring_series_title: Le().nullish(),
  is_active: ts().optional(),
  real_start_time: Le().nullish(),
  real_end_time: Le().nullish(),
  timezone: Le().nullish()
}).passthrough().transform(Ii), H7e = ti({
  meetings: Ri(jTe),
  total: Ft(),
  api_source: Le(),
  transcript_support: ts(),
  authentication_type: Le(),
  note: Le(),
  meeting_discovery: ti({
    total_events_checked: Le(),
    online_meetings_found: Ft(),
    id_format: Le()
  }),
  transcript_limitation: ti({
    issue: Le(),
    solution: Le()
  })
}).strict().transform(Ii);
fh([
  Ri(jTe).transform((e) => ({
    meetings: e,
    total: e.length,
    api_source: "database",
    transcript_support: !0,
    authentication_type: "oauth",
    note: "",
    meeting_discovery: {
      total_events_checked: "0",
      online_meetings_found: e.length,
      id_format: "uuid"
    },
    transcript_limitation: {
      issue: "",
      solution: ""
    }
  })),
  H7e
]);
ti({
  total_action_items: Ft(),
  total_meetings: Ft(),
  total_meeting_hours: Ft()
}).strict().transform((e) => ({
  totalActionItems: e.total_action_items,
  totalMeetings: e.total_meetings,
  totalMeetingHours: e.total_meeting_hours
}));
const G7e = ti({
  id: Le().uuid(),
  speaker_name: Le().nullable().optional(),
  cleaned_transcription_text: Le().nullable().optional(),
  start_ms: Ft().nullable().optional(),
  end_ms: Ft().nullable().optional(),
  locale: Le().nullable().optional(),
  source: Le().nullable().optional(),
  // Set once a segment is linked to a real MeetingUser. The backend clears
  // `speaker_name` and resolves the display name into `assigned_user_name`.
  assigned_meeting_user_id: Le().uuid().nullable().optional(),
  assigned_user_name: Le().nullable().optional(),
  // legacy fields kept for backward compatibility
  speaker: Le().optional(),
  transcription_text: Le().optional(),
  enriched_transcription_text: Le().nullable().optional()
}).passthrough().transform(Ii);
GA(["single", "all_same_name", "all_same_user"]);
ti({
  updated_count: Ft()
}).transform(Ii);
const k7e = ti({
  id: Le(),
  meeting_id: Le().optional(),
  content: Le().nullable().optional(),
  full_raw_text: Le().optional(),
  source: Le().optional(),
  creation_timestamp: Le().optional(),
  created_at: Le().optional(),
  updated_at: Le().optional(),
  createdDateTime: Le().optional(),
  segments: Ri(G7e).optional()
}).passthrough().transform(Ii), V7e = ti({
  transcripts: Ri(k7e),
  message_key: Le().optional(),
  // Only on a transcript list served straight from the database. True for the
  // organizer while the meeting still has text-only segments.
  can_regenerate_with_audio: ts().optional(),
  // A re-run found no recording, or the meeting belongs to another tenant: the audio cannot be
  // had, for anyone. Absent when the response never computes it, which is not the same as false.
  audio_unavailable: ts().optional(),
  audio_unavailable_reason: GA(["no_recording", "external_organizer"]).optional()
}).transform(Ii);
ti({
  transcripts: V7e,
  error: Le().optional(),
  user_friendly_message: Le().optional(),
  message: Le().optional()
}).passthrough().transform(Ii);
const z7e = ti({
  generated_summary_text: Le(),
  // The two editable sections, raw. Optional so an older backend still parses.
  summary_text: Le().optional(),
  key_discussion_points_text: Le().optional(),
  updated_at: Le().nullish(),
  key_discussion_points: Ri(Le()).optional(),
  related_documents: Ri(Le()).optional(),
  start: Le().nullish(),
  end: Le().nullish(),
  location: Le().nullish()
}).passthrough().transform(Ii);
e7e(z7e);
const die = ti({
  meeting_user_id: Le().nullable(),
  custom_party_id: Le().nullable(),
  name: Le().nullable()
}).transform(Ii), j7e = ti({
  // Backend may return either 'id' or 'action_item_id'
  id: Le().nullish(),
  action_item_id: Le().nullish(),
  description_text: Le(),
  completion_status: Le(),
  // Single responsible person (null when unassigned).
  responsible_person: die.nullish(),
  due_date: Le().nullish(),
  topic: Le().nullish(),
  status: Le().nullish(),
  supersedes_id: Le().nullish(),
  is_active: ts().nullish(),
  superseded_by_id: Le().nullish(),
  source_transcript_id: Le().nullish(),
  source_segment_ids: Ri(Le()).nullish()
}).passthrough().refine((e) => !!(e.id ?? e.action_item_id), {
  message: "ActionItem must have either id or action_item_id"
}).transform((e) => {
  const t = {
    ...e,
    // Cast is safe: refine above guarantees one of these is defined
    id: e.id ?? e.action_item_id
  };
  return Ii(t);
});
Ri(j7e);
const W7e = ti({
  id: Le(),
  meeting_id: Le(),
  description_text: Le(),
  responsible_person: die.nullish(),
  completion_status: Le(),
  source_transcript_id: Le().nullish(),
  source_segment_ids: Ri(Le()).nullish(),
  creation_timestamp: Le(),
  due_date: Le().nullish(),
  topic: Le().nullish(),
  meeting_title: Le().nullish(),
  meeting_scheduled_start_time: Le().nullish(),
  created_at: Le(),
  updated_at: Le(),
  status: Le().nullish(),
  supersedes_id: Le().nullish(),
  is_active: ts().nullish(),
  superseded_by_id: Le().nullish()
}).passthrough().transform(Ii);
Ri(W7e);
const WTe = ti({
  id: Le(),
  meeting_id: Le(),
  project_id: Ft(),
  agreement: Le(),
  source_text_from_transcript: Le().nullish(),
  source_segment_ids: Ri(Le()).nullish(),
  enriched_agreement: Le().nullish(),
  responsible_parties: Ri(die).nullish().default([]),
  aux_agreement_info: Ri(Le()).nullish(),
  has_meeting_contradictions: ts().nullish(),
  has_document_contradictions: ts().nullish(),
  active: ts().nullish(),
  created_by: GA(["meeting_assistant", "user"]).nullish(),
  created_at: Le().nullish(),
  updated_at: Le().nullish(),
  created_by_user_id: Le().nullish(),
  updated_by_user_id: Le().nullish(),
  // Built from a text-only transcript: only its own meeting sees it, until audio replaces it.
  provisional: ts().nullish()
}).passthrough().transform(Ii);
Ri(WTe);
ti({
  agreements: Ri(WTe).optional()
}).passthrough().transform(Ii);
const Y7e = ti({
  contradiction_id: Le(),
  agreement_id: Le(),
  confidence_score: Ft().optional(),
  contradiction_severity: GA(["low", "medium", "high"]).optional(),
  contradiction_reason: Le().optional(),
  contradiction_source_text: Le().optional(),
  created_at: Le().optional(),
  updated_at: Le().optional(),
  agreement_text: Le().optional(),
  responsible_parties: Ri(die).nullish().default([]),
  meeting_datetime: Le().nullish()
}).passthrough().transform(Ii), q7e = ti({
  id: Le(),
  project_id: Ft(),
  meeting_id: Le().nullish(),
  conflict_type: Le().optional(),
  title: Le().optional(),
  contradiction_description: Le().optional(),
  status: GA(["active", "resolved", "dismissed"]).optional(),
  notes: Le().nullish(),
  resolved_by_user_id: Le().nullish(),
  resolved_at: Le().nullish(),
  expires_at: Le().nullish(),
  provisional: ts().nullish(),
  created_at: Le().optional(),
  updated_at: Le().optional(),
  agreement_links: Ri(Y7e).optional()
}).passthrough().transform(Ii);
Ri(q7e);
const $7e = ti({
  contradiction_id: Le(),
  agreement_id: Le(),
  agreement_text: Le(),
  confidence_score: Ft().nullish(),
  contradiction_severity: GA(["low", "medium", "high"]).nullish(),
  contradiction_reason: Le().nullish(),
  contradiction_source_text: Le().nullish(),
  responsible_parties: Ri(die).nullish().default([]),
  meeting_datetime: Le().nullish(),
  created_at: Le(),
  updated_at: Le()
}).passthrough().transform(Ii), K7e = ti({
  id: Le(),
  contradiction_id: Le(),
  document_package_id: Le(),
  blob_id: Le().nullish(),
  chunk_text: Le(),
  highlight_text: Le().nullish(),
  el_numbers: Ri(Ft()).nullish(),
  file_name: Le().nullish(),
  page_numbers: Ri(Ft()).nullish(),
  /** 0-based page of the bounding box below, in the same space as ProcessorFinding. */
  page_index: Ft().nullish(),
  x0: Ft().nullish(),
  y0: Ft().nullish(),
  x1: Ft().nullish(),
  y1: Ft().nullish(),
  confidence_score: Ft().nullish(),
  contradiction_severity: GA(["low", "medium", "high"]).nullish(),
  contradiction_reason: Le().nullish(),
  created_at: Le(),
  updated_at: Le()
}).passthrough().transform(Ii), Z7e = ti({
  id: Le(),
  project_id: Ft(),
  meeting_id: Le().nullish(),
  conflict_type: Le(),
  title: Le(),
  contradiction_description: Le(),
  status: GA(["active", "resolved", "dismissed"]),
  notes: Le().nullish(),
  resolved_by_user_id: Le().nullish(),
  resolved_at: Le().nullish(),
  expires_at: Le().nullish(),
  provisional: ts().nullish(),
  created_at: Le(),
  updated_at: Le(),
  agreement_links: Ri($7e).default([]),
  chunk_links: Ri(K7e).default([])
}).passthrough().transform(Ii);
Ri(Z7e);
const Q7e = GA([
  "daily",
  "weekly",
  "absoluteMonthly",
  "relativeMonthly",
  "absoluteYearly",
  "relativeYearly"
]), J7e = GA(["endDate", "noEnd", "numbered"]), X7e = ti({
  type: Q7e,
  interval: Ft().min(1),
  days_of_week: Ri(Le()).optional(),
  day_of_month: Ft().min(1).max(31).optional()
}), e_e = ti({
  type: J7e,
  start_date: Le(),
  // YYYY-MM-DD format
  end_date: Le().optional(),
  // for endDate type
  number_of_occurrences: Ft().min(1).optional()
  // for numbered type
});
ti({
  title: Le().min(1).max(500),
  description: Le().optional(),
  location: Le().optional(),
  start_time: Le(),
  // HH:MM format
  end_time: Le(),
  // HH:MM format
  timezone: Le().default("UTC"),
  attendees: Ri(Le()).optional(),
  recurrence_pattern: X7e,
  recurrence_range: e_e
});
ti({
  recurring_series_id: Le().uuid(),
  title: Le(),
  description: Le().nullish(),
  recurrence_pattern: Le(),
  recurrence_interval: Ft(),
  days_of_week: Ri(Le()).nullish(),
  recurrence_end_type: Le(),
  recurrence_end_date: Le().nullish(),
  number_of_occurrences: Ft().nullish(),
  meetings_created: Ft(),
  calendar_event_id: Le().optional(),
  created_at: Le()
}).passthrough().transform(Ii);
const t_e = ti({
  series_id: Le(),
  error: Le()
}).passthrough().transform(Ii);
Ri(ti({
  synced_count: Ft().optional(),
  error_count: Ft().optional(),
  meetings_count: Ft().default(0),
  errors: Ri(t_e).default([]),
  message: Le().optional(),
  used_delta: ts().default(!1)
}).passthrough().transform(Ii));
ti({
  task_id: Le().min(1)
});
ti({
  task_id: Le().min(1),
  task_type: Le().optional()
});
ti({
  task_id: Le().nullable(),
  task_type: Le().optional(),
  already_generated: ts()
});
ti({
  task_id: Le(),
  status: Le(),
  result: sB().nullable(),
  error: Le().nullish(),
  error_code: Le().nullish(),
  message_key: Le().nullish(),
  user_friendly_message: Le().nullish()
});
var the;
(function(e) {
  e.DOCUMENT_PACKAGE_PROCESSING = "document_package_processing", e.DOCUMENT_PACKAGE_EMPTY = "document_package_empty";
})(the || (the = {}));
ti({
  error_code: Le().nullish(),
  message_key: Le().nullish(),
  user_friendly_message: Le().nullish(),
  retriable: ts().nullish(),
  detail: Le().nullish(),
  message: Le().nullish()
}).passthrough();
the.DOCUMENT_PACKAGE_PROCESSING;
const i_e = ti({
  id: Le().uuid(),
  email: Le(),
  name: Le().nullable().optional(),
  project_id: Ft(),
  consigli_user_id: Le().uuid().nullable().optional(),
  created_at: Le()
}).transform(Ii);
Ri(i_e);
var tle;
(function(e) {
  e.DONE = "done", e.ERROR = "error", e.STOPPED = "stopped", e.CONNECTION_LOST = "connection_lost", e.NEVER_FINISHED = "never_finished", e.RUNNING = "running";
})(tle || (tle = {}));
const AW = Le().datetime({ offset: !0 }), n_e = ti({
  sessions: Ft().int(),
  turns: Ft().int(),
  input_tokens: Ft().int(),
  cached_input_tokens: Ft().int(),
  output_tokens: Ft().int(),
  failed_turns: Ft().int(),
  stopped_turns: Ft().int(),
  lost_turns: Ft().int(),
  unfinished_turns: Ft().int(),
  failed_tool_calls: Ft().int(),
  flags: Ft().int()
}).strict().transform(Ii), s_e = ti({
  day: Le().date(),
  finished: Ft().int(),
  failed: Ft().int(),
  stopped: Ft().int(),
  lost: Ft().int(),
  unfinished: Ft().int(),
  input_tokens: Ft().int(),
  cached_input_tokens: Ft().int(),
  output_tokens: Ft().int()
}).strict().transform(Ii), o_e = ti({
  tool: Le(),
  agent: Le().nullable(),
  calls: Ft().int(),
  failed: Ft().int(),
  common_failure: Le().nullable()
}).strict().transform(Ii), r_e = ti({
  turn_id: Le(),
  conversation_id: Le(),
  flagged_at: AW,
  comment: Le(),
  building_id: Le().nullable(),
  outcome: ki(tle),
  workflow_id: Le().nullable()
}).strict().transform(Ii);
ti({
  totals: n_e,
  per_day: Ri(s_e),
  failing_tools: Ri(o_e)
}).strict().transform(Ii);
const l_e = ti({
  conversation_id: Le(),
  project_id: Ft().int().nullable(),
  building_id: Le().nullable(),
  started_at: AW,
  last_turn_at: AW,
  turns: Ft().int(),
  failed_turns: Ft().int(),
  stopped_turns: Ft().int(),
  lost_turns: Ft().int(),
  unfinished_turns: Ft().int(),
  failed_tool_calls: Ft().int(),
  input_tokens: Ft().int(),
  cached_input_tokens: Ft().int(),
  output_tokens: Ft().int(),
  flags: Ft().int(),
  workflows: Kp(Le(), Ft().int())
}).strict().transform(({ workflows: e, ...t }) => ({ ...Ii(t), workflows: e }));
Ri(l_e);
const a_e = ti({
  seq: Ft().int(),
  kind: Le(),
  tool: Le().nullable(),
  agent: Le().nullable(),
  model: Le().nullable(),
  arguments: Le().nullable(),
  output: Le().nullable(),
  ok: ts().nullable(),
  output_tokens: Ft().int().nullable(),
  reasoning_tokens: Ft().int().nullable(),
  duration_ms: Ft().int().nullable()
}).strict().transform(Ii), u_e = ti({
  id: Le(),
  seq: Ft().int(),
  message: Le(),
  reply: Le(),
  workflow_id: Le().nullable(),
  started_at: AW,
  duration_ms: Ft().int().nullable(),
  outcome: ki(tle),
  error: Le().nullable(),
  input_tokens: Ft().int(),
  cached_input_tokens: Ft().int(),
  output_tokens: Ft().int(),
  reasoning_tokens: Ft().int(),
  requests: Ft().int(),
  flag_comment: Le().nullable(),
  flagged_at: AW.nullable(),
  steps: Ri(a_e)
}).strict().transform(Ii);
ti({
  conversation_id: Le(),
  project_id: Ft().int().nullable(),
  building_id: Le().nullable(),
  created_at: AW,
  turns: Ri(u_e)
}).strict().transform(Ii);
Ri(r_e);
var ile;
(function(e) {
  e[e.LANDSCAPE = 0] = "LANDSCAPE", e[e.PORTRAIT = 1] = "PORTRAIT";
})(ile || (ile = {}));
var Pye;
(function(e) {
  e.SUCCESS = "SUCCESS", e.ERROR = "ERROR", e.WARNING = "WARNING", e.INFO = "INFO";
})(Pye || (Pye = {}));
const By = typeof process == "object" && process + "" == "[object process]" && !process.versions.nw && !(process.versions.electron && process.type && process.type !== "browser"), ihe = [1e-3, 0, 0, 1e-3, 0, 0], ide = 1.35, g2 = {
  ANY: 1,
  DISPLAY: 2,
  PRINT: 4,
  ANNOTATIONS_FORMS: 16,
  ANNOTATIONS_STORAGE: 32,
  ANNOTATIONS_DISABLE: 64,
  IS_EDITING: 128,
  OPLIST: 256
}, rx = {
  DISABLE: 0,
  ENABLE: 1,
  ENABLE_FORMS: 2,
  ENABLE_STORAGE: 3
}, YTe = "pdfjs_internal_editor_", eo = {
  DISABLE: -1,
  NONE: 0,
  FREETEXT: 3,
  HIGHLIGHT: 9,
  STAMP: 13,
  INK: 15,
  SIGNATURE: 101,
  COMMENT: 102
}, Ir = {
  RESIZE: 1,
  CREATE: 2,
  FREETEXT_SIZE: 11,
  FREETEXT_COLOR: 12,
  FREETEXT_OPACITY: 13,
  INK_COLOR: 21,
  INK_THICKNESS: 22,
  INK_OPACITY: 23,
  HIGHLIGHT_COLOR: 31,
  HIGHLIGHT_THICKNESS: 32,
  HIGHLIGHT_FREE: 33,
  HIGHLIGHT_SHOW_ALL: 34,
  DRAW_STEP: 41
}, d_e = {
  PRINT: 4,
  MODIFY_CONTENTS: 8,
  COPY: 16,
  MODIFY_ANNOTATIONS: 32,
  FILL_INTERACTIVE_FORMS: 256,
  COPY_FOR_ACCESSIBILITY: 512,
  ASSEMBLE: 1024,
  PRINT_HIGH_QUALITY: 2048
}, Lm = {
  FILL: 0,
  STROKE: 1,
  FILL_STROKE: 2,
  INVISIBLE: 3,
  FILL_STROKE_MASK: 3,
  ADD_TO_PATH_FLAG: 4
}, qse = {
  GRAYSCALE_1BPP: 1,
  RGB_24BPP: 2,
  RGBA_32BPP: 3
}, O0 = {
  TEXT: 1,
  LINK: 2,
  FREETEXT: 3,
  LINE: 4,
  SQUARE: 5,
  CIRCLE: 6,
  POLYGON: 7,
  POLYLINE: 8,
  HIGHLIGHT: 9,
  UNDERLINE: 10,
  SQUIGGLY: 11,
  STRIKEOUT: 12,
  STAMP: 13,
  CARET: 14,
  INK: 15,
  POPUP: 16,
  FILEATTACHMENT: 17,
  SOUND: 18,
  MOVIE: 19,
  WIDGET: 20,
  SCREEN: 21,
  PRINTERMARK: 22,
  TRAPNET: 23,
  WATERMARK: 24,
  THREED: 25,
  REDACT: 26
}, yV = {
  SOLID: 1,
  DASHED: 2,
  BEVELED: 3,
  INSET: 4,
  UNDERLINE: 5
}, Iae = {
  ERRORS: 0,
  WARNINGS: 1,
  INFOS: 5
}, nle = {
  dependency: 1,
  setLineWidth: 2,
  setLineCap: 3,
  setLineJoin: 4,
  setMiterLimit: 5,
  setDash: 6,
  setRenderingIntent: 7,
  setFlatness: 8,
  setGState: 9,
  save: 10,
  restore: 11,
  transform: 12,
  moveTo: 13,
  lineTo: 14,
  curveTo: 15,
  curveTo2: 16,
  curveTo3: 17,
  closePath: 18,
  rectangle: 19,
  stroke: 20,
  closeStroke: 21,
  fill: 22,
  eoFill: 23,
  fillStroke: 24,
  eoFillStroke: 25,
  closeFillStroke: 26,
  closeEOFillStroke: 27,
  endPath: 28,
  clip: 29,
  eoClip: 30,
  beginText: 31,
  endText: 32,
  setCharSpacing: 33,
  setWordSpacing: 34,
  setHScale: 35,
  setLeading: 36,
  setFont: 37,
  setTextRenderingMode: 38,
  setTextRise: 39,
  moveText: 40,
  setLeadingMoveText: 41,
  setTextMatrix: 42,
  nextLine: 43,
  showText: 44,
  showSpacedText: 45,
  nextLineShowText: 46,
  nextLineSetSpacingShowText: 47,
  setCharWidth: 48,
  setCharWidthAndBounds: 49,
  setStrokeColorSpace: 50,
  setFillColorSpace: 51,
  setStrokeColor: 52,
  setStrokeColorN: 53,
  setFillColor: 54,
  setFillColorN: 55,
  setStrokeGray: 56,
  setFillGray: 57,
  setStrokeRGBColor: 58,
  setFillRGBColor: 59,
  setStrokeCMYKColor: 60,
  setFillCMYKColor: 61,
  shadingFill: 62,
  beginInlineImage: 63,
  beginImageData: 64,
  endInlineImage: 65,
  paintXObject: 66,
  markPoint: 67,
  markPointProps: 68,
  beginMarkedContent: 69,
  beginMarkedContentProps: 70,
  endMarkedContent: 71,
  beginCompat: 72,
  endCompat: 73,
  paintFormXObjectBegin: 74,
  paintFormXObjectEnd: 75,
  beginGroup: 76,
  endGroup: 77,
  beginAnnotation: 80,
  endAnnotation: 81,
  paintImageMaskXObject: 83,
  paintImageMaskXObjectGroup: 84,
  paintImageXObject: 85,
  paintInlineImageXObject: 86,
  paintInlineImageXObjectGroup: 87,
  paintImageXObjectRepeat: 88,
  paintImageMaskXObjectRepeat: 89,
  paintSolidColorImageMask: 90,
  constructPath: 91,
  setStrokeTransparent: 92,
  setFillTransparent: 93,
  rawFillPath: 94
}, dne = {
  moveTo: 0,
  lineTo: 1,
  curveTo: 2,
  closePath: 3
}, c_e = {
  NEED_PASSWORD: 1,
  INCORRECT_PASSWORD: 2
};
let pae = Iae.WARNINGS;
function h_e(e) {
  Number.isInteger(e) && (pae = e);
}
function f_e() {
  return pae;
}
function mae(e) {
  pae >= Iae.INFOS && console.log(`Info: ${e}`);
}
function to(e) {
  pae >= Iae.WARNINGS && console.log(`Warning: ${e}`);
}
function Ll(e) {
  throw new Error(e);
}
function uh(e, t) {
  e || Ll(t);
}
function I_e(e) {
  switch (e == null ? void 0 : e.protocol) {
    case "http:":
    case "https:":
    case "ftp:":
    case "mailto:":
    case "tel:":
      return !0;
    default:
      return !1;
  }
}
function qTe(e, t = null, i = null) {
  if (!e)
    return null;
  if (i && typeof e == "string") {
    if (i.addDefaultProtocol && e.startsWith("www.")) {
      const s = e.match(/\./g);
      (s == null ? void 0 : s.length) >= 2 && (e = `http://${e}`);
    }
    if (i.tryConvertEncoding)
      try {
        e = g_e(e);
      } catch {
      }
  }
  const n = t ? URL.parse(e, t) : URL.parse(e);
  return I_e(n) ? n : null;
}
function $Te(e, t, i = !1) {
  const n = URL.parse(e);
  return n ? (n.hash = t, n.href) : i && qTe(e, "http://example.com") ? e.split("#", 1)[0] + `${t ? `#${t}` : ""}` : "";
}
function Zo(e, t, i, n = !1) {
  return Object.defineProperty(e, t, {
    value: i,
    enumerable: !n,
    configurable: !0,
    writable: !1
  }), i;
}
const CH = (function() {
  function t(i, n) {
    this.message = i, this.name = n;
  }
  return t.prototype = new Error(), t.constructor = t, t;
})();
class Mye extends CH {
  constructor(t, i) {
    super(t, "PasswordException"), this.code = i;
  }
}
class nde extends CH {
  constructor(t, i) {
    super(t, "UnknownErrorException"), this.details = i;
  }
}
let nhe = class extends CH {
  constructor(t) {
    super(t, "InvalidPDFException");
  }
}, sle = class extends CH {
  constructor(t, i, n) {
    super(t, "ResponseException"), this.status = i, this.missing = n;
  }
};
class p_e extends CH {
  constructor(t) {
    super(t, "FormatError");
  }
}
let WP = class extends CH {
  constructor(t) {
    super(t, "AbortException");
  }
};
function KTe(e) {
  (typeof e != "object" || (e == null ? void 0 : e.length) === void 0) && Ll("Invalid argument for bytesToString");
  const t = e.length, i = 8192;
  if (t < i)
    return String.fromCharCode.apply(null, e);
  const n = [];
  for (let s = 0; s < t; s += i) {
    const o = Math.min(s + i, t), r = e.subarray(s, o);
    n.push(String.fromCharCode.apply(null, r));
  }
  return n.join("");
}
function cie(e) {
  typeof e != "string" && Ll("Invalid argument for stringToBytes");
  const t = e.length, i = new Uint8Array(t);
  for (let n = 0; n < t; ++n)
    i[n] = e.charCodeAt(n) & 255;
  return i;
}
function m_e(e) {
  return String.fromCharCode(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, e & 255);
}
function y_e() {
  const e = new Uint8Array(4);
  return e[0] = 1, new Uint32Array(e.buffer, 0, 1)[0] === 1;
}
function E_e() {
  try {
    return new Function(""), !0;
  } catch {
    return !1;
  }
}
class Qp {
  static get isLittleEndian() {
    return Zo(this, "isLittleEndian", y_e());
  }
  static get isEvalSupported() {
    return Zo(this, "isEvalSupported", E_e());
  }
  static get isOffscreenCanvasSupported() {
    return Zo(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas < "u");
  }
  static get isImageDecoderSupported() {
    return Zo(this, "isImageDecoderSupported", typeof ImageDecoder < "u");
  }
  static get platform() {
    const {
      platform: t,
      userAgent: i
    } = navigator;
    return Zo(this, "platform", {
      isAndroid: i.includes("Android"),
      isLinux: t.includes("Linux"),
      isMac: t.includes("Mac"),
      isWindows: t.includes("Win"),
      isFirefox: i.includes("Firefox")
    });
  }
  static get isCSSRoundSupported() {
    var t, i;
    return Zo(this, "isCSSRoundSupported", (i = (t = globalThis.CSS) == null ? void 0 : t.supports) == null ? void 0 : i.call(t, "width: round(1.5px, 1px)"));
  }
}
const sde = Array.from(Array(256).keys(), (e) => e.toString(16).padStart(2, "0"));
var lL, c0e, $se, she;
let ys = (c0e = class {
  static makeHexColor(t, i, n) {
    return `#${sde[t]}${sde[i]}${sde[n]}`;
  }
  static scaleMinMax(t, i) {
    let n;
    t[0] ? (t[0] < 0 && (n = i[0], i[0] = i[2], i[2] = n), i[0] *= t[0], i[2] *= t[0], t[3] < 0 && (n = i[1], i[1] = i[3], i[3] = n), i[1] *= t[3], i[3] *= t[3]) : (n = i[0], i[0] = i[1], i[1] = n, n = i[2], i[2] = i[3], i[3] = n, t[1] < 0 && (n = i[1], i[1] = i[3], i[3] = n), i[1] *= t[1], i[3] *= t[1], t[2] < 0 && (n = i[0], i[0] = i[2], i[2] = n), i[0] *= t[2], i[2] *= t[2]), i[0] += t[4], i[1] += t[5], i[2] += t[4], i[3] += t[5];
  }
  static transform(t, i) {
    return [t[0] * i[0] + t[2] * i[1], t[1] * i[0] + t[3] * i[1], t[0] * i[2] + t[2] * i[3], t[1] * i[2] + t[3] * i[3], t[0] * i[4] + t[2] * i[5] + t[4], t[1] * i[4] + t[3] * i[5] + t[5]];
  }
  static applyTransform(t, i, n = 0) {
    const s = t[n], o = t[n + 1];
    t[n] = s * i[0] + o * i[2] + i[4], t[n + 1] = s * i[1] + o * i[3] + i[5];
  }
  static applyTransformToBezier(t, i, n = 0) {
    const s = i[0], o = i[1], r = i[2], l = i[3], c = i[4], h = i[5];
    for (let I = 0; I < 6; I += 2) {
      const p = t[n + I], y = t[n + I + 1];
      t[n + I] = p * s + y * r + c, t[n + I + 1] = p * o + y * l + h;
    }
  }
  static applyInverseTransform(t, i) {
    const n = t[0], s = t[1], o = i[0] * i[3] - i[1] * i[2];
    t[0] = (n * i[3] - s * i[2] + i[2] * i[5] - i[4] * i[3]) / o, t[1] = (-n * i[1] + s * i[0] + i[4] * i[1] - i[5] * i[0]) / o;
  }
  static axialAlignedBoundingBox(t, i, n) {
    const s = i[0], o = i[1], r = i[2], l = i[3], c = i[4], h = i[5], I = t[0], p = t[1], y = t[2], m = t[3];
    let A = s * I + c, C = A, O = s * y + c, R = O, F = l * p + h, L = F, P = l * m + h, z = P;
    if (o !== 0 || r !== 0) {
      const W = o * I, re = o * y, ce = r * p, te = r * m;
      A += ce, R += ce, O += te, C += te, F += W, z += W, P += re, L += re;
    }
    n[0] = Math.min(n[0], A, O, C, R), n[1] = Math.min(n[1], F, P, L, z), n[2] = Math.max(n[2], A, O, C, R), n[3] = Math.max(n[3], F, P, L, z);
  }
  static inverseTransform(t) {
    const i = t[0] * t[3] - t[1] * t[2];
    return [t[3] / i, -t[1] / i, -t[2] / i, t[0] / i, (t[2] * t[5] - t[4] * t[3]) / i, (t[4] * t[1] - t[5] * t[0]) / i];
  }
  static singularValueDecompose2dScale(t, i) {
    const n = t[0], s = t[1], o = t[2], r = t[3], l = n ** 2 + s ** 2, c = n * o + s * r, h = o ** 2 + r ** 2, I = (l + h) / 2, p = Math.sqrt(I ** 2 - (l * h - c ** 2));
    i[0] = Math.sqrt(I + p || 1), i[1] = Math.sqrt(I - p || 1);
  }
  static normalizeRect(t) {
    const i = t.slice(0);
    return t[0] > t[2] && (i[0] = t[2], i[2] = t[0]), t[1] > t[3] && (i[1] = t[3], i[3] = t[1]), i;
  }
  static intersect(t, i) {
    const n = Math.max(Math.min(t[0], t[2]), Math.min(i[0], i[2])), s = Math.min(Math.max(t[0], t[2]), Math.max(i[0], i[2]));
    if (n > s)
      return null;
    const o = Math.max(Math.min(t[1], t[3]), Math.min(i[1], i[3])), r = Math.min(Math.max(t[1], t[3]), Math.max(i[1], i[3]));
    return o > r ? null : [n, o, s, r];
  }
  static pointBoundingBox(t, i, n) {
    n[0] = Math.min(n[0], t), n[1] = Math.min(n[1], i), n[2] = Math.max(n[2], t), n[3] = Math.max(n[3], i);
  }
  static rectBoundingBox(t, i, n, s, o) {
    o[0] = Math.min(o[0], t, n), o[1] = Math.min(o[1], i, s), o[2] = Math.max(o[2], t, n), o[3] = Math.max(o[3], i, s);
  }
  static bezierBoundingBox(t, i, n, s, o, r, l, c, h) {
    h[0] = Math.min(h[0], t, l), h[1] = Math.min(h[1], i, c), h[2] = Math.max(h[2], t, l), h[3] = Math.max(h[3], i, c), _e(this, lL, she).call(this, t, n, o, l, i, s, r, c, 3 * (-t + 3 * (n - o) + l), 6 * (t - 2 * n + o), 3 * (n - t), h), _e(this, lL, she).call(this, t, n, o, l, i, s, r, c, 3 * (-i + 3 * (s - r) + c), 6 * (i - 2 * s + r), 3 * (s - i), h);
  }
}, lL = new WeakSet(), $se = function(t, i, n, s, o, r, l, c, h, I) {
  if (h <= 0 || h >= 1)
    return;
  const p = 1 - h, y = h * h, m = y * h, A = p * (p * (p * t + 3 * h * i) + 3 * y * n) + m * s, C = p * (p * (p * o + 3 * h * r) + 3 * y * l) + m * c;
  I[0] = Math.min(I[0], A), I[1] = Math.min(I[1], C), I[2] = Math.max(I[2], A), I[3] = Math.max(I[3], C);
}, she = function(t, i, n, s, o, r, l, c, h, I, p, y) {
  if (Math.abs(h) < 1e-12) {
    Math.abs(I) >= 1e-12 && _e(this, lL, $se).call(this, t, i, n, s, o, r, l, c, -p / I, y);
    return;
  }
  const m = I ** 2 - 4 * p * h;
  if (m < 0)
    return;
  const A = Math.sqrt(m), C = 2 * h;
  _e(this, lL, $se).call(this, t, i, n, s, o, r, l, c, (-I + A) / C, y), _e(this, lL, $se).call(this, t, i, n, s, o, r, l, c, (-I - A) / C, y);
}, xe(c0e, lL), c0e);
function g_e(e) {
  return decodeURIComponent(escape(e));
}
let ode = null, Uye = null;
function w_e(e) {
  return ode || (ode = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu, Uye = /* @__PURE__ */ new Map([["ﬅ", "ſt"]])), e.replaceAll(ode, (t, i, n) => i ? i.normalize("NFKC") : Uye.get(n));
}
function ZTe() {
  if (typeof crypto.randomUUID == "function")
    return crypto.randomUUID();
  const e = new Uint8Array(32);
  return crypto.getRandomValues(e), KTe(e);
}
const Spe = "pdfjs_internal_id_";
function T_e(e, t, i) {
  if (!Array.isArray(i) || i.length < 2)
    return !1;
  const [n, s, ...o] = i;
  if (!e(n) && !Number.isInteger(n) || !t(s))
    return !1;
  const r = o.length;
  let l = !0;
  switch (s.name) {
    case "XYZ":
      if (r < 2 || r > 3)
        return !1;
      break;
    case "Fit":
    case "FitB":
      return r === 0;
    case "FitH":
    case "FitBH":
    case "FitV":
    case "FitBV":
      if (r > 1)
        return !1;
      break;
    case "FitR":
      if (r !== 4)
        return !1;
      l = !1;
      break;
    default:
      return !1;
  }
  for (const c of o)
    if (!(typeof c == "number" || l && c === null))
      return !1;
  return !0;
}
function Fy(e, t, i) {
  return Math.min(Math.max(e, t), i);
}
function QTe(e) {
  return Uint8Array.prototype.toBase64 ? e.toBase64() : btoa(KTe(e));
}
function R_e(e) {
  return Uint8Array.fromBase64 ? Uint8Array.fromBase64(e) : cie(atob(e));
}
typeof Promise.try != "function" && (Promise.try = function(e, ...t) {
  return new Promise((i) => {
    i(e(...t));
  });
});
typeof Math.sumPrecise != "function" && (Math.sumPrecise = function(e) {
  return e.reduce((t, i) => t + i, 0);
});
const kD = "http://www.w3.org/2000/svg";
var sN;
let SW = (sN = class {
}, Zi(sN, "CSS", 96), Zi(sN, "PDF", 72), Zi(sN, "PDF_TO_CSS_UNITS", sN.CSS / sN.PDF), sN);
async function hie(e, t = "text") {
  if (eQ(e, document.baseURI)) {
    const i = await fetch(e);
    if (!i.ok)
      throw new Error(i.statusText);
    switch (t) {
      case "arraybuffer":
        return i.arrayBuffer();
      case "blob":
        return i.blob();
      case "json":
        return i.json();
    }
    return i.text();
  }
  return new Promise((i, n) => {
    const s = new XMLHttpRequest();
    s.open("GET", e, !0), s.responseType = t, s.onreadystatechange = () => {
      if (s.readyState === XMLHttpRequest.DONE) {
        if (s.status === 200 || s.status === 0) {
          switch (t) {
            case "arraybuffer":
            case "blob":
            case "json":
              i(s.response);
              return;
          }
          i(s.responseText);
          return;
        }
        n(new Error(s.statusText));
      }
    }, s.send(null);
  });
}
class fie {
  constructor({
    viewBox: t,
    userUnit: i,
    scale: n,
    rotation: s,
    offsetX: o = 0,
    offsetY: r = 0,
    dontFlip: l = !1
  }) {
    this.viewBox = t, this.userUnit = i, this.scale = n, this.rotation = s, this.offsetX = o, this.offsetY = r, n *= i;
    const c = (t[2] + t[0]) / 2, h = (t[3] + t[1]) / 2;
    let I, p, y, m;
    switch (s %= 360, s < 0 && (s += 360), s) {
      case 180:
        I = -1, p = 0, y = 0, m = 1;
        break;
      case 90:
        I = 0, p = 1, y = 1, m = 0;
        break;
      case 270:
        I = 0, p = -1, y = -1, m = 0;
        break;
      case 0:
        I = 1, p = 0, y = 0, m = -1;
        break;
      default:
        throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
    }
    l && (y = -y, m = -m);
    let A, C, O, R;
    I === 0 ? (A = Math.abs(h - t[1]) * n + o, C = Math.abs(c - t[0]) * n + r, O = (t[3] - t[1]) * n, R = (t[2] - t[0]) * n) : (A = Math.abs(c - t[0]) * n + o, C = Math.abs(h - t[1]) * n + r, O = (t[2] - t[0]) * n, R = (t[3] - t[1]) * n), this.transform = [I * n, p * n, y * n, m * n, A - I * n * c - y * n * h, C - p * n * c - m * n * h], this.width = O, this.height = R;
  }
  get rawDims() {
    const t = this.viewBox;
    return Zo(this, "rawDims", {
      pageWidth: t[2] - t[0],
      pageHeight: t[3] - t[1],
      pageX: t[0],
      pageY: t[1]
    });
  }
  clone({
    scale: t = this.scale,
    rotation: i = this.rotation,
    offsetX: n = this.offsetX,
    offsetY: s = this.offsetY,
    dontFlip: o = !1
  } = {}) {
    return new fie({
      viewBox: this.viewBox.slice(),
      userUnit: this.userUnit,
      scale: t,
      rotation: i,
      offsetX: n,
      offsetY: s,
      dontFlip: o
    });
  }
  convertToViewportPoint(t, i) {
    const n = [t, i];
    return ys.applyTransform(n, this.transform), n;
  }
  convertToViewportRectangle(t) {
    const i = [t[0], t[1]];
    ys.applyTransform(i, this.transform);
    const n = [t[2], t[3]];
    return ys.applyTransform(n, this.transform), [i[0], i[1], n[0], n[1]];
  }
  convertToPdfPoint(t, i) {
    const n = [t, i];
    return ys.applyInverseTransform(n, this.transform), n;
  }
}
let bpe = class extends CH {
  constructor(t, i = 0) {
    super(t, "RenderingCancelledException"), this.extraDelay = i;
  }
};
function yae(e) {
  const t = e.length;
  let i = 0;
  for (; i < t && e[i].trim() === ""; )
    i++;
  return e.substring(i, i + 5).toLowerCase() === "data:";
}
function Npe(e) {
  return typeof e == "string" && /\.pdf$/i.test(e);
}
function v_e(e) {
  return [e] = e.split(/[#?]/, 1), e.substring(e.lastIndexOf("/") + 1);
}
function A_e(e, t = "document.pdf") {
  if (typeof e != "string")
    return t;
  if (yae(e))
    return to('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.'), t;
  const n = ((l) => {
    try {
      return new URL(l);
    } catch {
      try {
        return new URL(decodeURIComponent(l));
      } catch {
        try {
          return new URL(l, "https://foo.bar");
        } catch {
          try {
            return new URL(decodeURIComponent(l), "https://foo.bar");
          } catch {
            return null;
          }
        }
      }
    }
  })(e);
  if (!n)
    return t;
  const s = (l) => {
    try {
      let c = decodeURIComponent(l);
      return c.includes("/") ? (c = c.split("/").at(-1), c.test(/^\.pdf$/i) ? c : l) : c;
    } catch {
      return l;
    }
  }, o = /\.pdf$/i, r = n.pathname.split("/").at(-1);
  if (o.test(r))
    return s(r);
  if (n.searchParams.size > 0) {
    const l = Array.from(n.searchParams.values()).reverse();
    for (const h of l)
      if (o.test(h))
        return s(h);
    const c = Array.from(n.searchParams.keys()).reverse();
    for (const h of c)
      if (o.test(h))
        return s(h);
  }
  if (n.hash) {
    const c = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i.exec(n.hash);
    if (c)
      return s(c[0]);
  }
  return t;
}
class Bye {
  constructor() {
    Zi(this, "started", /* @__PURE__ */ Object.create(null));
    Zi(this, "times", []);
  }
  time(t) {
    t in this.started && to(`Timer is already running for ${t}`), this.started[t] = Date.now();
  }
  timeEnd(t) {
    t in this.started || to(`Timer has not been started for ${t}`), this.times.push({
      name: t,
      start: this.started[t],
      end: Date.now()
    }), delete this.started[t];
  }
  toString() {
    const t = [];
    let i = 0;
    for (const {
      name: n
    } of this.times)
      i = Math.max(n.length, i);
    for (const {
      name: n,
      start: s,
      end: o
    } of this.times)
      t.push(`${n.padEnd(i)} ${o - s}ms
`);
    return t.join("");
  }
}
function eQ(e, t) {
  const i = t ? URL.parse(e, t) : URL.parse(e);
  return (i == null ? void 0 : i.protocol) === "http:" || (i == null ? void 0 : i.protocol) === "https:";
}
function F5(e) {
  e.preventDefault();
}
function P0(e) {
  e.preventDefault(), e.stopPropagation();
}
function S_e(e) {
  console.log("Deprecated API usage: " + e);
}
var h0e, YX;
let ohe = (h0e = class {
  static toDateObject(t) {
    if (t instanceof Date)
      return t;
    if (!t || typeof t != "string")
      return null;
    S(this, YX) || be(this, YX, new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?"));
    const i = S(this, YX).exec(t);
    if (!i)
      return null;
    const n = parseInt(i[1], 10);
    let s = parseInt(i[2], 10);
    s = s >= 1 && s <= 12 ? s - 1 : 0;
    let o = parseInt(i[3], 10);
    o = o >= 1 && o <= 31 ? o : 1;
    let r = parseInt(i[4], 10);
    r = r >= 0 && r <= 23 ? r : 0;
    let l = parseInt(i[5], 10);
    l = l >= 0 && l <= 59 ? l : 0;
    let c = parseInt(i[6], 10);
    c = c >= 0 && c <= 59 ? c : 0;
    const h = i[7] || "Z";
    let I = parseInt(i[8], 10);
    I = I >= 0 && I <= 23 ? I : 0;
    let p = parseInt(i[9], 10) || 0;
    return p = p >= 0 && p <= 59 ? p : 0, h === "-" ? (r += I, l += p) : h === "+" && (r -= I, l -= p), new Date(Date.UTC(n, s, o, r, l, c));
  }
}, YX = new WeakMap(), xe(h0e, YX), h0e);
function b_e(e, {
  scale: t = 1,
  rotation: i = 0
}) {
  const {
    width: n,
    height: s
  } = e.attributes.style, o = [0, 0, parseInt(n), parseInt(s)];
  return new fie({
    viewBox: o,
    userUnit: 1,
    scale: t,
    rotation: i
  });
}
function Eae(e) {
  if (e.startsWith("#")) {
    const t = parseInt(e.slice(1), 16);
    return [(t & 16711680) >> 16, (t & 65280) >> 8, t & 255];
  }
  return e.startsWith("rgb(") ? e.slice(4, -1).split(",").map((t) => parseInt(t)) : e.startsWith("rgba(") ? e.slice(5, -1).split(",").map((t) => parseInt(t)).slice(0, 3) : (to(`Not a valid color format: "${e}"`), [0, 0, 0]);
}
function N_e(e) {
  const t = document.createElement("span");
  t.style.visibility = "hidden", t.style.colorScheme = "only light", document.body.append(t);
  for (const i of e.keys()) {
    t.style.color = i;
    const n = window.getComputedStyle(t).color;
    e.set(i, Eae(n));
  }
  t.remove();
}
function rd(e) {
  const {
    a: t,
    b: i,
    c: n,
    d: s,
    e: o,
    f: r
  } = e.getTransform();
  return [t, i, n, s, o, r];
}
function ob(e) {
  const {
    a: t,
    b: i,
    c: n,
    d: s,
    e: o,
    f: r
  } = e.getTransform().invertSelf();
  return [t, i, n, s, o, r];
}
function KF(e, t, i = !1, n = !0) {
  if (t instanceof fie) {
    const {
      pageWidth: s,
      pageHeight: o
    } = t.rawDims, {
      style: r
    } = e, l = Qp.isCSSRoundSupported, c = `var(--total-scale-factor) * ${s}px`, h = `var(--total-scale-factor) * ${o}px`, I = l ? `round(down, ${c}, var(--scale-round-x))` : `calc(${c})`, p = l ? `round(down, ${h}, var(--scale-round-y))` : `calc(${h})`;
    !i || t.rotation % 180 === 0 ? (r.width = I, r.height = p) : (r.width = p, r.height = I);
  }
  n && e.setAttribute("data-main-rotation", t.rotation);
}
let ZF = class rhe {
  constructor() {
    const {
      pixelRatio: t
    } = rhe;
    this.sx = t, this.sy = t;
  }
  get scaled() {
    return this.sx !== 1 || this.sy !== 1;
  }
  get symmetric() {
    return this.sx === this.sy;
  }
  limitCanvas(t, i, n, s, o = -1) {
    let r = 1 / 0, l = 1 / 0, c = 1 / 0;
    n = rhe.capPixels(n, o), n > 0 && (r = Math.sqrt(n / (t * i))), s !== -1 && (l = s / t, c = s / i);
    const h = Math.min(r, l, c);
    return this.sx > h || this.sy > h ? (this.sx = h, this.sy = h, !0) : !1;
  }
  static get pixelRatio() {
    return globalThis.devicePixelRatio || 1;
  }
  static capPixels(t, i) {
    if (i >= 0) {
      const n = Math.ceil(window.screen.availWidth * window.screen.availHeight * this.pixelRatio ** 2 * (1 + i / 100));
      return t > 0 ? Math.min(t, n) : n;
    }
    return t;
  }
};
const lhe = ["image/apng", "image/avif", "image/bmp", "image/gif", "image/jpeg", "image/png", "image/svg+xml", "image/webp", "image/x-icon"];
var hx, fx, $T, CC, qX, Mz, Uz, $X, Gle, JTe, $p, XTe, e5e, EV, tQ;
const SC = class SC {
  constructor(t) {
    xe(this, $p);
    xe(this, hx, null);
    xe(this, fx, null);
    xe(this, $T);
    xe(this, CC, null);
    xe(this, qX, null);
    xe(this, Mz, null);
    xe(this, Uz, null);
    be(this, $T, t), S(SC, $X) || be(SC, $X, Object.freeze({
      freetext: "pdfjs-editor-remove-freetext-button",
      highlight: "pdfjs-editor-remove-highlight-button",
      ink: "pdfjs-editor-remove-ink-button",
      stamp: "pdfjs-editor-remove-stamp-button",
      signature: "pdfjs-editor-remove-signature-button"
    }));
  }
  render() {
    const t = be(this, hx, document.createElement("div"));
    t.classList.add("editToolbar", "hidden"), t.setAttribute("role", "toolbar");
    const i = S(this, $T)._uiManager._signal;
    t.addEventListener("contextmenu", F5, {
      signal: i
    }), t.addEventListener("pointerdown", _e(SC, Gle, JTe), {
      signal: i
    });
    const n = be(this, CC, document.createElement("div"));
    n.className = "buttons", t.append(n);
    const s = S(this, $T).toolbarPosition;
    if (s) {
      const {
        style: o
      } = t, r = S(this, $T)._uiManager.direction === "ltr" ? 1 - s[0] : s[0];
      o.insetInlineEnd = `${100 * r}%`, o.top = `calc(${100 * s[1]}% + var(--editor-toolbar-vert-offset))`;
    }
    return t;
  }
  get div() {
    return S(this, hx);
  }
  hide() {
    var t;
    S(this, hx).classList.add("hidden"), (t = S(this, fx)) == null || t.hideDropdown();
  }
  show() {
    var t, i;
    S(this, hx).classList.remove("hidden"), (t = S(this, qX)) == null || t.shown(), (i = S(this, Mz)) == null || i.shown();
  }
  addDeleteButton() {
    const {
      editorType: t,
      _uiManager: i
    } = S(this, $T), n = document.createElement("button");
    n.className = "delete", n.tabIndex = 0, n.setAttribute("data-l10n-id", S(SC, $X)[t]), _e(this, $p, EV).call(this, n), n.addEventListener("click", (s) => {
      i.delete();
    }, {
      signal: i._signal
    }), S(this, CC).append(n);
  }
  async addAltText(t) {
    const i = await t.render();
    _e(this, $p, EV).call(this, i), S(this, CC).append(i, S(this, $p, tQ)), be(this, qX, t);
  }
  addComment(t) {
    if (S(this, Mz))
      return;
    const i = t.render();
    i && (_e(this, $p, EV).call(this, i), S(this, CC).prepend(i, S(this, $p, tQ)), be(this, Mz, t), t.toolbar = this);
  }
  addColorPicker(t) {
    if (S(this, fx))
      return;
    be(this, fx, t);
    const i = t.renderButton();
    _e(this, $p, EV).call(this, i), S(this, CC).append(i, S(this, $p, tQ));
  }
  async addEditSignatureButton(t) {
    const i = be(this, Uz, await t.renderEditButton(S(this, $T)));
    _e(this, $p, EV).call(this, i), S(this, CC).append(i, S(this, $p, tQ));
  }
  async addButton(t, i) {
    switch (t) {
      case "colorPicker":
        this.addColorPicker(i);
        break;
      case "altText":
        await this.addAltText(i);
        break;
      case "editSignature":
        await this.addEditSignatureButton(i);
        break;
      case "delete":
        this.addDeleteButton();
        break;
      case "comment":
        this.addComment(i);
        break;
    }
  }
  updateEditSignatureButton(t) {
    S(this, Uz) && (S(this, Uz).title = t);
  }
  remove() {
    var t;
    S(this, hx).remove(), (t = S(this, fx)) == null || t.destroy(), be(this, fx, null);
  }
};
hx = new WeakMap(), fx = new WeakMap(), $T = new WeakMap(), CC = new WeakMap(), qX = new WeakMap(), Mz = new WeakMap(), Uz = new WeakMap(), $X = new WeakMap(), Gle = new WeakSet(), JTe = function(t) {
  t.stopPropagation();
}, $p = new WeakSet(), XTe = function(t) {
  S(this, $T)._focusEventsAllowed = !1, P0(t);
}, e5e = function(t) {
  S(this, $T)._focusEventsAllowed = !0, P0(t);
}, EV = function(t) {
  const i = S(this, $T)._uiManager._signal;
  t.addEventListener("focusin", _e(this, $p, XTe).bind(this), {
    capture: !0,
    signal: i
  }), t.addEventListener("focusout", _e(this, $p, e5e).bind(this), {
    capture: !0,
    signal: i
  }), t.addEventListener("contextmenu", F5, {
    signal: i
  });
}, tQ = function() {
  const t = document.createElement("div");
  return t.className = "divider", t;
}, xe(SC, Gle), xe(SC, $X, null);
let ahe = SC;
var KX, IB, pB, _8, t5e, i5e, n5e;
class D_e {
  constructor(t) {
    xe(this, _8);
    xe(this, KX, null);
    xe(this, IB, null);
    xe(this, pB);
    be(this, pB, t);
  }
  show(t, i, n) {
    const [s, o] = _e(this, _8, i5e).call(this, i, n), {
      style: r
    } = S(this, IB) || be(this, IB, _e(this, _8, t5e).call(this));
    t.append(S(this, IB)), r.insetInlineEnd = `${100 * s}%`, r.top = `calc(${100 * o}% + var(--editor-toolbar-vert-offset))`;
  }
  hide() {
    S(this, IB).remove();
  }
}
KX = new WeakMap(), IB = new WeakMap(), pB = new WeakMap(), _8 = new WeakSet(), t5e = function() {
  const t = be(this, IB, document.createElement("div"));
  t.className = "editToolbar", t.setAttribute("role", "toolbar"), t.addEventListener("contextmenu", F5, {
    signal: S(this, pB)._signal
  });
  const i = be(this, KX, document.createElement("div"));
  return i.className = "buttons", t.append(i), _e(this, _8, n5e).call(this), t;
}, i5e = function(t, i) {
  let n = 0, s = 0;
  for (const o of t) {
    const r = o.y + o.height;
    if (r < n)
      continue;
    const l = o.x + (i ? o.width : 0);
    if (r > n) {
      s = l, n = r;
      continue;
    }
    i ? l > s && (s = l) : l < s && (s = l);
  }
  return [i ? 1 - s : s, n];
}, n5e = function() {
  const t = document.createElement("button");
  t.className = "highlightButton", t.tabIndex = 0, t.setAttribute("data-l10n-id", "pdfjs-highlight-floating-button1");
  const i = document.createElement("span");
  t.append(i), i.className = "visuallyHidden", i.setAttribute("data-l10n-id", "pdfjs-highlight-floating-button-label");
  const n = S(this, pB)._signal;
  t.addEventListener("contextmenu", F5, {
    signal: n
  }), t.addEventListener("click", () => {
    S(this, pB).highlightSelection("floating_button");
  }, {
    signal: n
  }), S(this, KX).append(t);
};
function s5e(e, t, i) {
  for (const n of i)
    t.addEventListener(n, e[n].bind(e));
}
var kle;
class C_e {
  constructor() {
    xe(this, kle, 0);
  }
  get id() {
    return `${YTe}${hp(this, kle)._++}`;
  }
}
kle = new WeakMap();
var Bz, ZX, xm, Fz, Kse;
const I3e = class I3e {
  constructor() {
    xe(this, Fz);
    xe(this, Bz, ZTe());
    xe(this, ZX, 0);
    xe(this, xm, null);
  }
  static get _isSVGFittingCanvas() {
    const t = 'data:image/svg+xml;charset=UTF-8,<svg viewBox="0 0 1 1" width="1" height="1" xmlns="http://www.w3.org/2000/svg"><rect width="1" height="1" style="fill:red;"/></svg>', n = new OffscreenCanvas(1, 3).getContext("2d", {
      willReadFrequently: !0
    }), s = new Image();
    s.src = t;
    const o = s.decode().then(() => (n.drawImage(s, 0, 0, 1, 1, 0, 0, 1, 3), new Uint32Array(n.getImageData(0, 0, 1, 1).data.buffer)[0] === 0));
    return Zo(this, "_isSVGFittingCanvas", o);
  }
  async getFromFile(t) {
    const {
      lastModified: i,
      name: n,
      size: s,
      type: o
    } = t;
    return _e(this, Fz, Kse).call(this, `${i}_${n}_${s}_${o}`, t);
  }
  async getFromUrl(t) {
    return _e(this, Fz, Kse).call(this, t, t);
  }
  async getFromBlob(t, i) {
    const n = await i;
    return _e(this, Fz, Kse).call(this, t, n);
  }
  async getFromId(t) {
    S(this, xm) || be(this, xm, /* @__PURE__ */ new Map());
    const i = S(this, xm).get(t);
    if (!i)
      return null;
    if (i.bitmap)
      return i.refCounter += 1, i;
    if (i.file)
      return this.getFromFile(i.file);
    if (i.blobPromise) {
      const {
        blobPromise: n
      } = i;
      return delete i.blobPromise, this.getFromBlob(i.id, n);
    }
    return this.getFromUrl(i.url);
  }
  getFromCanvas(t, i) {
    S(this, xm) || be(this, xm, /* @__PURE__ */ new Map());
    let n = S(this, xm).get(t);
    if (n != null && n.bitmap)
      return n.refCounter += 1, n;
    const s = new OffscreenCanvas(i.width, i.height);
    return s.getContext("2d").drawImage(i, 0, 0), n = {
      bitmap: s.transferToImageBitmap(),
      id: `image_${S(this, Bz)}_${hp(this, ZX)._++}`,
      refCounter: 1,
      isSvg: !1
    }, S(this, xm).set(t, n), S(this, xm).set(n.id, n), n;
  }
  getSvgUrl(t) {
    const i = S(this, xm).get(t);
    return i != null && i.isSvg ? i.svgUrl : null;
  }
  deleteId(t) {
    var s;
    S(this, xm) || be(this, xm, /* @__PURE__ */ new Map());
    const i = S(this, xm).get(t);
    if (!i || (i.refCounter -= 1, i.refCounter !== 0))
      return;
    const {
      bitmap: n
    } = i;
    if (!i.url && !i.file) {
      const o = new OffscreenCanvas(n.width, n.height);
      o.getContext("bitmaprenderer").transferFromImageBitmap(n), i.blobPromise = o.convertToBlob();
    }
    (s = n.close) == null || s.call(n), i.bitmap = null;
  }
  isValidId(t) {
    return t.startsWith(`image_${S(this, Bz)}_`);
  }
};
Bz = new WeakMap(), ZX = new WeakMap(), xm = new WeakMap(), Fz = new WeakSet(), Kse = async function(t, i) {
  S(this, xm) || be(this, xm, /* @__PURE__ */ new Map());
  let n = S(this, xm).get(t);
  if (n === null)
    return null;
  if (n != null && n.bitmap)
    return n.refCounter += 1, n;
  try {
    n || (n = {
      bitmap: null,
      id: `image_${S(this, Bz)}_${hp(this, ZX)._++}`,
      refCounter: 0,
      isSvg: !1
    });
    let s;
    if (typeof i == "string" ? (n.url = i, s = await hie(i, "blob")) : i instanceof File ? s = n.file = i : i instanceof Blob && (s = i), s.type === "image/svg+xml") {
      const o = I3e._isSVGFittingCanvas, r = new FileReader(), l = new Image(), c = new Promise((h, I) => {
        l.onload = () => {
          n.bitmap = l, n.isSvg = !0, h();
        }, r.onload = async () => {
          const p = n.svgUrl = r.result;
          l.src = await o ? `${p}#svgView(preserveAspectRatio(none))` : p;
        }, l.onerror = r.onerror = I;
      });
      r.readAsDataURL(s), await c;
    } else
      n.bitmap = await createImageBitmap(s);
    n.refCounter = 1;
  } catch (s) {
    to(s), n = null;
  }
  return S(this, xm).set(t, n), n && S(this, xm).set(n.id, n), n;
};
let uhe = I3e;
var Xc, Ix, QX, od;
class O_e {
  constructor(t = 128) {
    xe(this, Xc, []);
    xe(this, Ix, !1);
    xe(this, QX);
    xe(this, od, -1);
    be(this, QX, t);
  }
  add({
    cmd: t,
    undo: i,
    post: n,
    mustExec: s,
    type: o = NaN,
    overwriteIfSameType: r = !1,
    keepUndo: l = !1
  }) {
    if (s && t(), S(this, Ix))
      return;
    const c = {
      cmd: t,
      undo: i,
      post: n,
      type: o
    };
    if (S(this, od) === -1) {
      S(this, Xc).length > 0 && (S(this, Xc).length = 0), be(this, od, 0), S(this, Xc).push(c);
      return;
    }
    if (r && S(this, Xc)[S(this, od)].type === o) {
      l && (c.undo = S(this, Xc)[S(this, od)].undo), S(this, Xc)[S(this, od)] = c;
      return;
    }
    const h = S(this, od) + 1;
    h === S(this, QX) ? S(this, Xc).splice(0, 1) : (be(this, od, h), h < S(this, Xc).length && S(this, Xc).splice(h)), S(this, Xc).push(c);
  }
  undo() {
    if (S(this, od) === -1)
      return;
    be(this, Ix, !0);
    const {
      undo: t,
      post: i
    } = S(this, Xc)[S(this, od)];
    t(), i == null || i(), be(this, Ix, !1), be(this, od, S(this, od) - 1);
  }
  redo() {
    if (S(this, od) < S(this, Xc).length - 1) {
      be(this, od, S(this, od) + 1), be(this, Ix, !0);
      const {
        cmd: t,
        post: i
      } = S(this, Xc)[S(this, od)];
      t(), i == null || i(), be(this, Ix, !1);
    }
  }
  hasSomethingToUndo() {
    return S(this, od) !== -1;
  }
  hasSomethingToRedo() {
    return S(this, od) < S(this, Xc).length - 1;
  }
  cleanType(t) {
    if (S(this, od) !== -1) {
      for (let i = S(this, od); i >= 0; i--)
        if (S(this, Xc)[i].type !== t) {
          S(this, Xc).splice(i + 1, S(this, od) - i), be(this, od, i);
          return;
        }
      S(this, Xc).length = 0, be(this, od, -1);
    }
  }
  destroy() {
    be(this, Xc, null);
  }
}
Xc = new WeakMap(), Ix = new WeakMap(), QX = new WeakMap(), od = new WeakMap();
var Vle, o5e;
class Iie {
  constructor(t) {
    xe(this, Vle);
    this.buffer = [], this.callbacks = /* @__PURE__ */ new Map(), this.allKeys = /* @__PURE__ */ new Set();
    const {
      isMac: i
    } = Qp.platform;
    for (const [n, s, o = {}] of t)
      for (const r of n) {
        const l = r.startsWith("mac+");
        i && l ? (this.callbacks.set(r.slice(4), {
          callback: s,
          options: o
        }), this.allKeys.add(r.split("+").at(-1))) : !i && !l && (this.callbacks.set(r, {
          callback: s,
          options: o
        }), this.allKeys.add(r.split("+").at(-1)));
      }
  }
  exec(t, i) {
    if (!this.allKeys.has(i.key))
      return;
    const n = this.callbacks.get(_e(this, Vle, o5e).call(this, i));
    if (!n)
      return;
    const {
      callback: s,
      options: {
        bubbles: o = !1,
        args: r = [],
        checker: l = null
      }
    } = n;
    l && !l(t, i) || (s.bind(t, ...r, i)(), o || P0(i));
  }
}
Vle = new WeakSet(), o5e = function(t) {
  t.altKey && this.buffer.push("alt"), t.ctrlKey && this.buffer.push("ctrl"), t.metaKey && this.buffer.push("meta"), t.shiftKey && this.buffer.push("shift"), this.buffer.push(t.key);
  const i = this.buffer.join("+");
  return this.buffer.length = 0, i;
};
const zle = class zle {
  get _colors() {
    const t = /* @__PURE__ */ new Map([["CanvasText", null], ["Canvas", null]]);
    return N_e(t), Zo(this, "_colors", t);
  }
  convert(t) {
    const i = Eae(t);
    if (!window.matchMedia("(forced-colors: active)").matches)
      return i;
    for (const [n, s] of this._colors)
      if (s.every((o, r) => o === i[r]))
        return zle._colorsMapping.get(n);
    return i;
  }
  getHexCode(t) {
    const i = this._colors.get(t);
    return i ? ys.makeHexColor(...i) : t;
  }
};
Zi(zle, "_colorsMapping", /* @__PURE__ */ new Map([["CanvasText", [0, 0, 0]], ["Canvas", [255, 255, 255]]]));
let dhe = zle;
var Hz, n2, Gh, Ep, Gz, OC, kz, KT, mB, px, mx, Vz, yB, bb, Iv, EB, JX, XX, zz, eee, Nb, yx, jz, Ex, Db, jle, gx, tee, wx, gB, Wz, Tx, iee, s1, wl, LC, Rx, vx, nee, see, Ax, Cb, _C, oee, ree, ZT, wO, _n, Zse, che, r5e, l5e, Qse, a5e, u5e, d5e, hhe, c5e, fhe, Ihe, h5e, Ny, VD, f5e, I5e, phe, p5e, iQ, mhe;
let uX = (wO = class {
  constructor(t, i, n, s, o, r, l, c, h, I, p, y, m, A, C, O) {
    xe(this, _n);
    xe(this, Hz, new AbortController());
    xe(this, n2, null);
    xe(this, Gh, /* @__PURE__ */ new Map());
    xe(this, Ep, /* @__PURE__ */ new Map());
    xe(this, Gz, null);
    xe(this, OC, null);
    xe(this, kz, null);
    xe(this, KT, new O_e());
    xe(this, mB, null);
    xe(this, px, null);
    xe(this, mx, null);
    xe(this, Vz, 0);
    xe(this, yB, /* @__PURE__ */ new Set());
    xe(this, bb, null);
    xe(this, Iv, null);
    xe(this, EB, /* @__PURE__ */ new Set());
    Zi(this, "_editorUndoBar", null);
    xe(this, JX, !1);
    xe(this, XX, !1);
    xe(this, zz, !1);
    xe(this, eee, null);
    xe(this, Nb, null);
    xe(this, yx, null);
    xe(this, jz, null);
    xe(this, Ex, !1);
    xe(this, Db, null);
    xe(this, jle, new C_e());
    xe(this, gx, !1);
    xe(this, tee, !1);
    xe(this, wx, null);
    xe(this, gB, null);
    xe(this, Wz, null);
    xe(this, Tx, null);
    xe(this, iee, null);
    xe(this, s1, eo.NONE);
    xe(this, wl, /* @__PURE__ */ new Set());
    xe(this, LC, null);
    xe(this, Rx, null);
    xe(this, vx, null);
    xe(this, nee, null);
    xe(this, see, {
      isEditing: !1,
      isEmpty: !0,
      hasSomethingToUndo: !1,
      hasSomethingToRedo: !1,
      hasSelectedEditor: !1,
      hasSelectedText: !1
    });
    xe(this, Ax, [0, 0]);
    xe(this, Cb, null);
    xe(this, _C, null);
    xe(this, oee, null);
    xe(this, ree, null);
    xe(this, ZT, null);
    const R = this._signal = S(this, Hz).signal;
    be(this, _C, t), be(this, oee, i), be(this, ree, n), be(this, Gz, s), be(this, mB, o), be(this, Rx, r), this._eventBus = l, l._on("editingaction", this.onEditingAction.bind(this), {
      signal: R
    }), l._on("pagechanging", this.onPageChanging.bind(this), {
      signal: R
    }), l._on("scalechanging", this.onScaleChanging.bind(this), {
      signal: R
    }), l._on("rotationchanging", this.onRotationChanging.bind(this), {
      signal: R
    }), l._on("setpreference", this.onSetPreference.bind(this), {
      signal: R
    }), l._on("switchannotationeditorparams", (F) => this.updateParams(F.type, F.value), {
      signal: R
    }), _e(this, _n, a5e).call(this), _e(this, _n, h5e).call(this), _e(this, _n, hhe).call(this), be(this, OC, c.annotationStorage), be(this, eee, c.filterFactory), be(this, vx, h), be(this, jz, I || null), be(this, JX, p), be(this, XX, y), be(this, zz, m), be(this, iee, A || null), this.viewParameters = {
      realScale: SW.PDF_TO_CSS_UNITS,
      rotation: 0
    }, this.isShiftKeyDown = !1, this._editorUndoBar = C || null, this._supportsPinchToZoom = O !== !1;
  }
  static get _keyboardManager() {
    const t = wO.prototype, i = (r) => S(r, _C).contains(document.activeElement) && document.activeElement.tagName !== "BUTTON" && r.hasSomethingToControl(), n = (r, {
      target: l
    }) => {
      if (l instanceof HTMLInputElement) {
        const {
          type: c
        } = l;
        return c !== "text" && c !== "number";
      }
      return !0;
    }, s = this.TRANSLATE_SMALL, o = this.TRANSLATE_BIG;
    return Zo(this, "_keyboardManager", new Iie([[["ctrl+a", "mac+meta+a"], t.selectAll, {
      checker: n
    }], [["ctrl+z", "mac+meta+z"], t.undo, {
      checker: n
    }], [["ctrl+y", "ctrl+shift+z", "mac+meta+shift+z", "ctrl+shift+Z", "mac+meta+shift+Z"], t.redo, {
      checker: n
    }], [["Backspace", "alt+Backspace", "ctrl+Backspace", "shift+Backspace", "mac+Backspace", "mac+alt+Backspace", "mac+ctrl+Backspace", "Delete", "ctrl+Delete", "shift+Delete", "mac+Delete"], t.delete, {
      checker: n
    }], [["Enter", "mac+Enter"], t.addNewEditorFromKeyboard, {
      checker: (r, {
        target: l
      }) => !(l instanceof HTMLButtonElement) && S(r, _C).contains(l) && !r.isEnterHandled
    }], [[" ", "mac+ "], t.addNewEditorFromKeyboard, {
      checker: (r, {
        target: l
      }) => !(l instanceof HTMLButtonElement) && S(r, _C).contains(document.activeElement)
    }], [["Escape", "mac+Escape"], t.unselectAll], [["ArrowLeft", "mac+ArrowLeft"], t.translateSelectedEditors, {
      args: [-s, 0],
      checker: i
    }], [["ctrl+ArrowLeft", "mac+shift+ArrowLeft"], t.translateSelectedEditors, {
      args: [-o, 0],
      checker: i
    }], [["ArrowRight", "mac+ArrowRight"], t.translateSelectedEditors, {
      args: [s, 0],
      checker: i
    }], [["ctrl+ArrowRight", "mac+shift+ArrowRight"], t.translateSelectedEditors, {
      args: [o, 0],
      checker: i
    }], [["ArrowUp", "mac+ArrowUp"], t.translateSelectedEditors, {
      args: [0, -s],
      checker: i
    }], [["ctrl+ArrowUp", "mac+shift+ArrowUp"], t.translateSelectedEditors, {
      args: [0, -o],
      checker: i
    }], [["ArrowDown", "mac+ArrowDown"], t.translateSelectedEditors, {
      args: [0, s],
      checker: i
    }], [["ctrl+ArrowDown", "mac+shift+ArrowDown"], t.translateSelectedEditors, {
      args: [0, o],
      checker: i
    }]]));
  }
  destroy() {
    var t, i, n, s, o, r, l, c, h;
    (t = S(this, ZT)) == null || t.resolve(), be(this, ZT, null), (i = S(this, Hz)) == null || i.abort(), be(this, Hz, null), this._signal = null;
    for (const I of S(this, Ep).values())
      I.destroy();
    S(this, Ep).clear(), S(this, Gh).clear(), S(this, EB).clear(), (n = S(this, Tx)) == null || n.clear(), be(this, n2, null), S(this, wl).clear(), S(this, KT).destroy(), (s = S(this, Gz)) == null || s.destroy(), (o = S(this, mB)) == null || o.destroy(), (r = S(this, Rx)) == null || r.destroy(), (l = S(this, Db)) == null || l.hide(), be(this, Db, null), (c = S(this, Wz)) == null || c.destroy(), be(this, Wz, null), S(this, Nb) && (clearTimeout(S(this, Nb)), be(this, Nb, null)), S(this, Cb) && (clearTimeout(S(this, Cb)), be(this, Cb, null)), (h = this._editorUndoBar) == null || h.destroy();
  }
  combinedSignal(t) {
    return AbortSignal.any([this._signal, t.signal]);
  }
  get mlManager() {
    return S(this, iee);
  }
  get useNewAltTextFlow() {
    return S(this, XX);
  }
  get useNewAltTextWhenAddingImage() {
    return S(this, zz);
  }
  get hcmFilter() {
    return Zo(this, "hcmFilter", S(this, vx) ? S(this, eee).addHCMFilter(S(this, vx).foreground, S(this, vx).background) : "none");
  }
  get direction() {
    return Zo(this, "direction", getComputedStyle(S(this, _C)).direction);
  }
  get _highlightColors() {
    return Zo(this, "_highlightColors", S(this, jz) ? new Map(S(this, jz).split(",").map((t) => (t = t.split("=").map((i) => i.trim()), t[1] = t[1].toUpperCase(), t))) : null);
  }
  get highlightColors() {
    const {
      _highlightColors: t
    } = this;
    if (!t)
      return Zo(this, "highlightColors", null);
    const i = /* @__PURE__ */ new Map(), n = !!S(this, vx);
    for (const [s, o] of t) {
      const r = s.endsWith("_HCM");
      if (n && r) {
        i.set(s.replace("_HCM", ""), o);
        continue;
      }
      !n && !r && i.set(s, o);
    }
    return Zo(this, "highlightColors", i);
  }
  get highlightColorNames() {
    return Zo(this, "highlightColorNames", this.highlightColors ? new Map(Array.from(this.highlightColors, (t) => t.reverse())) : null);
  }
  getNonHCMColor(t) {
    if (!this._highlightColors)
      return t;
    const i = this.highlightColorNames.get(t);
    return this._highlightColors.get(i) || t;
  }
  getNonHCMColorName(t) {
    return this.highlightColorNames.get(t) || t;
  }
  setCurrentDrawingSession(t) {
    t ? (this.unselectAll(), this.disableUserSelect(!0)) : this.disableUserSelect(!1), be(this, mx, t);
  }
  setMainHighlightColorPicker(t) {
    be(this, Wz, t);
  }
  editAltText(t, i = !1) {
    var n;
    (n = S(this, Gz)) == null || n.editAltText(this, t, i);
  }
  hasCommentManager() {
    return !!S(this, mB);
  }
  editComment(t, i) {
    var n;
    (n = S(this, mB)) == null || n.open(this, t, i);
  }
  getSignature(t) {
    var i;
    (i = S(this, Rx)) == null || i.getSignature({
      uiManager: this,
      editor: t
    });
  }
  get signatureManager() {
    return S(this, Rx);
  }
  switchToMode(t, i) {
    this._eventBus.on("annotationeditormodechanged", i, {
      once: !0,
      signal: this._signal
    }), this._eventBus.dispatch("showannotationeditorui", {
      source: this,
      mode: t
    });
  }
  setPreference(t, i) {
    this._eventBus.dispatch("setpreference", {
      source: this,
      name: t,
      value: i
    });
  }
  onSetPreference({
    name: t,
    value: i
  }) {
    switch (t) {
      case "enableNewAltTextWhenAddingImage":
        be(this, zz, i);
        break;
    }
  }
  onPageChanging({
    pageNumber: t
  }) {
    be(this, Vz, t - 1);
  }
  focusMainContainer() {
    S(this, _C).focus();
  }
  findParent(t, i) {
    for (const n of S(this, Ep).values()) {
      const {
        x: s,
        y: o,
        width: r,
        height: l
      } = n.div.getBoundingClientRect();
      if (t >= s && t <= s + r && i >= o && i <= o + l)
        return n;
    }
    return null;
  }
  disableUserSelect(t = !1) {
    S(this, oee).classList.toggle("noUserSelect", t);
  }
  addShouldRescale(t) {
    S(this, EB).add(t);
  }
  removeShouldRescale(t) {
    S(this, EB).delete(t);
  }
  onScaleChanging({
    scale: t
  }) {
    var i;
    this.commitOrRemove(), this.viewParameters.realScale = t * SW.PDF_TO_CSS_UNITS;
    for (const n of S(this, EB))
      n.onScaleChanging();
    (i = S(this, mx)) == null || i.onScaleChanging();
  }
  onRotationChanging({
    pagesRotation: t
  }) {
    this.commitOrRemove(), this.viewParameters.rotation = t;
  }
  highlightSelection(t = "") {
    const i = document.getSelection();
    if (!i || i.isCollapsed)
      return;
    const {
      anchorNode: n,
      anchorOffset: s,
      focusNode: o,
      focusOffset: r
    } = i, l = i.toString(), h = _e(this, _n, Zse).call(this, i).closest(".textLayer"), I = this.getSelectionBoxes(h);
    if (!I)
      return;
    i.empty();
    const p = _e(this, _n, che).call(this, h), y = S(this, s1) === eo.NONE, m = () => {
      p == null || p.createAndAddNewEditor({
        x: 0,
        y: 0
      }, !1, {
        methodOfCreation: t,
        boxes: I,
        anchorNode: n,
        anchorOffset: s,
        focusNode: o,
        focusOffset: r,
        text: l
      }), y && this.showAllEditors("highlight", !0, !0);
    };
    if (y) {
      this.switchToMode(eo.HIGHLIGHT, m);
      return;
    }
    m();
  }
  addToAnnotationStorage(t) {
    !t.isEmpty() && S(this, OC) && !S(this, OC).has(t.id) && S(this, OC).setValue(t.id, t);
  }
  a11yAlert(t, i = null) {
    const n = S(this, ree);
    n && (n.setAttribute("data-l10n-id", t), i ? n.setAttribute("data-l10n-args", JSON.stringify(i)) : n.removeAttribute("data-l10n-args"));
  }
  blur() {
    if (this.isShiftKeyDown = !1, S(this, Ex) && (be(this, Ex, !1), _e(this, _n, Qse).call(this, "main_toolbar")), !this.hasSelection)
      return;
    const {
      activeElement: t
    } = document;
    for (const i of S(this, wl))
      if (i.div.contains(t)) {
        be(this, gB, [i, t]), i._focusEventsAllowed = !1;
        break;
      }
  }
  focus() {
    if (!S(this, gB))
      return;
    const [t, i] = S(this, gB);
    be(this, gB, null), i.addEventListener("focusin", () => {
      t._focusEventsAllowed = !0;
    }, {
      once: !0,
      signal: this._signal
    }), i.focus();
  }
  addEditListeners() {
    _e(this, _n, hhe).call(this), _e(this, _n, fhe).call(this);
  }
  removeEditListeners() {
    _e(this, _n, c5e).call(this), _e(this, _n, Ihe).call(this);
  }
  dragOver(t) {
    for (const {
      type: i
    } of t.dataTransfer.items)
      for (const n of S(this, Iv))
        if (n.isHandlingMimeForPasting(i)) {
          t.dataTransfer.dropEffect = "copy", t.preventDefault();
          return;
        }
  }
  drop(t) {
    for (const i of t.dataTransfer.items)
      for (const n of S(this, Iv))
        if (n.isHandlingMimeForPasting(i.type)) {
          n.paste(i, this.currentLayer), t.preventDefault();
          return;
        }
  }
  copy(t) {
    var n;
    if (t.preventDefault(), (n = S(this, n2)) == null || n.commitOrRemove(), !this.hasSelection)
      return;
    const i = [];
    for (const s of S(this, wl)) {
      const o = s.serialize(!0);
      o && i.push(o);
    }
    i.length !== 0 && t.clipboardData.setData("application/pdfjs", JSON.stringify(i));
  }
  cut(t) {
    this.copy(t), this.delete();
  }
  async paste(t) {
    t.preventDefault();
    const {
      clipboardData: i
    } = t;
    for (const o of i.items)
      for (const r of S(this, Iv))
        if (r.isHandlingMimeForPasting(o.type)) {
          r.paste(o, this.currentLayer);
          return;
        }
    let n = i.getData("application/pdfjs");
    if (!n)
      return;
    try {
      n = JSON.parse(n);
    } catch (o) {
      to(`paste: "${o.message}".`);
      return;
    }
    if (!Array.isArray(n))
      return;
    this.unselectAll();
    const s = this.currentLayer;
    try {
      const o = [];
      for (const c of n) {
        const h = await s.deserialize(c);
        if (!h)
          return;
        o.push(h);
      }
      const r = () => {
        for (const c of o)
          _e(this, _n, phe).call(this, c);
        _e(this, _n, mhe).call(this, o);
      }, l = () => {
        for (const c of o)
          c.remove();
      };
      this.addCommands({
        cmd: r,
        undo: l,
        mustExec: !0
      });
    } catch (o) {
      to(`paste: "${o.message}".`);
    }
  }
  keydown(t) {
    !this.isShiftKeyDown && t.key === "Shift" && (this.isShiftKeyDown = !0), S(this, s1) !== eo.NONE && !this.isEditorHandlingKeyboard && wO._keyboardManager.exec(this, t);
  }
  keyup(t) {
    this.isShiftKeyDown && t.key === "Shift" && (this.isShiftKeyDown = !1, S(this, Ex) && (be(this, Ex, !1), _e(this, _n, Qse).call(this, "main_toolbar")));
  }
  onEditingAction({
    name: t
  }) {
    switch (t) {
      case "undo":
      case "redo":
      case "delete":
      case "selectAll":
        this[t]();
        break;
      case "highlightSelection":
        this.highlightSelection("context_menu");
        break;
    }
  }
  setEditingState(t) {
    t ? (_e(this, _n, u5e).call(this), _e(this, _n, fhe).call(this), _e(this, _n, Ny).call(this, {
      isEditing: S(this, s1) !== eo.NONE,
      isEmpty: _e(this, _n, iQ).call(this),
      hasSomethingToUndo: S(this, KT).hasSomethingToUndo(),
      hasSomethingToRedo: S(this, KT).hasSomethingToRedo(),
      hasSelectedEditor: !1
    })) : (_e(this, _n, d5e).call(this), _e(this, _n, Ihe).call(this), _e(this, _n, Ny).call(this, {
      isEditing: !1
    }), this.disableUserSelect(!1));
  }
  registerEditorTypes(t) {
    if (!S(this, Iv)) {
      be(this, Iv, t);
      for (const i of S(this, Iv))
        _e(this, _n, VD).call(this, i.defaultPropertiesToUpdate);
    }
  }
  getId() {
    return S(this, jle).id;
  }
  get currentLayer() {
    return S(this, Ep).get(S(this, Vz));
  }
  getLayer(t) {
    return S(this, Ep).get(t);
  }
  get currentPageIndex() {
    return S(this, Vz);
  }
  addLayer(t) {
    S(this, Ep).set(t.pageIndex, t), S(this, gx) ? t.enable() : t.disable();
  }
  removeLayer(t) {
    S(this, Ep).delete(t.pageIndex);
  }
  async updateMode(t, i = null, n = !1, s = !1, o = !1) {
    var r, l, c;
    if (S(this, s1) !== t && !(S(this, ZT) && (await S(this, ZT).promise, !S(this, ZT)))) {
      if (be(this, ZT, Promise.withResolvers()), (r = S(this, mx)) == null || r.commitOrRemove(), be(this, s1, t), t === eo.NONE) {
        this.setEditingState(!1), _e(this, _n, I5e).call(this), (l = this._editorUndoBar) == null || l.hide(), S(this, ZT).resolve();
        return;
      }
      t === eo.SIGNATURE && await ((c = S(this, Rx)) == null ? void 0 : c.loadSignatures()), this.setEditingState(!0), await _e(this, _n, f5e).call(this), this.unselectAll();
      for (const h of S(this, Ep).values())
        h.updateMode(t);
      if (!i) {
        n && this.addNewEditorFromKeyboard(), S(this, ZT).resolve();
        return;
      }
      for (const h of S(this, Gh).values())
        h.annotationElementId === i || h.id === i ? (this.setSelected(h), o ? h.editComment() : s && h.enterInEditMode()) : h.unselect();
      S(this, ZT).resolve();
    }
  }
  addNewEditorFromKeyboard() {
    this.currentLayer.canCreateNewEmptyEditor() && this.currentLayer.addNewEditor();
  }
  updateToolbar(t) {
    t.mode !== S(this, s1) && this._eventBus.dispatch("switchannotationeditormode", {
      source: this,
      ...t
    });
  }
  updateParams(t, i) {
    if (S(this, Iv)) {
      switch (t) {
        case Ir.CREATE:
          this.currentLayer.addNewEditor(i);
          return;
        case Ir.HIGHLIGHT_SHOW_ALL:
          this._eventBus.dispatch("reporttelemetry", {
            source: this,
            details: {
              type: "editing",
              data: {
                type: "highlight",
                action: "toggle_visibility"
              }
            }
          }), (S(this, nee) || be(this, nee, /* @__PURE__ */ new Map())).set(t, i), this.showAllEditors("highlight", i);
          break;
      }
      if (this.hasSelection)
        for (const n of S(this, wl))
          n.updateParams(t, i);
      else
        for (const n of S(this, Iv))
          n.updateDefaultParams(t, i);
    }
  }
  showAllEditors(t, i, n = !1) {
    var o;
    for (const r of S(this, Gh).values())
      r.editorType === t && r.show(i);
    (((o = S(this, nee)) == null ? void 0 : o.get(Ir.HIGHLIGHT_SHOW_ALL)) ?? !0) !== i && _e(this, _n, VD).call(this, [[Ir.HIGHLIGHT_SHOW_ALL, i]]);
  }
  enableWaiting(t = !1) {
    if (S(this, tee) !== t) {
      be(this, tee, t);
      for (const i of S(this, Ep).values())
        t ? i.disableClick() : i.enableClick(), i.div.classList.toggle("waiting", t);
    }
  }
  getEditors(t) {
    const i = [];
    for (const n of S(this, Gh).values())
      n.pageIndex === t && i.push(n);
    return i;
  }
  getEditor(t) {
    return S(this, Gh).get(t);
  }
  addEditor(t) {
    S(this, Gh).set(t.id, t);
  }
  removeEditor(t) {
    var i, n;
    t.div.contains(document.activeElement) && (S(this, Nb) && clearTimeout(S(this, Nb)), be(this, Nb, setTimeout(() => {
      this.focusMainContainer(), be(this, Nb, null);
    }, 0))), S(this, Gh).delete(t.id), t.annotationElementId && ((i = S(this, Tx)) == null || i.delete(t.annotationElementId)), this.unselect(t), (!t.annotationElementId || !S(this, yB).has(t.annotationElementId)) && ((n = S(this, OC)) == null || n.remove(t.id));
  }
  addDeletedAnnotationElement(t) {
    S(this, yB).add(t.annotationElementId), this.addChangedExistingAnnotation(t), t.deleted = !0;
  }
  isDeletedAnnotationElement(t) {
    return S(this, yB).has(t);
  }
  removeDeletedAnnotationElement(t) {
    S(this, yB).delete(t.annotationElementId), this.removeChangedExistingAnnotation(t), t.deleted = !1;
  }
  setActiveEditor(t) {
    S(this, n2) !== t && (be(this, n2, t), t && _e(this, _n, VD).call(this, t.propertiesToUpdate));
  }
  updateUI(t) {
    S(this, _n, p5e) === t && _e(this, _n, VD).call(this, t.propertiesToUpdate);
  }
  updateUIForDefaultProperties(t) {
    _e(this, _n, VD).call(this, t.defaultPropertiesToUpdate);
  }
  toggleSelected(t) {
    if (S(this, wl).has(t)) {
      S(this, wl).delete(t), t.unselect(), _e(this, _n, Ny).call(this, {
        hasSelectedEditor: this.hasSelection
      });
      return;
    }
    S(this, wl).add(t), t.select(), _e(this, _n, VD).call(this, t.propertiesToUpdate), _e(this, _n, Ny).call(this, {
      hasSelectedEditor: !0
    });
  }
  setSelected(t) {
    var i;
    this.updateToolbar({
      mode: t.mode,
      editId: t.id
    }), (i = S(this, mx)) == null || i.commitOrRemove();
    for (const n of S(this, wl))
      n !== t && n.unselect();
    S(this, wl).clear(), S(this, wl).add(t), t.select(), _e(this, _n, VD).call(this, t.propertiesToUpdate), _e(this, _n, Ny).call(this, {
      hasSelectedEditor: !0
    });
  }
  isSelected(t) {
    return S(this, wl).has(t);
  }
  get firstSelectedEditor() {
    return S(this, wl).values().next().value;
  }
  unselect(t) {
    t.unselect(), S(this, wl).delete(t), _e(this, _n, Ny).call(this, {
      hasSelectedEditor: this.hasSelection
    });
  }
  get hasSelection() {
    return S(this, wl).size !== 0;
  }
  get isEnterHandled() {
    return S(this, wl).size === 1 && this.firstSelectedEditor.isEnterHandled;
  }
  undo() {
    var t;
    S(this, KT).undo(), _e(this, _n, Ny).call(this, {
      hasSomethingToUndo: S(this, KT).hasSomethingToUndo(),
      hasSomethingToRedo: !0,
      isEmpty: _e(this, _n, iQ).call(this)
    }), (t = this._editorUndoBar) == null || t.hide();
  }
  redo() {
    S(this, KT).redo(), _e(this, _n, Ny).call(this, {
      hasSomethingToUndo: !0,
      hasSomethingToRedo: S(this, KT).hasSomethingToRedo(),
      isEmpty: _e(this, _n, iQ).call(this)
    });
  }
  addCommands(t) {
    S(this, KT).add(t), _e(this, _n, Ny).call(this, {
      hasSomethingToUndo: !0,
      hasSomethingToRedo: !1,
      isEmpty: _e(this, _n, iQ).call(this)
    });
  }
  cleanUndoStack(t) {
    S(this, KT).cleanType(t);
  }
  delete() {
    var o;
    this.commitOrRemove();
    const t = (o = this.currentLayer) == null ? void 0 : o.endDrawingSession(!0);
    if (!this.hasSelection && !t)
      return;
    const i = t ? [t] : [...S(this, wl)], n = () => {
      var r;
      (r = this._editorUndoBar) == null || r.show(s, i.length === 1 ? i[0].editorType : i.length);
      for (const l of i)
        l.remove();
    }, s = () => {
      for (const r of i)
        _e(this, _n, phe).call(this, r);
    };
    this.addCommands({
      cmd: n,
      undo: s,
      mustExec: !0
    });
  }
  commitOrRemove() {
    var t;
    (t = S(this, n2)) == null || t.commitOrRemove();
  }
  hasSomethingToControl() {
    return S(this, n2) || this.hasSelection;
  }
  selectAll() {
    for (const t of S(this, wl))
      t.commit();
    _e(this, _n, mhe).call(this, S(this, Gh).values());
  }
  unselectAll() {
    var t;
    if (!(S(this, n2) && (S(this, n2).commitOrRemove(), S(this, s1) !== eo.NONE)) && !((t = S(this, mx)) != null && t.commitOrRemove()) && this.hasSelection) {
      for (const i of S(this, wl))
        i.unselect();
      S(this, wl).clear(), _e(this, _n, Ny).call(this, {
        hasSelectedEditor: !1
      });
    }
  }
  translateSelectedEditors(t, i, n = !1) {
    if (n || this.commitOrRemove(), !this.hasSelection)
      return;
    S(this, Ax)[0] += t, S(this, Ax)[1] += i;
    const [s, o] = S(this, Ax), r = [...S(this, wl)], l = 1e3;
    S(this, Cb) && clearTimeout(S(this, Cb)), be(this, Cb, setTimeout(() => {
      be(this, Cb, null), S(this, Ax)[0] = S(this, Ax)[1] = 0, this.addCommands({
        cmd: () => {
          for (const c of r)
            S(this, Gh).has(c.id) && (c.translateInPage(s, o), c.translationDone());
        },
        undo: () => {
          for (const c of r)
            S(this, Gh).has(c.id) && (c.translateInPage(-s, -o), c.translationDone());
        },
        mustExec: !1
      });
    }, l));
    for (const c of r)
      c.translateInPage(t, i), c.translationDone();
  }
  setUpDragSession() {
    if (this.hasSelection) {
      this.disableUserSelect(!0), be(this, bb, /* @__PURE__ */ new Map());
      for (const t of S(this, wl))
        S(this, bb).set(t, {
          savedX: t.x,
          savedY: t.y,
          savedPageIndex: t.pageIndex,
          newX: 0,
          newY: 0,
          newPageIndex: -1
        });
    }
  }
  endDragSession() {
    if (!S(this, bb))
      return !1;
    this.disableUserSelect(!1);
    const t = S(this, bb);
    be(this, bb, null);
    let i = !1;
    for (const [{
      x: s,
      y: o,
      pageIndex: r
    }, l] of t)
      l.newX = s, l.newY = o, l.newPageIndex = r, i || (i = s !== l.savedX || o !== l.savedY || r !== l.savedPageIndex);
    if (!i)
      return !1;
    const n = (s, o, r, l) => {
      if (S(this, Gh).has(s.id)) {
        const c = S(this, Ep).get(l);
        c ? s._setParentAndPosition(c, o, r) : (s.pageIndex = l, s.x = o, s.y = r);
      }
    };
    return this.addCommands({
      cmd: () => {
        for (const [s, {
          newX: o,
          newY: r,
          newPageIndex: l
        }] of t)
          n(s, o, r, l);
      },
      undo: () => {
        for (const [s, {
          savedX: o,
          savedY: r,
          savedPageIndex: l
        }] of t)
          n(s, o, r, l);
      },
      mustExec: !0
    }), !0;
  }
  dragSelectedEditors(t, i) {
    if (S(this, bb))
      for (const n of S(this, bb).keys())
        n.drag(t, i);
  }
  rebuild(t) {
    if (t.parent === null) {
      const i = this.getLayer(t.pageIndex);
      i ? (i.changeParent(t), i.addOrRebuild(t)) : (this.addEditor(t), this.addToAnnotationStorage(t), t.rebuild());
    } else
      t.parent.addOrRebuild(t);
  }
  get isEditorHandlingKeyboard() {
    var t;
    return ((t = this.getActive()) == null ? void 0 : t.shouldGetKeyboardEvents()) || S(this, wl).size === 1 && this.firstSelectedEditor.shouldGetKeyboardEvents();
  }
  isActive(t) {
    return S(this, n2) === t;
  }
  getActive() {
    return S(this, n2);
  }
  getMode() {
    return S(this, s1);
  }
  get imageManager() {
    return Zo(this, "imageManager", new uhe());
  }
  getSelectionBoxes(t) {
    if (!t)
      return null;
    const i = document.getSelection();
    for (let h = 0, I = i.rangeCount; h < I; h++)
      if (!t.contains(i.getRangeAt(h).commonAncestorContainer))
        return null;
    const {
      x: n,
      y: s,
      width: o,
      height: r
    } = t.getBoundingClientRect();
    let l;
    switch (t.getAttribute("data-main-rotation")) {
      case "90":
        l = (h, I, p, y) => ({
          x: (I - s) / r,
          y: 1 - (h + p - n) / o,
          width: y / r,
          height: p / o
        });
        break;
      case "180":
        l = (h, I, p, y) => ({
          x: 1 - (h + p - n) / o,
          y: 1 - (I + y - s) / r,
          width: p / o,
          height: y / r
        });
        break;
      case "270":
        l = (h, I, p, y) => ({
          x: 1 - (I + y - s) / r,
          y: (h - n) / o,
          width: y / r,
          height: p / o
        });
        break;
      default:
        l = (h, I, p, y) => ({
          x: (h - n) / o,
          y: (I - s) / r,
          width: p / o,
          height: y / r
        });
        break;
    }
    const c = [];
    for (let h = 0, I = i.rangeCount; h < I; h++) {
      const p = i.getRangeAt(h);
      if (!p.collapsed)
        for (const {
          x: y,
          y: m,
          width: A,
          height: C
        } of p.getClientRects())
          A === 0 || C === 0 || c.push(l(y, m, A, C));
    }
    return c.length === 0 ? null : c;
  }
  addChangedExistingAnnotation({
    annotationElementId: t,
    id: i
  }) {
    (S(this, kz) || be(this, kz, /* @__PURE__ */ new Map())).set(t, i);
  }
  removeChangedExistingAnnotation({
    annotationElementId: t
  }) {
    var i;
    (i = S(this, kz)) == null || i.delete(t);
  }
  renderAnnotationElement(t) {
    var s;
    const i = (s = S(this, kz)) == null ? void 0 : s.get(t.data.id);
    if (!i)
      return;
    const n = S(this, OC).getRawValue(i);
    n && (S(this, s1) === eo.NONE && !n.hasBeenModified || n.renderAnnotationElement(t));
  }
  setMissingCanvas(t, i, n) {
    var o;
    const s = (o = S(this, Tx)) == null ? void 0 : o.get(t);
    s && (s.setCanvas(i, n), S(this, Tx).delete(t));
  }
  addMissingCanvas(t, i) {
    (S(this, Tx) || be(this, Tx, /* @__PURE__ */ new Map())).set(t, i);
  }
}, Hz = new WeakMap(), n2 = new WeakMap(), Gh = new WeakMap(), Ep = new WeakMap(), Gz = new WeakMap(), OC = new WeakMap(), kz = new WeakMap(), KT = new WeakMap(), mB = new WeakMap(), px = new WeakMap(), mx = new WeakMap(), Vz = new WeakMap(), yB = new WeakMap(), bb = new WeakMap(), Iv = new WeakMap(), EB = new WeakMap(), JX = new WeakMap(), XX = new WeakMap(), zz = new WeakMap(), eee = new WeakMap(), Nb = new WeakMap(), yx = new WeakMap(), jz = new WeakMap(), Ex = new WeakMap(), Db = new WeakMap(), jle = new WeakMap(), gx = new WeakMap(), tee = new WeakMap(), wx = new WeakMap(), gB = new WeakMap(), Wz = new WeakMap(), Tx = new WeakMap(), iee = new WeakMap(), s1 = new WeakMap(), wl = new WeakMap(), LC = new WeakMap(), Rx = new WeakMap(), vx = new WeakMap(), nee = new WeakMap(), see = new WeakMap(), Ax = new WeakMap(), Cb = new WeakMap(), _C = new WeakMap(), oee = new WeakMap(), ree = new WeakMap(), ZT = new WeakMap(), _n = new WeakSet(), Zse = function({
  anchorNode: t
}) {
  return t.nodeType === Node.TEXT_NODE ? t.parentElement : t;
}, che = function(t) {
  const {
    currentLayer: i
  } = this;
  if (i.hasTextLayer(t))
    return i;
  for (const n of S(this, Ep).values())
    if (n.hasTextLayer(t))
      return n;
  return null;
}, r5e = function() {
  const t = document.getSelection();
  if (!t || t.isCollapsed)
    return;
  const n = _e(this, _n, Zse).call(this, t).closest(".textLayer"), s = this.getSelectionBoxes(n);
  s && (S(this, Db) || be(this, Db, new D_e(this)), S(this, Db).show(n, s, this.direction === "ltr"));
}, l5e = function() {
  var o, r, l;
  const t = document.getSelection();
  if (!t || t.isCollapsed) {
    S(this, LC) && ((o = S(this, Db)) == null || o.hide(), be(this, LC, null), _e(this, _n, Ny).call(this, {
      hasSelectedText: !1
    }));
    return;
  }
  const {
    anchorNode: i
  } = t;
  if (i === S(this, LC))
    return;
  const s = _e(this, _n, Zse).call(this, t).closest(".textLayer");
  if (!s) {
    S(this, LC) && ((r = S(this, Db)) == null || r.hide(), be(this, LC, null), _e(this, _n, Ny).call(this, {
      hasSelectedText: !1
    }));
    return;
  }
  if ((l = S(this, Db)) == null || l.hide(), be(this, LC, i), _e(this, _n, Ny).call(this, {
    hasSelectedText: !0
  }), !(S(this, s1) !== eo.HIGHLIGHT && S(this, s1) !== eo.NONE) && (S(this, s1) === eo.HIGHLIGHT && this.showAllEditors("highlight", !0, !0), be(this, Ex, this.isShiftKeyDown), !this.isShiftKeyDown)) {
    const c = S(this, s1) === eo.HIGHLIGHT ? _e(this, _n, che).call(this, s) : null;
    c == null || c.toggleDrawing();
    const h = new AbortController(), I = this.combinedSignal(h), p = (y) => {
      y.type === "pointerup" && y.button !== 0 || (h.abort(), c == null || c.toggleDrawing(!0), y.type === "pointerup" && _e(this, _n, Qse).call(this, "main_toolbar"));
    };
    window.addEventListener("pointerup", p, {
      signal: I
    }), window.addEventListener("blur", p, {
      signal: I
    });
  }
}, Qse = function(t = "") {
  S(this, s1) === eo.HIGHLIGHT ? this.highlightSelection(t) : S(this, JX) && _e(this, _n, r5e).call(this);
}, a5e = function() {
  document.addEventListener("selectionchange", _e(this, _n, l5e).bind(this), {
    signal: this._signal
  });
}, u5e = function() {
  if (S(this, yx))
    return;
  be(this, yx, new AbortController());
  const t = this.combinedSignal(S(this, yx));
  window.addEventListener("focus", this.focus.bind(this), {
    signal: t
  }), window.addEventListener("blur", this.blur.bind(this), {
    signal: t
  });
}, d5e = function() {
  var t;
  (t = S(this, yx)) == null || t.abort(), be(this, yx, null);
}, hhe = function() {
  if (S(this, wx))
    return;
  be(this, wx, new AbortController());
  const t = this.combinedSignal(S(this, wx));
  window.addEventListener("keydown", this.keydown.bind(this), {
    signal: t
  }), window.addEventListener("keyup", this.keyup.bind(this), {
    signal: t
  });
}, c5e = function() {
  var t;
  (t = S(this, wx)) == null || t.abort(), be(this, wx, null);
}, fhe = function() {
  if (S(this, px))
    return;
  be(this, px, new AbortController());
  const t = this.combinedSignal(S(this, px));
  document.addEventListener("copy", this.copy.bind(this), {
    signal: t
  }), document.addEventListener("cut", this.cut.bind(this), {
    signal: t
  }), document.addEventListener("paste", this.paste.bind(this), {
    signal: t
  });
}, Ihe = function() {
  var t;
  (t = S(this, px)) == null || t.abort(), be(this, px, null);
}, h5e = function() {
  const t = this._signal;
  document.addEventListener("dragover", this.dragOver.bind(this), {
    signal: t
  }), document.addEventListener("drop", this.drop.bind(this), {
    signal: t
  });
}, Ny = function(t) {
  Object.entries(t).some(([n, s]) => S(this, see)[n] !== s) && (this._eventBus.dispatch("annotationeditorstateschanged", {
    source: this,
    details: Object.assign(S(this, see), t)
  }), S(this, s1) === eo.HIGHLIGHT && t.hasSelectedEditor === !1 && _e(this, _n, VD).call(this, [[Ir.HIGHLIGHT_FREE, !0]]));
}, VD = function(t) {
  this._eventBus.dispatch("annotationeditorparamschanged", {
    source: this,
    details: t
  });
}, f5e = async function() {
  if (!S(this, gx)) {
    be(this, gx, !0);
    const t = [];
    for (const i of S(this, Ep).values())
      t.push(i.enable());
    await Promise.all(t);
    for (const i of S(this, Gh).values())
      i.enable();
  }
}, I5e = function() {
  if (this.unselectAll(), S(this, gx)) {
    be(this, gx, !1);
    for (const t of S(this, Ep).values())
      t.disable();
    for (const t of S(this, Gh).values())
      t.disable();
  }
}, phe = function(t) {
  const i = S(this, Ep).get(t.pageIndex);
  i ? i.addOrRebuild(t) : (this.addEditor(t), this.addToAnnotationStorage(t));
}, p5e = function() {
  let t = null;
  for (t of S(this, wl))
    ;
  return t;
}, iQ = function() {
  if (S(this, Gh).size === 0)
    return !0;
  if (S(this, Gh).size === 1)
    for (const t of S(this, Gh).values())
      return t.isEmpty();
  return !1;
}, mhe = function(t) {
  for (const i of S(this, wl))
    i.unselect();
  S(this, wl).clear();
  for (const i of t)
    i.isEmpty() || (S(this, wl).add(i), i.select());
  _e(this, _n, Ny).call(this, {
    hasSelectedEditor: this.hasSelection
  });
}, Zi(wO, "TRANSLATE_SMALL", 1), Zi(wO, "TRANSLATE_BIG", 10), wO);
var o1, Ob, pv, Yz, Lb, s2, qz, _b, dg, xC, wB, xb, Sx, sA, nQ, Jse;
const Ly = class Ly {
  constructor(t) {
    xe(this, sA);
    xe(this, o1, null);
    xe(this, Ob, !1);
    xe(this, pv, null);
    xe(this, Yz, null);
    xe(this, Lb, null);
    xe(this, s2, null);
    xe(this, qz, !1);
    xe(this, _b, null);
    xe(this, dg, null);
    xe(this, xC, null);
    xe(this, wB, null);
    xe(this, xb, !1);
    be(this, dg, t), be(this, xb, t._uiManager.useNewAltTextFlow), S(Ly, Sx) || be(Ly, Sx, Object.freeze({
      added: "pdfjs-editor-new-alt-text-added-button",
      "added-label": "pdfjs-editor-new-alt-text-added-button-label",
      missing: "pdfjs-editor-new-alt-text-missing-button",
      "missing-label": "pdfjs-editor-new-alt-text-missing-button-label",
      review: "pdfjs-editor-new-alt-text-to-review-button",
      "review-label": "pdfjs-editor-new-alt-text-to-review-button-label"
    }));
  }
  static initialize(t) {
    Ly._l10n ?? (Ly._l10n = t);
  }
  async render() {
    const t = be(this, pv, document.createElement("button"));
    t.className = "altText", t.tabIndex = "0";
    const i = be(this, Yz, document.createElement("span"));
    t.append(i), S(this, xb) ? (t.classList.add("new"), t.setAttribute("data-l10n-id", S(Ly, Sx).missing), i.setAttribute("data-l10n-id", S(Ly, Sx)["missing-label"])) : (t.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-button"), i.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-button-label"));
    const n = S(this, dg)._uiManager._signal;
    t.addEventListener("contextmenu", F5, {
      signal: n
    }), t.addEventListener("pointerdown", (o) => o.stopPropagation(), {
      signal: n
    });
    const s = (o) => {
      o.preventDefault(), S(this, dg)._uiManager.editAltText(S(this, dg)), S(this, xb) && S(this, dg)._reportTelemetry({
        action: "pdfjs.image.alt_text.image_status_label_clicked",
        data: {
          label: S(this, sA, nQ)
        }
      });
    };
    return t.addEventListener("click", s, {
      capture: !0,
      signal: n
    }), t.addEventListener("keydown", (o) => {
      o.target === t && o.key === "Enter" && (be(this, qz, !0), s(o));
    }, {
      signal: n
    }), await _e(this, sA, Jse).call(this), t;
  }
  finish() {
    S(this, pv) && (S(this, pv).focus({
      focusVisible: S(this, qz)
    }), be(this, qz, !1));
  }
  isEmpty() {
    return S(this, xb) ? S(this, o1) === null : !S(this, o1) && !S(this, Ob);
  }
  hasData() {
    return S(this, xb) ? S(this, o1) !== null || !!S(this, xC) : this.isEmpty();
  }
  get guessedText() {
    return S(this, xC);
  }
  async setGuessedText(t) {
    S(this, o1) === null && (be(this, xC, t), be(this, wB, await Ly._l10n.get("pdfjs-editor-new-alt-text-generated-alt-text-with-disclaimer", {
      generatedAltText: t
    })), _e(this, sA, Jse).call(this));
  }
  toggleAltTextBadge(t = !1) {
    var i;
    if (!S(this, xb) || S(this, o1)) {
      (i = S(this, _b)) == null || i.remove(), be(this, _b, null);
      return;
    }
    if (!S(this, _b)) {
      const n = be(this, _b, document.createElement("div"));
      n.className = "noAltTextBadge", S(this, dg).div.append(n);
    }
    S(this, _b).classList.toggle("hidden", !t);
  }
  serialize(t) {
    let i = S(this, o1);
    return !t && S(this, xC) === i && (i = S(this, wB)), {
      altText: i,
      decorative: S(this, Ob),
      guessedText: S(this, xC),
      textWithDisclaimer: S(this, wB)
    };
  }
  get data() {
    return {
      altText: S(this, o1),
      decorative: S(this, Ob)
    };
  }
  set data({
    altText: t,
    decorative: i,
    guessedText: n,
    textWithDisclaimer: s,
    cancel: o = !1
  }) {
    n && (be(this, xC, n), be(this, wB, s)), !(S(this, o1) === t && S(this, Ob) === i) && (o || (be(this, o1, t), be(this, Ob, i)), _e(this, sA, Jse).call(this));
  }
  toggle(t = !1) {
    S(this, pv) && (!t && S(this, s2) && (clearTimeout(S(this, s2)), be(this, s2, null)), S(this, pv).disabled = !t);
  }
  shown() {
    S(this, dg)._reportTelemetry({
      action: "pdfjs.image.alt_text.image_status_label_displayed",
      data: {
        label: S(this, sA, nQ)
      }
    });
  }
  destroy() {
    var t, i;
    (t = S(this, pv)) == null || t.remove(), be(this, pv, null), be(this, Yz, null), be(this, Lb, null), (i = S(this, _b)) == null || i.remove(), be(this, _b, null);
  }
};
o1 = new WeakMap(), Ob = new WeakMap(), pv = new WeakMap(), Yz = new WeakMap(), Lb = new WeakMap(), s2 = new WeakMap(), qz = new WeakMap(), _b = new WeakMap(), dg = new WeakMap(), xC = new WeakMap(), wB = new WeakMap(), xb = new WeakMap(), Sx = new WeakMap(), sA = new WeakSet(), nQ = function() {
  return S(this, o1) && "added" || S(this, o1) === null && this.guessedText && "review" || "missing";
}, Jse = async function() {
  var s, o, r;
  const t = S(this, pv);
  if (!t)
    return;
  if (S(this, xb)) {
    if (t.classList.toggle("done", !!S(this, o1)), t.setAttribute("data-l10n-id", S(Ly, Sx)[S(this, sA, nQ)]), (s = S(this, Yz)) == null || s.setAttribute("data-l10n-id", S(Ly, Sx)[`${S(this, sA, nQ)}-label`]), !S(this, o1)) {
      (o = S(this, Lb)) == null || o.remove();
      return;
    }
  } else {
    if (!S(this, o1) && !S(this, Ob)) {
      t.classList.remove("done"), (r = S(this, Lb)) == null || r.remove();
      return;
    }
    t.classList.add("done"), t.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-edit-button");
  }
  let i = S(this, Lb);
  if (!i) {
    be(this, Lb, i = document.createElement("span")), i.className = "tooltip", i.setAttribute("role", "tooltip"), i.id = `alt-text-tooltip-${S(this, dg).id}`;
    const l = 100, c = S(this, dg)._uiManager._signal;
    c.addEventListener("abort", () => {
      clearTimeout(S(this, s2)), be(this, s2, null);
    }, {
      once: !0
    }), t.addEventListener("mouseenter", () => {
      be(this, s2, setTimeout(() => {
        be(this, s2, null), S(this, Lb).classList.add("show"), S(this, dg)._reportTelemetry({
          action: "alt_text_tooltip"
        });
      }, l));
    }, {
      signal: c
    }), t.addEventListener("mouseleave", () => {
      var h;
      S(this, s2) && (clearTimeout(S(this, s2)), be(this, s2, null)), (h = S(this, Lb)) == null || h.classList.remove("show");
    }, {
      signal: c
    });
  }
  S(this, Ob) ? i.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-decorative-tooltip") : (i.removeAttribute("data-l10n-id"), i.textContent = S(this, o1)), i.parentNode || t.append(i);
  const n = S(this, dg).getElementForAltText();
  n == null || n.setAttribute("aria-describedby", i.id);
}, xe(Ly, Sx, null), Zi(Ly, "_l10n", null);
let ole = Ly;
var Pb, TB, mv, lee, PC, $z, bx, q4e;
let cne = (q4e = class {
  constructor(t) {
    xe(this, Pb, null);
    xe(this, TB, !1);
    xe(this, mv, null);
    xe(this, lee, null);
    xe(this, PC, null);
    xe(this, $z, null);
    xe(this, bx, !1);
    be(this, mv, t), this.toolbar = null;
  }
  render() {
    if (!S(this, mv)._uiManager.hasCommentManager())
      return null;
    const t = be(this, Pb, document.createElement("button"));
    t.className = "comment", t.tabIndex = "0", t.setAttribute("data-l10n-id", "pdfjs-editor-edit-comment-button");
    const i = S(this, mv)._uiManager._signal;
    t.addEventListener("contextmenu", F5, {
      signal: i
    }), t.addEventListener("pointerdown", (s) => s.stopPropagation(), {
      signal: i
    });
    const n = (s) => {
      s.preventDefault(), this.edit();
    };
    return t.addEventListener("click", n, {
      capture: !0,
      signal: i
    }), t.addEventListener("keydown", (s) => {
      s.target === t && s.key === "Enter" && (be(this, TB, !0), n(s));
    }, {
      signal: i
    }), t;
  }
  edit() {
    const {
      bottom: t,
      left: i,
      right: n
    } = S(this, mv).getClientDimensions(), s = {
      top: t
    };
    S(this, mv)._uiManager.direction === "ltr" ? s.right = n : s.left = i, S(this, mv)._uiManager.editComment(S(this, mv), s);
  }
  finish() {
    S(this, Pb) && (S(this, Pb).focus({
      focusVisible: S(this, TB)
    }), be(this, TB, !1));
  }
  isDeleted() {
    return S(this, bx) || S(this, PC) === "";
  }
  hasBeenEdited() {
    return this.isDeleted() || S(this, PC) !== S(this, lee);
  }
  serialize() {
    return this.data;
  }
  get data() {
    return {
      text: S(this, PC),
      date: S(this, $z),
      deleted: S(this, bx)
    };
  }
  set data(t) {
    if (t === null) {
      be(this, PC, ""), be(this, bx, !0);
      return;
    }
    be(this, PC, t), be(this, $z, /* @__PURE__ */ new Date()), be(this, bx, !1);
  }
  setInitialText(t) {
    be(this, lee, t), this.data = t;
  }
  toggle(t = !1) {
    S(this, Pb) && (S(this, Pb).disabled = !t);
  }
  shown() {
  }
  destroy() {
    var t;
    (t = S(this, Pb)) == null || t.remove(), be(this, Pb, null), be(this, PC, ""), be(this, $z, null), be(this, mv, null), be(this, TB, !1), be(this, bx, !1);
  }
}, Pb = new WeakMap(), TB = new WeakMap(), mv = new WeakMap(), lee = new WeakMap(), PC = new WeakMap(), $z = new WeakMap(), bx = new WeakMap(), q4e);
var Kz, RB, aee, uee, dee, cee, hee, MC, vB, UC, AB, BC, x8, y5e, E5e, g5e, Zz;
let m5e = (Zz = class {
  constructor({
    container: t,
    isPinchingDisabled: i = null,
    isPinchingStopped: n = null,
    onPinchStart: s = null,
    onPinching: o = null,
    onPinchEnd: r = null,
    signal: l
  }) {
    xe(this, x8);
    xe(this, Kz);
    xe(this, RB, !1);
    xe(this, aee, null);
    xe(this, uee);
    xe(this, dee);
    xe(this, cee);
    xe(this, hee);
    xe(this, MC, null);
    xe(this, vB);
    xe(this, UC, null);
    xe(this, AB);
    xe(this, BC, null);
    be(this, Kz, t), be(this, aee, n), be(this, uee, i), be(this, dee, s), be(this, cee, o), be(this, hee, r), be(this, AB, new AbortController()), be(this, vB, AbortSignal.any([l, S(this, AB).signal])), t.addEventListener("touchstart", _e(this, x8, y5e).bind(this), {
      passive: !1,
      signal: S(this, vB)
    });
  }
  get MIN_TOUCH_DISTANCE_TO_PINCH() {
    return 35 / ZF.pixelRatio;
  }
  destroy() {
    var t, i;
    (t = S(this, AB)) == null || t.abort(), be(this, AB, null), (i = S(this, MC)) == null || i.abort(), be(this, MC, null);
  }
}, Kz = new WeakMap(), RB = new WeakMap(), aee = new WeakMap(), uee = new WeakMap(), dee = new WeakMap(), cee = new WeakMap(), hee = new WeakMap(), MC = new WeakMap(), vB = new WeakMap(), UC = new WeakMap(), AB = new WeakMap(), BC = new WeakMap(), x8 = new WeakSet(), y5e = function(t) {
  var s, o, r;
  if ((s = S(this, uee)) != null && s.call(this))
    return;
  if (t.touches.length === 1) {
    if (S(this, MC))
      return;
    const l = be(this, MC, new AbortController()), c = AbortSignal.any([S(this, vB), l.signal]), h = S(this, Kz), I = {
      capture: !0,
      signal: c,
      passive: !1
    }, p = (y) => {
      var m;
      y.pointerType === "touch" && ((m = S(this, MC)) == null || m.abort(), be(this, MC, null));
    };
    h.addEventListener("pointerdown", (y) => {
      y.pointerType === "touch" && (P0(y), p(y));
    }, I), h.addEventListener("pointerup", p, I), h.addEventListener("pointercancel", p, I);
    return;
  }
  if (!S(this, BC)) {
    be(this, BC, new AbortController());
    const l = AbortSignal.any([S(this, vB), S(this, BC).signal]), c = S(this, Kz), h = {
      signal: l,
      capture: !1,
      passive: !1
    };
    c.addEventListener("touchmove", _e(this, x8, E5e).bind(this), h);
    const I = _e(this, x8, g5e).bind(this);
    c.addEventListener("touchend", I, h), c.addEventListener("touchcancel", I, h), h.capture = !0, c.addEventListener("pointerdown", P0, h), c.addEventListener("pointermove", P0, h), c.addEventListener("pointercancel", P0, h), c.addEventListener("pointerup", P0, h), (o = S(this, dee)) == null || o.call(this);
  }
  if (P0(t), t.touches.length !== 2 || (r = S(this, aee)) != null && r.call(this)) {
    be(this, UC, null);
    return;
  }
  let [i, n] = t.touches;
  i.identifier > n.identifier && ([i, n] = [n, i]), be(this, UC, {
    touch0X: i.screenX,
    touch0Y: i.screenY,
    touch1X: n.screenX,
    touch1Y: n.screenY
  });
}, E5e = function(t) {
  var P;
  if (!S(this, UC) || t.touches.length !== 2)
    return;
  P0(t);
  let [i, n] = t.touches;
  i.identifier > n.identifier && ([i, n] = [n, i]);
  const {
    screenX: s,
    screenY: o
  } = i, {
    screenX: r,
    screenY: l
  } = n, c = S(this, UC), {
    touch0X: h,
    touch0Y: I,
    touch1X: p,
    touch1Y: y
  } = c, m = p - h, A = y - I, C = r - s, O = l - o, R = Math.hypot(C, O) || 1, F = Math.hypot(m, A) || 1;
  if (!S(this, RB) && Math.abs(F - R) <= Zz.MIN_TOUCH_DISTANCE_TO_PINCH)
    return;
  if (c.touch0X = s, c.touch0Y = o, c.touch1X = r, c.touch1Y = l, !S(this, RB)) {
    be(this, RB, !0);
    return;
  }
  const L = [(s + r) / 2, (o + l) / 2];
  (P = S(this, cee)) == null || P.call(this, L, F, R);
}, g5e = function(t) {
  var i;
  t.touches.length >= 2 || (S(this, BC) && (S(this, BC).abort(), be(this, BC, null), (i = S(this, hee)) == null || i.call(this)), S(this, UC) && (P0(t), be(this, UC, null), be(this, RB, !1)));
}, Zz);
var SB, yv, Mu, gp, Qz, Nx, fee, bB, wp, NB, FC, Dx, Iee, DB, o2, pee, CB, HC, Mb, Jz, Xz, QT, OB, mee, Wle, Cs, yhe, yee, Ehe, Xse, w5e, T5e, ghe, eoe, whe, R5e, v5e, A5e, The, S5e, Rhe, b5e, N5e, D5e, vhe, sQ;
const Oo = class Oo {
  constructor(t) {
    xe(this, Cs);
    xe(this, SB, null);
    xe(this, yv, null);
    xe(this, Mu, null);
    xe(this, gp, null);
    xe(this, Qz, !1);
    xe(this, Nx, null);
    xe(this, fee, "");
    xe(this, bB, !1);
    xe(this, wp, null);
    xe(this, NB, null);
    xe(this, FC, null);
    xe(this, Dx, null);
    xe(this, Iee, "");
    xe(this, DB, !1);
    xe(this, o2, null);
    xe(this, pee, !1);
    xe(this, CB, !1);
    xe(this, HC, !1);
    xe(this, Mb, null);
    xe(this, Jz, 0);
    xe(this, Xz, 0);
    xe(this, QT, null);
    xe(this, OB, null);
    Zi(this, "isSelected", !1);
    Zi(this, "_isCopy", !1);
    Zi(this, "_editToolbar", null);
    Zi(this, "_initialOptions", /* @__PURE__ */ Object.create(null));
    Zi(this, "_initialData", null);
    Zi(this, "_isVisible", !0);
    Zi(this, "_uiManager", null);
    Zi(this, "_focusEventsAllowed", !0);
    xe(this, mee, !1);
    xe(this, Wle, Oo._zIndex++);
    this.parent = t.parent, this.id = t.id, this.width = this.height = null, this.pageIndex = t.parent.pageIndex, this.name = t.name, this.div = null, this._uiManager = t.uiManager, this.annotationElementId = null, this._willKeepAspectRatio = !1, this._initialOptions.isCentered = t.isCentered, this._structTreeParentId = null, this.annotationElementId = t.annotationElementId || null;
    const {
      rotation: i,
      rawDims: {
        pageWidth: n,
        pageHeight: s,
        pageX: o,
        pageY: r
      }
    } = this.parent.viewport;
    this.rotation = i, this.pageRotation = (360 + i - this._uiManager.viewParameters.rotation) % 360, this.pageDimensions = [n, s], this.pageTranslation = [o, r];
    const [l, c] = this.parentDimensions;
    this.x = t.x / l, this.y = t.y / c, this.isAttachedToDOM = !1, this.deleted = !1;
  }
  static get _resizerKeyboardManager() {
    const t = Oo.prototype._resizeWithKeyboard, i = uX.TRANSLATE_SMALL, n = uX.TRANSLATE_BIG;
    return Zo(this, "_resizerKeyboardManager", new Iie([[["ArrowLeft", "mac+ArrowLeft"], t, {
      args: [-i, 0]
    }], [["ctrl+ArrowLeft", "mac+shift+ArrowLeft"], t, {
      args: [-n, 0]
    }], [["ArrowRight", "mac+ArrowRight"], t, {
      args: [i, 0]
    }], [["ctrl+ArrowRight", "mac+shift+ArrowRight"], t, {
      args: [n, 0]
    }], [["ArrowUp", "mac+ArrowUp"], t, {
      args: [0, -i]
    }], [["ctrl+ArrowUp", "mac+shift+ArrowUp"], t, {
      args: [0, -n]
    }], [["ArrowDown", "mac+ArrowDown"], t, {
      args: [0, i]
    }], [["ctrl+ArrowDown", "mac+shift+ArrowDown"], t, {
      args: [0, n]
    }], [["Escape", "mac+Escape"], Oo.prototype._stopResizingWithKeyboard]]));
  }
  get editorType() {
    return Object.getPrototypeOf(this).constructor._type;
  }
  get mode() {
    return Object.getPrototypeOf(this).constructor._editorType;
  }
  static get isDrawer() {
    return !1;
  }
  static get _defaultLineColor() {
    return Zo(this, "_defaultLineColor", this._colorManager.getHexCode("CanvasText"));
  }
  static deleteAnnotationElement(t) {
    const i = new L_e({
      id: t.parent.getNextId(),
      parent: t.parent,
      uiManager: t._uiManager
    });
    i.annotationElementId = t.annotationElementId, i.deleted = !0, i._uiManager.addToAnnotationStorage(i);
  }
  static initialize(t, i) {
    if (Oo._l10n ?? (Oo._l10n = t), Oo._l10nResizer || (Oo._l10nResizer = Object.freeze({
      topLeft: "pdfjs-editor-resizer-top-left",
      topMiddle: "pdfjs-editor-resizer-top-middle",
      topRight: "pdfjs-editor-resizer-top-right",
      middleRight: "pdfjs-editor-resizer-middle-right",
      bottomRight: "pdfjs-editor-resizer-bottom-right",
      bottomMiddle: "pdfjs-editor-resizer-bottom-middle",
      bottomLeft: "pdfjs-editor-resizer-bottom-left",
      middleLeft: "pdfjs-editor-resizer-middle-left"
    })), Oo._borderLineWidth !== -1)
      return;
    const n = getComputedStyle(document.documentElement);
    Oo._borderLineWidth = parseFloat(n.getPropertyValue("--outline-width")) || 0;
  }
  static updateDefaultParams(t, i) {
  }
  static get defaultPropertiesToUpdate() {
    return [];
  }
  static isHandlingMimeForPasting(t) {
    return !1;
  }
  static paste(t, i) {
    Ll("Not implemented");
  }
  get propertiesToUpdate() {
    return [];
  }
  get _isDraggable() {
    return S(this, mee);
  }
  set _isDraggable(t) {
    var i;
    be(this, mee, t), (i = this.div) == null || i.classList.toggle("draggable", t);
  }
  get isEnterHandled() {
    return !0;
  }
  center() {
    const [t, i] = this.pageDimensions;
    switch (this.parentRotation) {
      case 90:
        this.x -= this.height * i / (t * 2), this.y += this.width * t / (i * 2);
        break;
      case 180:
        this.x += this.width / 2, this.y += this.height / 2;
        break;
      case 270:
        this.x += this.height * i / (t * 2), this.y -= this.width * t / (i * 2);
        break;
      default:
        this.x -= this.width / 2, this.y -= this.height / 2;
        break;
    }
    this.fixAndSetPosition();
  }
  addCommands(t) {
    this._uiManager.addCommands(t);
  }
  get currentLayer() {
    return this._uiManager.currentLayer;
  }
  setInBackground() {
    this.div.style.zIndex = 0;
  }
  setInForeground() {
    this.div.style.zIndex = S(this, Wle);
  }
  setParent(t) {
    t !== null ? (this.pageIndex = t.pageIndex, this.pageDimensions = t.pageDimensions) : _e(this, Cs, sQ).call(this), this.parent = t;
  }
  focusin(t) {
    this._focusEventsAllowed && (S(this, DB) ? be(this, DB, !1) : this.parent.setSelected(this));
  }
  focusout(t) {
    var n;
    if (!this._focusEventsAllowed || !this.isAttachedToDOM)
      return;
    const i = t.relatedTarget;
    i != null && i.closest(`#${this.id}`) || (t.preventDefault(), (n = this.parent) != null && n.isMultipleSelection || this.commitOrRemove());
  }
  commitOrRemove() {
    this.isEmpty() ? this.remove() : this.commit();
  }
  commit() {
    this.isInEditMode() && this.addToAnnotationStorage();
  }
  addToAnnotationStorage() {
    this._uiManager.addToAnnotationStorage(this);
  }
  setAt(t, i, n, s) {
    const [o, r] = this.parentDimensions;
    [n, s] = this.screenToPageTranslation(n, s), this.x = (t + n) / o, this.y = (i + s) / r, this.fixAndSetPosition();
  }
  _moveAfterPaste(t, i) {
    const [n, s] = this.parentDimensions;
    this.setAt(t * n, i * s, this.width * n, this.height * s), this._onTranslated();
  }
  translate(t, i) {
    _e(this, Cs, yhe).call(this, this.parentDimensions, t, i);
  }
  translateInPage(t, i) {
    S(this, o2) || be(this, o2, [this.x, this.y, this.width, this.height]), _e(this, Cs, yhe).call(this, this.pageDimensions, t, i), this.div.scrollIntoView({
      block: "nearest"
    });
  }
  translationDone() {
    this._onTranslated(this.x, this.y);
  }
  drag(t, i) {
    S(this, o2) || be(this, o2, [this.x, this.y, this.width, this.height]);
    const {
      div: n,
      parentDimensions: [s, o]
    } = this;
    if (this.x += t / s, this.y += i / o, this.parent && (this.x < 0 || this.x > 1 || this.y < 0 || this.y > 1)) {
      const {
        x: p,
        y
      } = this.div.getBoundingClientRect();
      this.parent.findNewParent(this, p, y) && (this.x -= Math.floor(this.x), this.y -= Math.floor(this.y));
    }
    let {
      x: r,
      y: l
    } = this;
    const [c, h] = this.getBaseTranslation();
    r += c, l += h;
    const {
      style: I
    } = n;
    I.left = `${(100 * r).toFixed(2)}%`, I.top = `${(100 * l).toFixed(2)}%`, this._onTranslating(r, l), n.scrollIntoView({
      block: "nearest"
    });
  }
  _onTranslating(t, i) {
  }
  _onTranslated(t, i) {
  }
  get _hasBeenMoved() {
    return !!S(this, o2) && (S(this, o2)[0] !== this.x || S(this, o2)[1] !== this.y);
  }
  get _hasBeenResized() {
    return !!S(this, o2) && (S(this, o2)[2] !== this.width || S(this, o2)[3] !== this.height);
  }
  getBaseTranslation() {
    const [t, i] = this.parentDimensions, {
      _borderLineWidth: n
    } = Oo, s = n / t, o = n / i;
    switch (this.rotation) {
      case 90:
        return [-s, o];
      case 180:
        return [s, o];
      case 270:
        return [s, -o];
      default:
        return [-s, -o];
    }
  }
  get _mustFixPosition() {
    return !0;
  }
  fixAndSetPosition(t = this.rotation) {
    const {
      div: {
        style: i
      },
      pageDimensions: [n, s]
    } = this;
    let {
      x: o,
      y: r,
      width: l,
      height: c
    } = this;
    if (l *= n, c *= s, o *= n, r *= s, this._mustFixPosition)
      switch (t) {
        case 0:
          o = Fy(o, 0, n - l), r = Fy(r, 0, s - c);
          break;
        case 90:
          o = Fy(o, 0, n - c), r = Fy(r, l, s);
          break;
        case 180:
          o = Fy(o, l, n), r = Fy(r, c, s);
          break;
        case 270:
          o = Fy(o, c, n), r = Fy(r, 0, s - l);
          break;
      }
    this.x = o /= n, this.y = r /= s;
    const [h, I] = this.getBaseTranslation();
    o += h, r += I, i.left = `${(100 * o).toFixed(2)}%`, i.top = `${(100 * r).toFixed(2)}%`, this.moveInDOM();
  }
  screenToPageTranslation(t, i) {
    var n;
    return _e(n = Oo, yee, Ehe).call(n, t, i, this.parentRotation);
  }
  pageTranslationToScreen(t, i) {
    var n;
    return _e(n = Oo, yee, Ehe).call(n, t, i, 360 - this.parentRotation);
  }
  get parentScale() {
    return this._uiManager.viewParameters.realScale;
  }
  get parentRotation() {
    return (this._uiManager.viewParameters.rotation + this.pageRotation) % 360;
  }
  get parentDimensions() {
    const {
      parentScale: t,
      pageDimensions: [i, n]
    } = this;
    return [i * t, n * t];
  }
  setDims(t, i) {
    const [n, s] = this.parentDimensions, {
      style: o
    } = this.div;
    o.width = `${(100 * t / n).toFixed(2)}%`, S(this, bB) || (o.height = `${(100 * i / s).toFixed(2)}%`);
  }
  fixDims() {
    const {
      style: t
    } = this.div, {
      height: i,
      width: n
    } = t, s = n.endsWith("%"), o = !S(this, bB) && i.endsWith("%");
    if (s && o)
      return;
    const [r, l] = this.parentDimensions;
    s || (t.width = `${(100 * parseFloat(n) / r).toFixed(2)}%`), !S(this, bB) && !o && (t.height = `${(100 * parseFloat(i) / l).toFixed(2)}%`);
  }
  getInitialTranslation() {
    return [0, 0];
  }
  _onResized() {
  }
  static _round(t) {
    return Math.round(t * 1e4) / 1e4;
  }
  _onResizing() {
  }
  altTextFinish() {
    var t;
    (t = S(this, Mu)) == null || t.finish();
  }
  get toolbarButtons() {
    return null;
  }
  async addEditToolbar() {
    if (this._editToolbar || S(this, CB))
      return this._editToolbar;
    this._editToolbar = new ahe(this), this.div.append(this._editToolbar.render()), this._editToolbar.addButton("comment", this.addCommentButton());
    const {
      toolbarButtons: t
    } = this;
    if (t)
      for (const [i, n] of t)
        await this._editToolbar.addButton(i, n);
    return this._editToolbar.addButton("delete"), this._editToolbar;
  }
  removeEditToolbar() {
    var t;
    this._editToolbar && (this._editToolbar.remove(), this._editToolbar = null, (t = S(this, Mu)) == null || t.destroy());
  }
  addContainer(t) {
    var n;
    const i = (n = this._editToolbar) == null ? void 0 : n.div;
    i ? i.before(t) : this.div.append(t);
  }
  getClientDimensions() {
    return this.div.getBoundingClientRect();
  }
  createAltText() {
    return S(this, Mu) || (ole.initialize(Oo._l10n), be(this, Mu, new ole(this)), S(this, SB) && (S(this, Mu).data = S(this, SB), be(this, SB, null))), S(this, Mu);
  }
  get altTextData() {
    var t;
    return (t = S(this, Mu)) == null ? void 0 : t.data;
  }
  set altTextData(t) {
    S(this, Mu) && (S(this, Mu).data = t);
  }
  get guessedAltText() {
    var t;
    return (t = S(this, Mu)) == null ? void 0 : t.guessedText;
  }
  async setGuessedAltText(t) {
    var i;
    await ((i = S(this, Mu)) == null ? void 0 : i.setGuessedText(t));
  }
  serializeAltText(t) {
    var i;
    return (i = S(this, Mu)) == null ? void 0 : i.serialize(t);
  }
  hasAltText() {
    return !!S(this, Mu) && !S(this, Mu).isEmpty();
  }
  hasAltTextData() {
    var t;
    return ((t = S(this, Mu)) == null ? void 0 : t.hasData()) ?? !1;
  }
  addCommentButton() {
    return S(this, gp) ? S(this, gp) : be(this, gp, new cne(this));
  }
  get commentColor() {
    return null;
  }
  get comment() {
    const t = S(this, gp);
    return {
      text: t.data.text,
      date: t.data.date,
      deleted: t.isDeleted(),
      color: this.commentColor
    };
  }
  set comment(t) {
    S(this, gp) || be(this, gp, new cne(this)), S(this, gp).data = t;
  }
  setCommentData(t) {
    S(this, gp) || be(this, gp, new cne(this)), S(this, gp).setInitialText(t);
  }
  get hasEditedComment() {
    var t;
    return (t = S(this, gp)) == null ? void 0 : t.hasBeenEdited();
  }
  async editComment() {
    S(this, gp) || be(this, gp, new cne(this)), S(this, gp).edit();
  }
  addComment(t) {
    this.hasEditedComment && (t.popup = {
      contents: this.comment.text,
      deleted: this.comment.deleted
    });
  }
  render() {
    var r;
    const t = this.div = document.createElement("div");
    t.setAttribute("data-editor-rotation", (360 - this.rotation) % 360), t.className = this.name, t.setAttribute("id", this.id), t.tabIndex = S(this, Qz) ? -1 : 0, t.setAttribute("role", "application"), this.defaultL10nId && t.setAttribute("data-l10n-id", this.defaultL10nId), this._isVisible || t.classList.add("hidden"), this.setInForeground(), _e(this, Cs, Rhe).call(this);
    const [i, n] = this.parentDimensions;
    this.parentRotation % 180 !== 0 && (t.style.maxWidth = `${(100 * n / i).toFixed(2)}%`, t.style.maxHeight = `${(100 * i / n).toFixed(2)}%`);
    const [s, o] = this.getInitialTranslation();
    return this.translate(s, o), s5e(this, t, ["keydown", "pointerdown", "dblclick"]), this.isResizable && this._uiManager._supportsPinchToZoom && (S(this, OB) || be(this, OB, new m5e({
      container: t,
      isPinchingDisabled: () => !this.isSelected,
      onPinchStart: _e(this, Cs, R5e).bind(this),
      onPinching: _e(this, Cs, v5e).bind(this),
      onPinchEnd: _e(this, Cs, A5e).bind(this),
      signal: this._uiManager._signal
    }))), (r = this._uiManager._editorUndoBar) == null || r.hide(), t;
  }
  pointerdown(t) {
    const {
      isMac: i
    } = Qp.platform;
    if (t.button !== 0 || t.ctrlKey && i) {
      t.preventDefault();
      return;
    }
    if (be(this, DB, !0), this._isDraggable) {
      _e(this, Cs, S5e).call(this, t);
      return;
    }
    _e(this, Cs, The).call(this, t);
  }
  _onStartDragging() {
  }
  _onStopDragging() {
  }
  moveInDOM() {
    S(this, Mb) && clearTimeout(S(this, Mb)), be(this, Mb, setTimeout(() => {
      var t;
      be(this, Mb, null), (t = this.parent) == null || t.moveEditorInDOM(this);
    }, 0));
  }
  _setParentAndPosition(t, i, n) {
    t.changeParent(this), this.x = i, this.y = n, this.fixAndSetPosition(), this._onTranslated();
  }
  getRect(t, i, n = this.rotation) {
    const s = this.parentScale, [o, r] = this.pageDimensions, [l, c] = this.pageTranslation, h = t / s, I = i / s, p = this.x * o, y = this.y * r, m = this.width * o, A = this.height * r;
    switch (n) {
      case 0:
        return [p + h + l, r - y - I - A + c, p + h + m + l, r - y - I + c];
      case 90:
        return [p + I + l, r - y + h + c, p + I + A + l, r - y + h + m + c];
      case 180:
        return [p - h - m + l, r - y + I + c, p - h + l, r - y + I + A + c];
      case 270:
        return [p - I - A + l, r - y - h - m + c, p - I + l, r - y - h + c];
      default:
        throw new Error("Invalid rotation");
    }
  }
  getRectInCurrentCoords(t, i) {
    const [n, s, o, r] = t, l = o - n, c = r - s;
    switch (this.rotation) {
      case 0:
        return [n, i - r, l, c];
      case 90:
        return [n, i - s, c, l];
      case 180:
        return [o, i - s, l, c];
      case 270:
        return [o, i - r, c, l];
      default:
        throw new Error("Invalid rotation");
    }
  }
  onceAdded(t) {
  }
  isEmpty() {
    return !1;
  }
  enableEditMode() {
    return this.isInEditMode() ? !1 : (this.parent.setEditingState(!1), be(this, CB, !0), !0);
  }
  disableEditMode() {
    return this.isInEditMode() ? (this.parent.setEditingState(!0), be(this, CB, !1), !0) : !1;
  }
  isInEditMode() {
    return S(this, CB);
  }
  shouldGetKeyboardEvents() {
    return S(this, HC);
  }
  needsToBeRebuilt() {
    return this.div && !this.isAttachedToDOM;
  }
  get isOnScreen() {
    const {
      top: t,
      left: i,
      bottom: n,
      right: s
    } = this.getClientDimensions(), {
      innerHeight: o,
      innerWidth: r
    } = window;
    return i < r && s > 0 && t < o && n > 0;
  }
  rebuild() {
    _e(this, Cs, Rhe).call(this);
  }
  rotate(t) {
  }
  resize() {
  }
  serializeDeleted() {
    var t;
    return {
      id: this.annotationElementId,
      deleted: !0,
      pageIndex: this.pageIndex,
      popupRef: ((t = this._initialData) == null ? void 0 : t.popupRef) || ""
    };
  }
  serialize(t = !1, i = null) {
    Ll("An editor must be serializable");
  }
  static async deserialize(t, i, n) {
    const s = new this.prototype.constructor({
      parent: i,
      id: i.getNextId(),
      uiManager: n,
      annotationElementId: t.annotationElementId
    });
    s.rotation = t.rotation, be(s, SB, t.accessibilityData), s._isCopy = t.isCopy || !1;
    const [o, r] = s.pageDimensions, [l, c, h, I] = s.getRectInCurrentCoords(t.rect, r);
    return s.x = l / o, s.y = c / r, s.width = h / o, s.height = I / r, s;
  }
  get hasBeenModified() {
    return !!this.annotationElementId && (this.deleted || this.serialize() !== null);
  }
  remove() {
    var t, i;
    if ((t = S(this, Dx)) == null || t.abort(), be(this, Dx, null), this.isEmpty() || this.commit(), this.parent ? this.parent.remove(this) : this._uiManager.removeEditor(this), S(this, Mb) && (clearTimeout(S(this, Mb)), be(this, Mb, null)), _e(this, Cs, sQ).call(this), this.removeEditToolbar(), S(this, QT)) {
      for (const n of S(this, QT).values())
        clearTimeout(n);
      be(this, QT, null);
    }
    this.parent = null, (i = S(this, OB)) == null || i.destroy(), be(this, OB, null);
  }
  get isResizable() {
    return !1;
  }
  makeResizable() {
    this.isResizable && (_e(this, Cs, w5e).call(this), S(this, wp).classList.remove("hidden"));
  }
  get toolbarPosition() {
    return null;
  }
  keydown(t) {
    if (!this.isResizable || t.target !== this.div || t.key !== "Enter")
      return;
    this._uiManager.setSelected(this), be(this, FC, {
      savedX: this.x,
      savedY: this.y,
      savedWidth: this.width,
      savedHeight: this.height
    });
    const i = S(this, wp).children;
    if (!S(this, yv)) {
      be(this, yv, Array.from(i));
      const r = _e(this, Cs, b5e).bind(this), l = _e(this, Cs, N5e).bind(this), c = this._uiManager._signal;
      for (const h of S(this, yv)) {
        const I = h.getAttribute("data-resizer-name");
        h.setAttribute("role", "spinbutton"), h.addEventListener("keydown", r, {
          signal: c
        }), h.addEventListener("blur", l, {
          signal: c
        }), h.addEventListener("focus", _e(this, Cs, D5e).bind(this, I), {
          signal: c
        }), h.setAttribute("data-l10n-id", Oo._l10nResizer[I]);
      }
    }
    const n = S(this, yv)[0];
    let s = 0;
    for (const r of i) {
      if (r === n)
        break;
      s++;
    }
    const o = (360 - this.rotation + this.parentRotation) % 360 / 90 * (S(this, yv).length / 4);
    if (o !== s) {
      if (o < s)
        for (let l = 0; l < s - o; l++)
          S(this, wp).append(S(this, wp).firstChild);
      else if (o > s)
        for (let l = 0; l < o - s; l++)
          S(this, wp).firstChild.before(S(this, wp).lastChild);
      let r = 0;
      for (const l of i) {
        const h = S(this, yv)[r++].getAttribute("data-resizer-name");
        l.setAttribute("data-l10n-id", Oo._l10nResizer[h]);
      }
    }
    _e(this, Cs, vhe).call(this, 0), be(this, HC, !0), S(this, wp).firstChild.focus({
      focusVisible: !0
    }), t.preventDefault(), t.stopImmediatePropagation();
  }
  _resizeWithKeyboard(t, i) {
    S(this, HC) && _e(this, Cs, whe).call(this, S(this, Iee), {
      deltaX: t,
      deltaY: i,
      fromKeyboard: !0
    });
  }
  _stopResizingWithKeyboard() {
    _e(this, Cs, sQ).call(this), this.div.focus();
  }
  select() {
    var t, i, n;
    if (!(this.isSelected && this._editToolbar)) {
      if (this.isSelected = !0, this.makeResizable(), (t = this.div) == null || t.classList.add("selectedEditor"), !this._editToolbar) {
        this.addEditToolbar().then(() => {
          var s, o;
          (s = this.div) != null && s.classList.contains("selectedEditor") && ((o = this._editToolbar) == null || o.show());
        });
        return;
      }
      (i = this._editToolbar) == null || i.show(), (n = S(this, Mu)) == null || n.toggleAltTextBadge(!1);
    }
  }
  unselect() {
    var t, i, n, s, o;
    this.isSelected && (this.isSelected = !1, (t = S(this, wp)) == null || t.classList.add("hidden"), (i = this.div) == null || i.classList.remove("selectedEditor"), (n = this.div) != null && n.contains(document.activeElement) && this._uiManager.currentLayer.div.focus({
      preventScroll: !0
    }), (s = this._editToolbar) == null || s.hide(), (o = S(this, Mu)) == null || o.toggleAltTextBadge(!0));
  }
  updateParams(t, i) {
  }
  disableEditing() {
  }
  enableEditing() {
  }
  get canChangeContent() {
    return !1;
  }
  enterInEditMode() {
    this.canChangeContent && (this.enableEditMode(), this.div.focus());
  }
  dblclick(t) {
    this.enterInEditMode(), this.parent.updateToolbar({
      mode: this.constructor._editorType,
      editId: this.id
    });
  }
  getElementForAltText() {
    return this.div;
  }
  get contentDiv() {
    return this.div;
  }
  get isEditing() {
    return S(this, pee);
  }
  set isEditing(t) {
    be(this, pee, t), this.parent && (t ? (this.parent.setSelected(this), this.parent.setActiveEditor(this)) : this.parent.setActiveEditor(null));
  }
  setAspectRatio(t, i) {
    be(this, bB, !0);
    const n = t / i, {
      style: s
    } = this.div;
    s.aspectRatio = n, s.height = "auto";
  }
  static get MIN_SIZE() {
    return 16;
  }
  static canCreateNewEmptyEditor() {
    return !0;
  }
  get telemetryInitialData() {
    return {
      action: "added"
    };
  }
  get telemetryFinalData() {
    return null;
  }
  _reportTelemetry(t, i = !1) {
    if (i) {
      S(this, QT) || be(this, QT, /* @__PURE__ */ new Map());
      const {
        action: n
      } = t;
      let s = S(this, QT).get(n);
      s && clearTimeout(s), s = setTimeout(() => {
        this._reportTelemetry(t), S(this, QT).delete(n), S(this, QT).size === 0 && be(this, QT, null);
      }, Oo._telemetryTimeout), S(this, QT).set(n, s);
      return;
    }
    t.type || (t.type = this.editorType), this._uiManager._eventBus.dispatch("reporttelemetry", {
      source: this,
      details: {
        type: "editing",
        data: t
      }
    });
  }
  show(t = this._isVisible) {
    this.div.classList.toggle("hidden", !t), this._isVisible = t;
  }
  enable() {
    this.div && (this.div.tabIndex = 0), be(this, Qz, !1);
  }
  disable() {
    this.div && (this.div.tabIndex = -1), be(this, Qz, !0);
  }
  renderAnnotationElement(t) {
    let i = t.container.querySelector(".annotationContent");
    if (!i)
      i = document.createElement("div"), i.classList.add("annotationContent", this.editorType), t.container.prepend(i);
    else if (i.nodeName === "CANVAS") {
      const n = i;
      i = document.createElement("div"), i.classList.add("annotationContent", this.editorType), n.before(i);
    }
    return i;
  }
  resetAnnotationElement(t) {
    const {
      firstChild: i
    } = t.container;
    (i == null ? void 0 : i.nodeName) === "DIV" && i.classList.contains("annotationContent") && i.remove();
  }
};
SB = new WeakMap(), yv = new WeakMap(), Mu = new WeakMap(), gp = new WeakMap(), Qz = new WeakMap(), Nx = new WeakMap(), fee = new WeakMap(), bB = new WeakMap(), wp = new WeakMap(), NB = new WeakMap(), FC = new WeakMap(), Dx = new WeakMap(), Iee = new WeakMap(), DB = new WeakMap(), o2 = new WeakMap(), pee = new WeakMap(), CB = new WeakMap(), HC = new WeakMap(), Mb = new WeakMap(), Jz = new WeakMap(), Xz = new WeakMap(), QT = new WeakMap(), OB = new WeakMap(), mee = new WeakMap(), Wle = new WeakMap(), Cs = new WeakSet(), yhe = function([t, i], n, s) {
  [n, s] = this.screenToPageTranslation(n, s), this.x += n / t, this.y += s / i, this._onTranslating(this.x, this.y), this.fixAndSetPosition();
}, yee = new WeakSet(), Ehe = function(t, i, n) {
  switch (n) {
    case 90:
      return [i, -t];
    case 180:
      return [-t, -i];
    case 270:
      return [-i, t];
    default:
      return [t, i];
  }
}, Xse = function(t) {
  switch (t) {
    case 90: {
      const [i, n] = this.pageDimensions;
      return [0, -i / n, n / i, 0];
    }
    case 180:
      return [-1, 0, 0, -1];
    case 270: {
      const [i, n] = this.pageDimensions;
      return [0, i / n, -n / i, 0];
    }
    default:
      return [1, 0, 0, 1];
  }
}, w5e = function() {
  if (S(this, wp))
    return;
  be(this, wp, document.createElement("div")), S(this, wp).classList.add("resizers");
  const t = this._willKeepAspectRatio ? ["topLeft", "topRight", "bottomRight", "bottomLeft"] : ["topLeft", "topMiddle", "topRight", "middleRight", "bottomRight", "bottomMiddle", "bottomLeft", "middleLeft"], i = this._uiManager._signal;
  for (const n of t) {
    const s = document.createElement("div");
    S(this, wp).append(s), s.classList.add("resizer", n), s.setAttribute("data-resizer-name", n), s.addEventListener("pointerdown", _e(this, Cs, T5e).bind(this, n), {
      signal: i
    }), s.addEventListener("contextmenu", F5, {
      signal: i
    }), s.tabIndex = -1;
  }
  this.div.prepend(S(this, wp));
}, T5e = function(t, i) {
  var I;
  i.preventDefault();
  const {
    isMac: n
  } = Qp.platform;
  if (i.button !== 0 || i.ctrlKey && n)
    return;
  (I = S(this, Mu)) == null || I.toggle(!1);
  const s = this._isDraggable;
  this._isDraggable = !1, be(this, NB, [i.screenX, i.screenY]);
  const o = new AbortController(), r = this._uiManager.combinedSignal(o);
  this.parent.togglePointerEvents(!1), window.addEventListener("pointermove", _e(this, Cs, whe).bind(this, t), {
    passive: !0,
    capture: !0,
    signal: r
  }), window.addEventListener("touchmove", P0, {
    passive: !1,
    signal: r
  }), window.addEventListener("contextmenu", F5, {
    signal: r
  }), be(this, FC, {
    savedX: this.x,
    savedY: this.y,
    savedWidth: this.width,
    savedHeight: this.height
  });
  const l = this.parent.div.style.cursor, c = this.div.style.cursor;
  this.div.style.cursor = this.parent.div.style.cursor = window.getComputedStyle(i.target).cursor;
  const h = () => {
    var p;
    o.abort(), this.parent.togglePointerEvents(!0), (p = S(this, Mu)) == null || p.toggle(!0), this._isDraggable = s, this.parent.div.style.cursor = l, this.div.style.cursor = c, _e(this, Cs, eoe).call(this);
  };
  window.addEventListener("pointerup", h, {
    signal: r
  }), window.addEventListener("blur", h, {
    signal: r
  });
}, ghe = function(t, i, n, s) {
  this.width = n, this.height = s, this.x = t, this.y = i;
  const [o, r] = this.parentDimensions;
  this.setDims(o * n, r * s), this.fixAndSetPosition(), this._onResized();
}, eoe = function() {
  if (!S(this, FC))
    return;
  const {
    savedX: t,
    savedY: i,
    savedWidth: n,
    savedHeight: s
  } = S(this, FC);
  be(this, FC, null);
  const o = this.x, r = this.y, l = this.width, c = this.height;
  o === t && r === i && l === n && c === s || this.addCommands({
    cmd: _e(this, Cs, ghe).bind(this, o, r, l, c),
    undo: _e(this, Cs, ghe).bind(this, t, i, n, s),
    mustExec: !0
  });
}, whe = function(t, i) {
  const [n, s] = this.parentDimensions, o = this.x, r = this.y, l = this.width, c = this.height, h = Oo.MIN_SIZE / n, I = Oo.MIN_SIZE / s, p = _e(this, Cs, Xse).call(this, this.rotation), y = (Ve, $e) => [p[0] * Ve + p[2] * $e, p[1] * Ve + p[3] * $e], m = _e(this, Cs, Xse).call(this, 360 - this.rotation), A = (Ve, $e) => [m[0] * Ve + m[2] * $e, m[1] * Ve + m[3] * $e];
  let C, O, R = !1, F = !1;
  switch (t) {
    case "topLeft":
      R = !0, C = (Ve, $e) => [0, 0], O = (Ve, $e) => [Ve, $e];
      break;
    case "topMiddle":
      C = (Ve, $e) => [Ve / 2, 0], O = (Ve, $e) => [Ve / 2, $e];
      break;
    case "topRight":
      R = !0, C = (Ve, $e) => [Ve, 0], O = (Ve, $e) => [0, $e];
      break;
    case "middleRight":
      F = !0, C = (Ve, $e) => [Ve, $e / 2], O = (Ve, $e) => [0, $e / 2];
      break;
    case "bottomRight":
      R = !0, C = (Ve, $e) => [Ve, $e], O = (Ve, $e) => [0, 0];
      break;
    case "bottomMiddle":
      C = (Ve, $e) => [Ve / 2, $e], O = (Ve, $e) => [Ve / 2, 0];
      break;
    case "bottomLeft":
      R = !0, C = (Ve, $e) => [0, $e], O = (Ve, $e) => [Ve, 0];
      break;
    case "middleLeft":
      F = !0, C = (Ve, $e) => [0, $e / 2], O = (Ve, $e) => [Ve, $e / 2];
      break;
  }
  const L = C(l, c), P = O(l, c);
  let z = y(...P);
  const W = Oo._round(o + z[0]), re = Oo._round(r + z[1]);
  let ce = 1, te = 1, ee, Ne;
  if (i.fromKeyboard)
    ({
      deltaX: ee,
      deltaY: Ne
    } = i);
  else {
    const {
      screenX: Ve,
      screenY: $e
    } = i, [vt, Rt] = S(this, NB);
    [ee, Ne] = this.screenToPageTranslation(Ve - vt, $e - Rt), S(this, NB)[0] = Ve, S(this, NB)[1] = $e;
  }
  if ([ee, Ne] = A(ee / n, Ne / s), R) {
    const Ve = Math.hypot(l, c);
    ce = te = Math.max(Math.min(Math.hypot(P[0] - L[0] - ee, P[1] - L[1] - Ne) / Ve, 1 / l, 1 / c), h / l, I / c);
  } else F ? ce = Fy(Math.abs(P[0] - L[0] - ee), h, 1) / l : te = Fy(Math.abs(P[1] - L[1] - Ne), I, 1) / c;
  const Ae = Oo._round(l * ce), Oe = Oo._round(c * te);
  z = y(...O(Ae, Oe));
  const pe = W - z[0], je = re - z[1];
  S(this, o2) || be(this, o2, [this.x, this.y, this.width, this.height]), this.width = Ae, this.height = Oe, this.x = pe, this.y = je, this.setDims(n * Ae, s * Oe), this.fixAndSetPosition(), this._onResizing();
}, R5e = function() {
  var t;
  be(this, FC, {
    savedX: this.x,
    savedY: this.y,
    savedWidth: this.width,
    savedHeight: this.height
  }), (t = S(this, Mu)) == null || t.toggle(!1), this.parent.togglePointerEvents(!1);
}, v5e = function(t, i, n) {
  let o = 0.7 * (n / i) + 1 - 0.7;
  if (o === 1)
    return;
  const r = _e(this, Cs, Xse).call(this, this.rotation), l = (W, re) => [r[0] * W + r[2] * re, r[1] * W + r[3] * re], [c, h] = this.parentDimensions, I = this.x, p = this.y, y = this.width, m = this.height, A = Oo.MIN_SIZE / c, C = Oo.MIN_SIZE / h;
  o = Math.max(Math.min(o, 1 / y, 1 / m), A / y, C / m);
  const O = Oo._round(y * o), R = Oo._round(m * o);
  if (O === y && R === m)
    return;
  S(this, o2) || be(this, o2, [I, p, y, m]);
  const F = l(y / 2, m / 2), L = Oo._round(I + F[0]), P = Oo._round(p + F[1]), z = l(O / 2, R / 2);
  this.x = L - z[0], this.y = P - z[1], this.width = O, this.height = R, this.setDims(c * O, h * R), this.fixAndSetPosition(), this._onResizing();
}, A5e = function() {
  var t;
  (t = S(this, Mu)) == null || t.toggle(!0), this.parent.togglePointerEvents(!0), _e(this, Cs, eoe).call(this);
}, The = function(t) {
  const {
    isMac: i
  } = Qp.platform;
  t.ctrlKey && !i || t.shiftKey || t.metaKey && i ? this.parent.toggleSelected(this) : this.parent.setSelected(this);
}, S5e = function(t) {
  const {
    isSelected: i
  } = this;
  this._uiManager.setUpDragSession();
  let n = !1;
  const s = new AbortController(), o = this._uiManager.combinedSignal(s), r = {
    capture: !0,
    passive: !1,
    signal: o
  }, l = (h) => {
    s.abort(), be(this, Nx, null), be(this, DB, !1), this._uiManager.endDragSession() || _e(this, Cs, The).call(this, h), n && this._onStopDragging();
  };
  i && (be(this, Jz, t.clientX), be(this, Xz, t.clientY), be(this, Nx, t.pointerId), be(this, fee, t.pointerType), window.addEventListener("pointermove", (h) => {
    n || (n = !0, this._onStartDragging());
    const {
      clientX: I,
      clientY: p,
      pointerId: y
    } = h;
    if (y !== S(this, Nx)) {
      P0(h);
      return;
    }
    const [m, A] = this.screenToPageTranslation(I - S(this, Jz), p - S(this, Xz));
    be(this, Jz, I), be(this, Xz, p), this._uiManager.dragSelectedEditors(m, A);
  }, r), window.addEventListener("touchmove", P0, r), window.addEventListener("pointerdown", (h) => {
    h.pointerType === S(this, fee) && (S(this, OB) || h.isPrimary) && l(h), P0(h);
  }, r));
  const c = (h) => {
    if (!S(this, Nx) || S(this, Nx) === h.pointerId) {
      l(h);
      return;
    }
    P0(h);
  };
  window.addEventListener("pointerup", c, {
    signal: o
  }), window.addEventListener("blur", c, {
    signal: o
  });
}, Rhe = function() {
  if (S(this, Dx) || !this.div)
    return;
  be(this, Dx, new AbortController());
  const t = this._uiManager.combinedSignal(S(this, Dx));
  this.div.addEventListener("focusin", this.focusin.bind(this), {
    signal: t
  }), this.div.addEventListener("focusout", this.focusout.bind(this), {
    signal: t
  });
}, b5e = function(t) {
  Oo._resizerKeyboardManager.exec(this, t);
}, N5e = function(t) {
  var i;
  S(this, HC) && ((i = t.relatedTarget) == null ? void 0 : i.parentNode) !== S(this, wp) && _e(this, Cs, sQ).call(this);
}, D5e = function(t) {
  be(this, Iee, S(this, HC) ? t : "");
}, vhe = function(t) {
  if (S(this, yv))
    for (const i of S(this, yv))
      i.tabIndex = t;
}, sQ = function() {
  be(this, HC, !1), _e(this, Cs, vhe).call(this, -1), _e(this, Cs, eoe).call(this);
}, xe(Oo, yee), Zi(Oo, "_l10n", null), Zi(Oo, "_l10nResizer", null), Zi(Oo, "_borderLineWidth", -1), Zi(Oo, "_colorManager", new dhe()), Zi(Oo, "_zIndex", 1), Zi(Oo, "_telemetryTimeout", 1e3);
let na = Oo;
class L_e extends na {
  constructor(t) {
    super(t), this.annotationElementId = t.annotationElementId, this.deleted = !0;
  }
  serialize() {
    return this.serializeDeleted();
  }
}
const Fye = 3285377520, kT = 4294901760, rb = 65535;
class C5e {
  constructor(t) {
    this.h1 = t ? t & 4294967295 : Fye, this.h2 = t ? t & 4294967295 : Fye;
  }
  update(t) {
    let i, n;
    if (typeof t == "string") {
      i = new Uint8Array(t.length * 2), n = 0;
      for (let C = 0, O = t.length; C < O; C++) {
        const R = t.charCodeAt(C);
        R <= 255 ? i[n++] = R : (i[n++] = R >>> 8, i[n++] = R & 255);
      }
    } else if (ArrayBuffer.isView(t))
      i = t.slice(), n = i.byteLength;
    else
      throw new Error("Invalid data format, must be a string or TypedArray.");
    const s = n >> 2, o = n - s * 4, r = new Uint32Array(i.buffer, 0, s);
    let l = 0, c = 0, h = this.h1, I = this.h2;
    const p = 3432918353, y = 461845907, m = p & rb, A = y & rb;
    for (let C = 0; C < s; C++)
      C & 1 ? (l = r[C], l = l * p & kT | l * m & rb, l = l << 15 | l >>> 17, l = l * y & kT | l * A & rb, h ^= l, h = h << 13 | h >>> 19, h = h * 5 + 3864292196) : (c = r[C], c = c * p & kT | c * m & rb, c = c << 15 | c >>> 17, c = c * y & kT | c * A & rb, I ^= c, I = I << 13 | I >>> 19, I = I * 5 + 3864292196);
    switch (l = 0, o) {
      case 3:
        l ^= i[s * 4 + 2] << 16;
      case 2:
        l ^= i[s * 4 + 1] << 8;
      case 1:
        l ^= i[s * 4], l = l * p & kT | l * m & rb, l = l << 15 | l >>> 17, l = l * y & kT | l * A & rb, s & 1 ? h ^= l : I ^= l;
    }
    this.h1 = h, this.h2 = I;
  }
  hexdigest() {
    let t = this.h1, i = this.h2;
    return t ^= i >>> 1, t = t * 3981806797 & kT | t * 36045 & rb, i = i * 4283543511 & kT | ((i << 16 | t >>> 16) * 2950163797 & kT) >>> 16, t ^= i >>> 1, t = t * 444984403 & kT | t * 60499 & rb, i = i * 3301882366 & kT | ((i << 16 | t >>> 16) * 3120437893 & kT) >>> 16, t ^= i >>> 1, (t >>> 0).toString(16).padStart(8, "0") + (i >>> 0).toString(16).padStart(8, "0");
  }
}
const Ahe = Object.freeze({
  map: null,
  hash: "",
  transfer: void 0
});
var LB, _B, Tp, Yle, O5e;
class Dpe {
  constructor() {
    xe(this, Yle);
    xe(this, LB, !1);
    xe(this, _B, null);
    xe(this, Tp, /* @__PURE__ */ new Map());
    this.onSetModified = null, this.onResetModified = null, this.onAnnotationEditor = null;
  }
  getValue(t, i) {
    const n = S(this, Tp).get(t);
    return n === void 0 ? i : Object.assign(i, n);
  }
  getRawValue(t) {
    return S(this, Tp).get(t);
  }
  remove(t) {
    if (S(this, Tp).delete(t), S(this, Tp).size === 0 && this.resetModified(), typeof this.onAnnotationEditor == "function") {
      for (const i of S(this, Tp).values())
        if (i instanceof na)
          return;
      this.onAnnotationEditor(null);
    }
  }
  setValue(t, i) {
    const n = S(this, Tp).get(t);
    let s = !1;
    if (n !== void 0)
      for (const [o, r] of Object.entries(i))
        n[o] !== r && (s = !0, n[o] = r);
    else
      s = !0, S(this, Tp).set(t, i);
    s && _e(this, Yle, O5e).call(this), i instanceof na && typeof this.onAnnotationEditor == "function" && this.onAnnotationEditor(i.constructor._type);
  }
  has(t) {
    return S(this, Tp).has(t);
  }
  get size() {
    return S(this, Tp).size;
  }
  resetModified() {
    S(this, LB) && (be(this, LB, !1), typeof this.onResetModified == "function" && this.onResetModified());
  }
  get print() {
    return new L5e(this);
  }
  get serializable() {
    if (S(this, Tp).size === 0)
      return Ahe;
    const t = /* @__PURE__ */ new Map(), i = new C5e(), n = [], s = /* @__PURE__ */ Object.create(null);
    let o = !1;
    for (const [r, l] of S(this, Tp)) {
      const c = l instanceof na ? l.serialize(!1, s) : l;
      c && (t.set(r, c), i.update(`${r}:${JSON.stringify(c)}`), o || (o = !!c.bitmap));
    }
    if (o)
      for (const r of t.values())
        r.bitmap && n.push(r.bitmap);
    return t.size > 0 ? {
      map: t,
      hash: i.hexdigest(),
      transfer: n
    } : Ahe;
  }
  get editorStats() {
    let t = null;
    const i = /* @__PURE__ */ new Map();
    for (const n of S(this, Tp).values()) {
      if (!(n instanceof na))
        continue;
      const s = n.telemetryFinalData;
      if (!s)
        continue;
      const {
        type: o
      } = s;
      i.has(o) || i.set(o, Object.getPrototypeOf(n).constructor), t || (t = /* @__PURE__ */ Object.create(null));
      const r = t[o] || (t[o] = /* @__PURE__ */ new Map());
      for (const [l, c] of Object.entries(s)) {
        if (l === "type")
          continue;
        let h = r.get(l);
        h || (h = /* @__PURE__ */ new Map(), r.set(l, h));
        const I = h.get(c) ?? 0;
        h.set(c, I + 1);
      }
    }
    for (const [n, s] of i)
      t[n] = s.computeTelemetryFinalData(t[n]);
    return t;
  }
  resetModifiedIds() {
    be(this, _B, null);
  }
  get modifiedIds() {
    if (S(this, _B))
      return S(this, _B);
    const t = [];
    for (const i of S(this, Tp).values())
      !(i instanceof na) || !i.annotationElementId || !i.serialize() || t.push(i.annotationElementId);
    return be(this, _B, {
      ids: new Set(t),
      hash: t.join(",")
    });
  }
  [Symbol.iterator]() {
    return S(this, Tp).entries();
  }
}
LB = new WeakMap(), _B = new WeakMap(), Tp = new WeakMap(), Yle = new WeakSet(), O5e = function() {
  S(this, LB) || (be(this, LB, !0), typeof this.onSetModified == "function" && this.onSetModified());
};
var Eee;
class L5e extends Dpe {
  constructor(i) {
    super();
    xe(this, Eee);
    const {
      map: n,
      hash: s,
      transfer: o
    } = i.serializable, r = structuredClone(n, o ? {
      transfer: o
    } : null);
    be(this, Eee, {
      map: r,
      hash: s,
      transfer: o
    });
  }
  get print() {
    Ll("Should not call PrintAnnotationStorage.print");
  }
  get serializable() {
    return S(this, Eee);
  }
  get modifiedIds() {
    return Zo(this, "modifiedIds", {
      ids: /* @__PURE__ */ new Set(),
      hash: ""
    });
  }
}
Eee = new WeakMap();
var ej;
class __e {
  constructor({
    ownerDocument: t = globalThis.document,
    styleElement: i = null
  }) {
    xe(this, ej, /* @__PURE__ */ new Set());
    this._document = t, this.nativeFontFaces = /* @__PURE__ */ new Set(), this.styleElement = null, this.loadingRequests = [], this.loadTestFontId = 0;
  }
  addNativeFontFace(t) {
    this.nativeFontFaces.add(t), this._document.fonts.add(t);
  }
  removeNativeFontFace(t) {
    this.nativeFontFaces.delete(t), this._document.fonts.delete(t);
  }
  insertRule(t) {
    this.styleElement || (this.styleElement = this._document.createElement("style"), this._document.documentElement.getElementsByTagName("head")[0].append(this.styleElement));
    const i = this.styleElement.sheet;
    i.insertRule(t, i.cssRules.length);
  }
  clear() {
    for (const t of this.nativeFontFaces)
      this._document.fonts.delete(t);
    this.nativeFontFaces.clear(), S(this, ej).clear(), this.styleElement && (this.styleElement.remove(), this.styleElement = null);
  }
  async loadSystemFont({
    systemFontInfo: t,
    disableFontFace: i,
    _inspectFont: n
  }) {
    if (!(!t || S(this, ej).has(t.loadedName))) {
      if (uh(!i, "loadSystemFont shouldn't be called when `disableFontFace` is set."), this.isFontLoadingAPISupported) {
        const {
          loadedName: s,
          src: o,
          style: r
        } = t, l = new FontFace(s, o, r);
        this.addNativeFontFace(l);
        try {
          await l.load(), S(this, ej).add(s), n == null || n(t);
        } catch {
          to(`Cannot load system font: ${t.baseFontName}, installing it could help to improve PDF rendering.`), this.removeNativeFontFace(l);
        }
        return;
      }
      Ll("Not implemented: loadSystemFont without the Font Loading API.");
    }
  }
  async bind(t) {
    if (t.attached || t.missingFile && !t.systemFontInfo)
      return;
    if (t.attached = !0, t.systemFontInfo) {
      await this.loadSystemFont(t);
      return;
    }
    if (this.isFontLoadingAPISupported) {
      const n = t.createNativeFontFace();
      if (n) {
        this.addNativeFontFace(n);
        try {
          await n.loaded;
        } catch (s) {
          throw to(`Failed to load font '${n.family}': '${s}'.`), t.disableFontFace = !0, s;
        }
      }
      return;
    }
    const i = t.createFontFaceRule();
    if (i) {
      if (this.insertRule(i), this.isSyncFontLoadingSupported)
        return;
      await new Promise((n) => {
        const s = this._queueLoadingCallback(n);
        this._prepareFontLoadEvent(t, s);
      });
    }
  }
  get isFontLoadingAPISupported() {
    var i;
    const t = !!((i = this._document) != null && i.fonts);
    return Zo(this, "isFontLoadingAPISupported", t);
  }
  get isSyncFontLoadingSupported() {
    return Zo(this, "isSyncFontLoadingSupported", By || Qp.platform.isFirefox);
  }
  _queueLoadingCallback(t) {
    function i() {
      for (uh(!s.done, "completeRequest() cannot be called twice."), s.done = !0; n.length > 0 && n[0].done; ) {
        const o = n.shift();
        setTimeout(o.callback, 0);
      }
    }
    const {
      loadingRequests: n
    } = this, s = {
      done: !1,
      complete: i,
      callback: t
    };
    return n.push(s), s;
  }
  get _loadTestFont() {
    const t = atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
    return Zo(this, "_loadTestFont", t);
  }
  _prepareFontLoadEvent(t, i) {
    function n(P, z) {
      return P.charCodeAt(z) << 24 | P.charCodeAt(z + 1) << 16 | P.charCodeAt(z + 2) << 8 | P.charCodeAt(z + 3) & 255;
    }
    function s(P, z, W, re) {
      const ce = P.substring(0, z), te = P.substring(z + W);
      return ce + re + te;
    }
    let o, r;
    const l = this._document.createElement("canvas");
    l.width = 1, l.height = 1;
    const c = l.getContext("2d");
    let h = 0;
    function I(P, z) {
      if (++h > 30) {
        to("Load test font never loaded."), z();
        return;
      }
      if (c.font = "30px " + P, c.fillText(".", 0, 20), c.getImageData(0, 0, 1, 1).data[3] > 0) {
        z();
        return;
      }
      setTimeout(I.bind(null, P, z));
    }
    const p = `lt${Date.now()}${this.loadTestFontId++}`;
    let y = this._loadTestFont;
    y = s(y, 976, p.length, p);
    const A = 16, C = 1482184792;
    let O = n(y, A);
    for (o = 0, r = p.length - 3; o < r; o += 4)
      O = O - C + n(p, o) | 0;
    o < p.length && (O = O - C + n(p + "XXX", o) | 0), y = s(y, A, 4, m_e(O));
    const R = `url(data:font/opentype;base64,${btoa(y)});`, F = `@font-face {font-family:"${p}";src:${R}}`;
    this.insertRule(F);
    const L = this._document.createElement("div");
    L.style.visibility = "hidden", L.style.width = L.style.height = "10px", L.style.position = "absolute", L.style.top = L.style.left = "0px";
    for (const P of [t.loadedName, p]) {
      const z = this._document.createElement("span");
      z.textContent = "Hi", z.style.fontFamily = P, L.append(z);
    }
    this._document.body.append(L), I(p, () => {
      L.remove(), i.complete();
    });
  }
}
ej = new WeakMap();
class x_e {
  constructor(t, i = null) {
    this.compiledGlyphs = /* @__PURE__ */ Object.create(null);
    for (const n in t)
      this[n] = t[n];
    this._inspectFont = i;
  }
  createNativeFontFace() {
    var i;
    if (!this.data || this.disableFontFace)
      return null;
    let t;
    if (!this.cssFontInfo)
      t = new FontFace(this.loadedName, this.data, {});
    else {
      const n = {
        weight: this.cssFontInfo.fontWeight
      };
      this.cssFontInfo.italicAngle && (n.style = `oblique ${this.cssFontInfo.italicAngle}deg`), t = new FontFace(this.cssFontInfo.fontFamily, this.data, n);
    }
    return (i = this._inspectFont) == null || i.call(this, this), t;
  }
  createFontFaceRule() {
    var n;
    if (!this.data || this.disableFontFace)
      return null;
    const t = `url(data:${this.mimetype};base64,${QTe(this.data)});`;
    let i;
    if (!this.cssFontInfo)
      i = `@font-face {font-family:"${this.loadedName}";src:${t}}`;
    else {
      let s = `font-weight: ${this.cssFontInfo.fontWeight};`;
      this.cssFontInfo.italicAngle && (s += `font-style: oblique ${this.cssFontInfo.italicAngle}deg;`), i = `@font-face {font-family:"${this.cssFontInfo.fontFamily}";${s}src:${t}}`;
    }
    return (n = this._inspectFont) == null || n.call(this, this, t), i;
  }
  getPathGenerator(t, i) {
    if (this.compiledGlyphs[i] !== void 0)
      return this.compiledGlyphs[i];
    const n = this.loadedName + "_path_" + i;
    let s;
    try {
      s = t.get(n);
    } catch (r) {
      to(`getPathGenerator - ignoring character: "${r}".`);
    }
    const o = new Path2D(s || "");
    return this.fontExtraProperties || t.delete(n), this.compiledGlyphs[i] = o;
  }
}
function P_e(e) {
  if (e instanceof URL)
    return e.href;
  if (typeof e == "string") {
    if (By)
      return e;
    const t = URL.parse(e, window.location);
    if (t)
      return t.href;
  }
  throw new Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
}
function M_e(e) {
  if (By && typeof Buffer < "u" && e instanceof Buffer)
    throw new Error("Please provide binary data as `Uint8Array`, rather than `Buffer`.");
  if (e instanceof Uint8Array && e.byteLength === e.buffer.byteLength)
    return e;
  if (typeof e == "string")
    return cie(e);
  if (e instanceof ArrayBuffer || ArrayBuffer.isView(e) || typeof e == "object" && !isNaN(e == null ? void 0 : e.length))
    return new Uint8Array(e);
  throw new Error("Invalid PDF binary data: either TypedArray, string, or array-like object is expected in the data property.");
}
function hne(e) {
  if (typeof e != "string")
    return null;
  if (e.endsWith("/"))
    return e;
  throw new Error(`Invalid factory url: "${e}" must include trailing slash.`);
}
const She = (e) => typeof e == "object" && Number.isInteger(e == null ? void 0 : e.num) && e.num >= 0 && Number.isInteger(e == null ? void 0 : e.gen) && e.gen >= 0, U_e = (e) => typeof e == "object" && typeof (e == null ? void 0 : e.name) == "string", B_e = T_e.bind(null, She, U_e);
var GC, qle;
class F_e {
  constructor() {
    xe(this, GC, /* @__PURE__ */ new Map());
    xe(this, qle, Promise.resolve());
  }
  postMessage(t, i) {
    const n = {
      data: structuredClone(t, i ? {
        transfer: i
      } : null)
    };
    S(this, qle).then(() => {
      for (const [s] of S(this, GC))
        s.call(this, n);
    });
  }
  addEventListener(t, i, n = null) {
    let s = null;
    if ((n == null ? void 0 : n.signal) instanceof AbortSignal) {
      const {
        signal: o
      } = n;
      if (o.aborted) {
        to("LoopbackPort - cannot use an `aborted` signal.");
        return;
      }
      const r = () => this.removeEventListener(t, i);
      s = () => o.removeEventListener("abort", r), o.addEventListener("abort", r);
    }
    S(this, GC).set(i, s);
  }
  removeEventListener(t, i) {
    const n = S(this, GC).get(i);
    n == null || n(), S(this, GC).delete(i);
  }
  terminate() {
    for (const [, t] of S(this, GC))
      t == null || t();
    S(this, GC).clear();
  }
}
GC = new WeakMap(), qle = new WeakMap();
const fne = {
  DATA: 1,
  ERROR: 2
}, D0 = {
  CANCEL: 1,
  CANCEL_COMPLETE: 2,
  CLOSE: 3,
  ENQUEUE: 4,
  ERROR: 5,
  PULL: 6,
  PULL_COMPLETE: 7,
  START_COMPLETE: 8
};
function Hye() {
}
function ug(e) {
  if (e instanceof WP || e instanceof nhe || e instanceof Mye || e instanceof sle || e instanceof nde)
    return e;
  switch (e instanceof Error || typeof e == "object" && e !== null || Ll('wrapReason: Expected "reason" to be a (possibly cloned) Error.'), e.name) {
    case "AbortException":
      return new WP(e.message);
    case "InvalidPDFException":
      return new nhe(e.message);
    case "PasswordException":
      return new Mye(e.message, e.code);
    case "ResponseException":
      return new sle(e.message, e.status, e.missing);
    case "UnknownErrorException":
      return new nde(e.message, e.details);
  }
  return new nde(e.message, e.toString());
}
var tj, B5, _5e, x5e, P5e, toe;
class oQ {
  constructor(t, i, n) {
    xe(this, B5);
    xe(this, tj, new AbortController());
    this.sourceName = t, this.targetName = i, this.comObj = n, this.callbackId = 1, this.streamId = 1, this.streamSinks = /* @__PURE__ */ Object.create(null), this.streamControllers = /* @__PURE__ */ Object.create(null), this.callbackCapabilities = /* @__PURE__ */ Object.create(null), this.actionHandler = /* @__PURE__ */ Object.create(null), n.addEventListener("message", _e(this, B5, _5e).bind(this), {
      signal: S(this, tj).signal
    });
  }
  on(t, i) {
    const n = this.actionHandler;
    if (n[t])
      throw new Error(`There is already an actionName called "${t}"`);
    n[t] = i;
  }
  send(t, i, n) {
    this.comObj.postMessage({
      sourceName: this.sourceName,
      targetName: this.targetName,
      action: t,
      data: i
    }, n);
  }
  sendWithPromise(t, i, n) {
    const s = this.callbackId++, o = Promise.withResolvers();
    this.callbackCapabilities[s] = o;
    try {
      this.comObj.postMessage({
        sourceName: this.sourceName,
        targetName: this.targetName,
        action: t,
        callbackId: s,
        data: i
      }, n);
    } catch (r) {
      o.reject(r);
    }
    return o.promise;
  }
  sendWithStream(t, i, n, s) {
    const o = this.streamId++, r = this.sourceName, l = this.targetName, c = this.comObj;
    return new ReadableStream({
      start: (h) => {
        const I = Promise.withResolvers();
        return this.streamControllers[o] = {
          controller: h,
          startCall: I,
          pullCall: null,
          cancelCall: null,
          isClosed: !1
        }, c.postMessage({
          sourceName: r,
          targetName: l,
          action: t,
          streamId: o,
          data: i,
          desiredSize: h.desiredSize
        }, s), I.promise;
      },
      pull: (h) => {
        const I = Promise.withResolvers();
        return this.streamControllers[o].pullCall = I, c.postMessage({
          sourceName: r,
          targetName: l,
          stream: D0.PULL,
          streamId: o,
          desiredSize: h.desiredSize
        }), I.promise;
      },
      cancel: (h) => {
        uh(h instanceof Error, "cancel must have a valid reason");
        const I = Promise.withResolvers();
        return this.streamControllers[o].cancelCall = I, this.streamControllers[o].isClosed = !0, c.postMessage({
          sourceName: r,
          targetName: l,
          stream: D0.CANCEL,
          streamId: o,
          reason: ug(h)
        }), I.promise;
      }
    }, n);
  }
  destroy() {
    var t;
    (t = S(this, tj)) == null || t.abort(), be(this, tj, null);
  }
}
tj = new WeakMap(), B5 = new WeakSet(), _5e = function({
  data: t
}) {
  if (t.targetName !== this.sourceName)
    return;
  if (t.stream) {
    _e(this, B5, P5e).call(this, t);
    return;
  }
  if (t.callback) {
    const n = t.callbackId, s = this.callbackCapabilities[n];
    if (!s)
      throw new Error(`Cannot resolve callback ${n}`);
    if (delete this.callbackCapabilities[n], t.callback === fne.DATA)
      s.resolve(t.data);
    else if (t.callback === fne.ERROR)
      s.reject(ug(t.reason));
    else
      throw new Error("Unexpected callback case");
    return;
  }
  const i = this.actionHandler[t.action];
  if (!i)
    throw new Error(`Unknown action from worker: ${t.action}`);
  if (t.callbackId) {
    const n = this.sourceName, s = t.sourceName, o = this.comObj;
    Promise.try(i, t.data).then(function(r) {
      o.postMessage({
        sourceName: n,
        targetName: s,
        callback: fne.DATA,
        callbackId: t.callbackId,
        data: r
      });
    }, function(r) {
      o.postMessage({
        sourceName: n,
        targetName: s,
        callback: fne.ERROR,
        callbackId: t.callbackId,
        reason: ug(r)
      });
    });
    return;
  }
  if (t.streamId) {
    _e(this, B5, x5e).call(this, t);
    return;
  }
  i(t.data);
}, x5e = function(t) {
  const i = t.streamId, n = this.sourceName, s = t.sourceName, o = this.comObj, r = this, l = this.actionHandler[t.action], c = {
    enqueue(h, I = 1, p) {
      if (this.isCancelled)
        return;
      const y = this.desiredSize;
      this.desiredSize -= I, y > 0 && this.desiredSize <= 0 && (this.sinkCapability = Promise.withResolvers(), this.ready = this.sinkCapability.promise), o.postMessage({
        sourceName: n,
        targetName: s,
        stream: D0.ENQUEUE,
        streamId: i,
        chunk: h
      }, p);
    },
    close() {
      this.isCancelled || (this.isCancelled = !0, o.postMessage({
        sourceName: n,
        targetName: s,
        stream: D0.CLOSE,
        streamId: i
      }), delete r.streamSinks[i]);
    },
    error(h) {
      uh(h instanceof Error, "error must have a valid reason"), !this.isCancelled && (this.isCancelled = !0, o.postMessage({
        sourceName: n,
        targetName: s,
        stream: D0.ERROR,
        streamId: i,
        reason: ug(h)
      }));
    },
    sinkCapability: Promise.withResolvers(),
    onPull: null,
    onCancel: null,
    isCancelled: !1,
    desiredSize: t.desiredSize,
    ready: null
  };
  c.sinkCapability.resolve(), c.ready = c.sinkCapability.promise, this.streamSinks[i] = c, Promise.try(l, t.data, c).then(function() {
    o.postMessage({
      sourceName: n,
      targetName: s,
      stream: D0.START_COMPLETE,
      streamId: i,
      success: !0
    });
  }, function(h) {
    o.postMessage({
      sourceName: n,
      targetName: s,
      stream: D0.START_COMPLETE,
      streamId: i,
      reason: ug(h)
    });
  });
}, P5e = function(t) {
  const i = t.streamId, n = this.sourceName, s = t.sourceName, o = this.comObj, r = this.streamControllers[i], l = this.streamSinks[i];
  switch (t.stream) {
    case D0.START_COMPLETE:
      t.success ? r.startCall.resolve() : r.startCall.reject(ug(t.reason));
      break;
    case D0.PULL_COMPLETE:
      t.success ? r.pullCall.resolve() : r.pullCall.reject(ug(t.reason));
      break;
    case D0.PULL:
      if (!l) {
        o.postMessage({
          sourceName: n,
          targetName: s,
          stream: D0.PULL_COMPLETE,
          streamId: i,
          success: !0
        });
        break;
      }
      l.desiredSize <= 0 && t.desiredSize > 0 && l.sinkCapability.resolve(), l.desiredSize = t.desiredSize, Promise.try(l.onPull || Hye).then(function() {
        o.postMessage({
          sourceName: n,
          targetName: s,
          stream: D0.PULL_COMPLETE,
          streamId: i,
          success: !0
        });
      }, function(h) {
        o.postMessage({
          sourceName: n,
          targetName: s,
          stream: D0.PULL_COMPLETE,
          streamId: i,
          reason: ug(h)
        });
      });
      break;
    case D0.ENQUEUE:
      if (uh(r, "enqueue should have stream controller"), r.isClosed)
        break;
      r.controller.enqueue(t.chunk);
      break;
    case D0.CLOSE:
      if (uh(r, "close should have stream controller"), r.isClosed)
        break;
      r.isClosed = !0, r.controller.close(), _e(this, B5, toe).call(this, r, i);
      break;
    case D0.ERROR:
      uh(r, "error should have stream controller"), r.controller.error(ug(t.reason)), _e(this, B5, toe).call(this, r, i);
      break;
    case D0.CANCEL_COMPLETE:
      t.success ? r.cancelCall.resolve() : r.cancelCall.reject(ug(t.reason)), _e(this, B5, toe).call(this, r, i);
      break;
    case D0.CANCEL:
      if (!l)
        break;
      const c = ug(t.reason);
      Promise.try(l.onCancel || Hye, c).then(function() {
        o.postMessage({
          sourceName: n,
          targetName: s,
          stream: D0.CANCEL_COMPLETE,
          streamId: i,
          success: !0
        });
      }, function(h) {
        o.postMessage({
          sourceName: n,
          targetName: s,
          stream: D0.CANCEL_COMPLETE,
          streamId: i,
          reason: ug(h)
        });
      }), l.sinkCapability.reject(c), l.isCancelled = !0, delete this.streamSinks[i];
      break;
    default:
      throw new Error("Unexpected stream case");
  }
}, toe = async function(t, i) {
  var n, s, o;
  await Promise.allSettled([(n = t.startCall) == null ? void 0 : n.promise, (s = t.pullCall) == null ? void 0 : s.promise, (o = t.cancelCall) == null ? void 0 : o.promise]), delete this.streamControllers[i];
};
var gee;
class M5e {
  constructor({
    enableHWA: t = !1
  }) {
    xe(this, gee, !1);
    be(this, gee, t);
  }
  create(t, i) {
    if (t <= 0 || i <= 0)
      throw new Error("Invalid canvas size");
    const n = this._createCanvas(t, i);
    return {
      canvas: n,
      context: n.getContext("2d", {
        willReadFrequently: !S(this, gee)
      })
    };
  }
  reset(t, i, n) {
    if (!t.canvas)
      throw new Error("Canvas is not specified");
    if (i <= 0 || n <= 0)
      throw new Error("Invalid canvas size");
    t.canvas.width = i, t.canvas.height = n;
  }
  destroy(t) {
    if (!t.canvas)
      throw new Error("Canvas is not specified");
    t.canvas.width = 0, t.canvas.height = 0, t.canvas = null, t.context = null;
  }
  _createCanvas(t, i) {
    Ll("Abstract method `_createCanvas` called.");
  }
}
gee = new WeakMap();
class H_e extends M5e {
  constructor({
    ownerDocument: t = globalThis.document,
    enableHWA: i = !1
  }) {
    super({
      enableHWA: i
    }), this._document = t;
  }
  _createCanvas(t, i) {
    const n = this._document.createElement("canvas");
    return n.width = t, n.height = i, n;
  }
}
class U5e {
  constructor({
    baseUrl: t = null,
    isCompressed: i = !0
  }) {
    this.baseUrl = t, this.isCompressed = i;
  }
  async fetch({
    name: t
  }) {
    if (!this.baseUrl)
      throw new Error("Ensure that the `cMapUrl` and `cMapPacked` API parameters are provided.");
    if (!t)
      throw new Error("CMap name must be specified.");
    const i = this.baseUrl + t + (this.isCompressed ? ".bcmap" : "");
    return this._fetch(i).then((n) => ({
      cMapData: n,
      isCompressed: this.isCompressed
    })).catch((n) => {
      throw new Error(`Unable to load ${this.isCompressed ? "binary " : ""}CMap at: ${i}`);
    });
  }
  async _fetch(t) {
    Ll("Abstract method `_fetch` called.");
  }
}
class Gye extends U5e {
  async _fetch(t) {
    const i = await hie(t, this.isCompressed ? "arraybuffer" : "text");
    return i instanceof ArrayBuffer ? new Uint8Array(i) : cie(i);
  }
}
class B5e {
  addFilter(t) {
    return "none";
  }
  addHCMFilter(t, i) {
    return "none";
  }
  addAlphaFilter(t) {
    return "none";
  }
  addLuminosityFilter(t) {
    return "none";
  }
  addHighlightHCMFilter(t, i, n, s, o) {
    return "none";
  }
  destroy(t = !1) {
  }
}
var xB, ij, kC, VC, Pm, PB, MB, zn, _m, rQ, gV, ioe, wV, F5e, bhe, TV, lQ, aQ, Nhe, uQ;
class G_e extends B5e {
  constructor({
    docId: i,
    ownerDocument: n = globalThis.document
  }) {
    super();
    xe(this, zn);
    xe(this, xB);
    xe(this, ij);
    xe(this, kC);
    xe(this, VC);
    xe(this, Pm);
    xe(this, PB);
    xe(this, MB, 0);
    be(this, VC, i), be(this, Pm, n);
  }
  addFilter(i) {
    if (!i)
      return "none";
    let n = S(this, zn, _m).get(i);
    if (n)
      return n;
    const [s, o, r] = _e(this, zn, ioe).call(this, i), l = i.length === 1 ? s : `${s}${o}${r}`;
    if (n = S(this, zn, _m).get(l), n)
      return S(this, zn, _m).set(i, n), n;
    const c = `g_${S(this, VC)}_transfer_map_${hp(this, MB)._++}`, h = _e(this, zn, wV).call(this, c);
    S(this, zn, _m).set(i, h), S(this, zn, _m).set(l, h);
    const I = _e(this, zn, TV).call(this, c);
    return _e(this, zn, aQ).call(this, s, o, r, I), h;
  }
  addHCMFilter(i, n) {
    var A;
    const s = `${i}-${n}`, o = "base";
    let r = S(this, zn, rQ).get(o);
    if ((r == null ? void 0 : r.key) === s || (r ? ((A = r.filter) == null || A.remove(), r.key = s, r.url = "none", r.filter = null) : (r = {
      key: s,
      url: "none",
      filter: null
    }, S(this, zn, rQ).set(o, r)), !i || !n))
      return r.url;
    const l = _e(this, zn, uQ).call(this, i);
    i = ys.makeHexColor(...l);
    const c = _e(this, zn, uQ).call(this, n);
    if (n = ys.makeHexColor(...c), S(this, zn, gV).style.color = "", i === "#000000" && n === "#ffffff" || i === n)
      return r.url;
    const h = new Array(256);
    for (let C = 0; C <= 255; C++) {
      const O = C / 255;
      h[C] = O <= 0.03928 ? O / 12.92 : ((O + 0.055) / 1.055) ** 2.4;
    }
    const I = h.join(","), p = `g_${S(this, VC)}_hcm_filter`, y = r.filter = _e(this, zn, TV).call(this, p);
    _e(this, zn, aQ).call(this, I, I, I, y), _e(this, zn, bhe).call(this, y);
    const m = (C, O) => {
      const R = l[C] / 255, F = c[C] / 255, L = new Array(O + 1);
      for (let P = 0; P <= O; P++)
        L[P] = R + P / O * (F - R);
      return L.join(",");
    };
    return _e(this, zn, aQ).call(this, m(0, 5), m(1, 5), m(2, 5), y), r.url = _e(this, zn, wV).call(this, p), r.url;
  }
  addAlphaFilter(i) {
    let n = S(this, zn, _m).get(i);
    if (n)
      return n;
    const [s] = _e(this, zn, ioe).call(this, [i]), o = `alpha_${s}`;
    if (n = S(this, zn, _m).get(o), n)
      return S(this, zn, _m).set(i, n), n;
    const r = `g_${S(this, VC)}_alpha_map_${hp(this, MB)._++}`, l = _e(this, zn, wV).call(this, r);
    S(this, zn, _m).set(i, l), S(this, zn, _m).set(o, l);
    const c = _e(this, zn, TV).call(this, r);
    return _e(this, zn, Nhe).call(this, s, c), l;
  }
  addLuminosityFilter(i) {
    let n = S(this, zn, _m).get(i || "luminosity");
    if (n)
      return n;
    let s, o;
    if (i ? ([s] = _e(this, zn, ioe).call(this, [i]), o = `luminosity_${s}`) : o = "luminosity", n = S(this, zn, _m).get(o), n)
      return S(this, zn, _m).set(i, n), n;
    const r = `g_${S(this, VC)}_luminosity_map_${hp(this, MB)._++}`, l = _e(this, zn, wV).call(this, r);
    S(this, zn, _m).set(i, l), S(this, zn, _m).set(o, l);
    const c = _e(this, zn, TV).call(this, r);
    return _e(this, zn, F5e).call(this, c), i && _e(this, zn, Nhe).call(this, s, c), l;
  }
  addHighlightHCMFilter(i, n, s, o, r) {
    var F;
    const l = `${n}-${s}-${o}-${r}`;
    let c = S(this, zn, rQ).get(i);
    if ((c == null ? void 0 : c.key) === l || (c ? ((F = c.filter) == null || F.remove(), c.key = l, c.url = "none", c.filter = null) : (c = {
      key: l,
      url: "none",
      filter: null
    }, S(this, zn, rQ).set(i, c)), !n || !s))
      return c.url;
    const [h, I] = [n, s].map(_e(this, zn, uQ).bind(this));
    let p = Math.round(0.2126 * h[0] + 0.7152 * h[1] + 0.0722 * h[2]), y = Math.round(0.2126 * I[0] + 0.7152 * I[1] + 0.0722 * I[2]), [m, A] = [o, r].map(_e(this, zn, uQ).bind(this));
    y < p && ([p, y, m, A] = [y, p, A, m]), S(this, zn, gV).style.color = "";
    const C = (L, P, z) => {
      const W = new Array(256), re = (y - p) / z, ce = L / 255, te = (P - L) / (255 * z);
      let ee = 0;
      for (let Ne = 0; Ne <= z; Ne++) {
        const Ae = Math.round(p + Ne * re), Oe = ce + Ne * te;
        for (let pe = ee; pe <= Ae; pe++)
          W[pe] = Oe;
        ee = Ae + 1;
      }
      for (let Ne = ee; Ne < 256; Ne++)
        W[Ne] = W[ee - 1];
      return W.join(",");
    }, O = `g_${S(this, VC)}_hcm_${i}_filter`, R = c.filter = _e(this, zn, TV).call(this, O);
    return _e(this, zn, bhe).call(this, R), _e(this, zn, aQ).call(this, C(m[0], A[0], 5), C(m[1], A[1], 5), C(m[2], A[2], 5), R), c.url = _e(this, zn, wV).call(this, O), c.url;
  }
  destroy(i = !1) {
    var n, s, o, r;
    i && ((n = S(this, PB)) != null && n.size) || ((s = S(this, kC)) == null || s.parentNode.parentNode.remove(), be(this, kC, null), (o = S(this, ij)) == null || o.clear(), be(this, ij, null), (r = S(this, PB)) == null || r.clear(), be(this, PB, null), be(this, MB, 0));
  }
}
xB = new WeakMap(), ij = new WeakMap(), kC = new WeakMap(), VC = new WeakMap(), Pm = new WeakMap(), PB = new WeakMap(), MB = new WeakMap(), zn = new WeakSet(), _m = function() {
  return S(this, ij) || be(this, ij, /* @__PURE__ */ new Map());
}, rQ = function() {
  return S(this, PB) || be(this, PB, /* @__PURE__ */ new Map());
}, gV = function() {
  if (!S(this, kC)) {
    const i = S(this, Pm).createElement("div"), {
      style: n
    } = i;
    n.visibility = "hidden", n.contain = "strict", n.width = n.height = 0, n.position = "absolute", n.top = n.left = 0, n.zIndex = -1;
    const s = S(this, Pm).createElementNS(kD, "svg");
    s.setAttribute("width", 0), s.setAttribute("height", 0), be(this, kC, S(this, Pm).createElementNS(kD, "defs")), i.append(s), s.append(S(this, kC)), S(this, Pm).body.append(i);
  }
  return S(this, kC);
}, ioe = function(i) {
  if (i.length === 1) {
    const h = i[0], I = new Array(256);
    for (let y = 0; y < 256; y++)
      I[y] = h[y] / 255;
    const p = I.join(",");
    return [p, p, p];
  }
  const [n, s, o] = i, r = new Array(256), l = new Array(256), c = new Array(256);
  for (let h = 0; h < 256; h++)
    r[h] = n[h] / 255, l[h] = s[h] / 255, c[h] = o[h] / 255;
  return [r.join(","), l.join(","), c.join(",")];
}, wV = function(i) {
  if (S(this, xB) === void 0) {
    be(this, xB, "");
    const n = S(this, Pm).URL;
    n !== S(this, Pm).baseURI && (yae(n) ? to('#createUrl: ignore "data:"-URL for performance reasons.') : be(this, xB, $Te(n, "")));
  }
  return `url(${S(this, xB)}#${i})`;
}, F5e = function(i) {
  const n = S(this, Pm).createElementNS(kD, "feColorMatrix");
  n.setAttribute("type", "matrix"), n.setAttribute("values", "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0.59 0.11 0 0"), i.append(n);
}, bhe = function(i) {
  const n = S(this, Pm).createElementNS(kD, "feColorMatrix");
  n.setAttribute("type", "matrix"), n.setAttribute("values", "0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"), i.append(n);
}, TV = function(i) {
  const n = S(this, Pm).createElementNS(kD, "filter");
  return n.setAttribute("color-interpolation-filters", "sRGB"), n.setAttribute("id", i), S(this, zn, gV).append(n), n;
}, lQ = function(i, n, s) {
  const o = S(this, Pm).createElementNS(kD, n);
  o.setAttribute("type", "discrete"), o.setAttribute("tableValues", s), i.append(o);
}, aQ = function(i, n, s, o) {
  const r = S(this, Pm).createElementNS(kD, "feComponentTransfer");
  o.append(r), _e(this, zn, lQ).call(this, r, "feFuncR", i), _e(this, zn, lQ).call(this, r, "feFuncG", n), _e(this, zn, lQ).call(this, r, "feFuncB", s);
}, Nhe = function(i, n) {
  const s = S(this, Pm).createElementNS(kD, "feComponentTransfer");
  n.append(s), _e(this, zn, lQ).call(this, s, "feFuncA", i);
}, uQ = function(i) {
  return S(this, zn, gV).style.color = i, Eae(getComputedStyle(S(this, zn, gV)).getPropertyValue("color"));
};
class H5e {
  constructor({
    baseUrl: t = null
  }) {
    this.baseUrl = t;
  }
  async fetch({
    filename: t
  }) {
    if (!this.baseUrl)
      throw new Error("Ensure that the `standardFontDataUrl` API parameter is provided.");
    if (!t)
      throw new Error("Font filename must be specified.");
    const i = `${this.baseUrl}${t}`;
    return this._fetch(i).catch((n) => {
      throw new Error(`Unable to load font data at: ${i}`);
    });
  }
  async _fetch(t) {
    Ll("Abstract method `_fetch` called.");
  }
}
class kye extends H5e {
  async _fetch(t) {
    const i = await hie(t, "arraybuffer");
    return new Uint8Array(i);
  }
}
class G5e {
  constructor({
    baseUrl: t = null
  }) {
    this.baseUrl = t;
  }
  async fetch({
    filename: t
  }) {
    if (!this.baseUrl)
      throw new Error("Ensure that the `wasmUrl` API parameter is provided.");
    if (!t)
      throw new Error("Wasm filename must be specified.");
    const i = `${this.baseUrl}${t}`;
    return this._fetch(i).catch((n) => {
      throw new Error(`Unable to load wasm data at: ${i}`);
    });
  }
  async _fetch(t) {
    Ll("Abstract method `_fetch` called.");
  }
}
class Vye extends G5e {
  async _fetch(t) {
    const i = await hie(t, "arraybuffer");
    return new Uint8Array(i);
  }
}
By && to("Please use the `legacy` build in Node.js environments.");
async function Cpe(e) {
  const i = await process.getBuiltinModule("fs").promises.readFile(e);
  return new Uint8Array(i);
}
class k_e extends B5e {
}
class V_e extends M5e {
  _createCanvas(t, i) {
    return process.getBuiltinModule("module").createRequire(import.meta.url)("@napi-rs/canvas").createCanvas(t, i);
  }
}
class z_e extends U5e {
  async _fetch(t) {
    return Cpe(t);
  }
}
class j_e extends H5e {
  async _fetch(t) {
    return Cpe(t);
  }
}
class W_e extends G5e {
  async _fetch(t) {
    return Cpe(t);
  }
}
const Np = {
  FILL: "Fill",
  STROKE: "Stroke",
  SHADING: "Shading"
};
function Dhe(e, t) {
  if (!t)
    return;
  const i = t[2] - t[0], n = t[3] - t[1], s = new Path2D();
  s.rect(t[0], t[1], i, n), e.clip(s);
}
class Ope {
  isModifyingCurrentTransform() {
    return !1;
  }
  getPattern() {
    Ll("Abstract method `getPattern` called.");
  }
}
class Y_e extends Ope {
  constructor(t) {
    super(), this._type = t[1], this._bbox = t[2], this._colorStops = t[3], this._p0 = t[4], this._p1 = t[5], this._r0 = t[6], this._r1 = t[7], this.matrix = null;
  }
  _createGradient(t) {
    let i;
    this._type === "axial" ? i = t.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]) : this._type === "radial" && (i = t.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1));
    for (const n of this._colorStops)
      i.addColorStop(n[0], n[1]);
    return i;
  }
  getPattern(t, i, n, s) {
    let o;
    if (s === Np.STROKE || s === Np.FILL) {
      const r = i.current.getClippedPathBoundingBox(s, rd(t)) || [0, 0, 0, 0], l = Math.ceil(r[2] - r[0]) || 1, c = Math.ceil(r[3] - r[1]) || 1, h = i.cachedCanvases.getCanvas("pattern", l, c), I = h.context;
      I.clearRect(0, 0, I.canvas.width, I.canvas.height), I.beginPath(), I.rect(0, 0, I.canvas.width, I.canvas.height), I.translate(-r[0], -r[1]), n = ys.transform(n, [1, 0, 0, 1, r[0], r[1]]), I.transform(...i.baseTransform), this.matrix && I.transform(...this.matrix), Dhe(I, this._bbox), I.fillStyle = this._createGradient(I), I.fill(), o = t.createPattern(h.canvas, "no-repeat");
      const p = new DOMMatrix(n);
      o.setTransform(p);
    } else
      Dhe(t, this._bbox), o = this._createGradient(t);
    return o;
  }
}
function rde(e, t, i, n, s, o, r, l) {
  const c = t.coords, h = t.colors, I = e.data, p = e.width * 4;
  let y;
  c[i + 1] > c[n + 1] && (y = i, i = n, n = y, y = o, o = r, r = y), c[n + 1] > c[s + 1] && (y = n, n = s, s = y, y = r, r = l, l = y), c[i + 1] > c[n + 1] && (y = i, i = n, n = y, y = o, o = r, r = y);
  const m = (c[i] + t.offsetX) * t.scaleX, A = (c[i + 1] + t.offsetY) * t.scaleY, C = (c[n] + t.offsetX) * t.scaleX, O = (c[n + 1] + t.offsetY) * t.scaleY, R = (c[s] + t.offsetX) * t.scaleX, F = (c[s + 1] + t.offsetY) * t.scaleY;
  if (A >= F)
    return;
  const L = h[o], P = h[o + 1], z = h[o + 2], W = h[r], re = h[r + 1], ce = h[r + 2], te = h[l], ee = h[l + 1], Ne = h[l + 2], Ae = Math.round(A), Oe = Math.round(F);
  let pe, je, Ve, $e, vt, Rt, ze, mt;
  for (let Et = Ae; Et <= Oe; Et++) {
    if (Et < O) {
      const Zt = Et < A ? 0 : (A - Et) / (A - O);
      pe = m - (m - C) * Zt, je = L - (L - W) * Zt, Ve = P - (P - re) * Zt, $e = z - (z - ce) * Zt;
    } else {
      let Zt;
      Et > F ? Zt = 1 : O === F ? Zt = 0 : Zt = (O - Et) / (O - F), pe = C - (C - R) * Zt, je = W - (W - te) * Zt, Ve = re - (re - ee) * Zt, $e = ce - (ce - Ne) * Zt;
    }
    let it;
    Et < A ? it = 0 : Et > F ? it = 1 : it = (A - Et) / (A - F), vt = m - (m - R) * it, Rt = L - (L - te) * it, ze = P - (P - ee) * it, mt = z - (z - Ne) * it;
    const Dt = Math.round(Math.min(pe, vt)), Ct = Math.round(Math.max(pe, vt));
    let Kt = p * Et + Dt * 4;
    for (let Zt = Dt; Zt <= Ct; Zt++)
      it = (pe - Zt) / (pe - vt), it < 0 ? it = 0 : it > 1 && (it = 1), I[Kt++] = je - (je - Rt) * it | 0, I[Kt++] = Ve - (Ve - ze) * it | 0, I[Kt++] = $e - ($e - mt) * it | 0, I[Kt++] = 255;
  }
}
function q_e(e, t, i) {
  const n = t.coords, s = t.colors;
  let o, r;
  switch (t.type) {
    case "lattice":
      const l = t.verticesPerRow, c = Math.floor(n.length / l) - 1, h = l - 1;
      for (o = 0; o < c; o++) {
        let I = o * l;
        for (let p = 0; p < h; p++, I++)
          rde(e, i, n[I], n[I + 1], n[I + l], s[I], s[I + 1], s[I + l]), rde(e, i, n[I + l + 1], n[I + 1], n[I + l], s[I + l + 1], s[I + 1], s[I + l]);
      }
      break;
    case "triangles":
      for (o = 0, r = n.length; o < r; o += 3)
        rde(e, i, n[o], n[o + 1], n[o + 2], s[o], s[o + 1], s[o + 2]);
      break;
    default:
      throw new Error("illegal figure");
  }
}
class $_e extends Ope {
  constructor(t) {
    super(), this._coords = t[2], this._colors = t[3], this._figures = t[4], this._bounds = t[5], this._bbox = t[6], this._background = t[7], this.matrix = null;
  }
  _createMeshCanvas(t, i, n) {
    const l = Math.floor(this._bounds[0]), c = Math.floor(this._bounds[1]), h = Math.ceil(this._bounds[2]) - l, I = Math.ceil(this._bounds[3]) - c, p = Math.min(Math.ceil(Math.abs(h * t[0] * 1.1)), 3e3), y = Math.min(Math.ceil(Math.abs(I * t[1] * 1.1)), 3e3), m = h / p, A = I / y, C = {
      coords: this._coords,
      colors: this._colors,
      offsetX: -l,
      offsetY: -c,
      scaleX: 1 / m,
      scaleY: 1 / A
    }, O = p + 4, R = y + 4, F = n.getCanvas("mesh", O, R), L = F.context, P = L.createImageData(p, y);
    if (i) {
      const W = P.data;
      for (let re = 0, ce = W.length; re < ce; re += 4)
        W[re] = i[0], W[re + 1] = i[1], W[re + 2] = i[2], W[re + 3] = 255;
    }
    for (const W of this._figures)
      q_e(P, W, C);
    return L.putImageData(P, 2, 2), {
      canvas: F.canvas,
      offsetX: l - 2 * m,
      offsetY: c - 2 * A,
      scaleX: m,
      scaleY: A
    };
  }
  isModifyingCurrentTransform() {
    return !0;
  }
  getPattern(t, i, n, s) {
    Dhe(t, this._bbox);
    const o = new Float32Array(2);
    if (s === Np.SHADING)
      ys.singularValueDecompose2dScale(rd(t), o);
    else if (this.matrix) {
      ys.singularValueDecompose2dScale(this.matrix, o);
      const [l, c] = o;
      ys.singularValueDecompose2dScale(i.baseTransform, o), o[0] *= l, o[1] *= c;
    } else
      ys.singularValueDecompose2dScale(i.baseTransform, o);
    const r = this._createMeshCanvas(o, s === Np.SHADING ? null : this._background, i.cachedCanvases);
    return s !== Np.SHADING && (t.setTransform(...i.baseTransform), this.matrix && t.transform(...this.matrix)), t.translate(r.offsetX, r.offsetY), t.scale(r.scaleX, r.scaleY), t.createPattern(r.canvas, "no-repeat");
  }
}
class K_e extends Ope {
  getPattern() {
    return "hotpink";
  }
}
function Z_e(e) {
  switch (e[0]) {
    case "RadialAxial":
      return new Y_e(e);
    case "Mesh":
      return new $_e(e);
    case "Dummy":
      return new K_e();
  }
  throw new Error(`Unknown IR type: ${e[0]}`);
}
const zye = {
  COLORED: 1,
  UNCOLORED: 2
}, $le = class $le {
  constructor(t, i, n, s) {
    this.color = t[1], this.operatorList = t[2], this.matrix = t[3], this.bbox = t[4], this.xstep = t[5], this.ystep = t[6], this.paintType = t[7], this.tilingType = t[8], this.ctx = i, this.canvasGraphicsFactory = n, this.baseTransform = s;
  }
  createPatternCanvas(t) {
    const {
      bbox: i,
      operatorList: n,
      paintType: s,
      tilingType: o,
      color: r,
      canvasGraphicsFactory: l
    } = this;
    let {
      xstep: c,
      ystep: h
    } = this;
    c = Math.abs(c), h = Math.abs(h), mae("TilingType: " + o);
    const I = i[0], p = i[1], y = i[2], m = i[3], A = y - I, C = m - p, O = new Float32Array(2);
    ys.singularValueDecompose2dScale(this.matrix, O);
    const [R, F] = O;
    ys.singularValueDecompose2dScale(this.baseTransform, O);
    const L = R * O[0], P = F * O[1];
    let z = A, W = C, re = !1, ce = !1;
    const te = Math.ceil(c * L), ee = Math.ceil(h * P), Ne = Math.ceil(A * L), Ae = Math.ceil(C * P);
    te >= Ne ? z = c : re = !0, ee >= Ae ? W = h : ce = !0;
    const Oe = this.getSizeAndScale(z, this.ctx.canvas.width, L), pe = this.getSizeAndScale(W, this.ctx.canvas.height, P), je = t.cachedCanvases.getCanvas("pattern", Oe.size, pe.size), Ve = je.context, $e = l.createCanvasGraphics(Ve);
    if ($e.groupLevel = t.groupLevel, this.setFillAndStrokeStyleToContext($e, s, r), Ve.translate(-Oe.scale * I, -pe.scale * p), $e.transform(Oe.scale, 0, 0, pe.scale, 0, 0), Ve.save(), this.clipBbox($e, I, p, y, m), $e.baseTransform = rd($e.ctx), $e.executeOperatorList(n), $e.endDrawing(), Ve.restore(), re || ce) {
      const vt = je.canvas;
      re && (z = c), ce && (W = h);
      const Rt = this.getSizeAndScale(z, this.ctx.canvas.width, L), ze = this.getSizeAndScale(W, this.ctx.canvas.height, P), mt = Rt.size, Et = ze.size, it = t.cachedCanvases.getCanvas("pattern-workaround", mt, Et), Dt = it.context, Ct = re ? Math.floor(A / c) : 0, Kt = ce ? Math.floor(C / h) : 0;
      for (let Zt = 0; Zt <= Ct; Zt++)
        for (let Xt = 0; Xt <= Kt; Xt++)
          Dt.drawImage(vt, mt * Zt, Et * Xt, mt, Et, 0, 0, mt, Et);
      return {
        canvas: it.canvas,
        scaleX: Rt.scale,
        scaleY: ze.scale,
        offsetX: I,
        offsetY: p
      };
    }
    return {
      canvas: je.canvas,
      scaleX: Oe.scale,
      scaleY: pe.scale,
      offsetX: I,
      offsetY: p
    };
  }
  getSizeAndScale(t, i, n) {
    const s = Math.max($le.MAX_PATTERN_SIZE, i);
    let o = Math.ceil(t * n);
    return o >= s ? o = s : n = o / t, {
      scale: n,
      size: o
    };
  }
  clipBbox(t, i, n, s, o) {
    const r = s - i, l = o - n;
    t.ctx.rect(i, n, r, l), ys.axialAlignedBoundingBox([i, n, s, o], rd(t.ctx), t.current.minMax), t.clip(), t.endPath();
  }
  setFillAndStrokeStyleToContext(t, i, n) {
    const s = t.ctx, o = t.current;
    switch (i) {
      case zye.COLORED:
        const {
          fillStyle: r,
          strokeStyle: l
        } = this.ctx;
        s.fillStyle = o.fillColor = r, s.strokeStyle = o.strokeColor = l;
        break;
      case zye.UNCOLORED:
        s.fillStyle = s.strokeStyle = n, o.fillColor = o.strokeColor = n;
        break;
      default:
        throw new p_e(`Unsupported paint type: ${i}`);
    }
  }
  isModifyingCurrentTransform() {
    return !1;
  }
  getPattern(t, i, n, s) {
    let o = n;
    s !== Np.SHADING && (o = ys.transform(o, i.baseTransform), this.matrix && (o = ys.transform(o, this.matrix)));
    const r = this.createPatternCanvas(i);
    let l = new DOMMatrix(o);
    l = l.translate(r.offsetX, r.offsetY), l = l.scale(1 / r.scaleX, 1 / r.scaleY);
    const c = t.createPattern(r.canvas, "repeat");
    return c.setTransform(l), c;
  }
};
Zi($le, "MAX_PATTERN_SIZE", 3e3);
let Che = $le;
function Q_e({
  src: e,
  srcPos: t = 0,
  dest: i,
  width: n,
  height: s,
  nonBlackColor: o = 4294967295,
  inverseDecode: r = !1
}) {
  const l = Qp.isLittleEndian ? 4278190080 : 255, [c, h] = r ? [o, l] : [l, o], I = n >> 3, p = n & 7, y = e.length;
  i = new Uint32Array(i.buffer);
  let m = 0;
  for (let A = 0; A < s; A++) {
    for (const O = t + I; t < O; t++) {
      const R = t < y ? e[t] : 255;
      i[m++] = R & 128 ? h : c, i[m++] = R & 64 ? h : c, i[m++] = R & 32 ? h : c, i[m++] = R & 16 ? h : c, i[m++] = R & 8 ? h : c, i[m++] = R & 4 ? h : c, i[m++] = R & 2 ? h : c, i[m++] = R & 1 ? h : c;
    }
    if (p === 0)
      continue;
    const C = t < y ? e[t++] : 255;
    for (let O = 0; O < p; O++)
      i[m++] = C & 1 << 7 - O ? h : c;
  }
  return {
    srcPos: t,
    destPos: m
  };
}
const jye = 16, Wye = 100, J_e = 15, Yye = 10, mg = 16, lde = new DOMMatrix(), w2 = new Float32Array(2), nz = new Float32Array([1 / 0, 1 / 0, -1 / 0, -1 / 0]);
function X_e(e, t) {
  if (e._removeMirroring)
    throw new Error("Context is already forwarding operations.");
  e.__originalSave = e.save, e.__originalRestore = e.restore, e.__originalRotate = e.rotate, e.__originalScale = e.scale, e.__originalTranslate = e.translate, e.__originalTransform = e.transform, e.__originalSetTransform = e.setTransform, e.__originalResetTransform = e.resetTransform, e.__originalClip = e.clip, e.__originalMoveTo = e.moveTo, e.__originalLineTo = e.lineTo, e.__originalBezierCurveTo = e.bezierCurveTo, e.__originalRect = e.rect, e.__originalClosePath = e.closePath, e.__originalBeginPath = e.beginPath, e._removeMirroring = () => {
    e.save = e.__originalSave, e.restore = e.__originalRestore, e.rotate = e.__originalRotate, e.scale = e.__originalScale, e.translate = e.__originalTranslate, e.transform = e.__originalTransform, e.setTransform = e.__originalSetTransform, e.resetTransform = e.__originalResetTransform, e.clip = e.__originalClip, e.moveTo = e.__originalMoveTo, e.lineTo = e.__originalLineTo, e.bezierCurveTo = e.__originalBezierCurveTo, e.rect = e.__originalRect, e.closePath = e.__originalClosePath, e.beginPath = e.__originalBeginPath, delete e._removeMirroring;
  }, e.save = function() {
    t.save(), this.__originalSave();
  }, e.restore = function() {
    t.restore(), this.__originalRestore();
  }, e.translate = function(i, n) {
    t.translate(i, n), this.__originalTranslate(i, n);
  }, e.scale = function(i, n) {
    t.scale(i, n), this.__originalScale(i, n);
  }, e.transform = function(i, n, s, o, r, l) {
    t.transform(i, n, s, o, r, l), this.__originalTransform(i, n, s, o, r, l);
  }, e.setTransform = function(i, n, s, o, r, l) {
    t.setTransform(i, n, s, o, r, l), this.__originalSetTransform(i, n, s, o, r, l);
  }, e.resetTransform = function() {
    t.resetTransform(), this.__originalResetTransform();
  }, e.rotate = function(i) {
    t.rotate(i), this.__originalRotate(i);
  }, e.clip = function(i) {
    t.clip(i), this.__originalClip(i);
  }, e.moveTo = function(i, n) {
    t.moveTo(i, n), this.__originalMoveTo(i, n);
  }, e.lineTo = function(i, n) {
    t.lineTo(i, n), this.__originalLineTo(i, n);
  }, e.bezierCurveTo = function(i, n, s, o, r, l) {
    t.bezierCurveTo(i, n, s, o, r, l), this.__originalBezierCurveTo(i, n, s, o, r, l);
  }, e.rect = function(i, n, s, o) {
    t.rect(i, n, s, o), this.__originalRect(i, n, s, o);
  }, e.closePath = function() {
    t.closePath(), this.__originalClosePath();
  }, e.beginPath = function() {
    t.beginPath(), this.__originalBeginPath();
  };
}
class exe {
  constructor(t) {
    this.canvasFactory = t, this.cache = /* @__PURE__ */ Object.create(null);
  }
  getCanvas(t, i, n) {
    let s;
    return this.cache[t] !== void 0 ? (s = this.cache[t], this.canvasFactory.reset(s, i, n)) : (s = this.canvasFactory.create(i, n), this.cache[t] = s), s;
  }
  delete(t) {
    delete this.cache[t];
  }
  clear() {
    for (const t in this.cache) {
      const i = this.cache[t];
      this.canvasFactory.destroy(i), delete this.cache[t];
    }
  }
}
function Ine(e, t, i, n, s, o, r, l, c, h) {
  const [I, p, y, m, A, C] = rd(e);
  if (p === 0 && y === 0) {
    const F = r * I + A, L = Math.round(F), P = l * m + C, z = Math.round(P), W = (r + c) * I + A, re = Math.abs(Math.round(W) - L) || 1, ce = (l + h) * m + C, te = Math.abs(Math.round(ce) - z) || 1;
    return e.setTransform(Math.sign(I), 0, 0, Math.sign(m), L, z), e.drawImage(t, i, n, s, o, 0, 0, re, te), e.setTransform(I, p, y, m, A, C), [re, te];
  }
  if (I === 0 && m === 0) {
    const F = l * y + A, L = Math.round(F), P = r * p + C, z = Math.round(P), W = (l + h) * y + A, re = Math.abs(Math.round(W) - L) || 1, ce = (r + c) * p + C, te = Math.abs(Math.round(ce) - z) || 1;
    return e.setTransform(0, Math.sign(p), Math.sign(y), 0, L, z), e.drawImage(t, i, n, s, o, 0, 0, te, re), e.setTransform(I, p, y, m, A, C), [te, re];
  }
  e.drawImage(t, i, n, s, o, r, l, c, h);
  const O = Math.hypot(I, p), R = Math.hypot(y, m);
  return [O * c, R * h];
}
class qye {
  constructor(t, i) {
    Zi(this, "alphaIsShape", !1);
    Zi(this, "fontSize", 0);
    Zi(this, "fontSizeScale", 1);
    Zi(this, "textMatrix", null);
    Zi(this, "textMatrixScale", 1);
    Zi(this, "fontMatrix", ihe);
    Zi(this, "leading", 0);
    Zi(this, "x", 0);
    Zi(this, "y", 0);
    Zi(this, "lineX", 0);
    Zi(this, "lineY", 0);
    Zi(this, "charSpacing", 0);
    Zi(this, "wordSpacing", 0);
    Zi(this, "textHScale", 1);
    Zi(this, "textRenderingMode", Lm.FILL);
    Zi(this, "textRise", 0);
    Zi(this, "fillColor", "#000000");
    Zi(this, "strokeColor", "#000000");
    Zi(this, "patternFill", !1);
    Zi(this, "patternStroke", !1);
    Zi(this, "fillAlpha", 1);
    Zi(this, "strokeAlpha", 1);
    Zi(this, "lineWidth", 1);
    Zi(this, "activeSMask", null);
    Zi(this, "transferMaps", "none");
    this.clipBox = new Float32Array([0, 0, t, i]), this.minMax = nz.slice();
  }
  clone() {
    const t = Object.create(this);
    return t.clipBox = this.clipBox.slice(), t.minMax = this.minMax.slice(), t;
  }
  getPathBoundingBox(t = Np.FILL, i = null) {
    const n = this.minMax.slice();
    if (t === Np.STROKE) {
      i || Ll("Stroke bounding box must include transform."), ys.singularValueDecompose2dScale(i, w2);
      const s = w2[0] * this.lineWidth / 2, o = w2[1] * this.lineWidth / 2;
      n[0] -= s, n[1] -= o, n[2] += s, n[3] += o;
    }
    return n;
  }
  updateClipFromPath() {
    const t = ys.intersect(this.clipBox, this.getPathBoundingBox());
    this.startNewPathAndClipBox(t || [0, 0, 0, 0]);
  }
  isEmptyClip() {
    return this.minMax[0] === 1 / 0;
  }
  startNewPathAndClipBox(t) {
    this.clipBox.set(t, 0), this.minMax.set(nz, 0);
  }
  getClippedPathBoundingBox(t = Np.FILL, i = null) {
    return ys.intersect(this.clipBox, this.getPathBoundingBox(t, i));
  }
}
function $ye(e, t) {
  if (t instanceof ImageData) {
    e.putImageData(t, 0, 0);
    return;
  }
  const i = t.height, n = t.width, s = i % mg, o = (i - s) / mg, r = s === 0 ? o : o + 1, l = e.createImageData(n, mg);
  let c = 0, h;
  const I = t.data, p = l.data;
  let y, m, A, C;
  if (t.kind === qse.GRAYSCALE_1BPP) {
    const O = I.byteLength, R = new Uint32Array(p.buffer, 0, p.byteLength >> 2), F = R.length, L = n + 7 >> 3, P = 4294967295, z = Qp.isLittleEndian ? 4278190080 : 255;
    for (y = 0; y < r; y++) {
      for (A = y < o ? mg : s, h = 0, m = 0; m < A; m++) {
        const W = O - c;
        let re = 0;
        const ce = W > L ? n : W * 8 - 7, te = ce & -8;
        let ee = 0, Ne = 0;
        for (; re < te; re += 8)
          Ne = I[c++], R[h++] = Ne & 128 ? P : z, R[h++] = Ne & 64 ? P : z, R[h++] = Ne & 32 ? P : z, R[h++] = Ne & 16 ? P : z, R[h++] = Ne & 8 ? P : z, R[h++] = Ne & 4 ? P : z, R[h++] = Ne & 2 ? P : z, R[h++] = Ne & 1 ? P : z;
        for (; re < ce; re++)
          ee === 0 && (Ne = I[c++], ee = 128), R[h++] = Ne & ee ? P : z, ee >>= 1;
      }
      for (; h < F; )
        R[h++] = 0;
      e.putImageData(l, 0, y * mg);
    }
  } else if (t.kind === qse.RGBA_32BPP) {
    for (m = 0, C = n * mg * 4, y = 0; y < o; y++)
      p.set(I.subarray(c, c + C)), c += C, e.putImageData(l, 0, m), m += mg;
    y < r && (C = n * s * 4, p.set(I.subarray(c, c + C)), e.putImageData(l, 0, m));
  } else if (t.kind === qse.RGB_24BPP)
    for (A = mg, C = n * A, y = 0; y < r; y++) {
      for (y >= o && (A = s, C = n * A), h = 0, m = C; m--; )
        p[h++] = I[c++], p[h++] = I[c++], p[h++] = I[c++], p[h++] = 255;
      e.putImageData(l, 0, y * mg);
    }
  else
    throw new Error(`bad image kind: ${t.kind}`);
}
function Kye(e, t) {
  if (t.bitmap) {
    e.drawImage(t.bitmap, 0, 0);
    return;
  }
  const i = t.height, n = t.width, s = i % mg, o = (i - s) / mg, r = s === 0 ? o : o + 1, l = e.createImageData(n, mg);
  let c = 0;
  const h = t.data, I = l.data;
  for (let p = 0; p < r; p++) {
    const y = p < o ? mg : s;
    ({
      srcPos: c
    } = Q_e({
      src: h,
      srcPos: c,
      dest: I,
      width: n,
      height: y,
      nonBlackColor: 0
    })), e.putImageData(l, 0, p * mg);
  }
}
function pZ(e, t) {
  const i = ["strokeStyle", "fillStyle", "fillRule", "globalAlpha", "lineWidth", "lineCap", "lineJoin", "miterLimit", "globalCompositeOperation", "font", "filter"];
  for (const n of i)
    e[n] !== void 0 && (t[n] = e[n]);
  e.setLineDash !== void 0 && (t.setLineDash(e.getLineDash()), t.lineDashOffset = e.lineDashOffset);
}
function pne(e) {
  e.strokeStyle = e.fillStyle = "#000000", e.fillRule = "nonzero", e.globalAlpha = 1, e.lineWidth = 1, e.lineCap = "butt", e.lineJoin = "miter", e.miterLimit = 10, e.globalCompositeOperation = "source-over", e.font = "10px sans-serif", e.setLineDash !== void 0 && (e.setLineDash([]), e.lineDashOffset = 0);
  const {
    filter: t
  } = e;
  t !== "none" && t !== "" && (e.filter = "none");
}
function Zye(e, t) {
  if (t)
    return !0;
  ys.singularValueDecompose2dScale(e, w2);
  const i = Math.fround(ZF.pixelRatio * SW.PDF_TO_CSS_UNITS);
  return w2[0] <= i && w2[1] <= i;
}
const txe = ["butt", "round", "square"], ixe = ["miter", "round", "bevel"], nxe = {}, Qye = {};
var HA, Ohe, Lhe, _he;
const p3e = class p3e {
  constructor(t, i, n, s, o, {
    optionalContentConfig: r,
    markedContentStack: l = null
  }, c, h) {
    xe(this, HA);
    this.ctx = t, this.current = new qye(this.ctx.canvas.width, this.ctx.canvas.height), this.stateStack = [], this.pendingClip = null, this.pendingEOFill = !1, this.res = null, this.xobjs = null, this.commonObjs = i, this.objs = n, this.canvasFactory = s, this.filterFactory = o, this.groupStack = [], this.baseTransform = null, this.baseTransformStack = [], this.groupLevel = 0, this.smaskStack = [], this.smaskCounter = 0, this.tempSMask = null, this.suspendedCtx = null, this.contentVisible = !0, this.markedContentStack = l || [], this.optionalContentConfig = r, this.cachedCanvases = new exe(this.canvasFactory), this.cachedPatterns = /* @__PURE__ */ new Map(), this.annotationCanvasMap = c, this.viewportScale = 1, this.outputScaleX = 1, this.outputScaleY = 1, this.pageColors = h, this._cachedScaleForStroking = [-1, 0], this._cachedGetSinglePixelWidth = null, this._cachedBitmapsMap = /* @__PURE__ */ new Map();
  }
  getObject(t, i = null) {
    return typeof t == "string" ? t.startsWith("g_") ? this.commonObjs.get(t) : this.objs.get(t) : i;
  }
  beginDrawing({
    transform: t,
    viewport: i,
    transparency: n = !1,
    background: s = null
  }) {
    const o = this.ctx.canvas.width, r = this.ctx.canvas.height, l = this.ctx.fillStyle;
    if (this.ctx.fillStyle = s || "#ffffff", this.ctx.fillRect(0, 0, o, r), this.ctx.fillStyle = l, n) {
      const c = this.cachedCanvases.getCanvas("transparent", o, r);
      this.compositeCtx = this.ctx, this.transparentCanvas = c.canvas, this.ctx = c.context, this.ctx.save(), this.ctx.transform(...rd(this.compositeCtx));
    }
    this.ctx.save(), pne(this.ctx), t && (this.ctx.transform(...t), this.outputScaleX = t[0], this.outputScaleY = t[0]), this.ctx.transform(...i.transform), this.viewportScale = i.scale, this.baseTransform = rd(this.ctx);
  }
  executeOperatorList(t, i, n, s) {
    const o = t.argsArray, r = t.fnArray;
    let l = i || 0;
    const c = o.length;
    if (c === l)
      return l;
    const h = c - l > Yye && typeof n == "function", I = h ? Date.now() + J_e : 0;
    let p = 0;
    const y = this.commonObjs, m = this.objs;
    let A;
    for (; ; ) {
      if (s !== void 0 && l === s.nextBreakPoint)
        return s.breakIt(l, n), l;
      if (A = r[l], A !== nle.dependency)
        this[A].apply(this, o[l]);
      else
        for (const C of o[l]) {
          const O = C.startsWith("g_") ? y : m;
          if (!O.has(C))
            return O.get(C, n), l;
        }
      if (l++, l === c)
        return l;
      if (h && ++p > Yye) {
        if (Date.now() > I)
          return n(), l;
        p = 0;
      }
    }
  }
  endDrawing() {
    _e(this, HA, Ohe).call(this), this.cachedCanvases.clear(), this.cachedPatterns.clear();
    for (const t of this._cachedBitmapsMap.values()) {
      for (const i of t.values())
        typeof HTMLCanvasElement < "u" && i instanceof HTMLCanvasElement && (i.width = i.height = 0);
      t.clear();
    }
    this._cachedBitmapsMap.clear(), _e(this, HA, Lhe).call(this);
  }
  _scaleImage(t, i) {
    const n = t.width ?? t.displayWidth, s = t.height ?? t.displayHeight;
    let o = Math.max(Math.hypot(i[0], i[1]), 1), r = Math.max(Math.hypot(i[2], i[3]), 1), l = n, c = s, h = "prescale1", I, p;
    for (; o > 2 && l > 1 || r > 2 && c > 1; ) {
      let y = l, m = c;
      o > 2 && l > 1 && (y = l >= 16384 ? Math.floor(l / 2) - 1 || 1 : Math.ceil(l / 2), o /= l / y), r > 2 && c > 1 && (m = c >= 16384 ? Math.floor(c / 2) - 1 || 1 : Math.ceil(c) / 2, r /= c / m), I = this.cachedCanvases.getCanvas(h, y, m), p = I.context, p.clearRect(0, 0, y, m), p.drawImage(t, 0, 0, l, c, 0, 0, y, m), t = I.canvas, l = y, c = m, h = h === "prescale1" ? "prescale2" : "prescale1";
    }
    return {
      img: t,
      paintWidth: l,
      paintHeight: c
    };
  }
  _createMaskCanvas(t) {
    const i = this.ctx, {
      width: n,
      height: s
    } = t, o = this.current.fillColor, r = this.current.patternFill, l = rd(i);
    let c, h, I, p;
    if ((t.bitmap || t.data) && t.count > 1) {
      const te = t.bitmap || t.data.buffer;
      h = JSON.stringify(r ? l : [l.slice(0, 4), o]), c = this._cachedBitmapsMap.get(te), c || (c = /* @__PURE__ */ new Map(), this._cachedBitmapsMap.set(te, c));
      const ee = c.get(h);
      if (ee && !r) {
        const Ne = Math.round(Math.min(l[0], l[2]) + l[4]), Ae = Math.round(Math.min(l[1], l[3]) + l[5]);
        return {
          canvas: ee,
          offsetX: Ne,
          offsetY: Ae
        };
      }
      I = ee;
    }
    I || (p = this.cachedCanvases.getCanvas("maskCanvas", n, s), Kye(p.context, t));
    let y = ys.transform(l, [1 / n, 0, 0, -1 / s, 0, 0]);
    y = ys.transform(y, [1, 0, 0, 1, 0, -s]);
    const m = nz.slice();
    ys.axialAlignedBoundingBox([0, 0, n, s], y, m);
    const [A, C, O, R] = m, F = Math.round(O - A) || 1, L = Math.round(R - C) || 1, P = this.cachedCanvases.getCanvas("fillCanvas", F, L), z = P.context, W = A, re = C;
    z.translate(-W, -re), z.transform(...y), I || (I = this._scaleImage(p.canvas, ob(z)), I = I.img, c && r && c.set(h, I)), z.imageSmoothingEnabled = Zye(rd(z), t.interpolate), Ine(z, I, 0, 0, I.width, I.height, 0, 0, n, s), z.globalCompositeOperation = "source-in";
    const ce = ys.transform(ob(z), [1, 0, 0, 1, -W, -re]);
    return z.fillStyle = r ? o.getPattern(i, this, ce, Np.FILL) : o, z.fillRect(0, 0, n, s), c && !r && (this.cachedCanvases.delete("fillCanvas"), c.set(h, P.canvas)), {
      canvas: P.canvas,
      offsetX: Math.round(W),
      offsetY: Math.round(re)
    };
  }
  setLineWidth(t) {
    t !== this.current.lineWidth && (this._cachedScaleForStroking[0] = -1), this.current.lineWidth = t, this.ctx.lineWidth = t;
  }
  setLineCap(t) {
    this.ctx.lineCap = txe[t];
  }
  setLineJoin(t) {
    this.ctx.lineJoin = ixe[t];
  }
  setMiterLimit(t) {
    this.ctx.miterLimit = t;
  }
  setDash(t, i) {
    const n = this.ctx;
    n.setLineDash !== void 0 && (n.setLineDash(t), n.lineDashOffset = i);
  }
  setRenderingIntent(t) {
  }
  setFlatness(t) {
  }
  setGState(t) {
    for (const [i, n] of t)
      switch (i) {
        case "LW":
          this.setLineWidth(n);
          break;
        case "LC":
          this.setLineCap(n);
          break;
        case "LJ":
          this.setLineJoin(n);
          break;
        case "ML":
          this.setMiterLimit(n);
          break;
        case "D":
          this.setDash(n[0], n[1]);
          break;
        case "RI":
          this.setRenderingIntent(n);
          break;
        case "FL":
          this.setFlatness(n);
          break;
        case "Font":
          this.setFont(n[0], n[1]);
          break;
        case "CA":
          this.current.strokeAlpha = n;
          break;
        case "ca":
          this.ctx.globalAlpha = this.current.fillAlpha = n;
          break;
        case "BM":
          this.ctx.globalCompositeOperation = n;
          break;
        case "SMask":
          this.current.activeSMask = n ? this.tempSMask : null, this.tempSMask = null, this.checkSMaskState();
          break;
        case "TR":
          this.ctx.filter = this.current.transferMaps = this.filterFactory.addFilter(n);
          break;
      }
  }
  get inSMaskMode() {
    return !!this.suspendedCtx;
  }
  checkSMaskState() {
    const t = this.inSMaskMode;
    this.current.activeSMask && !t ? this.beginSMaskMode() : !this.current.activeSMask && t && this.endSMaskMode();
  }
  beginSMaskMode() {
    if (this.inSMaskMode)
      throw new Error("beginSMaskMode called while already in smask mode");
    const t = this.ctx.canvas.width, i = this.ctx.canvas.height, n = "smaskGroupAt" + this.groupLevel, s = this.cachedCanvases.getCanvas(n, t, i);
    this.suspendedCtx = this.ctx;
    const o = this.ctx = s.context;
    o.setTransform(this.suspendedCtx.getTransform()), pZ(this.suspendedCtx, o), X_e(o, this.suspendedCtx), this.setGState([["BM", "source-over"]]);
  }
  endSMaskMode() {
    if (!this.inSMaskMode)
      throw new Error("endSMaskMode called while not in smask mode");
    this.ctx._removeMirroring(), pZ(this.ctx, this.suspendedCtx), this.ctx = this.suspendedCtx, this.suspendedCtx = null;
  }
  compose(t) {
    if (!this.current.activeSMask)
      return;
    t ? (t[0] = Math.floor(t[0]), t[1] = Math.floor(t[1]), t[2] = Math.ceil(t[2]), t[3] = Math.ceil(t[3])) : t = [0, 0, this.ctx.canvas.width, this.ctx.canvas.height];
    const i = this.current.activeSMask, n = this.suspendedCtx;
    this.composeSMask(n, i, this.ctx, t), this.ctx.save(), this.ctx.setTransform(1, 0, 0, 1, 0, 0), this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height), this.ctx.restore();
  }
  composeSMask(t, i, n, s) {
    const o = s[0], r = s[1], l = s[2] - o, c = s[3] - r;
    l === 0 || c === 0 || (this.genericComposeSMask(i.context, n, l, c, i.subtype, i.backdrop, i.transferMap, o, r, i.offsetX, i.offsetY), t.save(), t.globalAlpha = 1, t.globalCompositeOperation = "source-over", t.setTransform(1, 0, 0, 1, 0, 0), t.drawImage(n.canvas, 0, 0), t.restore());
  }
  genericComposeSMask(t, i, n, s, o, r, l, c, h, I, p) {
    let y = t.canvas, m = c - I, A = h - p;
    if (r)
      if (m < 0 || A < 0 || m + n > y.width || A + s > y.height) {
        const O = this.cachedCanvases.getCanvas("maskExtension", n, s), R = O.context;
        R.drawImage(y, -m, -A), R.globalCompositeOperation = "destination-atop", R.fillStyle = r, R.fillRect(0, 0, n, s), R.globalCompositeOperation = "source-over", y = O.canvas, m = A = 0;
      } else {
        t.save(), t.globalAlpha = 1, t.setTransform(1, 0, 0, 1, 0, 0);
        const O = new Path2D();
        O.rect(m, A, n, s), t.clip(O), t.globalCompositeOperation = "destination-atop", t.fillStyle = r, t.fillRect(m, A, n, s), t.restore();
      }
    i.save(), i.globalAlpha = 1, i.setTransform(1, 0, 0, 1, 0, 0), o === "Alpha" && l ? i.filter = this.filterFactory.addAlphaFilter(l) : o === "Luminosity" && (i.filter = this.filterFactory.addLuminosityFilter(l));
    const C = new Path2D();
    C.rect(c, h, n, s), i.clip(C), i.globalCompositeOperation = "destination-in", i.drawImage(y, m, A, n, s, c, h, n, s), i.restore();
  }
  save() {
    this.inSMaskMode && pZ(this.ctx, this.suspendedCtx), this.ctx.save();
    const t = this.current;
    this.stateStack.push(t), this.current = t.clone();
  }
  restore() {
    if (this.stateStack.length === 0) {
      this.inSMaskMode && this.endSMaskMode();
      return;
    }
    this.current = this.stateStack.pop(), this.ctx.restore(), this.inSMaskMode && pZ(this.suspendedCtx, this.ctx), this.checkSMaskState(), this.pendingClip = null, this._cachedScaleForStroking[0] = -1, this._cachedGetSinglePixelWidth = null;
  }
  transform(t, i, n, s, o, r) {
    this.ctx.transform(t, i, n, s, o, r), this._cachedScaleForStroking[0] = -1, this._cachedGetSinglePixelWidth = null;
  }
  constructPath(t, i, n) {
    let [s] = i;
    if (!n) {
      s || (s = i[0] = new Path2D()), this[t](s);
      return;
    }
    if (!(s instanceof Path2D)) {
      const o = i[0] = new Path2D();
      for (let r = 0, l = s.length; r < l; )
        switch (s[r++]) {
          case dne.moveTo:
            o.moveTo(s[r++], s[r++]);
            break;
          case dne.lineTo:
            o.lineTo(s[r++], s[r++]);
            break;
          case dne.curveTo:
            o.bezierCurveTo(s[r++], s[r++], s[r++], s[r++], s[r++], s[r++]);
            break;
          case dne.closePath:
            o.closePath();
            break;
          default:
            to(`Unrecognized drawing path operator: ${s[r - 1]}`);
            break;
        }
      s = o;
    }
    ys.axialAlignedBoundingBox(n, rd(this.ctx), this.current.minMax), this[t](s);
  }
  closePath() {
    this.ctx.closePath();
  }
  stroke(t, i = !0) {
    const n = this.ctx, s = this.current.strokeColor;
    if (n.globalAlpha = this.current.strokeAlpha, this.contentVisible)
      if (typeof s == "object" && (s != null && s.getPattern)) {
        const o = s.isModifyingCurrentTransform() ? n.getTransform() : null;
        if (n.save(), n.strokeStyle = s.getPattern(n, this, ob(n), Np.STROKE), o) {
          const r = new Path2D();
          r.addPath(t, n.getTransform().invertSelf().multiplySelf(o)), t = r;
        }
        this.rescaleAndStroke(t, !1), n.restore();
      } else
        this.rescaleAndStroke(t, !0);
    i && this.consumePath(t, this.current.getClippedPathBoundingBox(Np.STROKE, rd(this.ctx))), n.globalAlpha = this.current.fillAlpha;
  }
  closeStroke(t) {
    this.stroke(t);
  }
  fill(t, i = !0) {
    const n = this.ctx, s = this.current.fillColor, o = this.current.patternFill;
    let r = !1;
    if (o) {
      const c = s.isModifyingCurrentTransform() ? n.getTransform() : null;
      if (n.save(), n.fillStyle = s.getPattern(n, this, ob(n), Np.FILL), c) {
        const h = new Path2D();
        h.addPath(t, n.getTransform().invertSelf().multiplySelf(c)), t = h;
      }
      r = !0;
    }
    const l = this.current.getClippedPathBoundingBox();
    this.contentVisible && l !== null && (this.pendingEOFill ? (n.fill(t, "evenodd"), this.pendingEOFill = !1) : n.fill(t)), r && n.restore(), i && this.consumePath(t, l);
  }
  eoFill(t) {
    this.pendingEOFill = !0, this.fill(t);
  }
  fillStroke(t) {
    this.fill(t, !1), this.stroke(t, !1), this.consumePath(t);
  }
  eoFillStroke(t) {
    this.pendingEOFill = !0, this.fillStroke(t);
  }
  closeFillStroke(t) {
    this.fillStroke(t);
  }
  closeEOFillStroke(t) {
    this.pendingEOFill = !0, this.fillStroke(t);
  }
  endPath(t) {
    this.consumePath(t);
  }
  rawFillPath(t) {
    this.ctx.fill(t);
  }
  clip() {
    this.pendingClip = nxe;
  }
  eoClip() {
    this.pendingClip = Qye;
  }
  beginText() {
    this.current.textMatrix = null, this.current.textMatrixScale = 1, this.current.x = this.current.lineX = 0, this.current.y = this.current.lineY = 0;
  }
  endText() {
    const t = this.pendingTextPaths, i = this.ctx;
    if (t === void 0)
      return;
    const n = new Path2D(), s = i.getTransform().invertSelf();
    for (const {
      transform: o,
      x: r,
      y: l,
      fontSize: c,
      path: h
    } of t)
      h && n.addPath(h, new DOMMatrix(o).preMultiplySelf(s).translate(r, l).scale(c, -c));
    i.clip(n), delete this.pendingTextPaths;
  }
  setCharSpacing(t) {
    this.current.charSpacing = t;
  }
  setWordSpacing(t) {
    this.current.wordSpacing = t;
  }
  setHScale(t) {
    this.current.textHScale = t / 100;
  }
  setLeading(t) {
    this.current.leading = -t;
  }
  setFont(t, i) {
    var I;
    const n = this.commonObjs.get(t), s = this.current;
    if (!n)
      throw new Error(`Can't find font for ${t}`);
    if (s.fontMatrix = n.fontMatrix || ihe, (s.fontMatrix[0] === 0 || s.fontMatrix[3] === 0) && to("Invalid font matrix for font " + t), i < 0 ? (i = -i, s.fontDirection = -1) : s.fontDirection = 1, this.current.font = n, this.current.fontSize = i, n.isType3Font)
      return;
    const o = n.loadedName || "sans-serif", r = ((I = n.systemFontInfo) == null ? void 0 : I.css) || `"${o}", ${n.fallbackName}`;
    let l = "normal";
    n.black ? l = "900" : n.bold && (l = "bold");
    const c = n.italic ? "italic" : "normal";
    let h = i;
    i < jye ? h = jye : i > Wye && (h = Wye), this.current.fontSizeScale = i / h, this.ctx.font = `${c} ${l} ${h}px ${r}`;
  }
  setTextRenderingMode(t) {
    this.current.textRenderingMode = t;
  }
  setTextRise(t) {
    this.current.textRise = t;
  }
  moveText(t, i) {
    this.current.x = this.current.lineX += t, this.current.y = this.current.lineY += i;
  }
  setLeadingMoveText(t, i) {
    this.setLeading(-i), this.moveText(t, i);
  }
  setTextMatrix(t) {
    const {
      current: i
    } = this;
    i.textMatrix = t, i.textMatrixScale = Math.hypot(t[0], t[1]), i.x = i.lineX = 0, i.y = i.lineY = 0;
  }
  nextLine() {
    this.moveText(0, this.current.leading);
  }
  paintChar(t, i, n, s, o) {
    const r = this.ctx, l = this.current, c = l.font, h = l.textRenderingMode, I = l.fontSize / l.fontSizeScale, p = h & Lm.FILL_STROKE_MASK, y = !!(h & Lm.ADD_TO_PATH_FLAG), m = l.patternFill && !c.missingFile, A = l.patternStroke && !c.missingFile;
    let C;
    if ((c.disableFontFace || y || m || A) && !c.missingFile && (C = c.getPathGenerator(this.commonObjs, t)), C && (c.disableFontFace || m || A)) {
      r.save(), r.translate(i, n), r.scale(I, -I);
      let O;
      if ((p === Lm.FILL || p === Lm.FILL_STROKE) && (s ? (O = r.getTransform(), r.setTransform(...s), r.fill(_e(this, HA, _he).call(this, C, O, s))) : r.fill(C)), p === Lm.STROKE || p === Lm.FILL_STROKE)
        if (o) {
          O || (O = r.getTransform()), r.setTransform(...o);
          const {
            a: R,
            b: F,
            c: L,
            d: P
          } = O, z = ys.inverseTransform(o), W = ys.transform([R, F, L, P, 0, 0], z);
          ys.singularValueDecompose2dScale(W, w2), r.lineWidth *= Math.max(w2[0], w2[1]) / I, r.stroke(_e(this, HA, _he).call(this, C, O, o));
        } else
          r.lineWidth /= I, r.stroke(C);
      r.restore();
    } else
      (p === Lm.FILL || p === Lm.FILL_STROKE) && r.fillText(t, i, n), (p === Lm.STROKE || p === Lm.FILL_STROKE) && r.strokeText(t, i, n);
    y && (this.pendingTextPaths || (this.pendingTextPaths = [])).push({
      transform: rd(r),
      x: i,
      y: n,
      fontSize: I,
      path: C
    });
  }
  get isFontSubpixelAAEnabled() {
    const {
      context: t
    } = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10);
    t.scale(1.5, 1), t.fillText("I", 0, 10);
    const i = t.getImageData(0, 0, 10, 10).data;
    let n = !1;
    for (let s = 3; s < i.length; s += 4)
      if (i[s] > 0 && i[s] < 255) {
        n = !0;
        break;
      }
    return Zo(this, "isFontSubpixelAAEnabled", n);
  }
  showText(t) {
    const i = this.current, n = i.font;
    if (n.isType3Font)
      return this.showType3Text(t);
    const s = i.fontSize;
    if (s === 0)
      return;
    const o = this.ctx, r = i.fontSizeScale, l = i.charSpacing, c = i.wordSpacing, h = i.fontDirection, I = i.textHScale * h, p = t.length, y = n.vertical, m = y ? 1 : -1, A = n.defaultVMetrics, C = s * i.fontMatrix[0], O = i.textRenderingMode === Lm.FILL && !n.disableFontFace && !i.patternFill;
    o.save(), i.textMatrix && o.transform(...i.textMatrix), o.translate(i.x, i.y + i.textRise), h > 0 ? o.scale(I, -1) : o.scale(I, 1);
    let R, F;
    if (i.patternFill) {
      o.save();
      const re = i.fillColor.getPattern(o, this, ob(o), Np.FILL);
      R = rd(o), o.restore(), o.fillStyle = re;
    }
    if (i.patternStroke) {
      o.save();
      const re = i.strokeColor.getPattern(o, this, ob(o), Np.STROKE);
      F = rd(o), o.restore(), o.strokeStyle = re;
    }
    let L = i.lineWidth;
    const P = i.textMatrixScale;
    if (P === 0 || L === 0) {
      const re = i.textRenderingMode & Lm.FILL_STROKE_MASK;
      (re === Lm.STROKE || re === Lm.FILL_STROKE) && (L = this.getSinglePixelWidth());
    } else
      L /= P;
    if (r !== 1 && (o.scale(r, r), L /= r), o.lineWidth = L, n.isInvalidPDFjsFont) {
      const re = [];
      let ce = 0;
      for (const te of t)
        re.push(te.unicode), ce += te.width;
      o.fillText(re.join(""), 0, 0), i.x += ce * C * I, o.restore(), this.compose();
      return;
    }
    let z = 0, W;
    for (W = 0; W < p; ++W) {
      const re = t[W];
      if (typeof re == "number") {
        z += m * re * s / 1e3;
        continue;
      }
      let ce = !1;
      const te = (re.isSpace ? c : 0) + l, ee = re.fontChar, Ne = re.accent;
      let Ae, Oe, pe = re.width;
      if (y) {
        const Ve = re.vmetric || A, $e = -(re.vmetric ? Ve[1] : pe * 0.5) * C, vt = Ve[2] * C;
        pe = Ve ? -Ve[0] : pe, Ae = $e / r, Oe = (z + vt) / r;
      } else
        Ae = z / r, Oe = 0;
      if (n.remeasure && pe > 0) {
        const Ve = o.measureText(ee).width * 1e3 / s * r;
        if (pe < Ve && this.isFontSubpixelAAEnabled) {
          const $e = pe / Ve;
          ce = !0, o.save(), o.scale($e, 1), Ae /= $e;
        } else pe !== Ve && (Ae += (pe - Ve) / 2e3 * s / r);
      }
      if (this.contentVisible && (re.isInFont || n.missingFile)) {
        if (O && !Ne)
          o.fillText(ee, Ae, Oe);
        else if (this.paintChar(ee, Ae, Oe, R, F), Ne) {
          const Ve = Ae + s * Ne.offset.x / r, $e = Oe - s * Ne.offset.y / r;
          this.paintChar(Ne.fontChar, Ve, $e, R, F);
        }
      }
      const je = y ? pe * C - te * h : pe * C + te * h;
      z += je, ce && o.restore();
    }
    y ? i.y -= z : i.x += z * I, o.restore(), this.compose();
  }
  showType3Text(t) {
    const i = this.ctx, n = this.current, s = n.font, o = n.fontSize, r = n.fontDirection, l = s.vertical ? 1 : -1, c = n.charSpacing, h = n.wordSpacing, I = n.textHScale * r, p = n.fontMatrix || ihe, y = t.length, m = n.textRenderingMode === Lm.INVISIBLE;
    let A, C, O, R;
    if (!(m || o === 0)) {
      for (this._cachedScaleForStroking[0] = -1, this._cachedGetSinglePixelWidth = null, i.save(), n.textMatrix && i.transform(...n.textMatrix), i.translate(n.x, n.y + n.textRise), i.scale(I, r), A = 0; A < y; ++A) {
        if (C = t[A], typeof C == "number") {
          R = l * C * o / 1e3, this.ctx.translate(R, 0), n.x += R * I;
          continue;
        }
        const F = (C.isSpace ? h : 0) + c, L = s.charProcOperatorList[C.operatorListId];
        L ? this.contentVisible && (this.save(), i.scale(o, o), i.transform(...p), this.executeOperatorList(L), this.restore()) : to(`Type3 character "${C.operatorListId}" is not available.`);
        const P = [C.width, 0];
        ys.applyTransform(P, p), O = P[0] * o + F, i.translate(O, 0), n.x += O * I;
      }
      i.restore();
    }
  }
  setCharWidth(t, i) {
  }
  setCharWidthAndBounds(t, i, n, s, o, r) {
    const l = new Path2D();
    l.rect(n, s, o - n, r - s), this.ctx.clip(l), this.endPath();
  }
  getColorN_Pattern(t) {
    let i;
    if (t[0] === "TilingPattern") {
      const n = this.baseTransform || rd(this.ctx), s = {
        createCanvasGraphics: (o) => new p3e(o, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
          optionalContentConfig: this.optionalContentConfig,
          markedContentStack: this.markedContentStack
        })
      };
      i = new Che(t, this.ctx, s, n);
    } else
      i = this._getPattern(t[1], t[2]);
    return i;
  }
  setStrokeColorN() {
    this.current.strokeColor = this.getColorN_Pattern(arguments), this.current.patternStroke = !0;
  }
  setFillColorN() {
    this.current.fillColor = this.getColorN_Pattern(arguments), this.current.patternFill = !0;
  }
  setStrokeRGBColor(t) {
    this.ctx.strokeStyle = this.current.strokeColor = t, this.current.patternStroke = !1;
  }
  setStrokeTransparent() {
    this.ctx.strokeStyle = this.current.strokeColor = "transparent", this.current.patternStroke = !1;
  }
  setFillRGBColor(t) {
    this.ctx.fillStyle = this.current.fillColor = t, this.current.patternFill = !1;
  }
  setFillTransparent() {
    this.ctx.fillStyle = this.current.fillColor = "transparent", this.current.patternFill = !1;
  }
  _getPattern(t, i = null) {
    let n;
    return this.cachedPatterns.has(t) ? n = this.cachedPatterns.get(t) : (n = Z_e(this.getObject(t)), this.cachedPatterns.set(t, n)), i && (n.matrix = i), n;
  }
  shadingFill(t) {
    if (!this.contentVisible)
      return;
    const i = this.ctx;
    this.save();
    const n = this._getPattern(t);
    i.fillStyle = n.getPattern(i, this, ob(i), Np.SHADING);
    const s = ob(i);
    if (s) {
      const {
        width: o,
        height: r
      } = i.canvas, l = nz.slice();
      ys.axialAlignedBoundingBox([0, 0, o, r], s, l);
      const [c, h, I, p] = l;
      this.ctx.fillRect(c, h, I - c, p - h);
    } else
      this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
    this.compose(this.current.getClippedPathBoundingBox()), this.restore();
  }
  beginInlineImage() {
    Ll("Should not call beginInlineImage");
  }
  beginImageData() {
    Ll("Should not call beginImageData");
  }
  paintFormXObjectBegin(t, i) {
    if (this.contentVisible && (this.save(), this.baseTransformStack.push(this.baseTransform), t && this.transform(...t), this.baseTransform = rd(this.ctx), i)) {
      ys.axialAlignedBoundingBox(i, this.baseTransform, this.current.minMax);
      const [n, s, o, r] = i, l = new Path2D();
      l.rect(n, s, o - n, r - s), this.ctx.clip(l), this.endPath();
    }
  }
  paintFormXObjectEnd() {
    this.contentVisible && (this.restore(), this.baseTransform = this.baseTransformStack.pop());
  }
  beginGroup(t) {
    if (!this.contentVisible)
      return;
    this.save(), this.inSMaskMode && (this.endSMaskMode(), this.current.activeSMask = null);
    const i = this.ctx;
    t.isolated || mae("TODO: Support non-isolated groups."), t.knockout && to("Knockout groups not supported.");
    const n = rd(i);
    if (t.matrix && i.transform(...t.matrix), !t.bbox)
      throw new Error("Bounding box is required.");
    let s = nz.slice();
    ys.axialAlignedBoundingBox(t.bbox, rd(i), s);
    const o = [0, 0, i.canvas.width, i.canvas.height];
    s = ys.intersect(s, o) || [0, 0, 0, 0];
    const r = Math.floor(s[0]), l = Math.floor(s[1]), c = Math.max(Math.ceil(s[2]) - r, 1), h = Math.max(Math.ceil(s[3]) - l, 1);
    this.current.startNewPathAndClipBox([0, 0, c, h]);
    let I = "groupAt" + this.groupLevel;
    t.smask && (I += "_smask_" + this.smaskCounter++ % 2);
    const p = this.cachedCanvases.getCanvas(I, c, h), y = p.context;
    y.translate(-r, -l), y.transform(...n);
    let m = new Path2D();
    const [A, C, O, R] = t.bbox;
    if (m.rect(A, C, O - A, R - C), t.matrix) {
      const F = new Path2D();
      F.addPath(m, new DOMMatrix(t.matrix)), m = F;
    }
    y.clip(m), t.smask ? this.smaskStack.push({
      canvas: p.canvas,
      context: y,
      offsetX: r,
      offsetY: l,
      subtype: t.smask.subtype,
      backdrop: t.smask.backdrop,
      transferMap: t.smask.transferMap || null,
      startTransformInverse: null
    }) : (i.setTransform(1, 0, 0, 1, 0, 0), i.translate(r, l), i.save()), pZ(i, y), this.ctx = y, this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]), this.groupStack.push(i), this.groupLevel++;
  }
  endGroup(t) {
    if (!this.contentVisible)
      return;
    this.groupLevel--;
    const i = this.ctx, n = this.groupStack.pop();
    if (this.ctx = n, this.ctx.imageSmoothingEnabled = !1, t.smask)
      this.tempSMask = this.smaskStack.pop(), this.restore();
    else {
      this.ctx.restore();
      const s = rd(this.ctx);
      this.restore(), this.ctx.save(), this.ctx.setTransform(...s);
      const o = nz.slice();
      ys.axialAlignedBoundingBox([0, 0, i.canvas.width, i.canvas.height], s, o), this.ctx.drawImage(i.canvas, 0, 0), this.ctx.restore(), this.compose(o);
    }
  }
  beginAnnotation(t, i, n, s, o) {
    if (_e(this, HA, Ohe).call(this), pne(this.ctx), this.ctx.save(), this.save(), this.baseTransform && this.ctx.setTransform(...this.baseTransform), i) {
      const r = i[2] - i[0], l = i[3] - i[1];
      if (o && this.annotationCanvasMap) {
        n = n.slice(), n[4] -= i[0], n[5] -= i[1], i = i.slice(), i[0] = i[1] = 0, i[2] = r, i[3] = l, ys.singularValueDecompose2dScale(rd(this.ctx), w2);
        const {
          viewportScale: c
        } = this, h = Math.ceil(r * this.outputScaleX * c), I = Math.ceil(l * this.outputScaleY * c);
        this.annotationCanvas = this.canvasFactory.create(h, I);
        const {
          canvas: p,
          context: y
        } = this.annotationCanvas;
        this.annotationCanvasMap.set(t, p), this.annotationCanvas.savedCtx = this.ctx, this.ctx = y, this.ctx.save(), this.ctx.setTransform(w2[0], 0, 0, -w2[1], 0, l * w2[1]), pne(this.ctx);
      } else {
        pne(this.ctx), this.endPath();
        const c = new Path2D();
        c.rect(i[0], i[1], r, l), this.ctx.clip(c);
      }
    }
    this.current = new qye(this.ctx.canvas.width, this.ctx.canvas.height), this.transform(...n), this.transform(...s);
  }
  endAnnotation() {
    this.annotationCanvas && (this.ctx.restore(), _e(this, HA, Lhe).call(this), this.ctx = this.annotationCanvas.savedCtx, delete this.annotationCanvas.savedCtx, delete this.annotationCanvas);
  }
  paintImageMaskXObject(t) {
    if (!this.contentVisible)
      return;
    const i = t.count;
    t = this.getObject(t.data, t), t.count = i;
    const n = this.ctx, s = this._createMaskCanvas(t), o = s.canvas;
    n.save(), n.setTransform(1, 0, 0, 1, 0, 0), n.drawImage(o, s.offsetX, s.offsetY), n.restore(), this.compose();
  }
  paintImageMaskXObjectRepeat(t, i, n = 0, s = 0, o, r) {
    if (!this.contentVisible)
      return;
    t = this.getObject(t.data, t);
    const l = this.ctx;
    l.save();
    const c = rd(l);
    l.transform(i, n, s, o, 0, 0);
    const h = this._createMaskCanvas(t);
    l.setTransform(1, 0, 0, 1, h.offsetX - c[4], h.offsetY - c[5]);
    for (let I = 0, p = r.length; I < p; I += 2) {
      const y = ys.transform(c, [i, n, s, o, r[I], r[I + 1]]);
      l.drawImage(h.canvas, y[4], y[5]);
    }
    l.restore(), this.compose();
  }
  paintImageMaskXObjectGroup(t) {
    if (!this.contentVisible)
      return;
    const i = this.ctx, n = this.current.fillColor, s = this.current.patternFill;
    for (const o of t) {
      const {
        data: r,
        width: l,
        height: c,
        transform: h
      } = o, I = this.cachedCanvases.getCanvas("maskCanvas", l, c), p = I.context;
      p.save();
      const y = this.getObject(r, o);
      Kye(p, y), p.globalCompositeOperation = "source-in", p.fillStyle = s ? n.getPattern(p, this, ob(i), Np.FILL) : n, p.fillRect(0, 0, l, c), p.restore(), i.save(), i.transform(...h), i.scale(1, -1), Ine(i, I.canvas, 0, 0, l, c, 0, -1, 1, 1), i.restore();
    }
    this.compose();
  }
  paintImageXObject(t) {
    if (!this.contentVisible)
      return;
    const i = this.getObject(t);
    if (!i) {
      to("Dependent image isn't ready yet");
      return;
    }
    this.paintInlineImageXObject(i);
  }
  paintImageXObjectRepeat(t, i, n, s) {
    if (!this.contentVisible)
      return;
    const o = this.getObject(t);
    if (!o) {
      to("Dependent image isn't ready yet");
      return;
    }
    const r = o.width, l = o.height, c = [];
    for (let h = 0, I = s.length; h < I; h += 2)
      c.push({
        transform: [i, 0, 0, n, s[h], s[h + 1]],
        x: 0,
        y: 0,
        w: r,
        h: l
      });
    this.paintInlineImageXObjectGroup(o, c);
  }
  applyTransferMapsToCanvas(t) {
    return this.current.transferMaps !== "none" && (t.filter = this.current.transferMaps, t.drawImage(t.canvas, 0, 0), t.filter = "none"), t.canvas;
  }
  applyTransferMapsToBitmap(t) {
    if (this.current.transferMaps === "none")
      return t.bitmap;
    const {
      bitmap: i,
      width: n,
      height: s
    } = t, o = this.cachedCanvases.getCanvas("inlineImage", n, s), r = o.context;
    return r.filter = this.current.transferMaps, r.drawImage(i, 0, 0), r.filter = "none", o.canvas;
  }
  paintInlineImageXObject(t) {
    if (!this.contentVisible)
      return;
    const i = t.width, n = t.height, s = this.ctx;
    this.save();
    const {
      filter: o
    } = s;
    o !== "none" && o !== "" && (s.filter = "none"), s.scale(1 / i, -1 / n);
    let r;
    if (t.bitmap)
      r = this.applyTransferMapsToBitmap(t);
    else if (typeof HTMLElement == "function" && t instanceof HTMLElement || !t.data)
      r = t;
    else {
      const h = this.cachedCanvases.getCanvas("inlineImage", i, n).context;
      $ye(h, t), r = this.applyTransferMapsToCanvas(h);
    }
    const l = this._scaleImage(r, ob(s));
    s.imageSmoothingEnabled = Zye(rd(s), t.interpolate), Ine(s, l.img, 0, 0, l.paintWidth, l.paintHeight, 0, -n, i, n), this.compose(), this.restore();
  }
  paintInlineImageXObjectGroup(t, i) {
    if (!this.contentVisible)
      return;
    const n = this.ctx;
    let s;
    if (t.bitmap)
      s = t.bitmap;
    else {
      const o = t.width, r = t.height, c = this.cachedCanvases.getCanvas("inlineImage", o, r).context;
      $ye(c, t), s = this.applyTransferMapsToCanvas(c);
    }
    for (const o of i)
      n.save(), n.transform(...o.transform), n.scale(1, -1), Ine(n, s, o.x, o.y, o.w, o.h, 0, -1, 1, 1), n.restore();
    this.compose();
  }
  paintSolidColorImageMask() {
    this.contentVisible && (this.ctx.fillRect(0, 0, 1, 1), this.compose());
  }
  markPoint(t) {
  }
  markPointProps(t, i) {
  }
  beginMarkedContent(t) {
    this.markedContentStack.push({
      visible: !0
    });
  }
  beginMarkedContentProps(t, i) {
    t === "OC" ? this.markedContentStack.push({
      visible: this.optionalContentConfig.isVisible(i)
    }) : this.markedContentStack.push({
      visible: !0
    }), this.contentVisible = this.isContentVisible();
  }
  endMarkedContent() {
    this.markedContentStack.pop(), this.contentVisible = this.isContentVisible();
  }
  beginCompat() {
  }
  endCompat() {
  }
  consumePath(t, i) {
    const n = this.current.isEmptyClip();
    this.pendingClip && this.current.updateClipFromPath(), this.pendingClip || this.compose(i);
    const s = this.ctx;
    this.pendingClip && (n || (this.pendingClip === Qye ? s.clip(t, "evenodd") : s.clip(t)), this.pendingClip = null), this.current.startNewPathAndClipBox(this.current.clipBox);
  }
  getSinglePixelWidth() {
    if (!this._cachedGetSinglePixelWidth) {
      const t = rd(this.ctx);
      if (t[1] === 0 && t[2] === 0)
        this._cachedGetSinglePixelWidth = 1 / Math.min(Math.abs(t[0]), Math.abs(t[3]));
      else {
        const i = Math.abs(t[0] * t[3] - t[2] * t[1]), n = Math.hypot(t[0], t[2]), s = Math.hypot(t[1], t[3]);
        this._cachedGetSinglePixelWidth = Math.max(n, s) / i;
      }
    }
    return this._cachedGetSinglePixelWidth;
  }
  getScaleForStroking() {
    if (this._cachedScaleForStroking[0] === -1) {
      const {
        lineWidth: t
      } = this.current, {
        a: i,
        b: n,
        c: s,
        d: o
      } = this.ctx.getTransform();
      let r, l;
      if (n === 0 && s === 0) {
        const c = Math.abs(i), h = Math.abs(o);
        if (c === h)
          if (t === 0)
            r = l = 1 / c;
          else {
            const I = c * t;
            r = l = I < 1 ? 1 / I : 1;
          }
        else if (t === 0)
          r = 1 / c, l = 1 / h;
        else {
          const I = c * t, p = h * t;
          r = I < 1 ? 1 / I : 1, l = p < 1 ? 1 / p : 1;
        }
      } else {
        const c = Math.abs(i * o - n * s), h = Math.hypot(i, n), I = Math.hypot(s, o);
        if (t === 0)
          r = I / c, l = h / c;
        else {
          const p = t * c;
          r = I > p ? I / p : 1, l = h > p ? h / p : 1;
        }
      }
      this._cachedScaleForStroking[0] = r, this._cachedScaleForStroking[1] = l;
    }
    return this._cachedScaleForStroking;
  }
  rescaleAndStroke(t, i) {
    const {
      ctx: n,
      current: {
        lineWidth: s
      }
    } = this, [o, r] = this.getScaleForStroking();
    if (o === r) {
      n.lineWidth = (s || 1) * o, n.stroke(t);
      return;
    }
    const l = n.getLineDash();
    i && n.save(), n.scale(o, r), lde.a = 1 / o, lde.d = 1 / r;
    const c = new Path2D();
    if (c.addPath(t, lde), l.length > 0) {
      const h = Math.max(o, r);
      n.setLineDash(l.map((I) => I / h)), n.lineDashOffset /= h;
    }
    n.lineWidth = s || 1, n.stroke(c), i && n.restore();
  }
  isContentVisible() {
    for (let t = this.markedContentStack.length - 1; t >= 0; t--)
      if (!this.markedContentStack[t].visible)
        return !1;
    return !0;
  }
};
HA = new WeakSet(), Ohe = function() {
  for (; this.stateStack.length || this.inSMaskMode; )
    this.restore();
  this.current.activeSMask = null, this.ctx.restore(), this.transparentCanvas && (this.ctx = this.compositeCtx, this.ctx.save(), this.ctx.setTransform(1, 0, 0, 1, 0, 0), this.ctx.drawImage(this.transparentCanvas, 0, 0), this.ctx.restore(), this.transparentCanvas = null);
}, Lhe = function() {
  if (this.pageColors) {
    const t = this.filterFactory.addHCMFilter(this.pageColors.foreground, this.pageColors.background);
    if (t !== "none") {
      const i = this.ctx.filter;
      this.ctx.filter = t, this.ctx.drawImage(this.ctx.canvas, 0, 0), this.ctx.filter = i;
    }
  }
}, _he = function(t, i, n) {
  const s = new Path2D();
  return s.addPath(t, new DOMMatrix(n).invertSelf().multiplySelf(i)), s;
};
let Rz = p3e;
for (const e in nle)
  Rz.prototype[e] !== void 0 && (Rz.prototype[nle[e]] = Rz.prototype[e]);
var Wse, wee, Tee;
let lx = (Wse = class {
  static get workerPort() {
    return S(this, wee);
  }
  static set workerPort(t) {
    if (!(typeof Worker < "u" && t instanceof Worker) && t !== null)
      throw new Error("Invalid `workerPort` type.");
    be(this, wee, t);
  }
  static get workerSrc() {
    return S(this, Tee);
  }
  static set workerSrc(t) {
    if (typeof t != "string")
      throw new Error("Invalid `workerSrc` type.");
    be(this, Tee, t);
  }
}, wee = new WeakMap(), Tee = new WeakMap(), xe(Wse, wee, null), xe(Wse, Tee, ""), Wse);
var nj, Ree;
class sxe {
  constructor({
    parsedData: t,
    rawData: i
  }) {
    xe(this, nj);
    xe(this, Ree);
    be(this, nj, t), be(this, Ree, i);
  }
  getRaw() {
    return S(this, Ree);
  }
  get(t) {
    return S(this, nj).get(t) ?? null;
  }
  [Symbol.iterator]() {
    return S(this, nj).entries();
  }
}
nj = new WeakMap(), Ree = new WeakMap();
const RV = Symbol("INTERNAL");
var vee, Aee, See, sj;
class oxe {
  constructor(t, {
    name: i,
    intent: n,
    usage: s,
    rbGroups: o
  }) {
    xe(this, vee, !1);
    xe(this, Aee, !1);
    xe(this, See, !1);
    xe(this, sj, !0);
    be(this, vee, !!(t & g2.DISPLAY)), be(this, Aee, !!(t & g2.PRINT)), this.name = i, this.intent = n, this.usage = s, this.rbGroups = o;
  }
  get visible() {
    if (S(this, See))
      return S(this, sj);
    if (!S(this, sj))
      return !1;
    const {
      print: t,
      view: i
    } = this.usage;
    return S(this, vee) ? (i == null ? void 0 : i.viewState) !== "OFF" : S(this, Aee) ? (t == null ? void 0 : t.printState) !== "OFF" : !0;
  }
  _setVisible(t, i, n = !1) {
    t !== RV && Ll("Internal method `_setVisible` called."), be(this, See, n), be(this, sj, i);
  }
}
vee = new WeakMap(), Aee = new WeakMap(), See = new WeakMap(), sj = new WeakMap();
var Cx, Nl, oj, rj, bee, xhe;
class rxe {
  constructor(t, i = g2.DISPLAY) {
    xe(this, bee);
    xe(this, Cx, null);
    xe(this, Nl, /* @__PURE__ */ new Map());
    xe(this, oj, null);
    xe(this, rj, null);
    if (this.renderingIntent = i, this.name = null, this.creator = null, t !== null) {
      this.name = t.name, this.creator = t.creator, be(this, rj, t.order);
      for (const n of t.groups)
        S(this, Nl).set(n.id, new oxe(i, n));
      if (t.baseState === "OFF")
        for (const n of S(this, Nl).values())
          n._setVisible(RV, !1);
      for (const n of t.on)
        S(this, Nl).get(n)._setVisible(RV, !0);
      for (const n of t.off)
        S(this, Nl).get(n)._setVisible(RV, !1);
      be(this, oj, this.getHash());
    }
  }
  isVisible(t) {
    if (S(this, Nl).size === 0)
      return !0;
    if (!t)
      return mae("Optional content group not defined."), !0;
    if (t.type === "OCG")
      return S(this, Nl).has(t.id) ? S(this, Nl).get(t.id).visible : (to(`Optional content group not found: ${t.id}`), !0);
    if (t.type === "OCMD") {
      if (t.expression)
        return _e(this, bee, xhe).call(this, t.expression);
      if (!t.policy || t.policy === "AnyOn") {
        for (const i of t.ids) {
          if (!S(this, Nl).has(i))
            return to(`Optional content group not found: ${i}`), !0;
          if (S(this, Nl).get(i).visible)
            return !0;
        }
        return !1;
      } else if (t.policy === "AllOn") {
        for (const i of t.ids) {
          if (!S(this, Nl).has(i))
            return to(`Optional content group not found: ${i}`), !0;
          if (!S(this, Nl).get(i).visible)
            return !1;
        }
        return !0;
      } else if (t.policy === "AnyOff") {
        for (const i of t.ids) {
          if (!S(this, Nl).has(i))
            return to(`Optional content group not found: ${i}`), !0;
          if (!S(this, Nl).get(i).visible)
            return !0;
        }
        return !1;
      } else if (t.policy === "AllOff") {
        for (const i of t.ids) {
          if (!S(this, Nl).has(i))
            return to(`Optional content group not found: ${i}`), !0;
          if (S(this, Nl).get(i).visible)
            return !1;
        }
        return !0;
      }
      return to(`Unknown optional content policy ${t.policy}.`), !0;
    }
    return to(`Unknown group type ${t.type}.`), !0;
  }
  setVisibility(t, i = !0, n = !0) {
    var o;
    const s = S(this, Nl).get(t);
    if (!s) {
      to(`Optional content group not found: ${t}`);
      return;
    }
    if (n && i && s.rbGroups.length)
      for (const r of s.rbGroups)
        for (const l of r)
          l !== t && ((o = S(this, Nl).get(l)) == null || o._setVisible(RV, !1, !0));
    s._setVisible(RV, !!i, !0), be(this, Cx, null);
  }
  setOCGState({
    state: t,
    preserveRB: i
  }) {
    let n;
    for (const s of t) {
      switch (s) {
        case "ON":
        case "OFF":
        case "Toggle":
          n = s;
          continue;
      }
      const o = S(this, Nl).get(s);
      if (o)
        switch (n) {
          case "ON":
            this.setVisibility(s, !0, i);
            break;
          case "OFF":
            this.setVisibility(s, !1, i);
            break;
          case "Toggle":
            this.setVisibility(s, !o.visible, i);
            break;
        }
    }
    be(this, Cx, null);
  }
  get hasInitialVisibility() {
    return S(this, oj) === null || this.getHash() === S(this, oj);
  }
  getOrder() {
    return S(this, Nl).size ? S(this, rj) ? S(this, rj).slice() : [...S(this, Nl).keys()] : null;
  }
  getGroup(t) {
    return S(this, Nl).get(t) || null;
  }
  getHash() {
    if (S(this, Cx) !== null)
      return S(this, Cx);
    const t = new C5e();
    for (const [i, n] of S(this, Nl))
      t.update(`${i}:${n.visible}`);
    return be(this, Cx, t.hexdigest());
  }
  [Symbol.iterator]() {
    return S(this, Nl).entries();
  }
}
Cx = new WeakMap(), Nl = new WeakMap(), oj = new WeakMap(), rj = new WeakMap(), bee = new WeakSet(), xhe = function(t) {
  const i = t.length;
  if (i < 2)
    return !0;
  const n = t[0];
  for (let s = 1; s < i; s++) {
    const o = t[s];
    let r;
    if (Array.isArray(o))
      r = _e(this, bee, xhe).call(this, o);
    else if (S(this, Nl).has(o))
      r = S(this, Nl).get(o).visible;
    else
      return to(`Optional content group not found: ${o}`), !0;
    switch (n) {
      case "And":
        if (!r)
          return !1;
        break;
      case "Or":
        if (r)
          return !0;
        break;
      case "Not":
        return !r;
      default:
        return !0;
    }
  }
  return n === "And";
};
class lxe {
  constructor(t, {
    disableRange: i = !1,
    disableStream: n = !1
  }) {
    uh(t, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.');
    const {
      length: s,
      initialData: o,
      progressiveDone: r,
      contentDispositionFilename: l
    } = t;
    if (this._queuedChunks = [], this._progressiveDone = r, this._contentDispositionFilename = l, (o == null ? void 0 : o.length) > 0) {
      const c = o instanceof Uint8Array && o.byteLength === o.buffer.byteLength ? o.buffer : new Uint8Array(o).buffer;
      this._queuedChunks.push(c);
    }
    this._pdfDataRangeTransport = t, this._isStreamingSupported = !n, this._isRangeSupported = !i, this._contentLength = s, this._fullRequestReader = null, this._rangeReaders = [], t.addRangeListener((c, h) => {
      this._onReceiveData({
        begin: c,
        chunk: h
      });
    }), t.addProgressListener((c, h) => {
      this._onProgress({
        loaded: c,
        total: h
      });
    }), t.addProgressiveReadListener((c) => {
      this._onReceiveData({
        chunk: c
      });
    }), t.addProgressiveDoneListener(() => {
      this._onProgressiveDone();
    }), t.transportReady();
  }
  _onReceiveData({
    begin: t,
    chunk: i
  }) {
    const n = i instanceof Uint8Array && i.byteLength === i.buffer.byteLength ? i.buffer : new Uint8Array(i).buffer;
    if (t === void 0)
      this._fullRequestReader ? this._fullRequestReader._enqueue(n) : this._queuedChunks.push(n);
    else {
      const s = this._rangeReaders.some(function(o) {
        return o._begin !== t ? !1 : (o._enqueue(n), !0);
      });
      uh(s, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
    }
  }
  get _progressiveDataLength() {
    var t;
    return ((t = this._fullRequestReader) == null ? void 0 : t._loaded) ?? 0;
  }
  _onProgress(t) {
    var i, n, s, o;
    t.total === void 0 ? (n = (i = this._rangeReaders[0]) == null ? void 0 : i.onProgress) == null || n.call(i, {
      loaded: t.loaded
    }) : (o = (s = this._fullRequestReader) == null ? void 0 : s.onProgress) == null || o.call(s, {
      loaded: t.loaded,
      total: t.total
    });
  }
  _onProgressiveDone() {
    var t;
    (t = this._fullRequestReader) == null || t.progressiveDone(), this._progressiveDone = !0;
  }
  _removeRangeReader(t) {
    const i = this._rangeReaders.indexOf(t);
    i >= 0 && this._rangeReaders.splice(i, 1);
  }
  getFullReader() {
    uh(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
    const t = this._queuedChunks;
    return this._queuedChunks = null, new axe(this, t, this._progressiveDone, this._contentDispositionFilename);
  }
  getRangeReader(t, i) {
    if (i <= this._progressiveDataLength)
      return null;
    const n = new uxe(this, t, i);
    return this._pdfDataRangeTransport.requestDataRange(t, i), this._rangeReaders.push(n), n;
  }
  cancelAllRequests(t) {
    var i;
    (i = this._fullRequestReader) == null || i.cancel(t);
    for (const n of this._rangeReaders.slice(0))
      n.cancel(t);
    this._pdfDataRangeTransport.abort();
  }
}
class axe {
  constructor(t, i, n = !1, s = null) {
    this._stream = t, this._done = n || !1, this._filename = Npe(s) ? s : null, this._queuedChunks = i || [], this._loaded = 0;
    for (const o of this._queuedChunks)
      this._loaded += o.byteLength;
    this._requests = [], this._headersReady = Promise.resolve(), t._fullRequestReader = this, this.onProgress = null;
  }
  _enqueue(t) {
    this._done || (this._requests.length > 0 ? this._requests.shift().resolve({
      value: t,
      done: !1
    }) : this._queuedChunks.push(t), this._loaded += t.byteLength);
  }
  get headersReady() {
    return this._headersReady;
  }
  get filename() {
    return this._filename;
  }
  get isRangeSupported() {
    return this._stream._isRangeSupported;
  }
  get isStreamingSupported() {
    return this._stream._isStreamingSupported;
  }
  get contentLength() {
    return this._stream._contentLength;
  }
  async read() {
    if (this._queuedChunks.length > 0)
      return {
        value: this._queuedChunks.shift(),
        done: !1
      };
    if (this._done)
      return {
        value: void 0,
        done: !0
      };
    const t = Promise.withResolvers();
    return this._requests.push(t), t.promise;
  }
  cancel(t) {
    this._done = !0;
    for (const i of this._requests)
      i.resolve({
        value: void 0,
        done: !0
      });
    this._requests.length = 0;
  }
  progressiveDone() {
    this._done || (this._done = !0);
  }
}
class uxe {
  constructor(t, i, n) {
    this._stream = t, this._begin = i, this._end = n, this._queuedChunk = null, this._requests = [], this._done = !1, this.onProgress = null;
  }
  _enqueue(t) {
    if (!this._done) {
      if (this._requests.length === 0)
        this._queuedChunk = t;
      else {
        this._requests.shift().resolve({
          value: t,
          done: !1
        });
        for (const n of this._requests)
          n.resolve({
            value: void 0,
            done: !0
          });
        this._requests.length = 0;
      }
      this._done = !0, this._stream._removeRangeReader(this);
    }
  }
  get isStreamingSupported() {
    return !1;
  }
  async read() {
    if (this._queuedChunk) {
      const i = this._queuedChunk;
      return this._queuedChunk = null, {
        value: i,
        done: !1
      };
    }
    if (this._done)
      return {
        value: void 0,
        done: !0
      };
    const t = Promise.withResolvers();
    return this._requests.push(t), t.promise;
  }
  cancel(t) {
    this._done = !0;
    for (const i of this._requests)
      i.resolve({
        value: void 0,
        done: !0
      });
    this._requests.length = 0, this._stream._removeRangeReader(this);
  }
}
function dxe(e) {
  let t = !0, i = n("filename\\*", "i").exec(e);
  if (i) {
    i = i[1];
    let I = l(i);
    return I = unescape(I), I = c(I), I = h(I), o(I);
  }
  if (i = r(e), i) {
    const I = h(i);
    return o(I);
  }
  if (i = n("filename", "i").exec(e), i) {
    i = i[1];
    let I = l(i);
    return I = h(I), o(I);
  }
  function n(I, p) {
    return new RegExp("(?:^|;)\\s*" + I + '\\s*=\\s*([^";\\s][^;\\s]*|"(?:[^"\\\\]|\\\\"?)+"?)', p);
  }
  function s(I, p) {
    if (I) {
      if (!/^[\x00-\xFF]+$/.test(p))
        return p;
      try {
        const y = new TextDecoder(I, {
          fatal: !0
        }), m = cie(p);
        p = y.decode(m), t = !1;
      } catch {
      }
    }
    return p;
  }
  function o(I) {
    return t && /[\x80-\xff]/.test(I) && (I = s("utf-8", I), t && (I = s("iso-8859-1", I))), I;
  }
  function r(I) {
    const p = [];
    let y;
    const m = n("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
    for (; (y = m.exec(I)) !== null; ) {
      let [, C, O, R] = y;
      if (C = parseInt(C, 10), C in p) {
        if (C === 0)
          break;
        continue;
      }
      p[C] = [O, R];
    }
    const A = [];
    for (let C = 0; C < p.length && C in p; ++C) {
      let [O, R] = p[C];
      R = l(R), O && (R = unescape(R), C === 0 && (R = c(R))), A.push(R);
    }
    return A.join("");
  }
  function l(I) {
    if (I.startsWith('"')) {
      const p = I.slice(1).split('\\"');
      for (let y = 0; y < p.length; ++y) {
        const m = p[y].indexOf('"');
        m !== -1 && (p[y] = p[y].slice(0, m), p.length = y + 1), p[y] = p[y].replaceAll(/\\(.)/g, "$1");
      }
      I = p.join('"');
    }
    return I;
  }
  function c(I) {
    const p = I.indexOf("'");
    if (p === -1)
      return I;
    const y = I.slice(0, p), A = I.slice(p + 1).replace(/^[^']*'/, "");
    return s(y, A);
  }
  function h(I) {
    return !I.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(I) ? I : I.replaceAll(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(p, y, m, A) {
      if (m === "q" || m === "Q")
        return A = A.replaceAll("_", " "), A = A.replaceAll(/=([0-9a-fA-F]{2})/g, function(C, O) {
          return String.fromCharCode(parseInt(O, 16));
        }), s(y, A);
      try {
        A = atob(A);
      } catch {
      }
      return s(y, A);
    });
  }
  return "";
}
function k5e(e, t) {
  const i = new Headers();
  if (!e || !t || typeof t != "object")
    return i;
  for (const n in t) {
    const s = t[n];
    s !== void 0 && i.append(n, s);
  }
  return i;
}
function gae(e) {
  var t;
  return ((t = URL.parse(e)) == null ? void 0 : t.origin) ?? null;
}
function V5e({
  responseHeaders: e,
  isHttp: t,
  rangeChunkSize: i,
  disableRange: n
}) {
  const s = {
    allowRangeRequests: !1,
    suggestedLength: void 0
  }, o = parseInt(e.get("Content-Length"), 10);
  return !Number.isInteger(o) || (s.suggestedLength = o, o <= 2 * i) || n || !t || e.get("Accept-Ranges") !== "bytes" || (e.get("Content-Encoding") || "identity") !== "identity" || (s.allowRangeRequests = !0), s;
}
function z5e(e) {
  const t = e.get("Content-Disposition");
  if (t) {
    let i = dxe(t);
    if (i.includes("%"))
      try {
        i = decodeURIComponent(i);
      } catch {
      }
    if (Npe(i))
      return i;
  }
  return null;
}
function pie(e, t) {
  return new sle(`Unexpected server response (${e}) while retrieving PDF "${t}".`, e, e === 404 || e === 0 && t.startsWith("file:"));
}
function j5e(e) {
  return e === 200 || e === 206;
}
function W5e(e, t, i) {
  return {
    method: "GET",
    headers: e,
    signal: i.signal,
    mode: "cors",
    credentials: t ? "include" : "same-origin",
    redirect: "follow"
  };
}
function Y5e(e) {
  return e instanceof Uint8Array ? e.buffer : e instanceof ArrayBuffer ? e : (to(`getArrayBuffer - unexpected data format: ${e}`), new Uint8Array(e).buffer);
}
class cxe {
  constructor(t) {
    Zi(this, "_responseOrigin", null);
    this.source = t, this.isHttp = /^https?:/i.test(t.url), this.headers = k5e(this.isHttp, t.httpHeaders), this._fullRequestReader = null, this._rangeRequestReaders = [];
  }
  get _progressiveDataLength() {
    var t;
    return ((t = this._fullRequestReader) == null ? void 0 : t._loaded) ?? 0;
  }
  getFullReader() {
    return uh(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once."), this._fullRequestReader = new hxe(this), this._fullRequestReader;
  }
  getRangeReader(t, i) {
    if (i <= this._progressiveDataLength)
      return null;
    const n = new fxe(this, t, i);
    return this._rangeRequestReaders.push(n), n;
  }
  cancelAllRequests(t) {
    var i;
    (i = this._fullRequestReader) == null || i.cancel(t);
    for (const n of this._rangeRequestReaders.slice(0))
      n.cancel(t);
  }
}
class hxe {
  constructor(t) {
    this._stream = t, this._reader = null, this._loaded = 0, this._filename = null;
    const i = t.source;
    this._withCredentials = i.withCredentials || !1, this._contentLength = i.length, this._headersCapability = Promise.withResolvers(), this._disableRange = i.disableRange || !1, this._rangeChunkSize = i.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._abortController = new AbortController(), this._isStreamingSupported = !i.disableStream, this._isRangeSupported = !i.disableRange;
    const n = new Headers(t.headers), s = i.url;
    fetch(s, W5e(n, this._withCredentials, this._abortController)).then((o) => {
      if (t._responseOrigin = gae(o.url), !j5e(o.status))
        throw pie(o.status, s);
      this._reader = o.body.getReader(), this._headersCapability.resolve();
      const r = o.headers, {
        allowRangeRequests: l,
        suggestedLength: c
      } = V5e({
        responseHeaders: r,
        isHttp: t.isHttp,
        rangeChunkSize: this._rangeChunkSize,
        disableRange: this._disableRange
      });
      this._isRangeSupported = l, this._contentLength = c || this._contentLength, this._filename = z5e(r), !this._isStreamingSupported && this._isRangeSupported && this.cancel(new WP("Streaming is disabled."));
    }).catch(this._headersCapability.reject), this.onProgress = null;
  }
  get headersReady() {
    return this._headersCapability.promise;
  }
  get filename() {
    return this._filename;
  }
  get contentLength() {
    return this._contentLength;
  }
  get isRangeSupported() {
    return this._isRangeSupported;
  }
  get isStreamingSupported() {
    return this._isStreamingSupported;
  }
  async read() {
    var n;
    await this._headersCapability.promise;
    const {
      value: t,
      done: i
    } = await this._reader.read();
    return i ? {
      value: t,
      done: i
    } : (this._loaded += t.byteLength, (n = this.onProgress) == null || n.call(this, {
      loaded: this._loaded,
      total: this._contentLength
    }), {
      value: Y5e(t),
      done: !1
    });
  }
  cancel(t) {
    var i;
    (i = this._reader) == null || i.cancel(t), this._abortController.abort();
  }
}
class fxe {
  constructor(t, i, n) {
    this._stream = t, this._reader = null, this._loaded = 0;
    const s = t.source;
    this._withCredentials = s.withCredentials || !1, this._readCapability = Promise.withResolvers(), this._isStreamingSupported = !s.disableStream, this._abortController = new AbortController();
    const o = new Headers(t.headers);
    o.append("Range", `bytes=${i}-${n - 1}`);
    const r = s.url;
    fetch(r, W5e(o, this._withCredentials, this._abortController)).then((l) => {
      const c = gae(l.url);
      if (c !== t._responseOrigin)
        throw new Error(`Expected range response-origin "${c}" to match "${t._responseOrigin}".`);
      if (!j5e(l.status))
        throw pie(l.status, r);
      this._readCapability.resolve(), this._reader = l.body.getReader();
    }).catch(this._readCapability.reject), this.onProgress = null;
  }
  get isStreamingSupported() {
    return this._isStreamingSupported;
  }
  async read() {
    var n;
    await this._readCapability.promise;
    const {
      value: t,
      done: i
    } = await this._reader.read();
    return i ? {
      value: t,
      done: i
    } : (this._loaded += t.byteLength, (n = this.onProgress) == null || n.call(this, {
      loaded: this._loaded
    }), {
      value: Y5e(t),
      done: !1
    });
  }
  cancel(t) {
    var i;
    (i = this._reader) == null || i.cancel(t), this._abortController.abort();
  }
}
const ade = 200, ude = 206;
function Ixe(e) {
  const t = e.response;
  return typeof t != "string" ? t : cie(t).buffer;
}
class pxe {
  constructor({
    url: t,
    httpHeaders: i,
    withCredentials: n
  }) {
    Zi(this, "_responseOrigin", null);
    this.url = t, this.isHttp = /^https?:/i.test(t), this.headers = k5e(this.isHttp, i), this.withCredentials = n || !1, this.currXhrId = 0, this.pendingRequests = /* @__PURE__ */ Object.create(null);
  }
  request(t) {
    const i = new XMLHttpRequest(), n = this.currXhrId++, s = this.pendingRequests[n] = {
      xhr: i
    };
    i.open("GET", this.url), i.withCredentials = this.withCredentials;
    for (const [o, r] of this.headers)
      i.setRequestHeader(o, r);
    return this.isHttp && "begin" in t && "end" in t ? (i.setRequestHeader("Range", `bytes=${t.begin}-${t.end - 1}`), s.expectedStatus = ude) : s.expectedStatus = ade, i.responseType = "arraybuffer", uh(t.onError, "Expected `onError` callback to be provided."), i.onerror = () => {
      t.onError(i.status);
    }, i.onreadystatechange = this.onStateChange.bind(this, n), i.onprogress = this.onProgress.bind(this, n), s.onHeadersReceived = t.onHeadersReceived, s.onDone = t.onDone, s.onError = t.onError, s.onProgress = t.onProgress, i.send(null), n;
  }
  onProgress(t, i) {
    var s;
    const n = this.pendingRequests[t];
    n && ((s = n.onProgress) == null || s.call(n, i));
  }
  onStateChange(t, i) {
    const n = this.pendingRequests[t];
    if (!n)
      return;
    const s = n.xhr;
    if (s.readyState >= 2 && n.onHeadersReceived && (n.onHeadersReceived(), delete n.onHeadersReceived), s.readyState !== 4 || !(t in this.pendingRequests))
      return;
    if (delete this.pendingRequests[t], s.status === 0 && this.isHttp) {
      n.onError(s.status);
      return;
    }
    const o = s.status || ade;
    if (!(o === ade && n.expectedStatus === ude) && o !== n.expectedStatus) {
      n.onError(s.status);
      return;
    }
    const l = Ixe(s);
    if (o === ude) {
      const c = s.getResponseHeader("Content-Range"), h = /bytes (\d+)-(\d+)\/(\d+)/.exec(c);
      h ? n.onDone({
        begin: parseInt(h[1], 10),
        chunk: l
      }) : (to('Missing or invalid "Content-Range" header.'), n.onError(0));
    } else l ? n.onDone({
      begin: 0,
      chunk: l
    }) : n.onError(s.status);
  }
  getRequestXhr(t) {
    return this.pendingRequests[t].xhr;
  }
  isPendingRequest(t) {
    return t in this.pendingRequests;
  }
  abortRequest(t) {
    const i = this.pendingRequests[t].xhr;
    delete this.pendingRequests[t], i.abort();
  }
}
class mxe {
  constructor(t) {
    this._source = t, this._manager = new pxe(t), this._rangeChunkSize = t.rangeChunkSize, this._fullRequestReader = null, this._rangeRequestReaders = [];
  }
  _onRangeRequestReaderClosed(t) {
    const i = this._rangeRequestReaders.indexOf(t);
    i >= 0 && this._rangeRequestReaders.splice(i, 1);
  }
  getFullReader() {
    return uh(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once."), this._fullRequestReader = new yxe(this._manager, this._source), this._fullRequestReader;
  }
  getRangeReader(t, i) {
    const n = new Exe(this._manager, t, i);
    return n.onClosed = this._onRangeRequestReaderClosed.bind(this), this._rangeRequestReaders.push(n), n;
  }
  cancelAllRequests(t) {
    var i;
    (i = this._fullRequestReader) == null || i.cancel(t);
    for (const n of this._rangeRequestReaders.slice(0))
      n.cancel(t);
  }
}
class yxe {
  constructor(t, i) {
    this._manager = t, this._url = i.url, this._fullRequestId = t.request({
      onHeadersReceived: this._onHeadersReceived.bind(this),
      onDone: this._onDone.bind(this),
      onError: this._onError.bind(this),
      onProgress: this._onProgress.bind(this)
    }), this._headersCapability = Promise.withResolvers(), this._disableRange = i.disableRange || !1, this._contentLength = i.length, this._rangeChunkSize = i.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._isStreamingSupported = !1, this._isRangeSupported = !1, this._cachedChunks = [], this._requests = [], this._done = !1, this._storedError = void 0, this._filename = null, this.onProgress = null;
  }
  _onHeadersReceived() {
    const t = this._fullRequestId, i = this._manager.getRequestXhr(t);
    this._manager._responseOrigin = gae(i.responseURL);
    const n = i.getAllResponseHeaders(), s = new Headers(n ? n.trimStart().replace(/[^\S ]+$/, "").split(/[\r\n]+/).map((l) => {
      const [c, ...h] = l.split(": ");
      return [c, h.join(": ")];
    }) : []), {
      allowRangeRequests: o,
      suggestedLength: r
    } = V5e({
      responseHeaders: s,
      isHttp: this._manager.isHttp,
      rangeChunkSize: this._rangeChunkSize,
      disableRange: this._disableRange
    });
    o && (this._isRangeSupported = !0), this._contentLength = r || this._contentLength, this._filename = z5e(s), this._isRangeSupported && this._manager.abortRequest(t), this._headersCapability.resolve();
  }
  _onDone(t) {
    if (t && (this._requests.length > 0 ? this._requests.shift().resolve({
      value: t.chunk,
      done: !1
    }) : this._cachedChunks.push(t.chunk)), this._done = !0, !(this._cachedChunks.length > 0)) {
      for (const i of this._requests)
        i.resolve({
          value: void 0,
          done: !0
        });
      this._requests.length = 0;
    }
  }
  _onError(t) {
    this._storedError = pie(t, this._url), this._headersCapability.reject(this._storedError);
    for (const i of this._requests)
      i.reject(this._storedError);
    this._requests.length = 0, this._cachedChunks.length = 0;
  }
  _onProgress(t) {
    var i;
    (i = this.onProgress) == null || i.call(this, {
      loaded: t.loaded,
      total: t.lengthComputable ? t.total : this._contentLength
    });
  }
  get filename() {
    return this._filename;
  }
  get isRangeSupported() {
    return this._isRangeSupported;
  }
  get isStreamingSupported() {
    return this._isStreamingSupported;
  }
  get contentLength() {
    return this._contentLength;
  }
  get headersReady() {
    return this._headersCapability.promise;
  }
  async read() {
    if (await this._headersCapability.promise, this._storedError)
      throw this._storedError;
    if (this._cachedChunks.length > 0)
      return {
        value: this._cachedChunks.shift(),
        done: !1
      };
    if (this._done)
      return {
        value: void 0,
        done: !0
      };
    const t = Promise.withResolvers();
    return this._requests.push(t), t.promise;
  }
  cancel(t) {
    this._done = !0, this._headersCapability.reject(t);
    for (const i of this._requests)
      i.resolve({
        value: void 0,
        done: !0
      });
    this._requests.length = 0, this._manager.isPendingRequest(this._fullRequestId) && this._manager.abortRequest(this._fullRequestId), this._fullRequestReader = null;
  }
}
class Exe {
  constructor(t, i, n) {
    this._manager = t, this._url = t.url, this._requestId = t.request({
      begin: i,
      end: n,
      onHeadersReceived: this._onHeadersReceived.bind(this),
      onDone: this._onDone.bind(this),
      onError: this._onError.bind(this),
      onProgress: this._onProgress.bind(this)
    }), this._requests = [], this._queuedChunk = null, this._done = !1, this._storedError = void 0, this.onProgress = null, this.onClosed = null;
  }
  _onHeadersReceived() {
    var i;
    const t = gae((i = this._manager.getRequestXhr(this._requestId)) == null ? void 0 : i.responseURL);
    t !== this._manager._responseOrigin && (this._storedError = new Error(`Expected range response-origin "${t}" to match "${this._manager._responseOrigin}".`), this._onError(0));
  }
  _close() {
    var t;
    (t = this.onClosed) == null || t.call(this, this);
  }
  _onDone(t) {
    const i = t.chunk;
    this._requests.length > 0 ? this._requests.shift().resolve({
      value: i,
      done: !1
    }) : this._queuedChunk = i, this._done = !0;
    for (const n of this._requests)
      n.resolve({
        value: void 0,
        done: !0
      });
    this._requests.length = 0, this._close();
  }
  _onError(t) {
    this._storedError ?? (this._storedError = pie(t, this._url));
    for (const i of this._requests)
      i.reject(this._storedError);
    this._requests.length = 0, this._queuedChunk = null;
  }
  _onProgress(t) {
    var i;
    this.isStreamingSupported || (i = this.onProgress) == null || i.call(this, {
      loaded: t.loaded
    });
  }
  get isStreamingSupported() {
    return !1;
  }
  async read() {
    if (this._storedError)
      throw this._storedError;
    if (this._queuedChunk !== null) {
      const i = this._queuedChunk;
      return this._queuedChunk = null, {
        value: i,
        done: !1
      };
    }
    if (this._done)
      return {
        value: void 0,
        done: !0
      };
    const t = Promise.withResolvers();
    return this._requests.push(t), t.promise;
  }
  cancel(t) {
    this._done = !0;
    for (const i of this._requests)
      i.resolve({
        value: void 0,
        done: !0
      });
    this._requests.length = 0, this._manager.isPendingRequest(this._requestId) && this._manager.abortRequest(this._requestId), this._close();
  }
}
const gxe = /^[a-z][a-z0-9\-+.]+:/i;
function wxe(e) {
  if (gxe.test(e))
    return new URL(e);
  const t = process.getBuiltinModule("url");
  return new URL(t.pathToFileURL(e));
}
class Txe {
  constructor(t) {
    this.source = t, this.url = wxe(t.url), uh(this.url.protocol === "file:", "PDFNodeStream only supports file:// URLs."), this._fullRequestReader = null, this._rangeRequestReaders = [];
  }
  get _progressiveDataLength() {
    var t;
    return ((t = this._fullRequestReader) == null ? void 0 : t._loaded) ?? 0;
  }
  getFullReader() {
    return uh(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once."), this._fullRequestReader = new Rxe(this), this._fullRequestReader;
  }
  getRangeReader(t, i) {
    if (i <= this._progressiveDataLength)
      return null;
    const n = new vxe(this, t, i);
    return this._rangeRequestReaders.push(n), n;
  }
  cancelAllRequests(t) {
    var i;
    (i = this._fullRequestReader) == null || i.cancel(t);
    for (const n of this._rangeRequestReaders.slice(0))
      n.cancel(t);
  }
}
class Rxe {
  constructor(t) {
    this._url = t.url, this._done = !1, this._storedError = null, this.onProgress = null;
    const i = t.source;
    this._contentLength = i.length, this._loaded = 0, this._filename = null, this._disableRange = i.disableRange || !1, this._rangeChunkSize = i.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._isStreamingSupported = !i.disableStream, this._isRangeSupported = !i.disableRange, this._readableStream = null, this._readCapability = Promise.withResolvers(), this._headersCapability = Promise.withResolvers();
    const n = process.getBuiltinModule("fs");
    n.promises.lstat(this._url).then((s) => {
      this._contentLength = s.size, this._setReadableStream(n.createReadStream(this._url)), this._headersCapability.resolve();
    }, (s) => {
      s.code === "ENOENT" && (s = pie(0, this._url.href)), this._storedError = s, this._headersCapability.reject(s);
    });
  }
  get headersReady() {
    return this._headersCapability.promise;
  }
  get filename() {
    return this._filename;
  }
  get contentLength() {
    return this._contentLength;
  }
  get isRangeSupported() {
    return this._isRangeSupported;
  }
  get isStreamingSupported() {
    return this._isStreamingSupported;
  }
  async read() {
    var n;
    if (await this._readCapability.promise, this._done)
      return {
        value: void 0,
        done: !0
      };
    if (this._storedError)
      throw this._storedError;
    const t = this._readableStream.read();
    return t === null ? (this._readCapability = Promise.withResolvers(), this.read()) : (this._loaded += t.length, (n = this.onProgress) == null || n.call(this, {
      loaded: this._loaded,
      total: this._contentLength
    }), {
      value: new Uint8Array(t).buffer,
      done: !1
    });
  }
  cancel(t) {
    if (!this._readableStream) {
      this._error(t);
      return;
    }
    this._readableStream.destroy(t);
  }
  _error(t) {
    this._storedError = t, this._readCapability.resolve();
  }
  _setReadableStream(t) {
    this._readableStream = t, t.on("readable", () => {
      this._readCapability.resolve();
    }), t.on("end", () => {
      t.destroy(), this._done = !0, this._readCapability.resolve();
    }), t.on("error", (i) => {
      this._error(i);
    }), !this._isStreamingSupported && this._isRangeSupported && this._error(new WP("streaming is disabled")), this._storedError && this._readableStream.destroy(this._storedError);
  }
}
class vxe {
  constructor(t, i, n) {
    this._url = t.url, this._done = !1, this._storedError = null, this.onProgress = null, this._loaded = 0, this._readableStream = null, this._readCapability = Promise.withResolvers();
    const s = t.source;
    this._isStreamingSupported = !s.disableStream;
    const o = process.getBuiltinModule("fs");
    this._setReadableStream(o.createReadStream(this._url, {
      start: i,
      end: n - 1
    }));
  }
  get isStreamingSupported() {
    return this._isStreamingSupported;
  }
  async read() {
    var n;
    if (await this._readCapability.promise, this._done)
      return {
        value: void 0,
        done: !0
      };
    if (this._storedError)
      throw this._storedError;
    const t = this._readableStream.read();
    return t === null ? (this._readCapability = Promise.withResolvers(), this.read()) : (this._loaded += t.length, (n = this.onProgress) == null || n.call(this, {
      loaded: this._loaded
    }), {
      value: new Uint8Array(t).buffer,
      done: !1
    });
  }
  cancel(t) {
    if (!this._readableStream) {
      this._error(t);
      return;
    }
    this._readableStream.destroy(t);
  }
  _error(t) {
    this._storedError = t, this._readCapability.resolve();
  }
  _setReadableStream(t) {
    this._readableStream = t, t.on("readable", () => {
      this._readCapability.resolve();
    }), t.on("end", () => {
      t.destroy(), this._done = !0, this._readCapability.resolve();
    }), t.on("error", (i) => {
      this._error(i);
    }), this._storedError && this._readableStream.destroy(this._storedError);
  }
}
const mZ = Symbol("INITIAL_DATA");
var r2, Nee, Phe;
class q5e {
  constructor() {
    xe(this, Nee);
    xe(this, r2, /* @__PURE__ */ Object.create(null));
  }
  get(t, i = null) {
    if (i) {
      const s = _e(this, Nee, Phe).call(this, t);
      return s.promise.then(() => i(s.data)), null;
    }
    const n = S(this, r2)[t];
    if (!n || n.data === mZ)
      throw new Error(`Requesting object that isn't resolved yet ${t}.`);
    return n.data;
  }
  has(t) {
    const i = S(this, r2)[t];
    return !!i && i.data !== mZ;
  }
  delete(t) {
    const i = S(this, r2)[t];
    return !i || i.data === mZ ? !1 : (delete S(this, r2)[t], !0);
  }
  resolve(t, i = null) {
    const n = _e(this, Nee, Phe).call(this, t);
    n.data = i, n.resolve();
  }
  clear() {
    var t;
    for (const i in S(this, r2)) {
      const {
        data: n
      } = S(this, r2)[i];
      (t = n == null ? void 0 : n.bitmap) == null || t.close();
    }
    be(this, r2, /* @__PURE__ */ Object.create(null));
  }
  *[Symbol.iterator]() {
    for (const t in S(this, r2)) {
      const {
        data: i
      } = S(this, r2)[t];
      i !== mZ && (yield [t, i]);
    }
  }
}
r2 = new WeakMap(), Nee = new WeakSet(), Phe = function(t) {
  var i;
  return (i = S(this, r2))[t] || (i[t] = {
    ...Promise.withResolvers(),
    data: mZ
  });
};
const Axe = 1e5, Jye = 30;
var $4e, Ox, cg, Dee, Cee, UB, zC, Oee, Lee, BB, lj, aj, Lx, uj, _ee, dj, FB, xee, Pee, Xd, cj, HB, Mee, _x, hj, gL, $5e, K5e, Mhe, v4, noe, Uhe, Z5e, Q5e;
let rle = (Xd = class {
  constructor({
    textContentSource: t,
    container: i,
    viewport: n
  }) {
    xe(this, gL);
    xe(this, Ox, Promise.withResolvers());
    xe(this, cg, null);
    xe(this, Dee, !1);
    xe(this, Cee, !!(($4e = globalThis.FontInspector) != null && $4e.enabled));
    xe(this, UB, null);
    xe(this, zC, null);
    xe(this, Oee, 0);
    xe(this, Lee, 0);
    xe(this, BB, null);
    xe(this, lj, null);
    xe(this, aj, 0);
    xe(this, Lx, 0);
    xe(this, uj, /* @__PURE__ */ Object.create(null));
    xe(this, _ee, []);
    xe(this, dj, null);
    xe(this, FB, []);
    xe(this, xee, /* @__PURE__ */ new WeakMap());
    xe(this, Pee, null);
    var c;
    if (t instanceof ReadableStream)
      be(this, dj, t);
    else if (typeof t == "object")
      be(this, dj, new ReadableStream({
        start(h) {
          h.enqueue(t), h.close();
        }
      }));
    else
      throw new Error('No "textContentSource" parameter specified.');
    be(this, cg, be(this, lj, i)), be(this, Lx, n.scale * ZF.pixelRatio), be(this, aj, n.rotation), be(this, zC, {
      div: null,
      properties: null,
      ctx: null
    });
    const {
      pageWidth: s,
      pageHeight: o,
      pageX: r,
      pageY: l
    } = n.rawDims;
    be(this, Pee, [1, 0, 0, -1, -r, l + o]), be(this, Lee, s), be(this, Oee, o), _e(c = Xd, v4, Z5e).call(c), KF(i, n), S(this, Ox).promise.finally(() => {
      S(Xd, hj).delete(this), be(this, zC, null), be(this, uj, null);
    }).catch(() => {
    });
  }
  static get fontFamilyMap() {
    const {
      isWindows: t,
      isFirefox: i
    } = Qp.platform;
    return Zo(this, "fontFamilyMap", /* @__PURE__ */ new Map([["sans-serif", `${t && i ? "Calibri, " : ""}sans-serif`], ["monospace", `${t && i ? "Lucida Console, " : ""}monospace`]]));
  }
  render() {
    const t = () => {
      S(this, BB).read().then(({
        value: i,
        done: n
      }) => {
        if (n) {
          S(this, Ox).resolve();
          return;
        }
        S(this, UB) ?? be(this, UB, i.lang), Object.assign(S(this, uj), i.styles), _e(this, gL, $5e).call(this, i.items), t();
      }, S(this, Ox).reject);
    };
    return be(this, BB, S(this, dj).getReader()), S(Xd, hj).add(this), t(), S(this, Ox).promise;
  }
  update({
    viewport: t,
    onBefore: i = null
  }) {
    var o;
    const n = t.scale * ZF.pixelRatio, s = t.rotation;
    if (s !== S(this, aj) && (i == null || i(), be(this, aj, s), KF(S(this, lj), {
      rotation: s
    })), n !== S(this, Lx)) {
      i == null || i(), be(this, Lx, n);
      const r = {
        div: null,
        properties: null,
        ctx: _e(o = Xd, v4, noe).call(o, S(this, UB))
      };
      for (const l of S(this, FB))
        r.properties = S(this, xee).get(l), r.div = l, _e(this, gL, Mhe).call(this, r);
    }
  }
  cancel() {
    var i;
    const t = new WP("TextLayer task cancelled.");
    (i = S(this, BB)) == null || i.cancel(t).catch(() => {
    }), be(this, BB, null), S(this, Ox).reject(t);
  }
  get textDivs() {
    return S(this, FB);
  }
  get textContentItemsStr() {
    return S(this, _ee);
  }
  static cleanup() {
    if (!(S(this, hj).size > 0)) {
      S(this, cj).clear();
      for (const {
        canvas: t
      } of S(this, HB).values())
        t.remove();
      S(this, HB).clear();
    }
  }
}, Ox = new WeakMap(), cg = new WeakMap(), Dee = new WeakMap(), Cee = new WeakMap(), UB = new WeakMap(), zC = new WeakMap(), Oee = new WeakMap(), Lee = new WeakMap(), BB = new WeakMap(), lj = new WeakMap(), aj = new WeakMap(), Lx = new WeakMap(), uj = new WeakMap(), _ee = new WeakMap(), dj = new WeakMap(), FB = new WeakMap(), xee = new WeakMap(), Pee = new WeakMap(), cj = new WeakMap(), HB = new WeakMap(), Mee = new WeakMap(), _x = new WeakMap(), hj = new WeakMap(), gL = new WeakSet(), $5e = function(t) {
  var s, o;
  if (S(this, Dee))
    return;
  (o = S(this, zC)).ctx ?? (o.ctx = _e(s = Xd, v4, noe).call(s, S(this, UB)));
  const i = S(this, FB), n = S(this, _ee);
  for (const r of t) {
    if (i.length > Axe) {
      to("Ignoring additional textDivs for performance reasons."), be(this, Dee, !0);
      return;
    }
    if (r.str === void 0) {
      if (r.type === "beginMarkedContentProps" || r.type === "beginMarkedContent") {
        const l = S(this, cg);
        be(this, cg, document.createElement("span")), S(this, cg).classList.add("markedContent"), r.id && S(this, cg).setAttribute("id", `${r.id}`), l.append(S(this, cg));
      } else r.type === "endMarkedContent" && be(this, cg, S(this, cg).parentNode);
      continue;
    }
    n.push(r.str), _e(this, gL, K5e).call(this, r);
  }
}, K5e = function(t) {
  var C;
  const i = document.createElement("span"), n = {
    angle: 0,
    canvasWidth: 0,
    hasText: t.str !== "",
    hasEOL: t.hasEOL,
    fontSize: 0
  };
  S(this, FB).push(i);
  const s = ys.transform(S(this, Pee), t.transform);
  let o = Math.atan2(s[1], s[0]);
  const r = S(this, uj)[t.fontName];
  r.vertical && (o += Math.PI / 2);
  let l = S(this, Cee) && r.fontSubstitution || r.fontFamily;
  l = Xd.fontFamilyMap.get(l) || l;
  const c = Math.hypot(s[2], s[3]), h = c * _e(C = Xd, v4, Q5e).call(C, l, r, S(this, UB));
  let I, p;
  o === 0 ? (I = s[4], p = s[5] - h) : (I = s[4] + h * Math.sin(o), p = s[5] - h * Math.cos(o));
  const y = "calc(var(--total-scale-factor) *", m = i.style;
  S(this, cg) === S(this, lj) ? (m.left = `${(100 * I / S(this, Lee)).toFixed(2)}%`, m.top = `${(100 * p / S(this, Oee)).toFixed(2)}%`) : (m.left = `${y}${I.toFixed(2)}px)`, m.top = `${y}${p.toFixed(2)}px)`), m.fontSize = `${y}${(S(Xd, _x) * c).toFixed(2)}px)`, m.fontFamily = l, n.fontSize = c, i.setAttribute("role", "presentation"), i.textContent = t.str, i.dir = t.dir, S(this, Cee) && (i.dataset.fontName = r.fontSubstitutionLoadedName || t.fontName), o !== 0 && (n.angle = o * (180 / Math.PI));
  let A = !1;
  if (t.str.length > 1)
    A = !0;
  else if (t.str !== " " && t.transform[0] !== t.transform[3]) {
    const O = Math.abs(t.transform[0]), R = Math.abs(t.transform[3]);
    O !== R && Math.max(O, R) / Math.min(O, R) > 1.5 && (A = !0);
  }
  if (A && (n.canvasWidth = r.vertical ? t.height : t.width), S(this, xee).set(i, n), S(this, zC).div = i, S(this, zC).properties = n, _e(this, gL, Mhe).call(this, S(this, zC)), n.hasText && S(this, cg).append(i), n.hasEOL) {
    const O = document.createElement("br");
    O.setAttribute("role", "presentation"), S(this, cg).append(O);
  }
}, Mhe = function(t) {
  var l;
  const {
    div: i,
    properties: n,
    ctx: s
  } = t, {
    style: o
  } = i;
  let r = "";
  if (S(Xd, _x) > 1 && (r = `scale(${1 / S(Xd, _x)})`), n.canvasWidth !== 0 && n.hasText) {
    const {
      fontFamily: c
    } = o, {
      canvasWidth: h,
      fontSize: I
    } = n;
    _e(l = Xd, v4, Uhe).call(l, s, I * S(this, Lx), c);
    const {
      width: p
    } = s.measureText(i.textContent);
    p > 0 && (r = `scaleX(${h * S(this, Lx) / p}) ${r}`);
  }
  n.angle !== 0 && (r = `rotate(${n.angle}deg) ${r}`), r.length > 0 && (o.transform = r);
}, v4 = new WeakSet(), noe = function(t = null) {
  let i = S(this, HB).get(t || (t = ""));
  if (!i) {
    const n = document.createElement("canvas");
    n.className = "hiddenCanvasElement", n.lang = t, document.body.append(n), i = n.getContext("2d", {
      alpha: !1,
      willReadFrequently: !0
    }), S(this, HB).set(t, i), S(this, Mee).set(i, {
      size: 0,
      family: ""
    });
  }
  return i;
}, Uhe = function(t, i, n) {
  const s = S(this, Mee).get(t);
  i === s.size && n === s.family || (t.font = `${i}px ${n}`, s.size = i, s.family = n);
}, Z5e = function() {
  if (S(this, _x) !== null)
    return;
  const t = document.createElement("div");
  t.style.opacity = 0, t.style.lineHeight = 1, t.style.fontSize = "1px", t.style.position = "absolute", t.textContent = "X", document.body.append(t), be(this, _x, t.getBoundingClientRect().height), t.remove();
}, Q5e = function(t, i, n) {
  const s = S(this, cj).get(t);
  if (s)
    return s;
  const o = _e(this, v4, noe).call(this, n);
  o.canvas.width = o.canvas.height = Jye, _e(this, v4, Uhe).call(this, o, Jye, t);
  const r = o.measureText(""), l = r.fontBoundingBoxAscent, c = Math.abs(r.fontBoundingBoxDescent);
  o.canvas.width = o.canvas.height = 0;
  let h = 0.8;
  return l ? h = l / (l + c) : (Qp.platform.isFirefox && to("Enable the `dom.textMetrics.fontBoundingBox.enabled` preference in `about:config` to improve TextLayer rendering."), i.ascent ? h = i.ascent : i.descent && (h = 1 + i.descent)), S(this, cj).set(t, h), h;
}, xe(Xd, v4), xe(Xd, cj, /* @__PURE__ */ new Map()), xe(Xd, HB, /* @__PURE__ */ new Map()), xe(Xd, Mee, /* @__PURE__ */ new WeakMap()), xe(Xd, _x, null), xe(Xd, hj, /* @__PURE__ */ new Set()), Xd);
class dX {
  static textContent(t) {
    const i = [], n = {
      items: i,
      styles: /* @__PURE__ */ Object.create(null)
    };
    function s(o) {
      var c;
      if (!o)
        return;
      let r = null;
      const l = o.name;
      if (l === "#text")
        r = o.value;
      else if (dX.shouldBuildText(l))
        (c = o == null ? void 0 : o.attributes) != null && c.textContent ? r = o.attributes.textContent : o.value && (r = o.value);
      else return;
      if (r !== null && i.push({
        str: r
      }), !!o.children)
        for (const h of o.children)
          s(h);
    }
    return s(t), n;
  }
  static shouldBuildText(t) {
    return !(t === "textarea" || t === "input" || t === "option" || t === "select");
  }
}
const Sxe = 100;
function J5e(e = {}) {
  typeof e == "string" || e instanceof URL ? e = {
    url: e
  } : (e instanceof ArrayBuffer || ArrayBuffer.isView(e)) && (e = {
    data: e
  });
  const t = new Bhe(), {
    docId: i
  } = t, n = e.url ? P_e(e.url) : null, s = e.data ? M_e(e.data) : null, o = e.httpHeaders || null, r = e.withCredentials === !0, l = e.password ?? null, c = e.range instanceof X5e ? e.range : null, h = Number.isInteger(e.rangeChunkSize) && e.rangeChunkSize > 0 ? e.rangeChunkSize : 2 ** 16;
  let I = e.worker instanceof Fhe ? e.worker : null;
  const p = e.verbosity, y = typeof e.docBaseUrl == "string" && !yae(e.docBaseUrl) ? e.docBaseUrl : null, m = hne(e.cMapUrl), A = e.cMapPacked !== !1, C = e.CMapReaderFactory || (By ? z_e : Gye), O = hne(e.iccUrl), R = hne(e.standardFontDataUrl), F = e.StandardFontDataFactory || (By ? j_e : kye), L = hne(e.wasmUrl), P = e.WasmFactory || (By ? W_e : Vye), z = e.stopAtErrors !== !0, W = Number.isInteger(e.maxImageSize) && e.maxImageSize > -1 ? e.maxImageSize : -1, re = e.isEvalSupported !== !1, ce = typeof e.isOffscreenCanvasSupported == "boolean" ? e.isOffscreenCanvasSupported : !By, te = typeof e.isImageDecoderSupported == "boolean" ? e.isImageDecoderSupported : !By && (Qp.platform.isFirefox || !globalThis.chrome), ee = Number.isInteger(e.canvasMaxAreaInBytes) ? e.canvasMaxAreaInBytes : -1, Ne = typeof e.disableFontFace == "boolean" ? e.disableFontFace : By, Ae = e.fontExtraProperties === !0, Oe = e.enableXfa === !0, pe = e.ownerDocument || globalThis.document, je = e.disableRange === !0, Ve = e.disableStream === !0, $e = e.disableAutoFetch === !0, vt = e.pdfBug === !0, Rt = e.CanvasFactory || (By ? V_e : H_e), ze = e.FilterFactory || (By ? k_e : G_e), mt = e.enableHWA === !0, Et = e.useWasm !== !1, it = c ? c.length : e.length ?? NaN, Dt = typeof e.useSystemFonts == "boolean" ? e.useSystemFonts : !By && !Ne, Ct = typeof e.useWorkerFetch == "boolean" ? e.useWorkerFetch : !!(C === Gye && F === kye && P === Vye && m && R && L && eQ(m, document.baseURI) && eQ(R, document.baseURI) && eQ(L, document.baseURI)), Kt = null;
  h_e(p);
  const Zt = {
    canvasFactory: new Rt({
      ownerDocument: pe,
      enableHWA: mt
    }),
    filterFactory: new ze({
      docId: i,
      ownerDocument: pe
    }),
    cMapReaderFactory: Ct ? null : new C({
      baseUrl: m,
      isCompressed: A
    }),
    standardFontDataFactory: Ct ? null : new F({
      baseUrl: R
    }),
    wasmFactory: Ct ? null : new P({
      baseUrl: L
    })
  };
  I || (I = Fhe.create({
    verbosity: p,
    port: lx.workerPort
  }), t._worker = I);
  const Xt = {
    docId: i,
    apiVersion: "5.4.54",
    data: s,
    password: l,
    disableAutoFetch: $e,
    rangeChunkSize: h,
    length: it,
    docBaseUrl: y,
    enableXfa: Oe,
    evaluatorOptions: {
      maxImageSize: W,
      disableFontFace: Ne,
      ignoreErrors: z,
      isEvalSupported: re,
      isOffscreenCanvasSupported: ce,
      isImageDecoderSupported: te,
      canvasMaxAreaInBytes: ee,
      fontExtraProperties: Ae,
      useSystemFonts: Dt,
      useWasm: Et,
      useWorkerFetch: Ct,
      cMapUrl: m,
      iccUrl: O,
      standardFontDataUrl: R,
      wasmUrl: L
    }
  }, gi = {
    ownerDocument: pe,
    pdfBug: vt,
    styleElement: Kt,
    loadingParams: {
      disableAutoFetch: $e,
      enableXfa: Oe
    }
  };
  return I.promise.then(function() {
    if (t.destroyed)
      throw new Error("Loading aborted");
    if (I.destroyed)
      throw new Error("Worker was destroyed");
    const Wt = I.messageHandler.sendWithPromise("GetDocRequest", Xt, s ? [s.buffer] : null);
    let Di;
    if (c)
      Di = new lxe(c, {
        disableRange: je,
        disableStream: Ve
      });
    else if (!s) {
      if (!n)
        throw new Error("getDocument - no `url` parameter provided.");
      const ni = eQ(n) ? cxe : By ? Txe : mxe;
      Di = new ni({
        url: n,
        length: it,
        httpHeaders: o,
        withCredentials: r,
        rangeChunkSize: h,
        disableRange: je,
        disableStream: Ve
      });
    }
    return Wt.then((ni) => {
      if (t.destroyed)
        throw new Error("Loading aborted");
      if (I.destroyed)
        throw new Error("Worker was destroyed");
      const Ci = new oQ(i, ni, I.port), Se = new Dxe(Ci, t, Di, gi, Zt, mt);
      t._transport = Se, Ci.send("Ready", null);
    });
  }).catch(t._capability.reject), t;
}
var Kle;
const Zle = class Zle {
  constructor() {
    Zi(this, "_capability", Promise.withResolvers());
    Zi(this, "_transport", null);
    Zi(this, "_worker", null);
    Zi(this, "docId", `d${hp(Zle, Kle)._++}`);
    Zi(this, "destroyed", !1);
    Zi(this, "onPassword", null);
    Zi(this, "onProgress", null);
  }
  get promise() {
    return this._capability.promise;
  }
  async destroy() {
    var t, i, n, s;
    this.destroyed = !0;
    try {
      (t = this._worker) != null && t.port && (this._worker._pendingDestroy = !0), await ((i = this._transport) == null ? void 0 : i.destroy());
    } catch (o) {
      throw (n = this._worker) != null && n.port && delete this._worker._pendingDestroy, o;
    }
    this._transport = null, (s = this._worker) == null || s.destroy(), this._worker = null;
  }
  async getData() {
    return this._transport.getData();
  }
};
Kle = new WeakMap(), xe(Zle, Kle, 0);
let Bhe = Zle;
var GB, Uee, Bee, Fee, Hee, K4e;
let X5e = (K4e = class {
  constructor(t, i, n = !1, s = null) {
    xe(this, GB, Promise.withResolvers());
    xe(this, Uee, []);
    xe(this, Bee, []);
    xe(this, Fee, []);
    xe(this, Hee, []);
    this.length = t, this.initialData = i, this.progressiveDone = n, this.contentDispositionFilename = s;
  }
  addRangeListener(t) {
    S(this, Hee).push(t);
  }
  addProgressListener(t) {
    S(this, Fee).push(t);
  }
  addProgressiveReadListener(t) {
    S(this, Bee).push(t);
  }
  addProgressiveDoneListener(t) {
    S(this, Uee).push(t);
  }
  onDataRange(t, i) {
    for (const n of S(this, Hee))
      n(t, i);
  }
  onDataProgress(t, i) {
    S(this, GB).promise.then(() => {
      for (const n of S(this, Fee))
        n(t, i);
    });
  }
  onDataProgressiveRead(t) {
    S(this, GB).promise.then(() => {
      for (const i of S(this, Bee))
        i(t);
    });
  }
  onDataProgressiveDone() {
    S(this, GB).promise.then(() => {
      for (const t of S(this, Uee))
        t();
    });
  }
  transportReady() {
    S(this, GB).resolve();
  }
  requestDataRange(t, i) {
    Ll("Abstract method PDFDataRangeTransport.requestDataRange");
  }
  abort() {
  }
}, GB = new WeakMap(), Uee = new WeakMap(), Bee = new WeakMap(), Fee = new WeakMap(), Hee = new WeakMap(), K4e);
class bxe {
  constructor(t, i) {
    this._pdfInfo = t, this._transport = i;
  }
  get annotationStorage() {
    return this._transport.annotationStorage;
  }
  get canvasFactory() {
    return this._transport.canvasFactory;
  }
  get filterFactory() {
    return this._transport.filterFactory;
  }
  get numPages() {
    return this._pdfInfo.numPages;
  }
  get fingerprints() {
    return this._pdfInfo.fingerprints;
  }
  get isPureXfa() {
    return Zo(this, "isPureXfa", !!this._transport._htmlForXfa);
  }
  get allXfaHtml() {
    return this._transport._htmlForXfa;
  }
  getPage(t) {
    return this._transport.getPage(t);
  }
  getPageIndex(t) {
    return this._transport.getPageIndex(t);
  }
  getDestinations() {
    return this._transport.getDestinations();
  }
  getDestination(t) {
    return this._transport.getDestination(t);
  }
  getPageLabels() {
    return this._transport.getPageLabels();
  }
  getPageLayout() {
    return this._transport.getPageLayout();
  }
  getPageMode() {
    return this._transport.getPageMode();
  }
  getViewerPreferences() {
    return this._transport.getViewerPreferences();
  }
  getOpenAction() {
    return this._transport.getOpenAction();
  }
  getAttachments() {
    return this._transport.getAttachments();
  }
  getJSActions() {
    return this._transport.getDocJSActions();
  }
  getOutline() {
    return this._transport.getOutline();
  }
  getOptionalContentConfig({
    intent: t = "display"
  } = {}) {
    const {
      renderingIntent: i
    } = this._transport.getRenderingIntent(t);
    return this._transport.getOptionalContentConfig(i);
  }
  getPermissions() {
    return this._transport.getPermissions();
  }
  getMetadata() {
    return this._transport.getMetadata();
  }
  getMarkInfo() {
    return this._transport.getMarkInfo();
  }
  getData() {
    return this._transport.getData();
  }
  saveDocument() {
    return this._transport.saveDocument();
  }
  getDownloadInfo() {
    return this._transport.downloadInfoCapability.promise;
  }
  cleanup(t = !1) {
    return this._transport.startCleanup(t || this.isPureXfa);
  }
  destroy() {
    return this.loadingTask.destroy();
  }
  cachedPageNumber(t) {
    return this._transport.cachedPageNumber(t);
  }
  get loadingParams() {
    return this._transport.loadingParams;
  }
  get loadingTask() {
    return this._transport.loadingTask;
  }
  getFieldObjects() {
    return this._transport.getFieldObjects();
  }
  hasJSActions() {
    return this._transport.hasJSActions();
  }
  getCalculationOrderIds() {
    return this._transport.getCalculationOrderIds();
  }
}
var jC, kB, dQ;
class Nxe {
  constructor(t, i, n, s = !1) {
    xe(this, kB);
    xe(this, jC, !1);
    this._pageIndex = t, this._pageInfo = i, this._transport = n, this._stats = s ? new Bye() : null, this._pdfBug = s, this.commonObjs = n.commonObjs, this.objs = new q5e(), this._intentStates = /* @__PURE__ */ new Map(), this.destroyed = !1;
  }
  get pageNumber() {
    return this._pageIndex + 1;
  }
  get rotate() {
    return this._pageInfo.rotate;
  }
  get ref() {
    return this._pageInfo.ref;
  }
  get userUnit() {
    return this._pageInfo.userUnit;
  }
  get view() {
    return this._pageInfo.view;
  }
  getViewport({
    scale: t,
    rotation: i = this.rotate,
    offsetX: n = 0,
    offsetY: s = 0,
    dontFlip: o = !1
  } = {}) {
    return new fie({
      viewBox: this.view,
      userUnit: this.userUnit,
      scale: t,
      rotation: i,
      offsetX: n,
      offsetY: s,
      dontFlip: o
    });
  }
  getAnnotations({
    intent: t = "display"
  } = {}) {
    const {
      renderingIntent: i
    } = this._transport.getRenderingIntent(t);
    return this._transport.getAnnotations(this._pageIndex, i);
  }
  getJSActions() {
    return this._transport.getPageJSActions(this._pageIndex);
  }
  get filterFactory() {
    return this._transport.filterFactory;
  }
  get isPureXfa() {
    return Zo(this, "isPureXfa", !!this._transport._htmlForXfa);
  }
  async getXfa() {
    var t;
    return ((t = this._transport._htmlForXfa) == null ? void 0 : t.children[this._pageIndex]) || null;
  }
  render({
    canvasContext: t,
    canvas: i = t.canvas,
    viewport: n,
    intent: s = "display",
    annotationMode: o = rx.ENABLE,
    transform: r = null,
    background: l = null,
    optionalContentConfigPromise: c = null,
    annotationCanvasMap: h = null,
    pageColors: I = null,
    printAnnotationStorage: p = null,
    isEditing: y = !1
  }) {
    var z, W;
    (z = this._stats) == null || z.time("Overall");
    const m = this._transport.getRenderingIntent(s, o, p, y), {
      renderingIntent: A,
      cacheKey: C
    } = m;
    be(this, jC, !1), c || (c = this._transport.getOptionalContentConfig(A));
    let O = this._intentStates.get(C);
    O || (O = /* @__PURE__ */ Object.create(null), this._intentStates.set(C, O)), O.streamReaderCancelTimeout && (clearTimeout(O.streamReaderCancelTimeout), O.streamReaderCancelTimeout = null);
    const R = !!(A & g2.PRINT);
    O.displayReadyCapability || (O.displayReadyCapability = Promise.withResolvers(), O.operatorList = {
      fnArray: [],
      argsArray: [],
      lastChunk: !1,
      separateAnnots: null
    }, (W = this._stats) == null || W.time("Page Request"), this._pumpOperatorList(m));
    const F = (re) => {
      var ce;
      O.renderTasks.delete(L), R && be(this, jC, !0), _e(this, kB, dQ).call(this), re ? (L.capability.reject(re), this._abortOperatorList({
        intentState: O,
        reason: re instanceof Error ? re : new Error(re)
      })) : L.capability.resolve(), this._stats && (this._stats.timeEnd("Rendering"), this._stats.timeEnd("Overall"), (ce = globalThis.Stats) != null && ce.enabled && globalThis.Stats.add(this.pageNumber, this._stats));
    }, L = new Hhe({
      callback: F,
      params: {
        canvas: i,
        canvasContext: t,
        viewport: n,
        transform: r,
        background: l
      },
      objs: this.objs,
      commonObjs: this.commonObjs,
      annotationCanvasMap: h,
      operatorList: O.operatorList,
      pageIndex: this._pageIndex,
      canvasFactory: this._transport.canvasFactory,
      filterFactory: this._transport.filterFactory,
      useRequestAnimationFrame: !R,
      pdfBug: this._pdfBug,
      pageColors: I,
      enableHWA: this._transport.enableHWA
    });
    (O.renderTasks || (O.renderTasks = /* @__PURE__ */ new Set())).add(L);
    const P = L.task;
    return Promise.all([O.displayReadyCapability.promise, c]).then(([re, ce]) => {
      var te;
      if (this.destroyed) {
        F();
        return;
      }
      if ((te = this._stats) == null || te.time("Rendering"), !(ce.renderingIntent & A))
        throw new Error("Must use the same `intent`-argument when calling the `PDFPageProxy.render` and `PDFDocumentProxy.getOptionalContentConfig` methods.");
      L.initializeGraphics({
        transparency: re,
        optionalContentConfig: ce
      }), L.operatorListChanged();
    }).catch(F), P;
  }
  getOperatorList({
    intent: t = "display",
    annotationMode: i = rx.ENABLE,
    printAnnotationStorage: n = null,
    isEditing: s = !1
  } = {}) {
    var h;
    function o() {
      l.operatorList.lastChunk && (l.opListReadCapability.resolve(l.operatorList), l.renderTasks.delete(c));
    }
    const r = this._transport.getRenderingIntent(t, i, n, s, !0);
    let l = this._intentStates.get(r.cacheKey);
    l || (l = /* @__PURE__ */ Object.create(null), this._intentStates.set(r.cacheKey, l));
    let c;
    return l.opListReadCapability || (c = /* @__PURE__ */ Object.create(null), c.operatorListChanged = o, l.opListReadCapability = Promise.withResolvers(), (l.renderTasks || (l.renderTasks = /* @__PURE__ */ new Set())).add(c), l.operatorList = {
      fnArray: [],
      argsArray: [],
      lastChunk: !1,
      separateAnnots: null
    }, (h = this._stats) == null || h.time("Page Request"), this._pumpOperatorList(r)), l.opListReadCapability.promise;
  }
  streamTextContent({
    includeMarkedContent: t = !1,
    disableNormalization: i = !1
  } = {}) {
    return this._transport.messageHandler.sendWithStream("GetTextContent", {
      pageIndex: this._pageIndex,
      includeMarkedContent: t === !0,
      disableNormalization: i === !0
    }, {
      highWaterMark: 100,
      size(s) {
        return s.items.length;
      }
    });
  }
  getTextContent(t = {}) {
    if (this._transport._htmlForXfa)
      return this.getXfa().then((n) => dX.textContent(n));
    const i = this.streamTextContent(t);
    return new Promise(function(n, s) {
      function o() {
        r.read().then(function({
          value: c,
          done: h
        }) {
          if (h) {
            n(l);
            return;
          }
          l.lang ?? (l.lang = c.lang), Object.assign(l.styles, c.styles), l.items.push(...c.items), o();
        }, s);
      }
      const r = i.getReader(), l = {
        items: [],
        styles: /* @__PURE__ */ Object.create(null),
        lang: null
      };
      o();
    });
  }
  getStructTree() {
    return this._transport.getStructTree(this._pageIndex);
  }
  _destroy() {
    this.destroyed = !0;
    const t = [];
    for (const i of this._intentStates.values())
      if (this._abortOperatorList({
        intentState: i,
        reason: new Error("Page was destroyed."),
        force: !0
      }), !i.opListReadCapability)
        for (const n of i.renderTasks)
          t.push(n.completed), n.cancel();
    return this.objs.clear(), be(this, jC, !1), Promise.all(t);
  }
  cleanup(t = !1) {
    be(this, jC, !0);
    const i = _e(this, kB, dQ).call(this);
    return t && i && this._stats && (this._stats = new Bye()), i;
  }
  _startRenderPage(t, i) {
    var s, o;
    const n = this._intentStates.get(i);
    n && ((s = this._stats) == null || s.timeEnd("Page Request"), (o = n.displayReadyCapability) == null || o.resolve(t));
  }
  _renderPageChunk(t, i) {
    for (let n = 0, s = t.length; n < s; n++)
      i.operatorList.fnArray.push(t.fnArray[n]), i.operatorList.argsArray.push(t.argsArray[n]);
    i.operatorList.lastChunk = t.lastChunk, i.operatorList.separateAnnots = t.separateAnnots;
    for (const n of i.renderTasks)
      n.operatorListChanged();
    t.lastChunk && _e(this, kB, dQ).call(this);
  }
  _pumpOperatorList({
    renderingIntent: t,
    cacheKey: i,
    annotationStorageSerializable: n,
    modifiedIds: s
  }) {
    const {
      map: o,
      transfer: r
    } = n, c = this._transport.messageHandler.sendWithStream("GetOperatorList", {
      pageIndex: this._pageIndex,
      intent: t,
      cacheKey: i,
      annotationStorage: o,
      modifiedIds: s
    }, r).getReader(), h = this._intentStates.get(i);
    h.streamReader = c;
    const I = () => {
      c.read().then(({
        value: p,
        done: y
      }) => {
        if (y) {
          h.streamReader = null;
          return;
        }
        this._transport.destroyed || (this._renderPageChunk(p, h), I());
      }, (p) => {
        if (h.streamReader = null, !this._transport.destroyed) {
          if (h.operatorList) {
            h.operatorList.lastChunk = !0;
            for (const y of h.renderTasks)
              y.operatorListChanged();
            _e(this, kB, dQ).call(this);
          }
          if (h.displayReadyCapability)
            h.displayReadyCapability.reject(p);
          else if (h.opListReadCapability)
            h.opListReadCapability.reject(p);
          else
            throw p;
        }
      });
    };
    I();
  }
  _abortOperatorList({
    intentState: t,
    reason: i,
    force: n = !1
  }) {
    if (t.streamReader) {
      if (t.streamReaderCancelTimeout && (clearTimeout(t.streamReaderCancelTimeout), t.streamReaderCancelTimeout = null), !n) {
        if (t.renderTasks.size > 0)
          return;
        if (i instanceof bpe) {
          let s = Sxe;
          i.extraDelay > 0 && i.extraDelay < 1e3 && (s += i.extraDelay), t.streamReaderCancelTimeout = setTimeout(() => {
            t.streamReaderCancelTimeout = null, this._abortOperatorList({
              intentState: t,
              reason: i,
              force: !0
            });
          }, s);
          return;
        }
      }
      if (t.streamReader.cancel(new WP(i.message)).catch(() => {
      }), t.streamReader = null, !this._transport.destroyed) {
        for (const [s, o] of this._intentStates)
          if (o === t) {
            this._intentStates.delete(s);
            break;
          }
        this.cleanup();
      }
    }
  }
  get stats() {
    return this._stats;
  }
}
jC = new WeakMap(), kB = new WeakSet(), dQ = function() {
  if (!S(this, jC) || this.destroyed)
    return !1;
  for (const {
    renderTasks: t,
    operatorList: i
  } of this._intentStates.values())
    if (t.size > 0 || !i.lastChunk)
      return !1;
  return this._intentStates.clear(), this.objs.clear(), be(this, jC, !1), !0;
};
var xx, Ev, WC, VB, Hl, Qle, zB, jB, iE, soe, eRe, tRe, cQ, fj, ooe;
let Fhe = (Hl = class {
  constructor({
    name: t = null,
    port: i = null,
    verbosity: n = f_e()
  } = {}) {
    xe(this, iE);
    xe(this, xx, Promise.withResolvers());
    xe(this, Ev, null);
    xe(this, WC, null);
    xe(this, VB, null);
    if (this.name = t, this.destroyed = !1, this.verbosity = n, i) {
      if (S(Hl, jB).has(i))
        throw new Error("Cannot use more than one PDFWorker per port.");
      S(Hl, jB).set(i, this), _e(this, iE, eRe).call(this, i);
    } else
      _e(this, iE, tRe).call(this);
  }
  get promise() {
    return S(this, xx).promise;
  }
  get port() {
    return S(this, WC);
  }
  get messageHandler() {
    return S(this, Ev);
  }
  destroy() {
    var t, i;
    this.destroyed = !0, (t = S(this, VB)) == null || t.terminate(), be(this, VB, null), S(Hl, jB).delete(S(this, WC)), be(this, WC, null), (i = S(this, Ev)) == null || i.destroy(), be(this, Ev, null);
  }
  static create(t) {
    const i = S(this, jB).get(t == null ? void 0 : t.port);
    if (i) {
      if (i._pendingDestroy)
        throw new Error("PDFWorker.create - the worker is being destroyed.\nPlease remember to await `PDFDocumentLoadingTask.destroy()`-calls.");
      return i;
    }
    return new Hl(t);
  }
  static get workerSrc() {
    if (lx.workerSrc)
      return lx.workerSrc;
    throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
  }
  static get _setupFakeWorkerGlobal() {
    return Zo(this, "_setupFakeWorkerGlobal", (async () => S(this, fj, ooe) ? S(this, fj, ooe) : (await import(
      /*webpackIgnore: true*/
      /*@vite-ignore*/
      this.workerSrc
    )).WorkerMessageHandler)());
  }
}, xx = new WeakMap(), Ev = new WeakMap(), WC = new WeakMap(), VB = new WeakMap(), Qle = new WeakMap(), zB = new WeakMap(), jB = new WeakMap(), iE = new WeakSet(), soe = function() {
  S(this, xx).resolve(), S(this, Ev).send("configure", {
    verbosity: this.verbosity
  });
}, eRe = function(t) {
  be(this, WC, t), be(this, Ev, new oQ("main", "worker", t)), S(this, Ev).on("ready", () => {
  }), _e(this, iE, soe).call(this);
}, tRe = function() {
  if (S(Hl, zB) || S(Hl, fj, ooe)) {
    _e(this, iE, cQ).call(this);
    return;
  }
  let {
    workerSrc: t
  } = Hl;
  try {
    Hl._isSameOrigin(window.location, t) || (t = Hl._createCDNWrapper(new URL(t, window.location).href));
    const i = new Worker(t, {
      type: "module"
    }), n = new oQ("main", "worker", i), s = () => {
      o.abort(), n.destroy(), i.terminate(), this.destroyed ? S(this, xx).reject(new Error("Worker was destroyed")) : _e(this, iE, cQ).call(this);
    }, o = new AbortController();
    i.addEventListener("error", () => {
      S(this, VB) || s();
    }, {
      signal: o.signal
    }), n.on("test", (l) => {
      if (o.abort(), this.destroyed || !l) {
        s();
        return;
      }
      be(this, Ev, n), be(this, WC, i), be(this, VB, i), _e(this, iE, soe).call(this);
    }), n.on("ready", (l) => {
      if (o.abort(), this.destroyed) {
        s();
        return;
      }
      try {
        r();
      } catch {
        _e(this, iE, cQ).call(this);
      }
    });
    const r = () => {
      const l = new Uint8Array();
      n.send("test", l, [l.buffer]);
    };
    r();
    return;
  } catch {
    mae("The worker has been disabled.");
  }
  _e(this, iE, cQ).call(this);
}, cQ = function() {
  S(Hl, zB) || (to("Setting up fake worker."), be(Hl, zB, !0)), Hl._setupFakeWorkerGlobal.then((t) => {
    if (this.destroyed) {
      S(this, xx).reject(new Error("Worker was destroyed"));
      return;
    }
    const i = new F_e();
    be(this, WC, i);
    const n = `fake${hp(Hl, Qle)._++}`, s = new oQ(n + "_worker", n, i);
    t.setup(s, i), be(this, Ev, new oQ(n, n + "_worker", i)), _e(this, iE, soe).call(this);
  }).catch((t) => {
    S(this, xx).reject(new Error(`Setting up fake worker failed: "${t.message}".`));
  });
}, fj = new WeakSet(), ooe = function() {
  var t;
  try {
    return ((t = globalThis.pdfjsWorker) == null ? void 0 : t.WorkerMessageHandler) || null;
  } catch {
    return null;
  }
}, xe(Hl, fj), xe(Hl, Qle, 0), xe(Hl, zB, !1), xe(Hl, jB, /* @__PURE__ */ new WeakMap()), By && (be(Hl, zB, !0), lx.workerSrc || (lx.workerSrc = "./pdf.worker.mjs")), Hl._isSameOrigin = (t, i) => {
  const n = URL.parse(t);
  if (!(n != null && n.origin) || n.origin === "null")
    return !1;
  const s = new URL(i, n);
  return n.origin === s.origin;
}, Hl._createCDNWrapper = (t) => {
  const i = `await import("${t}");`;
  return URL.createObjectURL(new Blob([i], {
    type: "text/javascript"
  }));
}, Hl.fromPort = (t) => {
  if (S_e("`PDFWorker.fromPort` - please use `PDFWorker.create` instead."), !(t != null && t.port))
    throw new Error("PDFWorker.fromPort - invalid method signature.");
  return Hl.create(t);
}, Hl);
var YC, Ub, Ij, pj, qC, WB, hQ;
class Dxe {
  constructor(t, i, n, s, o, r) {
    xe(this, WB);
    xe(this, YC, /* @__PURE__ */ new Map());
    xe(this, Ub, /* @__PURE__ */ new Map());
    xe(this, Ij, /* @__PURE__ */ new Map());
    xe(this, pj, /* @__PURE__ */ new Map());
    xe(this, qC, null);
    this.messageHandler = t, this.loadingTask = i, this.commonObjs = new q5e(), this.fontLoader = new __e({
      ownerDocument: s.ownerDocument,
      styleElement: s.styleElement
    }), this.loadingParams = s.loadingParams, this._params = s, this.canvasFactory = o.canvasFactory, this.filterFactory = o.filterFactory, this.cMapReaderFactory = o.cMapReaderFactory, this.standardFontDataFactory = o.standardFontDataFactory, this.wasmFactory = o.wasmFactory, this.destroyed = !1, this.destroyCapability = null, this._networkStream = n, this._fullReader = null, this._lastProgress = null, this.downloadInfoCapability = Promise.withResolvers(), this.enableHWA = r, this.setupMessageHandler();
  }
  get annotationStorage() {
    return Zo(this, "annotationStorage", new Dpe());
  }
  getRenderingIntent(t, i = rx.ENABLE, n = null, s = !1, o = !1) {
    let r = g2.DISPLAY, l = Ahe;
    switch (t) {
      case "any":
        r = g2.ANY;
        break;
      case "display":
        break;
      case "print":
        r = g2.PRINT;
        break;
      default:
        to(`getRenderingIntent - invalid intent: ${t}`);
    }
    const c = r & g2.PRINT && n instanceof L5e ? n : this.annotationStorage;
    switch (i) {
      case rx.DISABLE:
        r += g2.ANNOTATIONS_DISABLE;
        break;
      case rx.ENABLE:
        break;
      case rx.ENABLE_FORMS:
        r += g2.ANNOTATIONS_FORMS;
        break;
      case rx.ENABLE_STORAGE:
        r += g2.ANNOTATIONS_STORAGE, l = c.serializable;
        break;
      default:
        to(`getRenderingIntent - invalid annotationMode: ${i}`);
    }
    s && (r += g2.IS_EDITING), o && (r += g2.OPLIST);
    const {
      ids: h,
      hash: I
    } = c.modifiedIds, p = [r, l.hash, I];
    return {
      renderingIntent: r,
      cacheKey: p.join("_"),
      annotationStorageSerializable: l,
      modifiedIds: h
    };
  }
  destroy() {
    var n;
    if (this.destroyCapability)
      return this.destroyCapability.promise;
    this.destroyed = !0, this.destroyCapability = Promise.withResolvers(), (n = S(this, qC)) == null || n.reject(new Error("Worker was destroyed during onPassword callback"));
    const t = [];
    for (const s of S(this, Ub).values())
      t.push(s._destroy());
    S(this, Ub).clear(), S(this, Ij).clear(), S(this, pj).clear(), this.hasOwnProperty("annotationStorage") && this.annotationStorage.resetModified();
    const i = this.messageHandler.sendWithPromise("Terminate", null);
    return t.push(i), Promise.all(t).then(() => {
      var s, o;
      this.commonObjs.clear(), this.fontLoader.clear(), S(this, YC).clear(), this.filterFactory.destroy(), rle.cleanup(), (s = this._networkStream) == null || s.cancelAllRequests(new WP("Worker was terminated.")), (o = this.messageHandler) == null || o.destroy(), this.messageHandler = null, this.destroyCapability.resolve();
    }, this.destroyCapability.reject), this.destroyCapability.promise;
  }
  setupMessageHandler() {
    const {
      messageHandler: t,
      loadingTask: i
    } = this;
    t.on("GetReader", (n, s) => {
      uh(this._networkStream, "GetReader - no `IPDFStream` instance available."), this._fullReader = this._networkStream.getFullReader(), this._fullReader.onProgress = (o) => {
        this._lastProgress = {
          loaded: o.loaded,
          total: o.total
        };
      }, s.onPull = () => {
        this._fullReader.read().then(function({
          value: o,
          done: r
        }) {
          if (r) {
            s.close();
            return;
          }
          uh(o instanceof ArrayBuffer, "GetReader - expected an ArrayBuffer."), s.enqueue(new Uint8Array(o), 1, [o]);
        }).catch((o) => {
          s.error(o);
        });
      }, s.onCancel = (o) => {
        this._fullReader.cancel(o), s.ready.catch((r) => {
          if (!this.destroyed)
            throw r;
        });
      };
    }), t.on("ReaderHeadersReady", async (n) => {
      var l;
      await this._fullReader.headersReady;
      const {
        isStreamingSupported: s,
        isRangeSupported: o,
        contentLength: r
      } = this._fullReader;
      return (!s || !o) && (this._lastProgress && ((l = i.onProgress) == null || l.call(i, this._lastProgress)), this._fullReader.onProgress = (c) => {
        var h;
        (h = i.onProgress) == null || h.call(i, {
          loaded: c.loaded,
          total: c.total
        });
      }), {
        isStreamingSupported: s,
        isRangeSupported: o,
        contentLength: r
      };
    }), t.on("GetRangeReader", (n, s) => {
      uh(this._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
      const o = this._networkStream.getRangeReader(n.begin, n.end);
      if (!o) {
        s.close();
        return;
      }
      s.onPull = () => {
        o.read().then(function({
          value: r,
          done: l
        }) {
          if (l) {
            s.close();
            return;
          }
          uh(r instanceof ArrayBuffer, "GetRangeReader - expected an ArrayBuffer."), s.enqueue(new Uint8Array(r), 1, [r]);
        }).catch((r) => {
          s.error(r);
        });
      }, s.onCancel = (r) => {
        o.cancel(r), s.ready.catch((l) => {
          if (!this.destroyed)
            throw l;
        });
      };
    }), t.on("GetDoc", ({
      pdfInfo: n
    }) => {
      this._numPages = n.numPages, this._htmlForXfa = n.htmlForXfa, delete n.htmlForXfa, i._capability.resolve(new bxe(n, this));
    }), t.on("DocException", (n) => {
      i._capability.reject(ug(n));
    }), t.on("PasswordRequest", (n) => {
      be(this, qC, Promise.withResolvers());
      try {
        if (!i.onPassword)
          throw ug(n);
        const s = (o) => {
          o instanceof Error ? S(this, qC).reject(o) : S(this, qC).resolve({
            password: o
          });
        };
        i.onPassword(s, n.code);
      } catch (s) {
        S(this, qC).reject(s);
      }
      return S(this, qC).promise;
    }), t.on("DataLoaded", (n) => {
      var s;
      (s = i.onProgress) == null || s.call(i, {
        loaded: n.length,
        total: n.length
      }), this.downloadInfoCapability.resolve(n);
    }), t.on("StartRenderPage", (n) => {
      if (this.destroyed)
        return;
      S(this, Ub).get(n.pageIndex)._startRenderPage(n.transparency, n.cacheKey);
    }), t.on("commonobj", ([n, s, o]) => {
      var r;
      if (this.destroyed || this.commonObjs.has(n))
        return null;
      switch (s) {
        case "Font":
          if ("error" in o) {
            const I = o.error;
            to(`Error during font loading: ${I}`), this.commonObjs.resolve(n, I);
            break;
          }
          const l = this._params.pdfBug && ((r = globalThis.FontInspector) != null && r.enabled) ? (I, p) => globalThis.FontInspector.fontAdded(I, p) : null, c = new x_e(o, l);
          this.fontLoader.bind(c).catch(() => t.sendWithPromise("FontFallback", {
            id: n
          })).finally(() => {
            !c.fontExtraProperties && c.data && (c.data = null), this.commonObjs.resolve(n, c);
          });
          break;
        case "CopyLocalImage":
          const {
            imageRef: h
          } = o;
          uh(h, "The imageRef must be defined.");
          for (const I of S(this, Ub).values())
            for (const [, p] of I.objs)
              if ((p == null ? void 0 : p.ref) === h)
                return p.dataLen ? (this.commonObjs.resolve(n, structuredClone(p)), p.dataLen) : null;
          break;
        case "FontPath":
        case "Image":
        case "Pattern":
          this.commonObjs.resolve(n, o);
          break;
        default:
          throw new Error(`Got unknown common object type ${s}`);
      }
      return null;
    }), t.on("obj", ([n, s, o, r]) => {
      var c;
      if (this.destroyed)
        return;
      const l = S(this, Ub).get(s);
      if (!l.objs.has(n)) {
        if (l._intentStates.size === 0) {
          (c = r == null ? void 0 : r.bitmap) == null || c.close();
          return;
        }
        switch (o) {
          case "Image":
          case "Pattern":
            l.objs.resolve(n, r);
            break;
          default:
            throw new Error(`Got unknown object type ${o}`);
        }
      }
    }), t.on("DocProgress", (n) => {
      var s;
      this.destroyed || (s = i.onProgress) == null || s.call(i, {
        loaded: n.loaded,
        total: n.total
      });
    }), t.on("FetchBinaryData", async (n) => {
      if (this.destroyed)
        throw new Error("Worker was destroyed.");
      const s = this[n.type];
      if (!s)
        throw new Error(`${n.type} not initialized, see the \`useWorkerFetch\` parameter.`);
      return s.fetch(n);
    });
  }
  getData() {
    return this.messageHandler.sendWithPromise("GetData", null);
  }
  saveDocument() {
    var n;
    this.annotationStorage.size <= 0 && to("saveDocument called while `annotationStorage` is empty, please use the getData-method instead.");
    const {
      map: t,
      transfer: i
    } = this.annotationStorage.serializable;
    return this.messageHandler.sendWithPromise("SaveDocument", {
      isPureXfa: !!this._htmlForXfa,
      numPages: this._numPages,
      annotationStorage: t,
      filename: ((n = this._fullReader) == null ? void 0 : n.filename) ?? null
    }, i).finally(() => {
      this.annotationStorage.resetModified();
    });
  }
  getPage(t) {
    if (!Number.isInteger(t) || t <= 0 || t > this._numPages)
      return Promise.reject(new Error("Invalid page request."));
    const i = t - 1, n = S(this, Ij).get(i);
    if (n)
      return n;
    const s = this.messageHandler.sendWithPromise("GetPage", {
      pageIndex: i
    }).then((o) => {
      if (this.destroyed)
        throw new Error("Transport destroyed");
      o.refStr && S(this, pj).set(o.refStr, t);
      const r = new Nxe(i, o, this, this._params.pdfBug);
      return S(this, Ub).set(i, r), r;
    });
    return S(this, Ij).set(i, s), s;
  }
  getPageIndex(t) {
    return She(t) ? this.messageHandler.sendWithPromise("GetPageIndex", {
      num: t.num,
      gen: t.gen
    }) : Promise.reject(new Error("Invalid pageIndex request."));
  }
  getAnnotations(t, i) {
    return this.messageHandler.sendWithPromise("GetAnnotations", {
      pageIndex: t,
      intent: i
    });
  }
  getFieldObjects() {
    return _e(this, WB, hQ).call(this, "GetFieldObjects");
  }
  hasJSActions() {
    return _e(this, WB, hQ).call(this, "HasJSActions");
  }
  getCalculationOrderIds() {
    return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
  }
  getDestinations() {
    return this.messageHandler.sendWithPromise("GetDestinations", null);
  }
  getDestination(t) {
    return typeof t != "string" ? Promise.reject(new Error("Invalid destination request.")) : this.messageHandler.sendWithPromise("GetDestination", {
      id: t
    });
  }
  getPageLabels() {
    return this.messageHandler.sendWithPromise("GetPageLabels", null);
  }
  getPageLayout() {
    return this.messageHandler.sendWithPromise("GetPageLayout", null);
  }
  getPageMode() {
    return this.messageHandler.sendWithPromise("GetPageMode", null);
  }
  getViewerPreferences() {
    return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
  }
  getOpenAction() {
    return this.messageHandler.sendWithPromise("GetOpenAction", null);
  }
  getAttachments() {
    return this.messageHandler.sendWithPromise("GetAttachments", null);
  }
  getDocJSActions() {
    return _e(this, WB, hQ).call(this, "GetDocJSActions");
  }
  getPageJSActions(t) {
    return this.messageHandler.sendWithPromise("GetPageJSActions", {
      pageIndex: t
    });
  }
  getStructTree(t) {
    return this.messageHandler.sendWithPromise("GetStructTree", {
      pageIndex: t
    });
  }
  getOutline() {
    return this.messageHandler.sendWithPromise("GetOutline", null);
  }
  getOptionalContentConfig(t) {
    return _e(this, WB, hQ).call(this, "GetOptionalContentConfig").then((i) => new rxe(i, t));
  }
  getPermissions() {
    return this.messageHandler.sendWithPromise("GetPermissions", null);
  }
  getMetadata() {
    const t = "GetMetadata", i = S(this, YC).get(t);
    if (i)
      return i;
    const n = this.messageHandler.sendWithPromise(t, null).then((s) => {
      var o, r;
      return {
        info: s[0],
        metadata: s[1] ? new sxe(s[1]) : null,
        contentDispositionFilename: ((o = this._fullReader) == null ? void 0 : o.filename) ?? null,
        contentLength: ((r = this._fullReader) == null ? void 0 : r.contentLength) ?? null
      };
    });
    return S(this, YC).set(t, n), n;
  }
  getMarkInfo() {
    return this.messageHandler.sendWithPromise("GetMarkInfo", null);
  }
  async startCleanup(t = !1) {
    if (!this.destroyed) {
      await this.messageHandler.sendWithPromise("Cleanup", null);
      for (const i of S(this, Ub).values())
        if (!i.cleanup())
          throw new Error(`startCleanup: Page ${i.pageNumber} is currently rendering.`);
      this.commonObjs.clear(), t || this.fontLoader.clear(), S(this, YC).clear(), this.filterFactory.destroy(!0), rle.cleanup();
    }
  }
  cachedPageNumber(t) {
    if (!She(t))
      return null;
    const i = t.gen === 0 ? `${t.num}R` : `${t.num}R${t.gen}`;
    return S(this, pj).get(i) ?? null;
  }
}
YC = new WeakMap(), Ub = new WeakMap(), Ij = new WeakMap(), pj = new WeakMap(), qC = new WeakMap(), WB = new WeakSet(), hQ = function(t, i = null) {
  const n = S(this, YC).get(t);
  if (n)
    return n;
  const s = this.messageHandler.sendWithPromise(t, i);
  return S(this, YC).set(t, s), s;
};
var Px;
class Cxe {
  constructor(t) {
    xe(this, Px, null);
    Zi(this, "onContinue", null);
    Zi(this, "onError", null);
    be(this, Px, t);
  }
  get promise() {
    return S(this, Px).capability.promise;
  }
  cancel(t = 0) {
    S(this, Px).cancel(null, t);
  }
  get separateAnnots() {
    const {
      separateAnnots: t
    } = S(this, Px).operatorList;
    if (!t)
      return !1;
    const {
      annotationCanvasMap: i
    } = S(this, Px);
    return t.form || t.canvas && (i == null ? void 0 : i.size) > 0;
  }
}
Px = new WeakMap();
var Mx, YB;
const tB = class tB {
  constructor({
    callback: t,
    params: i,
    objs: n,
    commonObjs: s,
    annotationCanvasMap: o,
    operatorList: r,
    pageIndex: l,
    canvasFactory: c,
    filterFactory: h,
    useRequestAnimationFrame: I = !1,
    pdfBug: p = !1,
    pageColors: y = null,
    enableHWA: m = !1
  }) {
    xe(this, Mx, null);
    this.callback = t, this.params = i, this.objs = n, this.commonObjs = s, this.annotationCanvasMap = o, this.operatorListIdx = null, this.operatorList = r, this._pageIndex = l, this.canvasFactory = c, this.filterFactory = h, this._pdfBug = p, this.pageColors = y, this.running = !1, this.graphicsReadyCallback = null, this.graphicsReady = !1, this._useRequestAnimationFrame = I === !0 && typeof window < "u", this.cancelled = !1, this.capability = Promise.withResolvers(), this.task = new Cxe(this), this._cancelBound = this.cancel.bind(this), this._continueBound = this._continue.bind(this), this._scheduleNextBound = this._scheduleNext.bind(this), this._nextBound = this._next.bind(this), this._canvas = i.canvas, this._canvasContext = i.canvas ? null : i.canvasContext, this._enableHWA = m;
  }
  get completed() {
    return this.capability.promise.catch(function() {
    });
  }
  initializeGraphics({
    transparency: t = !1,
    optionalContentConfig: i
  }) {
    var l, c;
    if (this.cancelled)
      return;
    if (this._canvas) {
      if (S(tB, YB).has(this._canvas))
        throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
      S(tB, YB).add(this._canvas);
    }
    this._pdfBug && ((l = globalThis.StepperManager) != null && l.enabled) && (this.stepper = globalThis.StepperManager.create(this._pageIndex), this.stepper.init(this.operatorList), this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint());
    const {
      viewport: n,
      transform: s,
      background: o
    } = this.params, r = this._canvasContext || this._canvas.getContext("2d", {
      alpha: !1,
      willReadFrequently: !this._enableHWA
    });
    this.gfx = new Rz(r, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
      optionalContentConfig: i
    }, this.annotationCanvasMap, this.pageColors), this.gfx.beginDrawing({
      transform: s,
      viewport: n,
      transparency: t,
      background: o
    }), this.operatorListIdx = 0, this.graphicsReady = !0, (c = this.graphicsReadyCallback) == null || c.call(this);
  }
  cancel(t = null, i = 0) {
    var n, s, o;
    this.running = !1, this.cancelled = !0, (n = this.gfx) == null || n.endDrawing(), S(this, Mx) && (window.cancelAnimationFrame(S(this, Mx)), be(this, Mx, null)), S(tB, YB).delete(this._canvas), t || (t = new bpe(`Rendering cancelled, page ${this._pageIndex + 1}`, i)), this.callback(t), (o = (s = this.task).onError) == null || o.call(s, t);
  }
  operatorListChanged() {
    var t;
    if (!this.graphicsReady) {
      this.graphicsReadyCallback || (this.graphicsReadyCallback = this._continueBound);
      return;
    }
    (t = this.stepper) == null || t.updateOperatorList(this.operatorList), !this.running && this._continue();
  }
  _continue() {
    this.running = !0, !this.cancelled && (this.task.onContinue ? this.task.onContinue(this._scheduleNextBound) : this._scheduleNext());
  }
  _scheduleNext() {
    this._useRequestAnimationFrame ? be(this, Mx, window.requestAnimationFrame(() => {
      be(this, Mx, null), this._nextBound().catch(this._cancelBound);
    })) : Promise.resolve().then(this._nextBound).catch(this._cancelBound);
  }
  async _next() {
    this.cancelled || (this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper), this.operatorListIdx === this.operatorList.argsArray.length && (this.running = !1, this.operatorList.lastChunk && (this.gfx.endDrawing(), S(tB, YB).delete(this._canvas), this.callback())));
  }
};
Mx = new WeakMap(), YB = new WeakMap(), xe(tB, YB, /* @__PURE__ */ new WeakSet());
let Hhe = tB;
const Oxe = "5.4.54", Lxe = "295fb3ec4";
var l2, qB, mj, kh, Gee, yj, $C, kee, Ux, gv, Ap, Vee, Cl, Ghe, khe, Vhe, rU, nRe, g_;
let iRe = (Ap = class {
  constructor({
    editor: t = null,
    uiManager: i = null
  }) {
    xe(this, Cl);
    xe(this, l2, null);
    xe(this, qB, null);
    xe(this, mj);
    xe(this, kh, null);
    xe(this, Gee, !1);
    xe(this, yj, !1);
    xe(this, $C, null);
    xe(this, kee);
    xe(this, Ux, null);
    xe(this, gv, null);
    var n, s;
    t ? (be(this, yj, !1), be(this, $C, t)) : be(this, yj, !0), be(this, gv, (t == null ? void 0 : t._uiManager) || i), be(this, kee, S(this, gv)._eventBus), be(this, mj, ((n = t == null ? void 0 : t.color) == null ? void 0 : n.toUpperCase()) || ((s = S(this, gv)) == null ? void 0 : s.highlightColors.values().next().value) || "#FFFF98"), S(Ap, Vee) || be(Ap, Vee, Object.freeze({
      blue: "pdfjs-editor-colorpicker-blue",
      green: "pdfjs-editor-colorpicker-green",
      pink: "pdfjs-editor-colorpicker-pink",
      red: "pdfjs-editor-colorpicker-red",
      yellow: "pdfjs-editor-colorpicker-yellow"
    }));
  }
  static get _keyboardManager() {
    return Zo(this, "_keyboardManager", new Iie([[["Escape", "mac+Escape"], Ap.prototype._hideDropdownFromKeyboard], [[" ", "mac+ "], Ap.prototype._colorSelectFromKeyboard], [["ArrowDown", "ArrowRight", "mac+ArrowDown", "mac+ArrowRight"], Ap.prototype._moveToNext], [["ArrowUp", "ArrowLeft", "mac+ArrowUp", "mac+ArrowLeft"], Ap.prototype._moveToPrevious], [["Home", "mac+Home"], Ap.prototype._moveToBeginning], [["End", "mac+End"], Ap.prototype._moveToEnd]]));
  }
  renderButton() {
    const t = be(this, l2, document.createElement("button"));
    t.className = "colorPicker", t.tabIndex = "0", t.setAttribute("data-l10n-id", "pdfjs-editor-colorpicker-button"), t.ariaHasPopup = "true", S(this, $C) && (t.ariaControls = `${S(this, $C).id}_colorpicker_dropdown`);
    const i = S(this, gv)._signal;
    t.addEventListener("click", _e(this, Cl, rU).bind(this), {
      signal: i
    }), t.addEventListener("keydown", _e(this, Cl, Vhe).bind(this), {
      signal: i
    });
    const n = be(this, qB, document.createElement("span"));
    return n.className = "swatch", n.ariaHidden = "true", n.style.backgroundColor = S(this, mj), t.append(n), t;
  }
  renderMainDropdown() {
    const t = be(this, kh, _e(this, Cl, Ghe).call(this));
    return t.ariaOrientation = "horizontal", t.ariaLabelledBy = "highlightColorPickerLabel", t;
  }
  _colorSelectFromKeyboard(t) {
    if (t.target === S(this, l2)) {
      _e(this, Cl, rU).call(this, t);
      return;
    }
    const i = t.target.getAttribute("data-color");
    i && _e(this, Cl, khe).call(this, i, t);
  }
  _moveToNext(t) {
    var i, n;
    if (!S(this, Cl, g_)) {
      _e(this, Cl, rU).call(this, t);
      return;
    }
    if (t.target === S(this, l2)) {
      (i = S(this, kh).firstChild) == null || i.focus();
      return;
    }
    (n = t.target.nextSibling) == null || n.focus();
  }
  _moveToPrevious(t) {
    var i, n;
    if (t.target === ((i = S(this, kh)) == null ? void 0 : i.firstChild) || t.target === S(this, l2)) {
      S(this, Cl, g_) && this._hideDropdownFromKeyboard();
      return;
    }
    S(this, Cl, g_) || _e(this, Cl, rU).call(this, t), (n = t.target.previousSibling) == null || n.focus();
  }
  _moveToBeginning(t) {
    var i;
    if (!S(this, Cl, g_)) {
      _e(this, Cl, rU).call(this, t);
      return;
    }
    (i = S(this, kh).firstChild) == null || i.focus();
  }
  _moveToEnd(t) {
    var i;
    if (!S(this, Cl, g_)) {
      _e(this, Cl, rU).call(this, t);
      return;
    }
    (i = S(this, kh).lastChild) == null || i.focus();
  }
  hideDropdown() {
    var t, i;
    (t = S(this, kh)) == null || t.classList.add("hidden"), S(this, l2).ariaExpanded = "false", (i = S(this, Ux)) == null || i.abort(), be(this, Ux, null);
  }
  _hideDropdownFromKeyboard() {
    var t;
    if (!S(this, yj)) {
      if (!S(this, Cl, g_)) {
        (t = S(this, $C)) == null || t.unselect();
        return;
      }
      this.hideDropdown(), S(this, l2).focus({
        preventScroll: !0,
        focusVisible: S(this, Gee)
      });
    }
  }
  updateColor(t) {
    if (S(this, qB) && (S(this, qB).style.backgroundColor = t), !S(this, kh))
      return;
    const i = S(this, gv).highlightColors.values();
    for (const n of S(this, kh).children)
      n.ariaSelected = i.next().value === t.toUpperCase();
  }
  destroy() {
    var t, i;
    (t = S(this, l2)) == null || t.remove(), be(this, l2, null), be(this, qB, null), (i = S(this, kh)) == null || i.remove(), be(this, kh, null);
  }
}, l2 = new WeakMap(), qB = new WeakMap(), mj = new WeakMap(), kh = new WeakMap(), Gee = new WeakMap(), yj = new WeakMap(), $C = new WeakMap(), kee = new WeakMap(), Ux = new WeakMap(), gv = new WeakMap(), Vee = new WeakMap(), Cl = new WeakSet(), Ghe = function() {
  const t = document.createElement("div"), i = S(this, gv)._signal;
  t.addEventListener("contextmenu", F5, {
    signal: i
  }), t.className = "dropdown", t.role = "listbox", t.ariaMultiSelectable = "false", t.ariaOrientation = "vertical", t.setAttribute("data-l10n-id", "pdfjs-editor-colorpicker-dropdown"), S(this, $C) && (t.id = `${S(this, $C).id}_colorpicker_dropdown`);
  for (const [n, s] of S(this, gv).highlightColors) {
    const o = document.createElement("button");
    o.tabIndex = "0", o.role = "option", o.setAttribute("data-color", s), o.title = n, o.setAttribute("data-l10n-id", S(Ap, Vee)[n]);
    const r = document.createElement("span");
    o.append(r), r.className = "swatch", r.style.backgroundColor = s, o.ariaSelected = s === S(this, mj), o.addEventListener("click", _e(this, Cl, khe).bind(this, s), {
      signal: i
    }), t.append(o);
  }
  return t.addEventListener("keydown", _e(this, Cl, Vhe).bind(this), {
    signal: i
  }), t;
}, khe = function(t, i) {
  i.stopPropagation(), S(this, kee).dispatch("switchannotationeditorparams", {
    source: this,
    type: Ir.HIGHLIGHT_COLOR,
    value: t
  }), this.updateColor(t);
}, Vhe = function(t) {
  Ap._keyboardManager.exec(this, t);
}, rU = function(t) {
  if (S(this, Cl, g_)) {
    this.hideDropdown();
    return;
  }
  if (be(this, Gee, t.detail === 0), S(this, Ux) || (be(this, Ux, new AbortController()), window.addEventListener("pointerdown", _e(this, Cl, nRe).bind(this), {
    signal: S(this, gv).combinedSignal(S(this, Ux))
  })), S(this, l2).ariaExpanded = "true", S(this, kh)) {
    S(this, kh).classList.remove("hidden");
    return;
  }
  const i = be(this, kh, _e(this, Cl, Ghe).call(this));
  S(this, l2).append(i);
}, nRe = function(t) {
  var i;
  (i = S(this, kh)) != null && i.contains(t.target) || this.hideDropdown();
}, g_ = function() {
  return S(this, kh) && !S(this, kh).classList.contains("hidden");
}, xe(Ap, Vee, null), Ap);
var Bb, zee, Ej, jee;
const iB = class iB {
  constructor(t) {
    xe(this, Bb, null);
    xe(this, zee, null);
    xe(this, Ej, null);
    be(this, zee, t), be(this, Ej, t._uiManager), S(iB, jee) || be(iB, jee, Object.freeze({
      freetext: "pdfjs-editor-color-picker-free-text-input",
      ink: "pdfjs-editor-color-picker-ink-input"
    }));
  }
  renderButton() {
    if (S(this, Bb))
      return S(this, Bb);
    const {
      editorType: t,
      colorType: i,
      colorValue: n
    } = S(this, zee), s = be(this, Bb, document.createElement("input"));
    return s.type = "color", s.value = n || "#000000", s.className = "basicColorPicker", s.tabIndex = 0, s.setAttribute("data-l10n-id", S(iB, jee)[t]), s.addEventListener("input", () => {
      S(this, Ej).updateParams(i, s.value);
    }, {
      signal: S(this, Ej)._signal
    }), s;
  }
  update(t) {
    S(this, Bb) && (S(this, Bb).value = t);
  }
  destroy() {
    var t;
    (t = S(this, Bb)) == null || t.remove(), be(this, Bb, null);
  }
  hideDropdown() {
  }
};
Bb = new WeakMap(), zee = new WeakMap(), Ej = new WeakMap(), jee = new WeakMap(), xe(iB, jee, null);
let lle = iB;
function Xye(e) {
  return Math.floor(Math.max(0, Math.min(1, e)) * 255).toString(16).padStart(2, "0");
}
function yZ(e) {
  return Math.max(0, Math.min(255, 255 * e));
}
class eEe {
  static CMYK_G([t, i, n, s]) {
    return ["G", 1 - Math.min(1, 0.3 * t + 0.59 * n + 0.11 * i + s)];
  }
  static G_CMYK([t]) {
    return ["CMYK", 0, 0, 0, 1 - t];
  }
  static G_RGB([t]) {
    return ["RGB", t, t, t];
  }
  static G_rgb([t]) {
    return t = yZ(t), [t, t, t];
  }
  static G_HTML([t]) {
    const i = Xye(t);
    return `#${i}${i}${i}`;
  }
  static RGB_G([t, i, n]) {
    return ["G", 0.3 * t + 0.59 * i + 0.11 * n];
  }
  static RGB_rgb(t) {
    return t.map(yZ);
  }
  static RGB_HTML(t) {
    return `#${t.map(Xye).join("")}`;
  }
  static T_HTML() {
    return "#00000000";
  }
  static T_rgb() {
    return [null];
  }
  static CMYK_RGB([t, i, n, s]) {
    return ["RGB", 1 - Math.min(1, t + s), 1 - Math.min(1, n + s), 1 - Math.min(1, i + s)];
  }
  static CMYK_rgb([t, i, n, s]) {
    return [yZ(1 - Math.min(1, t + s)), yZ(1 - Math.min(1, n + s)), yZ(1 - Math.min(1, i + s))];
  }
  static CMYK_HTML(t) {
    const i = this.CMYK_RGB(t).slice(1);
    return this.RGB_HTML(i);
  }
  static RGB_CMYK([t, i, n]) {
    const s = 1 - t, o = 1 - i, r = 1 - n, l = Math.min(s, o, r);
    return ["CMYK", s, o, r, l];
  }
}
class _xe {
  create(t, i, n = !1) {
    if (t <= 0 || i <= 0)
      throw new Error("Invalid SVG dimensions");
    const s = this._createSVG("svg:svg");
    return s.setAttribute("version", "1.1"), n || (s.setAttribute("width", `${t}px`), s.setAttribute("height", `${i}px`)), s.setAttribute("preserveAspectRatio", "none"), s.setAttribute("viewBox", `0 0 ${t} ${i}`), s;
  }
  createElement(t) {
    if (typeof t != "string")
      throw new Error("Invalid SVG element type");
    return this._createSVG(t);
  }
  _createSVG(t) {
    Ll("Abstract method `_createSVG` called.");
  }
}
let ale = class extends _xe {
  _createSVG(t) {
    return document.createElementNS(kD, t);
  }
}, sRe = class {
  static setupStorage(t, i, n, s, o) {
    const r = s.getValue(i, {
      value: null
    });
    switch (n.name) {
      case "textarea":
        if (r.value !== null && (t.textContent = r.value), o === "print")
          break;
        t.addEventListener("input", (l) => {
          s.setValue(i, {
            value: l.target.value
          });
        });
        break;
      case "input":
        if (n.attributes.type === "radio" || n.attributes.type === "checkbox") {
          if (r.value === n.attributes.xfaOn ? t.setAttribute("checked", !0) : r.value === n.attributes.xfaOff && t.removeAttribute("checked"), o === "print")
            break;
          t.addEventListener("change", (l) => {
            s.setValue(i, {
              value: l.target.checked ? l.target.getAttribute("xfaOn") : l.target.getAttribute("xfaOff")
            });
          });
        } else {
          if (r.value !== null && t.setAttribute("value", r.value), o === "print")
            break;
          t.addEventListener("input", (l) => {
            s.setValue(i, {
              value: l.target.value
            });
          });
        }
        break;
      case "select":
        if (r.value !== null) {
          t.setAttribute("value", r.value);
          for (const l of n.children)
            l.attributes.value === r.value ? l.attributes.selected = !0 : l.attributes.hasOwnProperty("selected") && delete l.attributes.selected;
        }
        t.addEventListener("input", (l) => {
          const c = l.target.options, h = c.selectedIndex === -1 ? "" : c[c.selectedIndex].value;
          s.setValue(i, {
            value: h
          });
        });
        break;
    }
  }
  static setAttributes({
    html: t,
    element: i,
    storage: n = null,
    intent: s,
    linkService: o
  }) {
    const {
      attributes: r
    } = i, l = t instanceof HTMLAnchorElement;
    r.type === "radio" && (r.name = `${r.name}-${s}`);
    for (const [c, h] of Object.entries(r))
      if (h != null)
        switch (c) {
          case "class":
            h.length && t.setAttribute(c, h.join(" "));
            break;
          case "dataId":
            break;
          case "id":
            t.setAttribute("data-element-id", h);
            break;
          case "style":
            Object.assign(t.style, h);
            break;
          case "textContent":
            t.textContent = h;
            break;
          default:
            (!l || c !== "href" && c !== "newWindow") && t.setAttribute(c, h);
        }
    l && o.addLinkAttributes(t, r.href, r.newWindow), n && r.dataId && this.setupStorage(t, r.dataId, i, n);
  }
  static render(t) {
    var p, y;
    const i = t.annotationStorage, n = t.linkService, s = t.xfaHtml, o = t.intent || "display", r = document.createElement(s.name);
    s.attributes && this.setAttributes({
      html: r,
      element: s,
      intent: o,
      linkService: n
    });
    const l = o !== "richText", c = t.div;
    if (c.append(r), t.viewport) {
      const m = `matrix(${t.viewport.transform.join(",")})`;
      c.style.transform = m;
    }
    l && c.setAttribute("class", "xfaLayer xfaFont");
    const h = [];
    if (s.children.length === 0) {
      if (s.value) {
        const m = document.createTextNode(s.value);
        r.append(m), l && dX.shouldBuildText(s.name) && h.push(m);
      }
      return {
        textDivs: h
      };
    }
    const I = [[s, -1, r]];
    for (; I.length > 0; ) {
      const [m, A, C] = I.at(-1);
      if (A + 1 === m.children.length) {
        I.pop();
        continue;
      }
      const O = m.children[++I.at(-1)[1]];
      if (O === null)
        continue;
      const {
        name: R
      } = O;
      if (R === "#text") {
        const L = document.createTextNode(O.value);
        h.push(L), C.append(L);
        continue;
      }
      const F = (p = O == null ? void 0 : O.attributes) != null && p.xmlns ? document.createElementNS(O.attributes.xmlns, R) : document.createElement(R);
      if (C.append(F), O.attributes && this.setAttributes({
        html: F,
        element: O,
        storage: i,
        intent: o,
        linkService: n
      }), ((y = O.children) == null ? void 0 : y.length) > 0)
        I.push([O, -1, F]);
      else if (O.value) {
        const L = document.createTextNode(O.value);
        l && dX.shouldBuildText(R) && h.push(L), F.append(L);
      }
    }
    for (const m of c.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea"))
      m.setAttribute("readOnly", !0);
    return {
      textDivs: h
    };
  }
  static update(t) {
    const i = `matrix(${t.viewport.transform.join(",")})`;
    t.div.style.transform = i, t.div.hidden = !1;
  }
};
const xxe = 9, QF = /* @__PURE__ */ new WeakSet(), Pxe = (/* @__PURE__ */ new Date()).getTimezoneOffset() * 60 * 1e3;
class tEe {
  static create(t) {
    switch (t.data.annotationType) {
      case O0.LINK:
        return new Lpe(t);
      case O0.TEXT:
        return new Mxe(t);
      case O0.WIDGET:
        switch (t.data.fieldType) {
          case "Tx":
            return new Uxe(t);
          case "Btn":
            return t.data.radioButton ? new lRe(t) : t.data.checkBox ? new Fxe(t) : new Hxe(t);
          case "Ch":
            return new Gxe(t);
          case "Sig":
            return new Bxe(t);
        }
        return new OH(t);
      case O0.POPUP:
        return new jhe(t);
      case O0.FREETEXT:
        return new hRe(t);
      case O0.LINE:
        return new Vxe(t);
      case O0.SQUARE:
        return new zxe(t);
      case O0.CIRCLE:
        return new jxe(t);
      case O0.POLYLINE:
        return new fRe(t);
      case O0.CARET:
        return new Yxe(t);
      case O0.INK:
        return new _pe(t);
      case O0.POLYGON:
        return new Wxe(t);
      case O0.HIGHLIGHT:
        return new IRe(t);
      case O0.UNDERLINE:
        return new qxe(t);
      case O0.SQUIGGLY:
        return new $xe(t);
      case O0.STRIKEOUT:
        return new Kxe(t);
      case O0.STAMP:
        return new pRe(t);
      case O0.FILEATTACHMENT:
        return new Zxe(t);
      default:
        return new h0(t);
    }
  }
}
var $B, gj, KC, Wee, zhe;
const m3e = class m3e {
  constructor(t, {
    isRenderable: i = !1,
    ignoreBorder: n = !1,
    createQuadrilaterals: s = !1
  } = {}) {
    xe(this, Wee);
    xe(this, $B, null);
    xe(this, gj, !1);
    xe(this, KC, null);
    this.isRenderable = i, this.data = t.data, this.layer = t.layer, this.linkService = t.linkService, this.downloadManager = t.downloadManager, this.imageResourcesPath = t.imageResourcesPath, this.renderForms = t.renderForms, this.svgFactory = t.svgFactory, this.annotationStorage = t.annotationStorage, this.enableScripting = t.enableScripting, this.hasJSActions = t.hasJSActions, this._fieldObjects = t.fieldObjects, this.parent = t.parent, i && (this.container = this._createContainer(n)), s && this._createQuadrilaterals();
  }
  static _hasPopupData({
    contentsObj: t,
    richText: i
  }) {
    return !!(t != null && t.str || i != null && i.str);
  }
  get _isEditable() {
    return this.data.isEditable;
  }
  get hasPopupData() {
    return m3e._hasPopupData(this.data);
  }
  updateEdited(t) {
    var o;
    if (!this.container)
      return;
    t.rect && (S(this, $B) || be(this, $B, {
      rect: this.data.rect.slice(0)
    }));
    const {
      rect: i,
      popup: n
    } = t;
    i && _e(this, Wee, zhe).call(this, i);
    let s = ((o = S(this, KC)) == null ? void 0 : o.popup) || this.popup;
    !s && (n != null && n.text) && (this._createPopup(n), s = S(this, KC).popup), s && (s.updateEdited(t), n != null && n.deleted && (s.remove(), be(this, KC, null), this.popup = null));
  }
  resetEdited() {
    var t;
    S(this, $B) && (_e(this, Wee, zhe).call(this, S(this, $B).rect), (t = S(this, KC)) == null || t.popup.resetEdited(), be(this, $B, null));
  }
  _createContainer(t) {
    const {
      data: i,
      parent: {
        page: n,
        viewport: s
      }
    } = this, o = document.createElement("section");
    o.setAttribute("data-annotation-id", i.id), !(this instanceof OH) && !(this instanceof Lpe) && (o.tabIndex = 0);
    const {
      style: r
    } = o;
    if (r.zIndex = this.parent.zIndex++, i.alternativeText && (o.title = i.alternativeText), i.noRotate && o.classList.add("norotate"), !i.rect || this instanceof jhe) {
      const {
        rotation: C
      } = i;
      return !i.hasOwnCanvas && C !== 0 && this.setRotation(C, o), o;
    }
    const {
      width: l,
      height: c
    } = this;
    if (!t && i.borderStyle.width > 0) {
      r.borderWidth = `${i.borderStyle.width}px`;
      const C = i.borderStyle.horizontalCornerRadius, O = i.borderStyle.verticalCornerRadius;
      if (C > 0 || O > 0) {
        const F = `calc(${C}px * var(--total-scale-factor)) / calc(${O}px * var(--total-scale-factor))`;
        r.borderRadius = F;
      } else if (this instanceof lRe) {
        const F = `calc(${l}px * var(--total-scale-factor)) / calc(${c}px * var(--total-scale-factor))`;
        r.borderRadius = F;
      }
      switch (i.borderStyle.style) {
        case yV.SOLID:
          r.borderStyle = "solid";
          break;
        case yV.DASHED:
          r.borderStyle = "dashed";
          break;
        case yV.BEVELED:
          to("Unimplemented border style: beveled");
          break;
        case yV.INSET:
          to("Unimplemented border style: inset");
          break;
        case yV.UNDERLINE:
          r.borderBottomStyle = "solid";
          break;
      }
      const R = i.borderColor || null;
      R ? (be(this, gj, !0), r.borderColor = ys.makeHexColor(R[0] | 0, R[1] | 0, R[2] | 0)) : r.borderWidth = 0;
    }
    const h = ys.normalizeRect([i.rect[0], n.view[3] - i.rect[1] + n.view[1], i.rect[2], n.view[3] - i.rect[3] + n.view[1]]), {
      pageWidth: I,
      pageHeight: p,
      pageX: y,
      pageY: m
    } = s.rawDims;
    r.left = `${100 * (h[0] - y) / I}%`, r.top = `${100 * (h[1] - m) / p}%`;
    const {
      rotation: A
    } = i;
    return i.hasOwnCanvas || A === 0 ? (r.width = `${100 * l / I}%`, r.height = `${100 * c / p}%`) : this.setRotation(A, o), o;
  }
  setRotation(t, i = this.container) {
    if (!this.data.rect)
      return;
    const {
      pageWidth: n,
      pageHeight: s
    } = this.parent.viewport.rawDims;
    let {
      width: o,
      height: r
    } = this;
    t % 180 !== 0 && ([o, r] = [r, o]), i.style.width = `${100 * o / n}%`, i.style.height = `${100 * r / s}%`, i.setAttribute("data-main-rotation", (360 - t) % 360);
  }
  get _commonActions() {
    const t = (i, n, s) => {
      const o = s.detail[i], r = o[0], l = o.slice(1);
      s.target.style[n] = eEe[`${r}_HTML`](l), this.annotationStorage.setValue(this.data.id, {
        [n]: eEe[`${r}_rgb`](l)
      });
    };
    return Zo(this, "_commonActions", {
      display: (i) => {
        const {
          display: n
        } = i.detail, s = n % 2 === 1;
        this.container.style.visibility = s ? "hidden" : "visible", this.annotationStorage.setValue(this.data.id, {
          noView: s,
          noPrint: n === 1 || n === 2
        });
      },
      print: (i) => {
        this.annotationStorage.setValue(this.data.id, {
          noPrint: !i.detail.print
        });
      },
      hidden: (i) => {
        const {
          hidden: n
        } = i.detail;
        this.container.style.visibility = n ? "hidden" : "visible", this.annotationStorage.setValue(this.data.id, {
          noPrint: n,
          noView: n
        });
      },
      focus: (i) => {
        setTimeout(() => i.target.focus({
          preventScroll: !1
        }), 0);
      },
      userName: (i) => {
        i.target.title = i.detail.userName;
      },
      readonly: (i) => {
        i.target.disabled = i.detail.readonly;
      },
      required: (i) => {
        this._setRequired(i.target, i.detail.required);
      },
      bgColor: (i) => {
        t("bgColor", "backgroundColor", i);
      },
      fillColor: (i) => {
        t("fillColor", "backgroundColor", i);
      },
      fgColor: (i) => {
        t("fgColor", "color", i);
      },
      textColor: (i) => {
        t("textColor", "color", i);
      },
      borderColor: (i) => {
        t("borderColor", "borderColor", i);
      },
      strokeColor: (i) => {
        t("strokeColor", "borderColor", i);
      },
      rotation: (i) => {
        const n = i.detail.rotation;
        this.setRotation(n), this.annotationStorage.setValue(this.data.id, {
          rotation: n
        });
      }
    });
  }
  _dispatchEventFromSandbox(t, i) {
    const n = this._commonActions;
    for (const s of Object.keys(i.detail)) {
      const o = t[s] || n[s];
      o == null || o(i);
    }
  }
  _setDefaultPropertiesFromJS(t) {
    if (!this.enableScripting)
      return;
    const i = this.annotationStorage.getRawValue(this.data.id);
    if (!i)
      return;
    const n = this._commonActions;
    for (const [s, o] of Object.entries(i)) {
      const r = n[s];
      if (r) {
        const l = {
          detail: {
            [s]: o
          },
          target: t
        };
        r(l), delete i[s];
      }
    }
  }
  _createQuadrilaterals() {
    if (!this.container)
      return;
    const {
      quadPoints: t
    } = this.data;
    if (!t)
      return;
    const [i, n, s, o] = this.data.rect.map((C) => Math.fround(C));
    if (t.length === 8) {
      const [C, O, R, F] = t.subarray(2, 6);
      if (s === C && o === O && i === R && n === F)
        return;
    }
    const {
      style: r
    } = this.container;
    let l;
    if (S(this, gj)) {
      const {
        borderColor: C,
        borderWidth: O
      } = r;
      r.borderWidth = 0, l = ["url('data:image/svg+xml;utf8,", '<svg xmlns="http://www.w3.org/2000/svg"', ' preserveAspectRatio="none" viewBox="0 0 1 1">', `<g fill="transparent" stroke="${C}" stroke-width="${O}">`], this.container.classList.add("hasBorder");
    }
    const c = s - i, h = o - n, {
      svgFactory: I
    } = this, p = I.createElement("svg");
    p.classList.add("quadrilateralsContainer"), p.setAttribute("width", 0), p.setAttribute("height", 0), p.role = "none";
    const y = I.createElement("defs");
    p.append(y);
    const m = I.createElement("clipPath"), A = `clippath_${this.data.id}`;
    m.setAttribute("id", A), m.setAttribute("clipPathUnits", "objectBoundingBox"), y.append(m);
    for (let C = 2, O = t.length; C < O; C += 8) {
      const R = t[C], F = t[C + 1], L = t[C + 2], P = t[C + 3], z = I.createElement("rect"), W = (L - i) / c, re = (o - F) / h, ce = (R - L) / c, te = (F - P) / h;
      z.setAttribute("x", W), z.setAttribute("y", re), z.setAttribute("width", ce), z.setAttribute("height", te), m.append(z), l == null || l.push(`<rect vector-effect="non-scaling-stroke" x="${W}" y="${re}" width="${ce}" height="${te}"/>`);
    }
    S(this, gj) && (l.push("</g></svg>')"), r.backgroundImage = l.join("")), this.container.append(p), this.container.style.clipPath = `url(#${A})`;
  }
  _createPopup(t = null) {
    const {
      data: i
    } = this;
    let n, s;
    t ? (n = {
      str: t.text
    }, s = t.date) : (n = i.contentsObj, s = i.modificationDate);
    const o = be(this, KC, new jhe({
      data: {
        color: i.color,
        titleObj: i.titleObj,
        modificationDate: s,
        contentsObj: n,
        richText: i.richText,
        parentRect: i.rect,
        borderStyle: 0,
        id: `popup_${i.id}`,
        rotation: i.rotation,
        noRotate: !0
      },
      linkService: this.linkService,
      parent: this.parent,
      elements: [this]
    }));
    this.parent.div.append(o.render());
  }
  get hasPopupElement() {
    return !!(S(this, KC) || this.popup || this.data.popupRef);
  }
  render() {
    Ll("Abstract method `AnnotationElement.render` called");
  }
  _getElementsByName(t, i = null) {
    const n = [];
    if (this._fieldObjects) {
      const s = this._fieldObjects[t];
      if (s)
        for (const {
          page: o,
          id: r,
          exportValues: l
        } of s) {
          if (o === -1 || r === i)
            continue;
          const c = typeof l == "string" ? l : null, h = document.querySelector(`[data-element-id="${r}"]`);
          if (h && !QF.has(h)) {
            to(`_getElementsByName - element not allowed: ${r}`);
            continue;
          }
          n.push({
            id: r,
            exportValue: c,
            domElement: h
          });
        }
      return n;
    }
    for (const s of document.getElementsByName(t)) {
      const {
        exportValue: o
      } = s, r = s.getAttribute("data-element-id");
      r !== i && QF.has(s) && n.push({
        id: r,
        exportValue: o,
        domElement: s
      });
    }
    return n;
  }
  show() {
    var t;
    this.container && (this.container.hidden = !1), (t = this.popup) == null || t.maybeShow();
  }
  hide() {
    var t;
    this.container && (this.container.hidden = !0), (t = this.popup) == null || t.forceHide();
  }
  getElementsToTriggerPopup() {
    return this.container;
  }
  addHighlightArea() {
    const t = this.getElementsToTriggerPopup();
    if (Array.isArray(t))
      for (const i of t)
        i.classList.add("highlightArea");
    else
      t.classList.add("highlightArea");
  }
  _editOnDoubleClick() {
    if (!this._isEditable)
      return;
    const {
      annotationEditorType: t,
      data: {
        id: i
      }
    } = this;
    this.container.addEventListener("dblclick", () => {
      var n;
      (n = this.linkService.eventBus) == null || n.dispatch("switchannotationeditormode", {
        source: this,
        mode: t,
        editId: i,
        mustEnterInEditMode: !0
      });
    });
  }
  get width() {
    return this.data.rect[2] - this.data.rect[0];
  }
  get height() {
    return this.data.rect[3] - this.data.rect[1];
  }
};
$B = new WeakMap(), gj = new WeakMap(), KC = new WeakMap(), Wee = new WeakSet(), zhe = function(t) {
  const {
    container: {
      style: i
    },
    data: {
      rect: n,
      rotation: s
    },
    parent: {
      viewport: {
        rawDims: {
          pageWidth: o,
          pageHeight: r,
          pageX: l,
          pageY: c
        }
      }
    }
  } = this;
  n == null || n.splice(0, 4, ...t), i.left = `${100 * (t[0] - l) / o}%`, i.top = `${100 * (r - t[3] + c) / r}%`, s === 0 ? (i.width = `${100 * (t[2] - t[0]) / o}%`, i.height = `${100 * (t[3] - t[1]) / r}%`) : this.setRotation(s);
};
let h0 = m3e;
var G2, lU, oRe, rRe;
class Lpe extends h0 {
  constructor(i, n = null) {
    super(i, {
      isRenderable: !0,
      ignoreBorder: !!(n != null && n.ignoreBorder),
      createQuadrilaterals: !0
    });
    xe(this, G2);
    this.isTooltipOnly = i.data.isTooltipOnly;
  }
  render() {
    const {
      data: i,
      linkService: n
    } = this, s = document.createElement("a");
    s.setAttribute("data-element-id", i.id);
    let o = !1;
    return i.url ? (n.addLinkAttributes(s, i.url, i.newWindow), o = !0) : i.action ? (this._bindNamedAction(s, i.action, i.overlaidText), o = !0) : i.attachment ? (_e(this, G2, oRe).call(this, s, i.attachment, i.overlaidText, i.attachmentDest), o = !0) : i.setOCGState ? (_e(this, G2, rRe).call(this, s, i.setOCGState, i.overlaidText), o = !0) : i.dest ? (this._bindLink(s, i.dest, i.overlaidText), o = !0) : (i.actions && (i.actions.Action || i.actions["Mouse Up"] || i.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions && (this._bindJSAction(s, i), o = !0), i.resetForm ? (this._bindResetFormAction(s, i.resetForm), o = !0) : this.isTooltipOnly && !o && (this._bindLink(s, ""), o = !0)), this.container.classList.add("linkAnnotation"), o && this.container.append(s), this.container;
  }
  _bindLink(i, n, s = "") {
    i.href = this.linkService.getDestinationHash(n), i.onclick = () => (n && this.linkService.goToDestination(n), !1), (n || n === "") && _e(this, G2, lU).call(this), s && (i.title = s);
  }
  _bindNamedAction(i, n, s = "") {
    i.href = this.linkService.getAnchorUrl(""), i.onclick = () => (this.linkService.executeNamedAction(n), !1), s && (i.title = s), _e(this, G2, lU).call(this);
  }
  _bindJSAction(i, n) {
    i.href = this.linkService.getAnchorUrl("");
    const s = /* @__PURE__ */ new Map([["Action", "onclick"], ["Mouse Up", "onmouseup"], ["Mouse Down", "onmousedown"]]);
    for (const o of Object.keys(n.actions)) {
      const r = s.get(o);
      r && (i[r] = () => {
        var l;
        return (l = this.linkService.eventBus) == null || l.dispatch("dispatcheventinsandbox", {
          source: this,
          detail: {
            id: n.id,
            name: o
          }
        }), !1;
      });
    }
    n.overlaidText && (i.title = n.overlaidText), i.onclick || (i.onclick = () => !1), _e(this, G2, lU).call(this);
  }
  _bindResetFormAction(i, n) {
    const s = i.onclick;
    if (s || (i.href = this.linkService.getAnchorUrl("")), _e(this, G2, lU).call(this), !this._fieldObjects) {
      to('_bindResetFormAction - "resetForm" action not supported, ensure that the `fieldObjects` parameter is provided.'), s || (i.onclick = () => !1);
      return;
    }
    i.onclick = () => {
      var p;
      s == null || s();
      const {
        fields: o,
        refs: r,
        include: l
      } = n, c = [];
      if (o.length !== 0 || r.length !== 0) {
        const y = new Set(r);
        for (const m of o) {
          const A = this._fieldObjects[m] || [];
          for (const {
            id: C
          } of A)
            y.add(C);
        }
        for (const m of Object.values(this._fieldObjects))
          for (const A of m)
            y.has(A.id) === l && c.push(A);
      } else
        for (const y of Object.values(this._fieldObjects))
          c.push(...y);
      const h = this.annotationStorage, I = [];
      for (const y of c) {
        const {
          id: m
        } = y;
        switch (I.push(m), y.type) {
          case "text": {
            const C = y.defaultValue || "";
            h.setValue(m, {
              value: C
            });
            break;
          }
          case "checkbox":
          case "radiobutton": {
            const C = y.defaultValue === y.exportValues;
            h.setValue(m, {
              value: C
            });
            break;
          }
          case "combobox":
          case "listbox": {
            const C = y.defaultValue || "";
            h.setValue(m, {
              value: C
            });
            break;
          }
          default:
            continue;
        }
        const A = document.querySelector(`[data-element-id="${m}"]`);
        if (A) {
          if (!QF.has(A)) {
            to(`_bindResetFormAction - element not allowed: ${m}`);
            continue;
          }
        } else continue;
        A.dispatchEvent(new Event("resetform"));
      }
      return this.enableScripting && ((p = this.linkService.eventBus) == null || p.dispatch("dispatcheventinsandbox", {
        source: this,
        detail: {
          id: "app",
          ids: I,
          name: "ResetForm"
        }
      })), !1;
    };
  }
}
G2 = new WeakSet(), lU = function() {
  this.container.setAttribute("data-internal-link", "");
}, oRe = function(i, n, s = "", o = null) {
  i.href = this.linkService.getAnchorUrl(""), n.description ? i.title = n.description : s && (i.title = s), i.onclick = () => {
    var r;
    return (r = this.downloadManager) == null || r.openOrDownloadData(n.content, n.filename, o), !1;
  }, _e(this, G2, lU).call(this);
}, rRe = function(i, n, s = "") {
  i.href = this.linkService.getAnchorUrl(""), i.onclick = () => (this.linkService.executeSetOCGState(n), !1), s && (i.title = s), _e(this, G2, lU).call(this);
};
class Mxe extends h0 {
  constructor(t) {
    super(t, {
      isRenderable: !0
    });
  }
  render() {
    this.container.classList.add("textAnnotation");
    const t = document.createElement("img");
    return t.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg", t.setAttribute("data-l10n-id", "pdfjs-text-annotation-type"), t.setAttribute("data-l10n-args", JSON.stringify({
      type: this.data.name
    })), !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container.append(t), this.container;
  }
}
class OH extends h0 {
  render() {
    return this.container;
  }
  showElementAndHideCanvas(t) {
    var i;
    this.data.hasOwnCanvas && (((i = t.previousSibling) == null ? void 0 : i.nodeName) === "CANVAS" && (t.previousSibling.hidden = !0), t.hidden = !1);
  }
  _getKeyModifier(t) {
    return Qp.platform.isMac ? t.metaKey : t.ctrlKey;
  }
  _setEventListener(t, i, n, s, o) {
    n.includes("mouse") ? t.addEventListener(n, (r) => {
      var l;
      (l = this.linkService.eventBus) == null || l.dispatch("dispatcheventinsandbox", {
        source: this,
        detail: {
          id: this.data.id,
          name: s,
          value: o(r),
          shift: r.shiftKey,
          modifier: this._getKeyModifier(r)
        }
      });
    }) : t.addEventListener(n, (r) => {
      var l;
      if (n === "blur") {
        if (!i.focused || !r.relatedTarget)
          return;
        i.focused = !1;
      } else if (n === "focus") {
        if (i.focused)
          return;
        i.focused = !0;
      }
      o && ((l = this.linkService.eventBus) == null || l.dispatch("dispatcheventinsandbox", {
        source: this,
        detail: {
          id: this.data.id,
          name: s,
          value: o(r)
        }
      }));
    });
  }
  _setEventListeners(t, i, n, s) {
    var o, r, l;
    for (const [c, h] of n)
      (h === "Action" || (o = this.data.actions) != null && o[h]) && ((h === "Focus" || h === "Blur") && (i || (i = {
        focused: !1
      })), this._setEventListener(t, i, c, h, s), h === "Focus" && !((r = this.data.actions) != null && r.Blur) ? this._setEventListener(t, i, "blur", "Blur", null) : h === "Blur" && !((l = this.data.actions) != null && l.Focus) && this._setEventListener(t, i, "focus", "Focus", null));
  }
  _setBackgroundColor(t) {
    const i = this.data.backgroundColor || null;
    t.style.backgroundColor = i === null ? "transparent" : ys.makeHexColor(i[0], i[1], i[2]);
  }
  _setTextStyle(t) {
    const i = ["left", "center", "right"], {
      fontColor: n
    } = this.data.defaultAppearanceData, s = this.data.defaultAppearanceData.fontSize || xxe, o = t.style;
    let r;
    const l = 2, c = (h) => Math.round(10 * h) / 10;
    if (this.data.multiLine) {
      const h = Math.abs(this.data.rect[3] - this.data.rect[1] - l), I = Math.round(h / (ide * s)) || 1, p = h / I;
      r = Math.min(s, c(p / ide));
    } else {
      const h = Math.abs(this.data.rect[3] - this.data.rect[1] - l);
      r = Math.min(s, c(h / ide));
    }
    o.fontSize = `calc(${r}px * var(--total-scale-factor))`, o.color = ys.makeHexColor(n[0], n[1], n[2]), this.data.textAlignment !== null && (o.textAlign = i[this.data.textAlignment]);
  }
  _setRequired(t, i) {
    i ? t.setAttribute("required", !0) : t.removeAttribute("required"), t.setAttribute("aria-required", i);
  }
}
class Uxe extends OH {
  constructor(t) {
    const i = t.renderForms || t.data.hasOwnCanvas || !t.data.hasAppearance && !!t.data.fieldValue;
    super(t, {
      isRenderable: i
    });
  }
  setPropertyOnSiblings(t, i, n, s) {
    const o = this.annotationStorage;
    for (const r of this._getElementsByName(t.name, t.id))
      r.domElement && (r.domElement[i] = n), o.setValue(r.id, {
        [s]: n
      });
  }
  render() {
    var s, o;
    const t = this.annotationStorage, i = this.data.id;
    this.container.classList.add("textWidgetAnnotation");
    let n = null;
    if (this.renderForms) {
      const r = t.getValue(i, {
        value: this.data.fieldValue
      });
      let l = r.value || "";
      const c = t.getValue(i, {
        charLimit: this.data.maxLen
      }).charLimit;
      c && l.length > c && (l = l.slice(0, c));
      let h = r.formattedValue || ((s = this.data.textContent) == null ? void 0 : s.join(`
`)) || null;
      h && this.data.comb && (h = h.replaceAll(/\s+/g, ""));
      const I = {
        userValue: l,
        formattedValue: h,
        lastCommittedValue: null,
        commitKey: 1,
        focused: !1
      };
      this.data.multiLine ? (n = document.createElement("textarea"), n.textContent = h ?? l, this.data.doNotScroll && (n.style.overflowY = "hidden")) : (n = document.createElement("input"), n.type = this.data.password ? "password" : "text", n.setAttribute("value", h ?? l), this.data.doNotScroll && (n.style.overflowX = "hidden")), this.data.hasOwnCanvas && (n.hidden = !0), QF.add(n), n.setAttribute("data-element-id", i), n.disabled = this.data.readOnly, n.name = this.data.fieldName, n.tabIndex = 0;
      const {
        datetimeFormat: p,
        datetimeType: y,
        timeStep: m
      } = this.data, A = !!y && this.enableScripting;
      p && (n.title = p), this._setRequired(n, this.data.required), c && (n.maxLength = c), n.addEventListener("input", (O) => {
        t.setValue(i, {
          value: O.target.value
        }), this.setPropertyOnSiblings(n, "value", O.target.value, "value"), I.formattedValue = null;
      }), n.addEventListener("resetform", (O) => {
        const R = this.data.defaultFieldValue ?? "";
        n.value = I.userValue = R, I.formattedValue = null;
      });
      let C = (O) => {
        const {
          formattedValue: R
        } = I;
        R != null && (O.target.value = R), O.target.scrollLeft = 0;
      };
      if (this.enableScripting && this.hasJSActions) {
        n.addEventListener("focus", (R) => {
          var L;
          if (I.focused)
            return;
          const {
            target: F
          } = R;
          if (A && (F.type = y, m && (F.step = m)), I.userValue) {
            const P = I.userValue;
            if (A)
              if (y === "time") {
                const z = new Date(P), W = [z.getHours(), z.getMinutes(), z.getSeconds()];
                F.value = W.map((re) => re.toString().padStart(2, "0")).join(":");
              } else
                F.value = new Date(P - Pxe).toISOString().split(y === "date" ? "T" : ".", 1)[0];
            else
              F.value = P;
          }
          I.lastCommittedValue = F.value, I.commitKey = 1, (L = this.data.actions) != null && L.Focus || (I.focused = !0);
        }), n.addEventListener("updatefromsandbox", (R) => {
          this.showElementAndHideCanvas(R.target);
          const F = {
            value(L) {
              I.userValue = L.detail.value ?? "", A || t.setValue(i, {
                value: I.userValue.toString()
              }), L.target.value = I.userValue;
            },
            formattedValue(L) {
              const {
                formattedValue: P
              } = L.detail;
              I.formattedValue = P, P != null && L.target !== document.activeElement && (L.target.value = P);
              const z = {
                formattedValue: P
              };
              A && (z.value = P), t.setValue(i, z);
            },
            selRange(L) {
              L.target.setSelectionRange(...L.detail.selRange);
            },
            charLimit: (L) => {
              var re;
              const {
                charLimit: P
              } = L.detail, {
                target: z
              } = L;
              if (P === 0) {
                z.removeAttribute("maxLength");
                return;
              }
              z.setAttribute("maxLength", P);
              let W = I.userValue;
              !W || W.length <= P || (W = W.slice(0, P), z.value = I.userValue = W, t.setValue(i, {
                value: W
              }), (re = this.linkService.eventBus) == null || re.dispatch("dispatcheventinsandbox", {
                source: this,
                detail: {
                  id: i,
                  name: "Keystroke",
                  value: W,
                  willCommit: !0,
                  commitKey: 1,
                  selStart: z.selectionStart,
                  selEnd: z.selectionEnd
                }
              }));
            }
          };
          this._dispatchEventFromSandbox(F, R);
        }), n.addEventListener("keydown", (R) => {
          var P;
          I.commitKey = 1;
          let F = -1;
          if (R.key === "Escape" ? F = 0 : R.key === "Enter" && !this.data.multiLine ? F = 2 : R.key === "Tab" && (I.commitKey = 3), F === -1)
            return;
          const {
            value: L
          } = R.target;
          I.lastCommittedValue !== L && (I.lastCommittedValue = L, I.userValue = L, (P = this.linkService.eventBus) == null || P.dispatch("dispatcheventinsandbox", {
            source: this,
            detail: {
              id: i,
              name: "Keystroke",
              value: L,
              willCommit: !0,
              commitKey: F,
              selStart: R.target.selectionStart,
              selEnd: R.target.selectionEnd
            }
          }));
        });
        const O = C;
        C = null, n.addEventListener("blur", (R) => {
          var P, z;
          if (!I.focused || !R.relatedTarget)
            return;
          (P = this.data.actions) != null && P.Blur || (I.focused = !1);
          const {
            target: F
          } = R;
          let {
            value: L
          } = F;
          if (A) {
            if (L && y === "time") {
              const W = L.split(":").map((re) => parseInt(re, 10));
              L = new Date(2e3, 0, 1, W[0], W[1], W[2] || 0).valueOf(), F.step = "";
            } else
              L = new Date(L).valueOf();
            F.type = "text";
          }
          I.userValue = L, I.lastCommittedValue !== L && ((z = this.linkService.eventBus) == null || z.dispatch("dispatcheventinsandbox", {
            source: this,
            detail: {
              id: i,
              name: "Keystroke",
              value: L,
              willCommit: !0,
              commitKey: I.commitKey,
              selStart: R.target.selectionStart,
              selEnd: R.target.selectionEnd
            }
          })), O(R);
        }), (o = this.data.actions) != null && o.Keystroke && n.addEventListener("beforeinput", (R) => {
          var te;
          I.lastCommittedValue = null;
          const {
            data: F,
            target: L
          } = R, {
            value: P,
            selectionStart: z,
            selectionEnd: W
          } = L;
          let re = z, ce = W;
          switch (R.inputType) {
            case "deleteWordBackward": {
              const ee = P.substring(0, z).match(/\w*[^\w]*$/);
              ee && (re -= ee[0].length);
              break;
            }
            case "deleteWordForward": {
              const ee = P.substring(z).match(/^[^\w]*\w*/);
              ee && (ce += ee[0].length);
              break;
            }
            case "deleteContentBackward":
              z === W && (re -= 1);
              break;
            case "deleteContentForward":
              z === W && (ce += 1);
              break;
          }
          R.preventDefault(), (te = this.linkService.eventBus) == null || te.dispatch("dispatcheventinsandbox", {
            source: this,
            detail: {
              id: i,
              name: "Keystroke",
              value: P,
              change: F || "",
              willCommit: !1,
              selStart: re,
              selEnd: ce
            }
          });
        }), this._setEventListeners(n, I, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (R) => R.target.value);
      }
      if (C && n.addEventListener("blur", C), this.data.comb) {
        const R = (this.data.rect[2] - this.data.rect[0]) / c;
        n.classList.add("comb"), n.style.letterSpacing = `calc(${R}px * var(--total-scale-factor) - 1ch)`;
      }
    } else
      n = document.createElement("div"), n.textContent = this.data.fieldValue, n.style.verticalAlign = "middle", n.style.display = "table-cell", this.data.hasOwnCanvas && (n.hidden = !0);
    return this._setTextStyle(n), this._setBackgroundColor(n), this._setDefaultPropertiesFromJS(n), this.container.append(n), this.container;
  }
}
class Bxe extends OH {
  constructor(t) {
    super(t, {
      isRenderable: !!t.data.hasOwnCanvas
    });
  }
}
class Fxe extends OH {
  constructor(t) {
    super(t, {
      isRenderable: t.renderForms
    });
  }
  render() {
    const t = this.annotationStorage, i = this.data, n = i.id;
    let s = t.getValue(n, {
      value: i.exportValue === i.fieldValue
    }).value;
    typeof s == "string" && (s = s !== "Off", t.setValue(n, {
      value: s
    })), this.container.classList.add("buttonWidgetAnnotation", "checkBox");
    const o = document.createElement("input");
    return QF.add(o), o.setAttribute("data-element-id", n), o.disabled = i.readOnly, this._setRequired(o, this.data.required), o.type = "checkbox", o.name = i.fieldName, s && o.setAttribute("checked", !0), o.setAttribute("exportValue", i.exportValue), o.tabIndex = 0, o.addEventListener("change", (r) => {
      const {
        name: l,
        checked: c
      } = r.target;
      for (const h of this._getElementsByName(l, n)) {
        const I = c && h.exportValue === i.exportValue;
        h.domElement && (h.domElement.checked = I), t.setValue(h.id, {
          value: I
        });
      }
      t.setValue(n, {
        value: c
      });
    }), o.addEventListener("resetform", (r) => {
      const l = i.defaultFieldValue || "Off";
      r.target.checked = l === i.exportValue;
    }), this.enableScripting && this.hasJSActions && (o.addEventListener("updatefromsandbox", (r) => {
      const l = {
        value(c) {
          c.target.checked = c.detail.value !== "Off", t.setValue(n, {
            value: c.target.checked
          });
        }
      };
      this._dispatchEventFromSandbox(l, r);
    }), this._setEventListeners(o, null, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (r) => r.target.checked)), this._setBackgroundColor(o), this._setDefaultPropertiesFromJS(o), this.container.append(o), this.container;
  }
}
class lRe extends OH {
  constructor(t) {
    super(t, {
      isRenderable: t.renderForms
    });
  }
  render() {
    this.container.classList.add("buttonWidgetAnnotation", "radioButton");
    const t = this.annotationStorage, i = this.data, n = i.id;
    let s = t.getValue(n, {
      value: i.fieldValue === i.buttonValue
    }).value;
    if (typeof s == "string" && (s = s !== i.buttonValue, t.setValue(n, {
      value: s
    })), s)
      for (const r of this._getElementsByName(i.fieldName, n))
        t.setValue(r.id, {
          value: !1
        });
    const o = document.createElement("input");
    if (QF.add(o), o.setAttribute("data-element-id", n), o.disabled = i.readOnly, this._setRequired(o, this.data.required), o.type = "radio", o.name = i.fieldName, s && o.setAttribute("checked", !0), o.tabIndex = 0, o.addEventListener("change", (r) => {
      const {
        name: l,
        checked: c
      } = r.target;
      for (const h of this._getElementsByName(l, n))
        t.setValue(h.id, {
          value: !1
        });
      t.setValue(n, {
        value: c
      });
    }), o.addEventListener("resetform", (r) => {
      const l = i.defaultFieldValue;
      r.target.checked = l != null && l === i.buttonValue;
    }), this.enableScripting && this.hasJSActions) {
      const r = i.buttonValue;
      o.addEventListener("updatefromsandbox", (l) => {
        const c = {
          value: (h) => {
            const I = r === h.detail.value;
            for (const p of this._getElementsByName(h.target.name)) {
              const y = I && p.id === n;
              p.domElement && (p.domElement.checked = y), t.setValue(p.id, {
                value: y
              });
            }
          }
        };
        this._dispatchEventFromSandbox(c, l);
      }), this._setEventListeners(o, null, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (l) => l.target.checked);
    }
    return this._setBackgroundColor(o), this._setDefaultPropertiesFromJS(o), this.container.append(o), this.container;
  }
}
class Hxe extends Lpe {
  constructor(t) {
    super(t, {
      ignoreBorder: t.data.hasAppearance
    });
  }
  render() {
    const t = super.render();
    t.classList.add("buttonWidgetAnnotation", "pushButton");
    const i = t.lastChild;
    return this.enableScripting && this.hasJSActions && i && (this._setDefaultPropertiesFromJS(i), i.addEventListener("updatefromsandbox", (n) => {
      this._dispatchEventFromSandbox({}, n);
    })), t;
  }
}
class Gxe extends OH {
  constructor(t) {
    super(t, {
      isRenderable: t.renderForms
    });
  }
  render() {
    this.container.classList.add("choiceWidgetAnnotation");
    const t = this.annotationStorage, i = this.data.id, n = t.getValue(i, {
      value: this.data.fieldValue
    }), s = document.createElement("select");
    QF.add(s), s.setAttribute("data-element-id", i), s.disabled = this.data.readOnly, this._setRequired(s, this.data.required), s.name = this.data.fieldName, s.tabIndex = 0;
    let o = this.data.combo && this.data.options.length > 0;
    this.data.combo || (s.size = this.data.options.length, this.data.multiSelect && (s.multiple = !0)), s.addEventListener("resetform", (I) => {
      const p = this.data.defaultFieldValue;
      for (const y of s.options)
        y.selected = y.value === p;
    });
    for (const I of this.data.options) {
      const p = document.createElement("option");
      p.textContent = I.displayValue, p.value = I.exportValue, n.value.includes(I.exportValue) && (p.setAttribute("selected", !0), o = !1), s.append(p);
    }
    let r = null;
    if (o) {
      const I = document.createElement("option");
      I.value = " ", I.setAttribute("hidden", !0), I.setAttribute("selected", !0), s.prepend(I), r = () => {
        I.remove(), s.removeEventListener("input", r), r = null;
      }, s.addEventListener("input", r);
    }
    const l = (I) => {
      const p = I ? "value" : "textContent", {
        options: y,
        multiple: m
      } = s;
      return m ? Array.prototype.filter.call(y, (A) => A.selected).map((A) => A[p]) : y.selectedIndex === -1 ? null : y[y.selectedIndex][p];
    };
    let c = l(!1);
    const h = (I) => {
      const p = I.target.options;
      return Array.prototype.map.call(p, (y) => ({
        displayValue: y.textContent,
        exportValue: y.value
      }));
    };
    return this.enableScripting && this.hasJSActions ? (s.addEventListener("updatefromsandbox", (I) => {
      const p = {
        value(y) {
          r == null || r();
          const m = y.detail.value, A = new Set(Array.isArray(m) ? m : [m]);
          for (const C of s.options)
            C.selected = A.has(C.value);
          t.setValue(i, {
            value: l(!0)
          }), c = l(!1);
        },
        multipleSelection(y) {
          s.multiple = !0;
        },
        remove(y) {
          const m = s.options, A = y.detail.remove;
          m[A].selected = !1, s.remove(A), m.length > 0 && Array.prototype.findIndex.call(m, (O) => O.selected) === -1 && (m[0].selected = !0), t.setValue(i, {
            value: l(!0),
            items: h(y)
          }), c = l(!1);
        },
        clear(y) {
          for (; s.length !== 0; )
            s.remove(0);
          t.setValue(i, {
            value: null,
            items: []
          }), c = l(!1);
        },
        insert(y) {
          const {
            index: m,
            displayValue: A,
            exportValue: C
          } = y.detail.insert, O = s.children[m], R = document.createElement("option");
          R.textContent = A, R.value = C, O ? O.before(R) : s.append(R), t.setValue(i, {
            value: l(!0),
            items: h(y)
          }), c = l(!1);
        },
        items(y) {
          const {
            items: m
          } = y.detail;
          for (; s.length !== 0; )
            s.remove(0);
          for (const A of m) {
            const {
              displayValue: C,
              exportValue: O
            } = A, R = document.createElement("option");
            R.textContent = C, R.value = O, s.append(R);
          }
          s.options.length > 0 && (s.options[0].selected = !0), t.setValue(i, {
            value: l(!0),
            items: h(y)
          }), c = l(!1);
        },
        indices(y) {
          const m = new Set(y.detail.indices);
          for (const A of y.target.options)
            A.selected = m.has(A.index);
          t.setValue(i, {
            value: l(!0)
          }), c = l(!1);
        },
        editable(y) {
          y.target.disabled = !y.detail.editable;
        }
      };
      this._dispatchEventFromSandbox(p, I);
    }), s.addEventListener("input", (I) => {
      var m;
      const p = l(!0), y = l(!1);
      t.setValue(i, {
        value: p
      }), I.preventDefault(), (m = this.linkService.eventBus) == null || m.dispatch("dispatcheventinsandbox", {
        source: this,
        detail: {
          id: i,
          name: "Keystroke",
          value: c,
          change: y,
          changeEx: p,
          willCommit: !1,
          commitKey: 1,
          keyDown: !1
        }
      });
    }), this._setEventListeners(s, null, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"], ["input", "Action"], ["input", "Validate"]], (I) => I.target.value)) : s.addEventListener("input", function(I) {
      t.setValue(i, {
        value: l(!0)
      });
    }), this.data.combo && this._setTextStyle(s), this._setBackgroundColor(s), this._setDefaultPropertiesFromJS(s), this.container.append(s), this.container;
  }
}
class jhe extends h0 {
  constructor(t) {
    const {
      data: i,
      elements: n
    } = t;
    super(t, {
      isRenderable: h0._hasPopupData(i)
    }), this.elements = n, this.popup = null;
  }
  render() {
    const {
      container: t
    } = this;
    t.classList.add("popupAnnotation"), t.role = "comment";
    const i = this.popup = new kxe({
      container: this.container,
      color: this.data.color,
      titleObj: this.data.titleObj,
      modificationDate: this.data.modificationDate || this.data.creationDate,
      contentsObj: this.data.contentsObj,
      richText: this.data.richText,
      rect: this.data.rect,
      parentRect: this.data.parentRect || null,
      parent: this.parent,
      elements: this.elements,
      open: this.data.open
    }), n = [];
    for (const s of this.elements)
      s.popup = i, s.container.ariaHasPopup = "dialog", n.push(s.data.id), s.addHighlightArea();
    return this.container.setAttribute("aria-controls", n.map((s) => `${Spe}${s}`).join(",")), this.container;
  }
}
var wj, Jle, Xle, Tj, Rj, Qd, ZC, Bx, vj, Yee, Aj, Fb, a2, Fx, QC, qee, JC, Sj, KB, Hx, il, roe, loe, Whe, aRe, uRe, dRe, cRe, aoe, uoe, Yhe;
class kxe {
  constructor({
    container: t,
    color: i,
    elements: n,
    titleObj: s,
    modificationDate: o,
    contentsObj: r,
    richText: l,
    parent: c,
    rect: h,
    parentRect: I,
    open: p
  }) {
    xe(this, il);
    xe(this, wj, _e(this, il, dRe).bind(this));
    xe(this, Jle, _e(this, il, Yhe).bind(this));
    xe(this, Xle, _e(this, il, uoe).bind(this));
    xe(this, Tj, _e(this, il, aoe).bind(this));
    xe(this, Rj, null);
    xe(this, Qd, null);
    xe(this, ZC, null);
    xe(this, Bx, null);
    xe(this, vj, null);
    xe(this, Yee, null);
    xe(this, Aj, null);
    xe(this, Fb, !1);
    xe(this, a2, null);
    xe(this, Fx, null);
    xe(this, QC, null);
    xe(this, qee, null);
    xe(this, JC, null);
    xe(this, Sj, null);
    xe(this, KB, null);
    xe(this, Hx, !1);
    be(this, Qd, t), be(this, Sj, s), be(this, ZC, r), be(this, JC, l), be(this, Yee, c), be(this, Rj, i), be(this, qee, h), be(this, Aj, I), be(this, vj, n), be(this, Bx, ohe.toDateObject(o)), this.trigger = n.flatMap((y) => y.getElementsToTriggerPopup()), _e(this, il, roe).call(this), S(this, Qd).hidden = !0, p && _e(this, il, aoe).call(this);
  }
  render() {
    var s;
    if (S(this, a2))
      return;
    const t = be(this, a2, document.createElement("div"));
    if (t.className = "popup", S(this, Rj)) {
      const o = t.style.outlineColor = ys.makeHexColor(...S(this, Rj));
      t.style.backgroundColor = `color-mix(in srgb, ${o} 30%, white)`;
    }
    const i = document.createElement("span");
    if (i.className = "header", (s = S(this, Sj)) != null && s.str) {
      const o = document.createElement("span");
      o.className = "title", i.append(o), {
        dir: o.dir,
        str: o.textContent
      } = S(this, Sj);
    }
    if (t.append(i), S(this, Bx)) {
      const o = document.createElement("time");
      o.className = "popupDate", o.setAttribute("data-l10n-id", "pdfjs-annotation-date-time-string"), o.setAttribute("data-l10n-args", JSON.stringify({
        dateObj: S(this, Bx).valueOf()
      })), o.dateTime = S(this, Bx).toISOString(), i.append(o);
    }
    const n = S(this, il, loe);
    if (n)
      sRe.render({
        xfaHtml: n,
        intent: "richText",
        div: t
      }), t.lastChild.classList.add("richText", "popupContent");
    else {
      const o = this._formatContents(S(this, ZC));
      t.append(o);
    }
    S(this, Qd).append(t);
  }
  _formatContents({
    str: t,
    dir: i
  }) {
    const n = document.createElement("p");
    n.classList.add("popupContent"), n.dir = i;
    const s = t.split(/(?:\r\n?|\n)/);
    for (let o = 0, r = s.length; o < r; ++o) {
      const l = s[o];
      n.append(document.createTextNode(l)), o < r - 1 && n.append(document.createElement("br"));
    }
    return n;
  }
  updateEdited({
    rect: t,
    popup: i,
    deleted: n
  }) {
    var s;
    if (n || i != null && i.deleted) {
      this.remove();
      return;
    }
    _e(this, il, roe).call(this), S(this, KB) || be(this, KB, {
      contentsObj: S(this, ZC),
      richText: S(this, JC)
    }), t && be(this, QC, null), i && (be(this, JC, _e(this, il, uRe).call(this, i.text)), be(this, Bx, ohe.toDateObject(i.date)), be(this, ZC, null)), (s = S(this, a2)) == null || s.remove(), be(this, a2, null);
  }
  resetEdited() {
    var t;
    S(this, KB) && ({
      contentsObj: hp(this, ZC)._,
      richText: hp(this, JC)._
    } = S(this, KB), be(this, KB, null), (t = S(this, a2)) == null || t.remove(), be(this, a2, null), be(this, QC, null));
  }
  remove() {
    var t, i;
    (t = S(this, Fx)) == null || t.abort(), be(this, Fx, null), (i = S(this, a2)) == null || i.remove(), be(this, a2, null), be(this, Hx, !1), be(this, Fb, !1);
    for (const n of this.trigger)
      n.classList.remove("popupTriggerArea");
  }
  forceHide() {
    be(this, Hx, this.isVisible), S(this, Hx) && (S(this, Qd).hidden = !0);
  }
  maybeShow() {
    _e(this, il, roe).call(this), S(this, Hx) && (S(this, a2) || _e(this, il, uoe).call(this), be(this, Hx, !1), S(this, Qd).hidden = !1);
  }
  get isVisible() {
    return S(this, Qd).hidden === !1;
  }
}
wj = new WeakMap(), Jle = new WeakMap(), Xle = new WeakMap(), Tj = new WeakMap(), Rj = new WeakMap(), Qd = new WeakMap(), ZC = new WeakMap(), Bx = new WeakMap(), vj = new WeakMap(), Yee = new WeakMap(), Aj = new WeakMap(), Fb = new WeakMap(), a2 = new WeakMap(), Fx = new WeakMap(), QC = new WeakMap(), qee = new WeakMap(), JC = new WeakMap(), Sj = new WeakMap(), KB = new WeakMap(), Hx = new WeakMap(), il = new WeakSet(), roe = function() {
  var i;
  if (S(this, Fx))
    return;
  be(this, Fx, new AbortController());
  const {
    signal: t
  } = S(this, Fx);
  for (const n of this.trigger)
    n.addEventListener("click", S(this, Tj), {
      signal: t
    }), n.addEventListener("mouseenter", S(this, Xle), {
      signal: t
    }), n.addEventListener("mouseleave", S(this, Jle), {
      signal: t
    }), n.classList.add("popupTriggerArea");
  for (const n of S(this, vj))
    (i = n.container) == null || i.addEventListener("keydown", S(this, wj), {
      signal: t
    });
}, loe = function() {
  const t = S(this, JC), i = S(this, ZC);
  return t != null && t.str && (!(i != null && i.str) || i.str === t.str) && S(this, JC).html || null;
}, Whe = function() {
  var t, i, n;
  return ((n = (i = (t = S(this, il, loe)) == null ? void 0 : t.attributes) == null ? void 0 : i.style) == null ? void 0 : n.fontSize) || 0;
}, aRe = function() {
  var t, i, n;
  return ((n = (i = (t = S(this, il, loe)) == null ? void 0 : t.attributes) == null ? void 0 : i.style) == null ? void 0 : n.color) || null;
}, uRe = function(t) {
  const i = [], n = {
    str: t,
    html: {
      name: "div",
      attributes: {
        dir: "auto"
      },
      children: [{
        name: "p",
        children: i
      }]
    }
  }, s = {
    style: {
      color: S(this, il, aRe),
      fontSize: S(this, il, Whe) ? `calc(${S(this, il, Whe)}px * var(--total-scale-factor))` : ""
    }
  };
  for (const o of t.split(`
`))
    i.push({
      name: "span",
      value: o,
      attributes: s
    });
  return n;
}, dRe = function(t) {
  t.altKey || t.shiftKey || t.ctrlKey || t.metaKey || (t.key === "Enter" || t.key === "Escape" && S(this, Fb)) && _e(this, il, aoe).call(this);
}, cRe = function() {
  if (S(this, QC) !== null)
    return;
  const {
    page: {
      view: t
    },
    viewport: {
      rawDims: {
        pageWidth: i,
        pageHeight: n,
        pageX: s,
        pageY: o
      }
    }
  } = S(this, Yee);
  let r = !!S(this, Aj), l = r ? S(this, Aj) : S(this, qee);
  for (const A of S(this, vj))
    if (!l || ys.intersect(A.data.rect, l) !== null) {
      l = A.data.rect, r = !0;
      break;
    }
  const c = ys.normalizeRect([l[0], t[3] - l[1] + t[1], l[2], t[3] - l[3] + t[1]]), I = r ? l[2] - l[0] + 5 : 0, p = c[0] + I, y = c[1];
  be(this, QC, [100 * (p - s) / i, 100 * (y - o) / n]);
  const {
    style: m
  } = S(this, Qd);
  m.left = `${S(this, QC)[0]}%`, m.top = `${S(this, QC)[1]}%`;
}, aoe = function() {
  be(this, Fb, !S(this, Fb)), S(this, Fb) ? (_e(this, il, uoe).call(this), S(this, Qd).addEventListener("click", S(this, Tj)), S(this, Qd).addEventListener("keydown", S(this, wj))) : (_e(this, il, Yhe).call(this), S(this, Qd).removeEventListener("click", S(this, Tj)), S(this, Qd).removeEventListener("keydown", S(this, wj)));
}, uoe = function() {
  S(this, a2) || this.render(), this.isVisible ? S(this, Fb) && S(this, Qd).classList.add("focused") : (_e(this, il, cRe).call(this), S(this, Qd).hidden = !1, S(this, Qd).style.zIndex = parseInt(S(this, Qd).style.zIndex) + 1e3);
}, Yhe = function() {
  S(this, Qd).classList.remove("focused"), !(S(this, Fb) || !this.isVisible) && (S(this, Qd).hidden = !0, S(this, Qd).style.zIndex = parseInt(S(this, Qd).style.zIndex) - 1e3);
};
class hRe extends h0 {
  constructor(t) {
    super(t, {
      isRenderable: !0,
      ignoreBorder: !0
    }), this.textContent = t.data.textContent, this.textPosition = t.data.textPosition, this.annotationEditorType = eo.FREETEXT;
  }
  render() {
    if (this.container.classList.add("freeTextAnnotation"), this.textContent) {
      const t = document.createElement("div");
      t.classList.add("annotationTextContent"), t.setAttribute("role", "comment");
      for (const i of this.textContent) {
        const n = document.createElement("span");
        n.textContent = i, t.append(n);
      }
      this.container.append(t);
    }
    return !this.data.popupRef && this.hasPopupData && this._createPopup(), this._editOnDoubleClick(), this.container;
  }
}
var $ee;
class Vxe extends h0 {
  constructor(i) {
    super(i, {
      isRenderable: !0,
      ignoreBorder: !0
    });
    xe(this, $ee, null);
  }
  render() {
    this.container.classList.add("lineAnnotation");
    const {
      data: i,
      width: n,
      height: s
    } = this, o = this.svgFactory.create(n, s, !0), r = be(this, $ee, this.svgFactory.createElement("svg:line"));
    return r.setAttribute("x1", i.rect[2] - i.lineCoordinates[0]), r.setAttribute("y1", i.rect[3] - i.lineCoordinates[1]), r.setAttribute("x2", i.rect[2] - i.lineCoordinates[2]), r.setAttribute("y2", i.rect[3] - i.lineCoordinates[3]), r.setAttribute("stroke-width", i.borderStyle.width || 1), r.setAttribute("stroke", "transparent"), r.setAttribute("fill", "transparent"), o.append(r), this.container.append(o), !i.popupRef && this.hasPopupData && this._createPopup(), this.container;
  }
  getElementsToTriggerPopup() {
    return S(this, $ee);
  }
  addHighlightArea() {
    this.container.classList.add("highlightArea");
  }
}
$ee = new WeakMap();
var Kee;
class zxe extends h0 {
  constructor(i) {
    super(i, {
      isRenderable: !0,
      ignoreBorder: !0
    });
    xe(this, Kee, null);
  }
  render() {
    this.container.classList.add("squareAnnotation");
    const {
      data: i,
      width: n,
      height: s
    } = this, o = this.svgFactory.create(n, s, !0), r = i.borderStyle.width, l = be(this, Kee, this.svgFactory.createElement("svg:rect"));
    return l.setAttribute("x", r / 2), l.setAttribute("y", r / 2), l.setAttribute("width", n - r), l.setAttribute("height", s - r), l.setAttribute("stroke-width", r || 1), l.setAttribute("stroke", "transparent"), l.setAttribute("fill", "transparent"), o.append(l), this.container.append(o), !i.popupRef && this.hasPopupData && this._createPopup(), this.container;
  }
  getElementsToTriggerPopup() {
    return S(this, Kee);
  }
  addHighlightArea() {
    this.container.classList.add("highlightArea");
  }
}
Kee = new WeakMap();
var Zee;
class jxe extends h0 {
  constructor(i) {
    super(i, {
      isRenderable: !0,
      ignoreBorder: !0
    });
    xe(this, Zee, null);
  }
  render() {
    this.container.classList.add("circleAnnotation");
    const {
      data: i,
      width: n,
      height: s
    } = this, o = this.svgFactory.create(n, s, !0), r = i.borderStyle.width, l = be(this, Zee, this.svgFactory.createElement("svg:ellipse"));
    return l.setAttribute("cx", n / 2), l.setAttribute("cy", s / 2), l.setAttribute("rx", n / 2 - r / 2), l.setAttribute("ry", s / 2 - r / 2), l.setAttribute("stroke-width", r || 1), l.setAttribute("stroke", "transparent"), l.setAttribute("fill", "transparent"), o.append(l), this.container.append(o), !i.popupRef && this.hasPopupData && this._createPopup(), this.container;
  }
  getElementsToTriggerPopup() {
    return S(this, Zee);
  }
  addHighlightArea() {
    this.container.classList.add("highlightArea");
  }
}
Zee = new WeakMap();
var Qee;
class fRe extends h0 {
  constructor(i) {
    super(i, {
      isRenderable: !0,
      ignoreBorder: !0
    });
    xe(this, Qee, null);
    this.containerClassName = "polylineAnnotation", this.svgElementName = "svg:polyline";
  }
  render() {
    this.container.classList.add(this.containerClassName);
    const {
      data: {
        rect: i,
        vertices: n,
        borderStyle: s,
        popupRef: o
      },
      width: r,
      height: l
    } = this;
    if (!n)
      return this.container;
    const c = this.svgFactory.create(r, l, !0);
    let h = [];
    for (let p = 0, y = n.length; p < y; p += 2) {
      const m = n[p] - i[0], A = i[3] - n[p + 1];
      h.push(`${m},${A}`);
    }
    h = h.join(" ");
    const I = be(this, Qee, this.svgFactory.createElement(this.svgElementName));
    return I.setAttribute("points", h), I.setAttribute("stroke-width", s.width || 1), I.setAttribute("stroke", "transparent"), I.setAttribute("fill", "transparent"), c.append(I), this.container.append(c), !o && this.hasPopupData && this._createPopup(), this.container;
  }
  getElementsToTriggerPopup() {
    return S(this, Qee);
  }
  addHighlightArea() {
    this.container.classList.add("highlightArea");
  }
}
Qee = new WeakMap();
class Wxe extends fRe {
  constructor(t) {
    super(t), this.containerClassName = "polygonAnnotation", this.svgElementName = "svg:polygon";
  }
}
class Yxe extends h0 {
  constructor(t) {
    super(t, {
      isRenderable: !0,
      ignoreBorder: !0
    });
  }
  render() {
    return this.container.classList.add("caretAnnotation"), !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container;
  }
}
var Jee, ZB, Xee, qhe;
class _pe extends h0 {
  constructor(i) {
    super(i, {
      isRenderable: !0,
      ignoreBorder: !0
    });
    xe(this, Xee);
    xe(this, Jee, null);
    xe(this, ZB, []);
    this.containerClassName = "inkAnnotation", this.svgElementName = "svg:polyline", this.annotationEditorType = this.data.it === "InkHighlight" ? eo.HIGHLIGHT : eo.INK;
  }
  render() {
    this.container.classList.add(this.containerClassName);
    const {
      data: {
        rect: i,
        rotation: n,
        inkLists: s,
        borderStyle: o,
        popupRef: r
      }
    } = this, {
      transform: l,
      width: c,
      height: h
    } = _e(this, Xee, qhe).call(this, n, i), I = this.svgFactory.create(c, h, !0), p = be(this, Jee, this.svgFactory.createElement("svg:g"));
    I.append(p), p.setAttribute("stroke-width", o.width || 1), p.setAttribute("stroke-linecap", "round"), p.setAttribute("stroke-linejoin", "round"), p.setAttribute("stroke-miterlimit", 10), p.setAttribute("stroke", "transparent"), p.setAttribute("fill", "transparent"), p.setAttribute("transform", l);
    for (let y = 0, m = s.length; y < m; y++) {
      const A = this.svgFactory.createElement(this.svgElementName);
      S(this, ZB).push(A), A.setAttribute("points", s[y].join(",")), p.append(A);
    }
    return !r && this.hasPopupData && this._createPopup(), this.container.append(I), this._editOnDoubleClick(), this.container;
  }
  updateEdited(i) {
    super.updateEdited(i);
    const {
      thickness: n,
      points: s,
      rect: o
    } = i, r = S(this, Jee);
    if (n >= 0 && r.setAttribute("stroke-width", n || 1), s)
      for (let l = 0, c = S(this, ZB).length; l < c; l++)
        S(this, ZB)[l].setAttribute("points", s[l].join(","));
    if (o) {
      const {
        transform: l,
        width: c,
        height: h
      } = _e(this, Xee, qhe).call(this, this.data.rotation, o);
      r.parentElement.setAttribute("viewBox", `0 0 ${c} ${h}`), r.setAttribute("transform", l);
    }
  }
  getElementsToTriggerPopup() {
    return S(this, ZB);
  }
  addHighlightArea() {
    this.container.classList.add("highlightArea");
  }
}
Jee = new WeakMap(), ZB = new WeakMap(), Xee = new WeakSet(), qhe = function(i, n) {
  switch (i) {
    case 90:
      return {
        transform: `rotate(90) translate(${-n[0]},${n[1]}) scale(1,-1)`,
        width: n[3] - n[1],
        height: n[2] - n[0]
      };
    case 180:
      return {
        transform: `rotate(180) translate(${-n[2]},${n[1]}) scale(1,-1)`,
        width: n[2] - n[0],
        height: n[3] - n[1]
      };
    case 270:
      return {
        transform: `rotate(270) translate(${-n[2]},${n[3]}) scale(1,-1)`,
        width: n[3] - n[1],
        height: n[2] - n[0]
      };
    default:
      return {
        transform: `translate(${-n[0]},${n[3]}) scale(1,-1)`,
        width: n[2] - n[0],
        height: n[3] - n[1]
      };
  }
};
class IRe extends h0 {
  constructor(t) {
    super(t, {
      isRenderable: !0,
      ignoreBorder: !0,
      createQuadrilaterals: !0
    }), this.annotationEditorType = eo.HIGHLIGHT;
  }
  render() {
    const {
      data: {
        overlaidText: t,
        popupRef: i
      }
    } = this;
    if (!i && this.hasPopupData && this._createPopup(), this.container.classList.add("highlightAnnotation"), this._editOnDoubleClick(), t) {
      const n = document.createElement("mark");
      n.classList.add("overlaidText"), n.textContent = t, this.container.append(n);
    }
    return this.container;
  }
}
class qxe extends h0 {
  constructor(t) {
    super(t, {
      isRenderable: !0,
      ignoreBorder: !0,
      createQuadrilaterals: !0
    });
  }
  render() {
    const {
      data: {
        overlaidText: t,
        popupRef: i
      }
    } = this;
    if (!i && this.hasPopupData && this._createPopup(), this.container.classList.add("underlineAnnotation"), t) {
      const n = document.createElement("u");
      n.classList.add("overlaidText"), n.textContent = t, this.container.append(n);
    }
    return this.container;
  }
}
class $xe extends h0 {
  constructor(t) {
    super(t, {
      isRenderable: !0,
      ignoreBorder: !0,
      createQuadrilaterals: !0
    });
  }
  render() {
    const {
      data: {
        overlaidText: t,
        popupRef: i
      }
    } = this;
    if (!i && this.hasPopupData && this._createPopup(), this.container.classList.add("squigglyAnnotation"), t) {
      const n = document.createElement("u");
      n.classList.add("overlaidText"), n.textContent = t, this.container.append(n);
    }
    return this.container;
  }
}
class Kxe extends h0 {
  constructor(t) {
    super(t, {
      isRenderable: !0,
      ignoreBorder: !0,
      createQuadrilaterals: !0
    });
  }
  render() {
    const {
      data: {
        overlaidText: t,
        popupRef: i
      }
    } = this;
    if (!i && this.hasPopupData && this._createPopup(), this.container.classList.add("strikeoutAnnotation"), t) {
      const n = document.createElement("s");
      n.classList.add("overlaidText"), n.textContent = t, this.container.append(n);
    }
    return this.container;
  }
}
class pRe extends h0 {
  constructor(t) {
    super(t, {
      isRenderable: !0,
      ignoreBorder: !0
    }), this.annotationEditorType = eo.STAMP;
  }
  render() {
    return this.container.classList.add("stampAnnotation"), this.container.setAttribute("role", "img"), !this.data.popupRef && this.hasPopupData && this._createPopup(), this._editOnDoubleClick(), this.container;
  }
}
var ete, tte, $he;
class Zxe extends h0 {
  constructor(i) {
    var s;
    super(i, {
      isRenderable: !0
    });
    xe(this, tte);
    xe(this, ete, null);
    const {
      file: n
    } = this.data;
    this.filename = n.filename, this.content = n.content, (s = this.linkService.eventBus) == null || s.dispatch("fileattachmentannotation", {
      source: this,
      ...n
    });
  }
  render() {
    this.container.classList.add("fileAttachmentAnnotation");
    const {
      container: i,
      data: n
    } = this;
    let s;
    n.hasAppearance || n.fillAlpha === 0 ? s = document.createElement("div") : (s = document.createElement("img"), s.src = `${this.imageResourcesPath}annotation-${/paperclip/i.test(n.name) ? "paperclip" : "pushpin"}.svg`, n.fillAlpha && n.fillAlpha < 1 && (s.style = `filter: opacity(${Math.round(n.fillAlpha * 100)}%);`)), s.addEventListener("dblclick", _e(this, tte, $he).bind(this)), be(this, ete, s);
    const {
      isMac: o
    } = Qp.platform;
    return i.addEventListener("keydown", (r) => {
      r.key === "Enter" && (o ? r.metaKey : r.ctrlKey) && _e(this, tte, $he).call(this);
    }), !n.popupRef && this.hasPopupData ? this._createPopup() : s.classList.add("popupTriggerArea"), i.append(s), i;
  }
  getElementsToTriggerPopup() {
    return S(this, ete);
  }
  addHighlightArea() {
    this.container.classList.add("highlightArea");
  }
}
ete = new WeakMap(), tte = new WeakSet(), $he = function() {
  var i;
  (i = this.downloadManager) == null || i.openOrDownloadData(this.content, this.filename);
};
var ite, QB, Gx, nte, P8, Khe, Zhe, bj;
let mRe = (bj = class {
  constructor({
    div: t,
    accessibilityManager: i,
    annotationCanvasMap: n,
    annotationEditorUIManager: s,
    page: o,
    viewport: r,
    structTreeLayer: l
  }) {
    xe(this, P8);
    xe(this, ite, null);
    xe(this, QB, null);
    xe(this, Gx, /* @__PURE__ */ new Map());
    xe(this, nte, null);
    this.div = t, be(this, ite, i), be(this, QB, n), be(this, nte, l || null), this.page = o, this.viewport = r, this.zIndex = 0, this._annotationEditorUIManager = s;
  }
  hasEditableAnnotations() {
    return S(this, Gx).size > 0;
  }
  async render(t) {
    var r;
    const {
      annotations: i
    } = t, n = this.div;
    KF(n, this.viewport);
    const s = /* @__PURE__ */ new Map(), o = {
      data: null,
      layer: n,
      linkService: t.linkService,
      downloadManager: t.downloadManager,
      imageResourcesPath: t.imageResourcesPath || "",
      renderForms: t.renderForms !== !1,
      svgFactory: new ale(),
      annotationStorage: t.annotationStorage || new Dpe(),
      enableScripting: t.enableScripting === !0,
      hasJSActions: t.hasJSActions,
      fieldObjects: t.fieldObjects,
      parent: this,
      elements: null
    };
    for (const l of i) {
      if (l.noHTML)
        continue;
      const c = l.annotationType === O0.POPUP;
      if (c) {
        const p = s.get(l.id);
        if (!p)
          continue;
        o.elements = p;
      } else if (l.rect[2] === l.rect[0] || l.rect[3] === l.rect[1])
        continue;
      o.data = l;
      const h = tEe.create(o);
      if (!h.isRenderable)
        continue;
      if (!c && l.popupRef) {
        const p = s.get(l.popupRef);
        p ? p.push(h) : s.set(l.popupRef, [h]);
      }
      const I = h.render();
      l.hidden && (I.style.visibility = "hidden"), await _e(this, P8, Khe).call(this, I, l.id, o.elements), h._isEditable && (S(this, Gx).set(h.data.id, h), (r = this._annotationEditorUIManager) == null || r.renderAnnotationElement(h));
    }
    _e(this, P8, Zhe).call(this);
  }
  async addLinkAnnotations(t, i) {
    const n = {
      data: null,
      layer: this.div,
      linkService: i,
      svgFactory: new ale(),
      parent: this
    };
    for (const s of t) {
      s.borderStyle || (s.borderStyle = bj._defaultBorderStyle), n.data = s;
      const o = tEe.create(n);
      if (!o.isRenderable)
        continue;
      const r = o.render();
      await _e(this, P8, Khe).call(this, r, s.id, null);
    }
  }
  update({
    viewport: t
  }) {
    const i = this.div;
    this.viewport = t, KF(i, {
      rotation: t.rotation
    }), _e(this, P8, Zhe).call(this), i.hidden = !1;
  }
  getEditableAnnotations() {
    return Array.from(S(this, Gx).values());
  }
  getEditableAnnotation(t) {
    return S(this, Gx).get(t);
  }
  static get _defaultBorderStyle() {
    return Zo(this, "_defaultBorderStyle", Object.freeze({
      width: 1,
      rawWidth: 1,
      style: yV.SOLID,
      dashArray: [3],
      horizontalCornerRadius: 0,
      verticalCornerRadius: 0
    }));
  }
}, ite = new WeakMap(), QB = new WeakMap(), Gx = new WeakMap(), nte = new WeakMap(), P8 = new WeakSet(), Khe = async function(t, i, n) {
  var l, c;
  const s = t.firstChild || t, o = s.id = `${Spe}${i}`, r = await ((l = S(this, nte)) == null ? void 0 : l.getAriaAttributes(o));
  if (r)
    for (const [h, I] of r)
      s.setAttribute(h, I);
  n ? n.at(-1).container.after(t) : (this.div.append(t), (c = S(this, ite)) == null || c.moveElementInDOM(this.div, t, s, !1));
}, Zhe = function() {
  var i;
  if (!S(this, QB))
    return;
  const t = this.div;
  for (const [n, s] of S(this, QB)) {
    const o = t.querySelector(`[data-annotation-id="${n}"]`);
    if (!o)
      continue;
    s.className = "annotationContent";
    const {
      firstChild: r
    } = o;
    r ? r.nodeName === "CANVAS" ? r.replaceWith(s) : r.classList.contains("annotationContent") ? r.after(s) : r.before(s) : o.append(s);
    const l = S(this, Gx).get(n);
    l && (l._hasNoCanvas ? ((i = this._annotationEditorUIManager) == null || i.setMissingCanvas(n, o.id, s), l._hasNoCanvas = !1) : l.canvas = s);
  }
  S(this, QB).clear();
}, bj);
const mne = /\r\n?|\n/g;
var JT, u2, ste, JB, d2, hh, yRe, ERe, gRe, doe, aL, coe, hoe, wRe, Jhe, TRe;
const ea = class ea extends na {
  constructor(i) {
    super({
      ...i,
      name: "freeTextEditor"
    });
    xe(this, hh);
    xe(this, JT);
    xe(this, u2, "");
    xe(this, ste, `${this.id}-editor`);
    xe(this, JB, null);
    xe(this, d2);
    Zi(this, "_colorPicker", null);
    be(this, JT, i.color || ea._defaultColor || na._defaultLineColor), be(this, d2, i.fontSize || ea._defaultFontSize), this.annotationElementId || this._uiManager.a11yAlert("pdfjs-editor-freetext-added-alert");
  }
  static get _keyboardManager() {
    const i = ea.prototype, n = (r) => r.isEmpty(), s = uX.TRANSLATE_SMALL, o = uX.TRANSLATE_BIG;
    return Zo(this, "_keyboardManager", new Iie([[["ctrl+s", "mac+meta+s", "ctrl+p", "mac+meta+p"], i.commitOrRemove, {
      bubbles: !0
    }], [["ctrl+Enter", "mac+meta+Enter", "Escape", "mac+Escape"], i.commitOrRemove], [["ArrowLeft", "mac+ArrowLeft"], i._translateEmpty, {
      args: [-s, 0],
      checker: n
    }], [["ctrl+ArrowLeft", "mac+shift+ArrowLeft"], i._translateEmpty, {
      args: [-o, 0],
      checker: n
    }], [["ArrowRight", "mac+ArrowRight"], i._translateEmpty, {
      args: [s, 0],
      checker: n
    }], [["ctrl+ArrowRight", "mac+shift+ArrowRight"], i._translateEmpty, {
      args: [o, 0],
      checker: n
    }], [["ArrowUp", "mac+ArrowUp"], i._translateEmpty, {
      args: [0, -s],
      checker: n
    }], [["ctrl+ArrowUp", "mac+shift+ArrowUp"], i._translateEmpty, {
      args: [0, -o],
      checker: n
    }], [["ArrowDown", "mac+ArrowDown"], i._translateEmpty, {
      args: [0, s],
      checker: n
    }], [["ctrl+ArrowDown", "mac+shift+ArrowDown"], i._translateEmpty, {
      args: [0, o],
      checker: n
    }]]));
  }
  static initialize(i, n) {
    na.initialize(i, n);
    const s = getComputedStyle(document.documentElement);
    this._internalPadding = parseFloat(s.getPropertyValue("--freetext-padding"));
  }
  static updateDefaultParams(i, n) {
    switch (i) {
      case Ir.FREETEXT_SIZE:
        ea._defaultFontSize = n;
        break;
      case Ir.FREETEXT_COLOR:
        ea._defaultColor = n;
        break;
    }
  }
  updateParams(i, n) {
    switch (i) {
      case Ir.FREETEXT_SIZE:
        _e(this, hh, yRe).call(this, n);
        break;
      case Ir.FREETEXT_COLOR:
        _e(this, hh, ERe).call(this, n);
        break;
    }
  }
  static get defaultPropertiesToUpdate() {
    return [[Ir.FREETEXT_SIZE, ea._defaultFontSize], [Ir.FREETEXT_COLOR, ea._defaultColor || na._defaultLineColor]];
  }
  get propertiesToUpdate() {
    return [[Ir.FREETEXT_SIZE, S(this, d2)], [Ir.FREETEXT_COLOR, S(this, JT)]];
  }
  get toolbarButtons() {
    return this._colorPicker || (this._colorPicker = new lle(this)), [["colorPicker", this._colorPicker]];
  }
  get colorType() {
    return Ir.FREETEXT_COLOR;
  }
  get colorValue() {
    return S(this, JT);
  }
  _translateEmpty(i, n) {
    this._uiManager.translateSelectedEditors(i, n, !0);
  }
  getInitialTranslation() {
    const i = this.parentScale;
    return [-ea._internalPadding * i, -(ea._internalPadding + S(this, d2)) * i];
  }
  rebuild() {
    this.parent && (super.rebuild(), this.div !== null && (this.isAttachedToDOM || this.parent.add(this)));
  }
  enableEditMode() {
    if (!super.enableEditMode())
      return !1;
    this.overlayDiv.classList.remove("enabled"), this.editorDiv.contentEditable = !0, this._isDraggable = !1, this.div.removeAttribute("aria-activedescendant"), be(this, JB, new AbortController());
    const i = this._uiManager.combinedSignal(S(this, JB));
    return this.editorDiv.addEventListener("keydown", this.editorDivKeydown.bind(this), {
      signal: i
    }), this.editorDiv.addEventListener("focus", this.editorDivFocus.bind(this), {
      signal: i
    }), this.editorDiv.addEventListener("blur", this.editorDivBlur.bind(this), {
      signal: i
    }), this.editorDiv.addEventListener("input", this.editorDivInput.bind(this), {
      signal: i
    }), this.editorDiv.addEventListener("paste", this.editorDivPaste.bind(this), {
      signal: i
    }), !0;
  }
  disableEditMode() {
    var i;
    return super.disableEditMode() ? (this.overlayDiv.classList.add("enabled"), this.editorDiv.contentEditable = !1, this.div.setAttribute("aria-activedescendant", S(this, ste)), this._isDraggable = !0, (i = S(this, JB)) == null || i.abort(), be(this, JB, null), this.div.focus({
      preventScroll: !0
    }), this.isEditing = !1, this.parent.div.classList.add("freetextEditing"), !0) : !1;
  }
  focusin(i) {
    this._focusEventsAllowed && (super.focusin(i), i.target !== this.editorDiv && this.editorDiv.focus());
  }
  onceAdded(i) {
    var n;
    this.width || (this.enableEditMode(), i && this.editorDiv.focus(), (n = this._initialOptions) != null && n.isCentered && this.center(), this._initialOptions = null);
  }
  isEmpty() {
    return !this.editorDiv || this.editorDiv.innerText.trim() === "";
  }
  remove() {
    this.isEditing = !1, this.parent && (this.parent.setEditingState(!0), this.parent.div.classList.add("freetextEditing")), super.remove();
  }
  commit() {
    if (!this.isInEditMode())
      return;
    super.commit(), this.disableEditMode();
    const i = S(this, u2), n = be(this, u2, _e(this, hh, gRe).call(this).trimEnd());
    if (i === n)
      return;
    const s = (o) => {
      if (be(this, u2, o), !o) {
        this.remove();
        return;
      }
      _e(this, hh, hoe).call(this), this._uiManager.rebuild(this), _e(this, hh, doe).call(this);
    };
    this.addCommands({
      cmd: () => {
        s(n);
      },
      undo: () => {
        s(i);
      },
      mustExec: !1
    }), _e(this, hh, doe).call(this);
  }
  shouldGetKeyboardEvents() {
    return this.isInEditMode();
  }
  enterInEditMode() {
    this.enableEditMode(), this.editorDiv.focus();
  }
  keydown(i) {
    i.target === this.div && i.key === "Enter" && (this.enterInEditMode(), i.preventDefault());
  }
  editorDivKeydown(i) {
    ea._keyboardManager.exec(this, i);
  }
  editorDivFocus(i) {
    this.isEditing = !0;
  }
  editorDivBlur(i) {
    this.isEditing = !1;
  }
  editorDivInput(i) {
    this.parent.div.classList.toggle("freetextEditing", this.isEmpty());
  }
  disableEditing() {
    this.editorDiv.setAttribute("role", "comment"), this.editorDiv.removeAttribute("aria-multiline");
  }
  enableEditing() {
    this.editorDiv.setAttribute("role", "textbox"), this.editorDiv.setAttribute("aria-multiline", !0);
  }
  get canChangeContent() {
    return !0;
  }
  render() {
    if (this.div)
      return this.div;
    let i, n;
    (this._isCopy || this.annotationElementId) && (i = this.x, n = this.y), super.render(), this.editorDiv = document.createElement("div"), this.editorDiv.className = "internal", this.editorDiv.setAttribute("id", S(this, ste)), this.editorDiv.setAttribute("data-l10n-id", "pdfjs-free-text2"), this.editorDiv.setAttribute("data-l10n-attrs", "default-content"), this.enableEditing(), this.editorDiv.contentEditable = !0;
    const {
      style: s
    } = this.editorDiv;
    if (s.fontSize = `calc(${S(this, d2)}px * var(--total-scale-factor))`, s.color = S(this, JT), this.div.append(this.editorDiv), this.overlayDiv = document.createElement("div"), this.overlayDiv.classList.add("overlay", "enabled"), this.div.append(this.overlayDiv), this._isCopy || this.annotationElementId) {
      const [o, r] = this.parentDimensions;
      if (this.annotationElementId) {
        const {
          position: l
        } = this._initialData;
        let [c, h] = this.getInitialTranslation();
        [c, h] = this.pageTranslationToScreen(c, h);
        const [I, p] = this.pageDimensions, [y, m] = this.pageTranslation;
        let A, C;
        switch (this.rotation) {
          case 0:
            A = i + (l[0] - y) / I, C = n + this.height - (l[1] - m) / p;
            break;
          case 90:
            A = i + (l[0] - y) / I, C = n - (l[1] - m) / p, [c, h] = [h, -c];
            break;
          case 180:
            A = i - this.width + (l[0] - y) / I, C = n - (l[1] - m) / p, [c, h] = [-c, -h];
            break;
          case 270:
            A = i + (l[0] - y - this.height * p) / I, C = n + (l[1] - m - this.width * I) / p, [c, h] = [-h, c];
            break;
        }
        this.setAt(A * o, C * r, c, h);
      } else
        this._moveAfterPaste(i, n);
      _e(this, hh, hoe).call(this), this._isDraggable = !0, this.editorDiv.contentEditable = !1;
    } else
      this._isDraggable = !1, this.editorDiv.contentEditable = !0;
    return this.div;
  }
  editorDivPaste(i) {
    var A, C, O;
    const n = i.clipboardData || window.clipboardData, {
      types: s
    } = n;
    if (s.length === 1 && s[0] === "text/plain")
      return;
    i.preventDefault();
    const o = _e(A = ea, aL, Jhe).call(A, n.getData("text") || "").replaceAll(mne, `
`);
    if (!o)
      return;
    const r = window.getSelection();
    if (!r.rangeCount)
      return;
    this.editorDiv.normalize(), r.deleteFromDocument();
    const l = r.getRangeAt(0);
    if (!o.includes(`
`)) {
      l.insertNode(document.createTextNode(o)), this.editorDiv.normalize(), r.collapseToStart();
      return;
    }
    const {
      startContainer: c,
      startOffset: h
    } = l, I = [], p = [];
    if (c.nodeType === Node.TEXT_NODE) {
      const R = c.parentElement;
      if (p.push(c.nodeValue.slice(h).replaceAll(mne, "")), R !== this.editorDiv) {
        let F = I;
        for (const L of this.editorDiv.childNodes) {
          if (L === R) {
            F = p;
            continue;
          }
          F.push(_e(C = ea, aL, coe).call(C, L));
        }
      }
      I.push(c.nodeValue.slice(0, h).replaceAll(mne, ""));
    } else if (c === this.editorDiv) {
      let R = I, F = 0;
      for (const L of this.editorDiv.childNodes)
        F++ === h && (R = p), R.push(_e(O = ea, aL, coe).call(O, L));
    }
    be(this, u2, `${I.join(`
`)}${o}${p.join(`
`)}`), _e(this, hh, hoe).call(this);
    const y = new Range();
    let m = Math.sumPrecise(I.map((R) => R.length));
    for (const {
      firstChild: R
    } of this.editorDiv.childNodes)
      if (R.nodeType === Node.TEXT_NODE) {
        const F = R.nodeValue.length;
        if (m <= F) {
          y.setStart(R, m), y.setEnd(R, m);
          break;
        }
        m -= F;
      }
    r.removeAllRanges(), r.addRange(y);
  }
  get contentDiv() {
    return this.editorDiv;
  }
  static async deserialize(i, n, s) {
    var l;
    let o = null;
    if (i instanceof hRe) {
      const {
        data: {
          defaultAppearanceData: {
            fontSize: c,
            fontColor: h
          },
          rect: I,
          rotation: p,
          id: y,
          popupRef: m,
          contentsObj: A
        },
        textContent: C,
        textPosition: O,
        parent: {
          page: {
            pageNumber: R
          }
        }
      } = i;
      if (!C || C.length === 0)
        return null;
      o = i = {
        annotationType: eo.FREETEXT,
        color: Array.from(h),
        fontSize: c,
        value: C.join(`
`),
        position: O,
        pageIndex: R - 1,
        rect: I.slice(0),
        rotation: p,
        annotationElementId: y,
        id: y,
        deleted: !1,
        popupRef: m,
        comment: (A == null ? void 0 : A.str) || null
      };
    }
    const r = await super.deserialize(i, n, s);
    return be(r, d2, i.fontSize), be(r, JT, ys.makeHexColor(...i.color)), be(r, u2, _e(l = ea, aL, Jhe).call(l, i.value)), r._initialData = o, i.comment && r.setCommentData(i.comment), r;
  }
  serialize(i = !1) {
    if (this.isEmpty())
      return null;
    if (this.deleted)
      return this.serializeDeleted();
    const n = ea._internalPadding * this.parentScale, s = this.getRect(n, n), o = na._colorManager.convert(this.isAttachedToDOM ? getComputedStyle(this.editorDiv).color : S(this, JT)), r = {
      annotationType: eo.FREETEXT,
      color: o,
      fontSize: S(this, d2),
      value: _e(this, hh, wRe).call(this),
      pageIndex: this.pageIndex,
      rect: s,
      rotation: this.rotation,
      structTreeParentId: this._structTreeParentId
    };
    return this.addComment(r), i ? (r.isCopy = !0, r) : this.annotationElementId && !_e(this, hh, TRe).call(this, r) ? null : (r.id = this.annotationElementId, r);
  }
  renderAnnotationElement(i) {
    const n = super.renderAnnotationElement(i), {
      style: s
    } = n;
    s.fontSize = `calc(${S(this, d2)}px * var(--total-scale-factor))`, s.color = S(this, JT), n.replaceChildren();
    for (const l of S(this, u2).split(`
`)) {
      const c = document.createElement("div");
      c.append(l ? document.createTextNode(l) : document.createElement("br")), n.append(c);
    }
    const o = ea._internalPadding * this.parentScale, r = {
      rect: this.getRect(o, o)
    };
    return r.popup = this.hasEditedComment ? this.comment : {
      text: S(this, u2)
    }, i.updateEdited(r), n;
  }
  resetAnnotationElement(i) {
    super.resetAnnotationElement(i), i.resetEdited();
  }
};
JT = new WeakMap(), u2 = new WeakMap(), ste = new WeakMap(), JB = new WeakMap(), d2 = new WeakMap(), hh = new WeakSet(), yRe = function(i) {
  const n = (o) => {
    this.editorDiv.style.fontSize = `calc(${o}px * var(--total-scale-factor))`, this.translate(0, -(o - S(this, d2)) * this.parentScale), be(this, d2, o), _e(this, hh, doe).call(this);
  }, s = S(this, d2);
  this.addCommands({
    cmd: n.bind(this, i),
    undo: n.bind(this, s),
    post: this._uiManager.updateUI.bind(this._uiManager, this),
    mustExec: !0,
    type: Ir.FREETEXT_SIZE,
    overwriteIfSameType: !0,
    keepUndo: !0
  });
}, ERe = function(i) {
  const n = (o) => {
    var r;
    be(this, JT, this.editorDiv.style.color = o), (r = this._colorPicker) == null || r.update(o);
  }, s = S(this, JT);
  this.addCommands({
    cmd: n.bind(this, i),
    undo: n.bind(this, s),
    post: this._uiManager.updateUI.bind(this._uiManager, this),
    mustExec: !0,
    type: Ir.FREETEXT_COLOR,
    overwriteIfSameType: !0,
    keepUndo: !0
  });
}, gRe = function() {
  var s;
  const i = [];
  this.editorDiv.normalize();
  let n = null;
  for (const o of this.editorDiv.childNodes)
    (n == null ? void 0 : n.nodeType) === Node.TEXT_NODE && o.nodeName === "BR" || (i.push(_e(s = ea, aL, coe).call(s, o)), n = o);
  return i.join(`
`);
}, doe = function() {
  const [i, n] = this.parentDimensions;
  let s;
  if (this.isAttachedToDOM)
    s = this.div.getBoundingClientRect();
  else {
    const {
      currentLayer: o,
      div: r
    } = this, l = r.style.display, c = r.classList.contains("hidden");
    r.classList.remove("hidden"), r.style.display = "hidden", o.div.append(this.div), s = r.getBoundingClientRect(), r.remove(), r.style.display = l, r.classList.toggle("hidden", c);
  }
  this.rotation % 180 === this.parentRotation % 180 ? (this.width = s.width / i, this.height = s.height / n) : (this.width = s.height / i, this.height = s.width / n), this.fixAndSetPosition();
}, aL = new WeakSet(), coe = function(i) {
  return (i.nodeType === Node.TEXT_NODE ? i.nodeValue : i.innerText).replaceAll(mne, "");
}, hoe = function() {
  if (this.editorDiv.replaceChildren(), !!S(this, u2))
    for (const i of S(this, u2).split(`
`)) {
      const n = document.createElement("div");
      n.append(i ? document.createTextNode(i) : document.createElement("br")), this.editorDiv.append(n);
    }
}, wRe = function() {
  return S(this, u2).replaceAll(" ", " ");
}, Jhe = function(i) {
  return i.replaceAll(" ", " ");
}, TRe = function(i) {
  const {
    value: n,
    fontSize: s,
    color: o,
    pageIndex: r
  } = this._initialData;
  return this.hasEditedComment || this._hasBeenMoved || i.value !== n || i.fontSize !== s || i.color.some((l, c) => l !== o[c]) || i.pageIndex !== r;
}, xe(ea, aL), Zi(ea, "_freeTextDefaultContent", ""), Zi(ea, "_internalPadding", 0), Zi(ea, "_defaultColor", null), Zi(ea, "_defaultFontSize", 10), Zi(ea, "_type", "freetext"), Zi(ea, "_editorType", eo.FREETEXT);
let Qhe = ea;
class Wn {
  toSVGPath() {
    Ll("Abstract method `toSVGPath` must be implemented.");
  }
  get box() {
    Ll("Abstract getter `box` must be implemented.");
  }
  serialize(t, i) {
    Ll("Abstract method `serialize` must be implemented.");
  }
  static _rescale(t, i, n, s, o, r) {
    r || (r = new Float32Array(t.length));
    for (let l = 0, c = t.length; l < c; l += 2)
      r[l] = i + t[l] * s, r[l + 1] = n + t[l + 1] * o;
    return r;
  }
  static _rescaleAndSwap(t, i, n, s, o, r) {
    r || (r = new Float32Array(t.length));
    for (let l = 0, c = t.length; l < c; l += 2)
      r[l] = i + t[l + 1] * s, r[l + 1] = n + t[l] * o;
    return r;
  }
  static _translate(t, i, n, s) {
    s || (s = new Float32Array(t.length));
    for (let o = 0, r = t.length; o < r; o += 2)
      s[o] = i + t[o], s[o + 1] = n + t[o + 1];
    return s;
  }
  static svgRound(t) {
    return Math.round(t * 1e4);
  }
  static _normalizePoint(t, i, n, s, o) {
    switch (o) {
      case 90:
        return [1 - i / n, t / s];
      case 180:
        return [1 - t / n, 1 - i / s];
      case 270:
        return [i / n, 1 - t / s];
      default:
        return [t / n, i / s];
    }
  }
  static _normalizePagePoint(t, i, n) {
    switch (n) {
      case 90:
        return [1 - i, t];
      case 180:
        return [1 - t, 1 - i];
      case 270:
        return [i, 1 - t];
      default:
        return [t, i];
    }
  }
  static createBezierPoints(t, i, n, s, o, r) {
    return [(t + 5 * n) / 6, (i + 5 * s) / 6, (5 * n + o) / 6, (5 * s + r) / 6, (n + o) / 2, (s + r) / 2];
  }
}
Zi(Wn, "PRECISION", 1e-4);
var c2, wv, Nj, Dj, Hb, qo, XB, eF, ote, rte, Cj, Oj, kx, lte, eae, tae, Tf, fQ, RRe, vRe, ARe, SRe, bRe, NRe;
const bC = class bC {
  constructor({
    x: t,
    y: i
  }, n, s, o, r, l = 0) {
    xe(this, Tf);
    xe(this, c2);
    xe(this, wv, []);
    xe(this, Nj);
    xe(this, Dj);
    xe(this, Hb, []);
    xe(this, qo, new Float32Array(18));
    xe(this, XB);
    xe(this, eF);
    xe(this, ote);
    xe(this, rte);
    xe(this, Cj);
    xe(this, Oj);
    xe(this, kx, []);
    be(this, c2, n), be(this, Oj, o * s), be(this, Dj, r), S(this, qo).set([NaN, NaN, NaN, NaN, t, i], 6), be(this, Nj, l), be(this, rte, S(bC, lte) * s), be(this, ote, S(bC, tae) * s), be(this, Cj, s), S(this, kx).push(t, i);
  }
  isEmpty() {
    return isNaN(S(this, qo)[8]);
  }
  add({
    x: t,
    y: i
  }) {
    var te;
    be(this, XB, t), be(this, eF, i);
    const [n, s, o, r] = S(this, c2);
    let [l, c, h, I] = S(this, qo).subarray(8, 12);
    const p = t - h, y = i - I, m = Math.hypot(p, y);
    if (m < S(this, ote))
      return !1;
    const A = m - S(this, rte), C = A / m, O = C * p, R = C * y;
    let F = l, L = c;
    l = h, c = I, h += O, I += R, (te = S(this, kx)) == null || te.push(t, i);
    const P = -R / A, z = O / A, W = P * S(this, Oj), re = z * S(this, Oj);
    return S(this, qo).set(S(this, qo).subarray(2, 8), 0), S(this, qo).set([h + W, I + re], 4), S(this, qo).set(S(this, qo).subarray(14, 18), 12), S(this, qo).set([h - W, I - re], 16), isNaN(S(this, qo)[6]) ? (S(this, Hb).length === 0 && (S(this, qo).set([l + W, c + re], 2), S(this, Hb).push(NaN, NaN, NaN, NaN, (l + W - n) / o, (c + re - s) / r), S(this, qo).set([l - W, c - re], 14), S(this, wv).push(NaN, NaN, NaN, NaN, (l - W - n) / o, (c - re - s) / r)), S(this, qo).set([F, L, l, c, h, I], 6), !this.isEmpty()) : (S(this, qo).set([F, L, l, c, h, I], 6), Math.abs(Math.atan2(L - c, F - l) - Math.atan2(R, O)) < Math.PI / 2 ? ([l, c, h, I] = S(this, qo).subarray(2, 6), S(this, Hb).push(NaN, NaN, NaN, NaN, ((l + h) / 2 - n) / o, ((c + I) / 2 - s) / r), [l, c, F, L] = S(this, qo).subarray(14, 18), S(this, wv).push(NaN, NaN, NaN, NaN, ((F + l) / 2 - n) / o, ((L + c) / 2 - s) / r), !0) : ([F, L, l, c, h, I] = S(this, qo).subarray(0, 6), S(this, Hb).push(((F + 5 * l) / 6 - n) / o, ((L + 5 * c) / 6 - s) / r, ((5 * l + h) / 6 - n) / o, ((5 * c + I) / 6 - s) / r, ((l + h) / 2 - n) / o, ((c + I) / 2 - s) / r), [h, I, l, c, F, L] = S(this, qo).subarray(12, 18), S(this, wv).push(((F + 5 * l) / 6 - n) / o, ((L + 5 * c) / 6 - s) / r, ((5 * l + h) / 6 - n) / o, ((5 * c + I) / 6 - s) / r, ((l + h) / 2 - n) / o, ((c + I) / 2 - s) / r), !0));
  }
  toSVGPath() {
    if (this.isEmpty())
      return "";
    const t = S(this, Hb), i = S(this, wv);
    if (isNaN(S(this, qo)[6]) && !this.isEmpty())
      return _e(this, Tf, RRe).call(this);
    const n = [];
    n.push(`M${t[4]} ${t[5]}`);
    for (let s = 6; s < t.length; s += 6)
      isNaN(t[s]) ? n.push(`L${t[s + 4]} ${t[s + 5]}`) : n.push(`C${t[s]} ${t[s + 1]} ${t[s + 2]} ${t[s + 3]} ${t[s + 4]} ${t[s + 5]}`);
    _e(this, Tf, ARe).call(this, n);
    for (let s = i.length - 6; s >= 6; s -= 6)
      isNaN(i[s]) ? n.push(`L${i[s + 4]} ${i[s + 5]}`) : n.push(`C${i[s]} ${i[s + 1]} ${i[s + 2]} ${i[s + 3]} ${i[s + 4]} ${i[s + 5]}`);
    return _e(this, Tf, vRe).call(this, n), n.join(" ");
  }
  newFreeDrawOutline(t, i, n, s, o, r) {
    return new DRe(t, i, n, s, o, r);
  }
  getOutlines() {
    var p;
    const t = S(this, Hb), i = S(this, wv), n = S(this, qo), [s, o, r, l] = S(this, c2), c = new Float32Array((((p = S(this, kx)) == null ? void 0 : p.length) ?? 0) + 2);
    for (let y = 0, m = c.length - 2; y < m; y += 2)
      c[y] = (S(this, kx)[y] - s) / r, c[y + 1] = (S(this, kx)[y + 1] - o) / l;
    if (c[c.length - 2] = (S(this, XB) - s) / r, c[c.length - 1] = (S(this, eF) - o) / l, isNaN(n[6]) && !this.isEmpty())
      return _e(this, Tf, SRe).call(this, c);
    const h = new Float32Array(S(this, Hb).length + 24 + S(this, wv).length);
    let I = t.length;
    for (let y = 0; y < I; y += 2) {
      if (isNaN(t[y])) {
        h[y] = h[y + 1] = NaN;
        continue;
      }
      h[y] = t[y], h[y + 1] = t[y + 1];
    }
    I = _e(this, Tf, NRe).call(this, h, I);
    for (let y = i.length - 6; y >= 6; y -= 6)
      for (let m = 0; m < 6; m += 2) {
        if (isNaN(i[y + m])) {
          h[I] = h[I + 1] = NaN, I += 2;
          continue;
        }
        h[I] = i[y + m], h[I + 1] = i[y + m + 1], I += 2;
      }
    return _e(this, Tf, bRe).call(this, h, I), this.newFreeDrawOutline(h, c, S(this, c2), S(this, Cj), S(this, Nj), S(this, Dj));
  }
};
c2 = new WeakMap(), wv = new WeakMap(), Nj = new WeakMap(), Dj = new WeakMap(), Hb = new WeakMap(), qo = new WeakMap(), XB = new WeakMap(), eF = new WeakMap(), ote = new WeakMap(), rte = new WeakMap(), Cj = new WeakMap(), Oj = new WeakMap(), kx = new WeakMap(), lte = new WeakMap(), eae = new WeakMap(), tae = new WeakMap(), Tf = new WeakSet(), fQ = function() {
  const t = S(this, qo).subarray(4, 6), i = S(this, qo).subarray(16, 18), [n, s, o, r] = S(this, c2);
  return [(S(this, XB) + (t[0] - i[0]) / 2 - n) / o, (S(this, eF) + (t[1] - i[1]) / 2 - s) / r, (S(this, XB) + (i[0] - t[0]) / 2 - n) / o, (S(this, eF) + (i[1] - t[1]) / 2 - s) / r];
}, RRe = function() {
  const [t, i, n, s] = S(this, c2), [o, r, l, c] = _e(this, Tf, fQ).call(this);
  return `M${(S(this, qo)[2] - t) / n} ${(S(this, qo)[3] - i) / s} L${(S(this, qo)[4] - t) / n} ${(S(this, qo)[5] - i) / s} L${o} ${r} L${l} ${c} L${(S(this, qo)[16] - t) / n} ${(S(this, qo)[17] - i) / s} L${(S(this, qo)[14] - t) / n} ${(S(this, qo)[15] - i) / s} Z`;
}, vRe = function(t) {
  const i = S(this, wv);
  t.push(`L${i[4]} ${i[5]} Z`);
}, ARe = function(t) {
  const [i, n, s, o] = S(this, c2), r = S(this, qo).subarray(4, 6), l = S(this, qo).subarray(16, 18), [c, h, I, p] = _e(this, Tf, fQ).call(this);
  t.push(`L${(r[0] - i) / s} ${(r[1] - n) / o} L${c} ${h} L${I} ${p} L${(l[0] - i) / s} ${(l[1] - n) / o}`);
}, SRe = function(t) {
  const i = S(this, qo), [n, s, o, r] = S(this, c2), [l, c, h, I] = _e(this, Tf, fQ).call(this), p = new Float32Array(36);
  return p.set([NaN, NaN, NaN, NaN, (i[2] - n) / o, (i[3] - s) / r, NaN, NaN, NaN, NaN, (i[4] - n) / o, (i[5] - s) / r, NaN, NaN, NaN, NaN, l, c, NaN, NaN, NaN, NaN, h, I, NaN, NaN, NaN, NaN, (i[16] - n) / o, (i[17] - s) / r, NaN, NaN, NaN, NaN, (i[14] - n) / o, (i[15] - s) / r], 0), this.newFreeDrawOutline(p, t, S(this, c2), S(this, Cj), S(this, Nj), S(this, Dj));
}, bRe = function(t, i) {
  const n = S(this, wv);
  return t.set([NaN, NaN, NaN, NaN, n[4], n[5]], i), i += 6;
}, NRe = function(t, i) {
  const n = S(this, qo).subarray(4, 6), s = S(this, qo).subarray(16, 18), [o, r, l, c] = S(this, c2), [h, I, p, y] = _e(this, Tf, fQ).call(this);
  return t.set([NaN, NaN, NaN, NaN, (n[0] - o) / l, (n[1] - r) / c, NaN, NaN, NaN, NaN, h, I, NaN, NaN, NaN, NaN, p, y, NaN, NaN, NaN, NaN, (s[0] - o) / l, (s[1] - r) / c], i), i += 24;
}, xe(bC, lte, 8), xe(bC, eae, 2), xe(bC, tae, S(bC, lte) + S(bC, eae));
let ule = bC;
var Lj, tF, XC, ate, h2, ute, e0, iae, CRe;
class DRe extends Wn {
  constructor(i, n, s, o, r, l) {
    super();
    xe(this, iae);
    xe(this, Lj);
    xe(this, tF, new Float32Array(4));
    xe(this, XC);
    xe(this, ate);
    xe(this, h2);
    xe(this, ute);
    xe(this, e0);
    be(this, e0, i), be(this, h2, n), be(this, Lj, s), be(this, ute, o), be(this, XC, r), be(this, ate, l), this.lastPoint = [NaN, NaN], _e(this, iae, CRe).call(this, l);
    const [c, h, I, p] = S(this, tF);
    for (let y = 0, m = i.length; y < m; y += 2)
      i[y] = (i[y] - c) / I, i[y + 1] = (i[y + 1] - h) / p;
    for (let y = 0, m = n.length; y < m; y += 2)
      n[y] = (n[y] - c) / I, n[y + 1] = (n[y + 1] - h) / p;
  }
  toSVGPath() {
    const i = [`M${S(this, e0)[4]} ${S(this, e0)[5]}`];
    for (let n = 6, s = S(this, e0).length; n < s; n += 6) {
      if (isNaN(S(this, e0)[n])) {
        i.push(`L${S(this, e0)[n + 4]} ${S(this, e0)[n + 5]}`);
        continue;
      }
      i.push(`C${S(this, e0)[n]} ${S(this, e0)[n + 1]} ${S(this, e0)[n + 2]} ${S(this, e0)[n + 3]} ${S(this, e0)[n + 4]} ${S(this, e0)[n + 5]}`);
    }
    return i.push("Z"), i.join(" ");
  }
  serialize([i, n, s, o], r) {
    const l = s - i, c = o - n;
    let h, I;
    switch (r) {
      case 0:
        h = Wn._rescale(S(this, e0), i, o, l, -c), I = Wn._rescale(S(this, h2), i, o, l, -c);
        break;
      case 90:
        h = Wn._rescaleAndSwap(S(this, e0), i, n, l, c), I = Wn._rescaleAndSwap(S(this, h2), i, n, l, c);
        break;
      case 180:
        h = Wn._rescale(S(this, e0), s, n, -l, c), I = Wn._rescale(S(this, h2), s, n, -l, c);
        break;
      case 270:
        h = Wn._rescaleAndSwap(S(this, e0), s, o, -l, -c), I = Wn._rescaleAndSwap(S(this, h2), s, o, -l, -c);
        break;
    }
    return {
      outline: Array.from(h),
      points: [Array.from(I)]
    };
  }
  get box() {
    return S(this, tF);
  }
  newOutliner(i, n, s, o, r, l = 0) {
    return new ule(i, n, s, o, r, l);
  }
  getNewOutline(i, n) {
    const [s, o, r, l] = S(this, tF), [c, h, I, p] = S(this, Lj), y = r * I, m = l * p, A = s * I + c, C = o * p + h, O = this.newOutliner({
      x: S(this, h2)[0] * y + A,
      y: S(this, h2)[1] * m + C
    }, S(this, Lj), S(this, ute), i, S(this, ate), n ?? S(this, XC));
    for (let R = 2; R < S(this, h2).length; R += 2)
      O.add({
        x: S(this, h2)[R] * y + A,
        y: S(this, h2)[R + 1] * m + C
      });
    return O.getOutlines();
  }
}
Lj = new WeakMap(), tF = new WeakMap(), XC = new WeakMap(), ate = new WeakMap(), h2 = new WeakMap(), ute = new WeakMap(), e0 = new WeakMap(), iae = new WeakSet(), CRe = function(i) {
  const n = S(this, e0);
  let s = n[4], o = n[5];
  const r = [s, o, s, o];
  let l = s, c = o;
  const h = i ? Math.max : Math.min;
  for (let p = 6, y = n.length; p < y; p += 6) {
    const m = n[p + 4], A = n[p + 5];
    if (isNaN(n[p]))
      ys.pointBoundingBox(m, A, r), c < A ? (l = m, c = A) : c === A && (l = h(l, m));
    else {
      const C = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
      ys.bezierBoundingBox(s, o, ...n.slice(p, p + 6), C), ys.rectBoundingBox(...C, r), c < C[3] ? (l = C[2], c = C[3]) : c === C[3] && (l = h(l, C[2]));
    }
    s = m, o = A;
  }
  const I = S(this, tF);
  I[0] = r[0] - S(this, XC), I[1] = r[1] - S(this, XC), I[2] = r[2] - r[0] + 2 * S(this, XC), I[3] = r[3] - r[1] + 2 * S(this, XC), this.lastPoint = [l, c];
};
var dte, cte, Vx, Tv, aE, ORe, foe, LRe, _Re, efe;
class Xhe {
  constructor(t, i = 0, n = 0, s = !0) {
    xe(this, aE);
    xe(this, dte);
    xe(this, cte);
    xe(this, Vx, []);
    xe(this, Tv, []);
    const o = [1 / 0, 1 / 0, -1 / 0, -1 / 0], r = 10 ** -4;
    for (const {
      x: m,
      y: A,
      width: C,
      height: O
    } of t) {
      const R = Math.floor((m - i) / r) * r, F = Math.ceil((m + C + i) / r) * r, L = Math.floor((A - i) / r) * r, P = Math.ceil((A + O + i) / r) * r, z = [R, L, P, !0], W = [F, L, P, !1];
      S(this, Vx).push(z, W), ys.rectBoundingBox(R, L, F, P, o);
    }
    const l = o[2] - o[0] + 2 * n, c = o[3] - o[1] + 2 * n, h = o[0] - n, I = o[1] - n, p = S(this, Vx).at(s ? -1 : -2), y = [p[0], p[2]];
    for (const m of S(this, Vx)) {
      const [A, C, O] = m;
      m[0] = (A - h) / l, m[1] = (C - I) / c, m[2] = (O - I) / c;
    }
    be(this, dte, new Float32Array([h, I, l, c])), be(this, cte, y);
  }
  getOutlines() {
    S(this, Vx).sort((i, n) => i[0] - n[0] || i[1] - n[1] || i[2] - n[2]);
    const t = [];
    for (const i of S(this, Vx))
      i[3] ? (t.push(..._e(this, aE, efe).call(this, i)), _e(this, aE, LRe).call(this, i)) : (_e(this, aE, _Re).call(this, i), t.push(..._e(this, aE, efe).call(this, i)));
    return _e(this, aE, ORe).call(this, t);
  }
}
dte = new WeakMap(), cte = new WeakMap(), Vx = new WeakMap(), Tv = new WeakMap(), aE = new WeakSet(), ORe = function(t) {
  const i = [], n = /* @__PURE__ */ new Set();
  for (const r of t) {
    const [l, c, h] = r;
    i.push([l, c, r], [l, h, r]);
  }
  i.sort((r, l) => r[1] - l[1] || r[0] - l[0]);
  for (let r = 0, l = i.length; r < l; r += 2) {
    const c = i[r][2], h = i[r + 1][2];
    c.push(h), h.push(c), n.add(c), n.add(h);
  }
  const s = [];
  let o;
  for (; n.size > 0; ) {
    const r = n.values().next().value;
    let [l, c, h, I, p] = r;
    n.delete(r);
    let y = l, m = c;
    for (o = [l, h], s.push(o); ; ) {
      let A;
      if (n.has(I))
        A = I;
      else if (n.has(p))
        A = p;
      else
        break;
      n.delete(A), [l, c, h, I, p] = A, y !== l && (o.push(y, m, l, m === c ? c : h), y = l), m = m === c ? h : c;
    }
    o.push(y, m);
  }
  return new Qxe(s, S(this, dte), S(this, cte));
}, foe = function(t) {
  const i = S(this, Tv);
  let n = 0, s = i.length - 1;
  for (; n <= s; ) {
    const o = n + s >> 1, r = i[o][0];
    if (r === t)
      return o;
    r < t ? n = o + 1 : s = o - 1;
  }
  return s + 1;
}, LRe = function([, t, i]) {
  const n = _e(this, aE, foe).call(this, t);
  S(this, Tv).splice(n, 0, [t, i]);
}, _Re = function([, t, i]) {
  const n = _e(this, aE, foe).call(this, t);
  for (let s = n; s < S(this, Tv).length; s++) {
    const [o, r] = S(this, Tv)[s];
    if (o !== t)
      break;
    if (o === t && r === i) {
      S(this, Tv).splice(s, 1);
      return;
    }
  }
  for (let s = n - 1; s >= 0; s--) {
    const [o, r] = S(this, Tv)[s];
    if (o !== t)
      break;
    if (o === t && r === i) {
      S(this, Tv).splice(s, 1);
      return;
    }
  }
}, efe = function(t) {
  const [i, n, s] = t, o = [[i, n, s]], r = _e(this, aE, foe).call(this, s);
  for (let l = 0; l < r; l++) {
    const [c, h] = S(this, Tv)[l];
    for (let I = 0, p = o.length; I < p; I++) {
      const [, y, m] = o[I];
      if (!(h <= y || m <= c)) {
        if (y >= c) {
          if (m > h)
            o[I][1] = h;
          else {
            if (p === 1)
              return [];
            o.splice(I, 1), I--, p--;
          }
          continue;
        }
        o[I][2] = c, m > h && o.push([i, h, m]);
      }
    }
  }
  return o;
};
var hte, _j;
class Qxe extends Wn {
  constructor(i, n, s) {
    super();
    xe(this, hte);
    xe(this, _j);
    be(this, _j, i), be(this, hte, n), this.lastPoint = s;
  }
  toSVGPath() {
    const i = [];
    for (const n of S(this, _j)) {
      let [s, o] = n;
      i.push(`M${s} ${o}`);
      for (let r = 2; r < n.length; r += 2) {
        const l = n[r], c = n[r + 1];
        l === s ? (i.push(`V${c}`), o = c) : c === o && (i.push(`H${l}`), s = l);
      }
      i.push("Z");
    }
    return i.join(" ");
  }
  serialize([i, n, s, o], r) {
    const l = [], c = s - i, h = o - n;
    for (const I of S(this, _j)) {
      const p = new Array(I.length);
      for (let y = 0; y < I.length; y += 2)
        p[y] = i + I[y] * c, p[y + 1] = o - I[y + 1] * h;
      l.push(p);
    }
    return l;
  }
  get box() {
    return S(this, hte);
  }
  get classNamesForOutlining() {
    return ["highlightOutline"];
  }
}
hte = new WeakMap(), _j = new WeakMap();
class tfe extends ule {
  newFreeDrawOutline(t, i, n, s, o, r) {
    return new Jxe(t, i, n, s, o, r);
  }
}
class Jxe extends DRe {
  newOutliner(t, i, n, s, o, r = 0) {
    return new tfe(t, i, n, s, o, r);
  }
}
var xj, fte, eO, iF, Ite, hg, pte, mte, nF, XT, f2, Rp, Pj, tO, Mm, Mj, e5, yte, mo, ife, Ioe, xRe, PRe, MRe, nfe, aU, m5, vV, URe, poe, IQ, BRe, FRe, HRe, GRe, kRe;
const rl = class rl extends na {
  constructor(i) {
    super({
      ...i,
      name: "highlightEditor"
    });
    xe(this, mo);
    xe(this, xj, null);
    xe(this, fte, 0);
    xe(this, eO);
    xe(this, iF, null);
    xe(this, Ite, null);
    xe(this, hg, null);
    xe(this, pte, null);
    xe(this, mte, 0);
    xe(this, nF, null);
    xe(this, XT, null);
    xe(this, f2, null);
    xe(this, Rp, !1);
    xe(this, Pj, null);
    xe(this, tO);
    xe(this, Mm, null);
    xe(this, Mj, "");
    xe(this, e5);
    xe(this, yte, "");
    this.color = i.color || rl._defaultColor, be(this, e5, i.thickness || rl._defaultThickness), be(this, tO, i.opacity || rl._defaultOpacity), be(this, eO, i.boxes || null), be(this, yte, i.methodOfCreation || ""), be(this, Mj, i.text || ""), this._isDraggable = !1, this.defaultL10nId = "pdfjs-editor-highlight-editor", i.highlightId > -1 ? (be(this, Rp, !0), _e(this, mo, Ioe).call(this, i), _e(this, mo, aU).call(this)) : S(this, eO) && (be(this, xj, i.anchorNode), be(this, fte, i.anchorOffset), be(this, pte, i.focusNode), be(this, mte, i.focusOffset), _e(this, mo, ife).call(this), _e(this, mo, aU).call(this), this.rotate(this.rotation)), this.annotationElementId || this._uiManager.a11yAlert("pdfjs-editor-highlight-added-alert");
  }
  static get _keyboardManager() {
    const i = rl.prototype;
    return Zo(this, "_keyboardManager", new Iie([[["ArrowLeft", "mac+ArrowLeft"], i._moveCaret, {
      args: [0]
    }], [["ArrowRight", "mac+ArrowRight"], i._moveCaret, {
      args: [1]
    }], [["ArrowUp", "mac+ArrowUp"], i._moveCaret, {
      args: [2]
    }], [["ArrowDown", "mac+ArrowDown"], i._moveCaret, {
      args: [3]
    }]]));
  }
  get telemetryInitialData() {
    return {
      action: "added",
      type: S(this, Rp) ? "free_highlight" : "highlight",
      color: this._uiManager.getNonHCMColorName(this.color),
      thickness: S(this, e5),
      methodOfCreation: S(this, yte)
    };
  }
  get telemetryFinalData() {
    return {
      type: "highlight",
      color: this._uiManager.getNonHCMColorName(this.color)
    };
  }
  get commentColor() {
    return this.color;
  }
  static computeTelemetryFinalData(i) {
    return {
      numberOfColors: i.get("color").size
    };
  }
  static initialize(i, n) {
    var s;
    na.initialize(i, n), rl._defaultColor || (rl._defaultColor = ((s = n.highlightColors) == null ? void 0 : s.values().next().value) || "#fff066");
  }
  static updateDefaultParams(i, n) {
    switch (i) {
      case Ir.HIGHLIGHT_COLOR:
        rl._defaultColor = n;
        break;
      case Ir.HIGHLIGHT_THICKNESS:
        rl._defaultThickness = n;
        break;
    }
  }
  translateInPage(i, n) {
  }
  get toolbarPosition() {
    return S(this, Pj);
  }
  updateParams(i, n) {
    switch (i) {
      case Ir.HIGHLIGHT_COLOR:
        _e(this, mo, xRe).call(this, n);
        break;
      case Ir.HIGHLIGHT_THICKNESS:
        _e(this, mo, PRe).call(this, n);
        break;
    }
  }
  static get defaultPropertiesToUpdate() {
    return [[Ir.HIGHLIGHT_COLOR, rl._defaultColor], [Ir.HIGHLIGHT_THICKNESS, rl._defaultThickness]];
  }
  get propertiesToUpdate() {
    return [[Ir.HIGHLIGHT_COLOR, this.color || rl._defaultColor], [Ir.HIGHLIGHT_THICKNESS, S(this, e5) || rl._defaultThickness], [Ir.HIGHLIGHT_FREE, S(this, Rp)]];
  }
  get toolbarButtons() {
    return this._uiManager.highlightColors ? [["colorPicker", be(this, Ite, new iRe({
      editor: this
    }))]] : super.toolbarButtons;
  }
  disableEditing() {
    super.disableEditing(), this.div.classList.toggle("disabled", !0);
  }
  enableEditing() {
    super.enableEditing(), this.div.classList.toggle("disabled", !1);
  }
  fixAndSetPosition() {
    return super.fixAndSetPosition(_e(this, mo, IQ).call(this));
  }
  getBaseTranslation() {
    return [0, 0];
  }
  getRect(i, n) {
    return super.getRect(i, n, _e(this, mo, IQ).call(this));
  }
  onceAdded(i) {
    this.annotationElementId || this.parent.addUndoableEditor(this), i && this.div.focus();
  }
  remove() {
    _e(this, mo, nfe).call(this), this._reportTelemetry({
      action: "deleted"
    }), super.remove();
  }
  rebuild() {
    this.parent && (super.rebuild(), this.div !== null && (_e(this, mo, aU).call(this), this.isAttachedToDOM || this.parent.add(this)));
  }
  setParent(i) {
    var s;
    let n = !1;
    this.parent && !i ? _e(this, mo, nfe).call(this) : i && (_e(this, mo, aU).call(this, i), n = !this.parent && ((s = this.div) == null ? void 0 : s.classList.contains("selectedEditor"))), super.setParent(i), this.show(this._isVisible), n && this.select();
  }
  rotate(i) {
    var o, r, l;
    const {
      drawLayer: n
    } = this.parent;
    let s;
    S(this, Rp) ? (i = (i - this.rotation + 360) % 360, s = _e(o = rl, m5, vV).call(o, S(this, XT).box, i)) : s = _e(r = rl, m5, vV).call(r, [this.x, this.y, this.width, this.height], i), n.updateProperties(S(this, f2), {
      bbox: s,
      root: {
        "data-main-rotation": i
      }
    }), n.updateProperties(S(this, Mm), {
      bbox: _e(l = rl, m5, vV).call(l, S(this, hg).box, i),
      root: {
        "data-main-rotation": i
      }
    });
  }
  render() {
    if (this.div)
      return this.div;
    const i = super.render();
    S(this, Mj) && (i.setAttribute("aria-label", S(this, Mj)), i.setAttribute("role", "mark")), S(this, Rp) ? i.classList.add("free") : this.div.addEventListener("keydown", _e(this, mo, URe).bind(this), {
      signal: this._uiManager._signal
    });
    const n = be(this, nF, document.createElement("div"));
    i.append(n), n.setAttribute("aria-hidden", "true"), n.className = "internal", n.style.clipPath = S(this, iF);
    const [s, o] = this.parentDimensions;
    return this.setDims(this.width * s, this.height * o), s5e(this, S(this, nF), ["pointerover", "pointerleave"]), this.enableEditing(), i;
  }
  pointerover() {
    var i;
    this.isSelected || (i = this.parent) == null || i.drawLayer.updateProperties(S(this, Mm), {
      rootClass: {
        hovered: !0
      }
    });
  }
  pointerleave() {
    var i;
    this.isSelected || (i = this.parent) == null || i.drawLayer.updateProperties(S(this, Mm), {
      rootClass: {
        hovered: !1
      }
    });
  }
  _moveCaret(i) {
    switch (this.parent.unselect(this), i) {
      case 0:
      case 2:
        _e(this, mo, poe).call(this, !0);
        break;
      case 1:
      case 3:
        _e(this, mo, poe).call(this, !1);
        break;
    }
  }
  select() {
    var i;
    super.select(), S(this, Mm) && ((i = this.parent) == null || i.drawLayer.updateProperties(S(this, Mm), {
      rootClass: {
        hovered: !1,
        selected: !0
      }
    }));
  }
  unselect() {
    var i;
    super.unselect(), S(this, Mm) && ((i = this.parent) == null || i.drawLayer.updateProperties(S(this, Mm), {
      rootClass: {
        selected: !1
      }
    }), S(this, Rp) || _e(this, mo, poe).call(this, !1));
  }
  get _mustFixPosition() {
    return !S(this, Rp);
  }
  show(i = this._isVisible) {
    super.show(i), this.parent && (this.parent.drawLayer.updateProperties(S(this, f2), {
      rootClass: {
        hidden: !i
      }
    }), this.parent.drawLayer.updateProperties(S(this, Mm), {
      rootClass: {
        hidden: !i
      }
    }));
  }
  static startHighlighting(i, n, {
    target: s,
    x: o,
    y: r
  }) {
    const {
      x: l,
      y: c,
      width: h,
      height: I
    } = s.getBoundingClientRect(), p = new AbortController(), y = i.combinedSignal(p), m = (A) => {
      p.abort(), _e(this, m5, GRe).call(this, i, A);
    };
    window.addEventListener("blur", m, {
      signal: y
    }), window.addEventListener("pointerup", m, {
      signal: y
    }), window.addEventListener("pointerdown", P0, {
      capture: !0,
      passive: !1,
      signal: y
    }), window.addEventListener("contextmenu", F5, {
      signal: y
    }), s.addEventListener("pointermove", _e(this, m5, HRe).bind(this, i), {
      signal: y
    }), this._freeHighlight = new tfe({
      x: o,
      y: r
    }, [l, c, h, I], i.scale, this._defaultThickness / 2, n, 1e-3), {
      id: this._freeHighlightId,
      clipPathId: this._freeHighlightClipId
    } = i.drawLayer.draw({
      bbox: [0, 0, 1, 1],
      root: {
        viewBox: "0 0 1 1",
        fill: this._defaultColor,
        "fill-opacity": this._defaultOpacity
      },
      rootClass: {
        highlight: !0,
        free: !0
      },
      path: {
        d: this._freeHighlight.toSVGPath()
      }
    }, !0, !0);
  }
  static async deserialize(i, n, s) {
    var C, O, R, F;
    let o = null;
    if (i instanceof IRe) {
      const {
        data: {
          quadPoints: L,
          rect: P,
          rotation: z,
          id: W,
          color: re,
          opacity: ce,
          popupRef: te,
          contentsObj: ee
        },
        parent: {
          page: {
            pageNumber: Ne
          }
        }
      } = i;
      o = i = {
        annotationType: eo.HIGHLIGHT,
        color: Array.from(re),
        opacity: ce,
        quadPoints: L,
        boxes: null,
        pageIndex: Ne - 1,
        rect: P.slice(0),
        rotation: z,
        annotationElementId: W,
        id: W,
        deleted: !1,
        popupRef: te,
        comment: (ee == null ? void 0 : ee.str) || null
      };
    } else if (i instanceof _pe) {
      const {
        data: {
          inkLists: L,
          rect: P,
          rotation: z,
          id: W,
          color: re,
          borderStyle: {
            rawWidth: ce
          },
          popupRef: te,
          contentsObj: ee
        },
        parent: {
          page: {
            pageNumber: Ne
          }
        }
      } = i;
      o = i = {
        annotationType: eo.HIGHLIGHT,
        color: Array.from(re),
        thickness: ce,
        inkLists: L,
        boxes: null,
        pageIndex: Ne - 1,
        rect: P.slice(0),
        rotation: z,
        annotationElementId: W,
        id: W,
        deleted: !1,
        popupRef: te,
        comment: (ee == null ? void 0 : ee.str) || null
      };
    }
    const {
      color: r,
      quadPoints: l,
      inkLists: c,
      opacity: h
    } = i, I = await super.deserialize(i, n, s);
    I.color = ys.makeHexColor(...r), be(I, tO, h || 1), c && be(I, e5, i.thickness), I._initialData = o, i.comment && I.setCommentData(i.comment);
    const [p, y] = I.pageDimensions, [m, A] = I.pageTranslation;
    if (l) {
      const L = be(I, eO, []);
      for (let P = 0; P < l.length; P += 8)
        L.push({
          x: (l[P] - m) / p,
          y: 1 - (l[P + 1] - A) / y,
          width: (l[P + 2] - l[P]) / p,
          height: (l[P + 1] - l[P + 5]) / y
        });
      _e(C = I, mo, ife).call(C), _e(O = I, mo, aU).call(O), I.rotate(I.rotation);
    } else if (c) {
      be(I, Rp, !0);
      const L = c[0], P = {
        x: L[0] - m,
        y: y - (L[1] - A)
      }, z = new tfe(P, [0, 0, p, y], 1, S(I, e5) / 2, !0, 1e-3);
      for (let ce = 0, te = L.length; ce < te; ce += 2)
        P.x = L[ce] - m, P.y = y - (L[ce + 1] - A), z.add(P);
      const {
        id: W,
        clipPathId: re
      } = n.drawLayer.draw({
        bbox: [0, 0, 1, 1],
        root: {
          viewBox: "0 0 1 1",
          fill: I.color,
          "fill-opacity": I._defaultOpacity
        },
        rootClass: {
          highlight: !0,
          free: !0
        },
        path: {
          d: z.toSVGPath()
        }
      }, !0, !0);
      _e(R = I, mo, Ioe).call(R, {
        highlightOutlines: z.getOutlines(),
        highlightId: W,
        clipPathId: re
      }), _e(F = I, mo, aU).call(F), I.rotate(I.parentRotation);
    }
    return I;
  }
  serialize(i = !1) {
    if (this.isEmpty() || i)
      return null;
    if (this.deleted)
      return this.serializeDeleted();
    const n = this.getRect(0, 0), s = na._colorManager.convert(this._uiManager.getNonHCMColor(this.color)), o = {
      annotationType: eo.HIGHLIGHT,
      color: s,
      opacity: S(this, tO),
      thickness: S(this, e5),
      quadPoints: _e(this, mo, BRe).call(this),
      outlines: _e(this, mo, FRe).call(this, n),
      pageIndex: this.pageIndex,
      rect: n,
      rotation: _e(this, mo, IQ).call(this),
      structTreeParentId: this._structTreeParentId
    };
    return this.addComment(o), this.annotationElementId && !_e(this, mo, kRe).call(this, o) ? null : (o.id = this.annotationElementId, o);
  }
  renderAnnotationElement(i) {
    const n = {
      rect: this.getRect(0, 0)
    };
    return this.hasEditedComment && (n.popup = this.comment), i.updateEdited(n), null;
  }
  static canCreateNewEmptyEditor() {
    return !1;
  }
};
xj = new WeakMap(), fte = new WeakMap(), eO = new WeakMap(), iF = new WeakMap(), Ite = new WeakMap(), hg = new WeakMap(), pte = new WeakMap(), mte = new WeakMap(), nF = new WeakMap(), XT = new WeakMap(), f2 = new WeakMap(), Rp = new WeakMap(), Pj = new WeakMap(), tO = new WeakMap(), Mm = new WeakMap(), Mj = new WeakMap(), e5 = new WeakMap(), yte = new WeakMap(), mo = new WeakSet(), ife = function() {
  const i = new Xhe(S(this, eO), 1e-3);
  be(this, XT, i.getOutlines()), [this.x, this.y, this.width, this.height] = S(this, XT).box;
  const n = new Xhe(S(this, eO), 25e-4, 1e-3, this._uiManager.direction === "ltr");
  be(this, hg, n.getOutlines());
  const {
    lastPoint: s
  } = S(this, hg);
  be(this, Pj, [(s[0] - this.x) / this.width, (s[1] - this.y) / this.height]);
}, Ioe = function({
  highlightOutlines: i,
  highlightId: n,
  clipPathId: s
}) {
  var p, y;
  if (be(this, XT, i), be(this, hg, i.getNewOutline(S(this, e5) / 2 + 1.5, 25e-4)), n >= 0)
    be(this, f2, n), be(this, iF, s), this.parent.drawLayer.finalizeDraw(n, {
      bbox: i.box,
      path: {
        d: i.toSVGPath()
      }
    }), be(this, Mm, this.parent.drawLayer.drawOutline({
      rootClass: {
        highlightOutline: !0,
        free: !0
      },
      bbox: S(this, hg).box,
      path: {
        d: S(this, hg).toSVGPath()
      }
    }, !0));
  else if (this.parent) {
    const m = this.parent.viewport.rotation;
    this.parent.drawLayer.updateProperties(S(this, f2), {
      bbox: _e(p = rl, m5, vV).call(p, S(this, XT).box, (m - this.rotation + 360) % 360),
      path: {
        d: i.toSVGPath()
      }
    }), this.parent.drawLayer.updateProperties(S(this, Mm), {
      bbox: _e(y = rl, m5, vV).call(y, S(this, hg).box, m),
      path: {
        d: S(this, hg).toSVGPath()
      }
    });
  }
  const [r, l, c, h] = i.box;
  switch (this.rotation) {
    case 0:
      this.x = r, this.y = l, this.width = c, this.height = h;
      break;
    case 90: {
      const [m, A] = this.parentDimensions;
      this.x = l, this.y = 1 - r, this.width = c * A / m, this.height = h * m / A;
      break;
    }
    case 180:
      this.x = 1 - r, this.y = 1 - l, this.width = c, this.height = h;
      break;
    case 270: {
      const [m, A] = this.parentDimensions;
      this.x = 1 - l, this.y = r, this.width = c * A / m, this.height = h * m / A;
      break;
    }
  }
  const {
    lastPoint: I
  } = S(this, hg);
  be(this, Pj, [(I[0] - r) / c, (I[1] - l) / h]);
}, xRe = function(i) {
  const n = (r, l) => {
    var c, h;
    this.color = r, be(this, tO, l), (c = this.parent) == null || c.drawLayer.updateProperties(S(this, f2), {
      root: {
        fill: r,
        "fill-opacity": l
      }
    }), (h = S(this, Ite)) == null || h.updateColor(r);
  }, s = this.color, o = S(this, tO);
  this.addCommands({
    cmd: n.bind(this, i, rl._defaultOpacity),
    undo: n.bind(this, s, o),
    post: this._uiManager.updateUI.bind(this._uiManager, this),
    mustExec: !0,
    type: Ir.HIGHLIGHT_COLOR,
    overwriteIfSameType: !0,
    keepUndo: !0
  }), this._reportTelemetry({
    action: "color_changed",
    color: this._uiManager.getNonHCMColorName(i)
  }, !0);
}, PRe = function(i) {
  const n = S(this, e5), s = (o) => {
    be(this, e5, o), _e(this, mo, MRe).call(this, o);
  };
  this.addCommands({
    cmd: s.bind(this, i),
    undo: s.bind(this, n),
    post: this._uiManager.updateUI.bind(this._uiManager, this),
    mustExec: !0,
    type: Ir.INK_THICKNESS,
    overwriteIfSameType: !0,
    keepUndo: !0
  }), this._reportTelemetry({
    action: "thickness_changed",
    thickness: i
  }, !0);
}, MRe = function(i) {
  if (!S(this, Rp))
    return;
  _e(this, mo, Ioe).call(this, {
    highlightOutlines: S(this, XT).getNewOutline(i / 2)
  }), this.fixAndSetPosition();
  const [n, s] = this.parentDimensions;
  this.setDims(this.width * n, this.height * s);
}, nfe = function() {
  S(this, f2) === null || !this.parent || (this.parent.drawLayer.remove(S(this, f2)), be(this, f2, null), this.parent.drawLayer.remove(S(this, Mm)), be(this, Mm, null));
}, aU = function(i = this.parent) {
  S(this, f2) === null && ({
    id: hp(this, f2)._,
    clipPathId: hp(this, iF)._
  } = i.drawLayer.draw({
    bbox: S(this, XT).box,
    root: {
      viewBox: "0 0 1 1",
      fill: this.color,
      "fill-opacity": S(this, tO)
    },
    rootClass: {
      highlight: !0,
      free: S(this, Rp)
    },
    path: {
      d: S(this, XT).toSVGPath()
    }
  }, !1, !0), be(this, Mm, i.drawLayer.drawOutline({
    rootClass: {
      highlightOutline: !0,
      free: S(this, Rp)
    },
    bbox: S(this, hg).box,
    path: {
      d: S(this, hg).toSVGPath()
    }
  }, S(this, Rp))), S(this, nF) && (S(this, nF).style.clipPath = S(this, iF)));
}, m5 = new WeakSet(), vV = function([i, n, s, o], r) {
  switch (r) {
    case 90:
      return [1 - n - o, i, o, s];
    case 180:
      return [1 - i - s, 1 - n - o, s, o];
    case 270:
      return [n, 1 - i - s, o, s];
  }
  return [i, n, s, o];
}, URe = function(i) {
  rl._keyboardManager.exec(this, i);
}, poe = function(i) {
  if (!S(this, xj))
    return;
  const n = window.getSelection();
  i ? n.setPosition(S(this, xj), S(this, fte)) : n.setPosition(S(this, pte), S(this, mte));
}, IQ = function() {
  return S(this, Rp) ? this.rotation : 0;
}, BRe = function() {
  if (S(this, Rp))
    return null;
  const [i, n] = this.pageDimensions, [s, o] = this.pageTranslation, r = S(this, eO), l = new Float32Array(r.length * 8);
  let c = 0;
  for (const {
    x: h,
    y: I,
    width: p,
    height: y
  } of r) {
    const m = h * i + s, A = (1 - I) * n + o;
    l[c] = l[c + 4] = m, l[c + 1] = l[c + 3] = A, l[c + 2] = l[c + 6] = m + p * i, l[c + 5] = l[c + 7] = A - y * n, c += 8;
  }
  return l;
}, FRe = function(i) {
  return S(this, XT).serialize(i, _e(this, mo, IQ).call(this));
}, HRe = function(i, n) {
  this._freeHighlight.add(n) && i.drawLayer.updateProperties(this._freeHighlightId, {
    path: {
      d: this._freeHighlight.toSVGPath()
    }
  });
}, GRe = function(i, n) {
  this._freeHighlight.isEmpty() ? i.drawLayer.remove(this._freeHighlightId) : i.createAndAddNewEditor(n, !1, {
    highlightId: this._freeHighlightId,
    highlightOutlines: this._freeHighlight.getOutlines(),
    clipPathId: this._freeHighlightClipId,
    methodOfCreation: "main_toolbar"
  }), this._freeHighlightId = -1, this._freeHighlight = null, this._freeHighlightClipId = "";
}, kRe = function(i) {
  const {
    color: n
  } = this._initialData;
  return this.hasEditedComment || i.color.some((s, o) => s !== n[o]);
}, xe(rl, m5), Zi(rl, "_defaultColor", null), Zi(rl, "_defaultOpacity", 1), Zi(rl, "_defaultThickness", 12), Zi(rl, "_type", "highlight"), Zi(rl, "_editorType", eo.HIGHLIGHT), Zi(rl, "_freeHighlightId", -1), Zi(rl, "_freeHighlight", null), Zi(rl, "_freeHighlightClipId", "");
let dle = rl;
var sF;
class VRe {
  constructor() {
    xe(this, sF, /* @__PURE__ */ Object.create(null));
  }
  updateProperty(t, i) {
    this[t] = i, this.updateSVGProperty(t, i);
  }
  updateProperties(t) {
    if (t)
      for (const [i, n] of Object.entries(t))
        i.startsWith("_") || this.updateProperty(i, n);
  }
  updateSVGProperty(t, i) {
    S(this, sF)[t] = i;
  }
  toSVGProperties() {
    const t = S(this, sF);
    return be(this, sF, /* @__PURE__ */ Object.create(null)), {
      root: t
    };
  }
  reset() {
    be(this, sF, /* @__PURE__ */ Object.create(null));
  }
  updateAll(t = this) {
    this.updateProperties(t);
  }
  clone() {
    Ll("Not implemented");
  }
}
sF = new WeakMap();
var I2, Uj, r1, oF, rF, zx, jx, Wx, lF, Fr, sfe, ofe, rfe, pQ, zRe, moe, mQ, AV;
const qn = class qn extends na {
  constructor(i) {
    super(i);
    xe(this, Fr);
    xe(this, I2, null);
    xe(this, Uj);
    Zi(this, "_colorPicker", null);
    Zi(this, "_drawId", null);
    be(this, Uj, i.mustBeCommitted || !1), this._addOutlines(i);
  }
  _addOutlines(i) {
    i.drawOutlines && (_e(this, Fr, sfe).call(this, i), _e(this, Fr, pQ).call(this));
  }
  static _mergeSVGProperties(i, n) {
    const s = new Set(Object.keys(i));
    for (const [o, r] of Object.entries(n))
      s.has(o) ? Object.assign(i[o], r) : i[o] = r;
    return i;
  }
  static getDefaultDrawingOptions(i) {
    Ll("Not implemented");
  }
  static get typesMap() {
    Ll("Not implemented");
  }
  static get isDrawer() {
    return !0;
  }
  static get supportMultipleDrawings() {
    return !1;
  }
  static updateDefaultParams(i, n) {
    const s = this.typesMap.get(i);
    s && this._defaultDrawingOptions.updateProperty(s, n), this._currentParent && (S(qn, r1).updateProperty(s, n), this._currentParent.drawLayer.updateProperties(this._currentDrawId, this._defaultDrawingOptions.toSVGProperties()));
  }
  updateParams(i, n) {
    const s = this.constructor.typesMap.get(i);
    s && this._updateProperty(i, s, n);
  }
  static get defaultPropertiesToUpdate() {
    const i = [], n = this._defaultDrawingOptions;
    for (const [s, o] of this.typesMap)
      i.push([s, n[o]]);
    return i;
  }
  get propertiesToUpdate() {
    const i = [], {
      _drawingOptions: n
    } = this;
    for (const [s, o] of this.constructor.typesMap)
      i.push([s, n[o]]);
    return i;
  }
  _updateProperty(i, n, s) {
    const o = this._drawingOptions, r = o[n], l = (c) => {
      var I, p;
      o.updateProperty(n, c);
      const h = S(this, I2).updateProperty(n, c);
      h && _e(this, Fr, mQ).call(this, h), (I = this.parent) == null || I.drawLayer.updateProperties(this._drawId, o.toSVGProperties()), i === this.colorType && ((p = this._colorPicker) == null || p.update(c));
    };
    this.addCommands({
      cmd: l.bind(this, s),
      undo: l.bind(this, r),
      post: this._uiManager.updateUI.bind(this._uiManager, this),
      mustExec: !0,
      type: i,
      overwriteIfSameType: !0,
      keepUndo: !0
    });
  }
  _onResizing() {
    var i;
    (i = this.parent) == null || i.drawLayer.updateProperties(this._drawId, qn._mergeSVGProperties(S(this, I2).getPathResizingSVGProperties(_e(this, Fr, moe).call(this)), {
      bbox: _e(this, Fr, AV).call(this)
    }));
  }
  _onResized() {
    var i;
    (i = this.parent) == null || i.drawLayer.updateProperties(this._drawId, qn._mergeSVGProperties(S(this, I2).getPathResizedSVGProperties(_e(this, Fr, moe).call(this)), {
      bbox: _e(this, Fr, AV).call(this)
    }));
  }
  _onTranslating(i, n) {
    var s;
    (s = this.parent) == null || s.drawLayer.updateProperties(this._drawId, {
      bbox: _e(this, Fr, AV).call(this)
    });
  }
  _onTranslated() {
    var i;
    (i = this.parent) == null || i.drawLayer.updateProperties(this._drawId, qn._mergeSVGProperties(S(this, I2).getPathTranslatedSVGProperties(_e(this, Fr, moe).call(this), this.parentDimensions), {
      bbox: _e(this, Fr, AV).call(this)
    }));
  }
  _onStartDragging() {
    var i;
    (i = this.parent) == null || i.drawLayer.updateProperties(this._drawId, {
      rootClass: {
        moving: !0
      }
    });
  }
  _onStopDragging() {
    var i;
    (i = this.parent) == null || i.drawLayer.updateProperties(this._drawId, {
      rootClass: {
        moving: !1
      }
    });
  }
  commit() {
    super.commit(), this.disableEditMode(), this.disableEditing();
  }
  disableEditing() {
    super.disableEditing(), this.div.classList.toggle("disabled", !0);
  }
  enableEditing() {
    super.enableEditing(), this.div.classList.toggle("disabled", !1);
  }
  getBaseTranslation() {
    return [0, 0];
  }
  get isResizable() {
    return !0;
  }
  onceAdded(i) {
    this.annotationElementId || this.parent.addUndoableEditor(this), this._isDraggable = !0, S(this, Uj) && (be(this, Uj, !1), this.commit(), this.parent.setSelected(this), i && this.isOnScreen && this.div.focus());
  }
  remove() {
    _e(this, Fr, rfe).call(this), super.remove();
  }
  rebuild() {
    this.parent && (super.rebuild(), this.div !== null && (_e(this, Fr, pQ).call(this), _e(this, Fr, mQ).call(this, S(this, I2).box), this.isAttachedToDOM || this.parent.add(this)));
  }
  setParent(i) {
    var s;
    let n = !1;
    this.parent && !i ? (this._uiManager.removeShouldRescale(this), _e(this, Fr, rfe).call(this)) : i && (this._uiManager.addShouldRescale(this), _e(this, Fr, pQ).call(this, i), n = !this.parent && ((s = this.div) == null ? void 0 : s.classList.contains("selectedEditor"))), super.setParent(i), n && this.select();
  }
  rotate() {
    this.parent && this.parent.drawLayer.updateProperties(this._drawId, qn._mergeSVGProperties({
      bbox: _e(this, Fr, AV).call(this)
    }, S(this, I2).updateRotation((this.parentRotation - this.rotation + 360) % 360)));
  }
  onScaleChanging() {
    this.parent && _e(this, Fr, mQ).call(this, S(this, I2).updateParentDimensions(this.parentDimensions, this.parent.scale));
  }
  static onScaleChangingWhenDrawing() {
  }
  render() {
    if (this.div)
      return this.div;
    let i, n;
    this._isCopy && (i = this.x, n = this.y);
    const s = super.render();
    s.classList.add("draw");
    const o = document.createElement("div");
    s.append(o), o.setAttribute("aria-hidden", "true"), o.className = "internal";
    const [r, l] = this.parentDimensions;
    return this.setDims(this.width * r, this.height * l), this._uiManager.addShouldRescale(this), this.disableEditing(), this._isCopy && this._moveAfterPaste(i, n), s;
  }
  static createDrawerInstance(i, n, s, o, r) {
    Ll("Not implemented");
  }
  static startDrawing(i, n, s, o) {
    var O;
    const {
      target: r,
      offsetX: l,
      offsetY: c,
      pointerId: h,
      pointerType: I
    } = o;
    if (S(qn, jx) && S(qn, jx) !== I)
      return;
    const {
      viewport: {
        rotation: p
      }
    } = i, {
      width: y,
      height: m
    } = r.getBoundingClientRect(), A = be(qn, oF, new AbortController()), C = i.combinedSignal(A);
    if (S(qn, zx) || be(qn, zx, h), S(qn, jx) ?? be(qn, jx, I), window.addEventListener("pointerup", (R) => {
      var F;
      S(qn, zx) === R.pointerId ? this._endDraw(R) : (F = S(qn, Wx)) == null || F.delete(R.pointerId);
    }, {
      signal: C
    }), window.addEventListener("pointercancel", (R) => {
      var F;
      S(qn, zx) === R.pointerId ? this._currentParent.endDrawingSession() : (F = S(qn, Wx)) == null || F.delete(R.pointerId);
    }, {
      signal: C
    }), window.addEventListener("pointerdown", (R) => {
      S(qn, jx) === R.pointerType && ((S(qn, Wx) || be(qn, Wx, /* @__PURE__ */ new Set())).add(R.pointerId), S(qn, r1).isCancellable() && (S(qn, r1).removeLastElement(), S(qn, r1).isEmpty() ? this._currentParent.endDrawingSession(!0) : this._endDraw(null)));
    }, {
      capture: !0,
      passive: !1,
      signal: C
    }), window.addEventListener("contextmenu", F5, {
      signal: C
    }), r.addEventListener("pointermove", this._drawMove.bind(this), {
      signal: C
    }), r.addEventListener("touchmove", (R) => {
      R.timeStamp === S(qn, lF) && P0(R);
    }, {
      signal: C
    }), i.toggleDrawing(), (O = n._editorUndoBar) == null || O.hide(), S(qn, r1)) {
      i.drawLayer.updateProperties(this._currentDrawId, S(qn, r1).startNew(l, c, y, m, p));
      return;
    }
    n.updateUIForDefaultProperties(this), be(qn, r1, this.createDrawerInstance(l, c, y, m, p)), be(qn, rF, this.getDefaultDrawingOptions()), this._currentParent = i, {
      id: this._currentDrawId
    } = i.drawLayer.draw(this._mergeSVGProperties(S(qn, rF).toSVGProperties(), S(qn, r1).defaultSVGProperties), !0, !1);
  }
  static _drawMove(i) {
    var r;
    if (be(qn, lF, -1), !S(qn, r1))
      return;
    const {
      offsetX: n,
      offsetY: s,
      pointerId: o
    } = i;
    if (S(qn, zx) === o) {
      if (((r = S(qn, Wx)) == null ? void 0 : r.size) >= 1) {
        this._endDraw(i);
        return;
      }
      this._currentParent.drawLayer.updateProperties(this._currentDrawId, S(qn, r1).add(n, s)), be(qn, lF, i.timeStamp), P0(i);
    }
  }
  static _cleanup(i) {
    i && (this._currentDrawId = -1, this._currentParent = null, be(qn, r1, null), be(qn, rF, null), be(qn, jx, null), be(qn, lF, NaN)), S(qn, oF) && (S(qn, oF).abort(), be(qn, oF, null), be(qn, zx, NaN), be(qn, Wx, null));
  }
  static _endDraw(i) {
    const n = this._currentParent;
    if (n) {
      if (n.toggleDrawing(!0), this._cleanup(!1), (i == null ? void 0 : i.target) === n.div && n.drawLayer.updateProperties(this._currentDrawId, S(qn, r1).end(i.offsetX, i.offsetY)), this.supportMultipleDrawings) {
        const s = S(qn, r1), o = this._currentDrawId, r = s.getLastElement();
        n.addCommands({
          cmd: () => {
            n.drawLayer.updateProperties(o, s.setLastElement(r));
          },
          undo: () => {
            n.drawLayer.updateProperties(o, s.removeLastElement());
          },
          mustExec: !1,
          type: Ir.DRAW_STEP
        });
        return;
      }
      this.endDrawing(!1);
    }
  }
  static endDrawing(i) {
    const n = this._currentParent;
    if (!n)
      return null;
    if (n.toggleDrawing(!0), n.cleanUndoStack(Ir.DRAW_STEP), !S(qn, r1).isEmpty()) {
      const {
        pageDimensions: [s, o],
        scale: r
      } = n, l = n.createAndAddNewEditor({
        offsetX: 0,
        offsetY: 0
      }, !1, {
        drawId: this._currentDrawId,
        drawOutlines: S(qn, r1).getOutlines(s * r, o * r, r, this._INNER_MARGIN),
        drawingOptions: S(qn, rF),
        mustBeCommitted: !i
      });
      return this._cleanup(!0), l;
    }
    return n.drawLayer.remove(this._currentDrawId), this._cleanup(!0), null;
  }
  createDrawingOptions(i) {
  }
  static deserializeDraw(i, n, s, o, r, l) {
    Ll("Not implemented");
  }
  static async deserialize(i, n, s) {
    var p, y;
    const {
      rawDims: {
        pageWidth: o,
        pageHeight: r,
        pageX: l,
        pageY: c
      }
    } = n.viewport, h = this.deserializeDraw(l, c, o, r, this._INNER_MARGIN, i), I = await super.deserialize(i, n, s);
    return I.createDrawingOptions(i), _e(p = I, Fr, sfe).call(p, {
      drawOutlines: h
    }), _e(y = I, Fr, pQ).call(y), I.onScaleChanging(), I.rotate(), I;
  }
  serializeDraw(i) {
    const [n, s] = this.pageTranslation, [o, r] = this.pageDimensions;
    return S(this, I2).serialize([n, s, o, r], i);
  }
  renderAnnotationElement(i) {
    return i.updateEdited({
      rect: this.getRect(0, 0)
    }), null;
  }
  static canCreateNewEmptyEditor() {
    return !1;
  }
};
I2 = new WeakMap(), Uj = new WeakMap(), r1 = new WeakMap(), oF = new WeakMap(), rF = new WeakMap(), zx = new WeakMap(), jx = new WeakMap(), Wx = new WeakMap(), lF = new WeakMap(), Fr = new WeakSet(), sfe = function({
  drawOutlines: i,
  drawId: n,
  drawingOptions: s
}) {
  be(this, I2, i), this._drawingOptions || (this._drawingOptions = s), this.annotationElementId || this._uiManager.a11yAlert(`pdfjs-editor-${this.editorType}-added-alert`), n >= 0 ? (this._drawId = n, this.parent.drawLayer.finalizeDraw(n, i.defaultProperties)) : this._drawId = _e(this, Fr, ofe).call(this, i, this.parent), _e(this, Fr, mQ).call(this, i.box);
}, ofe = function(i, n) {
  const {
    id: s
  } = n.drawLayer.draw(qn._mergeSVGProperties(this._drawingOptions.toSVGProperties(), i.defaultSVGProperties), !1, !1);
  return s;
}, rfe = function() {
  this._drawId === null || !this.parent || (this.parent.drawLayer.remove(this._drawId), this._drawId = null, this._drawingOptions.reset());
}, pQ = function(i = this.parent) {
  if (!(this._drawId !== null && this.parent === i)) {
    if (this._drawId !== null) {
      this.parent.drawLayer.updateParent(this._drawId, i.drawLayer);
      return;
    }
    this._drawingOptions.updateAll(), this._drawId = _e(this, Fr, ofe).call(this, S(this, I2), i);
  }
}, zRe = function([i, n, s, o]) {
  const {
    parentDimensions: [r, l],
    rotation: c
  } = this;
  switch (c) {
    case 90:
      return [n, 1 - i, s * (l / r), o * (r / l)];
    case 180:
      return [1 - i, 1 - n, s, o];
    case 270:
      return [1 - n, i, s * (l / r), o * (r / l)];
    default:
      return [i, n, s, o];
  }
}, moe = function() {
  const {
    x: i,
    y: n,
    width: s,
    height: o,
    parentDimensions: [r, l],
    rotation: c
  } = this;
  switch (c) {
    case 90:
      return [1 - n, i, s * (r / l), o * (l / r)];
    case 180:
      return [1 - i, 1 - n, s, o];
    case 270:
      return [n, 1 - i, s * (r / l), o * (l / r)];
    default:
      return [i, n, s, o];
  }
}, mQ = function(i) {
  if ([this.x, this.y, this.width, this.height] = _e(this, Fr, zRe).call(this, i), this.div) {
    this.fixAndSetPosition();
    const [n, s] = this.parentDimensions;
    this.setDims(this.width * n, this.height * s);
  }
  this._onResized();
}, AV = function() {
  const {
    x: i,
    y: n,
    width: s,
    height: o,
    rotation: r,
    parentRotation: l,
    parentDimensions: [c, h]
  } = this;
  switch ((r * 4 + l) / 90) {
    case 1:
      return [1 - n - o, i, o, s];
    case 2:
      return [1 - i - s, 1 - n - o, s, o];
    case 3:
      return [n, 1 - i - s, o, s];
    case 4:
      return [i, n - s * (c / h), o * (h / c), s * (c / h)];
    case 5:
      return [1 - n, i, s * (c / h), o * (h / c)];
    case 6:
      return [1 - i - o * (h / c), 1 - n, o * (h / c), s * (c / h)];
    case 7:
      return [n - s * (c / h), 1 - i - o * (h / c), s * (c / h), o * (h / c)];
    case 8:
      return [i - s, n - o, s, o];
    case 9:
      return [1 - n, i - s, o, s];
    case 10:
      return [1 - i, 1 - n, s, o];
    case 11:
      return [n - o, 1 - i, o, s];
    case 12:
      return [i - o * (h / c), n, o * (h / c), s * (c / h)];
    case 13:
      return [1 - n - s * (c / h), i - o * (h / c), s * (c / h), o * (h / c)];
    case 14:
      return [1 - i, 1 - n - s * (c / h), o * (h / c), s * (c / h)];
    case 15:
      return [n, 1 - i, s * (c / h), o * (h / c)];
    default:
      return [i, n, s, o];
  }
}, Zi(qn, "_currentDrawId", -1), Zi(qn, "_currentParent", null), xe(qn, r1, null), xe(qn, oF, null), xe(qn, rF, null), xe(qn, zx, NaN), xe(qn, jx, null), xe(qn, Wx, null), xe(qn, lF, NaN), Zi(qn, "_INNER_MARGIN", 3);
let cle = qn;
var Gb, l1, a1, aF, Bj, _y, vp, t5, uF, dF, cF, Fj, yoe;
class Xxe {
  constructor(t, i, n, s, o, r) {
    xe(this, Fj);
    xe(this, Gb, new Float64Array(6));
    xe(this, l1);
    xe(this, a1);
    xe(this, aF);
    xe(this, Bj);
    xe(this, _y);
    xe(this, vp, "");
    xe(this, t5, 0);
    xe(this, uF, new mie());
    xe(this, dF);
    xe(this, cF);
    be(this, dF, n), be(this, cF, s), be(this, aF, o), be(this, Bj, r), [t, i] = _e(this, Fj, yoe).call(this, t, i);
    const l = be(this, l1, [NaN, NaN, NaN, NaN, t, i]);
    be(this, _y, [t, i]), be(this, a1, [{
      line: l,
      points: S(this, _y)
    }]), S(this, Gb).set(l, 0);
  }
  updateProperty(t, i) {
    t === "stroke-width" && be(this, Bj, i);
  }
  isEmpty() {
    return !S(this, a1) || S(this, a1).length === 0;
  }
  isCancellable() {
    return S(this, _y).length <= 10;
  }
  add(t, i) {
    [t, i] = _e(this, Fj, yoe).call(this, t, i);
    const [n, s, o, r] = S(this, Gb).subarray(2, 6), l = t - o, c = i - r;
    return Math.hypot(S(this, dF) * l, S(this, cF) * c) <= 2 ? null : (S(this, _y).push(t, i), isNaN(n) ? (S(this, Gb).set([o, r, t, i], 2), S(this, l1).push(NaN, NaN, NaN, NaN, t, i), {
      path: {
        d: this.toSVGPath()
      }
    }) : (isNaN(S(this, Gb)[0]) && S(this, l1).splice(6, 6), S(this, Gb).set([n, s, o, r, t, i], 0), S(this, l1).push(...Wn.createBezierPoints(n, s, o, r, t, i)), {
      path: {
        d: this.toSVGPath()
      }
    }));
  }
  end(t, i) {
    const n = this.add(t, i);
    return n || (S(this, _y).length === 2 ? {
      path: {
        d: this.toSVGPath()
      }
    } : null);
  }
  startNew(t, i, n, s, o) {
    be(this, dF, n), be(this, cF, s), be(this, aF, o), [t, i] = _e(this, Fj, yoe).call(this, t, i);
    const r = be(this, l1, [NaN, NaN, NaN, NaN, t, i]);
    be(this, _y, [t, i]);
    const l = S(this, a1).at(-1);
    return l && (l.line = new Float32Array(l.line), l.points = new Float32Array(l.points)), S(this, a1).push({
      line: r,
      points: S(this, _y)
    }), S(this, Gb).set(r, 0), be(this, t5, 0), this.toSVGPath(), null;
  }
  getLastElement() {
    return S(this, a1).at(-1);
  }
  setLastElement(t) {
    return S(this, a1) ? (S(this, a1).push(t), be(this, l1, t.line), be(this, _y, t.points), be(this, t5, 0), {
      path: {
        d: this.toSVGPath()
      }
    }) : S(this, uF).setLastElement(t);
  }
  removeLastElement() {
    if (!S(this, a1))
      return S(this, uF).removeLastElement();
    S(this, a1).pop(), be(this, vp, "");
    for (let t = 0, i = S(this, a1).length; t < i; t++) {
      const {
        line: n,
        points: s
      } = S(this, a1)[t];
      be(this, l1, n), be(this, _y, s), be(this, t5, 0), this.toSVGPath();
    }
    return {
      path: {
        d: S(this, vp)
      }
    };
  }
  toSVGPath() {
    const t = Wn.svgRound(S(this, l1)[4]), i = Wn.svgRound(S(this, l1)[5]);
    if (S(this, _y).length === 2)
      return be(this, vp, `${S(this, vp)} M ${t} ${i} Z`), S(this, vp);
    if (S(this, _y).length <= 6) {
      const s = S(this, vp).lastIndexOf("M");
      be(this, vp, `${S(this, vp).slice(0, s)} M ${t} ${i}`), be(this, t5, 6);
    }
    if (S(this, _y).length === 4) {
      const s = Wn.svgRound(S(this, l1)[10]), o = Wn.svgRound(S(this, l1)[11]);
      return be(this, vp, `${S(this, vp)} L ${s} ${o}`), be(this, t5, 12), S(this, vp);
    }
    const n = [];
    S(this, t5) === 0 && (n.push(`M ${t} ${i}`), be(this, t5, 6));
    for (let s = S(this, t5), o = S(this, l1).length; s < o; s += 6) {
      const [r, l, c, h, I, p] = S(this, l1).slice(s, s + 6).map(Wn.svgRound);
      n.push(`C${r} ${l} ${c} ${h} ${I} ${p}`);
    }
    return be(this, vp, S(this, vp) + n.join(" ")), be(this, t5, S(this, l1).length), S(this, vp);
  }
  getOutlines(t, i, n, s) {
    const o = S(this, a1).at(-1);
    return o.line = new Float32Array(o.line), o.points = new Float32Array(o.points), S(this, uF).build(S(this, a1), t, i, n, S(this, aF), S(this, Bj), s), be(this, Gb, null), be(this, l1, null), be(this, a1, null), be(this, vp, null), S(this, uF);
  }
  get defaultSVGProperties() {
    return {
      root: {
        viewBox: "0 0 10000 10000"
      },
      rootClass: {
        draw: !0
      },
      bbox: [0, 0, 1, 1]
    };
  }
}
Gb = new WeakMap(), l1 = new WeakMap(), a1 = new WeakMap(), aF = new WeakMap(), Bj = new WeakMap(), _y = new WeakMap(), vp = new WeakMap(), t5 = new WeakMap(), uF = new WeakMap(), dF = new WeakMap(), cF = new WeakMap(), Fj = new WeakSet(), yoe = function(t, i) {
  return Wn._normalizePoint(t, i, S(this, dF), S(this, cF), S(this, aF));
};
var xy, Ete, gte, p2, kb, Vb, Hj, Gj, hF, Fp, zD, jRe, WRe, YRe;
class mie extends Wn {
  constructor() {
    super(...arguments);
    xe(this, Fp);
    xe(this, xy);
    xe(this, Ete, 0);
    xe(this, gte);
    xe(this, p2);
    xe(this, kb);
    xe(this, Vb);
    xe(this, Hj);
    xe(this, Gj);
    xe(this, hF);
  }
  build(i, n, s, o, r, l, c) {
    be(this, kb, n), be(this, Vb, s), be(this, Hj, o), be(this, Gj, r), be(this, hF, l), be(this, gte, c ?? 0), be(this, p2, i), _e(this, Fp, WRe).call(this);
  }
  get thickness() {
    return S(this, hF);
  }
  setLastElement(i) {
    return S(this, p2).push(i), {
      path: {
        d: this.toSVGPath()
      }
    };
  }
  removeLastElement() {
    return S(this, p2).pop(), {
      path: {
        d: this.toSVGPath()
      }
    };
  }
  toSVGPath() {
    const i = [];
    for (const {
      line: n
    } of S(this, p2)) {
      if (i.push(`M${Wn.svgRound(n[4])} ${Wn.svgRound(n[5])}`), n.length === 6) {
        i.push("Z");
        continue;
      }
      if (n.length === 12 && isNaN(n[6])) {
        i.push(`L${Wn.svgRound(n[10])} ${Wn.svgRound(n[11])}`);
        continue;
      }
      for (let s = 6, o = n.length; s < o; s += 6) {
        const [r, l, c, h, I, p] = n.subarray(s, s + 6).map(Wn.svgRound);
        i.push(`C${r} ${l} ${c} ${h} ${I} ${p}`);
      }
    }
    return i.join("");
  }
  serialize([i, n, s, o], r) {
    const l = [], c = [], [h, I, p, y] = _e(this, Fp, jRe).call(this);
    let m, A, C, O, R, F, L, P, z;
    switch (S(this, Gj)) {
      case 0:
        z = Wn._rescale, m = i, A = n + o, C = s, O = -o, R = i + h * s, F = n + (1 - I - y) * o, L = i + (h + p) * s, P = n + (1 - I) * o;
        break;
      case 90:
        z = Wn._rescaleAndSwap, m = i, A = n, C = s, O = o, R = i + I * s, F = n + h * o, L = i + (I + y) * s, P = n + (h + p) * o;
        break;
      case 180:
        z = Wn._rescale, m = i + s, A = n, C = -s, O = o, R = i + (1 - h - p) * s, F = n + I * o, L = i + (1 - h) * s, P = n + (I + y) * o;
        break;
      case 270:
        z = Wn._rescaleAndSwap, m = i + s, A = n + o, C = -s, O = -o, R = i + (1 - I - y) * s, F = n + (1 - h - p) * o, L = i + (1 - I) * s, P = n + (1 - h) * o;
        break;
    }
    for (const {
      line: W,
      points: re
    } of S(this, p2))
      l.push(z(W, m, A, C, O, r ? new Array(W.length) : null)), c.push(z(re, m, A, C, O, r ? new Array(re.length) : null));
    return {
      lines: l,
      points: c,
      rect: [R, F, L, P]
    };
  }
  static deserialize(i, n, s, o, r, {
    paths: {
      lines: l,
      points: c
    },
    rotation: h,
    thickness: I
  }) {
    const p = [];
    let y, m, A, C, O;
    switch (h) {
      case 0:
        O = Wn._rescale, y = -i / s, m = n / o + 1, A = 1 / s, C = -1 / o;
        break;
      case 90:
        O = Wn._rescaleAndSwap, y = -n / o, m = -i / s, A = 1 / o, C = 1 / s;
        break;
      case 180:
        O = Wn._rescale, y = i / s + 1, m = -n / o, A = -1 / s, C = 1 / o;
        break;
      case 270:
        O = Wn._rescaleAndSwap, y = n / o + 1, m = i / s + 1, A = -1 / o, C = -1 / s;
        break;
    }
    if (!l) {
      l = [];
      for (const F of c) {
        const L = F.length;
        if (L === 2) {
          l.push(new Float32Array([NaN, NaN, NaN, NaN, F[0], F[1]]));
          continue;
        }
        if (L === 4) {
          l.push(new Float32Array([NaN, NaN, NaN, NaN, F[0], F[1], NaN, NaN, NaN, NaN, F[2], F[3]]));
          continue;
        }
        const P = new Float32Array(3 * (L - 2));
        l.push(P);
        let [z, W, re, ce] = F.subarray(0, 4);
        P.set([NaN, NaN, NaN, NaN, z, W], 0);
        for (let te = 4; te < L; te += 2) {
          const ee = F[te], Ne = F[te + 1];
          P.set(Wn.createBezierPoints(z, W, re, ce, ee, Ne), (te - 2) * 3), [z, W, re, ce] = [re, ce, ee, Ne];
        }
      }
    }
    for (let F = 0, L = l.length; F < L; F++)
      p.push({
        line: O(l[F].map((P) => P ?? NaN), y, m, A, C),
        points: O(c[F].map((P) => P ?? NaN), y, m, A, C)
      });
    const R = new this.prototype.constructor();
    return R.build(p, s, o, 1, h, I, r), R;
  }
  get box() {
    return S(this, xy);
  }
  updateProperty(i, n) {
    return i === "stroke-width" ? _e(this, Fp, YRe).call(this, n) : null;
  }
  updateParentDimensions([i, n], s) {
    const [o, r] = _e(this, Fp, zD).call(this);
    be(this, kb, i), be(this, Vb, n), be(this, Hj, s);
    const [l, c] = _e(this, Fp, zD).call(this), h = l - o, I = c - r, p = S(this, xy);
    return p[0] -= h, p[1] -= I, p[2] += 2 * h, p[3] += 2 * I, p;
  }
  updateRotation(i) {
    return be(this, Ete, i), {
      path: {
        transform: this.rotationTransform
      }
    };
  }
  get viewBox() {
    return S(this, xy).map(Wn.svgRound).join(" ");
  }
  get defaultProperties() {
    const [i, n] = S(this, xy);
    return {
      root: {
        viewBox: this.viewBox
      },
      path: {
        "transform-origin": `${Wn.svgRound(i)} ${Wn.svgRound(n)}`
      }
    };
  }
  get rotationTransform() {
    const [, , i, n] = S(this, xy);
    let s = 0, o = 0, r = 0, l = 0, c = 0, h = 0;
    switch (S(this, Ete)) {
      case 90:
        o = n / i, r = -i / n, c = i;
        break;
      case 180:
        s = -1, l = -1, c = i, h = n;
        break;
      case 270:
        o = -n / i, r = i / n, h = n;
        break;
      default:
        return "";
    }
    return `matrix(${s} ${o} ${r} ${l} ${Wn.svgRound(c)} ${Wn.svgRound(h)})`;
  }
  getPathResizingSVGProperties([i, n, s, o]) {
    const [r, l] = _e(this, Fp, zD).call(this), [c, h, I, p] = S(this, xy);
    if (Math.abs(I - r) <= Wn.PRECISION || Math.abs(p - l) <= Wn.PRECISION) {
      const O = i + s / 2 - (c + I / 2), R = n + o / 2 - (h + p / 2);
      return {
        path: {
          "transform-origin": `${Wn.svgRound(i)} ${Wn.svgRound(n)}`,
          transform: `${this.rotationTransform} translate(${O} ${R})`
        }
      };
    }
    const y = (s - 2 * r) / (I - 2 * r), m = (o - 2 * l) / (p - 2 * l), A = I / s, C = p / o;
    return {
      path: {
        "transform-origin": `${Wn.svgRound(c)} ${Wn.svgRound(h)}`,
        transform: `${this.rotationTransform} scale(${A} ${C}) translate(${Wn.svgRound(r)} ${Wn.svgRound(l)}) scale(${y} ${m}) translate(${Wn.svgRound(-r)} ${Wn.svgRound(-l)})`
      }
    };
  }
  getPathResizedSVGProperties([i, n, s, o]) {
    const [r, l] = _e(this, Fp, zD).call(this), c = S(this, xy), [h, I, p, y] = c;
    if (c[0] = i, c[1] = n, c[2] = s, c[3] = o, Math.abs(p - r) <= Wn.PRECISION || Math.abs(y - l) <= Wn.PRECISION) {
      const R = i + s / 2 - (h + p / 2), F = n + o / 2 - (I + y / 2);
      for (const {
        line: L,
        points: P
      } of S(this, p2))
        Wn._translate(L, R, F, L), Wn._translate(P, R, F, P);
      return {
        root: {
          viewBox: this.viewBox
        },
        path: {
          "transform-origin": `${Wn.svgRound(i)} ${Wn.svgRound(n)}`,
          transform: this.rotationTransform || null,
          d: this.toSVGPath()
        }
      };
    }
    const m = (s - 2 * r) / (p - 2 * r), A = (o - 2 * l) / (y - 2 * l), C = -m * (h + r) + i + r, O = -A * (I + l) + n + l;
    if (m !== 1 || A !== 1 || C !== 0 || O !== 0)
      for (const {
        line: R,
        points: F
      } of S(this, p2))
        Wn._rescale(R, C, O, m, A, R), Wn._rescale(F, C, O, m, A, F);
    return {
      root: {
        viewBox: this.viewBox
      },
      path: {
        "transform-origin": `${Wn.svgRound(i)} ${Wn.svgRound(n)}`,
        transform: this.rotationTransform || null,
        d: this.toSVGPath()
      }
    };
  }
  getPathTranslatedSVGProperties([i, n], s) {
    const [o, r] = s, l = S(this, xy), c = i - l[0], h = n - l[1];
    if (S(this, kb) === o && S(this, Vb) === r)
      for (const {
        line: I,
        points: p
      } of S(this, p2))
        Wn._translate(I, c, h, I), Wn._translate(p, c, h, p);
    else {
      const I = S(this, kb) / o, p = S(this, Vb) / r;
      be(this, kb, o), be(this, Vb, r);
      for (const {
        line: y,
        points: m
      } of S(this, p2))
        Wn._rescale(y, c, h, I, p, y), Wn._rescale(m, c, h, I, p, m);
      l[2] *= I, l[3] *= p;
    }
    return l[0] = i, l[1] = n, {
      root: {
        viewBox: this.viewBox
      },
      path: {
        d: this.toSVGPath(),
        "transform-origin": `${Wn.svgRound(i)} ${Wn.svgRound(n)}`
      }
    };
  }
  get defaultSVGProperties() {
    const i = S(this, xy);
    return {
      root: {
        viewBox: this.viewBox
      },
      rootClass: {
        draw: !0
      },
      path: {
        d: this.toSVGPath(),
        "transform-origin": `${Wn.svgRound(i[0])} ${Wn.svgRound(i[1])}`,
        transform: this.rotationTransform || null
      },
      bbox: i
    };
  }
}
xy = new WeakMap(), Ete = new WeakMap(), gte = new WeakMap(), p2 = new WeakMap(), kb = new WeakMap(), Vb = new WeakMap(), Hj = new WeakMap(), Gj = new WeakMap(), hF = new WeakMap(), Fp = new WeakSet(), zD = function(i = S(this, hF)) {
  const n = S(this, gte) + i / 2 * S(this, Hj);
  return S(this, Gj) % 180 === 0 ? [n / S(this, kb), n / S(this, Vb)] : [n / S(this, Vb), n / S(this, kb)];
}, jRe = function() {
  const [i, n, s, o] = S(this, xy), [r, l] = _e(this, Fp, zD).call(this, 0);
  return [i + r, n + l, s - 2 * r, o - 2 * l];
}, WRe = function() {
  const i = be(this, xy, new Float32Array([1 / 0, 1 / 0, -1 / 0, -1 / 0]));
  for (const {
    line: o
  } of S(this, p2)) {
    if (o.length <= 12) {
      for (let c = 4, h = o.length; c < h; c += 6)
        ys.pointBoundingBox(o[c], o[c + 1], i);
      continue;
    }
    let r = o[4], l = o[5];
    for (let c = 6, h = o.length; c < h; c += 6) {
      const [I, p, y, m, A, C] = o.subarray(c, c + 6);
      ys.bezierBoundingBox(r, l, I, p, y, m, A, C, i), r = A, l = C;
    }
  }
  const [n, s] = _e(this, Fp, zD).call(this);
  i[0] = Fy(i[0] - n, 0, 1), i[1] = Fy(i[1] - s, 0, 1), i[2] = Fy(i[2] + n, 0, 1), i[3] = Fy(i[3] + s, 0, 1), i[2] -= i[0], i[3] -= i[1];
}, YRe = function(i) {
  const [n, s] = _e(this, Fp, zD).call(this);
  be(this, hF, i);
  const [o, r] = _e(this, Fp, zD).call(this), [l, c] = [o - n, r - s], h = S(this, xy);
  return h[0] -= l, h[1] -= c, h[2] += 2 * l, h[3] += 2 * c, h;
};
class wae extends VRe {
  constructor(t) {
    super(), this._viewParameters = t, super.updateProperties({
      fill: "none",
      stroke: na._defaultLineColor,
      "stroke-opacity": 1,
      "stroke-width": 1,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": 10
    });
  }
  updateSVGProperty(t, i) {
    t === "stroke-width" && (i ?? (i = this["stroke-width"]), i *= this._viewParameters.realScale), super.updateSVGProperty(t, i);
  }
  clone() {
    const t = new wae(this._viewParameters);
    return t.updateAll(this), t;
  }
}
var nae, qRe;
const gz = class gz extends cle {
  constructor(i) {
    super({
      ...i,
      name: "inkEditor"
    });
    xe(this, nae);
    this._willKeepAspectRatio = !0, this.defaultL10nId = "pdfjs-editor-ink-editor";
  }
  static initialize(i, n) {
    na.initialize(i, n), this._defaultDrawingOptions = new wae(n.viewParameters);
  }
  static getDefaultDrawingOptions(i) {
    const n = this._defaultDrawingOptions.clone();
    return n.updateProperties(i), n;
  }
  static get supportMultipleDrawings() {
    return !0;
  }
  static get typesMap() {
    return Zo(this, "typesMap", /* @__PURE__ */ new Map([[Ir.INK_THICKNESS, "stroke-width"], [Ir.INK_COLOR, "stroke"], [Ir.INK_OPACITY, "stroke-opacity"]]));
  }
  static createDrawerInstance(i, n, s, o, r) {
    return new Xxe(i, n, s, o, r, this._defaultDrawingOptions["stroke-width"]);
  }
  static deserializeDraw(i, n, s, o, r, l) {
    return mie.deserialize(i, n, s, o, r, l);
  }
  static async deserialize(i, n, s) {
    let o = null;
    if (i instanceof _pe) {
      const {
        data: {
          inkLists: l,
          rect: c,
          rotation: h,
          id: I,
          color: p,
          opacity: y,
          borderStyle: {
            rawWidth: m
          },
          popupRef: A,
          contentsObj: C
        },
        parent: {
          page: {
            pageNumber: O
          }
        }
      } = i;
      o = i = {
        annotationType: eo.INK,
        color: Array.from(p),
        thickness: m,
        opacity: y,
        paths: {
          points: l
        },
        boxes: null,
        pageIndex: O - 1,
        rect: c.slice(0),
        rotation: h,
        annotationElementId: I,
        id: I,
        deleted: !1,
        popupRef: A,
        comment: (C == null ? void 0 : C.str) || null
      };
    }
    const r = await super.deserialize(i, n, s);
    return r._initialData = o, i.comment && r.setCommentData(i.comment), r;
  }
  get toolbarButtons() {
    return this._colorPicker || (this._colorPicker = new lle(this)), [["colorPicker", this._colorPicker]];
  }
  get colorType() {
    return Ir.INK_COLOR;
  }
  get colorValue() {
    return this._drawingOptions.stroke;
  }
  onScaleChanging() {
    if (!this.parent)
      return;
    super.onScaleChanging();
    const {
      _drawId: i,
      _drawingOptions: n,
      parent: s
    } = this;
    n.updateSVGProperty("stroke-width"), s.drawLayer.updateProperties(i, n.toSVGProperties());
  }
  static onScaleChangingWhenDrawing() {
    const i = this._currentParent;
    i && (super.onScaleChangingWhenDrawing(), this._defaultDrawingOptions.updateSVGProperty("stroke-width"), i.drawLayer.updateProperties(this._currentDrawId, this._defaultDrawingOptions.toSVGProperties()));
  }
  createDrawingOptions({
    color: i,
    thickness: n,
    opacity: s
  }) {
    this._drawingOptions = gz.getDefaultDrawingOptions({
      stroke: ys.makeHexColor(...i),
      "stroke-width": n,
      "stroke-opacity": s
    });
  }
  serialize(i = !1) {
    if (this.isEmpty())
      return null;
    if (this.deleted)
      return this.serializeDeleted();
    const {
      lines: n,
      points: s,
      rect: o
    } = this.serializeDraw(i), {
      _drawingOptions: {
        stroke: r,
        "stroke-opacity": l,
        "stroke-width": c
      }
    } = this, h = {
      annotationType: eo.INK,
      color: na._colorManager.convert(r),
      opacity: l,
      thickness: c,
      paths: {
        lines: n,
        points: s
      },
      pageIndex: this.pageIndex,
      rect: o,
      rotation: this.rotation,
      structTreeParentId: this._structTreeParentId
    };
    return this.addComment(h), i ? (h.isCopy = !0, h) : this.annotationElementId && !_e(this, nae, qRe).call(this, h) ? null : (h.id = this.annotationElementId, h);
  }
  renderAnnotationElement(i) {
    const {
      points: n,
      rect: s
    } = this.serializeDraw(!1), o = {
      rect: s,
      thickness: this._drawingOptions["stroke-width"],
      points: n
    };
    return this.hasEditedComment && (o.popup = this.comment), i.updateEdited(o), null;
  }
};
nae = new WeakSet(), qRe = function(i) {
  const {
    color: n,
    thickness: s,
    opacity: o,
    pageIndex: r
  } = this._initialData;
  return this.hasEditedComment || this._hasBeenMoved || this._hasBeenResized || i.color.some((l, c) => l !== n[c]) || i.thickness !== s || i.opacity !== o || i.pageIndex !== r;
}, Zi(gz, "_type", "ink"), Zi(gz, "_editorType", eo.INK), Zi(gz, "_defaultDrawingOptions", null);
let lfe = gz;
class afe extends mie {
  toSVGPath() {
    let t = super.toSVGPath();
    return t.endsWith("Z") || (t += "Z"), t;
  }
}
const yne = 8, EZ = 3;
var QZ, fF, ml, ufe, Rv, $Re, KRe, dfe, Eoe, ZRe, QRe, JRe, cfe, hfe, XRe;
let SV = (QZ = class {
  static extractContoursFromText(t, {
    fontFamily: i,
    fontStyle: n,
    fontWeight: s
  }, o, r, l, c) {
    let h = new OffscreenCanvas(1, 1), I = h.getContext("2d", {
      alpha: !1
    });
    const p = 200, y = I.font = `${n} ${s} ${p}px ${i}`, {
      actualBoundingBoxLeft: m,
      actualBoundingBoxRight: A,
      actualBoundingBoxAscent: C,
      actualBoundingBoxDescent: O,
      fontBoundingBoxAscent: R,
      fontBoundingBoxDescent: F,
      width: L
    } = I.measureText(t), P = 1.5, z = Math.ceil(Math.max(Math.abs(m) + Math.abs(A) || 0, L) * P), W = Math.ceil(Math.max(Math.abs(C) + Math.abs(O) || p, Math.abs(R) + Math.abs(F) || p) * P);
    h = new OffscreenCanvas(z, W), I = h.getContext("2d", {
      alpha: !0,
      willReadFrequently: !0
    }), I.font = y, I.filter = "grayscale(1)", I.fillStyle = "white", I.fillRect(0, 0, z, W), I.fillStyle = "black", I.fillText(t, z * (P - 1) / 2, W * (3 - P) / 2);
    const re = _e(this, ml, cfe).call(this, I.getImageData(0, 0, z, W).data), ce = _e(this, ml, JRe).call(this, re), te = _e(this, ml, hfe).call(this, ce), ee = _e(this, ml, dfe).call(this, re, z, W, te);
    return this.processDrawnLines({
      lines: {
        curves: ee,
        width: z,
        height: W
      },
      pageWidth: o,
      pageHeight: r,
      rotation: l,
      innerMargin: c,
      mustSmooth: !0,
      areContours: !0
    });
  }
  static process(t, i, n, s, o) {
    const [r, l, c] = _e(this, ml, XRe).call(this, t), [h, I] = _e(this, ml, QRe).call(this, r, l, c, Math.hypot(l, c) * S(this, fF).sigmaSFactor, S(this, fF).sigmaR, S(this, fF).kernelSize), p = _e(this, ml, hfe).call(this, I), y = _e(this, ml, dfe).call(this, h, l, c, p);
    return this.processDrawnLines({
      lines: {
        curves: y,
        width: l,
        height: c
      },
      pageWidth: i,
      pageHeight: n,
      rotation: s,
      innerMargin: o,
      mustSmooth: !0,
      areContours: !0
    });
  }
  static processDrawnLines({
    lines: t,
    pageWidth: i,
    pageHeight: n,
    rotation: s,
    innerMargin: o,
    mustSmooth: r,
    areContours: l
  }) {
    s % 180 !== 0 && ([i, n] = [n, i]);
    const {
      curves: c,
      width: h,
      height: I
    } = t, p = t.thickness ?? 0, y = [], m = Math.min(i / h, n / I), A = m / i, C = m / n, O = [];
    for (const {
      points: F
    } of c) {
      const L = r ? _e(this, ml, ZRe).call(this, F) : F;
      if (!L)
        continue;
      O.push(L);
      const P = L.length, z = new Float32Array(P), W = new Float32Array(3 * (P === 2 ? 2 : P - 2));
      if (y.push({
        line: W,
        points: z
      }), P === 2) {
        z[0] = L[0] * A, z[1] = L[1] * C, W.set([NaN, NaN, NaN, NaN, z[0], z[1]], 0);
        continue;
      }
      let [re, ce, te, ee] = L;
      re *= A, ce *= C, te *= A, ee *= C, z.set([re, ce, te, ee], 0), W.set([NaN, NaN, NaN, NaN, re, ce], 0);
      for (let Ne = 4; Ne < P; Ne += 2) {
        const Ae = z[Ne] = L[Ne] * A, Oe = z[Ne + 1] = L[Ne + 1] * C;
        W.set(Wn.createBezierPoints(re, ce, te, ee, Ae, Oe), (Ne - 2) * 3), [re, ce, te, ee] = [te, ee, Ae, Oe];
      }
    }
    if (y.length === 0)
      return null;
    const R = l ? new afe() : new mie();
    return R.build(y, i, n, 1, s, l ? 0 : p, o), {
      outline: R,
      newCurves: O,
      areContours: l,
      thickness: p,
      width: h,
      height: I
    };
  }
  static async compressSignature({
    outlines: t,
    areContours: i,
    thickness: n,
    width: s,
    height: o
  }) {
    let r = 1 / 0, l = -1 / 0, c = 0;
    for (const L of t) {
      c += L.length;
      for (let P = 2, z = L.length; P < z; P++) {
        const W = L[P] - L[P - 2];
        r = Math.min(r, W), l = Math.max(l, W);
      }
    }
    let h;
    r >= -128 && l <= 127 ? h = Int8Array : r >= -32768 && l <= 32767 ? h = Int16Array : h = Int32Array;
    const I = t.length, p = yne + EZ * I, y = new Uint32Array(p);
    let m = 0;
    y[m++] = p * Uint32Array.BYTES_PER_ELEMENT + (c - 2 * I) * h.BYTES_PER_ELEMENT, y[m++] = 0, y[m++] = s, y[m++] = o, y[m++] = i ? 0 : 1, y[m++] = Math.max(0, Math.floor(n ?? 0)), y[m++] = I, y[m++] = h.BYTES_PER_ELEMENT;
    for (const L of t)
      y[m++] = L.length - 2, y[m++] = L[0], y[m++] = L[1];
    const A = new CompressionStream("deflate-raw"), C = A.writable.getWriter();
    await C.ready, C.write(y);
    const O = h.prototype.constructor;
    for (const L of t) {
      const P = new O(L.length - 2);
      for (let z = 2, W = L.length; z < W; z++)
        P[z - 2] = L[z] - L[z - 2];
      C.write(P);
    }
    C.close();
    const R = await new Response(A.readable).arrayBuffer(), F = new Uint8Array(R);
    return QTe(F);
  }
  static async decompressSignature(t) {
    try {
      const i = R_e(t), {
        readable: n,
        writable: s
      } = new DecompressionStream("deflate-raw"), o = s.getWriter();
      await o.ready, o.write(i).then(async () => {
        await o.ready, await o.close();
      }).catch(() => {
      });
      let r = null, l = 0;
      for await (const L of n)
        r || (r = new Uint8Array(new Uint32Array(L.buffer, 0, 4)[0])), r.set(L, l), l += L.length;
      const c = new Uint32Array(r.buffer, 0, r.length >> 2), h = c[1];
      if (h !== 0)
        throw new Error(`Invalid version: ${h}`);
      const I = c[2], p = c[3], y = c[4] === 0, m = c[5], A = c[6], C = c[7], O = [], R = (yne + EZ * A) * Uint32Array.BYTES_PER_ELEMENT;
      let F;
      switch (C) {
        case Int8Array.BYTES_PER_ELEMENT:
          F = new Int8Array(r.buffer, R);
          break;
        case Int16Array.BYTES_PER_ELEMENT:
          F = new Int16Array(r.buffer, R);
          break;
        case Int32Array.BYTES_PER_ELEMENT:
          F = new Int32Array(r.buffer, R);
          break;
      }
      l = 0;
      for (let L = 0; L < A; L++) {
        const P = c[EZ * L + yne], z = new Float32Array(P + 2);
        O.push(z);
        for (let W = 0; W < EZ - 1; W++)
          z[W] = c[EZ * L + yne + W + 1];
        for (let W = 0; W < P; W++)
          z[W + 2] = z[W] + F[l++];
      }
      return {
        areContours: y,
        thickness: m,
        outlines: O,
        width: I,
        height: p
      };
    } catch (i) {
      return to(`decompressSignature: ${i}`), null;
    }
  }
}, fF = new WeakMap(), ml = new WeakSet(), ufe = function(t, i, n, s) {
  return n -= t, s -= i, n === 0 ? s > 0 ? 0 : 4 : n === 1 ? s + 6 : 2 - s;
}, Rv = new WeakMap(), $Re = function(t, i, n, s, o, r, l) {
  const c = _e(this, ml, ufe).call(this, n, s, o, r);
  for (let h = 0; h < 8; h++) {
    const I = (-h + c - l + 16) % 8, p = S(this, Rv)[2 * I], y = S(this, Rv)[2 * I + 1];
    if (t[(n + p) * i + (s + y)] !== 0)
      return I;
  }
  return -1;
}, KRe = function(t, i, n, s, o, r, l) {
  const c = _e(this, ml, ufe).call(this, n, s, o, r);
  for (let h = 0; h < 8; h++) {
    const I = (h + c + l + 16) % 8, p = S(this, Rv)[2 * I], y = S(this, Rv)[2 * I + 1];
    if (t[(n + p) * i + (s + y)] !== 0)
      return I;
  }
  return -1;
}, dfe = function(t, i, n, s) {
  const o = t.length, r = new Int32Array(o);
  for (let I = 0; I < o; I++)
    r[I] = t[I] <= s ? 1 : 0;
  for (let I = 1; I < n - 1; I++)
    r[I * i] = r[I * i + i - 1] = 0;
  for (let I = 0; I < i; I++)
    r[I] = r[i * n - 1 - I] = 0;
  let l = 1, c;
  const h = [];
  for (let I = 1; I < n - 1; I++) {
    c = 1;
    for (let p = 1; p < i - 1; p++) {
      const y = I * i + p, m = r[y];
      if (m === 0)
        continue;
      let A = I, C = p;
      if (m === 1 && r[y - 1] === 0)
        l += 1, C -= 1;
      else if (m >= 1 && r[y + 1] === 0)
        l += 1, C += 1, m > 1 && (c = m);
      else {
        m !== 1 && (c = Math.abs(m));
        continue;
      }
      const O = [p, I], R = C === p + 1, F = {
        isHole: R,
        points: O,
        id: l,
        parent: 0
      };
      h.push(F);
      let L;
      for (const Ne of h)
        if (Ne.id === c) {
          L = Ne;
          break;
        }
      L ? L.isHole ? F.parent = R ? L.parent : c : F.parent = R ? c : L.parent : F.parent = R ? c : 0;
      const P = _e(this, ml, $Re).call(this, r, i, I, p, A, C, 0);
      if (P === -1) {
        r[y] = -l, r[y] !== 1 && (c = Math.abs(r[y]));
        continue;
      }
      let z = S(this, Rv)[2 * P], W = S(this, Rv)[2 * P + 1];
      const re = I + z, ce = p + W;
      A = re, C = ce;
      let te = I, ee = p;
      for (; ; ) {
        const Ne = _e(this, ml, KRe).call(this, r, i, te, ee, A, C, 1);
        z = S(this, Rv)[2 * Ne], W = S(this, Rv)[2 * Ne + 1];
        const Ae = te + z, Oe = ee + W;
        O.push(Oe, Ae);
        const pe = te * i + ee;
        if (r[pe + 1] === 0 ? r[pe] = -l : r[pe] === 1 && (r[pe] = l), Ae === I && Oe === p && te === re && ee === ce) {
          r[y] !== 1 && (c = Math.abs(r[y]));
          break;
        } else
          A = te, C = ee, te = Ae, ee = Oe;
      }
    }
  }
  return h;
}, Eoe = function(t, i, n, s) {
  if (n - i <= 4) {
    for (let re = i; re < n - 2; re += 2)
      s.push(t[re], t[re + 1]);
    return;
  }
  const o = t[i], r = t[i + 1], l = t[n - 4] - o, c = t[n - 3] - r, h = Math.hypot(l, c), I = l / h, p = c / h, y = I * r - p * o, m = c / l, A = 1 / h, C = Math.atan(m), O = Math.cos(C), R = Math.sin(C), F = A * (Math.abs(O) + Math.abs(R)), L = A * (1 - F + F ** 2), P = Math.max(Math.atan(Math.abs(R + O) * L), Math.atan(Math.abs(R - O) * L));
  let z = 0, W = i;
  for (let re = i + 2; re < n - 2; re += 2) {
    const ce = Math.abs(y - I * t[re + 1] + p * t[re]);
    ce > z && (W = re, z = ce);
  }
  z > (h * P) ** 2 ? (_e(this, ml, Eoe).call(this, t, i, W + 2, s), _e(this, ml, Eoe).call(this, t, W, n, s)) : s.push(o, r);
}, ZRe = function(t) {
  const i = [], n = t.length;
  return _e(this, ml, Eoe).call(this, t, 0, n, i), i.push(t[n - 2], t[n - 1]), i.length <= 4 ? null : i;
}, QRe = function(t, i, n, s, o, r) {
  const l = new Float32Array(r ** 2), c = -2 * s ** 2, h = r >> 1;
  for (let C = 0; C < r; C++) {
    const O = (C - h) ** 2;
    for (let R = 0; R < r; R++)
      l[C * r + R] = Math.exp((O + (R - h) ** 2) / c);
  }
  const I = new Float32Array(256), p = -2 * o ** 2;
  for (let C = 0; C < 256; C++)
    I[C] = Math.exp(C ** 2 / p);
  const y = t.length, m = new Uint8Array(y), A = new Uint32Array(256);
  for (let C = 0; C < n; C++)
    for (let O = 0; O < i; O++) {
      const R = C * i + O, F = t[R];
      let L = 0, P = 0;
      for (let W = 0; W < r; W++) {
        const re = C + W - h;
        if (!(re < 0 || re >= n))
          for (let ce = 0; ce < r; ce++) {
            const te = O + ce - h;
            if (te < 0 || te >= i)
              continue;
            const ee = t[re * i + te], Ne = l[W * r + ce] * I[Math.abs(ee - F)];
            L += ee * Ne, P += Ne;
          }
      }
      const z = m[R] = Math.round(L / P);
      A[z]++;
    }
  return [m, A];
}, JRe = function(t) {
  const i = new Uint32Array(256);
  for (const n of t)
    i[n]++;
  return i;
}, cfe = function(t) {
  const i = t.length, n = new Uint8ClampedArray(i >> 2);
  let s = -1 / 0, o = 1 / 0;
  for (let l = 0, c = n.length; l < c; l++) {
    const h = n[l] = t[l << 2];
    s = Math.max(s, h), o = Math.min(o, h);
  }
  const r = 255 / (s - o);
  for (let l = 0, c = n.length; l < c; l++)
    n[l] = (n[l] - o) * r;
  return n;
}, hfe = function(t) {
  let i, n = -1 / 0, s = -1 / 0;
  const o = t.findIndex((c) => c !== 0);
  let r = o, l = o;
  for (i = o; i < 256; i++) {
    const c = t[i];
    c > n && (i - r > s && (s = i - r, l = i - 1), n = c, r = i);
  }
  for (i = l - 1; i >= 0 && !(t[i] > t[i + 1]); i--)
    ;
  return i;
}, XRe = function(t) {
  const i = t, {
    width: n,
    height: s
  } = t, {
    maxDim: o
  } = S(this, fF);
  let r = n, l = s;
  if (n > o || s > o) {
    let y = n, m = s, A = Math.log2(Math.max(n, s) / o);
    const C = Math.floor(A);
    A = A === C ? C - 1 : C;
    for (let R = 0; R < A; R++) {
      r = Math.ceil(y / 2), l = Math.ceil(m / 2);
      const F = new OffscreenCanvas(r, l);
      F.getContext("2d").drawImage(t, 0, 0, y, m, 0, 0, r, l), y = r, m = l, t !== i && t.close(), t = F.transferToImageBitmap();
    }
    const O = Math.min(o / r, o / l);
    r = Math.round(r * O), l = Math.round(l * O);
  }
  const h = new OffscreenCanvas(r, l).getContext("2d", {
    willReadFrequently: !0
  });
  h.fillStyle = "white", h.fillRect(0, 0, r, l), h.filter = "grayscale(1)", h.drawImage(t, 0, 0, t.width, t.height, 0, 0, r, l);
  const I = h.getImageData(0, 0, r, l).data;
  return [_e(this, ml, cfe).call(this, I), r, l];
}, xe(QZ, ml), xe(QZ, fF, {
  maxDim: 512,
  sigmaSFactor: 0.02,
  sigmaR: 25,
  kernelSize: 16
}), xe(QZ, Rv, new Int32Array([0, 1, -1, 1, -1, 0, -1, -1, 0, -1, 1, -1, 1, 0, 1, 1])), QZ);
class xpe extends VRe {
  constructor() {
    super(), super.updateProperties({
      fill: na._defaultLineColor,
      "stroke-width": 0
    });
  }
  clone() {
    const t = new xpe();
    return t.updateAll(this), t;
  }
}
class Ppe extends wae {
  constructor(t) {
    super(t), super.updateProperties({
      stroke: na._defaultLineColor,
      "stroke-width": 1
    });
  }
  clone() {
    const t = new Ppe(this._viewParameters);
    return t.updateAll(this), t;
  }
}
var Yx, zb, qx, IF;
const t2 = class t2 extends cle {
  constructor(i) {
    super({
      ...i,
      mustBeCommitted: !0,
      name: "signatureEditor"
    });
    xe(this, Yx, !1);
    xe(this, zb, null);
    xe(this, qx, null);
    xe(this, IF, null);
    this._willKeepAspectRatio = !0, be(this, qx, i.signatureData || null), be(this, zb, null), this.defaultL10nId = "pdfjs-editor-signature-editor1";
  }
  static initialize(i, n) {
    na.initialize(i, n), this._defaultDrawingOptions = new xpe(), this._defaultDrawnSignatureOptions = new Ppe(n.viewParameters);
  }
  static getDefaultDrawingOptions(i) {
    const n = this._defaultDrawingOptions.clone();
    return n.updateProperties(i), n;
  }
  static get supportMultipleDrawings() {
    return !1;
  }
  static get typesMap() {
    return Zo(this, "typesMap", /* @__PURE__ */ new Map());
  }
  static get isDrawer() {
    return !1;
  }
  get telemetryFinalData() {
    return {
      type: "signature",
      hasDescription: !!S(this, zb)
    };
  }
  static computeTelemetryFinalData(i) {
    const n = i.get("hasDescription");
    return {
      hasAltText: n.get(!0) ?? 0,
      hasNoAltText: n.get(!1) ?? 0
    };
  }
  get isResizable() {
    return !0;
  }
  onScaleChanging() {
    this._drawId !== null && super.onScaleChanging();
  }
  render() {
    if (this.div)
      return this.div;
    let i, n;
    const {
      _isCopy: s
    } = this;
    if (s && (this._isCopy = !1, i = this.x, n = this.y), super.render(), this._drawId === null)
      if (S(this, qx)) {
        const {
          lines: o,
          mustSmooth: r,
          areContours: l,
          description: c,
          uuid: h,
          heightInPage: I
        } = S(this, qx), {
          rawDims: {
            pageWidth: p,
            pageHeight: y
          },
          rotation: m
        } = this.parent.viewport, A = SV.processDrawnLines({
          lines: o,
          pageWidth: p,
          pageHeight: y,
          rotation: m,
          innerMargin: t2._INNER_MARGIN,
          mustSmooth: r,
          areContours: l
        });
        this.addSignature(A, I, c, h);
      } else
        this.div.setAttribute("data-l10n-args", JSON.stringify({
          description: ""
        })), this.div.hidden = !0, this._uiManager.getSignature(this);
    else
      this.div.setAttribute("data-l10n-args", JSON.stringify({
        description: S(this, zb) || ""
      }));
    return s && (this._isCopy = !0, this._moveAfterPaste(i, n)), this.div;
  }
  setUuid(i) {
    be(this, IF, i), this.addEditToolbar();
  }
  getUuid() {
    return S(this, IF);
  }
  get description() {
    return S(this, zb);
  }
  set description(i) {
    be(this, zb, i), this.div && (this.div.setAttribute("data-l10n-args", JSON.stringify({
      description: i
    })), super.addEditToolbar().then((n) => {
      n == null || n.updateEditSignatureButton(i);
    }));
  }
  getSignaturePreview() {
    const {
      newCurves: i,
      areContours: n,
      thickness: s,
      width: o,
      height: r
    } = S(this, qx), l = Math.max(o, r), c = SV.processDrawnLines({
      lines: {
        curves: i.map((h) => ({
          points: h
        })),
        thickness: s,
        width: o,
        height: r
      },
      pageWidth: l,
      pageHeight: l,
      rotation: 0,
      innerMargin: 0,
      mustSmooth: !1,
      areContours: n
    });
    return {
      areContours: n,
      outline: c.outline
    };
  }
  get toolbarButtons() {
    return this._uiManager.signatureManager ? [["editSignature", this._uiManager.signatureManager]] : super.toolbarButtons;
  }
  addSignature(i, n, s, o) {
    const {
      x: r,
      y: l
    } = this, {
      outline: c
    } = be(this, qx, i);
    be(this, Yx, c instanceof afe), this.description = s;
    let h;
    S(this, Yx) ? h = t2.getDefaultDrawingOptions() : (h = t2._defaultDrawnSignatureOptions.clone(), h.updateProperties({
      "stroke-width": c.thickness
    })), this._addOutlines({
      drawOutlines: c,
      drawingOptions: h
    });
    const [I, p] = this.parentDimensions, [, y] = this.pageDimensions;
    let m = n / y;
    m = m >= 1 ? 0.5 : m, this.width *= m / this.height, this.width >= 1 && (m *= 0.9 / this.width, this.width = 0.9), this.height = m, this.setDims(I * this.width, p * this.height), this.x = r, this.y = l, this.center(), this._onResized(), this.onScaleChanging(), this.rotate(), this._uiManager.addToAnnotationStorage(this), this.setUuid(o), this._reportTelemetry({
      action: "pdfjs.signature.inserted",
      data: {
        hasBeenSaved: !!o,
        hasDescription: !!s
      }
    }), this.div.hidden = !1;
  }
  getFromImage(i) {
    const {
      rawDims: {
        pageWidth: n,
        pageHeight: s
      },
      rotation: o
    } = this.parent.viewport;
    return SV.process(i, n, s, o, t2._INNER_MARGIN);
  }
  getFromText(i, n) {
    const {
      rawDims: {
        pageWidth: s,
        pageHeight: o
      },
      rotation: r
    } = this.parent.viewport;
    return SV.extractContoursFromText(i, n, s, o, r, t2._INNER_MARGIN);
  }
  getDrawnSignature(i) {
    const {
      rawDims: {
        pageWidth: n,
        pageHeight: s
      },
      rotation: o
    } = this.parent.viewport;
    return SV.processDrawnLines({
      lines: i,
      pageWidth: n,
      pageHeight: s,
      rotation: o,
      innerMargin: t2._INNER_MARGIN,
      mustSmooth: !1,
      areContours: !1
    });
  }
  createDrawingOptions({
    areContours: i,
    thickness: n
  }) {
    i ? this._drawingOptions = t2.getDefaultDrawingOptions() : (this._drawingOptions = t2._defaultDrawnSignatureOptions.clone(), this._drawingOptions.updateProperties({
      "stroke-width": n
    }));
  }
  serialize(i = !1) {
    if (this.isEmpty())
      return null;
    const {
      lines: n,
      points: s,
      rect: o
    } = this.serializeDraw(i), {
      _drawingOptions: {
        "stroke-width": r
      }
    } = this, l = {
      annotationType: eo.SIGNATURE,
      isSignature: !0,
      areContours: S(this, Yx),
      color: [0, 0, 0],
      thickness: S(this, Yx) ? 0 : r,
      pageIndex: this.pageIndex,
      rect: o,
      rotation: this.rotation,
      structTreeParentId: this._structTreeParentId
    };
    return this.addComment(l), i ? (l.paths = {
      lines: n,
      points: s
    }, l.uuid = S(this, IF), l.isCopy = !0) : l.lines = n, S(this, zb) && (l.accessibilityData = {
      type: "Figure",
      alt: S(this, zb)
    }), l;
  }
  static deserializeDraw(i, n, s, o, r, l) {
    return l.areContours ? afe.deserialize(i, n, s, o, r, l) : mie.deserialize(i, n, s, o, r, l);
  }
  static async deserialize(i, n, s) {
    var r;
    const o = await super.deserialize(i, n, s);
    return be(o, Yx, i.areContours), o.description = ((r = i.accessibilityData) == null ? void 0 : r.alt) || "", be(o, IF, i.uuid), o;
  }
};
Yx = new WeakMap(), zb = new WeakMap(), qx = new WeakMap(), IF = new WeakMap(), Zi(t2, "_type", "signature"), Zi(t2, "_editorType", eo.SIGNATURE), Zi(t2, "_defaultDrawingOptions", null);
let ffe = t2;
var Uu, u1, $x, iO, Kx, kj, nO, pF, jb, m2, Vj, Hr, yQ, EQ, goe, woe, Toe, pfe, Roe, eve;
class Ife extends na {
  constructor(i) {
    super({
      ...i,
      name: "stampEditor"
    });
    xe(this, Hr);
    xe(this, Uu, null);
    xe(this, u1, null);
    xe(this, $x, null);
    xe(this, iO, null);
    xe(this, Kx, null);
    xe(this, kj, "");
    xe(this, nO, null);
    xe(this, pF, !1);
    xe(this, jb, null);
    xe(this, m2, !1);
    xe(this, Vj, !1);
    be(this, iO, i.bitmapUrl), be(this, Kx, i.bitmapFile), this.defaultL10nId = "pdfjs-editor-stamp-editor";
  }
  static initialize(i, n) {
    na.initialize(i, n);
  }
  static isHandlingMimeForPasting(i) {
    return lhe.includes(i);
  }
  static paste(i, n) {
    n.pasteEditor({
      mode: eo.STAMP
    }, {
      bitmapFile: i.getAsFile()
    });
  }
  altTextFinish() {
    this._uiManager.useNewAltTextFlow && (this.div.hidden = !1), super.altTextFinish();
  }
  get telemetryFinalData() {
    var i;
    return {
      type: "stamp",
      hasAltText: !!((i = this.altTextData) != null && i.altText)
    };
  }
  static computeTelemetryFinalData(i) {
    const n = i.get("hasAltText");
    return {
      hasAltText: n.get(!0) ?? 0,
      hasNoAltText: n.get(!1) ?? 0
    };
  }
  async mlGuessAltText(i = null, n = !0) {
    if (this.hasAltTextData())
      return null;
    const {
      mlManager: s
    } = this._uiManager;
    if (!s)
      throw new Error("No ML.");
    if (!await s.isEnabledFor("altText"))
      throw new Error("ML isn't enabled for alt text.");
    const {
      data: o,
      width: r,
      height: l
    } = i || this.copyCanvas(null, null, !0).imageData, c = await s.guess({
      name: "altText",
      request: {
        data: o,
        width: r,
        height: l,
        channels: o.length / (r * l)
      }
    });
    if (!c)
      throw new Error("No response from the AI service.");
    if (c.error)
      throw new Error("Error from the AI service.");
    if (c.cancel)
      return null;
    if (!c.output)
      throw new Error("No valid response from the AI service.");
    const h = c.output;
    return await this.setGuessedAltText(h), n && !this.hasAltTextData() && (this.altTextData = {
      alt: h,
      decorative: !1
    }), h;
  }
  remove() {
    var i;
    S(this, u1) && (be(this, Uu, null), this._uiManager.imageManager.deleteId(S(this, u1)), (i = S(this, nO)) == null || i.remove(), be(this, nO, null), S(this, jb) && (clearTimeout(S(this, jb)), be(this, jb, null))), super.remove();
  }
  rebuild() {
    if (!this.parent) {
      S(this, u1) && _e(this, Hr, goe).call(this);
      return;
    }
    super.rebuild(), this.div !== null && (S(this, u1) && S(this, nO) === null && _e(this, Hr, goe).call(this), this.isAttachedToDOM || this.parent.add(this));
  }
  onceAdded(i) {
    this._isDraggable = !0, i && this.div.focus();
  }
  isEmpty() {
    return !(S(this, $x) || S(this, Uu) || S(this, iO) || S(this, Kx) || S(this, u1) || S(this, pF));
  }
  get toolbarButtons() {
    return [["altText", this.createAltText()]];
  }
  get isResizable() {
    return !0;
  }
  render() {
    if (this.div)
      return this.div;
    let i, n;
    return this._isCopy && (i = this.x, n = this.y), super.render(), this.div.hidden = !0, this.createAltText(), S(this, pF) || (S(this, Uu) ? _e(this, Hr, woe).call(this) : _e(this, Hr, goe).call(this)), this._isCopy && this._moveAfterPaste(i, n), this._uiManager.addShouldRescale(this), this.div;
  }
  setCanvas(i, n) {
    const {
      id: s,
      bitmap: o
    } = this._uiManager.imageManager.getFromCanvas(i, n);
    n.remove(), s && this._uiManager.imageManager.isValidId(s) && (be(this, u1, s), o && be(this, Uu, o), be(this, pF, !1), _e(this, Hr, woe).call(this));
  }
  _onResized() {
    this.onScaleChanging();
  }
  onScaleChanging() {
    if (!this.parent)
      return;
    S(this, jb) !== null && clearTimeout(S(this, jb)), be(this, jb, setTimeout(() => {
      be(this, jb, null), _e(this, Hr, pfe).call(this);
    }, 200));
  }
  copyCanvas(i, n, s = !1) {
    var m;
    i || (i = 224);
    const {
      width: o,
      height: r
    } = S(this, Uu), l = new ZF();
    let c = S(this, Uu), h = o, I = r, p = null;
    if (n) {
      if (o > n || r > n) {
        const ce = Math.min(n / o, n / r);
        h = Math.floor(o * ce), I = Math.floor(r * ce);
      }
      p = document.createElement("canvas");
      const A = p.width = Math.ceil(h * l.sx), C = p.height = Math.ceil(I * l.sy);
      S(this, m2) || (c = _e(this, Hr, Toe).call(this, A, C));
      const O = p.getContext("2d");
      O.filter = this._uiManager.hcmFilter;
      let R = "white", F = "#cfcfd8";
      this._uiManager.hcmFilter !== "none" ? F = "black" : (m = window.matchMedia) != null && m.call(window, "(prefers-color-scheme: dark)").matches && (R = "#8f8f9d", F = "#42414d");
      const L = 15, P = L * l.sx, z = L * l.sy, W = new OffscreenCanvas(P * 2, z * 2), re = W.getContext("2d");
      re.fillStyle = R, re.fillRect(0, 0, P * 2, z * 2), re.fillStyle = F, re.fillRect(0, 0, P, z), re.fillRect(P, z, P, z), O.fillStyle = O.createPattern(W, "repeat"), O.fillRect(0, 0, A, C), O.drawImage(c, 0, 0, c.width, c.height, 0, 0, A, C);
    }
    let y = null;
    if (s) {
      let A, C;
      if (l.symmetric && c.width < i && c.height < i)
        A = c.width, C = c.height;
      else if (c = S(this, Uu), o > i || r > i) {
        const F = Math.min(i / o, i / r);
        A = Math.floor(o * F), C = Math.floor(r * F), S(this, m2) || (c = _e(this, Hr, Toe).call(this, A, C));
      }
      const R = new OffscreenCanvas(A, C).getContext("2d", {
        willReadFrequently: !0
      });
      R.drawImage(c, 0, 0, c.width, c.height, 0, 0, A, C), y = {
        width: A,
        height: C,
        data: R.getImageData(0, 0, A, C).data
      };
    }
    return {
      canvas: p,
      width: h,
      height: I,
      imageData: y
    };
  }
  static async deserialize(i, n, s) {
    var O;
    let o = null, r = !1;
    if (i instanceof pRe) {
      const {
        data: {
          rect: R,
          rotation: F,
          id: L,
          structParent: P,
          popupRef: z,
          contentsObj: W
        },
        container: re,
        parent: {
          page: {
            pageNumber: ce
          }
        },
        canvas: te
      } = i;
      let ee, Ne;
      te ? (delete i.canvas, {
        id: ee,
        bitmap: Ne
      } = s.imageManager.getFromCanvas(re.id, te), te.remove()) : (r = !0, i._hasNoCanvas = !0);
      const Ae = ((O = await n._structTree.getAriaAttributes(`${Spe}${L}`)) == null ? void 0 : O.get("aria-label")) || "";
      o = i = {
        annotationType: eo.STAMP,
        bitmapId: ee,
        bitmap: Ne,
        pageIndex: ce - 1,
        rect: R.slice(0),
        rotation: F,
        annotationElementId: L,
        id: L,
        deleted: !1,
        accessibilityData: {
          decorative: !1,
          altText: Ae
        },
        isSvg: !1,
        structParent: P,
        popupRef: z,
        comment: (W == null ? void 0 : W.str) || null
      };
    }
    const l = await super.deserialize(i, n, s), {
      rect: c,
      bitmap: h,
      bitmapUrl: I,
      bitmapId: p,
      isSvg: y,
      accessibilityData: m
    } = i;
    r ? (s.addMissingCanvas(i.id, l), be(l, pF, !0)) : p && s.imageManager.isValidId(p) ? (be(l, u1, p), h && be(l, Uu, h)) : be(l, iO, I), be(l, m2, y);
    const [A, C] = l.pageDimensions;
    return l.width = (c[2] - c[0]) / A, l.height = (c[3] - c[1]) / C, m && (l.altTextData = m), l._initialData = o, i.comment && l.setCommentData(i.comment), be(l, Vj, !!o), l;
  }
  serialize(i = !1, n = null) {
    if (this.isEmpty())
      return null;
    if (this.deleted)
      return this.serializeDeleted();
    const s = {
      annotationType: eo.STAMP,
      bitmapId: S(this, u1),
      pageIndex: this.pageIndex,
      rect: this.getRect(0, 0),
      rotation: this.rotation,
      isSvg: S(this, m2),
      structTreeParentId: this._structTreeParentId
    };
    if (this.addComment(s), i)
      return s.bitmapUrl = _e(this, Hr, Roe).call(this, !0), s.accessibilityData = this.serializeAltText(!0), s.isCopy = !0, s;
    const {
      decorative: o,
      altText: r
    } = this.serializeAltText(!1);
    if (!o && r && (s.accessibilityData = {
      type: "Figure",
      alt: r
    }), this.annotationElementId) {
      const c = _e(this, Hr, eve).call(this, s);
      if (c.isSame)
        return null;
      c.isSameAltText ? delete s.accessibilityData : s.accessibilityData.structParent = this._initialData.structParent ?? -1;
    }
    if (s.id = this.annotationElementId, n === null)
      return s;
    n.stamps || (n.stamps = /* @__PURE__ */ new Map());
    const l = S(this, m2) ? (s.rect[2] - s.rect[0]) * (s.rect[3] - s.rect[1]) : null;
    if (!n.stamps.has(S(this, u1)))
      n.stamps.set(S(this, u1), {
        area: l,
        serialized: s
      }), s.bitmap = _e(this, Hr, Roe).call(this, !1);
    else if (S(this, m2)) {
      const c = n.stamps.get(S(this, u1));
      l > c.area && (c.area = l, c.serialized.bitmap.close(), c.serialized.bitmap = _e(this, Hr, Roe).call(this, !1));
    }
    return s;
  }
  renderAnnotationElement(i) {
    const n = {
      rect: this.getRect(0, 0)
    };
    return this.hasEditedComment && (n.popup = this.comment), i.updateEdited(n), null;
  }
}
Uu = new WeakMap(), u1 = new WeakMap(), $x = new WeakMap(), iO = new WeakMap(), Kx = new WeakMap(), kj = new WeakMap(), nO = new WeakMap(), pF = new WeakMap(), jb = new WeakMap(), m2 = new WeakMap(), Vj = new WeakMap(), Hr = new WeakSet(), yQ = function(i, n = !1) {
  if (!i) {
    this.remove();
    return;
  }
  be(this, Uu, i.bitmap), n || (be(this, u1, i.id), be(this, m2, i.isSvg)), i.file && be(this, kj, i.file.name), _e(this, Hr, woe).call(this);
}, EQ = function() {
  if (be(this, $x, null), this._uiManager.enableWaiting(!1), !!S(this, nO)) {
    if (this._uiManager.useNewAltTextWhenAddingImage && this._uiManager.useNewAltTextFlow && S(this, Uu)) {
      this.addEditToolbar().then(() => {
        this._editToolbar.hide(), this._uiManager.editAltText(this, !0);
      });
      return;
    }
    if (!this._uiManager.useNewAltTextWhenAddingImage && this._uiManager.useNewAltTextFlow && S(this, Uu)) {
      this._reportTelemetry({
        action: "pdfjs.image.image_added",
        data: {
          alt_text_modal: !1,
          alt_text_type: "empty"
        }
      });
      try {
        this.mlGuessAltText();
      } catch {
      }
    }
    this.div.focus();
  }
}, goe = function() {
  if (S(this, u1)) {
    this._uiManager.enableWaiting(!0), this._uiManager.imageManager.getFromId(S(this, u1)).then((s) => _e(this, Hr, yQ).call(this, s, !0)).finally(() => _e(this, Hr, EQ).call(this));
    return;
  }
  if (S(this, iO)) {
    const s = S(this, iO);
    be(this, iO, null), this._uiManager.enableWaiting(!0), be(this, $x, this._uiManager.imageManager.getFromUrl(s).then((o) => _e(this, Hr, yQ).call(this, o)).finally(() => _e(this, Hr, EQ).call(this)));
    return;
  }
  if (S(this, Kx)) {
    const s = S(this, Kx);
    be(this, Kx, null), this._uiManager.enableWaiting(!0), be(this, $x, this._uiManager.imageManager.getFromFile(s).then((o) => _e(this, Hr, yQ).call(this, o)).finally(() => _e(this, Hr, EQ).call(this)));
    return;
  }
  const i = document.createElement("input");
  i.type = "file", i.accept = lhe.join(",");
  const n = this._uiManager._signal;
  be(this, $x, new Promise((s) => {
    i.addEventListener("change", async () => {
      if (!i.files || i.files.length === 0)
        this.remove();
      else {
        this._uiManager.enableWaiting(!0);
        const o = await this._uiManager.imageManager.getFromFile(i.files[0]);
        this._reportTelemetry({
          action: "pdfjs.image.image_selected",
          data: {
            alt_text_modal: this._uiManager.useNewAltTextFlow
          }
        }), _e(this, Hr, yQ).call(this, o);
      }
      s();
    }, {
      signal: n
    }), i.addEventListener("cancel", () => {
      this.remove(), s();
    }, {
      signal: n
    });
  }).finally(() => _e(this, Hr, EQ).call(this))), i.click();
}, woe = function() {
  var p;
  const {
    div: i
  } = this;
  let {
    width: n,
    height: s
  } = S(this, Uu);
  const [o, r] = this.pageDimensions, l = 0.75;
  if (this.width)
    n = this.width * o, s = this.height * r;
  else if (n > l * o || s > l * r) {
    const y = Math.min(l * o / n, l * r / s);
    n *= y, s *= y;
  }
  const [c, h] = this.parentDimensions;
  this.setDims(n * c / o, s * h / r), this._uiManager.enableWaiting(!1);
  const I = be(this, nO, document.createElement("canvas"));
  I.setAttribute("role", "img"), this.addContainer(I), this.width = n / o, this.height = s / r, (p = this._initialOptions) != null && p.isCentered ? this.center() : this.fixAndSetPosition(), this._initialOptions = null, (!this._uiManager.useNewAltTextWhenAddingImage || !this._uiManager.useNewAltTextFlow || this.annotationElementId) && (i.hidden = !1), _e(this, Hr, pfe).call(this), S(this, Vj) || (this.parent.addUndoableEditor(this), be(this, Vj, !0)), this._reportTelemetry({
    action: "inserted_image"
  }), S(this, kj) && this.div.setAttribute("aria-description", S(this, kj)), this.annotationElementId || this._uiManager.a11yAlert("pdfjs-editor-stamp-added-alert");
}, Toe = function(i, n) {
  const {
    width: s,
    height: o
  } = S(this, Uu);
  let r = s, l = o, c = S(this, Uu);
  for (; r > 2 * i || l > 2 * n; ) {
    const h = r, I = l;
    r > 2 * i && (r = r >= 16384 ? Math.floor(r / 2) - 1 : Math.ceil(r / 2)), l > 2 * n && (l = l >= 16384 ? Math.floor(l / 2) - 1 : Math.ceil(l / 2));
    const p = new OffscreenCanvas(r, l);
    p.getContext("2d").drawImage(c, 0, 0, h, I, 0, 0, r, l), c = p.transferToImageBitmap();
  }
  return c;
}, pfe = function() {
  const [i, n] = this.parentDimensions, {
    width: s,
    height: o
  } = this, r = new ZF(), l = Math.ceil(s * i * r.sx), c = Math.ceil(o * n * r.sy), h = S(this, nO);
  if (!h || h.width === l && h.height === c)
    return;
  h.width = l, h.height = c;
  const I = S(this, m2) ? S(this, Uu) : _e(this, Hr, Toe).call(this, l, c), p = h.getContext("2d");
  p.filter = this._uiManager.hcmFilter, p.drawImage(I, 0, 0, I.width, I.height, 0, 0, l, c);
}, Roe = function(i) {
  if (i) {
    if (S(this, m2)) {
      const o = this._uiManager.imageManager.getSvgUrl(S(this, u1));
      if (o)
        return o;
    }
    const n = document.createElement("canvas");
    return {
      width: n.width,
      height: n.height
    } = S(this, Uu), n.getContext("2d").drawImage(S(this, Uu), 0, 0), n.toDataURL();
  }
  if (S(this, m2)) {
    const [n, s] = this.pageDimensions, o = Math.round(this.width * n * SW.PDF_TO_CSS_UNITS), r = Math.round(this.height * s * SW.PDF_TO_CSS_UNITS), l = new OffscreenCanvas(o, r);
    return l.getContext("2d").drawImage(S(this, Uu), 0, 0, S(this, Uu).width, S(this, Uu).height, 0, 0, o, r), l.transferToImageBitmap();
  }
  return structuredClone(S(this, Uu));
}, eve = function(i) {
  var l;
  const {
    pageIndex: n,
    accessibilityData: {
      altText: s
    }
  } = this._initialData, o = i.pageIndex === n, r = (((l = i.accessibilityData) == null ? void 0 : l.alt) || "") === s;
  return {
    isSame: !this.hasEditedComment && !this._hasBeenMoved && !this._hasBeenResized && o && r,
    isSameAltText: r
  };
}, Zi(Ife, "_type", "stamp"), Zi(Ife, "_editorType", eo.STAMP);
var mF, zj, Wb, Zx, sO, y2, Qx, jj, yF, vv, oO, d1, rO, Jx, Wj, ls, wg, Xx, Fu, tve, mb, mfe, yfe, voe;
let ePe = (wg = class {
  constructor({
    uiManager: t,
    pageIndex: i,
    div: n,
    structTreeLayer: s,
    accessibilityManager: o,
    annotationLayer: r,
    drawLayer: l,
    textLayer: c,
    viewport: h,
    l10n: I
  }) {
    xe(this, Fu);
    xe(this, mF);
    xe(this, zj, !1);
    xe(this, Wb, null);
    xe(this, Zx, null);
    xe(this, sO, null);
    xe(this, y2, /* @__PURE__ */ new Map());
    xe(this, Qx, !1);
    xe(this, jj, !1);
    xe(this, yF, !1);
    xe(this, vv, null);
    xe(this, oO, null);
    xe(this, d1, null);
    xe(this, rO, null);
    xe(this, Jx, null);
    xe(this, Wj, -1);
    xe(this, ls);
    const p = [...S(wg, Xx).values()];
    if (!wg._initialized) {
      wg._initialized = !0;
      for (const y of p)
        y.initialize(I, t);
    }
    t.registerEditorTypes(p), be(this, ls, t), this.pageIndex = i, this.div = n, be(this, mF, o), be(this, Wb, r), this.viewport = h, be(this, d1, c), this.drawLayer = l, this._structTree = s, S(this, ls).addLayer(this);
  }
  get isEmpty() {
    return S(this, y2).size === 0;
  }
  get isInvisible() {
    return this.isEmpty && S(this, ls).getMode() === eo.NONE;
  }
  updateToolbar(t) {
    S(this, ls).updateToolbar(t);
  }
  updateMode(t = S(this, ls).getMode()) {
    switch (_e(this, Fu, voe).call(this), t) {
      case eo.NONE:
        this.disableTextSelection(), this.togglePointerEvents(!1), this.toggleAnnotationLayerPointerEvents(!0), this.disableClick();
        return;
      case eo.INK:
        this.disableTextSelection(), this.togglePointerEvents(!0), this.enableClick();
        break;
      case eo.HIGHLIGHT:
        this.enableTextSelection(), this.togglePointerEvents(!1), this.disableClick();
        break;
      default:
        this.disableTextSelection(), this.togglePointerEvents(!0), this.enableClick();
    }
    this.toggleAnnotationLayerPointerEvents(!1);
    const {
      classList: i
    } = this.div;
    for (const n of S(wg, Xx).values())
      i.toggle(`${n._type}Editing`, t === n._editorType);
    this.div.hidden = !1;
  }
  hasTextLayer(t) {
    var i;
    return t === ((i = S(this, d1)) == null ? void 0 : i.div);
  }
  setEditingState(t) {
    S(this, ls).setEditingState(t);
  }
  addCommands(t) {
    S(this, ls).addCommands(t);
  }
  cleanUndoStack(t) {
    S(this, ls).cleanUndoStack(t);
  }
  toggleDrawing(t = !1) {
    this.div.classList.toggle("drawing", !t);
  }
  togglePointerEvents(t = !1) {
    this.div.classList.toggle("disabled", !t);
  }
  toggleAnnotationLayerPointerEvents(t = !1) {
    var i;
    (i = S(this, Wb)) == null || i.div.classList.toggle("disabled", !t);
  }
  async enable() {
    var n;
    be(this, yF, !0), this.div.tabIndex = 0, this.togglePointerEvents(!0), (n = S(this, Jx)) == null || n.abort(), be(this, Jx, null);
    const t = /* @__PURE__ */ new Set();
    for (const s of S(this, y2).values())
      s.enableEditing(), s.show(!0), s.annotationElementId && (S(this, ls).removeChangedExistingAnnotation(s), t.add(s.annotationElementId));
    if (!S(this, Wb)) {
      be(this, yF, !1);
      return;
    }
    const i = S(this, Wb).getEditableAnnotations();
    for (const s of i) {
      if (s.hide(), S(this, ls).isDeletedAnnotationElement(s.data.id) || t.has(s.data.id))
        continue;
      const o = await this.deserialize(s);
      o && (this.addOrRebuild(o), o.enableEditing());
    }
    be(this, yF, !1);
  }
  disable() {
    var s;
    if (be(this, jj, !0), this.div.tabIndex = -1, this.togglePointerEvents(!1), S(this, d1) && !S(this, Jx)) {
      be(this, Jx, new AbortController());
      const o = S(this, ls).combinedSignal(S(this, Jx));
      S(this, d1).div.addEventListener("pointerdown", (r) => {
        const {
          clientX: c,
          clientY: h,
          timeStamp: I
        } = r, p = S(this, Wj);
        if (I - p > 500) {
          be(this, Wj, I);
          return;
        }
        be(this, Wj, -1);
        const {
          classList: y
        } = this.div;
        y.toggle("getElements", !0);
        const m = document.elementsFromPoint(c, h);
        if (y.toggle("getElements", !1), !this.div.contains(m[0]))
          return;
        let A;
        const C = new RegExp(`^${YTe}[0-9]+$`);
        for (const R of m)
          if (C.test(R.id)) {
            A = R.id;
            break;
          }
        if (!A)
          return;
        const O = S(this, y2).get(A);
        (O == null ? void 0 : O.annotationElementId) === null && (r.stopPropagation(), r.preventDefault(), O.dblclick());
      }, {
        signal: o,
        capture: !0
      });
    }
    const t = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
    for (const o of S(this, y2).values())
      if (o.disableEditing(), !!o.annotationElementId) {
        if (o.serialize() !== null) {
          t.set(o.annotationElementId, o);
          continue;
        } else
          i.set(o.annotationElementId, o);
        (s = this.getEditableAnnotation(o.annotationElementId)) == null || s.show(), o.remove();
      }
    if (S(this, Wb)) {
      const o = S(this, Wb).getEditableAnnotations();
      for (const r of o) {
        const {
          id: l
        } = r.data;
        if (S(this, ls).isDeletedAnnotationElement(l)) {
          r.updateEdited({
            deleted: !0
          });
          continue;
        }
        let c = i.get(l);
        if (c) {
          c.resetAnnotationElement(r), c.show(!1), r.show();
          continue;
        }
        c = t.get(l), c && (S(this, ls).addChangedExistingAnnotation(c), c.renderAnnotationElement(r) && c.show(!1)), r.show();
      }
    }
    _e(this, Fu, voe).call(this), this.isEmpty && (this.div.hidden = !0);
    const {
      classList: n
    } = this.div;
    for (const o of S(wg, Xx).values())
      n.remove(`${o._type}Editing`);
    this.disableTextSelection(), this.toggleAnnotationLayerPointerEvents(!0), be(this, jj, !1);
  }
  getEditableAnnotation(t) {
    var i;
    return ((i = S(this, Wb)) == null ? void 0 : i.getEditableAnnotation(t)) || null;
  }
  setActiveEditor(t) {
    S(this, ls).getActive() !== t && S(this, ls).setActiveEditor(t);
  }
  enableTextSelection() {
    var t;
    if (this.div.tabIndex = -1, (t = S(this, d1)) != null && t.div && !S(this, rO)) {
      be(this, rO, new AbortController());
      const i = S(this, ls).combinedSignal(S(this, rO));
      S(this, d1).div.addEventListener("pointerdown", _e(this, Fu, tve).bind(this), {
        signal: i
      }), S(this, d1).div.classList.add("highlighting");
    }
  }
  disableTextSelection() {
    var t;
    this.div.tabIndex = 0, (t = S(this, d1)) != null && t.div && S(this, rO) && (S(this, rO).abort(), be(this, rO, null), S(this, d1).div.classList.remove("highlighting"));
  }
  enableClick() {
    if (S(this, Zx))
      return;
    be(this, Zx, new AbortController());
    const t = S(this, ls).combinedSignal(S(this, Zx));
    this.div.addEventListener("pointerdown", this.pointerdown.bind(this), {
      signal: t
    });
    const i = this.pointerup.bind(this);
    this.div.addEventListener("pointerup", i, {
      signal: t
    }), this.div.addEventListener("pointercancel", i, {
      signal: t
    });
  }
  disableClick() {
    var t;
    (t = S(this, Zx)) == null || t.abort(), be(this, Zx, null);
  }
  attach(t) {
    S(this, y2).set(t.id, t);
    const {
      annotationElementId: i
    } = t;
    i && S(this, ls).isDeletedAnnotationElement(i) && S(this, ls).removeDeletedAnnotationElement(t);
  }
  detach(t) {
    var i;
    S(this, y2).delete(t.id), (i = S(this, mF)) == null || i.removePointerInTextLayer(t.contentDiv), !S(this, jj) && t.annotationElementId && S(this, ls).addDeletedAnnotationElement(t);
  }
  remove(t) {
    this.detach(t), S(this, ls).removeEditor(t), t.div.remove(), t.isAttachedToDOM = !1;
  }
  changeParent(t) {
    var i;
    t.parent !== this && (t.parent && t.annotationElementId && (S(this, ls).addDeletedAnnotationElement(t.annotationElementId), na.deleteAnnotationElement(t), t.annotationElementId = null), this.attach(t), (i = t.parent) == null || i.detach(t), t.setParent(this), t.div && t.isAttachedToDOM && (t.div.remove(), this.div.append(t.div)));
  }
  add(t) {
    if (!(t.parent === this && t.isAttachedToDOM)) {
      if (this.changeParent(t), S(this, ls).addEditor(t), this.attach(t), !t.isAttachedToDOM) {
        const i = t.render();
        this.div.append(i), t.isAttachedToDOM = !0;
      }
      t.fixAndSetPosition(), t.onceAdded(!S(this, yF)), S(this, ls).addToAnnotationStorage(t), t._reportTelemetry(t.telemetryInitialData);
    }
  }
  moveEditorInDOM(t) {
    var n;
    if (!t.isAttachedToDOM)
      return;
    const {
      activeElement: i
    } = document;
    t.div.contains(i) && !S(this, sO) && (t._focusEventsAllowed = !1, be(this, sO, setTimeout(() => {
      be(this, sO, null), t.div.contains(document.activeElement) ? t._focusEventsAllowed = !0 : (t.div.addEventListener("focusin", () => {
        t._focusEventsAllowed = !0;
      }, {
        once: !0,
        signal: S(this, ls)._signal
      }), i.focus());
    }, 0))), t._structTreeParentId = (n = S(this, mF)) == null ? void 0 : n.moveElementInDOM(this.div, t.div, t.contentDiv, !0);
  }
  addOrRebuild(t) {
    t.needsToBeRebuilt() ? (t.parent || (t.parent = this), t.rebuild(), t.show()) : this.add(t);
  }
  addUndoableEditor(t) {
    const i = () => t._uiManager.rebuild(t), n = () => {
      t.remove();
    };
    this.addCommands({
      cmd: i,
      undo: n,
      mustExec: !1
    });
  }
  getNextId() {
    return S(this, ls).getId();
  }
  combinedSignal(t) {
    return S(this, ls).combinedSignal(t);
  }
  canCreateNewEmptyEditor() {
    var t;
    return (t = S(this, Fu, mb)) == null ? void 0 : t.canCreateNewEmptyEditor();
  }
  async pasteEditor(t, i) {
    this.updateToolbar(t), await S(this, ls).updateMode(t.mode);
    const {
      offsetX: n,
      offsetY: s
    } = _e(this, Fu, yfe).call(this), o = this.getNextId(), r = _e(this, Fu, mfe).call(this, {
      parent: this,
      id: o,
      x: n,
      y: s,
      uiManager: S(this, ls),
      isCentered: !0,
      ...i
    });
    r && this.add(r);
  }
  async deserialize(t) {
    var i;
    return await ((i = S(wg, Xx).get(t.annotationType ?? t.annotationEditorType)) == null ? void 0 : i.deserialize(t, this, S(this, ls))) || null;
  }
  createAndAddNewEditor(t, i, n = {}) {
    const s = this.getNextId(), o = _e(this, Fu, mfe).call(this, {
      parent: this,
      id: s,
      x: t.offsetX,
      y: t.offsetY,
      uiManager: S(this, ls),
      isCentered: i,
      ...n
    });
    return o && this.add(o), o;
  }
  addNewEditor(t = {}) {
    this.createAndAddNewEditor(_e(this, Fu, yfe).call(this), !0, t);
  }
  setSelected(t) {
    S(this, ls).setSelected(t);
  }
  toggleSelected(t) {
    S(this, ls).toggleSelected(t);
  }
  unselect(t) {
    S(this, ls).unselect(t);
  }
  pointerup(t) {
    var s;
    const {
      isMac: i
    } = Qp.platform;
    if (t.button !== 0 || t.ctrlKey && i || t.target !== this.div || !S(this, Qx) || (be(this, Qx, !1), (s = S(this, Fu, mb)) != null && s.isDrawer && S(this, Fu, mb).supportMultipleDrawings))
      return;
    if (!S(this, zj)) {
      be(this, zj, !0);
      return;
    }
    const n = S(this, ls).getMode();
    if (n === eo.STAMP || n === eo.SIGNATURE) {
      S(this, ls).unselectAll();
      return;
    }
    this.createAndAddNewEditor(t, !1);
  }
  pointerdown(t) {
    var s;
    if (S(this, ls).getMode() === eo.HIGHLIGHT && this.enableTextSelection(), S(this, Qx)) {
      be(this, Qx, !1);
      return;
    }
    const {
      isMac: i
    } = Qp.platform;
    if (t.button !== 0 || t.ctrlKey && i || t.target !== this.div)
      return;
    if (be(this, Qx, !0), (s = S(this, Fu, mb)) != null && s.isDrawer) {
      this.startDrawingSession(t);
      return;
    }
    const n = S(this, ls).getActive();
    be(this, zj, !n || n.isEmpty());
  }
  startDrawingSession(t) {
    if (this.div.focus({
      preventScroll: !0
    }), S(this, vv)) {
      S(this, Fu, mb).startDrawing(this, S(this, ls), !1, t);
      return;
    }
    S(this, ls).setCurrentDrawingSession(this), be(this, vv, new AbortController());
    const i = S(this, ls).combinedSignal(S(this, vv));
    this.div.addEventListener("blur", ({
      relatedTarget: n
    }) => {
      n && !this.div.contains(n) && (be(this, oO, null), this.commitOrRemove());
    }, {
      signal: i
    }), S(this, Fu, mb).startDrawing(this, S(this, ls), !1, t);
  }
  pause(t) {
    if (t) {
      const {
        activeElement: i
      } = document;
      this.div.contains(i) && be(this, oO, i);
      return;
    }
    S(this, oO) && setTimeout(() => {
      var i;
      (i = S(this, oO)) == null || i.focus(), be(this, oO, null);
    }, 0);
  }
  endDrawingSession(t = !1) {
    return S(this, vv) ? (S(this, ls).setCurrentDrawingSession(null), S(this, vv).abort(), be(this, vv, null), be(this, oO, null), S(this, Fu, mb).endDrawing(t)) : null;
  }
  findNewParent(t, i, n) {
    const s = S(this, ls).findParent(i, n);
    return s === null || s === this ? !1 : (s.changeParent(t), !0);
  }
  commitOrRemove() {
    return S(this, vv) ? (this.endDrawingSession(), !0) : !1;
  }
  onScaleChanging() {
    S(this, vv) && S(this, Fu, mb).onScaleChangingWhenDrawing(this);
  }
  destroy() {
    var t, i;
    this.commitOrRemove(), ((t = S(this, ls).getActive()) == null ? void 0 : t.parent) === this && (S(this, ls).commitOrRemove(), S(this, ls).setActiveEditor(null)), S(this, sO) && (clearTimeout(S(this, sO)), be(this, sO, null));
    for (const n of S(this, y2).values())
      (i = S(this, mF)) == null || i.removePointerInTextLayer(n.contentDiv), n.setParent(null), n.isAttachedToDOM = !1, n.div.remove();
    this.div = null, S(this, y2).clear(), S(this, ls).removeLayer(this);
  }
  render({
    viewport: t
  }) {
    this.viewport = t, KF(this.div, t);
    for (const i of S(this, ls).getEditors(this.pageIndex))
      this.add(i), i.rebuild();
    this.updateMode();
  }
  update({
    viewport: t
  }) {
    S(this, ls).commitOrRemove(), _e(this, Fu, voe).call(this);
    const i = this.viewport.rotation, n = t.rotation;
    if (this.viewport = t, KF(this.div, {
      rotation: n
    }), i !== n)
      for (const s of S(this, y2).values())
        s.rotate(n);
  }
  get pageDimensions() {
    const {
      pageWidth: t,
      pageHeight: i
    } = this.viewport.rawDims;
    return [t, i];
  }
  get scale() {
    return S(this, ls).viewParameters.realScale;
  }
}, mF = new WeakMap(), zj = new WeakMap(), Wb = new WeakMap(), Zx = new WeakMap(), sO = new WeakMap(), y2 = new WeakMap(), Qx = new WeakMap(), jj = new WeakMap(), yF = new WeakMap(), vv = new WeakMap(), oO = new WeakMap(), d1 = new WeakMap(), rO = new WeakMap(), Jx = new WeakMap(), Wj = new WeakMap(), ls = new WeakMap(), Xx = new WeakMap(), Fu = new WeakSet(), tve = function(t) {
  S(this, ls).unselectAll();
  const {
    target: i
  } = t;
  if (i === S(this, d1).div || (i.getAttribute("role") === "img" || i.classList.contains("endOfContent")) && S(this, d1).div.contains(i)) {
    const {
      isMac: n
    } = Qp.platform;
    if (t.button !== 0 || t.ctrlKey && n)
      return;
    S(this, ls).showAllEditors("highlight", !0, !0), S(this, d1).div.classList.add("free"), this.toggleDrawing(), dle.startHighlighting(this, S(this, ls).direction === "ltr", {
      target: S(this, d1).div,
      x: t.x,
      y: t.y
    }), S(this, d1).div.addEventListener("pointerup", () => {
      S(this, d1).div.classList.remove("free"), this.toggleDrawing(!0);
    }, {
      once: !0,
      signal: S(this, ls)._signal
    }), t.preventDefault();
  }
}, mb = function() {
  return S(wg, Xx).get(S(this, ls).getMode());
}, mfe = function(t) {
  const i = S(this, Fu, mb);
  return i ? new i.prototype.constructor(t) : null;
}, yfe = function() {
  const {
    x: t,
    y: i,
    width: n,
    height: s
  } = this.div.getBoundingClientRect(), o = Math.max(0, t), r = Math.max(0, i), l = Math.min(window.innerWidth, t + n), c = Math.min(window.innerHeight, i + s), h = (o + l) / 2 - t, I = (r + c) / 2 - i, [p, y] = this.viewport.rotation % 180 === 0 ? [h, I] : [I, h];
  return {
    offsetX: p,
    offsetY: y
  };
}, voe = function() {
  for (const t of S(this, y2).values())
    t.isEmpty() && t.remove();
}, Zi(wg, "_initialized", !1), xe(wg, Xx, new Map([Qhe, lfe, Ife, dle, ffe].map((t) => [t._editorType, t]))), wg);
var Av, Py, EF, Jd, wte, sae, ive, l6, Efe, nve, gfe;
let tPe = (Jd = class {
  constructor({
    pageIndex: t
  }) {
    xe(this, l6);
    xe(this, Av, null);
    xe(this, Py, /* @__PURE__ */ new Map());
    xe(this, EF, /* @__PURE__ */ new Map());
    this.pageIndex = t;
  }
  setParent(t) {
    if (!S(this, Av)) {
      be(this, Av, t);
      return;
    }
    if (S(this, Av) !== t) {
      if (S(this, Py).size > 0)
        for (const i of S(this, Py).values())
          i.remove(), t.append(i);
      be(this, Av, t);
    }
  }
  static get _svgFactory() {
    return Zo(this, "_svgFactory", new ale());
  }
  draw(t, i = !1, n = !1) {
    const s = hp(Jd, wte)._++, o = _e(this, l6, Efe).call(this), r = Jd._svgFactory.createElement("defs");
    o.append(r);
    const l = Jd._svgFactory.createElement("path");
    r.append(l);
    const c = `path_p${this.pageIndex}_${s}`;
    l.setAttribute("id", c), l.setAttribute("vector-effect", "non-scaling-stroke"), i && S(this, EF).set(s, l);
    const h = n ? _e(this, l6, nve).call(this, r, c) : null, I = Jd._svgFactory.createElement("use");
    return o.append(I), I.setAttribute("href", `#${c}`), this.updateProperties(o, t), S(this, Py).set(s, o), {
      id: s,
      clipPathId: `url(#${h})`
    };
  }
  drawOutline(t, i) {
    const n = hp(Jd, wte)._++, s = _e(this, l6, Efe).call(this), o = Jd._svgFactory.createElement("defs");
    s.append(o);
    const r = Jd._svgFactory.createElement("path");
    o.append(r);
    const l = `path_p${this.pageIndex}_${n}`;
    r.setAttribute("id", l), r.setAttribute("vector-effect", "non-scaling-stroke");
    let c;
    if (i) {
      const p = Jd._svgFactory.createElement("mask");
      o.append(p), c = `mask_p${this.pageIndex}_${n}`, p.setAttribute("id", c), p.setAttribute("maskUnits", "objectBoundingBox");
      const y = Jd._svgFactory.createElement("rect");
      p.append(y), y.setAttribute("width", "1"), y.setAttribute("height", "1"), y.setAttribute("fill", "white");
      const m = Jd._svgFactory.createElement("use");
      p.append(m), m.setAttribute("href", `#${l}`), m.setAttribute("stroke", "none"), m.setAttribute("fill", "black"), m.setAttribute("fill-rule", "nonzero"), m.classList.add("mask");
    }
    const h = Jd._svgFactory.createElement("use");
    s.append(h), h.setAttribute("href", `#${l}`), c && h.setAttribute("mask", `url(#${c})`);
    const I = h.cloneNode();
    return s.append(I), h.classList.add("mainOutline"), I.classList.add("secondaryOutline"), this.updateProperties(s, t), S(this, Py).set(n, s), n;
  }
  finalizeDraw(t, i) {
    S(this, EF).delete(t), this.updateProperties(t, i);
  }
  updateProperties(t, i) {
    var c;
    if (!i)
      return;
    const {
      root: n,
      bbox: s,
      rootClass: o,
      path: r
    } = i, l = typeof t == "number" ? S(this, Py).get(t) : t;
    if (l) {
      if (n && _e(this, l6, gfe).call(this, l, n), s && _e(c = Jd, sae, ive).call(c, l, s), o) {
        const {
          classList: h
        } = l;
        for (const [I, p] of Object.entries(o))
          h.toggle(I, p);
      }
      if (r) {
        const I = l.firstChild.firstChild;
        _e(this, l6, gfe).call(this, I, r);
      }
    }
  }
  updateParent(t, i) {
    if (i === this)
      return;
    const n = S(this, Py).get(t);
    n && (S(i, Av).append(n), S(this, Py).delete(t), S(i, Py).set(t, n));
  }
  remove(t) {
    S(this, EF).delete(t), S(this, Av) !== null && (S(this, Py).get(t).remove(), S(this, Py).delete(t));
  }
  destroy() {
    be(this, Av, null);
    for (const t of S(this, Py).values())
      t.remove();
    S(this, Py).clear(), S(this, EF).clear();
  }
}, Av = new WeakMap(), Py = new WeakMap(), EF = new WeakMap(), wte = new WeakMap(), sae = new WeakSet(), ive = function(t, [i, n, s, o]) {
  const {
    style: r
  } = t;
  r.top = `${100 * n}%`, r.left = `${100 * i}%`, r.width = `${100 * s}%`, r.height = `${100 * o}%`;
}, l6 = new WeakSet(), Efe = function() {
  const t = Jd._svgFactory.create(1, 1, !0);
  return S(this, Av).append(t), t.setAttribute("aria-hidden", !0), t;
}, nve = function(t, i) {
  const n = Jd._svgFactory.createElement("clipPath");
  t.append(n);
  const s = `clip_${i}`;
  n.setAttribute("id", s), n.setAttribute("clipPathUnits", "objectBoundingBox");
  const o = Jd._svgFactory.createElement("use");
  return n.append(o), o.setAttribute("href", `#${i}`), o.classList.add("clip"), s;
}, gfe = function(t, i) {
  for (const [n, s] of Object.entries(i))
    s === null ? t.removeAttribute(n) : t.setAttribute(n, s);
}, xe(Jd, sae), xe(Jd, wte, 0), Jd);
globalThis._pdfjsTestingUtils = {
  HighlightOutliner: Xhe
};
globalThis.pdfjsLib = {
  AbortException: WP,
  AnnotationEditorLayer: ePe,
  AnnotationEditorParamsType: Ir,
  AnnotationEditorType: eo,
  AnnotationEditorUIManager: uX,
  AnnotationLayer: mRe,
  AnnotationMode: rx,
  AnnotationType: O0,
  build: Lxe,
  ColorPicker: iRe,
  createValidAbsoluteUrl: qTe,
  DOMSVGFactory: ale,
  DrawLayer: tPe,
  FeatureTest: Qp,
  fetchData: hie,
  getDocument: J5e,
  getFilenameFromUrl: v_e,
  getPdfFilenameFromUrl: A_e,
  getRGB: Eae,
  getUuid: ZTe,
  getXfaPageViewport: b_e,
  GlobalWorkerOptions: lx,
  ImageKind: qse,
  InvalidPDFException: nhe,
  isDataScheme: yae,
  isPdfFile: Npe,
  isValidExplicitDest: B_e,
  MathClamp: Fy,
  noContextMenu: F5,
  normalizeUnicode: w_e,
  OPS: nle,
  OutputScale: ZF,
  PasswordResponses: c_e,
  PDFDataRangeTransport: X5e,
  PDFDateString: ohe,
  PDFWorker: Fhe,
  PermissionFlag: d_e,
  PixelsPerInch: SW,
  RenderingCancelledException: bpe,
  ResponseException: sle,
  setLayerDimensions: KF,
  shadow: Zo,
  SignatureExtractor: SV,
  stopEvent: P0,
  SupportedImageMimeTypes: lhe,
  TextLayer: rle,
  TouchManager: m5e,
  updateUrlHash: $Te,
  Util: ys,
  VerbosityLevel: Iae,
  version: Oxe,
  XfaLayer: sRe
};
const iPe = 8, ax = /* @__PURE__ */ new Map(), nPe = (e) => {
  try {
    const t = new URL(e);
    return t.origin + t.pathname;
  } catch {
    return e;
  }
}, sPe = (e) => {
  const t = ax.get(e);
  return t && (ax.delete(e), ax.set(e, t)), t;
}, oPe = (e, t) => {
  if (ax.delete(e), ax.set(e, t), ax.size > iPe) {
    const i = ax.keys().next().value;
    i !== void 0 && ax.delete(i);
  }
};
function rPe(e) {
  const [t, i] = Is(null), [n, s] = Is(0), [o, r] = Is(null), [l, c] = Is(!0), [h, I] = Is(null), [p, y] = Is(0), [m, A] = Is("downloading"), [C, O] = Is(0), R = io(/* @__PURE__ */ new Map()), F = io(/* @__PURE__ */ new Set()), L = io(null);
  vr(() => {
    let W = !0;
    const re = nPe(e), ce = sPe(re);
    if (ce && ce.pdf === L.current)
      return;
    if (R.current.clear(), F.current.clear(), ce) {
      L.current = ce.pdf, R.current.set(0, ce.firstPage), F.current.add(0), i(ce.pdf), s(ce.pdf.numPages), r(ce.firstPage), A("ready"), c(!1), y(100);
      return;
    }
    return (async () => {
      try {
        c(!0), I(null), y(0), A("downloading"), s(0), r(null);
        const ee = {
          url: e,
          wasmUrl: window.location.origin + "/",
          useWasm: !0,
          useWorkerFetch: !1,
          disableAutoFetch: !0,
          disableStream: !0,
          rangeChunkSize: 524288,
          // 512KB chunks
          cMapUrl: "https://cdn.jsdelivr.net/npm/pdfjs-dist@5.4.54/cmaps/",
          cMapPacked: !0,
          // GPU-accelerate rasterization.
          enableHWA: !0
        }, Ne = J5e(ee);
        Ne.onProgress = (pe) => {
          if (W && pe.total > 0) {
            const je = Math.round(pe.loaded / pe.total * 100);
            y(je);
          }
        };
        const Ae = await Ne.promise;
        if (!W) return;
        L.current = Ae, i(Ae), s(Ae.numPages);
        const Oe = await Ae.getPage(1);
        if (!W) return;
        R.current.set(0, Oe), F.current.add(0), r(Oe), A("ready"), c(!1), oPe(re, { pdf: Ae, firstPage: Oe });
      } catch (ee) {
        if (!W) return;
        I(ee instanceof Error ? ee : new Error(String(ee))), c(!1);
      }
    })(), () => {
      W = !1;
    };
  }, [e]);
  const P = On(
    (W) => R.current.get(W) ?? null,
    [C]
  ), z = On(
    (W) => {
      if (!t) return;
      const re = W.filter(
        (ce) => ce >= 0 && ce < n && !R.current.has(ce) && !F.current.has(ce)
      );
      re.length !== 0 && (re.forEach((ce) => F.current.add(ce)), Promise.all(
        re.map(async (ce) => {
          try {
            const te = await t.getPage(ce + 1);
            R.current.set(ce, te);
          } catch {
            F.current.delete(ce);
          }
        })
      ).then(() => {
        O((ce) => ce + 1);
      }));
    },
    [t, n]
  );
  return {
    numPages: n,
    pdfDocument: t,
    loading: l,
    error: h,
    downloadProgress: p,
    currentStep: m,
    getLoadedPage: P,
    ensurePagesLoaded: z,
    firstPage: o
  };
}
const lPe = (e, t, i) => {
  const [n, s] = Is(""), [o, r] = Is([]), [l, c] = Is(-1), [h, I] = Is(!1), p = io(null), y = On(() => {
    s(""), r([]), c(-1), p.current && (p.current.abort(), p.current = null);
  }, []), m = On(
    async (R, F, L, P) => {
      if (P.aborted) return [];
      try {
        const z = await R.getTextContent(), W = [];
        if (P.aborted) return [];
        const re = R.getViewport({ scale: 1, rotation: R.rotate }), ce = F.toLowerCase();
        for (let te = 0; te < z.items.length && !P.aborted; te++) {
          const ee = z.items[te];
          if (!ee.str) continue;
          const Ne = ee.str, Ae = Ne.toLowerCase();
          let Oe = Ae.indexOf(ce);
          for (; Oe !== -1 && !P.aborted; ) {
            if (!ee.transform || ee.transform.length < 6) {
              Oe = Ae.indexOf(ce, Oe + 1);
              continue;
            }
            if (!ee.width) {
              const Di = Math.sqrt(
                ee.transform[0] * ee.transform[0] + ee.transform[1] * ee.transform[1]
              );
              ee.width = Ne.length * Di * 0.6;
            }
            const [pe, je, , , Ve, $e] = ee.transform, vt = ee.width / Ne.length, Rt = Ve + Oe * vt, ze = Rt + F.length * vt, Et = Math.sqrt(pe * pe + je * je) * 1.5, it = $e, Dt = it - Et, Ct = re.convertToViewportPoint(Rt, Dt), Kt = re.convertToViewportPoint(ze, it), Zt = 10;
            let Xt = Math.min(Ct[1], Kt[1]), gi = Math.max(Ct[1], Kt[1]);
            if (gi - Xt < Zt) {
              const Di = (Xt + gi) / 2;
              Xt = Di - Zt / 2, gi = Di + Zt / 2;
            }
            const Wt = 12;
            Xt -= Wt, gi -= Wt, W.push({
              pageNumber: L + 1,
              pageIndex: L,
              text: Ne.substring(Oe, Oe + F.length),
              coordinates: {
                x0: Math.min(Ct[0], Kt[0]),
                y0: Xt,
                // CSS top of highlight (smaller y = higher on page)
                x1: Math.max(Ct[0], Kt[0]),
                y1: gi,
                // CSS bottom of highlight (larger y = lower on page)
                pageNumber: L + 1
              }
            }), Oe = Ae.indexOf(ce, Oe + 1);
          }
        }
        return W;
      } catch (z) {
        return P.aborted ? [] : (console.error(`Error searching in page ${L + 1}:`, z), []);
      }
    },
    []
  ), A = On(
    async (R, F = !1) => {
      if (!e || !R.trim()) {
        y();
        return;
      }
      I(!0), p.current && p.current.abort(), p.current = new AbortController();
      const { signal: L } = p.current;
      try {
        const P = e.numPages, z = [];
        for (let W = 0; W < P && !L.aborted; W++) {
          const re = await e.getPage(W + 1);
          if (L.aborted) break;
          const ce = await m(re, R, W, L);
          ce.length > 0 && z.push(...ce);
        }
        if (!L.aborted) {
          let W = 0;
          if (z.length > 0)
            if (F && i && i > 0) {
              let re = 0, ce = Math.abs(z[0].pageNumber - i);
              for (let te = 1; te < z.length; te++) {
                const ee = Math.abs(z[te].pageNumber - i);
                ee < ce && (ce = ee, re = te);
              }
              W = re;
            } else
              W = 0;
          else
            W = -1;
          if (r(z), c(W), W >= 0 && z.length > 0 && t) {
            const re = z[W];
            t(re);
          }
        }
      } catch (P) {
        L.aborted || console.error("Error during search:", P);
      } finally {
        L.aborted || I(!1);
      }
    },
    [e, y, m, t, i]
  ), C = On(() => {
    if (o.length === 0) return;
    const R = (l + 1) % o.length;
    c(R), t && t(o[R]);
  }, [o, l, t]), O = On(() => {
    if (o.length === 0) return;
    const R = (l - 1 + o.length) % o.length;
    c(R), t && t(o[R]);
  }, [o, l, t]);
  return {
    searchTerm: n,
    setSearchTerm: s,
    matches: o,
    isSearching: h,
    currentMatchIndex: l,
    totalMatches: o.length,
    searchNextMatch: C,
    searchPreviousMatch: O,
    clearSearch: y,
    performSearch: A
  };
};
function aPe({
  initialPage: e = 1,
  numPages: t
}) {
  const [i, n] = Is(1), [s, o] = Is(e), [r, l] = Is(/* @__PURE__ */ new Set()), [c, h] = Is(!1), I = On((z) => {
    n(z);
  }, []), p = io([]), y = io(/* @__PURE__ */ new Set()), m = io(/* @__PURE__ */ new Set()), A = io(!1), C = io(!1), O = On(
    (z) => {
      const W = z + 1;
      return Math.abs(W - s) <= 2;
    },
    [s]
  ), R = On(
    (z, W) => {
      if (!W || A.current) return;
      const re = W.clientWidth, ce = z.getViewport({ scale: 1, rotation: z.rotate }), te = (re - 40) / ce.width;
      I(te), A.current = !0;
    },
    [I]
  ), F = On(
    (z, W, re, ce, te = !1) => {
      if (!W || z < 1 || z > t || C.current && !te) return;
      C.current = !0, o(z);
      const ee = z - 1, Ne = p.current[ee];
      if (!Ne) return;
      for (let $e = Math.max(0, ee - 2); $e < Math.min(t, ee + 3); $e++)
        y.current.delete($e);
      const Ae = re * i, Oe = ce * i, pe = Ae + Oe / 2, je = W.clientHeight, Ve = Ne.offsetTop + pe - je / 2;
      W.scrollTo({
        top: Math.max(0, Ve),
        behavior: "smooth"
      });
    },
    [t, i]
  ), L = On(
    (z, W, re = !1) => {
      if (!W || z < 1 || z > t) return;
      h(!0), o(z);
      const ce = p.current[z - 1];
      ce && (re && z === 1 ? W.scrollTo({
        top: 0,
        behavior: "auto"
      }) : ce.scrollIntoView({
        behavior: "auto",
        // Instant scrolling like PDF.js
        block: "start",
        // Align to top of container
        inline: "nearest"
        // Don't change horizontal scroll
      })), setTimeout(() => h(!1), 100);
    },
    [t]
  ), P = On(
    (z) => {
      const W = document.querySelector(".fc\\:overflow-y-auto");
      if (!W) return;
      const re = s;
      I(z), y.current.clear(), m.current.clear(), requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          re >= 1 && re <= t && setTimeout(() => {
            L(re, W, !1);
          }, 10);
        });
      });
    },
    [s, I, t, L]
  );
  return {
    scale: i,
    setScale: I,
    currentPage: s,
    setCurrentPage: o,
    visiblePages: r,
    setVisiblePages: l,
    pageRefs: p,
    canvasesRendered: y,
    textLayersRendered: m,
    isPageVisible: O,
    handleScaleChange: P,
    handlePageChange: L,
    scrollToHighlight: F,
    calculateInitialScale: R,
    initialScaleSetRef: A,
    resetHighlightScrolled: () => {
      C.current = !1;
    },
    isNavigating: c
  };
}
const {
  AbortException: uPe,
  AnnotationEditorLayer: dPe,
  AnnotationEditorParamsType: Rat,
  AnnotationEditorType: e2,
  AnnotationEditorUIManager: cPe,
  AnnotationLayer: hPe,
  AnnotationMode: mO,
  AnnotationType: sve,
  build: vat,
  ColorPicker: Aat,
  createValidAbsoluteUrl: ove,
  DOMSVGFactory: Sat,
  DrawLayer: fPe,
  FeatureTest: IPe,
  fetchData: iEe,
  getDocument: bat,
  getFilenameFromUrl: Nat,
  getPdfFilenameFromUrl: pPe,
  getRGB: Dat,
  getUuid: Cat,
  getXfaPageViewport: Oat,
  GlobalWorkerOptions: Lat,
  ImageKind: _at,
  InvalidPDFException: xat,
  isDataScheme: Pat,
  isPdfFile: mPe,
  isValidExplicitDest: yPe,
  MathClamp: rve,
  noContextMenu: Mat,
  normalizeUnicode: EPe,
  OPS: Uat,
  OutputScale: Aoe,
  PasswordResponses: Bat,
  PDFDataRangeTransport: Fat,
  PDFDateString: Hat,
  PDFWorker: Gat,
  PermissionFlag: Ene,
  PixelsPerInch: NC,
  RenderingCancelledException: wfe,
  ResponseException: kat,
  setLayerDimensions: lve,
  shadow: hle,
  SignatureExtractor: Vat,
  stopEvent: Tfe,
  SupportedImageMimeTypes: zat,
  TextLayer: gPe,
  TouchManager: jat,
  updateUrlHash: wPe,
  Util: Mpe,
  VerbosityLevel: Wat,
  version: nEe,
  XfaLayer: dde
} = globalThis.pdfjsLib, TPe = "auto", ave = 1, sEe = 1.1, RPe = 0.1, vPe = 10, cde = 0, APe = 1.25, oEe = 40, rEe = 5, ll = {
  INITIAL: 0,
  RUNNING: 1,
  PAUSED: 2,
  FINISHED: 3
}, vz = {
  UNKNOWN: 0,
  NORMAL: 1,
  CHANGING: 2,
  FULLSCREEN: 3
}, Zb = {
  DISABLE: 0,
  ENABLE: 1,
  ENABLE_PERMISSIONS: 2
}, Rr = {
  UNKNOWN: -1,
  VERTICAL: 0,
  HORIZONTAL: 1,
  WRAPPED: 2,
  PAGE: 3
}, Bm = {
  UNKNOWN: -1,
  NONE: 0,
  ODD: 1,
  EVEN: 2
};
function uve(e, t, i = !1) {
  let n = e.offsetParent;
  if (!n) {
    console.error("offsetParent is not set -- cannot scroll");
    return;
  }
  let s = e.offsetTop + e.clientTop, o = e.offsetLeft + e.clientLeft;
  for (; n.clientHeight === n.scrollHeight && n.clientWidth === n.scrollWidth || i && (n.classList.contains("markedContent") || getComputedStyle(n).overflow === "hidden"); )
    if (s += n.offsetTop, o += n.offsetLeft, n = n.offsetParent, !n)
      return;
  t && (t.top !== void 0 && (s += t.top), t.left !== void 0 && (o += t.left, n.scrollLeft = o)), n.scrollTop = s;
}
function SPe(e, t, i = void 0) {
  const n = function(r) {
    o || (o = window.requestAnimationFrame(function() {
      o = null;
      const c = e.scrollLeft, h = s.lastX;
      c !== h && (s.right = c > h), s.lastX = c;
      const I = e.scrollTop, p = s.lastY;
      I !== p && (s.down = I > p), s.lastY = I, t(s);
    }));
  }, s = {
    right: !0,
    down: !0,
    lastX: e.scrollLeft,
    lastY: e.scrollTop,
    _eventHandler: n
  };
  let o = null;
  return e.addEventListener("scroll", n, {
    useCapture: !0,
    signal: i
  }), i == null || i.addEventListener("abort", () => window.cancelAnimationFrame(o), {
    once: !0
  }), s;
}
function Tae(e) {
  const t = /* @__PURE__ */ new Map();
  for (const [i, n] of new URLSearchParams(e))
    t.set(i.toLowerCase(), n);
  return t;
}
const lEe = /[\x00-\x1F]/g;
function TJ(e, t = !1) {
  return lEe.test(e) ? t ? e.replaceAll(lEe, (i) => i === "\0" ? "" : " ") : e.replaceAll("\0", "") : e;
}
function cX(e, t, i = 0) {
  let n = i, s = e.length - 1;
  if (s < 0 || !t(e[s]))
    return e.length;
  if (t(e[n]))
    return n;
  for (; n < s; ) {
    const o = n + s >> 1, r = e[o];
    t(r) ? s = o : n = o + 1;
  }
  return n;
}
function aEe(e) {
  if (Math.floor(e) === e)
    return [e, 1];
  const t = 1 / e, i = 8;
  if (t > i)
    return [1, i];
  if (Math.floor(t) === t)
    return [1, t];
  const n = e > 1 ? t : e;
  let s = 0, o = 1, r = 1, l = 1;
  for (; ; ) {
    const h = s + r, I = o + l;
    if (I > i)
      break;
    n <= h / I ? (r = h, l = I) : (s = h, o = I);
  }
  let c;
  return n - s / o < r / l - n ? c = n === e ? [s, o] : [o, s] : c = n === e ? [r, l] : [l, r], c;
}
function gne(e, t) {
  return e - e % t;
}
function bPe(e, t, i) {
  if (e < 2)
    return e;
  let n = t[e].div, s = n.offsetTop + n.clientTop;
  s >= i && (n = t[e - 1].div, s = n.offsetTop + n.clientTop);
  for (let o = e - 2; o >= 0 && (n = t[o].div, !(n.offsetTop + n.clientTop + n.clientHeight <= s)); --o)
    e = o;
  return e;
}
function NPe({
  scrollEl: e,
  views: t,
  sortByVisibility: i = !1,
  horizontal: n = !1,
  rtl: s = !1
}) {
  const o = e.scrollTop, r = o + e.clientHeight, l = e.scrollLeft, c = l + e.clientWidth;
  function h(F) {
    const L = F.div;
    return L.offsetTop + L.clientTop + L.clientHeight > o;
  }
  function I(F) {
    const L = F.div, P = L.offsetLeft + L.clientLeft, z = P + L.clientWidth;
    return s ? P < c : z > l;
  }
  const p = [], y = /* @__PURE__ */ new Set(), m = t.length;
  let A = cX(t, n ? I : h);
  A > 0 && A < m && !n && (A = bPe(A, t, o));
  let C = n ? c : -1;
  for (let F = A; F < m; F++) {
    const L = t[F], P = L.div, z = P.offsetLeft + P.clientLeft, W = P.offsetTop + P.clientTop, re = P.clientWidth, ce = P.clientHeight, te = z + re, ee = W + ce;
    if (C === -1)
      ee >= r && (C = ee);
    else if ((n ? z : W) > C)
      break;
    if (ee <= o || W >= r || te <= l || z >= c)
      continue;
    const Ne = Math.max(0, o - W), Ae = Math.max(0, l - z), Oe = Ne + Math.max(0, ee - r), pe = Ae + Math.max(0, te - c), je = (ce - Oe) / ce, Ve = (re - pe) / re, $e = je * Ve * 100 | 0;
    p.push({
      id: L.id,
      x: z,
      y: W,
      visibleArea: $e === 100 ? null : {
        minX: Ae,
        minY: Ne,
        maxX: Math.min(te, c) - z,
        maxY: Math.min(ee, r) - W
      },
      view: L,
      percent: $e,
      widthPercent: Ve * 100 | 0
    }), y.add(L.id);
  }
  const O = p[0], R = p.at(-1);
  return i && p.sort(function(F, L) {
    const P = F.percent - L.percent;
    return Math.abs(P) > 1e-3 ? -P : F.id - L.id;
  }), {
    first: O,
    last: R,
    views: p,
    ids: y
  };
}
function dve(e) {
  return Number.isInteger(e) && e % 90 === 0;
}
function DPe(e) {
  return Number.isInteger(e) && Object.values(Rr).includes(e) && e !== Rr.UNKNOWN;
}
function CPe(e) {
  return Number.isInteger(e) && Object.values(Bm).includes(e) && e !== Bm.UNKNOWN;
}
function uEe(e) {
  return e.width <= e.height;
}
new Promise(function(e) {
  window.requestAnimationFrame(e);
});
const OPe = document.documentElement.style;
var eP, gF, tP, Yj, wF;
class LPe {
  constructor(t) {
    xe(this, eP, null);
    xe(this, gF, null);
    xe(this, tP, 0);
    xe(this, Yj, null);
    xe(this, wF, !0);
    be(this, eP, t.classList), be(this, Yj, t.style);
  }
  get percent() {
    return S(this, tP);
  }
  set percent(t) {
    if (be(this, tP, rve(t, 0, 100)), isNaN(t)) {
      S(this, eP).add("indeterminate");
      return;
    }
    S(this, eP).remove("indeterminate"), S(this, Yj).setProperty("--progressBar-percent", `${S(this, tP)}%`);
  }
  setWidth(t) {
    if (!t)
      return;
    const n = t.parentNode.offsetWidth - t.offsetWidth;
    n > 0 && S(this, Yj).setProperty("--progressBar-end-offset", `${n}px`);
  }
  setDisableAutoFetch(t = 5e3) {
    S(this, tP) === 100 || isNaN(S(this, tP)) || (S(this, gF) && clearTimeout(S(this, gF)), this.show(), be(this, gF, setTimeout(() => {
      be(this, gF, null), this.hide();
    }, t)));
  }
  hide() {
    S(this, wF) && (be(this, wF, !1), S(this, eP).add("hidden"));
  }
  show() {
    S(this, wF) || (be(this, wF, !0), S(this, eP).remove("hidden"));
  }
}
eP = new WeakMap(), gF = new WeakMap(), tP = new WeakMap(), Yj = new WeakMap(), wF = new WeakMap();
function _Pe(e) {
  let t = Rr.VERTICAL, i = Bm.NONE;
  switch (e) {
    case "SinglePage":
      t = Rr.PAGE;
      break;
    case "OneColumn":
      break;
    case "TwoPageLeft":
      t = Rr.PAGE;
    case "TwoColumnLeft":
      i = Bm.ODD;
      break;
    case "TwoPageRight":
      t = Rr.PAGE;
    case "TwoColumnRight":
      i = Bm.EVEN;
      break;
  }
  return {
    scrollMode: t,
    spreadMode: i
  };
}
const wne = (function() {
  const e = document.createElement("div");
  return e.style.width = "round(down, calc(1.6666666666666665 * 792px), 1px)", e.style.width === "calc(1320px)" ? Math.fround : (t) => t;
})(), rv = {
  SPACE: 0,
  ALPHA_LETTER: 1,
  PUNCT: 2,
  HAN_LETTER: 3,
  KATAKANA_LETTER: 4,
  HIRAGANA_LETTER: 5,
  HALFWIDTH_KATAKANA_LETTER: 6,
  THAI_LETTER: 7
};
function xPe(e) {
  return e < 11904;
}
function PPe(e) {
  return (e & 65408) === 0;
}
function MPe(e) {
  return e >= 97 && e <= 122 || e >= 65 && e <= 90;
}
function UPe(e) {
  return e >= 48 && e <= 57;
}
function BPe(e) {
  return e === 32 || e === 9 || e === 13 || e === 10;
}
function FPe(e) {
  return e >= 13312 && e <= 40959 || e >= 63744 && e <= 64255;
}
function HPe(e) {
  return e >= 12448 && e <= 12543;
}
function GPe(e) {
  return e >= 12352 && e <= 12447;
}
function kPe(e) {
  return e >= 65376 && e <= 65439;
}
function VPe(e) {
  return (e & 65408) === 3584;
}
function Tne(e) {
  return xPe(e) ? PPe(e) ? BPe(e) ? rv.SPACE : MPe(e) || UPe(e) || e === 95 ? rv.ALPHA_LETTER : rv.PUNCT : VPe(e) ? rv.THAI_LETTER : e === 160 ? rv.SPACE : rv.ALPHA_LETTER : FPe(e) ? rv.HAN_LETTER : HPe(e) ? rv.KATAKANA_LETTER : GPe(e) ? rv.HIRAGANA_LETTER : kPe(e) ? rv.HALFWIDTH_KATAKANA_LETTER : rv.ALPHA_LETTER;
}
let dEe;
function zPe() {
  return dEe || (dEe = " ¨ª¯²-µ¸-º¼-¾Ĳ-ĳĿ-ŀŉſǄ-ǌǱ-ǳʰ-ʸ˘-˝ˠ-ˤʹͺ;΄-΅·ϐ-ϖϰ-ϲϴ-ϵϹևٵ-ٸक़-य़ড়-ঢ়য়ਲ਼ਸ਼ਖ਼-ਜ਼ਫ਼ଡ଼-ଢ଼ำຳໜ-ໝ༌གྷཌྷདྷབྷཛྷཀྵჼᴬ-ᴮᴰ-ᴺᴼ-ᵍᵏ-ᵪᵸᶛ-ᶿẚ-ẛάέήίόύώΆ᾽-῁ΈΉ῍-῏ΐΊ῝-῟ΰΎ῭-`ΌΏ´-῾ - ‑‗․-… ″-‴‶-‷‼‾⁇-⁉⁗ ⁰-ⁱ⁴-₎ₐ-ₜ₨℀-℃℅-ℇ℉-ℓℕ-№ℙ-ℝ℠-™ℤΩℨK-ℭℯ-ℱℳ-ℹ℻-⅀ⅅ-ⅉ⅐-ⅿ↉∬-∭∯-∰〈-〉①-⓪⨌⩴-⩶⫝̸ⱼ-ⱽⵯ⺟⻳⼀-⿕　〶〸-〺゛-゜ゟヿㄱ-ㆎ㆒-㆟㈀-㈞㈠-㉇㉐-㉾㊀-㏿ꚜ-ꚝꝰꟲ-ꟴꟸ-ꟹꭜ-ꭟꭩ豈-嗀塚晴凞-羽蘒諸逸-都飯-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-זּטּ-לּמּנּ-סּףּ-פּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-﷼︐-︙︰-﹄﹇-﹒﹔-﹦﹨-﹫ﹰ-ﹲﹴﹶ-ﻼ！-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ￠-￦"), dEe;
}
const w_ = {
  FOUND: 0,
  NOT_FOUND: 1,
  WRAPPED: 2,
  PENDING: 3
}, jPe = 250, WPe = -50, YPe = -400, cEe = {
  "‐": "-",
  "‘": "'",
  "’": "'",
  "‚": "'",
  "‛": "'",
  "“": '"',
  "”": '"',
  "„": '"',
  "‟": '"',
  "¼": "1/4",
  "½": "1/2",
  "¾": "3/4"
}, hEe = /* @__PURE__ */ new Set([12441, 12442, 2381, 2509, 2637, 2765, 2893, 3021, 3149, 3277, 3387, 3388, 3405, 3530, 3642, 3770, 3972, 4153, 4154, 5908, 5940, 6098, 6752, 6980, 7082, 7083, 7154, 7155, 11647, 43014, 43052, 43204, 43347, 43456, 43766, 44013, 3158, 3953, 3954, 3962, 3963, 3964, 3965, 3968, 3956]);
let fEe;
const qPe = new RegExp("\\p{M}+", "gu"), $Pe = new RegExp("([.*+?^${}()|[\\]\\\\])|(\\p{P})|(\\s+)|(\\p{M})|(\\p{L})", "gu"), KPe = new RegExp("([^\\p{M}])\\p{M}*$", "u"), ZPe = new RegExp("^\\p{M}*([^\\p{M}])", "u"), QPe = /[\uAC00-\uD7AF\uFA6C\uFACF-\uFAD1\uFAD5-\uFAD7]+/g, IEe = /* @__PURE__ */ new Map(), JPe = "[\\u1100-\\u1112\\ud7a4-\\ud7af\\ud84a\\ud84c\\ud850\\ud854\\ud857\\ud85f]", pEe = /* @__PURE__ */ new Map();
let hde = null, fde = null;
function Soe(e, t = {}) {
  const i = [];
  let n;
  for (; (n = QPe.exec(e)) !== null; ) {
    let {
      index: F
    } = n;
    for (const L of n[0]) {
      let P = IEe.get(L);
      P || (P = L.normalize("NFD").length, IEe.set(L, P)), i.push([P, F++]);
    }
  }
  const s = i.length > 0, o = t.ignoreDashEOL ?? !1;
  let r;
  if (!s && hde)
    r = hde;
  else if (s && fde)
    r = fde;
  else {
    const F = Object.keys(cEe).join(""), L = zPe(), re = [`[${F}]`, `[${L}]`, "(?:゙|゚)\\n", "\\p{M}+(?:-\\n)?", "\\p{Ll}-\\n(?=\\p{Ll})|\\p{Lu}-\\n(?=\\p{L})", "\\S-\\n", "(?:\\p{Ideographic}|[぀-ヿ])\\n", "\\n", s ? JPe : "\\u0000"];
    r = new RegExp(re.map((ce) => `(${ce})`).join("|"), "gum"), s ? fde = r : hde = r;
  }
  const l = [];
  for (; (n = qPe.exec(e)) !== null; )
    l.push([n[0].length, n.index]);
  let c = e.normalize("NFD");
  const h = [0, 0];
  let I = 0, p = 0, y = 0, m = 0, A = 0, C = !1;
  c = c.replace(r, (F, L, P, z, W, re, ce, te, ee, Ne, Ae) => {
    var Oe, pe, je;
    if (Ae -= m, L) {
      const Ve = cEe[L], $e = Ve.length;
      for (let vt = 1; vt < $e; vt++)
        h.push(Ae - y + vt, y - vt);
      return y -= $e - 1, Ve;
    }
    if (P) {
      let Ve = pEe.get(P);
      Ve || (Ve = P.normalize("NFKC"), pEe.set(P, Ve));
      const $e = Ve.length;
      for (let vt = 1; vt < $e; vt++)
        h.push(Ae - y + vt, y - vt);
      return y -= $e - 1, Ve;
    }
    if (z)
      return C = !0, Ae + A === ((Oe = l[I]) == null ? void 0 : Oe[1]) ? ++I : (h.push(Ae - 1 - y + 1, y - 1), y -= 1, m += 1), h.push(Ae - y + 1, y), m += 1, A += 1, z.charAt(0);
    if (W) {
      const Ve = W.endsWith(`
`), $e = Ve ? W.length - 2 : W.length;
      C = !0;
      let vt = $e;
      Ae + A === ((pe = l[I]) == null ? void 0 : pe[1]) && (vt -= l[I][0], ++I);
      for (let Rt = 1; Rt <= vt; Rt++)
        h.push(Ae - 1 - y + Rt, y - Rt);
      return y -= vt, m += vt, Ve ? (Ae += $e - 1, h.push(Ae - y + 1, 1 + y), y += 1, m += 1, A += 1, W.slice(0, $e)) : W;
    }
    if (re) {
      if (o)
        return m += 1, A += 1, re.slice(0, -1);
      const Ve = re.length - 2;
      return h.push(Ae - y + Ve, 1 + y), y += 1, m += 1, A += 1, re.slice(0, -2);
    }
    if (ce)
      return m += 1, A += 1, ce.slice(0, -1);
    if (te) {
      const Ve = te.length - 1;
      return h.push(Ae - y + Ve, y), m += 1, A += 1, te.slice(0, -1);
    }
    if (ee)
      return h.push(Ae - y + 1, y - 1), y -= 1, m += 1, A += 1, " ";
    if (Ae + A === ((je = i[p]) == null ? void 0 : je[1])) {
      const Ve = i[p][0] - 1;
      ++p;
      for (let $e = 1; $e <= Ve; $e++)
        h.push(Ae - (y - $e), y - $e);
      y -= Ve, m += Ve;
    }
    return Ne;
  }), h.push(c.length, y);
  const O = new Uint32Array(h.length >> 1), R = new Int32Array(h.length >> 1);
  for (let F = 0, L = h.length; F < L; F += 2)
    O[F >> 1] = h[F], R[F >> 1] = h[F + 1];
  return [c, [O, R], C];
}
function cve(e, t, i) {
  if (!e)
    return [t, i];
  const [n, s] = e, o = t, r = t + i - 1;
  let l = cX(n, (y) => y >= o);
  n[l] > o && --l;
  let c = cX(n, (y) => y >= r, l);
  n[c] > r && --c;
  const h = o + s[l], p = r + s[c] + 1 - h;
  return [h, p];
}
var Vh, qj, TF, ss, hve, Rfe, vfe, fve, Ive, Afe, pve, mve, boe, gQ, bV, yve, Sfe, bfe, Noe, Eve, Nfe, Dfe, wQ;
class XPe {
  constructor({
    linkService: t,
    eventBus: i,
    updateMatchesCountOnProgress: n = !0
  }) {
    xe(this, ss);
    xe(this, Vh, null);
    xe(this, qj, !0);
    xe(this, TF, 0);
    this._linkService = t, this._eventBus = i, be(this, qj, n), this.onIsPageVisible = null, _e(this, ss, Rfe).call(this), i._on("find", _e(this, ss, hve).bind(this)), i._on("findbarclose", _e(this, ss, Eve).bind(this));
  }
  get highlightMatches() {
    return this._highlightMatches;
  }
  get pageMatches() {
    return this._pageMatches;
  }
  get pageMatchesLength() {
    return this._pageMatchesLength;
  }
  get selected() {
    return this._selected;
  }
  get state() {
    return S(this, Vh);
  }
  setDocument(t) {
    this._pdfDocument && _e(this, ss, Rfe).call(this), t && (this._pdfDocument = t, this._firstPageCapability.resolve());
  }
  scrollMatchIntoView({
    element: t = null,
    selectedLeft: i = 0,
    pageIndex: n = -1,
    matchIndex: s = -1
  }) {
    if (!this._scrollMatches || !t)
      return;
    if (s === -1 || s !== this._selected.matchIdx)
      return;
    if (n === -1 || n !== this._selected.pageIdx)
      return;
    this._scrollMatches = !1;
    const o = {
      top: WPe,
      left: i + YPe
    };
    uve(t, o, !0);
  }
  match(t, i, n) {
    const s = this._hasDiacritics[n];
    let o = !1;
    if (typeof t == "string" ? [o, t] = _e(this, ss, Afe).call(this, t, s) : t = t.sort().reverse().map((p) => {
      const [y, m] = _e(this, ss, Afe).call(this, p, s);
      return o || (o = y), `(${m})`;
    }).join("|"), !t)
      return;
    const {
      caseSensitive: r,
      entireWord: l
    } = S(this, Vh), c = `g${o ? "u" : ""}${r ? "" : "i"}`;
    t = new RegExp(t, c);
    const h = [];
    let I;
    for (; (I = t.exec(i)) !== null; )
      l && !_e(this, ss, Ive).call(this, i, I.index, I[0].length) || h.push({
        index: I.index,
        length: I[0].length
      });
    return h;
  }
}
Vh = new WeakMap(), qj = new WeakMap(), TF = new WeakMap(), ss = new WeakSet(), hve = function(t) {
  if (!t)
    return;
  const i = this._pdfDocument, {
    type: n
  } = t;
  (S(this, Vh) === null || _e(this, ss, fve).call(this, t)) && (this._dirtyMatch = !0), be(this, Vh, t), n !== "highlightallchange" && _e(this, ss, wQ).call(this, w_.PENDING), this._firstPageCapability.promise.then(() => {
    if (!this._pdfDocument || i && this._pdfDocument !== i)
      return;
    _e(this, ss, mve).call(this);
    const s = !this._highlightMatches, o = !!this._findTimeout;
    this._findTimeout && (clearTimeout(this._findTimeout), this._findTimeout = null), n ? this._dirtyMatch ? _e(this, ss, bV).call(this) : n === "again" ? (_e(this, ss, bV).call(this), s && S(this, Vh).highlightAll && _e(this, ss, gQ).call(this)) : n === "highlightallchange" ? (o ? _e(this, ss, bV).call(this) : this._highlightMatches = !0, _e(this, ss, gQ).call(this)) : _e(this, ss, bV).call(this) : this._findTimeout = setTimeout(() => {
      _e(this, ss, bV).call(this), this._findTimeout = null;
    }, jPe);
  });
}, Rfe = function() {
  this._highlightMatches = !1, this._scrollMatches = !1, this._pdfDocument = null, this._pageMatches = [], this._pageMatchesLength = [], be(this, TF, 0), be(this, Vh, null), this._selected = {
    pageIdx: -1,
    matchIdx: -1
  }, this._offset = {
    pageIdx: null,
    matchIdx: null,
    wrapped: !1
  }, this._extractTextPromises = [], this._pageContents = [], this._pageDiffs = [], this._hasDiacritics = [], this._matchesCountTotal = 0, this._pagesToSearch = null, this._pendingFindMatches = /* @__PURE__ */ new Set(), this._resumePageIdx = null, this._dirtyMatch = !1, clearTimeout(this._findTimeout), this._findTimeout = null, this._firstPageCapability = Promise.withResolvers();
}, vfe = function() {
  const {
    query: t
  } = S(this, Vh);
  return typeof t == "string" ? (t !== this._rawQuery && (this._rawQuery = t, [this._normalizedQuery] = Soe(t)), this._normalizedQuery) : (t || []).filter((i) => !!i).map((i) => Soe(i)[0]);
}, fve = function(t) {
  var r;
  const i = t.query, n = S(this, Vh).query, s = typeof i;
  if (s !== typeof n)
    return !0;
  if (s === "string") {
    if (i !== n)
      return !0;
  } else if (JSON.stringify(i) !== JSON.stringify(n))
    return !0;
  switch (t.type) {
    case "again":
      const l = this._selected.pageIdx + 1, c = this._linkService;
      return l >= 1 && l <= c.pagesCount && l !== c.page && !(((r = this.onIsPageVisible) == null ? void 0 : r.call(this, l)) ?? !0);
    case "highlightallchange":
      return !1;
  }
  return !0;
}, Ive = function(t, i, n) {
  let s = t.slice(0, i).match(KPe);
  if (s) {
    const o = t.charCodeAt(i), r = s[1].charCodeAt(0);
    if (Tne(o) === Tne(r))
      return !1;
  }
  if (s = t.slice(i + n).match(ZPe), s) {
    const o = t.charCodeAt(i + n - 1), r = s[1].charCodeAt(0);
    if (Tne(o) === Tne(r))
      return !1;
  }
  return !0;
}, Afe = function(t, i) {
  const {
    matchDiacritics: n
  } = S(this, Vh);
  let s = !1;
  t = t.replaceAll($Pe, (r, l, c, h, I, p) => l ? `[ ]*\\${l}[ ]*` : c ? `[ ]*${c}[ ]*` : h ? "[ ]+" : n ? I || p : I ? hEe.has(I.charCodeAt(0)) ? I : "" : i ? (s = !0, `${p}\\p{M}*`) : p);
  const o = "[ ]*";
  return t.endsWith(o) && (t = t.slice(0, t.length - o.length)), n && i && (fEe || (fEe = String.fromCharCode(...hEe)), s = !0, t = `${t}(?=[${fEe}]|[^\\p{M}]|$)`), [s, t];
}, pve = function(t) {
  if (!S(this, Vh))
    return;
  const i = S(this, ss, vfe);
  if (i.length === 0)
    return;
  const n = this._pageContents[t], s = this.match(i, n, t), o = this._pageMatches[t] = [], r = this._pageMatchesLength[t] = [], l = this._pageDiffs[t];
  s == null || s.forEach(({
    index: h,
    length: I
  }) => {
    const [p, y] = cve(l, h, I);
    y && (o.push(p), r.push(y));
  }), S(this, Vh).highlightAll && _e(this, ss, boe).call(this, t), this._resumePageIdx === t && (this._resumePageIdx = null, _e(this, ss, Sfe).call(this));
  const c = o.length;
  this._matchesCountTotal += c, S(this, qj) ? c > 0 && _e(this, ss, Dfe).call(this) : ++hp(this, TF)._ === this._linkService.pagesCount && _e(this, ss, Dfe).call(this);
}, mve = function() {
  if (this._extractTextPromises.length > 0)
    return;
  let t = Promise.resolve();
  const i = {
    disableNormalization: !0
  }, n = this._pdfDocument;
  for (let s = 0, o = this._linkService.pagesCount; s < o; s++) {
    const {
      promise: r,
      resolve: l
    } = Promise.withResolvers();
    this._extractTextPromises[s] = r, t = t.then(async () => {
      if (n !== this._pdfDocument) {
        l();
        return;
      }
      await n.getPage(s + 1).then((c) => c.getTextContent(i)).then((c) => {
        const h = [];
        for (const I of c.items)
          h.push(I.str), I.hasEOL && h.push(`
`);
        [this._pageContents[s], this._pageDiffs[s], this._hasDiacritics[s]] = Soe(h.join("")), l();
      }, (c) => {
        console.error(`Unable to get text content for page ${s + 1}`, c), this._pageContents[s] = "", this._pageDiffs[s] = null, this._hasDiacritics[s] = !1, l();
      });
    });
  }
}, boe = function(t) {
  this._scrollMatches && this._selected.pageIdx === t && (this._linkService.page = t + 1), this._eventBus.dispatch("updatetextlayermatches", {
    source: this,
    pageIndex: t
  });
}, gQ = function() {
  this._eventBus.dispatch("updatetextlayermatches", {
    source: this,
    pageIndex: -1
  });
}, bV = function() {
  const t = S(this, Vh).findPrevious, i = this._linkService.page - 1, n = this._linkService.pagesCount;
  if (this._highlightMatches = !0, this._dirtyMatch) {
    this._dirtyMatch = !1, this._selected.pageIdx = this._selected.matchIdx = -1, this._offset.pageIdx = i, this._offset.matchIdx = null, this._offset.wrapped = !1, this._resumePageIdx = null, this._pageMatches.length = 0, this._pageMatchesLength.length = 0, be(this, TF, 0), this._matchesCountTotal = 0, _e(this, ss, gQ).call(this);
    for (let r = 0; r < n; r++)
      this._pendingFindMatches.has(r) || (this._pendingFindMatches.add(r), this._extractTextPromises[r].then(() => {
        this._pendingFindMatches.delete(r), _e(this, ss, pve).call(this, r);
      }));
  }
  if (S(this, ss, vfe).length === 0) {
    _e(this, ss, wQ).call(this, w_.FOUND);
    return;
  }
  if (this._resumePageIdx)
    return;
  const o = this._offset;
  if (this._pagesToSearch = n, o.matchIdx !== null) {
    const r = this._pageMatches[o.pageIdx].length;
    if (!t && o.matchIdx + 1 < r || t && o.matchIdx > 0) {
      o.matchIdx = t ? o.matchIdx - 1 : o.matchIdx + 1, _e(this, ss, Noe).call(this, !0);
      return;
    }
    _e(this, ss, bfe).call(this, t);
  }
  _e(this, ss, Sfe).call(this);
}, yve = function(t) {
  const i = this._offset, n = t.length, s = S(this, Vh).findPrevious;
  return n ? (i.matchIdx = s ? n - 1 : 0, _e(this, ss, Noe).call(this, !0), !0) : (_e(this, ss, bfe).call(this, s), i.wrapped && (i.matchIdx = null, this._pagesToSearch < 0) ? (_e(this, ss, Noe).call(this, !1), !0) : !1);
}, Sfe = function() {
  this._resumePageIdx !== null && console.error("There can only be one pending page.");
  let t = null;
  do {
    const i = this._offset.pageIdx;
    if (t = this._pageMatches[i], !t) {
      this._resumePageIdx = i;
      break;
    }
  } while (!_e(this, ss, yve).call(this, t));
}, bfe = function(t) {
  const i = this._offset, n = this._linkService.pagesCount;
  i.pageIdx = t ? i.pageIdx - 1 : i.pageIdx + 1, i.matchIdx = null, this._pagesToSearch--, (i.pageIdx >= n || i.pageIdx < 0) && (i.pageIdx = t ? n - 1 : 0, i.wrapped = !0);
}, Noe = function(t = !1) {
  let i = w_.NOT_FOUND;
  const n = this._offset.wrapped;
  if (this._offset.wrapped = !1, t) {
    const s = this._selected.pageIdx;
    this._selected.pageIdx = this._offset.pageIdx, this._selected.matchIdx = this._offset.matchIdx, i = n ? w_.WRAPPED : w_.FOUND, s !== -1 && s !== this._selected.pageIdx && _e(this, ss, boe).call(this, s);
  }
  _e(this, ss, wQ).call(this, i, S(this, Vh).findPrevious), this._selected.pageIdx !== -1 && (this._scrollMatches = !0, _e(this, ss, boe).call(this, this._selected.pageIdx));
}, Eve = function(t) {
  const i = this._pdfDocument;
  this._firstPageCapability.promise.then(() => {
    !this._pdfDocument || i && this._pdfDocument !== i || (this._findTimeout && (clearTimeout(this._findTimeout), this._findTimeout = null), this._resumePageIdx && (this._resumePageIdx = null, this._dirtyMatch = !0), _e(this, ss, wQ).call(this, w_.FOUND), this._highlightMatches = !1, _e(this, ss, gQ).call(this));
  });
}, Nfe = function() {
  var o;
  const {
    pageIdx: t,
    matchIdx: i
  } = this._selected;
  let n = 0, s = this._matchesCountTotal;
  if (i !== -1) {
    for (let r = 0; r < t; r++)
      n += ((o = this._pageMatches[r]) == null ? void 0 : o.length) || 0;
    n += i + 1;
  }
  return (n < 1 || n > s) && (n = s = 0), {
    current: n,
    total: s
  };
}, Dfe = function() {
  this._eventBus.dispatch("updatefindmatchescount", {
    source: this,
    matchesCount: _e(this, ss, Nfe).call(this)
  });
}, wQ = function(t, i = !1) {
  var n, s;
  !S(this, qj) && (S(this, TF) !== this._linkService.pagesCount || t === w_.PENDING) || this._eventBus.dispatch("updatefindcontrolstate", {
    source: this,
    state: t,
    previous: i,
    entireWord: ((n = S(this, Vh)) == null ? void 0 : n.entireWord) ?? null,
    matchesCount: _e(this, ss, Nfe).call(this),
    rawQuery: ((s = S(this, Vh)) == null ? void 0 : s.query) ?? null
  });
};
const e8e = "noopener noreferrer nofollow", K_ = {
  NONE: 0,
  SELF: 1,
  BLANK: 2,
  PARENT: 3,
  TOP: 4
};
class Upe {
  constructor({
    eventBus: t,
    externalLinkTarget: i = null,
    externalLinkRel: n = null,
    ignoreDestinationZoom: s = !1
  } = {}) {
    Zi(this, "externalLinkEnabled", !0);
    this.eventBus = t, this.externalLinkTarget = i, this.externalLinkRel = n, this._ignoreDestinationZoom = s, this.baseUrl = null, this.pdfDocument = null, this.pdfViewer = null, this.pdfHistory = null;
  }
  setDocument(t, i = null) {
    this.baseUrl = i, this.pdfDocument = t;
  }
  setViewer(t) {
    this.pdfViewer = t;
  }
  setHistory(t) {
    this.pdfHistory = t;
  }
  get pagesCount() {
    return this.pdfDocument ? this.pdfDocument.numPages : 0;
  }
  get page() {
    return this.pdfDocument ? this.pdfViewer.currentPageNumber : 1;
  }
  set page(t) {
    this.pdfDocument && (this.pdfViewer.currentPageNumber = t);
  }
  get rotation() {
    return this.pdfDocument ? this.pdfViewer.pagesRotation : 0;
  }
  set rotation(t) {
    this.pdfDocument && (this.pdfViewer.pagesRotation = t);
  }
  get isInPresentationMode() {
    return this.pdfDocument ? this.pdfViewer.isInPresentationMode : !1;
  }
  async goToDestination(t) {
    if (!this.pdfDocument)
      return;
    let i, n, s;
    if (typeof t == "string" ? (i = t, n = await this.pdfDocument.getDestination(t)) : (i = null, n = await t), !Array.isArray(n)) {
      console.error(`goToDestination: "${n}" is not a valid destination array, for dest="${t}".`);
      return;
    }
    const [o] = n;
    if (o && typeof o == "object") {
      if (s = this.pdfDocument.cachedPageNumber(o), !s)
        try {
          s = await this.pdfDocument.getPageIndex(o) + 1;
        } catch {
          console.error(`goToDestination: "${o}" is not a valid page reference, for dest="${t}".`);
          return;
        }
    } else Number.isInteger(o) && (s = o + 1);
    if (!s || s < 1 || s > this.pagesCount) {
      console.error(`goToDestination: "${s}" is not a valid page number, for dest="${t}".`);
      return;
    }
    this.pdfHistory && (this.pdfHistory.pushCurrentPosition(), this.pdfHistory.push({
      namedDest: i,
      explicitDest: n,
      pageNumber: s
    })), this.pdfViewer.scrollPageIntoView({
      pageNumber: s,
      destArray: n,
      ignoreDestinationZoom: this._ignoreDestinationZoom
    });
    const r = new AbortController();
    this.eventBus._on("textlayerrendered", (l) => {
      l.pageNumber === s && (l.source.textLayer.div.focus(), r.abort());
    }, {
      signal: r.signal
    });
  }
  goToPage(t) {
    if (!this.pdfDocument)
      return;
    const i = typeof t == "string" && this.pdfViewer.pageLabelToPageNumber(t) || t | 0;
    if (!(Number.isInteger(i) && i > 0 && i <= this.pagesCount)) {
      console.error(`PDFLinkService.goToPage: "${t}" is not a valid page.`);
      return;
    }
    this.pdfHistory && (this.pdfHistory.pushCurrentPosition(), this.pdfHistory.pushPage(i)), this.pdfViewer.scrollPageIntoView({
      pageNumber: i
    });
  }
  addLinkAttributes(t, i, n = !1) {
    if (!i || typeof i != "string")
      throw new Error('A valid "url" parameter must provided.');
    const s = n ? K_.BLANK : this.externalLinkTarget, o = this.externalLinkRel;
    this.externalLinkEnabled ? t.href = t.title = i : (t.href = "", t.title = `Disabled: ${i}`, t.onclick = () => !1);
    let r = "";
    switch (s) {
      case K_.NONE:
        break;
      case K_.SELF:
        r = "_self";
        break;
      case K_.BLANK:
        r = "_blank";
        break;
      case K_.PARENT:
        r = "_parent";
        break;
      case K_.TOP:
        r = "_top";
        break;
    }
    t.target = r, t.rel = typeof o == "string" ? o : e8e;
  }
  getDestinationHash(t) {
    if (typeof t == "string") {
      if (t.length > 0)
        return this.getAnchorUrl("#" + escape(t));
    } else if (Array.isArray(t)) {
      const i = JSON.stringify(t);
      if (i.length > 0)
        return this.getAnchorUrl("#" + escape(i));
    }
    return this.getAnchorUrl("");
  }
  getAnchorUrl(t) {
    return this.baseUrl ? this.baseUrl + t : t;
  }
  setHash(t) {
    if (!this.pdfDocument)
      return;
    let i, n;
    if (t.includes("=")) {
      const s = Tae(t);
      if (s.has("search")) {
        const o = s.get("search").replaceAll('"', ""), r = s.get("phrase") === "true";
        this.eventBus.dispatch("findfromurlhash", {
          source: this,
          query: r ? o : o.match(/\S+/g)
        });
      }
      if (s.has("page") && (i = s.get("page") | 0 || 1), s.has("zoom")) {
        const o = s.get("zoom").split(","), r = o[0], l = parseFloat(r);
        r.includes("Fit") ? r === "Fit" || r === "FitB" ? n = [null, {
          name: r
        }] : r === "FitH" || r === "FitBH" || r === "FitV" || r === "FitBV" ? n = [null, {
          name: r
        }, o.length > 1 ? o[1] | 0 : null] : r === "FitR" ? o.length !== 5 ? console.error('PDFLinkService.setHash: Not enough parameters for "FitR".') : n = [null, {
          name: r
        }, o[1] | 0, o[2] | 0, o[3] | 0, o[4] | 0] : console.error(`PDFLinkService.setHash: "${r}" is not a valid zoom value.`) : n = [null, {
          name: "XYZ"
        }, o.length > 1 ? o[1] | 0 : null, o.length > 2 ? o[2] | 0 : null, l ? l / 100 : r];
      }
      n ? this.pdfViewer.scrollPageIntoView({
        pageNumber: i || this.page,
        destArray: n,
        allowNegativeOffset: !0
      }) : i && (this.page = i), s.has("pagemode") && this.eventBus.dispatch("pagemode", {
        source: this,
        mode: s.get("pagemode")
      }), s.has("nameddest") && this.goToDestination(s.get("nameddest"));
      return;
    }
    n = unescape(t);
    try {
      n = JSON.parse(n), Array.isArray(n) || (n = n.toString());
    } catch {
    }
    if (typeof n == "string" || yPe(n)) {
      this.goToDestination(n);
      return;
    }
    console.error(`PDFLinkService.setHash: "${unescape(t)}" is not a valid destination.`);
  }
  executeNamedAction(t) {
    var i, n;
    if (this.pdfDocument) {
      switch (t) {
        case "GoBack":
          (i = this.pdfHistory) == null || i.back();
          break;
        case "GoForward":
          (n = this.pdfHistory) == null || n.forward();
          break;
        case "NextPage":
          this.pdfViewer.nextPage();
          break;
        case "PrevPage":
          this.pdfViewer.previousPage();
          break;
        case "LastPage":
          this.page = this.pagesCount;
          break;
        case "FirstPage":
          this.page = 1;
          break;
      }
      this.eventBus.dispatch("namedaction", {
        source: this,
        action: t
      });
    }
  }
  async executeSetOCGState(t) {
    if (!this.pdfDocument)
      return;
    const i = this.pdfDocument, n = await this.pdfViewer.optionalContentConfigPromise;
    i === this.pdfDocument && (n.setOCGState(t), this.pdfViewer.optionalContentConfigPromise = Promise.resolve(n));
  }
}
class Bpe extends Upe {
  setDocument(t, i = null) {
  }
}
var iP, Tte, Rte, nP, vte, a6, Cfe, Ofe, wve;
class gve {
  constructor({
    pdfPage: t,
    linkService: i,
    downloadManager: n,
    annotationStorage: s = null,
    imageResourcesPath: o = "",
    renderForms: r = !0,
    enableScripting: l = !1,
    hasJSActionsPromise: c = null,
    fieldObjectsPromise: h = null,
    annotationCanvasMap: I = null,
    accessibilityManager: p = null,
    annotationEditorUIManager: y = null,
    onAppend: m = null
  }) {
    xe(this, a6);
    xe(this, iP, null);
    xe(this, Tte, !1);
    xe(this, Rte, null);
    xe(this, nP, null);
    xe(this, vte, !1);
    this.pdfPage = t, this.linkService = i, this.downloadManager = n, this.imageResourcesPath = o, this.renderForms = r, this.annotationStorage = s, this.enableScripting = l, this._hasJSActionsPromise = c || Promise.resolve(!1), this._fieldObjectsPromise = h || Promise.resolve(null), this._annotationCanvasMap = I, this._accessibilityManager = p, this._annotationEditorUIManager = y, be(this, Rte, m), this.annotationLayer = null, this.div = null, this._cancelled = !1, this._eventBus = i.eventBus;
  }
  async render({
    viewport: t,
    intent: i = "display",
    structTreeLayer: n = null
  }) {
    var c, h;
    if (this.div) {
      if (this._cancelled || !this.annotationLayer)
        return;
      this.annotationLayer.update({
        viewport: t.clone({
          dontFlip: !0
        })
      });
      return;
    }
    const [s, o, r] = await Promise.all([this.pdfPage.getAnnotations({
      intent: i
    }), this._hasJSActionsPromise, this._fieldObjectsPromise]);
    if (this._cancelled)
      return;
    const l = this.div = document.createElement("div");
    if (l.className = "annotationLayer", (c = S(this, Rte)) == null || c.call(this, l), s.length === 0) {
      be(this, iP, s), this.hide(!0);
      return;
    }
    _e(this, a6, Cfe).call(this, t, n), await this.annotationLayer.render({
      annotations: s,
      imageResourcesPath: this.imageResourcesPath,
      renderForms: this.renderForms,
      linkService: this.linkService,
      downloadManager: this.downloadManager,
      annotationStorage: this.annotationStorage,
      enableScripting: this.enableScripting,
      hasJSActions: o,
      fieldObjects: r
    }), be(this, iP, s), this.linkService.isInPresentationMode && _e(this, a6, Ofe).call(this, vz.FULLSCREEN), S(this, nP) || (be(this, nP, new AbortController()), (h = this._eventBus) == null || h._on("presentationmodechanged", (I) => {
      _e(this, a6, Ofe).call(this, I.state);
    }, {
      signal: S(this, nP).signal
    }));
  }
  cancel() {
    var t;
    this._cancelled = !0, (t = S(this, nP)) == null || t.abort(), be(this, nP, null);
  }
  hide(t = !1) {
    be(this, Tte, !t), this.div && (this.div.hidden = !0);
  }
  hasEditableAnnotations() {
    var t;
    return !!((t = this.annotationLayer) != null && t.hasEditableAnnotations());
  }
  async injectLinkAnnotations({
    inferredLinks: t,
    viewport: i,
    structTreeLayer: n = null
  }) {
    if (S(this, iP) === null)
      throw new Error("`render` method must be called before `injectLinkAnnotations`.");
    if (this._cancelled || S(this, vte))
      return;
    be(this, vte, !0);
    const s = S(this, iP).length ? _e(this, a6, wve).call(this, t) : t;
    s.length && (this.annotationLayer || (_e(this, a6, Cfe).call(this, i, n), lve(this.div, i)), await this.annotationLayer.addLinkAnnotations(s, this.linkService), S(this, Tte) || (this.div.hidden = !1));
  }
}
iP = new WeakMap(), Tte = new WeakMap(), Rte = new WeakMap(), nP = new WeakMap(), vte = new WeakMap(), a6 = new WeakSet(), Cfe = function(t, i) {
  this.annotationLayer = new hPe({
    div: this.div,
    accessibilityManager: this._accessibilityManager,
    annotationCanvasMap: this._annotationCanvasMap,
    annotationEditorUIManager: this._annotationEditorUIManager,
    page: this.pdfPage,
    viewport: t.clone({
      dontFlip: !0
    }),
    structTreeLayer: i
  });
}, Ofe = function(t) {
  if (!this.div)
    return;
  let i = !1;
  switch (t) {
    case vz.FULLSCREEN:
      i = !0;
      break;
    case vz.NORMAL:
      break;
    default:
      return;
  }
  for (const n of this.div.childNodes)
    n.hasAttribute("data-internal-link") || (n.inert = i);
}, wve = function(t) {
  function i(o) {
    if (!o.quadPoints)
      return [o.rect];
    const r = [];
    for (let l = 2, c = o.quadPoints.length; l < c; l += 8) {
      const h = o.quadPoints[l], I = o.quadPoints[l + 1], p = o.quadPoints[l + 2], y = o.quadPoints[l + 3];
      r.push([p, y, h, I]);
    }
    return r;
  }
  function n(o, r) {
    const l = [], c = i(o), h = i(r);
    for (const I of c)
      for (const p of h) {
        const y = Mpe.intersect(I, p);
        y && l.push(y);
      }
    return l;
  }
  function s(o) {
    let r = 0;
    for (const l of o)
      r += Math.abs((l[2] - l[0]) * (l[3] - l[1]));
    return r;
  }
  return t.filter((o) => {
    let r;
    for (const l of S(this, iP)) {
      if (l.annotationType !== sve.LINK || !l.url)
        continue;
      const c = n(l, o);
      if (c.length !== 0 && (r ?? (r = s(i(o))), s(c) / r > 0.5))
        return !1;
    }
    return !0;
  });
};
function mEe(e, t) {
  const i = document.createElement("a");
  if (!i.click)
    throw new Error('DownloadManager: "a.click()" is not supported.');
  i.href = e, i.target = "_parent", "download" in i && (i.download = t), (document.body || document.documentElement).append(i), i.click(), i.remove();
}
var Ipe;
class t8e {
  constructor() {
    xe(this, Ipe, /* @__PURE__ */ new WeakMap());
  }
  downloadData(t, i, n) {
    const s = URL.createObjectURL(new Blob([t], {
      type: n
    }));
    mEe(s, i);
  }
  openOrDownloadData(t, i, n = null) {
    const o = mPe(i) ? "application/pdf" : "";
    return this.downloadData(t, i, o), !1;
  }
  download(t, i, n) {
    let s;
    if (t)
      s = URL.createObjectURL(new Blob([t], {
        type: "application/pdf"
      }));
    else {
      if (!ove(i, "http://example.com")) {
        console.error(`download - not a valid URL: ${i}`);
        return;
      }
      s = i + "#pdfjs.action=download";
    }
    mEe(s, n);
  }
}
Ipe = new WeakMap();
const yEe = {
  EVENT: "event",
  TIMEOUT: "timeout"
};
async function i8e({
  target: e,
  name: t,
  delay: i = 0
}) {
  if (typeof e != "object" || !(Number.isInteger(i) && i >= 0))
    throw new Error("waitOnEventOrTimeout - invalid parameters.");
  const {
    promise: n,
    resolve: s
  } = Promise.withResolvers(), o = new AbortController();
  function r(h) {
    o.abort(), clearTimeout(c), s(h);
  }
  const l = e instanceof Fpe ? "_on" : "addEventListener";
  e[l](t, r.bind(null, yEe.EVENT), {
    signal: o.signal
  });
  const c = setTimeout(r.bind(null, yEe.TIMEOUT), i);
  return n;
}
var $j;
class Fpe {
  constructor() {
    xe(this, $j, /* @__PURE__ */ Object.create(null));
  }
  on(t, i, n = null) {
    this._on(t, i, {
      external: !0,
      once: n == null ? void 0 : n.once,
      signal: n == null ? void 0 : n.signal
    });
  }
  off(t, i, n = null) {
    this._off(t, i);
  }
  dispatch(t, i) {
    const n = S(this, $j)[t];
    if (!n || n.length === 0)
      return;
    let s;
    for (const {
      listener: o,
      external: r,
      once: l
    } of n.slice(0)) {
      if (l && this._off(t, o), r) {
        (s || (s = [])).push(o);
        continue;
      }
      o(i);
    }
    if (s) {
      for (const o of s)
        o(i);
      s = null;
    }
  }
  _on(t, i, n = null) {
    var r;
    let s = null;
    if ((n == null ? void 0 : n.signal) instanceof AbortSignal) {
      const {
        signal: l
      } = n;
      if (l.aborted) {
        console.error("Cannot use an `aborted` signal.");
        return;
      }
      const c = () => this._off(t, i);
      s = () => l.removeEventListener("abort", c), l.addEventListener("abort", c);
    }
    ((r = S(this, $j))[t] || (r[t] = [])).push({
      listener: i,
      external: (n == null ? void 0 : n.external) === !0,
      once: (n == null ? void 0 : n.once) === !0,
      rmAbort: s
    });
  }
  _off(t, i, n = null) {
    var o;
    const s = S(this, $j)[t];
    if (s)
      for (let r = 0, l = s.length; r < l; r++) {
        const c = s[r];
        if (c.listener === i) {
          (o = c.rmAbort) == null || o.call(c), s.splice(r, 1);
          return;
        }
      }
  }
}
$j = new WeakMap();
class Az {
  constructor(t) {
    this.value = t;
  }
  valueOf() {
    return this.value;
  }
}
class ch extends Az {
  constructor(t = "???") {
    super(t);
  }
  toString(t) {
    return `{${this.value}}`;
  }
}
class zO extends Az {
  constructor(t, i = {}) {
    super(t), this.opts = i;
  }
  toString(t) {
    if (t)
      try {
        return t.memoizeIntlObject(Intl.NumberFormat, this.opts).format(this.value);
      } catch (i) {
        t.reportError(i);
      }
    return this.value.toString(10);
  }
}
class YP extends Az {
  static supportsValue(t) {
    if (typeof t == "number" || t instanceof Date) return !0;
    if (t instanceof Az) return YP.supportsValue(t.valueOf());
    if ("Temporal" in globalThis) {
      const i = globalThis.Temporal;
      if (t instanceof i.Instant || t instanceof i.PlainDateTime || t instanceof i.PlainDate || t instanceof i.PlainMonthDay || t instanceof i.PlainTime || t instanceof i.PlainYearMonth)
        return !0;
    }
    return !1;
  }
  constructor(t, i = {}) {
    t instanceof YP ? (i = {
      ...t.opts,
      ...i
    }, t = t.value) : t instanceof Az && (t = t.valueOf()), typeof t == "object" && "calendarId" in t && i.calendar === void 0 && (i = {
      ...i,
      calendar: t.calendarId
    }), super(t), this.opts = i;
  }
  [Symbol.toPrimitive](t) {
    return t === "string" ? this.toString() : this.toNumber();
  }
  toNumber() {
    const t = this.value;
    if (typeof t == "number") return t;
    if (t instanceof Date) return t.getTime();
    if ("epochMilliseconds" in t)
      return t.epochMilliseconds;
    if ("toZonedDateTime" in t)
      return t.toZonedDateTime("UTC").epochMilliseconds;
    throw new TypeError("Unwrapping a non-number value as a number");
  }
  toString(t) {
    if (t)
      try {
        return t.memoizeIntlObject(Intl.DateTimeFormat, this.opts).format(this.value);
      } catch (i) {
        t.reportError(i);
      }
    return typeof this.value == "number" || this.value instanceof Date ? new Date(this.value).toISOString() : this.value.toString();
  }
}
const EEe = 100, n8e = "⁨", s8e = "⁩";
function o8e(e, t, i) {
  if (i === t || i instanceof zO && t instanceof zO && i.value === t.value)
    return !0;
  if (t instanceof zO && typeof i == "string") {
    let n = e.memoizeIntlObject(Intl.PluralRules, t.opts).select(t.value);
    if (i === n)
      return !0;
  }
  return !1;
}
function gEe(e, t, i) {
  return t[i] ? bW(e, t[i].value) : (e.reportError(new RangeError("No default")), new ch());
}
function Lfe(e, t) {
  const i = [], n = /* @__PURE__ */ Object.create(null);
  for (const s of t)
    s.type === "narg" ? n[s.name] = hX(e, s.value) : i.push(hX(e, s));
  return {
    positional: i,
    named: n
  };
}
function hX(e, t) {
  switch (t.type) {
    case "str":
      return t.value;
    case "num":
      return new zO(t.value, {
        minimumFractionDigits: t.precision
      });
    case "var":
      return r8e(e, t);
    case "mesg":
      return l8e(e, t);
    case "term":
      return a8e(e, t);
    case "func":
      return u8e(e, t);
    case "select":
      return d8e(e, t);
    default:
      return new ch();
  }
}
function r8e(e, {
  name: t
}) {
  let i;
  if (e.params)
    if (Object.prototype.hasOwnProperty.call(e.params, t))
      i = e.params[t];
    else
      return new ch(`$${t}`);
  else if (e.args && Object.prototype.hasOwnProperty.call(e.args, t))
    i = e.args[t];
  else
    return e.reportError(new ReferenceError(`Unknown variable: $${t}`)), new ch(`$${t}`);
  if (i instanceof Az)
    return i;
  switch (typeof i) {
    case "string":
      return i;
    case "number":
      return new zO(i);
    case "object":
      if (YP.supportsValue(i))
        return new YP(i);
    default:
      return e.reportError(new TypeError(`Variable type not supported: $${t}, ${typeof i}`)), new ch(`$${t}`);
  }
}
function l8e(e, {
  name: t,
  attr: i
}) {
  const n = e.bundle._messages.get(t);
  if (!n)
    return e.reportError(new ReferenceError(`Unknown message: ${t}`)), new ch(t);
  if (i) {
    const s = n.attributes[i];
    return s ? bW(e, s) : (e.reportError(new ReferenceError(`Unknown attribute: ${i}`)), new ch(`${t}.${i}`));
  }
  return n.value ? bW(e, n.value) : (e.reportError(new ReferenceError(`No value: ${t}`)), new ch(t));
}
function a8e(e, {
  name: t,
  attr: i,
  args: n
}) {
  const s = `-${t}`, o = e.bundle._terms.get(s);
  if (!o)
    return e.reportError(new ReferenceError(`Unknown term: ${s}`)), new ch(s);
  if (i) {
    const l = o.attributes[i];
    if (l) {
      e.params = Lfe(e, n).named;
      const c = bW(e, l);
      return e.params = null, c;
    }
    return e.reportError(new ReferenceError(`Unknown attribute: ${i}`)), new ch(`${s}.${i}`);
  }
  e.params = Lfe(e, n).named;
  const r = bW(e, o.value);
  return e.params = null, r;
}
function u8e(e, {
  name: t,
  args: i
}) {
  let n = e.bundle._functions[t];
  if (!n)
    return e.reportError(new ReferenceError(`Unknown function: ${t}()`)), new ch(`${t}()`);
  if (typeof n != "function")
    return e.reportError(new TypeError(`Function ${t}() is not callable`)), new ch(`${t}()`);
  try {
    let s = Lfe(e, i);
    return n(s.positional, s.named);
  } catch (s) {
    return e.reportError(s), new ch(`${t}()`);
  }
}
function d8e(e, {
  selector: t,
  variants: i,
  star: n
}) {
  let s = hX(e, t);
  if (s instanceof ch)
    return gEe(e, i, n);
  for (const o of i) {
    const r = hX(e, o.key);
    if (o8e(e, s, r))
      return bW(e, o.value);
  }
  return gEe(e, i, n);
}
function Tve(e, t) {
  if (e.dirty.has(t))
    return e.reportError(new RangeError("Cyclic reference")), new ch();
  e.dirty.add(t);
  const i = [], n = e.bundle._useIsolating && t.length > 1;
  for (const s of t) {
    if (typeof s == "string") {
      i.push(e.bundle._transform(s));
      continue;
    }
    if (e.placeables++, e.placeables > EEe)
      throw e.dirty.delete(t), new RangeError(`Too many placeables expanded: ${e.placeables}, max allowed is ${EEe}`);
    n && i.push(n8e), i.push(hX(e, s).toString(e)), n && i.push(s8e);
  }
  return e.dirty.delete(t), i.join("");
}
function bW(e, t) {
  return typeof t == "string" ? e.bundle._transform(t) : Tve(e, t);
}
class c8e {
  constructor(t, i, n) {
    this.dirty = /* @__PURE__ */ new WeakSet(), this.params = null, this.placeables = 0, this.bundle = t, this.errors = i, this.args = n;
  }
  reportError(t) {
    if (!this.errors || !(t instanceof Error))
      throw t;
    this.errors.push(t);
  }
  memoizeIntlObject(t, i) {
    let n = this.bundle._intls.get(t);
    n || (n = {}, this.bundle._intls.set(t, n));
    let s = JSON.stringify(i);
    return n[s] || (n[s] = new t(this.bundle.locales, i)), n[s];
  }
}
function _fe(e, t) {
  const i = /* @__PURE__ */ Object.create(null);
  for (const [n, s] of Object.entries(e))
    t.includes(n) && (i[n] = s.valueOf());
  return i;
}
const wEe = ["unitDisplay", "currencyDisplay", "useGrouping", "minimumIntegerDigits", "minimumFractionDigits", "maximumFractionDigits", "minimumSignificantDigits", "maximumSignificantDigits"];
function h8e(e, t) {
  let i = e[0];
  if (i instanceof ch)
    return new ch(`NUMBER(${i.valueOf()})`);
  if (i instanceof zO)
    return new zO(i.valueOf(), {
      ...i.opts,
      ..._fe(t, wEe)
    });
  if (i instanceof YP)
    return new zO(i.toNumber(), {
      ..._fe(t, wEe)
    });
  throw new TypeError("Invalid argument to NUMBER");
}
const f8e = ["dateStyle", "timeStyle", "fractionalSecondDigits", "dayPeriod", "hour12", "weekday", "era", "year", "month", "day", "hour", "minute", "second", "timeZoneName"];
function I8e(e, t) {
  let i = e[0];
  if (i instanceof ch)
    return new ch(`DATETIME(${i.valueOf()})`);
  if (i instanceof YP || i instanceof zO)
    return new YP(i, _fe(t, f8e));
  throw new TypeError("Invalid argument to DATETIME");
}
const TEe = /* @__PURE__ */ new Map();
function p8e(e) {
  const t = Array.isArray(e) ? e.join(" ") : e;
  let i = TEe.get(t);
  return i === void 0 && (i = /* @__PURE__ */ new Map(), TEe.set(t, i)), i;
}
class m8e {
  constructor(t, {
    functions: i,
    useIsolating: n = !0,
    transform: s = (o) => o
  } = {}) {
    this._terms = /* @__PURE__ */ new Map(), this._messages = /* @__PURE__ */ new Map(), this.locales = Array.isArray(t) ? t : [t], this._functions = {
      NUMBER: h8e,
      DATETIME: I8e,
      ...i
    }, this._useIsolating = n, this._transform = s, this._intls = p8e(t);
  }
  hasMessage(t) {
    return this._messages.has(t);
  }
  getMessage(t) {
    return this._messages.get(t);
  }
  addResource(t, {
    allowOverrides: i = !1
  } = {}) {
    const n = [];
    for (let s = 0; s < t.body.length; s++) {
      let o = t.body[s];
      if (o.id.startsWith("-")) {
        if (i === !1 && this._terms.has(o.id)) {
          n.push(new Error(`Attempt to override an existing term: "${o.id}"`));
          continue;
        }
        this._terms.set(o.id, o);
      } else {
        if (i === !1 && this._messages.has(o.id)) {
          n.push(new Error(`Attempt to override an existing message: "${o.id}"`));
          continue;
        }
        this._messages.set(o.id, o);
      }
    }
    return n;
  }
  formatPattern(t, i = null, n = null) {
    if (typeof t == "string")
      return this._transform(t);
    let s = new c8e(this, n, i);
    try {
      return Tve(s, t).toString(s);
    } catch (o) {
      if (s.errors && o instanceof Error)
        return s.errors.push(o), new ch().toString(s);
      throw o;
    }
  }
}
const Ide = /^(-?[a-zA-Z][\w-]*) *= */gm, REe = /\.([a-zA-Z][\w-]*) *= */y, y8e = /\*?\[/y, pde = /(-?[0-9]+(?:\.([0-9]+))?)/y, E8e = /([a-zA-Z][\w-]*)/y, vEe = /([$-])?([a-zA-Z][\w-]*)(?:\.([a-zA-Z][\w-]*))?/y, g8e = /^[A-Z][A-Z0-9_-]*$/, Rne = /([^{}\n\r]+)/y, w8e = /([^\\"\n\r]*)/y, AEe = /\\([\\"])/y, SEe = /\\u([a-fA-F0-9]{4})|\\U([a-fA-F0-9]{6})/y, T8e = /^\n+/, bEe = / +$/, R8e = / *\r?\n/g, v8e = /( *)$/, A8e = /{\s*/y, NEe = /\s*}/y, S8e = /\[\s*/y, b8e = /\s*] */y, N8e = /\s*\(\s*/y, D8e = /\s*->\s*/y, C8e = /\s*:\s*/y, O8e = /\s*,?\s*/y, L8e = /\s+/y;
class _8e {
  constructor(t) {
    this.body = [], Ide.lastIndex = 0;
    let i = 0;
    for (; ; ) {
      let te = Ide.exec(t);
      if (te === null)
        break;
      i = Ide.lastIndex;
      try {
        this.body.push(c(te[1]));
      } catch (ee) {
        if (ee instanceof SyntaxError)
          continue;
        throw ee;
      }
    }
    function n(te) {
      return te.lastIndex = i, te.test(t);
    }
    function s(te, ee) {
      if (t[i] === te)
        return i++, !0;
      if (ee)
        throw new ee(`Expected ${te}`);
      return !1;
    }
    function o(te, ee) {
      if (n(te))
        return i = te.lastIndex, !0;
      if (ee)
        throw new ee(`Expected ${te.toString()}`);
      return !1;
    }
    function r(te) {
      te.lastIndex = i;
      let ee = te.exec(t);
      if (ee === null)
        throw new SyntaxError(`Expected ${te.toString()}`);
      return i = te.lastIndex, ee;
    }
    function l(te) {
      return r(te)[1];
    }
    function c(te) {
      let ee = I(), Ne = h();
      if (ee === null && Object.keys(Ne).length === 0)
        throw new SyntaxError("Expected message value or attributes");
      return {
        id: te,
        value: ee,
        attributes: Ne
      };
    }
    function h() {
      let te = /* @__PURE__ */ Object.create(null);
      for (; n(REe); ) {
        let ee = l(REe), Ne = I();
        if (Ne === null)
          throw new SyntaxError("Expected attribute value");
        te[ee] = Ne;
      }
      return te;
    }
    function I() {
      let te;
      if (n(Rne) && (te = l(Rne)), t[i] === "{" || t[i] === "}")
        return p(te ? [te] : [], 1 / 0);
      let ee = W();
      return ee ? te ? p([te, ee], ee.length) : (ee.value = re(ee.value, T8e), p([ee], ee.length)) : te ? re(te, bEe) : null;
    }
    function p(te = [], ee) {
      for (; ; ) {
        if (n(Rne)) {
          te.push(l(Rne));
          continue;
        }
        if (t[i] === "{") {
          te.push(y());
          continue;
        }
        if (t[i] === "}")
          throw new SyntaxError("Unbalanced closing brace");
        let pe = W();
        if (pe) {
          te.push(pe), ee = Math.min(ee, pe.length);
          continue;
        }
        break;
      }
      let Ne = te.length - 1, Ae = te[Ne];
      typeof Ae == "string" && (te[Ne] = re(Ae, bEe));
      let Oe = [];
      for (let pe of te)
        pe instanceof DEe && (pe = pe.value.slice(0, pe.value.length - ee)), pe && Oe.push(pe);
      return Oe;
    }
    function y() {
      o(A8e, SyntaxError);
      let te = m();
      if (o(NEe))
        return te;
      if (o(D8e)) {
        let ee = O();
        return o(NEe, SyntaxError), {
          type: "select",
          selector: te,
          ...ee
        };
      }
      throw new SyntaxError("Unclosed placeable");
    }
    function m() {
      if (t[i] === "{")
        return y();
      if (n(vEe)) {
        let [, te, ee, Ne = null] = r(vEe);
        if (te === "$")
          return {
            type: "var",
            name: ee
          };
        if (o(N8e)) {
          let Ae = A();
          if (te === "-")
            return {
              type: "term",
              name: ee,
              attr: Ne,
              args: Ae
            };
          if (g8e.test(ee))
            return {
              type: "func",
              name: ee,
              args: Ae
            };
          throw new SyntaxError("Function names must be all upper-case");
        }
        return te === "-" ? {
          type: "term",
          name: ee,
          attr: Ne,
          args: []
        } : {
          type: "mesg",
          name: ee,
          attr: Ne
        };
      }
      return F();
    }
    function A() {
      let te = [];
      for (; ; ) {
        switch (t[i]) {
          case ")":
            return i++, te;
          case void 0:
            throw new SyntaxError("Unclosed argument list");
        }
        te.push(C()), o(O8e);
      }
    }
    function C() {
      let te = m();
      return te.type !== "mesg" ? te : o(C8e) ? {
        type: "narg",
        name: te.name,
        value: F()
      } : te;
    }
    function O() {
      let te = [], ee = 0, Ne;
      for (; n(y8e); ) {
        s("*") && (Ne = ee);
        let Ae = R(), Oe = I();
        if (Oe === null)
          throw new SyntaxError("Expected variant value");
        te[ee++] = {
          key: Ae,
          value: Oe
        };
      }
      if (ee === 0)
        return null;
      if (Ne === void 0)
        throw new SyntaxError("Expected default variant");
      return {
        variants: te,
        star: Ne
      };
    }
    function R() {
      o(S8e, SyntaxError);
      let te;
      return n(pde) ? te = L() : te = {
        type: "str",
        value: l(E8e)
      }, o(b8e, SyntaxError), te;
    }
    function F() {
      if (n(pde))
        return L();
      if (t[i] === '"')
        return P();
      throw new SyntaxError("Invalid expression");
    }
    function L() {
      let [, te, ee = ""] = r(pde), Ne = ee.length;
      return {
        type: "num",
        value: parseFloat(te),
        precision: Ne
      };
    }
    function P() {
      s('"', SyntaxError);
      let te = "";
      for (; ; ) {
        if (te += l(w8e), t[i] === "\\") {
          te += z();
          continue;
        }
        if (s('"'))
          return {
            type: "str",
            value: te
          };
        throw new SyntaxError("Unclosed string literal");
      }
    }
    function z() {
      if (n(AEe))
        return l(AEe);
      if (n(SEe)) {
        let [, te, ee] = r(SEe), Ne = parseInt(te || ee, 16);
        return Ne <= 55295 || 57344 <= Ne ? String.fromCodePoint(Ne) : "�";
      }
      throw new SyntaxError("Unknown escape sequence");
    }
    function W() {
      let te = i;
      switch (o(L8e), t[i]) {
        case ".":
        case "[":
        case "*":
        case "}":
        case void 0:
          return !1;
        case "{":
          return ce(t.slice(te, i));
      }
      return t[i - 1] === " " ? ce(t.slice(te, i)) : !1;
    }
    function re(te, ee) {
      return te.replace(ee, "");
    }
    function ce(te) {
      let ee = te.replace(R8e, `
`), Ne = v8e.exec(te)[1].length;
      return new DEe(ee, Ne);
    }
  }
}
class DEe {
  constructor(t, i) {
    this.value = t, this.length = i;
  }
}
const x8e = /<|&#?\w+;/, P8e = {
  "http://www.w3.org/1999/xhtml": ["em", "strong", "small", "s", "cite", "q", "dfn", "abbr", "data", "time", "code", "var", "samp", "kbd", "sub", "sup", "i", "b", "u", "mark", "bdi", "bdo", "span", "br", "wbr"]
}, M8e = {
  "http://www.w3.org/1999/xhtml": {
    global: ["title", "aria-description", "aria-label", "aria-valuetext"],
    a: ["download"],
    area: ["download", "alt"],
    input: ["alt", "placeholder"],
    menuitem: ["label"],
    menu: ["label"],
    optgroup: ["label"],
    option: ["label"],
    track: ["label"],
    img: ["alt"],
    textarea: ["placeholder"],
    th: ["abbr"]
  },
  "http://www.mozilla.org/keymaster/gatekeeper/there.is.only.xul": {
    global: ["accesskey", "aria-label", "aria-valuetext", "label", "title", "tooltiptext"],
    description: ["value"],
    key: ["key", "keycode"],
    label: ["value"],
    textbox: ["placeholder", "value"]
  }
};
function U8e(e, t) {
  const {
    value: i
  } = t;
  if (typeof i == "string")
    if (e.localName === "title" && e.namespaceURI === "http://www.w3.org/1999/xhtml")
      e.textContent = i;
    else if (!x8e.test(i))
      e.textContent = i;
    else {
      const n = e.ownerDocument.createElementNS("http://www.w3.org/1999/xhtml", "template");
      n.innerHTML = i, B8e(n.content, e);
    }
  Rve(t, e);
}
function B8e(e, t) {
  for (const i of e.childNodes)
    if (i.nodeType !== i.TEXT_NODE) {
      if (i.hasAttribute("data-l10n-name")) {
        const n = H8e(t, i);
        e.replaceChild(n, i);
        continue;
      }
      if (k8e(i)) {
        const n = G8e(i);
        e.replaceChild(n, i);
        continue;
      }
      console.warn(`An element of forbidden type "${i.localName}" was found in the translation. Only safe text-level elements and elements with data-l10n-name are allowed.`), e.replaceChild(xfe(i), i);
    }
  t.textContent = "", t.appendChild(e);
}
function F8e(e, t) {
  if (!e)
    return !1;
  for (let i of e)
    if (i.name === t)
      return !0;
  return !1;
}
function Rve(e, t) {
  const i = t.hasAttribute("data-l10n-attrs") ? t.getAttribute("data-l10n-attrs").split(",").map((n) => n.trim()) : null;
  for (const n of Array.from(t.attributes))
    CEe(n.name, t, i) && !F8e(e.attributes, n.name) && t.removeAttribute(n.name);
  if (e.attributes)
    for (const n of Array.from(e.attributes))
      CEe(n.name, t, i) && t.getAttribute(n.name) !== n.value && t.setAttribute(n.name, n.value);
}
function H8e(e, t) {
  const i = t.getAttribute("data-l10n-name"), n = e.querySelector(`[data-l10n-name="${i}"]`);
  if (!n)
    return console.warn(`An element named "${i}" wasn't found in the source.`), xfe(t);
  if (n.localName !== t.localName)
    return console.warn(`An element named "${i}" was found in the translation but its type ${t.localName} didn't match the element found in the source (${n.localName}).`), xfe(t);
  e.removeChild(n);
  const s = n.cloneNode(!1);
  return vve(t, s);
}
function G8e(e) {
  const t = e.ownerDocument.createElement(e.localName);
  return vve(e, t);
}
function xfe(e) {
  return e.ownerDocument.createTextNode(e.textContent);
}
function k8e(e) {
  const t = P8e[e.namespaceURI];
  return t && t.includes(e.localName);
}
function CEe(e, t, i = null) {
  if (i && i.includes(e))
    return !0;
  const n = M8e[t.namespaceURI];
  if (!n)
    return !1;
  const s = e.toLowerCase(), o = t.localName;
  if (n.global.includes(s))
    return !0;
  if (!n[o])
    return !1;
  if (n[o].includes(s))
    return !0;
  if (t.namespaceURI === "http://www.w3.org/1999/xhtml" && o === "input" && s === "value") {
    const r = t.type.toLowerCase();
    if (r === "submit" || r === "button" || r === "reset")
      return !0;
  }
  return !1;
}
function vve(e, t) {
  return t.textContent = e.textContent, Rve(e, t), t;
}
class V8e extends Array {
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
}
class z8e extends V8e {
  constructor(t) {
    if (super(), Symbol.asyncIterator in Object(t))
      this.iterator = t[Symbol.asyncIterator]();
    else if (Symbol.iterator in Object(t))
      this.iterator = t[Symbol.iterator]();
    else
      throw new TypeError("Argument must implement the iteration protocol.");
  }
  [Symbol.asyncIterator]() {
    const t = this;
    let i = 0;
    return {
      async next() {
        return t.length <= i && t.push(t.iterator.next()), t[i++];
      }
    };
  }
  async touchNext(t = 1) {
    let i = 0;
    for (; i++ < t; ) {
      const n = this[this.length - 1];
      if (n && (await n).done)
        break;
      this.push(this.iterator.next());
    }
    return this[this.length - 1];
  }
}
class j8e {
  constructor(t = [], i) {
    this.resourceIds = t, this.generateBundles = i, this.onChange(!0);
  }
  addResourceIds(t, i = !1) {
    return this.resourceIds.push(...t), this.onChange(i), this.resourceIds.length;
  }
  removeResourceIds(t) {
    return this.resourceIds = this.resourceIds.filter((i) => !t.includes(i)), this.onChange(), this.resourceIds.length;
  }
  async formatWithFallback(t, i) {
    const n = [];
    let s = !1;
    for await (const o of this.bundles) {
      s = !0;
      const r = q8e(i, o, t, n);
      if (r.size === 0)
        break;
      if (typeof console < "u") {
        const l = o.locales[0], c = Array.from(r).join(", ");
        console.warn(`[fluent] Missing translations in ${l}: ${c}`);
      }
    }
    return !s && typeof console < "u" && console.warn(`[fluent] Request for keys failed because no resource bundles got generated.
  keys: ${JSON.stringify(t)}.
  resourceIds: ${JSON.stringify(this.resourceIds)}.`), n;
  }
  formatMessages(t) {
    return this.formatWithFallback(t, Y8e);
  }
  formatValues(t) {
    return this.formatWithFallback(t, W8e);
  }
  async formatValue(t, i) {
    const [n] = await this.formatValues([{
      id: t,
      args: i
    }]);
    return n;
  }
  handleEvent() {
    this.onChange();
  }
  onChange(t = !1) {
    this.bundles = z8e.from(this.generateBundles(this.resourceIds)), t && this.bundles.touchNext(2);
  }
}
function W8e(e, t, i, n) {
  return i.value ? e.formatPattern(i.value, n, t) : null;
}
function Y8e(e, t, i, n) {
  const s = {
    value: null,
    attributes: null
  };
  i.value && (s.value = e.formatPattern(i.value, n, t));
  let o = Object.keys(i.attributes);
  if (o.length > 0) {
    s.attributes = new Array(o.length);
    for (let [r, l] of o.entries()) {
      let c = e.formatPattern(i.attributes[l], n, t);
      s.attributes[r] = {
        name: l,
        value: c
      };
    }
  }
  return s;
}
function q8e(e, t, i, n) {
  const s = [], o = /* @__PURE__ */ new Set();
  return i.forEach(({
    id: r,
    args: l
  }, c) => {
    if (n[c] !== void 0)
      return;
    let h = t.getMessage(r);
    if (h) {
      if (s.length = 0, n[c] = e(t, s, h, l), s.length > 0 && typeof console < "u") {
        const I = t.locales[0], p = s.join(", ");
        console.warn(`[fluent][resolver] errors in ${I}/${r}: ${p}.`);
      }
    } else
      o.add(r);
  }), o;
}
const uU = "data-l10n-id", gZ = "data-l10n-args", $8e = `[${uU}]`;
class K8e extends j8e {
  constructor(t, i) {
    super(t, i), this.roots = /* @__PURE__ */ new Set(), this.pendingrAF = null, this.pendingElements = /* @__PURE__ */ new Set(), this.windowElement = null, this.mutationObserver = null, this.observerConfig = {
      attributes: !0,
      characterData: !1,
      childList: !0,
      subtree: !0,
      attributeFilter: [uU, gZ]
    };
  }
  onChange(t = !1) {
    super.onChange(t), this.roots && this.translateRoots();
  }
  setAttributes(t, i, n) {
    return t.setAttribute(uU, i), n ? t.setAttribute(gZ, JSON.stringify(n)) : t.removeAttribute(gZ), t;
  }
  getAttributes(t) {
    return {
      id: t.getAttribute(uU),
      args: JSON.parse(t.getAttribute(gZ) || null)
    };
  }
  connectRoot(t) {
    for (const i of this.roots)
      if (i === t || i.contains(t) || t.contains(i))
        throw new Error("Cannot add a root that overlaps with existing root.");
    if (this.windowElement) {
      if (this.windowElement !== t.ownerDocument.defaultView)
        throw new Error(`Cannot connect a root:
          DOMLocalization already has a root from a different window.`);
    } else
      this.windowElement = t.ownerDocument.defaultView, this.mutationObserver = new this.windowElement.MutationObserver((i) => this.translateMutations(i));
    this.roots.add(t), this.mutationObserver.observe(t, this.observerConfig);
  }
  disconnectRoot(t) {
    return this.roots.delete(t), this.pauseObserving(), this.roots.size === 0 ? (this.mutationObserver = null, this.windowElement && this.pendingrAF && this.windowElement.cancelAnimationFrame(this.pendingrAF), this.windowElement = null, this.pendingrAF = null, this.pendingElements.clear(), !0) : (this.resumeObserving(), !1);
  }
  translateRoots() {
    const t = Array.from(this.roots);
    return Promise.all(t.map((i) => this.translateFragment(i)));
  }
  pauseObserving() {
    this.mutationObserver && (this.translateMutations(this.mutationObserver.takeRecords()), this.mutationObserver.disconnect());
  }
  resumeObserving() {
    if (this.mutationObserver)
      for (const t of this.roots)
        this.mutationObserver.observe(t, this.observerConfig);
  }
  translateMutations(t) {
    for (const i of t)
      switch (i.type) {
        case "attributes":
          i.target.hasAttribute("data-l10n-id") && this.pendingElements.add(i.target);
          break;
        case "childList":
          for (const n of i.addedNodes)
            if (n.nodeType === n.ELEMENT_NODE)
              if (n.childElementCount)
                for (const s of this.getTranslatables(n))
                  this.pendingElements.add(s);
              else n.hasAttribute(uU) && this.pendingElements.add(n);
          break;
      }
    this.pendingElements.size > 0 && this.pendingrAF === null && (this.pendingrAF = this.windowElement.requestAnimationFrame(() => {
      this.translateElements(Array.from(this.pendingElements)), this.pendingElements.clear(), this.pendingrAF = null;
    }));
  }
  translateFragment(t) {
    return this.translateElements(this.getTranslatables(t));
  }
  async translateElements(t) {
    if (!t.length)
      return;
    const i = t.map(this.getKeysForElement), n = await this.formatMessages(i);
    return this.applyTranslations(t, n);
  }
  applyTranslations(t, i) {
    this.pauseObserving();
    for (let n = 0; n < t.length; n++)
      i[n] !== void 0 && U8e(t[n], i[n]);
    this.resumeObserving();
  }
  getTranslatables(t) {
    const i = Array.from(t.querySelectorAll($8e));
    return typeof t.hasAttribute == "function" && t.hasAttribute(uU) && i.push(t), i;
  }
  getKeysForElement(t) {
    return {
      id: t.getAttribute(uU),
      args: JSON.parse(t.getAttribute(gZ) || null)
    };
  }
}
var Ate, sP, Kj, fg, QW, Ave, Sve;
const XJ = class XJ {
  constructor({
    lang: t,
    isRTL: i
  }, n = null) {
    xe(this, Ate);
    xe(this, sP);
    xe(this, Kj);
    xe(this, fg);
    var s, o;
    be(this, Kj, _e(s = XJ, QW, Ave).call(s, t)), be(this, fg, n), be(this, Ate, i ?? _e(o = XJ, QW, Sve).call(o, S(this, Kj)) ? "rtl" : "ltr");
  }
  _setL10n(t) {
    be(this, fg, t);
  }
  getLanguage() {
    return S(this, Kj);
  }
  getDirection() {
    return S(this, Ate);
  }
  async get(t, i = null, n) {
    var o;
    return Array.isArray(t) ? (t = t.map((l) => ({
      id: l
    })), (await S(this, fg).formatMessages(t)).map((l) => l.value)) : ((o = (await S(this, fg).formatMessages([{
      id: t,
      args: i
    }]))[0]) == null ? void 0 : o.value) || n;
  }
  async translate(t) {
    (S(this, sP) || be(this, sP, /* @__PURE__ */ new Set())).add(t);
    try {
      S(this, fg).connectRoot(t), await S(this, fg).translateRoots();
    } catch {
    }
  }
  async translateOnce(t) {
    try {
      await S(this, fg).translateElements([t]);
    } catch (i) {
      console.error("translateOnce:", i);
    }
  }
  async destroy() {
    if (S(this, sP)) {
      for (const t of S(this, sP))
        S(this, fg).disconnectRoot(t);
      S(this, sP).clear(), be(this, sP, null);
    }
    S(this, fg).pauseObserving();
  }
  pause() {
    S(this, fg).pauseObserving();
  }
  resume() {
    S(this, fg).resumeObserving();
  }
};
Ate = new WeakMap(), sP = new WeakMap(), Kj = new WeakMap(), fg = new WeakMap(), QW = new WeakSet(), Ave = function(t) {
  return t = (t == null ? void 0 : t.toLowerCase()) || "en-us", {
    en: "en-us",
    es: "es-es",
    fy: "fy-nl",
    ga: "ga-ie",
    gu: "gu-in",
    hi: "hi-in",
    hy: "hy-am",
    nb: "nb-no",
    ne: "ne-np",
    nn: "nn-no",
    pa: "pa-in",
    pt: "pt-pt",
    sv: "sv-se",
    zh: "zh-cn"
  }[t] || t;
}, Sve = function(t) {
  const i = t.split("-", 1)[0];
  return ["ar", "he", "fa", "ps", "ur"].includes(i);
}, xe(XJ, QW);
let Pfe = XJ;
function Z8e() {
  const {
    isAndroid: e,
    isLinux: t,
    isMac: i,
    isWindows: n
  } = IPe.platform;
  return t ? "linux" : n ? "windows" : i ? "macos" : e ? "android" : "other";
}
function OEe(e, t) {
  const i = new _8e(t), n = new m8e(e, {
    functions: {
      PLATFORM: Z8e
    }
  }), s = n.addResource(i);
  return s.length && console.error("L10n errors", s), n;
}
var A4, bve, Nve, Dve, Cve, Mfe;
const nB = class nB extends Pfe {
  constructor(t) {
    super({
      lang: t
    });
    const i = t ? _e(nB, A4, bve).bind(nB, "en-us", this.getLanguage()) : _e(nB, A4, Cve).bind(nB, this.getLanguage());
    this._setL10n(new K8e([], i));
  }
};
A4 = new WeakSet(), bve = async function* (t, i) {
  const {
    baseURL: n,
    paths: s
  } = await _e(this, A4, Dve).call(this), o = [i];
  if (t !== i) {
    const l = i.split("-", 1)[0];
    l !== i && o.push(l), o.push(t);
  }
  const r = o.map((l) => [l, _e(this, A4, Nve).call(this, l, n, s)]);
  for (const [l, c] of r) {
    const h = await c;
    h ? yield h : l === "en-us" && (yield _e(this, A4, Mfe).call(this, l));
  }
}, Nve = async function(t, i, n) {
  const s = n[t];
  if (!s)
    return null;
  const o = new URL(s, i), r = await iEe(o, "text");
  return OEe(t, r);
}, Dve = async function() {
  try {
    const {
      href: t
    } = document.querySelector('link[type="application/l10n"]'), i = await iEe(t, "json");
    return {
      baseURL: t.substring(0, t.lastIndexOf("/") + 1) || "./",
      paths: i
    };
  } catch {
  }
  return {
    baseURL: "./",
    paths: /* @__PURE__ */ Object.create(null)
  };
}, Cve = async function* (t) {
  yield _e(this, A4, Mfe).call(this, t);
}, Mfe = async function(t) {
  return OEe(t, `pdfjs-previous-button =
    .title = Previous Page
pdfjs-previous-button-label = Previous
pdfjs-next-button =
    .title = Next Page
pdfjs-next-button-label = Next
pdfjs-page-input =
    .title = Page
pdfjs-of-pages = of { $pagesCount }
pdfjs-page-of-pages = ({ $pageNumber } of { $pagesCount })
pdfjs-zoom-out-button =
    .title = Zoom Out
pdfjs-zoom-out-button-label = Zoom Out
pdfjs-zoom-in-button =
    .title = Zoom In
pdfjs-zoom-in-button-label = Zoom In
pdfjs-zoom-select =
    .title = Zoom
pdfjs-presentation-mode-button =
    .title = Switch to Presentation Mode
pdfjs-presentation-mode-button-label = Presentation Mode
pdfjs-open-file-button =
    .title = Open File
pdfjs-open-file-button-label = Open
pdfjs-print-button =
    .title = Print
pdfjs-print-button-label = Print
pdfjs-save-button =
    .title = Save
pdfjs-save-button-label = Save
pdfjs-download-button =
    .title = Download
pdfjs-download-button-label = Download
pdfjs-bookmark-button =
    .title = Current Page (View URL from Current Page)
pdfjs-bookmark-button-label = Current Page
pdfjs-tools-button =
    .title = Tools
pdfjs-tools-button-label = Tools
pdfjs-first-page-button =
    .title = Go to First Page
pdfjs-first-page-button-label = Go to First Page
pdfjs-last-page-button =
    .title = Go to Last Page
pdfjs-last-page-button-label = Go to Last Page
pdfjs-page-rotate-cw-button =
    .title = Rotate Clockwise
pdfjs-page-rotate-cw-button-label = Rotate Clockwise
pdfjs-page-rotate-ccw-button =
    .title = Rotate Counterclockwise
pdfjs-page-rotate-ccw-button-label = Rotate Counterclockwise
pdfjs-cursor-text-select-tool-button =
    .title = Enable Text Selection Tool
pdfjs-cursor-text-select-tool-button-label = Text Selection Tool
pdfjs-cursor-hand-tool-button =
    .title = Enable Hand Tool
pdfjs-cursor-hand-tool-button-label = Hand Tool
pdfjs-scroll-page-button =
    .title = Use Page Scrolling
pdfjs-scroll-page-button-label = Page Scrolling
pdfjs-scroll-vertical-button =
    .title = Use Vertical Scrolling
pdfjs-scroll-vertical-button-label = Vertical Scrolling
pdfjs-scroll-horizontal-button =
    .title = Use Horizontal Scrolling
pdfjs-scroll-horizontal-button-label = Horizontal Scrolling
pdfjs-scroll-wrapped-button =
    .title = Use Wrapped Scrolling
pdfjs-scroll-wrapped-button-label = Wrapped Scrolling
pdfjs-spread-none-button =
    .title = Do not join page spreads
pdfjs-spread-none-button-label = No Spreads
pdfjs-spread-odd-button =
    .title = Join page spreads starting with odd-numbered pages
pdfjs-spread-odd-button-label = Odd Spreads
pdfjs-spread-even-button =
    .title = Join page spreads starting with even-numbered pages
pdfjs-spread-even-button-label = Even Spreads
pdfjs-document-properties-button =
    .title = Document Properties…
pdfjs-document-properties-button-label = Document Properties…
pdfjs-document-properties-file-name = File name:
pdfjs-document-properties-file-size = File size:
pdfjs-document-properties-size-kb = { NUMBER($kb, maximumSignificantDigits: 3) } KB ({ $b } bytes)
pdfjs-document-properties-size-mb = { NUMBER($mb, maximumSignificantDigits: 3) } MB ({ $b } bytes)
pdfjs-document-properties-title = Title:
pdfjs-document-properties-author = Author:
pdfjs-document-properties-subject = Subject:
pdfjs-document-properties-keywords = Keywords:
pdfjs-document-properties-creation-date = Creation Date:
pdfjs-document-properties-modification-date = Modification Date:
pdfjs-document-properties-date-time-string = { DATETIME($dateObj, dateStyle: "short", timeStyle: "medium") }
pdfjs-document-properties-creator = Creator:
pdfjs-document-properties-producer = PDF Producer:
pdfjs-document-properties-version = PDF Version:
pdfjs-document-properties-page-count = Page Count:
pdfjs-document-properties-page-size = Page Size:
pdfjs-document-properties-page-size-unit-inches = in
pdfjs-document-properties-page-size-unit-millimeters = mm
pdfjs-document-properties-page-size-orientation-portrait = portrait
pdfjs-document-properties-page-size-orientation-landscape = landscape
pdfjs-document-properties-page-size-name-a-three = A3
pdfjs-document-properties-page-size-name-a-four = A4
pdfjs-document-properties-page-size-name-letter = Letter
pdfjs-document-properties-page-size-name-legal = Legal
pdfjs-document-properties-page-size-dimension-string = { $width } × { $height } { $unit } ({ $orientation })
pdfjs-document-properties-page-size-dimension-name-string = { $width } × { $height } { $unit } ({ $name }, { $orientation })
pdfjs-document-properties-linearized = Fast Web View:
pdfjs-document-properties-linearized-yes = Yes
pdfjs-document-properties-linearized-no = No
pdfjs-document-properties-close-button = Close
pdfjs-print-progress-message = Preparing document for printing…
pdfjs-print-progress-percent = { $progress }%
pdfjs-print-progress-close-button = Cancel
pdfjs-printing-not-supported = Warning: Printing is not fully supported by this browser.
pdfjs-printing-not-ready = Warning: The PDF is not fully loaded for printing.
pdfjs-toggle-sidebar-button =
    .title = Toggle Sidebar
pdfjs-toggle-sidebar-notification-button =
    .title = Toggle Sidebar (document contains outline/attachments/layers)
pdfjs-toggle-sidebar-button-label = Toggle Sidebar
pdfjs-document-outline-button =
    .title = Show Document Outline (double-click to expand/collapse all items)
pdfjs-document-outline-button-label = Document Outline
pdfjs-attachments-button =
    .title = Show Attachments
pdfjs-attachments-button-label = Attachments
pdfjs-layers-button =
    .title = Show Layers (double-click to reset all layers to the default state)
pdfjs-layers-button-label = Layers
pdfjs-thumbs-button =
    .title = Show Thumbnails
pdfjs-thumbs-button-label = Thumbnails
pdfjs-current-outline-item-button =
    .title = Find Current Outline Item
pdfjs-current-outline-item-button-label = Current Outline Item
pdfjs-findbar-button =
    .title = Find in Document
pdfjs-findbar-button-label = Find
pdfjs-additional-layers = Additional Layers
pdfjs-thumb-page-title =
    .title = Page { $page }
pdfjs-thumb-page-canvas =
    .aria-label = Thumbnail of Page { $page }
pdfjs-find-input =
    .title = Find
    .placeholder = Find in document…
pdfjs-find-previous-button =
    .title = Find the previous occurrence of the phrase
pdfjs-find-previous-button-label = Previous
pdfjs-find-next-button =
    .title = Find the next occurrence of the phrase
pdfjs-find-next-button-label = Next
pdfjs-find-highlight-checkbox = Highlight All
pdfjs-find-match-case-checkbox-label = Match Case
pdfjs-find-match-diacritics-checkbox-label = Match Diacritics
pdfjs-find-entire-word-checkbox-label = Whole Words
pdfjs-find-reached-top = Reached top of document, continued from bottom
pdfjs-find-reached-bottom = Reached end of document, continued from top
pdfjs-find-match-count =
    { $total ->
        [one] { $current } of { $total } match
       *[other] { $current } of { $total } matches
    }
pdfjs-find-match-count-limit =
    { $limit ->
        [one] More than { $limit } match
       *[other] More than { $limit } matches
    }
pdfjs-find-not-found = Phrase not found
pdfjs-page-scale-width = Page Width
pdfjs-page-scale-fit = Page Fit
pdfjs-page-scale-auto = Automatic Zoom
pdfjs-page-scale-actual = Actual Size
pdfjs-page-scale-percent = { $scale }%
pdfjs-page-landmark =
    .aria-label = Page { $page }
pdfjs-loading-error = An error occurred while loading the PDF.
pdfjs-invalid-file-error = Invalid or corrupted PDF file.
pdfjs-missing-file-error = Missing PDF file.
pdfjs-unexpected-response-error = Unexpected server response.
pdfjs-rendering-error = An error occurred while rendering the page.
pdfjs-annotation-date-time-string = { DATETIME($dateObj, dateStyle: "short", timeStyle: "medium") }
pdfjs-text-annotation-type =
    .alt = [{ $type } Annotation]
pdfjs-password-label = Enter the password to open this PDF file.
pdfjs-password-invalid = Invalid password. Please try again.
pdfjs-password-ok-button = OK
pdfjs-password-cancel-button = Cancel
pdfjs-web-fonts-disabled = Web fonts are disabled: unable to use embedded PDF fonts.
pdfjs-editor-free-text-button =
    .title = Text
pdfjs-editor-color-picker-free-text-input =
    .title = Change text color
pdfjs-editor-free-text-button-label = Text
pdfjs-editor-ink-button =
    .title = Draw
pdfjs-editor-color-picker-ink-input =
    .title = Change drawing color
pdfjs-editor-ink-button-label = Draw
pdfjs-editor-stamp-button =
    .title = Add or edit images
pdfjs-editor-stamp-button-label = Add or edit images
pdfjs-editor-highlight-button =
    .title = Highlight
pdfjs-editor-highlight-button-label = Highlight
pdfjs-highlight-floating-button1 =
    .title = Highlight
    .aria-label = Highlight
pdfjs-highlight-floating-button-label = Highlight
pdfjs-editor-signature-button =
    .title = Add signature
pdfjs-editor-signature-button-label = Add signature
pdfjs-editor-highlight-editor =
    .aria-label = Highlight editor
pdfjs-editor-ink-editor =
    .aria-label = Drawing editor
pdfjs-editor-signature-editor1 =
    .aria-description = Signature editor: { $description }
pdfjs-editor-stamp-editor =
    .aria-label = Image editor
pdfjs-editor-remove-ink-button =
    .title = Remove drawing
pdfjs-editor-remove-freetext-button =
    .title = Remove text
pdfjs-editor-remove-stamp-button =
    .title = Remove image
pdfjs-editor-remove-highlight-button =
    .title = Remove highlight
pdfjs-editor-remove-signature-button =
    .title = Remove signature
pdfjs-editor-free-text-color-input = Color
pdfjs-editor-free-text-size-input = Size
pdfjs-editor-ink-color-input = Color
pdfjs-editor-ink-thickness-input = Thickness
pdfjs-editor-ink-opacity-input = Opacity
pdfjs-editor-stamp-add-image-button =
    .title = Add image
pdfjs-editor-stamp-add-image-button-label = Add image
pdfjs-editor-free-highlight-thickness-input = Thickness
pdfjs-editor-free-highlight-thickness-title =
    .title = Change thickness when highlighting items other than text
pdfjs-editor-add-signature-container =
    .aria-label = Signature controls and saved signatures
pdfjs-editor-signature-add-signature-button =
    .title = Add new signature
pdfjs-editor-signature-add-signature-button-label = Add new signature
pdfjs-editor-add-saved-signature-button =
    .title = Saved signature: { $description }
pdfjs-free-text2 =
    .aria-label = Text Editor
    .default-content = Start typing…
pdfjs-editor-alt-text-button =
    .aria-label = Alt text
pdfjs-editor-alt-text-button-label = Alt text
pdfjs-editor-alt-text-edit-button =
    .aria-label = Edit alt text
pdfjs-editor-alt-text-dialog-label = Choose an option
pdfjs-editor-alt-text-dialog-description = Alt text (alternative text) helps when people can’t see the image or when it doesn’t load.
pdfjs-editor-alt-text-add-description-label = Add a description
pdfjs-editor-alt-text-add-description-description = Aim for 1-2 sentences that describe the subject, setting, or actions.
pdfjs-editor-alt-text-mark-decorative-label = Mark as decorative
pdfjs-editor-alt-text-mark-decorative-description = This is used for ornamental images, like borders or watermarks.
pdfjs-editor-alt-text-cancel-button = Cancel
pdfjs-editor-alt-text-save-button = Save
pdfjs-editor-alt-text-decorative-tooltip = Marked as decorative
pdfjs-editor-alt-text-textarea =
    .placeholder = For example, “A young man sits down at a table to eat a meal”
pdfjs-editor-resizer-top-left =
    .aria-label = Top left corner — resize
pdfjs-editor-resizer-top-middle =
    .aria-label = Top middle — resize
pdfjs-editor-resizer-top-right =
    .aria-label = Top right corner — resize
pdfjs-editor-resizer-middle-right =
    .aria-label = Middle right — resize
pdfjs-editor-resizer-bottom-right =
    .aria-label = Bottom right corner — resize
pdfjs-editor-resizer-bottom-middle =
    .aria-label = Bottom middle — resize
pdfjs-editor-resizer-bottom-left =
    .aria-label = Bottom left corner — resize
pdfjs-editor-resizer-middle-left =
    .aria-label = Middle left — resize
pdfjs-editor-highlight-colorpicker-label = Highlight color
pdfjs-editor-colorpicker-button =
    .title = Change color
pdfjs-editor-colorpicker-dropdown =
    .aria-label = Color choices
pdfjs-editor-colorpicker-yellow =
    .title = Yellow
pdfjs-editor-colorpicker-green =
    .title = Green
pdfjs-editor-colorpicker-blue =
    .title = Blue
pdfjs-editor-colorpicker-pink =
    .title = Pink
pdfjs-editor-colorpicker-red =
    .title = Red
pdfjs-editor-highlight-show-all-button-label = Show all
pdfjs-editor-highlight-show-all-button =
    .title = Show all
pdfjs-editor-new-alt-text-dialog-edit-label = Edit alt text (image description)
pdfjs-editor-new-alt-text-dialog-add-label = Add alt text (image description)
pdfjs-editor-new-alt-text-textarea =
    .placeholder = Write your description here…
pdfjs-editor-new-alt-text-description = Short description for people who can’t see the image or when the image doesn’t load.
pdfjs-editor-new-alt-text-disclaimer1 = This alt text was created automatically and may be inaccurate.
pdfjs-editor-new-alt-text-disclaimer-learn-more-url = Learn more
pdfjs-editor-new-alt-text-create-automatically-button-label = Create alt text automatically
pdfjs-editor-new-alt-text-not-now-button = Not now
pdfjs-editor-new-alt-text-error-title = Couldn’t create alt text automatically
pdfjs-editor-new-alt-text-error-description = Please write your own alt text or try again later.
pdfjs-editor-new-alt-text-error-close-button = Close
pdfjs-editor-new-alt-text-ai-model-downloading-progress = Downloading alt text AI model ({ $downloadedSize } of { $totalSize } MB)
    .aria-valuetext = Downloading alt text AI model ({ $downloadedSize } of { $totalSize } MB)
pdfjs-editor-new-alt-text-added-button =
    .aria-label = Alt text added
pdfjs-editor-new-alt-text-added-button-label = Alt text added
pdfjs-editor-new-alt-text-missing-button =
    .aria-label = Missing alt text
pdfjs-editor-new-alt-text-missing-button-label = Missing alt text
pdfjs-editor-new-alt-text-to-review-button =
    .aria-label = Review alt text
pdfjs-editor-new-alt-text-to-review-button-label = Review alt text
pdfjs-editor-new-alt-text-generated-alt-text-with-disclaimer = Created automatically: { $generatedAltText }
pdfjs-image-alt-text-settings-button =
    .title = Image alt text settings
pdfjs-image-alt-text-settings-button-label = Image alt text settings
pdfjs-editor-alt-text-settings-dialog-label = Image alt text settings
pdfjs-editor-alt-text-settings-automatic-title = Automatic alt text
pdfjs-editor-alt-text-settings-create-model-button-label = Create alt text automatically
pdfjs-editor-alt-text-settings-create-model-description = Suggests descriptions to help people who can’t see the image or when the image doesn’t load.
pdfjs-editor-alt-text-settings-download-model-label = Alt text AI model ({ $totalSize } MB)
pdfjs-editor-alt-text-settings-ai-model-description = Runs locally on your device so your data stays private. Required for automatic alt text.
pdfjs-editor-alt-text-settings-delete-model-button = Delete
pdfjs-editor-alt-text-settings-download-model-button = Download
pdfjs-editor-alt-text-settings-downloading-model-button = Downloading…
pdfjs-editor-alt-text-settings-editor-title = Alt text editor
pdfjs-editor-alt-text-settings-show-dialog-button-label = Show alt text editor right away when adding an image
pdfjs-editor-alt-text-settings-show-dialog-description = Helps you make sure all your images have alt text.
pdfjs-editor-alt-text-settings-close-button = Close
pdfjs-editor-highlight-added-alert = Highlight added
pdfjs-editor-freetext-added-alert = Text added
pdfjs-editor-ink-added-alert = Drawing added
pdfjs-editor-stamp-added-alert = Image added
pdfjs-editor-signature-added-alert = Signature added
pdfjs-editor-undo-bar-message-highlight = Highlight removed
pdfjs-editor-undo-bar-message-freetext = Text removed
pdfjs-editor-undo-bar-message-ink = Drawing removed
pdfjs-editor-undo-bar-message-stamp = Image removed
pdfjs-editor-undo-bar-message-signature = Signature removed
pdfjs-editor-undo-bar-message-multiple =
    { $count ->
        [one] { $count } annotation removed
       *[other] { $count } annotations removed
    }
pdfjs-editor-undo-bar-undo-button =
    .title = Undo
pdfjs-editor-undo-bar-undo-button-label = Undo
pdfjs-editor-undo-bar-close-button =
    .title = Close
pdfjs-editor-undo-bar-close-button-label = Close
pdfjs-editor-add-signature-dialog-label = This modal allows the user to create a signature to add to a PDF document. The user can edit the name (which also serves as the alt text), and optionally save the signature for repeated use.
pdfjs-editor-add-signature-dialog-title = Add a signature
pdfjs-editor-add-signature-type-button = Type
    .title = Type
pdfjs-editor-add-signature-draw-button = Draw
    .title = Draw
pdfjs-editor-add-signature-image-button = Image
    .title = Image
pdfjs-editor-add-signature-type-input =
    .aria-label = Type your signature
    .placeholder = Type your signature
pdfjs-editor-add-signature-draw-placeholder = Draw your signature
pdfjs-editor-add-signature-draw-thickness-range-label = Thickness
pdfjs-editor-add-signature-draw-thickness-range =
    .title = Drawing thickness: { $thickness }
pdfjs-editor-add-signature-image-placeholder = Drag a file here to upload
pdfjs-editor-add-signature-image-browse-link =
    { PLATFORM() ->
        [macos] Or choose image files
       *[other] Or browse image files
    }
pdfjs-editor-add-signature-description-label = Description (alt text)
pdfjs-editor-add-signature-description-input =
    .title = Description (alt text)
pdfjs-editor-add-signature-description-default-when-drawing = Signature
pdfjs-editor-add-signature-clear-button-label = Clear signature
pdfjs-editor-add-signature-clear-button =
    .title = Clear signature
pdfjs-editor-add-signature-save-checkbox = Save signature
pdfjs-editor-add-signature-save-warning-message = You’ve reached the limit of 5 saved signatures. Remove one to save more.
pdfjs-editor-add-signature-image-upload-error-title = Couldn’t upload image
pdfjs-editor-add-signature-image-upload-error-description = Check your network connection or try another image.
pdfjs-editor-add-signature-image-no-data-error-title = Can’t convert this image into a signature
pdfjs-editor-add-signature-image-no-data-error-description = Please try uploading a different image.
pdfjs-editor-add-signature-error-close-button = Close
pdfjs-editor-add-signature-cancel-button = Cancel
pdfjs-editor-add-signature-add-button = Add
pdfjs-editor-delete-signature-button1 =
    .title = Remove saved signature
pdfjs-editor-delete-signature-button-label1 = Remove saved signature
pdfjs-editor-add-signature-edit-button-label = Edit description
pdfjs-editor-edit-signature-dialog-title = Edit description
pdfjs-editor-edit-signature-update-button = Update
pdfjs-editor-edit-comment-actions-button-label = Actions
pdfjs-editor-edit-comment-actions-button =
    .title = Actions
pdfjs-editor-edit-comment-close-button-label = Close
pdfjs-editor-edit-comment-close-button =
    .title = Close
pdfjs-editor-edit-comment-actions-edit-button-label = Edit
pdfjs-editor-edit-comment-actions-delete-button-label = Delete
pdfjs-editor-edit-comment-manager-text-input =
    .placeholder = Enter your comment
pdfjs-editor-edit-comment-manager-cancel-button = Cancel
pdfjs-editor-edit-comment-manager-save-button = Save
pdfjs-editor-edit-comment-button =
    .title = Edit comment`);
}, xe(nB, A4);
let NW = nB;
const Q8e = 1e3, J8e = 50, X8e = 1e3;
function mde() {
  return document.location.hash;
}
var oP, po, jD, Doe, Coe, TQ, Ooe, Ufe, Ove, Lve, Bfe, _ve, xve;
class eMe {
  constructor({
    linkService: t,
    eventBus: i
  }) {
    xe(this, po);
    xe(this, oP, null);
    this.linkService = t, this.eventBus = i, this._initialized = !1, this._fingerprint = "", this.reset(), this.eventBus._on("pagesinit", () => {
      this._isPagesLoaded = !1, this.eventBus._on("pagesloaded", (n) => {
        this._isPagesLoaded = !!n.pagesCount;
      }, {
        once: !0
      });
    });
  }
  initialize({
    fingerprint: t,
    resetHistory: i = !1,
    updateUrl: n = !1
  }) {
    if (!t || typeof t != "string") {
      console.error('PDFHistory.initialize: The "fingerprint" must be a non-empty string.');
      return;
    }
    this._initialized && this.reset();
    const s = this._fingerprint !== "" && this._fingerprint !== t;
    this._fingerprint = t, this._updateUrl = n === !0, this._initialized = !0, _e(this, po, _ve).call(this);
    const o = window.history.state;
    if (this._popStateInProgress = !1, this._blockHashChange = 0, this._currentHash = mde(), this._numPositionUpdates = 0, this._uid = this._maxUid = 0, this._destination = null, this._position = null, !_e(this, po, TQ).call(this, o, !0) || i) {
      const {
        hash: l,
        page: c,
        rotation: h
      } = _e(this, po, Ufe).call(this, !0);
      if (!l || s || i) {
        _e(this, po, jD).call(this, null, !0);
        return;
      }
      _e(this, po, jD).call(this, {
        hash: l,
        page: c,
        rotation: h
      }, !0);
      return;
    }
    const r = o.destination;
    _e(this, po, Ooe).call(this, r, o.uid, !0), r.rotation !== void 0 && (this._initialRotation = r.rotation), r.dest ? (this._initialBookmark = JSON.stringify(r.dest), this._destination.page = null) : r.hash ? this._initialBookmark = r.hash : r.page && (this._initialBookmark = `page=${r.page}`);
  }
  reset() {
    this._initialized && (_e(this, po, Bfe).call(this), this._initialized = !1, _e(this, po, xve).call(this)), this._updateViewareaTimeout && (clearTimeout(this._updateViewareaTimeout), this._updateViewareaTimeout = null), this._initialBookmark = null, this._initialRotation = null;
  }
  push({
    namedDest: t = null,
    explicitDest: i,
    pageNumber: n
  }) {
    if (!this._initialized)
      return;
    if (t && typeof t != "string") {
      console.error(`PDFHistory.push: "${t}" is not a valid namedDest parameter.`);
      return;
    } else if (Array.isArray(i)) {
      if (!_e(this, po, Coe).call(this, n) && (n !== null || this._destination)) {
        console.error(`PDFHistory.push: "${n}" is not a valid pageNumber parameter.`);
        return;
      }
    } else {
      console.error(`PDFHistory.push: "${i}" is not a valid explicitDest parameter.`);
      return;
    }
    const s = t || JSON.stringify(i);
    if (!s)
      return;
    let o = !1;
    if (this._destination && (tMe(this._destination.hash, s) || iMe(this._destination.dest, i))) {
      if (this._destination.page)
        return;
      o = !0;
    }
    this._popStateInProgress && !o || (_e(this, po, jD).call(this, {
      dest: i,
      hash: s,
      page: n,
      rotation: this.linkService.rotation
    }, o), this._popStateInProgress || (this._popStateInProgress = !0, Promise.resolve().then(() => {
      this._popStateInProgress = !1;
    })));
  }
  pushPage(t) {
    var i;
    if (this._initialized) {
      if (!_e(this, po, Coe).call(this, t)) {
        console.error(`PDFHistory.pushPage: "${t}" is not a valid page number.`);
        return;
      }
      ((i = this._destination) == null ? void 0 : i.page) !== t && (this._popStateInProgress || (_e(this, po, jD).call(this, {
        dest: null,
        hash: `page=${t}`,
        page: t,
        rotation: this.linkService.rotation
      }), this._popStateInProgress || (this._popStateInProgress = !0, Promise.resolve().then(() => {
        this._popStateInProgress = !1;
      }))));
    }
  }
  pushCurrentPosition() {
    !this._initialized || this._popStateInProgress || _e(this, po, Doe).call(this);
  }
  back() {
    if (!this._initialized || this._popStateInProgress)
      return;
    const t = window.history.state;
    _e(this, po, TQ).call(this, t) && t.uid > 0 && window.history.back();
  }
  forward() {
    if (!this._initialized || this._popStateInProgress)
      return;
    const t = window.history.state;
    _e(this, po, TQ).call(this, t) && t.uid < this._maxUid && window.history.forward();
  }
  get popStateInProgress() {
    return this._initialized && (this._popStateInProgress || this._blockHashChange > 0);
  }
  get initialBookmark() {
    return this._initialized ? this._initialBookmark : null;
  }
  get initialRotation() {
    return this._initialized ? this._initialRotation : null;
  }
}
oP = new WeakMap(), po = new WeakSet(), jD = function(t, i = !1) {
  const n = i || !this._destination, s = {
    fingerprint: this._fingerprint,
    uid: n ? this._uid : this._uid + 1,
    destination: t
  };
  _e(this, po, Ooe).call(this, t, s.uid);
  let o;
  if (this._updateUrl && (t != null && t.hash)) {
    const {
      href: r,
      protocol: l
    } = document.location;
    l !== "file:" && (o = wPe(r, t.hash));
  }
  n ? window.history.replaceState(s, "", o) : window.history.pushState(s, "", o);
}, Doe = function(t = !1) {
  if (!this._position)
    return;
  let i = this._position;
  if (t && (i = Object.assign(/* @__PURE__ */ Object.create(null), this._position), i.temporary = !0), !this._destination) {
    _e(this, po, jD).call(this, i);
    return;
  }
  if (this._destination.temporary) {
    _e(this, po, jD).call(this, i, !0);
    return;
  }
  if (this._destination.hash === i.hash || !this._destination.page && this._numPositionUpdates <= J8e)
    return;
  let n = !1;
  if (this._destination.page >= i.first && this._destination.page <= i.page) {
    if (this._destination.dest !== void 0 || !this._destination.first)
      return;
    n = !0;
  }
  _e(this, po, jD).call(this, i, n);
}, Coe = function(t) {
  return Number.isInteger(t) && t > 0 && t <= this.linkService.pagesCount;
}, TQ = function(t, i = !1) {
  if (!t)
    return !1;
  if (t.fingerprint !== this._fingerprint)
    if (i) {
      if (typeof t.fingerprint != "string" || t.fingerprint.length !== this._fingerprint.length)
        return !1;
      const [n] = performance.getEntriesByType("navigation");
      if ((n == null ? void 0 : n.type) !== "reload")
        return !1;
    } else
      return !1;
  return !(!Number.isInteger(t.uid) || t.uid < 0 || t.destination === null || typeof t.destination != "object");
}, Ooe = function(t, i, n = !1) {
  this._updateViewareaTimeout && (clearTimeout(this._updateViewareaTimeout), this._updateViewareaTimeout = null), n && (t != null && t.temporary) && delete t.temporary, this._destination = t, this._uid = i, this._maxUid = Math.max(this._maxUid, i), this._numPositionUpdates = 0;
}, Ufe = function(t = !1) {
  const i = unescape(mde()).substring(1), n = Tae(i), s = n.get("nameddest") || "";
  let o = n.get("page") | 0;
  return (!_e(this, po, Coe).call(this, o) || t && s.length > 0) && (o = null), {
    hash: i,
    page: o,
    rotation: this.linkService.rotation
  };
}, Ove = function({
  location: t
}) {
  this._updateViewareaTimeout && (clearTimeout(this._updateViewareaTimeout), this._updateViewareaTimeout = null), this._position = {
    hash: t.pdfOpenParams.substring(1),
    page: this.linkService.page,
    first: t.pageNumber,
    rotation: t.rotation
  }, !this._popStateInProgress && (this._isPagesLoaded && this._destination && !this._destination.page && this._numPositionUpdates++, this._updateViewareaTimeout = setTimeout(() => {
    this._popStateInProgress || _e(this, po, Doe).call(this, !0), this._updateViewareaTimeout = null;
  }, X8e));
}, Lve = function({
  state: t
}) {
  const i = mde(), n = this._currentHash !== i;
  if (this._currentHash = i, !t) {
    this._uid++;
    const {
      hash: o,
      page: r,
      rotation: l
    } = _e(this, po, Ufe).call(this);
    _e(this, po, jD).call(this, {
      hash: o,
      page: r,
      rotation: l
    }, !0);
    return;
  }
  if (!_e(this, po, TQ).call(this, t))
    return;
  this._popStateInProgress = !0, n && (this._blockHashChange++, i8e({
    target: window,
    name: "hashchange",
    delay: Q8e
  }).then(() => {
    this._blockHashChange--;
  }));
  const s = t.destination;
  _e(this, po, Ooe).call(this, s, t.uid, !0), dve(s.rotation) && (this.linkService.rotation = s.rotation), s.dest ? this.linkService.goToDestination(s.dest) : s.hash ? this.linkService.setHash(s.hash) : s.page && (this.linkService.page = s.page), Promise.resolve().then(() => {
    this._popStateInProgress = !1;
  });
}, Bfe = function() {
  (!this._destination || this._destination.temporary) && _e(this, po, Doe).call(this);
}, _ve = function() {
  if (S(this, oP))
    return;
  be(this, oP, new AbortController());
  const {
    signal: t
  } = S(this, oP);
  this.eventBus._on("updateviewarea", _e(this, po, Ove).bind(this), {
    signal: t
  }), window.addEventListener("popstate", _e(this, po, Lve).bind(this), {
    signal: t
  }), window.addEventListener("pagehide", _e(this, po, Bfe).bind(this), {
    signal: t
  });
}, xve = function() {
  var t;
  (t = S(this, oP)) == null || t.abort(), be(this, oP, null);
};
function tMe(e, t) {
  return typeof e != "string" || typeof t != "string" ? !1 : e === t || Tae(e).get("nameddest") === t;
}
function iMe(e, t) {
  function i(n, s) {
    if (typeof n != typeof s || Array.isArray(n) || Array.isArray(s))
      return !1;
    if (n !== null && typeof n == "object" && s !== null) {
      if (Object.keys(n).length !== Object.keys(s).length)
        return !1;
      for (const o in n)
        if (!i(n[o], s[o]))
          return !1;
      return !0;
    }
    return n === s || Number.isNaN(n) && Number.isNaN(s);
  }
  if (!(Array.isArray(e) && Array.isArray(t)) || e.length !== t.length)
    return !1;
  for (let n = 0, s = e.length; n < s; n++)
    if (!i(e[n], t[n]))
      return !1;
  return !0;
}
var Ste, bte, Nte, Dte, Cte, Zj;
class nMe {
  constructor(t) {
    xe(this, Ste, null);
    xe(this, bte, null);
    xe(this, Nte, null);
    xe(this, Dte, null);
    xe(this, Cte, null);
    xe(this, Zj);
    this.pdfPage = t.pdfPage, this.accessibilityManager = t.accessibilityManager, this.l10n = t.l10n, this.l10n || (this.l10n = new NW()), this.annotationEditorLayer = null, this.div = null, this._cancelled = !1, be(this, Zj, t.uiManager), be(this, Ste, t.annotationLayer || null), be(this, Cte, t.textLayer || null), be(this, bte, t.drawLayer || null), be(this, Nte, t.onAppend || null), be(this, Dte, t.structTreeLayer || null);
  }
  async render({
    viewport: t,
    intent: i = "display"
  }) {
    var r;
    if (i !== "display" || this._cancelled)
      return;
    const n = t.clone({
      dontFlip: !0
    });
    if (this.div) {
      this.annotationEditorLayer.update({
        viewport: n
      }), this.show();
      return;
    }
    const s = this.div = document.createElement("div");
    s.className = "annotationEditorLayer", s.hidden = !0, s.dir = S(this, Zj).direction, (r = S(this, Nte)) == null || r.call(this, s), this.annotationEditorLayer = new dPe({
      uiManager: S(this, Zj),
      div: s,
      structTreeLayer: S(this, Dte),
      accessibilityManager: this.accessibilityManager,
      pageIndex: this.pdfPage.pageNumber - 1,
      l10n: this.l10n,
      viewport: n,
      annotationLayer: S(this, Ste),
      textLayer: S(this, Cte),
      drawLayer: S(this, bte)
    });
    const o = {
      viewport: n,
      div: s,
      annotations: null,
      intent: i
    };
    this.annotationEditorLayer.render(o), this.show();
  }
  cancel() {
    this._cancelled = !0, this.div && this.annotationEditorLayer.destroy();
  }
  hide() {
    this.div && (this.annotationEditorLayer.pause(!0), this.div.hidden = !0);
  }
  show() {
    !this.div || this.annotationEditorLayer.isInvisible || (this.div.hidden = !1, this.annotationEditorLayer.pause(!1));
  }
}
Ste = new WeakMap(), bte = new WeakMap(), Nte = new WeakMap(), Dte = new WeakMap(), Cte = new WeakMap(), Zj = new WeakMap();
{
  var Ffe = /* @__PURE__ */ new Map();
  const {
    maxTouchPoints: e,
    platform: t,
    userAgent: i
  } = navigator, n = /Android/.test(i), s = /\b(iPad|iPhone|iPod)(?=;)/.test(i) || t === "MacIntel" && e > 1;
  (function() {
    (s || n) && Ffe.set("maxCanvasPixels", 5242880);
  })(), (function() {
    n && Ffe.set("useSystemFonts", !1);
  })();
}
const xi = {
  BROWSER: 1,
  VIEWER: 2,
  API: 4,
  WORKER: 8,
  EVENT_DISPATCH: 16,
  PREFERENCE: 128
}, Hfe = {
  BOOLEAN: 1,
  NUMBER: 2,
  OBJECT: 4,
  STRING: 8,
  UNDEFINED: 16
}, yO = {
  allowedGlobalEvents: {
    value: null,
    kind: xi.BROWSER
  },
  canvasMaxAreaInBytes: {
    value: -1,
    kind: xi.BROWSER + xi.API
  },
  isInAutomation: {
    value: !1,
    kind: xi.BROWSER
  },
  localeProperties: {
    value: {
      lang: navigator.language || "en-US"
    },
    kind: xi.BROWSER
  },
  maxCanvasDim: {
    value: 32767,
    kind: xi.BROWSER + xi.VIEWER
  },
  nimbusDataStr: {
    value: "",
    kind: xi.BROWSER
  },
  supportsCaretBrowsingMode: {
    value: !1,
    kind: xi.BROWSER
  },
  supportsDocumentFonts: {
    value: !0,
    kind: xi.BROWSER
  },
  supportsIntegratedFind: {
    value: !1,
    kind: xi.BROWSER
  },
  supportsMouseWheelZoomCtrlKey: {
    value: !0,
    kind: xi.BROWSER
  },
  supportsMouseWheelZoomMetaKey: {
    value: !0,
    kind: xi.BROWSER
  },
  supportsPinchToZoom: {
    value: !0,
    kind: xi.BROWSER
  },
  supportsPrinting: {
    value: !0,
    kind: xi.BROWSER
  },
  toolbarDensity: {
    value: 0,
    kind: xi.BROWSER + xi.EVENT_DISPATCH
  },
  altTextLearnMoreUrl: {
    value: "",
    kind: xi.VIEWER + xi.PREFERENCE
  },
  annotationEditorMode: {
    value: 0,
    kind: xi.VIEWER + xi.PREFERENCE
  },
  annotationMode: {
    value: 2,
    kind: xi.VIEWER + xi.PREFERENCE
  },
  capCanvasAreaFactor: {
    value: 200,
    kind: xi.VIEWER + xi.PREFERENCE
  },
  cursorToolOnLoad: {
    value: 0,
    kind: xi.VIEWER + xi.PREFERENCE
  },
  debuggerSrc: {
    value: "./debugger.mjs",
    kind: xi.VIEWER
  },
  defaultZoomDelay: {
    value: 400,
    kind: xi.VIEWER + xi.PREFERENCE
  },
  defaultZoomValue: {
    value: "",
    kind: xi.VIEWER + xi.PREFERENCE
  },
  disableHistory: {
    value: !1,
    kind: xi.VIEWER
  },
  disablePageLabels: {
    value: !1,
    kind: xi.VIEWER + xi.PREFERENCE
  },
  enableAltText: {
    value: !1,
    kind: xi.VIEWER + xi.PREFERENCE
  },
  enableAltTextModelDownload: {
    value: !0,
    kind: xi.VIEWER + xi.PREFERENCE + xi.EVENT_DISPATCH
  },
  enableAutoLinking: {
    value: !0,
    kind: xi.VIEWER + xi.PREFERENCE
  },
  enableComment: {
    value: !1,
    kind: xi.VIEWER + xi.PREFERENCE
  },
  enableDetailCanvas: {
    value: !0,
    kind: xi.VIEWER
  },
  enableGuessAltText: {
    value: !0,
    kind: xi.VIEWER + xi.PREFERENCE + xi.EVENT_DISPATCH
  },
  enableHighlightFloatingButton: {
    value: !1,
    kind: xi.VIEWER + xi.PREFERENCE
  },
  enableNewAltTextWhenAddingImage: {
    value: !0,
    kind: xi.VIEWER + xi.PREFERENCE
  },
  enablePermissions: {
    value: !1,
    kind: xi.VIEWER + xi.PREFERENCE
  },
  enablePrintAutoRotate: {
    value: !0,
    kind: xi.VIEWER + xi.PREFERENCE
  },
  enableScripting: {
    value: !0,
    kind: xi.VIEWER + xi.PREFERENCE
  },
  enableSignatureEditor: {
    value: !1,
    kind: xi.VIEWER + xi.PREFERENCE
  },
  enableUpdatedAddImage: {
    value: !1,
    kind: xi.VIEWER + xi.PREFERENCE
  },
  externalLinkRel: {
    value: "noopener noreferrer nofollow",
    kind: xi.VIEWER
  },
  externalLinkTarget: {
    value: 0,
    kind: xi.VIEWER + xi.PREFERENCE
  },
  highlightEditorColors: {
    value: "yellow=#FFFF98,green=#53FFBC,blue=#80EBFF,pink=#FFCBE6,red=#FF4F5F,yellow_HCM=#FFFFCC,green_HCM=#53FFBC,blue_HCM=#80EBFF,pink_HCM=#F6B8FF,red_HCM=#C50043",
    kind: xi.VIEWER + xi.PREFERENCE
  },
  historyUpdateUrl: {
    value: !1,
    kind: xi.VIEWER + xi.PREFERENCE
  },
  ignoreDestinationZoom: {
    value: !1,
    kind: xi.VIEWER + xi.PREFERENCE
  },
  imageResourcesPath: {
    value: "./images/",
    kind: xi.VIEWER
  },
  maxCanvasPixels: {
    value: 2 ** 25,
    kind: xi.VIEWER
  },
  minDurationToUpdateCanvas: {
    value: 500,
    kind: xi.VIEWER
  },
  forcePageColors: {
    value: !1,
    kind: xi.VIEWER + xi.PREFERENCE
  },
  pageColorsBackground: {
    value: "Canvas",
    kind: xi.VIEWER + xi.PREFERENCE
  },
  pageColorsForeground: {
    value: "CanvasText",
    kind: xi.VIEWER + xi.PREFERENCE
  },
  pdfBugEnabled: {
    value: !1,
    kind: xi.VIEWER + xi.PREFERENCE
  },
  printResolution: {
    value: 150,
    kind: xi.VIEWER
  },
  sidebarViewOnLoad: {
    value: -1,
    kind: xi.VIEWER + xi.PREFERENCE
  },
  scrollModeOnLoad: {
    value: -1,
    kind: xi.VIEWER + xi.PREFERENCE
  },
  spreadModeOnLoad: {
    value: -1,
    kind: xi.VIEWER + xi.PREFERENCE
  },
  textLayerMode: {
    value: 1,
    kind: xi.VIEWER + xi.PREFERENCE
  },
  viewerCssTheme: {
    value: 0,
    kind: xi.VIEWER + xi.PREFERENCE
  },
  viewOnLoad: {
    value: 0,
    kind: xi.VIEWER + xi.PREFERENCE
  },
  cMapPacked: {
    value: !0,
    kind: xi.API
  },
  cMapUrl: {
    value: "../web/cmaps/",
    kind: xi.API
  },
  disableAutoFetch: {
    value: !1,
    kind: xi.API + xi.PREFERENCE
  },
  disableFontFace: {
    value: !1,
    kind: xi.API + xi.PREFERENCE
  },
  disableRange: {
    value: !1,
    kind: xi.API + xi.PREFERENCE
  },
  disableStream: {
    value: !1,
    kind: xi.API + xi.PREFERENCE
  },
  docBaseUrl: {
    value: "",
    kind: xi.API
  },
  enableHWA: {
    value: !0,
    kind: xi.API + xi.VIEWER + xi.PREFERENCE
  },
  enableXfa: {
    value: !0,
    kind: xi.API + xi.PREFERENCE
  },
  fontExtraProperties: {
    value: !1,
    kind: xi.API
  },
  iccUrl: {
    value: "../web/iccs/",
    kind: xi.API
  },
  isEvalSupported: {
    value: !0,
    kind: xi.API
  },
  isOffscreenCanvasSupported: {
    value: !0,
    kind: xi.API
  },
  maxImageSize: {
    value: -1,
    kind: xi.API
  },
  pdfBug: {
    value: !1,
    kind: xi.API
  },
  standardFontDataUrl: {
    value: "../web/standard_fonts/",
    kind: xi.API
  },
  useSystemFonts: {
    value: void 0,
    kind: xi.API,
    type: Hfe.BOOLEAN + Hfe.UNDEFINED
  },
  verbosity: {
    value: 1,
    kind: xi.API
  },
  wasmUrl: {
    value: "../web/wasm/",
    kind: xi.API
  },
  workerPort: {
    value: null,
    kind: xi.WORKER
  },
  workerSrc: {
    value: "../build/pdf.worker.mjs",
    kind: xi.WORKER
  }
};
yO.defaultUrl = {
  value: "compressed.tracemonkey-pldi-09.pdf",
  kind: xi.VIEWER
}, yO.sandboxBundleSrc = {
  value: "../build/pdf.sandbox.mjs",
  kind: xi.VIEWER
}, yO.enableFakeMLManager = {
  value: !0,
  kind: xi.VIEWER
};
yO.disablePreferences = {
  value: !1,
  kind: xi.VIEWER
};
var rP;
const Tb = class Tb {
  static get(t) {
    return S(this, rP).get(t);
  }
  static getAll(t = null, i = !1) {
    const n = /* @__PURE__ */ Object.create(null);
    for (const s in yO) {
      const o = yO[s];
      t && !(t & o.kind) || (n[s] = i ? o.value : S(this, rP).get(s));
    }
    return n;
  }
  static set(t, i) {
    this.setAll({
      [t]: i
    });
  }
  static setAll(t, i = !1) {
    this._hasInvokedSet || (this._hasInvokedSet = !0);
    let n;
    for (const s in t) {
      const o = yO[s], r = t[s];
      if (!o || !(typeof r == typeof o.value || Hfe[(typeof r).toUpperCase()] & o.type))
        continue;
      const {
        kind: l
      } = o;
      i && !(l & xi.BROWSER || l & xi.PREFERENCE) || (this.eventBus && l & xi.EVENT_DISPATCH && (n || (n = /* @__PURE__ */ new Map())).set(s, r), S(this, rP).set(s, r));
    }
    if (n)
      for (const [s, o] of n)
        this.eventBus.dispatch(s.toLowerCase(), {
          source: this,
          value: o
        });
  }
};
rP = new WeakMap(), Zi(Tb, "eventBus"), xe(Tb, rP, /* @__PURE__ */ new Map()), (() => {
  for (const t in yO)
    S(Tb, rP).set(t, yO[t].value);
  for (const [t, i] of Ffe)
    S(Tb, rP).set(t, i);
  Tb._hasInvokedSet = !1, Tb._checkDisablePreferences = () => Tb.get("disablePreferences") ? !0 : (Tb._hasInvokedSet && console.warn('The Preferences may override manually set AppOptions; please use the "disablePreferences"-option to prevent that.'), !1);
})();
let RJ = Tb;
function LEe({
  width: e,
  height: t,
  left: i,
  top: n
}, s) {
  if (e === 0 || t === 0)
    return null;
  const o = s.textLayer.div.getBoundingClientRect(), r = s.getPagePoint(i - o.left, n - o.top), l = s.getPagePoint(i - o.left + e, n - o.top + t);
  return Mpe.normalizeRect([r[0], r[1], l[0], l[1]]);
}
function sMe(e, t) {
  const i = e.getClientRects();
  if (i.length === 1)
    return {
      rect: LEe(i[0], t)
    };
  const n = [1 / 0, 1 / 0, -1 / 0, -1 / 0], s = [];
  let o = 0;
  for (const r of i) {
    const l = LEe(r, t);
    l !== null && (s[o] = s[o + 4] = l[0], s[o + 1] = s[o + 3] = l[3], s[o + 2] = s[o + 6] = l[2], s[o + 5] = s[o + 7] = l[1], Mpe.rectBoundingBox(...l, n), o += 8);
  }
  return {
    quadPoints: s,
    rect: n
  };
}
function _Ee(e, t) {
  let i = e;
  do {
    if (i.nodeType === Node.TEXT_NODE) {
      const n = i.textContent.length;
      if (t <= n)
        return [i, t];
      t -= n;
    } else if (i.firstChild) {
      i = i.firstChild;
      continue;
    }
    for (; !i.nextSibling && i !== e; )
      i = i.parentNode;
    i !== e && (i = i.nextSibling);
  } while (i !== e);
  throw new Error("Offset is bigger than container's contents length.");
}
function oMe({
  url: e,
  index: t,
  length: i
}, n, s) {
  const o = n._textHighlighter, [{
    begin: r,
    end: l
  }] = o._convertMatches([t], [i]), c = new Range();
  return c.setStart(..._Ee(o.textDivs[r.divIdx], r.offset)), c.setEnd(..._Ee(o.textDivs[l.divIdx], l.offset)), {
    id: `inferred_link_${s}`,
    unsafeUrl: e,
    url: e,
    annotationType: sve.LINK,
    rotation: 0,
    ...sMe(c, n),
    borderStyle: null
  };
}
var oae, Ote;
class Gfe {
  static findLinks(t) {
    S(this, Ote) ?? be(this, Ote, new RegExp("\\b(?:https?:\\/\\/|mailto:|www\\.)(?:[\\S--[\\p{P}<>]]|\\/|[\\S--[\\[\\]]]+[\\S--[\\p{P}<>]])+|\\b[\\S--[@\\p{Ps}\\p{Pe}<>]]+@([\\S--[\\p{P}<>]]+(?:\\.[\\S--[\\p{P}<>]]+)+)", "gmv"));
    const [i, n] = Soe(t, {
      ignoreDashEOL: !0
    }), s = i.matchAll(S(this, Ote)), o = [];
    for (const r of s) {
      const [l, c] = r;
      let h;
      if (l.startsWith("www.") || l.startsWith("http://") || l.startsWith("https://"))
        h = l;
      else if (URL.canParse(`http://${c}`))
        h = l.startsWith("mailto:") ? l : `mailto:${l}`;
      else
        continue;
      const I = ove(h, null, {
        addDefaultProtocol: !0
      });
      if (I) {
        const [p, y] = cve(n, r.index, l.length);
        o.push({
          url: I.href,
          index: p,
          length: y
        });
      }
    }
    return o;
  }
  static processLinks(t) {
    return this.findLinks(t._textHighlighter.textContentItemsStr.join(`
`)).map((i) => oMe(i, t, hp(this, oae)._++));
  }
}
oae = new WeakMap(), Ote = new WeakMap(), xe(Gfe, oae, 0), xe(Gfe, Ote);
var lP, Qj, Jj, Xj, lO, aP, aO, rae, Lte, kfe;
class Pve {
  constructor(t) {
    xe(this, Lte);
    xe(this, lP, null);
    xe(this, Qj, 0);
    xe(this, Jj, null);
    xe(this, Xj, ll.INITIAL);
    xe(this, lO, null);
    xe(this, aP, 0);
    xe(this, aO, null);
    Zi(this, "canvas", null);
    Zi(this, "div", null);
    Zi(this, "eventBus", null);
    Zi(this, "id", null);
    Zi(this, "pageColors", null);
    Zi(this, "renderingQueue", null);
    Zi(this, "renderTask", null);
    Zi(this, "resume", null);
    xe(this, rae, (t) => {
      var i;
      if ((i = S(this, lO)) == null || i.call(this, !1), this.renderingQueue && !this.renderingQueue.isHighestPriority(this)) {
        this.renderingState = ll.PAUSED, this.resume = () => {
          this.renderingState = ll.RUNNING, t();
        };
        return;
      }
      t();
    });
    this.eventBus = t.eventBus, this.id = t.id, this.pageColors = t.pageColors || null, this.renderingQueue = t.renderingQueue, be(this, Qj, t.minDurationToUpdateCanvas ?? 500);
  }
  get renderingState() {
    return S(this, Xj);
  }
  set renderingState(t) {
    var i;
    if (t !== S(this, Xj))
      switch (be(this, Xj, t), S(this, lP) && (clearTimeout(S(this, lP)), be(this, lP, null)), t) {
        case ll.PAUSED:
          this.div.classList.remove("loading"), be(this, aP, 0), (i = S(this, lO)) == null || i.call(this, !1);
          break;
        case ll.RUNNING:
          this.div.classList.add("loadingIcon"), be(this, lP, setTimeout(() => {
            this.div.classList.add("loading"), be(this, lP, null);
          }, 0)), be(this, aP, Date.now());
          break;
        case ll.INITIAL:
        case ll.FINISHED:
          this.div.classList.remove("loadingIcon", "loading"), be(this, aP, 0);
          break;
      }
  }
  _createCanvas(t, i = !1) {
    const {
      pageColors: n
    } = this, s = !!(n != null && n.background && (n != null && n.foreground)), o = this.canvas, r = !o && !s && !i;
    let l = this.canvas = document.createElement("canvas");
    return be(this, lO, (c) => {
      if (r) {
        let h = S(this, aO);
        if (!c && S(this, Qj) > 0) {
          if (Date.now() - S(this, aP) < S(this, Qj))
            return;
          h || (h = be(this, aO, l), l = this.canvas = l.cloneNode(!1), t(l));
        }
        if (h) {
          l.getContext("2d", {
            alpha: !1
          }).drawImage(h, 0, 0), c ? _e(this, Lte, kfe).call(this) : be(this, aP, Date.now());
          return;
        }
        t(l), be(this, lO, null);
        return;
      }
      c && (o ? (o.replaceWith(l), o.width = o.height = 0) : t(l));
    }), {
      canvas: l,
      prevCanvas: o
    };
  }
  _resetCanvas() {
    const {
      canvas: t
    } = this;
    t && (t.remove(), t.width = t.height = 0, this.canvas = null, _e(this, Lte, kfe).call(this));
  }
  async _drawCanvas(t, i, n) {
    var r, l;
    const s = this.renderTask = this.pdfPage.render(t);
    s.onContinue = S(this, rae), s.onError = (c) => {
      c instanceof wfe && (i(), be(this, Jj, null));
    };
    let o = null;
    try {
      await s.promise, (r = S(this, lO)) == null || r.call(this, !0);
    } catch (c) {
      if (c instanceof wfe)
        return;
      o = c, (l = S(this, lO)) == null || l.call(this, !0);
    } finally {
      be(this, Jj, o), s === this.renderTask && (this.renderTask = null);
    }
    if (this.renderingState = ll.FINISHED, n(s), o)
      throw o;
  }
  cancelRendering({
    cancelExtraDelay: t = 0
  } = {}) {
    this.renderTask && (this.renderTask.cancel(t), this.renderTask = null), this.resume = null;
  }
  dispatchPageRender() {
    this.eventBus.dispatch("pagerender", {
      source: this,
      pageNumber: this.id
    });
  }
  dispatchPageRendered(t, i) {
    this.eventBus.dispatch("pagerendered", {
      source: this,
      pageNumber: this.id,
      cssTransform: t,
      isDetailView: i,
      timestamp: performance.now(),
      error: S(this, Jj)
    });
  }
}
lP = new WeakMap(), Qj = new WeakMap(), Jj = new WeakMap(), Xj = new WeakMap(), lO = new WeakMap(), aP = new WeakMap(), aO = new WeakMap(), rae = new WeakMap(), Lte = new WeakSet(), kfe = function() {
  S(this, aO) && (S(this, aO).width = S(this, aO).height = 0, be(this, aO, null));
};
var Yb;
class rMe {
  constructor(t) {
    xe(this, Yb, null);
    this.pageIndex = t.pageIndex;
  }
  async render({
    intent: t = "display"
  }) {
    t !== "display" || S(this, Yb) || this._cancelled || be(this, Yb, new fPe({
      pageIndex: this.pageIndex
    }));
  }
  cancel() {
    this._cancelled = !0, S(this, Yb) && (S(this, Yb).destroy(), be(this, Yb, null));
  }
  setParent(t) {
    var i;
    (i = S(this, Yb)) == null || i.setParent(t);
  }
  getDrawLayer() {
    return S(this, Yb);
  }
}
Yb = new WeakMap();
var Sv, lae, Mve;
class lMe extends Pve {
  constructor({
    pageView: i
  }) {
    super(i);
    xe(this, lae);
    xe(this, Sv, null);
    Zi(this, "renderingCancelled", !1);
    this.pageView = i, this.renderingId = "detail" + this.id, this.div = i.div;
  }
  setPdfPage(i) {
    this.pageView.setPdfPage(i);
  }
  get pdfPage() {
    return this.pageView.pdfPage;
  }
  get renderingState() {
    return super.renderingState;
  }
  set renderingState(i) {
    this.renderingCancelled = !1, super.renderingState = i;
  }
  reset({
    keepCanvas: i = !1
  } = {}) {
    const n = this.renderingCancelled || this.renderingState === ll.RUNNING || this.renderingState === ll.PAUSED;
    this.cancelRendering(), this.renderingState = ll.INITIAL, this.renderingCancelled = n, i || this._resetCanvas();
  }
  update({
    visibleArea: i = null,
    underlyingViewUpdated: n = !1
  } = {}) {
    if (n) {
      this.cancelRendering(), this.renderingState = ll.INITIAL;
      return;
    }
    if (!_e(this, lae, Mve).call(this, i))
      return;
    const {
      viewport: s,
      maxCanvasPixels: o,
      capCanvasAreaFactor: r
    } = this.pageView, l = i.maxX - i.minX, c = i.maxY - i.minY, h = l * c * Aoe.pixelRatio ** 2, p = (Math.sqrt(Aoe.capPixels(o, r) / h) - 1) / 2;
    let y = Math.min(1, p);
    y < 0 && (y = 0);
    const m = l * y, A = c * y, C = Math.max(0, i.minX - m), O = Math.min(s.width, i.maxX + m), R = Math.max(0, i.minY - A), F = Math.min(s.height, i.maxY + A), L = O - C, P = F - R;
    be(this, Sv, {
      minX: C,
      minY: R,
      width: L,
      height: P,
      scale: s.scale
    }), this.reset({
      keepCanvas: !0
    });
  }
  async draw() {
    if (this.pageView.detailView !== this)
      return;
    const i = this.pageView.renderingState === ll.FINISHED || this.renderingState === ll.FINISHED;
    this.renderingState !== ll.INITIAL && (console.error("Must be in new state before drawing"), this.reset());
    const {
      div: n,
      pdfPage: s,
      viewport: o
    } = this.pageView;
    if (!s)
      throw this.renderingState = ll.FINISHED, new Error("pdfPage is not loaded");
    this.renderingState = ll.RUNNING;
    const r = this.pageView._ensureCanvasWrapper(), {
      canvas: l,
      prevCanvas: c
    } = this._createCanvas((O) => {
      var R;
      ((R = r.firstElementChild) == null ? void 0 : R.tagName) === "CANVAS" ? r.firstElementChild.after(O) : r.prepend(O);
    }, i);
    l.setAttribute("aria-hidden", "true");
    const {
      width: h,
      height: I
    } = o, p = S(this, Sv), {
      pixelRatio: y
    } = Aoe, m = [y, 0, 0, y, -p.minX * y, -p.minY * y];
    l.width = p.width * y, l.height = p.height * y;
    const {
      style: A
    } = l;
    A.width = `${p.width * 100 / h}%`, A.height = `${p.height * 100 / I}%`, A.top = `${p.minY * 100 / I}%`, A.left = `${p.minX * 100 / h}%`;
    const C = this._drawCanvas(this.pageView._getRenderingContext(l, m), () => {
      var O;
      (O = this.canvas) == null || O.remove(), this.canvas = c;
    }, () => {
      this.dispatchPageRendered(!1, !0);
    });
    return n.setAttribute("data-loaded", !0), this.dispatchPageRender(), C;
  }
}
Sv = new WeakMap(), lae = new WeakSet(), Mve = function(i) {
  if (!S(this, Sv))
    return !0;
  const n = S(this, Sv).minX, s = S(this, Sv).minY, o = S(this, Sv).width + n, r = S(this, Sv).height + s;
  if (i.minX < n || i.minY < s || i.maxX > o || i.maxY > r)
    return !0;
  const {
    width: l,
    height: c,
    scale: h
  } = this.pageView.viewport;
  if (S(this, Sv).scale !== h)
    return !0;
  const I = i.minX - n, p = o - i.maxX, y = i.minY - s, m = r - i.maxY, A = 0.5, C = (1 + A) / A;
  return n > 0 && p / I > C || o < l && I / p > C || s > 0 && m / y > C || r < c && y / m > C;
};
const xEe = {
  Document: null,
  DocumentFragment: null,
  Part: "group",
  Sect: "group",
  Div: "group",
  Aside: "note",
  NonStruct: "none",
  P: null,
  H: "heading",
  Title: null,
  FENote: "note",
  Sub: "group",
  Lbl: null,
  Span: null,
  Em: null,
  Strong: null,
  Link: "link",
  Annot: "note",
  Form: "form",
  Ruby: null,
  RB: null,
  RT: null,
  RP: null,
  Warichu: null,
  WT: null,
  WP: null,
  L: "list",
  LI: "listitem",
  LBody: null,
  Table: "table",
  TR: "row",
  TH: "columnheader",
  TD: "cell",
  THead: "columnheader",
  TBody: null,
  TFoot: null,
  Caption: null,
  Figure: "figure",
  Formula: null,
  Artifact: null
}, aMe = /^H(\d+)$/;
var eW, bv, tW, iW, nW, uP, u6, Vfe, Bve, zfe;
class Uve {
  constructor(t, i) {
    xe(this, u6);
    xe(this, eW);
    xe(this, bv, null);
    xe(this, tW);
    xe(this, iW, /* @__PURE__ */ new Map());
    xe(this, nW);
    xe(this, uP, null);
    be(this, eW, t.getStructTree()), be(this, nW, i);
  }
  async render() {
    var s;
    if (S(this, tW))
      return S(this, tW);
    const {
      promise: t,
      resolve: i,
      reject: n
    } = Promise.withResolvers();
    be(this, tW, t);
    try {
      be(this, bv, _e(this, u6, zfe).call(this, await S(this, eW)));
    } catch (o) {
      n(o);
    }
    return be(this, eW, null), (s = S(this, bv)) == null || s.classList.add("structTree"), i(S(this, bv)), t;
  }
  async getAriaAttributes(t) {
    try {
      return await this.render(), S(this, iW).get(t);
    } catch {
    }
    return null;
  }
  hide() {
    S(this, bv) && !S(this, bv).hidden && (S(this, bv).hidden = !0);
  }
  show() {
    var t;
    (t = S(this, bv)) != null && t.hidden && (S(this, bv).hidden = !1);
  }
  addElementsToTextLayer() {
    var t;
    if (S(this, uP)) {
      for (const [i, n] of S(this, uP))
        (t = document.getElementById(i)) == null || t.append(n);
      S(this, uP).clear(), be(this, uP, null);
    }
  }
}
eW = new WeakMap(), bv = new WeakMap(), tW = new WeakMap(), iW = new WeakMap(), nW = new WeakMap(), uP = new WeakMap(), u6 = new WeakSet(), Vfe = function(t, i) {
  const {
    alt: n,
    id: s,
    lang: o
  } = t;
  if (n !== void 0) {
    let r = !1;
    const l = TJ(n);
    for (const c of t.children)
      if (c.type === "annotation") {
        let h = S(this, iW).get(c.id);
        h || (h = /* @__PURE__ */ new Map(), S(this, iW).set(c.id, h)), h.set("aria-label", l), r = !0;
      }
    r || i.setAttribute("aria-label", l);
  }
  s !== void 0 && i.setAttribute("aria-owns", s), o !== void 0 && i.setAttribute("lang", TJ(o, !0));
}, Bve = function(t, i) {
  const {
    alt: n,
    bbox: s,
    children: o
  } = t, r = o == null ? void 0 : o[0];
  if (!S(this, nW) || !n || !s || (r == null ? void 0 : r.type) !== "content")
    return !1;
  const {
    id: l
  } = r;
  if (!l)
    return !1;
  i.setAttribute("aria-owns", l);
  const c = document.createElement("span");
  (S(this, uP) || be(this, uP, /* @__PURE__ */ new Map())).set(l, c), c.setAttribute("role", "img"), c.setAttribute("aria-label", TJ(n));
  const {
    pageHeight: h,
    pageX: I,
    pageY: p
  } = S(this, nW), y = "calc(var(--total-scale-factor) *", {
    style: m
  } = c;
  return m.width = `${y}${s[2] - s[0]}px)`, m.height = `${y}${s[3] - s[1]}px)`, m.left = `${y}${s[0] - I}px)`, m.top = `${y}${h - s[3] + p}px)`, !0;
}, zfe = function(t) {
  if (!t)
    return null;
  const i = document.createElement("span");
  if ("role" in t) {
    const {
      role: n
    } = t, s = n.match(aMe);
    if (s ? (i.setAttribute("role", "heading"), i.setAttribute("aria-level", s[1])) : xEe[n] && i.setAttribute("role", xEe[n]), n === "Figure" && _e(this, u6, Bve).call(this, t, i))
      return i;
  }
  if (_e(this, u6, Vfe).call(this, t, i), t.children)
    if (t.children.length === 1 && "id" in t.children[0])
      _e(this, u6, Vfe).call(this, t.children[0], i);
    else
      for (const n of t.children)
        i.append(_e(this, u6, zfe).call(this, n));
  return i;
};
var uO, i5, dO, dP, sW, Loe, _te, Wfe;
const wz = class wz {
  constructor() {
    xe(this, _te);
    xe(this, uO, !1);
    xe(this, i5, null);
    xe(this, dO, /* @__PURE__ */ new Map());
    xe(this, dP, /* @__PURE__ */ new Map());
  }
  setTextMapping(t) {
    be(this, i5, t);
  }
  enable() {
    if (S(this, uO))
      throw new Error("TextAccessibilityManager is already enabled.");
    if (!S(this, i5))
      throw new Error("Text divs and strings have not been set.");
    if (be(this, uO, !0), be(this, i5, S(this, i5).slice()), S(this, i5).sort(_e(wz, sW, Loe)), S(this, dO).size > 0) {
      const t = S(this, i5);
      for (const [i, n] of S(this, dO)) {
        if (!document.getElementById(i)) {
          S(this, dO).delete(i);
          continue;
        }
        _e(this, _te, Wfe).call(this, i, t[n]);
      }
    }
    for (const [t, i] of S(this, dP))
      this.addPointerInTextLayer(t, i);
    S(this, dP).clear();
  }
  disable() {
    S(this, uO) && (S(this, dP).clear(), be(this, i5, null), be(this, uO, !1));
  }
  removePointerInTextLayer(t) {
    if (!S(this, uO)) {
      S(this, dP).delete(t);
      return;
    }
    const i = S(this, i5);
    if (!i || i.length === 0)
      return;
    const {
      id: n
    } = t, s = S(this, dO).get(n);
    if (s === void 0)
      return;
    const o = i[s];
    S(this, dO).delete(n);
    let r = o.getAttribute("aria-owns");
    r != null && r.includes(n) && (r = r.split(" ").filter((l) => l !== n).join(" "), r ? o.setAttribute("aria-owns", r) : (o.removeAttribute("aria-owns"), o.setAttribute("role", "presentation")));
  }
  addPointerInTextLayer(t, i) {
    const {
      id: n
    } = t;
    if (!n)
      return null;
    if (!S(this, uO))
      return S(this, dP).set(t, i), null;
    i && this.removePointerInTextLayer(t);
    const s = S(this, i5);
    if (!s || s.length === 0)
      return null;
    const o = cX(s, (h) => {
      var I;
      return _e(I = wz, sW, Loe).call(I, t, h) < 0;
    }), r = Math.max(0, o - 1), l = s[r];
    _e(this, _te, Wfe).call(this, n, l), S(this, dO).set(n, r);
    const c = l.parentNode;
    return c != null && c.classList.contains("markedContent") ? c.id : null;
  }
  moveElementInDOM(t, i, n, s) {
    const o = this.addPointerInTextLayer(n, s);
    if (!t.hasChildNodes())
      return t.append(i), o;
    const r = Array.from(t.childNodes).filter((h) => h !== i);
    if (r.length === 0)
      return o;
    const l = n || i, c = cX(r, (h) => {
      var I;
      return _e(I = wz, sW, Loe).call(I, l, h) < 0;
    });
    return c === 0 ? r[0].before(i) : r[c - 1].after(i), o;
  }
};
uO = new WeakMap(), i5 = new WeakMap(), dO = new WeakMap(), dP = new WeakMap(), sW = new WeakSet(), Loe = function(t, i) {
  const n = t.getBoundingClientRect(), s = i.getBoundingClientRect();
  if (n.width === 0 && n.height === 0)
    return 1;
  if (s.width === 0 && s.height === 0)
    return -1;
  const o = n.y, r = n.y + n.height, l = n.y + n.height / 2, c = s.y, h = s.y + s.height, I = s.y + s.height / 2;
  if (l <= c && I >= r)
    return -1;
  if (I <= o && l >= h)
    return 1;
  const p = n.x + n.width / 2, y = s.x + s.width / 2;
  return p - y;
}, _te = new WeakSet(), Wfe = function(t, i) {
  const n = i.getAttribute("aria-owns");
  n != null && n.includes(t) || i.setAttribute("aria-owns", n ? `${n} ${t}` : t), i.removeAttribute("role");
}, xe(wz, sW);
let jfe = wz;
var cP;
class uMe {
  constructor({
    findController: t,
    eventBus: i,
    pageIndex: n
  }) {
    xe(this, cP, null);
    this.findController = t, this.matches = [], this.eventBus = i, this.pageIdx = n, this.textDivs = null, this.textContentItemsStr = null, this.enabled = !1;
  }
  setTextMapping(t, i) {
    this.textDivs = t, this.textContentItemsStr = i;
  }
  enable() {
    if (!this.textDivs || !this.textContentItemsStr)
      throw new Error("Text divs and strings have not been set.");
    if (this.enabled)
      throw new Error("TextHighlighter is already enabled.");
    this.enabled = !0, S(this, cP) || (be(this, cP, new AbortController()), this.eventBus._on("updatetextlayermatches", (t) => {
      (t.pageIndex === this.pageIdx || t.pageIndex === -1) && this._updateMatches();
    }, {
      signal: S(this, cP).signal
    })), this._updateMatches();
  }
  disable() {
    var t;
    this.enabled && (this.enabled = !1, (t = S(this, cP)) == null || t.abort(), be(this, cP, null), this._updateMatches(!0));
  }
  _convertMatches(t, i) {
    if (!t)
      return [];
    const {
      textContentItemsStr: n
    } = this;
    let s = 0, o = 0;
    const r = n.length - 1, l = [];
    for (let c = 0, h = t.length; c < h; c++) {
      let I = t[c];
      for (; s !== r && I >= o + n[s].length; )
        o += n[s].length, s++;
      s === n.length && console.error("Could not find a matching mapping");
      const p = {
        begin: {
          divIdx: s,
          offset: I - o
        }
      };
      for (I += i[c]; s !== r && I > o + n[s].length; )
        o += n[s].length, s++;
      p.end = {
        divIdx: s,
        offset: I - o
      }, l.push(p);
    }
    return l;
  }
  _renderMatches(t) {
    if (t.length === 0)
      return;
    const {
      findController: i,
      pageIdx: n
    } = this, {
      textContentItemsStr: s,
      textDivs: o
    } = this, r = n === i.selected.pageIdx, l = i.selected.matchIdx, c = i.state.highlightAll;
    let h = null;
    const I = {
      offset: void 0
    };
    function p(R, F) {
      const L = R.divIdx;
      return o[L].textContent = "", y(L, 0, R.offset, F);
    }
    function y(R, F, L, P) {
      let z = o[R];
      if (z.nodeType === Node.TEXT_NODE) {
        const ce = document.createElement("span");
        z.before(ce), ce.append(z), o[R] = ce, z = ce;
      }
      const W = s[R].substring(F, L), re = document.createTextNode(W);
      if (P) {
        const ce = document.createElement("span");
        if (ce.className = `${P} appended`, ce.append(re), z.append(ce), P.includes("selected")) {
          const {
            left: te
          } = ce.getClientRects()[0], ee = z.getBoundingClientRect().left;
          return te - ee;
        }
        return 0;
      }
      return z.append(re), 0;
    }
    let m = l, A = m + 1;
    if (c)
      m = 0, A = t.length;
    else if (!r)
      return;
    let C = -1, O = -1;
    for (let R = m; R < A; R++) {
      const F = t[R], L = F.begin;
      if (L.divIdx === C && L.offset === O)
        continue;
      C = L.divIdx, O = L.offset;
      const P = F.end, z = r && R === l, W = z ? " selected" : "";
      let re = 0;
      if (!h || L.divIdx !== h.divIdx ? (h !== null && y(h.divIdx, h.offset, I.offset), p(L)) : y(h.divIdx, h.offset, L.offset), L.divIdx === P.divIdx)
        re = y(L.divIdx, L.offset, P.offset, "highlight" + W);
      else {
        re = y(L.divIdx, L.offset, I.offset, "highlight begin" + W);
        for (let ce = L.divIdx + 1, te = P.divIdx; ce < te; ce++)
          o[ce].className = "highlight middle" + W;
        p(P, "highlight end" + W);
      }
      h = P, z && i.scrollMatchIntoView({
        element: o[L.divIdx],
        selectedLeft: re,
        pageIndex: n,
        matchIndex: l
      });
    }
    h && y(h.divIdx, h.offset, I.offset);
  }
  _updateMatches(t = !1) {
    if (!this.enabled && !t)
      return;
    const {
      findController: i,
      matches: n,
      pageIdx: s
    } = this, {
      textContentItemsStr: o,
      textDivs: r
    } = this;
    let l = -1;
    for (const I of n) {
      const p = Math.max(l, I.begin.divIdx);
      for (let y = p, m = I.end.divIdx; y <= m; y++) {
        const A = r[y];
        A.textContent = o[y], A.className = "";
      }
      l = I.end.divIdx + 1;
    }
    if (!(i != null && i.highlightMatches) || t)
      return;
    const c = i.pageMatches[s] || null, h = i.pageMatchesLength[s] || null;
    this.matches = this._convertMatches(c, h), this._renderMatches(this.matches);
  }
}
cP = new WeakMap();
var xte, Pte, RF, qb, Ig, hP, aae, Fve, JW, Hve, Gve;
const ox = class ox {
  constructor({
    pdfPage: t,
    highlighter: i = null,
    accessibilityManager: n = null,
    enablePermissions: s = !1,
    onAppend: o = null
  }) {
    xe(this, aae);
    xe(this, xte, !1);
    xe(this, Pte, null);
    xe(this, RF, !1);
    xe(this, qb, null);
    this.pdfPage = t, this.highlighter = i, this.accessibilityManager = n, be(this, xte, s === !0), be(this, Pte, o), this.div = document.createElement("div"), this.div.tabIndex = 0, this.div.className = "textLayer";
  }
  async render({
    viewport: t,
    textContentParams: i = null
  }) {
    var r, l, c, h, I;
    if (S(this, RF) && S(this, qb)) {
      S(this, qb).update({
        viewport: t,
        onBefore: this.hide.bind(this)
      }), this.show();
      return;
    }
    this.cancel(), be(this, qb, new gPe({
      textContentSource: this.pdfPage.streamTextContent(i || {
        includeMarkedContent: !0,
        disableNormalization: !0
      }),
      container: this.div,
      viewport: t
    }));
    const {
      textDivs: n,
      textContentItemsStr: s
    } = S(this, qb);
    (r = this.highlighter) == null || r.setTextMapping(n, s), (l = this.accessibilityManager) == null || l.setTextMapping(n), await S(this, qb).render(), be(this, RF, !0);
    const o = document.createElement("div");
    o.className = "endOfContent", this.div.append(o), _e(this, aae, Fve).call(this, o), (c = S(this, Pte)) == null || c.call(this, this.div), (h = this.highlighter) == null || h.enable(), (I = this.accessibilityManager) == null || I.enable();
  }
  hide() {
    var t;
    !this.div.hidden && S(this, RF) && ((t = this.highlighter) == null || t.disable(), this.div.hidden = !0);
  }
  show() {
    var t;
    this.div.hidden && S(this, RF) && (this.div.hidden = !1, (t = this.highlighter) == null || t.enable());
  }
  cancel() {
    var t, i, n, s;
    (t = S(this, qb)) == null || t.cancel(), be(this, qb, null), (i = this.highlighter) == null || i.disable(), (n = this.accessibilityManager) == null || n.disable(), _e(s = ox, JW, Hve).call(s, this.div);
  }
};
xte = new WeakMap(), Pte = new WeakMap(), RF = new WeakMap(), qb = new WeakMap(), Ig = new WeakMap(), hP = new WeakMap(), aae = new WeakSet(), Fve = function(t) {
  var n;
  const {
    div: i
  } = this;
  i.addEventListener("mousedown", () => {
    i.classList.add("selecting");
  }), i.addEventListener("copy", (s) => {
    if (!S(this, xte)) {
      const o = document.getSelection();
      s.clipboardData.setData("text/plain", TJ(EPe(o.toString())));
    }
    Tfe(s);
  }), S(ox, Ig).set(i, t), _e(n = ox, JW, Gve).call(n);
}, JW = new WeakSet(), Hve = function(t) {
  var i;
  S(this, Ig).delete(t), S(this, Ig).size === 0 && ((i = S(this, hP)) == null || i.abort(), be(this, hP, null));
}, Gve = function() {
  if (S(this, hP))
    return;
  be(this, hP, new AbortController());
  const {
    signal: t
  } = S(this, hP), i = (r, l) => {
    l.append(r), r.style.width = "", r.style.height = "", l.classList.remove("selecting");
  };
  let n = !1;
  document.addEventListener("pointerdown", () => {
    n = !0;
  }, {
    signal: t
  }), document.addEventListener("pointerup", () => {
    n = !1, S(this, Ig).forEach(i);
  }, {
    signal: t
  }), window.addEventListener("blur", () => {
    n = !1, S(this, Ig).forEach(i);
  }, {
    signal: t
  }), document.addEventListener("keyup", () => {
    n || S(this, Ig).forEach(i);
  }, {
    signal: t
  });
  var s, o;
  document.addEventListener("selectionchange", () => {
    var m;
    const r = document.getSelection();
    if (r.rangeCount === 0) {
      S(this, Ig).forEach(i);
      return;
    }
    const l = /* @__PURE__ */ new Set();
    for (let A = 0; A < r.rangeCount; A++) {
      const C = r.getRangeAt(A);
      for (const O of S(this, Ig).keys())
        !l.has(O) && C.intersectsNode(O) && l.add(O);
    }
    for (const [A, C] of S(this, Ig))
      l.has(A) ? A.classList.add("selecting") : i(C, A);
    if (s ?? (s = getComputedStyle(S(this, Ig).values().next().value).getPropertyValue("-moz-user-select") === "none"), s)
      return;
    const c = r.getRangeAt(0), h = o && (c.compareBoundaryPoints(Range.END_TO_END, o) === 0 || c.compareBoundaryPoints(Range.START_TO_END, o) === 0);
    let I = h ? c.startContainer : c.endContainer;
    if (I.nodeType === Node.TEXT_NODE && (I = I.parentNode), !h && c.endOffset === 0)
      do {
        for (; !I.previousSibling; )
          I = I.parentNode;
        I = I.previousSibling;
      } while (!I.childNodes.length);
    const p = (m = I.parentElement) == null ? void 0 : m.closest(".textLayer"), y = S(this, Ig).get(p);
    y && (y.style.width = p.style.width, y.style.height = p.style.height, I.parentElement.insertBefore(y, h ? I : I.nextSibling)), o = c.cloneRange();
  }, {
    signal: t
  });
}, xe(ox, JW), xe(ox, Ig, /* @__PURE__ */ new Map()), xe(ox, hP, null);
let fle = ox;
class kve {
  constructor({
    pdfPage: t,
    annotationStorage: i = null,
    linkService: n,
    xfaHtml: s = null
  }) {
    this.pdfPage = t, this.annotationStorage = i, this.linkService = n, this.xfaHtml = s, this.div = null, this._cancelled = !1;
  }
  async render({
    viewport: t,
    intent: i = "display"
  }) {
    if (i === "print") {
      const o = {
        viewport: t.clone({
          dontFlip: !0
        }),
        div: this.div,
        xfaHtml: this.xfaHtml,
        annotationStorage: this.annotationStorage,
        linkService: this.linkService,
        intent: i
      };
      return this.div = document.createElement("div"), o.div = this.div, dde.render(o);
    }
    const n = await this.pdfPage.getXfa();
    if (this._cancelled || !n)
      return {
        textDivs: []
      };
    const s = {
      viewport: t.clone({
        dontFlip: !0
      }),
      div: this.div,
      xfaHtml: n,
      annotationStorage: this.annotationStorage,
      linkService: this.linkService,
      intent: i
    };
    return this.div ? dde.update(s) : (this.div = document.createElement("div"), s.div = this.div, dde.render(s));
  }
  cancel() {
    this._cancelled = !0;
  }
  hide() {
    this.div && (this.div.hidden = !0);
  }
}
const dMe = {
  annotationEditorUIManager: null,
  annotationStorage: null,
  downloadManager: null,
  enableScripting: !1,
  fieldObjectsPromise: null,
  findController: null,
  hasJSActionsPromise: null,
  get linkService() {
    return new Bpe();
  }
}, cMe = /* @__PURE__ */ new Map([["canvasWrapper", 0], ["textLayer", 1], ["annotationLayer", 2], ["annotationEditorLayer", 3], ["xfaLayer", 3]]);
var vF, fP, Mte, Ute, Bte, IP, pP, oW, Fte, Hte, Gte, rW, kte, cO, mP, bo, NV, _oe, RQ, Yfe, qfe, $fe, Kfe, Zfe, zve, jve, Wve, Qfe;
class Vve extends Pve {
  constructor(i) {
    var r, l;
    super(i);
    xe(this, bo);
    xe(this, vF, mO.ENABLE_FORMS);
    xe(this, fP, null);
    xe(this, Mte, !0);
    xe(this, Ute, !1);
    xe(this, Bte, !1);
    xe(this, IP, null);
    xe(this, pP, !1);
    xe(this, oW, null);
    xe(this, Fte, null);
    xe(this, Hte, 1);
    xe(this, Gte, 1);
    xe(this, rW, Zb.ENABLE);
    xe(this, kte, 1);
    xe(this, cO, {
      directDrawing: !0,
      initialOptionalContent: !0,
      regularAnnotations: !0
    });
    xe(this, mP, [null, null, null, null]);
    const n = i.container, s = i.defaultViewport;
    this.renderingId = "page" + this.id, be(this, IP, i.layerProperties || dMe), this.pdfPage = null, this.pageLabel = null, this.rotation = 0, this.scale = i.scale || ave, this.viewport = s, this.pdfPageRotate = s.rotation, this._optionalContentConfigPromise = i.optionalContentConfigPromise || null, be(this, rW, i.textLayerMode ?? Zb.ENABLE), be(this, vF, i.annotationMode ?? mO.ENABLE_FORMS), this.imageResourcesPath = i.imageResourcesPath || "", this.enableDetailCanvas = i.enableDetailCanvas ?? !0, this.maxCanvasPixels = i.maxCanvasPixels ?? RJ.get("maxCanvasPixels"), this.maxCanvasDim = i.maxCanvasDim || RJ.get("maxCanvasDim"), this.capCanvasAreaFactor = i.capCanvasAreaFactor ?? RJ.get("capCanvasAreaFactor"), be(this, Mte, i.enableAutoLinking !== !1), this.l10n = i.l10n, this.l10n || (this.l10n = new NW()), this._isStandalone = !((r = this.renderingQueue) != null && r.hasViewer()), this._container = n, this._annotationCanvasMap = null, this.annotationLayer = null, this.annotationEditorLayer = null, this.textLayer = null, this.xfaLayer = null, this.structTreeLayer = null, this.drawLayer = null, this.detailView = null;
    const o = document.createElement("div");
    if (o.className = "page", o.setAttribute("data-page-number", this.id), o.setAttribute("role", "region"), o.setAttribute("data-l10n-id", "pdfjs-page-landmark"), o.setAttribute("data-l10n-args", JSON.stringify({
      page: this.id
    })), this.div = o, _e(this, bo, _oe).call(this), n == null || n.append(o), this._isStandalone) {
      n == null || n.style.setProperty("--scale-factor", this.scale * NC.PDF_TO_CSS_UNITS), (l = this.pageColors) != null && l.background && (n == null || n.style.setProperty("--page-bg-color", this.pageColors.background));
      const {
        optionalContentConfigPromise: c
      } = i;
      c && c.then((h) => {
        c === this._optionalContentConfigPromise && (S(this, cO).initialOptionalContent = h.hasInitialVisibility);
      }), i.l10n || this.l10n.translate(this.div);
    }
  }
  setPdfPage(i) {
    var s, o, r, l;
    this._isStandalone && (((s = this.pageColors) == null ? void 0 : s.foreground) === "CanvasText" || ((o = this.pageColors) == null ? void 0 : o.background) === "Canvas") && ((r = this._container) == null || r.style.setProperty("--hcm-highlight-filter", i.filterFactory.addHighlightHCMFilter("highlight", "CanvasText", "Canvas", "HighlightText", "Highlight")), (l = this._container) == null || l.style.setProperty("--hcm-highlight-selected-filter", i.filterFactory.addHighlightHCMFilter("highlight_selected", "CanvasText", "Canvas", "HighlightText", "Highlight"))), this.pdfPage = i, this.pdfPageRotate = i.rotate;
    const n = (this.rotation + this.pdfPageRotate) % 360;
    this.viewport = i.getViewport({
      scale: this.scale * NC.PDF_TO_CSS_UNITS,
      rotation: n
    }), _e(this, bo, _oe).call(this), this.reset();
  }
  destroy() {
    var i;
    this.reset(), (i = this.pdfPage) == null || i.cleanup();
  }
  hasEditableAnnotations() {
    var i;
    return !!((i = this.annotationLayer) != null && i.hasEditableAnnotations());
  }
  get _textHighlighter() {
    return hle(this, "_textHighlighter", new uMe({
      pageIndex: this.id - 1,
      eventBus: this.eventBus,
      findController: S(this, IP).findController
    }));
  }
  _resetCanvas() {
    super._resetCanvas(), be(this, oW, null);
  }
  reset({
    keepAnnotationLayer: i = !1,
    keepAnnotationEditorLayer: n = !1,
    keepXfaLayer: s = !1,
    keepTextLayer: o = !1,
    keepCanvasWrapper: r = !1,
    preserveDetailViewState: l = !1
  } = {}) {
    var C, O, R, F, L, P;
    this.cancelRendering({
      keepAnnotationLayer: i,
      keepAnnotationEditorLayer: n,
      keepXfaLayer: s,
      keepTextLayer: o
    }), this.renderingState = ll.INITIAL;
    const c = this.div, h = c.childNodes, I = i && ((C = this.annotationLayer) == null ? void 0 : C.div) || null, p = n && ((O = this.annotationEditorLayer) == null ? void 0 : O.div) || null, y = s && ((R = this.xfaLayer) == null ? void 0 : R.div) || null, m = o && ((F = this.textLayer) == null ? void 0 : F.div) || null, A = r && S(this, fP) || null;
    for (let z = h.length - 1; z >= 0; z--) {
      const W = h[z];
      switch (W) {
        case I:
        case p:
        case y:
        case m:
        case A:
          continue;
      }
      W.remove();
      const re = S(this, mP).indexOf(W);
      re >= 0 && (S(this, mP)[re] = null);
    }
    c.removeAttribute("data-loaded"), I && this.annotationLayer.hide(), p && this.annotationEditorLayer.hide(), y && this.xfaLayer.hide(), m && this.textLayer.hide(), (L = this.structTreeLayer) == null || L.hide(), !r && S(this, fP) && (be(this, fP, null), this._resetCanvas()), l || ((P = this.detailView) == null || P.reset({
      keepCanvas: r
    }), r || (this.detailView = null));
  }
  toggleEditingMode(i) {
    be(this, Bte, i), this.hasEditableAnnotations() && this.reset({
      keepAnnotationLayer: !0,
      keepAnnotationEditorLayer: !0,
      keepXfaLayer: !0,
      keepTextLayer: !0,
      keepCanvasWrapper: !0
    });
  }
  updateVisibleArea(i) {
    this.enableDetailCanvas && (S(this, pP) && this.maxCanvasPixels > 0 && i ? (this.detailView ?? (this.detailView = new lMe({
      pageView: this
    })), this.detailView.update({
      visibleArea: i
    })) : this.detailView && (this.detailView.reset(), this.detailView = null));
  }
  update({
    scale: i = 0,
    rotation: n = null,
    optionalContentConfigPromise: s = null,
    drawingDelay: o = -1
  }) {
    var l, c, h;
    this.scale = i || this.scale, typeof n == "number" && (this.rotation = n), s instanceof Promise && (this._optionalContentConfigPromise = s, s.then((I) => {
      s === this._optionalContentConfigPromise && (S(this, cO).initialOptionalContent = I.hasInitialVisibility);
    })), S(this, cO).directDrawing = !0;
    const r = (this.rotation + this.pdfPageRotate) % 360;
    if (this.viewport = this.viewport.clone({
      scale: this.scale * NC.PDF_TO_CSS_UNITS,
      rotation: r
    }), _e(this, bo, _oe).call(this), this._isStandalone && ((l = this._container) == null || l.style.setProperty("--scale-factor", this.viewport.scale)), _e(this, bo, Qfe).call(this), this.canvas) {
      const I = S(this, Ute) && S(this, pP), p = o >= 0 && o < 1e3;
      if (p || I) {
        p && !I && this.renderingState !== ll.FINISHED && (this.cancelRendering({
          keepAnnotationLayer: !0,
          keepAnnotationEditorLayer: !0,
          keepXfaLayer: !0,
          keepTextLayer: !0,
          cancelExtraDelay: o
        }), this.renderingState = ll.FINISHED, S(this, cO).directDrawing = !1), this.cssTransform({
          redrawAnnotationLayer: !0,
          redrawAnnotationEditorLayer: !0,
          redrawXfaLayer: !0,
          redrawTextLayer: !p,
          hideTextLayer: p
        }), p || ((c = this.detailView) == null || c.update({
          underlyingViewUpdated: !0
        }), this.dispatchPageRendered(!0, !1));
        return;
      }
    }
    this.cssTransform({}), this.reset({
      keepAnnotationLayer: !0,
      keepAnnotationEditorLayer: !0,
      keepXfaLayer: !0,
      keepTextLayer: !0,
      keepCanvasWrapper: !0,
      preserveDetailViewState: !0
    }), (h = this.detailView) == null || h.update({
      underlyingViewUpdated: !0
    });
  }
  cancelRendering({
    keepAnnotationLayer: i = !1,
    keepAnnotationEditorLayer: n = !1,
    keepXfaLayer: s = !1,
    keepTextLayer: o = !1,
    cancelExtraDelay: r = 0
  } = {}) {
    var l;
    super.cancelRendering({
      cancelExtraDelay: r
    }), this.textLayer && (!o || !this.textLayer.div) && (this.textLayer.cancel(), this.textLayer = null), this.annotationLayer && (!i || !this.annotationLayer.div) && (this.annotationLayer.cancel(), this.annotationLayer = null, this._annotationCanvasMap = null), this.structTreeLayer && !this.textLayer && (this.structTreeLayer = null), this.annotationEditorLayer && (!n || !this.annotationEditorLayer.div) && (this.drawLayer && (this.drawLayer.cancel(), this.drawLayer = null), this.annotationEditorLayer.cancel(), this.annotationEditorLayer = null), this.xfaLayer && (!s || !this.xfaLayer.div) && (this.xfaLayer.cancel(), this.xfaLayer = null, (l = this._textHighlighter) == null || l.disable());
  }
  cssTransform({
    redrawAnnotationLayer: i = !1,
    redrawAnnotationEditorLayer: n = !1,
    redrawXfaLayer: s = !1,
    redrawTextLayer: o = !1,
    hideTextLayer: r = !1
  }) {
    var h;
    const {
      canvas: l
    } = this;
    if (!l)
      return;
    const c = S(this, oW);
    if (this.viewport !== c) {
      const I = (360 + this.viewport.rotation - c.rotation) % 360;
      if (I === 90 || I === 270) {
        const {
          width: p,
          height: y
        } = this.viewport, m = y / p, A = p / y;
        l.style.transform = `rotate(${I}deg) scale(${m},${A})`;
      } else
        l.style.transform = I === 0 ? "" : `rotate(${I}deg)`;
    }
    i && this.annotationLayer && _e(this, bo, Yfe).call(this), n && this.annotationEditorLayer && (this.drawLayer && _e(this, bo, $fe).call(this), _e(this, bo, qfe).call(this)), s && this.xfaLayer && _e(this, bo, Kfe).call(this), this.textLayer && (r ? (this.textLayer.hide(), (h = this.structTreeLayer) == null || h.hide()) : o && _e(this, bo, Zfe).call(this));
  }
  get width() {
    return this.viewport.width;
  }
  get height() {
    return this.viewport.height;
  }
  getPagePoint(i, n) {
    return this.viewport.convertToPdfPoint(i, n);
  }
  _ensureCanvasWrapper() {
    let i = S(this, fP);
    return i || (i = be(this, fP, document.createElement("div")), i.classList.add("canvasWrapper"), _e(this, bo, NV).call(this, i, "canvasWrapper")), i;
  }
  _getRenderingContext(i, n) {
    return {
      canvas: i,
      transform: n,
      viewport: this.viewport,
      annotationMode: S(this, vF),
      optionalContentConfigPromise: this._optionalContentConfigPromise,
      annotationCanvasMap: this._annotationCanvasMap,
      pageColors: this.pageColors,
      isEditing: S(this, Bte)
    };
  }
  async draw() {
    this.renderingState !== ll.INITIAL && (console.error("Must be in new state before drawing"), this.reset());
    const {
      div: i,
      l10n: n,
      pdfPage: s,
      viewport: o
    } = this;
    if (!s)
      throw this.renderingState = ll.FINISHED, new Error("pdfPage is not loaded");
    this.renderingState = ll.RUNNING;
    const r = this._ensureCanvasWrapper();
    if (!this.textLayer && S(this, rW) !== Zb.DISABLE && !s.isPureXfa && (this._accessibilityManager || (this._accessibilityManager = new jfe()), this.textLayer = new fle({
      pdfPage: s,
      highlighter: this._textHighlighter,
      accessibilityManager: this._accessibilityManager,
      enablePermissions: S(this, rW) === Zb.ENABLE_PERMISSIONS,
      onAppend: (P) => {
        this.l10n.pause(), _e(this, bo, NV).call(this, P, "textLayer"), this.l10n.resume();
      }
    })), !this.annotationLayer && S(this, vF) !== mO.DISABLE) {
      const {
        annotationStorage: P,
        annotationEditorUIManager: z,
        downloadManager: W,
        enableScripting: re,
        fieldObjectsPromise: ce,
        hasJSActionsPromise: te,
        linkService: ee
      } = S(this, IP);
      this._annotationCanvasMap || (this._annotationCanvasMap = /* @__PURE__ */ new Map()), this.annotationLayer = new gve({
        pdfPage: s,
        annotationStorage: P,
        imageResourcesPath: this.imageResourcesPath,
        renderForms: S(this, vF) === mO.ENABLE_FORMS,
        linkService: ee,
        downloadManager: W,
        enableScripting: re,
        hasJSActionsPromise: te,
        fieldObjectsPromise: ce,
        annotationCanvasMap: this._annotationCanvasMap,
        accessibilityManager: this._accessibilityManager,
        annotationEditorUIManager: z,
        onAppend: (Ne) => {
          _e(this, bo, NV).call(this, Ne, "annotationLayer");
        }
      });
    }
    const {
      width: l,
      height: c
    } = o;
    be(this, oW, o);
    const {
      canvas: h,
      prevCanvas: I
    } = this._createCanvas((P) => {
      r.prepend(P);
    });
    h.setAttribute("role", "presentation"), this.outputScale || _e(this, bo, Qfe).call(this);
    const {
      outputScale: p
    } = this;
    be(this, Ute, S(this, pP));
    const y = aEe(p.sx), m = aEe(p.sy), A = h.width = gne(wne(l * p.sx), y[0]), C = h.height = gne(wne(c * p.sy), m[0]), O = gne(wne(l), y[1]), R = gne(wne(c), m[1]);
    p.sx = A / O, p.sy = C / R, S(this, Hte) !== y[1] && (i.style.setProperty("--scale-round-x", `${y[1]}px`), be(this, Hte, y[1])), S(this, Gte) !== m[1] && (i.style.setProperty("--scale-round-y", `${m[1]}px`), be(this, Gte, m[1]));
    const F = p.scaled ? [p.sx, 0, 0, p.sy, 0, 0] : null, L = this._drawCanvas(this._getRenderingContext(h, F), () => {
      I == null || I.remove(), this._resetCanvas();
    }, (P) => {
      S(this, cO).regularAnnotations = !P.separateAnnots, this.dispatchPageRendered(!1, !1);
    }).then(async () => {
      var W;
      this.structTreeLayer || (this.structTreeLayer = new Uve(s, o.rawDims));
      const P = _e(this, bo, Zfe).call(this);
      this.annotationLayer && (await _e(this, bo, Yfe).call(this), S(this, Mte) && this.annotationLayer && this.textLayer && await _e(this, bo, Wve).call(this, P));
      const {
        annotationEditorUIManager: z
      } = S(this, IP);
      z && (this.drawLayer || (this.drawLayer = new rMe({
        pageIndex: this.id
      })), await _e(this, bo, $fe).call(this), this.drawLayer.setParent(r), this.annotationEditorLayer || (this.annotationEditorLayer = new nMe({
        uiManager: z,
        pdfPage: s,
        l10n: n,
        structTreeLayer: this.structTreeLayer,
        accessibilityManager: this._accessibilityManager,
        annotationLayer: (W = this.annotationLayer) == null ? void 0 : W.annotationLayer,
        textLayer: this.textLayer,
        drawLayer: this.drawLayer.getDrawLayer(),
        onAppend: (re) => {
          _e(this, bo, NV).call(this, re, "annotationEditorLayer");
        }
      })), _e(this, bo, qfe).call(this));
    });
    if (s.isPureXfa) {
      if (!this.xfaLayer) {
        const {
          annotationStorage: P,
          linkService: z
        } = S(this, IP);
        this.xfaLayer = new kve({
          pdfPage: s,
          annotationStorage: P,
          linkService: z
        });
      }
      _e(this, bo, Kfe).call(this);
    }
    return i.setAttribute("data-loaded", !0), this.dispatchPageRender(), L;
  }
  setPageLabel(i) {
    this.pageLabel = typeof i == "string" ? i : null, this.div.setAttribute("data-l10n-args", JSON.stringify({
      page: this.pageLabel ?? this.id
    })), this.pageLabel !== null ? this.div.setAttribute("data-page-label", this.pageLabel) : this.div.removeAttribute("data-page-label");
  }
  get thumbnailCanvas() {
    const {
      directDrawing: i,
      initialOptionalContent: n,
      regularAnnotations: s
    } = S(this, cO);
    return i && n && s ? this.canvas : null;
  }
}
vF = new WeakMap(), fP = new WeakMap(), Mte = new WeakMap(), Ute = new WeakMap(), Bte = new WeakMap(), IP = new WeakMap(), pP = new WeakMap(), oW = new WeakMap(), Fte = new WeakMap(), Hte = new WeakMap(), Gte = new WeakMap(), rW = new WeakMap(), kte = new WeakMap(), cO = new WeakMap(), mP = new WeakMap(), bo = new WeakSet(), NV = function(i, n) {
  const s = cMe.get(n), o = S(this, mP)[s];
  if (S(this, mP)[s] = i, o) {
    o.replaceWith(i);
    return;
  }
  for (let r = s - 1; r >= 0; r--) {
    const l = S(this, mP)[r];
    if (l) {
      l.after(i);
      return;
    }
  }
  this.div.prepend(i);
}, _oe = function() {
  const {
    div: i,
    viewport: n
  } = this;
  if (n.userUnit !== S(this, kte) && (n.userUnit !== 1 ? i.style.setProperty("--user-unit", n.userUnit) : i.style.removeProperty("--user-unit"), be(this, kte, n.userUnit)), this.pdfPage) {
    if (S(this, Fte) === n.rotation)
      return;
    be(this, Fte, n.rotation);
  }
  lve(i, n, !0, !1);
}, RQ = function(i, n) {
  this.eventBus.dispatch(i, {
    source: this,
    pageNumber: this.id,
    error: n
  });
}, Yfe = async function() {
  let i = null;
  try {
    await this.annotationLayer.render({
      viewport: this.viewport,
      intent: "display",
      structTreeLayer: this.structTreeLayer
    });
  } catch (n) {
    console.error("#renderAnnotationLayer:", n), i = n;
  } finally {
    _e(this, bo, RQ).call(this, "annotationlayerrendered", i);
  }
}, qfe = async function() {
  let i = null;
  try {
    await this.annotationEditorLayer.render({
      viewport: this.viewport,
      intent: "display"
    });
  } catch (n) {
    console.error("#renderAnnotationEditorLayer:", n), i = n;
  } finally {
    _e(this, bo, RQ).call(this, "annotationeditorlayerrendered", i);
  }
}, $fe = async function() {
  try {
    await this.drawLayer.render({
      intent: "display"
    });
  } catch (i) {
    console.error("#renderDrawLayer:", i);
  }
}, Kfe = async function() {
  var n;
  let i = null;
  try {
    const s = await this.xfaLayer.render({
      viewport: this.viewport,
      intent: "display"
    });
    s != null && s.textDivs && this._textHighlighter && _e(this, bo, jve).call(this, s.textDivs);
  } catch (s) {
    console.error("#renderXfaLayer:", s), i = s;
  } finally {
    (n = this.xfaLayer) != null && n.div && (this.l10n.pause(), _e(this, bo, NV).call(this, this.xfaLayer.div, "xfaLayer"), this.l10n.resume()), _e(this, bo, RQ).call(this, "xfalayerrendered", i);
  }
}, Zfe = async function() {
  if (!this.textLayer)
    return;
  let i = null;
  try {
    await this.textLayer.render({
      viewport: this.viewport
    });
  } catch (n) {
    if (n instanceof uPe)
      return;
    console.error("#renderTextLayer:", n), i = n;
  }
  _e(this, bo, RQ).call(this, "textlayerrendered", i), _e(this, bo, zve).call(this);
}, zve = async function() {
  var n, s, o;
  if (!this.textLayer)
    return;
  const i = await ((n = this.structTreeLayer) == null ? void 0 : n.render());
  i && (this.l10n.pause(), (s = this.structTreeLayer) == null || s.addElementsToTextLayer(), this.canvas && i.parentNode !== this.canvas && this.canvas.append(i), this.l10n.resume()), (o = this.structTreeLayer) == null || o.show();
}, jve = async function(i) {
  const n = await this.pdfPage.getTextContent(), s = [];
  for (const o of n.items)
    s.push(o.str);
  this._textHighlighter.setTextMapping(i, s), this._textHighlighter.enable();
}, Wve = async function(i) {
  try {
    if (await i, !this.annotationLayer)
      return;
    await this.annotationLayer.injectLinkAnnotations({
      inferredLinks: Gfe.processLinks(this),
      viewport: this.viewport,
      structTreeLayer: this.structTreeLayer
    });
  } catch (n) {
    console.error("#injectLinkAnnotations:", n);
  }
}, Qfe = function() {
  const {
    width: i,
    height: n
  } = this.viewport, s = this.outputScale = new Aoe();
  if (this.maxCanvasPixels === 0) {
    const o = 1 / this.scale;
    s.sx *= o, s.sy *= o, be(this, pP, !0);
  } else
    be(this, pP, s.limitCanvas(i, n, this.maxCanvasPixels, this.maxCanvasDim, this.capCanvasAreaFactor));
};
async function hMe(e) {
  const {
    info: n,
    metadata: s,
    contentDispositionFilename: o,
    contentLength: r
  } = await e.getMetadata();
  return {
    ...n,
    baseURL: "",
    filesize: r || (await e.getDownloadInfo()).length,
    filename: o || pPe(""),
    metadata: s == null ? void 0 : s.getRaw(),
    authors: s == null ? void 0 : s.get("dc:creator"),
    numPages: e.numPages,
    URL: ""
  };
}
class fMe {
  constructor(t) {
    this._ready = new Promise((i, n) => {
      import(
        /*webpackIgnore: true*/
        /*@vite-ignore*/
        t
      ).then((o) => {
        i(o.QuickJSSandbox());
      }).catch(n);
    });
  }
  async createSandbox(t) {
    (await this._ready).create(t);
  }
  async dispatchEventInSandbox(t) {
    const i = await this._ready;
    setTimeout(() => i.dispatchEvent(t), 0);
  }
  async destroySandbox() {
    (await this._ready).nukeSandbox();
  }
}
var $b, AF, Vte, SF, bF, zte, My, hO, lW, zh, n5, SI, Yve, xoe, Jfe, qve, vQ;
class IMe {
  constructor({
    eventBus: t,
    externalServices: i = null,
    docProperties: n = null
  }) {
    xe(this, SI);
    xe(this, $b, null);
    xe(this, AF, null);
    xe(this, Vte, null);
    xe(this, SF, null);
    xe(this, bF, null);
    xe(this, zte, null);
    xe(this, My, null);
    xe(this, hO, null);
    xe(this, lW, !1);
    xe(this, zh, null);
    xe(this, n5, null);
    be(this, bF, t), be(this, zte, i), be(this, Vte, n);
  }
  setViewer(t) {
    be(this, hO, t);
  }
  async setDocument(t) {
    var l;
    if (S(this, My) && await _e(this, SI, vQ).call(this), be(this, My, t), !t)
      return;
    const [i, n, s] = await Promise.all([t.getFieldObjects(), t.getCalculationOrderIds(), t.getJSActions()]);
    if (!i && !s) {
      await _e(this, SI, vQ).call(this);
      return;
    }
    if (t !== S(this, My))
      return;
    try {
      be(this, zh, _e(this, SI, qve).call(this));
    } catch (c) {
      console.error("setDocument:", c), await _e(this, SI, vQ).call(this);
      return;
    }
    const o = S(this, bF);
    be(this, SF, new AbortController());
    const {
      signal: r
    } = S(this, SF);
    o._on("updatefromsandbox", (c) => {
      (c == null ? void 0 : c.source) === window && _e(this, SI, Yve).call(this, c.detail);
    }, {
      signal: r
    }), o._on("dispatcheventinsandbox", (c) => {
      var h;
      (h = S(this, zh)) == null || h.dispatchEventInSandbox(c.detail);
    }, {
      signal: r
    }), o._on("pagechanging", ({
      pageNumber: c,
      previous: h
    }) => {
      c !== h && (_e(this, SI, Jfe).call(this, h), _e(this, SI, xoe).call(this, c));
    }, {
      signal: r
    }), o._on("pagerendered", ({
      pageNumber: c
    }) => {
      this._pageOpenPending.has(c) && c === S(this, hO).currentPageNumber && _e(this, SI, xoe).call(this, c);
    }, {
      signal: r
    }), o._on("pagesdestroy", async () => {
      var c, h;
      await _e(this, SI, Jfe).call(this, S(this, hO).currentPageNumber), await ((c = S(this, zh)) == null ? void 0 : c.dispatchEventInSandbox({
        id: "doc",
        name: "WillClose"
      })), (h = S(this, $b)) == null || h.resolve();
    }, {
      signal: r
    });
    try {
      const c = await S(this, Vte).call(this, t);
      if (t !== S(this, My))
        return;
      await S(this, zh).createSandbox({
        objects: i,
        calculationOrder: n,
        appInfo: {
          platform: navigator.platform,
          language: navigator.language
        },
        docInfo: {
          ...c,
          actions: s
        }
      }), o.dispatch("sandboxcreated", {
        source: this
      });
    } catch (c) {
      console.error("setDocument:", c), await _e(this, SI, vQ).call(this);
      return;
    }
    await ((l = S(this, zh)) == null ? void 0 : l.dispatchEventInSandbox({
      id: "doc",
      name: "Open"
    })), await _e(this, SI, xoe).call(this, S(this, hO).currentPageNumber, !0), Promise.resolve().then(() => {
      t === S(this, My) && be(this, lW, !0);
    });
  }
  async dispatchWillSave() {
    var t;
    return (t = S(this, zh)) == null ? void 0 : t.dispatchEventInSandbox({
      id: "doc",
      name: "WillSave"
    });
  }
  async dispatchDidSave() {
    var t;
    return (t = S(this, zh)) == null ? void 0 : t.dispatchEventInSandbox({
      id: "doc",
      name: "DidSave"
    });
  }
  async dispatchWillPrint() {
    var t;
    if (S(this, zh)) {
      await ((t = S(this, n5)) == null ? void 0 : t.promise), be(this, n5, Promise.withResolvers());
      try {
        await S(this, zh).dispatchEventInSandbox({
          id: "doc",
          name: "WillPrint"
        });
      } catch (i) {
        throw S(this, n5).resolve(), be(this, n5, null), i;
      }
      await S(this, n5).promise;
    }
  }
  async dispatchDidPrint() {
    var t;
    return (t = S(this, zh)) == null ? void 0 : t.dispatchEventInSandbox({
      id: "doc",
      name: "DidPrint"
    });
  }
  get destroyPromise() {
    var t;
    return ((t = S(this, AF)) == null ? void 0 : t.promise) || null;
  }
  get ready() {
    return S(this, lW);
  }
  get _pageOpenPending() {
    return hle(this, "_pageOpenPending", /* @__PURE__ */ new Set());
  }
  get _visitedPages() {
    return hle(this, "_visitedPages", /* @__PURE__ */ new Map());
  }
}
$b = new WeakMap(), AF = new WeakMap(), Vte = new WeakMap(), SF = new WeakMap(), bF = new WeakMap(), zte = new WeakMap(), My = new WeakMap(), hO = new WeakMap(), lW = new WeakMap(), zh = new WeakMap(), n5 = new WeakMap(), SI = new WeakSet(), Yve = async function(t) {
  var h, I;
  const i = S(this, hO), n = i.isInPresentationMode || i.isChangingPresentationMode, {
    id: s,
    siblings: o,
    command: r,
    value: l
  } = t;
  if (!s) {
    switch (r) {
      case "clear":
        console.clear();
        break;
      case "error":
        console.error(l);
        break;
      case "layout":
        if (!n) {
          const p = _Pe(l);
          i.spreadMode = p.spreadMode;
        }
        break;
      case "page-num":
        i.currentPageNumber = l + 1;
        break;
      case "print":
        await i.pagesPromise, S(this, bF).dispatch("print", {
          source: this
        });
        break;
      case "println":
        console.log(l);
        break;
      case "zoom":
        n || (i.currentScaleValue = l);
        break;
      case "SaveAs":
        S(this, bF).dispatch("download", {
          source: this
        });
        break;
      case "FirstPage":
        i.currentPageNumber = 1;
        break;
      case "LastPage":
        i.currentPageNumber = i.pagesCount;
        break;
      case "NextPage":
        i.nextPage();
        break;
      case "PrevPage":
        i.previousPage();
        break;
      case "ZoomViewIn":
        n || i.increaseScale();
        break;
      case "ZoomViewOut":
        n || i.decreaseScale();
        break;
      case "WillPrintFinished":
        (h = S(this, n5)) == null || h.resolve(), be(this, n5, null);
        break;
    }
    return;
  }
  if (n && t.focus)
    return;
  delete t.id, delete t.siblings;
  const c = o ? [s, ...o] : [s];
  for (const p of c) {
    const y = document.querySelector(`[data-element-id="${p}"]`);
    y ? y.dispatchEvent(new CustomEvent("updatefromsandbox", {
      detail: t
    })) : (I = S(this, My)) == null || I.annotationStorage.setValue(p, t);
  }
}, xoe = async function(t, i = !1) {
  const n = S(this, My), s = this._visitedPages;
  if (i && be(this, $b, Promise.withResolvers()), !S(this, $b))
    return;
  const o = S(this, hO).getPageView(t - 1);
  if ((o == null ? void 0 : o.renderingState) !== ll.FINISHED) {
    this._pageOpenPending.add(t);
    return;
  }
  this._pageOpenPending.delete(t);
  const r = (async () => {
    var c, h;
    const l = await (s.has(t) ? null : (c = o.pdfPage) == null ? void 0 : c.getJSActions());
    n === S(this, My) && await ((h = S(this, zh)) == null ? void 0 : h.dispatchEventInSandbox({
      id: "page",
      name: "PageOpen",
      pageNumber: t,
      actions: l
    }));
  })();
  s.set(t, r);
}, Jfe = async function(t) {
  var o;
  const i = S(this, My), n = this._visitedPages;
  if (!S(this, $b) || this._pageOpenPending.has(t))
    return;
  const s = n.get(t);
  s && (n.set(t, null), await s, i === S(this, My) && await ((o = S(this, zh)) == null ? void 0 : o.dispatchEventInSandbox({
    id: "page",
    name: "PageClose",
    pageNumber: t
  })));
}, qve = function() {
  if (be(this, AF, Promise.withResolvers()), S(this, zh))
    throw new Error("#initScripting: Scripting already exists.");
  return S(this, zte).createScripting();
}, vQ = async function() {
  var t, i, n, s;
  if (!S(this, zh)) {
    be(this, My, null), (t = S(this, AF)) == null || t.resolve();
    return;
  }
  S(this, $b) && (await Promise.race([S(this, $b).promise, new Promise((o) => {
    setTimeout(o, 1e3);
  })]).catch(() => {
  }), be(this, $b, null)), be(this, My, null);
  try {
    await S(this, zh).destroySandbox();
  } catch {
  }
  (i = S(this, n5)) == null || i.reject(new Error("Scripting destroyed.")), be(this, n5, null), (n = S(this, SF)) == null || n.abort(), be(this, SF, null), this._pageOpenPending.clear(), this._visitedPages.clear(), be(this, zh, null), be(this, lW, !1), (s = S(this, AF)) == null || s.resolve();
};
class pMe extends IMe {
  constructor(t) {
    t.externalServices || window.addEventListener("updatefromsandbox", (i) => {
      t.eventBus.dispatch("updatefromsandbox", {
        source: window,
        detail: i.detail
      });
    }), t.externalServices || (t.externalServices = {
      createScripting: () => new fMe(t.sandboxBundleSrc)
    }), t.docProperties || (t.docProperties = (i) => hMe(i)), super(t);
  }
}
const mMe = 3e4;
class yMe {
  constructor() {
    this.pdfViewer = null, this.pdfThumbnailViewer = null, this.onIdle = null, this.highestPriorityPage = null, this.idleTimeout = null, this.printing = !1, this.isThumbnailViewEnabled = !1, Object.defineProperty(this, "hasViewer", {
      value: () => !!this.pdfViewer
    });
  }
  setViewer(t) {
    this.pdfViewer = t;
  }
  setThumbnailViewer(t) {
    this.pdfThumbnailViewer = t;
  }
  isHighestPriority(t) {
    return this.highestPriorityPage === t.renderingId;
  }
  renderHighestPriority(t) {
    var i;
    this.idleTimeout && (clearTimeout(this.idleTimeout), this.idleTimeout = null), !this.pdfViewer.forceRendering(t) && (this.isThumbnailViewEnabled && ((i = this.pdfThumbnailViewer) != null && i.forceRendering()) || this.printing || this.onIdle && (this.idleTimeout = setTimeout(this.onIdle.bind(this), mMe)));
  }
  getHighestPriority(t, i, n, s = !1, o = !1) {
    const r = t.views, l = r.length;
    if (l === 0)
      return null;
    for (let y = 0; y < l; y++) {
      const m = r[y].view;
      if (!this.isViewFinished(m))
        return m;
    }
    if (!o)
      for (let y = 0; y < l; y++) {
        const {
          detailView: m
        } = r[y].view;
        if (m && !this.isViewFinished(m))
          return m;
      }
    const c = t.first.id, h = t.last.id;
    if (h - c + 1 > l) {
      const y = t.ids;
      for (let m = 1, A = h - c; m < A; m++) {
        const C = n ? c + m : h - m;
        if (y.has(C))
          continue;
        const O = i[C - 1];
        if (!this.isViewFinished(O))
          return O;
      }
    }
    let I = n ? h : c - 2, p = i[I];
    return p && !this.isViewFinished(p) || s && (I += n ? 1 : -1, p = i[I], p && !this.isViewFinished(p)) ? p : null;
  }
  isViewFinished(t) {
    return t.renderingState === ll.FINISHED;
  }
  renderView(t) {
    switch (t.renderingState) {
      case ll.FINISHED:
        return !1;
      case ll.PAUSED:
        this.highestPriorityPage = t.renderingId, t.resume();
        break;
      case ll.RUNNING:
        this.highestPriorityPage = t.renderingId;
        break;
      case ll.INITIAL:
        this.highestPriorityPage = t.renderingId, t.draw().finally(() => {
          this.renderHighestPriority();
        }).catch((i) => {
          i instanceof wfe || console.error("renderView:", i);
        });
        break;
    }
    return !0;
  }
}
const PEe = 10, vne = {
  FORCE_SCROLL_MODE_PAGE: 1e4,
  FORCE_LAZY_PAGE_INIT: 5e3,
  PAUSE_EAGER_PAGE_INIT: 250
};
function MEe(e) {
  return Object.values(e2).includes(e) && e !== e2.DISABLE;
}
var fO, NF, jte, Xfe;
class EMe {
  constructor(t) {
    xe(this, jte);
    xe(this, fO, /* @__PURE__ */ new Set());
    xe(this, NF, 0);
    be(this, NF, t);
  }
  push(t) {
    const i = S(this, fO);
    i.has(t) && i.delete(t), i.add(t), i.size > S(this, NF) && _e(this, jte, Xfe).call(this);
  }
  resize(t, i = null) {
    be(this, NF, t);
    const n = S(this, fO);
    if (i) {
      const s = n.size;
      let o = 1;
      for (const r of n)
        if (i.has(r.id) && (n.delete(r), n.add(r)), ++o > s)
          break;
    }
    for (; n.size > S(this, NF); )
      _e(this, jte, Xfe).call(this);
  }
  has(t) {
    return S(this, fO).has(t);
  }
  [Symbol.iterator]() {
    return S(this, fO).keys();
  }
}
fO = new WeakMap(), NF = new WeakMap(), jte = new WeakSet(), Xfe = function() {
  const t = S(this, fO).keys().next().value;
  t == null || t.destroy(), S(this, fO).delete(t);
};
var IO, Wte, Yte, Nv, E2, DF, qte, $te, Kte, Zte, Qte, Jte, Xte, eie, tie, yP, iie, aW, Dv, CF, OF, uW, EP, dW, nie, cW, LF, pO, hW, sie, fW, oie, ps, Kve, Zve, Qve, AQ, Poe, Jve, e1e, Xve, T_, t1e, eAe, tAe, iAe, i1e, nAe, n1e, Moe, s1e;
class $ve {
  constructor(t) {
    xe(this, ps);
    xe(this, IO, null);
    xe(this, Wte, null);
    xe(this, Yte, null);
    xe(this, Nv, e2.NONE);
    xe(this, E2, null);
    xe(this, DF, mO.ENABLE_FORMS);
    xe(this, qte, null);
    xe(this, $te, null);
    xe(this, Kte, null);
    xe(this, Zte, !1);
    xe(this, Qte, !1);
    xe(this, Jte, !1);
    xe(this, Xte, !1);
    xe(this, eie, !1);
    xe(this, tie, !0);
    xe(this, yP, null);
    xe(this, iie, 0);
    xe(this, aW, null);
    xe(this, Dv, null);
    xe(this, CF, null);
    xe(this, OF, null);
    xe(this, uW, !1);
    xe(this, EP, null);
    xe(this, dW, !1);
    xe(this, nie, 0);
    xe(this, cW, new ResizeObserver(_e(this, ps, nAe).bind(this)));
    xe(this, LF, null);
    xe(this, pO, null);
    xe(this, hW, null);
    xe(this, sie, !0);
    xe(this, fW, Zb.ENABLE);
    xe(this, oie, null);
    var s, o;
    const i = "5.4.54";
    if (nEe !== i)
      throw new Error(`The API version "${nEe}" does not match the Viewer version "${i}".`);
    if (this.container = t.container, this.viewer = t.viewer || t.container.firstElementChild, be(this, oie, t.viewerAlert || null), ((s = this.container) == null ? void 0 : s.tagName) !== "DIV" || ((o = this.viewer) == null ? void 0 : o.tagName) !== "DIV")
      throw new Error("Invalid `container` and/or `viewer` option.");
    if (this.container.offsetParent && getComputedStyle(this.container).position !== "absolute")
      throw new Error("The `container` must be absolutely positioned.");
    S(this, cW).observe(this.container), this.eventBus = t.eventBus, this.linkService = t.linkService || new Bpe(), this.downloadManager = t.downloadManager || null, this.findController = t.findController || null, be(this, Wte, t.altTextManager || null), be(this, qte, t.commentManager || null), be(this, hW, t.signatureManager || null), be(this, Kte, t.editorUndoBar || null), this.findController && (this.findController.onIsPageVisible = (r) => this._getVisiblePages().ids.has(r)), this._scriptingManager = t.scriptingManager || null, be(this, fW, t.textLayerMode ?? Zb.ENABLE), be(this, DF, t.annotationMode ?? mO.ENABLE_FORMS), be(this, Nv, t.annotationEditorMode ?? e2.NONE), be(this, Yte, t.annotationEditorHighlightColors || null), be(this, Qte, t.enableHighlightFloatingButton === !0), be(this, Xte, t.enableUpdatedAddImage === !0), be(this, eie, t.enableNewAltTextWhenAddingImage === !0), this.imageResourcesPath = t.imageResourcesPath || "", this.enablePrintAutoRotate = t.enablePrintAutoRotate || !1, this.removePageBorders = t.removePageBorders || !1, this.maxCanvasPixels = t.maxCanvasPixels, this.maxCanvasDim = t.maxCanvasDim, this.capCanvasAreaFactor = t.capCanvasAreaFactor, this.enableDetailCanvas = t.enableDetailCanvas ?? !0, this.l10n = t.l10n, this.l10n || (this.l10n = new NW()), be(this, Jte, t.enablePermissions || !1), this.pageColors = t.pageColors || null, be(this, aW, t.mlManager || null), be(this, Zte, t.enableHWA || !1), be(this, sie, t.supportsPinchToZoom !== !1), be(this, tie, t.enableAutoLinking !== !1), be(this, iie, t.minDurationToUpdateCanvas ?? 500), this.defaultRenderingQueue = !t.renderingQueue, this.defaultRenderingQueue ? (this.renderingQueue = new yMe(), this.renderingQueue.setViewer(this)) : this.renderingQueue = t.renderingQueue;
    const {
      abortSignal: n
    } = t;
    n == null || n.addEventListener("abort", () => {
      S(this, cW).disconnect(), be(this, cW, null);
    }, {
      once: !0
    }), this.scroll = SPe(this.container, this._scrollUpdate.bind(this), n), this.presentationModeState = vz.UNKNOWN, this._resetView(), this.removePageBorders && this.viewer.classList.add("removePageBorders"), _e(this, ps, i1e).call(this), this.eventBus._on("thumbnailrendered", ({
      pageNumber: r,
      pdfPage: l
    }) => {
      const c = this._pages[r - 1];
      S(this, IO).has(c) || l == null || l.cleanup();
    }), t.l10n || this.l10n.translate(this.container);
  }
  get pagesCount() {
    return this._pages.length;
  }
  getPageView(t) {
    return this._pages[t];
  }
  getCachedPageViews() {
    return new Set(S(this, IO));
  }
  get pageViewsReady() {
    return this._pages.every((t) => t == null ? void 0 : t.pdfPage);
  }
  get renderForms() {
    return S(this, DF) === mO.ENABLE_FORMS;
  }
  get enableScripting() {
    return !!this._scriptingManager;
  }
  get currentPageNumber() {
    return this._currentPageNumber;
  }
  set currentPageNumber(t) {
    if (!Number.isInteger(t))
      throw new Error("Invalid page number.");
    this.pdfDocument && (this._setCurrentPageNumber(t, !0) || console.error(`currentPageNumber: "${t}" is not a valid page.`));
  }
  _setCurrentPageNumber(t, i = !1) {
    var s;
    if (this._currentPageNumber === t)
      return i && _e(this, ps, t1e).call(this), !0;
    if (!(0 < t && t <= this.pagesCount))
      return !1;
    const n = this._currentPageNumber;
    return this._currentPageNumber = t, this.eventBus.dispatch("pagechanging", {
      source: this,
      pageNumber: t,
      pageLabel: ((s = this._pageLabels) == null ? void 0 : s[t - 1]) ?? null,
      previous: n
    }), i && _e(this, ps, t1e).call(this), !0;
  }
  get currentPageLabel() {
    var t;
    return ((t = this._pageLabels) == null ? void 0 : t[this._currentPageNumber - 1]) ?? null;
  }
  set currentPageLabel(t) {
    if (!this.pdfDocument)
      return;
    let i = t | 0;
    if (this._pageLabels) {
      const n = this._pageLabels.indexOf(t);
      n >= 0 && (i = n + 1);
    }
    this._setCurrentPageNumber(i, !0) || console.error(`currentPageLabel: "${t}" is not a valid page.`);
  }
  get currentScale() {
    return this._currentScale !== cde ? this._currentScale : ave;
  }
  set currentScale(t) {
    if (isNaN(t))
      throw new Error("Invalid numeric scale.");
    this.pdfDocument && _e(this, ps, T_).call(this, t, {
      noScroll: !1
    });
  }
  get currentScaleValue() {
    return this._currentScaleValue;
  }
  set currentScaleValue(t) {
    this.pdfDocument && _e(this, ps, T_).call(this, t, {
      noScroll: !1
    });
  }
  get pagesRotation() {
    return this._pagesRotation;
  }
  set pagesRotation(t) {
    if (!dve(t))
      throw new Error("Invalid pages rotation angle.");
    if (!this.pdfDocument || (t %= 360, t < 0 && (t += 360), this._pagesRotation === t))
      return;
    this._pagesRotation = t;
    const i = this._currentPageNumber;
    this.refresh(!0, {
      rotation: t
    }), this._currentScaleValue && _e(this, ps, T_).call(this, this._currentScaleValue, {
      noScroll: !0
    }), this.eventBus.dispatch("rotationchanging", {
      source: this,
      pagesRotation: t,
      pageNumber: i
    }), this.defaultRenderingQueue && this.update();
  }
  get firstPagePromise() {
    return this.pdfDocument ? this._firstPageCapability.promise : null;
  }
  get onePageRendered() {
    return this.pdfDocument ? this._onePageRenderedCapability.promise : null;
  }
  get pagesPromise() {
    return this.pdfDocument ? this._pagesCapability.promise : null;
  }
  get _layerProperties() {
    const t = this;
    return hle(this, "_layerProperties", {
      get annotationEditorUIManager() {
        return S(t, E2);
      },
      get annotationStorage() {
        var i;
        return (i = t.pdfDocument) == null ? void 0 : i.annotationStorage;
      },
      get downloadManager() {
        return t.downloadManager;
      },
      get enableScripting() {
        return !!t._scriptingManager;
      },
      get fieldObjectsPromise() {
        var i;
        return (i = t.pdfDocument) == null ? void 0 : i.getFieldObjects();
      },
      get findController() {
        return t.findController;
      },
      get hasJSActionsPromise() {
        var i;
        return (i = t.pdfDocument) == null ? void 0 : i.hasJSActions();
      },
      get linkService() {
        return t.linkService;
      }
    });
  }
  async getAllText() {
    const t = [], i = [];
    for (let n = 1, s = this.pdfDocument.numPages; n <= s; ++n) {
      if (S(this, dW))
        return null;
      i.length = 0;
      const o = await this.pdfDocument.getPage(n), {
        items: r
      } = await o.getTextContent();
      for (const l of r)
        l.str && i.push(l.str), l.hasEOL && i.push(`
`);
      t.push(TJ(i.join("")));
    }
    return t.join(`
`);
  }
  setDocument(t) {
    var y, m, A;
    if (this.pdfDocument && (this.eventBus.dispatch("pagesdestroy", {
      source: this
    }), this._cancelRendering(), this._resetView(), (y = this.findController) == null || y.setDocument(null), (m = this._scriptingManager) == null || m.setDocument(null), (A = S(this, E2)) == null || A.destroy(), be(this, E2, null)), this.pdfDocument = t, !t)
      return;
    const i = t.numPages, n = t.getPage(1), s = t.getOptionalContentConfig({
      intent: "display"
    }), o = S(this, Jte) ? t.getPermissions() : Promise.resolve(), {
      eventBus: r,
      pageColors: l,
      viewer: c
    } = this;
    be(this, yP, new AbortController());
    const {
      signal: h
    } = S(this, yP);
    if (i > vne.FORCE_SCROLL_MODE_PAGE) {
      console.warn("Forcing PAGE-scrolling for performance reasons, given the length of the document.");
      const C = this._scrollMode = Rr.PAGE;
      r.dispatch("scrollmodechanged", {
        source: this,
        mode: C
      });
    }
    this._pagesCapability.promise.then(() => {
      r.dispatch("pagesloaded", {
        source: this,
        pagesCount: i
      });
    }, () => {
    });
    const I = (C) => {
      const O = this._pages[C.pageNumber - 1];
      O && S(this, IO).push(O);
    };
    r._on("pagerender", I, {
      signal: h
    });
    const p = (C) => {
      C.cssTransform || C.isDetailView || (this._onePageRenderedCapability.resolve({
        timestamp: C.timestamp
      }), r._off("pagerendered", p));
    };
    r._on("pagerendered", p, {
      signal: h
    }), Promise.all([n, o]).then(([C, O]) => {
      var re;
      if (t !== this.pdfDocument)
        return;
      this._firstPageCapability.resolve(C), this._optionalContentConfigPromise = s;
      const {
        annotationEditorMode: R,
        annotationMode: F,
        textLayerMode: L
      } = _e(this, ps, Kve).call(this, O);
      if (L !== Zb.DISABLE) {
        const ce = be(this, EP, document.createElement("div"));
        ce.id = "hiddenCopyElement", c.before(ce);
      }
      if (R !== e2.DISABLE) {
        const ce = R;
        t.isPureXfa ? console.warn("Warning: XFA-editing is not implemented.") : MEe(ce) ? (be(this, E2, new cPe(this.container, c, S(this, oie), S(this, Wte), S(this, qte), S(this, hW), r, t, l, S(this, Yte), S(this, Qte), S(this, Xte), S(this, eie), S(this, aW), S(this, Kte), S(this, sie))), r.dispatch("annotationeditoruimanager", {
          source: this,
          uiManager: S(this, E2)
        }), ce !== e2.NONE && (_e(this, ps, s1e).call(this, ce), S(this, E2).updateMode(ce))) : console.error(`Invalid AnnotationEditor mode: ${ce}`);
      }
      const P = this._scrollMode === Rr.PAGE ? null : c, z = this.currentScale, W = C.getViewport({
        scale: z * NC.PDF_TO_CSS_UNITS
      });
      c.style.setProperty("--scale-factor", W.scale), l != null && l.background && c.style.setProperty("--page-bg-color", l.background), ((l == null ? void 0 : l.foreground) === "CanvasText" || (l == null ? void 0 : l.background) === "Canvas") && (c.style.setProperty("--hcm-highlight-filter", t.filterFactory.addHighlightHCMFilter("highlight", "CanvasText", "Canvas", "HighlightText", "Highlight")), c.style.setProperty("--hcm-highlight-selected-filter", t.filterFactory.addHighlightHCMFilter("highlight_selected", "CanvasText", "Canvas", "HighlightText", "ButtonText")));
      for (let ce = 1; ce <= i; ++ce) {
        const te = new Vve({
          container: P,
          eventBus: r,
          id: ce,
          scale: z,
          defaultViewport: W.clone(),
          optionalContentConfigPromise: s,
          renderingQueue: this.renderingQueue,
          textLayerMode: L,
          annotationMode: F,
          imageResourcesPath: this.imageResourcesPath,
          maxCanvasPixels: this.maxCanvasPixels,
          maxCanvasDim: this.maxCanvasDim,
          capCanvasAreaFactor: this.capCanvasAreaFactor,
          enableDetailCanvas: this.enableDetailCanvas,
          pageColors: l,
          l10n: this.l10n,
          layerProperties: this._layerProperties,
          enableHWA: S(this, Zte),
          enableAutoLinking: S(this, tie),
          minDurationToUpdateCanvas: S(this, iie)
        });
        this._pages.push(te);
      }
      (re = this._pages[0]) == null || re.setPdfPage(C), this._scrollMode === Rr.PAGE ? _e(this, ps, AQ).call(this) : this._spreadMode !== Bm.NONE && this._updateSpreadMode(), _e(this, ps, Zve).call(this, h).then(async () => {
        var te, ee;
        if (t !== this.pdfDocument)
          return;
        if ((te = this.findController) == null || te.setDocument(t), (ee = this._scriptingManager) == null || ee.setDocument(t), S(this, EP) && document.addEventListener("copy", _e(this, ps, Qve).bind(this, L), {
          signal: h
        }), S(this, E2) && r.dispatch("annotationeditormodechanged", {
          source: this,
          mode: S(this, Nv)
        }), t.loadingParams.disableAutoFetch || i > vne.FORCE_LAZY_PAGE_INIT) {
          this._pagesCapability.resolve();
          return;
        }
        let ce = i - 1;
        if (ce <= 0) {
          this._pagesCapability.resolve();
          return;
        }
        for (let Ne = 2; Ne <= i; ++Ne) {
          const Ae = t.getPage(Ne).then((Oe) => {
            const pe = this._pages[Ne - 1];
            pe.pdfPage || pe.setPdfPage(Oe), --ce === 0 && this._pagesCapability.resolve();
          }, (Oe) => {
            console.error(`Unable to get page ${Ne} to initialize viewer`, Oe), --ce === 0 && this._pagesCapability.resolve();
          });
          Ne % vne.PAUSE_EAGER_PAGE_INIT === 0 && await Ae;
        }
      }), r.dispatch("pagesinit", {
        source: this
      }), t.getMetadata().then(({
        info: ce
      }) => {
        t === this.pdfDocument && ce.Language && (c.lang = ce.Language);
      }), this.defaultRenderingQueue && this.update();
    }).catch((C) => {
      console.error("Unable to initialize viewer", C), this._pagesCapability.reject(C);
    });
  }
  setPageLabels(t) {
    var i;
    if (this.pdfDocument) {
      t ? Array.isArray(t) && this.pdfDocument.numPages === t.length ? this._pageLabels = t : (this._pageLabels = null, console.error("setPageLabels: Invalid page labels.")) : this._pageLabels = null;
      for (let n = 0, s = this._pages.length; n < s; n++)
        this._pages[n].setPageLabel(((i = this._pageLabels) == null ? void 0 : i[n]) ?? null);
    }
  }
  _resetView() {
    var t, i;
    this._pages = [], this._currentPageNumber = 1, this._currentScale = cde, this._currentScaleValue = null, this._pageLabels = null, be(this, IO, new EMe(PEe)), this._location = null, this._pagesRotation = 0, this._optionalContentConfigPromise = null, this._firstPageCapability = Promise.withResolvers(), this._onePageRenderedCapability = Promise.withResolvers(), this._pagesCapability = Promise.withResolvers(), this._scrollMode = Rr.VERTICAL, this._previousScrollMode = Rr.UNKNOWN, this._spreadMode = Bm.NONE, be(this, LF, {
      previousPageNumber: 1,
      scrollDown: !0,
      pages: []
    }), (t = S(this, yP)) == null || t.abort(), be(this, yP, null), this.viewer.textContent = "", this._updateScrollMode(), this.viewer.removeAttribute("lang"), (i = S(this, EP)) == null || i.remove(), be(this, EP, null), _e(this, ps, n1e).call(this), _e(this, ps, Moe).call(this);
  }
  _scrollUpdate() {
    this.pagesCount !== 0 && (S(this, Dv) && clearTimeout(S(this, Dv)), be(this, Dv, setTimeout(() => {
      be(this, Dv, null), this.update();
    }, 100)), this.update());
  }
  pageLabelToPageNumber(t) {
    if (!this._pageLabels)
      return null;
    const i = this._pageLabels.indexOf(t);
    return i < 0 ? null : i + 1;
  }
  scrollPageIntoView({
    pageNumber: t,
    destArray: i = null,
    allowNegativeOffset: n = !1,
    ignoreDestinationZoom: s = !1
  }) {
    if (!this.pdfDocument)
      return;
    const o = Number.isInteger(t) && this._pages[t - 1];
    if (!o) {
      console.error(`scrollPageIntoView: "${t}" is not a valid pageNumber parameter.`);
      return;
    }
    if (this.isInPresentationMode || !i) {
      this._setCurrentPageNumber(t, !0);
      return;
    }
    let r = 0, l = 0, c = 0, h = 0, I, p;
    const y = o.rotation % 180 !== 0, m = (y ? o.height : o.width) / o.scale / NC.PDF_TO_CSS_UNITS, A = (y ? o.width : o.height) / o.scale / NC.PDF_TO_CSS_UNITS;
    let C = 0;
    switch (i[1].name) {
      case "XYZ":
        r = i[2], l = i[3], C = i[4], r = r !== null ? r : 0, l = l !== null ? l : A;
        break;
      case "Fit":
      case "FitB":
        C = "page-fit";
        break;
      case "FitH":
      case "FitBH":
        l = i[2], C = "page-width", l === null && this._location ? (r = this._location.left, l = this._location.top) : (typeof l != "number" || l < 0) && (l = A);
        break;
      case "FitV":
      case "FitBV":
        r = i[2], c = m, h = A, C = "page-height";
        break;
      case "FitR":
        r = i[2], l = i[3], c = i[4] - r, h = i[5] - l;
        let L = oEe, P = rEe;
        this.removePageBorders && (L = P = 0), I = (this.container.clientWidth - L) / c / NC.PDF_TO_CSS_UNITS, p = (this.container.clientHeight - P) / h / NC.PDF_TO_CSS_UNITS, C = Math.min(Math.abs(I), Math.abs(p));
        break;
      default:
        console.error(`scrollPageIntoView: "${i[1].name}" is not a valid destination type.`);
        return;
    }
    if (s || (C && C !== this._currentScale ? this.currentScaleValue = C : this._currentScale === cde && (this.currentScaleValue = TPe)), C === "page-fit" && !i[4]) {
      _e(this, ps, Poe).call(this, o);
      return;
    }
    const O = [o.viewport.convertToViewportPoint(r, l), o.viewport.convertToViewportPoint(r + c, l + h)];
    let R = Math.min(O[0][0], O[1][0]), F = Math.min(O[0][1], O[1][1]);
    n || (R = Math.max(R, 0), F = Math.max(F, 0)), _e(this, ps, Poe).call(this, o, {
      left: R,
      top: F
    });
  }
  _updateLocation(t) {
    const i = this._currentScale, n = this._currentScaleValue, s = parseFloat(n) === i ? Math.round(i * 1e4) / 100 : n, o = t.id, r = this._pages[o - 1], l = this.container, c = r.getPagePoint(l.scrollLeft - t.x, l.scrollTop - t.y), h = Math.round(c[0]), I = Math.round(c[1]);
    let p = `#page=${o}`;
    this.isInPresentationMode || (p += `&zoom=${s},${h},${I}`), this._location = {
      pageNumber: o,
      scale: s,
      top: I,
      left: h,
      rotation: this._pagesRotation,
      pdfOpenParams: p
    };
  }
  update() {
    const t = this._getVisiblePages(), i = t.views, n = i.length;
    if (n === 0)
      return;
    const s = Math.max(PEe, 2 * n + 1);
    S(this, IO).resize(s, t.ids);
    for (const {
      view: c,
      visibleArea: h
    } of i)
      c.updateVisibleArea(h);
    for (const c of S(this, IO))
      t.ids.has(c.id) || c.updateVisibleArea(null);
    this.renderingQueue.renderHighestPriority(t);
    const o = this._spreadMode === Bm.NONE && (this._scrollMode === Rr.PAGE || this._scrollMode === Rr.VERTICAL), r = this._currentPageNumber;
    let l = !1;
    for (const c of i) {
      if (c.percent < 100)
        break;
      if (c.id === r && o) {
        l = !0;
        break;
      }
    }
    this._setCurrentPageNumber(l ? r : i[0].id), this._updateLocation(t.first), this.eventBus.dispatch("updateviewarea", {
      source: this,
      location: this._location
    });
  }
  containsElement(t) {
    return this.container.contains(t);
  }
  focus() {
    this.container.focus();
  }
  get _isContainerRtl() {
    return getComputedStyle(this.container).direction === "rtl";
  }
  get isInPresentationMode() {
    return this.presentationModeState === vz.FULLSCREEN;
  }
  get isChangingPresentationMode() {
    return this.presentationModeState === vz.CHANGING;
  }
  get isHorizontalScrollbarEnabled() {
    return this.isInPresentationMode ? !1 : this.container.scrollWidth > this.container.clientWidth;
  }
  get isVerticalScrollbarEnabled() {
    return this.isInPresentationMode ? !1 : this.container.scrollHeight > this.container.clientHeight;
  }
  _getVisiblePages() {
    const t = this._scrollMode === Rr.PAGE ? S(this, LF).pages : this._pages, i = this._scrollMode === Rr.HORIZONTAL, n = i && this._isContainerRtl;
    return NPe({
      scrollEl: this.container,
      views: t,
      sortByVisibility: !0,
      horizontal: i,
      rtl: n
    });
  }
  cleanup() {
    for (const t of this._pages)
      t.renderingState !== ll.FINISHED && t.reset();
  }
  _cancelRendering() {
    for (const t of this._pages)
      t.cancelRendering();
  }
  forceRendering(t) {
    const i = t || this._getVisiblePages(), n = _e(this, ps, iAe).call(this, i), s = this._spreadMode !== Bm.NONE && this._scrollMode !== Rr.HORIZONTAL, o = S(this, pO) !== null || S(this, Dv) !== null && i.views.some((l) => {
      var c;
      return (c = l.detailView) == null ? void 0 : c.renderingCancelled;
    }), r = this.renderingQueue.getHighestPriority(i, this._pages, n, s, o);
    return r ? (_e(this, ps, tAe).call(this, r).then(() => {
      this.renderingQueue.renderView(r);
    }), !0) : !1;
  }
  get hasEqualPageSizes() {
    const t = this._pages[0];
    for (let i = 1, n = this._pages.length; i < n; ++i) {
      const s = this._pages[i];
      if (s.width !== t.width || s.height !== t.height)
        return !1;
    }
    return !0;
  }
  getPagesOverview() {
    let t;
    return this._pages.map((i) => {
      const n = i.pdfPage.getViewport({
        scale: 1
      }), s = uEe(n);
      if (t === void 0)
        t = s;
      else if (this.enablePrintAutoRotate && s !== t)
        return {
          width: n.height,
          height: n.width,
          rotation: (n.rotation - 90) % 360
        };
      return {
        width: n.width,
        height: n.height,
        rotation: n.rotation
      };
    });
  }
  get optionalContentConfigPromise() {
    return this.pdfDocument ? this._optionalContentConfigPromise ? this._optionalContentConfigPromise : (console.error("optionalContentConfigPromise: Not initialized yet."), this.pdfDocument.getOptionalContentConfig({
      intent: "display"
    })) : Promise.resolve(null);
  }
  set optionalContentConfigPromise(t) {
    if (!(t instanceof Promise))
      throw new Error(`Invalid optionalContentConfigPromise: ${t}`);
    this.pdfDocument && this._optionalContentConfigPromise && (this._optionalContentConfigPromise = t, this.refresh(!1, {
      optionalContentConfigPromise: t
    }), this.eventBus.dispatch("optionalcontentconfigchanged", {
      source: this,
      promise: t
    }));
  }
  get scrollMode() {
    return this._scrollMode;
  }
  set scrollMode(t) {
    if (this._scrollMode !== t) {
      if (!DPe(t))
        throw new Error(`Invalid scroll mode: ${t}`);
      this.pagesCount > vne.FORCE_SCROLL_MODE_PAGE || (this._previousScrollMode = this._scrollMode, this._scrollMode = t, this.eventBus.dispatch("scrollmodechanged", {
        source: this,
        mode: t
      }), this._updateScrollMode(this._currentPageNumber));
    }
  }
  _updateScrollMode(t = null) {
    const i = this._scrollMode, n = this.viewer;
    n.classList.toggle("scrollHorizontal", i === Rr.HORIZONTAL), n.classList.toggle("scrollWrapped", i === Rr.WRAPPED), !(!this.pdfDocument || !t) && (i === Rr.PAGE ? _e(this, ps, AQ).call(this) : this._previousScrollMode === Rr.PAGE && this._updateSpreadMode(), this._currentScaleValue && isNaN(this._currentScaleValue) && _e(this, ps, T_).call(this, this._currentScaleValue, {
      noScroll: !0
    }), this._setCurrentPageNumber(t, !0), this.update());
  }
  get spreadMode() {
    return this._spreadMode;
  }
  set spreadMode(t) {
    if (this._spreadMode !== t) {
      if (!CPe(t))
        throw new Error(`Invalid spread mode: ${t}`);
      this._spreadMode = t, this.eventBus.dispatch("spreadmodechanged", {
        source: this,
        mode: t
      }), this._updateSpreadMode(this._currentPageNumber);
    }
  }
  _updateSpreadMode(t = null) {
    if (!this.pdfDocument)
      return;
    const i = this.viewer, n = this._pages;
    if (this._scrollMode === Rr.PAGE)
      _e(this, ps, AQ).call(this);
    else if (i.textContent = "", this._spreadMode === Bm.NONE)
      for (const s of this._pages)
        i.append(s.div);
    else {
      const s = this._spreadMode - 1;
      let o = null;
      for (let r = 0, l = n.length; r < l; ++r)
        o === null ? (o = document.createElement("div"), o.className = "spread", i.append(o)) : r % 2 === s && (o = o.cloneNode(!1), i.append(o)), o.append(n[r].div);
    }
    t && (this._currentScaleValue && isNaN(this._currentScaleValue) && _e(this, ps, T_).call(this, this._currentScaleValue, {
      noScroll: !0
    }), this._setCurrentPageNumber(t, !0), this.update());
  }
  _getPageAdvance(t, i = !1) {
    switch (this._scrollMode) {
      case Rr.WRAPPED: {
        const {
          views: n
        } = this._getVisiblePages(), s = /* @__PURE__ */ new Map();
        for (const {
          id: o,
          y: r,
          percent: l,
          widthPercent: c
        } of n) {
          if (l === 0 || c < 100)
            continue;
          let h = s.get(r);
          h || s.set(r, h || (h = [])), h.push(o);
        }
        for (const o of s.values()) {
          const r = o.indexOf(t);
          if (r === -1)
            continue;
          const l = o.length;
          if (l === 1)
            break;
          if (i)
            for (let c = r - 1, h = 0; c >= h; c--) {
              const I = o[c], p = o[c + 1] - 1;
              if (I < p)
                return t - p;
            }
          else
            for (let c = r + 1, h = l; c < h; c++) {
              const I = o[c], p = o[c - 1] + 1;
              if (I > p)
                return p - t;
            }
          if (i) {
            const c = o[0];
            if (c < t)
              return t - c + 1;
          } else {
            const c = o[l - 1];
            if (c > t)
              return c - t + 1;
          }
          break;
        }
        break;
      }
      case Rr.HORIZONTAL:
        break;
      case Rr.PAGE:
      case Rr.VERTICAL: {
        if (this._spreadMode === Bm.NONE)
          break;
        const n = this._spreadMode - 1;
        if (i && t % 2 !== n)
          break;
        if (!i && t % 2 === n)
          break;
        const {
          views: s
        } = this._getVisiblePages(), o = i ? t - 1 : t + 1;
        for (const {
          id: r,
          percent: l,
          widthPercent: c
        } of s)
          if (r === o) {
            if (l > 0 && c === 100)
              return 2;
            break;
          }
        break;
      }
    }
    return 1;
  }
  nextPage() {
    const t = this._currentPageNumber, i = this.pagesCount;
    if (t >= i)
      return !1;
    const n = this._getPageAdvance(t, !1) || 1;
    return this.currentPageNumber = Math.min(t + n, i), !0;
  }
  previousPage() {
    const t = this._currentPageNumber;
    if (t <= 1)
      return !1;
    const i = this._getPageAdvance(t, !0) || 1;
    return this.currentPageNumber = Math.max(t - i, 1), !0;
  }
  updateScale({
    drawingDelay: t,
    scaleFactor: i = null,
    steps: n = null,
    origin: s
  }) {
    if (n === null && i === null)
      throw new Error("Invalid updateScale options: either `steps` or `scaleFactor` must be provided.");
    if (!this.pdfDocument)
      return;
    let o = this._currentScale;
    if (i > 0 && i !== 1)
      o = Math.round(o * i * 100) / 100;
    else if (n) {
      const r = n > 0 ? sEe : 1 / sEe, l = n > 0 ? Math.ceil : Math.floor;
      n = Math.abs(n);
      do
        o = l((o * r).toFixed(2) * 10) / 10;
      while (--n > 0);
    }
    o = rve(o, RPe, vPe), _e(this, ps, T_).call(this, o, {
      noScroll: !1,
      drawingDelay: t,
      origin: s
    });
  }
  increaseScale(t = {}) {
    this.updateScale({
      ...t,
      steps: t.steps ?? 1
    });
  }
  decreaseScale(t = {}) {
    this.updateScale({
      ...t,
      steps: -(t.steps ?? 1)
    });
  }
  get containerTopLeft() {
    return S(this, $te) || be(this, $te, [this.container.offsetTop, this.container.offsetLeft]);
  }
  get annotationEditorMode() {
    return S(this, E2) ? S(this, Nv) : e2.DISABLE;
  }
  set annotationEditorMode({
    mode: t,
    editId: i = null,
    isFromKeyboard: n = !1,
    mustEnterInEditMode: s = !1,
    editComment: o = !1
  }) {
    if (!S(this, E2))
      throw new Error("The AnnotationEditor is not enabled.");
    if (S(this, Nv) === t)
      return;
    if (!MEe(t))
      throw new Error(`Invalid AnnotationEditor mode: ${t}`);
    if (!this.pdfDocument)
      return;
    _e(this, ps, s1e).call(this, t);
    const {
      eventBus: r,
      pdfDocument: l
    } = this, c = async () => {
      _e(this, ps, Moe).call(this), be(this, Nv, t), await S(this, E2).updateMode(t, i, n, s, o), !(t !== S(this, Nv) || l !== this.pdfDocument) && r.dispatch("annotationeditormodechanged", {
        source: this,
        mode: t
      });
    };
    if (t === e2.NONE || S(this, Nv) === e2.NONE) {
      const h = t !== e2.NONE;
      h || this.pdfDocument.annotationStorage.resetModifiedIds();
      for (const p of this._pages)
        p.toggleEditingMode(h);
      const I = _e(this, ps, eAe).call(this);
      if (h && I) {
        _e(this, ps, Moe).call(this), be(this, CF, new AbortController());
        const p = AbortSignal.any([S(this, yP).signal, S(this, CF).signal]);
        r._on("pagerendered", ({
          pageNumber: y
        }) => {
          I.delete(y), I.size === 0 && be(this, OF, setTimeout(c, 0));
        }, {
          signal: p
        });
        return;
      }
    }
    c();
  }
  refresh(t = !1, i = /* @__PURE__ */ Object.create(null)) {
    if (this.pdfDocument) {
      for (const n of this._pages)
        n.update(i);
      _e(this, ps, n1e).call(this), t || this.update();
    }
  }
}
IO = new WeakMap(), Wte = new WeakMap(), Yte = new WeakMap(), Nv = new WeakMap(), E2 = new WeakMap(), DF = new WeakMap(), qte = new WeakMap(), $te = new WeakMap(), Kte = new WeakMap(), Zte = new WeakMap(), Qte = new WeakMap(), Jte = new WeakMap(), Xte = new WeakMap(), eie = new WeakMap(), tie = new WeakMap(), yP = new WeakMap(), iie = new WeakMap(), aW = new WeakMap(), Dv = new WeakMap(), CF = new WeakMap(), OF = new WeakMap(), uW = new WeakMap(), EP = new WeakMap(), dW = new WeakMap(), nie = new WeakMap(), cW = new WeakMap(), LF = new WeakMap(), pO = new WeakMap(), hW = new WeakMap(), sie = new WeakMap(), fW = new WeakMap(), oie = new WeakMap(), ps = new WeakSet(), Kve = function(t) {
  const i = {
    annotationEditorMode: S(this, Nv),
    annotationMode: S(this, DF),
    textLayerMode: S(this, fW)
  };
  return t && (!t.includes(Ene.COPY) && S(this, fW) === Zb.ENABLE && (i.textLayerMode = Zb.ENABLE_PERMISSIONS), t.includes(Ene.MODIFY_CONTENTS) || (i.annotationEditorMode = e2.DISABLE), !t.includes(Ene.MODIFY_ANNOTATIONS) && !t.includes(Ene.FILL_INTERACTIVE_FORMS) && S(this, DF) === mO.ENABLE_FORMS && (i.annotationMode = mO.ENABLE)), i;
}, Zve = async function(t) {
  if (document.visibilityState === "hidden" || !this.container.offsetParent || this._getVisiblePages().views.length === 0)
    return;
  const i = Promise.withResolvers(), n = new AbortController();
  document.addEventListener("visibilitychange", () => {
    document.visibilityState === "hidden" && i.resolve();
  }, {
    signal: AbortSignal.any([t, n.signal])
  }), await Promise.race([this._onePageRenderedCapability.promise, i.promise]), n.abort();
}, Qve = function(t, i) {
  const n = document.getSelection(), {
    focusNode: s,
    anchorNode: o
  } = n;
  if (o && s && n.containsNode(S(this, EP))) {
    if (S(this, uW) || t === Zb.ENABLE_PERMISSIONS) {
      Tfe(i);
      return;
    }
    be(this, uW, !0);
    const {
      classList: r
    } = this.viewer;
    r.add("copyAll");
    const l = new AbortController();
    window.addEventListener("keydown", (c) => be(this, dW, c.key === "Escape"), {
      signal: l.signal
    }), this.getAllText().then(async (c) => {
      c !== null && await navigator.clipboard.writeText(c);
    }).catch((c) => {
      console.warn(`Something goes wrong when extracting the text: ${c.message}`);
    }).finally(() => {
      be(this, uW, !1), be(this, dW, !1), l.abort(), r.remove("copyAll");
    }), Tfe(i);
  }
}, AQ = function() {
  if (this._scrollMode !== Rr.PAGE)
    throw new Error("#ensurePageViewVisible: Invalid scrollMode value.");
  const t = this._currentPageNumber, i = S(this, LF), n = this.viewer;
  if (n.textContent = "", i.pages.length = 0, this._spreadMode === Bm.NONE && !this.isInPresentationMode) {
    const s = this._pages[t - 1];
    n.append(s.div), i.pages.push(s);
  } else {
    const s = /* @__PURE__ */ new Set(), o = this._spreadMode - 1;
    o === -1 ? s.add(t - 1) : t % 2 !== o ? (s.add(t - 1), s.add(t)) : (s.add(t - 2), s.add(t - 1));
    const r = document.createElement("div");
    if (r.className = "spread", this.isInPresentationMode) {
      const l = document.createElement("div");
      l.className = "dummyPage", r.append(l);
    }
    for (const l of s) {
      const c = this._pages[l];
      c && (r.append(c.div), i.pages.push(c));
    }
    n.append(r);
  }
  i.scrollDown = t >= i.previousPageNumber, i.previousPageNumber = t;
}, Poe = function(t, i = null) {
  const {
    div: n,
    id: s
  } = t;
  if (this._currentPageNumber !== s && this._setCurrentPageNumber(s), this._scrollMode === Rr.PAGE && (_e(this, ps, AQ).call(this), this.update()), !i && !this.isInPresentationMode) {
    const o = n.offsetLeft + n.clientLeft, r = o + n.clientWidth, {
      scrollLeft: l,
      clientWidth: c
    } = this.container;
    (this._scrollMode === Rr.HORIZONTAL || o < l || r > l + c) && (i = {
      left: 0,
      top: 0
    });
  }
  uve(n, i), !this._currentScaleValue && this._location && (this._location = null);
}, Jve = function(t) {
  return t === this._currentScale || Math.abs(t - this._currentScale) < 1e-15;
}, e1e = function(t, i, {
  noScroll: n = !1,
  preset: s = !1,
  drawingDelay: o = -1,
  origin: r = null
}) {
  if (this._currentScaleValue = i.toString(), _e(this, ps, Jve).call(this, t)) {
    s && this.eventBus.dispatch("scalechanging", {
      source: this,
      scale: t,
      presetValue: i
    });
    return;
  }
  this.viewer.style.setProperty("--scale-factor", t * NC.PDF_TO_CSS_UNITS);
  const l = o >= 0 && o < 1e3;
  this.refresh(!0, {
    scale: t,
    drawingDelay: l ? o : -1
  }), l && be(this, pO, setTimeout(() => {
    be(this, pO, null), this.refresh();
  }, o));
  const c = this._currentScale;
  if (this._currentScale = t, !n) {
    let h = this._currentPageNumber, I;
    if (this._location && !(this.isInPresentationMode || this.isChangingPresentationMode) && (h = this._location.pageNumber, I = [null, {
      name: "XYZ"
    }, this._location.left, this._location.top, null]), this.scrollPageIntoView({
      pageNumber: h,
      destArray: I,
      allowNegativeOffset: !0
    }), Array.isArray(r)) {
      const p = t / c - 1, [y, m] = this.containerTopLeft;
      this.container.scrollLeft += (r[0] - m) * p, this.container.scrollTop += (r[1] - y) * p;
    }
  }
  this.eventBus.dispatch("scalechanging", {
    source: this,
    scale: t,
    presetValue: s ? i : void 0
  }), this.defaultRenderingQueue && this.update();
}, Xve = function() {
  return this._spreadMode !== Bm.NONE && this._scrollMode !== Rr.HORIZONTAL ? 2 : 1;
}, T_ = function(t, i) {
  let n = parseFloat(t);
  if (n > 0)
    i.preset = !1, _e(this, ps, e1e).call(this, n, t, i);
  else {
    const s = this._pages[this._currentPageNumber - 1];
    if (!s)
      return;
    let o = oEe, r = rEe;
    this.isInPresentationMode ? (o = r = 4, this._spreadMode !== Bm.NONE && (o *= 2)) : this.removePageBorders ? o = r = 0 : this._scrollMode === Rr.HORIZONTAL && ([o, r] = [r, o]);
    const l = (this.container.clientWidth - o) / s.width * s.scale / S(this, ps, Xve), c = (this.container.clientHeight - r) / s.height * s.scale;
    switch (t) {
      case "page-actual":
        n = 1;
        break;
      case "page-width":
        n = l;
        break;
      case "page-height":
        n = c;
        break;
      case "page-fit":
        n = Math.min(l, c);
        break;
      case "auto":
        const h = uEe(s) ? l : Math.min(c, l);
        n = Math.min(APe, h);
        break;
      default:
        console.error(`#setScale: "${t}" is an unknown zoom value.`);
        return;
    }
    i.preset = !0, _e(this, ps, e1e).call(this, n, t, i);
  }
}, t1e = function() {
  const t = this._pages[this._currentPageNumber - 1];
  this.isInPresentationMode && _e(this, ps, T_).call(this, this._currentScaleValue, {
    noScroll: !0
  }), _e(this, ps, Poe).call(this, t);
}, eAe = function() {
  const t = this._getVisiblePages(), i = [], {
    ids: n,
    views: s
  } = t;
  for (const o of s) {
    const {
      view: r
    } = o;
    if (!r.hasEditableAnnotations()) {
      n.delete(r.id);
      continue;
    }
    i.push(o);
  }
  return i.length === 0 ? null : (this.renderingQueue.renderHighestPriority({
    first: i[0],
    last: i.at(-1),
    views: i,
    ids: n
  }), n);
}, tAe = async function(t) {
  if (t.pdfPage)
    return t.pdfPage;
  try {
    const i = await this.pdfDocument.getPage(t.id);
    return t.pdfPage || t.setPdfPage(i), i;
  } catch (i) {
    return console.error("Unable to get page for page view", i), null;
  }
}, iAe = function(t) {
  var i, n;
  if (((i = t.first) == null ? void 0 : i.id) === 1)
    return !0;
  if (((n = t.last) == null ? void 0 : n.id) === this.pagesCount)
    return !1;
  switch (this._scrollMode) {
    case Rr.PAGE:
      return S(this, LF).scrollDown;
    case Rr.HORIZONTAL:
      return this.scroll.right;
  }
  return this.scroll.down;
}, i1e = function(t = this.container.clientHeight) {
  t !== S(this, nie) && (be(this, nie, t), OPe.setProperty("--viewer-container-height", `${t}px`));
}, nAe = function(t) {
  for (const i of t)
    if (i.target === this.container) {
      _e(this, ps, i1e).call(this, Math.floor(i.borderBoxSize[0].blockSize)), be(this, $te, null);
      break;
    }
}, n1e = function() {
  S(this, pO) !== null && (clearTimeout(S(this, pO)), be(this, pO, null)), S(this, Dv) !== null && (clearTimeout(S(this, Dv)), be(this, Dv, null));
}, Moe = function() {
  var t;
  (t = S(this, CF)) == null || t.abort(), be(this, CF, null), S(this, OF) !== null && (clearTimeout(S(this, OF)), be(this, OF, null));
}, s1e = function(t) {
  var i, n;
  switch (t) {
    case e2.STAMP:
      (i = S(this, aW)) == null || i.loadModel("altText");
      break;
    case e2.SIGNATURE:
      (n = S(this, hW)) == null || n.loadSignatures();
      break;
  }
};
class gMe extends $ve {
  _resetView() {
    super._resetView(), this._scrollMode = Rr.PAGE, this._spreadMode = Bm.NONE;
  }
  set scrollMode(t) {
  }
  _updateScrollMode() {
  }
  set spreadMode(t) {
  }
  _updateSpreadMode() {
  }
}
globalThis.pdfjsViewer = {
  AnnotationLayerBuilder: gve,
  DownloadManager: t8e,
  EventBus: Fpe,
  FindState: w_,
  GenericL10n: NW,
  LinkTarget: K_,
  parseQueryString: Tae,
  PDFFindController: XPe,
  PDFHistory: eMe,
  PDFLinkService: Upe,
  PDFPageView: Vve,
  PDFScriptingManager: pMe,
  PDFSinglePageViewer: gMe,
  PDFViewer: $ve,
  ProgressBar: LPe,
  RenderingStates: ll,
  ScrollMode: Rr,
  SimpleLinkService: Bpe,
  SpreadMode: Bm,
  StructTreeLayerBuilder: Uve,
  TextLayerBuilder: fle,
  XfaLayerBuilder: kve
};
const wMe = ({
  page: e,
  scale: t,
  rotation: i = 0
}) => {
  const n = io(null), s = io(null);
  vr(() => {
    s.current || (s.current = new Upe({
      eventBus: new Fpe(),
      externalLinkTarget: K_.BLANK
    }));
  }, []);
  const o = On(async () => {
    const r = n.current;
    if (!r || !s.current) return;
    r.innerHTML = "";
    const l = e.getViewport({ scale: t, rotation: i }), c = await e.getAnnotations(), h = mRe;
    await new h({
      div: r,
      accessibilityManager: void 0,
      annotationCanvasMap: /* @__PURE__ */ new Map(),
      annotationEditorUIManager: void 0,
      page: e,
      viewport: l.clone({ dontFlip: !0 }),
      structTreeLayer: void 0
    }).render({
      annotations: c,
      imageResourcesPath: "",
      renderForms: !1,
      linkService: s.current,
      downloadManager: void 0,
      annotationStorage: void 0,
      enableScripting: !1,
      hasJSActions: !1,
      fieldObjects: null
    });
  }, [e, t, i]);
  return vr(() => {
    o();
  }, [o]), /* @__PURE__ */ He.jsx(
    "div",
    {
      ref: n,
      className: "annotationLayer",
      style: { position: "absolute", inset: 0, pointerEvents: "none", zIndex: 3 }
    }
  );
}, TMe = ({ coordinates: e, scale: t, pageIndex: i }) => {
  if (e.pageNumber - 1 !== i)
    return null;
  const n = e.x0 * t, s = e.y0 * t, o = (e.x1 - e.x0) * t, r = (e.y1 - e.y0) * t;
  return /* @__PURE__ */ He.jsx(
    "div",
    {
      style: {
        position: "absolute",
        left: `${n}px`,
        top: `${s}px`,
        width: `${o}px`,
        height: `${r}px`,
        backgroundColor: "rgba(255, 255, 0, 0.3)",
        mixBlendMode: "multiply",
        pointerEvents: "none",
        zIndex: 5,
        borderRadius: "2px",
        // Use transparent border to avoid overlapping with text
        border: "1px solid rgba(255, 200, 0, 0.5)",
        // Align with text layer position
        transform: "translateY(0)"
      },
      className: "pdfjs-highlight",
      "data-page-index": i,
      role: "mark"
    }
  );
}, RMe = ({
  downloadProgress: e,
  pageLoadProgress: t,
  currentStep: i,
  theme: n = "light"
}) => {
  const o = i === "downloading" ? e * 0.95 : i === "loading-pages" ? 95 + t * 0.05 : 100, r = Math.round(o), l = 28, c = 2 * Math.PI * l, h = c - o / 100 * c, I = n === "light" ? "#e5e7eb" : "#475569", p = n === "light" ? "#3b82f6" : "#93c5fd", y = n === "light" ? "text-gray-900" : "text-gray-100";
  return /* @__PURE__ */ He.jsxs("div", { className: "flex flex-col items-center justify-center h-full w-full", children: [
    /* @__PURE__ */ He.jsxs("div", { className: "relative", children: [
      /* @__PURE__ */ He.jsxs("svg", { width: "80", height: "80", className: "transform -rotate-90", children: [
        /* @__PURE__ */ He.jsx(
          "circle",
          {
            cx: "40",
            cy: "40",
            r: l,
            stroke: I,
            strokeWidth: "4",
            fill: "none"
          }
        ),
        /* @__PURE__ */ He.jsx(
          "circle",
          {
            cx: "40",
            cy: "40",
            r: l,
            stroke: p,
            strokeWidth: "4",
            fill: "none",
            strokeDasharray: c,
            strokeDashoffset: h,
            strokeLinecap: "round",
            className: "transition-all duration-300 ease-out"
          }
        )
      ] }),
      /* @__PURE__ */ He.jsx("div", { className: "absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ He.jsxs("span", { className: `text-base font-medium ${y}`, children: [
        r,
        "%"
      ] }) })
    ] }),
    /* @__PURE__ */ He.jsx("p", { className: `mt-4 text-sm ${y}`, children: i === "downloading" ? "Downloading PDF..." : "Loading pages..." })
  ] });
};
function vMe({
  page: e,
  scale: t,
  index: i,
  onRendered: n,
  initialScaleSet: s = !0
}) {
  const o = io(null), r = io(!1), l = io(null), c = io(!0), h = io(t), I = io(0), p = io(null), [y, m] = Is(!1), A = On(() => {
    const C = l.current;
    if (!C || !c.current) return;
    const O = C.getContext("2d");
    if (!O) {
      m(!1);
      return;
    }
    if (o.current) {
      try {
        o.current.cancel();
      } catch (ce) {
        console.log("Ignoring cancellation error:", ce);
      }
      o.current = null;
    }
    const R = ++I.current, F = t;
    m(!0);
    const L = e.getViewport({ scale: t, rotation: e.rotate }), P = window.devicePixelRatio || 1;
    C.style.width = "100%", C.style.height = "100%", C.style.display = "block";
    const z = Math.min(Math.max(P, 1), 1.5);
    C.width = L.width * z, C.height = L.height * z, O.scale(z, z);
    const W = {
      canvasContext: O,
      viewport: L,
      canvas: C
    }, re = e.render(W);
    o.current = re, re.promise.then(() => {
      c.current && R === I.current && (r.current = !0, p.current = F, o.current = null, m(!1), n && n(i));
    }).catch((ce) => {
      var te;
      !c.current || R !== I.current || (m(!1), (ce == null ? void 0 : ce.name) !== "RenderingCancelledException" && (ce == null ? void 0 : ce.message) !== "Rendering cancelled" && !((te = ce == null ? void 0 : ce.message) != null && te.includes("Rendering cancelled")) && console.error("Error rendering page canvas:", ce), o.current = null);
    });
  }, [e, t, i, n]);
  return vr(() => {
    const C = p.current ?? h.current;
    if (Math.abs(C - t) < 0.01 || t === 1 && h.current === 1 && !s)
      return;
    const O = setTimeout(() => {
      h.current = t, r.current = !1, A();
    }, 50);
    return () => {
      clearTimeout(O);
    };
  }, [t, A, i, s]), vr(() => {
    if (r.current || t === 1 && !s)
      return;
    const C = setTimeout(() => {
      A();
    }, 30);
    return () => {
      clearTimeout(C);
    };
  }, [i, A, t, s]), vr(() => () => {
    if (c.current = !1, o.current) {
      try {
        o.current.cancel();
      } catch (C) {
        console.log("Ignoring cancellation error:", C);
      }
      o.current = null;
    }
  }, []), vr(() => {
    c.current = !0;
  }, [i]), { canvasRef: l, isRendering: y };
}
const AMe = ({
  page: e,
  scale: t,
  index: i,
  onCanvasRendered: n,
  renderLoading: s,
  initialScaleSet: o = !0
}) => {
  const { canvasRef: r, isRendering: l } = vMe({
    page: e,
    scale: t,
    index: i,
    onRendered: n,
    initialScaleSet: o
  });
  return /* @__PURE__ */ He.jsxs(He.Fragment, { children: [
    /* @__PURE__ */ He.jsx("canvas", { ref: r }),
    s && s(l)
  ] });
}, SMe = ({
  page: e,
  scale: t,
  rotation: i = 0,
  pageIndex: n,
  onTextLayerRendered: s,
  matches: o = []
}) => {
  const r = io(null), l = io(null), c = io(!1), h = io(!1);
  vr(() => () => {
    l.current && (l.current = null);
  }, []);
  const I = On(() => {
    if (!r.current || o.length === 0 || h.current) return;
    const y = r.current, m = Array.from(y.querySelectorAll(".textLayer span")).filter(
      (O) => O.childNodes.length > 0 && Array.from(O.childNodes).every((R) => R.nodeType === Node.TEXT_NODE)
    );
    if (m.length === 0) return;
    y.querySelectorAll(".pdfjs-search-highlight").forEach((O) => {
      const R = O.parentNode;
      if (R) {
        const F = O.textContent || "";
        if (R instanceof HTMLElement && (R.classList.contains("textLayer") || R.parentElement && R.parentElement.classList.contains("textLayer")) && R instanceof HTMLElement) {
          const P = R.getAttribute("style"), z = R.style.transform, W = R.style.left, re = R.style.top, ce = document.createTextNode(F);
          R.replaceChild(ce, O), P && R.setAttribute("style", P), z && (R.style.transform = z), W && (R.style.left = W), re && (R.style.top = re);
        } else {
          const P = document.createTextNode(F);
          R.replaceChild(P, O);
        }
        R.normalize();
      }
    });
    const C = /* @__PURE__ */ new Map();
    m.forEach((O) => {
      O.textContent && C.set(O, O.textContent);
    }), o.forEach((O) => {
      const { text: R } = O;
      if (!R.trim()) return;
      const F = "pdfjs-search-highlight";
      for (const [L, P] of C.entries()) {
        const z = P.indexOf(R);
        if (z >= 0) {
          const W = L.getAttribute("style"), re = L.style.transform, ce = L.style.left, te = L.style.top, ee = L.style.fontSize, Ne = L.className, Ae = document.createDocumentFragment();
          z > 0 && Ae.appendChild(document.createTextNode(P.substring(0, z)));
          const Oe = document.createElement("span");
          Oe.className = F, Oe.textContent = P.substring(z, z + R.length), Oe.dataset.matchText = R, Oe.dataset.pageIndex = O.pageIndex.toString(), Ae.appendChild(Oe), z + R.length < P.length && Ae.appendChild(
            document.createTextNode(P.substring(z + R.length))
          );
          const pe = document.createElement("div");
          pe.appendChild(Ae.cloneNode(!0)), L.innerHTML = pe.innerHTML, W && L.setAttribute("style", W), re && (L.style.transform = re), ce && (L.style.left = ce), te && (L.style.top = te), ee && (L.style.fontSize = ee), Ne && (L.className = Ne);
        }
      }
    }), h.current = !0;
  }, [o]), p = On(async () => {
    if (!e || !r.current) return;
    const y = r.current;
    y.innerHTML = "", h.current = !1;
    try {
      c.current = !1;
      const m = e.getViewport({ scale: t, rotation: i }), A = e.streamTextContent({ includeMarkedContent: !0 }), C = {
        container: y,
        textContentSource: A,
        viewport: m
      };
      y.style.setProperty("--total-scale-factor", String(t));
      const O = new rle(C);
      l.current = O, await O.render();
      const R = document.createElement("div");
      R.className = "endOfContent", y.append(R), c.current = !0, s && s(), I();
    } catch (m) {
      console.error("Error rendering text layer:", m);
    }
  }, [e, t, i, s, I]);
  return vr(() => {
    c.current && (h.current = !1, I());
  }, [o, I, n]), J4e(() => {
    p();
  }, [p]), vr(() => {
    const y = r.current;
    if (!y) return;
    const m = () => {
      r.current && r.current.classList.add("selecting");
      const A = () => {
        r.current && r.current.classList.remove("selecting"), window.removeEventListener("pointerup", A, !0);
      };
      window.addEventListener("pointerup", A, !0);
    };
    return y.addEventListener("pointerdown", m, { passive: !0 }), () => {
      y.removeEventListener("pointerdown", m);
    };
  }, []), /* @__PURE__ */ He.jsx(
    "div",
    {
      ref: r,
      className: "textLayer",
      style: {
        position: "absolute",
        inset: 0,
        overflow: "hidden",
        opacity: 1,
        lineHeight: "normal",
        textAlign: "initial",
        pointerEvents: "auto"
      }
    }
  );
};
function bMe(e) {
  return Sd({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M18 15v3H6v-3H4v3c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-3h-2zm-1-4-1.41-1.41L13 12.17V4h-2v8.17L8.41 9.59 7 11l5 5 5-5z" }, child: [] }] })(e);
}
const NMe = ({
  pdfUrl: e,
  fileName: t = "document.pdf",
  className: i
}) => {
  const [n, s] = Is(!1), o = On(async () => {
    if (e) {
      s(!0);
      try {
        const r = await fetch(e);
        if (!r.ok)
          throw new Error("Failed to download PDF");
        const l = await r.blob(), c = window.URL.createObjectURL(l), h = document.createElement("a");
        h.href = c, h.download = t, document.body.appendChild(h), h.click(), document.body.removeChild(h), window.URL.revokeObjectURL(c);
      } catch (r) {
        console.error("Error downloading PDF:", r);
      } finally {
        s(!1);
      }
    }
  }, [e, t]);
  return /* @__PURE__ */ He.jsx(
    "button",
    {
      onClick: o,
      disabled: n,
      className: `fc:p-1 fc:rounded fc:hover:bg-gray-200 fc:text-gray-700 fc:cursor-pointer fc:disabled:opacity-50 fc:disabled:cursor-not-allowed ${i || ""}`,
      title: "Download PDF",
      "aria-label": "Download PDF",
      children: n ? /* @__PURE__ */ He.jsx(jF, { size: "xsmall" }) : /* @__PURE__ */ He.jsx(bMe, { className: "fc:h-5 fc:w-5" })
    }
  );
}, DMe = ({
  currentPage: e,
  totalPages: t,
  onPageChange: i
}) => {
  const n = () => {
    e > 1 && i(e - 1);
  }, s = () => {
    e < t && i(e + 1);
  };
  return /* @__PURE__ */ He.jsxs("div", { className: "fc:flex fc:items-center fc:text-gray-700", children: [
    /* @__PURE__ */ He.jsx(
      "button",
      {
        onClick: n,
        disabled: e <= 1,
        className: "fc:p-1 fc:rounded fc:hover:bg-gray-200 fc:disabled:opacity-50 fc:text-gray-700 fc:cursor-pointer fc:disabled:cursor-not-allowed",
        "aria-label": "Previous page",
        children: /* @__PURE__ */ He.jsx(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            className: "fc:h-5 fc:w-5",
            viewBox: "0 0 20 20",
            fill: "currentColor",
            children: /* @__PURE__ */ He.jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z",
                clipRule: "evenodd"
              }
            )
          }
        )
      }
    ),
    /* @__PURE__ */ He.jsxs("span", { className: "fc:text-sm fc:text-gray-700", children: [
      e,
      " / ",
      t
    ] }),
    /* @__PURE__ */ He.jsx(
      "button",
      {
        onClick: s,
        disabled: e >= t,
        className: "fc:p-1 fc:rounded fc:hover:bg-gray-200 fc:disabled:opacity-50 fc:text-gray-700 fc:cursor-pointer fc:disabled:cursor-not-allowed",
        "aria-label": "Next page",
        children: /* @__PURE__ */ He.jsx(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            className: "fc:h-5 fc:w-5",
            viewBox: "0 0 20 20",
            fill: "currentColor",
            children: /* @__PURE__ */ He.jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
                clipRule: "evenodd"
              }
            )
          }
        )
      }
    )
  ] });
}, CMe = ({
  searchTerm: e,
  setSearchTerm: t,
  performSearch: i,
  clearSearch: n,
  totalMatches: s,
  currentMatchIndex: o,
  searchNextMatch: r,
  searchPreviousMatch: l,
  isSearching: c
}) => {
  const [h, I] = Is(!1), [p, y] = Is(!1), [m, A] = Is(""), C = io(null), O = io(null);
  vr(() => {
    h && C.current && C.current.focus();
  }, [h]), vr(() => {
    const P = O.current;
    return () => {
      P && clearTimeout(P);
    };
  }, []);
  const R = (P) => {
    const z = P.target.value;
    t(z), y(!1), z.trim() || (n(), A(""));
  }, F = (P) => {
    P.key === "Enter" ? (P.preventDefault(), e.trim() && e !== m ? (i(e, !1), y(!0), A(e)) : s > 0 ? P.shiftKey ? l() : r() : e.trim() && (i(e, !1), y(!0), A(e))) : P.key === "Escape" && I(!1);
  }, L = () => {
    h ? (n(), y(!1), A("")) : e && (i(e, !1), y(!0), A(e)), I(!h);
  };
  return /* @__PURE__ */ He.jsxs(He.Fragment, { children: [
    /* @__PURE__ */ He.jsx(
      "button",
      {
        className: "fc:p-2 fc:text-gray-700 fc:rounded-md fc:hover:bg-gray-200 fc:transition-colors fc:duration-150 fc:flex fc:items-center fc:justify-center fc:cursor-pointer",
        onClick: L,
        title: "Search in document",
        children: /* @__PURE__ */ He.jsx(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            strokeWidth: 1.5,
            stroke: "currentColor",
            className: "fc:w-5 fc:h-5",
            children: /* @__PURE__ */ He.jsx(
              "path",
              {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
              }
            )
          }
        )
      }
    ),
    h && /* @__PURE__ */ He.jsx("div", { className: "fc:absolute fc:top-12 fc:right-2 fc:bg-white fc:shadow-lg fc:rounded-md fc:border fc:border-gray-300 fc:p-3 fc:z-20 fc:w-50", children: /* @__PURE__ */ He.jsxs("div", { className: "fc:flex fc:flex-col fc:gap-2", children: [
      /* @__PURE__ */ He.jsx("div", { className: "fc:flex fc:items-center fc:gap-2", children: /* @__PURE__ */ He.jsxs("div", { className: "fc:relative fc:flex-grow", children: [
        /* @__PURE__ */ He.jsx(
          "input",
          {
            ref: C,
            type: "text",
            className: "fc:text-sm fc:w-full fc:px-3 fc:py-2 fc:border fc:border-gray-300 fc:rounded-md fc:pr-8",
            value: e,
            onChange: R,
            onKeyDown: F
          }
        ),
        e && /* @__PURE__ */ He.jsx(
          "button",
          {
            className: "fc:absolute fc:right-2 fc:top-1/2 fc:transform fc:-translate-y-1/2 fc:text-gray-500 fc:hover:text-gray-700 fc:cursor-pointer",
            onClick: () => {
              n(), y(!1), A(""), C.current && C.current.focus();
            },
            title: "Clear search",
            children: /* @__PURE__ */ He.jsx(
              "svg",
              {
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                strokeWidth: 1.5,
                stroke: "currentColor",
                className: "fc:w-4 fc:h-4",
                children: /* @__PURE__ */ He.jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M6 18L18 6M6 6l12 12" })
              }
            )
          }
        )
      ] }) }),
      e && /* @__PURE__ */ He.jsxs("div", { className: "fc:flex fc:items-center fc:justify-between", children: [
        /* @__PURE__ */ He.jsx("div", { className: "fc:text-sm fc:text-gray-600", children: c ? "Searching..." : s > 0 ? /* @__PURE__ */ He.jsxs(He.Fragment, { children: [
          o + 1,
          " of ",
          s,
          " matches"
        ] }) : p && e.length > 0 ? "No matches found" : null }),
        /* @__PURE__ */ He.jsxs("div", { className: "fc:flex fc:gap-1", children: [
          /* @__PURE__ */ He.jsx(
            "button",
            {
              className: "fc:p-1 fc:text-gray-700 fc:rounded-md fc:hover:bg-gray-200 fc:disabled:opacity-50 fc:disabled:hover:bg-transparent fc:cursor-pointer fc:disabled:cursor-not-allowed",
              onClick: l,
              disabled: s === 0 || c,
              title: "Previous match (Shift+Enter)",
              children: /* @__PURE__ */ He.jsx(
                "svg",
                {
                  xmlns: "http://www.w3.org/2000/svg",
                  className: "fc:h-5 fc:w-5",
                  viewBox: "0 0 20 20",
                  fill: "currentColor",
                  children: /* @__PURE__ */ He.jsx(
                    "path",
                    {
                      fillRule: "evenodd",
                      d: "M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z",
                      clipRule: "evenodd"
                    }
                  )
                }
              )
            }
          ),
          /* @__PURE__ */ He.jsx(
            "button",
            {
              className: "fc:p-1 fc:text-gray-700 fc:rounded-md fc:hover:bg-gray-200 fc:disabled:opacity-50 fc:disabled:hover:bg-transparent fc:cursor-pointer fc:disabled:cursor-not-allowed",
              onClick: r,
              disabled: s === 0 || c,
              title: "Next match (Enter)",
              children: /* @__PURE__ */ He.jsx(
                "svg",
                {
                  xmlns: "http://www.w3.org/2000/svg",
                  className: "fc:h-5 fc:w-5",
                  viewBox: "0 0 20 20",
                  fill: "currentColor",
                  children: /* @__PURE__ */ He.jsx(
                    "path",
                    {
                      fillRule: "evenodd",
                      d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
                      clipRule: "evenodd"
                    }
                  )
                }
              )
            }
          )
        ] })
      ] })
    ] }) })
  ] });
}, OMe = ({ scale: e, onScaleChange: t }) => {
  const o = () => {
    const l = Math.max(Math.round((e - 0.1) * 10) / 10, 0.5);
    t(l);
  }, r = () => {
    const l = Math.min(Math.round((e + 0.1) * 10) / 10, 3);
    t(l);
  };
  return /* @__PURE__ */ He.jsxs("div", { className: "fc:flex fc:items-center fc:space-x-2 fc:text-gray-700", children: [
    /* @__PURE__ */ He.jsx(
      "button",
      {
        onClick: o,
        className: "fc:p-1 fc:rounded fc:hover:bg-gray-200 fc:text-gray-700 fc:cursor-pointer",
        "aria-label": "Zoom out",
        children: /* @__PURE__ */ He.jsx(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            className: "fc:h-5 fc:w-5",
            viewBox: "0 0 20 20",
            fill: "currentColor",
            children: /* @__PURE__ */ He.jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z",
                clipRule: "evenodd"
              }
            )
          }
        )
      }
    ),
    /* @__PURE__ */ He.jsxs("span", { className: "fc:text-sm fc:text-gray-700", children: [
      Math.round(e * 100),
      "%"
    ] }),
    /* @__PURE__ */ He.jsx(
      "button",
      {
        onClick: r,
        className: "fc:p-1 fc:rounded fc:hover:bg-gray-200 fc:text-gray-700 fc:cursor-pointer",
        "aria-label": "Zoom in",
        children: /* @__PURE__ */ He.jsx(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            className: "fc:h-5 fc:w-5",
            viewBox: "0 0 20 20",
            fill: "currentColor",
            children: /* @__PURE__ */ He.jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z",
                clipRule: "evenodd"
              }
            )
          }
        )
      }
    )
  ] });
}, LMe = ({
  currentPage: e,
  totalPages: t,
  onPageChange: i,
  scale: n,
  onScaleChange: s,
  // PDF download props
  pdfUrl: o,
  fileName: r,
  hideDownloadButton: l = !1,
  // Search props
  searchTerm: c,
  setSearchTerm: h,
  performSearch: I,
  clearSearch: p,
  totalMatches: y,
  currentMatchIndex: m,
  searchNextMatch: A,
  searchPreviousMatch: C,
  isSearching: O
}) => /* @__PURE__ */ He.jsxs("div", { className: "fc:sticky fc:top-0 fc:z-10 fc:flex fc:items-center fc:justify-between fc:bg-gray-100 fc:py-0.5 fc:px-2 fc:border-b fc:border-gray-300 fc:text-gray-700", children: [
  /* @__PURE__ */ He.jsx("div", { className: "fc:flex fc:items-center", children: /* @__PURE__ */ He.jsx(
    DMe,
    {
      currentPage: e,
      totalPages: t,
      onPageChange: i
    }
  ) }),
  /* @__PURE__ */ He.jsxs("div", { className: "fc:flex fc:items-center fc:gap-2", children: [
    !l && /* @__PURE__ */ He.jsx(NMe, { pdfUrl: o, fileName: r }),
    /* @__PURE__ */ He.jsx(OMe, { scale: n, onScaleChange: s }),
    /* @__PURE__ */ He.jsx("div", { className: "fc:relative", children: /* @__PURE__ */ He.jsx(
      CMe,
      {
        searchTerm: c,
        setSearchTerm: h,
        performSearch: I,
        clearSearch: p,
        totalMatches: y,
        currentMatchIndex: m,
        searchNextMatch: A,
        searchPreviousMatch: C,
        isSearching: O
      }
    ) })
  ] })
] });
lx.workerSrc = window.location.origin + "/pdf.worker.min.mjs";
const Yat = ({
  pdfUrl: e,
  fileName: t,
  initialPage: i = 1,
  highlight: n,
  searchTerm: s,
  className: o,
  theme: r = "light",
  onOrientationDetected: l,
  hideDownloadButton: c = !1
}) => {
  const {
    numPages: h,
    pdfDocument: I,
    loading: p,
    error: y,
    downloadProgress: m,
    currentStep: A,
    getLoadedPage: C,
    ensurePagesLoaded: O,
    firstPage: R
  } = rPe(e), F = io(null), L = io(null), {
    scale: P,
    currentPage: z,
    visiblePages: W,
    setVisiblePages: re,
    pageRefs: ce,
    canvasesRendered: te,
    textLayersRendered: ee,
    isPageVisible: Ne,
    handleScaleChange: Ae,
    handlePageChange: Oe,
    calculateInitialScale: pe,
    initialScaleSetRef: je,
    setCurrentPage: Ve,
    scrollToHighlight: $e,
    resetHighlightScrolled: vt,
    isNavigating: Rt
  } = aPe({
    initialPage: i,
    numPages: h
  }), ze = On(() => L.current ? L.current.offsetHeight : 50, []), mt = On(
    (Mt) => {
      !Mt || !F.current || (Ve(Mt.pageNumber), $e(
        Mt.pageNumber,
        F.current,
        Mt.coordinates.y0,
        Mt.coordinates.y1 - Mt.coordinates.y0,
        !0
        // Force scroll to search matches
      ));
    },
    [Ve, $e]
  ), Et = On(
    (Mt) => {
      !Mt || !F.current || mt(Mt);
    },
    [mt]
  ), {
    searchTerm: it,
    setSearchTerm: Dt,
    matches: Ct,
    isSearching: Kt,
    currentMatchIndex: Zt,
    totalMatches: Xt,
    searchNextMatch: gi,
    searchPreviousMatch: Wt,
    clearSearch: Di,
    performSearch: ni
  } = lPe(I, Et, i);
  vr(() => {
    if (Zt >= 0 && Ct.length > 0) {
      const Mt = new Set(Ct.map((ft) => ft.pageIndex));
      ee.current.forEach((ft) => {
        if (Mt.has(ft)) {
          const rt = ce.current[ft];
          rt && (rt.classList.add("force-update"), setTimeout(() => {
            rt && rt.classList.remove("force-update");
          }, 0));
        }
      });
    }
  }, [Zt, Ct, ce, ee]), vr(() => {
    s && I && ni(s, !0);
  }, [s, I, ni]), vr(() => {
    if (!p && h > 0 && R && F.current) {
      if (ce.current.length === 0 && (ce.current = new Array(h).fill(null)), W.size === 0) {
        const Mt = /* @__PURE__ */ new Set();
        for (let ft = 0; ft < h; ft++)
          Mt.add(ft);
        re(Mt);
      }
      if (je.current || pe(R, F.current), l) {
        const Mt = R.getViewport({ scale: 1 }), ft = Mt.width > Mt.height ? ile.LANDSCAPE : ile.PORTRAIT;
        l(ft);
      }
      n && n.pageNumber >= 1 && n.pageNumber <= h ? $e(
        n.pageNumber,
        F.current,
        n.y0,
        n.y1 - n.y0,
        !0
      ) : i > 1 && i <= h ? Oe(i, F.current, !0) : Oe(1, F.current, !0);
    }
  }, [
    p,
    h,
    R,
    i,
    n,
    Oe,
    pe,
    je,
    W,
    re,
    ce,
    $e,
    l
  ]);
  const Ci = (Mt) => {
    te.current.add(Mt);
  }, Se = On(() => {
    if (!F.current || h === 0 || Rt) return;
    const Mt = F.current, ft = ze();
    let rt = 0, Tt = 0;
    ce.current.forEach((jt, Jt) => {
      if (!jt) return;
      const $t = jt.getBoundingClientRect(), ht = Mt.getBoundingClientRect(), Me = Math.max($t.top, ht.top + ft), gt = Math.min($t.bottom, ht.bottom);
      if (gt > Me) {
        const yt = gt - Me;
        yt > rt && (rt = yt, Tt = Jt);
      }
    }), Tt + 1 !== z && Ve(Tt + 1);
  }, [h, ze, ce, z, Ve, Rt]);
  vr(() => {
    const Mt = F.current;
    if (!Mt) return;
    let ft = null, rt = Mt.scrollTop, Tt = !1;
    const jt = () => {
      const $t = Mt.scrollTop;
      Math.abs($t - rt) > 20 && !Tt && (Tt = !0, vt()), rt = $t, ft && clearTimeout(ft), requestAnimationFrame(() => {
        ft = setTimeout(() => {
          Se(), setTimeout(() => {
            Tt = !1;
          }, 500);
        }, 50);
      });
    }, Jt = ($t) => {
      const { scrollTop: ht, scrollHeight: Me, clientHeight: gt } = Mt, yt = ht === 0, Ut = ht + gt >= Me;
      (!yt && $t.deltaY < 0 || !Ut && $t.deltaY > 0) && $t.stopPropagation();
    };
    return Mt.addEventListener("scroll", jt), Mt.addEventListener("wheel", Jt, { passive: !1 }), () => {
      ft && clearTimeout(ft), Mt.removeEventListener("scroll", jt), Mt.removeEventListener("wheel", Jt);
    };
  }, [Se, vt]), vr(() => {
    const Mt = () => {
      if (!F.current) return;
      const Tt = F.current, jt = Tt.scrollTop, Jt = Tt.scrollHeight, $t = jt / Jt, ht = jt + Tt.clientHeight / 2;
      te.current.clear(), ee.current.clear(), requestAnimationFrame(() => {
        if (!F.current) return;
        const Me = F.current.scrollHeight, gt = ht * (Me / Jt) - F.current.clientHeight / 2;
        F.current.scrollTop = gt, setTimeout(() => {
          F.current && (F.current.scrollTop = $t * F.current.scrollHeight);
        }, 50);
      });
    };
    let ft = null;
    const rt = () => {
      ft && clearTimeout(ft), ft = setTimeout(Mt, 100);
    };
    return window.addEventListener("resize", rt), () => {
      ft && clearTimeout(ft), window.removeEventListener("resize", rt);
    };
  }, [te, ee]), vr(() => {
    if (!R || h === 0) return;
    const Mt = [];
    for (let ft = Math.max(0, z - 4); ft < Math.min(h, z + 3); ft++)
      Mt.push(ft);
    O(Mt);
  }, [z, h, R, O]);
  const si = (Mt) => {
    const ft = C(Mt), rt = Ne(Mt), Tt = ft || R;
    if (!Tt) return null;
    const jt = Tt.getViewport({ scale: P, rotation: Tt.rotate }), Jt = Ct.filter(($t) => $t.pageIndex === Mt);
    return /* @__PURE__ */ He.jsx(
      "div",
      {
        ref: ($t) => {
          ce.current[Mt] = $t;
        },
        "data-page-index": Mt,
        className: "fc:mb-4 fc:w-fit",
        children: /* @__PURE__ */ He.jsxs(
          "div",
          {
            className: "fc:shadow-md fc:border fc:border-gray-200 fc:rounded",
            style: {
              width: `${jt.width}px`,
              height: `${jt.height}px`,
              position: "relative"
            },
            children: [
              rt && ft && (P !== 1 || je.current) && /* @__PURE__ */ He.jsx(
                AMe,
                {
                  page: ft,
                  scale: P,
                  index: Mt,
                  onCanvasRendered: Ci,
                  initialScaleSet: je.current,
                  renderLoading: ($t) => {
                    if (!$t) return null;
                    const ht = r === "light" ? "fc:bg-white/70" : "fc:bg-gray-900/70";
                    return /* @__PURE__ */ He.jsx(
                      "div",
                      {
                        className: `fc:absolute fc:inset-0 fc:flex fc:items-center fc:justify-center ${ht}`,
                        children: /* @__PURE__ */ He.jsx(jF, { size: "small" })
                      }
                    );
                  }
                }
              ),
              rt && ft && (P !== 1 || je.current) && /* @__PURE__ */ He.jsx(
                SMe,
                {
                  page: ft,
                  scale: P,
                  rotation: ft.rotate,
                  pageIndex: Mt,
                  onTextLayerRendered: () => {
                    ee.current.add(Mt);
                  },
                  matches: Jt
                }
              ),
              rt && ft && (P !== 1 || je.current) && /* @__PURE__ */ He.jsx(wMe, { page: ft, scale: P, rotation: ft.rotate }),
              n && rt && ft && (P !== 1 || je.current) && /* @__PURE__ */ He.jsx(TMe, { coordinates: n, scale: P, pageIndex: Mt }),
              rt && !ft && /* @__PURE__ */ He.jsx("div", { className: "fc:absolute fc:inset-0 fc:flex fc:items-center fc:justify-center", children: /* @__PURE__ */ He.jsx(jF, { size: "small" }) })
            ]
          }
        )
      },
      Mt
    );
  };
  if (p)
    return /* @__PURE__ */ He.jsx(
      RMe,
      {
        downloadProgress: m,
        pageLoadProgress: 0,
        currentStep: A === "ready" ? "loading-pages" : "downloading",
        theme: r
      }
    );
  if (y || h === 0) {
    const Mt = r === "light" ? "fc:text-gray-900" : "fc:text-gray-100";
    return /* @__PURE__ */ He.jsx("div", { className: `fc:flex fc:justify-center fc:items-center fc:h-full ${Mt}`, children: "Failed to load PDF" });
  }
  return /* @__PURE__ */ He.jsxs("div", { className: `fc:flex fc:flex-col fc:w-full fc:min-h-0 fc:h-full ${o || ""}`, children: [
    /* @__PURE__ */ He.jsx("div", { ref: L, className: "fc:flex-shrink-0", children: /* @__PURE__ */ He.jsx(
      LMe,
      {
        currentPage: z,
        totalPages: h,
        onPageChange: (Mt) => Oe(Mt, F.current),
        scale: P,
        onScaleChange: Ae,
        pdfUrl: e,
        fileName: t || "document.pdf",
        hideDownloadButton: c,
        searchTerm: it,
        setSearchTerm: Dt,
        performSearch: ni,
        clearSearch: Di,
        totalMatches: Xt,
        currentMatchIndex: Zt,
        searchNextMatch: gi,
        searchPreviousMatch: Wt,
        isSearching: Kt
      }
    ) }),
    /* @__PURE__ */ He.jsx(
      "div",
      {
        ref: F,
        className: "fc:overflow-y-auto fc:overflow-x-auto fc:flex-1 fc:bg-gray-100 fc:min-h-0",
        style: { scrollbarWidth: "auto" },
        children: /* @__PURE__ */ He.jsx("div", { className: "fc:py-4 fc:flex fc:flex-col fc:items-center fc:min-w-full", children: /* @__PURE__ */ He.jsx("div", { className: "fc:w-fit fc:mx-auto", children: Array.from({ length: h }, (Mt, ft) => si(ft)) }) })
      }
    )
  ] });
}, UEe = () => {
  if (typeof window > "u") return "en";
  try {
    const e = localStorage.getItem("i18nextLng");
    return e || navigator.language.split("-")[0] || "en";
  } catch {
    return "en";
  }
};
class _Me {
  constructor() {
    Zi(this, "currentLanguage");
    Zi(this, "listeners", /* @__PURE__ */ new Set());
    Zi(this, "initialized", !1);
    this.currentLanguage = UEe(), this.setupEventListeners();
  }
  setupEventListeners() {
    if (this.initialized || typeof window > "u") return;
    console.log("FacadeLanguageManager: Setting up global event listeners"), this.initialized = !0;
    const t = (n) => {
      const s = n.detail.language;
      console.log(
        "FacadeLanguageManager: Received language change event:",
        s,
        "current:",
        this.currentLanguage
      ), s && s !== this.currentLanguage && this.setLanguage(s);
    }, i = (n) => {
      if (n.key === "i18nextLng" && n.newValue) {
        const s = n.newValue;
        console.log("FacadeLanguageManager: Storage change detected:", s), s !== this.currentLanguage && this.setLanguage(s);
      }
    };
    window.addEventListener("facade-language-change", t), window.addEventListener("storage", i), setInterval(() => {
      const n = UEe();
      n !== this.currentLanguage && (console.log("FacadeLanguageManager: Polling detected language change:", n), this.setLanguage(n));
    }, 1e3);
  }
  setLanguage(t) {
    t !== this.currentLanguage && (console.log(
      "FacadeLanguageManager: Changing language from",
      this.currentLanguage,
      "to",
      t
    ), this.currentLanguage = t, Sf.changeLanguage(t), this.listeners.forEach((i) => {
      try {
        i(t);
      } catch (n) {
        console.error("FacadeLanguageManager: Error in language listener:", n);
      }
    }));
  }
  getCurrentLanguage() {
    return this.currentLanguage;
  }
  subscribe(t) {
    return console.log("FacadeLanguageManager: Adding listener, total:", this.listeners.size + 1), this.listeners.add(t), () => {
      console.log("FacadeLanguageManager: Removing listener, total:", this.listeners.size - 1), this.listeners.delete(t);
    };
  }
}
const BEe = new _Me(), M8 = () => {
  const [e, t] = Is(
    () => BEe.getCurrentLanguage()
  );
  return vr(() => BEe.subscribe((s) => {
    t(s);
  }), []), { t: On((n, s) => Sf.t(n, s), []), language: e };
};
/**
 * @license
 * Copyright 2010-2025 Three.js Authors
 * SPDX-License-Identifier: MIT
 */
const Hpe = "178", xMe = { LEFT: 0, MIDDLE: 1, RIGHT: 2, ROTATE: 0, DOLLY: 1, PAN: 2 }, PMe = 0, FEe = 1, MMe = 2, sAe = 1, UMe = 2, WD = 3, xA = 0, nE = 1, $y = 2, CP = 0, Sz = 1, HEe = 2, GEe = 3, kEe = 4, BMe = 5, YU = 100, FMe = 101, HMe = 102, GMe = 103, kMe = 104, VMe = 200, zMe = 201, jMe = 202, WMe = 203, o1e = 204, r1e = 205, YMe = 206, qMe = 207, $Me = 208, KMe = 209, ZMe = 210, QMe = 211, JMe = 212, XMe = 213, e9e = 214, l1e = 0, a1e = 1, u1e = 2, DW = 3, d1e = 4, c1e = 5, h1e = 6, f1e = 7, Gpe = 0, t9e = 1, i9e = 2, OP = 0, n9e = 1, s9e = 2, o9e = 3, r9e = 4, l9e = 5, a9e = 6, u9e = 7, oAe = 300, CW = 301, OW = 302, I1e = 303, p1e = 304, Rae = 306, m1e = 1e3, oB = 1001, y1e = 1002, g4 = 1003, d9e = 1004, Ane = 1005, dN = 1006, yde = 1007, rB = 1008, PA = 1009, rAe = 1010, lAe = 1011, fX = 1012, kpe = 1013, JF = 1014, cN = 1015, yie = 1016, Vpe = 1017, zpe = 1018, IX = 1020, aAe = 35902, uAe = 1021, dAe = 1022, y5 = 1023, pX = 1026, mX = 1027, jpe = 1028, Wpe = 1029, cAe = 1030, Ype = 1031, qpe = 1033, Uoe = 33776, Boe = 33777, Foe = 33778, Hoe = 33779, E1e = 35840, g1e = 35841, w1e = 35842, T1e = 35843, R1e = 36196, v1e = 37492, A1e = 37496, S1e = 37808, b1e = 37809, N1e = 37810, D1e = 37811, C1e = 37812, O1e = 37813, L1e = 37814, _1e = 37815, x1e = 37816, P1e = 37817, M1e = 37818, U1e = 37819, B1e = 37820, F1e = 37821, Goe = 36492, H1e = 36494, G1e = 36495, hAe = 36283, k1e = 36284, V1e = 36285, z1e = 36286, c9e = 3200, h9e = 3201, fAe = 0, f9e = 1, ux = "", Hy = "srgb", LW = "srgb-linear", Ile = "linear", Dl = "srgb", Uk = 7680, VEe = 519, I9e = 512, p9e = 513, m9e = 514, IAe = 515, y9e = 516, E9e = 517, g9e = 518, w9e = 519, j1e = 35044, zEe = "300 es", hN = 2e3, ple = 2001;
let LH = class {
  /**
   * Adds the given event listener to the given event type.
   *
   * @param {string} type - The type of event to listen to.
   * @param {Function} listener - The function that gets called when the event is fired.
   */
  addEventListener(t, i) {
    this._listeners === void 0 && (this._listeners = {});
    const n = this._listeners;
    n[t] === void 0 && (n[t] = []), n[t].indexOf(i) === -1 && n[t].push(i);
  }
  /**
   * Returns `true` if the given event listener has been added to the given event type.
   *
   * @param {string} type - The type of event.
   * @param {Function} listener - The listener to check.
   * @return {boolean} Whether the given event listener has been added to the given event type.
   */
  hasEventListener(t, i) {
    const n = this._listeners;
    return n === void 0 ? !1 : n[t] !== void 0 && n[t].indexOf(i) !== -1;
  }
  /**
   * Removes the given event listener from the given event type.
   *
   * @param {string} type - The type of event.
   * @param {Function} listener - The listener to remove.
   */
  removeEventListener(t, i) {
    const n = this._listeners;
    if (n === void 0) return;
    const s = n[t];
    if (s !== void 0) {
      const o = s.indexOf(i);
      o !== -1 && s.splice(o, 1);
    }
  }
  /**
   * Dispatches an event object.
   *
   * @param {Object} event - The event that gets fired.
   */
  dispatchEvent(t) {
    const i = this._listeners;
    if (i === void 0) return;
    const n = i[t.type];
    if (n !== void 0) {
      t.target = this;
      const s = n.slice(0);
      for (let o = 0, r = s.length; o < r; o++)
        s[o].call(this, t);
      t.target = null;
    }
  }
};
const Cm = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "0a", "0b", "0c", "0d", "0e", "0f", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "1a", "1b", "1c", "1d", "1e", "1f", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "2a", "2b", "2c", "2d", "2e", "2f", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "3a", "3b", "3c", "3d", "3e", "3f", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "4a", "4b", "4c", "4d", "4e", "4f", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59", "5a", "5b", "5c", "5d", "5e", "5f", "60", "61", "62", "63", "64", "65", "66", "67", "68", "69", "6a", "6b", "6c", "6d", "6e", "6f", "70", "71", "72", "73", "74", "75", "76", "77", "78", "79", "7a", "7b", "7c", "7d", "7e", "7f", "80", "81", "82", "83", "84", "85", "86", "87", "88", "89", "8a", "8b", "8c", "8d", "8e", "8f", "90", "91", "92", "93", "94", "95", "96", "97", "98", "99", "9a", "9b", "9c", "9d", "9e", "9f", "a0", "a1", "a2", "a3", "a4", "a5", "a6", "a7", "a8", "a9", "aa", "ab", "ac", "ad", "ae", "af", "b0", "b1", "b2", "b3", "b4", "b5", "b6", "b7", "b8", "b9", "ba", "bb", "bc", "bd", "be", "bf", "c0", "c1", "c2", "c3", "c4", "c5", "c6", "c7", "c8", "c9", "ca", "cb", "cc", "cd", "ce", "cf", "d0", "d1", "d2", "d3", "d4", "d5", "d6", "d7", "d8", "d9", "da", "db", "dc", "dd", "de", "df", "e0", "e1", "e2", "e3", "e4", "e5", "e6", "e7", "e8", "e9", "ea", "eb", "ec", "ed", "ee", "ef", "f0", "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9", "fa", "fb", "fc", "fd", "fe", "ff"];
let jEe = 1234567;
const vJ = Math.PI / 180, yX = 180 / Math.PI;
function jO() {
  const e = Math.random() * 4294967295 | 0, t = Math.random() * 4294967295 | 0, i = Math.random() * 4294967295 | 0, n = Math.random() * 4294967295 | 0;
  return (Cm[e & 255] + Cm[e >> 8 & 255] + Cm[e >> 16 & 255] + Cm[e >> 24 & 255] + "-" + Cm[t & 255] + Cm[t >> 8 & 255] + "-" + Cm[t >> 16 & 15 | 64] + Cm[t >> 24 & 255] + "-" + Cm[i & 63 | 128] + Cm[i >> 8 & 255] + "-" + Cm[i >> 16 & 255] + Cm[i >> 24 & 255] + Cm[n & 255] + Cm[n >> 8 & 255] + Cm[n >> 16 & 255] + Cm[n >> 24 & 255]).toLowerCase();
}
function Ho(e, t, i) {
  return Math.max(t, Math.min(i, e));
}
function $pe(e, t) {
  return (e % t + t) % t;
}
function T9e(e, t, i, n, s) {
  return n + (e - t) * (s - n) / (i - t);
}
function R9e(e, t, i) {
  return e !== t ? (i - e) / (t - e) : 0;
}
function AJ(e, t, i) {
  return (1 - i) * e + i * t;
}
function v9e(e, t, i, n) {
  return AJ(e, t, 1 - Math.exp(-i * n));
}
function A9e(e, t = 1) {
  return t - Math.abs($pe(e, t * 2) - t);
}
function S9e(e, t, i) {
  return e <= t ? 0 : e >= i ? 1 : (e = (e - t) / (i - t), e * e * (3 - 2 * e));
}
function b9e(e, t, i) {
  return e <= t ? 0 : e >= i ? 1 : (e = (e - t) / (i - t), e * e * e * (e * (e * 6 - 15) + 10));
}
function N9e(e, t) {
  return e + Math.floor(Math.random() * (t - e + 1));
}
function D9e(e, t) {
  return e + Math.random() * (t - e);
}
function C9e(e) {
  return e * (0.5 - Math.random());
}
function O9e(e) {
  e !== void 0 && (jEe = e);
  let t = jEe += 1831565813;
  return t = Math.imul(t ^ t >>> 15, t | 1), t ^= t + Math.imul(t ^ t >>> 7, t | 61), ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function L9e(e) {
  return e * vJ;
}
function _9e(e) {
  return e * yX;
}
function x9e(e) {
  return (e & e - 1) === 0 && e !== 0;
}
function P9e(e) {
  return Math.pow(2, Math.ceil(Math.log(e) / Math.LN2));
}
function M9e(e) {
  return Math.pow(2, Math.floor(Math.log(e) / Math.LN2));
}
function U9e(e, t, i, n, s) {
  const o = Math.cos, r = Math.sin, l = o(i / 2), c = r(i / 2), h = o((t + n) / 2), I = r((t + n) / 2), p = o((t - n) / 2), y = r((t - n) / 2), m = o((n - t) / 2), A = r((n - t) / 2);
  switch (s) {
    case "XYX":
      e.set(l * I, c * p, c * y, l * h);
      break;
    case "YZY":
      e.set(c * y, l * I, c * p, l * h);
      break;
    case "ZXZ":
      e.set(c * p, c * y, l * I, l * h);
      break;
    case "XZX":
      e.set(l * I, c * A, c * m, l * h);
      break;
    case "YXY":
      e.set(c * m, l * I, c * A, l * h);
      break;
    case "ZYZ":
      e.set(c * A, c * m, l * I, l * h);
      break;
    default:
      console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + s);
  }
}
function Lv(e, t) {
  switch (t.constructor) {
    case Float32Array:
      return e;
    case Uint32Array:
      return e / 4294967295;
    case Uint16Array:
      return e / 65535;
    case Uint8Array:
      return e / 255;
    case Int32Array:
      return Math.max(e / 2147483647, -1);
    case Int16Array:
      return Math.max(e / 32767, -1);
    case Int8Array:
      return Math.max(e / 127, -1);
    default:
      throw new Error("Invalid component type.");
  }
}
function Tl(e, t) {
  switch (t.constructor) {
    case Float32Array:
      return e;
    case Uint32Array:
      return Math.round(e * 4294967295);
    case Uint16Array:
      return Math.round(e * 65535);
    case Uint8Array:
      return Math.round(e * 255);
    case Int32Array:
      return Math.round(e * 2147483647);
    case Int16Array:
      return Math.round(e * 32767);
    case Int8Array:
      return Math.round(e * 127);
    default:
      throw new Error("Invalid component type.");
  }
}
const Eie = {
  DEG2RAD: vJ,
  RAD2DEG: yX,
  /**
   * Generate a [UUID]{@link https://en.wikipedia.org/wiki/Universally_unique_identifier}
   * (universally unique identifier).
   *
   * @static
   * @method
   * @return {string} The UUID.
   */
  generateUUID: jO,
  /**
   * Clamps the given value between min and max.
   *
   * @static
   * @method
   * @param {number} value - The value to clamp.
   * @param {number} min - The min value.
   * @param {number} max - The max value.
   * @return {number} The clamped value.
   */
  clamp: Ho,
  /**
   * Computes the Euclidean modulo of the given parameters that
   * is `( ( n % m ) + m ) % m`.
   *
   * @static
   * @method
   * @param {number} n - The first parameter.
   * @param {number} m - The second parameter.
   * @return {number} The Euclidean modulo.
   */
  euclideanModulo: $pe,
  /**
   * Performs a linear mapping from range `<a1, a2>` to range `<b1, b2>`
   * for the given value.
   *
   * @static
   * @method
   * @param {number} x - The value to be mapped.
   * @param {number} a1 - Minimum value for range A.
   * @param {number} a2 - Maximum value for range A.
   * @param {number} b1 - Minimum value for range B.
   * @param {number} b2 - Maximum value for range B.
   * @return {number} The mapped value.
   */
  mapLinear: T9e,
  /**
   * Returns the percentage in the closed interval `[0, 1]` of the given value
   * between the start and end point.
   *
   * @static
   * @method
   * @param {number} x - The start point
   * @param {number} y - The end point.
   * @param {number} value - A value between start and end.
   * @return {number} The interpolation factor.
   */
  inverseLerp: R9e,
  /**
   * Returns a value linearly interpolated from two known points based on the given interval -
   * `t = 0` will return `x` and `t = 1` will return `y`.
   *
   * @static
   * @method
   * @param {number} x - The start point
   * @param {number} y - The end point.
   * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
   * @return {number} The interpolated value.
   */
  lerp: AJ,
  /**
   * Smoothly interpolate a number from `x` to `y` in  a spring-like manner using a delta
   * time to maintain frame rate independent movement. For details, see
   * [Frame rate independent damping using lerp]{@link http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/}.
   *
   * @static
   * @method
   * @param {number} x - The current point.
   * @param {number} y - The target point.
   * @param {number} lambda - A higher lambda value will make the movement more sudden,
   * and a lower value will make the movement more gradual.
   * @param {number} dt - Delta time in seconds.
   * @return {number} The interpolated value.
   */
  damp: v9e,
  /**
   * Returns a value that alternates between `0` and the given `length` parameter.
   *
   * @static
   * @method
   * @param {number} x - The value to pingpong.
   * @param {number} [length=1] - The positive value the function will pingpong to.
   * @return {number} The alternated value.
   */
  pingpong: A9e,
  /**
   * Returns a value in the range `[0,1]` that represents the percentage that `x` has
   * moved between `min` and `max`, but smoothed or slowed down the closer `x` is to
   * the `min` and `max`.
   *
   * See [Smoothstep]{@link http://en.wikipedia.org/wiki/Smoothstep} for more details.
   *
   * @static
   * @method
   * @param {number} x - The value to evaluate based on its position between min and max.
   * @param {number} min - The min value. Any x value below min will be `0`.
   * @param {number} max - The max value. Any x value above max will be `1`.
   * @return {number} The alternated value.
   */
  smoothstep: S9e,
  /**
   * A [variation on smoothstep]{@link https://en.wikipedia.org/wiki/Smoothstep#Variations}
   * that has zero 1st and 2nd order derivatives at x=0 and x=1.
   *
   * @static
   * @method
   * @param {number} x - The value to evaluate based on its position between min and max.
   * @param {number} min - The min value. Any x value below min will be `0`.
   * @param {number} max - The max value. Any x value above max will be `1`.
   * @return {number} The alternated value.
   */
  smootherstep: b9e,
  /**
   * Returns a random integer from `<low, high>` interval.
   *
   * @static
   * @method
   * @param {number} low - The lower value boundary.
   * @param {number} high - The upper value boundary
   * @return {number} A random integer.
   */
  randInt: N9e,
  /**
   * Returns a random float from `<low, high>` interval.
   *
   * @static
   * @method
   * @param {number} low - The lower value boundary.
   * @param {number} high - The upper value boundary
   * @return {number} A random float.
   */
  randFloat: D9e,
  /**
   * Returns a random integer from `<-range/2, range/2>` interval.
   *
   * @static
   * @method
   * @param {number} range - Defines the value range.
   * @return {number} A random float.
   */
  randFloatSpread: C9e,
  /**
   * Returns a deterministic pseudo-random float in the interval `[0, 1]`.
   *
   * @static
   * @method
   * @param {number} [s] - The integer seed.
   * @return {number} A random float.
   */
  seededRandom: O9e,
  /**
   * Converts degrees to radians.
   *
   * @static
   * @method
   * @param {number} degrees - A value in degrees.
   * @return {number} The converted value in radians.
   */
  degToRad: L9e,
  /**
   * Converts radians to degrees.
   *
   * @static
   * @method
   * @param {number} radians - A value in radians.
   * @return {number} The converted value in degrees.
   */
  radToDeg: _9e,
  /**
   * Returns `true` if the given number is a power of two.
   *
   * @static
   * @method
   * @param {number} value - The value to check.
   * @return {boolean} Whether the given number is a power of two or not.
   */
  isPowerOfTwo: x9e,
  /**
   * Returns the smallest power of two that is greater than or equal to the given number.
   *
   * @static
   * @method
   * @param {number} value - The value to find a POT for.
   * @return {number} The smallest power of two that is greater than or equal to the given number.
   */
  ceilPowerOfTwo: P9e,
  /**
   * Returns the largest power of two that is less than or equal to the given number.
   *
   * @static
   * @method
   * @param {number} value - The value to find a POT for.
   * @return {number} The largest power of two that is less than or equal to the given number.
   */
  floorPowerOfTwo: M9e,
  /**
   * Sets the given quaternion from the [Intrinsic Proper Euler Angles]{@link https://en.wikipedia.org/wiki/Euler_angles}
   * defined by the given angles and order.
   *
   * Rotations are applied to the axes in the order specified by order:
   * rotation by angle `a` is applied first, then by angle `b`, then by angle `c`.
   *
   * @static
   * @method
   * @param {Quaternion} q - The quaternion to set.
   * @param {number} a - The rotation applied to the first axis, in radians.
   * @param {number} b - The rotation applied to the second axis, in radians.
   * @param {number} c - The rotation applied to the third axis, in radians.
   * @param {('XYX'|'XZX'|'YXY'|'YZY'|'ZXZ'|'ZYZ')} order - A string specifying the axes order.
   */
  setQuaternionFromProperEuler: U9e,
  /**
   * Normalizes the given value according to the given typed array.
   *
   * @static
   * @method
   * @param {number} value - The float value in the range `[0,1]` to normalize.
   * @param {TypedArray} array - The typed array that defines the data type of the value.
   * @return {number} The normalize value.
   */
  normalize: Tl,
  /**
   * Denormalizes the given value according to the given typed array.
   *
   * @static
   * @method
   * @param {number} value - The value to denormalize.
   * @param {TypedArray} array - The typed array that defines the data type of the value.
   * @return {number} The denormalize (float) value in the range `[0,1]`.
   */
  denormalize: Lv
};
class us {
  /**
   * Constructs a new 2D vector.
   *
   * @param {number} [x=0] - The x value of this vector.
   * @param {number} [y=0] - The y value of this vector.
   */
  constructor(t = 0, i = 0) {
    us.prototype.isVector2 = !0, this.x = t, this.y = i;
  }
  /**
   * Alias for {@link Vector2#x}.
   *
   * @type {number}
   */
  get width() {
    return this.x;
  }
  set width(t) {
    this.x = t;
  }
  /**
   * Alias for {@link Vector2#y}.
   *
   * @type {number}
   */
  get height() {
    return this.y;
  }
  set height(t) {
    this.y = t;
  }
  /**
   * Sets the vector components.
   *
   * @param {number} x - The value of the x component.
   * @param {number} y - The value of the y component.
   * @return {Vector2} A reference to this vector.
   */
  set(t, i) {
    return this.x = t, this.y = i, this;
  }
  /**
   * Sets the vector components to the same value.
   *
   * @param {number} scalar - The value to set for all vector components.
   * @return {Vector2} A reference to this vector.
   */
  setScalar(t) {
    return this.x = t, this.y = t, this;
  }
  /**
   * Sets the vector's x component to the given value
   *
   * @param {number} x - The value to set.
   * @return {Vector2} A reference to this vector.
   */
  setX(t) {
    return this.x = t, this;
  }
  /**
   * Sets the vector's y component to the given value
   *
   * @param {number} y - The value to set.
   * @return {Vector2} A reference to this vector.
   */
  setY(t) {
    return this.y = t, this;
  }
  /**
   * Allows to set a vector component with an index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y.
   * @param {number} value - The value to set.
   * @return {Vector2} A reference to this vector.
   */
  setComponent(t, i) {
    switch (t) {
      case 0:
        this.x = i;
        break;
      case 1:
        this.y = i;
        break;
      default:
        throw new Error("index is out of range: " + t);
    }
    return this;
  }
  /**
   * Returns the value of the vector component which matches the given index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y.
   * @return {number} A vector component value.
   */
  getComponent(t) {
    switch (t) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      default:
        throw new Error("index is out of range: " + t);
    }
  }
  /**
   * Returns a new vector with copied values from this instance.
   *
   * @return {Vector2} A clone of this instance.
   */
  clone() {
    return new this.constructor(this.x, this.y);
  }
  /**
   * Copies the values of the given vector to this instance.
   *
   * @param {Vector2} v - The vector to copy.
   * @return {Vector2} A reference to this vector.
   */
  copy(t) {
    return this.x = t.x, this.y = t.y, this;
  }
  /**
   * Adds the given vector to this instance.
   *
   * @param {Vector2} v - The vector to add.
   * @return {Vector2} A reference to this vector.
   */
  add(t) {
    return this.x += t.x, this.y += t.y, this;
  }
  /**
   * Adds the given scalar value to all components of this instance.
   *
   * @param {number} s - The scalar to add.
   * @return {Vector2} A reference to this vector.
   */
  addScalar(t) {
    return this.x += t, this.y += t, this;
  }
  /**
   * Adds the given vectors and stores the result in this instance.
   *
   * @param {Vector2} a - The first vector.
   * @param {Vector2} b - The second vector.
   * @return {Vector2} A reference to this vector.
   */
  addVectors(t, i) {
    return this.x = t.x + i.x, this.y = t.y + i.y, this;
  }
  /**
   * Adds the given vector scaled by the given factor to this instance.
   *
   * @param {Vector2} v - The vector.
   * @param {number} s - The factor that scales `v`.
   * @return {Vector2} A reference to this vector.
   */
  addScaledVector(t, i) {
    return this.x += t.x * i, this.y += t.y * i, this;
  }
  /**
   * Subtracts the given vector from this instance.
   *
   * @param {Vector2} v - The vector to subtract.
   * @return {Vector2} A reference to this vector.
   */
  sub(t) {
    return this.x -= t.x, this.y -= t.y, this;
  }
  /**
   * Subtracts the given scalar value from all components of this instance.
   *
   * @param {number} s - The scalar to subtract.
   * @return {Vector2} A reference to this vector.
   */
  subScalar(t) {
    return this.x -= t, this.y -= t, this;
  }
  /**
   * Subtracts the given vectors and stores the result in this instance.
   *
   * @param {Vector2} a - The first vector.
   * @param {Vector2} b - The second vector.
   * @return {Vector2} A reference to this vector.
   */
  subVectors(t, i) {
    return this.x = t.x - i.x, this.y = t.y - i.y, this;
  }
  /**
   * Multiplies the given vector with this instance.
   *
   * @param {Vector2} v - The vector to multiply.
   * @return {Vector2} A reference to this vector.
   */
  multiply(t) {
    return this.x *= t.x, this.y *= t.y, this;
  }
  /**
   * Multiplies the given scalar value with all components of this instance.
   *
   * @param {number} scalar - The scalar to multiply.
   * @return {Vector2} A reference to this vector.
   */
  multiplyScalar(t) {
    return this.x *= t, this.y *= t, this;
  }
  /**
   * Divides this instance by the given vector.
   *
   * @param {Vector2} v - The vector to divide.
   * @return {Vector2} A reference to this vector.
   */
  divide(t) {
    return this.x /= t.x, this.y /= t.y, this;
  }
  /**
   * Divides this vector by the given scalar.
   *
   * @param {number} scalar - The scalar to divide.
   * @return {Vector2} A reference to this vector.
   */
  divideScalar(t) {
    return this.multiplyScalar(1 / t);
  }
  /**
   * Multiplies this vector (with an implicit 1 as the 3rd component) by
   * the given 3x3 matrix.
   *
   * @param {Matrix3} m - The matrix to apply.
   * @return {Vector2} A reference to this vector.
   */
  applyMatrix3(t) {
    const i = this.x, n = this.y, s = t.elements;
    return this.x = s[0] * i + s[3] * n + s[6], this.y = s[1] * i + s[4] * n + s[7], this;
  }
  /**
   * If this vector's x or y value is greater than the given vector's x or y
   * value, replace that value with the corresponding min value.
   *
   * @param {Vector2} v - The vector.
   * @return {Vector2} A reference to this vector.
   */
  min(t) {
    return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this;
  }
  /**
   * If this vector's x or y value is less than the given vector's x or y
   * value, replace that value with the corresponding max value.
   *
   * @param {Vector2} v - The vector.
   * @return {Vector2} A reference to this vector.
   */
  max(t) {
    return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this;
  }
  /**
   * If this vector's x or y value is greater than the max vector's x or y
   * value, it is replaced by the corresponding value.
   * If this vector's x or y value is less than the min vector's x or y value,
   * it is replaced by the corresponding value.
   *
   * @param {Vector2} min - The minimum x and y values.
   * @param {Vector2} max - The maximum x and y values in the desired range.
   * @return {Vector2} A reference to this vector.
   */
  clamp(t, i) {
    return this.x = Ho(this.x, t.x, i.x), this.y = Ho(this.y, t.y, i.y), this;
  }
  /**
   * If this vector's x or y values are greater than the max value, they are
   * replaced by the max value.
   * If this vector's x or y values are less than the min value, they are
   * replaced by the min value.
   *
   * @param {number} minVal - The minimum value the components will be clamped to.
   * @param {number} maxVal - The maximum value the components will be clamped to.
   * @return {Vector2} A reference to this vector.
   */
  clampScalar(t, i) {
    return this.x = Ho(this.x, t, i), this.y = Ho(this.y, t, i), this;
  }
  /**
   * If this vector's length is greater than the max value, it is replaced by
   * the max value.
   * If this vector's length is less than the min value, it is replaced by the
   * min value.
   *
   * @param {number} min - The minimum value the vector length will be clamped to.
   * @param {number} max - The maximum value the vector length will be clamped to.
   * @return {Vector2} A reference to this vector.
   */
  clampLength(t, i) {
    const n = this.length();
    return this.divideScalar(n || 1).multiplyScalar(Ho(n, t, i));
  }
  /**
   * The components of this vector are rounded down to the nearest integer value.
   *
   * @return {Vector2} A reference to this vector.
   */
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
  }
  /**
   * The components of this vector are rounded up to the nearest integer value.
   *
   * @return {Vector2} A reference to this vector.
   */
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
  }
  /**
   * The components of this vector are rounded to the nearest integer value
   *
   * @return {Vector2} A reference to this vector.
   */
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
  }
  /**
   * The components of this vector are rounded towards zero (up if negative,
   * down if positive) to an integer value.
   *
   * @return {Vector2} A reference to this vector.
   */
  roundToZero() {
    return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this;
  }
  /**
   * Inverts this vector - i.e. sets x = -x and y = -y.
   *
   * @return {Vector2} A reference to this vector.
   */
  negate() {
    return this.x = -this.x, this.y = -this.y, this;
  }
  /**
   * Calculates the dot product of the given vector with this instance.
   *
   * @param {Vector2} v - The vector to compute the dot product with.
   * @return {number} The result of the dot product.
   */
  dot(t) {
    return this.x * t.x + this.y * t.y;
  }
  /**
   * Calculates the cross product of the given vector with this instance.
   *
   * @param {Vector2} v - The vector to compute the cross product with.
   * @return {number} The result of the cross product.
   */
  cross(t) {
    return this.x * t.y - this.y * t.x;
  }
  /**
   * Computes the square of the Euclidean length (straight-line length) from
   * (0, 0) to (x, y). If you are comparing the lengths of vectors, you should
   * compare the length squared instead as it is slightly more efficient to calculate.
   *
   * @return {number} The square length of this vector.
   */
  lengthSq() {
    return this.x * this.x + this.y * this.y;
  }
  /**
   * Computes the  Euclidean length (straight-line length) from (0, 0) to (x, y).
   *
   * @return {number} The length of this vector.
   */
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  }
  /**
   * Computes the Manhattan length of this vector.
   *
   * @return {number} The length of this vector.
   */
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y);
  }
  /**
   * Converts this vector to a unit vector - that is, sets it equal to a vector
   * with the same direction as this one, but with a vector length of `1`.
   *
   * @return {Vector2} A reference to this vector.
   */
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  /**
   * Computes the angle in radians of this vector with respect to the positive x-axis.
   *
   * @return {number} The angle in radians.
   */
  angle() {
    return Math.atan2(-this.y, -this.x) + Math.PI;
  }
  /**
   * Returns the angle between the given vector and this instance in radians.
   *
   * @param {Vector2} v - The vector to compute the angle with.
   * @return {number} The angle in radians.
   */
  angleTo(t) {
    const i = Math.sqrt(this.lengthSq() * t.lengthSq());
    if (i === 0) return Math.PI / 2;
    const n = this.dot(t) / i;
    return Math.acos(Ho(n, -1, 1));
  }
  /**
   * Computes the distance from the given vector to this instance.
   *
   * @param {Vector2} v - The vector to compute the distance to.
   * @return {number} The distance.
   */
  distanceTo(t) {
    return Math.sqrt(this.distanceToSquared(t));
  }
  /**
   * Computes the squared distance from the given vector to this instance.
   * If you are just comparing the distance with another distance, you should compare
   * the distance squared instead as it is slightly more efficient to calculate.
   *
   * @param {Vector2} v - The vector to compute the squared distance to.
   * @return {number} The squared distance.
   */
  distanceToSquared(t) {
    const i = this.x - t.x, n = this.y - t.y;
    return i * i + n * n;
  }
  /**
   * Computes the Manhattan distance from the given vector to this instance.
   *
   * @param {Vector2} v - The vector to compute the Manhattan distance to.
   * @return {number} The Manhattan distance.
   */
  manhattanDistanceTo(t) {
    return Math.abs(this.x - t.x) + Math.abs(this.y - t.y);
  }
  /**
   * Sets this vector to a vector with the same direction as this one, but
   * with the specified length.
   *
   * @param {number} length - The new length of this vector.
   * @return {Vector2} A reference to this vector.
   */
  setLength(t) {
    return this.normalize().multiplyScalar(t);
  }
  /**
   * Linearly interpolates between the given vector and this instance, where
   * alpha is the percent distance along the line - alpha = 0 will be this
   * vector, and alpha = 1 will be the given one.
   *
   * @param {Vector2} v - The vector to interpolate towards.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector2} A reference to this vector.
   */
  lerp(t, i) {
    return this.x += (t.x - this.x) * i, this.y += (t.y - this.y) * i, this;
  }
  /**
   * Linearly interpolates between the given vectors, where alpha is the percent
   * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
   * be the second one. The result is stored in this instance.
   *
   * @param {Vector2} v1 - The first vector.
   * @param {Vector2} v2 - The second vector.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector2} A reference to this vector.
   */
  lerpVectors(t, i, n) {
    return this.x = t.x + (i.x - t.x) * n, this.y = t.y + (i.y - t.y) * n, this;
  }
  /**
   * Returns `true` if this vector is equal with the given one.
   *
   * @param {Vector2} v - The vector to test for equality.
   * @return {boolean} Whether this vector is equal with the given one.
   */
  equals(t) {
    return t.x === this.x && t.y === this.y;
  }
  /**
   * Sets this vector's x value to be `array[ offset ]` and y
   * value to be `array[ offset + 1 ]`.
   *
   * @param {Array<number>} array - An array holding the vector component values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Vector2} A reference to this vector.
   */
  fromArray(t, i = 0) {
    return this.x = t[i], this.y = t[i + 1], this;
  }
  /**
   * Writes the components of this vector to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the vector components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The vector components.
   */
  toArray(t = [], i = 0) {
    return t[i] = this.x, t[i + 1] = this.y, t;
  }
  /**
   * Sets the components of this vector from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
   * @param {number} index - The index into the attribute.
   * @return {Vector2} A reference to this vector.
   */
  fromBufferAttribute(t, i) {
    return this.x = t.getX(i), this.y = t.getY(i), this;
  }
  /**
   * Rotates this vector around the given center by the given angle.
   *
   * @param {Vector2} center - The point around which to rotate.
   * @param {number} angle - The angle to rotate, in radians.
   * @return {Vector2} A reference to this vector.
   */
  rotateAround(t, i) {
    const n = Math.cos(i), s = Math.sin(i), o = this.x - t.x, r = this.y - t.y;
    return this.x = o * n - r * s + t.x, this.y = o * s + r * n + t.y, this;
  }
  /**
   * Sets each component of this vector to a pseudo-random value between `0` and
   * `1`, excluding `1`.
   *
   * @return {Vector2} A reference to this vector.
   */
  random() {
    return this.x = Math.random(), this.y = Math.random(), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y;
  }
}
class gI {
  /**
   * Constructs a new quaternion.
   *
   * @param {number} [x=0] - The x value of this quaternion.
   * @param {number} [y=0] - The y value of this quaternion.
   * @param {number} [z=0] - The z value of this quaternion.
   * @param {number} [w=1] - The w value of this quaternion.
   */
  constructor(t = 0, i = 0, n = 0, s = 1) {
    this.isQuaternion = !0, this._x = t, this._y = i, this._z = n, this._w = s;
  }
  /**
   * Interpolates between two quaternions via SLERP. This implementation assumes the
   * quaternion data are managed  in flat arrays.
   *
   * @param {Array<number>} dst - The destination array.
   * @param {number} dstOffset - An offset into the destination array.
   * @param {Array<number>} src0 - The source array of the first quaternion.
   * @param {number} srcOffset0 - An offset into the first source array.
   * @param {Array<number>} src1 -  The source array of the second quaternion.
   * @param {number} srcOffset1 - An offset into the second source array.
   * @param {number} t - The interpolation factor in the range `[0,1]`.
   * @see {@link Quaternion#slerp}
   */
  static slerpFlat(t, i, n, s, o, r, l) {
    let c = n[s + 0], h = n[s + 1], I = n[s + 2], p = n[s + 3];
    const y = o[r + 0], m = o[r + 1], A = o[r + 2], C = o[r + 3];
    if (l === 0) {
      t[i + 0] = c, t[i + 1] = h, t[i + 2] = I, t[i + 3] = p;
      return;
    }
    if (l === 1) {
      t[i + 0] = y, t[i + 1] = m, t[i + 2] = A, t[i + 3] = C;
      return;
    }
    if (p !== C || c !== y || h !== m || I !== A) {
      let O = 1 - l;
      const R = c * y + h * m + I * A + p * C, F = R >= 0 ? 1 : -1, L = 1 - R * R;
      if (L > Number.EPSILON) {
        const z = Math.sqrt(L), W = Math.atan2(z, R * F);
        O = Math.sin(O * W) / z, l = Math.sin(l * W) / z;
      }
      const P = l * F;
      if (c = c * O + y * P, h = h * O + m * P, I = I * O + A * P, p = p * O + C * P, O === 1 - l) {
        const z = 1 / Math.sqrt(c * c + h * h + I * I + p * p);
        c *= z, h *= z, I *= z, p *= z;
      }
    }
    t[i] = c, t[i + 1] = h, t[i + 2] = I, t[i + 3] = p;
  }
  /**
   * Multiplies two quaternions. This implementation assumes the quaternion data are managed
   * in flat arrays.
   *
   * @param {Array<number>} dst - The destination array.
   * @param {number} dstOffset - An offset into the destination array.
   * @param {Array<number>} src0 - The source array of the first quaternion.
   * @param {number} srcOffset0 - An offset into the first source array.
   * @param {Array<number>} src1 -  The source array of the second quaternion.
   * @param {number} srcOffset1 - An offset into the second source array.
   * @return {Array<number>} The destination array.
   * @see {@link Quaternion#multiplyQuaternions}.
   */
  static multiplyQuaternionsFlat(t, i, n, s, o, r) {
    const l = n[s], c = n[s + 1], h = n[s + 2], I = n[s + 3], p = o[r], y = o[r + 1], m = o[r + 2], A = o[r + 3];
    return t[i] = l * A + I * p + c * m - h * y, t[i + 1] = c * A + I * y + h * p - l * m, t[i + 2] = h * A + I * m + l * y - c * p, t[i + 3] = I * A - l * p - c * y - h * m, t;
  }
  /**
   * The x value of this quaternion.
   *
   * @type {number}
   * @default 0
   */
  get x() {
    return this._x;
  }
  set x(t) {
    this._x = t, this._onChangeCallback();
  }
  /**
   * The y value of this quaternion.
   *
   * @type {number}
   * @default 0
   */
  get y() {
    return this._y;
  }
  set y(t) {
    this._y = t, this._onChangeCallback();
  }
  /**
   * The z value of this quaternion.
   *
   * @type {number}
   * @default 0
   */
  get z() {
    return this._z;
  }
  set z(t) {
    this._z = t, this._onChangeCallback();
  }
  /**
   * The w value of this quaternion.
   *
   * @type {number}
   * @default 1
   */
  get w() {
    return this._w;
  }
  set w(t) {
    this._w = t, this._onChangeCallback();
  }
  /**
   * Sets the quaternion components.
   *
   * @param {number} x - The x value of this quaternion.
   * @param {number} y - The y value of this quaternion.
   * @param {number} z - The z value of this quaternion.
   * @param {number} w - The w value of this quaternion.
   * @return {Quaternion} A reference to this quaternion.
   */
  set(t, i, n, s) {
    return this._x = t, this._y = i, this._z = n, this._w = s, this._onChangeCallback(), this;
  }
  /**
   * Returns a new quaternion with copied values from this instance.
   *
   * @return {Quaternion} A clone of this instance.
   */
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._w);
  }
  /**
   * Copies the values of the given quaternion to this instance.
   *
   * @param {Quaternion} quaternion - The quaternion to copy.
   * @return {Quaternion} A reference to this quaternion.
   */
  copy(t) {
    return this._x = t.x, this._y = t.y, this._z = t.z, this._w = t.w, this._onChangeCallback(), this;
  }
  /**
   * Sets this quaternion from the rotation specified by the given
   * Euler angles.
   *
   * @param {Euler} euler - The Euler angles.
   * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
   * @return {Quaternion} A reference to this quaternion.
   */
  setFromEuler(t, i = !0) {
    const n = t._x, s = t._y, o = t._z, r = t._order, l = Math.cos, c = Math.sin, h = l(n / 2), I = l(s / 2), p = l(o / 2), y = c(n / 2), m = c(s / 2), A = c(o / 2);
    switch (r) {
      case "XYZ":
        this._x = y * I * p + h * m * A, this._y = h * m * p - y * I * A, this._z = h * I * A + y * m * p, this._w = h * I * p - y * m * A;
        break;
      case "YXZ":
        this._x = y * I * p + h * m * A, this._y = h * m * p - y * I * A, this._z = h * I * A - y * m * p, this._w = h * I * p + y * m * A;
        break;
      case "ZXY":
        this._x = y * I * p - h * m * A, this._y = h * m * p + y * I * A, this._z = h * I * A + y * m * p, this._w = h * I * p - y * m * A;
        break;
      case "ZYX":
        this._x = y * I * p - h * m * A, this._y = h * m * p + y * I * A, this._z = h * I * A - y * m * p, this._w = h * I * p + y * m * A;
        break;
      case "YZX":
        this._x = y * I * p + h * m * A, this._y = h * m * p + y * I * A, this._z = h * I * A - y * m * p, this._w = h * I * p - y * m * A;
        break;
      case "XZY":
        this._x = y * I * p - h * m * A, this._y = h * m * p - y * I * A, this._z = h * I * A + y * m * p, this._w = h * I * p + y * m * A;
        break;
      default:
        console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + r);
    }
    return i === !0 && this._onChangeCallback(), this;
  }
  /**
   * Sets this quaternion from the given axis and angle.
   *
   * @param {Vector3} axis - The normalized axis.
   * @param {number} angle - The angle in radians.
   * @return {Quaternion} A reference to this quaternion.
   */
  setFromAxisAngle(t, i) {
    const n = i / 2, s = Math.sin(n);
    return this._x = t.x * s, this._y = t.y * s, this._z = t.z * s, this._w = Math.cos(n), this._onChangeCallback(), this;
  }
  /**
   * Sets this quaternion from the given rotation matrix.
   *
   * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
   * @return {Quaternion} A reference to this quaternion.
   */
  setFromRotationMatrix(t) {
    const i = t.elements, n = i[0], s = i[4], o = i[8], r = i[1], l = i[5], c = i[9], h = i[2], I = i[6], p = i[10], y = n + l + p;
    if (y > 0) {
      const m = 0.5 / Math.sqrt(y + 1);
      this._w = 0.25 / m, this._x = (I - c) * m, this._y = (o - h) * m, this._z = (r - s) * m;
    } else if (n > l && n > p) {
      const m = 2 * Math.sqrt(1 + n - l - p);
      this._w = (I - c) / m, this._x = 0.25 * m, this._y = (s + r) / m, this._z = (o + h) / m;
    } else if (l > p) {
      const m = 2 * Math.sqrt(1 + l - n - p);
      this._w = (o - h) / m, this._x = (s + r) / m, this._y = 0.25 * m, this._z = (c + I) / m;
    } else {
      const m = 2 * Math.sqrt(1 + p - n - l);
      this._w = (r - s) / m, this._x = (o + h) / m, this._y = (c + I) / m, this._z = 0.25 * m;
    }
    return this._onChangeCallback(), this;
  }
  /**
   * Sets this quaternion to the rotation required to rotate the direction vector
   * `vFrom` to the direction vector `vTo`.
   *
   * @param {Vector3} vFrom - The first (normalized) direction vector.
   * @param {Vector3} vTo - The second (normalized) direction vector.
   * @return {Quaternion} A reference to this quaternion.
   */
  setFromUnitVectors(t, i) {
    let n = t.dot(i) + 1;
    return n < 1e-8 ? (n = 0, Math.abs(t.x) > Math.abs(t.z) ? (this._x = -t.y, this._y = t.x, this._z = 0, this._w = n) : (this._x = 0, this._y = -t.z, this._z = t.y, this._w = n)) : (this._x = t.y * i.z - t.z * i.y, this._y = t.z * i.x - t.x * i.z, this._z = t.x * i.y - t.y * i.x, this._w = n), this.normalize();
  }
  /**
   * Returns the angle between this quaternion and the given one in radians.
   *
   * @param {Quaternion} q - The quaternion to compute the angle with.
   * @return {number} The angle in radians.
   */
  angleTo(t) {
    return 2 * Math.acos(Math.abs(Ho(this.dot(t), -1, 1)));
  }
  /**
   * Rotates this quaternion by a given angular step to the given quaternion.
   * The method ensures that the final quaternion will not overshoot `q`.
   *
   * @param {Quaternion} q - The target quaternion.
   * @param {number} step - The angular step in radians.
   * @return {Quaternion} A reference to this quaternion.
   */
  rotateTowards(t, i) {
    const n = this.angleTo(t);
    if (n === 0) return this;
    const s = Math.min(1, i / n);
    return this.slerp(t, s), this;
  }
  /**
   * Sets this quaternion to the identity quaternion; that is, to the
   * quaternion that represents "no rotation".
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  identity() {
    return this.set(0, 0, 0, 1);
  }
  /**
   * Inverts this quaternion via {@link Quaternion#conjugate}. The
   * quaternion is assumed to have unit length.
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  invert() {
    return this.conjugate();
  }
  /**
   * Returns the rotational conjugate of this quaternion. The conjugate of a
   * quaternion represents the same rotation in the opposite direction about
   * the rotational axis.
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  conjugate() {
    return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
  }
  /**
   * Calculates the dot product of this quaternion and the given one.
   *
   * @param {Quaternion} v - The quaternion to compute the dot product with.
   * @return {number} The result of the dot product.
   */
  dot(t) {
    return this._x * t._x + this._y * t._y + this._z * t._z + this._w * t._w;
  }
  /**
   * Computes the squared Euclidean length (straight-line length) of this quaternion,
   * considered as a 4 dimensional vector. This can be useful if you are comparing the
   * lengths of two quaternions, as this is a slightly more efficient calculation than
   * {@link Quaternion#length}.
   *
   * @return {number} The squared Euclidean length.
   */
  lengthSq() {
    return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
  }
  /**
   * Computes the Euclidean length (straight-line length) of this quaternion,
   * considered as a 4 dimensional vector.
   *
   * @return {number} The Euclidean length.
   */
  length() {
    return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
  }
  /**
   * Normalizes this quaternion - that is, calculated the quaternion that performs
   * the same rotation as this one, but has a length equal to `1`.
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  normalize() {
    let t = this.length();
    return t === 0 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (t = 1 / t, this._x = this._x * t, this._y = this._y * t, this._z = this._z * t, this._w = this._w * t), this._onChangeCallback(), this;
  }
  /**
   * Multiplies this quaternion by the given one.
   *
   * @param {Quaternion} q - The quaternion.
   * @return {Quaternion} A reference to this quaternion.
   */
  multiply(t) {
    return this.multiplyQuaternions(this, t);
  }
  /**
   * Pre-multiplies this quaternion by the given one.
   *
   * @param {Quaternion} q - The quaternion.
   * @return {Quaternion} A reference to this quaternion.
   */
  premultiply(t) {
    return this.multiplyQuaternions(t, this);
  }
  /**
   * Multiplies the given quaternions and stores the result in this instance.
   *
   * @param {Quaternion} a - The first quaternion.
   * @param {Quaternion} b - The second quaternion.
   * @return {Quaternion} A reference to this quaternion.
   */
  multiplyQuaternions(t, i) {
    const n = t._x, s = t._y, o = t._z, r = t._w, l = i._x, c = i._y, h = i._z, I = i._w;
    return this._x = n * I + r * l + s * h - o * c, this._y = s * I + r * c + o * l - n * h, this._z = o * I + r * h + n * c - s * l, this._w = r * I - n * l - s * c - o * h, this._onChangeCallback(), this;
  }
  /**
   * Performs a spherical linear interpolation between quaternions.
   *
   * @param {Quaternion} qb - The target quaternion.
   * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
   * @return {Quaternion} A reference to this quaternion.
   */
  slerp(t, i) {
    if (i === 0) return this;
    if (i === 1) return this.copy(t);
    const n = this._x, s = this._y, o = this._z, r = this._w;
    let l = r * t._w + n * t._x + s * t._y + o * t._z;
    if (l < 0 ? (this._w = -t._w, this._x = -t._x, this._y = -t._y, this._z = -t._z, l = -l) : this.copy(t), l >= 1)
      return this._w = r, this._x = n, this._y = s, this._z = o, this;
    const c = 1 - l * l;
    if (c <= Number.EPSILON) {
      const m = 1 - i;
      return this._w = m * r + i * this._w, this._x = m * n + i * this._x, this._y = m * s + i * this._y, this._z = m * o + i * this._z, this.normalize(), this;
    }
    const h = Math.sqrt(c), I = Math.atan2(h, l), p = Math.sin((1 - i) * I) / h, y = Math.sin(i * I) / h;
    return this._w = r * p + this._w * y, this._x = n * p + this._x * y, this._y = s * p + this._y * y, this._z = o * p + this._z * y, this._onChangeCallback(), this;
  }
  /**
   * Performs a spherical linear interpolation between the given quaternions
   * and stores the result in this quaternion.
   *
   * @param {Quaternion} qa - The source quaternion.
   * @param {Quaternion} qb - The target quaternion.
   * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
   * @return {Quaternion} A reference to this quaternion.
   */
  slerpQuaternions(t, i, n) {
    return this.copy(t).slerp(i, n);
  }
  /**
   * Sets this quaternion to a uniformly random, normalized quaternion.
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  random() {
    const t = 2 * Math.PI * Math.random(), i = 2 * Math.PI * Math.random(), n = Math.random(), s = Math.sqrt(1 - n), o = Math.sqrt(n);
    return this.set(
      s * Math.sin(t),
      s * Math.cos(t),
      o * Math.sin(i),
      o * Math.cos(i)
    );
  }
  /**
   * Returns `true` if this quaternion is equal with the given one.
   *
   * @param {Quaternion} quaternion - The quaternion to test for equality.
   * @return {boolean} Whether this quaternion is equal with the given one.
   */
  equals(t) {
    return t._x === this._x && t._y === this._y && t._z === this._z && t._w === this._w;
  }
  /**
   * Sets this quaternion's components from the given array.
   *
   * @param {Array<number>} array - An array holding the quaternion component values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Quaternion} A reference to this quaternion.
   */
  fromArray(t, i = 0) {
    return this._x = t[i], this._y = t[i + 1], this._z = t[i + 2], this._w = t[i + 3], this._onChangeCallback(), this;
  }
  /**
   * Writes the components of this quaternion to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the quaternion components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The quaternion components.
   */
  toArray(t = [], i = 0) {
    return t[i] = this._x, t[i + 1] = this._y, t[i + 2] = this._z, t[i + 3] = this._w, t;
  }
  /**
   * Sets the components of this quaternion from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding quaternion data.
   * @param {number} index - The index into the attribute.
   * @return {Quaternion} A reference to this quaternion.
   */
  fromBufferAttribute(t, i) {
    return this._x = t.getX(i), this._y = t.getY(i), this._z = t.getZ(i), this._w = t.getW(i), this._onChangeCallback(), this;
  }
  /**
   * This methods defines the serialization result of this class. Returns the
   * numerical elements of this quaternion in an array of format `[x, y, z, w]`.
   *
   * @return {Array<number>} The serialized quaternion.
   */
  toJSON() {
    return this.toArray();
  }
  _onChange(t) {
    return this._onChangeCallback = t, this;
  }
  _onChangeCallback() {
  }
  *[Symbol.iterator]() {
    yield this._x, yield this._y, yield this._z, yield this._w;
  }
}
class Ge {
  /**
   * Constructs a new 3D vector.
   *
   * @param {number} [x=0] - The x value of this vector.
   * @param {number} [y=0] - The y value of this vector.
   * @param {number} [z=0] - The z value of this vector.
   */
  constructor(t = 0, i = 0, n = 0) {
    Ge.prototype.isVector3 = !0, this.x = t, this.y = i, this.z = n;
  }
  /**
   * Sets the vector components.
   *
   * @param {number} x - The value of the x component.
   * @param {number} y - The value of the y component.
   * @param {number} z - The value of the z component.
   * @return {Vector3} A reference to this vector.
   */
  set(t, i, n) {
    return n === void 0 && (n = this.z), this.x = t, this.y = i, this.z = n, this;
  }
  /**
   * Sets the vector components to the same value.
   *
   * @param {number} scalar - The value to set for all vector components.
   * @return {Vector3} A reference to this vector.
   */
  setScalar(t) {
    return this.x = t, this.y = t, this.z = t, this;
  }
  /**
   * Sets the vector's x component to the given value
   *
   * @param {number} x - The value to set.
   * @return {Vector3} A reference to this vector.
   */
  setX(t) {
    return this.x = t, this;
  }
  /**
   * Sets the vector's y component to the given value
   *
   * @param {number} y - The value to set.
   * @return {Vector3} A reference to this vector.
   */
  setY(t) {
    return this.y = t, this;
  }
  /**
   * Sets the vector's z component to the given value
   *
   * @param {number} z - The value to set.
   * @return {Vector3} A reference to this vector.
   */
  setZ(t) {
    return this.z = t, this;
  }
  /**
   * Allows to set a vector component with an index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
   * @param {number} value - The value to set.
   * @return {Vector3} A reference to this vector.
   */
  setComponent(t, i) {
    switch (t) {
      case 0:
        this.x = i;
        break;
      case 1:
        this.y = i;
        break;
      case 2:
        this.z = i;
        break;
      default:
        throw new Error("index is out of range: " + t);
    }
    return this;
  }
  /**
   * Returns the value of the vector component which matches the given index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
   * @return {number} A vector component value.
   */
  getComponent(t) {
    switch (t) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      default:
        throw new Error("index is out of range: " + t);
    }
  }
  /**
   * Returns a new vector with copied values from this instance.
   *
   * @return {Vector3} A clone of this instance.
   */
  clone() {
    return new this.constructor(this.x, this.y, this.z);
  }
  /**
   * Copies the values of the given vector to this instance.
   *
   * @param {Vector3} v - The vector to copy.
   * @return {Vector3} A reference to this vector.
   */
  copy(t) {
    return this.x = t.x, this.y = t.y, this.z = t.z, this;
  }
  /**
   * Adds the given vector to this instance.
   *
   * @param {Vector3} v - The vector to add.
   * @return {Vector3} A reference to this vector.
   */
  add(t) {
    return this.x += t.x, this.y += t.y, this.z += t.z, this;
  }
  /**
   * Adds the given scalar value to all components of this instance.
   *
   * @param {number} s - The scalar to add.
   * @return {Vector3} A reference to this vector.
   */
  addScalar(t) {
    return this.x += t, this.y += t, this.z += t, this;
  }
  /**
   * Adds the given vectors and stores the result in this instance.
   *
   * @param {Vector3} a - The first vector.
   * @param {Vector3} b - The second vector.
   * @return {Vector3} A reference to this vector.
   */
  addVectors(t, i) {
    return this.x = t.x + i.x, this.y = t.y + i.y, this.z = t.z + i.z, this;
  }
  /**
   * Adds the given vector scaled by the given factor to this instance.
   *
   * @param {Vector3|Vector4} v - The vector.
   * @param {number} s - The factor that scales `v`.
   * @return {Vector3} A reference to this vector.
   */
  addScaledVector(t, i) {
    return this.x += t.x * i, this.y += t.y * i, this.z += t.z * i, this;
  }
  /**
   * Subtracts the given vector from this instance.
   *
   * @param {Vector3} v - The vector to subtract.
   * @return {Vector3} A reference to this vector.
   */
  sub(t) {
    return this.x -= t.x, this.y -= t.y, this.z -= t.z, this;
  }
  /**
   * Subtracts the given scalar value from all components of this instance.
   *
   * @param {number} s - The scalar to subtract.
   * @return {Vector3} A reference to this vector.
   */
  subScalar(t) {
    return this.x -= t, this.y -= t, this.z -= t, this;
  }
  /**
   * Subtracts the given vectors and stores the result in this instance.
   *
   * @param {Vector3} a - The first vector.
   * @param {Vector3} b - The second vector.
   * @return {Vector3} A reference to this vector.
   */
  subVectors(t, i) {
    return this.x = t.x - i.x, this.y = t.y - i.y, this.z = t.z - i.z, this;
  }
  /**
   * Multiplies the given vector with this instance.
   *
   * @param {Vector3} v - The vector to multiply.
   * @return {Vector3} A reference to this vector.
   */
  multiply(t) {
    return this.x *= t.x, this.y *= t.y, this.z *= t.z, this;
  }
  /**
   * Multiplies the given scalar value with all components of this instance.
   *
   * @param {number} scalar - The scalar to multiply.
   * @return {Vector3} A reference to this vector.
   */
  multiplyScalar(t) {
    return this.x *= t, this.y *= t, this.z *= t, this;
  }
  /**
   * Multiplies the given vectors and stores the result in this instance.
   *
   * @param {Vector3} a - The first vector.
   * @param {Vector3} b - The second vector.
   * @return {Vector3} A reference to this vector.
   */
  multiplyVectors(t, i) {
    return this.x = t.x * i.x, this.y = t.y * i.y, this.z = t.z * i.z, this;
  }
  /**
   * Applies the given Euler rotation to this vector.
   *
   * @param {Euler} euler - The Euler angles.
   * @return {Vector3} A reference to this vector.
   */
  applyEuler(t) {
    return this.applyQuaternion(WEe.setFromEuler(t));
  }
  /**
   * Applies a rotation specified by an axis and an angle to this vector.
   *
   * @param {Vector3} axis - A normalized vector representing the rotation axis.
   * @param {number} angle - The angle in radians.
   * @return {Vector3} A reference to this vector.
   */
  applyAxisAngle(t, i) {
    return this.applyQuaternion(WEe.setFromAxisAngle(t, i));
  }
  /**
   * Multiplies this vector with the given 3x3 matrix.
   *
   * @param {Matrix3} m - The 3x3 matrix.
   * @return {Vector3} A reference to this vector.
   */
  applyMatrix3(t) {
    const i = this.x, n = this.y, s = this.z, o = t.elements;
    return this.x = o[0] * i + o[3] * n + o[6] * s, this.y = o[1] * i + o[4] * n + o[7] * s, this.z = o[2] * i + o[5] * n + o[8] * s, this;
  }
  /**
   * Multiplies this vector by the given normal matrix and normalizes
   * the result.
   *
   * @param {Matrix3} m - The normal matrix.
   * @return {Vector3} A reference to this vector.
   */
  applyNormalMatrix(t) {
    return this.applyMatrix3(t).normalize();
  }
  /**
   * Multiplies this vector (with an implicit 1 in the 4th dimension) by m, and
   * divides by perspective.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {Vector3} A reference to this vector.
   */
  applyMatrix4(t) {
    const i = this.x, n = this.y, s = this.z, o = t.elements, r = 1 / (o[3] * i + o[7] * n + o[11] * s + o[15]);
    return this.x = (o[0] * i + o[4] * n + o[8] * s + o[12]) * r, this.y = (o[1] * i + o[5] * n + o[9] * s + o[13]) * r, this.z = (o[2] * i + o[6] * n + o[10] * s + o[14]) * r, this;
  }
  /**
   * Applies the given Quaternion to this vector.
   *
   * @param {Quaternion} q - The Quaternion.
   * @return {Vector3} A reference to this vector.
   */
  applyQuaternion(t) {
    const i = this.x, n = this.y, s = this.z, o = t.x, r = t.y, l = t.z, c = t.w, h = 2 * (r * s - l * n), I = 2 * (l * i - o * s), p = 2 * (o * n - r * i);
    return this.x = i + c * h + r * p - l * I, this.y = n + c * I + l * h - o * p, this.z = s + c * p + o * I - r * h, this;
  }
  /**
   * Projects this vector from world space into the camera's normalized
   * device coordinate (NDC) space.
   *
   * @param {Camera} camera - The camera.
   * @return {Vector3} A reference to this vector.
   */
  project(t) {
    return this.applyMatrix4(t.matrixWorldInverse).applyMatrix4(t.projectionMatrix);
  }
  /**
   * Unprojects this vector from the camera's normalized device coordinate (NDC)
   * space into world space.
   *
   * @param {Camera} camera - The camera.
   * @return {Vector3} A reference to this vector.
   */
  unproject(t) {
    return this.applyMatrix4(t.projectionMatrixInverse).applyMatrix4(t.matrixWorld);
  }
  /**
   * Transforms the direction of this vector by a matrix (the upper left 3 x 3
   * subset of the given 4x4 matrix and then normalizes the result.
   *
   * @param {Matrix4} m - The matrix.
   * @return {Vector3} A reference to this vector.
   */
  transformDirection(t) {
    const i = this.x, n = this.y, s = this.z, o = t.elements;
    return this.x = o[0] * i + o[4] * n + o[8] * s, this.y = o[1] * i + o[5] * n + o[9] * s, this.z = o[2] * i + o[6] * n + o[10] * s, this.normalize();
  }
  /**
   * Divides this instance by the given vector.
   *
   * @param {Vector3} v - The vector to divide.
   * @return {Vector3} A reference to this vector.
   */
  divide(t) {
    return this.x /= t.x, this.y /= t.y, this.z /= t.z, this;
  }
  /**
   * Divides this vector by the given scalar.
   *
   * @param {number} scalar - The scalar to divide.
   * @return {Vector3} A reference to this vector.
   */
  divideScalar(t) {
    return this.multiplyScalar(1 / t);
  }
  /**
   * If this vector's x, y or z value is greater than the given vector's x, y or z
   * value, replace that value with the corresponding min value.
   *
   * @param {Vector3} v - The vector.
   * @return {Vector3} A reference to this vector.
   */
  min(t) {
    return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this.z = Math.min(this.z, t.z), this;
  }
  /**
   * If this vector's x, y or z value is less than the given vector's x, y or z
   * value, replace that value with the corresponding max value.
   *
   * @param {Vector3} v - The vector.
   * @return {Vector3} A reference to this vector.
   */
  max(t) {
    return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this.z = Math.max(this.z, t.z), this;
  }
  /**
   * If this vector's x, y or z value is greater than the max vector's x, y or z
   * value, it is replaced by the corresponding value.
   * If this vector's x, y or z value is less than the min vector's x, y or z value,
   * it is replaced by the corresponding value.
   *
   * @param {Vector3} min - The minimum x, y and z values.
   * @param {Vector3} max - The maximum x, y and z values in the desired range.
   * @return {Vector3} A reference to this vector.
   */
  clamp(t, i) {
    return this.x = Ho(this.x, t.x, i.x), this.y = Ho(this.y, t.y, i.y), this.z = Ho(this.z, t.z, i.z), this;
  }
  /**
   * If this vector's x, y or z values are greater than the max value, they are
   * replaced by the max value.
   * If this vector's x, y or z values are less than the min value, they are
   * replaced by the min value.
   *
   * @param {number} minVal - The minimum value the components will be clamped to.
   * @param {number} maxVal - The maximum value the components will be clamped to.
   * @return {Vector3} A reference to this vector.
   */
  clampScalar(t, i) {
    return this.x = Ho(this.x, t, i), this.y = Ho(this.y, t, i), this.z = Ho(this.z, t, i), this;
  }
  /**
   * If this vector's length is greater than the max value, it is replaced by
   * the max value.
   * If this vector's length is less than the min value, it is replaced by the
   * min value.
   *
   * @param {number} min - The minimum value the vector length will be clamped to.
   * @param {number} max - The maximum value the vector length will be clamped to.
   * @return {Vector3} A reference to this vector.
   */
  clampLength(t, i) {
    const n = this.length();
    return this.divideScalar(n || 1).multiplyScalar(Ho(n, t, i));
  }
  /**
   * The components of this vector are rounded down to the nearest integer value.
   *
   * @return {Vector3} A reference to this vector.
   */
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
  }
  /**
   * The components of this vector are rounded up to the nearest integer value.
   *
   * @return {Vector3} A reference to this vector.
   */
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
  }
  /**
   * The components of this vector are rounded to the nearest integer value
   *
   * @return {Vector3} A reference to this vector.
   */
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
  }
  /**
   * The components of this vector are rounded towards zero (up if negative,
   * down if positive) to an integer value.
   *
   * @return {Vector3} A reference to this vector.
   */
  roundToZero() {
    return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this;
  }
  /**
   * Inverts this vector - i.e. sets x = -x, y = -y and z = -z.
   *
   * @return {Vector3} A reference to this vector.
   */
  negate() {
    return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
  }
  /**
   * Calculates the dot product of the given vector with this instance.
   *
   * @param {Vector3} v - The vector to compute the dot product with.
   * @return {number} The result of the dot product.
   */
  dot(t) {
    return this.x * t.x + this.y * t.y + this.z * t.z;
  }
  // TODO lengthSquared?
  /**
   * Computes the square of the Euclidean length (straight-line length) from
   * (0, 0, 0) to (x, y, z). If you are comparing the lengths of vectors, you should
   * compare the length squared instead as it is slightly more efficient to calculate.
   *
   * @return {number} The square length of this vector.
   */
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z;
  }
  /**
   * Computes the  Euclidean length (straight-line length) from (0, 0, 0) to (x, y, z).
   *
   * @return {number} The length of this vector.
   */
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
  }
  /**
   * Computes the Manhattan length of this vector.
   *
   * @return {number} The length of this vector.
   */
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
  }
  /**
   * Converts this vector to a unit vector - that is, sets it equal to a vector
   * with the same direction as this one, but with a vector length of `1`.
   *
   * @return {Vector3} A reference to this vector.
   */
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  /**
   * Sets this vector to a vector with the same direction as this one, but
   * with the specified length.
   *
   * @param {number} length - The new length of this vector.
   * @return {Vector3} A reference to this vector.
   */
  setLength(t) {
    return this.normalize().multiplyScalar(t);
  }
  /**
   * Linearly interpolates between the given vector and this instance, where
   * alpha is the percent distance along the line - alpha = 0 will be this
   * vector, and alpha = 1 will be the given one.
   *
   * @param {Vector3} v - The vector to interpolate towards.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector3} A reference to this vector.
   */
  lerp(t, i) {
    return this.x += (t.x - this.x) * i, this.y += (t.y - this.y) * i, this.z += (t.z - this.z) * i, this;
  }
  /**
   * Linearly interpolates between the given vectors, where alpha is the percent
   * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
   * be the second one. The result is stored in this instance.
   *
   * @param {Vector3} v1 - The first vector.
   * @param {Vector3} v2 - The second vector.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector3} A reference to this vector.
   */
  lerpVectors(t, i, n) {
    return this.x = t.x + (i.x - t.x) * n, this.y = t.y + (i.y - t.y) * n, this.z = t.z + (i.z - t.z) * n, this;
  }
  /**
   * Calculates the cross product of the given vector with this instance.
   *
   * @param {Vector3} v - The vector to compute the cross product with.
   * @return {Vector3} The result of the cross product.
   */
  cross(t) {
    return this.crossVectors(this, t);
  }
  /**
   * Calculates the cross product of the given vectors and stores the result
   * in this instance.
   *
   * @param {Vector3} a - The first vector.
   * @param {Vector3} b - The second vector.
   * @return {Vector3} A reference to this vector.
   */
  crossVectors(t, i) {
    const n = t.x, s = t.y, o = t.z, r = i.x, l = i.y, c = i.z;
    return this.x = s * c - o * l, this.y = o * r - n * c, this.z = n * l - s * r, this;
  }
  /**
   * Projects this vector onto the given one.
   *
   * @param {Vector3} v - The vector to project to.
   * @return {Vector3} A reference to this vector.
   */
  projectOnVector(t) {
    const i = t.lengthSq();
    if (i === 0) return this.set(0, 0, 0);
    const n = t.dot(this) / i;
    return this.copy(t).multiplyScalar(n);
  }
  /**
   * Projects this vector onto a plane by subtracting this
   * vector projected onto the plane's normal from this vector.
   *
   * @param {Vector3} planeNormal - The plane normal.
   * @return {Vector3} A reference to this vector.
   */
  projectOnPlane(t) {
    return Ede.copy(this).projectOnVector(t), this.sub(Ede);
  }
  /**
   * Reflects this vector off a plane orthogonal to the given normal vector.
   *
   * @param {Vector3} normal - The (normalized) normal vector.
   * @return {Vector3} A reference to this vector.
   */
  reflect(t) {
    return this.sub(Ede.copy(t).multiplyScalar(2 * this.dot(t)));
  }
  /**
   * Returns the angle between the given vector and this instance in radians.
   *
   * @param {Vector3} v - The vector to compute the angle with.
   * @return {number} The angle in radians.
   */
  angleTo(t) {
    const i = Math.sqrt(this.lengthSq() * t.lengthSq());
    if (i === 0) return Math.PI / 2;
    const n = this.dot(t) / i;
    return Math.acos(Ho(n, -1, 1));
  }
  /**
   * Computes the distance from the given vector to this instance.
   *
   * @param {Vector3} v - The vector to compute the distance to.
   * @return {number} The distance.
   */
  distanceTo(t) {
    return Math.sqrt(this.distanceToSquared(t));
  }
  /**
   * Computes the squared distance from the given vector to this instance.
   * If you are just comparing the distance with another distance, you should compare
   * the distance squared instead as it is slightly more efficient to calculate.
   *
   * @param {Vector3} v - The vector to compute the squared distance to.
   * @return {number} The squared distance.
   */
  distanceToSquared(t) {
    const i = this.x - t.x, n = this.y - t.y, s = this.z - t.z;
    return i * i + n * n + s * s;
  }
  /**
   * Computes the Manhattan distance from the given vector to this instance.
   *
   * @param {Vector3} v - The vector to compute the Manhattan distance to.
   * @return {number} The Manhattan distance.
   */
  manhattanDistanceTo(t) {
    return Math.abs(this.x - t.x) + Math.abs(this.y - t.y) + Math.abs(this.z - t.z);
  }
  /**
   * Sets the vector components from the given spherical coordinates.
   *
   * @param {Spherical} s - The spherical coordinates.
   * @return {Vector3} A reference to this vector.
   */
  setFromSpherical(t) {
    return this.setFromSphericalCoords(t.radius, t.phi, t.theta);
  }
  /**
   * Sets the vector components from the given spherical coordinates.
   *
   * @param {number} radius - The radius.
   * @param {number} phi - The phi angle in radians.
   * @param {number} theta - The theta angle in radians.
   * @return {Vector3} A reference to this vector.
   */
  setFromSphericalCoords(t, i, n) {
    const s = Math.sin(i) * t;
    return this.x = s * Math.sin(n), this.y = Math.cos(i) * t, this.z = s * Math.cos(n), this;
  }
  /**
   * Sets the vector components from the given cylindrical coordinates.
   *
   * @param {Cylindrical} c - The cylindrical coordinates.
   * @return {Vector3} A reference to this vector.
   */
  setFromCylindrical(t) {
    return this.setFromCylindricalCoords(t.radius, t.theta, t.y);
  }
  /**
   * Sets the vector components from the given cylindrical coordinates.
   *
   * @param {number} radius - The radius.
   * @param {number} theta - The theta angle in radians.
   * @param {number} y - The y value.
   * @return {Vector3} A reference to this vector.
   */
  setFromCylindricalCoords(t, i, n) {
    return this.x = t * Math.sin(i), this.y = n, this.z = t * Math.cos(i), this;
  }
  /**
   * Sets the vector components to the position elements of the
   * given transformation matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Vector3} A reference to this vector.
   */
  setFromMatrixPosition(t) {
    const i = t.elements;
    return this.x = i[12], this.y = i[13], this.z = i[14], this;
  }
  /**
   * Sets the vector components to the scale elements of the
   * given transformation matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Vector3} A reference to this vector.
   */
  setFromMatrixScale(t) {
    const i = this.setFromMatrixColumn(t, 0).length(), n = this.setFromMatrixColumn(t, 1).length(), s = this.setFromMatrixColumn(t, 2).length();
    return this.x = i, this.y = n, this.z = s, this;
  }
  /**
   * Sets the vector components from the specified matrix column.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @param {number} index - The column index.
   * @return {Vector3} A reference to this vector.
   */
  setFromMatrixColumn(t, i) {
    return this.fromArray(t.elements, i * 4);
  }
  /**
   * Sets the vector components from the specified matrix column.
   *
   * @param {Matrix3} m - The 3x3 matrix.
   * @param {number} index - The column index.
   * @return {Vector3} A reference to this vector.
   */
  setFromMatrix3Column(t, i) {
    return this.fromArray(t.elements, i * 3);
  }
  /**
   * Sets the vector components from the given Euler angles.
   *
   * @param {Euler} e - The Euler angles to set.
   * @return {Vector3} A reference to this vector.
   */
  setFromEuler(t) {
    return this.x = t._x, this.y = t._y, this.z = t._z, this;
  }
  /**
   * Sets the vector components from the RGB components of the
   * given color.
   *
   * @param {Color} c - The color to set.
   * @return {Vector3} A reference to this vector.
   */
  setFromColor(t) {
    return this.x = t.r, this.y = t.g, this.z = t.b, this;
  }
  /**
   * Returns `true` if this vector is equal with the given one.
   *
   * @param {Vector3} v - The vector to test for equality.
   * @return {boolean} Whether this vector is equal with the given one.
   */
  equals(t) {
    return t.x === this.x && t.y === this.y && t.z === this.z;
  }
  /**
   * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`
   * and z value to be `array[ offset + 2 ]`.
   *
   * @param {Array<number>} array - An array holding the vector component values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Vector3} A reference to this vector.
   */
  fromArray(t, i = 0) {
    return this.x = t[i], this.y = t[i + 1], this.z = t[i + 2], this;
  }
  /**
   * Writes the components of this vector to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the vector components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The vector components.
   */
  toArray(t = [], i = 0) {
    return t[i] = this.x, t[i + 1] = this.y, t[i + 2] = this.z, t;
  }
  /**
   * Sets the components of this vector from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
   * @param {number} index - The index into the attribute.
   * @return {Vector3} A reference to this vector.
   */
  fromBufferAttribute(t, i) {
    return this.x = t.getX(i), this.y = t.getY(i), this.z = t.getZ(i), this;
  }
  /**
   * Sets each component of this vector to a pseudo-random value between `0` and
   * `1`, excluding `1`.
   *
   * @return {Vector3} A reference to this vector.
   */
  random() {
    return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
  }
  /**
   * Sets this vector to a uniformly random point on a unit sphere.
   *
   * @return {Vector3} A reference to this vector.
   */
  randomDirection() {
    const t = Math.random() * Math.PI * 2, i = Math.random() * 2 - 1, n = Math.sqrt(1 - i * i);
    return this.x = n * Math.cos(t), this.y = i, this.z = n * Math.sin(t), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z;
  }
}
const Ede = /* @__PURE__ */ new Ge(), WEe = /* @__PURE__ */ new gI();
class fo {
  /**
   * Constructs a new 3x3 matrix. The arguments are supposed to be
   * in row-major order. If no arguments are provided, the constructor
   * initializes the matrix as an identity matrix.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n13] - 1-3 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   * @param {number} [n23] - 2-3 matrix element.
   * @param {number} [n31] - 3-1 matrix element.
   * @param {number} [n32] - 3-2 matrix element.
   * @param {number} [n33] - 3-3 matrix element.
   */
  constructor(t, i, n, s, o, r, l, c, h) {
    fo.prototype.isMatrix3 = !0, this.elements = [
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ], t !== void 0 && this.set(t, i, n, s, o, r, l, c, h);
  }
  /**
   * Sets the elements of the matrix.The arguments are supposed to be
   * in row-major order.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n13] - 1-3 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   * @param {number} [n23] - 2-3 matrix element.
   * @param {number} [n31] - 3-1 matrix element.
   * @param {number} [n32] - 3-2 matrix element.
   * @param {number} [n33] - 3-3 matrix element.
   * @return {Matrix3} A reference to this matrix.
   */
  set(t, i, n, s, o, r, l, c, h) {
    const I = this.elements;
    return I[0] = t, I[1] = s, I[2] = l, I[3] = i, I[4] = o, I[5] = c, I[6] = n, I[7] = r, I[8] = h, this;
  }
  /**
   * Sets this matrix to the 3x3 identity matrix.
   *
   * @return {Matrix3} A reference to this matrix.
   */
  identity() {
    return this.set(
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Copies the values of the given matrix to this instance.
   *
   * @param {Matrix3} m - The matrix to copy.
   * @return {Matrix3} A reference to this matrix.
   */
  copy(t) {
    const i = this.elements, n = t.elements;
    return i[0] = n[0], i[1] = n[1], i[2] = n[2], i[3] = n[3], i[4] = n[4], i[5] = n[5], i[6] = n[6], i[7] = n[7], i[8] = n[8], this;
  }
  /**
   * Extracts the basis of this matrix into the three axis vectors provided.
   *
   * @param {Vector3} xAxis - The basis's x axis.
   * @param {Vector3} yAxis - The basis's y axis.
   * @param {Vector3} zAxis - The basis's z axis.
   * @return {Matrix3} A reference to this matrix.
   */
  extractBasis(t, i, n) {
    return t.setFromMatrix3Column(this, 0), i.setFromMatrix3Column(this, 1), n.setFromMatrix3Column(this, 2), this;
  }
  /**
   * Set this matrix to the upper 3x3 matrix of the given 4x4 matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Matrix3} A reference to this matrix.
   */
  setFromMatrix4(t) {
    const i = t.elements;
    return this.set(
      i[0],
      i[4],
      i[8],
      i[1],
      i[5],
      i[9],
      i[2],
      i[6],
      i[10]
    ), this;
  }
  /**
   * Post-multiplies this matrix by the given 3x3 matrix.
   *
   * @param {Matrix3} m - The matrix to multiply with.
   * @return {Matrix3} A reference to this matrix.
   */
  multiply(t) {
    return this.multiplyMatrices(this, t);
  }
  /**
   * Pre-multiplies this matrix by the given 3x3 matrix.
   *
   * @param {Matrix3} m - The matrix to multiply with.
   * @return {Matrix3} A reference to this matrix.
   */
  premultiply(t) {
    return this.multiplyMatrices(t, this);
  }
  /**
   * Multiples the given 3x3 matrices and stores the result
   * in this matrix.
   *
   * @param {Matrix3} a - The first matrix.
   * @param {Matrix3} b - The second matrix.
   * @return {Matrix3} A reference to this matrix.
   */
  multiplyMatrices(t, i) {
    const n = t.elements, s = i.elements, o = this.elements, r = n[0], l = n[3], c = n[6], h = n[1], I = n[4], p = n[7], y = n[2], m = n[5], A = n[8], C = s[0], O = s[3], R = s[6], F = s[1], L = s[4], P = s[7], z = s[2], W = s[5], re = s[8];
    return o[0] = r * C + l * F + c * z, o[3] = r * O + l * L + c * W, o[6] = r * R + l * P + c * re, o[1] = h * C + I * F + p * z, o[4] = h * O + I * L + p * W, o[7] = h * R + I * P + p * re, o[2] = y * C + m * F + A * z, o[5] = y * O + m * L + A * W, o[8] = y * R + m * P + A * re, this;
  }
  /**
   * Multiplies every component of the matrix by the given scalar.
   *
   * @param {number} s - The scalar.
   * @return {Matrix3} A reference to this matrix.
   */
  multiplyScalar(t) {
    const i = this.elements;
    return i[0] *= t, i[3] *= t, i[6] *= t, i[1] *= t, i[4] *= t, i[7] *= t, i[2] *= t, i[5] *= t, i[8] *= t, this;
  }
  /**
   * Computes and returns the determinant of this matrix.
   *
   * @return {number} The determinant.
   */
  determinant() {
    const t = this.elements, i = t[0], n = t[1], s = t[2], o = t[3], r = t[4], l = t[5], c = t[6], h = t[7], I = t[8];
    return i * r * I - i * l * h - n * o * I + n * l * c + s * o * h - s * r * c;
  }
  /**
   * Inverts this matrix, using the [analytic method]{@link https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution}.
   * You can not invert with a determinant of zero. If you attempt this, the method produces
   * a zero matrix instead.
   *
   * @return {Matrix3} A reference to this matrix.
   */
  invert() {
    const t = this.elements, i = t[0], n = t[1], s = t[2], o = t[3], r = t[4], l = t[5], c = t[6], h = t[7], I = t[8], p = I * r - l * h, y = l * c - I * o, m = h * o - r * c, A = i * p + n * y + s * m;
    if (A === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
    const C = 1 / A;
    return t[0] = p * C, t[1] = (s * h - I * n) * C, t[2] = (l * n - s * r) * C, t[3] = y * C, t[4] = (I * i - s * c) * C, t[5] = (s * o - l * i) * C, t[6] = m * C, t[7] = (n * c - h * i) * C, t[8] = (r * i - n * o) * C, this;
  }
  /**
   * Transposes this matrix in place.
   *
   * @return {Matrix3} A reference to this matrix.
   */
  transpose() {
    let t;
    const i = this.elements;
    return t = i[1], i[1] = i[3], i[3] = t, t = i[2], i[2] = i[6], i[6] = t, t = i[5], i[5] = i[7], i[7] = t, this;
  }
  /**
   * Computes the normal matrix which is the inverse transpose of the upper
   * left 3x3 portion of the given 4x4 matrix.
   *
   * @param {Matrix4} matrix4 - The 4x4 matrix.
   * @return {Matrix3} A reference to this matrix.
   */
  getNormalMatrix(t) {
    return this.setFromMatrix4(t).invert().transpose();
  }
  /**
   * Transposes this matrix into the supplied array, and returns itself unchanged.
   *
   * @param {Array<number>} r - An array to store the transposed matrix elements.
   * @return {Matrix3} A reference to this matrix.
   */
  transposeIntoArray(t) {
    const i = this.elements;
    return t[0] = i[0], t[1] = i[3], t[2] = i[6], t[3] = i[1], t[4] = i[4], t[5] = i[7], t[6] = i[2], t[7] = i[5], t[8] = i[8], this;
  }
  /**
   * Sets the UV transform matrix from offset, repeat, rotation, and center.
   *
   * @param {number} tx - Offset x.
   * @param {number} ty - Offset y.
   * @param {number} sx - Repeat x.
   * @param {number} sy - Repeat y.
   * @param {number} rotation - Rotation, in radians. Positive values rotate counterclockwise.
   * @param {number} cx - Center x of rotation.
   * @param {number} cy - Center y of rotation
   * @return {Matrix3} A reference to this matrix.
   */
  setUvTransform(t, i, n, s, o, r, l) {
    const c = Math.cos(o), h = Math.sin(o);
    return this.set(
      n * c,
      n * h,
      -n * (c * r + h * l) + r + t,
      -s * h,
      s * c,
      -s * (-h * r + c * l) + l + i,
      0,
      0,
      1
    ), this;
  }
  /**
   * Scales this matrix with the given scalar values.
   *
   * @param {number} sx - The amount to scale in the X axis.
   * @param {number} sy - The amount to scale in the Y axis.
   * @return {Matrix3} A reference to this matrix.
   */
  scale(t, i) {
    return this.premultiply(gde.makeScale(t, i)), this;
  }
  /**
   * Rotates this matrix by the given angle.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix3} A reference to this matrix.
   */
  rotate(t) {
    return this.premultiply(gde.makeRotation(-t)), this;
  }
  /**
   * Translates this matrix by the given scalar values.
   *
   * @param {number} tx - The amount to translate in the X axis.
   * @param {number} ty - The amount to translate in the Y axis.
   * @return {Matrix3} A reference to this matrix.
   */
  translate(t, i) {
    return this.premultiply(gde.makeTranslation(t, i)), this;
  }
  // for 2D Transforms
  /**
   * Sets this matrix as a 2D translation transform.
   *
   * @param {number|Vector2} x - The amount to translate in the X axis or alternatively a translation vector.
   * @param {number} y - The amount to translate in the Y axis.
   * @return {Matrix3} A reference to this matrix.
   */
  makeTranslation(t, i) {
    return t.isVector2 ? this.set(
      1,
      0,
      t.x,
      0,
      1,
      t.y,
      0,
      0,
      1
    ) : this.set(
      1,
      0,
      t,
      0,
      1,
      i,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a 2D rotational transformation.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix3} A reference to this matrix.
   */
  makeRotation(t) {
    const i = Math.cos(t), n = Math.sin(t);
    return this.set(
      i,
      -n,
      0,
      n,
      i,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a 2D scale transform.
   *
   * @param {number} x - The amount to scale in the X axis.
   * @param {number} y - The amount to scale in the Y axis.
   * @return {Matrix3} A reference to this matrix.
   */
  makeScale(t, i) {
    return this.set(
      t,
      0,
      0,
      0,
      i,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Returns `true` if this matrix is equal with the given one.
   *
   * @param {Matrix3} matrix - The matrix to test for equality.
   * @return {boolean} Whether this matrix is equal with the given one.
   */
  equals(t) {
    const i = this.elements, n = t.elements;
    for (let s = 0; s < 9; s++)
      if (i[s] !== n[s]) return !1;
    return !0;
  }
  /**
   * Sets the elements of the matrix from the given array.
   *
   * @param {Array<number>} array - The matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Matrix3} A reference to this matrix.
   */
  fromArray(t, i = 0) {
    for (let n = 0; n < 9; n++)
      this.elements[n] = t[n + i];
    return this;
  }
  /**
   * Writes the elements of this matrix to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The matrix elements in column-major order.
   */
  toArray(t = [], i = 0) {
    const n = this.elements;
    return t[i] = n[0], t[i + 1] = n[1], t[i + 2] = n[2], t[i + 3] = n[3], t[i + 4] = n[4], t[i + 5] = n[5], t[i + 6] = n[6], t[i + 7] = n[7], t[i + 8] = n[8], t;
  }
  /**
   * Returns a matrix with copied values from this instance.
   *
   * @return {Matrix3} A clone of this instance.
   */
  clone() {
    return new this.constructor().fromArray(this.elements);
  }
}
const gde = /* @__PURE__ */ new fo();
function pAe(e) {
  for (let t = e.length - 1; t >= 0; --t)
    if (e[t] >= 65535) return !0;
  return !1;
}
function mle(e) {
  return document.createElementNS("http://www.w3.org/1999/xhtml", e);
}
function B9e() {
  const e = mle("canvas");
  return e.style.display = "block", e;
}
const YEe = {};
function bz(e) {
  e in YEe || (YEe[e] = !0, console.warn(e));
}
function F9e(e, t, i) {
  return new Promise(function(n, s) {
    function o() {
      switch (e.clientWaitSync(t, e.SYNC_FLUSH_COMMANDS_BIT, 0)) {
        case e.WAIT_FAILED:
          s();
          break;
        case e.TIMEOUT_EXPIRED:
          setTimeout(o, i);
          break;
        default:
          n();
      }
    }
    setTimeout(o, i);
  });
}
function H9e(e) {
  const t = e.elements;
  t[2] = 0.5 * t[2] + 0.5 * t[3], t[6] = 0.5 * t[6] + 0.5 * t[7], t[10] = 0.5 * t[10] + 0.5 * t[11], t[14] = 0.5 * t[14] + 0.5 * t[15];
}
function G9e(e) {
  const t = e.elements;
  t[11] === -1 ? (t[10] = -t[10] - 1, t[14] = -t[14]) : (t[10] = -t[10], t[14] = -t[14] + 1);
}
const qEe = /* @__PURE__ */ new fo().set(
  0.4123908,
  0.3575843,
  0.1804808,
  0.212639,
  0.7151687,
  0.0721923,
  0.0193308,
  0.1191948,
  0.9505322
), $Ee = /* @__PURE__ */ new fo().set(
  3.2409699,
  -1.5373832,
  -0.4986108,
  -0.9692436,
  1.8759675,
  0.0415551,
  0.0556301,
  -0.203977,
  1.0569715
);
function k9e() {
  const e = {
    enabled: !0,
    workingColorSpace: LW,
    /**
     * Implementations of supported color spaces.
     *
     * Required:
     *	- primaries: chromaticity coordinates [ rx ry gx gy bx by ]
     *	- whitePoint: reference white [ x y ]
     *	- transfer: transfer function (pre-defined)
     *	- toXYZ: Matrix3 RGB to XYZ transform
     *	- fromXYZ: Matrix3 XYZ to RGB transform
     *	- luminanceCoefficients: RGB luminance coefficients
     *
     * Optional:
     *  - outputColorSpaceConfig: { drawingBufferColorSpace: ColorSpace }
     *  - workingColorSpaceConfig: { unpackColorSpace: ColorSpace }
     *
     * Reference:
     * - https://www.russellcottrell.com/photo/matrixCalculator.htm
     */
    spaces: {},
    convert: function(s, o, r) {
      return this.enabled === !1 || o === r || !o || !r || (this.spaces[o].transfer === Dl && (s.r = WO(s.r), s.g = WO(s.g), s.b = WO(s.b)), this.spaces[o].primaries !== this.spaces[r].primaries && (s.applyMatrix3(this.spaces[o].toXYZ), s.applyMatrix3(this.spaces[r].fromXYZ)), this.spaces[r].transfer === Dl && (s.r = Nz(s.r), s.g = Nz(s.g), s.b = Nz(s.b))), s;
    },
    workingToColorSpace: function(s, o) {
      return this.convert(s, this.workingColorSpace, o);
    },
    colorSpaceToWorking: function(s, o) {
      return this.convert(s, o, this.workingColorSpace);
    },
    getPrimaries: function(s) {
      return this.spaces[s].primaries;
    },
    getTransfer: function(s) {
      return s === ux ? Ile : this.spaces[s].transfer;
    },
    getLuminanceCoefficients: function(s, o = this.workingColorSpace) {
      return s.fromArray(this.spaces[o].luminanceCoefficients);
    },
    define: function(s) {
      Object.assign(this.spaces, s);
    },
    // Internal APIs
    _getMatrix: function(s, o, r) {
      return s.copy(this.spaces[o].toXYZ).multiply(this.spaces[r].fromXYZ);
    },
    _getDrawingBufferColorSpace: function(s) {
      return this.spaces[s].outputColorSpaceConfig.drawingBufferColorSpace;
    },
    _getUnpackColorSpace: function(s = this.workingColorSpace) {
      return this.spaces[s].workingColorSpaceConfig.unpackColorSpace;
    },
    // Deprecated
    fromWorkingColorSpace: function(s, o) {
      return bz("THREE.ColorManagement: .fromWorkingColorSpace() has been renamed to .workingToColorSpace()."), e.workingToColorSpace(s, o);
    },
    toWorkingColorSpace: function(s, o) {
      return bz("THREE.ColorManagement: .toWorkingColorSpace() has been renamed to .colorSpaceToWorking()."), e.colorSpaceToWorking(s, o);
    }
  }, t = [0.64, 0.33, 0.3, 0.6, 0.15, 0.06], i = [0.2126, 0.7152, 0.0722], n = [0.3127, 0.329];
  return e.define({
    [LW]: {
      primaries: t,
      whitePoint: n,
      transfer: Ile,
      toXYZ: qEe,
      fromXYZ: $Ee,
      luminanceCoefficients: i,
      workingColorSpaceConfig: { unpackColorSpace: Hy },
      outputColorSpaceConfig: { drawingBufferColorSpace: Hy }
    },
    [Hy]: {
      primaries: t,
      whitePoint: n,
      transfer: Dl,
      toXYZ: qEe,
      fromXYZ: $Ee,
      luminanceCoefficients: i,
      outputColorSpaceConfig: { drawingBufferColorSpace: Hy }
    }
  }), e;
}
const Qr = /* @__PURE__ */ k9e();
function WO(e) {
  return e < 0.04045 ? e * 0.0773993808 : Math.pow(e * 0.9478672986 + 0.0521327014, 2.4);
}
function Nz(e) {
  return e < 31308e-7 ? e * 12.92 : 1.055 * Math.pow(e, 0.41666) - 0.055;
}
let Bk;
class V9e {
  /**
   * Returns a data URI containing a representation of the given image.
   *
   * @param {(HTMLImageElement|HTMLCanvasElement)} image - The image object.
   * @param {string} [type='image/png'] - Indicates the image format.
   * @return {string} The data URI.
   */
  static getDataURL(t, i = "image/png") {
    if (/^data:/i.test(t.src) || typeof HTMLCanvasElement > "u")
      return t.src;
    let n;
    if (t instanceof HTMLCanvasElement)
      n = t;
    else {
      Bk === void 0 && (Bk = mle("canvas")), Bk.width = t.width, Bk.height = t.height;
      const s = Bk.getContext("2d");
      t instanceof ImageData ? s.putImageData(t, 0, 0) : s.drawImage(t, 0, 0, t.width, t.height), n = Bk;
    }
    return n.toDataURL(i);
  }
  /**
   * Converts the given sRGB image data to linear color space.
   *
   * @param {(HTMLImageElement|HTMLCanvasElement|ImageBitmap|Object)} image - The image object.
   * @return {HTMLCanvasElement|Object} The converted image.
   */
  static sRGBToLinear(t) {
    if (typeof HTMLImageElement < "u" && t instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && t instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && t instanceof ImageBitmap) {
      const i = mle("canvas");
      i.width = t.width, i.height = t.height;
      const n = i.getContext("2d");
      n.drawImage(t, 0, 0, t.width, t.height);
      const s = n.getImageData(0, 0, t.width, t.height), o = s.data;
      for (let r = 0; r < o.length; r++)
        o[r] = WO(o[r] / 255) * 255;
      return n.putImageData(s, 0, 0), i;
    } else if (t.data) {
      const i = t.data.slice(0);
      for (let n = 0; n < i.length; n++)
        i instanceof Uint8Array || i instanceof Uint8ClampedArray ? i[n] = Math.floor(WO(i[n] / 255) * 255) : i[n] = WO(i[n]);
      return {
        data: i,
        width: t.width,
        height: t.height
      };
    } else
      return console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), t;
  }
}
let z9e = 0;
class Kpe {
  /**
   * Constructs a new video texture.
   *
   * @param {any} [data=null] - The data definition of a texture.
   */
  constructor(t = null) {
    this.isSource = !0, Object.defineProperty(this, "id", { value: z9e++ }), this.uuid = jO(), this.data = t, this.dataReady = !0, this.version = 0;
  }
  getSize(t) {
    const i = this.data;
    return i instanceof HTMLVideoElement ? t.set(i.videoWidth, i.videoHeight) : i !== null ? t.set(i.width, i.height, i.depth || 0) : t.set(0, 0, 0), t;
  }
  /**
   * When the property is set to `true`, the engine allocates the memory
   * for the texture (if necessary) and triggers the actual texture upload
   * to the GPU next time the source is used.
   *
   * @type {boolean}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(t) {
    t === !0 && this.version++;
  }
  /**
   * Serializes the source into JSON.
   *
   * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized source.
   * @see {@link ObjectLoader#parse}
   */
  toJSON(t) {
    const i = t === void 0 || typeof t == "string";
    if (!i && t.images[this.uuid] !== void 0)
      return t.images[this.uuid];
    const n = {
      uuid: this.uuid,
      url: ""
    }, s = this.data;
    if (s !== null) {
      let o;
      if (Array.isArray(s)) {
        o = [];
        for (let r = 0, l = s.length; r < l; r++)
          s[r].isDataTexture ? o.push(wde(s[r].image)) : o.push(wde(s[r]));
      } else
        o = wde(s);
      n.url = o;
    }
    return i || (t.images[this.uuid] = n), n;
  }
}
function wde(e) {
  return typeof HTMLImageElement < "u" && e instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && e instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && e instanceof ImageBitmap ? V9e.getDataURL(e) : e.data ? {
    data: Array.from(e.data),
    width: e.width,
    height: e.height,
    type: e.data.constructor.name
  } : (console.warn("THREE.Texture: Unable to serialize Texture."), {});
}
let j9e = 0;
const Tde = /* @__PURE__ */ new Ge();
class sE extends LH {
  /**
   * Constructs a new texture.
   *
   * @param {?Object} [image=Texture.DEFAULT_IMAGE] - The image holding the texture data.
   * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
   * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
   * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
   * @param {number} [magFilter=LinearFilter] - The mag filter value.
   * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
   * @param {number} [format=RGBAFormat] - The texture format.
   * @param {number} [type=UnsignedByteType] - The texture type.
   * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
   * @param {string} [colorSpace=NoColorSpace] - The color space.
   */
  constructor(t = sE.DEFAULT_IMAGE, i = sE.DEFAULT_MAPPING, n = oB, s = oB, o = dN, r = rB, l = y5, c = PA, h = sE.DEFAULT_ANISOTROPY, I = ux) {
    super(), this.isTexture = !0, Object.defineProperty(this, "id", { value: j9e++ }), this.uuid = jO(), this.name = "", this.source = new Kpe(t), this.mipmaps = [], this.mapping = i, this.channel = 0, this.wrapS = n, this.wrapT = s, this.magFilter = o, this.minFilter = r, this.anisotropy = h, this.format = l, this.internalFormat = null, this.type = c, this.offset = new us(0, 0), this.repeat = new us(1, 1), this.center = new us(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new fo(), this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, this.colorSpace = I, this.userData = {}, this.updateRanges = [], this.version = 0, this.onUpdate = null, this.renderTarget = null, this.isRenderTargetTexture = !1, this.isArrayTexture = !!(t && t.depth && t.depth > 1), this.pmremVersion = 0;
  }
  /**
   * The width of the texture in pixels.
   */
  get width() {
    return this.source.getSize(Tde).x;
  }
  /**
   * The height of the texture in pixels.
   */
  get height() {
    return this.source.getSize(Tde).y;
  }
  /**
   * The depth of the texture in pixels.
   */
  get depth() {
    return this.source.getSize(Tde).z;
  }
  /**
   * The image object holding the texture data.
   *
   * @type {?Object}
   */
  get image() {
    return this.source.data;
  }
  set image(t = null) {
    this.source.data = t;
  }
  /**
   * Updates the texture transformation matrix from the from the properties {@link Texture#offset},
   * {@link Texture#repeat}, {@link Texture#rotation}, and {@link Texture#center}.
   */
  updateMatrix() {
    this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
  }
  /**
   * Adds a range of data in the data texture to be updated on the GPU.
   *
   * @param {number} start - Position at which to start update.
   * @param {number} count - The number of components to update.
   */
  addUpdateRange(t, i) {
    this.updateRanges.push({ start: t, count: i });
  }
  /**
   * Clears the update ranges.
   */
  clearUpdateRanges() {
    this.updateRanges.length = 0;
  }
  /**
   * Returns a new texture with copied values from this instance.
   *
   * @return {Texture} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the values of the given texture to this instance.
   *
   * @param {Texture} source - The texture to copy.
   * @return {Texture} A reference to this instance.
   */
  copy(t) {
    return this.name = t.name, this.source = t.source, this.mipmaps = t.mipmaps.slice(0), this.mapping = t.mapping, this.channel = t.channel, this.wrapS = t.wrapS, this.wrapT = t.wrapT, this.magFilter = t.magFilter, this.minFilter = t.minFilter, this.anisotropy = t.anisotropy, this.format = t.format, this.internalFormat = t.internalFormat, this.type = t.type, this.offset.copy(t.offset), this.repeat.copy(t.repeat), this.center.copy(t.center), this.rotation = t.rotation, this.matrixAutoUpdate = t.matrixAutoUpdate, this.matrix.copy(t.matrix), this.generateMipmaps = t.generateMipmaps, this.premultiplyAlpha = t.premultiplyAlpha, this.flipY = t.flipY, this.unpackAlignment = t.unpackAlignment, this.colorSpace = t.colorSpace, this.renderTarget = t.renderTarget, this.isRenderTargetTexture = t.isRenderTargetTexture, this.isArrayTexture = t.isArrayTexture, this.userData = JSON.parse(JSON.stringify(t.userData)), this.needsUpdate = !0, this;
  }
  /**
   * Sets this texture's properties based on `values`.
   * @param {Object} values - A container with texture parameters.
   */
  setValues(t) {
    for (const i in t) {
      const n = t[i];
      if (n === void 0) {
        console.warn(`THREE.Texture.setValues(): parameter '${i}' has value of undefined.`);
        continue;
      }
      const s = this[i];
      if (s === void 0) {
        console.warn(`THREE.Texture.setValues(): property '${i}' does not exist.`);
        continue;
      }
      s && n && s.isVector2 && n.isVector2 || s && n && s.isVector3 && n.isVector3 || s && n && s.isMatrix3 && n.isMatrix3 ? s.copy(n) : this[i] = n;
    }
  }
  /**
   * Serializes the texture into JSON.
   *
   * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized texture.
   * @see {@link ObjectLoader#parse}
   */
  toJSON(t) {
    const i = t === void 0 || typeof t == "string";
    if (!i && t.textures[this.uuid] !== void 0)
      return t.textures[this.uuid];
    const n = {
      metadata: {
        version: 4.7,
        type: "Texture",
        generator: "Texture.toJSON"
      },
      uuid: this.uuid,
      name: this.name,
      image: this.source.toJSON(t).uuid,
      mapping: this.mapping,
      channel: this.channel,
      repeat: [this.repeat.x, this.repeat.y],
      offset: [this.offset.x, this.offset.y],
      center: [this.center.x, this.center.y],
      rotation: this.rotation,
      wrap: [this.wrapS, this.wrapT],
      format: this.format,
      internalFormat: this.internalFormat,
      type: this.type,
      colorSpace: this.colorSpace,
      minFilter: this.minFilter,
      magFilter: this.magFilter,
      anisotropy: this.anisotropy,
      flipY: this.flipY,
      generateMipmaps: this.generateMipmaps,
      premultiplyAlpha: this.premultiplyAlpha,
      unpackAlignment: this.unpackAlignment
    };
    return Object.keys(this.userData).length > 0 && (n.userData = this.userData), i || (t.textures[this.uuid] = n), n;
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   *
   * @fires Texture#dispose
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  /**
   * Transforms the given uv vector with the textures uv transformation matrix.
   *
   * @param {Vector2} uv - The uv vector.
   * @return {Vector2} The transformed uv vector.
   */
  transformUv(t) {
    if (this.mapping !== oAe) return t;
    if (t.applyMatrix3(this.matrix), t.x < 0 || t.x > 1)
      switch (this.wrapS) {
        case m1e:
          t.x = t.x - Math.floor(t.x);
          break;
        case oB:
          t.x = t.x < 0 ? 0 : 1;
          break;
        case y1e:
          Math.abs(Math.floor(t.x) % 2) === 1 ? t.x = Math.ceil(t.x) - t.x : t.x = t.x - Math.floor(t.x);
          break;
      }
    if (t.y < 0 || t.y > 1)
      switch (this.wrapT) {
        case m1e:
          t.y = t.y - Math.floor(t.y);
          break;
        case oB:
          t.y = t.y < 0 ? 0 : 1;
          break;
        case y1e:
          Math.abs(Math.floor(t.y) % 2) === 1 ? t.y = Math.ceil(t.y) - t.y : t.y = t.y - Math.floor(t.y);
          break;
      }
    return this.flipY && (t.y = 1 - t.y), t;
  }
  /**
   * Setting this property to `true` indicates the engine the texture
   * must be updated in the next render. This triggers a texture upload
   * to the GPU and ensures correct texture parameter configuration.
   *
   * @type {boolean}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(t) {
    t === !0 && (this.version++, this.source.needsUpdate = !0);
  }
  /**
   * Setting this property to `true` indicates the engine the PMREM
   * must be regenerated.
   *
   * @type {boolean}
   * @default false
   * @param {boolean} value
   */
  set needsPMREMUpdate(t) {
    t === !0 && this.pmremVersion++;
  }
}
sE.DEFAULT_IMAGE = null;
sE.DEFAULT_MAPPING = oAe;
sE.DEFAULT_ANISOTROPY = 1;
class Ol {
  /**
   * Constructs a new 4D vector.
   *
   * @param {number} [x=0] - The x value of this vector.
   * @param {number} [y=0] - The y value of this vector.
   * @param {number} [z=0] - The z value of this vector.
   * @param {number} [w=1] - The w value of this vector.
   */
  constructor(t = 0, i = 0, n = 0, s = 1) {
    Ol.prototype.isVector4 = !0, this.x = t, this.y = i, this.z = n, this.w = s;
  }
  /**
   * Alias for {@link Vector4#z}.
   *
   * @type {number}
   */
  get width() {
    return this.z;
  }
  set width(t) {
    this.z = t;
  }
  /**
   * Alias for {@link Vector4#w}.
   *
   * @type {number}
   */
  get height() {
    return this.w;
  }
  set height(t) {
    this.w = t;
  }
  /**
   * Sets the vector components.
   *
   * @param {number} x - The value of the x component.
   * @param {number} y - The value of the y component.
   * @param {number} z - The value of the z component.
   * @param {number} w - The value of the w component.
   * @return {Vector4} A reference to this vector.
   */
  set(t, i, n, s) {
    return this.x = t, this.y = i, this.z = n, this.w = s, this;
  }
  /**
   * Sets the vector components to the same value.
   *
   * @param {number} scalar - The value to set for all vector components.
   * @return {Vector4} A reference to this vector.
   */
  setScalar(t) {
    return this.x = t, this.y = t, this.z = t, this.w = t, this;
  }
  /**
   * Sets the vector's x component to the given value
   *
   * @param {number} x - The value to set.
   * @return {Vector4} A reference to this vector.
   */
  setX(t) {
    return this.x = t, this;
  }
  /**
   * Sets the vector's y component to the given value
   *
   * @param {number} y - The value to set.
   * @return {Vector4} A reference to this vector.
   */
  setY(t) {
    return this.y = t, this;
  }
  /**
   * Sets the vector's z component to the given value
   *
   * @param {number} z - The value to set.
   * @return {Vector4} A reference to this vector.
   */
  setZ(t) {
    return this.z = t, this;
  }
  /**
   * Sets the vector's w component to the given value
   *
   * @param {number} w - The value to set.
   * @return {Vector4} A reference to this vector.
   */
  setW(t) {
    return this.w = t, this;
  }
  /**
   * Allows to set a vector component with an index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y,
   * `2` equals to z, `3` equals to w.
   * @param {number} value - The value to set.
   * @return {Vector4} A reference to this vector.
   */
  setComponent(t, i) {
    switch (t) {
      case 0:
        this.x = i;
        break;
      case 1:
        this.y = i;
        break;
      case 2:
        this.z = i;
        break;
      case 3:
        this.w = i;
        break;
      default:
        throw new Error("index is out of range: " + t);
    }
    return this;
  }
  /**
   * Returns the value of the vector component which matches the given index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y,
   * `2` equals to z, `3` equals to w.
   * @return {number} A vector component value.
   */
  getComponent(t) {
    switch (t) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      case 3:
        return this.w;
      default:
        throw new Error("index is out of range: " + t);
    }
  }
  /**
   * Returns a new vector with copied values from this instance.
   *
   * @return {Vector4} A clone of this instance.
   */
  clone() {
    return new this.constructor(this.x, this.y, this.z, this.w);
  }
  /**
   * Copies the values of the given vector to this instance.
   *
   * @param {Vector3|Vector4} v - The vector to copy.
   * @return {Vector4} A reference to this vector.
   */
  copy(t) {
    return this.x = t.x, this.y = t.y, this.z = t.z, this.w = t.w !== void 0 ? t.w : 1, this;
  }
  /**
   * Adds the given vector to this instance.
   *
   * @param {Vector4} v - The vector to add.
   * @return {Vector4} A reference to this vector.
   */
  add(t) {
    return this.x += t.x, this.y += t.y, this.z += t.z, this.w += t.w, this;
  }
  /**
   * Adds the given scalar value to all components of this instance.
   *
   * @param {number} s - The scalar to add.
   * @return {Vector4} A reference to this vector.
   */
  addScalar(t) {
    return this.x += t, this.y += t, this.z += t, this.w += t, this;
  }
  /**
   * Adds the given vectors and stores the result in this instance.
   *
   * @param {Vector4} a - The first vector.
   * @param {Vector4} b - The second vector.
   * @return {Vector4} A reference to this vector.
   */
  addVectors(t, i) {
    return this.x = t.x + i.x, this.y = t.y + i.y, this.z = t.z + i.z, this.w = t.w + i.w, this;
  }
  /**
   * Adds the given vector scaled by the given factor to this instance.
   *
   * @param {Vector4} v - The vector.
   * @param {number} s - The factor that scales `v`.
   * @return {Vector4} A reference to this vector.
   */
  addScaledVector(t, i) {
    return this.x += t.x * i, this.y += t.y * i, this.z += t.z * i, this.w += t.w * i, this;
  }
  /**
   * Subtracts the given vector from this instance.
   *
   * @param {Vector4} v - The vector to subtract.
   * @return {Vector4} A reference to this vector.
   */
  sub(t) {
    return this.x -= t.x, this.y -= t.y, this.z -= t.z, this.w -= t.w, this;
  }
  /**
   * Subtracts the given scalar value from all components of this instance.
   *
   * @param {number} s - The scalar to subtract.
   * @return {Vector4} A reference to this vector.
   */
  subScalar(t) {
    return this.x -= t, this.y -= t, this.z -= t, this.w -= t, this;
  }
  /**
   * Subtracts the given vectors and stores the result in this instance.
   *
   * @param {Vector4} a - The first vector.
   * @param {Vector4} b - The second vector.
   * @return {Vector4} A reference to this vector.
   */
  subVectors(t, i) {
    return this.x = t.x - i.x, this.y = t.y - i.y, this.z = t.z - i.z, this.w = t.w - i.w, this;
  }
  /**
   * Multiplies the given vector with this instance.
   *
   * @param {Vector4} v - The vector to multiply.
   * @return {Vector4} A reference to this vector.
   */
  multiply(t) {
    return this.x *= t.x, this.y *= t.y, this.z *= t.z, this.w *= t.w, this;
  }
  /**
   * Multiplies the given scalar value with all components of this instance.
   *
   * @param {number} scalar - The scalar to multiply.
   * @return {Vector4} A reference to this vector.
   */
  multiplyScalar(t) {
    return this.x *= t, this.y *= t, this.z *= t, this.w *= t, this;
  }
  /**
   * Multiplies this vector with the given 4x4 matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Vector4} A reference to this vector.
   */
  applyMatrix4(t) {
    const i = this.x, n = this.y, s = this.z, o = this.w, r = t.elements;
    return this.x = r[0] * i + r[4] * n + r[8] * s + r[12] * o, this.y = r[1] * i + r[5] * n + r[9] * s + r[13] * o, this.z = r[2] * i + r[6] * n + r[10] * s + r[14] * o, this.w = r[3] * i + r[7] * n + r[11] * s + r[15] * o, this;
  }
  /**
   * Divides this instance by the given vector.
   *
   * @param {Vector4} v - The vector to divide.
   * @return {Vector4} A reference to this vector.
   */
  divide(t) {
    return this.x /= t.x, this.y /= t.y, this.z /= t.z, this.w /= t.w, this;
  }
  /**
   * Divides this vector by the given scalar.
   *
   * @param {number} scalar - The scalar to divide.
   * @return {Vector4} A reference to this vector.
   */
  divideScalar(t) {
    return this.multiplyScalar(1 / t);
  }
  /**
   * Sets the x, y and z components of this
   * vector to the quaternion's axis and w to the angle.
   *
   * @param {Quaternion} q - The Quaternion to set.
   * @return {Vector4} A reference to this vector.
   */
  setAxisAngleFromQuaternion(t) {
    this.w = 2 * Math.acos(t.w);
    const i = Math.sqrt(1 - t.w * t.w);
    return i < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = t.x / i, this.y = t.y / i, this.z = t.z / i), this;
  }
  /**
   * Sets the x, y and z components of this
   * vector to the axis of rotation and w to the angle.
   *
   * @param {Matrix4} m - A 4x4 matrix of which the upper left 3x3 matrix is a pure rotation matrix.
   * @return {Vector4} A reference to this vector.
   */
  setAxisAngleFromRotationMatrix(t) {
    let i, n, s, o;
    const c = t.elements, h = c[0], I = c[4], p = c[8], y = c[1], m = c[5], A = c[9], C = c[2], O = c[6], R = c[10];
    if (Math.abs(I - y) < 0.01 && Math.abs(p - C) < 0.01 && Math.abs(A - O) < 0.01) {
      if (Math.abs(I + y) < 0.1 && Math.abs(p + C) < 0.1 && Math.abs(A + O) < 0.1 && Math.abs(h + m + R - 3) < 0.1)
        return this.set(1, 0, 0, 0), this;
      i = Math.PI;
      const L = (h + 1) / 2, P = (m + 1) / 2, z = (R + 1) / 2, W = (I + y) / 4, re = (p + C) / 4, ce = (A + O) / 4;
      return L > P && L > z ? L < 0.01 ? (n = 0, s = 0.707106781, o = 0.707106781) : (n = Math.sqrt(L), s = W / n, o = re / n) : P > z ? P < 0.01 ? (n = 0.707106781, s = 0, o = 0.707106781) : (s = Math.sqrt(P), n = W / s, o = ce / s) : z < 0.01 ? (n = 0.707106781, s = 0.707106781, o = 0) : (o = Math.sqrt(z), n = re / o, s = ce / o), this.set(n, s, o, i), this;
    }
    let F = Math.sqrt((O - A) * (O - A) + (p - C) * (p - C) + (y - I) * (y - I));
    return Math.abs(F) < 1e-3 && (F = 1), this.x = (O - A) / F, this.y = (p - C) / F, this.z = (y - I) / F, this.w = Math.acos((h + m + R - 1) / 2), this;
  }
  /**
   * Sets the vector components to the position elements of the
   * given transformation matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Vector4} A reference to this vector.
   */
  setFromMatrixPosition(t) {
    const i = t.elements;
    return this.x = i[12], this.y = i[13], this.z = i[14], this.w = i[15], this;
  }
  /**
   * If this vector's x, y, z or w value is greater than the given vector's x, y, z or w
   * value, replace that value with the corresponding min value.
   *
   * @param {Vector4} v - The vector.
   * @return {Vector4} A reference to this vector.
   */
  min(t) {
    return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this.z = Math.min(this.z, t.z), this.w = Math.min(this.w, t.w), this;
  }
  /**
   * If this vector's x, y, z or w value is less than the given vector's x, y, z or w
   * value, replace that value with the corresponding max value.
   *
   * @param {Vector4} v - The vector.
   * @return {Vector4} A reference to this vector.
   */
  max(t) {
    return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this.z = Math.max(this.z, t.z), this.w = Math.max(this.w, t.w), this;
  }
  /**
   * If this vector's x, y, z or w value is greater than the max vector's x, y, z or w
   * value, it is replaced by the corresponding value.
   * If this vector's x, y, z or w value is less than the min vector's x, y, z or w value,
   * it is replaced by the corresponding value.
   *
   * @param {Vector4} min - The minimum x, y and z values.
   * @param {Vector4} max - The maximum x, y and z values in the desired range.
   * @return {Vector4} A reference to this vector.
   */
  clamp(t, i) {
    return this.x = Ho(this.x, t.x, i.x), this.y = Ho(this.y, t.y, i.y), this.z = Ho(this.z, t.z, i.z), this.w = Ho(this.w, t.w, i.w), this;
  }
  /**
   * If this vector's x, y, z or w values are greater than the max value, they are
   * replaced by the max value.
   * If this vector's x, y, z or w values are less than the min value, they are
   * replaced by the min value.
   *
   * @param {number} minVal - The minimum value the components will be clamped to.
   * @param {number} maxVal - The maximum value the components will be clamped to.
   * @return {Vector4} A reference to this vector.
   */
  clampScalar(t, i) {
    return this.x = Ho(this.x, t, i), this.y = Ho(this.y, t, i), this.z = Ho(this.z, t, i), this.w = Ho(this.w, t, i), this;
  }
  /**
   * If this vector's length is greater than the max value, it is replaced by
   * the max value.
   * If this vector's length is less than the min value, it is replaced by the
   * min value.
   *
   * @param {number} min - The minimum value the vector length will be clamped to.
   * @param {number} max - The maximum value the vector length will be clamped to.
   * @return {Vector4} A reference to this vector.
   */
  clampLength(t, i) {
    const n = this.length();
    return this.divideScalar(n || 1).multiplyScalar(Ho(n, t, i));
  }
  /**
   * The components of this vector are rounded down to the nearest integer value.
   *
   * @return {Vector4} A reference to this vector.
   */
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
  }
  /**
   * The components of this vector are rounded up to the nearest integer value.
   *
   * @return {Vector4} A reference to this vector.
   */
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
  }
  /**
   * The components of this vector are rounded to the nearest integer value
   *
   * @return {Vector4} A reference to this vector.
   */
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
  }
  /**
   * The components of this vector are rounded towards zero (up if negative,
   * down if positive) to an integer value.
   *
   * @return {Vector4} A reference to this vector.
   */
  roundToZero() {
    return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this.w = Math.trunc(this.w), this;
  }
  /**
   * Inverts this vector - i.e. sets x = -x, y = -y, z = -z, w = -w.
   *
   * @return {Vector4} A reference to this vector.
   */
  negate() {
    return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
  }
  /**
   * Calculates the dot product of the given vector with this instance.
   *
   * @param {Vector4} v - The vector to compute the dot product with.
   * @return {number} The result of the dot product.
   */
  dot(t) {
    return this.x * t.x + this.y * t.y + this.z * t.z + this.w * t.w;
  }
  /**
   * Computes the square of the Euclidean length (straight-line length) from
   * (0, 0, 0, 0) to (x, y, z, w). If you are comparing the lengths of vectors, you should
   * compare the length squared instead as it is slightly more efficient to calculate.
   *
   * @return {number} The square length of this vector.
   */
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
  }
  /**
   * Computes the  Euclidean length (straight-line length) from (0, 0, 0, 0) to (x, y, z, w).
   *
   * @return {number} The length of this vector.
   */
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
  }
  /**
   * Computes the Manhattan length of this vector.
   *
   * @return {number} The length of this vector.
   */
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
  }
  /**
   * Converts this vector to a unit vector - that is, sets it equal to a vector
   * with the same direction as this one, but with a vector length of `1`.
   *
   * @return {Vector4} A reference to this vector.
   */
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  /**
   * Sets this vector to a vector with the same direction as this one, but
   * with the specified length.
   *
   * @param {number} length - The new length of this vector.
   * @return {Vector4} A reference to this vector.
   */
  setLength(t) {
    return this.normalize().multiplyScalar(t);
  }
  /**
   * Linearly interpolates between the given vector and this instance, where
   * alpha is the percent distance along the line - alpha = 0 will be this
   * vector, and alpha = 1 will be the given one.
   *
   * @param {Vector4} v - The vector to interpolate towards.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector4} A reference to this vector.
   */
  lerp(t, i) {
    return this.x += (t.x - this.x) * i, this.y += (t.y - this.y) * i, this.z += (t.z - this.z) * i, this.w += (t.w - this.w) * i, this;
  }
  /**
   * Linearly interpolates between the given vectors, where alpha is the percent
   * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
   * be the second one. The result is stored in this instance.
   *
   * @param {Vector4} v1 - The first vector.
   * @param {Vector4} v2 - The second vector.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector4} A reference to this vector.
   */
  lerpVectors(t, i, n) {
    return this.x = t.x + (i.x - t.x) * n, this.y = t.y + (i.y - t.y) * n, this.z = t.z + (i.z - t.z) * n, this.w = t.w + (i.w - t.w) * n, this;
  }
  /**
   * Returns `true` if this vector is equal with the given one.
   *
   * @param {Vector4} v - The vector to test for equality.
   * @return {boolean} Whether this vector is equal with the given one.
   */
  equals(t) {
    return t.x === this.x && t.y === this.y && t.z === this.z && t.w === this.w;
  }
  /**
   * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`,
   * z value to be `array[ offset + 2 ]`, w value to be `array[ offset + 3 ]`.
   *
   * @param {Array<number>} array - An array holding the vector component values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Vector4} A reference to this vector.
   */
  fromArray(t, i = 0) {
    return this.x = t[i], this.y = t[i + 1], this.z = t[i + 2], this.w = t[i + 3], this;
  }
  /**
   * Writes the components of this vector to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the vector components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The vector components.
   */
  toArray(t = [], i = 0) {
    return t[i] = this.x, t[i + 1] = this.y, t[i + 2] = this.z, t[i + 3] = this.w, t;
  }
  /**
   * Sets the components of this vector from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
   * @param {number} index - The index into the attribute.
   * @return {Vector4} A reference to this vector.
   */
  fromBufferAttribute(t, i) {
    return this.x = t.getX(i), this.y = t.getY(i), this.z = t.getZ(i), this.w = t.getW(i), this;
  }
  /**
   * Sets each component of this vector to a pseudo-random value between `0` and
   * `1`, excluding `1`.
   *
   * @return {Vector4} A reference to this vector.
   */
  random() {
    return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z, yield this.w;
  }
}
class W9e extends LH {
  /**
   * Render target options.
   *
   * @typedef {Object} RenderTarget~Options
   * @property {boolean} [generateMipmaps=false] - Whether to generate mipmaps or not.
   * @property {number} [magFilter=LinearFilter] - The mag filter.
   * @property {number} [minFilter=LinearFilter] - The min filter.
   * @property {number} [format=RGBAFormat] - The texture format.
   * @property {number} [type=UnsignedByteType] - The texture type.
   * @property {?string} [internalFormat=null] - The texture's internal format.
   * @property {number} [wrapS=ClampToEdgeWrapping] - The texture's uv wrapping mode.
   * @property {number} [wrapT=ClampToEdgeWrapping] - The texture's uv wrapping mode.
   * @property {number} [anisotropy=1] - The texture's anisotropy value.
   * @property {string} [colorSpace=NoColorSpace] - The texture's color space.
   * @property {boolean} [depthBuffer=true] - Whether to allocate a depth buffer or not.
   * @property {boolean} [stencilBuffer=false] - Whether to allocate a stencil buffer or not.
   * @property {boolean} [resolveDepthBuffer=true] - Whether to resolve the depth buffer or not.
   * @property {boolean} [resolveStencilBuffer=true] - Whether  to resolve the stencil buffer or not.
   * @property {?Texture} [depthTexture=null] - Reference to a depth texture.
   * @property {number} [samples=0] - The MSAA samples count.
   * @property {number} [count=1] - Defines the number of color attachments . Must be at least `1`.
   * @property {number} [depth=1] - The texture depth.
   * @property {boolean} [multiview=false] - Whether this target is used for multiview rendering.
   */
  /**
   * Constructs a new render target.
   *
   * @param {number} [width=1] - The width of the render target.
   * @param {number} [height=1] - The height of the render target.
   * @param {RenderTarget~Options} [options] - The configuration object.
   */
  constructor(t = 1, i = 1, n = {}) {
    super(), n = Object.assign({
      generateMipmaps: !1,
      internalFormat: null,
      minFilter: dN,
      depthBuffer: !0,
      stencilBuffer: !1,
      resolveDepthBuffer: !0,
      resolveStencilBuffer: !0,
      depthTexture: null,
      samples: 0,
      count: 1,
      depth: 1,
      multiview: !1
    }, n), this.isRenderTarget = !0, this.width = t, this.height = i, this.depth = n.depth, this.scissor = new Ol(0, 0, t, i), this.scissorTest = !1, this.viewport = new Ol(0, 0, t, i);
    const s = { width: t, height: i, depth: n.depth }, o = new sE(s);
    this.textures = [];
    const r = n.count;
    for (let l = 0; l < r; l++)
      this.textures[l] = o.clone(), this.textures[l].isRenderTargetTexture = !0, this.textures[l].renderTarget = this;
    this._setTextureOptions(n), this.depthBuffer = n.depthBuffer, this.stencilBuffer = n.stencilBuffer, this.resolveDepthBuffer = n.resolveDepthBuffer, this.resolveStencilBuffer = n.resolveStencilBuffer, this._depthTexture = null, this.depthTexture = n.depthTexture, this.samples = n.samples, this.multiview = n.multiview;
  }
  _setTextureOptions(t = {}) {
    const i = {
      minFilter: dN,
      generateMipmaps: !1,
      flipY: !1,
      internalFormat: null
    };
    t.mapping !== void 0 && (i.mapping = t.mapping), t.wrapS !== void 0 && (i.wrapS = t.wrapS), t.wrapT !== void 0 && (i.wrapT = t.wrapT), t.wrapR !== void 0 && (i.wrapR = t.wrapR), t.magFilter !== void 0 && (i.magFilter = t.magFilter), t.minFilter !== void 0 && (i.minFilter = t.minFilter), t.format !== void 0 && (i.format = t.format), t.type !== void 0 && (i.type = t.type), t.anisotropy !== void 0 && (i.anisotropy = t.anisotropy), t.colorSpace !== void 0 && (i.colorSpace = t.colorSpace), t.flipY !== void 0 && (i.flipY = t.flipY), t.generateMipmaps !== void 0 && (i.generateMipmaps = t.generateMipmaps), t.internalFormat !== void 0 && (i.internalFormat = t.internalFormat);
    for (let n = 0; n < this.textures.length; n++)
      this.textures[n].setValues(i);
  }
  /**
   * The texture representing the default color attachment.
   *
   * @type {Texture}
   */
  get texture() {
    return this.textures[0];
  }
  set texture(t) {
    this.textures[0] = t;
  }
  set depthTexture(t) {
    this._depthTexture !== null && (this._depthTexture.renderTarget = null), t !== null && (t.renderTarget = this), this._depthTexture = t;
  }
  /**
   * Instead of saving the depth in a renderbuffer, a texture
   * can be used instead which is useful for further processing
   * e.g. in context of post-processing.
   *
   * @type {?DepthTexture}
   * @default null
   */
  get depthTexture() {
    return this._depthTexture;
  }
  /**
   * Sets the size of this render target.
   *
   * @param {number} width - The width.
   * @param {number} height - The height.
   * @param {number} [depth=1] - The depth.
   */
  setSize(t, i, n = 1) {
    if (this.width !== t || this.height !== i || this.depth !== n) {
      this.width = t, this.height = i, this.depth = n;
      for (let s = 0, o = this.textures.length; s < o; s++)
        this.textures[s].image.width = t, this.textures[s].image.height = i, this.textures[s].image.depth = n, this.textures[s].isArrayTexture = this.textures[s].image.depth > 1;
      this.dispose();
    }
    this.viewport.set(0, 0, t, i), this.scissor.set(0, 0, t, i);
  }
  /**
   * Returns a new render target with copied values from this instance.
   *
   * @return {RenderTarget} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the settings of the given render target. This is a structural copy so
   * no resources are shared between render targets after the copy. That includes
   * all MRT textures and the depth texture.
   *
   * @param {RenderTarget} source - The render target to copy.
   * @return {RenderTarget} A reference to this instance.
   */
  copy(t) {
    this.width = t.width, this.height = t.height, this.depth = t.depth, this.scissor.copy(t.scissor), this.scissorTest = t.scissorTest, this.viewport.copy(t.viewport), this.textures.length = 0;
    for (let i = 0, n = t.textures.length; i < n; i++) {
      this.textures[i] = t.textures[i].clone(), this.textures[i].isRenderTargetTexture = !0, this.textures[i].renderTarget = this;
      const s = Object.assign({}, t.textures[i].image);
      this.textures[i].source = new Kpe(s);
    }
    return this.depthBuffer = t.depthBuffer, this.stencilBuffer = t.stencilBuffer, this.resolveDepthBuffer = t.resolveDepthBuffer, this.resolveStencilBuffer = t.resolveStencilBuffer, t.depthTexture !== null && (this.depthTexture = t.depthTexture.clone()), this.samples = t.samples, this;
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   *
   * @fires RenderTarget#dispose
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
class qP extends W9e {
  /**
   * Constructs a new 3D render target.
   *
   * @param {number} [width=1] - The width of the render target.
   * @param {number} [height=1] - The height of the render target.
   * @param {RenderTarget~Options} [options] - The configuration object.
   */
  constructor(t = 1, i = 1, n = {}) {
    super(t, i, n), this.isWebGLRenderTarget = !0;
  }
}
class mAe extends sE {
  /**
   * Constructs a new data array texture.
   *
   * @param {?TypedArray} [data=null] - The buffer data.
   * @param {number} [width=1] - The width of the texture.
   * @param {number} [height=1] - The height of the texture.
   * @param {number} [depth=1] - The depth of the texture.
   */
  constructor(t = null, i = 1, n = 1, s = 1) {
    super(null), this.isDataArrayTexture = !0, this.image = { data: t, width: i, height: n, depth: s }, this.magFilter = g4, this.minFilter = g4, this.wrapR = oB, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1, this.layerUpdates = /* @__PURE__ */ new Set();
  }
  /**
   * Describes that a specific layer of the texture needs to be updated.
   * Normally when {@link Texture#needsUpdate} is set to `true`, the
   * entire data texture array is sent to the GPU. Marking specific
   * layers will only transmit subsets of all mipmaps associated with a
   * specific depth in the array which is often much more performant.
   *
   * @param {number} layerIndex - The layer index that should be updated.
   */
  addLayerUpdate(t) {
    this.layerUpdates.add(t);
  }
  /**
   * Resets the layer updates registry.
   */
  clearLayerUpdates() {
    this.layerUpdates.clear();
  }
}
class Y9e extends sE {
  /**
   * Constructs a new data array texture.
   *
   * @param {?TypedArray} [data=null] - The buffer data.
   * @param {number} [width=1] - The width of the texture.
   * @param {number} [height=1] - The height of the texture.
   * @param {number} [depth=1] - The depth of the texture.
   */
  constructor(t = null, i = 1, n = 1, s = 1) {
    super(null), this.isData3DTexture = !0, this.image = { data: t, width: i, height: n, depth: s }, this.magFilter = g4, this.minFilter = g4, this.wrapR = oB, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
  }
}
class Zs {
  /**
   * Constructs a new bounding box.
   *
   * @param {Vector3} [min=(Infinity,Infinity,Infinity)] - A vector representing the lower boundary of the box.
   * @param {Vector3} [max=(-Infinity,-Infinity,-Infinity)] - A vector representing the upper boundary of the box.
   */
  constructor(t = new Ge(1 / 0, 1 / 0, 1 / 0), i = new Ge(-1 / 0, -1 / 0, -1 / 0)) {
    this.isBox3 = !0, this.min = t, this.max = i;
  }
  /**
   * Sets the lower and upper boundaries of this box.
   * Please note that this method only copies the values from the given objects.
   *
   * @param {Vector3} min - The lower boundary of the box.
   * @param {Vector3} max - The upper boundary of the box.
   * @return {Box3} A reference to this bounding box.
   */
  set(t, i) {
    return this.min.copy(t), this.max.copy(i), this;
  }
  /**
   * Sets the upper and lower bounds of this box so it encloses the position data
   * in the given array.
   *
   * @param {Array<number>} array - An array holding 3D position data.
   * @return {Box3} A reference to this bounding box.
   */
  setFromArray(t) {
    this.makeEmpty();
    for (let i = 0, n = t.length; i < n; i += 3)
      this.expandByPoint(lv.fromArray(t, i));
    return this;
  }
  /**
   * Sets the upper and lower bounds of this box so it encloses the position data
   * in the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - A buffer attribute holding 3D position data.
   * @return {Box3} A reference to this bounding box.
   */
  setFromBufferAttribute(t) {
    this.makeEmpty();
    for (let i = 0, n = t.count; i < n; i++)
      this.expandByPoint(lv.fromBufferAttribute(t, i));
    return this;
  }
  /**
   * Sets the upper and lower bounds of this box so it encloses the position data
   * in the given array.
   *
   * @param {Array<Vector3>} points - An array holding 3D position data as instances of {@link Vector3}.
   * @return {Box3} A reference to this bounding box.
   */
  setFromPoints(t) {
    this.makeEmpty();
    for (let i = 0, n = t.length; i < n; i++)
      this.expandByPoint(t[i]);
    return this;
  }
  /**
   * Centers this box on the given center vector and sets this box's width, height and
   * depth to the given size values.
   *
   * @param {Vector3} center - The center of the box.
   * @param {Vector3} size - The x, y and z dimensions of the box.
   * @return {Box3} A reference to this bounding box.
   */
  setFromCenterAndSize(t, i) {
    const n = lv.copy(i).multiplyScalar(0.5);
    return this.min.copy(t).sub(n), this.max.copy(t).add(n), this;
  }
  /**
   * Computes the world-axis-aligned bounding box for the given 3D object
   * (including its children), accounting for the object's, and children's,
   * world transforms. The function may result in a larger box than strictly necessary.
   *
   * @param {Object3D} object - The 3D object to compute the bounding box for.
   * @param {boolean} [precise=false] - If set to `true`, the method computes the smallest
   * world-axis-aligned bounding box at the expense of more computation.
   * @return {Box3} A reference to this bounding box.
   */
  setFromObject(t, i = !1) {
    return this.makeEmpty(), this.expandByObject(t, i);
  }
  /**
   * Returns a new box with copied values from this instance.
   *
   * @return {Box3} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the values of the given box to this instance.
   *
   * @param {Box3} box - The box to copy.
   * @return {Box3} A reference to this bounding box.
   */
  copy(t) {
    return this.min.copy(t.min), this.max.copy(t.max), this;
  }
  /**
   * Makes this box empty which means in encloses a zero space in 3D.
   *
   * @return {Box3} A reference to this bounding box.
   */
  makeEmpty() {
    return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
  }
  /**
   * Returns true if this box includes zero points within its bounds.
   * Note that a box with equal lower and upper bounds still includes one
   * point, the one both bounds share.
   *
   * @return {boolean} Whether this box is empty or not.
   */
  isEmpty() {
    return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
  }
  /**
   * Returns the center point of this box.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The center point.
   */
  getCenter(t) {
    return this.isEmpty() ? t.set(0, 0, 0) : t.addVectors(this.min, this.max).multiplyScalar(0.5);
  }
  /**
   * Returns the dimensions of this box.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The size.
   */
  getSize(t) {
    return this.isEmpty() ? t.set(0, 0, 0) : t.subVectors(this.max, this.min);
  }
  /**
   * Expands the boundaries of this box to include the given point.
   *
   * @param {Vector3} point - The point that should be included by the bounding box.
   * @return {Box3} A reference to this bounding box.
   */
  expandByPoint(t) {
    return this.min.min(t), this.max.max(t), this;
  }
  /**
   * Expands this box equilaterally by the given vector. The width of this
   * box will be expanded by the x component of the vector in both
   * directions. The height of this box will be expanded by the y component of
   * the vector in both directions. The depth of this box will be
   * expanded by the z component of the vector in both directions.
   *
   * @param {Vector3} vector - The vector that should expand the bounding box.
   * @return {Box3} A reference to this bounding box.
   */
  expandByVector(t) {
    return this.min.sub(t), this.max.add(t), this;
  }
  /**
   * Expands each dimension of the box by the given scalar. If negative, the
   * dimensions of the box will be contracted.
   *
   * @param {number} scalar - The scalar value that should expand the bounding box.
   * @return {Box3} A reference to this bounding box.
   */
  expandByScalar(t) {
    return this.min.addScalar(-t), this.max.addScalar(t), this;
  }
  /**
   * Expands the boundaries of this box to include the given 3D object and
   * its children, accounting for the object's, and children's, world
   * transforms. The function may result in a larger box than strictly
   * necessary (unless the precise parameter is set to true).
   *
   * @param {Object3D} object - The 3D object that should expand the bounding box.
   * @param {boolean} precise - If set to `true`, the method expands the bounding box
   * as little as necessary at the expense of more computation.
   * @return {Box3} A reference to this bounding box.
   */
  expandByObject(t, i = !1) {
    t.updateWorldMatrix(!1, !1);
    const n = t.geometry;
    if (n !== void 0) {
      const o = n.getAttribute("position");
      if (i === !0 && o !== void 0 && t.isInstancedMesh !== !0)
        for (let r = 0, l = o.count; r < l; r++)
          t.isMesh === !0 ? t.getVertexPosition(r, lv) : lv.fromBufferAttribute(o, r), lv.applyMatrix4(t.matrixWorld), this.expandByPoint(lv);
      else
        t.boundingBox !== void 0 ? (t.boundingBox === null && t.computeBoundingBox(), Sne.copy(t.boundingBox)) : (n.boundingBox === null && n.computeBoundingBox(), Sne.copy(n.boundingBox)), Sne.applyMatrix4(t.matrixWorld), this.union(Sne);
    }
    const s = t.children;
    for (let o = 0, r = s.length; o < r; o++)
      this.expandByObject(s[o], i);
    return this;
  }
  /**
   * Returns `true` if the given point lies within or on the boundaries of this box.
   *
   * @param {Vector3} point - The point to test.
   * @return {boolean} Whether the bounding box contains the given point or not.
   */
  containsPoint(t) {
    return t.x >= this.min.x && t.x <= this.max.x && t.y >= this.min.y && t.y <= this.max.y && t.z >= this.min.z && t.z <= this.max.z;
  }
  /**
   * Returns `true` if this bounding box includes the entirety of the given bounding box.
   * If this box and the given one are identical, this function also returns `true`.
   *
   * @param {Box3} box - The bounding box to test.
   * @return {boolean} Whether the bounding box contains the given bounding box or not.
   */
  containsBox(t) {
    return this.min.x <= t.min.x && t.max.x <= this.max.x && this.min.y <= t.min.y && t.max.y <= this.max.y && this.min.z <= t.min.z && t.max.z <= this.max.z;
  }
  /**
   * Returns a point as a proportion of this box's width, height and depth.
   *
   * @param {Vector3} point - A point in 3D space.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} A point as a proportion of this box's width, height and depth.
   */
  getParameter(t, i) {
    return i.set(
      (t.x - this.min.x) / (this.max.x - this.min.x),
      (t.y - this.min.y) / (this.max.y - this.min.y),
      (t.z - this.min.z) / (this.max.z - this.min.z)
    );
  }
  /**
   * Returns `true` if the given bounding box intersects with this bounding box.
   *
   * @param {Box3} box - The bounding box to test.
   * @return {boolean} Whether the given bounding box intersects with this bounding box.
   */
  intersectsBox(t) {
    return t.max.x >= this.min.x && t.min.x <= this.max.x && t.max.y >= this.min.y && t.min.y <= this.max.y && t.max.z >= this.min.z && t.min.z <= this.max.z;
  }
  /**
   * Returns `true` if the given bounding sphere intersects with this bounding box.
   *
   * @param {Sphere} sphere - The bounding sphere to test.
   * @return {boolean} Whether the given bounding sphere intersects with this bounding box.
   */
  intersectsSphere(t) {
    return this.clampPoint(t.center, lv), lv.distanceToSquared(t.center) <= t.radius * t.radius;
  }
  /**
   * Returns `true` if the given plane intersects with this bounding box.
   *
   * @param {Plane} plane - The plane to test.
   * @return {boolean} Whether the given plane intersects with this bounding box.
   */
  intersectsPlane(t) {
    let i, n;
    return t.normal.x > 0 ? (i = t.normal.x * this.min.x, n = t.normal.x * this.max.x) : (i = t.normal.x * this.max.x, n = t.normal.x * this.min.x), t.normal.y > 0 ? (i += t.normal.y * this.min.y, n += t.normal.y * this.max.y) : (i += t.normal.y * this.max.y, n += t.normal.y * this.min.y), t.normal.z > 0 ? (i += t.normal.z * this.min.z, n += t.normal.z * this.max.z) : (i += t.normal.z * this.max.z, n += t.normal.z * this.min.z), i <= -t.constant && n >= -t.constant;
  }
  /**
   * Returns `true` if the given triangle intersects with this bounding box.
   *
   * @param {Triangle} triangle - The triangle to test.
   * @return {boolean} Whether the given triangle intersects with this bounding box.
   */
  intersectsTriangle(t) {
    if (this.isEmpty())
      return !1;
    this.getCenter(wZ), bne.subVectors(this.max, wZ), Fk.subVectors(t.a, wZ), Hk.subVectors(t.b, wZ), Gk.subVectors(t.c, wZ), u_.subVectors(Hk, Fk), d_.subVectors(Gk, Hk), Z9.subVectors(Fk, Gk);
    let i = [
      0,
      -u_.z,
      u_.y,
      0,
      -d_.z,
      d_.y,
      0,
      -Z9.z,
      Z9.y,
      u_.z,
      0,
      -u_.x,
      d_.z,
      0,
      -d_.x,
      Z9.z,
      0,
      -Z9.x,
      -u_.y,
      u_.x,
      0,
      -d_.y,
      d_.x,
      0,
      -Z9.y,
      Z9.x,
      0
    ];
    return !Rde(i, Fk, Hk, Gk, bne) || (i = [1, 0, 0, 0, 1, 0, 0, 0, 1], !Rde(i, Fk, Hk, Gk, bne)) ? !1 : (Nne.crossVectors(u_, d_), i = [Nne.x, Nne.y, Nne.z], Rde(i, Fk, Hk, Gk, bne));
  }
  /**
   * Clamps the given point within the bounds of this box.
   *
   * @param {Vector3} point - The point to clamp.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The clamped point.
   */
  clampPoint(t, i) {
    return i.copy(t).clamp(this.min, this.max);
  }
  /**
   * Returns the euclidean distance from any edge of this box to the specified point. If
   * the given point lies inside of this box, the distance will be `0`.
   *
   * @param {Vector3} point - The point to compute the distance to.
   * @return {number} The euclidean distance.
   */
  distanceToPoint(t) {
    return this.clampPoint(t, lv).distanceTo(t);
  }
  /**
   * Returns a bounding sphere that encloses this bounding box.
   *
   * @param {Sphere} target - The target sphere that is used to store the method's result.
   * @return {Sphere} The bounding sphere that encloses this bounding box.
   */
  getBoundingSphere(t) {
    return this.isEmpty() ? t.makeEmpty() : (this.getCenter(t.center), t.radius = this.getSize(lv).length() * 0.5), t;
  }
  /**
   * Computes the intersection of this bounding box and the given one, setting the upper
   * bound of this box to the lesser of the two boxes' upper bounds and the
   * lower bound of this box to the greater of the two boxes' lower bounds. If
   * there's no overlap, makes this box empty.
   *
   * @param {Box3} box - The bounding box to intersect with.
   * @return {Box3} A reference to this bounding box.
   */
  intersect(t) {
    return this.min.max(t.min), this.max.min(t.max), this.isEmpty() && this.makeEmpty(), this;
  }
  /**
   * Computes the union of this box and another and the given one, setting the upper
   * bound of this box to the greater of the two boxes' upper bounds and the
   * lower bound of this box to the lesser of the two boxes' lower bounds.
   *
   * @param {Box3} box - The bounding box that will be unioned with this instance.
   * @return {Box3} A reference to this bounding box.
   */
  union(t) {
    return this.min.min(t.min), this.max.max(t.max), this;
  }
  /**
   * Transforms this bounding box by the given 4x4 transformation matrix.
   *
   * @param {Matrix4} matrix - The transformation matrix.
   * @return {Box3} A reference to this bounding box.
   */
  applyMatrix4(t) {
    return this.isEmpty() ? this : (MD[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(t), MD[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(t), MD[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(t), MD[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(t), MD[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(t), MD[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(t), MD[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(t), MD[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(t), this.setFromPoints(MD), this);
  }
  /**
   * Adds the given offset to both the upper and lower bounds of this bounding box,
   * effectively moving it in 3D space.
   *
   * @param {Vector3} offset - The offset that should be used to translate the bounding box.
   * @return {Box3} A reference to this bounding box.
   */
  translate(t) {
    return this.min.add(t), this.max.add(t), this;
  }
  /**
   * Returns `true` if this bounding box is equal with the given one.
   *
   * @param {Box3} box - The box to test for equality.
   * @return {boolean} Whether this bounding box is equal with the given one.
   */
  equals(t) {
    return t.min.equals(this.min) && t.max.equals(this.max);
  }
  /**
   * Returns a serialized structure of the bounding box.
   *
   * @return {Object} Serialized structure with fields representing the object state.
   */
  toJSON() {
    return {
      min: this.min.toArray(),
      max: this.max.toArray()
    };
  }
  /**
   * Returns a serialized structure of the bounding box.
   *
   * @param {Object} json - The serialized json to set the box from.
   * @return {Box3} A reference to this bounding box.
   */
  fromJSON(t) {
    return this.min.fromArray(t.min), this.max.fromArray(t.max), this;
  }
}
const MD = [
  /* @__PURE__ */ new Ge(),
  /* @__PURE__ */ new Ge(),
  /* @__PURE__ */ new Ge(),
  /* @__PURE__ */ new Ge(),
  /* @__PURE__ */ new Ge(),
  /* @__PURE__ */ new Ge(),
  /* @__PURE__ */ new Ge(),
  /* @__PURE__ */ new Ge()
], lv = /* @__PURE__ */ new Ge(), Sne = /* @__PURE__ */ new Zs(), Fk = /* @__PURE__ */ new Ge(), Hk = /* @__PURE__ */ new Ge(), Gk = /* @__PURE__ */ new Ge(), u_ = /* @__PURE__ */ new Ge(), d_ = /* @__PURE__ */ new Ge(), Z9 = /* @__PURE__ */ new Ge(), wZ = /* @__PURE__ */ new Ge(), bne = /* @__PURE__ */ new Ge(), Nne = /* @__PURE__ */ new Ge(), Q9 = /* @__PURE__ */ new Ge();
function Rde(e, t, i, n, s) {
  for (let o = 0, r = e.length - 3; o <= r; o += 3) {
    Q9.fromArray(e, o);
    const l = s.x * Math.abs(Q9.x) + s.y * Math.abs(Q9.y) + s.z * Math.abs(Q9.z), c = t.dot(Q9), h = i.dot(Q9), I = n.dot(Q9);
    if (Math.max(-Math.max(c, h, I), Math.min(c, h, I)) > l)
      return !1;
  }
  return !0;
}
const q9e = /* @__PURE__ */ new Zs(), TZ = /* @__PURE__ */ new Ge(), vde = /* @__PURE__ */ new Ge();
class f3 {
  /**
   * Constructs a new sphere.
   *
   * @param {Vector3} [center=(0,0,0)] - The center of the sphere
   * @param {number} [radius=-1] - The radius of the sphere.
   */
  constructor(t = new Ge(), i = -1) {
    this.isSphere = !0, this.center = t, this.radius = i;
  }
  /**
   * Sets the sphere's components by copying the given values.
   *
   * @param {Vector3} center - The center.
   * @param {number} radius - The radius.
   * @return {Sphere} A reference to this sphere.
   */
  set(t, i) {
    return this.center.copy(t), this.radius = i, this;
  }
  /**
   * Computes the minimum bounding sphere for list of points.
   * If the optional center point is given, it is used as the sphere's
   * center. Otherwise, the center of the axis-aligned bounding box
   * encompassing the points is calculated.
   *
   * @param {Array<Vector3>} points - A list of points in 3D space.
   * @param {Vector3} [optionalCenter] - The center of the sphere.
   * @return {Sphere} A reference to this sphere.
   */
  setFromPoints(t, i) {
    const n = this.center;
    i !== void 0 ? n.copy(i) : q9e.setFromPoints(t).getCenter(n);
    let s = 0;
    for (let o = 0, r = t.length; o < r; o++)
      s = Math.max(s, n.distanceToSquared(t[o]));
    return this.radius = Math.sqrt(s), this;
  }
  /**
   * Copies the values of the given sphere to this instance.
   *
   * @param {Sphere} sphere - The sphere to copy.
   * @return {Sphere} A reference to this sphere.
   */
  copy(t) {
    return this.center.copy(t.center), this.radius = t.radius, this;
  }
  /**
   * Returns `true` if the sphere is empty (the radius set to a negative number).
   *
   * Spheres with a radius of `0` contain only their center point and are not
   * considered to be empty.
   *
   * @return {boolean} Whether this sphere is empty or not.
   */
  isEmpty() {
    return this.radius < 0;
  }
  /**
   * Makes this sphere empty which means in encloses a zero space in 3D.
   *
   * @return {Sphere} A reference to this sphere.
   */
  makeEmpty() {
    return this.center.set(0, 0, 0), this.radius = -1, this;
  }
  /**
   * Returns `true` if this sphere contains the given point inclusive of
   * the surface of the sphere.
   *
   * @param {Vector3} point - The point to check.
   * @return {boolean} Whether this sphere contains the given point or not.
   */
  containsPoint(t) {
    return t.distanceToSquared(this.center) <= this.radius * this.radius;
  }
  /**
   * Returns the closest distance from the boundary of the sphere to the
   * given point. If the sphere contains the point, the distance will
   * be negative.
   *
   * @param {Vector3} point - The point to compute the distance to.
   * @return {number} The distance to the point.
   */
  distanceToPoint(t) {
    return t.distanceTo(this.center) - this.radius;
  }
  /**
   * Returns `true` if this sphere intersects with the given one.
   *
   * @param {Sphere} sphere - The sphere to test.
   * @return {boolean} Whether this sphere intersects with the given one or not.
   */
  intersectsSphere(t) {
    const i = this.radius + t.radius;
    return t.center.distanceToSquared(this.center) <= i * i;
  }
  /**
   * Returns `true` if this sphere intersects with the given box.
   *
   * @param {Box3} box - The box to test.
   * @return {boolean} Whether this sphere intersects with the given box or not.
   */
  intersectsBox(t) {
    return t.intersectsSphere(this);
  }
  /**
   * Returns `true` if this sphere intersects with the given plane.
   *
   * @param {Plane} plane - The plane to test.
   * @return {boolean} Whether this sphere intersects with the given plane or not.
   */
  intersectsPlane(t) {
    return Math.abs(t.distanceToPoint(this.center)) <= this.radius;
  }
  /**
   * Clamps a point within the sphere. If the point is outside the sphere, it
   * will clamp it to the closest point on the edge of the sphere. Points
   * already inside the sphere will not be affected.
   *
   * @param {Vector3} point - The plane to clamp.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The clamped point.
   */
  clampPoint(t, i) {
    const n = this.center.distanceToSquared(t);
    return i.copy(t), n > this.radius * this.radius && (i.sub(this.center).normalize(), i.multiplyScalar(this.radius).add(this.center)), i;
  }
  /**
   * Returns a bounding box that encloses this sphere.
   *
   * @param {Box3} target - The target box that is used to store the method's result.
   * @return {Box3} The bounding box that encloses this sphere.
   */
  getBoundingBox(t) {
    return this.isEmpty() ? (t.makeEmpty(), t) : (t.set(this.center, this.center), t.expandByScalar(this.radius), t);
  }
  /**
   * Transforms this sphere with the given 4x4 transformation matrix.
   *
   * @param {Matrix4} matrix - The transformation matrix.
   * @return {Sphere} A reference to this sphere.
   */
  applyMatrix4(t) {
    return this.center.applyMatrix4(t), this.radius = this.radius * t.getMaxScaleOnAxis(), this;
  }
  /**
   * Translates the sphere's center by the given offset.
   *
   * @param {Vector3} offset - The offset.
   * @return {Sphere} A reference to this sphere.
   */
  translate(t) {
    return this.center.add(t), this;
  }
  /**
   * Expands the boundaries of this sphere to include the given point.
   *
   * @param {Vector3} point - The point to include.
   * @return {Sphere} A reference to this sphere.
   */
  expandByPoint(t) {
    if (this.isEmpty())
      return this.center.copy(t), this.radius = 0, this;
    TZ.subVectors(t, this.center);
    const i = TZ.lengthSq();
    if (i > this.radius * this.radius) {
      const n = Math.sqrt(i), s = (n - this.radius) * 0.5;
      this.center.addScaledVector(TZ, s / n), this.radius += s;
    }
    return this;
  }
  /**
   * Expands this sphere to enclose both the original sphere and the given sphere.
   *
   * @param {Sphere} sphere - The sphere to include.
   * @return {Sphere} A reference to this sphere.
   */
  union(t) {
    return t.isEmpty() ? this : this.isEmpty() ? (this.copy(t), this) : (this.center.equals(t.center) === !0 ? this.radius = Math.max(this.radius, t.radius) : (vde.subVectors(t.center, this.center).setLength(t.radius), this.expandByPoint(TZ.copy(t.center).add(vde)), this.expandByPoint(TZ.copy(t.center).sub(vde))), this);
  }
  /**
   * Returns `true` if this sphere is equal with the given one.
   *
   * @param {Sphere} sphere - The sphere to test for equality.
   * @return {boolean} Whether this bounding sphere is equal with the given one.
   */
  equals(t) {
    return t.center.equals(this.center) && t.radius === this.radius;
  }
  /**
   * Returns a new sphere with copied values from this instance.
   *
   * @return {Sphere} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Returns a serialized structure of the bounding sphere.
   *
   * @return {Object} Serialized structure with fields representing the object state.
   */
  toJSON() {
    return {
      radius: this.radius,
      center: this.center.toArray()
    };
  }
  /**
   * Returns a serialized structure of the bounding sphere.
   *
   * @param {Object} json - The serialized json to set the sphere from.
   * @return {Box3} A reference to this bounding sphere.
   */
  fromJSON(t) {
    return this.radius = t.radius, this.center.fromArray(t.center), this;
  }
}
const UD = /* @__PURE__ */ new Ge(), Ade = /* @__PURE__ */ new Ge(), Dne = /* @__PURE__ */ new Ge(), c_ = /* @__PURE__ */ new Ge(), Sde = /* @__PURE__ */ new Ge(), Cne = /* @__PURE__ */ new Ge(), bde = /* @__PURE__ */ new Ge();
class MA {
  /**
   * Constructs a new ray.
   *
   * @param {Vector3} [origin=(0,0,0)] - The origin of the ray.
   * @param {Vector3} [direction=(0,0,-1)] - The (normalized) direction of the ray.
   */
  constructor(t = new Ge(), i = new Ge(0, 0, -1)) {
    this.origin = t, this.direction = i;
  }
  /**
   * Sets the ray's components by copying the given values.
   *
   * @param {Vector3} origin - The origin.
   * @param {Vector3} direction - The direction.
   * @return {Ray} A reference to this ray.
   */
  set(t, i) {
    return this.origin.copy(t), this.direction.copy(i), this;
  }
  /**
   * Copies the values of the given ray to this instance.
   *
   * @param {Ray} ray - The ray to copy.
   * @return {Ray} A reference to this ray.
   */
  copy(t) {
    return this.origin.copy(t.origin), this.direction.copy(t.direction), this;
  }
  /**
   * Returns a vector that is located at a given distance along this ray.
   *
   * @param {number} t - The distance along the ray to retrieve a position for.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} A position on the ray.
   */
  at(t, i) {
    return i.copy(this.origin).addScaledVector(this.direction, t);
  }
  /**
   * Adjusts the direction of the ray to point at the given vector in world space.
   *
   * @param {Vector3} v - The target position.
   * @return {Ray} A reference to this ray.
   */
  lookAt(t) {
    return this.direction.copy(t).sub(this.origin).normalize(), this;
  }
  /**
   * Shift the origin of this ray along its direction by the given distance.
   *
   * @param {number} t - The distance along the ray to interpolate.
   * @return {Ray} A reference to this ray.
   */
  recast(t) {
    return this.origin.copy(this.at(t, UD)), this;
  }
  /**
   * Returns the point along this ray that is closest to the given point.
   *
   * @param {Vector3} point - A point in 3D space to get the closet location on the ray for.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The closest point on this ray.
   */
  closestPointToPoint(t, i) {
    i.subVectors(t, this.origin);
    const n = i.dot(this.direction);
    return n < 0 ? i.copy(this.origin) : i.copy(this.origin).addScaledVector(this.direction, n);
  }
  /**
   * Returns the distance of the closest approach between this ray and the given point.
   *
   * @param {Vector3} point - A point in 3D space to compute the distance to.
   * @return {number} The distance.
   */
  distanceToPoint(t) {
    return Math.sqrt(this.distanceSqToPoint(t));
  }
  /**
   * Returns the squared distance of the closest approach between this ray and the given point.
   *
   * @param {Vector3} point - A point in 3D space to compute the distance to.
   * @return {number} The squared distance.
   */
  distanceSqToPoint(t) {
    const i = UD.subVectors(t, this.origin).dot(this.direction);
    return i < 0 ? this.origin.distanceToSquared(t) : (UD.copy(this.origin).addScaledVector(this.direction, i), UD.distanceToSquared(t));
  }
  /**
   * Returns the squared distance between this ray and the given line segment.
   *
   * @param {Vector3} v0 - The start point of the line segment.
   * @param {Vector3} v1 - The end point of the line segment.
   * @param {Vector3} [optionalPointOnRay] - When provided, it receives the point on this ray that is closest to the segment.
   * @param {Vector3} [optionalPointOnSegment] - When provided, it receives the point on the line segment that is closest to this ray.
   * @return {number} The squared distance.
   */
  distanceSqToSegment(t, i, n, s) {
    Ade.copy(t).add(i).multiplyScalar(0.5), Dne.copy(i).sub(t).normalize(), c_.copy(this.origin).sub(Ade);
    const o = t.distanceTo(i) * 0.5, r = -this.direction.dot(Dne), l = c_.dot(this.direction), c = -c_.dot(Dne), h = c_.lengthSq(), I = Math.abs(1 - r * r);
    let p, y, m, A;
    if (I > 0)
      if (p = r * c - l, y = r * l - c, A = o * I, p >= 0)
        if (y >= -A)
          if (y <= A) {
            const C = 1 / I;
            p *= C, y *= C, m = p * (p + r * y + 2 * l) + y * (r * p + y + 2 * c) + h;
          } else
            y = o, p = Math.max(0, -(r * y + l)), m = -p * p + y * (y + 2 * c) + h;
        else
          y = -o, p = Math.max(0, -(r * y + l)), m = -p * p + y * (y + 2 * c) + h;
      else
        y <= -A ? (p = Math.max(0, -(-r * o + l)), y = p > 0 ? -o : Math.min(Math.max(-o, -c), o), m = -p * p + y * (y + 2 * c) + h) : y <= A ? (p = 0, y = Math.min(Math.max(-o, -c), o), m = y * (y + 2 * c) + h) : (p = Math.max(0, -(r * o + l)), y = p > 0 ? o : Math.min(Math.max(-o, -c), o), m = -p * p + y * (y + 2 * c) + h);
    else
      y = r > 0 ? -o : o, p = Math.max(0, -(r * y + l)), m = -p * p + y * (y + 2 * c) + h;
    return n && n.copy(this.origin).addScaledVector(this.direction, p), s && s.copy(Ade).addScaledVector(Dne, y), m;
  }
  /**
   * Intersects this ray with the given sphere, returning the intersection
   * point or `null` if there is no intersection.
   *
   * @param {Sphere} sphere - The sphere to intersect.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */
  intersectSphere(t, i) {
    UD.subVectors(t.center, this.origin);
    const n = UD.dot(this.direction), s = UD.dot(UD) - n * n, o = t.radius * t.radius;
    if (s > o) return null;
    const r = Math.sqrt(o - s), l = n - r, c = n + r;
    return c < 0 ? null : l < 0 ? this.at(c, i) : this.at(l, i);
  }
  /**
   * Returns `true` if this ray intersects with the given sphere.
   *
   * @param {Sphere} sphere - The sphere to intersect.
   * @return {boolean} Whether this ray intersects with the given sphere or not.
   */
  intersectsSphere(t) {
    return t.radius < 0 ? !1 : this.distanceSqToPoint(t.center) <= t.radius * t.radius;
  }
  /**
   * Computes the distance from the ray's origin to the given plane. Returns `null` if the ray
   * does not intersect with the plane.
   *
   * @param {Plane} plane - The plane to compute the distance to.
   * @return {?number} Whether this ray intersects with the given sphere or not.
   */
  distanceToPlane(t) {
    const i = t.normal.dot(this.direction);
    if (i === 0)
      return t.distanceToPoint(this.origin) === 0 ? 0 : null;
    const n = -(this.origin.dot(t.normal) + t.constant) / i;
    return n >= 0 ? n : null;
  }
  /**
   * Intersects this ray with the given plane, returning the intersection
   * point or `null` if there is no intersection.
   *
   * @param {Plane} plane - The plane to intersect.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */
  intersectPlane(t, i) {
    const n = this.distanceToPlane(t);
    return n === null ? null : this.at(n, i);
  }
  /**
   * Returns `true` if this ray intersects with the given plane.
   *
   * @param {Plane} plane - The plane to intersect.
   * @return {boolean} Whether this ray intersects with the given plane or not.
   */
  intersectsPlane(t) {
    const i = t.distanceToPoint(this.origin);
    return i === 0 || t.normal.dot(this.direction) * i < 0;
  }
  /**
   * Intersects this ray with the given bounding box, returning the intersection
   * point or `null` if there is no intersection.
   *
   * @param {Box3} box - The box to intersect.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */
  intersectBox(t, i) {
    let n, s, o, r, l, c;
    const h = 1 / this.direction.x, I = 1 / this.direction.y, p = 1 / this.direction.z, y = this.origin;
    return h >= 0 ? (n = (t.min.x - y.x) * h, s = (t.max.x - y.x) * h) : (n = (t.max.x - y.x) * h, s = (t.min.x - y.x) * h), I >= 0 ? (o = (t.min.y - y.y) * I, r = (t.max.y - y.y) * I) : (o = (t.max.y - y.y) * I, r = (t.min.y - y.y) * I), n > r || o > s || ((o > n || isNaN(n)) && (n = o), (r < s || isNaN(s)) && (s = r), p >= 0 ? (l = (t.min.z - y.z) * p, c = (t.max.z - y.z) * p) : (l = (t.max.z - y.z) * p, c = (t.min.z - y.z) * p), n > c || l > s) || ((l > n || n !== n) && (n = l), (c < s || s !== s) && (s = c), s < 0) ? null : this.at(n >= 0 ? n : s, i);
  }
  /**
   * Returns `true` if this ray intersects with the given box.
   *
   * @param {Box3} box - The box to intersect.
   * @return {boolean} Whether this ray intersects with the given box or not.
   */
  intersectsBox(t) {
    return this.intersectBox(t, UD) !== null;
  }
  /**
   * Intersects this ray with the given triangle, returning the intersection
   * point or `null` if there is no intersection.
   *
   * @param {Vector3} a - The first vertex of the triangle.
   * @param {Vector3} b - The second vertex of the triangle.
   * @param {Vector3} c - The third vertex of the triangle.
   * @param {boolean} backfaceCulling - Whether to use backface culling or not.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */
  intersectTriangle(t, i, n, s, o) {
    Sde.subVectors(i, t), Cne.subVectors(n, t), bde.crossVectors(Sde, Cne);
    let r = this.direction.dot(bde), l;
    if (r > 0) {
      if (s) return null;
      l = 1;
    } else if (r < 0)
      l = -1, r = -r;
    else
      return null;
    c_.subVectors(this.origin, t);
    const c = l * this.direction.dot(Cne.crossVectors(c_, Cne));
    if (c < 0)
      return null;
    const h = l * this.direction.dot(Sde.cross(c_));
    if (h < 0 || c + h > r)
      return null;
    const I = -l * c_.dot(bde);
    return I < 0 ? null : this.at(I / r, o);
  }
  /**
   * Transforms this ray with the given 4x4 transformation matrix.
   *
   * @param {Matrix4} matrix4 - The transformation matrix.
   * @return {Ray} A reference to this ray.
   */
  applyMatrix4(t) {
    return this.origin.applyMatrix4(t), this.direction.transformDirection(t), this;
  }
  /**
   * Returns `true` if this ray is equal with the given one.
   *
   * @param {Ray} ray - The ray to test for equality.
   * @return {boolean} Whether this ray is equal with the given one.
   */
  equals(t) {
    return t.origin.equals(this.origin) && t.direction.equals(this.direction);
  }
  /**
   * Returns a new ray with copied values from this instance.
   *
   * @return {Ray} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
}
class Ln {
  /**
   * Constructs a new 4x4 matrix. The arguments are supposed to be
   * in row-major order. If no arguments are provided, the constructor
   * initializes the matrix as an identity matrix.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n13] - 1-3 matrix element.
   * @param {number} [n14] - 1-4 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   * @param {number} [n23] - 2-3 matrix element.
   * @param {number} [n24] - 2-4 matrix element.
   * @param {number} [n31] - 3-1 matrix element.
   * @param {number} [n32] - 3-2 matrix element.
   * @param {number} [n33] - 3-3 matrix element.
   * @param {number} [n34] - 3-4 matrix element.
   * @param {number} [n41] - 4-1 matrix element.
   * @param {number} [n42] - 4-2 matrix element.
   * @param {number} [n43] - 4-3 matrix element.
   * @param {number} [n44] - 4-4 matrix element.
   */
  constructor(t, i, n, s, o, r, l, c, h, I, p, y, m, A, C, O) {
    Ln.prototype.isMatrix4 = !0, this.elements = [
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ], t !== void 0 && this.set(t, i, n, s, o, r, l, c, h, I, p, y, m, A, C, O);
  }
  /**
   * Sets the elements of the matrix.The arguments are supposed to be
   * in row-major order.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n13] - 1-3 matrix element.
   * @param {number} [n14] - 1-4 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   * @param {number} [n23] - 2-3 matrix element.
   * @param {number} [n24] - 2-4 matrix element.
   * @param {number} [n31] - 3-1 matrix element.
   * @param {number} [n32] - 3-2 matrix element.
   * @param {number} [n33] - 3-3 matrix element.
   * @param {number} [n34] - 3-4 matrix element.
   * @param {number} [n41] - 4-1 matrix element.
   * @param {number} [n42] - 4-2 matrix element.
   * @param {number} [n43] - 4-3 matrix element.
   * @param {number} [n44] - 4-4 matrix element.
   * @return {Matrix4} A reference to this matrix.
   */
  set(t, i, n, s, o, r, l, c, h, I, p, y, m, A, C, O) {
    const R = this.elements;
    return R[0] = t, R[4] = i, R[8] = n, R[12] = s, R[1] = o, R[5] = r, R[9] = l, R[13] = c, R[2] = h, R[6] = I, R[10] = p, R[14] = y, R[3] = m, R[7] = A, R[11] = C, R[15] = O, this;
  }
  /**
   * Sets this matrix to the 4x4 identity matrix.
   *
   * @return {Matrix4} A reference to this matrix.
   */
  identity() {
    return this.set(
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Returns a matrix with copied values from this instance.
   *
   * @return {Matrix4} A clone of this instance.
   */
  clone() {
    return new Ln().fromArray(this.elements);
  }
  /**
   * Copies the values of the given matrix to this instance.
   *
   * @param {Matrix4} m - The matrix to copy.
   * @return {Matrix4} A reference to this matrix.
   */
  copy(t) {
    const i = this.elements, n = t.elements;
    return i[0] = n[0], i[1] = n[1], i[2] = n[2], i[3] = n[3], i[4] = n[4], i[5] = n[5], i[6] = n[6], i[7] = n[7], i[8] = n[8], i[9] = n[9], i[10] = n[10], i[11] = n[11], i[12] = n[12], i[13] = n[13], i[14] = n[14], i[15] = n[15], this;
  }
  /**
   * Copies the translation component of the given matrix
   * into this matrix's translation component.
   *
   * @param {Matrix4} m - The matrix to copy the translation component.
   * @return {Matrix4} A reference to this matrix.
   */
  copyPosition(t) {
    const i = this.elements, n = t.elements;
    return i[12] = n[12], i[13] = n[13], i[14] = n[14], this;
  }
  /**
   * Set the upper 3x3 elements of this matrix to the values of given 3x3 matrix.
   *
   * @param {Matrix3} m - The 3x3 matrix.
   * @return {Matrix4} A reference to this matrix.
   */
  setFromMatrix3(t) {
    const i = t.elements;
    return this.set(
      i[0],
      i[3],
      i[6],
      0,
      i[1],
      i[4],
      i[7],
      0,
      i[2],
      i[5],
      i[8],
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Extracts the basis of this matrix into the three axis vectors provided.
   *
   * @param {Vector3} xAxis - The basis's x axis.
   * @param {Vector3} yAxis - The basis's y axis.
   * @param {Vector3} zAxis - The basis's z axis.
   * @return {Matrix4} A reference to this matrix.
   */
  extractBasis(t, i, n) {
    return t.setFromMatrixColumn(this, 0), i.setFromMatrixColumn(this, 1), n.setFromMatrixColumn(this, 2), this;
  }
  /**
   * Sets the given basis vectors to this matrix.
   *
   * @param {Vector3} xAxis - The basis's x axis.
   * @param {Vector3} yAxis - The basis's y axis.
   * @param {Vector3} zAxis - The basis's z axis.
   * @return {Matrix4} A reference to this matrix.
   */
  makeBasis(t, i, n) {
    return this.set(
      t.x,
      i.x,
      n.x,
      0,
      t.y,
      i.y,
      n.y,
      0,
      t.z,
      i.z,
      n.z,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Extracts the rotation component of the given matrix
   * into this matrix's rotation component.
   *
   * Note: This method does not support reflection matrices.
   *
   * @param {Matrix4} m - The matrix.
   * @return {Matrix4} A reference to this matrix.
   */
  extractRotation(t) {
    const i = this.elements, n = t.elements, s = 1 / kk.setFromMatrixColumn(t, 0).length(), o = 1 / kk.setFromMatrixColumn(t, 1).length(), r = 1 / kk.setFromMatrixColumn(t, 2).length();
    return i[0] = n[0] * s, i[1] = n[1] * s, i[2] = n[2] * s, i[3] = 0, i[4] = n[4] * o, i[5] = n[5] * o, i[6] = n[6] * o, i[7] = 0, i[8] = n[8] * r, i[9] = n[9] * r, i[10] = n[10] * r, i[11] = 0, i[12] = 0, i[13] = 0, i[14] = 0, i[15] = 1, this;
  }
  /**
   * Sets the rotation component (the upper left 3x3 matrix) of this matrix to
   * the rotation specified by the given Euler angles. The rest of
   * the matrix is set to the identity. Depending on the {@link Euler#order},
   * there are six possible outcomes. See [this page]{@link https://en.wikipedia.org/wiki/Euler_angles#Rotation_matrix}
   * for a complete list.
   *
   * @param {Euler} euler - The Euler angles.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationFromEuler(t) {
    const i = this.elements, n = t.x, s = t.y, o = t.z, r = Math.cos(n), l = Math.sin(n), c = Math.cos(s), h = Math.sin(s), I = Math.cos(o), p = Math.sin(o);
    if (t.order === "XYZ") {
      const y = r * I, m = r * p, A = l * I, C = l * p;
      i[0] = c * I, i[4] = -c * p, i[8] = h, i[1] = m + A * h, i[5] = y - C * h, i[9] = -l * c, i[2] = C - y * h, i[6] = A + m * h, i[10] = r * c;
    } else if (t.order === "YXZ") {
      const y = c * I, m = c * p, A = h * I, C = h * p;
      i[0] = y + C * l, i[4] = A * l - m, i[8] = r * h, i[1] = r * p, i[5] = r * I, i[9] = -l, i[2] = m * l - A, i[6] = C + y * l, i[10] = r * c;
    } else if (t.order === "ZXY") {
      const y = c * I, m = c * p, A = h * I, C = h * p;
      i[0] = y - C * l, i[4] = -r * p, i[8] = A + m * l, i[1] = m + A * l, i[5] = r * I, i[9] = C - y * l, i[2] = -r * h, i[6] = l, i[10] = r * c;
    } else if (t.order === "ZYX") {
      const y = r * I, m = r * p, A = l * I, C = l * p;
      i[0] = c * I, i[4] = A * h - m, i[8] = y * h + C, i[1] = c * p, i[5] = C * h + y, i[9] = m * h - A, i[2] = -h, i[6] = l * c, i[10] = r * c;
    } else if (t.order === "YZX") {
      const y = r * c, m = r * h, A = l * c, C = l * h;
      i[0] = c * I, i[4] = C - y * p, i[8] = A * p + m, i[1] = p, i[5] = r * I, i[9] = -l * I, i[2] = -h * I, i[6] = m * p + A, i[10] = y - C * p;
    } else if (t.order === "XZY") {
      const y = r * c, m = r * h, A = l * c, C = l * h;
      i[0] = c * I, i[4] = -p, i[8] = h * I, i[1] = y * p + C, i[5] = r * I, i[9] = m * p - A, i[2] = A * p - m, i[6] = l * I, i[10] = C * p + y;
    }
    return i[3] = 0, i[7] = 0, i[11] = 0, i[12] = 0, i[13] = 0, i[14] = 0, i[15] = 1, this;
  }
  /**
   * Sets the rotation component of this matrix to the rotation specified by
   * the given Quaternion as outlined [here]{@link https://en.wikipedia.org/wiki/Rotation_matrix#Quaternion}
   * The rest of the matrix is set to the identity.
   *
   * @param {Quaternion} q - The Quaternion.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationFromQuaternion(t) {
    return this.compose($9e, t, K9e);
  }
  /**
   * Sets the rotation component of the transformation matrix, looking from `eye` towards
   * `target`, and oriented by the up-direction.
   *
   * @param {Vector3} eye - The eye vector.
   * @param {Vector3} target - The target vector.
   * @param {Vector3} up - The up vector.
   * @return {Matrix4} A reference to this matrix.
   */
  lookAt(t, i, n) {
    const s = this.elements;
    return Qw.subVectors(t, i), Qw.lengthSq() === 0 && (Qw.z = 1), Qw.normalize(), h_.crossVectors(n, Qw), h_.lengthSq() === 0 && (Math.abs(n.z) === 1 ? Qw.x += 1e-4 : Qw.z += 1e-4, Qw.normalize(), h_.crossVectors(n, Qw)), h_.normalize(), One.crossVectors(Qw, h_), s[0] = h_.x, s[4] = One.x, s[8] = Qw.x, s[1] = h_.y, s[5] = One.y, s[9] = Qw.y, s[2] = h_.z, s[6] = One.z, s[10] = Qw.z, this;
  }
  /**
   * Post-multiplies this matrix by the given 4x4 matrix.
   *
   * @param {Matrix4} m - The matrix to multiply with.
   * @return {Matrix4} A reference to this matrix.
   */
  multiply(t) {
    return this.multiplyMatrices(this, t);
  }
  /**
   * Pre-multiplies this matrix by the given 4x4 matrix.
   *
   * @param {Matrix4} m - The matrix to multiply with.
   * @return {Matrix4} A reference to this matrix.
   */
  premultiply(t) {
    return this.multiplyMatrices(t, this);
  }
  /**
   * Multiples the given 4x4 matrices and stores the result
   * in this matrix.
   *
   * @param {Matrix4} a - The first matrix.
   * @param {Matrix4} b - The second matrix.
   * @return {Matrix4} A reference to this matrix.
   */
  multiplyMatrices(t, i) {
    const n = t.elements, s = i.elements, o = this.elements, r = n[0], l = n[4], c = n[8], h = n[12], I = n[1], p = n[5], y = n[9], m = n[13], A = n[2], C = n[6], O = n[10], R = n[14], F = n[3], L = n[7], P = n[11], z = n[15], W = s[0], re = s[4], ce = s[8], te = s[12], ee = s[1], Ne = s[5], Ae = s[9], Oe = s[13], pe = s[2], je = s[6], Ve = s[10], $e = s[14], vt = s[3], Rt = s[7], ze = s[11], mt = s[15];
    return o[0] = r * W + l * ee + c * pe + h * vt, o[4] = r * re + l * Ne + c * je + h * Rt, o[8] = r * ce + l * Ae + c * Ve + h * ze, o[12] = r * te + l * Oe + c * $e + h * mt, o[1] = I * W + p * ee + y * pe + m * vt, o[5] = I * re + p * Ne + y * je + m * Rt, o[9] = I * ce + p * Ae + y * Ve + m * ze, o[13] = I * te + p * Oe + y * $e + m * mt, o[2] = A * W + C * ee + O * pe + R * vt, o[6] = A * re + C * Ne + O * je + R * Rt, o[10] = A * ce + C * Ae + O * Ve + R * ze, o[14] = A * te + C * Oe + O * $e + R * mt, o[3] = F * W + L * ee + P * pe + z * vt, o[7] = F * re + L * Ne + P * je + z * Rt, o[11] = F * ce + L * Ae + P * Ve + z * ze, o[15] = F * te + L * Oe + P * $e + z * mt, this;
  }
  /**
   * Multiplies every component of the matrix by the given scalar.
   *
   * @param {number} s - The scalar.
   * @return {Matrix4} A reference to this matrix.
   */
  multiplyScalar(t) {
    const i = this.elements;
    return i[0] *= t, i[4] *= t, i[8] *= t, i[12] *= t, i[1] *= t, i[5] *= t, i[9] *= t, i[13] *= t, i[2] *= t, i[6] *= t, i[10] *= t, i[14] *= t, i[3] *= t, i[7] *= t, i[11] *= t, i[15] *= t, this;
  }
  /**
   * Computes and returns the determinant of this matrix.
   *
   * Based on the method outlined [here]{@link http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.html}.
   *
   * @return {number} The determinant.
   */
  determinant() {
    const t = this.elements, i = t[0], n = t[4], s = t[8], o = t[12], r = t[1], l = t[5], c = t[9], h = t[13], I = t[2], p = t[6], y = t[10], m = t[14], A = t[3], C = t[7], O = t[11], R = t[15];
    return A * (+o * c * p - s * h * p - o * l * y + n * h * y + s * l * m - n * c * m) + C * (+i * c * m - i * h * y + o * r * y - s * r * m + s * h * I - o * c * I) + O * (+i * h * p - i * l * m - o * r * p + n * r * m + o * l * I - n * h * I) + R * (-s * l * I - i * c * p + i * l * y + s * r * p - n * r * y + n * c * I);
  }
  /**
   * Transposes this matrix in place.
   *
   * @return {Matrix4} A reference to this matrix.
   */
  transpose() {
    const t = this.elements;
    let i;
    return i = t[1], t[1] = t[4], t[4] = i, i = t[2], t[2] = t[8], t[8] = i, i = t[6], t[6] = t[9], t[9] = i, i = t[3], t[3] = t[12], t[12] = i, i = t[7], t[7] = t[13], t[13] = i, i = t[11], t[11] = t[14], t[14] = i, this;
  }
  /**
   * Sets the position component for this matrix from the given vector,
   * without affecting the rest of the matrix.
   *
   * @param {number|Vector3} x - The x component of the vector or alternatively the vector object.
   * @param {number} y - The y component of the vector.
   * @param {number} z - The z component of the vector.
   * @return {Matrix4} A reference to this matrix.
   */
  setPosition(t, i, n) {
    const s = this.elements;
    return t.isVector3 ? (s[12] = t.x, s[13] = t.y, s[14] = t.z) : (s[12] = t, s[13] = i, s[14] = n), this;
  }
  /**
   * Inverts this matrix, using the [analytic method]{@link https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution}.
   * You can not invert with a determinant of zero. If you attempt this, the method produces
   * a zero matrix instead.
   *
   * @return {Matrix4} A reference to this matrix.
   */
  invert() {
    const t = this.elements, i = t[0], n = t[1], s = t[2], o = t[3], r = t[4], l = t[5], c = t[6], h = t[7], I = t[8], p = t[9], y = t[10], m = t[11], A = t[12], C = t[13], O = t[14], R = t[15], F = p * O * h - C * y * h + C * c * m - l * O * m - p * c * R + l * y * R, L = A * y * h - I * O * h - A * c * m + r * O * m + I * c * R - r * y * R, P = I * C * h - A * p * h + A * l * m - r * C * m - I * l * R + r * p * R, z = A * p * c - I * C * c - A * l * y + r * C * y + I * l * O - r * p * O, W = i * F + n * L + s * P + o * z;
    if (W === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    const re = 1 / W;
    return t[0] = F * re, t[1] = (C * y * o - p * O * o - C * s * m + n * O * m + p * s * R - n * y * R) * re, t[2] = (l * O * o - C * c * o + C * s * h - n * O * h - l * s * R + n * c * R) * re, t[3] = (p * c * o - l * y * o - p * s * h + n * y * h + l * s * m - n * c * m) * re, t[4] = L * re, t[5] = (I * O * o - A * y * o + A * s * m - i * O * m - I * s * R + i * y * R) * re, t[6] = (A * c * o - r * O * o - A * s * h + i * O * h + r * s * R - i * c * R) * re, t[7] = (r * y * o - I * c * o + I * s * h - i * y * h - r * s * m + i * c * m) * re, t[8] = P * re, t[9] = (A * p * o - I * C * o - A * n * m + i * C * m + I * n * R - i * p * R) * re, t[10] = (r * C * o - A * l * o + A * n * h - i * C * h - r * n * R + i * l * R) * re, t[11] = (I * l * o - r * p * o - I * n * h + i * p * h + r * n * m - i * l * m) * re, t[12] = z * re, t[13] = (I * C * s - A * p * s + A * n * y - i * C * y - I * n * O + i * p * O) * re, t[14] = (A * l * s - r * C * s - A * n * c + i * C * c + r * n * O - i * l * O) * re, t[15] = (r * p * s - I * l * s + I * n * c - i * p * c - r * n * y + i * l * y) * re, this;
  }
  /**
   * Multiplies the columns of this matrix by the given vector.
   *
   * @param {Vector3} v - The scale vector.
   * @return {Matrix4} A reference to this matrix.
   */
  scale(t) {
    const i = this.elements, n = t.x, s = t.y, o = t.z;
    return i[0] *= n, i[4] *= s, i[8] *= o, i[1] *= n, i[5] *= s, i[9] *= o, i[2] *= n, i[6] *= s, i[10] *= o, i[3] *= n, i[7] *= s, i[11] *= o, this;
  }
  /**
   * Gets the maximum scale value of the three axes.
   *
   * @return {number} The maximum scale.
   */
  getMaxScaleOnAxis() {
    const t = this.elements, i = t[0] * t[0] + t[1] * t[1] + t[2] * t[2], n = t[4] * t[4] + t[5] * t[5] + t[6] * t[6], s = t[8] * t[8] + t[9] * t[9] + t[10] * t[10];
    return Math.sqrt(Math.max(i, n, s));
  }
  /**
   * Sets this matrix as a translation transform from the given vector.
   *
   * @param {number|Vector3} x - The amount to translate in the X axis or alternatively a translation vector.
   * @param {number} y - The amount to translate in the Y axis.
   * @param {number} z - The amount to translate in the z axis.
   * @return {Matrix4} A reference to this matrix.
   */
  makeTranslation(t, i, n) {
    return t.isVector3 ? this.set(
      1,
      0,
      0,
      t.x,
      0,
      1,
      0,
      t.y,
      0,
      0,
      1,
      t.z,
      0,
      0,
      0,
      1
    ) : this.set(
      1,
      0,
      0,
      t,
      0,
      1,
      0,
      i,
      0,
      0,
      1,
      n,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a rotational transformation around the X axis by
   * the given angle.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationX(t) {
    const i = Math.cos(t), n = Math.sin(t);
    return this.set(
      1,
      0,
      0,
      0,
      0,
      i,
      -n,
      0,
      0,
      n,
      i,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a rotational transformation around the Y axis by
   * the given angle.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationY(t) {
    const i = Math.cos(t), n = Math.sin(t);
    return this.set(
      i,
      0,
      n,
      0,
      0,
      1,
      0,
      0,
      -n,
      0,
      i,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a rotational transformation around the Z axis by
   * the given angle.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationZ(t) {
    const i = Math.cos(t), n = Math.sin(t);
    return this.set(
      i,
      -n,
      0,
      0,
      n,
      i,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a rotational transformation around the given axis by
   * the given angle.
   *
   * This is a somewhat controversial but mathematically sound alternative to
   * rotating via Quaternions. See the discussion [here]{@link https://www.gamedev.net/articles/programming/math-and-physics/do-we-really-need-quaternions-r1199}.
   *
   * @param {Vector3} axis - The normalized rotation axis.
   * @param {number} angle - The rotation in radians.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationAxis(t, i) {
    const n = Math.cos(i), s = Math.sin(i), o = 1 - n, r = t.x, l = t.y, c = t.z, h = o * r, I = o * l;
    return this.set(
      h * r + n,
      h * l - s * c,
      h * c + s * l,
      0,
      h * l + s * c,
      I * l + n,
      I * c - s * r,
      0,
      h * c - s * l,
      I * c + s * r,
      o * c * c + n,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a scale transformation.
   *
   * @param {number} x - The amount to scale in the X axis.
   * @param {number} y - The amount to scale in the Y axis.
   * @param {number} z - The amount to scale in the Z axis.
   * @return {Matrix4} A reference to this matrix.
   */
  makeScale(t, i, n) {
    return this.set(
      t,
      0,
      0,
      0,
      0,
      i,
      0,
      0,
      0,
      0,
      n,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a shear transformation.
   *
   * @param {number} xy - The amount to shear X by Y.
   * @param {number} xz - The amount to shear X by Z.
   * @param {number} yx - The amount to shear Y by X.
   * @param {number} yz - The amount to shear Y by Z.
   * @param {number} zx - The amount to shear Z by X.
   * @param {number} zy - The amount to shear Z by Y.
   * @return {Matrix4} A reference to this matrix.
   */
  makeShear(t, i, n, s, o, r) {
    return this.set(
      1,
      n,
      o,
      0,
      t,
      1,
      r,
      0,
      i,
      s,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix to the transformation composed of the given position,
   * rotation (Quaternion) and scale.
   *
   * @param {Vector3} position - The position vector.
   * @param {Quaternion} quaternion - The rotation as a Quaternion.
   * @param {Vector3} scale - The scale vector.
   * @return {Matrix4} A reference to this matrix.
   */
  compose(t, i, n) {
    const s = this.elements, o = i._x, r = i._y, l = i._z, c = i._w, h = o + o, I = r + r, p = l + l, y = o * h, m = o * I, A = o * p, C = r * I, O = r * p, R = l * p, F = c * h, L = c * I, P = c * p, z = n.x, W = n.y, re = n.z;
    return s[0] = (1 - (C + R)) * z, s[1] = (m + P) * z, s[2] = (A - L) * z, s[3] = 0, s[4] = (m - P) * W, s[5] = (1 - (y + R)) * W, s[6] = (O + F) * W, s[7] = 0, s[8] = (A + L) * re, s[9] = (O - F) * re, s[10] = (1 - (y + C)) * re, s[11] = 0, s[12] = t.x, s[13] = t.y, s[14] = t.z, s[15] = 1, this;
  }
  /**
   * Decomposes this matrix into its position, rotation and scale components
   * and provides the result in the given objects.
   *
   * Note: Not all matrices are decomposable in this way. For example, if an
   * object has a non-uniformly scaled parent, then the object's world matrix
   * may not be decomposable, and this method may not be appropriate.
   *
   * @param {Vector3} position - The position vector.
   * @param {Quaternion} quaternion - The rotation as a Quaternion.
   * @param {Vector3} scale - The scale vector.
   * @return {Matrix4} A reference to this matrix.
   */
  decompose(t, i, n) {
    const s = this.elements;
    let o = kk.set(s[0], s[1], s[2]).length();
    const r = kk.set(s[4], s[5], s[6]).length(), l = kk.set(s[8], s[9], s[10]).length();
    this.determinant() < 0 && (o = -o), t.x = s[12], t.y = s[13], t.z = s[14], av.copy(this);
    const h = 1 / o, I = 1 / r, p = 1 / l;
    return av.elements[0] *= h, av.elements[1] *= h, av.elements[2] *= h, av.elements[4] *= I, av.elements[5] *= I, av.elements[6] *= I, av.elements[8] *= p, av.elements[9] *= p, av.elements[10] *= p, i.setFromRotationMatrix(av), n.x = o, n.y = r, n.z = l, this;
  }
  /**
  	 * Creates a perspective projection matrix. This is used internally by
  	 * {@link PerspectiveCamera#updateProjectionMatrix}.
  
  	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
  	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
  	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
  	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
  	 * @param {number} near - The distance from the camera to the near plane.
  	 * @param {number} far - The distance from the camera to the far plane.
  	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
  	 * @return {Matrix4} A reference to this matrix.
  	 */
  makePerspective(t, i, n, s, o, r, l = hN) {
    const c = this.elements, h = 2 * o / (i - t), I = 2 * o / (n - s), p = (i + t) / (i - t), y = (n + s) / (n - s);
    let m, A;
    if (l === hN)
      m = -(r + o) / (r - o), A = -2 * r * o / (r - o);
    else if (l === ple)
      m = -r / (r - o), A = -r * o / (r - o);
    else
      throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + l);
    return c[0] = h, c[4] = 0, c[8] = p, c[12] = 0, c[1] = 0, c[5] = I, c[9] = y, c[13] = 0, c[2] = 0, c[6] = 0, c[10] = m, c[14] = A, c[3] = 0, c[7] = 0, c[11] = -1, c[15] = 0, this;
  }
  /**
  	 * Creates a orthographic projection matrix. This is used internally by
  	 * {@link OrthographicCamera#updateProjectionMatrix}.
  
  	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
  	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
  	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
  	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
  	 * @param {number} near - The distance from the camera to the near plane.
  	 * @param {number} far - The distance from the camera to the far plane.
  	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
  	 * @return {Matrix4} A reference to this matrix.
  	 */
  makeOrthographic(t, i, n, s, o, r, l = hN) {
    const c = this.elements, h = 1 / (i - t), I = 1 / (n - s), p = 1 / (r - o), y = (i + t) * h, m = (n + s) * I;
    let A, C;
    if (l === hN)
      A = (r + o) * p, C = -2 * p;
    else if (l === ple)
      A = o * p, C = -1 * p;
    else
      throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + l);
    return c[0] = 2 * h, c[4] = 0, c[8] = 0, c[12] = -y, c[1] = 0, c[5] = 2 * I, c[9] = 0, c[13] = -m, c[2] = 0, c[6] = 0, c[10] = C, c[14] = -A, c[3] = 0, c[7] = 0, c[11] = 0, c[15] = 1, this;
  }
  /**
   * Returns `true` if this matrix is equal with the given one.
   *
   * @param {Matrix4} matrix - The matrix to test for equality.
   * @return {boolean} Whether this matrix is equal with the given one.
   */
  equals(t) {
    const i = this.elements, n = t.elements;
    for (let s = 0; s < 16; s++)
      if (i[s] !== n[s]) return !1;
    return !0;
  }
  /**
   * Sets the elements of the matrix from the given array.
   *
   * @param {Array<number>} array - The matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Matrix4} A reference to this matrix.
   */
  fromArray(t, i = 0) {
    for (let n = 0; n < 16; n++)
      this.elements[n] = t[n + i];
    return this;
  }
  /**
   * Writes the elements of this matrix to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The matrix elements in column-major order.
   */
  toArray(t = [], i = 0) {
    const n = this.elements;
    return t[i] = n[0], t[i + 1] = n[1], t[i + 2] = n[2], t[i + 3] = n[3], t[i + 4] = n[4], t[i + 5] = n[5], t[i + 6] = n[6], t[i + 7] = n[7], t[i + 8] = n[8], t[i + 9] = n[9], t[i + 10] = n[10], t[i + 11] = n[11], t[i + 12] = n[12], t[i + 13] = n[13], t[i + 14] = n[14], t[i + 15] = n[15], t;
  }
}
const kk = /* @__PURE__ */ new Ge(), av = /* @__PURE__ */ new Ln(), $9e = /* @__PURE__ */ new Ge(0, 0, 0), K9e = /* @__PURE__ */ new Ge(1, 1, 1), h_ = /* @__PURE__ */ new Ge(), One = /* @__PURE__ */ new Ge(), Qw = /* @__PURE__ */ new Ge(), KEe = /* @__PURE__ */ new Ln(), ZEe = /* @__PURE__ */ new gI();
class UA {
  /**
   * Constructs a new euler instance.
   *
   * @param {number} [x=0] - The angle of the x axis in radians.
   * @param {number} [y=0] - The angle of the y axis in radians.
   * @param {number} [z=0] - The angle of the z axis in radians.
   * @param {string} [order=Euler.DEFAULT_ORDER] - A string representing the order that the rotations are applied.
   */
  constructor(t = 0, i = 0, n = 0, s = UA.DEFAULT_ORDER) {
    this.isEuler = !0, this._x = t, this._y = i, this._z = n, this._order = s;
  }
  /**
   * The angle of the x axis in radians.
   *
   * @type {number}
   * @default 0
   */
  get x() {
    return this._x;
  }
  set x(t) {
    this._x = t, this._onChangeCallback();
  }
  /**
   * The angle of the y axis in radians.
   *
   * @type {number}
   * @default 0
   */
  get y() {
    return this._y;
  }
  set y(t) {
    this._y = t, this._onChangeCallback();
  }
  /**
   * The angle of the z axis in radians.
   *
   * @type {number}
   * @default 0
   */
  get z() {
    return this._z;
  }
  set z(t) {
    this._z = t, this._onChangeCallback();
  }
  /**
   * A string representing the order that the rotations are applied.
   *
   * @type {string}
   * @default 'XYZ'
   */
  get order() {
    return this._order;
  }
  set order(t) {
    this._order = t, this._onChangeCallback();
  }
  /**
   * Sets the Euler components.
   *
   * @param {number} x - The angle of the x axis in radians.
   * @param {number} y - The angle of the y axis in radians.
   * @param {number} z - The angle of the z axis in radians.
   * @param {string} [order] - A string representing the order that the rotations are applied.
   * @return {Euler} A reference to this Euler instance.
   */
  set(t, i, n, s = this._order) {
    return this._x = t, this._y = i, this._z = n, this._order = s, this._onChangeCallback(), this;
  }
  /**
   * Returns a new Euler instance with copied values from this instance.
   *
   * @return {Euler} A clone of this instance.
   */
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._order);
  }
  /**
   * Copies the values of the given Euler instance to this instance.
   *
   * @param {Euler} euler - The Euler instance to copy.
   * @return {Euler} A reference to this Euler instance.
   */
  copy(t) {
    return this._x = t._x, this._y = t._y, this._z = t._z, this._order = t._order, this._onChangeCallback(), this;
  }
  /**
   * Sets the angles of this Euler instance from a pure rotation matrix.
   *
   * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
   * @param {string} [order] - A string representing the order that the rotations are applied.
   * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
   * @return {Euler} A reference to this Euler instance.
   */
  setFromRotationMatrix(t, i = this._order, n = !0) {
    const s = t.elements, o = s[0], r = s[4], l = s[8], c = s[1], h = s[5], I = s[9], p = s[2], y = s[6], m = s[10];
    switch (i) {
      case "XYZ":
        this._y = Math.asin(Ho(l, -1, 1)), Math.abs(l) < 0.9999999 ? (this._x = Math.atan2(-I, m), this._z = Math.atan2(-r, o)) : (this._x = Math.atan2(y, h), this._z = 0);
        break;
      case "YXZ":
        this._x = Math.asin(-Ho(I, -1, 1)), Math.abs(I) < 0.9999999 ? (this._y = Math.atan2(l, m), this._z = Math.atan2(c, h)) : (this._y = Math.atan2(-p, o), this._z = 0);
        break;
      case "ZXY":
        this._x = Math.asin(Ho(y, -1, 1)), Math.abs(y) < 0.9999999 ? (this._y = Math.atan2(-p, m), this._z = Math.atan2(-r, h)) : (this._y = 0, this._z = Math.atan2(c, o));
        break;
      case "ZYX":
        this._y = Math.asin(-Ho(p, -1, 1)), Math.abs(p) < 0.9999999 ? (this._x = Math.atan2(y, m), this._z = Math.atan2(c, o)) : (this._x = 0, this._z = Math.atan2(-r, h));
        break;
      case "YZX":
        this._z = Math.asin(Ho(c, -1, 1)), Math.abs(c) < 0.9999999 ? (this._x = Math.atan2(-I, h), this._y = Math.atan2(-p, o)) : (this._x = 0, this._y = Math.atan2(l, m));
        break;
      case "XZY":
        this._z = Math.asin(-Ho(r, -1, 1)), Math.abs(r) < 0.9999999 ? (this._x = Math.atan2(y, h), this._y = Math.atan2(l, o)) : (this._x = Math.atan2(-I, m), this._y = 0);
        break;
      default:
        console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + i);
    }
    return this._order = i, n === !0 && this._onChangeCallback(), this;
  }
  /**
   * Sets the angles of this Euler instance from a normalized quaternion.
   *
   * @param {Quaternion} q - A normalized Quaternion.
   * @param {string} [order] - A string representing the order that the rotations are applied.
   * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
   * @return {Euler} A reference to this Euler instance.
   */
  setFromQuaternion(t, i, n) {
    return KEe.makeRotationFromQuaternion(t), this.setFromRotationMatrix(KEe, i, n);
  }
  /**
   * Sets the angles of this Euler instance from the given vector.
   *
   * @param {Vector3} v - The vector.
   * @param {string} [order] - A string representing the order that the rotations are applied.
   * @return {Euler} A reference to this Euler instance.
   */
  setFromVector3(t, i = this._order) {
    return this.set(t.x, t.y, t.z, i);
  }
  /**
   * Resets the euler angle with a new order by creating a quaternion from this
   * euler angle and then setting this euler angle with the quaternion and the
   * new order.
   *
   * Warning: This discards revolution information.
   *
   * @param {string} [newOrder] - A string representing the new order that the rotations are applied.
   * @return {Euler} A reference to this Euler instance.
   */
  reorder(t) {
    return ZEe.setFromEuler(this), this.setFromQuaternion(ZEe, t);
  }
  /**
   * Returns `true` if this Euler instance is equal with the given one.
   *
   * @param {Euler} euler - The Euler instance to test for equality.
   * @return {boolean} Whether this Euler instance is equal with the given one.
   */
  equals(t) {
    return t._x === this._x && t._y === this._y && t._z === this._z && t._order === this._order;
  }
  /**
   * Sets this Euler instance's components to values from the given array. The first three
   * entries of the array are assign to the x,y and z components. An optional fourth entry
   * defines the Euler order.
   *
   * @param {Array<number,number,number,?string>} array - An array holding the Euler component values.
   * @return {Euler} A reference to this Euler instance.
   */
  fromArray(t) {
    return this._x = t[0], this._y = t[1], this._z = t[2], t[3] !== void 0 && (this._order = t[3]), this._onChangeCallback(), this;
  }
  /**
   * Writes the components of this Euler instance to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number,number,number,string>} [array=[]] - The target array holding the Euler components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number,number,number,string>} The Euler components.
   */
  toArray(t = [], i = 0) {
    return t[i] = this._x, t[i + 1] = this._y, t[i + 2] = this._z, t[i + 3] = this._order, t;
  }
  _onChange(t) {
    return this._onChangeCallback = t, this;
  }
  _onChangeCallback() {
  }
  *[Symbol.iterator]() {
    yield this._x, yield this._y, yield this._z, yield this._order;
  }
}
UA.DEFAULT_ORDER = "XYZ";
class Zpe {
  /**
   * Constructs a new layers instance, with membership
   * initially set to layer `0`.
   */
  constructor() {
    this.mask = 1;
  }
  /**
   * Sets membership to the given layer, and remove membership all other layers.
   *
   * @param {number} layer - The layer to set.
   */
  set(t) {
    this.mask = (1 << t | 0) >>> 0;
  }
  /**
   * Adds membership of the given layer.
   *
   * @param {number} layer - The layer to enable.
   */
  enable(t) {
    this.mask |= 1 << t | 0;
  }
  /**
   * Adds membership to all layers.
   */
  enableAll() {
    this.mask = -1;
  }
  /**
   * Toggles the membership of the given layer.
   *
   * @param {number} layer - The layer to toggle.
   */
  toggle(t) {
    this.mask ^= 1 << t | 0;
  }
  /**
   * Removes membership of the given layer.
   *
   * @param {number} layer - The layer to enable.
   */
  disable(t) {
    this.mask &= ~(1 << t | 0);
  }
  /**
   * Removes the membership from all layers.
   */
  disableAll() {
    this.mask = 0;
  }
  /**
   * Returns `true` if this and the given layers object have at least one
   * layer in common.
   *
   * @param {Layers} layers - The layers to test.
   * @return {boolean } Whether this and the given layers object have at least one layer in common or not.
   */
  test(t) {
    return (this.mask & t.mask) !== 0;
  }
  /**
   * Returns `true` if the given layer is enabled.
   *
   * @param {number} layer - The layer to test.
   * @return {boolean } Whether the given layer is enabled or not.
   */
  isEnabled(t) {
    return (this.mask & (1 << t | 0)) !== 0;
  }
}
let Z9e = 0;
const QEe = /* @__PURE__ */ new Ge(), Vk = /* @__PURE__ */ new gI(), BD = /* @__PURE__ */ new Ln(), Lne = /* @__PURE__ */ new Ge(), RZ = /* @__PURE__ */ new Ge(), Q9e = /* @__PURE__ */ new Ge(), J9e = /* @__PURE__ */ new gI(), JEe = /* @__PURE__ */ new Ge(1, 0, 0), XEe = /* @__PURE__ */ new Ge(0, 1, 0), ege = /* @__PURE__ */ new Ge(0, 0, 1), tge = { type: "added" }, X9e = { type: "removed" }, zk = { type: "childadded", child: null }, Nde = { type: "childremoved", child: null };
class wu extends LH {
  /**
   * Constructs a new 3D object.
   */
  constructor() {
    super(), this.isObject3D = !0, Object.defineProperty(this, "id", { value: Z9e++ }), this.uuid = jO(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = wu.DEFAULT_UP.clone();
    const t = new Ge(), i = new UA(), n = new gI(), s = new Ge(1, 1, 1);
    function o() {
      n.setFromEuler(i, !1);
    }
    function r() {
      i.setFromQuaternion(n, void 0, !1);
    }
    i._onChange(o), n._onChange(r), Object.defineProperties(this, {
      /**
       * Represents the object's local position.
       *
       * @name Object3D#position
       * @type {Vector3}
       * @default (0,0,0)
       */
      position: {
        configurable: !0,
        enumerable: !0,
        value: t
      },
      /**
       * Represents the object's local rotation as Euler angles, in radians.
       *
       * @name Object3D#rotation
       * @type {Euler}
       * @default (0,0,0)
       */
      rotation: {
        configurable: !0,
        enumerable: !0,
        value: i
      },
      /**
       * Represents the object's local rotation as Quaternions.
       *
       * @name Object3D#quaternion
       * @type {Quaternion}
       */
      quaternion: {
        configurable: !0,
        enumerable: !0,
        value: n
      },
      /**
       * Represents the object's local scale.
       *
       * @name Object3D#scale
       * @type {Vector3}
       * @default (1,1,1)
       */
      scale: {
        configurable: !0,
        enumerable: !0,
        value: s
      },
      /**
       * Represents the object's model-view matrix.
       *
       * @name Object3D#modelViewMatrix
       * @type {Matrix4}
       */
      modelViewMatrix: {
        value: new Ln()
      },
      /**
       * Represents the object's normal matrix.
       *
       * @name Object3D#normalMatrix
       * @type {Matrix3}
       */
      normalMatrix: {
        value: new fo()
      }
    }), this.matrix = new Ln(), this.matrixWorld = new Ln(), this.matrixAutoUpdate = wu.DEFAULT_MATRIX_AUTO_UPDATE, this.matrixWorldAutoUpdate = wu.DEFAULT_MATRIX_WORLD_AUTO_UPDATE, this.matrixWorldNeedsUpdate = !1, this.layers = new Zpe(), this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.animations = [], this.customDepthMaterial = void 0, this.customDistanceMaterial = void 0, this.userData = {};
  }
  /**
   * A callback that is executed immediately before a 3D object is rendered to a shadow map.
   *
   * @param {Renderer|WebGLRenderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {Camera} shadowCamera - The shadow camera.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} depthMaterial - The depth material.
   * @param {Object} group - The geometry group data.
   */
  onBeforeShadow() {
  }
  /**
   * A callback that is executed immediately after a 3D object is rendered to a shadow map.
   *
   * @param {Renderer|WebGLRenderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {Camera} shadowCamera - The shadow camera.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} depthMaterial - The depth material.
   * @param {Object} group - The geometry group data.
   */
  onAfterShadow() {
  }
  /**
   * A callback that is executed immediately before a 3D object is rendered.
   *
   * @param {Renderer|WebGLRenderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} material - The 3D object's material.
   * @param {Object} group - The geometry group data.
   */
  onBeforeRender() {
  }
  /**
   * A callback that is executed immediately after a 3D object is rendered.
   *
   * @param {Renderer|WebGLRenderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} material - The 3D object's material.
   * @param {Object} group - The geometry group data.
   */
  onAfterRender() {
  }
  /**
   * Applies the given transformation matrix to the object and updates the object's position,
   * rotation and scale.
   *
   * @param {Matrix4} matrix - The transformation matrix.
   */
  applyMatrix4(t) {
    this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(t), this.matrix.decompose(this.position, this.quaternion, this.scale);
  }
  /**
   * Applies a rotation represented by given the quaternion to the 3D object.
   *
   * @param {Quaternion} q - The quaternion.
   * @return {Object3D} A reference to this instance.
   */
  applyQuaternion(t) {
    return this.quaternion.premultiply(t), this;
  }
  /**
   * Sets the given rotation represented as an axis/angle couple to the 3D object.
   *
   * @param {Vector3} axis - The (normalized) axis vector.
   * @param {number} angle - The angle in radians.
   */
  setRotationFromAxisAngle(t, i) {
    this.quaternion.setFromAxisAngle(t, i);
  }
  /**
   * Sets the given rotation represented as Euler angles to the 3D object.
   *
   * @param {Euler} euler - The Euler angles.
   */
  setRotationFromEuler(t) {
    this.quaternion.setFromEuler(t, !0);
  }
  /**
   * Sets the given rotation represented as rotation matrix to the 3D object.
   *
   * @param {Matrix4} m - Although a 4x4 matrix is expected, the upper 3x3 portion must be
   * a pure rotation matrix (i.e, unscaled).
   */
  setRotationFromMatrix(t) {
    this.quaternion.setFromRotationMatrix(t);
  }
  /**
   * Sets the given rotation represented as a Quaternion to the 3D object.
   *
   * @param {Quaternion} q - The Quaternion
   */
  setRotationFromQuaternion(t) {
    this.quaternion.copy(t);
  }
  /**
   * Rotates the 3D object along an axis in local space.
   *
   * @param {Vector3} axis - The (normalized) axis vector.
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateOnAxis(t, i) {
    return Vk.setFromAxisAngle(t, i), this.quaternion.multiply(Vk), this;
  }
  /**
   * Rotates the 3D object along an axis in world space.
   *
   * @param {Vector3} axis - The (normalized) axis vector.
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateOnWorldAxis(t, i) {
    return Vk.setFromAxisAngle(t, i), this.quaternion.premultiply(Vk), this;
  }
  /**
   * Rotates the 3D object around its X axis in local space.
   *
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateX(t) {
    return this.rotateOnAxis(JEe, t);
  }
  /**
   * Rotates the 3D object around its Y axis in local space.
   *
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateY(t) {
    return this.rotateOnAxis(XEe, t);
  }
  /**
   * Rotates the 3D object around its Z axis in local space.
   *
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateZ(t) {
    return this.rotateOnAxis(ege, t);
  }
  /**
   * Translate the 3D object by a distance along the given axis in local space.
   *
   * @param {Vector3} axis - The (normalized) axis vector.
   * @param {number} distance - The distance in world units.
   * @return {Object3D} A reference to this instance.
   */
  translateOnAxis(t, i) {
    return QEe.copy(t).applyQuaternion(this.quaternion), this.position.add(QEe.multiplyScalar(i)), this;
  }
  /**
   * Translate the 3D object by a distance along its X-axis in local space.
   *
   * @param {number} distance - The distance in world units.
   * @return {Object3D} A reference to this instance.
   */
  translateX(t) {
    return this.translateOnAxis(JEe, t);
  }
  /**
   * Translate the 3D object by a distance along its Y-axis in local space.
   *
   * @param {number} distance - The distance in world units.
   * @return {Object3D} A reference to this instance.
   */
  translateY(t) {
    return this.translateOnAxis(XEe, t);
  }
  /**
   * Translate the 3D object by a distance along its Z-axis in local space.
   *
   * @param {number} distance - The distance in world units.
   * @return {Object3D} A reference to this instance.
   */
  translateZ(t) {
    return this.translateOnAxis(ege, t);
  }
  /**
   * Converts the given vector from this 3D object's local space to world space.
   *
   * @param {Vector3} vector - The vector to convert.
   * @return {Vector3} The converted vector.
   */
  localToWorld(t) {
    return this.updateWorldMatrix(!0, !1), t.applyMatrix4(this.matrixWorld);
  }
  /**
   * Converts the given vector from this 3D object's word space to local space.
   *
   * @param {Vector3} vector - The vector to convert.
   * @return {Vector3} The converted vector.
   */
  worldToLocal(t) {
    return this.updateWorldMatrix(!0, !1), t.applyMatrix4(BD.copy(this.matrixWorld).invert());
  }
  /**
   * Rotates the object to face a point in world space.
   *
   * This method does not support objects having non-uniformly-scaled parent(s).
   *
   * @param {number|Vector3} x - The x coordinate in world space. Alternatively, a vector representing a position in world space
   * @param {number} [y] - The y coordinate in world space.
   * @param {number} [z] - The z coordinate in world space.
   */
  lookAt(t, i, n) {
    t.isVector3 ? Lne.copy(t) : Lne.set(t, i, n);
    const s = this.parent;
    this.updateWorldMatrix(!0, !1), RZ.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? BD.lookAt(RZ, Lne, this.up) : BD.lookAt(Lne, RZ, this.up), this.quaternion.setFromRotationMatrix(BD), s && (BD.extractRotation(s.matrixWorld), Vk.setFromRotationMatrix(BD), this.quaternion.premultiply(Vk.invert()));
  }
  /**
   * Adds the given 3D object as a child to this 3D object. An arbitrary number of
   * objects may be added. Any current parent on an object passed in here will be
   * removed, since an object can have at most one parent.
   *
   * @fires Object3D#added
   * @fires Object3D#childadded
   * @param {Object3D} object - The 3D object to add.
   * @return {Object3D} A reference to this instance.
   */
  add(t) {
    if (arguments.length > 1) {
      for (let i = 0; i < arguments.length; i++)
        this.add(arguments[i]);
      return this;
    }
    return t === this ? (console.error("THREE.Object3D.add: object can't be added as a child of itself.", t), this) : (t && t.isObject3D ? (t.removeFromParent(), t.parent = this, this.children.push(t), t.dispatchEvent(tge), zk.child = t, this.dispatchEvent(zk), zk.child = null) : console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", t), this);
  }
  /**
   * Removes the given 3D object as child from this 3D object.
   * An arbitrary number of objects may be removed.
   *
   * @fires Object3D#removed
   * @fires Object3D#childremoved
   * @param {Object3D} object - The 3D object to remove.
   * @return {Object3D} A reference to this instance.
   */
  remove(t) {
    if (arguments.length > 1) {
      for (let n = 0; n < arguments.length; n++)
        this.remove(arguments[n]);
      return this;
    }
    const i = this.children.indexOf(t);
    return i !== -1 && (t.parent = null, this.children.splice(i, 1), t.dispatchEvent(X9e), Nde.child = t, this.dispatchEvent(Nde), Nde.child = null), this;
  }
  /**
   * Removes this 3D object from its current parent.
   *
   * @fires Object3D#removed
   * @fires Object3D#childremoved
   * @return {Object3D} A reference to this instance.
   */
  removeFromParent() {
    const t = this.parent;
    return t !== null && t.remove(this), this;
  }
  /**
   * Removes all child objects.
   *
   * @fires Object3D#removed
   * @fires Object3D#childremoved
   * @return {Object3D} A reference to this instance.
   */
  clear() {
    return this.remove(...this.children);
  }
  /**
   * Adds the given 3D object as a child of this 3D object, while maintaining the object's world
   * transform. This method does not support scene graphs having non-uniformly-scaled nodes(s).
   *
   * @fires Object3D#added
   * @fires Object3D#childadded
   * @param {Object3D} object - The 3D object to attach.
   * @return {Object3D} A reference to this instance.
   */
  attach(t) {
    return this.updateWorldMatrix(!0, !1), BD.copy(this.matrixWorld).invert(), t.parent !== null && (t.parent.updateWorldMatrix(!0, !1), BD.multiply(t.parent.matrixWorld)), t.applyMatrix4(BD), t.removeFromParent(), t.parent = this, this.children.push(t), t.updateWorldMatrix(!1, !0), t.dispatchEvent(tge), zk.child = t, this.dispatchEvent(zk), zk.child = null, this;
  }
  /**
   * Searches through the 3D object and its children, starting with the 3D object
   * itself, and returns the first with a matching ID.
   *
   * @param {number} id - The id.
   * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
   */
  getObjectById(t) {
    return this.getObjectByProperty("id", t);
  }
  /**
   * Searches through the 3D object and its children, starting with the 3D object
   * itself, and returns the first with a matching name.
   *
   * @param {string} name - The name.
   * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
   */
  getObjectByName(t) {
    return this.getObjectByProperty("name", t);
  }
  /**
   * Searches through the 3D object and its children, starting with the 3D object
   * itself, and returns the first with a matching property value.
   *
   * @param {string} name - The name of the property.
   * @param {any} value - The value.
   * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
   */
  getObjectByProperty(t, i) {
    if (this[t] === i) return this;
    for (let n = 0, s = this.children.length; n < s; n++) {
      const r = this.children[n].getObjectByProperty(t, i);
      if (r !== void 0)
        return r;
    }
  }
  /**
   * Searches through the 3D object and its children, starting with the 3D object
   * itself, and returns all 3D objects with a matching property value.
   *
   * @param {string} name - The name of the property.
   * @param {any} value - The value.
   * @param {Array<Object3D>} result - The method stores the result in this array.
   * @return {Array<Object3D>} The found 3D objects.
   */
  getObjectsByProperty(t, i, n = []) {
    this[t] === i && n.push(this);
    const s = this.children;
    for (let o = 0, r = s.length; o < r; o++)
      s[o].getObjectsByProperty(t, i, n);
    return n;
  }
  /**
   * Returns a vector representing the position of the 3D object in world space.
   *
   * @param {Vector3} target - The target vector the result is stored to.
   * @return {Vector3} The 3D object's position in world space.
   */
  getWorldPosition(t) {
    return this.updateWorldMatrix(!0, !1), t.setFromMatrixPosition(this.matrixWorld);
  }
  /**
   * Returns a Quaternion representing the position of the 3D object in world space.
   *
   * @param {Quaternion} target - The target Quaternion the result is stored to.
   * @return {Quaternion} The 3D object's rotation in world space.
   */
  getWorldQuaternion(t) {
    return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(RZ, t, Q9e), t;
  }
  /**
   * Returns a vector representing the scale of the 3D object in world space.
   *
   * @param {Vector3} target - The target vector the result is stored to.
   * @return {Vector3} The 3D object's scale in world space.
   */
  getWorldScale(t) {
    return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(RZ, J9e, t), t;
  }
  /**
   * Returns a vector representing the ("look") direction of the 3D object in world space.
   *
   * @param {Vector3} target - The target vector the result is stored to.
   * @return {Vector3} The 3D object's direction in world space.
   */
  getWorldDirection(t) {
    this.updateWorldMatrix(!0, !1);
    const i = this.matrixWorld.elements;
    return t.set(i[8], i[9], i[10]).normalize();
  }
  /**
   * Abstract method to get intersections between a casted ray and this
   * 3D object. Renderable 3D objects such as {@link Mesh}, {@link Line} or {@link Points}
   * implement this method in order to use raycasting.
   *
   * @abstract
   * @param {Raycaster} raycaster - The raycaster.
   * @param {Array<Object>} intersects - An array holding the result of the method.
   */
  raycast() {
  }
  /**
   * Executes the callback on this 3D object and all descendants.
   *
   * Note: Modifying the scene graph inside the callback is discouraged.
   *
   * @param {Function} callback - A callback function that allows to process the current 3D object.
   */
  traverse(t) {
    t(this);
    const i = this.children;
    for (let n = 0, s = i.length; n < s; n++)
      i[n].traverse(t);
  }
  /**
   * Like {@link Object3D#traverse}, but the callback will only be executed for visible 3D objects.
   * Descendants of invisible 3D objects are not traversed.
   *
   * Note: Modifying the scene graph inside the callback is discouraged.
   *
   * @param {Function} callback - A callback function that allows to process the current 3D object.
   */
  traverseVisible(t) {
    if (this.visible === !1) return;
    t(this);
    const i = this.children;
    for (let n = 0, s = i.length; n < s; n++)
      i[n].traverseVisible(t);
  }
  /**
   * Like {@link Object3D#traverse}, but the callback will only be executed for all ancestors.
   *
   * Note: Modifying the scene graph inside the callback is discouraged.
   *
   * @param {Function} callback - A callback function that allows to process the current 3D object.
   */
  traverseAncestors(t) {
    const i = this.parent;
    i !== null && (t(i), i.traverseAncestors(t));
  }
  /**
   * Updates the transformation matrix in local space by computing it from the current
   * position, rotation and scale values.
   */
  updateMatrix() {
    this.matrix.compose(this.position, this.quaternion, this.scale), this.matrixWorldNeedsUpdate = !0;
  }
  /**
   * Updates the transformation matrix in world space of this 3D objects and its descendants.
   *
   * To ensure correct results, this method also recomputes the 3D object's transformation matrix in
   * local space. The computation of the local and world matrix can be controlled with the
   * {@link Object3D#matrixAutoUpdate} and {@link Object3D#matrixWorldAutoUpdate} flags which are both
   * `true` by default.  Set these flags to `false` if you need more control over the update matrix process.
   *
   * @param {boolean} [force=false] - When set to `true`, a recomputation of world matrices is forced even
   * when {@link Object3D#matrixWorldAutoUpdate} is set to `false`.
   */
  updateMatrixWorld(t) {
    this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || t) && (this.matrixWorldAutoUpdate === !0 && (this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), this.matrixWorldNeedsUpdate = !1, t = !0);
    const i = this.children;
    for (let n = 0, s = i.length; n < s; n++)
      i[n].updateMatrixWorld(t);
  }
  /**
   * An alternative version of {@link Object3D#updateMatrixWorld} with more control over the
   * update of ancestor and descendant nodes.
   *
   * @param {boolean} [updateParents=false] Whether ancestor nodes should be updated or not.
   * @param {boolean} [updateChildren=false] Whether descendant nodes should be updated or not.
   */
  updateWorldMatrix(t, i) {
    const n = this.parent;
    if (t === !0 && n !== null && n.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), this.matrixWorldAutoUpdate === !0 && (this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), i === !0) {
      const s = this.children;
      for (let o = 0, r = s.length; o < r; o++)
        s[o].updateWorldMatrix(!1, !0);
    }
  }
  /**
   * Serializes the 3D object into JSON.
   *
   * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized 3D object.
   * @see {@link ObjectLoader#parse}
   */
  toJSON(t) {
    const i = t === void 0 || typeof t == "string", n = {};
    i && (t = {
      geometries: {},
      materials: {},
      textures: {},
      images: {},
      shapes: {},
      skeletons: {},
      animations: {},
      nodes: {}
    }, n.metadata = {
      version: 4.7,
      type: "Object",
      generator: "Object3D.toJSON"
    });
    const s = {};
    s.uuid = this.uuid, s.type = this.type, this.name !== "" && (s.name = this.name), this.castShadow === !0 && (s.castShadow = !0), this.receiveShadow === !0 && (s.receiveShadow = !0), this.visible === !1 && (s.visible = !1), this.frustumCulled === !1 && (s.frustumCulled = !1), this.renderOrder !== 0 && (s.renderOrder = this.renderOrder), Object.keys(this.userData).length > 0 && (s.userData = this.userData), s.layers = this.layers.mask, s.matrix = this.matrix.toArray(), s.up = this.up.toArray(), this.matrixAutoUpdate === !1 && (s.matrixAutoUpdate = !1), this.isInstancedMesh && (s.type = "InstancedMesh", s.count = this.count, s.instanceMatrix = this.instanceMatrix.toJSON(), this.instanceColor !== null && (s.instanceColor = this.instanceColor.toJSON())), this.isBatchedMesh && (s.type = "BatchedMesh", s.perObjectFrustumCulled = this.perObjectFrustumCulled, s.sortObjects = this.sortObjects, s.drawRanges = this._drawRanges, s.reservedRanges = this._reservedRanges, s.geometryInfo = this._geometryInfo.map((l) => ({
      ...l,
      boundingBox: l.boundingBox ? l.boundingBox.toJSON() : void 0,
      boundingSphere: l.boundingSphere ? l.boundingSphere.toJSON() : void 0
    })), s.instanceInfo = this._instanceInfo.map((l) => ({ ...l })), s.availableInstanceIds = this._availableInstanceIds.slice(), s.availableGeometryIds = this._availableGeometryIds.slice(), s.nextIndexStart = this._nextIndexStart, s.nextVertexStart = this._nextVertexStart, s.geometryCount = this._geometryCount, s.maxInstanceCount = this._maxInstanceCount, s.maxVertexCount = this._maxVertexCount, s.maxIndexCount = this._maxIndexCount, s.geometryInitialized = this._geometryInitialized, s.matricesTexture = this._matricesTexture.toJSON(t), s.indirectTexture = this._indirectTexture.toJSON(t), this._colorsTexture !== null && (s.colorsTexture = this._colorsTexture.toJSON(t)), this.boundingSphere !== null && (s.boundingSphere = this.boundingSphere.toJSON()), this.boundingBox !== null && (s.boundingBox = this.boundingBox.toJSON()));
    function o(l, c) {
      return l[c.uuid] === void 0 && (l[c.uuid] = c.toJSON(t)), c.uuid;
    }
    if (this.isScene)
      this.background && (this.background.isColor ? s.background = this.background.toJSON() : this.background.isTexture && (s.background = this.background.toJSON(t).uuid)), this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== !0 && (s.environment = this.environment.toJSON(t).uuid);
    else if (this.isMesh || this.isLine || this.isPoints) {
      s.geometry = o(t.geometries, this.geometry);
      const l = this.geometry.parameters;
      if (l !== void 0 && l.shapes !== void 0) {
        const c = l.shapes;
        if (Array.isArray(c))
          for (let h = 0, I = c.length; h < I; h++) {
            const p = c[h];
            o(t.shapes, p);
          }
        else
          o(t.shapes, c);
      }
    }
    if (this.isSkinnedMesh && (s.bindMode = this.bindMode, s.bindMatrix = this.bindMatrix.toArray(), this.skeleton !== void 0 && (o(t.skeletons, this.skeleton), s.skeleton = this.skeleton.uuid)), this.material !== void 0)
      if (Array.isArray(this.material)) {
        const l = [];
        for (let c = 0, h = this.material.length; c < h; c++)
          l.push(o(t.materials, this.material[c]));
        s.material = l;
      } else
        s.material = o(t.materials, this.material);
    if (this.children.length > 0) {
      s.children = [];
      for (let l = 0; l < this.children.length; l++)
        s.children.push(this.children[l].toJSON(t).object);
    }
    if (this.animations.length > 0) {
      s.animations = [];
      for (let l = 0; l < this.animations.length; l++) {
        const c = this.animations[l];
        s.animations.push(o(t.animations, c));
      }
    }
    if (i) {
      const l = r(t.geometries), c = r(t.materials), h = r(t.textures), I = r(t.images), p = r(t.shapes), y = r(t.skeletons), m = r(t.animations), A = r(t.nodes);
      l.length > 0 && (n.geometries = l), c.length > 0 && (n.materials = c), h.length > 0 && (n.textures = h), I.length > 0 && (n.images = I), p.length > 0 && (n.shapes = p), y.length > 0 && (n.skeletons = y), m.length > 0 && (n.animations = m), A.length > 0 && (n.nodes = A);
    }
    return n.object = s, n;
    function r(l) {
      const c = [];
      for (const h in l) {
        const I = l[h];
        delete I.metadata, c.push(I);
      }
      return c;
    }
  }
  /**
   * Returns a new 3D object with copied values from this instance.
   *
   * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are also cloned.
   * @return {Object3D} A clone of this instance.
   */
  clone(t) {
    return new this.constructor().copy(this, t);
  }
  /**
   * Copies the values of the given 3D object to this instance.
   *
   * @param {Object3D} source - The 3D object to copy.
   * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are cloned.
   * @return {Object3D} A reference to this instance.
   */
  copy(t, i = !0) {
    if (this.name = t.name, this.up.copy(t.up), this.position.copy(t.position), this.rotation.order = t.rotation.order, this.quaternion.copy(t.quaternion), this.scale.copy(t.scale), this.matrix.copy(t.matrix), this.matrixWorld.copy(t.matrixWorld), this.matrixAutoUpdate = t.matrixAutoUpdate, this.matrixWorldAutoUpdate = t.matrixWorldAutoUpdate, this.matrixWorldNeedsUpdate = t.matrixWorldNeedsUpdate, this.layers.mask = t.layers.mask, this.visible = t.visible, this.castShadow = t.castShadow, this.receiveShadow = t.receiveShadow, this.frustumCulled = t.frustumCulled, this.renderOrder = t.renderOrder, this.animations = t.animations.slice(), this.userData = JSON.parse(JSON.stringify(t.userData)), i === !0)
      for (let n = 0; n < t.children.length; n++) {
        const s = t.children[n];
        this.add(s.clone());
      }
    return this;
  }
}
wu.DEFAULT_UP = /* @__PURE__ */ new Ge(0, 1, 0);
wu.DEFAULT_MATRIX_AUTO_UPDATE = !0;
wu.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = !0;
const uv = /* @__PURE__ */ new Ge(), FD = /* @__PURE__ */ new Ge(), Dde = /* @__PURE__ */ new Ge(), HD = /* @__PURE__ */ new Ge(), jk = /* @__PURE__ */ new Ge(), Wk = /* @__PURE__ */ new Ge(), ige = /* @__PURE__ */ new Ge(), Cde = /* @__PURE__ */ new Ge(), Ode = /* @__PURE__ */ new Ge(), Lde = /* @__PURE__ */ new Ge(), _de = /* @__PURE__ */ new Ol(), xde = /* @__PURE__ */ new Ol(), Pde = /* @__PURE__ */ new Ol();
class wc {
  /**
   * Constructs a new triangle.
   *
   * @param {Vector3} [a=(0,0,0)] - The first corner of the triangle.
   * @param {Vector3} [b=(0,0,0)] - The second corner of the triangle.
   * @param {Vector3} [c=(0,0,0)] - The third corner of the triangle.
   */
  constructor(t = new Ge(), i = new Ge(), n = new Ge()) {
    this.a = t, this.b = i, this.c = n;
  }
  /**
   * Computes the normal vector of a triangle.
   *
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The triangle's normal.
   */
  static getNormal(t, i, n, s) {
    s.subVectors(n, i), uv.subVectors(t, i), s.cross(uv);
    const o = s.lengthSq();
    return o > 0 ? s.multiplyScalar(1 / Math.sqrt(o)) : s.set(0, 0, 0);
  }
  /**
   * Computes a barycentric coordinates from the given vector.
   * Returns `null` if the triangle is degenerate.
   *
   * @param {Vector3} point - A point in 3D space.
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The barycentric coordinates for the given point
   */
  static getBarycoord(t, i, n, s, o) {
    uv.subVectors(s, i), FD.subVectors(n, i), Dde.subVectors(t, i);
    const r = uv.dot(uv), l = uv.dot(FD), c = uv.dot(Dde), h = FD.dot(FD), I = FD.dot(Dde), p = r * h - l * l;
    if (p === 0)
      return o.set(0, 0, 0), null;
    const y = 1 / p, m = (h * c - l * I) * y, A = (r * I - l * c) * y;
    return o.set(1 - m - A, A, m);
  }
  /**
   * Returns `true` if the given point, when projected onto the plane of the
   * triangle, lies within the triangle.
   *
   * @param {Vector3} point - The point in 3D space to test.
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @return {boolean} Whether the given point, when projected onto the plane of the
   * triangle, lies within the triangle or not.
   */
  static containsPoint(t, i, n, s) {
    return this.getBarycoord(t, i, n, s, HD) === null ? !1 : HD.x >= 0 && HD.y >= 0 && HD.x + HD.y <= 1;
  }
  /**
   * Computes the value barycentrically interpolated for the given point on the
   * triangle. Returns `null` if the triangle is degenerate.
   *
   * @param {Vector3} point - Position of interpolated point.
   * @param {Vector3} p1 - The first corner of the triangle.
   * @param {Vector3} p2 - The second corner of the triangle.
   * @param {Vector3} p3 - The third corner of the triangle.
   * @param {Vector3} v1 - Value to interpolate of first vertex.
   * @param {Vector3} v2 - Value to interpolate of second vertex.
   * @param {Vector3} v3 - Value to interpolate of third vertex.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The interpolated value.
   */
  static getInterpolation(t, i, n, s, o, r, l, c) {
    return this.getBarycoord(t, i, n, s, HD) === null ? (c.x = 0, c.y = 0, "z" in c && (c.z = 0), "w" in c && (c.w = 0), null) : (c.setScalar(0), c.addScaledVector(o, HD.x), c.addScaledVector(r, HD.y), c.addScaledVector(l, HD.z), c);
  }
  /**
   * Computes the value barycentrically interpolated for the given attribute and indices.
   *
   * @param {BufferAttribute} attr - The attribute to interpolate.
   * @param {number} i1 - Index of first vertex.
   * @param {number} i2 - Index of second vertex.
   * @param {number} i3 - Index of third vertex.
   * @param {Vector3} barycoord - The barycoordinate value to use to interpolate.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The interpolated attribute value.
   */
  static getInterpolatedAttribute(t, i, n, s, o, r) {
    return _de.setScalar(0), xde.setScalar(0), Pde.setScalar(0), _de.fromBufferAttribute(t, i), xde.fromBufferAttribute(t, n), Pde.fromBufferAttribute(t, s), r.setScalar(0), r.addScaledVector(_de, o.x), r.addScaledVector(xde, o.y), r.addScaledVector(Pde, o.z), r;
  }
  /**
   * Returns `true` if the triangle is oriented towards the given direction.
   *
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @param {Vector3} direction - The (normalized) direction vector.
   * @return {boolean} Whether the triangle is oriented towards the given direction or not.
   */
  static isFrontFacing(t, i, n, s) {
    return uv.subVectors(n, i), FD.subVectors(t, i), uv.cross(FD).dot(s) < 0;
  }
  /**
   * Sets the triangle's vertices by copying the given values.
   *
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @return {Triangle} A reference to this triangle.
   */
  set(t, i, n) {
    return this.a.copy(t), this.b.copy(i), this.c.copy(n), this;
  }
  /**
   * Sets the triangle's vertices by copying the given array values.
   *
   * @param {Array<Vector3>} points - An array with 3D points.
   * @param {number} i0 - The array index representing the first corner of the triangle.
   * @param {number} i1 - The array index representing the second corner of the triangle.
   * @param {number} i2 - The array index representing the third corner of the triangle.
   * @return {Triangle} A reference to this triangle.
   */
  setFromPointsAndIndices(t, i, n, s) {
    return this.a.copy(t[i]), this.b.copy(t[n]), this.c.copy(t[s]), this;
  }
  /**
   * Sets the triangle's vertices by copying the given attribute values.
   *
   * @param {BufferAttribute} attribute - A buffer attribute with 3D points data.
   * @param {number} i0 - The attribute index representing the first corner of the triangle.
   * @param {number} i1 - The attribute index representing the second corner of the triangle.
   * @param {number} i2 - The attribute index representing the third corner of the triangle.
   * @return {Triangle} A reference to this triangle.
   */
  setFromAttributeAndIndices(t, i, n, s) {
    return this.a.fromBufferAttribute(t, i), this.b.fromBufferAttribute(t, n), this.c.fromBufferAttribute(t, s), this;
  }
  /**
   * Returns a new triangle with copied values from this instance.
   *
   * @return {Triangle} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the values of the given triangle to this instance.
   *
   * @param {Triangle} triangle - The triangle to copy.
   * @return {Triangle} A reference to this triangle.
   */
  copy(t) {
    return this.a.copy(t.a), this.b.copy(t.b), this.c.copy(t.c), this;
  }
  /**
   * Computes the area of the triangle.
   *
   * @return {number} The triangle's area.
   */
  getArea() {
    return uv.subVectors(this.c, this.b), FD.subVectors(this.a, this.b), uv.cross(FD).length() * 0.5;
  }
  /**
   * Computes the midpoint of the triangle.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The triangle's midpoint.
   */
  getMidpoint(t) {
    return t.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
  }
  /**
   * Computes the normal of the triangle.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The triangle's normal.
   */
  getNormal(t) {
    return wc.getNormal(this.a, this.b, this.c, t);
  }
  /**
   * Computes a plane the triangle lies within.
   *
   * @param {Plane} target - The target vector that is used to store the method's result.
   * @return {Plane} The plane the triangle lies within.
   */
  getPlane(t) {
    return t.setFromCoplanarPoints(this.a, this.b, this.c);
  }
  /**
   * Computes a barycentric coordinates from the given vector.
   * Returns `null` if the triangle is degenerate.
   *
   * @param {Vector3} point - A point in 3D space.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The barycentric coordinates for the given point
   */
  getBarycoord(t, i) {
    return wc.getBarycoord(t, this.a, this.b, this.c, i);
  }
  /**
   * Computes the value barycentrically interpolated for the given point on the
   * triangle. Returns `null` if the triangle is degenerate.
   *
   * @param {Vector3} point - Position of interpolated point.
   * @param {Vector3} v1 - Value to interpolate of first vertex.
   * @param {Vector3} v2 - Value to interpolate of second vertex.
   * @param {Vector3} v3 - Value to interpolate of third vertex.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The interpolated value.
   */
  getInterpolation(t, i, n, s, o) {
    return wc.getInterpolation(t, this.a, this.b, this.c, i, n, s, o);
  }
  /**
   * Returns `true` if the given point, when projected onto the plane of the
   * triangle, lies within the triangle.
   *
   * @param {Vector3} point - The point in 3D space to test.
   * @return {boolean} Whether the given point, when projected onto the plane of the
   * triangle, lies within the triangle or not.
   */
  containsPoint(t) {
    return wc.containsPoint(t, this.a, this.b, this.c);
  }
  /**
   * Returns `true` if the triangle is oriented towards the given direction.
   *
   * @param {Vector3} direction - The (normalized) direction vector.
   * @return {boolean} Whether the triangle is oriented towards the given direction or not.
   */
  isFrontFacing(t) {
    return wc.isFrontFacing(this.a, this.b, this.c, t);
  }
  /**
   * Returns `true` if this triangle intersects with the given box.
   *
   * @param {Box3} box - The box to intersect.
   * @return {boolean} Whether this triangle intersects with the given box or not.
   */
  intersectsBox(t) {
    return t.intersectsTriangle(this);
  }
  /**
   * Returns the closest point on the triangle to the given point.
   *
   * @param {Vector3} p - The point to compute the closest point for.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The closest point on the triangle.
   */
  closestPointToPoint(t, i) {
    const n = this.a, s = this.b, o = this.c;
    let r, l;
    jk.subVectors(s, n), Wk.subVectors(o, n), Cde.subVectors(t, n);
    const c = jk.dot(Cde), h = Wk.dot(Cde);
    if (c <= 0 && h <= 0)
      return i.copy(n);
    Ode.subVectors(t, s);
    const I = jk.dot(Ode), p = Wk.dot(Ode);
    if (I >= 0 && p <= I)
      return i.copy(s);
    const y = c * p - I * h;
    if (y <= 0 && c >= 0 && I <= 0)
      return r = c / (c - I), i.copy(n).addScaledVector(jk, r);
    Lde.subVectors(t, o);
    const m = jk.dot(Lde), A = Wk.dot(Lde);
    if (A >= 0 && m <= A)
      return i.copy(o);
    const C = m * h - c * A;
    if (C <= 0 && h >= 0 && A <= 0)
      return l = h / (h - A), i.copy(n).addScaledVector(Wk, l);
    const O = I * A - m * p;
    if (O <= 0 && p - I >= 0 && m - A >= 0)
      return ige.subVectors(o, s), l = (p - I) / (p - I + (m - A)), i.copy(s).addScaledVector(ige, l);
    const R = 1 / (O + C + y);
    return r = C * R, l = y * R, i.copy(n).addScaledVector(jk, r).addScaledVector(Wk, l);
  }
  /**
   * Returns `true` if this triangle is equal with the given one.
   *
   * @param {Triangle} triangle - The triangle to test for equality.
   * @return {boolean} Whether this triangle is equal with the given one.
   */
  equals(t) {
    return t.a.equals(this.a) && t.b.equals(this.b) && t.c.equals(this.c);
  }
}
const yAe = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
}, f_ = { h: 0, s: 0, l: 0 }, _ne = { h: 0, s: 0, l: 0 };
function Mde(e, t, i) {
  return i < 0 && (i += 1), i > 1 && (i -= 1), i < 1 / 6 ? e + (t - e) * 6 * i : i < 1 / 2 ? t : i < 2 / 3 ? e + (t - e) * 6 * (2 / 3 - i) : e;
}
class Xn {
  /**
   * Constructs a new color.
   *
   * Note that standard method of specifying color in three.js is with a hexadecimal triplet,
   * and that method is used throughout the rest of the documentation.
   *
   * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
   * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
   * @param {number} [g] - The green component.
   * @param {number} [b] - The blue component.
   */
  constructor(t, i, n) {
    return this.isColor = !0, this.r = 1, this.g = 1, this.b = 1, this.set(t, i, n);
  }
  /**
   * Sets the colors's components from the given values.
   *
   * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
   * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
   * @param {number} [g] - The green component.
   * @param {number} [b] - The blue component.
   * @return {Color} A reference to this color.
   */
  set(t, i, n) {
    if (i === void 0 && n === void 0) {
      const s = t;
      s && s.isColor ? this.copy(s) : typeof s == "number" ? this.setHex(s) : typeof s == "string" && this.setStyle(s);
    } else
      this.setRGB(t, i, n);
    return this;
  }
  /**
   * Sets the colors's components to the given scalar value.
   *
   * @param {number} scalar - The scalar value.
   * @return {Color} A reference to this color.
   */
  setScalar(t) {
    return this.r = t, this.g = t, this.b = t, this;
  }
  /**
   * Sets this color from a hexadecimal value.
   *
   * @param {number} hex - The hexadecimal value.
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setHex(t, i = Hy) {
    return t = Math.floor(t), this.r = (t >> 16 & 255) / 255, this.g = (t >> 8 & 255) / 255, this.b = (t & 255) / 255, Qr.colorSpaceToWorking(this, i), this;
  }
  /**
   * Sets this color from RGB values.
   *
   * @param {number} r - Red channel value between `0.0` and `1.0`.
   * @param {number} g - Green channel value between `0.0` and `1.0`.
   * @param {number} b - Blue channel value between `0.0` and `1.0`.
   * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setRGB(t, i, n, s = Qr.workingColorSpace) {
    return this.r = t, this.g = i, this.b = n, Qr.colorSpaceToWorking(this, s), this;
  }
  /**
   * Sets this color from RGB values.
   *
   * @param {number} h - Hue value between `0.0` and `1.0`.
   * @param {number} s - Saturation value between `0.0` and `1.0`.
   * @param {number} l - Lightness value between `0.0` and `1.0`.
   * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setHSL(t, i, n, s = Qr.workingColorSpace) {
    if (t = $pe(t, 1), i = Ho(i, 0, 1), n = Ho(n, 0, 1), i === 0)
      this.r = this.g = this.b = n;
    else {
      const o = n <= 0.5 ? n * (1 + i) : n + i - n * i, r = 2 * n - o;
      this.r = Mde(r, o, t + 1 / 3), this.g = Mde(r, o, t), this.b = Mde(r, o, t - 1 / 3);
    }
    return Qr.colorSpaceToWorking(this, s), this;
  }
  /**
   * Sets this color from a CSS-style string. For example, `rgb(250, 0,0)`,
   * `rgb(100%, 0%, 0%)`, `hsl(0, 100%, 50%)`, `#ff0000`, `#f00`, or `red` ( or
   * any [X11 color name]{@link https://en.wikipedia.org/wiki/X11_color_names#Color_name_chart} -
   * all 140 color names are supported).
   *
   * @param {string} style - Color as a CSS-style string.
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setStyle(t, i = Hy) {
    function n(o) {
      o !== void 0 && parseFloat(o) < 1 && console.warn("THREE.Color: Alpha component of " + t + " will be ignored.");
    }
    let s;
    if (s = /^(\w+)\(([^\)]*)\)/.exec(t)) {
      let o;
      const r = s[1], l = s[2];
      switch (r) {
        case "rgb":
        case "rgba":
          if (o = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(l))
            return n(o[4]), this.setRGB(
              Math.min(255, parseInt(o[1], 10)) / 255,
              Math.min(255, parseInt(o[2], 10)) / 255,
              Math.min(255, parseInt(o[3], 10)) / 255,
              i
            );
          if (o = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(l))
            return n(o[4]), this.setRGB(
              Math.min(100, parseInt(o[1], 10)) / 100,
              Math.min(100, parseInt(o[2], 10)) / 100,
              Math.min(100, parseInt(o[3], 10)) / 100,
              i
            );
          break;
        case "hsl":
        case "hsla":
          if (o = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(l))
            return n(o[4]), this.setHSL(
              parseFloat(o[1]) / 360,
              parseFloat(o[2]) / 100,
              parseFloat(o[3]) / 100,
              i
            );
          break;
        default:
          console.warn("THREE.Color: Unknown color model " + t);
      }
    } else if (s = /^\#([A-Fa-f\d]+)$/.exec(t)) {
      const o = s[1], r = o.length;
      if (r === 3)
        return this.setRGB(
          parseInt(o.charAt(0), 16) / 15,
          parseInt(o.charAt(1), 16) / 15,
          parseInt(o.charAt(2), 16) / 15,
          i
        );
      if (r === 6)
        return this.setHex(parseInt(o, 16), i);
      console.warn("THREE.Color: Invalid hex color " + t);
    } else if (t && t.length > 0)
      return this.setColorName(t, i);
    return this;
  }
  /**
   * Sets this color from a color name. Faster than {@link Color#setStyle} if
   * you don't need the other CSS-style formats.
   *
   * For convenience, the list of names is exposed in `Color.NAMES` as a hash.
   * ```js
   * Color.NAMES.aliceblue // returns 0xF0F8FF
   * ```
   *
   * @param {string} style - The color name.
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setColorName(t, i = Hy) {
    const n = yAe[t.toLowerCase()];
    return n !== void 0 ? this.setHex(n, i) : console.warn("THREE.Color: Unknown color " + t), this;
  }
  /**
   * Returns a new color with copied values from this instance.
   *
   * @return {Color} A clone of this instance.
   */
  clone() {
    return new this.constructor(this.r, this.g, this.b);
  }
  /**
   * Copies the values of the given color to this instance.
   *
   * @param {Color} color - The color to copy.
   * @return {Color} A reference to this color.
   */
  copy(t) {
    return this.r = t.r, this.g = t.g, this.b = t.b, this;
  }
  /**
   * Copies the given color into this color, and then converts this color from
   * `SRGBColorSpace` to `LinearSRGBColorSpace`.
   *
   * @param {Color} color - The color to copy/convert.
   * @return {Color} A reference to this color.
   */
  copySRGBToLinear(t) {
    return this.r = WO(t.r), this.g = WO(t.g), this.b = WO(t.b), this;
  }
  /**
   * Copies the given color into this color, and then converts this color from
   * `LinearSRGBColorSpace` to `SRGBColorSpace`.
   *
   * @param {Color} color - The color to copy/convert.
   * @return {Color} A reference to this color.
   */
  copyLinearToSRGB(t) {
    return this.r = Nz(t.r), this.g = Nz(t.g), this.b = Nz(t.b), this;
  }
  /**
   * Converts this color from `SRGBColorSpace` to `LinearSRGBColorSpace`.
   *
   * @return {Color} A reference to this color.
   */
  convertSRGBToLinear() {
    return this.copySRGBToLinear(this), this;
  }
  /**
   * Converts this color from `LinearSRGBColorSpace` to `SRGBColorSpace`.
   *
   * @return {Color} A reference to this color.
   */
  convertLinearToSRGB() {
    return this.copyLinearToSRGB(this), this;
  }
  /**
   * Returns the hexadecimal value of this color.
   *
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {number} The hexadecimal value.
   */
  getHex(t = Hy) {
    return Qr.workingToColorSpace(Om.copy(this), t), Math.round(Ho(Om.r * 255, 0, 255)) * 65536 + Math.round(Ho(Om.g * 255, 0, 255)) * 256 + Math.round(Ho(Om.b * 255, 0, 255));
  }
  /**
   * Returns the hexadecimal value of this color as a string (for example, 'FFFFFF').
   *
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {string} The hexadecimal value as a string.
   */
  getHexString(t = Hy) {
    return ("000000" + this.getHex(t).toString(16)).slice(-6);
  }
  /**
   * Converts the colors RGB values into the HSL format and stores them into the
   * given target object.
   *
   * @param {{h:number,s:number,l:number}} target - The target object that is used to store the method's result.
   * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
   * @return {{h:number,s:number,l:number}} The HSL representation of this color.
   */
  getHSL(t, i = Qr.workingColorSpace) {
    Qr.workingToColorSpace(Om.copy(this), i);
    const n = Om.r, s = Om.g, o = Om.b, r = Math.max(n, s, o), l = Math.min(n, s, o);
    let c, h;
    const I = (l + r) / 2;
    if (l === r)
      c = 0, h = 0;
    else {
      const p = r - l;
      switch (h = I <= 0.5 ? p / (r + l) : p / (2 - r - l), r) {
        case n:
          c = (s - o) / p + (s < o ? 6 : 0);
          break;
        case s:
          c = (o - n) / p + 2;
          break;
        case o:
          c = (n - s) / p + 4;
          break;
      }
      c /= 6;
    }
    return t.h = c, t.s = h, t.l = I, t;
  }
  /**
   * Returns the RGB values of this color and stores them into the given target object.
   *
   * @param {Color} target - The target color that is used to store the method's result.
   * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
   * @return {Color} The RGB representation of this color.
   */
  getRGB(t, i = Qr.workingColorSpace) {
    return Qr.workingToColorSpace(Om.copy(this), i), t.r = Om.r, t.g = Om.g, t.b = Om.b, t;
  }
  /**
   * Returns the value of this color as a CSS style string. Example: `rgb(255,0,0)`.
   *
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {string} The CSS representation of this color.
   */
  getStyle(t = Hy) {
    Qr.workingToColorSpace(Om.copy(this), t);
    const i = Om.r, n = Om.g, s = Om.b;
    return t !== Hy ? `color(${t} ${i.toFixed(3)} ${n.toFixed(3)} ${s.toFixed(3)})` : `rgb(${Math.round(i * 255)},${Math.round(n * 255)},${Math.round(s * 255)})`;
  }
  /**
   * Adds the given HSL values to this color's values.
   * Internally, this converts the color's RGB values to HSL, adds HSL
   * and then converts the color back to RGB.
   *
   * @param {number} h - Hue value between `0.0` and `1.0`.
   * @param {number} s - Saturation value between `0.0` and `1.0`.
   * @param {number} l - Lightness value between `0.0` and `1.0`.
   * @return {Color} A reference to this color.
   */
  offsetHSL(t, i, n) {
    return this.getHSL(f_), this.setHSL(f_.h + t, f_.s + i, f_.l + n);
  }
  /**
   * Adds the RGB values of the given color to the RGB values of this color.
   *
   * @param {Color} color - The color to add.
   * @return {Color} A reference to this color.
   */
  add(t) {
    return this.r += t.r, this.g += t.g, this.b += t.b, this;
  }
  /**
   * Adds the RGB values of the given colors and stores the result in this instance.
   *
   * @param {Color} color1 - The first color.
   * @param {Color} color2 - The second color.
   * @return {Color} A reference to this color.
   */
  addColors(t, i) {
    return this.r = t.r + i.r, this.g = t.g + i.g, this.b = t.b + i.b, this;
  }
  /**
   * Adds the given scalar value to the RGB values of this color.
   *
   * @param {number} s - The scalar to add.
   * @return {Color} A reference to this color.
   */
  addScalar(t) {
    return this.r += t, this.g += t, this.b += t, this;
  }
  /**
   * Subtracts the RGB values of the given color from the RGB values of this color.
   *
   * @param {Color} color - The color to subtract.
   * @return {Color} A reference to this color.
   */
  sub(t) {
    return this.r = Math.max(0, this.r - t.r), this.g = Math.max(0, this.g - t.g), this.b = Math.max(0, this.b - t.b), this;
  }
  /**
   * Multiplies the RGB values of the given color with the RGB values of this color.
   *
   * @param {Color} color - The color to multiply.
   * @return {Color} A reference to this color.
   */
  multiply(t) {
    return this.r *= t.r, this.g *= t.g, this.b *= t.b, this;
  }
  /**
   * Multiplies the given scalar value with the RGB values of this color.
   *
   * @param {number} s - The scalar to multiply.
   * @return {Color} A reference to this color.
   */
  multiplyScalar(t) {
    return this.r *= t, this.g *= t, this.b *= t, this;
  }
  /**
   * Linearly interpolates this color's RGB values toward the RGB values of the
   * given color. The alpha argument can be thought of as the ratio between
   * the two colors, where `0.0` is this color and `1.0` is the first argument.
   *
   * @param {Color} color - The color to converge on.
   * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
   * @return {Color} A reference to this color.
   */
  lerp(t, i) {
    return this.r += (t.r - this.r) * i, this.g += (t.g - this.g) * i, this.b += (t.b - this.b) * i, this;
  }
  /**
   * Linearly interpolates between the given colors and stores the result in this instance.
   * The alpha argument can be thought of as the ratio between the two colors, where `0.0`
   * is the first and `1.0` is the second color.
   *
   * @param {Color} color1 - The first color.
   * @param {Color} color2 - The second color.
   * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
   * @return {Color} A reference to this color.
   */
  lerpColors(t, i, n) {
    return this.r = t.r + (i.r - t.r) * n, this.g = t.g + (i.g - t.g) * n, this.b = t.b + (i.b - t.b) * n, this;
  }
  /**
   * Linearly interpolates this color's HSL values toward the HSL values of the
   * given color. It differs from {@link Color#lerp} by not interpolating straight
   * from one color to the other, but instead going through all the hues in between
   * those two colors. The alpha argument can be thought of as the ratio between
   * the two colors, where 0.0 is this color and 1.0 is the first argument.
   *
   * @param {Color} color - The color to converge on.
   * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
   * @return {Color} A reference to this color.
   */
  lerpHSL(t, i) {
    this.getHSL(f_), t.getHSL(_ne);
    const n = AJ(f_.h, _ne.h, i), s = AJ(f_.s, _ne.s, i), o = AJ(f_.l, _ne.l, i);
    return this.setHSL(n, s, o), this;
  }
  /**
   * Sets the color's RGB components from the given 3D vector.
   *
   * @param {Vector3} v - The vector to set.
   * @return {Color} A reference to this color.
   */
  setFromVector3(t) {
    return this.r = t.x, this.g = t.y, this.b = t.z, this;
  }
  /**
   * Transforms this color with the given 3x3 matrix.
   *
   * @param {Matrix3} m - The matrix.
   * @return {Color} A reference to this color.
   */
  applyMatrix3(t) {
    const i = this.r, n = this.g, s = this.b, o = t.elements;
    return this.r = o[0] * i + o[3] * n + o[6] * s, this.g = o[1] * i + o[4] * n + o[7] * s, this.b = o[2] * i + o[5] * n + o[8] * s, this;
  }
  /**
   * Returns `true` if this color is equal with the given one.
   *
   * @param {Color} c - The color to test for equality.
   * @return {boolean} Whether this bounding color is equal with the given one.
   */
  equals(t) {
    return t.r === this.r && t.g === this.g && t.b === this.b;
  }
  /**
   * Sets this color's RGB components from the given array.
   *
   * @param {Array<number>} array - An array holding the RGB values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Color} A reference to this color.
   */
  fromArray(t, i = 0) {
    return this.r = t[i], this.g = t[i + 1], this.b = t[i + 2], this;
  }
  /**
   * Writes the RGB components of this color to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the color components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The color components.
   */
  toArray(t = [], i = 0) {
    return t[i] = this.r, t[i + 1] = this.g, t[i + 2] = this.b, t;
  }
  /**
   * Sets the components of this color from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding color data.
   * @param {number} index - The index into the attribute.
   * @return {Color} A reference to this color.
   */
  fromBufferAttribute(t, i) {
    return this.r = t.getX(i), this.g = t.getY(i), this.b = t.getZ(i), this;
  }
  /**
   * This methods defines the serialization result of this class. Returns the color
   * as a hexadecimal value.
   *
   * @return {number} The hexadecimal value.
   */
  toJSON() {
    return this.getHex();
  }
  *[Symbol.iterator]() {
    yield this.r, yield this.g, yield this.b;
  }
}
const Om = /* @__PURE__ */ new Xn();
Xn.NAMES = yAe;
let eUe = 0;
class _H extends LH {
  /**
   * Constructs a new material.
   */
  constructor() {
    super(), this.isMaterial = !0, Object.defineProperty(this, "id", { value: eUe++ }), this.uuid = jO(), this.name = "", this.type = "Material", this.blending = Sz, this.side = xA, this.vertexColors = !1, this.opacity = 1, this.transparent = !1, this.alphaHash = !1, this.blendSrc = o1e, this.blendDst = r1e, this.blendEquation = YU, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.blendColor = new Xn(0, 0, 0), this.blendAlpha = 0, this.depthFunc = DW, this.depthTest = !0, this.depthWrite = !0, this.stencilWriteMask = 255, this.stencilFunc = VEe, this.stencilRef = 0, this.stencilFuncMask = 255, this.stencilFail = Uk, this.stencilZFail = Uk, this.stencilZPass = Uk, this.stencilWrite = !1, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.shadowSide = null, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaToCoverage = !1, this.premultipliedAlpha = !1, this.forceSinglePass = !1, this.allowOverride = !0, this.visible = !0, this.toneMapped = !0, this.userData = {}, this.version = 0, this._alphaTest = 0;
  }
  /**
   * Sets the alpha value to be used when running an alpha test. The material
   * will not be rendered if the opacity is lower than this value.
   *
   * @type {number}
   * @readonly
   * @default 0
   */
  get alphaTest() {
    return this._alphaTest;
  }
  set alphaTest(t) {
    this._alphaTest > 0 != t > 0 && this.version++, this._alphaTest = t;
  }
  /**
   * An optional callback that is executed immediately before the material is used to render a 3D object.
   *
   * This method can only be used when rendering with {@link WebGLRenderer}.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Scene} scene - The scene.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Object3D} object - The 3D object.
   * @param {Object} group - The geometry group data.
   */
  onBeforeRender() {
  }
  /**
   * An optional callback that is executed immediately before the shader
   * program is compiled. This function is called with the shader source code
   * as a parameter. Useful for the modification of built-in materials.
   *
   * This method can only be used when rendering with {@link WebGLRenderer}. The
   * recommended approach when customizing materials is to use `WebGPURenderer` with the new
   * Node Material system and [TSL]{@link https://github.com/mrdoob/three.js/wiki/Three.js-Shading-Language}.
   *
   * @param {{vertexShader:string,fragmentShader:string,uniforms:Object}} shaderobject - The object holds the uniforms and the vertex and fragment shader source.
   * @param {WebGLRenderer} renderer - A reference to the renderer.
   */
  onBeforeCompile() {
  }
  /**
   * In case {@link Material#onBeforeCompile} is used, this callback can be used to identify
   * values of settings used in `onBeforeCompile()`, so three.js can reuse a cached
   * shader or recompile the shader for this material as needed.
   *
   * This method can only be used when rendering with {@link WebGLRenderer}.
   *
   * @return {string} The custom program cache key.
   */
  customProgramCacheKey() {
    return this.onBeforeCompile.toString();
  }
  /**
   * This method can be used to set default values from parameter objects.
   * It is a generic implementation so it can be used with different types
   * of materials.
   *
   * @param {Object} [values] - The material values to set.
   */
  setValues(t) {
    if (t !== void 0)
      for (const i in t) {
        const n = t[i];
        if (n === void 0) {
          console.warn(`THREE.Material: parameter '${i}' has value of undefined.`);
          continue;
        }
        const s = this[i];
        if (s === void 0) {
          console.warn(`THREE.Material: '${i}' is not a property of THREE.${this.type}.`);
          continue;
        }
        s && s.isColor ? s.set(n) : s && s.isVector3 && n && n.isVector3 ? s.copy(n) : this[i] = n;
      }
  }
  /**
   * Serializes the material into JSON.
   *
   * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized material.
   * @see {@link ObjectLoader#parse}
   */
  toJSON(t) {
    const i = t === void 0 || typeof t == "string";
    i && (t = {
      textures: {},
      images: {}
    });
    const n = {
      metadata: {
        version: 4.7,
        type: "Material",
        generator: "Material.toJSON"
      }
    };
    n.uuid = this.uuid, n.type = this.type, this.name !== "" && (n.name = this.name), this.color && this.color.isColor && (n.color = this.color.getHex()), this.roughness !== void 0 && (n.roughness = this.roughness), this.metalness !== void 0 && (n.metalness = this.metalness), this.sheen !== void 0 && (n.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (n.sheenColor = this.sheenColor.getHex()), this.sheenRoughness !== void 0 && (n.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (n.emissive = this.emissive.getHex()), this.emissiveIntensity !== void 0 && this.emissiveIntensity !== 1 && (n.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (n.specular = this.specular.getHex()), this.specularIntensity !== void 0 && (n.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (n.specularColor = this.specularColor.getHex()), this.shininess !== void 0 && (n.shininess = this.shininess), this.clearcoat !== void 0 && (n.clearcoat = this.clearcoat), this.clearcoatRoughness !== void 0 && (n.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (n.clearcoatMap = this.clearcoatMap.toJSON(t).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (n.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(t).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (n.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(t).uuid, n.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), this.dispersion !== void 0 && (n.dispersion = this.dispersion), this.iridescence !== void 0 && (n.iridescence = this.iridescence), this.iridescenceIOR !== void 0 && (n.iridescenceIOR = this.iridescenceIOR), this.iridescenceThicknessRange !== void 0 && (n.iridescenceThicknessRange = this.iridescenceThicknessRange), this.iridescenceMap && this.iridescenceMap.isTexture && (n.iridescenceMap = this.iridescenceMap.toJSON(t).uuid), this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture && (n.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(t).uuid), this.anisotropy !== void 0 && (n.anisotropy = this.anisotropy), this.anisotropyRotation !== void 0 && (n.anisotropyRotation = this.anisotropyRotation), this.anisotropyMap && this.anisotropyMap.isTexture && (n.anisotropyMap = this.anisotropyMap.toJSON(t).uuid), this.map && this.map.isTexture && (n.map = this.map.toJSON(t).uuid), this.matcap && this.matcap.isTexture && (n.matcap = this.matcap.toJSON(t).uuid), this.alphaMap && this.alphaMap.isTexture && (n.alphaMap = this.alphaMap.toJSON(t).uuid), this.lightMap && this.lightMap.isTexture && (n.lightMap = this.lightMap.toJSON(t).uuid, n.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (n.aoMap = this.aoMap.toJSON(t).uuid, n.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (n.bumpMap = this.bumpMap.toJSON(t).uuid, n.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (n.normalMap = this.normalMap.toJSON(t).uuid, n.normalMapType = this.normalMapType, n.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (n.displacementMap = this.displacementMap.toJSON(t).uuid, n.displacementScale = this.displacementScale, n.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (n.roughnessMap = this.roughnessMap.toJSON(t).uuid), this.metalnessMap && this.metalnessMap.isTexture && (n.metalnessMap = this.metalnessMap.toJSON(t).uuid), this.emissiveMap && this.emissiveMap.isTexture && (n.emissiveMap = this.emissiveMap.toJSON(t).uuid), this.specularMap && this.specularMap.isTexture && (n.specularMap = this.specularMap.toJSON(t).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (n.specularIntensityMap = this.specularIntensityMap.toJSON(t).uuid), this.specularColorMap && this.specularColorMap.isTexture && (n.specularColorMap = this.specularColorMap.toJSON(t).uuid), this.envMap && this.envMap.isTexture && (n.envMap = this.envMap.toJSON(t).uuid, this.combine !== void 0 && (n.combine = this.combine)), this.envMapRotation !== void 0 && (n.envMapRotation = this.envMapRotation.toArray()), this.envMapIntensity !== void 0 && (n.envMapIntensity = this.envMapIntensity), this.reflectivity !== void 0 && (n.reflectivity = this.reflectivity), this.refractionRatio !== void 0 && (n.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (n.gradientMap = this.gradientMap.toJSON(t).uuid), this.transmission !== void 0 && (n.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (n.transmissionMap = this.transmissionMap.toJSON(t).uuid), this.thickness !== void 0 && (n.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (n.thicknessMap = this.thicknessMap.toJSON(t).uuid), this.attenuationDistance !== void 0 && this.attenuationDistance !== 1 / 0 && (n.attenuationDistance = this.attenuationDistance), this.attenuationColor !== void 0 && (n.attenuationColor = this.attenuationColor.getHex()), this.size !== void 0 && (n.size = this.size), this.shadowSide !== null && (n.shadowSide = this.shadowSide), this.sizeAttenuation !== void 0 && (n.sizeAttenuation = this.sizeAttenuation), this.blending !== Sz && (n.blending = this.blending), this.side !== xA && (n.side = this.side), this.vertexColors === !0 && (n.vertexColors = !0), this.opacity < 1 && (n.opacity = this.opacity), this.transparent === !0 && (n.transparent = !0), this.blendSrc !== o1e && (n.blendSrc = this.blendSrc), this.blendDst !== r1e && (n.blendDst = this.blendDst), this.blendEquation !== YU && (n.blendEquation = this.blendEquation), this.blendSrcAlpha !== null && (n.blendSrcAlpha = this.blendSrcAlpha), this.blendDstAlpha !== null && (n.blendDstAlpha = this.blendDstAlpha), this.blendEquationAlpha !== null && (n.blendEquationAlpha = this.blendEquationAlpha), this.blendColor && this.blendColor.isColor && (n.blendColor = this.blendColor.getHex()), this.blendAlpha !== 0 && (n.blendAlpha = this.blendAlpha), this.depthFunc !== DW && (n.depthFunc = this.depthFunc), this.depthTest === !1 && (n.depthTest = this.depthTest), this.depthWrite === !1 && (n.depthWrite = this.depthWrite), this.colorWrite === !1 && (n.colorWrite = this.colorWrite), this.stencilWriteMask !== 255 && (n.stencilWriteMask = this.stencilWriteMask), this.stencilFunc !== VEe && (n.stencilFunc = this.stencilFunc), this.stencilRef !== 0 && (n.stencilRef = this.stencilRef), this.stencilFuncMask !== 255 && (n.stencilFuncMask = this.stencilFuncMask), this.stencilFail !== Uk && (n.stencilFail = this.stencilFail), this.stencilZFail !== Uk && (n.stencilZFail = this.stencilZFail), this.stencilZPass !== Uk && (n.stencilZPass = this.stencilZPass), this.stencilWrite === !0 && (n.stencilWrite = this.stencilWrite), this.rotation !== void 0 && this.rotation !== 0 && (n.rotation = this.rotation), this.polygonOffset === !0 && (n.polygonOffset = !0), this.polygonOffsetFactor !== 0 && (n.polygonOffsetFactor = this.polygonOffsetFactor), this.polygonOffsetUnits !== 0 && (n.polygonOffsetUnits = this.polygonOffsetUnits), this.linewidth !== void 0 && this.linewidth !== 1 && (n.linewidth = this.linewidth), this.dashSize !== void 0 && (n.dashSize = this.dashSize), this.gapSize !== void 0 && (n.gapSize = this.gapSize), this.scale !== void 0 && (n.scale = this.scale), this.dithering === !0 && (n.dithering = !0), this.alphaTest > 0 && (n.alphaTest = this.alphaTest), this.alphaHash === !0 && (n.alphaHash = !0), this.alphaToCoverage === !0 && (n.alphaToCoverage = !0), this.premultipliedAlpha === !0 && (n.premultipliedAlpha = !0), this.forceSinglePass === !0 && (n.forceSinglePass = !0), this.wireframe === !0 && (n.wireframe = !0), this.wireframeLinewidth > 1 && (n.wireframeLinewidth = this.wireframeLinewidth), this.wireframeLinecap !== "round" && (n.wireframeLinecap = this.wireframeLinecap), this.wireframeLinejoin !== "round" && (n.wireframeLinejoin = this.wireframeLinejoin), this.flatShading === !0 && (n.flatShading = !0), this.visible === !1 && (n.visible = !1), this.toneMapped === !1 && (n.toneMapped = !1), this.fog === !1 && (n.fog = !1), Object.keys(this.userData).length > 0 && (n.userData = this.userData);
    function s(o) {
      const r = [];
      for (const l in o) {
        const c = o[l];
        delete c.metadata, r.push(c);
      }
      return r;
    }
    if (i) {
      const o = s(t.textures), r = s(t.images);
      o.length > 0 && (n.textures = o), r.length > 0 && (n.images = r);
    }
    return n;
  }
  /**
   * Returns a new material with copied values from this instance.
   *
   * @return {Material} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the values of the given material to this instance.
   *
   * @param {Material} source - The material to copy.
   * @return {Material} A reference to this instance.
   */
  copy(t) {
    this.name = t.name, this.blending = t.blending, this.side = t.side, this.vertexColors = t.vertexColors, this.opacity = t.opacity, this.transparent = t.transparent, this.blendSrc = t.blendSrc, this.blendDst = t.blendDst, this.blendEquation = t.blendEquation, this.blendSrcAlpha = t.blendSrcAlpha, this.blendDstAlpha = t.blendDstAlpha, this.blendEquationAlpha = t.blendEquationAlpha, this.blendColor.copy(t.blendColor), this.blendAlpha = t.blendAlpha, this.depthFunc = t.depthFunc, this.depthTest = t.depthTest, this.depthWrite = t.depthWrite, this.stencilWriteMask = t.stencilWriteMask, this.stencilFunc = t.stencilFunc, this.stencilRef = t.stencilRef, this.stencilFuncMask = t.stencilFuncMask, this.stencilFail = t.stencilFail, this.stencilZFail = t.stencilZFail, this.stencilZPass = t.stencilZPass, this.stencilWrite = t.stencilWrite;
    const i = t.clippingPlanes;
    let n = null;
    if (i !== null) {
      const s = i.length;
      n = new Array(s);
      for (let o = 0; o !== s; ++o)
        n[o] = i[o].clone();
    }
    return this.clippingPlanes = n, this.clipIntersection = t.clipIntersection, this.clipShadows = t.clipShadows, this.shadowSide = t.shadowSide, this.colorWrite = t.colorWrite, this.precision = t.precision, this.polygonOffset = t.polygonOffset, this.polygonOffsetFactor = t.polygonOffsetFactor, this.polygonOffsetUnits = t.polygonOffsetUnits, this.dithering = t.dithering, this.alphaTest = t.alphaTest, this.alphaHash = t.alphaHash, this.alphaToCoverage = t.alphaToCoverage, this.premultipliedAlpha = t.premultipliedAlpha, this.forceSinglePass = t.forceSinglePass, this.visible = t.visible, this.toneMapped = t.toneMapped, this.userData = JSON.parse(JSON.stringify(t.userData)), this;
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   *
   * @fires Material#dispose
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  /**
   * Setting this property to `true` indicates the engine the material
   * needs to be recompiled.
   *
   * @type {boolean}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(t) {
    t === !0 && this.version++;
  }
}
class U8 extends _H {
  /**
   * Constructs a new mesh basic material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(t) {
    super(), this.isMeshBasicMaterial = !0, this.type = "MeshBasicMaterial", this.color = new Xn(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.envMapRotation = new UA(), this.combine = Gpe, this.reflectivity = 1, this.refractionRatio = 0.98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(t);
  }
  copy(t) {
    return super.copy(t), this.color.copy(t.color), this.map = t.map, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.specularMap = t.specularMap, this.alphaMap = t.alphaMap, this.envMap = t.envMap, this.envMapRotation.copy(t.envMapRotation), this.combine = t.combine, this.reflectivity = t.reflectivity, this.refractionRatio = t.refractionRatio, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this.fog = t.fog, this;
  }
}
const C0 = /* @__PURE__ */ new Ge(), xne = /* @__PURE__ */ new us();
let tUe = 0;
class zu {
  /**
   * Constructs a new buffer attribute.
   *
   * @param {TypedArray} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */
  constructor(t, i, n = !1) {
    if (Array.isArray(t))
      throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
    this.isBufferAttribute = !0, Object.defineProperty(this, "id", { value: tUe++ }), this.name = "", this.array = t, this.itemSize = i, this.count = t !== void 0 ? t.length / i : 0, this.normalized = n, this.usage = j1e, this.updateRanges = [], this.gpuType = cN, this.version = 0;
  }
  /**
   * A callback function that is executed after the renderer has transferred the attribute
   * array data to the GPU.
   */
  onUploadCallback() {
  }
  /**
   * Flag to indicate that this attribute has changed and should be re-sent to
   * the GPU. Set this to `true` when you modify the value of the array.
   *
   * @type {number}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(t) {
    t === !0 && this.version++;
  }
  /**
   * Sets the usage of this buffer attribute.
   *
   * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
   * @return {BufferAttribute} A reference to this buffer attribute.
   */
  setUsage(t) {
    return this.usage = t, this;
  }
  /**
   * Adds a range of data in the data array to be updated on the GPU.
   *
   * @param {number} start - Position at which to start update.
   * @param {number} count - The number of components to update.
   */
  addUpdateRange(t, i) {
    this.updateRanges.push({ start: t, count: i });
  }
  /**
   * Clears the update ranges.
   */
  clearUpdateRanges() {
    this.updateRanges.length = 0;
  }
  /**
   * Copies the values of the given buffer attribute to this instance.
   *
   * @param {BufferAttribute} source - The buffer attribute to copy.
   * @return {BufferAttribute} A reference to this instance.
   */
  copy(t) {
    return this.name = t.name, this.array = new t.array.constructor(t.array), this.itemSize = t.itemSize, this.count = t.count, this.normalized = t.normalized, this.usage = t.usage, this.gpuType = t.gpuType, this;
  }
  /**
   * Copies a vector from the given buffer attribute to this one. The start
   * and destination position in the attribute buffers are represented by the
   * given indices.
   *
   * @param {number} index1 - The destination index into this buffer attribute.
   * @param {BufferAttribute} attribute - The buffer attribute to copy from.
   * @param {number} index2 - The source index into the given buffer attribute.
   * @return {BufferAttribute} A reference to this instance.
   */
  copyAt(t, i, n) {
    t *= this.itemSize, n *= i.itemSize;
    for (let s = 0, o = this.itemSize; s < o; s++)
      this.array[t + s] = i.array[n + s];
    return this;
  }
  /**
   * Copies the given array data into this buffer attribute.
   *
   * @param {(TypedArray|Array)} array - The array to copy.
   * @return {BufferAttribute} A reference to this instance.
   */
  copyArray(t) {
    return this.array.set(t), this;
  }
  /**
   * Applies the given 3x3 matrix to the given attribute. Works with
   * item size `2` and `3`.
   *
   * @param {Matrix3} m - The matrix to apply.
   * @return {BufferAttribute} A reference to this instance.
   */
  applyMatrix3(t) {
    if (this.itemSize === 2)
      for (let i = 0, n = this.count; i < n; i++)
        xne.fromBufferAttribute(this, i), xne.applyMatrix3(t), this.setXY(i, xne.x, xne.y);
    else if (this.itemSize === 3)
      for (let i = 0, n = this.count; i < n; i++)
        C0.fromBufferAttribute(this, i), C0.applyMatrix3(t), this.setXYZ(i, C0.x, C0.y, C0.z);
    return this;
  }
  /**
   * Applies the given 4x4 matrix to the given attribute. Only works with
   * item size `3`.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {BufferAttribute} A reference to this instance.
   */
  applyMatrix4(t) {
    for (let i = 0, n = this.count; i < n; i++)
      C0.fromBufferAttribute(this, i), C0.applyMatrix4(t), this.setXYZ(i, C0.x, C0.y, C0.z);
    return this;
  }
  /**
   * Applies the given 3x3 normal matrix to the given attribute. Only works with
   * item size `3`.
   *
   * @param {Matrix3} m - The normal matrix to apply.
   * @return {BufferAttribute} A reference to this instance.
   */
  applyNormalMatrix(t) {
    for (let i = 0, n = this.count; i < n; i++)
      C0.fromBufferAttribute(this, i), C0.applyNormalMatrix(t), this.setXYZ(i, C0.x, C0.y, C0.z);
    return this;
  }
  /**
   * Applies the given 4x4 matrix to the given attribute. Only works with
   * item size `3` and with direction vectors.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {BufferAttribute} A reference to this instance.
   */
  transformDirection(t) {
    for (let i = 0, n = this.count; i < n; i++)
      C0.fromBufferAttribute(this, i), C0.transformDirection(t), this.setXYZ(i, C0.x, C0.y, C0.z);
    return this;
  }
  /**
   * Sets the given array data in the buffer attribute.
   *
   * @param {(TypedArray|Array)} value - The array data to set.
   * @param {number} [offset=0] - The offset in this buffer attribute's array.
   * @return {BufferAttribute} A reference to this instance.
   */
  set(t, i = 0) {
    return this.array.set(t, i), this;
  }
  /**
   * Returns the given component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} component - The component index.
   * @return {number} The returned value.
   */
  getComponent(t, i) {
    let n = this.array[t * this.itemSize + i];
    return this.normalized && (n = Lv(n, this.array)), n;
  }
  /**
   * Sets the given value to the given component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} component - The component index.
   * @param {number} value - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setComponent(t, i, n) {
    return this.normalized && (n = Tl(n, this.array)), this.array[t * this.itemSize + i] = n, this;
  }
  /**
   * Returns the x component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The x component.
   */
  getX(t) {
    let i = this.array[t * this.itemSize];
    return this.normalized && (i = Lv(i, this.array)), i;
  }
  /**
   * Sets the x component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setX(t, i) {
    return this.normalized && (i = Tl(i, this.array)), this.array[t * this.itemSize] = i, this;
  }
  /**
   * Returns the y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The y component.
   */
  getY(t) {
    let i = this.array[t * this.itemSize + 1];
    return this.normalized && (i = Lv(i, this.array)), i;
  }
  /**
   * Sets the y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} y - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setY(t, i) {
    return this.normalized && (i = Tl(i, this.array)), this.array[t * this.itemSize + 1] = i, this;
  }
  /**
   * Returns the z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The z component.
   */
  getZ(t) {
    let i = this.array[t * this.itemSize + 2];
    return this.normalized && (i = Lv(i, this.array)), i;
  }
  /**
   * Sets the z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} z - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setZ(t, i) {
    return this.normalized && (i = Tl(i, this.array)), this.array[t * this.itemSize + 2] = i, this;
  }
  /**
   * Returns the w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The w component.
   */
  getW(t) {
    let i = this.array[t * this.itemSize + 3];
    return this.normalized && (i = Lv(i, this.array)), i;
  }
  /**
   * Sets the w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} w - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setW(t, i) {
    return this.normalized && (i = Tl(i, this.array)), this.array[t * this.itemSize + 3] = i, this;
  }
  /**
   * Sets the x and y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setXY(t, i, n) {
    return t *= this.itemSize, this.normalized && (i = Tl(i, this.array), n = Tl(n, this.array)), this.array[t + 0] = i, this.array[t + 1] = n, this;
  }
  /**
   * Sets the x, y and z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @param {number} z - The value for the z component to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setXYZ(t, i, n, s) {
    return t *= this.itemSize, this.normalized && (i = Tl(i, this.array), n = Tl(n, this.array), s = Tl(s, this.array)), this.array[t + 0] = i, this.array[t + 1] = n, this.array[t + 2] = s, this;
  }
  /**
   * Sets the x, y, z and w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @param {number} z - The value for the z component to set.
   * @param {number} w - The value for the w component to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setXYZW(t, i, n, s, o) {
    return t *= this.itemSize, this.normalized && (i = Tl(i, this.array), n = Tl(n, this.array), s = Tl(s, this.array), o = Tl(o, this.array)), this.array[t + 0] = i, this.array[t + 1] = n, this.array[t + 2] = s, this.array[t + 3] = o, this;
  }
  /**
   * Sets the given callback function that is executed after the Renderer has transferred
   * the attribute array data to the GPU. Can be used to perform clean-up operations after
   * the upload when attribute data are not needed anymore on the CPU side.
   *
   * @param {Function} callback - The `onUpload()` callback.
   * @return {BufferAttribute} A reference to this instance.
   */
  onUpload(t) {
    return this.onUploadCallback = t, this;
  }
  /**
   * Returns a new buffer attribute with copied values from this instance.
   *
   * @return {BufferAttribute} A clone of this instance.
   */
  clone() {
    return new this.constructor(this.array, this.itemSize).copy(this);
  }
  /**
   * Serializes the buffer attribute into JSON.
   *
   * @return {Object} A JSON object representing the serialized buffer attribute.
   */
  toJSON() {
    const t = {
      itemSize: this.itemSize,
      type: this.array.constructor.name,
      array: Array.from(this.array),
      normalized: this.normalized
    };
    return this.name !== "" && (t.name = this.name), this.usage !== j1e && (t.usage = this.usage), t;
  }
}
class iUe extends zu {
  /**
   * Constructs a new buffer attribute.
   *
   * @param {(Array<number>|Uint8Array)} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */
  constructor(t, i, n) {
    super(new Uint8Array(t), i, n);
  }
}
class EAe extends zu {
  /**
   * Constructs a new buffer attribute.
   *
   * @param {(Array<number>|Uint16Array)} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */
  constructor(t, i, n) {
    super(new Uint16Array(t), i, n);
  }
}
class gAe extends zu {
  /**
   * Constructs a new buffer attribute.
   *
   * @param {(Array<number>|Uint32Array)} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */
  constructor(t, i, n) {
    super(new Uint32Array(t), i, n);
  }
}
class al extends zu {
  /**
   * Constructs a new buffer attribute.
   *
   * @param {(Array<number>|Float32Array)} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */
  constructor(t, i, n) {
    super(new Float32Array(t), i, n);
  }
}
let nUe = 0;
const VT = /* @__PURE__ */ new Ln(), Ude = /* @__PURE__ */ new wu(), Yk = /* @__PURE__ */ new Ge(), Jw = /* @__PURE__ */ new Zs(), vZ = /* @__PURE__ */ new Zs(), t1 = /* @__PURE__ */ new Ge();
class Vl extends LH {
  /**
   * Constructs a new geometry.
   */
  constructor() {
    super(), this.isBufferGeometry = !0, Object.defineProperty(this, "id", { value: nUe++ }), this.uuid = jO(), this.name = "", this.type = "BufferGeometry", this.index = null, this.indirect = null, this.attributes = {}, this.morphAttributes = {}, this.morphTargetsRelative = !1, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = { start: 0, count: 1 / 0 }, this.userData = {};
  }
  /**
   * Returns the index of this geometry.
   *
   * @return {?BufferAttribute} The index. Returns `null` if no index is defined.
   */
  getIndex() {
    return this.index;
  }
  /**
   * Sets the given index to this geometry.
   *
   * @param {Array<number>|BufferAttribute} index - The index to set.
   * @return {BufferGeometry} A reference to this instance.
   */
  setIndex(t) {
    return Array.isArray(t) ? this.index = new (pAe(t) ? gAe : EAe)(t, 1) : this.index = t, this;
  }
  /**
   * Sets the given indirect attribute to this geometry.
   *
   * @param {BufferAttribute} indirect - The attribute holding indirect draw calls.
   * @return {BufferGeometry} A reference to this instance.
   */
  setIndirect(t) {
    return this.indirect = t, this;
  }
  /**
   * Returns the indirect attribute of this geometry.
   *
   * @return {?BufferAttribute} The indirect attribute. Returns `null` if no indirect attribute is defined.
   */
  getIndirect() {
    return this.indirect;
  }
  /**
   * Returns the buffer attribute for the given name.
   *
   * @param {string} name - The attribute name.
   * @return {BufferAttribute|InterleavedBufferAttribute|undefined} The buffer attribute.
   * Returns `undefined` if not attribute has been found.
   */
  getAttribute(t) {
    return this.attributes[t];
  }
  /**
   * Sets the given attribute for the given name.
   *
   * @param {string} name - The attribute name.
   * @param {BufferAttribute|InterleavedBufferAttribute} attribute - The attribute to set.
   * @return {BufferGeometry} A reference to this instance.
   */
  setAttribute(t, i) {
    return this.attributes[t] = i, this;
  }
  /**
   * Deletes the attribute for the given name.
   *
   * @param {string} name - The attribute name to delete.
   * @return {BufferGeometry} A reference to this instance.
   */
  deleteAttribute(t) {
    return delete this.attributes[t], this;
  }
  /**
   * Returns `true` if this geometry has an attribute for the given name.
   *
   * @param {string} name - The attribute name.
   * @return {boolean} Whether this geometry has an attribute for the given name or not.
   */
  hasAttribute(t) {
    return this.attributes[t] !== void 0;
  }
  /**
   * Adds a group to this geometry.
   *
   * @param {number} start - The first element in this draw call. That is the first
   * vertex for non-indexed geometry, otherwise the first triangle index.
   * @param {number} count - Specifies how many vertices (or indices) are part of this group.
   * @param {number} [materialIndex=0] - The material array index to use.
   */
  addGroup(t, i, n = 0) {
    this.groups.push({
      start: t,
      count: i,
      materialIndex: n
    });
  }
  /**
   * Clears all groups.
   */
  clearGroups() {
    this.groups = [];
  }
  /**
   * Sets the draw range for this geometry.
   *
   * @param {number} start - The first vertex for non-indexed geometry, otherwise the first triangle index.
   * @param {number} count - For non-indexed BufferGeometry, `count` is the number of vertices to render.
   * For indexed BufferGeometry, `count` is the number of indices to render.
   */
  setDrawRange(t, i) {
    this.drawRange.start = t, this.drawRange.count = i;
  }
  /**
   * Applies the given 4x4 transformation matrix to the geometry.
   *
   * @param {Matrix4} matrix - The matrix to apply.
   * @return {BufferGeometry} A reference to this instance.
   */
  applyMatrix4(t) {
    const i = this.attributes.position;
    i !== void 0 && (i.applyMatrix4(t), i.needsUpdate = !0);
    const n = this.attributes.normal;
    if (n !== void 0) {
      const o = new fo().getNormalMatrix(t);
      n.applyNormalMatrix(o), n.needsUpdate = !0;
    }
    const s = this.attributes.tangent;
    return s !== void 0 && (s.transformDirection(t), s.needsUpdate = !0), this.boundingBox !== null && this.computeBoundingBox(), this.boundingSphere !== null && this.computeBoundingSphere(), this;
  }
  /**
   * Applies the rotation represented by the Quaternion to the geometry.
   *
   * @param {Quaternion} q - The Quaternion to apply.
   * @return {BufferGeometry} A reference to this instance.
   */
  applyQuaternion(t) {
    return VT.makeRotationFromQuaternion(t), this.applyMatrix4(VT), this;
  }
  /**
   * Rotates the geometry about the X axis. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#rotation} for typical
   * real-time mesh rotation.
   *
   * @param {number} angle - The angle in radians.
   * @return {BufferGeometry} A reference to this instance.
   */
  rotateX(t) {
    return VT.makeRotationX(t), this.applyMatrix4(VT), this;
  }
  /**
   * Rotates the geometry about the Y axis. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#rotation} for typical
   * real-time mesh rotation.
   *
   * @param {number} angle - The angle in radians.
   * @return {BufferGeometry} A reference to this instance.
   */
  rotateY(t) {
    return VT.makeRotationY(t), this.applyMatrix4(VT), this;
  }
  /**
   * Rotates the geometry about the Z axis. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#rotation} for typical
   * real-time mesh rotation.
   *
   * @param {number} angle - The angle in radians.
   * @return {BufferGeometry} A reference to this instance.
   */
  rotateZ(t) {
    return VT.makeRotationZ(t), this.applyMatrix4(VT), this;
  }
  /**
   * Translates the geometry. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#position} for typical
   * real-time mesh rotation.
   *
   * @param {number} x - The x offset.
   * @param {number} y - The y offset.
   * @param {number} z - The z offset.
   * @return {BufferGeometry} A reference to this instance.
   */
  translate(t, i, n) {
    return VT.makeTranslation(t, i, n), this.applyMatrix4(VT), this;
  }
  /**
   * Scales the geometry. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#scale} for typical
   * real-time mesh rotation.
   *
   * @param {number} x - The x scale.
   * @param {number} y - The y scale.
   * @param {number} z - The z scale.
   * @return {BufferGeometry} A reference to this instance.
   */
  scale(t, i, n) {
    return VT.makeScale(t, i, n), this.applyMatrix4(VT), this;
  }
  /**
   * Rotates the geometry to face a point in 3D space. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#lookAt} for typical
   * real-time mesh rotation.
   *
   * @param {Vector3} vector - The target point.
   * @return {BufferGeometry} A reference to this instance.
   */
  lookAt(t) {
    return Ude.lookAt(t), Ude.updateMatrix(), this.applyMatrix4(Ude.matrix), this;
  }
  /**
   * Center the geometry based on its bounding box.
   *
   * @return {BufferGeometry} A reference to this instance.
   */
  center() {
    return this.computeBoundingBox(), this.boundingBox.getCenter(Yk).negate(), this.translate(Yk.x, Yk.y, Yk.z), this;
  }
  /**
   * Defines a geometry by creating a `position` attribute based on the given array of points. The array
   * can hold 2D or 3D vectors. When using two-dimensional data, the `z` coordinate for all vertices is
   * set to `0`.
   *
   * If the method is used with an existing `position` attribute, the vertex data are overwritten with the
   * data from the array. The length of the array must match the vertex count.
   *
   * @param {Array<Vector2>|Array<Vector3>} points - The points.
   * @return {BufferGeometry} A reference to this instance.
   */
  setFromPoints(t) {
    const i = this.getAttribute("position");
    if (i === void 0) {
      const n = [];
      for (let s = 0, o = t.length; s < o; s++) {
        const r = t[s];
        n.push(r.x, r.y, r.z || 0);
      }
      this.setAttribute("position", new al(n, 3));
    } else {
      const n = Math.min(t.length, i.count);
      for (let s = 0; s < n; s++) {
        const o = t[s];
        i.setXYZ(s, o.x, o.y, o.z || 0);
      }
      t.length > i.count && console.warn("THREE.BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry."), i.needsUpdate = !0;
    }
    return this;
  }
  /**
   * Computes the bounding box of the geometry, and updates the `boundingBox` member.
   * The bounding box is not computed by the engine; it must be computed by your app.
   * You may need to recompute the bounding box if the geometry vertices are modified.
   */
  computeBoundingBox() {
    this.boundingBox === null && (this.boundingBox = new Zs());
    const t = this.attributes.position, i = this.morphAttributes.position;
    if (t && t.isGLBufferAttribute) {
      console.error("THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.", this), this.boundingBox.set(
        new Ge(-1 / 0, -1 / 0, -1 / 0),
        new Ge(1 / 0, 1 / 0, 1 / 0)
      );
      return;
    }
    if (t !== void 0) {
      if (this.boundingBox.setFromBufferAttribute(t), i)
        for (let n = 0, s = i.length; n < s; n++) {
          const o = i[n];
          Jw.setFromBufferAttribute(o), this.morphTargetsRelative ? (t1.addVectors(this.boundingBox.min, Jw.min), this.boundingBox.expandByPoint(t1), t1.addVectors(this.boundingBox.max, Jw.max), this.boundingBox.expandByPoint(t1)) : (this.boundingBox.expandByPoint(Jw.min), this.boundingBox.expandByPoint(Jw.max));
        }
    } else
      this.boundingBox.makeEmpty();
    (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
  }
  /**
   * Computes the bounding sphere of the geometry, and updates the `boundingSphere` member.
   * The engine automatically computes the bounding sphere when it is needed, e.g., for ray casting or view frustum culling.
   * You may need to recompute the bounding sphere if the geometry vertices are modified.
   */
  computeBoundingSphere() {
    this.boundingSphere === null && (this.boundingSphere = new f3());
    const t = this.attributes.position, i = this.morphAttributes.position;
    if (t && t.isGLBufferAttribute) {
      console.error("THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.", this), this.boundingSphere.set(new Ge(), 1 / 0);
      return;
    }
    if (t) {
      const n = this.boundingSphere.center;
      if (Jw.setFromBufferAttribute(t), i)
        for (let o = 0, r = i.length; o < r; o++) {
          const l = i[o];
          vZ.setFromBufferAttribute(l), this.morphTargetsRelative ? (t1.addVectors(Jw.min, vZ.min), Jw.expandByPoint(t1), t1.addVectors(Jw.max, vZ.max), Jw.expandByPoint(t1)) : (Jw.expandByPoint(vZ.min), Jw.expandByPoint(vZ.max));
        }
      Jw.getCenter(n);
      let s = 0;
      for (let o = 0, r = t.count; o < r; o++)
        t1.fromBufferAttribute(t, o), s = Math.max(s, n.distanceToSquared(t1));
      if (i)
        for (let o = 0, r = i.length; o < r; o++) {
          const l = i[o], c = this.morphTargetsRelative;
          for (let h = 0, I = l.count; h < I; h++)
            t1.fromBufferAttribute(l, h), c && (Yk.fromBufferAttribute(t, h), t1.add(Yk)), s = Math.max(s, n.distanceToSquared(t1));
        }
      this.boundingSphere.radius = Math.sqrt(s), isNaN(this.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
    }
  }
  /**
   * Calculates and adds a tangent attribute to this geometry.
   *
   * The computation is only supported for indexed geometries and if position, normal, and uv attributes
   * are defined. When using a tangent space normal map, prefer the MikkTSpace algorithm provided by
   * {@link BufferGeometryUtils#computeMikkTSpaceTangents} instead.
   */
  computeTangents() {
    const t = this.index, i = this.attributes;
    if (t === null || i.position === void 0 || i.normal === void 0 || i.uv === void 0) {
      console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
      return;
    }
    const n = i.position, s = i.normal, o = i.uv;
    this.hasAttribute("tangent") === !1 && this.setAttribute("tangent", new zu(new Float32Array(4 * n.count), 4));
    const r = this.getAttribute("tangent"), l = [], c = [];
    for (let ce = 0; ce < n.count; ce++)
      l[ce] = new Ge(), c[ce] = new Ge();
    const h = new Ge(), I = new Ge(), p = new Ge(), y = new us(), m = new us(), A = new us(), C = new Ge(), O = new Ge();
    function R(ce, te, ee) {
      h.fromBufferAttribute(n, ce), I.fromBufferAttribute(n, te), p.fromBufferAttribute(n, ee), y.fromBufferAttribute(o, ce), m.fromBufferAttribute(o, te), A.fromBufferAttribute(o, ee), I.sub(h), p.sub(h), m.sub(y), A.sub(y);
      const Ne = 1 / (m.x * A.y - A.x * m.y);
      isFinite(Ne) && (C.copy(I).multiplyScalar(A.y).addScaledVector(p, -m.y).multiplyScalar(Ne), O.copy(p).multiplyScalar(m.x).addScaledVector(I, -A.x).multiplyScalar(Ne), l[ce].add(C), l[te].add(C), l[ee].add(C), c[ce].add(O), c[te].add(O), c[ee].add(O));
    }
    let F = this.groups;
    F.length === 0 && (F = [{
      start: 0,
      count: t.count
    }]);
    for (let ce = 0, te = F.length; ce < te; ++ce) {
      const ee = F[ce], Ne = ee.start, Ae = ee.count;
      for (let Oe = Ne, pe = Ne + Ae; Oe < pe; Oe += 3)
        R(
          t.getX(Oe + 0),
          t.getX(Oe + 1),
          t.getX(Oe + 2)
        );
    }
    const L = new Ge(), P = new Ge(), z = new Ge(), W = new Ge();
    function re(ce) {
      z.fromBufferAttribute(s, ce), W.copy(z);
      const te = l[ce];
      L.copy(te), L.sub(z.multiplyScalar(z.dot(te))).normalize(), P.crossVectors(W, te);
      const Ne = P.dot(c[ce]) < 0 ? -1 : 1;
      r.setXYZW(ce, L.x, L.y, L.z, Ne);
    }
    for (let ce = 0, te = F.length; ce < te; ++ce) {
      const ee = F[ce], Ne = ee.start, Ae = ee.count;
      for (let Oe = Ne, pe = Ne + Ae; Oe < pe; Oe += 3)
        re(t.getX(Oe + 0)), re(t.getX(Oe + 1)), re(t.getX(Oe + 2));
    }
  }
  /**
   * Computes vertex normals for the given vertex data. For indexed geometries, the method sets
   * each vertex normal to be the average of the face normals of the faces that share that vertex.
   * For non-indexed geometries, vertices are not shared, and the method sets each vertex normal
   * to be the same as the face normal.
   */
  computeVertexNormals() {
    const t = this.index, i = this.getAttribute("position");
    if (i !== void 0) {
      let n = this.getAttribute("normal");
      if (n === void 0)
        n = new zu(new Float32Array(i.count * 3), 3), this.setAttribute("normal", n);
      else
        for (let y = 0, m = n.count; y < m; y++)
          n.setXYZ(y, 0, 0, 0);
      const s = new Ge(), o = new Ge(), r = new Ge(), l = new Ge(), c = new Ge(), h = new Ge(), I = new Ge(), p = new Ge();
      if (t)
        for (let y = 0, m = t.count; y < m; y += 3) {
          const A = t.getX(y + 0), C = t.getX(y + 1), O = t.getX(y + 2);
          s.fromBufferAttribute(i, A), o.fromBufferAttribute(i, C), r.fromBufferAttribute(i, O), I.subVectors(r, o), p.subVectors(s, o), I.cross(p), l.fromBufferAttribute(n, A), c.fromBufferAttribute(n, C), h.fromBufferAttribute(n, O), l.add(I), c.add(I), h.add(I), n.setXYZ(A, l.x, l.y, l.z), n.setXYZ(C, c.x, c.y, c.z), n.setXYZ(O, h.x, h.y, h.z);
        }
      else
        for (let y = 0, m = i.count; y < m; y += 3)
          s.fromBufferAttribute(i, y + 0), o.fromBufferAttribute(i, y + 1), r.fromBufferAttribute(i, y + 2), I.subVectors(r, o), p.subVectors(s, o), I.cross(p), n.setXYZ(y + 0, I.x, I.y, I.z), n.setXYZ(y + 1, I.x, I.y, I.z), n.setXYZ(y + 2, I.x, I.y, I.z);
      this.normalizeNormals(), n.needsUpdate = !0;
    }
  }
  /**
   * Ensures every normal vector in a geometry will have a magnitude of `1`. This will
   * correct lighting on the geometry surfaces.
   */
  normalizeNormals() {
    const t = this.attributes.normal;
    for (let i = 0, n = t.count; i < n; i++)
      t1.fromBufferAttribute(t, i), t1.normalize(), t.setXYZ(i, t1.x, t1.y, t1.z);
  }
  /**
   * Return a new non-index version of this indexed geometry. If the geometry
   * is already non-indexed, the method is a NOOP.
   *
   * @return {BufferGeometry} The non-indexed version of this indexed geometry.
   */
  toNonIndexed() {
    function t(l, c) {
      const h = l.array, I = l.itemSize, p = l.normalized, y = new h.constructor(c.length * I);
      let m = 0, A = 0;
      for (let C = 0, O = c.length; C < O; C++) {
        l.isInterleavedBufferAttribute ? m = c[C] * l.data.stride + l.offset : m = c[C] * I;
        for (let R = 0; R < I; R++)
          y[A++] = h[m++];
      }
      return new zu(y, I, p);
    }
    if (this.index === null)
      return console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
    const i = new Vl(), n = this.index.array, s = this.attributes;
    for (const l in s) {
      const c = s[l], h = t(c, n);
      i.setAttribute(l, h);
    }
    const o = this.morphAttributes;
    for (const l in o) {
      const c = [], h = o[l];
      for (let I = 0, p = h.length; I < p; I++) {
        const y = h[I], m = t(y, n);
        c.push(m);
      }
      i.morphAttributes[l] = c;
    }
    i.morphTargetsRelative = this.morphTargetsRelative;
    const r = this.groups;
    for (let l = 0, c = r.length; l < c; l++) {
      const h = r[l];
      i.addGroup(h.start, h.count, h.materialIndex);
    }
    return i;
  }
  /**
   * Serializes the geometry into JSON.
   *
   * @return {Object} A JSON object representing the serialized geometry.
   */
  toJSON() {
    const t = {
      metadata: {
        version: 4.7,
        type: "BufferGeometry",
        generator: "BufferGeometry.toJSON"
      }
    };
    if (t.uuid = this.uuid, t.type = this.type, this.name !== "" && (t.name = this.name), Object.keys(this.userData).length > 0 && (t.userData = this.userData), this.parameters !== void 0) {
      const c = this.parameters;
      for (const h in c)
        c[h] !== void 0 && (t[h] = c[h]);
      return t;
    }
    t.data = { attributes: {} };
    const i = this.index;
    i !== null && (t.data.index = {
      type: i.array.constructor.name,
      array: Array.prototype.slice.call(i.array)
    });
    const n = this.attributes;
    for (const c in n) {
      const h = n[c];
      t.data.attributes[c] = h.toJSON(t.data);
    }
    const s = {};
    let o = !1;
    for (const c in this.morphAttributes) {
      const h = this.morphAttributes[c], I = [];
      for (let p = 0, y = h.length; p < y; p++) {
        const m = h[p];
        I.push(m.toJSON(t.data));
      }
      I.length > 0 && (s[c] = I, o = !0);
    }
    o && (t.data.morphAttributes = s, t.data.morphTargetsRelative = this.morphTargetsRelative);
    const r = this.groups;
    r.length > 0 && (t.data.groups = JSON.parse(JSON.stringify(r)));
    const l = this.boundingSphere;
    return l !== null && (t.data.boundingSphere = l.toJSON()), t;
  }
  /**
   * Returns a new geometry with copied values from this instance.
   *
   * @return {BufferGeometry} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the values of the given geometry to this instance.
   *
   * @param {BufferGeometry} source - The geometry to copy.
   * @return {BufferGeometry} A reference to this instance.
   */
  copy(t) {
    this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
    const i = {};
    this.name = t.name;
    const n = t.index;
    n !== null && this.setIndex(n.clone());
    const s = t.attributes;
    for (const h in s) {
      const I = s[h];
      this.setAttribute(h, I.clone(i));
    }
    const o = t.morphAttributes;
    for (const h in o) {
      const I = [], p = o[h];
      for (let y = 0, m = p.length; y < m; y++)
        I.push(p[y].clone(i));
      this.morphAttributes[h] = I;
    }
    this.morphTargetsRelative = t.morphTargetsRelative;
    const r = t.groups;
    for (let h = 0, I = r.length; h < I; h++) {
      const p = r[h];
      this.addGroup(p.start, p.count, p.materialIndex);
    }
    const l = t.boundingBox;
    l !== null && (this.boundingBox = l.clone());
    const c = t.boundingSphere;
    return c !== null && (this.boundingSphere = c.clone()), this.drawRange.start = t.drawRange.start, this.drawRange.count = t.drawRange.count, this.userData = t.userData, this;
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   *
   * @fires BufferGeometry#dispose
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
const nge = /* @__PURE__ */ new Ln(), J9 = /* @__PURE__ */ new MA(), Pne = /* @__PURE__ */ new f3(), sge = /* @__PURE__ */ new Ge(), Mne = /* @__PURE__ */ new Ge(), Une = /* @__PURE__ */ new Ge(), Bne = /* @__PURE__ */ new Ge(), Bde = /* @__PURE__ */ new Ge(), Fne = /* @__PURE__ */ new Ge(), oge = /* @__PURE__ */ new Ge(), Hne = /* @__PURE__ */ new Ge();
class En extends wu {
  /**
   * Constructs a new mesh.
   *
   * @param {BufferGeometry} [geometry] - The mesh geometry.
   * @param {Material|Array<Material>} [material] - The mesh material.
   */
  constructor(t = new Vl(), i = new U8()) {
    super(), this.isMesh = !0, this.type = "Mesh", this.geometry = t, this.material = i, this.morphTargetDictionary = void 0, this.morphTargetInfluences = void 0, this.count = 1, this.updateMorphTargets();
  }
  copy(t, i) {
    return super.copy(t, i), t.morphTargetInfluences !== void 0 && (this.morphTargetInfluences = t.morphTargetInfluences.slice()), t.morphTargetDictionary !== void 0 && (this.morphTargetDictionary = Object.assign({}, t.morphTargetDictionary)), this.material = Array.isArray(t.material) ? t.material.slice() : t.material, this.geometry = t.geometry, this;
  }
  /**
   * Sets the values of {@link Mesh#morphTargetDictionary} and {@link Mesh#morphTargetInfluences}
   * to make sure existing morph targets can influence this 3D object.
   */
  updateMorphTargets() {
    const i = this.geometry.morphAttributes, n = Object.keys(i);
    if (n.length > 0) {
      const s = i[n[0]];
      if (s !== void 0) {
        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
        for (let o = 0, r = s.length; o < r; o++) {
          const l = s[o].name || String(o);
          this.morphTargetInfluences.push(0), this.morphTargetDictionary[l] = o;
        }
      }
    }
  }
  /**
   * Returns the local-space position of the vertex at the given index, taking into
   * account the current animation state of both morph targets and skinning.
   *
   * @param {number} index - The vertex index.
   * @param {Vector3} target - The target object that is used to store the method's result.
   * @return {Vector3} The vertex position in local space.
   */
  getVertexPosition(t, i) {
    const n = this.geometry, s = n.attributes.position, o = n.morphAttributes.position, r = n.morphTargetsRelative;
    i.fromBufferAttribute(s, t);
    const l = this.morphTargetInfluences;
    if (o && l) {
      Fne.set(0, 0, 0);
      for (let c = 0, h = o.length; c < h; c++) {
        const I = l[c], p = o[c];
        I !== 0 && (Bde.fromBufferAttribute(p, t), r ? Fne.addScaledVector(Bde, I) : Fne.addScaledVector(Bde.sub(i), I));
      }
      i.add(Fne);
    }
    return i;
  }
  /**
   * Computes intersection points between a casted ray and this line.
   *
   * @param {Raycaster} raycaster - The raycaster.
   * @param {Array<Object>} intersects - The target array that holds the intersection points.
   */
  raycast(t, i) {
    const n = this.geometry, s = this.material, o = this.matrixWorld;
    s !== void 0 && (n.boundingSphere === null && n.computeBoundingSphere(), Pne.copy(n.boundingSphere), Pne.applyMatrix4(o), J9.copy(t.ray).recast(t.near), !(Pne.containsPoint(J9.origin) === !1 && (J9.intersectSphere(Pne, sge) === null || J9.origin.distanceToSquared(sge) > (t.far - t.near) ** 2)) && (nge.copy(o).invert(), J9.copy(t.ray).applyMatrix4(nge), !(n.boundingBox !== null && J9.intersectsBox(n.boundingBox) === !1) && this._computeIntersections(t, i, J9)));
  }
  _computeIntersections(t, i, n) {
    let s;
    const o = this.geometry, r = this.material, l = o.index, c = o.attributes.position, h = o.attributes.uv, I = o.attributes.uv1, p = o.attributes.normal, y = o.groups, m = o.drawRange;
    if (l !== null)
      if (Array.isArray(r))
        for (let A = 0, C = y.length; A < C; A++) {
          const O = y[A], R = r[O.materialIndex], F = Math.max(O.start, m.start), L = Math.min(l.count, Math.min(O.start + O.count, m.start + m.count));
          for (let P = F, z = L; P < z; P += 3) {
            const W = l.getX(P), re = l.getX(P + 1), ce = l.getX(P + 2);
            s = Gne(this, R, t, n, h, I, p, W, re, ce), s && (s.faceIndex = Math.floor(P / 3), s.face.materialIndex = O.materialIndex, i.push(s));
          }
        }
      else {
        const A = Math.max(0, m.start), C = Math.min(l.count, m.start + m.count);
        for (let O = A, R = C; O < R; O += 3) {
          const F = l.getX(O), L = l.getX(O + 1), P = l.getX(O + 2);
          s = Gne(this, r, t, n, h, I, p, F, L, P), s && (s.faceIndex = Math.floor(O / 3), i.push(s));
        }
      }
    else if (c !== void 0)
      if (Array.isArray(r))
        for (let A = 0, C = y.length; A < C; A++) {
          const O = y[A], R = r[O.materialIndex], F = Math.max(O.start, m.start), L = Math.min(c.count, Math.min(O.start + O.count, m.start + m.count));
          for (let P = F, z = L; P < z; P += 3) {
            const W = P, re = P + 1, ce = P + 2;
            s = Gne(this, R, t, n, h, I, p, W, re, ce), s && (s.faceIndex = Math.floor(P / 3), s.face.materialIndex = O.materialIndex, i.push(s));
          }
        }
      else {
        const A = Math.max(0, m.start), C = Math.min(c.count, m.start + m.count);
        for (let O = A, R = C; O < R; O += 3) {
          const F = O, L = O + 1, P = O + 2;
          s = Gne(this, r, t, n, h, I, p, F, L, P), s && (s.faceIndex = Math.floor(O / 3), i.push(s));
        }
      }
  }
}
function sUe(e, t, i, n, s, o, r, l) {
  let c;
  if (t.side === nE ? c = n.intersectTriangle(r, o, s, !0, l) : c = n.intersectTriangle(s, o, r, t.side === xA, l), c === null) return null;
  Hne.copy(l), Hne.applyMatrix4(e.matrixWorld);
  const h = i.ray.origin.distanceTo(Hne);
  return h < i.near || h > i.far ? null : {
    distance: h,
    point: Hne.clone(),
    object: e
  };
}
function Gne(e, t, i, n, s, o, r, l, c, h) {
  e.getVertexPosition(l, Mne), e.getVertexPosition(c, Une), e.getVertexPosition(h, Bne);
  const I = sUe(e, t, i, n, Mne, Une, Bne, oge);
  if (I) {
    const p = new Ge();
    wc.getBarycoord(oge, Mne, Une, Bne, p), s && (I.uv = wc.getInterpolatedAttribute(s, l, c, h, p, new us())), o && (I.uv1 = wc.getInterpolatedAttribute(o, l, c, h, p, new us())), r && (I.normal = wc.getInterpolatedAttribute(r, l, c, h, p, new Ge()), I.normal.dot(n.direction) > 0 && I.normal.multiplyScalar(-1));
    const y = {
      a: l,
      b: c,
      c: h,
      normal: new Ge(),
      materialIndex: 0
    };
    wc.getNormal(Mne, Une, Bne, y.normal), I.face = y, I.barycoord = p;
  }
  return I;
}
class L0 extends Vl {
  /**
   * Constructs a new box geometry.
   *
   * @param {number} [width=1] - The width. That is, the length of the edges parallel to the X axis.
   * @param {number} [height=1] - The height. That is, the length of the edges parallel to the Y axis.
   * @param {number} [depth=1] - The depth. That is, the length of the edges parallel to the Z axis.
   * @param {number} [widthSegments=1] - Number of segmented rectangular faces along the width of the sides.
   * @param {number} [heightSegments=1] - Number of segmented rectangular faces along the height of the sides.
   * @param {number} [depthSegments=1] - Number of segmented rectangular faces along the depth of the sides.
   */
  constructor(t = 1, i = 1, n = 1, s = 1, o = 1, r = 1) {
    super(), this.type = "BoxGeometry", this.parameters = {
      width: t,
      height: i,
      depth: n,
      widthSegments: s,
      heightSegments: o,
      depthSegments: r
    };
    const l = this;
    s = Math.floor(s), o = Math.floor(o), r = Math.floor(r);
    const c = [], h = [], I = [], p = [];
    let y = 0, m = 0;
    A("z", "y", "x", -1, -1, n, i, t, r, o, 0), A("z", "y", "x", 1, -1, n, i, -t, r, o, 1), A("x", "z", "y", 1, 1, t, n, i, s, r, 2), A("x", "z", "y", 1, -1, t, n, -i, s, r, 3), A("x", "y", "z", 1, -1, t, i, n, s, o, 4), A("x", "y", "z", -1, -1, t, i, -n, s, o, 5), this.setIndex(c), this.setAttribute("position", new al(h, 3)), this.setAttribute("normal", new al(I, 3)), this.setAttribute("uv", new al(p, 2));
    function A(C, O, R, F, L, P, z, W, re, ce, te) {
      const ee = P / re, Ne = z / ce, Ae = P / 2, Oe = z / 2, pe = W / 2, je = re + 1, Ve = ce + 1;
      let $e = 0, vt = 0;
      const Rt = new Ge();
      for (let ze = 0; ze < Ve; ze++) {
        const mt = ze * Ne - Oe;
        for (let Et = 0; Et < je; Et++) {
          const it = Et * ee - Ae;
          Rt[C] = it * F, Rt[O] = mt * L, Rt[R] = pe, h.push(Rt.x, Rt.y, Rt.z), Rt[C] = 0, Rt[O] = 0, Rt[R] = W > 0 ? 1 : -1, I.push(Rt.x, Rt.y, Rt.z), p.push(Et / re), p.push(1 - ze / ce), $e += 1;
        }
      }
      for (let ze = 0; ze < ce; ze++)
        for (let mt = 0; mt < re; mt++) {
          const Et = y + mt + je * ze, it = y + mt + je * (ze + 1), Dt = y + (mt + 1) + je * (ze + 1), Ct = y + (mt + 1) + je * ze;
          c.push(Et, it, Ct), c.push(it, Dt, Ct), vt += 6;
        }
      l.addGroup(m, vt, te), m += vt, y += $e;
    }
  }
  copy(t) {
    return super.copy(t), this.parameters = Object.assign({}, t.parameters), this;
  }
  /**
   * Factory method for creating an instance of this class from the given
   * JSON object.
   *
   * @param {Object} data - A JSON object representing the serialized geometry.
   * @return {BoxGeometry} A new instance.
   */
  static fromJSON(t) {
    return new L0(t.width, t.height, t.depth, t.widthSegments, t.heightSegments, t.depthSegments);
  }
}
function _W(e) {
  const t = {};
  for (const i in e) {
    t[i] = {};
    for (const n in e[i]) {
      const s = e[i][n];
      s && (s.isColor || s.isMatrix3 || s.isMatrix4 || s.isVector2 || s.isVector3 || s.isVector4 || s.isTexture || s.isQuaternion) ? s.isRenderTargetTexture ? (console.warn("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms()."), t[i][n] = null) : t[i][n] = s.clone() : Array.isArray(s) ? t[i][n] = s.slice() : t[i][n] = s;
    }
  }
  return t;
}
function Oy(e) {
  const t = {};
  for (let i = 0; i < e.length; i++) {
    const n = _W(e[i]);
    for (const s in n)
      t[s] = n[s];
  }
  return t;
}
function oUe(e) {
  const t = [];
  for (let i = 0; i < e.length; i++)
    t.push(e[i].clone());
  return t;
}
function wAe(e) {
  const t = e.getRenderTarget();
  return t === null ? e.outputColorSpace : t.isXRRenderTarget === !0 ? t.texture.colorSpace : Qr.workingColorSpace;
}
const vae = { clone: _W, merge: Oy };
var rUe = `void main() {
	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`, lUe = `void main() {
	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );
}`;
class BA extends _H {
  /**
   * Constructs a new shader material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(t) {
    super(), this.isShaderMaterial = !0, this.type = "ShaderMaterial", this.defines = {}, this.uniforms = {}, this.uniformsGroups = [], this.vertexShader = rUe, this.fragmentShader = lUe, this.linewidth = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.clipping = !1, this.forceSinglePass = !0, this.extensions = {
      clipCullDistance: !1,
      // set to use vertex shader clipping
      multiDraw: !1
      // set to use vertex shader multi_draw / enable gl_DrawID
    }, this.defaultAttributeValues = {
      color: [1, 1, 1],
      uv: [0, 0],
      uv1: [0, 0]
    }, this.index0AttributeName = void 0, this.uniformsNeedUpdate = !1, this.glslVersion = null, t !== void 0 && this.setValues(t);
  }
  copy(t) {
    return super.copy(t), this.fragmentShader = t.fragmentShader, this.vertexShader = t.vertexShader, this.uniforms = _W(t.uniforms), this.uniformsGroups = oUe(t.uniformsGroups), this.defines = Object.assign({}, t.defines), this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.fog = t.fog, this.lights = t.lights, this.clipping = t.clipping, this.extensions = Object.assign({}, t.extensions), this.glslVersion = t.glslVersion, this;
  }
  toJSON(t) {
    const i = super.toJSON(t);
    i.glslVersion = this.glslVersion, i.uniforms = {};
    for (const s in this.uniforms) {
      const r = this.uniforms[s].value;
      r && r.isTexture ? i.uniforms[s] = {
        type: "t",
        value: r.toJSON(t).uuid
      } : r && r.isColor ? i.uniforms[s] = {
        type: "c",
        value: r.getHex()
      } : r && r.isVector2 ? i.uniforms[s] = {
        type: "v2",
        value: r.toArray()
      } : r && r.isVector3 ? i.uniforms[s] = {
        type: "v3",
        value: r.toArray()
      } : r && r.isVector4 ? i.uniforms[s] = {
        type: "v4",
        value: r.toArray()
      } : r && r.isMatrix3 ? i.uniforms[s] = {
        type: "m3",
        value: r.toArray()
      } : r && r.isMatrix4 ? i.uniforms[s] = {
        type: "m4",
        value: r.toArray()
      } : i.uniforms[s] = {
        value: r
      };
    }
    Object.keys(this.defines).length > 0 && (i.defines = this.defines), i.vertexShader = this.vertexShader, i.fragmentShader = this.fragmentShader, i.lights = this.lights, i.clipping = this.clipping;
    const n = {};
    for (const s in this.extensions)
      this.extensions[s] === !0 && (n[s] = !0);
    return Object.keys(n).length > 0 && (i.extensions = n), i;
  }
}
class Qpe extends wu {
  /**
   * Constructs a new camera.
   */
  constructor() {
    super(), this.isCamera = !0, this.type = "Camera", this.matrixWorldInverse = new Ln(), this.projectionMatrix = new Ln(), this.projectionMatrixInverse = new Ln(), this.coordinateSystem = hN;
  }
  copy(t, i) {
    return super.copy(t, i), this.matrixWorldInverse.copy(t.matrixWorldInverse), this.projectionMatrix.copy(t.projectionMatrix), this.projectionMatrixInverse.copy(t.projectionMatrixInverse), this.coordinateSystem = t.coordinateSystem, this;
  }
  /**
   * Returns a vector representing the ("look") direction of the 3D object in world space.
   *
   * This method is overwritten since cameras have a different forward vector compared to other
   * 3D objects. A camera looks down its local, negative z-axis by default.
   *
   * @param {Vector3} target - The target vector the result is stored to.
   * @return {Vector3} The 3D object's direction in world space.
   */
  getWorldDirection(t) {
    return super.getWorldDirection(t).negate();
  }
  updateMatrixWorld(t) {
    super.updateMatrixWorld(t), this.matrixWorldInverse.copy(this.matrixWorld).invert();
  }
  updateWorldMatrix(t, i) {
    super.updateWorldMatrix(t, i), this.matrixWorldInverse.copy(this.matrixWorld).invert();
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
const I_ = /* @__PURE__ */ new Ge(), rge = /* @__PURE__ */ new us(), lge = /* @__PURE__ */ new us();
class Tg extends Qpe {
  /**
   * Constructs a new perspective camera.
   *
   * @param {number} [fov=50] - The vertical field of view.
   * @param {number} [aspect=1] - The aspect ratio.
   * @param {number} [near=0.1] - The camera's near plane.
   * @param {number} [far=2000] - The camera's far plane.
   */
  constructor(t = 50, i = 1, n = 0.1, s = 2e3) {
    super(), this.isPerspectiveCamera = !0, this.type = "PerspectiveCamera", this.fov = t, this.zoom = 1, this.near = n, this.far = s, this.focus = 10, this.aspect = i, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
  }
  copy(t, i) {
    return super.copy(t, i), this.fov = t.fov, this.zoom = t.zoom, this.near = t.near, this.far = t.far, this.focus = t.focus, this.aspect = t.aspect, this.view = t.view === null ? null : Object.assign({}, t.view), this.filmGauge = t.filmGauge, this.filmOffset = t.filmOffset, this;
  }
  /**
   * Sets the FOV by focal length in respect to the current {@link PerspectiveCamera#filmGauge}.
   *
   * The default film gauge is 35, so that the focal length can be specified for
   * a 35mm (full frame) camera.
   *
   * @param {number} focalLength - Values for focal length and film gauge must have the same unit.
   */
  setFocalLength(t) {
    const i = 0.5 * this.getFilmHeight() / t;
    this.fov = yX * 2 * Math.atan(i), this.updateProjectionMatrix();
  }
  /**
   * Returns the focal length from the current {@link PerspectiveCamera#fov} and
   * {@link PerspectiveCamera#filmGauge}.
   *
   * @return {number} The computed focal length.
   */
  getFocalLength() {
    const t = Math.tan(vJ * 0.5 * this.fov);
    return 0.5 * this.getFilmHeight() / t;
  }
  /**
   * Returns the current vertical field of view angle in degrees considering {@link PerspectiveCamera#zoom}.
   *
   * @return {number} The effective FOV.
   */
  getEffectiveFOV() {
    return yX * 2 * Math.atan(
      Math.tan(vJ * 0.5 * this.fov) / this.zoom
    );
  }
  /**
   * Returns the width of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
   * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
   *
   * @return {number} The film width.
   */
  getFilmWidth() {
    return this.filmGauge * Math.min(this.aspect, 1);
  }
  /**
   * Returns the height of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
   * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
   *
   * @return {number} The film width.
   */
  getFilmHeight() {
    return this.filmGauge / Math.max(this.aspect, 1);
  }
  /**
   * Computes the 2D bounds of the camera's viewable rectangle at a given distance along the viewing direction.
   * Sets `minTarget` and `maxTarget` to the coordinates of the lower-left and upper-right corners of the view rectangle.
   *
   * @param {number} distance - The viewing distance.
   * @param {Vector2} minTarget - The lower-left corner of the view rectangle is written into this vector.
   * @param {Vector2} maxTarget - The upper-right corner of the view rectangle is written into this vector.
   */
  getViewBounds(t, i, n) {
    I_.set(-1, -1, 0.5).applyMatrix4(this.projectionMatrixInverse), i.set(I_.x, I_.y).multiplyScalar(-t / I_.z), I_.set(1, 1, 0.5).applyMatrix4(this.projectionMatrixInverse), n.set(I_.x, I_.y).multiplyScalar(-t / I_.z);
  }
  /**
   * Computes the width and height of the camera's viewable rectangle at a given distance along the viewing direction.
   *
   * @param {number} distance - The viewing distance.
   * @param {Vector2} target - The target vector that is used to store result where x is width and y is height.
   * @returns {Vector2} The view size.
   */
  getViewSize(t, i) {
    return this.getViewBounds(t, rge, lge), i.subVectors(lge, rge);
  }
  /**
   * Sets an offset in a larger frustum. This is useful for multi-window or
   * multi-monitor/multi-machine setups.
   *
   * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
   * the monitors are in grid like this
   *```
   *   +---+---+---+
   *   | A | B | C |
   *   +---+---+---+
   *   | D | E | F |
   *   +---+---+---+
   *```
   * then for each monitor you would call it like this:
   *```js
   * const w = 1920;
   * const h = 1080;
   * const fullWidth = w * 3;
   * const fullHeight = h * 2;
   *
   * // --A--
   * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
   * // --B--
   * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
   * // --C--
   * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
   * // --D--
   * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
   * // --E--
   * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
   * // --F--
   * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
   * ```
   *
   * Note there is no reason monitors have to be the same size or in a grid.
   *
   * @param {number} fullWidth - The full width of multiview setup.
   * @param {number} fullHeight - The full height of multiview setup.
   * @param {number} x - The horizontal offset of the subcamera.
   * @param {number} y - The vertical offset of the subcamera.
   * @param {number} width - The width of subcamera.
   * @param {number} height - The height of subcamera.
   */
  setViewOffset(t, i, n, s, o, r) {
    this.aspect = t / i, this.view === null && (this.view = {
      enabled: !0,
      fullWidth: 1,
      fullHeight: 1,
      offsetX: 0,
      offsetY: 0,
      width: 1,
      height: 1
    }), this.view.enabled = !0, this.view.fullWidth = t, this.view.fullHeight = i, this.view.offsetX = n, this.view.offsetY = s, this.view.width = o, this.view.height = r, this.updateProjectionMatrix();
  }
  /**
   * Removes the view offset from the projection matrix.
   */
  clearViewOffset() {
    this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
  }
  /**
   * Updates the camera's projection matrix. Must be called after any change of
   * camera properties.
   */
  updateProjectionMatrix() {
    const t = this.near;
    let i = t * Math.tan(vJ * 0.5 * this.fov) / this.zoom, n = 2 * i, s = this.aspect * n, o = -0.5 * s;
    const r = this.view;
    if (this.view !== null && this.view.enabled) {
      const c = r.fullWidth, h = r.fullHeight;
      o += r.offsetX * s / c, i -= r.offsetY * n / h, s *= r.width / c, n *= r.height / h;
    }
    const l = this.filmOffset;
    l !== 0 && (o += t * l / this.getFilmWidth()), this.projectionMatrix.makePerspective(o, o + s, i, i - n, t, this.far, this.coordinateSystem), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(t) {
    const i = super.toJSON(t);
    return i.object.fov = this.fov, i.object.zoom = this.zoom, i.object.near = this.near, i.object.far = this.far, i.object.focus = this.focus, i.object.aspect = this.aspect, this.view !== null && (i.object.view = Object.assign({}, this.view)), i.object.filmGauge = this.filmGauge, i.object.filmOffset = this.filmOffset, i;
  }
}
const qk = -90, $k = 1;
class aUe extends wu {
  /**
   * Constructs a new cube camera.
   *
   * @param {number} near - The camera's near plane.
   * @param {number} far - The camera's far plane.
   * @param {WebGLCubeRenderTarget} renderTarget - The cube render target.
   */
  constructor(t, i, n) {
    super(), this.type = "CubeCamera", this.renderTarget = n, this.coordinateSystem = null, this.activeMipmapLevel = 0;
    const s = new Tg(qk, $k, t, i);
    s.layers = this.layers, this.add(s);
    const o = new Tg(qk, $k, t, i);
    o.layers = this.layers, this.add(o);
    const r = new Tg(qk, $k, t, i);
    r.layers = this.layers, this.add(r);
    const l = new Tg(qk, $k, t, i);
    l.layers = this.layers, this.add(l);
    const c = new Tg(qk, $k, t, i);
    c.layers = this.layers, this.add(c);
    const h = new Tg(qk, $k, t, i);
    h.layers = this.layers, this.add(h);
  }
  /**
   * Must be called when the coordinate system of the cube camera is changed.
   */
  updateCoordinateSystem() {
    const t = this.coordinateSystem, i = this.children.concat(), [n, s, o, r, l, c] = i;
    for (const h of i) this.remove(h);
    if (t === hN)
      n.up.set(0, 1, 0), n.lookAt(1, 0, 0), s.up.set(0, 1, 0), s.lookAt(-1, 0, 0), o.up.set(0, 0, -1), o.lookAt(0, 1, 0), r.up.set(0, 0, 1), r.lookAt(0, -1, 0), l.up.set(0, 1, 0), l.lookAt(0, 0, 1), c.up.set(0, 1, 0), c.lookAt(0, 0, -1);
    else if (t === ple)
      n.up.set(0, -1, 0), n.lookAt(-1, 0, 0), s.up.set(0, -1, 0), s.lookAt(1, 0, 0), o.up.set(0, 0, 1), o.lookAt(0, 1, 0), r.up.set(0, 0, -1), r.lookAt(0, -1, 0), l.up.set(0, -1, 0), l.lookAt(0, 0, 1), c.up.set(0, -1, 0), c.lookAt(0, 0, -1);
    else
      throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + t);
    for (const h of i)
      this.add(h), h.updateMatrixWorld();
  }
  /**
   * Calling this method will render the given scene with the given renderer
   * into the cube render target of the camera.
   *
   * @param {(Renderer|WebGLRenderer)} renderer - The renderer.
   * @param {Scene} scene - The scene to render.
   */
  update(t, i) {
    this.parent === null && this.updateMatrixWorld();
    const { renderTarget: n, activeMipmapLevel: s } = this;
    this.coordinateSystem !== t.coordinateSystem && (this.coordinateSystem = t.coordinateSystem, this.updateCoordinateSystem());
    const [o, r, l, c, h, I] = this.children, p = t.getRenderTarget(), y = t.getActiveCubeFace(), m = t.getActiveMipmapLevel(), A = t.xr.enabled;
    t.xr.enabled = !1;
    const C = n.texture.generateMipmaps;
    n.texture.generateMipmaps = !1, t.setRenderTarget(n, 0, s), t.render(i, o), t.setRenderTarget(n, 1, s), t.render(i, r), t.setRenderTarget(n, 2, s), t.render(i, l), t.setRenderTarget(n, 3, s), t.render(i, c), t.setRenderTarget(n, 4, s), t.render(i, h), n.texture.generateMipmaps = C, t.setRenderTarget(n, 5, s), t.render(i, I), t.setRenderTarget(p, y, m), t.xr.enabled = A, n.texture.needsPMREMUpdate = !0;
  }
}
class TAe extends sE {
  /**
   * Constructs a new cube texture.
   *
   * @param {Array<Image>} [images=[]] - An array holding a image for each side of a cube.
   * @param {number} [mapping=CubeReflectionMapping] - The texture mapping.
   * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
   * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
   * @param {number} [magFilter=LinearFilter] - The mag filter value.
   * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
   * @param {number} [format=RGBAFormat] - The texture format.
   * @param {number} [type=UnsignedByteType] - The texture type.
   * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
   * @param {string} [colorSpace=NoColorSpace] - The color space value.
   */
  constructor(t = [], i = CW, n, s, o, r, l, c, h, I) {
    super(t, i, n, s, o, r, l, c, h, I), this.isCubeTexture = !0, this.flipY = !1;
  }
  /**
   * Alias for {@link CubeTexture#image}.
   *
   * @type {Array<Image>}
   */
  get images() {
    return this.image;
  }
  set images(t) {
    this.image = t;
  }
}
class uUe extends qP {
  /**
   * Constructs a new cube render target.
   *
   * @param {number} [size=1] - The size of the render target.
   * @param {RenderTarget~Options} [options] - The configuration object.
   */
  constructor(t = 1, i = {}) {
    super(t, t, i), this.isWebGLCubeRenderTarget = !0;
    const n = { width: t, height: t, depth: 1 }, s = [n, n, n, n, n, n];
    this.texture = new TAe(s), this._setTextureOptions(i), this.texture.isRenderTargetTexture = !0;
  }
  /**
   * Converts the given equirectangular texture to a cube map.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Texture} texture - The equirectangular texture.
   * @return {WebGLCubeRenderTarget} A reference to this cube render target.
   */
  fromEquirectangularTexture(t, i) {
    this.texture.type = i.type, this.texture.colorSpace = i.colorSpace, this.texture.generateMipmaps = i.generateMipmaps, this.texture.minFilter = i.minFilter, this.texture.magFilter = i.magFilter;
    const n = {
      uniforms: {
        tEquirect: { value: null }
      },
      vertexShader: (
        /* glsl */
        `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`
      ),
      fragmentShader: (
        /* glsl */
        `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
      )
    }, s = new L0(5, 5, 5), o = new BA({
      name: "CubemapFromEquirect",
      uniforms: _W(n.uniforms),
      vertexShader: n.vertexShader,
      fragmentShader: n.fragmentShader,
      side: nE,
      blending: CP
    });
    o.uniforms.tEquirect.value = i;
    const r = new En(s, o), l = i.minFilter;
    return i.minFilter === rB && (i.minFilter = dN), new aUe(1, 10, this).update(t, r), i.minFilter = l, r.geometry.dispose(), r.material.dispose(), this;
  }
  /**
   * Clears this cube render target.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {boolean} [color=true] - Whether the color buffer should be cleared or not.
   * @param {boolean} [depth=true] - Whether the depth buffer should be cleared or not.
   * @param {boolean} [stencil=true] - Whether the stencil buffer should be cleared or not.
   */
  clear(t, i = !0, n = !0, s = !0) {
    const o = t.getRenderTarget();
    for (let r = 0; r < 6; r++)
      t.setRenderTarget(this, r), t.clear(i, n, s);
    t.setRenderTarget(o);
  }
}
class E5 extends wu {
  constructor() {
    super(), this.isGroup = !0, this.type = "Group";
  }
}
const dUe = { type: "move" };
class Fde {
  /**
   * Constructs a new XR controller.
   */
  constructor() {
    this._targetRay = null, this._grip = null, this._hand = null;
  }
  /**
   * Returns a group representing the hand space of the XR controller.
   *
   * @return {Group} A group representing the hand space of the XR controller.
   */
  getHandSpace() {
    return this._hand === null && (this._hand = new E5(), this._hand.matrixAutoUpdate = !1, this._hand.visible = !1, this._hand.joints = {}, this._hand.inputState = { pinching: !1 }), this._hand;
  }
  /**
   * Returns a group representing the target ray space of the XR controller.
   *
   * @return {Group} A group representing the target ray space of the XR controller.
   */
  getTargetRaySpace() {
    return this._targetRay === null && (this._targetRay = new E5(), this._targetRay.matrixAutoUpdate = !1, this._targetRay.visible = !1, this._targetRay.hasLinearVelocity = !1, this._targetRay.linearVelocity = new Ge(), this._targetRay.hasAngularVelocity = !1, this._targetRay.angularVelocity = new Ge()), this._targetRay;
  }
  /**
   * Returns a group representing the grip space of the XR controller.
   *
   * @return {Group} A group representing the grip space of the XR controller.
   */
  getGripSpace() {
    return this._grip === null && (this._grip = new E5(), this._grip.matrixAutoUpdate = !1, this._grip.visible = !1, this._grip.hasLinearVelocity = !1, this._grip.linearVelocity = new Ge(), this._grip.hasAngularVelocity = !1, this._grip.angularVelocity = new Ge()), this._grip;
  }
  /**
   * Dispatches the given event to the groups representing
   * the different coordinate spaces of the XR controller.
   *
   * @param {Object} event - The event to dispatch.
   * @return {WebXRController} A reference to this instance.
   */
  dispatchEvent(t) {
    return this._targetRay !== null && this._targetRay.dispatchEvent(t), this._grip !== null && this._grip.dispatchEvent(t), this._hand !== null && this._hand.dispatchEvent(t), this;
  }
  /**
   * Connects the controller with the given XR input source.
   *
   * @param {XRInputSource} inputSource - The input source.
   * @return {WebXRController} A reference to this instance.
   */
  connect(t) {
    if (t && t.hand) {
      const i = this._hand;
      if (i)
        for (const n of t.hand.values())
          this._getHandJoint(i, n);
    }
    return this.dispatchEvent({ type: "connected", data: t }), this;
  }
  /**
   * Disconnects the controller from the given XR input source.
   *
   * @param {XRInputSource} inputSource - The input source.
   * @return {WebXRController} A reference to this instance.
   */
  disconnect(t) {
    return this.dispatchEvent({ type: "disconnected", data: t }), this._targetRay !== null && (this._targetRay.visible = !1), this._grip !== null && (this._grip.visible = !1), this._hand !== null && (this._hand.visible = !1), this;
  }
  /**
   * Updates the controller with the given input source, XR frame and reference space.
   * This updates the transformations of the groups that represent the different
   * coordinate systems of the controller.
   *
   * @param {XRInputSource} inputSource - The input source.
   * @param {XRFrame} frame - The XR frame.
   * @param {XRReferenceSpace} referenceSpace - The reference space.
   * @return {WebXRController} A reference to this instance.
   */
  update(t, i, n) {
    let s = null, o = null, r = null;
    const l = this._targetRay, c = this._grip, h = this._hand;
    if (t && i.session.visibilityState !== "visible-blurred") {
      if (h && t.hand) {
        r = !0;
        for (const C of t.hand.values()) {
          const O = i.getJointPose(C, n), R = this._getHandJoint(h, C);
          O !== null && (R.matrix.fromArray(O.transform.matrix), R.matrix.decompose(R.position, R.rotation, R.scale), R.matrixWorldNeedsUpdate = !0, R.jointRadius = O.radius), R.visible = O !== null;
        }
        const I = h.joints["index-finger-tip"], p = h.joints["thumb-tip"], y = I.position.distanceTo(p.position), m = 0.02, A = 5e-3;
        h.inputState.pinching && y > m + A ? (h.inputState.pinching = !1, this.dispatchEvent({
          type: "pinchend",
          handedness: t.handedness,
          target: this
        })) : !h.inputState.pinching && y <= m - A && (h.inputState.pinching = !0, this.dispatchEvent({
          type: "pinchstart",
          handedness: t.handedness,
          target: this
        }));
      } else
        c !== null && t.gripSpace && (o = i.getPose(t.gripSpace, n), o !== null && (c.matrix.fromArray(o.transform.matrix), c.matrix.decompose(c.position, c.rotation, c.scale), c.matrixWorldNeedsUpdate = !0, o.linearVelocity ? (c.hasLinearVelocity = !0, c.linearVelocity.copy(o.linearVelocity)) : c.hasLinearVelocity = !1, o.angularVelocity ? (c.hasAngularVelocity = !0, c.angularVelocity.copy(o.angularVelocity)) : c.hasAngularVelocity = !1));
      l !== null && (s = i.getPose(t.targetRaySpace, n), s === null && o !== null && (s = o), s !== null && (l.matrix.fromArray(s.transform.matrix), l.matrix.decompose(l.position, l.rotation, l.scale), l.matrixWorldNeedsUpdate = !0, s.linearVelocity ? (l.hasLinearVelocity = !0, l.linearVelocity.copy(s.linearVelocity)) : l.hasLinearVelocity = !1, s.angularVelocity ? (l.hasAngularVelocity = !0, l.angularVelocity.copy(s.angularVelocity)) : l.hasAngularVelocity = !1, this.dispatchEvent(dUe)));
    }
    return l !== null && (l.visible = s !== null), c !== null && (c.visible = o !== null), h !== null && (h.visible = r !== null), this;
  }
  /**
   * Returns a group representing the hand joint for the given input joint.
   *
   * @private
   * @param {Group} hand - The group representing the hand space.
   * @param {XRJointSpace} inputjoint - The hand joint data.
   * @return {Group} A group representing the hand joint for the given input joint.
   */
  _getHandJoint(t, i) {
    if (t.joints[i.jointName] === void 0) {
      const n = new E5();
      n.matrixAutoUpdate = !1, n.visible = !1, t.joints[i.jointName] = n, t.add(n);
    }
    return t.joints[i.jointName];
  }
}
class cUe extends wu {
  /**
   * Constructs a new scene.
   */
  constructor() {
    super(), this.isScene = !0, this.type = "Scene", this.background = null, this.environment = null, this.fog = null, this.backgroundBlurriness = 0, this.backgroundIntensity = 1, this.backgroundRotation = new UA(), this.environmentIntensity = 1, this.environmentRotation = new UA(), this.overrideMaterial = null, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
  }
  copy(t, i) {
    return super.copy(t, i), t.background !== null && (this.background = t.background.clone()), t.environment !== null && (this.environment = t.environment.clone()), t.fog !== null && (this.fog = t.fog.clone()), this.backgroundBlurriness = t.backgroundBlurriness, this.backgroundIntensity = t.backgroundIntensity, this.backgroundRotation.copy(t.backgroundRotation), this.environmentIntensity = t.environmentIntensity, this.environmentRotation.copy(t.environmentRotation), t.overrideMaterial !== null && (this.overrideMaterial = t.overrideMaterial.clone()), this.matrixAutoUpdate = t.matrixAutoUpdate, this;
  }
  toJSON(t) {
    const i = super.toJSON(t);
    return this.fog !== null && (i.object.fog = this.fog.toJSON()), this.backgroundBlurriness > 0 && (i.object.backgroundBlurriness = this.backgroundBlurriness), this.backgroundIntensity !== 1 && (i.object.backgroundIntensity = this.backgroundIntensity), i.object.backgroundRotation = this.backgroundRotation.toArray(), this.environmentIntensity !== 1 && (i.object.environmentIntensity = this.environmentIntensity), i.object.environmentRotation = this.environmentRotation.toArray(), i;
  }
}
class hUe {
  /**
   * Constructs a new interleaved buffer.
   *
   * @param {TypedArray} array - A typed array with a shared buffer storing attribute data.
   * @param {number} stride - The number of typed-array elements per vertex.
   */
  constructor(t, i) {
    this.isInterleavedBuffer = !0, this.array = t, this.stride = i, this.count = t !== void 0 ? t.length / i : 0, this.usage = j1e, this.updateRanges = [], this.version = 0, this.uuid = jO();
  }
  /**
   * A callback function that is executed after the renderer has transferred the attribute array
   * data to the GPU.
   */
  onUploadCallback() {
  }
  /**
   * Flag to indicate that this attribute has changed and should be re-sent to
   * the GPU. Set this to `true` when you modify the value of the array.
   *
   * @type {number}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(t) {
    t === !0 && this.version++;
  }
  /**
   * Sets the usage of this interleaved buffer.
   *
   * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
   * @return {InterleavedBuffer} A reference to this interleaved buffer.
   */
  setUsage(t) {
    return this.usage = t, this;
  }
  /**
   * Adds a range of data in the data array to be updated on the GPU.
   *
   * @param {number} start - Position at which to start update.
   * @param {number} count - The number of components to update.
   */
  addUpdateRange(t, i) {
    this.updateRanges.push({ start: t, count: i });
  }
  /**
   * Clears the update ranges.
   */
  clearUpdateRanges() {
    this.updateRanges.length = 0;
  }
  /**
   * Copies the values of the given interleaved buffer to this instance.
   *
   * @param {InterleavedBuffer} source - The interleaved buffer to copy.
   * @return {InterleavedBuffer} A reference to this instance.
   */
  copy(t) {
    return this.array = new t.array.constructor(t.array), this.count = t.count, this.stride = t.stride, this.usage = t.usage, this;
  }
  /**
   * Copies a vector from the given interleaved buffer to this one. The start
   * and destination position in the attribute buffers are represented by the
   * given indices.
   *
   * @param {number} index1 - The destination index into this interleaved buffer.
   * @param {InterleavedBuffer} interleavedBuffer - The interleaved buffer to copy from.
   * @param {number} index2 - The source index into the given interleaved buffer.
   * @return {InterleavedBuffer} A reference to this instance.
   */
  copyAt(t, i, n) {
    t *= this.stride, n *= i.stride;
    for (let s = 0, o = this.stride; s < o; s++)
      this.array[t + s] = i.array[n + s];
    return this;
  }
  /**
   * Sets the given array data in the interleaved buffer.
   *
   * @param {(TypedArray|Array)} value - The array data to set.
   * @param {number} [offset=0] - The offset in this interleaved buffer's array.
   * @return {InterleavedBuffer} A reference to this instance.
   */
  set(t, i = 0) {
    return this.array.set(t, i), this;
  }
  /**
   * Returns a new interleaved buffer with copied values from this instance.
   *
   * @param {Object} [data] - An object with shared array buffers that allows to retain shared structures.
   * @return {InterleavedBuffer} A clone of this instance.
   */
  clone(t) {
    t.arrayBuffers === void 0 && (t.arrayBuffers = {}), this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = jO()), t.arrayBuffers[this.array.buffer._uuid] === void 0 && (t.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer);
    const i = new this.array.constructor(t.arrayBuffers[this.array.buffer._uuid]), n = new this.constructor(i, this.stride);
    return n.setUsage(this.usage), n;
  }
  /**
   * Sets the given callback function that is executed after the Renderer has transferred
   * the array data to the GPU. Can be used to perform clean-up operations after
   * the upload when data are not needed anymore on the CPU side.
   *
   * @param {Function} callback - The `onUpload()` callback.
   * @return {InterleavedBuffer} A reference to this instance.
   */
  onUpload(t) {
    return this.onUploadCallback = t, this;
  }
  /**
   * Serializes the interleaved buffer into JSON.
   *
   * @param {Object} [data] - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized interleaved buffer.
   */
  toJSON(t) {
    return t.arrayBuffers === void 0 && (t.arrayBuffers = {}), this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = jO()), t.arrayBuffers[this.array.buffer._uuid] === void 0 && (t.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer))), {
      uuid: this.uuid,
      buffer: this.array.buffer._uuid,
      type: this.array.constructor.name,
      stride: this.stride
    };
  }
}
const by = /* @__PURE__ */ new Ge();
class fN {
  /**
   * Constructs a new interleaved buffer attribute.
   *
   * @param {InterleavedBuffer} interleavedBuffer - The buffer holding the interleaved data.
   * @param {number} itemSize - The item size.
   * @param {number} offset - The attribute offset into the buffer.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */
  constructor(t, i, n, s = !1) {
    this.isInterleavedBufferAttribute = !0, this.name = "", this.data = t, this.itemSize = i, this.offset = n, this.normalized = s;
  }
  /**
   * The item count of this buffer attribute.
   *
   * @type {number}
   * @readonly
   */
  get count() {
    return this.data.count;
  }
  /**
   * The array holding the interleaved buffer attribute data.
   *
   * @type {TypedArray}
   */
  get array() {
    return this.data.array;
  }
  /**
   * Flag to indicate that this attribute has changed and should be re-sent to
   * the GPU. Set this to `true` when you modify the value of the array.
   *
   * @type {number}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(t) {
    this.data.needsUpdate = t;
  }
  /**
   * Applies the given 4x4 matrix to the given attribute. Only works with
   * item size `3`.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  applyMatrix4(t) {
    for (let i = 0, n = this.data.count; i < n; i++)
      by.fromBufferAttribute(this, i), by.applyMatrix4(t), this.setXYZ(i, by.x, by.y, by.z);
    return this;
  }
  /**
   * Applies the given 3x3 normal matrix to the given attribute. Only works with
   * item size `3`.
   *
   * @param {Matrix3} m - The normal matrix to apply.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  applyNormalMatrix(t) {
    for (let i = 0, n = this.count; i < n; i++)
      by.fromBufferAttribute(this, i), by.applyNormalMatrix(t), this.setXYZ(i, by.x, by.y, by.z);
    return this;
  }
  /**
   * Applies the given 4x4 matrix to the given attribute. Only works with
   * item size `3` and with direction vectors.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  transformDirection(t) {
    for (let i = 0, n = this.count; i < n; i++)
      by.fromBufferAttribute(this, i), by.transformDirection(t), this.setXYZ(i, by.x, by.y, by.z);
    return this;
  }
  /**
   * Returns the given component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} component - The component index.
   * @return {number} The returned value.
   */
  getComponent(t, i) {
    let n = this.array[t * this.data.stride + this.offset + i];
    return this.normalized && (n = Lv(n, this.array)), n;
  }
  /**
   * Sets the given value to the given component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} component - The component index.
   * @param {number} value - The value to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setComponent(t, i, n) {
    return this.normalized && (n = Tl(n, this.array)), this.data.array[t * this.data.stride + this.offset + i] = n, this;
  }
  /**
   * Sets the x component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setX(t, i) {
    return this.normalized && (i = Tl(i, this.array)), this.data.array[t * this.data.stride + this.offset] = i, this;
  }
  /**
   * Sets the y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} y - The value to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setY(t, i) {
    return this.normalized && (i = Tl(i, this.array)), this.data.array[t * this.data.stride + this.offset + 1] = i, this;
  }
  /**
   * Sets the z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} z - The value to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setZ(t, i) {
    return this.normalized && (i = Tl(i, this.array)), this.data.array[t * this.data.stride + this.offset + 2] = i, this;
  }
  /**
   * Sets the w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} w - The value to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setW(t, i) {
    return this.normalized && (i = Tl(i, this.array)), this.data.array[t * this.data.stride + this.offset + 3] = i, this;
  }
  /**
   * Returns the x component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The x component.
   */
  getX(t) {
    let i = this.data.array[t * this.data.stride + this.offset];
    return this.normalized && (i = Lv(i, this.array)), i;
  }
  /**
   * Returns the y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The y component.
   */
  getY(t) {
    let i = this.data.array[t * this.data.stride + this.offset + 1];
    return this.normalized && (i = Lv(i, this.array)), i;
  }
  /**
   * Returns the z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The z component.
   */
  getZ(t) {
    let i = this.data.array[t * this.data.stride + this.offset + 2];
    return this.normalized && (i = Lv(i, this.array)), i;
  }
  /**
   * Returns the w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The w component.
   */
  getW(t) {
    let i = this.data.array[t * this.data.stride + this.offset + 3];
    return this.normalized && (i = Lv(i, this.array)), i;
  }
  /**
   * Sets the x and y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setXY(t, i, n) {
    return t = t * this.data.stride + this.offset, this.normalized && (i = Tl(i, this.array), n = Tl(n, this.array)), this.data.array[t + 0] = i, this.data.array[t + 1] = n, this;
  }
  /**
   * Sets the x, y and z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @param {number} z - The value for the z component to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setXYZ(t, i, n, s) {
    return t = t * this.data.stride + this.offset, this.normalized && (i = Tl(i, this.array), n = Tl(n, this.array), s = Tl(s, this.array)), this.data.array[t + 0] = i, this.data.array[t + 1] = n, this.data.array[t + 2] = s, this;
  }
  /**
   * Sets the x, y, z and w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @param {number} z - The value for the z component to set.
   * @param {number} w - The value for the w component to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setXYZW(t, i, n, s, o) {
    return t = t * this.data.stride + this.offset, this.normalized && (i = Tl(i, this.array), n = Tl(n, this.array), s = Tl(s, this.array), o = Tl(o, this.array)), this.data.array[t + 0] = i, this.data.array[t + 1] = n, this.data.array[t + 2] = s, this.data.array[t + 3] = o, this;
  }
  /**
   * Returns a new buffer attribute with copied values from this instance.
   *
   * If no parameter is provided, cloning an interleaved buffer attribute will de-interleave buffer data.
   *
   * @param {Object} [data] - An object with interleaved buffers that allows to retain the interleaved property.
   * @return {BufferAttribute|InterleavedBufferAttribute} A clone of this instance.
   */
  clone(t) {
    if (t === void 0) {
      console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.");
      const i = [];
      for (let n = 0; n < this.count; n++) {
        const s = n * this.data.stride + this.offset;
        for (let o = 0; o < this.itemSize; o++)
          i.push(this.data.array[s + o]);
      }
      return new zu(new this.array.constructor(i), this.itemSize, this.normalized);
    } else
      return t.interleavedBuffers === void 0 && (t.interleavedBuffers = {}), t.interleavedBuffers[this.data.uuid] === void 0 && (t.interleavedBuffers[this.data.uuid] = this.data.clone(t)), new fN(t.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
  }
  /**
   * Serializes the buffer attribute into JSON.
   *
   * If no parameter is provided, cloning an interleaved buffer attribute will de-interleave buffer data.
   *
   * @param {Object} [data] - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized buffer attribute.
   */
  toJSON(t) {
    if (t === void 0) {
      console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.");
      const i = [];
      for (let n = 0; n < this.count; n++) {
        const s = n * this.data.stride + this.offset;
        for (let o = 0; o < this.itemSize; o++)
          i.push(this.data.array[s + o]);
      }
      return {
        itemSize: this.itemSize,
        type: this.array.constructor.name,
        array: i,
        normalized: this.normalized
      };
    } else
      return t.interleavedBuffers === void 0 && (t.interleavedBuffers = {}), t.interleavedBuffers[this.data.uuid] === void 0 && (t.interleavedBuffers[this.data.uuid] = this.data.toJSON(t)), {
        isInterleavedBufferAttribute: !0,
        itemSize: this.itemSize,
        data: this.data.uuid,
        offset: this.offset,
        normalized: this.normalized
      };
  }
}
class fUe extends sE {
  /**
   * Constructs a new data texture.
   *
   * @param {?TypedArray} [data=null] - The buffer data.
   * @param {number} [width=1] - The width of the texture.
   * @param {number} [height=1] - The height of the texture.
   * @param {number} [format=RGBAFormat] - The texture format.
   * @param {number} [type=UnsignedByteType] - The texture type.
   * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
   * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
   * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
   * @param {number} [magFilter=NearestFilter] - The mag filter value.
   * @param {number} [minFilter=NearestFilter] - The min filter value.
   * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
   * @param {string} [colorSpace=NoColorSpace] - The color space.
   */
  constructor(t = null, i = 1, n = 1, s, o, r, l, c, h = g4, I = g4, p, y) {
    super(null, r, l, c, h, I, s, o, p, y), this.isDataTexture = !0, this.image = { data: t, width: i, height: n }, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
  }
}
class W1e extends zu {
  /**
   * Constructs a new instanced buffer attribute.
   *
   * @param {TypedArray} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   * @param {number} [meshPerAttribute=1] - How often a value of this buffer attribute should be repeated.
   */
  constructor(t, i, n, s = 1) {
    super(t, i, n), this.isInstancedBufferAttribute = !0, this.meshPerAttribute = s;
  }
  copy(t) {
    return super.copy(t), this.meshPerAttribute = t.meshPerAttribute, this;
  }
  toJSON() {
    const t = super.toJSON();
    return t.meshPerAttribute = this.meshPerAttribute, t.isInstancedBufferAttribute = !0, t;
  }
}
const Kk = /* @__PURE__ */ new Ln(), age = /* @__PURE__ */ new Ln(), kne = [], uge = /* @__PURE__ */ new Zs(), IUe = /* @__PURE__ */ new Ln(), AZ = /* @__PURE__ */ new En(), SZ = /* @__PURE__ */ new f3();
class pUe extends En {
  /**
   * Constructs a new instanced mesh.
   *
   * @param {BufferGeometry} [geometry] - The mesh geometry.
   * @param {Material|Array<Material>} [material] - The mesh material.
   * @param {number} count - The number of instances.
   */
  constructor(t, i, n) {
    super(t, i), this.isInstancedMesh = !0, this.instanceMatrix = new W1e(new Float32Array(n * 16), 16), this.instanceColor = null, this.morphTexture = null, this.count = n, this.boundingBox = null, this.boundingSphere = null;
    for (let s = 0; s < n; s++)
      this.setMatrixAt(s, IUe);
  }
  /**
   * Computes the bounding box of the instanced mesh, and updates {@link InstancedMesh#boundingBox}.
   * The bounding box is not automatically computed by the engine; this method must be called by your app.
   * You may need to recompute the bounding box if an instance is transformed via {@link InstancedMesh#setMatrixAt}.
   */
  computeBoundingBox() {
    const t = this.geometry, i = this.count;
    this.boundingBox === null && (this.boundingBox = new Zs()), t.boundingBox === null && t.computeBoundingBox(), this.boundingBox.makeEmpty();
    for (let n = 0; n < i; n++)
      this.getMatrixAt(n, Kk), uge.copy(t.boundingBox).applyMatrix4(Kk), this.boundingBox.union(uge);
  }
  /**
   * Computes the bounding sphere of the instanced mesh, and updates {@link InstancedMesh#boundingSphere}
   * The engine automatically computes the bounding sphere when it is needed, e.g., for ray casting or view frustum culling.
   * You may need to recompute the bounding sphere if an instance is transformed via {@link InstancedMesh#setMatrixAt}.
   */
  computeBoundingSphere() {
    const t = this.geometry, i = this.count;
    this.boundingSphere === null && (this.boundingSphere = new f3()), t.boundingSphere === null && t.computeBoundingSphere(), this.boundingSphere.makeEmpty();
    for (let n = 0; n < i; n++)
      this.getMatrixAt(n, Kk), SZ.copy(t.boundingSphere).applyMatrix4(Kk), this.boundingSphere.union(SZ);
  }
  copy(t, i) {
    return super.copy(t, i), this.instanceMatrix.copy(t.instanceMatrix), t.morphTexture !== null && (this.morphTexture = t.morphTexture.clone()), t.instanceColor !== null && (this.instanceColor = t.instanceColor.clone()), this.count = t.count, t.boundingBox !== null && (this.boundingBox = t.boundingBox.clone()), t.boundingSphere !== null && (this.boundingSphere = t.boundingSphere.clone()), this;
  }
  /**
   * Gets the color of the defined instance.
   *
   * @param {number} index - The instance index.
   * @param {Color} color - The target object that is used to store the method's result.
   */
  getColorAt(t, i) {
    i.fromArray(this.instanceColor.array, t * 3);
  }
  /**
   * Gets the local transformation matrix of the defined instance.
   *
   * @param {number} index - The instance index.
   * @param {Matrix4} matrix - The target object that is used to store the method's result.
   */
  getMatrixAt(t, i) {
    i.fromArray(this.instanceMatrix.array, t * 16);
  }
  /**
   * Gets the morph target weights of the defined instance.
   *
   * @param {number} index - The instance index.
   * @param {Mesh} object - The target object that is used to store the method's result.
   */
  getMorphAt(t, i) {
    const n = i.morphTargetInfluences, s = this.morphTexture.source.data.data, o = n.length + 1, r = t * o + 1;
    for (let l = 0; l < n.length; l++)
      n[l] = s[r + l];
  }
  raycast(t, i) {
    const n = this.matrixWorld, s = this.count;
    if (AZ.geometry = this.geometry, AZ.material = this.material, AZ.material !== void 0 && (this.boundingSphere === null && this.computeBoundingSphere(), SZ.copy(this.boundingSphere), SZ.applyMatrix4(n), t.ray.intersectsSphere(SZ) !== !1))
      for (let o = 0; o < s; o++) {
        this.getMatrixAt(o, Kk), age.multiplyMatrices(n, Kk), AZ.matrixWorld = age, AZ.raycast(t, kne);
        for (let r = 0, l = kne.length; r < l; r++) {
          const c = kne[r];
          c.instanceId = o, c.object = this, i.push(c);
        }
        kne.length = 0;
      }
  }
  /**
   * Sets the given color to the defined instance. Make sure you set the `needsUpdate` flag of
   * {@link InstancedMesh#instanceColor} to `true` after updating all the colors.
   *
   * @param {number} index - The instance index.
   * @param {Color} color - The instance color.
   */
  setColorAt(t, i) {
    this.instanceColor === null && (this.instanceColor = new W1e(new Float32Array(this.instanceMatrix.count * 3).fill(1), 3)), i.toArray(this.instanceColor.array, t * 3);
  }
  /**
   * Sets the given local transformation matrix to the defined instance. Make sure you set the `needsUpdate` flag of
   * {@link InstancedMesh#instanceMatrix} to `true` after updating all the colors.
   *
   * @param {number} index - The instance index.
   * @param {Matrix4} matrix - The local transformation.
   */
  setMatrixAt(t, i) {
    i.toArray(this.instanceMatrix.array, t * 16);
  }
  /**
   * Sets the morph target weights to the defined instance. Make sure you set the `needsUpdate` flag of
   * {@link InstancedMesh#morphTexture} to `true` after updating all the influences.
   *
   * @param {number} index - The instance index.
   * @param {Mesh} object -  A mesh which `morphTargetInfluences` property containing the morph target weights
   * of a single instance.
   */
  setMorphAt(t, i) {
    const n = i.morphTargetInfluences, s = n.length + 1;
    this.morphTexture === null && (this.morphTexture = new fUe(new Float32Array(s * this.count), s, this.count, jpe, cN));
    const o = this.morphTexture.source.data.data;
    let r = 0;
    for (let h = 0; h < n.length; h++)
      r += n[h];
    const l = this.geometry.morphTargetsRelative ? 1 : 1 - r, c = s * t;
    o[c] = l, o.set(n, c + 1);
  }
  updateMorphTargets() {
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" }), this.morphTexture !== null && (this.morphTexture.dispose(), this.morphTexture = null);
  }
}
const Hde = /* @__PURE__ */ new Ge(), mUe = /* @__PURE__ */ new Ge(), yUe = /* @__PURE__ */ new fo();
class tl {
  /**
   * Constructs a new plane.
   *
   * @param {Vector3} [normal=(1,0,0)] - A unit length vector defining the normal of the plane.
   * @param {number} [constant=0] - The signed distance from the origin to the plane.
   */
  constructor(t = new Ge(1, 0, 0), i = 0) {
    this.isPlane = !0, this.normal = t, this.constant = i;
  }
  /**
   * Sets the plane components by copying the given values.
   *
   * @param {Vector3} normal - The normal.
   * @param {number} constant - The constant.
   * @return {Plane} A reference to this plane.
   */
  set(t, i) {
    return this.normal.copy(t), this.constant = i, this;
  }
  /**
   * Sets the plane components by defining `x`, `y`, `z` as the
   * plane normal and `w` as the constant.
   *
   * @param {number} x - The value for the normal's x component.
   * @param {number} y - The value for the normal's y component.
   * @param {number} z - The value for the normal's z component.
   * @param {number} w - The constant value.
   * @return {Plane} A reference to this plane.
   */
  setComponents(t, i, n, s) {
    return this.normal.set(t, i, n), this.constant = s, this;
  }
  /**
   * Sets the plane from the given normal and coplanar point (that is a point
   * that lies onto the plane).
   *
   * @param {Vector3} normal - The normal.
   * @param {Vector3} point - A coplanar point.
   * @return {Plane} A reference to this plane.
   */
  setFromNormalAndCoplanarPoint(t, i) {
    return this.normal.copy(t), this.constant = -i.dot(this.normal), this;
  }
  /**
   * Sets the plane from three coplanar points. The winding order is
   * assumed to be counter-clockwise, and determines the direction of
   * the plane normal.
   *
   * @param {Vector3} a - The first coplanar point.
   * @param {Vector3} b - The second coplanar point.
   * @param {Vector3} c - The third coplanar point.
   * @return {Plane} A reference to this plane.
   */
  setFromCoplanarPoints(t, i, n) {
    const s = Hde.subVectors(n, i).cross(mUe.subVectors(t, i)).normalize();
    return this.setFromNormalAndCoplanarPoint(s, t), this;
  }
  /**
   * Copies the values of the given plane to this instance.
   *
   * @param {Plane} plane - The plane to copy.
   * @return {Plane} A reference to this plane.
   */
  copy(t) {
    return this.normal.copy(t.normal), this.constant = t.constant, this;
  }
  /**
   * Normalizes the plane normal and adjusts the constant accordingly.
   *
   * @return {Plane} A reference to this plane.
   */
  normalize() {
    const t = 1 / this.normal.length();
    return this.normal.multiplyScalar(t), this.constant *= t, this;
  }
  /**
   * Negates both the plane normal and the constant.
   *
   * @return {Plane} A reference to this plane.
   */
  negate() {
    return this.constant *= -1, this.normal.negate(), this;
  }
  /**
   * Returns the signed distance from the given point to this plane.
   *
   * @param {Vector3} point - The point to compute the distance for.
   * @return {number} The signed distance.
   */
  distanceToPoint(t) {
    return this.normal.dot(t) + this.constant;
  }
  /**
   * Returns the signed distance from the given sphere to this plane.
   *
   * @param {Sphere} sphere - The sphere to compute the distance for.
   * @return {number} The signed distance.
   */
  distanceToSphere(t) {
    return this.distanceToPoint(t.center) - t.radius;
  }
  /**
   * Projects a the given point onto the plane.
   *
   * @param {Vector3} point - The point to project.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The projected point on the plane.
   */
  projectPoint(t, i) {
    return i.copy(t).addScaledVector(this.normal, -this.distanceToPoint(t));
  }
  /**
   * Returns the intersection point of the passed line and the plane. Returns
   * `null` if the line does not intersect. Returns the line's starting point if
   * the line is coplanar with the plane.
   *
   * @param {Line3} line - The line to compute the intersection for.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */
  intersectLine(t, i) {
    const n = t.delta(Hde), s = this.normal.dot(n);
    if (s === 0)
      return this.distanceToPoint(t.start) === 0 ? i.copy(t.start) : null;
    const o = -(t.start.dot(this.normal) + this.constant) / s;
    return o < 0 || o > 1 ? null : i.copy(t.start).addScaledVector(n, o);
  }
  /**
   * Returns `true` if the given line segment intersects with (passes through) the plane.
   *
   * @param {Line3} line - The line to test.
   * @return {boolean} Whether the given line segment intersects with the plane or not.
   */
  intersectsLine(t) {
    const i = this.distanceToPoint(t.start), n = this.distanceToPoint(t.end);
    return i < 0 && n > 0 || n < 0 && i > 0;
  }
  /**
   * Returns `true` if the given bounding box intersects with the plane.
   *
   * @param {Box3} box - The bounding box to test.
   * @return {boolean} Whether the given bounding box intersects with the plane or not.
   */
  intersectsBox(t) {
    return t.intersectsPlane(this);
  }
  /**
   * Returns `true` if the given bounding sphere intersects with the plane.
   *
   * @param {Sphere} sphere - The bounding sphere to test.
   * @return {boolean} Whether the given bounding sphere intersects with the plane or not.
   */
  intersectsSphere(t) {
    return t.intersectsPlane(this);
  }
  /**
   * Returns a coplanar vector to the plane, by calculating the
   * projection of the normal at the origin onto the plane.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The coplanar point.
   */
  coplanarPoint(t) {
    return t.copy(this.normal).multiplyScalar(-this.constant);
  }
  /**
   * Apply a 4x4 matrix to the plane. The matrix must be an affine, homogeneous transform.
   *
   * The optional normal matrix can be pre-computed like so:
   * ```js
   * const optionalNormalMatrix = new THREE.Matrix3().getNormalMatrix( matrix );
   * ```
   *
   * @param {Matrix4} matrix - The transformation matrix.
   * @param {Matrix4} [optionalNormalMatrix] - A pre-computed normal matrix.
   * @return {Plane} A reference to this plane.
   */
  applyMatrix4(t, i) {
    const n = i || yUe.getNormalMatrix(t), s = this.coplanarPoint(Hde).applyMatrix4(t), o = this.normal.applyMatrix3(n).normalize();
    return this.constant = -s.dot(o), this;
  }
  /**
   * Translates the plane by the distance defined by the given offset vector.
   * Note that this only affects the plane constant and will not affect the normal vector.
   *
   * @param {Vector3} offset - The offset vector.
   * @return {Plane} A reference to this plane.
   */
  translate(t) {
    return this.constant -= t.dot(this.normal), this;
  }
  /**
   * Returns `true` if this plane is equal with the given one.
   *
   * @param {Plane} plane - The plane to test for equality.
   * @return {boolean} Whether this plane is equal with the given one.
   */
  equals(t) {
    return t.normal.equals(this.normal) && t.constant === this.constant;
  }
  /**
   * Returns a new plane with copied values from this instance.
   *
   * @return {Plane} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
}
const X9 = /* @__PURE__ */ new f3(), EUe = /* @__PURE__ */ new us(0.5, 0.5), Vne = /* @__PURE__ */ new Ge();
class cL {
  /**
   * Constructs a new frustum.
   *
   * @param {Plane} [p0] - The first plane that encloses the frustum.
   * @param {Plane} [p1] - The second plane that encloses the frustum.
   * @param {Plane} [p2] - The third plane that encloses the frustum.
   * @param {Plane} [p3] - The fourth plane that encloses the frustum.
   * @param {Plane} [p4] - The fifth plane that encloses the frustum.
   * @param {Plane} [p5] - The sixth plane that encloses the frustum.
   */
  constructor(t = new tl(), i = new tl(), n = new tl(), s = new tl(), o = new tl(), r = new tl()) {
    this.planes = [t, i, n, s, o, r];
  }
  /**
   * Sets the frustum planes by copying the given planes.
   *
   * @param {Plane} [p0] - The first plane that encloses the frustum.
   * @param {Plane} [p1] - The second plane that encloses the frustum.
   * @param {Plane} [p2] - The third plane that encloses the frustum.
   * @param {Plane} [p3] - The fourth plane that encloses the frustum.
   * @param {Plane} [p4] - The fifth plane that encloses the frustum.
   * @param {Plane} [p5] - The sixth plane that encloses the frustum.
   * @return {Frustum} A reference to this frustum.
   */
  set(t, i, n, s, o, r) {
    const l = this.planes;
    return l[0].copy(t), l[1].copy(i), l[2].copy(n), l[3].copy(s), l[4].copy(o), l[5].copy(r), this;
  }
  /**
   * Copies the values of the given frustum to this instance.
   *
   * @param {Frustum} frustum - The frustum to copy.
   * @return {Frustum} A reference to this frustum.
   */
  copy(t) {
    const i = this.planes;
    for (let n = 0; n < 6; n++)
      i[n].copy(t.planes[n]);
    return this;
  }
  /**
   * Sets the frustum planes from the given projection matrix.
   *
   * @param {Matrix4} m - The projection matrix.
   * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} coordinateSystem - The coordinate system.
   * @return {Frustum} A reference to this frustum.
   */
  setFromProjectionMatrix(t, i = hN) {
    const n = this.planes, s = t.elements, o = s[0], r = s[1], l = s[2], c = s[3], h = s[4], I = s[5], p = s[6], y = s[7], m = s[8], A = s[9], C = s[10], O = s[11], R = s[12], F = s[13], L = s[14], P = s[15];
    if (n[0].setComponents(c - o, y - h, O - m, P - R).normalize(), n[1].setComponents(c + o, y + h, O + m, P + R).normalize(), n[2].setComponents(c + r, y + I, O + A, P + F).normalize(), n[3].setComponents(c - r, y - I, O - A, P - F).normalize(), n[4].setComponents(c - l, y - p, O - C, P - L).normalize(), i === hN)
      n[5].setComponents(c + l, y + p, O + C, P + L).normalize();
    else if (i === ple)
      n[5].setComponents(l, p, C, L).normalize();
    else
      throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + i);
    return this;
  }
  /**
   * Returns `true` if the 3D object's bounding sphere is intersecting this frustum.
   *
   * Note that the 3D object must have a geometry so that the bounding sphere can be calculated.
   *
   * @param {Object3D} object - The 3D object to test.
   * @return {boolean} Whether the 3D object's bounding sphere is intersecting this frustum or not.
   */
  intersectsObject(t) {
    if (t.boundingSphere !== void 0)
      t.boundingSphere === null && t.computeBoundingSphere(), X9.copy(t.boundingSphere).applyMatrix4(t.matrixWorld);
    else {
      const i = t.geometry;
      i.boundingSphere === null && i.computeBoundingSphere(), X9.copy(i.boundingSphere).applyMatrix4(t.matrixWorld);
    }
    return this.intersectsSphere(X9);
  }
  /**
   * Returns `true` if the given sprite is intersecting this frustum.
   *
   * @param {Sprite} sprite - The sprite to test.
   * @return {boolean} Whether the sprite is intersecting this frustum or not.
   */
  intersectsSprite(t) {
    X9.center.set(0, 0, 0);
    const i = EUe.distanceTo(t.center);
    return X9.radius = 0.7071067811865476 + i, X9.applyMatrix4(t.matrixWorld), this.intersectsSphere(X9);
  }
  /**
   * Returns `true` if the given bounding sphere is intersecting this frustum.
   *
   * @param {Sphere} sphere - The bounding sphere to test.
   * @return {boolean} Whether the bounding sphere is intersecting this frustum or not.
   */
  intersectsSphere(t) {
    const i = this.planes, n = t.center, s = -t.radius;
    for (let o = 0; o < 6; o++)
      if (i[o].distanceToPoint(n) < s)
        return !1;
    return !0;
  }
  /**
   * Returns `true` if the given bounding box is intersecting this frustum.
   *
   * @param {Box3} box - The bounding box to test.
   * @return {boolean} Whether the bounding box is intersecting this frustum or not.
   */
  intersectsBox(t) {
    const i = this.planes;
    for (let n = 0; n < 6; n++) {
      const s = i[n];
      if (Vne.x = s.normal.x > 0 ? t.max.x : t.min.x, Vne.y = s.normal.y > 0 ? t.max.y : t.min.y, Vne.z = s.normal.z > 0 ? t.max.z : t.min.z, s.distanceToPoint(Vne) < 0)
        return !1;
    }
    return !0;
  }
  /**
   * Returns `true` if the given point lies within the frustum.
   *
   * @param {Vector3} point - The point to test.
   * @return {boolean} Whether the point lies within this frustum or not.
   */
  containsPoint(t) {
    const i = this.planes;
    for (let n = 0; n < 6; n++)
      if (i[n].distanceToPoint(t) < 0)
        return !1;
    return !0;
  }
  /**
   * Returns a new frustum with copied values from this instance.
   *
   * @return {Frustum} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
}
class gie extends _H {
  /**
   * Constructs a new line basic material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(t) {
    super(), this.isLineBasicMaterial = !0, this.type = "LineBasicMaterial", this.color = new Xn(16777215), this.map = null, this.linewidth = 1, this.linecap = "round", this.linejoin = "round", this.fog = !0, this.setValues(t);
  }
  copy(t) {
    return super.copy(t), this.color.copy(t.color), this.map = t.map, this.linewidth = t.linewidth, this.linecap = t.linecap, this.linejoin = t.linejoin, this.fog = t.fog, this;
  }
}
const yle = /* @__PURE__ */ new Ge(), Ele = /* @__PURE__ */ new Ge(), dge = /* @__PURE__ */ new Ln(), bZ = /* @__PURE__ */ new MA(), zne = /* @__PURE__ */ new f3(), Gde = /* @__PURE__ */ new Ge(), cge = /* @__PURE__ */ new Ge();
class fv extends wu {
  /**
   * Constructs a new line.
   *
   * @param {BufferGeometry} [geometry] - The line geometry.
   * @param {Material|Array<Material>} [material] - The line material.
   */
  constructor(t = new Vl(), i = new gie()) {
    super(), this.isLine = !0, this.type = "Line", this.geometry = t, this.material = i, this.morphTargetDictionary = void 0, this.morphTargetInfluences = void 0, this.updateMorphTargets();
  }
  copy(t, i) {
    return super.copy(t, i), this.material = Array.isArray(t.material) ? t.material.slice() : t.material, this.geometry = t.geometry, this;
  }
  /**
   * Computes an array of distance values which are necessary for rendering dashed lines.
   * For each vertex in the geometry, the method calculates the cumulative length from the
   * current point to the very beginning of the line.
   *
   * @return {Line} A reference to this line.
   */
  computeLineDistances() {
    const t = this.geometry;
    if (t.index === null) {
      const i = t.attributes.position, n = [0];
      for (let s = 1, o = i.count; s < o; s++)
        yle.fromBufferAttribute(i, s - 1), Ele.fromBufferAttribute(i, s), n[s] = n[s - 1], n[s] += yle.distanceTo(Ele);
      t.setAttribute("lineDistance", new al(n, 1));
    } else
      console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
    return this;
  }
  /**
   * Computes intersection points between a casted ray and this line.
   *
   * @param {Raycaster} raycaster - The raycaster.
   * @param {Array<Object>} intersects - The target array that holds the intersection points.
   */
  raycast(t, i) {
    const n = this.geometry, s = this.matrixWorld, o = t.params.Line.threshold, r = n.drawRange;
    if (n.boundingSphere === null && n.computeBoundingSphere(), zne.copy(n.boundingSphere), zne.applyMatrix4(s), zne.radius += o, t.ray.intersectsSphere(zne) === !1) return;
    dge.copy(s).invert(), bZ.copy(t.ray).applyMatrix4(dge);
    const l = o / ((this.scale.x + this.scale.y + this.scale.z) / 3), c = l * l, h = this.isLineSegments ? 2 : 1, I = n.index, y = n.attributes.position;
    if (I !== null) {
      const m = Math.max(0, r.start), A = Math.min(I.count, r.start + r.count);
      for (let C = m, O = A - 1; C < O; C += h) {
        const R = I.getX(C), F = I.getX(C + 1), L = jne(this, t, bZ, c, R, F, C);
        L && i.push(L);
      }
      if (this.isLineLoop) {
        const C = I.getX(A - 1), O = I.getX(m), R = jne(this, t, bZ, c, C, O, A - 1);
        R && i.push(R);
      }
    } else {
      const m = Math.max(0, r.start), A = Math.min(y.count, r.start + r.count);
      for (let C = m, O = A - 1; C < O; C += h) {
        const R = jne(this, t, bZ, c, C, C + 1, C);
        R && i.push(R);
      }
      if (this.isLineLoop) {
        const C = jne(this, t, bZ, c, A - 1, m, A - 1);
        C && i.push(C);
      }
    }
  }
  /**
   * Sets the values of {@link Line#morphTargetDictionary} and {@link Line#morphTargetInfluences}
   * to make sure existing morph targets can influence this 3D object.
   */
  updateMorphTargets() {
    const i = this.geometry.morphAttributes, n = Object.keys(i);
    if (n.length > 0) {
      const s = i[n[0]];
      if (s !== void 0) {
        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
        for (let o = 0, r = s.length; o < r; o++) {
          const l = s[o].name || String(o);
          this.morphTargetInfluences.push(0), this.morphTargetDictionary[l] = o;
        }
      }
    }
  }
}
function jne(e, t, i, n, s, o, r) {
  const l = e.geometry.attributes.position;
  if (yle.fromBufferAttribute(l, s), Ele.fromBufferAttribute(l, o), i.distanceSqToSegment(yle, Ele, Gde, cge) > n) return;
  Gde.applyMatrix4(e.matrixWorld);
  const h = t.ray.origin.distanceTo(Gde);
  if (!(h < t.near || h > t.far))
    return {
      distance: h,
      // What do we want? intersection point on the ray or on the segment??
      // point: raycaster.ray.at( distance ),
      point: cge.clone().applyMatrix4(e.matrixWorld),
      index: r,
      face: null,
      faceIndex: null,
      barycoord: null,
      object: e
    };
}
const hge = /* @__PURE__ */ new Ge(), fge = /* @__PURE__ */ new Ge();
class gUe extends fv {
  /**
   * Constructs a new line segments.
   *
   * @param {BufferGeometry} [geometry] - The line geometry.
   * @param {Material|Array<Material>} [material] - The line material.
   */
  constructor(t, i) {
    super(t, i), this.isLineSegments = !0, this.type = "LineSegments";
  }
  computeLineDistances() {
    const t = this.geometry;
    if (t.index === null) {
      const i = t.attributes.position, n = [];
      for (let s = 0, o = i.count; s < o; s += 2)
        hge.fromBufferAttribute(i, s), fge.fromBufferAttribute(i, s + 1), n[s] = s === 0 ? 0 : n[s - 1], n[s + 1] = n[s] + hge.distanceTo(fge);
      t.setAttribute("lineDistance", new al(n, 1));
    } else
      console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
    return this;
  }
}
class Y1e extends _H {
  /**
   * Constructs a new points material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(t) {
    super(), this.isPointsMaterial = !0, this.type = "PointsMaterial", this.color = new Xn(16777215), this.map = null, this.alphaMap = null, this.size = 1, this.sizeAttenuation = !0, this.fog = !0, this.setValues(t);
  }
  copy(t) {
    return super.copy(t), this.color.copy(t.color), this.map = t.map, this.alphaMap = t.alphaMap, this.size = t.size, this.sizeAttenuation = t.sizeAttenuation, this.fog = t.fog, this;
  }
}
const Ige = /* @__PURE__ */ new Ln(), q1e = /* @__PURE__ */ new MA(), Wne = /* @__PURE__ */ new f3(), Yne = /* @__PURE__ */ new Ge();
class wUe extends wu {
  /**
   * Constructs a new point cloud.
   *
   * @param {BufferGeometry} [geometry] - The points geometry.
   * @param {Material|Array<Material>} [material] - The points material.
   */
  constructor(t = new Vl(), i = new Y1e()) {
    super(), this.isPoints = !0, this.type = "Points", this.geometry = t, this.material = i, this.morphTargetDictionary = void 0, this.morphTargetInfluences = void 0, this.updateMorphTargets();
  }
  copy(t, i) {
    return super.copy(t, i), this.material = Array.isArray(t.material) ? t.material.slice() : t.material, this.geometry = t.geometry, this;
  }
  /**
   * Computes intersection points between a casted ray and this point cloud.
   *
   * @param {Raycaster} raycaster - The raycaster.
   * @param {Array<Object>} intersects - The target array that holds the intersection points.
   */
  raycast(t, i) {
    const n = this.geometry, s = this.matrixWorld, o = t.params.Points.threshold, r = n.drawRange;
    if (n.boundingSphere === null && n.computeBoundingSphere(), Wne.copy(n.boundingSphere), Wne.applyMatrix4(s), Wne.radius += o, t.ray.intersectsSphere(Wne) === !1) return;
    Ige.copy(s).invert(), q1e.copy(t.ray).applyMatrix4(Ige);
    const l = o / ((this.scale.x + this.scale.y + this.scale.z) / 3), c = l * l, h = n.index, p = n.attributes.position;
    if (h !== null) {
      const y = Math.max(0, r.start), m = Math.min(h.count, r.start + r.count);
      for (let A = y, C = m; A < C; A++) {
        const O = h.getX(A);
        Yne.fromBufferAttribute(p, O), pge(Yne, O, c, s, t, i, this);
      }
    } else {
      const y = Math.max(0, r.start), m = Math.min(p.count, r.start + r.count);
      for (let A = y, C = m; A < C; A++)
        Yne.fromBufferAttribute(p, A), pge(Yne, A, c, s, t, i, this);
    }
  }
  /**
   * Sets the values of {@link Points#morphTargetDictionary} and {@link Points#morphTargetInfluences}
   * to make sure existing morph targets can influence this 3D object.
   */
  updateMorphTargets() {
    const i = this.geometry.morphAttributes, n = Object.keys(i);
    if (n.length > 0) {
      const s = i[n[0]];
      if (s !== void 0) {
        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
        for (let o = 0, r = s.length; o < r; o++) {
          const l = s[o].name || String(o);
          this.morphTargetInfluences.push(0), this.morphTargetDictionary[l] = o;
        }
      }
    }
  }
}
function pge(e, t, i, n, s, o, r) {
  const l = q1e.distanceSqToPoint(e);
  if (l < i) {
    const c = new Ge();
    q1e.closestPointToPoint(e, c), c.applyMatrix4(n);
    const h = s.ray.origin.distanceTo(c);
    if (h < s.near || h > s.far) return;
    o.push({
      distance: h,
      distanceToRay: Math.sqrt(l),
      point: c,
      index: t,
      face: null,
      faceIndex: null,
      barycoord: null,
      object: r
    });
  }
}
class RAe extends sE {
  /**
   * Constructs a new depth texture.
   *
   * @param {number} width - The width of the texture.
   * @param {number} height - The height of the texture.
   * @param {number} [type=UnsignedIntType] - The texture type.
   * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
   * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
   * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
   * @param {number} [magFilter=LinearFilter] - The mag filter value.
   * @param {number} [minFilter=LinearFilter] - The min filter value.
   * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
   * @param {number} [format=DepthFormat] - The texture format.
   * @param {number} [depth=1] - The depth of the texture.
   */
  constructor(t, i, n = JF, s, o, r, l = g4, c = g4, h, I = pX, p = 1) {
    if (I !== pX && I !== mX)
      throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
    const y = { width: t, height: i, depth: p };
    super(y, s, o, r, l, c, I, n, h), this.isDepthTexture = !0, this.flipY = !1, this.generateMipmaps = !1, this.compareFunction = null;
  }
  copy(t) {
    return super.copy(t), this.source = new Kpe(Object.assign({}, t.image)), this.compareFunction = t.compareFunction, this;
  }
  toJSON(t) {
    const i = super.toJSON(t);
    return this.compareFunction !== null && (i.compareFunction = this.compareFunction), i;
  }
}
class yp extends Vl {
  /**
   * Constructs a new cylinder geometry.
   *
   * @param {number} [radiusTop=1] - Radius of the cylinder at the top.
   * @param {number} [radiusBottom=1] - Radius of the cylinder at the bottom.
   * @param {number} [height=1] - Height of the cylinder.
   * @param {number} [radialSegments=32] - Number of segmented faces around the circumference of the cylinder.
   * @param {number} [heightSegments=1] - Number of rows of faces along the height of the cylinder.
   * @param {boolean} [openEnded=false] - Whether the base of the cylinder is open or capped.
   * @param {number} [thetaStart=0] - Start angle for first segment, in radians.
   * @param {number} [thetaLength=Math.PI*2] - The central angle, often called theta, of the circular sector, in radians.
   * The default value results in a complete cylinder.
   */
  constructor(t = 1, i = 1, n = 1, s = 32, o = 1, r = !1, l = 0, c = Math.PI * 2) {
    super(), this.type = "CylinderGeometry", this.parameters = {
      radiusTop: t,
      radiusBottom: i,
      height: n,
      radialSegments: s,
      heightSegments: o,
      openEnded: r,
      thetaStart: l,
      thetaLength: c
    };
    const h = this;
    s = Math.floor(s), o = Math.floor(o);
    const I = [], p = [], y = [], m = [];
    let A = 0;
    const C = [], O = n / 2;
    let R = 0;
    F(), r === !1 && (t > 0 && L(!0), i > 0 && L(!1)), this.setIndex(I), this.setAttribute("position", new al(p, 3)), this.setAttribute("normal", new al(y, 3)), this.setAttribute("uv", new al(m, 2));
    function F() {
      const P = new Ge(), z = new Ge();
      let W = 0;
      const re = (i - t) / n;
      for (let ce = 0; ce <= o; ce++) {
        const te = [], ee = ce / o, Ne = ee * (i - t) + t;
        for (let Ae = 0; Ae <= s; Ae++) {
          const Oe = Ae / s, pe = Oe * c + l, je = Math.sin(pe), Ve = Math.cos(pe);
          z.x = Ne * je, z.y = -ee * n + O, z.z = Ne * Ve, p.push(z.x, z.y, z.z), P.set(je, re, Ve).normalize(), y.push(P.x, P.y, P.z), m.push(Oe, 1 - ee), te.push(A++);
        }
        C.push(te);
      }
      for (let ce = 0; ce < s; ce++)
        for (let te = 0; te < o; te++) {
          const ee = C[te][ce], Ne = C[te + 1][ce], Ae = C[te + 1][ce + 1], Oe = C[te][ce + 1];
          (t > 0 || te !== 0) && (I.push(ee, Ne, Oe), W += 3), (i > 0 || te !== o - 1) && (I.push(Ne, Ae, Oe), W += 3);
        }
      h.addGroup(R, W, 0), R += W;
    }
    function L(P) {
      const z = A, W = new us(), re = new Ge();
      let ce = 0;
      const te = P === !0 ? t : i, ee = P === !0 ? 1 : -1;
      for (let Ae = 1; Ae <= s; Ae++)
        p.push(0, O * ee, 0), y.push(0, ee, 0), m.push(0.5, 0.5), A++;
      const Ne = A;
      for (let Ae = 0; Ae <= s; Ae++) {
        const pe = Ae / s * c + l, je = Math.cos(pe), Ve = Math.sin(pe);
        re.x = te * Ve, re.y = O * ee, re.z = te * je, p.push(re.x, re.y, re.z), y.push(0, ee, 0), W.x = je * 0.5 + 0.5, W.y = Ve * 0.5 * ee + 0.5, m.push(W.x, W.y), A++;
      }
      for (let Ae = 0; Ae < s; Ae++) {
        const Oe = z + Ae, pe = Ne + Ae;
        P === !0 ? I.push(pe, pe + 1, Oe) : I.push(pe + 1, pe, Oe), ce += 3;
      }
      h.addGroup(R, ce, P === !0 ? 1 : 2), R += ce;
    }
  }
  copy(t) {
    return super.copy(t), this.parameters = Object.assign({}, t.parameters), this;
  }
  /**
   * Factory method for creating an instance of this class from the given
   * JSON object.
   *
   * @param {Object} data - A JSON object representing the serialized geometry.
   * @return {CylinderGeometry} A new instance.
   */
  static fromJSON(t) {
    return new yp(t.radiusTop, t.radiusBottom, t.height, t.radialSegments, t.heightSegments, t.openEnded, t.thetaStart, t.thetaLength);
  }
}
class Jpe extends Vl {
  /**
   * Constructs a new polyhedron geometry.
   *
   * @param {Array<number>} [vertices] - A flat array of vertices describing the base shape.
   * @param {Array<number>} [indices] - A flat array of indices describing the base shape.
   * @param {number} [radius=1] - The radius of the shape.
   * @param {number} [detail=0] - How many levels to subdivide the geometry. The more detail, the smoother the shape.
   */
  constructor(t = [], i = [], n = 1, s = 0) {
    super(), this.type = "PolyhedronGeometry", this.parameters = {
      vertices: t,
      indices: i,
      radius: n,
      detail: s
    };
    const o = [], r = [];
    l(s), h(n), I(), this.setAttribute("position", new al(o, 3)), this.setAttribute("normal", new al(o.slice(), 3)), this.setAttribute("uv", new al(r, 2)), s === 0 ? this.computeVertexNormals() : this.normalizeNormals();
    function l(F) {
      const L = new Ge(), P = new Ge(), z = new Ge();
      for (let W = 0; W < i.length; W += 3)
        m(i[W + 0], L), m(i[W + 1], P), m(i[W + 2], z), c(L, P, z, F);
    }
    function c(F, L, P, z) {
      const W = z + 1, re = [];
      for (let ce = 0; ce <= W; ce++) {
        re[ce] = [];
        const te = F.clone().lerp(P, ce / W), ee = L.clone().lerp(P, ce / W), Ne = W - ce;
        for (let Ae = 0; Ae <= Ne; Ae++)
          Ae === 0 && ce === W ? re[ce][Ae] = te : re[ce][Ae] = te.clone().lerp(ee, Ae / Ne);
      }
      for (let ce = 0; ce < W; ce++)
        for (let te = 0; te < 2 * (W - ce) - 1; te++) {
          const ee = Math.floor(te / 2);
          te % 2 === 0 ? (y(re[ce][ee + 1]), y(re[ce + 1][ee]), y(re[ce][ee])) : (y(re[ce][ee + 1]), y(re[ce + 1][ee + 1]), y(re[ce + 1][ee]));
        }
    }
    function h(F) {
      const L = new Ge();
      for (let P = 0; P < o.length; P += 3)
        L.x = o[P + 0], L.y = o[P + 1], L.z = o[P + 2], L.normalize().multiplyScalar(F), o[P + 0] = L.x, o[P + 1] = L.y, o[P + 2] = L.z;
    }
    function I() {
      const F = new Ge();
      for (let L = 0; L < o.length; L += 3) {
        F.x = o[L + 0], F.y = o[L + 1], F.z = o[L + 2];
        const P = O(F) / 2 / Math.PI + 0.5, z = R(F) / Math.PI + 0.5;
        r.push(P, 1 - z);
      }
      A(), p();
    }
    function p() {
      for (let F = 0; F < r.length; F += 6) {
        const L = r[F + 0], P = r[F + 2], z = r[F + 4], W = Math.max(L, P, z), re = Math.min(L, P, z);
        W > 0.9 && re < 0.1 && (L < 0.2 && (r[F + 0] += 1), P < 0.2 && (r[F + 2] += 1), z < 0.2 && (r[F + 4] += 1));
      }
    }
    function y(F) {
      o.push(F.x, F.y, F.z);
    }
    function m(F, L) {
      const P = F * 3;
      L.x = t[P + 0], L.y = t[P + 1], L.z = t[P + 2];
    }
    function A() {
      const F = new Ge(), L = new Ge(), P = new Ge(), z = new Ge(), W = new us(), re = new us(), ce = new us();
      for (let te = 0, ee = 0; te < o.length; te += 9, ee += 6) {
        F.set(o[te + 0], o[te + 1], o[te + 2]), L.set(o[te + 3], o[te + 4], o[te + 5]), P.set(o[te + 6], o[te + 7], o[te + 8]), W.set(r[ee + 0], r[ee + 1]), re.set(r[ee + 2], r[ee + 3]), ce.set(r[ee + 4], r[ee + 5]), z.copy(F).add(L).add(P).divideScalar(3);
        const Ne = O(z);
        C(W, ee + 0, F, Ne), C(re, ee + 2, L, Ne), C(ce, ee + 4, P, Ne);
      }
    }
    function C(F, L, P, z) {
      z < 0 && F.x === 1 && (r[L] = F.x - 1), P.x === 0 && P.z === 0 && (r[L] = z / 2 / Math.PI + 0.5);
    }
    function O(F) {
      return Math.atan2(F.z, -F.x);
    }
    function R(F) {
      return Math.atan2(-F.y, Math.sqrt(F.x * F.x + F.z * F.z));
    }
  }
  copy(t) {
    return super.copy(t), this.parameters = Object.assign({}, t.parameters), this;
  }
  /**
   * Factory method for creating an instance of this class from the given
   * JSON object.
   *
   * @param {Object} data - A JSON object representing the serialized geometry.
   * @return {PolyhedronGeometry} A new instance.
   */
  static fromJSON(t) {
    return new Jpe(t.vertices, t.indices, t.radius, t.details);
  }
}
class sz extends Jpe {
  /**
   * Constructs a new octahedron geometry.
   *
   * @param {number} [radius=1] - Radius of the octahedron.
   * @param {number} [detail=0] - Setting this to a value greater than `0` adds vertices making it no longer a octahedron.
   */
  constructor(t = 1, i = 0) {
    const n = [
      1,
      0,
      0,
      -1,
      0,
      0,
      0,
      1,
      0,
      0,
      -1,
      0,
      0,
      0,
      1,
      0,
      0,
      -1
    ], s = [
      0,
      2,
      4,
      0,
      4,
      3,
      0,
      3,
      5,
      0,
      5,
      2,
      1,
      2,
      5,
      1,
      5,
      3,
      1,
      3,
      4,
      1,
      4,
      2
    ];
    super(n, s, t, i), this.type = "OctahedronGeometry", this.parameters = {
      radius: t,
      detail: i
    };
  }
  /**
   * Factory method for creating an instance of this class from the given
   * JSON object.
   *
   * @param {Object} data - A JSON object representing the serialized geometry.
   * @return {OctahedronGeometry} A new instance.
   */
  static fromJSON(t) {
    return new sz(t.radius, t.detail);
  }
}
class xH extends Vl {
  /**
   * Constructs a new plane geometry.
   *
   * @param {number} [width=1] - The width along the X axis.
   * @param {number} [height=1] - The height along the Y axis
   * @param {number} [widthSegments=1] - The number of segments along the X axis.
   * @param {number} [heightSegments=1] - The number of segments along the Y axis.
   */
  constructor(t = 1, i = 1, n = 1, s = 1) {
    super(), this.type = "PlaneGeometry", this.parameters = {
      width: t,
      height: i,
      widthSegments: n,
      heightSegments: s
    };
    const o = t / 2, r = i / 2, l = Math.floor(n), c = Math.floor(s), h = l + 1, I = c + 1, p = t / l, y = i / c, m = [], A = [], C = [], O = [];
    for (let R = 0; R < I; R++) {
      const F = R * y - r;
      for (let L = 0; L < h; L++) {
        const P = L * p - o;
        A.push(P, -F, 0), C.push(0, 0, 1), O.push(L / l), O.push(1 - R / c);
      }
    }
    for (let R = 0; R < c; R++)
      for (let F = 0; F < l; F++) {
        const L = F + h * R, P = F + h * (R + 1), z = F + 1 + h * (R + 1), W = F + 1 + h * R;
        m.push(L, P, W), m.push(P, z, W);
      }
    this.setIndex(m), this.setAttribute("position", new al(A, 3)), this.setAttribute("normal", new al(C, 3)), this.setAttribute("uv", new al(O, 2));
  }
  copy(t) {
    return super.copy(t), this.parameters = Object.assign({}, t.parameters), this;
  }
  /**
   * Factory method for creating an instance of this class from the given
   * JSON object.
   *
   * @param {Object} data - A JSON object representing the serialized geometry.
   * @return {PlaneGeometry} A new instance.
   */
  static fromJSON(t) {
    return new xH(t.width, t.height, t.widthSegments, t.heightSegments);
  }
}
class Xpe extends Vl {
  /**
   * Constructs a new sphere geometry.
   *
   * @param {number} [radius=1] - The sphere radius.
   * @param {number} [widthSegments=32] - The number of horizontal segments. Minimum value is `3`.
   * @param {number} [heightSegments=16] - The number of vertical segments. Minimum value is `2`.
   * @param {number} [phiStart=0] - The horizontal starting angle in radians.
   * @param {number} [phiLength=Math.PI*2] - The horizontal sweep angle size.
   * @param {number} [thetaStart=0] - The vertical starting angle in radians.
   * @param {number} [thetaLength=Math.PI] - The vertical sweep angle size.
   */
  constructor(t = 1, i = 32, n = 16, s = 0, o = Math.PI * 2, r = 0, l = Math.PI) {
    super(), this.type = "SphereGeometry", this.parameters = {
      radius: t,
      widthSegments: i,
      heightSegments: n,
      phiStart: s,
      phiLength: o,
      thetaStart: r,
      thetaLength: l
    }, i = Math.max(3, Math.floor(i)), n = Math.max(2, Math.floor(n));
    const c = Math.min(r + l, Math.PI);
    let h = 0;
    const I = [], p = new Ge(), y = new Ge(), m = [], A = [], C = [], O = [];
    for (let R = 0; R <= n; R++) {
      const F = [], L = R / n;
      let P = 0;
      R === 0 && r === 0 ? P = 0.5 / i : R === n && c === Math.PI && (P = -0.5 / i);
      for (let z = 0; z <= i; z++) {
        const W = z / i;
        p.x = -t * Math.cos(s + W * o) * Math.sin(r + L * l), p.y = t * Math.cos(r + L * l), p.z = t * Math.sin(s + W * o) * Math.sin(r + L * l), A.push(p.x, p.y, p.z), y.copy(p).normalize(), C.push(y.x, y.y, y.z), O.push(W + P, 1 - L), F.push(h++);
      }
      I.push(F);
    }
    for (let R = 0; R < n; R++)
      for (let F = 0; F < i; F++) {
        const L = I[R][F + 1], P = I[R][F], z = I[R + 1][F], W = I[R + 1][F + 1];
        (R !== 0 || r > 0) && m.push(L, P, W), (R !== n - 1 || c < Math.PI) && m.push(P, z, W);
      }
    this.setIndex(m), this.setAttribute("position", new al(A, 3)), this.setAttribute("normal", new al(C, 3)), this.setAttribute("uv", new al(O, 2));
  }
  copy(t) {
    return super.copy(t), this.parameters = Object.assign({}, t.parameters), this;
  }
  /**
   * Factory method for creating an instance of this class from the given
   * JSON object.
   *
   * @param {Object} data - A JSON object representing the serialized geometry.
   * @return {SphereGeometry} A new instance.
   */
  static fromJSON(t) {
    return new Xpe(t.radius, t.widthSegments, t.heightSegments, t.phiStart, t.phiLength, t.thetaStart, t.thetaLength);
  }
}
class qU extends Vl {
  /**
   * Constructs a new torus geometry.
   *
   * @param {number} [radius=1] - Radius of the torus, from the center of the torus to the center of the tube.
   * @param {number} [tube=0.4] - Radius of the tube. Must be smaller than `radius`.
   * @param {number} [radialSegments=12] - The number of radial segments.
   * @param {number} [tubularSegments=48] - The number of tubular segments.
   * @param {number} [arc=Math.PI*2] - Central angle in radians.
   */
  constructor(t = 1, i = 0.4, n = 12, s = 48, o = Math.PI * 2) {
    super(), this.type = "TorusGeometry", this.parameters = {
      radius: t,
      tube: i,
      radialSegments: n,
      tubularSegments: s,
      arc: o
    }, n = Math.floor(n), s = Math.floor(s);
    const r = [], l = [], c = [], h = [], I = new Ge(), p = new Ge(), y = new Ge();
    for (let m = 0; m <= n; m++)
      for (let A = 0; A <= s; A++) {
        const C = A / s * o, O = m / n * Math.PI * 2;
        p.x = (t + i * Math.cos(O)) * Math.cos(C), p.y = (t + i * Math.cos(O)) * Math.sin(C), p.z = i * Math.sin(O), l.push(p.x, p.y, p.z), I.x = t * Math.cos(C), I.y = t * Math.sin(C), y.subVectors(p, I).normalize(), c.push(y.x, y.y, y.z), h.push(A / s), h.push(m / n);
      }
    for (let m = 1; m <= n; m++)
      for (let A = 1; A <= s; A++) {
        const C = (s + 1) * m + A - 1, O = (s + 1) * (m - 1) + A - 1, R = (s + 1) * (m - 1) + A, F = (s + 1) * m + A;
        r.push(C, O, F), r.push(O, R, F);
      }
    this.setIndex(r), this.setAttribute("position", new al(l, 3)), this.setAttribute("normal", new al(c, 3)), this.setAttribute("uv", new al(h, 2));
  }
  copy(t) {
    return super.copy(t), this.parameters = Object.assign({}, t.parameters), this;
  }
  /**
   * Factory method for creating an instance of this class from the given
   * JSON object.
   *
   * @param {Object} data - A JSON object representing the serialized geometry.
   * @return {TorusGeometry} A new instance.
   */
  static fromJSON(t) {
    return new qU(t.radius, t.tube, t.radialSegments, t.tubularSegments, t.arc);
  }
}
class TUe extends Vl {
  /**
   * Constructs a new wireframe geometry.
   *
   * @param {?BufferGeometry} [geometry=null] - The geometry.
   */
  constructor(t = null) {
    if (super(), this.type = "WireframeGeometry", this.parameters = {
      geometry: t
    }, t !== null) {
      const i = [], n = /* @__PURE__ */ new Set(), s = new Ge(), o = new Ge();
      if (t.index !== null) {
        const r = t.attributes.position, l = t.index;
        let c = t.groups;
        c.length === 0 && (c = [{ start: 0, count: l.count, materialIndex: 0 }]);
        for (let h = 0, I = c.length; h < I; ++h) {
          const p = c[h], y = p.start, m = p.count;
          for (let A = y, C = y + m; A < C; A += 3)
            for (let O = 0; O < 3; O++) {
              const R = l.getX(A + O), F = l.getX(A + (O + 1) % 3);
              s.fromBufferAttribute(r, R), o.fromBufferAttribute(r, F), mge(s, o, n) === !0 && (i.push(s.x, s.y, s.z), i.push(o.x, o.y, o.z));
            }
        }
      } else {
        const r = t.attributes.position;
        for (let l = 0, c = r.count / 3; l < c; l++)
          for (let h = 0; h < 3; h++) {
            const I = 3 * l + h, p = 3 * l + (h + 1) % 3;
            s.fromBufferAttribute(r, I), o.fromBufferAttribute(r, p), mge(s, o, n) === !0 && (i.push(s.x, s.y, s.z), i.push(o.x, o.y, o.z));
          }
      }
      this.setAttribute("position", new al(i, 3));
    }
  }
  copy(t) {
    return super.copy(t), this.parameters = Object.assign({}, t.parameters), this;
  }
}
function mge(e, t, i) {
  const n = `${e.x},${e.y},${e.z}-${t.x},${t.y},${t.z}`, s = `${t.x},${t.y},${t.z}-${e.x},${e.y},${e.z}`;
  return i.has(n) === !0 || i.has(s) === !0 ? !1 : (i.add(n), i.add(s), !0);
}
class vAe extends _H {
  /**
   * Constructs a new mesh lambert material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(t) {
    super(), this.isMeshLambertMaterial = !0, this.type = "MeshLambertMaterial", this.color = new Xn(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new Xn(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = fAe, this.normalScale = new us(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.envMapRotation = new UA(), this.combine = Gpe, this.reflectivity = 1, this.refractionRatio = 0.98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(t);
  }
  copy(t) {
    return super.copy(t), this.color.copy(t.color), this.map = t.map, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.emissive.copy(t.emissive), this.emissiveMap = t.emissiveMap, this.emissiveIntensity = t.emissiveIntensity, this.bumpMap = t.bumpMap, this.bumpScale = t.bumpScale, this.normalMap = t.normalMap, this.normalMapType = t.normalMapType, this.normalScale.copy(t.normalScale), this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.specularMap = t.specularMap, this.alphaMap = t.alphaMap, this.envMap = t.envMap, this.envMapRotation.copy(t.envMapRotation), this.combine = t.combine, this.reflectivity = t.reflectivity, this.refractionRatio = t.refractionRatio, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this.flatShading = t.flatShading, this.fog = t.fog, this;
  }
}
class RUe extends _H {
  /**
   * Constructs a new mesh depth material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(t) {
    super(), this.isMeshDepthMaterial = !0, this.type = "MeshDepthMaterial", this.depthPacking = c9e, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.setValues(t);
  }
  copy(t) {
    return super.copy(t), this.depthPacking = t.depthPacking, this.map = t.map, this.alphaMap = t.alphaMap, this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this;
  }
}
class vUe extends _H {
  /**
   * Constructs a new mesh distance material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(t) {
    super(), this.isMeshDistanceMaterial = !0, this.type = "MeshDistanceMaterial", this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.setValues(t);
  }
  copy(t) {
    return super.copy(t), this.map = t.map, this.alphaMap = t.alphaMap, this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this;
  }
}
class AUe extends gie {
  /**
   * Constructs a new line dashed material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(t) {
    super(), this.isLineDashedMaterial = !0, this.type = "LineDashedMaterial", this.scale = 1, this.dashSize = 3, this.gapSize = 1, this.setValues(t);
  }
  copy(t) {
    return super.copy(t), this.scale = t.scale, this.dashSize = t.dashSize, this.gapSize = t.gapSize, this;
  }
}
class AAe extends wu {
  /**
   * Constructs a new light.
   *
   * @param {(number|Color|string)} [color=0xffffff] - The light's color.
   * @param {number} [intensity=1] - The light's strength/intensity.
   */
  constructor(t, i = 1) {
    super(), this.isLight = !0, this.type = "Light", this.color = new Xn(t), this.intensity = i;
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   */
  dispose() {
  }
  copy(t, i) {
    return super.copy(t, i), this.color.copy(t.color), this.intensity = t.intensity, this;
  }
  toJSON(t) {
    const i = super.toJSON(t);
    return i.object.color = this.color.getHex(), i.object.intensity = this.intensity, this.groundColor !== void 0 && (i.object.groundColor = this.groundColor.getHex()), this.distance !== void 0 && (i.object.distance = this.distance), this.angle !== void 0 && (i.object.angle = this.angle), this.decay !== void 0 && (i.object.decay = this.decay), this.penumbra !== void 0 && (i.object.penumbra = this.penumbra), this.shadow !== void 0 && (i.object.shadow = this.shadow.toJSON()), this.target !== void 0 && (i.object.target = this.target.uuid), i;
  }
}
const kde = /* @__PURE__ */ new Ln(), yge = /* @__PURE__ */ new Ge(), Ege = /* @__PURE__ */ new Ge();
class SUe {
  /**
   * Constructs a new light shadow.
   *
   * @param {Camera} camera - The light's view of the world.
   */
  constructor(t) {
    this.camera = t, this.intensity = 1, this.bias = 0, this.normalBias = 0, this.radius = 1, this.blurSamples = 8, this.mapSize = new us(512, 512), this.mapType = PA, this.map = null, this.mapPass = null, this.matrix = new Ln(), this.autoUpdate = !0, this.needsUpdate = !1, this._frustum = new cL(), this._frameExtents = new us(1, 1), this._viewportCount = 1, this._viewports = [
      new Ol(0, 0, 1, 1)
    ];
  }
  /**
   * Used internally by the renderer to get the number of viewports that need
   * to be rendered for this shadow.
   *
   * @return {number} The viewport count.
   */
  getViewportCount() {
    return this._viewportCount;
  }
  /**
   * Gets the shadow cameras frustum. Used internally by the renderer to cull objects.
   *
   * @return {Frustum} The shadow camera frustum.
   */
  getFrustum() {
    return this._frustum;
  }
  /**
   * Update the matrices for the camera and shadow, used internally by the renderer.
   *
   * @param {Light} light - The light for which the shadow is being rendered.
   */
  updateMatrices(t) {
    const i = this.camera, n = this.matrix;
    yge.setFromMatrixPosition(t.matrixWorld), i.position.copy(yge), Ege.setFromMatrixPosition(t.target.matrixWorld), i.lookAt(Ege), i.updateMatrixWorld(), kde.multiplyMatrices(i.projectionMatrix, i.matrixWorldInverse), this._frustum.setFromProjectionMatrix(kde), n.set(
      0.5,
      0,
      0,
      0.5,
      0,
      0.5,
      0,
      0.5,
      0,
      0,
      0.5,
      0.5,
      0,
      0,
      0,
      1
    ), n.multiply(kde);
  }
  /**
   * Returns a viewport definition for the given viewport index.
   *
   * @param {number} viewportIndex - The viewport index.
   * @return {Vector4} The viewport.
   */
  getViewport(t) {
    return this._viewports[t];
  }
  /**
   * Returns the frame extends.
   *
   * @return {Vector2} The frame extends.
   */
  getFrameExtents() {
    return this._frameExtents;
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   */
  dispose() {
    this.map && this.map.dispose(), this.mapPass && this.mapPass.dispose();
  }
  /**
   * Copies the values of the given light shadow instance to this instance.
   *
   * @param {LightShadow} source - The light shadow to copy.
   * @return {LightShadow} A reference to this light shadow instance.
   */
  copy(t) {
    return this.camera = t.camera.clone(), this.intensity = t.intensity, this.bias = t.bias, this.radius = t.radius, this.autoUpdate = t.autoUpdate, this.needsUpdate = t.needsUpdate, this.normalBias = t.normalBias, this.blurSamples = t.blurSamples, this.mapSize.copy(t.mapSize), this;
  }
  /**
   * Returns a new light shadow instance with copied values from this instance.
   *
   * @return {LightShadow} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Serializes the light shadow into JSON.
   *
   * @return {Object} A JSON object representing the serialized light shadow.
   * @see {@link ObjectLoader#parse}
   */
  toJSON() {
    const t = {};
    return this.intensity !== 1 && (t.intensity = this.intensity), this.bias !== 0 && (t.bias = this.bias), this.normalBias !== 0 && (t.normalBias = this.normalBias), this.radius !== 1 && (t.radius = this.radius), (this.mapSize.x !== 512 || this.mapSize.y !== 512) && (t.mapSize = this.mapSize.toArray()), t.camera = this.camera.toJSON(!1).object, delete t.camera.matrix, t;
  }
}
class eY extends Qpe {
  /**
   * Constructs a new orthographic camera.
   *
   * @param {number} [left=-1] - The left plane of the camera's frustum.
   * @param {number} [right=1] - The right plane of the camera's frustum.
   * @param {number} [top=1] - The top plane of the camera's frustum.
   * @param {number} [bottom=-1] - The bottom plane of the camera's frustum.
   * @param {number} [near=0.1] - The camera's near plane.
   * @param {number} [far=2000] - The camera's far plane.
   */
  constructor(t = -1, i = 1, n = 1, s = -1, o = 0.1, r = 2e3) {
    super(), this.isOrthographicCamera = !0, this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = t, this.right = i, this.top = n, this.bottom = s, this.near = o, this.far = r, this.updateProjectionMatrix();
  }
  copy(t, i) {
    return super.copy(t, i), this.left = t.left, this.right = t.right, this.top = t.top, this.bottom = t.bottom, this.near = t.near, this.far = t.far, this.zoom = t.zoom, this.view = t.view === null ? null : Object.assign({}, t.view), this;
  }
  /**
   * Sets an offset in a larger frustum. This is useful for multi-window or
   * multi-monitor/multi-machine setups.
   *
   * @param {number} fullWidth - The full width of multiview setup.
   * @param {number} fullHeight - The full height of multiview setup.
   * @param {number} x - The horizontal offset of the subcamera.
   * @param {number} y - The vertical offset of the subcamera.
   * @param {number} width - The width of subcamera.
   * @param {number} height - The height of subcamera.
   * @see {@link PerspectiveCamera#setViewOffset}
   */
  setViewOffset(t, i, n, s, o, r) {
    this.view === null && (this.view = {
      enabled: !0,
      fullWidth: 1,
      fullHeight: 1,
      offsetX: 0,
      offsetY: 0,
      width: 1,
      height: 1
    }), this.view.enabled = !0, this.view.fullWidth = t, this.view.fullHeight = i, this.view.offsetX = n, this.view.offsetY = s, this.view.width = o, this.view.height = r, this.updateProjectionMatrix();
  }
  /**
   * Removes the view offset from the projection matrix.
   */
  clearViewOffset() {
    this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
  }
  /**
   * Updates the camera's projection matrix. Must be called after any change of
   * camera properties.
   */
  updateProjectionMatrix() {
    const t = (this.right - this.left) / (2 * this.zoom), i = (this.top - this.bottom) / (2 * this.zoom), n = (this.right + this.left) / 2, s = (this.top + this.bottom) / 2;
    let o = n - t, r = n + t, l = s + i, c = s - i;
    if (this.view !== null && this.view.enabled) {
      const h = (this.right - this.left) / this.view.fullWidth / this.zoom, I = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
      o += h * this.view.offsetX, r = o + h * this.view.width, l -= I * this.view.offsetY, c = l - I * this.view.height;
    }
    this.projectionMatrix.makeOrthographic(o, r, l, c, this.near, this.far, this.coordinateSystem), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(t) {
    const i = super.toJSON(t);
    return i.object.zoom = this.zoom, i.object.left = this.left, i.object.right = this.right, i.object.top = this.top, i.object.bottom = this.bottom, i.object.near = this.near, i.object.far = this.far, this.view !== null && (i.object.view = Object.assign({}, this.view)), i;
  }
}
class bUe extends SUe {
  /**
   * Constructs a new directional light shadow.
   */
  constructor() {
    super(new eY(-5, 5, 5, -5, 0.5, 500)), this.isDirectionalLightShadow = !0;
  }
}
class NUe extends AAe {
  /**
   * Constructs a new directional light.
   *
   * @param {(number|Color|string)} [color=0xffffff] - The light's color.
   * @param {number} [intensity=1] - The light's strength/intensity.
   */
  constructor(t, i) {
    super(t, i), this.isDirectionalLight = !0, this.type = "DirectionalLight", this.position.copy(wu.DEFAULT_UP), this.updateMatrix(), this.target = new wu(), this.shadow = new bUe();
  }
  dispose() {
    this.shadow.dispose();
  }
  copy(t) {
    return super.copy(t), this.target = t.target.clone(), this.shadow = t.shadow.clone(), this;
  }
}
class DUe extends AAe {
  /**
   * Constructs a new ambient light.
   *
   * @param {(number|Color|string)} [color=0xffffff] - The light's color.
   * @param {number} [intensity=1] - The light's strength/intensity.
   */
  constructor(t, i) {
    super(t, i), this.isAmbientLight = !0, this.type = "AmbientLight";
  }
}
class SAe extends Vl {
  /**
   * Constructs a new instanced buffer geometry.
   */
  constructor() {
    super(), this.isInstancedBufferGeometry = !0, this.type = "InstancedBufferGeometry", this.instanceCount = 1 / 0;
  }
  copy(t) {
    return super.copy(t), this.instanceCount = t.instanceCount, this;
  }
  toJSON() {
    const t = super.toJSON();
    return t.instanceCount = this.instanceCount, t.isInstancedBufferGeometry = !0, t;
  }
}
class CUe extends Tg {
  /**
   * Constructs a new array camera.
   *
   * @param {Array<PerspectiveCamera>} [array=[]] - An array of perspective sub cameras.
   */
  constructor(t = []) {
    super(), this.isArrayCamera = !0, this.isMultiViewCamera = !1, this.cameras = t;
  }
}
class OUe {
  /**
   * Constructs a new clock.
   *
   * @param {boolean} [autoStart=true] - Whether to automatically start the clock when
   * `getDelta()` is called for the first time.
   */
  constructor(t = !0) {
    this.autoStart = t, this.startTime = 0, this.oldTime = 0, this.elapsedTime = 0, this.running = !1;
  }
  /**
   * Starts the clock. When `autoStart` is set to `true`, the method is automatically
   * called by the class.
   */
  start() {
    this.startTime = performance.now(), this.oldTime = this.startTime, this.elapsedTime = 0, this.running = !0;
  }
  /**
   * Stops the clock.
   */
  stop() {
    this.getElapsedTime(), this.running = !1, this.autoStart = !1;
  }
  /**
   * Returns the elapsed time in seconds.
   *
   * @return {number} The elapsed time.
   */
  getElapsedTime() {
    return this.getDelta(), this.elapsedTime;
  }
  /**
   * Returns the delta time in seconds.
   *
   * @return {number} The delta time.
   */
  getDelta() {
    let t = 0;
    if (this.autoStart && !this.running)
      return this.start(), 0;
    if (this.running) {
      const i = performance.now();
      t = (i - this.oldTime) / 1e3, this.oldTime = i, this.elapsedTime += t;
    }
    return t;
  }
}
class gle extends hUe {
  /**
   * Constructs a new instanced interleaved buffer.
   *
   * @param {TypedArray} array - A typed array with a shared buffer storing attribute data.
   * @param {number} stride - The number of typed-array elements per vertex.
   * @param {number} [meshPerAttribute=1] - Defines how often a value of this interleaved buffer should be repeated.
   */
  constructor(t, i, n = 1) {
    super(t, i), this.isInstancedInterleavedBuffer = !0, this.meshPerAttribute = n;
  }
  copy(t) {
    return super.copy(t), this.meshPerAttribute = t.meshPerAttribute, this;
  }
  clone(t) {
    const i = super.clone(t);
    return i.meshPerAttribute = this.meshPerAttribute, i;
  }
  toJSON(t) {
    const i = super.toJSON(t);
    return i.isInstancedInterleavedBuffer = !0, i.meshPerAttribute = this.meshPerAttribute, i;
  }
}
const gge = /* @__PURE__ */ new Ln();
class Aae {
  /**
   * Constructs a new raycaster.
   *
   * @param {Vector3} origin - The origin vector where the ray casts from.
   * @param {Vector3} direction - The (normalized) direction vector that gives direction to the ray.
   * @param {number} [near=0] - All results returned are further away than near. Near can't be negative.
   * @param {number} [far=Infinity] - All results returned are closer than far. Far can't be lower than near.
   */
  constructor(t, i, n = 0, s = 1 / 0) {
    this.ray = new MA(t, i), this.near = n, this.far = s, this.camera = null, this.layers = new Zpe(), this.params = {
      Mesh: {},
      Line: { threshold: 1 },
      LOD: {},
      Points: { threshold: 1 },
      Sprite: {}
    };
  }
  /**
   * Updates the ray with a new origin and direction by copying the values from the arguments.
   *
   * @param {Vector3} origin - The origin vector where the ray casts from.
   * @param {Vector3} direction - The (normalized) direction vector that gives direction to the ray.
   */
  set(t, i) {
    this.ray.set(t, i);
  }
  /**
   * Uses the given coordinates and camera to compute a new origin and direction for the internal ray.
   *
   * @param {Vector2} coords - 2D coordinates of the mouse, in normalized device coordinates (NDC).
   * X and Y components should be between `-1` and `1`.
   * @param {Camera} camera - The camera from which the ray should originate.
   */
  setFromCamera(t, i) {
    i.isPerspectiveCamera ? (this.ray.origin.setFromMatrixPosition(i.matrixWorld), this.ray.direction.set(t.x, t.y, 0.5).unproject(i).sub(this.ray.origin).normalize(), this.camera = i) : i.isOrthographicCamera ? (this.ray.origin.set(t.x, t.y, (i.near + i.far) / (i.near - i.far)).unproject(i), this.ray.direction.set(0, 0, -1).transformDirection(i.matrixWorld), this.camera = i) : console.error("THREE.Raycaster: Unsupported camera type: " + i.type);
  }
  /**
   * Uses the given WebXR controller to compute a new origin and direction for the internal ray.
   *
   * @param {WebXRController} controller - The controller to copy the position and direction from.
   * @return {Raycaster} A reference to this raycaster.
   */
  setFromXRController(t) {
    return gge.identity().extractRotation(t.matrixWorld), this.ray.origin.setFromMatrixPosition(t.matrixWorld), this.ray.direction.set(0, 0, -1).applyMatrix4(gge), this;
  }
  /**
   * The intersection point of a raycaster intersection test.
   * @typedef {Object} Raycaster~Intersection
   * @property {number} distance - The distance from the ray's origin to the intersection point.
   * @property {number} distanceToRay -  Some 3D objects e.g. {@link Points} provide the distance of the
   * intersection to the nearest point on the ray. For other objects it will be `undefined`.
   * @property {Vector3} point - The intersection point, in world coordinates.
   * @property {Object} face - The face that has been intersected.
   * @property {number} faceIndex - The face index.
   * @property {Object3D} object - The 3D object that has been intersected.
   * @property {Vector2} uv - U,V coordinates at point of intersection.
   * @property {Vector2} uv1 - Second set of U,V coordinates at point of intersection.
   * @property {Vector3} uv1 - Interpolated normal vector at point of intersection.
   * @property {number} instanceId - The index number of the instance where the ray
   * intersects the {@link InstancedMesh}.
   */
  /**
   * Checks all intersection between the ray and the object with or without the
   * descendants. Intersections are returned sorted by distance, closest first.
   *
   * `Raycaster` delegates to the `raycast()` method of the passed 3D object, when
   * evaluating whether the ray intersects the object or not. This allows meshes to respond
   * differently to ray casting than lines or points.
   *
   * Note that for meshes, faces must be pointed towards the origin of the ray in order
   * to be detected; intersections of the ray passing through the back of a face will not
   * be detected. To raycast against both faces of an object, you'll want to set  {@link Material#side}
   * to `THREE.DoubleSide`.
   *
   * @param {Object3D} object - The 3D object to check for intersection with the ray.
   * @param {boolean} [recursive=true] - If set to `true`, it also checks all descendants.
   * Otherwise it only checks intersection with the object.
   * @param {Array<Raycaster~Intersection>} [intersects=[]] The target array that holds the result of the method.
   * @return {Array<Raycaster~Intersection>} An array holding the intersection points.
   */
  intersectObject(t, i = !0, n = []) {
    return $1e(t, this, n, i), n.sort(wge), n;
  }
  /**
   * Checks all intersection between the ray and the objects with or without
   * the descendants. Intersections are returned sorted by distance, closest first.
   *
   * @param {Array<Object3D>} objects - The 3D objects to check for intersection with the ray.
   * @param {boolean} [recursive=true] - If set to `true`, it also checks all descendants.
   * Otherwise it only checks intersection with the object.
   * @param {Array<Raycaster~Intersection>} [intersects=[]] The target array that holds the result of the method.
   * @return {Array<Raycaster~Intersection>} An array holding the intersection points.
   */
  intersectObjects(t, i = !0, n = []) {
    for (let s = 0, o = t.length; s < o; s++)
      $1e(t[s], this, n, i);
    return n.sort(wge), n;
  }
}
function wge(e, t) {
  return e.distance - t.distance;
}
function $1e(e, t, i, n) {
  let s = !0;
  if (e.layers.test(t.layers) && e.raycast(t, i) === !1 && (s = !1), s === !0 && n === !0) {
    const o = e.children;
    for (let r = 0, l = o.length; r < l; r++)
      $1e(o[r], t, i, !0);
  }
}
class LUe {
  /**
   * Constructs a new spherical.
   *
   * @param {number} [radius=1] - The radius, or the Euclidean distance (straight-line distance) from the point to the origin.
   * @param {number} [phi=0] - The polar angle in radians from the y (up) axis.
   * @param {number} [theta=0] - The equator/azimuthal angle in radians around the y (up) axis.
   */
  constructor(t = 1, i = 0, n = 0) {
    this.radius = t, this.phi = i, this.theta = n;
  }
  /**
   * Sets the spherical components by copying the given values.
   *
   * @param {number} radius - The radius.
   * @param {number} phi - The polar angle.
   * @param {number} theta - The azimuthal angle.
   * @return {Spherical} A reference to this spherical.
   */
  set(t, i, n) {
    return this.radius = t, this.phi = i, this.theta = n, this;
  }
  /**
   * Copies the values of the given spherical to this instance.
   *
   * @param {Spherical} other - The spherical to copy.
   * @return {Spherical} A reference to this spherical.
   */
  copy(t) {
    return this.radius = t.radius, this.phi = t.phi, this.theta = t.theta, this;
  }
  /**
   * Restricts the polar angle [page:.phi phi] to be between `0.000001` and pi -
   * `0.000001`.
   *
   * @return {Spherical} A reference to this spherical.
   */
  makeSafe() {
    return this.phi = Ho(this.phi, 1e-6, Math.PI - 1e-6), this;
  }
  /**
   * Sets the spherical components from the given vector which is assumed to hold
   * Cartesian coordinates.
   *
   * @param {Vector3} v - The vector to set.
   * @return {Spherical} A reference to this spherical.
   */
  setFromVector3(t) {
    return this.setFromCartesianCoords(t.x, t.y, t.z);
  }
  /**
   * Sets the spherical components from the given Cartesian coordinates.
   *
   * @param {number} x - The x value.
   * @param {number} y - The x value.
   * @param {number} z - The x value.
   * @return {Spherical} A reference to this spherical.
   */
  setFromCartesianCoords(t, i, n) {
    return this.radius = Math.sqrt(t * t + i * i + n * n), this.radius === 0 ? (this.theta = 0, this.phi = 0) : (this.theta = Math.atan2(t, n), this.phi = Math.acos(Ho(i / this.radius, -1, 1))), this;
  }
  /**
   * Returns a new spherical with copied values from this instance.
   *
   * @return {Spherical} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
}
const Tge = /* @__PURE__ */ new Ge(), qne = /* @__PURE__ */ new Ge();
class gc {
  /**
   * Constructs a new line segment.
   *
   * @param {Vector3} [start=(0,0,0)] - Start of the line segment.
   * @param {Vector3} [end=(0,0,0)] - End of the line segment.
   */
  constructor(t = new Ge(), i = new Ge()) {
    this.start = t, this.end = i;
  }
  /**
   * Sets the start and end values by copying the given vectors.
   *
   * @param {Vector3} start - The start point.
   * @param {Vector3} end - The end point.
   * @return {Line3} A reference to this line segment.
   */
  set(t, i) {
    return this.start.copy(t), this.end.copy(i), this;
  }
  /**
   * Copies the values of the given line segment to this instance.
   *
   * @param {Line3} line - The line segment to copy.
   * @return {Line3} A reference to this line segment.
   */
  copy(t) {
    return this.start.copy(t.start), this.end.copy(t.end), this;
  }
  /**
   * Returns the center of the line segment.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The center point.
   */
  getCenter(t) {
    return t.addVectors(this.start, this.end).multiplyScalar(0.5);
  }
  /**
   * Returns the delta vector of the line segment's start and end point.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The delta vector.
   */
  delta(t) {
    return t.subVectors(this.end, this.start);
  }
  /**
   * Returns the squared Euclidean distance between the line' start and end point.
   *
   * @return {number} The squared Euclidean distance.
   */
  distanceSq() {
    return this.start.distanceToSquared(this.end);
  }
  /**
   * Returns the Euclidean distance between the line' start and end point.
   *
   * @return {number} The Euclidean distance.
   */
  distance() {
    return this.start.distanceTo(this.end);
  }
  /**
   * Returns a vector at a certain position along the line segment.
   *
   * @param {number} t - A value between `[0,1]` to represent a position along the line segment.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The delta vector.
   */
  at(t, i) {
    return this.delta(i).multiplyScalar(t).add(this.start);
  }
  /**
   * Returns a point parameter based on the closest point as projected on the line segment.
   *
   * @param {Vector3} point - The point for which to return a point parameter.
   * @param {boolean} clampToLine - Whether to clamp the result to the range `[0,1]` or not.
   * @return {number} The point parameter.
   */
  closestPointToPointParameter(t, i) {
    Tge.subVectors(t, this.start), qne.subVectors(this.end, this.start);
    const n = qne.dot(qne);
    let o = qne.dot(Tge) / n;
    return i && (o = Ho(o, 0, 1)), o;
  }
  /**
   * Returns the closets point on the line for a given point.
   *
   * @param {Vector3} point - The point to compute the closest point on the line for.
   * @param {boolean} clampToLine - Whether to clamp the result to the range `[0,1]` or not.
   * @param {Vector3} target -  The target vector that is used to store the method's result.
   * @return {Vector3} The closest point on the line.
   */
  closestPointToPoint(t, i, n) {
    const s = this.closestPointToPointParameter(t, i);
    return this.delta(n).multiplyScalar(s).add(this.start);
  }
  /**
   * Applies a 4x4 transformation matrix to this line segment.
   *
   * @param {Matrix4} matrix - The transformation matrix.
   * @return {Line3} A reference to this line segment.
   */
  applyMatrix4(t) {
    return this.start.applyMatrix4(t), this.end.applyMatrix4(t), this;
  }
  /**
   * Returns `true` if this line segment is equal with the given one.
   *
   * @param {Line3} line - The line segment to test for equality.
   * @return {boolean} Whether this line segment is equal with the given one.
   */
  equals(t) {
    return t.start.equals(this.start) && t.end.equals(this.end);
  }
  /**
   * Returns a new line segment with copied values from this instance.
   *
   * @return {Line3} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
}
const $ne = /* @__PURE__ */ new Ge(), Kd = /* @__PURE__ */ new Qpe();
class _Ue extends gUe {
  /**
   * Constructs a new arrow helper.
   *
   * @param {Camera} camera - The camera to visualize.
   */
  constructor(t) {
    const i = new Vl(), n = new gie({ color: 16777215, vertexColors: !0, toneMapped: !1 }), s = [], o = [], r = {};
    l("n1", "n2"), l("n2", "n4"), l("n4", "n3"), l("n3", "n1"), l("f1", "f2"), l("f2", "f4"), l("f4", "f3"), l("f3", "f1"), l("n1", "f1"), l("n2", "f2"), l("n3", "f3"), l("n4", "f4"), l("p", "n1"), l("p", "n2"), l("p", "n3"), l("p", "n4"), l("u1", "u2"), l("u2", "u3"), l("u3", "u1"), l("c", "t"), l("p", "c"), l("cn1", "cn2"), l("cn3", "cn4"), l("cf1", "cf2"), l("cf3", "cf4");
    function l(A, C) {
      c(A), c(C);
    }
    function c(A) {
      s.push(0, 0, 0), o.push(0, 0, 0), r[A] === void 0 && (r[A] = []), r[A].push(s.length / 3 - 1);
    }
    i.setAttribute("position", new al(s, 3)), i.setAttribute("color", new al(o, 3)), super(i, n), this.type = "CameraHelper", this.camera = t, this.camera.updateProjectionMatrix && this.camera.updateProjectionMatrix(), this.matrix = t.matrixWorld, this.matrixAutoUpdate = !1, this.pointMap = r, this.update();
    const h = new Xn(16755200), I = new Xn(16711680), p = new Xn(43775), y = new Xn(16777215), m = new Xn(3355443);
    this.setColors(h, I, p, y, m);
  }
  /**
   * Defines the colors of the helper.
   *
   * @param {Color} frustum - The frustum line color.
   * @param {Color} cone - The cone line color.
   * @param {Color} up - The up line color.
   * @param {Color} target - The target line color.
   * @param {Color} cross - The cross line color.
   */
  setColors(t, i, n, s, o) {
    const l = this.geometry.getAttribute("color");
    l.setXYZ(0, t.r, t.g, t.b), l.setXYZ(1, t.r, t.g, t.b), l.setXYZ(2, t.r, t.g, t.b), l.setXYZ(3, t.r, t.g, t.b), l.setXYZ(4, t.r, t.g, t.b), l.setXYZ(5, t.r, t.g, t.b), l.setXYZ(6, t.r, t.g, t.b), l.setXYZ(7, t.r, t.g, t.b), l.setXYZ(8, t.r, t.g, t.b), l.setXYZ(9, t.r, t.g, t.b), l.setXYZ(10, t.r, t.g, t.b), l.setXYZ(11, t.r, t.g, t.b), l.setXYZ(12, t.r, t.g, t.b), l.setXYZ(13, t.r, t.g, t.b), l.setXYZ(14, t.r, t.g, t.b), l.setXYZ(15, t.r, t.g, t.b), l.setXYZ(16, t.r, t.g, t.b), l.setXYZ(17, t.r, t.g, t.b), l.setXYZ(18, t.r, t.g, t.b), l.setXYZ(19, t.r, t.g, t.b), l.setXYZ(20, t.r, t.g, t.b), l.setXYZ(21, t.r, t.g, t.b), l.setXYZ(22, t.r, t.g, t.b), l.setXYZ(23, t.r, t.g, t.b), l.setXYZ(24, i.r, i.g, i.b), l.setXYZ(25, i.r, i.g, i.b), l.setXYZ(26, i.r, i.g, i.b), l.setXYZ(27, i.r, i.g, i.b), l.setXYZ(28, i.r, i.g, i.b), l.setXYZ(29, i.r, i.g, i.b), l.setXYZ(30, i.r, i.g, i.b), l.setXYZ(31, i.r, i.g, i.b), l.setXYZ(32, n.r, n.g, n.b), l.setXYZ(33, n.r, n.g, n.b), l.setXYZ(34, n.r, n.g, n.b), l.setXYZ(35, n.r, n.g, n.b), l.setXYZ(36, n.r, n.g, n.b), l.setXYZ(37, n.r, n.g, n.b), l.setXYZ(38, s.r, s.g, s.b), l.setXYZ(39, s.r, s.g, s.b), l.setXYZ(40, o.r, o.g, o.b), l.setXYZ(41, o.r, o.g, o.b), l.setXYZ(42, o.r, o.g, o.b), l.setXYZ(43, o.r, o.g, o.b), l.setXYZ(44, o.r, o.g, o.b), l.setXYZ(45, o.r, o.g, o.b), l.setXYZ(46, o.r, o.g, o.b), l.setXYZ(47, o.r, o.g, o.b), l.setXYZ(48, o.r, o.g, o.b), l.setXYZ(49, o.r, o.g, o.b), l.needsUpdate = !0;
  }
  /**
   * Updates the helper based on the projection matrix of the camera.
   */
  update() {
    const t = this.geometry, i = this.pointMap, n = 1, s = 1;
    Kd.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
    const o = this.camera.coordinateSystem === hN ? -1 : 0;
    Jc("c", i, t, Kd, 0, 0, o), Jc("t", i, t, Kd, 0, 0, 1), Jc("n1", i, t, Kd, -n, -s, o), Jc("n2", i, t, Kd, n, -s, o), Jc("n3", i, t, Kd, -n, s, o), Jc("n4", i, t, Kd, n, s, o), Jc("f1", i, t, Kd, -n, -s, 1), Jc("f2", i, t, Kd, n, -s, 1), Jc("f3", i, t, Kd, -n, s, 1), Jc("f4", i, t, Kd, n, s, 1), Jc("u1", i, t, Kd, n * 0.7, s * 1.1, o), Jc("u2", i, t, Kd, -n * 0.7, s * 1.1, o), Jc("u3", i, t, Kd, 0, s * 2, o), Jc("cf1", i, t, Kd, -n, 0, 1), Jc("cf2", i, t, Kd, n, 0, 1), Jc("cf3", i, t, Kd, 0, -s, 1), Jc("cf4", i, t, Kd, 0, s, 1), Jc("cn1", i, t, Kd, -n, 0, o), Jc("cn2", i, t, Kd, n, 0, o), Jc("cn3", i, t, Kd, 0, -s, o), Jc("cn4", i, t, Kd, 0, s, o), t.getAttribute("position").needsUpdate = !0;
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   */
  dispose() {
    this.geometry.dispose(), this.material.dispose();
  }
}
function Jc(e, t, i, n, s, o, r) {
  $ne.set(s, o, r).unproject(n);
  const l = t[e];
  if (l !== void 0) {
    const c = i.getAttribute("position");
    for (let h = 0, I = l.length; h < I; h++)
      c.setXYZ(l[h], $ne.x, $ne.y, $ne.z);
  }
}
class Rge extends fv {
  /**
   * Constructs a new plane helper.
   *
   * @param {Plane} plane - The plane to be visualized.
   * @param {number} [size=1] - The side length of plane helper.
   * @param {number|Color|string} [hex=0xffff00] - The helper's color.
   */
  constructor(t, i = 1, n = 16776960) {
    const s = n, o = [1, -1, 0, -1, 1, 0, -1, -1, 0, 1, 1, 0, -1, 1, 0, -1, -1, 0, 1, -1, 0, 1, 1, 0], r = new Vl();
    r.setAttribute("position", new al(o, 3)), r.computeBoundingSphere(), super(r, new gie({ color: s, toneMapped: !1 })), this.type = "PlaneHelper", this.plane = t, this.size = i;
    const l = [1, 1, 0, -1, 1, 0, -1, -1, 0, 1, 1, 0, -1, -1, 0, 1, -1, 0], c = new Vl();
    c.setAttribute("position", new al(l, 3)), c.computeBoundingSphere(), this.add(new En(c, new U8({ color: s, opacity: 0.2, transparent: !0, depthWrite: !1, toneMapped: !1 })));
  }
  updateMatrixWorld(t) {
    this.position.set(0, 0, 0), this.scale.set(0.5 * this.size, 0.5 * this.size, 1), this.lookAt(this.plane.normal), this.translateZ(-this.plane.constant), super.updateMatrixWorld(t);
  }
  /**
   * Updates the helper to match the position and direction of the
   * light being visualized.
   */
  dispose() {
    this.geometry.dispose(), this.material.dispose(), this.children[0].geometry.dispose(), this.children[0].material.dispose();
  }
}
class xUe extends LH {
  /**
   * Constructs a new controls instance.
   *
   * @param {Object3D} object - The object that is managed by the controls.
   * @param {?HTMLDOMElement} domElement - The HTML element used for event listeners.
   */
  constructor(t, i = null) {
    super(), this.object = t, this.domElement = i, this.enabled = !0, this.state = -1, this.keys = {}, this.mouseButtons = { LEFT: null, MIDDLE: null, RIGHT: null }, this.touches = { ONE: null, TWO: null };
  }
  /**
   * Connects the controls to the DOM. This method has so called "side effects" since
   * it adds the module's event listeners to the DOM.
   *
   * @param {HTMLDOMElement} element - The DOM element to connect to.
   */
  connect(t) {
    if (t === void 0) {
      console.warn("THREE.Controls: connect() now requires an element.");
      return;
    }
    this.domElement !== null && this.disconnect(), this.domElement = t;
  }
  /**
   * Disconnects the controls from the DOM.
   */
  disconnect() {
  }
  /**
   * Call this method if you no longer want use to the controls. It frees all internal
   * resources and removes all event listeners.
   */
  dispose() {
  }
  /**
   * Controls should implement this method if they have to update their internal state
   * per simulation step.
   *
   * @param {number} [delta] - The time delta in seconds.
   */
  update() {
  }
}
function vge(e, t, i, n) {
  const s = PUe(n);
  switch (i) {
    // https://registry.khronos.org/OpenGL-Refpages/es3.0/html/glTexImage2D.xhtml
    case uAe:
      return e * t;
    case jpe:
      return e * t / s.components * s.byteLength;
    case Wpe:
      return e * t / s.components * s.byteLength;
    case cAe:
      return e * t * 2 / s.components * s.byteLength;
    case Ype:
      return e * t * 2 / s.components * s.byteLength;
    case dAe:
      return e * t * 3 / s.components * s.byteLength;
    case y5:
      return e * t * 4 / s.components * s.byteLength;
    case qpe:
      return e * t * 4 / s.components * s.byteLength;
    // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_s3tc_srgb/
    case Uoe:
    case Boe:
      return Math.floor((e + 3) / 4) * Math.floor((t + 3) / 4) * 8;
    case Foe:
    case Hoe:
      return Math.floor((e + 3) / 4) * Math.floor((t + 3) / 4) * 16;
    // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_pvrtc/
    case g1e:
    case T1e:
      return Math.max(e, 16) * Math.max(t, 8) / 4;
    case E1e:
    case w1e:
      return Math.max(e, 8) * Math.max(t, 8) / 2;
    // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_etc/
    case R1e:
    case v1e:
      return Math.floor((e + 3) / 4) * Math.floor((t + 3) / 4) * 8;
    case A1e:
      return Math.floor((e + 3) / 4) * Math.floor((t + 3) / 4) * 16;
    // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_astc/
    case S1e:
      return Math.floor((e + 3) / 4) * Math.floor((t + 3) / 4) * 16;
    case b1e:
      return Math.floor((e + 4) / 5) * Math.floor((t + 3) / 4) * 16;
    case N1e:
      return Math.floor((e + 4) / 5) * Math.floor((t + 4) / 5) * 16;
    case D1e:
      return Math.floor((e + 5) / 6) * Math.floor((t + 4) / 5) * 16;
    case C1e:
      return Math.floor((e + 5) / 6) * Math.floor((t + 5) / 6) * 16;
    case O1e:
      return Math.floor((e + 7) / 8) * Math.floor((t + 4) / 5) * 16;
    case L1e:
      return Math.floor((e + 7) / 8) * Math.floor((t + 5) / 6) * 16;
    case _1e:
      return Math.floor((e + 7) / 8) * Math.floor((t + 7) / 8) * 16;
    case x1e:
      return Math.floor((e + 9) / 10) * Math.floor((t + 4) / 5) * 16;
    case P1e:
      return Math.floor((e + 9) / 10) * Math.floor((t + 5) / 6) * 16;
    case M1e:
      return Math.floor((e + 9) / 10) * Math.floor((t + 7) / 8) * 16;
    case U1e:
      return Math.floor((e + 9) / 10) * Math.floor((t + 9) / 10) * 16;
    case B1e:
      return Math.floor((e + 11) / 12) * Math.floor((t + 9) / 10) * 16;
    case F1e:
      return Math.floor((e + 11) / 12) * Math.floor((t + 11) / 12) * 16;
    // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_bptc/
    case Goe:
    case H1e:
    case G1e:
      return Math.ceil(e / 4) * Math.ceil(t / 4) * 16;
    // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_rgtc/
    case hAe:
    case k1e:
      return Math.ceil(e / 4) * Math.ceil(t / 4) * 8;
    case V1e:
    case z1e:
      return Math.ceil(e / 4) * Math.ceil(t / 4) * 16;
  }
  throw new Error(
    `Unable to determine texture byte length for ${i} format.`
  );
}
function PUe(e) {
  switch (e) {
    case PA:
    case rAe:
      return { byteLength: 1, components: 1 };
    case fX:
    case lAe:
    case yie:
      return { byteLength: 2, components: 1 };
    case Vpe:
    case zpe:
      return { byteLength: 2, components: 4 };
    case JF:
    case kpe:
    case cN:
      return { byteLength: 4, components: 1 };
    case aAe:
      return { byteLength: 4, components: 3 };
  }
  throw new Error(`Unknown texture type ${e}.`);
}
typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", { detail: {
  revision: Hpe
} }));
typeof window < "u" && (window.__THREE__ ? console.warn("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = Hpe);
/**
 * @license
 * Copyright 2010-2025 Three.js Authors
 * SPDX-License-Identifier: MIT
 */
function bAe() {
  let e = null, t = !1, i = null, n = null;
  function s(o, r) {
    i(o, r), n = e.requestAnimationFrame(s);
  }
  return {
    start: function() {
      t !== !0 && i !== null && (n = e.requestAnimationFrame(s), t = !0);
    },
    stop: function() {
      e.cancelAnimationFrame(n), t = !1;
    },
    setAnimationLoop: function(o) {
      i = o;
    },
    setContext: function(o) {
      e = o;
    }
  };
}
function MUe(e) {
  const t = /* @__PURE__ */ new WeakMap();
  function i(l, c) {
    const h = l.array, I = l.usage, p = h.byteLength, y = e.createBuffer();
    e.bindBuffer(c, y), e.bufferData(c, h, I), l.onUploadCallback();
    let m;
    if (h instanceof Float32Array)
      m = e.FLOAT;
    else if (typeof Float16Array < "u" && h instanceof Float16Array)
      m = e.HALF_FLOAT;
    else if (h instanceof Uint16Array)
      l.isFloat16BufferAttribute ? m = e.HALF_FLOAT : m = e.UNSIGNED_SHORT;
    else if (h instanceof Int16Array)
      m = e.SHORT;
    else if (h instanceof Uint32Array)
      m = e.UNSIGNED_INT;
    else if (h instanceof Int32Array)
      m = e.INT;
    else if (h instanceof Int8Array)
      m = e.BYTE;
    else if (h instanceof Uint8Array)
      m = e.UNSIGNED_BYTE;
    else if (h instanceof Uint8ClampedArray)
      m = e.UNSIGNED_BYTE;
    else
      throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + h);
    return {
      buffer: y,
      type: m,
      bytesPerElement: h.BYTES_PER_ELEMENT,
      version: l.version,
      size: p
    };
  }
  function n(l, c, h) {
    const I = c.array, p = c.updateRanges;
    if (e.bindBuffer(h, l), p.length === 0)
      e.bufferSubData(h, 0, I);
    else {
      p.sort((m, A) => m.start - A.start);
      let y = 0;
      for (let m = 1; m < p.length; m++) {
        const A = p[y], C = p[m];
        C.start <= A.start + A.count + 1 ? A.count = Math.max(
          A.count,
          C.start + C.count - A.start
        ) : (++y, p[y] = C);
      }
      p.length = y + 1;
      for (let m = 0, A = p.length; m < A; m++) {
        const C = p[m];
        e.bufferSubData(
          h,
          C.start * I.BYTES_PER_ELEMENT,
          I,
          C.start,
          C.count
        );
      }
      c.clearUpdateRanges();
    }
    c.onUploadCallback();
  }
  function s(l) {
    return l.isInterleavedBufferAttribute && (l = l.data), t.get(l);
  }
  function o(l) {
    l.isInterleavedBufferAttribute && (l = l.data);
    const c = t.get(l);
    c && (e.deleteBuffer(c.buffer), t.delete(l));
  }
  function r(l, c) {
    if (l.isInterleavedBufferAttribute && (l = l.data), l.isGLBufferAttribute) {
      const I = t.get(l);
      (!I || I.version < l.version) && t.set(l, {
        buffer: l.buffer,
        type: l.type,
        bytesPerElement: l.elementSize,
        version: l.version
      });
      return;
    }
    const h = t.get(l);
    if (h === void 0)
      t.set(l, i(l, c));
    else if (h.version < l.version) {
      if (h.size !== l.array.byteLength)
        throw new Error("THREE.WebGLAttributes: The size of the buffer attribute's array buffer does not match the original size. Resizing buffer attributes is not supported.");
      n(h.buffer, l, c), h.version = l.version;
    }
  }
  return {
    get: s,
    remove: o,
    update: r
  };
}
var UUe = `#ifdef USE_ALPHAHASH
	if ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;
#endif`, BUe = `#ifdef USE_ALPHAHASH
	const float ALPHA_HASH_SCALE = 0.05;
	float hash2D( vec2 value ) {
		return fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );
	}
	float hash3D( vec3 value ) {
		return hash2D( vec2( hash2D( value.xy ), value.z ) );
	}
	float getAlphaHashThreshold( vec3 position ) {
		float maxDeriv = max(
			length( dFdx( position.xyz ) ),
			length( dFdy( position.xyz ) )
		);
		float pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );
		vec2 pixScales = vec2(
			exp2( floor( log2( pixScale ) ) ),
			exp2( ceil( log2( pixScale ) ) )
		);
		vec2 alpha = vec2(
			hash3D( floor( pixScales.x * position.xyz ) ),
			hash3D( floor( pixScales.y * position.xyz ) )
		);
		float lerpFactor = fract( log2( pixScale ) );
		float x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;
		float a = min( lerpFactor, 1.0 - lerpFactor );
		vec3 cases = vec3(
			x * x / ( 2.0 * a * ( 1.0 - a ) ),
			( x - 0.5 * a ) / ( 1.0 - a ),
			1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )
		);
		float threshold = ( x < ( 1.0 - a ) )
			? ( ( x < a ) ? cases.x : cases.y )
			: cases.z;
		return clamp( threshold , 1.0e-6, 1.0 );
	}
#endif`, FUe = `#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;
#endif`, HUe = `#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`, GUe = `#ifdef USE_ALPHATEST
	#ifdef ALPHA_TO_COVERAGE
	diffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );
	if ( diffuseColor.a == 0.0 ) discard;
	#else
	if ( diffuseColor.a < alphaTest ) discard;
	#endif
#endif`, kUe = `#ifdef USE_ALPHATEST
	uniform float alphaTest;
#endif`, VUe = `#ifdef USE_AOMAP
	float ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;
	reflectedLight.indirectDiffuse *= ambientOcclusion;
	#if defined( USE_CLEARCOAT ) 
		clearcoatSpecularIndirect *= ambientOcclusion;
	#endif
	#if defined( USE_SHEEN ) 
		sheenSpecularIndirect *= ambientOcclusion;
	#endif
	#if defined( USE_ENVMAP ) && defined( STANDARD )
		float dotNV = saturate( dot( geometryNormal, geometryViewDir ) );
		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );
	#endif
#endif`, zUe = `#ifdef USE_AOMAP
	uniform sampler2D aoMap;
	uniform float aoMapIntensity;
#endif`, jUe = `#ifdef USE_BATCHING
	#if ! defined( GL_ANGLE_multi_draw )
	#define gl_DrawID _gl_DrawID
	uniform int _gl_DrawID;
	#endif
	uniform highp sampler2D batchingTexture;
	uniform highp usampler2D batchingIdTexture;
	mat4 getBatchingMatrix( const in float i ) {
		int size = textureSize( batchingTexture, 0 ).x;
		int j = int( i ) * 4;
		int x = j % size;
		int y = j / size;
		vec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );
		vec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );
		vec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );
		vec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );
		return mat4( v1, v2, v3, v4 );
	}
	float getIndirectIndex( const in int i ) {
		int size = textureSize( batchingIdTexture, 0 ).x;
		int x = i % size;
		int y = i / size;
		return float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );
	}
#endif
#ifdef USE_BATCHING_COLOR
	uniform sampler2D batchingColorTexture;
	vec3 getBatchingColor( const in float i ) {
		int size = textureSize( batchingColorTexture, 0 ).x;
		int j = int( i );
		int x = j % size;
		int y = j / size;
		return texelFetch( batchingColorTexture, ivec2( x, y ), 0 ).rgb;
	}
#endif`, WUe = `#ifdef USE_BATCHING
	mat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );
#endif`, YUe = `vec3 transformed = vec3( position );
#ifdef USE_ALPHAHASH
	vPosition = vec3( position );
#endif`, qUe = `vec3 objectNormal = vec3( normal );
#ifdef USE_TANGENT
	vec3 objectTangent = vec3( tangent.xyz );
#endif`, $Ue = `float G_BlinnPhong_Implicit( ) {
	return 0.25;
}
float D_BlinnPhong( const in float shininess, const in float dotNH ) {
	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );
}
vec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( specularColor, 1.0, dotVH );
	float G = G_BlinnPhong_Implicit( );
	float D = D_BlinnPhong( shininess, dotNH );
	return F * ( G * D );
} // validated`, KUe = `#ifdef USE_IRIDESCENCE
	const mat3 XYZ_TO_REC709 = mat3(
		 3.2404542, -0.9692660,  0.0556434,
		-1.5371385,  1.8760108, -0.2040259,
		-0.4985314,  0.0415560,  1.0572252
	);
	vec3 Fresnel0ToIor( vec3 fresnel0 ) {
		vec3 sqrtF0 = sqrt( fresnel0 );
		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );
	}
	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );
	}
	float IorToFresnel0( float transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));
	}
	vec3 evalSensitivity( float OPD, vec3 shift ) {
		float phase = 2.0 * PI * OPD * 1.0e-9;
		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );
		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );
		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );
		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );
		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );
		xyz /= 1.0685e-7;
		vec3 rgb = XYZ_TO_REC709 * xyz;
		return rgb;
	}
	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {
		vec3 I;
		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );
		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );
		float cosTheta2Sq = 1.0 - sinTheta2Sq;
		if ( cosTheta2Sq < 0.0 ) {
			return vec3( 1.0 );
		}
		float cosTheta2 = sqrt( cosTheta2Sq );
		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );
		float R12 = F_Schlick( R0, 1.0, cosTheta1 );
		float T121 = 1.0 - R12;
		float phi12 = 0.0;
		if ( iridescenceIOR < outsideIOR ) phi12 = PI;
		float phi21 = PI - phi12;
		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );
		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );
		vec3 phi23 = vec3( 0.0 );
		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;
		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;
		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;
		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;
		vec3 phi = vec3( phi21 ) + phi23;
		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );
		vec3 r123 = sqrt( R123 );
		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );
		vec3 C0 = R12 + Rs;
		I = C0;
		vec3 Cm = Rs - T121;
		for ( int m = 1; m <= 2; ++ m ) {
			Cm *= r123;
			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );
			I += Cm * Sm;
		}
		return max( I, vec3( 0.0 ) );
	}
#endif`, ZUe = `#ifdef USE_BUMPMAP
	uniform sampler2D bumpMap;
	uniform float bumpScale;
	vec2 dHdxy_fwd() {
		vec2 dSTdx = dFdx( vBumpMapUv );
		vec2 dSTdy = dFdy( vBumpMapUv );
		float Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;
		float dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;
		float dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;
		return vec2( dBx, dBy );
	}
	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {
		vec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );
		vec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );
		vec3 vN = surf_norm;
		vec3 R1 = cross( vSigmaY, vN );
		vec3 R2 = cross( vN, vSigmaX );
		float fDet = dot( vSigmaX, R1 ) * faceDirection;
		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );
		return normalize( abs( fDet ) * surf_norm - vGrad );
	}
#endif`, QUe = `#if NUM_CLIPPING_PLANES > 0
	vec4 plane;
	#ifdef ALPHA_TO_COVERAGE
		float distanceToPlane, distanceGradient;
		float clipOpacity = 1.0;
		#pragma unroll_loop_start
		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {
			plane = clippingPlanes[ i ];
			distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;
			distanceGradient = fwidth( distanceToPlane ) / 2.0;
			clipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );
			if ( clipOpacity == 0.0 ) discard;
		}
		#pragma unroll_loop_end
		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES
			float unionClipOpacity = 1.0;
			#pragma unroll_loop_start
			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {
				plane = clippingPlanes[ i ];
				distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;
				distanceGradient = fwidth( distanceToPlane ) / 2.0;
				unionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );
			}
			#pragma unroll_loop_end
			clipOpacity *= 1.0 - unionClipOpacity;
		#endif
		diffuseColor.a *= clipOpacity;
		if ( diffuseColor.a == 0.0 ) discard;
	#else
		#pragma unroll_loop_start
		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {
			plane = clippingPlanes[ i ];
			if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;
		}
		#pragma unroll_loop_end
		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES
			bool clipped = true;
			#pragma unroll_loop_start
			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {
				plane = clippingPlanes[ i ];
				clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;
			}
			#pragma unroll_loop_end
			if ( clipped ) discard;
		#endif
	#endif
#endif`, JUe = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];
#endif`, XUe = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
#endif`, eBe = `#if NUM_CLIPPING_PLANES > 0
	vClipPosition = - mvPosition.xyz;
#endif`, tBe = `#if defined( USE_COLOR_ALPHA )
	diffuseColor *= vColor;
#elif defined( USE_COLOR )
	diffuseColor.rgb *= vColor;
#endif`, iBe = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR )
	varying vec3 vColor;
#endif`, nBe = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )
	varying vec3 vColor;
#endif`, sBe = `#if defined( USE_COLOR_ALPHA )
	vColor = vec4( 1.0 );
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )
	vColor = vec3( 1.0 );
#endif
#ifdef USE_COLOR
	vColor *= color;
#endif
#ifdef USE_INSTANCING_COLOR
	vColor.xyz *= instanceColor.xyz;
#endif
#ifdef USE_BATCHING_COLOR
	vec3 batchingColor = getBatchingColor( getIndirectIndex( gl_DrawID ) );
	vColor.xyz *= batchingColor.xyz;
#endif`, oBe = `#define PI 3.141592653589793
#define PI2 6.283185307179586
#define PI_HALF 1.5707963267948966
#define RECIPROCAL_PI 0.3183098861837907
#define RECIPROCAL_PI2 0.15915494309189535
#define EPSILON 1e-6
#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
#define whiteComplement( a ) ( 1.0 - saturate( a ) )
float pow2( const in float x ) { return x*x; }
vec3 pow2( const in vec3 x ) { return x*x; }
float pow3( const in float x ) { return x*x*x; }
float pow4( const in float x ) { float x2 = x*x; return x2*x2; }
float max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }
float average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }
highp float rand( const in vec2 uv ) {
	const highp float a = 12.9898, b = 78.233, c = 43758.5453;
	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );
	return fract( sin( sn ) * c );
}
#ifdef HIGH_PRECISION
	float precisionSafeLength( vec3 v ) { return length( v ); }
#else
	float precisionSafeLength( vec3 v ) {
		float maxComponent = max3( abs( v ) );
		return length( v / maxComponent ) * maxComponent;
	}
#endif
struct IncidentLight {
	vec3 color;
	vec3 direction;
	bool visible;
};
struct ReflectedLight {
	vec3 directDiffuse;
	vec3 directSpecular;
	vec3 indirectDiffuse;
	vec3 indirectSpecular;
};
#ifdef USE_ALPHAHASH
	varying vec3 vPosition;
#endif
vec3 transformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );
}
vec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );
}
mat3 transposeMat3( const in mat3 m ) {
	mat3 tmp;
	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );
	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );
	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );
	return tmp;
}
bool isPerspectiveMatrix( mat4 m ) {
	return m[ 2 ][ 3 ] == - 1.0;
}
vec2 equirectUv( in vec3 dir ) {
	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;
	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;
	return vec2( u, v );
}
vec3 BRDF_Lambert( const in vec3 diffuseColor ) {
	return RECIPROCAL_PI * diffuseColor;
}
vec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
}
float F_Schlick( const in float f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
} // validated`, rBe = `#ifdef ENVMAP_TYPE_CUBE_UV
	#define cubeUV_minMipLevel 4.0
	#define cubeUV_minTileSize 16.0
	float getFace( vec3 direction ) {
		vec3 absDirection = abs( direction );
		float face = - 1.0;
		if ( absDirection.x > absDirection.z ) {
			if ( absDirection.x > absDirection.y )
				face = direction.x > 0.0 ? 0.0 : 3.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		} else {
			if ( absDirection.z > absDirection.y )
				face = direction.z > 0.0 ? 2.0 : 5.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		}
		return face;
	}
	vec2 getUV( vec3 direction, float face ) {
		vec2 uv;
		if ( face == 0.0 ) {
			uv = vec2( direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 1.0 ) {
			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );
		} else if ( face == 2.0 ) {
			uv = vec2( - direction.x, direction.y ) / abs( direction.z );
		} else if ( face == 3.0 ) {
			uv = vec2( - direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 4.0 ) {
			uv = vec2( - direction.x, direction.z ) / abs( direction.y );
		} else {
			uv = vec2( direction.x, direction.y ) / abs( direction.z );
		}
		return 0.5 * ( uv + 1.0 );
	}
	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {
		float face = getFace( direction );
		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );
		mipInt = max( mipInt, cubeUV_minMipLevel );
		float faceSize = exp2( mipInt );
		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;
		if ( face > 2.0 ) {
			uv.y += faceSize;
			face -= 3.0;
		}
		uv.x += face * faceSize;
		uv.x += filterInt * 3.0 * cubeUV_minTileSize;
		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );
		uv.x *= CUBEUV_TEXEL_WIDTH;
		uv.y *= CUBEUV_TEXEL_HEIGHT;
		#ifdef texture2DGradEXT
			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;
		#else
			return texture2D( envMap, uv ).rgb;
		#endif
	}
	#define cubeUV_r0 1.0
	#define cubeUV_m0 - 2.0
	#define cubeUV_r1 0.8
	#define cubeUV_m1 - 1.0
	#define cubeUV_r4 0.4
	#define cubeUV_m4 2.0
	#define cubeUV_r5 0.305
	#define cubeUV_m5 3.0
	#define cubeUV_r6 0.21
	#define cubeUV_m6 4.0
	float roughnessToMip( float roughness ) {
		float mip = 0.0;
		if ( roughness >= cubeUV_r1 ) {
			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;
		} else if ( roughness >= cubeUV_r4 ) {
			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;
		} else if ( roughness >= cubeUV_r5 ) {
			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;
		} else if ( roughness >= cubeUV_r6 ) {
			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;
		} else {
			mip = - 2.0 * log2( 1.16 * roughness );		}
		return mip;
	}
	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {
		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );
		float mipF = fract( mip );
		float mipInt = floor( mip );
		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );
		if ( mipF == 0.0 ) {
			return vec4( color0, 1.0 );
		} else {
			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );
			return vec4( mix( color0, color1, mipF ), 1.0 );
		}
	}
#endif`, lBe = `vec3 transformedNormal = objectNormal;
#ifdef USE_TANGENT
	vec3 transformedTangent = objectTangent;
#endif
#ifdef USE_BATCHING
	mat3 bm = mat3( batchingMatrix );
	transformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );
	transformedNormal = bm * transformedNormal;
	#ifdef USE_TANGENT
		transformedTangent = bm * transformedTangent;
	#endif
#endif
#ifdef USE_INSTANCING
	mat3 im = mat3( instanceMatrix );
	transformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );
	transformedNormal = im * transformedNormal;
	#ifdef USE_TANGENT
		transformedTangent = im * transformedTangent;
	#endif
#endif
transformedNormal = normalMatrix * transformedNormal;
#ifdef FLIP_SIDED
	transformedNormal = - transformedNormal;
#endif
#ifdef USE_TANGENT
	transformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;
	#ifdef FLIP_SIDED
		transformedTangent = - transformedTangent;
	#endif
#endif`, aBe = `#ifdef USE_DISPLACEMENTMAP
	uniform sampler2D displacementMap;
	uniform float displacementScale;
	uniform float displacementBias;
#endif`, uBe = `#ifdef USE_DISPLACEMENTMAP
	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );
#endif`, dBe = `#ifdef USE_EMISSIVEMAP
	vec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );
	#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE
		emissiveColor = sRGBTransferEOTF( emissiveColor );
	#endif
	totalEmissiveRadiance *= emissiveColor.rgb;
#endif`, cBe = `#ifdef USE_EMISSIVEMAP
	uniform sampler2D emissiveMap;
#endif`, hBe = "gl_FragColor = linearToOutputTexel( gl_FragColor );", fBe = `vec4 LinearTransferOETF( in vec4 value ) {
	return value;
}
vec4 sRGBTransferEOTF( in vec4 value ) {
	return vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );
}
vec4 sRGBTransferOETF( in vec4 value ) {
	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );
}`, IBe = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vec3 cameraToFrag;
		if ( isOrthographic ) {
			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToFrag = normalize( vWorldPosition - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vec3 reflectVec = reflect( cameraToFrag, worldNormal );
		#else
			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );
		#endif
	#else
		vec3 reflectVec = vReflect;
	#endif
	#ifdef ENVMAP_TYPE_CUBE
		vec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );
	#else
		vec4 envColor = vec4( 0.0 );
	#endif
	#ifdef ENVMAP_BLENDING_MULTIPLY
		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_MIX )
		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_ADD )
		outgoingLight += envColor.xyz * specularStrength * reflectivity;
	#endif
#endif`, pBe = `#ifdef USE_ENVMAP
	uniform float envMapIntensity;
	uniform float flipEnvMap;
	uniform mat3 envMapRotation;
	#ifdef ENVMAP_TYPE_CUBE
		uniform samplerCube envMap;
	#else
		uniform sampler2D envMap;
	#endif
	
#endif`, mBe = `#ifdef USE_ENVMAP
	uniform float reflectivity;
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		varying vec3 vWorldPosition;
		uniform float refractionRatio;
	#else
		varying vec3 vReflect;
	#endif
#endif`, yBe = `#ifdef USE_ENVMAP
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		
		varying vec3 vWorldPosition;
	#else
		varying vec3 vReflect;
		uniform float refractionRatio;
	#endif
#endif`, EBe = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vWorldPosition = worldPosition.xyz;
	#else
		vec3 cameraToVertex;
		if ( isOrthographic ) {
			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vReflect = reflect( cameraToVertex, worldNormal );
		#else
			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );
		#endif
	#endif
#endif`, gBe = `#ifdef USE_FOG
	vFogDepth = - mvPosition.z;
#endif`, wBe = `#ifdef USE_FOG
	varying float vFogDepth;
#endif`, TBe = `#ifdef USE_FOG
	#ifdef FOG_EXP2
		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );
	#else
		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );
	#endif
	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );
#endif`, RBe = `#ifdef USE_FOG
	uniform vec3 fogColor;
	varying float vFogDepth;
	#ifdef FOG_EXP2
		uniform float fogDensity;
	#else
		uniform float fogNear;
		uniform float fogFar;
	#endif
#endif`, vBe = `#ifdef USE_GRADIENTMAP
	uniform sampler2D gradientMap;
#endif
vec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {
	float dotNL = dot( normal, lightDirection );
	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );
	#ifdef USE_GRADIENTMAP
		return vec3( texture2D( gradientMap, coord ).r );
	#else
		vec2 fw = fwidth( coord ) * 0.5;
		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );
	#endif
}`, ABe = `#ifdef USE_LIGHTMAP
	uniform sampler2D lightMap;
	uniform float lightMapIntensity;
#endif`, SBe = `LambertMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularStrength = specularStrength;`, bBe = `varying vec3 vViewPosition;
struct LambertMaterial {
	vec3 diffuseColor;
	float specularStrength;
};
void RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Lambert
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert`, NBe = `uniform bool receiveShadow;
uniform vec3 ambientLightColor;
#if defined( USE_LIGHT_PROBES )
	uniform vec3 lightProbe[ 9 ];
#endif
vec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {
	float x = normal.x, y = normal.y, z = normal.z;
	vec3 result = shCoefficients[ 0 ] * 0.886227;
	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;
	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;
	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;
	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;
	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;
	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );
	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;
	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );
	return result;
}
vec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {
	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );
	return irradiance;
}
vec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {
	vec3 irradiance = ambientLightColor;
	return irradiance;
}
float getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {
	float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );
	if ( cutoffDistance > 0.0 ) {
		distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );
	}
	return distanceFalloff;
}
float getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {
	return smoothstep( coneCosine, penumbraCosine, angleCosine );
}
#if NUM_DIR_LIGHTS > 0
	struct DirectionalLight {
		vec3 direction;
		vec3 color;
	};
	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];
	void getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {
		light.color = directionalLight.color;
		light.direction = directionalLight.direction;
		light.visible = true;
	}
#endif
#if NUM_POINT_LIGHTS > 0
	struct PointLight {
		vec3 position;
		vec3 color;
		float distance;
		float decay;
	};
	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];
	void getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {
		vec3 lVector = pointLight.position - geometryPosition;
		light.direction = normalize( lVector );
		float lightDistance = length( lVector );
		light.color = pointLight.color;
		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );
		light.visible = ( light.color != vec3( 0.0 ) );
	}
#endif
#if NUM_SPOT_LIGHTS > 0
	struct SpotLight {
		vec3 position;
		vec3 direction;
		vec3 color;
		float distance;
		float decay;
		float coneCos;
		float penumbraCos;
	};
	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];
	void getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {
		vec3 lVector = spotLight.position - geometryPosition;
		light.direction = normalize( lVector );
		float angleCos = dot( light.direction, spotLight.direction );
		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );
		if ( spotAttenuation > 0.0 ) {
			float lightDistance = length( lVector );
			light.color = spotLight.color * spotAttenuation;
			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );
			light.visible = ( light.color != vec3( 0.0 ) );
		} else {
			light.color = vec3( 0.0 );
			light.visible = false;
		}
	}
#endif
#if NUM_RECT_AREA_LIGHTS > 0
	struct RectAreaLight {
		vec3 color;
		vec3 position;
		vec3 halfWidth;
		vec3 halfHeight;
	};
	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;
	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];
#endif
#if NUM_HEMI_LIGHTS > 0
	struct HemisphereLight {
		vec3 direction;
		vec3 skyColor;
		vec3 groundColor;
	};
	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];
	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {
		float dotNL = dot( normal, hemiLight.direction );
		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;
		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );
		return irradiance;
	}
#endif`, DBe = `#ifdef USE_ENVMAP
	vec3 getIBLIrradiance( const in vec3 normal ) {
		#ifdef ENVMAP_TYPE_CUBE_UV
			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );
			return PI * envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {
		#ifdef ENVMAP_TYPE_CUBE_UV
			vec3 reflectVec = reflect( - viewDir, normal );
			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );
			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );
			return envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
	#ifdef USE_ANISOTROPY
		vec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {
			#ifdef ENVMAP_TYPE_CUBE_UV
				vec3 bentNormal = cross( bitangent, viewDir );
				bentNormal = normalize( cross( bentNormal, bitangent ) );
				bentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );
				return getIBLRadiance( viewDir, bentNormal, roughness );
			#else
				return vec3( 0.0 );
			#endif
		}
	#endif
#endif`, CBe = `ToonMaterial material;
material.diffuseColor = diffuseColor.rgb;`, OBe = `varying vec3 vViewPosition;
struct ToonMaterial {
	vec3 diffuseColor;
};
void RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	vec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Toon
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon`, LBe = `BlinnPhongMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularColor = specular;
material.specularShininess = shininess;
material.specularStrength = specularStrength;`, _Be = `varying vec3 vViewPosition;
struct BlinnPhongMaterial {
	vec3 diffuseColor;
	vec3 specularColor;
	float specularShininess;
	float specularStrength;
};
void RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;
}
void RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_BlinnPhong
#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong`, xBe = `PhysicalMaterial material;
material.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );
vec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );
float geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );
material.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;
material.roughness = min( material.roughness, 1.0 );
#ifdef IOR
	material.ior = ior;
	#ifdef USE_SPECULAR
		float specularIntensityFactor = specularIntensity;
		vec3 specularColorFactor = specularColor;
		#ifdef USE_SPECULAR_COLORMAP
			specularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;
		#endif
		#ifdef USE_SPECULAR_INTENSITYMAP
			specularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;
		#endif
		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );
	#else
		float specularIntensityFactor = 1.0;
		vec3 specularColorFactor = vec3( 1.0 );
		material.specularF90 = 1.0;
	#endif
	material.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );
#else
	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );
	material.specularF90 = 1.0;
#endif
#ifdef USE_CLEARCOAT
	material.clearcoat = clearcoat;
	material.clearcoatRoughness = clearcoatRoughness;
	material.clearcoatF0 = vec3( 0.04 );
	material.clearcoatF90 = 1.0;
	#ifdef USE_CLEARCOATMAP
		material.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;
	#endif
	#ifdef USE_CLEARCOAT_ROUGHNESSMAP
		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;
	#endif
	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );
	material.clearcoatRoughness += geometryRoughness;
	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );
#endif
#ifdef USE_DISPERSION
	material.dispersion = dispersion;
#endif
#ifdef USE_IRIDESCENCE
	material.iridescence = iridescence;
	material.iridescenceIOR = iridescenceIOR;
	#ifdef USE_IRIDESCENCEMAP
		material.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;
	#endif
	#ifdef USE_IRIDESCENCE_THICKNESSMAP
		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;
	#else
		material.iridescenceThickness = iridescenceThicknessMaximum;
	#endif
#endif
#ifdef USE_SHEEN
	material.sheenColor = sheenColor;
	#ifdef USE_SHEEN_COLORMAP
		material.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;
	#endif
	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );
	#ifdef USE_SHEEN_ROUGHNESSMAP
		material.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;
	#endif
#endif
#ifdef USE_ANISOTROPY
	#ifdef USE_ANISOTROPYMAP
		mat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );
		vec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;
		vec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;
	#else
		vec2 anisotropyV = anisotropyVector;
	#endif
	material.anisotropy = length( anisotropyV );
	if( material.anisotropy == 0.0 ) {
		anisotropyV = vec2( 1.0, 0.0 );
	} else {
		anisotropyV /= material.anisotropy;
		material.anisotropy = saturate( material.anisotropy );
	}
	material.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );
	material.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;
	material.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;
#endif`, PBe = `struct PhysicalMaterial {
	vec3 diffuseColor;
	float roughness;
	vec3 specularColor;
	float specularF90;
	float dispersion;
	#ifdef USE_CLEARCOAT
		float clearcoat;
		float clearcoatRoughness;
		vec3 clearcoatF0;
		float clearcoatF90;
	#endif
	#ifdef USE_IRIDESCENCE
		float iridescence;
		float iridescenceIOR;
		float iridescenceThickness;
		vec3 iridescenceFresnel;
		vec3 iridescenceF0;
	#endif
	#ifdef USE_SHEEN
		vec3 sheenColor;
		float sheenRoughness;
	#endif
	#ifdef IOR
		float ior;
	#endif
	#ifdef USE_TRANSMISSION
		float transmission;
		float transmissionAlpha;
		float thickness;
		float attenuationDistance;
		vec3 attenuationColor;
	#endif
	#ifdef USE_ANISOTROPY
		float anisotropy;
		float alphaT;
		vec3 anisotropyT;
		vec3 anisotropyB;
	#endif
};
vec3 clearcoatSpecularDirect = vec3( 0.0 );
vec3 clearcoatSpecularIndirect = vec3( 0.0 );
vec3 sheenSpecularDirect = vec3( 0.0 );
vec3 sheenSpecularIndirect = vec3(0.0 );
vec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {
    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );
    float x2 = x * x;
    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );
    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );
}
float V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {
	float a2 = pow2( alpha );
	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );
	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );
	return 0.5 / max( gv + gl, EPSILON );
}
float D_GGX( const in float alpha, const in float dotNH ) {
	float a2 = pow2( alpha );
	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;
	return RECIPROCAL_PI * a2 / pow2( denom );
}
#ifdef USE_ANISOTROPY
	float V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {
		float gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );
		float gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );
		float v = 0.5 / ( gv + gl );
		return saturate(v);
	}
	float D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {
		float a2 = alphaT * alphaB;
		highp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );
		highp float v2 = dot( v, v );
		float w2 = a2 / v2;
		return RECIPROCAL_PI * a2 * pow2 ( w2 );
	}
#endif
#ifdef USE_CLEARCOAT
	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {
		vec3 f0 = material.clearcoatF0;
		float f90 = material.clearcoatF90;
		float roughness = material.clearcoatRoughness;
		float alpha = pow2( roughness );
		vec3 halfDir = normalize( lightDir + viewDir );
		float dotNL = saturate( dot( normal, lightDir ) );
		float dotNV = saturate( dot( normal, viewDir ) );
		float dotNH = saturate( dot( normal, halfDir ) );
		float dotVH = saturate( dot( viewDir, halfDir ) );
		vec3 F = F_Schlick( f0, f90, dotVH );
		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
		float D = D_GGX( alpha, dotNH );
		return F * ( V * D );
	}
#endif
vec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {
	vec3 f0 = material.specularColor;
	float f90 = material.specularF90;
	float roughness = material.roughness;
	float alpha = pow2( roughness );
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( f0, f90, dotVH );
	#ifdef USE_IRIDESCENCE
		F = mix( F, material.iridescenceFresnel, material.iridescence );
	#endif
	#ifdef USE_ANISOTROPY
		float dotTL = dot( material.anisotropyT, lightDir );
		float dotTV = dot( material.anisotropyT, viewDir );
		float dotTH = dot( material.anisotropyT, halfDir );
		float dotBL = dot( material.anisotropyB, lightDir );
		float dotBV = dot( material.anisotropyB, viewDir );
		float dotBH = dot( material.anisotropyB, halfDir );
		float V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );
		float D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );
	#else
		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
		float D = D_GGX( alpha, dotNH );
	#endif
	return F * ( V * D );
}
vec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {
	const float LUT_SIZE = 64.0;
	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;
	const float LUT_BIAS = 0.5 / LUT_SIZE;
	float dotNV = saturate( dot( N, V ) );
	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );
	uv = uv * LUT_SCALE + LUT_BIAS;
	return uv;
}
float LTC_ClippedSphereFormFactor( const in vec3 f ) {
	float l = length( f );
	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );
}
vec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {
	float x = dot( v1, v2 );
	float y = abs( x );
	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;
	float b = 3.4175940 + ( 4.1616724 + y ) * y;
	float v = a / b;
	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;
	return cross( v1, v2 ) * theta_sintheta;
}
vec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {
	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];
	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];
	vec3 lightNormal = cross( v1, v2 );
	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );
	vec3 T1, T2;
	T1 = normalize( V - N * dot( V, N ) );
	T2 = - cross( N, T1 );
	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );
	vec3 coords[ 4 ];
	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );
	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );
	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );
	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );
	coords[ 0 ] = normalize( coords[ 0 ] );
	coords[ 1 ] = normalize( coords[ 1 ] );
	coords[ 2 ] = normalize( coords[ 2 ] );
	coords[ 3 ] = normalize( coords[ 3 ] );
	vec3 vectorFormFactor = vec3( 0.0 );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );
	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );
	return vec3( result );
}
#if defined( USE_SHEEN )
float D_Charlie( float roughness, float dotNH ) {
	float alpha = pow2( roughness );
	float invAlpha = 1.0 / alpha;
	float cos2h = dotNH * dotNH;
	float sin2h = max( 1.0 - cos2h, 0.0078125 );
	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );
}
float V_Neubelt( float dotNV, float dotNL ) {
	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );
}
vec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float D = D_Charlie( sheenRoughness, dotNH );
	float V = V_Neubelt( dotNV, dotNL );
	return sheenColor * ( D * V );
}
#endif
float IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	float r2 = roughness * roughness;
	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;
	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;
	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );
	return saturate( DG * RECIPROCAL_PI );
}
vec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );
	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );
	vec4 r = roughness * c0 + c1;
	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;
	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;
	return fab;
}
vec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {
	vec2 fab = DFGApprox( normal, viewDir, roughness );
	return specularColor * fab.x + specularF90 * fab.y;
}
#ifdef USE_IRIDESCENCE
void computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#else
void computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#endif
	vec2 fab = DFGApprox( normal, viewDir, roughness );
	#ifdef USE_IRIDESCENCE
		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );
	#else
		vec3 Fr = specularColor;
	#endif
	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;
	float Ess = fab.x + fab.y;
	float Ems = 1.0 - Ess;
	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );
	singleScatter += FssEss;
	multiScatter += Fms * Ems;
}
#if NUM_RECT_AREA_LIGHTS > 0
	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
		vec3 normal = geometryNormal;
		vec3 viewDir = geometryViewDir;
		vec3 position = geometryPosition;
		vec3 lightPos = rectAreaLight.position;
		vec3 halfWidth = rectAreaLight.halfWidth;
		vec3 halfHeight = rectAreaLight.halfHeight;
		vec3 lightColor = rectAreaLight.color;
		float roughness = material.roughness;
		vec3 rectCoords[ 4 ];
		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;
		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;
		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;
		vec2 uv = LTC_Uv( normal, viewDir, roughness );
		vec4 t1 = texture2D( ltc_1, uv );
		vec4 t2 = texture2D( ltc_2, uv );
		mat3 mInv = mat3(
			vec3( t1.x, 0, t1.y ),
			vec3(    0, 1,    0 ),
			vec3( t1.z, 0, t1.w )
		);
		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );
		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );
		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );
	}
#endif
void RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	#ifdef USE_CLEARCOAT
		float dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );
		vec3 ccIrradiance = dotNLcc * directLight.color;
		clearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );
	#endif
	#ifdef USE_SHEEN
		sheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );
	#endif
	reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {
	#ifdef USE_CLEARCOAT
		clearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );
	#endif
	#ifdef USE_SHEEN
		sheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );
	#endif
	vec3 singleScattering = vec3( 0.0 );
	vec3 multiScattering = vec3( 0.0 );
	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;
	#ifdef USE_IRIDESCENCE
		computeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );
	#else
		computeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );
	#endif
	vec3 totalScattering = singleScattering + multiScattering;
	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );
	reflectedLight.indirectSpecular += radiance * singleScattering;
	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;
	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;
}
#define RE_Direct				RE_Direct_Physical
#define RE_Direct_RectArea		RE_Direct_RectArea_Physical
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical
#define RE_IndirectSpecular		RE_IndirectSpecular_Physical
float computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {
	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );
}`, MBe = `
vec3 geometryPosition = - vViewPosition;
vec3 geometryNormal = normal;
vec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );
vec3 geometryClearcoatNormal = vec3( 0.0 );
#ifdef USE_CLEARCOAT
	geometryClearcoatNormal = clearcoatNormal;
#endif
#ifdef USE_IRIDESCENCE
	float dotNVi = saturate( dot( normal, geometryViewDir ) );
	if ( material.iridescenceThickness == 0.0 ) {
		material.iridescence = 0.0;
	} else {
		material.iridescence = saturate( material.iridescence );
	}
	if ( material.iridescence > 0.0 ) {
		material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );
		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );
	}
#endif
IncidentLight directLight;
#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )
	PointLight pointLight;
	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {
		pointLight = pointLights[ i ];
		getPointLightInfo( pointLight, geometryPosition, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )
		pointLightShadow = pointLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )
	SpotLight spotLight;
	vec4 spotColor;
	vec3 spotLightCoord;
	bool inSpotLightMap;
	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {
		spotLight = spotLights[ i ];
		getSpotLightInfo( spotLight, geometryPosition, directLight );
		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX
		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS
		#else
		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#endif
		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )
			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;
			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );
			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );
			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;
		#endif
		#undef SPOT_LIGHT_MAP_INDEX
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		spotLightShadow = spotLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )
	DirectionalLight directionalLight;
	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {
		directionalLight = directionalLights[ i ];
		getDirectionalLightInfo( directionalLight, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )
		directionalLightShadow = directionalLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )
	RectAreaLight rectAreaLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {
		rectAreaLight = rectAreaLights[ i ];
		RE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if defined( RE_IndirectDiffuse )
	vec3 iblIrradiance = vec3( 0.0 );
	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );
	#if defined( USE_LIGHT_PROBES )
		irradiance += getLightProbeIrradiance( lightProbe, geometryNormal );
	#endif
	#if ( NUM_HEMI_LIGHTS > 0 )
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {
			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );
		}
		#pragma unroll_loop_end
	#endif
#endif
#if defined( RE_IndirectSpecular )
	vec3 radiance = vec3( 0.0 );
	vec3 clearcoatRadiance = vec3( 0.0 );
#endif`, UBe = `#if defined( RE_IndirectDiffuse )
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );
		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;
		irradiance += lightMapIrradiance;
	#endif
	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )
		iblIrradiance += getIBLIrradiance( geometryNormal );
	#endif
#endif
#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )
	#ifdef USE_ANISOTROPY
		radiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );
	#else
		radiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );
	#endif
	#ifdef USE_CLEARCOAT
		clearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );
	#endif
#endif`, BBe = `#if defined( RE_IndirectDiffuse )
	RE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
#endif
#if defined( RE_IndirectSpecular )
	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
#endif`, FBe = `#if defined( USE_LOGDEPTHBUF )
	gl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;
#endif`, HBe = `#if defined( USE_LOGDEPTHBUF )
	uniform float logDepthBufFC;
	varying float vFragDepth;
	varying float vIsPerspective;
#endif`, GBe = `#ifdef USE_LOGDEPTHBUF
	varying float vFragDepth;
	varying float vIsPerspective;
#endif`, kBe = `#ifdef USE_LOGDEPTHBUF
	vFragDepth = 1.0 + gl_Position.w;
	vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );
#endif`, VBe = `#ifdef USE_MAP
	vec4 sampledDiffuseColor = texture2D( map, vMapUv );
	#ifdef DECODE_VIDEO_TEXTURE
		sampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );
	#endif
	diffuseColor *= sampledDiffuseColor;
#endif`, zBe = `#ifdef USE_MAP
	uniform sampler2D map;
#endif`, jBe = `#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
	#if defined( USE_POINTS_UV )
		vec2 uv = vUv;
	#else
		vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;
	#endif
#endif
#ifdef USE_MAP
	diffuseColor *= texture2D( map, uv );
#endif
#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, uv ).g;
#endif`, WBe = `#if defined( USE_POINTS_UV )
	varying vec2 vUv;
#else
	#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
		uniform mat3 uvTransform;
	#endif
#endif
#ifdef USE_MAP
	uniform sampler2D map;
#endif
#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`, YBe = `float metalnessFactor = metalness;
#ifdef USE_METALNESSMAP
	vec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );
	metalnessFactor *= texelMetalness.b;
#endif`, qBe = `#ifdef USE_METALNESSMAP
	uniform sampler2D metalnessMap;
#endif`, $Be = `#ifdef USE_INSTANCING_MORPH
	float morphTargetInfluences[ MORPHTARGETS_COUNT ];
	float morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		morphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;
	}
#endif`, KBe = `#if defined( USE_MORPHCOLORS )
	vColor *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		#if defined( USE_COLOR_ALPHA )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];
		#elif defined( USE_COLOR )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];
		#endif
	}
#endif`, ZBe = `#ifdef USE_MORPHNORMALS
	objectNormal *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];
	}
#endif`, QBe = `#ifdef USE_MORPHTARGETS
	#ifndef USE_INSTANCING_MORPH
		uniform float morphTargetBaseInfluence;
		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];
	#endif
	uniform sampler2DArray morphTargetsTexture;
	uniform ivec2 morphTargetsTextureSize;
	vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {
		int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;
		int y = texelIndex / morphTargetsTextureSize.x;
		int x = texelIndex - y * morphTargetsTextureSize.x;
		ivec3 morphUV = ivec3( x, y, morphTargetIndex );
		return texelFetch( morphTargetsTexture, morphUV, 0 );
	}
#endif`, JBe = `#ifdef USE_MORPHTARGETS
	transformed *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];
	}
#endif`, XBe = `float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;
#ifdef FLAT_SHADED
	vec3 fdx = dFdx( vViewPosition );
	vec3 fdy = dFdy( vViewPosition );
	vec3 normal = normalize( cross( fdx, fdy ) );
#else
	vec3 normal = normalize( vNormal );
	#ifdef DOUBLE_SIDED
		normal *= faceDirection;
	#endif
#endif
#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )
	#ifdef USE_TANGENT
		mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );
	#else
		mat3 tbn = getTangentFrame( - vViewPosition, normal,
		#if defined( USE_NORMALMAP )
			vNormalMapUv
		#elif defined( USE_CLEARCOAT_NORMALMAP )
			vClearcoatNormalMapUv
		#else
			vUv
		#endif
		);
	#endif
	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )
		tbn[0] *= faceDirection;
		tbn[1] *= faceDirection;
	#endif
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	#ifdef USE_TANGENT
		mat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );
	#else
		mat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );
	#endif
	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )
		tbn2[0] *= faceDirection;
		tbn2[1] *= faceDirection;
	#endif
#endif
vec3 nonPerturbedNormal = normal;`, eFe = `#ifdef USE_NORMALMAP_OBJECTSPACE
	normal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;
	#ifdef FLIP_SIDED
		normal = - normal;
	#endif
	#ifdef DOUBLE_SIDED
		normal = normal * faceDirection;
	#endif
	normal = normalize( normalMatrix * normal );
#elif defined( USE_NORMALMAP_TANGENTSPACE )
	vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;
	mapN.xy *= normalScale;
	normal = normalize( tbn * mapN );
#elif defined( USE_BUMPMAP )
	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );
#endif`, tFe = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`, iFe = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`, nFe = `#ifndef FLAT_SHADED
	vNormal = normalize( transformedNormal );
	#ifdef USE_TANGENT
		vTangent = normalize( transformedTangent );
		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );
	#endif
#endif`, sFe = `#ifdef USE_NORMALMAP
	uniform sampler2D normalMap;
	uniform vec2 normalScale;
#endif
#ifdef USE_NORMALMAP_OBJECTSPACE
	uniform mat3 normalMatrix;
#endif
#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )
	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {
		vec3 q0 = dFdx( eye_pos.xyz );
		vec3 q1 = dFdy( eye_pos.xyz );
		vec2 st0 = dFdx( uv.st );
		vec2 st1 = dFdy( uv.st );
		vec3 N = surf_norm;
		vec3 q1perp = cross( q1, N );
		vec3 q0perp = cross( N, q0 );
		vec3 T = q1perp * st0.x + q0perp * st1.x;
		vec3 B = q1perp * st0.y + q0perp * st1.y;
		float det = max( dot( T, T ), dot( B, B ) );
		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );
		return mat3( T * scale, B * scale, N );
	}
#endif`, oFe = `#ifdef USE_CLEARCOAT
	vec3 clearcoatNormal = nonPerturbedNormal;
#endif`, rFe = `#ifdef USE_CLEARCOAT_NORMALMAP
	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;
	clearcoatMapN.xy *= clearcoatNormalScale;
	clearcoatNormal = normalize( tbn2 * clearcoatMapN );
#endif`, lFe = `#ifdef USE_CLEARCOATMAP
	uniform sampler2D clearcoatMap;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	uniform sampler2D clearcoatNormalMap;
	uniform vec2 clearcoatNormalScale;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	uniform sampler2D clearcoatRoughnessMap;
#endif`, aFe = `#ifdef USE_IRIDESCENCEMAP
	uniform sampler2D iridescenceMap;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	uniform sampler2D iridescenceThicknessMap;
#endif`, uFe = `#ifdef OPAQUE
diffuseColor.a = 1.0;
#endif
#ifdef USE_TRANSMISSION
diffuseColor.a *= material.transmissionAlpha;
#endif
gl_FragColor = vec4( outgoingLight, diffuseColor.a );`, dFe = `vec3 packNormalToRGB( const in vec3 normal ) {
	return normalize( normal ) * 0.5 + 0.5;
}
vec3 unpackRGBToNormal( const in vec3 rgb ) {
	return 2.0 * rgb.xyz - 1.0;
}
const float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;
const float Inv255 = 1. / 255.;
const vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );
const vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );
const vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );
const vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );
vec4 packDepthToRGBA( const in float v ) {
	if( v <= 0.0 )
		return vec4( 0., 0., 0., 0. );
	if( v >= 1.0 )
		return vec4( 1., 1., 1., 1. );
	float vuf;
	float af = modf( v * PackFactors.a, vuf );
	float bf = modf( vuf * ShiftRight8, vuf );
	float gf = modf( vuf * ShiftRight8, vuf );
	return vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );
}
vec3 packDepthToRGB( const in float v ) {
	if( v <= 0.0 )
		return vec3( 0., 0., 0. );
	if( v >= 1.0 )
		return vec3( 1., 1., 1. );
	float vuf;
	float bf = modf( v * PackFactors.b, vuf );
	float gf = modf( vuf * ShiftRight8, vuf );
	return vec3( vuf * Inv255, gf * PackUpscale, bf );
}
vec2 packDepthToRG( const in float v ) {
	if( v <= 0.0 )
		return vec2( 0., 0. );
	if( v >= 1.0 )
		return vec2( 1., 1. );
	float vuf;
	float gf = modf( v * 256., vuf );
	return vec2( vuf * Inv255, gf );
}
float unpackRGBAToDepth( const in vec4 v ) {
	return dot( v, UnpackFactors4 );
}
float unpackRGBToDepth( const in vec3 v ) {
	return dot( v, UnpackFactors3 );
}
float unpackRGToDepth( const in vec2 v ) {
	return v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;
}
vec4 pack2HalfToRGBA( const in vec2 v ) {
	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );
	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );
}
vec2 unpackRGBATo2Half( const in vec4 v ) {
	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );
}
float viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {
	return ( viewZ + near ) / ( near - far );
}
float orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {
	return depth * ( near - far ) - near;
}
float viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {
	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );
}
float perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {
	return ( near * far ) / ( ( far - near ) * depth - far );
}`, cFe = `#ifdef PREMULTIPLIED_ALPHA
	gl_FragColor.rgb *= gl_FragColor.a;
#endif`, hFe = `vec4 mvPosition = vec4( transformed, 1.0 );
#ifdef USE_BATCHING
	mvPosition = batchingMatrix * mvPosition;
#endif
#ifdef USE_INSTANCING
	mvPosition = instanceMatrix * mvPosition;
#endif
mvPosition = modelViewMatrix * mvPosition;
gl_Position = projectionMatrix * mvPosition;`, fFe = `#ifdef DITHERING
	gl_FragColor.rgb = dithering( gl_FragColor.rgb );
#endif`, IFe = `#ifdef DITHERING
	vec3 dithering( vec3 color ) {
		float grid_position = rand( gl_FragCoord.xy );
		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );
		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );
		return color + dither_shift_RGB;
	}
#endif`, pFe = `float roughnessFactor = roughness;
#ifdef USE_ROUGHNESSMAP
	vec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );
	roughnessFactor *= texelRoughness.g;
#endif`, mFe = `#ifdef USE_ROUGHNESSMAP
	uniform sampler2D roughnessMap;
#endif`, yFe = `#if NUM_SPOT_LIGHT_COORDS > 0
	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#if NUM_SPOT_LIGHT_MAPS > 0
	uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];
		struct SpotLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {
		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );
	}
	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {
		return unpackRGBATo2Half( texture2D( shadow, uv ) );
	}
	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){
		float occlusion = 1.0;
		vec2 distribution = texture2DDistribution( shadow, uv );
		float hard_shadow = step( compare , distribution.x );
		if (hard_shadow != 1.0 ) {
			float distance = compare - distribution.x ;
			float variance = max( 0.00000, distribution.y * distribution.y );
			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );
		}
		return occlusion;
	}
	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {
		float shadow = 1.0;
		shadowCoord.xyz /= shadowCoord.w;
		shadowCoord.z += shadowBias;
		bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;
		bool frustumTest = inFrustum && shadowCoord.z <= 1.0;
		if ( frustumTest ) {
		#if defined( SHADOWMAP_TYPE_PCF )
			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
			float dx0 = - texelSize.x * shadowRadius;
			float dy0 = - texelSize.y * shadowRadius;
			float dx1 = + texelSize.x * shadowRadius;
			float dy1 = + texelSize.y * shadowRadius;
			float dx2 = dx0 / 2.0;
			float dy2 = dy0 / 2.0;
			float dx3 = dx1 / 2.0;
			float dy3 = dy1 / 2.0;
			shadow = (
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )
			) * ( 1.0 / 17.0 );
		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )
			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
			float dx = texelSize.x;
			float dy = texelSize.y;
			vec2 uv = shadowCoord.xy;
			vec2 f = fract( uv * shadowMapSize + 0.5 );
			uv -= f * texelSize;
			shadow = (
				texture2DCompare( shadowMap, uv, shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +
				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),
					 f.x ) +
				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),
					 f.x ) +
				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),
					 f.y ) +
				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),
					 f.y ) +
				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),
						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),
						  f.x ),
					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),
						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),
						  f.x ),
					 f.y )
			) * ( 1.0 / 9.0 );
		#elif defined( SHADOWMAP_TYPE_VSM )
			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );
		#else
			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );
		#endif
		}
		return mix( 1.0, shadow, shadowIntensity );
	}
	vec2 cubeToUV( vec3 v, float texelSizeY ) {
		vec3 absV = abs( v );
		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );
		absV *= scaleToCube;
		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );
		vec2 planar = v.xy;
		float almostATexel = 1.5 * texelSizeY;
		float almostOne = 1.0 - almostATexel;
		if ( absV.z >= almostOne ) {
			if ( v.z > 0.0 )
				planar.x = 4.0 - v.x;
		} else if ( absV.x >= almostOne ) {
			float signX = sign( v.x );
			planar.x = v.z * signX + 2.0 * signX;
		} else if ( absV.y >= almostOne ) {
			float signY = sign( v.y );
			planar.x = v.x + 2.0 * signY + 2.0;
			planar.y = v.z * signY - 2.0;
		}
		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );
	}
	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {
		float shadow = 1.0;
		vec3 lightToPosition = shadowCoord.xyz;
		
		float lightToPositionLength = length( lightToPosition );
		if ( lightToPositionLength - shadowCameraFar <= 0.0 && lightToPositionLength - shadowCameraNear >= 0.0 ) {
			float dp = ( lightToPositionLength - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );			dp += shadowBias;
			vec3 bd3D = normalize( lightToPosition );
			vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );
			#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )
				vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;
				shadow = (
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )
				) * ( 1.0 / 9.0 );
			#else
				shadow = texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );
			#endif
		}
		return mix( 1.0, shadow, shadowIntensity );
	}
#endif`, EFe = `#if NUM_SPOT_LIGHT_COORDS > 0
	uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];
	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		struct SpotLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
#endif`, gFe = `#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )
	vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
	vec4 shadowWorldPosition;
#endif
#if defined( USE_SHADOWMAP )
	#if NUM_DIR_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );
			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );
			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
#endif
#if NUM_SPOT_LIGHT_COORDS > 0
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {
		shadowWorldPosition = worldPosition;
		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;
		#endif
		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;
	}
	#pragma unroll_loop_end
#endif`, wFe = `float getShadowMask() {
	float shadow = 1.0;
	#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
		directionalLight = directionalLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {
		spotLight = spotLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
		pointLight = pointLightShadows[ i ];
		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#endif
	return shadow;
}`, TFe = `#ifdef USE_SKINNING
	mat4 boneMatX = getBoneMatrix( skinIndex.x );
	mat4 boneMatY = getBoneMatrix( skinIndex.y );
	mat4 boneMatZ = getBoneMatrix( skinIndex.z );
	mat4 boneMatW = getBoneMatrix( skinIndex.w );
#endif`, RFe = `#ifdef USE_SKINNING
	uniform mat4 bindMatrix;
	uniform mat4 bindMatrixInverse;
	uniform highp sampler2D boneTexture;
	mat4 getBoneMatrix( const in float i ) {
		int size = textureSize( boneTexture, 0 ).x;
		int j = int( i ) * 4;
		int x = j % size;
		int y = j / size;
		vec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );
		vec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );
		vec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );
		vec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );
		return mat4( v1, v2, v3, v4 );
	}
#endif`, vFe = `#ifdef USE_SKINNING
	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );
	vec4 skinned = vec4( 0.0 );
	skinned += boneMatX * skinVertex * skinWeight.x;
	skinned += boneMatY * skinVertex * skinWeight.y;
	skinned += boneMatZ * skinVertex * skinWeight.z;
	skinned += boneMatW * skinVertex * skinWeight.w;
	transformed = ( bindMatrixInverse * skinned ).xyz;
#endif`, AFe = `#ifdef USE_SKINNING
	mat4 skinMatrix = mat4( 0.0 );
	skinMatrix += skinWeight.x * boneMatX;
	skinMatrix += skinWeight.y * boneMatY;
	skinMatrix += skinWeight.z * boneMatZ;
	skinMatrix += skinWeight.w * boneMatW;
	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;
	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;
	#ifdef USE_TANGENT
		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;
	#endif
#endif`, SFe = `float specularStrength;
#ifdef USE_SPECULARMAP
	vec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );
	specularStrength = texelSpecular.r;
#else
	specularStrength = 1.0;
#endif`, bFe = `#ifdef USE_SPECULARMAP
	uniform sampler2D specularMap;
#endif`, NFe = `#if defined( TONE_MAPPING )
	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );
#endif`, DFe = `#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
uniform float toneMappingExposure;
vec3 LinearToneMapping( vec3 color ) {
	return saturate( toneMappingExposure * color );
}
vec3 ReinhardToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	return saturate( color / ( vec3( 1.0 ) + color ) );
}
vec3 CineonToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	color = max( vec3( 0.0 ), color - 0.004 );
	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );
}
vec3 RRTAndODTFit( vec3 v ) {
	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;
	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;
	return a / b;
}
vec3 ACESFilmicToneMapping( vec3 color ) {
	const mat3 ACESInputMat = mat3(
		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),
		vec3( 0.04823, 0.01566, 0.83777 )
	);
	const mat3 ACESOutputMat = mat3(
		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),
		vec3( -0.07367, -0.00605,  1.07602 )
	);
	color *= toneMappingExposure / 0.6;
	color = ACESInputMat * color;
	color = RRTAndODTFit( color );
	color = ACESOutputMat * color;
	return saturate( color );
}
const mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(
	vec3( 1.6605, - 0.1246, - 0.0182 ),
	vec3( - 0.5876, 1.1329, - 0.1006 ),
	vec3( - 0.0728, - 0.0083, 1.1187 )
);
const mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(
	vec3( 0.6274, 0.0691, 0.0164 ),
	vec3( 0.3293, 0.9195, 0.0880 ),
	vec3( 0.0433, 0.0113, 0.8956 )
);
vec3 agxDefaultContrastApprox( vec3 x ) {
	vec3 x2 = x * x;
	vec3 x4 = x2 * x2;
	return + 15.5 * x4 * x2
		- 40.14 * x4 * x
		+ 31.96 * x4
		- 6.868 * x2 * x
		+ 0.4298 * x2
		+ 0.1191 * x
		- 0.00232;
}
vec3 AgXToneMapping( vec3 color ) {
	const mat3 AgXInsetMatrix = mat3(
		vec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),
		vec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),
		vec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )
	);
	const mat3 AgXOutsetMatrix = mat3(
		vec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),
		vec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),
		vec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )
	);
	const float AgxMinEv = - 12.47393;	const float AgxMaxEv = 4.026069;
	color *= toneMappingExposure;
	color = LINEAR_SRGB_TO_LINEAR_REC2020 * color;
	color = AgXInsetMatrix * color;
	color = max( color, 1e-10 );	color = log2( color );
	color = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );
	color = clamp( color, 0.0, 1.0 );
	color = agxDefaultContrastApprox( color );
	color = AgXOutsetMatrix * color;
	color = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );
	color = LINEAR_REC2020_TO_LINEAR_SRGB * color;
	color = clamp( color, 0.0, 1.0 );
	return color;
}
vec3 NeutralToneMapping( vec3 color ) {
	const float StartCompression = 0.8 - 0.04;
	const float Desaturation = 0.15;
	color *= toneMappingExposure;
	float x = min( color.r, min( color.g, color.b ) );
	float offset = x < 0.08 ? x - 6.25 * x * x : 0.04;
	color -= offset;
	float peak = max( color.r, max( color.g, color.b ) );
	if ( peak < StartCompression ) return color;
	float d = 1. - StartCompression;
	float newPeak = 1. - d * d / ( peak + d - StartCompression );
	color *= newPeak / peak;
	float g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );
	return mix( color, vec3( newPeak ), g );
}
vec3 CustomToneMapping( vec3 color ) { return color; }`, CFe = `#ifdef USE_TRANSMISSION
	material.transmission = transmission;
	material.transmissionAlpha = 1.0;
	material.thickness = thickness;
	material.attenuationDistance = attenuationDistance;
	material.attenuationColor = attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		material.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;
	#endif
	#ifdef USE_THICKNESSMAP
		material.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;
	#endif
	vec3 pos = vWorldPosition;
	vec3 v = normalize( cameraPosition - pos );
	vec3 n = inverseTransformDirection( normal, viewMatrix );
	vec4 transmitted = getIBLVolumeRefraction(
		n, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,
		pos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,
		material.attenuationColor, material.attenuationDistance );
	material.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );
	totalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );
#endif`, OFe = `#ifdef USE_TRANSMISSION
	uniform float transmission;
	uniform float thickness;
	uniform float attenuationDistance;
	uniform vec3 attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		uniform sampler2D transmissionMap;
	#endif
	#ifdef USE_THICKNESSMAP
		uniform sampler2D thicknessMap;
	#endif
	uniform vec2 transmissionSamplerSize;
	uniform sampler2D transmissionSamplerMap;
	uniform mat4 modelMatrix;
	uniform mat4 projectionMatrix;
	varying vec3 vWorldPosition;
	float w0( float a ) {
		return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );
	}
	float w1( float a ) {
		return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );
	}
	float w2( float a ){
		return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );
	}
	float w3( float a ) {
		return ( 1.0 / 6.0 ) * ( a * a * a );
	}
	float g0( float a ) {
		return w0( a ) + w1( a );
	}
	float g1( float a ) {
		return w2( a ) + w3( a );
	}
	float h0( float a ) {
		return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );
	}
	float h1( float a ) {
		return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );
	}
	vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {
		uv = uv * texelSize.zw + 0.5;
		vec2 iuv = floor( uv );
		vec2 fuv = fract( uv );
		float g0x = g0( fuv.x );
		float g1x = g1( fuv.x );
		float h0x = h0( fuv.x );
		float h1x = h1( fuv.x );
		float h0y = h0( fuv.y );
		float h1y = h1( fuv.y );
		vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
		vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
		vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;
		vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;
		return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +
			g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );
	}
	vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {
		vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );
		vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );
		vec2 fLodSizeInv = 1.0 / fLodSize;
		vec2 cLodSizeInv = 1.0 / cLodSize;
		vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );
		vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );
		return mix( fSample, cSample, fract( lod ) );
	}
	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {
		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );
		vec3 modelScale;
		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );
		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );
		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );
		return normalize( refractionVector ) * thickness * modelScale;
	}
	float applyIorToRoughness( const in float roughness, const in float ior ) {
		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );
	}
	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {
		float lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );
		return textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );
	}
	vec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {
		if ( isinf( attenuationDistance ) ) {
			return vec3( 1.0 );
		} else {
			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;
			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance;
		}
	}
	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,
		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,
		const in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,
		const in vec3 attenuationColor, const in float attenuationDistance ) {
		vec4 transmittedLight;
		vec3 transmittance;
		#ifdef USE_DISPERSION
			float halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;
			vec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );
			for ( int i = 0; i < 3; i ++ ) {
				vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );
				vec3 refractedRayExit = position + transmissionRay;
				vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );
				vec2 refractionCoords = ndcPos.xy / ndcPos.w;
				refractionCoords += 1.0;
				refractionCoords /= 2.0;
				vec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );
				transmittedLight[ i ] = transmissionSample[ i ];
				transmittedLight.a += transmissionSample.a;
				transmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];
			}
			transmittedLight.a /= 3.0;
		#else
			vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );
			vec3 refractedRayExit = position + transmissionRay;
			vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );
			vec2 refractionCoords = ndcPos.xy / ndcPos.w;
			refractionCoords += 1.0;
			refractionCoords /= 2.0;
			transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );
			transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );
		#endif
		vec3 attenuatedColor = transmittance * transmittedLight.rgb;
		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );
		float transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;
		return vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );
	}
#endif`, LFe = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	varying vec2 vUv;
#endif
#ifdef USE_MAP
	varying vec2 vMapUv;
#endif
#ifdef USE_ALPHAMAP
	varying vec2 vAlphaMapUv;
#endif
#ifdef USE_LIGHTMAP
	varying vec2 vLightMapUv;
#endif
#ifdef USE_AOMAP
	varying vec2 vAoMapUv;
#endif
#ifdef USE_BUMPMAP
	varying vec2 vBumpMapUv;
#endif
#ifdef USE_NORMALMAP
	varying vec2 vNormalMapUv;
#endif
#ifdef USE_EMISSIVEMAP
	varying vec2 vEmissiveMapUv;
#endif
#ifdef USE_METALNESSMAP
	varying vec2 vMetalnessMapUv;
#endif
#ifdef USE_ROUGHNESSMAP
	varying vec2 vRoughnessMapUv;
#endif
#ifdef USE_ANISOTROPYMAP
	varying vec2 vAnisotropyMapUv;
#endif
#ifdef USE_CLEARCOATMAP
	varying vec2 vClearcoatMapUv;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	varying vec2 vClearcoatNormalMapUv;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	varying vec2 vClearcoatRoughnessMapUv;
#endif
#ifdef USE_IRIDESCENCEMAP
	varying vec2 vIridescenceMapUv;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	varying vec2 vIridescenceThicknessMapUv;
#endif
#ifdef USE_SHEEN_COLORMAP
	varying vec2 vSheenColorMapUv;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	varying vec2 vSheenRoughnessMapUv;
#endif
#ifdef USE_SPECULARMAP
	varying vec2 vSpecularMapUv;
#endif
#ifdef USE_SPECULAR_COLORMAP
	varying vec2 vSpecularColorMapUv;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	varying vec2 vSpecularIntensityMapUv;
#endif
#ifdef USE_TRANSMISSIONMAP
	uniform mat3 transmissionMapTransform;
	varying vec2 vTransmissionMapUv;
#endif
#ifdef USE_THICKNESSMAP
	uniform mat3 thicknessMapTransform;
	varying vec2 vThicknessMapUv;
#endif`, _Fe = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	varying vec2 vUv;
#endif
#ifdef USE_MAP
	uniform mat3 mapTransform;
	varying vec2 vMapUv;
#endif
#ifdef USE_ALPHAMAP
	uniform mat3 alphaMapTransform;
	varying vec2 vAlphaMapUv;
#endif
#ifdef USE_LIGHTMAP
	uniform mat3 lightMapTransform;
	varying vec2 vLightMapUv;
#endif
#ifdef USE_AOMAP
	uniform mat3 aoMapTransform;
	varying vec2 vAoMapUv;
#endif
#ifdef USE_BUMPMAP
	uniform mat3 bumpMapTransform;
	varying vec2 vBumpMapUv;
#endif
#ifdef USE_NORMALMAP
	uniform mat3 normalMapTransform;
	varying vec2 vNormalMapUv;
#endif
#ifdef USE_DISPLACEMENTMAP
	uniform mat3 displacementMapTransform;
	varying vec2 vDisplacementMapUv;
#endif
#ifdef USE_EMISSIVEMAP
	uniform mat3 emissiveMapTransform;
	varying vec2 vEmissiveMapUv;
#endif
#ifdef USE_METALNESSMAP
	uniform mat3 metalnessMapTransform;
	varying vec2 vMetalnessMapUv;
#endif
#ifdef USE_ROUGHNESSMAP
	uniform mat3 roughnessMapTransform;
	varying vec2 vRoughnessMapUv;
#endif
#ifdef USE_ANISOTROPYMAP
	uniform mat3 anisotropyMapTransform;
	varying vec2 vAnisotropyMapUv;
#endif
#ifdef USE_CLEARCOATMAP
	uniform mat3 clearcoatMapTransform;
	varying vec2 vClearcoatMapUv;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	uniform mat3 clearcoatNormalMapTransform;
	varying vec2 vClearcoatNormalMapUv;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	uniform mat3 clearcoatRoughnessMapTransform;
	varying vec2 vClearcoatRoughnessMapUv;
#endif
#ifdef USE_SHEEN_COLORMAP
	uniform mat3 sheenColorMapTransform;
	varying vec2 vSheenColorMapUv;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	uniform mat3 sheenRoughnessMapTransform;
	varying vec2 vSheenRoughnessMapUv;
#endif
#ifdef USE_IRIDESCENCEMAP
	uniform mat3 iridescenceMapTransform;
	varying vec2 vIridescenceMapUv;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	uniform mat3 iridescenceThicknessMapTransform;
	varying vec2 vIridescenceThicknessMapUv;
#endif
#ifdef USE_SPECULARMAP
	uniform mat3 specularMapTransform;
	varying vec2 vSpecularMapUv;
#endif
#ifdef USE_SPECULAR_COLORMAP
	uniform mat3 specularColorMapTransform;
	varying vec2 vSpecularColorMapUv;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	uniform mat3 specularIntensityMapTransform;
	varying vec2 vSpecularIntensityMapUv;
#endif
#ifdef USE_TRANSMISSIONMAP
	uniform mat3 transmissionMapTransform;
	varying vec2 vTransmissionMapUv;
#endif
#ifdef USE_THICKNESSMAP
	uniform mat3 thicknessMapTransform;
	varying vec2 vThicknessMapUv;
#endif`, xFe = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	vUv = vec3( uv, 1 ).xy;
#endif
#ifdef USE_MAP
	vMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ALPHAMAP
	vAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_LIGHTMAP
	vLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_AOMAP
	vAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_BUMPMAP
	vBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_NORMALMAP
	vNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_DISPLACEMENTMAP
	vDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_EMISSIVEMAP
	vEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_METALNESSMAP
	vMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ROUGHNESSMAP
	vRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ANISOTROPYMAP
	vAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOATMAP
	vClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	vClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	vClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_IRIDESCENCEMAP
	vIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	vIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SHEEN_COLORMAP
	vSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	vSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULARMAP
	vSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULAR_COLORMAP
	vSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	vSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_TRANSMISSIONMAP
	vTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_THICKNESSMAP
	vThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;
#endif`, PFe = `#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0
	vec4 worldPosition = vec4( transformed, 1.0 );
	#ifdef USE_BATCHING
		worldPosition = batchingMatrix * worldPosition;
	#endif
	#ifdef USE_INSTANCING
		worldPosition = instanceMatrix * worldPosition;
	#endif
	worldPosition = modelMatrix * worldPosition;
#endif`;
const MFe = `varying vec2 vUv;
uniform mat3 uvTransform;
void main() {
	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
	gl_Position = vec4( position.xy, 1.0, 1.0 );
}`, UFe = `uniform sampler2D t2D;
uniform float backgroundIntensity;
varying vec2 vUv;
void main() {
	vec4 texColor = texture2D( t2D, vUv );
	#ifdef DECODE_VIDEO_TEXTURE
		texColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`, BFe = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`, FFe = `#ifdef ENVMAP_TYPE_CUBE
	uniform samplerCube envMap;
#elif defined( ENVMAP_TYPE_CUBE_UV )
	uniform sampler2D envMap;
#endif
uniform float flipEnvMap;
uniform float backgroundBlurriness;
uniform float backgroundIntensity;
uniform mat3 backgroundRotation;
varying vec3 vWorldDirection;
#include <cube_uv_reflection_fragment>
void main() {
	#ifdef ENVMAP_TYPE_CUBE
		vec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );
	#elif defined( ENVMAP_TYPE_CUBE_UV )
		vec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );
	#else
		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`, HFe = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`, GFe = `uniform samplerCube tCube;
uniform float tFlip;
uniform float opacity;
varying vec3 vWorldDirection;
void main() {
	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );
	gl_FragColor = texColor;
	gl_FragColor.a *= opacity;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`, kFe = `#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
varying vec2 vHighPrecisionZW;
void main() {
	#include <uv_vertex>
	#include <batching_vertex>
	#include <skinbase_vertex>
	#include <morphinstance_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vHighPrecisionZW = gl_Position.zw;
}`, VFe = `#if DEPTH_PACKING == 3200
	uniform float opacity;
#endif
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
varying vec2 vHighPrecisionZW;
void main() {
	vec4 diffuseColor = vec4( 1.0 );
	#include <clipping_planes_fragment>
	#if DEPTH_PACKING == 3200
		diffuseColor.a = opacity;
	#endif
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <logdepthbuf_fragment>
	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;
	#if DEPTH_PACKING == 3200
		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );
	#elif DEPTH_PACKING == 3201
		gl_FragColor = packDepthToRGBA( fragCoordZ );
	#elif DEPTH_PACKING == 3202
		gl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );
	#elif DEPTH_PACKING == 3203
		gl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );
	#endif
}`, zFe = `#define DISTANCE
varying vec3 vWorldPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <batching_vertex>
	#include <skinbase_vertex>
	#include <morphinstance_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <worldpos_vertex>
	#include <clipping_planes_vertex>
	vWorldPosition = worldPosition.xyz;
}`, jFe = `#define DISTANCE
uniform vec3 referencePosition;
uniform float nearDistance;
uniform float farDistance;
varying vec3 vWorldPosition;
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <clipping_planes_pars_fragment>
void main () {
	vec4 diffuseColor = vec4( 1.0 );
	#include <clipping_planes_fragment>
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	float dist = length( vWorldPosition - referencePosition );
	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );
	dist = saturate( dist );
	gl_FragColor = packDepthToRGBA( dist );
}`, WFe = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
}`, YFe = `uniform sampler2D tEquirect;
varying vec3 vWorldDirection;
#include <common>
void main() {
	vec3 direction = normalize( vWorldDirection );
	vec2 sampleUV = equirectUv( direction );
	gl_FragColor = texture2D( tEquirect, sampleUV );
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`, qFe = `uniform float scale;
attribute float lineDistance;
varying float vLineDistance;
#include <common>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	vLineDistance = scale * lineDistance;
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`, $Fe = `uniform vec3 diffuse;
uniform float opacity;
uniform float dashSize;
uniform float totalSize;
varying float vLineDistance;
#include <common>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	if ( mod( vLineDistance, totalSize ) > dashSize ) {
		discard;
	}
	vec3 outgoingLight = vec3( 0.0 );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`, KFe = `#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinbase_vertex>
		#include <skinnormal_vertex>
		#include <defaultnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <fog_vertex>
}`, ZFe = `uniform vec3 diffuse;
uniform float opacity;
#ifndef FLAT_SHADED
	varying vec3 vNormal;
#endif
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );
		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;
	#else
		reflectedLight.indirectDiffuse += vec3( 1.0 );
	#endif
	#include <aomap_fragment>
	reflectedLight.indirectDiffuse *= diffuseColor.rgb;
	vec3 outgoingLight = reflectedLight.indirectDiffuse;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, QFe = `#define LAMBERT
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, JFe = `#define LAMBERT
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_lambert_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_lambert_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, XFe = `#define MATCAP
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <displacementmap_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
	vViewPosition = - mvPosition.xyz;
}`, eHe = `#define MATCAP
uniform vec3 diffuse;
uniform float opacity;
uniform sampler2D matcap;
varying vec3 vViewPosition;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	vec3 viewDir = normalize( vViewPosition );
	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );
	vec3 y = cross( viewDir, x );
	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;
	#ifdef USE_MATCAP
		vec4 matcapColor = texture2D( matcap, uv );
	#else
		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );
	#endif
	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, tHe = `#define NORMAL
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	varying vec3 vViewPosition;
#endif
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	vViewPosition = - mvPosition.xyz;
#endif
}`, iHe = `#define NORMAL
uniform float opacity;
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	varying vec3 vViewPosition;
#endif
#include <packing>
#include <uv_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	gl_FragColor = vec4( packNormalToRGB( normal ), diffuseColor.a );
	#ifdef OPAQUE
		gl_FragColor.a = 1.0;
	#endif
}`, nHe = `#define PHONG
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, sHe = `#define PHONG
uniform vec3 diffuse;
uniform vec3 emissive;
uniform vec3 specular;
uniform float shininess;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_phong_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_phong_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, oHe = `#define STANDARD
varying vec3 vViewPosition;
#ifdef USE_TRANSMISSION
	varying vec3 vWorldPosition;
#endif
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
#ifdef USE_TRANSMISSION
	vWorldPosition = worldPosition.xyz;
#endif
}`, rHe = `#define STANDARD
#ifdef PHYSICAL
	#define IOR
	#define USE_SPECULAR
#endif
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float roughness;
uniform float metalness;
uniform float opacity;
#ifdef IOR
	uniform float ior;
#endif
#ifdef USE_SPECULAR
	uniform float specularIntensity;
	uniform vec3 specularColor;
	#ifdef USE_SPECULAR_COLORMAP
		uniform sampler2D specularColorMap;
	#endif
	#ifdef USE_SPECULAR_INTENSITYMAP
		uniform sampler2D specularIntensityMap;
	#endif
#endif
#ifdef USE_CLEARCOAT
	uniform float clearcoat;
	uniform float clearcoatRoughness;
#endif
#ifdef USE_DISPERSION
	uniform float dispersion;
#endif
#ifdef USE_IRIDESCENCE
	uniform float iridescence;
	uniform float iridescenceIOR;
	uniform float iridescenceThicknessMinimum;
	uniform float iridescenceThicknessMaximum;
#endif
#ifdef USE_SHEEN
	uniform vec3 sheenColor;
	uniform float sheenRoughness;
	#ifdef USE_SHEEN_COLORMAP
		uniform sampler2D sheenColorMap;
	#endif
	#ifdef USE_SHEEN_ROUGHNESSMAP
		uniform sampler2D sheenRoughnessMap;
	#endif
#endif
#ifdef USE_ANISOTROPY
	uniform vec2 anisotropyVector;
	#ifdef USE_ANISOTROPYMAP
		uniform sampler2D anisotropyMap;
	#endif
#endif
varying vec3 vViewPosition;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <iridescence_fragment>
#include <cube_uv_reflection_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_physical_pars_fragment>
#include <fog_pars_fragment>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_physical_pars_fragment>
#include <transmission_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <clearcoat_pars_fragment>
#include <iridescence_pars_fragment>
#include <roughnessmap_pars_fragment>
#include <metalnessmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <roughnessmap_fragment>
	#include <metalnessmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <clearcoat_normal_fragment_begin>
	#include <clearcoat_normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_physical_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;
	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;
	#include <transmission_fragment>
	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;
	#ifdef USE_SHEEN
		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );
		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;
	#endif
	#ifdef USE_CLEARCOAT
		float dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );
		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );
		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;
	#endif
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, lHe = `#define TOON
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, aHe = `#define TOON
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <gradientmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_toon_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_toon_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, uHe = `uniform float size;
uniform float scale;
#include <common>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
#ifdef USE_POINTS_UV
	varying vec2 vUv;
	uniform mat3 uvTransform;
#endif
void main() {
	#ifdef USE_POINTS_UV
		vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
	#endif
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	gl_PointSize = size;
	#ifdef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );
	#endif
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <fog_vertex>
}`, dHe = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <color_pars_fragment>
#include <map_particle_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	#include <logdepthbuf_fragment>
	#include <map_particle_fragment>
	#include <color_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`, cHe = `#include <common>
#include <batching_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <shadowmap_pars_vertex>
void main() {
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, hHe = `uniform vec3 color;
uniform float opacity;
#include <common>
#include <packing>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <logdepthbuf_pars_fragment>
#include <shadowmap_pars_fragment>
#include <shadowmask_pars_fragment>
void main() {
	#include <logdepthbuf_fragment>
	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
}`, fHe = `uniform float rotation;
uniform vec2 center;
#include <common>
#include <uv_pars_vertex>
#include <fog_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	vec4 mvPosition = modelViewMatrix[ 3 ];
	vec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );
	#ifndef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) scale *= - mvPosition.z;
	#endif
	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;
	vec2 rotatedPosition;
	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;
	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;
	mvPosition.xy += rotatedPosition;
	gl_Position = projectionMatrix * mvPosition;
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`, IHe = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
}`, Lo = {
  alphahash_fragment: UUe,
  alphahash_pars_fragment: BUe,
  alphamap_fragment: FUe,
  alphamap_pars_fragment: HUe,
  alphatest_fragment: GUe,
  alphatest_pars_fragment: kUe,
  aomap_fragment: VUe,
  aomap_pars_fragment: zUe,
  batching_pars_vertex: jUe,
  batching_vertex: WUe,
  begin_vertex: YUe,
  beginnormal_vertex: qUe,
  bsdfs: $Ue,
  iridescence_fragment: KUe,
  bumpmap_pars_fragment: ZUe,
  clipping_planes_fragment: QUe,
  clipping_planes_pars_fragment: JUe,
  clipping_planes_pars_vertex: XUe,
  clipping_planes_vertex: eBe,
  color_fragment: tBe,
  color_pars_fragment: iBe,
  color_pars_vertex: nBe,
  color_vertex: sBe,
  common: oBe,
  cube_uv_reflection_fragment: rBe,
  defaultnormal_vertex: lBe,
  displacementmap_pars_vertex: aBe,
  displacementmap_vertex: uBe,
  emissivemap_fragment: dBe,
  emissivemap_pars_fragment: cBe,
  colorspace_fragment: hBe,
  colorspace_pars_fragment: fBe,
  envmap_fragment: IBe,
  envmap_common_pars_fragment: pBe,
  envmap_pars_fragment: mBe,
  envmap_pars_vertex: yBe,
  envmap_physical_pars_fragment: DBe,
  envmap_vertex: EBe,
  fog_vertex: gBe,
  fog_pars_vertex: wBe,
  fog_fragment: TBe,
  fog_pars_fragment: RBe,
  gradientmap_pars_fragment: vBe,
  lightmap_pars_fragment: ABe,
  lights_lambert_fragment: SBe,
  lights_lambert_pars_fragment: bBe,
  lights_pars_begin: NBe,
  lights_toon_fragment: CBe,
  lights_toon_pars_fragment: OBe,
  lights_phong_fragment: LBe,
  lights_phong_pars_fragment: _Be,
  lights_physical_fragment: xBe,
  lights_physical_pars_fragment: PBe,
  lights_fragment_begin: MBe,
  lights_fragment_maps: UBe,
  lights_fragment_end: BBe,
  logdepthbuf_fragment: FBe,
  logdepthbuf_pars_fragment: HBe,
  logdepthbuf_pars_vertex: GBe,
  logdepthbuf_vertex: kBe,
  map_fragment: VBe,
  map_pars_fragment: zBe,
  map_particle_fragment: jBe,
  map_particle_pars_fragment: WBe,
  metalnessmap_fragment: YBe,
  metalnessmap_pars_fragment: qBe,
  morphinstance_vertex: $Be,
  morphcolor_vertex: KBe,
  morphnormal_vertex: ZBe,
  morphtarget_pars_vertex: QBe,
  morphtarget_vertex: JBe,
  normal_fragment_begin: XBe,
  normal_fragment_maps: eFe,
  normal_pars_fragment: tFe,
  normal_pars_vertex: iFe,
  normal_vertex: nFe,
  normalmap_pars_fragment: sFe,
  clearcoat_normal_fragment_begin: oFe,
  clearcoat_normal_fragment_maps: rFe,
  clearcoat_pars_fragment: lFe,
  iridescence_pars_fragment: aFe,
  opaque_fragment: uFe,
  packing: dFe,
  premultiplied_alpha_fragment: cFe,
  project_vertex: hFe,
  dithering_fragment: fFe,
  dithering_pars_fragment: IFe,
  roughnessmap_fragment: pFe,
  roughnessmap_pars_fragment: mFe,
  shadowmap_pars_fragment: yFe,
  shadowmap_pars_vertex: EFe,
  shadowmap_vertex: gFe,
  shadowmask_pars_fragment: wFe,
  skinbase_vertex: TFe,
  skinning_pars_vertex: RFe,
  skinning_vertex: vFe,
  skinnormal_vertex: AFe,
  specularmap_fragment: SFe,
  specularmap_pars_fragment: bFe,
  tonemapping_fragment: NFe,
  tonemapping_pars_fragment: DFe,
  transmission_fragment: CFe,
  transmission_pars_fragment: OFe,
  uv_pars_fragment: LFe,
  uv_pars_vertex: _Fe,
  uv_vertex: xFe,
  worldpos_vertex: PFe,
  background_vert: MFe,
  background_frag: UFe,
  backgroundCube_vert: BFe,
  backgroundCube_frag: FFe,
  cube_vert: HFe,
  cube_frag: GFe,
  depth_vert: kFe,
  depth_frag: VFe,
  distanceRGBA_vert: zFe,
  distanceRGBA_frag: jFe,
  equirect_vert: WFe,
  equirect_frag: YFe,
  linedashed_vert: qFe,
  linedashed_frag: $Fe,
  meshbasic_vert: KFe,
  meshbasic_frag: ZFe,
  meshlambert_vert: QFe,
  meshlambert_frag: JFe,
  meshmatcap_vert: XFe,
  meshmatcap_frag: eHe,
  meshnormal_vert: tHe,
  meshnormal_frag: iHe,
  meshphong_vert: nHe,
  meshphong_frag: sHe,
  meshphysical_vert: oHe,
  meshphysical_frag: rHe,
  meshtoon_vert: lHe,
  meshtoon_frag: aHe,
  points_vert: uHe,
  points_frag: dHe,
  shadow_vert: cHe,
  shadow_frag: hHe,
  sprite_vert: fHe,
  sprite_frag: IHe
}, An = {
  common: {
    diffuse: { value: /* @__PURE__ */ new Xn(16777215) },
    opacity: { value: 1 },
    map: { value: null },
    mapTransform: { value: /* @__PURE__ */ new fo() },
    alphaMap: { value: null },
    alphaMapTransform: { value: /* @__PURE__ */ new fo() },
    alphaTest: { value: 0 }
  },
  specularmap: {
    specularMap: { value: null },
    specularMapTransform: { value: /* @__PURE__ */ new fo() }
  },
  envmap: {
    envMap: { value: null },
    envMapRotation: { value: /* @__PURE__ */ new fo() },
    flipEnvMap: { value: -1 },
    reflectivity: { value: 1 },
    // basic, lambert, phong
    ior: { value: 1.5 },
    // physical
    refractionRatio: { value: 0.98 }
    // basic, lambert, phong
  },
  aomap: {
    aoMap: { value: null },
    aoMapIntensity: { value: 1 },
    aoMapTransform: { value: /* @__PURE__ */ new fo() }
  },
  lightmap: {
    lightMap: { value: null },
    lightMapIntensity: { value: 1 },
    lightMapTransform: { value: /* @__PURE__ */ new fo() }
  },
  bumpmap: {
    bumpMap: { value: null },
    bumpMapTransform: { value: /* @__PURE__ */ new fo() },
    bumpScale: { value: 1 }
  },
  normalmap: {
    normalMap: { value: null },
    normalMapTransform: { value: /* @__PURE__ */ new fo() },
    normalScale: { value: /* @__PURE__ */ new us(1, 1) }
  },
  displacementmap: {
    displacementMap: { value: null },
    displacementMapTransform: { value: /* @__PURE__ */ new fo() },
    displacementScale: { value: 1 },
    displacementBias: { value: 0 }
  },
  emissivemap: {
    emissiveMap: { value: null },
    emissiveMapTransform: { value: /* @__PURE__ */ new fo() }
  },
  metalnessmap: {
    metalnessMap: { value: null },
    metalnessMapTransform: { value: /* @__PURE__ */ new fo() }
  },
  roughnessmap: {
    roughnessMap: { value: null },
    roughnessMapTransform: { value: /* @__PURE__ */ new fo() }
  },
  gradientmap: {
    gradientMap: { value: null }
  },
  fog: {
    fogDensity: { value: 25e-5 },
    fogNear: { value: 1 },
    fogFar: { value: 2e3 },
    fogColor: { value: /* @__PURE__ */ new Xn(16777215) }
  },
  lights: {
    ambientLightColor: { value: [] },
    lightProbe: { value: [] },
    directionalLights: { value: [], properties: {
      direction: {},
      color: {}
    } },
    directionalLightShadows: { value: [], properties: {
      shadowIntensity: 1,
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {}
    } },
    directionalShadowMap: { value: [] },
    directionalShadowMatrix: { value: [] },
    spotLights: { value: [], properties: {
      color: {},
      position: {},
      direction: {},
      distance: {},
      coneCos: {},
      penumbraCos: {},
      decay: {}
    } },
    spotLightShadows: { value: [], properties: {
      shadowIntensity: 1,
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {}
    } },
    spotLightMap: { value: [] },
    spotShadowMap: { value: [] },
    spotLightMatrix: { value: [] },
    pointLights: { value: [], properties: {
      color: {},
      position: {},
      decay: {},
      distance: {}
    } },
    pointLightShadows: { value: [], properties: {
      shadowIntensity: 1,
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {},
      shadowCameraNear: {},
      shadowCameraFar: {}
    } },
    pointShadowMap: { value: [] },
    pointShadowMatrix: { value: [] },
    hemisphereLights: { value: [], properties: {
      direction: {},
      skyColor: {},
      groundColor: {}
    } },
    // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
    rectAreaLights: { value: [], properties: {
      color: {},
      position: {},
      width: {},
      height: {}
    } },
    ltc_1: { value: null },
    ltc_2: { value: null }
  },
  points: {
    diffuse: { value: /* @__PURE__ */ new Xn(16777215) },
    opacity: { value: 1 },
    size: { value: 1 },
    scale: { value: 1 },
    map: { value: null },
    alphaMap: { value: null },
    alphaMapTransform: { value: /* @__PURE__ */ new fo() },
    alphaTest: { value: 0 },
    uvTransform: { value: /* @__PURE__ */ new fo() }
  },
  sprite: {
    diffuse: { value: /* @__PURE__ */ new Xn(16777215) },
    opacity: { value: 1 },
    center: { value: /* @__PURE__ */ new us(0.5, 0.5) },
    rotation: { value: 0 },
    map: { value: null },
    mapTransform: { value: /* @__PURE__ */ new fo() },
    alphaMap: { value: null },
    alphaMapTransform: { value: /* @__PURE__ */ new fo() },
    alphaTest: { value: 0 }
  }
}, Rg = {
  basic: {
    uniforms: /* @__PURE__ */ Oy([
      An.common,
      An.specularmap,
      An.envmap,
      An.aomap,
      An.lightmap,
      An.fog
    ]),
    vertexShader: Lo.meshbasic_vert,
    fragmentShader: Lo.meshbasic_frag
  },
  lambert: {
    uniforms: /* @__PURE__ */ Oy([
      An.common,
      An.specularmap,
      An.envmap,
      An.aomap,
      An.lightmap,
      An.emissivemap,
      An.bumpmap,
      An.normalmap,
      An.displacementmap,
      An.fog,
      An.lights,
      {
        emissive: { value: /* @__PURE__ */ new Xn(0) }
      }
    ]),
    vertexShader: Lo.meshlambert_vert,
    fragmentShader: Lo.meshlambert_frag
  },
  phong: {
    uniforms: /* @__PURE__ */ Oy([
      An.common,
      An.specularmap,
      An.envmap,
      An.aomap,
      An.lightmap,
      An.emissivemap,
      An.bumpmap,
      An.normalmap,
      An.displacementmap,
      An.fog,
      An.lights,
      {
        emissive: { value: /* @__PURE__ */ new Xn(0) },
        specular: { value: /* @__PURE__ */ new Xn(1118481) },
        shininess: { value: 30 }
      }
    ]),
    vertexShader: Lo.meshphong_vert,
    fragmentShader: Lo.meshphong_frag
  },
  standard: {
    uniforms: /* @__PURE__ */ Oy([
      An.common,
      An.envmap,
      An.aomap,
      An.lightmap,
      An.emissivemap,
      An.bumpmap,
      An.normalmap,
      An.displacementmap,
      An.roughnessmap,
      An.metalnessmap,
      An.fog,
      An.lights,
      {
        emissive: { value: /* @__PURE__ */ new Xn(0) },
        roughness: { value: 1 },
        metalness: { value: 0 },
        envMapIntensity: { value: 1 }
      }
    ]),
    vertexShader: Lo.meshphysical_vert,
    fragmentShader: Lo.meshphysical_frag
  },
  toon: {
    uniforms: /* @__PURE__ */ Oy([
      An.common,
      An.aomap,
      An.lightmap,
      An.emissivemap,
      An.bumpmap,
      An.normalmap,
      An.displacementmap,
      An.gradientmap,
      An.fog,
      An.lights,
      {
        emissive: { value: /* @__PURE__ */ new Xn(0) }
      }
    ]),
    vertexShader: Lo.meshtoon_vert,
    fragmentShader: Lo.meshtoon_frag
  },
  matcap: {
    uniforms: /* @__PURE__ */ Oy([
      An.common,
      An.bumpmap,
      An.normalmap,
      An.displacementmap,
      An.fog,
      {
        matcap: { value: null }
      }
    ]),
    vertexShader: Lo.meshmatcap_vert,
    fragmentShader: Lo.meshmatcap_frag
  },
  points: {
    uniforms: /* @__PURE__ */ Oy([
      An.points,
      An.fog
    ]),
    vertexShader: Lo.points_vert,
    fragmentShader: Lo.points_frag
  },
  dashed: {
    uniforms: /* @__PURE__ */ Oy([
      An.common,
      An.fog,
      {
        scale: { value: 1 },
        dashSize: { value: 1 },
        totalSize: { value: 2 }
      }
    ]),
    vertexShader: Lo.linedashed_vert,
    fragmentShader: Lo.linedashed_frag
  },
  depth: {
    uniforms: /* @__PURE__ */ Oy([
      An.common,
      An.displacementmap
    ]),
    vertexShader: Lo.depth_vert,
    fragmentShader: Lo.depth_frag
  },
  normal: {
    uniforms: /* @__PURE__ */ Oy([
      An.common,
      An.bumpmap,
      An.normalmap,
      An.displacementmap,
      {
        opacity: { value: 1 }
      }
    ]),
    vertexShader: Lo.meshnormal_vert,
    fragmentShader: Lo.meshnormal_frag
  },
  sprite: {
    uniforms: /* @__PURE__ */ Oy([
      An.sprite,
      An.fog
    ]),
    vertexShader: Lo.sprite_vert,
    fragmentShader: Lo.sprite_frag
  },
  background: {
    uniforms: {
      uvTransform: { value: /* @__PURE__ */ new fo() },
      t2D: { value: null },
      backgroundIntensity: { value: 1 }
    },
    vertexShader: Lo.background_vert,
    fragmentShader: Lo.background_frag
  },
  backgroundCube: {
    uniforms: {
      envMap: { value: null },
      flipEnvMap: { value: -1 },
      backgroundBlurriness: { value: 0 },
      backgroundIntensity: { value: 1 },
      backgroundRotation: { value: /* @__PURE__ */ new fo() }
    },
    vertexShader: Lo.backgroundCube_vert,
    fragmentShader: Lo.backgroundCube_frag
  },
  cube: {
    uniforms: {
      tCube: { value: null },
      tFlip: { value: -1 },
      opacity: { value: 1 }
    },
    vertexShader: Lo.cube_vert,
    fragmentShader: Lo.cube_frag
  },
  equirect: {
    uniforms: {
      tEquirect: { value: null }
    },
    vertexShader: Lo.equirect_vert,
    fragmentShader: Lo.equirect_frag
  },
  distanceRGBA: {
    uniforms: /* @__PURE__ */ Oy([
      An.common,
      An.displacementmap,
      {
        referencePosition: { value: /* @__PURE__ */ new Ge() },
        nearDistance: { value: 1 },
        farDistance: { value: 1e3 }
      }
    ]),
    vertexShader: Lo.distanceRGBA_vert,
    fragmentShader: Lo.distanceRGBA_frag
  },
  shadow: {
    uniforms: /* @__PURE__ */ Oy([
      An.lights,
      An.fog,
      {
        color: { value: /* @__PURE__ */ new Xn(0) },
        opacity: { value: 1 }
      }
    ]),
    vertexShader: Lo.shadow_vert,
    fragmentShader: Lo.shadow_frag
  }
};
Rg.physical = {
  uniforms: /* @__PURE__ */ Oy([
    Rg.standard.uniforms,
    {
      clearcoat: { value: 0 },
      clearcoatMap: { value: null },
      clearcoatMapTransform: { value: /* @__PURE__ */ new fo() },
      clearcoatNormalMap: { value: null },
      clearcoatNormalMapTransform: { value: /* @__PURE__ */ new fo() },
      clearcoatNormalScale: { value: /* @__PURE__ */ new us(1, 1) },
      clearcoatRoughness: { value: 0 },
      clearcoatRoughnessMap: { value: null },
      clearcoatRoughnessMapTransform: { value: /* @__PURE__ */ new fo() },
      dispersion: { value: 0 },
      iridescence: { value: 0 },
      iridescenceMap: { value: null },
      iridescenceMapTransform: { value: /* @__PURE__ */ new fo() },
      iridescenceIOR: { value: 1.3 },
      iridescenceThicknessMinimum: { value: 100 },
      iridescenceThicknessMaximum: { value: 400 },
      iridescenceThicknessMap: { value: null },
      iridescenceThicknessMapTransform: { value: /* @__PURE__ */ new fo() },
      sheen: { value: 0 },
      sheenColor: { value: /* @__PURE__ */ new Xn(0) },
      sheenColorMap: { value: null },
      sheenColorMapTransform: { value: /* @__PURE__ */ new fo() },
      sheenRoughness: { value: 1 },
      sheenRoughnessMap: { value: null },
      sheenRoughnessMapTransform: { value: /* @__PURE__ */ new fo() },
      transmission: { value: 0 },
      transmissionMap: { value: null },
      transmissionMapTransform: { value: /* @__PURE__ */ new fo() },
      transmissionSamplerSize: { value: /* @__PURE__ */ new us() },
      transmissionSamplerMap: { value: null },
      thickness: { value: 0 },
      thicknessMap: { value: null },
      thicknessMapTransform: { value: /* @__PURE__ */ new fo() },
      attenuationDistance: { value: 0 },
      attenuationColor: { value: /* @__PURE__ */ new Xn(0) },
      specularColor: { value: /* @__PURE__ */ new Xn(1, 1, 1) },
      specularColorMap: { value: null },
      specularColorMapTransform: { value: /* @__PURE__ */ new fo() },
      specularIntensity: { value: 1 },
      specularIntensityMap: { value: null },
      specularIntensityMapTransform: { value: /* @__PURE__ */ new fo() },
      anisotropyVector: { value: /* @__PURE__ */ new us() },
      anisotropyMap: { value: null },
      anisotropyMapTransform: { value: /* @__PURE__ */ new fo() }
    }
  ]),
  vertexShader: Lo.meshphysical_vert,
  fragmentShader: Lo.meshphysical_frag
};
const Kne = { r: 0, b: 0, g: 0 }, eU = /* @__PURE__ */ new UA(), pHe = /* @__PURE__ */ new Ln();
function mHe(e, t, i, n, s, o, r) {
  const l = new Xn(0);
  let c = o === !0 ? 0 : 1, h, I, p = null, y = 0, m = null;
  function A(L) {
    let P = L.isScene === !0 ? L.background : null;
    return P && P.isTexture && (P = (L.backgroundBlurriness > 0 ? i : t).get(P)), P;
  }
  function C(L) {
    let P = !1;
    const z = A(L);
    z === null ? R(l, c) : z && z.isColor && (R(z, 1), P = !0);
    const W = e.xr.getEnvironmentBlendMode();
    W === "additive" ? n.buffers.color.setClear(0, 0, 0, 1, r) : W === "alpha-blend" && n.buffers.color.setClear(0, 0, 0, 0, r), (e.autoClear || P) && (n.buffers.depth.setTest(!0), n.buffers.depth.setMask(!0), n.buffers.color.setMask(!0), e.clear(e.autoClearColor, e.autoClearDepth, e.autoClearStencil));
  }
  function O(L, P) {
    const z = A(P);
    z && (z.isCubeTexture || z.mapping === Rae) ? (I === void 0 && (I = new En(
      new L0(1, 1, 1),
      new BA({
        name: "BackgroundCubeMaterial",
        uniforms: _W(Rg.backgroundCube.uniforms),
        vertexShader: Rg.backgroundCube.vertexShader,
        fragmentShader: Rg.backgroundCube.fragmentShader,
        side: nE,
        depthTest: !1,
        depthWrite: !1,
        fog: !1,
        allowOverride: !1
      })
    ), I.geometry.deleteAttribute("normal"), I.geometry.deleteAttribute("uv"), I.onBeforeRender = function(W, re, ce) {
      this.matrixWorld.copyPosition(ce.matrixWorld);
    }, Object.defineProperty(I.material, "envMap", {
      get: function() {
        return this.uniforms.envMap.value;
      }
    }), s.update(I)), eU.copy(P.backgroundRotation), eU.x *= -1, eU.y *= -1, eU.z *= -1, z.isCubeTexture && z.isRenderTargetTexture === !1 && (eU.y *= -1, eU.z *= -1), I.material.uniforms.envMap.value = z, I.material.uniforms.flipEnvMap.value = z.isCubeTexture && z.isRenderTargetTexture === !1 ? -1 : 1, I.material.uniforms.backgroundBlurriness.value = P.backgroundBlurriness, I.material.uniforms.backgroundIntensity.value = P.backgroundIntensity, I.material.uniforms.backgroundRotation.value.setFromMatrix4(pHe.makeRotationFromEuler(eU)), I.material.toneMapped = Qr.getTransfer(z.colorSpace) !== Dl, (p !== z || y !== z.version || m !== e.toneMapping) && (I.material.needsUpdate = !0, p = z, y = z.version, m = e.toneMapping), I.layers.enableAll(), L.unshift(I, I.geometry, I.material, 0, 0, null)) : z && z.isTexture && (h === void 0 && (h = new En(
      new xH(2, 2),
      new BA({
        name: "BackgroundMaterial",
        uniforms: _W(Rg.background.uniforms),
        vertexShader: Rg.background.vertexShader,
        fragmentShader: Rg.background.fragmentShader,
        side: xA,
        depthTest: !1,
        depthWrite: !1,
        fog: !1,
        allowOverride: !1
      })
    ), h.geometry.deleteAttribute("normal"), Object.defineProperty(h.material, "map", {
      get: function() {
        return this.uniforms.t2D.value;
      }
    }), s.update(h)), h.material.uniforms.t2D.value = z, h.material.uniforms.backgroundIntensity.value = P.backgroundIntensity, h.material.toneMapped = Qr.getTransfer(z.colorSpace) !== Dl, z.matrixAutoUpdate === !0 && z.updateMatrix(), h.material.uniforms.uvTransform.value.copy(z.matrix), (p !== z || y !== z.version || m !== e.toneMapping) && (h.material.needsUpdate = !0, p = z, y = z.version, m = e.toneMapping), h.layers.enableAll(), L.unshift(h, h.geometry, h.material, 0, 0, null));
  }
  function R(L, P) {
    L.getRGB(Kne, wAe(e)), n.buffers.color.setClear(Kne.r, Kne.g, Kne.b, P, r);
  }
  function F() {
    I !== void 0 && (I.geometry.dispose(), I.material.dispose(), I = void 0), h !== void 0 && (h.geometry.dispose(), h.material.dispose(), h = void 0);
  }
  return {
    getClearColor: function() {
      return l;
    },
    setClearColor: function(L, P = 1) {
      l.set(L), c = P, R(l, c);
    },
    getClearAlpha: function() {
      return c;
    },
    setClearAlpha: function(L) {
      c = L, R(l, c);
    },
    render: C,
    addToRenderList: O,
    dispose: F
  };
}
function yHe(e, t) {
  const i = e.getParameter(e.MAX_VERTEX_ATTRIBS), n = {}, s = y(null);
  let o = s, r = !1;
  function l(ee, Ne, Ae, Oe, pe) {
    let je = !1;
    const Ve = p(Oe, Ae, Ne);
    o !== Ve && (o = Ve, h(o.object)), je = m(ee, Oe, Ae, pe), je && A(ee, Oe, Ae, pe), pe !== null && t.update(pe, e.ELEMENT_ARRAY_BUFFER), (je || r) && (r = !1, P(ee, Ne, Ae, Oe), pe !== null && e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, t.get(pe).buffer));
  }
  function c() {
    return e.createVertexArray();
  }
  function h(ee) {
    return e.bindVertexArray(ee);
  }
  function I(ee) {
    return e.deleteVertexArray(ee);
  }
  function p(ee, Ne, Ae) {
    const Oe = Ae.wireframe === !0;
    let pe = n[ee.id];
    pe === void 0 && (pe = {}, n[ee.id] = pe);
    let je = pe[Ne.id];
    je === void 0 && (je = {}, pe[Ne.id] = je);
    let Ve = je[Oe];
    return Ve === void 0 && (Ve = y(c()), je[Oe] = Ve), Ve;
  }
  function y(ee) {
    const Ne = [], Ae = [], Oe = [];
    for (let pe = 0; pe < i; pe++)
      Ne[pe] = 0, Ae[pe] = 0, Oe[pe] = 0;
    return {
      // for backward compatibility on non-VAO support browser
      geometry: null,
      program: null,
      wireframe: !1,
      newAttributes: Ne,
      enabledAttributes: Ae,
      attributeDivisors: Oe,
      object: ee,
      attributes: {},
      index: null
    };
  }
  function m(ee, Ne, Ae, Oe) {
    const pe = o.attributes, je = Ne.attributes;
    let Ve = 0;
    const $e = Ae.getAttributes();
    for (const vt in $e)
      if ($e[vt].location >= 0) {
        const ze = pe[vt];
        let mt = je[vt];
        if (mt === void 0 && (vt === "instanceMatrix" && ee.instanceMatrix && (mt = ee.instanceMatrix), vt === "instanceColor" && ee.instanceColor && (mt = ee.instanceColor)), ze === void 0 || ze.attribute !== mt || mt && ze.data !== mt.data) return !0;
        Ve++;
      }
    return o.attributesNum !== Ve || o.index !== Oe;
  }
  function A(ee, Ne, Ae, Oe) {
    const pe = {}, je = Ne.attributes;
    let Ve = 0;
    const $e = Ae.getAttributes();
    for (const vt in $e)
      if ($e[vt].location >= 0) {
        let ze = je[vt];
        ze === void 0 && (vt === "instanceMatrix" && ee.instanceMatrix && (ze = ee.instanceMatrix), vt === "instanceColor" && ee.instanceColor && (ze = ee.instanceColor));
        const mt = {};
        mt.attribute = ze, ze && ze.data && (mt.data = ze.data), pe[vt] = mt, Ve++;
      }
    o.attributes = pe, o.attributesNum = Ve, o.index = Oe;
  }
  function C() {
    const ee = o.newAttributes;
    for (let Ne = 0, Ae = ee.length; Ne < Ae; Ne++)
      ee[Ne] = 0;
  }
  function O(ee) {
    R(ee, 0);
  }
  function R(ee, Ne) {
    const Ae = o.newAttributes, Oe = o.enabledAttributes, pe = o.attributeDivisors;
    Ae[ee] = 1, Oe[ee] === 0 && (e.enableVertexAttribArray(ee), Oe[ee] = 1), pe[ee] !== Ne && (e.vertexAttribDivisor(ee, Ne), pe[ee] = Ne);
  }
  function F() {
    const ee = o.newAttributes, Ne = o.enabledAttributes;
    for (let Ae = 0, Oe = Ne.length; Ae < Oe; Ae++)
      Ne[Ae] !== ee[Ae] && (e.disableVertexAttribArray(Ae), Ne[Ae] = 0);
  }
  function L(ee, Ne, Ae, Oe, pe, je, Ve) {
    Ve === !0 ? e.vertexAttribIPointer(ee, Ne, Ae, pe, je) : e.vertexAttribPointer(ee, Ne, Ae, Oe, pe, je);
  }
  function P(ee, Ne, Ae, Oe) {
    C();
    const pe = Oe.attributes, je = Ae.getAttributes(), Ve = Ne.defaultAttributeValues;
    for (const $e in je) {
      const vt = je[$e];
      if (vt.location >= 0) {
        let Rt = pe[$e];
        if (Rt === void 0 && ($e === "instanceMatrix" && ee.instanceMatrix && (Rt = ee.instanceMatrix), $e === "instanceColor" && ee.instanceColor && (Rt = ee.instanceColor)), Rt !== void 0) {
          const ze = Rt.normalized, mt = Rt.itemSize, Et = t.get(Rt);
          if (Et === void 0) continue;
          const it = Et.buffer, Dt = Et.type, Ct = Et.bytesPerElement, Kt = Dt === e.INT || Dt === e.UNSIGNED_INT || Rt.gpuType === kpe;
          if (Rt.isInterleavedBufferAttribute) {
            const Zt = Rt.data, Xt = Zt.stride, gi = Rt.offset;
            if (Zt.isInstancedInterleavedBuffer) {
              for (let Wt = 0; Wt < vt.locationSize; Wt++)
                R(vt.location + Wt, Zt.meshPerAttribute);
              ee.isInstancedMesh !== !0 && Oe._maxInstanceCount === void 0 && (Oe._maxInstanceCount = Zt.meshPerAttribute * Zt.count);
            } else
              for (let Wt = 0; Wt < vt.locationSize; Wt++)
                O(vt.location + Wt);
            e.bindBuffer(e.ARRAY_BUFFER, it);
            for (let Wt = 0; Wt < vt.locationSize; Wt++)
              L(
                vt.location + Wt,
                mt / vt.locationSize,
                Dt,
                ze,
                Xt * Ct,
                (gi + mt / vt.locationSize * Wt) * Ct,
                Kt
              );
          } else {
            if (Rt.isInstancedBufferAttribute) {
              for (let Zt = 0; Zt < vt.locationSize; Zt++)
                R(vt.location + Zt, Rt.meshPerAttribute);
              ee.isInstancedMesh !== !0 && Oe._maxInstanceCount === void 0 && (Oe._maxInstanceCount = Rt.meshPerAttribute * Rt.count);
            } else
              for (let Zt = 0; Zt < vt.locationSize; Zt++)
                O(vt.location + Zt);
            e.bindBuffer(e.ARRAY_BUFFER, it);
            for (let Zt = 0; Zt < vt.locationSize; Zt++)
              L(
                vt.location + Zt,
                mt / vt.locationSize,
                Dt,
                ze,
                mt * Ct,
                mt / vt.locationSize * Zt * Ct,
                Kt
              );
          }
        } else if (Ve !== void 0) {
          const ze = Ve[$e];
          if (ze !== void 0)
            switch (ze.length) {
              case 2:
                e.vertexAttrib2fv(vt.location, ze);
                break;
              case 3:
                e.vertexAttrib3fv(vt.location, ze);
                break;
              case 4:
                e.vertexAttrib4fv(vt.location, ze);
                break;
              default:
                e.vertexAttrib1fv(vt.location, ze);
            }
        }
      }
    }
    F();
  }
  function z() {
    ce();
    for (const ee in n) {
      const Ne = n[ee];
      for (const Ae in Ne) {
        const Oe = Ne[Ae];
        for (const pe in Oe)
          I(Oe[pe].object), delete Oe[pe];
        delete Ne[Ae];
      }
      delete n[ee];
    }
  }
  function W(ee) {
    if (n[ee.id] === void 0) return;
    const Ne = n[ee.id];
    for (const Ae in Ne) {
      const Oe = Ne[Ae];
      for (const pe in Oe)
        I(Oe[pe].object), delete Oe[pe];
      delete Ne[Ae];
    }
    delete n[ee.id];
  }
  function re(ee) {
    for (const Ne in n) {
      const Ae = n[Ne];
      if (Ae[ee.id] === void 0) continue;
      const Oe = Ae[ee.id];
      for (const pe in Oe)
        I(Oe[pe].object), delete Oe[pe];
      delete Ae[ee.id];
    }
  }
  function ce() {
    te(), r = !0, o !== s && (o = s, h(o.object));
  }
  function te() {
    s.geometry = null, s.program = null, s.wireframe = !1;
  }
  return {
    setup: l,
    reset: ce,
    resetDefaultState: te,
    dispose: z,
    releaseStatesOfGeometry: W,
    releaseStatesOfProgram: re,
    initAttributes: C,
    enableAttribute: O,
    disableUnusedAttributes: F
  };
}
function EHe(e, t, i) {
  let n;
  function s(h) {
    n = h;
  }
  function o(h, I) {
    e.drawArrays(n, h, I), i.update(I, n, 1);
  }
  function r(h, I, p) {
    p !== 0 && (e.drawArraysInstanced(n, h, I, p), i.update(I, n, p));
  }
  function l(h, I, p) {
    if (p === 0) return;
    t.get("WEBGL_multi_draw").multiDrawArraysWEBGL(n, h, 0, I, 0, p);
    let m = 0;
    for (let A = 0; A < p; A++)
      m += I[A];
    i.update(m, n, 1);
  }
  function c(h, I, p, y) {
    if (p === 0) return;
    const m = t.get("WEBGL_multi_draw");
    if (m === null)
      for (let A = 0; A < h.length; A++)
        r(h[A], I[A], y[A]);
    else {
      m.multiDrawArraysInstancedWEBGL(n, h, 0, I, 0, y, 0, p);
      let A = 0;
      for (let C = 0; C < p; C++)
        A += I[C] * y[C];
      i.update(A, n, 1);
    }
  }
  this.setMode = s, this.render = o, this.renderInstances = r, this.renderMultiDraw = l, this.renderMultiDrawInstances = c;
}
function gHe(e, t, i, n) {
  let s;
  function o() {
    if (s !== void 0) return s;
    if (t.has("EXT_texture_filter_anisotropic") === !0) {
      const re = t.get("EXT_texture_filter_anisotropic");
      s = e.getParameter(re.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
    } else
      s = 0;
    return s;
  }
  function r(re) {
    return !(re !== y5 && n.convert(re) !== e.getParameter(e.IMPLEMENTATION_COLOR_READ_FORMAT));
  }
  function l(re) {
    const ce = re === yie && (t.has("EXT_color_buffer_half_float") || t.has("EXT_color_buffer_float"));
    return !(re !== PA && n.convert(re) !== e.getParameter(e.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
    re !== cN && !ce);
  }
  function c(re) {
    if (re === "highp") {
      if (e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.HIGH_FLOAT).precision > 0 && e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.HIGH_FLOAT).precision > 0)
        return "highp";
      re = "mediump";
    }
    return re === "mediump" && e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.MEDIUM_FLOAT).precision > 0 && e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.MEDIUM_FLOAT).precision > 0 ? "mediump" : "lowp";
  }
  let h = i.precision !== void 0 ? i.precision : "highp";
  const I = c(h);
  I !== h && (console.warn("THREE.WebGLRenderer:", h, "not supported, using", I, "instead."), h = I);
  const p = i.logarithmicDepthBuffer === !0, y = i.reverseDepthBuffer === !0 && t.has("EXT_clip_control"), m = e.getParameter(e.MAX_TEXTURE_IMAGE_UNITS), A = e.getParameter(e.MAX_VERTEX_TEXTURE_IMAGE_UNITS), C = e.getParameter(e.MAX_TEXTURE_SIZE), O = e.getParameter(e.MAX_CUBE_MAP_TEXTURE_SIZE), R = e.getParameter(e.MAX_VERTEX_ATTRIBS), F = e.getParameter(e.MAX_VERTEX_UNIFORM_VECTORS), L = e.getParameter(e.MAX_VARYING_VECTORS), P = e.getParameter(e.MAX_FRAGMENT_UNIFORM_VECTORS), z = A > 0, W = e.getParameter(e.MAX_SAMPLES);
  return {
    isWebGL2: !0,
    // keeping this for backwards compatibility
    getMaxAnisotropy: o,
    getMaxPrecision: c,
    textureFormatReadable: r,
    textureTypeReadable: l,
    precision: h,
    logarithmicDepthBuffer: p,
    reverseDepthBuffer: y,
    maxTextures: m,
    maxVertexTextures: A,
    maxTextureSize: C,
    maxCubemapSize: O,
    maxAttributes: R,
    maxVertexUniforms: F,
    maxVaryings: L,
    maxFragmentUniforms: P,
    vertexTextures: z,
    maxSamples: W
  };
}
function wHe(e) {
  const t = this;
  let i = null, n = 0, s = !1, o = !1;
  const r = new tl(), l = new fo(), c = { value: null, needsUpdate: !1 };
  this.uniform = c, this.numPlanes = 0, this.numIntersection = 0, this.init = function(p, y) {
    const m = p.length !== 0 || y || // enable state of previous frame - the clipping code has to
    // run another frame in order to reset the state:
    n !== 0 || s;
    return s = y, n = p.length, m;
  }, this.beginShadows = function() {
    o = !0, I(null);
  }, this.endShadows = function() {
    o = !1;
  }, this.setGlobalState = function(p, y) {
    i = I(p, y, 0);
  }, this.setState = function(p, y, m) {
    const A = p.clippingPlanes, C = p.clipIntersection, O = p.clipShadows, R = e.get(p);
    if (!s || A === null || A.length === 0 || o && !O)
      o ? I(null) : h();
    else {
      const F = o ? 0 : n, L = F * 4;
      let P = R.clippingState || null;
      c.value = P, P = I(A, y, L, m);
      for (let z = 0; z !== L; ++z)
        P[z] = i[z];
      R.clippingState = P, this.numIntersection = C ? this.numPlanes : 0, this.numPlanes += F;
    }
  };
  function h() {
    c.value !== i && (c.value = i, c.needsUpdate = n > 0), t.numPlanes = n, t.numIntersection = 0;
  }
  function I(p, y, m, A) {
    const C = p !== null ? p.length : 0;
    let O = null;
    if (C !== 0) {
      if (O = c.value, A !== !0 || O === null) {
        const R = m + C * 4, F = y.matrixWorldInverse;
        l.getNormalMatrix(F), (O === null || O.length < R) && (O = new Float32Array(R));
        for (let L = 0, P = m; L !== C; ++L, P += 4)
          r.copy(p[L]).applyMatrix4(F, l), r.normal.toArray(O, P), O[P + 3] = r.constant;
      }
      c.value = O, c.needsUpdate = !0;
    }
    return t.numPlanes = C, t.numIntersection = 0, O;
  }
}
function THe(e) {
  let t = /* @__PURE__ */ new WeakMap();
  function i(r, l) {
    return l === I1e ? r.mapping = CW : l === p1e && (r.mapping = OW), r;
  }
  function n(r) {
    if (r && r.isTexture) {
      const l = r.mapping;
      if (l === I1e || l === p1e)
        if (t.has(r)) {
          const c = t.get(r).texture;
          return i(c, r.mapping);
        } else {
          const c = r.image;
          if (c && c.height > 0) {
            const h = new uUe(c.height);
            return h.fromEquirectangularTexture(e, r), t.set(r, h), r.addEventListener("dispose", s), i(h.texture, r.mapping);
          } else
            return null;
        }
    }
    return r;
  }
  function s(r) {
    const l = r.target;
    l.removeEventListener("dispose", s);
    const c = t.get(l);
    c !== void 0 && (t.delete(l), c.dispose());
  }
  function o() {
    t = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: n,
    dispose: o
  };
}
const oz = 4, Age = [0.125, 0.215, 0.35, 0.446, 0.526, 0.582], $U = 20, Vde = /* @__PURE__ */ new eY(), Sge = /* @__PURE__ */ new Xn();
let zde = null, jde = 0, Wde = 0, Yde = !1;
const dU = (1 + Math.sqrt(5)) / 2, Zk = 1 / dU, bge = [
  /* @__PURE__ */ new Ge(-dU, Zk, 0),
  /* @__PURE__ */ new Ge(dU, Zk, 0),
  /* @__PURE__ */ new Ge(-Zk, 0, dU),
  /* @__PURE__ */ new Ge(Zk, 0, dU),
  /* @__PURE__ */ new Ge(0, dU, -Zk),
  /* @__PURE__ */ new Ge(0, dU, Zk),
  /* @__PURE__ */ new Ge(-1, 1, -1),
  /* @__PURE__ */ new Ge(1, 1, -1),
  /* @__PURE__ */ new Ge(-1, 1, 1),
  /* @__PURE__ */ new Ge(1, 1, 1)
], RHe = /* @__PURE__ */ new Ge();
class Nge {
  /**
   * Constructs a new PMREM generator.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   */
  constructor(t) {
    this._renderer = t, this._pingPongRenderTarget = null, this._lodMax = 0, this._cubeSize = 0, this._lodPlanes = [], this._sizeLods = [], this._sigmas = [], this._blurMaterial = null, this._cubemapMaterial = null, this._equirectMaterial = null, this._compileMaterial(this._blurMaterial);
  }
  /**
   * Generates a PMREM from a supplied Scene, which can be faster than using an
   * image if networking bandwidth is low. Optional sigma specifies a blur radius
   * in radians to be applied to the scene before PMREM generation. Optional near
   * and far planes ensure the scene is rendered in its entirety.
   *
   * @param {Scene} scene - The scene to be captured.
   * @param {number} [sigma=0] - The blur radius in radians.
   * @param {number} [near=0.1] - The near plane distance.
   * @param {number} [far=100] - The far plane distance.
   * @param {Object} [options={}] - The configuration options.
   * @param {number} [options.size=256] - The texture size of the PMREM.
   * @param {Vector3} [options.renderTarget=origin] - The position of the internal cube camera that renders the scene.
   * @return {WebGLRenderTarget} The resulting PMREM.
   */
  fromScene(t, i = 0, n = 0.1, s = 100, o = {}) {
    const {
      size: r = 256,
      position: l = RHe
    } = o;
    zde = this._renderer.getRenderTarget(), jde = this._renderer.getActiveCubeFace(), Wde = this._renderer.getActiveMipmapLevel(), Yde = this._renderer.xr.enabled, this._renderer.xr.enabled = !1, this._setSize(r);
    const c = this._allocateTargets();
    return c.depthBuffer = !0, this._sceneToCubeUV(t, n, s, c, l), i > 0 && this._blur(c, 0, 0, i), this._applyPMREM(c), this._cleanup(c), c;
  }
  /**
   * Generates a PMREM from an equirectangular texture, which can be either LDR
   * or HDR. The ideal input image size is 1k (1024 x 512),
   * as this matches best with the 256 x 256 cubemap output.
   *
   * @param {Texture} equirectangular - The equirectangular texture to be converted.
   * @param {?WebGLRenderTarget} [renderTarget=null] - The render target to use.
   * @return {WebGLRenderTarget} The resulting PMREM.
   */
  fromEquirectangular(t, i = null) {
    return this._fromTexture(t, i);
  }
  /**
   * Generates a PMREM from an cubemap texture, which can be either LDR
   * or HDR. The ideal input cube size is 256 x 256,
   * as this matches best with the 256 x 256 cubemap output.
   *
   * @param {Texture} cubemap - The cubemap texture to be converted.
   * @param {?WebGLRenderTarget} [renderTarget=null] - The render target to use.
   * @return {WebGLRenderTarget} The resulting PMREM.
   */
  fromCubemap(t, i = null) {
    return this._fromTexture(t, i);
  }
  /**
   * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
   * your texture's network fetch for increased concurrency.
   */
  compileCubemapShader() {
    this._cubemapMaterial === null && (this._cubemapMaterial = Oge(), this._compileMaterial(this._cubemapMaterial));
  }
  /**
   * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
   * your texture's network fetch for increased concurrency.
   */
  compileEquirectangularShader() {
    this._equirectMaterial === null && (this._equirectMaterial = Cge(), this._compileMaterial(this._equirectMaterial));
  }
  /**
   * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
   * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
   * one of them will cause any others to also become unusable.
   */
  dispose() {
    this._dispose(), this._cubemapMaterial !== null && this._cubemapMaterial.dispose(), this._equirectMaterial !== null && this._equirectMaterial.dispose();
  }
  // private interface
  _setSize(t) {
    this._lodMax = Math.floor(Math.log2(t)), this._cubeSize = Math.pow(2, this._lodMax);
  }
  _dispose() {
    this._blurMaterial !== null && this._blurMaterial.dispose(), this._pingPongRenderTarget !== null && this._pingPongRenderTarget.dispose();
    for (let t = 0; t < this._lodPlanes.length; t++)
      this._lodPlanes[t].dispose();
  }
  _cleanup(t) {
    this._renderer.setRenderTarget(zde, jde, Wde), this._renderer.xr.enabled = Yde, t.scissorTest = !1, Zne(t, 0, 0, t.width, t.height);
  }
  _fromTexture(t, i) {
    t.mapping === CW || t.mapping === OW ? this._setSize(t.image.length === 0 ? 16 : t.image[0].width || t.image[0].image.width) : this._setSize(t.image.width / 4), zde = this._renderer.getRenderTarget(), jde = this._renderer.getActiveCubeFace(), Wde = this._renderer.getActiveMipmapLevel(), Yde = this._renderer.xr.enabled, this._renderer.xr.enabled = !1;
    const n = i || this._allocateTargets();
    return this._textureToCubeUV(t, n), this._applyPMREM(n), this._cleanup(n), n;
  }
  _allocateTargets() {
    const t = 3 * Math.max(this._cubeSize, 112), i = 4 * this._cubeSize, n = {
      magFilter: dN,
      minFilter: dN,
      generateMipmaps: !1,
      type: yie,
      format: y5,
      colorSpace: LW,
      depthBuffer: !1
    }, s = Dge(t, i, n);
    if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== t || this._pingPongRenderTarget.height !== i) {
      this._pingPongRenderTarget !== null && this._dispose(), this._pingPongRenderTarget = Dge(t, i, n);
      const { _lodMax: o } = this;
      ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = vHe(o)), this._blurMaterial = AHe(o, t, i);
    }
    return s;
  }
  _compileMaterial(t) {
    const i = new En(this._lodPlanes[0], t);
    this._renderer.compile(i, Vde);
  }
  _sceneToCubeUV(t, i, n, s, o) {
    const c = new Tg(90, 1, i, n), h = [1, -1, 1, 1, 1, 1], I = [1, 1, 1, -1, -1, -1], p = this._renderer, y = p.autoClear, m = p.toneMapping;
    p.getClearColor(Sge), p.toneMapping = OP, p.autoClear = !1;
    const A = new U8({
      name: "PMREM.Background",
      side: nE,
      depthWrite: !1,
      depthTest: !1
    }), C = new En(new L0(), A);
    let O = !1;
    const R = t.background;
    R ? R.isColor && (A.color.copy(R), t.background = null, O = !0) : (A.color.copy(Sge), O = !0);
    for (let F = 0; F < 6; F++) {
      const L = F % 3;
      L === 0 ? (c.up.set(0, h[F], 0), c.position.set(o.x, o.y, o.z), c.lookAt(o.x + I[F], o.y, o.z)) : L === 1 ? (c.up.set(0, 0, h[F]), c.position.set(o.x, o.y, o.z), c.lookAt(o.x, o.y + I[F], o.z)) : (c.up.set(0, h[F], 0), c.position.set(o.x, o.y, o.z), c.lookAt(o.x, o.y, o.z + I[F]));
      const P = this._cubeSize;
      Zne(s, L * P, F > 2 ? P : 0, P, P), p.setRenderTarget(s), O && p.render(C, c), p.render(t, c);
    }
    C.geometry.dispose(), C.material.dispose(), p.toneMapping = m, p.autoClear = y, t.background = R;
  }
  _textureToCubeUV(t, i) {
    const n = this._renderer, s = t.mapping === CW || t.mapping === OW;
    s ? (this._cubemapMaterial === null && (this._cubemapMaterial = Oge()), this._cubemapMaterial.uniforms.flipEnvMap.value = t.isRenderTargetTexture === !1 ? -1 : 1) : this._equirectMaterial === null && (this._equirectMaterial = Cge());
    const o = s ? this._cubemapMaterial : this._equirectMaterial, r = new En(this._lodPlanes[0], o), l = o.uniforms;
    l.envMap.value = t;
    const c = this._cubeSize;
    Zne(i, 0, 0, 3 * c, 2 * c), n.setRenderTarget(i), n.render(r, Vde);
  }
  _applyPMREM(t) {
    const i = this._renderer, n = i.autoClear;
    i.autoClear = !1;
    const s = this._lodPlanes.length;
    for (let o = 1; o < s; o++) {
      const r = Math.sqrt(this._sigmas[o] * this._sigmas[o] - this._sigmas[o - 1] * this._sigmas[o - 1]), l = bge[(s - o - 1) % bge.length];
      this._blur(t, o - 1, o, r, l);
    }
    i.autoClear = n;
  }
  /**
   * This is a two-pass Gaussian blur for a cubemap. Normally this is done
   * vertically and horizontally, but this breaks down on a cube. Here we apply
   * the blur latitudinally (around the poles), and then longitudinally (towards
   * the poles) to approximate the orthogonally-separable blur. It is least
   * accurate at the poles, but still does a decent job.
   *
   * @private
   * @param {WebGLRenderTarget} cubeUVRenderTarget
   * @param {number} lodIn
   * @param {number} lodOut
   * @param {number} sigma
   * @param {Vector3} [poleAxis]
   */
  _blur(t, i, n, s, o) {
    const r = this._pingPongRenderTarget;
    this._halfBlur(
      t,
      r,
      i,
      n,
      s,
      "latitudinal",
      o
    ), this._halfBlur(
      r,
      t,
      n,
      n,
      s,
      "longitudinal",
      o
    );
  }
  _halfBlur(t, i, n, s, o, r, l) {
    const c = this._renderer, h = this._blurMaterial;
    r !== "latitudinal" && r !== "longitudinal" && console.error(
      "blur direction must be either latitudinal or longitudinal!"
    );
    const I = 3, p = new En(this._lodPlanes[s], h), y = h.uniforms, m = this._sizeLods[n] - 1, A = isFinite(o) ? Math.PI / (2 * m) : 2 * Math.PI / (2 * $U - 1), C = o / A, O = isFinite(o) ? 1 + Math.floor(I * C) : $U;
    O > $U && console.warn(`sigmaRadians, ${o}, is too large and will clip, as it requested ${O} samples when the maximum is set to ${$U}`);
    const R = [];
    let F = 0;
    for (let re = 0; re < $U; ++re) {
      const ce = re / C, te = Math.exp(-ce * ce / 2);
      R.push(te), re === 0 ? F += te : re < O && (F += 2 * te);
    }
    for (let re = 0; re < R.length; re++)
      R[re] = R[re] / F;
    y.envMap.value = t.texture, y.samples.value = O, y.weights.value = R, y.latitudinal.value = r === "latitudinal", l && (y.poleAxis.value = l);
    const { _lodMax: L } = this;
    y.dTheta.value = A, y.mipInt.value = L - n;
    const P = this._sizeLods[s], z = 3 * P * (s > L - oz ? s - L + oz : 0), W = 4 * (this._cubeSize - P);
    Zne(i, z, W, 3 * P, 2 * P), c.setRenderTarget(i), c.render(p, Vde);
  }
}
function vHe(e) {
  const t = [], i = [], n = [];
  let s = e;
  const o = e - oz + 1 + Age.length;
  for (let r = 0; r < o; r++) {
    const l = Math.pow(2, s);
    i.push(l);
    let c = 1 / l;
    r > e - oz ? c = Age[r - e + oz - 1] : r === 0 && (c = 0), n.push(c);
    const h = 1 / (l - 2), I = -h, p = 1 + h, y = [I, I, p, I, p, p, I, I, p, p, I, p], m = 6, A = 6, C = 3, O = 2, R = 1, F = new Float32Array(C * A * m), L = new Float32Array(O * A * m), P = new Float32Array(R * A * m);
    for (let W = 0; W < m; W++) {
      const re = W % 3 * 2 / 3 - 1, ce = W > 2 ? 0 : -1, te = [
        re,
        ce,
        0,
        re + 2 / 3,
        ce,
        0,
        re + 2 / 3,
        ce + 1,
        0,
        re,
        ce,
        0,
        re + 2 / 3,
        ce + 1,
        0,
        re,
        ce + 1,
        0
      ];
      F.set(te, C * A * W), L.set(y, O * A * W);
      const ee = [W, W, W, W, W, W];
      P.set(ee, R * A * W);
    }
    const z = new Vl();
    z.setAttribute("position", new zu(F, C)), z.setAttribute("uv", new zu(L, O)), z.setAttribute("faceIndex", new zu(P, R)), t.push(z), s > oz && s--;
  }
  return { lodPlanes: t, sizeLods: i, sigmas: n };
}
function Dge(e, t, i) {
  const n = new qP(e, t, i);
  return n.texture.mapping = Rae, n.texture.name = "PMREM.cubeUv", n.scissorTest = !0, n;
}
function Zne(e, t, i, n, s) {
  e.viewport.set(t, i, n, s), e.scissor.set(t, i, n, s);
}
function AHe(e, t, i) {
  const n = new Float32Array($U), s = new Ge(0, 1, 0);
  return new BA({
    name: "SphericalGaussianBlur",
    defines: {
      n: $U,
      CUBEUV_TEXEL_WIDTH: 1 / t,
      CUBEUV_TEXEL_HEIGHT: 1 / i,
      CUBEUV_MAX_MIP: `${e}.0`
    },
    uniforms: {
      envMap: { value: null },
      samples: { value: 1 },
      weights: { value: n },
      latitudinal: { value: !1 },
      dTheta: { value: 0 },
      mipInt: { value: 0 },
      poleAxis: { value: s }
    },
    vertexShader: eme(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`
    ),
    blending: CP,
    depthTest: !1,
    depthWrite: !1
  });
}
function Cge() {
  return new BA({
    name: "EquirectangularToCubeUV",
    uniforms: {
      envMap: { value: null }
    },
    vertexShader: eme(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`
    ),
    blending: CP,
    depthTest: !1,
    depthWrite: !1
  });
}
function Oge() {
  return new BA({
    name: "CubemapToCubeUV",
    uniforms: {
      envMap: { value: null },
      flipEnvMap: { value: -1 }
    },
    vertexShader: eme(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`
    ),
    blending: CP,
    depthTest: !1,
    depthWrite: !1
  });
}
function eme() {
  return (
    /* glsl */
    `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`
  );
}
function SHe(e) {
  let t = /* @__PURE__ */ new WeakMap(), i = null;
  function n(l) {
    if (l && l.isTexture) {
      const c = l.mapping, h = c === I1e || c === p1e, I = c === CW || c === OW;
      if (h || I) {
        let p = t.get(l);
        const y = p !== void 0 ? p.texture.pmremVersion : 0;
        if (l.isRenderTargetTexture && l.pmremVersion !== y)
          return i === null && (i = new Nge(e)), p = h ? i.fromEquirectangular(l, p) : i.fromCubemap(l, p), p.texture.pmremVersion = l.pmremVersion, t.set(l, p), p.texture;
        if (p !== void 0)
          return p.texture;
        {
          const m = l.image;
          return h && m && m.height > 0 || I && m && s(m) ? (i === null && (i = new Nge(e)), p = h ? i.fromEquirectangular(l) : i.fromCubemap(l), p.texture.pmremVersion = l.pmremVersion, t.set(l, p), l.addEventListener("dispose", o), p.texture) : null;
        }
      }
    }
    return l;
  }
  function s(l) {
    let c = 0;
    const h = 6;
    for (let I = 0; I < h; I++)
      l[I] !== void 0 && c++;
    return c === h;
  }
  function o(l) {
    const c = l.target;
    c.removeEventListener("dispose", o);
    const h = t.get(c);
    h !== void 0 && (t.delete(c), h.dispose());
  }
  function r() {
    t = /* @__PURE__ */ new WeakMap(), i !== null && (i.dispose(), i = null);
  }
  return {
    get: n,
    dispose: r
  };
}
function bHe(e) {
  const t = {};
  function i(n) {
    if (t[n] !== void 0)
      return t[n];
    let s;
    switch (n) {
      case "WEBGL_depth_texture":
        s = e.getExtension("WEBGL_depth_texture") || e.getExtension("MOZ_WEBGL_depth_texture") || e.getExtension("WEBKIT_WEBGL_depth_texture");
        break;
      case "EXT_texture_filter_anisotropic":
        s = e.getExtension("EXT_texture_filter_anisotropic") || e.getExtension("MOZ_EXT_texture_filter_anisotropic") || e.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
        break;
      case "WEBGL_compressed_texture_s3tc":
        s = e.getExtension("WEBGL_compressed_texture_s3tc") || e.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || e.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
        break;
      case "WEBGL_compressed_texture_pvrtc":
        s = e.getExtension("WEBGL_compressed_texture_pvrtc") || e.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
        break;
      default:
        s = e.getExtension(n);
    }
    return t[n] = s, s;
  }
  return {
    has: function(n) {
      return i(n) !== null;
    },
    init: function() {
      i("EXT_color_buffer_float"), i("WEBGL_clip_cull_distance"), i("OES_texture_float_linear"), i("EXT_color_buffer_half_float"), i("WEBGL_multisampled_render_to_texture"), i("WEBGL_render_shared_exponent");
    },
    get: function(n) {
      const s = i(n);
      return s === null && bz("THREE.WebGLRenderer: " + n + " extension not supported."), s;
    }
  };
}
function NHe(e, t, i, n) {
  const s = {}, o = /* @__PURE__ */ new WeakMap();
  function r(p) {
    const y = p.target;
    y.index !== null && t.remove(y.index);
    for (const A in y.attributes)
      t.remove(y.attributes[A]);
    y.removeEventListener("dispose", r), delete s[y.id];
    const m = o.get(y);
    m && (t.remove(m), o.delete(y)), n.releaseStatesOfGeometry(y), y.isInstancedBufferGeometry === !0 && delete y._maxInstanceCount, i.memory.geometries--;
  }
  function l(p, y) {
    return s[y.id] === !0 || (y.addEventListener("dispose", r), s[y.id] = !0, i.memory.geometries++), y;
  }
  function c(p) {
    const y = p.attributes;
    for (const m in y)
      t.update(y[m], e.ARRAY_BUFFER);
  }
  function h(p) {
    const y = [], m = p.index, A = p.attributes.position;
    let C = 0;
    if (m !== null) {
      const F = m.array;
      C = m.version;
      for (let L = 0, P = F.length; L < P; L += 3) {
        const z = F[L + 0], W = F[L + 1], re = F[L + 2];
        y.push(z, W, W, re, re, z);
      }
    } else if (A !== void 0) {
      const F = A.array;
      C = A.version;
      for (let L = 0, P = F.length / 3 - 1; L < P; L += 3) {
        const z = L + 0, W = L + 1, re = L + 2;
        y.push(z, W, W, re, re, z);
      }
    } else
      return;
    const O = new (pAe(y) ? gAe : EAe)(y, 1);
    O.version = C;
    const R = o.get(p);
    R && t.remove(R), o.set(p, O);
  }
  function I(p) {
    const y = o.get(p);
    if (y) {
      const m = p.index;
      m !== null && y.version < m.version && h(p);
    } else
      h(p);
    return o.get(p);
  }
  return {
    get: l,
    update: c,
    getWireframeAttribute: I
  };
}
function DHe(e, t, i) {
  let n;
  function s(y) {
    n = y;
  }
  let o, r;
  function l(y) {
    o = y.type, r = y.bytesPerElement;
  }
  function c(y, m) {
    e.drawElements(n, m, o, y * r), i.update(m, n, 1);
  }
  function h(y, m, A) {
    A !== 0 && (e.drawElementsInstanced(n, m, o, y * r, A), i.update(m, n, A));
  }
  function I(y, m, A) {
    if (A === 0) return;
    t.get("WEBGL_multi_draw").multiDrawElementsWEBGL(n, m, 0, o, y, 0, A);
    let O = 0;
    for (let R = 0; R < A; R++)
      O += m[R];
    i.update(O, n, 1);
  }
  function p(y, m, A, C) {
    if (A === 0) return;
    const O = t.get("WEBGL_multi_draw");
    if (O === null)
      for (let R = 0; R < y.length; R++)
        h(y[R] / r, m[R], C[R]);
    else {
      O.multiDrawElementsInstancedWEBGL(n, m, 0, o, y, 0, C, 0, A);
      let R = 0;
      for (let F = 0; F < A; F++)
        R += m[F] * C[F];
      i.update(R, n, 1);
    }
  }
  this.setMode = s, this.setIndex = l, this.render = c, this.renderInstances = h, this.renderMultiDraw = I, this.renderMultiDrawInstances = p;
}
function CHe(e) {
  const t = {
    geometries: 0,
    textures: 0
  }, i = {
    frame: 0,
    calls: 0,
    triangles: 0,
    points: 0,
    lines: 0
  };
  function n(o, r, l) {
    switch (i.calls++, r) {
      case e.TRIANGLES:
        i.triangles += l * (o / 3);
        break;
      case e.LINES:
        i.lines += l * (o / 2);
        break;
      case e.LINE_STRIP:
        i.lines += l * (o - 1);
        break;
      case e.LINE_LOOP:
        i.lines += l * o;
        break;
      case e.POINTS:
        i.points += l * o;
        break;
      default:
        console.error("THREE.WebGLInfo: Unknown draw mode:", r);
        break;
    }
  }
  function s() {
    i.calls = 0, i.triangles = 0, i.points = 0, i.lines = 0;
  }
  return {
    memory: t,
    render: i,
    programs: null,
    autoReset: !0,
    reset: s,
    update: n
  };
}
function OHe(e, t, i) {
  const n = /* @__PURE__ */ new WeakMap(), s = new Ol();
  function o(r, l, c) {
    const h = r.morphTargetInfluences, I = l.morphAttributes.position || l.morphAttributes.normal || l.morphAttributes.color, p = I !== void 0 ? I.length : 0;
    let y = n.get(l);
    if (y === void 0 || y.count !== p) {
      let te = function() {
        re.dispose(), n.delete(l), l.removeEventListener("dispose", te);
      };
      y !== void 0 && y.texture.dispose();
      const m = l.morphAttributes.position !== void 0, A = l.morphAttributes.normal !== void 0, C = l.morphAttributes.color !== void 0, O = l.morphAttributes.position || [], R = l.morphAttributes.normal || [], F = l.morphAttributes.color || [];
      let L = 0;
      m === !0 && (L = 1), A === !0 && (L = 2), C === !0 && (L = 3);
      let P = l.attributes.position.count * L, z = 1;
      P > t.maxTextureSize && (z = Math.ceil(P / t.maxTextureSize), P = t.maxTextureSize);
      const W = new Float32Array(P * z * 4 * p), re = new mAe(W, P, z, p);
      re.type = cN, re.needsUpdate = !0;
      const ce = L * 4;
      for (let ee = 0; ee < p; ee++) {
        const Ne = O[ee], Ae = R[ee], Oe = F[ee], pe = P * z * 4 * ee;
        for (let je = 0; je < Ne.count; je++) {
          const Ve = je * ce;
          m === !0 && (s.fromBufferAttribute(Ne, je), W[pe + Ve + 0] = s.x, W[pe + Ve + 1] = s.y, W[pe + Ve + 2] = s.z, W[pe + Ve + 3] = 0), A === !0 && (s.fromBufferAttribute(Ae, je), W[pe + Ve + 4] = s.x, W[pe + Ve + 5] = s.y, W[pe + Ve + 6] = s.z, W[pe + Ve + 7] = 0), C === !0 && (s.fromBufferAttribute(Oe, je), W[pe + Ve + 8] = s.x, W[pe + Ve + 9] = s.y, W[pe + Ve + 10] = s.z, W[pe + Ve + 11] = Oe.itemSize === 4 ? s.w : 1);
        }
      }
      y = {
        count: p,
        texture: re,
        size: new us(P, z)
      }, n.set(l, y), l.addEventListener("dispose", te);
    }
    if (r.isInstancedMesh === !0 && r.morphTexture !== null)
      c.getUniforms().setValue(e, "morphTexture", r.morphTexture, i);
    else {
      let m = 0;
      for (let C = 0; C < h.length; C++)
        m += h[C];
      const A = l.morphTargetsRelative ? 1 : 1 - m;
      c.getUniforms().setValue(e, "morphTargetBaseInfluence", A), c.getUniforms().setValue(e, "morphTargetInfluences", h);
    }
    c.getUniforms().setValue(e, "morphTargetsTexture", y.texture, i), c.getUniforms().setValue(e, "morphTargetsTextureSize", y.size);
  }
  return {
    update: o
  };
}
function LHe(e, t, i, n) {
  let s = /* @__PURE__ */ new WeakMap();
  function o(c) {
    const h = n.render.frame, I = c.geometry, p = t.get(c, I);
    if (s.get(p) !== h && (t.update(p), s.set(p, h)), c.isInstancedMesh && (c.hasEventListener("dispose", l) === !1 && c.addEventListener("dispose", l), s.get(c) !== h && (i.update(c.instanceMatrix, e.ARRAY_BUFFER), c.instanceColor !== null && i.update(c.instanceColor, e.ARRAY_BUFFER), s.set(c, h))), c.isSkinnedMesh) {
      const y = c.skeleton;
      s.get(y) !== h && (y.update(), s.set(y, h));
    }
    return p;
  }
  function r() {
    s = /* @__PURE__ */ new WeakMap();
  }
  function l(c) {
    const h = c.target;
    h.removeEventListener("dispose", l), i.remove(h.instanceMatrix), h.instanceColor !== null && i.remove(h.instanceColor);
  }
  return {
    update: o,
    dispose: r
  };
}
const NAe = /* @__PURE__ */ new sE(), Lge = /* @__PURE__ */ new RAe(1, 1), DAe = /* @__PURE__ */ new mAe(), CAe = /* @__PURE__ */ new Y9e(), OAe = /* @__PURE__ */ new TAe(), _ge = [], xge = [], Pge = new Float32Array(16), Mge = new Float32Array(9), Uge = new Float32Array(4);
function tY(e, t, i) {
  const n = e[0];
  if (n <= 0 || n > 0) return e;
  const s = t * i;
  let o = _ge[s];
  if (o === void 0 && (o = new Float32Array(s), _ge[s] = o), t !== 0) {
    n.toArray(o, 0);
    for (let r = 1, l = 0; r !== t; ++r)
      l += i, e[r].toArray(o, l);
  }
  return o;
}
function vf(e, t) {
  if (e.length !== t.length) return !1;
  for (let i = 0, n = e.length; i < n; i++)
    if (e[i] !== t[i]) return !1;
  return !0;
}
function Af(e, t) {
  for (let i = 0, n = t.length; i < n; i++)
    e[i] = t[i];
}
function Sae(e, t) {
  let i = xge[t];
  i === void 0 && (i = new Int32Array(t), xge[t] = i);
  for (let n = 0; n !== t; ++n)
    i[n] = e.allocateTextureUnit();
  return i;
}
function _He(e, t) {
  const i = this.cache;
  i[0] !== t && (e.uniform1f(this.addr, t), i[0] = t);
}
function xHe(e, t) {
  const i = this.cache;
  if (t.x !== void 0)
    (i[0] !== t.x || i[1] !== t.y) && (e.uniform2f(this.addr, t.x, t.y), i[0] = t.x, i[1] = t.y);
  else {
    if (vf(i, t)) return;
    e.uniform2fv(this.addr, t), Af(i, t);
  }
}
function PHe(e, t) {
  const i = this.cache;
  if (t.x !== void 0)
    (i[0] !== t.x || i[1] !== t.y || i[2] !== t.z) && (e.uniform3f(this.addr, t.x, t.y, t.z), i[0] = t.x, i[1] = t.y, i[2] = t.z);
  else if (t.r !== void 0)
    (i[0] !== t.r || i[1] !== t.g || i[2] !== t.b) && (e.uniform3f(this.addr, t.r, t.g, t.b), i[0] = t.r, i[1] = t.g, i[2] = t.b);
  else {
    if (vf(i, t)) return;
    e.uniform3fv(this.addr, t), Af(i, t);
  }
}
function MHe(e, t) {
  const i = this.cache;
  if (t.x !== void 0)
    (i[0] !== t.x || i[1] !== t.y || i[2] !== t.z || i[3] !== t.w) && (e.uniform4f(this.addr, t.x, t.y, t.z, t.w), i[0] = t.x, i[1] = t.y, i[2] = t.z, i[3] = t.w);
  else {
    if (vf(i, t)) return;
    e.uniform4fv(this.addr, t), Af(i, t);
  }
}
function UHe(e, t) {
  const i = this.cache, n = t.elements;
  if (n === void 0) {
    if (vf(i, t)) return;
    e.uniformMatrix2fv(this.addr, !1, t), Af(i, t);
  } else {
    if (vf(i, n)) return;
    Uge.set(n), e.uniformMatrix2fv(this.addr, !1, Uge), Af(i, n);
  }
}
function BHe(e, t) {
  const i = this.cache, n = t.elements;
  if (n === void 0) {
    if (vf(i, t)) return;
    e.uniformMatrix3fv(this.addr, !1, t), Af(i, t);
  } else {
    if (vf(i, n)) return;
    Mge.set(n), e.uniformMatrix3fv(this.addr, !1, Mge), Af(i, n);
  }
}
function FHe(e, t) {
  const i = this.cache, n = t.elements;
  if (n === void 0) {
    if (vf(i, t)) return;
    e.uniformMatrix4fv(this.addr, !1, t), Af(i, t);
  } else {
    if (vf(i, n)) return;
    Pge.set(n), e.uniformMatrix4fv(this.addr, !1, Pge), Af(i, n);
  }
}
function HHe(e, t) {
  const i = this.cache;
  i[0] !== t && (e.uniform1i(this.addr, t), i[0] = t);
}
function GHe(e, t) {
  const i = this.cache;
  if (t.x !== void 0)
    (i[0] !== t.x || i[1] !== t.y) && (e.uniform2i(this.addr, t.x, t.y), i[0] = t.x, i[1] = t.y);
  else {
    if (vf(i, t)) return;
    e.uniform2iv(this.addr, t), Af(i, t);
  }
}
function kHe(e, t) {
  const i = this.cache;
  if (t.x !== void 0)
    (i[0] !== t.x || i[1] !== t.y || i[2] !== t.z) && (e.uniform3i(this.addr, t.x, t.y, t.z), i[0] = t.x, i[1] = t.y, i[2] = t.z);
  else {
    if (vf(i, t)) return;
    e.uniform3iv(this.addr, t), Af(i, t);
  }
}
function VHe(e, t) {
  const i = this.cache;
  if (t.x !== void 0)
    (i[0] !== t.x || i[1] !== t.y || i[2] !== t.z || i[3] !== t.w) && (e.uniform4i(this.addr, t.x, t.y, t.z, t.w), i[0] = t.x, i[1] = t.y, i[2] = t.z, i[3] = t.w);
  else {
    if (vf(i, t)) return;
    e.uniform4iv(this.addr, t), Af(i, t);
  }
}
function zHe(e, t) {
  const i = this.cache;
  i[0] !== t && (e.uniform1ui(this.addr, t), i[0] = t);
}
function jHe(e, t) {
  const i = this.cache;
  if (t.x !== void 0)
    (i[0] !== t.x || i[1] !== t.y) && (e.uniform2ui(this.addr, t.x, t.y), i[0] = t.x, i[1] = t.y);
  else {
    if (vf(i, t)) return;
    e.uniform2uiv(this.addr, t), Af(i, t);
  }
}
function WHe(e, t) {
  const i = this.cache;
  if (t.x !== void 0)
    (i[0] !== t.x || i[1] !== t.y || i[2] !== t.z) && (e.uniform3ui(this.addr, t.x, t.y, t.z), i[0] = t.x, i[1] = t.y, i[2] = t.z);
  else {
    if (vf(i, t)) return;
    e.uniform3uiv(this.addr, t), Af(i, t);
  }
}
function YHe(e, t) {
  const i = this.cache;
  if (t.x !== void 0)
    (i[0] !== t.x || i[1] !== t.y || i[2] !== t.z || i[3] !== t.w) && (e.uniform4ui(this.addr, t.x, t.y, t.z, t.w), i[0] = t.x, i[1] = t.y, i[2] = t.z, i[3] = t.w);
  else {
    if (vf(i, t)) return;
    e.uniform4uiv(this.addr, t), Af(i, t);
  }
}
function qHe(e, t, i) {
  const n = this.cache, s = i.allocateTextureUnit();
  n[0] !== s && (e.uniform1i(this.addr, s), n[0] = s);
  let o;
  this.type === e.SAMPLER_2D_SHADOW ? (Lge.compareFunction = IAe, o = Lge) : o = NAe, i.setTexture2D(t || o, s);
}
function $He(e, t, i) {
  const n = this.cache, s = i.allocateTextureUnit();
  n[0] !== s && (e.uniform1i(this.addr, s), n[0] = s), i.setTexture3D(t || CAe, s);
}
function KHe(e, t, i) {
  const n = this.cache, s = i.allocateTextureUnit();
  n[0] !== s && (e.uniform1i(this.addr, s), n[0] = s), i.setTextureCube(t || OAe, s);
}
function ZHe(e, t, i) {
  const n = this.cache, s = i.allocateTextureUnit();
  n[0] !== s && (e.uniform1i(this.addr, s), n[0] = s), i.setTexture2DArray(t || DAe, s);
}
function QHe(e) {
  switch (e) {
    case 5126:
      return _He;
    // FLOAT
    case 35664:
      return xHe;
    // _VEC2
    case 35665:
      return PHe;
    // _VEC3
    case 35666:
      return MHe;
    // _VEC4
    case 35674:
      return UHe;
    // _MAT2
    case 35675:
      return BHe;
    // _MAT3
    case 35676:
      return FHe;
    // _MAT4
    case 5124:
    case 35670:
      return HHe;
    // INT, BOOL
    case 35667:
    case 35671:
      return GHe;
    // _VEC2
    case 35668:
    case 35672:
      return kHe;
    // _VEC3
    case 35669:
    case 35673:
      return VHe;
    // _VEC4
    case 5125:
      return zHe;
    // UINT
    case 36294:
      return jHe;
    // _VEC2
    case 36295:
      return WHe;
    // _VEC3
    case 36296:
      return YHe;
    // _VEC4
    case 35678:
    // SAMPLER_2D
    case 36198:
    // SAMPLER_EXTERNAL_OES
    case 36298:
    // INT_SAMPLER_2D
    case 36306:
    // UNSIGNED_INT_SAMPLER_2D
    case 35682:
      return qHe;
    case 35679:
    // SAMPLER_3D
    case 36299:
    // INT_SAMPLER_3D
    case 36307:
      return $He;
    case 35680:
    // SAMPLER_CUBE
    case 36300:
    // INT_SAMPLER_CUBE
    case 36308:
    // UNSIGNED_INT_SAMPLER_CUBE
    case 36293:
      return KHe;
    case 36289:
    // SAMPLER_2D_ARRAY
    case 36303:
    // INT_SAMPLER_2D_ARRAY
    case 36311:
    // UNSIGNED_INT_SAMPLER_2D_ARRAY
    case 36292:
      return ZHe;
  }
}
function JHe(e, t) {
  e.uniform1fv(this.addr, t);
}
function XHe(e, t) {
  const i = tY(t, this.size, 2);
  e.uniform2fv(this.addr, i);
}
function eGe(e, t) {
  const i = tY(t, this.size, 3);
  e.uniform3fv(this.addr, i);
}
function tGe(e, t) {
  const i = tY(t, this.size, 4);
  e.uniform4fv(this.addr, i);
}
function iGe(e, t) {
  const i = tY(t, this.size, 4);
  e.uniformMatrix2fv(this.addr, !1, i);
}
function nGe(e, t) {
  const i = tY(t, this.size, 9);
  e.uniformMatrix3fv(this.addr, !1, i);
}
function sGe(e, t) {
  const i = tY(t, this.size, 16);
  e.uniformMatrix4fv(this.addr, !1, i);
}
function oGe(e, t) {
  e.uniform1iv(this.addr, t);
}
function rGe(e, t) {
  e.uniform2iv(this.addr, t);
}
function lGe(e, t) {
  e.uniform3iv(this.addr, t);
}
function aGe(e, t) {
  e.uniform4iv(this.addr, t);
}
function uGe(e, t) {
  e.uniform1uiv(this.addr, t);
}
function dGe(e, t) {
  e.uniform2uiv(this.addr, t);
}
function cGe(e, t) {
  e.uniform3uiv(this.addr, t);
}
function hGe(e, t) {
  e.uniform4uiv(this.addr, t);
}
function fGe(e, t, i) {
  const n = this.cache, s = t.length, o = Sae(i, s);
  vf(n, o) || (e.uniform1iv(this.addr, o), Af(n, o));
  for (let r = 0; r !== s; ++r)
    i.setTexture2D(t[r] || NAe, o[r]);
}
function IGe(e, t, i) {
  const n = this.cache, s = t.length, o = Sae(i, s);
  vf(n, o) || (e.uniform1iv(this.addr, o), Af(n, o));
  for (let r = 0; r !== s; ++r)
    i.setTexture3D(t[r] || CAe, o[r]);
}
function pGe(e, t, i) {
  const n = this.cache, s = t.length, o = Sae(i, s);
  vf(n, o) || (e.uniform1iv(this.addr, o), Af(n, o));
  for (let r = 0; r !== s; ++r)
    i.setTextureCube(t[r] || OAe, o[r]);
}
function mGe(e, t, i) {
  const n = this.cache, s = t.length, o = Sae(i, s);
  vf(n, o) || (e.uniform1iv(this.addr, o), Af(n, o));
  for (let r = 0; r !== s; ++r)
    i.setTexture2DArray(t[r] || DAe, o[r]);
}
function yGe(e) {
  switch (e) {
    case 5126:
      return JHe;
    // FLOAT
    case 35664:
      return XHe;
    // _VEC2
    case 35665:
      return eGe;
    // _VEC3
    case 35666:
      return tGe;
    // _VEC4
    case 35674:
      return iGe;
    // _MAT2
    case 35675:
      return nGe;
    // _MAT3
    case 35676:
      return sGe;
    // _MAT4
    case 5124:
    case 35670:
      return oGe;
    // INT, BOOL
    case 35667:
    case 35671:
      return rGe;
    // _VEC2
    case 35668:
    case 35672:
      return lGe;
    // _VEC3
    case 35669:
    case 35673:
      return aGe;
    // _VEC4
    case 5125:
      return uGe;
    // UINT
    case 36294:
      return dGe;
    // _VEC2
    case 36295:
      return cGe;
    // _VEC3
    case 36296:
      return hGe;
    // _VEC4
    case 35678:
    // SAMPLER_2D
    case 36198:
    // SAMPLER_EXTERNAL_OES
    case 36298:
    // INT_SAMPLER_2D
    case 36306:
    // UNSIGNED_INT_SAMPLER_2D
    case 35682:
      return fGe;
    case 35679:
    // SAMPLER_3D
    case 36299:
    // INT_SAMPLER_3D
    case 36307:
      return IGe;
    case 35680:
    // SAMPLER_CUBE
    case 36300:
    // INT_SAMPLER_CUBE
    case 36308:
    // UNSIGNED_INT_SAMPLER_CUBE
    case 36293:
      return pGe;
    case 36289:
    // SAMPLER_2D_ARRAY
    case 36303:
    // INT_SAMPLER_2D_ARRAY
    case 36311:
    // UNSIGNED_INT_SAMPLER_2D_ARRAY
    case 36292:
      return mGe;
  }
}
class EGe {
  constructor(t, i, n) {
    this.id = t, this.addr = n, this.cache = [], this.type = i.type, this.setValue = QHe(i.type);
  }
}
class gGe {
  constructor(t, i, n) {
    this.id = t, this.addr = n, this.cache = [], this.type = i.type, this.size = i.size, this.setValue = yGe(i.type);
  }
}
class wGe {
  constructor(t) {
    this.id = t, this.seq = [], this.map = {};
  }
  setValue(t, i, n) {
    const s = this.seq;
    for (let o = 0, r = s.length; o !== r; ++o) {
      const l = s[o];
      l.setValue(t, i[l.id], n);
    }
  }
}
const qde = /(\w+)(\])?(\[|\.)?/g;
function Bge(e, t) {
  e.seq.push(t), e.map[t.id] = t;
}
function TGe(e, t, i) {
  const n = e.name, s = n.length;
  for (qde.lastIndex = 0; ; ) {
    const o = qde.exec(n), r = qde.lastIndex;
    let l = o[1];
    const c = o[2] === "]", h = o[3];
    if (c && (l = l | 0), h === void 0 || h === "[" && r + 2 === s) {
      Bge(i, h === void 0 ? new EGe(l, e, t) : new gGe(l, e, t));
      break;
    } else {
      let p = i.map[l];
      p === void 0 && (p = new wGe(l), Bge(i, p)), i = p;
    }
  }
}
class koe {
  constructor(t, i) {
    this.seq = [], this.map = {};
    const n = t.getProgramParameter(i, t.ACTIVE_UNIFORMS);
    for (let s = 0; s < n; ++s) {
      const o = t.getActiveUniform(i, s), r = t.getUniformLocation(i, o.name);
      TGe(o, r, this);
    }
  }
  setValue(t, i, n, s) {
    const o = this.map[i];
    o !== void 0 && o.setValue(t, n, s);
  }
  setOptional(t, i, n) {
    const s = i[n];
    s !== void 0 && this.setValue(t, n, s);
  }
  static upload(t, i, n, s) {
    for (let o = 0, r = i.length; o !== r; ++o) {
      const l = i[o], c = n[l.id];
      c.needsUpdate !== !1 && l.setValue(t, c.value, s);
    }
  }
  static seqWithValue(t, i) {
    const n = [];
    for (let s = 0, o = t.length; s !== o; ++s) {
      const r = t[s];
      r.id in i && n.push(r);
    }
    return n;
  }
}
function Fge(e, t, i) {
  const n = e.createShader(t);
  return e.shaderSource(n, i), e.compileShader(n), n;
}
const RGe = 37297;
let vGe = 0;
function AGe(e, t) {
  const i = e.split(`
`), n = [], s = Math.max(t - 6, 0), o = Math.min(t + 6, i.length);
  for (let r = s; r < o; r++) {
    const l = r + 1;
    n.push(`${l === t ? ">" : " "} ${l}: ${i[r]}`);
  }
  return n.join(`
`);
}
const Hge = /* @__PURE__ */ new fo();
function SGe(e) {
  Qr._getMatrix(Hge, Qr.workingColorSpace, e);
  const t = `mat3( ${Hge.elements.map((i) => i.toFixed(4))} )`;
  switch (Qr.getTransfer(e)) {
    case Ile:
      return [t, "LinearTransferOETF"];
    case Dl:
      return [t, "sRGBTransferOETF"];
    default:
      return console.warn("THREE.WebGLProgram: Unsupported color space: ", e), [t, "LinearTransferOETF"];
  }
}
function Gge(e, t, i) {
  const n = e.getShaderParameter(t, e.COMPILE_STATUS), s = e.getShaderInfoLog(t).trim();
  if (n && s === "") return "";
  const o = /ERROR: 0:(\d+)/.exec(s);
  if (o) {
    const r = parseInt(o[1]);
    return i.toUpperCase() + `

` + s + `

` + AGe(e.getShaderSource(t), r);
  } else
    return s;
}
function bGe(e, t) {
  const i = SGe(t);
  return [
    `vec4 ${e}( vec4 value ) {`,
    `	return ${i[1]}( vec4( value.rgb * ${i[0]}, value.a ) );`,
    "}"
  ].join(`
`);
}
function NGe(e, t) {
  let i;
  switch (t) {
    case n9e:
      i = "Linear";
      break;
    case s9e:
      i = "Reinhard";
      break;
    case o9e:
      i = "Cineon";
      break;
    case r9e:
      i = "ACESFilmic";
      break;
    case a9e:
      i = "AgX";
      break;
    case u9e:
      i = "Neutral";
      break;
    case l9e:
      i = "Custom";
      break;
    default:
      console.warn("THREE.WebGLProgram: Unsupported toneMapping:", t), i = "Linear";
  }
  return "vec3 " + e + "( vec3 color ) { return " + i + "ToneMapping( color ); }";
}
const Qne = /* @__PURE__ */ new Ge();
function DGe() {
  Qr.getLuminanceCoefficients(Qne);
  const e = Qne.x.toFixed(4), t = Qne.y.toFixed(4), i = Qne.z.toFixed(4);
  return [
    "float luminance( const in vec3 rgb ) {",
    `	const vec3 weights = vec3( ${e}, ${t}, ${i} );`,
    "	return dot( weights, rgb );",
    "}"
  ].join(`
`);
}
function CGe(e) {
  return [
    e.extensionClipCullDistance ? "#extension GL_ANGLE_clip_cull_distance : require" : "",
    e.extensionMultiDraw ? "#extension GL_ANGLE_multi_draw : require" : ""
  ].filter(SQ).join(`
`);
}
function OGe(e) {
  const t = [];
  for (const i in e) {
    const n = e[i];
    n !== !1 && t.push("#define " + i + " " + n);
  }
  return t.join(`
`);
}
function LGe(e, t) {
  const i = {}, n = e.getProgramParameter(t, e.ACTIVE_ATTRIBUTES);
  for (let s = 0; s < n; s++) {
    const o = e.getActiveAttrib(t, s), r = o.name;
    let l = 1;
    o.type === e.FLOAT_MAT2 && (l = 2), o.type === e.FLOAT_MAT3 && (l = 3), o.type === e.FLOAT_MAT4 && (l = 4), i[r] = {
      type: o.type,
      location: e.getAttribLocation(t, r),
      locationSize: l
    };
  }
  return i;
}
function SQ(e) {
  return e !== "";
}
function kge(e, t) {
  const i = t.numSpotLightShadows + t.numSpotLightMaps - t.numSpotLightShadowsWithMaps;
  return e.replace(/NUM_DIR_LIGHTS/g, t.numDirLights).replace(/NUM_SPOT_LIGHTS/g, t.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, t.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, i).replace(/NUM_RECT_AREA_LIGHTS/g, t.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, t.numPointLights).replace(/NUM_HEMI_LIGHTS/g, t.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, t.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, t.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, t.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, t.numPointLightShadows);
}
function Vge(e, t) {
  return e.replace(/NUM_CLIPPING_PLANES/g, t.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, t.numClippingPlanes - t.numClipIntersection);
}
const _Ge = /^[ \t]*#include +<([\w\d./]+)>/gm;
function K1e(e) {
  return e.replace(_Ge, PGe);
}
const xGe = /* @__PURE__ */ new Map();
function PGe(e, t) {
  let i = Lo[t];
  if (i === void 0) {
    const n = xGe.get(t);
    if (n !== void 0)
      i = Lo[n], console.warn('THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', t, n);
    else
      throw new Error("Can not resolve #include <" + t + ">");
  }
  return K1e(i);
}
const MGe = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function zge(e) {
  return e.replace(MGe, UGe);
}
function UGe(e, t, i, n) {
  let s = "";
  for (let o = parseInt(t); o < parseInt(i); o++)
    s += n.replace(/\[\s*i\s*\]/g, "[ " + o + " ]").replace(/UNROLLED_LOOP_INDEX/g, o);
  return s;
}
function jge(e) {
  let t = `precision ${e.precision} float;
	precision ${e.precision} int;
	precision ${e.precision} sampler2D;
	precision ${e.precision} samplerCube;
	precision ${e.precision} sampler3D;
	precision ${e.precision} sampler2DArray;
	precision ${e.precision} sampler2DShadow;
	precision ${e.precision} samplerCubeShadow;
	precision ${e.precision} sampler2DArrayShadow;
	precision ${e.precision} isampler2D;
	precision ${e.precision} isampler3D;
	precision ${e.precision} isamplerCube;
	precision ${e.precision} isampler2DArray;
	precision ${e.precision} usampler2D;
	precision ${e.precision} usampler3D;
	precision ${e.precision} usamplerCube;
	precision ${e.precision} usampler2DArray;
	`;
  return e.precision === "highp" ? t += `
#define HIGH_PRECISION` : e.precision === "mediump" ? t += `
#define MEDIUM_PRECISION` : e.precision === "lowp" && (t += `
#define LOW_PRECISION`), t;
}
function BGe(e) {
  let t = "SHADOWMAP_TYPE_BASIC";
  return e.shadowMapType === sAe ? t = "SHADOWMAP_TYPE_PCF" : e.shadowMapType === UMe ? t = "SHADOWMAP_TYPE_PCF_SOFT" : e.shadowMapType === WD && (t = "SHADOWMAP_TYPE_VSM"), t;
}
function FGe(e) {
  let t = "ENVMAP_TYPE_CUBE";
  if (e.envMap)
    switch (e.envMapMode) {
      case CW:
      case OW:
        t = "ENVMAP_TYPE_CUBE";
        break;
      case Rae:
        t = "ENVMAP_TYPE_CUBE_UV";
        break;
    }
  return t;
}
function HGe(e) {
  let t = "ENVMAP_MODE_REFLECTION";
  if (e.envMap)
    switch (e.envMapMode) {
      case OW:
        t = "ENVMAP_MODE_REFRACTION";
        break;
    }
  return t;
}
function GGe(e) {
  let t = "ENVMAP_BLENDING_NONE";
  if (e.envMap)
    switch (e.combine) {
      case Gpe:
        t = "ENVMAP_BLENDING_MULTIPLY";
        break;
      case t9e:
        t = "ENVMAP_BLENDING_MIX";
        break;
      case i9e:
        t = "ENVMAP_BLENDING_ADD";
        break;
    }
  return t;
}
function kGe(e) {
  const t = e.envMapCubeUVHeight;
  if (t === null) return null;
  const i = Math.log2(t) - 2, n = 1 / t;
  return { texelWidth: 1 / (3 * Math.max(Math.pow(2, i), 112)), texelHeight: n, maxMip: i };
}
function VGe(e, t, i, n) {
  const s = e.getContext(), o = i.defines;
  let r = i.vertexShader, l = i.fragmentShader;
  const c = BGe(i), h = FGe(i), I = HGe(i), p = GGe(i), y = kGe(i), m = CGe(i), A = OGe(o), C = s.createProgram();
  let O, R, F = i.glslVersion ? "#version " + i.glslVersion + `
` : "";
  i.isRawShaderMaterial ? (O = [
    "#define SHADER_TYPE " + i.shaderType,
    "#define SHADER_NAME " + i.shaderName,
    A
  ].filter(SQ).join(`
`), O.length > 0 && (O += `
`), R = [
    "#define SHADER_TYPE " + i.shaderType,
    "#define SHADER_NAME " + i.shaderName,
    A
  ].filter(SQ).join(`
`), R.length > 0 && (R += `
`)) : (O = [
    jge(i),
    "#define SHADER_TYPE " + i.shaderType,
    "#define SHADER_NAME " + i.shaderName,
    A,
    i.extensionClipCullDistance ? "#define USE_CLIP_DISTANCE" : "",
    i.batching ? "#define USE_BATCHING" : "",
    i.batchingColor ? "#define USE_BATCHING_COLOR" : "",
    i.instancing ? "#define USE_INSTANCING" : "",
    i.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
    i.instancingMorph ? "#define USE_INSTANCING_MORPH" : "",
    i.useFog && i.fog ? "#define USE_FOG" : "",
    i.useFog && i.fogExp2 ? "#define FOG_EXP2" : "",
    i.map ? "#define USE_MAP" : "",
    i.envMap ? "#define USE_ENVMAP" : "",
    i.envMap ? "#define " + I : "",
    i.lightMap ? "#define USE_LIGHTMAP" : "",
    i.aoMap ? "#define USE_AOMAP" : "",
    i.bumpMap ? "#define USE_BUMPMAP" : "",
    i.normalMap ? "#define USE_NORMALMAP" : "",
    i.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
    i.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
    i.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
    i.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
    i.anisotropy ? "#define USE_ANISOTROPY" : "",
    i.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
    i.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
    i.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
    i.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
    i.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
    i.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
    i.specularMap ? "#define USE_SPECULARMAP" : "",
    i.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
    i.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
    i.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
    i.metalnessMap ? "#define USE_METALNESSMAP" : "",
    i.alphaMap ? "#define USE_ALPHAMAP" : "",
    i.alphaHash ? "#define USE_ALPHAHASH" : "",
    i.transmission ? "#define USE_TRANSMISSION" : "",
    i.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
    i.thicknessMap ? "#define USE_THICKNESSMAP" : "",
    i.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
    i.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
    //
    i.mapUv ? "#define MAP_UV " + i.mapUv : "",
    i.alphaMapUv ? "#define ALPHAMAP_UV " + i.alphaMapUv : "",
    i.lightMapUv ? "#define LIGHTMAP_UV " + i.lightMapUv : "",
    i.aoMapUv ? "#define AOMAP_UV " + i.aoMapUv : "",
    i.emissiveMapUv ? "#define EMISSIVEMAP_UV " + i.emissiveMapUv : "",
    i.bumpMapUv ? "#define BUMPMAP_UV " + i.bumpMapUv : "",
    i.normalMapUv ? "#define NORMALMAP_UV " + i.normalMapUv : "",
    i.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + i.displacementMapUv : "",
    i.metalnessMapUv ? "#define METALNESSMAP_UV " + i.metalnessMapUv : "",
    i.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + i.roughnessMapUv : "",
    i.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + i.anisotropyMapUv : "",
    i.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + i.clearcoatMapUv : "",
    i.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + i.clearcoatNormalMapUv : "",
    i.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + i.clearcoatRoughnessMapUv : "",
    i.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + i.iridescenceMapUv : "",
    i.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + i.iridescenceThicknessMapUv : "",
    i.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + i.sheenColorMapUv : "",
    i.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + i.sheenRoughnessMapUv : "",
    i.specularMapUv ? "#define SPECULARMAP_UV " + i.specularMapUv : "",
    i.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + i.specularColorMapUv : "",
    i.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + i.specularIntensityMapUv : "",
    i.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + i.transmissionMapUv : "",
    i.thicknessMapUv ? "#define THICKNESSMAP_UV " + i.thicknessMapUv : "",
    //
    i.vertexTangents && i.flatShading === !1 ? "#define USE_TANGENT" : "",
    i.vertexColors ? "#define USE_COLOR" : "",
    i.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
    i.vertexUv1s ? "#define USE_UV1" : "",
    i.vertexUv2s ? "#define USE_UV2" : "",
    i.vertexUv3s ? "#define USE_UV3" : "",
    i.pointsUvs ? "#define USE_POINTS_UV" : "",
    i.flatShading ? "#define FLAT_SHADED" : "",
    i.skinning ? "#define USE_SKINNING" : "",
    i.morphTargets ? "#define USE_MORPHTARGETS" : "",
    i.morphNormals && i.flatShading === !1 ? "#define USE_MORPHNORMALS" : "",
    i.morphColors ? "#define USE_MORPHCOLORS" : "",
    i.morphTargetsCount > 0 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + i.morphTextureStride : "",
    i.morphTargetsCount > 0 ? "#define MORPHTARGETS_COUNT " + i.morphTargetsCount : "",
    i.doubleSided ? "#define DOUBLE_SIDED" : "",
    i.flipSided ? "#define FLIP_SIDED" : "",
    i.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
    i.shadowMapEnabled ? "#define " + c : "",
    i.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
    i.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
    i.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
    i.reverseDepthBuffer ? "#define USE_REVERSEDEPTHBUF" : "",
    "uniform mat4 modelMatrix;",
    "uniform mat4 modelViewMatrix;",
    "uniform mat4 projectionMatrix;",
    "uniform mat4 viewMatrix;",
    "uniform mat3 normalMatrix;",
    "uniform vec3 cameraPosition;",
    "uniform bool isOrthographic;",
    "#ifdef USE_INSTANCING",
    "	attribute mat4 instanceMatrix;",
    "#endif",
    "#ifdef USE_INSTANCING_COLOR",
    "	attribute vec3 instanceColor;",
    "#endif",
    "#ifdef USE_INSTANCING_MORPH",
    "	uniform sampler2D morphTexture;",
    "#endif",
    "attribute vec3 position;",
    "attribute vec3 normal;",
    "attribute vec2 uv;",
    "#ifdef USE_UV1",
    "	attribute vec2 uv1;",
    "#endif",
    "#ifdef USE_UV2",
    "	attribute vec2 uv2;",
    "#endif",
    "#ifdef USE_UV3",
    "	attribute vec2 uv3;",
    "#endif",
    "#ifdef USE_TANGENT",
    "	attribute vec4 tangent;",
    "#endif",
    "#if defined( USE_COLOR_ALPHA )",
    "	attribute vec4 color;",
    "#elif defined( USE_COLOR )",
    "	attribute vec3 color;",
    "#endif",
    "#ifdef USE_SKINNING",
    "	attribute vec4 skinIndex;",
    "	attribute vec4 skinWeight;",
    "#endif",
    `
`
  ].filter(SQ).join(`
`), R = [
    jge(i),
    "#define SHADER_TYPE " + i.shaderType,
    "#define SHADER_NAME " + i.shaderName,
    A,
    i.useFog && i.fog ? "#define USE_FOG" : "",
    i.useFog && i.fogExp2 ? "#define FOG_EXP2" : "",
    i.alphaToCoverage ? "#define ALPHA_TO_COVERAGE" : "",
    i.map ? "#define USE_MAP" : "",
    i.matcap ? "#define USE_MATCAP" : "",
    i.envMap ? "#define USE_ENVMAP" : "",
    i.envMap ? "#define " + h : "",
    i.envMap ? "#define " + I : "",
    i.envMap ? "#define " + p : "",
    y ? "#define CUBEUV_TEXEL_WIDTH " + y.texelWidth : "",
    y ? "#define CUBEUV_TEXEL_HEIGHT " + y.texelHeight : "",
    y ? "#define CUBEUV_MAX_MIP " + y.maxMip + ".0" : "",
    i.lightMap ? "#define USE_LIGHTMAP" : "",
    i.aoMap ? "#define USE_AOMAP" : "",
    i.bumpMap ? "#define USE_BUMPMAP" : "",
    i.normalMap ? "#define USE_NORMALMAP" : "",
    i.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
    i.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
    i.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
    i.anisotropy ? "#define USE_ANISOTROPY" : "",
    i.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
    i.clearcoat ? "#define USE_CLEARCOAT" : "",
    i.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
    i.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
    i.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
    i.dispersion ? "#define USE_DISPERSION" : "",
    i.iridescence ? "#define USE_IRIDESCENCE" : "",
    i.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
    i.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
    i.specularMap ? "#define USE_SPECULARMAP" : "",
    i.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
    i.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
    i.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
    i.metalnessMap ? "#define USE_METALNESSMAP" : "",
    i.alphaMap ? "#define USE_ALPHAMAP" : "",
    i.alphaTest ? "#define USE_ALPHATEST" : "",
    i.alphaHash ? "#define USE_ALPHAHASH" : "",
    i.sheen ? "#define USE_SHEEN" : "",
    i.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
    i.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
    i.transmission ? "#define USE_TRANSMISSION" : "",
    i.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
    i.thicknessMap ? "#define USE_THICKNESSMAP" : "",
    i.vertexTangents && i.flatShading === !1 ? "#define USE_TANGENT" : "",
    i.vertexColors || i.instancingColor || i.batchingColor ? "#define USE_COLOR" : "",
    i.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
    i.vertexUv1s ? "#define USE_UV1" : "",
    i.vertexUv2s ? "#define USE_UV2" : "",
    i.vertexUv3s ? "#define USE_UV3" : "",
    i.pointsUvs ? "#define USE_POINTS_UV" : "",
    i.gradientMap ? "#define USE_GRADIENTMAP" : "",
    i.flatShading ? "#define FLAT_SHADED" : "",
    i.doubleSided ? "#define DOUBLE_SIDED" : "",
    i.flipSided ? "#define FLIP_SIDED" : "",
    i.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
    i.shadowMapEnabled ? "#define " + c : "",
    i.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
    i.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
    i.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
    i.decodeVideoTextureEmissive ? "#define DECODE_VIDEO_TEXTURE_EMISSIVE" : "",
    i.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
    i.reverseDepthBuffer ? "#define USE_REVERSEDEPTHBUF" : "",
    "uniform mat4 viewMatrix;",
    "uniform vec3 cameraPosition;",
    "uniform bool isOrthographic;",
    i.toneMapping !== OP ? "#define TONE_MAPPING" : "",
    i.toneMapping !== OP ? Lo.tonemapping_pars_fragment : "",
    // this code is required here because it is used by the toneMapping() function defined below
    i.toneMapping !== OP ? NGe("toneMapping", i.toneMapping) : "",
    i.dithering ? "#define DITHERING" : "",
    i.opaque ? "#define OPAQUE" : "",
    Lo.colorspace_pars_fragment,
    // this code is required here because it is used by the various encoding/decoding function defined below
    bGe("linearToOutputTexel", i.outputColorSpace),
    DGe(),
    i.useDepthPacking ? "#define DEPTH_PACKING " + i.depthPacking : "",
    `
`
  ].filter(SQ).join(`
`)), r = K1e(r), r = kge(r, i), r = Vge(r, i), l = K1e(l), l = kge(l, i), l = Vge(l, i), r = zge(r), l = zge(l), i.isRawShaderMaterial !== !0 && (F = `#version 300 es
`, O = [
    m,
    "#define attribute in",
    "#define varying out",
    "#define texture2D texture"
  ].join(`
`) + `
` + O, R = [
    "#define varying in",
    i.glslVersion === zEe ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
    i.glslVersion === zEe ? "" : "#define gl_FragColor pc_fragColor",
    "#define gl_FragDepthEXT gl_FragDepth",
    "#define texture2D texture",
    "#define textureCube texture",
    "#define texture2DProj textureProj",
    "#define texture2DLodEXT textureLod",
    "#define texture2DProjLodEXT textureProjLod",
    "#define textureCubeLodEXT textureLod",
    "#define texture2DGradEXT textureGrad",
    "#define texture2DProjGradEXT textureProjGrad",
    "#define textureCubeGradEXT textureGrad"
  ].join(`
`) + `
` + R);
  const L = F + O + r, P = F + R + l, z = Fge(s, s.VERTEX_SHADER, L), W = Fge(s, s.FRAGMENT_SHADER, P);
  s.attachShader(C, z), s.attachShader(C, W), i.index0AttributeName !== void 0 ? s.bindAttribLocation(C, 0, i.index0AttributeName) : i.morphTargets === !0 && s.bindAttribLocation(C, 0, "position"), s.linkProgram(C);
  function re(Ne) {
    if (e.debug.checkShaderErrors) {
      const Ae = s.getProgramInfoLog(C).trim(), Oe = s.getShaderInfoLog(z).trim(), pe = s.getShaderInfoLog(W).trim();
      let je = !0, Ve = !0;
      if (s.getProgramParameter(C, s.LINK_STATUS) === !1)
        if (je = !1, typeof e.debug.onShaderError == "function")
          e.debug.onShaderError(s, C, z, W);
        else {
          const $e = Gge(s, z, "vertex"), vt = Gge(s, W, "fragment");
          console.error(
            "THREE.WebGLProgram: Shader Error " + s.getError() + " - VALIDATE_STATUS " + s.getProgramParameter(C, s.VALIDATE_STATUS) + `

Material Name: ` + Ne.name + `
Material Type: ` + Ne.type + `

Program Info Log: ` + Ae + `
` + $e + `
` + vt
          );
        }
      else Ae !== "" ? console.warn("THREE.WebGLProgram: Program Info Log:", Ae) : (Oe === "" || pe === "") && (Ve = !1);
      Ve && (Ne.diagnostics = {
        runnable: je,
        programLog: Ae,
        vertexShader: {
          log: Oe,
          prefix: O
        },
        fragmentShader: {
          log: pe,
          prefix: R
        }
      });
    }
    s.deleteShader(z), s.deleteShader(W), ce = new koe(s, C), te = LGe(s, C);
  }
  let ce;
  this.getUniforms = function() {
    return ce === void 0 && re(this), ce;
  };
  let te;
  this.getAttributes = function() {
    return te === void 0 && re(this), te;
  };
  let ee = i.rendererExtensionParallelShaderCompile === !1;
  return this.isReady = function() {
    return ee === !1 && (ee = s.getProgramParameter(C, RGe)), ee;
  }, this.destroy = function() {
    n.releaseStatesOfProgram(this), s.deleteProgram(C), this.program = void 0;
  }, this.type = i.shaderType, this.name = i.shaderName, this.id = vGe++, this.cacheKey = t, this.usedTimes = 1, this.program = C, this.vertexShader = z, this.fragmentShader = W, this;
}
let zGe = 0;
class jGe {
  constructor() {
    this.shaderCache = /* @__PURE__ */ new Map(), this.materialCache = /* @__PURE__ */ new Map();
  }
  update(t) {
    const i = t.vertexShader, n = t.fragmentShader, s = this._getShaderStage(i), o = this._getShaderStage(n), r = this._getShaderCacheForMaterial(t);
    return r.has(s) === !1 && (r.add(s), s.usedTimes++), r.has(o) === !1 && (r.add(o), o.usedTimes++), this;
  }
  remove(t) {
    const i = this.materialCache.get(t);
    for (const n of i)
      n.usedTimes--, n.usedTimes === 0 && this.shaderCache.delete(n.code);
    return this.materialCache.delete(t), this;
  }
  getVertexShaderID(t) {
    return this._getShaderStage(t.vertexShader).id;
  }
  getFragmentShaderID(t) {
    return this._getShaderStage(t.fragmentShader).id;
  }
  dispose() {
    this.shaderCache.clear(), this.materialCache.clear();
  }
  _getShaderCacheForMaterial(t) {
    const i = this.materialCache;
    let n = i.get(t);
    return n === void 0 && (n = /* @__PURE__ */ new Set(), i.set(t, n)), n;
  }
  _getShaderStage(t) {
    const i = this.shaderCache;
    let n = i.get(t);
    return n === void 0 && (n = new WGe(t), i.set(t, n)), n;
  }
}
class WGe {
  constructor(t) {
    this.id = zGe++, this.code = t, this.usedTimes = 0;
  }
}
function YGe(e, t, i, n, s, o, r) {
  const l = new Zpe(), c = new jGe(), h = /* @__PURE__ */ new Set(), I = [], p = s.logarithmicDepthBuffer, y = s.vertexTextures;
  let m = s.precision;
  const A = {
    MeshDepthMaterial: "depth",
    MeshDistanceMaterial: "distanceRGBA",
    MeshNormalMaterial: "normal",
    MeshBasicMaterial: "basic",
    MeshLambertMaterial: "lambert",
    MeshPhongMaterial: "phong",
    MeshToonMaterial: "toon",
    MeshStandardMaterial: "physical",
    MeshPhysicalMaterial: "physical",
    MeshMatcapMaterial: "matcap",
    LineBasicMaterial: "basic",
    LineDashedMaterial: "dashed",
    PointsMaterial: "points",
    ShadowMaterial: "shadow",
    SpriteMaterial: "sprite"
  };
  function C(te) {
    return h.add(te), te === 0 ? "uv" : `uv${te}`;
  }
  function O(te, ee, Ne, Ae, Oe) {
    const pe = Ae.fog, je = Oe.geometry, Ve = te.isMeshStandardMaterial ? Ae.environment : null, $e = (te.isMeshStandardMaterial ? i : t).get(te.envMap || Ve), vt = $e && $e.mapping === Rae ? $e.image.height : null, Rt = A[te.type];
    te.precision !== null && (m = s.getMaxPrecision(te.precision), m !== te.precision && console.warn("THREE.WebGLProgram.getParameters:", te.precision, "not supported, using", m, "instead."));
    const ze = je.morphAttributes.position || je.morphAttributes.normal || je.morphAttributes.color, mt = ze !== void 0 ? ze.length : 0;
    let Et = 0;
    je.morphAttributes.position !== void 0 && (Et = 1), je.morphAttributes.normal !== void 0 && (Et = 2), je.morphAttributes.color !== void 0 && (Et = 3);
    let it, Dt, Ct, Kt;
    if (Rt) {
      const Bs = Rg[Rt];
      it = Bs.vertexShader, Dt = Bs.fragmentShader;
    } else
      it = te.vertexShader, Dt = te.fragmentShader, c.update(te), Ct = c.getVertexShaderID(te), Kt = c.getFragmentShaderID(te);
    const Zt = e.getRenderTarget(), Xt = e.state.buffers.depth.getReversed(), gi = Oe.isInstancedMesh === !0, Wt = Oe.isBatchedMesh === !0, Di = !!te.map, ni = !!te.matcap, Ci = !!$e, Se = !!te.aoMap, si = !!te.lightMap, Mt = !!te.bumpMap, ft = !!te.normalMap, rt = !!te.displacementMap, Tt = !!te.emissiveMap, jt = !!te.metalnessMap, Jt = !!te.roughnessMap, $t = te.anisotropy > 0, ht = te.clearcoat > 0, Me = te.dispersion > 0, gt = te.iridescence > 0, yt = te.sheen > 0, Ut = te.transmission > 0, Ht = $t && !!te.anisotropyMap, wi = ht && !!te.clearcoatMap, bi = ht && !!te.clearcoatNormalMap, Hi = ht && !!te.clearcoatRoughnessMap, Wi = gt && !!te.iridescenceMap, hi = gt && !!te.iridescenceThicknessMap, Ji = yt && !!te.sheenColorMap, Sn = yt && !!te.sheenRoughnessMap, nn = !!te.specularMap, Yi = !!te.specularColorMap, Pi = !!te.specularIntensityMap, kt = Ut && !!te.transmissionMap, sn = Ut && !!te.thicknessMap, Fi = !!te.gradientMap, tn = !!te.alphaMap, Gi = te.alphaTest > 0, yi = !!te.alphaHash, bn = !!te.extensions;
    let ln = OP;
    te.toneMapped && (Zt === null || Zt.isXRRenderTarget === !0) && (ln = e.toneMapping);
    const No = {
      shaderID: Rt,
      shaderType: te.type,
      shaderName: te.name,
      vertexShader: it,
      fragmentShader: Dt,
      defines: te.defines,
      customVertexShaderID: Ct,
      customFragmentShaderID: Kt,
      isRawShaderMaterial: te.isRawShaderMaterial === !0,
      glslVersion: te.glslVersion,
      precision: m,
      batching: Wt,
      batchingColor: Wt && Oe._colorsTexture !== null,
      instancing: gi,
      instancingColor: gi && Oe.instanceColor !== null,
      instancingMorph: gi && Oe.morphTexture !== null,
      supportsVertexTextures: y,
      outputColorSpace: Zt === null ? e.outputColorSpace : Zt.isXRRenderTarget === !0 ? Zt.texture.colorSpace : LW,
      alphaToCoverage: !!te.alphaToCoverage,
      map: Di,
      matcap: ni,
      envMap: Ci,
      envMapMode: Ci && $e.mapping,
      envMapCubeUVHeight: vt,
      aoMap: Se,
      lightMap: si,
      bumpMap: Mt,
      normalMap: ft,
      displacementMap: y && rt,
      emissiveMap: Tt,
      normalMapObjectSpace: ft && te.normalMapType === f9e,
      normalMapTangentSpace: ft && te.normalMapType === fAe,
      metalnessMap: jt,
      roughnessMap: Jt,
      anisotropy: $t,
      anisotropyMap: Ht,
      clearcoat: ht,
      clearcoatMap: wi,
      clearcoatNormalMap: bi,
      clearcoatRoughnessMap: Hi,
      dispersion: Me,
      iridescence: gt,
      iridescenceMap: Wi,
      iridescenceThicknessMap: hi,
      sheen: yt,
      sheenColorMap: Ji,
      sheenRoughnessMap: Sn,
      specularMap: nn,
      specularColorMap: Yi,
      specularIntensityMap: Pi,
      transmission: Ut,
      transmissionMap: kt,
      thicknessMap: sn,
      gradientMap: Fi,
      opaque: te.transparent === !1 && te.blending === Sz && te.alphaToCoverage === !1,
      alphaMap: tn,
      alphaTest: Gi,
      alphaHash: yi,
      combine: te.combine,
      //
      mapUv: Di && C(te.map.channel),
      aoMapUv: Se && C(te.aoMap.channel),
      lightMapUv: si && C(te.lightMap.channel),
      bumpMapUv: Mt && C(te.bumpMap.channel),
      normalMapUv: ft && C(te.normalMap.channel),
      displacementMapUv: rt && C(te.displacementMap.channel),
      emissiveMapUv: Tt && C(te.emissiveMap.channel),
      metalnessMapUv: jt && C(te.metalnessMap.channel),
      roughnessMapUv: Jt && C(te.roughnessMap.channel),
      anisotropyMapUv: Ht && C(te.anisotropyMap.channel),
      clearcoatMapUv: wi && C(te.clearcoatMap.channel),
      clearcoatNormalMapUv: bi && C(te.clearcoatNormalMap.channel),
      clearcoatRoughnessMapUv: Hi && C(te.clearcoatRoughnessMap.channel),
      iridescenceMapUv: Wi && C(te.iridescenceMap.channel),
      iridescenceThicknessMapUv: hi && C(te.iridescenceThicknessMap.channel),
      sheenColorMapUv: Ji && C(te.sheenColorMap.channel),
      sheenRoughnessMapUv: Sn && C(te.sheenRoughnessMap.channel),
      specularMapUv: nn && C(te.specularMap.channel),
      specularColorMapUv: Yi && C(te.specularColorMap.channel),
      specularIntensityMapUv: Pi && C(te.specularIntensityMap.channel),
      transmissionMapUv: kt && C(te.transmissionMap.channel),
      thicknessMapUv: sn && C(te.thicknessMap.channel),
      alphaMapUv: tn && C(te.alphaMap.channel),
      //
      vertexTangents: !!je.attributes.tangent && (ft || $t),
      vertexColors: te.vertexColors,
      vertexAlphas: te.vertexColors === !0 && !!je.attributes.color && je.attributes.color.itemSize === 4,
      pointsUvs: Oe.isPoints === !0 && !!je.attributes.uv && (Di || tn),
      fog: !!pe,
      useFog: te.fog === !0,
      fogExp2: !!pe && pe.isFogExp2,
      flatShading: te.flatShading === !0 && te.wireframe === !1,
      sizeAttenuation: te.sizeAttenuation === !0,
      logarithmicDepthBuffer: p,
      reverseDepthBuffer: Xt,
      skinning: Oe.isSkinnedMesh === !0,
      morphTargets: je.morphAttributes.position !== void 0,
      morphNormals: je.morphAttributes.normal !== void 0,
      morphColors: je.morphAttributes.color !== void 0,
      morphTargetsCount: mt,
      morphTextureStride: Et,
      numDirLights: ee.directional.length,
      numPointLights: ee.point.length,
      numSpotLights: ee.spot.length,
      numSpotLightMaps: ee.spotLightMap.length,
      numRectAreaLights: ee.rectArea.length,
      numHemiLights: ee.hemi.length,
      numDirLightShadows: ee.directionalShadowMap.length,
      numPointLightShadows: ee.pointShadowMap.length,
      numSpotLightShadows: ee.spotShadowMap.length,
      numSpotLightShadowsWithMaps: ee.numSpotLightShadowsWithMaps,
      numLightProbes: ee.numLightProbes,
      numClippingPlanes: r.numPlanes,
      numClipIntersection: r.numIntersection,
      dithering: te.dithering,
      shadowMapEnabled: e.shadowMap.enabled && Ne.length > 0,
      shadowMapType: e.shadowMap.type,
      toneMapping: ln,
      decodeVideoTexture: Di && te.map.isVideoTexture === !0 && Qr.getTransfer(te.map.colorSpace) === Dl,
      decodeVideoTextureEmissive: Tt && te.emissiveMap.isVideoTexture === !0 && Qr.getTransfer(te.emissiveMap.colorSpace) === Dl,
      premultipliedAlpha: te.premultipliedAlpha,
      doubleSided: te.side === $y,
      flipSided: te.side === nE,
      useDepthPacking: te.depthPacking >= 0,
      depthPacking: te.depthPacking || 0,
      index0AttributeName: te.index0AttributeName,
      extensionClipCullDistance: bn && te.extensions.clipCullDistance === !0 && n.has("WEBGL_clip_cull_distance"),
      extensionMultiDraw: (bn && te.extensions.multiDraw === !0 || Wt) && n.has("WEBGL_multi_draw"),
      rendererExtensionParallelShaderCompile: n.has("KHR_parallel_shader_compile"),
      customProgramCacheKey: te.customProgramCacheKey()
    };
    return No.vertexUv1s = h.has(1), No.vertexUv2s = h.has(2), No.vertexUv3s = h.has(3), h.clear(), No;
  }
  function R(te) {
    const ee = [];
    if (te.shaderID ? ee.push(te.shaderID) : (ee.push(te.customVertexShaderID), ee.push(te.customFragmentShaderID)), te.defines !== void 0)
      for (const Ne in te.defines)
        ee.push(Ne), ee.push(te.defines[Ne]);
    return te.isRawShaderMaterial === !1 && (F(ee, te), L(ee, te), ee.push(e.outputColorSpace)), ee.push(te.customProgramCacheKey), ee.join();
  }
  function F(te, ee) {
    te.push(ee.precision), te.push(ee.outputColorSpace), te.push(ee.envMapMode), te.push(ee.envMapCubeUVHeight), te.push(ee.mapUv), te.push(ee.alphaMapUv), te.push(ee.lightMapUv), te.push(ee.aoMapUv), te.push(ee.bumpMapUv), te.push(ee.normalMapUv), te.push(ee.displacementMapUv), te.push(ee.emissiveMapUv), te.push(ee.metalnessMapUv), te.push(ee.roughnessMapUv), te.push(ee.anisotropyMapUv), te.push(ee.clearcoatMapUv), te.push(ee.clearcoatNormalMapUv), te.push(ee.clearcoatRoughnessMapUv), te.push(ee.iridescenceMapUv), te.push(ee.iridescenceThicknessMapUv), te.push(ee.sheenColorMapUv), te.push(ee.sheenRoughnessMapUv), te.push(ee.specularMapUv), te.push(ee.specularColorMapUv), te.push(ee.specularIntensityMapUv), te.push(ee.transmissionMapUv), te.push(ee.thicknessMapUv), te.push(ee.combine), te.push(ee.fogExp2), te.push(ee.sizeAttenuation), te.push(ee.morphTargetsCount), te.push(ee.morphAttributeCount), te.push(ee.numDirLights), te.push(ee.numPointLights), te.push(ee.numSpotLights), te.push(ee.numSpotLightMaps), te.push(ee.numHemiLights), te.push(ee.numRectAreaLights), te.push(ee.numDirLightShadows), te.push(ee.numPointLightShadows), te.push(ee.numSpotLightShadows), te.push(ee.numSpotLightShadowsWithMaps), te.push(ee.numLightProbes), te.push(ee.shadowMapType), te.push(ee.toneMapping), te.push(ee.numClippingPlanes), te.push(ee.numClipIntersection), te.push(ee.depthPacking);
  }
  function L(te, ee) {
    l.disableAll(), ee.supportsVertexTextures && l.enable(0), ee.instancing && l.enable(1), ee.instancingColor && l.enable(2), ee.instancingMorph && l.enable(3), ee.matcap && l.enable(4), ee.envMap && l.enable(5), ee.normalMapObjectSpace && l.enable(6), ee.normalMapTangentSpace && l.enable(7), ee.clearcoat && l.enable(8), ee.iridescence && l.enable(9), ee.alphaTest && l.enable(10), ee.vertexColors && l.enable(11), ee.vertexAlphas && l.enable(12), ee.vertexUv1s && l.enable(13), ee.vertexUv2s && l.enable(14), ee.vertexUv3s && l.enable(15), ee.vertexTangents && l.enable(16), ee.anisotropy && l.enable(17), ee.alphaHash && l.enable(18), ee.batching && l.enable(19), ee.dispersion && l.enable(20), ee.batchingColor && l.enable(21), ee.gradientMap && l.enable(22), te.push(l.mask), l.disableAll(), ee.fog && l.enable(0), ee.useFog && l.enable(1), ee.flatShading && l.enable(2), ee.logarithmicDepthBuffer && l.enable(3), ee.reverseDepthBuffer && l.enable(4), ee.skinning && l.enable(5), ee.morphTargets && l.enable(6), ee.morphNormals && l.enable(7), ee.morphColors && l.enable(8), ee.premultipliedAlpha && l.enable(9), ee.shadowMapEnabled && l.enable(10), ee.doubleSided && l.enable(11), ee.flipSided && l.enable(12), ee.useDepthPacking && l.enable(13), ee.dithering && l.enable(14), ee.transmission && l.enable(15), ee.sheen && l.enable(16), ee.opaque && l.enable(17), ee.pointsUvs && l.enable(18), ee.decodeVideoTexture && l.enable(19), ee.decodeVideoTextureEmissive && l.enable(20), ee.alphaToCoverage && l.enable(21), te.push(l.mask);
  }
  function P(te) {
    const ee = A[te.type];
    let Ne;
    if (ee) {
      const Ae = Rg[ee];
      Ne = vae.clone(Ae.uniforms);
    } else
      Ne = te.uniforms;
    return Ne;
  }
  function z(te, ee) {
    let Ne;
    for (let Ae = 0, Oe = I.length; Ae < Oe; Ae++) {
      const pe = I[Ae];
      if (pe.cacheKey === ee) {
        Ne = pe, ++Ne.usedTimes;
        break;
      }
    }
    return Ne === void 0 && (Ne = new VGe(e, ee, te, o), I.push(Ne)), Ne;
  }
  function W(te) {
    if (--te.usedTimes === 0) {
      const ee = I.indexOf(te);
      I[ee] = I[I.length - 1], I.pop(), te.destroy();
    }
  }
  function re(te) {
    c.remove(te);
  }
  function ce() {
    c.dispose();
  }
  return {
    getParameters: O,
    getProgramCacheKey: R,
    getUniforms: P,
    acquireProgram: z,
    releaseProgram: W,
    releaseShaderCache: re,
    // Exposed for resource monitoring & error feedback via renderer.info:
    programs: I,
    dispose: ce
  };
}
function qGe() {
  let e = /* @__PURE__ */ new WeakMap();
  function t(r) {
    return e.has(r);
  }
  function i(r) {
    let l = e.get(r);
    return l === void 0 && (l = {}, e.set(r, l)), l;
  }
  function n(r) {
    e.delete(r);
  }
  function s(r, l, c) {
    e.get(r)[l] = c;
  }
  function o() {
    e = /* @__PURE__ */ new WeakMap();
  }
  return {
    has: t,
    get: i,
    remove: n,
    update: s,
    dispose: o
  };
}
function $Ge(e, t) {
  return e.groupOrder !== t.groupOrder ? e.groupOrder - t.groupOrder : e.renderOrder !== t.renderOrder ? e.renderOrder - t.renderOrder : e.material.id !== t.material.id ? e.material.id - t.material.id : e.z !== t.z ? e.z - t.z : e.id - t.id;
}
function Wge(e, t) {
  return e.groupOrder !== t.groupOrder ? e.groupOrder - t.groupOrder : e.renderOrder !== t.renderOrder ? e.renderOrder - t.renderOrder : e.z !== t.z ? t.z - e.z : e.id - t.id;
}
function Yge() {
  const e = [];
  let t = 0;
  const i = [], n = [], s = [];
  function o() {
    t = 0, i.length = 0, n.length = 0, s.length = 0;
  }
  function r(p, y, m, A, C, O) {
    let R = e[t];
    return R === void 0 ? (R = {
      id: p.id,
      object: p,
      geometry: y,
      material: m,
      groupOrder: A,
      renderOrder: p.renderOrder,
      z: C,
      group: O
    }, e[t] = R) : (R.id = p.id, R.object = p, R.geometry = y, R.material = m, R.groupOrder = A, R.renderOrder = p.renderOrder, R.z = C, R.group = O), t++, R;
  }
  function l(p, y, m, A, C, O) {
    const R = r(p, y, m, A, C, O);
    m.transmission > 0 ? n.push(R) : m.transparent === !0 ? s.push(R) : i.push(R);
  }
  function c(p, y, m, A, C, O) {
    const R = r(p, y, m, A, C, O);
    m.transmission > 0 ? n.unshift(R) : m.transparent === !0 ? s.unshift(R) : i.unshift(R);
  }
  function h(p, y) {
    i.length > 1 && i.sort(p || $Ge), n.length > 1 && n.sort(y || Wge), s.length > 1 && s.sort(y || Wge);
  }
  function I() {
    for (let p = t, y = e.length; p < y; p++) {
      const m = e[p];
      if (m.id === null) break;
      m.id = null, m.object = null, m.geometry = null, m.material = null, m.group = null;
    }
  }
  return {
    opaque: i,
    transmissive: n,
    transparent: s,
    init: o,
    push: l,
    unshift: c,
    finish: I,
    sort: h
  };
}
function KGe() {
  let e = /* @__PURE__ */ new WeakMap();
  function t(n, s) {
    const o = e.get(n);
    let r;
    return o === void 0 ? (r = new Yge(), e.set(n, [r])) : s >= o.length ? (r = new Yge(), o.push(r)) : r = o[s], r;
  }
  function i() {
    e = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: t,
    dispose: i
  };
}
function ZGe() {
  const e = {};
  return {
    get: function(t) {
      if (e[t.id] !== void 0)
        return e[t.id];
      let i;
      switch (t.type) {
        case "DirectionalLight":
          i = {
            direction: new Ge(),
            color: new Xn()
          };
          break;
        case "SpotLight":
          i = {
            position: new Ge(),
            direction: new Ge(),
            color: new Xn(),
            distance: 0,
            coneCos: 0,
            penumbraCos: 0,
            decay: 0
          };
          break;
        case "PointLight":
          i = {
            position: new Ge(),
            color: new Xn(),
            distance: 0,
            decay: 0
          };
          break;
        case "HemisphereLight":
          i = {
            direction: new Ge(),
            skyColor: new Xn(),
            groundColor: new Xn()
          };
          break;
        case "RectAreaLight":
          i = {
            color: new Xn(),
            position: new Ge(),
            halfWidth: new Ge(),
            halfHeight: new Ge()
          };
          break;
      }
      return e[t.id] = i, i;
    }
  };
}
function QGe() {
  const e = {};
  return {
    get: function(t) {
      if (e[t.id] !== void 0)
        return e[t.id];
      let i;
      switch (t.type) {
        case "DirectionalLight":
          i = {
            shadowIntensity: 1,
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new us()
          };
          break;
        case "SpotLight":
          i = {
            shadowIntensity: 1,
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new us()
          };
          break;
        case "PointLight":
          i = {
            shadowIntensity: 1,
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new us(),
            shadowCameraNear: 1,
            shadowCameraFar: 1e3
          };
          break;
      }
      return e[t.id] = i, i;
    }
  };
}
let JGe = 0;
function XGe(e, t) {
  return (t.castShadow ? 2 : 0) - (e.castShadow ? 2 : 0) + (t.map ? 1 : 0) - (e.map ? 1 : 0);
}
function eke(e) {
  const t = new ZGe(), i = QGe(), n = {
    version: 0,
    hash: {
      directionalLength: -1,
      pointLength: -1,
      spotLength: -1,
      rectAreaLength: -1,
      hemiLength: -1,
      numDirectionalShadows: -1,
      numPointShadows: -1,
      numSpotShadows: -1,
      numSpotMaps: -1,
      numLightProbes: -1
    },
    ambient: [0, 0, 0],
    probe: [],
    directional: [],
    directionalShadow: [],
    directionalShadowMap: [],
    directionalShadowMatrix: [],
    spot: [],
    spotLightMap: [],
    spotShadow: [],
    spotShadowMap: [],
    spotLightMatrix: [],
    rectArea: [],
    rectAreaLTC1: null,
    rectAreaLTC2: null,
    point: [],
    pointShadow: [],
    pointShadowMap: [],
    pointShadowMatrix: [],
    hemi: [],
    numSpotLightShadowsWithMaps: 0,
    numLightProbes: 0
  };
  for (let h = 0; h < 9; h++) n.probe.push(new Ge());
  const s = new Ge(), o = new Ln(), r = new Ln();
  function l(h) {
    let I = 0, p = 0, y = 0;
    for (let te = 0; te < 9; te++) n.probe[te].set(0, 0, 0);
    let m = 0, A = 0, C = 0, O = 0, R = 0, F = 0, L = 0, P = 0, z = 0, W = 0, re = 0;
    h.sort(XGe);
    for (let te = 0, ee = h.length; te < ee; te++) {
      const Ne = h[te], Ae = Ne.color, Oe = Ne.intensity, pe = Ne.distance, je = Ne.shadow && Ne.shadow.map ? Ne.shadow.map.texture : null;
      if (Ne.isAmbientLight)
        I += Ae.r * Oe, p += Ae.g * Oe, y += Ae.b * Oe;
      else if (Ne.isLightProbe) {
        for (let Ve = 0; Ve < 9; Ve++)
          n.probe[Ve].addScaledVector(Ne.sh.coefficients[Ve], Oe);
        re++;
      } else if (Ne.isDirectionalLight) {
        const Ve = t.get(Ne);
        if (Ve.color.copy(Ne.color).multiplyScalar(Ne.intensity), Ne.castShadow) {
          const $e = Ne.shadow, vt = i.get(Ne);
          vt.shadowIntensity = $e.intensity, vt.shadowBias = $e.bias, vt.shadowNormalBias = $e.normalBias, vt.shadowRadius = $e.radius, vt.shadowMapSize = $e.mapSize, n.directionalShadow[m] = vt, n.directionalShadowMap[m] = je, n.directionalShadowMatrix[m] = Ne.shadow.matrix, F++;
        }
        n.directional[m] = Ve, m++;
      } else if (Ne.isSpotLight) {
        const Ve = t.get(Ne);
        Ve.position.setFromMatrixPosition(Ne.matrixWorld), Ve.color.copy(Ae).multiplyScalar(Oe), Ve.distance = pe, Ve.coneCos = Math.cos(Ne.angle), Ve.penumbraCos = Math.cos(Ne.angle * (1 - Ne.penumbra)), Ve.decay = Ne.decay, n.spot[C] = Ve;
        const $e = Ne.shadow;
        if (Ne.map && (n.spotLightMap[z] = Ne.map, z++, $e.updateMatrices(Ne), Ne.castShadow && W++), n.spotLightMatrix[C] = $e.matrix, Ne.castShadow) {
          const vt = i.get(Ne);
          vt.shadowIntensity = $e.intensity, vt.shadowBias = $e.bias, vt.shadowNormalBias = $e.normalBias, vt.shadowRadius = $e.radius, vt.shadowMapSize = $e.mapSize, n.spotShadow[C] = vt, n.spotShadowMap[C] = je, P++;
        }
        C++;
      } else if (Ne.isRectAreaLight) {
        const Ve = t.get(Ne);
        Ve.color.copy(Ae).multiplyScalar(Oe), Ve.halfWidth.set(Ne.width * 0.5, 0, 0), Ve.halfHeight.set(0, Ne.height * 0.5, 0), n.rectArea[O] = Ve, O++;
      } else if (Ne.isPointLight) {
        const Ve = t.get(Ne);
        if (Ve.color.copy(Ne.color).multiplyScalar(Ne.intensity), Ve.distance = Ne.distance, Ve.decay = Ne.decay, Ne.castShadow) {
          const $e = Ne.shadow, vt = i.get(Ne);
          vt.shadowIntensity = $e.intensity, vt.shadowBias = $e.bias, vt.shadowNormalBias = $e.normalBias, vt.shadowRadius = $e.radius, vt.shadowMapSize = $e.mapSize, vt.shadowCameraNear = $e.camera.near, vt.shadowCameraFar = $e.camera.far, n.pointShadow[A] = vt, n.pointShadowMap[A] = je, n.pointShadowMatrix[A] = Ne.shadow.matrix, L++;
        }
        n.point[A] = Ve, A++;
      } else if (Ne.isHemisphereLight) {
        const Ve = t.get(Ne);
        Ve.skyColor.copy(Ne.color).multiplyScalar(Oe), Ve.groundColor.copy(Ne.groundColor).multiplyScalar(Oe), n.hemi[R] = Ve, R++;
      }
    }
    O > 0 && (e.has("OES_texture_float_linear") === !0 ? (n.rectAreaLTC1 = An.LTC_FLOAT_1, n.rectAreaLTC2 = An.LTC_FLOAT_2) : (n.rectAreaLTC1 = An.LTC_HALF_1, n.rectAreaLTC2 = An.LTC_HALF_2)), n.ambient[0] = I, n.ambient[1] = p, n.ambient[2] = y;
    const ce = n.hash;
    (ce.directionalLength !== m || ce.pointLength !== A || ce.spotLength !== C || ce.rectAreaLength !== O || ce.hemiLength !== R || ce.numDirectionalShadows !== F || ce.numPointShadows !== L || ce.numSpotShadows !== P || ce.numSpotMaps !== z || ce.numLightProbes !== re) && (n.directional.length = m, n.spot.length = C, n.rectArea.length = O, n.point.length = A, n.hemi.length = R, n.directionalShadow.length = F, n.directionalShadowMap.length = F, n.pointShadow.length = L, n.pointShadowMap.length = L, n.spotShadow.length = P, n.spotShadowMap.length = P, n.directionalShadowMatrix.length = F, n.pointShadowMatrix.length = L, n.spotLightMatrix.length = P + z - W, n.spotLightMap.length = z, n.numSpotLightShadowsWithMaps = W, n.numLightProbes = re, ce.directionalLength = m, ce.pointLength = A, ce.spotLength = C, ce.rectAreaLength = O, ce.hemiLength = R, ce.numDirectionalShadows = F, ce.numPointShadows = L, ce.numSpotShadows = P, ce.numSpotMaps = z, ce.numLightProbes = re, n.version = JGe++);
  }
  function c(h, I) {
    let p = 0, y = 0, m = 0, A = 0, C = 0;
    const O = I.matrixWorldInverse;
    for (let R = 0, F = h.length; R < F; R++) {
      const L = h[R];
      if (L.isDirectionalLight) {
        const P = n.directional[p];
        P.direction.setFromMatrixPosition(L.matrixWorld), s.setFromMatrixPosition(L.target.matrixWorld), P.direction.sub(s), P.direction.transformDirection(O), p++;
      } else if (L.isSpotLight) {
        const P = n.spot[m];
        P.position.setFromMatrixPosition(L.matrixWorld), P.position.applyMatrix4(O), P.direction.setFromMatrixPosition(L.matrixWorld), s.setFromMatrixPosition(L.target.matrixWorld), P.direction.sub(s), P.direction.transformDirection(O), m++;
      } else if (L.isRectAreaLight) {
        const P = n.rectArea[A];
        P.position.setFromMatrixPosition(L.matrixWorld), P.position.applyMatrix4(O), r.identity(), o.copy(L.matrixWorld), o.premultiply(O), r.extractRotation(o), P.halfWidth.set(L.width * 0.5, 0, 0), P.halfHeight.set(0, L.height * 0.5, 0), P.halfWidth.applyMatrix4(r), P.halfHeight.applyMatrix4(r), A++;
      } else if (L.isPointLight) {
        const P = n.point[y];
        P.position.setFromMatrixPosition(L.matrixWorld), P.position.applyMatrix4(O), y++;
      } else if (L.isHemisphereLight) {
        const P = n.hemi[C];
        P.direction.setFromMatrixPosition(L.matrixWorld), P.direction.transformDirection(O), C++;
      }
    }
  }
  return {
    setup: l,
    setupView: c,
    state: n
  };
}
function qge(e) {
  const t = new eke(e), i = [], n = [];
  function s(I) {
    h.camera = I, i.length = 0, n.length = 0;
  }
  function o(I) {
    i.push(I);
  }
  function r(I) {
    n.push(I);
  }
  function l() {
    t.setup(i);
  }
  function c(I) {
    t.setupView(i, I);
  }
  const h = {
    lightsArray: i,
    shadowsArray: n,
    camera: null,
    lights: t,
    transmissionRenderTarget: {}
  };
  return {
    init: s,
    state: h,
    setupLights: l,
    setupLightsView: c,
    pushLight: o,
    pushShadow: r
  };
}
function tke(e) {
  let t = /* @__PURE__ */ new WeakMap();
  function i(s, o = 0) {
    const r = t.get(s);
    let l;
    return r === void 0 ? (l = new qge(e), t.set(s, [l])) : o >= r.length ? (l = new qge(e), r.push(l)) : l = r[o], l;
  }
  function n() {
    t = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: i,
    dispose: n
  };
}
const ike = `void main() {
	gl_Position = vec4( position, 1.0 );
}`, nke = `uniform sampler2D shadow_pass;
uniform vec2 resolution;
uniform float radius;
#include <packing>
void main() {
	const float samples = float( VSM_SAMPLES );
	float mean = 0.0;
	float squared_mean = 0.0;
	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );
	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;
	for ( float i = 0.0; i < samples; i ++ ) {
		float uvOffset = uvStart + i * uvStride;
		#ifdef HORIZONTAL_PASS
			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );
			mean += distribution.x;
			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;
		#else
			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );
			mean += depth;
			squared_mean += depth * depth;
		#endif
	}
	mean = mean / samples;
	squared_mean = squared_mean / samples;
	float std_dev = sqrt( squared_mean - mean * mean );
	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );
}`;
function ske(e, t, i) {
  let n = new cL();
  const s = new us(), o = new us(), r = new Ol(), l = new RUe({ depthPacking: h9e }), c = new vUe(), h = {}, I = i.maxTextureSize, p = { [xA]: nE, [nE]: xA, [$y]: $y }, y = new BA({
    defines: {
      VSM_SAMPLES: 8
    },
    uniforms: {
      shadow_pass: { value: null },
      resolution: { value: new us() },
      radius: { value: 4 }
    },
    vertexShader: ike,
    fragmentShader: nke
  }), m = y.clone();
  m.defines.HORIZONTAL_PASS = 1;
  const A = new Vl();
  A.setAttribute(
    "position",
    new zu(
      new Float32Array([-1, -1, 0.5, 3, -1, 0.5, -1, 3, 0.5]),
      3
    )
  );
  const C = new En(A, y), O = this;
  this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = sAe;
  let R = this.type;
  this.render = function(W, re, ce) {
    if (O.enabled === !1 || O.autoUpdate === !1 && O.needsUpdate === !1 || W.length === 0) return;
    const te = e.getRenderTarget(), ee = e.getActiveCubeFace(), Ne = e.getActiveMipmapLevel(), Ae = e.state;
    Ae.setBlending(CP), Ae.buffers.color.setClear(1, 1, 1, 1), Ae.buffers.depth.setTest(!0), Ae.setScissorTest(!1);
    const Oe = R !== WD && this.type === WD, pe = R === WD && this.type !== WD;
    for (let je = 0, Ve = W.length; je < Ve; je++) {
      const $e = W[je], vt = $e.shadow;
      if (vt === void 0) {
        console.warn("THREE.WebGLShadowMap:", $e, "has no shadow.");
        continue;
      }
      if (vt.autoUpdate === !1 && vt.needsUpdate === !1) continue;
      s.copy(vt.mapSize);
      const Rt = vt.getFrameExtents();
      if (s.multiply(Rt), o.copy(vt.mapSize), (s.x > I || s.y > I) && (s.x > I && (o.x = Math.floor(I / Rt.x), s.x = o.x * Rt.x, vt.mapSize.x = o.x), s.y > I && (o.y = Math.floor(I / Rt.y), s.y = o.y * Rt.y, vt.mapSize.y = o.y)), vt.map === null || Oe === !0 || pe === !0) {
        const mt = this.type !== WD ? { minFilter: g4, magFilter: g4 } : {};
        vt.map !== null && vt.map.dispose(), vt.map = new qP(s.x, s.y, mt), vt.map.texture.name = $e.name + ".shadowMap", vt.camera.updateProjectionMatrix();
      }
      e.setRenderTarget(vt.map), e.clear();
      const ze = vt.getViewportCount();
      for (let mt = 0; mt < ze; mt++) {
        const Et = vt.getViewport(mt);
        r.set(
          o.x * Et.x,
          o.y * Et.y,
          o.x * Et.z,
          o.y * Et.w
        ), Ae.viewport(r), vt.updateMatrices($e, mt), n = vt.getFrustum(), P(re, ce, vt.camera, $e, this.type);
      }
      vt.isPointLightShadow !== !0 && this.type === WD && F(vt, ce), vt.needsUpdate = !1;
    }
    R = this.type, O.needsUpdate = !1, e.setRenderTarget(te, ee, Ne);
  };
  function F(W, re) {
    const ce = t.update(C);
    y.defines.VSM_SAMPLES !== W.blurSamples && (y.defines.VSM_SAMPLES = W.blurSamples, m.defines.VSM_SAMPLES = W.blurSamples, y.needsUpdate = !0, m.needsUpdate = !0), W.mapPass === null && (W.mapPass = new qP(s.x, s.y)), y.uniforms.shadow_pass.value = W.map.texture, y.uniforms.resolution.value = W.mapSize, y.uniforms.radius.value = W.radius, e.setRenderTarget(W.mapPass), e.clear(), e.renderBufferDirect(re, null, ce, y, C, null), m.uniforms.shadow_pass.value = W.mapPass.texture, m.uniforms.resolution.value = W.mapSize, m.uniforms.radius.value = W.radius, e.setRenderTarget(W.map), e.clear(), e.renderBufferDirect(re, null, ce, m, C, null);
  }
  function L(W, re, ce, te) {
    let ee = null;
    const Ne = ce.isPointLight === !0 ? W.customDistanceMaterial : W.customDepthMaterial;
    if (Ne !== void 0)
      ee = Ne;
    else if (ee = ce.isPointLight === !0 ? c : l, e.localClippingEnabled && re.clipShadows === !0 && Array.isArray(re.clippingPlanes) && re.clippingPlanes.length !== 0 || re.displacementMap && re.displacementScale !== 0 || re.alphaMap && re.alphaTest > 0 || re.map && re.alphaTest > 0 || re.alphaToCoverage === !0) {
      const Ae = ee.uuid, Oe = re.uuid;
      let pe = h[Ae];
      pe === void 0 && (pe = {}, h[Ae] = pe);
      let je = pe[Oe];
      je === void 0 && (je = ee.clone(), pe[Oe] = je, re.addEventListener("dispose", z)), ee = je;
    }
    if (ee.visible = re.visible, ee.wireframe = re.wireframe, te === WD ? ee.side = re.shadowSide !== null ? re.shadowSide : re.side : ee.side = re.shadowSide !== null ? re.shadowSide : p[re.side], ee.alphaMap = re.alphaMap, ee.alphaTest = re.alphaToCoverage === !0 ? 0.5 : re.alphaTest, ee.map = re.map, ee.clipShadows = re.clipShadows, ee.clippingPlanes = re.clippingPlanes, ee.clipIntersection = re.clipIntersection, ee.displacementMap = re.displacementMap, ee.displacementScale = re.displacementScale, ee.displacementBias = re.displacementBias, ee.wireframeLinewidth = re.wireframeLinewidth, ee.linewidth = re.linewidth, ce.isPointLight === !0 && ee.isMeshDistanceMaterial === !0) {
      const Ae = e.properties.get(ee);
      Ae.light = ce;
    }
    return ee;
  }
  function P(W, re, ce, te, ee) {
    if (W.visible === !1) return;
    if (W.layers.test(re.layers) && (W.isMesh || W.isLine || W.isPoints) && (W.castShadow || W.receiveShadow && ee === WD) && (!W.frustumCulled || n.intersectsObject(W))) {
      W.modelViewMatrix.multiplyMatrices(ce.matrixWorldInverse, W.matrixWorld);
      const Oe = t.update(W), pe = W.material;
      if (Array.isArray(pe)) {
        const je = Oe.groups;
        for (let Ve = 0, $e = je.length; Ve < $e; Ve++) {
          const vt = je[Ve], Rt = pe[vt.materialIndex];
          if (Rt && Rt.visible) {
            const ze = L(W, Rt, te, ee);
            W.onBeforeShadow(e, W, re, ce, Oe, ze, vt), e.renderBufferDirect(ce, null, Oe, ze, W, vt), W.onAfterShadow(e, W, re, ce, Oe, ze, vt);
          }
        }
      } else if (pe.visible) {
        const je = L(W, pe, te, ee);
        W.onBeforeShadow(e, W, re, ce, Oe, je, null), e.renderBufferDirect(ce, null, Oe, je, W, null), W.onAfterShadow(e, W, re, ce, Oe, je, null);
      }
    }
    const Ae = W.children;
    for (let Oe = 0, pe = Ae.length; Oe < pe; Oe++)
      P(Ae[Oe], re, ce, te, ee);
  }
  function z(W) {
    W.target.removeEventListener("dispose", z);
    for (const ce in h) {
      const te = h[ce], ee = W.target.uuid;
      ee in te && (te[ee].dispose(), delete te[ee]);
    }
  }
}
const oke = {
  [l1e]: a1e,
  [u1e]: h1e,
  [d1e]: f1e,
  [DW]: c1e,
  [a1e]: l1e,
  [h1e]: u1e,
  [f1e]: d1e,
  [c1e]: DW
};
function rke(e, t) {
  function i() {
    let kt = !1;
    const sn = new Ol();
    let Fi = null;
    const tn = new Ol(0, 0, 0, 0);
    return {
      setMask: function(Gi) {
        Fi !== Gi && !kt && (e.colorMask(Gi, Gi, Gi, Gi), Fi = Gi);
      },
      setLocked: function(Gi) {
        kt = Gi;
      },
      setClear: function(Gi, yi, bn, ln, No) {
        No === !0 && (Gi *= ln, yi *= ln, bn *= ln), sn.set(Gi, yi, bn, ln), tn.equals(sn) === !1 && (e.clearColor(Gi, yi, bn, ln), tn.copy(sn));
      },
      reset: function() {
        kt = !1, Fi = null, tn.set(-1, 0, 0, 0);
      }
    };
  }
  function n() {
    let kt = !1, sn = !1, Fi = null, tn = null, Gi = null;
    return {
      setReversed: function(yi) {
        if (sn !== yi) {
          const bn = t.get("EXT_clip_control");
          yi ? bn.clipControlEXT(bn.LOWER_LEFT_EXT, bn.ZERO_TO_ONE_EXT) : bn.clipControlEXT(bn.LOWER_LEFT_EXT, bn.NEGATIVE_ONE_TO_ONE_EXT), sn = yi;
          const ln = Gi;
          Gi = null, this.setClear(ln);
        }
      },
      getReversed: function() {
        return sn;
      },
      setTest: function(yi) {
        yi ? Zt(e.DEPTH_TEST) : Xt(e.DEPTH_TEST);
      },
      setMask: function(yi) {
        Fi !== yi && !kt && (e.depthMask(yi), Fi = yi);
      },
      setFunc: function(yi) {
        if (sn && (yi = oke[yi]), tn !== yi) {
          switch (yi) {
            case l1e:
              e.depthFunc(e.NEVER);
              break;
            case a1e:
              e.depthFunc(e.ALWAYS);
              break;
            case u1e:
              e.depthFunc(e.LESS);
              break;
            case DW:
              e.depthFunc(e.LEQUAL);
              break;
            case d1e:
              e.depthFunc(e.EQUAL);
              break;
            case c1e:
              e.depthFunc(e.GEQUAL);
              break;
            case h1e:
              e.depthFunc(e.GREATER);
              break;
            case f1e:
              e.depthFunc(e.NOTEQUAL);
              break;
            default:
              e.depthFunc(e.LEQUAL);
          }
          tn = yi;
        }
      },
      setLocked: function(yi) {
        kt = yi;
      },
      setClear: function(yi) {
        Gi !== yi && (sn && (yi = 1 - yi), e.clearDepth(yi), Gi = yi);
      },
      reset: function() {
        kt = !1, Fi = null, tn = null, Gi = null, sn = !1;
      }
    };
  }
  function s() {
    let kt = !1, sn = null, Fi = null, tn = null, Gi = null, yi = null, bn = null, ln = null, No = null;
    return {
      setTest: function(Bs) {
        kt || (Bs ? Zt(e.STENCIL_TEST) : Xt(e.STENCIL_TEST));
      },
      setMask: function(Bs) {
        sn !== Bs && !kt && (e.stencilMask(Bs), sn = Bs);
      },
      setFunc: function(Bs, os, vl) {
        (Fi !== Bs || tn !== os || Gi !== vl) && (e.stencilFunc(Bs, os, vl), Fi = Bs, tn = os, Gi = vl);
      },
      setOp: function(Bs, os, vl) {
        (yi !== Bs || bn !== os || ln !== vl) && (e.stencilOp(Bs, os, vl), yi = Bs, bn = os, ln = vl);
      },
      setLocked: function(Bs) {
        kt = Bs;
      },
      setClear: function(Bs) {
        No !== Bs && (e.clearStencil(Bs), No = Bs);
      },
      reset: function() {
        kt = !1, sn = null, Fi = null, tn = null, Gi = null, yi = null, bn = null, ln = null, No = null;
      }
    };
  }
  const o = new i(), r = new n(), l = new s(), c = /* @__PURE__ */ new WeakMap(), h = /* @__PURE__ */ new WeakMap();
  let I = {}, p = {}, y = /* @__PURE__ */ new WeakMap(), m = [], A = null, C = !1, O = null, R = null, F = null, L = null, P = null, z = null, W = null, re = new Xn(0, 0, 0), ce = 0, te = !1, ee = null, Ne = null, Ae = null, Oe = null, pe = null;
  const je = e.getParameter(e.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
  let Ve = !1, $e = 0;
  const vt = e.getParameter(e.VERSION);
  vt.indexOf("WebGL") !== -1 ? ($e = parseFloat(/^WebGL (\d)/.exec(vt)[1]), Ve = $e >= 1) : vt.indexOf("OpenGL ES") !== -1 && ($e = parseFloat(/^OpenGL ES (\d)/.exec(vt)[1]), Ve = $e >= 2);
  let Rt = null, ze = {};
  const mt = e.getParameter(e.SCISSOR_BOX), Et = e.getParameter(e.VIEWPORT), it = new Ol().fromArray(mt), Dt = new Ol().fromArray(Et);
  function Ct(kt, sn, Fi, tn) {
    const Gi = new Uint8Array(4), yi = e.createTexture();
    e.bindTexture(kt, yi), e.texParameteri(kt, e.TEXTURE_MIN_FILTER, e.NEAREST), e.texParameteri(kt, e.TEXTURE_MAG_FILTER, e.NEAREST);
    for (let bn = 0; bn < Fi; bn++)
      kt === e.TEXTURE_3D || kt === e.TEXTURE_2D_ARRAY ? e.texImage3D(sn, 0, e.RGBA, 1, 1, tn, 0, e.RGBA, e.UNSIGNED_BYTE, Gi) : e.texImage2D(sn + bn, 0, e.RGBA, 1, 1, 0, e.RGBA, e.UNSIGNED_BYTE, Gi);
    return yi;
  }
  const Kt = {};
  Kt[e.TEXTURE_2D] = Ct(e.TEXTURE_2D, e.TEXTURE_2D, 1), Kt[e.TEXTURE_CUBE_MAP] = Ct(e.TEXTURE_CUBE_MAP, e.TEXTURE_CUBE_MAP_POSITIVE_X, 6), Kt[e.TEXTURE_2D_ARRAY] = Ct(e.TEXTURE_2D_ARRAY, e.TEXTURE_2D_ARRAY, 1, 1), Kt[e.TEXTURE_3D] = Ct(e.TEXTURE_3D, e.TEXTURE_3D, 1, 1), o.setClear(0, 0, 0, 1), r.setClear(1), l.setClear(0), Zt(e.DEPTH_TEST), r.setFunc(DW), Mt(!1), ft(FEe), Zt(e.CULL_FACE), Se(CP);
  function Zt(kt) {
    I[kt] !== !0 && (e.enable(kt), I[kt] = !0);
  }
  function Xt(kt) {
    I[kt] !== !1 && (e.disable(kt), I[kt] = !1);
  }
  function gi(kt, sn) {
    return p[kt] !== sn ? (e.bindFramebuffer(kt, sn), p[kt] = sn, kt === e.DRAW_FRAMEBUFFER && (p[e.FRAMEBUFFER] = sn), kt === e.FRAMEBUFFER && (p[e.DRAW_FRAMEBUFFER] = sn), !0) : !1;
  }
  function Wt(kt, sn) {
    let Fi = m, tn = !1;
    if (kt) {
      Fi = y.get(sn), Fi === void 0 && (Fi = [], y.set(sn, Fi));
      const Gi = kt.textures;
      if (Fi.length !== Gi.length || Fi[0] !== e.COLOR_ATTACHMENT0) {
        for (let yi = 0, bn = Gi.length; yi < bn; yi++)
          Fi[yi] = e.COLOR_ATTACHMENT0 + yi;
        Fi.length = Gi.length, tn = !0;
      }
    } else
      Fi[0] !== e.BACK && (Fi[0] = e.BACK, tn = !0);
    tn && e.drawBuffers(Fi);
  }
  function Di(kt) {
    return A !== kt ? (e.useProgram(kt), A = kt, !0) : !1;
  }
  const ni = {
    [YU]: e.FUNC_ADD,
    [FMe]: e.FUNC_SUBTRACT,
    [HMe]: e.FUNC_REVERSE_SUBTRACT
  };
  ni[GMe] = e.MIN, ni[kMe] = e.MAX;
  const Ci = {
    [VMe]: e.ZERO,
    [zMe]: e.ONE,
    [jMe]: e.SRC_COLOR,
    [o1e]: e.SRC_ALPHA,
    [ZMe]: e.SRC_ALPHA_SATURATE,
    [$Me]: e.DST_COLOR,
    [YMe]: e.DST_ALPHA,
    [WMe]: e.ONE_MINUS_SRC_COLOR,
    [r1e]: e.ONE_MINUS_SRC_ALPHA,
    [KMe]: e.ONE_MINUS_DST_COLOR,
    [qMe]: e.ONE_MINUS_DST_ALPHA,
    [QMe]: e.CONSTANT_COLOR,
    [JMe]: e.ONE_MINUS_CONSTANT_COLOR,
    [XMe]: e.CONSTANT_ALPHA,
    [e9e]: e.ONE_MINUS_CONSTANT_ALPHA
  };
  function Se(kt, sn, Fi, tn, Gi, yi, bn, ln, No, Bs) {
    if (kt === CP) {
      C === !0 && (Xt(e.BLEND), C = !1);
      return;
    }
    if (C === !1 && (Zt(e.BLEND), C = !0), kt !== BMe) {
      if (kt !== O || Bs !== te) {
        if ((R !== YU || P !== YU) && (e.blendEquation(e.FUNC_ADD), R = YU, P = YU), Bs)
          switch (kt) {
            case Sz:
              e.blendFuncSeparate(e.ONE, e.ONE_MINUS_SRC_ALPHA, e.ONE, e.ONE_MINUS_SRC_ALPHA);
              break;
            case HEe:
              e.blendFunc(e.ONE, e.ONE);
              break;
            case GEe:
              e.blendFuncSeparate(e.ZERO, e.ONE_MINUS_SRC_COLOR, e.ZERO, e.ONE);
              break;
            case kEe:
              e.blendFuncSeparate(e.DST_COLOR, e.ONE_MINUS_SRC_ALPHA, e.ZERO, e.ONE);
              break;
            default:
              console.error("THREE.WebGLState: Invalid blending: ", kt);
              break;
          }
        else
          switch (kt) {
            case Sz:
              e.blendFuncSeparate(e.SRC_ALPHA, e.ONE_MINUS_SRC_ALPHA, e.ONE, e.ONE_MINUS_SRC_ALPHA);
              break;
            case HEe:
              e.blendFuncSeparate(e.SRC_ALPHA, e.ONE, e.ONE, e.ONE);
              break;
            case GEe:
              console.error("THREE.WebGLState: SubtractiveBlending requires material.premultipliedAlpha = true");
              break;
            case kEe:
              console.error("THREE.WebGLState: MultiplyBlending requires material.premultipliedAlpha = true");
              break;
            default:
              console.error("THREE.WebGLState: Invalid blending: ", kt);
              break;
          }
        F = null, L = null, z = null, W = null, re.set(0, 0, 0), ce = 0, O = kt, te = Bs;
      }
      return;
    }
    Gi = Gi || sn, yi = yi || Fi, bn = bn || tn, (sn !== R || Gi !== P) && (e.blendEquationSeparate(ni[sn], ni[Gi]), R = sn, P = Gi), (Fi !== F || tn !== L || yi !== z || bn !== W) && (e.blendFuncSeparate(Ci[Fi], Ci[tn], Ci[yi], Ci[bn]), F = Fi, L = tn, z = yi, W = bn), (ln.equals(re) === !1 || No !== ce) && (e.blendColor(ln.r, ln.g, ln.b, No), re.copy(ln), ce = No), O = kt, te = !1;
  }
  function si(kt, sn) {
    kt.side === $y ? Xt(e.CULL_FACE) : Zt(e.CULL_FACE);
    let Fi = kt.side === nE;
    sn && (Fi = !Fi), Mt(Fi), kt.blending === Sz && kt.transparent === !1 ? Se(CP) : Se(kt.blending, kt.blendEquation, kt.blendSrc, kt.blendDst, kt.blendEquationAlpha, kt.blendSrcAlpha, kt.blendDstAlpha, kt.blendColor, kt.blendAlpha, kt.premultipliedAlpha), r.setFunc(kt.depthFunc), r.setTest(kt.depthTest), r.setMask(kt.depthWrite), o.setMask(kt.colorWrite);
    const tn = kt.stencilWrite;
    l.setTest(tn), tn && (l.setMask(kt.stencilWriteMask), l.setFunc(kt.stencilFunc, kt.stencilRef, kt.stencilFuncMask), l.setOp(kt.stencilFail, kt.stencilZFail, kt.stencilZPass)), Tt(kt.polygonOffset, kt.polygonOffsetFactor, kt.polygonOffsetUnits), kt.alphaToCoverage === !0 ? Zt(e.SAMPLE_ALPHA_TO_COVERAGE) : Xt(e.SAMPLE_ALPHA_TO_COVERAGE);
  }
  function Mt(kt) {
    ee !== kt && (kt ? e.frontFace(e.CW) : e.frontFace(e.CCW), ee = kt);
  }
  function ft(kt) {
    kt !== PMe ? (Zt(e.CULL_FACE), kt !== Ne && (kt === FEe ? e.cullFace(e.BACK) : kt === MMe ? e.cullFace(e.FRONT) : e.cullFace(e.FRONT_AND_BACK))) : Xt(e.CULL_FACE), Ne = kt;
  }
  function rt(kt) {
    kt !== Ae && (Ve && e.lineWidth(kt), Ae = kt);
  }
  function Tt(kt, sn, Fi) {
    kt ? (Zt(e.POLYGON_OFFSET_FILL), (Oe !== sn || pe !== Fi) && (e.polygonOffset(sn, Fi), Oe = sn, pe = Fi)) : Xt(e.POLYGON_OFFSET_FILL);
  }
  function jt(kt) {
    kt ? Zt(e.SCISSOR_TEST) : Xt(e.SCISSOR_TEST);
  }
  function Jt(kt) {
    kt === void 0 && (kt = e.TEXTURE0 + je - 1), Rt !== kt && (e.activeTexture(kt), Rt = kt);
  }
  function $t(kt, sn, Fi) {
    Fi === void 0 && (Rt === null ? Fi = e.TEXTURE0 + je - 1 : Fi = Rt);
    let tn = ze[Fi];
    tn === void 0 && (tn = { type: void 0, texture: void 0 }, ze[Fi] = tn), (tn.type !== kt || tn.texture !== sn) && (Rt !== Fi && (e.activeTexture(Fi), Rt = Fi), e.bindTexture(kt, sn || Kt[kt]), tn.type = kt, tn.texture = sn);
  }
  function ht() {
    const kt = ze[Rt];
    kt !== void 0 && kt.type !== void 0 && (e.bindTexture(kt.type, null), kt.type = void 0, kt.texture = void 0);
  }
  function Me() {
    try {
      e.compressedTexImage2D(...arguments);
    } catch (kt) {
      console.error("THREE.WebGLState:", kt);
    }
  }
  function gt() {
    try {
      e.compressedTexImage3D(...arguments);
    } catch (kt) {
      console.error("THREE.WebGLState:", kt);
    }
  }
  function yt() {
    try {
      e.texSubImage2D(...arguments);
    } catch (kt) {
      console.error("THREE.WebGLState:", kt);
    }
  }
  function Ut() {
    try {
      e.texSubImage3D(...arguments);
    } catch (kt) {
      console.error("THREE.WebGLState:", kt);
    }
  }
  function Ht() {
    try {
      e.compressedTexSubImage2D(...arguments);
    } catch (kt) {
      console.error("THREE.WebGLState:", kt);
    }
  }
  function wi() {
    try {
      e.compressedTexSubImage3D(...arguments);
    } catch (kt) {
      console.error("THREE.WebGLState:", kt);
    }
  }
  function bi() {
    try {
      e.texStorage2D(...arguments);
    } catch (kt) {
      console.error("THREE.WebGLState:", kt);
    }
  }
  function Hi() {
    try {
      e.texStorage3D(...arguments);
    } catch (kt) {
      console.error("THREE.WebGLState:", kt);
    }
  }
  function Wi() {
    try {
      e.texImage2D(...arguments);
    } catch (kt) {
      console.error("THREE.WebGLState:", kt);
    }
  }
  function hi() {
    try {
      e.texImage3D(...arguments);
    } catch (kt) {
      console.error("THREE.WebGLState:", kt);
    }
  }
  function Ji(kt) {
    it.equals(kt) === !1 && (e.scissor(kt.x, kt.y, kt.z, kt.w), it.copy(kt));
  }
  function Sn(kt) {
    Dt.equals(kt) === !1 && (e.viewport(kt.x, kt.y, kt.z, kt.w), Dt.copy(kt));
  }
  function nn(kt, sn) {
    let Fi = h.get(sn);
    Fi === void 0 && (Fi = /* @__PURE__ */ new WeakMap(), h.set(sn, Fi));
    let tn = Fi.get(kt);
    tn === void 0 && (tn = e.getUniformBlockIndex(sn, kt.name), Fi.set(kt, tn));
  }
  function Yi(kt, sn) {
    const tn = h.get(sn).get(kt);
    c.get(sn) !== tn && (e.uniformBlockBinding(sn, tn, kt.__bindingPointIndex), c.set(sn, tn));
  }
  function Pi() {
    e.disable(e.BLEND), e.disable(e.CULL_FACE), e.disable(e.DEPTH_TEST), e.disable(e.POLYGON_OFFSET_FILL), e.disable(e.SCISSOR_TEST), e.disable(e.STENCIL_TEST), e.disable(e.SAMPLE_ALPHA_TO_COVERAGE), e.blendEquation(e.FUNC_ADD), e.blendFunc(e.ONE, e.ZERO), e.blendFuncSeparate(e.ONE, e.ZERO, e.ONE, e.ZERO), e.blendColor(0, 0, 0, 0), e.colorMask(!0, !0, !0, !0), e.clearColor(0, 0, 0, 0), e.depthMask(!0), e.depthFunc(e.LESS), r.setReversed(!1), e.clearDepth(1), e.stencilMask(4294967295), e.stencilFunc(e.ALWAYS, 0, 4294967295), e.stencilOp(e.KEEP, e.KEEP, e.KEEP), e.clearStencil(0), e.cullFace(e.BACK), e.frontFace(e.CCW), e.polygonOffset(0, 0), e.activeTexture(e.TEXTURE0), e.bindFramebuffer(e.FRAMEBUFFER, null), e.bindFramebuffer(e.DRAW_FRAMEBUFFER, null), e.bindFramebuffer(e.READ_FRAMEBUFFER, null), e.useProgram(null), e.lineWidth(1), e.scissor(0, 0, e.canvas.width, e.canvas.height), e.viewport(0, 0, e.canvas.width, e.canvas.height), I = {}, Rt = null, ze = {}, p = {}, y = /* @__PURE__ */ new WeakMap(), m = [], A = null, C = !1, O = null, R = null, F = null, L = null, P = null, z = null, W = null, re = new Xn(0, 0, 0), ce = 0, te = !1, ee = null, Ne = null, Ae = null, Oe = null, pe = null, it.set(0, 0, e.canvas.width, e.canvas.height), Dt.set(0, 0, e.canvas.width, e.canvas.height), o.reset(), r.reset(), l.reset();
  }
  return {
    buffers: {
      color: o,
      depth: r,
      stencil: l
    },
    enable: Zt,
    disable: Xt,
    bindFramebuffer: gi,
    drawBuffers: Wt,
    useProgram: Di,
    setBlending: Se,
    setMaterial: si,
    setFlipSided: Mt,
    setCullFace: ft,
    setLineWidth: rt,
    setPolygonOffset: Tt,
    setScissorTest: jt,
    activeTexture: Jt,
    bindTexture: $t,
    unbindTexture: ht,
    compressedTexImage2D: Me,
    compressedTexImage3D: gt,
    texImage2D: Wi,
    texImage3D: hi,
    updateUBOMapping: nn,
    uniformBlockBinding: Yi,
    texStorage2D: bi,
    texStorage3D: Hi,
    texSubImage2D: yt,
    texSubImage3D: Ut,
    compressedTexSubImage2D: Ht,
    compressedTexSubImage3D: wi,
    scissor: Ji,
    viewport: Sn,
    reset: Pi
  };
}
function lke(e, t, i, n, s, o, r) {
  const l = t.has("WEBGL_multisampled_render_to_texture") ? t.get("WEBGL_multisampled_render_to_texture") : null, c = typeof navigator > "u" ? !1 : /OculusBrowser/g.test(navigator.userAgent), h = new us(), I = /* @__PURE__ */ new WeakMap();
  let p;
  const y = /* @__PURE__ */ new WeakMap();
  let m = !1;
  try {
    m = typeof OffscreenCanvas < "u" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
  } catch {
  }
  function A(ht, Me) {
    return m ? (
      // eslint-disable-next-line compat/compat
      new OffscreenCanvas(ht, Me)
    ) : mle("canvas");
  }
  function C(ht, Me, gt) {
    let yt = 1;
    const Ut = $t(ht);
    if ((Ut.width > gt || Ut.height > gt) && (yt = gt / Math.max(Ut.width, Ut.height)), yt < 1)
      if (typeof HTMLImageElement < "u" && ht instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && ht instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && ht instanceof ImageBitmap || typeof VideoFrame < "u" && ht instanceof VideoFrame) {
        const Ht = Math.floor(yt * Ut.width), wi = Math.floor(yt * Ut.height);
        p === void 0 && (p = A(Ht, wi));
        const bi = Me ? A(Ht, wi) : p;
        return bi.width = Ht, bi.height = wi, bi.getContext("2d").drawImage(ht, 0, 0, Ht, wi), console.warn("THREE.WebGLRenderer: Texture has been resized from (" + Ut.width + "x" + Ut.height + ") to (" + Ht + "x" + wi + ")."), bi;
      } else
        return "data" in ht && console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + Ut.width + "x" + Ut.height + ")."), ht;
    return ht;
  }
  function O(ht) {
    return ht.generateMipmaps;
  }
  function R(ht) {
    e.generateMipmap(ht);
  }
  function F(ht) {
    return ht.isWebGLCubeRenderTarget ? e.TEXTURE_CUBE_MAP : ht.isWebGL3DRenderTarget ? e.TEXTURE_3D : ht.isWebGLArrayRenderTarget || ht.isCompressedArrayTexture ? e.TEXTURE_2D_ARRAY : e.TEXTURE_2D;
  }
  function L(ht, Me, gt, yt, Ut = !1) {
    if (ht !== null) {
      if (e[ht] !== void 0) return e[ht];
      console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + ht + "'");
    }
    let Ht = Me;
    if (Me === e.RED && (gt === e.FLOAT && (Ht = e.R32F), gt === e.HALF_FLOAT && (Ht = e.R16F), gt === e.UNSIGNED_BYTE && (Ht = e.R8)), Me === e.RED_INTEGER && (gt === e.UNSIGNED_BYTE && (Ht = e.R8UI), gt === e.UNSIGNED_SHORT && (Ht = e.R16UI), gt === e.UNSIGNED_INT && (Ht = e.R32UI), gt === e.BYTE && (Ht = e.R8I), gt === e.SHORT && (Ht = e.R16I), gt === e.INT && (Ht = e.R32I)), Me === e.RG && (gt === e.FLOAT && (Ht = e.RG32F), gt === e.HALF_FLOAT && (Ht = e.RG16F), gt === e.UNSIGNED_BYTE && (Ht = e.RG8)), Me === e.RG_INTEGER && (gt === e.UNSIGNED_BYTE && (Ht = e.RG8UI), gt === e.UNSIGNED_SHORT && (Ht = e.RG16UI), gt === e.UNSIGNED_INT && (Ht = e.RG32UI), gt === e.BYTE && (Ht = e.RG8I), gt === e.SHORT && (Ht = e.RG16I), gt === e.INT && (Ht = e.RG32I)), Me === e.RGB_INTEGER && (gt === e.UNSIGNED_BYTE && (Ht = e.RGB8UI), gt === e.UNSIGNED_SHORT && (Ht = e.RGB16UI), gt === e.UNSIGNED_INT && (Ht = e.RGB32UI), gt === e.BYTE && (Ht = e.RGB8I), gt === e.SHORT && (Ht = e.RGB16I), gt === e.INT && (Ht = e.RGB32I)), Me === e.RGBA_INTEGER && (gt === e.UNSIGNED_BYTE && (Ht = e.RGBA8UI), gt === e.UNSIGNED_SHORT && (Ht = e.RGBA16UI), gt === e.UNSIGNED_INT && (Ht = e.RGBA32UI), gt === e.BYTE && (Ht = e.RGBA8I), gt === e.SHORT && (Ht = e.RGBA16I), gt === e.INT && (Ht = e.RGBA32I)), Me === e.RGB && gt === e.UNSIGNED_INT_5_9_9_9_REV && (Ht = e.RGB9_E5), Me === e.RGBA) {
      const wi = Ut ? Ile : Qr.getTransfer(yt);
      gt === e.FLOAT && (Ht = e.RGBA32F), gt === e.HALF_FLOAT && (Ht = e.RGBA16F), gt === e.UNSIGNED_BYTE && (Ht = wi === Dl ? e.SRGB8_ALPHA8 : e.RGBA8), gt === e.UNSIGNED_SHORT_4_4_4_4 && (Ht = e.RGBA4), gt === e.UNSIGNED_SHORT_5_5_5_1 && (Ht = e.RGB5_A1);
    }
    return (Ht === e.R16F || Ht === e.R32F || Ht === e.RG16F || Ht === e.RG32F || Ht === e.RGBA16F || Ht === e.RGBA32F) && t.get("EXT_color_buffer_float"), Ht;
  }
  function P(ht, Me) {
    let gt;
    return ht ? Me === null || Me === JF || Me === IX ? gt = e.DEPTH24_STENCIL8 : Me === cN ? gt = e.DEPTH32F_STENCIL8 : Me === fX && (gt = e.DEPTH24_STENCIL8, console.warn("DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.")) : Me === null || Me === JF || Me === IX ? gt = e.DEPTH_COMPONENT24 : Me === cN ? gt = e.DEPTH_COMPONENT32F : Me === fX && (gt = e.DEPTH_COMPONENT16), gt;
  }
  function z(ht, Me) {
    return O(ht) === !0 || ht.isFramebufferTexture && ht.minFilter !== g4 && ht.minFilter !== dN ? Math.log2(Math.max(Me.width, Me.height)) + 1 : ht.mipmaps !== void 0 && ht.mipmaps.length > 0 ? ht.mipmaps.length : ht.isCompressedTexture && Array.isArray(ht.image) ? Me.mipmaps.length : 1;
  }
  function W(ht) {
    const Me = ht.target;
    Me.removeEventListener("dispose", W), ce(Me), Me.isVideoTexture && I.delete(Me);
  }
  function re(ht) {
    const Me = ht.target;
    Me.removeEventListener("dispose", re), ee(Me);
  }
  function ce(ht) {
    const Me = n.get(ht);
    if (Me.__webglInit === void 0) return;
    const gt = ht.source, yt = y.get(gt);
    if (yt) {
      const Ut = yt[Me.__cacheKey];
      Ut.usedTimes--, Ut.usedTimes === 0 && te(ht), Object.keys(yt).length === 0 && y.delete(gt);
    }
    n.remove(ht);
  }
  function te(ht) {
    const Me = n.get(ht);
    e.deleteTexture(Me.__webglTexture);
    const gt = ht.source, yt = y.get(gt);
    delete yt[Me.__cacheKey], r.memory.textures--;
  }
  function ee(ht) {
    const Me = n.get(ht);
    if (ht.depthTexture && (ht.depthTexture.dispose(), n.remove(ht.depthTexture)), ht.isWebGLCubeRenderTarget)
      for (let yt = 0; yt < 6; yt++) {
        if (Array.isArray(Me.__webglFramebuffer[yt]))
          for (let Ut = 0; Ut < Me.__webglFramebuffer[yt].length; Ut++) e.deleteFramebuffer(Me.__webglFramebuffer[yt][Ut]);
        else
          e.deleteFramebuffer(Me.__webglFramebuffer[yt]);
        Me.__webglDepthbuffer && e.deleteRenderbuffer(Me.__webglDepthbuffer[yt]);
      }
    else {
      if (Array.isArray(Me.__webglFramebuffer))
        for (let yt = 0; yt < Me.__webglFramebuffer.length; yt++) e.deleteFramebuffer(Me.__webglFramebuffer[yt]);
      else
        e.deleteFramebuffer(Me.__webglFramebuffer);
      if (Me.__webglDepthbuffer && e.deleteRenderbuffer(Me.__webglDepthbuffer), Me.__webglMultisampledFramebuffer && e.deleteFramebuffer(Me.__webglMultisampledFramebuffer), Me.__webglColorRenderbuffer)
        for (let yt = 0; yt < Me.__webglColorRenderbuffer.length; yt++)
          Me.__webglColorRenderbuffer[yt] && e.deleteRenderbuffer(Me.__webglColorRenderbuffer[yt]);
      Me.__webglDepthRenderbuffer && e.deleteRenderbuffer(Me.__webglDepthRenderbuffer);
    }
    const gt = ht.textures;
    for (let yt = 0, Ut = gt.length; yt < Ut; yt++) {
      const Ht = n.get(gt[yt]);
      Ht.__webglTexture && (e.deleteTexture(Ht.__webglTexture), r.memory.textures--), n.remove(gt[yt]);
    }
    n.remove(ht);
  }
  let Ne = 0;
  function Ae() {
    Ne = 0;
  }
  function Oe() {
    const ht = Ne;
    return ht >= s.maxTextures && console.warn("THREE.WebGLTextures: Trying to use " + ht + " texture units while this GPU supports only " + s.maxTextures), Ne += 1, ht;
  }
  function pe(ht) {
    const Me = [];
    return Me.push(ht.wrapS), Me.push(ht.wrapT), Me.push(ht.wrapR || 0), Me.push(ht.magFilter), Me.push(ht.minFilter), Me.push(ht.anisotropy), Me.push(ht.internalFormat), Me.push(ht.format), Me.push(ht.type), Me.push(ht.generateMipmaps), Me.push(ht.premultiplyAlpha), Me.push(ht.flipY), Me.push(ht.unpackAlignment), Me.push(ht.colorSpace), Me.join();
  }
  function je(ht, Me) {
    const gt = n.get(ht);
    if (ht.isVideoTexture && jt(ht), ht.isRenderTargetTexture === !1 && ht.version > 0 && gt.__version !== ht.version) {
      const yt = ht.image;
      if (yt === null)
        console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
      else if (yt.complete === !1)
        console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
      else {
        Kt(gt, ht, Me);
        return;
      }
    }
    i.bindTexture(e.TEXTURE_2D, gt.__webglTexture, e.TEXTURE0 + Me);
  }
  function Ve(ht, Me) {
    const gt = n.get(ht);
    if (ht.version > 0 && gt.__version !== ht.version) {
      Kt(gt, ht, Me);
      return;
    }
    i.bindTexture(e.TEXTURE_2D_ARRAY, gt.__webglTexture, e.TEXTURE0 + Me);
  }
  function $e(ht, Me) {
    const gt = n.get(ht);
    if (ht.version > 0 && gt.__version !== ht.version) {
      Kt(gt, ht, Me);
      return;
    }
    i.bindTexture(e.TEXTURE_3D, gt.__webglTexture, e.TEXTURE0 + Me);
  }
  function vt(ht, Me) {
    const gt = n.get(ht);
    if (ht.version > 0 && gt.__version !== ht.version) {
      Zt(gt, ht, Me);
      return;
    }
    i.bindTexture(e.TEXTURE_CUBE_MAP, gt.__webglTexture, e.TEXTURE0 + Me);
  }
  const Rt = {
    [m1e]: e.REPEAT,
    [oB]: e.CLAMP_TO_EDGE,
    [y1e]: e.MIRRORED_REPEAT
  }, ze = {
    [g4]: e.NEAREST,
    [d9e]: e.NEAREST_MIPMAP_NEAREST,
    [Ane]: e.NEAREST_MIPMAP_LINEAR,
    [dN]: e.LINEAR,
    [yde]: e.LINEAR_MIPMAP_NEAREST,
    [rB]: e.LINEAR_MIPMAP_LINEAR
  }, mt = {
    [I9e]: e.NEVER,
    [w9e]: e.ALWAYS,
    [p9e]: e.LESS,
    [IAe]: e.LEQUAL,
    [m9e]: e.EQUAL,
    [g9e]: e.GEQUAL,
    [y9e]: e.GREATER,
    [E9e]: e.NOTEQUAL
  };
  function Et(ht, Me) {
    if (Me.type === cN && t.has("OES_texture_float_linear") === !1 && (Me.magFilter === dN || Me.magFilter === yde || Me.magFilter === Ane || Me.magFilter === rB || Me.minFilter === dN || Me.minFilter === yde || Me.minFilter === Ane || Me.minFilter === rB) && console.warn("THREE.WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device."), e.texParameteri(ht, e.TEXTURE_WRAP_S, Rt[Me.wrapS]), e.texParameteri(ht, e.TEXTURE_WRAP_T, Rt[Me.wrapT]), (ht === e.TEXTURE_3D || ht === e.TEXTURE_2D_ARRAY) && e.texParameteri(ht, e.TEXTURE_WRAP_R, Rt[Me.wrapR]), e.texParameteri(ht, e.TEXTURE_MAG_FILTER, ze[Me.magFilter]), e.texParameteri(ht, e.TEXTURE_MIN_FILTER, ze[Me.minFilter]), Me.compareFunction && (e.texParameteri(ht, e.TEXTURE_COMPARE_MODE, e.COMPARE_REF_TO_TEXTURE), e.texParameteri(ht, e.TEXTURE_COMPARE_FUNC, mt[Me.compareFunction])), t.has("EXT_texture_filter_anisotropic") === !0) {
      if (Me.magFilter === g4 || Me.minFilter !== Ane && Me.minFilter !== rB || Me.type === cN && t.has("OES_texture_float_linear") === !1) return;
      if (Me.anisotropy > 1 || n.get(Me).__currentAnisotropy) {
        const gt = t.get("EXT_texture_filter_anisotropic");
        e.texParameterf(ht, gt.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(Me.anisotropy, s.getMaxAnisotropy())), n.get(Me).__currentAnisotropy = Me.anisotropy;
      }
    }
  }
  function it(ht, Me) {
    let gt = !1;
    ht.__webglInit === void 0 && (ht.__webglInit = !0, Me.addEventListener("dispose", W));
    const yt = Me.source;
    let Ut = y.get(yt);
    Ut === void 0 && (Ut = {}, y.set(yt, Ut));
    const Ht = pe(Me);
    if (Ht !== ht.__cacheKey) {
      Ut[Ht] === void 0 && (Ut[Ht] = {
        texture: e.createTexture(),
        usedTimes: 0
      }, r.memory.textures++, gt = !0), Ut[Ht].usedTimes++;
      const wi = Ut[ht.__cacheKey];
      wi !== void 0 && (Ut[ht.__cacheKey].usedTimes--, wi.usedTimes === 0 && te(Me)), ht.__cacheKey = Ht, ht.__webglTexture = Ut[Ht].texture;
    }
    return gt;
  }
  function Dt(ht, Me, gt) {
    return Math.floor(Math.floor(ht / gt) / Me);
  }
  function Ct(ht, Me, gt, yt) {
    const Ht = ht.updateRanges;
    if (Ht.length === 0)
      i.texSubImage2D(e.TEXTURE_2D, 0, 0, 0, Me.width, Me.height, gt, yt, Me.data);
    else {
      Ht.sort((hi, Ji) => hi.start - Ji.start);
      let wi = 0;
      for (let hi = 1; hi < Ht.length; hi++) {
        const Ji = Ht[wi], Sn = Ht[hi], nn = Ji.start + Ji.count, Yi = Dt(Sn.start, Me.width, 4), Pi = Dt(Ji.start, Me.width, 4);
        Sn.start <= nn + 1 && Yi === Pi && Dt(Sn.start + Sn.count - 1, Me.width, 4) === Yi ? Ji.count = Math.max(
          Ji.count,
          Sn.start + Sn.count - Ji.start
        ) : (++wi, Ht[wi] = Sn);
      }
      Ht.length = wi + 1;
      const bi = e.getParameter(e.UNPACK_ROW_LENGTH), Hi = e.getParameter(e.UNPACK_SKIP_PIXELS), Wi = e.getParameter(e.UNPACK_SKIP_ROWS);
      e.pixelStorei(e.UNPACK_ROW_LENGTH, Me.width);
      for (let hi = 0, Ji = Ht.length; hi < Ji; hi++) {
        const Sn = Ht[hi], nn = Math.floor(Sn.start / 4), Yi = Math.ceil(Sn.count / 4), Pi = nn % Me.width, kt = Math.floor(nn / Me.width), sn = Yi, Fi = 1;
        e.pixelStorei(e.UNPACK_SKIP_PIXELS, Pi), e.pixelStorei(e.UNPACK_SKIP_ROWS, kt), i.texSubImage2D(e.TEXTURE_2D, 0, Pi, kt, sn, Fi, gt, yt, Me.data);
      }
      ht.clearUpdateRanges(), e.pixelStorei(e.UNPACK_ROW_LENGTH, bi), e.pixelStorei(e.UNPACK_SKIP_PIXELS, Hi), e.pixelStorei(e.UNPACK_SKIP_ROWS, Wi);
    }
  }
  function Kt(ht, Me, gt) {
    let yt = e.TEXTURE_2D;
    (Me.isDataArrayTexture || Me.isCompressedArrayTexture) && (yt = e.TEXTURE_2D_ARRAY), Me.isData3DTexture && (yt = e.TEXTURE_3D);
    const Ut = it(ht, Me), Ht = Me.source;
    i.bindTexture(yt, ht.__webglTexture, e.TEXTURE0 + gt);
    const wi = n.get(Ht);
    if (Ht.version !== wi.__version || Ut === !0) {
      i.activeTexture(e.TEXTURE0 + gt);
      const bi = Qr.getPrimaries(Qr.workingColorSpace), Hi = Me.colorSpace === ux ? null : Qr.getPrimaries(Me.colorSpace), Wi = Me.colorSpace === ux || bi === Hi ? e.NONE : e.BROWSER_DEFAULT_WEBGL;
      e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL, Me.flipY), e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL, Me.premultiplyAlpha), e.pixelStorei(e.UNPACK_ALIGNMENT, Me.unpackAlignment), e.pixelStorei(e.UNPACK_COLORSPACE_CONVERSION_WEBGL, Wi);
      let hi = C(Me.image, !1, s.maxTextureSize);
      hi = Jt(Me, hi);
      const Ji = o.convert(Me.format, Me.colorSpace), Sn = o.convert(Me.type);
      let nn = L(Me.internalFormat, Ji, Sn, Me.colorSpace, Me.isVideoTexture);
      Et(yt, Me);
      let Yi;
      const Pi = Me.mipmaps, kt = Me.isVideoTexture !== !0, sn = wi.__version === void 0 || Ut === !0, Fi = Ht.dataReady, tn = z(Me, hi);
      if (Me.isDepthTexture)
        nn = P(Me.format === mX, Me.type), sn && (kt ? i.texStorage2D(e.TEXTURE_2D, 1, nn, hi.width, hi.height) : i.texImage2D(e.TEXTURE_2D, 0, nn, hi.width, hi.height, 0, Ji, Sn, null));
      else if (Me.isDataTexture)
        if (Pi.length > 0) {
          kt && sn && i.texStorage2D(e.TEXTURE_2D, tn, nn, Pi[0].width, Pi[0].height);
          for (let Gi = 0, yi = Pi.length; Gi < yi; Gi++)
            Yi = Pi[Gi], kt ? Fi && i.texSubImage2D(e.TEXTURE_2D, Gi, 0, 0, Yi.width, Yi.height, Ji, Sn, Yi.data) : i.texImage2D(e.TEXTURE_2D, Gi, nn, Yi.width, Yi.height, 0, Ji, Sn, Yi.data);
          Me.generateMipmaps = !1;
        } else
          kt ? (sn && i.texStorage2D(e.TEXTURE_2D, tn, nn, hi.width, hi.height), Fi && Ct(Me, hi, Ji, Sn)) : i.texImage2D(e.TEXTURE_2D, 0, nn, hi.width, hi.height, 0, Ji, Sn, hi.data);
      else if (Me.isCompressedTexture)
        if (Me.isCompressedArrayTexture) {
          kt && sn && i.texStorage3D(e.TEXTURE_2D_ARRAY, tn, nn, Pi[0].width, Pi[0].height, hi.depth);
          for (let Gi = 0, yi = Pi.length; Gi < yi; Gi++)
            if (Yi = Pi[Gi], Me.format !== y5)
              if (Ji !== null)
                if (kt) {
                  if (Fi)
                    if (Me.layerUpdates.size > 0) {
                      const bn = vge(Yi.width, Yi.height, Me.format, Me.type);
                      for (const ln of Me.layerUpdates) {
                        const No = Yi.data.subarray(
                          ln * bn / Yi.data.BYTES_PER_ELEMENT,
                          (ln + 1) * bn / Yi.data.BYTES_PER_ELEMENT
                        );
                        i.compressedTexSubImage3D(e.TEXTURE_2D_ARRAY, Gi, 0, 0, ln, Yi.width, Yi.height, 1, Ji, No);
                      }
                      Me.clearLayerUpdates();
                    } else
                      i.compressedTexSubImage3D(e.TEXTURE_2D_ARRAY, Gi, 0, 0, 0, Yi.width, Yi.height, hi.depth, Ji, Yi.data);
                } else
                  i.compressedTexImage3D(e.TEXTURE_2D_ARRAY, Gi, nn, Yi.width, Yi.height, hi.depth, 0, Yi.data, 0, 0);
              else
                console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
            else
              kt ? Fi && i.texSubImage3D(e.TEXTURE_2D_ARRAY, Gi, 0, 0, 0, Yi.width, Yi.height, hi.depth, Ji, Sn, Yi.data) : i.texImage3D(e.TEXTURE_2D_ARRAY, Gi, nn, Yi.width, Yi.height, hi.depth, 0, Ji, Sn, Yi.data);
        } else {
          kt && sn && i.texStorage2D(e.TEXTURE_2D, tn, nn, Pi[0].width, Pi[0].height);
          for (let Gi = 0, yi = Pi.length; Gi < yi; Gi++)
            Yi = Pi[Gi], Me.format !== y5 ? Ji !== null ? kt ? Fi && i.compressedTexSubImage2D(e.TEXTURE_2D, Gi, 0, 0, Yi.width, Yi.height, Ji, Yi.data) : i.compressedTexImage2D(e.TEXTURE_2D, Gi, nn, Yi.width, Yi.height, 0, Yi.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : kt ? Fi && i.texSubImage2D(e.TEXTURE_2D, Gi, 0, 0, Yi.width, Yi.height, Ji, Sn, Yi.data) : i.texImage2D(e.TEXTURE_2D, Gi, nn, Yi.width, Yi.height, 0, Ji, Sn, Yi.data);
        }
      else if (Me.isDataArrayTexture)
        if (kt) {
          if (sn && i.texStorage3D(e.TEXTURE_2D_ARRAY, tn, nn, hi.width, hi.height, hi.depth), Fi)
            if (Me.layerUpdates.size > 0) {
              const Gi = vge(hi.width, hi.height, Me.format, Me.type);
              for (const yi of Me.layerUpdates) {
                const bn = hi.data.subarray(
                  yi * Gi / hi.data.BYTES_PER_ELEMENT,
                  (yi + 1) * Gi / hi.data.BYTES_PER_ELEMENT
                );
                i.texSubImage3D(e.TEXTURE_2D_ARRAY, 0, 0, 0, yi, hi.width, hi.height, 1, Ji, Sn, bn);
              }
              Me.clearLayerUpdates();
            } else
              i.texSubImage3D(e.TEXTURE_2D_ARRAY, 0, 0, 0, 0, hi.width, hi.height, hi.depth, Ji, Sn, hi.data);
        } else
          i.texImage3D(e.TEXTURE_2D_ARRAY, 0, nn, hi.width, hi.height, hi.depth, 0, Ji, Sn, hi.data);
      else if (Me.isData3DTexture)
        kt ? (sn && i.texStorage3D(e.TEXTURE_3D, tn, nn, hi.width, hi.height, hi.depth), Fi && i.texSubImage3D(e.TEXTURE_3D, 0, 0, 0, 0, hi.width, hi.height, hi.depth, Ji, Sn, hi.data)) : i.texImage3D(e.TEXTURE_3D, 0, nn, hi.width, hi.height, hi.depth, 0, Ji, Sn, hi.data);
      else if (Me.isFramebufferTexture) {
        if (sn)
          if (kt)
            i.texStorage2D(e.TEXTURE_2D, tn, nn, hi.width, hi.height);
          else {
            let Gi = hi.width, yi = hi.height;
            for (let bn = 0; bn < tn; bn++)
              i.texImage2D(e.TEXTURE_2D, bn, nn, Gi, yi, 0, Ji, Sn, null), Gi >>= 1, yi >>= 1;
          }
      } else if (Pi.length > 0) {
        if (kt && sn) {
          const Gi = $t(Pi[0]);
          i.texStorage2D(e.TEXTURE_2D, tn, nn, Gi.width, Gi.height);
        }
        for (let Gi = 0, yi = Pi.length; Gi < yi; Gi++)
          Yi = Pi[Gi], kt ? Fi && i.texSubImage2D(e.TEXTURE_2D, Gi, 0, 0, Ji, Sn, Yi) : i.texImage2D(e.TEXTURE_2D, Gi, nn, Ji, Sn, Yi);
        Me.generateMipmaps = !1;
      } else if (kt) {
        if (sn) {
          const Gi = $t(hi);
          i.texStorage2D(e.TEXTURE_2D, tn, nn, Gi.width, Gi.height);
        }
        Fi && i.texSubImage2D(e.TEXTURE_2D, 0, 0, 0, Ji, Sn, hi);
      } else
        i.texImage2D(e.TEXTURE_2D, 0, nn, Ji, Sn, hi);
      O(Me) && R(yt), wi.__version = Ht.version, Me.onUpdate && Me.onUpdate(Me);
    }
    ht.__version = Me.version;
  }
  function Zt(ht, Me, gt) {
    if (Me.image.length !== 6) return;
    const yt = it(ht, Me), Ut = Me.source;
    i.bindTexture(e.TEXTURE_CUBE_MAP, ht.__webglTexture, e.TEXTURE0 + gt);
    const Ht = n.get(Ut);
    if (Ut.version !== Ht.__version || yt === !0) {
      i.activeTexture(e.TEXTURE0 + gt);
      const wi = Qr.getPrimaries(Qr.workingColorSpace), bi = Me.colorSpace === ux ? null : Qr.getPrimaries(Me.colorSpace), Hi = Me.colorSpace === ux || wi === bi ? e.NONE : e.BROWSER_DEFAULT_WEBGL;
      e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL, Me.flipY), e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL, Me.premultiplyAlpha), e.pixelStorei(e.UNPACK_ALIGNMENT, Me.unpackAlignment), e.pixelStorei(e.UNPACK_COLORSPACE_CONVERSION_WEBGL, Hi);
      const Wi = Me.isCompressedTexture || Me.image[0].isCompressedTexture, hi = Me.image[0] && Me.image[0].isDataTexture, Ji = [];
      for (let yi = 0; yi < 6; yi++)
        !Wi && !hi ? Ji[yi] = C(Me.image[yi], !0, s.maxCubemapSize) : Ji[yi] = hi ? Me.image[yi].image : Me.image[yi], Ji[yi] = Jt(Me, Ji[yi]);
      const Sn = Ji[0], nn = o.convert(Me.format, Me.colorSpace), Yi = o.convert(Me.type), Pi = L(Me.internalFormat, nn, Yi, Me.colorSpace), kt = Me.isVideoTexture !== !0, sn = Ht.__version === void 0 || yt === !0, Fi = Ut.dataReady;
      let tn = z(Me, Sn);
      Et(e.TEXTURE_CUBE_MAP, Me);
      let Gi;
      if (Wi) {
        kt && sn && i.texStorage2D(e.TEXTURE_CUBE_MAP, tn, Pi, Sn.width, Sn.height);
        for (let yi = 0; yi < 6; yi++) {
          Gi = Ji[yi].mipmaps;
          for (let bn = 0; bn < Gi.length; bn++) {
            const ln = Gi[bn];
            Me.format !== y5 ? nn !== null ? kt ? Fi && i.compressedTexSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + yi, bn, 0, 0, ln.width, ln.height, nn, ln.data) : i.compressedTexImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + yi, bn, Pi, ln.width, ln.height, 0, ln.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : kt ? Fi && i.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + yi, bn, 0, 0, ln.width, ln.height, nn, Yi, ln.data) : i.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + yi, bn, Pi, ln.width, ln.height, 0, nn, Yi, ln.data);
          }
        }
      } else {
        if (Gi = Me.mipmaps, kt && sn) {
          Gi.length > 0 && tn++;
          const yi = $t(Ji[0]);
          i.texStorage2D(e.TEXTURE_CUBE_MAP, tn, Pi, yi.width, yi.height);
        }
        for (let yi = 0; yi < 6; yi++)
          if (hi) {
            kt ? Fi && i.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + yi, 0, 0, 0, Ji[yi].width, Ji[yi].height, nn, Yi, Ji[yi].data) : i.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + yi, 0, Pi, Ji[yi].width, Ji[yi].height, 0, nn, Yi, Ji[yi].data);
            for (let bn = 0; bn < Gi.length; bn++) {
              const No = Gi[bn].image[yi].image;
              kt ? Fi && i.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + yi, bn + 1, 0, 0, No.width, No.height, nn, Yi, No.data) : i.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + yi, bn + 1, Pi, No.width, No.height, 0, nn, Yi, No.data);
            }
          } else {
            kt ? Fi && i.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + yi, 0, 0, 0, nn, Yi, Ji[yi]) : i.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + yi, 0, Pi, nn, Yi, Ji[yi]);
            for (let bn = 0; bn < Gi.length; bn++) {
              const ln = Gi[bn];
              kt ? Fi && i.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + yi, bn + 1, 0, 0, nn, Yi, ln.image[yi]) : i.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + yi, bn + 1, Pi, nn, Yi, ln.image[yi]);
            }
          }
      }
      O(Me) && R(e.TEXTURE_CUBE_MAP), Ht.__version = Ut.version, Me.onUpdate && Me.onUpdate(Me);
    }
    ht.__version = Me.version;
  }
  function Xt(ht, Me, gt, yt, Ut, Ht) {
    const wi = o.convert(gt.format, gt.colorSpace), bi = o.convert(gt.type), Hi = L(gt.internalFormat, wi, bi, gt.colorSpace), Wi = n.get(Me), hi = n.get(gt);
    if (hi.__renderTarget = Me, !Wi.__hasExternalTextures) {
      const Ji = Math.max(1, Me.width >> Ht), Sn = Math.max(1, Me.height >> Ht);
      Ut === e.TEXTURE_3D || Ut === e.TEXTURE_2D_ARRAY ? i.texImage3D(Ut, Ht, Hi, Ji, Sn, Me.depth, 0, wi, bi, null) : i.texImage2D(Ut, Ht, Hi, Ji, Sn, 0, wi, bi, null);
    }
    i.bindFramebuffer(e.FRAMEBUFFER, ht), Tt(Me) ? l.framebufferTexture2DMultisampleEXT(e.FRAMEBUFFER, yt, Ut, hi.__webglTexture, 0, rt(Me)) : (Ut === e.TEXTURE_2D || Ut >= e.TEXTURE_CUBE_MAP_POSITIVE_X && Ut <= e.TEXTURE_CUBE_MAP_NEGATIVE_Z) && e.framebufferTexture2D(e.FRAMEBUFFER, yt, Ut, hi.__webglTexture, Ht), i.bindFramebuffer(e.FRAMEBUFFER, null);
  }
  function gi(ht, Me, gt) {
    if (e.bindRenderbuffer(e.RENDERBUFFER, ht), Me.depthBuffer) {
      const yt = Me.depthTexture, Ut = yt && yt.isDepthTexture ? yt.type : null, Ht = P(Me.stencilBuffer, Ut), wi = Me.stencilBuffer ? e.DEPTH_STENCIL_ATTACHMENT : e.DEPTH_ATTACHMENT, bi = rt(Me);
      Tt(Me) ? l.renderbufferStorageMultisampleEXT(e.RENDERBUFFER, bi, Ht, Me.width, Me.height) : gt ? e.renderbufferStorageMultisample(e.RENDERBUFFER, bi, Ht, Me.width, Me.height) : e.renderbufferStorage(e.RENDERBUFFER, Ht, Me.width, Me.height), e.framebufferRenderbuffer(e.FRAMEBUFFER, wi, e.RENDERBUFFER, ht);
    } else {
      const yt = Me.textures;
      for (let Ut = 0; Ut < yt.length; Ut++) {
        const Ht = yt[Ut], wi = o.convert(Ht.format, Ht.colorSpace), bi = o.convert(Ht.type), Hi = L(Ht.internalFormat, wi, bi, Ht.colorSpace), Wi = rt(Me);
        gt && Tt(Me) === !1 ? e.renderbufferStorageMultisample(e.RENDERBUFFER, Wi, Hi, Me.width, Me.height) : Tt(Me) ? l.renderbufferStorageMultisampleEXT(e.RENDERBUFFER, Wi, Hi, Me.width, Me.height) : e.renderbufferStorage(e.RENDERBUFFER, Hi, Me.width, Me.height);
      }
    }
    e.bindRenderbuffer(e.RENDERBUFFER, null);
  }
  function Wt(ht, Me) {
    if (Me && Me.isWebGLCubeRenderTarget) throw new Error("Depth Texture with cube render targets is not supported");
    if (i.bindFramebuffer(e.FRAMEBUFFER, ht), !(Me.depthTexture && Me.depthTexture.isDepthTexture))
      throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
    const yt = n.get(Me.depthTexture);
    yt.__renderTarget = Me, (!yt.__webglTexture || Me.depthTexture.image.width !== Me.width || Me.depthTexture.image.height !== Me.height) && (Me.depthTexture.image.width = Me.width, Me.depthTexture.image.height = Me.height, Me.depthTexture.needsUpdate = !0), je(Me.depthTexture, 0);
    const Ut = yt.__webglTexture, Ht = rt(Me);
    if (Me.depthTexture.format === pX)
      Tt(Me) ? l.framebufferTexture2DMultisampleEXT(e.FRAMEBUFFER, e.DEPTH_ATTACHMENT, e.TEXTURE_2D, Ut, 0, Ht) : e.framebufferTexture2D(e.FRAMEBUFFER, e.DEPTH_ATTACHMENT, e.TEXTURE_2D, Ut, 0);
    else if (Me.depthTexture.format === mX)
      Tt(Me) ? l.framebufferTexture2DMultisampleEXT(e.FRAMEBUFFER, e.DEPTH_STENCIL_ATTACHMENT, e.TEXTURE_2D, Ut, 0, Ht) : e.framebufferTexture2D(e.FRAMEBUFFER, e.DEPTH_STENCIL_ATTACHMENT, e.TEXTURE_2D, Ut, 0);
    else
      throw new Error("Unknown depthTexture format");
  }
  function Di(ht) {
    const Me = n.get(ht), gt = ht.isWebGLCubeRenderTarget === !0;
    if (Me.__boundDepthTexture !== ht.depthTexture) {
      const yt = ht.depthTexture;
      if (Me.__depthDisposeCallback && Me.__depthDisposeCallback(), yt) {
        const Ut = () => {
          delete Me.__boundDepthTexture, delete Me.__depthDisposeCallback, yt.removeEventListener("dispose", Ut);
        };
        yt.addEventListener("dispose", Ut), Me.__depthDisposeCallback = Ut;
      }
      Me.__boundDepthTexture = yt;
    }
    if (ht.depthTexture && !Me.__autoAllocateDepthBuffer) {
      if (gt) throw new Error("target.depthTexture not supported in Cube render targets");
      const yt = ht.texture.mipmaps;
      yt && yt.length > 0 ? Wt(Me.__webglFramebuffer[0], ht) : Wt(Me.__webglFramebuffer, ht);
    } else if (gt) {
      Me.__webglDepthbuffer = [];
      for (let yt = 0; yt < 6; yt++)
        if (i.bindFramebuffer(e.FRAMEBUFFER, Me.__webglFramebuffer[yt]), Me.__webglDepthbuffer[yt] === void 0)
          Me.__webglDepthbuffer[yt] = e.createRenderbuffer(), gi(Me.__webglDepthbuffer[yt], ht, !1);
        else {
          const Ut = ht.stencilBuffer ? e.DEPTH_STENCIL_ATTACHMENT : e.DEPTH_ATTACHMENT, Ht = Me.__webglDepthbuffer[yt];
          e.bindRenderbuffer(e.RENDERBUFFER, Ht), e.framebufferRenderbuffer(e.FRAMEBUFFER, Ut, e.RENDERBUFFER, Ht);
        }
    } else {
      const yt = ht.texture.mipmaps;
      if (yt && yt.length > 0 ? i.bindFramebuffer(e.FRAMEBUFFER, Me.__webglFramebuffer[0]) : i.bindFramebuffer(e.FRAMEBUFFER, Me.__webglFramebuffer), Me.__webglDepthbuffer === void 0)
        Me.__webglDepthbuffer = e.createRenderbuffer(), gi(Me.__webglDepthbuffer, ht, !1);
      else {
        const Ut = ht.stencilBuffer ? e.DEPTH_STENCIL_ATTACHMENT : e.DEPTH_ATTACHMENT, Ht = Me.__webglDepthbuffer;
        e.bindRenderbuffer(e.RENDERBUFFER, Ht), e.framebufferRenderbuffer(e.FRAMEBUFFER, Ut, e.RENDERBUFFER, Ht);
      }
    }
    i.bindFramebuffer(e.FRAMEBUFFER, null);
  }
  function ni(ht, Me, gt) {
    const yt = n.get(ht);
    Me !== void 0 && Xt(yt.__webglFramebuffer, ht, ht.texture, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, 0), gt !== void 0 && Di(ht);
  }
  function Ci(ht) {
    const Me = ht.texture, gt = n.get(ht), yt = n.get(Me);
    ht.addEventListener("dispose", re);
    const Ut = ht.textures, Ht = ht.isWebGLCubeRenderTarget === !0, wi = Ut.length > 1;
    if (wi || (yt.__webglTexture === void 0 && (yt.__webglTexture = e.createTexture()), yt.__version = Me.version, r.memory.textures++), Ht) {
      gt.__webglFramebuffer = [];
      for (let bi = 0; bi < 6; bi++)
        if (Me.mipmaps && Me.mipmaps.length > 0) {
          gt.__webglFramebuffer[bi] = [];
          for (let Hi = 0; Hi < Me.mipmaps.length; Hi++)
            gt.__webglFramebuffer[bi][Hi] = e.createFramebuffer();
        } else
          gt.__webglFramebuffer[bi] = e.createFramebuffer();
    } else {
      if (Me.mipmaps && Me.mipmaps.length > 0) {
        gt.__webglFramebuffer = [];
        for (let bi = 0; bi < Me.mipmaps.length; bi++)
          gt.__webglFramebuffer[bi] = e.createFramebuffer();
      } else
        gt.__webglFramebuffer = e.createFramebuffer();
      if (wi)
        for (let bi = 0, Hi = Ut.length; bi < Hi; bi++) {
          const Wi = n.get(Ut[bi]);
          Wi.__webglTexture === void 0 && (Wi.__webglTexture = e.createTexture(), r.memory.textures++);
        }
      if (ht.samples > 0 && Tt(ht) === !1) {
        gt.__webglMultisampledFramebuffer = e.createFramebuffer(), gt.__webglColorRenderbuffer = [], i.bindFramebuffer(e.FRAMEBUFFER, gt.__webglMultisampledFramebuffer);
        for (let bi = 0; bi < Ut.length; bi++) {
          const Hi = Ut[bi];
          gt.__webglColorRenderbuffer[bi] = e.createRenderbuffer(), e.bindRenderbuffer(e.RENDERBUFFER, gt.__webglColorRenderbuffer[bi]);
          const Wi = o.convert(Hi.format, Hi.colorSpace), hi = o.convert(Hi.type), Ji = L(Hi.internalFormat, Wi, hi, Hi.colorSpace, ht.isXRRenderTarget === !0), Sn = rt(ht);
          e.renderbufferStorageMultisample(e.RENDERBUFFER, Sn, Ji, ht.width, ht.height), e.framebufferRenderbuffer(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0 + bi, e.RENDERBUFFER, gt.__webglColorRenderbuffer[bi]);
        }
        e.bindRenderbuffer(e.RENDERBUFFER, null), ht.depthBuffer && (gt.__webglDepthRenderbuffer = e.createRenderbuffer(), gi(gt.__webglDepthRenderbuffer, ht, !0)), i.bindFramebuffer(e.FRAMEBUFFER, null);
      }
    }
    if (Ht) {
      i.bindTexture(e.TEXTURE_CUBE_MAP, yt.__webglTexture), Et(e.TEXTURE_CUBE_MAP, Me);
      for (let bi = 0; bi < 6; bi++)
        if (Me.mipmaps && Me.mipmaps.length > 0)
          for (let Hi = 0; Hi < Me.mipmaps.length; Hi++)
            Xt(gt.__webglFramebuffer[bi][Hi], ht, Me, e.COLOR_ATTACHMENT0, e.TEXTURE_CUBE_MAP_POSITIVE_X + bi, Hi);
        else
          Xt(gt.__webglFramebuffer[bi], ht, Me, e.COLOR_ATTACHMENT0, e.TEXTURE_CUBE_MAP_POSITIVE_X + bi, 0);
      O(Me) && R(e.TEXTURE_CUBE_MAP), i.unbindTexture();
    } else if (wi) {
      for (let bi = 0, Hi = Ut.length; bi < Hi; bi++) {
        const Wi = Ut[bi], hi = n.get(Wi);
        i.bindTexture(e.TEXTURE_2D, hi.__webglTexture), Et(e.TEXTURE_2D, Wi), Xt(gt.__webglFramebuffer, ht, Wi, e.COLOR_ATTACHMENT0 + bi, e.TEXTURE_2D, 0), O(Wi) && R(e.TEXTURE_2D);
      }
      i.unbindTexture();
    } else {
      let bi = e.TEXTURE_2D;
      if ((ht.isWebGL3DRenderTarget || ht.isWebGLArrayRenderTarget) && (bi = ht.isWebGL3DRenderTarget ? e.TEXTURE_3D : e.TEXTURE_2D_ARRAY), i.bindTexture(bi, yt.__webglTexture), Et(bi, Me), Me.mipmaps && Me.mipmaps.length > 0)
        for (let Hi = 0; Hi < Me.mipmaps.length; Hi++)
          Xt(gt.__webglFramebuffer[Hi], ht, Me, e.COLOR_ATTACHMENT0, bi, Hi);
      else
        Xt(gt.__webglFramebuffer, ht, Me, e.COLOR_ATTACHMENT0, bi, 0);
      O(Me) && R(bi), i.unbindTexture();
    }
    ht.depthBuffer && Di(ht);
  }
  function Se(ht) {
    const Me = ht.textures;
    for (let gt = 0, yt = Me.length; gt < yt; gt++) {
      const Ut = Me[gt];
      if (O(Ut)) {
        const Ht = F(ht), wi = n.get(Ut).__webglTexture;
        i.bindTexture(Ht, wi), R(Ht), i.unbindTexture();
      }
    }
  }
  const si = [], Mt = [];
  function ft(ht) {
    if (ht.samples > 0) {
      if (Tt(ht) === !1) {
        const Me = ht.textures, gt = ht.width, yt = ht.height;
        let Ut = e.COLOR_BUFFER_BIT;
        const Ht = ht.stencilBuffer ? e.DEPTH_STENCIL_ATTACHMENT : e.DEPTH_ATTACHMENT, wi = n.get(ht), bi = Me.length > 1;
        if (bi)
          for (let Wi = 0; Wi < Me.length; Wi++)
            i.bindFramebuffer(e.FRAMEBUFFER, wi.__webglMultisampledFramebuffer), e.framebufferRenderbuffer(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0 + Wi, e.RENDERBUFFER, null), i.bindFramebuffer(e.FRAMEBUFFER, wi.__webglFramebuffer), e.framebufferTexture2D(e.DRAW_FRAMEBUFFER, e.COLOR_ATTACHMENT0 + Wi, e.TEXTURE_2D, null, 0);
        i.bindFramebuffer(e.READ_FRAMEBUFFER, wi.__webglMultisampledFramebuffer);
        const Hi = ht.texture.mipmaps;
        Hi && Hi.length > 0 ? i.bindFramebuffer(e.DRAW_FRAMEBUFFER, wi.__webglFramebuffer[0]) : i.bindFramebuffer(e.DRAW_FRAMEBUFFER, wi.__webglFramebuffer);
        for (let Wi = 0; Wi < Me.length; Wi++) {
          if (ht.resolveDepthBuffer && (ht.depthBuffer && (Ut |= e.DEPTH_BUFFER_BIT), ht.stencilBuffer && ht.resolveStencilBuffer && (Ut |= e.STENCIL_BUFFER_BIT)), bi) {
            e.framebufferRenderbuffer(e.READ_FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.RENDERBUFFER, wi.__webglColorRenderbuffer[Wi]);
            const hi = n.get(Me[Wi]).__webglTexture;
            e.framebufferTexture2D(e.DRAW_FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, hi, 0);
          }
          e.blitFramebuffer(0, 0, gt, yt, 0, 0, gt, yt, Ut, e.NEAREST), c === !0 && (si.length = 0, Mt.length = 0, si.push(e.COLOR_ATTACHMENT0 + Wi), ht.depthBuffer && ht.resolveDepthBuffer === !1 && (si.push(Ht), Mt.push(Ht), e.invalidateFramebuffer(e.DRAW_FRAMEBUFFER, Mt)), e.invalidateFramebuffer(e.READ_FRAMEBUFFER, si));
        }
        if (i.bindFramebuffer(e.READ_FRAMEBUFFER, null), i.bindFramebuffer(e.DRAW_FRAMEBUFFER, null), bi)
          for (let Wi = 0; Wi < Me.length; Wi++) {
            i.bindFramebuffer(e.FRAMEBUFFER, wi.__webglMultisampledFramebuffer), e.framebufferRenderbuffer(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0 + Wi, e.RENDERBUFFER, wi.__webglColorRenderbuffer[Wi]);
            const hi = n.get(Me[Wi]).__webglTexture;
            i.bindFramebuffer(e.FRAMEBUFFER, wi.__webglFramebuffer), e.framebufferTexture2D(e.DRAW_FRAMEBUFFER, e.COLOR_ATTACHMENT0 + Wi, e.TEXTURE_2D, hi, 0);
          }
        i.bindFramebuffer(e.DRAW_FRAMEBUFFER, wi.__webglMultisampledFramebuffer);
      } else if (ht.depthBuffer && ht.resolveDepthBuffer === !1 && c) {
        const Me = ht.stencilBuffer ? e.DEPTH_STENCIL_ATTACHMENT : e.DEPTH_ATTACHMENT;
        e.invalidateFramebuffer(e.DRAW_FRAMEBUFFER, [Me]);
      }
    }
  }
  function rt(ht) {
    return Math.min(s.maxSamples, ht.samples);
  }
  function Tt(ht) {
    const Me = n.get(ht);
    return ht.samples > 0 && t.has("WEBGL_multisampled_render_to_texture") === !0 && Me.__useRenderToTexture !== !1;
  }
  function jt(ht) {
    const Me = r.render.frame;
    I.get(ht) !== Me && (I.set(ht, Me), ht.update());
  }
  function Jt(ht, Me) {
    const gt = ht.colorSpace, yt = ht.format, Ut = ht.type;
    return ht.isCompressedTexture === !0 || ht.isVideoTexture === !0 || gt !== LW && gt !== ux && (Qr.getTransfer(gt) === Dl ? (yt !== y5 || Ut !== PA) && console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.") : console.error("THREE.WebGLTextures: Unsupported texture color space:", gt)), Me;
  }
  function $t(ht) {
    return typeof HTMLImageElement < "u" && ht instanceof HTMLImageElement ? (h.width = ht.naturalWidth || ht.width, h.height = ht.naturalHeight || ht.height) : typeof VideoFrame < "u" && ht instanceof VideoFrame ? (h.width = ht.displayWidth, h.height = ht.displayHeight) : (h.width = ht.width, h.height = ht.height), h;
  }
  this.allocateTextureUnit = Oe, this.resetTextureUnits = Ae, this.setTexture2D = je, this.setTexture2DArray = Ve, this.setTexture3D = $e, this.setTextureCube = vt, this.rebindTextures = ni, this.setupRenderTarget = Ci, this.updateRenderTargetMipmap = Se, this.updateMultisampleRenderTarget = ft, this.setupDepthRenderbuffer = Di, this.setupFrameBufferTexture = Xt, this.useMultisampledRTT = Tt;
}
function ake(e, t) {
  function i(n, s = ux) {
    let o;
    const r = Qr.getTransfer(s);
    if (n === PA) return e.UNSIGNED_BYTE;
    if (n === Vpe) return e.UNSIGNED_SHORT_4_4_4_4;
    if (n === zpe) return e.UNSIGNED_SHORT_5_5_5_1;
    if (n === aAe) return e.UNSIGNED_INT_5_9_9_9_REV;
    if (n === rAe) return e.BYTE;
    if (n === lAe) return e.SHORT;
    if (n === fX) return e.UNSIGNED_SHORT;
    if (n === kpe) return e.INT;
    if (n === JF) return e.UNSIGNED_INT;
    if (n === cN) return e.FLOAT;
    if (n === yie) return e.HALF_FLOAT;
    if (n === uAe) return e.ALPHA;
    if (n === dAe) return e.RGB;
    if (n === y5) return e.RGBA;
    if (n === pX) return e.DEPTH_COMPONENT;
    if (n === mX) return e.DEPTH_STENCIL;
    if (n === jpe) return e.RED;
    if (n === Wpe) return e.RED_INTEGER;
    if (n === cAe) return e.RG;
    if (n === Ype) return e.RG_INTEGER;
    if (n === qpe) return e.RGBA_INTEGER;
    if (n === Uoe || n === Boe || n === Foe || n === Hoe)
      if (r === Dl)
        if (o = t.get("WEBGL_compressed_texture_s3tc_srgb"), o !== null) {
          if (n === Uoe) return o.COMPRESSED_SRGB_S3TC_DXT1_EXT;
          if (n === Boe) return o.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
          if (n === Foe) return o.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
          if (n === Hoe) return o.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
        } else
          return null;
      else if (o = t.get("WEBGL_compressed_texture_s3tc"), o !== null) {
        if (n === Uoe) return o.COMPRESSED_RGB_S3TC_DXT1_EXT;
        if (n === Boe) return o.COMPRESSED_RGBA_S3TC_DXT1_EXT;
        if (n === Foe) return o.COMPRESSED_RGBA_S3TC_DXT3_EXT;
        if (n === Hoe) return o.COMPRESSED_RGBA_S3TC_DXT5_EXT;
      } else
        return null;
    if (n === E1e || n === g1e || n === w1e || n === T1e)
      if (o = t.get("WEBGL_compressed_texture_pvrtc"), o !== null) {
        if (n === E1e) return o.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
        if (n === g1e) return o.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
        if (n === w1e) return o.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
        if (n === T1e) return o.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
      } else
        return null;
    if (n === R1e || n === v1e || n === A1e)
      if (o = t.get("WEBGL_compressed_texture_etc"), o !== null) {
        if (n === R1e || n === v1e) return r === Dl ? o.COMPRESSED_SRGB8_ETC2 : o.COMPRESSED_RGB8_ETC2;
        if (n === A1e) return r === Dl ? o.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : o.COMPRESSED_RGBA8_ETC2_EAC;
      } else
        return null;
    if (n === S1e || n === b1e || n === N1e || n === D1e || n === C1e || n === O1e || n === L1e || n === _1e || n === x1e || n === P1e || n === M1e || n === U1e || n === B1e || n === F1e)
      if (o = t.get("WEBGL_compressed_texture_astc"), o !== null) {
        if (n === S1e) return r === Dl ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : o.COMPRESSED_RGBA_ASTC_4x4_KHR;
        if (n === b1e) return r === Dl ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : o.COMPRESSED_RGBA_ASTC_5x4_KHR;
        if (n === N1e) return r === Dl ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : o.COMPRESSED_RGBA_ASTC_5x5_KHR;
        if (n === D1e) return r === Dl ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : o.COMPRESSED_RGBA_ASTC_6x5_KHR;
        if (n === C1e) return r === Dl ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : o.COMPRESSED_RGBA_ASTC_6x6_KHR;
        if (n === O1e) return r === Dl ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : o.COMPRESSED_RGBA_ASTC_8x5_KHR;
        if (n === L1e) return r === Dl ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : o.COMPRESSED_RGBA_ASTC_8x6_KHR;
        if (n === _1e) return r === Dl ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : o.COMPRESSED_RGBA_ASTC_8x8_KHR;
        if (n === x1e) return r === Dl ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : o.COMPRESSED_RGBA_ASTC_10x5_KHR;
        if (n === P1e) return r === Dl ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : o.COMPRESSED_RGBA_ASTC_10x6_KHR;
        if (n === M1e) return r === Dl ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : o.COMPRESSED_RGBA_ASTC_10x8_KHR;
        if (n === U1e) return r === Dl ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : o.COMPRESSED_RGBA_ASTC_10x10_KHR;
        if (n === B1e) return r === Dl ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : o.COMPRESSED_RGBA_ASTC_12x10_KHR;
        if (n === F1e) return r === Dl ? o.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : o.COMPRESSED_RGBA_ASTC_12x12_KHR;
      } else
        return null;
    if (n === Goe || n === H1e || n === G1e)
      if (o = t.get("EXT_texture_compression_bptc"), o !== null) {
        if (n === Goe) return r === Dl ? o.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : o.COMPRESSED_RGBA_BPTC_UNORM_EXT;
        if (n === H1e) return o.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
        if (n === G1e) return o.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
      } else
        return null;
    if (n === hAe || n === k1e || n === V1e || n === z1e)
      if (o = t.get("EXT_texture_compression_rgtc"), o !== null) {
        if (n === Goe) return o.COMPRESSED_RED_RGTC1_EXT;
        if (n === k1e) return o.COMPRESSED_SIGNED_RED_RGTC1_EXT;
        if (n === V1e) return o.COMPRESSED_RED_GREEN_RGTC2_EXT;
        if (n === z1e) return o.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
      } else
        return null;
    return n === IX ? e.UNSIGNED_INT_24_8 : e[n] !== void 0 ? e[n] : null;
  }
  return { convert: i };
}
const uke = `
void main() {

	gl_Position = vec4( position, 1.0 );

}`, dke = `
uniform sampler2DArray depthColor;
uniform float depthWidth;
uniform float depthHeight;

void main() {

	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );

	if ( coord.x >= 1.0 ) {

		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;

	} else {

		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;

	}

}`;
class cke {
  /**
   * Constructs a new depth sensing module.
   */
  constructor() {
    this.texture = null, this.mesh = null, this.depthNear = 0, this.depthFar = 0;
  }
  /**
   * Inits the depth sensing module
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {XRWebGLDepthInformation} depthData - The XR depth data.
   * @param {XRRenderState} renderState - The XR render state.
   */
  init(t, i, n) {
    if (this.texture === null) {
      const s = new sE(), o = t.properties.get(s);
      o.__webglTexture = i.texture, (i.depthNear !== n.depthNear || i.depthFar !== n.depthFar) && (this.depthNear = i.depthNear, this.depthFar = i.depthFar), this.texture = s;
    }
  }
  /**
   * Returns a plane mesh that visualizes the depth texture.
   *
   * @param {ArrayCamera} cameraXR - The XR camera.
   * @return {?Mesh} The plane mesh.
   */
  getMesh(t) {
    if (this.texture !== null && this.mesh === null) {
      const i = t.cameras[0].viewport, n = new BA({
        vertexShader: uke,
        fragmentShader: dke,
        uniforms: {
          depthColor: { value: this.texture },
          depthWidth: { value: i.z },
          depthHeight: { value: i.w }
        }
      });
      this.mesh = new En(new xH(20, 20), n);
    }
    return this.mesh;
  }
  /**
   * Resets the module
   */
  reset() {
    this.texture = null, this.mesh = null;
  }
  /**
   * Returns a texture representing the depth of the user's environment.
   *
   * @return {?Texture} The depth texture.
   */
  getDepthTexture() {
    return this.texture;
  }
}
class hke extends LH {
  /**
   * Constructs a new WebGL renderer.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGL2RenderingContext} gl - The rendering context.
   */
  constructor(t, i) {
    super();
    const n = this;
    let s = null, o = 1, r = null, l = "local-floor", c = 1, h = null, I = null, p = null, y = null, m = null, A = null;
    const C = new cke(), O = i.getContextAttributes();
    let R = null, F = null;
    const L = [], P = [], z = new us();
    let W = null;
    const re = new Tg();
    re.viewport = new Ol();
    const ce = new Tg();
    ce.viewport = new Ol();
    const te = [re, ce], ee = new CUe();
    let Ne = null, Ae = null;
    this.cameraAutoUpdate = !0, this.enabled = !1, this.isPresenting = !1, this.getController = function(Dt) {
      let Ct = L[Dt];
      return Ct === void 0 && (Ct = new Fde(), L[Dt] = Ct), Ct.getTargetRaySpace();
    }, this.getControllerGrip = function(Dt) {
      let Ct = L[Dt];
      return Ct === void 0 && (Ct = new Fde(), L[Dt] = Ct), Ct.getGripSpace();
    }, this.getHand = function(Dt) {
      let Ct = L[Dt];
      return Ct === void 0 && (Ct = new Fde(), L[Dt] = Ct), Ct.getHandSpace();
    };
    function Oe(Dt) {
      const Ct = P.indexOf(Dt.inputSource);
      if (Ct === -1)
        return;
      const Kt = L[Ct];
      Kt !== void 0 && (Kt.update(Dt.inputSource, Dt.frame, h || r), Kt.dispatchEvent({ type: Dt.type, data: Dt.inputSource }));
    }
    function pe() {
      s.removeEventListener("select", Oe), s.removeEventListener("selectstart", Oe), s.removeEventListener("selectend", Oe), s.removeEventListener("squeeze", Oe), s.removeEventListener("squeezestart", Oe), s.removeEventListener("squeezeend", Oe), s.removeEventListener("end", pe), s.removeEventListener("inputsourceschange", je);
      for (let Dt = 0; Dt < L.length; Dt++) {
        const Ct = P[Dt];
        Ct !== null && (P[Dt] = null, L[Dt].disconnect(Ct));
      }
      Ne = null, Ae = null, C.reset(), t.setRenderTarget(R), m = null, y = null, p = null, s = null, F = null, it.stop(), n.isPresenting = !1, t.setPixelRatio(W), t.setSize(z.width, z.height, !1), n.dispatchEvent({ type: "sessionend" });
    }
    this.setFramebufferScaleFactor = function(Dt) {
      o = Dt, n.isPresenting === !0 && console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
    }, this.setReferenceSpaceType = function(Dt) {
      l = Dt, n.isPresenting === !0 && console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
    }, this.getReferenceSpace = function() {
      return h || r;
    }, this.setReferenceSpace = function(Dt) {
      h = Dt;
    }, this.getBaseLayer = function() {
      return y !== null ? y : m;
    }, this.getBinding = function() {
      return p;
    }, this.getFrame = function() {
      return A;
    }, this.getSession = function() {
      return s;
    }, this.setSession = async function(Dt) {
      if (s = Dt, s !== null) {
        if (R = t.getRenderTarget(), s.addEventListener("select", Oe), s.addEventListener("selectstart", Oe), s.addEventListener("selectend", Oe), s.addEventListener("squeeze", Oe), s.addEventListener("squeezestart", Oe), s.addEventListener("squeezeend", Oe), s.addEventListener("end", pe), s.addEventListener("inputsourceschange", je), O.xrCompatible !== !0 && await i.makeXRCompatible(), W = t.getPixelRatio(), t.getSize(z), typeof XRWebGLBinding < "u" && "createProjectionLayer" in XRWebGLBinding.prototype) {
          let Kt = null, Zt = null, Xt = null;
          O.depth && (Xt = O.stencil ? i.DEPTH24_STENCIL8 : i.DEPTH_COMPONENT24, Kt = O.stencil ? mX : pX, Zt = O.stencil ? IX : JF);
          const gi = {
            colorFormat: i.RGBA8,
            depthFormat: Xt,
            scaleFactor: o
          };
          p = new XRWebGLBinding(s, i), y = p.createProjectionLayer(gi), s.updateRenderState({ layers: [y] }), t.setPixelRatio(1), t.setSize(y.textureWidth, y.textureHeight, !1), F = new qP(
            y.textureWidth,
            y.textureHeight,
            {
              format: y5,
              type: PA,
              depthTexture: new RAe(y.textureWidth, y.textureHeight, Zt, void 0, void 0, void 0, void 0, void 0, void 0, Kt),
              stencilBuffer: O.stencil,
              colorSpace: t.outputColorSpace,
              samples: O.antialias ? 4 : 0,
              resolveDepthBuffer: y.ignoreDepthValues === !1,
              resolveStencilBuffer: y.ignoreDepthValues === !1
            }
          );
        } else {
          const Kt = {
            antialias: O.antialias,
            alpha: !0,
            depth: O.depth,
            stencil: O.stencil,
            framebufferScaleFactor: o
          };
          m = new XRWebGLLayer(s, i, Kt), s.updateRenderState({ baseLayer: m }), t.setPixelRatio(1), t.setSize(m.framebufferWidth, m.framebufferHeight, !1), F = new qP(
            m.framebufferWidth,
            m.framebufferHeight,
            {
              format: y5,
              type: PA,
              colorSpace: t.outputColorSpace,
              stencilBuffer: O.stencil,
              resolveDepthBuffer: m.ignoreDepthValues === !1,
              resolveStencilBuffer: m.ignoreDepthValues === !1
            }
          );
        }
        F.isXRRenderTarget = !0, this.setFoveation(c), h = null, r = await s.requestReferenceSpace(l), it.setContext(s), it.start(), n.isPresenting = !0, n.dispatchEvent({ type: "sessionstart" });
      }
    }, this.getEnvironmentBlendMode = function() {
      if (s !== null)
        return s.environmentBlendMode;
    }, this.getDepthTexture = function() {
      return C.getDepthTexture();
    };
    function je(Dt) {
      for (let Ct = 0; Ct < Dt.removed.length; Ct++) {
        const Kt = Dt.removed[Ct], Zt = P.indexOf(Kt);
        Zt >= 0 && (P[Zt] = null, L[Zt].disconnect(Kt));
      }
      for (let Ct = 0; Ct < Dt.added.length; Ct++) {
        const Kt = Dt.added[Ct];
        let Zt = P.indexOf(Kt);
        if (Zt === -1) {
          for (let gi = 0; gi < L.length; gi++)
            if (gi >= P.length) {
              P.push(Kt), Zt = gi;
              break;
            } else if (P[gi] === null) {
              P[gi] = Kt, Zt = gi;
              break;
            }
          if (Zt === -1) break;
        }
        const Xt = L[Zt];
        Xt && Xt.connect(Kt);
      }
    }
    const Ve = new Ge(), $e = new Ge();
    function vt(Dt, Ct, Kt) {
      Ve.setFromMatrixPosition(Ct.matrixWorld), $e.setFromMatrixPosition(Kt.matrixWorld);
      const Zt = Ve.distanceTo($e), Xt = Ct.projectionMatrix.elements, gi = Kt.projectionMatrix.elements, Wt = Xt[14] / (Xt[10] - 1), Di = Xt[14] / (Xt[10] + 1), ni = (Xt[9] + 1) / Xt[5], Ci = (Xt[9] - 1) / Xt[5], Se = (Xt[8] - 1) / Xt[0], si = (gi[8] + 1) / gi[0], Mt = Wt * Se, ft = Wt * si, rt = Zt / (-Se + si), Tt = rt * -Se;
      if (Ct.matrixWorld.decompose(Dt.position, Dt.quaternion, Dt.scale), Dt.translateX(Tt), Dt.translateZ(rt), Dt.matrixWorld.compose(Dt.position, Dt.quaternion, Dt.scale), Dt.matrixWorldInverse.copy(Dt.matrixWorld).invert(), Xt[10] === -1)
        Dt.projectionMatrix.copy(Ct.projectionMatrix), Dt.projectionMatrixInverse.copy(Ct.projectionMatrixInverse);
      else {
        const jt = Wt + rt, Jt = Di + rt, $t = Mt - Tt, ht = ft + (Zt - Tt), Me = ni * Di / Jt * jt, gt = Ci * Di / Jt * jt;
        Dt.projectionMatrix.makePerspective($t, ht, Me, gt, jt, Jt), Dt.projectionMatrixInverse.copy(Dt.projectionMatrix).invert();
      }
    }
    function Rt(Dt, Ct) {
      Ct === null ? Dt.matrixWorld.copy(Dt.matrix) : Dt.matrixWorld.multiplyMatrices(Ct.matrixWorld, Dt.matrix), Dt.matrixWorldInverse.copy(Dt.matrixWorld).invert();
    }
    this.updateCamera = function(Dt) {
      if (s === null) return;
      let Ct = Dt.near, Kt = Dt.far;
      C.texture !== null && (C.depthNear > 0 && (Ct = C.depthNear), C.depthFar > 0 && (Kt = C.depthFar)), ee.near = ce.near = re.near = Ct, ee.far = ce.far = re.far = Kt, (Ne !== ee.near || Ae !== ee.far) && (s.updateRenderState({
        depthNear: ee.near,
        depthFar: ee.far
      }), Ne = ee.near, Ae = ee.far), re.layers.mask = Dt.layers.mask | 2, ce.layers.mask = Dt.layers.mask | 4, ee.layers.mask = re.layers.mask | ce.layers.mask;
      const Zt = Dt.parent, Xt = ee.cameras;
      Rt(ee, Zt);
      for (let gi = 0; gi < Xt.length; gi++)
        Rt(Xt[gi], Zt);
      Xt.length === 2 ? vt(ee, re, ce) : ee.projectionMatrix.copy(re.projectionMatrix), ze(Dt, ee, Zt);
    };
    function ze(Dt, Ct, Kt) {
      Kt === null ? Dt.matrix.copy(Ct.matrixWorld) : (Dt.matrix.copy(Kt.matrixWorld), Dt.matrix.invert(), Dt.matrix.multiply(Ct.matrixWorld)), Dt.matrix.decompose(Dt.position, Dt.quaternion, Dt.scale), Dt.updateMatrixWorld(!0), Dt.projectionMatrix.copy(Ct.projectionMatrix), Dt.projectionMatrixInverse.copy(Ct.projectionMatrixInverse), Dt.isPerspectiveCamera && (Dt.fov = yX * 2 * Math.atan(1 / Dt.projectionMatrix.elements[5]), Dt.zoom = 1);
    }
    this.getCamera = function() {
      return ee;
    }, this.getFoveation = function() {
      if (!(y === null && m === null))
        return c;
    }, this.setFoveation = function(Dt) {
      c = Dt, y !== null && (y.fixedFoveation = Dt), m !== null && m.fixedFoveation !== void 0 && (m.fixedFoveation = Dt);
    }, this.hasDepthSensing = function() {
      return C.texture !== null;
    }, this.getDepthSensingMesh = function() {
      return C.getMesh(ee);
    };
    let mt = null;
    function Et(Dt, Ct) {
      if (I = Ct.getViewerPose(h || r), A = Ct, I !== null) {
        const Kt = I.views;
        m !== null && (t.setRenderTargetFramebuffer(F, m.framebuffer), t.setRenderTarget(F));
        let Zt = !1;
        Kt.length !== ee.cameras.length && (ee.cameras.length = 0, Zt = !0);
        for (let Wt = 0; Wt < Kt.length; Wt++) {
          const Di = Kt[Wt];
          let ni = null;
          if (m !== null)
            ni = m.getViewport(Di);
          else {
            const Se = p.getViewSubImage(y, Di);
            ni = Se.viewport, Wt === 0 && (t.setRenderTargetTextures(
              F,
              Se.colorTexture,
              Se.depthStencilTexture
            ), t.setRenderTarget(F));
          }
          let Ci = te[Wt];
          Ci === void 0 && (Ci = new Tg(), Ci.layers.enable(Wt), Ci.viewport = new Ol(), te[Wt] = Ci), Ci.matrix.fromArray(Di.transform.matrix), Ci.matrix.decompose(Ci.position, Ci.quaternion, Ci.scale), Ci.projectionMatrix.fromArray(Di.projectionMatrix), Ci.projectionMatrixInverse.copy(Ci.projectionMatrix).invert(), Ci.viewport.set(ni.x, ni.y, ni.width, ni.height), Wt === 0 && (ee.matrix.copy(Ci.matrix), ee.matrix.decompose(ee.position, ee.quaternion, ee.scale)), Zt === !0 && ee.cameras.push(Ci);
        }
        const Xt = s.enabledFeatures;
        if (Xt && Xt.includes("depth-sensing") && s.depthUsage == "gpu-optimized" && p) {
          const Wt = p.getDepthInformation(Kt[0]);
          Wt && Wt.isValid && Wt.texture && C.init(t, Wt, s.renderState);
        }
      }
      for (let Kt = 0; Kt < L.length; Kt++) {
        const Zt = P[Kt], Xt = L[Kt];
        Zt !== null && Xt !== void 0 && Xt.update(Zt, Ct, h || r);
      }
      mt && mt(Dt, Ct), Ct.detectedPlanes && n.dispatchEvent({ type: "planesdetected", data: Ct }), A = null;
    }
    const it = new bAe();
    it.setAnimationLoop(Et), this.setAnimationLoop = function(Dt) {
      mt = Dt;
    }, this.dispose = function() {
    };
  }
}
const tU = /* @__PURE__ */ new UA(), fke = /* @__PURE__ */ new Ln();
function Ike(e, t) {
  function i(O, R) {
    O.matrixAutoUpdate === !0 && O.updateMatrix(), R.value.copy(O.matrix);
  }
  function n(O, R) {
    R.color.getRGB(O.fogColor.value, wAe(e)), R.isFog ? (O.fogNear.value = R.near, O.fogFar.value = R.far) : R.isFogExp2 && (O.fogDensity.value = R.density);
  }
  function s(O, R, F, L, P) {
    R.isMeshBasicMaterial || R.isMeshLambertMaterial ? o(O, R) : R.isMeshToonMaterial ? (o(O, R), p(O, R)) : R.isMeshPhongMaterial ? (o(O, R), I(O, R)) : R.isMeshStandardMaterial ? (o(O, R), y(O, R), R.isMeshPhysicalMaterial && m(O, R, P)) : R.isMeshMatcapMaterial ? (o(O, R), A(O, R)) : R.isMeshDepthMaterial ? o(O, R) : R.isMeshDistanceMaterial ? (o(O, R), C(O, R)) : R.isMeshNormalMaterial ? o(O, R) : R.isLineBasicMaterial ? (r(O, R), R.isLineDashedMaterial && l(O, R)) : R.isPointsMaterial ? c(O, R, F, L) : R.isSpriteMaterial ? h(O, R) : R.isShadowMaterial ? (O.color.value.copy(R.color), O.opacity.value = R.opacity) : R.isShaderMaterial && (R.uniformsNeedUpdate = !1);
  }
  function o(O, R) {
    O.opacity.value = R.opacity, R.color && O.diffuse.value.copy(R.color), R.emissive && O.emissive.value.copy(R.emissive).multiplyScalar(R.emissiveIntensity), R.map && (O.map.value = R.map, i(R.map, O.mapTransform)), R.alphaMap && (O.alphaMap.value = R.alphaMap, i(R.alphaMap, O.alphaMapTransform)), R.bumpMap && (O.bumpMap.value = R.bumpMap, i(R.bumpMap, O.bumpMapTransform), O.bumpScale.value = R.bumpScale, R.side === nE && (O.bumpScale.value *= -1)), R.normalMap && (O.normalMap.value = R.normalMap, i(R.normalMap, O.normalMapTransform), O.normalScale.value.copy(R.normalScale), R.side === nE && O.normalScale.value.negate()), R.displacementMap && (O.displacementMap.value = R.displacementMap, i(R.displacementMap, O.displacementMapTransform), O.displacementScale.value = R.displacementScale, O.displacementBias.value = R.displacementBias), R.emissiveMap && (O.emissiveMap.value = R.emissiveMap, i(R.emissiveMap, O.emissiveMapTransform)), R.specularMap && (O.specularMap.value = R.specularMap, i(R.specularMap, O.specularMapTransform)), R.alphaTest > 0 && (O.alphaTest.value = R.alphaTest);
    const F = t.get(R), L = F.envMap, P = F.envMapRotation;
    L && (O.envMap.value = L, tU.copy(P), tU.x *= -1, tU.y *= -1, tU.z *= -1, L.isCubeTexture && L.isRenderTargetTexture === !1 && (tU.y *= -1, tU.z *= -1), O.envMapRotation.value.setFromMatrix4(fke.makeRotationFromEuler(tU)), O.flipEnvMap.value = L.isCubeTexture && L.isRenderTargetTexture === !1 ? -1 : 1, O.reflectivity.value = R.reflectivity, O.ior.value = R.ior, O.refractionRatio.value = R.refractionRatio), R.lightMap && (O.lightMap.value = R.lightMap, O.lightMapIntensity.value = R.lightMapIntensity, i(R.lightMap, O.lightMapTransform)), R.aoMap && (O.aoMap.value = R.aoMap, O.aoMapIntensity.value = R.aoMapIntensity, i(R.aoMap, O.aoMapTransform));
  }
  function r(O, R) {
    O.diffuse.value.copy(R.color), O.opacity.value = R.opacity, R.map && (O.map.value = R.map, i(R.map, O.mapTransform));
  }
  function l(O, R) {
    O.dashSize.value = R.dashSize, O.totalSize.value = R.dashSize + R.gapSize, O.scale.value = R.scale;
  }
  function c(O, R, F, L) {
    O.diffuse.value.copy(R.color), O.opacity.value = R.opacity, O.size.value = R.size * F, O.scale.value = L * 0.5, R.map && (O.map.value = R.map, i(R.map, O.uvTransform)), R.alphaMap && (O.alphaMap.value = R.alphaMap, i(R.alphaMap, O.alphaMapTransform)), R.alphaTest > 0 && (O.alphaTest.value = R.alphaTest);
  }
  function h(O, R) {
    O.diffuse.value.copy(R.color), O.opacity.value = R.opacity, O.rotation.value = R.rotation, R.map && (O.map.value = R.map, i(R.map, O.mapTransform)), R.alphaMap && (O.alphaMap.value = R.alphaMap, i(R.alphaMap, O.alphaMapTransform)), R.alphaTest > 0 && (O.alphaTest.value = R.alphaTest);
  }
  function I(O, R) {
    O.specular.value.copy(R.specular), O.shininess.value = Math.max(R.shininess, 1e-4);
  }
  function p(O, R) {
    R.gradientMap && (O.gradientMap.value = R.gradientMap);
  }
  function y(O, R) {
    O.metalness.value = R.metalness, R.metalnessMap && (O.metalnessMap.value = R.metalnessMap, i(R.metalnessMap, O.metalnessMapTransform)), O.roughness.value = R.roughness, R.roughnessMap && (O.roughnessMap.value = R.roughnessMap, i(R.roughnessMap, O.roughnessMapTransform)), R.envMap && (O.envMapIntensity.value = R.envMapIntensity);
  }
  function m(O, R, F) {
    O.ior.value = R.ior, R.sheen > 0 && (O.sheenColor.value.copy(R.sheenColor).multiplyScalar(R.sheen), O.sheenRoughness.value = R.sheenRoughness, R.sheenColorMap && (O.sheenColorMap.value = R.sheenColorMap, i(R.sheenColorMap, O.sheenColorMapTransform)), R.sheenRoughnessMap && (O.sheenRoughnessMap.value = R.sheenRoughnessMap, i(R.sheenRoughnessMap, O.sheenRoughnessMapTransform))), R.clearcoat > 0 && (O.clearcoat.value = R.clearcoat, O.clearcoatRoughness.value = R.clearcoatRoughness, R.clearcoatMap && (O.clearcoatMap.value = R.clearcoatMap, i(R.clearcoatMap, O.clearcoatMapTransform)), R.clearcoatRoughnessMap && (O.clearcoatRoughnessMap.value = R.clearcoatRoughnessMap, i(R.clearcoatRoughnessMap, O.clearcoatRoughnessMapTransform)), R.clearcoatNormalMap && (O.clearcoatNormalMap.value = R.clearcoatNormalMap, i(R.clearcoatNormalMap, O.clearcoatNormalMapTransform), O.clearcoatNormalScale.value.copy(R.clearcoatNormalScale), R.side === nE && O.clearcoatNormalScale.value.negate())), R.dispersion > 0 && (O.dispersion.value = R.dispersion), R.iridescence > 0 && (O.iridescence.value = R.iridescence, O.iridescenceIOR.value = R.iridescenceIOR, O.iridescenceThicknessMinimum.value = R.iridescenceThicknessRange[0], O.iridescenceThicknessMaximum.value = R.iridescenceThicknessRange[1], R.iridescenceMap && (O.iridescenceMap.value = R.iridescenceMap, i(R.iridescenceMap, O.iridescenceMapTransform)), R.iridescenceThicknessMap && (O.iridescenceThicknessMap.value = R.iridescenceThicknessMap, i(R.iridescenceThicknessMap, O.iridescenceThicknessMapTransform))), R.transmission > 0 && (O.transmission.value = R.transmission, O.transmissionSamplerMap.value = F.texture, O.transmissionSamplerSize.value.set(F.width, F.height), R.transmissionMap && (O.transmissionMap.value = R.transmissionMap, i(R.transmissionMap, O.transmissionMapTransform)), O.thickness.value = R.thickness, R.thicknessMap && (O.thicknessMap.value = R.thicknessMap, i(R.thicknessMap, O.thicknessMapTransform)), O.attenuationDistance.value = R.attenuationDistance, O.attenuationColor.value.copy(R.attenuationColor)), R.anisotropy > 0 && (O.anisotropyVector.value.set(R.anisotropy * Math.cos(R.anisotropyRotation), R.anisotropy * Math.sin(R.anisotropyRotation)), R.anisotropyMap && (O.anisotropyMap.value = R.anisotropyMap, i(R.anisotropyMap, O.anisotropyMapTransform))), O.specularIntensity.value = R.specularIntensity, O.specularColor.value.copy(R.specularColor), R.specularColorMap && (O.specularColorMap.value = R.specularColorMap, i(R.specularColorMap, O.specularColorMapTransform)), R.specularIntensityMap && (O.specularIntensityMap.value = R.specularIntensityMap, i(R.specularIntensityMap, O.specularIntensityMapTransform));
  }
  function A(O, R) {
    R.matcap && (O.matcap.value = R.matcap);
  }
  function C(O, R) {
    const F = t.get(R).light;
    O.referencePosition.value.setFromMatrixPosition(F.matrixWorld), O.nearDistance.value = F.shadow.camera.near, O.farDistance.value = F.shadow.camera.far;
  }
  return {
    refreshFogUniforms: n,
    refreshMaterialUniforms: s
  };
}
function pke(e, t, i, n) {
  let s = {}, o = {}, r = [];
  const l = e.getParameter(e.MAX_UNIFORM_BUFFER_BINDINGS);
  function c(F, L) {
    const P = L.program;
    n.uniformBlockBinding(F, P);
  }
  function h(F, L) {
    let P = s[F.id];
    P === void 0 && (A(F), P = I(F), s[F.id] = P, F.addEventListener("dispose", O));
    const z = L.program;
    n.updateUBOMapping(F, z);
    const W = t.render.frame;
    o[F.id] !== W && (y(F), o[F.id] = W);
  }
  function I(F) {
    const L = p();
    F.__bindingPointIndex = L;
    const P = e.createBuffer(), z = F.__size, W = F.usage;
    return e.bindBuffer(e.UNIFORM_BUFFER, P), e.bufferData(e.UNIFORM_BUFFER, z, W), e.bindBuffer(e.UNIFORM_BUFFER, null), e.bindBufferBase(e.UNIFORM_BUFFER, L, P), P;
  }
  function p() {
    for (let F = 0; F < l; F++)
      if (r.indexOf(F) === -1)
        return r.push(F), F;
    return console.error("THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached."), 0;
  }
  function y(F) {
    const L = s[F.id], P = F.uniforms, z = F.__cache;
    e.bindBuffer(e.UNIFORM_BUFFER, L);
    for (let W = 0, re = P.length; W < re; W++) {
      const ce = Array.isArray(P[W]) ? P[W] : [P[W]];
      for (let te = 0, ee = ce.length; te < ee; te++) {
        const Ne = ce[te];
        if (m(Ne, W, te, z) === !0) {
          const Ae = Ne.__offset, Oe = Array.isArray(Ne.value) ? Ne.value : [Ne.value];
          let pe = 0;
          for (let je = 0; je < Oe.length; je++) {
            const Ve = Oe[je], $e = C(Ve);
            typeof Ve == "number" || typeof Ve == "boolean" ? (Ne.__data[0] = Ve, e.bufferSubData(e.UNIFORM_BUFFER, Ae + pe, Ne.__data)) : Ve.isMatrix3 ? (Ne.__data[0] = Ve.elements[0], Ne.__data[1] = Ve.elements[1], Ne.__data[2] = Ve.elements[2], Ne.__data[3] = 0, Ne.__data[4] = Ve.elements[3], Ne.__data[5] = Ve.elements[4], Ne.__data[6] = Ve.elements[5], Ne.__data[7] = 0, Ne.__data[8] = Ve.elements[6], Ne.__data[9] = Ve.elements[7], Ne.__data[10] = Ve.elements[8], Ne.__data[11] = 0) : (Ve.toArray(Ne.__data, pe), pe += $e.storage / Float32Array.BYTES_PER_ELEMENT);
          }
          e.bufferSubData(e.UNIFORM_BUFFER, Ae, Ne.__data);
        }
      }
    }
    e.bindBuffer(e.UNIFORM_BUFFER, null);
  }
  function m(F, L, P, z) {
    const W = F.value, re = L + "_" + P;
    if (z[re] === void 0)
      return typeof W == "number" || typeof W == "boolean" ? z[re] = W : z[re] = W.clone(), !0;
    {
      const ce = z[re];
      if (typeof W == "number" || typeof W == "boolean") {
        if (ce !== W)
          return z[re] = W, !0;
      } else if (ce.equals(W) === !1)
        return ce.copy(W), !0;
    }
    return !1;
  }
  function A(F) {
    const L = F.uniforms;
    let P = 0;
    const z = 16;
    for (let re = 0, ce = L.length; re < ce; re++) {
      const te = Array.isArray(L[re]) ? L[re] : [L[re]];
      for (let ee = 0, Ne = te.length; ee < Ne; ee++) {
        const Ae = te[ee], Oe = Array.isArray(Ae.value) ? Ae.value : [Ae.value];
        for (let pe = 0, je = Oe.length; pe < je; pe++) {
          const Ve = Oe[pe], $e = C(Ve), vt = P % z, Rt = vt % $e.boundary, ze = vt + Rt;
          P += Rt, ze !== 0 && z - ze < $e.storage && (P += z - ze), Ae.__data = new Float32Array($e.storage / Float32Array.BYTES_PER_ELEMENT), Ae.__offset = P, P += $e.storage;
        }
      }
    }
    const W = P % z;
    return W > 0 && (P += z - W), F.__size = P, F.__cache = {}, this;
  }
  function C(F) {
    const L = {
      boundary: 0,
      // bytes
      storage: 0
      // bytes
    };
    return typeof F == "number" || typeof F == "boolean" ? (L.boundary = 4, L.storage = 4) : F.isVector2 ? (L.boundary = 8, L.storage = 8) : F.isVector3 || F.isColor ? (L.boundary = 16, L.storage = 12) : F.isVector4 ? (L.boundary = 16, L.storage = 16) : F.isMatrix3 ? (L.boundary = 48, L.storage = 48) : F.isMatrix4 ? (L.boundary = 64, L.storage = 64) : F.isTexture ? console.warn("THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.") : console.warn("THREE.WebGLRenderer: Unsupported uniform value type.", F), L;
  }
  function O(F) {
    const L = F.target;
    L.removeEventListener("dispose", O);
    const P = r.indexOf(L.__bindingPointIndex);
    r.splice(P, 1), e.deleteBuffer(s[L.id]), delete s[L.id], delete o[L.id];
  }
  function R() {
    for (const F in s)
      e.deleteBuffer(s[F]);
    r = [], s = {}, o = {};
  }
  return {
    bind: c,
    update: h,
    dispose: R
  };
}
class $ge {
  /**
   * Constructs a new WebGL renderer.
   *
   * @param {WebGLRenderer~Options} [parameters] - The configuration parameter.
   */
  constructor(t = {}) {
    const {
      canvas: i = B9e(),
      context: n = null,
      depth: s = !0,
      stencil: o = !1,
      alpha: r = !1,
      antialias: l = !1,
      premultipliedAlpha: c = !0,
      preserveDrawingBuffer: h = !1,
      powerPreference: I = "default",
      failIfMajorPerformanceCaveat: p = !1,
      reverseDepthBuffer: y = !1
    } = t;
    this.isWebGLRenderer = !0;
    let m;
    if (n !== null) {
      if (typeof WebGLRenderingContext < "u" && n instanceof WebGLRenderingContext)
        throw new Error("THREE.WebGLRenderer: WebGL 1 is not supported since r163.");
      m = n.getContextAttributes().alpha;
    } else
      m = r;
    const A = new Uint32Array(4), C = new Int32Array(4);
    let O = null, R = null;
    const F = [], L = [];
    this.domElement = i, this.debug = {
      /**
       * Enables error checking and reporting when shader programs are being compiled.
       * @type {boolean}
       */
      checkShaderErrors: !0,
      /**
       * Callback for custom error reporting.
       * @type {?Function}
       */
      onShaderError: null
    }, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this.toneMapping = OP, this.toneMappingExposure = 1, this.transmissionResolutionScale = 1;
    const P = this;
    let z = !1;
    this._outputColorSpace = Hy;
    let W = 0, re = 0, ce = null, te = -1, ee = null;
    const Ne = new Ol(), Ae = new Ol();
    let Oe = null;
    const pe = new Xn(0);
    let je = 0, Ve = i.width, $e = i.height, vt = 1, Rt = null, ze = null;
    const mt = new Ol(0, 0, Ve, $e), Et = new Ol(0, 0, Ve, $e);
    let it = !1;
    const Dt = new cL();
    let Ct = !1, Kt = !1;
    const Zt = new Ln(), Xt = new Ln(), gi = new Ge(), Wt = new Ol(), Di = { background: null, fog: null, environment: null, overrideMaterial: null, isScene: !0 };
    let ni = !1;
    function Ci() {
      return ce === null ? vt : 1;
    }
    let Se = n;
    function si(It, Qt) {
      return i.getContext(It, Qt);
    }
    try {
      const It = {
        alpha: !0,
        depth: s,
        stencil: o,
        antialias: l,
        premultipliedAlpha: c,
        preserveDrawingBuffer: h,
        powerPreference: I,
        failIfMajorPerformanceCaveat: p
      };
      if ("setAttribute" in i && i.setAttribute("data-engine", `three.js r${Hpe}`), i.addEventListener("webglcontextlost", tn, !1), i.addEventListener("webglcontextrestored", Gi, !1), i.addEventListener("webglcontextcreationerror", yi, !1), Se === null) {
        const Qt = "webgl2";
        if (Se = si(Qt, It), Se === null)
          throw si(Qt) ? new Error("Error creating WebGL context with your selected attributes.") : new Error("Error creating WebGL context.");
      }
    } catch (It) {
      throw console.error("THREE.WebGLRenderer: " + It.message), It;
    }
    let Mt, ft, rt, Tt, jt, Jt, $t, ht, Me, gt, yt, Ut, Ht, wi, bi, Hi, Wi, hi, Ji, Sn, nn, Yi, Pi, kt;
    function sn() {
      Mt = new bHe(Se), Mt.init(), Yi = new ake(Se, Mt), ft = new gHe(Se, Mt, t, Yi), rt = new rke(Se, Mt), ft.reverseDepthBuffer && y && rt.buffers.depth.setReversed(!0), Tt = new CHe(Se), jt = new qGe(), Jt = new lke(Se, Mt, rt, jt, ft, Yi, Tt), $t = new THe(P), ht = new SHe(P), Me = new MUe(Se), Pi = new yHe(Se, Me), gt = new NHe(Se, Me, Tt, Pi), yt = new LHe(Se, gt, Me, Tt), Ji = new OHe(Se, ft, Jt), Hi = new wHe(jt), Ut = new YGe(P, $t, ht, Mt, ft, Pi, Hi), Ht = new Ike(P, jt), wi = new KGe(), bi = new tke(Mt), hi = new mHe(P, $t, ht, rt, yt, m, c), Wi = new ske(P, yt, ft), kt = new pke(Se, Tt, ft, rt), Sn = new EHe(Se, Mt, Tt), nn = new DHe(Se, Mt, Tt), Tt.programs = Ut.programs, P.capabilities = ft, P.extensions = Mt, P.properties = jt, P.renderLists = wi, P.shadowMap = Wi, P.state = rt, P.info = Tt;
    }
    sn();
    const Fi = new hke(P, Se);
    this.xr = Fi, this.getContext = function() {
      return Se;
    }, this.getContextAttributes = function() {
      return Se.getContextAttributes();
    }, this.forceContextLoss = function() {
      const It = Mt.get("WEBGL_lose_context");
      It && It.loseContext();
    }, this.forceContextRestore = function() {
      const It = Mt.get("WEBGL_lose_context");
      It && It.restoreContext();
    }, this.getPixelRatio = function() {
      return vt;
    }, this.setPixelRatio = function(It) {
      It !== void 0 && (vt = It, this.setSize(Ve, $e, !1));
    }, this.getSize = function(It) {
      return It.set(Ve, $e);
    }, this.setSize = function(It, Qt, ci = !0) {
      if (Fi.isPresenting) {
        console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.");
        return;
      }
      Ve = It, $e = Qt, i.width = Math.floor(It * vt), i.height = Math.floor(Qt * vt), ci === !0 && (i.style.width = It + "px", i.style.height = Qt + "px"), this.setViewport(0, 0, It, Qt);
    }, this.getDrawingBufferSize = function(It) {
      return It.set(Ve * vt, $e * vt).floor();
    }, this.setDrawingBufferSize = function(It, Qt, ci) {
      Ve = It, $e = Qt, vt = ci, i.width = Math.floor(It * ci), i.height = Math.floor(Qt * ci), this.setViewport(0, 0, It, Qt);
    }, this.getCurrentViewport = function(It) {
      return It.copy(Ne);
    }, this.getViewport = function(It) {
      return It.copy(mt);
    }, this.setViewport = function(It, Qt, ci, ai) {
      It.isVector4 ? mt.set(It.x, It.y, It.z, It.w) : mt.set(It, Qt, ci, ai), rt.viewport(Ne.copy(mt).multiplyScalar(vt).round());
    }, this.getScissor = function(It) {
      return It.copy(Et);
    }, this.setScissor = function(It, Qt, ci, ai) {
      It.isVector4 ? Et.set(It.x, It.y, It.z, It.w) : Et.set(It, Qt, ci, ai), rt.scissor(Ae.copy(Et).multiplyScalar(vt).round());
    }, this.getScissorTest = function() {
      return it;
    }, this.setScissorTest = function(It) {
      rt.setScissorTest(it = It);
    }, this.setOpaqueSort = function(It) {
      Rt = It;
    }, this.setTransparentSort = function(It) {
      ze = It;
    }, this.getClearColor = function(It) {
      return It.copy(hi.getClearColor());
    }, this.setClearColor = function() {
      hi.setClearColor(...arguments);
    }, this.getClearAlpha = function() {
      return hi.getClearAlpha();
    }, this.setClearAlpha = function() {
      hi.setClearAlpha(...arguments);
    }, this.clear = function(It = !0, Qt = !0, ci = !0) {
      let ai = 0;
      if (It) {
        let ei = !1;
        if (ce !== null) {
          const Si = ce.texture.format;
          ei = Si === qpe || Si === Ype || Si === Wpe;
        }
        if (ei) {
          const Si = ce.texture.type, mn = Si === PA || Si === JF || Si === fX || Si === IX || Si === Vpe || Si === zpe, wn = hi.getClearColor(), Nn = hi.getClearAlpha(), Kn = wn.r, is = wn.g, jn = wn.b;
          mn ? (A[0] = Kn, A[1] = is, A[2] = jn, A[3] = Nn, Se.clearBufferuiv(Se.COLOR, 0, A)) : (C[0] = Kn, C[1] = is, C[2] = jn, C[3] = Nn, Se.clearBufferiv(Se.COLOR, 0, C));
        } else
          ai |= Se.COLOR_BUFFER_BIT;
      }
      Qt && (ai |= Se.DEPTH_BUFFER_BIT), ci && (ai |= Se.STENCIL_BUFFER_BIT, this.state.buffers.stencil.setMask(4294967295)), Se.clear(ai);
    }, this.clearColor = function() {
      this.clear(!0, !1, !1);
    }, this.clearDepth = function() {
      this.clear(!1, !0, !1);
    }, this.clearStencil = function() {
      this.clear(!1, !1, !0);
    }, this.dispose = function() {
      i.removeEventListener("webglcontextlost", tn, !1), i.removeEventListener("webglcontextrestored", Gi, !1), i.removeEventListener("webglcontextcreationerror", yi, !1), hi.dispose(), wi.dispose(), bi.dispose(), jt.dispose(), $t.dispose(), ht.dispose(), yt.dispose(), Pi.dispose(), kt.dispose(), Ut.dispose(), Fi.dispose(), Fi.removeEventListener("sessionstart", zl), Fi.removeEventListener("sessionend", Wu), jl.stop();
    };
    function tn(It) {
      It.preventDefault(), console.log("THREE.WebGLRenderer: Context Lost."), z = !0;
    }
    function Gi() {
      console.log("THREE.WebGLRenderer: Context Restored."), z = !1;
      const It = Tt.autoReset, Qt = Wi.enabled, ci = Wi.autoUpdate, ai = Wi.needsUpdate, ei = Wi.type;
      sn(), Tt.autoReset = It, Wi.enabled = Qt, Wi.autoUpdate = ci, Wi.needsUpdate = ai, Wi.type = ei;
    }
    function yi(It) {
      console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ", It.statusMessage);
    }
    function bn(It) {
      const Qt = It.target;
      Qt.removeEventListener("dispose", bn), ln(Qt);
    }
    function ln(It) {
      No(It), jt.remove(It);
    }
    function No(It) {
      const Qt = jt.get(It).programs;
      Qt !== void 0 && (Qt.forEach(function(ci) {
        Ut.releaseProgram(ci);
      }), It.isShaderMaterial && Ut.releaseShaderCache(It));
    }
    this.renderBufferDirect = function(It, Qt, ci, ai, ei, Si) {
      Qt === null && (Qt = Di);
      const mn = ei.isMesh && ei.matrixWorld.determinant() < 0, wn = Ai(It, Qt, ci, ai, ei);
      rt.setMaterial(ai, mn);
      let Nn = ci.index, Kn = 1;
      if (ai.wireframe === !0) {
        if (Nn = gt.getWireframeAttribute(ci), Nn === void 0) return;
        Kn = 2;
      }
      const is = ci.drawRange, jn = ci.attributes.position;
      let _s = is.start * Kn, yo = (is.start + is.count) * Kn;
      Si !== null && (_s = Math.max(_s, Si.start * Kn), yo = Math.min(yo, (Si.start + Si.count) * Kn)), Nn !== null ? (_s = Math.max(_s, 0), yo = Math.min(yo, Nn.count)) : jn != null && (_s = Math.max(_s, 0), yo = Math.min(yo, jn.count));
      const Qo = yo - _s;
      if (Qo < 0 || Qo === 1 / 0) return;
      Pi.setup(ei, ai, wn, ci, Nn);
      let so, Eo = Sn;
      if (Nn !== null && (so = Me.get(Nn), Eo = nn, Eo.setIndex(so)), ei.isMesh)
        ai.wireframe === !0 ? (rt.setLineWidth(ai.wireframeLinewidth * Ci()), Eo.setMode(Se.LINES)) : Eo.setMode(Se.TRIANGLES);
      else if (ei.isLine) {
        let Yn = ai.linewidth;
        Yn === void 0 && (Yn = 1), rt.setLineWidth(Yn * Ci()), ei.isLineSegments ? Eo.setMode(Se.LINES) : ei.isLineLoop ? Eo.setMode(Se.LINE_LOOP) : Eo.setMode(Se.LINE_STRIP);
      } else ei.isPoints ? Eo.setMode(Se.POINTS) : ei.isSprite && Eo.setMode(Se.TRIANGLES);
      if (ei.isBatchedMesh)
        if (ei._multiDrawInstances !== null)
          bz("THREE.WebGLRenderer: renderMultiDrawInstances has been deprecated and will be removed in r184. Append to renderMultiDraw arguments and use indirection."), Eo.renderMultiDrawInstances(ei._multiDrawStarts, ei._multiDrawCounts, ei._multiDrawCount, ei._multiDrawInstances);
        else if (Mt.get("WEBGL_multi_draw"))
          Eo.renderMultiDraw(ei._multiDrawStarts, ei._multiDrawCounts, ei._multiDrawCount);
        else {
          const Yn = ei._multiDrawStarts, Jo = ei._multiDrawCounts, xs = ei._multiDrawCount, Gr = Nn ? Me.get(Nn).bytesPerElement : 1, sa = jt.get(ai).currentProgram.getUniforms();
          for (let yr = 0; yr < xs; yr++)
            sa.setValue(Se, "_gl_DrawID", yr), Eo.render(Yn[yr] / Gr, Jo[yr]);
        }
      else if (ei.isInstancedMesh)
        Eo.renderInstances(_s, Qo, ei.count);
      else if (ci.isInstancedBufferGeometry) {
        const Yn = ci._maxInstanceCount !== void 0 ? ci._maxInstanceCount : 1 / 0, Jo = Math.min(ci.instanceCount, Yn);
        Eo.renderInstances(_s, Qo, Jo);
      } else
        Eo.render(_s, Qo);
    };
    function Bs(It, Qt, ci) {
      It.transparent === !0 && It.side === $y && It.forceSinglePass === !1 ? (It.side = nE, It.needsUpdate = !0, _i(It, Qt, ci), It.side = xA, It.needsUpdate = !0, _i(It, Qt, ci), It.side = $y) : _i(It, Qt, ci);
    }
    this.compile = function(It, Qt, ci = null) {
      ci === null && (ci = It), R = bi.get(ci), R.init(Qt), L.push(R), ci.traverseVisible(function(ei) {
        ei.isLight && ei.layers.test(Qt.layers) && (R.pushLight(ei), ei.castShadow && R.pushShadow(ei));
      }), It !== ci && It.traverseVisible(function(ei) {
        ei.isLight && ei.layers.test(Qt.layers) && (R.pushLight(ei), ei.castShadow && R.pushShadow(ei));
      }), R.setupLights();
      const ai = /* @__PURE__ */ new Set();
      return It.traverse(function(ei) {
        if (!(ei.isMesh || ei.isPoints || ei.isLine || ei.isSprite))
          return;
        const Si = ei.material;
        if (Si)
          if (Array.isArray(Si))
            for (let mn = 0; mn < Si.length; mn++) {
              const wn = Si[mn];
              Bs(wn, ci, ei), ai.add(wn);
            }
          else
            Bs(Si, ci, ei), ai.add(Si);
      }), R = L.pop(), ai;
    }, this.compileAsync = function(It, Qt, ci = null) {
      const ai = this.compile(It, Qt, ci);
      return new Promise((ei) => {
        function Si() {
          if (ai.forEach(function(mn) {
            jt.get(mn).currentProgram.isReady() && ai.delete(mn);
          }), ai.size === 0) {
            ei(It);
            return;
          }
          setTimeout(Si, 10);
        }
        Mt.get("KHR_parallel_shader_compile") !== null ? Si() : setTimeout(Si, 10);
      });
    };
    let os = null;
    function vl(It) {
      os && os(It);
    }
    function zl() {
      jl.stop();
    }
    function Wu() {
      jl.start();
    }
    const jl = new bAe();
    jl.setAnimationLoop(vl), typeof self < "u" && jl.setContext(self), this.setAnimationLoop = function(It) {
      os = It, Fi.setAnimationLoop(It), It === null ? jl.stop() : jl.start();
    }, Fi.addEventListener("sessionstart", zl), Fi.addEventListener("sessionend", Wu), this.render = function(It, Qt) {
      if (Qt !== void 0 && Qt.isCamera !== !0) {
        console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
        return;
      }
      if (z === !0) return;
      if (It.matrixWorldAutoUpdate === !0 && It.updateMatrixWorld(), Qt.parent === null && Qt.matrixWorldAutoUpdate === !0 && Qt.updateMatrixWorld(), Fi.enabled === !0 && Fi.isPresenting === !0 && (Fi.cameraAutoUpdate === !0 && Fi.updateCamera(Qt), Qt = Fi.getCamera()), It.isScene === !0 && It.onBeforeRender(P, It, Qt, ce), R = bi.get(It, L.length), R.init(Qt), L.push(R), Xt.multiplyMatrices(Qt.projectionMatrix, Qt.matrixWorldInverse), Dt.setFromProjectionMatrix(Xt), Kt = this.localClippingEnabled, Ct = Hi.init(this.clippingPlanes, Kt), O = wi.get(It, F.length), O.init(), F.push(O), Fi.enabled === !0 && Fi.isPresenting === !0) {
        const Si = P.xr.getDepthSensingMesh();
        Si !== null && Yu(Si, Qt, -1 / 0, P.sortObjects);
      }
      Yu(It, Qt, 0, P.sortObjects), O.finish(), P.sortObjects === !0 && O.sort(Rt, ze), ni = Fi.enabled === !1 || Fi.isPresenting === !1 || Fi.hasDepthSensing() === !1, ni && hi.addToRenderList(O, It), this.info.render.frame++, Ct === !0 && Hi.beginShadows();
      const ci = R.state.shadowsArray;
      Wi.render(ci, It, Qt), Ct === !0 && Hi.endShadows(), this.info.autoReset === !0 && this.info.reset();
      const ai = O.opaque, ei = O.transmissive;
      if (R.setupLights(), Qt.isArrayCamera) {
        const Si = Qt.cameras;
        if (ei.length > 0)
          for (let mn = 0, wn = Si.length; mn < wn; mn++) {
            const Nn = Si[mn];
            I0(ai, ei, It, Nn);
          }
        ni && hi.render(It);
        for (let mn = 0, wn = Si.length; mn < wn; mn++) {
          const Nn = Si[mn];
          bd(O, It, Nn, Nn.viewport);
        }
      } else
        ei.length > 0 && I0(ai, ei, It, Qt), ni && hi.render(It), bd(O, It, Qt);
      ce !== null && re === 0 && (Jt.updateMultisampleRenderTarget(ce), Jt.updateRenderTargetMipmap(ce)), It.isScene === !0 && It.onAfterRender(P, It, Qt), Pi.resetDefaultState(), te = -1, ee = null, L.pop(), L.length > 0 ? (R = L[L.length - 1], Ct === !0 && Hi.setGlobalState(P.clippingPlanes, R.state.camera)) : R = null, F.pop(), F.length > 0 ? O = F[F.length - 1] : O = null;
    };
    function Yu(It, Qt, ci, ai) {
      if (It.visible === !1) return;
      if (It.layers.test(Qt.layers)) {
        if (It.isGroup)
          ci = It.renderOrder;
        else if (It.isLOD)
          It.autoUpdate === !0 && It.update(Qt);
        else if (It.isLight)
          R.pushLight(It), It.castShadow && R.pushShadow(It);
        else if (It.isSprite) {
          if (!It.frustumCulled || Dt.intersectsSprite(It)) {
            ai && Wt.setFromMatrixPosition(It.matrixWorld).applyMatrix4(Xt);
            const mn = yt.update(It), wn = It.material;
            wn.visible && O.push(It, mn, wn, ci, Wt.z, null);
          }
        } else if ((It.isMesh || It.isLine || It.isPoints) && (!It.frustumCulled || Dt.intersectsObject(It))) {
          const mn = yt.update(It), wn = It.material;
          if (ai && (It.boundingSphere !== void 0 ? (It.boundingSphere === null && It.computeBoundingSphere(), Wt.copy(It.boundingSphere.center)) : (mn.boundingSphere === null && mn.computeBoundingSphere(), Wt.copy(mn.boundingSphere.center)), Wt.applyMatrix4(It.matrixWorld).applyMatrix4(Xt)), Array.isArray(wn)) {
            const Nn = mn.groups;
            for (let Kn = 0, is = Nn.length; Kn < is; Kn++) {
              const jn = Nn[Kn], _s = wn[jn.materialIndex];
              _s && _s.visible && O.push(It, mn, _s, ci, Wt.z, jn);
            }
          } else wn.visible && O.push(It, mn, wn, ci, Wt.z, null);
        }
      }
      const Si = It.children;
      for (let mn = 0, wn = Si.length; mn < wn; mn++)
        Yu(Si[mn], Qt, ci, ai);
    }
    function bd(It, Qt, ci, ai) {
      const ei = It.opaque, Si = It.transmissive, mn = It.transparent;
      R.setupLightsView(ci), Ct === !0 && Hi.setGlobalState(P.clippingPlanes, ci), ai && rt.viewport(Ne.copy(ai)), ei.length > 0 && Gt(ei, Qt, ci), Si.length > 0 && Gt(Si, Qt, ci), mn.length > 0 && Gt(mn, Qt, ci), rt.buffers.depth.setTest(!0), rt.buffers.depth.setMask(!0), rt.buffers.color.setMask(!0), rt.setPolygonOffset(!1);
    }
    function I0(It, Qt, ci, ai) {
      if ((ci.isScene === !0 ? ci.overrideMaterial : null) !== null)
        return;
      R.state.transmissionRenderTarget[ai.id] === void 0 && (R.state.transmissionRenderTarget[ai.id] = new qP(1, 1, {
        generateMipmaps: !0,
        type: Mt.has("EXT_color_buffer_half_float") || Mt.has("EXT_color_buffer_float") ? yie : PA,
        minFilter: rB,
        samples: 4,
        stencilBuffer: o,
        resolveDepthBuffer: !1,
        resolveStencilBuffer: !1,
        colorSpace: Qr.workingColorSpace
      }));
      const Si = R.state.transmissionRenderTarget[ai.id], mn = ai.viewport || Ne;
      Si.setSize(mn.z * P.transmissionResolutionScale, mn.w * P.transmissionResolutionScale);
      const wn = P.getRenderTarget(), Nn = P.getActiveCubeFace(), Kn = P.getActiveMipmapLevel();
      P.setRenderTarget(Si), P.getClearColor(pe), je = P.getClearAlpha(), je < 1 && P.setClearColor(16777215, 0.5), P.clear(), ni && hi.render(ci);
      const is = P.toneMapping;
      P.toneMapping = OP;
      const jn = ai.viewport;
      if (ai.viewport !== void 0 && (ai.viewport = void 0), R.setupLightsView(ai), Ct === !0 && Hi.setGlobalState(P.clippingPlanes, ai), Gt(It, ci, ai), Jt.updateMultisampleRenderTarget(Si), Jt.updateRenderTargetMipmap(Si), Mt.has("WEBGL_multisampled_render_to_texture") === !1) {
        let _s = !1;
        for (let yo = 0, Qo = Qt.length; yo < Qo; yo++) {
          const so = Qt[yo], Eo = so.object, Yn = so.geometry, Jo = so.material, xs = so.group;
          if (Jo.side === $y && Eo.layers.test(ai.layers)) {
            const Gr = Jo.side;
            Jo.side = nE, Jo.needsUpdate = !0, Vi(Eo, ci, ai, Yn, Jo, xs), Jo.side = Gr, Jo.needsUpdate = !0, _s = !0;
          }
        }
        _s === !0 && (Jt.updateMultisampleRenderTarget(Si), Jt.updateRenderTargetMipmap(Si));
      }
      P.setRenderTarget(wn, Nn, Kn), P.setClearColor(pe, je), jn !== void 0 && (ai.viewport = jn), P.toneMapping = is;
    }
    function Gt(It, Qt, ci) {
      const ai = Qt.isScene === !0 ? Qt.overrideMaterial : null;
      for (let ei = 0, Si = It.length; ei < Si; ei++) {
        const mn = It[ei], wn = mn.object, Nn = mn.geometry, Kn = mn.group;
        let is = mn.material;
        is.allowOverride === !0 && ai !== null && (is = ai), wn.layers.test(ci.layers) && Vi(wn, Qt, ci, Nn, is, Kn);
      }
    }
    function Vi(It, Qt, ci, ai, ei, Si) {
      It.onBeforeRender(P, Qt, ci, ai, ei, Si), It.modelViewMatrix.multiplyMatrices(ci.matrixWorldInverse, It.matrixWorld), It.normalMatrix.getNormalMatrix(It.modelViewMatrix), ei.onBeforeRender(P, Qt, ci, ai, It, Si), ei.transparent === !0 && ei.side === $y && ei.forceSinglePass === !1 ? (ei.side = nE, ei.needsUpdate = !0, P.renderBufferDirect(ci, Qt, ai, ei, It, Si), ei.side = xA, ei.needsUpdate = !0, P.renderBufferDirect(ci, Qt, ai, ei, It, Si), ei.side = $y) : P.renderBufferDirect(ci, Qt, ai, ei, It, Si), It.onAfterRender(P, Qt, ci, ai, ei, Si);
    }
    function _i(It, Qt, ci) {
      Qt.isScene !== !0 && (Qt = Di);
      const ai = jt.get(It), ei = R.state.lights, Si = R.state.shadowsArray, mn = ei.state.version, wn = Ut.getParameters(It, ei.state, Si, Qt, ci), Nn = Ut.getProgramCacheKey(wn);
      let Kn = ai.programs;
      ai.environment = It.isMeshStandardMaterial ? Qt.environment : null, ai.fog = Qt.fog, ai.envMap = (It.isMeshStandardMaterial ? ht : $t).get(It.envMap || ai.environment), ai.envMapRotation = ai.environment !== null && It.envMap === null ? Qt.environmentRotation : It.envMapRotation, Kn === void 0 && (It.addEventListener("dispose", bn), Kn = /* @__PURE__ */ new Map(), ai.programs = Kn);
      let is = Kn.get(Nn);
      if (is !== void 0) {
        if (ai.currentProgram === is && ai.lightsStateVersion === mn)
          return Os(It, wn), is;
      } else
        wn.uniforms = Ut.getUniforms(It), It.onBeforeCompile(wn, P), is = Ut.acquireProgram(wn, Nn), Kn.set(Nn, is), ai.uniforms = wn.uniforms;
      const jn = ai.uniforms;
      return (!It.isShaderMaterial && !It.isRawShaderMaterial || It.clipping === !0) && (jn.clippingPlanes = Hi.uniform), Os(It, wn), ai.needsLights = Es(It), ai.lightsStateVersion = mn, ai.needsLights && (jn.ambientLightColor.value = ei.state.ambient, jn.lightProbe.value = ei.state.probe, jn.directionalLights.value = ei.state.directional, jn.directionalLightShadows.value = ei.state.directionalShadow, jn.spotLights.value = ei.state.spot, jn.spotLightShadows.value = ei.state.spotShadow, jn.rectAreaLights.value = ei.state.rectArea, jn.ltc_1.value = ei.state.rectAreaLTC1, jn.ltc_2.value = ei.state.rectAreaLTC2, jn.pointLights.value = ei.state.point, jn.pointLightShadows.value = ei.state.pointShadow, jn.hemisphereLights.value = ei.state.hemi, jn.directionalShadowMap.value = ei.state.directionalShadowMap, jn.directionalShadowMatrix.value = ei.state.directionalShadowMatrix, jn.spotShadowMap.value = ei.state.spotShadowMap, jn.spotLightMatrix.value = ei.state.spotLightMatrix, jn.spotLightMap.value = ei.state.spotLightMap, jn.pointShadowMap.value = ei.state.pointShadowMap, jn.pointShadowMatrix.value = ei.state.pointShadowMatrix), ai.currentProgram = is, ai.uniformsList = null, is;
    }
    function $n(It) {
      if (It.uniformsList === null) {
        const Qt = It.currentProgram.getUniforms();
        It.uniformsList = koe.seqWithValue(Qt.seq, It.uniforms);
      }
      return It.uniformsList;
    }
    function Os(It, Qt) {
      const ci = jt.get(It);
      ci.outputColorSpace = Qt.outputColorSpace, ci.batching = Qt.batching, ci.batchingColor = Qt.batchingColor, ci.instancing = Qt.instancing, ci.instancingColor = Qt.instancingColor, ci.instancingMorph = Qt.instancingMorph, ci.skinning = Qt.skinning, ci.morphTargets = Qt.morphTargets, ci.morphNormals = Qt.morphNormals, ci.morphColors = Qt.morphColors, ci.morphTargetsCount = Qt.morphTargetsCount, ci.numClippingPlanes = Qt.numClippingPlanes, ci.numIntersection = Qt.numClipIntersection, ci.vertexAlphas = Qt.vertexAlphas, ci.vertexTangents = Qt.vertexTangents, ci.toneMapping = Qt.toneMapping;
    }
    function Ai(It, Qt, ci, ai, ei) {
      Qt.isScene !== !0 && (Qt = Di), Jt.resetTextureUnits();
      const Si = Qt.fog, mn = ai.isMeshStandardMaterial ? Qt.environment : null, wn = ce === null ? P.outputColorSpace : ce.isXRRenderTarget === !0 ? ce.texture.colorSpace : LW, Nn = (ai.isMeshStandardMaterial ? ht : $t).get(ai.envMap || mn), Kn = ai.vertexColors === !0 && !!ci.attributes.color && ci.attributes.color.itemSize === 4, is = !!ci.attributes.tangent && (!!ai.normalMap || ai.anisotropy > 0), jn = !!ci.morphAttributes.position, _s = !!ci.morphAttributes.normal, yo = !!ci.morphAttributes.color;
      let Qo = OP;
      ai.toneMapped && (ce === null || ce.isXRRenderTarget === !0) && (Qo = P.toneMapping);
      const so = ci.morphAttributes.position || ci.morphAttributes.normal || ci.morphAttributes.color, Eo = so !== void 0 ? so.length : 0, Yn = jt.get(ai), Jo = R.state.lights;
      if (Ct === !0 && (Kt === !0 || It !== ee)) {
        const ao = It === ee && ai.id === te;
        Hi.setState(ai, It, ao);
      }
      let xs = !1;
      ai.version === Yn.__version ? (Yn.needsLights && Yn.lightsStateVersion !== Jo.state.version || Yn.outputColorSpace !== wn || ei.isBatchedMesh && Yn.batching === !1 || !ei.isBatchedMesh && Yn.batching === !0 || ei.isBatchedMesh && Yn.batchingColor === !0 && ei.colorTexture === null || ei.isBatchedMesh && Yn.batchingColor === !1 && ei.colorTexture !== null || ei.isInstancedMesh && Yn.instancing === !1 || !ei.isInstancedMesh && Yn.instancing === !0 || ei.isSkinnedMesh && Yn.skinning === !1 || !ei.isSkinnedMesh && Yn.skinning === !0 || ei.isInstancedMesh && Yn.instancingColor === !0 && ei.instanceColor === null || ei.isInstancedMesh && Yn.instancingColor === !1 && ei.instanceColor !== null || ei.isInstancedMesh && Yn.instancingMorph === !0 && ei.morphTexture === null || ei.isInstancedMesh && Yn.instancingMorph === !1 && ei.morphTexture !== null || Yn.envMap !== Nn || ai.fog === !0 && Yn.fog !== Si || Yn.numClippingPlanes !== void 0 && (Yn.numClippingPlanes !== Hi.numPlanes || Yn.numIntersection !== Hi.numIntersection) || Yn.vertexAlphas !== Kn || Yn.vertexTangents !== is || Yn.morphTargets !== jn || Yn.morphNormals !== _s || Yn.morphColors !== yo || Yn.toneMapping !== Qo || Yn.morphTargetsCount !== Eo) && (xs = !0) : (xs = !0, Yn.__version = ai.version);
      let Gr = Yn.currentProgram;
      xs === !0 && (Gr = _i(ai, Qt, ei));
      let sa = !1, yr = !1, nr = !1;
      const Ws = Gr.getUniforms(), ul = Yn.uniforms;
      if (rt.useProgram(Gr.program) && (sa = !0, yr = !0, nr = !0), ai.id !== te && (te = ai.id, yr = !0), sa || ee !== It) {
        rt.buffers.depth.getReversed() ? (Zt.copy(It.projectionMatrix), H9e(Zt), G9e(Zt), Ws.setValue(Se, "projectionMatrix", Zt)) : Ws.setValue(Se, "projectionMatrix", It.projectionMatrix), Ws.setValue(Se, "viewMatrix", It.matrixWorldInverse);
        const kr = Ws.map.cameraPosition;
        kr !== void 0 && kr.setValue(Se, gi.setFromMatrixPosition(It.matrixWorld)), ft.logarithmicDepthBuffer && Ws.setValue(
          Se,
          "logDepthBufFC",
          2 / (Math.log(It.far + 1) / Math.LN2)
        ), (ai.isMeshPhongMaterial || ai.isMeshToonMaterial || ai.isMeshLambertMaterial || ai.isMeshBasicMaterial || ai.isMeshStandardMaterial || ai.isShaderMaterial) && Ws.setValue(Se, "isOrthographic", It.isOrthographicCamera === !0), ee !== It && (ee = It, yr = !0, nr = !0);
      }
      if (ei.isSkinnedMesh) {
        Ws.setOptional(Se, ei, "bindMatrix"), Ws.setOptional(Se, ei, "bindMatrixInverse");
        const ao = ei.skeleton;
        ao && (ao.boneTexture === null && ao.computeBoneTexture(), Ws.setValue(Se, "boneTexture", ao.boneTexture, Jt));
      }
      ei.isBatchedMesh && (Ws.setOptional(Se, ei, "batchingTexture"), Ws.setValue(Se, "batchingTexture", ei._matricesTexture, Jt), Ws.setOptional(Se, ei, "batchingIdTexture"), Ws.setValue(Se, "batchingIdTexture", ei._indirectTexture, Jt), Ws.setOptional(Se, ei, "batchingColorTexture"), ei._colorsTexture !== null && Ws.setValue(Se, "batchingColorTexture", ei._colorsTexture, Jt));
      const ur = ci.morphAttributes;
      if ((ur.position !== void 0 || ur.normal !== void 0 || ur.color !== void 0) && Ji.update(ei, ci, Gr), (yr || Yn.receiveShadow !== ei.receiveShadow) && (Yn.receiveShadow = ei.receiveShadow, Ws.setValue(Se, "receiveShadow", ei.receiveShadow)), ai.isMeshGouraudMaterial && ai.envMap !== null && (ul.envMap.value = Nn, ul.flipEnvMap.value = Nn.isCubeTexture && Nn.isRenderTargetTexture === !1 ? -1 : 1), ai.isMeshStandardMaterial && ai.envMap === null && Qt.environment !== null && (ul.envMapIntensity.value = Qt.environmentIntensity), yr && (Ws.setValue(Se, "toneMappingExposure", P.toneMappingExposure), Yn.needsLights && As(ul, nr), Si && ai.fog === !0 && Ht.refreshFogUniforms(ul, Si), Ht.refreshMaterialUniforms(ul, ai, vt, $e, R.state.transmissionRenderTarget[It.id]), koe.upload(Se, $n(Yn), ul, Jt)), ai.isShaderMaterial && ai.uniformsNeedUpdate === !0 && (koe.upload(Se, $n(Yn), ul, Jt), ai.uniformsNeedUpdate = !1), ai.isSpriteMaterial && Ws.setValue(Se, "center", ei.center), Ws.setValue(Se, "modelViewMatrix", ei.modelViewMatrix), Ws.setValue(Se, "normalMatrix", ei.normalMatrix), Ws.setValue(Se, "modelMatrix", ei.matrixWorld), ai.isShaderMaterial || ai.isRawShaderMaterial) {
        const ao = ai.uniformsGroups;
        for (let kr = 0, oa = ao.length; kr < oa; kr++) {
          const Po = ao[kr];
          kt.update(Po, Gr), kt.bind(Po, Gr);
        }
      }
      return Gr;
    }
    function As(It, Qt) {
      It.ambientLightColor.needsUpdate = Qt, It.lightProbe.needsUpdate = Qt, It.directionalLights.needsUpdate = Qt, It.directionalLightShadows.needsUpdate = Qt, It.pointLights.needsUpdate = Qt, It.pointLightShadows.needsUpdate = Qt, It.spotLights.needsUpdate = Qt, It.spotLightShadows.needsUpdate = Qt, It.rectAreaLights.needsUpdate = Qt, It.hemisphereLights.needsUpdate = Qt;
    }
    function Es(It) {
      return It.isMeshLambertMaterial || It.isMeshToonMaterial || It.isMeshPhongMaterial || It.isMeshStandardMaterial || It.isShadowMaterial || It.isShaderMaterial && It.lights === !0;
    }
    this.getActiveCubeFace = function() {
      return W;
    }, this.getActiveMipmapLevel = function() {
      return re;
    }, this.getRenderTarget = function() {
      return ce;
    }, this.setRenderTargetTextures = function(It, Qt, ci) {
      const ai = jt.get(It);
      ai.__autoAllocateDepthBuffer = It.resolveDepthBuffer === !1, ai.__autoAllocateDepthBuffer === !1 && (ai.__useRenderToTexture = !1), jt.get(It.texture).__webglTexture = Qt, jt.get(It.depthTexture).__webglTexture = ai.__autoAllocateDepthBuffer ? void 0 : ci, ai.__hasExternalTextures = !0;
    }, this.setRenderTargetFramebuffer = function(It, Qt) {
      const ci = jt.get(It);
      ci.__webglFramebuffer = Qt, ci.__useDefaultFramebuffer = Qt === void 0;
    };
    const mr = Se.createFramebuffer();
    this.setRenderTarget = function(It, Qt = 0, ci = 0) {
      ce = It, W = Qt, re = ci;
      let ai = !0, ei = null, Si = !1, mn = !1;
      if (It) {
        const Nn = jt.get(It);
        if (Nn.__useDefaultFramebuffer !== void 0)
          rt.bindFramebuffer(Se.FRAMEBUFFER, null), ai = !1;
        else if (Nn.__webglFramebuffer === void 0)
          Jt.setupRenderTarget(It);
        else if (Nn.__hasExternalTextures)
          Jt.rebindTextures(It, jt.get(It.texture).__webglTexture, jt.get(It.depthTexture).__webglTexture);
        else if (It.depthBuffer) {
          const jn = It.depthTexture;
          if (Nn.__boundDepthTexture !== jn) {
            if (jn !== null && jt.has(jn) && (It.width !== jn.image.width || It.height !== jn.image.height))
              throw new Error("WebGLRenderTarget: Attached DepthTexture is initialized to the incorrect size.");
            Jt.setupDepthRenderbuffer(It);
          }
        }
        const Kn = It.texture;
        (Kn.isData3DTexture || Kn.isDataArrayTexture || Kn.isCompressedArrayTexture) && (mn = !0);
        const is = jt.get(It).__webglFramebuffer;
        It.isWebGLCubeRenderTarget ? (Array.isArray(is[Qt]) ? ei = is[Qt][ci] : ei = is[Qt], Si = !0) : It.samples > 0 && Jt.useMultisampledRTT(It) === !1 ? ei = jt.get(It).__webglMultisampledFramebuffer : Array.isArray(is) ? ei = is[ci] : ei = is, Ne.copy(It.viewport), Ae.copy(It.scissor), Oe = It.scissorTest;
      } else
        Ne.copy(mt).multiplyScalar(vt).floor(), Ae.copy(Et).multiplyScalar(vt).floor(), Oe = it;
      if (ci !== 0 && (ei = mr), rt.bindFramebuffer(Se.FRAMEBUFFER, ei) && ai && rt.drawBuffers(It, ei), rt.viewport(Ne), rt.scissor(Ae), rt.setScissorTest(Oe), Si) {
        const Nn = jt.get(It.texture);
        Se.framebufferTexture2D(Se.FRAMEBUFFER, Se.COLOR_ATTACHMENT0, Se.TEXTURE_CUBE_MAP_POSITIVE_X + Qt, Nn.__webglTexture, ci);
      } else if (mn) {
        const Nn = jt.get(It.texture), Kn = Qt;
        Se.framebufferTextureLayer(Se.FRAMEBUFFER, Se.COLOR_ATTACHMENT0, Nn.__webglTexture, ci, Kn);
      } else if (It !== null && ci !== 0) {
        const Nn = jt.get(It.texture);
        Se.framebufferTexture2D(Se.FRAMEBUFFER, Se.COLOR_ATTACHMENT0, Se.TEXTURE_2D, Nn.__webglTexture, ci);
      }
      te = -1;
    }, this.readRenderTargetPixels = function(It, Qt, ci, ai, ei, Si, mn, wn = 0) {
      if (!(It && It.isWebGLRenderTarget)) {
        console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
        return;
      }
      let Nn = jt.get(It).__webglFramebuffer;
      if (It.isWebGLCubeRenderTarget && mn !== void 0 && (Nn = Nn[mn]), Nn) {
        rt.bindFramebuffer(Se.FRAMEBUFFER, Nn);
        try {
          const Kn = It.textures[wn], is = Kn.format, jn = Kn.type;
          if (!ft.textureFormatReadable(is)) {
            console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
            return;
          }
          if (!ft.textureTypeReadable(jn)) {
            console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
            return;
          }
          Qt >= 0 && Qt <= It.width - ai && ci >= 0 && ci <= It.height - ei && (It.textures.length > 1 && Se.readBuffer(Se.COLOR_ATTACHMENT0 + wn), Se.readPixels(Qt, ci, ai, ei, Yi.convert(is), Yi.convert(jn), Si));
        } finally {
          const Kn = ce !== null ? jt.get(ce).__webglFramebuffer : null;
          rt.bindFramebuffer(Se.FRAMEBUFFER, Kn);
        }
      }
    }, this.readRenderTargetPixelsAsync = async function(It, Qt, ci, ai, ei, Si, mn, wn = 0) {
      if (!(It && It.isWebGLRenderTarget))
        throw new Error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
      let Nn = jt.get(It).__webglFramebuffer;
      if (It.isWebGLCubeRenderTarget && mn !== void 0 && (Nn = Nn[mn]), Nn)
        if (Qt >= 0 && Qt <= It.width - ai && ci >= 0 && ci <= It.height - ei) {
          rt.bindFramebuffer(Se.FRAMEBUFFER, Nn);
          const Kn = It.textures[wn], is = Kn.format, jn = Kn.type;
          if (!ft.textureFormatReadable(is))
            throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.");
          if (!ft.textureTypeReadable(jn))
            throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.");
          const _s = Se.createBuffer();
          Se.bindBuffer(Se.PIXEL_PACK_BUFFER, _s), Se.bufferData(Se.PIXEL_PACK_BUFFER, Si.byteLength, Se.STREAM_READ), It.textures.length > 1 && Se.readBuffer(Se.COLOR_ATTACHMENT0 + wn), Se.readPixels(Qt, ci, ai, ei, Yi.convert(is), Yi.convert(jn), 0);
          const yo = ce !== null ? jt.get(ce).__webglFramebuffer : null;
          rt.bindFramebuffer(Se.FRAMEBUFFER, yo);
          const Qo = Se.fenceSync(Se.SYNC_GPU_COMMANDS_COMPLETE, 0);
          return Se.flush(), await F9e(Se, Qo, 4), Se.bindBuffer(Se.PIXEL_PACK_BUFFER, _s), Se.getBufferSubData(Se.PIXEL_PACK_BUFFER, 0, Si), Se.deleteBuffer(_s), Se.deleteSync(Qo), Si;
        } else
          throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.");
    }, this.copyFramebufferToTexture = function(It, Qt = null, ci = 0) {
      const ai = Math.pow(2, -ci), ei = Math.floor(It.image.width * ai), Si = Math.floor(It.image.height * ai), mn = Qt !== null ? Qt.x : 0, wn = Qt !== null ? Qt.y : 0;
      Jt.setTexture2D(It, 0), Se.copyTexSubImage2D(Se.TEXTURE_2D, ci, 0, 0, mn, wn, ei, Si), rt.unbindTexture();
    };
    const Je = Se.createFramebuffer(), no = Se.createFramebuffer();
    this.copyTextureToTexture = function(It, Qt, ci = null, ai = null, ei = 0, Si = null) {
      Si === null && (ei !== 0 ? (bz("WebGLRenderer: copyTextureToTexture function signature has changed to support src and dst mipmap levels."), Si = ei, ei = 0) : Si = 0);
      let mn, wn, Nn, Kn, is, jn, _s, yo, Qo;
      const so = It.isCompressedTexture ? It.mipmaps[Si] : It.image;
      if (ci !== null)
        mn = ci.max.x - ci.min.x, wn = ci.max.y - ci.min.y, Nn = ci.isBox3 ? ci.max.z - ci.min.z : 1, Kn = ci.min.x, is = ci.min.y, jn = ci.isBox3 ? ci.min.z : 0;
      else {
        const ur = Math.pow(2, -ei);
        mn = Math.floor(so.width * ur), wn = Math.floor(so.height * ur), It.isDataArrayTexture ? Nn = so.depth : It.isData3DTexture ? Nn = Math.floor(so.depth * ur) : Nn = 1, Kn = 0, is = 0, jn = 0;
      }
      ai !== null ? (_s = ai.x, yo = ai.y, Qo = ai.z) : (_s = 0, yo = 0, Qo = 0);
      const Eo = Yi.convert(Qt.format), Yn = Yi.convert(Qt.type);
      let Jo;
      Qt.isData3DTexture ? (Jt.setTexture3D(Qt, 0), Jo = Se.TEXTURE_3D) : Qt.isDataArrayTexture || Qt.isCompressedArrayTexture ? (Jt.setTexture2DArray(Qt, 0), Jo = Se.TEXTURE_2D_ARRAY) : (Jt.setTexture2D(Qt, 0), Jo = Se.TEXTURE_2D), Se.pixelStorei(Se.UNPACK_FLIP_Y_WEBGL, Qt.flipY), Se.pixelStorei(Se.UNPACK_PREMULTIPLY_ALPHA_WEBGL, Qt.premultiplyAlpha), Se.pixelStorei(Se.UNPACK_ALIGNMENT, Qt.unpackAlignment);
      const xs = Se.getParameter(Se.UNPACK_ROW_LENGTH), Gr = Se.getParameter(Se.UNPACK_IMAGE_HEIGHT), sa = Se.getParameter(Se.UNPACK_SKIP_PIXELS), yr = Se.getParameter(Se.UNPACK_SKIP_ROWS), nr = Se.getParameter(Se.UNPACK_SKIP_IMAGES);
      Se.pixelStorei(Se.UNPACK_ROW_LENGTH, so.width), Se.pixelStorei(Se.UNPACK_IMAGE_HEIGHT, so.height), Se.pixelStorei(Se.UNPACK_SKIP_PIXELS, Kn), Se.pixelStorei(Se.UNPACK_SKIP_ROWS, is), Se.pixelStorei(Se.UNPACK_SKIP_IMAGES, jn);
      const Ws = It.isDataArrayTexture || It.isData3DTexture, ul = Qt.isDataArrayTexture || Qt.isData3DTexture;
      if (It.isDepthTexture) {
        const ur = jt.get(It), ao = jt.get(Qt), kr = jt.get(ur.__renderTarget), oa = jt.get(ao.__renderTarget);
        rt.bindFramebuffer(Se.READ_FRAMEBUFFER, kr.__webglFramebuffer), rt.bindFramebuffer(Se.DRAW_FRAMEBUFFER, oa.__webglFramebuffer);
        for (let Po = 0; Po < Nn; Po++)
          Ws && (Se.framebufferTextureLayer(Se.READ_FRAMEBUFFER, Se.COLOR_ATTACHMENT0, jt.get(It).__webglTexture, ei, jn + Po), Se.framebufferTextureLayer(Se.DRAW_FRAMEBUFFER, Se.COLOR_ATTACHMENT0, jt.get(Qt).__webglTexture, Si, Qo + Po)), Se.blitFramebuffer(Kn, is, mn, wn, _s, yo, mn, wn, Se.DEPTH_BUFFER_BIT, Se.NEAREST);
        rt.bindFramebuffer(Se.READ_FRAMEBUFFER, null), rt.bindFramebuffer(Se.DRAW_FRAMEBUFFER, null);
      } else if (ei !== 0 || It.isRenderTargetTexture || jt.has(It)) {
        const ur = jt.get(It), ao = jt.get(Qt);
        rt.bindFramebuffer(Se.READ_FRAMEBUFFER, Je), rt.bindFramebuffer(Se.DRAW_FRAMEBUFFER, no);
        for (let kr = 0; kr < Nn; kr++)
          Ws ? Se.framebufferTextureLayer(Se.READ_FRAMEBUFFER, Se.COLOR_ATTACHMENT0, ur.__webglTexture, ei, jn + kr) : Se.framebufferTexture2D(Se.READ_FRAMEBUFFER, Se.COLOR_ATTACHMENT0, Se.TEXTURE_2D, ur.__webglTexture, ei), ul ? Se.framebufferTextureLayer(Se.DRAW_FRAMEBUFFER, Se.COLOR_ATTACHMENT0, ao.__webglTexture, Si, Qo + kr) : Se.framebufferTexture2D(Se.DRAW_FRAMEBUFFER, Se.COLOR_ATTACHMENT0, Se.TEXTURE_2D, ao.__webglTexture, Si), ei !== 0 ? Se.blitFramebuffer(Kn, is, mn, wn, _s, yo, mn, wn, Se.COLOR_BUFFER_BIT, Se.NEAREST) : ul ? Se.copyTexSubImage3D(Jo, Si, _s, yo, Qo + kr, Kn, is, mn, wn) : Se.copyTexSubImage2D(Jo, Si, _s, yo, Kn, is, mn, wn);
        rt.bindFramebuffer(Se.READ_FRAMEBUFFER, null), rt.bindFramebuffer(Se.DRAW_FRAMEBUFFER, null);
      } else
        ul ? It.isDataTexture || It.isData3DTexture ? Se.texSubImage3D(Jo, Si, _s, yo, Qo, mn, wn, Nn, Eo, Yn, so.data) : Qt.isCompressedArrayTexture ? Se.compressedTexSubImage3D(Jo, Si, _s, yo, Qo, mn, wn, Nn, Eo, so.data) : Se.texSubImage3D(Jo, Si, _s, yo, Qo, mn, wn, Nn, Eo, Yn, so) : It.isDataTexture ? Se.texSubImage2D(Se.TEXTURE_2D, Si, _s, yo, mn, wn, Eo, Yn, so.data) : It.isCompressedTexture ? Se.compressedTexSubImage2D(Se.TEXTURE_2D, Si, _s, yo, so.width, so.height, Eo, so.data) : Se.texSubImage2D(Se.TEXTURE_2D, Si, _s, yo, mn, wn, Eo, Yn, so);
      Se.pixelStorei(Se.UNPACK_ROW_LENGTH, xs), Se.pixelStorei(Se.UNPACK_IMAGE_HEIGHT, Gr), Se.pixelStorei(Se.UNPACK_SKIP_PIXELS, sa), Se.pixelStorei(Se.UNPACK_SKIP_ROWS, yr), Se.pixelStorei(Se.UNPACK_SKIP_IMAGES, nr), Si === 0 && Qt.generateMipmaps && Se.generateMipmap(Jo), rt.unbindTexture();
    }, this.copyTextureToTexture3D = function(It, Qt, ci = null, ai = null, ei = 0) {
      return bz('WebGLRenderer: copyTextureToTexture3D function has been deprecated. Use "copyTextureToTexture" instead.'), this.copyTextureToTexture(It, Qt, ci, ai, ei);
    }, this.initRenderTarget = function(It) {
      jt.get(It).__webglFramebuffer === void 0 && Jt.setupRenderTarget(It);
    }, this.initTexture = function(It) {
      It.isCubeTexture ? Jt.setTextureCube(It, 0) : It.isData3DTexture ? Jt.setTexture3D(It, 0) : It.isDataArrayTexture || It.isCompressedArrayTexture ? Jt.setTexture2DArray(It, 0) : Jt.setTexture2D(It, 0), rt.unbindTexture();
    }, this.resetState = function() {
      W = 0, re = 0, ce = null, rt.reset(), Pi.reset();
    }, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
  }
  /**
   * Defines the coordinate system of the renderer.
   *
   * In `WebGLRenderer`, the value is always `WebGLCoordinateSystem`.
   *
   * @type {WebGLCoordinateSystem|WebGPUCoordinateSystem}
   * @default WebGLCoordinateSystem
   * @readonly
   */
  get coordinateSystem() {
    return hN;
  }
  /**
   * Defines the output color space of the renderer.
   *
   * @type {SRGBColorSpace|LinearSRGBColorSpace}
   * @default SRGBColorSpace
   */
  get outputColorSpace() {
    return this._outputColorSpace;
  }
  set outputColorSpace(t) {
    this._outputColorSpace = t;
    const i = this.getContext();
    i.drawingBufferColorSpace = Qr._getDrawingBufferColorSpace(t), i.unpackColorSpace = Qr._getUnpackColorSpace();
  }
}
var mke = Object.getOwnPropertyNames, LAe = (e, t) => function() {
  return t || (0, e[mke(e)[0]])((t = { exports: {} }).exports, t), t.exports;
}, yke = LAe({
  "dist/web-ifc-mt.js"(e, t) {
    var i = (() => {
      var n = typeof document < "u" && document.currentScript ? document.currentScript.src : void 0;
      return function(s = {}) {
        function o() {
          return Ve.buffer != Et.buffer && Wt(), Et;
        }
        function r() {
          return Ve.buffer != Et.buffer && Wt(), it;
        }
        function l() {
          return Ve.buffer != Et.buffer && Wt(), Dt;
        }
        function c() {
          return Ve.buffer != Et.buffer && Wt(), Ct;
        }
        function h() {
          return Ve.buffer != Et.buffer && Wt(), Kt;
        }
        function I() {
          return Ve.buffer != Et.buffer && Wt(), Zt;
        }
        function p() {
          return Ve.buffer != Et.buffer && Wt(), Xt;
        }
        function y() {
          return Ve.buffer != Et.buffer && Wt(), gi;
        }
        var m = s, A, C;
        m.ready = new Promise((Y, oe) => {
          A = Y, C = oe;
        });
        var O = Object.assign({}, m), R = "./this.program", F = (Y, oe) => {
          throw oe;
        }, L = typeof window == "object", P = typeof importScripts == "function", z = typeof process == "object" && typeof process.versions == "object" && typeof process.versions.node == "string", W = m.ENVIRONMENT_IS_PTHREAD || !1, re = "";
        function ce(Y) {
          return m.locateFile ? m.locateFile(Y, re) : re + Y;
        }
        var te, ee, Ne;
        (L || P) && (P ? re = self.location.href : typeof document < "u" && document.currentScript && (re = document.currentScript.src), n && (re = n), re.indexOf("blob:") !== 0 ? re = re.substr(0, re.replace(/[?#].*/, "").lastIndexOf("/") + 1) : re = "", te = (Y) => {
          var oe = new XMLHttpRequest();
          return oe.open("GET", Y, !1), oe.send(null), oe.responseText;
        }, P && (Ne = (Y) => {
          var oe = new XMLHttpRequest();
          return oe.open("GET", Y, !1), oe.responseType = "arraybuffer", oe.send(null), new Uint8Array(oe.response);
        }), ee = (Y, oe, we) => {
          var Pe = new XMLHttpRequest();
          Pe.open("GET", Y, !0), Pe.responseType = "arraybuffer", Pe.onload = () => {
            if (Pe.status == 200 || Pe.status == 0 && Pe.response) {
              oe(Pe.response);
              return;
            }
            we();
          }, Pe.onerror = we, Pe.send(null);
        });
        var Ae = m.print || console.log.bind(console), Oe = m.printErr || console.error.bind(console);
        Object.assign(m, O), O = null, m.arguments && m.arguments, m.thisProgram && (R = m.thisProgram), m.quit && (F = m.quit);
        var pe;
        m.wasmBinary && (pe = m.wasmBinary);
        var je = m.noExitRuntime || !0;
        typeof WebAssembly != "object" && wi("no native wasm support detected");
        var Ve, $e, vt, Rt = !1, ze;
        function mt(Y, oe) {
          Y || wi(oe);
        }
        var Et, it, Dt, Ct, Kt, Zt, Xt, gi;
        function Wt() {
          var Y = Ve.buffer;
          m.HEAP8 = Et = new Int8Array(Y), m.HEAP16 = Dt = new Int16Array(Y), m.HEAP32 = Kt = new Int32Array(Y), m.HEAPU8 = it = new Uint8Array(Y), m.HEAPU16 = Ct = new Uint16Array(Y), m.HEAPU32 = Zt = new Uint32Array(Y), m.HEAPF32 = Xt = new Float32Array(Y), m.HEAPF64 = gi = new Float64Array(Y);
        }
        var Di = m.INITIAL_MEMORY || 16777216;
        if (mt(Di >= 5242880, "INITIAL_MEMORY should be larger than STACK_SIZE, was " + Di + "! (STACK_SIZE=5242880)"), W)
          Ve = m.wasmMemory;
        else if (m.wasmMemory)
          Ve = m.wasmMemory;
        else if (Ve = new WebAssembly.Memory({ initial: Di / 65536, maximum: 65536, shared: !0 }), !(Ve.buffer instanceof SharedArrayBuffer))
          throw Oe("requested a shared WebAssembly.Memory but the returned buffer is not a SharedArrayBuffer, indicating that while the browser has SharedArrayBuffer it does not have WebAssembly threads support - you may need to set a flag"), z && Oe("(on node you may need: --experimental-wasm-threads --experimental-wasm-bulk-memory and/or recent version)"), Error("bad memory");
        Wt(), Di = Ve.buffer.byteLength;
        var ni, Ci = [], Se = [], si = [], Mt = 0;
        function ft() {
          return je || Mt > 0;
        }
        function rt() {
          if (m.preRun)
            for (typeof m.preRun == "function" && (m.preRun = [m.preRun]); m.preRun.length; )
              Jt(m.preRun.shift());
          mn(Ci);
        }
        function Tt() {
          W || (!m.noFSInit && !Je.init.initialized && Je.init(), Je.ignorePermissions = !1, mn(Se));
        }
        function jt() {
          if (!W) {
            if (m.postRun)
              for (typeof m.postRun == "function" && (m.postRun = [m.postRun]); m.postRun.length; )
                ht(m.postRun.shift());
            mn(si);
          }
        }
        function Jt(Y) {
          Ci.unshift(Y);
        }
        function $t(Y) {
          Se.unshift(Y);
        }
        function ht(Y) {
          si.unshift(Y);
        }
        var Me = 0, gt = null;
        function yt(Y) {
          return Y;
        }
        function Ut(Y) {
          Me++, m.monitorRunDependencies && m.monitorRunDependencies(Me);
        }
        function Ht(Y) {
          if (Me--, m.monitorRunDependencies && m.monitorRunDependencies(Me), Me == 0 && gt) {
            var oe = gt;
            gt = null, oe();
          }
        }
        function wi(Y) {
          m.onAbort && m.onAbort(Y), Y = "Aborted(" + Y + ")", Oe(Y), Rt = !0, ze = 1, Y += ". Build with -sASSERTIONS for more info.";
          var oe = new WebAssembly.RuntimeError(Y);
          throw C(oe), oe;
        }
        var bi = "data:application/octet-stream;base64,";
        function Hi(Y) {
          return Y.startsWith(bi);
        }
        var Wi;
        Wi = "web-ifc-mt.wasm", Hi(Wi) || (Wi = ce(Wi));
        function hi(Y) {
          if (Y == Wi && pe)
            return new Uint8Array(pe);
          if (Ne)
            return Ne(Y);
          throw "both async and sync fetching of the wasm failed";
        }
        function Ji(Y) {
          return !pe && (L || P) && typeof fetch == "function" ? fetch(Y, { credentials: "same-origin" }).then((oe) => {
            if (!oe.ok)
              throw "failed to load wasm binary file at '" + Y + "'";
            return oe.arrayBuffer();
          }).catch(() => hi(Y)) : Promise.resolve().then(() => hi(Y));
        }
        function Sn(Y, oe, we) {
          return Ji(Y).then((Pe) => WebAssembly.instantiate(Pe, oe)).then((Pe) => Pe).then(we, (Pe) => {
            Oe("failed to asynchronously prepare wasm: " + Pe), wi(Pe);
          });
        }
        function nn(Y, oe, we, Pe) {
          return !Y && typeof WebAssembly.instantiateStreaming == "function" && !Hi(oe) && typeof fetch == "function" ? fetch(oe, { credentials: "same-origin" }).then((et) => {
            var wt = WebAssembly.instantiateStreaming(et, we);
            return wt.then(Pe, function(St) {
              return Oe("wasm streaming compile failed: " + St), Oe("falling back to ArrayBuffer instantiation"), Sn(oe, we, Pe);
            });
          }) : Sn(oe, we, Pe);
        }
        function Yi() {
          var Y = { a: W5 };
          function oe(Pe, et) {
            var wt = Pe.exports;
            return wt = Y5(wt), $e = wt, _s($e.oa), ni = $e.na, $t($e.ja), vt = et, Ht(), wt;
          }
          Ut();
          function we(Pe) {
            oe(Pe.instance, Pe.module);
          }
          if (m.instantiateWasm)
            try {
              return m.instantiateWasm(Y, oe);
            } catch (Pe) {
              Oe("Module.instantiateWasm callback failed with error: " + Pe), C(Pe);
            }
          return nn(pe, Wi, Y, we).catch(C), {};
        }
        var Pi, kt;
        function sn(Y) {
          this.name = "ExitStatus", this.message = `Program terminated with exit(${Y})`, this.status = Y;
        }
        var Fi = function(Y) {
          Y.terminate(), Y.onmessage = (oe) => {
          };
        };
        function tn(Y) {
          var oe = Si.pthreads[Y];
          delete Si.pthreads[Y], Fi(oe), Zg(Y), Si.runningWorkers.splice(Si.runningWorkers.indexOf(oe), 1), oe.pthread_ptr = 0;
        }
        function Gi(Y) {
          var oe = Si.pthreads[Y];
          oe.postMessage({ cmd: "cancel" });
        }
        function yi(Y) {
          var oe = Si.pthreads[Y];
          mt(oe), Si.returnWorkerToPool(oe);
        }
        function bn(Y) {
          var oe = Si.getNewWorker();
          if (!oe)
            return 6;
          Si.runningWorkers.push(oe), Si.pthreads[Y.pthread_ptr] = oe, oe.pthread_ptr = Y.pthread_ptr;
          var we = { cmd: "run", start_routine: Y.startRoutine, arg: Y.arg, pthread_ptr: Y.pthread_ptr };
          return oe.postMessage(we, Y.transferList), 0;
        }
        var ln = { isAbs: (Y) => Y.charAt(0) === "/", splitPath: (Y) => {
          var oe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
          return oe.exec(Y).slice(1);
        }, normalizeArray: (Y, oe) => {
          for (var we = 0, Pe = Y.length - 1; Pe >= 0; Pe--) {
            var et = Y[Pe];
            et === "." ? Y.splice(Pe, 1) : et === ".." ? (Y.splice(Pe, 1), we++) : we && (Y.splice(Pe, 1), we--);
          }
          if (oe)
            for (; we; we--)
              Y.unshift("..");
          return Y;
        }, normalize: (Y) => {
          var oe = ln.isAbs(Y), we = Y.substr(-1) === "/";
          return Y = ln.normalizeArray(Y.split("/").filter((Pe) => !!Pe), !oe).join("/"), !Y && !oe && (Y = "."), Y && we && (Y += "/"), (oe ? "/" : "") + Y;
        }, dirname: (Y) => {
          var oe = ln.splitPath(Y), we = oe[0], Pe = oe[1];
          return !we && !Pe ? "." : (Pe && (Pe = Pe.substr(0, Pe.length - 1)), we + Pe);
        }, basename: (Y) => {
          if (Y === "/") return "/";
          Y = ln.normalize(Y), Y = Y.replace(/\/$/, "");
          var oe = Y.lastIndexOf("/");
          return oe === -1 ? Y : Y.substr(oe + 1);
        }, join: function() {
          var Y = Array.prototype.slice.call(arguments);
          return ln.normalize(Y.join("/"));
        }, join2: (Y, oe) => ln.normalize(Y + "/" + oe) }, No = () => {
          if (typeof crypto == "object" && typeof crypto.getRandomValues == "function")
            return (Y) => (Y.set(crypto.getRandomValues(new Uint8Array(Y.byteLength))), Y);
          wi("initRandomDevice");
        }, Bs = (Y) => (Bs = No())(Y), os = { resolve: function() {
          for (var Y = "", oe = !1, we = arguments.length - 1; we >= -1 && !oe; we--) {
            var Pe = we >= 0 ? arguments[we] : Je.cwd();
            if (typeof Pe != "string")
              throw new TypeError("Arguments to path.resolve must be strings");
            if (!Pe)
              return "";
            Y = Pe + "/" + Y, oe = ln.isAbs(Pe);
          }
          return Y = ln.normalizeArray(Y.split("/").filter((et) => !!et), !oe).join("/"), (oe ? "/" : "") + Y || ".";
        }, relative: (Y, oe) => {
          Y = os.resolve(Y).substr(1), oe = os.resolve(oe).substr(1);
          function we(Ei) {
            for (var Qi = 0; Qi < Ei.length && Ei[Qi] === ""; Qi++)
              ;
            for (var vn = Ei.length - 1; vn >= 0 && Ei[vn] === ""; vn--)
              ;
            return Qi > vn ? [] : Ei.slice(Qi, vn - Qi + 1);
          }
          for (var Pe = we(Y.split("/")), et = we(oe.split("/")), wt = Math.min(Pe.length, et.length), St = wt, Ot = 0; Ot < wt; Ot++)
            if (Pe[Ot] !== et[Ot]) {
              St = Ot;
              break;
            }
          for (var ii = [], Ot = St; Ot < Pe.length; Ot++)
            ii.push("..");
          return ii = ii.concat(et.slice(St)), ii.join("/");
        } }, vl = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0, zl = (Y, oe, we) => {
          oe >>>= 0;
          for (var Pe = oe + we, et = oe; Y[et] && !(et >= Pe); ) ++et;
          if (et - oe > 16 && Y.buffer && vl)
            return vl.decode(Y.buffer instanceof SharedArrayBuffer ? Y.slice(oe, et) : Y.subarray(oe, et));
          for (var wt = ""; oe < et; ) {
            var St = Y[oe++];
            if (!(St & 128)) {
              wt += String.fromCharCode(St);
              continue;
            }
            var Ot = Y[oe++] & 63;
            if ((St & 224) == 192) {
              wt += String.fromCharCode((St & 31) << 6 | Ot);
              continue;
            }
            var ii = Y[oe++] & 63;
            if ((St & 240) == 224 ? St = (St & 15) << 12 | Ot << 6 | ii : St = (St & 7) << 18 | Ot << 12 | ii << 6 | Y[oe++] & 63, St < 65536)
              wt += String.fromCharCode(St);
            else {
              var Ei = St - 65536;
              wt += String.fromCharCode(55296 | Ei >> 10, 56320 | Ei & 1023);
            }
          }
          return wt;
        }, Wu = [], jl = (Y) => {
          for (var oe = 0, we = 0; we < Y.length; ++we) {
            var Pe = Y.charCodeAt(we);
            Pe <= 127 ? oe++ : Pe <= 2047 ? oe += 2 : Pe >= 55296 && Pe <= 57343 ? (oe += 4, ++we) : oe += 3;
          }
          return oe;
        }, Yu = (Y, oe, we, Pe) => {
          if (we >>>= 0, !(Pe > 0)) return 0;
          for (var et = we, wt = we + Pe - 1, St = 0; St < Y.length; ++St) {
            var Ot = Y.charCodeAt(St);
            if (Ot >= 55296 && Ot <= 57343) {
              var ii = Y.charCodeAt(++St);
              Ot = 65536 + ((Ot & 1023) << 10) | ii & 1023;
            }
            if (Ot <= 127) {
              if (we >= wt) break;
              oe[we++ >>> 0] = Ot;
            } else if (Ot <= 2047) {
              if (we + 1 >= wt) break;
              oe[we++ >>> 0] = 192 | Ot >> 6, oe[we++ >>> 0] = 128 | Ot & 63;
            } else if (Ot <= 65535) {
              if (we + 2 >= wt) break;
              oe[we++ >>> 0] = 224 | Ot >> 12, oe[we++ >>> 0] = 128 | Ot >> 6 & 63, oe[we++ >>> 0] = 128 | Ot & 63;
            } else {
              if (we + 3 >= wt) break;
              oe[we++ >>> 0] = 240 | Ot >> 18, oe[we++ >>> 0] = 128 | Ot >> 12 & 63, oe[we++ >>> 0] = 128 | Ot >> 6 & 63, oe[we++ >>> 0] = 128 | Ot & 63;
            }
          }
          return oe[we >>> 0] = 0, we - et;
        };
        function bd(Y, oe, we) {
          var Pe = jl(Y) + 1, et = new Array(Pe), wt = Yu(Y, et, 0, et.length);
          return oe && (et.length = wt), et;
        }
        var I0 = () => {
          if (!Wu.length) {
            var Y = null;
            if (typeof window < "u" && typeof window.prompt == "function" ? (Y = window.prompt("Input: "), Y !== null && (Y += `
`)) : typeof readline == "function" && (Y = readline(), Y !== null && (Y += `
`)), !Y)
              return null;
            Wu = bd(Y, !0);
          }
          return Wu.shift();
        }, Gt = { ttys: [], init: function() {
        }, shutdown: function() {
        }, register: function(Y, oe) {
          Gt.ttys[Y] = { input: [], output: [], ops: oe }, Je.registerDevice(Y, Gt.stream_ops);
        }, stream_ops: { open: function(Y) {
          var oe = Gt.ttys[Y.node.rdev];
          if (!oe)
            throw new Je.ErrnoError(43);
          Y.tty = oe, Y.seekable = !1;
        }, close: function(Y) {
          Y.tty.ops.fsync(Y.tty);
        }, fsync: function(Y) {
          Y.tty.ops.fsync(Y.tty);
        }, read: function(Y, oe, we, Pe, et) {
          if (!Y.tty || !Y.tty.ops.get_char)
            throw new Je.ErrnoError(60);
          for (var wt = 0, St = 0; St < Pe; St++) {
            var Ot;
            try {
              Ot = Y.tty.ops.get_char(Y.tty);
            } catch {
              throw new Je.ErrnoError(29);
            }
            if (Ot === void 0 && wt === 0)
              throw new Je.ErrnoError(6);
            if (Ot == null) break;
            wt++, oe[we + St] = Ot;
          }
          return wt && (Y.node.timestamp = Date.now()), wt;
        }, write: function(Y, oe, we, Pe, et) {
          if (!Y.tty || !Y.tty.ops.put_char)
            throw new Je.ErrnoError(60);
          try {
            for (var wt = 0; wt < Pe; wt++)
              Y.tty.ops.put_char(Y.tty, oe[we + wt]);
          } catch {
            throw new Je.ErrnoError(29);
          }
          return Pe && (Y.node.timestamp = Date.now()), wt;
        } }, default_tty_ops: { get_char: function(Y) {
          return I0();
        }, put_char: function(Y, oe) {
          oe === null || oe === 10 ? (Ae(zl(Y.output, 0)), Y.output = []) : oe != 0 && Y.output.push(oe);
        }, fsync: function(Y) {
          Y.output && Y.output.length > 0 && (Ae(zl(Y.output, 0)), Y.output = []);
        }, ioctl_tcgets: function(Y) {
          return { c_iflag: 25856, c_oflag: 5, c_cflag: 191, c_lflag: 35387, c_cc: [3, 28, 127, 21, 4, 0, 1, 0, 17, 19, 26, 0, 18, 15, 23, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] };
        }, ioctl_tcsets: function(Y, oe, we) {
          return 0;
        }, ioctl_tiocgwinsz: function(Y) {
          return [24, 80];
        } }, default_tty1_ops: { put_char: function(Y, oe) {
          oe === null || oe === 10 ? (Oe(zl(Y.output, 0)), Y.output = []) : oe != 0 && Y.output.push(oe);
        }, fsync: function(Y) {
          Y.output && Y.output.length > 0 && (Oe(zl(Y.output, 0)), Y.output = []);
        } } }, Vi = (Y) => {
          wi();
        }, _i = { ops_table: null, mount(Y) {
          return _i.createNode(null, "/", 16895, 0);
        }, createNode(Y, oe, we, Pe) {
          if (Je.isBlkdev(we) || Je.isFIFO(we))
            throw new Je.ErrnoError(63);
          _i.ops_table || (_i.ops_table = { dir: { node: { getattr: _i.node_ops.getattr, setattr: _i.node_ops.setattr, lookup: _i.node_ops.lookup, mknod: _i.node_ops.mknod, rename: _i.node_ops.rename, unlink: _i.node_ops.unlink, rmdir: _i.node_ops.rmdir, readdir: _i.node_ops.readdir, symlink: _i.node_ops.symlink }, stream: { llseek: _i.stream_ops.llseek } }, file: { node: { getattr: _i.node_ops.getattr, setattr: _i.node_ops.setattr }, stream: { llseek: _i.stream_ops.llseek, read: _i.stream_ops.read, write: _i.stream_ops.write, allocate: _i.stream_ops.allocate, mmap: _i.stream_ops.mmap, msync: _i.stream_ops.msync } }, link: { node: { getattr: _i.node_ops.getattr, setattr: _i.node_ops.setattr, readlink: _i.node_ops.readlink }, stream: {} }, chrdev: { node: { getattr: _i.node_ops.getattr, setattr: _i.node_ops.setattr }, stream: Je.chrdev_stream_ops } });
          var et = Je.createNode(Y, oe, we, Pe);
          return Je.isDir(et.mode) ? (et.node_ops = _i.ops_table.dir.node, et.stream_ops = _i.ops_table.dir.stream, et.contents = {}) : Je.isFile(et.mode) ? (et.node_ops = _i.ops_table.file.node, et.stream_ops = _i.ops_table.file.stream, et.usedBytes = 0, et.contents = null) : Je.isLink(et.mode) ? (et.node_ops = _i.ops_table.link.node, et.stream_ops = _i.ops_table.link.stream) : Je.isChrdev(et.mode) && (et.node_ops = _i.ops_table.chrdev.node, et.stream_ops = _i.ops_table.chrdev.stream), et.timestamp = Date.now(), Y && (Y.contents[oe] = et, Y.timestamp = et.timestamp), et;
        }, getFileDataAsTypedArray(Y) {
          return Y.contents ? Y.contents.subarray ? Y.contents.subarray(0, Y.usedBytes) : new Uint8Array(Y.contents) : new Uint8Array(0);
        }, expandFileStorage(Y, oe) {
          var we = Y.contents ? Y.contents.length : 0;
          if (!(we >= oe)) {
            var Pe = 1024 * 1024;
            oe = Math.max(oe, we * (we < Pe ? 2 : 1.125) >>> 0), we != 0 && (oe = Math.max(oe, 256));
            var et = Y.contents;
            Y.contents = new Uint8Array(oe), Y.usedBytes > 0 && Y.contents.set(et.subarray(0, Y.usedBytes), 0);
          }
        }, resizeFileStorage(Y, oe) {
          if (Y.usedBytes != oe)
            if (oe == 0)
              Y.contents = null, Y.usedBytes = 0;
            else {
              var we = Y.contents;
              Y.contents = new Uint8Array(oe), we && Y.contents.set(we.subarray(0, Math.min(oe, Y.usedBytes))), Y.usedBytes = oe;
            }
        }, node_ops: { getattr(Y) {
          var oe = {};
          return oe.dev = Je.isChrdev(Y.mode) ? Y.id : 1, oe.ino = Y.id, oe.mode = Y.mode, oe.nlink = 1, oe.uid = 0, oe.gid = 0, oe.rdev = Y.rdev, Je.isDir(Y.mode) ? oe.size = 4096 : Je.isFile(Y.mode) ? oe.size = Y.usedBytes : Je.isLink(Y.mode) ? oe.size = Y.link.length : oe.size = 0, oe.atime = new Date(Y.timestamp), oe.mtime = new Date(Y.timestamp), oe.ctime = new Date(Y.timestamp), oe.blksize = 4096, oe.blocks = Math.ceil(oe.size / oe.blksize), oe;
        }, setattr(Y, oe) {
          oe.mode !== void 0 && (Y.mode = oe.mode), oe.timestamp !== void 0 && (Y.timestamp = oe.timestamp), oe.size !== void 0 && _i.resizeFileStorage(Y, oe.size);
        }, lookup(Y, oe) {
          throw Je.genericErrors[44];
        }, mknod(Y, oe, we, Pe) {
          return _i.createNode(Y, oe, we, Pe);
        }, rename(Y, oe, we) {
          if (Je.isDir(Y.mode)) {
            var Pe;
            try {
              Pe = Je.lookupNode(oe, we);
            } catch {
            }
            if (Pe)
              for (var et in Pe.contents)
                throw new Je.ErrnoError(55);
          }
          delete Y.parent.contents[Y.name], Y.parent.timestamp = Date.now(), Y.name = we, oe.contents[we] = Y, oe.timestamp = Y.parent.timestamp, Y.parent = oe;
        }, unlink(Y, oe) {
          delete Y.contents[oe], Y.timestamp = Date.now();
        }, rmdir(Y, oe) {
          var we = Je.lookupNode(Y, oe);
          for (var Pe in we.contents)
            throw new Je.ErrnoError(55);
          delete Y.contents[oe], Y.timestamp = Date.now();
        }, readdir(Y) {
          var oe = [".", ".."];
          for (var we in Y.contents)
            Y.contents.hasOwnProperty(we) && oe.push(we);
          return oe;
        }, symlink(Y, oe, we) {
          var Pe = _i.createNode(Y, oe, 41471, 0);
          return Pe.link = we, Pe;
        }, readlink(Y) {
          if (!Je.isLink(Y.mode))
            throw new Je.ErrnoError(28);
          return Y.link;
        } }, stream_ops: { read(Y, oe, we, Pe, et) {
          var wt = Y.node.contents;
          if (et >= Y.node.usedBytes) return 0;
          var St = Math.min(Y.node.usedBytes - et, Pe);
          if (St > 8 && wt.subarray)
            oe.set(wt.subarray(et, et + St), we);
          else
            for (var Ot = 0; Ot < St; Ot++) oe[we + Ot] = wt[et + Ot];
          return St;
        }, write(Y, oe, we, Pe, et, wt) {
          if (oe.buffer === o().buffer && (wt = !1), !Pe) return 0;
          var St = Y.node;
          if (St.timestamp = Date.now(), oe.subarray && (!St.contents || St.contents.subarray)) {
            if (wt)
              return St.contents = oe.subarray(we, we + Pe), St.usedBytes = Pe, Pe;
            if (St.usedBytes === 0 && et === 0)
              return St.contents = oe.slice(we, we + Pe), St.usedBytes = Pe, Pe;
            if (et + Pe <= St.usedBytes)
              return St.contents.set(oe.subarray(we, we + Pe), et), Pe;
          }
          if (_i.expandFileStorage(St, et + Pe), St.contents.subarray && oe.subarray)
            St.contents.set(oe.subarray(we, we + Pe), et);
          else
            for (var Ot = 0; Ot < Pe; Ot++)
              St.contents[et + Ot] = oe[we + Ot];
          return St.usedBytes = Math.max(St.usedBytes, et + Pe), Pe;
        }, llseek(Y, oe, we) {
          var Pe = oe;
          if (we === 1 ? Pe += Y.position : we === 2 && Je.isFile(Y.node.mode) && (Pe += Y.node.usedBytes), Pe < 0)
            throw new Je.ErrnoError(28);
          return Pe;
        }, allocate(Y, oe, we) {
          _i.expandFileStorage(Y.node, oe + we), Y.node.usedBytes = Math.max(Y.node.usedBytes, oe + we);
        }, mmap(Y, oe, we, Pe, et) {
          if (!Je.isFile(Y.node.mode))
            throw new Je.ErrnoError(43);
          var wt, St, Ot = Y.node.contents;
          if (!(et & 2) && Ot.buffer === o().buffer)
            St = !1, wt = Ot.byteOffset;
          else {
            if ((we > 0 || we + oe < Ot.length) && (Ot.subarray ? Ot = Ot.subarray(we, we + oe) : Ot = Array.prototype.slice.call(Ot, we, we + oe)), St = !0, wt = Vi(), !wt)
              throw new Je.ErrnoError(48);
            o().set(Ot, wt >>> 0);
          }
          return { ptr: wt, allocated: St };
        }, msync(Y, oe, we, Pe, et) {
          return _i.stream_ops.write(Y, oe, 0, Pe, we, !1), 0;
        } } }, $n = (Y, oe, we, Pe) => {
          var et = `al ${Y}`;
          ee(Y, (wt) => {
            mt(wt, `Loading data file "${Y}" failed (no arrayBuffer).`), oe(new Uint8Array(wt)), et && Ht();
          }, (wt) => {
            if (we)
              we();
            else
              throw `Loading data file "${Y}" failed.`;
          }), et && Ut();
        }, Os = m.preloadPlugins || [];
        function Ai(Y, oe, we, Pe) {
          typeof Browser < "u" && Browser.init();
          var et = !1;
          return Os.forEach(function(wt) {
            et || wt.canHandle(oe) && (wt.handle(Y, oe, we, Pe), et = !0);
          }), et;
        }
        function As(Y, oe, we, Pe, et, wt, St, Ot, ii, Ei) {
          var Qi = oe ? os.resolve(ln.join2(Y, oe)) : Y;
          function vn(cn) {
            function hn(Zn) {
              Ei && Ei(), Ot || Je.createDataFile(Y, oe, Zn, Pe, et, ii), wt && wt(), Ht();
            }
            Ai(cn, Qi, hn, () => {
              St && St(), Ht();
            }) || hn(cn);
          }
          Ut(), typeof we == "string" ? $n(we, (cn) => vn(cn), St) : vn(we);
        }
        function Es(Y) {
          var oe = { r: 0, "r+": 2, w: 577, "w+": 578, a: 1089, "a+": 1090 }, we = oe[Y];
          if (typeof we > "u")
            throw new Error(`Unknown file open mode: ${Y}`);
          return we;
        }
        function mr(Y, oe) {
          var we = 0;
          return Y && (we |= 365), oe && (we |= 146), we;
        }
        var Je = { root: null, mounts: [], devices: {}, streams: [], nextInode: 1, nameTable: null, currentPath: "/", initialized: !1, ignorePermissions: !0, ErrnoError: null, genericErrors: {}, filesystems: null, syncFSRequests: 0, lookupPath: (Y, oe = {}) => {
          if (Y = os.resolve(Y), !Y) return { path: "", node: null };
          var we = { follow_mount: !0, recurse_count: 0 };
          if (oe = Object.assign(we, oe), oe.recurse_count > 8)
            throw new Je.ErrnoError(32);
          for (var Pe = Y.split("/").filter((vn) => !!vn), et = Je.root, wt = "/", St = 0; St < Pe.length; St++) {
            var Ot = St === Pe.length - 1;
            if (Ot && oe.parent)
              break;
            if (et = Je.lookupNode(et, Pe[St]), wt = ln.join2(wt, Pe[St]), Je.isMountpoint(et) && (!Ot || Ot && oe.follow_mount) && (et = et.mounted.root), !Ot || oe.follow)
              for (var ii = 0; Je.isLink(et.mode); ) {
                var Ei = Je.readlink(wt);
                wt = os.resolve(ln.dirname(wt), Ei);
                var Qi = Je.lookupPath(wt, { recurse_count: oe.recurse_count + 1 });
                if (et = Qi.node, ii++ > 40)
                  throw new Je.ErrnoError(32);
              }
          }
          return { path: wt, node: et };
        }, getPath: (Y) => {
          for (var oe; ; ) {
            if (Je.isRoot(Y)) {
              var we = Y.mount.mountpoint;
              return oe ? we[we.length - 1] !== "/" ? `${we}/${oe}` : we + oe : we;
            }
            oe = oe ? `${Y.name}/${oe}` : Y.name, Y = Y.parent;
          }
        }, hashName: (Y, oe) => {
          for (var we = 0, Pe = 0; Pe < oe.length; Pe++)
            we = (we << 5) - we + oe.charCodeAt(Pe) | 0;
          return (Y + we >>> 0) % Je.nameTable.length;
        }, hashAddNode: (Y) => {
          var oe = Je.hashName(Y.parent.id, Y.name);
          Y.name_next = Je.nameTable[oe], Je.nameTable[oe] = Y;
        }, hashRemoveNode: (Y) => {
          var oe = Je.hashName(Y.parent.id, Y.name);
          if (Je.nameTable[oe] === Y)
            Je.nameTable[oe] = Y.name_next;
          else
            for (var we = Je.nameTable[oe]; we; ) {
              if (we.name_next === Y) {
                we.name_next = Y.name_next;
                break;
              }
              we = we.name_next;
            }
        }, lookupNode: (Y, oe) => {
          var we = Je.mayLookup(Y);
          if (we)
            throw new Je.ErrnoError(we, Y);
          for (var Pe = Je.hashName(Y.id, oe), et = Je.nameTable[Pe]; et; et = et.name_next) {
            var wt = et.name;
            if (et.parent.id === Y.id && wt === oe)
              return et;
          }
          return Je.lookup(Y, oe);
        }, createNode: (Y, oe, we, Pe) => {
          var et = new Je.FSNode(Y, oe, we, Pe);
          return Je.hashAddNode(et), et;
        }, destroyNode: (Y) => {
          Je.hashRemoveNode(Y);
        }, isRoot: (Y) => Y === Y.parent, isMountpoint: (Y) => !!Y.mounted, isFile: (Y) => (Y & 61440) === 32768, isDir: (Y) => (Y & 61440) === 16384, isLink: (Y) => (Y & 61440) === 40960, isChrdev: (Y) => (Y & 61440) === 8192, isBlkdev: (Y) => (Y & 61440) === 24576, isFIFO: (Y) => (Y & 61440) === 4096, isSocket: (Y) => (Y & 49152) === 49152, flagsToPermissionString: (Y) => {
          var oe = ["r", "w", "rw"][Y & 3];
          return Y & 512 && (oe += "w"), oe;
        }, nodePermissions: (Y, oe) => Je.ignorePermissions ? 0 : oe.includes("r") && !(Y.mode & 292) || oe.includes("w") && !(Y.mode & 146) || oe.includes("x") && !(Y.mode & 73) ? 2 : 0, mayLookup: (Y) => {
          var oe = Je.nodePermissions(Y, "x");
          return oe || (Y.node_ops.lookup ? 0 : 2);
        }, mayCreate: (Y, oe) => {
          try {
            var we = Je.lookupNode(Y, oe);
            return 20;
          } catch {
          }
          return Je.nodePermissions(Y, "wx");
        }, mayDelete: (Y, oe, we) => {
          var Pe;
          try {
            Pe = Je.lookupNode(Y, oe);
          } catch (wt) {
            return wt.errno;
          }
          var et = Je.nodePermissions(Y, "wx");
          if (et)
            return et;
          if (we) {
            if (!Je.isDir(Pe.mode))
              return 54;
            if (Je.isRoot(Pe) || Je.getPath(Pe) === Je.cwd())
              return 10;
          } else if (Je.isDir(Pe.mode))
            return 31;
          return 0;
        }, mayOpen: (Y, oe) => Y ? Je.isLink(Y.mode) ? 32 : Je.isDir(Y.mode) && (Je.flagsToPermissionString(oe) !== "r" || oe & 512) ? 31 : Je.nodePermissions(Y, Je.flagsToPermissionString(oe)) : 44, MAX_OPEN_FDS: 4096, nextfd: () => {
          for (var Y = 0; Y <= Je.MAX_OPEN_FDS; Y++)
            if (!Je.streams[Y])
              return Y;
          throw new Je.ErrnoError(33);
        }, getStreamChecked: (Y) => {
          var oe = Je.getStream(Y);
          if (!oe)
            throw new Je.ErrnoError(8);
          return oe;
        }, getStream: (Y) => Je.streams[Y], createStream: (Y, oe = -1) => (Je.FSStream || (Je.FSStream = function() {
          this.shared = {};
        }, Je.FSStream.prototype = {}, Object.defineProperties(Je.FSStream.prototype, { object: { get() {
          return this.node;
        }, set(we) {
          this.node = we;
        } }, isRead: { get() {
          return (this.flags & 2097155) !== 1;
        } }, isWrite: { get() {
          return (this.flags & 2097155) !== 0;
        } }, isAppend: { get() {
          return this.flags & 1024;
        } }, flags: { get() {
          return this.shared.flags;
        }, set(we) {
          this.shared.flags = we;
        } }, position: { get() {
          return this.shared.position;
        }, set(we) {
          this.shared.position = we;
        } } })), Y = Object.assign(new Je.FSStream(), Y), oe == -1 && (oe = Je.nextfd()), Y.fd = oe, Je.streams[oe] = Y, Y), closeStream: (Y) => {
          Je.streams[Y] = null;
        }, chrdev_stream_ops: { open: (Y) => {
          var oe = Je.getDevice(Y.node.rdev);
          Y.stream_ops = oe.stream_ops, Y.stream_ops.open && Y.stream_ops.open(Y);
        }, llseek: () => {
          throw new Je.ErrnoError(70);
        } }, major: (Y) => Y >> 8, minor: (Y) => Y & 255, makedev: (Y, oe) => Y << 8 | oe, registerDevice: (Y, oe) => {
          Je.devices[Y] = { stream_ops: oe };
        }, getDevice: (Y) => Je.devices[Y], getMounts: (Y) => {
          for (var oe = [], we = [Y]; we.length; ) {
            var Pe = we.pop();
            oe.push(Pe), we.push.apply(we, Pe.mounts);
          }
          return oe;
        }, syncfs: (Y, oe) => {
          typeof Y == "function" && (oe = Y, Y = !1), Je.syncFSRequests++, Je.syncFSRequests > 1 && Oe(`warning: ${Je.syncFSRequests} FS.syncfs operations in flight at once, probably just doing extra work`);
          var we = Je.getMounts(Je.root.mount), Pe = 0;
          function et(St) {
            return Je.syncFSRequests--, oe(St);
          }
          function wt(St) {
            if (St)
              return wt.errored ? void 0 : (wt.errored = !0, et(St));
            ++Pe >= we.length && et(null);
          }
          we.forEach((St) => {
            if (!St.type.syncfs)
              return wt(null);
            St.type.syncfs(St, Y, wt);
          });
        }, mount: (Y, oe, we) => {
          var Pe = we === "/", et = !we, wt;
          if (Pe && Je.root)
            throw new Je.ErrnoError(10);
          if (!Pe && !et) {
            var St = Je.lookupPath(we, { follow_mount: !1 });
            if (we = St.path, wt = St.node, Je.isMountpoint(wt))
              throw new Je.ErrnoError(10);
            if (!Je.isDir(wt.mode))
              throw new Je.ErrnoError(54);
          }
          var Ot = { type: Y, opts: oe, mountpoint: we, mounts: [] }, ii = Y.mount(Ot);
          return ii.mount = Ot, Ot.root = ii, Pe ? Je.root = ii : wt && (wt.mounted = Ot, wt.mount && wt.mount.mounts.push(Ot)), ii;
        }, unmount: (Y) => {
          var oe = Je.lookupPath(Y, { follow_mount: !1 });
          if (!Je.isMountpoint(oe.node))
            throw new Je.ErrnoError(28);
          var we = oe.node, Pe = we.mounted, et = Je.getMounts(Pe);
          Object.keys(Je.nameTable).forEach((St) => {
            for (var Ot = Je.nameTable[St]; Ot; ) {
              var ii = Ot.name_next;
              et.includes(Ot.mount) && Je.destroyNode(Ot), Ot = ii;
            }
          }), we.mounted = null;
          var wt = we.mount.mounts.indexOf(Pe);
          we.mount.mounts.splice(wt, 1);
        }, lookup: (Y, oe) => Y.node_ops.lookup(Y, oe), mknod: (Y, oe, we) => {
          var Pe = Je.lookupPath(Y, { parent: !0 }), et = Pe.node, wt = ln.basename(Y);
          if (!wt || wt === "." || wt === "..")
            throw new Je.ErrnoError(28);
          var St = Je.mayCreate(et, wt);
          if (St)
            throw new Je.ErrnoError(St);
          if (!et.node_ops.mknod)
            throw new Je.ErrnoError(63);
          return et.node_ops.mknod(et, wt, oe, we);
        }, create: (Y, oe) => (oe = oe !== void 0 ? oe : 438, oe &= 4095, oe |= 32768, Je.mknod(Y, oe, 0)), mkdir: (Y, oe) => (oe = oe !== void 0 ? oe : 511, oe &= 1023, oe |= 16384, Je.mknod(Y, oe, 0)), mkdirTree: (Y, oe) => {
          for (var we = Y.split("/"), Pe = "", et = 0; et < we.length; ++et)
            if (we[et]) {
              Pe += "/" + we[et];
              try {
                Je.mkdir(Pe, oe);
              } catch (wt) {
                if (wt.errno != 20) throw wt;
              }
            }
        }, mkdev: (Y, oe, we) => (typeof we > "u" && (we = oe, oe = 438), oe |= 8192, Je.mknod(Y, oe, we)), symlink: (Y, oe) => {
          if (!os.resolve(Y))
            throw new Je.ErrnoError(44);
          var we = Je.lookupPath(oe, { parent: !0 }), Pe = we.node;
          if (!Pe)
            throw new Je.ErrnoError(44);
          var et = ln.basename(oe), wt = Je.mayCreate(Pe, et);
          if (wt)
            throw new Je.ErrnoError(wt);
          if (!Pe.node_ops.symlink)
            throw new Je.ErrnoError(63);
          return Pe.node_ops.symlink(Pe, et, Y);
        }, rename: (Y, oe) => {
          var we = ln.dirname(Y), Pe = ln.dirname(oe), et = ln.basename(Y), wt = ln.basename(oe), St, Ot, ii;
          if (St = Je.lookupPath(Y, { parent: !0 }), Ot = St.node, St = Je.lookupPath(oe, { parent: !0 }), ii = St.node, !Ot || !ii) throw new Je.ErrnoError(44);
          if (Ot.mount !== ii.mount)
            throw new Je.ErrnoError(75);
          var Ei = Je.lookupNode(Ot, et), Qi = os.relative(Y, Pe);
          if (Qi.charAt(0) !== ".")
            throw new Je.ErrnoError(28);
          if (Qi = os.relative(oe, we), Qi.charAt(0) !== ".")
            throw new Je.ErrnoError(55);
          var vn;
          try {
            vn = Je.lookupNode(ii, wt);
          } catch {
          }
          if (Ei !== vn) {
            var cn = Je.isDir(Ei.mode), hn = Je.mayDelete(Ot, et, cn);
            if (hn)
              throw new Je.ErrnoError(hn);
            if (hn = vn ? Je.mayDelete(ii, wt, cn) : Je.mayCreate(ii, wt), hn)
              throw new Je.ErrnoError(hn);
            if (!Ot.node_ops.rename)
              throw new Je.ErrnoError(63);
            if (Je.isMountpoint(Ei) || vn && Je.isMountpoint(vn))
              throw new Je.ErrnoError(10);
            if (ii !== Ot && (hn = Je.nodePermissions(Ot, "w"), hn))
              throw new Je.ErrnoError(hn);
            Je.hashRemoveNode(Ei);
            try {
              Ot.node_ops.rename(Ei, ii, wt);
            } catch (Zn) {
              throw Zn;
            } finally {
              Je.hashAddNode(Ei);
            }
          }
        }, rmdir: (Y) => {
          var oe = Je.lookupPath(Y, { parent: !0 }), we = oe.node, Pe = ln.basename(Y), et = Je.lookupNode(we, Pe), wt = Je.mayDelete(we, Pe, !0);
          if (wt)
            throw new Je.ErrnoError(wt);
          if (!we.node_ops.rmdir)
            throw new Je.ErrnoError(63);
          if (Je.isMountpoint(et))
            throw new Je.ErrnoError(10);
          we.node_ops.rmdir(we, Pe), Je.destroyNode(et);
        }, readdir: (Y) => {
          var oe = Je.lookupPath(Y, { follow: !0 }), we = oe.node;
          if (!we.node_ops.readdir)
            throw new Je.ErrnoError(54);
          return we.node_ops.readdir(we);
        }, unlink: (Y) => {
          var oe = Je.lookupPath(Y, { parent: !0 }), we = oe.node;
          if (!we)
            throw new Je.ErrnoError(44);
          var Pe = ln.basename(Y), et = Je.lookupNode(we, Pe), wt = Je.mayDelete(we, Pe, !1);
          if (wt)
            throw new Je.ErrnoError(wt);
          if (!we.node_ops.unlink)
            throw new Je.ErrnoError(63);
          if (Je.isMountpoint(et))
            throw new Je.ErrnoError(10);
          we.node_ops.unlink(we, Pe), Je.destroyNode(et);
        }, readlink: (Y) => {
          var oe = Je.lookupPath(Y), we = oe.node;
          if (!we)
            throw new Je.ErrnoError(44);
          if (!we.node_ops.readlink)
            throw new Je.ErrnoError(28);
          return os.resolve(Je.getPath(we.parent), we.node_ops.readlink(we));
        }, stat: (Y, oe) => {
          var we = Je.lookupPath(Y, { follow: !oe }), Pe = we.node;
          if (!Pe)
            throw new Je.ErrnoError(44);
          if (!Pe.node_ops.getattr)
            throw new Je.ErrnoError(63);
          return Pe.node_ops.getattr(Pe);
        }, lstat: (Y) => Je.stat(Y, !0), chmod: (Y, oe, we) => {
          var Pe;
          if (typeof Y == "string") {
            var et = Je.lookupPath(Y, { follow: !we });
            Pe = et.node;
          } else
            Pe = Y;
          if (!Pe.node_ops.setattr)
            throw new Je.ErrnoError(63);
          Pe.node_ops.setattr(Pe, { mode: oe & 4095 | Pe.mode & -4096, timestamp: Date.now() });
        }, lchmod: (Y, oe) => {
          Je.chmod(Y, oe, !0);
        }, fchmod: (Y, oe) => {
          var we = Je.getStreamChecked(Y);
          Je.chmod(we.node, oe);
        }, chown: (Y, oe, we, Pe) => {
          var et;
          if (typeof Y == "string") {
            var wt = Je.lookupPath(Y, { follow: !Pe });
            et = wt.node;
          } else
            et = Y;
          if (!et.node_ops.setattr)
            throw new Je.ErrnoError(63);
          et.node_ops.setattr(et, { timestamp: Date.now() });
        }, lchown: (Y, oe, we) => {
          Je.chown(Y, oe, we, !0);
        }, fchown: (Y, oe, we) => {
          var Pe = Je.getStreamChecked(Y);
          Je.chown(Pe.node, oe, we);
        }, truncate: (Y, oe) => {
          if (oe < 0)
            throw new Je.ErrnoError(28);
          var we;
          if (typeof Y == "string") {
            var Pe = Je.lookupPath(Y, { follow: !0 });
            we = Pe.node;
          } else
            we = Y;
          if (!we.node_ops.setattr)
            throw new Je.ErrnoError(63);
          if (Je.isDir(we.mode))
            throw new Je.ErrnoError(31);
          if (!Je.isFile(we.mode))
            throw new Je.ErrnoError(28);
          var et = Je.nodePermissions(we, "w");
          if (et)
            throw new Je.ErrnoError(et);
          we.node_ops.setattr(we, { size: oe, timestamp: Date.now() });
        }, ftruncate: (Y, oe) => {
          var we = Je.getStreamChecked(Y);
          if ((we.flags & 2097155) === 0)
            throw new Je.ErrnoError(28);
          Je.truncate(we.node, oe);
        }, utime: (Y, oe, we) => {
          var Pe = Je.lookupPath(Y, { follow: !0 }), et = Pe.node;
          et.node_ops.setattr(et, { timestamp: Math.max(oe, we) });
        }, open: (Y, oe, we) => {
          if (Y === "")
            throw new Je.ErrnoError(44);
          oe = typeof oe == "string" ? Es(oe) : oe, we = typeof we > "u" ? 438 : we, oe & 64 ? we = we & 4095 | 32768 : we = 0;
          var Pe;
          if (typeof Y == "object")
            Pe = Y;
          else {
            Y = ln.normalize(Y);
            try {
              var et = Je.lookupPath(Y, { follow: !(oe & 131072) });
              Pe = et.node;
            } catch {
            }
          }
          var wt = !1;
          if (oe & 64)
            if (Pe) {
              if (oe & 128)
                throw new Je.ErrnoError(20);
            } else
              Pe = Je.mknod(Y, we, 0), wt = !0;
          if (!Pe)
            throw new Je.ErrnoError(44);
          if (Je.isChrdev(Pe.mode) && (oe &= -513), oe & 65536 && !Je.isDir(Pe.mode))
            throw new Je.ErrnoError(54);
          if (!wt) {
            var St = Je.mayOpen(Pe, oe);
            if (St)
              throw new Je.ErrnoError(St);
          }
          oe & 512 && !wt && Je.truncate(Pe, 0), oe &= -131713;
          var Ot = Je.createStream({ node: Pe, path: Je.getPath(Pe), flags: oe, seekable: !0, position: 0, stream_ops: Pe.stream_ops, ungotten: [], error: !1 });
          return Ot.stream_ops.open && Ot.stream_ops.open(Ot), m.logReadFiles && !(oe & 1) && (Je.readFiles || (Je.readFiles = {}), Y in Je.readFiles || (Je.readFiles[Y] = 1)), Ot;
        }, close: (Y) => {
          if (Je.isClosed(Y))
            throw new Je.ErrnoError(8);
          Y.getdents && (Y.getdents = null);
          try {
            Y.stream_ops.close && Y.stream_ops.close(Y);
          } catch (oe) {
            throw oe;
          } finally {
            Je.closeStream(Y.fd);
          }
          Y.fd = null;
        }, isClosed: (Y) => Y.fd === null, llseek: (Y, oe, we) => {
          if (Je.isClosed(Y))
            throw new Je.ErrnoError(8);
          if (!Y.seekable || !Y.stream_ops.llseek)
            throw new Je.ErrnoError(70);
          if (we != 0 && we != 1 && we != 2)
            throw new Je.ErrnoError(28);
          return Y.position = Y.stream_ops.llseek(Y, oe, we), Y.ungotten = [], Y.position;
        }, read: (Y, oe, we, Pe, et) => {
          if (Pe < 0 || et < 0)
            throw new Je.ErrnoError(28);
          if (Je.isClosed(Y))
            throw new Je.ErrnoError(8);
          if ((Y.flags & 2097155) === 1)
            throw new Je.ErrnoError(8);
          if (Je.isDir(Y.node.mode))
            throw new Je.ErrnoError(31);
          if (!Y.stream_ops.read)
            throw new Je.ErrnoError(28);
          var wt = typeof et < "u";
          if (!wt)
            et = Y.position;
          else if (!Y.seekable)
            throw new Je.ErrnoError(70);
          var St = Y.stream_ops.read(Y, oe, we, Pe, et);
          return wt || (Y.position += St), St;
        }, write: (Y, oe, we, Pe, et, wt) => {
          if (Pe < 0 || et < 0)
            throw new Je.ErrnoError(28);
          if (Je.isClosed(Y))
            throw new Je.ErrnoError(8);
          if ((Y.flags & 2097155) === 0)
            throw new Je.ErrnoError(8);
          if (Je.isDir(Y.node.mode))
            throw new Je.ErrnoError(31);
          if (!Y.stream_ops.write)
            throw new Je.ErrnoError(28);
          Y.seekable && Y.flags & 1024 && Je.llseek(Y, 0, 2);
          var St = typeof et < "u";
          if (!St)
            et = Y.position;
          else if (!Y.seekable)
            throw new Je.ErrnoError(70);
          var Ot = Y.stream_ops.write(Y, oe, we, Pe, et, wt);
          return St || (Y.position += Ot), Ot;
        }, allocate: (Y, oe, we) => {
          if (Je.isClosed(Y))
            throw new Je.ErrnoError(8);
          if (oe < 0 || we <= 0)
            throw new Je.ErrnoError(28);
          if ((Y.flags & 2097155) === 0)
            throw new Je.ErrnoError(8);
          if (!Je.isFile(Y.node.mode) && !Je.isDir(Y.node.mode))
            throw new Je.ErrnoError(43);
          if (!Y.stream_ops.allocate)
            throw new Je.ErrnoError(138);
          Y.stream_ops.allocate(Y, oe, we);
        }, mmap: (Y, oe, we, Pe, et) => {
          if ((Pe & 2) !== 0 && (et & 2) === 0 && (Y.flags & 2097155) !== 2)
            throw new Je.ErrnoError(2);
          if ((Y.flags & 2097155) === 1)
            throw new Je.ErrnoError(2);
          if (!Y.stream_ops.mmap)
            throw new Je.ErrnoError(43);
          return Y.stream_ops.mmap(Y, oe, we, Pe, et);
        }, msync: (Y, oe, we, Pe, et) => Y.stream_ops.msync ? Y.stream_ops.msync(Y, oe, we, Pe, et) : 0, munmap: (Y) => 0, ioctl: (Y, oe, we) => {
          if (!Y.stream_ops.ioctl)
            throw new Je.ErrnoError(59);
          return Y.stream_ops.ioctl(Y, oe, we);
        }, readFile: (Y, oe = {}) => {
          if (oe.flags = oe.flags || 0, oe.encoding = oe.encoding || "binary", oe.encoding !== "utf8" && oe.encoding !== "binary")
            throw new Error(`Invalid encoding type "${oe.encoding}"`);
          var we, Pe = Je.open(Y, oe.flags), et = Je.stat(Y), wt = et.size, St = new Uint8Array(wt);
          return Je.read(Pe, St, 0, wt, 0), oe.encoding === "utf8" ? we = zl(St, 0) : oe.encoding === "binary" && (we = St), Je.close(Pe), we;
        }, writeFile: (Y, oe, we = {}) => {
          we.flags = we.flags || 577;
          var Pe = Je.open(Y, we.flags, we.mode);
          if (typeof oe == "string") {
            var et = new Uint8Array(jl(oe) + 1), wt = Yu(oe, et, 0, et.length);
            Je.write(Pe, et, 0, wt, void 0, we.canOwn);
          } else if (ArrayBuffer.isView(oe))
            Je.write(Pe, oe, 0, oe.byteLength, void 0, we.canOwn);
          else
            throw new Error("Unsupported data type");
          Je.close(Pe);
        }, cwd: () => Je.currentPath, chdir: (Y) => {
          var oe = Je.lookupPath(Y, { follow: !0 });
          if (oe.node === null)
            throw new Je.ErrnoError(44);
          if (!Je.isDir(oe.node.mode))
            throw new Je.ErrnoError(54);
          var we = Je.nodePermissions(oe.node, "x");
          if (we)
            throw new Je.ErrnoError(we);
          Je.currentPath = oe.path;
        }, createDefaultDirectories: () => {
          Je.mkdir("/tmp"), Je.mkdir("/home"), Je.mkdir("/home/web_user");
        }, createDefaultDevices: () => {
          Je.mkdir("/dev"), Je.registerDevice(Je.makedev(1, 3), { read: () => 0, write: (Pe, et, wt, St, Ot) => St }), Je.mkdev("/dev/null", Je.makedev(1, 3)), Gt.register(Je.makedev(5, 0), Gt.default_tty_ops), Gt.register(Je.makedev(6, 0), Gt.default_tty1_ops), Je.mkdev("/dev/tty", Je.makedev(5, 0)), Je.mkdev("/dev/tty1", Je.makedev(6, 0));
          var Y = new Uint8Array(1024), oe = 0, we = () => (oe === 0 && (oe = Bs(Y).byteLength), Y[--oe]);
          Je.createDevice("/dev", "random", we), Je.createDevice("/dev", "urandom", we), Je.mkdir("/dev/shm"), Je.mkdir("/dev/shm/tmp");
        }, createSpecialDirectories: () => {
          Je.mkdir("/proc");
          var Y = Je.mkdir("/proc/self");
          Je.mkdir("/proc/self/fd"), Je.mount({ mount: () => {
            var oe = Je.createNode(Y, "fd", 16895, 73);
            return oe.node_ops = { lookup: (we, Pe) => {
              var et = +Pe, wt = Je.getStreamChecked(et), St = { parent: null, mount: { mountpoint: "fake" }, node_ops: { readlink: () => wt.path } };
              return St.parent = St, St;
            } }, oe;
          } }, {}, "/proc/self/fd");
        }, createStandardStreams: () => {
          m.stdin ? Je.createDevice("/dev", "stdin", m.stdin) : Je.symlink("/dev/tty", "/dev/stdin"), m.stdout ? Je.createDevice("/dev", "stdout", null, m.stdout) : Je.symlink("/dev/tty", "/dev/stdout"), m.stderr ? Je.createDevice("/dev", "stderr", null, m.stderr) : Je.symlink("/dev/tty1", "/dev/stderr"), Je.open("/dev/stdin", 0), Je.open("/dev/stdout", 1), Je.open("/dev/stderr", 1);
        }, ensureErrnoError: () => {
          Je.ErrnoError || (Je.ErrnoError = function(oe, we) {
            this.name = "ErrnoError", this.node = we, this.setErrno = function(Pe) {
              this.errno = Pe;
            }, this.setErrno(oe), this.message = "FS error";
          }, Je.ErrnoError.prototype = new Error(), Je.ErrnoError.prototype.constructor = Je.ErrnoError, [44].forEach((Y) => {
            Je.genericErrors[Y] = new Je.ErrnoError(Y), Je.genericErrors[Y].stack = "<generic error, no stack>";
          }));
        }, staticInit: () => {
          Je.ensureErrnoError(), Je.nameTable = new Array(4096), Je.mount(_i, {}, "/"), Je.createDefaultDirectories(), Je.createDefaultDevices(), Je.createSpecialDirectories(), Je.filesystems = { MEMFS: _i };
        }, init: (Y, oe, we) => {
          Je.init.initialized = !0, Je.ensureErrnoError(), m.stdin = Y || m.stdin, m.stdout = oe || m.stdout, m.stderr = we || m.stderr, Je.createStandardStreams();
        }, quit: () => {
          Je.init.initialized = !1;
          for (var Y = 0; Y < Je.streams.length; Y++) {
            var oe = Je.streams[Y];
            oe && Je.close(oe);
          }
        }, findObject: (Y, oe) => {
          var we = Je.analyzePath(Y, oe);
          return we.exists ? we.object : null;
        }, analyzePath: (Y, oe) => {
          try {
            var we = Je.lookupPath(Y, { follow: !oe });
            Y = we.path;
          } catch {
          }
          var Pe = { isRoot: !1, exists: !1, error: 0, name: null, path: null, object: null, parentExists: !1, parentPath: null, parentObject: null };
          try {
            var we = Je.lookupPath(Y, { parent: !0 });
            Pe.parentExists = !0, Pe.parentPath = we.path, Pe.parentObject = we.node, Pe.name = ln.basename(Y), we = Je.lookupPath(Y, { follow: !oe }), Pe.exists = !0, Pe.path = we.path, Pe.object = we.node, Pe.name = we.node.name, Pe.isRoot = we.path === "/";
          } catch (et) {
            Pe.error = et.errno;
          }
          return Pe;
        }, createPath: (Y, oe, we, Pe) => {
          Y = typeof Y == "string" ? Y : Je.getPath(Y);
          for (var et = oe.split("/").reverse(); et.length; ) {
            var wt = et.pop();
            if (wt) {
              var St = ln.join2(Y, wt);
              try {
                Je.mkdir(St);
              } catch {
              }
              Y = St;
            }
          }
          return St;
        }, createFile: (Y, oe, we, Pe, et) => {
          var wt = ln.join2(typeof Y == "string" ? Y : Je.getPath(Y), oe), St = mr(Pe, et);
          return Je.create(wt, St);
        }, createDataFile: (Y, oe, we, Pe, et, wt) => {
          var St = oe;
          Y && (Y = typeof Y == "string" ? Y : Je.getPath(Y), St = oe ? ln.join2(Y, oe) : Y);
          var Ot = mr(Pe, et), ii = Je.create(St, Ot);
          if (we) {
            if (typeof we == "string") {
              for (var Ei = new Array(we.length), Qi = 0, vn = we.length; Qi < vn; ++Qi) Ei[Qi] = we.charCodeAt(Qi);
              we = Ei;
            }
            Je.chmod(ii, Ot | 146);
            var cn = Je.open(ii, 577);
            Je.write(cn, we, 0, we.length, 0, wt), Je.close(cn), Je.chmod(ii, Ot);
          }
          return ii;
        }, createDevice: (Y, oe, we, Pe) => {
          var et = ln.join2(typeof Y == "string" ? Y : Je.getPath(Y), oe), wt = mr(!!we, !!Pe);
          Je.createDevice.major || (Je.createDevice.major = 64);
          var St = Je.makedev(Je.createDevice.major++, 0);
          return Je.registerDevice(St, { open: (Ot) => {
            Ot.seekable = !1;
          }, close: (Ot) => {
            Pe && Pe.buffer && Pe.buffer.length && Pe(10);
          }, read: (Ot, ii, Ei, Qi, vn) => {
            for (var cn = 0, hn = 0; hn < Qi; hn++) {
              var Zn;
              try {
                Zn = we();
              } catch {
                throw new Je.ErrnoError(29);
              }
              if (Zn === void 0 && cn === 0)
                throw new Je.ErrnoError(6);
              if (Zn == null) break;
              cn++, ii[Ei + hn] = Zn;
            }
            return cn && (Ot.node.timestamp = Date.now()), cn;
          }, write: (Ot, ii, Ei, Qi, vn) => {
            for (var cn = 0; cn < Qi; cn++)
              try {
                Pe(ii[Ei + cn]);
              } catch {
                throw new Je.ErrnoError(29);
              }
            return Qi && (Ot.node.timestamp = Date.now()), cn;
          } }), Je.mkdev(et, wt, St);
        }, forceLoadFile: (Y) => {
          if (Y.isDevice || Y.isFolder || Y.link || Y.contents) return !0;
          if (typeof XMLHttpRequest < "u")
            throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");
          if (te)
            try {
              Y.contents = bd(te(Y.url), !0), Y.usedBytes = Y.contents.length;
            } catch {
              throw new Je.ErrnoError(29);
            }
          else
            throw new Error("Cannot load without read() or XMLHttpRequest.");
        }, createLazyFile: (Y, oe, we, Pe, et) => {
          function wt() {
            this.lengthKnown = !1, this.chunks = [];
          }
          if (wt.prototype.get = function(hn) {
            if (!(hn > this.length - 1 || hn < 0)) {
              var Zn = hn % this.chunkSize, Js = hn / this.chunkSize | 0;
              return this.getter(Js)[Zn];
            }
          }, wt.prototype.setDataGetter = function(hn) {
            this.getter = hn;
          }, wt.prototype.cacheLength = function() {
            var hn = new XMLHttpRequest();
            if (hn.open("HEAD", we, !1), hn.send(null), !(hn.status >= 200 && hn.status < 300 || hn.status === 304)) throw new Error("Couldn't load " + we + ". Status: " + hn.status);
            var Zn = Number(hn.getResponseHeader("Content-length")), Js, wo = (Js = hn.getResponseHeader("Accept-Ranges")) && Js === "bytes", To = (Js = hn.getResponseHeader("Content-Encoding")) && Js === "gzip", Mi = 1024 * 1024;
            wo || (Mi = Zn);
            var Dn = (sr, Yl) => {
              if (sr > Yl) throw new Error("invalid range (" + sr + ", " + Yl + ") or no bytes requested!");
              if (Yl > Zn - 1) throw new Error("only " + Zn + " bytes available! programmer error!");
              var sl = new XMLHttpRequest();
              if (sl.open("GET", we, !1), Zn !== Mi && sl.setRequestHeader("Range", "bytes=" + sr + "-" + Yl), sl.responseType = "arraybuffer", sl.overrideMimeType && sl.overrideMimeType("text/plain; charset=x-user-defined"), sl.send(null), !(sl.status >= 200 && sl.status < 300 || sl.status === 304)) throw new Error("Couldn't load " + we + ". Status: " + sl.status);
              return sl.response !== void 0 ? new Uint8Array(sl.response || []) : bd(sl.responseText || "", !0);
            }, nl = this;
            nl.setDataGetter((sr) => {
              var Yl = sr * Mi, sl = (sr + 1) * Mi - 1;
              if (sl = Math.min(sl, Zn - 1), typeof nl.chunks[sr] > "u" && (nl.chunks[sr] = Dn(Yl, sl)), typeof nl.chunks[sr] > "u") throw new Error("doXHR failed!");
              return nl.chunks[sr];
            }), (To || !Zn) && (Mi = Zn = 1, Zn = this.getter(0).length, Mi = Zn, Ae("LazyFiles on gzip forces download of the whole file when length is accessed")), this._length = Zn, this._chunkSize = Mi, this.lengthKnown = !0;
          }, typeof XMLHttpRequest < "u") {
            if (!P) throw "Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";
            var St = new wt();
            Object.defineProperties(St, { length: { get: function() {
              return this.lengthKnown || this.cacheLength(), this._length;
            } }, chunkSize: { get: function() {
              return this.lengthKnown || this.cacheLength(), this._chunkSize;
            } } });
            var Ot = { isDevice: !1, contents: St };
          } else
            var Ot = { isDevice: !1, url: we };
          var ii = Je.createFile(Y, oe, Ot, Pe, et);
          Ot.contents ? ii.contents = Ot.contents : Ot.url && (ii.contents = null, ii.url = Ot.url), Object.defineProperties(ii, { usedBytes: { get: function() {
            return this.contents.length;
          } } });
          var Ei = {}, Qi = Object.keys(ii.stream_ops);
          Qi.forEach((cn) => {
            var hn = ii.stream_ops[cn];
            Ei[cn] = function() {
              return Je.forceLoadFile(ii), hn.apply(null, arguments);
            };
          });
          function vn(cn, hn, Zn, Js, wo) {
            var To = cn.node.contents;
            if (wo >= To.length) return 0;
            var Mi = Math.min(To.length - wo, Js);
            if (To.slice)
              for (var Dn = 0; Dn < Mi; Dn++)
                hn[Zn + Dn] = To[wo + Dn];
            else
              for (var Dn = 0; Dn < Mi; Dn++)
                hn[Zn + Dn] = To.get(wo + Dn);
            return Mi;
          }
          return Ei.read = (cn, hn, Zn, Js, wo) => (Je.forceLoadFile(ii), vn(cn, hn, Zn, Js, wo)), Ei.mmap = (cn, hn, Zn, Js, wo) => {
            Je.forceLoadFile(ii);
            var To = Vi();
            if (!To)
              throw new Je.ErrnoError(48);
            return vn(cn, o(), To, hn, Zn), { ptr: To, allocated: !0 };
          }, ii.stream_ops = Ei, ii;
        } }, no = (Y, oe) => (Y >>>= 0, Y ? zl(r(), Y, oe) : ""), It = { DEFAULT_POLLMASK: 5, calculateAt: function(Y, oe, we) {
          if (ln.isAbs(oe))
            return oe;
          var Pe;
          if (Y === -100)
            Pe = Je.cwd();
          else {
            var et = It.getStreamFromFD(Y);
            Pe = et.path;
          }
          if (oe.length == 0) {
            if (!we)
              throw new Je.ErrnoError(44);
            return Pe;
          }
          return ln.join2(Pe, oe);
        }, doStat: function(Y, oe, we) {
          try {
            var Pe = Y(oe);
          } catch (Ot) {
            if (Ot && Ot.node && ln.normalize(oe) !== ln.normalize(Je.getPath(Ot.node)))
              return -54;
            throw Ot;
          }
          h()[we >>> 2] = Pe.dev, h()[we + 4 >>> 2] = Pe.mode, I()[we + 8 >>> 2] = Pe.nlink, h()[we + 12 >>> 2] = Pe.uid, h()[we + 16 >>> 2] = Pe.gid, h()[we + 20 >>> 2] = Pe.rdev, kt = [Pe.size >>> 0, (Pi = Pe.size, +Math.abs(Pi) >= 1 ? Pi > 0 ? +Math.floor(Pi / 4294967296) >>> 0 : ~~+Math.ceil((Pi - +(~~Pi >>> 0)) / 4294967296) >>> 0 : 0)], h()[we + 24 >>> 2] = kt[0], h()[we + 28 >>> 2] = kt[1], h()[we + 32 >>> 2] = 4096, h()[we + 36 >>> 2] = Pe.blocks;
          var et = Pe.atime.getTime(), wt = Pe.mtime.getTime(), St = Pe.ctime.getTime();
          return kt = [Math.floor(et / 1e3) >>> 0, (Pi = Math.floor(et / 1e3), +Math.abs(Pi) >= 1 ? Pi > 0 ? +Math.floor(Pi / 4294967296) >>> 0 : ~~+Math.ceil((Pi - +(~~Pi >>> 0)) / 4294967296) >>> 0 : 0)], h()[we + 40 >>> 2] = kt[0], h()[we + 44 >>> 2] = kt[1], I()[we + 48 >>> 2] = et % 1e3 * 1e3, kt = [Math.floor(wt / 1e3) >>> 0, (Pi = Math.floor(wt / 1e3), +Math.abs(Pi) >= 1 ? Pi > 0 ? +Math.floor(Pi / 4294967296) >>> 0 : ~~+Math.ceil((Pi - +(~~Pi >>> 0)) / 4294967296) >>> 0 : 0)], h()[we + 56 >>> 2] = kt[0], h()[we + 60 >>> 2] = kt[1], I()[we + 64 >>> 2] = wt % 1e3 * 1e3, kt = [Math.floor(St / 1e3) >>> 0, (Pi = Math.floor(St / 1e3), +Math.abs(Pi) >= 1 ? Pi > 0 ? +Math.floor(Pi / 4294967296) >>> 0 : ~~+Math.ceil((Pi - +(~~Pi >>> 0)) / 4294967296) >>> 0 : 0)], h()[we + 72 >>> 2] = kt[0], h()[we + 76 >>> 2] = kt[1], I()[we + 80 >>> 2] = St % 1e3 * 1e3, kt = [Pe.ino >>> 0, (Pi = Pe.ino, +Math.abs(Pi) >= 1 ? Pi > 0 ? +Math.floor(Pi / 4294967296) >>> 0 : ~~+Math.ceil((Pi - +(~~Pi >>> 0)) / 4294967296) >>> 0 : 0)], h()[we + 88 >>> 2] = kt[0], h()[we + 92 >>> 2] = kt[1], 0;
        }, doMsync: function(Y, oe, we, Pe, et) {
          if (!Je.isFile(oe.node.mode))
            throw new Je.ErrnoError(43);
          if (Pe & 2)
            return 0;
          var wt = r().slice(Y, Y + we);
          Je.msync(oe, wt, et, we, Pe);
        }, varargs: void 0, get() {
          It.varargs += 4;
          var Y = h()[It.varargs - 4 >>> 2];
          return Y;
        }, getStr(Y) {
          var oe = no(Y);
          return oe;
        }, getStreamFromFD: function(Y) {
          var oe = Je.getStreamChecked(Y);
          return oe;
        } };
        function Qt(Y) {
          if (W) return Xi(1, 1, Y);
          ze = Y, ft() || (Si.terminateAllThreads(), m.onExit && m.onExit(Y), Rt = !0), F(Y, new sn(Y));
        }
        var ci = (Y, oe) => {
          if (ze = Y, W)
            throw Nn(Y), "unwind";
          Qt(Y);
        }, ai = ci, ei = (Y) => {
          if (Y instanceof sn || Y == "unwind")
            return ze;
          F(1, Y);
        }, Si = { unusedWorkers: [], runningWorkers: [], tlsInitFunctions: [], pthreads: {}, init: function() {
          W ? Si.initWorker() : Si.initMainThread();
        }, initMainThread: function() {
          for (var Y = navigator.hardwareConcurrency; Y--; )
            Si.allocateUnusedWorker();
          Jt(() => {
            Ut(), Si.loadWasmModuleToAllWorkers(() => Ht());
          });
        }, initWorker: function() {
          je = !1;
        }, setExitStatus: function(Y) {
          ze = Y;
        }, terminateAllThreads__deps: ["$terminateWorker"], terminateAllThreads: function() {
          for (var Y of Si.runningWorkers)
            Fi(Y);
          for (var Y of Si.unusedWorkers)
            Fi(Y);
          Si.unusedWorkers = [], Si.runningWorkers = [], Si.pthreads = [];
        }, returnWorkerToPool: function(Y) {
          var oe = Y.pthread_ptr;
          delete Si.pthreads[oe], Si.unusedWorkers.push(Y), Si.runningWorkers.splice(Si.runningWorkers.indexOf(Y), 1), Y.pthread_ptr = 0, Zg(oe);
        }, receiveObjectTransfer: function(Y) {
        }, threadInitTLS: function() {
          Si.tlsInitFunctions.forEach((Y) => Y());
        }, loadWasmModuleToWorker: (Y) => new Promise((oe) => {
          Y.onmessage = (wt) => {
            var St = wt.data, Ot = St.cmd;
            if (St.targetThread && St.targetThread != EE()) {
              var ii = Si.pthreads[St.targetThread];
              ii ? ii.postMessage(St, St.transferList) : Oe('Internal error! Worker sent a message "' + Ot + '" to target pthread ' + St.targetThread + ", but that thread no longer exists!");
              return;
            }
            Ot === "checkMailbox" ? Ff() : Ot === "spawnThread" ? bn(St) : Ot === "cleanupThread" ? yi(St.thread) : Ot === "killThread" ? tn(St.thread) : Ot === "cancelThread" ? Gi(St.thread) : Ot === "loaded" ? (Y.loaded = !0, oe(Y)) : Ot === "alert" ? alert("Thread " + St.threadId + ": " + St.text) : St.target === "setimmediate" ? Y.postMessage(St) : Ot === "callHandler" ? m[St.handler](...St.args) : Ot && Oe("worker sent an unknown command " + Ot);
          }, Y.onerror = (wt) => {
            var St = "worker sent an error!";
            throw Oe(St + " " + wt.filename + ":" + wt.lineno + ": " + wt.message), wt;
          };
          var we = [], Pe = ["onExit", "onAbort", "print", "printErr"];
          for (var et of Pe)
            m.hasOwnProperty(et) && we.push(et);
          Y.postMessage({ cmd: "load", handlers: we, urlOrBlob: m.mainScriptUrlOrBlob || n, wasmMemory: Ve, wasmModule: vt });
        }), loadWasmModuleToAllWorkers: function(Y) {
          if (W)
            return Y();
          Promise.all(Si.unusedWorkers.map(Si.loadWasmModuleToWorker)).then(Y);
        }, allocateUnusedWorker: function() {
          var Y, oe = ce("web-ifc-mt.worker.js");
          Y = new Worker(oe), Si.unusedWorkers.push(Y);
        }, getNewWorker: function() {
          return Si.unusedWorkers.length == 0 && (Si.allocateUnusedWorker(), Si.loadWasmModuleToWorker(Si.unusedWorkers[0])), Si.unusedWorkers.pop();
        } };
        m.PThread = Si;
        var mn = (Y) => {
          for (; Y.length > 0; )
            Y.shift()(m);
        };
        function wn() {
          var Y = EE(), oe = h()[Y + 52 >>> 2], we = h()[Y + 56 >>> 2], Pe = oe - we;
          F4(oe, Pe), Jg(oe);
        }
        m.establishStackSpace = wn;
        function Nn(Y) {
          if (W) return Xi(2, 0, Y);
          ai(Y);
        }
        var Kn = [], is = (Y) => {
          var oe = Kn[Y];
          return oe || (Y >= Kn.length && (Kn.length = Y + 1), Kn[Y] = oe = ni.get(Y)), oe;
        };
        function jn(Y, oe) {
          var we = is(Y)(oe);
          function Pe(et) {
            ft() ? Si.setExitStatus(et) : Qg(et);
          }
          Pe(we);
        }
        m.invokeEntryPoint = jn;
        function _s(Y) {
          Si.tlsInitFunctions.push(Y);
        }
        function yo(Y) {
          this.excPtr = Y, this.ptr = Y - 24, this.set_type = function(oe) {
            I()[this.ptr + 4 >>> 2] = oe;
          }, this.get_type = function() {
            return I()[this.ptr + 4 >>> 2];
          }, this.set_destructor = function(oe) {
            I()[this.ptr + 8 >>> 2] = oe;
          }, this.get_destructor = function() {
            return I()[this.ptr + 8 >>> 2];
          }, this.set_caught = function(oe) {
            oe = oe ? 1 : 0, o()[this.ptr + 12 >>> 0] = oe;
          }, this.get_caught = function() {
            return o()[this.ptr + 12 >>> 0] != 0;
          }, this.set_rethrown = function(oe) {
            oe = oe ? 1 : 0, o()[this.ptr + 13 >>> 0] = oe;
          }, this.get_rethrown = function() {
            return o()[this.ptr + 13 >>> 0] != 0;
          }, this.init = function(oe, we) {
            this.set_adjusted_ptr(0), this.set_type(oe), this.set_destructor(we);
          }, this.set_adjusted_ptr = function(oe) {
            I()[this.ptr + 16 >>> 2] = oe;
          }, this.get_adjusted_ptr = function() {
            return I()[this.ptr + 16 >>> 2];
          }, this.get_exception_ptr = function() {
            var oe = k4(this.get_type());
            if (oe)
              return I()[this.excPtr >>> 2];
            var we = this.get_adjusted_ptr();
            return we !== 0 ? we : this.excPtr;
          };
        }
        var Qo = 0;
        function so(Y, oe) {
          return oe + 2097152 >>> 0 < 4194305 - !!Y ? (Y >>> 0) + oe * 4294967296 : NaN;
        }
        function Eo(Y, oe, we) {
          Y >>>= 0, oe >>>= 0, we >>>= 0;
          var Pe = new yo(Y);
          throw Pe.init(oe, we), Qo = Y, Qo;
        }
        function Yn(Y) {
          Y >>>= 0, M4(Y, !P, 1, !L, 5242880, !1), Si.threadInitTLS();
        }
        function Jo(Y) {
          Y >>>= 0, W ? postMessage({ cmd: "cleanupThread", thread: Y }) : yi(Y);
        }
        var xs = {};
        function Gr(Y) {
          for (; Y.length; ) {
            var oe = Y.pop(), we = Y.pop();
            we(oe);
          }
        }
        function sa(Y) {
          return this.fromWireType(h()[Y >>> 2]);
        }
        var yr = {}, nr = {}, Ws = {}, ul = void 0;
        function ur(Y) {
          throw new ul(Y);
        }
        function ao(Y, oe, we) {
          Y.forEach(function(Ot) {
            Ws[Ot] = oe;
          });
          function Pe(Ot) {
            var ii = we(Ot);
            ii.length !== Y.length && ur("Mismatched type converter count");
            for (var Ei = 0; Ei < Y.length; ++Ei)
              la(Y[Ei], ii[Ei]);
          }
          var et = new Array(oe.length), wt = [], St = 0;
          oe.forEach((Ot, ii) => {
            nr.hasOwnProperty(Ot) ? et[ii] = nr[Ot] : (wt.push(Ot), yr.hasOwnProperty(Ot) || (yr[Ot] = []), yr[Ot].push(() => {
              et[ii] = nr[Ot], ++St, St === wt.length && Pe(et);
            }));
          }), wt.length === 0 && Pe(et);
        }
        function kr(Y) {
          Y >>>= 0;
          var oe = xs[Y];
          delete xs[Y];
          var we = oe.elements, Pe = we.length, et = we.map(function(Ot) {
            return Ot.getterReturnType;
          }).concat(we.map(function(Ot) {
            return Ot.setterArgumentType;
          })), wt = oe.rawConstructor, St = oe.rawDestructor;
          ao([Y], et, function(Ot) {
            return we.forEach((ii, Ei) => {
              var Qi = Ot[Ei], vn = ii.getter, cn = ii.getterContext, hn = Ot[Ei + Pe], Zn = ii.setter, Js = ii.setterContext;
              ii.read = (wo) => Qi.fromWireType(vn(cn, wo)), ii.write = (wo, To) => {
                var Mi = [];
                Zn(Js, wo, hn.toWireType(Mi, To)), Gr(Mi);
              };
            }), [{ name: oe.name, fromWireType: function(ii) {
              for (var Ei = new Array(Pe), Qi = 0; Qi < Pe; ++Qi)
                Ei[Qi] = we[Qi].read(ii);
              return St(ii), Ei;
            }, toWireType: function(ii, Ei) {
              if (Pe !== Ei.length)
                throw new TypeError(`Incorrect number of tuple elements for ${oe.name}: expected=${Pe}, actual=${Ei.length}`);
              for (var Qi = wt(), vn = 0; vn < Pe; ++vn)
                we[vn].write(Qi, Ei[vn]);
              return ii !== null && ii.push(St, Qi), Qi;
            }, argPackAdvance: 8, readValueFromPointer: sa, destructorFunction: St }];
          });
        }
        var oa = {}, Po = function(Y) {
          Y >>>= 0;
          var oe = oa[Y];
          delete oa[Y];
          var we = oe.rawConstructor, Pe = oe.rawDestructor, et = oe.fields, wt = et.map((St) => St.getterReturnType).concat(et.map((St) => St.setterArgumentType));
          ao([Y], wt, (St) => {
            var Ot = {};
            return et.forEach((ii, Ei) => {
              var Qi = ii.fieldName, vn = St[Ei], cn = ii.getter, hn = ii.getterContext, Zn = St[Ei + et.length], Js = ii.setter, wo = ii.setterContext;
              Ot[Qi] = { read: (To) => vn.fromWireType(cn(hn, To)), write: (To, Mi) => {
                var Dn = [];
                Js(wo, To, Zn.toWireType(Dn, Mi)), Gr(Dn);
              } };
            }), [{ name: oe.name, fromWireType: function(ii) {
              var Ei = {};
              for (var Qi in Ot)
                Ei[Qi] = Ot[Qi].read(ii);
              return Pe(ii), Ei;
            }, toWireType: function(ii, Ei) {
              for (var Qi in Ot)
                if (!(Qi in Ei))
                  throw new TypeError(`Missing field: "${Qi}"`);
              var vn = we();
              for (Qi in Ot)
                Ot[Qi].write(vn, Ei[Qi]);
              return ii !== null && ii.push(Pe, vn), vn;
            }, argPackAdvance: 8, readValueFromPointer: sa, destructorFunction: Pe }];
          });
        };
        function NI(Y, oe, we, Pe, et) {
        }
        function Tc(Y) {
          switch (Y) {
            case 1:
              return 0;
            case 2:
              return 1;
            case 4:
              return 2;
            case 8:
              return 3;
            default:
              throw new TypeError(`Unknown type size: ${Y}`);
          }
        }
        function bf() {
          for (var Y = new Array(256), oe = 0; oe < 256; ++oe)
            Y[oe] = String.fromCharCode(oe);
          Rc = Y;
        }
        var Rc = void 0;
        function Sr(Y) {
          for (var oe = "", we = Y; r()[we >>> 0]; )
            oe += Rc[r()[we++ >>> 0]];
          return oe;
        }
        var ra = void 0;
        function Ls(Y) {
          throw new ra(Y);
        }
        function vc(Y, oe, we = {}) {
          var Pe = oe.name;
          if (Y || Ls(`type "${Pe}" must have a positive integer typeid pointer`), nr.hasOwnProperty(Y)) {
            if (we.ignoreDuplicateRegistrations)
              return;
            Ls(`Cannot register type '${Pe}' twice`);
          }
          if (nr[Y] = oe, delete Ws[Y], yr.hasOwnProperty(Y)) {
            var et = yr[Y];
            delete yr[Y], et.forEach((wt) => wt());
          }
        }
        function la(Y, oe, we = {}) {
          if (!("argPackAdvance" in oe))
            throw new TypeError("registerType registeredInstance requires argPackAdvance");
          return vc(Y, oe, we);
        }
        function Nf(Y, oe, we, Pe, et) {
          Y >>>= 0, oe >>>= 0, we >>>= 0;
          var wt = Tc(we);
          oe = Sr(oe), la(Y, { name: oe, fromWireType: function(St) {
            return !!St;
          }, toWireType: function(St, Ot) {
            return Ot ? Pe : et;
          }, argPackAdvance: 8, readValueFromPointer: function(St) {
            var Ot;
            if (we === 1)
              Ot = o();
            else if (we === 2)
              Ot = l();
            else if (we === 4)
              Ot = h();
            else
              throw new TypeError("Unknown boolean type size: " + oe);
            return this.fromWireType(Ot[St >>> wt]);
          }, destructorFunction: null });
        }
        function DI(Y) {
          if (!(this instanceof aa) || !(Y instanceof aa))
            return !1;
          for (var oe = this.$$.ptrType.registeredClass, we = this.$$.ptr, Pe = Y.$$.ptrType.registeredClass, et = Y.$$.ptr; oe.baseClass; )
            we = oe.upcast(we), oe = oe.baseClass;
          for (; Pe.baseClass; )
            et = Pe.upcast(et), Pe = Pe.baseClass;
          return oe === Pe && we === et;
        }
        function Df(Y) {
          return { count: Y.count, deleteScheduled: Y.deleteScheduled, preservePointerOnDelete: Y.preservePointerOnDelete, ptr: Y.ptr, ptrType: Y.ptrType, smartPtr: Y.smartPtr, smartPtrType: Y.smartPtrType };
        }
        function dl(Y) {
          function oe(we) {
            return we.$$.ptrType.registeredClass.name;
          }
          Ls(oe(Y) + " instance already deleted");
        }
        var Ac = !1;
        function Sc(Y) {
        }
        function CI(Y) {
          Y.smartPtr ? Y.smartPtrType.rawDestructor(Y.smartPtr) : Y.ptrType.registeredClass.rawDestructor(Y.ptr);
        }
        function go(Y) {
          Y.count.value -= 1;
          var oe = Y.count.value === 0;
          oe && CI(Y);
        }
        function Cf(Y, oe, we) {
          if (oe === we)
            return Y;
          if (we.baseClass === void 0)
            return null;
          var Pe = Cf(Y, oe, we.baseClass);
          return Pe === null ? null : we.downcast(Pe);
        }
        var bc = {};
        function OI() {
          return Object.keys(Pn).length;
        }
        function Of() {
          var Y = [];
          for (var oe in Pn)
            Pn.hasOwnProperty(oe) && Y.push(Pn[oe]);
          return Y;
        }
        var xt = [];
        function li() {
          for (; xt.length; ) {
            var Y = xt.pop();
            Y.$$.deleteScheduled = !1, Y.delete();
          }
        }
        var qi = void 0;
        function un(Y) {
          qi = Y, xt.length && qi && qi(li);
        }
        function Mn() {
          m.getInheritedInstanceCount = OI, m.getLiveInheritedInstances = Of, m.flushPendingDeletes = li, m.setDelayFunction = un;
        }
        var Pn = {};
        function ws(Y, oe) {
          for (oe === void 0 && Ls("ptr should not be undefined"); Y.baseClass; )
            oe = Y.upcast(oe), Y = Y.baseClass;
          return oe;
        }
        function Ys(Y, oe) {
          return oe = ws(Y, oe), Pn[oe];
        }
        function Ss(Y, oe) {
          (!oe.ptrType || !oe.ptr) && ur("makeClassHandle requires ptr and ptrType");
          var we = !!oe.smartPtrType, Pe = !!oe.smartPtr;
          return we !== Pe && ur("Both smartPtrType and smartPtr must be specified"), oe.count = { value: 1 }, Vr(Object.create(Y, { $$: { value: oe } }));
        }
        function dr(Y) {
          var oe = this.getPointee(Y);
          if (!oe)
            return this.destructor(Y), null;
          var we = Ys(this.registeredClass, oe);
          if (we !== void 0) {
            if (we.$$.count.value === 0)
              return we.$$.ptr = oe, we.$$.smartPtr = Y, we.clone();
            var Pe = we.clone();
            return this.destructor(Y), Pe;
          }
          function et() {
            return this.isSmartPointer ? Ss(this.registeredClass.instancePrototype, { ptrType: this.pointeeType, ptr: oe, smartPtrType: this, smartPtr: Y }) : Ss(this.registeredClass.instancePrototype, { ptrType: this, ptr: Y });
          }
          var wt = this.registeredClass.getActualType(oe), St = bc[wt];
          if (!St)
            return et.call(this);
          var Ot;
          this.isConst ? Ot = St.constPointerType : Ot = St.pointerType;
          var ii = Cf(oe, this.registeredClass, Ot.registeredClass);
          return ii === null ? et.call(this) : this.isSmartPointer ? Ss(Ot.registeredClass.instancePrototype, { ptrType: Ot, ptr: ii, smartPtrType: this, smartPtr: Y }) : Ss(Ot.registeredClass.instancePrototype, { ptrType: Ot, ptr: ii });
        }
        var Vr = function(Y) {
          return typeof FinalizationRegistry > "u" ? (Vr = (oe) => oe, Y) : (Ac = new FinalizationRegistry((oe) => {
            go(oe.$$);
          }), Vr = (oe) => {
            var we = oe.$$, Pe = !!we.smartPtr;
            if (Pe) {
              var et = { $$: we };
              Ac.register(oe, et, oe);
            }
            return oe;
          }, Sc = (oe) => Ac.unregister(oe), Vr(Y));
        };
        function _l() {
          if (this.$$.ptr || dl(this), this.$$.preservePointerOnDelete)
            return this.$$.count.value += 1, this;
          var Y = Vr(Object.create(Object.getPrototypeOf(this), { $$: { value: Df(this.$$) } }));
          return Y.$$.count.value += 1, Y.$$.deleteScheduled = !1, Y;
        }
        function p0() {
          this.$$.ptr || dl(this), this.$$.deleteScheduled && !this.$$.preservePointerOnDelete && Ls("Object already scheduled for deletion"), Sc(this), go(this.$$), this.$$.preservePointerOnDelete || (this.$$.smartPtr = void 0, this.$$.ptr = void 0);
        }
        function Lf() {
          return !this.$$.ptr;
        }
        function _f() {
          return this.$$.ptr || dl(this), this.$$.deleteScheduled && !this.$$.preservePointerOnDelete && Ls("Object already scheduled for deletion"), xt.push(this), xt.length === 1 && qi && qi(li), this.$$.deleteScheduled = !0, this;
        }
        function xf() {
          aa.prototype.isAliasOf = DI, aa.prototype.clone = _l, aa.prototype.delete = p0, aa.prototype.isDeleted = Lf, aa.prototype.deleteLater = _f;
        }
        function aa() {
        }
        var Ih = 48, ph = 57;
        function m0(Y) {
          if (Y === void 0)
            return "_unknown";
          Y = Y.replace(/[^a-zA-Z0-9_]/g, "$");
          var oe = Y.charCodeAt(0);
          return oe >= Ih && oe <= ph ? `_${Y}` : Y;
        }
        function Nc(Y, oe) {
          return Y = m0(Y), { [Y]: function() {
            return oe.apply(this, arguments);
          } }[Y];
        }
        function Nd(Y, oe, we) {
          if (Y[oe].overloadTable === void 0) {
            var Pe = Y[oe];
            Y[oe] = function() {
              return Y[oe].overloadTable.hasOwnProperty(arguments.length) || Ls(`Function '${we}' called with an invalid number of arguments (${arguments.length}) - expects one of (${Y[oe].overloadTable})!`), Y[oe].overloadTable[arguments.length].apply(this, arguments);
            }, Y[oe].overloadTable = [], Y[oe].overloadTable[Pe.argCount] = Pe;
          }
        }
        function Dd(Y, oe, we) {
          m.hasOwnProperty(Y) ? ((we === void 0 || m[Y].overloadTable !== void 0 && m[Y].overloadTable[we] !== void 0) && Ls(`Cannot register public name '${Y}' twice`), Nd(m, Y, Y), m.hasOwnProperty(we) && Ls(`Cannot register multiple overloads of a function with the same number of arguments (${we})!`), m[Y].overloadTable[we] = oe) : (m[Y] = oe, we !== void 0 && (m[Y].numArguments = we));
        }
        function Dc(Y, oe, we, Pe, et, wt, St, Ot) {
          this.name = Y, this.constructor = oe, this.instancePrototype = we, this.rawDestructor = Pe, this.baseClass = et, this.getActualType = wt, this.upcast = St, this.downcast = Ot, this.pureVirtualFunctions = [];
        }
        function Cc(Y, oe, we) {
          for (; oe !== we; )
            oe.upcast || Ls(`Expected null or instance of ${we.name}, got an instance of ${oe.name}`), Y = oe.upcast(Y), oe = oe.baseClass;
          return Y;
        }
        function mh(Y, oe) {
          if (oe === null)
            return this.isReference && Ls(`null is not a valid ${this.name}`), 0;
          oe.$$ || Ls(`Cannot pass "${_I(oe)}" as a ${this.name}`), oe.$$.ptr || Ls(`Cannot pass deleted object as a pointer of type ${this.name}`);
          var we = oe.$$.ptrType.registeredClass, Pe = Cc(oe.$$.ptr, we, this.registeredClass);
          return Pe;
        }
        function Go(Y, oe) {
          var we;
          if (oe === null)
            return this.isReference && Ls(`null is not a valid ${this.name}`), this.isSmartPointer ? (we = this.rawConstructor(), Y !== null && Y.push(this.rawDestructor, we), we) : 0;
          oe.$$ || Ls(`Cannot pass "${_I(oe)}" as a ${this.name}`), oe.$$.ptr || Ls(`Cannot pass deleted object as a pointer of type ${this.name}`), !this.isConst && oe.$$.ptrType.isConst && Ls(`Cannot convert argument of type ${oe.$$.smartPtrType ? oe.$$.smartPtrType.name : oe.$$.ptrType.name} to parameter type ${this.name}`);
          var Pe = oe.$$.ptrType.registeredClass;
          if (we = Cc(oe.$$.ptr, Pe, this.registeredClass), this.isSmartPointer)
            switch (oe.$$.smartPtr === void 0 && Ls("Passing raw pointer to smart pointer is illegal"), this.sharingPolicy) {
              case 0:
                oe.$$.smartPtrType === this ? we = oe.$$.smartPtr : Ls(`Cannot convert argument of type ${oe.$$.smartPtrType ? oe.$$.smartPtrType.name : oe.$$.ptrType.name} to parameter type ${this.name}`);
                break;
              case 1:
                we = oe.$$.smartPtr;
                break;
              case 2:
                if (oe.$$.smartPtrType === this)
                  we = oe.$$.smartPtr;
                else {
                  var et = oe.clone();
                  we = this.rawShare(we, ko.toHandle(function() {
                    et.delete();
                  })), Y !== null && Y.push(this.rawDestructor, we);
                }
                break;
              default:
                Ls("Unsupporting sharing policy");
            }
          return we;
        }
        function Oc(Y, oe) {
          if (oe === null)
            return this.isReference && Ls(`null is not a valid ${this.name}`), 0;
          oe.$$ || Ls(`Cannot pass "${_I(oe)}" as a ${this.name}`), oe.$$.ptr || Ls(`Cannot pass deleted object as a pointer of type ${this.name}`), oe.$$.ptrType.isConst && Ls(`Cannot convert argument of type ${oe.$$.ptrType.name} to parameter type ${this.name}`);
          var we = oe.$$.ptrType.registeredClass, Pe = Cc(oe.$$.ptr, we, this.registeredClass);
          return Pe;
        }
        function Lc(Y) {
          return this.rawGetPointee && (Y = this.rawGetPointee(Y)), Y;
        }
        function _c(Y) {
          this.rawDestructor && this.rawDestructor(Y);
        }
        function xc(Y) {
          Y !== null && Y.delete();
        }
        function Cd() {
          xl.prototype.getPointee = Lc, xl.prototype.destructor = _c, xl.prototype.argPackAdvance = 8, xl.prototype.readValueFromPointer = sa, xl.prototype.deleteObject = xc, xl.prototype.fromWireType = dr;
        }
        function xl(Y, oe, we, Pe, et, wt, St, Ot, ii, Ei, Qi) {
          this.name = Y, this.registeredClass = oe, this.isReference = we, this.isConst = Pe, this.isSmartPointer = et, this.pointeeType = wt, this.sharingPolicy = St, this.rawGetPointee = Ot, this.rawConstructor = ii, this.rawShare = Ei, this.rawDestructor = Qi, !et && oe.baseClass === void 0 ? Pe ? (this.toWireType = mh, this.destructorFunction = null) : (this.toWireType = Oc, this.destructorFunction = null) : this.toWireType = Go;
        }
        function yh(Y, oe, we) {
          m.hasOwnProperty(Y) || ur("Replacing nonexistant public symbol"), m[Y].overloadTable !== void 0 && we !== void 0 ? m[Y].overloadTable[we] = oe : (m[Y] = oe, m[Y].argCount = we);
        }
        var Eh = (Y, oe, we) => {
          var Pe = m["dynCall_" + Y];
          return we && we.length ? Pe.apply(null, [oe].concat(we)) : Pe.call(null, oe);
        }, LI = (Y, oe, we) => {
          if (Y.includes("j"))
            return Eh(Y, oe, we);
          var Pe = is(oe).apply(null, we);
          return Pe;
        }, Pf = (Y, oe) => {
          var we = [];
          return function() {
            return we.length = 0, Object.assign(we, arguments), LI(Y, oe, we);
          };
        };
        function Bi(Y, oe) {
          Y = Sr(Y);
          function we() {
            return Y.includes("j") ? Pf(Y, oe) : is(oe);
          }
          var Pe = we();
          return typeof Pe != "function" && Ls(`unknown function pointer with signature ${Y}: ${oe}`), Pe;
        }
        function qu(Y, oe) {
          var we = Nc(oe, function(Pe) {
            this.name = oe, this.message = Pe;
            var et = new Error(Pe).stack;
            et !== void 0 && (this.stack = this.toString() + `
` + et.replace(/^Error(:[^\n]*)?\n/, ""));
          });
          return we.prototype = Object.create(Y.prototype), we.prototype.constructor = we, we.prototype.toString = function() {
            return this.message === void 0 ? this.name : `${this.name}: ${this.message}`;
          }, we;
        }
        var Ru = void 0;
        function Pc(Y) {
          var oe = P4(Y), we = Sr(oe);
          return Th(oe), we;
        }
        function Od(Y, oe) {
          var we = [], Pe = {};
          function et(wt) {
            if (!Pe[wt] && !nr[wt]) {
              if (Ws[wt]) {
                Ws[wt].forEach(et);
                return;
              }
              we.push(wt), Pe[wt] = !0;
            }
          }
          throw oe.forEach(et), new Ru(`${Y}: ` + we.map(Pc).join([", "]));
        }
        function gh(Y, oe, we, Pe, et, wt, St, Ot, ii, Ei, Qi, vn, cn) {
          Y >>>= 0, oe >>>= 0, we >>>= 0, Pe >>>= 0, et >>>= 0, wt >>>= 0, St >>>= 0, Ot >>>= 0, ii >>>= 0, Ei >>>= 0, Qi >>>= 0, vn >>>= 0, cn >>>= 0, Qi = Sr(Qi), wt = Bi(et, wt), Ot && (Ot = Bi(St, Ot)), Ei && (Ei = Bi(ii, Ei)), cn = Bi(vn, cn);
          var hn = m0(Qi);
          Dd(hn, function() {
            Od(`Cannot construct ${Qi} due to unbound types`, [Pe]);
          }), ao([Y, oe, we], Pe ? [Pe] : [], function(Zn) {
            Zn = Zn[0];
            var Js, wo;
            Pe ? (Js = Zn.registeredClass, wo = Js.instancePrototype) : wo = aa.prototype;
            var To = Nc(hn, function() {
              if (Object.getPrototypeOf(this) !== Mi)
                throw new ra("Use 'new' to construct " + Qi);
              if (Dn.constructor_body === void 0)
                throw new ra(Qi + " has no accessible constructor");
              var sl = Dn.constructor_body[arguments.length];
              if (sl === void 0)
                throw new ra(`Tried to invoke ctor of ${Qi} with invalid number of parameters (${arguments.length}) - expected (${Object.keys(Dn.constructor_body).toString()}) parameters instead!`);
              return sl.apply(this, arguments);
            }), Mi = Object.create(wo, { constructor: { value: To } });
            To.prototype = Mi;
            var Dn = new Dc(Qi, To, Mi, cn, Js, wt, Ot, Ei);
            Dn.baseClass && (Dn.baseClass.__derivedClasses === void 0 && (Dn.baseClass.__derivedClasses = []), Dn.baseClass.__derivedClasses.push(Dn));
            var nl = new xl(Qi, Dn, !0, !1, !1), sr = new xl(Qi + "*", Dn, !1, !1, !1), Yl = new xl(Qi + " const*", Dn, !1, !0, !1);
            return bc[Y] = { pointerType: sr, constPointerType: Yl }, yh(hn, To), [nl, sr, Yl];
          });
        }
        function Mc(Y, oe) {
          for (var we = [], Pe = 0; Pe < Y; Pe++)
            we.push(I()[oe + Pe * 4 >>> 2]);
          return we;
        }
        function Uc(Y, oe) {
          if (!(Y instanceof Function))
            throw new TypeError(`new_ called with constructor type ${typeof Y} which is not a function`);
          var we = Nc(Y.name || "unknownFunctionName", function() {
          });
          we.prototype = Y.prototype;
          var Pe = new we(), et = Y.apply(Pe, oe);
          return et instanceof Object ? et : Pe;
        }
        function $u(Y, oe, we, Pe, et, wt) {
          var St = oe.length;
          St < 2 && Ls("argTypes array size mismatch! Must at least get return value and 'this' types!");
          for (var Ot = oe[1] !== null && we !== null, ii = !1, Ei = 1; Ei < oe.length; ++Ei)
            if (oe[Ei] !== null && oe[Ei].destructorFunction === void 0) {
              ii = !0;
              break;
            }
          for (var Qi = oe[0].name !== "void", vn = "", cn = "", Ei = 0; Ei < St - 2; ++Ei)
            vn += (Ei !== 0 ? ", " : "") + "arg" + Ei, cn += (Ei !== 0 ? ", " : "") + "arg" + Ei + "Wired";
          var hn = `
        return function ${m0(Y)}(${vn}) {
        if (arguments.length !== ${St - 2}) {
          throwBindingError('function ${Y} called with ${arguments.length} arguments, expected ${St - 2} args!');
        }`;
          ii && (hn += `var destructors = [];
`);
          var Zn = ii ? "destructors" : "null", Js = ["throwBindingError", "invoker", "fn", "runDestructors", "retType", "classParam"], wo = [Ls, Pe, et, Gr, oe[0], oe[1]];
          Ot && (hn += "var thisWired = classParam.toWireType(" + Zn + `, this);
`);
          for (var Ei = 0; Ei < St - 2; ++Ei)
            hn += "var arg" + Ei + "Wired = argType" + Ei + ".toWireType(" + Zn + ", arg" + Ei + "); // " + oe[Ei + 2].name + `
`, Js.push("argType" + Ei), wo.push(oe[Ei + 2]);
          if (Ot && (cn = "thisWired" + (cn.length > 0 ? ", " : "") + cn), hn += (Qi || wt ? "var rv = " : "") + "invoker(fn" + (cn.length > 0 ? ", " : "") + cn + `);
`, ii)
            hn += `runDestructors(destructors);
`;
          else
            for (var Ei = Ot ? 1 : 2; Ei < oe.length; ++Ei) {
              var To = Ei === 1 ? "thisWired" : "arg" + (Ei - 2) + "Wired";
              oe[Ei].destructorFunction !== null && (hn += To + "_dtor(" + To + "); // " + oe[Ei].name + `
`, Js.push(To + "_dtor"), wo.push(oe[Ei].destructorFunction));
            }
          return Qi && (hn += `var ret = retType.fromWireType(rv);
return ret;
`), hn += `}
`, Js.push(hn), Uc(Function, Js).apply(null, wo);
        }
        function ua(Y, oe, we, Pe, et, wt) {
          Y >>>= 0, we >>>= 0, Pe >>>= 0, et >>>= 0, wt >>>= 0;
          var St = Mc(oe, we);
          et = Bi(Pe, et), ao([], [Y], function(Ot) {
            Ot = Ot[0];
            var ii = `constructor ${Ot.name}`;
            if (Ot.registeredClass.constructor_body === void 0 && (Ot.registeredClass.constructor_body = []), Ot.registeredClass.constructor_body[oe - 1] !== void 0)
              throw new ra(`Cannot register multiple constructors with identical number of parameters (${oe - 1}) for class '${Ot.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
            return Ot.registeredClass.constructor_body[oe - 1] = () => {
              Od(`Cannot construct ${Ot.name} due to unbound types`, St);
            }, ao([], St, function(Ei) {
              return Ei.splice(1, 0, null), Ot.registeredClass.constructor_body[oe - 1] = $u(ii, Ei, null, et, wt), [];
            }), [];
          });
        }
        function Bc(Y, oe, we, Pe, et, wt, St, Ot, ii) {
          Y >>>= 0, oe >>>= 0, Pe >>>= 0, et >>>= 0, wt >>>= 0, St >>>= 0;
          var Ei = Mc(we, Pe);
          oe = Sr(oe), wt = Bi(et, wt), ao([], [Y], function(Qi) {
            Qi = Qi[0];
            var vn = `${Qi.name}.${oe}`;
            oe.startsWith("@@") && (oe = Symbol[oe.substring(2)]), Ot && Qi.registeredClass.pureVirtualFunctions.push(oe);
            function cn() {
              Od(`Cannot call ${vn} due to unbound types`, Ei);
            }
            var hn = Qi.registeredClass.instancePrototype, Zn = hn[oe];
            return Zn === void 0 || Zn.overloadTable === void 0 && Zn.className !== Qi.name && Zn.argCount === we - 2 ? (cn.argCount = we - 2, cn.className = Qi.name, hn[oe] = cn) : (Nd(hn, oe, vn), hn[oe].overloadTable[we - 2] = cn), ao([], Ei, function(Js) {
              var wo = $u(vn, Js, Qi, wt, St, ii);
              return hn[oe].overloadTable === void 0 ? (wo.argCount = we - 2, hn[oe] = wo) : hn[oe].overloadTable[we - 2] = wo, [];
            }), [];
          });
        }
        function Fc() {
          Object.assign(y0.prototype, { get(Y) {
            return this.allocated[Y];
          }, has(Y) {
            return this.allocated[Y] !== void 0;
          }, allocate(Y) {
            var oe = this.freelist.pop() || this.allocated.length;
            return this.allocated[oe] = Y, oe;
          }, free(Y) {
            this.allocated[Y] = void 0, this.freelist.push(Y);
          } });
        }
        function y0() {
          this.allocated = [void 0], this.freelist = [];
        }
        var Wl = new y0();
        function Mf(Y) {
          Y >>>= 0, Y >= Wl.reserved && --Wl.get(Y).refcount === 0 && Wl.free(Y);
        }
        function m3() {
          for (var Y = 0, oe = Wl.reserved; oe < Wl.allocated.length; ++oe)
            Wl.allocated[oe] !== void 0 && ++Y;
          return Y;
        }
        function y3() {
          Wl.allocated.push({ value: void 0 }, { value: null }, { value: !0 }, { value: !1 }), Wl.reserved = Wl.allocated.length, m.count_emval_handles = m3;
        }
        var ko = { toValue: (Y) => (Y || Ls("Cannot use deleted val. handle = " + Y), Wl.get(Y).value), toHandle: (Y) => {
          switch (Y) {
            case void 0:
              return 1;
            case null:
              return 2;
            case !0:
              return 3;
            case !1:
              return 4;
            default:
              return Wl.allocate({ refcount: 1, value: Y });
          }
        } };
        function E3(Y, oe) {
          Y >>>= 0, oe >>>= 0, oe = Sr(oe), la(Y, { name: oe, fromWireType: function(we) {
            var Pe = ko.toValue(we);
            return Mf(we), Pe;
          }, toWireType: function(we, Pe) {
            return ko.toHandle(Pe);
          }, argPackAdvance: 8, readValueFromPointer: sa, destructorFunction: null });
        }
        function _I(Y) {
          if (Y === null)
            return "null";
          var oe = typeof Y;
          return oe === "object" || oe === "array" || oe === "function" ? Y.toString() : "" + Y;
        }
        function g3(Y, oe) {
          switch (oe) {
            case 2:
              return function(we) {
                return this.fromWireType(p()[we >>> 2]);
              };
            case 3:
              return function(we) {
                return this.fromWireType(y()[we >>> 3]);
              };
            default:
              throw new TypeError("Unknown float type: " + Y);
          }
        }
        function w3(Y, oe, we) {
          Y >>>= 0, oe >>>= 0, we >>>= 0;
          var Pe = Tc(we);
          oe = Sr(oe), la(Y, { name: oe, fromWireType: function(et) {
            return et;
          }, toWireType: function(et, wt) {
            return wt;
          }, argPackAdvance: 8, readValueFromPointer: g3(oe, Pe), destructorFunction: null });
        }
        function xI(Y, oe, we, Pe, et, wt, St) {
          Y >>>= 0, we >>>= 0, Pe >>>= 0, et >>>= 0, wt >>>= 0;
          var Ot = Mc(oe, we);
          Y = Sr(Y), et = Bi(Pe, et), Dd(Y, function() {
            Od(`Cannot call ${Y} due to unbound types`, Ot);
          }, oe - 1), ao([], Ot, function(ii) {
            var Ei = [ii[0], null].concat(ii.slice(1));
            return yh(Y, $u(Y, Ei, null, et, wt, St), oe - 1), [];
          });
        }
        function T3(Y, oe, we) {
          switch (oe) {
            case 0:
              return we ? function(et) {
                return o()[et >>> 0];
              } : function(et) {
                return r()[et >>> 0];
              };
            case 1:
              return we ? function(et) {
                return l()[et >>> 1];
              } : function(et) {
                return c()[et >>> 1];
              };
            case 2:
              return we ? function(et) {
                return h()[et >>> 2];
              } : function(et) {
                return I()[et >>> 2];
              };
            default:
              throw new TypeError("Unknown integer type: " + Y);
          }
        }
        function wh(Y, oe, we, Pe, et) {
          Y >>>= 0, oe >>>= 0, we >>>= 0, oe = Sr(oe);
          var wt = Tc(we), St = (vn) => vn;
          if (Pe === 0) {
            var Ot = 32 - 8 * we;
            St = (vn) => vn << Ot >>> Ot;
          }
          var ii = oe.includes("unsigned"), Ei = (vn, cn) => {
          }, Qi;
          ii ? Qi = function(vn, cn) {
            return Ei(cn, this.name), cn >>> 0;
          } : Qi = function(vn, cn) {
            return Ei(cn, this.name), cn;
          }, la(Y, { name: oe, fromWireType: St, toWireType: Qi, argPackAdvance: 8, readValueFromPointer: T3(oe, wt, Pe !== 0), destructorFunction: null });
        }
        function R3(Y, oe, we) {
          Y >>>= 0, we >>>= 0;
          var Pe = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array], et = Pe[oe];
          function wt(St) {
            St = St >> 2;
            var Ot = I(), ii = Ot[St >>> 0], Ei = Ot[St + 1 >>> 0];
            return new et(Ot.buffer, Ei, ii);
          }
          we = Sr(we), la(Y, { name: we, fromWireType: wt, argPackAdvance: 8, readValueFromPointer: wt }, { ignoreDuplicateRegistrations: !0 });
        }
        var Qs = (Y, oe, we) => Yu(Y, r(), oe, we);
        function v3(Y, oe) {
          Y >>>= 0, oe >>>= 0, oe = Sr(oe);
          var we = oe === "std::string";
          la(Y, { name: oe, fromWireType: function(Pe) {
            var et = I()[Pe >>> 2], wt = Pe + 4, St;
            if (we)
              for (var Ot = wt, ii = 0; ii <= et; ++ii) {
                var Ei = wt + ii;
                if (ii == et || r()[Ei >>> 0] == 0) {
                  var Qi = Ei - Ot, vn = no(Ot, Qi);
                  St === void 0 ? St = vn : (St += "\0", St += vn), Ot = Ei + 1;
                }
              }
            else {
              for (var cn = new Array(et), ii = 0; ii < et; ++ii)
                cn[ii] = String.fromCharCode(r()[wt + ii >>> 0]);
              St = cn.join("");
            }
            return Th(Pe), St;
          }, toWireType: function(Pe, et) {
            et instanceof ArrayBuffer && (et = new Uint8Array(et));
            var wt, St = typeof et == "string";
            St || et instanceof Uint8Array || et instanceof Uint8ClampedArray || et instanceof Int8Array || Ls("Cannot pass non-string to std::string"), we && St ? wt = jl(et) : wt = et.length;
            var Ot = yE(4 + wt + 1), ii = Ot + 4;
            if (I()[Ot >>> 2] = wt, we && St)
              Qs(et, ii, wt + 1);
            else if (St)
              for (var Ei = 0; Ei < wt; ++Ei) {
                var Qi = et.charCodeAt(Ei);
                Qi > 255 && (Th(ii), Ls("String has UTF-16 code units that do not fit in 8 bits")), r()[ii + Ei >>> 0] = Qi;
              }
            else
              for (var Ei = 0; Ei < wt; ++Ei)
                r()[ii + Ei >>> 0] = et[Ei];
            return Pe !== null && Pe.push(Th, Ot), Ot;
          }, argPackAdvance: 8, readValueFromPointer: sa, destructorFunction: function(Pe) {
            Th(Pe);
          } });
        }
        var Uf = typeof TextDecoder < "u" ? new TextDecoder("utf-16le") : void 0, Ku = (Y, oe) => {
          for (var we = Y, Pe = we >> 1, et = Pe + oe / 2; !(Pe >= et) && c()[Pe >>> 0]; ) ++Pe;
          if (we = Pe << 1, we - Y > 32 && Uf) return Uf.decode(r().slice(Y, we));
          for (var wt = "", St = 0; !(St >= oe / 2); ++St) {
            var Ot = l()[Y + St * 2 >>> 1];
            if (Ot == 0) break;
            wt += String.fromCharCode(Ot);
          }
          return wt;
        }, PI = (Y, oe, we) => {
          if (we === void 0 && (we = 2147483647), we < 2) return 0;
          we -= 2;
          for (var Pe = oe, et = we < Y.length * 2 ? we / 2 : Y.length, wt = 0; wt < et; ++wt) {
            var St = Y.charCodeAt(wt);
            l()[oe >>> 1] = St, oe += 2;
          }
          return l()[oe >>> 1] = 0, oe - Pe;
        }, Bf = (Y) => Y.length * 2, A3 = (Y, oe) => {
          for (var we = 0, Pe = ""; !(we >= oe / 4); ) {
            var et = h()[Y + we * 4 >>> 2];
            if (et == 0) break;
            if (++we, et >= 65536) {
              var wt = et - 65536;
              Pe += String.fromCharCode(55296 | wt >> 10, 56320 | wt & 1023);
            } else
              Pe += String.fromCharCode(et);
          }
          return Pe;
        }, Hc = (Y, oe, we) => {
          if (oe >>>= 0, we === void 0 && (we = 2147483647), we < 4) return 0;
          for (var Pe = oe, et = Pe + we - 4, wt = 0; wt < Y.length; ++wt) {
            var St = Y.charCodeAt(wt);
            if (St >= 55296 && St <= 57343) {
              var Ot = Y.charCodeAt(++wt);
              St = 65536 + ((St & 1023) << 10) | Ot & 1023;
            }
            if (h()[oe >>> 2] = St, oe += 4, oe + 4 > et) break;
          }
          return h()[oe >>> 2] = 0, oe - Pe;
        }, tm = (Y) => {
          for (var oe = 0, we = 0; we < Y.length; ++we) {
            var Pe = Y.charCodeAt(we);
            Pe >= 55296 && Pe <= 57343 && ++we, oe += 4;
          }
          return oe;
        }, hs = function(Y, oe, we) {
          Y >>>= 0, oe >>>= 0, we >>>= 0, we = Sr(we);
          var Pe, et, wt, St, Ot;
          oe === 2 ? (Pe = Ku, et = PI, St = Bf, wt = () => c(), Ot = 1) : oe === 4 && (Pe = A3, et = Hc, St = tm, wt = () => I(), Ot = 2), la(Y, { name: we, fromWireType: function(ii) {
            for (var Ei = I()[ii >>> 2], Qi = wt(), vn, cn = ii + 4, hn = 0; hn <= Ei; ++hn) {
              var Zn = ii + 4 + hn * oe;
              if (hn == Ei || Qi[Zn >>> Ot] == 0) {
                var Js = Zn - cn, wo = Pe(cn, Js);
                vn === void 0 ? vn = wo : (vn += "\0", vn += wo), cn = Zn + oe;
              }
            }
            return Th(ii), vn;
          }, toWireType: function(ii, Ei) {
            typeof Ei != "string" && Ls(`Cannot pass non-string to C++ string type ${we}`);
            var Qi = St(Ei), vn = yE(4 + Qi + oe);
            return I()[vn >>> 2] = Qi >> Ot, et(Ei, vn + 4, Qi + oe), ii !== null && ii.push(Th, vn), vn;
          }, argPackAdvance: 8, readValueFromPointer: sa, destructorFunction: function(ii) {
            Th(ii);
          } });
        };
        function S3(Y, oe, we, Pe, et, wt) {
          Y >>>= 0, oe >>>= 0, we >>>= 0, Pe >>>= 0, et >>>= 0, wt >>>= 0, xs[Y] = { name: Sr(oe), rawConstructor: Bi(we, Pe), rawDestructor: Bi(et, wt), elements: [] };
        }
        function b3(Y, oe, we, Pe, et, wt, St, Ot, ii) {
          Y >>>= 0, oe >>>= 0, we >>>= 0, Pe >>>= 0, et >>>= 0, wt >>>= 0, St >>>= 0, Ot >>>= 0, ii >>>= 0, xs[Y].elements.push({ getterReturnType: oe, getter: Bi(we, Pe), getterContext: et, setterArgumentType: wt, setter: Bi(St, Ot), setterContext: ii });
        }
        function N3(Y, oe, we, Pe, et, wt) {
          Y >>>= 0, oe >>>= 0, we >>>= 0, Pe >>>= 0, et >>>= 0, wt >>>= 0, oa[Y] = { name: Sr(oe), rawConstructor: Bi(we, Pe), rawDestructor: Bi(et, wt), fields: [] };
        }
        function D3(Y, oe, we, Pe, et, wt, St, Ot, ii, Ei) {
          Y >>>= 0, oe >>>= 0, we >>>= 0, Pe >>>= 0, et >>>= 0, wt >>>= 0, St >>>= 0, Ot >>>= 0, ii >>>= 0, Ei >>>= 0, oa[Y].fields.push({ fieldName: Sr(oe), getterReturnType: we, getter: Bi(Pe, et), getterContext: wt, setterArgumentType: St, setter: Bi(Ot, ii), setterContext: Ei });
        }
        function C3(Y, oe) {
          Y >>>= 0, oe >>>= 0, oe = Sr(oe), la(Y, { isVoid: !0, name: oe, argPackAdvance: 0, fromWireType: function() {
          }, toWireType: function(we, Pe) {
          } });
        }
        var MI = !0, st = () => MI, Ld = () => {
          if (!ft())
            try {
              W ? Qg(ze) : ai(ze);
            } catch (Y) {
              ei(Y);
            }
        }, O3 = (Y) => {
          if (!Rt)
            try {
              Y(), Ld();
            } catch (oe) {
              ei(oe);
            }
        };
        function UI(Y) {
          if (Y >>>= 0, typeof Atomics.waitAsync == "function") {
            var oe = Atomics.waitAsync(h(), Y >> 2, Y);
            oe.value.then(Ff);
            var we = Y + 128;
            Atomics.store(h(), we >> 2, 1);
          }
        }
        m.__emscripten_thread_mailbox_await = UI;
        var Ff = function() {
          var Y = EE();
          Y && (UI(Y), O3(() => B4()));
        };
        m.checkMailbox = Ff;
        var L3 = function(Y, oe, we) {
          if (Y >>>= 0, oe >>>= 0, Y == oe)
            setTimeout(() => Ff());
          else if (W)
            postMessage({ targetThread: Y, cmd: "checkMailbox" });
          else {
            var Pe = Si.pthreads[Y];
            if (!Pe)
              return;
            Pe.postMessage({ cmd: "checkMailbox" });
          }
        };
        function _3(Y, oe, we) {
          return -1;
        }
        function x3(Y) {
        }
        function BI(Y, oe) {
          var we = nr[Y];
          return we === void 0 && Ls(oe + " has unknown type " + Pc(Y)), we;
        }
        function P3(Y, oe, we) {
          Y >>>= 0, oe >>>= 0, we >>>= 0, Y = ko.toValue(Y), oe = BI(oe, "emval::as");
          var Pe = [], et = ko.toHandle(Pe);
          return I()[we >>> 2] = et, oe.toWireType(Pe, Y);
        }
        function M3(Y, oe) {
          for (var we = new Array(Y), Pe = 0; Pe < Y; ++Pe)
            we[Pe] = BI(I()[oe + Pe * 4 >>> 2], "parameter " + Pe);
          return we;
        }
        function U3(Y, oe, we, Pe) {
          Y >>>= 0, we >>>= 0, Pe >>>= 0, Y = ko.toValue(Y);
          for (var et = M3(oe, we), wt = new Array(oe), St = 0; St < oe; ++St) {
            var Ot = et[St];
            wt[St] = Ot.readValueFromPointer(Pe), Pe += Ot.argPackAdvance;
          }
          var ii = Y.apply(void 0, wt);
          return ko.toHandle(ii);
        }
        var B3 = {};
        function FI(Y) {
          var oe = B3[Y];
          return oe === void 0 ? Sr(Y) : oe;
        }
        function HI() {
          return typeof globalThis == "object" ? globalThis : (/* @__PURE__ */ (function() {
            return Function;
          })())("return this")();
        }
        function F3(Y) {
          return Y >>>= 0, Y === 0 ? ko.toHandle(HI()) : (Y = FI(Y), ko.toHandle(HI()[Y]));
        }
        function H3(Y, oe) {
          return Y >>>= 0, oe >>>= 0, Y = ko.toValue(Y), oe = ko.toValue(oe), ko.toHandle(Y[oe]);
        }
        function G3(Y) {
          Y >>>= 0, Y > 4 && (Wl.get(Y).refcount += 1);
        }
        function k3(Y, oe) {
          return Y >>>= 0, oe >>>= 0, Y = ko.toValue(Y), oe = ko.toValue(oe), Y instanceof oe;
        }
        function im(Y) {
          return Y >>>= 0, Y = ko.toValue(Y), typeof Y == "number";
        }
        function Hf(Y) {
          return Y >>>= 0, Y = ko.toValue(Y), typeof Y == "string";
        }
        function Gf() {
          return ko.toHandle([]);
        }
        function V3(Y) {
          return Y >>>= 0, ko.toHandle(FI(Y));
        }
        function Zu() {
          return ko.toHandle({});
        }
        function kf(Y) {
          Y >>>= 0;
          var oe = ko.toValue(Y);
          Gr(oe), Mf(Y);
        }
        function nm(Y, oe, we) {
          Y >>>= 0, oe >>>= 0, we >>>= 0, Y = ko.toValue(Y), oe = ko.toValue(oe), we = ko.toValue(we), Y[oe] = we;
        }
        function sm(Y, oe) {
          Y >>>= 0, oe >>>= 0, Y = BI(Y, "_emval_take_value");
          var we = Y.readValueFromPointer(oe);
          return ko.toHandle(we);
        }
        function z3(Y, oe, we) {
          var Pe = so(Y, oe);
          we >>>= 0;
          var et = new Date(Pe * 1e3);
          h()[we >>> 2] = et.getUTCSeconds(), h()[we + 4 >>> 2] = et.getUTCMinutes(), h()[we + 8 >>> 2] = et.getUTCHours(), h()[we + 12 >>> 2] = et.getUTCDate(), h()[we + 16 >>> 2] = et.getUTCMonth(), h()[we + 20 >>> 2] = et.getUTCFullYear() - 1900, h()[we + 24 >>> 2] = et.getUTCDay();
          var wt = Date.UTC(et.getUTCFullYear(), 0, 1, 0, 0, 0, 0), St = (et.getTime() - wt) / (1e3 * 60 * 60 * 24) | 0;
          h()[we + 28 >>> 2] = St;
        }
        var _d = (Y) => Y % 4 === 0 && (Y % 100 !== 0 || Y % 400 === 0), om = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335], Z = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], ae = (Y) => {
          var oe = _d(Y.getFullYear()), we = oe ? om : Z, Pe = we[Y.getMonth()] + Y.getDate() - 1;
          return Pe;
        };
        function Re(Y, oe, we) {
          var Pe = so(Y, oe);
          we >>>= 0;
          var et = new Date(Pe * 1e3);
          h()[we >>> 2] = et.getSeconds(), h()[we + 4 >>> 2] = et.getMinutes(), h()[we + 8 >>> 2] = et.getHours(), h()[we + 12 >>> 2] = et.getDate(), h()[we + 16 >>> 2] = et.getMonth(), h()[we + 20 >>> 2] = et.getFullYear() - 1900, h()[we + 24 >>> 2] = et.getDay();
          var wt = ae(et) | 0;
          h()[we + 28 >>> 2] = wt, h()[we + 36 >>> 2] = -(et.getTimezoneOffset() * 60);
          var St = new Date(et.getFullYear(), 0, 1), Ot = new Date(et.getFullYear(), 6, 1).getTimezoneOffset(), ii = St.getTimezoneOffset(), Ei = (Ot != ii && et.getTimezoneOffset() == Math.min(ii, Ot)) | 0;
          h()[we + 32 >>> 2] = Ei;
        }
        var Ue = (Y) => {
          var oe = jl(Y) + 1, we = yE(oe);
          return we && Qs(Y, we, oe), we;
        };
        function nt(Y, oe, we) {
          Y >>>= 0, oe >>>= 0, we >>>= 0;
          var Pe = (/* @__PURE__ */ new Date()).getFullYear(), et = new Date(Pe, 0, 1), wt = new Date(Pe, 6, 1), St = et.getTimezoneOffset(), Ot = wt.getTimezoneOffset(), ii = Math.max(St, Ot);
          I()[Y >>> 2] = ii * 60, h()[oe >>> 2] = +(St != Ot);
          function Ei(Zn) {
            var Js = Zn.toTimeString().match(/\(([A-Za-z ]+)\)$/);
            return Js ? Js[1] : "GMT";
          }
          var Qi = Ei(et), vn = Ei(wt), cn = Ue(Qi), hn = Ue(vn);
          Ot < St ? (I()[we >>> 2] = cn, I()[we + 4 >>> 2] = hn) : (I()[we >>> 2] = hn, I()[we + 4 >>> 2] = cn);
        }
        var At = () => {
          wi("");
        };
        function Lt() {
        }
        function _t() {
          return Date.now();
        }
        var oi = () => {
          Mt += 1;
        }, mi = () => {
          throw oi(), "unwind";
        }, zi;
        zi = () => performance.timeOrigin + performance.now();
        var yn = (Y) => {
          var oe = H4(), we = Y();
          return Jg(oe), we;
        }, Xi = function(Y, oe) {
          var we = arguments.length - 2, Pe = arguments;
          return yn(() => {
            for (var et = we, wt = G4(et * 8), St = wt >> 3, Ot = 0; Ot < we; Ot++) {
              var ii = Pe[2 + Ot];
              y()[St + Ot >>> 0] = ii;
            }
            return U4(Y, et, wt, oe);
          });
        }, rn = [];
        function Fn(Y, oe, we, Pe) {
          oe >>>= 0, Pe >>>= 0, Si.currentProxiedOperationCallerThread = oe, rn.length = we;
          for (var et = Pe >> 3, wt = 0; wt < we; wt++)
            rn[wt] = y()[et + wt >>> 0];
          var St = Kg[Y];
          return St.apply(null, rn);
        }
        var Ps = () => 4294901760, Fs = (Y) => {
          var oe = Ve.buffer, we = Y - oe.byteLength + 65535 >>> 16;
          try {
            return Ve.grow(we), Wt(), 1;
          } catch {
          }
        };
        function uo(Y) {
          Y >>>= 0;
          var oe = r().length;
          if (Y <= oe)
            return !1;
          var we = Ps();
          if (Y > we)
            return !1;
          for (var Pe = (ii, Ei) => ii + (Ei - ii % Ei) % Ei, et = 1; et <= 4; et *= 2) {
            var wt = oe * (1 + 0.2 / et);
            wt = Math.min(wt, Y + 100663296);
            var St = Math.min(we, Pe(Math.max(Y, wt), 65536)), Ot = Fs(St);
            if (Ot)
              return !0;
          }
          return !1;
        }
        var Ui = {}, Rn = () => R || "./this.program", Vo = () => {
          if (!Vo.strings) {
            var Y = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", oe = { USER: "web_user", LOGNAME: "web_user", PATH: "/", PWD: "/", HOME: "/home/web_user", LANG: Y, _: Rn() };
            for (var we in Ui)
              Ui[we] === void 0 ? delete oe[we] : oe[we] = Ui[we];
            var Pe = [];
            for (var we in oe)
              Pe.push(`${we}=${oe[we]}`);
            Vo.strings = Pe;
          }
          return Vo.strings;
        }, Do = (Y, oe) => {
          for (var we = 0; we < Y.length; ++we)
            o()[oe++ >>> 0] = Y.charCodeAt(we);
          o()[oe >>> 0] = 0;
        };
        function Pl(Y, oe) {
          if (W) return Xi(3, 1, Y, oe);
          Y >>>= 0, oe >>>= 0;
          var we = 0;
          return Vo().forEach(function(Pe, et) {
            var wt = oe + we;
            I()[Y + et * 4 >>> 2] = wt, Do(Pe, wt), we += Pe.length + 1;
          }), 0;
        }
        function cr(Y, oe) {
          if (W) return Xi(4, 1, Y, oe);
          Y >>>= 0, oe >>>= 0;
          var we = Vo();
          I()[Y >>> 2] = we.length;
          var Pe = 0;
          return we.forEach(function(et) {
            Pe += et.length + 1;
          }), I()[oe >>> 2] = Pe, 0;
        }
        function S4(Y) {
          if (W) return Xi(5, 1, Y);
          try {
            var oe = It.getStreamFromFD(Y);
            return Je.close(oe), 0;
          } catch (we) {
            if (typeof Je > "u" || we.name !== "ErrnoError") throw we;
            return we.errno;
          }
        }
        function b4(Y, oe) {
          if (W) return Xi(6, 1, Y, oe);
          oe >>>= 0;
          try {
            var we = 0, Pe = 0, et = 0, wt = It.getStreamFromFD(Y), St = wt.tty ? 2 : Je.isDir(wt.mode) ? 3 : Je.isLink(wt.mode) ? 7 : 4;
            return o()[oe >>> 0] = St, l()[oe + 2 >>> 1] = et, kt = [we >>> 0, (Pi = we, +Math.abs(Pi) >= 1 ? Pi > 0 ? +Math.floor(Pi / 4294967296) >>> 0 : ~~+Math.ceil((Pi - +(~~Pi >>> 0)) / 4294967296) >>> 0 : 0)], h()[oe + 8 >>> 2] = kt[0], h()[oe + 12 >>> 2] = kt[1], kt = [Pe >>> 0, (Pi = Pe, +Math.abs(Pi) >= 1 ? Pi > 0 ? +Math.floor(Pi / 4294967296) >>> 0 : ~~+Math.ceil((Pi - +(~~Pi >>> 0)) / 4294967296) >>> 0 : 0)], h()[oe + 16 >>> 2] = kt[0], h()[oe + 20 >>> 2] = kt[1], 0;
          } catch (Ot) {
            if (typeof Je > "u" || Ot.name !== "ErrnoError") throw Ot;
            return Ot.errno;
          }
        }
        var IE = (Y, oe, we, Pe) => {
          for (var et = 0, wt = 0; wt < we; wt++) {
            var St = I()[oe >>> 2], Ot = I()[oe + 4 >>> 2];
            oe += 8;
            var ii = Je.read(Y, o(), St, Ot, Pe);
            if (ii < 0) return -1;
            if (et += ii, ii < Ot) break;
          }
          return et;
        };
        function N4(Y, oe, we, Pe) {
          if (W) return Xi(7, 1, Y, oe, we, Pe);
          oe >>>= 0, we >>>= 0, Pe >>>= 0;
          try {
            var et = It.getStreamFromFD(Y), wt = IE(et, oe, we);
            return I()[Pe >>> 2] = wt, 0;
          } catch (St) {
            if (typeof Je > "u" || St.name !== "ErrnoError") throw St;
            return St.errno;
          }
        }
        function D4(Y, oe, we, Pe, et) {
          if (W) return Xi(8, 1, Y, oe, we, Pe, et);
          var wt = so(oe, we);
          et >>>= 0;
          try {
            if (isNaN(wt)) return 61;
            var St = It.getStreamFromFD(Y);
            return Je.llseek(St, wt, Pe), kt = [St.position >>> 0, (Pi = St.position, +Math.abs(Pi) >= 1 ? Pi > 0 ? +Math.floor(Pi / 4294967296) >>> 0 : ~~+Math.ceil((Pi - +(~~Pi >>> 0)) / 4294967296) >>> 0 : 0)], h()[et >>> 2] = kt[0], h()[et + 4 >>> 2] = kt[1], St.getdents && wt === 0 && Pe === 0 && (St.getdents = null), 0;
          } catch (Ot) {
            if (typeof Je > "u" || Ot.name !== "ErrnoError") throw Ot;
            return Ot.errno;
          }
        }
        var C4 = (Y, oe, we, Pe) => {
          for (var et = 0, wt = 0; wt < we; wt++) {
            var St = I()[oe >>> 2], Ot = I()[oe + 4 >>> 2];
            oe += 8;
            var ii = Je.write(Y, o(), St, Ot, Pe);
            if (ii < 0) return -1;
            et += ii;
          }
          return et;
        };
        function O4(Y, oe, we, Pe) {
          if (W) return Xi(9, 1, Y, oe, we, Pe);
          oe >>>= 0, we >>>= 0, Pe >>>= 0;
          try {
            var et = It.getStreamFromFD(Y), wt = C4(et, oe, we);
            return I()[Pe >>> 2] = wt, 0;
          } catch (St) {
            if (typeof Je > "u" || St.name !== "ErrnoError") throw St;
            return St.errno;
          }
        }
        function k5(Y, oe) {
          return Y >>>= 0, oe >>>= 0, Bs(r().subarray(Y >>> 0, Y + oe >>> 0)), 0;
        }
        var V5 = (Y, oe) => {
          for (var we = 0, Pe = 0; Pe <= oe; we += Y[Pe++])
            ;
          return we;
        }, L4 = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], _4 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], z5 = (Y, oe) => {
          for (var we = new Date(Y.getTime()); oe > 0; ) {
            var Pe = _d(we.getFullYear()), et = we.getMonth(), wt = (Pe ? L4 : _4)[et];
            if (oe > wt - we.getDate())
              oe -= wt - we.getDate() + 1, we.setDate(1), et < 11 ? we.setMonth(et + 1) : (we.setMonth(0), we.setFullYear(we.getFullYear() + 1));
            else
              return we.setDate(we.getDate() + oe), we;
          }
          return we;
        }, j5 = (Y, oe) => {
          o().set(Y, oe >>> 0);
        };
        function x4(Y, oe, we, Pe) {
          Y >>>= 0, oe >>>= 0, we >>>= 0, Pe >>>= 0;
          var et = h()[Pe + 40 >>> 2], wt = { tm_sec: h()[Pe >>> 2], tm_min: h()[Pe + 4 >>> 2], tm_hour: h()[Pe + 8 >>> 2], tm_mday: h()[Pe + 12 >>> 2], tm_mon: h()[Pe + 16 >>> 2], tm_year: h()[Pe + 20 >>> 2], tm_wday: h()[Pe + 24 >>> 2], tm_yday: h()[Pe + 28 >>> 2], tm_isdst: h()[Pe + 32 >>> 2], tm_gmtoff: h()[Pe + 36 >>> 2], tm_zone: et ? no(et) : "" }, St = no(we), Ot = { "%c": "%a %b %d %H:%M:%S %Y", "%D": "%m/%d/%y", "%F": "%Y-%m-%d", "%h": "%b", "%r": "%I:%M:%S %p", "%R": "%H:%M", "%T": "%H:%M:%S", "%x": "%m/%d/%y", "%X": "%H:%M:%S", "%Ec": "%c", "%EC": "%C", "%Ex": "%m/%d/%y", "%EX": "%H:%M:%S", "%Ey": "%y", "%EY": "%Y", "%Od": "%d", "%Oe": "%e", "%OH": "%H", "%OI": "%I", "%Om": "%m", "%OM": "%M", "%OS": "%S", "%Ou": "%u", "%OU": "%U", "%OV": "%V", "%Ow": "%w", "%OW": "%W", "%Oy": "%y" };
          for (var ii in Ot)
            St = St.replace(new RegExp(ii, "g"), Ot[ii]);
          var Ei = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], Qi = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
          function vn(Mi, Dn, nl) {
            for (var sr = typeof Mi == "number" ? Mi.toString() : Mi || ""; sr.length < Dn; )
              sr = nl[0] + sr;
            return sr;
          }
          function cn(Mi, Dn) {
            return vn(Mi, Dn, "0");
          }
          function hn(Mi, Dn) {
            function nl(Yl) {
              return Yl < 0 ? -1 : Yl > 0 ? 1 : 0;
            }
            var sr;
            return (sr = nl(Mi.getFullYear() - Dn.getFullYear())) === 0 && (sr = nl(Mi.getMonth() - Dn.getMonth())) === 0 && (sr = nl(Mi.getDate() - Dn.getDate())), sr;
          }
          function Zn(Mi) {
            switch (Mi.getDay()) {
              case 0:
                return new Date(Mi.getFullYear() - 1, 11, 29);
              case 1:
                return Mi;
              case 2:
                return new Date(Mi.getFullYear(), 0, 3);
              case 3:
                return new Date(Mi.getFullYear(), 0, 2);
              case 4:
                return new Date(Mi.getFullYear(), 0, 1);
              case 5:
                return new Date(Mi.getFullYear() - 1, 11, 31);
              case 6:
                return new Date(Mi.getFullYear() - 1, 11, 30);
            }
          }
          function Js(Mi) {
            var Dn = z5(new Date(Mi.tm_year + 1900, 0, 1), Mi.tm_yday), nl = new Date(Dn.getFullYear(), 0, 4), sr = new Date(Dn.getFullYear() + 1, 0, 4), Yl = Zn(nl), sl = Zn(sr);
            return hn(Yl, Dn) <= 0 ? hn(sl, Dn) <= 0 ? Dn.getFullYear() + 1 : Dn.getFullYear() : Dn.getFullYear() - 1;
          }
          var wo = { "%a": (Mi) => Ei[Mi.tm_wday].substring(0, 3), "%A": (Mi) => Ei[Mi.tm_wday], "%b": (Mi) => Qi[Mi.tm_mon].substring(0, 3), "%B": (Mi) => Qi[Mi.tm_mon], "%C": (Mi) => {
            var Dn = Mi.tm_year + 1900;
            return cn(Dn / 100 | 0, 2);
          }, "%d": (Mi) => cn(Mi.tm_mday, 2), "%e": (Mi) => vn(Mi.tm_mday, 2, " "), "%g": (Mi) => Js(Mi).toString().substring(2), "%G": (Mi) => Js(Mi), "%H": (Mi) => cn(Mi.tm_hour, 2), "%I": (Mi) => {
            var Dn = Mi.tm_hour;
            return Dn == 0 ? Dn = 12 : Dn > 12 && (Dn -= 12), cn(Dn, 2);
          }, "%j": (Mi) => cn(Mi.tm_mday + V5(_d(Mi.tm_year + 1900) ? L4 : _4, Mi.tm_mon - 1), 3), "%m": (Mi) => cn(Mi.tm_mon + 1, 2), "%M": (Mi) => cn(Mi.tm_min, 2), "%n": () => `
`, "%p": (Mi) => Mi.tm_hour >= 0 && Mi.tm_hour < 12 ? "AM" : "PM", "%S": (Mi) => cn(Mi.tm_sec, 2), "%t": () => "	", "%u": (Mi) => Mi.tm_wday || 7, "%U": (Mi) => {
            var Dn = Mi.tm_yday + 7 - Mi.tm_wday;
            return cn(Math.floor(Dn / 7), 2);
          }, "%V": (Mi) => {
            var Dn = Math.floor((Mi.tm_yday + 7 - (Mi.tm_wday + 6) % 7) / 7);
            if ((Mi.tm_wday + 371 - Mi.tm_yday - 2) % 7 <= 2 && Dn++, Dn) {
              if (Dn == 53) {
                var sr = (Mi.tm_wday + 371 - Mi.tm_yday) % 7;
                sr != 4 && (sr != 3 || !_d(Mi.tm_year)) && (Dn = 1);
              }
            } else {
              Dn = 52;
              var nl = (Mi.tm_wday + 7 - Mi.tm_yday - 1) % 7;
              (nl == 4 || nl == 5 && _d(Mi.tm_year % 400 - 1)) && Dn++;
            }
            return cn(Dn, 2);
          }, "%w": (Mi) => Mi.tm_wday, "%W": (Mi) => {
            var Dn = Mi.tm_yday + 7 - (Mi.tm_wday + 6) % 7;
            return cn(Math.floor(Dn / 7), 2);
          }, "%y": (Mi) => (Mi.tm_year + 1900).toString().substring(2), "%Y": (Mi) => Mi.tm_year + 1900, "%z": (Mi) => {
            var Dn = Mi.tm_gmtoff, nl = Dn >= 0;
            return Dn = Math.abs(Dn) / 60, Dn = Dn / 60 * 100 + Dn % 60, (nl ? "+" : "-") + ("0000" + Dn).slice(-4);
          }, "%Z": (Mi) => Mi.tm_zone, "%%": () => "%" };
          St = St.replace(/%%/g, "\0\0");
          for (var ii in wo)
            St.includes(ii) && (St = St.replace(new RegExp(ii, "g"), wo[ii](wt)));
          St = St.replace(/\0\0/g, "%");
          var To = bd(St, !1);
          return To.length > oe ? 0 : (j5(To, Y), To.length - 1);
        }
        function j3(Y, oe, we, Pe, et) {
          return Y >>>= 0, oe >>>= 0, we >>>= 0, Pe >>>= 0, x4(Y, oe, we, Pe);
        }
        Si.init();
        var $g = function(Y, oe, we, Pe) {
          Y || (Y = this), this.parent = Y, this.mount = Y.mount, this.mounted = null, this.id = Je.nextInode++, this.name = oe, this.mode = we, this.node_ops = {}, this.stream_ops = {}, this.rdev = Pe;
        }, pE = 365, mE = 146;
        Object.defineProperties($g.prototype, { read: { get: function() {
          return (this.mode & pE) === pE;
        }, set: function(Y) {
          Y ? this.mode |= pE : this.mode &= ~pE;
        } }, write: { get: function() {
          return (this.mode & mE) === mE;
        }, set: function(Y) {
          Y ? this.mode |= mE : this.mode &= ~mE;
        } }, isFolder: { get: function() {
          return Je.isDir(this.mode);
        } }, isDevice: { get: function() {
          return Je.isChrdev(this.mode);
        } } }), Je.FSNode = $g, Je.createPreloadedFile = As, Je.staticInit(), ul = m.InternalError = class extends Error {
          constructor(oe) {
            super(oe), this.name = "InternalError";
          }
        }, bf(), ra = m.BindingError = class extends Error {
          constructor(oe) {
            super(oe), this.name = "BindingError";
          }
        }, xf(), Mn(), Cd(), Ru = m.UnboundTypeError = qu(Error, "UnboundTypeError"), Fc(), y3();
        var Kg = [null, Qt, Nn, Pl, cr, S4, b4, N4, D4, O4], W5 = { g: Eo, _: Yn, B: Jo, ha: kr, q: Po, L: NI, fa: Nf, j: gh, i: ua, c: Bc, ea: E3, D: w3, d: xI, t: wh, n: R3, E: v3, y: hs, ia: S3, o: b3, r: N3, f: D3, ga: C3, V: st, T: L3, Y: _3, Z: UI, da: x3, m: P3, x: U3, b: Mf, A: F3, k: H3, s: G3, H: k3, z: im, G: Hf, F: Gf, h: V3, u: Zu, l: kf, p: nm, e: sm, J: z3, K: Re, S: nt, w: At, C: Lt, W: _t, ca: mi, v: zi, X: Fn, R: uo, aa: Pl, ba: cr, M: ai, P: S4, $: b4, Q: N4, I: D4, U: O4, N: k5, a: Ve || m.wasmMemory, O: j3 };
        Yi();
        var Th = (Y) => (Th = $e.ka)(Y), yE = (Y) => (yE = $e.la)(Y), EE = m._pthread_self = () => (EE = m._pthread_self = $e.ma)();
        m.__emscripten_tls_init = () => (m.__emscripten_tls_init = $e.oa)();
        var P4 = (Y) => (P4 = $e.pa)(Y);
        m.__embind_initialize_bindings = () => (m.__embind_initialize_bindings = $e.qa)();
        var M4 = m.__emscripten_thread_init = (Y, oe, we, Pe, et, wt) => (M4 = m.__emscripten_thread_init = $e.ra)(Y, oe, we, Pe, et, wt);
        m.__emscripten_thread_crashed = () => (m.__emscripten_thread_crashed = $e.sa)();
        var U4 = (Y, oe, we, Pe) => (U4 = $e.ta)(Y, oe, we, Pe), Zg = (Y) => (Zg = $e.ua)(Y), Qg = m.__emscripten_thread_exit = (Y) => (Qg = m.__emscripten_thread_exit = $e.va)(Y), B4 = m.__emscripten_check_mailbox = () => (B4 = m.__emscripten_check_mailbox = $e.wa)(), F4 = (Y, oe) => (F4 = $e.xa)(Y, oe), H4 = () => (H4 = $e.ya)(), Jg = (Y) => (Jg = $e.za)(Y), G4 = (Y) => (G4 = $e.Aa)(Y), k4 = (Y) => (k4 = $e.Ba)(Y);
        m.dynCall_jiji = (Y, oe, we, Pe, et) => (m.dynCall_jiji = $e.Ca)(Y, oe, we, Pe, et), m.dynCall_viijii = (Y, oe, we, Pe, et, wt, St) => (m.dynCall_viijii = $e.Da)(Y, oe, we, Pe, et, wt, St), m.dynCall_iiiiij = (Y, oe, we, Pe, et, wt, St) => (m.dynCall_iiiiij = $e.Ea)(Y, oe, we, Pe, et, wt, St), m.dynCall_iiiiijj = (Y, oe, we, Pe, et, wt, St, Ot, ii) => (m.dynCall_iiiiijj = $e.Fa)(Y, oe, we, Pe, et, wt, St, Ot, ii), m.dynCall_iiiiiijj = (Y, oe, we, Pe, et, wt, St, Ot, ii, Ei) => (m.dynCall_iiiiiijj = $e.Ga)(Y, oe, we, Pe, et, wt, St, Ot, ii, Ei);
        function Y5(Y) {
          Y = Object.assign({}, Y);
          var oe = (Pe) => (et) => Pe(et) >>> 0, we = (Pe) => () => Pe() >>> 0;
          return Y.malloc = oe(Y.malloc), Y.pthread_self = we(Y.pthread_self), Y.__getTypeName = oe(Y.__getTypeName), Y.__errno_location = we(Y.__errno_location), Y.stackSave = we(Y.stackSave), Y.stackAlloc = oe(Y.stackAlloc), Y;
        }
        m.keepRuntimeAlive = ft, m.wasmMemory = Ve, m.ExitStatus = sn, m.PThread = Si;
        var rm;
        gt = function Y() {
          rm || V4(), rm || (gt = Y);
        };
        function V4() {
          if (Me > 0)
            return;
          if (W) {
            A(m), Tt(), startWorker(m);
            return;
          }
          if (rt(), Me > 0)
            return;
          function Y() {
            rm || (rm = !0, m.calledRun = !0, !Rt && (Tt(), A(m), m.onRuntimeInitialized && m.onRuntimeInitialized(), jt()));
          }
          m.setStatus ? (m.setStatus("Running..."), setTimeout(function() {
            setTimeout(function() {
              m.setStatus("");
            }, 1), Y();
          }, 1)) : Y();
        }
        if (m.preInit)
          for (typeof m.preInit == "function" && (m.preInit = [m.preInit]); m.preInit.length > 0; )
            m.preInit.pop()();
        return V4(), s.ready;
      };
    })();
    typeof e == "object" && typeof t == "object" ? t.exports = i : typeof define == "function" && define.amd && define([], () => i);
  }
}), Kge = LAe({
  "dist/web-ifc.js"(e, t) {
    var i = (() => {
      var n = typeof document < "u" && document.currentScript ? document.currentScript.src : void 0;
      return function(s = {}) {
        var o = s, r, l;
        o.ready = new Promise((Z, ae) => {
          r = Z, l = ae;
        });
        var c = Object.assign({}, o), h = "./this.program", I = !0, p = "";
        function y(Z) {
          return o.locateFile ? o.locateFile(Z, p) : p + Z;
        }
        var m, A;
        typeof document < "u" && document.currentScript && (p = document.currentScript.src), n && (p = n), p.indexOf("blob:") !== 0 ? p = p.substr(0, p.replace(/[?#].*/, "").lastIndexOf("/") + 1) : p = "", m = (Z) => {
          var ae = new XMLHttpRequest();
          return ae.open("GET", Z, !1), ae.send(null), ae.responseText;
        }, A = (Z, ae, Re) => {
          var Ue = new XMLHttpRequest();
          Ue.open("GET", Z, !0), Ue.responseType = "arraybuffer", Ue.onload = () => {
            if (Ue.status == 200 || Ue.status == 0 && Ue.response) {
              ae(Ue.response);
              return;
            }
            Re();
          }, Ue.onerror = Re, Ue.send(null);
        };
        var C = o.print || console.log.bind(console), O = o.printErr || console.error.bind(console);
        Object.assign(o, c), c = null, o.arguments && o.arguments, o.thisProgram && (h = o.thisProgram), o.quit && o.quit;
        var R;
        o.wasmBinary && (R = o.wasmBinary), o.noExitRuntime, typeof WebAssembly != "object" && Wt("no native wasm support detected");
        var F, L, P = !1;
        function z(Z, ae) {
          Z || Wt(ae);
        }
        var W, re, ce, te, ee, Ne, Ae, Oe;
        function pe() {
          var Z = F.buffer;
          o.HEAP8 = W = new Int8Array(Z), o.HEAP16 = ce = new Int16Array(Z), o.HEAP32 = ee = new Int32Array(Z), o.HEAPU8 = re = new Uint8Array(Z), o.HEAPU16 = te = new Uint16Array(Z), o.HEAPU32 = Ne = new Uint32Array(Z), o.HEAPF32 = Ae = new Float32Array(Z), o.HEAPF64 = Oe = new Float64Array(Z);
        }
        var je, Ve = [], $e = [], vt = [];
        function Rt() {
          if (o.preRun)
            for (typeof o.preRun == "function" && (o.preRun = [o.preRun]); o.preRun.length; )
              Et(o.preRun.shift());
          Jt(Ve);
        }
        function ze() {
          !o.noFSInit && !st.init.initialized && st.init(), st.ignorePermissions = !1, Jt($e);
        }
        function mt() {
          if (o.postRun)
            for (typeof o.postRun == "function" && (o.postRun = [o.postRun]); o.postRun.length; )
              Dt(o.postRun.shift());
          Jt(vt);
        }
        function Et(Z) {
          Ve.unshift(Z);
        }
        function it(Z) {
          $e.unshift(Z);
        }
        function Dt(Z) {
          vt.unshift(Z);
        }
        var Ct = 0, Kt = null;
        function Zt(Z) {
          return Z;
        }
        function Xt(Z) {
          Ct++, o.monitorRunDependencies && o.monitorRunDependencies(Ct);
        }
        function gi(Z) {
          if (Ct--, o.monitorRunDependencies && o.monitorRunDependencies(Ct), Ct == 0 && Kt) {
            var ae = Kt;
            Kt = null, ae();
          }
        }
        function Wt(Z) {
          o.onAbort && o.onAbort(Z), Z = "Aborted(" + Z + ")", O(Z), P = !0, Z += ". Build with -sASSERTIONS for more info.";
          var ae = new WebAssembly.RuntimeError(Z);
          throw l(ae), ae;
        }
        var Di = "data:application/octet-stream;base64,";
        function ni(Z) {
          return Z.startsWith(Di);
        }
        var Ci;
        Ci = "web-ifc.wasm", ni(Ci) || (Ci = y(Ci));
        function Se(Z) {
          if (Z == Ci && R)
            return new Uint8Array(R);
          throw "both async and sync fetching of the wasm failed";
        }
        function si(Z) {
          return !R && I && typeof fetch == "function" ? fetch(Z, { credentials: "same-origin" }).then((ae) => {
            if (!ae.ok)
              throw "failed to load wasm binary file at '" + Z + "'";
            return ae.arrayBuffer();
          }).catch(() => Se(Z)) : Promise.resolve().then(() => Se(Z));
        }
        function Mt(Z, ae, Re) {
          return si(Z).then((Ue) => WebAssembly.instantiate(Ue, ae)).then((Ue) => Ue).then(Re, (Ue) => {
            O("failed to asynchronously prepare wasm: " + Ue), Wt(Ue);
          });
        }
        function ft(Z, ae, Re, Ue) {
          return !Z && typeof WebAssembly.instantiateStreaming == "function" && !ni(ae) && typeof fetch == "function" ? fetch(ae, { credentials: "same-origin" }).then((nt) => {
            var At = WebAssembly.instantiateStreaming(nt, Re);
            return At.then(Ue, function(Lt) {
              return O("wasm streaming compile failed: " + Lt), O("falling back to ArrayBuffer instantiation"), Mt(ae, Re, Ue);
            });
          }) : Mt(ae, Re, Ue);
        }
        function rt() {
          var Z = { a: V3 };
          function ae(Ue, nt) {
            var At = Ue.exports;
            return At = z3(At), L = At, F = L._, pe(), je = L.ca, it(L.$), gi(), At;
          }
          Xt();
          function Re(Ue) {
            ae(Ue.instance);
          }
          if (o.instantiateWasm)
            try {
              return o.instantiateWasm(Z, ae);
            } catch (Ue) {
              O("Module.instantiateWasm callback failed with error: " + Ue), l(Ue);
            }
          return ft(R, Ci, Z, Re).catch(l), {};
        }
        var Tt, jt, Jt = (Z) => {
          for (; Z.length > 0; )
            Z.shift()(o);
        };
        function $t(Z) {
          this.excPtr = Z, this.ptr = Z - 24, this.set_type = function(ae) {
            Ne[this.ptr + 4 >>> 2] = ae;
          }, this.get_type = function() {
            return Ne[this.ptr + 4 >>> 2];
          }, this.set_destructor = function(ae) {
            Ne[this.ptr + 8 >>> 2] = ae;
          }, this.get_destructor = function() {
            return Ne[this.ptr + 8 >>> 2];
          }, this.set_caught = function(ae) {
            ae = ae ? 1 : 0, W[this.ptr + 12 >>> 0] = ae;
          }, this.get_caught = function() {
            return W[this.ptr + 12 >>> 0] != 0;
          }, this.set_rethrown = function(ae) {
            ae = ae ? 1 : 0, W[this.ptr + 13 >>> 0] = ae;
          }, this.get_rethrown = function() {
            return W[this.ptr + 13 >>> 0] != 0;
          }, this.init = function(ae, Re) {
            this.set_adjusted_ptr(0), this.set_type(ae), this.set_destructor(Re);
          }, this.set_adjusted_ptr = function(ae) {
            Ne[this.ptr + 16 >>> 2] = ae;
          }, this.get_adjusted_ptr = function() {
            return Ne[this.ptr + 16 >>> 2];
          }, this.get_exception_ptr = function() {
            var ae = sm(this.get_type());
            if (ae)
              return Ne[this.excPtr >>> 2];
            var Re = this.get_adjusted_ptr();
            return Re !== 0 ? Re : this.excPtr;
          };
        }
        var ht = 0;
        function Me(Z, ae) {
          return ae + 2097152 >>> 0 < 4194305 - !!Z ? (Z >>> 0) + ae * 4294967296 : NaN;
        }
        function gt(Z, ae, Re) {
          Z >>>= 0, ae >>>= 0, Re >>>= 0;
          var Ue = new $t(Z);
          throw Ue.init(ae, Re), ht = Z, ht;
        }
        var yt = {};
        function Ut(Z) {
          for (; Z.length; ) {
            var ae = Z.pop(), Re = Z.pop();
            Re(ae);
          }
        }
        function Ht(Z) {
          return this.fromWireType(ee[Z >>> 2]);
        }
        var wi = {}, bi = {}, Hi = {}, Wi = void 0;
        function hi(Z) {
          throw new Wi(Z);
        }
        function Ji(Z, ae, Re) {
          Z.forEach(function(_t) {
            Hi[_t] = ae;
          });
          function Ue(_t) {
            var oi = Re(_t);
            oi.length !== Z.length && hi("Mismatched type converter count");
            for (var mi = 0; mi < Z.length; ++mi)
              ln(Z[mi], oi[mi]);
          }
          var nt = new Array(ae.length), At = [], Lt = 0;
          ae.forEach((_t, oi) => {
            bi.hasOwnProperty(_t) ? nt[oi] = bi[_t] : (At.push(_t), wi.hasOwnProperty(_t) || (wi[_t] = []), wi[_t].push(() => {
              nt[oi] = bi[_t], ++Lt, Lt === At.length && Ue(nt);
            }));
          }), At.length === 0 && Ue(nt);
        }
        function Sn(Z) {
          Z >>>= 0;
          var ae = yt[Z];
          delete yt[Z];
          var Re = ae.elements, Ue = Re.length, nt = Re.map(function(_t) {
            return _t.getterReturnType;
          }).concat(Re.map(function(_t) {
            return _t.setterArgumentType;
          })), At = ae.rawConstructor, Lt = ae.rawDestructor;
          Ji([Z], nt, function(_t) {
            return Re.forEach((oi, mi) => {
              var zi = _t[mi], yn = oi.getter, Xi = oi.getterContext, rn = _t[mi + Ue], Fn = oi.setter, Ps = oi.setterContext;
              oi.read = (Fs) => zi.fromWireType(yn(Xi, Fs)), oi.write = (Fs, uo) => {
                var Ui = [];
                Fn(Ps, Fs, rn.toWireType(Ui, uo)), Ut(Ui);
              };
            }), [{ name: ae.name, fromWireType: function(oi) {
              for (var mi = new Array(Ue), zi = 0; zi < Ue; ++zi)
                mi[zi] = Re[zi].read(oi);
              return Lt(oi), mi;
            }, toWireType: function(oi, mi) {
              if (Ue !== mi.length)
                throw new TypeError(`Incorrect number of tuple elements for ${ae.name}: expected=${Ue}, actual=${mi.length}`);
              for (var zi = At(), yn = 0; yn < Ue; ++yn)
                Re[yn].write(zi, mi[yn]);
              return oi !== null && oi.push(Lt, zi), zi;
            }, argPackAdvance: 8, readValueFromPointer: Ht, destructorFunction: Lt }];
          });
        }
        var nn = {}, Yi = function(Z) {
          Z >>>= 0;
          var ae = nn[Z];
          delete nn[Z];
          var Re = ae.rawConstructor, Ue = ae.rawDestructor, nt = ae.fields, At = nt.map((Lt) => Lt.getterReturnType).concat(nt.map((Lt) => Lt.setterArgumentType));
          Ji([Z], At, (Lt) => {
            var _t = {};
            return nt.forEach((oi, mi) => {
              var zi = oi.fieldName, yn = Lt[mi], Xi = oi.getter, rn = oi.getterContext, Fn = Lt[mi + nt.length], Ps = oi.setter, Fs = oi.setterContext;
              _t[zi] = { read: (uo) => yn.fromWireType(Xi(rn, uo)), write: (uo, Ui) => {
                var Rn = [];
                Ps(Fs, uo, Fn.toWireType(Rn, Ui)), Ut(Rn);
              } };
            }), [{ name: ae.name, fromWireType: function(oi) {
              var mi = {};
              for (var zi in _t)
                mi[zi] = _t[zi].read(oi);
              return Ue(oi), mi;
            }, toWireType: function(oi, mi) {
              for (var zi in _t)
                if (!(zi in mi))
                  throw new TypeError(`Missing field: "${zi}"`);
              var yn = Re();
              for (zi in _t)
                _t[zi].write(yn, mi[zi]);
              return oi !== null && oi.push(Ue, yn), yn;
            }, argPackAdvance: 8, readValueFromPointer: Ht, destructorFunction: Ue }];
          });
        };
        function Pi(Z, ae, Re, Ue, nt) {
        }
        function kt(Z) {
          switch (Z) {
            case 1:
              return 0;
            case 2:
              return 1;
            case 4:
              return 2;
            case 8:
              return 3;
            default:
              throw new TypeError(`Unknown type size: ${Z}`);
          }
        }
        function sn() {
          for (var Z = new Array(256), ae = 0; ae < 256; ++ae)
            Z[ae] = String.fromCharCode(ae);
          Fi = Z;
        }
        var Fi = void 0;
        function tn(Z) {
          for (var ae = "", Re = Z; re[Re >>> 0]; )
            ae += Fi[re[Re++ >>> 0]];
          return ae;
        }
        var Gi = void 0;
        function yi(Z) {
          throw new Gi(Z);
        }
        function bn(Z, ae, Re = {}) {
          var Ue = ae.name;
          if (Z || yi(`type "${Ue}" must have a positive integer typeid pointer`), bi.hasOwnProperty(Z)) {
            if (Re.ignoreDuplicateRegistrations)
              return;
            yi(`Cannot register type '${Ue}' twice`);
          }
          if (bi[Z] = ae, delete Hi[Z], wi.hasOwnProperty(Z)) {
            var nt = wi[Z];
            delete wi[Z], nt.forEach((At) => At());
          }
        }
        function ln(Z, ae, Re = {}) {
          if (!("argPackAdvance" in ae))
            throw new TypeError("registerType registeredInstance requires argPackAdvance");
          return bn(Z, ae, Re);
        }
        function No(Z, ae, Re, Ue, nt) {
          Z >>>= 0, ae >>>= 0, Re >>>= 0;
          var At = kt(Re);
          ae = tn(ae), ln(Z, { name: ae, fromWireType: function(Lt) {
            return !!Lt;
          }, toWireType: function(Lt, _t) {
            return _t ? Ue : nt;
          }, argPackAdvance: 8, readValueFromPointer: function(Lt) {
            var _t;
            if (Re === 1)
              _t = W;
            else if (Re === 2)
              _t = ce;
            else if (Re === 4)
              _t = ee;
            else
              throw new TypeError("Unknown boolean type size: " + ae);
            return this.fromWireType(_t[Lt >>> At]);
          }, destructorFunction: null });
        }
        function Bs(Z) {
          if (!(this instanceof wn) || !(Z instanceof wn))
            return !1;
          for (var ae = this.$$.ptrType.registeredClass, Re = this.$$.ptr, Ue = Z.$$.ptrType.registeredClass, nt = Z.$$.ptr; ae.baseClass; )
            Re = ae.upcast(Re), ae = ae.baseClass;
          for (; Ue.baseClass; )
            nt = Ue.upcast(nt), Ue = Ue.baseClass;
          return ae === Ue && Re === nt;
        }
        function os(Z) {
          return { count: Z.count, deleteScheduled: Z.deleteScheduled, preservePointerOnDelete: Z.preservePointerOnDelete, ptr: Z.ptr, ptrType: Z.ptrType, smartPtr: Z.smartPtr, smartPtrType: Z.smartPtrType };
        }
        function vl(Z) {
          function ae(Re) {
            return Re.$$.ptrType.registeredClass.name;
          }
          yi(ae(Z) + " instance already deleted");
        }
        var zl = !1;
        function Wu(Z) {
        }
        function jl(Z) {
          Z.smartPtr ? Z.smartPtrType.rawDestructor(Z.smartPtr) : Z.ptrType.registeredClass.rawDestructor(Z.ptr);
        }
        function Yu(Z) {
          Z.count.value -= 1;
          var ae = Z.count.value === 0;
          ae && jl(Z);
        }
        function bd(Z, ae, Re) {
          if (ae === Re)
            return Z;
          if (Re.baseClass === void 0)
            return null;
          var Ue = bd(Z, ae, Re.baseClass);
          return Ue === null ? null : Re.downcast(Ue);
        }
        var I0 = {};
        function Gt() {
          return Object.keys(Es).length;
        }
        function Vi() {
          var Z = [];
          for (var ae in Es)
            Es.hasOwnProperty(ae) && Z.push(Es[ae]);
          return Z;
        }
        var _i = [];
        function $n() {
          for (; _i.length; ) {
            var Z = _i.pop();
            Z.$$.deleteScheduled = !1, Z.delete();
          }
        }
        var Os = void 0;
        function Ai(Z) {
          Os = Z, _i.length && Os && Os($n);
        }
        function As() {
          o.getInheritedInstanceCount = Gt, o.getLiveInheritedInstances = Vi, o.flushPendingDeletes = $n, o.setDelayFunction = Ai;
        }
        var Es = {};
        function mr(Z, ae) {
          for (ae === void 0 && yi("ptr should not be undefined"); Z.baseClass; )
            ae = Z.upcast(ae), Z = Z.baseClass;
          return ae;
        }
        function Je(Z, ae) {
          return ae = mr(Z, ae), Es[ae];
        }
        function no(Z, ae) {
          (!ae.ptrType || !ae.ptr) && hi("makeClassHandle requires ptr and ptrType");
          var Re = !!ae.smartPtrType, Ue = !!ae.smartPtr;
          return Re !== Ue && hi("Both smartPtrType and smartPtr must be specified"), ae.count = { value: 1 }, Qt(Object.create(Z, { $$: { value: ae } }));
        }
        function It(Z) {
          var ae = this.getPointee(Z);
          if (!ae)
            return this.destructor(Z), null;
          var Re = Je(this.registeredClass, ae);
          if (Re !== void 0) {
            if (Re.$$.count.value === 0)
              return Re.$$.ptr = ae, Re.$$.smartPtr = Z, Re.clone();
            var Ue = Re.clone();
            return this.destructor(Z), Ue;
          }
          function nt() {
            return this.isSmartPointer ? no(this.registeredClass.instancePrototype, { ptrType: this.pointeeType, ptr: ae, smartPtrType: this, smartPtr: Z }) : no(this.registeredClass.instancePrototype, { ptrType: this, ptr: Z });
          }
          var At = this.registeredClass.getActualType(ae), Lt = I0[At];
          if (!Lt)
            return nt.call(this);
          var _t;
          this.isConst ? _t = Lt.constPointerType : _t = Lt.pointerType;
          var oi = bd(ae, this.registeredClass, _t.registeredClass);
          return oi === null ? nt.call(this) : this.isSmartPointer ? no(_t.registeredClass.instancePrototype, { ptrType: _t, ptr: oi, smartPtrType: this, smartPtr: Z }) : no(_t.registeredClass.instancePrototype, { ptrType: _t, ptr: oi });
        }
        var Qt = function(Z) {
          return typeof FinalizationRegistry > "u" ? (Qt = (ae) => ae, Z) : (zl = new FinalizationRegistry((ae) => {
            Yu(ae.$$);
          }), Qt = (ae) => {
            var Re = ae.$$, Ue = !!Re.smartPtr;
            if (Ue) {
              var nt = { $$: Re };
              zl.register(ae, nt, ae);
            }
            return ae;
          }, Wu = (ae) => zl.unregister(ae), Qt(Z));
        };
        function ci() {
          if (this.$$.ptr || vl(this), this.$$.preservePointerOnDelete)
            return this.$$.count.value += 1, this;
          var Z = Qt(Object.create(Object.getPrototypeOf(this), { $$: { value: os(this.$$) } }));
          return Z.$$.count.value += 1, Z.$$.deleteScheduled = !1, Z;
        }
        function ai() {
          this.$$.ptr || vl(this), this.$$.deleteScheduled && !this.$$.preservePointerOnDelete && yi("Object already scheduled for deletion"), Wu(this), Yu(this.$$), this.$$.preservePointerOnDelete || (this.$$.smartPtr = void 0, this.$$.ptr = void 0);
        }
        function ei() {
          return !this.$$.ptr;
        }
        function Si() {
          return this.$$.ptr || vl(this), this.$$.deleteScheduled && !this.$$.preservePointerOnDelete && yi("Object already scheduled for deletion"), _i.push(this), _i.length === 1 && Os && Os($n), this.$$.deleteScheduled = !0, this;
        }
        function mn() {
          wn.prototype.isAliasOf = Bs, wn.prototype.clone = ci, wn.prototype.delete = ai, wn.prototype.isDeleted = ei, wn.prototype.deleteLater = Si;
        }
        function wn() {
        }
        var Nn = 48, Kn = 57;
        function is(Z) {
          if (Z === void 0)
            return "_unknown";
          Z = Z.replace(/[^a-zA-Z0-9_]/g, "$");
          var ae = Z.charCodeAt(0);
          return ae >= Nn && ae <= Kn ? `_${Z}` : Z;
        }
        function jn(Z, ae) {
          return Z = is(Z), { [Z]: function() {
            return ae.apply(this, arguments);
          } }[Z];
        }
        function _s(Z, ae, Re) {
          if (Z[ae].overloadTable === void 0) {
            var Ue = Z[ae];
            Z[ae] = function() {
              return Z[ae].overloadTable.hasOwnProperty(arguments.length) || yi(`Function '${Re}' called with an invalid number of arguments (${arguments.length}) - expects one of (${Z[ae].overloadTable})!`), Z[ae].overloadTable[arguments.length].apply(this, arguments);
            }, Z[ae].overloadTable = [], Z[ae].overloadTable[Ue.argCount] = Ue;
          }
        }
        function yo(Z, ae, Re) {
          o.hasOwnProperty(Z) ? ((Re === void 0 || o[Z].overloadTable !== void 0 && o[Z].overloadTable[Re] !== void 0) && yi(`Cannot register public name '${Z}' twice`), _s(o, Z, Z), o.hasOwnProperty(Re) && yi(`Cannot register multiple overloads of a function with the same number of arguments (${Re})!`), o[Z].overloadTable[Re] = ae) : (o[Z] = ae, Re !== void 0 && (o[Z].numArguments = Re));
        }
        function Qo(Z, ae, Re, Ue, nt, At, Lt, _t) {
          this.name = Z, this.constructor = ae, this.instancePrototype = Re, this.rawDestructor = Ue, this.baseClass = nt, this.getActualType = At, this.upcast = Lt, this.downcast = _t, this.pureVirtualFunctions = [];
        }
        function so(Z, ae, Re) {
          for (; ae !== Re; )
            ae.upcast || yi(`Expected null or instance of ${Re.name}, got an instance of ${ae.name}`), Z = ae.upcast(Z), ae = ae.baseClass;
          return Z;
        }
        function Eo(Z, ae) {
          if (ae === null)
            return this.isReference && yi(`null is not a valid ${this.name}`), 0;
          ae.$$ || yi(`Cannot pass "${bc(ae)}" as a ${this.name}`), ae.$$.ptr || yi(`Cannot pass deleted object as a pointer of type ${this.name}`);
          var Re = ae.$$.ptrType.registeredClass, Ue = so(ae.$$.ptr, Re, this.registeredClass);
          return Ue;
        }
        function Yn(Z, ae) {
          var Re;
          if (ae === null)
            return this.isReference && yi(`null is not a valid ${this.name}`), this.isSmartPointer ? (Re = this.rawConstructor(), Z !== null && Z.push(this.rawDestructor, Re), Re) : 0;
          ae.$$ || yi(`Cannot pass "${bc(ae)}" as a ${this.name}`), ae.$$.ptr || yi(`Cannot pass deleted object as a pointer of type ${this.name}`), !this.isConst && ae.$$.ptrType.isConst && yi(`Cannot convert argument of type ${ae.$$.smartPtrType ? ae.$$.smartPtrType.name : ae.$$.ptrType.name} to parameter type ${this.name}`);
          var Ue = ae.$$.ptrType.registeredClass;
          if (Re = so(ae.$$.ptr, Ue, this.registeredClass), this.isSmartPointer)
            switch (ae.$$.smartPtr === void 0 && yi("Passing raw pointer to smart pointer is illegal"), this.sharingPolicy) {
              case 0:
                ae.$$.smartPtrType === this ? Re = ae.$$.smartPtr : yi(`Cannot convert argument of type ${ae.$$.smartPtrType ? ae.$$.smartPtrType.name : ae.$$.ptrType.name} to parameter type ${this.name}`);
                break;
              case 1:
                Re = ae.$$.smartPtr;
                break;
              case 2:
                if (ae.$$.smartPtrType === this)
                  Re = ae.$$.smartPtr;
                else {
                  var nt = ae.clone();
                  Re = this.rawShare(Re, go.toHandle(function() {
                    nt.delete();
                  })), Z !== null && Z.push(this.rawDestructor, Re);
                }
                break;
              default:
                yi("Unsupporting sharing policy");
            }
          return Re;
        }
        function Jo(Z, ae) {
          if (ae === null)
            return this.isReference && yi(`null is not a valid ${this.name}`), 0;
          ae.$$ || yi(`Cannot pass "${bc(ae)}" as a ${this.name}`), ae.$$.ptr || yi(`Cannot pass deleted object as a pointer of type ${this.name}`), ae.$$.ptrType.isConst && yi(`Cannot convert argument of type ${ae.$$.ptrType.name} to parameter type ${this.name}`);
          var Re = ae.$$.ptrType.registeredClass, Ue = so(ae.$$.ptr, Re, this.registeredClass);
          return Ue;
        }
        function xs(Z) {
          return this.rawGetPointee && (Z = this.rawGetPointee(Z)), Z;
        }
        function Gr(Z) {
          this.rawDestructor && this.rawDestructor(Z);
        }
        function sa(Z) {
          Z !== null && Z.delete();
        }
        function yr() {
          nr.prototype.getPointee = xs, nr.prototype.destructor = Gr, nr.prototype.argPackAdvance = 8, nr.prototype.readValueFromPointer = Ht, nr.prototype.deleteObject = sa, nr.prototype.fromWireType = It;
        }
        function nr(Z, ae, Re, Ue, nt, At, Lt, _t, oi, mi, zi) {
          this.name = Z, this.registeredClass = ae, this.isReference = Re, this.isConst = Ue, this.isSmartPointer = nt, this.pointeeType = At, this.sharingPolicy = Lt, this.rawGetPointee = _t, this.rawConstructor = oi, this.rawShare = mi, this.rawDestructor = zi, !nt && ae.baseClass === void 0 ? Ue ? (this.toWireType = Eo, this.destructorFunction = null) : (this.toWireType = Jo, this.destructorFunction = null) : this.toWireType = Yn;
        }
        function Ws(Z, ae, Re) {
          o.hasOwnProperty(Z) || hi("Replacing nonexistant public symbol"), o[Z].overloadTable !== void 0 && Re !== void 0 ? o[Z].overloadTable[Re] = ae : (o[Z] = ae, o[Z].argCount = Re);
        }
        var ul = (Z, ae, Re) => {
          var Ue = o["dynCall_" + Z];
          return Re && Re.length ? Ue.apply(null, [ae].concat(Re)) : Ue.call(null, ae);
        }, ur = [], ao = (Z) => {
          var ae = ur[Z];
          return ae || (Z >= ur.length && (ur.length = Z + 1), ur[Z] = ae = je.get(Z)), ae;
        }, kr = (Z, ae, Re) => {
          if (Z.includes("j"))
            return ul(Z, ae, Re);
          var Ue = ao(ae).apply(null, Re);
          return Ue;
        }, oa = (Z, ae) => {
          var Re = [];
          return function() {
            return Re.length = 0, Object.assign(Re, arguments), kr(Z, ae, Re);
          };
        };
        function Po(Z, ae) {
          Z = tn(Z);
          function Re() {
            return Z.includes("j") ? oa(Z, ae) : ao(ae);
          }
          var Ue = Re();
          return typeof Ue != "function" && yi(`unknown function pointer with signature ${Z}: ${ae}`), Ue;
        }
        function NI(Z, ae) {
          var Re = jn(ae, function(Ue) {
            this.name = ae, this.message = Ue;
            var nt = new Error(Ue).stack;
            nt !== void 0 && (this.stack = this.toString() + `
` + nt.replace(/^Error(:[^\n]*)?\n/, ""));
          });
          return Re.prototype = Object.create(Z.prototype), Re.prototype.constructor = Re, Re.prototype.toString = function() {
            return this.message === void 0 ? this.name : `${this.name}: ${this.message}`;
          }, Re;
        }
        var Tc = void 0;
        function bf(Z) {
          var ae = nm(Z), Re = tn(ae);
          return Zu(ae), Re;
        }
        function Rc(Z, ae) {
          var Re = [], Ue = {};
          function nt(At) {
            if (!Ue[At] && !bi[At]) {
              if (Hi[At]) {
                Hi[At].forEach(nt);
                return;
              }
              Re.push(At), Ue[At] = !0;
            }
          }
          throw ae.forEach(nt), new Tc(`${Z}: ` + Re.map(bf).join([", "]));
        }
        function Sr(Z, ae, Re, Ue, nt, At, Lt, _t, oi, mi, zi, yn, Xi) {
          Z >>>= 0, ae >>>= 0, Re >>>= 0, Ue >>>= 0, nt >>>= 0, At >>>= 0, Lt >>>= 0, _t >>>= 0, oi >>>= 0, mi >>>= 0, zi >>>= 0, yn >>>= 0, Xi >>>= 0, zi = tn(zi), At = Po(nt, At), _t && (_t = Po(Lt, _t)), mi && (mi = Po(oi, mi)), Xi = Po(yn, Xi);
          var rn = is(zi);
          yo(rn, function() {
            Rc(`Cannot construct ${zi} due to unbound types`, [Ue]);
          }), Ji([Z, ae, Re], Ue ? [Ue] : [], function(Fn) {
            Fn = Fn[0];
            var Ps, Fs;
            Ue ? (Ps = Fn.registeredClass, Fs = Ps.instancePrototype) : Fs = wn.prototype;
            var uo = jn(rn, function() {
              if (Object.getPrototypeOf(this) !== Ui)
                throw new Gi("Use 'new' to construct " + zi);
              if (Rn.constructor_body === void 0)
                throw new Gi(zi + " has no accessible constructor");
              var cr = Rn.constructor_body[arguments.length];
              if (cr === void 0)
                throw new Gi(`Tried to invoke ctor of ${zi} with invalid number of parameters (${arguments.length}) - expected (${Object.keys(Rn.constructor_body).toString()}) parameters instead!`);
              return cr.apply(this, arguments);
            }), Ui = Object.create(Fs, { constructor: { value: uo } });
            uo.prototype = Ui;
            var Rn = new Qo(zi, uo, Ui, Xi, Ps, At, _t, mi);
            Rn.baseClass && (Rn.baseClass.__derivedClasses === void 0 && (Rn.baseClass.__derivedClasses = []), Rn.baseClass.__derivedClasses.push(Rn));
            var Vo = new nr(zi, Rn, !0, !1, !1), Do = new nr(zi + "*", Rn, !1, !1, !1), Pl = new nr(zi + " const*", Rn, !1, !0, !1);
            return I0[Z] = { pointerType: Do, constPointerType: Pl }, Ws(rn, uo), [Vo, Do, Pl];
          });
        }
        function ra(Z, ae) {
          for (var Re = [], Ue = 0; Ue < Z; Ue++)
            Re.push(Ne[ae + Ue * 4 >>> 2]);
          return Re;
        }
        function Ls(Z, ae) {
          if (!(Z instanceof Function))
            throw new TypeError(`new_ called with constructor type ${typeof Z} which is not a function`);
          var Re = jn(Z.name || "unknownFunctionName", function() {
          });
          Re.prototype = Z.prototype;
          var Ue = new Re(), nt = Z.apply(Ue, ae);
          return nt instanceof Object ? nt : Ue;
        }
        function vc(Z, ae, Re, Ue, nt, At) {
          var Lt = ae.length;
          Lt < 2 && yi("argTypes array size mismatch! Must at least get return value and 'this' types!");
          for (var _t = ae[1] !== null && Re !== null, oi = !1, mi = 1; mi < ae.length; ++mi)
            if (ae[mi] !== null && ae[mi].destructorFunction === void 0) {
              oi = !0;
              break;
            }
          for (var zi = ae[0].name !== "void", yn = "", Xi = "", mi = 0; mi < Lt - 2; ++mi)
            yn += (mi !== 0 ? ", " : "") + "arg" + mi, Xi += (mi !== 0 ? ", " : "") + "arg" + mi + "Wired";
          var rn = `
        return function ${is(Z)}(${yn}) {
        if (arguments.length !== ${Lt - 2}) {
          throwBindingError('function ${Z} called with ${arguments.length} arguments, expected ${Lt - 2} args!');
        }`;
          oi && (rn += `var destructors = [];
`);
          var Fn = oi ? "destructors" : "null", Ps = ["throwBindingError", "invoker", "fn", "runDestructors", "retType", "classParam"], Fs = [yi, Ue, nt, Ut, ae[0], ae[1]];
          _t && (rn += "var thisWired = classParam.toWireType(" + Fn + `, this);
`);
          for (var mi = 0; mi < Lt - 2; ++mi)
            rn += "var arg" + mi + "Wired = argType" + mi + ".toWireType(" + Fn + ", arg" + mi + "); // " + ae[mi + 2].name + `
`, Ps.push("argType" + mi), Fs.push(ae[mi + 2]);
          if (_t && (Xi = "thisWired" + (Xi.length > 0 ? ", " : "") + Xi), rn += (zi || At ? "var rv = " : "") + "invoker(fn" + (Xi.length > 0 ? ", " : "") + Xi + `);
`, oi)
            rn += `runDestructors(destructors);
`;
          else
            for (var mi = _t ? 1 : 2; mi < ae.length; ++mi) {
              var uo = mi === 1 ? "thisWired" : "arg" + (mi - 2) + "Wired";
              ae[mi].destructorFunction !== null && (rn += uo + "_dtor(" + uo + "); // " + ae[mi].name + `
`, Ps.push(uo + "_dtor"), Fs.push(ae[mi].destructorFunction));
            }
          return zi && (rn += `var ret = retType.fromWireType(rv);
return ret;
`), rn += `}
`, Ps.push(rn), Ls(Function, Ps).apply(null, Fs);
        }
        function la(Z, ae, Re, Ue, nt, At) {
          Z >>>= 0, Re >>>= 0, Ue >>>= 0, nt >>>= 0, At >>>= 0;
          var Lt = ra(ae, Re);
          nt = Po(Ue, nt), Ji([], [Z], function(_t) {
            _t = _t[0];
            var oi = `constructor ${_t.name}`;
            if (_t.registeredClass.constructor_body === void 0 && (_t.registeredClass.constructor_body = []), _t.registeredClass.constructor_body[ae - 1] !== void 0)
              throw new Gi(`Cannot register multiple constructors with identical number of parameters (${ae - 1}) for class '${_t.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
            return _t.registeredClass.constructor_body[ae - 1] = () => {
              Rc(`Cannot construct ${_t.name} due to unbound types`, Lt);
            }, Ji([], Lt, function(mi) {
              return mi.splice(1, 0, null), _t.registeredClass.constructor_body[ae - 1] = vc(oi, mi, null, nt, At), [];
            }), [];
          });
        }
        function Nf(Z, ae, Re, Ue, nt, At, Lt, _t, oi) {
          Z >>>= 0, ae >>>= 0, Ue >>>= 0, nt >>>= 0, At >>>= 0, Lt >>>= 0;
          var mi = ra(Re, Ue);
          ae = tn(ae), At = Po(nt, At), Ji([], [Z], function(zi) {
            zi = zi[0];
            var yn = `${zi.name}.${ae}`;
            ae.startsWith("@@") && (ae = Symbol[ae.substring(2)]), _t && zi.registeredClass.pureVirtualFunctions.push(ae);
            function Xi() {
              Rc(`Cannot call ${yn} due to unbound types`, mi);
            }
            var rn = zi.registeredClass.instancePrototype, Fn = rn[ae];
            return Fn === void 0 || Fn.overloadTable === void 0 && Fn.className !== zi.name && Fn.argCount === Re - 2 ? (Xi.argCount = Re - 2, Xi.className = zi.name, rn[ae] = Xi) : (_s(rn, ae, yn), rn[ae].overloadTable[Re - 2] = Xi), Ji([], mi, function(Ps) {
              var Fs = vc(yn, Ps, zi, At, Lt, oi);
              return rn[ae].overloadTable === void 0 ? (Fs.argCount = Re - 2, rn[ae] = Fs) : rn[ae].overloadTable[Re - 2] = Fs, [];
            }), [];
          });
        }
        function DI() {
          Object.assign(Df.prototype, { get(Z) {
            return this.allocated[Z];
          }, has(Z) {
            return this.allocated[Z] !== void 0;
          }, allocate(Z) {
            var ae = this.freelist.pop() || this.allocated.length;
            return this.allocated[ae] = Z, ae;
          }, free(Z) {
            this.allocated[Z] = void 0, this.freelist.push(Z);
          } });
        }
        function Df() {
          this.allocated = [void 0], this.freelist = [];
        }
        var dl = new Df();
        function Ac(Z) {
          Z >>>= 0, Z >= dl.reserved && --dl.get(Z).refcount === 0 && dl.free(Z);
        }
        function Sc() {
          for (var Z = 0, ae = dl.reserved; ae < dl.allocated.length; ++ae)
            dl.allocated[ae] !== void 0 && ++Z;
          return Z;
        }
        function CI() {
          dl.allocated.push({ value: void 0 }, { value: null }, { value: !0 }, { value: !1 }), dl.reserved = dl.allocated.length, o.count_emval_handles = Sc;
        }
        var go = { toValue: (Z) => (Z || yi("Cannot use deleted val. handle = " + Z), dl.get(Z).value), toHandle: (Z) => {
          switch (Z) {
            case void 0:
              return 1;
            case null:
              return 2;
            case !0:
              return 3;
            case !1:
              return 4;
            default:
              return dl.allocate({ refcount: 1, value: Z });
          }
        } };
        function Cf(Z, ae) {
          Z >>>= 0, ae >>>= 0, ae = tn(ae), ln(Z, { name: ae, fromWireType: function(Re) {
            var Ue = go.toValue(Re);
            return Ac(Re), Ue;
          }, toWireType: function(Re, Ue) {
            return go.toHandle(Ue);
          }, argPackAdvance: 8, readValueFromPointer: Ht, destructorFunction: null });
        }
        function bc(Z) {
          if (Z === null)
            return "null";
          var ae = typeof Z;
          return ae === "object" || ae === "array" || ae === "function" ? Z.toString() : "" + Z;
        }
        function OI(Z, ae) {
          switch (ae) {
            case 2:
              return function(Re) {
                return this.fromWireType(Ae[Re >>> 2]);
              };
            case 3:
              return function(Re) {
                return this.fromWireType(Oe[Re >>> 3]);
              };
            default:
              throw new TypeError("Unknown float type: " + Z);
          }
        }
        function Of(Z, ae, Re) {
          Z >>>= 0, ae >>>= 0, Re >>>= 0;
          var Ue = kt(Re);
          ae = tn(ae), ln(Z, { name: ae, fromWireType: function(nt) {
            return nt;
          }, toWireType: function(nt, At) {
            return At;
          }, argPackAdvance: 8, readValueFromPointer: OI(ae, Ue), destructorFunction: null });
        }
        function xt(Z, ae, Re, Ue, nt, At, Lt) {
          Z >>>= 0, Re >>>= 0, Ue >>>= 0, nt >>>= 0, At >>>= 0;
          var _t = ra(ae, Re);
          Z = tn(Z), nt = Po(Ue, nt), yo(Z, function() {
            Rc(`Cannot call ${Z} due to unbound types`, _t);
          }, ae - 1), Ji([], _t, function(oi) {
            var mi = [oi[0], null].concat(oi.slice(1));
            return Ws(Z, vc(Z, mi, null, nt, At, Lt), ae - 1), [];
          });
        }
        function li(Z, ae, Re) {
          switch (ae) {
            case 0:
              return Re ? function(nt) {
                return W[nt >>> 0];
              } : function(nt) {
                return re[nt >>> 0];
              };
            case 1:
              return Re ? function(nt) {
                return ce[nt >>> 1];
              } : function(nt) {
                return te[nt >>> 1];
              };
            case 2:
              return Re ? function(nt) {
                return ee[nt >>> 2];
              } : function(nt) {
                return Ne[nt >>> 2];
              };
            default:
              throw new TypeError("Unknown integer type: " + Z);
          }
        }
        function qi(Z, ae, Re, Ue, nt) {
          Z >>>= 0, ae >>>= 0, Re >>>= 0, ae = tn(ae);
          var At = kt(Re), Lt = (yn) => yn;
          if (Ue === 0) {
            var _t = 32 - 8 * Re;
            Lt = (yn) => yn << _t >>> _t;
          }
          var oi = ae.includes("unsigned"), mi = (yn, Xi) => {
          }, zi;
          oi ? zi = function(yn, Xi) {
            return mi(Xi, this.name), Xi >>> 0;
          } : zi = function(yn, Xi) {
            return mi(Xi, this.name), Xi;
          }, ln(Z, { name: ae, fromWireType: Lt, toWireType: zi, argPackAdvance: 8, readValueFromPointer: li(ae, At, Ue !== 0), destructorFunction: null });
        }
        function un(Z, ae, Re) {
          Z >>>= 0, Re >>>= 0;
          var Ue = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array], nt = Ue[ae];
          function At(Lt) {
            Lt = Lt >> 2;
            var _t = Ne, oi = _t[Lt >>> 0], mi = _t[Lt + 1 >>> 0];
            return new nt(_t.buffer, mi, oi);
          }
          Re = tn(Re), ln(Z, { name: Re, fromWireType: At, argPackAdvance: 8, readValueFromPointer: At }, { ignoreDuplicateRegistrations: !0 });
        }
        var Mn = (Z, ae, Re, Ue) => {
          if (Re >>>= 0, !(Ue > 0)) return 0;
          for (var nt = Re, At = Re + Ue - 1, Lt = 0; Lt < Z.length; ++Lt) {
            var _t = Z.charCodeAt(Lt);
            if (_t >= 55296 && _t <= 57343) {
              var oi = Z.charCodeAt(++Lt);
              _t = 65536 + ((_t & 1023) << 10) | oi & 1023;
            }
            if (_t <= 127) {
              if (Re >= At) break;
              ae[Re++ >>> 0] = _t;
            } else if (_t <= 2047) {
              if (Re + 1 >= At) break;
              ae[Re++ >>> 0] = 192 | _t >> 6, ae[Re++ >>> 0] = 128 | _t & 63;
            } else if (_t <= 65535) {
              if (Re + 2 >= At) break;
              ae[Re++ >>> 0] = 224 | _t >> 12, ae[Re++ >>> 0] = 128 | _t >> 6 & 63, ae[Re++ >>> 0] = 128 | _t & 63;
            } else {
              if (Re + 3 >= At) break;
              ae[Re++ >>> 0] = 240 | _t >> 18, ae[Re++ >>> 0] = 128 | _t >> 12 & 63, ae[Re++ >>> 0] = 128 | _t >> 6 & 63, ae[Re++ >>> 0] = 128 | _t & 63;
            }
          }
          return ae[Re >>> 0] = 0, Re - nt;
        }, Pn = (Z, ae, Re) => Mn(Z, re, ae, Re), ws = (Z) => {
          for (var ae = 0, Re = 0; Re < Z.length; ++Re) {
            var Ue = Z.charCodeAt(Re);
            Ue <= 127 ? ae++ : Ue <= 2047 ? ae += 2 : Ue >= 55296 && Ue <= 57343 ? (ae += 4, ++Re) : ae += 3;
          }
          return ae;
        }, Ys = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0, Ss = (Z, ae, Re) => {
          ae >>>= 0;
          for (var Ue = ae + Re, nt = ae; Z[nt] && !(nt >= Ue); ) ++nt;
          if (nt - ae > 16 && Z.buffer && Ys)
            return Ys.decode(Z.subarray(ae, nt));
          for (var At = ""; ae < nt; ) {
            var Lt = Z[ae++];
            if (!(Lt & 128)) {
              At += String.fromCharCode(Lt);
              continue;
            }
            var _t = Z[ae++] & 63;
            if ((Lt & 224) == 192) {
              At += String.fromCharCode((Lt & 31) << 6 | _t);
              continue;
            }
            var oi = Z[ae++] & 63;
            if ((Lt & 240) == 224 ? Lt = (Lt & 15) << 12 | _t << 6 | oi : Lt = (Lt & 7) << 18 | _t << 12 | oi << 6 | Z[ae++] & 63, Lt < 65536)
              At += String.fromCharCode(Lt);
            else {
              var mi = Lt - 65536;
              At += String.fromCharCode(55296 | mi >> 10, 56320 | mi & 1023);
            }
          }
          return At;
        }, dr = (Z, ae) => (Z >>>= 0, Z ? Ss(re, Z, ae) : "");
        function Vr(Z, ae) {
          Z >>>= 0, ae >>>= 0, ae = tn(ae);
          var Re = ae === "std::string";
          ln(Z, { name: ae, fromWireType: function(Ue) {
            var nt = Ne[Ue >>> 2], At = Ue + 4, Lt;
            if (Re)
              for (var _t = At, oi = 0; oi <= nt; ++oi) {
                var mi = At + oi;
                if (oi == nt || re[mi >>> 0] == 0) {
                  var zi = mi - _t, yn = dr(_t, zi);
                  Lt === void 0 ? Lt = yn : (Lt += "\0", Lt += yn), _t = mi + 1;
                }
              }
            else {
              for (var Xi = new Array(nt), oi = 0; oi < nt; ++oi)
                Xi[oi] = String.fromCharCode(re[At + oi >>> 0]);
              Lt = Xi.join("");
            }
            return Zu(Ue), Lt;
          }, toWireType: function(Ue, nt) {
            nt instanceof ArrayBuffer && (nt = new Uint8Array(nt));
            var At, Lt = typeof nt == "string";
            Lt || nt instanceof Uint8Array || nt instanceof Uint8ClampedArray || nt instanceof Int8Array || yi("Cannot pass non-string to std::string"), Re && Lt ? At = ws(nt) : At = nt.length;
            var _t = kf(4 + At + 1), oi = _t + 4;
            if (Ne[_t >>> 2] = At, Re && Lt)
              Pn(nt, oi, At + 1);
            else if (Lt)
              for (var mi = 0; mi < At; ++mi) {
                var zi = nt.charCodeAt(mi);
                zi > 255 && (Zu(oi), yi("String has UTF-16 code units that do not fit in 8 bits")), re[oi + mi >>> 0] = zi;
              }
            else
              for (var mi = 0; mi < At; ++mi)
                re[oi + mi >>> 0] = nt[mi];
            return Ue !== null && Ue.push(Zu, _t), _t;
          }, argPackAdvance: 8, readValueFromPointer: Ht, destructorFunction: function(Ue) {
            Zu(Ue);
          } });
        }
        var _l = typeof TextDecoder < "u" ? new TextDecoder("utf-16le") : void 0, p0 = (Z, ae) => {
          for (var Re = Z, Ue = Re >> 1, nt = Ue + ae / 2; !(Ue >= nt) && te[Ue >>> 0]; ) ++Ue;
          if (Re = Ue << 1, Re - Z > 32 && _l) return _l.decode(re.subarray(Z >>> 0, Re >>> 0));
          for (var At = "", Lt = 0; !(Lt >= ae / 2); ++Lt) {
            var _t = ce[Z + Lt * 2 >>> 1];
            if (_t == 0) break;
            At += String.fromCharCode(_t);
          }
          return At;
        }, Lf = (Z, ae, Re) => {
          if (Re === void 0 && (Re = 2147483647), Re < 2) return 0;
          Re -= 2;
          for (var Ue = ae, nt = Re < Z.length * 2 ? Re / 2 : Z.length, At = 0; At < nt; ++At) {
            var Lt = Z.charCodeAt(At);
            ce[ae >>> 1] = Lt, ae += 2;
          }
          return ce[ae >>> 1] = 0, ae - Ue;
        }, _f = (Z) => Z.length * 2, xf = (Z, ae) => {
          for (var Re = 0, Ue = ""; !(Re >= ae / 4); ) {
            var nt = ee[Z + Re * 4 >>> 2];
            if (nt == 0) break;
            if (++Re, nt >= 65536) {
              var At = nt - 65536;
              Ue += String.fromCharCode(55296 | At >> 10, 56320 | At & 1023);
            } else
              Ue += String.fromCharCode(nt);
          }
          return Ue;
        }, aa = (Z, ae, Re) => {
          if (ae >>>= 0, Re === void 0 && (Re = 2147483647), Re < 4) return 0;
          for (var Ue = ae, nt = Ue + Re - 4, At = 0; At < Z.length; ++At) {
            var Lt = Z.charCodeAt(At);
            if (Lt >= 55296 && Lt <= 57343) {
              var _t = Z.charCodeAt(++At);
              Lt = 65536 + ((Lt & 1023) << 10) | _t & 1023;
            }
            if (ee[ae >>> 2] = Lt, ae += 4, ae + 4 > nt) break;
          }
          return ee[ae >>> 2] = 0, ae - Ue;
        }, Ih = (Z) => {
          for (var ae = 0, Re = 0; Re < Z.length; ++Re) {
            var Ue = Z.charCodeAt(Re);
            Ue >= 55296 && Ue <= 57343 && ++Re, ae += 4;
          }
          return ae;
        }, ph = function(Z, ae, Re) {
          Z >>>= 0, ae >>>= 0, Re >>>= 0, Re = tn(Re);
          var Ue, nt, At, Lt, _t;
          ae === 2 ? (Ue = p0, nt = Lf, Lt = _f, At = () => te, _t = 1) : ae === 4 && (Ue = xf, nt = aa, Lt = Ih, At = () => Ne, _t = 2), ln(Z, { name: Re, fromWireType: function(oi) {
            for (var mi = Ne[oi >>> 2], zi = At(), yn, Xi = oi + 4, rn = 0; rn <= mi; ++rn) {
              var Fn = oi + 4 + rn * ae;
              if (rn == mi || zi[Fn >>> _t] == 0) {
                var Ps = Fn - Xi, Fs = Ue(Xi, Ps);
                yn === void 0 ? yn = Fs : (yn += "\0", yn += Fs), Xi = Fn + ae;
              }
            }
            return Zu(oi), yn;
          }, toWireType: function(oi, mi) {
            typeof mi != "string" && yi(`Cannot pass non-string to C++ string type ${Re}`);
            var zi = Lt(mi), yn = kf(4 + zi + ae);
            return Ne[yn >>> 2] = zi >> _t, nt(mi, yn + 4, zi + ae), oi !== null && oi.push(Zu, yn), yn;
          }, argPackAdvance: 8, readValueFromPointer: Ht, destructorFunction: function(oi) {
            Zu(oi);
          } });
        };
        function m0(Z, ae, Re, Ue, nt, At) {
          Z >>>= 0, ae >>>= 0, Re >>>= 0, Ue >>>= 0, nt >>>= 0, At >>>= 0, yt[Z] = { name: tn(ae), rawConstructor: Po(Re, Ue), rawDestructor: Po(nt, At), elements: [] };
        }
        function Nc(Z, ae, Re, Ue, nt, At, Lt, _t, oi) {
          Z >>>= 0, ae >>>= 0, Re >>>= 0, Ue >>>= 0, nt >>>= 0, At >>>= 0, Lt >>>= 0, _t >>>= 0, oi >>>= 0, yt[Z].elements.push({ getterReturnType: ae, getter: Po(Re, Ue), getterContext: nt, setterArgumentType: At, setter: Po(Lt, _t), setterContext: oi });
        }
        function Nd(Z, ae, Re, Ue, nt, At) {
          Z >>>= 0, ae >>>= 0, Re >>>= 0, Ue >>>= 0, nt >>>= 0, At >>>= 0, nn[Z] = { name: tn(ae), rawConstructor: Po(Re, Ue), rawDestructor: Po(nt, At), fields: [] };
        }
        function Dd(Z, ae, Re, Ue, nt, At, Lt, _t, oi, mi) {
          Z >>>= 0, ae >>>= 0, Re >>>= 0, Ue >>>= 0, nt >>>= 0, At >>>= 0, Lt >>>= 0, _t >>>= 0, oi >>>= 0, mi >>>= 0, nn[Z].fields.push({ fieldName: tn(ae), getterReturnType: Re, getter: Po(Ue, nt), getterContext: At, setterArgumentType: Lt, setter: Po(_t, oi), setterContext: mi });
        }
        function Dc(Z, ae) {
          Z >>>= 0, ae >>>= 0, ae = tn(ae), ln(Z, { isVoid: !0, name: ae, argPackAdvance: 0, fromWireType: function() {
          }, toWireType: function(Re, Ue) {
          } });
        }
        var Cc = !0, mh = () => Cc;
        function Go(Z, ae) {
          var Re = bi[Z];
          return Re === void 0 && yi(ae + " has unknown type " + bf(Z)), Re;
        }
        function Oc(Z, ae, Re) {
          Z >>>= 0, ae >>>= 0, Re >>>= 0, Z = go.toValue(Z), ae = Go(ae, "emval::as");
          var Ue = [], nt = go.toHandle(Ue);
          return Ne[Re >>> 2] = nt, ae.toWireType(Ue, Z);
        }
        function Lc(Z, ae) {
          for (var Re = new Array(Z), Ue = 0; Ue < Z; ++Ue)
            Re[Ue] = Go(Ne[ae + Ue * 4 >>> 2], "parameter " + Ue);
          return Re;
        }
        function _c(Z, ae, Re, Ue) {
          Z >>>= 0, Re >>>= 0, Ue >>>= 0, Z = go.toValue(Z);
          for (var nt = Lc(ae, Re), At = new Array(ae), Lt = 0; Lt < ae; ++Lt) {
            var _t = nt[Lt];
            At[Lt] = _t.readValueFromPointer(Ue), Ue += _t.argPackAdvance;
          }
          var oi = Z.apply(void 0, At);
          return go.toHandle(oi);
        }
        var xc = {};
        function Cd(Z) {
          var ae = xc[Z];
          return ae === void 0 ? tn(Z) : ae;
        }
        function xl() {
          return typeof globalThis == "object" ? globalThis : (/* @__PURE__ */ (function() {
            return Function;
          })())("return this")();
        }
        function yh(Z) {
          return Z >>>= 0, Z === 0 ? go.toHandle(xl()) : (Z = Cd(Z), go.toHandle(xl()[Z]));
        }
        function Eh(Z, ae) {
          return Z >>>= 0, ae >>>= 0, Z = go.toValue(Z), ae = go.toValue(ae), go.toHandle(Z[ae]);
        }
        function LI(Z) {
          Z >>>= 0, Z > 4 && (dl.get(Z).refcount += 1);
        }
        function Pf(Z, ae) {
          return Z >>>= 0, ae >>>= 0, Z = go.toValue(Z), ae = go.toValue(ae), Z instanceof ae;
        }
        function Bi(Z) {
          return Z >>>= 0, Z = go.toValue(Z), typeof Z == "number";
        }
        function qu(Z) {
          return Z >>>= 0, Z = go.toValue(Z), typeof Z == "string";
        }
        function Ru() {
          return go.toHandle([]);
        }
        function Pc(Z) {
          return Z >>>= 0, go.toHandle(Cd(Z));
        }
        function Od() {
          return go.toHandle({});
        }
        function gh(Z) {
          Z >>>= 0;
          var ae = go.toValue(Z);
          Ut(ae), Ac(Z);
        }
        function Mc(Z, ae, Re) {
          Z >>>= 0, ae >>>= 0, Re >>>= 0, Z = go.toValue(Z), ae = go.toValue(ae), Re = go.toValue(Re), Z[ae] = Re;
        }
        function Uc(Z, ae) {
          Z >>>= 0, ae >>>= 0, Z = Go(Z, "_emval_take_value");
          var Re = Z.readValueFromPointer(ae);
          return go.toHandle(Re);
        }
        function $u(Z, ae, Re) {
          var Ue = Me(Z, ae);
          Re >>>= 0;
          var nt = new Date(Ue * 1e3);
          ee[Re >>> 2] = nt.getUTCSeconds(), ee[Re + 4 >>> 2] = nt.getUTCMinutes(), ee[Re + 8 >>> 2] = nt.getUTCHours(), ee[Re + 12 >>> 2] = nt.getUTCDate(), ee[Re + 16 >>> 2] = nt.getUTCMonth(), ee[Re + 20 >>> 2] = nt.getUTCFullYear() - 1900, ee[Re + 24 >>> 2] = nt.getUTCDay();
          var At = Date.UTC(nt.getUTCFullYear(), 0, 1, 0, 0, 0, 0), Lt = (nt.getTime() - At) / (1e3 * 60 * 60 * 24) | 0;
          ee[Re + 28 >>> 2] = Lt;
        }
        var ua = (Z) => Z % 4 === 0 && (Z % 100 !== 0 || Z % 400 === 0), Bc = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335], Fc = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], y0 = (Z) => {
          var ae = ua(Z.getFullYear()), Re = ae ? Bc : Fc, Ue = Re[Z.getMonth()] + Z.getDate() - 1;
          return Ue;
        };
        function Wl(Z, ae, Re) {
          var Ue = Me(Z, ae);
          Re >>>= 0;
          var nt = new Date(Ue * 1e3);
          ee[Re >>> 2] = nt.getSeconds(), ee[Re + 4 >>> 2] = nt.getMinutes(), ee[Re + 8 >>> 2] = nt.getHours(), ee[Re + 12 >>> 2] = nt.getDate(), ee[Re + 16 >>> 2] = nt.getMonth(), ee[Re + 20 >>> 2] = nt.getFullYear() - 1900, ee[Re + 24 >>> 2] = nt.getDay();
          var At = y0(nt) | 0;
          ee[Re + 28 >>> 2] = At, ee[Re + 36 >>> 2] = -(nt.getTimezoneOffset() * 60);
          var Lt = new Date(nt.getFullYear(), 0, 1), _t = new Date(nt.getFullYear(), 6, 1).getTimezoneOffset(), oi = Lt.getTimezoneOffset(), mi = (_t != oi && nt.getTimezoneOffset() == Math.min(oi, _t)) | 0;
          ee[Re + 32 >>> 2] = mi;
        }
        var Mf = (Z) => {
          var ae = ws(Z) + 1, Re = kf(ae);
          return Re && Pn(Z, Re, ae), Re;
        };
        function m3(Z, ae, Re) {
          Z >>>= 0, ae >>>= 0, Re >>>= 0;
          var Ue = (/* @__PURE__ */ new Date()).getFullYear(), nt = new Date(Ue, 0, 1), At = new Date(Ue, 6, 1), Lt = nt.getTimezoneOffset(), _t = At.getTimezoneOffset(), oi = Math.max(Lt, _t);
          Ne[Z >>> 2] = oi * 60, ee[ae >>> 2] = +(Lt != _t);
          function mi(Fn) {
            var Ps = Fn.toTimeString().match(/\(([A-Za-z ]+)\)$/);
            return Ps ? Ps[1] : "GMT";
          }
          var zi = mi(nt), yn = mi(At), Xi = Mf(zi), rn = Mf(yn);
          _t < Lt ? (Ne[Re >>> 2] = Xi, Ne[Re + 4 >>> 2] = rn) : (Ne[Re >>> 2] = rn, Ne[Re + 4 >>> 2] = Xi);
        }
        var y3 = () => {
          Wt("");
        };
        function ko() {
          return Date.now();
        }
        function E3(Z, ae, Re) {
          return Z >>>= 0, ae >>>= 0, Re >>>= 0, re.copyWithin(Z >>> 0, ae >>> 0, ae + Re >>> 0);
        }
        var _I = () => 4294901760, g3 = (Z) => {
          var ae = F.buffer, Re = Z - ae.byteLength + 65535 >>> 16;
          try {
            return F.grow(Re), pe(), 1;
          } catch {
          }
        };
        function w3(Z) {
          Z >>>= 0;
          var ae = re.length, Re = _I();
          if (Z > Re)
            return !1;
          for (var Ue = (oi, mi) => oi + (mi - oi % mi) % mi, nt = 1; nt <= 4; nt *= 2) {
            var At = ae * (1 + 0.2 / nt);
            At = Math.min(At, Z + 100663296);
            var Lt = Math.min(Re, Ue(Math.max(Z, At), 65536)), _t = g3(Lt);
            if (_t)
              return !0;
          }
          return !1;
        }
        var xI = {}, T3 = () => h || "./this.program", wh = () => {
          if (!wh.strings) {
            var Z = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", ae = { USER: "web_user", LOGNAME: "web_user", PATH: "/", PWD: "/", HOME: "/home/web_user", LANG: Z, _: T3() };
            for (var Re in xI)
              xI[Re] === void 0 ? delete ae[Re] : ae[Re] = xI[Re];
            var Ue = [];
            for (var Re in ae)
              Ue.push(`${Re}=${ae[Re]}`);
            wh.strings = Ue;
          }
          return wh.strings;
        }, R3 = (Z, ae) => {
          for (var Re = 0; Re < Z.length; ++Re)
            W[ae++ >>> 0] = Z.charCodeAt(Re);
          W[ae >>> 0] = 0;
        }, Qs = { isAbs: (Z) => Z.charAt(0) === "/", splitPath: (Z) => {
          var ae = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
          return ae.exec(Z).slice(1);
        }, normalizeArray: (Z, ae) => {
          for (var Re = 0, Ue = Z.length - 1; Ue >= 0; Ue--) {
            var nt = Z[Ue];
            nt === "." ? Z.splice(Ue, 1) : nt === ".." ? (Z.splice(Ue, 1), Re++) : Re && (Z.splice(Ue, 1), Re--);
          }
          if (ae)
            for (; Re; Re--)
              Z.unshift("..");
          return Z;
        }, normalize: (Z) => {
          var ae = Qs.isAbs(Z), Re = Z.substr(-1) === "/";
          return Z = Qs.normalizeArray(Z.split("/").filter((Ue) => !!Ue), !ae).join("/"), !Z && !ae && (Z = "."), Z && Re && (Z += "/"), (ae ? "/" : "") + Z;
        }, dirname: (Z) => {
          var ae = Qs.splitPath(Z), Re = ae[0], Ue = ae[1];
          return !Re && !Ue ? "." : (Ue && (Ue = Ue.substr(0, Ue.length - 1)), Re + Ue);
        }, basename: (Z) => {
          if (Z === "/") return "/";
          Z = Qs.normalize(Z), Z = Z.replace(/\/$/, "");
          var ae = Z.lastIndexOf("/");
          return ae === -1 ? Z : Z.substr(ae + 1);
        }, join: function() {
          var Z = Array.prototype.slice.call(arguments);
          return Qs.normalize(Z.join("/"));
        }, join2: (Z, ae) => Qs.normalize(Z + "/" + ae) }, v3 = () => {
          if (typeof crypto == "object" && typeof crypto.getRandomValues == "function")
            return (Z) => crypto.getRandomValues(Z);
          Wt("initRandomDevice");
        }, Uf = (Z) => (Uf = v3())(Z), Ku = { resolve: function() {
          for (var Z = "", ae = !1, Re = arguments.length - 1; Re >= -1 && !ae; Re--) {
            var Ue = Re >= 0 ? arguments[Re] : st.cwd();
            if (typeof Ue != "string")
              throw new TypeError("Arguments to path.resolve must be strings");
            if (!Ue)
              return "";
            Z = Ue + "/" + Z, ae = Qs.isAbs(Ue);
          }
          return Z = Qs.normalizeArray(Z.split("/").filter((nt) => !!nt), !ae).join("/"), (ae ? "/" : "") + Z || ".";
        }, relative: (Z, ae) => {
          Z = Ku.resolve(Z).substr(1), ae = Ku.resolve(ae).substr(1);
          function Re(mi) {
            for (var zi = 0; zi < mi.length && mi[zi] === ""; zi++)
              ;
            for (var yn = mi.length - 1; yn >= 0 && mi[yn] === ""; yn--)
              ;
            return zi > yn ? [] : mi.slice(zi, yn - zi + 1);
          }
          for (var Ue = Re(Z.split("/")), nt = Re(ae.split("/")), At = Math.min(Ue.length, nt.length), Lt = At, _t = 0; _t < At; _t++)
            if (Ue[_t] !== nt[_t]) {
              Lt = _t;
              break;
            }
          for (var oi = [], _t = Lt; _t < Ue.length; _t++)
            oi.push("..");
          return oi = oi.concat(nt.slice(Lt)), oi.join("/");
        } }, PI = [];
        function Bf(Z, ae, Re) {
          var Ue = ws(Z) + 1, nt = new Array(Ue), At = Mn(Z, nt, 0, nt.length);
          return ae && (nt.length = At), nt;
        }
        var A3 = () => {
          if (!PI.length) {
            var Z = null;
            if (typeof window < "u" && typeof window.prompt == "function" ? (Z = window.prompt("Input: "), Z !== null && (Z += `
`)) : typeof readline == "function" && (Z = readline(), Z !== null && (Z += `
`)), !Z)
              return null;
            PI = Bf(Z, !0);
          }
          return PI.shift();
        }, Hc = { ttys: [], init: function() {
        }, shutdown: function() {
        }, register: function(Z, ae) {
          Hc.ttys[Z] = { input: [], output: [], ops: ae }, st.registerDevice(Z, Hc.stream_ops);
        }, stream_ops: { open: function(Z) {
          var ae = Hc.ttys[Z.node.rdev];
          if (!ae)
            throw new st.ErrnoError(43);
          Z.tty = ae, Z.seekable = !1;
        }, close: function(Z) {
          Z.tty.ops.fsync(Z.tty);
        }, fsync: function(Z) {
          Z.tty.ops.fsync(Z.tty);
        }, read: function(Z, ae, Re, Ue, nt) {
          if (!Z.tty || !Z.tty.ops.get_char)
            throw new st.ErrnoError(60);
          for (var At = 0, Lt = 0; Lt < Ue; Lt++) {
            var _t;
            try {
              _t = Z.tty.ops.get_char(Z.tty);
            } catch {
              throw new st.ErrnoError(29);
            }
            if (_t === void 0 && At === 0)
              throw new st.ErrnoError(6);
            if (_t == null) break;
            At++, ae[Re + Lt] = _t;
          }
          return At && (Z.node.timestamp = Date.now()), At;
        }, write: function(Z, ae, Re, Ue, nt) {
          if (!Z.tty || !Z.tty.ops.put_char)
            throw new st.ErrnoError(60);
          try {
            for (var At = 0; At < Ue; At++)
              Z.tty.ops.put_char(Z.tty, ae[Re + At]);
          } catch {
            throw new st.ErrnoError(29);
          }
          return Ue && (Z.node.timestamp = Date.now()), At;
        } }, default_tty_ops: { get_char: function(Z) {
          return A3();
        }, put_char: function(Z, ae) {
          ae === null || ae === 10 ? (C(Ss(Z.output, 0)), Z.output = []) : ae != 0 && Z.output.push(ae);
        }, fsync: function(Z) {
          Z.output && Z.output.length > 0 && (C(Ss(Z.output, 0)), Z.output = []);
        }, ioctl_tcgets: function(Z) {
          return { c_iflag: 25856, c_oflag: 5, c_cflag: 191, c_lflag: 35387, c_cc: [3, 28, 127, 21, 4, 0, 1, 0, 17, 19, 26, 0, 18, 15, 23, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] };
        }, ioctl_tcsets: function(Z, ae, Re) {
          return 0;
        }, ioctl_tiocgwinsz: function(Z) {
          return [24, 80];
        } }, default_tty1_ops: { put_char: function(Z, ae) {
          ae === null || ae === 10 ? (O(Ss(Z.output, 0)), Z.output = []) : ae != 0 && Z.output.push(ae);
        }, fsync: function(Z) {
          Z.output && Z.output.length > 0 && (O(Ss(Z.output, 0)), Z.output = []);
        } } }, tm = (Z) => {
          Wt();
        }, hs = { ops_table: null, mount(Z) {
          return hs.createNode(null, "/", 16895, 0);
        }, createNode(Z, ae, Re, Ue) {
          if (st.isBlkdev(Re) || st.isFIFO(Re))
            throw new st.ErrnoError(63);
          hs.ops_table || (hs.ops_table = { dir: { node: { getattr: hs.node_ops.getattr, setattr: hs.node_ops.setattr, lookup: hs.node_ops.lookup, mknod: hs.node_ops.mknod, rename: hs.node_ops.rename, unlink: hs.node_ops.unlink, rmdir: hs.node_ops.rmdir, readdir: hs.node_ops.readdir, symlink: hs.node_ops.symlink }, stream: { llseek: hs.stream_ops.llseek } }, file: { node: { getattr: hs.node_ops.getattr, setattr: hs.node_ops.setattr }, stream: { llseek: hs.stream_ops.llseek, read: hs.stream_ops.read, write: hs.stream_ops.write, allocate: hs.stream_ops.allocate, mmap: hs.stream_ops.mmap, msync: hs.stream_ops.msync } }, link: { node: { getattr: hs.node_ops.getattr, setattr: hs.node_ops.setattr, readlink: hs.node_ops.readlink }, stream: {} }, chrdev: { node: { getattr: hs.node_ops.getattr, setattr: hs.node_ops.setattr }, stream: st.chrdev_stream_ops } });
          var nt = st.createNode(Z, ae, Re, Ue);
          return st.isDir(nt.mode) ? (nt.node_ops = hs.ops_table.dir.node, nt.stream_ops = hs.ops_table.dir.stream, nt.contents = {}) : st.isFile(nt.mode) ? (nt.node_ops = hs.ops_table.file.node, nt.stream_ops = hs.ops_table.file.stream, nt.usedBytes = 0, nt.contents = null) : st.isLink(nt.mode) ? (nt.node_ops = hs.ops_table.link.node, nt.stream_ops = hs.ops_table.link.stream) : st.isChrdev(nt.mode) && (nt.node_ops = hs.ops_table.chrdev.node, nt.stream_ops = hs.ops_table.chrdev.stream), nt.timestamp = Date.now(), Z && (Z.contents[ae] = nt, Z.timestamp = nt.timestamp), nt;
        }, getFileDataAsTypedArray(Z) {
          return Z.contents ? Z.contents.subarray ? Z.contents.subarray(0, Z.usedBytes) : new Uint8Array(Z.contents) : new Uint8Array(0);
        }, expandFileStorage(Z, ae) {
          var Re = Z.contents ? Z.contents.length : 0;
          if (!(Re >= ae)) {
            var Ue = 1024 * 1024;
            ae = Math.max(ae, Re * (Re < Ue ? 2 : 1.125) >>> 0), Re != 0 && (ae = Math.max(ae, 256));
            var nt = Z.contents;
            Z.contents = new Uint8Array(ae), Z.usedBytes > 0 && Z.contents.set(nt.subarray(0, Z.usedBytes), 0);
          }
        }, resizeFileStorage(Z, ae) {
          if (Z.usedBytes != ae)
            if (ae == 0)
              Z.contents = null, Z.usedBytes = 0;
            else {
              var Re = Z.contents;
              Z.contents = new Uint8Array(ae), Re && Z.contents.set(Re.subarray(0, Math.min(ae, Z.usedBytes))), Z.usedBytes = ae;
            }
        }, node_ops: { getattr(Z) {
          var ae = {};
          return ae.dev = st.isChrdev(Z.mode) ? Z.id : 1, ae.ino = Z.id, ae.mode = Z.mode, ae.nlink = 1, ae.uid = 0, ae.gid = 0, ae.rdev = Z.rdev, st.isDir(Z.mode) ? ae.size = 4096 : st.isFile(Z.mode) ? ae.size = Z.usedBytes : st.isLink(Z.mode) ? ae.size = Z.link.length : ae.size = 0, ae.atime = new Date(Z.timestamp), ae.mtime = new Date(Z.timestamp), ae.ctime = new Date(Z.timestamp), ae.blksize = 4096, ae.blocks = Math.ceil(ae.size / ae.blksize), ae;
        }, setattr(Z, ae) {
          ae.mode !== void 0 && (Z.mode = ae.mode), ae.timestamp !== void 0 && (Z.timestamp = ae.timestamp), ae.size !== void 0 && hs.resizeFileStorage(Z, ae.size);
        }, lookup(Z, ae) {
          throw st.genericErrors[44];
        }, mknod(Z, ae, Re, Ue) {
          return hs.createNode(Z, ae, Re, Ue);
        }, rename(Z, ae, Re) {
          if (st.isDir(Z.mode)) {
            var Ue;
            try {
              Ue = st.lookupNode(ae, Re);
            } catch {
            }
            if (Ue)
              for (var nt in Ue.contents)
                throw new st.ErrnoError(55);
          }
          delete Z.parent.contents[Z.name], Z.parent.timestamp = Date.now(), Z.name = Re, ae.contents[Re] = Z, ae.timestamp = Z.parent.timestamp, Z.parent = ae;
        }, unlink(Z, ae) {
          delete Z.contents[ae], Z.timestamp = Date.now();
        }, rmdir(Z, ae) {
          var Re = st.lookupNode(Z, ae);
          for (var Ue in Re.contents)
            throw new st.ErrnoError(55);
          delete Z.contents[ae], Z.timestamp = Date.now();
        }, readdir(Z) {
          var ae = [".", ".."];
          for (var Re in Z.contents)
            Z.contents.hasOwnProperty(Re) && ae.push(Re);
          return ae;
        }, symlink(Z, ae, Re) {
          var Ue = hs.createNode(Z, ae, 41471, 0);
          return Ue.link = Re, Ue;
        }, readlink(Z) {
          if (!st.isLink(Z.mode))
            throw new st.ErrnoError(28);
          return Z.link;
        } }, stream_ops: { read(Z, ae, Re, Ue, nt) {
          var At = Z.node.contents;
          if (nt >= Z.node.usedBytes) return 0;
          var Lt = Math.min(Z.node.usedBytes - nt, Ue);
          if (Lt > 8 && At.subarray)
            ae.set(At.subarray(nt, nt + Lt), Re);
          else
            for (var _t = 0; _t < Lt; _t++) ae[Re + _t] = At[nt + _t];
          return Lt;
        }, write(Z, ae, Re, Ue, nt, At) {
          if (ae.buffer === W.buffer && (At = !1), !Ue) return 0;
          var Lt = Z.node;
          if (Lt.timestamp = Date.now(), ae.subarray && (!Lt.contents || Lt.contents.subarray)) {
            if (At)
              return Lt.contents = ae.subarray(Re, Re + Ue), Lt.usedBytes = Ue, Ue;
            if (Lt.usedBytes === 0 && nt === 0)
              return Lt.contents = ae.slice(Re, Re + Ue), Lt.usedBytes = Ue, Ue;
            if (nt + Ue <= Lt.usedBytes)
              return Lt.contents.set(ae.subarray(Re, Re + Ue), nt), Ue;
          }
          if (hs.expandFileStorage(Lt, nt + Ue), Lt.contents.subarray && ae.subarray)
            Lt.contents.set(ae.subarray(Re, Re + Ue), nt);
          else
            for (var _t = 0; _t < Ue; _t++)
              Lt.contents[nt + _t] = ae[Re + _t];
          return Lt.usedBytes = Math.max(Lt.usedBytes, nt + Ue), Ue;
        }, llseek(Z, ae, Re) {
          var Ue = ae;
          if (Re === 1 ? Ue += Z.position : Re === 2 && st.isFile(Z.node.mode) && (Ue += Z.node.usedBytes), Ue < 0)
            throw new st.ErrnoError(28);
          return Ue;
        }, allocate(Z, ae, Re) {
          hs.expandFileStorage(Z.node, ae + Re), Z.node.usedBytes = Math.max(Z.node.usedBytes, ae + Re);
        }, mmap(Z, ae, Re, Ue, nt) {
          if (!st.isFile(Z.node.mode))
            throw new st.ErrnoError(43);
          var At, Lt, _t = Z.node.contents;
          if (!(nt & 2) && _t.buffer === W.buffer)
            Lt = !1, At = _t.byteOffset;
          else {
            if ((Re > 0 || Re + ae < _t.length) && (_t.subarray ? _t = _t.subarray(Re, Re + ae) : _t = Array.prototype.slice.call(_t, Re, Re + ae)), Lt = !0, At = tm(), !At)
              throw new st.ErrnoError(48);
            W.set(_t, At >>> 0);
          }
          return { ptr: At, allocated: Lt };
        }, msync(Z, ae, Re, Ue, nt) {
          return hs.stream_ops.write(Z, ae, 0, Ue, Re, !1), 0;
        } } }, S3 = (Z, ae, Re, Ue) => {
          var nt = `al ${Z}`;
          A(Z, (At) => {
            z(At, `Loading data file "${Z}" failed (no arrayBuffer).`), ae(new Uint8Array(At)), nt && gi();
          }, (At) => {
            if (Re)
              Re();
            else
              throw `Loading data file "${Z}" failed.`;
          }), nt && Xt();
        }, b3 = o.preloadPlugins || [];
        function N3(Z, ae, Re, Ue) {
          typeof Browser < "u" && Browser.init();
          var nt = !1;
          return b3.forEach(function(At) {
            nt || At.canHandle(ae) && (At.handle(Z, ae, Re, Ue), nt = !0);
          }), nt;
        }
        function D3(Z, ae, Re, Ue, nt, At, Lt, _t, oi, mi) {
          var zi = ae ? Ku.resolve(Qs.join2(Z, ae)) : Z;
          function yn(Xi) {
            function rn(Fn) {
              mi && mi(), _t || st.createDataFile(Z, ae, Fn, Ue, nt, oi), At && At(), gi();
            }
            N3(Xi, zi, rn, () => {
              Lt && Lt(), gi();
            }) || rn(Xi);
          }
          Xt(), typeof Re == "string" ? S3(Re, (Xi) => yn(Xi), Lt) : yn(Re);
        }
        function C3(Z) {
          var ae = { r: 0, "r+": 2, w: 577, "w+": 578, a: 1089, "a+": 1090 }, Re = ae[Z];
          if (typeof Re > "u")
            throw new Error(`Unknown file open mode: ${Z}`);
          return Re;
        }
        function MI(Z, ae) {
          var Re = 0;
          return Z && (Re |= 365), ae && (Re |= 146), Re;
        }
        var st = { root: null, mounts: [], devices: {}, streams: [], nextInode: 1, nameTable: null, currentPath: "/", initialized: !1, ignorePermissions: !0, ErrnoError: null, genericErrors: {}, filesystems: null, syncFSRequests: 0, lookupPath: (Z, ae = {}) => {
          if (Z = Ku.resolve(Z), !Z) return { path: "", node: null };
          var Re = { follow_mount: !0, recurse_count: 0 };
          if (ae = Object.assign(Re, ae), ae.recurse_count > 8)
            throw new st.ErrnoError(32);
          for (var Ue = Z.split("/").filter((yn) => !!yn), nt = st.root, At = "/", Lt = 0; Lt < Ue.length; Lt++) {
            var _t = Lt === Ue.length - 1;
            if (_t && ae.parent)
              break;
            if (nt = st.lookupNode(nt, Ue[Lt]), At = Qs.join2(At, Ue[Lt]), st.isMountpoint(nt) && (!_t || _t && ae.follow_mount) && (nt = nt.mounted.root), !_t || ae.follow)
              for (var oi = 0; st.isLink(nt.mode); ) {
                var mi = st.readlink(At);
                At = Ku.resolve(Qs.dirname(At), mi);
                var zi = st.lookupPath(At, { recurse_count: ae.recurse_count + 1 });
                if (nt = zi.node, oi++ > 40)
                  throw new st.ErrnoError(32);
              }
          }
          return { path: At, node: nt };
        }, getPath: (Z) => {
          for (var ae; ; ) {
            if (st.isRoot(Z)) {
              var Re = Z.mount.mountpoint;
              return ae ? Re[Re.length - 1] !== "/" ? `${Re}/${ae}` : Re + ae : Re;
            }
            ae = ae ? `${Z.name}/${ae}` : Z.name, Z = Z.parent;
          }
        }, hashName: (Z, ae) => {
          for (var Re = 0, Ue = 0; Ue < ae.length; Ue++)
            Re = (Re << 5) - Re + ae.charCodeAt(Ue) | 0;
          return (Z + Re >>> 0) % st.nameTable.length;
        }, hashAddNode: (Z) => {
          var ae = st.hashName(Z.parent.id, Z.name);
          Z.name_next = st.nameTable[ae], st.nameTable[ae] = Z;
        }, hashRemoveNode: (Z) => {
          var ae = st.hashName(Z.parent.id, Z.name);
          if (st.nameTable[ae] === Z)
            st.nameTable[ae] = Z.name_next;
          else
            for (var Re = st.nameTable[ae]; Re; ) {
              if (Re.name_next === Z) {
                Re.name_next = Z.name_next;
                break;
              }
              Re = Re.name_next;
            }
        }, lookupNode: (Z, ae) => {
          var Re = st.mayLookup(Z);
          if (Re)
            throw new st.ErrnoError(Re, Z);
          for (var Ue = st.hashName(Z.id, ae), nt = st.nameTable[Ue]; nt; nt = nt.name_next) {
            var At = nt.name;
            if (nt.parent.id === Z.id && At === ae)
              return nt;
          }
          return st.lookup(Z, ae);
        }, createNode: (Z, ae, Re, Ue) => {
          var nt = new st.FSNode(Z, ae, Re, Ue);
          return st.hashAddNode(nt), nt;
        }, destroyNode: (Z) => {
          st.hashRemoveNode(Z);
        }, isRoot: (Z) => Z === Z.parent, isMountpoint: (Z) => !!Z.mounted, isFile: (Z) => (Z & 61440) === 32768, isDir: (Z) => (Z & 61440) === 16384, isLink: (Z) => (Z & 61440) === 40960, isChrdev: (Z) => (Z & 61440) === 8192, isBlkdev: (Z) => (Z & 61440) === 24576, isFIFO: (Z) => (Z & 61440) === 4096, isSocket: (Z) => (Z & 49152) === 49152, flagsToPermissionString: (Z) => {
          var ae = ["r", "w", "rw"][Z & 3];
          return Z & 512 && (ae += "w"), ae;
        }, nodePermissions: (Z, ae) => st.ignorePermissions ? 0 : ae.includes("r") && !(Z.mode & 292) || ae.includes("w") && !(Z.mode & 146) || ae.includes("x") && !(Z.mode & 73) ? 2 : 0, mayLookup: (Z) => {
          var ae = st.nodePermissions(Z, "x");
          return ae || (Z.node_ops.lookup ? 0 : 2);
        }, mayCreate: (Z, ae) => {
          try {
            var Re = st.lookupNode(Z, ae);
            return 20;
          } catch {
          }
          return st.nodePermissions(Z, "wx");
        }, mayDelete: (Z, ae, Re) => {
          var Ue;
          try {
            Ue = st.lookupNode(Z, ae);
          } catch (At) {
            return At.errno;
          }
          var nt = st.nodePermissions(Z, "wx");
          if (nt)
            return nt;
          if (Re) {
            if (!st.isDir(Ue.mode))
              return 54;
            if (st.isRoot(Ue) || st.getPath(Ue) === st.cwd())
              return 10;
          } else if (st.isDir(Ue.mode))
            return 31;
          return 0;
        }, mayOpen: (Z, ae) => Z ? st.isLink(Z.mode) ? 32 : st.isDir(Z.mode) && (st.flagsToPermissionString(ae) !== "r" || ae & 512) ? 31 : st.nodePermissions(Z, st.flagsToPermissionString(ae)) : 44, MAX_OPEN_FDS: 4096, nextfd: () => {
          for (var Z = 0; Z <= st.MAX_OPEN_FDS; Z++)
            if (!st.streams[Z])
              return Z;
          throw new st.ErrnoError(33);
        }, getStreamChecked: (Z) => {
          var ae = st.getStream(Z);
          if (!ae)
            throw new st.ErrnoError(8);
          return ae;
        }, getStream: (Z) => st.streams[Z], createStream: (Z, ae = -1) => (st.FSStream || (st.FSStream = function() {
          this.shared = {};
        }, st.FSStream.prototype = {}, Object.defineProperties(st.FSStream.prototype, { object: { get() {
          return this.node;
        }, set(Re) {
          this.node = Re;
        } }, isRead: { get() {
          return (this.flags & 2097155) !== 1;
        } }, isWrite: { get() {
          return (this.flags & 2097155) !== 0;
        } }, isAppend: { get() {
          return this.flags & 1024;
        } }, flags: { get() {
          return this.shared.flags;
        }, set(Re) {
          this.shared.flags = Re;
        } }, position: { get() {
          return this.shared.position;
        }, set(Re) {
          this.shared.position = Re;
        } } })), Z = Object.assign(new st.FSStream(), Z), ae == -1 && (ae = st.nextfd()), Z.fd = ae, st.streams[ae] = Z, Z), closeStream: (Z) => {
          st.streams[Z] = null;
        }, chrdev_stream_ops: { open: (Z) => {
          var ae = st.getDevice(Z.node.rdev);
          Z.stream_ops = ae.stream_ops, Z.stream_ops.open && Z.stream_ops.open(Z);
        }, llseek: () => {
          throw new st.ErrnoError(70);
        } }, major: (Z) => Z >> 8, minor: (Z) => Z & 255, makedev: (Z, ae) => Z << 8 | ae, registerDevice: (Z, ae) => {
          st.devices[Z] = { stream_ops: ae };
        }, getDevice: (Z) => st.devices[Z], getMounts: (Z) => {
          for (var ae = [], Re = [Z]; Re.length; ) {
            var Ue = Re.pop();
            ae.push(Ue), Re.push.apply(Re, Ue.mounts);
          }
          return ae;
        }, syncfs: (Z, ae) => {
          typeof Z == "function" && (ae = Z, Z = !1), st.syncFSRequests++, st.syncFSRequests > 1 && O(`warning: ${st.syncFSRequests} FS.syncfs operations in flight at once, probably just doing extra work`);
          var Re = st.getMounts(st.root.mount), Ue = 0;
          function nt(Lt) {
            return st.syncFSRequests--, ae(Lt);
          }
          function At(Lt) {
            if (Lt)
              return At.errored ? void 0 : (At.errored = !0, nt(Lt));
            ++Ue >= Re.length && nt(null);
          }
          Re.forEach((Lt) => {
            if (!Lt.type.syncfs)
              return At(null);
            Lt.type.syncfs(Lt, Z, At);
          });
        }, mount: (Z, ae, Re) => {
          var Ue = Re === "/", nt = !Re, At;
          if (Ue && st.root)
            throw new st.ErrnoError(10);
          if (!Ue && !nt) {
            var Lt = st.lookupPath(Re, { follow_mount: !1 });
            if (Re = Lt.path, At = Lt.node, st.isMountpoint(At))
              throw new st.ErrnoError(10);
            if (!st.isDir(At.mode))
              throw new st.ErrnoError(54);
          }
          var _t = { type: Z, opts: ae, mountpoint: Re, mounts: [] }, oi = Z.mount(_t);
          return oi.mount = _t, _t.root = oi, Ue ? st.root = oi : At && (At.mounted = _t, At.mount && At.mount.mounts.push(_t)), oi;
        }, unmount: (Z) => {
          var ae = st.lookupPath(Z, { follow_mount: !1 });
          if (!st.isMountpoint(ae.node))
            throw new st.ErrnoError(28);
          var Re = ae.node, Ue = Re.mounted, nt = st.getMounts(Ue);
          Object.keys(st.nameTable).forEach((Lt) => {
            for (var _t = st.nameTable[Lt]; _t; ) {
              var oi = _t.name_next;
              nt.includes(_t.mount) && st.destroyNode(_t), _t = oi;
            }
          }), Re.mounted = null;
          var At = Re.mount.mounts.indexOf(Ue);
          Re.mount.mounts.splice(At, 1);
        }, lookup: (Z, ae) => Z.node_ops.lookup(Z, ae), mknod: (Z, ae, Re) => {
          var Ue = st.lookupPath(Z, { parent: !0 }), nt = Ue.node, At = Qs.basename(Z);
          if (!At || At === "." || At === "..")
            throw new st.ErrnoError(28);
          var Lt = st.mayCreate(nt, At);
          if (Lt)
            throw new st.ErrnoError(Lt);
          if (!nt.node_ops.mknod)
            throw new st.ErrnoError(63);
          return nt.node_ops.mknod(nt, At, ae, Re);
        }, create: (Z, ae) => (ae = ae !== void 0 ? ae : 438, ae &= 4095, ae |= 32768, st.mknod(Z, ae, 0)), mkdir: (Z, ae) => (ae = ae !== void 0 ? ae : 511, ae &= 1023, ae |= 16384, st.mknod(Z, ae, 0)), mkdirTree: (Z, ae) => {
          for (var Re = Z.split("/"), Ue = "", nt = 0; nt < Re.length; ++nt)
            if (Re[nt]) {
              Ue += "/" + Re[nt];
              try {
                st.mkdir(Ue, ae);
              } catch (At) {
                if (At.errno != 20) throw At;
              }
            }
        }, mkdev: (Z, ae, Re) => (typeof Re > "u" && (Re = ae, ae = 438), ae |= 8192, st.mknod(Z, ae, Re)), symlink: (Z, ae) => {
          if (!Ku.resolve(Z))
            throw new st.ErrnoError(44);
          var Re = st.lookupPath(ae, { parent: !0 }), Ue = Re.node;
          if (!Ue)
            throw new st.ErrnoError(44);
          var nt = Qs.basename(ae), At = st.mayCreate(Ue, nt);
          if (At)
            throw new st.ErrnoError(At);
          if (!Ue.node_ops.symlink)
            throw new st.ErrnoError(63);
          return Ue.node_ops.symlink(Ue, nt, Z);
        }, rename: (Z, ae) => {
          var Re = Qs.dirname(Z), Ue = Qs.dirname(ae), nt = Qs.basename(Z), At = Qs.basename(ae), Lt, _t, oi;
          if (Lt = st.lookupPath(Z, { parent: !0 }), _t = Lt.node, Lt = st.lookupPath(ae, { parent: !0 }), oi = Lt.node, !_t || !oi) throw new st.ErrnoError(44);
          if (_t.mount !== oi.mount)
            throw new st.ErrnoError(75);
          var mi = st.lookupNode(_t, nt), zi = Ku.relative(Z, Ue);
          if (zi.charAt(0) !== ".")
            throw new st.ErrnoError(28);
          if (zi = Ku.relative(ae, Re), zi.charAt(0) !== ".")
            throw new st.ErrnoError(55);
          var yn;
          try {
            yn = st.lookupNode(oi, At);
          } catch {
          }
          if (mi !== yn) {
            var Xi = st.isDir(mi.mode), rn = st.mayDelete(_t, nt, Xi);
            if (rn)
              throw new st.ErrnoError(rn);
            if (rn = yn ? st.mayDelete(oi, At, Xi) : st.mayCreate(oi, At), rn)
              throw new st.ErrnoError(rn);
            if (!_t.node_ops.rename)
              throw new st.ErrnoError(63);
            if (st.isMountpoint(mi) || yn && st.isMountpoint(yn))
              throw new st.ErrnoError(10);
            if (oi !== _t && (rn = st.nodePermissions(_t, "w"), rn))
              throw new st.ErrnoError(rn);
            st.hashRemoveNode(mi);
            try {
              _t.node_ops.rename(mi, oi, At);
            } catch (Fn) {
              throw Fn;
            } finally {
              st.hashAddNode(mi);
            }
          }
        }, rmdir: (Z) => {
          var ae = st.lookupPath(Z, { parent: !0 }), Re = ae.node, Ue = Qs.basename(Z), nt = st.lookupNode(Re, Ue), At = st.mayDelete(Re, Ue, !0);
          if (At)
            throw new st.ErrnoError(At);
          if (!Re.node_ops.rmdir)
            throw new st.ErrnoError(63);
          if (st.isMountpoint(nt))
            throw new st.ErrnoError(10);
          Re.node_ops.rmdir(Re, Ue), st.destroyNode(nt);
        }, readdir: (Z) => {
          var ae = st.lookupPath(Z, { follow: !0 }), Re = ae.node;
          if (!Re.node_ops.readdir)
            throw new st.ErrnoError(54);
          return Re.node_ops.readdir(Re);
        }, unlink: (Z) => {
          var ae = st.lookupPath(Z, { parent: !0 }), Re = ae.node;
          if (!Re)
            throw new st.ErrnoError(44);
          var Ue = Qs.basename(Z), nt = st.lookupNode(Re, Ue), At = st.mayDelete(Re, Ue, !1);
          if (At)
            throw new st.ErrnoError(At);
          if (!Re.node_ops.unlink)
            throw new st.ErrnoError(63);
          if (st.isMountpoint(nt))
            throw new st.ErrnoError(10);
          Re.node_ops.unlink(Re, Ue), st.destroyNode(nt);
        }, readlink: (Z) => {
          var ae = st.lookupPath(Z), Re = ae.node;
          if (!Re)
            throw new st.ErrnoError(44);
          if (!Re.node_ops.readlink)
            throw new st.ErrnoError(28);
          return Ku.resolve(st.getPath(Re.parent), Re.node_ops.readlink(Re));
        }, stat: (Z, ae) => {
          var Re = st.lookupPath(Z, { follow: !ae }), Ue = Re.node;
          if (!Ue)
            throw new st.ErrnoError(44);
          if (!Ue.node_ops.getattr)
            throw new st.ErrnoError(63);
          return Ue.node_ops.getattr(Ue);
        }, lstat: (Z) => st.stat(Z, !0), chmod: (Z, ae, Re) => {
          var Ue;
          if (typeof Z == "string") {
            var nt = st.lookupPath(Z, { follow: !Re });
            Ue = nt.node;
          } else
            Ue = Z;
          if (!Ue.node_ops.setattr)
            throw new st.ErrnoError(63);
          Ue.node_ops.setattr(Ue, { mode: ae & 4095 | Ue.mode & -4096, timestamp: Date.now() });
        }, lchmod: (Z, ae) => {
          st.chmod(Z, ae, !0);
        }, fchmod: (Z, ae) => {
          var Re = st.getStreamChecked(Z);
          st.chmod(Re.node, ae);
        }, chown: (Z, ae, Re, Ue) => {
          var nt;
          if (typeof Z == "string") {
            var At = st.lookupPath(Z, { follow: !Ue });
            nt = At.node;
          } else
            nt = Z;
          if (!nt.node_ops.setattr)
            throw new st.ErrnoError(63);
          nt.node_ops.setattr(nt, { timestamp: Date.now() });
        }, lchown: (Z, ae, Re) => {
          st.chown(Z, ae, Re, !0);
        }, fchown: (Z, ae, Re) => {
          var Ue = st.getStreamChecked(Z);
          st.chown(Ue.node, ae, Re);
        }, truncate: (Z, ae) => {
          if (ae < 0)
            throw new st.ErrnoError(28);
          var Re;
          if (typeof Z == "string") {
            var Ue = st.lookupPath(Z, { follow: !0 });
            Re = Ue.node;
          } else
            Re = Z;
          if (!Re.node_ops.setattr)
            throw new st.ErrnoError(63);
          if (st.isDir(Re.mode))
            throw new st.ErrnoError(31);
          if (!st.isFile(Re.mode))
            throw new st.ErrnoError(28);
          var nt = st.nodePermissions(Re, "w");
          if (nt)
            throw new st.ErrnoError(nt);
          Re.node_ops.setattr(Re, { size: ae, timestamp: Date.now() });
        }, ftruncate: (Z, ae) => {
          var Re = st.getStreamChecked(Z);
          if ((Re.flags & 2097155) === 0)
            throw new st.ErrnoError(28);
          st.truncate(Re.node, ae);
        }, utime: (Z, ae, Re) => {
          var Ue = st.lookupPath(Z, { follow: !0 }), nt = Ue.node;
          nt.node_ops.setattr(nt, { timestamp: Math.max(ae, Re) });
        }, open: (Z, ae, Re) => {
          if (Z === "")
            throw new st.ErrnoError(44);
          ae = typeof ae == "string" ? C3(ae) : ae, Re = typeof Re > "u" ? 438 : Re, ae & 64 ? Re = Re & 4095 | 32768 : Re = 0;
          var Ue;
          if (typeof Z == "object")
            Ue = Z;
          else {
            Z = Qs.normalize(Z);
            try {
              var nt = st.lookupPath(Z, { follow: !(ae & 131072) });
              Ue = nt.node;
            } catch {
            }
          }
          var At = !1;
          if (ae & 64)
            if (Ue) {
              if (ae & 128)
                throw new st.ErrnoError(20);
            } else
              Ue = st.mknod(Z, Re, 0), At = !0;
          if (!Ue)
            throw new st.ErrnoError(44);
          if (st.isChrdev(Ue.mode) && (ae &= -513), ae & 65536 && !st.isDir(Ue.mode))
            throw new st.ErrnoError(54);
          if (!At) {
            var Lt = st.mayOpen(Ue, ae);
            if (Lt)
              throw new st.ErrnoError(Lt);
          }
          ae & 512 && !At && st.truncate(Ue, 0), ae &= -131713;
          var _t = st.createStream({ node: Ue, path: st.getPath(Ue), flags: ae, seekable: !0, position: 0, stream_ops: Ue.stream_ops, ungotten: [], error: !1 });
          return _t.stream_ops.open && _t.stream_ops.open(_t), o.logReadFiles && !(ae & 1) && (st.readFiles || (st.readFiles = {}), Z in st.readFiles || (st.readFiles[Z] = 1)), _t;
        }, close: (Z) => {
          if (st.isClosed(Z))
            throw new st.ErrnoError(8);
          Z.getdents && (Z.getdents = null);
          try {
            Z.stream_ops.close && Z.stream_ops.close(Z);
          } catch (ae) {
            throw ae;
          } finally {
            st.closeStream(Z.fd);
          }
          Z.fd = null;
        }, isClosed: (Z) => Z.fd === null, llseek: (Z, ae, Re) => {
          if (st.isClosed(Z))
            throw new st.ErrnoError(8);
          if (!Z.seekable || !Z.stream_ops.llseek)
            throw new st.ErrnoError(70);
          if (Re != 0 && Re != 1 && Re != 2)
            throw new st.ErrnoError(28);
          return Z.position = Z.stream_ops.llseek(Z, ae, Re), Z.ungotten = [], Z.position;
        }, read: (Z, ae, Re, Ue, nt) => {
          if (Ue < 0 || nt < 0)
            throw new st.ErrnoError(28);
          if (st.isClosed(Z))
            throw new st.ErrnoError(8);
          if ((Z.flags & 2097155) === 1)
            throw new st.ErrnoError(8);
          if (st.isDir(Z.node.mode))
            throw new st.ErrnoError(31);
          if (!Z.stream_ops.read)
            throw new st.ErrnoError(28);
          var At = typeof nt < "u";
          if (!At)
            nt = Z.position;
          else if (!Z.seekable)
            throw new st.ErrnoError(70);
          var Lt = Z.stream_ops.read(Z, ae, Re, Ue, nt);
          return At || (Z.position += Lt), Lt;
        }, write: (Z, ae, Re, Ue, nt, At) => {
          if (Ue < 0 || nt < 0)
            throw new st.ErrnoError(28);
          if (st.isClosed(Z))
            throw new st.ErrnoError(8);
          if ((Z.flags & 2097155) === 0)
            throw new st.ErrnoError(8);
          if (st.isDir(Z.node.mode))
            throw new st.ErrnoError(31);
          if (!Z.stream_ops.write)
            throw new st.ErrnoError(28);
          Z.seekable && Z.flags & 1024 && st.llseek(Z, 0, 2);
          var Lt = typeof nt < "u";
          if (!Lt)
            nt = Z.position;
          else if (!Z.seekable)
            throw new st.ErrnoError(70);
          var _t = Z.stream_ops.write(Z, ae, Re, Ue, nt, At);
          return Lt || (Z.position += _t), _t;
        }, allocate: (Z, ae, Re) => {
          if (st.isClosed(Z))
            throw new st.ErrnoError(8);
          if (ae < 0 || Re <= 0)
            throw new st.ErrnoError(28);
          if ((Z.flags & 2097155) === 0)
            throw new st.ErrnoError(8);
          if (!st.isFile(Z.node.mode) && !st.isDir(Z.node.mode))
            throw new st.ErrnoError(43);
          if (!Z.stream_ops.allocate)
            throw new st.ErrnoError(138);
          Z.stream_ops.allocate(Z, ae, Re);
        }, mmap: (Z, ae, Re, Ue, nt) => {
          if ((Ue & 2) !== 0 && (nt & 2) === 0 && (Z.flags & 2097155) !== 2)
            throw new st.ErrnoError(2);
          if ((Z.flags & 2097155) === 1)
            throw new st.ErrnoError(2);
          if (!Z.stream_ops.mmap)
            throw new st.ErrnoError(43);
          return Z.stream_ops.mmap(Z, ae, Re, Ue, nt);
        }, msync: (Z, ae, Re, Ue, nt) => Z.stream_ops.msync ? Z.stream_ops.msync(Z, ae, Re, Ue, nt) : 0, munmap: (Z) => 0, ioctl: (Z, ae, Re) => {
          if (!Z.stream_ops.ioctl)
            throw new st.ErrnoError(59);
          return Z.stream_ops.ioctl(Z, ae, Re);
        }, readFile: (Z, ae = {}) => {
          if (ae.flags = ae.flags || 0, ae.encoding = ae.encoding || "binary", ae.encoding !== "utf8" && ae.encoding !== "binary")
            throw new Error(`Invalid encoding type "${ae.encoding}"`);
          var Re, Ue = st.open(Z, ae.flags), nt = st.stat(Z), At = nt.size, Lt = new Uint8Array(At);
          return st.read(Ue, Lt, 0, At, 0), ae.encoding === "utf8" ? Re = Ss(Lt, 0) : ae.encoding === "binary" && (Re = Lt), st.close(Ue), Re;
        }, writeFile: (Z, ae, Re = {}) => {
          Re.flags = Re.flags || 577;
          var Ue = st.open(Z, Re.flags, Re.mode);
          if (typeof ae == "string") {
            var nt = new Uint8Array(ws(ae) + 1), At = Mn(ae, nt, 0, nt.length);
            st.write(Ue, nt, 0, At, void 0, Re.canOwn);
          } else if (ArrayBuffer.isView(ae))
            st.write(Ue, ae, 0, ae.byteLength, void 0, Re.canOwn);
          else
            throw new Error("Unsupported data type");
          st.close(Ue);
        }, cwd: () => st.currentPath, chdir: (Z) => {
          var ae = st.lookupPath(Z, { follow: !0 });
          if (ae.node === null)
            throw new st.ErrnoError(44);
          if (!st.isDir(ae.node.mode))
            throw new st.ErrnoError(54);
          var Re = st.nodePermissions(ae.node, "x");
          if (Re)
            throw new st.ErrnoError(Re);
          st.currentPath = ae.path;
        }, createDefaultDirectories: () => {
          st.mkdir("/tmp"), st.mkdir("/home"), st.mkdir("/home/web_user");
        }, createDefaultDevices: () => {
          st.mkdir("/dev"), st.registerDevice(st.makedev(1, 3), { read: () => 0, write: (Ue, nt, At, Lt, _t) => Lt }), st.mkdev("/dev/null", st.makedev(1, 3)), Hc.register(st.makedev(5, 0), Hc.default_tty_ops), Hc.register(st.makedev(6, 0), Hc.default_tty1_ops), st.mkdev("/dev/tty", st.makedev(5, 0)), st.mkdev("/dev/tty1", st.makedev(6, 0));
          var Z = new Uint8Array(1024), ae = 0, Re = () => (ae === 0 && (ae = Uf(Z).byteLength), Z[--ae]);
          st.createDevice("/dev", "random", Re), st.createDevice("/dev", "urandom", Re), st.mkdir("/dev/shm"), st.mkdir("/dev/shm/tmp");
        }, createSpecialDirectories: () => {
          st.mkdir("/proc");
          var Z = st.mkdir("/proc/self");
          st.mkdir("/proc/self/fd"), st.mount({ mount: () => {
            var ae = st.createNode(Z, "fd", 16895, 73);
            return ae.node_ops = { lookup: (Re, Ue) => {
              var nt = +Ue, At = st.getStreamChecked(nt), Lt = { parent: null, mount: { mountpoint: "fake" }, node_ops: { readlink: () => At.path } };
              return Lt.parent = Lt, Lt;
            } }, ae;
          } }, {}, "/proc/self/fd");
        }, createStandardStreams: () => {
          o.stdin ? st.createDevice("/dev", "stdin", o.stdin) : st.symlink("/dev/tty", "/dev/stdin"), o.stdout ? st.createDevice("/dev", "stdout", null, o.stdout) : st.symlink("/dev/tty", "/dev/stdout"), o.stderr ? st.createDevice("/dev", "stderr", null, o.stderr) : st.symlink("/dev/tty1", "/dev/stderr"), st.open("/dev/stdin", 0), st.open("/dev/stdout", 1), st.open("/dev/stderr", 1);
        }, ensureErrnoError: () => {
          st.ErrnoError || (st.ErrnoError = function(ae, Re) {
            this.name = "ErrnoError", this.node = Re, this.setErrno = function(Ue) {
              this.errno = Ue;
            }, this.setErrno(ae), this.message = "FS error";
          }, st.ErrnoError.prototype = new Error(), st.ErrnoError.prototype.constructor = st.ErrnoError, [44].forEach((Z) => {
            st.genericErrors[Z] = new st.ErrnoError(Z), st.genericErrors[Z].stack = "<generic error, no stack>";
          }));
        }, staticInit: () => {
          st.ensureErrnoError(), st.nameTable = new Array(4096), st.mount(hs, {}, "/"), st.createDefaultDirectories(), st.createDefaultDevices(), st.createSpecialDirectories(), st.filesystems = { MEMFS: hs };
        }, init: (Z, ae, Re) => {
          st.init.initialized = !0, st.ensureErrnoError(), o.stdin = Z || o.stdin, o.stdout = ae || o.stdout, o.stderr = Re || o.stderr, st.createStandardStreams();
        }, quit: () => {
          st.init.initialized = !1;
          for (var Z = 0; Z < st.streams.length; Z++) {
            var ae = st.streams[Z];
            ae && st.close(ae);
          }
        }, findObject: (Z, ae) => {
          var Re = st.analyzePath(Z, ae);
          return Re.exists ? Re.object : null;
        }, analyzePath: (Z, ae) => {
          try {
            var Re = st.lookupPath(Z, { follow: !ae });
            Z = Re.path;
          } catch {
          }
          var Ue = { isRoot: !1, exists: !1, error: 0, name: null, path: null, object: null, parentExists: !1, parentPath: null, parentObject: null };
          try {
            var Re = st.lookupPath(Z, { parent: !0 });
            Ue.parentExists = !0, Ue.parentPath = Re.path, Ue.parentObject = Re.node, Ue.name = Qs.basename(Z), Re = st.lookupPath(Z, { follow: !ae }), Ue.exists = !0, Ue.path = Re.path, Ue.object = Re.node, Ue.name = Re.node.name, Ue.isRoot = Re.path === "/";
          } catch (nt) {
            Ue.error = nt.errno;
          }
          return Ue;
        }, createPath: (Z, ae, Re, Ue) => {
          Z = typeof Z == "string" ? Z : st.getPath(Z);
          for (var nt = ae.split("/").reverse(); nt.length; ) {
            var At = nt.pop();
            if (At) {
              var Lt = Qs.join2(Z, At);
              try {
                st.mkdir(Lt);
              } catch {
              }
              Z = Lt;
            }
          }
          return Lt;
        }, createFile: (Z, ae, Re, Ue, nt) => {
          var At = Qs.join2(typeof Z == "string" ? Z : st.getPath(Z), ae), Lt = MI(Ue, nt);
          return st.create(At, Lt);
        }, createDataFile: (Z, ae, Re, Ue, nt, At) => {
          var Lt = ae;
          Z && (Z = typeof Z == "string" ? Z : st.getPath(Z), Lt = ae ? Qs.join2(Z, ae) : Z);
          var _t = MI(Ue, nt), oi = st.create(Lt, _t);
          if (Re) {
            if (typeof Re == "string") {
              for (var mi = new Array(Re.length), zi = 0, yn = Re.length; zi < yn; ++zi) mi[zi] = Re.charCodeAt(zi);
              Re = mi;
            }
            st.chmod(oi, _t | 146);
            var Xi = st.open(oi, 577);
            st.write(Xi, Re, 0, Re.length, 0, At), st.close(Xi), st.chmod(oi, _t);
          }
          return oi;
        }, createDevice: (Z, ae, Re, Ue) => {
          var nt = Qs.join2(typeof Z == "string" ? Z : st.getPath(Z), ae), At = MI(!!Re, !!Ue);
          st.createDevice.major || (st.createDevice.major = 64);
          var Lt = st.makedev(st.createDevice.major++, 0);
          return st.registerDevice(Lt, { open: (_t) => {
            _t.seekable = !1;
          }, close: (_t) => {
            Ue && Ue.buffer && Ue.buffer.length && Ue(10);
          }, read: (_t, oi, mi, zi, yn) => {
            for (var Xi = 0, rn = 0; rn < zi; rn++) {
              var Fn;
              try {
                Fn = Re();
              } catch {
                throw new st.ErrnoError(29);
              }
              if (Fn === void 0 && Xi === 0)
                throw new st.ErrnoError(6);
              if (Fn == null) break;
              Xi++, oi[mi + rn] = Fn;
            }
            return Xi && (_t.node.timestamp = Date.now()), Xi;
          }, write: (_t, oi, mi, zi, yn) => {
            for (var Xi = 0; Xi < zi; Xi++)
              try {
                Ue(oi[mi + Xi]);
              } catch {
                throw new st.ErrnoError(29);
              }
            return zi && (_t.node.timestamp = Date.now()), Xi;
          } }), st.mkdev(nt, At, Lt);
        }, forceLoadFile: (Z) => {
          if (Z.isDevice || Z.isFolder || Z.link || Z.contents) return !0;
          if (typeof XMLHttpRequest < "u")
            throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");
          if (m)
            try {
              Z.contents = Bf(m(Z.url), !0), Z.usedBytes = Z.contents.length;
            } catch {
              throw new st.ErrnoError(29);
            }
          else
            throw new Error("Cannot load without read() or XMLHttpRequest.");
        }, createLazyFile: (Z, ae, Re, Ue, nt) => {
          function At() {
            this.lengthKnown = !1, this.chunks = [];
          }
          if (At.prototype.get = function(rn) {
            if (!(rn > this.length - 1 || rn < 0)) {
              var Fn = rn % this.chunkSize, Ps = rn / this.chunkSize | 0;
              return this.getter(Ps)[Fn];
            }
          }, At.prototype.setDataGetter = function(rn) {
            this.getter = rn;
          }, At.prototype.cacheLength = function() {
            var rn = new XMLHttpRequest();
            if (rn.open("HEAD", Re, !1), rn.send(null), !(rn.status >= 200 && rn.status < 300 || rn.status === 304)) throw new Error("Couldn't load " + Re + ". Status: " + rn.status);
            var Fn = Number(rn.getResponseHeader("Content-length")), Ps, Fs = (Ps = rn.getResponseHeader("Accept-Ranges")) && Ps === "bytes", uo = (Ps = rn.getResponseHeader("Content-Encoding")) && Ps === "gzip", Ui = 1024 * 1024;
            Fs || (Ui = Fn);
            var Rn = (Do, Pl) => {
              if (Do > Pl) throw new Error("invalid range (" + Do + ", " + Pl + ") or no bytes requested!");
              if (Pl > Fn - 1) throw new Error("only " + Fn + " bytes available! programmer error!");
              var cr = new XMLHttpRequest();
              if (cr.open("GET", Re, !1), Fn !== Ui && cr.setRequestHeader("Range", "bytes=" + Do + "-" + Pl), cr.responseType = "arraybuffer", cr.overrideMimeType && cr.overrideMimeType("text/plain; charset=x-user-defined"), cr.send(null), !(cr.status >= 200 && cr.status < 300 || cr.status === 304)) throw new Error("Couldn't load " + Re + ". Status: " + cr.status);
              return cr.response !== void 0 ? new Uint8Array(cr.response || []) : Bf(cr.responseText || "", !0);
            }, Vo = this;
            Vo.setDataGetter((Do) => {
              var Pl = Do * Ui, cr = (Do + 1) * Ui - 1;
              if (cr = Math.min(cr, Fn - 1), typeof Vo.chunks[Do] > "u" && (Vo.chunks[Do] = Rn(Pl, cr)), typeof Vo.chunks[Do] > "u") throw new Error("doXHR failed!");
              return Vo.chunks[Do];
            }), (uo || !Fn) && (Ui = Fn = 1, Fn = this.getter(0).length, Ui = Fn, C("LazyFiles on gzip forces download of the whole file when length is accessed")), this._length = Fn, this._chunkSize = Ui, this.lengthKnown = !0;
          }, typeof XMLHttpRequest < "u") {
            throw "Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";
            var Lt, _t;
          } else
            var _t = { isDevice: !1, url: Re };
          var oi = st.createFile(Z, ae, _t, Ue, nt);
          _t.contents ? oi.contents = _t.contents : _t.url && (oi.contents = null, oi.url = _t.url), Object.defineProperties(oi, { usedBytes: { get: function() {
            return this.contents.length;
          } } });
          var mi = {}, zi = Object.keys(oi.stream_ops);
          zi.forEach((Xi) => {
            var rn = oi.stream_ops[Xi];
            mi[Xi] = function() {
              return st.forceLoadFile(oi), rn.apply(null, arguments);
            };
          });
          function yn(Xi, rn, Fn, Ps, Fs) {
            var uo = Xi.node.contents;
            if (Fs >= uo.length) return 0;
            var Ui = Math.min(uo.length - Fs, Ps);
            if (uo.slice)
              for (var Rn = 0; Rn < Ui; Rn++)
                rn[Fn + Rn] = uo[Fs + Rn];
            else
              for (var Rn = 0; Rn < Ui; Rn++)
                rn[Fn + Rn] = uo.get(Fs + Rn);
            return Ui;
          }
          return mi.read = (Xi, rn, Fn, Ps, Fs) => (st.forceLoadFile(oi), yn(Xi, rn, Fn, Ps, Fs)), mi.mmap = (Xi, rn, Fn, Ps, Fs) => {
            st.forceLoadFile(oi);
            var uo = tm();
            if (!uo)
              throw new st.ErrnoError(48);
            return yn(Xi, W, uo, rn, Fn), { ptr: uo, allocated: !0 };
          }, oi.stream_ops = mi, oi;
        } }, Ld = { DEFAULT_POLLMASK: 5, calculateAt: function(Z, ae, Re) {
          if (Qs.isAbs(ae))
            return ae;
          var Ue;
          if (Z === -100)
            Ue = st.cwd();
          else {
            var nt = Ld.getStreamFromFD(Z);
            Ue = nt.path;
          }
          if (ae.length == 0) {
            if (!Re)
              throw new st.ErrnoError(44);
            return Ue;
          }
          return Qs.join2(Ue, ae);
        }, doStat: function(Z, ae, Re) {
          try {
            var Ue = Z(ae);
          } catch (_t) {
            if (_t && _t.node && Qs.normalize(ae) !== Qs.normalize(st.getPath(_t.node)))
              return -54;
            throw _t;
          }
          ee[Re >>> 2] = Ue.dev, ee[Re + 4 >>> 2] = Ue.mode, Ne[Re + 8 >>> 2] = Ue.nlink, ee[Re + 12 >>> 2] = Ue.uid, ee[Re + 16 >>> 2] = Ue.gid, ee[Re + 20 >>> 2] = Ue.rdev, jt = [Ue.size >>> 0, (Tt = Ue.size, +Math.abs(Tt) >= 1 ? Tt > 0 ? +Math.floor(Tt / 4294967296) >>> 0 : ~~+Math.ceil((Tt - +(~~Tt >>> 0)) / 4294967296) >>> 0 : 0)], ee[Re + 24 >>> 2] = jt[0], ee[Re + 28 >>> 2] = jt[1], ee[Re + 32 >>> 2] = 4096, ee[Re + 36 >>> 2] = Ue.blocks;
          var nt = Ue.atime.getTime(), At = Ue.mtime.getTime(), Lt = Ue.ctime.getTime();
          return jt = [Math.floor(nt / 1e3) >>> 0, (Tt = Math.floor(nt / 1e3), +Math.abs(Tt) >= 1 ? Tt > 0 ? +Math.floor(Tt / 4294967296) >>> 0 : ~~+Math.ceil((Tt - +(~~Tt >>> 0)) / 4294967296) >>> 0 : 0)], ee[Re + 40 >>> 2] = jt[0], ee[Re + 44 >>> 2] = jt[1], Ne[Re + 48 >>> 2] = nt % 1e3 * 1e3, jt = [Math.floor(At / 1e3) >>> 0, (Tt = Math.floor(At / 1e3), +Math.abs(Tt) >= 1 ? Tt > 0 ? +Math.floor(Tt / 4294967296) >>> 0 : ~~+Math.ceil((Tt - +(~~Tt >>> 0)) / 4294967296) >>> 0 : 0)], ee[Re + 56 >>> 2] = jt[0], ee[Re + 60 >>> 2] = jt[1], Ne[Re + 64 >>> 2] = At % 1e3 * 1e3, jt = [Math.floor(Lt / 1e3) >>> 0, (Tt = Math.floor(Lt / 1e3), +Math.abs(Tt) >= 1 ? Tt > 0 ? +Math.floor(Tt / 4294967296) >>> 0 : ~~+Math.ceil((Tt - +(~~Tt >>> 0)) / 4294967296) >>> 0 : 0)], ee[Re + 72 >>> 2] = jt[0], ee[Re + 76 >>> 2] = jt[1], Ne[Re + 80 >>> 2] = Lt % 1e3 * 1e3, jt = [Ue.ino >>> 0, (Tt = Ue.ino, +Math.abs(Tt) >= 1 ? Tt > 0 ? +Math.floor(Tt / 4294967296) >>> 0 : ~~+Math.ceil((Tt - +(~~Tt >>> 0)) / 4294967296) >>> 0 : 0)], ee[Re + 88 >>> 2] = jt[0], ee[Re + 92 >>> 2] = jt[1], 0;
        }, doMsync: function(Z, ae, Re, Ue, nt) {
          if (!st.isFile(ae.node.mode))
            throw new st.ErrnoError(43);
          if (Ue & 2)
            return 0;
          var At = re.slice(Z, Z + Re);
          st.msync(ae, At, nt, Re, Ue);
        }, varargs: void 0, get() {
          Ld.varargs += 4;
          var Z = ee[Ld.varargs - 4 >>> 2];
          return Z;
        }, getStr(Z) {
          var ae = dr(Z);
          return ae;
        }, getStreamFromFD: function(Z) {
          var ae = st.getStreamChecked(Z);
          return ae;
        } };
        function O3(Z, ae) {
          Z >>>= 0, ae >>>= 0;
          var Re = 0;
          return wh().forEach(function(Ue, nt) {
            var At = ae + Re;
            Ne[Z + nt * 4 >>> 2] = At, R3(Ue, At), Re += Ue.length + 1;
          }), 0;
        }
        function UI(Z, ae) {
          Z >>>= 0, ae >>>= 0;
          var Re = wh();
          Ne[Z >>> 2] = Re.length;
          var Ue = 0;
          return Re.forEach(function(nt) {
            Ue += nt.length + 1;
          }), Ne[ae >>> 2] = Ue, 0;
        }
        function Ff(Z) {
          try {
            var ae = Ld.getStreamFromFD(Z);
            return st.close(ae), 0;
          } catch (Re) {
            if (typeof st > "u" || Re.name !== "ErrnoError") throw Re;
            return Re.errno;
          }
        }
        function L3(Z, ae) {
          ae >>>= 0;
          try {
            var Re = 0, Ue = 0, nt = 0, At = Ld.getStreamFromFD(Z), Lt = At.tty ? 2 : st.isDir(At.mode) ? 3 : st.isLink(At.mode) ? 7 : 4;
            return W[ae >>> 0] = Lt, ce[ae + 2 >>> 1] = nt, jt = [Re >>> 0, (Tt = Re, +Math.abs(Tt) >= 1 ? Tt > 0 ? +Math.floor(Tt / 4294967296) >>> 0 : ~~+Math.ceil((Tt - +(~~Tt >>> 0)) / 4294967296) >>> 0 : 0)], ee[ae + 8 >>> 2] = jt[0], ee[ae + 12 >>> 2] = jt[1], jt = [Ue >>> 0, (Tt = Ue, +Math.abs(Tt) >= 1 ? Tt > 0 ? +Math.floor(Tt / 4294967296) >>> 0 : ~~+Math.ceil((Tt - +(~~Tt >>> 0)) / 4294967296) >>> 0 : 0)], ee[ae + 16 >>> 2] = jt[0], ee[ae + 20 >>> 2] = jt[1], 0;
          } catch (_t) {
            if (typeof st > "u" || _t.name !== "ErrnoError") throw _t;
            return _t.errno;
          }
        }
        var _3 = (Z, ae, Re, Ue) => {
          for (var nt = 0, At = 0; At < Re; At++) {
            var Lt = Ne[ae >>> 2], _t = Ne[ae + 4 >>> 2];
            ae += 8;
            var oi = st.read(Z, W, Lt, _t, Ue);
            if (oi < 0) return -1;
            if (nt += oi, oi < _t) break;
          }
          return nt;
        };
        function x3(Z, ae, Re, Ue) {
          ae >>>= 0, Re >>>= 0, Ue >>>= 0;
          try {
            var nt = Ld.getStreamFromFD(Z), At = _3(nt, ae, Re);
            return Ne[Ue >>> 2] = At, 0;
          } catch (Lt) {
            if (typeof st > "u" || Lt.name !== "ErrnoError") throw Lt;
            return Lt.errno;
          }
        }
        function BI(Z, ae, Re, Ue, nt) {
          var At = Me(ae, Re);
          nt >>>= 0;
          try {
            if (isNaN(At)) return 61;
            var Lt = Ld.getStreamFromFD(Z);
            return st.llseek(Lt, At, Ue), jt = [Lt.position >>> 0, (Tt = Lt.position, +Math.abs(Tt) >= 1 ? Tt > 0 ? +Math.floor(Tt / 4294967296) >>> 0 : ~~+Math.ceil((Tt - +(~~Tt >>> 0)) / 4294967296) >>> 0 : 0)], ee[nt >>> 2] = jt[0], ee[nt + 4 >>> 2] = jt[1], Lt.getdents && At === 0 && Ue === 0 && (Lt.getdents = null), 0;
          } catch (_t) {
            if (typeof st > "u" || _t.name !== "ErrnoError") throw _t;
            return _t.errno;
          }
        }
        var P3 = (Z, ae, Re, Ue) => {
          for (var nt = 0, At = 0; At < Re; At++) {
            var Lt = Ne[ae >>> 2], _t = Ne[ae + 4 >>> 2];
            ae += 8;
            var oi = st.write(Z, W, Lt, _t, Ue);
            if (oi < 0) return -1;
            nt += oi;
          }
          return nt;
        };
        function M3(Z, ae, Re, Ue) {
          ae >>>= 0, Re >>>= 0, Ue >>>= 0;
          try {
            var nt = Ld.getStreamFromFD(Z), At = P3(nt, ae, Re);
            return Ne[Ue >>> 2] = At, 0;
          } catch (Lt) {
            if (typeof st > "u" || Lt.name !== "ErrnoError") throw Lt;
            return Lt.errno;
          }
        }
        function U3(Z, ae) {
          return Z >>>= 0, ae >>>= 0, Uf(re.subarray(Z >>> 0, Z + ae >>> 0)), 0;
        }
        var B3 = (Z, ae) => {
          for (var Re = 0, Ue = 0; Ue <= ae; Re += Z[Ue++])
            ;
          return Re;
        }, FI = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], HI = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], F3 = (Z, ae) => {
          for (var Re = new Date(Z.getTime()); ae > 0; ) {
            var Ue = ua(Re.getFullYear()), nt = Re.getMonth(), At = (Ue ? FI : HI)[nt];
            if (ae > At - Re.getDate())
              ae -= At - Re.getDate() + 1, Re.setDate(1), nt < 11 ? Re.setMonth(nt + 1) : (Re.setMonth(0), Re.setFullYear(Re.getFullYear() + 1));
            else
              return Re.setDate(Re.getDate() + ae), Re;
          }
          return Re;
        }, H3 = (Z, ae) => {
          W.set(Z, ae >>> 0);
        };
        function G3(Z, ae, Re, Ue) {
          Z >>>= 0, ae >>>= 0, Re >>>= 0, Ue >>>= 0;
          var nt = ee[Ue + 40 >>> 2], At = { tm_sec: ee[Ue >>> 2], tm_min: ee[Ue + 4 >>> 2], tm_hour: ee[Ue + 8 >>> 2], tm_mday: ee[Ue + 12 >>> 2], tm_mon: ee[Ue + 16 >>> 2], tm_year: ee[Ue + 20 >>> 2], tm_wday: ee[Ue + 24 >>> 2], tm_yday: ee[Ue + 28 >>> 2], tm_isdst: ee[Ue + 32 >>> 2], tm_gmtoff: ee[Ue + 36 >>> 2], tm_zone: nt ? dr(nt) : "" }, Lt = dr(Re), _t = { "%c": "%a %b %d %H:%M:%S %Y", "%D": "%m/%d/%y", "%F": "%Y-%m-%d", "%h": "%b", "%r": "%I:%M:%S %p", "%R": "%H:%M", "%T": "%H:%M:%S", "%x": "%m/%d/%y", "%X": "%H:%M:%S", "%Ec": "%c", "%EC": "%C", "%Ex": "%m/%d/%y", "%EX": "%H:%M:%S", "%Ey": "%y", "%EY": "%Y", "%Od": "%d", "%Oe": "%e", "%OH": "%H", "%OI": "%I", "%Om": "%m", "%OM": "%M", "%OS": "%S", "%Ou": "%u", "%OU": "%U", "%OV": "%V", "%Ow": "%w", "%OW": "%W", "%Oy": "%y" };
          for (var oi in _t)
            Lt = Lt.replace(new RegExp(oi, "g"), _t[oi]);
          var mi = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], zi = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
          function yn(Ui, Rn, Vo) {
            for (var Do = typeof Ui == "number" ? Ui.toString() : Ui || ""; Do.length < Rn; )
              Do = Vo[0] + Do;
            return Do;
          }
          function Xi(Ui, Rn) {
            return yn(Ui, Rn, "0");
          }
          function rn(Ui, Rn) {
            function Vo(Pl) {
              return Pl < 0 ? -1 : Pl > 0 ? 1 : 0;
            }
            var Do;
            return (Do = Vo(Ui.getFullYear() - Rn.getFullYear())) === 0 && (Do = Vo(Ui.getMonth() - Rn.getMonth())) === 0 && (Do = Vo(Ui.getDate() - Rn.getDate())), Do;
          }
          function Fn(Ui) {
            switch (Ui.getDay()) {
              case 0:
                return new Date(Ui.getFullYear() - 1, 11, 29);
              case 1:
                return Ui;
              case 2:
                return new Date(Ui.getFullYear(), 0, 3);
              case 3:
                return new Date(Ui.getFullYear(), 0, 2);
              case 4:
                return new Date(Ui.getFullYear(), 0, 1);
              case 5:
                return new Date(Ui.getFullYear() - 1, 11, 31);
              case 6:
                return new Date(Ui.getFullYear() - 1, 11, 30);
            }
          }
          function Ps(Ui) {
            var Rn = F3(new Date(Ui.tm_year + 1900, 0, 1), Ui.tm_yday), Vo = new Date(Rn.getFullYear(), 0, 4), Do = new Date(Rn.getFullYear() + 1, 0, 4), Pl = Fn(Vo), cr = Fn(Do);
            return rn(Pl, Rn) <= 0 ? rn(cr, Rn) <= 0 ? Rn.getFullYear() + 1 : Rn.getFullYear() : Rn.getFullYear() - 1;
          }
          var Fs = { "%a": (Ui) => mi[Ui.tm_wday].substring(0, 3), "%A": (Ui) => mi[Ui.tm_wday], "%b": (Ui) => zi[Ui.tm_mon].substring(0, 3), "%B": (Ui) => zi[Ui.tm_mon], "%C": (Ui) => {
            var Rn = Ui.tm_year + 1900;
            return Xi(Rn / 100 | 0, 2);
          }, "%d": (Ui) => Xi(Ui.tm_mday, 2), "%e": (Ui) => yn(Ui.tm_mday, 2, " "), "%g": (Ui) => Ps(Ui).toString().substring(2), "%G": (Ui) => Ps(Ui), "%H": (Ui) => Xi(Ui.tm_hour, 2), "%I": (Ui) => {
            var Rn = Ui.tm_hour;
            return Rn == 0 ? Rn = 12 : Rn > 12 && (Rn -= 12), Xi(Rn, 2);
          }, "%j": (Ui) => Xi(Ui.tm_mday + B3(ua(Ui.tm_year + 1900) ? FI : HI, Ui.tm_mon - 1), 3), "%m": (Ui) => Xi(Ui.tm_mon + 1, 2), "%M": (Ui) => Xi(Ui.tm_min, 2), "%n": () => `
`, "%p": (Ui) => Ui.tm_hour >= 0 && Ui.tm_hour < 12 ? "AM" : "PM", "%S": (Ui) => Xi(Ui.tm_sec, 2), "%t": () => "	", "%u": (Ui) => Ui.tm_wday || 7, "%U": (Ui) => {
            var Rn = Ui.tm_yday + 7 - Ui.tm_wday;
            return Xi(Math.floor(Rn / 7), 2);
          }, "%V": (Ui) => {
            var Rn = Math.floor((Ui.tm_yday + 7 - (Ui.tm_wday + 6) % 7) / 7);
            if ((Ui.tm_wday + 371 - Ui.tm_yday - 2) % 7 <= 2 && Rn++, Rn) {
              if (Rn == 53) {
                var Do = (Ui.tm_wday + 371 - Ui.tm_yday) % 7;
                Do != 4 && (Do != 3 || !ua(Ui.tm_year)) && (Rn = 1);
              }
            } else {
              Rn = 52;
              var Vo = (Ui.tm_wday + 7 - Ui.tm_yday - 1) % 7;
              (Vo == 4 || Vo == 5 && ua(Ui.tm_year % 400 - 1)) && Rn++;
            }
            return Xi(Rn, 2);
          }, "%w": (Ui) => Ui.tm_wday, "%W": (Ui) => {
            var Rn = Ui.tm_yday + 7 - (Ui.tm_wday + 6) % 7;
            return Xi(Math.floor(Rn / 7), 2);
          }, "%y": (Ui) => (Ui.tm_year + 1900).toString().substring(2), "%Y": (Ui) => Ui.tm_year + 1900, "%z": (Ui) => {
            var Rn = Ui.tm_gmtoff, Vo = Rn >= 0;
            return Rn = Math.abs(Rn) / 60, Rn = Rn / 60 * 100 + Rn % 60, (Vo ? "+" : "-") + ("0000" + Rn).slice(-4);
          }, "%Z": (Ui) => Ui.tm_zone, "%%": () => "%" };
          Lt = Lt.replace(/%%/g, "\0\0");
          for (var oi in Fs)
            Lt.includes(oi) && (Lt = Lt.replace(new RegExp(oi, "g"), Fs[oi](At)));
          Lt = Lt.replace(/\0\0/g, "%");
          var uo = Bf(Lt, !1);
          return uo.length > ae ? 0 : (H3(uo, Z), uo.length - 1);
        }
        function k3(Z, ae, Re, Ue, nt) {
          return Z >>>= 0, ae >>>= 0, Re >>>= 0, Ue >>>= 0, G3(Z, ae, Re, Ue);
        }
        Wi = o.InternalError = class extends Error {
          constructor(ae) {
            super(ae), this.name = "InternalError";
          }
        }, sn(), Gi = o.BindingError = class extends Error {
          constructor(ae) {
            super(ae), this.name = "BindingError";
          }
        }, mn(), As(), yr(), Tc = o.UnboundTypeError = NI(Error, "UnboundTypeError"), DI(), CI();
        var im = function(Z, ae, Re, Ue) {
          Z || (Z = this), this.parent = Z, this.mount = Z.mount, this.mounted = null, this.id = st.nextInode++, this.name = ae, this.mode = Re, this.node_ops = {}, this.stream_ops = {}, this.rdev = Ue;
        }, Hf = 365, Gf = 146;
        Object.defineProperties(im.prototype, { read: { get: function() {
          return (this.mode & Hf) === Hf;
        }, set: function(Z) {
          Z ? this.mode |= Hf : this.mode &= ~Hf;
        } }, write: { get: function() {
          return (this.mode & Gf) === Gf;
        }, set: function(Z) {
          Z ? this.mode |= Gf : this.mode &= ~Gf;
        } }, isFolder: { get: function() {
          return st.isDir(this.mode);
        } }, isDevice: { get: function() {
          return st.isChrdev(this.mode);
        } } }), st.FSNode = im, st.createPreloadedFile = D3, st.staticInit();
        var V3 = { f: gt, Y: Sn, p: Yi, H: Pi, W: No, i: Sr, h: la, b: Nf, V: Cf, z: Of, c: xt, s: qi, m: un, A: Vr, w: ph, Z: m0, n: Nc, q: Nd, e: Dd, X: Dc, P: mh, l: Oc, v: _c, a: Ac, y: yh, j: Eh, r: LI, D: Pf, x: Bi, C: qu, B: Ru, g: Pc, t: Od, k: gh, o: Mc, d: Uc, F: $u, G: Wl, N: m3, u: y3, Q: ko, U: E3, M: w3, S: O3, T: UI, K: Ff, R: L3, L: x3, E: BI, O: M3, I: U3, J: k3 };
        rt();
        var Zu = (Z) => (Zu = L.aa)(Z), kf = (Z) => (kf = L.ba)(Z), nm = (Z) => (nm = L.da)(Z);
        o.__embind_initialize_bindings = () => (o.__embind_initialize_bindings = L.ea)();
        var sm = (Z) => (sm = L.fa)(Z);
        o.dynCall_jiji = (Z, ae, Re, Ue, nt) => (o.dynCall_jiji = L.ga)(Z, ae, Re, Ue, nt), o.dynCall_viijii = (Z, ae, Re, Ue, nt, At, Lt) => (o.dynCall_viijii = L.ha)(Z, ae, Re, Ue, nt, At, Lt), o.dynCall_iiiiij = (Z, ae, Re, Ue, nt, At, Lt) => (o.dynCall_iiiiij = L.ia)(Z, ae, Re, Ue, nt, At, Lt), o.dynCall_iiiiijj = (Z, ae, Re, Ue, nt, At, Lt, _t, oi) => (o.dynCall_iiiiijj = L.ja)(Z, ae, Re, Ue, nt, At, Lt, _t, oi), o.dynCall_iiiiiijj = (Z, ae, Re, Ue, nt, At, Lt, _t, oi, mi) => (o.dynCall_iiiiiijj = L.ka)(Z, ae, Re, Ue, nt, At, Lt, _t, oi, mi);
        function z3(Z) {
          Z = Object.assign({}, Z);
          var ae = (Ue) => (nt) => Ue(nt) >>> 0, Re = (Ue) => () => Ue() >>> 0;
          return Z.malloc = ae(Z.malloc), Z.__getTypeName = ae(Z.__getTypeName), Z.__errno_location = Re(Z.__errno_location), Z.stackSave = Re(Z.stackSave), Z.stackAlloc = ae(Z.stackAlloc), Z;
        }
        var _d;
        Kt = function Z() {
          _d || om(), _d || (Kt = Z);
        };
        function om() {
          if (Ct > 0 || (Rt(), Ct > 0))
            return;
          function Z() {
            _d || (_d = !0, o.calledRun = !0, !P && (ze(), r(o), o.onRuntimeInitialized && o.onRuntimeInitialized(), mt()));
          }
          o.setStatus ? (o.setStatus("Running..."), setTimeout(function() {
            setTimeout(function() {
              o.setStatus("");
            }, 1), Z();
          }, 1)) : Z();
        }
        if (o.preInit)
          for (typeof o.preInit == "function" && (o.preInit = [o.preInit]); o.preInit.length > 0; )
            o.preInit.pop()();
        return om(), s.ready;
      };
    })();
    typeof e == "object" && typeof t == "object" ? t.exports = i : typeof define == "function" && define.amd && define([], () => i);
  }
}), Eke = 950732822, gke = 4075327185, wke = 1209108979, Tke = 3457685358, Rke = 4157543285, vke = 2798247006, Ake = 1790229001, Ske = 525895558, bke = 1774176899, Nke = 1275358634, Dke = 2541165894, Cke = 3701338814, Oke = 2195413836, Lke = 937566702, _ke = 1683019596, xke = 2314439260, Pke = 1500781891, Mke = 3683503648, Uke = 4065007721, Bke = 1718600412, Fke = 51269191, Hke = 2593997549, Gke = 3458127941, kke = 3345633955, Vke = 1278329552, zke = 2591213694, jke = 2726807636, Wke = 743184107, Yke = 2016195849, qke = 857959152, $ke = 2281867870, Kke = 2645777649, Zke = 232962298, Qke = 296282323, Jke = 603696268, Xke = 3490877962, eVe = 1460886941, tVe = 2801250643, iVe = 58845555, nVe = 361837227, sVe = 2757832317, oVe = 3477203348, rVe = 993287707, lVe = 846465480, aVe = 3471399674, uVe = 408310005, dVe = 2190458107, cVe = 3467162246, hVe = 2766185779, fVe = 3211557302, IVe = 1755127002, pVe = 2133746277, mVe = 200335297, yVe = 96294661, EVe = 3972513137, gVe = 3665567075, wVe = 2169031380, TVe = 1364037233, RVe = 1245737093, vVe = 3054510233, AVe = 2815919920, SVe = 4042175685, bVe = 2642773653, NVe = 2260317790, DVe = 929793134, CVe = 2395907400, OVe = 2095195183, LVe = 765770214, _Ve = 2615040989, xVe = 3114022597, PVe = 1648970520, MVe = 3177669450, UVe = 1753493141, BVe = 1052454078, FVe = 2173214787, HVe = 3341486342, GVe = 102610177, kVe = 3531705166, VVe = 3124614049, zVe = 4017473158, jVe = 1477762836, WVe = 2486716878, YVe = 286949696, qVe = 151039812, $Ve = 2755797622, KVe = 2095003142, ZVe = 503418787, QVe = 3086160713, JVe = 1307019551, XVe = 2128979029, eze = 191860431, tze = 1243674935, ize = 3258342251, nze = 2054016361, sze = 3192672207, oze = 3686016028, rze = 3809634241, lze = 1939436016, aze = 2679005408, uze = 3358199106, dze = 983778844, cze = 2589826445, hze = 1158859006, fze = 3113092358, _Ae = 3064340077, Ize = 3044325142, pze = 1361398929, mze = 2590844177, yze = 2715512545, Eze = 1102727119, gze = 2078135608, wze = 2506197118, Tze = 2951915441, Rze = 3790457270, vze = 2093906313, Aze = 3818826038, Sze = 1827137117, bze = 69416015, Nze = 524656162, Dze = 4134073009, Cze = 1514641115, Oze = 300323983, Lze = 86635668, _ze = 94842927, xze = 1778710042, Pze = 3238673880, Mze = 3812528620, Uze = 2991860651, Bze = 1867003952, Fze = 2735952531, Hze = 2650437152, Gze = 632304761, kze = 360377573, Vze = 4182062534, zze = 3699917729, R_ = 1971632696, v_ = 2680139844, YD = 24726584, qD = 3693000487, $D = 3460952963, A_ = 3999819293, S_ = 3314249567, cU = 4196446775, hU = 325726236, Z_ = 3425753595, KD = 991950508, b_ = 3798194928, Q_ = 3290496277, J_ = 1383356374, fU = 2182337498, IU = 234836483, ZD = 2078563270, QD = 1638804497, DV = 1154579445, pU = 2696325953, mU = 2713699986, JD = 2142170206, Rb = 3376911765, yU = 1077100507, vb = 3071239417, XD = 479945903, EU = 3426335179, X_ = 1502416096, eC = 2940368186, N_ = 3203706013, CV = 3862327254, KU = 1876633798, fC = 963979645, D_ = 644574406, gU = 3649138523, OV = 1662888072, LV = 317615605, _V = 1545765605, xV = 4266260250, wU = 3956297820, TU = 1530820697, RU = 840318589, PV = 1953115116, vU = 618700268, C_ = 2281632017, O_ = 3663046924, bQ = 42703149, tC = 1894708472, AU = 3599934289, ex = 33720170, NQ = 1027922057, MV = 544395925, DQ = 3649235739, L_ = 550521510, IC = 146592293, di = 3818125796, UV = 4021432810, __ = 1891881377, x_ = 3992365140, SU = 1763565496, CQ = 1946335990, bU = 514975943, NU = 506776471, DU = 710110818, iC = 1950438474, P_ = 976884017, M_ = 525669439, nC = 1770583370, OQ = 2176059722, CU = 679976338, OU = 3948183225, LU = 2568555532, BV = 2898700619, _U = 1594536857, FV = 4230923436, U_ = 4228831410, xU = 1310830890, PU = 24185140, MU = 4234616927, UU = 1306400036, BU = 4189326743, LQ = 2000195564, _Q = 3497074424, HV = 1626504194, FU = 3651464721, GV = 1229763772, kV = 3665877780, xQ = 782932809, Voe = 2735484536, zoe = 1356537516, PQ = 1290935644, joe = 1862484736, Yt = 1441486842, SJ = 1033248425, Woe = 3381221214, MQ = 2485787929, Yoe = 590820931, Dz = 3465909080, UQ = 593015953, qoe = 4212018352, $oe = 3425423356, Z1e = 823603102, Koe = 2165702409, xAe = 182550632, tme = 388784114, PAe = 536804194, MAe = 3752311538, UAe = 1010789467, Q1e = 222769930, wle = 2691318326, BAe = 3633395639, jze = 2879124712, Fm = 25142252, Hm = 3087945054, Gm = 4288193352, km = 630975310, Vm = 4086658281, zm = 2295281155, jm = 182646315, p1 = 1426591983, m1 = 819412036, y1 = 3415622556, E1 = 1003880860, g1 = 402227799, w1 = 264262732, T1 = 3310460725, R1 = 862014818, v1 = 1904799276, A1 = 1360408905, S1 = 3518393246, b1 = 342316401, T2 = 562808652, N1 = 4074379575, D1 = 3640358203, C1 = 4136498852, O1 = 2272882330, L1 = 3571504051, _1 = 3221913625, x1 = 639361253, P1 = 3902619387, M1 = 4217484030, U1 = 1051757585, B1 = 3758799889, F1 = 635142910, H1 = 2938176219, G1 = 32344328, pC = 2906023776, k1 = 277319702, V1 = 2056796094, z1 = 177149247, j1 = 1634111441, mC = 486154966, W1 = 4237592921, yC = 4156078855, Y1 = 4207607924, q1 = 4292641817, Gy = 3179687236, $1 = 3026737570, K1 = 3825984169, Z1 = 812556717, Q1 = 1162798199, _v = 385403989, J1 = 1404847402, X1 = 1999602285, eI = 3420628829, EC = 3027962421, gC = 3127900445, vg = 1329646415, tI = 3053780830, ky = 2572171363, R2 = 1232101972, iI = 90941305, Vy = 655969474, nI = 738039164, wC = 1156407060, sI = 3612865200, oI = 310824031, rI = 3694346114, zy = 144952367, lI = 2474470126, TC = 1911478936, aI = 1437502449, uI = 629592764, dI = 76236018, cI = 2176052936, hI = 4175244083, fI = 2068733104, II = 3319311131, pI = 2188021234, v2 = 1209101575, mI = 484807127, yI = 3747195512, EI = 2814081492, Dp = 2417008758, RC = 3242481149, xv = 3205830791, Cp = 400855858, vC = 905975707, d5 = 1677625105, Ag = 3296154744, Op = 2674252688, Lp = 2188180465, Pv = 1177604601, A2 = 39481116, Sg = 1136057603, Mv = 2461110595, _p = 1532957894, RO = 4088093105, S2 = 4009809668, Wm = 926996030, bg = 2391383451, jy = 2415094496, Wy = 3081323446, Ng = 413509423, Dg = 3101698114, b2 = 3657597509, N2 = 2757150158, D2 = 1004757350, C2 = 338393293, xp = 1072016465, O2 = 4074543187, vO = 2157484638, L2 = 2781568857, Yy = 2310774935, _2 = 964333572, x2 = 683857671, P2 = 1469900589, _g = 2839578677, Eg = 1158309216, gb = 3079942009, Pp = 1114901282, AO = 3113134337, Mp = 3946677679, IN = 2571569899, c5 = 3493046030, Cg = 1509553395, M2 = 1893162501, Uv = 2853485674, SO = 4148101412, Up = 132023988, Bv = 2397081782, U2 = 2323601079, pN = 1213902940, Fv = 1525564444, Hv = 4105962743, Gv = 2185764099, h5 = 15328376, eE = 3875453745, kv = 3893394355, B2 = 2197970202, Vv = 167062518, bO = 2887950389, f5 = 2603310189, mN = 1635779807, NO = 2916149573, DO = 1935646853, LP = 2387106220, CO = 3206491090, xF = 699246055, zv = 4095615324, F2 = 603775116, OO = 4015995234, jv = 2481509218, Wv = 463610769, LO = 710998568, _O = 1412071761, xO = 3663146110, Yv = 3243963512, gP = 816062949, Og = 1521410863, xg = 3523091289, Ce = 427948657, Zr = 307848117, le = 1462361463, me = 2565941209, yN = 1027710054, PF = 3521284610, w4 = 492091185, MF = 653396225, PO = 569719735, UF = 3967405729, _P = 1682466193, qv = 428585644, EN = 2294589976, xP = 178912537, $v = 4095422895, oN = 2652556860, I5 = 2804161546, MO = 4024345920, gN = 2629017746, Kv = 1815067380, EX = 3419103109, UO = 2574617495, PP = 2059837836, MP = 1675464909, xW = 574549367, wN = 3406155212, BF = 3698973494, FF = 3736923433, gX = 901063453, BO = 1096409881, ime = 1042787934, Gl = 1608871552, ad = 2943643501, HF = 2090586900, wX = 1482703590, nme = 3778827333, TX = 2998442950, XF = 853536259, RX = 3404854881, bae = 3079605661, iY = 2852063980, Nae = 3708119e3, sme = 1585845231, UP = 2133299955, z2 = 1437953363, eA = 3570813810, ui = 1437805879, ome = 297599258, rme = 211053100, vX = 2713554722, Dae = 3285139300, lme = 1236880293, Wze = 1199560280, ame = 3611470254, AX = 2771591690, ume = 1549132990, Yze = 2043862942, SX = 2934153892, dme = 609421318, cme = 3478079324, qze = 1054537805, $ze = 2439245199, Kze = 2433181523, Zze = 3915482550, Qze = 986844984, hme = 3843373140, Jze = 677532197, Xze = 1507914824, bX = 552965576, $P = 164193824, Cae = 2235152071, NX = 1847252529, eje = 760658860, Oae = 3057273783, tje = 4294318154, ije = 1466758467, FO = 1785450214, Lae = 775493141, Ra = 979691226, sC = 3700593921, H0 = 1062813311, dd = 1052013943, ic = 578613899, oC = 2454782716, G0 = 753842376, nc = 3001207471, sc = 2874132201, k0 = 3304561284, cd = 3512223829, V0 = 2391406946, M0 = 3313531582, Hu = 2347447852, Gu = 3824725483, ju = 2515109513, z0 = 4252922144, j0 = 331165859, W0 = 1529196076, oc = 1783015770, rC = 1376911519, Y0 = 2016517767, ku = 2320036040, U0 = 3027567501, HU = 3055160366, q0 = 3283111854, $0 = 3024970846, K0 = 2262370178, Z0 = 3171933400, i0 = 1687234759, Q0 = 1073191201, J0 = 900683007, hd = 3508470533, fd = 2223149337, Id = 707683696, pd = 987401354, md = 3132237377, rc = 4037862832, yd = 4278956645, Ed = 2058353004, va = 4222183408, Aa = 1810631287, Sa = 346874300, gd = 1658829314, VV = 857184966, zV = 1634875225, ba = 712377611, Na = 1217240411, lC = 1365060375, Da = 1534661035, Ca = 3277789161, Oa = 663422040, B_ = 855621170, La = 2030761528, _a = 3760055223, xa = 869906466, X0 = 395920057, Ym = 3041715199, eh = 3040386961, Vp = 1945004755, Wh = 2063403501, lc = 1599208980, Yh = 2635815018, th = 1335981549, BQ = 4147604152, Pa = 3961806047, ih = 3495092785, nh = 1973544240, Ma = 2954562838, Ua = 335055490, qm = 488727124, $m = 1060000209, Km = 3898045240, FQ = 1163958913, HQ = 2188551683, Ba = 2816379211, Fa = 3850581409, sh = 843113511, Ha = 2301859152, Pg = 2611217952, Ga = 2951183804, ka = 1285652485, Va = 3293546465, za = 395041908, qh = 1909888760, oh = 1095909175, n0 = 2979338954, GU = 52481810, Zv = 3299480353, ja = 231477066, jV = 1916977116, $h = 819618141, j2 = 1967976161, W2 = 3460190687, GQ = 2470393545, Wa = 1871374353, Ya = 3352864051, qa = 1411407467, Y2 = 3821786052, WV = 1213861670, Ky = 1033361043, Zm = 3342526732, Qm = 4218914973, q2 = 1028945134, $a = 1133259667, Kh = 1898987631, zp = 2769231204, Ka = 728799441, Za = 1911125066, Qa = 1600972822, Mg = 3593883385, wI = 1620046519, Ja = 1692211062, kQ = 1637806684, Xa = 5716631, $2 = 2254336722, eu = 2315554128, Jm = 148013059, Zh = 1975003073, AI = 2986769608, Qh = 1235345126, Jh = 734778138, Xh = 2082059205, F_ = 3987759626, s0 = 1621171031, K2 = 1252848954, H_ = 1721250024, o0 = 1807405624, ac = 2445595289, ef = 214636428, tf = 4243806635, Xm = 1179482911, RI = 682877961, nf = 1039846685, tu = 3112655638, sf = 3812236995, VQ = 652456506, iu = 1305183839, rh = 3856911033, of = 2533589738, a0 = 4097777520, zQ = 4105383287, jQ = 3517283431, nu = 1768891740, lB = 2863920197, U = 160246688, rf = 2324767716, lf = 2893384427, WQ = 3248260540, su = 2250791053, ou = 1842657554, wd = 3651124850, YQ = 3642467123, Z2 = 2904328755, Q2 = 2744685151, J2 = 3740093272, Ug = 3724593414, af = 4017108033, ru = 4231323485, lu = 804291784, X2 = 3327091369, e4 = 2382730787, au = 2837617999, YV = 3425660407, uc = 3588315303, t4 = 4143007308, qV = 1916936684, uu = 977012517, uf = 3181161470, B0 = 2108223431, r0 = 377706215, qQ = 2506943328, du = 1161773419, cu = 1051575348, e3 = 3827777499, hu = 4288270099, i4 = 2391368822, fu = 1806887404, Iu = 1251058090, vN = 2706460486, gu = 3009204131, aC = 200128114, $Q = 814719939, jp = 263784265, dc = 3009222698, cc = 2297155007, hc = 1339347760, fc = 1834744321, Ic = 1482959167, pu = 3815607619, pc = 3198132628, mc = 3907093117, df = 1287392070, cf = 2143335405, t3 = 2827207264, hf = 2489546625, lh = 647756555, i3 = 3737207727, Bg = 807026263, mu = 3390157468, yu = 3174744832, KQ = 3272907226, $V = 1962604670, yc = 2107101300, Fg = 1704287377, n3 = 2590856083, s3 = 1623761950, Wp = 4123344466, n4 = 1758889154, ZQ = 360485395, ff = 3849074793, o3 = 3256556792, Zoe = 681481545, If = 1457835157, r3 = 3295246426, pf = 1916426348, s4 = 1419761937, o4 = 3895139033, AN = 3293443760, r4 = 2559216714, SN = 2510884976, c0 = 3732776249, mf = 300633059, oA = 2937912522, u0 = 3124254112, Qv = 1950629157, l0 = 4031249490, rA = 1260505505, _5 = 3649129432, bN = 1334484129, YO = 3207858831, Zp = 1674181508, NN = 2296667514, Hp = 2097647324, l4 = 3473067441, yf = 1580310250, a4 = 4124788165, u4 = 2809605785, Lg = 2028607225, Qoe = 4070609034, Ec = 2218152070, Ef = 3979015343, l3 = 3689010777, a3 = 530289379, d4 = 3136571912, c4 = 3544373492, DN = 451544542, u3 = 3893378262, Zy = 2706606064, CN = 3626867408, ON = 4158566097, h4 = 1856042241, LN = 2914609552, ot = 1401173127, at = 3451746338, ns = 366585022, tr = 4122056220, rz = 1058617721, We = 1245217292, lt = 750771296, lz = 202636808, az = 2051452291, B = 3268803585, GF = 4189434867, ri = 279856033, ut = 3940055652, fe = 781010003, Fe = 4186316022, Ni = 693640335, Ye = 2551354335, Jp = 2802773753, dt = 886880790, Xe = 3242617779, ct = 3678494232, Hg = 504942748, Ko = 1638771189, Hn = 3912681535, Un = 2127690289, Ad = 3190031847, Vt = 4201705270, Gg = 3945020480, Te = 1204542856, KP = 826625072, bJ = 2851387026, So = 2655215786, oE = 3840914261, rE = 982818633, lA = 2728634034, lE = 919958153, T4 = 4095574036, NJ = 1327628568, X = 1865459582, Ns = 205026976, uz = 3372526763, ge = 2857406711, Xr = 4278684876, Vs = 1307041759, bs = 2495723537, Xp = 1683148259, ie = 3939117080, f4 = 3454111270, _N = 2798486643, aA = 2770003689, HO = 3219374653, Rl = 1451395588, QQ = 4194566429, Yg = 103090709, Td = 4208778838, xN = 2945172077, kg = 220341763, PN = 603570806, g5 = 3566463478, tA = 3505215534, iA = 3388369263, eH = 3888040117, uA = 1425443689, dA = 1281925730, ZP = 572779678, QP = 1484403080, cA = 987898635, gf = 1268542332, d3 = 4238390223, Joe = 3455213021, JP = 315944413, J1e = 4203026998, XP = 374418227, e8 = 2047409740, Vg = 477187591, Xoe = 80994333, tH = 2835456948, MN = 2777663545, I4 = 339256511, p4 = 1883228015, hA = 1472233963, UN = 4006246654, qO = 445594917, X1e = 3073041342, GO = 526551008, w5 = 1714330368, T5 = 2963535650, t8 = 32440307, KV = 4054601972, JQ = 606661476, eIe = 693772133, zg = 2827736869, i8 = 2601014836, fA = 2147822146, iH = 2506170314, tIe = 194851669, iIe = 4133800736, $O = 2485617015, IA = 2205249479, n8 = 1383045692, jg = 1416205885, pA = 3331915920, Wg = 3486308946, mA = 3749851601, s8 = 59481748, yA = 1123145078, o8 = 2898889636, EA = 2713105998, nH = 2581212453, gA = 4182860854, r8 = 2736907675, wA = 2740243338, TA = 3125803723, RA = 4261334040, Cz = 1302238472, ere = 2265737646, sH = 669184980, tre = 3288037868, oH = 2543172580, kO = 1299126871, R5 = 512836454, v5 = 336235671, BN = 2759199220, rH = 1417489154, l8 = 427810014, FN = 2347495698, $s = 1628702193, ire = 1345879162, lH = 2715220739, HN = 3124975700, aH = 4282788508, dz = 3028897424, uH = 3071757647, vA = 230924584, GN = 1260650574, kN = 2247615214, a8 = 1878645084, u8 = 2513912981, VN = 2233826070, nre = 3653947884, nIe = 3843319758, A5 = 1190533807, KO = 1597423693, S5 = 1973038258, ZO = 2473145415, QO = 2668620305, JO = 1595516126, sre = 390701378, ore = 1202362311, rre = 2485662743, dH = 723233188, _ae = 2609359061, d8 = 4124623270, lre = 2411513650, cH = 1509187699, zN = 2778083089, xae = 478536968, b5 = 3765753017, Pae = 3413951693, c8 = 3615266464, XO = 110355661, jN = 3650150729, hH = 3357820518, eL = 941946838, tL = 2752243245, iL = 4166981789, Mae = 1680319473, nL = 871118103, wie = 673634403, sIe = 179317114, oIe = 433424934, PW = 2559016684, MW = 759155922, AA = 2775532180, SA = 2924175390, WN = 1423911732, YN = 4022376103, fH = 2067069095, IH = 1663979128, pH = 2004835150, UW = 597895409, Jr = 3021840470, h8 = 2519244187, Uae = 2529465313, qN = 1029017970, bA = 2665983363, rIe = 2833995503, Bae = 219451334, lIe = 1430189142, PH = 2022407955, hL = 2347385850, mH = 1008929658, x5 = 2624227202, m4 = 3422422726, $N = 1520743889, KN = 4266656042, ZN = 2604431987, QN = 125510826, yH = 1402838566, Fae = 3741457305, EH = 3905492369, FAe = 2445078500, f8 = 812098782, Hae = 178086475, I8 = 3590301190, dE = 4142052618, Gae = 2453401579, BW = 3448662350, HAe = 1446786286, GAe = 803998398, kAe = 3857492461, Tie = 738692330, kae = 4219587988, NA = 3008276851, DA = 803316827, p8 = 1809719519, m8 = 2556980723, VAe = 1860660968, CA = 476780140, y8 = 3900360178, aIe = 4170525392, nY = 3732053477, zAe = 1694125774, jAe = 2273265877, Rie = 3632507154, vie = 3800577675, Vae = 2889183280, zae = 3050246964, E8 = 45288368, Aie = 1981873012, fL = 370225590, Sie = 1485152156, Ur = 2542286263, gH = 776857604, g8 = 647927063, w8 = 3150382593, FW = 616511568, T8 = 2705031697, bie = 1310608509, Nie = 3798115385, are = 2297822566, ure = 3612888222, dre = 962685235, uIe = 2442683028, WAe = 1065908215, jae = 891718957, JN = 1907098498, nje = 3304826586, wH = 2799835756, fme = 180925521, TH = 1735638870, Wae = 1377556343, sje = 581633288, cre = 1718945513, oje = 3101149627, YAe = 3317419933, Ime = 1210645708, P5 = 2552916305, HW = 1742049831, nA = 280115917, rje = 1484833681, pme = 1640371178, mme = 2636378356, sL = 1983826977, Yae = 1447204868, qae = 912023232, lje = 531007025, qAe = 985171141, $Ae = 1290481447, yme = 626085974, N5 = 1351298697, $ae = 846575682, Kae = 1607154358, Zae = 3303107099, Die = 1300840506, R8 = 3049322572, Qe = 3958052878, Cie = 2830218821, oL = 3408363356, GW = 2525727697, aje = 2162789131, uje = 2273995522, kW = 3692461612, v8 = 4240577450, Qae = 3982875396, Qy = 867548509, DX = 4165799628, CX = 2042790032, Oie = 448429030, dje = 2341007311, KAe = 3679540991, ah = 1660063152, cje = 3008791417, hje = 3377609919, XN = 1076942058, fje = 1222501353, OX = 1580146022, hre = 2692823254, A8 = 825690147, S8 = 2405470396, b8 = 3252649465, N8 = 931644368, D8 = 2093928680, C8 = 2044713172, Eme = 3710013099, cs = 148025276, fre = 3896028662, gme = 2598011224, Rs = 2802850158, ZAe = 3958567839, QAe = 2267347899, wf = 2095639259, JAe = 2417041796, Ije = 3119450353, Jae = 1304840413, Ke = 2022622350, VW = 1775413392, dIe = 3213052703, XAe = 990879717, wme = 3727388367, Xae = 3355820592, eue = 2226359599, pje = 2483315170, RH = 101040310, e6 = 2077209135, mje = 1207048766, IL = 1411181986, t6 = 4251960020, eSe = 1227763645, tue = 2251480897, XQ = 3701648758, tSe = 1918398963, iSe = 2706619895, iue = 3368373690, cIe = 677618848, nSe = 4256014907, yje = 2597039031, Ta = 3265635763, sSe = 2199411900, nue = 1303795690, pL = 3303938423, sue = 248100487, oSe = 1847130766, oue = 1838606355, Eje = 30780891, gje = 1566485204, wje = 4162380809, sY = 3452421091, rue = 2655187982, Tje = 3020489413, Rje = 852622518, lue = 3548104201, rSe = 3207319532, aue = 1040185647, uue = 2242383968, vje = 3200245327, lSe = 1648886627, Dy = 3796139169, mL = 770865208, due = 1154170062, Aje = 1376555844, Sje = 2949456006, bje = 1045800335, aSe = 1765591967, Nje = 1072939445, cue = 3510044353, hue = 2367409068, fue = 1105321065, Tme = 539742890, Iue = 602808272, Dje = 1065062679, kU = 347226245, Ire = 613356794, VU = 1658513725, Cje = 1959218052, zW = 2732653382, uSe = 4257277454, Lie = 2614616156, dSe = 2859738748, pue = 3264961684, Oje = 3639012971, Lje = 938368621, hIe = 1098599126, cSe = 1767535486, Rme = 747523909, _je = 622194075, vH = 2069777674, mue = 1387855156, yue = 3367102660, Eue = 1560379544, xje = 4037036970, yL = 3869604511, Pje = 390851274, hSe = 2080292479, Mje = 130549933, zU = 1110488051, Uje = 411424972, Bje = 639542469, Fje = 618182010, Hje = 3630933823, vme = 599546466, Ame = 1390159747, pre = 1109904537, u = class {
  constructor(e, t = 2, i) {
    if (this.value = e, this.type = 5, i && (i == null ? void 0 : i.type) === 2) return Li(t, i);
  }
}, pt = class {
  constructor(e, t) {
    this.type = 4, t && (this.type = t), this.value = e;
  }
  get internalValue() {
    return this._internalValue;
  }
  get value() {
    return this._representationValue;
  }
  set value(e) {
    this._representationValue = (this._internalValue = e) === null ? e : parseFloat(e);
  }
}, fSe = /* @__PURE__ */ ((e) => (e[e.FALSE = 0] = "FALSE", e[e.TRUE = 1] = "TRUE", e[e.UNKNOWN = 2] = "UNKNOWN", e))(fSe || {}), qt = class {
  constructor(e = -1) {
    this.expressID = e, this.type = 0;
  }
}, kF = [], _ie = {}, wP = {}, xie = {}, Pie = {}, AH = {}, TP = [];
function Li(e, t) {
  return Array.isArray(t) && t.map((i) => Li(e, i)), t.typecode ? AH[e][t.typecode](t.value) : t.value;
}
function ke(e) {
  if ((e ?? void 0) === void 0 || e instanceof u || e instanceof pt || e.label) return e;
  if (Array.isArray(e)) return e.map((i) => ke(i));
  const t = e.type === 4 ? "internalValue" : "value";
  return { [t]: e[t], valueType: e.type, type: 2, label: e.name };
}
var ISe = /* @__PURE__ */ ((e) => (e.IFC2X3 = "IFC2X3", e.IFC4 = "IFC4", e.IFC4X3 = "IFC4X3", e))(ISe || {});
TP[1] = ["IFC2X3", "IFC2X_FINAL"];
kF[1] = {
  3630933823: (e) => new f.IfcActorRole(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcText((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  618182010: (e) => new f.IfcAddress(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  639542469: (e) => new f.IfcApplication(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new f.IfcIdentifier((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  411424972: (e) => new f.IfcAppliedValue((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5])),
  1110488051: (e) => {
    var t;
    return new f.IfcAppliedValueRelationship(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], e[2], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcLabel((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcText((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value));
  },
  130549933: (e) => new f.IfcApproval((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcText((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcLabel((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcText((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new f.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new f.IfcIdentifier((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  2080292479: (e) => new f.IfcApprovalActorRelationship(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2])),
  390851274: (e) => {
    var t;
    return new f.IfcApprovalPropertyRelationship(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]));
  },
  3869604511: (e) => new f.IfcApprovalRelationship(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcText((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new f.IfcLabel((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  4037036970: (e) => new f.IfcBoundaryCondition((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  1560379544: (e) => new f.IfcBoundaryEdgeCondition((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcModulusOfLinearSubgradeReactionMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcModulusOfLinearSubgradeReactionMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcModulusOfLinearSubgradeReactionMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcModulusOfRotationalSubgradeReactionMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcModulusOfRotationalSubgradeReactionMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcModulusOfRotationalSubgradeReactionMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  3367102660: (e) => new f.IfcBoundaryFaceCondition((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcModulusOfSubgradeReactionMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcModulusOfSubgradeReactionMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcModulusOfSubgradeReactionMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  1387855156: (e) => new f.IfcBoundaryNodeCondition((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLinearStiffnessMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLinearStiffnessMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcLinearStiffnessMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcRotationalStiffnessMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcRotationalStiffnessMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcRotationalStiffnessMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  2069777674: (e) => new f.IfcBoundaryNodeConditionWarping((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLinearStiffnessMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLinearStiffnessMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcLinearStiffnessMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcRotationalStiffnessMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcRotationalStiffnessMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcRotationalStiffnessMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcWarpingMomentMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  622194075: (e) => new f.IfcCalendarDate(new f.IfcDayInMonthNumber((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new f.IfcMonthInYearNumber((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new f.IfcYearNumber((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  747523909: (e) => new f.IfcClassification(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new f.IfcLabel((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  1767535486: (e) => new f.IfcClassificationItem(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  1098599126: (e) => {
    var t;
    return new f.IfcClassificationItemRelationship(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  938368621: (e) => {
    var t;
    return new f.IfcClassificationNotation(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  3639012971: (e) => new f.IfcClassificationNotationFacet(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  3264961684: (e) => new f.IfcColourSpecification((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  2859738748: (e) => new f.IfcConnectionGeometry(),
  2614616156: (e) => new f.IfcConnectionPointGeometry(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1])),
  4257277454: (e) => new f.IfcConnectionPortGeometry(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2])),
  2732653382: (e) => new f.IfcConnectionSurfaceGeometry(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1])),
  1959218052: (e) => new f.IfcConstraint(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), e[2], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcLabel((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  1658513725: (e) => {
    var t;
    return new f.IfcConstraintAggregationRelationship((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], e[4]);
  },
  613356794: (e) => {
    var t;
    return new f.IfcConstraintClassificationRelationship(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  347226245: (e) => {
    var t;
    return new f.IfcConstraintRelationship((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  1065062679: (e) => new f.IfcCoordinatedUniversalTimeOffset(new f.IfcHourInDay((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcMinuteInHour((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), e[2]),
  602808272: (e) => new f.IfcCostValue((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), new f.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcText((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  539742890: (e) => new f.IfcCurrencyRelationship(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), new f.IfcPositiveRatioMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4])),
  1105321065: (e) => {
    var t;
    return new f.IfcCurveStyleFont((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  2367409068: (e) => new f.IfcCurveStyleFontAndScaling((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), new f.IfcPositiveRatioMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  3510044353: (e) => new f.IfcCurveStyleFontPattern(new f.IfcLengthMeasure((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new f.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  1072939445: (e) => new f.IfcDateAndTime(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1])),
  1765591967: (e) => {
    var t;
    return new f.IfcDerivedUnit(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], e[1], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value));
  },
  1045800335: (e) => new f.IfcDerivedUnitElement(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new pt((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 10)),
  2949456006: (e) => new f.IfcDimensionalExponents(new pt((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 10), new pt((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 10), new pt((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 10), new pt((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 10), new pt((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 10), new pt((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 10), new pt((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 10)),
  1376555844: (e) => new f.IfcDocumentElectronicFormat((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  1154170062: (e) => {
    var t, i;
    return new f.IfcDocumentInformation(new f.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcText((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : ((t = e[3]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcText((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcText((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcText((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 1, e[8]), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : ((i = e[9]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 1, e[10]), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new u((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value, 1, e[11]), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new u((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value, 1, e[12]), (e[13] ?? void 0) === void 0 || e[13] === "" ? null : new u((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value, 1, e[13]), (e[14] ?? void 0) === void 0 || e[14] === "" ? null : new u((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value, 1, e[14]), e[15], e[16]);
  },
  770865208: (e) => {
    var t;
    return new f.IfcDocumentInformationRelationship(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value));
  },
  3796139169: (e) => new f.IfcDraughtingCalloutRelationship((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3])),
  1648886627: (e) => new f.IfcEnvironmentalImpactValue((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), new f.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), e[7], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  3200245327: (e) => new f.IfcExternalReference((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcIdentifier((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  2242383968: (e) => new f.IfcExternallyDefinedHatchStyle((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcIdentifier((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  1040185647: (e) => new f.IfcExternallyDefinedSurfaceStyle((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcIdentifier((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  3207319532: (e) => new f.IfcExternallyDefinedSymbol((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcIdentifier((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  3548104201: (e) => new f.IfcExternallyDefinedTextFont((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcIdentifier((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  852622518: (e) => new f.IfcGridAxis((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), new f.IfcBoolean((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  3020489413: (e) => {
    var t;
    return new f.IfcIrregularTimeSeriesValue(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? Li(1, i) : null)) || []);
  },
  2655187982: (e) => {
    var t;
    return new f.IfcLibraryInformation(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  3452421091: (e) => new f.IfcLibraryReference((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcIdentifier((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  4162380809: (e) => {
    var t, i;
    return new f.IfcLightDistributionData(new f.IfcPlaneAngleMeasure((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), ((t = e[1]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new f.IfcPlaneAngleMeasure(n.value) : null)) || [], ((i = e[2]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new f.IfcLuminousIntensityDistributionMeasure(n.value) : null)) || []);
  },
  1566485204: (e) => {
    var t;
    return new f.IfcLightIntensityDistribution(e[0], ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  30780891: (e) => new f.IfcLocalTime(new f.IfcHourInDay((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcMinuteInHour((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcSecondInMinute((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcDaylightSavingHour((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  1838606355: (e) => new f.IfcMaterial(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  1847130766: (e) => {
    var t;
    return new f.IfcMaterialClassificationRelationship(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]));
  },
  248100487: (e) => new f.IfcMaterialLayer((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new f.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLogical((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  3303938423: (e) => {
    var t;
    return new f.IfcMaterialLayerSet(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value));
  },
  1303795690: (e) => new f.IfcMaterialLayerSetUsage(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), e[1], e[2], new f.IfcLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2199411900: (e) => {
    var t;
    return new f.IfcMaterialList(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  3265635763: (e) => new f.IfcMaterialProperties(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0])),
  2597039031: (e) => new f.IfcMeasureWithUnit(Li(1, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1])),
  4256014907: (e) => new f.IfcMechanicalMaterialProperties(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcDynamicViscosityMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcModulusOfElasticityMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcModulusOfElasticityMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcPositiveRatioMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcThermalExpansionCoefficientMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value)),
  677618848: (e) => {
    var t;
    return new f.IfcMechanicalSteelMaterialProperties(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcDynamicViscosityMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcModulusOfElasticityMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcModulusOfElasticityMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcPositiveRatioMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcThermalExpansionCoefficientMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcPressureMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcPressureMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcPositiveRatioMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new f.IfcModulusOfElasticityMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new f.IfcPressureMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new f.IfcPositiveRatioMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : ((t = e[12]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  3368373690: (e) => new f.IfcMetric(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), e[2], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcLabel((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), e[7], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 1, e[9])),
  2706619895: (e) => new f.IfcMonetaryUnit(e[0]),
  1918398963: (e) => new f.IfcNamedUnit(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), e[1]),
  3701648758: (e) => new f.IfcObjectPlacement(),
  2251480897: (e) => new f.IfcObjective(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), e[2], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcLabel((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 1, e[7]), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 1, e[8]), e[9], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new f.IfcLabel((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value)),
  1227763645: (e) => new f.IfcOpticalMaterialProperties(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcPositiveRatioMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcPositiveRatioMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcPositiveRatioMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcPositiveRatioMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcPositiveRatioMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcPositiveRatioMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcPositiveRatioMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcPositiveRatioMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new f.IfcPositiveRatioMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value)),
  4251960020: (e) => {
    var t, i;
    return new f.IfcOrganization((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcText((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : ((t = e[3]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[4] ?? void 0) === void 0 || e[4] === "" ? null : ((i = e[4]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || []);
  },
  1411181986: (e) => {
    var t;
    return new f.IfcOrganizationRelationship(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  1207048766: (e) => new f.IfcOwnerHistory(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), e[2], e[3], (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcTimeStamp((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), new f.IfcTimeStamp((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  2077209135: (e) => {
    var t, i, n, s, o;
    return new f.IfcPerson((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : ((t = e[3]) == null ? void 0 : t.map((r) => ((r == null ? void 0 : r.value) ?? void 0) !== void 0 && (r == null ? void 0 : r.value) !== "" ? new f.IfcLabel(r.value) : null)) || [], (e[4] ?? void 0) === void 0 || e[4] === "" ? null : ((i = e[4]) == null ? void 0 : i.map((r) => ((r == null ? void 0 : r.value) ?? void 0) !== void 0 && (r == null ? void 0 : r.value) !== "" ? new f.IfcLabel(r.value) : null)) || [], (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((n = e[5]) == null ? void 0 : n.map((r) => ((r == null ? void 0 : r.value) ?? void 0) !== void 0 && (r == null ? void 0 : r.value) !== "" ? new f.IfcLabel(r.value) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((s = e[6]) == null ? void 0 : s.map((r) => ((r == null ? void 0 : r.value) ?? void 0) !== void 0 && (r == null ? void 0 : r.value) !== "" ? new u(r.value, 1, r) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((o = e[7]) == null ? void 0 : o.map((r) => ((r == null ? void 0 : r.value) ?? void 0) !== void 0 && (r == null ? void 0 : r.value) !== "" ? new u(r.value, 1, r) : null)) || []);
  },
  101040310: (e) => {
    var t;
    return new f.IfcPersonAndOrganization(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  2483315170: (e) => new f.IfcPhysicalQuantity(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  2226359599: (e) => new f.IfcPhysicalSimpleQuantity(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2])),
  3355820592: (e) => {
    var t;
    return new f.IfcPostalAddress(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcLabel((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new f.IfcLabel(i.value) : null)) || [], (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new f.IfcLabel((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value));
  },
  3727388367: (e) => new f.IfcPreDefinedItem(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  990879717: (e) => new f.IfcPreDefinedSymbol(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  3213052703: (e) => new f.IfcPreDefinedTerminatorSymbol(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  1775413392: (e) => new f.IfcPreDefinedTextFont(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  2022622350: (e) => {
    var t;
    return new f.IfcPresentationLayerAssignment(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcIdentifier((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value));
  },
  1304840413: (e) => {
    var t, i;
    return new f.IfcPresentationLayerWithStyle(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcIdentifier((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, (e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, (e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((i = e[7]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || []);
  },
  3119450353: (e) => new f.IfcPresentationStyle((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  2417041796: (e) => {
    var t;
    return new f.IfcPresentationStyleAssignment(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  2095639259: (e) => {
    var t;
    return new f.IfcProductRepresentation((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  2267347899: (e) => new f.IfcProductsOfCombustionProperties(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcSpecificHeatCapacityMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcPositiveRatioMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcPositiveRatioMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcPositiveRatioMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  3958567839: (e) => new f.IfcProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  2802850158: (e) => new f.IfcProfileProperties((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1])),
  2598011224: (e) => new f.IfcProperty(new f.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  3896028662: (e) => {
    var t;
    return new f.IfcPropertyConstraintRelationship(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value));
  },
  148025276: (e) => new f.IfcPropertyDependencyRelationship(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcText((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  3710013099: (e) => {
    var t;
    return new f.IfcPropertyEnumeration(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? Li(1, i) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]));
  },
  2044713172: (e) => new f.IfcQuantityArea(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new f.IfcAreaMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2093928680: (e) => new f.IfcQuantityCount(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new f.IfcCountMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  931644368: (e) => new f.IfcQuantityLength(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new f.IfcLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  3252649465: (e) => new f.IfcQuantityTime(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new f.IfcTimeMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2405470396: (e) => new f.IfcQuantityVolume(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new f.IfcVolumeMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  825690147: (e) => new f.IfcQuantityWeight(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new f.IfcMassMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2692823254: (e) => {
    var t;
    return new f.IfcReferencesValueDocument(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value));
  },
  1580146022: (e) => new f.IfcReinforcementBarProperties(new f.IfcAreaMeasure((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), e[2], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcCountMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value)),
  1222501353: (e) => new f.IfcRelaxation(new f.IfcNormalisedRatioMeasure((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new f.IfcNormalisedRatioMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  1076942058: (e) => {
    var t;
    return new f.IfcRepresentation(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  3377609919: (e) => new f.IfcRepresentationContext((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  3008791417: (e) => new f.IfcRepresentationItem(),
  1660063152: (e) => new f.IfcRepresentationMap(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1])),
  3679540991: (e) => new f.IfcRibPlateProfileProperties((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcPositiveLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), e[6]),
  2341007311: (e) => new f.IfcRoot(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  448429030: (e) => new f.IfcSIUnit(e[0], e[1], e[2]),
  2042790032: (e) => new f.IfcSectionProperties(e[0], new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2])),
  4165799628: (e) => {
    var t;
    return new f.IfcSectionReinforcementProperties(new f.IfcLengthMeasure((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new f.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), e[3], new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  867548509: (e) => {
    var t;
    return new f.IfcShapeAspect(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcText((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]));
  },
  3982875396: (e) => {
    var t;
    return new f.IfcShapeModel(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  4240577450: (e) => {
    var t;
    return new f.IfcShapeRepresentation(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  3692461612: (e) => new f.IfcSimpleProperty(new f.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  2273995522: (e) => new f.IfcStructuralConnectionCondition((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  2162789131: (e) => new f.IfcStructuralLoad((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  2525727697: (e) => new f.IfcStructuralLoadStatic((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  3408363356: (e) => new f.IfcStructuralLoadTemperature((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcThermodynamicTemperatureMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcThermodynamicTemperatureMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcThermodynamicTemperatureMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2830218821: (e) => {
    var t;
    return new f.IfcStyleModel(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  3958052878: (e) => {
    var t;
    return new f.IfcStyledItem((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value));
  },
  3049322572: (e) => {
    var t;
    return new f.IfcStyledRepresentation(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  1300840506: (e) => {
    var t;
    return new f.IfcSurfaceStyle((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), e[1], ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  3303107099: (e) => new f.IfcSurfaceStyleLighting(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3])),
  1607154358: (e) => new f.IfcSurfaceStyleRefraction((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcReal((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcReal((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  846575682: (e) => new f.IfcSurfaceStyleShading(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0])),
  1351298697: (e) => {
    var t;
    return new f.IfcSurfaceStyleWithTextures(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  626085974: (e) => new f.IfcSurfaceTexture((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, (e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, e[2], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3])),
  1290481447: (e) => new f.IfcSymbolStyle((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), Li(1, e[1])),
  985171141: (e) => {
    var t;
    return new f.IfcTable((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  531007025: (e) => {
    var t;
    return new f.IfcTableRow(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? Li(1, i) : null)) || [], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value);
  },
  912023232: (e) => {
    var t, i, n;
    return new f.IfcTelecomAddress(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : ((t = e[3]) == null ? void 0 : t.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new f.IfcLabel(s.value) : null)) || [], (e[4] ?? void 0) === void 0 || e[4] === "" ? null : ((i = e[4]) == null ? void 0 : i.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new f.IfcLabel(s.value) : null)) || [], (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((n = e[6]) == null ? void 0 : n.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new f.IfcLabel(s.value) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value));
  },
  1447204868: (e) => new f.IfcTextStyle((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3])),
  1983826977: (e) => {
    var t;
    return new f.IfcTextStyleFontModel(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new f.IfcTextFontName(i.value) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcFontStyle((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcFontVariant((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcFontWeight((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), Li(1, e[5]));
  },
  2636378356: (e) => new f.IfcTextStyleForDefinedFont(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1])),
  1640371178: (e) => new f.IfcTextStyleTextModel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : Li(1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcTextAlignment((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcTextDecoration((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : Li(1, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : Li(1, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcTextTransformation((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : Li(1, e[6])),
  1484833681: (e) => new f.IfcTextStyleWithBoxCharacteristics((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcPositiveLengthMeasure((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcPlaneAngleMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcPlaneAngleMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : Li(1, e[4])),
  280115917: (e) => new f.IfcTextureCoordinate(),
  1742049831: (e) => {
    var t;
    return new f.IfcTextureCoordinateGenerator(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? Li(1, i) : null)) || []);
  },
  2552916305: (e) => {
    var t;
    return new f.IfcTextureMap(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  1210645708: (e) => {
    var t;
    return new f.IfcTextureVertex(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new f.IfcParameterValue(i.value) : null)) || []);
  },
  3317419933: (e) => new f.IfcThermalMaterialProperties(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcSpecificHeatCapacityMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcThermodynamicTemperatureMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcThermodynamicTemperatureMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcThermalConductivityMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  3101149627: (e) => new f.IfcTimeSeries(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3]), e[4], e[5], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 1, e[7])),
  1718945513: (e) => {
    var t;
    return new f.IfcTimeSeriesReferenceRelationship(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  581633288: (e) => {
    var t;
    return new f.IfcTimeSeriesValue(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? Li(1, i) : null)) || []);
  },
  1377556343: (e) => new f.IfcTopologicalRepresentationItem(),
  1735638870: (e) => {
    var t;
    return new f.IfcTopologyRepresentation(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  180925521: (e) => {
    var t;
    return new f.IfcUnitAssignment(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  2799835756: (e) => new f.IfcVertex(),
  3304826586: (e) => {
    var t, i;
    return new f.IfcVertexBasedTextureMap(((t = e[0]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], ((i = e[1]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || []);
  },
  1907098498: (e) => new f.IfcVertexPoint(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0])),
  891718957: (e) => {
    var t, i;
    return new f.IfcVirtualGridIntersection(((t = e[0]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], ((i = e[1]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new f.IfcLengthMeasure(n.value) : null)) || []);
  },
  1065908215: (e) => new f.IfcWaterProperties(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" || (e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcIonConcentrationMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcIonConcentrationMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcIonConcentrationMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcNormalisedRatioMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcPHMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcNormalisedRatioMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  2442683028: (e) => {
    var t;
    return new f.IfcAnnotationOccurrence((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value));
  },
  962685235: (e) => {
    var t;
    return new f.IfcAnnotationSurfaceOccurrence((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value));
  },
  3612888222: (e) => {
    var t;
    return new f.IfcAnnotationSymbolOccurrence((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value));
  },
  2297822566: (e) => {
    var t;
    return new f.IfcAnnotationTextOccurrence((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value));
  },
  3798115385: (e) => new f.IfcArbitraryClosedProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2])),
  1310608509: (e) => new f.IfcArbitraryOpenProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2])),
  2705031697: (e) => {
    var t;
    return new f.IfcArbitraryProfileDefWithVoids(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  616511568: (e) => new f.IfcBlobTexture((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, (e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, e[2], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3]), new f.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value),
  3150382593: (e) => new f.IfcCenterLineProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new f.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  647927063: (e) => new f.IfcClassificationReference((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcIdentifier((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3])),
  776857604: (e) => new f.IfcColourRgb((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new f.IfcNormalisedRatioMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new f.IfcNormalisedRatioMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new f.IfcNormalisedRatioMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2542286263: (e) => {
    var t;
    return new f.IfcComplexProperty(new f.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new f.IfcIdentifier((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  1485152156: (e) => {
    var t;
    return new f.IfcCompositeProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcLabel((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value));
  },
  370225590: (e) => {
    var t;
    return new f.IfcConnectedFaceSet(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  1981873012: (e) => new f.IfcConnectionCurveGeometry(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1])),
  45288368: (e) => new f.IfcConnectionPointEccentricity(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  3050246964: (e) => new f.IfcContextDependentUnit(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), e[1], new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  2889183280: (e) => new f.IfcConversionBasedUnit(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), e[1], new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3])),
  3800577675: (e) => new f.IfcCurveStyle((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : Li(1, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3])),
  3632507154: (e) => new f.IfcDerivedProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  2273265877: (e) => new f.IfcDimensionCalloutRelationship((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3])),
  1694125774: (e) => new f.IfcDimensionPair((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3])),
  3732053477: (e) => new f.IfcDocumentReference((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcIdentifier((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  4170525392: (e) => new f.IfcDraughtingPreDefinedTextFont(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  3900360178: (e) => new f.IfcEdge(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1])),
  476780140: (e) => new f.IfcEdgeCurve(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value),
  1860660968: (e) => {
    var t;
    return new f.IfcExtendedMaterialProperties(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcText((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new f.IfcLabel((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value));
  },
  2556980723: (e) => {
    var t;
    return new f.IfcFace(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  1809719519: (e) => new f.IfcFaceBound(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value),
  803316827: (e) => new f.IfcFaceOuterBound(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value),
  3008276851: (e) => {
    var t;
    return new f.IfcFaceSurface(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value);
  },
  4219587988: (e) => new f.IfcFailureConnectionCondition((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcForceMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcForceMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcForceMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcForceMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcForceMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcForceMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  738692330: (e) => {
    var t;
    return new f.IfcFillAreaStyle((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  3857492461: (e) => new f.IfcFuelProperties(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcThermodynamicTemperatureMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcPositiveRatioMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcHeatingValueMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcHeatingValueMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  803998398: (e) => new f.IfcGeneralMaterialProperties(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcMolecularWeightMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcNormalisedRatioMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcMassDensityMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  1446786286: (e) => new f.IfcGeneralProfileProperties((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcMassPerLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcAreaMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  3448662350: (e) => new f.IfcGeometricRepresentationContext((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new f.IfcDimensionCount((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new pt((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 4), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5])),
  2453401579: (e) => new f.IfcGeometricRepresentationItem(),
  4142052618: (e) => new f.IfcGeometricRepresentationSubContext((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcPositiveRatioMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), e[4], (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value)),
  3590301190: (e) => {
    var t;
    return new f.IfcGeometricSet(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  178086475: (e) => new f.IfcGridPlacement(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1])),
  812098782: (e) => new f.IfcHalfSpaceSolid(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value),
  2445078500: (e) => new f.IfcHygroscopicMaterialProperties(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcPositiveRatioMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcPositiveRatioMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcIsothermalMoistureCapacityMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcVaporPermeabilityMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcMoistureDiffusivityMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value)),
  3905492369: (e) => new f.IfcImageTexture((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, (e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, e[2], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3]), new f.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  3741457305: (e) => {
    var t;
    return new f.IfcIrregularTimeSeries(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3]), e[4], e[5], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 1, e[7]), ((t = e[8]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  1402838566: (e) => new f.IfcLightSource((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcNormalisedRatioMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcNormalisedRatioMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  125510826: (e) => new f.IfcLightSourceAmbient((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcNormalisedRatioMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcNormalisedRatioMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2604431987: (e) => new f.IfcLightSourceDirectional((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcNormalisedRatioMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcNormalisedRatioMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4])),
  4266656042: (e) => new f.IfcLightSourceGoniometric((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcNormalisedRatioMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcNormalisedRatioMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), new f.IfcThermodynamicTemperatureMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), new f.IfcLuminousFluxMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 1, e[9])),
  1520743889: (e) => new f.IfcLightSourcePositional((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcNormalisedRatioMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcNormalisedRatioMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), new f.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new f.IfcReal((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), new f.IfcReal((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), new f.IfcReal((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  3422422726: (e) => new f.IfcLightSourceSpot((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcNormalisedRatioMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcNormalisedRatioMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), new f.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new f.IfcReal((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), new f.IfcReal((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), new f.IfcReal((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 1, e[9]), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new f.IfcReal((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), new f.IfcPositivePlaneAngleMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), new f.IfcPositivePlaneAngleMeasure((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value)),
  2624227202: (e) => new f.IfcLocalPlacement((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1])),
  1008929658: (e) => new f.IfcLoop(),
  2347385850: (e) => new f.IfcMappedItem(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1])),
  2022407955: (e) => {
    var t;
    return new f.IfcMaterialDefinitionRepresentation((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3]));
  },
  1430189142: (e) => new f.IfcMechanicalConcreteMaterialProperties(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcDynamicViscosityMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcModulusOfElasticityMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcModulusOfElasticityMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcPositiveRatioMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcThermalExpansionCoefficientMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcPressureMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcPositiveLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcText((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new f.IfcText((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new f.IfcNormalisedRatioMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new f.IfcText((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value)),
  219451334: (e) => new f.IfcObjectDefinition(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2833995503: (e) => new f.IfcOneDirectionRepeatFactor(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0])),
  2665983363: (e) => {
    var t;
    return new f.IfcOpenShell(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  1029017970: (e) => new f.IfcOrientedEdge(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value),
  2529465313: (e) => new f.IfcParameterizedProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2])),
  2519244187: (e) => {
    var t;
    return new f.IfcPath(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  3021840470: (e) => {
    var t;
    return new f.IfcPhysicalComplexQuantity(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], new f.IfcLabel((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value));
  },
  597895409: (e) => {
    var t;
    return new f.IfcPixelTexture((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, (e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, e[2], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3]), new f.IfcInteger((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new f.IfcInteger((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new f.IfcInteger((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), ((t = e[7]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? Number(i.value) : null)) || []);
  },
  2004835150: (e) => new f.IfcPlacement(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0])),
  1663979128: (e) => new f.IfcPlanarExtent(new f.IfcLengthMeasure((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new f.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  2067069095: (e) => new f.IfcPoint(),
  4022376103: (e) => new f.IfcPointOnCurve(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new f.IfcParameterValue((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  1423911732: (e) => new f.IfcPointOnSurface(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new f.IfcParameterValue((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new f.IfcParameterValue((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  2924175390: (e) => {
    var t;
    return new f.IfcPolyLoop(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  2775532180: (e) => new f.IfcPolygonalBoundedHalfSpace(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3])),
  759155922: (e) => new f.IfcPreDefinedColour(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  2559016684: (e) => new f.IfcPreDefinedCurveFont(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  433424934: (e) => new f.IfcPreDefinedDimensionSymbol(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  179317114: (e) => new f.IfcPreDefinedPointMarkerSymbol(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  673634403: (e) => {
    var t;
    return new f.IfcProductDefinitionShape((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  871118103: (e) => new f.IfcPropertyBoundedValue(new f.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : Li(1, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : Li(1, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4])),
  1680319473: (e) => new f.IfcPropertyDefinition(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  4166981789: (e) => {
    var t;
    return new f.IfcPropertyEnumeratedValue(new f.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? Li(1, i) : null)) || [], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3]));
  },
  2752243245: (e) => {
    var t;
    return new f.IfcPropertyListValue(new f.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? Li(1, i) : null)) || [], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3]));
  },
  941946838: (e) => new f.IfcPropertyReferenceValue(new f.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3])),
  3357820518: (e) => new f.IfcPropertySetDefinition(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  3650150729: (e) => new f.IfcPropertySingleValue(new f.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : Li(1, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3])),
  110355661: (e) => {
    var t, i;
    return new f.IfcPropertyTableValue(new f.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? Li(1, n) : null)) || [], ((i = e[3]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? Li(1, n) : null)) || [], (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcText((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]));
  },
  3615266464: (e) => new f.IfcRectangleProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new f.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new f.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  3413951693: (e) => {
    var t;
    return new f.IfcRegularTimeSeries(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3]), e[4], e[5], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 1, e[7]), new f.IfcTimeMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), ((t = e[9]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  3765753017: (e) => {
    var t;
    return new f.IfcReinforcementDefinitionProperties(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  478536968: (e) => new f.IfcRelationship(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2778083089: (e) => new f.IfcRoundedRectangleProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new f.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new f.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new f.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value)),
  1509187699: (e) => {
    var t, i;
    return new f.IfcSectionedSpine(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), ((t = e[1]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], ((i = e[2]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || []);
  },
  2411513650: (e) => new f.IfcServiceLifeFactor(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), e[4], (e[5] ?? void 0) === void 0 || e[5] === "" ? null : Li(1, e[5]), Li(1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : Li(1, e[7])),
  4124623270: (e) => {
    var t;
    return new f.IfcShellBasedSurfaceModel(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  2609359061: (e) => new f.IfcSlippageConnectionCondition((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  723233188: (e) => new f.IfcSolidModel(),
  2485662743: (e) => {
    var t;
    return new f.IfcSoundProperties(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new f.IfcBoolean((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), e[5], ((t = e[6]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  1202362311: (e) => new f.IfcSoundValue(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), new f.IfcFrequencyMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : Li(1, e[6])),
  390701378: (e) => new f.IfcSpaceThermalLoadProperties(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcPositiveRatioMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), e[5], e[6], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcText((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), new f.IfcPowerMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new f.IfcPowerMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 1, e[10]), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new f.IfcLabel((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new f.IfcLabel((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), e[13]),
  1595516126: (e) => new f.IfcStructuralLoadLinearForce((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLinearForceMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLinearForceMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcLinearForceMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLinearMomentMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcLinearMomentMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcLinearMomentMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  2668620305: (e) => new f.IfcStructuralLoadPlanarForce((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcPlanarForceMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcPlanarForceMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcPlanarForceMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2473145415: (e) => new f.IfcStructuralLoadSingleDisplacement((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcPlaneAngleMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcPlaneAngleMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcPlaneAngleMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  1973038258: (e) => new f.IfcStructuralLoadSingleDisplacementDistortion((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcPlaneAngleMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcPlaneAngleMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcPlaneAngleMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcCurvatureMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  1597423693: (e) => new f.IfcStructuralLoadSingleForce((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcForceMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcForceMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcForceMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcTorqueMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcTorqueMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcTorqueMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  1190533807: (e) => new f.IfcStructuralLoadSingleForceWarping((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcForceMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcForceMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcForceMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcTorqueMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcTorqueMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcTorqueMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcWarpingMomentMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  3843319758: (e) => new f.IfcStructuralProfileProperties((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcMassPerLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcAreaMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcMomentOfInertiaMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcMomentOfInertiaMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new f.IfcMomentOfInertiaMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new f.IfcMomentOfInertiaMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new f.IfcWarpingConstantMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new f.IfcLengthMeasure((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), (e[13] ?? void 0) === void 0 || e[13] === "" ? null : new f.IfcLengthMeasure((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value), (e[14] ?? void 0) === void 0 || e[14] === "" ? null : new f.IfcAreaMeasure((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value), (e[15] ?? void 0) === void 0 || e[15] === "" ? null : new f.IfcAreaMeasure((e[15] ?? void 0) === void 0 || e[15] === "" ? null : e[15].value), (e[16] ?? void 0) === void 0 || e[16] === "" ? null : new f.IfcSectionModulusMeasure((e[16] ?? void 0) === void 0 || e[16] === "" ? null : e[16].value), (e[17] ?? void 0) === void 0 || e[17] === "" ? null : new f.IfcSectionModulusMeasure((e[17] ?? void 0) === void 0 || e[17] === "" ? null : e[17].value), (e[18] ?? void 0) === void 0 || e[18] === "" ? null : new f.IfcSectionModulusMeasure((e[18] ?? void 0) === void 0 || e[18] === "" ? null : e[18].value), (e[19] ?? void 0) === void 0 || e[19] === "" ? null : new f.IfcSectionModulusMeasure((e[19] ?? void 0) === void 0 || e[19] === "" ? null : e[19].value), (e[20] ?? void 0) === void 0 || e[20] === "" ? null : new f.IfcSectionModulusMeasure((e[20] ?? void 0) === void 0 || e[20] === "" ? null : e[20].value), (e[21] ?? void 0) === void 0 || e[21] === "" ? null : new f.IfcLengthMeasure((e[21] ?? void 0) === void 0 || e[21] === "" ? null : e[21].value), (e[22] ?? void 0) === void 0 || e[22] === "" ? null : new f.IfcLengthMeasure((e[22] ?? void 0) === void 0 || e[22] === "" ? null : e[22].value)),
  3653947884: (e) => new f.IfcStructuralSteelProfileProperties((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcMassPerLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcAreaMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcMomentOfInertiaMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcMomentOfInertiaMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new f.IfcMomentOfInertiaMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new f.IfcMomentOfInertiaMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new f.IfcWarpingConstantMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new f.IfcLengthMeasure((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), (e[13] ?? void 0) === void 0 || e[13] === "" ? null : new f.IfcLengthMeasure((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value), (e[14] ?? void 0) === void 0 || e[14] === "" ? null : new f.IfcAreaMeasure((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value), (e[15] ?? void 0) === void 0 || e[15] === "" ? null : new f.IfcAreaMeasure((e[15] ?? void 0) === void 0 || e[15] === "" ? null : e[15].value), (e[16] ?? void 0) === void 0 || e[16] === "" ? null : new f.IfcSectionModulusMeasure((e[16] ?? void 0) === void 0 || e[16] === "" ? null : e[16].value), (e[17] ?? void 0) === void 0 || e[17] === "" ? null : new f.IfcSectionModulusMeasure((e[17] ?? void 0) === void 0 || e[17] === "" ? null : e[17].value), (e[18] ?? void 0) === void 0 || e[18] === "" ? null : new f.IfcSectionModulusMeasure((e[18] ?? void 0) === void 0 || e[18] === "" ? null : e[18].value), (e[19] ?? void 0) === void 0 || e[19] === "" ? null : new f.IfcSectionModulusMeasure((e[19] ?? void 0) === void 0 || e[19] === "" ? null : e[19].value), (e[20] ?? void 0) === void 0 || e[20] === "" ? null : new f.IfcSectionModulusMeasure((e[20] ?? void 0) === void 0 || e[20] === "" ? null : e[20].value), (e[21] ?? void 0) === void 0 || e[21] === "" ? null : new f.IfcLengthMeasure((e[21] ?? void 0) === void 0 || e[21] === "" ? null : e[21].value), (e[22] ?? void 0) === void 0 || e[22] === "" ? null : new f.IfcLengthMeasure((e[22] ?? void 0) === void 0 || e[22] === "" ? null : e[22].value), (e[23] ?? void 0) === void 0 || e[23] === "" ? null : new f.IfcAreaMeasure((e[23] ?? void 0) === void 0 || e[23] === "" ? null : e[23].value), (e[24] ?? void 0) === void 0 || e[24] === "" ? null : new f.IfcAreaMeasure((e[24] ?? void 0) === void 0 || e[24] === "" ? null : e[24].value), (e[25] ?? void 0) === void 0 || e[25] === "" ? null : new f.IfcPositiveRatioMeasure((e[25] ?? void 0) === void 0 || e[25] === "" ? null : e[25].value), (e[26] ?? void 0) === void 0 || e[26] === "" ? null : new f.IfcPositiveRatioMeasure((e[26] ?? void 0) === void 0 || e[26] === "" ? null : e[26].value)),
  2233826070: (e) => new f.IfcSubedge(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2])),
  2513912981: (e) => new f.IfcSurface(),
  1878645084: (e) => new f.IfcSurfaceStyleRendering(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcNormalisedRatioMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : Li(1, e[7]), e[8]),
  2247615214: (e) => new f.IfcSweptAreaSolid(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1])),
  1260650574: (e) => new f.IfcSweptDiskSolid(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new f.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcPositiveLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new f.IfcParameterValue((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new f.IfcParameterValue((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  230924584: (e) => new f.IfcSweptSurface(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1])),
  3071757647: (e) => new f.IfcTShapeProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new f.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new f.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new f.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new f.IfcPositiveLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcPositiveLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcPositiveLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new f.IfcPositiveLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new f.IfcPlaneAngleMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new f.IfcPlaneAngleMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new f.IfcPositiveLengthMeasure((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value)),
  3028897424: (e) => {
    var t;
    return new f.IfcTerminatorSymbol((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3]));
  },
  4282788508: (e) => new f.IfcTextLiteral(new f.IfcPresentableText((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), e[2]),
  3124975700: (e) => new f.IfcTextLiteralWithExtent(new f.IfcPresentableText((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), e[2], new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3]), new f.IfcBoxAlignment((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  2715220739: (e) => new f.IfcTrapeziumProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new f.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new f.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new f.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new f.IfcLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  1345879162: (e) => new f.IfcTwoDirectionRepeatFactor(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1])),
  1628702193: (e) => {
    var t;
    return new f.IfcTypeObject(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  2347495698: (e) => {
    var t, i;
    return new f.IfcTypeProduct(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value));
  },
  427810014: (e) => new f.IfcUShapeProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new f.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new f.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new f.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new f.IfcPositiveLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcPositiveLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcPositiveLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new f.IfcPlaneAngleMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new f.IfcPositiveLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value)),
  1417489154: (e) => new f.IfcVector(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new f.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  2759199220: (e) => new f.IfcVertexLoop(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0])),
  336235671: (e) => new f.IfcWindowLiningProperties(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcPositiveLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcPositiveLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcNormalisedRatioMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new f.IfcNormalisedRatioMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new f.IfcNormalisedRatioMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new f.IfcNormalisedRatioMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new u((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value, 1, e[12])),
  512836454: (e) => new f.IfcWindowPanelProperties(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), e[4], e[5], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcPositiveLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcPositiveLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 1, e[8])),
  1299126871: (e) => {
    var t, i;
    return new f.IfcWindowStyle(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], e[9], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, (e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value);
  },
  2543172580: (e) => new f.IfcZShapeProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new f.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new f.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new f.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new f.IfcPositiveLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcPositiveLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcPositiveLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  3288037868: (e) => {
    var t;
    return new f.IfcAnnotationCurveOccurrence((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value));
  },
  669184980: (e) => {
    var t;
    return new f.IfcAnnotationFillArea(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  2265737646: (e) => {
    var t;
    return new f.IfcAnnotationFillAreaOccurrence((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3]), e[4]);
  },
  1302238472: (e) => new f.IfcAnnotationSurface(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1])),
  4261334040: (e) => new f.IfcAxis1Placement(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1])),
  3125803723: (e) => new f.IfcAxis2Placement2D(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1])),
  2740243338: (e) => new f.IfcAxis2Placement3D(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2])),
  2736907675: (e) => new f.IfcBooleanResult(e[0], new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2])),
  4182860854: (e) => new f.IfcBoundedSurface(),
  2581212453: (e) => new f.IfcBoundingBox(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new f.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new f.IfcPositiveLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new f.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2713105998: (e) => new f.IfcBoxedHalfSpace(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2])),
  2898889636: (e) => new f.IfcCShapeProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new f.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new f.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new f.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new f.IfcPositiveLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcPositiveLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcPositiveLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  1123145078: (e) => {
    var t;
    return new f.IfcCartesianPoint(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new f.IfcLengthMeasure(i.value) : null)) || []);
  },
  59481748: (e) => new f.IfcCartesianTransformationOperator((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new pt((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 4)),
  3749851601: (e) => new f.IfcCartesianTransformationOperator2D((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new pt((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 4)),
  3486308946: (e) => new f.IfcCartesianTransformationOperator2DnonUniform((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new pt((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 4), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new pt((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 4)),
  3331915920: (e) => new f.IfcCartesianTransformationOperator3D((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new pt((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 4), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4])),
  1416205885: (e) => new f.IfcCartesianTransformationOperator3DnonUniform((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new pt((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 4), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new pt((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 4), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new pt((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 4)),
  1383045692: (e) => new f.IfcCircleProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new f.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2205249479: (e) => {
    var t;
    return new f.IfcClosedShell(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  2485617015: (e) => new f.IfcCompositeCurveSegment(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2])),
  4133800736: (e) => new f.IfcCraneRailAShapeProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new f.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new f.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new f.IfcPositiveLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), new f.IfcPositiveLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), new f.IfcPositiveLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), new f.IfcPositiveLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), new f.IfcPositiveLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), new f.IfcPositiveLengthMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), new f.IfcPositiveLengthMeasure((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), new f.IfcPositiveLengthMeasure((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value), (e[14] ?? void 0) === void 0 || e[14] === "" ? null : new f.IfcPositiveLengthMeasure((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value)),
  194851669: (e) => new f.IfcCraneRailFShapeProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new f.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new f.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new f.IfcPositiveLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), new f.IfcPositiveLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), new f.IfcPositiveLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), new f.IfcPositiveLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), new f.IfcPositiveLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new f.IfcPositiveLengthMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value)),
  2506170314: (e) => new f.IfcCsgPrimitive3D(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0])),
  2147822146: (e) => new f.IfcCsgSolid(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0])),
  2601014836: (e) => new f.IfcCurve(),
  2827736869: (e) => {
    var t;
    return new f.IfcCurveBoundedPlane(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  693772133: (e) => new f.IfcDefinedSymbol(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1])),
  606661476: (e) => {
    var t;
    return new f.IfcDimensionCurve((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value));
  },
  4054601972: (e) => {
    var t;
    return new f.IfcDimensionCurveTerminator((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3]), e[4]);
  },
  32440307: (e) => {
    var t;
    return new f.IfcDirection(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? Number(i.value) : null)) || []);
  },
  2963535650: (e) => new f.IfcDoorLiningProperties(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcPositiveLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcPositiveLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcPositiveLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new f.IfcLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new f.IfcLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new f.IfcLengthMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new f.IfcPositiveLengthMeasure((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), (e[13] ?? void 0) === void 0 || e[13] === "" ? null : new f.IfcPositiveLengthMeasure((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value), (e[14] ?? void 0) === void 0 || e[14] === "" ? null : new u((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value, 1, e[14])),
  1714330368: (e) => new f.IfcDoorPanelProperties(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), e[5], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcNormalisedRatioMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), e[7], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 1, e[8])),
  526551008: (e) => {
    var t, i;
    return new f.IfcDoorStyle(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], e[9], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, (e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value);
  },
  3073041342: (e) => {
    var t;
    return new f.IfcDraughtingCallout(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  445594917: (e) => new f.IfcDraughtingPreDefinedColour(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  4006246654: (e) => new f.IfcDraughtingPreDefinedCurveFont(new f.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  1472233963: (e) => {
    var t;
    return new f.IfcEdgeLoop(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  1883228015: (e) => {
    var t;
    return new f.IfcElementQuantity(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  339256511: (e) => {
    var t, i;
    return new f.IfcElementType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  2777663545: (e) => new f.IfcElementarySurface(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0])),
  2835456948: (e) => new f.IfcEllipseProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new f.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new f.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  80994333: (e) => new f.IfcEnergyProperties(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), e[4], (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value)),
  477187591: (e) => new f.IfcExtrudedAreaSolid(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new f.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2047409740: (e) => {
    var t;
    return new f.IfcFaceBasedSurfaceModel(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  374418227: (e) => new f.IfcFillAreaStyleHatching(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3]), new f.IfcPlaneAngleMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  4203026998: (e) => new f.IfcFillAreaStyleTileSymbolWithStyle(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0])),
  315944413: (e) => {
    var t;
    return new f.IfcFillAreaStyleTiles(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], new f.IfcPositiveRatioMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value));
  },
  3455213021: (e) => new f.IfcFluidFlowProperties(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), e[4], (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 1, e[7]), new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 1, e[8]), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 1, e[9]), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new f.IfcLabel((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new f.IfcThermodynamicTemperatureMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new f.IfcThermodynamicTemperatureMeasure((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), (e[13] ?? void 0) === void 0 || e[13] === "" ? null : new u((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value, 1, e[13]), (e[14] ?? void 0) === void 0 || e[14] === "" ? null : new u((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value, 1, e[14]), (e[15] ?? void 0) === void 0 || e[15] === "" ? null : Li(1, e[15]), (e[16] ?? void 0) === void 0 || e[16] === "" ? null : new f.IfcPositiveRatioMeasure((e[16] ?? void 0) === void 0 || e[16] === "" ? null : e[16].value), (e[17] ?? void 0) === void 0 || e[17] === "" ? null : new f.IfcLinearVelocityMeasure((e[17] ?? void 0) === void 0 || e[17] === "" ? null : e[17].value), (e[18] ?? void 0) === void 0 || e[18] === "" ? null : new f.IfcPressureMeasure((e[18] ?? void 0) === void 0 || e[18] === "" ? null : e[18].value)),
  4238390223: (e) => {
    var t, i;
    return new f.IfcFurnishingElementType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  1268542332: (e) => {
    var t, i;
    return new f.IfcFurnitureType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  987898635: (e) => {
    var t;
    return new f.IfcGeometricCurveSet(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  1484403080: (e) => new f.IfcIShapeProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new f.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new f.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new f.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new f.IfcPositiveLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcPositiveLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  572779678: (e) => new f.IfcLShapeProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new f.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new f.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcPositiveLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcPositiveLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcPlaneAngleMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new f.IfcPositiveLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new f.IfcPositiveLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value)),
  1281925730: (e) => new f.IfcLine(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1])),
  1425443689: (e) => new f.IfcManifoldSolidBrep(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0])),
  3888040117: (e) => new f.IfcObject(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  3388369263: (e) => new f.IfcOffsetCurve2D(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new f.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value),
  3505215534: (e) => new f.IfcOffsetCurve3D(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new f.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 1, e[3])),
  3566463478: (e) => new f.IfcPermeableCoveringProperties(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), e[4], e[5], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcPositiveLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcPositiveLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 1, e[8])),
  603570806: (e) => new f.IfcPlanarBox(new f.IfcLengthMeasure((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new f.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2])),
  220341763: (e) => new f.IfcPlane(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0])),
  2945172077: (e) => new f.IfcProcess(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  4208778838: (e) => new f.IfcProduct(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6])),
  103090709: (e) => {
    var t;
    return new f.IfcProject(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), ((t = e[7]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 1, e[8]));
  },
  4194566429: (e) => {
    var t;
    return new f.IfcProjectionCurve((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value));
  },
  1451395588: (e) => {
    var t;
    return new f.IfcPropertySet(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  3219374653: (e) => new f.IfcProxy(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), e[7], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  2770003689: (e) => new f.IfcRectangleHollowProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new f.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new f.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new f.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcPositiveLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcPositiveLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  2798486643: (e) => new f.IfcRectangularPyramid(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new f.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new f.IfcPositiveLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new f.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  3454111270: (e) => new f.IfcRectangularTrimmedSurface(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new f.IfcParameterValue((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new f.IfcParameterValue((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new f.IfcParameterValue((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new f.IfcParameterValue((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, (e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value),
  3939117080: (e) => {
    var t;
    return new f.IfcRelAssigns(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], e[5]);
  },
  1683148259: (e) => {
    var t;
    return new f.IfcRelAssignsToActor(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], e[5], new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 1, e[7]));
  },
  2495723537: (e) => {
    var t;
    return new f.IfcRelAssignsToControl(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], e[5], new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]));
  },
  1307041759: (e) => {
    var t;
    return new f.IfcRelAssignsToGroup(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], e[5], new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]));
  },
  4278684876: (e) => {
    var t;
    return new f.IfcRelAssignsToProcess(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], e[5], new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 1, e[7]));
  },
  2857406711: (e) => {
    var t;
    return new f.IfcRelAssignsToProduct(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], e[5], new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]));
  },
  3372526763: (e) => {
    var t;
    return new f.IfcRelAssignsToProjectOrder(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], e[5], new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]));
  },
  205026976: (e) => {
    var t;
    return new f.IfcRelAssignsToResource(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], e[5], new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]));
  },
  1865459582: (e) => {
    var t;
    return new f.IfcRelAssociates(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  1327628568: (e) => {
    var t;
    return new f.IfcRelAssociatesAppliedValue(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]));
  },
  4095574036: (e) => {
    var t;
    return new f.IfcRelAssociatesApproval(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]));
  },
  919958153: (e) => {
    var t;
    return new f.IfcRelAssociatesClassification(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]));
  },
  2728634034: (e) => {
    var t;
    return new f.IfcRelAssociatesConstraint(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], new f.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]));
  },
  982818633: (e) => {
    var t;
    return new f.IfcRelAssociatesDocument(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]));
  },
  3840914261: (e) => {
    var t;
    return new f.IfcRelAssociatesLibrary(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]));
  },
  2655215786: (e) => {
    var t;
    return new f.IfcRelAssociatesMaterial(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]));
  },
  2851387026: (e) => {
    var t;
    return new f.IfcRelAssociatesProfileProperties(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 1, e[7]));
  },
  826625072: (e) => new f.IfcRelConnects(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  1204542856: (e) => new f.IfcRelConnectsElements(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6])),
  3945020480: (e) => {
    var t, i;
    return new f.IfcRelConnectsPathElements(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((t = e[7]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? Number(n.value) : null)) || [], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : ((i = e[8]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? Number(n.value) : null)) || [], e[9], e[10]);
  },
  4201705270: (e) => new f.IfcRelConnectsPortToElement(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5])),
  3190031847: (e) => new f.IfcRelConnectsPorts(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6])),
  2127690289: (e) => new f.IfcRelConnectsStructuralActivity(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5])),
  3912681535: (e) => new f.IfcRelConnectsStructuralElement(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5])),
  1638771189: (e) => new f.IfcRelConnectsStructuralMember(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 1, e[7]), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 1, e[9])),
  504942748: (e) => new f.IfcRelConnectsWithEccentricity(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 1, e[7]), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 1, e[9]), new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 1, e[10])),
  3678494232: (e) => {
    var t;
    return new f.IfcRelConnectsWithRealizingElements(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), ((t = e[7]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  3242617779: (e) => {
    var t;
    return new f.IfcRelContainedInSpatialStructure(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]));
  },
  886880790: (e) => {
    var t;
    return new f.IfcRelCoversBldgElements(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  2802773753: (e) => {
    var t;
    return new f.IfcRelCoversSpaces(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  2551354335: (e) => {
    var t;
    return new f.IfcRelDecomposes(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  693640335: (e) => {
    var t;
    return new f.IfcRelDefines(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  4186316022: (e) => {
    var t;
    return new f.IfcRelDefinesByProperties(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]));
  },
  781010003: (e) => {
    var t;
    return new f.IfcRelDefinesByType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]));
  },
  3940055652: (e) => new f.IfcRelFillsElement(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5])),
  279856033: (e) => {
    var t;
    return new f.IfcRelFlowControlElements(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]));
  },
  4189434867: (e) => new f.IfcRelInteractionRequirements(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcCountMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcNormalisedRatioMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 1, e[7]), new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 1, e[8])),
  3268803585: (e) => {
    var t;
    return new f.IfcRelNests(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  2051452291: (e) => {
    var t;
    return new f.IfcRelOccupiesSpaces(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], e[5], new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 1, e[7]));
  },
  202636808: (e) => {
    var t, i;
    return new f.IfcRelOverridesProperties(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || []);
  },
  750771296: (e) => new f.IfcRelProjectsElement(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5])),
  1245217292: (e) => {
    var t;
    return new f.IfcRelReferencedInSpatialStructure(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]));
  },
  1058617721: (e) => {
    var t;
    return new f.IfcRelSchedulesCostItems(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], e[5], new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]));
  },
  4122056220: (e) => new f.IfcRelSequence(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), new f.IfcTimeMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), e[7]),
  366585022: (e) => {
    var t;
    return new f.IfcRelServicesBuildings(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  3451746338: (e) => new f.IfcRelSpaceBoundary(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), e[7], e[8]),
  1401173127: (e) => new f.IfcRelVoidsElement(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5])),
  2914609552: (e) => new f.IfcResource(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  1856042241: (e) => new f.IfcRevolvedAreaSolid(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new f.IfcPlaneAngleMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  4158566097: (e) => new f.IfcRightCircularCone(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new f.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new f.IfcPositiveLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  3626867408: (e) => new f.IfcRightCircularCylinder(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new f.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new f.IfcPositiveLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  2706606064: (e) => new f.IfcSpatialStructureElement(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3893378262: (e) => {
    var t, i;
    return new f.IfcSpatialStructureElementType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  451544542: (e) => new f.IfcSphere(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new f.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  3544373492: (e) => new f.IfcStructuralActivity(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 1, e[7]), e[8]),
  3136571912: (e) => new f.IfcStructuralItem(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6])),
  530289379: (e) => new f.IfcStructuralMember(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6])),
  3689010777: (e) => new f.IfcStructuralReaction(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 1, e[7]), e[8]),
  3979015343: (e) => new f.IfcStructuralSurfaceMember(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), e[7], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcPositiveLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  2218152070: (e) => {
    var t;
    return new f.IfcStructuralSurfaceMemberVarying(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), e[7], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcPositiveLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), ((t = e[9]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new f.IfcPositiveLengthMeasure(i.value) : null)) || [], new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 1, e[10]));
  },
  4070609034: (e) => {
    var t;
    return new f.IfcStructuredDimensionCallout(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  2028607225: (e) => new f.IfcSurfaceCurveSweptAreaSolid(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new f.IfcParameterValue((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new f.IfcParameterValue((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5])),
  2809605785: (e) => new f.IfcSurfaceOfLinearExtrusion(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new f.IfcLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  4124788165: (e) => new f.IfcSurfaceOfRevolution(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2])),
  1580310250: (e) => {
    var t, i;
    return new f.IfcSystemFurnitureElementType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  3473067441: (e) => new f.IfcTask(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new f.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new pt((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 10)),
  2097647324: (e) => {
    var t, i;
    return new f.IfcTransportElementType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2296667514: (e) => new f.IfcActor(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5])),
  1674181508: (e) => new f.IfcAnnotation(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6])),
  3207858831: (e) => new f.IfcAsymmetricIShapeProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new f.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new f.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new f.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new f.IfcPositiveLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcPositiveLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), new f.IfcPositiveLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new f.IfcPositiveLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new f.IfcPositiveLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new f.IfcPositiveLengthMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value)),
  1334484129: (e) => new f.IfcBlock(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new f.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new f.IfcPositiveLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new f.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  3649129432: (e) => new f.IfcBooleanClippingResult(e[0], new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2])),
  1260505505: (e) => new f.IfcBoundedCurve(),
  4031249490: (e) => new f.IfcBuilding(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new f.IfcLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new f.IfcLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new u((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value, 1, e[11])),
  1950629157: (e) => {
    var t, i;
    return new f.IfcBuildingElementType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  3124254112: (e) => new f.IfcBuildingStorey(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new f.IfcLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value)),
  2937912522: (e) => new f.IfcCircleHollowProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new f.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 1, e[2]), new f.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new f.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  300633059: (e) => {
    var t, i;
    return new f.IfcColumnType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3732776249: (e) => {
    var t;
    return new f.IfcCompositeCurve(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value);
  },
  2510884976: (e) => new f.IfcConic(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0])),
  2559216714: (e) => new f.IfcConstructionResource(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), e[7], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 1, e[8])),
  3293443760: (e) => new f.IfcControl(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  3895139033: (e) => new f.IfcCostItem(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  1419761937: (e) => {
    var t;
    return new f.IfcCostSchedule(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 1, e[7]), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : ((t = e[9]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 1, e[10]), new f.IfcIdentifier((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), e[12]);
  },
  1916426348: (e) => {
    var t, i;
    return new f.IfcCoveringType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3295246426: (e) => new f.IfcCrewResource(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), e[7], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 1, e[8])),
  1457835157: (e) => {
    var t, i;
    return new f.IfcCurtainWallType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  681481545: (e) => {
    var t;
    return new f.IfcDimensionCurveDirectedCallout(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  3256556792: (e) => {
    var t, i;
    return new f.IfcDistributionElementType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  3849074793: (e) => {
    var t, i;
    return new f.IfcDistributionFlowElementType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  360485395: (e) => new f.IfcElectricalBaseProperties(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), e[4], (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), e[6], new f.IfcElectricVoltageMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), new f.IfcFrequencyMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new f.IfcElectricCurrentMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new f.IfcElectricCurrentMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new f.IfcPowerMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new f.IfcPowerMeasure((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), new pt((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value, 10)),
  1758889154: (e) => new f.IfcElement(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  4123344466: (e) => new f.IfcElementAssembly(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], e[9]),
  1623761950: (e) => new f.IfcElementComponent(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  2590856083: (e) => {
    var t, i;
    return new f.IfcElementComponentType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  1704287377: (e) => new f.IfcEllipse(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new f.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new f.IfcPositiveLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  2107101300: (e) => {
    var t, i;
    return new f.IfcEnergyConversionDeviceType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  1962604670: (e) => new f.IfcEquipmentElement(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  3272907226: (e) => new f.IfcEquipmentStandard(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  3174744832: (e) => {
    var t, i;
    return new f.IfcEvaporativeCoolerType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3390157468: (e) => {
    var t, i;
    return new f.IfcEvaporatorType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  807026263: (e) => new f.IfcFacetedBrep(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0])),
  3737207727: (e) => {
    var t;
    return new f.IfcFacetedBrepWithVoids(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  647756555: (e) => new f.IfcFastener(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  2489546625: (e) => {
    var t, i;
    return new f.IfcFastenerType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  2827207264: (e) => new f.IfcFeatureElement(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  2143335405: (e) => new f.IfcFeatureElementAddition(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  1287392070: (e) => new f.IfcFeatureElementSubtraction(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  3907093117: (e) => {
    var t, i;
    return new f.IfcFlowControllerType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  3198132628: (e) => {
    var t, i;
    return new f.IfcFlowFittingType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  3815607619: (e) => {
    var t, i;
    return new f.IfcFlowMeterType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1482959167: (e) => {
    var t, i;
    return new f.IfcFlowMovingDeviceType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  1834744321: (e) => {
    var t, i;
    return new f.IfcFlowSegmentType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  1339347760: (e) => {
    var t, i;
    return new f.IfcFlowStorageDeviceType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  2297155007: (e) => {
    var t, i;
    return new f.IfcFlowTerminalType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  3009222698: (e) => {
    var t, i;
    return new f.IfcFlowTreatmentDeviceType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  263784265: (e) => new f.IfcFurnishingElement(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  814719939: (e) => new f.IfcFurnitureStandard(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  200128114: (e) => {
    var t, i;
    return new f.IfcGasTerminalType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3009204131: (e) => {
    var t, i, n;
    return new f.IfcGrid(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), ((t = e[7]) == null ? void 0 : t.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new u(s.value, 1, s) : null)) || [], ((i = e[8]) == null ? void 0 : i.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new u(s.value, 1, s) : null)) || [], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : ((n = e[9]) == null ? void 0 : n.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new u(s.value, 1, s) : null)) || []);
  },
  2706460486: (e) => new f.IfcGroup(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  1251058090: (e) => {
    var t, i;
    return new f.IfcHeatExchangerType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1806887404: (e) => {
    var t, i;
    return new f.IfcHumidifierType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2391368822: (e) => {
    var t;
    return new f.IfcInventory(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), e[5], new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), ((t = e[7]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 1, e[8]), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 1, e[9]), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 1, e[10]));
  },
  4288270099: (e) => {
    var t, i;
    return new f.IfcJunctionBoxType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3827777499: (e) => new f.IfcLaborResource(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), e[7], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 1, e[8]), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new f.IfcText((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value)),
  1051575348: (e) => {
    var t, i;
    return new f.IfcLampType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1161773419: (e) => {
    var t, i;
    return new f.IfcLightFixtureType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2506943328: (e) => {
    var t;
    return new f.IfcLinearDimension(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  377706215: (e) => new f.IfcMechanicalFastener(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcPositiveLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new f.IfcPositiveLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value)),
  2108223431: (e) => {
    var t, i;
    return new f.IfcMechanicalFastenerType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  3181161470: (e) => {
    var t, i;
    return new f.IfcMemberType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  977012517: (e) => {
    var t, i;
    return new f.IfcMotorConnectionType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1916936684: (e) => {
    var t;
    return new f.IfcMove(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new f.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new pt((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 10), new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 1, e[10]), new u((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value, 1, e[11]), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : ((t = e[12]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new f.IfcText(i.value) : null)) || []);
  },
  4143007308: (e) => new f.IfcOccupant(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), e[6]),
  3588315303: (e) => new f.IfcOpeningElement(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  3425660407: (e) => new f.IfcOrderAction(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new f.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new pt((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 10), new f.IfcIdentifier((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value)),
  2837617999: (e) => {
    var t, i;
    return new f.IfcOutletType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2382730787: (e) => new f.IfcPerformanceHistory(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new f.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value)),
  3327091369: (e) => new f.IfcPermit(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new f.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value)),
  804291784: (e) => {
    var t, i;
    return new f.IfcPipeFittingType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  4231323485: (e) => {
    var t, i;
    return new f.IfcPipeSegmentType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  4017108033: (e) => {
    var t, i;
    return new f.IfcPlateType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3724593414: (e) => {
    var t;
    return new f.IfcPolyline(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  3740093272: (e) => new f.IfcPort(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6])),
  2744685151: (e) => new f.IfcProcedure(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new f.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), e[6], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  2904328755: (e) => new f.IfcProjectOrder(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new f.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), e[6], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  3642467123: (e) => {
    var t;
    return new f.IfcProjectOrderRecord(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], e[6]);
  },
  3651124850: (e) => new f.IfcProjectionElement(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  1842657554: (e) => {
    var t, i;
    return new f.IfcProtectiveDeviceType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2250791053: (e) => {
    var t, i;
    return new f.IfcPumpType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3248260540: (e) => {
    var t;
    return new f.IfcRadiusDimension(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  2893384427: (e) => {
    var t, i;
    return new f.IfcRailingType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2324767716: (e) => {
    var t, i;
    return new f.IfcRampFlightType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  160246688: (e) => {
    var t;
    return new f.IfcRelAggregates(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 1, e[4]), ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  2863920197: (e) => {
    var t;
    return new f.IfcRelAssignsTasks(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], e[5], new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 1, e[7]));
  },
  1768891740: (e) => {
    var t, i;
    return new f.IfcSanitaryTerminalType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3517283431: (e) => new f.IfcScheduleTimeControl(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 1, e[7]), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 1, e[8]), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 1, e[9]), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 1, e[10]), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new u((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value, 1, e[11]), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new u((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value, 1, e[12]), (e[13] ?? void 0) === void 0 || e[13] === "" ? null : new f.IfcTimeMeasure((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value), (e[14] ?? void 0) === void 0 || e[14] === "" ? null : new f.IfcTimeMeasure((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value), (e[15] ?? void 0) === void 0 || e[15] === "" ? null : new f.IfcTimeMeasure((e[15] ?? void 0) === void 0 || e[15] === "" ? null : e[15].value), (e[16] ?? void 0) === void 0 || e[16] === "" ? null : new f.IfcTimeMeasure((e[16] ?? void 0) === void 0 || e[16] === "" ? null : e[16].value), (e[17] ?? void 0) === void 0 || e[17] === "" ? null : new f.IfcTimeMeasure((e[17] ?? void 0) === void 0 || e[17] === "" ? null : e[17].value), (e[18] ?? void 0) === void 0 || e[18] === "" || (e[18] ?? void 0) === void 0 || e[18] === "" ? null : e[18].value, (e[19] ?? void 0) === void 0 || e[19] === "" ? null : new u((e[19] ?? void 0) === void 0 || e[19] === "" ? null : e[19].value, 1, e[19]), (e[20] ?? void 0) === void 0 || e[20] === "" ? null : new f.IfcTimeMeasure((e[20] ?? void 0) === void 0 || e[20] === "" ? null : e[20].value), (e[21] ?? void 0) === void 0 || e[21] === "" ? null : new f.IfcTimeMeasure((e[21] ?? void 0) === void 0 || e[21] === "" ? null : e[21].value), (e[22] ?? void 0) === void 0 || e[22] === "" ? null : new f.IfcPositiveRatioMeasure((e[22] ?? void 0) === void 0 || e[22] === "" ? null : e[22].value)),
  4105383287: (e) => new f.IfcServiceLife(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), e[5], new f.IfcTimeMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  4097777520: (e) => new f.IfcSite(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new f.IfcCompoundPlaneAngleMeasure(e[9].map((t) => t.value)), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new f.IfcCompoundPlaneAngleMeasure(e[10].map((t) => t.value)), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new f.IfcLengthMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new f.IfcLabel((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), (e[13] ?? void 0) === void 0 || e[13] === "" ? null : new u((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value, 1, e[13])),
  2533589738: (e) => {
    var t, i;
    return new f.IfcSlabType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3856911033: (e) => new f.IfcSpace(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], e[9], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new f.IfcLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value)),
  1305183839: (e) => {
    var t, i;
    return new f.IfcSpaceHeaterType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  652456506: (e) => new f.IfcSpaceProgram(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new f.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcAreaMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcAreaMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 1, e[8]), new f.IfcAreaMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value)),
  3812236995: (e) => {
    var t, i;
    return new f.IfcSpaceType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3112655638: (e) => {
    var t, i;
    return new f.IfcStackTerminalType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1039846685: (e) => {
    var t, i;
    return new f.IfcStairFlightType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  682877961: (e) => new f.IfcStructuralAction(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 1, e[7]), e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 1, e[10])),
  1179482911: (e) => new f.IfcStructuralConnection(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 1, e[7])),
  4243806635: (e) => new f.IfcStructuralCurveConnection(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 1, e[7])),
  214636428: (e) => new f.IfcStructuralCurveMember(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), e[7]),
  2445595289: (e) => new f.IfcStructuralCurveMemberVarying(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), e[7]),
  1807405624: (e) => new f.IfcStructuralLinearAction(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 1, e[7]), e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 1, e[10]), e[11]),
  1721250024: (e) => {
    var t;
    return new f.IfcStructuralLinearActionVarying(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 1, e[7]), e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 1, e[10]), e[11], new u((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value, 1, e[12]), ((t = e[13]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  1252848954: (e) => new f.IfcStructuralLoadGroup(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), e[5], e[6], e[7], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcRatioMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new f.IfcLabel((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value)),
  1621171031: (e) => new f.IfcStructuralPlanarAction(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 1, e[7]), e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 1, e[10]), e[11]),
  3987759626: (e) => {
    var t;
    return new f.IfcStructuralPlanarActionVarying(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 1, e[7]), e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 1, e[10]), e[11], new u((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value, 1, e[12]), ((t = e[13]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  2082059205: (e) => new f.IfcStructuralPointAction(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 1, e[7]), e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 1, e[10])),
  734778138: (e) => new f.IfcStructuralPointConnection(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 1, e[7])),
  1235345126: (e) => new f.IfcStructuralPointReaction(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 1, e[7]), e[8]),
  2986769608: (e) => new f.IfcStructuralResultGroup(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), e[5], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value),
  1975003073: (e) => new f.IfcStructuralSurfaceConnection(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 1, e[7])),
  148013059: (e) => new f.IfcSubContractResource(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), e[7], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 1, e[8]), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 1, e[9]), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new f.IfcText((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value)),
  2315554128: (e) => {
    var t, i;
    return new f.IfcSwitchingDeviceType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2254336722: (e) => new f.IfcSystem(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  5716631: (e) => {
    var t, i;
    return new f.IfcTankType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1637806684: (e) => {
    var t;
    return new f.IfcTimeSeriesSchedule(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], e[6], new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 1, e[7]));
  },
  1692211062: (e) => {
    var t, i;
    return new f.IfcTransformerType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1620046519: (e) => new f.IfcTransportElement(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new f.IfcMassMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new f.IfcCountMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value)),
  3593883385: (e) => {
    var t, i;
    return new f.IfcTrimmedCurve(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), ((t = e[1]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], ((i = e[2]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, e[4]);
  },
  1600972822: (e) => {
    var t, i;
    return new f.IfcTubeBundleType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1911125066: (e) => {
    var t, i;
    return new f.IfcUnitaryEquipmentType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  728799441: (e) => {
    var t, i;
    return new f.IfcValveType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2769231204: (e) => new f.IfcVirtualElement(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  1898987631: (e) => {
    var t, i;
    return new f.IfcWallType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1133259667: (e) => {
    var t, i;
    return new f.IfcWasteTerminalType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1028945134: (e) => {
    var t;
    return new f.IfcWorkControl(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new f.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((t = e[7]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new f.IfcTimeMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new f.IfcTimeMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), new u((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value, 1, e[11]), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new u((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value, 1, e[12]), e[13], (e[14] ?? void 0) === void 0 || e[14] === "" ? null : new f.IfcLabel((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value));
  },
  4218914973: (e) => {
    var t;
    return new f.IfcWorkPlan(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new f.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((t = e[7]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new f.IfcTimeMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new f.IfcTimeMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), new u((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value, 1, e[11]), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new u((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value, 1, e[12]), e[13], (e[14] ?? void 0) === void 0 || e[14] === "" ? null : new f.IfcLabel((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value));
  },
  3342526732: (e) => {
    var t;
    return new f.IfcWorkSchedule(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new f.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((t = e[7]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new f.IfcTimeMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new f.IfcTimeMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), new u((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value, 1, e[11]), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new u((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value, 1, e[12]), e[13], (e[14] ?? void 0) === void 0 || e[14] === "" ? null : new f.IfcLabel((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value));
  },
  1033361043: (e) => new f.IfcZone(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  1213861670: (e) => {
    var t;
    return new f.Ifc2DCompositeCurve(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value);
  },
  3821786052: (e) => new f.IfcActionRequest(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new f.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value)),
  1411407467: (e) => {
    var t, i;
    return new f.IfcAirTerminalBoxType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3352864051: (e) => {
    var t, i;
    return new f.IfcAirTerminalType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1871374353: (e) => {
    var t, i;
    return new f.IfcAirToAirHeatRecoveryType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2470393545: (e) => {
    var t;
    return new f.IfcAngularDimension(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  3460190687: (e) => new f.IfcAsset(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new f.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 1, e[7]), new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 1, e[8]), new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 1, e[9]), new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 1, e[10]), new u((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value, 1, e[11]), new u((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value, 1, e[12]), new u((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value, 1, e[13])),
  1967976161: (e) => {
    var t;
    return new f.IfcBSplineCurve(new pt((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 10), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], e[2], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, (e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value);
  },
  819618141: (e) => {
    var t, i;
    return new f.IfcBeamType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1916977116: (e) => {
    var t;
    return new f.IfcBezierCurve(new pt((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 10), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], e[2], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, (e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value);
  },
  231477066: (e) => {
    var t, i;
    return new f.IfcBoilerType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3299480353: (e) => new f.IfcBuildingElement(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  52481810: (e) => new f.IfcBuildingElementComponent(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  2979338954: (e) => new f.IfcBuildingElementPart(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  1095909175: (e) => new f.IfcBuildingElementProxy(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1909888760: (e) => {
    var t, i;
    return new f.IfcBuildingElementProxyType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  395041908: (e) => {
    var t, i;
    return new f.IfcCableCarrierFittingType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3293546465: (e) => {
    var t, i;
    return new f.IfcCableCarrierSegmentType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1285652485: (e) => {
    var t, i;
    return new f.IfcCableSegmentType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2951183804: (e) => {
    var t, i;
    return new f.IfcChillerType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2611217952: (e) => new f.IfcCircle(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 1, e[0]), new f.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  2301859152: (e) => {
    var t, i;
    return new f.IfcCoilType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  843113511: (e) => new f.IfcColumn(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  3850581409: (e) => {
    var t, i;
    return new f.IfcCompressorType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2816379211: (e) => {
    var t, i;
    return new f.IfcCondenserType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2188551683: (e) => new f.IfcCondition(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  1163958913: (e) => new f.IfcConditionCriterion(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6])),
  3898045240: (e) => new f.IfcConstructionEquipmentResource(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), e[7], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 1, e[8])),
  1060000209: (e) => {
    var t;
    return new f.IfcConstructionMaterialResource(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), e[7], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 1, e[8]), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : ((t = e[9]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || [], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new f.IfcRatioMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value));
  },
  488727124: (e) => new f.IfcConstructionProductResource(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new f.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new f.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), e[7], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 1, e[8])),
  335055490: (e) => {
    var t, i;
    return new f.IfcCooledBeamType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2954562838: (e) => {
    var t, i;
    return new f.IfcCoolingTowerType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1973544240: (e) => new f.IfcCovering(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3495092785: (e) => new f.IfcCurtainWall(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  3961806047: (e) => {
    var t, i;
    return new f.IfcDamperType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  4147604152: (e) => {
    var t;
    return new f.IfcDiameterDimension(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 1, i) : null)) || []);
  },
  1335981549: (e) => new f.IfcDiscreteAccessory(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  2635815018: (e) => {
    var t, i;
    return new f.IfcDiscreteAccessoryType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  1599208980: (e) => {
    var t, i;
    return new f.IfcDistributionChamberElementType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2063403501: (e) => {
    var t, i;
    return new f.IfcDistributionControlElementType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  1945004755: (e) => new f.IfcDistributionElement(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  3040386961: (e) => new f.IfcDistributionFlowElement(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  3041715199: (e) => new f.IfcDistributionPort(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), e[7]),
  395920057: (e) => new f.IfcDoor(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcPositiveLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new f.IfcPositiveLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value)),
  869906466: (e) => {
    var t, i;
    return new f.IfcDuctFittingType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3760055223: (e) => {
    var t, i;
    return new f.IfcDuctSegmentType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2030761528: (e) => {
    var t, i;
    return new f.IfcDuctSilencerType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  855621170: (e) => new f.IfcEdgeFeature(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcPositiveLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  663422040: (e) => {
    var t, i;
    return new f.IfcElectricApplianceType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3277789161: (e) => {
    var t, i;
    return new f.IfcElectricFlowStorageDeviceType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1534661035: (e) => {
    var t, i;
    return new f.IfcElectricGeneratorType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1365060375: (e) => {
    var t, i;
    return new f.IfcElectricHeaterType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1217240411: (e) => {
    var t, i;
    return new f.IfcElectricMotorType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  712377611: (e) => {
    var t, i;
    return new f.IfcElectricTimeControlType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1634875225: (e) => new f.IfcElectricalCircuit(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  857184966: (e) => new f.IfcElectricalElement(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  1658829314: (e) => new f.IfcEnergyConversionDevice(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  346874300: (e) => {
    var t, i;
    return new f.IfcFanType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1810631287: (e) => {
    var t, i;
    return new f.IfcFilterType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  4222183408: (e) => {
    var t, i;
    return new f.IfcFireSuppressionTerminalType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2058353004: (e) => new f.IfcFlowController(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  4278956645: (e) => new f.IfcFlowFitting(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  4037862832: (e) => {
    var t, i;
    return new f.IfcFlowInstrumentType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3132237377: (e) => new f.IfcFlowMovingDevice(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  987401354: (e) => new f.IfcFlowSegment(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  707683696: (e) => new f.IfcFlowStorageDevice(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  2223149337: (e) => new f.IfcFlowTerminal(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  3508470533: (e) => new f.IfcFlowTreatmentDevice(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  900683007: (e) => new f.IfcFooting(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1073191201: (e) => new f.IfcMember(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  1687234759: (e) => new f.IfcPile(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], e[9]),
  3171933400: (e) => new f.IfcPlate(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  2262370178: (e) => new f.IfcRailing(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3024970846: (e) => new f.IfcRamp(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3283111854: (e) => new f.IfcRampFlight(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  3055160366: (e) => {
    var t, i;
    return new f.IfcRationalBezierCurve(new pt((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 10), ((t = e[1]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], e[2], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, (e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, ((i = e[5]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? Number(n.value) : null)) || []);
  },
  3027567501: (e) => new f.IfcReinforcingElement(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  2320036040: (e) => new f.IfcReinforcingMesh(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new f.IfcPositiveLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new f.IfcPositiveLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), new f.IfcPositiveLengthMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), new f.IfcPositiveLengthMeasure((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), new f.IfcAreaMeasure((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value), new f.IfcAreaMeasure((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value), new f.IfcPositiveLengthMeasure((e[15] ?? void 0) === void 0 || e[15] === "" ? null : e[15].value), new f.IfcPositiveLengthMeasure((e[16] ?? void 0) === void 0 || e[16] === "" ? null : e[16].value)),
  2016517767: (e) => new f.IfcRoof(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1376911519: (e) => new f.IfcRoundedEdgeFeature(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcPositiveLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new f.IfcPositiveLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value)),
  1783015770: (e) => {
    var t, i;
    return new f.IfcSensorType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1529196076: (e) => new f.IfcSlab(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  331165859: (e) => new f.IfcStair(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  4252922144: (e) => new f.IfcStairFlight(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new pt((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 10), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new pt((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 10), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new f.IfcPositiveLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new f.IfcPositiveLengthMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value)),
  2515109513: (e) => {
    var t, i;
    return new f.IfcStructuralAnalysisModel(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), e[5], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((t = e[7]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : ((i = e[8]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || []);
  },
  3824725483: (e) => new f.IfcTendon(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9], new f.IfcPositiveLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), new f.IfcAreaMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new f.IfcForceMeasure((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), (e[13] ?? void 0) === void 0 || e[13] === "" ? null : new f.IfcPressureMeasure((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value), (e[14] ?? void 0) === void 0 || e[14] === "" ? null : new f.IfcNormalisedRatioMeasure((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value), (e[15] ?? void 0) === void 0 || e[15] === "" ? null : new f.IfcPositiveLengthMeasure((e[15] ?? void 0) === void 0 || e[15] === "" ? null : e[15].value), (e[16] ?? void 0) === void 0 || e[16] === "" ? null : new f.IfcPositiveLengthMeasure((e[16] ?? void 0) === void 0 || e[16] === "" ? null : e[16].value)),
  2347447852: (e) => new f.IfcTendonAnchor(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  3313531582: (e) => {
    var t, i;
    return new f.IfcVibrationIsolatorType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2391406946: (e) => new f.IfcWall(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  3512223829: (e) => new f.IfcWallStandardCase(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  3304561284: (e) => new f.IfcWindow(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcPositiveLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new f.IfcPositiveLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value)),
  2874132201: (e) => {
    var t, i;
    return new f.IfcActuatorType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3001207471: (e) => {
    var t, i;
    return new f.IfcAlarmType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  753842376: (e) => new f.IfcBeam(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  2454782716: (e) => new f.IfcChamferEdgeFeature(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcPositiveLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new f.IfcPositiveLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new f.IfcPositiveLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value)),
  578613899: (e) => {
    var t, i;
    return new f.IfcControllerType(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 1, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1052013943: (e) => new f.IfcDistributionChamberElement(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  1062813311: (e) => new f.IfcDistributionControlElement(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcIdentifier((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  3700593921: (e) => new f.IfcElectricDistributionPoint(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new f.IfcLabel((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value)),
  979691226: (e) => new f.IfcReinforcingBar(new f.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 1, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new f.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new f.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new f.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 1, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 1, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new f.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new f.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), new f.IfcPositiveLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), new f.IfcAreaMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new f.IfcPositiveLengthMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), e[12], e[13])
};
wP[1] = {
  618182010: [qae, Xae],
  411424972: [lSe, Iue],
  4037036970: [vH, mue, yue, Eue],
  1387855156: [vH],
  3264961684: [gH],
  2859738748: [Aie, zW, uSe, E8, Lie],
  2614616156: [E8],
  1959218052: [tue, iue],
  3796139169: [zAe, jAe],
  3200245327: [nY, g8, sY, lue, rSe, aue, uue],
  3265635763: [FAe, GAe, kAe, VAe, WAe, YAe, QAe, eSe, lIe, cIe, nSe],
  4256014907: [lIe, cIe],
  1918398963: [Vae, zae, Oie],
  3701648758: [x5, Hae],
  2483315170: [Jr, A8, S8, b8, N8, D8, C8, eue],
  2226359599: [A8, S8, b8, N8, D8, C8],
  3727388367: [UN, PW, qO, MW, aIe, sL, VW, sIe, oIe, dIe, XAe],
  990879717: [sIe, oIe, dIe],
  1775413392: [aIe, sL],
  2022622350: [Jae],
  3119450353: [Tie, vie, Yae, $Ae, Die],
  2095639259: [wie, PH],
  3958567839: [ZP, YO, QP, tH, tIe, iIe, oA, n8, o8, oH, l8, lH, uH, aA, zN, c8, Uae, Rie, Sie, w8, bie, T8, Nie],
  2802850158: [nre, nIe, HAe, KAe],
  2598011224: [Ur, XO, jN, eL, tL, iL, nL, kW],
  1076942058: [R8, Cie, TH, v8, Qae],
  3377609919: [dE, BW],
  3008791417: [hL, JP, J1e, XP, e8, BQ, GQ, WQ, qQ, Zoe, Qoe, X1e, t8, eIe, Pg, Fg, SN, HU, jV, j2, Mg, Ug, WV, c0, rA, tA, iA, dA, i8, bN, DN, CN, ON, _N, iH, $O, jg, pA, Wg, mA, s8, nH, _5, r8, Cz, sH, rH, HN, aH, kg, MN, f4, zg, gA, a4, u4, vA, u8, i3, Bg, uA, fA, GN, Lg, h4, Vg, kN, dH, d8, cH, yA, WN, YN, fH, PN, IH, wA, TA, RA, pH, ire, rIe, m4, $N, KN, ZN, QN, yH, EA, AA, f8, cA, I8, Gae, h8, hA, BN, SA, mH, DA, p8, NA, m8, VN, qN, CA, y8, IA, bA, fL, JN, wH, Wae, ere, QQ, JQ, tre, are, KV, dz, ure, dre, uIe, Qe],
  2341007311: [fe, lz, Fe, Ni, U, B, Ye, ot, at, ns, tr, We, lt, GF, ri, ut, Jp, dt, Xe, Hg, Ko, Hn, Un, Ad, Vt, ct, Gg, Te, KP, bJ, So, oE, rE, lA, lE, T4, NJ, X, Ns, ge, Xr, Vs, lB, rz, uz, bs, az, Xp, ie, xae, Rl, g5, Joe, ZQ, Xoe, p4, w5, T5, R5, v5, sre, ore, rre, lre, b5, hH, Mae, HQ, W2, Ky, ju, zV, $2, AI, K2, i4, vN, FQ, Y2, Zm, Qm, q2, kQ, VQ, zQ, jQ, YQ, Z2, X2, e4, $Q, KQ, s4, o4, AN, t4, NN, qm, $m, Km, Jm, e3, r3, r4, LN, Yg, Ym, J2, gu, VV, H0, dd, hd, fd, Id, pd, md, yd, sC, Ed, gd, eh, Vp, G0, k0, cd, V0, z0, j0, W0, Y0, q0, $0, K0, Z0, i0, Q0, J0, X0, ih, nh, sh, oh, Ra, Hu, Gu, ku, U0, n0, GU, Zv, zp, wI, jp, oC, rC, B_, uc, df, wd, cf, t3, $V, th, r0, lh, s3, Wp, n4, Zp, Zh, Jh, tf, Xm, ac, ef, Ec, Ef, a3, d4, Xh, F_, s0, H_, o0, RI, Qh, l3, c4, rh, a0, u0, l0, Zy, HO, Td, Q2, YV, qV, l4, xN, eH, M0, Yh, B0, hf, n3, ic, nc, sc, oc, rc, Wh, lc, Aa, La, dc, va, lC, Oa, Ya, $a, tu, nu, au, du, cu, aC, cc, Ca, Xa, hc, _a, ka, Va, ru, fc, Sa, Fa, su, Ic, xa, za, lu, hu, pc, ba, Pa, qa, Ka, eu, ou, pu, mc, Na, Da, Ma, Ua, Ba, Ha, Ga, ja, Wa, Za, Qa, Ja, iu, uu, fu, Iu, mu, yu, yc, ff, o3, qh, $h, Kh, nf, of, rf, lf, af, uf, If, pf, mf, Qv, Hp, sf, u3, yf, gf, d3, I4, GO, kO, FN, $s, Bae],
  3982875396: [TH, v8],
  3692461612: [XO, jN, eL, tL, iL, nL],
  2273995522: [_ae, kae],
  2162789131: [A5, KO, S5, ZO, QO, JO, oL, GW],
  2525727697: [A5, KO, S5, ZO, QO, JO, oL],
  2830218821: [R8],
  3958052878: [ere, QQ, JQ, tre, are, KV, dz, ure, dre, uIe],
  846575682: [a8],
  626085974: [UW, EH, FW],
  280115917: [P5, HW],
  3101149627: [Pae, Fae],
  1377556343: [h8, hA, BN, SA, mH, DA, p8, NA, m8, VN, qN, CA, y8, IA, bA, fL, JN, wH],
  2799835756: [JN],
  2442683028: [ere, QQ, JQ, tre, are, KV, dz, ure, dre],
  3612888222: [KV, dz],
  3798115385: [T8],
  1310608509: [w8],
  370225590: [IA, bA],
  3900360178: [VN, qN, CA],
  2556980723: [NA],
  1809719519: [DA],
  1446786286: [nre, nIe],
  3448662350: [dE],
  2453401579: [JP, J1e, XP, e8, BQ, GQ, WQ, qQ, Zoe, Qoe, X1e, t8, eIe, Pg, Fg, SN, HU, jV, j2, Mg, Ug, WV, c0, rA, tA, iA, dA, i8, bN, DN, CN, ON, _N, iH, $O, jg, pA, Wg, mA, s8, nH, _5, r8, Cz, sH, rH, HN, aH, kg, MN, f4, zg, gA, a4, u4, vA, u8, i3, Bg, uA, fA, GN, Lg, h4, Vg, kN, dH, d8, cH, yA, WN, YN, fH, PN, IH, wA, TA, RA, pH, ire, rIe, m4, $N, KN, ZN, QN, yH, EA, AA, f8, cA, I8],
  3590301190: [cA],
  812098782: [EA, AA],
  1402838566: [m4, $N, KN, ZN, QN],
  1520743889: [m4],
  1008929658: [hA, BN, SA],
  219451334: [HQ, W2, Ky, ju, zV, $2, AI, K2, i4, vN, FQ, Y2, Zm, Qm, q2, kQ, VQ, zQ, jQ, YQ, Z2, X2, e4, $Q, KQ, s4, o4, AN, t4, NN, qm, $m, Km, Jm, e3, r3, r4, LN, Yg, Ym, J2, gu, VV, H0, dd, hd, fd, Id, pd, md, yd, sC, Ed, gd, eh, Vp, G0, k0, cd, V0, z0, j0, W0, Y0, q0, $0, K0, Z0, i0, Q0, J0, X0, ih, nh, sh, oh, Ra, Hu, Gu, ku, U0, n0, GU, Zv, zp, wI, jp, oC, rC, B_, uc, df, wd, cf, t3, $V, th, r0, lh, s3, Wp, n4, Zp, Zh, Jh, tf, Xm, ac, ef, Ec, Ef, a3, d4, Xh, F_, s0, H_, o0, RI, Qh, l3, c4, rh, a0, u0, l0, Zy, HO, Td, Q2, YV, qV, l4, xN, eH, M0, Yh, B0, hf, n3, ic, nc, sc, oc, rc, Wh, lc, Aa, La, dc, va, lC, Oa, Ya, $a, tu, nu, au, du, cu, aC, cc, Ca, Xa, hc, _a, ka, Va, ru, fc, Sa, Fa, su, Ic, xa, za, lu, hu, pc, ba, Pa, qa, Ka, eu, ou, pu, mc, Na, Da, Ma, Ua, Ba, Ha, Ga, ja, Wa, Za, Qa, Ja, iu, uu, fu, Iu, mu, yu, yc, ff, o3, qh, $h, Kh, nf, of, rf, lf, af, uf, If, pf, mf, Qv, Hp, sf, u3, yf, gf, d3, I4, GO, kO, FN, $s],
  2833995503: [ire],
  2529465313: [ZP, YO, QP, tH, tIe, iIe, oA, n8, o8, oH, l8, lH, uH, aA, zN, c8],
  2004835150: [wA, TA, RA],
  1663979128: [PN],
  2067069095: [yA, WN, YN],
  759155922: [qO],
  2559016684: [UN],
  1680319473: [Rl, g5, Joe, ZQ, Xoe, p4, w5, T5, R5, v5, sre, ore, rre, lre, b5, hH],
  3357820518: [Rl, g5, Joe, ZQ, Xoe, p4, w5, T5, R5, v5, sre, ore, rre, lre, b5],
  3615266464: [aA, zN],
  478536968: [fe, lz, Fe, Ni, U, B, Ye, ot, at, ns, tr, We, lt, GF, ri, ut, Jp, dt, Xe, Hg, Ko, Hn, Un, Ad, Vt, ct, Gg, Te, KP, bJ, So, oE, rE, lA, lE, T4, NJ, X, Ns, ge, Xr, Vs, lB, rz, uz, bs, az, Xp, ie],
  723233188: [i3, Bg, uA, fA, GN, Lg, h4, Vg, kN],
  2473145415: [S5],
  1597423693: [A5],
  3843319758: [nre],
  2513912981: [kg, MN, f4, zg, gA, a4, u4, vA],
  2247615214: [Lg, h4, Vg],
  230924584: [a4, u4],
  3028897424: [KV],
  4282788508: [HN],
  1628702193: [M0, Yh, B0, hf, n3, ic, nc, sc, oc, rc, Wh, lc, Aa, La, dc, va, lC, Oa, Ya, $a, tu, nu, au, du, cu, aC, cc, Ca, Xa, hc, _a, ka, Va, ru, fc, Sa, Fa, su, Ic, xa, za, lu, hu, pc, ba, Pa, qa, Ka, eu, ou, pu, mc, Na, Da, Ma, Ua, Ba, Ha, Ga, ja, Wa, Za, Qa, Ja, iu, uu, fu, Iu, mu, yu, yc, ff, o3, qh, $h, Kh, nf, of, rf, lf, af, uf, If, pf, mf, Qv, Hp, sf, u3, yf, gf, d3, I4, GO, kO, FN],
  2347495698: [M0, Yh, B0, hf, n3, ic, nc, sc, oc, rc, Wh, lc, Aa, La, dc, va, lC, Oa, Ya, $a, tu, nu, au, du, cu, aC, cc, Ca, Xa, hc, _a, ka, Va, ru, fc, Sa, Fa, su, Ic, xa, za, lu, hu, pc, ba, Pa, qa, Ka, eu, ou, pu, mc, Na, Da, Ma, Ua, Ba, Ha, Ga, ja, Wa, Za, Qa, Ja, iu, uu, fu, Iu, mu, yu, yc, ff, o3, qh, $h, Kh, nf, of, rf, lf, af, uf, If, pf, mf, Qv, Hp, sf, u3, yf, gf, d3, I4, GO, kO],
  3288037868: [QQ, JQ],
  2736907675: [_5],
  4182860854: [f4, zg],
  59481748: [jg, pA, Wg, mA],
  3749851601: [Wg],
  3331915920: [jg],
  1383045692: [oA],
  2506170314: [bN, DN, CN, ON, _N],
  2601014836: [Pg, Fg, SN, HU, jV, j2, Mg, Ug, WV, c0, rA, tA, iA, dA],
  3073041342: [BQ, GQ, WQ, qQ, Zoe, Qoe],
  339256511: [M0, Yh, B0, hf, n3, ic, nc, sc, oc, rc, Wh, lc, Aa, La, dc, va, lC, Oa, Ya, $a, tu, nu, au, du, cu, aC, cc, Ca, Xa, hc, _a, ka, Va, ru, fc, Sa, Fa, su, Ic, xa, za, lu, hu, pc, ba, Pa, qa, Ka, eu, ou, pu, mc, Na, Da, Ma, Ua, Ba, Ha, Ga, ja, Wa, Za, Qa, Ja, iu, uu, fu, Iu, mu, yu, yc, ff, o3, qh, $h, Kh, nf, of, rf, lf, af, uf, If, pf, mf, Qv, Hp, sf, u3, yf, gf, d3],
  2777663545: [kg],
  80994333: [ZQ],
  4238390223: [yf, gf],
  1484403080: [YO],
  1425443689: [i3, Bg],
  3888040117: [HQ, W2, Ky, ju, zV, $2, AI, K2, i4, vN, FQ, Y2, Zm, Qm, q2, kQ, VQ, zQ, jQ, YQ, Z2, X2, e4, $Q, KQ, s4, o4, AN, t4, NN, qm, $m, Km, Jm, e3, r3, r4, LN, Yg, Ym, J2, gu, VV, H0, dd, hd, fd, Id, pd, md, yd, sC, Ed, gd, eh, Vp, G0, k0, cd, V0, z0, j0, W0, Y0, q0, $0, K0, Z0, i0, Q0, J0, X0, ih, nh, sh, oh, Ra, Hu, Gu, ku, U0, n0, GU, Zv, zp, wI, jp, oC, rC, B_, uc, df, wd, cf, t3, $V, th, r0, lh, s3, Wp, n4, Zp, Zh, Jh, tf, Xm, ac, ef, Ec, Ef, a3, d4, Xh, F_, s0, H_, o0, RI, Qh, l3, c4, rh, a0, u0, l0, Zy, HO, Td, Q2, YV, qV, l4, xN],
  2945172077: [Q2, YV, qV, l4],
  4208778838: [Ym, J2, gu, VV, H0, dd, hd, fd, Id, pd, md, yd, sC, Ed, gd, eh, Vp, G0, k0, cd, V0, z0, j0, W0, Y0, q0, $0, K0, Z0, i0, Q0, J0, X0, ih, nh, sh, oh, Ra, Hu, Gu, ku, U0, n0, GU, Zv, zp, wI, jp, oC, rC, B_, uc, df, wd, cf, t3, $V, th, r0, lh, s3, Wp, n4, Zp, Zh, Jh, tf, Xm, ac, ef, Ec, Ef, a3, d4, Xh, F_, s0, H_, o0, RI, Qh, l3, c4, rh, a0, u0, l0, Zy, HO],
  3939117080: [Ns, ge, Xr, Vs, lB, rz, uz, bs, az, Xp],
  1683148259: [az],
  2495723537: [lB, rz, uz],
  1865459582: [bJ, So, oE, rE, lA, lE, T4, NJ],
  826625072: [ot, at, ns, tr, We, lt, GF, ri, ut, Jp, dt, Xe, Hg, Ko, Hn, Un, Ad, Vt, ct, Gg, Te],
  1204542856: [ct, Gg],
  1638771189: [Hg],
  2551354335: [U, B],
  693640335: [fe, lz, Fe],
  4186316022: [lz],
  2914609552: [qm, $m, Km, Jm, e3, r3, r4],
  2706606064: [rh, a0, u0, l0],
  3893378262: [sf],
  3544373492: [Xh, F_, s0, H_, o0, RI, Qh, l3],
  3136571912: [Zh, Jh, tf, Xm, ac, ef, Ec, Ef, a3],
  530289379: [ac, ef, Ec, Ef],
  3689010777: [Qh],
  3979015343: [Ec],
  3473067441: [YV, qV],
  2296667514: [t4],
  1260505505: [HU, jV, j2, Mg, Ug, WV, c0],
  1950629157: [qh, $h, Kh, nf, of, rf, lf, af, uf, If, pf, mf],
  3732776249: [WV],
  2510884976: [Pg, Fg],
  2559216714: [qm, $m, Km, Jm, e3, r3],
  3293443760: [FQ, Y2, Zm, Qm, q2, kQ, VQ, zQ, jQ, YQ, Z2, X2, e4, $Q, KQ, s4, o4],
  681481545: [BQ, GQ, WQ, qQ],
  3256556792: [ic, nc, sc, oc, rc, Wh, lc, Aa, La, dc, va, lC, Oa, Ya, $a, tu, nu, au, du, cu, aC, cc, Ca, Xa, hc, _a, ka, Va, ru, fc, Sa, Fa, su, Ic, xa, za, lu, hu, pc, ba, Pa, qa, Ka, eu, ou, pu, mc, Na, Da, Ma, Ua, Ba, Ha, Ga, ja, Wa, Za, Qa, Ja, iu, uu, fu, Iu, mu, yu, yc, ff],
  3849074793: [lc, Aa, La, dc, va, lC, Oa, Ya, $a, tu, nu, au, du, cu, aC, cc, Ca, Xa, hc, _a, ka, Va, ru, fc, Sa, Fa, su, Ic, xa, za, lu, hu, pc, ba, Pa, qa, Ka, eu, ou, pu, mc, Na, Da, Ma, Ua, Ba, Ha, Ga, ja, Wa, Za, Qa, Ja, iu, uu, fu, Iu, mu, yu, yc],
  1758889154: [VV, H0, dd, hd, fd, Id, pd, md, yd, sC, Ed, gd, eh, Vp, G0, k0, cd, V0, z0, j0, W0, Y0, q0, $0, K0, Z0, i0, Q0, J0, X0, ih, nh, sh, oh, Ra, Hu, Gu, ku, U0, n0, GU, Zv, zp, wI, jp, oC, rC, B_, uc, df, wd, cf, t3, $V, th, r0, lh, s3, Wp],
  1623761950: [th, r0, lh],
  2590856083: [M0, Yh, B0, hf],
  2107101300: [Na, Da, Ma, Ua, Ba, Ha, Ga, ja, Wa, Za, Qa, Ja, iu, uu, fu, Iu, mu, yu],
  647756555: [r0],
  2489546625: [B0],
  2827207264: [oC, rC, B_, uc, df, wd, cf],
  2143335405: [wd],
  1287392070: [oC, rC, B_, uc],
  3907093117: [ba, Pa, qa, Ka, eu, ou, pu],
  3198132628: [xa, za, lu, hu],
  1482959167: [Sa, Fa, su],
  1834744321: [_a, ka, Va, ru],
  1339347760: [Ca, Xa],
  2297155007: [va, lC, Oa, Ya, $a, tu, nu, au, du, cu, aC],
  3009222698: [Aa, La],
  2706460486: [HQ, W2, Ky, ju, zV, $2, AI, K2, i4],
  3740093272: [Ym],
  682877961: [Xh, F_, s0, H_, o0],
  1179482911: [Zh, Jh, tf],
  214636428: [ac],
  1807405624: [H_],
  1621171031: [F_],
  2254336722: [ju, zV],
  1028945134: [Zm, Qm],
  1967976161: [HU, jV],
  1916977116: [HU],
  3299480353: [G0, k0, cd, V0, z0, j0, W0, Y0, q0, $0, K0, Z0, i0, Q0, J0, X0, ih, nh, sh, oh, Ra, Hu, Gu, ku, U0, n0, GU],
  52481810: [Ra, Hu, Gu, ku, U0, n0],
  2635815018: [M0],
  2063403501: [ic, nc, sc, oc, rc],
  1945004755: [H0, dd, hd, fd, Id, pd, md, yd, sC, Ed, gd, eh],
  3040386961: [dd, hd, fd, Id, pd, md, yd, sC, Ed, gd],
  855621170: [oC, rC],
  2058353004: [sC],
  3027567501: [Ra, Hu, Gu, ku],
  2391406946: [cd]
};
_ie[1] = {
  618182010: [["OfPerson", e6, 7, !0], ["OfOrganization", t6, 4, !0]],
  411424972: [["ValuesReferenced", hre, 1, !0], ["ValueOfComponents", zU, 0, !0], ["IsComponentIn", zU, 1, !0]],
  130549933: [["Actors", hSe, 1, !0], ["IsRelatedWith", yL, 0, !0], ["Relates", yL, 1, !0]],
  747523909: [["Contains", cSe, 1, !0]],
  1767535486: [["IsClassifiedItemIn", hIe, 1, !0], ["IsClassifyingItemIn", hIe, 0, !0]],
  1959218052: [["ClassifiedAs", Ire, 0, !0], ["RelatesConstraints", kU, 2, !0], ["IsRelatedWith", kU, 3, !0], ["PropertiesForConstraint", fre, 0, !0], ["Aggregates", VU, 2, !0], ["IsAggregatedIn", VU, 3, !0]],
  602808272: [["ValuesReferenced", hre, 1, !0], ["ValueOfComponents", zU, 0, !0], ["IsComponentIn", zU, 1, !0]],
  1154170062: [["IsPointedTo", mL, 1, !0], ["IsPointer", mL, 0, !0]],
  1648886627: [["ValuesReferenced", hre, 1, !0], ["ValueOfComponents", zU, 0, !0], ["IsComponentIn", zU, 1, !0]],
  852622518: [["PartOfW", gu, 9, !0], ["PartOfV", gu, 8, !0], ["PartOfU", gu, 7, !0], ["HasIntersections", jae, 0, !0]],
  3452421091: [["ReferenceIntoLibrary", rue, 4, !0]],
  1838606355: [["HasRepresentation", PH, 3, !0], ["ClassifiedAs", oSe, 1, !0]],
  248100487: [["ToMaterialLayerSet", pL, 0, !1]],
  3368373690: [["ClassifiedAs", Ire, 0, !0], ["RelatesConstraints", kU, 2, !0], ["IsRelatedWith", kU, 3, !0], ["PropertiesForConstraint", fre, 0, !0], ["Aggregates", VU, 2, !0], ["IsAggregatedIn", VU, 3, !0]],
  3701648758: [["PlacesObject", Td, 5, !0], ["ReferencedByPlacements", x5, 0, !0]],
  2251480897: [["ClassifiedAs", Ire, 0, !0], ["RelatesConstraints", kU, 2, !0], ["IsRelatedWith", kU, 3, !0], ["PropertiesForConstraint", fre, 0, !0], ["Aggregates", VU, 2, !0], ["IsAggregatedIn", VU, 3, !0]],
  4251960020: [["IsRelatedBy", IL, 3, !0], ["Relates", IL, 2, !0], ["Engages", RH, 1, !0]],
  2077209135: [["EngagedIn", RH, 0, !0]],
  2483315170: [["PartOfComplex", Jr, 2, !0]],
  2226359599: [["PartOfComplex", Jr, 2, !0]],
  3355820592: [["OfPerson", e6, 7, !0], ["OfOrganization", t6, 4, !0]],
  2598011224: [["PropertyForDependance", cs, 0, !0], ["PropertyDependsOn", cs, 1, !0], ["PartOfComplex", Ur, 3, !0]],
  2044713172: [["PartOfComplex", Jr, 2, !0]],
  2093928680: [["PartOfComplex", Jr, 2, !0]],
  931644368: [["PartOfComplex", Jr, 2, !0]],
  3252649465: [["PartOfComplex", Jr, 2, !0]],
  2405470396: [["PartOfComplex", Jr, 2, !0]],
  825690147: [["PartOfComplex", Jr, 2, !0]],
  1076942058: [["RepresentationMap", ah, 1, !0], ["LayerAssignments", Ke, 2, !0], ["OfProductRepresentation", wf, 2, !0]],
  3377609919: [["RepresentationsInContext", XN, 0, !0]],
  3008791417: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1660063152: [["MapUsage", hL, 0, !0]],
  3982875396: [["RepresentationMap", ah, 1, !0], ["LayerAssignments", Ke, 2, !0], ["OfProductRepresentation", wf, 2, !0], ["OfShapeAspect", Qy, 0, !0]],
  4240577450: [["RepresentationMap", ah, 1, !0], ["LayerAssignments", Ke, 2, !0], ["OfProductRepresentation", wf, 2, !0], ["OfShapeAspect", Qy, 0, !0]],
  3692461612: [["PropertyForDependance", cs, 0, !0], ["PropertyDependsOn", cs, 1, !0], ["PartOfComplex", Ur, 3, !0]],
  2830218821: [["RepresentationMap", ah, 1, !0], ["LayerAssignments", Ke, 2, !0], ["OfProductRepresentation", wf, 2, !0]],
  3958052878: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3049322572: [["RepresentationMap", ah, 1, !0], ["LayerAssignments", Ke, 2, !0], ["OfProductRepresentation", wf, 2, !0]],
  531007025: [["OfTable", qAe, 1, !1]],
  912023232: [["OfPerson", e6, 7, !0], ["OfOrganization", t6, 4, !0]],
  280115917: [["AnnotatedSurface", Cz, 1, !0]],
  1742049831: [["AnnotatedSurface", Cz, 1, !0]],
  2552916305: [["AnnotatedSurface", Cz, 1, !0]],
  3101149627: [["DocumentedBy", cre, 0, !0]],
  1377556343: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1735638870: [["RepresentationMap", ah, 1, !0], ["LayerAssignments", Ke, 2, !0], ["OfProductRepresentation", wf, 2, !0], ["OfShapeAspect", Qy, 0, !0]],
  2799835756: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1907098498: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2442683028: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  962685235: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3612888222: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2297822566: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2542286263: [["PropertyForDependance", cs, 0, !0], ["PropertyDependsOn", cs, 1, !0], ["PartOfComplex", Ur, 3, !0]],
  370225590: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3732053477: [["ReferenceToDocument", due, 3, !0]],
  3900360178: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  476780140: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2556980723: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1809719519: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  803316827: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3008276851: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3448662350: [["RepresentationsInContext", XN, 0, !0], ["HasSubContexts", dE, 6, !0]],
  2453401579: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4142052618: [["RepresentationsInContext", XN, 0, !0], ["HasSubContexts", dE, 6, !0]],
  3590301190: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  178086475: [["PlacesObject", Td, 5, !0], ["ReferencedByPlacements", x5, 0, !0]],
  812098782: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3741457305: [["DocumentedBy", cre, 0, !0]],
  1402838566: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  125510826: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2604431987: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4266656042: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1520743889: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3422422726: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2624227202: [["PlacesObject", Td, 5, !0], ["ReferencedByPlacements", x5, 0, !0]],
  1008929658: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2347385850: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  219451334: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0]],
  2833995503: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2665983363: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1029017970: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2519244187: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3021840470: [["PartOfComplex", Jr, 2, !0]],
  2004835150: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1663979128: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2067069095: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4022376103: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1423911732: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2924175390: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2775532180: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  673634403: [["ShapeOfProduct", Td, 6, !0], ["HasShapeAspects", Qy, 4, !0]],
  871118103: [["PropertyForDependance", cs, 0, !0], ["PropertyDependsOn", cs, 1, !0], ["PartOfComplex", Ur, 3, !0]],
  1680319473: [["HasAssociations", X, 4, !0]],
  4166981789: [["PropertyForDependance", cs, 0, !0], ["PropertyDependsOn", cs, 1, !0], ["PartOfComplex", Ur, 3, !0]],
  2752243245: [["PropertyForDependance", cs, 0, !0], ["PropertyDependsOn", cs, 1, !0], ["PartOfComplex", Ur, 3, !0]],
  941946838: [["PropertyForDependance", cs, 0, !0], ["PropertyDependsOn", cs, 1, !0], ["PartOfComplex", Ur, 3, !0]],
  3357820518: [["HasAssociations", X, 4, !0], ["PropertyDefinitionOf", Fe, 5, !0], ["DefinesType", $s, 5, !0]],
  3650150729: [["PropertyForDependance", cs, 0, !0], ["PropertyDependsOn", cs, 1, !0], ["PartOfComplex", Ur, 3, !0]],
  110355661: [["PropertyForDependance", cs, 0, !0], ["PropertyDependsOn", cs, 1, !0], ["PartOfComplex", Ur, 3, !0]],
  3413951693: [["DocumentedBy", cre, 0, !0]],
  3765753017: [["HasAssociations", X, 4, !0], ["PropertyDefinitionOf", Fe, 5, !0], ["DefinesType", $s, 5, !0]],
  1509187699: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2411513650: [["HasAssociations", X, 4, !0], ["PropertyDefinitionOf", Fe, 5, !0], ["DefinesType", $s, 5, !0]],
  4124623270: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  723233188: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2485662743: [["HasAssociations", X, 4, !0], ["PropertyDefinitionOf", Fe, 5, !0], ["DefinesType", $s, 5, !0]],
  1202362311: [["HasAssociations", X, 4, !0], ["PropertyDefinitionOf", Fe, 5, !0], ["DefinesType", $s, 5, !0]],
  390701378: [["HasAssociations", X, 4, !0], ["PropertyDefinitionOf", Fe, 5, !0], ["DefinesType", $s, 5, !0]],
  2233826070: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2513912981: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2247615214: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1260650574: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  230924584: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3028897424: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4282788508: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3124975700: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1345879162: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1628702193: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  2347495698: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  1417489154: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2759199220: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  336235671: [["HasAssociations", X, 4, !0], ["PropertyDefinitionOf", Fe, 5, !0], ["DefinesType", $s, 5, !0]],
  512836454: [["HasAssociations", X, 4, !0], ["PropertyDefinitionOf", Fe, 5, !0], ["DefinesType", $s, 5, !0]],
  1299126871: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  3288037868: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  669184980: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2265737646: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1302238472: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4261334040: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3125803723: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2740243338: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2736907675: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4182860854: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2581212453: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2713105998: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1123145078: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  59481748: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3749851601: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3486308946: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3331915920: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1416205885: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2205249479: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2485617015: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0], ["UsingCurves", c0, 0, !0]],
  2506170314: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2147822146: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2601014836: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2827736869: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  693772133: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  606661476: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0], ["AnnotatedBySymbols", dz, 3, !0]],
  4054601972: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  32440307: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2963535650: [["HasAssociations", X, 4, !0], ["PropertyDefinitionOf", Fe, 5, !0], ["DefinesType", $s, 5, !0]],
  1714330368: [["HasAssociations", X, 4, !0], ["PropertyDefinitionOf", Fe, 5, !0], ["DefinesType", $s, 5, !0]],
  526551008: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  3073041342: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0], ["IsRelatedFromCallout", Dy, 3, !0], ["IsRelatedToCallout", Dy, 2, !0]],
  1472233963: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1883228015: [["HasAssociations", X, 4, !0], ["PropertyDefinitionOf", Fe, 5, !0], ["DefinesType", $s, 5, !0]],
  339256511: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  2777663545: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  80994333: [["HasAssociations", X, 4, !0], ["PropertyDefinitionOf", Fe, 5, !0], ["DefinesType", $s, 5, !0]],
  477187591: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2047409740: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  374418227: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4203026998: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  315944413: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3455213021: [["HasAssociations", X, 4, !0], ["PropertyDefinitionOf", Fe, 5, !0], ["DefinesType", $s, 5, !0]],
  4238390223: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  1268542332: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  987898635: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1281925730: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1425443689: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3888040117: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0]],
  3388369263: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3505215534: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3566463478: [["HasAssociations", X, 4, !0], ["PropertyDefinitionOf", Fe, 5, !0], ["DefinesType", $s, 5, !0]],
  603570806: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  220341763: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2945172077: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["OperatesOn", Xr, 6, !0], ["IsSuccessorFrom", tr, 5, !0], ["IsPredecessorTo", tr, 4, !0]],
  4208778838: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0]],
  103090709: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0]],
  4194566429: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1451395588: [["HasAssociations", X, 4, !0], ["PropertyDefinitionOf", Fe, 5, !0], ["DefinesType", $s, 5, !0]],
  3219374653: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0]],
  2798486643: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3454111270: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2914609552: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ResourceOf", Ns, 6, !0]],
  1856042241: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4158566097: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3626867408: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2706606064: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["ReferencesElements", We, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ContainsElements", Xe, 5, !0]],
  3893378262: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  451544542: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3544373492: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedToStructuralItem", Un, 5, !1]],
  3136571912: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedStructuralActivity", Un, 4, !0]],
  530289379: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedStructuralActivity", Un, 4, !0], ["ReferencesElement", Hn, 5, !0], ["ConnectedBy", Ko, 4, !0]],
  3689010777: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedToStructuralItem", Un, 5, !1], ["Causes", RI, 10, !0]],
  3979015343: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedStructuralActivity", Un, 4, !0], ["ReferencesElement", Hn, 5, !0], ["ConnectedBy", Ko, 4, !0]],
  2218152070: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedStructuralActivity", Un, 4, !0], ["ReferencesElement", Hn, 5, !0], ["ConnectedBy", Ko, 4, !0]],
  4070609034: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0], ["IsRelatedFromCallout", Dy, 3, !0], ["IsRelatedToCallout", Dy, 2, !0]],
  2028607225: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2809605785: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4124788165: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1580310250: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  3473067441: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["OperatesOn", Xr, 6, !0], ["IsSuccessorFrom", tr, 5, !0], ["IsPredecessorTo", tr, 4, !0]],
  2097647324: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  2296667514: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["IsActingUpon", Xp, 6, !0]],
  1674181508: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  1334484129: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3649129432: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1260505505: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4031249490: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["ReferencesElements", We, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ContainsElements", Xe, 5, !0]],
  1950629157: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  3124254112: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["ReferencesElements", We, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ContainsElements", Xe, 5, !0]],
  300633059: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  3732776249: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2510884976: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2559216714: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ResourceOf", Ns, 6, !0]],
  3293443760: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["Controls", bs, 6, !0]],
  3895139033: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["Controls", bs, 6, !0]],
  1419761937: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["Controls", bs, 6, !0]],
  1916426348: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  3295246426: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ResourceOf", Ns, 6, !0]],
  1457835157: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  681481545: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0], ["IsRelatedFromCallout", Dy, 3, !0], ["IsRelatedToCallout", Dy, 2, !0]],
  3256556792: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  3849074793: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  360485395: [["HasAssociations", X, 4, !0], ["PropertyDefinitionOf", Fe, 5, !0], ["DefinesType", $s, 5, !0]],
  1758889154: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  4123344466: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  1623761950: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  2590856083: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  1704287377: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2107101300: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  1962604670: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  3272907226: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["Controls", bs, 6, !0]],
  3174744832: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  3390157468: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  807026263: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3737207727: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  647756555: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  2489546625: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  2827207264: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  2143335405: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["ProjectsElements", lt, 5, !1]],
  1287392070: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["VoidsElements", ot, 5, !1]],
  3907093117: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  3198132628: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  3815607619: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  1482959167: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  1834744321: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  1339347760: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  2297155007: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  3009222698: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  263784265: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  814719939: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["Controls", bs, 6, !0]],
  200128114: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  3009204131: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  2706460486: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["IsGroupedBy", Vs, 6, !1]],
  1251058090: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  1806887404: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  2391368822: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["IsGroupedBy", Vs, 6, !1]],
  4288270099: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  3827777499: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ResourceOf", Ns, 6, !0]],
  1051575348: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  1161773419: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  2506943328: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0], ["IsRelatedFromCallout", Dy, 3, !0], ["IsRelatedToCallout", Dy, 2, !0]],
  377706215: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  2108223431: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  3181161470: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  977012517: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  1916936684: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["OperatesOn", Xr, 6, !0], ["IsSuccessorFrom", tr, 5, !0], ["IsPredecessorTo", tr, 4, !0]],
  4143007308: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["IsActingUpon", Xp, 6, !0]],
  3588315303: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["VoidsElements", ot, 5, !1], ["HasFillings", ut, 4, !0]],
  3425660407: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["OperatesOn", Xr, 6, !0], ["IsSuccessorFrom", tr, 5, !0], ["IsPredecessorTo", tr, 4, !0]],
  2837617999: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  2382730787: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["Controls", bs, 6, !0]],
  3327091369: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["Controls", bs, 6, !0]],
  804291784: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  4231323485: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  4017108033: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  3724593414: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3740093272: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["ContainedIn", Vt, 4, !1], ["ConnectedFrom", Ad, 5, !0], ["ConnectedTo", Ad, 4, !0]],
  2744685151: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["OperatesOn", Xr, 6, !0], ["IsSuccessorFrom", tr, 5, !0], ["IsPredecessorTo", tr, 4, !0]],
  2904328755: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["Controls", bs, 6, !0]],
  3642467123: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["Controls", bs, 6, !0]],
  3651124850: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["ProjectsElements", lt, 5, !1]],
  1842657554: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  2250791053: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  3248260540: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0], ["IsRelatedFromCallout", Dy, 3, !0], ["IsRelatedToCallout", Dy, 2, !0]],
  2893384427: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  2324767716: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  1768891740: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  3517283431: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["Controls", bs, 6, !0], ["ScheduleTimeControlAssigned", lB, 7, !1]],
  4105383287: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["Controls", bs, 6, !0]],
  4097777520: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["ReferencesElements", We, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ContainsElements", Xe, 5, !0]],
  2533589738: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  3856911033: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["ReferencesElements", We, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ContainsElements", Xe, 5, !0], ["HasCoverings", Jp, 4, !0], ["BoundedBy", at, 4, !0]],
  1305183839: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  652456506: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["Controls", bs, 6, !0], ["HasInteractionReqsFrom", GF, 7, !0], ["HasInteractionReqsTo", GF, 8, !0]],
  3812236995: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  3112655638: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  1039846685: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  682877961: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedToStructuralItem", Un, 5, !1]],
  1179482911: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedStructuralActivity", Un, 4, !0], ["ConnectsStructuralMembers", Ko, 5, !0]],
  4243806635: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedStructuralActivity", Un, 4, !0], ["ConnectsStructuralMembers", Ko, 5, !0]],
  214636428: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedStructuralActivity", Un, 4, !0], ["ReferencesElement", Hn, 5, !0], ["ConnectedBy", Ko, 4, !0]],
  2445595289: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedStructuralActivity", Un, 4, !0], ["ReferencesElement", Hn, 5, !0], ["ConnectedBy", Ko, 4, !0]],
  1807405624: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedToStructuralItem", Un, 5, !1]],
  1721250024: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedToStructuralItem", Un, 5, !1]],
  1252848954: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["IsGroupedBy", Vs, 6, !1], ["SourceOfResultGroup", AI, 6, !0], ["LoadGroupFor", ju, 7, !0]],
  1621171031: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedToStructuralItem", Un, 5, !1]],
  3987759626: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedToStructuralItem", Un, 5, !1]],
  2082059205: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedToStructuralItem", Un, 5, !1]],
  734778138: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedStructuralActivity", Un, 4, !0], ["ConnectsStructuralMembers", Ko, 5, !0]],
  1235345126: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedToStructuralItem", Un, 5, !1], ["Causes", RI, 10, !0]],
  2986769608: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["IsGroupedBy", Vs, 6, !1], ["ResultGroupFor", ju, 8, !0]],
  1975003073: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedStructuralActivity", Un, 4, !0], ["ConnectsStructuralMembers", Ko, 5, !0]],
  148013059: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ResourceOf", Ns, 6, !0]],
  2315554128: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  2254336722: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["IsGroupedBy", Vs, 6, !1], ["ServicesBuildings", ns, 4, !0]],
  5716631: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  1637806684: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["Controls", bs, 6, !0]],
  1692211062: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  1620046519: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  3593883385: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1600972822: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  1911125066: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  728799441: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  2769231204: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  1898987631: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  1133259667: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  1028945134: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["Controls", bs, 6, !0]],
  4218914973: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["Controls", bs, 6, !0]],
  3342526732: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["Controls", bs, 6, !0]],
  1033361043: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["IsGroupedBy", Vs, 6, !1]],
  1213861670: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3821786052: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["Controls", bs, 6, !0]],
  1411407467: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  3352864051: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  1871374353: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  2470393545: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0], ["IsRelatedFromCallout", Dy, 3, !0], ["IsRelatedToCallout", Dy, 2, !0]],
  3460190687: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["IsGroupedBy", Vs, 6, !1]],
  1967976161: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  819618141: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  1916977116: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  231477066: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  3299480353: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  52481810: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  2979338954: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  1095909175: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  1909888760: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  395041908: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  3293546465: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  1285652485: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  2951183804: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  2611217952: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2301859152: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  843113511: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  3850581409: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  2816379211: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  2188551683: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["IsGroupedBy", Vs, 6, !1]],
  1163958913: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["Controls", bs, 6, !0]],
  3898045240: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ResourceOf", Ns, 6, !0]],
  1060000209: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ResourceOf", Ns, 6, !0]],
  488727124: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ResourceOf", Ns, 6, !0]],
  335055490: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  2954562838: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  1973544240: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["CoversSpaces", Jp, 5, !0], ["Covers", dt, 5, !0]],
  3495092785: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  3961806047: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  4147604152: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0], ["IsRelatedFromCallout", Dy, 3, !0], ["IsRelatedToCallout", Dy, 2, !0]],
  1335981549: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  2635815018: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  1599208980: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  2063403501: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  1945004755: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  3040386961: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasControlElements", ri, 5, !0]],
  3041715199: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["ContainedIn", Vt, 4, !1], ["ConnectedFrom", Ad, 5, !0], ["ConnectedTo", Ad, 4, !0]],
  395920057: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  869906466: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  3760055223: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  2030761528: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  855621170: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["VoidsElements", ot, 5, !1]],
  663422040: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  3277789161: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  1534661035: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  1365060375: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  1217240411: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  712377611: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  1634875225: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["IsGroupedBy", Vs, 6, !1], ["ServicesBuildings", ns, 4, !0]],
  857184966: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  1658829314: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasControlElements", ri, 5, !0]],
  346874300: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  1810631287: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  4222183408: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  2058353004: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasControlElements", ri, 5, !0]],
  4278956645: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasControlElements", ri, 5, !0]],
  4037862832: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  3132237377: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasControlElements", ri, 5, !0]],
  987401354: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasControlElements", ri, 5, !0]],
  707683696: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasControlElements", ri, 5, !0]],
  2223149337: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasControlElements", ri, 5, !0]],
  3508470533: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasControlElements", ri, 5, !0]],
  900683007: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  1073191201: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  1687234759: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  3171933400: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  2262370178: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  3024970846: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  3283111854: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  3055160366: [["LayerAssignments", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3027567501: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  2320036040: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  2016517767: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  1376911519: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["VoidsElements", ot, 5, !1]],
  1783015770: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  1529196076: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  331165859: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  4252922144: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  2515109513: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["IsGroupedBy", Vs, 6, !1], ["ServicesBuildings", ns, 4, !0]],
  3824725483: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  2347447852: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  3313531582: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  2391406946: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  3512223829: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  3304561284: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  2874132201: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  3001207471: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  753842376: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  2454782716: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["VoidsElements", ot, 5, !1]],
  578613899: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["ObjectTypeOf", fe, 5, !0]],
  1052013943: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasControlElements", ri, 5, !0]],
  1062813311: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["AssignedToFlowElement", ri, 4, !0]],
  3700593921: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasControlElements", ri, 5, !0]],
  979691226: [["HasAssignments", ie, 4, !0], ["IsDecomposedBy", Ye, 4, !0], ["Decomposes", Ye, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Ni, 4, !0], ["ReferencedBy", ge, 6, !0], ["HasStructuralMember", Hn, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["HasCoverings", dt, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasPorts", Vt, 5, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0]]
};
xie[1] = {
  3630933823: (e) => new f.IfcActorRole(e[0], e[1], e[2]),
  618182010: (e) => new f.IfcAddress(e[0], e[1], e[2]),
  639542469: (e) => new f.IfcApplication(e[0], e[1], e[2], e[3]),
  411424972: (e) => new f.IfcAppliedValue(e[0], e[1], e[2], e[3], e[4], e[5]),
  1110488051: (e) => new f.IfcAppliedValueRelationship(e[0], e[1], e[2], e[3], e[4]),
  130549933: (e) => new f.IfcApproval(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2080292479: (e) => new f.IfcApprovalActorRelationship(e[0], e[1], e[2]),
  390851274: (e) => new f.IfcApprovalPropertyRelationship(e[0], e[1]),
  3869604511: (e) => new f.IfcApprovalRelationship(e[0], e[1], e[2], e[3]),
  4037036970: (e) => new f.IfcBoundaryCondition(e[0]),
  1560379544: (e) => new f.IfcBoundaryEdgeCondition(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3367102660: (e) => new f.IfcBoundaryFaceCondition(e[0], e[1], e[2], e[3]),
  1387855156: (e) => new f.IfcBoundaryNodeCondition(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2069777674: (e) => new f.IfcBoundaryNodeConditionWarping(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  622194075: (e) => new f.IfcCalendarDate(e[0], e[1], e[2]),
  747523909: (e) => new f.IfcClassification(e[0], e[1], e[2], e[3]),
  1767535486: (e) => new f.IfcClassificationItem(e[0], e[1], e[2]),
  1098599126: (e) => new f.IfcClassificationItemRelationship(e[0], e[1]),
  938368621: (e) => new f.IfcClassificationNotation(e[0]),
  3639012971: (e) => new f.IfcClassificationNotationFacet(e[0]),
  3264961684: (e) => new f.IfcColourSpecification(e[0]),
  2859738748: (e) => new f.IfcConnectionGeometry(),
  2614616156: (e) => new f.IfcConnectionPointGeometry(e[0], e[1]),
  4257277454: (e) => new f.IfcConnectionPortGeometry(e[0], e[1], e[2]),
  2732653382: (e) => new f.IfcConnectionSurfaceGeometry(e[0], e[1]),
  1959218052: (e) => new f.IfcConstraint(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1658513725: (e) => new f.IfcConstraintAggregationRelationship(e[0], e[1], e[2], e[3], e[4]),
  613356794: (e) => new f.IfcConstraintClassificationRelationship(e[0], e[1]),
  347226245: (e) => new f.IfcConstraintRelationship(e[0], e[1], e[2], e[3]),
  1065062679: (e) => new f.IfcCoordinatedUniversalTimeOffset(e[0], e[1], e[2]),
  602808272: (e) => new f.IfcCostValue(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  539742890: (e) => new f.IfcCurrencyRelationship(e[0], e[1], e[2], e[3], e[4]),
  1105321065: (e) => new f.IfcCurveStyleFont(e[0], e[1]),
  2367409068: (e) => new f.IfcCurveStyleFontAndScaling(e[0], e[1], e[2]),
  3510044353: (e) => new f.IfcCurveStyleFontPattern(e[0], e[1]),
  1072939445: (e) => new f.IfcDateAndTime(e[0], e[1]),
  1765591967: (e) => new f.IfcDerivedUnit(e[0], e[1], e[2]),
  1045800335: (e) => new f.IfcDerivedUnitElement(e[0], e[1]),
  2949456006: (e) => new f.IfcDimensionalExponents(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1376555844: (e) => new f.IfcDocumentElectronicFormat(e[0], e[1], e[2]),
  1154170062: (e) => new f.IfcDocumentInformation(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16]),
  770865208: (e) => new f.IfcDocumentInformationRelationship(e[0], e[1], e[2]),
  3796139169: (e) => new f.IfcDraughtingCalloutRelationship(e[0], e[1], e[2], e[3]),
  1648886627: (e) => new f.IfcEnvironmentalImpactValue(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3200245327: (e) => new f.IfcExternalReference(e[0], e[1], e[2]),
  2242383968: (e) => new f.IfcExternallyDefinedHatchStyle(e[0], e[1], e[2]),
  1040185647: (e) => new f.IfcExternallyDefinedSurfaceStyle(e[0], e[1], e[2]),
  3207319532: (e) => new f.IfcExternallyDefinedSymbol(e[0], e[1], e[2]),
  3548104201: (e) => new f.IfcExternallyDefinedTextFont(e[0], e[1], e[2]),
  852622518: (e) => new f.IfcGridAxis(e[0], e[1], e[2]),
  3020489413: (e) => new f.IfcIrregularTimeSeriesValue(e[0], e[1]),
  2655187982: (e) => new f.IfcLibraryInformation(e[0], e[1], e[2], e[3], e[4]),
  3452421091: (e) => new f.IfcLibraryReference(e[0], e[1], e[2]),
  4162380809: (e) => new f.IfcLightDistributionData(e[0], e[1], e[2]),
  1566485204: (e) => new f.IfcLightIntensityDistribution(e[0], e[1]),
  30780891: (e) => new f.IfcLocalTime(e[0], e[1], e[2], e[3], e[4]),
  1838606355: (e) => new f.IfcMaterial(e[0]),
  1847130766: (e) => new f.IfcMaterialClassificationRelationship(e[0], e[1]),
  248100487: (e) => new f.IfcMaterialLayer(e[0], e[1], e[2]),
  3303938423: (e) => new f.IfcMaterialLayerSet(e[0], e[1]),
  1303795690: (e) => new f.IfcMaterialLayerSetUsage(e[0], e[1], e[2], e[3]),
  2199411900: (e) => new f.IfcMaterialList(e[0]),
  3265635763: (e) => new f.IfcMaterialProperties(e[0]),
  2597039031: (e) => new f.IfcMeasureWithUnit(e[0], e[1]),
  4256014907: (e) => new f.IfcMechanicalMaterialProperties(e[0], e[1], e[2], e[3], e[4], e[5]),
  677618848: (e) => new f.IfcMechanicalSteelMaterialProperties(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  3368373690: (e) => new f.IfcMetric(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2706619895: (e) => new f.IfcMonetaryUnit(e[0]),
  1918398963: (e) => new f.IfcNamedUnit(e[0], e[1]),
  3701648758: (e) => new f.IfcObjectPlacement(),
  2251480897: (e) => new f.IfcObjective(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1227763645: (e) => new f.IfcOpticalMaterialProperties(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4251960020: (e) => new f.IfcOrganization(e[0], e[1], e[2], e[3], e[4]),
  1411181986: (e) => new f.IfcOrganizationRelationship(e[0], e[1], e[2], e[3]),
  1207048766: (e) => new f.IfcOwnerHistory(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2077209135: (e) => new f.IfcPerson(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  101040310: (e) => new f.IfcPersonAndOrganization(e[0], e[1], e[2]),
  2483315170: (e) => new f.IfcPhysicalQuantity(e[0], e[1]),
  2226359599: (e) => new f.IfcPhysicalSimpleQuantity(e[0], e[1], e[2]),
  3355820592: (e) => new f.IfcPostalAddress(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3727388367: (e) => new f.IfcPreDefinedItem(e[0]),
  990879717: (e) => new f.IfcPreDefinedSymbol(e[0]),
  3213052703: (e) => new f.IfcPreDefinedTerminatorSymbol(e[0]),
  1775413392: (e) => new f.IfcPreDefinedTextFont(e[0]),
  2022622350: (e) => new f.IfcPresentationLayerAssignment(e[0], e[1], e[2], e[3]),
  1304840413: (e) => new f.IfcPresentationLayerWithStyle(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3119450353: (e) => new f.IfcPresentationStyle(e[0]),
  2417041796: (e) => new f.IfcPresentationStyleAssignment(e[0]),
  2095639259: (e) => new f.IfcProductRepresentation(e[0], e[1], e[2]),
  2267347899: (e) => new f.IfcProductsOfCombustionProperties(e[0], e[1], e[2], e[3], e[4]),
  3958567839: (e) => new f.IfcProfileDef(e[0], e[1]),
  2802850158: (e) => new f.IfcProfileProperties(e[0], e[1]),
  2598011224: (e) => new f.IfcProperty(e[0], e[1]),
  3896028662: (e) => new f.IfcPropertyConstraintRelationship(e[0], e[1], e[2], e[3]),
  148025276: (e) => new f.IfcPropertyDependencyRelationship(e[0], e[1], e[2], e[3], e[4]),
  3710013099: (e) => new f.IfcPropertyEnumeration(e[0], e[1], e[2]),
  2044713172: (e) => new f.IfcQuantityArea(e[0], e[1], e[2], e[3]),
  2093928680: (e) => new f.IfcQuantityCount(e[0], e[1], e[2], e[3]),
  931644368: (e) => new f.IfcQuantityLength(e[0], e[1], e[2], e[3]),
  3252649465: (e) => new f.IfcQuantityTime(e[0], e[1], e[2], e[3]),
  2405470396: (e) => new f.IfcQuantityVolume(e[0], e[1], e[2], e[3]),
  825690147: (e) => new f.IfcQuantityWeight(e[0], e[1], e[2], e[3]),
  2692823254: (e) => new f.IfcReferencesValueDocument(e[0], e[1], e[2], e[3]),
  1580146022: (e) => new f.IfcReinforcementBarProperties(e[0], e[1], e[2], e[3], e[4], e[5]),
  1222501353: (e) => new f.IfcRelaxation(e[0], e[1]),
  1076942058: (e) => new f.IfcRepresentation(e[0], e[1], e[2], e[3]),
  3377609919: (e) => new f.IfcRepresentationContext(e[0], e[1]),
  3008791417: (e) => new f.IfcRepresentationItem(),
  1660063152: (e) => new f.IfcRepresentationMap(e[0], e[1]),
  3679540991: (e) => new f.IfcRibPlateProfileProperties(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2341007311: (e) => new f.IfcRoot(e[0], e[1], e[2], e[3]),
  448429030: (e) => new f.IfcSIUnit(e[0], e[1], e[2]),
  2042790032: (e) => new f.IfcSectionProperties(e[0], e[1], e[2]),
  4165799628: (e) => new f.IfcSectionReinforcementProperties(e[0], e[1], e[2], e[3], e[4], e[5]),
  867548509: (e) => new f.IfcShapeAspect(e[0], e[1], e[2], e[3], e[4]),
  3982875396: (e) => new f.IfcShapeModel(e[0], e[1], e[2], e[3]),
  4240577450: (e) => new f.IfcShapeRepresentation(e[0], e[1], e[2], e[3]),
  3692461612: (e) => new f.IfcSimpleProperty(e[0], e[1]),
  2273995522: (e) => new f.IfcStructuralConnectionCondition(e[0]),
  2162789131: (e) => new f.IfcStructuralLoad(e[0]),
  2525727697: (e) => new f.IfcStructuralLoadStatic(e[0]),
  3408363356: (e) => new f.IfcStructuralLoadTemperature(e[0], e[1], e[2], e[3]),
  2830218821: (e) => new f.IfcStyleModel(e[0], e[1], e[2], e[3]),
  3958052878: (e) => new f.IfcStyledItem(e[0], e[1], e[2]),
  3049322572: (e) => new f.IfcStyledRepresentation(e[0], e[1], e[2], e[3]),
  1300840506: (e) => new f.IfcSurfaceStyle(e[0], e[1], e[2]),
  3303107099: (e) => new f.IfcSurfaceStyleLighting(e[0], e[1], e[2], e[3]),
  1607154358: (e) => new f.IfcSurfaceStyleRefraction(e[0], e[1]),
  846575682: (e) => new f.IfcSurfaceStyleShading(e[0]),
  1351298697: (e) => new f.IfcSurfaceStyleWithTextures(e[0]),
  626085974: (e) => new f.IfcSurfaceTexture(e[0], e[1], e[2], e[3]),
  1290481447: (e) => new f.IfcSymbolStyle(e[0], e[1]),
  985171141: (e) => new f.IfcTable(e[0], e[1]),
  531007025: (e) => new f.IfcTableRow(e[0], e[1]),
  912023232: (e) => new f.IfcTelecomAddress(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1447204868: (e) => new f.IfcTextStyle(e[0], e[1], e[2], e[3]),
  1983826977: (e) => new f.IfcTextStyleFontModel(e[0], e[1], e[2], e[3], e[4], e[5]),
  2636378356: (e) => new f.IfcTextStyleForDefinedFont(e[0], e[1]),
  1640371178: (e) => new f.IfcTextStyleTextModel(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1484833681: (e) => new f.IfcTextStyleWithBoxCharacteristics(e[0], e[1], e[2], e[3], e[4]),
  280115917: (e) => new f.IfcTextureCoordinate(),
  1742049831: (e) => new f.IfcTextureCoordinateGenerator(e[0], e[1]),
  2552916305: (e) => new f.IfcTextureMap(e[0]),
  1210645708: (e) => new f.IfcTextureVertex(e[0]),
  3317419933: (e) => new f.IfcThermalMaterialProperties(e[0], e[1], e[2], e[3], e[4]),
  3101149627: (e) => new f.IfcTimeSeries(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1718945513: (e) => new f.IfcTimeSeriesReferenceRelationship(e[0], e[1]),
  581633288: (e) => new f.IfcTimeSeriesValue(e[0]),
  1377556343: (e) => new f.IfcTopologicalRepresentationItem(),
  1735638870: (e) => new f.IfcTopologyRepresentation(e[0], e[1], e[2], e[3]),
  180925521: (e) => new f.IfcUnitAssignment(e[0]),
  2799835756: (e) => new f.IfcVertex(),
  3304826586: (e) => new f.IfcVertexBasedTextureMap(e[0], e[1]),
  1907098498: (e) => new f.IfcVertexPoint(e[0]),
  891718957: (e) => new f.IfcVirtualGridIntersection(e[0], e[1]),
  1065908215: (e) => new f.IfcWaterProperties(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2442683028: (e) => new f.IfcAnnotationOccurrence(e[0], e[1], e[2]),
  962685235: (e) => new f.IfcAnnotationSurfaceOccurrence(e[0], e[1], e[2]),
  3612888222: (e) => new f.IfcAnnotationSymbolOccurrence(e[0], e[1], e[2]),
  2297822566: (e) => new f.IfcAnnotationTextOccurrence(e[0], e[1], e[2]),
  3798115385: (e) => new f.IfcArbitraryClosedProfileDef(e[0], e[1], e[2]),
  1310608509: (e) => new f.IfcArbitraryOpenProfileDef(e[0], e[1], e[2]),
  2705031697: (e) => new f.IfcArbitraryProfileDefWithVoids(e[0], e[1], e[2], e[3]),
  616511568: (e) => new f.IfcBlobTexture(e[0], e[1], e[2], e[3], e[4], e[5]),
  3150382593: (e) => new f.IfcCenterLineProfileDef(e[0], e[1], e[2], e[3]),
  647927063: (e) => new f.IfcClassificationReference(e[0], e[1], e[2], e[3]),
  776857604: (e) => new f.IfcColourRgb(e[0], e[1], e[2], e[3]),
  2542286263: (e) => new f.IfcComplexProperty(e[0], e[1], e[2], e[3]),
  1485152156: (e) => new f.IfcCompositeProfileDef(e[0], e[1], e[2], e[3]),
  370225590: (e) => new f.IfcConnectedFaceSet(e[0]),
  1981873012: (e) => new f.IfcConnectionCurveGeometry(e[0], e[1]),
  45288368: (e) => new f.IfcConnectionPointEccentricity(e[0], e[1], e[2], e[3], e[4]),
  3050246964: (e) => new f.IfcContextDependentUnit(e[0], e[1], e[2]),
  2889183280: (e) => new f.IfcConversionBasedUnit(e[0], e[1], e[2], e[3]),
  3800577675: (e) => new f.IfcCurveStyle(e[0], e[1], e[2], e[3]),
  3632507154: (e) => new f.IfcDerivedProfileDef(e[0], e[1], e[2], e[3], e[4]),
  2273265877: (e) => new f.IfcDimensionCalloutRelationship(e[0], e[1], e[2], e[3]),
  1694125774: (e) => new f.IfcDimensionPair(e[0], e[1], e[2], e[3]),
  3732053477: (e) => new f.IfcDocumentReference(e[0], e[1], e[2]),
  4170525392: (e) => new f.IfcDraughtingPreDefinedTextFont(e[0]),
  3900360178: (e) => new f.IfcEdge(e[0], e[1]),
  476780140: (e) => new f.IfcEdgeCurve(e[0], e[1], e[2], e[3]),
  1860660968: (e) => new f.IfcExtendedMaterialProperties(e[0], e[1], e[2], e[3]),
  2556980723: (e) => new f.IfcFace(e[0]),
  1809719519: (e) => new f.IfcFaceBound(e[0], e[1]),
  803316827: (e) => new f.IfcFaceOuterBound(e[0], e[1]),
  3008276851: (e) => new f.IfcFaceSurface(e[0], e[1], e[2]),
  4219587988: (e) => new f.IfcFailureConnectionCondition(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  738692330: (e) => new f.IfcFillAreaStyle(e[0], e[1]),
  3857492461: (e) => new f.IfcFuelProperties(e[0], e[1], e[2], e[3], e[4]),
  803998398: (e) => new f.IfcGeneralMaterialProperties(e[0], e[1], e[2], e[3]),
  1446786286: (e) => new f.IfcGeneralProfileProperties(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3448662350: (e) => new f.IfcGeometricRepresentationContext(e[0], e[1], e[2], e[3], e[4], e[5]),
  2453401579: (e) => new f.IfcGeometricRepresentationItem(),
  4142052618: (e) => new f.IfcGeometricRepresentationSubContext(e[0], e[1], e[2], e[3], e[4], e[5]),
  3590301190: (e) => new f.IfcGeometricSet(e[0]),
  178086475: (e) => new f.IfcGridPlacement(e[0], e[1]),
  812098782: (e) => new f.IfcHalfSpaceSolid(e[0], e[1]),
  2445078500: (e) => new f.IfcHygroscopicMaterialProperties(e[0], e[1], e[2], e[3], e[4], e[5]),
  3905492369: (e) => new f.IfcImageTexture(e[0], e[1], e[2], e[3], e[4]),
  3741457305: (e) => new f.IfcIrregularTimeSeries(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1402838566: (e) => new f.IfcLightSource(e[0], e[1], e[2], e[3]),
  125510826: (e) => new f.IfcLightSourceAmbient(e[0], e[1], e[2], e[3]),
  2604431987: (e) => new f.IfcLightSourceDirectional(e[0], e[1], e[2], e[3], e[4]),
  4266656042: (e) => new f.IfcLightSourceGoniometric(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1520743889: (e) => new f.IfcLightSourcePositional(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3422422726: (e) => new f.IfcLightSourceSpot(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  2624227202: (e) => new f.IfcLocalPlacement(e[0], e[1]),
  1008929658: (e) => new f.IfcLoop(),
  2347385850: (e) => new f.IfcMappedItem(e[0], e[1]),
  2022407955: (e) => new f.IfcMaterialDefinitionRepresentation(e[0], e[1], e[2], e[3]),
  1430189142: (e) => new f.IfcMechanicalConcreteMaterialProperties(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  219451334: (e) => new f.IfcObjectDefinition(e[0], e[1], e[2], e[3]),
  2833995503: (e) => new f.IfcOneDirectionRepeatFactor(e[0]),
  2665983363: (e) => new f.IfcOpenShell(e[0]),
  1029017970: (e) => new f.IfcOrientedEdge(e[0], e[1]),
  2529465313: (e) => new f.IfcParameterizedProfileDef(e[0], e[1], e[2]),
  2519244187: (e) => new f.IfcPath(e[0]),
  3021840470: (e) => new f.IfcPhysicalComplexQuantity(e[0], e[1], e[2], e[3], e[4], e[5]),
  597895409: (e) => new f.IfcPixelTexture(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2004835150: (e) => new f.IfcPlacement(e[0]),
  1663979128: (e) => new f.IfcPlanarExtent(e[0], e[1]),
  2067069095: (e) => new f.IfcPoint(),
  4022376103: (e) => new f.IfcPointOnCurve(e[0], e[1]),
  1423911732: (e) => new f.IfcPointOnSurface(e[0], e[1], e[2]),
  2924175390: (e) => new f.IfcPolyLoop(e[0]),
  2775532180: (e) => new f.IfcPolygonalBoundedHalfSpace(e[0], e[1], e[2], e[3]),
  759155922: (e) => new f.IfcPreDefinedColour(e[0]),
  2559016684: (e) => new f.IfcPreDefinedCurveFont(e[0]),
  433424934: (e) => new f.IfcPreDefinedDimensionSymbol(e[0]),
  179317114: (e) => new f.IfcPreDefinedPointMarkerSymbol(e[0]),
  673634403: (e) => new f.IfcProductDefinitionShape(e[0], e[1], e[2]),
  871118103: (e) => new f.IfcPropertyBoundedValue(e[0], e[1], e[2], e[3], e[4]),
  1680319473: (e) => new f.IfcPropertyDefinition(e[0], e[1], e[2], e[3]),
  4166981789: (e) => new f.IfcPropertyEnumeratedValue(e[0], e[1], e[2], e[3]),
  2752243245: (e) => new f.IfcPropertyListValue(e[0], e[1], e[2], e[3]),
  941946838: (e) => new f.IfcPropertyReferenceValue(e[0], e[1], e[2], e[3]),
  3357820518: (e) => new f.IfcPropertySetDefinition(e[0], e[1], e[2], e[3]),
  3650150729: (e) => new f.IfcPropertySingleValue(e[0], e[1], e[2], e[3]),
  110355661: (e) => new f.IfcPropertyTableValue(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3615266464: (e) => new f.IfcRectangleProfileDef(e[0], e[1], e[2], e[3], e[4]),
  3413951693: (e) => new f.IfcRegularTimeSeries(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3765753017: (e) => new f.IfcReinforcementDefinitionProperties(e[0], e[1], e[2], e[3], e[4], e[5]),
  478536968: (e) => new f.IfcRelationship(e[0], e[1], e[2], e[3]),
  2778083089: (e) => new f.IfcRoundedRectangleProfileDef(e[0], e[1], e[2], e[3], e[4], e[5]),
  1509187699: (e) => new f.IfcSectionedSpine(e[0], e[1], e[2]),
  2411513650: (e) => new f.IfcServiceLifeFactor(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  4124623270: (e) => new f.IfcShellBasedSurfaceModel(e[0]),
  2609359061: (e) => new f.IfcSlippageConnectionCondition(e[0], e[1], e[2], e[3]),
  723233188: (e) => new f.IfcSolidModel(),
  2485662743: (e) => new f.IfcSoundProperties(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1202362311: (e) => new f.IfcSoundValue(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  390701378: (e) => new f.IfcSpaceThermalLoadProperties(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13]),
  1595516126: (e) => new f.IfcStructuralLoadLinearForce(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2668620305: (e) => new f.IfcStructuralLoadPlanarForce(e[0], e[1], e[2], e[3]),
  2473145415: (e) => new f.IfcStructuralLoadSingleDisplacement(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1973038258: (e) => new f.IfcStructuralLoadSingleDisplacementDistortion(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1597423693: (e) => new f.IfcStructuralLoadSingleForce(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1190533807: (e) => new f.IfcStructuralLoadSingleForceWarping(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3843319758: (e) => new f.IfcStructuralProfileProperties(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], e[17], e[18], e[19], e[20], e[21], e[22]),
  3653947884: (e) => new f.IfcStructuralSteelProfileProperties(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], e[17], e[18], e[19], e[20], e[21], e[22], e[23], e[24], e[25], e[26]),
  2233826070: (e) => new f.IfcSubedge(e[0], e[1], e[2]),
  2513912981: (e) => new f.IfcSurface(),
  1878645084: (e) => new f.IfcSurfaceStyleRendering(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2247615214: (e) => new f.IfcSweptAreaSolid(e[0], e[1]),
  1260650574: (e) => new f.IfcSweptDiskSolid(e[0], e[1], e[2], e[3], e[4]),
  230924584: (e) => new f.IfcSweptSurface(e[0], e[1]),
  3071757647: (e) => new f.IfcTShapeProfileDef(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  3028897424: (e) => new f.IfcTerminatorSymbol(e[0], e[1], e[2], e[3]),
  4282788508: (e) => new f.IfcTextLiteral(e[0], e[1], e[2]),
  3124975700: (e) => new f.IfcTextLiteralWithExtent(e[0], e[1], e[2], e[3], e[4]),
  2715220739: (e) => new f.IfcTrapeziumProfileDef(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1345879162: (e) => new f.IfcTwoDirectionRepeatFactor(e[0], e[1]),
  1628702193: (e) => new f.IfcTypeObject(e[0], e[1], e[2], e[3], e[4], e[5]),
  2347495698: (e) => new f.IfcTypeProduct(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  427810014: (e) => new f.IfcUShapeProfileDef(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1417489154: (e) => new f.IfcVector(e[0], e[1]),
  2759199220: (e) => new f.IfcVertexLoop(e[0]),
  336235671: (e) => new f.IfcWindowLiningProperties(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  512836454: (e) => new f.IfcWindowPanelProperties(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1299126871: (e) => new f.IfcWindowStyle(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  2543172580: (e) => new f.IfcZShapeProfileDef(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3288037868: (e) => new f.IfcAnnotationCurveOccurrence(e[0], e[1], e[2]),
  669184980: (e) => new f.IfcAnnotationFillArea(e[0], e[1]),
  2265737646: (e) => new f.IfcAnnotationFillAreaOccurrence(e[0], e[1], e[2], e[3], e[4]),
  1302238472: (e) => new f.IfcAnnotationSurface(e[0], e[1]),
  4261334040: (e) => new f.IfcAxis1Placement(e[0], e[1]),
  3125803723: (e) => new f.IfcAxis2Placement2D(e[0], e[1]),
  2740243338: (e) => new f.IfcAxis2Placement3D(e[0], e[1], e[2]),
  2736907675: (e) => new f.IfcBooleanResult(e[0], e[1], e[2]),
  4182860854: (e) => new f.IfcBoundedSurface(),
  2581212453: (e) => new f.IfcBoundingBox(e[0], e[1], e[2], e[3]),
  2713105998: (e) => new f.IfcBoxedHalfSpace(e[0], e[1], e[2]),
  2898889636: (e) => new f.IfcCShapeProfileDef(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1123145078: (e) => new f.IfcCartesianPoint(e[0]),
  59481748: (e) => new f.IfcCartesianTransformationOperator(e[0], e[1], e[2], e[3]),
  3749851601: (e) => new f.IfcCartesianTransformationOperator2D(e[0], e[1], e[2], e[3]),
  3486308946: (e) => new f.IfcCartesianTransformationOperator2DnonUniform(e[0], e[1], e[2], e[3], e[4]),
  3331915920: (e) => new f.IfcCartesianTransformationOperator3D(e[0], e[1], e[2], e[3], e[4]),
  1416205885: (e) => new f.IfcCartesianTransformationOperator3DnonUniform(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1383045692: (e) => new f.IfcCircleProfileDef(e[0], e[1], e[2], e[3]),
  2205249479: (e) => new f.IfcClosedShell(e[0]),
  2485617015: (e) => new f.IfcCompositeCurveSegment(e[0], e[1], e[2]),
  4133800736: (e) => new f.IfcCraneRailAShapeProfileDef(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14]),
  194851669: (e) => new f.IfcCraneRailFShapeProfileDef(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  2506170314: (e) => new f.IfcCsgPrimitive3D(e[0]),
  2147822146: (e) => new f.IfcCsgSolid(e[0]),
  2601014836: (e) => new f.IfcCurve(),
  2827736869: (e) => new f.IfcCurveBoundedPlane(e[0], e[1], e[2]),
  693772133: (e) => new f.IfcDefinedSymbol(e[0], e[1]),
  606661476: (e) => new f.IfcDimensionCurve(e[0], e[1], e[2]),
  4054601972: (e) => new f.IfcDimensionCurveTerminator(e[0], e[1], e[2], e[3], e[4]),
  32440307: (e) => new f.IfcDirection(e[0]),
  2963535650: (e) => new f.IfcDoorLiningProperties(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14]),
  1714330368: (e) => new f.IfcDoorPanelProperties(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  526551008: (e) => new f.IfcDoorStyle(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  3073041342: (e) => new f.IfcDraughtingCallout(e[0]),
  445594917: (e) => new f.IfcDraughtingPreDefinedColour(e[0]),
  4006246654: (e) => new f.IfcDraughtingPreDefinedCurveFont(e[0]),
  1472233963: (e) => new f.IfcEdgeLoop(e[0]),
  1883228015: (e) => new f.IfcElementQuantity(e[0], e[1], e[2], e[3], e[4], e[5]),
  339256511: (e) => new f.IfcElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2777663545: (e) => new f.IfcElementarySurface(e[0]),
  2835456948: (e) => new f.IfcEllipseProfileDef(e[0], e[1], e[2], e[3], e[4]),
  80994333: (e) => new f.IfcEnergyProperties(e[0], e[1], e[2], e[3], e[4], e[5]),
  477187591: (e) => new f.IfcExtrudedAreaSolid(e[0], e[1], e[2], e[3]),
  2047409740: (e) => new f.IfcFaceBasedSurfaceModel(e[0]),
  374418227: (e) => new f.IfcFillAreaStyleHatching(e[0], e[1], e[2], e[3], e[4]),
  4203026998: (e) => new f.IfcFillAreaStyleTileSymbolWithStyle(e[0]),
  315944413: (e) => new f.IfcFillAreaStyleTiles(e[0], e[1], e[2]),
  3455213021: (e) => new f.IfcFluidFlowProperties(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], e[17], e[18]),
  4238390223: (e) => new f.IfcFurnishingElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1268542332: (e) => new f.IfcFurnitureType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  987898635: (e) => new f.IfcGeometricCurveSet(e[0]),
  1484403080: (e) => new f.IfcIShapeProfileDef(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  572779678: (e) => new f.IfcLShapeProfileDef(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1281925730: (e) => new f.IfcLine(e[0], e[1]),
  1425443689: (e) => new f.IfcManifoldSolidBrep(e[0]),
  3888040117: (e) => new f.IfcObject(e[0], e[1], e[2], e[3], e[4]),
  3388369263: (e) => new f.IfcOffsetCurve2D(e[0], e[1], e[2]),
  3505215534: (e) => new f.IfcOffsetCurve3D(e[0], e[1], e[2], e[3]),
  3566463478: (e) => new f.IfcPermeableCoveringProperties(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  603570806: (e) => new f.IfcPlanarBox(e[0], e[1], e[2]),
  220341763: (e) => new f.IfcPlane(e[0]),
  2945172077: (e) => new f.IfcProcess(e[0], e[1], e[2], e[3], e[4]),
  4208778838: (e) => new f.IfcProduct(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  103090709: (e) => new f.IfcProject(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4194566429: (e) => new f.IfcProjectionCurve(e[0], e[1], e[2]),
  1451395588: (e) => new f.IfcPropertySet(e[0], e[1], e[2], e[3], e[4]),
  3219374653: (e) => new f.IfcProxy(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2770003689: (e) => new f.IfcRectangleHollowProfileDef(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2798486643: (e) => new f.IfcRectangularPyramid(e[0], e[1], e[2], e[3]),
  3454111270: (e) => new f.IfcRectangularTrimmedSurface(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3939117080: (e) => new f.IfcRelAssigns(e[0], e[1], e[2], e[3], e[4], e[5]),
  1683148259: (e) => new f.IfcRelAssignsToActor(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2495723537: (e) => new f.IfcRelAssignsToControl(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1307041759: (e) => new f.IfcRelAssignsToGroup(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  4278684876: (e) => new f.IfcRelAssignsToProcess(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2857406711: (e) => new f.IfcRelAssignsToProduct(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3372526763: (e) => new f.IfcRelAssignsToProjectOrder(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  205026976: (e) => new f.IfcRelAssignsToResource(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1865459582: (e) => new f.IfcRelAssociates(e[0], e[1], e[2], e[3], e[4]),
  1327628568: (e) => new f.IfcRelAssociatesAppliedValue(e[0], e[1], e[2], e[3], e[4], e[5]),
  4095574036: (e) => new f.IfcRelAssociatesApproval(e[0], e[1], e[2], e[3], e[4], e[5]),
  919958153: (e) => new f.IfcRelAssociatesClassification(e[0], e[1], e[2], e[3], e[4], e[5]),
  2728634034: (e) => new f.IfcRelAssociatesConstraint(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  982818633: (e) => new f.IfcRelAssociatesDocument(e[0], e[1], e[2], e[3], e[4], e[5]),
  3840914261: (e) => new f.IfcRelAssociatesLibrary(e[0], e[1], e[2], e[3], e[4], e[5]),
  2655215786: (e) => new f.IfcRelAssociatesMaterial(e[0], e[1], e[2], e[3], e[4], e[5]),
  2851387026: (e) => new f.IfcRelAssociatesProfileProperties(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  826625072: (e) => new f.IfcRelConnects(e[0], e[1], e[2], e[3]),
  1204542856: (e) => new f.IfcRelConnectsElements(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3945020480: (e) => new f.IfcRelConnectsPathElements(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  4201705270: (e) => new f.IfcRelConnectsPortToElement(e[0], e[1], e[2], e[3], e[4], e[5]),
  3190031847: (e) => new f.IfcRelConnectsPorts(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2127690289: (e) => new f.IfcRelConnectsStructuralActivity(e[0], e[1], e[2], e[3], e[4], e[5]),
  3912681535: (e) => new f.IfcRelConnectsStructuralElement(e[0], e[1], e[2], e[3], e[4], e[5]),
  1638771189: (e) => new f.IfcRelConnectsStructuralMember(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  504942748: (e) => new f.IfcRelConnectsWithEccentricity(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  3678494232: (e) => new f.IfcRelConnectsWithRealizingElements(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3242617779: (e) => new f.IfcRelContainedInSpatialStructure(e[0], e[1], e[2], e[3], e[4], e[5]),
  886880790: (e) => new f.IfcRelCoversBldgElements(e[0], e[1], e[2], e[3], e[4], e[5]),
  2802773753: (e) => new f.IfcRelCoversSpaces(e[0], e[1], e[2], e[3], e[4], e[5]),
  2551354335: (e) => new f.IfcRelDecomposes(e[0], e[1], e[2], e[3], e[4], e[5]),
  693640335: (e) => new f.IfcRelDefines(e[0], e[1], e[2], e[3], e[4]),
  4186316022: (e) => new f.IfcRelDefinesByProperties(e[0], e[1], e[2], e[3], e[4], e[5]),
  781010003: (e) => new f.IfcRelDefinesByType(e[0], e[1], e[2], e[3], e[4], e[5]),
  3940055652: (e) => new f.IfcRelFillsElement(e[0], e[1], e[2], e[3], e[4], e[5]),
  279856033: (e) => new f.IfcRelFlowControlElements(e[0], e[1], e[2], e[3], e[4], e[5]),
  4189434867: (e) => new f.IfcRelInteractionRequirements(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3268803585: (e) => new f.IfcRelNests(e[0], e[1], e[2], e[3], e[4], e[5]),
  2051452291: (e) => new f.IfcRelOccupiesSpaces(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  202636808: (e) => new f.IfcRelOverridesProperties(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  750771296: (e) => new f.IfcRelProjectsElement(e[0], e[1], e[2], e[3], e[4], e[5]),
  1245217292: (e) => new f.IfcRelReferencedInSpatialStructure(e[0], e[1], e[2], e[3], e[4], e[5]),
  1058617721: (e) => new f.IfcRelSchedulesCostItems(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  4122056220: (e) => new f.IfcRelSequence(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  366585022: (e) => new f.IfcRelServicesBuildings(e[0], e[1], e[2], e[3], e[4], e[5]),
  3451746338: (e) => new f.IfcRelSpaceBoundary(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1401173127: (e) => new f.IfcRelVoidsElement(e[0], e[1], e[2], e[3], e[4], e[5]),
  2914609552: (e) => new f.IfcResource(e[0], e[1], e[2], e[3], e[4]),
  1856042241: (e) => new f.IfcRevolvedAreaSolid(e[0], e[1], e[2], e[3]),
  4158566097: (e) => new f.IfcRightCircularCone(e[0], e[1], e[2]),
  3626867408: (e) => new f.IfcRightCircularCylinder(e[0], e[1], e[2]),
  2706606064: (e) => new f.IfcSpatialStructureElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3893378262: (e) => new f.IfcSpatialStructureElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  451544542: (e) => new f.IfcSphere(e[0], e[1]),
  3544373492: (e) => new f.IfcStructuralActivity(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3136571912: (e) => new f.IfcStructuralItem(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  530289379: (e) => new f.IfcStructuralMember(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3689010777: (e) => new f.IfcStructuralReaction(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3979015343: (e) => new f.IfcStructuralSurfaceMember(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2218152070: (e) => new f.IfcStructuralSurfaceMemberVarying(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  4070609034: (e) => new f.IfcStructuredDimensionCallout(e[0]),
  2028607225: (e) => new f.IfcSurfaceCurveSweptAreaSolid(e[0], e[1], e[2], e[3], e[4], e[5]),
  2809605785: (e) => new f.IfcSurfaceOfLinearExtrusion(e[0], e[1], e[2], e[3]),
  4124788165: (e) => new f.IfcSurfaceOfRevolution(e[0], e[1], e[2]),
  1580310250: (e) => new f.IfcSystemFurnitureElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3473067441: (e) => new f.IfcTask(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2097647324: (e) => new f.IfcTransportElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2296667514: (e) => new f.IfcActor(e[0], e[1], e[2], e[3], e[4], e[5]),
  1674181508: (e) => new f.IfcAnnotation(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3207858831: (e) => new f.IfcAsymmetricIShapeProfileDef(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1334484129: (e) => new f.IfcBlock(e[0], e[1], e[2], e[3]),
  3649129432: (e) => new f.IfcBooleanClippingResult(e[0], e[1], e[2]),
  1260505505: (e) => new f.IfcBoundedCurve(),
  4031249490: (e) => new f.IfcBuilding(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1950629157: (e) => new f.IfcBuildingElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3124254112: (e) => new f.IfcBuildingStorey(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2937912522: (e) => new f.IfcCircleHollowProfileDef(e[0], e[1], e[2], e[3], e[4]),
  300633059: (e) => new f.IfcColumnType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3732776249: (e) => new f.IfcCompositeCurve(e[0], e[1]),
  2510884976: (e) => new f.IfcConic(e[0]),
  2559216714: (e) => new f.IfcConstructionResource(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3293443760: (e) => new f.IfcControl(e[0], e[1], e[2], e[3], e[4]),
  3895139033: (e) => new f.IfcCostItem(e[0], e[1], e[2], e[3], e[4]),
  1419761937: (e) => new f.IfcCostSchedule(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  1916426348: (e) => new f.IfcCoveringType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3295246426: (e) => new f.IfcCrewResource(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1457835157: (e) => new f.IfcCurtainWallType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  681481545: (e) => new f.IfcDimensionCurveDirectedCallout(e[0]),
  3256556792: (e) => new f.IfcDistributionElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3849074793: (e) => new f.IfcDistributionFlowElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  360485395: (e) => new f.IfcElectricalBaseProperties(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13]),
  1758889154: (e) => new f.IfcElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  4123344466: (e) => new f.IfcElementAssembly(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1623761950: (e) => new f.IfcElementComponent(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2590856083: (e) => new f.IfcElementComponentType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1704287377: (e) => new f.IfcEllipse(e[0], e[1], e[2]),
  2107101300: (e) => new f.IfcEnergyConversionDeviceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1962604670: (e) => new f.IfcEquipmentElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3272907226: (e) => new f.IfcEquipmentStandard(e[0], e[1], e[2], e[3], e[4]),
  3174744832: (e) => new f.IfcEvaporativeCoolerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3390157468: (e) => new f.IfcEvaporatorType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  807026263: (e) => new f.IfcFacetedBrep(e[0]),
  3737207727: (e) => new f.IfcFacetedBrepWithVoids(e[0], e[1]),
  647756555: (e) => new f.IfcFastener(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2489546625: (e) => new f.IfcFastenerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2827207264: (e) => new f.IfcFeatureElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2143335405: (e) => new f.IfcFeatureElementAddition(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1287392070: (e) => new f.IfcFeatureElementSubtraction(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3907093117: (e) => new f.IfcFlowControllerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3198132628: (e) => new f.IfcFlowFittingType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3815607619: (e) => new f.IfcFlowMeterType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1482959167: (e) => new f.IfcFlowMovingDeviceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1834744321: (e) => new f.IfcFlowSegmentType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1339347760: (e) => new f.IfcFlowStorageDeviceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2297155007: (e) => new f.IfcFlowTerminalType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3009222698: (e) => new f.IfcFlowTreatmentDeviceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  263784265: (e) => new f.IfcFurnishingElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  814719939: (e) => new f.IfcFurnitureStandard(e[0], e[1], e[2], e[3], e[4]),
  200128114: (e) => new f.IfcGasTerminalType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3009204131: (e) => new f.IfcGrid(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2706460486: (e) => new f.IfcGroup(e[0], e[1], e[2], e[3], e[4]),
  1251058090: (e) => new f.IfcHeatExchangerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1806887404: (e) => new f.IfcHumidifierType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2391368822: (e) => new f.IfcInventory(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  4288270099: (e) => new f.IfcJunctionBoxType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3827777499: (e) => new f.IfcLaborResource(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1051575348: (e) => new f.IfcLampType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1161773419: (e) => new f.IfcLightFixtureType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2506943328: (e) => new f.IfcLinearDimension(e[0]),
  377706215: (e) => new f.IfcMechanicalFastener(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2108223431: (e) => new f.IfcMechanicalFastenerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3181161470: (e) => new f.IfcMemberType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  977012517: (e) => new f.IfcMotorConnectionType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1916936684: (e) => new f.IfcMove(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  4143007308: (e) => new f.IfcOccupant(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3588315303: (e) => new f.IfcOpeningElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3425660407: (e) => new f.IfcOrderAction(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  2837617999: (e) => new f.IfcOutletType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2382730787: (e) => new f.IfcPerformanceHistory(e[0], e[1], e[2], e[3], e[4], e[5]),
  3327091369: (e) => new f.IfcPermit(e[0], e[1], e[2], e[3], e[4], e[5]),
  804291784: (e) => new f.IfcPipeFittingType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4231323485: (e) => new f.IfcPipeSegmentType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4017108033: (e) => new f.IfcPlateType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3724593414: (e) => new f.IfcPolyline(e[0]),
  3740093272: (e) => new f.IfcPort(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2744685151: (e) => new f.IfcProcedure(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2904328755: (e) => new f.IfcProjectOrder(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3642467123: (e) => new f.IfcProjectOrderRecord(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3651124850: (e) => new f.IfcProjectionElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1842657554: (e) => new f.IfcProtectiveDeviceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2250791053: (e) => new f.IfcPumpType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3248260540: (e) => new f.IfcRadiusDimension(e[0]),
  2893384427: (e) => new f.IfcRailingType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2324767716: (e) => new f.IfcRampFlightType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  160246688: (e) => new f.IfcRelAggregates(e[0], e[1], e[2], e[3], e[4], e[5]),
  2863920197: (e) => new f.IfcRelAssignsTasks(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1768891740: (e) => new f.IfcSanitaryTerminalType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3517283431: (e) => new f.IfcScheduleTimeControl(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], e[17], e[18], e[19], e[20], e[21], e[22]),
  4105383287: (e) => new f.IfcServiceLife(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  4097777520: (e) => new f.IfcSite(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13]),
  2533589738: (e) => new f.IfcSlabType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3856911033: (e) => new f.IfcSpace(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1305183839: (e) => new f.IfcSpaceHeaterType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  652456506: (e) => new f.IfcSpaceProgram(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3812236995: (e) => new f.IfcSpaceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3112655638: (e) => new f.IfcStackTerminalType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1039846685: (e) => new f.IfcStairFlightType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  682877961: (e) => new f.IfcStructuralAction(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1179482911: (e) => new f.IfcStructuralConnection(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  4243806635: (e) => new f.IfcStructuralCurveConnection(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  214636428: (e) => new f.IfcStructuralCurveMember(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2445595289: (e) => new f.IfcStructuralCurveMemberVarying(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1807405624: (e) => new f.IfcStructuralLinearAction(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1721250024: (e) => new f.IfcStructuralLinearActionVarying(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13]),
  1252848954: (e) => new f.IfcStructuralLoadGroup(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1621171031: (e) => new f.IfcStructuralPlanarAction(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  3987759626: (e) => new f.IfcStructuralPlanarActionVarying(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13]),
  2082059205: (e) => new f.IfcStructuralPointAction(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  734778138: (e) => new f.IfcStructuralPointConnection(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1235345126: (e) => new f.IfcStructuralPointReaction(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2986769608: (e) => new f.IfcStructuralResultGroup(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1975003073: (e) => new f.IfcStructuralSurfaceConnection(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  148013059: (e) => new f.IfcSubContractResource(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  2315554128: (e) => new f.IfcSwitchingDeviceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2254336722: (e) => new f.IfcSystem(e[0], e[1], e[2], e[3], e[4]),
  5716631: (e) => new f.IfcTankType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1637806684: (e) => new f.IfcTimeSeriesSchedule(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1692211062: (e) => new f.IfcTransformerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1620046519: (e) => new f.IfcTransportElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  3593883385: (e) => new f.IfcTrimmedCurve(e[0], e[1], e[2], e[3], e[4]),
  1600972822: (e) => new f.IfcTubeBundleType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1911125066: (e) => new f.IfcUnitaryEquipmentType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  728799441: (e) => new f.IfcValveType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2769231204: (e) => new f.IfcVirtualElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1898987631: (e) => new f.IfcWallType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1133259667: (e) => new f.IfcWasteTerminalType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1028945134: (e) => new f.IfcWorkControl(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14]),
  4218914973: (e) => new f.IfcWorkPlan(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14]),
  3342526732: (e) => new f.IfcWorkSchedule(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14]),
  1033361043: (e) => new f.IfcZone(e[0], e[1], e[2], e[3], e[4]),
  1213861670: (e) => new f.Ifc2DCompositeCurve(e[0], e[1]),
  3821786052: (e) => new f.IfcActionRequest(e[0], e[1], e[2], e[3], e[4], e[5]),
  1411407467: (e) => new f.IfcAirTerminalBoxType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3352864051: (e) => new f.IfcAirTerminalType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1871374353: (e) => new f.IfcAirToAirHeatRecoveryType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2470393545: (e) => new f.IfcAngularDimension(e[0]),
  3460190687: (e) => new f.IfcAsset(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13]),
  1967976161: (e) => new f.IfcBSplineCurve(e[0], e[1], e[2], e[3], e[4]),
  819618141: (e) => new f.IfcBeamType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1916977116: (e) => new f.IfcBezierCurve(e[0], e[1], e[2], e[3], e[4]),
  231477066: (e) => new f.IfcBoilerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3299480353: (e) => new f.IfcBuildingElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  52481810: (e) => new f.IfcBuildingElementComponent(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2979338954: (e) => new f.IfcBuildingElementPart(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1095909175: (e) => new f.IfcBuildingElementProxy(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1909888760: (e) => new f.IfcBuildingElementProxyType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  395041908: (e) => new f.IfcCableCarrierFittingType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3293546465: (e) => new f.IfcCableCarrierSegmentType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1285652485: (e) => new f.IfcCableSegmentType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2951183804: (e) => new f.IfcChillerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2611217952: (e) => new f.IfcCircle(e[0], e[1]),
  2301859152: (e) => new f.IfcCoilType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  843113511: (e) => new f.IfcColumn(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3850581409: (e) => new f.IfcCompressorType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2816379211: (e) => new f.IfcCondenserType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2188551683: (e) => new f.IfcCondition(e[0], e[1], e[2], e[3], e[4]),
  1163958913: (e) => new f.IfcConditionCriterion(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3898045240: (e) => new f.IfcConstructionEquipmentResource(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1060000209: (e) => new f.IfcConstructionMaterialResource(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  488727124: (e) => new f.IfcConstructionProductResource(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  335055490: (e) => new f.IfcCooledBeamType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2954562838: (e) => new f.IfcCoolingTowerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1973544240: (e) => new f.IfcCovering(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3495092785: (e) => new f.IfcCurtainWall(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3961806047: (e) => new f.IfcDamperType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4147604152: (e) => new f.IfcDiameterDimension(e[0]),
  1335981549: (e) => new f.IfcDiscreteAccessory(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2635815018: (e) => new f.IfcDiscreteAccessoryType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1599208980: (e) => new f.IfcDistributionChamberElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2063403501: (e) => new f.IfcDistributionControlElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1945004755: (e) => new f.IfcDistributionElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3040386961: (e) => new f.IfcDistributionFlowElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3041715199: (e) => new f.IfcDistributionPort(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  395920057: (e) => new f.IfcDoor(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  869906466: (e) => new f.IfcDuctFittingType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3760055223: (e) => new f.IfcDuctSegmentType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2030761528: (e) => new f.IfcDuctSilencerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  855621170: (e) => new f.IfcEdgeFeature(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  663422040: (e) => new f.IfcElectricApplianceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3277789161: (e) => new f.IfcElectricFlowStorageDeviceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1534661035: (e) => new f.IfcElectricGeneratorType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1365060375: (e) => new f.IfcElectricHeaterType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1217240411: (e) => new f.IfcElectricMotorType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  712377611: (e) => new f.IfcElectricTimeControlType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1634875225: (e) => new f.IfcElectricalCircuit(e[0], e[1], e[2], e[3], e[4]),
  857184966: (e) => new f.IfcElectricalElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1658829314: (e) => new f.IfcEnergyConversionDevice(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  346874300: (e) => new f.IfcFanType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1810631287: (e) => new f.IfcFilterType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4222183408: (e) => new f.IfcFireSuppressionTerminalType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2058353004: (e) => new f.IfcFlowController(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  4278956645: (e) => new f.IfcFlowFitting(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  4037862832: (e) => new f.IfcFlowInstrumentType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3132237377: (e) => new f.IfcFlowMovingDevice(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  987401354: (e) => new f.IfcFlowSegment(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  707683696: (e) => new f.IfcFlowStorageDevice(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2223149337: (e) => new f.IfcFlowTerminal(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3508470533: (e) => new f.IfcFlowTreatmentDevice(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  900683007: (e) => new f.IfcFooting(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1073191201: (e) => new f.IfcMember(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1687234759: (e) => new f.IfcPile(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3171933400: (e) => new f.IfcPlate(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2262370178: (e) => new f.IfcRailing(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3024970846: (e) => new f.IfcRamp(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3283111854: (e) => new f.IfcRampFlight(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3055160366: (e) => new f.IfcRationalBezierCurve(e[0], e[1], e[2], e[3], e[4], e[5]),
  3027567501: (e) => new f.IfcReinforcingElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2320036040: (e) => new f.IfcReinforcingMesh(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16]),
  2016517767: (e) => new f.IfcRoof(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1376911519: (e) => new f.IfcRoundedEdgeFeature(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1783015770: (e) => new f.IfcSensorType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1529196076: (e) => new f.IfcSlab(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  331165859: (e) => new f.IfcStair(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4252922144: (e) => new f.IfcStairFlight(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  2515109513: (e) => new f.IfcStructuralAnalysisModel(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3824725483: (e) => new f.IfcTendon(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16]),
  2347447852: (e) => new f.IfcTendonAnchor(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3313531582: (e) => new f.IfcVibrationIsolatorType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2391406946: (e) => new f.IfcWall(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3512223829: (e) => new f.IfcWallStandardCase(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3304561284: (e) => new f.IfcWindow(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2874132201: (e) => new f.IfcActuatorType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3001207471: (e) => new f.IfcAlarmType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  753842376: (e) => new f.IfcBeam(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2454782716: (e) => new f.IfcChamferEdgeFeature(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  578613899: (e) => new f.IfcControllerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1052013943: (e) => new f.IfcDistributionChamberElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1062813311: (e) => new f.IfcDistributionControlElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3700593921: (e) => new f.IfcElectricDistributionPoint(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  979691226: (e) => new f.IfcReinforcingBar(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13])
};
Pie[1] = {
  3630933823: (e) => [e.Role, e.UserDefinedRole, e.Description],
  618182010: (e) => [e.Purpose, e.Description, e.UserDefinedPurpose],
  639542469: (e) => [e.ApplicationDeveloper, e.Version, e.ApplicationFullName, e.ApplicationIdentifier],
  411424972: (e) => [e.Name, e.Description, ke(e.AppliedValue), e.UnitBasis, ke(e.ApplicableDate), ke(e.FixedUntilDate)],
  1110488051: (e) => [e.ComponentOfTotal, e.Components, e.ArithmeticOperator, e.Name, e.Description],
  130549933: (e) => [e.Description, ke(e.ApprovalDateTime), e.ApprovalStatus, e.ApprovalLevel, e.ApprovalQualifier, e.Name, e.Identifier],
  2080292479: (e) => [ke(e.Actor), e.Approval, e.Role],
  390851274: (e) => [e.ApprovedProperties, e.Approval],
  3869604511: (e) => [e.RelatedApproval, e.RelatingApproval, e.Description, e.Name],
  4037036970: (e) => [e.Name],
  1560379544: (e) => [e.Name, e.LinearStiffnessByLengthX, e.LinearStiffnessByLengthY, e.LinearStiffnessByLengthZ, e.RotationalStiffnessByLengthX, e.RotationalStiffnessByLengthY, e.RotationalStiffnessByLengthZ],
  3367102660: (e) => [e.Name, e.LinearStiffnessByAreaX, e.LinearStiffnessByAreaY, e.LinearStiffnessByAreaZ],
  1387855156: (e) => [e.Name, e.LinearStiffnessX, e.LinearStiffnessY, e.LinearStiffnessZ, e.RotationalStiffnessX, e.RotationalStiffnessY, e.RotationalStiffnessZ],
  2069777674: (e) => [e.Name, e.LinearStiffnessX, e.LinearStiffnessY, e.LinearStiffnessZ, e.RotationalStiffnessX, e.RotationalStiffnessY, e.RotationalStiffnessZ, e.WarpingStiffness],
  622194075: (e) => [e.DayComponent, e.MonthComponent, e.YearComponent],
  747523909: (e) => [e.Source, e.Edition, e.EditionDate, e.Name],
  1767535486: (e) => [e.Notation, e.ItemOf, e.Title],
  1098599126: (e) => [e.RelatingItem, e.RelatedItems],
  938368621: (e) => [e.NotationFacets],
  3639012971: (e) => [e.NotationValue],
  3264961684: (e) => [e.Name],
  2859738748: (e) => [],
  2614616156: (e) => [ke(e.PointOnRelatingElement), ke(e.PointOnRelatedElement)],
  4257277454: (e) => [ke(e.LocationAtRelatingElement), ke(e.LocationAtRelatedElement), e.ProfileOfPort],
  2732653382: (e) => [ke(e.SurfaceOnRelatingElement), ke(e.SurfaceOnRelatedElement)],
  1959218052: (e) => [e.Name, e.Description, e.ConstraintGrade, e.ConstraintSource, ke(e.CreatingActor), ke(e.CreationTime), e.UserDefinedGrade],
  1658513725: (e) => [e.Name, e.Description, e.RelatingConstraint, e.RelatedConstraints, e.LogicalAggregator],
  613356794: (e) => [e.ClassifiedConstraint, ke(e.RelatedClassifications)],
  347226245: (e) => [e.Name, e.Description, e.RelatingConstraint, e.RelatedConstraints],
  1065062679: (e) => [e.HourOffset, e.MinuteOffset, e.Sense],
  602808272: (e) => [e.Name, e.Description, ke(e.AppliedValue), e.UnitBasis, ke(e.ApplicableDate), ke(e.FixedUntilDate), e.CostType, e.Condition],
  539742890: (e) => [e.RelatingMonetaryUnit, e.RelatedMonetaryUnit, e.ExchangeRate, e.RateDateTime, e.RateSource],
  1105321065: (e) => [e.Name, e.PatternList],
  2367409068: (e) => [e.Name, ke(e.CurveFont), e.CurveFontScaling],
  3510044353: (e) => [e.VisibleSegmentLength, e.InvisibleSegmentLength],
  1072939445: (e) => [e.DateComponent, e.TimeComponent],
  1765591967: (e) => [e.Elements, e.UnitType, e.UserDefinedType],
  1045800335: (e) => [e.Unit, e.Exponent],
  2949456006: (e) => [e.LengthExponent, e.MassExponent, e.TimeExponent, e.ElectricCurrentExponent, e.ThermodynamicTemperatureExponent, e.AmountOfSubstanceExponent, e.LuminousIntensityExponent],
  1376555844: (e) => [e.FileExtension, e.MimeContentType, e.MimeSubtype],
  1154170062: (e) => [e.DocumentId, e.Name, e.Description, e.DocumentReferences, e.Purpose, e.IntendedUse, e.Scope, e.Revision, ke(e.DocumentOwner), ke(e.Editors), e.CreationTime, e.LastRevisionTime, e.ElectronicFormat, e.ValidFrom, e.ValidUntil, e.Confidentiality, e.Status],
  770865208: (e) => [e.RelatingDocument, e.RelatedDocuments, e.RelationshipType],
  3796139169: (e) => [e.Name, e.Description, e.RelatingDraughtingCallout, e.RelatedDraughtingCallout],
  1648886627: (e) => [e.Name, e.Description, ke(e.AppliedValue), e.UnitBasis, ke(e.ApplicableDate), ke(e.FixedUntilDate), e.ImpactType, e.Category, e.UserDefinedCategory],
  3200245327: (e) => [e.Location, e.ItemReference, e.Name],
  2242383968: (e) => [e.Location, e.ItemReference, e.Name],
  1040185647: (e) => [e.Location, e.ItemReference, e.Name],
  3207319532: (e) => [e.Location, e.ItemReference, e.Name],
  3548104201: (e) => [e.Location, e.ItemReference, e.Name],
  852622518: (e) => [e.AxisTag, e.AxisCurve, { type: 3, value: e.SameSense.value }],
  3020489413: (e) => [ke(e.TimeStamp), e.ListValues.map((t) => ke(t))],
  2655187982: (e) => [e.Name, e.Version, e.Publisher, e.VersionDate, e.LibraryReference],
  3452421091: (e) => [e.Location, e.ItemReference, e.Name],
  4162380809: (e) => [e.MainPlaneAngle, e.SecondaryPlaneAngle, e.LuminousIntensity],
  1566485204: (e) => [e.LightDistributionCurve, e.DistributionData],
  30780891: (e) => [e.HourComponent, e.MinuteComponent, e.SecondComponent, e.Zone, e.DaylightSavingOffset],
  1838606355: (e) => [e.Name],
  1847130766: (e) => [ke(e.MaterialClassifications), e.ClassifiedMaterial],
  248100487: (e) => [e.Material, e.LayerThickness, e.IsVentilated == null ? null : { type: 3, value: e.IsVentilated.value }],
  3303938423: (e) => [e.MaterialLayers, e.LayerSetName],
  1303795690: (e) => [e.ForLayerSet, e.LayerSetDirection, e.DirectionSense, e.OffsetFromReferenceLine],
  2199411900: (e) => [e.Materials],
  3265635763: (e) => [e.Material],
  2597039031: (e) => [ke(e.ValueComponent), ke(e.UnitComponent)],
  4256014907: (e) => [e.Material, e.DynamicViscosity, e.YoungModulus, e.ShearModulus, e.PoissonRatio, e.ThermalExpansionCoefficient],
  677618848: (e) => [e.Material, e.DynamicViscosity, e.YoungModulus, e.ShearModulus, e.PoissonRatio, e.ThermalExpansionCoefficient, e.YieldStress, e.UltimateStress, e.UltimateStrain, e.HardeningModule, e.ProportionalStress, e.PlasticStrain, e.Relaxations],
  3368373690: (e) => [e.Name, e.Description, e.ConstraintGrade, e.ConstraintSource, ke(e.CreatingActor), ke(e.CreationTime), e.UserDefinedGrade, e.Benchmark, e.ValueSource, ke(e.DataValue)],
  2706619895: (e) => [e.Currency],
  1918398963: (e) => [e.Dimensions, e.UnitType],
  3701648758: (e) => [],
  2251480897: (e) => [e.Name, e.Description, e.ConstraintGrade, e.ConstraintSource, ke(e.CreatingActor), ke(e.CreationTime), e.UserDefinedGrade, e.BenchmarkValues, e.ResultValues, e.ObjectiveQualifier, e.UserDefinedQualifier],
  1227763645: (e) => [e.Material, e.VisibleTransmittance, e.SolarTransmittance, e.ThermalIrTransmittance, e.ThermalIrEmissivityBack, e.ThermalIrEmissivityFront, e.VisibleReflectanceBack, e.VisibleReflectanceFront, e.SolarReflectanceFront, e.SolarReflectanceBack],
  4251960020: (e) => [e.Id, e.Name, e.Description, e.Roles, e.Addresses],
  1411181986: (e) => [e.Name, e.Description, e.RelatingOrganization, e.RelatedOrganizations],
  1207048766: (e) => [e.OwningUser, e.OwningApplication, e.State, e.ChangeAction, e.LastModifiedDate, e.LastModifyingUser, e.LastModifyingApplication, e.CreationDate],
  2077209135: (e) => [e.Id, e.FamilyName, e.GivenName, e.MiddleNames, e.PrefixTitles, e.SuffixTitles, e.Roles, e.Addresses],
  101040310: (e) => [e.ThePerson, e.TheOrganization, e.Roles],
  2483315170: (e) => [e.Name, e.Description],
  2226359599: (e) => [e.Name, e.Description, e.Unit],
  3355820592: (e) => [e.Purpose, e.Description, e.UserDefinedPurpose, e.InternalLocation, e.AddressLines, e.PostalBox, e.Town, e.Region, e.PostalCode, e.Country],
  3727388367: (e) => [e.Name],
  990879717: (e) => [e.Name],
  3213052703: (e) => [e.Name],
  1775413392: (e) => [e.Name],
  2022622350: (e) => [e.Name, e.Description, ke(e.AssignedItems), e.Identifier],
  1304840413: (e) => [e.Name, e.Description, ke(e.AssignedItems), e.Identifier, e.LayerOn, e.LayerFrozen, e.LayerBlocked, ke(e.LayerStyles)],
  3119450353: (e) => [e.Name],
  2417041796: (e) => [ke(e.Styles)],
  2095639259: (e) => [e.Name, e.Description, e.Representations],
  2267347899: (e) => [e.Material, e.SpecificHeatCapacity, e.N20Content, e.COContent, e.CO2Content],
  3958567839: (e) => [e.ProfileType, e.ProfileName],
  2802850158: (e) => [e.ProfileName, e.ProfileDefinition],
  2598011224: (e) => [e.Name, e.Description],
  3896028662: (e) => [e.RelatingConstraint, e.RelatedProperties, e.Name, e.Description],
  148025276: (e) => [e.DependingProperty, e.DependantProperty, e.Name, e.Description, e.Expression],
  3710013099: (e) => [e.Name, e.EnumerationValues.map((t) => ke(t)), ke(e.Unit)],
  2044713172: (e) => [e.Name, e.Description, e.Unit, e.AreaValue],
  2093928680: (e) => [e.Name, e.Description, e.Unit, e.CountValue],
  931644368: (e) => [e.Name, e.Description, e.Unit, e.LengthValue],
  3252649465: (e) => [e.Name, e.Description, e.Unit, e.TimeValue],
  2405470396: (e) => [e.Name, e.Description, e.Unit, e.VolumeValue],
  825690147: (e) => [e.Name, e.Description, e.Unit, e.WeightValue],
  2692823254: (e) => [ke(e.ReferencedDocument), e.ReferencingValues, e.Name, e.Description],
  1580146022: (e) => [e.TotalCrossSectionArea, e.SteelGrade, e.BarSurface, e.EffectiveDepth, e.NominalBarDiameter, e.BarCount],
  1222501353: (e) => [e.RelaxationValue, e.InitialStress],
  1076942058: (e) => [e.ContextOfItems, e.RepresentationIdentifier, e.RepresentationType, e.Items],
  3377609919: (e) => [e.ContextIdentifier, e.ContextType],
  3008791417: (e) => [],
  1660063152: (e) => [ke(e.MappingOrigin), e.MappedRepresentation],
  3679540991: (e) => [e.ProfileName, e.ProfileDefinition, e.Thickness, e.RibHeight, e.RibWidth, e.RibSpacing, e.Direction],
  2341007311: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description],
  448429030: (e) => [void 0, e.UnitType, e.Prefix, e.Name],
  2042790032: (e) => [e.SectionType, e.StartProfile, e.EndProfile],
  4165799628: (e) => [e.LongitudinalStartPosition, e.LongitudinalEndPosition, e.TransversePosition, e.ReinforcementRole, e.SectionDefinition, e.CrossSectionReinforcementDefinitions],
  867548509: (e) => [e.ShapeRepresentations, e.Name, e.Description, e.ProductDefinitional, e.PartOfProductDefinitionShape],
  3982875396: (e) => [e.ContextOfItems, e.RepresentationIdentifier, e.RepresentationType, e.Items],
  4240577450: (e) => [e.ContextOfItems, e.RepresentationIdentifier, e.RepresentationType, e.Items],
  3692461612: (e) => [e.Name, e.Description],
  2273995522: (e) => [e.Name],
  2162789131: (e) => [e.Name],
  2525727697: (e) => [e.Name],
  3408363356: (e) => [e.Name, e.DeltaT_Constant, e.DeltaT_Y, e.DeltaT_Z],
  2830218821: (e) => [e.ContextOfItems, e.RepresentationIdentifier, e.RepresentationType, e.Items],
  3958052878: (e) => [e.Item, e.Styles, e.Name],
  3049322572: (e) => [e.ContextOfItems, e.RepresentationIdentifier, e.RepresentationType, e.Items],
  1300840506: (e) => [e.Name, e.Side, ke(e.Styles)],
  3303107099: (e) => [e.DiffuseTransmissionColour, e.DiffuseReflectionColour, e.TransmissionColour, e.ReflectanceColour],
  1607154358: (e) => [e.RefractionIndex, e.DispersionFactor],
  846575682: (e) => [e.SurfaceColour],
  1351298697: (e) => [e.Textures],
  626085974: (e) => [e.RepeatS, e.RepeatT, e.TextureType, e.TextureTransform],
  1290481447: (e) => [e.Name, ke(e.StyleOfSymbol)],
  985171141: (e) => [e.Name, e.Rows],
  531007025: (e) => [e.RowCells.map((t) => ke(t)), e.IsHeading],
  912023232: (e) => [e.Purpose, e.Description, e.UserDefinedPurpose, e.TelephoneNumbers, e.FacsimileNumbers, e.PagerNumber, e.ElectronicMailAddresses, e.WWWHomePageURL],
  1447204868: (e) => [e.Name, ke(e.TextCharacterAppearance), ke(e.TextStyle), ke(e.TextFontStyle)],
  1983826977: (e) => [e.Name, e.FontFamily, e.FontStyle, e.FontVariant, e.FontWeight, ke(e.FontSize)],
  2636378356: (e) => [ke(e.Colour), ke(e.BackgroundColour)],
  1640371178: (e) => [(e.TextIndent ?? void 0) === void 0 ? null : ke(e.TextIndent), e.TextAlign, e.TextDecoration, (e.LetterSpacing ?? void 0) === void 0 ? null : ke(e.LetterSpacing), (e.WordSpacing ?? void 0) === void 0 ? null : ke(e.WordSpacing), e.TextTransform, (e.LineHeight ?? void 0) === void 0 ? null : ke(e.LineHeight)],
  1484833681: (e) => [e.BoxHeight, e.BoxWidth, e.BoxSlantAngle, e.BoxRotateAngle, (e.CharacterSpacing ?? void 0) === void 0 ? null : ke(e.CharacterSpacing)],
  280115917: (e) => [],
  1742049831: (e) => [e.Mode, e.Parameter.map((t) => ke(t))],
  2552916305: (e) => [e.TextureMaps],
  1210645708: (e) => [e.Coordinates],
  3317419933: (e) => [e.Material, e.SpecificHeatCapacity, e.BoilingPoint, e.FreezingPoint, e.ThermalConductivity],
  3101149627: (e) => [e.Name, e.Description, ke(e.StartTime), ke(e.EndTime), e.TimeSeriesDataType, e.DataOrigin, e.UserDefinedDataOrigin, ke(e.Unit)],
  1718945513: (e) => [e.ReferencedTimeSeries, ke(e.TimeSeriesReferences)],
  581633288: (e) => [e.ListValues.map((t) => ke(t))],
  1377556343: (e) => [],
  1735638870: (e) => [e.ContextOfItems, e.RepresentationIdentifier, e.RepresentationType, e.Items],
  180925521: (e) => [ke(e.Units)],
  2799835756: (e) => [],
  3304826586: (e) => [e.TextureVertices, e.TexturePoints],
  1907098498: (e) => [e.VertexGeometry],
  891718957: (e) => [e.IntersectingAxes, e.OffsetDistances],
  1065908215: (e) => [e.Material, e.IsPotable, e.Hardness, e.AlkalinityConcentration, e.AcidityConcentration, e.ImpuritiesContent, e.PHLevel, e.DissolvedSolidsContent],
  2442683028: (e) => [e.Item, e.Styles, e.Name],
  962685235: (e) => [e.Item, e.Styles, e.Name],
  3612888222: (e) => [e.Item, e.Styles, e.Name],
  2297822566: (e) => [e.Item, e.Styles, e.Name],
  3798115385: (e) => [e.ProfileType, e.ProfileName, e.OuterCurve],
  1310608509: (e) => [e.ProfileType, e.ProfileName, e.Curve],
  2705031697: (e) => [e.ProfileType, e.ProfileName, e.OuterCurve, e.InnerCurves],
  616511568: (e) => [e.RepeatS, e.RepeatT, e.TextureType, e.TextureTransform, e.RasterFormat, e.RasterCode],
  3150382593: (e) => [e.ProfileType, e.ProfileName, e.Curve, e.Thickness],
  647927063: (e) => [e.Location, e.ItemReference, e.Name, e.ReferencedSource],
  776857604: (e) => [e.Name, e.Red, e.Green, e.Blue],
  2542286263: (e) => [e.Name, e.Description, e.UsageName, e.HasProperties],
  1485152156: (e) => [e.ProfileType, e.ProfileName, e.Profiles, e.Label],
  370225590: (e) => [e.CfsFaces],
  1981873012: (e) => [ke(e.CurveOnRelatingElement), ke(e.CurveOnRelatedElement)],
  45288368: (e) => [ke(e.PointOnRelatingElement), ke(e.PointOnRelatedElement), e.EccentricityInX, e.EccentricityInY, e.EccentricityInZ],
  3050246964: (e) => [e.Dimensions, e.UnitType, e.Name],
  2889183280: (e) => [e.Dimensions, e.UnitType, e.Name, e.ConversionFactor],
  3800577675: (e) => [e.Name, ke(e.CurveFont), (e.CurveWidth ?? void 0) === void 0 ? null : ke(e.CurveWidth), ke(e.CurveColour)],
  3632507154: (e) => [e.ProfileType, e.ProfileName, e.ParentProfile, e.Operator, e.Label],
  2273265877: (e) => [e.Name, e.Description, e.RelatingDraughtingCallout, e.RelatedDraughtingCallout],
  1694125774: (e) => [e.Name, e.Description, e.RelatingDraughtingCallout, e.RelatedDraughtingCallout],
  3732053477: (e) => [e.Location, e.ItemReference, e.Name],
  4170525392: (e) => [e.Name],
  3900360178: (e) => [e.EdgeStart, e.EdgeEnd],
  476780140: (e) => [e.EdgeStart, e.EdgeEnd, e.EdgeGeometry, e.SameSense],
  1860660968: (e) => [e.Material, e.ExtendedProperties, e.Description, e.Name],
  2556980723: (e) => [e.Bounds],
  1809719519: (e) => [e.Bound, e.Orientation],
  803316827: (e) => [e.Bound, e.Orientation],
  3008276851: (e) => [e.Bounds, e.FaceSurface, e.SameSense],
  4219587988: (e) => [e.Name, e.TensionFailureX, e.TensionFailureY, e.TensionFailureZ, e.CompressionFailureX, e.CompressionFailureY, e.CompressionFailureZ],
  738692330: (e) => [e.Name, ke(e.FillStyles)],
  3857492461: (e) => [e.Material, e.CombustionTemperature, e.CarbonContent, e.LowerHeatingValue, e.HigherHeatingValue],
  803998398: (e) => [e.Material, e.MolecularWeight, e.Porosity, e.MassDensity],
  1446786286: (e) => [e.ProfileName, e.ProfileDefinition, e.PhysicalWeight, e.Perimeter, e.MinimumPlateThickness, e.MaximumPlateThickness, e.CrossSectionArea],
  3448662350: (e) => [e.ContextIdentifier, e.ContextType, e.CoordinateSpaceDimension, e.Precision, ke(e.WorldCoordinateSystem), e.TrueNorth],
  2453401579: (e) => [],
  4142052618: (e) => [e.ContextIdentifier, e.ContextType, void 0, void 0, void 0, void 0, e.ParentContext, e.TargetScale, e.TargetView, e.UserDefinedTargetView],
  3590301190: (e) => [ke(e.Elements)],
  178086475: (e) => [e.PlacementLocation, e.PlacementRefDirection],
  812098782: (e) => [e.BaseSurface, e.AgreementFlag],
  2445078500: (e) => [e.Material, e.UpperVaporResistanceFactor, e.LowerVaporResistanceFactor, e.IsothermalMoistureCapacity, e.VaporPermeability, e.MoistureDiffusivity],
  3905492369: (e) => [e.RepeatS, e.RepeatT, e.TextureType, e.TextureTransform, e.UrlReference],
  3741457305: (e) => [e.Name, e.Description, ke(e.StartTime), ke(e.EndTime), e.TimeSeriesDataType, e.DataOrigin, e.UserDefinedDataOrigin, ke(e.Unit), e.Values],
  1402838566: (e) => [e.Name, e.LightColour, e.AmbientIntensity, e.Intensity],
  125510826: (e) => [e.Name, e.LightColour, e.AmbientIntensity, e.Intensity],
  2604431987: (e) => [e.Name, e.LightColour, e.AmbientIntensity, e.Intensity, e.Orientation],
  4266656042: (e) => [e.Name, e.LightColour, e.AmbientIntensity, e.Intensity, e.Position, e.ColourAppearance, e.ColourTemperature, e.LuminousFlux, e.LightEmissionSource, ke(e.LightDistributionDataSource)],
  1520743889: (e) => [e.Name, e.LightColour, e.AmbientIntensity, e.Intensity, e.Position, e.Radius, e.ConstantAttenuation, e.DistanceAttenuation, e.QuadricAttenuation],
  3422422726: (e) => [e.Name, e.LightColour, e.AmbientIntensity, e.Intensity, e.Position, e.Radius, e.ConstantAttenuation, e.DistanceAttenuation, e.QuadricAttenuation, e.Orientation, e.ConcentrationExponent, e.SpreadAngle, e.BeamWidthAngle],
  2624227202: (e) => [e.PlacementRelTo, ke(e.RelativePlacement)],
  1008929658: (e) => [],
  2347385850: (e) => [e.MappingSource, e.MappingTarget],
  2022407955: (e) => [e.Name, e.Description, e.Representations, e.RepresentedMaterial],
  1430189142: (e) => [e.Material, e.DynamicViscosity, e.YoungModulus, e.ShearModulus, e.PoissonRatio, e.ThermalExpansionCoefficient, e.CompressiveStrength, e.MaxAggregateSize, e.AdmixturesDescription, e.Workability, e.ProtectivePoreRatio, e.WaterImpermeability],
  219451334: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description],
  2833995503: (e) => [e.RepeatFactor],
  2665983363: (e) => [e.CfsFaces],
  1029017970: (e) => [void 0, void 0, e.EdgeElement, e.Orientation],
  2529465313: (e) => [e.ProfileType, e.ProfileName, e.Position],
  2519244187: (e) => [e.EdgeList],
  3021840470: (e) => [e.Name, e.Description, e.HasQuantities, e.Discrimination, e.Quality, e.Usage],
  597895409: (e) => [e.RepeatS, e.RepeatT, e.TextureType, e.TextureTransform, e.Width, e.Height, e.ColourComponents, e.Pixel],
  2004835150: (e) => [e.Location],
  1663979128: (e) => [e.SizeInX, e.SizeInY],
  2067069095: (e) => [],
  4022376103: (e) => [e.BasisCurve, e.PointParameter],
  1423911732: (e) => [e.BasisSurface, e.PointParameterU, e.PointParameterV],
  2924175390: (e) => [e.Polygon],
  2775532180: (e) => [e.BaseSurface, e.AgreementFlag, e.Position, e.PolygonalBoundary],
  759155922: (e) => [e.Name],
  2559016684: (e) => [e.Name],
  433424934: (e) => [e.Name],
  179317114: (e) => [e.Name],
  673634403: (e) => [e.Name, e.Description, e.Representations],
  871118103: (e) => [e.Name, e.Description, (e.UpperBoundValue ?? void 0) === void 0 ? null : ke(e.UpperBoundValue), (e.LowerBoundValue ?? void 0) === void 0 ? null : ke(e.LowerBoundValue), ke(e.Unit)],
  1680319473: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description],
  4166981789: (e) => [e.Name, e.Description, e.EnumerationValues.map((t) => ke(t)), e.EnumerationReference],
  2752243245: (e) => [e.Name, e.Description, e.ListValues.map((t) => ke(t)), ke(e.Unit)],
  941946838: (e) => [e.Name, e.Description, e.UsageName, ke(e.PropertyReference)],
  3357820518: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description],
  3650150729: (e) => [e.Name, e.Description, (e.NominalValue ?? void 0) === void 0 ? null : ke(e.NominalValue), ke(e.Unit)],
  110355661: (e) => [e.Name, e.Description, e.DefiningValues.map((t) => ke(t)), e.DefinedValues.map((t) => ke(t)), e.Expression, ke(e.DefiningUnit), ke(e.DefinedUnit)],
  3615266464: (e) => [e.ProfileType, e.ProfileName, e.Position, e.XDim, e.YDim],
  3413951693: (e) => [e.Name, e.Description, ke(e.StartTime), ke(e.EndTime), e.TimeSeriesDataType, e.DataOrigin, e.UserDefinedDataOrigin, ke(e.Unit), e.TimeStep, e.Values],
  3765753017: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.DefinitionType, e.ReinforcementSectionDefinitions],
  478536968: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description],
  2778083089: (e) => [e.ProfileType, e.ProfileName, e.Position, e.XDim, e.YDim, e.RoundingRadius],
  1509187699: (e) => [e.SpineCurve, e.CrossSections, e.CrossSectionPositions],
  2411513650: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.PredefinedType, (e.UpperValue ?? void 0) === void 0 ? null : ke(e.UpperValue), ke(e.MostUsedValue), (e.LowerValue ?? void 0) === void 0 ? null : ke(e.LowerValue)],
  4124623270: (e) => [ke(e.SbsmBoundary)],
  2609359061: (e) => [e.Name, e.SlippageX, e.SlippageY, e.SlippageZ],
  723233188: (e) => [],
  2485662743: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, { type: 3, value: e.IsAttenuating.value }, e.SoundScale, e.SoundValues],
  1202362311: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.SoundLevelTimeSeries, e.Frequency, (e.SoundLevelSingleValue ?? void 0) === void 0 ? null : ke(e.SoundLevelSingleValue)],
  390701378: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableValueRatio, e.ThermalLoadSource, e.PropertySource, e.SourceDescription, e.MaximumValue, e.MinimumValue, e.ThermalLoadTimeSeriesValues, e.UserDefinedThermalLoadSource, e.UserDefinedPropertySource, e.ThermalLoadType],
  1595516126: (e) => [e.Name, e.LinearForceX, e.LinearForceY, e.LinearForceZ, e.LinearMomentX, e.LinearMomentY, e.LinearMomentZ],
  2668620305: (e) => [e.Name, e.PlanarForceX, e.PlanarForceY, e.PlanarForceZ],
  2473145415: (e) => [e.Name, e.DisplacementX, e.DisplacementY, e.DisplacementZ, e.RotationalDisplacementRX, e.RotationalDisplacementRY, e.RotationalDisplacementRZ],
  1973038258: (e) => [e.Name, e.DisplacementX, e.DisplacementY, e.DisplacementZ, e.RotationalDisplacementRX, e.RotationalDisplacementRY, e.RotationalDisplacementRZ, e.Distortion],
  1597423693: (e) => [e.Name, e.ForceX, e.ForceY, e.ForceZ, e.MomentX, e.MomentY, e.MomentZ],
  1190533807: (e) => [e.Name, e.ForceX, e.ForceY, e.ForceZ, e.MomentX, e.MomentY, e.MomentZ, e.WarpingMoment],
  3843319758: (e) => [e.ProfileName, e.ProfileDefinition, e.PhysicalWeight, e.Perimeter, e.MinimumPlateThickness, e.MaximumPlateThickness, e.CrossSectionArea, e.TorsionalConstantX, e.MomentOfInertiaYZ, e.MomentOfInertiaY, e.MomentOfInertiaZ, e.WarpingConstant, e.ShearCentreZ, e.ShearCentreY, e.ShearDeformationAreaZ, e.ShearDeformationAreaY, e.MaximumSectionModulusY, e.MinimumSectionModulusY, e.MaximumSectionModulusZ, e.MinimumSectionModulusZ, e.TorsionalSectionModulus, e.CentreOfGravityInX, e.CentreOfGravityInY],
  3653947884: (e) => [e.ProfileName, e.ProfileDefinition, e.PhysicalWeight, e.Perimeter, e.MinimumPlateThickness, e.MaximumPlateThickness, e.CrossSectionArea, e.TorsionalConstantX, e.MomentOfInertiaYZ, e.MomentOfInertiaY, e.MomentOfInertiaZ, e.WarpingConstant, e.ShearCentreZ, e.ShearCentreY, e.ShearDeformationAreaZ, e.ShearDeformationAreaY, e.MaximumSectionModulusY, e.MinimumSectionModulusY, e.MaximumSectionModulusZ, e.MinimumSectionModulusZ, e.TorsionalSectionModulus, e.CentreOfGravityInX, e.CentreOfGravityInY, e.ShearAreaZ, e.ShearAreaY, e.PlasticShapeFactorY, e.PlasticShapeFactorZ],
  2233826070: (e) => [e.EdgeStart, e.EdgeEnd, e.ParentEdge],
  2513912981: (e) => [],
  1878645084: (e) => [e.SurfaceColour, e.Transparency, ke(e.DiffuseColour), ke(e.TransmissionColour), ke(e.DiffuseTransmissionColour), ke(e.ReflectionColour), ke(e.SpecularColour), (e.SpecularHighlight ?? void 0) === void 0 ? null : ke(e.SpecularHighlight), e.ReflectanceMethod],
  2247615214: (e) => [e.SweptArea, e.Position],
  1260650574: (e) => [e.Directrix, e.Radius, e.InnerRadius, e.StartParam, e.EndParam],
  230924584: (e) => [e.SweptCurve, e.Position],
  3071757647: (e) => [e.ProfileType, e.ProfileName, e.Position, e.Depth, e.FlangeWidth, e.WebThickness, e.FlangeThickness, e.FilletRadius, e.FlangeEdgeRadius, e.WebEdgeRadius, e.WebSlope, e.FlangeSlope, e.CentreOfGravityInY],
  3028897424: (e) => [e.Item, e.Styles, e.Name, e.AnnotatedCurve],
  4282788508: (e) => [e.Literal, ke(e.Placement), e.Path],
  3124975700: (e) => [e.Literal, ke(e.Placement), e.Path, e.Extent, e.BoxAlignment],
  2715220739: (e) => [e.ProfileType, e.ProfileName, e.Position, e.BottomXDim, e.TopXDim, e.YDim, e.TopXOffset],
  1345879162: (e) => [e.RepeatFactor, e.SecondRepeatFactor],
  1628702193: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets],
  2347495698: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag],
  427810014: (e) => [e.ProfileType, e.ProfileName, e.Position, e.Depth, e.FlangeWidth, e.WebThickness, e.FlangeThickness, e.FilletRadius, e.EdgeRadius, e.FlangeSlope, e.CentreOfGravityInX],
  1417489154: (e) => [e.Orientation, e.Magnitude],
  2759199220: (e) => [e.LoopVertex],
  336235671: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.LiningDepth, e.LiningThickness, e.TransomThickness, e.MullionThickness, e.FirstTransomOffset, e.SecondTransomOffset, e.FirstMullionOffset, e.SecondMullionOffset, e.ShapeAspectStyle],
  512836454: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.OperationType, e.PanelPosition, e.FrameDepth, e.FrameThickness, e.ShapeAspectStyle],
  1299126871: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ConstructionType, e.OperationType, e.ParameterTakesPrecedence, e.Sizeable],
  2543172580: (e) => [e.ProfileType, e.ProfileName, e.Position, e.Depth, e.FlangeWidth, e.WebThickness, e.FlangeThickness, e.FilletRadius, e.EdgeRadius],
  3288037868: (e) => [e.Item, e.Styles, e.Name],
  669184980: (e) => [e.OuterBoundary, e.InnerBoundaries],
  2265737646: (e) => [e.Item, e.Styles, e.Name, e.FillStyleTarget, e.GlobalOrLocal],
  1302238472: (e) => [e.Item, e.TextureCoordinates],
  4261334040: (e) => [e.Location, e.Axis],
  3125803723: (e) => [e.Location, e.RefDirection],
  2740243338: (e) => [e.Location, e.Axis, e.RefDirection],
  2736907675: (e) => [e.Operator, ke(e.FirstOperand), ke(e.SecondOperand)],
  4182860854: (e) => [],
  2581212453: (e) => [e.Corner, e.XDim, e.YDim, e.ZDim],
  2713105998: (e) => [e.BaseSurface, e.AgreementFlag, e.Enclosure],
  2898889636: (e) => [e.ProfileType, e.ProfileName, e.Position, e.Depth, e.Width, e.WallThickness, e.Girth, e.InternalFilletRadius, e.CentreOfGravityInX],
  1123145078: (e) => [e.Coordinates],
  59481748: (e) => [e.Axis1, e.Axis2, e.LocalOrigin, e.Scale],
  3749851601: (e) => [e.Axis1, e.Axis2, e.LocalOrigin, e.Scale],
  3486308946: (e) => [e.Axis1, e.Axis2, e.LocalOrigin, e.Scale, e.Scale2],
  3331915920: (e) => [e.Axis1, e.Axis2, e.LocalOrigin, e.Scale, e.Axis3],
  1416205885: (e) => [e.Axis1, e.Axis2, e.LocalOrigin, e.Scale, e.Axis3, e.Scale2, e.Scale3],
  1383045692: (e) => [e.ProfileType, e.ProfileName, e.Position, e.Radius],
  2205249479: (e) => [e.CfsFaces],
  2485617015: (e) => [e.Transition, e.SameSense, e.ParentCurve],
  4133800736: (e) => [e.ProfileType, e.ProfileName, e.Position, e.OverallHeight, e.BaseWidth2, e.Radius, e.HeadWidth, e.HeadDepth2, e.HeadDepth3, e.WebThickness, e.BaseWidth4, e.BaseDepth1, e.BaseDepth2, e.BaseDepth3, e.CentreOfGravityInY],
  194851669: (e) => [e.ProfileType, e.ProfileName, e.Position, e.OverallHeight, e.HeadWidth, e.Radius, e.HeadDepth2, e.HeadDepth3, e.WebThickness, e.BaseDepth1, e.BaseDepth2, e.CentreOfGravityInY],
  2506170314: (e) => [e.Position],
  2147822146: (e) => [ke(e.TreeRootExpression)],
  2601014836: (e) => [],
  2827736869: (e) => [e.BasisSurface, e.OuterBoundary, e.InnerBoundaries],
  693772133: (e) => [ke(e.Definition), e.Target],
  606661476: (e) => [e.Item, e.Styles, e.Name],
  4054601972: (e) => [e.Item, e.Styles, e.Name, e.AnnotatedCurve, e.Role],
  32440307: (e) => [e.DirectionRatios],
  2963535650: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.LiningDepth, e.LiningThickness, e.ThresholdDepth, e.ThresholdThickness, e.TransomThickness, e.TransomOffset, e.LiningOffset, e.ThresholdOffset, e.CasingThickness, e.CasingDepth, e.ShapeAspectStyle],
  1714330368: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.PanelDepth, e.PanelOperation, e.PanelWidth, e.PanelPosition, e.ShapeAspectStyle],
  526551008: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.OperationType, e.ConstructionType, e.ParameterTakesPrecedence, e.Sizeable],
  3073041342: (e) => [ke(e.Contents)],
  445594917: (e) => [e.Name],
  4006246654: (e) => [e.Name],
  1472233963: (e) => [e.EdgeList],
  1883228015: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.MethodOfMeasurement, e.Quantities],
  339256511: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  2777663545: (e) => [e.Position],
  2835456948: (e) => [e.ProfileType, e.ProfileName, e.Position, e.SemiAxis1, e.SemiAxis2],
  80994333: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.EnergySequence, e.UserDefinedEnergySequence],
  477187591: (e) => [e.SweptArea, e.Position, e.ExtrudedDirection, e.Depth],
  2047409740: (e) => [e.FbsmFaces],
  374418227: (e) => [e.HatchLineAppearance, ke(e.StartOfNextHatchLine), e.PointOfReferenceHatchLine, e.PatternStart, e.HatchLineAngle],
  4203026998: (e) => [e.Symbol],
  315944413: (e) => [e.TilingPattern, ke(e.Tiles), e.TilingScale],
  3455213021: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.PropertySource, e.FlowConditionTimeSeries, e.VelocityTimeSeries, e.FlowrateTimeSeries, e.Fluid, e.PressureTimeSeries, e.UserDefinedPropertySource, e.TemperatureSingleValue, e.WetBulbTemperatureSingleValue, e.WetBulbTemperatureTimeSeries, e.TemperatureTimeSeries, (e.FlowrateSingleValue ?? void 0) === void 0 ? null : ke(e.FlowrateSingleValue), e.FlowConditionSingleValue, e.VelocitySingleValue, e.PressureSingleValue],
  4238390223: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  1268542332: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.AssemblyPlace],
  987898635: (e) => [ke(e.Elements)],
  1484403080: (e) => [e.ProfileType, e.ProfileName, e.Position, e.OverallWidth, e.OverallDepth, e.WebThickness, e.FlangeThickness, e.FilletRadius],
  572779678: (e) => [e.ProfileType, e.ProfileName, e.Position, e.Depth, e.Width, e.Thickness, e.FilletRadius, e.EdgeRadius, e.LegSlope, e.CentreOfGravityInX, e.CentreOfGravityInY],
  1281925730: (e) => [e.Pnt, e.Dir],
  1425443689: (e) => [e.Outer],
  3888040117: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType],
  3388369263: (e) => [e.BasisCurve, e.Distance, e.SelfIntersect],
  3505215534: (e) => [e.BasisCurve, e.Distance, e.SelfIntersect, e.RefDirection],
  3566463478: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.OperationType, e.PanelPosition, e.FrameDepth, e.FrameThickness, e.ShapeAspectStyle],
  603570806: (e) => [e.SizeInX, e.SizeInY, ke(e.Placement)],
  220341763: (e) => [e.Position],
  2945172077: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType],
  4208778838: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation],
  103090709: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.LongName, e.Phase, e.RepresentationContexts, e.UnitsInContext],
  4194566429: (e) => [e.Item, e.Styles, e.Name],
  1451395588: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.HasProperties],
  3219374653: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.ProxyType, e.Tag],
  2770003689: (e) => [e.ProfileType, e.ProfileName, e.Position, e.XDim, e.YDim, e.WallThickness, e.InnerFilletRadius, e.OuterFilletRadius],
  2798486643: (e) => [e.Position, e.XLength, e.YLength, e.Height],
  3454111270: (e) => [e.BasisSurface, e.U1, e.V1, e.U2, e.V2, e.Usense, e.Vsense],
  3939117080: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatedObjectsType],
  1683148259: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatedObjectsType, e.RelatingActor, e.ActingRole],
  2495723537: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatedObjectsType, e.RelatingControl],
  1307041759: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatedObjectsType, e.RelatingGroup],
  4278684876: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatedObjectsType, e.RelatingProcess, e.QuantityInProcess],
  2857406711: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatedObjectsType, e.RelatingProduct],
  3372526763: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatedObjectsType, e.RelatingControl],
  205026976: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatedObjectsType, e.RelatingResource],
  1865459582: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects],
  1327628568: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatingAppliedValue],
  4095574036: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatingApproval],
  919958153: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, ke(e.RelatingClassification)],
  2728634034: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.Intent, e.RelatingConstraint],
  982818633: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, ke(e.RelatingDocument)],
  3840914261: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, ke(e.RelatingLibrary)],
  2655215786: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, ke(e.RelatingMaterial)],
  2851387026: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatingProfileProperties, e.ProfileSectionLocation, ke(e.ProfileOrientation)],
  826625072: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description],
  1204542856: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ConnectionGeometry, e.RelatingElement, e.RelatedElement],
  3945020480: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ConnectionGeometry, e.RelatingElement, e.RelatedElement, e.RelatingPriorities, e.RelatedPriorities, e.RelatedConnectionType, e.RelatingConnectionType],
  4201705270: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingPort, e.RelatedElement],
  3190031847: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingPort, e.RelatedPort, e.RealizingElement],
  2127690289: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, ke(e.RelatingElement), e.RelatedStructuralActivity],
  3912681535: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingElement, e.RelatedStructuralMember],
  1638771189: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingStructuralMember, e.RelatedStructuralConnection, e.AppliedCondition, e.AdditionalConditions, e.SupportedLength, e.ConditionCoordinateSystem],
  504942748: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingStructuralMember, e.RelatedStructuralConnection, e.AppliedCondition, e.AdditionalConditions, e.SupportedLength, e.ConditionCoordinateSystem, e.ConnectionConstraint],
  3678494232: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ConnectionGeometry, e.RelatingElement, e.RelatedElement, e.RealizingElements, e.ConnectionType],
  3242617779: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedElements, e.RelatingStructure],
  886880790: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingBuildingElement, e.RelatedCoverings],
  2802773753: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedSpace, e.RelatedCoverings],
  2551354335: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingObject, e.RelatedObjects],
  693640335: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects],
  4186316022: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatingPropertyDefinition],
  781010003: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatingType],
  3940055652: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingOpeningElement, e.RelatedBuildingElement],
  279856033: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedControlElements, e.RelatingFlowElement],
  4189434867: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.DailyInteraction, e.ImportanceRating, e.LocationOfInteraction, e.RelatedSpaceProgram, e.RelatingSpaceProgram],
  3268803585: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingObject, e.RelatedObjects],
  2051452291: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatedObjectsType, e.RelatingActor, e.ActingRole],
  202636808: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatingPropertyDefinition, e.OverridingProperties],
  750771296: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingElement, e.RelatedFeatureElement],
  1245217292: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedElements, e.RelatingStructure],
  1058617721: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatedObjectsType, e.RelatingControl],
  4122056220: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingProcess, e.RelatedProcess, e.TimeLag, e.SequenceType],
  366585022: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingSystem, e.RelatedBuildings],
  3451746338: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingSpace, e.RelatedBuildingElement, e.ConnectionGeometry, e.PhysicalOrVirtualBoundary, e.InternalOrExternalBoundary],
  1401173127: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingBuildingElement, e.RelatedOpeningElement],
  2914609552: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType],
  1856042241: (e) => [e.SweptArea, e.Position, e.Axis, e.Angle],
  4158566097: (e) => [e.Position, e.Height, e.BottomRadius],
  3626867408: (e) => [e.Position, e.Height, e.Radius],
  2706606064: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName, e.CompositionType],
  3893378262: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  451544542: (e) => [e.Position, e.Radius],
  3544373492: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedLoad, e.GlobalOrLocal],
  3136571912: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation],
  530289379: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation],
  3689010777: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedLoad, e.GlobalOrLocal],
  3979015343: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.PredefinedType, e.Thickness],
  2218152070: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.PredefinedType, e.Thickness, e.SubsequentThickness, e.VaryingThicknessLocation],
  4070609034: (e) => [ke(e.Contents)],
  2028607225: (e) => [e.SweptArea, e.Position, e.Directrix, e.StartParam, e.EndParam, e.ReferenceSurface],
  2809605785: (e) => [e.SweptCurve, e.Position, e.ExtrudedDirection, e.Depth],
  4124788165: (e) => [e.SweptCurve, e.Position, e.AxisPosition],
  1580310250: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  3473067441: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.TaskId, e.Status, e.WorkMethod, e.IsMilestone, e.Priority],
  2097647324: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2296667514: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, ke(e.TheActor)],
  1674181508: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation],
  3207858831: (e) => [e.ProfileType, e.ProfileName, e.Position, e.OverallWidth, e.OverallDepth, e.WebThickness, e.FlangeThickness, e.FilletRadius, e.TopFlangeWidth, e.TopFlangeThickness, e.TopFlangeFilletRadius, e.CentreOfGravityInY],
  1334484129: (e) => [e.Position, e.XLength, e.YLength, e.ZLength],
  3649129432: (e) => [e.Operator, ke(e.FirstOperand), ke(e.SecondOperand)],
  1260505505: (e) => [],
  4031249490: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName, e.CompositionType, e.ElevationOfRefHeight, e.ElevationOfTerrain, e.BuildingAddress],
  1950629157: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  3124254112: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName, e.CompositionType, e.Elevation],
  2937912522: (e) => [e.ProfileType, e.ProfileName, e.Position, e.Radius, e.WallThickness],
  300633059: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3732776249: (e) => [e.Segments, e.SelfIntersect],
  2510884976: (e) => [ke(e.Position)],
  2559216714: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ResourceIdentifier, e.ResourceGroup, e.ResourceConsumption, e.BaseQuantity],
  3293443760: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType],
  3895139033: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType],
  1419761937: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, ke(e.SubmittedBy), ke(e.PreparedBy), ke(e.SubmittedOn), e.Status, ke(e.TargetUsers), ke(e.UpdateDate), e.ID, e.PredefinedType],
  1916426348: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3295246426: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ResourceIdentifier, e.ResourceGroup, e.ResourceConsumption, e.BaseQuantity],
  1457835157: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  681481545: (e) => [ke(e.Contents)],
  3256556792: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  3849074793: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  360485395: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.EnergySequence, e.UserDefinedEnergySequence, e.ElectricCurrentType, e.InputVoltage, e.InputFrequency, e.FullLoadCurrent, e.MinimumCircuitCurrent, e.MaximumPowerInput, e.RatedPowerInput, e.InputPhase],
  1758889154: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  4123344466: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.AssemblyPlace, e.PredefinedType],
  1623761950: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  2590856083: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  1704287377: (e) => [ke(e.Position), e.SemiAxis1, e.SemiAxis2],
  2107101300: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  1962604670: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  3272907226: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType],
  3174744832: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3390157468: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  807026263: (e) => [e.Outer],
  3737207727: (e) => [e.Outer, e.Voids],
  647756555: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  2489546625: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  2827207264: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  2143335405: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  1287392070: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  3907093117: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  3198132628: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  3815607619: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1482959167: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  1834744321: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  1339347760: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  2297155007: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  3009222698: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  263784265: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  814719939: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType],
  200128114: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3009204131: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.UAxes, e.VAxes, e.WAxes],
  2706460486: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType],
  1251058090: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1806887404: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2391368822: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.InventoryType, ke(e.Jurisdiction), e.ResponsiblePersons, e.LastUpdateDate, e.CurrentValue, e.OriginalValue],
  4288270099: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3827777499: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ResourceIdentifier, e.ResourceGroup, e.ResourceConsumption, e.BaseQuantity, e.SkillSet],
  1051575348: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1161773419: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2506943328: (e) => [ke(e.Contents)],
  377706215: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.NominalDiameter, e.NominalLength],
  2108223431: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  3181161470: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  977012517: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1916936684: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.TaskId, e.Status, e.WorkMethod, e.IsMilestone, e.Priority, e.MoveFrom, e.MoveTo, e.PunchList],
  4143007308: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, ke(e.TheActor), e.PredefinedType],
  3588315303: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  3425660407: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.TaskId, e.Status, e.WorkMethod, e.IsMilestone, e.Priority, e.ActionID],
  2837617999: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2382730787: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.LifeCyclePhase],
  3327091369: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.PermitID],
  804291784: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  4231323485: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  4017108033: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3724593414: (e) => [e.Points],
  3740093272: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation],
  2744685151: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ProcedureID, e.ProcedureType, e.UserDefinedProcedureType],
  2904328755: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ID, e.PredefinedType, e.Status],
  3642467123: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Records, e.PredefinedType],
  3651124850: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  1842657554: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2250791053: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3248260540: (e) => [ke(e.Contents)],
  2893384427: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2324767716: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  160246688: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingObject, e.RelatedObjects],
  2863920197: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatedObjectsType, e.RelatingControl, e.TimeForTask],
  1768891740: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3517283431: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, ke(e.ActualStart), ke(e.EarlyStart), ke(e.LateStart), ke(e.ScheduleStart), ke(e.ActualFinish), ke(e.EarlyFinish), ke(e.LateFinish), ke(e.ScheduleFinish), e.ScheduleDuration, e.ActualDuration, e.RemainingTime, e.FreeFloat, e.TotalFloat, e.IsCritical, ke(e.StatusTime), e.StartFloat, e.FinishFloat, e.Completion],
  4105383287: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ServiceLifeType, e.ServiceLifeDuration],
  4097777520: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName, e.CompositionType, e.RefLatitude, e.RefLongitude, e.RefElevation, e.LandTitleNumber, e.SiteAddress],
  2533589738: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3856911033: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName, e.CompositionType, e.InteriorOrExteriorSpace, e.ElevationWithFlooring],
  1305183839: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  652456506: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.SpaceProgramIdentifier, e.MaxRequiredArea, e.MinRequiredArea, e.RequestedLocation, e.StandardRequiredArea],
  3812236995: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3112655638: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1039846685: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  682877961: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedLoad, e.GlobalOrLocal, e.DestabilizingLoad, e.CausedBy],
  1179482911: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedCondition],
  4243806635: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedCondition],
  214636428: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.PredefinedType],
  2445595289: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.PredefinedType],
  1807405624: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedLoad, e.GlobalOrLocal, e.DestabilizingLoad, e.CausedBy, e.ProjectedOrTrue],
  1721250024: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedLoad, e.GlobalOrLocal, e.DestabilizingLoad, e.CausedBy, e.ProjectedOrTrue, e.VaryingAppliedLoadLocation, e.SubsequentAppliedLoads],
  1252848954: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.PredefinedType, e.ActionType, e.ActionSource, e.Coefficient, e.Purpose],
  1621171031: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedLoad, e.GlobalOrLocal, e.DestabilizingLoad, e.CausedBy, e.ProjectedOrTrue],
  3987759626: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedLoad, e.GlobalOrLocal, e.DestabilizingLoad, e.CausedBy, e.ProjectedOrTrue, e.VaryingAppliedLoadLocation, e.SubsequentAppliedLoads],
  2082059205: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedLoad, e.GlobalOrLocal, e.DestabilizingLoad, e.CausedBy],
  734778138: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedCondition],
  1235345126: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedLoad, e.GlobalOrLocal],
  2986769608: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.TheoryType, e.ResultForLoadGroup, e.IsLinear],
  1975003073: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedCondition],
  148013059: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ResourceIdentifier, e.ResourceGroup, e.ResourceConsumption, e.BaseQuantity, ke(e.SubContractor), e.JobDescription],
  2315554128: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2254336722: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType],
  5716631: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1637806684: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, ke(e.ApplicableDates), e.TimeSeriesScheduleType, e.TimeSeries],
  1692211062: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1620046519: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.OperationType, e.CapacityByWeight, e.CapacityByNumber],
  3593883385: (e) => [e.BasisCurve, ke(e.Trim1), ke(e.Trim2), e.SenseAgreement, e.MasterRepresentation],
  1600972822: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1911125066: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  728799441: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2769231204: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  1898987631: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1133259667: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1028945134: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identifier, ke(e.CreationDate), e.Creators, e.Purpose, e.Duration, e.TotalFloat, ke(e.StartTime), ke(e.FinishTime), e.WorkControlType, e.UserDefinedControlType],
  4218914973: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identifier, ke(e.CreationDate), e.Creators, e.Purpose, e.Duration, e.TotalFloat, ke(e.StartTime), ke(e.FinishTime), e.WorkControlType, e.UserDefinedControlType],
  3342526732: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identifier, ke(e.CreationDate), e.Creators, e.Purpose, e.Duration, e.TotalFloat, ke(e.StartTime), ke(e.FinishTime), e.WorkControlType, e.UserDefinedControlType],
  1033361043: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType],
  1213861670: (e) => [e.Segments, e.SelfIntersect],
  3821786052: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.RequestID],
  1411407467: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3352864051: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1871374353: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2470393545: (e) => [ke(e.Contents)],
  3460190687: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.AssetID, e.OriginalValue, e.CurrentValue, e.TotalReplacementCost, ke(e.Owner), ke(e.User), e.ResponsiblePerson, e.IncorporationDate, e.DepreciatedValue],
  1967976161: (e) => [e.Degree, e.ControlPointsList, e.CurveForm, e.ClosedCurve, e.SelfIntersect],
  819618141: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1916977116: (e) => [e.Degree, e.ControlPointsList, e.CurveForm, e.ClosedCurve, e.SelfIntersect],
  231477066: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3299480353: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  52481810: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  2979338954: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  1095909175: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.CompositionType],
  1909888760: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  395041908: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3293546465: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1285652485: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2951183804: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2611217952: (e) => [ke(e.Position), e.Radius],
  2301859152: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  843113511: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  3850581409: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2816379211: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2188551683: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType],
  1163958913: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, ke(e.Criterion), ke(e.CriterionDateTime)],
  3898045240: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ResourceIdentifier, e.ResourceGroup, e.ResourceConsumption, e.BaseQuantity],
  1060000209: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ResourceIdentifier, e.ResourceGroup, e.ResourceConsumption, e.BaseQuantity, ke(e.Suppliers), e.UsageRatio],
  488727124: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ResourceIdentifier, e.ResourceGroup, e.ResourceConsumption, e.BaseQuantity],
  335055490: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2954562838: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1973544240: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3495092785: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  3961806047: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  4147604152: (e) => [ke(e.Contents)],
  1335981549: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  2635815018: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  1599208980: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2063403501: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  1945004755: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  3040386961: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  3041715199: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.FlowDirection],
  395920057: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.OverallHeight, e.OverallWidth],
  869906466: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3760055223: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2030761528: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  855621170: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.FeatureLength],
  663422040: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3277789161: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1534661035: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1365060375: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1217240411: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  712377611: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1634875225: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType],
  857184966: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  1658829314: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  346874300: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1810631287: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  4222183408: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2058353004: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  4278956645: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  4037862832: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3132237377: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  987401354: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  707683696: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  2223149337: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  3508470533: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  900683007: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1073191201: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  1687234759: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType, e.ConstructionType],
  3171933400: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  2262370178: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3024970846: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.ShapeType],
  3283111854: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  3055160366: (e) => [e.Degree, e.ControlPointsList, e.CurveForm, e.ClosedCurve, e.SelfIntersect, e.WeightsData],
  3027567501: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.SteelGrade],
  2320036040: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.SteelGrade, e.MeshLength, e.MeshWidth, e.LongitudinalBarNominalDiameter, e.TransverseBarNominalDiameter, e.LongitudinalBarCrossSectionArea, e.TransverseBarCrossSectionArea, e.LongitudinalBarSpacing, e.TransverseBarSpacing],
  2016517767: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.ShapeType],
  1376911519: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.FeatureLength, e.Radius],
  1783015770: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1529196076: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  331165859: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.ShapeType],
  4252922144: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.NumberOfRiser, e.NumberOfTreads, e.RiserHeight, e.TreadLength],
  2515109513: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.PredefinedType, e.OrientationOf2DPlane, e.LoadedBy, e.HasResults],
  3824725483: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.SteelGrade, e.PredefinedType, e.NominalDiameter, e.CrossSectionArea, e.TensionForce, e.PreStress, e.FrictionCoefficient, e.AnchorageSlip, e.MinCurvatureRadius],
  2347447852: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.SteelGrade],
  3313531582: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2391406946: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  3512223829: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  3304561284: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.OverallHeight, e.OverallWidth],
  2874132201: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3001207471: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  753842376: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  2454782716: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.FeatureLength, e.Width, e.Height],
  578613899: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1052013943: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  1062813311: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.ControlElementId],
  3700593921: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.DistributionPointFunction, e.UserDefinedFunction],
  979691226: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.SteelGrade, e.NominalDiameter, e.CrossSectionArea, e.BarLength, e.BarRole, e.BarSurface]
};
AH[1] = {
  3699917729: (e) => new f.IfcAbsorbedDoseMeasure(e),
  4182062534: (e) => new f.IfcAccelerationMeasure(e),
  360377573: (e) => new f.IfcAmountOfSubstanceMeasure(e),
  632304761: (e) => new f.IfcAngularVelocityMeasure(e),
  2650437152: (e) => new f.IfcAreaMeasure(e),
  2735952531: (e) => new f.IfcBoolean(e),
  1867003952: (e) => new f.IfcBoxAlignment(e),
  2991860651: (e) => new f.IfcComplexNumber(e.map((t) => t.value)),
  3812528620: (e) => new f.IfcCompoundPlaneAngleMeasure(e.map((t) => t.value)),
  3238673880: (e) => new f.IfcContextDependentMeasure(e),
  1778710042: (e) => new f.IfcCountMeasure(e),
  94842927: (e) => new f.IfcCurvatureMeasure(e),
  86635668: (e) => new f.IfcDayInMonthNumber(e),
  300323983: (e) => new f.IfcDaylightSavingHour(e),
  1514641115: (e) => new f.IfcDescriptiveMeasure(e),
  4134073009: (e) => new f.IfcDimensionCount(e),
  524656162: (e) => new f.IfcDoseEquivalentMeasure(e),
  69416015: (e) => new f.IfcDynamicViscosityMeasure(e),
  1827137117: (e) => new f.IfcElectricCapacitanceMeasure(e),
  3818826038: (e) => new f.IfcElectricChargeMeasure(e),
  2093906313: (e) => new f.IfcElectricConductanceMeasure(e),
  3790457270: (e) => new f.IfcElectricCurrentMeasure(e),
  2951915441: (e) => new f.IfcElectricResistanceMeasure(e),
  2506197118: (e) => new f.IfcElectricVoltageMeasure(e),
  2078135608: (e) => new f.IfcEnergyMeasure(e),
  1102727119: (e) => new f.IfcFontStyle(e),
  2715512545: (e) => new f.IfcFontVariant(e),
  2590844177: (e) => new f.IfcFontWeight(e),
  1361398929: (e) => new f.IfcForceMeasure(e),
  3044325142: (e) => new f.IfcFrequencyMeasure(e),
  3064340077: (e) => new f.IfcGloballyUniqueId(e),
  3113092358: (e) => new f.IfcHeatFluxDensityMeasure(e),
  1158859006: (e) => new f.IfcHeatingValueMeasure(e),
  2589826445: (e) => new f.IfcHourInDay(e),
  983778844: (e) => new f.IfcIdentifier(e),
  3358199106: (e) => new f.IfcIlluminanceMeasure(e),
  2679005408: (e) => new f.IfcInductanceMeasure(e),
  1939436016: (e) => new f.IfcInteger(e),
  3809634241: (e) => new f.IfcIntegerCountRateMeasure(e),
  3686016028: (e) => new f.IfcIonConcentrationMeasure(e),
  3192672207: (e) => new f.IfcIsothermalMoistureCapacityMeasure(e),
  2054016361: (e) => new f.IfcKinematicViscosityMeasure(e),
  3258342251: (e) => new f.IfcLabel(e),
  1243674935: (e) => new f.IfcLengthMeasure(e),
  191860431: (e) => new f.IfcLinearForceMeasure(e),
  2128979029: (e) => new f.IfcLinearMomentMeasure(e),
  1307019551: (e) => new f.IfcLinearStiffnessMeasure(e),
  3086160713: (e) => new f.IfcLinearVelocityMeasure(e),
  503418787: (e) => new f.IfcLogical(e),
  2095003142: (e) => new f.IfcLuminousFluxMeasure(e),
  2755797622: (e) => new f.IfcLuminousIntensityDistributionMeasure(e),
  151039812: (e) => new f.IfcLuminousIntensityMeasure(e),
  286949696: (e) => new f.IfcMagneticFluxDensityMeasure(e),
  2486716878: (e) => new f.IfcMagneticFluxMeasure(e),
  1477762836: (e) => new f.IfcMassDensityMeasure(e),
  4017473158: (e) => new f.IfcMassFlowRateMeasure(e),
  3124614049: (e) => new f.IfcMassMeasure(e),
  3531705166: (e) => new f.IfcMassPerLengthMeasure(e),
  102610177: (e) => new f.IfcMinuteInHour(e),
  3341486342: (e) => new f.IfcModulusOfElasticityMeasure(e),
  2173214787: (e) => new f.IfcModulusOfLinearSubgradeReactionMeasure(e),
  1052454078: (e) => new f.IfcModulusOfRotationalSubgradeReactionMeasure(e),
  1753493141: (e) => new f.IfcModulusOfSubgradeReactionMeasure(e),
  3177669450: (e) => new f.IfcMoistureDiffusivityMeasure(e),
  1648970520: (e) => new f.IfcMolecularWeightMeasure(e),
  3114022597: (e) => new f.IfcMomentOfInertiaMeasure(e),
  2615040989: (e) => new f.IfcMonetaryMeasure(e),
  765770214: (e) => new f.IfcMonthInYearNumber(e),
  2095195183: (e) => new f.IfcNormalisedRatioMeasure(e),
  2395907400: (e) => new f.IfcNumericMeasure(e),
  929793134: (e) => new f.IfcPHMeasure(e),
  2260317790: (e) => new f.IfcParameterValue(e),
  2642773653: (e) => new f.IfcPlanarForceMeasure(e),
  4042175685: (e) => new f.IfcPlaneAngleMeasure(e),
  2815919920: (e) => new f.IfcPositiveLengthMeasure(e),
  3054510233: (e) => new f.IfcPositivePlaneAngleMeasure(e),
  1245737093: (e) => new f.IfcPositiveRatioMeasure(e),
  1364037233: (e) => new f.IfcPowerMeasure(e),
  2169031380: (e) => new f.IfcPresentableText(e),
  3665567075: (e) => new f.IfcPressureMeasure(e),
  3972513137: (e) => new f.IfcRadioActivityMeasure(e),
  96294661: (e) => new f.IfcRatioMeasure(e),
  200335297: (e) => new f.IfcReal(e),
  2133746277: (e) => new f.IfcRotationalFrequencyMeasure(e),
  1755127002: (e) => new f.IfcRotationalMassMeasure(e),
  3211557302: (e) => new f.IfcRotationalStiffnessMeasure(e),
  2766185779: (e) => new f.IfcSecondInMinute(e),
  3467162246: (e) => new f.IfcSectionModulusMeasure(e),
  2190458107: (e) => new f.IfcSectionalAreaIntegralMeasure(e),
  408310005: (e) => new f.IfcShearModulusMeasure(e),
  3471399674: (e) => new f.IfcSolidAngleMeasure(e),
  846465480: (e) => new f.IfcSoundPowerMeasure(e),
  993287707: (e) => new f.IfcSoundPressureMeasure(e),
  3477203348: (e) => new f.IfcSpecificHeatCapacityMeasure(e),
  2757832317: (e) => new f.IfcSpecularExponent(e),
  361837227: (e) => new f.IfcSpecularRoughness(e),
  58845555: (e) => new f.IfcTemperatureGradientMeasure(e),
  2801250643: (e) => new f.IfcText(e),
  1460886941: (e) => new f.IfcTextAlignment(e),
  3490877962: (e) => new f.IfcTextDecoration(e),
  603696268: (e) => new f.IfcTextFontName(e),
  296282323: (e) => new f.IfcTextTransformation(e),
  232962298: (e) => new f.IfcThermalAdmittanceMeasure(e),
  2645777649: (e) => new f.IfcThermalConductivityMeasure(e),
  2281867870: (e) => new f.IfcThermalExpansionCoefficientMeasure(e),
  857959152: (e) => new f.IfcThermalResistanceMeasure(e),
  2016195849: (e) => new f.IfcThermalTransmittanceMeasure(e),
  743184107: (e) => new f.IfcThermodynamicTemperatureMeasure(e),
  2726807636: (e) => new f.IfcTimeMeasure(e),
  2591213694: (e) => new f.IfcTimeStamp(e),
  1278329552: (e) => new f.IfcTorqueMeasure(e),
  3345633955: (e) => new f.IfcVaporPermeabilityMeasure(e),
  3458127941: (e) => new f.IfcVolumeMeasure(e),
  2593997549: (e) => new f.IfcVolumetricFlowRateMeasure(e),
  51269191: (e) => new f.IfcWarpingConstantMeasure(e),
  1718600412: (e) => new f.IfcWarpingMomentMeasure(e),
  4065007721: (e) => new f.IfcYearNumber(e)
};
var f;
((e) => {
  class t extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCABSORBEDDOSEMEASURE";
    }
  }
  e.IfcAbsorbedDoseMeasure = t;
  class i extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCACCELERATIONMEASURE";
    }
  }
  e.IfcAccelerationMeasure = i;
  class n extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCAMOUNTOFSUBSTANCEMEASURE";
    }
  }
  e.IfcAmountOfSubstanceMeasure = n;
  class s extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCANGULARVELOCITYMEASURE";
    }
  }
  e.IfcAngularVelocityMeasure = s;
  class o extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCAREAMEASURE";
    }
  }
  e.IfcAreaMeasure = o;
  class r {
    constructor(D) {
      this.type = 3, this.name = "IFCBOOLEAN", this.value = D;
    }
  }
  e.IfcBoolean = r;
  class l {
    constructor(D) {
      this.value = D, this.type = 1, this.name = "IFCBOXALIGNMENT";
    }
  }
  e.IfcBoxAlignment = l;
  class c {
    constructor(D) {
      this.value = D, this.type = 4;
    }
  }
  e.IfcComplexNumber = c;
  class h {
    constructor(D) {
      this.value = D, this.type = 10;
    }
  }
  e.IfcCompoundPlaneAngleMeasure = h;
  class I extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCCONTEXTDEPENDENTMEASURE";
    }
  }
  e.IfcContextDependentMeasure = I;
  class p extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCCOUNTMEASURE";
    }
  }
  e.IfcCountMeasure = p;
  class y extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCCURVATUREMEASURE";
    }
  }
  e.IfcCurvatureMeasure = y;
  class m extends pt {
    constructor() {
      super(...arguments), this.type = 10, this.name = "IFCDAYINMONTHNUMBER";
    }
  }
  e.IfcDayInMonthNumber = m;
  class A extends pt {
    constructor() {
      super(...arguments), this.type = 10, this.name = "IFCDAYLIGHTSAVINGHOUR";
    }
  }
  e.IfcDaylightSavingHour = A;
  class C {
    constructor(D) {
      this.value = D, this.type = 1, this.name = "IFCDESCRIPTIVEMEASURE";
    }
  }
  e.IfcDescriptiveMeasure = C;
  class O extends pt {
    constructor() {
      super(...arguments), this.type = 10, this.name = "IFCDIMENSIONCOUNT";
    }
  }
  e.IfcDimensionCount = O;
  class R extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCDOSEEQUIVALENTMEASURE";
    }
  }
  e.IfcDoseEquivalentMeasure = R;
  class F extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCDYNAMICVISCOSITYMEASURE";
    }
  }
  e.IfcDynamicViscosityMeasure = F;
  class L extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCELECTRICCAPACITANCEMEASURE";
    }
  }
  e.IfcElectricCapacitanceMeasure = L;
  class P extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCELECTRICCHARGEMEASURE";
    }
  }
  e.IfcElectricChargeMeasure = P;
  class z extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCELECTRICCONDUCTANCEMEASURE";
    }
  }
  e.IfcElectricConductanceMeasure = z;
  class W extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCELECTRICCURRENTMEASURE";
    }
  }
  e.IfcElectricCurrentMeasure = W;
  class re extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCELECTRICRESISTANCEMEASURE";
    }
  }
  e.IfcElectricResistanceMeasure = re;
  class ce extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCELECTRICVOLTAGEMEASURE";
    }
  }
  e.IfcElectricVoltageMeasure = ce;
  class te extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCENERGYMEASURE";
    }
  }
  e.IfcEnergyMeasure = te;
  class ee {
    constructor(D) {
      this.value = D, this.type = 1, this.name = "IFCFONTSTYLE";
    }
  }
  e.IfcFontStyle = ee;
  class Ne {
    constructor(D) {
      this.value = D, this.type = 1, this.name = "IFCFONTVARIANT";
    }
  }
  e.IfcFontVariant = Ne;
  class Ae {
    constructor(D) {
      this.value = D, this.type = 1, this.name = "IFCFONTWEIGHT";
    }
  }
  e.IfcFontWeight = Ae;
  class Oe extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCFORCEMEASURE";
    }
  }
  e.IfcForceMeasure = Oe;
  class pe extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCFREQUENCYMEASURE";
    }
  }
  e.IfcFrequencyMeasure = pe;
  class je {
    constructor(D) {
      this.value = D, this.type = 1, this.name = "IFCGLOBALLYUNIQUEID";
    }
  }
  e.IfcGloballyUniqueId = je;
  class Ve extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCHEATFLUXDENSITYMEASURE";
    }
  }
  e.IfcHeatFluxDensityMeasure = Ve;
  class $e extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCHEATINGVALUEMEASURE";
    }
  }
  e.IfcHeatingValueMeasure = $e;
  class vt extends pt {
    constructor() {
      super(...arguments), this.type = 10, this.name = "IFCHOURINDAY";
    }
  }
  e.IfcHourInDay = vt;
  class Rt {
    constructor(D) {
      this.value = D, this.type = 1, this.name = "IFCIDENTIFIER";
    }
  }
  e.IfcIdentifier = Rt;
  class ze extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCILLUMINANCEMEASURE";
    }
  }
  e.IfcIlluminanceMeasure = ze;
  class mt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCINDUCTANCEMEASURE";
    }
  }
  e.IfcInductanceMeasure = mt;
  class Et extends pt {
    constructor() {
      super(...arguments), this.type = 10, this.name = "IFCINTEGER";
    }
  }
  e.IfcInteger = Et;
  class it extends pt {
    constructor() {
      super(...arguments), this.type = 10, this.name = "IFCINTEGERCOUNTRATEMEASURE";
    }
  }
  e.IfcIntegerCountRateMeasure = it;
  class Dt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCIONCONCENTRATIONMEASURE";
    }
  }
  e.IfcIonConcentrationMeasure = Dt;
  class Ct extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCISOTHERMALMOISTURECAPACITYMEASURE";
    }
  }
  e.IfcIsothermalMoistureCapacityMeasure = Ct;
  class Kt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCKINEMATICVISCOSITYMEASURE";
    }
  }
  e.IfcKinematicViscosityMeasure = Kt;
  class Zt {
    constructor(D) {
      this.value = D, this.type = 1, this.name = "IFCLABEL";
    }
  }
  e.IfcLabel = Zt;
  class Xt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCLENGTHMEASURE";
    }
  }
  e.IfcLengthMeasure = Xt;
  class gi extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCLINEARFORCEMEASURE";
    }
  }
  e.IfcLinearForceMeasure = gi;
  class Wt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCLINEARMOMENTMEASURE";
    }
  }
  e.IfcLinearMomentMeasure = Wt;
  class Di extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCLINEARSTIFFNESSMEASURE";
    }
  }
  e.IfcLinearStiffnessMeasure = Di;
  class ni extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCLINEARVELOCITYMEASURE";
    }
  }
  e.IfcLinearVelocityMeasure = ni;
  class Ci {
    constructor(D) {
      this.type = 3, this.name = "IFCLOGICAL", this.value = D;
    }
  }
  e.IfcLogical = Ci;
  class Se extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCLUMINOUSFLUXMEASURE";
    }
  }
  e.IfcLuminousFluxMeasure = Se;
  class si extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCLUMINOUSINTENSITYDISTRIBUTIONMEASURE";
    }
  }
  e.IfcLuminousIntensityDistributionMeasure = si;
  class Mt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCLUMINOUSINTENSITYMEASURE";
    }
  }
  e.IfcLuminousIntensityMeasure = Mt;
  class ft extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMAGNETICFLUXDENSITYMEASURE";
    }
  }
  e.IfcMagneticFluxDensityMeasure = ft;
  class rt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMAGNETICFLUXMEASURE";
    }
  }
  e.IfcMagneticFluxMeasure = rt;
  class Tt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMASSDENSITYMEASURE";
    }
  }
  e.IfcMassDensityMeasure = Tt;
  class jt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMASSFLOWRATEMEASURE";
    }
  }
  e.IfcMassFlowRateMeasure = jt;
  class Jt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMASSMEASURE";
    }
  }
  e.IfcMassMeasure = Jt;
  class $t extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMASSPERLENGTHMEASURE";
    }
  }
  e.IfcMassPerLengthMeasure = $t;
  class ht extends pt {
    constructor() {
      super(...arguments), this.type = 10, this.name = "IFCMINUTEINHOUR";
    }
  }
  e.IfcMinuteInHour = ht;
  class Me extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMODULUSOFELASTICITYMEASURE";
    }
  }
  e.IfcModulusOfElasticityMeasure = Me;
  class gt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMODULUSOFLINEARSUBGRADEREACTIONMEASURE";
    }
  }
  e.IfcModulusOfLinearSubgradeReactionMeasure = gt;
  class yt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMODULUSOFROTATIONALSUBGRADEREACTIONMEASURE";
    }
  }
  e.IfcModulusOfRotationalSubgradeReactionMeasure = yt;
  class Ut extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMODULUSOFSUBGRADEREACTIONMEASURE";
    }
  }
  e.IfcModulusOfSubgradeReactionMeasure = Ut;
  class Ht extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMOISTUREDIFFUSIVITYMEASURE";
    }
  }
  e.IfcMoistureDiffusivityMeasure = Ht;
  class wi extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMOLECULARWEIGHTMEASURE";
    }
  }
  e.IfcMolecularWeightMeasure = wi;
  class bi extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMOMENTOFINERTIAMEASURE";
    }
  }
  e.IfcMomentOfInertiaMeasure = bi;
  class Hi extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMONETARYMEASURE";
    }
  }
  e.IfcMonetaryMeasure = Hi;
  class Wi extends pt {
    constructor() {
      super(...arguments), this.type = 10, this.name = "IFCMONTHINYEARNUMBER";
    }
  }
  e.IfcMonthInYearNumber = Wi;
  class hi extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCNORMALISEDRATIOMEASURE";
    }
  }
  e.IfcNormalisedRatioMeasure = hi;
  class Ji extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCNUMERICMEASURE";
    }
  }
  e.IfcNumericMeasure = Ji;
  class Sn extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCPHMEASURE";
    }
  }
  e.IfcPHMeasure = Sn;
  class nn extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCPARAMETERVALUE";
    }
  }
  e.IfcParameterValue = nn;
  class Yi extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCPLANARFORCEMEASURE";
    }
  }
  e.IfcPlanarForceMeasure = Yi;
  class Pi extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCPLANEANGLEMEASURE";
    }
  }
  e.IfcPlaneAngleMeasure = Pi;
  class kt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCPOSITIVELENGTHMEASURE";
    }
  }
  e.IfcPositiveLengthMeasure = kt;
  class sn extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCPOSITIVEPLANEANGLEMEASURE";
    }
  }
  e.IfcPositivePlaneAngleMeasure = sn;
  class Fi extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCPOSITIVERATIOMEASURE";
    }
  }
  e.IfcPositiveRatioMeasure = Fi;
  class tn extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCPOWERMEASURE";
    }
  }
  e.IfcPowerMeasure = tn;
  class Gi {
    constructor(D) {
      this.value = D, this.type = 1, this.name = "IFCPRESENTABLETEXT";
    }
  }
  e.IfcPresentableText = Gi;
  class yi extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCPRESSUREMEASURE";
    }
  }
  e.IfcPressureMeasure = yi;
  class bn extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCRADIOACTIVITYMEASURE";
    }
  }
  e.IfcRadioActivityMeasure = bn;
  class ln extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCRATIOMEASURE";
    }
  }
  e.IfcRatioMeasure = ln;
  class No extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCREAL";
    }
  }
  e.IfcReal = No;
  class Bs extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCROTATIONALFREQUENCYMEASURE";
    }
  }
  e.IfcRotationalFrequencyMeasure = Bs;
  class os extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCROTATIONALMASSMEASURE";
    }
  }
  e.IfcRotationalMassMeasure = os;
  class vl extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCROTATIONALSTIFFNESSMEASURE";
    }
  }
  e.IfcRotationalStiffnessMeasure = vl;
  class zl extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCSECONDINMINUTE";
    }
  }
  e.IfcSecondInMinute = zl;
  class Wu extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCSECTIONMODULUSMEASURE";
    }
  }
  e.IfcSectionModulusMeasure = Wu;
  class jl extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCSECTIONALAREAINTEGRALMEASURE";
    }
  }
  e.IfcSectionalAreaIntegralMeasure = jl;
  class Yu extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCSHEARMODULUSMEASURE";
    }
  }
  e.IfcShearModulusMeasure = Yu;
  class bd extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCSOLIDANGLEMEASURE";
    }
  }
  e.IfcSolidAngleMeasure = bd;
  class I0 extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCSOUNDPOWERMEASURE";
    }
  }
  e.IfcSoundPowerMeasure = I0;
  class Gt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCSOUNDPRESSUREMEASURE";
    }
  }
  e.IfcSoundPressureMeasure = Gt;
  class Vi extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCSPECIFICHEATCAPACITYMEASURE";
    }
  }
  e.IfcSpecificHeatCapacityMeasure = Vi;
  class _i extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCSPECULAREXPONENT";
    }
  }
  e.IfcSpecularExponent = _i;
  class $n extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCSPECULARROUGHNESS";
    }
  }
  e.IfcSpecularRoughness = $n;
  class Os extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCTEMPERATUREGRADIENTMEASURE";
    }
  }
  e.IfcTemperatureGradientMeasure = Os;
  class Ai {
    constructor(D) {
      this.value = D, this.type = 1, this.name = "IFCTEXT";
    }
  }
  e.IfcText = Ai;
  class As {
    constructor(D) {
      this.value = D, this.type = 1, this.name = "IFCTEXTALIGNMENT";
    }
  }
  e.IfcTextAlignment = As;
  class Es {
    constructor(D) {
      this.value = D, this.type = 1, this.name = "IFCTEXTDECORATION";
    }
  }
  e.IfcTextDecoration = Es;
  class mr {
    constructor(D) {
      this.value = D, this.type = 1, this.name = "IFCTEXTFONTNAME";
    }
  }
  e.IfcTextFontName = mr;
  class Je {
    constructor(D) {
      this.value = D, this.type = 1, this.name = "IFCTEXTTRANSFORMATION";
    }
  }
  e.IfcTextTransformation = Je;
  class no extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCTHERMALADMITTANCEMEASURE";
    }
  }
  e.IfcThermalAdmittanceMeasure = no;
  class It extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCTHERMALCONDUCTIVITYMEASURE";
    }
  }
  e.IfcThermalConductivityMeasure = It;
  class Qt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCTHERMALEXPANSIONCOEFFICIENTMEASURE";
    }
  }
  e.IfcThermalExpansionCoefficientMeasure = Qt;
  class ci extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCTHERMALRESISTANCEMEASURE";
    }
  }
  e.IfcThermalResistanceMeasure = ci;
  class ai extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCTHERMALTRANSMITTANCEMEASURE";
    }
  }
  e.IfcThermalTransmittanceMeasure = ai;
  class ei extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCTHERMODYNAMICTEMPERATUREMEASURE";
    }
  }
  e.IfcThermodynamicTemperatureMeasure = ei;
  class Si extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCTIMEMEASURE";
    }
  }
  e.IfcTimeMeasure = Si;
  class mn extends pt {
    constructor() {
      super(...arguments), this.type = 10, this.name = "IFCTIMESTAMP";
    }
  }
  e.IfcTimeStamp = mn;
  class wn extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCTORQUEMEASURE";
    }
  }
  e.IfcTorqueMeasure = wn;
  class Nn extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCVAPORPERMEABILITYMEASURE";
    }
  }
  e.IfcVaporPermeabilityMeasure = Nn;
  class Kn extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCVOLUMEMEASURE";
    }
  }
  e.IfcVolumeMeasure = Kn;
  class is extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCVOLUMETRICFLOWRATEMEASURE";
    }
  }
  e.IfcVolumetricFlowRateMeasure = is;
  class jn extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCWARPINGCONSTANTMEASURE";
    }
  }
  e.IfcWarpingConstantMeasure = jn;
  class _s extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCWARPINGMOMENTMEASURE";
    }
  }
  e.IfcWarpingMomentMeasure = _s;
  class yo extends pt {
    constructor() {
      super(...arguments), this.type = 10, this.name = "IFCYEARNUMBER";
    }
  }
  e.IfcYearNumber = yo;
  const Dr = class Dr {
  };
  Dr.DEAD_LOAD_G = { type: 3, value: "DEAD_LOAD_G" }, Dr.COMPLETION_G1 = { type: 3, value: "COMPLETION_G1" }, Dr.LIVE_LOAD_Q = { type: 3, value: "LIVE_LOAD_Q" }, Dr.SNOW_S = { type: 3, value: "SNOW_S" }, Dr.WIND_W = { type: 3, value: "WIND_W" }, Dr.PRESTRESSING_P = { type: 3, value: "PRESTRESSING_P" }, Dr.SETTLEMENT_U = { type: 3, value: "SETTLEMENT_U" }, Dr.TEMPERATURE_T = { type: 3, value: "TEMPERATURE_T" }, Dr.EARTHQUAKE_E = { type: 3, value: "EARTHQUAKE_E" }, Dr.FIRE = { type: 3, value: "FIRE" }, Dr.IMPULSE = { type: 3, value: "IMPULSE" }, Dr.IMPACT = { type: 3, value: "IMPACT" }, Dr.TRANSPORT = { type: 3, value: "TRANSPORT" }, Dr.ERECTION = { type: 3, value: "ERECTION" }, Dr.PROPPING = { type: 3, value: "PROPPING" }, Dr.SYSTEM_IMPERFECTION = { type: 3, value: "SYSTEM_IMPERFECTION" }, Dr.SHRINKAGE = { type: 3, value: "SHRINKAGE" }, Dr.CREEP = { type: 3, value: "CREEP" }, Dr.LACK_OF_FIT = { type: 3, value: "LACK_OF_FIT" }, Dr.BUOYANCY = { type: 3, value: "BUOYANCY" }, Dr.ICE = { type: 3, value: "ICE" }, Dr.CURRENT = { type: 3, value: "CURRENT" }, Dr.WAVE = { type: 3, value: "WAVE" }, Dr.RAIN = { type: 3, value: "RAIN" }, Dr.BRAKES = { type: 3, value: "BRAKES" }, Dr.USERDEFINED = { type: 3, value: "USERDEFINED" }, Dr.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Qo = Dr;
  e.IfcActionSourceTypeEnum = Qo;
  const IR = class IR {
  };
  IR.PERMANENT_G = { type: 3, value: "PERMANENT_G" }, IR.VARIABLE_Q = { type: 3, value: "VARIABLE_Q" }, IR.EXTRAORDINARY_A = { type: 3, value: "EXTRAORDINARY_A" }, IR.USERDEFINED = { type: 3, value: "USERDEFINED" }, IR.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let so = IR;
  e.IfcActionTypeEnum = so;
  const dw = class dw {
  };
  dw.ELECTRICACTUATOR = { type: 3, value: "ELECTRICACTUATOR" }, dw.HANDOPERATEDACTUATOR = { type: 3, value: "HANDOPERATEDACTUATOR" }, dw.HYDRAULICACTUATOR = { type: 3, value: "HYDRAULICACTUATOR" }, dw.PNEUMATICACTUATOR = { type: 3, value: "PNEUMATICACTUATOR" }, dw.THERMOSTATICACTUATOR = { type: 3, value: "THERMOSTATICACTUATOR" }, dw.USERDEFINED = { type: 3, value: "USERDEFINED" }, dw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Eo = dw;
  e.IfcActuatorTypeEnum = Eo;
  const pR = class pR {
  };
  pR.OFFICE = { type: 3, value: "OFFICE" }, pR.SITE = { type: 3, value: "SITE" }, pR.HOME = { type: 3, value: "HOME" }, pR.DISTRIBUTIONPOINT = { type: 3, value: "DISTRIBUTIONPOINT" }, pR.USERDEFINED = { type: 3, value: "USERDEFINED" };
  let Yn = pR;
  e.IfcAddressTypeEnum = Yn;
  const w7 = class w7 {
  };
  w7.AHEAD = { type: 3, value: "AHEAD" }, w7.BEHIND = { type: 3, value: "BEHIND" };
  let Jo = w7;
  e.IfcAheadOrBehind = Jo;
  const mR = class mR {
  };
  mR.CONSTANTFLOW = { type: 3, value: "CONSTANTFLOW" }, mR.VARIABLEFLOWPRESSUREDEPENDANT = { type: 3, value: "VARIABLEFLOWPRESSUREDEPENDANT" }, mR.VARIABLEFLOWPRESSUREINDEPENDANT = { type: 3, value: "VARIABLEFLOWPRESSUREINDEPENDANT" }, mR.USERDEFINED = { type: 3, value: "USERDEFINED" }, mR.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let xs = mR;
  e.IfcAirTerminalBoxTypeEnum = xs;
  const ty = class ty {
  };
  ty.GRILLE = { type: 3, value: "GRILLE" }, ty.REGISTER = { type: 3, value: "REGISTER" }, ty.DIFFUSER = { type: 3, value: "DIFFUSER" }, ty.EYEBALL = { type: 3, value: "EYEBALL" }, ty.IRIS = { type: 3, value: "IRIS" }, ty.LINEARGRILLE = { type: 3, value: "LINEARGRILLE" }, ty.LINEARDIFFUSER = { type: 3, value: "LINEARDIFFUSER" }, ty.USERDEFINED = { type: 3, value: "USERDEFINED" }, ty.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Gr = ty;
  e.IfcAirTerminalTypeEnum = Gr;
  const YI = class YI {
  };
  YI.FIXEDPLATECOUNTERFLOWEXCHANGER = { type: 3, value: "FIXEDPLATECOUNTERFLOWEXCHANGER" }, YI.FIXEDPLATECROSSFLOWEXCHANGER = { type: 3, value: "FIXEDPLATECROSSFLOWEXCHANGER" }, YI.FIXEDPLATEPARALLELFLOWEXCHANGER = { type: 3, value: "FIXEDPLATEPARALLELFLOWEXCHANGER" }, YI.ROTARYWHEEL = { type: 3, value: "ROTARYWHEEL" }, YI.RUNAROUNDCOILLOOP = { type: 3, value: "RUNAROUNDCOILLOOP" }, YI.HEATPIPE = { type: 3, value: "HEATPIPE" }, YI.TWINTOWERENTHALPYRECOVERYLOOPS = { type: 3, value: "TWINTOWERENTHALPYRECOVERYLOOPS" }, YI.THERMOSIPHONSEALEDTUBEHEATEXCHANGERS = { type: 3, value: "THERMOSIPHONSEALEDTUBEHEATEXCHANGERS" }, YI.THERMOSIPHONCOILTYPEHEATEXCHANGERS = { type: 3, value: "THERMOSIPHONCOILTYPEHEATEXCHANGERS" }, YI.USERDEFINED = { type: 3, value: "USERDEFINED" }, YI.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let sa = YI;
  e.IfcAirToAirHeatRecoveryTypeEnum = sa;
  const NE = class NE {
  };
  NE.BELL = { type: 3, value: "BELL" }, NE.BREAKGLASSBUTTON = { type: 3, value: "BREAKGLASSBUTTON" }, NE.LIGHT = { type: 3, value: "LIGHT" }, NE.MANUALPULLBOX = { type: 3, value: "MANUALPULLBOX" }, NE.SIREN = { type: 3, value: "SIREN" }, NE.WHISTLE = { type: 3, value: "WHISTLE" }, NE.USERDEFINED = { type: 3, value: "USERDEFINED" }, NE.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let yr = NE;
  e.IfcAlarmTypeEnum = yr;
  const sT = class sT {
  };
  sT.IN_PLANE_LOADING_2D = { type: 3, value: "IN_PLANE_LOADING_2D" }, sT.OUT_PLANE_LOADING_2D = { type: 3, value: "OUT_PLANE_LOADING_2D" }, sT.LOADING_3D = { type: 3, value: "LOADING_3D" }, sT.USERDEFINED = { type: 3, value: "USERDEFINED" }, sT.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let nr = sT;
  e.IfcAnalysisModelTypeEnum = nr;
  const cw = class cw {
  };
  cw.FIRST_ORDER_THEORY = { type: 3, value: "FIRST_ORDER_THEORY" }, cw.SECOND_ORDER_THEORY = { type: 3, value: "SECOND_ORDER_THEORY" }, cw.THIRD_ORDER_THEORY = { type: 3, value: "THIRD_ORDER_THEORY" }, cw.FULL_NONLINEAR_THEORY = { type: 3, value: "FULL_NONLINEAR_THEORY" }, cw.USERDEFINED = { type: 3, value: "USERDEFINED" }, cw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ws = cw;
  e.IfcAnalysisTheoryTypeEnum = Ws;
  const yS = class yS {
  };
  yS.ADD = { type: 3, value: "ADD" }, yS.DIVIDE = { type: 3, value: "DIVIDE" }, yS.MULTIPLY = { type: 3, value: "MULTIPLY" }, yS.SUBTRACT = { type: 3, value: "SUBTRACT" };
  let ul = yS;
  e.IfcArithmeticOperatorEnum = ul;
  const Y6 = class Y6 {
  };
  Y6.SITE = { type: 3, value: "SITE" }, Y6.FACTORY = { type: 3, value: "FACTORY" }, Y6.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let ur = Y6;
  e.IfcAssemblyPlaceEnum = ur;
  const hw = class hw {
  };
  hw.POLYLINE_FORM = { type: 3, value: "POLYLINE_FORM" }, hw.CIRCULAR_ARC = { type: 3, value: "CIRCULAR_ARC" }, hw.ELLIPTIC_ARC = { type: 3, value: "ELLIPTIC_ARC" }, hw.PARABOLIC_ARC = { type: 3, value: "PARABOLIC_ARC" }, hw.HYPERBOLIC_ARC = { type: 3, value: "HYPERBOLIC_ARC" }, hw.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" };
  let ao = hw;
  e.IfcBSplineCurveForm = ao;
  const Cr = class Cr {
  };
  Cr.BEAM = { type: 3, value: "BEAM" }, Cr.JOIST = { type: 3, value: "JOIST" }, Cr.LINTEL = { type: 3, value: "LINTEL" }, Cr.T_BEAM = { type: 3, value: "T_BEAM" }, Cr.USERDEFINED = { type: 3, value: "USERDEFINED" }, Cr.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let kr = Cr;
  e.IfcBeamTypeEnum = kr;
  const fw = class fw {
  };
  fw.GREATERTHAN = { type: 3, value: "GREATERTHAN" }, fw.GREATERTHANOREQUALTO = { type: 3, value: "GREATERTHANOREQUALTO" }, fw.LESSTHAN = { type: 3, value: "LESSTHAN" }, fw.LESSTHANOREQUALTO = { type: 3, value: "LESSTHANOREQUALTO" }, fw.EQUALTO = { type: 3, value: "EQUALTO" }, fw.NOTEQUALTO = { type: 3, value: "NOTEQUALTO" };
  let oa = fw;
  e.IfcBenchmarkEnum = oa;
  const Iw = class Iw {
  };
  Iw.WATER = { type: 3, value: "WATER" }, Iw.STEAM = { type: 3, value: "STEAM" }, Iw.USERDEFINED = { type: 3, value: "USERDEFINED" }, Iw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Po = Iw;
  e.IfcBoilerTypeEnum = Po;
  const q6 = class q6 {
  };
  q6.UNION = { type: 3, value: "UNION" }, q6.INTERSECTION = { type: 3, value: "INTERSECTION" }, q6.DIFFERENCE = { type: 3, value: "DIFFERENCE" };
  let NI = q6;
  e.IfcBooleanOperator = NI;
  const T7 = class T7 {
  };
  T7.USERDEFINED = { type: 3, value: "USERDEFINED" }, T7.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Tc = T7;
  e.IfcBuildingElementProxyTypeEnum = Tc;
  const oT = class oT {
  };
  oT.BEND = { type: 3, value: "BEND" }, oT.CROSS = { type: 3, value: "CROSS" }, oT.REDUCER = { type: 3, value: "REDUCER" }, oT.TEE = { type: 3, value: "TEE" }, oT.USERDEFINED = { type: 3, value: "USERDEFINED" }, oT.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let bf = oT;
  e.IfcCableCarrierFittingTypeEnum = bf;
  const rT = class rT {
  };
  rT.CABLELADDERSEGMENT = { type: 3, value: "CABLELADDERSEGMENT" }, rT.CABLETRAYSEGMENT = { type: 3, value: "CABLETRAYSEGMENT" }, rT.CABLETRUNKINGSEGMENT = { type: 3, value: "CABLETRUNKINGSEGMENT" }, rT.CONDUITSEGMENT = { type: 3, value: "CONDUITSEGMENT" }, rT.USERDEFINED = { type: 3, value: "USERDEFINED" }, rT.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Rc = rT;
  e.IfcCableCarrierSegmentTypeEnum = Rc;
  const ES = class ES {
  };
  ES.CABLESEGMENT = { type: 3, value: "CABLESEGMENT" }, ES.CONDUCTORSEGMENT = { type: 3, value: "CONDUCTORSEGMENT" }, ES.USERDEFINED = { type: 3, value: "USERDEFINED" }, ES.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Sr = ES;
  e.IfcCableSegmentTypeEnum = Sr;
  const lT = class lT {
  };
  lT.NOCHANGE = { type: 3, value: "NOCHANGE" }, lT.MODIFIED = { type: 3, value: "MODIFIED" }, lT.ADDED = { type: 3, value: "ADDED" }, lT.DELETED = { type: 3, value: "DELETED" }, lT.MODIFIEDADDED = { type: 3, value: "MODIFIEDADDED" }, lT.MODIFIEDDELETED = { type: 3, value: "MODIFIEDDELETED" };
  let ra = lT;
  e.IfcChangeActionEnum = ra;
  const yR = class yR {
  };
  yR.AIRCOOLED = { type: 3, value: "AIRCOOLED" }, yR.WATERCOOLED = { type: 3, value: "WATERCOOLED" }, yR.HEATRECOVERY = { type: 3, value: "HEATRECOVERY" }, yR.USERDEFINED = { type: 3, value: "USERDEFINED" }, yR.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ls = yR;
  e.IfcChillerTypeEnum = Ls;
  const DE = class DE {
  };
  DE.DXCOOLINGCOIL = { type: 3, value: "DXCOOLINGCOIL" }, DE.WATERCOOLINGCOIL = { type: 3, value: "WATERCOOLINGCOIL" }, DE.STEAMHEATINGCOIL = { type: 3, value: "STEAMHEATINGCOIL" }, DE.WATERHEATINGCOIL = { type: 3, value: "WATERHEATINGCOIL" }, DE.ELECTRICHEATINGCOIL = { type: 3, value: "ELECTRICHEATINGCOIL" }, DE.GASHEATINGCOIL = { type: 3, value: "GASHEATINGCOIL" }, DE.USERDEFINED = { type: 3, value: "USERDEFINED" }, DE.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let vc = DE;
  e.IfcCoilTypeEnum = vc;
  const $6 = class $6 {
  };
  $6.COLUMN = { type: 3, value: "COLUMN" }, $6.USERDEFINED = { type: 3, value: "USERDEFINED" }, $6.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let la = $6;
  e.IfcColumnTypeEnum = la;
  const Xu = class Xu {
  };
  Xu.DYNAMIC = { type: 3, value: "DYNAMIC" }, Xu.RECIPROCATING = { type: 3, value: "RECIPROCATING" }, Xu.ROTARY = { type: 3, value: "ROTARY" }, Xu.SCROLL = { type: 3, value: "SCROLL" }, Xu.TROCHOIDAL = { type: 3, value: "TROCHOIDAL" }, Xu.SINGLESTAGE = { type: 3, value: "SINGLESTAGE" }, Xu.BOOSTER = { type: 3, value: "BOOSTER" }, Xu.OPENTYPE = { type: 3, value: "OPENTYPE" }, Xu.HERMETIC = { type: 3, value: "HERMETIC" }, Xu.SEMIHERMETIC = { type: 3, value: "SEMIHERMETIC" }, Xu.WELDEDSHELLHERMETIC = { type: 3, value: "WELDEDSHELLHERMETIC" }, Xu.ROLLINGPISTON = { type: 3, value: "ROLLINGPISTON" }, Xu.ROTARYVANE = { type: 3, value: "ROTARYVANE" }, Xu.SINGLESCREW = { type: 3, value: "SINGLESCREW" }, Xu.TWINSCREW = { type: 3, value: "TWINSCREW" }, Xu.USERDEFINED = { type: 3, value: "USERDEFINED" }, Xu.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Nf = Xu;
  e.IfcCompressorTypeEnum = Nf;
  const CE = class CE {
  };
  CE.WATERCOOLEDSHELLTUBE = { type: 3, value: "WATERCOOLEDSHELLTUBE" }, CE.WATERCOOLEDSHELLCOIL = { type: 3, value: "WATERCOOLEDSHELLCOIL" }, CE.WATERCOOLEDTUBEINTUBE = { type: 3, value: "WATERCOOLEDTUBEINTUBE" }, CE.WATERCOOLEDBRAZEDPLATE = { type: 3, value: "WATERCOOLEDBRAZEDPLATE" }, CE.AIRCOOLED = { type: 3, value: "AIRCOOLED" }, CE.EVAPORATIVECOOLED = { type: 3, value: "EVAPORATIVECOOLED" }, CE.USERDEFINED = { type: 3, value: "USERDEFINED" }, CE.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let DI = CE;
  e.IfcCondenserTypeEnum = DI;
  const gS = class gS {
  };
  gS.ATPATH = { type: 3, value: "ATPATH" }, gS.ATSTART = { type: 3, value: "ATSTART" }, gS.ATEND = { type: 3, value: "ATEND" }, gS.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Df = gS;
  e.IfcConnectionTypeEnum = Df;
  const ER = class ER {
  };
  ER.HARD = { type: 3, value: "HARD" }, ER.SOFT = { type: 3, value: "SOFT" }, ER.ADVISORY = { type: 3, value: "ADVISORY" }, ER.USERDEFINED = { type: 3, value: "USERDEFINED" }, ER.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let dl = ER;
  e.IfcConstraintEnum = dl;
  const T0 = class T0 {
  };
  T0.FLOATING = { type: 3, value: "FLOATING" }, T0.PROPORTIONAL = { type: 3, value: "PROPORTIONAL" }, T0.PROPORTIONALINTEGRAL = { type: 3, value: "PROPORTIONALINTEGRAL" }, T0.PROPORTIONALINTEGRALDERIVATIVE = { type: 3, value: "PROPORTIONALINTEGRALDERIVATIVE" }, T0.TIMEDTWOPOSITION = { type: 3, value: "TIMEDTWOPOSITION" }, T0.TWOPOSITION = { type: 3, value: "TWOPOSITION" }, T0.USERDEFINED = { type: 3, value: "USERDEFINED" }, T0.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ac = T0;
  e.IfcControllerTypeEnum = Ac;
  const iy = class iy {
  };
  iy.ACTIVE = { type: 3, value: "ACTIVE" }, iy.PASSIVE = { type: 3, value: "PASSIVE" }, iy.USERDEFINED = { type: 3, value: "USERDEFINED" }, iy.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Sc = iy;
  e.IfcCooledBeamTypeEnum = Sc;
  const gR = class gR {
  };
  gR.NATURALDRAFT = { type: 3, value: "NATURALDRAFT" }, gR.MECHANICALINDUCEDDRAFT = { type: 3, value: "MECHANICALINDUCEDDRAFT" }, gR.MECHANICALFORCEDDRAFT = { type: 3, value: "MECHANICALFORCEDDRAFT" }, gR.USERDEFINED = { type: 3, value: "USERDEFINED" }, gR.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let CI = gR;
  e.IfcCoolingTowerTypeEnum = CI;
  const ny = class ny {
  };
  ny.BUDGET = { type: 3, value: "BUDGET" }, ny.COSTPLAN = { type: 3, value: "COSTPLAN" }, ny.ESTIMATE = { type: 3, value: "ESTIMATE" }, ny.TENDER = { type: 3, value: "TENDER" }, ny.PRICEDBILLOFQUANTITIES = { type: 3, value: "PRICEDBILLOFQUANTITIES" }, ny.UNPRICEDBILLOFQUANTITIES = { type: 3, value: "UNPRICEDBILLOFQUANTITIES" }, ny.SCHEDULEOFRATES = { type: 3, value: "SCHEDULEOFRATES" }, ny.USERDEFINED = { type: 3, value: "USERDEFINED" }, ny.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let go = ny;
  e.IfcCostScheduleTypeEnum = go;
  const fm = class fm {
  };
  fm.CEILING = { type: 3, value: "CEILING" }, fm.FLOORING = { type: 3, value: "FLOORING" }, fm.CLADDING = { type: 3, value: "CLADDING" }, fm.ROOFING = { type: 3, value: "ROOFING" }, fm.INSULATION = { type: 3, value: "INSULATION" }, fm.MEMBRANE = { type: 3, value: "MEMBRANE" }, fm.SLEEVING = { type: 3, value: "SLEEVING" }, fm.WRAPPING = { type: 3, value: "WRAPPING" }, fm.USERDEFINED = { type: 3, value: "USERDEFINED" }, fm.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Cf = fm;
  e.IfcCoveringTypeEnum = Cf;
  const fn = class fn {
  };
  fn.AED = { type: 3, value: "AED" }, fn.AES = { type: 3, value: "AES" }, fn.ATS = { type: 3, value: "ATS" }, fn.AUD = { type: 3, value: "AUD" }, fn.BBD = { type: 3, value: "BBD" }, fn.BEG = { type: 3, value: "BEG" }, fn.BGL = { type: 3, value: "BGL" }, fn.BHD = { type: 3, value: "BHD" }, fn.BMD = { type: 3, value: "BMD" }, fn.BND = { type: 3, value: "BND" }, fn.BRL = { type: 3, value: "BRL" }, fn.BSD = { type: 3, value: "BSD" }, fn.BWP = { type: 3, value: "BWP" }, fn.BZD = { type: 3, value: "BZD" }, fn.CAD = { type: 3, value: "CAD" }, fn.CBD = { type: 3, value: "CBD" }, fn.CHF = { type: 3, value: "CHF" }, fn.CLP = { type: 3, value: "CLP" }, fn.CNY = { type: 3, value: "CNY" }, fn.CYS = { type: 3, value: "CYS" }, fn.CZK = { type: 3, value: "CZK" }, fn.DDP = { type: 3, value: "DDP" }, fn.DEM = { type: 3, value: "DEM" }, fn.DKK = { type: 3, value: "DKK" }, fn.EGL = { type: 3, value: "EGL" }, fn.EST = { type: 3, value: "EST" }, fn.EUR = { type: 3, value: "EUR" }, fn.FAK = { type: 3, value: "FAK" }, fn.FIM = { type: 3, value: "FIM" }, fn.FJD = { type: 3, value: "FJD" }, fn.FKP = { type: 3, value: "FKP" }, fn.FRF = { type: 3, value: "FRF" }, fn.GBP = { type: 3, value: "GBP" }, fn.GIP = { type: 3, value: "GIP" }, fn.GMD = { type: 3, value: "GMD" }, fn.GRX = { type: 3, value: "GRX" }, fn.HKD = { type: 3, value: "HKD" }, fn.HUF = { type: 3, value: "HUF" }, fn.ICK = { type: 3, value: "ICK" }, fn.IDR = { type: 3, value: "IDR" }, fn.ILS = { type: 3, value: "ILS" }, fn.INR = { type: 3, value: "INR" }, fn.IRP = { type: 3, value: "IRP" }, fn.ITL = { type: 3, value: "ITL" }, fn.JMD = { type: 3, value: "JMD" }, fn.JOD = { type: 3, value: "JOD" }, fn.JPY = { type: 3, value: "JPY" }, fn.KES = { type: 3, value: "KES" }, fn.KRW = { type: 3, value: "KRW" }, fn.KWD = { type: 3, value: "KWD" }, fn.KYD = { type: 3, value: "KYD" }, fn.LKR = { type: 3, value: "LKR" }, fn.LUF = { type: 3, value: "LUF" }, fn.MTL = { type: 3, value: "MTL" }, fn.MUR = { type: 3, value: "MUR" }, fn.MXN = { type: 3, value: "MXN" }, fn.MYR = { type: 3, value: "MYR" }, fn.NLG = { type: 3, value: "NLG" }, fn.NZD = { type: 3, value: "NZD" }, fn.OMR = { type: 3, value: "OMR" }, fn.PGK = { type: 3, value: "PGK" }, fn.PHP = { type: 3, value: "PHP" }, fn.PKR = { type: 3, value: "PKR" }, fn.PLN = { type: 3, value: "PLN" }, fn.PTN = { type: 3, value: "PTN" }, fn.QAR = { type: 3, value: "QAR" }, fn.RUR = { type: 3, value: "RUR" }, fn.SAR = { type: 3, value: "SAR" }, fn.SCR = { type: 3, value: "SCR" }, fn.SEK = { type: 3, value: "SEK" }, fn.SGD = { type: 3, value: "SGD" }, fn.SKP = { type: 3, value: "SKP" }, fn.THB = { type: 3, value: "THB" }, fn.TRL = { type: 3, value: "TRL" }, fn.TTD = { type: 3, value: "TTD" }, fn.TWD = { type: 3, value: "TWD" }, fn.USD = { type: 3, value: "USD" }, fn.VEB = { type: 3, value: "VEB" }, fn.VND = { type: 3, value: "VND" }, fn.XEU = { type: 3, value: "XEU" }, fn.ZAR = { type: 3, value: "ZAR" }, fn.ZWD = { type: 3, value: "ZWD" }, fn.NOK = { type: 3, value: "NOK" };
  let bc = fn;
  e.IfcCurrencyEnum = bc;
  const R7 = class R7 {
  };
  R7.USERDEFINED = { type: 3, value: "USERDEFINED" }, R7.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let OI = R7;
  e.IfcCurtainWallTypeEnum = OI;
  const Sh = class Sh {
  };
  Sh.CONTROLDAMPER = { type: 3, value: "CONTROLDAMPER" }, Sh.FIREDAMPER = { type: 3, value: "FIREDAMPER" }, Sh.SMOKEDAMPER = { type: 3, value: "SMOKEDAMPER" }, Sh.FIRESMOKEDAMPER = { type: 3, value: "FIRESMOKEDAMPER" }, Sh.BACKDRAFTDAMPER = { type: 3, value: "BACKDRAFTDAMPER" }, Sh.RELIEFDAMPER = { type: 3, value: "RELIEFDAMPER" }, Sh.BLASTDAMPER = { type: 3, value: "BLASTDAMPER" }, Sh.GRAVITYDAMPER = { type: 3, value: "GRAVITYDAMPER" }, Sh.GRAVITYRELIEFDAMPER = { type: 3, value: "GRAVITYRELIEFDAMPER" }, Sh.BALANCINGDAMPER = { type: 3, value: "BALANCINGDAMPER" }, Sh.FUMEHOODEXHAUST = { type: 3, value: "FUMEHOODEXHAUST" }, Sh.USERDEFINED = { type: 3, value: "USERDEFINED" }, Sh.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Of = Sh;
  e.IfcDamperTypeEnum = Of;
  const wR = class wR {
  };
  wR.MEASURED = { type: 3, value: "MEASURED" }, wR.PREDICTED = { type: 3, value: "PREDICTED" }, wR.SIMULATED = { type: 3, value: "SIMULATED" }, wR.USERDEFINED = { type: 3, value: "USERDEFINED" }, wR.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let xt = wR;
  e.IfcDataOriginEnum = xt;
  const ms = class ms {
  };
  ms.ANGULARVELOCITYUNIT = { type: 3, value: "ANGULARVELOCITYUNIT" }, ms.COMPOUNDPLANEANGLEUNIT = { type: 3, value: "COMPOUNDPLANEANGLEUNIT" }, ms.DYNAMICVISCOSITYUNIT = { type: 3, value: "DYNAMICVISCOSITYUNIT" }, ms.HEATFLUXDENSITYUNIT = { type: 3, value: "HEATFLUXDENSITYUNIT" }, ms.INTEGERCOUNTRATEUNIT = { type: 3, value: "INTEGERCOUNTRATEUNIT" }, ms.ISOTHERMALMOISTURECAPACITYUNIT = { type: 3, value: "ISOTHERMALMOISTURECAPACITYUNIT" }, ms.KINEMATICVISCOSITYUNIT = { type: 3, value: "KINEMATICVISCOSITYUNIT" }, ms.LINEARVELOCITYUNIT = { type: 3, value: "LINEARVELOCITYUNIT" }, ms.MASSDENSITYUNIT = { type: 3, value: "MASSDENSITYUNIT" }, ms.MASSFLOWRATEUNIT = { type: 3, value: "MASSFLOWRATEUNIT" }, ms.MOISTUREDIFFUSIVITYUNIT = { type: 3, value: "MOISTUREDIFFUSIVITYUNIT" }, ms.MOLECULARWEIGHTUNIT = { type: 3, value: "MOLECULARWEIGHTUNIT" }, ms.SPECIFICHEATCAPACITYUNIT = { type: 3, value: "SPECIFICHEATCAPACITYUNIT" }, ms.THERMALADMITTANCEUNIT = { type: 3, value: "THERMALADMITTANCEUNIT" }, ms.THERMALCONDUCTANCEUNIT = { type: 3, value: "THERMALCONDUCTANCEUNIT" }, ms.THERMALRESISTANCEUNIT = { type: 3, value: "THERMALRESISTANCEUNIT" }, ms.THERMALTRANSMITTANCEUNIT = { type: 3, value: "THERMALTRANSMITTANCEUNIT" }, ms.VAPORPERMEABILITYUNIT = { type: 3, value: "VAPORPERMEABILITYUNIT" }, ms.VOLUMETRICFLOWRATEUNIT = { type: 3, value: "VOLUMETRICFLOWRATEUNIT" }, ms.ROTATIONALFREQUENCYUNIT = { type: 3, value: "ROTATIONALFREQUENCYUNIT" }, ms.TORQUEUNIT = { type: 3, value: "TORQUEUNIT" }, ms.MOMENTOFINERTIAUNIT = { type: 3, value: "MOMENTOFINERTIAUNIT" }, ms.LINEARMOMENTUNIT = { type: 3, value: "LINEARMOMENTUNIT" }, ms.LINEARFORCEUNIT = { type: 3, value: "LINEARFORCEUNIT" }, ms.PLANARFORCEUNIT = { type: 3, value: "PLANARFORCEUNIT" }, ms.MODULUSOFELASTICITYUNIT = { type: 3, value: "MODULUSOFELASTICITYUNIT" }, ms.SHEARMODULUSUNIT = { type: 3, value: "SHEARMODULUSUNIT" }, ms.LINEARSTIFFNESSUNIT = { type: 3, value: "LINEARSTIFFNESSUNIT" }, ms.ROTATIONALSTIFFNESSUNIT = { type: 3, value: "ROTATIONALSTIFFNESSUNIT" }, ms.MODULUSOFSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFSUBGRADEREACTIONUNIT" }, ms.ACCELERATIONUNIT = { type: 3, value: "ACCELERATIONUNIT" }, ms.CURVATUREUNIT = { type: 3, value: "CURVATUREUNIT" }, ms.HEATINGVALUEUNIT = { type: 3, value: "HEATINGVALUEUNIT" }, ms.IONCONCENTRATIONUNIT = { type: 3, value: "IONCONCENTRATIONUNIT" }, ms.LUMINOUSINTENSITYDISTRIBUTIONUNIT = { type: 3, value: "LUMINOUSINTENSITYDISTRIBUTIONUNIT" }, ms.MASSPERLENGTHUNIT = { type: 3, value: "MASSPERLENGTHUNIT" }, ms.MODULUSOFLINEARSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFLINEARSUBGRADEREACTIONUNIT" }, ms.MODULUSOFROTATIONALSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFROTATIONALSUBGRADEREACTIONUNIT" }, ms.PHUNIT = { type: 3, value: "PHUNIT" }, ms.ROTATIONALMASSUNIT = { type: 3, value: "ROTATIONALMASSUNIT" }, ms.SECTIONAREAINTEGRALUNIT = { type: 3, value: "SECTIONAREAINTEGRALUNIT" }, ms.SECTIONMODULUSUNIT = { type: 3, value: "SECTIONMODULUSUNIT" }, ms.SOUNDPOWERUNIT = { type: 3, value: "SOUNDPOWERUNIT" }, ms.SOUNDPRESSUREUNIT = { type: 3, value: "SOUNDPRESSUREUNIT" }, ms.TEMPERATUREGRADIENTUNIT = { type: 3, value: "TEMPERATUREGRADIENTUNIT" }, ms.THERMALEXPANSIONCOEFFICIENTUNIT = { type: 3, value: "THERMALEXPANSIONCOEFFICIENTUNIT" }, ms.WARPINGCONSTANTUNIT = { type: 3, value: "WARPINGCONSTANTUNIT" }, ms.WARPINGMOMENTUNIT = { type: 3, value: "WARPINGMOMENTUNIT" }, ms.USERDEFINED = { type: 3, value: "USERDEFINED" };
  let li = ms;
  e.IfcDerivedUnitEnum = li;
  const v7 = class v7 {
  };
  v7.ORIGIN = { type: 3, value: "ORIGIN" }, v7.TARGET = { type: 3, value: "TARGET" };
  let qi = v7;
  e.IfcDimensionExtentUsage = qi;
  const A7 = class A7 {
  };
  A7.POSITIVE = { type: 3, value: "POSITIVE" }, A7.NEGATIVE = { type: 3, value: "NEGATIVE" };
  let un = A7;
  e.IfcDirectionSenseEnum = un;
  const Im = class Im {
  };
  Im.FORMEDDUCT = { type: 3, value: "FORMEDDUCT" }, Im.INSPECTIONCHAMBER = { type: 3, value: "INSPECTIONCHAMBER" }, Im.INSPECTIONPIT = { type: 3, value: "INSPECTIONPIT" }, Im.MANHOLE = { type: 3, value: "MANHOLE" }, Im.METERCHAMBER = { type: 3, value: "METERCHAMBER" }, Im.SUMP = { type: 3, value: "SUMP" }, Im.TRENCH = { type: 3, value: "TRENCH" }, Im.VALVECHAMBER = { type: 3, value: "VALVECHAMBER" }, Im.USERDEFINED = { type: 3, value: "USERDEFINED" }, Im.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Mn = Im;
  e.IfcDistributionChamberElementTypeEnum = Mn;
  const aT = class aT {
  };
  aT.PUBLIC = { type: 3, value: "PUBLIC" }, aT.RESTRICTED = { type: 3, value: "RESTRICTED" }, aT.CONFIDENTIAL = { type: 3, value: "CONFIDENTIAL" }, aT.PERSONAL = { type: 3, value: "PERSONAL" }, aT.USERDEFINED = { type: 3, value: "USERDEFINED" }, aT.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Pn = aT;
  e.IfcDocumentConfidentialityEnum = Pn;
  const TR = class TR {
  };
  TR.DRAFT = { type: 3, value: "DRAFT" }, TR.FINALDRAFT = { type: 3, value: "FINALDRAFT" }, TR.FINAL = { type: 3, value: "FINAL" }, TR.REVISION = { type: 3, value: "REVISION" }, TR.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let ws = TR;
  e.IfcDocumentStatusEnum = ws;
  const OE = class OE {
  };
  OE.SWINGING = { type: 3, value: "SWINGING" }, OE.DOUBLE_ACTING = { type: 3, value: "DOUBLE_ACTING" }, OE.SLIDING = { type: 3, value: "SLIDING" }, OE.FOLDING = { type: 3, value: "FOLDING" }, OE.REVOLVING = { type: 3, value: "REVOLVING" }, OE.ROLLINGUP = { type: 3, value: "ROLLINGUP" }, OE.USERDEFINED = { type: 3, value: "USERDEFINED" }, OE.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ys = OE;
  e.IfcDoorPanelOperationEnum = Ys;
  const qI = class qI {
  };
  qI.LEFT = { type: 3, value: "LEFT" }, qI.MIDDLE = { type: 3, value: "MIDDLE" }, qI.RIGHT = { type: 3, value: "RIGHT" }, qI.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ss = qI;
  e.IfcDoorPanelPositionEnum = Ss;
  const $I = class $I {
  };
  $I.ALUMINIUM = { type: 3, value: "ALUMINIUM" }, $I.HIGH_GRADE_STEEL = { type: 3, value: "HIGH_GRADE_STEEL" }, $I.STEEL = { type: 3, value: "STEEL" }, $I.WOOD = { type: 3, value: "WOOD" }, $I.ALUMINIUM_WOOD = { type: 3, value: "ALUMINIUM_WOOD" }, $I.ALUMINIUM_PLASTIC = { type: 3, value: "ALUMINIUM_PLASTIC" }, $I.PLASTIC = { type: 3, value: "PLASTIC" }, $I.USERDEFINED = { type: 3, value: "USERDEFINED" }, $I.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let dr = $I;
  e.IfcDoorStyleConstructionEnum = dr;
  const Or = class Or {
  };
  Or.SINGLE_SWING_LEFT = { type: 3, value: "SINGLE_SWING_LEFT" }, Or.SINGLE_SWING_RIGHT = { type: 3, value: "SINGLE_SWING_RIGHT" }, Or.DOUBLE_DOOR_SINGLE_SWING = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING" }, Or.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT" }, Or.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT" }, Or.DOUBLE_SWING_LEFT = { type: 3, value: "DOUBLE_SWING_LEFT" }, Or.DOUBLE_SWING_RIGHT = { type: 3, value: "DOUBLE_SWING_RIGHT" }, Or.DOUBLE_DOOR_DOUBLE_SWING = { type: 3, value: "DOUBLE_DOOR_DOUBLE_SWING" }, Or.SLIDING_TO_LEFT = { type: 3, value: "SLIDING_TO_LEFT" }, Or.SLIDING_TO_RIGHT = { type: 3, value: "SLIDING_TO_RIGHT" }, Or.DOUBLE_DOOR_SLIDING = { type: 3, value: "DOUBLE_DOOR_SLIDING" }, Or.FOLDING_TO_LEFT = { type: 3, value: "FOLDING_TO_LEFT" }, Or.FOLDING_TO_RIGHT = { type: 3, value: "FOLDING_TO_RIGHT" }, Or.DOUBLE_DOOR_FOLDING = { type: 3, value: "DOUBLE_DOOR_FOLDING" }, Or.REVOLVING = { type: 3, value: "REVOLVING" }, Or.ROLLINGUP = { type: 3, value: "ROLLINGUP" }, Or.USERDEFINED = { type: 3, value: "USERDEFINED" }, Or.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Vr = Or;
  e.IfcDoorStyleOperationEnum = Vr;
  const sy = class sy {
  };
  sy.BEND = { type: 3, value: "BEND" }, sy.CONNECTOR = { type: 3, value: "CONNECTOR" }, sy.ENTRY = { type: 3, value: "ENTRY" }, sy.EXIT = { type: 3, value: "EXIT" }, sy.JUNCTION = { type: 3, value: "JUNCTION" }, sy.OBSTRUCTION = { type: 3, value: "OBSTRUCTION" }, sy.TRANSITION = { type: 3, value: "TRANSITION" }, sy.USERDEFINED = { type: 3, value: "USERDEFINED" }, sy.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let _l = sy;
  e.IfcDuctFittingTypeEnum = _l;
  const RR = class RR {
  };
  RR.RIGIDSEGMENT = { type: 3, value: "RIGIDSEGMENT" }, RR.FLEXIBLESEGMENT = { type: 3, value: "FLEXIBLESEGMENT" }, RR.USERDEFINED = { type: 3, value: "USERDEFINED" }, RR.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let p0 = RR;
  e.IfcDuctSegmentTypeEnum = p0;
  const uT = class uT {
  };
  uT.FLATOVAL = { type: 3, value: "FLATOVAL" }, uT.RECTANGULAR = { type: 3, value: "RECTANGULAR" }, uT.ROUND = { type: 3, value: "ROUND" }, uT.USERDEFINED = { type: 3, value: "USERDEFINED" }, uT.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Lf = uT;
  e.IfcDuctSilencerTypeEnum = Lf;
  const zr = class zr {
  };
  zr.COMPUTER = { type: 3, value: "COMPUTER" }, zr.DIRECTWATERHEATER = { type: 3, value: "DIRECTWATERHEATER" }, zr.DISHWASHER = { type: 3, value: "DISHWASHER" }, zr.ELECTRICCOOKER = { type: 3, value: "ELECTRICCOOKER" }, zr.ELECTRICHEATER = { type: 3, value: "ELECTRICHEATER" }, zr.FACSIMILE = { type: 3, value: "FACSIMILE" }, zr.FREESTANDINGFAN = { type: 3, value: "FREESTANDINGFAN" }, zr.FREEZER = { type: 3, value: "FREEZER" }, zr.FRIDGE_FREEZER = { type: 3, value: "FRIDGE_FREEZER" }, zr.HANDDRYER = { type: 3, value: "HANDDRYER" }, zr.INDIRECTWATERHEATER = { type: 3, value: "INDIRECTWATERHEATER" }, zr.MICROWAVE = { type: 3, value: "MICROWAVE" }, zr.PHOTOCOPIER = { type: 3, value: "PHOTOCOPIER" }, zr.PRINTER = { type: 3, value: "PRINTER" }, zr.REFRIGERATOR = { type: 3, value: "REFRIGERATOR" }, zr.RADIANTHEATER = { type: 3, value: "RADIANTHEATER" }, zr.SCANNER = { type: 3, value: "SCANNER" }, zr.TELEPHONE = { type: 3, value: "TELEPHONE" }, zr.TUMBLEDRYER = { type: 3, value: "TUMBLEDRYER" }, zr.TV = { type: 3, value: "TV" }, zr.VENDINGMACHINE = { type: 3, value: "VENDINGMACHINE" }, zr.WASHINGMACHINE = { type: 3, value: "WASHINGMACHINE" }, zr.WATERHEATER = { type: 3, value: "WATERHEATER" }, zr.WATERCOOLER = { type: 3, value: "WATERCOOLER" }, zr.USERDEFINED = { type: 3, value: "USERDEFINED" }, zr.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let _f = zr;
  e.IfcElectricApplianceTypeEnum = _f;
  const K6 = class K6 {
  };
  K6.ALTERNATING = { type: 3, value: "ALTERNATING" }, K6.DIRECT = { type: 3, value: "DIRECT" }, K6.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let xf = K6;
  e.IfcElectricCurrentEnum = xf;
  const KI = class KI {
  };
  KI.ALARMPANEL = { type: 3, value: "ALARMPANEL" }, KI.CONSUMERUNIT = { type: 3, value: "CONSUMERUNIT" }, KI.CONTROLPANEL = { type: 3, value: "CONTROLPANEL" }, KI.DISTRIBUTIONBOARD = { type: 3, value: "DISTRIBUTIONBOARD" }, KI.GASDETECTORPANEL = { type: 3, value: "GASDETECTORPANEL" }, KI.INDICATORPANEL = { type: 3, value: "INDICATORPANEL" }, KI.MIMICPANEL = { type: 3, value: "MIMICPANEL" }, KI.MOTORCONTROLCENTRE = { type: 3, value: "MOTORCONTROLCENTRE" }, KI.SWITCHBOARD = { type: 3, value: "SWITCHBOARD" }, KI.USERDEFINED = { type: 3, value: "USERDEFINED" }, KI.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let aa = KI;
  e.IfcElectricDistributionPointFunctionEnum = aa;
  const pw = class pw {
  };
  pw.BATTERY = { type: 3, value: "BATTERY" }, pw.CAPACITORBANK = { type: 3, value: "CAPACITORBANK" }, pw.HARMONICFILTER = { type: 3, value: "HARMONICFILTER" }, pw.INDUCTORBANK = { type: 3, value: "INDUCTORBANK" }, pw.UPS = { type: 3, value: "UPS" }, pw.USERDEFINED = { type: 3, value: "USERDEFINED" }, pw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ih = pw;
  e.IfcElectricFlowStorageDeviceTypeEnum = Ih;
  const S7 = class S7 {
  };
  S7.USERDEFINED = { type: 3, value: "USERDEFINED" }, S7.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let ph = S7;
  e.IfcElectricGeneratorTypeEnum = ph;
  const vR = class vR {
  };
  vR.ELECTRICPOINTHEATER = { type: 3, value: "ELECTRICPOINTHEATER" }, vR.ELECTRICCABLEHEATER = { type: 3, value: "ELECTRICCABLEHEATER" }, vR.ELECTRICMATHEATER = { type: 3, value: "ELECTRICMATHEATER" }, vR.USERDEFINED = { type: 3, value: "USERDEFINED" }, vR.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let m0 = vR;
  e.IfcElectricHeaterTypeEnum = m0;
  const pm = class pm {
  };
  pm.DC = { type: 3, value: "DC" }, pm.INDUCTION = { type: 3, value: "INDUCTION" }, pm.POLYPHASE = { type: 3, value: "POLYPHASE" }, pm.RELUCTANCESYNCHRONOUS = { type: 3, value: "RELUCTANCESYNCHRONOUS" }, pm.SYNCHRONOUS = { type: 3, value: "SYNCHRONOUS" }, pm.USERDEFINED = { type: 3, value: "USERDEFINED" }, pm.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Nc = pm;
  e.IfcElectricMotorTypeEnum = Nc;
  const LE = class LE {
  };
  LE.TIMECLOCK = { type: 3, value: "TIMECLOCK" }, LE.TIMEDELAY = { type: 3, value: "TIMEDELAY" }, LE.RELAY = { type: 3, value: "RELAY" }, LE.USERDEFINED = { type: 3, value: "USERDEFINED" }, LE.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Nd = LE;
  e.IfcElectricTimeControlTypeEnum = Nd;
  const Yf = class Yf {
  };
  Yf.ACCESSORY_ASSEMBLY = { type: 3, value: "ACCESSORY_ASSEMBLY" }, Yf.ARCH = { type: 3, value: "ARCH" }, Yf.BEAM_GRID = { type: 3, value: "BEAM_GRID" }, Yf.BRACED_FRAME = { type: 3, value: "BRACED_FRAME" }, Yf.GIRDER = { type: 3, value: "GIRDER" }, Yf.REINFORCEMENT_UNIT = { type: 3, value: "REINFORCEMENT_UNIT" }, Yf.RIGID_FRAME = { type: 3, value: "RIGID_FRAME" }, Yf.SLAB_FIELD = { type: 3, value: "SLAB_FIELD" }, Yf.TRUSS = { type: 3, value: "TRUSS" }, Yf.USERDEFINED = { type: 3, value: "USERDEFINED" }, Yf.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Dd = Yf;
  e.IfcElementAssemblyTypeEnum = Dd;
  const Z6 = class Z6 {
  };
  Z6.COMPLEX = { type: 3, value: "COMPLEX" }, Z6.ELEMENT = { type: 3, value: "ELEMENT" }, Z6.PARTIAL = { type: 3, value: "PARTIAL" };
  let Dc = Z6;
  e.IfcElementCompositionEnum = Dc;
  const Lr = class Lr {
  };
  Lr.PRIMARY = { type: 3, value: "PRIMARY" }, Lr.SECONDARY = { type: 3, value: "SECONDARY" }, Lr.TERTIARY = { type: 3, value: "TERTIARY" }, Lr.AUXILIARY = { type: 3, value: "AUXILIARY" }, Lr.USERDEFINED = { type: 3, value: "USERDEFINED" }, Lr.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Cc = Lr;
  e.IfcEnergySequenceEnum = Cc;
  const _E = class _E {
  };
  _E.COMBINEDVALUE = { type: 3, value: "COMBINEDVALUE" }, _E.DISPOSAL = { type: 3, value: "DISPOSAL" }, _E.EXTRACTION = { type: 3, value: "EXTRACTION" }, _E.INSTALLATION = { type: 3, value: "INSTALLATION" }, _E.MANUFACTURE = { type: 3, value: "MANUFACTURE" }, _E.TRANSPORTATION = { type: 3, value: "TRANSPORTATION" }, _E.USERDEFINED = { type: 3, value: "USERDEFINED" }, _E.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let mh = _E;
  e.IfcEnvironmentalImpactCategoryEnum = mh;
  const ZI = class ZI {
  };
  ZI.DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER" }, ZI.DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER" }, ZI.DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER" }, ZI.DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER" }, ZI.DIRECTEVAPORATIVEAIRWASHER = { type: 3, value: "DIRECTEVAPORATIVEAIRWASHER" }, ZI.INDIRECTEVAPORATIVEPACKAGEAIRCOOLER = { type: 3, value: "INDIRECTEVAPORATIVEPACKAGEAIRCOOLER" }, ZI.INDIRECTEVAPORATIVEWETCOIL = { type: 3, value: "INDIRECTEVAPORATIVEWETCOIL" }, ZI.INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER = { type: 3, value: "INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER" }, ZI.INDIRECTDIRECTCOMBINATION = { type: 3, value: "INDIRECTDIRECTCOMBINATION" }, ZI.USERDEFINED = { type: 3, value: "USERDEFINED" }, ZI.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Go = ZI;
  e.IfcEvaporativeCoolerTypeEnum = Go;
  const mw = class mw {
  };
  mw.DIRECTEXPANSIONSHELLANDTUBE = { type: 3, value: "DIRECTEXPANSIONSHELLANDTUBE" }, mw.DIRECTEXPANSIONTUBEINTUBE = { type: 3, value: "DIRECTEXPANSIONTUBEINTUBE" }, mw.DIRECTEXPANSIONBRAZEDPLATE = { type: 3, value: "DIRECTEXPANSIONBRAZEDPLATE" }, mw.FLOODEDSHELLANDTUBE = { type: 3, value: "FLOODEDSHELLANDTUBE" }, mw.SHELLANDCOIL = { type: 3, value: "SHELLANDCOIL" }, mw.USERDEFINED = { type: 3, value: "USERDEFINED" }, mw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Oc = mw;
  e.IfcEvaporatorTypeEnum = Oc;
  const mm = class mm {
  };
  mm.CENTRIFUGALFORWARDCURVED = { type: 3, value: "CENTRIFUGALFORWARDCURVED" }, mm.CENTRIFUGALRADIAL = { type: 3, value: "CENTRIFUGALRADIAL" }, mm.CENTRIFUGALBACKWARDINCLINEDCURVED = { type: 3, value: "CENTRIFUGALBACKWARDINCLINEDCURVED" }, mm.CENTRIFUGALAIRFOIL = { type: 3, value: "CENTRIFUGALAIRFOIL" }, mm.TUBEAXIAL = { type: 3, value: "TUBEAXIAL" }, mm.VANEAXIAL = { type: 3, value: "VANEAXIAL" }, mm.PROPELLORAXIAL = { type: 3, value: "PROPELLORAXIAL" }, mm.USERDEFINED = { type: 3, value: "USERDEFINED" }, mm.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Lc = mm;
  e.IfcFanTypeEnum = Lc;
  const yw = class yw {
  };
  yw.AIRPARTICLEFILTER = { type: 3, value: "AIRPARTICLEFILTER" }, yw.ODORFILTER = { type: 3, value: "ODORFILTER" }, yw.OILFILTER = { type: 3, value: "OILFILTER" }, yw.STRAINER = { type: 3, value: "STRAINER" }, yw.WATERFILTER = { type: 3, value: "WATERFILTER" }, yw.USERDEFINED = { type: 3, value: "USERDEFINED" }, yw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let _c = yw;
  e.IfcFilterTypeEnum = _c;
  const Ew = class Ew {
  };
  Ew.BREECHINGINLET = { type: 3, value: "BREECHINGINLET" }, Ew.FIREHYDRANT = { type: 3, value: "FIREHYDRANT" }, Ew.HOSEREEL = { type: 3, value: "HOSEREEL" }, Ew.SPRINKLER = { type: 3, value: "SPRINKLER" }, Ew.SPRINKLERDEFLECTOR = { type: 3, value: "SPRINKLERDEFLECTOR" }, Ew.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ew.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let xc = Ew;
  e.IfcFireSuppressionTerminalTypeEnum = xc;
  const wS = class wS {
  };
  wS.SOURCE = { type: 3, value: "SOURCE" }, wS.SINK = { type: 3, value: "SINK" }, wS.SOURCEANDSINK = { type: 3, value: "SOURCEANDSINK" }, wS.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Cd = wS;
  e.IfcFlowDirectionEnum = Cd;
  const Au = class Au {
  };
  Au.PRESSUREGAUGE = { type: 3, value: "PRESSUREGAUGE" }, Au.THERMOMETER = { type: 3, value: "THERMOMETER" }, Au.AMMETER = { type: 3, value: "AMMETER" }, Au.FREQUENCYMETER = { type: 3, value: "FREQUENCYMETER" }, Au.POWERFACTORMETER = { type: 3, value: "POWERFACTORMETER" }, Au.PHASEANGLEMETER = { type: 3, value: "PHASEANGLEMETER" }, Au.VOLTMETER_PEAK = { type: 3, value: "VOLTMETER_PEAK" }, Au.VOLTMETER_RMS = { type: 3, value: "VOLTMETER_RMS" }, Au.USERDEFINED = { type: 3, value: "USERDEFINED" }, Au.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let xl = Au;
  e.IfcFlowInstrumentTypeEnum = xl;
  const R0 = class R0 {
  };
  R0.ELECTRICMETER = { type: 3, value: "ELECTRICMETER" }, R0.ENERGYMETER = { type: 3, value: "ENERGYMETER" }, R0.FLOWMETER = { type: 3, value: "FLOWMETER" }, R0.GASMETER = { type: 3, value: "GASMETER" }, R0.OILMETER = { type: 3, value: "OILMETER" }, R0.WATERMETER = { type: 3, value: "WATERMETER" }, R0.USERDEFINED = { type: 3, value: "USERDEFINED" }, R0.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let yh = R0;
  e.IfcFlowMeterTypeEnum = yh;
  const dT = class dT {
  };
  dT.FOOTING_BEAM = { type: 3, value: "FOOTING_BEAM" }, dT.PAD_FOOTING = { type: 3, value: "PAD_FOOTING" }, dT.PILE_CAP = { type: 3, value: "PILE_CAP" }, dT.STRIP_FOOTING = { type: 3, value: "STRIP_FOOTING" }, dT.USERDEFINED = { type: 3, value: "USERDEFINED" }, dT.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Eh = dT;
  e.IfcFootingTypeEnum = Eh;
  const AR = class AR {
  };
  AR.GASAPPLIANCE = { type: 3, value: "GASAPPLIANCE" }, AR.GASBOOSTER = { type: 3, value: "GASBOOSTER" }, AR.GASBURNER = { type: 3, value: "GASBURNER" }, AR.USERDEFINED = { type: 3, value: "USERDEFINED" }, AR.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let LI = AR;
  e.IfcGasTerminalTypeEnum = LI;
  const qf = class qf {
  };
  qf.GRAPH_VIEW = { type: 3, value: "GRAPH_VIEW" }, qf.SKETCH_VIEW = { type: 3, value: "SKETCH_VIEW" }, qf.MODEL_VIEW = { type: 3, value: "MODEL_VIEW" }, qf.PLAN_VIEW = { type: 3, value: "PLAN_VIEW" }, qf.REFLECTED_PLAN_VIEW = { type: 3, value: "REFLECTED_PLAN_VIEW" }, qf.SECTION_VIEW = { type: 3, value: "SECTION_VIEW" }, qf.ELEVATION_VIEW = { type: 3, value: "ELEVATION_VIEW" }, qf.USERDEFINED = { type: 3, value: "USERDEFINED" }, qf.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Pf = qf;
  e.IfcGeometricProjectionEnum = Pf;
  const cT = class cT {
  };
  cT.GLOBAL_COORDS = { type: 3, value: "GLOBAL_COORDS" }, cT.LOCAL_COORDS = { type: 3, value: "LOCAL_COORDS" };
  let Bi = cT;
  e.IfcGlobalOrLocalEnum = Bi;
  const QI = class QI {
  };
  QI.PLATE = { type: 3, value: "PLATE" }, QI.SHELLANDTUBE = { type: 3, value: "SHELLANDTUBE" }, QI.USERDEFINED = { type: 3, value: "USERDEFINED" }, QI.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let qu = QI;
  e.IfcHeatExchangerTypeEnum = qu;
  const Er = class Er {
  };
  Er.STEAMINJECTION = { type: 3, value: "STEAMINJECTION" }, Er.ADIABATICAIRWASHER = { type: 3, value: "ADIABATICAIRWASHER" }, Er.ADIABATICPAN = { type: 3, value: "ADIABATICPAN" }, Er.ADIABATICWETTEDELEMENT = { type: 3, value: "ADIABATICWETTEDELEMENT" }, Er.ADIABATICATOMIZING = { type: 3, value: "ADIABATICATOMIZING" }, Er.ADIABATICULTRASONIC = { type: 3, value: "ADIABATICULTRASONIC" }, Er.ADIABATICRIGIDMEDIA = { type: 3, value: "ADIABATICRIGIDMEDIA" }, Er.ADIABATICCOMPRESSEDAIRNOZZLE = { type: 3, value: "ADIABATICCOMPRESSEDAIRNOZZLE" }, Er.ASSISTEDELECTRIC = { type: 3, value: "ASSISTEDELECTRIC" }, Er.ASSISTEDNATURALGAS = { type: 3, value: "ASSISTEDNATURALGAS" }, Er.ASSISTEDPROPANE = { type: 3, value: "ASSISTEDPROPANE" }, Er.ASSISTEDBUTANE = { type: 3, value: "ASSISTEDBUTANE" }, Er.ASSISTEDSTEAM = { type: 3, value: "ASSISTEDSTEAM" }, Er.USERDEFINED = { type: 3, value: "USERDEFINED" }, Er.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ru = Er;
  e.IfcHumidifierTypeEnum = Ru;
  const hT = class hT {
  };
  hT.INTERNAL = { type: 3, value: "INTERNAL" }, hT.EXTERNAL = { type: 3, value: "EXTERNAL" }, hT.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Pc = hT;
  e.IfcInternalOrExternalEnum = Pc;
  const SR = class SR {
  };
  SR.ASSETINVENTORY = { type: 3, value: "ASSETINVENTORY" }, SR.SPACEINVENTORY = { type: 3, value: "SPACEINVENTORY" }, SR.FURNITUREINVENTORY = { type: 3, value: "FURNITUREINVENTORY" }, SR.USERDEFINED = { type: 3, value: "USERDEFINED" }, SR.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Od = SR;
  e.IfcInventoryTypeEnum = Od;
  const b7 = class b7 {
  };
  b7.USERDEFINED = { type: 3, value: "USERDEFINED" }, b7.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let gh = b7;
  e.IfcJunctionBoxTypeEnum = gh;
  const xE = class xE {
  };
  xE.COMPACTFLUORESCENT = { type: 3, value: "COMPACTFLUORESCENT" }, xE.FLUORESCENT = { type: 3, value: "FLUORESCENT" }, xE.HIGHPRESSUREMERCURY = { type: 3, value: "HIGHPRESSUREMERCURY" }, xE.HIGHPRESSURESODIUM = { type: 3, value: "HIGHPRESSURESODIUM" }, xE.METALHALIDE = { type: 3, value: "METALHALIDE" }, xE.TUNGSTENFILAMENT = { type: 3, value: "TUNGSTENFILAMENT" }, xE.USERDEFINED = { type: 3, value: "USERDEFINED" }, xE.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Mc = xE;
  e.IfcLampTypeEnum = Mc;
  const Q6 = class Q6 {
  };
  Q6.AXIS1 = { type: 3, value: "AXIS1" }, Q6.AXIS2 = { type: 3, value: "AXIS2" }, Q6.AXIS3 = { type: 3, value: "AXIS3" };
  let Uc = Q6;
  e.IfcLayerSetDirectionEnum = Uc;
  const TS = class TS {
  };
  TS.TYPE_A = { type: 3, value: "TYPE_A" }, TS.TYPE_B = { type: 3, value: "TYPE_B" }, TS.TYPE_C = { type: 3, value: "TYPE_C" }, TS.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let $u = TS;
  e.IfcLightDistributionCurveEnum = $u;
  const JI = class JI {
  };
  JI.COMPACTFLUORESCENT = { type: 3, value: "COMPACTFLUORESCENT" }, JI.FLUORESCENT = { type: 3, value: "FLUORESCENT" }, JI.HIGHPRESSUREMERCURY = { type: 3, value: "HIGHPRESSUREMERCURY" }, JI.HIGHPRESSURESODIUM = { type: 3, value: "HIGHPRESSURESODIUM" }, JI.LIGHTEMITTINGDIODE = { type: 3, value: "LIGHTEMITTINGDIODE" }, JI.LOWPRESSURESODIUM = { type: 3, value: "LOWPRESSURESODIUM" }, JI.LOWVOLTAGEHALOGEN = { type: 3, value: "LOWVOLTAGEHALOGEN" }, JI.MAINVOLTAGEHALOGEN = { type: 3, value: "MAINVOLTAGEHALOGEN" }, JI.METALHALIDE = { type: 3, value: "METALHALIDE" }, JI.TUNGSTENFILAMENT = { type: 3, value: "TUNGSTENFILAMENT" }, JI.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let ua = JI;
  e.IfcLightEmissionSourceEnum = ua;
  const RS = class RS {
  };
  RS.POINTSOURCE = { type: 3, value: "POINTSOURCE" }, RS.DIRECTIONSOURCE = { type: 3, value: "DIRECTIONSOURCE" }, RS.USERDEFINED = { type: 3, value: "USERDEFINED" }, RS.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Bc = RS;
  e.IfcLightFixtureTypeEnum = Bc;
  const fT = class fT {
  };
  fT.LOAD_GROUP = { type: 3, value: "LOAD_GROUP" }, fT.LOAD_CASE = { type: 3, value: "LOAD_CASE" }, fT.LOAD_COMBINATION_GROUP = { type: 3, value: "LOAD_COMBINATION_GROUP" }, fT.LOAD_COMBINATION = { type: 3, value: "LOAD_COMBINATION" }, fT.USERDEFINED = { type: 3, value: "USERDEFINED" }, fT.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Fc = fT;
  e.IfcLoadGroupTypeEnum = Fc;
  const J6 = class J6 {
  };
  J6.LOGICALAND = { type: 3, value: "LOGICALAND" }, J6.LOGICALOR = { type: 3, value: "LOGICALOR" };
  let y0 = J6;
  e.IfcLogicalOperatorEnum = y0;
  const Md = class Md {
  };
  Md.BRACE = { type: 3, value: "BRACE" }, Md.CHORD = { type: 3, value: "CHORD" }, Md.COLLAR = { type: 3, value: "COLLAR" }, Md.MEMBER = { type: 3, value: "MEMBER" }, Md.MULLION = { type: 3, value: "MULLION" }, Md.PLATE = { type: 3, value: "PLATE" }, Md.POST = { type: 3, value: "POST" }, Md.PURLIN = { type: 3, value: "PURLIN" }, Md.RAFTER = { type: 3, value: "RAFTER" }, Md.STRINGER = { type: 3, value: "STRINGER" }, Md.STRUT = { type: 3, value: "STRUT" }, Md.STUD = { type: 3, value: "STUD" }, Md.USERDEFINED = { type: 3, value: "USERDEFINED" }, Md.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Wl = Md;
  e.IfcMemberTypeEnum = Wl;
  const bR = class bR {
  };
  bR.BELTDRIVE = { type: 3, value: "BELTDRIVE" }, bR.COUPLING = { type: 3, value: "COUPLING" }, bR.DIRECTDRIVE = { type: 3, value: "DIRECTDRIVE" }, bR.USERDEFINED = { type: 3, value: "USERDEFINED" }, bR.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Mf = bR;
  e.IfcMotorConnectionTypeEnum = Mf;
  const m9 = class m9 {
  };
  m9.NULL = { type: 3, value: "NULL" };
  let m3 = m9;
  e.IfcNullStyle = m3;
  const PE = class PE {
  };
  PE.PRODUCT = { type: 3, value: "PRODUCT" }, PE.PROCESS = { type: 3, value: "PROCESS" }, PE.CONTROL = { type: 3, value: "CONTROL" }, PE.RESOURCE = { type: 3, value: "RESOURCE" }, PE.ACTOR = { type: 3, value: "ACTOR" }, PE.GROUP = { type: 3, value: "GROUP" }, PE.PROJECT = { type: 3, value: "PROJECT" }, PE.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let y3 = PE;
  e.IfcObjectTypeEnum = y3;
  const ME = class ME {
  };
  ME.CODECOMPLIANCE = { type: 3, value: "CODECOMPLIANCE" }, ME.DESIGNINTENT = { type: 3, value: "DESIGNINTENT" }, ME.HEALTHANDSAFETY = { type: 3, value: "HEALTHANDSAFETY" }, ME.REQUIREMENT = { type: 3, value: "REQUIREMENT" }, ME.SPECIFICATION = { type: 3, value: "SPECIFICATION" }, ME.TRIGGERCONDITION = { type: 3, value: "TRIGGERCONDITION" }, ME.USERDEFINED = { type: 3, value: "USERDEFINED" }, ME.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let ko = ME;
  e.IfcObjectiveEnum = ko;
  const oy = class oy {
  };
  oy.ASSIGNEE = { type: 3, value: "ASSIGNEE" }, oy.ASSIGNOR = { type: 3, value: "ASSIGNOR" }, oy.LESSEE = { type: 3, value: "LESSEE" }, oy.LESSOR = { type: 3, value: "LESSOR" }, oy.LETTINGAGENT = { type: 3, value: "LETTINGAGENT" }, oy.OWNER = { type: 3, value: "OWNER" }, oy.TENANT = { type: 3, value: "TENANT" }, oy.USERDEFINED = { type: 3, value: "USERDEFINED" }, oy.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let E3 = oy;
  e.IfcOccupantTypeEnum = E3;
  const NR = class NR {
  };
  NR.AUDIOVISUALOUTLET = { type: 3, value: "AUDIOVISUALOUTLET" }, NR.COMMUNICATIONSOUTLET = { type: 3, value: "COMMUNICATIONSOUTLET" }, NR.POWEROUTLET = { type: 3, value: "POWEROUTLET" }, NR.USERDEFINED = { type: 3, value: "USERDEFINED" }, NR.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let _I = NR;
  e.IfcOutletTypeEnum = _I;
  const IT = class IT {
  };
  IT.GRILL = { type: 3, value: "GRILL" }, IT.LOUVER = { type: 3, value: "LOUVER" }, IT.SCREEN = { type: 3, value: "SCREEN" }, IT.USERDEFINED = { type: 3, value: "USERDEFINED" }, IT.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let g3 = IT;
  e.IfcPermeableCoveringOperationEnum = g3;
  const X6 = class X6 {
  };
  X6.PHYSICAL = { type: 3, value: "PHYSICAL" }, X6.VIRTUAL = { type: 3, value: "VIRTUAL" }, X6.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let w3 = X6;
  e.IfcPhysicalOrVirtualEnum = w3;
  const pT = class pT {
  };
  pT.CAST_IN_PLACE = { type: 3, value: "CAST_IN_PLACE" }, pT.COMPOSITE = { type: 3, value: "COMPOSITE" }, pT.PRECAST_CONCRETE = { type: 3, value: "PRECAST_CONCRETE" }, pT.PREFAB_STEEL = { type: 3, value: "PREFAB_STEEL" }, pT.USERDEFINED = { type: 3, value: "USERDEFINED" }, pT.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let xI = pT;
  e.IfcPileConstructionEnum = xI;
  const DR = class DR {
  };
  DR.COHESION = { type: 3, value: "COHESION" }, DR.FRICTION = { type: 3, value: "FRICTION" }, DR.SUPPORT = { type: 3, value: "SUPPORT" }, DR.USERDEFINED = { type: 3, value: "USERDEFINED" }, DR.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let T3 = DR;
  e.IfcPileTypeEnum = T3;
  const ry = class ry {
  };
  ry.BEND = { type: 3, value: "BEND" }, ry.CONNECTOR = { type: 3, value: "CONNECTOR" }, ry.ENTRY = { type: 3, value: "ENTRY" }, ry.EXIT = { type: 3, value: "EXIT" }, ry.JUNCTION = { type: 3, value: "JUNCTION" }, ry.OBSTRUCTION = { type: 3, value: "OBSTRUCTION" }, ry.TRANSITION = { type: 3, value: "TRANSITION" }, ry.USERDEFINED = { type: 3, value: "USERDEFINED" }, ry.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let wh = ry;
  e.IfcPipeFittingTypeEnum = wh;
  const mT = class mT {
  };
  mT.FLEXIBLESEGMENT = { type: 3, value: "FLEXIBLESEGMENT" }, mT.RIGIDSEGMENT = { type: 3, value: "RIGIDSEGMENT" }, mT.GUTTER = { type: 3, value: "GUTTER" }, mT.SPOOL = { type: 3, value: "SPOOL" }, mT.USERDEFINED = { type: 3, value: "USERDEFINED" }, mT.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let R3 = mT;
  e.IfcPipeSegmentTypeEnum = R3;
  const vS = class vS {
  };
  vS.CURTAIN_PANEL = { type: 3, value: "CURTAIN_PANEL" }, vS.SHEET = { type: 3, value: "SHEET" }, vS.USERDEFINED = { type: 3, value: "USERDEFINED" }, vS.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Qs = vS;
  e.IfcPlateTypeEnum = Qs;
  const ly = class ly {
  };
  ly.ADVICE_CAUTION = { type: 3, value: "ADVICE_CAUTION" }, ly.ADVICE_NOTE = { type: 3, value: "ADVICE_NOTE" }, ly.ADVICE_WARNING = { type: 3, value: "ADVICE_WARNING" }, ly.CALIBRATION = { type: 3, value: "CALIBRATION" }, ly.DIAGNOSTIC = { type: 3, value: "DIAGNOSTIC" }, ly.SHUTDOWN = { type: 3, value: "SHUTDOWN" }, ly.STARTUP = { type: 3, value: "STARTUP" }, ly.USERDEFINED = { type: 3, value: "USERDEFINED" }, ly.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let v3 = ly;
  e.IfcProcedureTypeEnum = v3;
  const N7 = class N7 {
  };
  N7.CURVE = { type: 3, value: "CURVE" }, N7.AREA = { type: 3, value: "AREA" };
  let Uf = N7;
  e.IfcProfileTypeEnum = Uf;
  const ay = class ay {
  };
  ay.CHANGE = { type: 3, value: "CHANGE" }, ay.MAINTENANCE = { type: 3, value: "MAINTENANCE" }, ay.MOVE = { type: 3, value: "MOVE" }, ay.PURCHASE = { type: 3, value: "PURCHASE" }, ay.WORK = { type: 3, value: "WORK" }, ay.USERDEFINED = { type: 3, value: "USERDEFINED" }, ay.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ku = ay;
  e.IfcProjectOrderRecordTypeEnum = Ku;
  const gw = class gw {
  };
  gw.CHANGEORDER = { type: 3, value: "CHANGEORDER" }, gw.MAINTENANCEWORKORDER = { type: 3, value: "MAINTENANCEWORKORDER" }, gw.MOVEORDER = { type: 3, value: "MOVEORDER" }, gw.PURCHASEORDER = { type: 3, value: "PURCHASEORDER" }, gw.WORKORDER = { type: 3, value: "WORKORDER" }, gw.USERDEFINED = { type: 3, value: "USERDEFINED" }, gw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let PI = gw;
  e.IfcProjectOrderTypeEnum = PI;
  const D7 = class D7 {
  };
  D7.PROJECTED_LENGTH = { type: 3, value: "PROJECTED_LENGTH" }, D7.TRUE_LENGTH = { type: 3, value: "TRUE_LENGTH" };
  let Bf = D7;
  e.IfcProjectedOrTrueLengthEnum = Bf;
  const uy = class uy {
  };
  uy.DESIGN = { type: 3, value: "DESIGN" }, uy.DESIGNMAXIMUM = { type: 3, value: "DESIGNMAXIMUM" }, uy.DESIGNMINIMUM = { type: 3, value: "DESIGNMINIMUM" }, uy.SIMULATED = { type: 3, value: "SIMULATED" }, uy.ASBUILT = { type: 3, value: "ASBUILT" }, uy.COMMISSIONING = { type: 3, value: "COMMISSIONING" }, uy.MEASURED = { type: 3, value: "MEASURED" }, uy.USERDEFINED = { type: 3, value: "USERDEFINED" }, uy.NOTKNOWN = { type: 3, value: "NOTKNOWN" };
  let A3 = uy;
  e.IfcPropertySourceEnum = A3;
  const UE = class UE {
  };
  UE.FUSEDISCONNECTOR = { type: 3, value: "FUSEDISCONNECTOR" }, UE.CIRCUITBREAKER = { type: 3, value: "CIRCUITBREAKER" }, UE.EARTHFAILUREDEVICE = { type: 3, value: "EARTHFAILUREDEVICE" }, UE.RESIDUALCURRENTCIRCUITBREAKER = { type: 3, value: "RESIDUALCURRENTCIRCUITBREAKER" }, UE.RESIDUALCURRENTSWITCH = { type: 3, value: "RESIDUALCURRENTSWITCH" }, UE.VARISTOR = { type: 3, value: "VARISTOR" }, UE.USERDEFINED = { type: 3, value: "USERDEFINED" }, UE.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Hc = UE;
  e.IfcProtectiveDeviceTypeEnum = Hc;
  const ww = class ww {
  };
  ww.CIRCULATOR = { type: 3, value: "CIRCULATOR" }, ww.ENDSUCTION = { type: 3, value: "ENDSUCTION" }, ww.SPLITCASE = { type: 3, value: "SPLITCASE" }, ww.VERTICALINLINE = { type: 3, value: "VERTICALINLINE" }, ww.VERTICALTURBINE = { type: 3, value: "VERTICALTURBINE" }, ww.USERDEFINED = { type: 3, value: "USERDEFINED" }, ww.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let tm = ww;
  e.IfcPumpTypeEnum = tm;
  const Tw = class Tw {
  };
  Tw.HANDRAIL = { type: 3, value: "HANDRAIL" }, Tw.GUARDRAIL = { type: 3, value: "GUARDRAIL" }, Tw.BALUSTRADE = { type: 3, value: "BALUSTRADE" }, Tw.USERDEFINED = { type: 3, value: "USERDEFINED" }, Tw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let hs = Tw;
  e.IfcRailingTypeEnum = hs;
  const AS = class AS {
  };
  AS.STRAIGHT = { type: 3, value: "STRAIGHT" }, AS.SPIRAL = { type: 3, value: "SPIRAL" }, AS.USERDEFINED = { type: 3, value: "USERDEFINED" }, AS.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let S3 = AS;
  e.IfcRampFlightTypeEnum = S3;
  const BE = class BE {
  };
  BE.STRAIGHT_RUN_RAMP = { type: 3, value: "STRAIGHT_RUN_RAMP" }, BE.TWO_STRAIGHT_RUN_RAMP = { type: 3, value: "TWO_STRAIGHT_RUN_RAMP" }, BE.QUARTER_TURN_RAMP = { type: 3, value: "QUARTER_TURN_RAMP" }, BE.TWO_QUARTER_TURN_RAMP = { type: 3, value: "TWO_QUARTER_TURN_RAMP" }, BE.HALF_TURN_RAMP = { type: 3, value: "HALF_TURN_RAMP" }, BE.SPIRAL_RAMP = { type: 3, value: "SPIRAL_RAMP" }, BE.USERDEFINED = { type: 3, value: "USERDEFINED" }, BE.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let b3 = BE;
  e.IfcRampTypeEnum = b3;
  const ym = class ym {
  };
  ym.BLINN = { type: 3, value: "BLINN" }, ym.FLAT = { type: 3, value: "FLAT" }, ym.GLASS = { type: 3, value: "GLASS" }, ym.MATT = { type: 3, value: "MATT" }, ym.METAL = { type: 3, value: "METAL" }, ym.MIRROR = { type: 3, value: "MIRROR" }, ym.PHONG = { type: 3, value: "PHONG" }, ym.PLASTIC = { type: 3, value: "PLASTIC" }, ym.STRAUSS = { type: 3, value: "STRAUSS" }, ym.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let N3 = ym;
  e.IfcReflectanceMethodEnum = N3;
  const dy = class dy {
  };
  dy.MAIN = { type: 3, value: "MAIN" }, dy.SHEAR = { type: 3, value: "SHEAR" }, dy.LIGATURE = { type: 3, value: "LIGATURE" }, dy.STUD = { type: 3, value: "STUD" }, dy.PUNCHING = { type: 3, value: "PUNCHING" }, dy.EDGE = { type: 3, value: "EDGE" }, dy.RING = { type: 3, value: "RING" }, dy.USERDEFINED = { type: 3, value: "USERDEFINED" }, dy.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let D3 = dy;
  e.IfcReinforcingBarRoleEnum = D3;
  const C7 = class C7 {
  };
  C7.PLAIN = { type: 3, value: "PLAIN" }, C7.TEXTURED = { type: 3, value: "TEXTURED" };
  let C3 = C7;
  e.IfcReinforcingBarSurfaceEnum = C3;
  const FE = class FE {
  };
  FE.CONSUMED = { type: 3, value: "CONSUMED" }, FE.PARTIALLYCONSUMED = { type: 3, value: "PARTIALLYCONSUMED" }, FE.NOTCONSUMED = { type: 3, value: "NOTCONSUMED" }, FE.OCCUPIED = { type: 3, value: "OCCUPIED" }, FE.PARTIALLYOCCUPIED = { type: 3, value: "PARTIALLYOCCUPIED" }, FE.NOTOCCUPIED = { type: 3, value: "NOTOCCUPIED" }, FE.USERDEFINED = { type: 3, value: "USERDEFINED" }, FE.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let MI = FE;
  e.IfcResourceConsumptionEnum = MI;
  const O7 = class O7 {
  };
  O7.DIRECTION_X = { type: 3, value: "DIRECTION_X" }, O7.DIRECTION_Y = { type: 3, value: "DIRECTION_Y" };
  let st = O7;
  e.IfcRibPlateDirectionEnum = st;
  const cl = class cl {
  };
  cl.SUPPLIER = { type: 3, value: "SUPPLIER" }, cl.MANUFACTURER = { type: 3, value: "MANUFACTURER" }, cl.CONTRACTOR = { type: 3, value: "CONTRACTOR" }, cl.SUBCONTRACTOR = { type: 3, value: "SUBCONTRACTOR" }, cl.ARCHITECT = { type: 3, value: "ARCHITECT" }, cl.STRUCTURALENGINEER = { type: 3, value: "STRUCTURALENGINEER" }, cl.COSTENGINEER = { type: 3, value: "COSTENGINEER" }, cl.CLIENT = { type: 3, value: "CLIENT" }, cl.BUILDINGOWNER = { type: 3, value: "BUILDINGOWNER" }, cl.BUILDINGOPERATOR = { type: 3, value: "BUILDINGOPERATOR" }, cl.MECHANICALENGINEER = { type: 3, value: "MECHANICALENGINEER" }, cl.ELECTRICALENGINEER = { type: 3, value: "ELECTRICALENGINEER" }, cl.PROJECTMANAGER = { type: 3, value: "PROJECTMANAGER" }, cl.FACILITIESMANAGER = { type: 3, value: "FACILITIESMANAGER" }, cl.CIVILENGINEER = { type: 3, value: "CIVILENGINEER" }, cl.COMISSIONINGENGINEER = { type: 3, value: "COMISSIONINGENGINEER" }, cl.ENGINEER = { type: 3, value: "ENGINEER" }, cl.OWNER = { type: 3, value: "OWNER" }, cl.CONSULTANT = { type: 3, value: "CONSULTANT" }, cl.CONSTRUCTIONMANAGER = { type: 3, value: "CONSTRUCTIONMANAGER" }, cl.FIELDCONSTRUCTIONMANAGER = { type: 3, value: "FIELDCONSTRUCTIONMANAGER" }, cl.RESELLER = { type: 3, value: "RESELLER" }, cl.USERDEFINED = { type: 3, value: "USERDEFINED" };
  let Ld = cl;
  e.IfcRoleEnum = Ld;
  const zc = class zc {
  };
  zc.FLAT_ROOF = { type: 3, value: "FLAT_ROOF" }, zc.SHED_ROOF = { type: 3, value: "SHED_ROOF" }, zc.GABLE_ROOF = { type: 3, value: "GABLE_ROOF" }, zc.HIP_ROOF = { type: 3, value: "HIP_ROOF" }, zc.HIPPED_GABLE_ROOF = { type: 3, value: "HIPPED_GABLE_ROOF" }, zc.GAMBREL_ROOF = { type: 3, value: "GAMBREL_ROOF" }, zc.MANSARD_ROOF = { type: 3, value: "MANSARD_ROOF" }, zc.BARREL_ROOF = { type: 3, value: "BARREL_ROOF" }, zc.RAINBOW_ROOF = { type: 3, value: "RAINBOW_ROOF" }, zc.BUTTERFLY_ROOF = { type: 3, value: "BUTTERFLY_ROOF" }, zc.PAVILION_ROOF = { type: 3, value: "PAVILION_ROOF" }, zc.DOME_ROOF = { type: 3, value: "DOME_ROOF" }, zc.FREEFORM = { type: 3, value: "FREEFORM" }, zc.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let O3 = zc;
  e.IfcRoofTypeEnum = O3;
  const Ud = class Ud {
  };
  Ud.EXA = { type: 3, value: "EXA" }, Ud.PETA = { type: 3, value: "PETA" }, Ud.TERA = { type: 3, value: "TERA" }, Ud.GIGA = { type: 3, value: "GIGA" }, Ud.MEGA = { type: 3, value: "MEGA" }, Ud.KILO = { type: 3, value: "KILO" }, Ud.HECTO = { type: 3, value: "HECTO" }, Ud.DECA = { type: 3, value: "DECA" }, Ud.DECI = { type: 3, value: "DECI" }, Ud.CENTI = { type: 3, value: "CENTI" }, Ud.MILLI = { type: 3, value: "MILLI" }, Ud.MICRO = { type: 3, value: "MICRO" }, Ud.NANO = { type: 3, value: "NANO" }, Ud.PICO = { type: 3, value: "PICO" }, Ud.FEMTO = { type: 3, value: "FEMTO" }, Ud.ATTO = { type: 3, value: "ATTO" };
  let UI = Ud;
  e.IfcSIPrefix = UI;
  const or = class or {
  };
  or.AMPERE = { type: 3, value: "AMPERE" }, or.BECQUEREL = { type: 3, value: "BECQUEREL" }, or.CANDELA = { type: 3, value: "CANDELA" }, or.COULOMB = { type: 3, value: "COULOMB" }, or.CUBIC_METRE = { type: 3, value: "CUBIC_METRE" }, or.DEGREE_CELSIUS = { type: 3, value: "DEGREE_CELSIUS" }, or.FARAD = { type: 3, value: "FARAD" }, or.GRAM = { type: 3, value: "GRAM" }, or.GRAY = { type: 3, value: "GRAY" }, or.HENRY = { type: 3, value: "HENRY" }, or.HERTZ = { type: 3, value: "HERTZ" }, or.JOULE = { type: 3, value: "JOULE" }, or.KELVIN = { type: 3, value: "KELVIN" }, or.LUMEN = { type: 3, value: "LUMEN" }, or.LUX = { type: 3, value: "LUX" }, or.METRE = { type: 3, value: "METRE" }, or.MOLE = { type: 3, value: "MOLE" }, or.NEWTON = { type: 3, value: "NEWTON" }, or.OHM = { type: 3, value: "OHM" }, or.PASCAL = { type: 3, value: "PASCAL" }, or.RADIAN = { type: 3, value: "RADIAN" }, or.SECOND = { type: 3, value: "SECOND" }, or.SIEMENS = { type: 3, value: "SIEMENS" }, or.SIEVERT = { type: 3, value: "SIEVERT" }, or.SQUARE_METRE = { type: 3, value: "SQUARE_METRE" }, or.STERADIAN = { type: 3, value: "STERADIAN" }, or.TESLA = { type: 3, value: "TESLA" }, or.VOLT = { type: 3, value: "VOLT" }, or.WATT = { type: 3, value: "WATT" }, or.WEBER = { type: 3, value: "WEBER" };
  let Ff = or;
  e.IfcSIUnitName = Ff;
  const $f = class $f {
  };
  $f.BATH = { type: 3, value: "BATH" }, $f.BIDET = { type: 3, value: "BIDET" }, $f.CISTERN = { type: 3, value: "CISTERN" }, $f.SHOWER = { type: 3, value: "SHOWER" }, $f.SINK = { type: 3, value: "SINK" }, $f.SANITARYFOUNTAIN = { type: 3, value: "SANITARYFOUNTAIN" }, $f.TOILETPAN = { type: 3, value: "TOILETPAN" }, $f.URINAL = { type: 3, value: "URINAL" }, $f.WASHHANDBASIN = { type: 3, value: "WASHHANDBASIN" }, $f.WCSEAT = { type: 3, value: "WCSEAT" }, $f.USERDEFINED = { type: 3, value: "USERDEFINED" }, $f.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let L3 = $f;
  e.IfcSanitaryTerminalTypeEnum = L3;
  const eD = class eD {
  };
  eD.UNIFORM = { type: 3, value: "UNIFORM" }, eD.TAPERED = { type: 3, value: "TAPERED" };
  let _3 = eD;
  e.IfcSectionTypeEnum = _3;
  const jc = class jc {
  };
  jc.CO2SENSOR = { type: 3, value: "CO2SENSOR" }, jc.FIRESENSOR = { type: 3, value: "FIRESENSOR" }, jc.FLOWSENSOR = { type: 3, value: "FLOWSENSOR" }, jc.GASSENSOR = { type: 3, value: "GASSENSOR" }, jc.HEATSENSOR = { type: 3, value: "HEATSENSOR" }, jc.HUMIDITYSENSOR = { type: 3, value: "HUMIDITYSENSOR" }, jc.LIGHTSENSOR = { type: 3, value: "LIGHTSENSOR" }, jc.MOISTURESENSOR = { type: 3, value: "MOISTURESENSOR" }, jc.MOVEMENTSENSOR = { type: 3, value: "MOVEMENTSENSOR" }, jc.PRESSURESENSOR = { type: 3, value: "PRESSURESENSOR" }, jc.SMOKESENSOR = { type: 3, value: "SMOKESENSOR" }, jc.SOUNDSENSOR = { type: 3, value: "SOUNDSENSOR" }, jc.TEMPERATURESENSOR = { type: 3, value: "TEMPERATURESENSOR" }, jc.USERDEFINED = { type: 3, value: "USERDEFINED" }, jc.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let x3 = jc;
  e.IfcSensorTypeEnum = x3;
  const CR = class CR {
  };
  CR.START_START = { type: 3, value: "START_START" }, CR.START_FINISH = { type: 3, value: "START_FINISH" }, CR.FINISH_START = { type: 3, value: "FINISH_START" }, CR.FINISH_FINISH = { type: 3, value: "FINISH_FINISH" }, CR.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let BI = CR;
  e.IfcSequenceEnum = BI;
  const cy = class cy {
  };
  cy.A_QUALITYOFCOMPONENTS = { type: 3, value: "A_QUALITYOFCOMPONENTS" }, cy.B_DESIGNLEVEL = { type: 3, value: "B_DESIGNLEVEL" }, cy.C_WORKEXECUTIONLEVEL = { type: 3, value: "C_WORKEXECUTIONLEVEL" }, cy.D_INDOORENVIRONMENT = { type: 3, value: "D_INDOORENVIRONMENT" }, cy.E_OUTDOORENVIRONMENT = { type: 3, value: "E_OUTDOORENVIRONMENT" }, cy.F_INUSECONDITIONS = { type: 3, value: "F_INUSECONDITIONS" }, cy.G_MAINTENANCELEVEL = { type: 3, value: "G_MAINTENANCELEVEL" }, cy.USERDEFINED = { type: 3, value: "USERDEFINED" }, cy.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let P3 = cy;
  e.IfcServiceLifeFactorTypeEnum = P3;
  const OR = class OR {
  };
  OR.ACTUALSERVICELIFE = { type: 3, value: "ACTUALSERVICELIFE" }, OR.EXPECTEDSERVICELIFE = { type: 3, value: "EXPECTEDSERVICELIFE" }, OR.OPTIMISTICREFERENCESERVICELIFE = { type: 3, value: "OPTIMISTICREFERENCESERVICELIFE" }, OR.PESSIMISTICREFERENCESERVICELIFE = { type: 3, value: "PESSIMISTICREFERENCESERVICELIFE" }, OR.REFERENCESERVICELIFE = { type: 3, value: "REFERENCESERVICELIFE" };
  let M3 = OR;
  e.IfcServiceLifeTypeEnum = M3;
  const HE = class HE {
  };
  HE.FLOOR = { type: 3, value: "FLOOR" }, HE.ROOF = { type: 3, value: "ROOF" }, HE.LANDING = { type: 3, value: "LANDING" }, HE.BASESLAB = { type: 3, value: "BASESLAB" }, HE.USERDEFINED = { type: 3, value: "USERDEFINED" }, HE.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let U3 = HE;
  e.IfcSlabTypeEnum = U3;
  const Rw = class Rw {
  };
  Rw.DBA = { type: 3, value: "DBA" }, Rw.DBB = { type: 3, value: "DBB" }, Rw.DBC = { type: 3, value: "DBC" }, Rw.NC = { type: 3, value: "NC" }, Rw.NR = { type: 3, value: "NR" }, Rw.USERDEFINED = { type: 3, value: "USERDEFINED" }, Rw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let B3 = Rw;
  e.IfcSoundScaleEnum = B3;
  const hy = class hy {
  };
  hy.SECTIONALRADIATOR = { type: 3, value: "SECTIONALRADIATOR" }, hy.PANELRADIATOR = { type: 3, value: "PANELRADIATOR" }, hy.TUBULARRADIATOR = { type: 3, value: "TUBULARRADIATOR" }, hy.CONVECTOR = { type: 3, value: "CONVECTOR" }, hy.BASEBOARDHEATER = { type: 3, value: "BASEBOARDHEATER" }, hy.FINNEDTUBEUNIT = { type: 3, value: "FINNEDTUBEUNIT" }, hy.UNITHEATER = { type: 3, value: "UNITHEATER" }, hy.USERDEFINED = { type: 3, value: "USERDEFINED" }, hy.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let FI = hy;
  e.IfcSpaceHeaterTypeEnum = FI;
  const zo = class zo {
  };
  zo.USERDEFINED = { type: 3, value: "USERDEFINED" }, zo.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let HI = zo;
  e.IfcSpaceTypeEnum = HI;
  const yT = class yT {
  };
  yT.BIRDCAGE = { type: 3, value: "BIRDCAGE" }, yT.COWL = { type: 3, value: "COWL" }, yT.RAINWATERHOPPER = { type: 3, value: "RAINWATERHOPPER" }, yT.USERDEFINED = { type: 3, value: "USERDEFINED" }, yT.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let F3 = yT;
  e.IfcStackTerminalTypeEnum = F3;
  const vw = class vw {
  };
  vw.STRAIGHT = { type: 3, value: "STRAIGHT" }, vw.WINDER = { type: 3, value: "WINDER" }, vw.SPIRAL = { type: 3, value: "SPIRAL" }, vw.CURVED = { type: 3, value: "CURVED" }, vw.FREEFORM = { type: 3, value: "FREEFORM" }, vw.USERDEFINED = { type: 3, value: "USERDEFINED" }, vw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let H3 = vw;
  e.IfcStairFlightTypeEnum = H3;
  const Bd = class Bd {
  };
  Bd.STRAIGHT_RUN_STAIR = { type: 3, value: "STRAIGHT_RUN_STAIR" }, Bd.TWO_STRAIGHT_RUN_STAIR = { type: 3, value: "TWO_STRAIGHT_RUN_STAIR" }, Bd.QUARTER_WINDING_STAIR = { type: 3, value: "QUARTER_WINDING_STAIR" }, Bd.QUARTER_TURN_STAIR = { type: 3, value: "QUARTER_TURN_STAIR" }, Bd.HALF_WINDING_STAIR = { type: 3, value: "HALF_WINDING_STAIR" }, Bd.HALF_TURN_STAIR = { type: 3, value: "HALF_TURN_STAIR" }, Bd.TWO_QUARTER_WINDING_STAIR = { type: 3, value: "TWO_QUARTER_WINDING_STAIR" }, Bd.TWO_QUARTER_TURN_STAIR = { type: 3, value: "TWO_QUARTER_TURN_STAIR" }, Bd.THREE_QUARTER_WINDING_STAIR = { type: 3, value: "THREE_QUARTER_WINDING_STAIR" }, Bd.THREE_QUARTER_TURN_STAIR = { type: 3, value: "THREE_QUARTER_TURN_STAIR" }, Bd.SPIRAL_STAIR = { type: 3, value: "SPIRAL_STAIR" }, Bd.DOUBLE_RETURN_STAIR = { type: 3, value: "DOUBLE_RETURN_STAIR" }, Bd.CURVED_RUN_STAIR = { type: 3, value: "CURVED_RUN_STAIR" }, Bd.TWO_CURVED_RUN_STAIR = { type: 3, value: "TWO_CURVED_RUN_STAIR" }, Bd.USERDEFINED = { type: 3, value: "USERDEFINED" }, Bd.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let G3 = Bd;
  e.IfcStairTypeEnum = G3;
  const LR = class LR {
  };
  LR.READWRITE = { type: 3, value: "READWRITE" }, LR.READONLY = { type: 3, value: "READONLY" }, LR.LOCKED = { type: 3, value: "LOCKED" }, LR.READWRITELOCKED = { type: 3, value: "READWRITELOCKED" }, LR.READONLYLOCKED = { type: 3, value: "READONLYLOCKED" };
  let k3 = LR;
  e.IfcStateEnum = k3;
  const Aw = class Aw {
  };
  Aw.RIGID_JOINED_MEMBER = { type: 3, value: "RIGID_JOINED_MEMBER" }, Aw.PIN_JOINED_MEMBER = { type: 3, value: "PIN_JOINED_MEMBER" }, Aw.CABLE = { type: 3, value: "CABLE" }, Aw.TENSION_MEMBER = { type: 3, value: "TENSION_MEMBER" }, Aw.COMPRESSION_MEMBER = { type: 3, value: "COMPRESSION_MEMBER" }, Aw.USERDEFINED = { type: 3, value: "USERDEFINED" }, Aw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let im = Aw;
  e.IfcStructuralCurveTypeEnum = im;
  const _R = class _R {
  };
  _R.BENDING_ELEMENT = { type: 3, value: "BENDING_ELEMENT" }, _R.MEMBRANE_ELEMENT = { type: 3, value: "MEMBRANE_ELEMENT" }, _R.SHELL = { type: 3, value: "SHELL" }, _R.USERDEFINED = { type: 3, value: "USERDEFINED" }, _R.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Hf = _R;
  e.IfcStructuralSurfaceTypeEnum = Hf;
  const tD = class tD {
  };
  tD.POSITIVE = { type: 3, value: "POSITIVE" }, tD.NEGATIVE = { type: 3, value: "NEGATIVE" }, tD.BOTH = { type: 3, value: "BOTH" };
  let Gf = tD;
  e.IfcSurfaceSide = Gf;
  const fy = class fy {
  };
  fy.BUMP = { type: 3, value: "BUMP" }, fy.OPACITY = { type: 3, value: "OPACITY" }, fy.REFLECTION = { type: 3, value: "REFLECTION" }, fy.SELFILLUMINATION = { type: 3, value: "SELFILLUMINATION" }, fy.SHININESS = { type: 3, value: "SHININESS" }, fy.SPECULAR = { type: 3, value: "SPECULAR" }, fy.TEXTURE = { type: 3, value: "TEXTURE" }, fy.TRANSPARENCYMAP = { type: 3, value: "TRANSPARENCYMAP" }, fy.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let V3 = fy;
  e.IfcSurfaceTextureEnum = V3;
  const GE = class GE {
  };
  GE.CONTACTOR = { type: 3, value: "CONTACTOR" }, GE.EMERGENCYSTOP = { type: 3, value: "EMERGENCYSTOP" }, GE.STARTER = { type: 3, value: "STARTER" }, GE.SWITCHDISCONNECTOR = { type: 3, value: "SWITCHDISCONNECTOR" }, GE.TOGGLESWITCH = { type: 3, value: "TOGGLESWITCH" }, GE.USERDEFINED = { type: 3, value: "USERDEFINED" }, GE.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Zu = GE;
  e.IfcSwitchingDeviceTypeEnum = Zu;
  const ET = class ET {
  };
  ET.PREFORMED = { type: 3, value: "PREFORMED" }, ET.SECTIONAL = { type: 3, value: "SECTIONAL" }, ET.EXPANSION = { type: 3, value: "EXPANSION" }, ET.PRESSUREVESSEL = { type: 3, value: "PRESSUREVESSEL" }, ET.USERDEFINED = { type: 3, value: "USERDEFINED" }, ET.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let kf = ET;
  e.IfcTankTypeEnum = kf;
  const gT = class gT {
  };
  gT.STRAND = { type: 3, value: "STRAND" }, gT.WIRE = { type: 3, value: "WIRE" }, gT.BAR = { type: 3, value: "BAR" }, gT.COATED = { type: 3, value: "COATED" }, gT.USERDEFINED = { type: 3, value: "USERDEFINED" }, gT.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let nm = gT;
  e.IfcTendonTypeEnum = nm;
  const SS = class SS {
  };
  SS.LEFT = { type: 3, value: "LEFT" }, SS.RIGHT = { type: 3, value: "RIGHT" }, SS.UP = { type: 3, value: "UP" }, SS.DOWN = { type: 3, value: "DOWN" };
  let sm = SS;
  e.IfcTextPath = sm;
  const bh = class bh {
  };
  bh.PEOPLE = { type: 3, value: "PEOPLE" }, bh.LIGHTING = { type: 3, value: "LIGHTING" }, bh.EQUIPMENT = { type: 3, value: "EQUIPMENT" }, bh.VENTILATIONINDOORAIR = { type: 3, value: "VENTILATIONINDOORAIR" }, bh.VENTILATIONOUTSIDEAIR = { type: 3, value: "VENTILATIONOUTSIDEAIR" }, bh.RECIRCULATEDAIR = { type: 3, value: "RECIRCULATEDAIR" }, bh.EXHAUSTAIR = { type: 3, value: "EXHAUSTAIR" }, bh.AIREXCHANGERATE = { type: 3, value: "AIREXCHANGERATE" }, bh.DRYBULBTEMPERATURE = { type: 3, value: "DRYBULBTEMPERATURE" }, bh.RELATIVEHUMIDITY = { type: 3, value: "RELATIVEHUMIDITY" }, bh.INFILTRATION = { type: 3, value: "INFILTRATION" }, bh.USERDEFINED = { type: 3, value: "USERDEFINED" }, bh.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let z3 = bh;
  e.IfcThermalLoadSourceEnum = z3;
  const bS = class bS {
  };
  bS.SENSIBLE = { type: 3, value: "SENSIBLE" }, bS.LATENT = { type: 3, value: "LATENT" }, bS.RADIANT = { type: 3, value: "RADIANT" }, bS.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let _d = bS;
  e.IfcThermalLoadTypeEnum = _d;
  const Sw = class Sw {
  };
  Sw.CONTINUOUS = { type: 3, value: "CONTINUOUS" }, Sw.DISCRETE = { type: 3, value: "DISCRETE" }, Sw.DISCRETEBINARY = { type: 3, value: "DISCRETEBINARY" }, Sw.PIECEWISEBINARY = { type: 3, value: "PIECEWISEBINARY" }, Sw.PIECEWISECONSTANT = { type: 3, value: "PIECEWISECONSTANT" }, Sw.PIECEWISECONTINUOUS = { type: 3, value: "PIECEWISECONTINUOUS" }, Sw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let om = Sw;
  e.IfcTimeSeriesDataTypeEnum = om;
  const wT = class wT {
  };
  wT.ANNUAL = { type: 3, value: "ANNUAL" }, wT.MONTHLY = { type: 3, value: "MONTHLY" }, wT.WEEKLY = { type: 3, value: "WEEKLY" }, wT.DAILY = { type: 3, value: "DAILY" }, wT.USERDEFINED = { type: 3, value: "USERDEFINED" }, wT.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Z = wT;
  e.IfcTimeSeriesScheduleTypeEnum = Z;
  const xR = class xR {
  };
  xR.CURRENT = { type: 3, value: "CURRENT" }, xR.FREQUENCY = { type: 3, value: "FREQUENCY" }, xR.VOLTAGE = { type: 3, value: "VOLTAGE" }, xR.USERDEFINED = { type: 3, value: "USERDEFINED" }, xR.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let ae = xR;
  e.IfcTransformerTypeEnum = ae;
  const NS = class NS {
  };
  NS.DISCONTINUOUS = { type: 3, value: "DISCONTINUOUS" }, NS.CONTINUOUS = { type: 3, value: "CONTINUOUS" }, NS.CONTSAMEGRADIENT = { type: 3, value: "CONTSAMEGRADIENT" }, NS.CONTSAMEGRADIENTSAMECURVATURE = { type: 3, value: "CONTSAMEGRADIENTSAMECURVATURE" };
  let Re = NS;
  e.IfcTransitionCode = Re;
  const PR = class PR {
  };
  PR.ELEVATOR = { type: 3, value: "ELEVATOR" }, PR.ESCALATOR = { type: 3, value: "ESCALATOR" }, PR.MOVINGWALKWAY = { type: 3, value: "MOVINGWALKWAY" }, PR.USERDEFINED = { type: 3, value: "USERDEFINED" }, PR.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ue = PR;
  e.IfcTransportElementTypeEnum = Ue;
  const iD = class iD {
  };
  iD.CARTESIAN = { type: 3, value: "CARTESIAN" }, iD.PARAMETER = { type: 3, value: "PARAMETER" }, iD.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" };
  let nt = iD;
  e.IfcTrimmingPreference = nt;
  const nD = class nD {
  };
  nD.FINNED = { type: 3, value: "FINNED" }, nD.USERDEFINED = { type: 3, value: "USERDEFINED" }, nD.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let At = nD;
  e.IfcTubeBundleTypeEnum = At;
  const rr = class rr {
  };
  rr.ABSORBEDDOSEUNIT = { type: 3, value: "ABSORBEDDOSEUNIT" }, rr.AMOUNTOFSUBSTANCEUNIT = { type: 3, value: "AMOUNTOFSUBSTANCEUNIT" }, rr.AREAUNIT = { type: 3, value: "AREAUNIT" }, rr.DOSEEQUIVALENTUNIT = { type: 3, value: "DOSEEQUIVALENTUNIT" }, rr.ELECTRICCAPACITANCEUNIT = { type: 3, value: "ELECTRICCAPACITANCEUNIT" }, rr.ELECTRICCHARGEUNIT = { type: 3, value: "ELECTRICCHARGEUNIT" }, rr.ELECTRICCONDUCTANCEUNIT = { type: 3, value: "ELECTRICCONDUCTANCEUNIT" }, rr.ELECTRICCURRENTUNIT = { type: 3, value: "ELECTRICCURRENTUNIT" }, rr.ELECTRICRESISTANCEUNIT = { type: 3, value: "ELECTRICRESISTANCEUNIT" }, rr.ELECTRICVOLTAGEUNIT = { type: 3, value: "ELECTRICVOLTAGEUNIT" }, rr.ENERGYUNIT = { type: 3, value: "ENERGYUNIT" }, rr.FORCEUNIT = { type: 3, value: "FORCEUNIT" }, rr.FREQUENCYUNIT = { type: 3, value: "FREQUENCYUNIT" }, rr.ILLUMINANCEUNIT = { type: 3, value: "ILLUMINANCEUNIT" }, rr.INDUCTANCEUNIT = { type: 3, value: "INDUCTANCEUNIT" }, rr.LENGTHUNIT = { type: 3, value: "LENGTHUNIT" }, rr.LUMINOUSFLUXUNIT = { type: 3, value: "LUMINOUSFLUXUNIT" }, rr.LUMINOUSINTENSITYUNIT = { type: 3, value: "LUMINOUSINTENSITYUNIT" }, rr.MAGNETICFLUXDENSITYUNIT = { type: 3, value: "MAGNETICFLUXDENSITYUNIT" }, rr.MAGNETICFLUXUNIT = { type: 3, value: "MAGNETICFLUXUNIT" }, rr.MASSUNIT = { type: 3, value: "MASSUNIT" }, rr.PLANEANGLEUNIT = { type: 3, value: "PLANEANGLEUNIT" }, rr.POWERUNIT = { type: 3, value: "POWERUNIT" }, rr.PRESSUREUNIT = { type: 3, value: "PRESSUREUNIT" }, rr.RADIOACTIVITYUNIT = { type: 3, value: "RADIOACTIVITYUNIT" }, rr.SOLIDANGLEUNIT = { type: 3, value: "SOLIDANGLEUNIT" }, rr.THERMODYNAMICTEMPERATUREUNIT = { type: 3, value: "THERMODYNAMICTEMPERATUREUNIT" }, rr.TIMEUNIT = { type: 3, value: "TIMEUNIT" }, rr.VOLUMEUNIT = { type: 3, value: "VOLUMEUNIT" }, rr.USERDEFINED = { type: 3, value: "USERDEFINED" };
  let Lt = rr;
  e.IfcUnitEnum = Lt;
  const TT = class TT {
  };
  TT.AIRHANDLER = { type: 3, value: "AIRHANDLER" }, TT.AIRCONDITIONINGUNIT = { type: 3, value: "AIRCONDITIONINGUNIT" }, TT.SPLITSYSTEM = { type: 3, value: "SPLITSYSTEM" }, TT.ROOFTOPUNIT = { type: 3, value: "ROOFTOPUNIT" }, TT.USERDEFINED = { type: 3, value: "USERDEFINED" }, TT.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let _t = TT;
  e.IfcUnitaryEquipmentTypeEnum = _t;
  const yl = class yl {
  };
  yl.AIRRELEASE = { type: 3, value: "AIRRELEASE" }, yl.ANTIVACUUM = { type: 3, value: "ANTIVACUUM" }, yl.CHANGEOVER = { type: 3, value: "CHANGEOVER" }, yl.CHECK = { type: 3, value: "CHECK" }, yl.COMMISSIONING = { type: 3, value: "COMMISSIONING" }, yl.DIVERTING = { type: 3, value: "DIVERTING" }, yl.DRAWOFFCOCK = { type: 3, value: "DRAWOFFCOCK" }, yl.DOUBLECHECK = { type: 3, value: "DOUBLECHECK" }, yl.DOUBLEREGULATING = { type: 3, value: "DOUBLEREGULATING" }, yl.FAUCET = { type: 3, value: "FAUCET" }, yl.FLUSHING = { type: 3, value: "FLUSHING" }, yl.GASCOCK = { type: 3, value: "GASCOCK" }, yl.GASTAP = { type: 3, value: "GASTAP" }, yl.ISOLATING = { type: 3, value: "ISOLATING" }, yl.MIXING = { type: 3, value: "MIXING" }, yl.PRESSUREREDUCING = { type: 3, value: "PRESSUREREDUCING" }, yl.PRESSURERELIEF = { type: 3, value: "PRESSURERELIEF" }, yl.REGULATING = { type: 3, value: "REGULATING" }, yl.SAFETYCUTOFF = { type: 3, value: "SAFETYCUTOFF" }, yl.STEAMTRAP = { type: 3, value: "STEAMTRAP" }, yl.STOPCOCK = { type: 3, value: "STOPCOCK" }, yl.USERDEFINED = { type: 3, value: "USERDEFINED" }, yl.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let oi = yl;
  e.IfcValveTypeEnum = oi;
  const DS = class DS {
  };
  DS.COMPRESSION = { type: 3, value: "COMPRESSION" }, DS.SPRING = { type: 3, value: "SPRING" }, DS.USERDEFINED = { type: 3, value: "USERDEFINED" }, DS.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let mi = DS;
  e.IfcVibrationIsolatorTypeEnum = mi;
  const bw = class bw {
  };
  bw.STANDARD = { type: 3, value: "STANDARD" }, bw.POLYGONAL = { type: 3, value: "POLYGONAL" }, bw.SHEAR = { type: 3, value: "SHEAR" }, bw.ELEMENTEDWALL = { type: 3, value: "ELEMENTEDWALL" }, bw.PLUMBINGWALL = { type: 3, value: "PLUMBINGWALL" }, bw.USERDEFINED = { type: 3, value: "USERDEFINED" }, bw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let zi = bw;
  e.IfcWallTypeEnum = zi;
  const v0 = class v0 {
  };
  v0.FLOORTRAP = { type: 3, value: "FLOORTRAP" }, v0.FLOORWASTE = { type: 3, value: "FLOORWASTE" }, v0.GULLYSUMP = { type: 3, value: "GULLYSUMP" }, v0.GULLYTRAP = { type: 3, value: "GULLYTRAP" }, v0.GREASEINTERCEPTOR = { type: 3, value: "GREASEINTERCEPTOR" }, v0.OILINTERCEPTOR = { type: 3, value: "OILINTERCEPTOR" }, v0.PETROLINTERCEPTOR = { type: 3, value: "PETROLINTERCEPTOR" }, v0.ROOFDRAIN = { type: 3, value: "ROOFDRAIN" }, v0.WASTEDISPOSALUNIT = { type: 3, value: "WASTEDISPOSALUNIT" }, v0.WASTETRAP = { type: 3, value: "WASTETRAP" }, v0.USERDEFINED = { type: 3, value: "USERDEFINED" }, v0.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let yn = v0;
  e.IfcWasteTerminalTypeEnum = yn;
  const Ml = class Ml {
  };
  Ml.SIDEHUNGRIGHTHAND = { type: 3, value: "SIDEHUNGRIGHTHAND" }, Ml.SIDEHUNGLEFTHAND = { type: 3, value: "SIDEHUNGLEFTHAND" }, Ml.TILTANDTURNRIGHTHAND = { type: 3, value: "TILTANDTURNRIGHTHAND" }, Ml.TILTANDTURNLEFTHAND = { type: 3, value: "TILTANDTURNLEFTHAND" }, Ml.TOPHUNG = { type: 3, value: "TOPHUNG" }, Ml.BOTTOMHUNG = { type: 3, value: "BOTTOMHUNG" }, Ml.PIVOTHORIZONTAL = { type: 3, value: "PIVOTHORIZONTAL" }, Ml.PIVOTVERTICAL = { type: 3, value: "PIVOTVERTICAL" }, Ml.SLIDINGHORIZONTAL = { type: 3, value: "SLIDINGHORIZONTAL" }, Ml.SLIDINGVERTICAL = { type: 3, value: "SLIDINGVERTICAL" }, Ml.REMOVABLECASEMENT = { type: 3, value: "REMOVABLECASEMENT" }, Ml.FIXEDCASEMENT = { type: 3, value: "FIXEDCASEMENT" }, Ml.OTHEROPERATION = { type: 3, value: "OTHEROPERATION" }, Ml.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Xi = Ml;
  e.IfcWindowPanelOperationEnum = Xi;
  const RT = class RT {
  };
  RT.LEFT = { type: 3, value: "LEFT" }, RT.MIDDLE = { type: 3, value: "MIDDLE" }, RT.RIGHT = { type: 3, value: "RIGHT" }, RT.BOTTOM = { type: 3, value: "BOTTOM" }, RT.TOP = { type: 3, value: "TOP" }, RT.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let rn = RT;
  e.IfcWindowPanelPositionEnum = rn;
  const kE = class kE {
  };
  kE.ALUMINIUM = { type: 3, value: "ALUMINIUM" }, kE.HIGH_GRADE_STEEL = { type: 3, value: "HIGH_GRADE_STEEL" }, kE.STEEL = { type: 3, value: "STEEL" }, kE.WOOD = { type: 3, value: "WOOD" }, kE.ALUMINIUM_WOOD = { type: 3, value: "ALUMINIUM_WOOD" }, kE.PLASTIC = { type: 3, value: "PLASTIC" }, kE.OTHER_CONSTRUCTION = { type: 3, value: "OTHER_CONSTRUCTION" }, kE.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Fn = kE;
  e.IfcWindowStyleConstructionEnum = Fn;
  const XI = class XI {
  };
  XI.SINGLE_PANEL = { type: 3, value: "SINGLE_PANEL" }, XI.DOUBLE_PANEL_VERTICAL = { type: 3, value: "DOUBLE_PANEL_VERTICAL" }, XI.DOUBLE_PANEL_HORIZONTAL = { type: 3, value: "DOUBLE_PANEL_HORIZONTAL" }, XI.TRIPLE_PANEL_VERTICAL = { type: 3, value: "TRIPLE_PANEL_VERTICAL" }, XI.TRIPLE_PANEL_BOTTOM = { type: 3, value: "TRIPLE_PANEL_BOTTOM" }, XI.TRIPLE_PANEL_TOP = { type: 3, value: "TRIPLE_PANEL_TOP" }, XI.TRIPLE_PANEL_LEFT = { type: 3, value: "TRIPLE_PANEL_LEFT" }, XI.TRIPLE_PANEL_RIGHT = { type: 3, value: "TRIPLE_PANEL_RIGHT" }, XI.TRIPLE_PANEL_HORIZONTAL = { type: 3, value: "TRIPLE_PANEL_HORIZONTAL" }, XI.USERDEFINED = { type: 3, value: "USERDEFINED" }, XI.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ps = XI;
  e.IfcWindowStyleOperationEnum = Ps;
  const Kf = class Kf {
  };
  Kf.ACTUAL = { type: 3, value: "ACTUAL" }, Kf.BASELINE = { type: 3, value: "BASELINE" }, Kf.PLANNED = { type: 3, value: "PLANNED" }, Kf.USERDEFINED = { type: 3, value: "USERDEFINED" }, Kf.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Fs = Kf;
  e.IfcWorkControlTypeEnum = Fs;
  class uo extends qt {
    constructor(D, M, k) {
      super(), this.Role = D, this.UserDefinedRole = M, this.Description = k, this.type = 3630933823;
    }
  }
  e.IfcActorRole = uo;
  class Ui extends qt {
    constructor(D, M, k) {
      super(), this.Purpose = D, this.Description = M, this.UserDefinedPurpose = k, this.type = 618182010;
    }
  }
  e.IfcAddress = Ui;
  class Rn extends qt {
    constructor(D, M, k, $) {
      super(), this.ApplicationDeveloper = D, this.Version = M, this.ApplicationFullName = k, this.ApplicationIdentifier = $, this.type = 639542469;
    }
  }
  e.IfcApplication = Rn;
  class Vo extends qt {
    constructor(D, M, k, $, J, ue) {
      super(), this.Name = D, this.Description = M, this.AppliedValue = k, this.UnitBasis = $, this.ApplicableDate = J, this.FixedUntilDate = ue, this.type = 411424972;
    }
  }
  e.IfcAppliedValue = Vo;
  class Do extends qt {
    constructor(D, M, k, $, J) {
      super(), this.ComponentOfTotal = D, this.Components = M, this.ArithmeticOperator = k, this.Name = $, this.Description = J, this.type = 1110488051;
    }
  }
  e.IfcAppliedValueRelationship = Do;
  class Pl extends qt {
    constructor(D, M, k, $, J, ue, Ie) {
      super(), this.Description = D, this.ApprovalDateTime = M, this.ApprovalStatus = k, this.ApprovalLevel = $, this.ApprovalQualifier = J, this.Name = ue, this.Identifier = Ie, this.type = 130549933;
    }
  }
  e.IfcApproval = Pl;
  class cr extends qt {
    constructor(D, M, k) {
      super(), this.Actor = D, this.Approval = M, this.Role = k, this.type = 2080292479;
    }
  }
  e.IfcApprovalActorRelationship = cr;
  class S4 extends qt {
    constructor(D, M) {
      super(), this.ApprovedProperties = D, this.Approval = M, this.type = 390851274;
    }
  }
  e.IfcApprovalPropertyRelationship = S4;
  class b4 extends qt {
    constructor(D, M, k, $) {
      super(), this.RelatedApproval = D, this.RelatingApproval = M, this.Description = k, this.Name = $, this.type = 3869604511;
    }
  }
  e.IfcApprovalRelationship = b4;
  class IE extends qt {
    constructor(D) {
      super(), this.Name = D, this.type = 4037036970;
    }
  }
  e.IfcBoundaryCondition = IE;
  class N4 extends IE {
    constructor(D, M, k, $, J, ue, Ie) {
      super(D), this.Name = D, this.LinearStiffnessByLengthX = M, this.LinearStiffnessByLengthY = k, this.LinearStiffnessByLengthZ = $, this.RotationalStiffnessByLengthX = J, this.RotationalStiffnessByLengthY = ue, this.RotationalStiffnessByLengthZ = Ie, this.type = 1560379544;
    }
  }
  e.IfcBoundaryEdgeCondition = N4;
  class D4 extends IE {
    constructor(D, M, k, $) {
      super(D), this.Name = D, this.LinearStiffnessByAreaX = M, this.LinearStiffnessByAreaY = k, this.LinearStiffnessByAreaZ = $, this.type = 3367102660;
    }
  }
  e.IfcBoundaryFaceCondition = D4;
  class C4 extends IE {
    constructor(D, M, k, $, J, ue, Ie) {
      super(D), this.Name = D, this.LinearStiffnessX = M, this.LinearStiffnessY = k, this.LinearStiffnessZ = $, this.RotationalStiffnessX = J, this.RotationalStiffnessY = ue, this.RotationalStiffnessZ = Ie, this.type = 1387855156;
    }
  }
  e.IfcBoundaryNodeCondition = C4;
  class O4 extends C4 {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie), this.Name = D, this.LinearStiffnessX = M, this.LinearStiffnessY = k, this.LinearStiffnessZ = $, this.RotationalStiffnessX = J, this.RotationalStiffnessY = ue, this.RotationalStiffnessZ = Ie, this.WarpingStiffness = ve, this.type = 2069777674;
    }
  }
  e.IfcBoundaryNodeConditionWarping = O4;
  class k5 extends qt {
    constructor(D, M, k) {
      super(), this.DayComponent = D, this.MonthComponent = M, this.YearComponent = k, this.type = 622194075;
    }
  }
  e.IfcCalendarDate = k5;
  class V5 extends qt {
    constructor(D, M, k, $) {
      super(), this.Source = D, this.Edition = M, this.EditionDate = k, this.Name = $, this.type = 747523909;
    }
  }
  e.IfcClassification = V5;
  class L4 extends qt {
    constructor(D, M, k) {
      super(), this.Notation = D, this.ItemOf = M, this.Title = k, this.type = 1767535486;
    }
  }
  e.IfcClassificationItem = L4;
  class _4 extends qt {
    constructor(D, M) {
      super(), this.RelatingItem = D, this.RelatedItems = M, this.type = 1098599126;
    }
  }
  e.IfcClassificationItemRelationship = _4;
  class z5 extends qt {
    constructor(D) {
      super(), this.NotationFacets = D, this.type = 938368621;
    }
  }
  e.IfcClassificationNotation = z5;
  class j5 extends qt {
    constructor(D) {
      super(), this.NotationValue = D, this.type = 3639012971;
    }
  }
  e.IfcClassificationNotationFacet = j5;
  class x4 extends qt {
    constructor(D) {
      super(), this.Name = D, this.type = 3264961684;
    }
  }
  e.IfcColourSpecification = x4;
  class j3 extends qt {
    constructor() {
      super(), this.type = 2859738748;
    }
  }
  e.IfcConnectionGeometry = j3;
  class $g extends j3 {
    constructor(D, M) {
      super(), this.PointOnRelatingElement = D, this.PointOnRelatedElement = M, this.type = 2614616156;
    }
  }
  e.IfcConnectionPointGeometry = $g;
  class pE extends j3 {
    constructor(D, M, k) {
      super(), this.LocationAtRelatingElement = D, this.LocationAtRelatedElement = M, this.ProfileOfPort = k, this.type = 4257277454;
    }
  }
  e.IfcConnectionPortGeometry = pE;
  class mE extends j3 {
    constructor(D, M) {
      super(), this.SurfaceOnRelatingElement = D, this.SurfaceOnRelatedElement = M, this.type = 2732653382;
    }
  }
  e.IfcConnectionSurfaceGeometry = mE;
  class Kg extends qt {
    constructor(D, M, k, $, J, ue, Ie) {
      super(), this.Name = D, this.Description = M, this.ConstraintGrade = k, this.ConstraintSource = $, this.CreatingActor = J, this.CreationTime = ue, this.UserDefinedGrade = Ie, this.type = 1959218052;
    }
  }
  e.IfcConstraint = Kg;
  class W5 extends qt {
    constructor(D, M, k, $, J) {
      super(), this.Name = D, this.Description = M, this.RelatingConstraint = k, this.RelatedConstraints = $, this.LogicalAggregator = J, this.type = 1658513725;
    }
  }
  e.IfcConstraintAggregationRelationship = W5;
  class Th extends qt {
    constructor(D, M) {
      super(), this.ClassifiedConstraint = D, this.RelatedClassifications = M, this.type = 613356794;
    }
  }
  e.IfcConstraintClassificationRelationship = Th;
  class yE extends qt {
    constructor(D, M, k, $) {
      super(), this.Name = D, this.Description = M, this.RelatingConstraint = k, this.RelatedConstraints = $, this.type = 347226245;
    }
  }
  e.IfcConstraintRelationship = yE;
  class EE extends qt {
    constructor(D, M, k) {
      super(), this.HourOffset = D, this.MinuteOffset = M, this.Sense = k, this.type = 1065062679;
    }
  }
  e.IfcCoordinatedUniversalTimeOffset = EE;
  class P4 extends Vo {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue), this.Name = D, this.Description = M, this.AppliedValue = k, this.UnitBasis = $, this.ApplicableDate = J, this.FixedUntilDate = ue, this.CostType = Ie, this.Condition = ve, this.type = 602808272;
    }
  }
  e.IfcCostValue = P4;
  class M4 extends qt {
    constructor(D, M, k, $, J) {
      super(), this.RelatingMonetaryUnit = D, this.RelatedMonetaryUnit = M, this.ExchangeRate = k, this.RateDateTime = $, this.RateSource = J, this.type = 539742890;
    }
  }
  e.IfcCurrencyRelationship = M4;
  class U4 extends qt {
    constructor(D, M) {
      super(), this.Name = D, this.PatternList = M, this.type = 1105321065;
    }
  }
  e.IfcCurveStyleFont = U4;
  class Zg extends qt {
    constructor(D, M, k) {
      super(), this.Name = D, this.CurveFont = M, this.CurveFontScaling = k, this.type = 2367409068;
    }
  }
  e.IfcCurveStyleFontAndScaling = Zg;
  class Qg extends qt {
    constructor(D, M) {
      super(), this.VisibleSegmentLength = D, this.InvisibleSegmentLength = M, this.type = 3510044353;
    }
  }
  e.IfcCurveStyleFontPattern = Qg;
  class B4 extends qt {
    constructor(D, M) {
      super(), this.DateComponent = D, this.TimeComponent = M, this.type = 1072939445;
    }
  }
  e.IfcDateAndTime = B4;
  class F4 extends qt {
    constructor(D, M, k) {
      super(), this.Elements = D, this.UnitType = M, this.UserDefinedType = k, this.type = 1765591967;
    }
  }
  e.IfcDerivedUnit = F4;
  class H4 extends qt {
    constructor(D, M) {
      super(), this.Unit = D, this.Exponent = M, this.type = 1045800335;
    }
  }
  e.IfcDerivedUnitElement = H4;
  class Jg extends qt {
    constructor(D, M, k, $, J, ue, Ie) {
      super(), this.LengthExponent = D, this.MassExponent = M, this.TimeExponent = k, this.ElectricCurrentExponent = $, this.ThermodynamicTemperatureExponent = J, this.AmountOfSubstanceExponent = ue, this.LuminousIntensityExponent = Ie, this.type = 2949456006;
    }
  }
  e.IfcDimensionalExponents = Jg;
  class G4 extends qt {
    constructor(D, M, k) {
      super(), this.FileExtension = D, this.MimeContentType = M, this.MimeSubtype = k, this.type = 1376555844;
    }
  }
  e.IfcDocumentElectronicFormat = G4;
  class k4 extends qt {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn, fs, Xs, jo, Gs, Su) {
      super(), this.DocumentId = D, this.Name = M, this.Description = k, this.DocumentReferences = $, this.Purpose = J, this.IntendedUse = ue, this.Scope = Ie, this.Revision = ve, this.DocumentOwner = Be, this.Editors = bt, this.CreationTime = ji, this.LastRevisionTime = xn, this.ElectronicFormat = fs, this.ValidFrom = Xs, this.ValidUntil = jo, this.Confidentiality = Gs, this.Status = Su, this.type = 1154170062;
    }
  }
  e.IfcDocumentInformation = k4;
  class Y5 extends qt {
    constructor(D, M, k) {
      super(), this.RelatingDocument = D, this.RelatedDocuments = M, this.RelationshipType = k, this.type = 770865208;
    }
  }
  e.IfcDocumentInformationRelationship = Y5;
  class rm extends qt {
    constructor(D, M, k, $) {
      super(), this.Name = D, this.Description = M, this.RelatingDraughtingCallout = k, this.RelatedDraughtingCallout = $, this.type = 3796139169;
    }
  }
  e.IfcDraughtingCalloutRelationship = rm;
  class V4 extends Vo {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue), this.Name = D, this.Description = M, this.AppliedValue = k, this.UnitBasis = $, this.ApplicableDate = J, this.FixedUntilDate = ue, this.ImpactType = Ie, this.Category = ve, this.UserDefinedCategory = Be, this.type = 1648886627;
    }
  }
  e.IfcEnvironmentalImpactValue = V4;
  class Y extends qt {
    constructor(D, M, k) {
      super(), this.Location = D, this.ItemReference = M, this.Name = k, this.type = 3200245327;
    }
  }
  e.IfcExternalReference = Y;
  class oe extends Y {
    constructor(D, M, k) {
      super(D, M, k), this.Location = D, this.ItemReference = M, this.Name = k, this.type = 2242383968;
    }
  }
  e.IfcExternallyDefinedHatchStyle = oe;
  class we extends Y {
    constructor(D, M, k) {
      super(D, M, k), this.Location = D, this.ItemReference = M, this.Name = k, this.type = 1040185647;
    }
  }
  e.IfcExternallyDefinedSurfaceStyle = we;
  class Pe extends Y {
    constructor(D, M, k) {
      super(D, M, k), this.Location = D, this.ItemReference = M, this.Name = k, this.type = 3207319532;
    }
  }
  e.IfcExternallyDefinedSymbol = Pe;
  class et extends Y {
    constructor(D, M, k) {
      super(D, M, k), this.Location = D, this.ItemReference = M, this.Name = k, this.type = 3548104201;
    }
  }
  e.IfcExternallyDefinedTextFont = et;
  class wt extends qt {
    constructor(D, M, k) {
      super(), this.AxisTag = D, this.AxisCurve = M, this.SameSense = k, this.type = 852622518;
    }
  }
  e.IfcGridAxis = wt;
  class St extends qt {
    constructor(D, M) {
      super(), this.TimeStamp = D, this.ListValues = M, this.type = 3020489413;
    }
  }
  e.IfcIrregularTimeSeriesValue = St;
  class Ot extends qt {
    constructor(D, M, k, $, J) {
      super(), this.Name = D, this.Version = M, this.Publisher = k, this.VersionDate = $, this.LibraryReference = J, this.type = 2655187982;
    }
  }
  e.IfcLibraryInformation = Ot;
  class ii extends Y {
    constructor(D, M, k) {
      super(D, M, k), this.Location = D, this.ItemReference = M, this.Name = k, this.type = 3452421091;
    }
  }
  e.IfcLibraryReference = ii;
  class Ei extends qt {
    constructor(D, M, k) {
      super(), this.MainPlaneAngle = D, this.SecondaryPlaneAngle = M, this.LuminousIntensity = k, this.type = 4162380809;
    }
  }
  e.IfcLightDistributionData = Ei;
  class Qi extends qt {
    constructor(D, M) {
      super(), this.LightDistributionCurve = D, this.DistributionData = M, this.type = 1566485204;
    }
  }
  e.IfcLightIntensityDistribution = Qi;
  class vn extends qt {
    constructor(D, M, k, $, J) {
      super(), this.HourComponent = D, this.MinuteComponent = M, this.SecondComponent = k, this.Zone = $, this.DaylightSavingOffset = J, this.type = 30780891;
    }
  }
  e.IfcLocalTime = vn;
  class cn extends qt {
    constructor(D) {
      super(), this.Name = D, this.type = 1838606355;
    }
  }
  e.IfcMaterial = cn;
  class hn extends qt {
    constructor(D, M) {
      super(), this.MaterialClassifications = D, this.ClassifiedMaterial = M, this.type = 1847130766;
    }
  }
  e.IfcMaterialClassificationRelationship = hn;
  class Zn extends qt {
    constructor(D, M, k) {
      super(), this.Material = D, this.LayerThickness = M, this.IsVentilated = k, this.type = 248100487;
    }
  }
  e.IfcMaterialLayer = Zn;
  class Js extends qt {
    constructor(D, M) {
      super(), this.MaterialLayers = D, this.LayerSetName = M, this.type = 3303938423;
    }
  }
  e.IfcMaterialLayerSet = Js;
  class wo extends qt {
    constructor(D, M, k, $) {
      super(), this.ForLayerSet = D, this.LayerSetDirection = M, this.DirectionSense = k, this.OffsetFromReferenceLine = $, this.type = 1303795690;
    }
  }
  e.IfcMaterialLayerSetUsage = wo;
  class To extends qt {
    constructor(D) {
      super(), this.Materials = D, this.type = 2199411900;
    }
  }
  e.IfcMaterialList = To;
  class Mi extends qt {
    constructor(D) {
      super(), this.Material = D, this.type = 3265635763;
    }
  }
  e.IfcMaterialProperties = Mi;
  class Dn extends qt {
    constructor(D, M) {
      super(), this.ValueComponent = D, this.UnitComponent = M, this.type = 2597039031;
    }
  }
  e.IfcMeasureWithUnit = Dn;
  class nl extends Mi {
    constructor(D, M, k, $, J, ue) {
      super(D), this.Material = D, this.DynamicViscosity = M, this.YoungModulus = k, this.ShearModulus = $, this.PoissonRatio = J, this.ThermalExpansionCoefficient = ue, this.type = 4256014907;
    }
  }
  e.IfcMechanicalMaterialProperties = nl;
  class sr extends nl {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn, fs) {
      super(D, M, k, $, J, ue), this.Material = D, this.DynamicViscosity = M, this.YoungModulus = k, this.ShearModulus = $, this.PoissonRatio = J, this.ThermalExpansionCoefficient = ue, this.YieldStress = Ie, this.UltimateStress = ve, this.UltimateStrain = Be, this.HardeningModule = bt, this.ProportionalStress = ji, this.PlasticStrain = xn, this.Relaxations = fs, this.type = 677618848;
    }
  }
  e.IfcMechanicalSteelMaterialProperties = sr;
  class Yl extends Kg {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie), this.Name = D, this.Description = M, this.ConstraintGrade = k, this.ConstraintSource = $, this.CreatingActor = J, this.CreationTime = ue, this.UserDefinedGrade = Ie, this.Benchmark = ve, this.ValueSource = Be, this.DataValue = bt, this.type = 3368373690;
    }
  }
  e.IfcMetric = Yl;
  class sl extends qt {
    constructor(D) {
      super(), this.Currency = D, this.type = 2706619895;
    }
  }
  e.IfcMonetaryUnit = sl;
  class VA extends qt {
    constructor(D, M) {
      super(), this.Dimensions = D, this.UnitType = M, this.type = 1918398963;
    }
  }
  e.IfcNamedUnit = VA;
  class h6 extends qt {
    constructor() {
      super(), this.type = 3701648758;
    }
  }
  e.IfcObjectPlacement = h6;
  class f6 extends Kg {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji) {
      super(D, M, k, $, J, ue, Ie), this.Name = D, this.Description = M, this.ConstraintGrade = k, this.ConstraintSource = $, this.CreatingActor = J, this.CreationTime = ue, this.UserDefinedGrade = Ie, this.BenchmarkValues = ve, this.ResultValues = Be, this.ObjectiveQualifier = bt, this.UserDefinedQualifier = ji, this.type = 2251480897;
    }
  }
  e.IfcObjective = f6;
  class RL extends Mi {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D), this.Material = D, this.VisibleTransmittance = M, this.SolarTransmittance = k, this.ThermalIrTransmittance = $, this.ThermalIrEmissivityBack = J, this.ThermalIrEmissivityFront = ue, this.VisibleReflectanceBack = Ie, this.VisibleReflectanceFront = ve, this.SolarReflectanceFront = Be, this.SolarReflectanceBack = bt, this.type = 1227763645;
    }
  }
  e.IfcOpticalMaterialProperties = RL;
  class vL extends qt {
    constructor(D, M, k, $, J) {
      super(), this.Id = D, this.Name = M, this.Description = k, this.Roles = $, this.Addresses = J, this.type = 4251960020;
    }
  }
  e.IfcOrganization = vL;
  class G8 extends qt {
    constructor(D, M, k, $) {
      super(), this.Name = D, this.Description = M, this.RelatingOrganization = k, this.RelatedOrganizations = $, this.type = 1411181986;
    }
  }
  e.IfcOrganizationRelationship = G8;
  class k8 extends qt {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(), this.OwningUser = D, this.OwningApplication = M, this.State = k, this.ChangeAction = $, this.LastModifiedDate = J, this.LastModifyingUser = ue, this.LastModifyingApplication = Ie, this.CreationDate = ve, this.type = 1207048766;
    }
  }
  e.IfcOwnerHistory = k8;
  class V8 extends qt {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(), this.Id = D, this.FamilyName = M, this.GivenName = k, this.MiddleNames = $, this.PrefixTitles = J, this.SuffixTitles = ue, this.Roles = Ie, this.Addresses = ve, this.type = 2077209135;
    }
  }
  e.IfcPerson = V8;
  class z8 extends qt {
    constructor(D, M, k) {
      super(), this.ThePerson = D, this.TheOrganization = M, this.Roles = k, this.type = 101040310;
    }
  }
  e.IfcPersonAndOrganization = z8;
  class z4 extends qt {
    constructor(D, M) {
      super(), this.Name = D, this.Description = M, this.type = 2483315170;
    }
  }
  e.IfcPhysicalQuantity = z4;
  class Rh extends z4 {
    constructor(D, M, k) {
      super(D, M), this.Name = D, this.Description = M, this.Unit = k, this.type = 2226359599;
    }
  }
  e.IfcPhysicalSimpleQuantity = Rh;
  class j8 extends Ui {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k), this.Purpose = D, this.Description = M, this.UserDefinedPurpose = k, this.InternalLocation = $, this.AddressLines = J, this.PostalBox = ue, this.Town = Ie, this.Region = ve, this.PostalCode = Be, this.Country = bt, this.type = 3355820592;
    }
  }
  e.IfcPostalAddress = j8;
  class q5 extends qt {
    constructor(D) {
      super(), this.Name = D, this.type = 3727388367;
    }
  }
  e.IfcPreDefinedItem = q5;
  class zA extends q5 {
    constructor(D) {
      super(D), this.Name = D, this.type = 990879717;
    }
  }
  e.IfcPreDefinedSymbol = zA;
  class W8 extends zA {
    constructor(D) {
      super(D), this.Name = D, this.type = 3213052703;
    }
  }
  e.IfcPreDefinedTerminatorSymbol = W8;
  class I6 extends q5 {
    constructor(D) {
      super(D), this.Name = D, this.type = 1775413392;
    }
  }
  e.IfcPreDefinedTextFont = I6;
  class AL extends qt {
    constructor(D, M, k, $) {
      super(), this.Name = D, this.Description = M, this.AssignedItems = k, this.Identifier = $, this.type = 2022622350;
    }
  }
  e.IfcPresentationLayerAssignment = AL;
  class Y8 extends AL {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $), this.Name = D, this.Description = M, this.AssignedItems = k, this.Identifier = $, this.LayerOn = J, this.LayerFrozen = ue, this.LayerBlocked = Ie, this.LayerStyles = ve, this.type = 1304840413;
    }
  }
  e.IfcPresentationLayerWithStyle = Y8;
  class j4 extends qt {
    constructor(D) {
      super(), this.Name = D, this.type = 3119450353;
    }
  }
  e.IfcPresentationStyle = j4;
  class q8 extends qt {
    constructor(D) {
      super(), this.Styles = D, this.type = 2417041796;
    }
  }
  e.IfcPresentationStyleAssignment = q8;
  class p6 extends qt {
    constructor(D, M, k) {
      super(), this.Name = D, this.Description = M, this.Representations = k, this.type = 2095639259;
    }
  }
  e.IfcProductRepresentation = p6;
  class $8 extends Mi {
    constructor(D, M, k, $, J) {
      super(D), this.Material = D, this.SpecificHeatCapacity = M, this.N20Content = k, this.COContent = $, this.CO2Content = J, this.type = 2267347899;
    }
  }
  e.IfcProductsOfCombustionProperties = $8;
  class vh extends qt {
    constructor(D, M) {
      super(), this.ProfileType = D, this.ProfileName = M, this.type = 3958567839;
    }
  }
  e.IfcProfileDef = vh;
  class jA extends qt {
    constructor(D, M) {
      super(), this.ProfileName = D, this.ProfileDefinition = M, this.type = 2802850158;
    }
  }
  e.IfcProfileProperties = jA;
  class m6 extends qt {
    constructor(D, M) {
      super(), this.Name = D, this.Description = M, this.type = 2598011224;
    }
  }
  e.IfcProperty = m6;
  class K8 extends qt {
    constructor(D, M, k, $) {
      super(), this.RelatingConstraint = D, this.RelatedProperties = M, this.Name = k, this.Description = $, this.type = 3896028662;
    }
  }
  e.IfcPropertyConstraintRelationship = K8;
  class Z8 extends qt {
    constructor(D, M, k, $, J) {
      super(), this.DependingProperty = D, this.DependantProperty = M, this.Name = k, this.Description = $, this.Expression = J, this.type = 148025276;
    }
  }
  e.IfcPropertyDependencyRelationship = Z8;
  class SL extends qt {
    constructor(D, M, k) {
      super(), this.Name = D, this.EnumerationValues = M, this.Unit = k, this.type = 3710013099;
    }
  }
  e.IfcPropertyEnumeration = SL;
  class Q8 extends Rh {
    constructor(D, M, k, $) {
      super(D, M, k), this.Name = D, this.Description = M, this.Unit = k, this.AreaValue = $, this.type = 2044713172;
    }
  }
  e.IfcQuantityArea = Q8;
  class pY extends Rh {
    constructor(D, M, k, $) {
      super(D, M, k), this.Name = D, this.Description = M, this.Unit = k, this.CountValue = $, this.type = 2093928680;
    }
  }
  e.IfcQuantityCount = pY;
  class y6 extends Rh {
    constructor(D, M, k, $) {
      super(D, M, k), this.Name = D, this.Description = M, this.Unit = k, this.LengthValue = $, this.type = 931644368;
    }
  }
  e.IfcQuantityLength = y6;
  class bL extends Rh {
    constructor(D, M, k, $) {
      super(D, M, k), this.Name = D, this.Description = M, this.Unit = k, this.TimeValue = $, this.type = 3252649465;
    }
  }
  e.IfcQuantityTime = bL;
  class mY extends Rh {
    constructor(D, M, k, $) {
      super(D, M, k), this.Name = D, this.Description = M, this.Unit = k, this.VolumeValue = $, this.type = 2405470396;
    }
  }
  e.IfcQuantityVolume = mY;
  class yY extends Rh {
    constructor(D, M, k, $) {
      super(D, M, k), this.Name = D, this.Description = M, this.Unit = k, this.WeightValue = $, this.type = 825690147;
    }
  }
  e.IfcQuantityWeight = yY;
  class E6 extends qt {
    constructor(D, M, k, $) {
      super(), this.ReferencedDocument = D, this.ReferencingValues = M, this.Name = k, this.Description = $, this.type = 2692823254;
    }
  }
  e.IfcReferencesValueDocument = E6;
  class J8 extends qt {
    constructor(D, M, k, $, J, ue) {
      super(), this.TotalCrossSectionArea = D, this.SteelGrade = M, this.BarSurface = k, this.EffectiveDepth = $, this.NominalBarDiameter = J, this.BarCount = ue, this.type = 1580146022;
    }
  }
  e.IfcReinforcementBarProperties = J8;
  class NL extends qt {
    constructor(D, M) {
      super(), this.RelaxationValue = D, this.InitialStress = M, this.type = 1222501353;
    }
  }
  e.IfcRelaxation = NL;
  class X8 extends qt {
    constructor(D, M, k, $) {
      super(), this.ContextOfItems = D, this.RepresentationIdentifier = M, this.RepresentationType = k, this.Items = $, this.type = 1076942058;
    }
  }
  e.IfcRepresentation = X8;
  class BH extends qt {
    constructor(D, M) {
      super(), this.ContextIdentifier = D, this.ContextType = M, this.type = 3377609919;
    }
  }
  e.IfcRepresentationContext = BH;
  class WA extends qt {
    constructor() {
      super(), this.type = 3008791417;
    }
  }
  e.IfcRepresentationItem = WA;
  class EY extends qt {
    constructor(D, M) {
      super(), this.MappingOrigin = D, this.MappedRepresentation = M, this.type = 1660063152;
    }
  }
  e.IfcRepresentationMap = EY;
  class $5 extends jA {
    constructor(D, M, k, $, J, ue, Ie) {
      super(D, M), this.ProfileName = D, this.ProfileDefinition = M, this.Thickness = k, this.RibHeight = $, this.RibWidth = J, this.RibSpacing = ue, this.Direction = Ie, this.type = 3679540991;
    }
  }
  e.IfcRibPlateProfileProperties = $5;
  class W3 extends qt {
    constructor(D, M, k, $) {
      super(), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.type = 2341007311;
    }
  }
  e.IfcRoot = W3;
  class gY extends VA {
    constructor(D, M, k) {
      super(new u(0), D), this.UnitType = D, this.Prefix = M, this.Name = k, this.type = 448429030;
    }
  }
  e.IfcSIUnit = gY;
  class xd extends qt {
    constructor(D, M, k) {
      super(), this.SectionType = D, this.StartProfile = M, this.EndProfile = k, this.type = 2042790032;
    }
  }
  e.IfcSectionProperties = xd;
  class DL extends qt {
    constructor(D, M, k, $, J, ue) {
      super(), this.LongitudinalStartPosition = D, this.LongitudinalEndPosition = M, this.TransversePosition = k, this.ReinforcementRole = $, this.SectionDefinition = J, this.CrossSectionReinforcementDefinitions = ue, this.type = 4165799628;
    }
  }
  e.IfcSectionReinforcementProperties = DL;
  class FH extends qt {
    constructor(D, M, k, $, J) {
      super(), this.ShapeRepresentations = D, this.Name = M, this.Description = k, this.ProductDefinitional = $, this.PartOfProductDefinitionShape = J, this.type = 867548509;
    }
  }
  e.IfcShapeAspect = FH;
  class W4 extends X8 {
    constructor(D, M, k, $) {
      super(D, M, k, $), this.ContextOfItems = D, this.RepresentationIdentifier = M, this.RepresentationType = k, this.Items = $, this.type = 3982875396;
    }
  }
  e.IfcShapeModel = W4;
  class wY extends W4 {
    constructor(D, M, k, $) {
      super(D, M, k, $), this.ContextOfItems = D, this.RepresentationIdentifier = M, this.RepresentationType = k, this.Items = $, this.type = 4240577450;
    }
  }
  e.IfcShapeRepresentation = wY;
  class Xg extends m6 {
    constructor(D, M) {
      super(D, M), this.Name = D, this.Description = M, this.type = 3692461612;
    }
  }
  e.IfcSimpleProperty = Xg;
  class Y4 extends qt {
    constructor(D) {
      super(), this.Name = D, this.type = 2273995522;
    }
  }
  e.IfcStructuralConnectionCondition = Y4;
  class HH extends qt {
    constructor(D) {
      super(), this.Name = D, this.type = 2162789131;
    }
  }
  e.IfcStructuralLoad = HH;
  class GI extends HH {
    constructor(D) {
      super(D), this.Name = D, this.type = 2525727697;
    }
  }
  e.IfcStructuralLoadStatic = GI;
  class K5 extends GI {
    constructor(D, M, k, $) {
      super(D), this.Name = D, this.DeltaT_Constant = M, this.DeltaT_Y = k, this.DeltaT_Z = $, this.type = 3408363356;
    }
  }
  e.IfcStructuralLoadTemperature = K5;
  class GH extends X8 {
    constructor(D, M, k, $) {
      super(D, M, k, $), this.ContextOfItems = D, this.RepresentationIdentifier = M, this.RepresentationType = k, this.Items = $, this.type = 2830218821;
    }
  }
  e.IfcStyleModel = GH;
  class kH extends WA {
    constructor(D, M, k) {
      super(), this.Item = D, this.Styles = M, this.Name = k, this.type = 3958052878;
    }
  }
  e.IfcStyledItem = kH;
  class TY extends GH {
    constructor(D, M, k, $) {
      super(D, M, k, $), this.ContextOfItems = D, this.RepresentationIdentifier = M, this.RepresentationType = k, this.Items = $, this.type = 3049322572;
    }
  }
  e.IfcStyledRepresentation = TY;
  class RY extends j4 {
    constructor(D, M, k) {
      super(D), this.Name = D, this.Side = M, this.Styles = k, this.type = 1300840506;
    }
  }
  e.IfcSurfaceStyle = RY;
  class vY extends qt {
    constructor(D, M, k, $) {
      super(), this.DiffuseTransmissionColour = D, this.DiffuseReflectionColour = M, this.TransmissionColour = k, this.ReflectanceColour = $, this.type = 3303107099;
    }
  }
  e.IfcSurfaceStyleLighting = vY;
  class AY extends qt {
    constructor(D, M) {
      super(), this.RefractionIndex = D, this.DispersionFactor = M, this.type = 1607154358;
    }
  }
  e.IfcSurfaceStyleRefraction = AY;
  class VH extends qt {
    constructor(D) {
      super(), this.SurfaceColour = D, this.type = 846575682;
    }
  }
  e.IfcSurfaceStyleShading = VH;
  class SY extends qt {
    constructor(D) {
      super(), this.Textures = D, this.type = 1351298697;
    }
  }
  e.IfcSurfaceStyleWithTextures = SY;
  class YA extends qt {
    constructor(D, M, k, $) {
      super(), this.RepeatS = D, this.RepeatT = M, this.TextureType = k, this.TextureTransform = $, this.type = 626085974;
    }
  }
  e.IfcSurfaceTexture = YA;
  class zH extends j4 {
    constructor(D, M) {
      super(D), this.Name = D, this.StyleOfSymbol = M, this.type = 1290481447;
    }
  }
  e.IfcSymbolStyle = zH;
  class g6 extends qt {
    constructor(D, M) {
      super(), this.Name = D, this.Rows = M, this.type = 985171141;
    }
  }
  e.IfcTable = g6;
  class q4 extends qt {
    constructor(D, M) {
      super(), this.RowCells = D, this.IsHeading = M, this.type = 531007025;
    }
  }
  e.IfcTableRow = q4;
  class Y3 extends Ui {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k), this.Purpose = D, this.Description = M, this.UserDefinedPurpose = k, this.TelephoneNumbers = $, this.FacsimileNumbers = J, this.PagerNumber = ue, this.ElectronicMailAddresses = Ie, this.WWWHomePageURL = ve, this.type = 912023232;
    }
  }
  e.IfcTelecomAddress = Y3;
  class CL extends j4 {
    constructor(D, M, k, $) {
      super(D), this.Name = D, this.TextCharacterAppearance = M, this.TextStyle = k, this.TextFontStyle = $, this.type = 1447204868;
    }
  }
  e.IfcTextStyle = CL;
  class bY extends I6 {
    constructor(D, M, k, $, J, ue) {
      super(D), this.Name = D, this.FontFamily = M, this.FontStyle = k, this.FontVariant = $, this.FontWeight = J, this.FontSize = ue, this.type = 1983826977;
    }
  }
  e.IfcTextStyleFontModel = bY;
  class qA extends qt {
    constructor(D, M) {
      super(), this.Colour = D, this.BackgroundColour = M, this.type = 2636378356;
    }
  }
  e.IfcTextStyleForDefinedFont = qA;
  class jH extends qt {
    constructor(D, M, k, $, J, ue, Ie) {
      super(), this.TextIndent = D, this.TextAlign = M, this.TextDecoration = k, this.LetterSpacing = $, this.WordSpacing = J, this.TextTransform = ue, this.LineHeight = Ie, this.type = 1640371178;
    }
  }
  e.IfcTextStyleTextModel = jH;
  class eM extends qt {
    constructor(D, M, k, $, J) {
      super(), this.BoxHeight = D, this.BoxWidth = M, this.BoxSlantAngle = k, this.BoxRotateAngle = $, this.CharacterSpacing = J, this.type = 1484833681;
    }
  }
  e.IfcTextStyleWithBoxCharacteristics = eM;
  class tM extends qt {
    constructor() {
      super(), this.type = 280115917;
    }
  }
  e.IfcTextureCoordinate = tM;
  class w6 extends tM {
    constructor(D, M) {
      super(), this.Mode = D, this.Parameter = M, this.type = 1742049831;
    }
  }
  e.IfcTextureCoordinateGenerator = w6;
  class iM extends tM {
    constructor(D) {
      super(), this.TextureMaps = D, this.type = 2552916305;
    }
  }
  e.IfcTextureMap = iM;
  class NY extends qt {
    constructor(D) {
      super(), this.Coordinates = D, this.type = 1210645708;
    }
  }
  e.IfcTextureVertex = NY;
  class nM extends Mi {
    constructor(D, M, k, $, J) {
      super(D), this.Material = D, this.SpecificHeatCapacity = M, this.BoilingPoint = k, this.FreezingPoint = $, this.ThermalConductivity = J, this.type = 3317419933;
    }
  }
  e.IfcThermalMaterialProperties = nM;
  class q3 extends qt {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(), this.Name = D, this.Description = M, this.StartTime = k, this.EndTime = $, this.TimeSeriesDataType = J, this.DataOrigin = ue, this.UserDefinedDataOrigin = Ie, this.Unit = ve, this.type = 3101149627;
    }
  }
  e.IfcTimeSeries = q3;
  class OL extends qt {
    constructor(D, M) {
      super(), this.ReferencedTimeSeries = D, this.TimeSeriesReferences = M, this.type = 1718945513;
    }
  }
  e.IfcTimeSeriesReferenceRelationship = OL;
  class WH extends qt {
    constructor(D) {
      super(), this.ListValues = D, this.type = 581633288;
    }
  }
  e.IfcTimeSeriesValue = WH;
  class $4 extends WA {
    constructor() {
      super(), this.type = 1377556343;
    }
  }
  e.IfcTopologicalRepresentationItem = $4;
  class DY extends W4 {
    constructor(D, M, k, $) {
      super(D, M, k, $), this.ContextOfItems = D, this.RepresentationIdentifier = M, this.RepresentationType = k, this.Items = $, this.type = 1735638870;
    }
  }
  e.IfcTopologyRepresentation = DY;
  class CY extends qt {
    constructor(D) {
      super(), this.Units = D, this.type = 180925521;
    }
  }
  e.IfcUnitAssignment = CY;
  class YH extends $4 {
    constructor() {
      super(), this.type = 2799835756;
    }
  }
  e.IfcVertex = YH;
  class sM extends qt {
    constructor(D, M) {
      super(), this.TextureVertices = D, this.TexturePoints = M, this.type = 3304826586;
    }
  }
  e.IfcVertexBasedTextureMap = sM;
  class K4 extends YH {
    constructor(D) {
      super(), this.VertexGeometry = D, this.type = 1907098498;
    }
  }
  e.IfcVertexPoint = K4;
  class qH extends qt {
    constructor(D, M) {
      super(), this.IntersectingAxes = D, this.OffsetDistances = M, this.type = 891718957;
    }
  }
  e.IfcVirtualGridIntersection = qH;
  class Pd extends Mi {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D), this.Material = D, this.IsPotable = M, this.Hardness = k, this.AlkalinityConcentration = $, this.AcidityConcentration = J, this.ImpuritiesContent = ue, this.PHLevel = Ie, this.DissolvedSolidsContent = ve, this.type = 1065908215;
    }
  }
  e.IfcWaterProperties = Pd;
  class gE extends kH {
    constructor(D, M, k) {
      super(D, M, k), this.Item = D, this.Styles = M, this.Name = k, this.type = 2442683028;
    }
  }
  e.IfcAnnotationOccurrence = gE;
  class OY extends gE {
    constructor(D, M, k) {
      super(D, M, k), this.Item = D, this.Styles = M, this.Name = k, this.type = 962685235;
    }
  }
  e.IfcAnnotationSurfaceOccurrence = OY;
  class $A extends gE {
    constructor(D, M, k) {
      super(D, M, k), this.Item = D, this.Styles = M, this.Name = k, this.type = 3612888222;
    }
  }
  e.IfcAnnotationSymbolOccurrence = $A;
  class oM extends gE {
    constructor(D, M, k) {
      super(D, M, k), this.Item = D, this.Styles = M, this.Name = k, this.type = 2297822566;
    }
  }
  e.IfcAnnotationTextOccurrence = oM;
  class ew extends vh {
    constructor(D, M, k) {
      super(D, M), this.ProfileType = D, this.ProfileName = M, this.OuterCurve = k, this.type = 3798115385;
    }
  }
  e.IfcArbitraryClosedProfileDef = ew;
  class $H extends vh {
    constructor(D, M, k) {
      super(D, M), this.ProfileType = D, this.ProfileName = M, this.Curve = k, this.type = 1310608509;
    }
  }
  e.IfcArbitraryOpenProfileDef = $H;
  class T6 extends ew {
    constructor(D, M, k, $) {
      super(D, M, k), this.ProfileType = D, this.ProfileName = M, this.OuterCurve = k, this.InnerCurves = $, this.type = 2705031697;
    }
  }
  e.IfcArbitraryProfileDefWithVoids = T6;
  class LY extends YA {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $), this.RepeatS = D, this.RepeatT = M, this.TextureType = k, this.TextureTransform = $, this.RasterFormat = J, this.RasterCode = ue, this.type = 616511568;
    }
  }
  e.IfcBlobTexture = LY;
  class _Y extends $H {
    constructor(D, M, k, $) {
      super(D, M, k), this.ProfileType = D, this.ProfileName = M, this.Curve = k, this.Thickness = $, this.type = 3150382593;
    }
  }
  e.IfcCenterLineProfileDef = _Y;
  class xY extends Y {
    constructor(D, M, k, $) {
      super(D, M, k), this.Location = D, this.ItemReference = M, this.Name = k, this.ReferencedSource = $, this.type = 647927063;
    }
  }
  e.IfcClassificationReference = xY;
  class LL extends x4 {
    constructor(D, M, k, $) {
      super(D), this.Name = D, this.Red = M, this.Green = k, this.Blue = $, this.type = 776857604;
    }
  }
  e.IfcColourRgb = LL;
  class PY extends m6 {
    constructor(D, M, k, $) {
      super(D, M), this.Name = D, this.Description = M, this.UsageName = k, this.HasProperties = $, this.type = 2542286263;
    }
  }
  e.IfcComplexProperty = PY;
  class MY extends vh {
    constructor(D, M, k, $) {
      super(D, M), this.ProfileType = D, this.ProfileName = M, this.Profiles = k, this.Label = $, this.type = 1485152156;
    }
  }
  e.IfcCompositeProfileDef = MY;
  class rM extends $4 {
    constructor(D) {
      super(), this.CfsFaces = D, this.type = 370225590;
    }
  }
  e.IfcConnectedFaceSet = rM;
  class UY extends j3 {
    constructor(D, M) {
      super(), this.CurveOnRelatingElement = D, this.CurveOnRelatedElement = M, this.type = 1981873012;
    }
  }
  e.IfcConnectionCurveGeometry = UY;
  class BY extends $g {
    constructor(D, M, k, $, J) {
      super(D, M), this.PointOnRelatingElement = D, this.PointOnRelatedElement = M, this.EccentricityInX = k, this.EccentricityInY = $, this.EccentricityInZ = J, this.type = 45288368;
    }
  }
  e.IfcConnectionPointEccentricity = BY;
  class lM extends VA {
    constructor(D, M, k) {
      super(D, M), this.Dimensions = D, this.UnitType = M, this.Name = k, this.type = 3050246964;
    }
  }
  e.IfcContextDependentUnit = lM;
  class aM extends VA {
    constructor(D, M, k, $) {
      super(D, M), this.Dimensions = D, this.UnitType = M, this.Name = k, this.ConversionFactor = $, this.type = 2889183280;
    }
  }
  e.IfcConversionBasedUnit = aM;
  class tw extends j4 {
    constructor(D, M, k, $) {
      super(D), this.Name = D, this.CurveFont = M, this.CurveWidth = k, this.CurveColour = $, this.type = 3800577675;
    }
  }
  e.IfcCurveStyle = tw;
  class R6 extends vh {
    constructor(D, M, k, $, J) {
      super(D, M), this.ProfileType = D, this.ProfileName = M, this.ParentProfile = k, this.Operator = $, this.Label = J, this.type = 3632507154;
    }
  }
  e.IfcDerivedProfileDef = R6;
  class FY extends rm {
    constructor(D, M, k, $) {
      super(D, M, k, $), this.Name = D, this.Description = M, this.RelatingDraughtingCallout = k, this.RelatedDraughtingCallout = $, this.type = 2273265877;
    }
  }
  e.IfcDimensionCalloutRelationship = FY;
  class $3 extends rm {
    constructor(D, M, k, $) {
      super(D, M, k, $), this.Name = D, this.Description = M, this.RelatingDraughtingCallout = k, this.RelatedDraughtingCallout = $, this.type = 1694125774;
    }
  }
  e.IfcDimensionPair = $3;
  class _L extends Y {
    constructor(D, M, k) {
      super(D, M, k), this.Location = D, this.ItemReference = M, this.Name = k, this.type = 3732053477;
    }
  }
  e.IfcDocumentReference = _L;
  class HY extends I6 {
    constructor(D) {
      super(D), this.Name = D, this.type = 4170525392;
    }
  }
  e.IfcDraughtingPreDefinedTextFont = HY;
  class iw extends $4 {
    constructor(D, M) {
      super(), this.EdgeStart = D, this.EdgeEnd = M, this.type = 3900360178;
    }
  }
  e.IfcEdge = iw;
  class GY extends iw {
    constructor(D, M, k, $) {
      super(D, M), this.EdgeStart = D, this.EdgeEnd = M, this.EdgeGeometry = k, this.SameSense = $, this.type = 476780140;
    }
  }
  e.IfcEdgeCurve = GY;
  class xL extends Mi {
    constructor(D, M, k, $) {
      super(D), this.Material = D, this.ExtendedProperties = M, this.Description = k, this.Name = $, this.type = 1860660968;
    }
  }
  e.IfcExtendedMaterialProperties = xL;
  class uM extends $4 {
    constructor(D) {
      super(), this.Bounds = D, this.type = 2556980723;
    }
  }
  e.IfcFace = uM;
  class PL extends $4 {
    constructor(D, M) {
      super(), this.Bound = D, this.Orientation = M, this.type = 1809719519;
    }
  }
  e.IfcFaceBound = PL;
  class dM extends PL {
    constructor(D, M) {
      super(D, M), this.Bound = D, this.Orientation = M, this.type = 803316827;
    }
  }
  e.IfcFaceOuterBound = dM;
  class kY extends uM {
    constructor(D, M, k) {
      super(D), this.Bounds = D, this.FaceSurface = M, this.SameSense = k, this.type = 3008276851;
    }
  }
  e.IfcFaceSurface = kY;
  class cM extends Y4 {
    constructor(D, M, k, $, J, ue, Ie) {
      super(D), this.Name = D, this.TensionFailureX = M, this.TensionFailureY = k, this.TensionFailureZ = $, this.CompressionFailureX = J, this.CompressionFailureY = ue, this.CompressionFailureZ = Ie, this.type = 4219587988;
    }
  }
  e.IfcFailureConnectionCondition = cM;
  class KA extends j4 {
    constructor(D, M) {
      super(D), this.Name = D, this.FillStyles = M, this.type = 738692330;
    }
  }
  e.IfcFillAreaStyle = KA;
  class VY extends Mi {
    constructor(D, M, k, $, J) {
      super(D), this.Material = D, this.CombustionTemperature = M, this.CarbonContent = k, this.LowerHeatingValue = $, this.HigherHeatingValue = J, this.type = 3857492461;
    }
  }
  e.IfcFuelProperties = VY;
  class hM extends Mi {
    constructor(D, M, k, $) {
      super(D), this.Material = D, this.MolecularWeight = M, this.Porosity = k, this.MassDensity = $, this.type = 803998398;
    }
  }
  e.IfcGeneralMaterialProperties = hM;
  class KH extends jA {
    constructor(D, M, k, $, J, ue, Ie) {
      super(D, M), this.ProfileName = D, this.ProfileDefinition = M, this.PhysicalWeight = k, this.Perimeter = $, this.MinimumPlateThickness = J, this.MaximumPlateThickness = ue, this.CrossSectionArea = Ie, this.type = 1446786286;
    }
  }
  e.IfcGeneralProfileProperties = KH;
  class ML extends BH {
    constructor(D, M, k, $, J, ue) {
      super(D, M), this.ContextIdentifier = D, this.ContextType = M, this.CoordinateSpaceDimension = k, this.Precision = $, this.WorldCoordinateSystem = J, this.TrueNorth = ue, this.type = 3448662350;
    }
  }
  e.IfcGeometricRepresentationContext = ML;
  class br extends WA {
    constructor() {
      super(), this.type = 2453401579;
    }
  }
  e.IfcGeometricRepresentationItem = br;
  class zY extends ML {
    constructor(D, M, k, $, J, ue) {
      super(D, M, new O(0), null, new u(0), null), this.ContextIdentifier = D, this.ContextType = M, this.ParentContext = k, this.TargetScale = $, this.TargetView = J, this.UserDefinedTargetView = ue, this.type = 4142052618;
    }
  }
  e.IfcGeometricRepresentationSubContext = zY;
  class ZH extends br {
    constructor(D) {
      super(), this.Elements = D, this.type = 3590301190;
    }
  }
  e.IfcGeometricSet = ZH;
  class QH extends h6 {
    constructor(D, M) {
      super(), this.PlacementLocation = D, this.PlacementRefDirection = M, this.type = 178086475;
    }
  }
  e.IfcGridPlacement = QH;
  class UL extends br {
    constructor(D, M) {
      super(), this.BaseSurface = D, this.AgreementFlag = M, this.type = 812098782;
    }
  }
  e.IfcHalfSpaceSolid = UL;
  class jY extends Mi {
    constructor(D, M, k, $, J, ue) {
      super(D), this.Material = D, this.UpperVaporResistanceFactor = M, this.LowerVaporResistanceFactor = k, this.IsothermalMoistureCapacity = $, this.VaporPermeability = J, this.MoistureDiffusivity = ue, this.type = 2445078500;
    }
  }
  e.IfcHygroscopicMaterialProperties = jY;
  class BL extends YA {
    constructor(D, M, k, $, J) {
      super(D, M, k, $), this.RepeatS = D, this.RepeatT = M, this.TextureType = k, this.TextureTransform = $, this.UrlReference = J, this.type = 3905492369;
    }
  }
  e.IfcImageTexture = BL;
  class WY extends q3 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve), this.Name = D, this.Description = M, this.StartTime = k, this.EndTime = $, this.TimeSeriesDataType = J, this.DataOrigin = ue, this.UserDefinedDataOrigin = Ie, this.Unit = ve, this.Values = Be, this.type = 3741457305;
    }
  }
  e.IfcIrregularTimeSeries = WY;
  class v6 extends br {
    constructor(D, M, k, $) {
      super(), this.Name = D, this.LightColour = M, this.AmbientIntensity = k, this.Intensity = $, this.type = 1402838566;
    }
  }
  e.IfcLightSource = v6;
  class YY extends v6 {
    constructor(D, M, k, $) {
      super(D, M, k, $), this.Name = D, this.LightColour = M, this.AmbientIntensity = k, this.Intensity = $, this.type = 125510826;
    }
  }
  e.IfcLightSourceAmbient = YY;
  class fM extends v6 {
    constructor(D, M, k, $, J) {
      super(D, M, k, $), this.Name = D, this.LightColour = M, this.AmbientIntensity = k, this.Intensity = $, this.Orientation = J, this.type = 2604431987;
    }
  }
  e.IfcLightSourceDirectional = fM;
  class qY extends v6 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $), this.Name = D, this.LightColour = M, this.AmbientIntensity = k, this.Intensity = $, this.Position = J, this.ColourAppearance = ue, this.ColourTemperature = Ie, this.LuminousFlux = ve, this.LightEmissionSource = Be, this.LightDistributionDataSource = bt, this.type = 4266656042;
    }
  }
  e.IfcLightSourceGoniometric = qY;
  class JH extends v6 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $), this.Name = D, this.LightColour = M, this.AmbientIntensity = k, this.Intensity = $, this.Position = J, this.Radius = ue, this.ConstantAttenuation = Ie, this.DistanceAttenuation = ve, this.QuadricAttenuation = Be, this.type = 1520743889;
    }
  }
  e.IfcLightSourcePositional = JH;
  class $Y extends JH {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn, fs) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.Name = D, this.LightColour = M, this.AmbientIntensity = k, this.Intensity = $, this.Position = J, this.Radius = ue, this.ConstantAttenuation = Ie, this.DistanceAttenuation = ve, this.QuadricAttenuation = Be, this.Orientation = bt, this.ConcentrationExponent = ji, this.SpreadAngle = xn, this.BeamWidthAngle = fs, this.type = 3422422726;
    }
  }
  e.IfcLightSourceSpot = $Y;
  class FL extends h6 {
    constructor(D, M) {
      super(), this.PlacementRelTo = D, this.RelativePlacement = M, this.type = 2624227202;
    }
  }
  e.IfcLocalPlacement = FL;
  class HL extends $4 {
    constructor() {
      super(), this.type = 1008929658;
    }
  }
  e.IfcLoop = HL;
  class GL extends WA {
    constructor(D, M) {
      super(), this.MappingSource = D, this.MappingTarget = M, this.type = 2347385850;
    }
  }
  e.IfcMappedItem = GL;
  class IM extends p6 {
    constructor(D, M, k, $) {
      super(D, M, k), this.Name = D, this.Description = M, this.Representations = k, this.RepresentedMaterial = $, this.type = 2022407955;
    }
  }
  e.IfcMaterialDefinitionRepresentation = IM;
  class XH extends nl {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn) {
      super(D, M, k, $, J, ue), this.Material = D, this.DynamicViscosity = M, this.YoungModulus = k, this.ShearModulus = $, this.PoissonRatio = J, this.ThermalExpansionCoefficient = ue, this.CompressiveStrength = Ie, this.MaxAggregateSize = ve, this.AdmixturesDescription = Be, this.Workability = bt, this.ProtectivePoreRatio = ji, this.WaterImpermeability = xn, this.type = 1430189142;
    }
  }
  e.IfcMechanicalConcreteMaterialProperties = XH;
  class kL extends W3 {
    constructor(D, M, k, $) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.type = 219451334;
    }
  }
  e.IfcObjectDefinition = kL;
  class pM extends br {
    constructor(D) {
      super(), this.RepeatFactor = D, this.type = 2833995503;
    }
  }
  e.IfcOneDirectionRepeatFactor = pM;
  class KY extends rM {
    constructor(D) {
      super(D), this.CfsFaces = D, this.type = 2665983363;
    }
  }
  e.IfcOpenShell = KY;
  class eG extends iw {
    constructor(D, M) {
      super(new u(0), new u(0)), this.EdgeElement = D, this.Orientation = M, this.type = 1029017970;
    }
  }
  e.IfcOrientedEdge = eG;
  class kI extends vh {
    constructor(D, M, k) {
      super(D, M), this.ProfileType = D, this.ProfileName = M, this.Position = k, this.type = 2529465313;
    }
  }
  e.IfcParameterizedProfileDef = kI;
  class mM extends $4 {
    constructor(D) {
      super(), this.EdgeList = D, this.type = 2519244187;
    }
  }
  e.IfcPath = mM;
  class tG extends z4 {
    constructor(D, M, k, $, J, ue) {
      super(D, M), this.Name = D, this.Description = M, this.HasQuantities = k, this.Discrimination = $, this.Quality = J, this.Usage = ue, this.type = 3021840470;
    }
  }
  e.IfcPhysicalComplexQuantity = tG;
  class Xo extends YA {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $), this.RepeatS = D, this.RepeatT = M, this.TextureType = k, this.TextureTransform = $, this.Width = J, this.Height = ue, this.ColourComponents = Ie, this.Pixel = ve, this.type = 597895409;
    }
  }
  e.IfcPixelTexture = Xo;
  class VL extends br {
    constructor(D) {
      super(), this.Location = D, this.type = 2004835150;
    }
  }
  e.IfcPlacement = VL;
  class yM extends br {
    constructor(D, M) {
      super(), this.SizeInX = D, this.SizeInY = M, this.type = 1663979128;
    }
  }
  e.IfcPlanarExtent = yM;
  class A6 extends br {
    constructor() {
      super(), this.type = 2067069095;
    }
  }
  e.IfcPoint = A6;
  class EM extends A6 {
    constructor(D, M) {
      super(), this.BasisCurve = D, this.PointParameter = M, this.type = 4022376103;
    }
  }
  e.IfcPointOnCurve = EM;
  class ZY extends A6 {
    constructor(D, M, k) {
      super(), this.BasisSurface = D, this.PointParameterU = M, this.PointParameterV = k, this.type = 1423911732;
    }
  }
  e.IfcPointOnSurface = ZY;
  class QY extends HL {
    constructor(D) {
      super(), this.Polygon = D, this.type = 2924175390;
    }
  }
  e.IfcPolyLoop = QY;
  class iG extends UL {
    constructor(D, M, k, $) {
      super(D, M), this.BaseSurface = D, this.AgreementFlag = M, this.Position = k, this.PolygonalBoundary = $, this.type = 2775532180;
    }
  }
  e.IfcPolygonalBoundedHalfSpace = iG;
  class nG extends q5 {
    constructor(D) {
      super(D), this.Name = D, this.type = 759155922;
    }
  }
  e.IfcPreDefinedColour = nG;
  class sG extends q5 {
    constructor(D) {
      super(D), this.Name = D, this.type = 2559016684;
    }
  }
  e.IfcPreDefinedCurveFont = sG;
  class oG extends zA {
    constructor(D) {
      super(D), this.Name = D, this.type = 433424934;
    }
  }
  e.IfcPreDefinedDimensionSymbol = oG;
  class ZA extends zA {
    constructor(D) {
      super(D), this.Name = D, this.type = 179317114;
    }
  }
  e.IfcPreDefinedPointMarkerSymbol = ZA;
  class JY extends p6 {
    constructor(D, M, k) {
      super(D, M, k), this.Name = D, this.Description = M, this.Representations = k, this.type = 673634403;
    }
  }
  e.IfcProductDefinitionShape = JY;
  class XY extends Xg {
    constructor(D, M, k, $, J) {
      super(D, M), this.Name = D, this.Description = M, this.UpperBoundValue = k, this.LowerBoundValue = $, this.Unit = J, this.type = 871118103;
    }
  }
  e.IfcPropertyBoundedValue = XY;
  class rG extends W3 {
    constructor(D, M, k, $) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.type = 1680319473;
    }
  }
  e.IfcPropertyDefinition = rG;
  class lG extends Xg {
    constructor(D, M, k, $) {
      super(D, M), this.Name = D, this.Description = M, this.EnumerationValues = k, this.EnumerationReference = $, this.type = 4166981789;
    }
  }
  e.IfcPropertyEnumeratedValue = lG;
  class eq extends Xg {
    constructor(D, M, k, $) {
      super(D, M), this.Name = D, this.Description = M, this.ListValues = k, this.Unit = $, this.type = 2752243245;
    }
  }
  e.IfcPropertyListValue = eq;
  class tq extends Xg {
    constructor(D, M, k, $) {
      super(D, M), this.Name = D, this.Description = M, this.UsageName = k, this.PropertyReference = $, this.type = 941946838;
    }
  }
  e.IfcPropertyReferenceValue = tq;
  class Qu extends rG {
    constructor(D, M, k, $) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.type = 3357820518;
    }
  }
  e.IfcPropertySetDefinition = Qu;
  class iq extends Xg {
    constructor(D, M, k, $) {
      super(D, M), this.Name = D, this.Description = M, this.NominalValue = k, this.Unit = $, this.type = 3650150729;
    }
  }
  e.IfcPropertySingleValue = iq;
  class gM extends Xg {
    constructor(D, M, k, $, J, ue, Ie) {
      super(D, M), this.Name = D, this.Description = M, this.DefiningValues = k, this.DefinedValues = $, this.Expression = J, this.DefiningUnit = ue, this.DefinedUnit = Ie, this.type = 110355661;
    }
  }
  e.IfcPropertyTableValue = gM;
  class wM extends kI {
    constructor(D, M, k, $, J) {
      super(D, M, k), this.ProfileType = D, this.ProfileName = M, this.Position = k, this.XDim = $, this.YDim = J, this.type = 3615266464;
    }
  }
  e.IfcRectangleProfileDef = wM;
  class nq extends q3 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve), this.Name = D, this.Description = M, this.StartTime = k, this.EndTime = $, this.TimeSeriesDataType = J, this.DataOrigin = ue, this.UserDefinedDataOrigin = Ie, this.Unit = ve, this.TimeStep = Be, this.Values = bt, this.type = 3413951693;
    }
  }
  e.IfcRegularTimeSeries = nq;
  class sq extends Qu {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.DefinitionType = J, this.ReinforcementSectionDefinitions = ue, this.type = 3765753017;
    }
  }
  e.IfcReinforcementDefinitionProperties = sq;
  class Z5 extends W3 {
    constructor(D, M, k, $) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.type = 478536968;
    }
  }
  e.IfcRelationship = Z5;
  class aG extends wM {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $, J), this.ProfileType = D, this.ProfileName = M, this.Position = k, this.XDim = $, this.YDim = J, this.RoundingRadius = ue, this.type = 2778083089;
    }
  }
  e.IfcRoundedRectangleProfileDef = aG;
  class oq extends br {
    constructor(D, M, k) {
      super(), this.SpineCurve = D, this.CrossSections = M, this.CrossSectionPositions = k, this.type = 1509187699;
    }
  }
  e.IfcSectionedSpine = oq;
  class rq extends Qu {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.PredefinedType = J, this.UpperValue = ue, this.MostUsedValue = Ie, this.LowerValue = ve, this.type = 2411513650;
    }
  }
  e.IfcServiceLifeFactor = rq;
  class lq extends br {
    constructor(D) {
      super(), this.SbsmBoundary = D, this.type = 4124623270;
    }
  }
  e.IfcShellBasedSurfaceModel = lq;
  class aq extends Y4 {
    constructor(D, M, k, $) {
      super(D), this.Name = D, this.SlippageX = M, this.SlippageY = k, this.SlippageZ = $, this.type = 2609359061;
    }
  }
  e.IfcSlippageConnectionCondition = aq;
  class Z4 extends br {
    constructor() {
      super(), this.type = 723233188;
    }
  }
  e.IfcSolidModel = Z4;
  class uG extends Qu {
    constructor(D, M, k, $, J, ue, Ie) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.IsAttenuating = J, this.SoundScale = ue, this.SoundValues = Ie, this.type = 2485662743;
    }
  }
  e.IfcSoundProperties = uG;
  class uq extends Qu {
    constructor(D, M, k, $, J, ue, Ie) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.SoundLevelTimeSeries = J, this.Frequency = ue, this.SoundLevelSingleValue = Ie, this.type = 1202362311;
    }
  }
  e.IfcSoundValue = uq;
  class dq extends Qu {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn, fs, Xs) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableValueRatio = J, this.ThermalLoadSource = ue, this.PropertySource = Ie, this.SourceDescription = ve, this.MaximumValue = Be, this.MinimumValue = bt, this.ThermalLoadTimeSeriesValues = ji, this.UserDefinedThermalLoadSource = xn, this.UserDefinedPropertySource = fs, this.ThermalLoadType = Xs, this.type = 390701378;
    }
  }
  e.IfcSpaceThermalLoadProperties = dq;
  class lm extends GI {
    constructor(D, M, k, $, J, ue, Ie) {
      super(D), this.Name = D, this.LinearForceX = M, this.LinearForceY = k, this.LinearForceZ = $, this.LinearMomentX = J, this.LinearMomentY = ue, this.LinearMomentZ = Ie, this.type = 1595516126;
    }
  }
  e.IfcStructuralLoadLinearForce = lm;
  class zL extends GI {
    constructor(D, M, k, $) {
      super(D), this.Name = D, this.PlanarForceX = M, this.PlanarForceY = k, this.PlanarForceZ = $, this.type = 2668620305;
    }
  }
  e.IfcStructuralLoadPlanarForce = zL;
  class dG extends GI {
    constructor(D, M, k, $, J, ue, Ie) {
      super(D), this.Name = D, this.DisplacementX = M, this.DisplacementY = k, this.DisplacementZ = $, this.RotationalDisplacementRX = J, this.RotationalDisplacementRY = ue, this.RotationalDisplacementRZ = Ie, this.type = 2473145415;
    }
  }
  e.IfcStructuralLoadSingleDisplacement = dG;
  class cq extends dG {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie), this.Name = D, this.DisplacementX = M, this.DisplacementY = k, this.DisplacementZ = $, this.RotationalDisplacementRX = J, this.RotationalDisplacementRY = ue, this.RotationalDisplacementRZ = Ie, this.Distortion = ve, this.type = 1973038258;
    }
  }
  e.IfcStructuralLoadSingleDisplacementDistortion = cq;
  class Q5 extends GI {
    constructor(D, M, k, $, J, ue, Ie) {
      super(D), this.Name = D, this.ForceX = M, this.ForceY = k, this.ForceZ = $, this.MomentX = J, this.MomentY = ue, this.MomentZ = Ie, this.type = 1597423693;
    }
  }
  e.IfcStructuralLoadSingleForce = Q5;
  class cG extends Q5 {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie), this.Name = D, this.ForceX = M, this.ForceY = k, this.ForceZ = $, this.MomentX = J, this.MomentY = ue, this.MomentZ = Ie, this.WarpingMoment = ve, this.type = 1190533807;
    }
  }
  e.IfcStructuralLoadSingleForceWarping = cG;
  class QA extends KH {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn, fs, Xs, jo, Gs, Su, Co, Zf, Em, ep, Fd, Nh) {
      super(D, M, k, $, J, ue, Ie), this.ProfileName = D, this.ProfileDefinition = M, this.PhysicalWeight = k, this.Perimeter = $, this.MinimumPlateThickness = J, this.MaximumPlateThickness = ue, this.CrossSectionArea = Ie, this.TorsionalConstantX = ve, this.MomentOfInertiaYZ = Be, this.MomentOfInertiaY = bt, this.MomentOfInertiaZ = ji, this.WarpingConstant = xn, this.ShearCentreZ = fs, this.ShearCentreY = Xs, this.ShearDeformationAreaZ = jo, this.ShearDeformationAreaY = Gs, this.MaximumSectionModulusY = Su, this.MinimumSectionModulusY = Co, this.MaximumSectionModulusZ = Zf, this.MinimumSectionModulusZ = Em, this.TorsionalSectionModulus = ep, this.CentreOfGravityInX = Fd, this.CentreOfGravityInY = Nh, this.type = 3843319758;
    }
  }
  e.IfcStructuralProfileProperties = QA;
  class hG extends QA {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn, fs, Xs, jo, Gs, Su, Co, Zf, Em, ep, Fd, Nh, MR, vT, Dh, VE) {
      super(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn, fs, Xs, jo, Gs, Su, Co, Zf, Em, ep, Fd, Nh), this.ProfileName = D, this.ProfileDefinition = M, this.PhysicalWeight = k, this.Perimeter = $, this.MinimumPlateThickness = J, this.MaximumPlateThickness = ue, this.CrossSectionArea = Ie, this.TorsionalConstantX = ve, this.MomentOfInertiaYZ = Be, this.MomentOfInertiaY = bt, this.MomentOfInertiaZ = ji, this.WarpingConstant = xn, this.ShearCentreZ = fs, this.ShearCentreY = Xs, this.ShearDeformationAreaZ = jo, this.ShearDeformationAreaY = Gs, this.MaximumSectionModulusY = Su, this.MinimumSectionModulusY = Co, this.MaximumSectionModulusZ = Zf, this.MinimumSectionModulusZ = Em, this.TorsionalSectionModulus = ep, this.CentreOfGravityInX = Fd, this.CentreOfGravityInY = Nh, this.ShearAreaZ = MR, this.ShearAreaY = vT, this.PlasticShapeFactorY = Dh, this.PlasticShapeFactorZ = VE, this.type = 3653947884;
    }
  }
  e.IfcStructuralSteelProfileProperties = hG;
  class hq extends iw {
    constructor(D, M, k) {
      super(D, M), this.EdgeStart = D, this.EdgeEnd = M, this.ParentEdge = k, this.type = 2233826070;
    }
  }
  e.IfcSubedge = hq;
  class S6 extends br {
    constructor() {
      super(), this.type = 2513912981;
    }
  }
  e.IfcSurface = S6;
  class fq extends VH {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D), this.SurfaceColour = D, this.Transparency = M, this.DiffuseColour = k, this.TransmissionColour = $, this.DiffuseTransmissionColour = J, this.ReflectionColour = ue, this.SpecularColour = Ie, this.SpecularHighlight = ve, this.ReflectanceMethod = Be, this.type = 1878645084;
    }
  }
  e.IfcSurfaceStyleRendering = fq;
  class J5 extends Z4 {
    constructor(D, M) {
      super(), this.SweptArea = D, this.Position = M, this.type = 2247615214;
    }
  }
  e.IfcSweptAreaSolid = J5;
  class b6 extends Z4 {
    constructor(D, M, k, $, J) {
      super(), this.Directrix = D, this.Radius = M, this.InnerRadius = k, this.StartParam = $, this.EndParam = J, this.type = 1260650574;
    }
  }
  e.IfcSweptDiskSolid = b6;
  class Nr extends S6 {
    constructor(D, M) {
      super(), this.SweptCurve = D, this.Position = M, this.type = 230924584;
    }
  }
  e.IfcSweptSurface = Nr;
  class Iq extends kI {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn, fs) {
      super(D, M, k), this.ProfileType = D, this.ProfileName = M, this.Position = k, this.Depth = $, this.FlangeWidth = J, this.WebThickness = ue, this.FlangeThickness = Ie, this.FilletRadius = ve, this.FlangeEdgeRadius = Be, this.WebEdgeRadius = bt, this.WebSlope = ji, this.FlangeSlope = xn, this.CentreOfGravityInY = fs, this.type = 3071757647;
    }
  }
  e.IfcTShapeProfileDef = Iq;
  class TM extends $A {
    constructor(D, M, k, $) {
      super(D, M, k), this.Item = D, this.Styles = M, this.Name = k, this.AnnotatedCurve = $, this.type = 3028897424;
    }
  }
  e.IfcTerminatorSymbol = TM;
  class jL extends br {
    constructor(D, M, k) {
      super(), this.Literal = D, this.Placement = M, this.Path = k, this.type = 4282788508;
    }
  }
  e.IfcTextLiteral = jL;
  class N6 extends jL {
    constructor(D, M, k, $, J) {
      super(D, M, k), this.Literal = D, this.Placement = M, this.Path = k, this.Extent = $, this.BoxAlignment = J, this.type = 3124975700;
    }
  }
  e.IfcTextLiteralWithExtent = N6;
  class pq extends kI {
    constructor(D, M, k, $, J, ue, Ie) {
      super(D, M, k), this.ProfileType = D, this.ProfileName = M, this.Position = k, this.BottomXDim = $, this.TopXDim = J, this.YDim = ue, this.TopXOffset = Ie, this.type = 2715220739;
    }
  }
  e.IfcTrapeziumProfileDef = pq;
  class WL extends pM {
    constructor(D, M) {
      super(D), this.RepeatFactor = D, this.SecondRepeatFactor = M, this.type = 1345879162;
    }
  }
  e.IfcTwoDirectionRepeatFactor = WL;
  class JA extends kL {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.type = 1628702193;
    }
  }
  e.IfcTypeObject = JA;
  class D6 extends JA {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.type = 2347495698;
    }
  }
  e.IfcTypeProduct = D6;
  class RM extends kI {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji) {
      super(D, M, k), this.ProfileType = D, this.ProfileName = M, this.Position = k, this.Depth = $, this.FlangeWidth = J, this.WebThickness = ue, this.FlangeThickness = Ie, this.FilletRadius = ve, this.EdgeRadius = Be, this.FlangeSlope = bt, this.CentreOfGravityInX = ji, this.type = 427810014;
    }
  }
  e.IfcUShapeProfileDef = RM;
  class mq extends br {
    constructor(D, M) {
      super(), this.Orientation = D, this.Magnitude = M, this.type = 1417489154;
    }
  }
  e.IfcVector = mq;
  class C6 extends HL {
    constructor(D) {
      super(), this.LoopVertex = D, this.type = 2759199220;
    }
  }
  e.IfcVertexLoop = C6;
  class X5 extends Qu {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn, fs) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.LiningDepth = J, this.LiningThickness = ue, this.TransomThickness = Ie, this.MullionThickness = ve, this.FirstTransomOffset = Be, this.SecondTransomOffset = bt, this.FirstMullionOffset = ji, this.SecondMullionOffset = xn, this.ShapeAspectStyle = fs, this.type = 336235671;
    }
  }
  e.IfcWindowLiningProperties = X5;
  class yq extends Qu {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.OperationType = J, this.PanelPosition = ue, this.FrameDepth = Ie, this.FrameThickness = ve, this.ShapeAspectStyle = Be, this.type = 512836454;
    }
  }
  e.IfcWindowPanelProperties = yq;
  class Eq extends D6 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ConstructionType = Be, this.OperationType = bt, this.ParameterTakesPrecedence = ji, this.Sizeable = xn, this.type = 1299126871;
    }
  }
  e.IfcWindowStyle = Eq;
  class fG extends kI {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k), this.ProfileType = D, this.ProfileName = M, this.Position = k, this.Depth = $, this.FlangeWidth = J, this.WebThickness = ue, this.FlangeThickness = Ie, this.FilletRadius = ve, this.EdgeRadius = Be, this.type = 2543172580;
    }
  }
  e.IfcZShapeProfileDef = fG;
  class vM extends gE {
    constructor(D, M, k) {
      super(D, M, k), this.Item = D, this.Styles = M, this.Name = k, this.type = 3288037868;
    }
  }
  e.IfcAnnotationCurveOccurrence = vM;
  class gq extends br {
    constructor(D, M) {
      super(), this.OuterBoundary = D, this.InnerBoundaries = M, this.type = 669184980;
    }
  }
  e.IfcAnnotationFillArea = gq;
  class wq extends gE {
    constructor(D, M, k, $, J) {
      super(D, M, k), this.Item = D, this.Styles = M, this.Name = k, this.FillStyleTarget = $, this.GlobalOrLocal = J, this.type = 2265737646;
    }
  }
  e.IfcAnnotationFillAreaOccurrence = wq;
  class YL extends br {
    constructor(D, M) {
      super(), this.Item = D, this.TextureCoordinates = M, this.type = 1302238472;
    }
  }
  e.IfcAnnotationSurface = YL;
  class Tq extends VL {
    constructor(D, M) {
      super(D), this.Location = D, this.Axis = M, this.type = 4261334040;
    }
  }
  e.IfcAxis1Placement = Tq;
  class eR extends VL {
    constructor(D, M) {
      super(D), this.Location = D, this.RefDirection = M, this.type = 3125803723;
    }
  }
  e.IfcAxis2Placement2D = eR;
  class Rq extends VL {
    constructor(D, M, k) {
      super(D), this.Location = D, this.Axis = M, this.RefDirection = k, this.type = 2740243338;
    }
  }
  e.IfcAxis2Placement3D = Rq;
  class XA extends br {
    constructor(D, M, k) {
      super(), this.Operator = D, this.FirstOperand = M, this.SecondOperand = k, this.type = 2736907675;
    }
  }
  e.IfcBooleanResult = XA;
  class AM extends S6 {
    constructor() {
      super(), this.type = 4182860854;
    }
  }
  e.IfcBoundedSurface = AM;
  class vq extends br {
    constructor(D, M, k, $) {
      super(), this.Corner = D, this.XDim = M, this.YDim = k, this.ZDim = $, this.type = 2581212453;
    }
  }
  e.IfcBoundingBox = vq;
  class SM extends UL {
    constructor(D, M, k) {
      super(D, M), this.BaseSurface = D, this.AgreementFlag = M, this.Enclosure = k, this.type = 2713105998;
    }
  }
  e.IfcBoxedHalfSpace = SM;
  class Aq extends kI {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k), this.ProfileType = D, this.ProfileName = M, this.Position = k, this.Depth = $, this.Width = J, this.WallThickness = ue, this.Girth = Ie, this.InternalFilletRadius = ve, this.CentreOfGravityInX = Be, this.type = 2898889636;
    }
  }
  e.IfcCShapeProfileDef = Aq;
  class IG extends A6 {
    constructor(D) {
      super(), this.Coordinates = D, this.type = 1123145078;
    }
  }
  e.IfcCartesianPoint = IG;
  class bM extends br {
    constructor(D, M, k, $) {
      super(), this.Axis1 = D, this.Axis2 = M, this.LocalOrigin = k, this.Scale = $, this.type = 59481748;
    }
  }
  e.IfcCartesianTransformationOperator = bM;
  class pG extends bM {
    constructor(D, M, k, $) {
      super(D, M, k, $), this.Axis1 = D, this.Axis2 = M, this.LocalOrigin = k, this.Scale = $, this.type = 3749851601;
    }
  }
  e.IfcCartesianTransformationOperator2D = pG;
  class tR extends pG {
    constructor(D, M, k, $, J) {
      super(D, M, k, $), this.Axis1 = D, this.Axis2 = M, this.LocalOrigin = k, this.Scale = $, this.Scale2 = J, this.type = 3486308946;
    }
  }
  e.IfcCartesianTransformationOperator2DnonUniform = tR;
  class mG extends bM {
    constructor(D, M, k, $, J) {
      super(D, M, k, $), this.Axis1 = D, this.Axis2 = M, this.LocalOrigin = k, this.Scale = $, this.Axis3 = J, this.type = 3331915920;
    }
  }
  e.IfcCartesianTransformationOperator3D = mG;
  class O6 extends mG {
    constructor(D, M, k, $, J, ue, Ie) {
      super(D, M, k, $, J), this.Axis1 = D, this.Axis2 = M, this.LocalOrigin = k, this.Scale = $, this.Axis3 = J, this.Scale2 = ue, this.Scale3 = Ie, this.type = 1416205885;
    }
  }
  e.IfcCartesianTransformationOperator3DnonUniform = O6;
  class NM extends kI {
    constructor(D, M, k, $) {
      super(D, M, k), this.ProfileType = D, this.ProfileName = M, this.Position = k, this.Radius = $, this.type = 1383045692;
    }
  }
  e.IfcCircleProfileDef = NM;
  class Sq extends rM {
    constructor(D) {
      super(D), this.CfsFaces = D, this.type = 2205249479;
    }
  }
  e.IfcClosedShell = Sq;
  class Vf extends br {
    constructor(D, M, k) {
      super(), this.Transition = D, this.SameSense = M, this.ParentCurve = k, this.type = 2485617015;
    }
  }
  e.IfcCompositeCurveSegment = Vf;
  class bq extends kI {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn, fs, Xs, jo) {
      super(D, M, k), this.ProfileType = D, this.ProfileName = M, this.Position = k, this.OverallHeight = $, this.BaseWidth2 = J, this.Radius = ue, this.HeadWidth = Ie, this.HeadDepth2 = ve, this.HeadDepth3 = Be, this.WebThickness = bt, this.BaseWidth4 = ji, this.BaseDepth1 = xn, this.BaseDepth2 = fs, this.BaseDepth3 = Xs, this.CentreOfGravityInY = jo, this.type = 4133800736;
    }
  }
  e.IfcCraneRailAShapeProfileDef = bq;
  class DM extends kI {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn) {
      super(D, M, k), this.ProfileType = D, this.ProfileName = M, this.Position = k, this.OverallHeight = $, this.HeadWidth = J, this.Radius = ue, this.HeadDepth2 = Ie, this.HeadDepth3 = ve, this.WebThickness = Be, this.BaseDepth1 = bt, this.BaseDepth2 = ji, this.CentreOfGravityInY = xn, this.type = 194851669;
    }
  }
  e.IfcCraneRailFShapeProfileDef = DM;
  class iR extends br {
    constructor(D) {
      super(), this.Position = D, this.type = 2506170314;
    }
  }
  e.IfcCsgPrimitive3D = iR;
  class L6 extends Z4 {
    constructor(D) {
      super(), this.TreeRootExpression = D, this.type = 2147822146;
    }
  }
  e.IfcCsgSolid = L6;
  class nR extends br {
    constructor() {
      super(), this.type = 2601014836;
    }
  }
  e.IfcCurve = nR;
  class _6 extends AM {
    constructor(D, M, k) {
      super(), this.BasisSurface = D, this.OuterBoundary = M, this.InnerBoundaries = k, this.type = 2827736869;
    }
  }
  e.IfcCurveBoundedPlane = _6;
  class qL extends br {
    constructor(D, M) {
      super(), this.Definition = D, this.Target = M, this.type = 693772133;
    }
  }
  e.IfcDefinedSymbol = qL;
  class $L extends vM {
    constructor(D, M, k) {
      super(D, M, k), this.Item = D, this.Styles = M, this.Name = k, this.type = 606661476;
    }
  }
  e.IfcDimensionCurve = $L;
  class x6 extends TM {
    constructor(D, M, k, $, J) {
      super(D, M, k, $), this.Item = D, this.Styles = M, this.Name = k, this.AnnotatedCurve = $, this.Role = J, this.type = 4054601972;
    }
  }
  e.IfcDimensionCurveTerminator = x6;
  class yG extends br {
    constructor(D) {
      super(), this.DirectionRatios = D, this.type = 32440307;
    }
  }
  e.IfcDirection = yG;
  class Nq extends Qu {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn, fs, Xs, jo) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.LiningDepth = J, this.LiningThickness = ue, this.ThresholdDepth = Ie, this.ThresholdThickness = ve, this.TransomThickness = Be, this.TransomOffset = bt, this.LiningOffset = ji, this.ThresholdOffset = xn, this.CasingThickness = fs, this.CasingDepth = Xs, this.ShapeAspectStyle = jo, this.type = 2963535650;
    }
  }
  e.IfcDoorLiningProperties = Nq;
  class KL extends Qu {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.PanelDepth = J, this.PanelOperation = ue, this.PanelWidth = Ie, this.PanelPosition = ve, this.ShapeAspectStyle = Be, this.type = 1714330368;
    }
  }
  e.IfcDoorPanelProperties = KL;
  class ZL extends D6 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.OperationType = Be, this.ConstructionType = bt, this.ParameterTakesPrecedence = ji, this.Sizeable = xn, this.type = 526551008;
    }
  }
  e.IfcDoorStyle = ZL;
  class QL extends br {
    constructor(D) {
      super(), this.Contents = D, this.type = 3073041342;
    }
  }
  e.IfcDraughtingCallout = QL;
  class Dq extends nG {
    constructor(D) {
      super(D), this.Name = D, this.type = 445594917;
    }
  }
  e.IfcDraughtingPreDefinedColour = Dq;
  class Cq extends sG {
    constructor(D) {
      super(D), this.Name = D, this.type = 4006246654;
    }
  }
  e.IfcDraughtingPreDefinedCurveFont = Cq;
  class CM extends HL {
    constructor(D) {
      super(), this.EdgeList = D, this.type = 1472233963;
    }
  }
  e.IfcEdgeLoop = CM;
  class OM extends Qu {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.MethodOfMeasurement = J, this.Quantities = ue, this.type = 1883228015;
    }
  }
  e.IfcElementQuantity = OM;
  class sR extends D6 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.type = 339256511;
    }
  }
  e.IfcElementType = sR;
  class P6 extends S6 {
    constructor(D) {
      super(), this.Position = D, this.type = 2777663545;
    }
  }
  e.IfcElementarySurface = P6;
  class LM extends kI {
    constructor(D, M, k, $, J) {
      super(D, M, k), this.ProfileType = D, this.ProfileName = M, this.Position = k, this.SemiAxis1 = $, this.SemiAxis2 = J, this.type = 2835456948;
    }
  }
  e.IfcEllipseProfileDef = LM;
  class JL extends Qu {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.EnergySequence = J, this.UserDefinedEnergySequence = ue, this.type = 80994333;
    }
  }
  e.IfcEnergyProperties = JL;
  class oR extends J5 {
    constructor(D, M, k, $) {
      super(D, M), this.SweptArea = D, this.Position = M, this.ExtrudedDirection = k, this.Depth = $, this.type = 477187591;
    }
  }
  e.IfcExtrudedAreaSolid = oR;
  class Oq extends br {
    constructor(D) {
      super(), this.FbsmFaces = D, this.type = 2047409740;
    }
  }
  e.IfcFaceBasedSurfaceModel = Oq;
  class Lq extends br {
    constructor(D, M, k, $, J) {
      super(), this.HatchLineAppearance = D, this.StartOfNextHatchLine = M, this.PointOfReferenceHatchLine = k, this.PatternStart = $, this.HatchLineAngle = J, this.type = 374418227;
    }
  }
  e.IfcFillAreaStyleHatching = Lq;
  class rR extends br {
    constructor(D) {
      super(), this.Symbol = D, this.type = 4203026998;
    }
  }
  e.IfcFillAreaStyleTileSymbolWithStyle = rR;
  class _q extends br {
    constructor(D, M, k) {
      super(), this.TilingPattern = D, this.Tiles = M, this.TilingScale = k, this.type = 315944413;
    }
  }
  e.IfcFillAreaStyleTiles = _q;
  class _M extends Qu {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn, fs, Xs, jo, Gs, Su, Co, Zf) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.PropertySource = J, this.FlowConditionTimeSeries = ue, this.VelocityTimeSeries = Ie, this.FlowrateTimeSeries = ve, this.Fluid = Be, this.PressureTimeSeries = bt, this.UserDefinedPropertySource = ji, this.TemperatureSingleValue = xn, this.WetBulbTemperatureSingleValue = fs, this.WetBulbTemperatureTimeSeries = Xs, this.TemperatureTimeSeries = jo, this.FlowrateSingleValue = Gs, this.FlowConditionSingleValue = Su, this.VelocitySingleValue = Co, this.PressureSingleValue = Zf, this.type = 3455213021;
    }
  }
  e.IfcFluidFlowProperties = _M;
  class xM extends sR {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.type = 4238390223;
    }
  }
  e.IfcFurnishingElementType = xM;
  class xq extends xM {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.AssemblyPlace = bt, this.type = 1268542332;
    }
  }
  e.IfcFurnitureType = xq;
  class PM extends ZH {
    constructor(D) {
      super(D), this.Elements = D, this.type = 987898635;
    }
  }
  e.IfcGeometricCurveSet = PM;
  class MM extends kI {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k), this.ProfileType = D, this.ProfileName = M, this.Position = k, this.OverallWidth = $, this.OverallDepth = J, this.WebThickness = ue, this.FlangeThickness = Ie, this.FilletRadius = ve, this.type = 1484403080;
    }
  }
  e.IfcIShapeProfileDef = MM;
  class Pq extends kI {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji) {
      super(D, M, k), this.ProfileType = D, this.ProfileName = M, this.Position = k, this.Depth = $, this.Width = J, this.Thickness = ue, this.FilletRadius = Ie, this.EdgeRadius = ve, this.LegSlope = Be, this.CentreOfGravityInX = bt, this.CentreOfGravityInY = ji, this.type = 572779678;
    }
  }
  e.IfcLShapeProfileDef = Pq;
  class XL extends nR {
    constructor(D, M) {
      super(), this.Pnt = D, this.Dir = M, this.type = 1281925730;
    }
  }
  e.IfcLine = XL;
  class UM extends Z4 {
    constructor(D) {
      super(), this.Outer = D, this.type = 1425443689;
    }
  }
  e.IfcManifoldSolidBrep = UM;
  class Ah extends kL {
    constructor(D, M, k, $, J) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.type = 3888040117;
    }
  }
  e.IfcObject = Ah;
  class Mq extends nR {
    constructor(D, M, k) {
      super(), this.BasisCurve = D, this.Distance = M, this.SelfIntersect = k, this.type = 3388369263;
    }
  }
  e.IfcOffsetCurve2D = Mq;
  class eS extends nR {
    constructor(D, M, k, $) {
      super(), this.BasisCurve = D, this.Distance = M, this.SelfIntersect = k, this.RefDirection = $, this.type = 3505215534;
    }
  }
  e.IfcOffsetCurve3D = eS;
  class Uq extends Qu {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.OperationType = J, this.PanelPosition = ue, this.FrameDepth = Ie, this.FrameThickness = ve, this.ShapeAspectStyle = Be, this.type = 3566463478;
    }
  }
  e.IfcPermeableCoveringProperties = Uq;
  class EG extends yM {
    constructor(D, M, k) {
      super(D, M), this.SizeInX = D, this.SizeInY = M, this.Placement = k, this.type = 603570806;
    }
  }
  e.IfcPlanarBox = EG;
  class Q4 extends P6 {
    constructor(D) {
      super(D), this.Position = D, this.type = 220341763;
    }
  }
  e.IfcPlane = Q4;
  class M6 extends Ah {
    constructor(D, M, k, $, J) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.type = 2945172077;
    }
  }
  e.IfcProcess = M6;
  class wE extends Ah {
    constructor(D, M, k, $, J, ue, Ie) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.type = 4208778838;
    }
  }
  e.IfcProduct = wE;
  class tS extends Ah {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.LongName = ue, this.Phase = Ie, this.RepresentationContexts = ve, this.UnitsInContext = Be, this.type = 103090709;
    }
  }
  e.IfcProject = tS;
  class Bq extends vM {
    constructor(D, M, k) {
      super(D, M, k), this.Item = D, this.Styles = M, this.Name = k, this.type = 4194566429;
    }
  }
  e.IfcProjectionCurve = Bq;
  class am extends Qu {
    constructor(D, M, k, $, J) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.HasProperties = J, this.type = 1451395588;
    }
  }
  e.IfcPropertySet = am;
  class Fq extends wE {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.ProxyType = ve, this.Tag = Be, this.type = 3219374653;
    }
  }
  e.IfcProxy = Fq;
  class e7 extends wM {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J), this.ProfileType = D, this.ProfileName = M, this.Position = k, this.XDim = $, this.YDim = J, this.WallThickness = ue, this.InnerFilletRadius = Ie, this.OuterFilletRadius = ve, this.type = 2770003689;
    }
  }
  e.IfcRectangleHollowProfileDef = e7;
  class gG extends iR {
    constructor(D, M, k, $) {
      super(D), this.Position = D, this.XLength = M, this.YLength = k, this.Height = $, this.type = 2798486643;
    }
  }
  e.IfcRectangularPyramid = gG;
  class Hq extends AM {
    constructor(D, M, k, $, J, ue, Ie) {
      super(), this.BasisSurface = D, this.U1 = M, this.V1 = k, this.U2 = $, this.V2 = J, this.Usense = ue, this.Vsense = Ie, this.type = 3454111270;
    }
  }
  e.IfcRectangularTrimmedSurface = Hq;
  class nw extends Z5 {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatedObjects = J, this.RelatedObjectsType = ue, this.type = 3939117080;
    }
  }
  e.IfcRelAssigns = nw;
  class wG extends nw {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatedObjects = J, this.RelatedObjectsType = ue, this.RelatingActor = Ie, this.ActingRole = ve, this.type = 1683148259;
    }
  }
  e.IfcRelAssignsToActor = wG;
  class zf extends nw {
    constructor(D, M, k, $, J, ue, Ie) {
      super(D, M, k, $, J, ue), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatedObjects = J, this.RelatedObjectsType = ue, this.RelatingControl = Ie, this.type = 2495723537;
    }
  }
  e.IfcRelAssignsToControl = zf;
  class iS extends nw {
    constructor(D, M, k, $, J, ue, Ie) {
      super(D, M, k, $, J, ue), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatedObjects = J, this.RelatedObjectsType = ue, this.RelatingGroup = Ie, this.type = 1307041759;
    }
  }
  e.IfcRelAssignsToGroup = iS;
  class Gq extends nw {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatedObjects = J, this.RelatedObjectsType = ue, this.RelatingProcess = Ie, this.QuantityInProcess = ve, this.type = 4278684876;
    }
  }
  e.IfcRelAssignsToProcess = Gq;
  class kq extends nw {
    constructor(D, M, k, $, J, ue, Ie) {
      super(D, M, k, $, J, ue), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatedObjects = J, this.RelatedObjectsType = ue, this.RelatingProduct = Ie, this.type = 2857406711;
    }
  }
  e.IfcRelAssignsToProduct = kq;
  class TG extends zf {
    constructor(D, M, k, $, J, ue, Ie) {
      super(D, M, k, $, J, ue, Ie), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatedObjects = J, this.RelatedObjectsType = ue, this.RelatingControl = Ie, this.type = 3372526763;
    }
  }
  e.IfcRelAssignsToProjectOrder = TG;
  class t7 extends nw {
    constructor(D, M, k, $, J, ue, Ie) {
      super(D, M, k, $, J, ue), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatedObjects = J, this.RelatedObjectsType = ue, this.RelatingResource = Ie, this.type = 205026976;
    }
  }
  e.IfcRelAssignsToResource = t7;
  class um extends Z5 {
    constructor(D, M, k, $, J) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatedObjects = J, this.type = 1865459582;
    }
  }
  e.IfcRelAssociates = um;
  class BM extends um {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatedObjects = J, this.RelatingAppliedValue = ue, this.type = 1327628568;
    }
  }
  e.IfcRelAssociatesAppliedValue = BM;
  class RG extends um {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatedObjects = J, this.RelatingApproval = ue, this.type = 4095574036;
    }
  }
  e.IfcRelAssociatesApproval = RG;
  class Vq extends um {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatedObjects = J, this.RelatingClassification = ue, this.type = 919958153;
    }
  }
  e.IfcRelAssociatesClassification = Vq;
  class FM extends um {
    constructor(D, M, k, $, J, ue, Ie) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatedObjects = J, this.Intent = ue, this.RelatingConstraint = Ie, this.type = 2728634034;
    }
  }
  e.IfcRelAssociatesConstraint = FM;
  class zq extends um {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatedObjects = J, this.RelatingDocument = ue, this.type = 982818633;
    }
  }
  e.IfcRelAssociatesDocument = zq;
  class jq extends um {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatedObjects = J, this.RelatingLibrary = ue, this.type = 3840914261;
    }
  }
  e.IfcRelAssociatesLibrary = jq;
  class Wq extends um {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatedObjects = J, this.RelatingMaterial = ue, this.type = 2655215786;
    }
  }
  e.IfcRelAssociatesMaterial = Wq;
  class Yq extends um {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatedObjects = J, this.RelatingProfileProperties = ue, this.ProfileSectionLocation = Ie, this.ProfileOrientation = ve, this.type = 2851387026;
    }
  }
  e.IfcRelAssociatesProfileProperties = Yq;
  class vu extends Z5 {
    constructor(D, M, k, $) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.type = 826625072;
    }
  }
  e.IfcRelConnects = vu;
  class HM extends vu {
    constructor(D, M, k, $, J, ue, Ie) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ConnectionGeometry = J, this.RelatingElement = ue, this.RelatedElement = Ie, this.type = 1204542856;
    }
  }
  e.IfcRelConnectsElements = HM;
  class qq extends HM {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji) {
      super(D, M, k, $, J, ue, Ie), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ConnectionGeometry = J, this.RelatingElement = ue, this.RelatedElement = Ie, this.RelatingPriorities = ve, this.RelatedPriorities = Be, this.RelatedConnectionType = bt, this.RelatingConnectionType = ji, this.type = 3945020480;
    }
  }
  e.IfcRelConnectsPathElements = qq;
  class $q extends vu {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatingPort = J, this.RelatedElement = ue, this.type = 4201705270;
    }
  }
  e.IfcRelConnectsPortToElement = $q;
  class Kq extends vu {
    constructor(D, M, k, $, J, ue, Ie) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatingPort = J, this.RelatedPort = ue, this.RealizingElement = Ie, this.type = 3190031847;
    }
  }
  e.IfcRelConnectsPorts = Kq;
  class i7 extends vu {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatingElement = J, this.RelatedStructuralActivity = ue, this.type = 2127690289;
    }
  }
  e.IfcRelConnectsStructuralActivity = i7;
  class K3 extends vu {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatingElement = J, this.RelatedStructuralMember = ue, this.type = 3912681535;
    }
  }
  e.IfcRelConnectsStructuralElement = K3;
  class vG extends vu {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatingStructuralMember = J, this.RelatedStructuralConnection = ue, this.AppliedCondition = Ie, this.AdditionalConditions = ve, this.SupportedLength = Be, this.ConditionCoordinateSystem = bt, this.type = 1638771189;
    }
  }
  e.IfcRelConnectsStructuralMember = vG;
  class Zq extends vG {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji) {
      super(D, M, k, $, J, ue, Ie, ve, Be, bt), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatingStructuralMember = J, this.RelatedStructuralConnection = ue, this.AppliedCondition = Ie, this.AdditionalConditions = ve, this.SupportedLength = Be, this.ConditionCoordinateSystem = bt, this.ConnectionConstraint = ji, this.type = 504942748;
    }
  }
  e.IfcRelConnectsWithEccentricity = Zq;
  class Qq extends HM {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ConnectionGeometry = J, this.RelatingElement = ue, this.RelatedElement = Ie, this.RealizingElements = ve, this.ConnectionType = Be, this.type = 3678494232;
    }
  }
  e.IfcRelConnectsWithRealizingElements = Qq;
  class Jq extends vu {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatedElements = J, this.RelatingStructure = ue, this.type = 3242617779;
    }
  }
  e.IfcRelContainedInSpatialStructure = Jq;
  class GM extends vu {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatingBuildingElement = J, this.RelatedCoverings = ue, this.type = 886880790;
    }
  }
  e.IfcRelCoversBldgElements = GM;
  class AG extends vu {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatedSpace = J, this.RelatedCoverings = ue, this.type = 2802773753;
    }
  }
  e.IfcRelCoversSpaces = AG;
  class n7 extends Z5 {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatingObject = J, this.RelatedObjects = ue, this.type = 2551354335;
    }
  }
  e.IfcRelDecomposes = n7;
  class Z3 extends Z5 {
    constructor(D, M, k, $, J) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatedObjects = J, this.type = 693640335;
    }
  }
  e.IfcRelDefines = Z3;
  class kM extends Z3 {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatedObjects = J, this.RelatingPropertyDefinition = ue, this.type = 4186316022;
    }
  }
  e.IfcRelDefinesByProperties = kM;
  class s7 extends Z3 {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatedObjects = J, this.RelatingType = ue, this.type = 781010003;
    }
  }
  e.IfcRelDefinesByType = s7;
  class TE extends vu {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatingOpeningElement = J, this.RelatedBuildingElement = ue, this.type = 3940055652;
    }
  }
  e.IfcRelFillsElement = TE;
  class Xq extends vu {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatedControlElements = J, this.RelatingFlowElement = ue, this.type = 279856033;
    }
  }
  e.IfcRelFlowControlElements = Xq;
  class SG extends vu {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.DailyInteraction = J, this.ImportanceRating = ue, this.LocationOfInteraction = Ie, this.RelatedSpaceProgram = ve, this.RelatingSpaceProgram = Be, this.type = 4189434867;
    }
  }
  e.IfcRelInteractionRequirements = SG;
  class e$ extends n7 {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $, J, ue), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatingObject = J, this.RelatedObjects = ue, this.type = 3268803585;
    }
  }
  e.IfcRelNests = e$;
  class t$ extends wG {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatedObjects = J, this.RelatedObjectsType = ue, this.RelatingActor = Ie, this.ActingRole = ve, this.type = 2051452291;
    }
  }
  e.IfcRelOccupiesSpaces = t$;
  class i$ extends kM {
    constructor(D, M, k, $, J, ue, Ie) {
      super(D, M, k, $, J, ue), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatedObjects = J, this.RelatingPropertyDefinition = ue, this.OverridingProperties = Ie, this.type = 202636808;
    }
  }
  e.IfcRelOverridesProperties = i$;
  class bG extends vu {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatingElement = J, this.RelatedFeatureElement = ue, this.type = 750771296;
    }
  }
  e.IfcRelProjectsElement = bG;
  class lR extends vu {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatedElements = J, this.RelatingStructure = ue, this.type = 1245217292;
    }
  }
  e.IfcRelReferencedInSpatialStructure = lR;
  class VM extends zf {
    constructor(D, M, k, $, J, ue, Ie) {
      super(D, M, k, $, J, ue, Ie), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatedObjects = J, this.RelatedObjectsType = ue, this.RelatingControl = Ie, this.type = 1058617721;
    }
  }
  e.IfcRelSchedulesCostItems = VM;
  class n$ extends vu {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatingProcess = J, this.RelatedProcess = ue, this.TimeLag = Ie, this.SequenceType = ve, this.type = 4122056220;
    }
  }
  e.IfcRelSequence = n$;
  class nS extends vu {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatingSystem = J, this.RelatedBuildings = ue, this.type = 366585022;
    }
  }
  e.IfcRelServicesBuildings = nS;
  class zM extends vu {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatingSpace = J, this.RelatedBuildingElement = ue, this.ConnectionGeometry = Ie, this.PhysicalOrVirtualBoundary = ve, this.InternalOrExternalBoundary = Be, this.type = 3451746338;
    }
  }
  e.IfcRelSpaceBoundary = zM;
  class sw extends vu {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatingBuildingElement = J, this.RelatedOpeningElement = ue, this.type = 1401173127;
    }
  }
  e.IfcRelVoidsElement = sw;
  class NG extends Ah {
    constructor(D, M, k, $, J) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.type = 2914609552;
    }
  }
  e.IfcResource = NG;
  class s$ extends J5 {
    constructor(D, M, k, $) {
      super(D, M), this.SweptArea = D, this.Position = M, this.Axis = k, this.Angle = $, this.type = 1856042241;
    }
  }
  e.IfcRevolvedAreaSolid = s$;
  class o$ extends iR {
    constructor(D, M, k) {
      super(D), this.Position = D, this.Height = M, this.BottomRadius = k, this.type = 4158566097;
    }
  }
  e.IfcRightCircularCone = o$;
  class r$ extends iR {
    constructor(D, M, k) {
      super(D), this.Position = D, this.Height = M, this.Radius = k, this.type = 3626867408;
    }
  }
  e.IfcRightCircularCylinder = r$;
  class VI extends wE {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.LongName = ve, this.CompositionType = Be, this.type = 2706606064;
    }
  }
  e.IfcSpatialStructureElement = VI;
  class DG extends sR {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.type = 3893378262;
    }
  }
  e.IfcSpatialStructureElementType = DG;
  class l$ extends iR {
    constructor(D, M) {
      super(D), this.Position = D, this.Radius = M, this.type = 451544542;
    }
  }
  e.IfcSphere = l$;
  class dm extends wE {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.AppliedLoad = ve, this.GlobalOrLocal = Be, this.type = 3544373492;
    }
  }
  e.IfcStructuralActivity = dm;
  class aR extends wE {
    constructor(D, M, k, $, J, ue, Ie) {
      super(D, M, k, $, J, ue, Ie), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.type = 3136571912;
    }
  }
  e.IfcStructuralItem = aR;
  class jM extends aR {
    constructor(D, M, k, $, J, ue, Ie) {
      super(D, M, k, $, J, ue, Ie), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.type = 530289379;
    }
  }
  e.IfcStructuralMember = jM;
  class CG extends dm {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.AppliedLoad = ve, this.GlobalOrLocal = Be, this.type = 3689010777;
    }
  }
  e.IfcStructuralReaction = CG;
  class WM extends jM {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.PredefinedType = ve, this.Thickness = Be, this.type = 3979015343;
    }
  }
  e.IfcStructuralSurfaceMember = WM;
  class uR extends WM {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.PredefinedType = ve, this.Thickness = Be, this.SubsequentThickness = bt, this.VaryingThicknessLocation = ji, this.type = 2218152070;
    }
  }
  e.IfcStructuralSurfaceMemberVarying = uR;
  class a$ extends QL {
    constructor(D) {
      super(D), this.Contents = D, this.type = 4070609034;
    }
  }
  e.IfcStructuredDimensionCallout = a$;
  class u$ extends J5 {
    constructor(D, M, k, $, J, ue) {
      super(D, M), this.SweptArea = D, this.Position = M, this.Directrix = k, this.StartParam = $, this.EndParam = J, this.ReferenceSurface = ue, this.type = 2028607225;
    }
  }
  e.IfcSurfaceCurveSweptAreaSolid = u$;
  class d$ extends Nr {
    constructor(D, M, k, $) {
      super(D, M), this.SweptCurve = D, this.Position = M, this.ExtrudedDirection = k, this.Depth = $, this.type = 2809605785;
    }
  }
  e.IfcSurfaceOfLinearExtrusion = d$;
  class OG extends Nr {
    constructor(D, M, k) {
      super(D, M), this.SweptCurve = D, this.Position = M, this.AxisPosition = k, this.type = 4124788165;
    }
  }
  e.IfcSurfaceOfRevolution = OG;
  class YM extends xM {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.type = 1580310250;
    }
  }
  e.IfcSystemFurnitureElementType = YM;
  class qM extends M6 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.TaskId = ue, this.Status = Ie, this.WorkMethod = ve, this.IsMilestone = Be, this.Priority = bt, this.type = 3473067441;
    }
  }
  e.IfcTask = qM;
  class E0 extends sR {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 2097647324;
    }
  }
  e.IfcTransportElementType = E0;
  class o7 extends Ah {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.TheActor = ue, this.type = 2296667514;
    }
  }
  e.IfcActor = o7;
  class c$ extends wE {
    constructor(D, M, k, $, J, ue, Ie) {
      super(D, M, k, $, J, ue, Ie), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.type = 1674181508;
    }
  }
  e.IfcAnnotation = c$;
  class LG extends MM {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn) {
      super(D, M, k, $, J, ue, Ie, ve), this.ProfileType = D, this.ProfileName = M, this.Position = k, this.OverallWidth = $, this.OverallDepth = J, this.WebThickness = ue, this.FlangeThickness = Ie, this.FilletRadius = ve, this.TopFlangeWidth = Be, this.TopFlangeThickness = bt, this.TopFlangeFilletRadius = ji, this.CentreOfGravityInY = xn, this.type = 3207858831;
    }
  }
  e.IfcAsymmetricIShapeProfileDef = LG;
  class h$ extends iR {
    constructor(D, M, k, $) {
      super(D), this.Position = D, this.XLength = M, this.YLength = k, this.ZLength = $, this.type = 1334484129;
    }
  }
  e.IfcBlock = h$;
  class f$ extends XA {
    constructor(D, M, k) {
      super(D, M, k), this.Operator = D, this.FirstOperand = M, this.SecondOperand = k, this.type = 3649129432;
    }
  }
  e.IfcBooleanClippingResult = f$;
  class sS extends nR {
    constructor() {
      super(), this.type = 1260505505;
    }
  }
  e.IfcBoundedCurve = sS;
  class I$ extends VI {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.LongName = ve, this.CompositionType = Be, this.ElevationOfRefHeight = bt, this.ElevationOfTerrain = ji, this.BuildingAddress = xn, this.type = 4031249490;
    }
  }
  e.IfcBuilding = I$;
  class zI extends sR {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.type = 1950629157;
    }
  }
  e.IfcBuildingElementType = zI;
  class $M extends VI {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.LongName = ve, this.CompositionType = Be, this.Elevation = bt, this.type = 3124254112;
    }
  }
  e.IfcBuildingStorey = $M;
  class dR extends NM {
    constructor(D, M, k, $, J) {
      super(D, M, k, $), this.ProfileType = D, this.ProfileName = M, this.Position = k, this.Radius = $, this.WallThickness = J, this.type = 2937912522;
    }
  }
  e.IfcCircleHollowProfileDef = dR;
  class r7 extends zI {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 300633059;
    }
  }
  e.IfcColumnType = r7;
  class _G extends sS {
    constructor(D, M) {
      super(), this.Segments = D, this.SelfIntersect = M, this.type = 3732776249;
    }
  }
  e.IfcCompositeCurve = _G;
  class cR extends nR {
    constructor(D) {
      super(), this.Position = D, this.type = 2510884976;
    }
  }
  e.IfcConic = cR;
  class Q3 extends NG {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ResourceIdentifier = ue, this.ResourceGroup = Ie, this.ResourceConsumption = ve, this.BaseQuantity = Be, this.type = 2559216714;
    }
  }
  e.IfcConstructionResource = Q3;
  class g0 extends Ah {
    constructor(D, M, k, $, J) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.type = 3293443760;
    }
  }
  e.IfcControl = g0;
  class p$ extends g0 {
    constructor(D, M, k, $, J) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.type = 3895139033;
    }
  }
  e.IfcCostItem = p$;
  class m$ extends g0 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn, fs) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.SubmittedBy = ue, this.PreparedBy = Ie, this.SubmittedOn = ve, this.Status = Be, this.TargetUsers = bt, this.UpdateDate = ji, this.ID = xn, this.PredefinedType = fs, this.type = 1419761937;
    }
  }
  e.IfcCostSchedule = m$;
  class y$ extends zI {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 1916426348;
    }
  }
  e.IfcCoveringType = y$;
  class xG extends Q3 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ResourceIdentifier = ue, this.ResourceGroup = Ie, this.ResourceConsumption = ve, this.BaseQuantity = Be, this.type = 3295246426;
    }
  }
  e.IfcCrewResource = xG;
  class PG extends zI {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 1457835157;
    }
  }
  e.IfcCurtainWallType = PG;
  class J3 extends QL {
    constructor(D) {
      super(D), this.Contents = D, this.type = 681481545;
    }
  }
  e.IfcDimensionCurveDirectedCallout = J3;
  class KM extends sR {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.type = 3256556792;
    }
  }
  e.IfcDistributionElementType = KM;
  class jI extends KM {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.type = 3849074793;
    }
  }
  e.IfcDistributionFlowElementType = jI;
  class ow extends JL {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn, fs, Xs) {
      super(D, M, k, $, J, ue), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.EnergySequence = J, this.UserDefinedEnergySequence = ue, this.ElectricCurrentType = Ie, this.InputVoltage = ve, this.InputFrequency = Be, this.FullLoadCurrent = bt, this.MinimumCircuitCurrent = ji, this.MaximumPowerInput = xn, this.RatedPowerInput = fs, this.InputPhase = Xs, this.type = 360485395;
    }
  }
  e.IfcElectricalBaseProperties = ow;
  class X3 extends wE {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 1758889154;
    }
  }
  e.IfcElement = X3;
  class E$ extends X3 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.AssemblyPlace = Be, this.PredefinedType = bt, this.type = 4123344466;
    }
  }
  e.IfcElementAssembly = E$;
  class l7 extends X3 {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 1623761950;
    }
  }
  e.IfcElementComponent = l7;
  class a7 extends sR {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.type = 2590856083;
    }
  }
  e.IfcElementComponentType = a7;
  class g$ extends cR {
    constructor(D, M, k) {
      super(D), this.Position = D, this.SemiAxis1 = M, this.SemiAxis2 = k, this.type = 1704287377;
    }
  }
  e.IfcEllipse = g$;
  class Ju extends jI {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.type = 2107101300;
    }
  }
  e.IfcEnergyConversionDeviceType = Ju;
  class w$ extends X3 {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 1962604670;
    }
  }
  e.IfcEquipmentElement = w$;
  class MG extends g0 {
    constructor(D, M, k, $, J) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.type = 3272907226;
    }
  }
  e.IfcEquipmentStandard = MG;
  class UG extends Ju {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 3174744832;
    }
  }
  e.IfcEvaporativeCoolerType = UG;
  class T$ extends Ju {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 3390157468;
    }
  }
  e.IfcEvaporatorType = T$;
  class ZM extends UM {
    constructor(D) {
      super(D), this.Outer = D, this.type = 807026263;
    }
  }
  e.IfcFacetedBrep = ZM;
  class R$ extends UM {
    constructor(D, M) {
      super(D), this.Outer = D, this.Voids = M, this.type = 3737207727;
    }
  }
  e.IfcFacetedBrepWithVoids = R$;
  class BG extends l7 {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 647756555;
    }
  }
  e.IfcFastener = BG;
  class U6 extends a7 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.type = 2489546625;
    }
  }
  e.IfcFastenerType = U6;
  class B6 extends X3 {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 2827207264;
    }
  }
  e.IfcFeatureElement = B6;
  class cm extends B6 {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 2143335405;
    }
  }
  e.IfcFeatureElementAddition = cm;
  class u7 extends B6 {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 1287392070;
    }
  }
  e.IfcFeatureElementSubtraction = u7;
  class J4 extends jI {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.type = 3907093117;
    }
  }
  e.IfcFlowControllerType = J4;
  class oS extends jI {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.type = 3198132628;
    }
  }
  e.IfcFlowFittingType = oS;
  class v$ extends J4 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 3815607619;
    }
  }
  e.IfcFlowMeterType = v$;
  class d7 extends jI {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.type = 1482959167;
    }
  }
  e.IfcFlowMovingDeviceType = d7;
  class hR extends jI {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.type = 1834744321;
    }
  }
  e.IfcFlowSegmentType = hR;
  class F6 extends jI {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.type = 1339347760;
    }
  }
  e.IfcFlowStorageDeviceType = F6;
  class da extends jI {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.type = 2297155007;
    }
  }
  e.IfcFlowTerminalType = da;
  class rS extends jI {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.type = 3009222698;
    }
  }
  e.IfcFlowTreatmentDeviceType = rS;
  class FG extends X3 {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 263784265;
    }
  }
  e.IfcFurnishingElement = FG;
  class A$ extends g0 {
    constructor(D, M, k, $, J) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.type = 814719939;
    }
  }
  e.IfcFurnitureStandard = A$;
  class S$ extends da {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 200128114;
    }
  }
  e.IfcGasTerminalType = S$;
  class b$ extends wE {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.UAxes = ve, this.VAxes = Be, this.WAxes = bt, this.type = 3009204131;
    }
  }
  e.IfcGrid = b$;
  class RE extends Ah {
    constructor(D, M, k, $, J) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.type = 2706460486;
    }
  }
  e.IfcGroup = RE;
  class N$ extends Ju {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 1251058090;
    }
  }
  e.IfcHeatExchangerType = N$;
  class Gc extends Ju {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 1806887404;
    }
  }
  e.IfcHumidifierType = Gc;
  class QM extends RE {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.InventoryType = ue, this.Jurisdiction = Ie, this.ResponsiblePersons = ve, this.LastUpdateDate = Be, this.CurrentValue = bt, this.OriginalValue = ji, this.type = 2391368822;
    }
  }
  e.IfcInventory = QM;
  class D$ extends oS {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 4288270099;
    }
  }
  e.IfcJunctionBoxType = D$;
  class C$ extends Q3 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ResourceIdentifier = ue, this.ResourceGroup = Ie, this.ResourceConsumption = ve, this.BaseQuantity = Be, this.SkillSet = bt, this.type = 3827777499;
    }
  }
  e.IfcLaborResource = C$;
  class O$ extends da {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 1051575348;
    }
  }
  e.IfcLampType = O$;
  class JM extends da {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 1161773419;
    }
  }
  e.IfcLightFixtureType = JM;
  class HG extends J3 {
    constructor(D) {
      super(D), this.Contents = D, this.type = 2506943328;
    }
  }
  e.IfcLinearDimension = HG;
  class L$ extends BG {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.NominalDiameter = Be, this.NominalLength = bt, this.type = 377706215;
    }
  }
  e.IfcMechanicalFastener = L$;
  class _$ extends U6 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.type = 2108223431;
    }
  }
  e.IfcMechanicalFastenerType = _$;
  class x$ extends zI {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 3181161470;
    }
  }
  e.IfcMemberType = x$;
  class P$ extends Ju {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 977012517;
    }
  }
  e.IfcMotorConnectionType = P$;
  class GG extends qM {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn, fs) {
      super(D, M, k, $, J, ue, Ie, ve, Be, bt), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.TaskId = ue, this.Status = Ie, this.WorkMethod = ve, this.IsMilestone = Be, this.Priority = bt, this.MoveFrom = ji, this.MoveTo = xn, this.PunchList = fs, this.type = 1916936684;
    }
  }
  e.IfcMove = GG;
  class kG extends o7 {
    constructor(D, M, k, $, J, ue, Ie) {
      super(D, M, k, $, J, ue), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.TheActor = ue, this.PredefinedType = Ie, this.type = 4143007308;
    }
  }
  e.IfcOccupant = kG;
  class lS extends u7 {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 3588315303;
    }
  }
  e.IfcOpeningElement = lS;
  class H6 extends qM {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji) {
      super(D, M, k, $, J, ue, Ie, ve, Be, bt), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.TaskId = ue, this.Status = Ie, this.WorkMethod = ve, this.IsMilestone = Be, this.Priority = bt, this.ActionID = ji, this.type = 3425660407;
    }
  }
  e.IfcOrderAction = H6;
  class VG extends da {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 2837617999;
    }
  }
  e.IfcOutletType = VG;
  class zG extends g0 {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.LifeCyclePhase = ue, this.type = 2382730787;
    }
  }
  e.IfcPerformanceHistory = zG;
  class M$ extends g0 {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.PermitID = ue, this.type = 3327091369;
    }
  }
  e.IfcPermit = M$;
  class U$ extends oS {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 804291784;
    }
  }
  e.IfcPipeFittingType = U$;
  class aS extends hR {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 4231323485;
    }
  }
  e.IfcPipeSegmentType = aS;
  class B$ extends zI {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 4017108033;
    }
  }
  e.IfcPlateType = B$;
  class ql extends sS {
    constructor(D) {
      super(), this.Points = D, this.type = 3724593414;
    }
  }
  e.IfcPolyline = ql;
  class jG extends wE {
    constructor(D, M, k, $, J, ue, Ie) {
      super(D, M, k, $, J, ue, Ie), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.type = 3740093272;
    }
  }
  e.IfcPort = jG;
  class F$ extends M6 {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ProcedureID = ue, this.ProcedureType = Ie, this.UserDefinedProcedureType = ve, this.type = 2744685151;
    }
  }
  e.IfcProcedure = F$;
  class H$ extends g0 {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ID = ue, this.PredefinedType = Ie, this.Status = ve, this.type = 2904328755;
    }
  }
  e.IfcProjectOrder = H$;
  class G$ extends g0 {
    constructor(D, M, k, $, J, ue, Ie) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.Records = ue, this.PredefinedType = Ie, this.type = 3642467123;
    }
  }
  e.IfcProjectOrderRecord = G$;
  class k$ extends cm {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 3651124850;
    }
  }
  e.IfcProjectionElement = k$;
  class V$ extends J4 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 1842657554;
    }
  }
  e.IfcProtectiveDeviceType = V$;
  class XM extends d7 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 2250791053;
    }
  }
  e.IfcPumpType = XM;
  class e9 extends J3 {
    constructor(D) {
      super(D), this.Contents = D, this.type = 3248260540;
    }
  }
  e.IfcRadiusDimension = e9;
  class t9 extends zI {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 2893384427;
    }
  }
  e.IfcRailingType = t9;
  class z$ extends zI {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 2324767716;
    }
  }
  e.IfcRampFlightType = z$;
  class j$ extends n7 {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $, J, ue), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatingObject = J, this.RelatedObjects = ue, this.type = 160246688;
    }
  }
  e.IfcRelAggregates = j$;
  class WG extends zf {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.RelatedObjects = J, this.RelatedObjectsType = ue, this.RelatingControl = Ie, this.TimeForTask = ve, this.type = 2863920197;
    }
  }
  e.IfcRelAssignsTasks = WG;
  class X4 extends da {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 1768891740;
    }
  }
  e.IfcSanitaryTerminalType = X4;
  class rw extends g0 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn, fs, Xs, jo, Gs, Su, Co, Zf, Em, ep, Fd, Nh) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ActualStart = ue, this.EarlyStart = Ie, this.LateStart = ve, this.ScheduleStart = Be, this.ActualFinish = bt, this.EarlyFinish = ji, this.LateFinish = xn, this.ScheduleFinish = fs, this.ScheduleDuration = Xs, this.ActualDuration = jo, this.RemainingTime = Gs, this.FreeFloat = Su, this.TotalFloat = Co, this.IsCritical = Zf, this.StatusTime = Em, this.StartFloat = ep, this.FinishFloat = Fd, this.Completion = Nh, this.type = 3517283431;
    }
  }
  e.IfcScheduleTimeControl = rw;
  class W$ extends g0 {
    constructor(D, M, k, $, J, ue, Ie) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ServiceLifeType = ue, this.ServiceLifeDuration = Ie, this.type = 4105383287;
    }
  }
  e.IfcServiceLife = W$;
  class Y$ extends VI {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn, fs, Xs) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.LongName = ve, this.CompositionType = Be, this.RefLatitude = bt, this.RefLongitude = ji, this.RefElevation = xn, this.LandTitleNumber = fs, this.SiteAddress = Xs, this.type = 4097777520;
    }
  }
  e.IfcSite = Y$;
  class YG extends zI {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 2533589738;
    }
  }
  e.IfcSlabType = YG;
  class q$ extends VI {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.LongName = ve, this.CompositionType = Be, this.InteriorOrExteriorSpace = bt, this.ElevationWithFlooring = ji, this.type = 3856911033;
    }
  }
  e.IfcSpace = q$;
  class $$ extends Ju {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 1305183839;
    }
  }
  e.IfcSpaceHeaterType = $$;
  class K$ extends g0 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.SpaceProgramIdentifier = ue, this.MaxRequiredArea = Ie, this.MinRequiredArea = ve, this.RequestedLocation = Be, this.StandardRequiredArea = bt, this.type = 652456506;
    }
  }
  e.IfcSpaceProgram = K$;
  class uS extends DG {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 3812236995;
    }
  }
  e.IfcSpaceType = uS;
  class hm extends da {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 3112655638;
    }
  }
  e.IfcStackTerminalType = hm;
  class dS extends zI {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 1039846685;
    }
  }
  e.IfcStairFlightType = dS;
  class G6 extends dm {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.AppliedLoad = ve, this.GlobalOrLocal = Be, this.DestabilizingLoad = bt, this.CausedBy = ji, this.type = 682877961;
    }
  }
  e.IfcStructuralAction = G6;
  class c7 extends aR {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.AppliedCondition = ve, this.type = 1179482911;
    }
  }
  e.IfcStructuralConnection = c7;
  class Z$ extends c7 {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.AppliedCondition = ve, this.type = 4243806635;
    }
  }
  e.IfcStructuralCurveConnection = Z$;
  class qG extends jM {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.PredefinedType = ve, this.type = 214636428;
    }
  }
  e.IfcStructuralCurveMember = qG;
  class ey extends qG {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.PredefinedType = ve, this.type = 2445595289;
    }
  }
  e.IfcStructuralCurveMemberVarying = ey;
  class eT extends G6 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn) {
      super(D, M, k, $, J, ue, Ie, ve, Be, bt, ji), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.AppliedLoad = ve, this.GlobalOrLocal = Be, this.DestabilizingLoad = bt, this.CausedBy = ji, this.ProjectedOrTrue = xn, this.type = 1807405624;
    }
  }
  e.IfcStructuralLinearAction = eT;
  class i9 extends eT {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn, fs, Xs) {
      super(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.AppliedLoad = ve, this.GlobalOrLocal = Be, this.DestabilizingLoad = bt, this.CausedBy = ji, this.ProjectedOrTrue = xn, this.VaryingAppliedLoadLocation = fs, this.SubsequentAppliedLoads = Xs, this.type = 1721250024;
    }
  }
  e.IfcStructuralLinearActionVarying = i9;
  class lw extends RE {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.PredefinedType = ue, this.ActionType = Ie, this.ActionSource = ve, this.Coefficient = Be, this.Purpose = bt, this.type = 1252848954;
    }
  }
  e.IfcStructuralLoadGroup = lw;
  class vE extends G6 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn) {
      super(D, M, k, $, J, ue, Ie, ve, Be, bt, ji), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.AppliedLoad = ve, this.GlobalOrLocal = Be, this.DestabilizingLoad = bt, this.CausedBy = ji, this.ProjectedOrTrue = xn, this.type = 1621171031;
    }
  }
  e.IfcStructuralPlanarAction = vE;
  class h7 extends vE {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn, fs, Xs) {
      super(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.AppliedLoad = ve, this.GlobalOrLocal = Be, this.DestabilizingLoad = bt, this.CausedBy = ji, this.ProjectedOrTrue = xn, this.VaryingAppliedLoadLocation = fs, this.SubsequentAppliedLoads = Xs, this.type = 3987759626;
    }
  }
  e.IfcStructuralPlanarActionVarying = h7;
  class $l extends G6 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji) {
      super(D, M, k, $, J, ue, Ie, ve, Be, bt, ji), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.AppliedLoad = ve, this.GlobalOrLocal = Be, this.DestabilizingLoad = bt, this.CausedBy = ji, this.type = 2082059205;
    }
  }
  e.IfcStructuralPointAction = $l;
  class Q$ extends c7 {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.AppliedCondition = ve, this.type = 734778138;
    }
  }
  e.IfcStructuralPointConnection = Q$;
  class J$ extends CG {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.AppliedLoad = ve, this.GlobalOrLocal = Be, this.type = 1235345126;
    }
  }
  e.IfcStructuralPointReaction = J$;
  class X$ extends RE {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.TheoryType = ue, this.ResultForLoadGroup = Ie, this.IsLinear = ve, this.type = 2986769608;
    }
  }
  e.IfcStructuralResultGroup = X$;
  class n9 extends c7 {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.AppliedCondition = ve, this.type = 1975003073;
    }
  }
  e.IfcStructuralSurfaceConnection = n9;
  class $G extends Q3 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ResourceIdentifier = ue, this.ResourceGroup = Ie, this.ResourceConsumption = ve, this.BaseQuantity = Be, this.SubContractor = bt, this.JobDescription = ji, this.type = 148013059;
    }
  }
  e.IfcSubContractResource = $G;
  class KG extends J4 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 2315554128;
    }
  }
  e.IfcSwitchingDeviceType = KG;
  class s9 extends RE {
    constructor(D, M, k, $, J) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.type = 2254336722;
    }
  }
  e.IfcSystem = s9;
  class eK extends F6 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 5716631;
    }
  }
  e.IfcTankType = eK;
  class tK extends g0 {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ApplicableDates = ue, this.TimeSeriesScheduleType = Ie, this.TimeSeries = ve, this.type = 1637806684;
    }
  }
  e.IfcTimeSeriesSchedule = tK;
  class f7 extends Ju {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 1692211062;
    }
  }
  e.IfcTransformerType = f7;
  class I7 extends X3 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.OperationType = Be, this.CapacityByWeight = bt, this.CapacityByNumber = ji, this.type = 1620046519;
    }
  }
  e.IfcTransportElement = I7;
  class o9 extends sS {
    constructor(D, M, k, $, J) {
      super(), this.BasisCurve = D, this.Trim1 = M, this.Trim2 = k, this.SenseAgreement = $, this.MasterRepresentation = J, this.type = 3593883385;
    }
  }
  e.IfcTrimmedCurve = o9;
  class aw extends Ju {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 1600972822;
    }
  }
  e.IfcTubeBundleType = aw;
  class tT extends Ju {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 1911125066;
    }
  }
  e.IfcUnitaryEquipmentType = tT;
  class ZG extends J4 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 728799441;
    }
  }
  e.IfcValveType = ZG;
  class p7 extends X3 {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 2769231204;
    }
  }
  e.IfcVirtualElement = p7;
  class k6 extends zI {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 1898987631;
    }
  }
  e.IfcWallType = k6;
  class r9 extends da {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 1133259667;
    }
  }
  e.IfcWasteTerminalType = r9;
  class w0 extends g0 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn, fs, Xs, jo) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.Identifier = ue, this.CreationDate = Ie, this.Creators = ve, this.Purpose = Be, this.Duration = bt, this.TotalFloat = ji, this.StartTime = xn, this.FinishTime = fs, this.WorkControlType = Xs, this.UserDefinedControlType = jo, this.type = 1028945134;
    }
  }
  e.IfcWorkControl = w0;
  class V6 extends w0 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn, fs, Xs, jo) {
      super(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn, fs, Xs, jo), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.Identifier = ue, this.CreationDate = Ie, this.Creators = ve, this.Purpose = Be, this.Duration = bt, this.TotalFloat = ji, this.StartTime = xn, this.FinishTime = fs, this.WorkControlType = Xs, this.UserDefinedControlType = jo, this.type = 4218914973;
    }
  }
  e.IfcWorkPlan = V6;
  class QG extends w0 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn, fs, Xs, jo) {
      super(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn, fs, Xs, jo), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.Identifier = ue, this.CreationDate = Ie, this.Creators = ve, this.Purpose = Be, this.Duration = bt, this.TotalFloat = ji, this.StartTime = xn, this.FinishTime = fs, this.WorkControlType = Xs, this.UserDefinedControlType = jo, this.type = 3342526732;
    }
  }
  e.IfcWorkSchedule = QG;
  class l9 extends RE {
    constructor(D, M, k, $, J) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.type = 1033361043;
    }
  }
  e.IfcZone = l9;
  class iK extends _G {
    constructor(D, M) {
      super(D, M), this.Segments = D, this.SelfIntersect = M, this.type = 1213861670;
    }
  }
  e.Ifc2DCompositeCurve = iK;
  class JG extends g0 {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.RequestID = ue, this.type = 3821786052;
    }
  }
  e.IfcActionRequest = JG;
  class XG extends J4 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 1411407467;
    }
  }
  e.IfcAirTerminalBoxType = XG;
  class cS extends da {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 3352864051;
    }
  }
  e.IfcAirTerminalType = cS;
  class nK extends Ju {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 1871374353;
    }
  }
  e.IfcAirToAirHeatRecoveryType = nK;
  class hS extends J3 {
    constructor(D) {
      super(D), this.Contents = D, this.type = 2470393545;
    }
  }
  e.IfcAngularDimension = hS;
  class sK extends RE {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn, fs, Xs) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.AssetID = ue, this.OriginalValue = Ie, this.CurrentValue = ve, this.TotalReplacementCost = Be, this.Owner = bt, this.User = ji, this.ResponsiblePerson = xn, this.IncorporationDate = fs, this.DepreciatedValue = Xs, this.type = 3460190687;
    }
  }
  e.IfcAsset = sK;
  class hr extends sS {
    constructor(D, M, k, $, J) {
      super(), this.Degree = D, this.ControlPointsList = M, this.CurveForm = k, this.ClosedCurve = $, this.SelfIntersect = J, this.type = 1967976161;
    }
  }
  e.IfcBSplineCurve = hr;
  class oK extends zI {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 819618141;
    }
  }
  e.IfcBeamType = oK;
  class ek extends hr {
    constructor(D, M, k, $, J) {
      super(D, M, k, $, J), this.Degree = D, this.ControlPointsList = M, this.CurveForm = k, this.ClosedCurve = $, this.SelfIntersect = J, this.type = 1916977116;
    }
  }
  e.IfcBezierCurve = ek;
  class rK extends Ju {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 231477066;
    }
  }
  e.IfcBoilerType = rK;
  class ca extends X3 {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 3299480353;
    }
  }
  e.IfcBuildingElement = ca;
  class a9 extends ca {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 52481810;
    }
  }
  e.IfcBuildingElementComponent = a9;
  class lK extends a9 {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 2979338954;
    }
  }
  e.IfcBuildingElementPart = lK;
  class m7 extends ca {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.CompositionType = Be, this.type = 1095909175;
    }
  }
  e.IfcBuildingElementProxy = m7;
  class tk extends zI {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 1909888760;
    }
  }
  e.IfcBuildingElementProxyType = tk;
  class u9 extends oS {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 395041908;
    }
  }
  e.IfcCableCarrierFittingType = u9;
  class aK extends hR {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 3293546465;
    }
  }
  e.IfcCableCarrierSegmentType = aK;
  class uK extends hR {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 1285652485;
    }
  }
  e.IfcCableSegmentType = uK;
  class dK extends Ju {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 2951183804;
    }
  }
  e.IfcChillerType = dK;
  class iT extends cR {
    constructor(D, M) {
      super(D), this.Position = D, this.Radius = M, this.type = 2611217952;
    }
  }
  e.IfcCircle = iT;
  class uw extends Ju {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 2301859152;
    }
  }
  e.IfcCoilType = uw;
  class cK extends ca {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 843113511;
    }
  }
  e.IfcColumn = cK;
  class hK extends d7 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 3850581409;
    }
  }
  e.IfcCompressorType = hK;
  class fK extends Ju {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 2816379211;
    }
  }
  e.IfcCondenserType = fK;
  class IK extends RE {
    constructor(D, M, k, $, J) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.type = 2188551683;
    }
  }
  e.IfcCondition = IK;
  class pK extends g0 {
    constructor(D, M, k, $, J, ue, Ie) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.Criterion = ue, this.CriterionDateTime = Ie, this.type = 1163958913;
    }
  }
  e.IfcConditionCriterion = pK;
  class mK extends Q3 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ResourceIdentifier = ue, this.ResourceGroup = Ie, this.ResourceConsumption = ve, this.BaseQuantity = Be, this.type = 3898045240;
    }
  }
  e.IfcConstructionEquipmentResource = mK;
  class yK extends Q3 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ResourceIdentifier = ue, this.ResourceGroup = Ie, this.ResourceConsumption = ve, this.BaseQuantity = Be, this.Suppliers = bt, this.UsageRatio = ji, this.type = 1060000209;
    }
  }
  e.IfcConstructionMaterialResource = yK;
  class EK extends Q3 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ResourceIdentifier = ue, this.ResourceGroup = Ie, this.ResourceConsumption = ve, this.BaseQuantity = Be, this.type = 488727124;
    }
  }
  e.IfcConstructionProductResource = EK;
  class d9 extends Ju {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 335055490;
    }
  }
  e.IfcCooledBeamType = d9;
  class gK extends Ju {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 2954562838;
    }
  }
  e.IfcCoolingTowerType = gK;
  class y7 extends ca {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.PredefinedType = Be, this.type = 1973544240;
    }
  }
  e.IfcCovering = y7;
  class AE extends ca {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 3495092785;
    }
  }
  e.IfcCurtainWall = AE;
  class wK extends J4 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 3961806047;
    }
  }
  e.IfcDamperType = wK;
  class TK extends J3 {
    constructor(D) {
      super(D), this.Contents = D, this.type = 4147604152;
    }
  }
  e.IfcDiameterDimension = TK;
  class RK extends l7 {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 1335981549;
    }
  }
  e.IfcDiscreteAccessory = RK;
  class ik extends a7 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.type = 2635815018;
    }
  }
  e.IfcDiscreteAccessoryType = ik;
  class vK extends jI {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 1599208980;
    }
  }
  e.IfcDistributionChamberElementType = vK;
  class kc extends KM {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.type = 2063403501;
    }
  }
  e.IfcDistributionControlElementType = kc;
  class c9 extends X3 {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 1945004755;
    }
  }
  e.IfcDistributionElement = c9;
  class SE extends c9 {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 3040386961;
    }
  }
  e.IfcDistributionFlowElement = SE;
  class jf extends jG {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.FlowDirection = ve, this.type = 3041715199;
    }
  }
  e.IfcDistributionPort = jf;
  class Wf extends ca {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.OverallHeight = Be, this.OverallWidth = bt, this.type = 395920057;
    }
  }
  e.IfcDoor = Wf;
  class AK extends oS {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 869906466;
    }
  }
  e.IfcDuctFittingType = AK;
  class ha extends hR {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 3760055223;
    }
  }
  e.IfcDuctSegmentType = ha;
  class SK extends rS {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 2030761528;
    }
  }
  e.IfcDuctSilencerType = SK;
  class h9 extends u7 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.FeatureLength = Be, this.type = 855621170;
    }
  }
  e.IfcEdgeFeature = h9;
  class bK extends da {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 663422040;
    }
  }
  e.IfcElectricApplianceType = bK;
  class NK extends F6 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 3277789161;
    }
  }
  e.IfcElectricFlowStorageDeviceType = NK;
  class nk extends Ju {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 1534661035;
    }
  }
  e.IfcElectricGeneratorType = nk;
  class sk extends da {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 1365060375;
    }
  }
  e.IfcElectricHeaterType = sk;
  class DK extends Ju {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 1217240411;
    }
  }
  e.IfcElectricMotorType = DK;
  class fS extends J4 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 712377611;
    }
  }
  e.IfcElectricTimeControlType = fS;
  class IS extends s9 {
    constructor(D, M, k, $, J) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.type = 1634875225;
    }
  }
  e.IfcElectricalCircuit = IS;
  class CK extends X3 {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 857184966;
    }
  }
  e.IfcElectricalElement = CK;
  class OK extends SE {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 1658829314;
    }
  }
  e.IfcEnergyConversionDevice = OK;
  class LK extends d7 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 346874300;
    }
  }
  e.IfcFanType = LK;
  class E7 extends rS {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 1810631287;
    }
  }
  e.IfcFilterType = E7;
  class ok extends da {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 4222183408;
    }
  }
  e.IfcFireSuppressionTerminalType = ok;
  class nT extends SE {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 2058353004;
    }
  }
  e.IfcFlowController = nT;
  class WI extends SE {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 4278956645;
    }
  }
  e.IfcFlowFitting = WI;
  class fR extends kc {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 4037862832;
    }
  }
  e.IfcFlowInstrumentType = fR;
  class _K extends SE {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 3132237377;
    }
  }
  e.IfcFlowMovingDevice = _K;
  class z6 extends SE {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 987401354;
    }
  }
  e.IfcFlowSegment = z6;
  class pS extends SE {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 707683696;
    }
  }
  e.IfcFlowStorageDevice = pS;
  class f9 extends SE {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 2223149337;
    }
  }
  e.IfcFlowTerminal = f9;
  class Vc extends SE {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 3508470533;
    }
  }
  e.IfcFlowTreatmentDevice = Vc;
  class mS extends ca {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.PredefinedType = Be, this.type = 900683007;
    }
  }
  e.IfcFooting = mS;
  class xK extends ca {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 1073191201;
    }
  }
  e.IfcMember = xK;
  class I9 extends ca {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.PredefinedType = Be, this.ConstructionType = bt, this.type = 1687234759;
    }
  }
  e.IfcPile = I9;
  class PK extends ca {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 3171933400;
    }
  }
  e.IfcPlate = PK;
  class MK extends ca {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.PredefinedType = Be, this.type = 2262370178;
    }
  }
  e.IfcRailing = MK;
  class g7 extends ca {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.ShapeType = Be, this.type = 3024970846;
    }
  }
  e.IfcRamp = g7;
  class UK extends ca {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 3283111854;
    }
  }
  e.IfcRampFlight = UK;
  class BK extends ek {
    constructor(D, M, k, $, J, ue) {
      super(D, M, k, $, J), this.Degree = D, this.ControlPointsList = M, this.CurveForm = k, this.ClosedCurve = $, this.SelfIntersect = J, this.WeightsData = ue, this.type = 3055160366;
    }
  }
  e.IfcRationalBezierCurve = BK;
  class bE extends a9 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.SteelGrade = Be, this.type = 3027567501;
    }
  }
  e.IfcReinforcingElement = bE;
  class FK extends bE {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn, fs, Xs, jo, Gs, Su) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.SteelGrade = Be, this.MeshLength = bt, this.MeshWidth = ji, this.LongitudinalBarNominalDiameter = xn, this.TransverseBarNominalDiameter = fs, this.LongitudinalBarCrossSectionArea = Xs, this.TransverseBarCrossSectionArea = jo, this.LongitudinalBarSpacing = Gs, this.TransverseBarSpacing = Su, this.type = 2320036040;
    }
  }
  e.IfcReinforcingMesh = FK;
  class j6 extends ca {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.ShapeType = Be, this.type = 2016517767;
    }
  }
  e.IfcRoof = j6;
  class HK extends h9 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.FeatureLength = Be, this.Radius = bt, this.type = 1376911519;
    }
  }
  e.IfcRoundedEdgeFeature = HK;
  class GK extends kc {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 1783015770;
    }
  }
  e.IfcSensorType = GK;
  class kK extends ca {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.PredefinedType = Be, this.type = 1529196076;
    }
  }
  e.IfcSlab = kK;
  class VK extends ca {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.ShapeType = Be, this.type = 331165859;
    }
  }
  e.IfcStair = VK;
  class zK extends ca {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.NumberOfRiser = Be, this.NumberOfTreads = bt, this.RiserHeight = ji, this.TreadLength = xn, this.type = 4252922144;
    }
  }
  e.IfcStairFlight = zK;
  class jK extends s9 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.PredefinedType = ue, this.OrientationOf2DPlane = Ie, this.LoadedBy = ve, this.HasResults = Be, this.type = 2515109513;
    }
  }
  e.IfcStructuralAnalysisModel = jK;
  class WK extends bE {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn, fs, Xs, jo, Gs, Su) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.SteelGrade = Be, this.PredefinedType = bt, this.NominalDiameter = ji, this.CrossSectionArea = xn, this.TensionForce = fs, this.PreStress = Xs, this.FrictionCoefficient = jo, this.AnchorageSlip = Gs, this.MinCurvatureRadius = Su, this.type = 3824725483;
    }
  }
  e.IfcTendon = WK;
  class YK extends bE {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.SteelGrade = Be, this.type = 2347447852;
    }
  }
  e.IfcTendonAnchor = YK;
  class qK extends ik {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 3313531582;
    }
  }
  e.IfcVibrationIsolatorType = qK;
  class rk extends ca {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 2391406946;
    }
  }
  e.IfcWall = rk;
  class $K extends rk {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 3512223829;
    }
  }
  e.IfcWallStandardCase = $K;
  class W6 extends ca {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.OverallHeight = Be, this.OverallWidth = bt, this.type = 3304561284;
    }
  }
  e.IfcWindow = W6;
  class KK extends kc {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 2874132201;
    }
  }
  e.IfcActuatorType = KK;
  class ZK extends kc {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 3001207471;
    }
  }
  e.IfcAlarmType = ZK;
  class QK extends ca {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 753842376;
    }
  }
  e.IfcBeam = QK;
  class JK extends h9 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.FeatureLength = Be, this.Width = bt, this.Height = ji, this.type = 2454782716;
    }
  }
  e.IfcChamferEdgeFeature = JK;
  class XK extends kc {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ApplicableOccurrence = J, this.HasPropertySets = ue, this.RepresentationMaps = Ie, this.Tag = ve, this.ElementType = Be, this.PredefinedType = bt, this.type = 578613899;
    }
  }
  e.IfcControllerType = XK;
  class eZ extends SE {
    constructor(D, M, k, $, J, ue, Ie, ve) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.type = 1052013943;
    }
  }
  e.IfcDistributionChamberElement = eZ;
  class tZ extends c9 {
    constructor(D, M, k, $, J, ue, Ie, ve, Be) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.ControlElementId = Be, this.type = 1062813311;
    }
  }
  e.IfcDistributionControlElement = tZ;
  class iZ extends nT {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt) {
      super(D, M, k, $, J, ue, Ie, ve), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.DistributionPointFunction = Be, this.UserDefinedFunction = bt, this.type = 3700593921;
    }
  }
  e.IfcElectricDistributionPoint = iZ;
  class p9 extends bE {
    constructor(D, M, k, $, J, ue, Ie, ve, Be, bt, ji, xn, fs, Xs) {
      super(D, M, k, $, J, ue, Ie, ve, Be), this.GlobalId = D, this.OwnerHistory = M, this.Name = k, this.Description = $, this.ObjectType = J, this.ObjectPlacement = ue, this.Representation = Ie, this.Tag = ve, this.SteelGrade = Be, this.NominalDiameter = bt, this.CrossSectionArea = ji, this.BarLength = xn, this.BarRole = fs, this.BarSurface = Xs, this.type = 979691226;
    }
  }
  e.IfcReinforcingBar = p9;
})(f || (f = {}));
TP[2] = ["IFC4"];
kF[2] = {
  3630933823: (e) => new d.IfcActorRole(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcText((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  618182010: (e) => new d.IfcAddress(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  639542469: (e) => new d.IfcApplication(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new d.IfcIdentifier((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  411424972: (e) => {
    var t;
    return new d.IfcAppliedValue((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcDate((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcDate((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : ((t = e[9]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  130549933: (e) => new d.IfcApproval((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcText((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcDateTime((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcText((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 2, e[7]), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 2, e[8])),
  4037036970: (e) => new d.IfcBoundaryCondition((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  1560379544: (e) => new d.IfcBoundaryEdgeCondition((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : Li(2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : Li(2, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : Li(2, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : Li(2, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : Li(2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : Li(2, e[6])),
  3367102660: (e) => new d.IfcBoundaryFaceCondition((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : Li(2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : Li(2, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : Li(2, e[3])),
  1387855156: (e) => new d.IfcBoundaryNodeCondition((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : Li(2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : Li(2, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : Li(2, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : Li(2, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : Li(2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : Li(2, e[6])),
  2069777674: (e) => new d.IfcBoundaryNodeConditionWarping((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : Li(2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : Li(2, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : Li(2, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : Li(2, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : Li(2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : Li(2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : Li(2, e[7])),
  2859738748: (e) => new d.IfcConnectionGeometry(),
  2614616156: (e) => new d.IfcConnectionPointGeometry(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1])),
  2732653382: (e) => new d.IfcConnectionSurfaceGeometry(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1])),
  775493141: (e) => new d.IfcConnectionVolumeGeometry(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1])),
  1959218052: (e) => new d.IfcConstraint(new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), e[2], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcLabel((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcDateTime((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  1785450214: (e) => new d.IfcCoordinateOperation(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1])),
  1466758467: (e) => new d.IfcCoordinateReferenceSystem(new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcIdentifier((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcIdentifier((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  602808272: (e) => {
    var t;
    return new d.IfcCostValue((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcDate((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcDate((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : ((t = e[9]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  1765591967: (e) => {
    var t;
    return new d.IfcDerivedUnit(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], e[1], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value));
  },
  1045800335: (e) => new d.IfcDerivedUnitElement(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new pt((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 10)),
  2949456006: (e) => new d.IfcDimensionalExponents(new pt((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 10), new pt((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 10), new pt((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 10), new pt((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 10), new pt((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 10), new pt((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 10), new pt((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 10)),
  4294318154: (e) => new d.IfcExternalInformation(),
  3200245327: (e) => new d.IfcExternalReference((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcURIReference((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcIdentifier((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  2242383968: (e) => new d.IfcExternallyDefinedHatchStyle((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcURIReference((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcIdentifier((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  1040185647: (e) => new d.IfcExternallyDefinedSurfaceStyle((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcURIReference((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcIdentifier((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  3548104201: (e) => new d.IfcExternallyDefinedTextFont((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcURIReference((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcIdentifier((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  852622518: (e) => new d.IfcGridAxis((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), new d.IfcBoolean((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  3020489413: (e) => {
    var t;
    return new d.IfcIrregularTimeSeriesValue(new d.IfcDateTime((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? Li(2, i) : null)) || []);
  },
  2655187982: (e) => new d.IfcLibraryInformation(new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcDateTime((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcURIReference((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcText((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value)),
  3452421091: (e) => new d.IfcLibraryReference((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcURIReference((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcIdentifier((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLanguageId((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5])),
  4162380809: (e) => {
    var t, i;
    return new d.IfcLightDistributionData(new d.IfcPlaneAngleMeasure((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), ((t = e[1]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new d.IfcPlaneAngleMeasure(n.value) : null)) || [], ((i = e[2]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new d.IfcLuminousIntensityDistributionMeasure(n.value) : null)) || []);
  },
  1566485204: (e) => {
    var t;
    return new d.IfcLightIntensityDistribution(e[0], ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  3057273783: (e) => new d.IfcMapConversion(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), new d.IfcLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new d.IfcLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new d.IfcLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcReal((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcReal((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcReal((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  1847130766: (e) => {
    var t;
    return new d.IfcMaterialClassificationRelationship(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]));
  },
  760658860: (e) => new d.IfcMaterialDefinition(),
  248100487: (e) => new d.IfcMaterialLayer((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new d.IfcNonNegativeLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLogical((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcLabel((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcText((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcInteger((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  3303938423: (e) => {
    var t;
    return new d.IfcMaterialLayerSet(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcText((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value));
  },
  1847252529: (e) => new d.IfcMaterialLayerWithOffsets((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new d.IfcNonNegativeLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLogical((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcLabel((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcText((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcInteger((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), e[7], new d.IfcLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  2199411900: (e) => {
    var t;
    return new d.IfcMaterialList(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  2235152071: (e) => new d.IfcMaterialProfile((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcInteger((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value)),
  164193824: (e) => {
    var t;
    return new d.IfcMaterialProfileSet((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3]));
  },
  552965576: (e) => new d.IfcMaterialProfileWithOffsets((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcInteger((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new d.IfcLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  1507914824: (e) => new d.IfcMaterialUsageDefinition(),
  2597039031: (e) => new d.IfcMeasureWithUnit(Li(2, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1])),
  3368373690: (e) => new d.IfcMetric(new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), e[2], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcLabel((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcDateTime((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), e[7], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 2, e[9]), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 2, e[10])),
  2706619895: (e) => new d.IfcMonetaryUnit(new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  1918398963: (e) => new d.IfcNamedUnit(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), e[1]),
  3701648758: (e) => new d.IfcObjectPlacement(),
  2251480897: (e) => {
    var t;
    return new d.IfcObjective(new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), e[2], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcLabel((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcDateTime((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((t = e[7]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], e[8], e[9], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new d.IfcLabel((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value));
  },
  4251960020: (e) => {
    var t, i;
    return new d.IfcOrganization((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcText((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : ((t = e[3]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[4] ?? void 0) === void 0 || e[4] === "" ? null : ((i = e[4]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || []);
  },
  1207048766: (e) => new d.IfcOwnerHistory(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), e[2], e[3], (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcTimeStamp((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), new d.IfcTimeStamp((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  2077209135: (e) => {
    var t, i, n, s, o;
    return new d.IfcPerson((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : ((t = e[3]) == null ? void 0 : t.map((r) => ((r == null ? void 0 : r.value) ?? void 0) !== void 0 && (r == null ? void 0 : r.value) !== "" ? new d.IfcLabel(r.value) : null)) || [], (e[4] ?? void 0) === void 0 || e[4] === "" ? null : ((i = e[4]) == null ? void 0 : i.map((r) => ((r == null ? void 0 : r.value) ?? void 0) !== void 0 && (r == null ? void 0 : r.value) !== "" ? new d.IfcLabel(r.value) : null)) || [], (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((n = e[5]) == null ? void 0 : n.map((r) => ((r == null ? void 0 : r.value) ?? void 0) !== void 0 && (r == null ? void 0 : r.value) !== "" ? new d.IfcLabel(r.value) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((s = e[6]) == null ? void 0 : s.map((r) => ((r == null ? void 0 : r.value) ?? void 0) !== void 0 && (r == null ? void 0 : r.value) !== "" ? new u(r.value, 2, r) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((o = e[7]) == null ? void 0 : o.map((r) => ((r == null ? void 0 : r.value) ?? void 0) !== void 0 && (r == null ? void 0 : r.value) !== "" ? new u(r.value, 2, r) : null)) || []);
  },
  101040310: (e) => {
    var t;
    return new d.IfcPersonAndOrganization(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  2483315170: (e) => new d.IfcPhysicalQuantity(new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  2226359599: (e) => new d.IfcPhysicalSimpleQuantity(new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2])),
  3355820592: (e) => {
    var t;
    return new d.IfcPostalAddress(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcLabel((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new d.IfcLabel(i.value) : null)) || [], (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcLabel((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value));
  },
  677532197: (e) => new d.IfcPresentationItem(),
  2022622350: (e) => {
    var t;
    return new d.IfcPresentationLayerAssignment(new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcIdentifier((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value));
  },
  1304840413: (e) => {
    var t, i;
    return new d.IfcPresentationLayerWithStyle(new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcIdentifier((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new d.IfcLogical((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new d.IfcLogical((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new d.IfcLogical((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((i = e[7]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || []);
  },
  3119450353: (e) => new d.IfcPresentationStyle((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  2417041796: (e) => {
    var t;
    return new d.IfcPresentationStyleAssignment(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  2095639259: (e) => {
    var t;
    return new d.IfcProductRepresentation((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  3958567839: (e) => new d.IfcProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  3843373140: (e) => new d.IfcProjectedCRS(new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcIdentifier((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcIdentifier((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6])),
  986844984: (e) => new d.IfcPropertyAbstraction(),
  3710013099: (e) => {
    var t;
    return new d.IfcPropertyEnumeration(new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? Li(2, i) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]));
  },
  2044713172: (e) => new d.IfcQuantityArea(new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new d.IfcAreaMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  2093928680: (e) => new d.IfcQuantityCount(new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new d.IfcCountMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  931644368: (e) => new d.IfcQuantityLength(new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new d.IfcLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  3252649465: (e) => new d.IfcQuantityTime(new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new d.IfcTimeMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  2405470396: (e) => new d.IfcQuantityVolume(new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new d.IfcVolumeMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  825690147: (e) => new d.IfcQuantityWeight(new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new d.IfcMassMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  3915482550: (e) => {
    var t, i, n, s;
    return new d.IfcRecurrencePattern(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : ((t = e[1]) == null ? void 0 : t.map((o) => ((o == null ? void 0 : o.value) ?? void 0) !== void 0 && (o == null ? void 0 : o.value) !== "" ? new d.IfcDayInMonthNumber(o.value) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : ((i = e[2]) == null ? void 0 : i.map((o) => ((o == null ? void 0 : o.value) ?? void 0) !== void 0 && (o == null ? void 0 : o.value) !== "" ? new d.IfcDayInWeekNumber(o.value) : null)) || [], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : ((n = e[3]) == null ? void 0 : n.map((o) => ((o == null ? void 0 : o.value) ?? void 0) !== void 0 && (o == null ? void 0 : o.value) !== "" ? new d.IfcMonthInYearNumber(o.value) : null)) || [], (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcInteger((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcInteger((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcInteger((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((s = e[7]) == null ? void 0 : s.map((o) => ((o == null ? void 0 : o.value) ?? void 0) !== void 0 && (o == null ? void 0 : o.value) !== "" ? new u(o.value, 2, o) : null)) || []);
  },
  2433181523: (e) => {
    var t;
    return new d.IfcReference((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcIdentifier((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new d.IfcInteger(i.value) : null)) || [], (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]));
  },
  1076942058: (e) => {
    var t;
    return new d.IfcRepresentation(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  3377609919: (e) => new d.IfcRepresentationContext((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  3008791417: (e) => new d.IfcRepresentationItem(),
  1660063152: (e) => new d.IfcRepresentationMap(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1])),
  2439245199: (e) => new d.IfcResourceLevelRelationship((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  2341007311: (e) => new d.IfcRoot(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  448429030: (e) => new d.IfcSIUnit(e[0], e[1], e[2]),
  1054537805: (e) => new d.IfcSchedulingTime((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), e[1], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  867548509: (e) => {
    var t;
    return new d.IfcShapeAspect(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcText((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new d.IfcLogical((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]));
  },
  3982875396: (e) => {
    var t;
    return new d.IfcShapeModel(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  4240577450: (e) => {
    var t;
    return new d.IfcShapeRepresentation(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  2273995522: (e) => new d.IfcStructuralConnectionCondition((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  2162789131: (e) => new d.IfcStructuralLoad((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  3478079324: (e) => {
    var t, i;
    return new d.IfcStructuralLoadConfiguration((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), ((t = e[1]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : (i = e[2]) == null ? void 0 : i.map((n) => (n == null ? void 0 : n.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new d.IfcLengthMeasure(s.value) : null)) || []));
  },
  609421318: (e) => new d.IfcStructuralLoadOrResult((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  2525727697: (e) => new d.IfcStructuralLoadStatic((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  3408363356: (e) => new d.IfcStructuralLoadTemperature((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcThermodynamicTemperatureMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcThermodynamicTemperatureMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcThermodynamicTemperatureMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2830218821: (e) => {
    var t;
    return new d.IfcStyleModel(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  3958052878: (e) => {
    var t;
    return new d.IfcStyledItem((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value));
  },
  3049322572: (e) => {
    var t;
    return new d.IfcStyledRepresentation(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  2934153892: (e) => {
    var t, i;
    return new d.IfcSurfaceReinforcementArea((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : ((t = e[1]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new d.IfcLengthMeasure(n.value) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : ((i = e[2]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new d.IfcLengthMeasure(n.value) : null)) || [], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcRatioMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value));
  },
  1300840506: (e) => {
    var t;
    return new d.IfcSurfaceStyle((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), e[1], ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  3303107099: (e) => new d.IfcSurfaceStyleLighting(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3])),
  1607154358: (e) => new d.IfcSurfaceStyleRefraction((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcReal((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcReal((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  846575682: (e) => new d.IfcSurfaceStyleShading(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcNormalisedRatioMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  1351298697: (e) => {
    var t;
    return new d.IfcSurfaceStyleWithTextures(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  626085974: (e) => {
    var t;
    return new d.IfcSurfaceTexture(new d.IfcBoolean((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new d.IfcBoolean((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcIdentifier((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new d.IfcIdentifier(i.value) : null)) || []);
  },
  985171141: (e) => {
    var t, i;
    return new d.IfcTable((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : ((t = e[1]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : ((i = e[2]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || []);
  },
  2043862942: (e) => new d.IfcTableColumn((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcText((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4])),
  531007025: (e) => {
    var t;
    return new d.IfcTableRow((e[0] ?? void 0) === void 0 || e[0] === "" ? null : ((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? Li(2, i) : null)) || [], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcBoolean((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value));
  },
  1549132990: (e) => new d.IfcTaskTime((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), e[1], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), e[3], (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcDuration((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcDateTime((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcDateTime((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcDateTime((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcDateTime((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcDateTime((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new d.IfcDateTime((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new d.IfcDuration((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new d.IfcDuration((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), (e[13] ?? void 0) === void 0 || e[13] === "" ? null : new d.IfcBoolean((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value), (e[14] ?? void 0) === void 0 || e[14] === "" ? null : new d.IfcDateTime((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value), (e[15] ?? void 0) === void 0 || e[15] === "" ? null : new d.IfcDuration((e[15] ?? void 0) === void 0 || e[15] === "" ? null : e[15].value), (e[16] ?? void 0) === void 0 || e[16] === "" ? null : new d.IfcDateTime((e[16] ?? void 0) === void 0 || e[16] === "" ? null : e[16].value), (e[17] ?? void 0) === void 0 || e[17] === "" ? null : new d.IfcDateTime((e[17] ?? void 0) === void 0 || e[17] === "" ? null : e[17].value), (e[18] ?? void 0) === void 0 || e[18] === "" ? null : new d.IfcDuration((e[18] ?? void 0) === void 0 || e[18] === "" ? null : e[18].value), (e[19] ?? void 0) === void 0 || e[19] === "" ? null : new d.IfcPositiveRatioMeasure((e[19] ?? void 0) === void 0 || e[19] === "" ? null : e[19].value)),
  2771591690: (e) => new d.IfcTaskTimeRecurring((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), e[1], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), e[3], (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcDuration((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcDateTime((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcDateTime((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcDateTime((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcDateTime((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcDateTime((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new d.IfcDateTime((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new d.IfcDuration((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new d.IfcDuration((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), (e[13] ?? void 0) === void 0 || e[13] === "" ? null : new d.IfcBoolean((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value), (e[14] ?? void 0) === void 0 || e[14] === "" ? null : new d.IfcDateTime((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value), (e[15] ?? void 0) === void 0 || e[15] === "" ? null : new d.IfcDuration((e[15] ?? void 0) === void 0 || e[15] === "" ? null : e[15].value), (e[16] ?? void 0) === void 0 || e[16] === "" ? null : new d.IfcDateTime((e[16] ?? void 0) === void 0 || e[16] === "" ? null : e[16].value), (e[17] ?? void 0) === void 0 || e[17] === "" ? null : new d.IfcDateTime((e[17] ?? void 0) === void 0 || e[17] === "" ? null : e[17].value), (e[18] ?? void 0) === void 0 || e[18] === "" ? null : new d.IfcDuration((e[18] ?? void 0) === void 0 || e[18] === "" ? null : e[18].value), (e[19] ?? void 0) === void 0 || e[19] === "" ? null : new d.IfcPositiveRatioMeasure((e[19] ?? void 0) === void 0 || e[19] === "" ? null : e[19].value), new u((e[20] ?? void 0) === void 0 || e[20] === "" ? null : e[20].value, 2, e[20])),
  912023232: (e) => {
    var t, i, n, s;
    return new d.IfcTelecomAddress(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : ((t = e[3]) == null ? void 0 : t.map((o) => ((o == null ? void 0 : o.value) ?? void 0) !== void 0 && (o == null ? void 0 : o.value) !== "" ? new d.IfcLabel(o.value) : null)) || [], (e[4] ?? void 0) === void 0 || e[4] === "" ? null : ((i = e[4]) == null ? void 0 : i.map((o) => ((o == null ? void 0 : o.value) ?? void 0) !== void 0 && (o == null ? void 0 : o.value) !== "" ? new d.IfcLabel(o.value) : null)) || [], (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((n = e[6]) == null ? void 0 : n.map((o) => ((o == null ? void 0 : o.value) ?? void 0) !== void 0 && (o == null ? void 0 : o.value) !== "" ? new d.IfcLabel(o.value) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcURIReference((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : ((s = e[8]) == null ? void 0 : s.map((o) => ((o == null ? void 0 : o.value) ?? void 0) !== void 0 && (o == null ? void 0 : o.value) !== "" ? new d.IfcURIReference(o.value) : null)) || []);
  },
  1447204868: (e) => new d.IfcTextStyle((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcBoolean((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  2636378356: (e) => new d.IfcTextStyleForDefinedFont(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1])),
  1640371178: (e) => new d.IfcTextStyleTextModel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : Li(2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcTextAlignment((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcTextDecoration((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : Li(2, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : Li(2, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcTextTransformation((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : Li(2, e[6])),
  280115917: (e) => {
    var t;
    return new d.IfcTextureCoordinate(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  1742049831: (e) => {
    var t, i;
    return new d.IfcTextureCoordinateGenerator(((t = e[0]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : ((i = e[2]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new d.IfcReal(n.value) : null)) || []);
  },
  2552916305: (e) => {
    var t, i;
    return new d.IfcTextureMap(((t = e[0]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], ((i = e[1]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]));
  },
  1210645708: (e) => {
    var t;
    return new d.IfcTextureVertex(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new d.IfcParameterValue(i.value) : null)) || []);
  },
  3611470254: (e) => {
    var t;
    return new d.IfcTextureVertexList((t = e[0]) == null ? void 0 : t.map((i) => (i == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new d.IfcParameterValue(n.value) : null)) || []));
  },
  1199560280: (e) => new d.IfcTimePeriod(new d.IfcTime((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new d.IfcTime((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  3101149627: (e) => new d.IfcTimeSeries(new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new d.IfcDateTime((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new d.IfcDateTime((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), e[4], e[5], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 2, e[7])),
  581633288: (e) => {
    var t;
    return new d.IfcTimeSeriesValue(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? Li(2, i) : null)) || []);
  },
  1377556343: (e) => new d.IfcTopologicalRepresentationItem(),
  1735638870: (e) => {
    var t;
    return new d.IfcTopologyRepresentation(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  180925521: (e) => {
    var t;
    return new d.IfcUnitAssignment(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  2799835756: (e) => new d.IfcVertex(),
  1907098498: (e) => new d.IfcVertexPoint(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0])),
  891718957: (e) => {
    var t, i;
    return new d.IfcVirtualGridIntersection(((t = e[0]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], ((i = e[1]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new d.IfcLengthMeasure(n.value) : null)) || []);
  },
  1236880293: (e) => new d.IfcWorkTime((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), e[1], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcDate((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcDate((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value)),
  3869604511: (e) => {
    var t;
    return new d.IfcApprovalRelationship((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  3798115385: (e) => new d.IfcArbitraryClosedProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2])),
  1310608509: (e) => new d.IfcArbitraryOpenProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2])),
  2705031697: (e) => {
    var t;
    return new d.IfcArbitraryProfileDefWithVoids(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  616511568: (e) => {
    var t;
    return new d.IfcBlobTexture(new d.IfcBoolean((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new d.IfcBoolean((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcIdentifier((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new d.IfcIdentifier(i.value) : null)) || [], new d.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new d.IfcBinary((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value));
  },
  3150382593: (e) => new d.IfcCenterLineProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new d.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  747523909: (e) => {
    var t;
    return new d.IfcClassification((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcDate((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new d.IfcLabel((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcText((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcURIReference((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((t = e[6]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new d.IfcIdentifier(i.value) : null)) || []);
  },
  647927063: (e) => new d.IfcClassificationReference((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcURIReference((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcIdentifier((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcText((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value)),
  3285139300: (e) => {
    var t;
    return new d.IfcColourRgbList((t = e[0]) == null ? void 0 : t.map((i) => (i == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new d.IfcNormalisedRatioMeasure(n.value) : null)) || []));
  },
  3264961684: (e) => new d.IfcColourSpecification((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  1485152156: (e) => {
    var t;
    return new d.IfcCompositeProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcLabel((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value));
  },
  370225590: (e) => {
    var t;
    return new d.IfcConnectedFaceSet(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  1981873012: (e) => new d.IfcConnectionCurveGeometry(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1])),
  45288368: (e) => new d.IfcConnectionPointEccentricity(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  3050246964: (e) => new d.IfcContextDependentUnit(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), e[1], new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  2889183280: (e) => new d.IfcConversionBasedUnit(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), e[1], new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3])),
  2713554722: (e) => new d.IfcConversionBasedUnitWithOffset(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), e[1], new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3]), new d.IfcReal((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  539742890: (e) => new d.IfcCurrencyRelationship((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3]), new d.IfcPositiveRatioMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcDateTime((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6])),
  3800577675: (e) => new d.IfcCurveStyle((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : Li(2, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcBoolean((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  1105321065: (e) => {
    var t;
    return new d.IfcCurveStyleFont((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  2367409068: (e) => new d.IfcCurveStyleFontAndScaling((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), new d.IfcPositiveRatioMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  3510044353: (e) => new d.IfcCurveStyleFontPattern(new d.IfcLengthMeasure((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new d.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  3632507154: (e) => new d.IfcDerivedProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  1154170062: (e) => {
    var t;
    return new d.IfcDocumentInformation(new d.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcText((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcURIReference((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcText((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcText((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcText((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 2, e[8]), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : ((t = e[9]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new d.IfcDateTime((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new d.IfcDateTime((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new d.IfcIdentifier((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), (e[13] ?? void 0) === void 0 || e[13] === "" ? null : new d.IfcDate((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value), (e[14] ?? void 0) === void 0 || e[14] === "" ? null : new d.IfcDate((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value), e[15], e[16]);
  },
  770865208: (e) => {
    var t;
    return new d.IfcDocumentInformationRelationship((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value));
  },
  3732053477: (e) => new d.IfcDocumentReference((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcURIReference((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcIdentifier((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4])),
  3900360178: (e) => new d.IfcEdge(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1])),
  476780140: (e) => new d.IfcEdgeCurve(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new d.IfcBoolean((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  211053100: (e) => new d.IfcEventTime((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), e[1], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcDateTime((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcDateTime((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcDateTime((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcDateTime((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  297599258: (e) => {
    var t;
    return new d.IfcExtendedProperties((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  1437805879: (e) => {
    var t;
    return new d.IfcExternalReferenceRelationship((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  2556980723: (e) => {
    var t;
    return new d.IfcFace(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  1809719519: (e) => new d.IfcFaceBound(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new d.IfcBoolean((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  803316827: (e) => new d.IfcFaceOuterBound(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new d.IfcBoolean((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  3008276851: (e) => {
    var t;
    return new d.IfcFaceSurface(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), new d.IfcBoolean((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value));
  },
  4219587988: (e) => new d.IfcFailureConnectionCondition((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcForceMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcForceMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcForceMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcForceMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcForceMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcForceMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  738692330: (e) => {
    var t;
    return new d.IfcFillAreaStyle((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcBoolean((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value));
  },
  3448662350: (e) => new d.IfcGeometricRepresentationContext((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new d.IfcDimensionCount((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcReal((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5])),
  2453401579: (e) => new d.IfcGeometricRepresentationItem(),
  4142052618: (e) => new d.IfcGeometricRepresentationSubContext((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcPositiveRatioMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), e[4], (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value)),
  3590301190: (e) => {
    var t;
    return new d.IfcGeometricSet(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  178086475: (e) => new d.IfcGridPlacement(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1])),
  812098782: (e) => new d.IfcHalfSpaceSolid(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new d.IfcBoolean((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  3905492369: (e) => {
    var t;
    return new d.IfcImageTexture(new d.IfcBoolean((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new d.IfcBoolean((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcIdentifier((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new d.IfcIdentifier(i.value) : null)) || [], new d.IfcURIReference((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value));
  },
  3570813810: (e) => {
    var t;
    return new d.IfcIndexedColourMap(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcNormalisedRatioMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new d.IfcPositiveInteger(i.value) : null)) || []);
  },
  1437953363: (e) => {
    var t;
    return new d.IfcIndexedTextureMap(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]));
  },
  2133299955: (e) => {
    var t, i;
    return new d.IfcIndexedTriangleTextureMap(((t = e[0]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : (i = e[3]) == null ? void 0 : i.map((n) => (n == null ? void 0 : n.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new d.IfcPositiveInteger(s.value) : null)) || []));
  },
  3741457305: (e) => {
    var t;
    return new d.IfcIrregularTimeSeries(new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new d.IfcDateTime((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new d.IfcDateTime((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), e[4], e[5], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 2, e[7]), ((t = e[8]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  1585845231: (e) => new d.IfcLagTime((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), e[1], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), Li(2, e[3]), e[4]),
  1402838566: (e) => new d.IfcLightSource((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcNormalisedRatioMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcNormalisedRatioMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  125510826: (e) => new d.IfcLightSourceAmbient((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcNormalisedRatioMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcNormalisedRatioMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2604431987: (e) => new d.IfcLightSourceDirectional((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcNormalisedRatioMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcNormalisedRatioMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4])),
  4266656042: (e) => new d.IfcLightSourceGoniometric((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcNormalisedRatioMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcNormalisedRatioMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), new d.IfcThermodynamicTemperatureMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), new d.IfcLuminousFluxMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 2, e[9])),
  1520743889: (e) => new d.IfcLightSourcePositional((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcNormalisedRatioMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcNormalisedRatioMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]), new d.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new d.IfcReal((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), new d.IfcReal((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), new d.IfcReal((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  3422422726: (e) => new d.IfcLightSourceSpot((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcNormalisedRatioMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcNormalisedRatioMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]), new d.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new d.IfcReal((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), new d.IfcReal((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), new d.IfcReal((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 2, e[9]), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new d.IfcReal((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), new d.IfcPositivePlaneAngleMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), new d.IfcPositivePlaneAngleMeasure((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value)),
  2624227202: (e) => new d.IfcLocalPlacement((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1])),
  1008929658: (e) => new d.IfcLoop(),
  2347385850: (e) => new d.IfcMappedItem(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1])),
  1838606355: (e) => new d.IfcMaterial(new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  3708119e3: (e) => new d.IfcMaterialConstituent((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcNormalisedRatioMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  2852063980: (e) => {
    var t;
    return new d.IfcMaterialConstituentSet((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  2022407955: (e) => {
    var t;
    return new d.IfcMaterialDefinitionRepresentation((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3]));
  },
  1303795690: (e) => new d.IfcMaterialLayerSetUsage(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), e[1], e[2], new d.IfcLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  3079605661: (e) => new d.IfcMaterialProfileSetUsage(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcCardinalPointReference((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcPositiveLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  3404854881: (e) => new d.IfcMaterialProfileSetUsageTapering(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcCardinalPointReference((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcPositiveLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcCardinalPointReference((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  3265635763: (e) => {
    var t;
    return new d.IfcMaterialProperties((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3]));
  },
  853536259: (e) => {
    var t;
    return new d.IfcMaterialRelationship((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value));
  },
  2998442950: (e) => new d.IfcMirroredProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcLabel((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  219451334: (e) => new d.IfcObjectDefinition(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2665983363: (e) => {
    var t;
    return new d.IfcOpenShell(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  1411181986: (e) => {
    var t;
    return new d.IfcOrganizationRelationship((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  1029017970: (e) => new d.IfcOrientedEdge(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new d.IfcBoolean((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  2529465313: (e) => new d.IfcParameterizedProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2])),
  2519244187: (e) => {
    var t;
    return new d.IfcPath(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  3021840470: (e) => {
    var t;
    return new d.IfcPhysicalComplexQuantity(new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], new d.IfcLabel((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value));
  },
  597895409: (e) => {
    var t, i;
    return new d.IfcPixelTexture(new d.IfcBoolean((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new d.IfcBoolean((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcIdentifier((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : ((t = e[4]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new d.IfcIdentifier(n.value) : null)) || [], new d.IfcInteger((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new d.IfcInteger((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), new d.IfcInteger((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), ((i = e[8]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new d.IfcBinary(n.value) : null)) || []);
  },
  2004835150: (e) => new d.IfcPlacement(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0])),
  1663979128: (e) => new d.IfcPlanarExtent(new d.IfcLengthMeasure((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new d.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  2067069095: (e) => new d.IfcPoint(),
  4022376103: (e) => new d.IfcPointOnCurve(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new d.IfcParameterValue((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  1423911732: (e) => new d.IfcPointOnSurface(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new d.IfcParameterValue((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new d.IfcParameterValue((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  2924175390: (e) => {
    var t;
    return new d.IfcPolyLoop(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  2775532180: (e) => new d.IfcPolygonalBoundedHalfSpace(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new d.IfcBoolean((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3])),
  3727388367: (e) => new d.IfcPreDefinedItem(new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  3778827333: (e) => new d.IfcPreDefinedProperties(),
  1775413392: (e) => new d.IfcPreDefinedTextFont(new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  673634403: (e) => {
    var t;
    return new d.IfcProductDefinitionShape((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  2802850158: (e) => {
    var t;
    return new d.IfcProfileProperties((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3]));
  },
  2598011224: (e) => new d.IfcProperty(new d.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  1680319473: (e) => new d.IfcPropertyDefinition(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  148025276: (e) => new d.IfcPropertyDependencyRelationship((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcText((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  3357820518: (e) => new d.IfcPropertySetDefinition(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  1482703590: (e) => new d.IfcPropertyTemplateDefinition(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2090586900: (e) => new d.IfcQuantitySet(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  3615266464: (e) => new d.IfcRectangleProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new d.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new d.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  3413951693: (e) => {
    var t;
    return new d.IfcRegularTimeSeries(new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new d.IfcDateTime((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new d.IfcDateTime((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), e[4], e[5], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 2, e[7]), new d.IfcTimeMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), ((t = e[9]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  1580146022: (e) => new d.IfcReinforcementBarProperties(new d.IfcAreaMeasure((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), e[2], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcCountMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value)),
  478536968: (e) => new d.IfcRelationship(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2943643501: (e) => {
    var t;
    return new d.IfcResourceApprovalRelationship((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3]));
  },
  1608871552: (e) => {
    var t;
    return new d.IfcResourceConstraintRelationship((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  1042787934: (e) => new d.IfcResourceTime((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), e[1], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcDuration((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcPositiveRatioMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcDateTime((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcDateTime((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcDuration((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcBoolean((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new d.IfcDateTime((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new d.IfcDuration((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new d.IfcPositiveRatioMeasure((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), (e[13] ?? void 0) === void 0 || e[13] === "" ? null : new d.IfcDateTime((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value), (e[14] ?? void 0) === void 0 || e[14] === "" ? null : new d.IfcDateTime((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value), (e[15] ?? void 0) === void 0 || e[15] === "" ? null : new d.IfcDuration((e[15] ?? void 0) === void 0 || e[15] === "" ? null : e[15].value), (e[16] ?? void 0) === void 0 || e[16] === "" ? null : new d.IfcPositiveRatioMeasure((e[16] ?? void 0) === void 0 || e[16] === "" ? null : e[16].value), (e[17] ?? void 0) === void 0 || e[17] === "" ? null : new d.IfcPositiveRatioMeasure((e[17] ?? void 0) === void 0 || e[17] === "" ? null : e[17].value)),
  2778083089: (e) => new d.IfcRoundedRectangleProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new d.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new d.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new d.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value)),
  2042790032: (e) => new d.IfcSectionProperties(e[0], new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2])),
  4165799628: (e) => {
    var t;
    return new d.IfcSectionReinforcementProperties(new d.IfcLengthMeasure((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new d.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), e[3], new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]), ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  1509187699: (e) => {
    var t, i;
    return new d.IfcSectionedSpine(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), ((t = e[1]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], ((i = e[2]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || []);
  },
  4124623270: (e) => {
    var t;
    return new d.IfcShellBasedSurfaceModel(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  3692461612: (e) => new d.IfcSimpleProperty(new d.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  2609359061: (e) => new d.IfcSlippageConnectionCondition((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  723233188: (e) => new d.IfcSolidModel(),
  1595516126: (e) => new d.IfcStructuralLoadLinearForce((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLinearForceMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLinearForceMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcLinearForceMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLinearMomentMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcLinearMomentMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcLinearMomentMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  2668620305: (e) => new d.IfcStructuralLoadPlanarForce((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcPlanarForceMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcPlanarForceMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcPlanarForceMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2473145415: (e) => new d.IfcStructuralLoadSingleDisplacement((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcPlaneAngleMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcPlaneAngleMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcPlaneAngleMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  1973038258: (e) => new d.IfcStructuralLoadSingleDisplacementDistortion((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcPlaneAngleMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcPlaneAngleMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcPlaneAngleMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcCurvatureMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  1597423693: (e) => new d.IfcStructuralLoadSingleForce((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcForceMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcForceMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcForceMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcTorqueMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcTorqueMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcTorqueMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  1190533807: (e) => new d.IfcStructuralLoadSingleForceWarping((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcForceMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcForceMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcForceMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcTorqueMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcTorqueMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcTorqueMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcWarpingMomentMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  2233826070: (e) => new d.IfcSubedge(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2])),
  2513912981: (e) => new d.IfcSurface(),
  1878645084: (e) => new d.IfcSurfaceStyleRendering(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcNormalisedRatioMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : Li(2, e[7]), e[8]),
  2247615214: (e) => new d.IfcSweptAreaSolid(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1])),
  1260650574: (e) => new d.IfcSweptDiskSolid(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new d.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcPositiveLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcParameterValue((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcParameterValue((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  1096409881: (e) => new d.IfcSweptDiskSolidPolygonal(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new d.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcPositiveLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcParameterValue((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcParameterValue((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value)),
  230924584: (e) => new d.IfcSweptSurface(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1])),
  3071757647: (e) => new d.IfcTShapeProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new d.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new d.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new d.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new d.IfcPositiveLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcNonNegativeLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcNonNegativeLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcNonNegativeLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new d.IfcPlaneAngleMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new d.IfcPlaneAngleMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value)),
  901063453: (e) => new d.IfcTessellatedItem(),
  4282788508: (e) => new d.IfcTextLiteral(new d.IfcPresentableText((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), e[2]),
  3124975700: (e) => new d.IfcTextLiteralWithExtent(new d.IfcPresentableText((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), e[2], new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3]), new d.IfcBoxAlignment((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  1983826977: (e) => {
    var t;
    return new d.IfcTextStyleFontModel(new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new d.IfcTextFontName(i.value) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcFontStyle((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcFontVariant((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcFontWeight((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), Li(2, e[5]));
  },
  2715220739: (e) => new d.IfcTrapeziumProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new d.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new d.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new d.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new d.IfcLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  1628702193: (e) => {
    var t;
    return new d.IfcTypeObject(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  3736923433: (e) => {
    var t;
    return new d.IfcTypeProcess(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcIdentifier((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcText((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  2347495698: (e) => {
    var t, i;
    return new d.IfcTypeProduct(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value));
  },
  3698973494: (e) => {
    var t;
    return new d.IfcTypeResource(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcIdentifier((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcText((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  427810014: (e) => new d.IfcUShapeProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new d.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new d.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new d.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new d.IfcPositiveLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcNonNegativeLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcNonNegativeLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcPlaneAngleMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value)),
  1417489154: (e) => new d.IfcVector(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new d.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  2759199220: (e) => new d.IfcVertexLoop(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0])),
  1299126871: (e) => {
    var t, i;
    return new d.IfcWindowStyle(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], e[9], new d.IfcBoolean((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), new d.IfcBoolean((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value));
  },
  2543172580: (e) => new d.IfcZShapeProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new d.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new d.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new d.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new d.IfcPositiveLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcNonNegativeLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcNonNegativeLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  3406155212: (e) => {
    var t;
    return new d.IfcAdvancedFace(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), new d.IfcBoolean((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value));
  },
  669184980: (e) => {
    var t;
    return new d.IfcAnnotationFillArea(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  3207858831: (e) => new d.IfcAsymmetricIShapeProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new d.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new d.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new d.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new d.IfcPositiveLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcNonNegativeLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), new d.IfcPositiveLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcPositiveLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new d.IfcNonNegativeLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new d.IfcNonNegativeLengthMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new d.IfcPlaneAngleMeasure((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), (e[13] ?? void 0) === void 0 || e[13] === "" ? null : new d.IfcNonNegativeLengthMeasure((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value), (e[14] ?? void 0) === void 0 || e[14] === "" ? null : new d.IfcPlaneAngleMeasure((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value)),
  4261334040: (e) => new d.IfcAxis1Placement(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1])),
  3125803723: (e) => new d.IfcAxis2Placement2D(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1])),
  2740243338: (e) => new d.IfcAxis2Placement3D(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2])),
  2736907675: (e) => new d.IfcBooleanResult(e[0], new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2])),
  4182860854: (e) => new d.IfcBoundedSurface(),
  2581212453: (e) => new d.IfcBoundingBox(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new d.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new d.IfcPositiveLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new d.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2713105998: (e) => new d.IfcBoxedHalfSpace(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new d.IfcBoolean((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2])),
  2898889636: (e) => new d.IfcCShapeProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new d.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new d.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new d.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new d.IfcPositiveLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcNonNegativeLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  1123145078: (e) => {
    var t;
    return new d.IfcCartesianPoint(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new d.IfcLengthMeasure(i.value) : null)) || []);
  },
  574549367: (e) => new d.IfcCartesianPointList(),
  1675464909: (e) => {
    var t;
    return new d.IfcCartesianPointList2D((t = e[0]) == null ? void 0 : t.map((i) => (i == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new d.IfcLengthMeasure(n.value) : null)) || []));
  },
  2059837836: (e) => {
    var t;
    return new d.IfcCartesianPointList3D((t = e[0]) == null ? void 0 : t.map((i) => (i == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new d.IfcLengthMeasure(n.value) : null)) || []));
  },
  59481748: (e) => new d.IfcCartesianTransformationOperator((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcReal((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  3749851601: (e) => new d.IfcCartesianTransformationOperator2D((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcReal((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  3486308946: (e) => new d.IfcCartesianTransformationOperator2DnonUniform((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcReal((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcReal((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  3331915920: (e) => new d.IfcCartesianTransformationOperator3D((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcReal((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4])),
  1416205885: (e) => new d.IfcCartesianTransformationOperator3DnonUniform((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcReal((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcReal((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcReal((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  1383045692: (e) => new d.IfcCircleProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new d.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2205249479: (e) => {
    var t;
    return new d.IfcClosedShell(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  776857604: (e) => new d.IfcColourRgb((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new d.IfcNormalisedRatioMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new d.IfcNormalisedRatioMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new d.IfcNormalisedRatioMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2542286263: (e) => {
    var t;
    return new d.IfcComplexProperty(new d.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new d.IfcIdentifier((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  2485617015: (e) => new d.IfcCompositeCurveSegment(e[0], new d.IfcBoolean((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2])),
  2574617495: (e) => {
    var t, i;
    return new d.IfcConstructionResourceType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcIdentifier((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcText((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : ((i = e[9]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 2, e[10]));
  },
  3419103109: (e) => {
    var t;
    return new d.IfcContext(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((t = e[7]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 2, e[8]));
  },
  1815067380: (e) => {
    var t, i;
    return new d.IfcCrewResourceType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcIdentifier((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcText((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : ((i = e[9]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 2, e[10]), e[11]);
  },
  2506170314: (e) => new d.IfcCsgPrimitive3D(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0])),
  2147822146: (e) => new d.IfcCsgSolid(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0])),
  2601014836: (e) => new d.IfcCurve(),
  2827736869: (e) => {
    var t;
    return new d.IfcCurveBoundedPlane(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  2629017746: (e) => {
    var t;
    return new d.IfcCurveBoundedSurface(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], new d.IfcBoolean((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value));
  },
  32440307: (e) => {
    var t;
    return new d.IfcDirection(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new d.IfcReal(i.value) : null)) || []);
  },
  526551008: (e) => {
    var t, i;
    return new d.IfcDoorStyle(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], e[9], new d.IfcBoolean((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), new d.IfcBoolean((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value));
  },
  1472233963: (e) => {
    var t;
    return new d.IfcEdgeLoop(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  1883228015: (e) => {
    var t;
    return new d.IfcElementQuantity(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  339256511: (e) => {
    var t, i;
    return new d.IfcElementType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  2777663545: (e) => new d.IfcElementarySurface(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0])),
  2835456948: (e) => new d.IfcEllipseProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new d.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new d.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  4024345920: (e) => {
    var t;
    return new d.IfcEventType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcIdentifier((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcText((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9], e[10], (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new d.IfcLabel((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value));
  },
  477187591: (e) => new d.IfcExtrudedAreaSolid(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new d.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2804161546: (e) => new d.IfcExtrudedAreaSolidTapered(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new d.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4])),
  2047409740: (e) => {
    var t;
    return new d.IfcFaceBasedSurfaceModel(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  374418227: (e) => new d.IfcFillAreaStyleHatching(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3]), new d.IfcPlaneAngleMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  315944413: (e) => {
    var t, i;
    return new d.IfcFillAreaStyleTiles(((t = e[0]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], ((i = e[1]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], new d.IfcPositiveRatioMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value));
  },
  2652556860: (e) => new d.IfcFixedReferenceSweptAreaSolid(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcParameterValue((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcParameterValue((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5])),
  4238390223: (e) => {
    var t, i;
    return new d.IfcFurnishingElementType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  1268542332: (e) => {
    var t, i;
    return new d.IfcFurnitureType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9], e[10]);
  },
  4095422895: (e) => {
    var t, i;
    return new d.IfcGeographicElementType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  987898635: (e) => {
    var t;
    return new d.IfcGeometricCurveSet(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  1484403080: (e) => new d.IfcIShapeProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new d.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new d.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new d.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new d.IfcPositiveLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcNonNegativeLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcNonNegativeLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcPlaneAngleMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value)),
  178912537: (e) => {
    var t;
    return new d.IfcIndexedPolygonalFace(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new d.IfcPositiveInteger(i.value) : null)) || []);
  },
  2294589976: (e) => {
    var t, i;
    return new d.IfcIndexedPolygonalFaceWithVoids(((t = e[0]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new d.IfcPositiveInteger(n.value) : null)) || [], (i = e[1]) == null ? void 0 : i.map((n) => (n == null ? void 0 : n.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new d.IfcPositiveInteger(s.value) : null)) || []));
  },
  572779678: (e) => new d.IfcLShapeProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new d.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new d.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcNonNegativeLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcNonNegativeLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcPlaneAngleMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  428585644: (e) => {
    var t, i;
    return new d.IfcLaborResourceType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcIdentifier((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcText((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : ((i = e[9]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 2, e[10]), e[11]);
  },
  1281925730: (e) => new d.IfcLine(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1])),
  1425443689: (e) => new d.IfcManifoldSolidBrep(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0])),
  3888040117: (e) => new d.IfcObject(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  3388369263: (e) => new d.IfcOffsetCurve2D(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new d.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new d.IfcLogical((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  3505215534: (e) => new d.IfcOffsetCurve3D(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new d.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new d.IfcLogical((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3])),
  1682466193: (e) => new d.IfcPcurve(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1])),
  603570806: (e) => new d.IfcPlanarBox(new d.IfcLengthMeasure((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new d.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2])),
  220341763: (e) => new d.IfcPlane(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0])),
  759155922: (e) => new d.IfcPreDefinedColour(new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  2559016684: (e) => new d.IfcPreDefinedCurveFont(new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  3967405729: (e) => new d.IfcPreDefinedPropertySet(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  569719735: (e) => {
    var t;
    return new d.IfcProcedureType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcIdentifier((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcText((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2945172077: (e) => new d.IfcProcess(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcText((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  4208778838: (e) => new d.IfcProduct(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6])),
  103090709: (e) => {
    var t;
    return new d.IfcProject(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((t = e[7]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 2, e[8]));
  },
  653396225: (e) => {
    var t;
    return new d.IfcProjectLibrary(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((t = e[7]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 2, e[8]));
  },
  871118103: (e) => new d.IfcPropertyBoundedValue(new d.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : Li(2, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : Li(2, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : Li(2, e[5])),
  4166981789: (e) => {
    var t;
    return new d.IfcPropertyEnumeratedValue(new d.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? Li(2, i) : null)) || [], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3]));
  },
  2752243245: (e) => {
    var t;
    return new d.IfcPropertyListValue(new d.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? Li(2, i) : null)) || [], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3]));
  },
  941946838: (e) => new d.IfcPropertyReferenceValue(new d.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcText((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3])),
  1451395588: (e) => {
    var t;
    return new d.IfcPropertySet(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  492091185: (e) => {
    var t;
    return new d.IfcPropertySetTemplate(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), e[4], (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), ((t = e[6]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  3650150729: (e) => new d.IfcPropertySingleValue(new d.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : Li(2, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 2, e[3])),
  110355661: (e) => {
    var t, i;
    return new d.IfcPropertyTableValue(new d.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : ((t = e[2]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? Li(2, n) : null)) || [], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : ((i = e[3]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? Li(2, n) : null)) || [], (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcText((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), e[7]);
  },
  3521284610: (e) => new d.IfcPropertyTemplate(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  3219374653: (e) => new d.IfcProxy(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), e[7], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  2770003689: (e) => new d.IfcRectangleHollowProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new d.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new d.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new d.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcNonNegativeLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcNonNegativeLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  2798486643: (e) => new d.IfcRectangularPyramid(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new d.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new d.IfcPositiveLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new d.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  3454111270: (e) => new d.IfcRectangularTrimmedSurface(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new d.IfcParameterValue((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new d.IfcParameterValue((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new d.IfcParameterValue((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new d.IfcParameterValue((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new d.IfcBoolean((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new d.IfcBoolean((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  3765753017: (e) => {
    var t;
    return new d.IfcReinforcementDefinitionProperties(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  3939117080: (e) => {
    var t;
    return new d.IfcRelAssigns(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], e[5]);
  },
  1683148259: (e) => {
    var t;
    return new d.IfcRelAssignsToActor(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], e[5], new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 2, e[7]));
  },
  2495723537: (e) => {
    var t;
    return new d.IfcRelAssignsToControl(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], e[5], new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]));
  },
  1307041759: (e) => {
    var t;
    return new d.IfcRelAssignsToGroup(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], e[5], new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]));
  },
  1027710054: (e) => {
    var t;
    return new d.IfcRelAssignsToGroupByFactor(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], e[5], new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), new d.IfcRatioMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value));
  },
  4278684876: (e) => {
    var t;
    return new d.IfcRelAssignsToProcess(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], e[5], new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 2, e[7]));
  },
  2857406711: (e) => {
    var t;
    return new d.IfcRelAssignsToProduct(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], e[5], new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]));
  },
  205026976: (e) => {
    var t;
    return new d.IfcRelAssignsToResource(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], e[5], new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]));
  },
  1865459582: (e) => {
    var t;
    return new d.IfcRelAssociates(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  4095574036: (e) => {
    var t;
    return new d.IfcRelAssociatesApproval(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]));
  },
  919958153: (e) => {
    var t;
    return new d.IfcRelAssociatesClassification(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]));
  },
  2728634034: (e) => {
    var t;
    return new d.IfcRelAssociatesConstraint(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]));
  },
  982818633: (e) => {
    var t;
    return new d.IfcRelAssociatesDocument(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]));
  },
  3840914261: (e) => {
    var t;
    return new d.IfcRelAssociatesLibrary(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]));
  },
  2655215786: (e) => {
    var t;
    return new d.IfcRelAssociatesMaterial(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]));
  },
  826625072: (e) => new d.IfcRelConnects(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  1204542856: (e) => new d.IfcRelConnectsElements(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6])),
  3945020480: (e) => {
    var t, i;
    return new d.IfcRelConnectsPathElements(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((t = e[7]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new d.IfcInteger(n.value) : null)) || [], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : ((i = e[8]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new d.IfcInteger(n.value) : null)) || [], e[9], e[10]);
  },
  4201705270: (e) => new d.IfcRelConnectsPortToElement(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5])),
  3190031847: (e) => new d.IfcRelConnectsPorts(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6])),
  2127690289: (e) => new d.IfcRelConnectsStructuralActivity(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5])),
  1638771189: (e) => new d.IfcRelConnectsStructuralMember(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 2, e[7]), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 2, e[9])),
  504942748: (e) => new d.IfcRelConnectsWithEccentricity(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 2, e[7]), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 2, e[9]), new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 2, e[10])),
  3678494232: (e) => {
    var t;
    return new d.IfcRelConnectsWithRealizingElements(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), ((t = e[7]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  3242617779: (e) => {
    var t;
    return new d.IfcRelContainedInSpatialStructure(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]));
  },
  886880790: (e) => {
    var t;
    return new d.IfcRelCoversBldgElements(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]), ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  2802773753: (e) => {
    var t;
    return new d.IfcRelCoversSpaces(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]), ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  2565941209: (e) => {
    var t;
    return new d.IfcRelDeclares(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]), ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  2551354335: (e) => new d.IfcRelDecomposes(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  693640335: (e) => new d.IfcRelDefines(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  1462361463: (e) => {
    var t;
    return new d.IfcRelDefinesByObject(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]));
  },
  4186316022: (e) => {
    var t;
    return new d.IfcRelDefinesByProperties(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]));
  },
  307848117: (e) => {
    var t;
    return new d.IfcRelDefinesByTemplate(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]));
  },
  781010003: (e) => {
    var t;
    return new d.IfcRelDefinesByType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]));
  },
  3940055652: (e) => new d.IfcRelFillsElement(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5])),
  279856033: (e) => {
    var t;
    return new d.IfcRelFlowControlElements(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]));
  },
  427948657: (e) => new d.IfcRelInterferesElements(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value),
  3268803585: (e) => {
    var t;
    return new d.IfcRelNests(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]), ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  750771296: (e) => new d.IfcRelProjectsElement(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5])),
  1245217292: (e) => {
    var t;
    return new d.IfcRelReferencedInSpatialStructure(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]));
  },
  4122056220: (e) => new d.IfcRelSequence(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), e[7], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  366585022: (e) => {
    var t;
    return new d.IfcRelServicesBuildings(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]), ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  3451746338: (e) => new d.IfcRelSpaceBoundary(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), e[7], e[8]),
  3523091289: (e) => new d.IfcRelSpaceBoundary1stLevel(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), e[7], e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 2, e[9])),
  1521410863: (e) => new d.IfcRelSpaceBoundary2ndLevel(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), e[7], e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 2, e[9]), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 2, e[10])),
  1401173127: (e) => new d.IfcRelVoidsElement(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5])),
  816062949: (e) => new d.IfcReparametrisedCompositeCurveSegment(e[0], new d.IfcBoolean((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new d.IfcParameterValue((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2914609552: (e) => new d.IfcResource(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcText((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  1856042241: (e) => new d.IfcRevolvedAreaSolid(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new d.IfcPlaneAngleMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  3243963512: (e) => new d.IfcRevolvedAreaSolidTapered(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new d.IfcPlaneAngleMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4])),
  4158566097: (e) => new d.IfcRightCircularCone(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new d.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new d.IfcPositiveLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  3626867408: (e) => new d.IfcRightCircularCylinder(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new d.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new d.IfcPositiveLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  3663146110: (e) => new d.IfcSimplePropertyTemplate(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), e[4], (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 2, e[7]), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 2, e[8]), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 2, e[9]), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new d.IfcLabel((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), e[11]),
  1412071761: (e) => new d.IfcSpatialElement(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  710998568: (e) => {
    var t, i;
    return new d.IfcSpatialElementType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  2706606064: (e) => new d.IfcSpatialStructureElement(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3893378262: (e) => {
    var t, i;
    return new d.IfcSpatialStructureElementType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  463610769: (e) => new d.IfcSpatialZone(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2481509218: (e) => {
    var t, i;
    return new d.IfcSpatialZoneType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new d.IfcLabel((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value));
  },
  451544542: (e) => new d.IfcSphere(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new d.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  4015995234: (e) => new d.IfcSphericalSurface(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new d.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  3544373492: (e) => new d.IfcStructuralActivity(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 2, e[7]), e[8]),
  3136571912: (e) => new d.IfcStructuralItem(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6])),
  530289379: (e) => new d.IfcStructuralMember(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6])),
  3689010777: (e) => new d.IfcStructuralReaction(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 2, e[7]), e[8]),
  3979015343: (e) => new d.IfcStructuralSurfaceMember(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), e[7], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcPositiveLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  2218152070: (e) => new d.IfcStructuralSurfaceMemberVarying(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), e[7], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcPositiveLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  603775116: (e) => new d.IfcStructuralSurfaceReaction(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 2, e[7]), e[8], e[9]),
  4095615324: (e) => {
    var t, i;
    return new d.IfcSubContractResourceType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcIdentifier((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcText((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : ((i = e[9]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 2, e[10]), e[11]);
  },
  699246055: (e) => {
    var t;
    return new d.IfcSurfaceCurve(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], e[2]);
  },
  2028607225: (e) => new d.IfcSurfaceCurveSweptAreaSolid(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcParameterValue((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcParameterValue((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5])),
  2809605785: (e) => new d.IfcSurfaceOfLinearExtrusion(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new d.IfcLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  4124788165: (e) => new d.IfcSurfaceOfRevolution(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2])),
  1580310250: (e) => {
    var t, i;
    return new d.IfcSystemFurnitureElementType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3473067441: (e) => new d.IfcTask(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcText((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), new d.IfcBoolean((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new d.IfcInteger((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new u((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value, 2, e[11]), e[12]),
  3206491090: (e) => {
    var t;
    return new d.IfcTaskType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcIdentifier((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcText((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new d.IfcLabel((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value));
  },
  2387106220: (e) => new d.IfcTessellatedFaceSet(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0])),
  1935646853: (e) => new d.IfcToroidalSurface(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new d.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new d.IfcPositiveLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  2097647324: (e) => {
    var t, i;
    return new d.IfcTransportElementType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2916149573: (e) => {
    var t, i, n;
    return new d.IfcTriangulatedFaceSet(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : (t = e[1]) == null ? void 0 : t.map((s) => (s == null ? void 0 : s.map((o) => ((o == null ? void 0 : o.value) ?? void 0) !== void 0 && (o == null ? void 0 : o.value) !== "" ? new d.IfcParameterValue(o.value) : null)) || []), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcBoolean((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (i = e[3]) == null ? void 0 : i.map((s) => (s == null ? void 0 : s.map((o) => ((o == null ? void 0 : o.value) ?? void 0) !== void 0 && (o == null ? void 0 : o.value) !== "" ? new d.IfcPositiveInteger(o.value) : null)) || []), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : ((n = e[4]) == null ? void 0 : n.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new d.IfcPositiveInteger(s.value) : null)) || []);
  },
  336235671: (e) => new d.IfcWindowLiningProperties(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcNonNegativeLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcNonNegativeLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcNonNegativeLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcNormalisedRatioMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcNormalisedRatioMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new d.IfcNormalisedRatioMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new d.IfcNormalisedRatioMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new u((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value, 2, e[12]), (e[13] ?? void 0) === void 0 || e[13] === "" ? null : new d.IfcLengthMeasure((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value), (e[14] ?? void 0) === void 0 || e[14] === "" ? null : new d.IfcLengthMeasure((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value), (e[15] ?? void 0) === void 0 || e[15] === "" ? null : new d.IfcLengthMeasure((e[15] ?? void 0) === void 0 || e[15] === "" ? null : e[15].value)),
  512836454: (e) => new d.IfcWindowPanelProperties(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), e[4], e[5], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcPositiveLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcPositiveLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 2, e[8])),
  2296667514: (e) => new d.IfcActor(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5])),
  1635779807: (e) => new d.IfcAdvancedBrep(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0])),
  2603310189: (e) => {
    var t;
    return new d.IfcAdvancedBrepWithVoids(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  1674181508: (e) => new d.IfcAnnotation(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6])),
  2887950389: (e) => {
    var t;
    return new d.IfcBSplineSurface(new d.IfcInteger((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new d.IfcInteger((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (t = e[2]) == null ? void 0 : t.map((i) => (i == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || []), e[3], new d.IfcLogical((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new d.IfcLogical((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new d.IfcLogical((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value));
  },
  167062518: (e) => {
    var t, i, n, s, o;
    return new d.IfcBSplineSurfaceWithKnots(new d.IfcInteger((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new d.IfcInteger((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (t = e[2]) == null ? void 0 : t.map((r) => (r == null ? void 0 : r.map((l) => ((l == null ? void 0 : l.value) ?? void 0) !== void 0 && (l == null ? void 0 : l.value) !== "" ? new u(l.value, 2, l) : null)) || []), e[3], new d.IfcLogical((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new d.IfcLogical((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new d.IfcLogical((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), ((i = e[7]) == null ? void 0 : i.map((r) => ((r == null ? void 0 : r.value) ?? void 0) !== void 0 && (r == null ? void 0 : r.value) !== "" ? new d.IfcInteger(r.value) : null)) || [], ((n = e[8]) == null ? void 0 : n.map((r) => ((r == null ? void 0 : r.value) ?? void 0) !== void 0 && (r == null ? void 0 : r.value) !== "" ? new d.IfcInteger(r.value) : null)) || [], ((s = e[9]) == null ? void 0 : s.map((r) => ((r == null ? void 0 : r.value) ?? void 0) !== void 0 && (r == null ? void 0 : r.value) !== "" ? new d.IfcParameterValue(r.value) : null)) || [], ((o = e[10]) == null ? void 0 : o.map((r) => ((r == null ? void 0 : r.value) ?? void 0) !== void 0 && (r == null ? void 0 : r.value) !== "" ? new d.IfcParameterValue(r.value) : null)) || [], e[11]);
  },
  1334484129: (e) => new d.IfcBlock(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new d.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new d.IfcPositiveLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new d.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  3649129432: (e) => new d.IfcBooleanClippingResult(e[0], new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2])),
  1260505505: (e) => new d.IfcBoundedCurve(),
  4031249490: (e) => new d.IfcBuilding(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new d.IfcLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new u((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value, 2, e[11])),
  1950629157: (e) => {
    var t, i;
    return new d.IfcBuildingElementType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  3124254112: (e) => new d.IfcBuildingStorey(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value)),
  2197970202: (e) => {
    var t, i;
    return new d.IfcChimneyType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2937912522: (e) => new d.IfcCircleHollowProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 2, e[2]), new d.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new d.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  3893394355: (e) => {
    var t, i;
    return new d.IfcCivilElementType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  300633059: (e) => {
    var t, i;
    return new d.IfcColumnType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3875453745: (e) => {
    var t;
    return new d.IfcComplexPropertyTemplate(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), e[5], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((t = e[6]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  3732776249: (e) => {
    var t;
    return new d.IfcCompositeCurve(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], new d.IfcLogical((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value));
  },
  15328376: (e) => {
    var t;
    return new d.IfcCompositeCurveOnSurface(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], new d.IfcLogical((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value));
  },
  2510884976: (e) => new d.IfcConic(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0])),
  2185764099: (e) => {
    var t, i;
    return new d.IfcConstructionEquipmentResourceType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcIdentifier((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcText((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : ((i = e[9]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 2, e[10]), e[11]);
  },
  4105962743: (e) => {
    var t, i;
    return new d.IfcConstructionMaterialResourceType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcIdentifier((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcText((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : ((i = e[9]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 2, e[10]), e[11]);
  },
  1525564444: (e) => {
    var t, i;
    return new d.IfcConstructionProductResourceType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcIdentifier((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcText((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : ((i = e[9]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 2, e[10]), e[11]);
  },
  2559216714: (e) => {
    var t;
    return new d.IfcConstructionResource(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcText((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 2, e[7]), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : ((t = e[8]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 2, e[9]));
  },
  3293443760: (e) => new d.IfcControl(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value)),
  3895139033: (e) => {
    var t, i;
    return new d.IfcCostItem(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), e[6], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((t = e[7]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : ((i = e[8]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || []);
  },
  1419761937: (e) => new d.IfcCostSchedule(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), e[6], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcDateTime((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcDateTime((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value)),
  1916426348: (e) => {
    var t, i;
    return new d.IfcCoveringType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3295246426: (e) => {
    var t;
    return new d.IfcCrewResource(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcText((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 2, e[7]), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : ((t = e[8]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 2, e[9]), e[10]);
  },
  1457835157: (e) => {
    var t, i;
    return new d.IfcCurtainWallType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1213902940: (e) => new d.IfcCylindricalSurface(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new d.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  3256556792: (e) => {
    var t, i;
    return new d.IfcDistributionElementType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  3849074793: (e) => {
    var t, i;
    return new d.IfcDistributionFlowElementType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  2963535650: (e) => new d.IfcDoorLiningProperties(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcNonNegativeLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcPositiveLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcNonNegativeLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcNonNegativeLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new d.IfcLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new d.IfcLengthMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new d.IfcPositiveLengthMeasure((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), (e[13] ?? void 0) === void 0 || e[13] === "" ? null : new d.IfcPositiveLengthMeasure((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value), (e[14] ?? void 0) === void 0 || e[14] === "" ? null : new u((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value, 2, e[14]), (e[15] ?? void 0) === void 0 || e[15] === "" ? null : new d.IfcLengthMeasure((e[15] ?? void 0) === void 0 || e[15] === "" ? null : e[15].value), (e[16] ?? void 0) === void 0 || e[16] === "" ? null : new d.IfcLengthMeasure((e[16] ?? void 0) === void 0 || e[16] === "" ? null : e[16].value)),
  1714330368: (e) => new d.IfcDoorPanelProperties(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), e[5], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcNormalisedRatioMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), e[7], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 2, e[8])),
  2323601079: (e) => {
    var t, i;
    return new d.IfcDoorType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9], e[10], (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new d.IfcBoolean((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new d.IfcLabel((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value));
  },
  445594917: (e) => new d.IfcDraughtingPreDefinedColour(new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  4006246654: (e) => new d.IfcDraughtingPreDefinedCurveFont(new d.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  1758889154: (e) => new d.IfcElement(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  4123344466: (e) => new d.IfcElementAssembly(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], e[9]),
  2397081782: (e) => {
    var t, i;
    return new d.IfcElementAssemblyType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1623761950: (e) => new d.IfcElementComponent(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  2590856083: (e) => {
    var t, i;
    return new d.IfcElementComponentType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  1704287377: (e) => new d.IfcEllipse(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new d.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new d.IfcPositiveLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  2107101300: (e) => {
    var t, i;
    return new d.IfcEnergyConversionDeviceType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  132023988: (e) => {
    var t, i;
    return new d.IfcEngineType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3174744832: (e) => {
    var t, i;
    return new d.IfcEvaporativeCoolerType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3390157468: (e) => {
    var t, i;
    return new d.IfcEvaporatorType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  4148101412: (e) => new d.IfcEvent(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcText((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), e[7], e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcLabel((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 2, e[10])),
  2853485674: (e) => new d.IfcExternalSpatialStructureElement(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  807026263: (e) => new d.IfcFacetedBrep(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0])),
  3737207727: (e) => {
    var t;
    return new d.IfcFacetedBrepWithVoids(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  647756555: (e) => new d.IfcFastener(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2489546625: (e) => {
    var t, i;
    return new d.IfcFastenerType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2827207264: (e) => new d.IfcFeatureElement(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  2143335405: (e) => new d.IfcFeatureElementAddition(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  1287392070: (e) => new d.IfcFeatureElementSubtraction(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  3907093117: (e) => {
    var t, i;
    return new d.IfcFlowControllerType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  3198132628: (e) => {
    var t, i;
    return new d.IfcFlowFittingType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  3815607619: (e) => {
    var t, i;
    return new d.IfcFlowMeterType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1482959167: (e) => {
    var t, i;
    return new d.IfcFlowMovingDeviceType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  1834744321: (e) => {
    var t, i;
    return new d.IfcFlowSegmentType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  1339347760: (e) => {
    var t, i;
    return new d.IfcFlowStorageDeviceType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  2297155007: (e) => {
    var t, i;
    return new d.IfcFlowTerminalType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  3009222698: (e) => {
    var t, i;
    return new d.IfcFlowTreatmentDeviceType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  1893162501: (e) => {
    var t, i;
    return new d.IfcFootingType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  263784265: (e) => new d.IfcFurnishingElement(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  1509553395: (e) => new d.IfcFurniture(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3493046030: (e) => new d.IfcGeographicElement(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3009204131: (e) => {
    var t, i, n;
    return new d.IfcGrid(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), ((t = e[7]) == null ? void 0 : t.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new u(s.value, 2, s) : null)) || [], ((i = e[8]) == null ? void 0 : i.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new u(s.value, 2, s) : null)) || [], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : ((n = e[9]) == null ? void 0 : n.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new u(s.value, 2, s) : null)) || [], e[10]);
  },
  2706460486: (e) => new d.IfcGroup(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  1251058090: (e) => {
    var t, i;
    return new d.IfcHeatExchangerType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1806887404: (e) => {
    var t, i;
    return new d.IfcHumidifierType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2571569899: (e) => {
    var t;
    return new d.IfcIndexedPolyCurve(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? Li(2, i) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcBoolean((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value));
  },
  3946677679: (e) => {
    var t, i;
    return new d.IfcInterceptorType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3113134337: (e) => {
    var t;
    return new d.IfcIntersectionCurve(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], e[2]);
  },
  2391368822: (e) => {
    var t;
    return new d.IfcInventory(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), e[5], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((t = e[7]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcDate((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 2, e[9]), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 2, e[10]));
  },
  4288270099: (e) => {
    var t, i;
    return new d.IfcJunctionBoxType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3827777499: (e) => {
    var t;
    return new d.IfcLaborResource(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcText((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 2, e[7]), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : ((t = e[8]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 2, e[9]), e[10]);
  },
  1051575348: (e) => {
    var t, i;
    return new d.IfcLampType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1161773419: (e) => {
    var t, i;
    return new d.IfcLightFixtureType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  377706215: (e) => new d.IfcMechanicalFastener(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcPositiveLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcPositiveLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), e[10]),
  2108223431: (e) => {
    var t, i;
    return new d.IfcMechanicalFastenerType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new d.IfcPositiveLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new d.IfcPositiveLengthMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value));
  },
  1114901282: (e) => {
    var t, i;
    return new d.IfcMedicalDeviceType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3181161470: (e) => {
    var t, i;
    return new d.IfcMemberType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  977012517: (e) => {
    var t, i;
    return new d.IfcMotorConnectionType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  4143007308: (e) => new d.IfcOccupant(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), e[6]),
  3588315303: (e) => new d.IfcOpeningElement(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3079942009: (e) => new d.IfcOpeningStandardCase(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2837617999: (e) => {
    var t, i;
    return new d.IfcOutletType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2382730787: (e) => new d.IfcPerformanceHistory(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new d.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), e[7]),
  3566463478: (e) => new d.IfcPermeableCoveringProperties(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), e[4], e[5], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcPositiveLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcPositiveLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 2, e[8])),
  3327091369: (e) => new d.IfcPermit(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), e[6], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcText((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  1158309216: (e) => {
    var t, i;
    return new d.IfcPileType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  804291784: (e) => {
    var t, i;
    return new d.IfcPipeFittingType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  4231323485: (e) => {
    var t, i;
    return new d.IfcPipeSegmentType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  4017108033: (e) => {
    var t, i;
    return new d.IfcPlateType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2839578677: (e) => {
    var t, i;
    return new d.IfcPolygonalFaceSet(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new d.IfcBoolean((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : ((i = e[3]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new d.IfcPositiveInteger(n.value) : null)) || []);
  },
  3724593414: (e) => {
    var t;
    return new d.IfcPolyline(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  3740093272: (e) => new d.IfcPort(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6])),
  2744685151: (e) => new d.IfcProcedure(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcText((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), e[7]),
  2904328755: (e) => new d.IfcProjectOrder(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), e[6], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcText((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  3651124850: (e) => new d.IfcProjectionElement(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1842657554: (e) => {
    var t, i;
    return new d.IfcProtectiveDeviceType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2250791053: (e) => {
    var t, i;
    return new d.IfcPumpType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2893384427: (e) => {
    var t, i;
    return new d.IfcRailingType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2324767716: (e) => {
    var t, i;
    return new d.IfcRampFlightType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1469900589: (e) => {
    var t, i;
    return new d.IfcRampType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  683857671: (e) => {
    var t, i, n, s, o, r;
    return new d.IfcRationalBSplineSurfaceWithKnots(new d.IfcInteger((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new d.IfcInteger((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (t = e[2]) == null ? void 0 : t.map((l) => (l == null ? void 0 : l.map((c) => ((c == null ? void 0 : c.value) ?? void 0) !== void 0 && (c == null ? void 0 : c.value) !== "" ? new u(c.value, 2, c) : null)) || []), e[3], new d.IfcLogical((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new d.IfcLogical((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new d.IfcLogical((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), ((i = e[7]) == null ? void 0 : i.map((l) => ((l == null ? void 0 : l.value) ?? void 0) !== void 0 && (l == null ? void 0 : l.value) !== "" ? new d.IfcInteger(l.value) : null)) || [], ((n = e[8]) == null ? void 0 : n.map((l) => ((l == null ? void 0 : l.value) ?? void 0) !== void 0 && (l == null ? void 0 : l.value) !== "" ? new d.IfcInteger(l.value) : null)) || [], ((s = e[9]) == null ? void 0 : s.map((l) => ((l == null ? void 0 : l.value) ?? void 0) !== void 0 && (l == null ? void 0 : l.value) !== "" ? new d.IfcParameterValue(l.value) : null)) || [], ((o = e[10]) == null ? void 0 : o.map((l) => ((l == null ? void 0 : l.value) ?? void 0) !== void 0 && (l == null ? void 0 : l.value) !== "" ? new d.IfcParameterValue(l.value) : null)) || [], e[11], (r = e[12]) == null ? void 0 : r.map((l) => (l == null ? void 0 : l.map((c) => ((c == null ? void 0 : c.value) ?? void 0) !== void 0 && (c == null ? void 0 : c.value) !== "" ? new d.IfcReal(c.value) : null)) || []));
  },
  3027567501: (e) => new d.IfcReinforcingElement(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  964333572: (e) => {
    var t, i;
    return new d.IfcReinforcingElementType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  2320036040: (e) => new d.IfcReinforcingMesh(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcPositiveLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new d.IfcPositiveLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new d.IfcPositiveLengthMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new d.IfcPositiveLengthMeasure((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), (e[13] ?? void 0) === void 0 || e[13] === "" ? null : new d.IfcAreaMeasure((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value), (e[14] ?? void 0) === void 0 || e[14] === "" ? null : new d.IfcAreaMeasure((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value), (e[15] ?? void 0) === void 0 || e[15] === "" ? null : new d.IfcPositiveLengthMeasure((e[15] ?? void 0) === void 0 || e[15] === "" ? null : e[15].value), (e[16] ?? void 0) === void 0 || e[16] === "" ? null : new d.IfcPositiveLengthMeasure((e[16] ?? void 0) === void 0 || e[16] === "" ? null : e[16].value), e[17]),
  2310774935: (e) => {
    var t, i, n;
    return new d.IfcReinforcingMeshType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new u(s.value, 2, s) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new u(s.value, 2, s) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new d.IfcPositiveLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new d.IfcPositiveLengthMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new d.IfcPositiveLengthMeasure((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), (e[13] ?? void 0) === void 0 || e[13] === "" ? null : new d.IfcPositiveLengthMeasure((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value), (e[14] ?? void 0) === void 0 || e[14] === "" ? null : new d.IfcAreaMeasure((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value), (e[15] ?? void 0) === void 0 || e[15] === "" ? null : new d.IfcAreaMeasure((e[15] ?? void 0) === void 0 || e[15] === "" ? null : e[15].value), (e[16] ?? void 0) === void 0 || e[16] === "" ? null : new d.IfcPositiveLengthMeasure((e[16] ?? void 0) === void 0 || e[16] === "" ? null : e[16].value), (e[17] ?? void 0) === void 0 || e[17] === "" ? null : new d.IfcPositiveLengthMeasure((e[17] ?? void 0) === void 0 || e[17] === "" ? null : e[17].value), (e[18] ?? void 0) === void 0 || e[18] === "" ? null : new d.IfcLabel((e[18] ?? void 0) === void 0 || e[18] === "" ? null : e[18].value), (e[19] ?? void 0) === void 0 || e[19] === "" ? null : ((n = e[19]) == null ? void 0 : n.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? Li(2, s) : null)) || []);
  },
  160246688: (e) => {
    var t;
    return new d.IfcRelAggregates(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 2, e[4]), ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || []);
  },
  2781568857: (e) => {
    var t, i;
    return new d.IfcRoofType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1768891740: (e) => {
    var t, i;
    return new d.IfcSanitaryTerminalType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2157484638: (e) => {
    var t;
    return new d.IfcSeamCurve(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], e[2]);
  },
  4074543187: (e) => {
    var t, i;
    return new d.IfcShadingDeviceType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  4097777520: (e) => new d.IfcSite(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcCompoundPlaneAngleMeasure(e[9].map((t) => t.value)), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new d.IfcCompoundPlaneAngleMeasure(e[10].map((t) => t.value)), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new d.IfcLengthMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new d.IfcLabel((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), (e[13] ?? void 0) === void 0 || e[13] === "" ? null : new u((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value, 2, e[13])),
  2533589738: (e) => {
    var t, i;
    return new d.IfcSlabType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1072016465: (e) => {
    var t, i;
    return new d.IfcSolarDeviceType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3856911033: (e) => new d.IfcSpace(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], e[9], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new d.IfcLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value)),
  1305183839: (e) => {
    var t, i;
    return new d.IfcSpaceHeaterType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3812236995: (e) => {
    var t, i;
    return new d.IfcSpaceType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new d.IfcLabel((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value));
  },
  3112655638: (e) => {
    var t, i;
    return new d.IfcStackTerminalType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1039846685: (e) => {
    var t, i;
    return new d.IfcStairFlightType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  338393293: (e) => {
    var t, i;
    return new d.IfcStairType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  682877961: (e) => new d.IfcStructuralAction(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 2, e[7]), e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcBoolean((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value)),
  1179482911: (e) => new d.IfcStructuralConnection(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 2, e[7])),
  1004757350: (e) => new d.IfcStructuralCurveAction(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 2, e[7]), e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcBoolean((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), e[10], e[11]),
  4243806635: (e) => new d.IfcStructuralCurveConnection(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 2, e[7]), new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 2, e[8])),
  214636428: (e) => new d.IfcStructuralCurveMember(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), e[7], new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 2, e[8])),
  2445595289: (e) => new d.IfcStructuralCurveMemberVarying(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), e[7], new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 2, e[8])),
  2757150158: (e) => new d.IfcStructuralCurveReaction(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 2, e[7]), e[8], e[9]),
  1807405624: (e) => new d.IfcStructuralLinearAction(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 2, e[7]), e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcBoolean((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), e[10], e[11]),
  1252848954: (e) => new d.IfcStructuralLoadGroup(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), e[5], e[6], e[7], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcRatioMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcLabel((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value)),
  2082059205: (e) => new d.IfcStructuralPointAction(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 2, e[7]), e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcBoolean((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value)),
  734778138: (e) => new d.IfcStructuralPointConnection(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 2, e[7]), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 2, e[8])),
  1235345126: (e) => new d.IfcStructuralPointReaction(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 2, e[7]), e[8]),
  2986769608: (e) => new d.IfcStructuralResultGroup(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), e[5], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), new d.IfcBoolean((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  3657597509: (e) => new d.IfcStructuralSurfaceAction(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 2, e[7]), e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcBoolean((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), e[10], e[11]),
  1975003073: (e) => new d.IfcStructuralSurfaceConnection(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 2, e[7])),
  148013059: (e) => {
    var t;
    return new d.IfcSubContractResource(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcText((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 2, e[7]), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : ((t = e[8]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 2, e[9]), e[10]);
  },
  3101698114: (e) => new d.IfcSurfaceFeature(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2315554128: (e) => {
    var t, i;
    return new d.IfcSwitchingDeviceType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2254336722: (e) => new d.IfcSystem(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  413509423: (e) => new d.IfcSystemFurnitureElement(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  5716631: (e) => {
    var t, i;
    return new d.IfcTankType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3824725483: (e) => new d.IfcTendon(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new d.IfcPositiveLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new d.IfcAreaMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new d.IfcForceMeasure((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), (e[13] ?? void 0) === void 0 || e[13] === "" ? null : new d.IfcPressureMeasure((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value), (e[14] ?? void 0) === void 0 || e[14] === "" ? null : new d.IfcNormalisedRatioMeasure((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value), (e[15] ?? void 0) === void 0 || e[15] === "" ? null : new d.IfcPositiveLengthMeasure((e[15] ?? void 0) === void 0 || e[15] === "" ? null : e[15].value), (e[16] ?? void 0) === void 0 || e[16] === "" ? null : new d.IfcPositiveLengthMeasure((e[16] ?? void 0) === void 0 || e[16] === "" ? null : e[16].value)),
  2347447852: (e) => new d.IfcTendonAnchor(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]),
  3081323446: (e) => {
    var t, i;
    return new d.IfcTendonAnchorType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2415094496: (e) => {
    var t, i;
    return new d.IfcTendonType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new d.IfcPositiveLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new d.IfcAreaMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new d.IfcPositiveLengthMeasure((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value));
  },
  1692211062: (e) => {
    var t, i;
    return new d.IfcTransformerType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1620046519: (e) => new d.IfcTransportElement(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3593883385: (e) => {
    var t, i;
    return new d.IfcTrimmedCurve(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), ((t = e[1]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], ((i = e[2]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], new d.IfcBoolean((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), e[4]);
  },
  1600972822: (e) => {
    var t, i;
    return new d.IfcTubeBundleType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1911125066: (e) => {
    var t, i;
    return new d.IfcUnitaryEquipmentType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  728799441: (e) => {
    var t, i;
    return new d.IfcValveType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2391383451: (e) => new d.IfcVibrationIsolator(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3313531582: (e) => {
    var t, i;
    return new d.IfcVibrationIsolatorType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2769231204: (e) => new d.IfcVirtualElement(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  926996030: (e) => new d.IfcVoidingFeature(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1898987631: (e) => {
    var t, i;
    return new d.IfcWallType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1133259667: (e) => {
    var t, i;
    return new d.IfcWasteTerminalType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  4009809668: (e) => {
    var t, i;
    return new d.IfcWindowType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9], e[10], (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new d.IfcBoolean((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new d.IfcLabel((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value));
  },
  4088093105: (e) => {
    var t, i;
    return new d.IfcWorkCalendar(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((t = e[6]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((i = e[7]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], e[8]);
  },
  1028945134: (e) => {
    var t;
    return new d.IfcWorkControl(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new d.IfcDateTime((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((t = e[7]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcDuration((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new d.IfcDuration((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), new d.IfcDateTime((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new d.IfcDateTime((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value));
  },
  4218914973: (e) => {
    var t;
    return new d.IfcWorkPlan(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new d.IfcDateTime((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((t = e[7]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcDuration((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new d.IfcDuration((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), new d.IfcDateTime((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new d.IfcDateTime((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), e[13]);
  },
  3342526732: (e) => {
    var t;
    return new d.IfcWorkSchedule(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new d.IfcDateTime((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((t = e[7]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcDuration((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new d.IfcDuration((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), new d.IfcDateTime((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new d.IfcDateTime((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), e[13]);
  },
  1033361043: (e) => new d.IfcZone(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value)),
  3821786052: (e) => new d.IfcActionRequest(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), e[6], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcText((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  1411407467: (e) => {
    var t, i;
    return new d.IfcAirTerminalBoxType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3352864051: (e) => {
    var t, i;
    return new d.IfcAirTerminalType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1871374353: (e) => {
    var t, i;
    return new d.IfcAirToAirHeatRecoveryType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3460190687: (e) => new d.IfcAsset(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 2, e[7]), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 2, e[8]), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 2, e[9]), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 2, e[10]), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new u((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value, 2, e[11]), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new d.IfcDate((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), (e[13] ?? void 0) === void 0 || e[13] === "" ? null : new u((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value, 2, e[13])),
  1532957894: (e) => {
    var t, i;
    return new d.IfcAudioVisualApplianceType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1967976161: (e) => {
    var t;
    return new d.IfcBSplineCurve(new d.IfcInteger((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], e[2], new d.IfcLogical((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new d.IfcLogical((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value));
  },
  2461110595: (e) => {
    var t, i, n;
    return new d.IfcBSplineCurveWithKnots(new d.IfcInteger((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), ((t = e[1]) == null ? void 0 : t.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new u(s.value, 2, s) : null)) || [], e[2], new d.IfcLogical((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new d.IfcLogical((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), ((i = e[5]) == null ? void 0 : i.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new d.IfcInteger(s.value) : null)) || [], ((n = e[6]) == null ? void 0 : n.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new d.IfcParameterValue(s.value) : null)) || [], e[7]);
  },
  819618141: (e) => {
    var t, i;
    return new d.IfcBeamType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  231477066: (e) => {
    var t, i;
    return new d.IfcBoilerType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1136057603: (e) => {
    var t;
    return new d.IfcBoundaryCurve(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], new d.IfcLogical((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value));
  },
  3299480353: (e) => new d.IfcBuildingElement(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  2979338954: (e) => new d.IfcBuildingElementPart(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  39481116: (e) => {
    var t, i;
    return new d.IfcBuildingElementPartType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1095909175: (e) => new d.IfcBuildingElementProxy(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1909888760: (e) => {
    var t, i;
    return new d.IfcBuildingElementProxyType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1177604601: (e) => new d.IfcBuildingSystem(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), e[5], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  2188180465: (e) => {
    var t, i;
    return new d.IfcBurnerType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  395041908: (e) => {
    var t, i;
    return new d.IfcCableCarrierFittingType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3293546465: (e) => {
    var t, i;
    return new d.IfcCableCarrierSegmentType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2674252688: (e) => {
    var t, i;
    return new d.IfcCableFittingType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1285652485: (e) => {
    var t, i;
    return new d.IfcCableSegmentType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2951183804: (e) => {
    var t, i;
    return new d.IfcChillerType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3296154744: (e) => new d.IfcChimney(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2611217952: (e) => new d.IfcCircle(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 2, e[0]), new d.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  1677625105: (e) => new d.IfcCivilElement(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  2301859152: (e) => {
    var t, i;
    return new d.IfcCoilType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  843113511: (e) => new d.IfcColumn(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  905975707: (e) => new d.IfcColumnStandardCase(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  400855858: (e) => {
    var t, i;
    return new d.IfcCommunicationsApplianceType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3850581409: (e) => {
    var t, i;
    return new d.IfcCompressorType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2816379211: (e) => {
    var t, i;
    return new d.IfcCondenserType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3898045240: (e) => {
    var t;
    return new d.IfcConstructionEquipmentResource(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcText((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 2, e[7]), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : ((t = e[8]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 2, e[9]), e[10]);
  },
  1060000209: (e) => {
    var t;
    return new d.IfcConstructionMaterialResource(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcText((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 2, e[7]), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : ((t = e[8]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 2, e[9]), e[10]);
  },
  488727124: (e) => {
    var t;
    return new d.IfcConstructionProductResource(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new d.IfcText((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 2, e[7]), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : ((t = e[8]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 2, e[9]), e[10]);
  },
  335055490: (e) => {
    var t, i;
    return new d.IfcCooledBeamType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2954562838: (e) => {
    var t, i;
    return new d.IfcCoolingTowerType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1973544240: (e) => new d.IfcCovering(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3495092785: (e) => new d.IfcCurtainWall(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3961806047: (e) => {
    var t, i;
    return new d.IfcDamperType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1335981549: (e) => new d.IfcDiscreteAccessory(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2635815018: (e) => {
    var t, i;
    return new d.IfcDiscreteAccessoryType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1599208980: (e) => {
    var t, i;
    return new d.IfcDistributionChamberElementType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2063403501: (e) => {
    var t, i;
    return new d.IfcDistributionControlElementType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  1945004755: (e) => new d.IfcDistributionElement(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  3040386961: (e) => new d.IfcDistributionFlowElement(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  3041715199: (e) => new d.IfcDistributionPort(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), e[7], e[8], e[9]),
  3205830791: (e) => new d.IfcDistributionSystem(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), e[6]),
  395920057: (e) => new d.IfcDoor(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcPositiveLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcPositiveLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), e[10], e[11], (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new d.IfcLabel((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value)),
  3242481149: (e) => new d.IfcDoorStandardCase(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcPositiveLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcPositiveLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), e[10], e[11], (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new d.IfcLabel((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value)),
  869906466: (e) => {
    var t, i;
    return new d.IfcDuctFittingType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3760055223: (e) => {
    var t, i;
    return new d.IfcDuctSegmentType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2030761528: (e) => {
    var t, i;
    return new d.IfcDuctSilencerType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  663422040: (e) => {
    var t, i;
    return new d.IfcElectricApplianceType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2417008758: (e) => {
    var t, i;
    return new d.IfcElectricDistributionBoardType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3277789161: (e) => {
    var t, i;
    return new d.IfcElectricFlowStorageDeviceType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1534661035: (e) => {
    var t, i;
    return new d.IfcElectricGeneratorType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1217240411: (e) => {
    var t, i;
    return new d.IfcElectricMotorType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  712377611: (e) => {
    var t, i;
    return new d.IfcElectricTimeControlType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1658829314: (e) => new d.IfcEnergyConversionDevice(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  2814081492: (e) => new d.IfcEngine(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3747195512: (e) => new d.IfcEvaporativeCooler(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  484807127: (e) => new d.IfcEvaporator(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1209101575: (e) => new d.IfcExternalSpatialElement(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  346874300: (e) => {
    var t, i;
    return new d.IfcFanType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1810631287: (e) => {
    var t, i;
    return new d.IfcFilterType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  4222183408: (e) => {
    var t, i;
    return new d.IfcFireSuppressionTerminalType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2058353004: (e) => new d.IfcFlowController(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  4278956645: (e) => new d.IfcFlowFitting(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  4037862832: (e) => {
    var t, i;
    return new d.IfcFlowInstrumentType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2188021234: (e) => new d.IfcFlowMeter(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3132237377: (e) => new d.IfcFlowMovingDevice(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  987401354: (e) => new d.IfcFlowSegment(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  707683696: (e) => new d.IfcFlowStorageDevice(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  2223149337: (e) => new d.IfcFlowTerminal(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  3508470533: (e) => new d.IfcFlowTreatmentDevice(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  900683007: (e) => new d.IfcFooting(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3319311131: (e) => new d.IfcHeatExchanger(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2068733104: (e) => new d.IfcHumidifier(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  4175244083: (e) => new d.IfcInterceptor(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2176052936: (e) => new d.IfcJunctionBox(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  76236018: (e) => new d.IfcLamp(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  629592764: (e) => new d.IfcLightFixture(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1437502449: (e) => new d.IfcMedicalDevice(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1073191201: (e) => new d.IfcMember(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1911478936: (e) => new d.IfcMemberStandardCase(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2474470126: (e) => new d.IfcMotorConnection(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  144952367: (e) => {
    var t;
    return new d.IfcOuterBoundaryCurve(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 2, i) : null)) || [], new d.IfcLogical((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value));
  },
  3694346114: (e) => new d.IfcOutlet(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1687234759: (e) => new d.IfcPile(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], e[9]),
  310824031: (e) => new d.IfcPipeFitting(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3612865200: (e) => new d.IfcPipeSegment(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3171933400: (e) => new d.IfcPlate(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1156407060: (e) => new d.IfcPlateStandardCase(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  738039164: (e) => new d.IfcProtectiveDevice(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  655969474: (e) => {
    var t, i;
    return new d.IfcProtectiveDeviceTrippingUnitType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  90941305: (e) => new d.IfcPump(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2262370178: (e) => new d.IfcRailing(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3024970846: (e) => new d.IfcRamp(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3283111854: (e) => new d.IfcRampFlight(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1232101972: (e) => {
    var t, i, n, s;
    return new d.IfcRationalBSplineCurveWithKnots(new d.IfcInteger((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), ((t = e[1]) == null ? void 0 : t.map((o) => ((o == null ? void 0 : o.value) ?? void 0) !== void 0 && (o == null ? void 0 : o.value) !== "" ? new u(o.value, 2, o) : null)) || [], e[2], new d.IfcLogical((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new d.IfcLogical((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), ((i = e[5]) == null ? void 0 : i.map((o) => ((o == null ? void 0 : o.value) ?? void 0) !== void 0 && (o == null ? void 0 : o.value) !== "" ? new d.IfcInteger(o.value) : null)) || [], ((n = e[6]) == null ? void 0 : n.map((o) => ((o == null ? void 0 : o.value) ?? void 0) !== void 0 && (o == null ? void 0 : o.value) !== "" ? new d.IfcParameterValue(o.value) : null)) || [], e[7], ((s = e[8]) == null ? void 0 : s.map((o) => ((o == null ? void 0 : o.value) ?? void 0) !== void 0 && (o == null ? void 0 : o.value) !== "" ? new d.IfcReal(o.value) : null)) || []);
  },
  979691226: (e) => new d.IfcReinforcingBar(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcPositiveLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new d.IfcAreaMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new d.IfcPositiveLengthMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), e[12], e[13]),
  2572171363: (e) => {
    var t, i, n;
    return new d.IfcReinforcingBarType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new u(s.value, 2, s) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new u(s.value, 2, s) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new d.IfcPositiveLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new d.IfcAreaMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new d.IfcPositiveLengthMeasure((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), e[13], (e[14] ?? void 0) === void 0 || e[14] === "" ? null : new d.IfcLabel((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value), (e[15] ?? void 0) === void 0 || e[15] === "" ? null : ((n = e[15]) == null ? void 0 : n.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? Li(2, s) : null)) || []);
  },
  2016517767: (e) => new d.IfcRoof(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3053780830: (e) => new d.IfcSanitaryTerminal(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1783015770: (e) => {
    var t, i;
    return new d.IfcSensorType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1329646415: (e) => new d.IfcShadingDevice(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1529196076: (e) => new d.IfcSlab(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3127900445: (e) => new d.IfcSlabElementedCase(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3027962421: (e) => new d.IfcSlabStandardCase(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3420628829: (e) => new d.IfcSolarDevice(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1999602285: (e) => new d.IfcSpaceHeater(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1404847402: (e) => new d.IfcStackTerminal(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  331165859: (e) => new d.IfcStair(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  4252922144: (e) => new d.IfcStairFlight(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcInteger((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcInteger((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new d.IfcPositiveLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new d.IfcPositiveLengthMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), e[12]),
  2515109513: (e) => {
    var t, i;
    return new d.IfcStructuralAnalysisModel(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), e[5], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((t = e[7]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : ((i = e[8]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 2, e[9]));
  },
  385403989: (e) => {
    var t;
    return new d.IfcStructuralLoadCase(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), e[5], e[6], e[7], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcRatioMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcLabel((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : ((t = e[10]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new d.IfcRatioMeasure(i.value) : null)) || []);
  },
  1621171031: (e) => new d.IfcStructuralPlanarAction(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 2, e[7]), e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcBoolean((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), e[10], e[11]),
  1162798199: (e) => new d.IfcSwitchingDevice(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  812556717: (e) => new d.IfcTank(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3825984169: (e) => new d.IfcTransformer(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3026737570: (e) => new d.IfcTubeBundle(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3179687236: (e) => {
    var t, i;
    return new d.IfcUnitaryControlElementType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  4292641817: (e) => new d.IfcUnitaryEquipment(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  4207607924: (e) => new d.IfcValve(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2391406946: (e) => new d.IfcWall(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  4156078855: (e) => new d.IfcWallElementedCase(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3512223829: (e) => new d.IfcWallStandardCase(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  4237592921: (e) => new d.IfcWasteTerminal(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3304561284: (e) => new d.IfcWindow(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcPositiveLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcPositiveLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), e[10], e[11], (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new d.IfcLabel((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value)),
  486154966: (e) => new d.IfcWindowStandardCase(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcPositiveLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new d.IfcPositiveLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), e[10], e[11], (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new d.IfcLabel((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value)),
  2874132201: (e) => {
    var t, i;
    return new d.IfcActuatorType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1634111441: (e) => new d.IfcAirTerminal(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  177149247: (e) => new d.IfcAirTerminalBox(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2056796094: (e) => new d.IfcAirToAirHeatRecovery(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3001207471: (e) => {
    var t, i;
    return new d.IfcAlarmType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  277319702: (e) => new d.IfcAudioVisualAppliance(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  753842376: (e) => new d.IfcBeam(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2906023776: (e) => new d.IfcBeamStandardCase(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  32344328: (e) => new d.IfcBoiler(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2938176219: (e) => new d.IfcBurner(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  635142910: (e) => new d.IfcCableCarrierFitting(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3758799889: (e) => new d.IfcCableCarrierSegment(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1051757585: (e) => new d.IfcCableFitting(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  4217484030: (e) => new d.IfcCableSegment(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3902619387: (e) => new d.IfcChiller(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  639361253: (e) => new d.IfcCoil(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3221913625: (e) => new d.IfcCommunicationsAppliance(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3571504051: (e) => new d.IfcCompressor(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2272882330: (e) => new d.IfcCondenser(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  578613899: (e) => {
    var t, i;
    return new d.IfcControllerType(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 2, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new d.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  4136498852: (e) => new d.IfcCooledBeam(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3640358203: (e) => new d.IfcCoolingTower(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  4074379575: (e) => new d.IfcDamper(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1052013943: (e) => new d.IfcDistributionChamberElement(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  562808652: (e) => new d.IfcDistributionCircuit(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new d.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), e[6]),
  1062813311: (e) => new d.IfcDistributionControlElement(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  342316401: (e) => new d.IfcDuctFitting(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3518393246: (e) => new d.IfcDuctSegment(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1360408905: (e) => new d.IfcDuctSilencer(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1904799276: (e) => new d.IfcElectricAppliance(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  862014818: (e) => new d.IfcElectricDistributionBoard(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3310460725: (e) => new d.IfcElectricFlowStorageDevice(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  264262732: (e) => new d.IfcElectricGenerator(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  402227799: (e) => new d.IfcElectricMotor(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1003880860: (e) => new d.IfcElectricTimeControl(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3415622556: (e) => new d.IfcFan(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  819412036: (e) => new d.IfcFilter(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1426591983: (e) => new d.IfcFireSuppressionTerminal(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  182646315: (e) => new d.IfcFlowInstrument(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2295281155: (e) => new d.IfcProtectiveDeviceTrippingUnit(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  4086658281: (e) => new d.IfcSensor(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  630975310: (e) => new d.IfcUnitaryControlElement(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  4288193352: (e) => new d.IfcActuator(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3087945054: (e) => new d.IfcAlarm(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  25142252: (e) => new d.IfcController(new d.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 2, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new d.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new d.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new d.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 2, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 2, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new d.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8])
};
wP[2] = {
  618182010: [qae, Xae],
  411424972: [Iue],
  4037036970: [vH, mue, yue, Eue],
  1387855156: [vH],
  2859738748: [Aie, Lae, zW, E8, Lie],
  2614616156: [E8],
  1959218052: [tue, iue],
  1785450214: [Oae],
  1466758467: [hme],
  4294318154: [due, Rme, rue],
  3200245327: [nY, g8, sY, lue, aue, uue],
  760658860: [iY, Nae, oue, $P, bX, Cae, pL, NX, sue],
  248100487: [NX],
  2235152071: [bX],
  1507914824: [RX, bae, nue],
  1918398963: [vX, Vae, zae, Oie],
  3701648758: [x5, Hae],
  2483315170: [Jr, A8, S8, b8, N8, D8, C8, eue],
  2226359599: [A8, S8, b8, N8, D8, C8],
  677532197: [UN, PW, qO, MW, sL, VW, wme, eA, cue, hue, fue, gH, pue, Dae, ame, Ime, UP, z2, P5, HW, nA, pme, mme, UW, EH, FW, yme, N5, a8, $ae, Kae, Zae],
  2022622350: [Jae],
  3119450353: [Tie, vie, Yae, Die],
  2095639259: [wie, PH],
  3958567839: [ZP, QP, tH, oA, n8, o8, YO, oH, l8, lH, uH, aA, zN, c8, Uae, TX, Rie, Sie, w8, bie, T8, Nie],
  986844984: [Ur, XO, jN, eL, tL, iL, nL, kW, gme, DX, CX, OX, nme, Rs, Ta, ome, Eme],
  1076942058: [R8, Cie, TH, v8, Qae],
  3377609919: [dE, BW],
  3008791417: [hL, JP, XP, e8, t8, Pg, Fg, SN, R2, Mv, j2, Mg, Ug, IN, zy, Sg, h5, c0, rA, vO, AO, xF, _P, tA, iA, dA, i8, bN, DN, CN, ON, _N, iH, gP, $O, jg, pA, Wg, mA, s8, PP, MP, xW, nH, _5, r8, sH, rH, HN, aH, _g, NO, LP, EN, xP, gX, pN, DO, OO, kg, MN, x2, Vv, bO, f4, gN, zg, gA, a4, u4, vA, u8, i3, Bg, f5, mN, uA, fA, BO, GN, Lg, Yv, h4, oN, I5, Vg, kN, dH, d8, cH, yA, WN, YN, fH, PN, IH, wA, TA, RA, pH, m4, $N, KN, ZN, QN, yH, EA, AA, f8, cA, I8, Gae, h8, hA, BN, SA, mH, DA, p8, wN, NA, m8, VN, qN, CA, y8, IA, bA, fL, JN, wH, Wae, Qe],
  2439245199: [Gl, ad, cs, IL, XF, ui, mL, Tme, yL],
  2341007311: [fe, Zr, Fe, le, Ni, U, ot, lt, B, Ye, me, Og, xg, at, ns, tr, We, Ce, ri, ut, Jp, dt, Xe, Hg, Ko, Un, Ad, Vt, ct, Gg, Te, KP, So, oE, rE, lA, lE, T4, X, Ns, ge, Xr, yN, Vs, bs, Xp, ie, xae, eE, xO, PF, w4, wX, Rl, g5, w5, T5, R5, v5, b5, UF, p4, HF, hH, Mae, W2, ju, T2, xv, Pv, Ky, $2, AI, _v, K2, i4, vN, Y2, Zm, Qm, q2, RO, Z2, X2, e4, s4, o4, AN, t4, NN, qm, $m, Km, Jm, e3, r3, r4, LN, Ym, J2, gu, Fm, Hm, Gm, km, Vm, zm, jm, H0, dd, m1, A1, hI, hd, p1, v1, _1, k1, j1, W1, J1, X1, tI, rI, aI, uI, dI, fd, T1, Z1, Id, S1, M1, B1, sI, pd, y1, L1, iI, md, b1, U1, F1, oI, cI, yd, E1, R1, N1, z1, Y1, Q1, nI, pI, Ed, g1, w1, D1, C1, O1, x1, P1, H1, G1, V1, q1, $1, K1, eI, lI, fI, II, mI, yI, EI, gd, eh, Vp, d5, pC, G0, mC, k0, cd, yC, V0, z0, j0, EC, gC, W0, vg, Y0, q0, $0, K0, wC, Z0, i0, TC, Q0, J0, RC, X0, ih, nh, vC, sh, Ag, oh, Zv, zp, wI, c5, Ng, Cg, jp, Dg, Wm, gb, uc, df, wd, cf, t3, th, n0, bg, Ra, Hu, Gu, ku, U0, r0, lh, s3, Wp, n4, Zp, Zh, Jh, tf, Xm, ac, ef, Ec, Ef, a3, d4, s0, b2, Xh, o0, D2, RI, Qh, N2, F2, l3, c4, v2, Uv, Wv, rh, a0, u0, l0, Zy, _O, HO, Td, Q2, SO, l4, xN, eH, MF, Yg, EX, Fv, Hv, Gv, zv, qv, Kv, UO, BF, jv, sf, u3, LO, Yh, A2, M0, ky, jy, Wy, Yy, _2, B0, hf, n3, Bv, ic, nc, sc, Gy, oc, Vy, rc, Wh, lc, Aa, La, Mp, dc, va, Oa, Cp, _p, Ya, $a, tu, iu, nu, au, Pp, du, cu, cc, Ca, Xa, hc, _a, ka, Va, ru, fc, Sa, Fa, su, Ic, xa, Op, za, lu, hu, pc, ba, Dp, Pa, qa, Ka, eu, ou, pu, mc, Na, Da, Ma, Ua, Ba, Ha, Ga, Lp, ja, Wa, Za, Qa, Ja, xp, uu, fu, Iu, mu, yu, Up, yc, ff, o3, kv, qh, $h, S2, Kh, C2, nf, of, O2, L2, P2, rf, lf, af, Eg, uf, M2, U2, If, pf, mf, B2, Qv, Hp, $v, yf, gf, d3, I4, GO, kO, FN, CO, PO, MO, FF, $s, Bae],
  1054537805: [ime, sme, rme, lme, AX, ume],
  3982875396: [TH, v8],
  2273995522: [_ae, kae],
  2162789131: [SX, A5, KO, S5, ZO, QO, JO, oL, GW, dme, cme],
  609421318: [SX, A5, KO, S5, ZO, QO, JO, oL, GW],
  2525727697: [A5, KO, S5, ZO, QO, JO, oL],
  2830218821: [R8],
  846575682: [a8],
  626085974: [UW, EH, FW],
  1549132990: [AX],
  280115917: [UP, z2, P5, HW],
  3101149627: [Pae, Fae],
  1377556343: [h8, hA, BN, SA, mH, DA, p8, wN, NA, m8, VN, qN, CA, y8, IA, bA, fL, JN, wH],
  2799835756: [JN],
  3798115385: [T8],
  1310608509: [w8],
  3264961684: [gH],
  370225590: [IA, bA],
  2889183280: [vX],
  3632507154: [TX],
  3900360178: [VN, qN, CA],
  297599258: [Rs, Ta],
  2556980723: [wN, NA],
  1809719519: [DA],
  3008276851: [wN],
  3448662350: [dE],
  2453401579: [JP, XP, e8, t8, Pg, Fg, SN, R2, Mv, j2, Mg, Ug, IN, zy, Sg, h5, c0, rA, vO, AO, xF, _P, tA, iA, dA, i8, bN, DN, CN, ON, _N, iH, gP, $O, jg, pA, Wg, mA, s8, PP, MP, xW, nH, _5, r8, sH, rH, HN, aH, _g, NO, LP, EN, xP, gX, pN, DO, OO, kg, MN, x2, Vv, bO, f4, gN, zg, gA, a4, u4, vA, u8, i3, Bg, f5, mN, uA, fA, BO, GN, Lg, Yv, h4, oN, I5, Vg, kN, dH, d8, cH, yA, WN, YN, fH, PN, IH, wA, TA, RA, pH, m4, $N, KN, ZN, QN, yH, EA, AA, f8, cA, I8],
  3590301190: [cA],
  812098782: [EA, AA],
  1437953363: [UP],
  1402838566: [m4, $N, KN, ZN, QN],
  1520743889: [m4],
  1008929658: [hA, BN, SA],
  3079605661: [RX],
  219451334: [W2, ju, T2, xv, Pv, Ky, $2, AI, _v, K2, i4, vN, Y2, Zm, Qm, q2, RO, Z2, X2, e4, s4, o4, AN, t4, NN, qm, $m, Km, Jm, e3, r3, r4, LN, Ym, J2, gu, Fm, Hm, Gm, km, Vm, zm, jm, H0, dd, m1, A1, hI, hd, p1, v1, _1, k1, j1, W1, J1, X1, tI, rI, aI, uI, dI, fd, T1, Z1, Id, S1, M1, B1, sI, pd, y1, L1, iI, md, b1, U1, F1, oI, cI, yd, E1, R1, N1, z1, Y1, Q1, nI, pI, Ed, g1, w1, D1, C1, O1, x1, P1, H1, G1, V1, q1, $1, K1, eI, lI, fI, II, mI, yI, EI, gd, eh, Vp, d5, pC, G0, mC, k0, cd, yC, V0, z0, j0, EC, gC, W0, vg, Y0, q0, $0, K0, wC, Z0, i0, TC, Q0, J0, RC, X0, ih, nh, vC, sh, Ag, oh, Zv, zp, wI, c5, Ng, Cg, jp, Dg, Wm, gb, uc, df, wd, cf, t3, th, n0, bg, Ra, Hu, Gu, ku, U0, r0, lh, s3, Wp, n4, Zp, Zh, Jh, tf, Xm, ac, ef, Ec, Ef, a3, d4, s0, b2, Xh, o0, D2, RI, Qh, N2, F2, l3, c4, v2, Uv, Wv, rh, a0, u0, l0, Zy, _O, HO, Td, Q2, SO, l4, xN, eH, MF, Yg, EX, Fv, Hv, Gv, zv, qv, Kv, UO, BF, jv, sf, u3, LO, Yh, A2, M0, ky, jy, Wy, Yy, _2, B0, hf, n3, Bv, ic, nc, sc, Gy, oc, Vy, rc, Wh, lc, Aa, La, Mp, dc, va, Oa, Cp, _p, Ya, $a, tu, iu, nu, au, Pp, du, cu, cc, Ca, Xa, hc, _a, ka, Va, ru, fc, Sa, Fa, su, Ic, xa, Op, za, lu, hu, pc, ba, Dp, Pa, qa, Ka, eu, ou, pu, mc, Na, Da, Ma, Ua, Ba, Ha, Ga, Lp, ja, Wa, Za, Qa, Ja, xp, uu, fu, Iu, mu, yu, Up, yc, ff, o3, kv, qh, $h, S2, Kh, C2, nf, of, O2, L2, P2, rf, lf, af, Eg, uf, M2, U2, If, pf, mf, B2, Qv, Hp, $v, yf, gf, d3, I4, GO, kO, FN, CO, PO, MO, FF, $s],
  2529465313: [ZP, QP, tH, oA, n8, o8, YO, oH, l8, lH, uH, aA, zN, c8],
  2004835150: [wA, TA, RA],
  1663979128: [PN],
  2067069095: [yA, WN, YN],
  3727388367: [UN, PW, qO, MW, sL, VW],
  3778827333: [DX, CX, OX],
  1775413392: [sL],
  2598011224: [Ur, XO, jN, eL, tL, iL, nL, kW],
  1680319473: [eE, xO, PF, w4, wX, Rl, g5, w5, T5, R5, v5, b5, UF, p4, HF, hH],
  3357820518: [Rl, g5, w5, T5, R5, v5, b5, UF, p4, HF],
  1482703590: [eE, xO, PF, w4],
  2090586900: [p4],
  3615266464: [aA, zN],
  478536968: [fe, Zr, Fe, le, Ni, U, ot, lt, B, Ye, me, Og, xg, at, ns, tr, We, Ce, ri, ut, Jp, dt, Xe, Hg, Ko, Un, Ad, Vt, ct, Gg, Te, KP, So, oE, rE, lA, lE, T4, X, Ns, ge, Xr, yN, Vs, bs, Xp, ie],
  3692461612: [XO, jN, eL, tL, iL, nL],
  723233188: [i3, Bg, f5, mN, uA, fA, BO, GN, Lg, Yv, h4, oN, I5, Vg, kN],
  2473145415: [S5],
  1597423693: [A5],
  2513912981: [pN, DO, OO, kg, MN, x2, Vv, bO, f4, gN, zg, gA, a4, u4, vA],
  2247615214: [Lg, Yv, h4, oN, I5, Vg],
  1260650574: [BO],
  230924584: [a4, u4],
  901063453: [_g, NO, LP, EN, xP],
  4282788508: [HN],
  1628702193: [Fv, Hv, Gv, zv, qv, Kv, UO, BF, jv, sf, u3, LO, Yh, A2, M0, ky, jy, Wy, Yy, _2, B0, hf, n3, Bv, ic, nc, sc, Gy, oc, Vy, rc, Wh, lc, Aa, La, Mp, dc, va, Oa, Cp, _p, Ya, $a, tu, iu, nu, au, Pp, du, cu, cc, Ca, Xa, hc, _a, ka, Va, ru, fc, Sa, Fa, su, Ic, xa, Op, za, lu, hu, pc, ba, Dp, Pa, qa, Ka, eu, ou, pu, mc, Na, Da, Ma, Ua, Ba, Ha, Ga, Lp, ja, Wa, Za, Qa, Ja, xp, uu, fu, Iu, mu, yu, Up, yc, ff, o3, kv, qh, $h, S2, Kh, C2, nf, of, O2, L2, P2, rf, lf, af, Eg, uf, M2, U2, If, pf, mf, B2, Qv, Hp, $v, yf, gf, d3, I4, GO, kO, FN, CO, PO, MO, FF],
  3736923433: [CO, PO, MO],
  2347495698: [jv, sf, u3, LO, Yh, A2, M0, ky, jy, Wy, Yy, _2, B0, hf, n3, Bv, ic, nc, sc, Gy, oc, Vy, rc, Wh, lc, Aa, La, Mp, dc, va, Oa, Cp, _p, Ya, $a, tu, iu, nu, au, Pp, du, cu, cc, Ca, Xa, hc, _a, ka, Va, ru, fc, Sa, Fa, su, Ic, xa, Op, za, lu, hu, pc, ba, Dp, Pa, qa, Ka, eu, ou, pu, mc, Na, Da, Ma, Ua, Ba, Ha, Ga, Lp, ja, Wa, Za, Qa, Ja, xp, uu, fu, Iu, mu, yu, Up, yc, ff, o3, kv, qh, $h, S2, Kh, C2, nf, of, O2, L2, P2, rf, lf, af, Eg, uf, M2, U2, If, pf, mf, B2, Qv, Hp, $v, yf, gf, d3, I4, GO, kO],
  3698973494: [Fv, Hv, Gv, zv, qv, Kv, UO],
  2736907675: [_5],
  4182860854: [x2, Vv, bO, f4, gN, zg],
  574549367: [PP, MP],
  59481748: [jg, pA, Wg, mA],
  3749851601: [Wg],
  3331915920: [jg],
  1383045692: [oA],
  2485617015: [gP],
  2574617495: [Fv, Hv, Gv, zv, qv, Kv],
  3419103109: [MF, Yg],
  2506170314: [bN, DN, CN, ON, _N],
  2601014836: [Pg, Fg, SN, R2, Mv, j2, Mg, Ug, IN, zy, Sg, h5, c0, rA, vO, AO, xF, _P, tA, iA, dA],
  339256511: [Yh, A2, M0, ky, jy, Wy, Yy, _2, B0, hf, n3, Bv, ic, nc, sc, Gy, oc, Vy, rc, Wh, lc, Aa, La, Mp, dc, va, Oa, Cp, _p, Ya, $a, tu, iu, nu, au, Pp, du, cu, cc, Ca, Xa, hc, _a, ka, Va, ru, fc, Sa, Fa, su, Ic, xa, Op, za, lu, hu, pc, ba, Dp, Pa, qa, Ka, eu, ou, pu, mc, Na, Da, Ma, Ua, Ba, Ha, Ga, Lp, ja, Wa, Za, Qa, Ja, xp, uu, fu, Iu, mu, yu, Up, yc, ff, o3, kv, qh, $h, S2, Kh, C2, nf, of, O2, L2, P2, rf, lf, af, Eg, uf, M2, U2, If, pf, mf, B2, Qv, Hp, $v, yf, gf, d3],
  2777663545: [pN, DO, OO, kg],
  477187591: [I5],
  4238390223: [yf, gf],
  178912537: [EN],
  1425443689: [i3, Bg, f5, mN],
  3888040117: [W2, ju, T2, xv, Pv, Ky, $2, AI, _v, K2, i4, vN, Y2, Zm, Qm, q2, RO, Z2, X2, e4, s4, o4, AN, t4, NN, qm, $m, Km, Jm, e3, r3, r4, LN, Ym, J2, gu, Fm, Hm, Gm, km, Vm, zm, jm, H0, dd, m1, A1, hI, hd, p1, v1, _1, k1, j1, W1, J1, X1, tI, rI, aI, uI, dI, fd, T1, Z1, Id, S1, M1, B1, sI, pd, y1, L1, iI, md, b1, U1, F1, oI, cI, yd, E1, R1, N1, z1, Y1, Q1, nI, pI, Ed, g1, w1, D1, C1, O1, x1, P1, H1, G1, V1, q1, $1, K1, eI, lI, fI, II, mI, yI, EI, gd, eh, Vp, d5, pC, G0, mC, k0, cd, yC, V0, z0, j0, EC, gC, W0, vg, Y0, q0, $0, K0, wC, Z0, i0, TC, Q0, J0, RC, X0, ih, nh, vC, sh, Ag, oh, Zv, zp, wI, c5, Ng, Cg, jp, Dg, Wm, gb, uc, df, wd, cf, t3, th, n0, bg, Ra, Hu, Gu, ku, U0, r0, lh, s3, Wp, n4, Zp, Zh, Jh, tf, Xm, ac, ef, Ec, Ef, a3, d4, s0, b2, Xh, o0, D2, RI, Qh, N2, F2, l3, c4, v2, Uv, Wv, rh, a0, u0, l0, Zy, _O, HO, Td, Q2, SO, l4, xN],
  759155922: [qO],
  2559016684: [UN],
  3967405729: [g5, w5, T5, R5, v5, b5],
  2945172077: [Q2, SO, l4],
  4208778838: [Ym, J2, gu, Fm, Hm, Gm, km, Vm, zm, jm, H0, dd, m1, A1, hI, hd, p1, v1, _1, k1, j1, W1, J1, X1, tI, rI, aI, uI, dI, fd, T1, Z1, Id, S1, M1, B1, sI, pd, y1, L1, iI, md, b1, U1, F1, oI, cI, yd, E1, R1, N1, z1, Y1, Q1, nI, pI, Ed, g1, w1, D1, C1, O1, x1, P1, H1, G1, V1, q1, $1, K1, eI, lI, fI, II, mI, yI, EI, gd, eh, Vp, d5, pC, G0, mC, k0, cd, yC, V0, z0, j0, EC, gC, W0, vg, Y0, q0, $0, K0, wC, Z0, i0, TC, Q0, J0, RC, X0, ih, nh, vC, sh, Ag, oh, Zv, zp, wI, c5, Ng, Cg, jp, Dg, Wm, gb, uc, df, wd, cf, t3, th, n0, bg, Ra, Hu, Gu, ku, U0, r0, lh, s3, Wp, n4, Zp, Zh, Jh, tf, Xm, ac, ef, Ec, Ef, a3, d4, s0, b2, Xh, o0, D2, RI, Qh, N2, F2, l3, c4, v2, Uv, Wv, rh, a0, u0, l0, Zy, _O, HO],
  3521284610: [eE, xO],
  3939117080: [Ns, ge, Xr, yN, Vs, bs, Xp],
  1307041759: [yN],
  1865459582: [So, oE, rE, lA, lE, T4],
  826625072: [Og, xg, at, ns, tr, We, Ce, ri, ut, Jp, dt, Xe, Hg, Ko, Un, Ad, Vt, ct, Gg, Te],
  1204542856: [ct, Gg],
  1638771189: [Hg],
  2551354335: [U, ot, lt, B],
  693640335: [fe, Zr, Fe, le],
  3451746338: [Og, xg],
  3523091289: [Og],
  2914609552: [qm, $m, Km, Jm, e3, r3, r4],
  1856042241: [Yv],
  1412071761: [v2, Uv, Wv, rh, a0, u0, l0, Zy],
  710998568: [jv, sf, u3],
  2706606064: [rh, a0, u0, l0],
  3893378262: [sf],
  3544373492: [s0, b2, Xh, o0, D2, RI, Qh, N2, F2, l3],
  3136571912: [Zh, Jh, tf, Xm, ac, ef, Ec, Ef, a3],
  530289379: [ac, ef, Ec, Ef],
  3689010777: [Qh, N2, F2],
  3979015343: [Ec],
  699246055: [vO, AO],
  2387106220: [_g, NO],
  2296667514: [t4],
  1635779807: [f5],
  2887950389: [x2, Vv],
  167062518: [x2],
  1260505505: [R2, Mv, j2, Mg, Ug, IN, zy, Sg, h5, c0],
  1950629157: [qh, $h, S2, Kh, C2, nf, of, O2, L2, P2, rf, lf, af, Eg, uf, M2, U2, If, pf, mf, B2],
  3732776249: [zy, Sg, h5],
  15328376: [zy, Sg],
  2510884976: [Pg, Fg],
  2559216714: [qm, $m, Km, Jm, e3, r3],
  3293443760: [Y2, Zm, Qm, q2, RO, Z2, X2, e4, s4, o4],
  3256556792: [ic, nc, sc, Gy, oc, Vy, rc, Wh, lc, Aa, La, Mp, dc, va, Oa, Cp, _p, Ya, $a, tu, iu, nu, au, Pp, du, cu, cc, Ca, Xa, hc, _a, ka, Va, ru, fc, Sa, Fa, su, Ic, xa, Op, za, lu, hu, pc, ba, Dp, Pa, qa, Ka, eu, ou, pu, mc, Na, Da, Ma, Ua, Ba, Ha, Ga, Lp, ja, Wa, Za, Qa, Ja, xp, uu, fu, Iu, mu, yu, Up, yc, ff],
  3849074793: [lc, Aa, La, Mp, dc, va, Oa, Cp, _p, Ya, $a, tu, iu, nu, au, Pp, du, cu, cc, Ca, Xa, hc, _a, ka, Va, ru, fc, Sa, Fa, su, Ic, xa, Op, za, lu, hu, pc, ba, Dp, Pa, qa, Ka, eu, ou, pu, mc, Na, Da, Ma, Ua, Ba, Ha, Ga, Lp, ja, Wa, Za, Qa, Ja, xp, uu, fu, Iu, mu, yu, Up, yc],
  1758889154: [Fm, Hm, Gm, km, Vm, zm, jm, H0, dd, m1, A1, hI, hd, p1, v1, _1, k1, j1, W1, J1, X1, tI, rI, aI, uI, dI, fd, T1, Z1, Id, S1, M1, B1, sI, pd, y1, L1, iI, md, b1, U1, F1, oI, cI, yd, E1, R1, N1, z1, Y1, Q1, nI, pI, Ed, g1, w1, D1, C1, O1, x1, P1, H1, G1, V1, q1, $1, K1, eI, lI, fI, II, mI, yI, EI, gd, eh, Vp, d5, pC, G0, mC, k0, cd, yC, V0, z0, j0, EC, gC, W0, vg, Y0, q0, $0, K0, wC, Z0, i0, TC, Q0, J0, RC, X0, ih, nh, vC, sh, Ag, oh, Zv, zp, wI, c5, Ng, Cg, jp, Dg, Wm, gb, uc, df, wd, cf, t3, th, n0, bg, Ra, Hu, Gu, ku, U0, r0, lh, s3, Wp],
  1623761950: [th, n0, bg, Ra, Hu, Gu, ku, U0, r0, lh],
  2590856083: [Yh, A2, M0, ky, jy, Wy, Yy, _2, B0, hf],
  2107101300: [Na, Da, Ma, Ua, Ba, Ha, Ga, Lp, ja, Wa, Za, Qa, Ja, xp, uu, fu, Iu, mu, yu, Up],
  2853485674: [v2],
  807026263: [i3],
  2827207264: [Dg, Wm, gb, uc, df, wd, cf],
  2143335405: [wd],
  1287392070: [Wm, gb, uc],
  3907093117: [ba, Dp, Pa, qa, Ka, eu, ou, pu],
  3198132628: [xa, Op, za, lu, hu],
  1482959167: [Sa, Fa, su],
  1834744321: [_a, ka, Va, ru],
  1339347760: [Ca, Xa],
  2297155007: [va, Oa, Cp, _p, Ya, $a, tu, iu, nu, au, Pp, du, cu],
  3009222698: [Aa, La, Mp],
  263784265: [Ng, Cg],
  2706460486: [W2, ju, T2, xv, Pv, Ky, $2, AI, _v, K2, i4],
  3588315303: [gb],
  3740093272: [Ym],
  3027567501: [Ra, Hu, Gu, ku],
  964333572: [ky, jy, Wy, Yy],
  682877961: [s0, b2, Xh, o0, D2],
  1179482911: [Zh, Jh, tf],
  1004757350: [o0],
  214636428: [ac],
  1252848954: [_v],
  3657597509: [s0],
  2254336722: [ju, T2, xv, Pv, Ky],
  1028945134: [Zm, Qm],
  1967976161: [R2, Mv],
  2461110595: [R2],
  1136057603: [zy],
  3299480353: [pC, G0, mC, k0, cd, yC, V0, z0, j0, EC, gC, W0, vg, Y0, q0, $0, K0, wC, Z0, i0, TC, Q0, J0, RC, X0, ih, nh, vC, sh, Ag, oh],
  843113511: [vC],
  2063403501: [ic, nc, sc, Gy, oc, Vy, rc],
  1945004755: [Fm, Hm, Gm, km, Vm, zm, jm, H0, dd, m1, A1, hI, hd, p1, v1, _1, k1, j1, W1, J1, X1, tI, rI, aI, uI, dI, fd, T1, Z1, Id, S1, M1, B1, sI, pd, y1, L1, iI, md, b1, U1, F1, oI, cI, yd, E1, R1, N1, z1, Y1, Q1, nI, pI, Ed, g1, w1, D1, C1, O1, x1, P1, H1, G1, V1, q1, $1, K1, eI, lI, fI, II, mI, yI, EI, gd, eh],
  3040386961: [dd, m1, A1, hI, hd, p1, v1, _1, k1, j1, W1, J1, X1, tI, rI, aI, uI, dI, fd, T1, Z1, Id, S1, M1, B1, sI, pd, y1, L1, iI, md, b1, U1, F1, oI, cI, yd, E1, R1, N1, z1, Y1, Q1, nI, pI, Ed, g1, w1, D1, C1, O1, x1, P1, H1, G1, V1, q1, $1, K1, eI, lI, fI, II, mI, yI, EI, gd],
  3205830791: [T2],
  395920057: [RC],
  1658829314: [g1, w1, D1, C1, O1, x1, P1, H1, G1, V1, q1, $1, K1, eI, lI, fI, II, mI, yI, EI],
  2058353004: [E1, R1, N1, z1, Y1, Q1, nI, pI],
  4278956645: [b1, U1, F1, oI, cI],
  3132237377: [y1, L1, iI],
  987401354: [S1, M1, B1, sI],
  707683696: [T1, Z1],
  2223149337: [p1, v1, _1, k1, j1, W1, J1, X1, tI, rI, aI, uI, dI],
  3508470533: [m1, A1, hI],
  1073191201: [TC],
  3171933400: [wC],
  1529196076: [EC, gC],
  2391406946: [cd, yC],
  3304561284: [mC],
  753842376: [pC],
  1062813311: [Fm, Hm, Gm, km, Vm, zm, jm]
};
_ie[2] = {
  3630933823: [["HasExternalReference", ui, 3, !0]],
  618182010: [["OfPerson", e6, 7, !0], ["OfOrganization", t6, 4, !0]],
  411424972: [["HasExternalReference", ui, 3, !0]],
  130549933: [["HasExternalReferences", ui, 3, !0], ["ApprovedObjects", T4, 5, !0], ["ApprovedResources", ad, 3, !0], ["IsRelatedWith", yL, 3, !0], ["Relates", yL, 2, !0]],
  1959218052: [["HasExternalReferences", ui, 3, !0], ["PropertiesForConstraint", Gl, 2, !0]],
  1466758467: [["HasCoordinateOperation", FO, 0, !0]],
  602808272: [["HasExternalReference", ui, 3, !0]],
  3200245327: [["ExternalReferenceForResources", ui, 2, !0]],
  2242383968: [["ExternalReferenceForResources", ui, 2, !0]],
  1040185647: [["ExternalReferenceForResources", ui, 2, !0]],
  3548104201: [["ExternalReferenceForResources", ui, 2, !0]],
  852622518: [["PartOfW", gu, 9, !0], ["PartOfV", gu, 8, !0], ["PartOfU", gu, 7, !0], ["HasIntersections", jae, 0, !0]],
  2655187982: [["LibraryInfoForObjects", oE, 5, !0], ["HasLibraryReferences", sY, 5, !0]],
  3452421091: [["ExternalReferenceForResources", ui, 2, !0], ["LibraryRefForObjects", oE, 5, !0]],
  760658860: [["AssociatedTo", So, 5, !0], ["HasExternalReferences", ui, 3, !0], ["HasProperties", Ta, 3, !0]],
  248100487: [["AssociatedTo", So, 5, !0], ["HasExternalReferences", ui, 3, !0], ["HasProperties", Ta, 3, !0], ["ToMaterialLayerSet", pL, 0, !1]],
  3303938423: [["AssociatedTo", So, 5, !0], ["HasExternalReferences", ui, 3, !0], ["HasProperties", Ta, 3, !0]],
  1847252529: [["AssociatedTo", So, 5, !0], ["HasExternalReferences", ui, 3, !0], ["HasProperties", Ta, 3, !0], ["ToMaterialLayerSet", pL, 0, !1]],
  2235152071: [["AssociatedTo", So, 5, !0], ["HasExternalReferences", ui, 3, !0], ["HasProperties", Ta, 3, !0], ["ToMaterialProfileSet", $P, 2, !1]],
  164193824: [["AssociatedTo", So, 5, !0], ["HasExternalReferences", ui, 3, !0], ["HasProperties", Ta, 3, !0]],
  552965576: [["AssociatedTo", So, 5, !0], ["HasExternalReferences", ui, 3, !0], ["HasProperties", Ta, 3, !0], ["ToMaterialProfileSet", $P, 2, !1]],
  1507914824: [["AssociatedTo", So, 5, !0]],
  3368373690: [["HasExternalReferences", ui, 3, !0], ["PropertiesForConstraint", Gl, 2, !0]],
  3701648758: [["PlacesObject", Td, 5, !0], ["ReferencedByPlacements", x5, 0, !0]],
  2251480897: [["HasExternalReferences", ui, 3, !0], ["PropertiesForConstraint", Gl, 2, !0]],
  4251960020: [["IsRelatedBy", IL, 3, !0], ["Relates", IL, 2, !0], ["Engages", RH, 1, !0]],
  2077209135: [["EngagedIn", RH, 0, !0]],
  2483315170: [["HasExternalReferences", ui, 3, !0], ["PartOfComplex", Jr, 2, !0]],
  2226359599: [["HasExternalReferences", ui, 3, !0], ["PartOfComplex", Jr, 2, !0]],
  3355820592: [["OfPerson", e6, 7, !0], ["OfOrganization", t6, 4, !0]],
  3958567839: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  3843373140: [["HasCoordinateOperation", FO, 0, !0]],
  986844984: [["HasExternalReferences", ui, 3, !0]],
  3710013099: [["HasExternalReferences", ui, 3, !0]],
  2044713172: [["HasExternalReferences", ui, 3, !0], ["PartOfComplex", Jr, 2, !0]],
  2093928680: [["HasExternalReferences", ui, 3, !0], ["PartOfComplex", Jr, 2, !0]],
  931644368: [["HasExternalReferences", ui, 3, !0], ["PartOfComplex", Jr, 2, !0]],
  3252649465: [["HasExternalReferences", ui, 3, !0], ["PartOfComplex", Jr, 2, !0]],
  2405470396: [["HasExternalReferences", ui, 3, !0], ["PartOfComplex", Jr, 2, !0]],
  825690147: [["HasExternalReferences", ui, 3, !0], ["PartOfComplex", Jr, 2, !0]],
  1076942058: [["RepresentationMap", ah, 1, !0], ["LayerAssignments", Ke, 2, !0], ["OfProductRepresentation", wf, 2, !0]],
  3377609919: [["RepresentationsInContext", XN, 0, !0]],
  3008791417: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1660063152: [["HasShapeAspects", Qy, 4, !0], ["MapUsage", hL, 0, !0]],
  3982875396: [["RepresentationMap", ah, 1, !0], ["LayerAssignments", Ke, 2, !0], ["OfProductRepresentation", wf, 2, !0], ["OfShapeAspect", Qy, 0, !0]],
  4240577450: [["RepresentationMap", ah, 1, !0], ["LayerAssignments", Ke, 2, !0], ["OfProductRepresentation", wf, 2, !0], ["OfShapeAspect", Qy, 0, !0]],
  2830218821: [["RepresentationMap", ah, 1, !0], ["LayerAssignments", Ke, 2, !0], ["OfProductRepresentation", wf, 2, !0]],
  3958052878: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3049322572: [["RepresentationMap", ah, 1, !0], ["LayerAssignments", Ke, 2, !0], ["OfProductRepresentation", wf, 2, !0]],
  626085974: [["IsMappedBy", nA, 0, !0], ["UsedInStyles", N5, 0, !0]],
  912023232: [["OfPerson", e6, 7, !0], ["OfOrganization", t6, 4, !0]],
  3101149627: [["HasExternalReference", ui, 3, !0]],
  1377556343: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1735638870: [["RepresentationMap", ah, 1, !0], ["LayerAssignments", Ke, 2, !0], ["OfProductRepresentation", wf, 2, !0], ["OfShapeAspect", Qy, 0, !0]],
  2799835756: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1907098498: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3798115385: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  1310608509: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  2705031697: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  616511568: [["IsMappedBy", nA, 0, !0], ["UsedInStyles", N5, 0, !0]],
  3150382593: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  747523909: [["ClassificationForObjects", lE, 5, !0], ["HasReferences", g8, 3, !0]],
  647927063: [["ExternalReferenceForResources", ui, 2, !0], ["ClassificationRefForObjects", lE, 5, !0], ["HasReferences", g8, 3, !0]],
  1485152156: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  370225590: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3050246964: [["HasExternalReference", ui, 3, !0]],
  2889183280: [["HasExternalReference", ui, 3, !0]],
  2713554722: [["HasExternalReference", ui, 3, !0]],
  3632507154: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  1154170062: [["DocumentInfoForObjects", rE, 5, !0], ["HasDocumentReferences", nY, 4, !0], ["IsPointedTo", mL, 3, !0], ["IsPointer", mL, 2, !0]],
  3732053477: [["ExternalReferenceForResources", ui, 2, !0], ["DocumentRefForObjects", rE, 5, !0]],
  3900360178: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  476780140: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  297599258: [["HasExternalReferences", ui, 3, !0]],
  2556980723: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0], ["HasTextureMaps", P5, 2, !0]],
  1809719519: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  803316827: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3008276851: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0], ["HasTextureMaps", P5, 2, !0]],
  3448662350: [["RepresentationsInContext", XN, 0, !0], ["HasSubContexts", dE, 6, !0], ["HasCoordinateOperation", FO, 0, !0]],
  2453401579: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4142052618: [["RepresentationsInContext", XN, 0, !0], ["HasSubContexts", dE, 6, !0], ["HasCoordinateOperation", FO, 0, !0]],
  3590301190: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  178086475: [["PlacesObject", Td, 5, !0], ["ReferencedByPlacements", x5, 0, !0]],
  812098782: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3905492369: [["IsMappedBy", nA, 0, !0], ["UsedInStyles", N5, 0, !0]],
  3741457305: [["HasExternalReference", ui, 3, !0]],
  1402838566: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  125510826: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2604431987: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4266656042: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1520743889: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3422422726: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2624227202: [["PlacesObject", Td, 5, !0], ["ReferencedByPlacements", x5, 0, !0]],
  1008929658: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2347385850: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1838606355: [["AssociatedTo", So, 5, !0], ["HasExternalReferences", ui, 3, !0], ["HasProperties", Ta, 3, !0], ["HasRepresentation", PH, 3, !0], ["IsRelatedWith", XF, 3, !0], ["RelatesTo", XF, 2, !0]],
  3708119e3: [["AssociatedTo", So, 5, !0], ["HasExternalReferences", ui, 3, !0], ["HasProperties", Ta, 3, !0], ["ToMaterialConstituentSet", iY, 2, !1]],
  2852063980: [["AssociatedTo", So, 5, !0], ["HasExternalReferences", ui, 3, !0], ["HasProperties", Ta, 3, !0]],
  1303795690: [["AssociatedTo", So, 5, !0]],
  3079605661: [["AssociatedTo", So, 5, !0]],
  3404854881: [["AssociatedTo", So, 5, !0]],
  3265635763: [["HasExternalReferences", ui, 3, !0]],
  2998442950: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  219451334: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0]],
  2665983363: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1029017970: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2529465313: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  2519244187: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3021840470: [["HasExternalReferences", ui, 3, !0], ["PartOfComplex", Jr, 2, !0]],
  597895409: [["IsMappedBy", nA, 0, !0], ["UsedInStyles", N5, 0, !0]],
  2004835150: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1663979128: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2067069095: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4022376103: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1423911732: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2924175390: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2775532180: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3778827333: [["HasExternalReferences", ui, 3, !0]],
  673634403: [["ShapeOfProduct", Td, 6, !0], ["HasShapeAspects", Qy, 4, !0]],
  2802850158: [["HasExternalReferences", ui, 3, !0]],
  2598011224: [["HasExternalReferences", ui, 3, !0], ["PartOfPset", Rl, 4, !0], ["PropertyForDependance", cs, 2, !0], ["PropertyDependsOn", cs, 3, !0], ["PartOfComplex", Ur, 3, !0], ["HasConstraints", Gl, 3, !0], ["HasApprovals", ad, 2, !0]],
  1680319473: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0]],
  3357820518: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0], ["DefinesType", $s, 5, !0], ["IsDefinedBy", Zr, 4, !0], ["DefinesOccurrence", Fe, 5, !0]],
  1482703590: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0]],
  2090586900: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0], ["DefinesType", $s, 5, !0], ["IsDefinedBy", Zr, 4, !0], ["DefinesOccurrence", Fe, 5, !0]],
  3615266464: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  3413951693: [["HasExternalReference", ui, 3, !0]],
  1580146022: [["HasExternalReferences", ui, 3, !0]],
  2778083089: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  2042790032: [["HasExternalReferences", ui, 3, !0]],
  4165799628: [["HasExternalReferences", ui, 3, !0]],
  1509187699: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4124623270: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3692461612: [["HasExternalReferences", ui, 3, !0], ["PartOfPset", Rl, 4, !0], ["PropertyForDependance", cs, 2, !0], ["PropertyDependsOn", cs, 3, !0], ["PartOfComplex", Ur, 3, !0], ["HasConstraints", Gl, 3, !0], ["HasApprovals", ad, 2, !0]],
  723233188: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2233826070: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2513912981: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2247615214: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1260650574: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1096409881: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  230924584: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3071757647: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  901063453: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4282788508: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3124975700: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2715220739: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  1628702193: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0]],
  3736923433: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["OperatesOn", Xr, 6, !0]],
  2347495698: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3698973494: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ResourceOf", Ns, 6, !0]],
  427810014: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  1417489154: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2759199220: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1299126871: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2543172580: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  3406155212: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0], ["HasTextureMaps", P5, 2, !0]],
  669184980: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3207858831: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  4261334040: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3125803723: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2740243338: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2736907675: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4182860854: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2581212453: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2713105998: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2898889636: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  1123145078: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  574549367: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1675464909: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2059837836: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  59481748: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3749851601: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3486308946: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3331915920: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1416205885: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1383045692: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  2205249479: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2542286263: [["HasExternalReferences", ui, 3, !0], ["PartOfPset", Rl, 4, !0], ["PropertyForDependance", cs, 2, !0], ["PropertyDependsOn", cs, 3, !0], ["PartOfComplex", Ur, 3, !0], ["HasConstraints", Gl, 3, !0], ["HasApprovals", ad, 2, !0]],
  2485617015: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0], ["UsingCurves", c0, 0, !0]],
  2574617495: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ResourceOf", Ns, 6, !0]],
  3419103109: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["Declares", me, 4, !0]],
  1815067380: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ResourceOf", Ns, 6, !0]],
  2506170314: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2147822146: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2601014836: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2827736869: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2629017746: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  32440307: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  526551008: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1472233963: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1883228015: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0], ["DefinesType", $s, 5, !0], ["IsDefinedBy", Zr, 4, !0], ["DefinesOccurrence", Fe, 5, !0]],
  339256511: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2777663545: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2835456948: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  4024345920: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["OperatesOn", Xr, 6, !0]],
  477187591: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2804161546: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2047409740: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  374418227: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  315944413: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2652556860: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4238390223: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1268542332: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  4095422895: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  987898635: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1484403080: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  178912537: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0], ["ToFaceSet", _g, 2, !0]],
  2294589976: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0], ["ToFaceSet", _g, 2, !0]],
  572779678: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  428585644: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ResourceOf", Ns, 6, !0]],
  1281925730: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1425443689: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3888040117: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0]],
  3388369263: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3505215534: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1682466193: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  603570806: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  220341763: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3967405729: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0], ["DefinesType", $s, 5, !0], ["IsDefinedBy", Zr, 4, !0], ["DefinesOccurrence", Fe, 5, !0]],
  569719735: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["OperatesOn", Xr, 6, !0]],
  2945172077: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsPredecessorTo", tr, 4, !0], ["IsSuccessorFrom", tr, 5, !0], ["OperatesOn", Xr, 6, !0]],
  4208778838: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0]],
  103090709: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["Declares", me, 4, !0]],
  653396225: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["Declares", me, 4, !0]],
  871118103: [["HasExternalReferences", ui, 3, !0], ["PartOfPset", Rl, 4, !0], ["PropertyForDependance", cs, 2, !0], ["PropertyDependsOn", cs, 3, !0], ["PartOfComplex", Ur, 3, !0], ["HasConstraints", Gl, 3, !0], ["HasApprovals", ad, 2, !0]],
  4166981789: [["HasExternalReferences", ui, 3, !0], ["PartOfPset", Rl, 4, !0], ["PropertyForDependance", cs, 2, !0], ["PropertyDependsOn", cs, 3, !0], ["PartOfComplex", Ur, 3, !0], ["HasConstraints", Gl, 3, !0], ["HasApprovals", ad, 2, !0]],
  2752243245: [["HasExternalReferences", ui, 3, !0], ["PartOfPset", Rl, 4, !0], ["PropertyForDependance", cs, 2, !0], ["PropertyDependsOn", cs, 3, !0], ["PartOfComplex", Ur, 3, !0], ["HasConstraints", Gl, 3, !0], ["HasApprovals", ad, 2, !0]],
  941946838: [["HasExternalReferences", ui, 3, !0], ["PartOfPset", Rl, 4, !0], ["PropertyForDependance", cs, 2, !0], ["PropertyDependsOn", cs, 3, !0], ["PartOfComplex", Ur, 3, !0], ["HasConstraints", Gl, 3, !0], ["HasApprovals", ad, 2, !0]],
  1451395588: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0], ["DefinesType", $s, 5, !0], ["IsDefinedBy", Zr, 4, !0], ["DefinesOccurrence", Fe, 5, !0]],
  492091185: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0], ["Defines", Zr, 5, !0]],
  3650150729: [["HasExternalReferences", ui, 3, !0], ["PartOfPset", Rl, 4, !0], ["PropertyForDependance", cs, 2, !0], ["PropertyDependsOn", cs, 3, !0], ["PartOfComplex", Ur, 3, !0], ["HasConstraints", Gl, 3, !0], ["HasApprovals", ad, 2, !0]],
  110355661: [["HasExternalReferences", ui, 3, !0], ["PartOfPset", Rl, 4, !0], ["PropertyForDependance", cs, 2, !0], ["PropertyDependsOn", cs, 3, !0], ["PartOfComplex", Ur, 3, !0], ["HasConstraints", Gl, 3, !0], ["HasApprovals", ad, 2, !0]],
  3521284610: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0], ["PartOfComplexTemplate", eE, 6, !0], ["PartOfPsetTemplate", w4, 6, !0]],
  3219374653: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0]],
  2770003689: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  2798486643: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3454111270: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3765753017: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0], ["DefinesType", $s, 5, !0], ["IsDefinedBy", Zr, 4, !0], ["DefinesOccurrence", Fe, 5, !0]],
  3523091289: [["InnerBoundaries", xg, 9, !0]],
  1521410863: [["InnerBoundaries", xg, 9, !0], ["Corresponds", Og, 10, !0]],
  816062949: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0], ["UsingCurves", c0, 0, !0]],
  2914609552: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ResourceOf", Ns, 6, !0]],
  1856042241: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3243963512: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4158566097: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3626867408: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3663146110: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0], ["PartOfComplexTemplate", eE, 6, !0], ["PartOfPsetTemplate", w4, 6, !0]],
  1412071761: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["ContainsElements", Xe, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ReferencesElements", We, 5, !0]],
  710998568: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2706606064: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["ContainsElements", Xe, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ReferencesElements", We, 5, !0]],
  3893378262: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  463610769: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["ContainsElements", Xe, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ReferencesElements", We, 5, !0]],
  2481509218: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  451544542: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4015995234: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3544373492: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedToStructuralItem", Un, 5, !0]],
  3136571912: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedStructuralActivity", Un, 4, !0]],
  530289379: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedStructuralActivity", Un, 4, !0], ["ConnectedBy", Ko, 4, !0]],
  3689010777: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedToStructuralItem", Un, 5, !0]],
  3979015343: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedStructuralActivity", Un, 4, !0], ["ConnectedBy", Ko, 4, !0]],
  2218152070: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedStructuralActivity", Un, 4, !0], ["ConnectedBy", Ko, 4, !0]],
  603775116: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedToStructuralItem", Un, 5, !0]],
  4095615324: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ResourceOf", Ns, 6, !0]],
  699246055: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2028607225: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2809605785: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4124788165: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1580310250: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3473067441: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsPredecessorTo", tr, 4, !0], ["IsSuccessorFrom", tr, 5, !0], ["OperatesOn", Xr, 6, !0]],
  3206491090: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["OperatesOn", Xr, 6, !0]],
  2387106220: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0], ["HasColours", eA, 0, !0], ["HasTextures", z2, 1, !0]],
  1935646853: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2097647324: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2916149573: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0], ["HasColours", eA, 0, !0], ["HasTextures", z2, 1, !0]],
  336235671: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0], ["DefinesType", $s, 5, !0], ["IsDefinedBy", Zr, 4, !0], ["DefinesOccurrence", Fe, 5, !0]],
  512836454: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0], ["DefinesType", $s, 5, !0], ["IsDefinedBy", Zr, 4, !0], ["DefinesOccurrence", Fe, 5, !0]],
  2296667514: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsActingUpon", Xp, 6, !0]],
  1635779807: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2603310189: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1674181508: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  2887950389: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  167062518: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1334484129: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3649129432: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1260505505: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4031249490: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["ContainsElements", Xe, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ReferencesElements", We, 5, !0]],
  1950629157: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3124254112: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["ContainsElements", Xe, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ReferencesElements", We, 5, !0]],
  2197970202: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2937912522: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  3893394355: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  300633059: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3875453745: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0], ["PartOfComplexTemplate", eE, 6, !0], ["PartOfPsetTemplate", w4, 6, !0]],
  3732776249: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  15328376: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2510884976: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2185764099: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ResourceOf", Ns, 6, !0]],
  4105962743: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ResourceOf", Ns, 6, !0]],
  1525564444: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ResourceOf", Ns, 6, !0]],
  2559216714: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ResourceOf", Ns, 6, !0]],
  3293443760: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["Controls", bs, 6, !0]],
  3895139033: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["Controls", bs, 6, !0]],
  1419761937: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["Controls", bs, 6, !0]],
  1916426348: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3295246426: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ResourceOf", Ns, 6, !0]],
  1457835157: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1213902940: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3256556792: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3849074793: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2963535650: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0], ["DefinesType", $s, 5, !0], ["IsDefinedBy", Zr, 4, !0], ["DefinesOccurrence", Fe, 5, !0]],
  1714330368: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0], ["DefinesType", $s, 5, !0], ["IsDefinedBy", Zr, 4, !0], ["DefinesOccurrence", Fe, 5, !0]],
  2323601079: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1758889154: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  4123344466: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  2397081782: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1623761950: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  2590856083: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1704287377: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2107101300: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  132023988: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3174744832: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3390157468: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  4148101412: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsPredecessorTo", tr, 4, !0], ["IsSuccessorFrom", tr, 5, !0], ["OperatesOn", Xr, 6, !0]],
  2853485674: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["ContainsElements", Xe, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ReferencesElements", We, 5, !0]],
  807026263: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3737207727: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  647756555: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  2489546625: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2827207264: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  2143335405: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["ProjectsElements", lt, 5, !1]],
  1287392070: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["VoidsElements", ot, 5, !1]],
  3907093117: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3198132628: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3815607619: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1482959167: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1834744321: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1339347760: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2297155007: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3009222698: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1893162501: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  263784265: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  1509553395: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  3493046030: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  3009204131: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["ContainedInStructure", Xe, 4, !0]],
  2706460486: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsGroupedBy", Vs, 6, !0]],
  1251058090: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1806887404: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2571569899: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3946677679: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3113134337: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2391368822: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsGroupedBy", Vs, 6, !0]],
  4288270099: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3827777499: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ResourceOf", Ns, 6, !0]],
  1051575348: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1161773419: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  377706215: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  2108223431: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1114901282: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3181161470: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  977012517: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  4143007308: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsActingUpon", Xp, 6, !0]],
  3588315303: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["VoidsElements", ot, 5, !1], ["HasFillings", ut, 4, !0]],
  3079942009: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["VoidsElements", ot, 5, !1], ["HasFillings", ut, 4, !0]],
  2837617999: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2382730787: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["Controls", bs, 6, !0]],
  3566463478: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0], ["DefinesType", $s, 5, !0], ["IsDefinedBy", Zr, 4, !0], ["DefinesOccurrence", Fe, 5, !0]],
  3327091369: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["Controls", bs, 6, !0]],
  1158309216: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  804291784: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  4231323485: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  4017108033: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2839578677: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0], ["HasColours", eA, 0, !0], ["HasTextures", z2, 1, !0]],
  3724593414: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3740093272: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["ContainedIn", Vt, 4, !0], ["ConnectedFrom", Ad, 5, !0], ["ConnectedTo", Ad, 4, !0]],
  2744685151: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsPredecessorTo", tr, 4, !0], ["IsSuccessorFrom", tr, 5, !0], ["OperatesOn", Xr, 6, !0]],
  2904328755: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["Controls", bs, 6, !0]],
  3651124850: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["ProjectsElements", lt, 5, !1]],
  1842657554: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2250791053: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2893384427: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2324767716: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1469900589: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  683857671: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3027567501: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  964333572: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2320036040: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  2310774935: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2781568857: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1768891740: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2157484638: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4074543187: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  4097777520: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["ContainsElements", Xe, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ReferencesElements", We, 5, !0]],
  2533589738: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1072016465: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3856911033: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["ContainsElements", Xe, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ReferencesElements", We, 5, !0], ["HasCoverings", Jp, 4, !0], ["BoundedBy", at, 4, !0]],
  1305183839: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3812236995: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3112655638: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1039846685: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  338393293: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  682877961: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedToStructuralItem", Un, 5, !0]],
  1179482911: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedStructuralActivity", Un, 4, !0], ["ConnectsStructuralMembers", Ko, 5, !0]],
  1004757350: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedToStructuralItem", Un, 5, !0]],
  4243806635: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedStructuralActivity", Un, 4, !0], ["ConnectsStructuralMembers", Ko, 5, !0]],
  214636428: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedStructuralActivity", Un, 4, !0], ["ConnectedBy", Ko, 4, !0]],
  2445595289: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedStructuralActivity", Un, 4, !0], ["ConnectedBy", Ko, 4, !0]],
  2757150158: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedToStructuralItem", Un, 5, !0]],
  1807405624: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedToStructuralItem", Un, 5, !0]],
  1252848954: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsGroupedBy", Vs, 6, !0], ["SourceOfResultGroup", AI, 6, !0], ["LoadGroupFor", ju, 7, !0]],
  2082059205: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedToStructuralItem", Un, 5, !0]],
  734778138: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedStructuralActivity", Un, 4, !0], ["ConnectsStructuralMembers", Ko, 5, !0]],
  1235345126: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedToStructuralItem", Un, 5, !0]],
  2986769608: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsGroupedBy", Vs, 6, !0], ["ResultGroupFor", ju, 8, !0]],
  3657597509: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedToStructuralItem", Un, 5, !0]],
  1975003073: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedStructuralActivity", Un, 4, !0], ["ConnectsStructuralMembers", Ko, 5, !0]],
  148013059: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ResourceOf", Ns, 6, !0]],
  3101698114: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  2315554128: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2254336722: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsGroupedBy", Vs, 6, !0], ["ServicesBuildings", ns, 4, !0]],
  413509423: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  5716631: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3824725483: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  2347447852: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  3081323446: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2415094496: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1692211062: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1620046519: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  3593883385: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1600972822: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1911125066: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  728799441: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2391383451: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  3313531582: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2769231204: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  926996030: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["VoidsElements", ot, 5, !1]],
  1898987631: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1133259667: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  4009809668: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  4088093105: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["Controls", bs, 6, !0]],
  1028945134: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["Controls", bs, 6, !0]],
  4218914973: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["Controls", bs, 6, !0]],
  3342526732: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["Controls", bs, 6, !0]],
  1033361043: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsGroupedBy", Vs, 6, !0], ["ServicesBuildings", ns, 4, !0]],
  3821786052: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["Controls", bs, 6, !0]],
  1411407467: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3352864051: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1871374353: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3460190687: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsGroupedBy", Vs, 6, !0]],
  1532957894: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1967976161: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2461110595: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  819618141: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  231477066: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1136057603: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3299480353: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  2979338954: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  39481116: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1095909175: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  1909888760: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1177604601: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsGroupedBy", Vs, 6, !0], ["ServicesBuildings", ns, 4, !0]],
  2188180465: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  395041908: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3293546465: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2674252688: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1285652485: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2951183804: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3296154744: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  2611217952: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1677625105: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  2301859152: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  843113511: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  905975707: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  400855858: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3850581409: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2816379211: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3898045240: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ResourceOf", Ns, 6, !0]],
  1060000209: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ResourceOf", Ns, 6, !0]],
  488727124: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ResourceOf", Ns, 6, !0]],
  335055490: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2954562838: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1973544240: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["CoversSpaces", Jp, 5, !0], ["CoversElements", dt, 5, !0]],
  3495092785: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  3961806047: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1335981549: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  2635815018: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1599208980: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2063403501: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1945004755: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0]],
  3040386961: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3041715199: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["ContainedIn", Vt, 4, !0], ["ConnectedFrom", Ad, 5, !0], ["ConnectedTo", Ad, 4, !0]],
  3205830791: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsGroupedBy", Vs, 6, !0], ["ServicesBuildings", ns, 4, !0]],
  395920057: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  3242481149: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  869906466: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3760055223: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2030761528: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  663422040: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2417008758: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3277789161: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1534661035: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1217240411: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  712377611: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1658829314: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  2814081492: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3747195512: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  484807127: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  1209101575: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["ContainsElements", Xe, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ReferencesElements", We, 5, !0], ["BoundedBy", at, 4, !0]],
  346874300: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1810631287: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  4222183408: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2058353004: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  4278956645: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  4037862832: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2188021234: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3132237377: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  987401354: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  707683696: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  2223149337: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3508470533: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  900683007: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  3319311131: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  2068733104: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  4175244083: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  2176052936: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  76236018: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  629592764: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  1437502449: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  1073191201: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  1911478936: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  2474470126: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  144952367: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3694346114: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  1687234759: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  310824031: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3612865200: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3171933400: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  1156407060: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  738039164: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  655969474: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  90941305: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  2262370178: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  3024970846: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  3283111854: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  1232101972: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  979691226: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  2572171363: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2016517767: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  3053780830: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  1783015770: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1329646415: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  1529196076: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  3127900445: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  3027962421: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  3420628829: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  1999602285: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  1404847402: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  331165859: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  4252922144: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  2515109513: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsGroupedBy", Vs, 6, !0], ["ServicesBuildings", ns, 4, !0]],
  385403989: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsGroupedBy", Vs, 6, !0], ["SourceOfResultGroup", AI, 6, !0], ["LoadGroupFor", ju, 7, !0]],
  1621171031: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["AssignedToStructuralItem", Un, 5, !0]],
  1162798199: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  812556717: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3825984169: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3026737570: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3179687236: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  4292641817: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  4207607924: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  2391406946: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  4156078855: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  3512223829: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  4237592921: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3304561284: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  486154966: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  2874132201: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1634111441: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  177149247: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  2056796094: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3001207471: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  277319702: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  753842376: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  2906023776: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0]],
  32344328: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  2938176219: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  635142910: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3758799889: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  1051757585: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  4217484030: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3902619387: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  639361253: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3221913625: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3571504051: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  2272882330: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  578613899: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  4136498852: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3640358203: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  4074379575: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  1052013943: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  562808652: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsGroupedBy", Vs, 6, !0], ["ServicesBuildings", ns, 4, !0]],
  1062813311: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["AssignedToFlowElement", ri, 4, !0]],
  342316401: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3518393246: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  1360408905: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  1904799276: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  862014818: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3310460725: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  264262732: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  402227799: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  1003880860: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3415622556: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  819412036: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  1426591983: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  182646315: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["AssignedToFlowElement", ri, 4, !0]],
  2295281155: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["AssignedToFlowElement", ri, 4, !0]],
  4086658281: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["AssignedToFlowElement", ri, 4, !0]],
  630975310: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["AssignedToFlowElement", ri, 4, !0]],
  4288193352: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["AssignedToFlowElement", ri, 4, !0]],
  3087945054: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["AssignedToFlowElement", ri, 4, !0]],
  25142252: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["ReferencedInStructures", We, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasPorts", Vt, 5, !0], ["AssignedToFlowElement", ri, 4, !0]]
};
xie[2] = {
  3630933823: (e) => new d.IfcActorRole(e[0], e[1], e[2]),
  618182010: (e) => new d.IfcAddress(e[0], e[1], e[2]),
  639542469: (e) => new d.IfcApplication(e[0], e[1], e[2], e[3]),
  411424972: (e) => new d.IfcAppliedValue(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  130549933: (e) => new d.IfcApproval(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4037036970: (e) => new d.IfcBoundaryCondition(e[0]),
  1560379544: (e) => new d.IfcBoundaryEdgeCondition(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3367102660: (e) => new d.IfcBoundaryFaceCondition(e[0], e[1], e[2], e[3]),
  1387855156: (e) => new d.IfcBoundaryNodeCondition(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2069777674: (e) => new d.IfcBoundaryNodeConditionWarping(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2859738748: (e) => new d.IfcConnectionGeometry(),
  2614616156: (e) => new d.IfcConnectionPointGeometry(e[0], e[1]),
  2732653382: (e) => new d.IfcConnectionSurfaceGeometry(e[0], e[1]),
  775493141: (e) => new d.IfcConnectionVolumeGeometry(e[0], e[1]),
  1959218052: (e) => new d.IfcConstraint(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1785450214: (e) => new d.IfcCoordinateOperation(e[0], e[1]),
  1466758467: (e) => new d.IfcCoordinateReferenceSystem(e[0], e[1], e[2], e[3]),
  602808272: (e) => new d.IfcCostValue(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1765591967: (e) => new d.IfcDerivedUnit(e[0], e[1], e[2]),
  1045800335: (e) => new d.IfcDerivedUnitElement(e[0], e[1]),
  2949456006: (e) => new d.IfcDimensionalExponents(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  4294318154: (e) => new d.IfcExternalInformation(),
  3200245327: (e) => new d.IfcExternalReference(e[0], e[1], e[2]),
  2242383968: (e) => new d.IfcExternallyDefinedHatchStyle(e[0], e[1], e[2]),
  1040185647: (e) => new d.IfcExternallyDefinedSurfaceStyle(e[0], e[1], e[2]),
  3548104201: (e) => new d.IfcExternallyDefinedTextFont(e[0], e[1], e[2]),
  852622518: (e) => new d.IfcGridAxis(e[0], e[1], e[2]),
  3020489413: (e) => new d.IfcIrregularTimeSeriesValue(e[0], e[1]),
  2655187982: (e) => new d.IfcLibraryInformation(e[0], e[1], e[2], e[3], e[4], e[5]),
  3452421091: (e) => new d.IfcLibraryReference(e[0], e[1], e[2], e[3], e[4], e[5]),
  4162380809: (e) => new d.IfcLightDistributionData(e[0], e[1], e[2]),
  1566485204: (e) => new d.IfcLightIntensityDistribution(e[0], e[1]),
  3057273783: (e) => new d.IfcMapConversion(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1847130766: (e) => new d.IfcMaterialClassificationRelationship(e[0], e[1]),
  760658860: (e) => new d.IfcMaterialDefinition(),
  248100487: (e) => new d.IfcMaterialLayer(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3303938423: (e) => new d.IfcMaterialLayerSet(e[0], e[1], e[2]),
  1847252529: (e) => new d.IfcMaterialLayerWithOffsets(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2199411900: (e) => new d.IfcMaterialList(e[0]),
  2235152071: (e) => new d.IfcMaterialProfile(e[0], e[1], e[2], e[3], e[4], e[5]),
  164193824: (e) => new d.IfcMaterialProfileSet(e[0], e[1], e[2], e[3]),
  552965576: (e) => new d.IfcMaterialProfileWithOffsets(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1507914824: (e) => new d.IfcMaterialUsageDefinition(),
  2597039031: (e) => new d.IfcMeasureWithUnit(e[0], e[1]),
  3368373690: (e) => new d.IfcMetric(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  2706619895: (e) => new d.IfcMonetaryUnit(e[0]),
  1918398963: (e) => new d.IfcNamedUnit(e[0], e[1]),
  3701648758: (e) => new d.IfcObjectPlacement(),
  2251480897: (e) => new d.IfcObjective(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  4251960020: (e) => new d.IfcOrganization(e[0], e[1], e[2], e[3], e[4]),
  1207048766: (e) => new d.IfcOwnerHistory(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2077209135: (e) => new d.IfcPerson(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  101040310: (e) => new d.IfcPersonAndOrganization(e[0], e[1], e[2]),
  2483315170: (e) => new d.IfcPhysicalQuantity(e[0], e[1]),
  2226359599: (e) => new d.IfcPhysicalSimpleQuantity(e[0], e[1], e[2]),
  3355820592: (e) => new d.IfcPostalAddress(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  677532197: (e) => new d.IfcPresentationItem(),
  2022622350: (e) => new d.IfcPresentationLayerAssignment(e[0], e[1], e[2], e[3]),
  1304840413: (e) => new d.IfcPresentationLayerWithStyle(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3119450353: (e) => new d.IfcPresentationStyle(e[0]),
  2417041796: (e) => new d.IfcPresentationStyleAssignment(e[0]),
  2095639259: (e) => new d.IfcProductRepresentation(e[0], e[1], e[2]),
  3958567839: (e) => new d.IfcProfileDef(e[0], e[1]),
  3843373140: (e) => new d.IfcProjectedCRS(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  986844984: (e) => new d.IfcPropertyAbstraction(),
  3710013099: (e) => new d.IfcPropertyEnumeration(e[0], e[1], e[2]),
  2044713172: (e) => new d.IfcQuantityArea(e[0], e[1], e[2], e[3], e[4]),
  2093928680: (e) => new d.IfcQuantityCount(e[0], e[1], e[2], e[3], e[4]),
  931644368: (e) => new d.IfcQuantityLength(e[0], e[1], e[2], e[3], e[4]),
  3252649465: (e) => new d.IfcQuantityTime(e[0], e[1], e[2], e[3], e[4]),
  2405470396: (e) => new d.IfcQuantityVolume(e[0], e[1], e[2], e[3], e[4]),
  825690147: (e) => new d.IfcQuantityWeight(e[0], e[1], e[2], e[3], e[4]),
  3915482550: (e) => new d.IfcRecurrencePattern(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2433181523: (e) => new d.IfcReference(e[0], e[1], e[2], e[3], e[4]),
  1076942058: (e) => new d.IfcRepresentation(e[0], e[1], e[2], e[3]),
  3377609919: (e) => new d.IfcRepresentationContext(e[0], e[1]),
  3008791417: (e) => new d.IfcRepresentationItem(),
  1660063152: (e) => new d.IfcRepresentationMap(e[0], e[1]),
  2439245199: (e) => new d.IfcResourceLevelRelationship(e[0], e[1]),
  2341007311: (e) => new d.IfcRoot(e[0], e[1], e[2], e[3]),
  448429030: (e) => new d.IfcSIUnit(e[0], e[1], e[2]),
  1054537805: (e) => new d.IfcSchedulingTime(e[0], e[1], e[2]),
  867548509: (e) => new d.IfcShapeAspect(e[0], e[1], e[2], e[3], e[4]),
  3982875396: (e) => new d.IfcShapeModel(e[0], e[1], e[2], e[3]),
  4240577450: (e) => new d.IfcShapeRepresentation(e[0], e[1], e[2], e[3]),
  2273995522: (e) => new d.IfcStructuralConnectionCondition(e[0]),
  2162789131: (e) => new d.IfcStructuralLoad(e[0]),
  3478079324: (e) => new d.IfcStructuralLoadConfiguration(e[0], e[1], e[2]),
  609421318: (e) => new d.IfcStructuralLoadOrResult(e[0]),
  2525727697: (e) => new d.IfcStructuralLoadStatic(e[0]),
  3408363356: (e) => new d.IfcStructuralLoadTemperature(e[0], e[1], e[2], e[3]),
  2830218821: (e) => new d.IfcStyleModel(e[0], e[1], e[2], e[3]),
  3958052878: (e) => new d.IfcStyledItem(e[0], e[1], e[2]),
  3049322572: (e) => new d.IfcStyledRepresentation(e[0], e[1], e[2], e[3]),
  2934153892: (e) => new d.IfcSurfaceReinforcementArea(e[0], e[1], e[2], e[3]),
  1300840506: (e) => new d.IfcSurfaceStyle(e[0], e[1], e[2]),
  3303107099: (e) => new d.IfcSurfaceStyleLighting(e[0], e[1], e[2], e[3]),
  1607154358: (e) => new d.IfcSurfaceStyleRefraction(e[0], e[1]),
  846575682: (e) => new d.IfcSurfaceStyleShading(e[0], e[1]),
  1351298697: (e) => new d.IfcSurfaceStyleWithTextures(e[0]),
  626085974: (e) => new d.IfcSurfaceTexture(e[0], e[1], e[2], e[3], e[4]),
  985171141: (e) => new d.IfcTable(e[0], e[1], e[2]),
  2043862942: (e) => new d.IfcTableColumn(e[0], e[1], e[2], e[3], e[4]),
  531007025: (e) => new d.IfcTableRow(e[0], e[1]),
  1549132990: (e) => new d.IfcTaskTime(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], e[17], e[18], e[19]),
  2771591690: (e) => new d.IfcTaskTimeRecurring(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], e[17], e[18], e[19], e[20]),
  912023232: (e) => new d.IfcTelecomAddress(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1447204868: (e) => new d.IfcTextStyle(e[0], e[1], e[2], e[3], e[4]),
  2636378356: (e) => new d.IfcTextStyleForDefinedFont(e[0], e[1]),
  1640371178: (e) => new d.IfcTextStyleTextModel(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  280115917: (e) => new d.IfcTextureCoordinate(e[0]),
  1742049831: (e) => new d.IfcTextureCoordinateGenerator(e[0], e[1], e[2]),
  2552916305: (e) => new d.IfcTextureMap(e[0], e[1], e[2]),
  1210645708: (e) => new d.IfcTextureVertex(e[0]),
  3611470254: (e) => new d.IfcTextureVertexList(e[0]),
  1199560280: (e) => new d.IfcTimePeriod(e[0], e[1]),
  3101149627: (e) => new d.IfcTimeSeries(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  581633288: (e) => new d.IfcTimeSeriesValue(e[0]),
  1377556343: (e) => new d.IfcTopologicalRepresentationItem(),
  1735638870: (e) => new d.IfcTopologyRepresentation(e[0], e[1], e[2], e[3]),
  180925521: (e) => new d.IfcUnitAssignment(e[0]),
  2799835756: (e) => new d.IfcVertex(),
  1907098498: (e) => new d.IfcVertexPoint(e[0]),
  891718957: (e) => new d.IfcVirtualGridIntersection(e[0], e[1]),
  1236880293: (e) => new d.IfcWorkTime(e[0], e[1], e[2], e[3], e[4], e[5]),
  3869604511: (e) => new d.IfcApprovalRelationship(e[0], e[1], e[2], e[3]),
  3798115385: (e) => new d.IfcArbitraryClosedProfileDef(e[0], e[1], e[2]),
  1310608509: (e) => new d.IfcArbitraryOpenProfileDef(e[0], e[1], e[2]),
  2705031697: (e) => new d.IfcArbitraryProfileDefWithVoids(e[0], e[1], e[2], e[3]),
  616511568: (e) => new d.IfcBlobTexture(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3150382593: (e) => new d.IfcCenterLineProfileDef(e[0], e[1], e[2], e[3]),
  747523909: (e) => new d.IfcClassification(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  647927063: (e) => new d.IfcClassificationReference(e[0], e[1], e[2], e[3], e[4], e[5]),
  3285139300: (e) => new d.IfcColourRgbList(e[0]),
  3264961684: (e) => new d.IfcColourSpecification(e[0]),
  1485152156: (e) => new d.IfcCompositeProfileDef(e[0], e[1], e[2], e[3]),
  370225590: (e) => new d.IfcConnectedFaceSet(e[0]),
  1981873012: (e) => new d.IfcConnectionCurveGeometry(e[0], e[1]),
  45288368: (e) => new d.IfcConnectionPointEccentricity(e[0], e[1], e[2], e[3], e[4]),
  3050246964: (e) => new d.IfcContextDependentUnit(e[0], e[1], e[2]),
  2889183280: (e) => new d.IfcConversionBasedUnit(e[0], e[1], e[2], e[3]),
  2713554722: (e) => new d.IfcConversionBasedUnitWithOffset(e[0], e[1], e[2], e[3], e[4]),
  539742890: (e) => new d.IfcCurrencyRelationship(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3800577675: (e) => new d.IfcCurveStyle(e[0], e[1], e[2], e[3], e[4]),
  1105321065: (e) => new d.IfcCurveStyleFont(e[0], e[1]),
  2367409068: (e) => new d.IfcCurveStyleFontAndScaling(e[0], e[1], e[2]),
  3510044353: (e) => new d.IfcCurveStyleFontPattern(e[0], e[1]),
  3632507154: (e) => new d.IfcDerivedProfileDef(e[0], e[1], e[2], e[3], e[4]),
  1154170062: (e) => new d.IfcDocumentInformation(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16]),
  770865208: (e) => new d.IfcDocumentInformationRelationship(e[0], e[1], e[2], e[3], e[4]),
  3732053477: (e) => new d.IfcDocumentReference(e[0], e[1], e[2], e[3], e[4]),
  3900360178: (e) => new d.IfcEdge(e[0], e[1]),
  476780140: (e) => new d.IfcEdgeCurve(e[0], e[1], e[2], e[3]),
  211053100: (e) => new d.IfcEventTime(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  297599258: (e) => new d.IfcExtendedProperties(e[0], e[1], e[2]),
  1437805879: (e) => new d.IfcExternalReferenceRelationship(e[0], e[1], e[2], e[3]),
  2556980723: (e) => new d.IfcFace(e[0]),
  1809719519: (e) => new d.IfcFaceBound(e[0], e[1]),
  803316827: (e) => new d.IfcFaceOuterBound(e[0], e[1]),
  3008276851: (e) => new d.IfcFaceSurface(e[0], e[1], e[2]),
  4219587988: (e) => new d.IfcFailureConnectionCondition(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  738692330: (e) => new d.IfcFillAreaStyle(e[0], e[1], e[2]),
  3448662350: (e) => new d.IfcGeometricRepresentationContext(e[0], e[1], e[2], e[3], e[4], e[5]),
  2453401579: (e) => new d.IfcGeometricRepresentationItem(),
  4142052618: (e) => new d.IfcGeometricRepresentationSubContext(e[0], e[1], e[2], e[3], e[4], e[5]),
  3590301190: (e) => new d.IfcGeometricSet(e[0]),
  178086475: (e) => new d.IfcGridPlacement(e[0], e[1]),
  812098782: (e) => new d.IfcHalfSpaceSolid(e[0], e[1]),
  3905492369: (e) => new d.IfcImageTexture(e[0], e[1], e[2], e[3], e[4], e[5]),
  3570813810: (e) => new d.IfcIndexedColourMap(e[0], e[1], e[2], e[3]),
  1437953363: (e) => new d.IfcIndexedTextureMap(e[0], e[1], e[2]),
  2133299955: (e) => new d.IfcIndexedTriangleTextureMap(e[0], e[1], e[2], e[3]),
  3741457305: (e) => new d.IfcIrregularTimeSeries(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1585845231: (e) => new d.IfcLagTime(e[0], e[1], e[2], e[3], e[4]),
  1402838566: (e) => new d.IfcLightSource(e[0], e[1], e[2], e[3]),
  125510826: (e) => new d.IfcLightSourceAmbient(e[0], e[1], e[2], e[3]),
  2604431987: (e) => new d.IfcLightSourceDirectional(e[0], e[1], e[2], e[3], e[4]),
  4266656042: (e) => new d.IfcLightSourceGoniometric(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1520743889: (e) => new d.IfcLightSourcePositional(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3422422726: (e) => new d.IfcLightSourceSpot(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  2624227202: (e) => new d.IfcLocalPlacement(e[0], e[1]),
  1008929658: (e) => new d.IfcLoop(),
  2347385850: (e) => new d.IfcMappedItem(e[0], e[1]),
  1838606355: (e) => new d.IfcMaterial(e[0], e[1], e[2]),
  3708119e3: (e) => new d.IfcMaterialConstituent(e[0], e[1], e[2], e[3], e[4]),
  2852063980: (e) => new d.IfcMaterialConstituentSet(e[0], e[1], e[2]),
  2022407955: (e) => new d.IfcMaterialDefinitionRepresentation(e[0], e[1], e[2], e[3]),
  1303795690: (e) => new d.IfcMaterialLayerSetUsage(e[0], e[1], e[2], e[3], e[4]),
  3079605661: (e) => new d.IfcMaterialProfileSetUsage(e[0], e[1], e[2]),
  3404854881: (e) => new d.IfcMaterialProfileSetUsageTapering(e[0], e[1], e[2], e[3], e[4]),
  3265635763: (e) => new d.IfcMaterialProperties(e[0], e[1], e[2], e[3]),
  853536259: (e) => new d.IfcMaterialRelationship(e[0], e[1], e[2], e[3], e[4]),
  2998442950: (e) => new d.IfcMirroredProfileDef(e[0], e[1], e[2], e[3]),
  219451334: (e) => new d.IfcObjectDefinition(e[0], e[1], e[2], e[3]),
  2665983363: (e) => new d.IfcOpenShell(e[0]),
  1411181986: (e) => new d.IfcOrganizationRelationship(e[0], e[1], e[2], e[3]),
  1029017970: (e) => new d.IfcOrientedEdge(e[0], e[1]),
  2529465313: (e) => new d.IfcParameterizedProfileDef(e[0], e[1], e[2]),
  2519244187: (e) => new d.IfcPath(e[0]),
  3021840470: (e) => new d.IfcPhysicalComplexQuantity(e[0], e[1], e[2], e[3], e[4], e[5]),
  597895409: (e) => new d.IfcPixelTexture(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2004835150: (e) => new d.IfcPlacement(e[0]),
  1663979128: (e) => new d.IfcPlanarExtent(e[0], e[1]),
  2067069095: (e) => new d.IfcPoint(),
  4022376103: (e) => new d.IfcPointOnCurve(e[0], e[1]),
  1423911732: (e) => new d.IfcPointOnSurface(e[0], e[1], e[2]),
  2924175390: (e) => new d.IfcPolyLoop(e[0]),
  2775532180: (e) => new d.IfcPolygonalBoundedHalfSpace(e[0], e[1], e[2], e[3]),
  3727388367: (e) => new d.IfcPreDefinedItem(e[0]),
  3778827333: (e) => new d.IfcPreDefinedProperties(),
  1775413392: (e) => new d.IfcPreDefinedTextFont(e[0]),
  673634403: (e) => new d.IfcProductDefinitionShape(e[0], e[1], e[2]),
  2802850158: (e) => new d.IfcProfileProperties(e[0], e[1], e[2], e[3]),
  2598011224: (e) => new d.IfcProperty(e[0], e[1]),
  1680319473: (e) => new d.IfcPropertyDefinition(e[0], e[1], e[2], e[3]),
  148025276: (e) => new d.IfcPropertyDependencyRelationship(e[0], e[1], e[2], e[3], e[4]),
  3357820518: (e) => new d.IfcPropertySetDefinition(e[0], e[1], e[2], e[3]),
  1482703590: (e) => new d.IfcPropertyTemplateDefinition(e[0], e[1], e[2], e[3]),
  2090586900: (e) => new d.IfcQuantitySet(e[0], e[1], e[2], e[3]),
  3615266464: (e) => new d.IfcRectangleProfileDef(e[0], e[1], e[2], e[3], e[4]),
  3413951693: (e) => new d.IfcRegularTimeSeries(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1580146022: (e) => new d.IfcReinforcementBarProperties(e[0], e[1], e[2], e[3], e[4], e[5]),
  478536968: (e) => new d.IfcRelationship(e[0], e[1], e[2], e[3]),
  2943643501: (e) => new d.IfcResourceApprovalRelationship(e[0], e[1], e[2], e[3]),
  1608871552: (e) => new d.IfcResourceConstraintRelationship(e[0], e[1], e[2], e[3]),
  1042787934: (e) => new d.IfcResourceTime(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], e[17]),
  2778083089: (e) => new d.IfcRoundedRectangleProfileDef(e[0], e[1], e[2], e[3], e[4], e[5]),
  2042790032: (e) => new d.IfcSectionProperties(e[0], e[1], e[2]),
  4165799628: (e) => new d.IfcSectionReinforcementProperties(e[0], e[1], e[2], e[3], e[4], e[5]),
  1509187699: (e) => new d.IfcSectionedSpine(e[0], e[1], e[2]),
  4124623270: (e) => new d.IfcShellBasedSurfaceModel(e[0]),
  3692461612: (e) => new d.IfcSimpleProperty(e[0], e[1]),
  2609359061: (e) => new d.IfcSlippageConnectionCondition(e[0], e[1], e[2], e[3]),
  723233188: (e) => new d.IfcSolidModel(),
  1595516126: (e) => new d.IfcStructuralLoadLinearForce(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2668620305: (e) => new d.IfcStructuralLoadPlanarForce(e[0], e[1], e[2], e[3]),
  2473145415: (e) => new d.IfcStructuralLoadSingleDisplacement(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1973038258: (e) => new d.IfcStructuralLoadSingleDisplacementDistortion(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1597423693: (e) => new d.IfcStructuralLoadSingleForce(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1190533807: (e) => new d.IfcStructuralLoadSingleForceWarping(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2233826070: (e) => new d.IfcSubedge(e[0], e[1], e[2]),
  2513912981: (e) => new d.IfcSurface(),
  1878645084: (e) => new d.IfcSurfaceStyleRendering(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2247615214: (e) => new d.IfcSweptAreaSolid(e[0], e[1]),
  1260650574: (e) => new d.IfcSweptDiskSolid(e[0], e[1], e[2], e[3], e[4]),
  1096409881: (e) => new d.IfcSweptDiskSolidPolygonal(e[0], e[1], e[2], e[3], e[4], e[5]),
  230924584: (e) => new d.IfcSweptSurface(e[0], e[1]),
  3071757647: (e) => new d.IfcTShapeProfileDef(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  901063453: (e) => new d.IfcTessellatedItem(),
  4282788508: (e) => new d.IfcTextLiteral(e[0], e[1], e[2]),
  3124975700: (e) => new d.IfcTextLiteralWithExtent(e[0], e[1], e[2], e[3], e[4]),
  1983826977: (e) => new d.IfcTextStyleFontModel(e[0], e[1], e[2], e[3], e[4], e[5]),
  2715220739: (e) => new d.IfcTrapeziumProfileDef(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1628702193: (e) => new d.IfcTypeObject(e[0], e[1], e[2], e[3], e[4], e[5]),
  3736923433: (e) => new d.IfcTypeProcess(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2347495698: (e) => new d.IfcTypeProduct(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3698973494: (e) => new d.IfcTypeResource(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  427810014: (e) => new d.IfcUShapeProfileDef(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1417489154: (e) => new d.IfcVector(e[0], e[1]),
  2759199220: (e) => new d.IfcVertexLoop(e[0]),
  1299126871: (e) => new d.IfcWindowStyle(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  2543172580: (e) => new d.IfcZShapeProfileDef(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3406155212: (e) => new d.IfcAdvancedFace(e[0], e[1], e[2]),
  669184980: (e) => new d.IfcAnnotationFillArea(e[0], e[1]),
  3207858831: (e) => new d.IfcAsymmetricIShapeProfileDef(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14]),
  4261334040: (e) => new d.IfcAxis1Placement(e[0], e[1]),
  3125803723: (e) => new d.IfcAxis2Placement2D(e[0], e[1]),
  2740243338: (e) => new d.IfcAxis2Placement3D(e[0], e[1], e[2]),
  2736907675: (e) => new d.IfcBooleanResult(e[0], e[1], e[2]),
  4182860854: (e) => new d.IfcBoundedSurface(),
  2581212453: (e) => new d.IfcBoundingBox(e[0], e[1], e[2], e[3]),
  2713105998: (e) => new d.IfcBoxedHalfSpace(e[0], e[1], e[2]),
  2898889636: (e) => new d.IfcCShapeProfileDef(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1123145078: (e) => new d.IfcCartesianPoint(e[0]),
  574549367: (e) => new d.IfcCartesianPointList(),
  1675464909: (e) => new d.IfcCartesianPointList2D(e[0]),
  2059837836: (e) => new d.IfcCartesianPointList3D(e[0]),
  59481748: (e) => new d.IfcCartesianTransformationOperator(e[0], e[1], e[2], e[3]),
  3749851601: (e) => new d.IfcCartesianTransformationOperator2D(e[0], e[1], e[2], e[3]),
  3486308946: (e) => new d.IfcCartesianTransformationOperator2DnonUniform(e[0], e[1], e[2], e[3], e[4]),
  3331915920: (e) => new d.IfcCartesianTransformationOperator3D(e[0], e[1], e[2], e[3], e[4]),
  1416205885: (e) => new d.IfcCartesianTransformationOperator3DnonUniform(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1383045692: (e) => new d.IfcCircleProfileDef(e[0], e[1], e[2], e[3]),
  2205249479: (e) => new d.IfcClosedShell(e[0]),
  776857604: (e) => new d.IfcColourRgb(e[0], e[1], e[2], e[3]),
  2542286263: (e) => new d.IfcComplexProperty(e[0], e[1], e[2], e[3]),
  2485617015: (e) => new d.IfcCompositeCurveSegment(e[0], e[1], e[2]),
  2574617495: (e) => new d.IfcConstructionResourceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  3419103109: (e) => new d.IfcContext(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1815067380: (e) => new d.IfcCrewResourceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  2506170314: (e) => new d.IfcCsgPrimitive3D(e[0]),
  2147822146: (e) => new d.IfcCsgSolid(e[0]),
  2601014836: (e) => new d.IfcCurve(),
  2827736869: (e) => new d.IfcCurveBoundedPlane(e[0], e[1], e[2]),
  2629017746: (e) => new d.IfcCurveBoundedSurface(e[0], e[1], e[2]),
  32440307: (e) => new d.IfcDirection(e[0]),
  526551008: (e) => new d.IfcDoorStyle(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1472233963: (e) => new d.IfcEdgeLoop(e[0]),
  1883228015: (e) => new d.IfcElementQuantity(e[0], e[1], e[2], e[3], e[4], e[5]),
  339256511: (e) => new d.IfcElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2777663545: (e) => new d.IfcElementarySurface(e[0]),
  2835456948: (e) => new d.IfcEllipseProfileDef(e[0], e[1], e[2], e[3], e[4]),
  4024345920: (e) => new d.IfcEventType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  477187591: (e) => new d.IfcExtrudedAreaSolid(e[0], e[1], e[2], e[3]),
  2804161546: (e) => new d.IfcExtrudedAreaSolidTapered(e[0], e[1], e[2], e[3], e[4]),
  2047409740: (e) => new d.IfcFaceBasedSurfaceModel(e[0]),
  374418227: (e) => new d.IfcFillAreaStyleHatching(e[0], e[1], e[2], e[3], e[4]),
  315944413: (e) => new d.IfcFillAreaStyleTiles(e[0], e[1], e[2]),
  2652556860: (e) => new d.IfcFixedReferenceSweptAreaSolid(e[0], e[1], e[2], e[3], e[4], e[5]),
  4238390223: (e) => new d.IfcFurnishingElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1268542332: (e) => new d.IfcFurnitureType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  4095422895: (e) => new d.IfcGeographicElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  987898635: (e) => new d.IfcGeometricCurveSet(e[0]),
  1484403080: (e) => new d.IfcIShapeProfileDef(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  178912537: (e) => new d.IfcIndexedPolygonalFace(e[0]),
  2294589976: (e) => new d.IfcIndexedPolygonalFaceWithVoids(e[0], e[1]),
  572779678: (e) => new d.IfcLShapeProfileDef(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  428585644: (e) => new d.IfcLaborResourceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1281925730: (e) => new d.IfcLine(e[0], e[1]),
  1425443689: (e) => new d.IfcManifoldSolidBrep(e[0]),
  3888040117: (e) => new d.IfcObject(e[0], e[1], e[2], e[3], e[4]),
  3388369263: (e) => new d.IfcOffsetCurve2D(e[0], e[1], e[2]),
  3505215534: (e) => new d.IfcOffsetCurve3D(e[0], e[1], e[2], e[3]),
  1682466193: (e) => new d.IfcPcurve(e[0], e[1]),
  603570806: (e) => new d.IfcPlanarBox(e[0], e[1], e[2]),
  220341763: (e) => new d.IfcPlane(e[0]),
  759155922: (e) => new d.IfcPreDefinedColour(e[0]),
  2559016684: (e) => new d.IfcPreDefinedCurveFont(e[0]),
  3967405729: (e) => new d.IfcPreDefinedPropertySet(e[0], e[1], e[2], e[3]),
  569719735: (e) => new d.IfcProcedureType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2945172077: (e) => new d.IfcProcess(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  4208778838: (e) => new d.IfcProduct(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  103090709: (e) => new d.IfcProject(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  653396225: (e) => new d.IfcProjectLibrary(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  871118103: (e) => new d.IfcPropertyBoundedValue(e[0], e[1], e[2], e[3], e[4], e[5]),
  4166981789: (e) => new d.IfcPropertyEnumeratedValue(e[0], e[1], e[2], e[3]),
  2752243245: (e) => new d.IfcPropertyListValue(e[0], e[1], e[2], e[3]),
  941946838: (e) => new d.IfcPropertyReferenceValue(e[0], e[1], e[2], e[3]),
  1451395588: (e) => new d.IfcPropertySet(e[0], e[1], e[2], e[3], e[4]),
  492091185: (e) => new d.IfcPropertySetTemplate(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3650150729: (e) => new d.IfcPropertySingleValue(e[0], e[1], e[2], e[3]),
  110355661: (e) => new d.IfcPropertyTableValue(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3521284610: (e) => new d.IfcPropertyTemplate(e[0], e[1], e[2], e[3]),
  3219374653: (e) => new d.IfcProxy(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2770003689: (e) => new d.IfcRectangleHollowProfileDef(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2798486643: (e) => new d.IfcRectangularPyramid(e[0], e[1], e[2], e[3]),
  3454111270: (e) => new d.IfcRectangularTrimmedSurface(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3765753017: (e) => new d.IfcReinforcementDefinitionProperties(e[0], e[1], e[2], e[3], e[4], e[5]),
  3939117080: (e) => new d.IfcRelAssigns(e[0], e[1], e[2], e[3], e[4], e[5]),
  1683148259: (e) => new d.IfcRelAssignsToActor(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2495723537: (e) => new d.IfcRelAssignsToControl(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1307041759: (e) => new d.IfcRelAssignsToGroup(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1027710054: (e) => new d.IfcRelAssignsToGroupByFactor(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  4278684876: (e) => new d.IfcRelAssignsToProcess(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2857406711: (e) => new d.IfcRelAssignsToProduct(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  205026976: (e) => new d.IfcRelAssignsToResource(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1865459582: (e) => new d.IfcRelAssociates(e[0], e[1], e[2], e[3], e[4]),
  4095574036: (e) => new d.IfcRelAssociatesApproval(e[0], e[1], e[2], e[3], e[4], e[5]),
  919958153: (e) => new d.IfcRelAssociatesClassification(e[0], e[1], e[2], e[3], e[4], e[5]),
  2728634034: (e) => new d.IfcRelAssociatesConstraint(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  982818633: (e) => new d.IfcRelAssociatesDocument(e[0], e[1], e[2], e[3], e[4], e[5]),
  3840914261: (e) => new d.IfcRelAssociatesLibrary(e[0], e[1], e[2], e[3], e[4], e[5]),
  2655215786: (e) => new d.IfcRelAssociatesMaterial(e[0], e[1], e[2], e[3], e[4], e[5]),
  826625072: (e) => new d.IfcRelConnects(e[0], e[1], e[2], e[3]),
  1204542856: (e) => new d.IfcRelConnectsElements(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3945020480: (e) => new d.IfcRelConnectsPathElements(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  4201705270: (e) => new d.IfcRelConnectsPortToElement(e[0], e[1], e[2], e[3], e[4], e[5]),
  3190031847: (e) => new d.IfcRelConnectsPorts(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2127690289: (e) => new d.IfcRelConnectsStructuralActivity(e[0], e[1], e[2], e[3], e[4], e[5]),
  1638771189: (e) => new d.IfcRelConnectsStructuralMember(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  504942748: (e) => new d.IfcRelConnectsWithEccentricity(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  3678494232: (e) => new d.IfcRelConnectsWithRealizingElements(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3242617779: (e) => new d.IfcRelContainedInSpatialStructure(e[0], e[1], e[2], e[3], e[4], e[5]),
  886880790: (e) => new d.IfcRelCoversBldgElements(e[0], e[1], e[2], e[3], e[4], e[5]),
  2802773753: (e) => new d.IfcRelCoversSpaces(e[0], e[1], e[2], e[3], e[4], e[5]),
  2565941209: (e) => new d.IfcRelDeclares(e[0], e[1], e[2], e[3], e[4], e[5]),
  2551354335: (e) => new d.IfcRelDecomposes(e[0], e[1], e[2], e[3]),
  693640335: (e) => new d.IfcRelDefines(e[0], e[1], e[2], e[3]),
  1462361463: (e) => new d.IfcRelDefinesByObject(e[0], e[1], e[2], e[3], e[4], e[5]),
  4186316022: (e) => new d.IfcRelDefinesByProperties(e[0], e[1], e[2], e[3], e[4], e[5]),
  307848117: (e) => new d.IfcRelDefinesByTemplate(e[0], e[1], e[2], e[3], e[4], e[5]),
  781010003: (e) => new d.IfcRelDefinesByType(e[0], e[1], e[2], e[3], e[4], e[5]),
  3940055652: (e) => new d.IfcRelFillsElement(e[0], e[1], e[2], e[3], e[4], e[5]),
  279856033: (e) => new d.IfcRelFlowControlElements(e[0], e[1], e[2], e[3], e[4], e[5]),
  427948657: (e) => new d.IfcRelInterferesElements(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3268803585: (e) => new d.IfcRelNests(e[0], e[1], e[2], e[3], e[4], e[5]),
  750771296: (e) => new d.IfcRelProjectsElement(e[0], e[1], e[2], e[3], e[4], e[5]),
  1245217292: (e) => new d.IfcRelReferencedInSpatialStructure(e[0], e[1], e[2], e[3], e[4], e[5]),
  4122056220: (e) => new d.IfcRelSequence(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  366585022: (e) => new d.IfcRelServicesBuildings(e[0], e[1], e[2], e[3], e[4], e[5]),
  3451746338: (e) => new d.IfcRelSpaceBoundary(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3523091289: (e) => new d.IfcRelSpaceBoundary1stLevel(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1521410863: (e) => new d.IfcRelSpaceBoundary2ndLevel(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1401173127: (e) => new d.IfcRelVoidsElement(e[0], e[1], e[2], e[3], e[4], e[5]),
  816062949: (e) => new d.IfcReparametrisedCompositeCurveSegment(e[0], e[1], e[2], e[3]),
  2914609552: (e) => new d.IfcResource(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1856042241: (e) => new d.IfcRevolvedAreaSolid(e[0], e[1], e[2], e[3]),
  3243963512: (e) => new d.IfcRevolvedAreaSolidTapered(e[0], e[1], e[2], e[3], e[4]),
  4158566097: (e) => new d.IfcRightCircularCone(e[0], e[1], e[2]),
  3626867408: (e) => new d.IfcRightCircularCylinder(e[0], e[1], e[2]),
  3663146110: (e) => new d.IfcSimplePropertyTemplate(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1412071761: (e) => new d.IfcSpatialElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  710998568: (e) => new d.IfcSpatialElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2706606064: (e) => new d.IfcSpatialStructureElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3893378262: (e) => new d.IfcSpatialStructureElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  463610769: (e) => new d.IfcSpatialZone(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2481509218: (e) => new d.IfcSpatialZoneType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  451544542: (e) => new d.IfcSphere(e[0], e[1]),
  4015995234: (e) => new d.IfcSphericalSurface(e[0], e[1]),
  3544373492: (e) => new d.IfcStructuralActivity(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3136571912: (e) => new d.IfcStructuralItem(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  530289379: (e) => new d.IfcStructuralMember(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3689010777: (e) => new d.IfcStructuralReaction(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3979015343: (e) => new d.IfcStructuralSurfaceMember(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2218152070: (e) => new d.IfcStructuralSurfaceMemberVarying(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  603775116: (e) => new d.IfcStructuralSurfaceReaction(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4095615324: (e) => new d.IfcSubContractResourceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  699246055: (e) => new d.IfcSurfaceCurve(e[0], e[1], e[2]),
  2028607225: (e) => new d.IfcSurfaceCurveSweptAreaSolid(e[0], e[1], e[2], e[3], e[4], e[5]),
  2809605785: (e) => new d.IfcSurfaceOfLinearExtrusion(e[0], e[1], e[2], e[3]),
  4124788165: (e) => new d.IfcSurfaceOfRevolution(e[0], e[1], e[2]),
  1580310250: (e) => new d.IfcSystemFurnitureElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3473067441: (e) => new d.IfcTask(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  3206491090: (e) => new d.IfcTaskType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  2387106220: (e) => new d.IfcTessellatedFaceSet(e[0]),
  1935646853: (e) => new d.IfcToroidalSurface(e[0], e[1], e[2]),
  2097647324: (e) => new d.IfcTransportElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2916149573: (e) => new d.IfcTriangulatedFaceSet(e[0], e[1], e[2], e[3], e[4]),
  336235671: (e) => new d.IfcWindowLiningProperties(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15]),
  512836454: (e) => new d.IfcWindowPanelProperties(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2296667514: (e) => new d.IfcActor(e[0], e[1], e[2], e[3], e[4], e[5]),
  1635779807: (e) => new d.IfcAdvancedBrep(e[0]),
  2603310189: (e) => new d.IfcAdvancedBrepWithVoids(e[0], e[1]),
  1674181508: (e) => new d.IfcAnnotation(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2887950389: (e) => new d.IfcBSplineSurface(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  167062518: (e) => new d.IfcBSplineSurfaceWithKnots(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1334484129: (e) => new d.IfcBlock(e[0], e[1], e[2], e[3]),
  3649129432: (e) => new d.IfcBooleanClippingResult(e[0], e[1], e[2]),
  1260505505: (e) => new d.IfcBoundedCurve(),
  4031249490: (e) => new d.IfcBuilding(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1950629157: (e) => new d.IfcBuildingElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3124254112: (e) => new d.IfcBuildingStorey(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2197970202: (e) => new d.IfcChimneyType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2937912522: (e) => new d.IfcCircleHollowProfileDef(e[0], e[1], e[2], e[3], e[4]),
  3893394355: (e) => new d.IfcCivilElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  300633059: (e) => new d.IfcColumnType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3875453745: (e) => new d.IfcComplexPropertyTemplate(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3732776249: (e) => new d.IfcCompositeCurve(e[0], e[1]),
  15328376: (e) => new d.IfcCompositeCurveOnSurface(e[0], e[1]),
  2510884976: (e) => new d.IfcConic(e[0]),
  2185764099: (e) => new d.IfcConstructionEquipmentResourceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  4105962743: (e) => new d.IfcConstructionMaterialResourceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1525564444: (e) => new d.IfcConstructionProductResourceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  2559216714: (e) => new d.IfcConstructionResource(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3293443760: (e) => new d.IfcControl(e[0], e[1], e[2], e[3], e[4], e[5]),
  3895139033: (e) => new d.IfcCostItem(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1419761937: (e) => new d.IfcCostSchedule(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1916426348: (e) => new d.IfcCoveringType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3295246426: (e) => new d.IfcCrewResource(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1457835157: (e) => new d.IfcCurtainWallType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1213902940: (e) => new d.IfcCylindricalSurface(e[0], e[1]),
  3256556792: (e) => new d.IfcDistributionElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3849074793: (e) => new d.IfcDistributionFlowElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2963535650: (e) => new d.IfcDoorLiningProperties(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16]),
  1714330368: (e) => new d.IfcDoorPanelProperties(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2323601079: (e) => new d.IfcDoorType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  445594917: (e) => new d.IfcDraughtingPreDefinedColour(e[0]),
  4006246654: (e) => new d.IfcDraughtingPreDefinedCurveFont(e[0]),
  1758889154: (e) => new d.IfcElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  4123344466: (e) => new d.IfcElementAssembly(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2397081782: (e) => new d.IfcElementAssemblyType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1623761950: (e) => new d.IfcElementComponent(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2590856083: (e) => new d.IfcElementComponentType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1704287377: (e) => new d.IfcEllipse(e[0], e[1], e[2]),
  2107101300: (e) => new d.IfcEnergyConversionDeviceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  132023988: (e) => new d.IfcEngineType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3174744832: (e) => new d.IfcEvaporativeCoolerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3390157468: (e) => new d.IfcEvaporatorType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4148101412: (e) => new d.IfcEvent(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  2853485674: (e) => new d.IfcExternalSpatialStructureElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  807026263: (e) => new d.IfcFacetedBrep(e[0]),
  3737207727: (e) => new d.IfcFacetedBrepWithVoids(e[0], e[1]),
  647756555: (e) => new d.IfcFastener(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2489546625: (e) => new d.IfcFastenerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2827207264: (e) => new d.IfcFeatureElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2143335405: (e) => new d.IfcFeatureElementAddition(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1287392070: (e) => new d.IfcFeatureElementSubtraction(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3907093117: (e) => new d.IfcFlowControllerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3198132628: (e) => new d.IfcFlowFittingType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3815607619: (e) => new d.IfcFlowMeterType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1482959167: (e) => new d.IfcFlowMovingDeviceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1834744321: (e) => new d.IfcFlowSegmentType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1339347760: (e) => new d.IfcFlowStorageDeviceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2297155007: (e) => new d.IfcFlowTerminalType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3009222698: (e) => new d.IfcFlowTreatmentDeviceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1893162501: (e) => new d.IfcFootingType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  263784265: (e) => new d.IfcFurnishingElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1509553395: (e) => new d.IfcFurniture(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3493046030: (e) => new d.IfcGeographicElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3009204131: (e) => new d.IfcGrid(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  2706460486: (e) => new d.IfcGroup(e[0], e[1], e[2], e[3], e[4]),
  1251058090: (e) => new d.IfcHeatExchangerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1806887404: (e) => new d.IfcHumidifierType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2571569899: (e) => new d.IfcIndexedPolyCurve(e[0], e[1], e[2]),
  3946677679: (e) => new d.IfcInterceptorType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3113134337: (e) => new d.IfcIntersectionCurve(e[0], e[1], e[2]),
  2391368822: (e) => new d.IfcInventory(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  4288270099: (e) => new d.IfcJunctionBoxType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3827777499: (e) => new d.IfcLaborResource(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1051575348: (e) => new d.IfcLampType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1161773419: (e) => new d.IfcLightFixtureType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  377706215: (e) => new d.IfcMechanicalFastener(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  2108223431: (e) => new d.IfcMechanicalFastenerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1114901282: (e) => new d.IfcMedicalDeviceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3181161470: (e) => new d.IfcMemberType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  977012517: (e) => new d.IfcMotorConnectionType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4143007308: (e) => new d.IfcOccupant(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3588315303: (e) => new d.IfcOpeningElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3079942009: (e) => new d.IfcOpeningStandardCase(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2837617999: (e) => new d.IfcOutletType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2382730787: (e) => new d.IfcPerformanceHistory(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3566463478: (e) => new d.IfcPermeableCoveringProperties(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3327091369: (e) => new d.IfcPermit(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1158309216: (e) => new d.IfcPileType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  804291784: (e) => new d.IfcPipeFittingType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4231323485: (e) => new d.IfcPipeSegmentType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4017108033: (e) => new d.IfcPlateType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2839578677: (e) => new d.IfcPolygonalFaceSet(e[0], e[1], e[2], e[3]),
  3724593414: (e) => new d.IfcPolyline(e[0]),
  3740093272: (e) => new d.IfcPort(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2744685151: (e) => new d.IfcProcedure(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2904328755: (e) => new d.IfcProjectOrder(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3651124850: (e) => new d.IfcProjectionElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1842657554: (e) => new d.IfcProtectiveDeviceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2250791053: (e) => new d.IfcPumpType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2893384427: (e) => new d.IfcRailingType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2324767716: (e) => new d.IfcRampFlightType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1469900589: (e) => new d.IfcRampType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  683857671: (e) => new d.IfcRationalBSplineSurfaceWithKnots(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  3027567501: (e) => new d.IfcReinforcingElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  964333572: (e) => new d.IfcReinforcingElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2320036040: (e) => new d.IfcReinforcingMesh(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], e[17]),
  2310774935: (e) => new d.IfcReinforcingMeshType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], e[17], e[18], e[19]),
  160246688: (e) => new d.IfcRelAggregates(e[0], e[1], e[2], e[3], e[4], e[5]),
  2781568857: (e) => new d.IfcRoofType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1768891740: (e) => new d.IfcSanitaryTerminalType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2157484638: (e) => new d.IfcSeamCurve(e[0], e[1], e[2]),
  4074543187: (e) => new d.IfcShadingDeviceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4097777520: (e) => new d.IfcSite(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13]),
  2533589738: (e) => new d.IfcSlabType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1072016465: (e) => new d.IfcSolarDeviceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3856911033: (e) => new d.IfcSpace(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1305183839: (e) => new d.IfcSpaceHeaterType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3812236995: (e) => new d.IfcSpaceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  3112655638: (e) => new d.IfcStackTerminalType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1039846685: (e) => new d.IfcStairFlightType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  338393293: (e) => new d.IfcStairType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  682877961: (e) => new d.IfcStructuralAction(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1179482911: (e) => new d.IfcStructuralConnection(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1004757350: (e) => new d.IfcStructuralCurveAction(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  4243806635: (e) => new d.IfcStructuralCurveConnection(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  214636428: (e) => new d.IfcStructuralCurveMember(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2445595289: (e) => new d.IfcStructuralCurveMemberVarying(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2757150158: (e) => new d.IfcStructuralCurveReaction(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1807405624: (e) => new d.IfcStructuralLinearAction(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1252848954: (e) => new d.IfcStructuralLoadGroup(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2082059205: (e) => new d.IfcStructuralPointAction(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  734778138: (e) => new d.IfcStructuralPointConnection(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1235345126: (e) => new d.IfcStructuralPointReaction(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2986769608: (e) => new d.IfcStructuralResultGroup(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3657597509: (e) => new d.IfcStructuralSurfaceAction(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1975003073: (e) => new d.IfcStructuralSurfaceConnection(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  148013059: (e) => new d.IfcSubContractResource(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  3101698114: (e) => new d.IfcSurfaceFeature(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2315554128: (e) => new d.IfcSwitchingDeviceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2254336722: (e) => new d.IfcSystem(e[0], e[1], e[2], e[3], e[4]),
  413509423: (e) => new d.IfcSystemFurnitureElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  5716631: (e) => new d.IfcTankType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3824725483: (e) => new d.IfcTendon(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16]),
  2347447852: (e) => new d.IfcTendonAnchor(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3081323446: (e) => new d.IfcTendonAnchorType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2415094496: (e) => new d.IfcTendonType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  1692211062: (e) => new d.IfcTransformerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1620046519: (e) => new d.IfcTransportElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3593883385: (e) => new d.IfcTrimmedCurve(e[0], e[1], e[2], e[3], e[4]),
  1600972822: (e) => new d.IfcTubeBundleType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1911125066: (e) => new d.IfcUnitaryEquipmentType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  728799441: (e) => new d.IfcValveType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2391383451: (e) => new d.IfcVibrationIsolator(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3313531582: (e) => new d.IfcVibrationIsolatorType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2769231204: (e) => new d.IfcVirtualElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  926996030: (e) => new d.IfcVoidingFeature(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1898987631: (e) => new d.IfcWallType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1133259667: (e) => new d.IfcWasteTerminalType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4009809668: (e) => new d.IfcWindowType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  4088093105: (e) => new d.IfcWorkCalendar(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1028945134: (e) => new d.IfcWorkControl(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  4218914973: (e) => new d.IfcWorkPlan(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13]),
  3342526732: (e) => new d.IfcWorkSchedule(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13]),
  1033361043: (e) => new d.IfcZone(e[0], e[1], e[2], e[3], e[4], e[5]),
  3821786052: (e) => new d.IfcActionRequest(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1411407467: (e) => new d.IfcAirTerminalBoxType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3352864051: (e) => new d.IfcAirTerminalType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1871374353: (e) => new d.IfcAirToAirHeatRecoveryType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3460190687: (e) => new d.IfcAsset(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13]),
  1532957894: (e) => new d.IfcAudioVisualApplianceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1967976161: (e) => new d.IfcBSplineCurve(e[0], e[1], e[2], e[3], e[4]),
  2461110595: (e) => new d.IfcBSplineCurveWithKnots(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  819618141: (e) => new d.IfcBeamType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  231477066: (e) => new d.IfcBoilerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1136057603: (e) => new d.IfcBoundaryCurve(e[0], e[1]),
  3299480353: (e) => new d.IfcBuildingElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2979338954: (e) => new d.IfcBuildingElementPart(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  39481116: (e) => new d.IfcBuildingElementPartType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1095909175: (e) => new d.IfcBuildingElementProxy(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1909888760: (e) => new d.IfcBuildingElementProxyType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1177604601: (e) => new d.IfcBuildingSystem(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2188180465: (e) => new d.IfcBurnerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  395041908: (e) => new d.IfcCableCarrierFittingType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3293546465: (e) => new d.IfcCableCarrierSegmentType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2674252688: (e) => new d.IfcCableFittingType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1285652485: (e) => new d.IfcCableSegmentType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2951183804: (e) => new d.IfcChillerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3296154744: (e) => new d.IfcChimney(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2611217952: (e) => new d.IfcCircle(e[0], e[1]),
  1677625105: (e) => new d.IfcCivilElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2301859152: (e) => new d.IfcCoilType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  843113511: (e) => new d.IfcColumn(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  905975707: (e) => new d.IfcColumnStandardCase(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  400855858: (e) => new d.IfcCommunicationsApplianceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3850581409: (e) => new d.IfcCompressorType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2816379211: (e) => new d.IfcCondenserType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3898045240: (e) => new d.IfcConstructionEquipmentResource(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1060000209: (e) => new d.IfcConstructionMaterialResource(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  488727124: (e) => new d.IfcConstructionProductResource(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  335055490: (e) => new d.IfcCooledBeamType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2954562838: (e) => new d.IfcCoolingTowerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1973544240: (e) => new d.IfcCovering(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3495092785: (e) => new d.IfcCurtainWall(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3961806047: (e) => new d.IfcDamperType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1335981549: (e) => new d.IfcDiscreteAccessory(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2635815018: (e) => new d.IfcDiscreteAccessoryType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1599208980: (e) => new d.IfcDistributionChamberElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2063403501: (e) => new d.IfcDistributionControlElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1945004755: (e) => new d.IfcDistributionElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3040386961: (e) => new d.IfcDistributionFlowElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3041715199: (e) => new d.IfcDistributionPort(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3205830791: (e) => new d.IfcDistributionSystem(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  395920057: (e) => new d.IfcDoor(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  3242481149: (e) => new d.IfcDoorStandardCase(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  869906466: (e) => new d.IfcDuctFittingType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3760055223: (e) => new d.IfcDuctSegmentType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2030761528: (e) => new d.IfcDuctSilencerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  663422040: (e) => new d.IfcElectricApplianceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2417008758: (e) => new d.IfcElectricDistributionBoardType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3277789161: (e) => new d.IfcElectricFlowStorageDeviceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1534661035: (e) => new d.IfcElectricGeneratorType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1217240411: (e) => new d.IfcElectricMotorType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  712377611: (e) => new d.IfcElectricTimeControlType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1658829314: (e) => new d.IfcEnergyConversionDevice(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2814081492: (e) => new d.IfcEngine(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3747195512: (e) => new d.IfcEvaporativeCooler(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  484807127: (e) => new d.IfcEvaporator(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1209101575: (e) => new d.IfcExternalSpatialElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  346874300: (e) => new d.IfcFanType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1810631287: (e) => new d.IfcFilterType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4222183408: (e) => new d.IfcFireSuppressionTerminalType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2058353004: (e) => new d.IfcFlowController(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  4278956645: (e) => new d.IfcFlowFitting(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  4037862832: (e) => new d.IfcFlowInstrumentType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2188021234: (e) => new d.IfcFlowMeter(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3132237377: (e) => new d.IfcFlowMovingDevice(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  987401354: (e) => new d.IfcFlowSegment(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  707683696: (e) => new d.IfcFlowStorageDevice(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2223149337: (e) => new d.IfcFlowTerminal(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3508470533: (e) => new d.IfcFlowTreatmentDevice(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  900683007: (e) => new d.IfcFooting(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3319311131: (e) => new d.IfcHeatExchanger(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2068733104: (e) => new d.IfcHumidifier(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4175244083: (e) => new d.IfcInterceptor(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2176052936: (e) => new d.IfcJunctionBox(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  76236018: (e) => new d.IfcLamp(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  629592764: (e) => new d.IfcLightFixture(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1437502449: (e) => new d.IfcMedicalDevice(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1073191201: (e) => new d.IfcMember(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1911478936: (e) => new d.IfcMemberStandardCase(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2474470126: (e) => new d.IfcMotorConnection(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  144952367: (e) => new d.IfcOuterBoundaryCurve(e[0], e[1]),
  3694346114: (e) => new d.IfcOutlet(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1687234759: (e) => new d.IfcPile(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  310824031: (e) => new d.IfcPipeFitting(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3612865200: (e) => new d.IfcPipeSegment(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3171933400: (e) => new d.IfcPlate(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1156407060: (e) => new d.IfcPlateStandardCase(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  738039164: (e) => new d.IfcProtectiveDevice(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  655969474: (e) => new d.IfcProtectiveDeviceTrippingUnitType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  90941305: (e) => new d.IfcPump(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2262370178: (e) => new d.IfcRailing(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3024970846: (e) => new d.IfcRamp(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3283111854: (e) => new d.IfcRampFlight(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1232101972: (e) => new d.IfcRationalBSplineCurveWithKnots(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  979691226: (e) => new d.IfcReinforcingBar(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13]),
  2572171363: (e) => new d.IfcReinforcingBarType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15]),
  2016517767: (e) => new d.IfcRoof(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3053780830: (e) => new d.IfcSanitaryTerminal(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1783015770: (e) => new d.IfcSensorType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1329646415: (e) => new d.IfcShadingDevice(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1529196076: (e) => new d.IfcSlab(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3127900445: (e) => new d.IfcSlabElementedCase(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3027962421: (e) => new d.IfcSlabStandardCase(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3420628829: (e) => new d.IfcSolarDevice(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1999602285: (e) => new d.IfcSpaceHeater(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1404847402: (e) => new d.IfcStackTerminal(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  331165859: (e) => new d.IfcStair(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4252922144: (e) => new d.IfcStairFlight(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  2515109513: (e) => new d.IfcStructuralAnalysisModel(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  385403989: (e) => new d.IfcStructuralLoadCase(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1621171031: (e) => new d.IfcStructuralPlanarAction(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1162798199: (e) => new d.IfcSwitchingDevice(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  812556717: (e) => new d.IfcTank(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3825984169: (e) => new d.IfcTransformer(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3026737570: (e) => new d.IfcTubeBundle(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3179687236: (e) => new d.IfcUnitaryControlElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4292641817: (e) => new d.IfcUnitaryEquipment(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4207607924: (e) => new d.IfcValve(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2391406946: (e) => new d.IfcWall(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4156078855: (e) => new d.IfcWallElementedCase(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3512223829: (e) => new d.IfcWallStandardCase(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4237592921: (e) => new d.IfcWasteTerminal(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3304561284: (e) => new d.IfcWindow(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  486154966: (e) => new d.IfcWindowStandardCase(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  2874132201: (e) => new d.IfcActuatorType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1634111441: (e) => new d.IfcAirTerminal(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  177149247: (e) => new d.IfcAirTerminalBox(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2056796094: (e) => new d.IfcAirToAirHeatRecovery(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3001207471: (e) => new d.IfcAlarmType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  277319702: (e) => new d.IfcAudioVisualAppliance(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  753842376: (e) => new d.IfcBeam(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2906023776: (e) => new d.IfcBeamStandardCase(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  32344328: (e) => new d.IfcBoiler(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2938176219: (e) => new d.IfcBurner(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  635142910: (e) => new d.IfcCableCarrierFitting(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3758799889: (e) => new d.IfcCableCarrierSegment(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1051757585: (e) => new d.IfcCableFitting(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4217484030: (e) => new d.IfcCableSegment(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3902619387: (e) => new d.IfcChiller(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  639361253: (e) => new d.IfcCoil(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3221913625: (e) => new d.IfcCommunicationsAppliance(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3571504051: (e) => new d.IfcCompressor(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2272882330: (e) => new d.IfcCondenser(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  578613899: (e) => new d.IfcControllerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4136498852: (e) => new d.IfcCooledBeam(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3640358203: (e) => new d.IfcCoolingTower(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4074379575: (e) => new d.IfcDamper(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1052013943: (e) => new d.IfcDistributionChamberElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  562808652: (e) => new d.IfcDistributionCircuit(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1062813311: (e) => new d.IfcDistributionControlElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  342316401: (e) => new d.IfcDuctFitting(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3518393246: (e) => new d.IfcDuctSegment(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1360408905: (e) => new d.IfcDuctSilencer(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1904799276: (e) => new d.IfcElectricAppliance(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  862014818: (e) => new d.IfcElectricDistributionBoard(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3310460725: (e) => new d.IfcElectricFlowStorageDevice(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  264262732: (e) => new d.IfcElectricGenerator(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  402227799: (e) => new d.IfcElectricMotor(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1003880860: (e) => new d.IfcElectricTimeControl(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3415622556: (e) => new d.IfcFan(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  819412036: (e) => new d.IfcFilter(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1426591983: (e) => new d.IfcFireSuppressionTerminal(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  182646315: (e) => new d.IfcFlowInstrument(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2295281155: (e) => new d.IfcProtectiveDeviceTrippingUnit(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4086658281: (e) => new d.IfcSensor(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  630975310: (e) => new d.IfcUnitaryControlElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4288193352: (e) => new d.IfcActuator(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3087945054: (e) => new d.IfcAlarm(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  25142252: (e) => new d.IfcController(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8])
};
Pie[2] = {
  3630933823: (e) => [e.Role, e.UserDefinedRole, e.Description],
  618182010: (e) => [e.Purpose, e.Description, e.UserDefinedPurpose],
  639542469: (e) => [e.ApplicationDeveloper, e.Version, e.ApplicationFullName, e.ApplicationIdentifier],
  411424972: (e) => [e.Name, e.Description, ke(e.AppliedValue), e.UnitBasis, e.ApplicableDate, e.FixedUntilDate, e.Category, e.Condition, e.ArithmeticOperator, e.Components],
  130549933: (e) => [e.Identifier, e.Name, e.Description, e.TimeOfApproval, e.Status, e.Level, e.Qualifier, ke(e.RequestingApproval), ke(e.GivingApproval)],
  4037036970: (e) => [e.Name],
  1560379544: (e) => [e.Name, (e.TranslationalStiffnessByLengthX ?? void 0) === void 0 ? null : ke(e.TranslationalStiffnessByLengthX), (e.TranslationalStiffnessByLengthY ?? void 0) === void 0 ? null : ke(e.TranslationalStiffnessByLengthY), (e.TranslationalStiffnessByLengthZ ?? void 0) === void 0 ? null : ke(e.TranslationalStiffnessByLengthZ), (e.RotationalStiffnessByLengthX ?? void 0) === void 0 ? null : ke(e.RotationalStiffnessByLengthX), (e.RotationalStiffnessByLengthY ?? void 0) === void 0 ? null : ke(e.RotationalStiffnessByLengthY), (e.RotationalStiffnessByLengthZ ?? void 0) === void 0 ? null : ke(e.RotationalStiffnessByLengthZ)],
  3367102660: (e) => [e.Name, (e.TranslationalStiffnessByAreaX ?? void 0) === void 0 ? null : ke(e.TranslationalStiffnessByAreaX), (e.TranslationalStiffnessByAreaY ?? void 0) === void 0 ? null : ke(e.TranslationalStiffnessByAreaY), (e.TranslationalStiffnessByAreaZ ?? void 0) === void 0 ? null : ke(e.TranslationalStiffnessByAreaZ)],
  1387855156: (e) => [e.Name, (e.TranslationalStiffnessX ?? void 0) === void 0 ? null : ke(e.TranslationalStiffnessX), (e.TranslationalStiffnessY ?? void 0) === void 0 ? null : ke(e.TranslationalStiffnessY), (e.TranslationalStiffnessZ ?? void 0) === void 0 ? null : ke(e.TranslationalStiffnessZ), (e.RotationalStiffnessX ?? void 0) === void 0 ? null : ke(e.RotationalStiffnessX), (e.RotationalStiffnessY ?? void 0) === void 0 ? null : ke(e.RotationalStiffnessY), (e.RotationalStiffnessZ ?? void 0) === void 0 ? null : ke(e.RotationalStiffnessZ)],
  2069777674: (e) => [e.Name, (e.TranslationalStiffnessX ?? void 0) === void 0 ? null : ke(e.TranslationalStiffnessX), (e.TranslationalStiffnessY ?? void 0) === void 0 ? null : ke(e.TranslationalStiffnessY), (e.TranslationalStiffnessZ ?? void 0) === void 0 ? null : ke(e.TranslationalStiffnessZ), (e.RotationalStiffnessX ?? void 0) === void 0 ? null : ke(e.RotationalStiffnessX), (e.RotationalStiffnessY ?? void 0) === void 0 ? null : ke(e.RotationalStiffnessY), (e.RotationalStiffnessZ ?? void 0) === void 0 ? null : ke(e.RotationalStiffnessZ), (e.WarpingStiffness ?? void 0) === void 0 ? null : ke(e.WarpingStiffness)],
  2859738748: (e) => [],
  2614616156: (e) => [ke(e.PointOnRelatingElement), ke(e.PointOnRelatedElement)],
  2732653382: (e) => [ke(e.SurfaceOnRelatingElement), ke(e.SurfaceOnRelatedElement)],
  775493141: (e) => [ke(e.VolumeOnRelatingElement), ke(e.VolumeOnRelatedElement)],
  1959218052: (e) => [e.Name, e.Description, e.ConstraintGrade, e.ConstraintSource, ke(e.CreatingActor), e.CreationTime, e.UserDefinedGrade],
  1785450214: (e) => [ke(e.SourceCRS), e.TargetCRS],
  1466758467: (e) => [e.Name, e.Description, e.GeodeticDatum, e.VerticalDatum],
  602808272: (e) => [e.Name, e.Description, ke(e.AppliedValue), e.UnitBasis, e.ApplicableDate, e.FixedUntilDate, e.Category, e.Condition, e.ArithmeticOperator, e.Components],
  1765591967: (e) => [e.Elements, e.UnitType, e.UserDefinedType],
  1045800335: (e) => [e.Unit, e.Exponent],
  2949456006: (e) => [e.LengthExponent, e.MassExponent, e.TimeExponent, e.ElectricCurrentExponent, e.ThermodynamicTemperatureExponent, e.AmountOfSubstanceExponent, e.LuminousIntensityExponent],
  4294318154: (e) => [],
  3200245327: (e) => [e.Location, e.Identification, e.Name],
  2242383968: (e) => [e.Location, e.Identification, e.Name],
  1040185647: (e) => [e.Location, e.Identification, e.Name],
  3548104201: (e) => [e.Location, e.Identification, e.Name],
  852622518: (e) => [e.AxisTag, e.AxisCurve, { type: 3, value: e.SameSense.value }],
  3020489413: (e) => [e.TimeStamp, e.ListValues.map((t) => ke(t))],
  2655187982: (e) => [e.Name, e.Version, ke(e.Publisher), e.VersionDate, e.Location, e.Description],
  3452421091: (e) => [e.Location, e.Identification, e.Name, e.Description, e.Language, e.ReferencedLibrary],
  4162380809: (e) => [e.MainPlaneAngle, e.SecondaryPlaneAngle, e.LuminousIntensity],
  1566485204: (e) => [e.LightDistributionCurve, e.DistributionData],
  3057273783: (e) => [ke(e.SourceCRS), e.TargetCRS, e.Eastings, e.Northings, e.OrthogonalHeight, e.XAxisAbscissa, e.XAxisOrdinate, e.Scale],
  1847130766: (e) => [ke(e.MaterialClassifications), e.ClassifiedMaterial],
  760658860: (e) => [],
  248100487: (e) => [e.Material, e.LayerThickness, e.IsVentilated == null ? null : { type: 3, value: e.IsVentilated.value }, e.Name, e.Description, e.Category, e.Priority],
  3303938423: (e) => [e.MaterialLayers, e.LayerSetName, e.Description],
  1847252529: (e) => [e.Material, e.LayerThickness, e.IsVentilated == null ? null : { type: 3, value: e.IsVentilated.value }, e.Name, e.Description, e.Category, e.Priority, e.OffsetDirection, e.OffsetValues],
  2199411900: (e) => [e.Materials],
  2235152071: (e) => [e.Name, e.Description, e.Material, e.Profile, e.Priority, e.Category],
  164193824: (e) => [e.Name, e.Description, e.MaterialProfiles, e.CompositeProfile],
  552965576: (e) => [e.Name, e.Description, e.Material, e.Profile, e.Priority, e.Category, e.OffsetValues],
  1507914824: (e) => [],
  2597039031: (e) => [ke(e.ValueComponent), ke(e.UnitComponent)],
  3368373690: (e) => [e.Name, e.Description, e.ConstraintGrade, e.ConstraintSource, ke(e.CreatingActor), e.CreationTime, e.UserDefinedGrade, e.Benchmark, e.ValueSource, ke(e.DataValue), e.ReferencePath],
  2706619895: (e) => [e.Currency],
  1918398963: (e) => [e.Dimensions, e.UnitType],
  3701648758: (e) => [],
  2251480897: (e) => [e.Name, e.Description, e.ConstraintGrade, e.ConstraintSource, ke(e.CreatingActor), e.CreationTime, e.UserDefinedGrade, e.BenchmarkValues, e.LogicalAggregator, e.ObjectiveQualifier, e.UserDefinedQualifier],
  4251960020: (e) => [e.Identification, e.Name, e.Description, e.Roles, e.Addresses],
  1207048766: (e) => [e.OwningUser, e.OwningApplication, e.State, e.ChangeAction, e.LastModifiedDate, e.LastModifyingUser, e.LastModifyingApplication, e.CreationDate],
  2077209135: (e) => [e.Identification, e.FamilyName, e.GivenName, e.MiddleNames, e.PrefixTitles, e.SuffixTitles, e.Roles, e.Addresses],
  101040310: (e) => [e.ThePerson, e.TheOrganization, e.Roles],
  2483315170: (e) => [e.Name, e.Description],
  2226359599: (e) => [e.Name, e.Description, e.Unit],
  3355820592: (e) => [e.Purpose, e.Description, e.UserDefinedPurpose, e.InternalLocation, e.AddressLines, e.PostalBox, e.Town, e.Region, e.PostalCode, e.Country],
  677532197: (e) => [],
  2022622350: (e) => [e.Name, e.Description, ke(e.AssignedItems), e.Identifier],
  1304840413: (e) => [e.Name, e.Description, ke(e.AssignedItems), e.Identifier, { type: 3, value: e.LayerOn.value }, { type: 3, value: e.LayerFrozen.value }, { type: 3, value: e.LayerBlocked.value }, e.LayerStyles],
  3119450353: (e) => [e.Name],
  2417041796: (e) => [ke(e.Styles)],
  2095639259: (e) => [e.Name, e.Description, e.Representations],
  3958567839: (e) => [e.ProfileType, e.ProfileName],
  3843373140: (e) => [e.Name, e.Description, e.GeodeticDatum, e.VerticalDatum, e.MapProjection, e.MapZone, e.MapUnit],
  986844984: (e) => [],
  3710013099: (e) => [e.Name, e.EnumerationValues.map((t) => ke(t)), ke(e.Unit)],
  2044713172: (e) => [e.Name, e.Description, e.Unit, e.AreaValue, e.Formula],
  2093928680: (e) => [e.Name, e.Description, e.Unit, e.CountValue, e.Formula],
  931644368: (e) => [e.Name, e.Description, e.Unit, e.LengthValue, e.Formula],
  3252649465: (e) => [e.Name, e.Description, e.Unit, e.TimeValue, e.Formula],
  2405470396: (e) => [e.Name, e.Description, e.Unit, e.VolumeValue, e.Formula],
  825690147: (e) => [e.Name, e.Description, e.Unit, e.WeightValue, e.Formula],
  3915482550: (e) => [e.RecurrenceType, e.DayComponent, e.WeekdayComponent, e.MonthComponent, e.Position, e.Interval, e.Occurrences, e.TimePeriods],
  2433181523: (e) => [e.TypeIdentifier, e.AttributeIdentifier, e.InstanceName, e.ListPositions, e.InnerReference],
  1076942058: (e) => [e.ContextOfItems, e.RepresentationIdentifier, e.RepresentationType, e.Items],
  3377609919: (e) => [e.ContextIdentifier, e.ContextType],
  3008791417: (e) => [],
  1660063152: (e) => [ke(e.MappingOrigin), e.MappedRepresentation],
  2439245199: (e) => [e.Name, e.Description],
  2341007311: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description],
  448429030: (e) => [void 0, e.UnitType, e.Prefix, e.Name],
  1054537805: (e) => [e.Name, e.DataOrigin, e.UserDefinedDataOrigin],
  867548509: (e) => [e.ShapeRepresentations, e.Name, e.Description, { type: 3, value: e.ProductDefinitional.value }, ke(e.PartOfProductDefinitionShape)],
  3982875396: (e) => [e.ContextOfItems, e.RepresentationIdentifier, e.RepresentationType, e.Items],
  4240577450: (e) => [e.ContextOfItems, e.RepresentationIdentifier, e.RepresentationType, e.Items],
  2273995522: (e) => [e.Name],
  2162789131: (e) => [e.Name],
  3478079324: (e) => [e.Name, e.Values, e.Locations],
  609421318: (e) => [e.Name],
  2525727697: (e) => [e.Name],
  3408363356: (e) => [e.Name, e.DeltaTConstant, e.DeltaTY, e.DeltaTZ],
  2830218821: (e) => [e.ContextOfItems, e.RepresentationIdentifier, e.RepresentationType, e.Items],
  3958052878: (e) => [e.Item, ke(e.Styles), e.Name],
  3049322572: (e) => [e.ContextOfItems, e.RepresentationIdentifier, e.RepresentationType, e.Items],
  2934153892: (e) => [e.Name, e.SurfaceReinforcement1, e.SurfaceReinforcement2, e.ShearReinforcement],
  1300840506: (e) => [e.Name, e.Side, ke(e.Styles)],
  3303107099: (e) => [e.DiffuseTransmissionColour, e.DiffuseReflectionColour, e.TransmissionColour, e.ReflectanceColour],
  1607154358: (e) => [e.RefractionIndex, e.DispersionFactor],
  846575682: (e) => [e.SurfaceColour, e.Transparency],
  1351298697: (e) => [e.Textures],
  626085974: (e) => [{ type: 3, value: e.RepeatS.value }, { type: 3, value: e.RepeatT.value }, e.Mode, e.TextureTransform, e.Parameter],
  985171141: (e) => [e.Name, e.Rows, e.Columns],
  2043862942: (e) => [e.Identifier, e.Name, e.Description, ke(e.Unit), e.ReferencePath],
  531007025: (e) => [(e.RowCells ?? void 0) === void 0 ? null : e.RowCells.map((t) => ke(t)), e.IsHeading == null ? null : { type: 3, value: e.IsHeading.value }],
  1549132990: (e) => [e.Name, e.DataOrigin, e.UserDefinedDataOrigin, e.DurationType, e.ScheduleDuration, e.ScheduleStart, e.ScheduleFinish, e.EarlyStart, e.EarlyFinish, e.LateStart, e.LateFinish, e.FreeFloat, e.TotalFloat, e.IsCritical == null ? null : { type: 3, value: e.IsCritical.value }, e.StatusTime, e.ActualDuration, e.ActualStart, e.ActualFinish, e.RemainingTime, e.Completion],
  2771591690: (e) => [e.Name, e.DataOrigin, e.UserDefinedDataOrigin, e.DurationType, e.ScheduleDuration, e.ScheduleStart, e.ScheduleFinish, e.EarlyStart, e.EarlyFinish, e.LateStart, e.LateFinish, e.FreeFloat, e.TotalFloat, e.IsCritical == null ? null : { type: 3, value: e.IsCritical.value }, e.StatusTime, e.ActualDuration, e.ActualStart, e.ActualFinish, e.RemainingTime, e.Completion, e.Recurrence],
  912023232: (e) => [e.Purpose, e.Description, e.UserDefinedPurpose, e.TelephoneNumbers, e.FacsimileNumbers, e.PagerNumber, e.ElectronicMailAddresses, e.WWWHomePageURL, e.MessagingIDs],
  1447204868: (e) => [e.Name, e.TextCharacterAppearance, e.TextStyle, ke(e.TextFontStyle), e.ModelOrDraughting == null ? null : { type: 3, value: e.ModelOrDraughting.value }],
  2636378356: (e) => [ke(e.Colour), ke(e.BackgroundColour)],
  1640371178: (e) => [(e.TextIndent ?? void 0) === void 0 ? null : ke(e.TextIndent), e.TextAlign, e.TextDecoration, (e.LetterSpacing ?? void 0) === void 0 ? null : ke(e.LetterSpacing), (e.WordSpacing ?? void 0) === void 0 ? null : ke(e.WordSpacing), e.TextTransform, (e.LineHeight ?? void 0) === void 0 ? null : ke(e.LineHeight)],
  280115917: (e) => [e.Maps],
  1742049831: (e) => [e.Maps, e.Mode, e.Parameter],
  2552916305: (e) => [e.Maps, e.Vertices, e.MappedTo],
  1210645708: (e) => [e.Coordinates],
  3611470254: (e) => [e.TexCoordsList],
  1199560280: (e) => [e.StartTime, e.EndTime],
  3101149627: (e) => [e.Name, e.Description, e.StartTime, e.EndTime, e.TimeSeriesDataType, e.DataOrigin, e.UserDefinedDataOrigin, ke(e.Unit)],
  581633288: (e) => [e.ListValues.map((t) => ke(t))],
  1377556343: (e) => [],
  1735638870: (e) => [e.ContextOfItems, e.RepresentationIdentifier, e.RepresentationType, e.Items],
  180925521: (e) => [ke(e.Units)],
  2799835756: (e) => [],
  1907098498: (e) => [e.VertexGeometry],
  891718957: (e) => [e.IntersectingAxes, e.OffsetDistances],
  1236880293: (e) => [e.Name, e.DataOrigin, e.UserDefinedDataOrigin, e.RecurrencePattern, e.Start, e.Finish],
  3869604511: (e) => [e.Name, e.Description, e.RelatingApproval, e.RelatedApprovals],
  3798115385: (e) => [e.ProfileType, e.ProfileName, e.OuterCurve],
  1310608509: (e) => [e.ProfileType, e.ProfileName, e.Curve],
  2705031697: (e) => [e.ProfileType, e.ProfileName, e.OuterCurve, e.InnerCurves],
  616511568: (e) => [{ type: 3, value: e.RepeatS.value }, { type: 3, value: e.RepeatT.value }, e.Mode, e.TextureTransform, e.Parameter, e.RasterFormat, e.RasterCode],
  3150382593: (e) => [e.ProfileType, e.ProfileName, e.Curve, e.Thickness],
  747523909: (e) => [e.Source, e.Edition, e.EditionDate, e.Name, e.Description, e.Location, e.ReferenceTokens],
  647927063: (e) => [e.Location, e.Identification, e.Name, ke(e.ReferencedSource), e.Description, e.Sort],
  3285139300: (e) => [e.ColourList],
  3264961684: (e) => [e.Name],
  1485152156: (e) => [e.ProfileType, e.ProfileName, e.Profiles, e.Label],
  370225590: (e) => [e.CfsFaces],
  1981873012: (e) => [ke(e.CurveOnRelatingElement), ke(e.CurveOnRelatedElement)],
  45288368: (e) => [ke(e.PointOnRelatingElement), ke(e.PointOnRelatedElement), e.EccentricityInX, e.EccentricityInY, e.EccentricityInZ],
  3050246964: (e) => [e.Dimensions, e.UnitType, e.Name],
  2889183280: (e) => [e.Dimensions, e.UnitType, e.Name, e.ConversionFactor],
  2713554722: (e) => [e.Dimensions, e.UnitType, e.Name, e.ConversionFactor, e.ConversionOffset],
  539742890: (e) => [e.Name, e.Description, e.RelatingMonetaryUnit, e.RelatedMonetaryUnit, e.ExchangeRate, e.RateDateTime, e.RateSource],
  3800577675: (e) => [e.Name, ke(e.CurveFont), (e.CurveWidth ?? void 0) === void 0 ? null : ke(e.CurveWidth), ke(e.CurveColour), e.ModelOrDraughting == null ? null : { type: 3, value: e.ModelOrDraughting.value }],
  1105321065: (e) => [e.Name, e.PatternList],
  2367409068: (e) => [e.Name, ke(e.CurveFont), e.CurveFontScaling],
  3510044353: (e) => [e.VisibleSegmentLength, e.InvisibleSegmentLength],
  3632507154: (e) => [e.ProfileType, e.ProfileName, e.ParentProfile, e.Operator, e.Label],
  1154170062: (e) => [e.Identification, e.Name, e.Description, e.Location, e.Purpose, e.IntendedUse, e.Scope, e.Revision, ke(e.DocumentOwner), ke(e.Editors), e.CreationTime, e.LastRevisionTime, e.ElectronicFormat, e.ValidFrom, e.ValidUntil, e.Confidentiality, e.Status],
  770865208: (e) => [e.Name, e.Description, e.RelatingDocument, e.RelatedDocuments, e.RelationshipType],
  3732053477: (e) => [e.Location, e.Identification, e.Name, e.Description, e.ReferencedDocument],
  3900360178: (e) => [e.EdgeStart, e.EdgeEnd],
  476780140: (e) => [e.EdgeStart, e.EdgeEnd, e.EdgeGeometry, { type: 3, value: e.SameSense.value }],
  211053100: (e) => [e.Name, e.DataOrigin, e.UserDefinedDataOrigin, e.ActualDate, e.EarlyDate, e.LateDate, e.ScheduleDate],
  297599258: (e) => [e.Name, e.Description, e.Properties],
  1437805879: (e) => [e.Name, e.Description, e.RelatingReference, ke(e.RelatedResourceObjects)],
  2556980723: (e) => [e.Bounds],
  1809719519: (e) => [e.Bound, { type: 3, value: e.Orientation.value }],
  803316827: (e) => [e.Bound, { type: 3, value: e.Orientation.value }],
  3008276851: (e) => [e.Bounds, e.FaceSurface, { type: 3, value: e.SameSense.value }],
  4219587988: (e) => [e.Name, e.TensionFailureX, e.TensionFailureY, e.TensionFailureZ, e.CompressionFailureX, e.CompressionFailureY, e.CompressionFailureZ],
  738692330: (e) => [e.Name, ke(e.FillStyles), e.ModelorDraughting == null ? null : { type: 3, value: e.ModelorDraughting.value }],
  3448662350: (e) => [e.ContextIdentifier, e.ContextType, e.CoordinateSpaceDimension, e.Precision, ke(e.WorldCoordinateSystem), e.TrueNorth],
  2453401579: (e) => [],
  4142052618: (e) => [e.ContextIdentifier, e.ContextType, void 0, void 0, void 0, void 0, e.ParentContext, e.TargetScale, e.TargetView, e.UserDefinedTargetView],
  3590301190: (e) => [ke(e.Elements)],
  178086475: (e) => [e.PlacementLocation, ke(e.PlacementRefDirection)],
  812098782: (e) => [e.BaseSurface, { type: 3, value: e.AgreementFlag.value }],
  3905492369: (e) => [{ type: 3, value: e.RepeatS.value }, { type: 3, value: e.RepeatT.value }, e.Mode, e.TextureTransform, e.Parameter, e.URLReference],
  3570813810: (e) => [e.MappedTo, e.Opacity, e.Colours, e.ColourIndex],
  1437953363: (e) => [e.Maps, e.MappedTo, e.TexCoords],
  2133299955: (e) => [e.Maps, e.MappedTo, e.TexCoords, e.TexCoordIndex],
  3741457305: (e) => [e.Name, e.Description, e.StartTime, e.EndTime, e.TimeSeriesDataType, e.DataOrigin, e.UserDefinedDataOrigin, ke(e.Unit), e.Values],
  1585845231: (e) => [e.Name, e.DataOrigin, e.UserDefinedDataOrigin, ke(e.LagValue), e.DurationType],
  1402838566: (e) => [e.Name, e.LightColour, e.AmbientIntensity, e.Intensity],
  125510826: (e) => [e.Name, e.LightColour, e.AmbientIntensity, e.Intensity],
  2604431987: (e) => [e.Name, e.LightColour, e.AmbientIntensity, e.Intensity, e.Orientation],
  4266656042: (e) => [e.Name, e.LightColour, e.AmbientIntensity, e.Intensity, e.Position, e.ColourAppearance, e.ColourTemperature, e.LuminousFlux, e.LightEmissionSource, ke(e.LightDistributionDataSource)],
  1520743889: (e) => [e.Name, e.LightColour, e.AmbientIntensity, e.Intensity, e.Position, e.Radius, e.ConstantAttenuation, e.DistanceAttenuation, e.QuadricAttenuation],
  3422422726: (e) => [e.Name, e.LightColour, e.AmbientIntensity, e.Intensity, e.Position, e.Radius, e.ConstantAttenuation, e.DistanceAttenuation, e.QuadricAttenuation, e.Orientation, e.ConcentrationExponent, e.SpreadAngle, e.BeamWidthAngle],
  2624227202: (e) => [e.PlacementRelTo, ke(e.RelativePlacement)],
  1008929658: (e) => [],
  2347385850: (e) => [e.MappingSource, e.MappingTarget],
  1838606355: (e) => [e.Name, e.Description, e.Category],
  3708119e3: (e) => [e.Name, e.Description, e.Material, e.Fraction, e.Category],
  2852063980: (e) => [e.Name, e.Description, e.MaterialConstituents],
  2022407955: (e) => [e.Name, e.Description, e.Representations, e.RepresentedMaterial],
  1303795690: (e) => [e.ForLayerSet, e.LayerSetDirection, e.DirectionSense, e.OffsetFromReferenceLine, e.ReferenceExtent],
  3079605661: (e) => [e.ForProfileSet, e.CardinalPoint, e.ReferenceExtent],
  3404854881: (e) => [e.ForProfileSet, e.CardinalPoint, e.ReferenceExtent, e.ForProfileEndSet, e.CardinalEndPoint],
  3265635763: (e) => [e.Name, e.Description, e.Properties, e.Material],
  853536259: (e) => [e.Name, e.Description, e.RelatingMaterial, e.RelatedMaterials, e.Expression],
  2998442950: (e) => [e.ProfileType, e.ProfileName, e.ParentProfile, void 0, e.Label],
  219451334: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description],
  2665983363: (e) => [e.CfsFaces],
  1411181986: (e) => [e.Name, e.Description, e.RelatingOrganization, e.RelatedOrganizations],
  1029017970: (e) => [void 0, void 0, e.EdgeElement, { type: 3, value: e.Orientation.value }],
  2529465313: (e) => [e.ProfileType, e.ProfileName, e.Position],
  2519244187: (e) => [e.EdgeList],
  3021840470: (e) => [e.Name, e.Description, e.HasQuantities, e.Discrimination, e.Quality, e.Usage],
  597895409: (e) => [{ type: 3, value: e.RepeatS.value }, { type: 3, value: e.RepeatT.value }, e.Mode, e.TextureTransform, e.Parameter, e.Width, e.Height, e.ColourComponents, e.Pixel],
  2004835150: (e) => [e.Location],
  1663979128: (e) => [e.SizeInX, e.SizeInY],
  2067069095: (e) => [],
  4022376103: (e) => [e.BasisCurve, e.PointParameter],
  1423911732: (e) => [e.BasisSurface, e.PointParameterU, e.PointParameterV],
  2924175390: (e) => [e.Polygon],
  2775532180: (e) => [e.BaseSurface, { type: 3, value: e.AgreementFlag.value }, e.Position, e.PolygonalBoundary],
  3727388367: (e) => [e.Name],
  3778827333: (e) => [],
  1775413392: (e) => [e.Name],
  673634403: (e) => [e.Name, e.Description, e.Representations],
  2802850158: (e) => [e.Name, e.Description, e.Properties, e.ProfileDefinition],
  2598011224: (e) => [e.Name, e.Description],
  1680319473: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description],
  148025276: (e) => [e.Name, e.Description, e.DependingProperty, e.DependantProperty, e.Expression],
  3357820518: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description],
  1482703590: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description],
  2090586900: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description],
  3615266464: (e) => [e.ProfileType, e.ProfileName, e.Position, e.XDim, e.YDim],
  3413951693: (e) => [e.Name, e.Description, e.StartTime, e.EndTime, e.TimeSeriesDataType, e.DataOrigin, e.UserDefinedDataOrigin, ke(e.Unit), e.TimeStep, e.Values],
  1580146022: (e) => [e.TotalCrossSectionArea, e.SteelGrade, e.BarSurface, e.EffectiveDepth, e.NominalBarDiameter, e.BarCount],
  478536968: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description],
  2943643501: (e) => [e.Name, e.Description, ke(e.RelatedResourceObjects), e.RelatingApproval],
  1608871552: (e) => [e.Name, e.Description, e.RelatingConstraint, ke(e.RelatedResourceObjects)],
  1042787934: (e) => [e.Name, e.DataOrigin, e.UserDefinedDataOrigin, e.ScheduleWork, e.ScheduleUsage, e.ScheduleStart, e.ScheduleFinish, e.ScheduleContour, e.LevelingDelay, e.IsOverAllocated == null ? null : { type: 3, value: e.IsOverAllocated.value }, e.StatusTime, e.ActualWork, e.ActualUsage, e.ActualStart, e.ActualFinish, e.RemainingWork, e.RemainingUsage, e.Completion],
  2778083089: (e) => [e.ProfileType, e.ProfileName, e.Position, e.XDim, e.YDim, e.RoundingRadius],
  2042790032: (e) => [e.SectionType, e.StartProfile, e.EndProfile],
  4165799628: (e) => [e.LongitudinalStartPosition, e.LongitudinalEndPosition, e.TransversePosition, e.ReinforcementRole, e.SectionDefinition, e.CrossSectionReinforcementDefinitions],
  1509187699: (e) => [e.SpineCurve, e.CrossSections, e.CrossSectionPositions],
  4124623270: (e) => [ke(e.SbsmBoundary)],
  3692461612: (e) => [e.Name, e.Description],
  2609359061: (e) => [e.Name, e.SlippageX, e.SlippageY, e.SlippageZ],
  723233188: (e) => [],
  1595516126: (e) => [e.Name, e.LinearForceX, e.LinearForceY, e.LinearForceZ, e.LinearMomentX, e.LinearMomentY, e.LinearMomentZ],
  2668620305: (e) => [e.Name, e.PlanarForceX, e.PlanarForceY, e.PlanarForceZ],
  2473145415: (e) => [e.Name, e.DisplacementX, e.DisplacementY, e.DisplacementZ, e.RotationalDisplacementRX, e.RotationalDisplacementRY, e.RotationalDisplacementRZ],
  1973038258: (e) => [e.Name, e.DisplacementX, e.DisplacementY, e.DisplacementZ, e.RotationalDisplacementRX, e.RotationalDisplacementRY, e.RotationalDisplacementRZ, e.Distortion],
  1597423693: (e) => [e.Name, e.ForceX, e.ForceY, e.ForceZ, e.MomentX, e.MomentY, e.MomentZ],
  1190533807: (e) => [e.Name, e.ForceX, e.ForceY, e.ForceZ, e.MomentX, e.MomentY, e.MomentZ, e.WarpingMoment],
  2233826070: (e) => [e.EdgeStart, e.EdgeEnd, e.ParentEdge],
  2513912981: (e) => [],
  1878645084: (e) => [e.SurfaceColour, e.Transparency, ke(e.DiffuseColour), ke(e.TransmissionColour), ke(e.DiffuseTransmissionColour), ke(e.ReflectionColour), ke(e.SpecularColour), (e.SpecularHighlight ?? void 0) === void 0 ? null : ke(e.SpecularHighlight), e.ReflectanceMethod],
  2247615214: (e) => [e.SweptArea, e.Position],
  1260650574: (e) => [e.Directrix, e.Radius, e.InnerRadius, e.StartParam, e.EndParam],
  1096409881: (e) => [e.Directrix, e.Radius, e.InnerRadius, e.StartParam, e.EndParam, e.FilletRadius],
  230924584: (e) => [e.SweptCurve, e.Position],
  3071757647: (e) => [e.ProfileType, e.ProfileName, e.Position, e.Depth, e.FlangeWidth, e.WebThickness, e.FlangeThickness, e.FilletRadius, e.FlangeEdgeRadius, e.WebEdgeRadius, e.WebSlope, e.FlangeSlope],
  901063453: (e) => [],
  4282788508: (e) => [e.Literal, ke(e.Placement), e.Path],
  3124975700: (e) => [e.Literal, ke(e.Placement), e.Path, e.Extent, e.BoxAlignment],
  1983826977: (e) => [e.Name, e.FontFamily, e.FontStyle, e.FontVariant, e.FontWeight, ke(e.FontSize)],
  2715220739: (e) => [e.ProfileType, e.ProfileName, e.Position, e.BottomXDim, e.TopXDim, e.YDim, e.TopXOffset],
  1628702193: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets],
  3736923433: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.Identification, e.LongDescription, e.ProcessType],
  2347495698: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag],
  3698973494: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.Identification, e.LongDescription, e.ResourceType],
  427810014: (e) => [e.ProfileType, e.ProfileName, e.Position, e.Depth, e.FlangeWidth, e.WebThickness, e.FlangeThickness, e.FilletRadius, e.EdgeRadius, e.FlangeSlope],
  1417489154: (e) => [e.Orientation, e.Magnitude],
  2759199220: (e) => [e.LoopVertex],
  1299126871: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ConstructionType, e.OperationType, { type: 3, value: e.ParameterTakesPrecedence.value }, { type: 3, value: e.Sizeable.value }],
  2543172580: (e) => [e.ProfileType, e.ProfileName, e.Position, e.Depth, e.FlangeWidth, e.WebThickness, e.FlangeThickness, e.FilletRadius, e.EdgeRadius],
  3406155212: (e) => [e.Bounds, e.FaceSurface, { type: 3, value: e.SameSense.value }],
  669184980: (e) => [e.OuterBoundary, e.InnerBoundaries],
  3207858831: (e) => [e.ProfileType, e.ProfileName, e.Position, e.BottomFlangeWidth, e.OverallDepth, e.WebThickness, e.BottomFlangeThickness, e.BottomFlangeFilletRadius, e.TopFlangeWidth, e.TopFlangeThickness, e.TopFlangeFilletRadius, e.BottomFlangeEdgeRadius, e.BottomFlangeSlope, e.TopFlangeEdgeRadius, e.TopFlangeSlope],
  4261334040: (e) => [e.Location, e.Axis],
  3125803723: (e) => [e.Location, e.RefDirection],
  2740243338: (e) => [e.Location, e.Axis, e.RefDirection],
  2736907675: (e) => [e.Operator, ke(e.FirstOperand), ke(e.SecondOperand)],
  4182860854: (e) => [],
  2581212453: (e) => [e.Corner, e.XDim, e.YDim, e.ZDim],
  2713105998: (e) => [e.BaseSurface, { type: 3, value: e.AgreementFlag.value }, e.Enclosure],
  2898889636: (e) => [e.ProfileType, e.ProfileName, e.Position, e.Depth, e.Width, e.WallThickness, e.Girth, e.InternalFilletRadius],
  1123145078: (e) => [e.Coordinates],
  574549367: (e) => [],
  1675464909: (e) => [e.CoordList],
  2059837836: (e) => [e.CoordList],
  59481748: (e) => [e.Axis1, e.Axis2, e.LocalOrigin, e.Scale],
  3749851601: (e) => [e.Axis1, e.Axis2, e.LocalOrigin, e.Scale],
  3486308946: (e) => [e.Axis1, e.Axis2, e.LocalOrigin, e.Scale, e.Scale2],
  3331915920: (e) => [e.Axis1, e.Axis2, e.LocalOrigin, e.Scale, e.Axis3],
  1416205885: (e) => [e.Axis1, e.Axis2, e.LocalOrigin, e.Scale, e.Axis3, e.Scale2, e.Scale3],
  1383045692: (e) => [e.ProfileType, e.ProfileName, e.Position, e.Radius],
  2205249479: (e) => [e.CfsFaces],
  776857604: (e) => [e.Name, e.Red, e.Green, e.Blue],
  2542286263: (e) => [e.Name, e.Description, e.UsageName, e.HasProperties],
  2485617015: (e) => [e.Transition, { type: 3, value: e.SameSense.value }, e.ParentCurve],
  2574617495: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.Identification, e.LongDescription, e.ResourceType, e.BaseCosts, e.BaseQuantity],
  3419103109: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.LongName, e.Phase, e.RepresentationContexts, e.UnitsInContext],
  1815067380: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.Identification, e.LongDescription, e.ResourceType, e.BaseCosts, e.BaseQuantity, e.PredefinedType],
  2506170314: (e) => [e.Position],
  2147822146: (e) => [ke(e.TreeRootExpression)],
  2601014836: (e) => [],
  2827736869: (e) => [e.BasisSurface, e.OuterBoundary, e.InnerBoundaries],
  2629017746: (e) => [e.BasisSurface, e.Boundaries, { type: 3, value: e.ImplicitOuter.value }],
  32440307: (e) => [e.DirectionRatios],
  526551008: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.OperationType, e.ConstructionType, { type: 3, value: e.ParameterTakesPrecedence.value }, { type: 3, value: e.Sizeable.value }],
  1472233963: (e) => [e.EdgeList],
  1883228015: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.MethodOfMeasurement, e.Quantities],
  339256511: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  2777663545: (e) => [e.Position],
  2835456948: (e) => [e.ProfileType, e.ProfileName, e.Position, e.SemiAxis1, e.SemiAxis2],
  4024345920: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.Identification, e.LongDescription, e.ProcessType, e.PredefinedType, e.EventTriggerType, e.UserDefinedEventTriggerType],
  477187591: (e) => [e.SweptArea, e.Position, e.ExtrudedDirection, e.Depth],
  2804161546: (e) => [e.SweptArea, e.Position, e.ExtrudedDirection, e.Depth, e.EndSweptArea],
  2047409740: (e) => [e.FbsmFaces],
  374418227: (e) => [e.HatchLineAppearance, ke(e.StartOfNextHatchLine), e.PointOfReferenceHatchLine, e.PatternStart, e.HatchLineAngle],
  315944413: (e) => [e.TilingPattern, e.Tiles, e.TilingScale],
  2652556860: (e) => [e.SweptArea, e.Position, e.Directrix, e.StartParam, e.EndParam, e.FixedReference],
  4238390223: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  1268542332: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.AssemblyPlace, e.PredefinedType],
  4095422895: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  987898635: (e) => [ke(e.Elements)],
  1484403080: (e) => [e.ProfileType, e.ProfileName, e.Position, e.OverallWidth, e.OverallDepth, e.WebThickness, e.FlangeThickness, e.FilletRadius, e.FlangeEdgeRadius, e.FlangeSlope],
  178912537: (e) => [e.CoordIndex],
  2294589976: (e) => [e.CoordIndex, e.InnerCoordIndices],
  572779678: (e) => [e.ProfileType, e.ProfileName, e.Position, e.Depth, e.Width, e.Thickness, e.FilletRadius, e.EdgeRadius, e.LegSlope],
  428585644: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.Identification, e.LongDescription, e.ResourceType, e.BaseCosts, e.BaseQuantity, e.PredefinedType],
  1281925730: (e) => [e.Pnt, e.Dir],
  1425443689: (e) => [e.Outer],
  3888040117: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType],
  3388369263: (e) => [e.BasisCurve, e.Distance, { type: 3, value: e.SelfIntersect.value }],
  3505215534: (e) => [e.BasisCurve, e.Distance, { type: 3, value: e.SelfIntersect.value }, e.RefDirection],
  1682466193: (e) => [e.BasisSurface, e.ReferenceCurve],
  603570806: (e) => [e.SizeInX, e.SizeInY, ke(e.Placement)],
  220341763: (e) => [e.Position],
  759155922: (e) => [e.Name],
  2559016684: (e) => [e.Name],
  3967405729: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description],
  569719735: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.Identification, e.LongDescription, e.ProcessType, e.PredefinedType],
  2945172077: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.LongDescription],
  4208778838: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation],
  103090709: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.LongName, e.Phase, e.RepresentationContexts, e.UnitsInContext],
  653396225: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.LongName, e.Phase, e.RepresentationContexts, e.UnitsInContext],
  871118103: (e) => [e.Name, e.Description, (e.UpperBoundValue ?? void 0) === void 0 ? null : ke(e.UpperBoundValue), (e.LowerBoundValue ?? void 0) === void 0 ? null : ke(e.LowerBoundValue), ke(e.Unit), (e.SetPointValue ?? void 0) === void 0 ? null : ke(e.SetPointValue)],
  4166981789: (e) => [e.Name, e.Description, (e.EnumerationValues ?? void 0) === void 0 ? null : e.EnumerationValues.map((t) => ke(t)), e.EnumerationReference],
  2752243245: (e) => [e.Name, e.Description, (e.ListValues ?? void 0) === void 0 ? null : e.ListValues.map((t) => ke(t)), ke(e.Unit)],
  941946838: (e) => [e.Name, e.Description, e.UsageName, ke(e.PropertyReference)],
  1451395588: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.HasProperties],
  492091185: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.TemplateType, e.ApplicableEntity, e.HasPropertyTemplates],
  3650150729: (e) => [e.Name, e.Description, (e.NominalValue ?? void 0) === void 0 ? null : ke(e.NominalValue), ke(e.Unit)],
  110355661: (e) => [e.Name, e.Description, (e.DefiningValues ?? void 0) === void 0 ? null : e.DefiningValues.map((t) => ke(t)), (e.DefinedValues ?? void 0) === void 0 ? null : e.DefinedValues.map((t) => ke(t)), e.Expression, ke(e.DefiningUnit), ke(e.DefinedUnit), e.CurveInterpolation],
  3521284610: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description],
  3219374653: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.ProxyType, e.Tag],
  2770003689: (e) => [e.ProfileType, e.ProfileName, e.Position, e.XDim, e.YDim, e.WallThickness, e.InnerFilletRadius, e.OuterFilletRadius],
  2798486643: (e) => [e.Position, e.XLength, e.YLength, e.Height],
  3454111270: (e) => [e.BasisSurface, e.U1, e.V1, e.U2, e.V2, { type: 3, value: e.Usense.value }, { type: 3, value: e.Vsense.value }],
  3765753017: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.DefinitionType, e.ReinforcementSectionDefinitions],
  3939117080: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatedObjectsType],
  1683148259: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatedObjectsType, e.RelatingActor, e.ActingRole],
  2495723537: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatedObjectsType, e.RelatingControl],
  1307041759: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatedObjectsType, e.RelatingGroup],
  1027710054: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatedObjectsType, e.RelatingGroup, e.Factor],
  4278684876: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatedObjectsType, ke(e.RelatingProcess), e.QuantityInProcess],
  2857406711: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatedObjectsType, ke(e.RelatingProduct)],
  205026976: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatedObjectsType, ke(e.RelatingResource)],
  1865459582: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, ke(e.RelatedObjects)],
  4095574036: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, ke(e.RelatedObjects), e.RelatingApproval],
  919958153: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, ke(e.RelatedObjects), ke(e.RelatingClassification)],
  2728634034: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, ke(e.RelatedObjects), e.Intent, e.RelatingConstraint],
  982818633: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, ke(e.RelatedObjects), ke(e.RelatingDocument)],
  3840914261: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, ke(e.RelatedObjects), ke(e.RelatingLibrary)],
  2655215786: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, ke(e.RelatedObjects), ke(e.RelatingMaterial)],
  826625072: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description],
  1204542856: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ConnectionGeometry, e.RelatingElement, e.RelatedElement],
  3945020480: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ConnectionGeometry, e.RelatingElement, e.RelatedElement, e.RelatingPriorities, e.RelatedPriorities, e.RelatedConnectionType, e.RelatingConnectionType],
  4201705270: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingPort, e.RelatedElement],
  3190031847: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingPort, e.RelatedPort, e.RealizingElement],
  2127690289: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, ke(e.RelatingElement), e.RelatedStructuralActivity],
  1638771189: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingStructuralMember, e.RelatedStructuralConnection, e.AppliedCondition, e.AdditionalConditions, e.SupportedLength, e.ConditionCoordinateSystem],
  504942748: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingStructuralMember, e.RelatedStructuralConnection, e.AppliedCondition, e.AdditionalConditions, e.SupportedLength, e.ConditionCoordinateSystem, e.ConnectionConstraint],
  3678494232: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ConnectionGeometry, e.RelatingElement, e.RelatedElement, e.RealizingElements, e.ConnectionType],
  3242617779: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedElements, e.RelatingStructure],
  886880790: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingBuildingElement, e.RelatedCoverings],
  2802773753: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingSpace, e.RelatedCoverings],
  2565941209: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingContext, ke(e.RelatedDefinitions)],
  2551354335: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description],
  693640335: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description],
  1462361463: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatingObject],
  4186316022: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, ke(e.RelatingPropertyDefinition)],
  307848117: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedPropertySets, e.RelatingTemplate],
  781010003: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatingType],
  3940055652: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingOpeningElement, e.RelatedBuildingElement],
  279856033: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedControlElements, e.RelatingFlowElement],
  427948657: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingElement, e.RelatedElement, e.InterferenceGeometry, e.InterferenceType, e.ImpliedOrder],
  3268803585: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingObject, e.RelatedObjects],
  750771296: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingElement, e.RelatedFeatureElement],
  1245217292: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedElements, e.RelatingStructure],
  4122056220: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingProcess, e.RelatedProcess, e.TimeLag, e.SequenceType, e.UserDefinedSequenceType],
  366585022: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingSystem, e.RelatedBuildings],
  3451746338: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, ke(e.RelatingSpace), e.RelatedBuildingElement, e.ConnectionGeometry, e.PhysicalOrVirtualBoundary, e.InternalOrExternalBoundary],
  3523091289: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, ke(e.RelatingSpace), e.RelatedBuildingElement, e.ConnectionGeometry, e.PhysicalOrVirtualBoundary, e.InternalOrExternalBoundary, e.ParentBoundary],
  1521410863: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, ke(e.RelatingSpace), e.RelatedBuildingElement, e.ConnectionGeometry, e.PhysicalOrVirtualBoundary, e.InternalOrExternalBoundary, e.ParentBoundary, e.CorrespondingBoundary],
  1401173127: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingBuildingElement, e.RelatedOpeningElement],
  816062949: (e) => [e.Transition, { type: 3, value: e.SameSense.value }, e.ParentCurve, e.ParamLength],
  2914609552: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.LongDescription],
  1856042241: (e) => [e.SweptArea, e.Position, e.Axis, e.Angle],
  3243963512: (e) => [e.SweptArea, e.Position, e.Axis, e.Angle, e.EndSweptArea],
  4158566097: (e) => [e.Position, e.Height, e.BottomRadius],
  3626867408: (e) => [e.Position, e.Height, e.Radius],
  3663146110: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.TemplateType, e.PrimaryMeasureType, e.SecondaryMeasureType, e.Enumerators, ke(e.PrimaryUnit), ke(e.SecondaryUnit), e.Expression, e.AccessState],
  1412071761: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName],
  710998568: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  2706606064: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName, e.CompositionType],
  3893378262: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  463610769: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName, e.PredefinedType],
  2481509218: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType, e.LongName],
  451544542: (e) => [e.Position, e.Radius],
  4015995234: (e) => [e.Position, e.Radius],
  3544373492: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedLoad, e.GlobalOrLocal],
  3136571912: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation],
  530289379: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation],
  3689010777: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedLoad, e.GlobalOrLocal],
  3979015343: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.PredefinedType, e.Thickness],
  2218152070: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.PredefinedType, e.Thickness],
  603775116: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedLoad, e.GlobalOrLocal, e.PredefinedType],
  4095615324: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.Identification, e.LongDescription, e.ResourceType, e.BaseCosts, e.BaseQuantity, e.PredefinedType],
  699246055: (e) => [e.Curve3D, e.AssociatedGeometry, e.MasterRepresentation],
  2028607225: (e) => [e.SweptArea, e.Position, e.Directrix, e.StartParam, e.EndParam, e.ReferenceSurface],
  2809605785: (e) => [e.SweptCurve, e.Position, e.ExtrudedDirection, e.Depth],
  4124788165: (e) => [e.SweptCurve, e.Position, e.AxisPosition],
  1580310250: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3473067441: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.LongDescription, e.Status, e.WorkMethod, { type: 3, value: e.IsMilestone.value }, e.Priority, e.TaskTime, e.PredefinedType],
  3206491090: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.Identification, e.LongDescription, e.ProcessType, e.PredefinedType, e.WorkMethod],
  2387106220: (e) => [e.Coordinates],
  1935646853: (e) => [e.Position, e.MajorRadius, e.MinorRadius],
  2097647324: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2916149573: (e) => [e.Coordinates, e.Normals, e.Closed == null ? null : { type: 3, value: e.Closed.value }, e.CoordIndex, e.PnIndex],
  336235671: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.LiningDepth, e.LiningThickness, e.TransomThickness, e.MullionThickness, e.FirstTransomOffset, e.SecondTransomOffset, e.FirstMullionOffset, e.SecondMullionOffset, e.ShapeAspectStyle, e.LiningOffset, e.LiningToPanelOffsetX, e.LiningToPanelOffsetY],
  512836454: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.OperationType, e.PanelPosition, e.FrameDepth, e.FrameThickness, e.ShapeAspectStyle],
  2296667514: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, ke(e.TheActor)],
  1635779807: (e) => [e.Outer],
  2603310189: (e) => [e.Outer, e.Voids],
  1674181508: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation],
  2887950389: (e) => [e.UDegree, e.VDegree, e.ControlPointsList, e.SurfaceForm, { type: 3, value: e.UClosed.value }, { type: 3, value: e.VClosed.value }, { type: 3, value: e.SelfIntersect.value }],
  167062518: (e) => [e.UDegree, e.VDegree, e.ControlPointsList, e.SurfaceForm, { type: 3, value: e.UClosed.value }, { type: 3, value: e.VClosed.value }, { type: 3, value: e.SelfIntersect.value }, e.UMultiplicities, e.VMultiplicities, e.UKnots, e.VKnots, e.KnotSpec],
  1334484129: (e) => [e.Position, e.XLength, e.YLength, e.ZLength],
  3649129432: (e) => [e.Operator, ke(e.FirstOperand), ke(e.SecondOperand)],
  1260505505: (e) => [],
  4031249490: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName, e.CompositionType, e.ElevationOfRefHeight, e.ElevationOfTerrain, e.BuildingAddress],
  1950629157: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  3124254112: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName, e.CompositionType, e.Elevation],
  2197970202: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2937912522: (e) => [e.ProfileType, e.ProfileName, e.Position, e.Radius, e.WallThickness],
  3893394355: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  300633059: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3875453745: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.UsageName, e.TemplateType, e.HasPropertyTemplates],
  3732776249: (e) => [e.Segments, { type: 3, value: e.SelfIntersect.value }],
  15328376: (e) => [e.Segments, { type: 3, value: e.SelfIntersect.value }],
  2510884976: (e) => [ke(e.Position)],
  2185764099: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.Identification, e.LongDescription, e.ResourceType, e.BaseCosts, e.BaseQuantity, e.PredefinedType],
  4105962743: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.Identification, e.LongDescription, e.ResourceType, e.BaseCosts, e.BaseQuantity, e.PredefinedType],
  1525564444: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.Identification, e.LongDescription, e.ResourceType, e.BaseCosts, e.BaseQuantity, e.PredefinedType],
  2559216714: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.LongDescription, e.Usage, e.BaseCosts, e.BaseQuantity],
  3293443760: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification],
  3895139033: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.PredefinedType, e.CostValues, e.CostQuantities],
  1419761937: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.PredefinedType, e.Status, e.SubmittedOn, e.UpdateDate],
  1916426348: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3295246426: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.LongDescription, e.Usage, e.BaseCosts, e.BaseQuantity, e.PredefinedType],
  1457835157: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1213902940: (e) => [e.Position, e.Radius],
  3256556792: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  3849074793: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  2963535650: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.LiningDepth, e.LiningThickness, e.ThresholdDepth, e.ThresholdThickness, e.TransomThickness, e.TransomOffset, e.LiningOffset, e.ThresholdOffset, e.CasingThickness, e.CasingDepth, e.ShapeAspectStyle, e.LiningToPanelOffsetX, e.LiningToPanelOffsetY],
  1714330368: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.PanelDepth, e.PanelOperation, e.PanelWidth, e.PanelPosition, e.ShapeAspectStyle],
  2323601079: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType, e.OperationType, e.ParameterTakesPrecedence == null ? null : { type: 3, value: e.ParameterTakesPrecedence.value }, e.UserDefinedOperationType],
  445594917: (e) => [e.Name],
  4006246654: (e) => [e.Name],
  1758889154: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  4123344466: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.AssemblyPlace, e.PredefinedType],
  2397081782: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1623761950: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  2590856083: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  1704287377: (e) => [ke(e.Position), e.SemiAxis1, e.SemiAxis2],
  2107101300: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  132023988: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3174744832: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3390157468: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  4148101412: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.LongDescription, e.PredefinedType, e.EventTriggerType, e.UserDefinedEventTriggerType, e.EventOccurenceTime],
  2853485674: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName],
  807026263: (e) => [e.Outer],
  3737207727: (e) => [e.Outer, e.Voids],
  647756555: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2489546625: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2827207264: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  2143335405: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  1287392070: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  3907093117: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  3198132628: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  3815607619: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1482959167: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  1834744321: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  1339347760: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  2297155007: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  3009222698: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  1893162501: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  263784265: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  1509553395: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3493046030: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3009204131: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.UAxes, e.VAxes, e.WAxes, e.PredefinedType],
  2706460486: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType],
  1251058090: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1806887404: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2571569899: (e) => [e.Points, (e.Segments ?? void 0) === void 0 ? null : e.Segments.map((t) => ke(t)), e.SelfIntersect == null ? null : { type: 3, value: e.SelfIntersect.value }],
  3946677679: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3113134337: (e) => [e.Curve3D, e.AssociatedGeometry, e.MasterRepresentation],
  2391368822: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.PredefinedType, ke(e.Jurisdiction), e.ResponsiblePersons, e.LastUpdateDate, e.CurrentValue, e.OriginalValue],
  4288270099: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3827777499: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.LongDescription, e.Usage, e.BaseCosts, e.BaseQuantity, e.PredefinedType],
  1051575348: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1161773419: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  377706215: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.NominalDiameter, e.NominalLength, e.PredefinedType],
  2108223431: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType, e.NominalDiameter, e.NominalLength],
  1114901282: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3181161470: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  977012517: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  4143007308: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, ke(e.TheActor), e.PredefinedType],
  3588315303: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3079942009: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2837617999: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2382730787: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.LifeCyclePhase, e.PredefinedType],
  3566463478: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.OperationType, e.PanelPosition, e.FrameDepth, e.FrameThickness, e.ShapeAspectStyle],
  3327091369: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.PredefinedType, e.Status, e.LongDescription],
  1158309216: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  804291784: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  4231323485: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  4017108033: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2839578677: (e) => [e.Coordinates, e.Closed == null ? null : { type: 3, value: e.Closed.value }, e.Faces, e.PnIndex],
  3724593414: (e) => [e.Points],
  3740093272: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation],
  2744685151: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.LongDescription, e.PredefinedType],
  2904328755: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.PredefinedType, e.Status, e.LongDescription],
  3651124850: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1842657554: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2250791053: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2893384427: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2324767716: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1469900589: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  683857671: (e) => [e.UDegree, e.VDegree, e.ControlPointsList, e.SurfaceForm, { type: 3, value: e.UClosed.value }, { type: 3, value: e.VClosed.value }, { type: 3, value: e.SelfIntersect.value }, e.UMultiplicities, e.VMultiplicities, e.UKnots, e.VKnots, e.KnotSpec, e.WeightsData],
  3027567501: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.SteelGrade],
  964333572: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  2320036040: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.SteelGrade, e.MeshLength, e.MeshWidth, e.LongitudinalBarNominalDiameter, e.TransverseBarNominalDiameter, e.LongitudinalBarCrossSectionArea, e.TransverseBarCrossSectionArea, e.LongitudinalBarSpacing, e.TransverseBarSpacing, e.PredefinedType],
  2310774935: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType, e.MeshLength, e.MeshWidth, e.LongitudinalBarNominalDiameter, e.TransverseBarNominalDiameter, e.LongitudinalBarCrossSectionArea, e.TransverseBarCrossSectionArea, e.LongitudinalBarSpacing, e.TransverseBarSpacing, e.BendingShapeCode, (e.BendingParameters ?? void 0) === void 0 ? null : e.BendingParameters.map((t) => ke(t))],
  160246688: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingObject, e.RelatedObjects],
  2781568857: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1768891740: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2157484638: (e) => [e.Curve3D, e.AssociatedGeometry, e.MasterRepresentation],
  4074543187: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  4097777520: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName, e.CompositionType, e.RefLatitude, e.RefLongitude, e.RefElevation, e.LandTitleNumber, e.SiteAddress],
  2533589738: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1072016465: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3856911033: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName, e.CompositionType, e.PredefinedType, e.ElevationWithFlooring],
  1305183839: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3812236995: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType, e.LongName],
  3112655638: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1039846685: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  338393293: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  682877961: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedLoad, e.GlobalOrLocal, e.DestabilizingLoad == null ? null : { type: 3, value: e.DestabilizingLoad.value }],
  1179482911: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedCondition],
  1004757350: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedLoad, e.GlobalOrLocal, e.DestabilizingLoad == null ? null : { type: 3, value: e.DestabilizingLoad.value }, e.ProjectedOrTrue, e.PredefinedType],
  4243806635: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedCondition, e.Axis],
  214636428: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.PredefinedType, e.Axis],
  2445595289: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.PredefinedType, e.Axis],
  2757150158: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedLoad, e.GlobalOrLocal, e.PredefinedType],
  1807405624: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedLoad, e.GlobalOrLocal, e.DestabilizingLoad == null ? null : { type: 3, value: e.DestabilizingLoad.value }, e.ProjectedOrTrue, e.PredefinedType],
  1252848954: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.PredefinedType, e.ActionType, e.ActionSource, e.Coefficient, e.Purpose],
  2082059205: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedLoad, e.GlobalOrLocal, e.DestabilizingLoad == null ? null : { type: 3, value: e.DestabilizingLoad.value }],
  734778138: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedCondition, e.ConditionCoordinateSystem],
  1235345126: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedLoad, e.GlobalOrLocal],
  2986769608: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.TheoryType, e.ResultForLoadGroup, { type: 3, value: e.IsLinear.value }],
  3657597509: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedLoad, e.GlobalOrLocal, e.DestabilizingLoad == null ? null : { type: 3, value: e.DestabilizingLoad.value }, e.ProjectedOrTrue, e.PredefinedType],
  1975003073: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedCondition],
  148013059: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.LongDescription, e.Usage, e.BaseCosts, e.BaseQuantity, e.PredefinedType],
  3101698114: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2315554128: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2254336722: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType],
  413509423: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  5716631: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3824725483: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.SteelGrade, e.PredefinedType, e.NominalDiameter, e.CrossSectionArea, e.TensionForce, e.PreStress, e.FrictionCoefficient, e.AnchorageSlip, e.MinCurvatureRadius],
  2347447852: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.SteelGrade, e.PredefinedType],
  3081323446: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2415094496: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType, e.NominalDiameter, e.CrossSectionArea, e.SheathDiameter],
  1692211062: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1620046519: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3593883385: (e) => [e.BasisCurve, ke(e.Trim1), ke(e.Trim2), { type: 3, value: e.SenseAgreement.value }, e.MasterRepresentation],
  1600972822: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1911125066: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  728799441: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2391383451: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3313531582: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2769231204: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  926996030: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1898987631: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1133259667: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  4009809668: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType, e.PartitioningType, e.ParameterTakesPrecedence == null ? null : { type: 3, value: e.ParameterTakesPrecedence.value }, e.UserDefinedPartitioningType],
  4088093105: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.WorkingTimes, e.ExceptionTimes, e.PredefinedType],
  1028945134: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.CreationDate, e.Creators, e.Purpose, e.Duration, e.TotalFloat, e.StartTime, e.FinishTime],
  4218914973: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.CreationDate, e.Creators, e.Purpose, e.Duration, e.TotalFloat, e.StartTime, e.FinishTime, e.PredefinedType],
  3342526732: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.CreationDate, e.Creators, e.Purpose, e.Duration, e.TotalFloat, e.StartTime, e.FinishTime, e.PredefinedType],
  1033361043: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.LongName],
  3821786052: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.PredefinedType, e.Status, e.LongDescription],
  1411407467: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3352864051: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1871374353: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3460190687: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.OriginalValue, e.CurrentValue, e.TotalReplacementCost, ke(e.Owner), ke(e.User), e.ResponsiblePerson, e.IncorporationDate, e.DepreciatedValue],
  1532957894: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1967976161: (e) => [e.Degree, e.ControlPointsList, e.CurveForm, { type: 3, value: e.ClosedCurve.value }, { type: 3, value: e.SelfIntersect.value }],
  2461110595: (e) => [e.Degree, e.ControlPointsList, e.CurveForm, { type: 3, value: e.ClosedCurve.value }, { type: 3, value: e.SelfIntersect.value }, e.KnotMultiplicities, e.Knots, e.KnotSpec],
  819618141: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  231477066: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1136057603: (e) => [e.Segments, { type: 3, value: e.SelfIntersect.value }],
  3299480353: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  2979338954: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  39481116: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1095909175: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1909888760: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1177604601: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.PredefinedType, e.LongName],
  2188180465: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  395041908: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3293546465: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2674252688: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1285652485: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2951183804: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3296154744: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2611217952: (e) => [ke(e.Position), e.Radius],
  1677625105: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  2301859152: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  843113511: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  905975707: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  400855858: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3850581409: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2816379211: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3898045240: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.LongDescription, e.Usage, e.BaseCosts, e.BaseQuantity, e.PredefinedType],
  1060000209: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.LongDescription, e.Usage, e.BaseCosts, e.BaseQuantity, e.PredefinedType],
  488727124: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.LongDescription, e.Usage, e.BaseCosts, e.BaseQuantity, e.PredefinedType],
  335055490: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2954562838: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1973544240: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3495092785: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3961806047: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1335981549: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2635815018: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1599208980: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2063403501: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  1945004755: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  3040386961: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  3041715199: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.FlowDirection, e.PredefinedType, e.SystemType],
  3205830791: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.LongName, e.PredefinedType],
  395920057: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.OverallHeight, e.OverallWidth, e.PredefinedType, e.OperationType, e.UserDefinedOperationType],
  3242481149: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.OverallHeight, e.OverallWidth, e.PredefinedType, e.OperationType, e.UserDefinedOperationType],
  869906466: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3760055223: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2030761528: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  663422040: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2417008758: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3277789161: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1534661035: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1217240411: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  712377611: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1658829314: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  2814081492: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3747195512: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  484807127: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1209101575: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName, e.PredefinedType],
  346874300: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1810631287: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  4222183408: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2058353004: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  4278956645: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  4037862832: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2188021234: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3132237377: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  987401354: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  707683696: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  2223149337: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  3508470533: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  900683007: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3319311131: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2068733104: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  4175244083: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2176052936: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  76236018: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  629592764: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1437502449: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1073191201: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1911478936: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2474470126: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  144952367: (e) => [e.Segments, { type: 3, value: e.SelfIntersect.value }],
  3694346114: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1687234759: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType, e.ConstructionType],
  310824031: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3612865200: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3171933400: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1156407060: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  738039164: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  655969474: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  90941305: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2262370178: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3024970846: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3283111854: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1232101972: (e) => [e.Degree, e.ControlPointsList, e.CurveForm, { type: 3, value: e.ClosedCurve.value }, { type: 3, value: e.SelfIntersect.value }, e.KnotMultiplicities, e.Knots, e.KnotSpec, e.WeightsData],
  979691226: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.SteelGrade, e.NominalDiameter, e.CrossSectionArea, e.BarLength, e.PredefinedType, e.BarSurface],
  2572171363: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType, e.NominalDiameter, e.CrossSectionArea, e.BarLength, e.BarSurface, e.BendingShapeCode, (e.BendingParameters ?? void 0) === void 0 ? null : e.BendingParameters.map((t) => ke(t))],
  2016517767: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3053780830: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1783015770: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1329646415: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1529196076: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3127900445: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3027962421: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3420628829: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1999602285: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1404847402: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  331165859: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  4252922144: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.NumberOfRisers, e.NumberOfTreads, e.RiserHeight, e.TreadLength, e.PredefinedType],
  2515109513: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.PredefinedType, e.OrientationOf2DPlane, e.LoadedBy, e.HasResults, e.SharedPlacement],
  385403989: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.PredefinedType, e.ActionType, e.ActionSource, e.Coefficient, e.Purpose, e.SelfWeightCoefficients],
  1621171031: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedLoad, e.GlobalOrLocal, e.DestabilizingLoad == null ? null : { type: 3, value: e.DestabilizingLoad.value }, e.ProjectedOrTrue, e.PredefinedType],
  1162798199: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  812556717: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3825984169: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3026737570: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3179687236: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  4292641817: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  4207607924: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2391406946: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  4156078855: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3512223829: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  4237592921: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3304561284: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.OverallHeight, e.OverallWidth, e.PredefinedType, e.PartitioningType, e.UserDefinedPartitioningType],
  486154966: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.OverallHeight, e.OverallWidth, e.PredefinedType, e.PartitioningType, e.UserDefinedPartitioningType],
  2874132201: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1634111441: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  177149247: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2056796094: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3001207471: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  277319702: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  753842376: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2906023776: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  32344328: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2938176219: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  635142910: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3758799889: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1051757585: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  4217484030: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3902619387: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  639361253: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3221913625: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3571504051: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2272882330: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  578613899: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  4136498852: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3640358203: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  4074379575: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1052013943: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  562808652: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.LongName, e.PredefinedType],
  1062813311: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  342316401: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3518393246: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1360408905: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1904799276: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  862014818: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3310460725: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  264262732: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  402227799: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1003880860: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3415622556: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  819412036: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1426591983: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  182646315: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2295281155: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  4086658281: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  630975310: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  4288193352: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3087945054: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  25142252: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType]
};
AH[2] = {
  3699917729: (e) => new d.IfcAbsorbedDoseMeasure(e),
  4182062534: (e) => new d.IfcAccelerationMeasure(e),
  360377573: (e) => new d.IfcAmountOfSubstanceMeasure(e),
  632304761: (e) => new d.IfcAngularVelocityMeasure(e),
  3683503648: (e) => new d.IfcArcIndex(e.map((t) => t.value)),
  1500781891: (e) => new d.IfcAreaDensityMeasure(e),
  2650437152: (e) => new d.IfcAreaMeasure(e),
  2314439260: (e) => new d.IfcBinary(e),
  2735952531: (e) => new d.IfcBoolean(e),
  1867003952: (e) => new d.IfcBoxAlignment(e),
  1683019596: (e) => new d.IfcCardinalPointReference(e),
  2991860651: (e) => new d.IfcComplexNumber(e.map((t) => t.value)),
  3812528620: (e) => new d.IfcCompoundPlaneAngleMeasure(e.map((t) => t.value)),
  3238673880: (e) => new d.IfcContextDependentMeasure(e),
  1778710042: (e) => new d.IfcCountMeasure(e),
  94842927: (e) => new d.IfcCurvatureMeasure(e),
  937566702: (e) => new d.IfcDate(e),
  2195413836: (e) => new d.IfcDateTime(e),
  86635668: (e) => new d.IfcDayInMonthNumber(e),
  3701338814: (e) => new d.IfcDayInWeekNumber(e),
  1514641115: (e) => new d.IfcDescriptiveMeasure(e),
  4134073009: (e) => new d.IfcDimensionCount(e),
  524656162: (e) => new d.IfcDoseEquivalentMeasure(e),
  2541165894: (e) => new d.IfcDuration(e),
  69416015: (e) => new d.IfcDynamicViscosityMeasure(e),
  1827137117: (e) => new d.IfcElectricCapacitanceMeasure(e),
  3818826038: (e) => new d.IfcElectricChargeMeasure(e),
  2093906313: (e) => new d.IfcElectricConductanceMeasure(e),
  3790457270: (e) => new d.IfcElectricCurrentMeasure(e),
  2951915441: (e) => new d.IfcElectricResistanceMeasure(e),
  2506197118: (e) => new d.IfcElectricVoltageMeasure(e),
  2078135608: (e) => new d.IfcEnergyMeasure(e),
  1102727119: (e) => new d.IfcFontStyle(e),
  2715512545: (e) => new d.IfcFontVariant(e),
  2590844177: (e) => new d.IfcFontWeight(e),
  1361398929: (e) => new d.IfcForceMeasure(e),
  3044325142: (e) => new d.IfcFrequencyMeasure(e),
  3064340077: (e) => new d.IfcGloballyUniqueId(e),
  3113092358: (e) => new d.IfcHeatFluxDensityMeasure(e),
  1158859006: (e) => new d.IfcHeatingValueMeasure(e),
  983778844: (e) => new d.IfcIdentifier(e),
  3358199106: (e) => new d.IfcIlluminanceMeasure(e),
  2679005408: (e) => new d.IfcInductanceMeasure(e),
  1939436016: (e) => new d.IfcInteger(e),
  3809634241: (e) => new d.IfcIntegerCountRateMeasure(e),
  3686016028: (e) => new d.IfcIonConcentrationMeasure(e),
  3192672207: (e) => new d.IfcIsothermalMoistureCapacityMeasure(e),
  2054016361: (e) => new d.IfcKinematicViscosityMeasure(e),
  3258342251: (e) => new d.IfcLabel(e),
  1275358634: (e) => new d.IfcLanguageId(e),
  1243674935: (e) => new d.IfcLengthMeasure(e),
  1774176899: (e) => new d.IfcLineIndex(e.map((t) => t.value)),
  191860431: (e) => new d.IfcLinearForceMeasure(e),
  2128979029: (e) => new d.IfcLinearMomentMeasure(e),
  1307019551: (e) => new d.IfcLinearStiffnessMeasure(e),
  3086160713: (e) => new d.IfcLinearVelocityMeasure(e),
  503418787: (e) => new d.IfcLogical(e),
  2095003142: (e) => new d.IfcLuminousFluxMeasure(e),
  2755797622: (e) => new d.IfcLuminousIntensityDistributionMeasure(e),
  151039812: (e) => new d.IfcLuminousIntensityMeasure(e),
  286949696: (e) => new d.IfcMagneticFluxDensityMeasure(e),
  2486716878: (e) => new d.IfcMagneticFluxMeasure(e),
  1477762836: (e) => new d.IfcMassDensityMeasure(e),
  4017473158: (e) => new d.IfcMassFlowRateMeasure(e),
  3124614049: (e) => new d.IfcMassMeasure(e),
  3531705166: (e) => new d.IfcMassPerLengthMeasure(e),
  3341486342: (e) => new d.IfcModulusOfElasticityMeasure(e),
  2173214787: (e) => new d.IfcModulusOfLinearSubgradeReactionMeasure(e),
  1052454078: (e) => new d.IfcModulusOfRotationalSubgradeReactionMeasure(e),
  1753493141: (e) => new d.IfcModulusOfSubgradeReactionMeasure(e),
  3177669450: (e) => new d.IfcMoistureDiffusivityMeasure(e),
  1648970520: (e) => new d.IfcMolecularWeightMeasure(e),
  3114022597: (e) => new d.IfcMomentOfInertiaMeasure(e),
  2615040989: (e) => new d.IfcMonetaryMeasure(e),
  765770214: (e) => new d.IfcMonthInYearNumber(e),
  525895558: (e) => new d.IfcNonNegativeLengthMeasure(e),
  2095195183: (e) => new d.IfcNormalisedRatioMeasure(e),
  2395907400: (e) => new d.IfcNumericMeasure(e),
  929793134: (e) => new d.IfcPHMeasure(e),
  2260317790: (e) => new d.IfcParameterValue(e),
  2642773653: (e) => new d.IfcPlanarForceMeasure(e),
  4042175685: (e) => new d.IfcPlaneAngleMeasure(e),
  1790229001: (e) => new d.IfcPositiveInteger(e),
  2815919920: (e) => new d.IfcPositiveLengthMeasure(e),
  3054510233: (e) => new d.IfcPositivePlaneAngleMeasure(e),
  1245737093: (e) => new d.IfcPositiveRatioMeasure(e),
  1364037233: (e) => new d.IfcPowerMeasure(e),
  2169031380: (e) => new d.IfcPresentableText(e),
  3665567075: (e) => new d.IfcPressureMeasure(e),
  2798247006: (e) => new d.IfcPropertySetDefinitionSet(e.map((t) => t.value)),
  3972513137: (e) => new d.IfcRadioActivityMeasure(e),
  96294661: (e) => new d.IfcRatioMeasure(e),
  200335297: (e) => new d.IfcReal(e),
  2133746277: (e) => new d.IfcRotationalFrequencyMeasure(e),
  1755127002: (e) => new d.IfcRotationalMassMeasure(e),
  3211557302: (e) => new d.IfcRotationalStiffnessMeasure(e),
  3467162246: (e) => new d.IfcSectionModulusMeasure(e),
  2190458107: (e) => new d.IfcSectionalAreaIntegralMeasure(e),
  408310005: (e) => new d.IfcShearModulusMeasure(e),
  3471399674: (e) => new d.IfcSolidAngleMeasure(e),
  4157543285: (e) => new d.IfcSoundPowerLevelMeasure(e),
  846465480: (e) => new d.IfcSoundPowerMeasure(e),
  3457685358: (e) => new d.IfcSoundPressureLevelMeasure(e),
  993287707: (e) => new d.IfcSoundPressureMeasure(e),
  3477203348: (e) => new d.IfcSpecificHeatCapacityMeasure(e),
  2757832317: (e) => new d.IfcSpecularExponent(e),
  361837227: (e) => new d.IfcSpecularRoughness(e),
  58845555: (e) => new d.IfcTemperatureGradientMeasure(e),
  1209108979: (e) => new d.IfcTemperatureRateOfChangeMeasure(e),
  2801250643: (e) => new d.IfcText(e),
  1460886941: (e) => new d.IfcTextAlignment(e),
  3490877962: (e) => new d.IfcTextDecoration(e),
  603696268: (e) => new d.IfcTextFontName(e),
  296282323: (e) => new d.IfcTextTransformation(e),
  232962298: (e) => new d.IfcThermalAdmittanceMeasure(e),
  2645777649: (e) => new d.IfcThermalConductivityMeasure(e),
  2281867870: (e) => new d.IfcThermalExpansionCoefficientMeasure(e),
  857959152: (e) => new d.IfcThermalResistanceMeasure(e),
  2016195849: (e) => new d.IfcThermalTransmittanceMeasure(e),
  743184107: (e) => new d.IfcThermodynamicTemperatureMeasure(e),
  4075327185: (e) => new d.IfcTime(e),
  2726807636: (e) => new d.IfcTimeMeasure(e),
  2591213694: (e) => new d.IfcTimeStamp(e),
  1278329552: (e) => new d.IfcTorqueMeasure(e),
  950732822: (e) => new d.IfcURIReference(e),
  3345633955: (e) => new d.IfcVaporPermeabilityMeasure(e),
  3458127941: (e) => new d.IfcVolumeMeasure(e),
  2593997549: (e) => new d.IfcVolumetricFlowRateMeasure(e),
  51269191: (e) => new d.IfcWarpingConstantMeasure(e),
  1718600412: (e) => new d.IfcWarpingMomentMeasure(e)
};
var d;
((e) => {
  class t extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCABSORBEDDOSEMEASURE";
    }
  }
  e.IfcAbsorbedDoseMeasure = t;
  class i extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCACCELERATIONMEASURE";
    }
  }
  e.IfcAccelerationMeasure = i;
  class n extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCAMOUNTOFSUBSTANCEMEASURE";
    }
  }
  e.IfcAmountOfSubstanceMeasure = n;
  class s extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCANGULARVELOCITYMEASURE";
    }
  }
  e.IfcAngularVelocityMeasure = s;
  class o {
    constructor(w) {
      this.value = w, this.type = 5;
    }
  }
  e.IfcArcIndex = o;
  class r extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCAREADENSITYMEASURE";
    }
  }
  e.IfcAreaDensityMeasure = r;
  class l extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCAREAMEASURE";
    }
  }
  e.IfcAreaMeasure = l;
  class c extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCBINARY";
    }
  }
  e.IfcBinary = c;
  class h {
    constructor(w) {
      this.type = 3, this.name = "IFCBOOLEAN", this.value = w;
    }
  }
  e.IfcBoolean = h;
  class I {
    constructor(w) {
      this.value = w, this.type = 1, this.name = "IFCBOXALIGNMENT";
    }
  }
  e.IfcBoxAlignment = I;
  class p extends pt {
    constructor() {
      super(...arguments), this.type = 10, this.name = "IFCCARDINALPOINTREFERENCE";
    }
  }
  e.IfcCardinalPointReference = p;
  class y {
    constructor(w) {
      this.value = w, this.type = 4;
    }
  }
  e.IfcComplexNumber = y;
  class m {
    constructor(w) {
      this.value = w, this.type = 10;
    }
  }
  e.IfcCompoundPlaneAngleMeasure = m;
  class A extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCCONTEXTDEPENDENTMEASURE";
    }
  }
  e.IfcContextDependentMeasure = A;
  class C extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCCOUNTMEASURE";
    }
  }
  e.IfcCountMeasure = C;
  class O extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCCURVATUREMEASURE";
    }
  }
  e.IfcCurvatureMeasure = O;
  class R {
    constructor(w) {
      this.value = w, this.type = 1, this.name = "IFCDATE";
    }
  }
  e.IfcDate = R;
  class F {
    constructor(w) {
      this.value = w, this.type = 1, this.name = "IFCDATETIME";
    }
  }
  e.IfcDateTime = F;
  class L extends pt {
    constructor() {
      super(...arguments), this.type = 10, this.name = "IFCDAYINMONTHNUMBER";
    }
  }
  e.IfcDayInMonthNumber = L;
  class P extends pt {
    constructor() {
      super(...arguments), this.type = 10, this.name = "IFCDAYINWEEKNUMBER";
    }
  }
  e.IfcDayInWeekNumber = P;
  class z {
    constructor(w) {
      this.value = w, this.type = 1, this.name = "IFCDESCRIPTIVEMEASURE";
    }
  }
  e.IfcDescriptiveMeasure = z;
  class W extends pt {
    constructor() {
      super(...arguments), this.type = 10, this.name = "IFCDIMENSIONCOUNT";
    }
  }
  e.IfcDimensionCount = W;
  class re extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCDOSEEQUIVALENTMEASURE";
    }
  }
  e.IfcDoseEquivalentMeasure = re;
  class ce {
    constructor(w) {
      this.value = w, this.type = 1, this.name = "IFCDURATION";
    }
  }
  e.IfcDuration = ce;
  class te extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCDYNAMICVISCOSITYMEASURE";
    }
  }
  e.IfcDynamicViscosityMeasure = te;
  class ee extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCELECTRICCAPACITANCEMEASURE";
    }
  }
  e.IfcElectricCapacitanceMeasure = ee;
  class Ne extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCELECTRICCHARGEMEASURE";
    }
  }
  e.IfcElectricChargeMeasure = Ne;
  class Ae extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCELECTRICCONDUCTANCEMEASURE";
    }
  }
  e.IfcElectricConductanceMeasure = Ae;
  class Oe extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCELECTRICCURRENTMEASURE";
    }
  }
  e.IfcElectricCurrentMeasure = Oe;
  class pe extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCELECTRICRESISTANCEMEASURE";
    }
  }
  e.IfcElectricResistanceMeasure = pe;
  class je extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCELECTRICVOLTAGEMEASURE";
    }
  }
  e.IfcElectricVoltageMeasure = je;
  class Ve extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCENERGYMEASURE";
    }
  }
  e.IfcEnergyMeasure = Ve;
  class $e {
    constructor(w) {
      this.value = w, this.type = 1, this.name = "IFCFONTSTYLE";
    }
  }
  e.IfcFontStyle = $e;
  class vt {
    constructor(w) {
      this.value = w, this.type = 1, this.name = "IFCFONTVARIANT";
    }
  }
  e.IfcFontVariant = vt;
  class Rt {
    constructor(w) {
      this.value = w, this.type = 1, this.name = "IFCFONTWEIGHT";
    }
  }
  e.IfcFontWeight = Rt;
  class ze extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCFORCEMEASURE";
    }
  }
  e.IfcForceMeasure = ze;
  class mt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCFREQUENCYMEASURE";
    }
  }
  e.IfcFrequencyMeasure = mt;
  class Et {
    constructor(w) {
      this.value = w, this.type = 1, this.name = "IFCGLOBALLYUNIQUEID";
    }
  }
  e.IfcGloballyUniqueId = Et;
  class it extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCHEATFLUXDENSITYMEASURE";
    }
  }
  e.IfcHeatFluxDensityMeasure = it;
  class Dt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCHEATINGVALUEMEASURE";
    }
  }
  e.IfcHeatingValueMeasure = Dt;
  class Ct {
    constructor(w) {
      this.value = w, this.type = 1, this.name = "IFCIDENTIFIER";
    }
  }
  e.IfcIdentifier = Ct;
  class Kt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCILLUMINANCEMEASURE";
    }
  }
  e.IfcIlluminanceMeasure = Kt;
  class Zt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCINDUCTANCEMEASURE";
    }
  }
  e.IfcInductanceMeasure = Zt;
  class Xt extends pt {
    constructor() {
      super(...arguments), this.type = 10, this.name = "IFCINTEGER";
    }
  }
  e.IfcInteger = Xt;
  class gi extends pt {
    constructor() {
      super(...arguments), this.type = 10, this.name = "IFCINTEGERCOUNTRATEMEASURE";
    }
  }
  e.IfcIntegerCountRateMeasure = gi;
  class Wt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCIONCONCENTRATIONMEASURE";
    }
  }
  e.IfcIonConcentrationMeasure = Wt;
  class Di extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCISOTHERMALMOISTURECAPACITYMEASURE";
    }
  }
  e.IfcIsothermalMoistureCapacityMeasure = Di;
  class ni extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCKINEMATICVISCOSITYMEASURE";
    }
  }
  e.IfcKinematicViscosityMeasure = ni;
  class Ci {
    constructor(w) {
      this.value = w, this.type = 1, this.name = "IFCLABEL";
    }
  }
  e.IfcLabel = Ci;
  class Se {
    constructor(w) {
      this.value = w, this.type = 1, this.name = "IFCLANGUAGEID";
    }
  }
  e.IfcLanguageId = Se;
  class si extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCLENGTHMEASURE";
    }
  }
  e.IfcLengthMeasure = si;
  class Mt {
    constructor(w) {
      this.value = w, this.type = 5;
    }
  }
  e.IfcLineIndex = Mt;
  class ft extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCLINEARFORCEMEASURE";
    }
  }
  e.IfcLinearForceMeasure = ft;
  class rt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCLINEARMOMENTMEASURE";
    }
  }
  e.IfcLinearMomentMeasure = rt;
  class Tt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCLINEARSTIFFNESSMEASURE";
    }
  }
  e.IfcLinearStiffnessMeasure = Tt;
  class jt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCLINEARVELOCITYMEASURE";
    }
  }
  e.IfcLinearVelocityMeasure = jt;
  class Jt {
    constructor(w) {
      this.type = 3, this.name = "IFCLOGICAL", this.value = w;
    }
  }
  e.IfcLogical = Jt;
  class $t extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCLUMINOUSFLUXMEASURE";
    }
  }
  e.IfcLuminousFluxMeasure = $t;
  class ht extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCLUMINOUSINTENSITYDISTRIBUTIONMEASURE";
    }
  }
  e.IfcLuminousIntensityDistributionMeasure = ht;
  class Me extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCLUMINOUSINTENSITYMEASURE";
    }
  }
  e.IfcLuminousIntensityMeasure = Me;
  class gt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMAGNETICFLUXDENSITYMEASURE";
    }
  }
  e.IfcMagneticFluxDensityMeasure = gt;
  class yt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMAGNETICFLUXMEASURE";
    }
  }
  e.IfcMagneticFluxMeasure = yt;
  class Ut extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMASSDENSITYMEASURE";
    }
  }
  e.IfcMassDensityMeasure = Ut;
  class Ht extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMASSFLOWRATEMEASURE";
    }
  }
  e.IfcMassFlowRateMeasure = Ht;
  class wi extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMASSMEASURE";
    }
  }
  e.IfcMassMeasure = wi;
  class bi extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMASSPERLENGTHMEASURE";
    }
  }
  e.IfcMassPerLengthMeasure = bi;
  class Hi extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMODULUSOFELASTICITYMEASURE";
    }
  }
  e.IfcModulusOfElasticityMeasure = Hi;
  class Wi extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMODULUSOFLINEARSUBGRADEREACTIONMEASURE";
    }
  }
  e.IfcModulusOfLinearSubgradeReactionMeasure = Wi;
  class hi extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMODULUSOFROTATIONALSUBGRADEREACTIONMEASURE";
    }
  }
  e.IfcModulusOfRotationalSubgradeReactionMeasure = hi;
  class Ji extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMODULUSOFSUBGRADEREACTIONMEASURE";
    }
  }
  e.IfcModulusOfSubgradeReactionMeasure = Ji;
  class Sn extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMOISTUREDIFFUSIVITYMEASURE";
    }
  }
  e.IfcMoistureDiffusivityMeasure = Sn;
  class nn extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMOLECULARWEIGHTMEASURE";
    }
  }
  e.IfcMolecularWeightMeasure = nn;
  class Yi extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMOMENTOFINERTIAMEASURE";
    }
  }
  e.IfcMomentOfInertiaMeasure = Yi;
  class Pi extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMONETARYMEASURE";
    }
  }
  e.IfcMonetaryMeasure = Pi;
  class kt extends pt {
    constructor() {
      super(...arguments), this.type = 10, this.name = "IFCMONTHINYEARNUMBER";
    }
  }
  e.IfcMonthInYearNumber = kt;
  class sn extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCNONNEGATIVELENGTHMEASURE";
    }
  }
  e.IfcNonNegativeLengthMeasure = sn;
  class Fi extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCNORMALISEDRATIOMEASURE";
    }
  }
  e.IfcNormalisedRatioMeasure = Fi;
  class tn extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCNUMERICMEASURE";
    }
  }
  e.IfcNumericMeasure = tn;
  class Gi extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCPHMEASURE";
    }
  }
  e.IfcPHMeasure = Gi;
  class yi extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCPARAMETERVALUE";
    }
  }
  e.IfcParameterValue = yi;
  class bn extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCPLANARFORCEMEASURE";
    }
  }
  e.IfcPlanarForceMeasure = bn;
  class ln extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCPLANEANGLEMEASURE";
    }
  }
  e.IfcPlaneAngleMeasure = ln;
  class No extends pt {
    constructor() {
      super(...arguments), this.type = 10, this.name = "IFCPOSITIVEINTEGER";
    }
  }
  e.IfcPositiveInteger = No;
  class Bs extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCPOSITIVELENGTHMEASURE";
    }
  }
  e.IfcPositiveLengthMeasure = Bs;
  class os extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCPOSITIVEPLANEANGLEMEASURE";
    }
  }
  e.IfcPositivePlaneAngleMeasure = os;
  class vl extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCPOSITIVERATIOMEASURE";
    }
  }
  e.IfcPositiveRatioMeasure = vl;
  class zl extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCPOWERMEASURE";
    }
  }
  e.IfcPowerMeasure = zl;
  class Wu {
    constructor(w) {
      this.value = w, this.type = 1, this.name = "IFCPRESENTABLETEXT";
    }
  }
  e.IfcPresentableText = Wu;
  class jl extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCPRESSUREMEASURE";
    }
  }
  e.IfcPressureMeasure = jl;
  class Yu {
    constructor(w) {
      this.value = w, this.type = 5;
    }
  }
  e.IfcPropertySetDefinitionSet = Yu;
  class bd extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCRADIOACTIVITYMEASURE";
    }
  }
  e.IfcRadioActivityMeasure = bd;
  class I0 extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCRATIOMEASURE";
    }
  }
  e.IfcRatioMeasure = I0;
  class Gt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCREAL";
    }
  }
  e.IfcReal = Gt;
  class Vi extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCROTATIONALFREQUENCYMEASURE";
    }
  }
  e.IfcRotationalFrequencyMeasure = Vi;
  class _i extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCROTATIONALMASSMEASURE";
    }
  }
  e.IfcRotationalMassMeasure = _i;
  class $n extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCROTATIONALSTIFFNESSMEASURE";
    }
  }
  e.IfcRotationalStiffnessMeasure = $n;
  class Os extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCSECTIONMODULUSMEASURE";
    }
  }
  e.IfcSectionModulusMeasure = Os;
  class Ai extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCSECTIONALAREAINTEGRALMEASURE";
    }
  }
  e.IfcSectionalAreaIntegralMeasure = Ai;
  class As extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCSHEARMODULUSMEASURE";
    }
  }
  e.IfcShearModulusMeasure = As;
  class Es extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCSOLIDANGLEMEASURE";
    }
  }
  e.IfcSolidAngleMeasure = Es;
  class mr extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCSOUNDPOWERLEVELMEASURE";
    }
  }
  e.IfcSoundPowerLevelMeasure = mr;
  class Je extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCSOUNDPOWERMEASURE";
    }
  }
  e.IfcSoundPowerMeasure = Je;
  class no extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCSOUNDPRESSURELEVELMEASURE";
    }
  }
  e.IfcSoundPressureLevelMeasure = no;
  class It extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCSOUNDPRESSUREMEASURE";
    }
  }
  e.IfcSoundPressureMeasure = It;
  class Qt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCSPECIFICHEATCAPACITYMEASURE";
    }
  }
  e.IfcSpecificHeatCapacityMeasure = Qt;
  class ci extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCSPECULAREXPONENT";
    }
  }
  e.IfcSpecularExponent = ci;
  class ai extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCSPECULARROUGHNESS";
    }
  }
  e.IfcSpecularRoughness = ai;
  class ei extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCTEMPERATUREGRADIENTMEASURE";
    }
  }
  e.IfcTemperatureGradientMeasure = ei;
  class Si extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCTEMPERATURERATEOFCHANGEMEASURE";
    }
  }
  e.IfcTemperatureRateOfChangeMeasure = Si;
  class mn {
    constructor(w) {
      this.value = w, this.type = 1, this.name = "IFCTEXT";
    }
  }
  e.IfcText = mn;
  class wn {
    constructor(w) {
      this.value = w, this.type = 1, this.name = "IFCTEXTALIGNMENT";
    }
  }
  e.IfcTextAlignment = wn;
  class Nn {
    constructor(w) {
      this.value = w, this.type = 1, this.name = "IFCTEXTDECORATION";
    }
  }
  e.IfcTextDecoration = Nn;
  class Kn {
    constructor(w) {
      this.value = w, this.type = 1, this.name = "IFCTEXTFONTNAME";
    }
  }
  e.IfcTextFontName = Kn;
  class is {
    constructor(w) {
      this.value = w, this.type = 1, this.name = "IFCTEXTTRANSFORMATION";
    }
  }
  e.IfcTextTransformation = is;
  class jn extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCTHERMALADMITTANCEMEASURE";
    }
  }
  e.IfcThermalAdmittanceMeasure = jn;
  class _s extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCTHERMALCONDUCTIVITYMEASURE";
    }
  }
  e.IfcThermalConductivityMeasure = _s;
  class yo extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCTHERMALEXPANSIONCOEFFICIENTMEASURE";
    }
  }
  e.IfcThermalExpansionCoefficientMeasure = yo;
  class Qo extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCTHERMALRESISTANCEMEASURE";
    }
  }
  e.IfcThermalResistanceMeasure = Qo;
  class so extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCTHERMALTRANSMITTANCEMEASURE";
    }
  }
  e.IfcThermalTransmittanceMeasure = so;
  class Eo extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCTHERMODYNAMICTEMPERATUREMEASURE";
    }
  }
  e.IfcThermodynamicTemperatureMeasure = Eo;
  class Yn {
    constructor(w) {
      this.value = w, this.type = 1, this.name = "IFCTIME";
    }
  }
  e.IfcTime = Yn;
  class Jo extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCTIMEMEASURE";
    }
  }
  e.IfcTimeMeasure = Jo;
  class xs extends pt {
    constructor() {
      super(...arguments), this.type = 10, this.name = "IFCTIMESTAMP";
    }
  }
  e.IfcTimeStamp = xs;
  class Gr extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCTORQUEMEASURE";
    }
  }
  e.IfcTorqueMeasure = Gr;
  class sa {
    constructor(w) {
      this.value = w, this.type = 1, this.name = "IFCURIREFERENCE";
    }
  }
  e.IfcURIReference = sa;
  class yr extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCVAPORPERMEABILITYMEASURE";
    }
  }
  e.IfcVaporPermeabilityMeasure = yr;
  class nr extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCVOLUMEMEASURE";
    }
  }
  e.IfcVolumeMeasure = nr;
  class Ws extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCVOLUMETRICFLOWRATEMEASURE";
    }
  }
  e.IfcVolumetricFlowRateMeasure = Ws;
  class ul extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCWARPINGCONSTANTMEASURE";
    }
  }
  e.IfcWarpingConstantMeasure = ul;
  class ur extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCWARPINGMOMENTMEASURE";
    }
  }
  e.IfcWarpingMomentMeasure = ur;
  const jo = class jo {
  };
  jo.EMAIL = { type: 3, value: "EMAIL" }, jo.FAX = { type: 3, value: "FAX" }, jo.PHONE = { type: 3, value: "PHONE" }, jo.POST = { type: 3, value: "POST" }, jo.VERBAL = { type: 3, value: "VERBAL" }, jo.USERDEFINED = { type: 3, value: "USERDEFINED" }, jo.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let ao = jo;
  e.IfcActionRequestTypeEnum = ao;
  const Gs = class Gs {
  };
  Gs.DEAD_LOAD_G = { type: 3, value: "DEAD_LOAD_G" }, Gs.COMPLETION_G1 = { type: 3, value: "COMPLETION_G1" }, Gs.LIVE_LOAD_Q = { type: 3, value: "LIVE_LOAD_Q" }, Gs.SNOW_S = { type: 3, value: "SNOW_S" }, Gs.WIND_W = { type: 3, value: "WIND_W" }, Gs.PRESTRESSING_P = { type: 3, value: "PRESTRESSING_P" }, Gs.SETTLEMENT_U = { type: 3, value: "SETTLEMENT_U" }, Gs.TEMPERATURE_T = { type: 3, value: "TEMPERATURE_T" }, Gs.EARTHQUAKE_E = { type: 3, value: "EARTHQUAKE_E" }, Gs.FIRE = { type: 3, value: "FIRE" }, Gs.IMPULSE = { type: 3, value: "IMPULSE" }, Gs.IMPACT = { type: 3, value: "IMPACT" }, Gs.TRANSPORT = { type: 3, value: "TRANSPORT" }, Gs.ERECTION = { type: 3, value: "ERECTION" }, Gs.PROPPING = { type: 3, value: "PROPPING" }, Gs.SYSTEM_IMPERFECTION = { type: 3, value: "SYSTEM_IMPERFECTION" }, Gs.SHRINKAGE = { type: 3, value: "SHRINKAGE" }, Gs.CREEP = { type: 3, value: "CREEP" }, Gs.LACK_OF_FIT = { type: 3, value: "LACK_OF_FIT" }, Gs.BUOYANCY = { type: 3, value: "BUOYANCY" }, Gs.ICE = { type: 3, value: "ICE" }, Gs.CURRENT = { type: 3, value: "CURRENT" }, Gs.WAVE = { type: 3, value: "WAVE" }, Gs.RAIN = { type: 3, value: "RAIN" }, Gs.BRAKES = { type: 3, value: "BRAKES" }, Gs.USERDEFINED = { type: 3, value: "USERDEFINED" }, Gs.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let kr = Gs;
  e.IfcActionSourceTypeEnum = kr;
  const Su = class Su {
  };
  Su.PERMANENT_G = { type: 3, value: "PERMANENT_G" }, Su.VARIABLE_Q = { type: 3, value: "VARIABLE_Q" }, Su.EXTRAORDINARY_A = { type: 3, value: "EXTRAORDINARY_A" }, Su.USERDEFINED = { type: 3, value: "USERDEFINED" }, Su.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let oa = Su;
  e.IfcActionTypeEnum = oa;
  const Co = class Co {
  };
  Co.ELECTRICACTUATOR = { type: 3, value: "ELECTRICACTUATOR" }, Co.HANDOPERATEDACTUATOR = { type: 3, value: "HANDOPERATEDACTUATOR" }, Co.HYDRAULICACTUATOR = { type: 3, value: "HYDRAULICACTUATOR" }, Co.PNEUMATICACTUATOR = { type: 3, value: "PNEUMATICACTUATOR" }, Co.THERMOSTATICACTUATOR = { type: 3, value: "THERMOSTATICACTUATOR" }, Co.USERDEFINED = { type: 3, value: "USERDEFINED" }, Co.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Po = Co;
  e.IfcActuatorTypeEnum = Po;
  const Zf = class Zf {
  };
  Zf.OFFICE = { type: 3, value: "OFFICE" }, Zf.SITE = { type: 3, value: "SITE" }, Zf.HOME = { type: 3, value: "HOME" }, Zf.DISTRIBUTIONPOINT = { type: 3, value: "DISTRIBUTIONPOINT" }, Zf.USERDEFINED = { type: 3, value: "USERDEFINED" };
  let NI = Zf;
  e.IfcAddressTypeEnum = NI;
  const Em = class Em {
  };
  Em.CONSTANTFLOW = { type: 3, value: "CONSTANTFLOW" }, Em.VARIABLEFLOWPRESSUREDEPENDANT = { type: 3, value: "VARIABLEFLOWPRESSUREDEPENDANT" }, Em.VARIABLEFLOWPRESSUREINDEPENDANT = { type: 3, value: "VARIABLEFLOWPRESSUREINDEPENDANT" }, Em.USERDEFINED = { type: 3, value: "USERDEFINED" }, Em.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Tc = Em;
  e.IfcAirTerminalBoxTypeEnum = Tc;
  const ep = class ep {
  };
  ep.DIFFUSER = { type: 3, value: "DIFFUSER" }, ep.GRILLE = { type: 3, value: "GRILLE" }, ep.LOUVRE = { type: 3, value: "LOUVRE" }, ep.REGISTER = { type: 3, value: "REGISTER" }, ep.USERDEFINED = { type: 3, value: "USERDEFINED" }, ep.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let bf = ep;
  e.IfcAirTerminalTypeEnum = bf;
  const Fd = class Fd {
  };
  Fd.FIXEDPLATECOUNTERFLOWEXCHANGER = { type: 3, value: "FIXEDPLATECOUNTERFLOWEXCHANGER" }, Fd.FIXEDPLATECROSSFLOWEXCHANGER = { type: 3, value: "FIXEDPLATECROSSFLOWEXCHANGER" }, Fd.FIXEDPLATEPARALLELFLOWEXCHANGER = { type: 3, value: "FIXEDPLATEPARALLELFLOWEXCHANGER" }, Fd.ROTARYWHEEL = { type: 3, value: "ROTARYWHEEL" }, Fd.RUNAROUNDCOILLOOP = { type: 3, value: "RUNAROUNDCOILLOOP" }, Fd.HEATPIPE = { type: 3, value: "HEATPIPE" }, Fd.TWINTOWERENTHALPYRECOVERYLOOPS = { type: 3, value: "TWINTOWERENTHALPYRECOVERYLOOPS" }, Fd.THERMOSIPHONSEALEDTUBEHEATEXCHANGERS = { type: 3, value: "THERMOSIPHONSEALEDTUBEHEATEXCHANGERS" }, Fd.THERMOSIPHONCOILTYPEHEATEXCHANGERS = { type: 3, value: "THERMOSIPHONCOILTYPEHEATEXCHANGERS" }, Fd.USERDEFINED = { type: 3, value: "USERDEFINED" }, Fd.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Rc = Fd;
  e.IfcAirToAirHeatRecoveryTypeEnum = Rc;
  const Nh = class Nh {
  };
  Nh.BELL = { type: 3, value: "BELL" }, Nh.BREAKGLASSBUTTON = { type: 3, value: "BREAKGLASSBUTTON" }, Nh.LIGHT = { type: 3, value: "LIGHT" }, Nh.MANUALPULLBOX = { type: 3, value: "MANUALPULLBOX" }, Nh.SIREN = { type: 3, value: "SIREN" }, Nh.WHISTLE = { type: 3, value: "WHISTLE" }, Nh.USERDEFINED = { type: 3, value: "USERDEFINED" }, Nh.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Sr = Nh;
  e.IfcAlarmTypeEnum = Sr;
  const MR = class MR {
  };
  MR.IN_PLANE_LOADING_2D = { type: 3, value: "IN_PLANE_LOADING_2D" }, MR.OUT_PLANE_LOADING_2D = { type: 3, value: "OUT_PLANE_LOADING_2D" }, MR.LOADING_3D = { type: 3, value: "LOADING_3D" }, MR.USERDEFINED = { type: 3, value: "USERDEFINED" }, MR.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let ra = MR;
  e.IfcAnalysisModelTypeEnum = ra;
  const vT = class vT {
  };
  vT.FIRST_ORDER_THEORY = { type: 3, value: "FIRST_ORDER_THEORY" }, vT.SECOND_ORDER_THEORY = { type: 3, value: "SECOND_ORDER_THEORY" }, vT.THIRD_ORDER_THEORY = { type: 3, value: "THIRD_ORDER_THEORY" }, vT.FULL_NONLINEAR_THEORY = { type: 3, value: "FULL_NONLINEAR_THEORY" }, vT.USERDEFINED = { type: 3, value: "USERDEFINED" }, vT.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ls = vT;
  e.IfcAnalysisTheoryTypeEnum = Ls;
  const Dh = class Dh {
  };
  Dh.ADD = { type: 3, value: "ADD" }, Dh.DIVIDE = { type: 3, value: "DIVIDE" }, Dh.MULTIPLY = { type: 3, value: "MULTIPLY" }, Dh.SUBTRACT = { type: 3, value: "SUBTRACT" };
  let vc = Dh;
  e.IfcArithmeticOperatorEnum = vc;
  const VE = class VE {
  };
  VE.SITE = { type: 3, value: "SITE" }, VE.FACTORY = { type: 3, value: "FACTORY" }, VE.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let la = VE;
  e.IfcAssemblyPlaceEnum = la;
  const tp = class tp {
  };
  tp.AMPLIFIER = { type: 3, value: "AMPLIFIER" }, tp.CAMERA = { type: 3, value: "CAMERA" }, tp.DISPLAY = { type: 3, value: "DISPLAY" }, tp.MICROPHONE = { type: 3, value: "MICROPHONE" }, tp.PLAYER = { type: 3, value: "PLAYER" }, tp.PROJECTOR = { type: 3, value: "PROJECTOR" }, tp.RECEIVER = { type: 3, value: "RECEIVER" }, tp.SPEAKER = { type: 3, value: "SPEAKER" }, tp.SWITCHER = { type: 3, value: "SWITCHER" }, tp.TELEPHONE = { type: 3, value: "TELEPHONE" }, tp.TUNER = { type: 3, value: "TUNER" }, tp.USERDEFINED = { type: 3, value: "USERDEFINED" }, tp.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Nf = tp;
  e.IfcAudioVisualApplianceTypeEnum = Nf;
  const CS = class CS {
  };
  CS.POLYLINE_FORM = { type: 3, value: "POLYLINE_FORM" }, CS.CIRCULAR_ARC = { type: 3, value: "CIRCULAR_ARC" }, CS.ELLIPTIC_ARC = { type: 3, value: "ELLIPTIC_ARC" }, CS.PARABOLIC_ARC = { type: 3, value: "PARABOLIC_ARC" }, CS.HYPERBOLIC_ARC = { type: 3, value: "HYPERBOLIC_ARC" }, CS.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" };
  let DI = CS;
  e.IfcBSplineCurveForm = DI;
  const Qf = class Qf {
  };
  Qf.PLANE_SURF = { type: 3, value: "PLANE_SURF" }, Qf.CYLINDRICAL_SURF = { type: 3, value: "CYLINDRICAL_SURF" }, Qf.CONICAL_SURF = { type: 3, value: "CONICAL_SURF" }, Qf.SPHERICAL_SURF = { type: 3, value: "SPHERICAL_SURF" }, Qf.TOROIDAL_SURF = { type: 3, value: "TOROIDAL_SURF" }, Qf.SURF_OF_REVOLUTION = { type: 3, value: "SURF_OF_REVOLUTION" }, Qf.RULED_SURF = { type: 3, value: "RULED_SURF" }, Qf.GENERALISED_CONE = { type: 3, value: "GENERALISED_CONE" }, Qf.QUADRIC_SURF = { type: 3, value: "QUADRIC_SURF" }, Qf.SURF_OF_LINEAR_EXTRUSION = { type: 3, value: "SURF_OF_LINEAR_EXTRUSION" }, Qf.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" };
  let Df = Qf;
  e.IfcBSplineSurfaceForm = Df;
  const ip = class ip {
  };
  ip.BEAM = { type: 3, value: "BEAM" }, ip.JOIST = { type: 3, value: "JOIST" }, ip.HOLLOWCORE = { type: 3, value: "HOLLOWCORE" }, ip.LINTEL = { type: 3, value: "LINTEL" }, ip.SPANDREL = { type: 3, value: "SPANDREL" }, ip.T_BEAM = { type: 3, value: "T_BEAM" }, ip.USERDEFINED = { type: 3, value: "USERDEFINED" }, ip.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let dl = ip;
  e.IfcBeamTypeEnum = dl;
  const gm = class gm {
  };
  gm.GREATERTHAN = { type: 3, value: "GREATERTHAN" }, gm.GREATERTHANOREQUALTO = { type: 3, value: "GREATERTHANOREQUALTO" }, gm.LESSTHAN = { type: 3, value: "LESSTHAN" }, gm.LESSTHANOREQUALTO = { type: 3, value: "LESSTHANOREQUALTO" }, gm.EQUALTO = { type: 3, value: "EQUALTO" }, gm.NOTEQUALTO = { type: 3, value: "NOTEQUALTO" }, gm.INCLUDES = { type: 3, value: "INCLUDES" }, gm.NOTINCLUDES = { type: 3, value: "NOTINCLUDES" }, gm.INCLUDEDIN = { type: 3, value: "INCLUDEDIN" }, gm.NOTINCLUDEDIN = { type: 3, value: "NOTINCLUDEDIN" };
  let Ac = gm;
  e.IfcBenchmarkEnum = Ac;
  const bu = class bu {
  };
  bu.WATER = { type: 3, value: "WATER" }, bu.STEAM = { type: 3, value: "STEAM" }, bu.USERDEFINED = { type: 3, value: "USERDEFINED" }, bu.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Sc = bu;
  e.IfcBoilerTypeEnum = Sc;
  const UR = class UR {
  };
  UR.UNION = { type: 3, value: "UNION" }, UR.INTERSECTION = { type: 3, value: "INTERSECTION" }, UR.DIFFERENCE = { type: 3, value: "DIFFERENCE" };
  let CI = UR;
  e.IfcBooleanOperator = CI;
  const L7 = class L7 {
  };
  L7.INSULATION = { type: 3, value: "INSULATION" }, L7.PRECASTPANEL = { type: 3, value: "PRECASTPANEL" }, L7.USERDEFINED = { type: 3, value: "USERDEFINED" }, L7.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let go = L7;
  e.IfcBuildingElementPartTypeEnum = go;
  const zE = class zE {
  };
  zE.COMPLEX = { type: 3, value: "COMPLEX" }, zE.ELEMENT = { type: 3, value: "ELEMENT" }, zE.PARTIAL = { type: 3, value: "PARTIAL" }, zE.PROVISIONFORVOID = { type: 3, value: "PROVISIONFORVOID" }, zE.PROVISIONFORSPACE = { type: 3, value: "PROVISIONFORSPACE" }, zE.USERDEFINED = { type: 3, value: "USERDEFINED" }, zE.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Cf = zE;
  e.IfcBuildingElementProxyTypeEnum = Cf;
  const AT = class AT {
  };
  AT.FENESTRATION = { type: 3, value: "FENESTRATION" }, AT.FOUNDATION = { type: 3, value: "FOUNDATION" }, AT.LOADBEARING = { type: 3, value: "LOADBEARING" }, AT.OUTERSHELL = { type: 3, value: "OUTERSHELL" }, AT.SHADING = { type: 3, value: "SHADING" }, AT.TRANSPORT = { type: 3, value: "TRANSPORT" }, AT.USERDEFINED = { type: 3, value: "USERDEFINED" }, AT.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let bc = AT;
  e.IfcBuildingSystemTypeEnum = bc;
  const lk = class lk {
  };
  lk.USERDEFINED = { type: 3, value: "USERDEFINED" }, lk.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let OI = lk;
  e.IfcBurnerTypeEnum = OI;
  const OS = class OS {
  };
  OS.BEND = { type: 3, value: "BEND" }, OS.CROSS = { type: 3, value: "CROSS" }, OS.REDUCER = { type: 3, value: "REDUCER" }, OS.TEE = { type: 3, value: "TEE" }, OS.USERDEFINED = { type: 3, value: "USERDEFINED" }, OS.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Of = OS;
  e.IfcCableCarrierFittingTypeEnum = Of;
  const LS = class LS {
  };
  LS.CABLELADDERSEGMENT = { type: 3, value: "CABLELADDERSEGMENT" }, LS.CABLETRAYSEGMENT = { type: 3, value: "CABLETRAYSEGMENT" }, LS.CABLETRUNKINGSEGMENT = { type: 3, value: "CABLETRUNKINGSEGMENT" }, LS.CONDUITSEGMENT = { type: 3, value: "CONDUITSEGMENT" }, LS.USERDEFINED = { type: 3, value: "USERDEFINED" }, LS.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let xt = LS;
  e.IfcCableCarrierSegmentTypeEnum = xt;
  const BR = class BR {
  };
  BR.CONNECTOR = { type: 3, value: "CONNECTOR" }, BR.ENTRY = { type: 3, value: "ENTRY" }, BR.EXIT = { type: 3, value: "EXIT" }, BR.JUNCTION = { type: 3, value: "JUNCTION" }, BR.TRANSITION = { type: 3, value: "TRANSITION" }, BR.USERDEFINED = { type: 3, value: "USERDEFINED" }, BR.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let li = BR;
  e.IfcCableFittingTypeEnum = li;
  const _S = class _S {
  };
  _S.BUSBARSEGMENT = { type: 3, value: "BUSBARSEGMENT" }, _S.CABLESEGMENT = { type: 3, value: "CABLESEGMENT" }, _S.CONDUCTORSEGMENT = { type: 3, value: "CONDUCTORSEGMENT" }, _S.CORESEGMENT = { type: 3, value: "CORESEGMENT" }, _S.USERDEFINED = { type: 3, value: "USERDEFINED" }, _S.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let qi = _S;
  e.IfcCableSegmentTypeEnum = qi;
  const sD = class sD {
  };
  sD.NOCHANGE = { type: 3, value: "NOCHANGE" }, sD.MODIFIED = { type: 3, value: "MODIFIED" }, sD.ADDED = { type: 3, value: "ADDED" }, sD.DELETED = { type: 3, value: "DELETED" }, sD.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let un = sD;
  e.IfcChangeActionEnum = un;
  const oD = class oD {
  };
  oD.AIRCOOLED = { type: 3, value: "AIRCOOLED" }, oD.WATERCOOLED = { type: 3, value: "WATERCOOLED" }, oD.HEATRECOVERY = { type: 3, value: "HEATRECOVERY" }, oD.USERDEFINED = { type: 3, value: "USERDEFINED" }, oD.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Mn = oD;
  e.IfcChillerTypeEnum = Mn;
  const y9 = class y9 {
  };
  y9.USERDEFINED = { type: 3, value: "USERDEFINED" }, y9.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Pn = y9;
  e.IfcChimneyTypeEnum = Pn;
  const Nw = class Nw {
  };
  Nw.DXCOOLINGCOIL = { type: 3, value: "DXCOOLINGCOIL" }, Nw.ELECTRICHEATINGCOIL = { type: 3, value: "ELECTRICHEATINGCOIL" }, Nw.GASHEATINGCOIL = { type: 3, value: "GASHEATINGCOIL" }, Nw.HYDRONICCOIL = { type: 3, value: "HYDRONICCOIL" }, Nw.STEAMHEATINGCOIL = { type: 3, value: "STEAMHEATINGCOIL" }, Nw.WATERCOOLINGCOIL = { type: 3, value: "WATERCOOLINGCOIL" }, Nw.WATERHEATINGCOIL = { type: 3, value: "WATERHEATINGCOIL" }, Nw.USERDEFINED = { type: 3, value: "USERDEFINED" }, Nw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let ws = Nw;
  e.IfcCoilTypeEnum = ws;
  const _7 = class _7 {
  };
  _7.COLUMN = { type: 3, value: "COLUMN" }, _7.PILASTER = { type: 3, value: "PILASTER" }, _7.USERDEFINED = { type: 3, value: "USERDEFINED" }, _7.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ys = _7;
  e.IfcColumnTypeEnum = Ys;
  const Jf = class Jf {
  };
  Jf.ANTENNA = { type: 3, value: "ANTENNA" }, Jf.COMPUTER = { type: 3, value: "COMPUTER" }, Jf.FAX = { type: 3, value: "FAX" }, Jf.GATEWAY = { type: 3, value: "GATEWAY" }, Jf.MODEM = { type: 3, value: "MODEM" }, Jf.NETWORKAPPLIANCE = { type: 3, value: "NETWORKAPPLIANCE" }, Jf.NETWORKBRIDGE = { type: 3, value: "NETWORKBRIDGE" }, Jf.NETWORKHUB = { type: 3, value: "NETWORKHUB" }, Jf.PRINTER = { type: 3, value: "PRINTER" }, Jf.REPEATER = { type: 3, value: "REPEATER" }, Jf.ROUTER = { type: 3, value: "ROUTER" }, Jf.SCANNER = { type: 3, value: "SCANNER" }, Jf.USERDEFINED = { type: 3, value: "USERDEFINED" }, Jf.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ss = Jf;
  e.IfcCommunicationsApplianceTypeEnum = Ss;
  const ak = class ak {
  };
  ak.P_COMPLEX = { type: 3, value: "P_COMPLEX" }, ak.Q_COMPLEX = { type: 3, value: "Q_COMPLEX" };
  let dr = ak;
  e.IfcComplexPropertyTemplateTypeEnum = dr;
  const Wc = class Wc {
  };
  Wc.DYNAMIC = { type: 3, value: "DYNAMIC" }, Wc.RECIPROCATING = { type: 3, value: "RECIPROCATING" }, Wc.ROTARY = { type: 3, value: "ROTARY" }, Wc.SCROLL = { type: 3, value: "SCROLL" }, Wc.TROCHOIDAL = { type: 3, value: "TROCHOIDAL" }, Wc.SINGLESTAGE = { type: 3, value: "SINGLESTAGE" }, Wc.BOOSTER = { type: 3, value: "BOOSTER" }, Wc.OPENTYPE = { type: 3, value: "OPENTYPE" }, Wc.HERMETIC = { type: 3, value: "HERMETIC" }, Wc.SEMIHERMETIC = { type: 3, value: "SEMIHERMETIC" }, Wc.WELDEDSHELLHERMETIC = { type: 3, value: "WELDEDSHELLHERMETIC" }, Wc.ROLLINGPISTON = { type: 3, value: "ROLLINGPISTON" }, Wc.ROTARYVANE = { type: 3, value: "ROTARYVANE" }, Wc.SINGLESCREW = { type: 3, value: "SINGLESCREW" }, Wc.TWINSCREW = { type: 3, value: "TWINSCREW" }, Wc.USERDEFINED = { type: 3, value: "USERDEFINED" }, Wc.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Vr = Wc;
  e.IfcCompressorTypeEnum = Vr;
  const Dw = class Dw {
  };
  Dw.AIRCOOLED = { type: 3, value: "AIRCOOLED" }, Dw.EVAPORATIVECOOLED = { type: 3, value: "EVAPORATIVECOOLED" }, Dw.WATERCOOLED = { type: 3, value: "WATERCOOLED" }, Dw.WATERCOOLEDBRAZEDPLATE = { type: 3, value: "WATERCOOLEDBRAZEDPLATE" }, Dw.WATERCOOLEDSHELLCOIL = { type: 3, value: "WATERCOOLEDSHELLCOIL" }, Dw.WATERCOOLEDSHELLTUBE = { type: 3, value: "WATERCOOLEDSHELLTUBE" }, Dw.WATERCOOLEDTUBEINTUBE = { type: 3, value: "WATERCOOLEDTUBEINTUBE" }, Dw.USERDEFINED = { type: 3, value: "USERDEFINED" }, Dw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let _l = Dw;
  e.IfcCondenserTypeEnum = _l;
  const x7 = class x7 {
  };
  x7.ATPATH = { type: 3, value: "ATPATH" }, x7.ATSTART = { type: 3, value: "ATSTART" }, x7.ATEND = { type: 3, value: "ATEND" }, x7.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let p0 = x7;
  e.IfcConnectionTypeEnum = p0;
  const rD = class rD {
  };
  rD.HARD = { type: 3, value: "HARD" }, rD.SOFT = { type: 3, value: "SOFT" }, rD.ADVISORY = { type: 3, value: "ADVISORY" }, rD.USERDEFINED = { type: 3, value: "USERDEFINED" }, rD.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Lf = rD;
  e.IfcConstraintEnum = Lf;
  const jE = class jE {
  };
  jE.DEMOLISHING = { type: 3, value: "DEMOLISHING" }, jE.EARTHMOVING = { type: 3, value: "EARTHMOVING" }, jE.ERECTING = { type: 3, value: "ERECTING" }, jE.HEATING = { type: 3, value: "HEATING" }, jE.LIGHTING = { type: 3, value: "LIGHTING" }, jE.PAVING = { type: 3, value: "PAVING" }, jE.PUMPING = { type: 3, value: "PUMPING" }, jE.TRANSPORTING = { type: 3, value: "TRANSPORTING" }, jE.USERDEFINED = { type: 3, value: "USERDEFINED" }, jE.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let _f = jE;
  e.IfcConstructionEquipmentResourceTypeEnum = _f;
  const Iy = class Iy {
  };
  Iy.AGGREGATES = { type: 3, value: "AGGREGATES" }, Iy.CONCRETE = { type: 3, value: "CONCRETE" }, Iy.DRYWALL = { type: 3, value: "DRYWALL" }, Iy.FUEL = { type: 3, value: "FUEL" }, Iy.GYPSUM = { type: 3, value: "GYPSUM" }, Iy.MASONRY = { type: 3, value: "MASONRY" }, Iy.METAL = { type: 3, value: "METAL" }, Iy.PLASTIC = { type: 3, value: "PLASTIC" }, Iy.WOOD = { type: 3, value: "WOOD" }, Iy.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, Iy.USERDEFINED = { type: 3, value: "USERDEFINED" };
  let xf = Iy;
  e.IfcConstructionMaterialResourceTypeEnum = xf;
  const P7 = class P7 {
  };
  P7.ASSEMBLY = { type: 3, value: "ASSEMBLY" }, P7.FORMWORK = { type: 3, value: "FORMWORK" }, P7.USERDEFINED = { type: 3, value: "USERDEFINED" }, P7.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let aa = P7;
  e.IfcConstructionProductResourceTypeEnum = aa;
  const FR = class FR {
  };
  FR.FLOATING = { type: 3, value: "FLOATING" }, FR.PROGRAMMABLE = { type: 3, value: "PROGRAMMABLE" }, FR.PROPORTIONAL = { type: 3, value: "PROPORTIONAL" }, FR.MULTIPOSITION = { type: 3, value: "MULTIPOSITION" }, FR.TWOPOSITION = { type: 3, value: "TWOPOSITION" }, FR.USERDEFINED = { type: 3, value: "USERDEFINED" }, FR.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ih = FR;
  e.IfcControllerTypeEnum = Ih;
  const M7 = class M7 {
  };
  M7.ACTIVE = { type: 3, value: "ACTIVE" }, M7.PASSIVE = { type: 3, value: "PASSIVE" }, M7.USERDEFINED = { type: 3, value: "USERDEFINED" }, M7.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let ph = M7;
  e.IfcCooledBeamTypeEnum = ph;
  const lD = class lD {
  };
  lD.NATURALDRAFT = { type: 3, value: "NATURALDRAFT" }, lD.MECHANICALINDUCEDDRAFT = { type: 3, value: "MECHANICALINDUCEDDRAFT" }, lD.MECHANICALFORCEDDRAFT = { type: 3, value: "MECHANICALFORCEDDRAFT" }, lD.USERDEFINED = { type: 3, value: "USERDEFINED" }, lD.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let m0 = lD;
  e.IfcCoolingTowerTypeEnum = m0;
  const uk = class uk {
  };
  uk.USERDEFINED = { type: 3, value: "USERDEFINED" }, uk.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Nc = uk;
  e.IfcCostItemTypeEnum = Nc;
  const Cw = class Cw {
  };
  Cw.BUDGET = { type: 3, value: "BUDGET" }, Cw.COSTPLAN = { type: 3, value: "COSTPLAN" }, Cw.ESTIMATE = { type: 3, value: "ESTIMATE" }, Cw.TENDER = { type: 3, value: "TENDER" }, Cw.PRICEDBILLOFQUANTITIES = { type: 3, value: "PRICEDBILLOFQUANTITIES" }, Cw.UNPRICEDBILLOFQUANTITIES = { type: 3, value: "UNPRICEDBILLOFQUANTITIES" }, Cw.SCHEDULEOFRATES = { type: 3, value: "SCHEDULEOFRATES" }, Cw.USERDEFINED = { type: 3, value: "USERDEFINED" }, Cw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Nd = Cw;
  e.IfcCostScheduleTypeEnum = Nd;
  const wm = class wm {
  };
  wm.CEILING = { type: 3, value: "CEILING" }, wm.FLOORING = { type: 3, value: "FLOORING" }, wm.CLADDING = { type: 3, value: "CLADDING" }, wm.ROOFING = { type: 3, value: "ROOFING" }, wm.MOLDING = { type: 3, value: "MOLDING" }, wm.SKIRTINGBOARD = { type: 3, value: "SKIRTINGBOARD" }, wm.INSULATION = { type: 3, value: "INSULATION" }, wm.MEMBRANE = { type: 3, value: "MEMBRANE" }, wm.SLEEVING = { type: 3, value: "SLEEVING" }, wm.WRAPPING = { type: 3, value: "WRAPPING" }, wm.USERDEFINED = { type: 3, value: "USERDEFINED" }, wm.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Dd = wm;
  e.IfcCoveringTypeEnum = Dd;
  const U7 = class U7 {
  };
  U7.OFFICE = { type: 3, value: "OFFICE" }, U7.SITE = { type: 3, value: "SITE" }, U7.USERDEFINED = { type: 3, value: "USERDEFINED" }, U7.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Dc = U7;
  e.IfcCrewResourceTypeEnum = Dc;
  const dk = class dk {
  };
  dk.USERDEFINED = { type: 3, value: "USERDEFINED" }, dk.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Cc = dk;
  e.IfcCurtainWallTypeEnum = Cc;
  const B7 = class B7 {
  };
  B7.LINEAR = { type: 3, value: "LINEAR" }, B7.LOG_LINEAR = { type: 3, value: "LOG_LINEAR" }, B7.LOG_LOG = { type: 3, value: "LOG_LOG" }, B7.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let mh = B7;
  e.IfcCurveInterpolationEnum = mh;
  const np = class np {
  };
  np.BACKDRAFTDAMPER = { type: 3, value: "BACKDRAFTDAMPER" }, np.BALANCINGDAMPER = { type: 3, value: "BALANCINGDAMPER" }, np.BLASTDAMPER = { type: 3, value: "BLASTDAMPER" }, np.CONTROLDAMPER = { type: 3, value: "CONTROLDAMPER" }, np.FIREDAMPER = { type: 3, value: "FIREDAMPER" }, np.FIRESMOKEDAMPER = { type: 3, value: "FIRESMOKEDAMPER" }, np.FUMEHOODEXHAUST = { type: 3, value: "FUMEHOODEXHAUST" }, np.GRAVITYDAMPER = { type: 3, value: "GRAVITYDAMPER" }, np.GRAVITYRELIEFDAMPER = { type: 3, value: "GRAVITYRELIEFDAMPER" }, np.RELIEFDAMPER = { type: 3, value: "RELIEFDAMPER" }, np.SMOKEDAMPER = { type: 3, value: "SMOKEDAMPER" }, np.USERDEFINED = { type: 3, value: "USERDEFINED" }, np.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Go = np;
  e.IfcDamperTypeEnum = Go;
  const aD = class aD {
  };
  aD.MEASURED = { type: 3, value: "MEASURED" }, aD.PREDICTED = { type: 3, value: "PREDICTED" }, aD.SIMULATED = { type: 3, value: "SIMULATED" }, aD.USERDEFINED = { type: 3, value: "USERDEFINED" }, aD.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Oc = aD;
  e.IfcDataOriginEnum = Oc;
  const ds = class ds {
  };
  ds.ANGULARVELOCITYUNIT = { type: 3, value: "ANGULARVELOCITYUNIT" }, ds.AREADENSITYUNIT = { type: 3, value: "AREADENSITYUNIT" }, ds.COMPOUNDPLANEANGLEUNIT = { type: 3, value: "COMPOUNDPLANEANGLEUNIT" }, ds.DYNAMICVISCOSITYUNIT = { type: 3, value: "DYNAMICVISCOSITYUNIT" }, ds.HEATFLUXDENSITYUNIT = { type: 3, value: "HEATFLUXDENSITYUNIT" }, ds.INTEGERCOUNTRATEUNIT = { type: 3, value: "INTEGERCOUNTRATEUNIT" }, ds.ISOTHERMALMOISTURECAPACITYUNIT = { type: 3, value: "ISOTHERMALMOISTURECAPACITYUNIT" }, ds.KINEMATICVISCOSITYUNIT = { type: 3, value: "KINEMATICVISCOSITYUNIT" }, ds.LINEARVELOCITYUNIT = { type: 3, value: "LINEARVELOCITYUNIT" }, ds.MASSDENSITYUNIT = { type: 3, value: "MASSDENSITYUNIT" }, ds.MASSFLOWRATEUNIT = { type: 3, value: "MASSFLOWRATEUNIT" }, ds.MOISTUREDIFFUSIVITYUNIT = { type: 3, value: "MOISTUREDIFFUSIVITYUNIT" }, ds.MOLECULARWEIGHTUNIT = { type: 3, value: "MOLECULARWEIGHTUNIT" }, ds.SPECIFICHEATCAPACITYUNIT = { type: 3, value: "SPECIFICHEATCAPACITYUNIT" }, ds.THERMALADMITTANCEUNIT = { type: 3, value: "THERMALADMITTANCEUNIT" }, ds.THERMALCONDUCTANCEUNIT = { type: 3, value: "THERMALCONDUCTANCEUNIT" }, ds.THERMALRESISTANCEUNIT = { type: 3, value: "THERMALRESISTANCEUNIT" }, ds.THERMALTRANSMITTANCEUNIT = { type: 3, value: "THERMALTRANSMITTANCEUNIT" }, ds.VAPORPERMEABILITYUNIT = { type: 3, value: "VAPORPERMEABILITYUNIT" }, ds.VOLUMETRICFLOWRATEUNIT = { type: 3, value: "VOLUMETRICFLOWRATEUNIT" }, ds.ROTATIONALFREQUENCYUNIT = { type: 3, value: "ROTATIONALFREQUENCYUNIT" }, ds.TORQUEUNIT = { type: 3, value: "TORQUEUNIT" }, ds.MOMENTOFINERTIAUNIT = { type: 3, value: "MOMENTOFINERTIAUNIT" }, ds.LINEARMOMENTUNIT = { type: 3, value: "LINEARMOMENTUNIT" }, ds.LINEARFORCEUNIT = { type: 3, value: "LINEARFORCEUNIT" }, ds.PLANARFORCEUNIT = { type: 3, value: "PLANARFORCEUNIT" }, ds.MODULUSOFELASTICITYUNIT = { type: 3, value: "MODULUSOFELASTICITYUNIT" }, ds.SHEARMODULUSUNIT = { type: 3, value: "SHEARMODULUSUNIT" }, ds.LINEARSTIFFNESSUNIT = { type: 3, value: "LINEARSTIFFNESSUNIT" }, ds.ROTATIONALSTIFFNESSUNIT = { type: 3, value: "ROTATIONALSTIFFNESSUNIT" }, ds.MODULUSOFSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFSUBGRADEREACTIONUNIT" }, ds.ACCELERATIONUNIT = { type: 3, value: "ACCELERATIONUNIT" }, ds.CURVATUREUNIT = { type: 3, value: "CURVATUREUNIT" }, ds.HEATINGVALUEUNIT = { type: 3, value: "HEATINGVALUEUNIT" }, ds.IONCONCENTRATIONUNIT = { type: 3, value: "IONCONCENTRATIONUNIT" }, ds.LUMINOUSINTENSITYDISTRIBUTIONUNIT = { type: 3, value: "LUMINOUSINTENSITYDISTRIBUTIONUNIT" }, ds.MASSPERLENGTHUNIT = { type: 3, value: "MASSPERLENGTHUNIT" }, ds.MODULUSOFLINEARSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFLINEARSUBGRADEREACTIONUNIT" }, ds.MODULUSOFROTATIONALSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFROTATIONALSUBGRADEREACTIONUNIT" }, ds.PHUNIT = { type: 3, value: "PHUNIT" }, ds.ROTATIONALMASSUNIT = { type: 3, value: "ROTATIONALMASSUNIT" }, ds.SECTIONAREAINTEGRALUNIT = { type: 3, value: "SECTIONAREAINTEGRALUNIT" }, ds.SECTIONMODULUSUNIT = { type: 3, value: "SECTIONMODULUSUNIT" }, ds.SOUNDPOWERLEVELUNIT = { type: 3, value: "SOUNDPOWERLEVELUNIT" }, ds.SOUNDPOWERUNIT = { type: 3, value: "SOUNDPOWERUNIT" }, ds.SOUNDPRESSURELEVELUNIT = { type: 3, value: "SOUNDPRESSURELEVELUNIT" }, ds.SOUNDPRESSUREUNIT = { type: 3, value: "SOUNDPRESSUREUNIT" }, ds.TEMPERATUREGRADIENTUNIT = { type: 3, value: "TEMPERATUREGRADIENTUNIT" }, ds.TEMPERATURERATEOFCHANGEUNIT = { type: 3, value: "TEMPERATURERATEOFCHANGEUNIT" }, ds.THERMALEXPANSIONCOEFFICIENTUNIT = { type: 3, value: "THERMALEXPANSIONCOEFFICIENTUNIT" }, ds.WARPINGCONSTANTUNIT = { type: 3, value: "WARPINGCONSTANTUNIT" }, ds.WARPINGMOMENTUNIT = { type: 3, value: "WARPINGMOMENTUNIT" }, ds.USERDEFINED = { type: 3, value: "USERDEFINED" };
  let Lc = ds;
  e.IfcDerivedUnitEnum = Lc;
  const ck = class ck {
  };
  ck.POSITIVE = { type: 3, value: "POSITIVE" }, ck.NEGATIVE = { type: 3, value: "NEGATIVE" };
  let _c = ck;
  e.IfcDirectionSenseEnum = _c;
  const uD = class uD {
  };
  uD.ANCHORPLATE = { type: 3, value: "ANCHORPLATE" }, uD.BRACKET = { type: 3, value: "BRACKET" }, uD.SHOE = { type: 3, value: "SHOE" }, uD.USERDEFINED = { type: 3, value: "USERDEFINED" }, uD.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let xc = uD;
  e.IfcDiscreteAccessoryTypeEnum = xc;
  const WE = class WE {
  };
  WE.FORMEDDUCT = { type: 3, value: "FORMEDDUCT" }, WE.INSPECTIONCHAMBER = { type: 3, value: "INSPECTIONCHAMBER" }, WE.INSPECTIONPIT = { type: 3, value: "INSPECTIONPIT" }, WE.MANHOLE = { type: 3, value: "MANHOLE" }, WE.METERCHAMBER = { type: 3, value: "METERCHAMBER" }, WE.SUMP = { type: 3, value: "SUMP" }, WE.TRENCH = { type: 3, value: "TRENCH" }, WE.VALVECHAMBER = { type: 3, value: "VALVECHAMBER" }, WE.USERDEFINED = { type: 3, value: "USERDEFINED" }, WE.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Cd = WE;
  e.IfcDistributionChamberElementTypeEnum = Cd;
  const xS = class xS {
  };
  xS.CABLE = { type: 3, value: "CABLE" }, xS.CABLECARRIER = { type: 3, value: "CABLECARRIER" }, xS.DUCT = { type: 3, value: "DUCT" }, xS.PIPE = { type: 3, value: "PIPE" }, xS.USERDEFINED = { type: 3, value: "USERDEFINED" }, xS.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let xl = xS;
  e.IfcDistributionPortTypeEnum = xl;
  const Us = class Us {
  };
  Us.AIRCONDITIONING = { type: 3, value: "AIRCONDITIONING" }, Us.AUDIOVISUAL = { type: 3, value: "AUDIOVISUAL" }, Us.CHEMICAL = { type: 3, value: "CHEMICAL" }, Us.CHILLEDWATER = { type: 3, value: "CHILLEDWATER" }, Us.COMMUNICATION = { type: 3, value: "COMMUNICATION" }, Us.COMPRESSEDAIR = { type: 3, value: "COMPRESSEDAIR" }, Us.CONDENSERWATER = { type: 3, value: "CONDENSERWATER" }, Us.CONTROL = { type: 3, value: "CONTROL" }, Us.CONVEYING = { type: 3, value: "CONVEYING" }, Us.DATA = { type: 3, value: "DATA" }, Us.DISPOSAL = { type: 3, value: "DISPOSAL" }, Us.DOMESTICCOLDWATER = { type: 3, value: "DOMESTICCOLDWATER" }, Us.DOMESTICHOTWATER = { type: 3, value: "DOMESTICHOTWATER" }, Us.DRAINAGE = { type: 3, value: "DRAINAGE" }, Us.EARTHING = { type: 3, value: "EARTHING" }, Us.ELECTRICAL = { type: 3, value: "ELECTRICAL" }, Us.ELECTROACOUSTIC = { type: 3, value: "ELECTROACOUSTIC" }, Us.EXHAUST = { type: 3, value: "EXHAUST" }, Us.FIREPROTECTION = { type: 3, value: "FIREPROTECTION" }, Us.FUEL = { type: 3, value: "FUEL" }, Us.GAS = { type: 3, value: "GAS" }, Us.HAZARDOUS = { type: 3, value: "HAZARDOUS" }, Us.HEATING = { type: 3, value: "HEATING" }, Us.LIGHTING = { type: 3, value: "LIGHTING" }, Us.LIGHTNINGPROTECTION = { type: 3, value: "LIGHTNINGPROTECTION" }, Us.MUNICIPALSOLIDWASTE = { type: 3, value: "MUNICIPALSOLIDWASTE" }, Us.OIL = { type: 3, value: "OIL" }, Us.OPERATIONAL = { type: 3, value: "OPERATIONAL" }, Us.POWERGENERATION = { type: 3, value: "POWERGENERATION" }, Us.RAINWATER = { type: 3, value: "RAINWATER" }, Us.REFRIGERATION = { type: 3, value: "REFRIGERATION" }, Us.SECURITY = { type: 3, value: "SECURITY" }, Us.SEWAGE = { type: 3, value: "SEWAGE" }, Us.SIGNAL = { type: 3, value: "SIGNAL" }, Us.STORMWATER = { type: 3, value: "STORMWATER" }, Us.TELEPHONE = { type: 3, value: "TELEPHONE" }, Us.TV = { type: 3, value: "TV" }, Us.VACUUM = { type: 3, value: "VACUUM" }, Us.VENT = { type: 3, value: "VENT" }, Us.VENTILATION = { type: 3, value: "VENTILATION" }, Us.WASTEWATER = { type: 3, value: "WASTEWATER" }, Us.WATERSUPPLY = { type: 3, value: "WATERSUPPLY" }, Us.USERDEFINED = { type: 3, value: "USERDEFINED" }, Us.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let yh = Us;
  e.IfcDistributionSystemEnum = yh;
  const PS = class PS {
  };
  PS.PUBLIC = { type: 3, value: "PUBLIC" }, PS.RESTRICTED = { type: 3, value: "RESTRICTED" }, PS.CONFIDENTIAL = { type: 3, value: "CONFIDENTIAL" }, PS.PERSONAL = { type: 3, value: "PERSONAL" }, PS.USERDEFINED = { type: 3, value: "USERDEFINED" }, PS.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Eh = PS;
  e.IfcDocumentConfidentialityEnum = Eh;
  const dD = class dD {
  };
  dD.DRAFT = { type: 3, value: "DRAFT" }, dD.FINALDRAFT = { type: 3, value: "FINALDRAFT" }, dD.FINAL = { type: 3, value: "FINAL" }, dD.REVISION = { type: 3, value: "REVISION" }, dD.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let LI = dD;
  e.IfcDocumentStatusEnum = LI;
  const Ow = class Ow {
  };
  Ow.SWINGING = { type: 3, value: "SWINGING" }, Ow.DOUBLE_ACTING = { type: 3, value: "DOUBLE_ACTING" }, Ow.SLIDING = { type: 3, value: "SLIDING" }, Ow.FOLDING = { type: 3, value: "FOLDING" }, Ow.REVOLVING = { type: 3, value: "REVOLVING" }, Ow.ROLLINGUP = { type: 3, value: "ROLLINGUP" }, Ow.FIXEDPANEL = { type: 3, value: "FIXEDPANEL" }, Ow.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ow.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Pf = Ow;
  e.IfcDoorPanelOperationEnum = Pf;
  const F7 = class F7 {
  };
  F7.LEFT = { type: 3, value: "LEFT" }, F7.MIDDLE = { type: 3, value: "MIDDLE" }, F7.RIGHT = { type: 3, value: "RIGHT" }, F7.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Bi = F7;
  e.IfcDoorPanelPositionEnum = Bi;
  const Lw = class Lw {
  };
  Lw.ALUMINIUM = { type: 3, value: "ALUMINIUM" }, Lw.HIGH_GRADE_STEEL = { type: 3, value: "HIGH_GRADE_STEEL" }, Lw.STEEL = { type: 3, value: "STEEL" }, Lw.WOOD = { type: 3, value: "WOOD" }, Lw.ALUMINIUM_WOOD = { type: 3, value: "ALUMINIUM_WOOD" }, Lw.ALUMINIUM_PLASTIC = { type: 3, value: "ALUMINIUM_PLASTIC" }, Lw.PLASTIC = { type: 3, value: "PLASTIC" }, Lw.USERDEFINED = { type: 3, value: "USERDEFINED" }, Lw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let qu = Lw;
  e.IfcDoorStyleConstructionEnum = qu;
  const Hd = class Hd {
  };
  Hd.SINGLE_SWING_LEFT = { type: 3, value: "SINGLE_SWING_LEFT" }, Hd.SINGLE_SWING_RIGHT = { type: 3, value: "SINGLE_SWING_RIGHT" }, Hd.DOUBLE_DOOR_SINGLE_SWING = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING" }, Hd.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT" }, Hd.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT" }, Hd.DOUBLE_SWING_LEFT = { type: 3, value: "DOUBLE_SWING_LEFT" }, Hd.DOUBLE_SWING_RIGHT = { type: 3, value: "DOUBLE_SWING_RIGHT" }, Hd.DOUBLE_DOOR_DOUBLE_SWING = { type: 3, value: "DOUBLE_DOOR_DOUBLE_SWING" }, Hd.SLIDING_TO_LEFT = { type: 3, value: "SLIDING_TO_LEFT" }, Hd.SLIDING_TO_RIGHT = { type: 3, value: "SLIDING_TO_RIGHT" }, Hd.DOUBLE_DOOR_SLIDING = { type: 3, value: "DOUBLE_DOOR_SLIDING" }, Hd.FOLDING_TO_LEFT = { type: 3, value: "FOLDING_TO_LEFT" }, Hd.FOLDING_TO_RIGHT = { type: 3, value: "FOLDING_TO_RIGHT" }, Hd.DOUBLE_DOOR_FOLDING = { type: 3, value: "DOUBLE_DOOR_FOLDING" }, Hd.REVOLVING = { type: 3, value: "REVOLVING" }, Hd.ROLLINGUP = { type: 3, value: "ROLLINGUP" }, Hd.USERDEFINED = { type: 3, value: "USERDEFINED" }, Hd.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ru = Hd;
  e.IfcDoorStyleOperationEnum = Ru;
  const cD = class cD {
  };
  cD.DOOR = { type: 3, value: "DOOR" }, cD.GATE = { type: 3, value: "GATE" }, cD.TRAPDOOR = { type: 3, value: "TRAPDOOR" }, cD.USERDEFINED = { type: 3, value: "USERDEFINED" }, cD.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Pc = cD;
  e.IfcDoorTypeEnum = Pc;
  const Nu = class Nu {
  };
  Nu.SINGLE_SWING_LEFT = { type: 3, value: "SINGLE_SWING_LEFT" }, Nu.SINGLE_SWING_RIGHT = { type: 3, value: "SINGLE_SWING_RIGHT" }, Nu.DOUBLE_DOOR_SINGLE_SWING = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING" }, Nu.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT" }, Nu.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT" }, Nu.DOUBLE_SWING_LEFT = { type: 3, value: "DOUBLE_SWING_LEFT" }, Nu.DOUBLE_SWING_RIGHT = { type: 3, value: "DOUBLE_SWING_RIGHT" }, Nu.DOUBLE_DOOR_DOUBLE_SWING = { type: 3, value: "DOUBLE_DOOR_DOUBLE_SWING" }, Nu.SLIDING_TO_LEFT = { type: 3, value: "SLIDING_TO_LEFT" }, Nu.SLIDING_TO_RIGHT = { type: 3, value: "SLIDING_TO_RIGHT" }, Nu.DOUBLE_DOOR_SLIDING = { type: 3, value: "DOUBLE_DOOR_SLIDING" }, Nu.FOLDING_TO_LEFT = { type: 3, value: "FOLDING_TO_LEFT" }, Nu.FOLDING_TO_RIGHT = { type: 3, value: "FOLDING_TO_RIGHT" }, Nu.DOUBLE_DOOR_FOLDING = { type: 3, value: "DOUBLE_DOOR_FOLDING" }, Nu.REVOLVING = { type: 3, value: "REVOLVING" }, Nu.ROLLINGUP = { type: 3, value: "ROLLINGUP" }, Nu.SWING_FIXED_LEFT = { type: 3, value: "SWING_FIXED_LEFT" }, Nu.SWING_FIXED_RIGHT = { type: 3, value: "SWING_FIXED_RIGHT" }, Nu.USERDEFINED = { type: 3, value: "USERDEFINED" }, Nu.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Od = Nu;
  e.IfcDoorTypeOperationEnum = Od;
  const _w = class _w {
  };
  _w.BEND = { type: 3, value: "BEND" }, _w.CONNECTOR = { type: 3, value: "CONNECTOR" }, _w.ENTRY = { type: 3, value: "ENTRY" }, _w.EXIT = { type: 3, value: "EXIT" }, _w.JUNCTION = { type: 3, value: "JUNCTION" }, _w.OBSTRUCTION = { type: 3, value: "OBSTRUCTION" }, _w.TRANSITION = { type: 3, value: "TRANSITION" }, _w.USERDEFINED = { type: 3, value: "USERDEFINED" }, _w.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let gh = _w;
  e.IfcDuctFittingTypeEnum = gh;
  const H7 = class H7 {
  };
  H7.RIGIDSEGMENT = { type: 3, value: "RIGIDSEGMENT" }, H7.FLEXIBLESEGMENT = { type: 3, value: "FLEXIBLESEGMENT" }, H7.USERDEFINED = { type: 3, value: "USERDEFINED" }, H7.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Mc = H7;
  e.IfcDuctSegmentTypeEnum = Mc;
  const hD = class hD {
  };
  hD.FLATOVAL = { type: 3, value: "FLATOVAL" }, hD.RECTANGULAR = { type: 3, value: "RECTANGULAR" }, hD.ROUND = { type: 3, value: "ROUND" }, hD.USERDEFINED = { type: 3, value: "USERDEFINED" }, hD.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Uc = hD;
  e.IfcDuctSilencerTypeEnum = Uc;
  const Gd = class Gd {
  };
  Gd.DISHWASHER = { type: 3, value: "DISHWASHER" }, Gd.ELECTRICCOOKER = { type: 3, value: "ELECTRICCOOKER" }, Gd.FREESTANDINGELECTRICHEATER = { type: 3, value: "FREESTANDINGELECTRICHEATER" }, Gd.FREESTANDINGFAN = { type: 3, value: "FREESTANDINGFAN" }, Gd.FREESTANDINGWATERHEATER = { type: 3, value: "FREESTANDINGWATERHEATER" }, Gd.FREESTANDINGWATERCOOLER = { type: 3, value: "FREESTANDINGWATERCOOLER" }, Gd.FREEZER = { type: 3, value: "FREEZER" }, Gd.FRIDGE_FREEZER = { type: 3, value: "FRIDGE_FREEZER" }, Gd.HANDDRYER = { type: 3, value: "HANDDRYER" }, Gd.KITCHENMACHINE = { type: 3, value: "KITCHENMACHINE" }, Gd.MICROWAVE = { type: 3, value: "MICROWAVE" }, Gd.PHOTOCOPIER = { type: 3, value: "PHOTOCOPIER" }, Gd.REFRIGERATOR = { type: 3, value: "REFRIGERATOR" }, Gd.TUMBLEDRYER = { type: 3, value: "TUMBLEDRYER" }, Gd.VENDINGMACHINE = { type: 3, value: "VENDINGMACHINE" }, Gd.WASHINGMACHINE = { type: 3, value: "WASHINGMACHINE" }, Gd.USERDEFINED = { type: 3, value: "USERDEFINED" }, Gd.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let $u = Gd;
  e.IfcElectricApplianceTypeEnum = $u;
  const MS = class MS {
  };
  MS.CONSUMERUNIT = { type: 3, value: "CONSUMERUNIT" }, MS.DISTRIBUTIONBOARD = { type: 3, value: "DISTRIBUTIONBOARD" }, MS.MOTORCONTROLCENTRE = { type: 3, value: "MOTORCONTROLCENTRE" }, MS.SWITCHBOARD = { type: 3, value: "SWITCHBOARD" }, MS.USERDEFINED = { type: 3, value: "USERDEFINED" }, MS.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let ua = MS;
  e.IfcElectricDistributionBoardTypeEnum = ua;
  const HR = class HR {
  };
  HR.BATTERY = { type: 3, value: "BATTERY" }, HR.CAPACITORBANK = { type: 3, value: "CAPACITORBANK" }, HR.HARMONICFILTER = { type: 3, value: "HARMONICFILTER" }, HR.INDUCTORBANK = { type: 3, value: "INDUCTORBANK" }, HR.UPS = { type: 3, value: "UPS" }, HR.USERDEFINED = { type: 3, value: "USERDEFINED" }, HR.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Bc = HR;
  e.IfcElectricFlowStorageDeviceTypeEnum = Bc;
  const fD = class fD {
  };
  fD.CHP = { type: 3, value: "CHP" }, fD.ENGINEGENERATOR = { type: 3, value: "ENGINEGENERATOR" }, fD.STANDALONE = { type: 3, value: "STANDALONE" }, fD.USERDEFINED = { type: 3, value: "USERDEFINED" }, fD.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Fc = fD;
  e.IfcElectricGeneratorTypeEnum = Fc;
  const GR = class GR {
  };
  GR.DC = { type: 3, value: "DC" }, GR.INDUCTION = { type: 3, value: "INDUCTION" }, GR.POLYPHASE = { type: 3, value: "POLYPHASE" }, GR.RELUCTANCESYNCHRONOUS = { type: 3, value: "RELUCTANCESYNCHRONOUS" }, GR.SYNCHRONOUS = { type: 3, value: "SYNCHRONOUS" }, GR.USERDEFINED = { type: 3, value: "USERDEFINED" }, GR.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let y0 = GR;
  e.IfcElectricMotorTypeEnum = y0;
  const ID = class ID {
  };
  ID.TIMECLOCK = { type: 3, value: "TIMECLOCK" }, ID.TIMEDELAY = { type: 3, value: "TIMEDELAY" }, ID.RELAY = { type: 3, value: "RELAY" }, ID.USERDEFINED = { type: 3, value: "USERDEFINED" }, ID.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Wl = ID;
  e.IfcElectricTimeControlTypeEnum = Wl;
  const py = class py {
  };
  py.ACCESSORY_ASSEMBLY = { type: 3, value: "ACCESSORY_ASSEMBLY" }, py.ARCH = { type: 3, value: "ARCH" }, py.BEAM_GRID = { type: 3, value: "BEAM_GRID" }, py.BRACED_FRAME = { type: 3, value: "BRACED_FRAME" }, py.GIRDER = { type: 3, value: "GIRDER" }, py.REINFORCEMENT_UNIT = { type: 3, value: "REINFORCEMENT_UNIT" }, py.RIGID_FRAME = { type: 3, value: "RIGID_FRAME" }, py.SLAB_FIELD = { type: 3, value: "SLAB_FIELD" }, py.TRUSS = { type: 3, value: "TRUSS" }, py.USERDEFINED = { type: 3, value: "USERDEFINED" }, py.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Mf = py;
  e.IfcElementAssemblyTypeEnum = Mf;
  const E9 = class E9 {
  };
  E9.COMPLEX = { type: 3, value: "COMPLEX" }, E9.ELEMENT = { type: 3, value: "ELEMENT" }, E9.PARTIAL = { type: 3, value: "PARTIAL" };
  let m3 = E9;
  e.IfcElementCompositionEnum = m3;
  const G7 = class G7 {
  };
  G7.EXTERNALCOMBUSTION = { type: 3, value: "EXTERNALCOMBUSTION" }, G7.INTERNALCOMBUSTION = { type: 3, value: "INTERNALCOMBUSTION" }, G7.USERDEFINED = { type: 3, value: "USERDEFINED" }, G7.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let y3 = G7;
  e.IfcEngineTypeEnum = y3;
  const Tm = class Tm {
  };
  Tm.DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER" }, Tm.DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER" }, Tm.DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER" }, Tm.DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER" }, Tm.DIRECTEVAPORATIVEAIRWASHER = { type: 3, value: "DIRECTEVAPORATIVEAIRWASHER" }, Tm.INDIRECTEVAPORATIVEPACKAGEAIRCOOLER = { type: 3, value: "INDIRECTEVAPORATIVEPACKAGEAIRCOOLER" }, Tm.INDIRECTEVAPORATIVEWETCOIL = { type: 3, value: "INDIRECTEVAPORATIVEWETCOIL" }, Tm.INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER = { type: 3, value: "INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER" }, Tm.INDIRECTDIRECTCOMBINATION = { type: 3, value: "INDIRECTDIRECTCOMBINATION" }, Tm.USERDEFINED = { type: 3, value: "USERDEFINED" }, Tm.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let ko = Tm;
  e.IfcEvaporativeCoolerTypeEnum = ko;
  const ST = class ST {
  };
  ST.DIRECTEXPANSION = { type: 3, value: "DIRECTEXPANSION" }, ST.DIRECTEXPANSIONSHELLANDTUBE = { type: 3, value: "DIRECTEXPANSIONSHELLANDTUBE" }, ST.DIRECTEXPANSIONTUBEINTUBE = { type: 3, value: "DIRECTEXPANSIONTUBEINTUBE" }, ST.DIRECTEXPANSIONBRAZEDPLATE = { type: 3, value: "DIRECTEXPANSIONBRAZEDPLATE" }, ST.FLOODEDSHELLANDTUBE = { type: 3, value: "FLOODEDSHELLANDTUBE" }, ST.SHELLANDCOIL = { type: 3, value: "SHELLANDCOIL" }, ST.USERDEFINED = { type: 3, value: "USERDEFINED" }, ST.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let E3 = ST;
  e.IfcEvaporatorTypeEnum = E3;
  const US = class US {
  };
  US.EVENTRULE = { type: 3, value: "EVENTRULE" }, US.EVENTMESSAGE = { type: 3, value: "EVENTMESSAGE" }, US.EVENTTIME = { type: 3, value: "EVENTTIME" }, US.EVENTCOMPLEX = { type: 3, value: "EVENTCOMPLEX" }, US.USERDEFINED = { type: 3, value: "USERDEFINED" }, US.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let _I = US;
  e.IfcEventTriggerTypeEnum = _I;
  const pD = class pD {
  };
  pD.STARTEVENT = { type: 3, value: "STARTEVENT" }, pD.ENDEVENT = { type: 3, value: "ENDEVENT" }, pD.INTERMEDIATEEVENT = { type: 3, value: "INTERMEDIATEEVENT" }, pD.USERDEFINED = { type: 3, value: "USERDEFINED" }, pD.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let g3 = pD;
  e.IfcEventTypeEnum = g3;
  const BS = class BS {
  };
  BS.EXTERNAL = { type: 3, value: "EXTERNAL" }, BS.EXTERNAL_EARTH = { type: 3, value: "EXTERNAL_EARTH" }, BS.EXTERNAL_WATER = { type: 3, value: "EXTERNAL_WATER" }, BS.EXTERNAL_FIRE = { type: 3, value: "EXTERNAL_FIRE" }, BS.USERDEFINED = { type: 3, value: "USERDEFINED" }, BS.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let w3 = BS;
  e.IfcExternalSpatialElementTypeEnum = w3;
  const xw = class xw {
  };
  xw.CENTRIFUGALFORWARDCURVED = { type: 3, value: "CENTRIFUGALFORWARDCURVED" }, xw.CENTRIFUGALRADIAL = { type: 3, value: "CENTRIFUGALRADIAL" }, xw.CENTRIFUGALBACKWARDINCLINEDCURVED = { type: 3, value: "CENTRIFUGALBACKWARDINCLINEDCURVED" }, xw.CENTRIFUGALAIRFOIL = { type: 3, value: "CENTRIFUGALAIRFOIL" }, xw.TUBEAXIAL = { type: 3, value: "TUBEAXIAL" }, xw.VANEAXIAL = { type: 3, value: "VANEAXIAL" }, xw.PROPELLORAXIAL = { type: 3, value: "PROPELLORAXIAL" }, xw.USERDEFINED = { type: 3, value: "USERDEFINED" }, xw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let xI = xw;
  e.IfcFanTypeEnum = xI;
  const mD = class mD {
  };
  mD.GLUE = { type: 3, value: "GLUE" }, mD.MORTAR = { type: 3, value: "MORTAR" }, mD.WELD = { type: 3, value: "WELD" }, mD.USERDEFINED = { type: 3, value: "USERDEFINED" }, mD.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let T3 = mD;
  e.IfcFastenerTypeEnum = T3;
  const bT = class bT {
  };
  bT.AIRPARTICLEFILTER = { type: 3, value: "AIRPARTICLEFILTER" }, bT.COMPRESSEDAIRFILTER = { type: 3, value: "COMPRESSEDAIRFILTER" }, bT.ODORFILTER = { type: 3, value: "ODORFILTER" }, bT.OILFILTER = { type: 3, value: "OILFILTER" }, bT.STRAINER = { type: 3, value: "STRAINER" }, bT.WATERFILTER = { type: 3, value: "WATERFILTER" }, bT.USERDEFINED = { type: 3, value: "USERDEFINED" }, bT.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let wh = bT;
  e.IfcFilterTypeEnum = wh;
  const kR = class kR {
  };
  kR.BREECHINGINLET = { type: 3, value: "BREECHINGINLET" }, kR.FIREHYDRANT = { type: 3, value: "FIREHYDRANT" }, kR.HOSEREEL = { type: 3, value: "HOSEREEL" }, kR.SPRINKLER = { type: 3, value: "SPRINKLER" }, kR.SPRINKLERDEFLECTOR = { type: 3, value: "SPRINKLERDEFLECTOR" }, kR.USERDEFINED = { type: 3, value: "USERDEFINED" }, kR.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let R3 = kR;
  e.IfcFireSuppressionTerminalTypeEnum = R3;
  const k7 = class k7 {
  };
  k7.SOURCE = { type: 3, value: "SOURCE" }, k7.SINK = { type: 3, value: "SINK" }, k7.SOURCEANDSINK = { type: 3, value: "SOURCEANDSINK" }, k7.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Qs = k7;
  e.IfcFlowDirectionEnum = Qs;
  const YE = class YE {
  };
  YE.PRESSUREGAUGE = { type: 3, value: "PRESSUREGAUGE" }, YE.THERMOMETER = { type: 3, value: "THERMOMETER" }, YE.AMMETER = { type: 3, value: "AMMETER" }, YE.FREQUENCYMETER = { type: 3, value: "FREQUENCYMETER" }, YE.POWERFACTORMETER = { type: 3, value: "POWERFACTORMETER" }, YE.PHASEANGLEMETER = { type: 3, value: "PHASEANGLEMETER" }, YE.VOLTMETER_PEAK = { type: 3, value: "VOLTMETER_PEAK" }, YE.VOLTMETER_RMS = { type: 3, value: "VOLTMETER_RMS" }, YE.USERDEFINED = { type: 3, value: "USERDEFINED" }, YE.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let v3 = YE;
  e.IfcFlowInstrumentTypeEnum = v3;
  const FS = class FS {
  };
  FS.ENERGYMETER = { type: 3, value: "ENERGYMETER" }, FS.GASMETER = { type: 3, value: "GASMETER" }, FS.OILMETER = { type: 3, value: "OILMETER" }, FS.WATERMETER = { type: 3, value: "WATERMETER" }, FS.USERDEFINED = { type: 3, value: "USERDEFINED" }, FS.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Uf = FS;
  e.IfcFlowMeterTypeEnum = Uf;
  const VR = class VR {
  };
  VR.CAISSON_FOUNDATION = { type: 3, value: "CAISSON_FOUNDATION" }, VR.FOOTING_BEAM = { type: 3, value: "FOOTING_BEAM" }, VR.PAD_FOOTING = { type: 3, value: "PAD_FOOTING" }, VR.PILE_CAP = { type: 3, value: "PILE_CAP" }, VR.STRIP_FOOTING = { type: 3, value: "STRIP_FOOTING" }, VR.USERDEFINED = { type: 3, value: "USERDEFINED" }, VR.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ku = VR;
  e.IfcFootingTypeEnum = Ku;
  const Pw = class Pw {
  };
  Pw.CHAIR = { type: 3, value: "CHAIR" }, Pw.TABLE = { type: 3, value: "TABLE" }, Pw.DESK = { type: 3, value: "DESK" }, Pw.BED = { type: 3, value: "BED" }, Pw.FILECABINET = { type: 3, value: "FILECABINET" }, Pw.SHELF = { type: 3, value: "SHELF" }, Pw.SOFA = { type: 3, value: "SOFA" }, Pw.USERDEFINED = { type: 3, value: "USERDEFINED" }, Pw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let PI = Pw;
  e.IfcFurnitureTypeEnum = PI;
  const g9 = class g9 {
  };
  g9.TERRAIN = { type: 3, value: "TERRAIN" }, g9.USERDEFINED = { type: 3, value: "USERDEFINED" }, g9.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Bf = g9;
  e.IfcGeographicElementTypeEnum = Bf;
  const Mw = class Mw {
  };
  Mw.GRAPH_VIEW = { type: 3, value: "GRAPH_VIEW" }, Mw.SKETCH_VIEW = { type: 3, value: "SKETCH_VIEW" }, Mw.MODEL_VIEW = { type: 3, value: "MODEL_VIEW" }, Mw.PLAN_VIEW = { type: 3, value: "PLAN_VIEW" }, Mw.REFLECTED_PLAN_VIEW = { type: 3, value: "REFLECTED_PLAN_VIEW" }, Mw.SECTION_VIEW = { type: 3, value: "SECTION_VIEW" }, Mw.ELEVATION_VIEW = { type: 3, value: "ELEVATION_VIEW" }, Mw.USERDEFINED = { type: 3, value: "USERDEFINED" }, Mw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let A3 = Mw;
  e.IfcGeometricProjectionEnum = A3;
  const hk = class hk {
  };
  hk.GLOBAL_COORDS = { type: 3, value: "GLOBAL_COORDS" }, hk.LOCAL_COORDS = { type: 3, value: "LOCAL_COORDS" };
  let Hc = hk;
  e.IfcGlobalOrLocalEnum = Hc;
  const HS = class HS {
  };
  HS.RECTANGULAR = { type: 3, value: "RECTANGULAR" }, HS.RADIAL = { type: 3, value: "RADIAL" }, HS.TRIANGULAR = { type: 3, value: "TRIANGULAR" }, HS.IRREGULAR = { type: 3, value: "IRREGULAR" }, HS.USERDEFINED = { type: 3, value: "USERDEFINED" }, HS.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let tm = HS;
  e.IfcGridTypeEnum = tm;
  const V7 = class V7 {
  };
  V7.PLATE = { type: 3, value: "PLATE" }, V7.SHELLANDTUBE = { type: 3, value: "SHELLANDTUBE" }, V7.USERDEFINED = { type: 3, value: "USERDEFINED" }, V7.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let hs = V7;
  e.IfcHeatExchangerTypeEnum = hs;
  const Ch = class Ch {
  };
  Ch.STEAMINJECTION = { type: 3, value: "STEAMINJECTION" }, Ch.ADIABATICAIRWASHER = { type: 3, value: "ADIABATICAIRWASHER" }, Ch.ADIABATICPAN = { type: 3, value: "ADIABATICPAN" }, Ch.ADIABATICWETTEDELEMENT = { type: 3, value: "ADIABATICWETTEDELEMENT" }, Ch.ADIABATICATOMIZING = { type: 3, value: "ADIABATICATOMIZING" }, Ch.ADIABATICULTRASONIC = { type: 3, value: "ADIABATICULTRASONIC" }, Ch.ADIABATICRIGIDMEDIA = { type: 3, value: "ADIABATICRIGIDMEDIA" }, Ch.ADIABATICCOMPRESSEDAIRNOZZLE = { type: 3, value: "ADIABATICCOMPRESSEDAIRNOZZLE" }, Ch.ASSISTEDELECTRIC = { type: 3, value: "ASSISTEDELECTRIC" }, Ch.ASSISTEDNATURALGAS = { type: 3, value: "ASSISTEDNATURALGAS" }, Ch.ASSISTEDPROPANE = { type: 3, value: "ASSISTEDPROPANE" }, Ch.ASSISTEDBUTANE = { type: 3, value: "ASSISTEDBUTANE" }, Ch.ASSISTEDSTEAM = { type: 3, value: "ASSISTEDSTEAM" }, Ch.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ch.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let S3 = Ch;
  e.IfcHumidifierTypeEnum = S3;
  const GS = class GS {
  };
  GS.CYCLONIC = { type: 3, value: "CYCLONIC" }, GS.GREASE = { type: 3, value: "GREASE" }, GS.OIL = { type: 3, value: "OIL" }, GS.PETROL = { type: 3, value: "PETROL" }, GS.USERDEFINED = { type: 3, value: "USERDEFINED" }, GS.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let b3 = GS;
  e.IfcInterceptorTypeEnum = b3;
  const kS = class kS {
  };
  kS.INTERNAL = { type: 3, value: "INTERNAL" }, kS.EXTERNAL = { type: 3, value: "EXTERNAL" }, kS.EXTERNAL_EARTH = { type: 3, value: "EXTERNAL_EARTH" }, kS.EXTERNAL_WATER = { type: 3, value: "EXTERNAL_WATER" }, kS.EXTERNAL_FIRE = { type: 3, value: "EXTERNAL_FIRE" }, kS.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let N3 = kS;
  e.IfcInternalOrExternalEnum = N3;
  const yD = class yD {
  };
  yD.ASSETINVENTORY = { type: 3, value: "ASSETINVENTORY" }, yD.SPACEINVENTORY = { type: 3, value: "SPACEINVENTORY" }, yD.FURNITUREINVENTORY = { type: 3, value: "FURNITUREINVENTORY" }, yD.USERDEFINED = { type: 3, value: "USERDEFINED" }, yD.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let D3 = yD;
  e.IfcInventoryTypeEnum = D3;
  const z7 = class z7 {
  };
  z7.DATA = { type: 3, value: "DATA" }, z7.POWER = { type: 3, value: "POWER" }, z7.USERDEFINED = { type: 3, value: "USERDEFINED" }, z7.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let C3 = z7;
  e.IfcJunctionBoxTypeEnum = C3;
  const j7 = class j7 {
  };
  j7.UNIFORM_KNOTS = { type: 3, value: "UNIFORM_KNOTS" }, j7.QUASI_UNIFORM_KNOTS = { type: 3, value: "QUASI_UNIFORM_KNOTS" }, j7.PIECEWISE_BEZIER_KNOTS = { type: 3, value: "PIECEWISE_BEZIER_KNOTS" }, j7.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" };
  let MI = j7;
  e.IfcKnotType = MI;
  const fa = class fa {
  };
  fa.ADMINISTRATION = { type: 3, value: "ADMINISTRATION" }, fa.CARPENTRY = { type: 3, value: "CARPENTRY" }, fa.CLEANING = { type: 3, value: "CLEANING" }, fa.CONCRETE = { type: 3, value: "CONCRETE" }, fa.DRYWALL = { type: 3, value: "DRYWALL" }, fa.ELECTRIC = { type: 3, value: "ELECTRIC" }, fa.FINISHING = { type: 3, value: "FINISHING" }, fa.FLOORING = { type: 3, value: "FLOORING" }, fa.GENERAL = { type: 3, value: "GENERAL" }, fa.HVAC = { type: 3, value: "HVAC" }, fa.LANDSCAPING = { type: 3, value: "LANDSCAPING" }, fa.MASONRY = { type: 3, value: "MASONRY" }, fa.PAINTING = { type: 3, value: "PAINTING" }, fa.PAVING = { type: 3, value: "PAVING" }, fa.PLUMBING = { type: 3, value: "PLUMBING" }, fa.ROOFING = { type: 3, value: "ROOFING" }, fa.SITEGRADING = { type: 3, value: "SITEGRADING" }, fa.STEELWORK = { type: 3, value: "STEELWORK" }, fa.SURVEYING = { type: 3, value: "SURVEYING" }, fa.USERDEFINED = { type: 3, value: "USERDEFINED" }, fa.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let st = fa;
  e.IfcLaborResourceTypeEnum = st;
  const my = class my {
  };
  my.COMPACTFLUORESCENT = { type: 3, value: "COMPACTFLUORESCENT" }, my.FLUORESCENT = { type: 3, value: "FLUORESCENT" }, my.HALOGEN = { type: 3, value: "HALOGEN" }, my.HIGHPRESSUREMERCURY = { type: 3, value: "HIGHPRESSUREMERCURY" }, my.HIGHPRESSURESODIUM = { type: 3, value: "HIGHPRESSURESODIUM" }, my.LED = { type: 3, value: "LED" }, my.METALHALIDE = { type: 3, value: "METALHALIDE" }, my.OLED = { type: 3, value: "OLED" }, my.TUNGSTENFILAMENT = { type: 3, value: "TUNGSTENFILAMENT" }, my.USERDEFINED = { type: 3, value: "USERDEFINED" }, my.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ld = my;
  e.IfcLampTypeEnum = Ld;
  const w9 = class w9 {
  };
  w9.AXIS1 = { type: 3, value: "AXIS1" }, w9.AXIS2 = { type: 3, value: "AXIS2" }, w9.AXIS3 = { type: 3, value: "AXIS3" };
  let O3 = w9;
  e.IfcLayerSetDirectionEnum = O3;
  const W7 = class W7 {
  };
  W7.TYPE_A = { type: 3, value: "TYPE_A" }, W7.TYPE_B = { type: 3, value: "TYPE_B" }, W7.TYPE_C = { type: 3, value: "TYPE_C" }, W7.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let UI = W7;
  e.IfcLightDistributionCurveEnum = UI;
  const yy = class yy {
  };
  yy.COMPACTFLUORESCENT = { type: 3, value: "COMPACTFLUORESCENT" }, yy.FLUORESCENT = { type: 3, value: "FLUORESCENT" }, yy.HIGHPRESSUREMERCURY = { type: 3, value: "HIGHPRESSUREMERCURY" }, yy.HIGHPRESSURESODIUM = { type: 3, value: "HIGHPRESSURESODIUM" }, yy.LIGHTEMITTINGDIODE = { type: 3, value: "LIGHTEMITTINGDIODE" }, yy.LOWPRESSURESODIUM = { type: 3, value: "LOWPRESSURESODIUM" }, yy.LOWVOLTAGEHALOGEN = { type: 3, value: "LOWVOLTAGEHALOGEN" }, yy.MAINVOLTAGEHALOGEN = { type: 3, value: "MAINVOLTAGEHALOGEN" }, yy.METALHALIDE = { type: 3, value: "METALHALIDE" }, yy.TUNGSTENFILAMENT = { type: 3, value: "TUNGSTENFILAMENT" }, yy.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ff = yy;
  e.IfcLightEmissionSourceEnum = Ff;
  const ED = class ED {
  };
  ED.POINTSOURCE = { type: 3, value: "POINTSOURCE" }, ED.DIRECTIONSOURCE = { type: 3, value: "DIRECTIONSOURCE" }, ED.SECURITYLIGHTING = { type: 3, value: "SECURITYLIGHTING" }, ED.USERDEFINED = { type: 3, value: "USERDEFINED" }, ED.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let L3 = ED;
  e.IfcLightFixtureTypeEnum = L3;
  const gD = class gD {
  };
  gD.LOAD_GROUP = { type: 3, value: "LOAD_GROUP" }, gD.LOAD_CASE = { type: 3, value: "LOAD_CASE" }, gD.LOAD_COMBINATION = { type: 3, value: "LOAD_COMBINATION" }, gD.USERDEFINED = { type: 3, value: "USERDEFINED" }, gD.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let _3 = gD;
  e.IfcLoadGroupTypeEnum = _3;
  const wD = class wD {
  };
  wD.LOGICALAND = { type: 3, value: "LOGICALAND" }, wD.LOGICALOR = { type: 3, value: "LOGICALOR" }, wD.LOGICALXOR = { type: 3, value: "LOGICALXOR" }, wD.LOGICALNOTAND = { type: 3, value: "LOGICALNOTAND" }, wD.LOGICALNOTOR = { type: 3, value: "LOGICALNOTOR" };
  let x3 = wD;
  e.IfcLogicalOperatorEnum = x3;
  const Rm = class Rm {
  };
  Rm.ANCHORBOLT = { type: 3, value: "ANCHORBOLT" }, Rm.BOLT = { type: 3, value: "BOLT" }, Rm.DOWEL = { type: 3, value: "DOWEL" }, Rm.NAIL = { type: 3, value: "NAIL" }, Rm.NAILPLATE = { type: 3, value: "NAILPLATE" }, Rm.RIVET = { type: 3, value: "RIVET" }, Rm.SCREW = { type: 3, value: "SCREW" }, Rm.SHEARCONNECTOR = { type: 3, value: "SHEARCONNECTOR" }, Rm.STAPLE = { type: 3, value: "STAPLE" }, Rm.STUDSHEARCONNECTOR = { type: 3, value: "STUDSHEARCONNECTOR" }, Rm.USERDEFINED = { type: 3, value: "USERDEFINED" }, Rm.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let BI = Rm;
  e.IfcMechanicalFastenerTypeEnum = BI;
  const zR = class zR {
  };
  zR.AIRSTATION = { type: 3, value: "AIRSTATION" }, zR.FEEDAIRUNIT = { type: 3, value: "FEEDAIRUNIT" }, zR.OXYGENGENERATOR = { type: 3, value: "OXYGENGENERATOR" }, zR.OXYGENPLANT = { type: 3, value: "OXYGENPLANT" }, zR.VACUUMSTATION = { type: 3, value: "VACUUMSTATION" }, zR.USERDEFINED = { type: 3, value: "USERDEFINED" }, zR.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let P3 = zR;
  e.IfcMedicalDeviceTypeEnum = P3;
  const Ia = class Ia {
  };
  Ia.BRACE = { type: 3, value: "BRACE" }, Ia.CHORD = { type: 3, value: "CHORD" }, Ia.COLLAR = { type: 3, value: "COLLAR" }, Ia.MEMBER = { type: 3, value: "MEMBER" }, Ia.MULLION = { type: 3, value: "MULLION" }, Ia.PLATE = { type: 3, value: "PLATE" }, Ia.POST = { type: 3, value: "POST" }, Ia.PURLIN = { type: 3, value: "PURLIN" }, Ia.RAFTER = { type: 3, value: "RAFTER" }, Ia.STRINGER = { type: 3, value: "STRINGER" }, Ia.STRUT = { type: 3, value: "STRUT" }, Ia.STUD = { type: 3, value: "STUD" }, Ia.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ia.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let M3 = Ia;
  e.IfcMemberTypeEnum = M3;
  const TD = class TD {
  };
  TD.BELTDRIVE = { type: 3, value: "BELTDRIVE" }, TD.COUPLING = { type: 3, value: "COUPLING" }, TD.DIRECTDRIVE = { type: 3, value: "DIRECTDRIVE" }, TD.USERDEFINED = { type: 3, value: "USERDEFINED" }, TD.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let U3 = TD;
  e.IfcMotorConnectionTypeEnum = U3;
  const nZ = class nZ {
  };
  nZ.NULL = { type: 3, value: "NULL" };
  let B3 = nZ;
  e.IfcNullStyle = B3;
  const NT = class NT {
  };
  NT.PRODUCT = { type: 3, value: "PRODUCT" }, NT.PROCESS = { type: 3, value: "PROCESS" }, NT.CONTROL = { type: 3, value: "CONTROL" }, NT.RESOURCE = { type: 3, value: "RESOURCE" }, NT.ACTOR = { type: 3, value: "ACTOR" }, NT.GROUP = { type: 3, value: "GROUP" }, NT.PROJECT = { type: 3, value: "PROJECT" }, NT.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let FI = NT;
  e.IfcObjectTypeEnum = FI;
  const sp = class sp {
  };
  sp.CODECOMPLIANCE = { type: 3, value: "CODECOMPLIANCE" }, sp.CODEWAIVER = { type: 3, value: "CODEWAIVER" }, sp.DESIGNINTENT = { type: 3, value: "DESIGNINTENT" }, sp.EXTERNAL = { type: 3, value: "EXTERNAL" }, sp.HEALTHANDSAFETY = { type: 3, value: "HEALTHANDSAFETY" }, sp.MERGECONFLICT = { type: 3, value: "MERGECONFLICT" }, sp.MODELVIEW = { type: 3, value: "MODELVIEW" }, sp.PARAMETER = { type: 3, value: "PARAMETER" }, sp.REQUIREMENT = { type: 3, value: "REQUIREMENT" }, sp.SPECIFICATION = { type: 3, value: "SPECIFICATION" }, sp.TRIGGERCONDITION = { type: 3, value: "TRIGGERCONDITION" }, sp.USERDEFINED = { type: 3, value: "USERDEFINED" }, sp.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let HI = sp;
  e.IfcObjectiveEnum = HI;
  const Uw = class Uw {
  };
  Uw.ASSIGNEE = { type: 3, value: "ASSIGNEE" }, Uw.ASSIGNOR = { type: 3, value: "ASSIGNOR" }, Uw.LESSEE = { type: 3, value: "LESSEE" }, Uw.LESSOR = { type: 3, value: "LESSOR" }, Uw.LETTINGAGENT = { type: 3, value: "LETTINGAGENT" }, Uw.OWNER = { type: 3, value: "OWNER" }, Uw.TENANT = { type: 3, value: "TENANT" }, Uw.USERDEFINED = { type: 3, value: "USERDEFINED" }, Uw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let F3 = Uw;
  e.IfcOccupantTypeEnum = F3;
  const Y7 = class Y7 {
  };
  Y7.OPENING = { type: 3, value: "OPENING" }, Y7.RECESS = { type: 3, value: "RECESS" }, Y7.USERDEFINED = { type: 3, value: "USERDEFINED" }, Y7.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let H3 = Y7;
  e.IfcOpeningElementTypeEnum = H3;
  const jR = class jR {
  };
  jR.AUDIOVISUALOUTLET = { type: 3, value: "AUDIOVISUALOUTLET" }, jR.COMMUNICATIONSOUTLET = { type: 3, value: "COMMUNICATIONSOUTLET" }, jR.POWEROUTLET = { type: 3, value: "POWEROUTLET" }, jR.DATAOUTLET = { type: 3, value: "DATAOUTLET" }, jR.TELEPHONEOUTLET = { type: 3, value: "TELEPHONEOUTLET" }, jR.USERDEFINED = { type: 3, value: "USERDEFINED" }, jR.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let G3 = jR;
  e.IfcOutletTypeEnum = G3;
  const fk = class fk {
  };
  fk.USERDEFINED = { type: 3, value: "USERDEFINED" }, fk.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let k3 = fk;
  e.IfcPerformanceHistoryTypeEnum = k3;
  const RD = class RD {
  };
  RD.GRILL = { type: 3, value: "GRILL" }, RD.LOUVER = { type: 3, value: "LOUVER" }, RD.SCREEN = { type: 3, value: "SCREEN" }, RD.USERDEFINED = { type: 3, value: "USERDEFINED" }, RD.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let im = RD;
  e.IfcPermeableCoveringOperationEnum = im;
  const vD = class vD {
  };
  vD.ACCESS = { type: 3, value: "ACCESS" }, vD.BUILDING = { type: 3, value: "BUILDING" }, vD.WORK = { type: 3, value: "WORK" }, vD.USERDEFINED = { type: 3, value: "USERDEFINED" }, vD.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Hf = vD;
  e.IfcPermitTypeEnum = Hf;
  const T9 = class T9 {
  };
  T9.PHYSICAL = { type: 3, value: "PHYSICAL" }, T9.VIRTUAL = { type: 3, value: "VIRTUAL" }, T9.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Gf = T9;
  e.IfcPhysicalOrVirtualEnum = Gf;
  const VS = class VS {
  };
  VS.CAST_IN_PLACE = { type: 3, value: "CAST_IN_PLACE" }, VS.COMPOSITE = { type: 3, value: "COMPOSITE" }, VS.PRECAST_CONCRETE = { type: 3, value: "PRECAST_CONCRETE" }, VS.PREFAB_STEEL = { type: 3, value: "PREFAB_STEEL" }, VS.USERDEFINED = { type: 3, value: "USERDEFINED" }, VS.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let V3 = VS;
  e.IfcPileConstructionEnum = V3;
  const DT = class DT {
  };
  DT.BORED = { type: 3, value: "BORED" }, DT.DRIVEN = { type: 3, value: "DRIVEN" }, DT.JETGROUTING = { type: 3, value: "JETGROUTING" }, DT.COHESION = { type: 3, value: "COHESION" }, DT.FRICTION = { type: 3, value: "FRICTION" }, DT.SUPPORT = { type: 3, value: "SUPPORT" }, DT.USERDEFINED = { type: 3, value: "USERDEFINED" }, DT.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Zu = DT;
  e.IfcPileTypeEnum = Zu;
  const Bw = class Bw {
  };
  Bw.BEND = { type: 3, value: "BEND" }, Bw.CONNECTOR = { type: 3, value: "CONNECTOR" }, Bw.ENTRY = { type: 3, value: "ENTRY" }, Bw.EXIT = { type: 3, value: "EXIT" }, Bw.JUNCTION = { type: 3, value: "JUNCTION" }, Bw.OBSTRUCTION = { type: 3, value: "OBSTRUCTION" }, Bw.TRANSITION = { type: 3, value: "TRANSITION" }, Bw.USERDEFINED = { type: 3, value: "USERDEFINED" }, Bw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let kf = Bw;
  e.IfcPipeFittingTypeEnum = kf;
  const WR = class WR {
  };
  WR.CULVERT = { type: 3, value: "CULVERT" }, WR.FLEXIBLESEGMENT = { type: 3, value: "FLEXIBLESEGMENT" }, WR.RIGIDSEGMENT = { type: 3, value: "RIGIDSEGMENT" }, WR.GUTTER = { type: 3, value: "GUTTER" }, WR.SPOOL = { type: 3, value: "SPOOL" }, WR.USERDEFINED = { type: 3, value: "USERDEFINED" }, WR.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let nm = WR;
  e.IfcPipeSegmentTypeEnum = nm;
  const q7 = class q7 {
  };
  q7.CURTAIN_PANEL = { type: 3, value: "CURTAIN_PANEL" }, q7.SHEET = { type: 3, value: "SHEET" }, q7.USERDEFINED = { type: 3, value: "USERDEFINED" }, q7.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let sm = q7;
  e.IfcPlateTypeEnum = sm;
  const R9 = class R9 {
  };
  R9.CURVE3D = { type: 3, value: "CURVE3D" }, R9.PCURVE_S1 = { type: 3, value: "PCURVE_S1" }, R9.PCURVE_S2 = { type: 3, value: "PCURVE_S2" };
  let z3 = R9;
  e.IfcPreferredSurfaceCurveRepresentation = z3;
  const Fw = class Fw {
  };
  Fw.ADVICE_CAUTION = { type: 3, value: "ADVICE_CAUTION" }, Fw.ADVICE_NOTE = { type: 3, value: "ADVICE_NOTE" }, Fw.ADVICE_WARNING = { type: 3, value: "ADVICE_WARNING" }, Fw.CALIBRATION = { type: 3, value: "CALIBRATION" }, Fw.DIAGNOSTIC = { type: 3, value: "DIAGNOSTIC" }, Fw.SHUTDOWN = { type: 3, value: "SHUTDOWN" }, Fw.STARTUP = { type: 3, value: "STARTUP" }, Fw.USERDEFINED = { type: 3, value: "USERDEFINED" }, Fw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let _d = Fw;
  e.IfcProcedureTypeEnum = _d;
  const Ik = class Ik {
  };
  Ik.CURVE = { type: 3, value: "CURVE" }, Ik.AREA = { type: 3, value: "AREA" };
  let om = Ik;
  e.IfcProfileTypeEnum = om;
  const YR = class YR {
  };
  YR.CHANGEORDER = { type: 3, value: "CHANGEORDER" }, YR.MAINTENANCEWORKORDER = { type: 3, value: "MAINTENANCEWORKORDER" }, YR.MOVEORDER = { type: 3, value: "MOVEORDER" }, YR.PURCHASEORDER = { type: 3, value: "PURCHASEORDER" }, YR.WORKORDER = { type: 3, value: "WORKORDER" }, YR.USERDEFINED = { type: 3, value: "USERDEFINED" }, YR.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Z = YR;
  e.IfcProjectOrderTypeEnum = Z;
  const pk = class pk {
  };
  pk.PROJECTED_LENGTH = { type: 3, value: "PROJECTED_LENGTH" }, pk.TRUE_LENGTH = { type: 3, value: "TRUE_LENGTH" };
  let ae = pk;
  e.IfcProjectedOrTrueLengthEnum = ae;
  const mk = class mk {
  };
  mk.USERDEFINED = { type: 3, value: "USERDEFINED" }, mk.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Re = mk;
  e.IfcProjectionElementTypeEnum = Re;
  const A0 = class A0 {
  };
  A0.PSET_TYPEDRIVENONLY = { type: 3, value: "PSET_TYPEDRIVENONLY" }, A0.PSET_TYPEDRIVENOVERRIDE = { type: 3, value: "PSET_TYPEDRIVENOVERRIDE" }, A0.PSET_OCCURRENCEDRIVEN = { type: 3, value: "PSET_OCCURRENCEDRIVEN" }, A0.PSET_PERFORMANCEDRIVEN = { type: 3, value: "PSET_PERFORMANCEDRIVEN" }, A0.QTO_TYPEDRIVENONLY = { type: 3, value: "QTO_TYPEDRIVENONLY" }, A0.QTO_TYPEDRIVENOVERRIDE = { type: 3, value: "QTO_TYPEDRIVENOVERRIDE" }, A0.QTO_OCCURRENCEDRIVEN = { type: 3, value: "QTO_OCCURRENCEDRIVEN" }, A0.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ue = A0;
  e.IfcPropertySetTemplateTypeEnum = Ue;
  const Wo = class Wo {
  };
  Wo.ELECTRONIC = { type: 3, value: "ELECTRONIC" }, Wo.ELECTROMAGNETIC = { type: 3, value: "ELECTROMAGNETIC" }, Wo.RESIDUALCURRENT = { type: 3, value: "RESIDUALCURRENT" }, Wo.THERMAL = { type: 3, value: "THERMAL" }, Wo.USERDEFINED = { type: 3, value: "USERDEFINED" }, Wo.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let nt = Wo;
  e.IfcProtectiveDeviceTrippingUnitTypeEnum = nt;
  const Oh = class Oh {
  };
  Oh.CIRCUITBREAKER = { type: 3, value: "CIRCUITBREAKER" }, Oh.EARTHLEAKAGECIRCUITBREAKER = { type: 3, value: "EARTHLEAKAGECIRCUITBREAKER" }, Oh.EARTHINGSWITCH = { type: 3, value: "EARTHINGSWITCH" }, Oh.FUSEDISCONNECTOR = { type: 3, value: "FUSEDISCONNECTOR" }, Oh.RESIDUALCURRENTCIRCUITBREAKER = { type: 3, value: "RESIDUALCURRENTCIRCUITBREAKER" }, Oh.RESIDUALCURRENTSWITCH = { type: 3, value: "RESIDUALCURRENTSWITCH" }, Oh.VARISTOR = { type: 3, value: "VARISTOR" }, Oh.USERDEFINED = { type: 3, value: "USERDEFINED" }, Oh.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let At = Oh;
  e.IfcProtectiveDeviceTypeEnum = At;
  const Yc = class Yc {
  };
  Yc.CIRCULATOR = { type: 3, value: "CIRCULATOR" }, Yc.ENDSUCTION = { type: 3, value: "ENDSUCTION" }, Yc.SPLITCASE = { type: 3, value: "SPLITCASE" }, Yc.SUBMERSIBLEPUMP = { type: 3, value: "SUBMERSIBLEPUMP" }, Yc.SUMPPUMP = { type: 3, value: "SUMPPUMP" }, Yc.VERTICALINLINE = { type: 3, value: "VERTICALINLINE" }, Yc.VERTICALTURBINE = { type: 3, value: "VERTICALTURBINE" }, Yc.USERDEFINED = { type: 3, value: "USERDEFINED" }, Yc.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Lt = Yc;
  e.IfcPumpTypeEnum = Lt;
  const Ey = class Ey {
  };
  Ey.HANDRAIL = { type: 3, value: "HANDRAIL" }, Ey.GUARDRAIL = { type: 3, value: "GUARDRAIL" }, Ey.BALUSTRADE = { type: 3, value: "BALUSTRADE" }, Ey.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ey.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let _t = Ey;
  e.IfcRailingTypeEnum = _t;
  const qE = class qE {
  };
  qE.STRAIGHT = { type: 3, value: "STRAIGHT" }, qE.SPIRAL = { type: 3, value: "SPIRAL" }, qE.USERDEFINED = { type: 3, value: "USERDEFINED" }, qE.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let oi = qE;
  e.IfcRampFlightTypeEnum = oi;
  const Lh = class Lh {
  };
  Lh.STRAIGHT_RUN_RAMP = { type: 3, value: "STRAIGHT_RUN_RAMP" }, Lh.TWO_STRAIGHT_RUN_RAMP = { type: 3, value: "TWO_STRAIGHT_RUN_RAMP" }, Lh.QUARTER_TURN_RAMP = { type: 3, value: "QUARTER_TURN_RAMP" }, Lh.TWO_QUARTER_TURN_RAMP = { type: 3, value: "TWO_QUARTER_TURN_RAMP" }, Lh.HALF_TURN_RAMP = { type: 3, value: "HALF_TURN_RAMP" }, Lh.SPIRAL_RAMP = { type: 3, value: "SPIRAL_RAMP" }, Lh.USERDEFINED = { type: 3, value: "USERDEFINED" }, Lh.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let mi = Lh;
  e.IfcRampTypeEnum = mi;
  const Du = class Du {
  };
  Du.DAILY = { type: 3, value: "DAILY" }, Du.WEEKLY = { type: 3, value: "WEEKLY" }, Du.MONTHLY_BY_DAY_OF_MONTH = { type: 3, value: "MONTHLY_BY_DAY_OF_MONTH" }, Du.MONTHLY_BY_POSITION = { type: 3, value: "MONTHLY_BY_POSITION" }, Du.BY_DAY_COUNT = { type: 3, value: "BY_DAY_COUNT" }, Du.BY_WEEKDAY_COUNT = { type: 3, value: "BY_WEEKDAY_COUNT" }, Du.YEARLY_BY_DAY_OF_MONTH = { type: 3, value: "YEARLY_BY_DAY_OF_MONTH" }, Du.YEARLY_BY_POSITION = { type: 3, value: "YEARLY_BY_POSITION" };
  let zi = Du;
  e.IfcRecurrenceTypeEnum = zi;
  const pa = class pa {
  };
  pa.BLINN = { type: 3, value: "BLINN" }, pa.FLAT = { type: 3, value: "FLAT" }, pa.GLASS = { type: 3, value: "GLASS" }, pa.MATT = { type: 3, value: "MATT" }, pa.METAL = { type: 3, value: "METAL" }, pa.MIRROR = { type: 3, value: "MIRROR" }, pa.PHONG = { type: 3, value: "PHONG" }, pa.PLASTIC = { type: 3, value: "PLASTIC" }, pa.STRAUSS = { type: 3, value: "STRAUSS" }, pa.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let yn = pa;
  e.IfcReflectanceMethodEnum = yn;
  const kd = class kd {
  };
  kd.MAIN = { type: 3, value: "MAIN" }, kd.SHEAR = { type: 3, value: "SHEAR" }, kd.LIGATURE = { type: 3, value: "LIGATURE" }, kd.STUD = { type: 3, value: "STUD" }, kd.PUNCHING = { type: 3, value: "PUNCHING" }, kd.EDGE = { type: 3, value: "EDGE" }, kd.RING = { type: 3, value: "RING" }, kd.ANCHORING = { type: 3, value: "ANCHORING" }, kd.USERDEFINED = { type: 3, value: "USERDEFINED" }, kd.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Xi = kd;
  e.IfcReinforcingBarRoleEnum = Xi;
  const vm = class vm {
  };
  vm.PLAIN = { type: 3, value: "PLAIN" }, vm.TEXTURED = { type: 3, value: "TEXTURED" };
  let rn = vm;
  e.IfcReinforcingBarSurfaceEnum = rn;
  const op = class op {
  };
  op.ANCHORING = { type: 3, value: "ANCHORING" }, op.EDGE = { type: 3, value: "EDGE" }, op.LIGATURE = { type: 3, value: "LIGATURE" }, op.MAIN = { type: 3, value: "MAIN" }, op.PUNCHING = { type: 3, value: "PUNCHING" }, op.RING = { type: 3, value: "RING" }, op.SHEAR = { type: 3, value: "SHEAR" }, op.STUD = { type: 3, value: "STUD" }, op.USERDEFINED = { type: 3, value: "USERDEFINED" }, op.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Fn = op;
  e.IfcReinforcingBarTypeEnum = Fn;
  const qR = class qR {
  };
  qR.USERDEFINED = { type: 3, value: "USERDEFINED" }, qR.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ps = qR;
  e.IfcReinforcingMeshTypeEnum = Ps;
  const _r = class _r {
  };
  _r.SUPPLIER = { type: 3, value: "SUPPLIER" }, _r.MANUFACTURER = { type: 3, value: "MANUFACTURER" }, _r.CONTRACTOR = { type: 3, value: "CONTRACTOR" }, _r.SUBCONTRACTOR = { type: 3, value: "SUBCONTRACTOR" }, _r.ARCHITECT = { type: 3, value: "ARCHITECT" }, _r.STRUCTURALENGINEER = { type: 3, value: "STRUCTURALENGINEER" }, _r.COSTENGINEER = { type: 3, value: "COSTENGINEER" }, _r.CLIENT = { type: 3, value: "CLIENT" }, _r.BUILDINGOWNER = { type: 3, value: "BUILDINGOWNER" }, _r.BUILDINGOPERATOR = { type: 3, value: "BUILDINGOPERATOR" }, _r.MECHANICALENGINEER = { type: 3, value: "MECHANICALENGINEER" }, _r.ELECTRICALENGINEER = { type: 3, value: "ELECTRICALENGINEER" }, _r.PROJECTMANAGER = { type: 3, value: "PROJECTMANAGER" }, _r.FACILITIESMANAGER = { type: 3, value: "FACILITIESMANAGER" }, _r.CIVILENGINEER = { type: 3, value: "CIVILENGINEER" }, _r.COMMISSIONINGENGINEER = { type: 3, value: "COMMISSIONINGENGINEER" }, _r.ENGINEER = { type: 3, value: "ENGINEER" }, _r.OWNER = { type: 3, value: "OWNER" }, _r.CONSULTANT = { type: 3, value: "CONSULTANT" }, _r.CONSTRUCTIONMANAGER = { type: 3, value: "CONSTRUCTIONMANAGER" }, _r.FIELDCONSTRUCTIONMANAGER = { type: 3, value: "FIELDCONSTRUCTIONMANAGER" }, _r.RESELLER = { type: 3, value: "RESELLER" }, _r.USERDEFINED = { type: 3, value: "USERDEFINED" };
  let Fs = _r;
  e.IfcRoleEnum = Fs;
  const Kl = class Kl {
  };
  Kl.FLAT_ROOF = { type: 3, value: "FLAT_ROOF" }, Kl.SHED_ROOF = { type: 3, value: "SHED_ROOF" }, Kl.GABLE_ROOF = { type: 3, value: "GABLE_ROOF" }, Kl.HIP_ROOF = { type: 3, value: "HIP_ROOF" }, Kl.HIPPED_GABLE_ROOF = { type: 3, value: "HIPPED_GABLE_ROOF" }, Kl.GAMBREL_ROOF = { type: 3, value: "GAMBREL_ROOF" }, Kl.MANSARD_ROOF = { type: 3, value: "MANSARD_ROOF" }, Kl.BARREL_ROOF = { type: 3, value: "BARREL_ROOF" }, Kl.RAINBOW_ROOF = { type: 3, value: "RAINBOW_ROOF" }, Kl.BUTTERFLY_ROOF = { type: 3, value: "BUTTERFLY_ROOF" }, Kl.PAVILION_ROOF = { type: 3, value: "PAVILION_ROOF" }, Kl.DOME_ROOF = { type: 3, value: "DOME_ROOF" }, Kl.FREEFORM = { type: 3, value: "FREEFORM" }, Kl.USERDEFINED = { type: 3, value: "USERDEFINED" }, Kl.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let uo = Kl;
  e.IfcRoofTypeEnum = uo;
  const jr = class jr {
  };
  jr.EXA = { type: 3, value: "EXA" }, jr.PETA = { type: 3, value: "PETA" }, jr.TERA = { type: 3, value: "TERA" }, jr.GIGA = { type: 3, value: "GIGA" }, jr.MEGA = { type: 3, value: "MEGA" }, jr.KILO = { type: 3, value: "KILO" }, jr.HECTO = { type: 3, value: "HECTO" }, jr.DECA = { type: 3, value: "DECA" }, jr.DECI = { type: 3, value: "DECI" }, jr.CENTI = { type: 3, value: "CENTI" }, jr.MILLI = { type: 3, value: "MILLI" }, jr.MICRO = { type: 3, value: "MICRO" }, jr.NANO = { type: 3, value: "NANO" }, jr.PICO = { type: 3, value: "PICO" }, jr.FEMTO = { type: 3, value: "FEMTO" }, jr.ATTO = { type: 3, value: "ATTO" };
  let Ui = jr;
  e.IfcSIPrefix = Ui;
  const Mo = class Mo {
  };
  Mo.AMPERE = { type: 3, value: "AMPERE" }, Mo.BECQUEREL = { type: 3, value: "BECQUEREL" }, Mo.CANDELA = { type: 3, value: "CANDELA" }, Mo.COULOMB = { type: 3, value: "COULOMB" }, Mo.CUBIC_METRE = { type: 3, value: "CUBIC_METRE" }, Mo.DEGREE_CELSIUS = { type: 3, value: "DEGREE_CELSIUS" }, Mo.FARAD = { type: 3, value: "FARAD" }, Mo.GRAM = { type: 3, value: "GRAM" }, Mo.GRAY = { type: 3, value: "GRAY" }, Mo.HENRY = { type: 3, value: "HENRY" }, Mo.HERTZ = { type: 3, value: "HERTZ" }, Mo.JOULE = { type: 3, value: "JOULE" }, Mo.KELVIN = { type: 3, value: "KELVIN" }, Mo.LUMEN = { type: 3, value: "LUMEN" }, Mo.LUX = { type: 3, value: "LUX" }, Mo.METRE = { type: 3, value: "METRE" }, Mo.MOLE = { type: 3, value: "MOLE" }, Mo.NEWTON = { type: 3, value: "NEWTON" }, Mo.OHM = { type: 3, value: "OHM" }, Mo.PASCAL = { type: 3, value: "PASCAL" }, Mo.RADIAN = { type: 3, value: "RADIAN" }, Mo.SECOND = { type: 3, value: "SECOND" }, Mo.SIEMENS = { type: 3, value: "SIEMENS" }, Mo.SIEVERT = { type: 3, value: "SIEVERT" }, Mo.SQUARE_METRE = { type: 3, value: "SQUARE_METRE" }, Mo.STERADIAN = { type: 3, value: "STERADIAN" }, Mo.TESLA = { type: 3, value: "TESLA" }, Mo.VOLT = { type: 3, value: "VOLT" }, Mo.WATT = { type: 3, value: "WATT" }, Mo.WEBER = { type: 3, value: "WEBER" };
  let Rn = Mo;
  e.IfcSIUnitName = Rn;
  const S0 = class S0 {
  };
  S0.BATH = { type: 3, value: "BATH" }, S0.BIDET = { type: 3, value: "BIDET" }, S0.CISTERN = { type: 3, value: "CISTERN" }, S0.SHOWER = { type: 3, value: "SHOWER" }, S0.SINK = { type: 3, value: "SINK" }, S0.SANITARYFOUNTAIN = { type: 3, value: "SANITARYFOUNTAIN" }, S0.TOILETPAN = { type: 3, value: "TOILETPAN" }, S0.URINAL = { type: 3, value: "URINAL" }, S0.WASHHANDBASIN = { type: 3, value: "WASHHANDBASIN" }, S0.WCSEAT = { type: 3, value: "WCSEAT" }, S0.USERDEFINED = { type: 3, value: "USERDEFINED" }, S0.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Vo = S0;
  e.IfcSanitaryTerminalTypeEnum = Vo;
  const Vd = class Vd {
  };
  Vd.UNIFORM = { type: 3, value: "UNIFORM" }, Vd.TAPERED = { type: 3, value: "TAPERED" };
  let Do = Vd;
  e.IfcSectionTypeEnum = Do;
  const er = class er {
  };
  er.COSENSOR = { type: 3, value: "COSENSOR" }, er.CO2SENSOR = { type: 3, value: "CO2SENSOR" }, er.CONDUCTANCESENSOR = { type: 3, value: "CONDUCTANCESENSOR" }, er.CONTACTSENSOR = { type: 3, value: "CONTACTSENSOR" }, er.FIRESENSOR = { type: 3, value: "FIRESENSOR" }, er.FLOWSENSOR = { type: 3, value: "FLOWSENSOR" }, er.FROSTSENSOR = { type: 3, value: "FROSTSENSOR" }, er.GASSENSOR = { type: 3, value: "GASSENSOR" }, er.HEATSENSOR = { type: 3, value: "HEATSENSOR" }, er.HUMIDITYSENSOR = { type: 3, value: "HUMIDITYSENSOR" }, er.IDENTIFIERSENSOR = { type: 3, value: "IDENTIFIERSENSOR" }, er.IONCONCENTRATIONSENSOR = { type: 3, value: "IONCONCENTRATIONSENSOR" }, er.LEVELSENSOR = { type: 3, value: "LEVELSENSOR" }, er.LIGHTSENSOR = { type: 3, value: "LIGHTSENSOR" }, er.MOISTURESENSOR = { type: 3, value: "MOISTURESENSOR" }, er.MOVEMENTSENSOR = { type: 3, value: "MOVEMENTSENSOR" }, er.PHSENSOR = { type: 3, value: "PHSENSOR" }, er.PRESSURESENSOR = { type: 3, value: "PRESSURESENSOR" }, er.RADIATIONSENSOR = { type: 3, value: "RADIATIONSENSOR" }, er.RADIOACTIVITYSENSOR = { type: 3, value: "RADIOACTIVITYSENSOR" }, er.SMOKESENSOR = { type: 3, value: "SMOKESENSOR" }, er.SOUNDSENSOR = { type: 3, value: "SOUNDSENSOR" }, er.TEMPERATURESENSOR = { type: 3, value: "TEMPERATURESENSOR" }, er.WINDSENSOR = { type: 3, value: "WINDSENSOR" }, er.USERDEFINED = { type: 3, value: "USERDEFINED" }, er.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Pl = er;
  e.IfcSensorTypeEnum = Pl;
  const zd = class zd {
  };
  zd.START_START = { type: 3, value: "START_START" }, zd.START_FINISH = { type: 3, value: "START_FINISH" }, zd.FINISH_START = { type: 3, value: "FINISH_START" }, zd.FINISH_FINISH = { type: 3, value: "FINISH_FINISH" }, zd.USERDEFINED = { type: 3, value: "USERDEFINED" }, zd.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let cr = zd;
  e.IfcSequenceEnum = cr;
  const Cu = class Cu {
  };
  Cu.JALOUSIE = { type: 3, value: "JALOUSIE" }, Cu.SHUTTER = { type: 3, value: "SHUTTER" }, Cu.AWNING = { type: 3, value: "AWNING" }, Cu.USERDEFINED = { type: 3, value: "USERDEFINED" }, Cu.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let S4 = Cu;
  e.IfcShadingDeviceTypeEnum = S4;
  const jd = class jd {
  };
  jd.P_SINGLEVALUE = { type: 3, value: "P_SINGLEVALUE" }, jd.P_ENUMERATEDVALUE = { type: 3, value: "P_ENUMERATEDVALUE" }, jd.P_BOUNDEDVALUE = { type: 3, value: "P_BOUNDEDVALUE" }, jd.P_LISTVALUE = { type: 3, value: "P_LISTVALUE" }, jd.P_TABLEVALUE = { type: 3, value: "P_TABLEVALUE" }, jd.P_REFERENCEVALUE = { type: 3, value: "P_REFERENCEVALUE" }, jd.Q_LENGTH = { type: 3, value: "Q_LENGTH" }, jd.Q_AREA = { type: 3, value: "Q_AREA" }, jd.Q_VOLUME = { type: 3, value: "Q_VOLUME" }, jd.Q_COUNT = { type: 3, value: "Q_COUNT" }, jd.Q_WEIGHT = { type: 3, value: "Q_WEIGHT" }, jd.Q_TIME = { type: 3, value: "Q_TIME" };
  let b4 = jd;
  e.IfcSimplePropertyTemplateTypeEnum = b4;
  const qc = class qc {
  };
  qc.FLOOR = { type: 3, value: "FLOOR" }, qc.ROOF = { type: 3, value: "ROOF" }, qc.LANDING = { type: 3, value: "LANDING" }, qc.BASESLAB = { type: 3, value: "BASESLAB" }, qc.USERDEFINED = { type: 3, value: "USERDEFINED" }, qc.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let IE = qc;
  e.IfcSlabTypeEnum = IE;
  const _h = class _h {
  };
  _h.SOLARCOLLECTOR = { type: 3, value: "SOLARCOLLECTOR" }, _h.SOLARPANEL = { type: 3, value: "SOLARPANEL" }, _h.USERDEFINED = { type: 3, value: "USERDEFINED" }, _h.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let N4 = _h;
  e.IfcSolarDeviceTypeEnum = N4;
  const Hw = class Hw {
  };
  Hw.CONVECTOR = { type: 3, value: "CONVECTOR" }, Hw.RADIATOR = { type: 3, value: "RADIATOR" }, Hw.USERDEFINED = { type: 3, value: "USERDEFINED" }, Hw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let D4 = Hw;
  e.IfcSpaceHeaterTypeEnum = D4;
  const gy = class gy {
  };
  gy.SPACE = { type: 3, value: "SPACE" }, gy.PARKING = { type: 3, value: "PARKING" }, gy.GFA = { type: 3, value: "GFA" }, gy.INTERNAL = { type: 3, value: "INTERNAL" }, gy.EXTERNAL = { type: 3, value: "EXTERNAL" }, gy.USERDEFINED = { type: 3, value: "USERDEFINED" }, gy.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let C4 = gy;
  e.IfcSpaceTypeEnum = C4;
  const Ul = class Ul {
  };
  Ul.CONSTRUCTION = { type: 3, value: "CONSTRUCTION" }, Ul.FIRESAFETY = { type: 3, value: "FIRESAFETY" }, Ul.LIGHTING = { type: 3, value: "LIGHTING" }, Ul.OCCUPANCY = { type: 3, value: "OCCUPANCY" }, Ul.SECURITY = { type: 3, value: "SECURITY" }, Ul.THERMAL = { type: 3, value: "THERMAL" }, Ul.TRANSPORT = { type: 3, value: "TRANSPORT" }, Ul.VENTILATION = { type: 3, value: "VENTILATION" }, Ul.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ul.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let O4 = Ul;
  e.IfcSpatialZoneTypeEnum = O4;
  const b0 = class b0 {
  };
  b0.BIRDCAGE = { type: 3, value: "BIRDCAGE" }, b0.COWL = { type: 3, value: "COWL" }, b0.RAINWATERHOPPER = { type: 3, value: "RAINWATERHOPPER" }, b0.USERDEFINED = { type: 3, value: "USERDEFINED" }, b0.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let k5 = b0;
  e.IfcStackTerminalTypeEnum = k5;
  const xh = class xh {
  };
  xh.STRAIGHT = { type: 3, value: "STRAIGHT" }, xh.WINDER = { type: 3, value: "WINDER" }, xh.SPIRAL = { type: 3, value: "SPIRAL" }, xh.CURVED = { type: 3, value: "CURVED" }, xh.FREEFORM = { type: 3, value: "FREEFORM" }, xh.USERDEFINED = { type: 3, value: "USERDEFINED" }, xh.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let V5 = xh;
  e.IfcStairFlightTypeEnum = V5;
  const Zl = class Zl {
  };
  Zl.STRAIGHT_RUN_STAIR = { type: 3, value: "STRAIGHT_RUN_STAIR" }, Zl.TWO_STRAIGHT_RUN_STAIR = { type: 3, value: "TWO_STRAIGHT_RUN_STAIR" }, Zl.QUARTER_WINDING_STAIR = { type: 3, value: "QUARTER_WINDING_STAIR" }, Zl.QUARTER_TURN_STAIR = { type: 3, value: "QUARTER_TURN_STAIR" }, Zl.HALF_WINDING_STAIR = { type: 3, value: "HALF_WINDING_STAIR" }, Zl.HALF_TURN_STAIR = { type: 3, value: "HALF_TURN_STAIR" }, Zl.TWO_QUARTER_WINDING_STAIR = { type: 3, value: "TWO_QUARTER_WINDING_STAIR" }, Zl.TWO_QUARTER_TURN_STAIR = { type: 3, value: "TWO_QUARTER_TURN_STAIR" }, Zl.THREE_QUARTER_WINDING_STAIR = { type: 3, value: "THREE_QUARTER_WINDING_STAIR" }, Zl.THREE_QUARTER_TURN_STAIR = { type: 3, value: "THREE_QUARTER_TURN_STAIR" }, Zl.SPIRAL_STAIR = { type: 3, value: "SPIRAL_STAIR" }, Zl.DOUBLE_RETURN_STAIR = { type: 3, value: "DOUBLE_RETURN_STAIR" }, Zl.CURVED_RUN_STAIR = { type: 3, value: "CURVED_RUN_STAIR" }, Zl.TWO_CURVED_RUN_STAIR = { type: 3, value: "TWO_CURVED_RUN_STAIR" }, Zl.USERDEFINED = { type: 3, value: "USERDEFINED" }, Zl.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let L4 = Zl;
  e.IfcStairTypeEnum = L4;
  const $c = class $c {
  };
  $c.READWRITE = { type: 3, value: "READWRITE" }, $c.READONLY = { type: 3, value: "READONLY" }, $c.LOCKED = { type: 3, value: "LOCKED" }, $c.READWRITELOCKED = { type: 3, value: "READWRITELOCKED" }, $c.READONLYLOCKED = { type: 3, value: "READONLYLOCKED" };
  let _4 = $c;
  e.IfcStateEnum = _4;
  const El = class El {
  };
  El.CONST = { type: 3, value: "CONST" }, El.LINEAR = { type: 3, value: "LINEAR" }, El.POLYGONAL = { type: 3, value: "POLYGONAL" }, El.EQUIDISTANT = { type: 3, value: "EQUIDISTANT" }, El.SINUS = { type: 3, value: "SINUS" }, El.PARABOLA = { type: 3, value: "PARABOLA" }, El.DISCRETE = { type: 3, value: "DISCRETE" }, El.USERDEFINED = { type: 3, value: "USERDEFINED" }, El.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let z5 = El;
  e.IfcStructuralCurveActivityTypeEnum = z5;
  const $E = class $E {
  };
  $E.RIGID_JOINED_MEMBER = { type: 3, value: "RIGID_JOINED_MEMBER" }, $E.PIN_JOINED_MEMBER = { type: 3, value: "PIN_JOINED_MEMBER" }, $E.CABLE = { type: 3, value: "CABLE" }, $E.TENSION_MEMBER = { type: 3, value: "TENSION_MEMBER" }, $E.COMPRESSION_MEMBER = { type: 3, value: "COMPRESSION_MEMBER" }, $E.USERDEFINED = { type: 3, value: "USERDEFINED" }, $E.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let j5 = $E;
  e.IfcStructuralCurveMemberTypeEnum = j5;
  const Ph = class Ph {
  };
  Ph.CONST = { type: 3, value: "CONST" }, Ph.BILINEAR = { type: 3, value: "BILINEAR" }, Ph.DISCRETE = { type: 3, value: "DISCRETE" }, Ph.ISOCONTOUR = { type: 3, value: "ISOCONTOUR" }, Ph.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ph.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let x4 = Ph;
  e.IfcStructuralSurfaceActivityTypeEnum = x4;
  const Mh = class Mh {
  };
  Mh.BENDING_ELEMENT = { type: 3, value: "BENDING_ELEMENT" }, Mh.MEMBRANE_ELEMENT = { type: 3, value: "MEMBRANE_ELEMENT" }, Mh.SHELL = { type: 3, value: "SHELL" }, Mh.USERDEFINED = { type: 3, value: "USERDEFINED" }, Mh.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let j3 = Mh;
  e.IfcStructuralSurfaceMemberTypeEnum = j3;
  const rp = class rp {
  };
  rp.PURCHASE = { type: 3, value: "PURCHASE" }, rp.WORK = { type: 3, value: "WORK" }, rp.USERDEFINED = { type: 3, value: "USERDEFINED" }, rp.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let $g = rp;
  e.IfcSubContractResourceTypeEnum = $g;
  const Wd = class Wd {
  };
  Wd.MARK = { type: 3, value: "MARK" }, Wd.TAG = { type: 3, value: "TAG" }, Wd.TREATMENT = { type: 3, value: "TREATMENT" }, Wd.USERDEFINED = { type: 3, value: "USERDEFINED" }, Wd.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let pE = Wd;
  e.IfcSurfaceFeatureTypeEnum = pE;
  const CT = class CT {
  };
  CT.POSITIVE = { type: 3, value: "POSITIVE" }, CT.NEGATIVE = { type: 3, value: "NEGATIVE" }, CT.BOTH = { type: 3, value: "BOTH" };
  let mE = CT;
  e.IfcSurfaceSide = mE;
  const Kc = class Kc {
  };
  Kc.CONTACTOR = { type: 3, value: "CONTACTOR" }, Kc.DIMMERSWITCH = { type: 3, value: "DIMMERSWITCH" }, Kc.EMERGENCYSTOP = { type: 3, value: "EMERGENCYSTOP" }, Kc.KEYPAD = { type: 3, value: "KEYPAD" }, Kc.MOMENTARYSWITCH = { type: 3, value: "MOMENTARYSWITCH" }, Kc.SELECTORSWITCH = { type: 3, value: "SELECTORSWITCH" }, Kc.STARTER = { type: 3, value: "STARTER" }, Kc.SWITCHDISCONNECTOR = { type: 3, value: "SWITCHDISCONNECTOR" }, Kc.TOGGLESWITCH = { type: 3, value: "TOGGLESWITCH" }, Kc.USERDEFINED = { type: 3, value: "USERDEFINED" }, Kc.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Kg = Kc;
  e.IfcSwitchingDeviceTypeEnum = Kg;
  const KE = class KE {
  };
  KE.PANEL = { type: 3, value: "PANEL" }, KE.WORKSURFACE = { type: 3, value: "WORKSURFACE" }, KE.USERDEFINED = { type: 3, value: "USERDEFINED" }, KE.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let W5 = KE;
  e.IfcSystemFurnitureElementTypeEnum = W5;
  const Am = class Am {
  };
  Am.BASIN = { type: 3, value: "BASIN" }, Am.BREAKPRESSURE = { type: 3, value: "BREAKPRESSURE" }, Am.EXPANSION = { type: 3, value: "EXPANSION" }, Am.FEEDANDEXPANSION = { type: 3, value: "FEEDANDEXPANSION" }, Am.PRESSUREVESSEL = { type: 3, value: "PRESSUREVESSEL" }, Am.STORAGE = { type: 3, value: "STORAGE" }, Am.VESSEL = { type: 3, value: "VESSEL" }, Am.USERDEFINED = { type: 3, value: "USERDEFINED" }, Am.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Th = Am;
  e.IfcTankTypeEnum = Th;
  const lp = class lp {
  };
  lp.ELAPSEDTIME = { type: 3, value: "ELAPSEDTIME" }, lp.WORKTIME = { type: 3, value: "WORKTIME" }, lp.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let yE = lp;
  e.IfcTaskDurationEnum = yE;
  const Ql = class Ql {
  };
  Ql.ATTENDANCE = { type: 3, value: "ATTENDANCE" }, Ql.CONSTRUCTION = { type: 3, value: "CONSTRUCTION" }, Ql.DEMOLITION = { type: 3, value: "DEMOLITION" }, Ql.DISMANTLE = { type: 3, value: "DISMANTLE" }, Ql.DISPOSAL = { type: 3, value: "DISPOSAL" }, Ql.INSTALLATION = { type: 3, value: "INSTALLATION" }, Ql.LOGISTIC = { type: 3, value: "LOGISTIC" }, Ql.MAINTENANCE = { type: 3, value: "MAINTENANCE" }, Ql.MOVE = { type: 3, value: "MOVE" }, Ql.OPERATION = { type: 3, value: "OPERATION" }, Ql.REMOVAL = { type: 3, value: "REMOVAL" }, Ql.RENOVATION = { type: 3, value: "RENOVATION" }, Ql.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ql.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let EE = Ql;
  e.IfcTaskTypeEnum = EE;
  const lr = class lr {
  };
  lr.COUPLER = { type: 3, value: "COUPLER" }, lr.FIXED_END = { type: 3, value: "FIXED_END" }, lr.TENSIONING_END = { type: 3, value: "TENSIONING_END" }, lr.USERDEFINED = { type: 3, value: "USERDEFINED" }, lr.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let P4 = lr;
  e.IfcTendonAnchorTypeEnum = P4;
  const Gw = class Gw {
  };
  Gw.BAR = { type: 3, value: "BAR" }, Gw.COATED = { type: 3, value: "COATED" }, Gw.STRAND = { type: 3, value: "STRAND" }, Gw.WIRE = { type: 3, value: "WIRE" }, Gw.USERDEFINED = { type: 3, value: "USERDEFINED" }, Gw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let M4 = Gw;
  e.IfcTendonTypeEnum = M4;
  const Jl = class Jl {
  };
  Jl.LEFT = { type: 3, value: "LEFT" }, Jl.RIGHT = { type: 3, value: "RIGHT" }, Jl.UP = { type: 3, value: "UP" }, Jl.DOWN = { type: 3, value: "DOWN" };
  let U4 = Jl;
  e.IfcTextPath = U4;
  const Zc = class Zc {
  };
  Zc.CONTINUOUS = { type: 3, value: "CONTINUOUS" }, Zc.DISCRETE = { type: 3, value: "DISCRETE" }, Zc.DISCRETEBINARY = { type: 3, value: "DISCRETEBINARY" }, Zc.PIECEWISEBINARY = { type: 3, value: "PIECEWISEBINARY" }, Zc.PIECEWISECONSTANT = { type: 3, value: "PIECEWISECONSTANT" }, Zc.PIECEWISECONTINUOUS = { type: 3, value: "PIECEWISECONTINUOUS" }, Zc.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Zg = Zc;
  e.IfcTimeSeriesDataTypeEnum = Zg;
  const Sm = class Sm {
  };
  Sm.CURRENT = { type: 3, value: "CURRENT" }, Sm.FREQUENCY = { type: 3, value: "FREQUENCY" }, Sm.INVERTER = { type: 3, value: "INVERTER" }, Sm.RECTIFIER = { type: 3, value: "RECTIFIER" }, Sm.VOLTAGE = { type: 3, value: "VOLTAGE" }, Sm.USERDEFINED = { type: 3, value: "USERDEFINED" }, Sm.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Qg = Sm;
  e.IfcTransformerTypeEnum = Qg;
  const ZE = class ZE {
  };
  ZE.DISCONTINUOUS = { type: 3, value: "DISCONTINUOUS" }, ZE.CONTINUOUS = { type: 3, value: "CONTINUOUS" }, ZE.CONTSAMEGRADIENT = { type: 3, value: "CONTSAMEGRADIENT" }, ZE.CONTSAMEGRADIENTSAMECURVATURE = { type: 3, value: "CONTSAMEGRADIENTSAMECURVATURE" };
  let B4 = ZE;
  e.IfcTransitionCode = B4;
  const Yd = class Yd {
  };
  Yd.ELEVATOR = { type: 3, value: "ELEVATOR" }, Yd.ESCALATOR = { type: 3, value: "ESCALATOR" }, Yd.MOVINGWALKWAY = { type: 3, value: "MOVINGWALKWAY" }, Yd.CRANEWAY = { type: 3, value: "CRANEWAY" }, Yd.LIFTINGGEAR = { type: 3, value: "LIFTINGGEAR" }, Yd.USERDEFINED = { type: 3, value: "USERDEFINED" }, Yd.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let F4 = Yd;
  e.IfcTransportElementTypeEnum = F4;
  const Uh = class Uh {
  };
  Uh.CARTESIAN = { type: 3, value: "CARTESIAN" }, Uh.PARAMETER = { type: 3, value: "PARAMETER" }, Uh.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" };
  let H4 = Uh;
  e.IfcTrimmingPreference = H4;
  const OT = class OT {
  };
  OT.FINNED = { type: 3, value: "FINNED" }, OT.USERDEFINED = { type: 3, value: "USERDEFINED" }, OT.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Jg = OT;
  e.IfcTubeBundleTypeEnum = Jg;
  const co = class co {
  };
  co.ABSORBEDDOSEUNIT = { type: 3, value: "ABSORBEDDOSEUNIT" }, co.AMOUNTOFSUBSTANCEUNIT = { type: 3, value: "AMOUNTOFSUBSTANCEUNIT" }, co.AREAUNIT = { type: 3, value: "AREAUNIT" }, co.DOSEEQUIVALENTUNIT = { type: 3, value: "DOSEEQUIVALENTUNIT" }, co.ELECTRICCAPACITANCEUNIT = { type: 3, value: "ELECTRICCAPACITANCEUNIT" }, co.ELECTRICCHARGEUNIT = { type: 3, value: "ELECTRICCHARGEUNIT" }, co.ELECTRICCONDUCTANCEUNIT = { type: 3, value: "ELECTRICCONDUCTANCEUNIT" }, co.ELECTRICCURRENTUNIT = { type: 3, value: "ELECTRICCURRENTUNIT" }, co.ELECTRICRESISTANCEUNIT = { type: 3, value: "ELECTRICRESISTANCEUNIT" }, co.ELECTRICVOLTAGEUNIT = { type: 3, value: "ELECTRICVOLTAGEUNIT" }, co.ENERGYUNIT = { type: 3, value: "ENERGYUNIT" }, co.FORCEUNIT = { type: 3, value: "FORCEUNIT" }, co.FREQUENCYUNIT = { type: 3, value: "FREQUENCYUNIT" }, co.ILLUMINANCEUNIT = { type: 3, value: "ILLUMINANCEUNIT" }, co.INDUCTANCEUNIT = { type: 3, value: "INDUCTANCEUNIT" }, co.LENGTHUNIT = { type: 3, value: "LENGTHUNIT" }, co.LUMINOUSFLUXUNIT = { type: 3, value: "LUMINOUSFLUXUNIT" }, co.LUMINOUSINTENSITYUNIT = { type: 3, value: "LUMINOUSINTENSITYUNIT" }, co.MAGNETICFLUXDENSITYUNIT = { type: 3, value: "MAGNETICFLUXDENSITYUNIT" }, co.MAGNETICFLUXUNIT = { type: 3, value: "MAGNETICFLUXUNIT" }, co.MASSUNIT = { type: 3, value: "MASSUNIT" }, co.PLANEANGLEUNIT = { type: 3, value: "PLANEANGLEUNIT" }, co.POWERUNIT = { type: 3, value: "POWERUNIT" }, co.PRESSUREUNIT = { type: 3, value: "PRESSUREUNIT" }, co.RADIOACTIVITYUNIT = { type: 3, value: "RADIOACTIVITYUNIT" }, co.SOLIDANGLEUNIT = { type: 3, value: "SOLIDANGLEUNIT" }, co.THERMODYNAMICTEMPERATUREUNIT = { type: 3, value: "THERMODYNAMICTEMPERATUREUNIT" }, co.TIMEUNIT = { type: 3, value: "TIMEUNIT" }, co.VOLUMEUNIT = { type: 3, value: "VOLUMEUNIT" }, co.USERDEFINED = { type: 3, value: "USERDEFINED" };
  let G4 = co;
  e.IfcUnitEnum = G4;
  const Qc = class Qc {
  };
  Qc.ALARMPANEL = { type: 3, value: "ALARMPANEL" }, Qc.CONTROLPANEL = { type: 3, value: "CONTROLPANEL" }, Qc.GASDETECTIONPANEL = { type: 3, value: "GASDETECTIONPANEL" }, Qc.INDICATORPANEL = { type: 3, value: "INDICATORPANEL" }, Qc.MIMICPANEL = { type: 3, value: "MIMICPANEL" }, Qc.HUMIDISTAT = { type: 3, value: "HUMIDISTAT" }, Qc.THERMOSTAT = { type: 3, value: "THERMOSTAT" }, Qc.WEATHERSTATION = { type: 3, value: "WEATHERSTATION" }, Qc.USERDEFINED = { type: 3, value: "USERDEFINED" }, Qc.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let k4 = Qc;
  e.IfcUnitaryControlElementTypeEnum = k4;
  const bm = class bm {
  };
  bm.AIRHANDLER = { type: 3, value: "AIRHANDLER" }, bm.AIRCONDITIONINGUNIT = { type: 3, value: "AIRCONDITIONINGUNIT" }, bm.DEHUMIDIFIER = { type: 3, value: "DEHUMIDIFIER" }, bm.SPLITSYSTEM = { type: 3, value: "SPLITSYSTEM" }, bm.ROOFTOPUNIT = { type: 3, value: "ROOFTOPUNIT" }, bm.USERDEFINED = { type: 3, value: "USERDEFINED" }, bm.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Y5 = bm;
  e.IfcUnitaryEquipmentTypeEnum = Y5;
  const xr = class xr {
  };
  xr.AIRRELEASE = { type: 3, value: "AIRRELEASE" }, xr.ANTIVACUUM = { type: 3, value: "ANTIVACUUM" }, xr.CHANGEOVER = { type: 3, value: "CHANGEOVER" }, xr.CHECK = { type: 3, value: "CHECK" }, xr.COMMISSIONING = { type: 3, value: "COMMISSIONING" }, xr.DIVERTING = { type: 3, value: "DIVERTING" }, xr.DRAWOFFCOCK = { type: 3, value: "DRAWOFFCOCK" }, xr.DOUBLECHECK = { type: 3, value: "DOUBLECHECK" }, xr.DOUBLEREGULATING = { type: 3, value: "DOUBLEREGULATING" }, xr.FAUCET = { type: 3, value: "FAUCET" }, xr.FLUSHING = { type: 3, value: "FLUSHING" }, xr.GASCOCK = { type: 3, value: "GASCOCK" }, xr.GASTAP = { type: 3, value: "GASTAP" }, xr.ISOLATING = { type: 3, value: "ISOLATING" }, xr.MIXING = { type: 3, value: "MIXING" }, xr.PRESSUREREDUCING = { type: 3, value: "PRESSUREREDUCING" }, xr.PRESSURERELIEF = { type: 3, value: "PRESSURERELIEF" }, xr.REGULATING = { type: 3, value: "REGULATING" }, xr.SAFETYCUTOFF = { type: 3, value: "SAFETYCUTOFF" }, xr.STEAMTRAP = { type: 3, value: "STEAMTRAP" }, xr.STOPCOCK = { type: 3, value: "STOPCOCK" }, xr.USERDEFINED = { type: 3, value: "USERDEFINED" }, xr.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let rm = xr;
  e.IfcValveTypeEnum = rm;
  const $R = class $R {
  };
  $R.COMPRESSION = { type: 3, value: "COMPRESSION" }, $R.SPRING = { type: 3, value: "SPRING" }, $R.USERDEFINED = { type: 3, value: "USERDEFINED" }, $R.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let V4 = $R;
  e.IfcVibrationIsolatorTypeEnum = V4;
  const qd = class qd {
  };
  qd.CUTOUT = { type: 3, value: "CUTOUT" }, qd.NOTCH = { type: 3, value: "NOTCH" }, qd.HOLE = { type: 3, value: "HOLE" }, qd.MITER = { type: 3, value: "MITER" }, qd.CHAMFER = { type: 3, value: "CHAMFER" }, qd.EDGE = { type: 3, value: "EDGE" }, qd.USERDEFINED = { type: 3, value: "USERDEFINED" }, qd.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Y = qd;
  e.IfcVoidingFeatureTypeEnum = Y;
  const Ou = class Ou {
  };
  Ou.MOVABLE = { type: 3, value: "MOVABLE" }, Ou.PARAPET = { type: 3, value: "PARAPET" }, Ou.PARTITIONING = { type: 3, value: "PARTITIONING" }, Ou.PLUMBINGWALL = { type: 3, value: "PLUMBINGWALL" }, Ou.SHEAR = { type: 3, value: "SHEAR" }, Ou.SOLIDWALL = { type: 3, value: "SOLIDWALL" }, Ou.STANDARD = { type: 3, value: "STANDARD" }, Ou.POLYGONAL = { type: 3, value: "POLYGONAL" }, Ou.ELEMENTEDWALL = { type: 3, value: "ELEMENTEDWALL" }, Ou.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ou.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let oe = Ou;
  e.IfcWallTypeEnum = oe;
  const Al = class Al {
  };
  Al.FLOORTRAP = { type: 3, value: "FLOORTRAP" }, Al.FLOORWASTE = { type: 3, value: "FLOORWASTE" }, Al.GULLYSUMP = { type: 3, value: "GULLYSUMP" }, Al.GULLYTRAP = { type: 3, value: "GULLYTRAP" }, Al.ROOFDRAIN = { type: 3, value: "ROOFDRAIN" }, Al.WASTEDISPOSALUNIT = { type: 3, value: "WASTEDISPOSALUNIT" }, Al.WASTETRAP = { type: 3, value: "WASTETRAP" }, Al.USERDEFINED = { type: 3, value: "USERDEFINED" }, Al.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let we = Al;
  e.IfcWasteTerminalTypeEnum = we;
  const ed = class ed {
  };
  ed.SIDEHUNGRIGHTHAND = { type: 3, value: "SIDEHUNGRIGHTHAND" }, ed.SIDEHUNGLEFTHAND = { type: 3, value: "SIDEHUNGLEFTHAND" }, ed.TILTANDTURNRIGHTHAND = { type: 3, value: "TILTANDTURNRIGHTHAND" }, ed.TILTANDTURNLEFTHAND = { type: 3, value: "TILTANDTURNLEFTHAND" }, ed.TOPHUNG = { type: 3, value: "TOPHUNG" }, ed.BOTTOMHUNG = { type: 3, value: "BOTTOMHUNG" }, ed.PIVOTHORIZONTAL = { type: 3, value: "PIVOTHORIZONTAL" }, ed.PIVOTVERTICAL = { type: 3, value: "PIVOTVERTICAL" }, ed.SLIDINGHORIZONTAL = { type: 3, value: "SLIDINGHORIZONTAL" }, ed.SLIDINGVERTICAL = { type: 3, value: "SLIDINGVERTICAL" }, ed.REMOVABLECASEMENT = { type: 3, value: "REMOVABLECASEMENT" }, ed.FIXEDCASEMENT = { type: 3, value: "FIXEDCASEMENT" }, ed.OTHEROPERATION = { type: 3, value: "OTHEROPERATION" }, ed.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Pe = ed;
  e.IfcWindowPanelOperationEnum = Pe;
  const kw = class kw {
  };
  kw.LEFT = { type: 3, value: "LEFT" }, kw.MIDDLE = { type: 3, value: "MIDDLE" }, kw.RIGHT = { type: 3, value: "RIGHT" }, kw.BOTTOM = { type: 3, value: "BOTTOM" }, kw.TOP = { type: 3, value: "TOP" }, kw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let et = kw;
  e.IfcWindowPanelPositionEnum = et;
  const ap = class ap {
  };
  ap.ALUMINIUM = { type: 3, value: "ALUMINIUM" }, ap.HIGH_GRADE_STEEL = { type: 3, value: "HIGH_GRADE_STEEL" }, ap.STEEL = { type: 3, value: "STEEL" }, ap.WOOD = { type: 3, value: "WOOD" }, ap.ALUMINIUM_WOOD = { type: 3, value: "ALUMINIUM_WOOD" }, ap.PLASTIC = { type: 3, value: "PLASTIC" }, ap.OTHER_CONSTRUCTION = { type: 3, value: "OTHER_CONSTRUCTION" }, ap.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let wt = ap;
  e.IfcWindowStyleConstructionEnum = wt;
  const gl = class gl {
  };
  gl.SINGLE_PANEL = { type: 3, value: "SINGLE_PANEL" }, gl.DOUBLE_PANEL_VERTICAL = { type: 3, value: "DOUBLE_PANEL_VERTICAL" }, gl.DOUBLE_PANEL_HORIZONTAL = { type: 3, value: "DOUBLE_PANEL_HORIZONTAL" }, gl.TRIPLE_PANEL_VERTICAL = { type: 3, value: "TRIPLE_PANEL_VERTICAL" }, gl.TRIPLE_PANEL_BOTTOM = { type: 3, value: "TRIPLE_PANEL_BOTTOM" }, gl.TRIPLE_PANEL_TOP = { type: 3, value: "TRIPLE_PANEL_TOP" }, gl.TRIPLE_PANEL_LEFT = { type: 3, value: "TRIPLE_PANEL_LEFT" }, gl.TRIPLE_PANEL_RIGHT = { type: 3, value: "TRIPLE_PANEL_RIGHT" }, gl.TRIPLE_PANEL_HORIZONTAL = { type: 3, value: "TRIPLE_PANEL_HORIZONTAL" }, gl.USERDEFINED = { type: 3, value: "USERDEFINED" }, gl.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let St = gl;
  e.IfcWindowStyleOperationEnum = St;
  const wy = class wy {
  };
  wy.WINDOW = { type: 3, value: "WINDOW" }, wy.SKYLIGHT = { type: 3, value: "SKYLIGHT" }, wy.LIGHTDOME = { type: 3, value: "LIGHTDOME" }, wy.USERDEFINED = { type: 3, value: "USERDEFINED" }, wy.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ot = wy;
  e.IfcWindowTypeEnum = Ot;
  const kn = class kn {
  };
  kn.SINGLE_PANEL = { type: 3, value: "SINGLE_PANEL" }, kn.DOUBLE_PANEL_VERTICAL = { type: 3, value: "DOUBLE_PANEL_VERTICAL" }, kn.DOUBLE_PANEL_HORIZONTAL = { type: 3, value: "DOUBLE_PANEL_HORIZONTAL" }, kn.TRIPLE_PANEL_VERTICAL = { type: 3, value: "TRIPLE_PANEL_VERTICAL" }, kn.TRIPLE_PANEL_BOTTOM = { type: 3, value: "TRIPLE_PANEL_BOTTOM" }, kn.TRIPLE_PANEL_TOP = { type: 3, value: "TRIPLE_PANEL_TOP" }, kn.TRIPLE_PANEL_LEFT = { type: 3, value: "TRIPLE_PANEL_LEFT" }, kn.TRIPLE_PANEL_RIGHT = { type: 3, value: "TRIPLE_PANEL_RIGHT" }, kn.TRIPLE_PANEL_HORIZONTAL = { type: 3, value: "TRIPLE_PANEL_HORIZONTAL" }, kn.USERDEFINED = { type: 3, value: "USERDEFINED" }, kn.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let ii = kn;
  e.IfcWindowTypePartitioningEnum = ii;
  const LT = class LT {
  };
  LT.FIRSTSHIFT = { type: 3, value: "FIRSTSHIFT" }, LT.SECONDSHIFT = { type: 3, value: "SECONDSHIFT" }, LT.THIRDSHIFT = { type: 3, value: "THIRDSHIFT" }, LT.USERDEFINED = { type: 3, value: "USERDEFINED" }, LT.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ei = LT;
  e.IfcWorkCalendarTypeEnum = Ei;
  const Pr = class Pr {
  };
  Pr.ACTUAL = { type: 3, value: "ACTUAL" }, Pr.BASELINE = { type: 3, value: "BASELINE" }, Pr.PLANNED = { type: 3, value: "PLANNED" }, Pr.USERDEFINED = { type: 3, value: "USERDEFINED" }, Pr.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Qi = Pr;
  e.IfcWorkPlanTypeEnum = Qi;
  const Xf = class Xf {
  };
  Xf.ACTUAL = { type: 3, value: "ACTUAL" }, Xf.BASELINE = { type: 3, value: "BASELINE" }, Xf.PLANNED = { type: 3, value: "PLANNED" }, Xf.USERDEFINED = { type: 3, value: "USERDEFINED" }, Xf.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let vn = Xf;
  e.IfcWorkScheduleTypeEnum = vn;
  class cn extends qt {
    constructor(w, v, N) {
      super(), this.Role = w, this.UserDefinedRole = v, this.Description = N, this.type = 3630933823;
    }
  }
  e.IfcActorRole = cn;
  class hn extends qt {
    constructor(w, v, N) {
      super(), this.Purpose = w, this.Description = v, this.UserDefinedPurpose = N, this.type = 618182010;
    }
  }
  e.IfcAddress = hn;
  class Zn extends qt {
    constructor(w, v, N, x) {
      super(), this.ApplicationDeveloper = w, this.Version = v, this.ApplicationFullName = N, this.ApplicationIdentifier = x, this.type = 639542469;
    }
  }
  e.IfcApplication = Zn;
  class Js extends qt {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(), this.Name = w, this.Description = v, this.AppliedValue = N, this.UnitBasis = x, this.ApplicableDate = G, this.FixedUntilDate = j, this.Category = K, this.Condition = Q, this.ArithmeticOperator = he, this.Components = Ze, this.type = 411424972;
    }
  }
  e.IfcAppliedValue = Js;
  class wo extends qt {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(), this.Identifier = w, this.Name = v, this.Description = N, this.TimeOfApproval = x, this.Status = G, this.Level = j, this.Qualifier = K, this.RequestingApproval = Q, this.GivingApproval = he, this.type = 130549933;
    }
  }
  e.IfcApproval = wo;
  class To extends qt {
    constructor(w) {
      super(), this.Name = w, this.type = 4037036970;
    }
  }
  e.IfcBoundaryCondition = To;
  class Mi extends To {
    constructor(w, v, N, x, G, j, K) {
      super(w), this.Name = w, this.TranslationalStiffnessByLengthX = v, this.TranslationalStiffnessByLengthY = N, this.TranslationalStiffnessByLengthZ = x, this.RotationalStiffnessByLengthX = G, this.RotationalStiffnessByLengthY = j, this.RotationalStiffnessByLengthZ = K, this.type = 1560379544;
    }
  }
  e.IfcBoundaryEdgeCondition = Mi;
  class Dn extends To {
    constructor(w, v, N, x) {
      super(w), this.Name = w, this.TranslationalStiffnessByAreaX = v, this.TranslationalStiffnessByAreaY = N, this.TranslationalStiffnessByAreaZ = x, this.type = 3367102660;
    }
  }
  e.IfcBoundaryFaceCondition = Dn;
  class nl extends To {
    constructor(w, v, N, x, G, j, K) {
      super(w), this.Name = w, this.TranslationalStiffnessX = v, this.TranslationalStiffnessY = N, this.TranslationalStiffnessZ = x, this.RotationalStiffnessX = G, this.RotationalStiffnessY = j, this.RotationalStiffnessZ = K, this.type = 1387855156;
    }
  }
  e.IfcBoundaryNodeCondition = nl;
  class sr extends nl {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G, j, K), this.Name = w, this.TranslationalStiffnessX = v, this.TranslationalStiffnessY = N, this.TranslationalStiffnessZ = x, this.RotationalStiffnessX = G, this.RotationalStiffnessY = j, this.RotationalStiffnessZ = K, this.WarpingStiffness = Q, this.type = 2069777674;
    }
  }
  e.IfcBoundaryNodeConditionWarping = sr;
  class Yl extends qt {
    constructor() {
      super(), this.type = 2859738748;
    }
  }
  e.IfcConnectionGeometry = Yl;
  class sl extends Yl {
    constructor(w, v) {
      super(), this.PointOnRelatingElement = w, this.PointOnRelatedElement = v, this.type = 2614616156;
    }
  }
  e.IfcConnectionPointGeometry = sl;
  class VA extends Yl {
    constructor(w, v) {
      super(), this.SurfaceOnRelatingElement = w, this.SurfaceOnRelatedElement = v, this.type = 2732653382;
    }
  }
  e.IfcConnectionSurfaceGeometry = VA;
  class h6 extends Yl {
    constructor(w, v) {
      super(), this.VolumeOnRelatingElement = w, this.VolumeOnRelatedElement = v, this.type = 775493141;
    }
  }
  e.IfcConnectionVolumeGeometry = h6;
  class f6 extends qt {
    constructor(w, v, N, x, G, j, K) {
      super(), this.Name = w, this.Description = v, this.ConstraintGrade = N, this.ConstraintSource = x, this.CreatingActor = G, this.CreationTime = j, this.UserDefinedGrade = K, this.type = 1959218052;
    }
  }
  e.IfcConstraint = f6;
  class RL extends qt {
    constructor(w, v) {
      super(), this.SourceCRS = w, this.TargetCRS = v, this.type = 1785450214;
    }
  }
  e.IfcCoordinateOperation = RL;
  class vL extends qt {
    constructor(w, v, N, x) {
      super(), this.Name = w, this.Description = v, this.GeodeticDatum = N, this.VerticalDatum = x, this.type = 1466758467;
    }
  }
  e.IfcCoordinateReferenceSystem = vL;
  class G8 extends Js {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he, Ze), this.Name = w, this.Description = v, this.AppliedValue = N, this.UnitBasis = x, this.ApplicableDate = G, this.FixedUntilDate = j, this.Category = K, this.Condition = Q, this.ArithmeticOperator = he, this.Components = Ze, this.type = 602808272;
    }
  }
  e.IfcCostValue = G8;
  class k8 extends qt {
    constructor(w, v, N) {
      super(), this.Elements = w, this.UnitType = v, this.UserDefinedType = N, this.type = 1765591967;
    }
  }
  e.IfcDerivedUnit = k8;
  class V8 extends qt {
    constructor(w, v) {
      super(), this.Unit = w, this.Exponent = v, this.type = 1045800335;
    }
  }
  e.IfcDerivedUnitElement = V8;
  class z8 extends qt {
    constructor(w, v, N, x, G, j, K) {
      super(), this.LengthExponent = w, this.MassExponent = v, this.TimeExponent = N, this.ElectricCurrentExponent = x, this.ThermodynamicTemperatureExponent = G, this.AmountOfSubstanceExponent = j, this.LuminousIntensityExponent = K, this.type = 2949456006;
    }
  }
  e.IfcDimensionalExponents = z8;
  class z4 extends qt {
    constructor() {
      super(), this.type = 4294318154;
    }
  }
  e.IfcExternalInformation = z4;
  class Rh extends qt {
    constructor(w, v, N) {
      super(), this.Location = w, this.Identification = v, this.Name = N, this.type = 3200245327;
    }
  }
  e.IfcExternalReference = Rh;
  class j8 extends Rh {
    constructor(w, v, N) {
      super(w, v, N), this.Location = w, this.Identification = v, this.Name = N, this.type = 2242383968;
    }
  }
  e.IfcExternallyDefinedHatchStyle = j8;
  class q5 extends Rh {
    constructor(w, v, N) {
      super(w, v, N), this.Location = w, this.Identification = v, this.Name = N, this.type = 1040185647;
    }
  }
  e.IfcExternallyDefinedSurfaceStyle = q5;
  class zA extends Rh {
    constructor(w, v, N) {
      super(w, v, N), this.Location = w, this.Identification = v, this.Name = N, this.type = 3548104201;
    }
  }
  e.IfcExternallyDefinedTextFont = zA;
  class W8 extends qt {
    constructor(w, v, N) {
      super(), this.AxisTag = w, this.AxisCurve = v, this.SameSense = N, this.type = 852622518;
    }
  }
  e.IfcGridAxis = W8;
  class I6 extends qt {
    constructor(w, v) {
      super(), this.TimeStamp = w, this.ListValues = v, this.type = 3020489413;
    }
  }
  e.IfcIrregularTimeSeriesValue = I6;
  class AL extends z4 {
    constructor(w, v, N, x, G, j) {
      super(), this.Name = w, this.Version = v, this.Publisher = N, this.VersionDate = x, this.Location = G, this.Description = j, this.type = 2655187982;
    }
  }
  e.IfcLibraryInformation = AL;
  class Y8 extends Rh {
    constructor(w, v, N, x, G, j) {
      super(w, v, N), this.Location = w, this.Identification = v, this.Name = N, this.Description = x, this.Language = G, this.ReferencedLibrary = j, this.type = 3452421091;
    }
  }
  e.IfcLibraryReference = Y8;
  class j4 extends qt {
    constructor(w, v, N) {
      super(), this.MainPlaneAngle = w, this.SecondaryPlaneAngle = v, this.LuminousIntensity = N, this.type = 4162380809;
    }
  }
  e.IfcLightDistributionData = j4;
  class q8 extends qt {
    constructor(w, v) {
      super(), this.LightDistributionCurve = w, this.DistributionData = v, this.type = 1566485204;
    }
  }
  e.IfcLightIntensityDistribution = q8;
  class p6 extends RL {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v), this.SourceCRS = w, this.TargetCRS = v, this.Eastings = N, this.Northings = x, this.OrthogonalHeight = G, this.XAxisAbscissa = j, this.XAxisOrdinate = K, this.Scale = Q, this.type = 3057273783;
    }
  }
  e.IfcMapConversion = p6;
  class $8 extends qt {
    constructor(w, v) {
      super(), this.MaterialClassifications = w, this.ClassifiedMaterial = v, this.type = 1847130766;
    }
  }
  e.IfcMaterialClassificationRelationship = $8;
  class vh extends qt {
    constructor() {
      super(), this.type = 760658860;
    }
  }
  e.IfcMaterialDefinition = vh;
  class jA extends vh {
    constructor(w, v, N, x, G, j, K) {
      super(), this.Material = w, this.LayerThickness = v, this.IsVentilated = N, this.Name = x, this.Description = G, this.Category = j, this.Priority = K, this.type = 248100487;
    }
  }
  e.IfcMaterialLayer = jA;
  class m6 extends vh {
    constructor(w, v, N) {
      super(), this.MaterialLayers = w, this.LayerSetName = v, this.Description = N, this.type = 3303938423;
    }
  }
  e.IfcMaterialLayerSet = m6;
  class K8 extends jA {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K), this.Material = w, this.LayerThickness = v, this.IsVentilated = N, this.Name = x, this.Description = G, this.Category = j, this.Priority = K, this.OffsetDirection = Q, this.OffsetValues = he, this.type = 1847252529;
    }
  }
  e.IfcMaterialLayerWithOffsets = K8;
  class Z8 extends qt {
    constructor(w) {
      super(), this.Materials = w, this.type = 2199411900;
    }
  }
  e.IfcMaterialList = Z8;
  class SL extends vh {
    constructor(w, v, N, x, G, j) {
      super(), this.Name = w, this.Description = v, this.Material = N, this.Profile = x, this.Priority = G, this.Category = j, this.type = 2235152071;
    }
  }
  e.IfcMaterialProfile = SL;
  class Q8 extends vh {
    constructor(w, v, N, x) {
      super(), this.Name = w, this.Description = v, this.MaterialProfiles = N, this.CompositeProfile = x, this.type = 164193824;
    }
  }
  e.IfcMaterialProfileSet = Q8;
  class pY extends SL {
    constructor(w, v, N, x, G, j, K) {
      super(w, v, N, x, G, j), this.Name = w, this.Description = v, this.Material = N, this.Profile = x, this.Priority = G, this.Category = j, this.OffsetValues = K, this.type = 552965576;
    }
  }
  e.IfcMaterialProfileWithOffsets = pY;
  class y6 extends qt {
    constructor() {
      super(), this.type = 1507914824;
    }
  }
  e.IfcMaterialUsageDefinition = y6;
  class bL extends qt {
    constructor(w, v) {
      super(), this.ValueComponent = w, this.UnitComponent = v, this.type = 2597039031;
    }
  }
  e.IfcMeasureWithUnit = bL;
  class mY extends f6 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi) {
      super(w, v, N, x, G, j, K), this.Name = w, this.Description = v, this.ConstraintGrade = N, this.ConstraintSource = x, this.CreatingActor = G, this.CreationTime = j, this.UserDefinedGrade = K, this.Benchmark = Q, this.ValueSource = he, this.DataValue = Ze, this.ReferencePath = pi, this.type = 3368373690;
    }
  }
  e.IfcMetric = mY;
  class yY extends qt {
    constructor(w) {
      super(), this.Currency = w, this.type = 2706619895;
    }
  }
  e.IfcMonetaryUnit = yY;
  class E6 extends qt {
    constructor(w, v) {
      super(), this.Dimensions = w, this.UnitType = v, this.type = 1918398963;
    }
  }
  e.IfcNamedUnit = E6;
  class J8 extends qt {
    constructor() {
      super(), this.type = 3701648758;
    }
  }
  e.IfcObjectPlacement = J8;
  class NL extends f6 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi) {
      super(w, v, N, x, G, j, K), this.Name = w, this.Description = v, this.ConstraintGrade = N, this.ConstraintSource = x, this.CreatingActor = G, this.CreationTime = j, this.UserDefinedGrade = K, this.BenchmarkValues = Q, this.LogicalAggregator = he, this.ObjectiveQualifier = Ze, this.UserDefinedQualifier = pi, this.type = 2251480897;
    }
  }
  e.IfcObjective = NL;
  class X8 extends qt {
    constructor(w, v, N, x, G) {
      super(), this.Identification = w, this.Name = v, this.Description = N, this.Roles = x, this.Addresses = G, this.type = 4251960020;
    }
  }
  e.IfcOrganization = X8;
  class BH extends qt {
    constructor(w, v, N, x, G, j, K, Q) {
      super(), this.OwningUser = w, this.OwningApplication = v, this.State = N, this.ChangeAction = x, this.LastModifiedDate = G, this.LastModifyingUser = j, this.LastModifyingApplication = K, this.CreationDate = Q, this.type = 1207048766;
    }
  }
  e.IfcOwnerHistory = BH;
  class WA extends qt {
    constructor(w, v, N, x, G, j, K, Q) {
      super(), this.Identification = w, this.FamilyName = v, this.GivenName = N, this.MiddleNames = x, this.PrefixTitles = G, this.SuffixTitles = j, this.Roles = K, this.Addresses = Q, this.type = 2077209135;
    }
  }
  e.IfcPerson = WA;
  class EY extends qt {
    constructor(w, v, N) {
      super(), this.ThePerson = w, this.TheOrganization = v, this.Roles = N, this.type = 101040310;
    }
  }
  e.IfcPersonAndOrganization = EY;
  class $5 extends qt {
    constructor(w, v) {
      super(), this.Name = w, this.Description = v, this.type = 2483315170;
    }
  }
  e.IfcPhysicalQuantity = $5;
  class W3 extends $5 {
    constructor(w, v, N) {
      super(w, v), this.Name = w, this.Description = v, this.Unit = N, this.type = 2226359599;
    }
  }
  e.IfcPhysicalSimpleQuantity = W3;
  class gY extends hn {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N), this.Purpose = w, this.Description = v, this.UserDefinedPurpose = N, this.InternalLocation = x, this.AddressLines = G, this.PostalBox = j, this.Town = K, this.Region = Q, this.PostalCode = he, this.Country = Ze, this.type = 3355820592;
    }
  }
  e.IfcPostalAddress = gY;
  class xd extends qt {
    constructor() {
      super(), this.type = 677532197;
    }
  }
  e.IfcPresentationItem = xd;
  class DL extends qt {
    constructor(w, v, N, x) {
      super(), this.Name = w, this.Description = v, this.AssignedItems = N, this.Identifier = x, this.type = 2022622350;
    }
  }
  e.IfcPresentationLayerAssignment = DL;
  class FH extends DL {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x), this.Name = w, this.Description = v, this.AssignedItems = N, this.Identifier = x, this.LayerOn = G, this.LayerFrozen = j, this.LayerBlocked = K, this.LayerStyles = Q, this.type = 1304840413;
    }
  }
  e.IfcPresentationLayerWithStyle = FH;
  class W4 extends qt {
    constructor(w) {
      super(), this.Name = w, this.type = 3119450353;
    }
  }
  e.IfcPresentationStyle = W4;
  class wY extends qt {
    constructor(w) {
      super(), this.Styles = w, this.type = 2417041796;
    }
  }
  e.IfcPresentationStyleAssignment = wY;
  class Xg extends qt {
    constructor(w, v, N) {
      super(), this.Name = w, this.Description = v, this.Representations = N, this.type = 2095639259;
    }
  }
  e.IfcProductRepresentation = Xg;
  class Y4 extends qt {
    constructor(w, v) {
      super(), this.ProfileType = w, this.ProfileName = v, this.type = 3958567839;
    }
  }
  e.IfcProfileDef = Y4;
  class HH extends vL {
    constructor(w, v, N, x, G, j, K) {
      super(w, v, N, x), this.Name = w, this.Description = v, this.GeodeticDatum = N, this.VerticalDatum = x, this.MapProjection = G, this.MapZone = j, this.MapUnit = K, this.type = 3843373140;
    }
  }
  e.IfcProjectedCRS = HH;
  class GI extends qt {
    constructor() {
      super(), this.type = 986844984;
    }
  }
  e.IfcPropertyAbstraction = GI;
  class K5 extends GI {
    constructor(w, v, N) {
      super(), this.Name = w, this.EnumerationValues = v, this.Unit = N, this.type = 3710013099;
    }
  }
  e.IfcPropertyEnumeration = K5;
  class GH extends W3 {
    constructor(w, v, N, x, G) {
      super(w, v, N), this.Name = w, this.Description = v, this.Unit = N, this.AreaValue = x, this.Formula = G, this.type = 2044713172;
    }
  }
  e.IfcQuantityArea = GH;
  class kH extends W3 {
    constructor(w, v, N, x, G) {
      super(w, v, N), this.Name = w, this.Description = v, this.Unit = N, this.CountValue = x, this.Formula = G, this.type = 2093928680;
    }
  }
  e.IfcQuantityCount = kH;
  class TY extends W3 {
    constructor(w, v, N, x, G) {
      super(w, v, N), this.Name = w, this.Description = v, this.Unit = N, this.LengthValue = x, this.Formula = G, this.type = 931644368;
    }
  }
  e.IfcQuantityLength = TY;
  class RY extends W3 {
    constructor(w, v, N, x, G) {
      super(w, v, N), this.Name = w, this.Description = v, this.Unit = N, this.TimeValue = x, this.Formula = G, this.type = 3252649465;
    }
  }
  e.IfcQuantityTime = RY;
  class vY extends W3 {
    constructor(w, v, N, x, G) {
      super(w, v, N), this.Name = w, this.Description = v, this.Unit = N, this.VolumeValue = x, this.Formula = G, this.type = 2405470396;
    }
  }
  e.IfcQuantityVolume = vY;
  class AY extends W3 {
    constructor(w, v, N, x, G) {
      super(w, v, N), this.Name = w, this.Description = v, this.Unit = N, this.WeightValue = x, this.Formula = G, this.type = 825690147;
    }
  }
  e.IfcQuantityWeight = AY;
  class VH extends qt {
    constructor(w, v, N, x, G, j, K, Q) {
      super(), this.RecurrenceType = w, this.DayComponent = v, this.WeekdayComponent = N, this.MonthComponent = x, this.Position = G, this.Interval = j, this.Occurrences = K, this.TimePeriods = Q, this.type = 3915482550;
    }
  }
  e.IfcRecurrencePattern = VH;
  class SY extends qt {
    constructor(w, v, N, x, G) {
      super(), this.TypeIdentifier = w, this.AttributeIdentifier = v, this.InstanceName = N, this.ListPositions = x, this.InnerReference = G, this.type = 2433181523;
    }
  }
  e.IfcReference = SY;
  class YA extends qt {
    constructor(w, v, N, x) {
      super(), this.ContextOfItems = w, this.RepresentationIdentifier = v, this.RepresentationType = N, this.Items = x, this.type = 1076942058;
    }
  }
  e.IfcRepresentation = YA;
  class zH extends qt {
    constructor(w, v) {
      super(), this.ContextIdentifier = w, this.ContextType = v, this.type = 3377609919;
    }
  }
  e.IfcRepresentationContext = zH;
  class g6 extends qt {
    constructor() {
      super(), this.type = 3008791417;
    }
  }
  e.IfcRepresentationItem = g6;
  class q4 extends qt {
    constructor(w, v) {
      super(), this.MappingOrigin = w, this.MappedRepresentation = v, this.type = 1660063152;
    }
  }
  e.IfcRepresentationMap = q4;
  class Y3 extends qt {
    constructor(w, v) {
      super(), this.Name = w, this.Description = v, this.type = 2439245199;
    }
  }
  e.IfcResourceLevelRelationship = Y3;
  class CL extends qt {
    constructor(w, v, N, x) {
      super(), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.type = 2341007311;
    }
  }
  e.IfcRoot = CL;
  class bY extends E6 {
    constructor(w, v, N) {
      super(new u(0), w), this.UnitType = w, this.Prefix = v, this.Name = N, this.type = 448429030;
    }
  }
  e.IfcSIUnit = bY;
  class qA extends qt {
    constructor(w, v, N) {
      super(), this.Name = w, this.DataOrigin = v, this.UserDefinedDataOrigin = N, this.type = 1054537805;
    }
  }
  e.IfcSchedulingTime = qA;
  class jH extends qt {
    constructor(w, v, N, x, G) {
      super(), this.ShapeRepresentations = w, this.Name = v, this.Description = N, this.ProductDefinitional = x, this.PartOfProductDefinitionShape = G, this.type = 867548509;
    }
  }
  e.IfcShapeAspect = jH;
  class eM extends YA {
    constructor(w, v, N, x) {
      super(w, v, N, x), this.ContextOfItems = w, this.RepresentationIdentifier = v, this.RepresentationType = N, this.Items = x, this.type = 3982875396;
    }
  }
  e.IfcShapeModel = eM;
  class tM extends eM {
    constructor(w, v, N, x) {
      super(w, v, N, x), this.ContextOfItems = w, this.RepresentationIdentifier = v, this.RepresentationType = N, this.Items = x, this.type = 4240577450;
    }
  }
  e.IfcShapeRepresentation = tM;
  class w6 extends qt {
    constructor(w) {
      super(), this.Name = w, this.type = 2273995522;
    }
  }
  e.IfcStructuralConnectionCondition = w6;
  class iM extends qt {
    constructor(w) {
      super(), this.Name = w, this.type = 2162789131;
    }
  }
  e.IfcStructuralLoad = iM;
  class NY extends iM {
    constructor(w, v, N) {
      super(w), this.Name = w, this.Values = v, this.Locations = N, this.type = 3478079324;
    }
  }
  e.IfcStructuralLoadConfiguration = NY;
  class nM extends iM {
    constructor(w) {
      super(w), this.Name = w, this.type = 609421318;
    }
  }
  e.IfcStructuralLoadOrResult = nM;
  class q3 extends nM {
    constructor(w) {
      super(w), this.Name = w, this.type = 2525727697;
    }
  }
  e.IfcStructuralLoadStatic = q3;
  class OL extends q3 {
    constructor(w, v, N, x) {
      super(w), this.Name = w, this.DeltaTConstant = v, this.DeltaTY = N, this.DeltaTZ = x, this.type = 3408363356;
    }
  }
  e.IfcStructuralLoadTemperature = OL;
  class WH extends YA {
    constructor(w, v, N, x) {
      super(w, v, N, x), this.ContextOfItems = w, this.RepresentationIdentifier = v, this.RepresentationType = N, this.Items = x, this.type = 2830218821;
    }
  }
  e.IfcStyleModel = WH;
  class $4 extends g6 {
    constructor(w, v, N) {
      super(), this.Item = w, this.Styles = v, this.Name = N, this.type = 3958052878;
    }
  }
  e.IfcStyledItem = $4;
  class DY extends WH {
    constructor(w, v, N, x) {
      super(w, v, N, x), this.ContextOfItems = w, this.RepresentationIdentifier = v, this.RepresentationType = N, this.Items = x, this.type = 3049322572;
    }
  }
  e.IfcStyledRepresentation = DY;
  class CY extends nM {
    constructor(w, v, N, x) {
      super(w), this.Name = w, this.SurfaceReinforcement1 = v, this.SurfaceReinforcement2 = N, this.ShearReinforcement = x, this.type = 2934153892;
    }
  }
  e.IfcSurfaceReinforcementArea = CY;
  class YH extends W4 {
    constructor(w, v, N) {
      super(w), this.Name = w, this.Side = v, this.Styles = N, this.type = 1300840506;
    }
  }
  e.IfcSurfaceStyle = YH;
  class sM extends xd {
    constructor(w, v, N, x) {
      super(), this.DiffuseTransmissionColour = w, this.DiffuseReflectionColour = v, this.TransmissionColour = N, this.ReflectanceColour = x, this.type = 3303107099;
    }
  }
  e.IfcSurfaceStyleLighting = sM;
  class K4 extends xd {
    constructor(w, v) {
      super(), this.RefractionIndex = w, this.DispersionFactor = v, this.type = 1607154358;
    }
  }
  e.IfcSurfaceStyleRefraction = K4;
  class qH extends xd {
    constructor(w, v) {
      super(), this.SurfaceColour = w, this.Transparency = v, this.type = 846575682;
    }
  }
  e.IfcSurfaceStyleShading = qH;
  class Pd extends xd {
    constructor(w) {
      super(), this.Textures = w, this.type = 1351298697;
    }
  }
  e.IfcSurfaceStyleWithTextures = Pd;
  class gE extends xd {
    constructor(w, v, N, x, G) {
      super(), this.RepeatS = w, this.RepeatT = v, this.Mode = N, this.TextureTransform = x, this.Parameter = G, this.type = 626085974;
    }
  }
  e.IfcSurfaceTexture = gE;
  class OY extends qt {
    constructor(w, v, N) {
      super(), this.Name = w, this.Rows = v, this.Columns = N, this.type = 985171141;
    }
  }
  e.IfcTable = OY;
  class $A extends qt {
    constructor(w, v, N, x, G) {
      super(), this.Identifier = w, this.Name = v, this.Description = N, this.Unit = x, this.ReferencePath = G, this.type = 2043862942;
    }
  }
  e.IfcTableColumn = $A;
  class oM extends qt {
    constructor(w, v) {
      super(), this.RowCells = w, this.IsHeading = v, this.type = 531007025;
    }
  }
  e.IfcTableRow = oM;
  class ew extends qA {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki, Vn, ks, gr, Ro, ma, Lu, _T, QE) {
      super(w, v, N), this.Name = w, this.DataOrigin = v, this.UserDefinedDataOrigin = N, this.DurationType = x, this.ScheduleDuration = G, this.ScheduleStart = j, this.ScheduleFinish = K, this.EarlyStart = Q, this.EarlyFinish = he, this.LateStart = Ze, this.LateFinish = pi, this.FreeFloat = Ki, this.TotalFloat = Vn, this.IsCritical = ks, this.StatusTime = gr, this.ActualDuration = Ro, this.ActualStart = ma, this.ActualFinish = Lu, this.RemainingTime = _T, this.Completion = QE, this.type = 1549132990;
    }
  }
  e.IfcTaskTime = ew;
  class $H extends ew {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki, Vn, ks, gr, Ro, ma, Lu, _T, QE, KR) {
      super(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki, Vn, ks, gr, Ro, ma, Lu, _T, QE), this.Name = w, this.DataOrigin = v, this.UserDefinedDataOrigin = N, this.DurationType = x, this.ScheduleDuration = G, this.ScheduleStart = j, this.ScheduleFinish = K, this.EarlyStart = Q, this.EarlyFinish = he, this.LateStart = Ze, this.LateFinish = pi, this.FreeFloat = Ki, this.TotalFloat = Vn, this.IsCritical = ks, this.StatusTime = gr, this.ActualDuration = Ro, this.ActualStart = ma, this.ActualFinish = Lu, this.RemainingTime = _T, this.Completion = QE, this.Recurrence = KR, this.type = 2771591690;
    }
  }
  e.IfcTaskTimeRecurring = $H;
  class T6 extends hn {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N), this.Purpose = w, this.Description = v, this.UserDefinedPurpose = N, this.TelephoneNumbers = x, this.FacsimileNumbers = G, this.PagerNumber = j, this.ElectronicMailAddresses = K, this.WWWHomePageURL = Q, this.MessagingIDs = he, this.type = 912023232;
    }
  }
  e.IfcTelecomAddress = T6;
  class LY extends W4 {
    constructor(w, v, N, x, G) {
      super(w), this.Name = w, this.TextCharacterAppearance = v, this.TextStyle = N, this.TextFontStyle = x, this.ModelOrDraughting = G, this.type = 1447204868;
    }
  }
  e.IfcTextStyle = LY;
  class _Y extends xd {
    constructor(w, v) {
      super(), this.Colour = w, this.BackgroundColour = v, this.type = 2636378356;
    }
  }
  e.IfcTextStyleForDefinedFont = _Y;
  class xY extends xd {
    constructor(w, v, N, x, G, j, K) {
      super(), this.TextIndent = w, this.TextAlign = v, this.TextDecoration = N, this.LetterSpacing = x, this.WordSpacing = G, this.TextTransform = j, this.LineHeight = K, this.type = 1640371178;
    }
  }
  e.IfcTextStyleTextModel = xY;
  class LL extends xd {
    constructor(w) {
      super(), this.Maps = w, this.type = 280115917;
    }
  }
  e.IfcTextureCoordinate = LL;
  class PY extends LL {
    constructor(w, v, N) {
      super(w), this.Maps = w, this.Mode = v, this.Parameter = N, this.type = 1742049831;
    }
  }
  e.IfcTextureCoordinateGenerator = PY;
  class MY extends LL {
    constructor(w, v, N) {
      super(w), this.Maps = w, this.Vertices = v, this.MappedTo = N, this.type = 2552916305;
    }
  }
  e.IfcTextureMap = MY;
  class rM extends xd {
    constructor(w) {
      super(), this.Coordinates = w, this.type = 1210645708;
    }
  }
  e.IfcTextureVertex = rM;
  class UY extends xd {
    constructor(w) {
      super(), this.TexCoordsList = w, this.type = 3611470254;
    }
  }
  e.IfcTextureVertexList = UY;
  class BY extends qt {
    constructor(w, v) {
      super(), this.StartTime = w, this.EndTime = v, this.type = 1199560280;
    }
  }
  e.IfcTimePeriod = BY;
  class lM extends qt {
    constructor(w, v, N, x, G, j, K, Q) {
      super(), this.Name = w, this.Description = v, this.StartTime = N, this.EndTime = x, this.TimeSeriesDataType = G, this.DataOrigin = j, this.UserDefinedDataOrigin = K, this.Unit = Q, this.type = 3101149627;
    }
  }
  e.IfcTimeSeries = lM;
  class aM extends qt {
    constructor(w) {
      super(), this.ListValues = w, this.type = 581633288;
    }
  }
  e.IfcTimeSeriesValue = aM;
  class tw extends g6 {
    constructor() {
      super(), this.type = 1377556343;
    }
  }
  e.IfcTopologicalRepresentationItem = tw;
  class R6 extends eM {
    constructor(w, v, N, x) {
      super(w, v, N, x), this.ContextOfItems = w, this.RepresentationIdentifier = v, this.RepresentationType = N, this.Items = x, this.type = 1735638870;
    }
  }
  e.IfcTopologyRepresentation = R6;
  class FY extends qt {
    constructor(w) {
      super(), this.Units = w, this.type = 180925521;
    }
  }
  e.IfcUnitAssignment = FY;
  class $3 extends tw {
    constructor() {
      super(), this.type = 2799835756;
    }
  }
  e.IfcVertex = $3;
  class _L extends $3 {
    constructor(w) {
      super(), this.VertexGeometry = w, this.type = 1907098498;
    }
  }
  e.IfcVertexPoint = _L;
  class HY extends qt {
    constructor(w, v) {
      super(), this.IntersectingAxes = w, this.OffsetDistances = v, this.type = 891718957;
    }
  }
  e.IfcVirtualGridIntersection = HY;
  class iw extends qA {
    constructor(w, v, N, x, G, j) {
      super(w, v, N), this.Name = w, this.DataOrigin = v, this.UserDefinedDataOrigin = N, this.RecurrencePattern = x, this.Start = G, this.Finish = j, this.type = 1236880293;
    }
  }
  e.IfcWorkTime = iw;
  class GY extends Y3 {
    constructor(w, v, N, x) {
      super(w, v), this.Name = w, this.Description = v, this.RelatingApproval = N, this.RelatedApprovals = x, this.type = 3869604511;
    }
  }
  e.IfcApprovalRelationship = GY;
  class xL extends Y4 {
    constructor(w, v, N) {
      super(w, v), this.ProfileType = w, this.ProfileName = v, this.OuterCurve = N, this.type = 3798115385;
    }
  }
  e.IfcArbitraryClosedProfileDef = xL;
  class uM extends Y4 {
    constructor(w, v, N) {
      super(w, v), this.ProfileType = w, this.ProfileName = v, this.Curve = N, this.type = 1310608509;
    }
  }
  e.IfcArbitraryOpenProfileDef = uM;
  class PL extends xL {
    constructor(w, v, N, x) {
      super(w, v, N), this.ProfileType = w, this.ProfileName = v, this.OuterCurve = N, this.InnerCurves = x, this.type = 2705031697;
    }
  }
  e.IfcArbitraryProfileDefWithVoids = PL;
  class dM extends gE {
    constructor(w, v, N, x, G, j, K) {
      super(w, v, N, x, G), this.RepeatS = w, this.RepeatT = v, this.Mode = N, this.TextureTransform = x, this.Parameter = G, this.RasterFormat = j, this.RasterCode = K, this.type = 616511568;
    }
  }
  e.IfcBlobTexture = dM;
  class kY extends uM {
    constructor(w, v, N, x) {
      super(w, v, N), this.ProfileType = w, this.ProfileName = v, this.Curve = N, this.Thickness = x, this.type = 3150382593;
    }
  }
  e.IfcCenterLineProfileDef = kY;
  class cM extends z4 {
    constructor(w, v, N, x, G, j, K) {
      super(), this.Source = w, this.Edition = v, this.EditionDate = N, this.Name = x, this.Description = G, this.Location = j, this.ReferenceTokens = K, this.type = 747523909;
    }
  }
  e.IfcClassification = cM;
  class KA extends Rh {
    constructor(w, v, N, x, G, j) {
      super(w, v, N), this.Location = w, this.Identification = v, this.Name = N, this.ReferencedSource = x, this.Description = G, this.Sort = j, this.type = 647927063;
    }
  }
  e.IfcClassificationReference = KA;
  class VY extends xd {
    constructor(w) {
      super(), this.ColourList = w, this.type = 3285139300;
    }
  }
  e.IfcColourRgbList = VY;
  class hM extends xd {
    constructor(w) {
      super(), this.Name = w, this.type = 3264961684;
    }
  }
  e.IfcColourSpecification = hM;
  class KH extends Y4 {
    constructor(w, v, N, x) {
      super(w, v), this.ProfileType = w, this.ProfileName = v, this.Profiles = N, this.Label = x, this.type = 1485152156;
    }
  }
  e.IfcCompositeProfileDef = KH;
  class ML extends tw {
    constructor(w) {
      super(), this.CfsFaces = w, this.type = 370225590;
    }
  }
  e.IfcConnectedFaceSet = ML;
  class br extends Yl {
    constructor(w, v) {
      super(), this.CurveOnRelatingElement = w, this.CurveOnRelatedElement = v, this.type = 1981873012;
    }
  }
  e.IfcConnectionCurveGeometry = br;
  class zY extends sl {
    constructor(w, v, N, x, G) {
      super(w, v), this.PointOnRelatingElement = w, this.PointOnRelatedElement = v, this.EccentricityInX = N, this.EccentricityInY = x, this.EccentricityInZ = G, this.type = 45288368;
    }
  }
  e.IfcConnectionPointEccentricity = zY;
  class ZH extends E6 {
    constructor(w, v, N) {
      super(w, v), this.Dimensions = w, this.UnitType = v, this.Name = N, this.type = 3050246964;
    }
  }
  e.IfcContextDependentUnit = ZH;
  class QH extends E6 {
    constructor(w, v, N, x) {
      super(w, v), this.Dimensions = w, this.UnitType = v, this.Name = N, this.ConversionFactor = x, this.type = 2889183280;
    }
  }
  e.IfcConversionBasedUnit = QH;
  class UL extends QH {
    constructor(w, v, N, x, G) {
      super(w, v, N, x), this.Dimensions = w, this.UnitType = v, this.Name = N, this.ConversionFactor = x, this.ConversionOffset = G, this.type = 2713554722;
    }
  }
  e.IfcConversionBasedUnitWithOffset = UL;
  class jY extends Y3 {
    constructor(w, v, N, x, G, j, K) {
      super(w, v), this.Name = w, this.Description = v, this.RelatingMonetaryUnit = N, this.RelatedMonetaryUnit = x, this.ExchangeRate = G, this.RateDateTime = j, this.RateSource = K, this.type = 539742890;
    }
  }
  e.IfcCurrencyRelationship = jY;
  class BL extends W4 {
    constructor(w, v, N, x, G) {
      super(w), this.Name = w, this.CurveFont = v, this.CurveWidth = N, this.CurveColour = x, this.ModelOrDraughting = G, this.type = 3800577675;
    }
  }
  e.IfcCurveStyle = BL;
  class WY extends xd {
    constructor(w, v) {
      super(), this.Name = w, this.PatternList = v, this.type = 1105321065;
    }
  }
  e.IfcCurveStyleFont = WY;
  class v6 extends xd {
    constructor(w, v, N) {
      super(), this.Name = w, this.CurveFont = v, this.CurveFontScaling = N, this.type = 2367409068;
    }
  }
  e.IfcCurveStyleFontAndScaling = v6;
  class YY extends xd {
    constructor(w, v) {
      super(), this.VisibleSegmentLength = w, this.InvisibleSegmentLength = v, this.type = 3510044353;
    }
  }
  e.IfcCurveStyleFontPattern = YY;
  class fM extends Y4 {
    constructor(w, v, N, x, G) {
      super(w, v), this.ProfileType = w, this.ProfileName = v, this.ParentProfile = N, this.Operator = x, this.Label = G, this.type = 3632507154;
    }
  }
  e.IfcDerivedProfileDef = fM;
  class qY extends z4 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki, Vn, ks, gr, Ro, ma) {
      super(), this.Identification = w, this.Name = v, this.Description = N, this.Location = x, this.Purpose = G, this.IntendedUse = j, this.Scope = K, this.Revision = Q, this.DocumentOwner = he, this.Editors = Ze, this.CreationTime = pi, this.LastRevisionTime = Ki, this.ElectronicFormat = Vn, this.ValidFrom = ks, this.ValidUntil = gr, this.Confidentiality = Ro, this.Status = ma, this.type = 1154170062;
    }
  }
  e.IfcDocumentInformation = qY;
  class JH extends Y3 {
    constructor(w, v, N, x, G) {
      super(w, v), this.Name = w, this.Description = v, this.RelatingDocument = N, this.RelatedDocuments = x, this.RelationshipType = G, this.type = 770865208;
    }
  }
  e.IfcDocumentInformationRelationship = JH;
  class $Y extends Rh {
    constructor(w, v, N, x, G) {
      super(w, v, N), this.Location = w, this.Identification = v, this.Name = N, this.Description = x, this.ReferencedDocument = G, this.type = 3732053477;
    }
  }
  e.IfcDocumentReference = $Y;
  class FL extends tw {
    constructor(w, v) {
      super(), this.EdgeStart = w, this.EdgeEnd = v, this.type = 3900360178;
    }
  }
  e.IfcEdge = FL;
  class HL extends FL {
    constructor(w, v, N, x) {
      super(w, v), this.EdgeStart = w, this.EdgeEnd = v, this.EdgeGeometry = N, this.SameSense = x, this.type = 476780140;
    }
  }
  e.IfcEdgeCurve = HL;
  class GL extends qA {
    constructor(w, v, N, x, G, j, K) {
      super(w, v, N), this.Name = w, this.DataOrigin = v, this.UserDefinedDataOrigin = N, this.ActualDate = x, this.EarlyDate = G, this.LateDate = j, this.ScheduleDate = K, this.type = 211053100;
    }
  }
  e.IfcEventTime = GL;
  class IM extends GI {
    constructor(w, v, N) {
      super(), this.Name = w, this.Description = v, this.Properties = N, this.type = 297599258;
    }
  }
  e.IfcExtendedProperties = IM;
  class XH extends Y3 {
    constructor(w, v, N, x) {
      super(w, v), this.Name = w, this.Description = v, this.RelatingReference = N, this.RelatedResourceObjects = x, this.type = 1437805879;
    }
  }
  e.IfcExternalReferenceRelationship = XH;
  class kL extends tw {
    constructor(w) {
      super(), this.Bounds = w, this.type = 2556980723;
    }
  }
  e.IfcFace = kL;
  class pM extends tw {
    constructor(w, v) {
      super(), this.Bound = w, this.Orientation = v, this.type = 1809719519;
    }
  }
  e.IfcFaceBound = pM;
  class KY extends pM {
    constructor(w, v) {
      super(w, v), this.Bound = w, this.Orientation = v, this.type = 803316827;
    }
  }
  e.IfcFaceOuterBound = KY;
  class eG extends kL {
    constructor(w, v, N) {
      super(w), this.Bounds = w, this.FaceSurface = v, this.SameSense = N, this.type = 3008276851;
    }
  }
  e.IfcFaceSurface = eG;
  class kI extends w6 {
    constructor(w, v, N, x, G, j, K) {
      super(w), this.Name = w, this.TensionFailureX = v, this.TensionFailureY = N, this.TensionFailureZ = x, this.CompressionFailureX = G, this.CompressionFailureY = j, this.CompressionFailureZ = K, this.type = 4219587988;
    }
  }
  e.IfcFailureConnectionCondition = kI;
  class mM extends W4 {
    constructor(w, v, N) {
      super(w), this.Name = w, this.FillStyles = v, this.ModelorDraughting = N, this.type = 738692330;
    }
  }
  e.IfcFillAreaStyle = mM;
  class tG extends zH {
    constructor(w, v, N, x, G, j) {
      super(w, v), this.ContextIdentifier = w, this.ContextType = v, this.CoordinateSpaceDimension = N, this.Precision = x, this.WorldCoordinateSystem = G, this.TrueNorth = j, this.type = 3448662350;
    }
  }
  e.IfcGeometricRepresentationContext = tG;
  class Xo extends g6 {
    constructor() {
      super(), this.type = 2453401579;
    }
  }
  e.IfcGeometricRepresentationItem = Xo;
  class VL extends tG {
    constructor(w, v, N, x, G, j) {
      super(w, v, new W(0), null, new u(0), null), this.ContextIdentifier = w, this.ContextType = v, this.ParentContext = N, this.TargetScale = x, this.TargetView = G, this.UserDefinedTargetView = j, this.type = 4142052618;
    }
  }
  e.IfcGeometricRepresentationSubContext = VL;
  class yM extends Xo {
    constructor(w) {
      super(), this.Elements = w, this.type = 3590301190;
    }
  }
  e.IfcGeometricSet = yM;
  class A6 extends J8 {
    constructor(w, v) {
      super(), this.PlacementLocation = w, this.PlacementRefDirection = v, this.type = 178086475;
    }
  }
  e.IfcGridPlacement = A6;
  class EM extends Xo {
    constructor(w, v) {
      super(), this.BaseSurface = w, this.AgreementFlag = v, this.type = 812098782;
    }
  }
  e.IfcHalfSpaceSolid = EM;
  class ZY extends gE {
    constructor(w, v, N, x, G, j) {
      super(w, v, N, x, G), this.RepeatS = w, this.RepeatT = v, this.Mode = N, this.TextureTransform = x, this.Parameter = G, this.URLReference = j, this.type = 3905492369;
    }
  }
  e.IfcImageTexture = ZY;
  class QY extends xd {
    constructor(w, v, N, x) {
      super(), this.MappedTo = w, this.Opacity = v, this.Colours = N, this.ColourIndex = x, this.type = 3570813810;
    }
  }
  e.IfcIndexedColourMap = QY;
  class iG extends LL {
    constructor(w, v, N) {
      super(w), this.Maps = w, this.MappedTo = v, this.TexCoords = N, this.type = 1437953363;
    }
  }
  e.IfcIndexedTextureMap = iG;
  class nG extends iG {
    constructor(w, v, N, x) {
      super(w, v, N), this.Maps = w, this.MappedTo = v, this.TexCoords = N, this.TexCoordIndex = x, this.type = 2133299955;
    }
  }
  e.IfcIndexedTriangleTextureMap = nG;
  class sG extends lM {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.Name = w, this.Description = v, this.StartTime = N, this.EndTime = x, this.TimeSeriesDataType = G, this.DataOrigin = j, this.UserDefinedDataOrigin = K, this.Unit = Q, this.Values = he, this.type = 3741457305;
    }
  }
  e.IfcIrregularTimeSeries = sG;
  class oG extends qA {
    constructor(w, v, N, x, G) {
      super(w, v, N), this.Name = w, this.DataOrigin = v, this.UserDefinedDataOrigin = N, this.LagValue = x, this.DurationType = G, this.type = 1585845231;
    }
  }
  e.IfcLagTime = oG;
  class ZA extends Xo {
    constructor(w, v, N, x) {
      super(), this.Name = w, this.LightColour = v, this.AmbientIntensity = N, this.Intensity = x, this.type = 1402838566;
    }
  }
  e.IfcLightSource = ZA;
  class JY extends ZA {
    constructor(w, v, N, x) {
      super(w, v, N, x), this.Name = w, this.LightColour = v, this.AmbientIntensity = N, this.Intensity = x, this.type = 125510826;
    }
  }
  e.IfcLightSourceAmbient = JY;
  class XY extends ZA {
    constructor(w, v, N, x, G) {
      super(w, v, N, x), this.Name = w, this.LightColour = v, this.AmbientIntensity = N, this.Intensity = x, this.Orientation = G, this.type = 2604431987;
    }
  }
  e.IfcLightSourceDirectional = XY;
  class rG extends ZA {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x), this.Name = w, this.LightColour = v, this.AmbientIntensity = N, this.Intensity = x, this.Position = G, this.ColourAppearance = j, this.ColourTemperature = K, this.LuminousFlux = Q, this.LightEmissionSource = he, this.LightDistributionDataSource = Ze, this.type = 4266656042;
    }
  }
  e.IfcLightSourceGoniometric = rG;
  class lG extends ZA {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x), this.Name = w, this.LightColour = v, this.AmbientIntensity = N, this.Intensity = x, this.Position = G, this.Radius = j, this.ConstantAttenuation = K, this.DistanceAttenuation = Q, this.QuadricAttenuation = he, this.type = 1520743889;
    }
  }
  e.IfcLightSourcePositional = lG;
  class eq extends lG {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki, Vn) {
      super(w, v, N, x, G, j, K, Q, he), this.Name = w, this.LightColour = v, this.AmbientIntensity = N, this.Intensity = x, this.Position = G, this.Radius = j, this.ConstantAttenuation = K, this.DistanceAttenuation = Q, this.QuadricAttenuation = he, this.Orientation = Ze, this.ConcentrationExponent = pi, this.SpreadAngle = Ki, this.BeamWidthAngle = Vn, this.type = 3422422726;
    }
  }
  e.IfcLightSourceSpot = eq;
  class tq extends J8 {
    constructor(w, v) {
      super(), this.PlacementRelTo = w, this.RelativePlacement = v, this.type = 2624227202;
    }
  }
  e.IfcLocalPlacement = tq;
  class Qu extends tw {
    constructor() {
      super(), this.type = 1008929658;
    }
  }
  e.IfcLoop = Qu;
  class iq extends g6 {
    constructor(w, v) {
      super(), this.MappingSource = w, this.MappingTarget = v, this.type = 2347385850;
    }
  }
  e.IfcMappedItem = iq;
  class gM extends vh {
    constructor(w, v, N) {
      super(), this.Name = w, this.Description = v, this.Category = N, this.type = 1838606355;
    }
  }
  e.IfcMaterial = gM;
  class wM extends vh {
    constructor(w, v, N, x, G) {
      super(), this.Name = w, this.Description = v, this.Material = N, this.Fraction = x, this.Category = G, this.type = 3708119e3;
    }
  }
  e.IfcMaterialConstituent = wM;
  class nq extends vh {
    constructor(w, v, N) {
      super(), this.Name = w, this.Description = v, this.MaterialConstituents = N, this.type = 2852063980;
    }
  }
  e.IfcMaterialConstituentSet = nq;
  class sq extends Xg {
    constructor(w, v, N, x) {
      super(w, v, N), this.Name = w, this.Description = v, this.Representations = N, this.RepresentedMaterial = x, this.type = 2022407955;
    }
  }
  e.IfcMaterialDefinitionRepresentation = sq;
  class Z5 extends y6 {
    constructor(w, v, N, x, G) {
      super(), this.ForLayerSet = w, this.LayerSetDirection = v, this.DirectionSense = N, this.OffsetFromReferenceLine = x, this.ReferenceExtent = G, this.type = 1303795690;
    }
  }
  e.IfcMaterialLayerSetUsage = Z5;
  class aG extends y6 {
    constructor(w, v, N) {
      super(), this.ForProfileSet = w, this.CardinalPoint = v, this.ReferenceExtent = N, this.type = 3079605661;
    }
  }
  e.IfcMaterialProfileSetUsage = aG;
  class oq extends aG {
    constructor(w, v, N, x, G) {
      super(w, v, N), this.ForProfileSet = w, this.CardinalPoint = v, this.ReferenceExtent = N, this.ForProfileEndSet = x, this.CardinalEndPoint = G, this.type = 3404854881;
    }
  }
  e.IfcMaterialProfileSetUsageTapering = oq;
  class rq extends IM {
    constructor(w, v, N, x) {
      super(w, v, N), this.Name = w, this.Description = v, this.Properties = N, this.Material = x, this.type = 3265635763;
    }
  }
  e.IfcMaterialProperties = rq;
  class lq extends Y3 {
    constructor(w, v, N, x, G) {
      super(w, v), this.Name = w, this.Description = v, this.RelatingMaterial = N, this.RelatedMaterials = x, this.Expression = G, this.type = 853536259;
    }
  }
  e.IfcMaterialRelationship = lq;
  class aq extends fM {
    constructor(w, v, N, x) {
      super(w, v, N, new u(0), x), this.ProfileType = w, this.ProfileName = v, this.ParentProfile = N, this.Label = x, this.type = 2998442950;
    }
  }
  e.IfcMirroredProfileDef = aq;
  class Z4 extends CL {
    constructor(w, v, N, x) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.type = 219451334;
    }
  }
  e.IfcObjectDefinition = Z4;
  class uG extends ML {
    constructor(w) {
      super(w), this.CfsFaces = w, this.type = 2665983363;
    }
  }
  e.IfcOpenShell = uG;
  class uq extends Y3 {
    constructor(w, v, N, x) {
      super(w, v), this.Name = w, this.Description = v, this.RelatingOrganization = N, this.RelatedOrganizations = x, this.type = 1411181986;
    }
  }
  e.IfcOrganizationRelationship = uq;
  class dq extends FL {
    constructor(w, v) {
      super(new u(0), new u(0)), this.EdgeElement = w, this.Orientation = v, this.type = 1029017970;
    }
  }
  e.IfcOrientedEdge = dq;
  class lm extends Y4 {
    constructor(w, v, N) {
      super(w, v), this.ProfileType = w, this.ProfileName = v, this.Position = N, this.type = 2529465313;
    }
  }
  e.IfcParameterizedProfileDef = lm;
  class zL extends tw {
    constructor(w) {
      super(), this.EdgeList = w, this.type = 2519244187;
    }
  }
  e.IfcPath = zL;
  class dG extends $5 {
    constructor(w, v, N, x, G, j) {
      super(w, v), this.Name = w, this.Description = v, this.HasQuantities = N, this.Discrimination = x, this.Quality = G, this.Usage = j, this.type = 3021840470;
    }
  }
  e.IfcPhysicalComplexQuantity = dG;
  class cq extends gE {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G), this.RepeatS = w, this.RepeatT = v, this.Mode = N, this.TextureTransform = x, this.Parameter = G, this.Width = j, this.Height = K, this.ColourComponents = Q, this.Pixel = he, this.type = 597895409;
    }
  }
  e.IfcPixelTexture = cq;
  class Q5 extends Xo {
    constructor(w) {
      super(), this.Location = w, this.type = 2004835150;
    }
  }
  e.IfcPlacement = Q5;
  class cG extends Xo {
    constructor(w, v) {
      super(), this.SizeInX = w, this.SizeInY = v, this.type = 1663979128;
    }
  }
  e.IfcPlanarExtent = cG;
  class QA extends Xo {
    constructor() {
      super(), this.type = 2067069095;
    }
  }
  e.IfcPoint = QA;
  class hG extends QA {
    constructor(w, v) {
      super(), this.BasisCurve = w, this.PointParameter = v, this.type = 4022376103;
    }
  }
  e.IfcPointOnCurve = hG;
  class hq extends QA {
    constructor(w, v, N) {
      super(), this.BasisSurface = w, this.PointParameterU = v, this.PointParameterV = N, this.type = 1423911732;
    }
  }
  e.IfcPointOnSurface = hq;
  class S6 extends Qu {
    constructor(w) {
      super(), this.Polygon = w, this.type = 2924175390;
    }
  }
  e.IfcPolyLoop = S6;
  class fq extends EM {
    constructor(w, v, N, x) {
      super(w, v), this.BaseSurface = w, this.AgreementFlag = v, this.Position = N, this.PolygonalBoundary = x, this.type = 2775532180;
    }
  }
  e.IfcPolygonalBoundedHalfSpace = fq;
  class J5 extends xd {
    constructor(w) {
      super(), this.Name = w, this.type = 3727388367;
    }
  }
  e.IfcPreDefinedItem = J5;
  class b6 extends GI {
    constructor() {
      super(), this.type = 3778827333;
    }
  }
  e.IfcPreDefinedProperties = b6;
  class Nr extends J5 {
    constructor(w) {
      super(w), this.Name = w, this.type = 1775413392;
    }
  }
  e.IfcPreDefinedTextFont = Nr;
  class Iq extends Xg {
    constructor(w, v, N) {
      super(w, v, N), this.Name = w, this.Description = v, this.Representations = N, this.type = 673634403;
    }
  }
  e.IfcProductDefinitionShape = Iq;
  class TM extends IM {
    constructor(w, v, N, x) {
      super(w, v, N), this.Name = w, this.Description = v, this.Properties = N, this.ProfileDefinition = x, this.type = 2802850158;
    }
  }
  e.IfcProfileProperties = TM;
  class jL extends GI {
    constructor(w, v) {
      super(), this.Name = w, this.Description = v, this.type = 2598011224;
    }
  }
  e.IfcProperty = jL;
  class N6 extends CL {
    constructor(w, v, N, x) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.type = 1680319473;
    }
  }
  e.IfcPropertyDefinition = N6;
  class pq extends Y3 {
    constructor(w, v, N, x, G) {
      super(w, v), this.Name = w, this.Description = v, this.DependingProperty = N, this.DependantProperty = x, this.Expression = G, this.type = 148025276;
    }
  }
  e.IfcPropertyDependencyRelationship = pq;
  class WL extends N6 {
    constructor(w, v, N, x) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.type = 3357820518;
    }
  }
  e.IfcPropertySetDefinition = WL;
  class JA extends N6 {
    constructor(w, v, N, x) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.type = 1482703590;
    }
  }
  e.IfcPropertyTemplateDefinition = JA;
  class D6 extends WL {
    constructor(w, v, N, x) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.type = 2090586900;
    }
  }
  e.IfcQuantitySet = D6;
  class RM extends lm {
    constructor(w, v, N, x, G) {
      super(w, v, N), this.ProfileType = w, this.ProfileName = v, this.Position = N, this.XDim = x, this.YDim = G, this.type = 3615266464;
    }
  }
  e.IfcRectangleProfileDef = RM;
  class mq extends lM {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q), this.Name = w, this.Description = v, this.StartTime = N, this.EndTime = x, this.TimeSeriesDataType = G, this.DataOrigin = j, this.UserDefinedDataOrigin = K, this.Unit = Q, this.TimeStep = he, this.Values = Ze, this.type = 3413951693;
    }
  }
  e.IfcRegularTimeSeries = mq;
  class C6 extends b6 {
    constructor(w, v, N, x, G, j) {
      super(), this.TotalCrossSectionArea = w, this.SteelGrade = v, this.BarSurface = N, this.EffectiveDepth = x, this.NominalBarDiameter = G, this.BarCount = j, this.type = 1580146022;
    }
  }
  e.IfcReinforcementBarProperties = C6;
  class X5 extends CL {
    constructor(w, v, N, x) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.type = 478536968;
    }
  }
  e.IfcRelationship = X5;
  class yq extends Y3 {
    constructor(w, v, N, x) {
      super(w, v), this.Name = w, this.Description = v, this.RelatedResourceObjects = N, this.RelatingApproval = x, this.type = 2943643501;
    }
  }
  e.IfcResourceApprovalRelationship = yq;
  class Eq extends Y3 {
    constructor(w, v, N, x) {
      super(w, v), this.Name = w, this.Description = v, this.RelatingConstraint = N, this.RelatedResourceObjects = x, this.type = 1608871552;
    }
  }
  e.IfcResourceConstraintRelationship = Eq;
  class fG extends qA {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki, Vn, ks, gr, Ro, ma, Lu) {
      super(w, v, N), this.Name = w, this.DataOrigin = v, this.UserDefinedDataOrigin = N, this.ScheduleWork = x, this.ScheduleUsage = G, this.ScheduleStart = j, this.ScheduleFinish = K, this.ScheduleContour = Q, this.LevelingDelay = he, this.IsOverAllocated = Ze, this.StatusTime = pi, this.ActualWork = Ki, this.ActualUsage = Vn, this.ActualStart = ks, this.ActualFinish = gr, this.RemainingWork = Ro, this.RemainingUsage = ma, this.Completion = Lu, this.type = 1042787934;
    }
  }
  e.IfcResourceTime = fG;
  class vM extends RM {
    constructor(w, v, N, x, G, j) {
      super(w, v, N, x, G), this.ProfileType = w, this.ProfileName = v, this.Position = N, this.XDim = x, this.YDim = G, this.RoundingRadius = j, this.type = 2778083089;
    }
  }
  e.IfcRoundedRectangleProfileDef = vM;
  class gq extends b6 {
    constructor(w, v, N) {
      super(), this.SectionType = w, this.StartProfile = v, this.EndProfile = N, this.type = 2042790032;
    }
  }
  e.IfcSectionProperties = gq;
  class wq extends b6 {
    constructor(w, v, N, x, G, j) {
      super(), this.LongitudinalStartPosition = w, this.LongitudinalEndPosition = v, this.TransversePosition = N, this.ReinforcementRole = x, this.SectionDefinition = G, this.CrossSectionReinforcementDefinitions = j, this.type = 4165799628;
    }
  }
  e.IfcSectionReinforcementProperties = wq;
  class YL extends Xo {
    constructor(w, v, N) {
      super(), this.SpineCurve = w, this.CrossSections = v, this.CrossSectionPositions = N, this.type = 1509187699;
    }
  }
  e.IfcSectionedSpine = YL;
  class Tq extends Xo {
    constructor(w) {
      super(), this.SbsmBoundary = w, this.type = 4124623270;
    }
  }
  e.IfcShellBasedSurfaceModel = Tq;
  class eR extends jL {
    constructor(w, v) {
      super(w, v), this.Name = w, this.Description = v, this.type = 3692461612;
    }
  }
  e.IfcSimpleProperty = eR;
  class Rq extends w6 {
    constructor(w, v, N, x) {
      super(w), this.Name = w, this.SlippageX = v, this.SlippageY = N, this.SlippageZ = x, this.type = 2609359061;
    }
  }
  e.IfcSlippageConnectionCondition = Rq;
  class XA extends Xo {
    constructor() {
      super(), this.type = 723233188;
    }
  }
  e.IfcSolidModel = XA;
  class AM extends q3 {
    constructor(w, v, N, x, G, j, K) {
      super(w), this.Name = w, this.LinearForceX = v, this.LinearForceY = N, this.LinearForceZ = x, this.LinearMomentX = G, this.LinearMomentY = j, this.LinearMomentZ = K, this.type = 1595516126;
    }
  }
  e.IfcStructuralLoadLinearForce = AM;
  class vq extends q3 {
    constructor(w, v, N, x) {
      super(w), this.Name = w, this.PlanarForceX = v, this.PlanarForceY = N, this.PlanarForceZ = x, this.type = 2668620305;
    }
  }
  e.IfcStructuralLoadPlanarForce = vq;
  class SM extends q3 {
    constructor(w, v, N, x, G, j, K) {
      super(w), this.Name = w, this.DisplacementX = v, this.DisplacementY = N, this.DisplacementZ = x, this.RotationalDisplacementRX = G, this.RotationalDisplacementRY = j, this.RotationalDisplacementRZ = K, this.type = 2473145415;
    }
  }
  e.IfcStructuralLoadSingleDisplacement = SM;
  class Aq extends SM {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G, j, K), this.Name = w, this.DisplacementX = v, this.DisplacementY = N, this.DisplacementZ = x, this.RotationalDisplacementRX = G, this.RotationalDisplacementRY = j, this.RotationalDisplacementRZ = K, this.Distortion = Q, this.type = 1973038258;
    }
  }
  e.IfcStructuralLoadSingleDisplacementDistortion = Aq;
  class IG extends q3 {
    constructor(w, v, N, x, G, j, K) {
      super(w), this.Name = w, this.ForceX = v, this.ForceY = N, this.ForceZ = x, this.MomentX = G, this.MomentY = j, this.MomentZ = K, this.type = 1597423693;
    }
  }
  e.IfcStructuralLoadSingleForce = IG;
  class bM extends IG {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G, j, K), this.Name = w, this.ForceX = v, this.ForceY = N, this.ForceZ = x, this.MomentX = G, this.MomentY = j, this.MomentZ = K, this.WarpingMoment = Q, this.type = 1190533807;
    }
  }
  e.IfcStructuralLoadSingleForceWarping = bM;
  class pG extends FL {
    constructor(w, v, N) {
      super(w, v), this.EdgeStart = w, this.EdgeEnd = v, this.ParentEdge = N, this.type = 2233826070;
    }
  }
  e.IfcSubedge = pG;
  class tR extends Xo {
    constructor() {
      super(), this.type = 2513912981;
    }
  }
  e.IfcSurface = tR;
  class mG extends qH {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v), this.SurfaceColour = w, this.Transparency = v, this.DiffuseColour = N, this.TransmissionColour = x, this.DiffuseTransmissionColour = G, this.ReflectionColour = j, this.SpecularColour = K, this.SpecularHighlight = Q, this.ReflectanceMethod = he, this.type = 1878645084;
    }
  }
  e.IfcSurfaceStyleRendering = mG;
  class O6 extends XA {
    constructor(w, v) {
      super(), this.SweptArea = w, this.Position = v, this.type = 2247615214;
    }
  }
  e.IfcSweptAreaSolid = O6;
  class NM extends XA {
    constructor(w, v, N, x, G) {
      super(), this.Directrix = w, this.Radius = v, this.InnerRadius = N, this.StartParam = x, this.EndParam = G, this.type = 1260650574;
    }
  }
  e.IfcSweptDiskSolid = NM;
  class Sq extends NM {
    constructor(w, v, N, x, G, j) {
      super(w, v, N, x, G), this.Directrix = w, this.Radius = v, this.InnerRadius = N, this.StartParam = x, this.EndParam = G, this.FilletRadius = j, this.type = 1096409881;
    }
  }
  e.IfcSweptDiskSolidPolygonal = Sq;
  class Vf extends tR {
    constructor(w, v) {
      super(), this.SweptCurve = w, this.Position = v, this.type = 230924584;
    }
  }
  e.IfcSweptSurface = Vf;
  class bq extends lm {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki) {
      super(w, v, N), this.ProfileType = w, this.ProfileName = v, this.Position = N, this.Depth = x, this.FlangeWidth = G, this.WebThickness = j, this.FlangeThickness = K, this.FilletRadius = Q, this.FlangeEdgeRadius = he, this.WebEdgeRadius = Ze, this.WebSlope = pi, this.FlangeSlope = Ki, this.type = 3071757647;
    }
  }
  e.IfcTShapeProfileDef = bq;
  class DM extends Xo {
    constructor() {
      super(), this.type = 901063453;
    }
  }
  e.IfcTessellatedItem = DM;
  class iR extends Xo {
    constructor(w, v, N) {
      super(), this.Literal = w, this.Placement = v, this.Path = N, this.type = 4282788508;
    }
  }
  e.IfcTextLiteral = iR;
  class L6 extends iR {
    constructor(w, v, N, x, G) {
      super(w, v, N), this.Literal = w, this.Placement = v, this.Path = N, this.Extent = x, this.BoxAlignment = G, this.type = 3124975700;
    }
  }
  e.IfcTextLiteralWithExtent = L6;
  class nR extends Nr {
    constructor(w, v, N, x, G, j) {
      super(w), this.Name = w, this.FontFamily = v, this.FontStyle = N, this.FontVariant = x, this.FontWeight = G, this.FontSize = j, this.type = 1983826977;
    }
  }
  e.IfcTextStyleFontModel = nR;
  class _6 extends lm {
    constructor(w, v, N, x, G, j, K) {
      super(w, v, N), this.ProfileType = w, this.ProfileName = v, this.Position = N, this.BottomXDim = x, this.TopXDim = G, this.YDim = j, this.TopXOffset = K, this.type = 2715220739;
    }
  }
  e.IfcTrapeziumProfileDef = _6;
  class qL extends Z4 {
    constructor(w, v, N, x, G, j) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.type = 1628702193;
    }
  }
  e.IfcTypeObject = qL;
  class $L extends qL {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.Identification = K, this.LongDescription = Q, this.ProcessType = he, this.type = 3736923433;
    }
  }
  e.IfcTypeProcess = $L;
  class x6 extends qL {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G, j), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.type = 2347495698;
    }
  }
  e.IfcTypeProduct = x6;
  class yG extends qL {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.Identification = K, this.LongDescription = Q, this.ResourceType = he, this.type = 3698973494;
    }
  }
  e.IfcTypeResource = yG;
  class Nq extends lm {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N), this.ProfileType = w, this.ProfileName = v, this.Position = N, this.Depth = x, this.FlangeWidth = G, this.WebThickness = j, this.FlangeThickness = K, this.FilletRadius = Q, this.EdgeRadius = he, this.FlangeSlope = Ze, this.type = 427810014;
    }
  }
  e.IfcUShapeProfileDef = Nq;
  class KL extends Xo {
    constructor(w, v) {
      super(), this.Orientation = w, this.Magnitude = v, this.type = 1417489154;
    }
  }
  e.IfcVector = KL;
  class ZL extends Qu {
    constructor(w) {
      super(), this.LoopVertex = w, this.type = 2759199220;
    }
  }
  e.IfcVertexLoop = ZL;
  class QL extends x6 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ConstructionType = he, this.OperationType = Ze, this.ParameterTakesPrecedence = pi, this.Sizeable = Ki, this.type = 1299126871;
    }
  }
  e.IfcWindowStyle = QL;
  class Dq extends lm {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N), this.ProfileType = w, this.ProfileName = v, this.Position = N, this.Depth = x, this.FlangeWidth = G, this.WebThickness = j, this.FlangeThickness = K, this.FilletRadius = Q, this.EdgeRadius = he, this.type = 2543172580;
    }
  }
  e.IfcZShapeProfileDef = Dq;
  class Cq extends eG {
    constructor(w, v, N) {
      super(w, v, N), this.Bounds = w, this.FaceSurface = v, this.SameSense = N, this.type = 3406155212;
    }
  }
  e.IfcAdvancedFace = Cq;
  class CM extends Xo {
    constructor(w, v) {
      super(), this.OuterBoundary = w, this.InnerBoundaries = v, this.type = 669184980;
    }
  }
  e.IfcAnnotationFillArea = CM;
  class OM extends lm {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki, Vn, ks, gr) {
      super(w, v, N), this.ProfileType = w, this.ProfileName = v, this.Position = N, this.BottomFlangeWidth = x, this.OverallDepth = G, this.WebThickness = j, this.BottomFlangeThickness = K, this.BottomFlangeFilletRadius = Q, this.TopFlangeWidth = he, this.TopFlangeThickness = Ze, this.TopFlangeFilletRadius = pi, this.BottomFlangeEdgeRadius = Ki, this.BottomFlangeSlope = Vn, this.TopFlangeEdgeRadius = ks, this.TopFlangeSlope = gr, this.type = 3207858831;
    }
  }
  e.IfcAsymmetricIShapeProfileDef = OM;
  class sR extends Q5 {
    constructor(w, v) {
      super(w), this.Location = w, this.Axis = v, this.type = 4261334040;
    }
  }
  e.IfcAxis1Placement = sR;
  class P6 extends Q5 {
    constructor(w, v) {
      super(w), this.Location = w, this.RefDirection = v, this.type = 3125803723;
    }
  }
  e.IfcAxis2Placement2D = P6;
  class LM extends Q5 {
    constructor(w, v, N) {
      super(w), this.Location = w, this.Axis = v, this.RefDirection = N, this.type = 2740243338;
    }
  }
  e.IfcAxis2Placement3D = LM;
  class JL extends Xo {
    constructor(w, v, N) {
      super(), this.Operator = w, this.FirstOperand = v, this.SecondOperand = N, this.type = 2736907675;
    }
  }
  e.IfcBooleanResult = JL;
  class oR extends tR {
    constructor() {
      super(), this.type = 4182860854;
    }
  }
  e.IfcBoundedSurface = oR;
  class Oq extends Xo {
    constructor(w, v, N, x) {
      super(), this.Corner = w, this.XDim = v, this.YDim = N, this.ZDim = x, this.type = 2581212453;
    }
  }
  e.IfcBoundingBox = Oq;
  class Lq extends EM {
    constructor(w, v, N) {
      super(w, v), this.BaseSurface = w, this.AgreementFlag = v, this.Enclosure = N, this.type = 2713105998;
    }
  }
  e.IfcBoxedHalfSpace = Lq;
  class rR extends lm {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N), this.ProfileType = w, this.ProfileName = v, this.Position = N, this.Depth = x, this.Width = G, this.WallThickness = j, this.Girth = K, this.InternalFilletRadius = Q, this.type = 2898889636;
    }
  }
  e.IfcCShapeProfileDef = rR;
  class _q extends QA {
    constructor(w) {
      super(), this.Coordinates = w, this.type = 1123145078;
    }
  }
  e.IfcCartesianPoint = _q;
  class _M extends Xo {
    constructor() {
      super(), this.type = 574549367;
    }
  }
  e.IfcCartesianPointList = _M;
  class xM extends _M {
    constructor(w) {
      super(), this.CoordList = w, this.type = 1675464909;
    }
  }
  e.IfcCartesianPointList2D = xM;
  class xq extends _M {
    constructor(w) {
      super(), this.CoordList = w, this.type = 2059837836;
    }
  }
  e.IfcCartesianPointList3D = xq;
  class PM extends Xo {
    constructor(w, v, N, x) {
      super(), this.Axis1 = w, this.Axis2 = v, this.LocalOrigin = N, this.Scale = x, this.type = 59481748;
    }
  }
  e.IfcCartesianTransformationOperator = PM;
  class MM extends PM {
    constructor(w, v, N, x) {
      super(w, v, N, x), this.Axis1 = w, this.Axis2 = v, this.LocalOrigin = N, this.Scale = x, this.type = 3749851601;
    }
  }
  e.IfcCartesianTransformationOperator2D = MM;
  class Pq extends MM {
    constructor(w, v, N, x, G) {
      super(w, v, N, x), this.Axis1 = w, this.Axis2 = v, this.LocalOrigin = N, this.Scale = x, this.Scale2 = G, this.type = 3486308946;
    }
  }
  e.IfcCartesianTransformationOperator2DnonUniform = Pq;
  class XL extends PM {
    constructor(w, v, N, x, G) {
      super(w, v, N, x), this.Axis1 = w, this.Axis2 = v, this.LocalOrigin = N, this.Scale = x, this.Axis3 = G, this.type = 3331915920;
    }
  }
  e.IfcCartesianTransformationOperator3D = XL;
  class UM extends XL {
    constructor(w, v, N, x, G, j, K) {
      super(w, v, N, x, G), this.Axis1 = w, this.Axis2 = v, this.LocalOrigin = N, this.Scale = x, this.Axis3 = G, this.Scale2 = j, this.Scale3 = K, this.type = 1416205885;
    }
  }
  e.IfcCartesianTransformationOperator3DnonUniform = UM;
  class Ah extends lm {
    constructor(w, v, N, x) {
      super(w, v, N), this.ProfileType = w, this.ProfileName = v, this.Position = N, this.Radius = x, this.type = 1383045692;
    }
  }
  e.IfcCircleProfileDef = Ah;
  class Mq extends ML {
    constructor(w) {
      super(w), this.CfsFaces = w, this.type = 2205249479;
    }
  }
  e.IfcClosedShell = Mq;
  class eS extends hM {
    constructor(w, v, N, x) {
      super(w), this.Name = w, this.Red = v, this.Green = N, this.Blue = x, this.type = 776857604;
    }
  }
  e.IfcColourRgb = eS;
  class Uq extends jL {
    constructor(w, v, N, x) {
      super(w, v), this.Name = w, this.Description = v, this.UsageName = N, this.HasProperties = x, this.type = 2542286263;
    }
  }
  e.IfcComplexProperty = Uq;
  class EG extends Xo {
    constructor(w, v, N) {
      super(), this.Transition = w, this.SameSense = v, this.ParentCurve = N, this.type = 2485617015;
    }
  }
  e.IfcCompositeCurveSegment = EG;
  class Q4 extends yG {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.Identification = K, this.LongDescription = Q, this.ResourceType = he, this.BaseCosts = Ze, this.BaseQuantity = pi, this.type = 2574617495;
    }
  }
  e.IfcConstructionResourceType = Q4;
  class M6 extends Z4 {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.LongName = j, this.Phase = K, this.RepresentationContexts = Q, this.UnitsInContext = he, this.type = 3419103109;
    }
  }
  e.IfcContext = M6;
  class wE extends Q4 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki) {
      super(w, v, N, x, G, j, K, Q, he, Ze, pi), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.Identification = K, this.LongDescription = Q, this.ResourceType = he, this.BaseCosts = Ze, this.BaseQuantity = pi, this.PredefinedType = Ki, this.type = 1815067380;
    }
  }
  e.IfcCrewResourceType = wE;
  class tS extends Xo {
    constructor(w) {
      super(), this.Position = w, this.type = 2506170314;
    }
  }
  e.IfcCsgPrimitive3D = tS;
  class Bq extends XA {
    constructor(w) {
      super(), this.TreeRootExpression = w, this.type = 2147822146;
    }
  }
  e.IfcCsgSolid = Bq;
  class am extends Xo {
    constructor() {
      super(), this.type = 2601014836;
    }
  }
  e.IfcCurve = am;
  class Fq extends oR {
    constructor(w, v, N) {
      super(), this.BasisSurface = w, this.OuterBoundary = v, this.InnerBoundaries = N, this.type = 2827736869;
    }
  }
  e.IfcCurveBoundedPlane = Fq;
  class e7 extends oR {
    constructor(w, v, N) {
      super(), this.BasisSurface = w, this.Boundaries = v, this.ImplicitOuter = N, this.type = 2629017746;
    }
  }
  e.IfcCurveBoundedSurface = e7;
  class gG extends Xo {
    constructor(w) {
      super(), this.DirectionRatios = w, this.type = 32440307;
    }
  }
  e.IfcDirection = gG;
  class Hq extends x6 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.OperationType = he, this.ConstructionType = Ze, this.ParameterTakesPrecedence = pi, this.Sizeable = Ki, this.type = 526551008;
    }
  }
  e.IfcDoorStyle = Hq;
  class nw extends Qu {
    constructor(w) {
      super(), this.EdgeList = w, this.type = 1472233963;
    }
  }
  e.IfcEdgeLoop = nw;
  class wG extends D6 {
    constructor(w, v, N, x, G, j) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.MethodOfMeasurement = G, this.Quantities = j, this.type = 1883228015;
    }
  }
  e.IfcElementQuantity = wG;
  class zf extends x6 {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.type = 339256511;
    }
  }
  e.IfcElementType = zf;
  class iS extends tR {
    constructor(w) {
      super(), this.Position = w, this.type = 2777663545;
    }
  }
  e.IfcElementarySurface = iS;
  class Gq extends lm {
    constructor(w, v, N, x, G) {
      super(w, v, N), this.ProfileType = w, this.ProfileName = v, this.Position = N, this.SemiAxis1 = x, this.SemiAxis2 = G, this.type = 2835456948;
    }
  }
  e.IfcEllipseProfileDef = Gq;
  class kq extends $L {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.Identification = K, this.LongDescription = Q, this.ProcessType = he, this.PredefinedType = Ze, this.EventTriggerType = pi, this.UserDefinedEventTriggerType = Ki, this.type = 4024345920;
    }
  }
  e.IfcEventType = kq;
  class TG extends O6 {
    constructor(w, v, N, x) {
      super(w, v), this.SweptArea = w, this.Position = v, this.ExtrudedDirection = N, this.Depth = x, this.type = 477187591;
    }
  }
  e.IfcExtrudedAreaSolid = TG;
  class t7 extends TG {
    constructor(w, v, N, x, G) {
      super(w, v, N, x), this.SweptArea = w, this.Position = v, this.ExtrudedDirection = N, this.Depth = x, this.EndSweptArea = G, this.type = 2804161546;
    }
  }
  e.IfcExtrudedAreaSolidTapered = t7;
  class um extends Xo {
    constructor(w) {
      super(), this.FbsmFaces = w, this.type = 2047409740;
    }
  }
  e.IfcFaceBasedSurfaceModel = um;
  class BM extends Xo {
    constructor(w, v, N, x, G) {
      super(), this.HatchLineAppearance = w, this.StartOfNextHatchLine = v, this.PointOfReferenceHatchLine = N, this.PatternStart = x, this.HatchLineAngle = G, this.type = 374418227;
    }
  }
  e.IfcFillAreaStyleHatching = BM;
  class RG extends Xo {
    constructor(w, v, N) {
      super(), this.TilingPattern = w, this.Tiles = v, this.TilingScale = N, this.type = 315944413;
    }
  }
  e.IfcFillAreaStyleTiles = RG;
  class Vq extends O6 {
    constructor(w, v, N, x, G, j) {
      super(w, v), this.SweptArea = w, this.Position = v, this.Directrix = N, this.StartParam = x, this.EndParam = G, this.FixedReference = j, this.type = 2652556860;
    }
  }
  e.IfcFixedReferenceSweptAreaSolid = Vq;
  class FM extends zf {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.type = 4238390223;
    }
  }
  e.IfcFurnishingElementType = FM;
  class zq extends FM {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.AssemblyPlace = Ze, this.PredefinedType = pi, this.type = 1268542332;
    }
  }
  e.IfcFurnitureType = zq;
  class jq extends zf {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 4095422895;
    }
  }
  e.IfcGeographicElementType = jq;
  class Wq extends yM {
    constructor(w) {
      super(w), this.Elements = w, this.type = 987898635;
    }
  }
  e.IfcGeometricCurveSet = Wq;
  class Yq extends lm {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N), this.ProfileType = w, this.ProfileName = v, this.Position = N, this.OverallWidth = x, this.OverallDepth = G, this.WebThickness = j, this.FlangeThickness = K, this.FilletRadius = Q, this.FlangeEdgeRadius = he, this.FlangeSlope = Ze, this.type = 1484403080;
    }
  }
  e.IfcIShapeProfileDef = Yq;
  class vu extends DM {
    constructor(w) {
      super(), this.CoordIndex = w, this.type = 178912537;
    }
  }
  e.IfcIndexedPolygonalFace = vu;
  class HM extends vu {
    constructor(w, v) {
      super(w), this.CoordIndex = w, this.InnerCoordIndices = v, this.type = 2294589976;
    }
  }
  e.IfcIndexedPolygonalFaceWithVoids = HM;
  class qq extends lm {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N), this.ProfileType = w, this.ProfileName = v, this.Position = N, this.Depth = x, this.Width = G, this.Thickness = j, this.FilletRadius = K, this.EdgeRadius = Q, this.LegSlope = he, this.type = 572779678;
    }
  }
  e.IfcLShapeProfileDef = qq;
  class $q extends Q4 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki) {
      super(w, v, N, x, G, j, K, Q, he, Ze, pi), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.Identification = K, this.LongDescription = Q, this.ResourceType = he, this.BaseCosts = Ze, this.BaseQuantity = pi, this.PredefinedType = Ki, this.type = 428585644;
    }
  }
  e.IfcLaborResourceType = $q;
  class Kq extends am {
    constructor(w, v) {
      super(), this.Pnt = w, this.Dir = v, this.type = 1281925730;
    }
  }
  e.IfcLine = Kq;
  class i7 extends XA {
    constructor(w) {
      super(), this.Outer = w, this.type = 1425443689;
    }
  }
  e.IfcManifoldSolidBrep = i7;
  class K3 extends Z4 {
    constructor(w, v, N, x, G) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.type = 3888040117;
    }
  }
  e.IfcObject = K3;
  class vG extends am {
    constructor(w, v, N) {
      super(), this.BasisCurve = w, this.Distance = v, this.SelfIntersect = N, this.type = 3388369263;
    }
  }
  e.IfcOffsetCurve2D = vG;
  class Zq extends am {
    constructor(w, v, N, x) {
      super(), this.BasisCurve = w, this.Distance = v, this.SelfIntersect = N, this.RefDirection = x, this.type = 3505215534;
    }
  }
  e.IfcOffsetCurve3D = Zq;
  class Qq extends am {
    constructor(w, v) {
      super(), this.BasisSurface = w, this.ReferenceCurve = v, this.type = 1682466193;
    }
  }
  e.IfcPcurve = Qq;
  class Jq extends cG {
    constructor(w, v, N) {
      super(w, v), this.SizeInX = w, this.SizeInY = v, this.Placement = N, this.type = 603570806;
    }
  }
  e.IfcPlanarBox = Jq;
  class GM extends iS {
    constructor(w) {
      super(w), this.Position = w, this.type = 220341763;
    }
  }
  e.IfcPlane = GM;
  class AG extends J5 {
    constructor(w) {
      super(w), this.Name = w, this.type = 759155922;
    }
  }
  e.IfcPreDefinedColour = AG;
  class n7 extends J5 {
    constructor(w) {
      super(w), this.Name = w, this.type = 2559016684;
    }
  }
  e.IfcPreDefinedCurveFont = n7;
  class Z3 extends WL {
    constructor(w, v, N, x) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.type = 3967405729;
    }
  }
  e.IfcPreDefinedPropertySet = Z3;
  class kM extends $L {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.Identification = K, this.LongDescription = Q, this.ProcessType = he, this.PredefinedType = Ze, this.type = 569719735;
    }
  }
  e.IfcProcedureType = kM;
  class s7 extends K3 {
    constructor(w, v, N, x, G, j, K) {
      super(w, v, N, x, G), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.Identification = j, this.LongDescription = K, this.type = 2945172077;
    }
  }
  e.IfcProcess = s7;
  class TE extends K3 {
    constructor(w, v, N, x, G, j, K) {
      super(w, v, N, x, G), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.type = 4208778838;
    }
  }
  e.IfcProduct = TE;
  class Xq extends M6 {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.LongName = j, this.Phase = K, this.RepresentationContexts = Q, this.UnitsInContext = he, this.type = 103090709;
    }
  }
  e.IfcProject = Xq;
  class SG extends M6 {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.LongName = j, this.Phase = K, this.RepresentationContexts = Q, this.UnitsInContext = he, this.type = 653396225;
    }
  }
  e.IfcProjectLibrary = SG;
  class e$ extends eR {
    constructor(w, v, N, x, G, j) {
      super(w, v), this.Name = w, this.Description = v, this.UpperBoundValue = N, this.LowerBoundValue = x, this.Unit = G, this.SetPointValue = j, this.type = 871118103;
    }
  }
  e.IfcPropertyBoundedValue = e$;
  class t$ extends eR {
    constructor(w, v, N, x) {
      super(w, v), this.Name = w, this.Description = v, this.EnumerationValues = N, this.EnumerationReference = x, this.type = 4166981789;
    }
  }
  e.IfcPropertyEnumeratedValue = t$;
  class i$ extends eR {
    constructor(w, v, N, x) {
      super(w, v), this.Name = w, this.Description = v, this.ListValues = N, this.Unit = x, this.type = 2752243245;
    }
  }
  e.IfcPropertyListValue = i$;
  class bG extends eR {
    constructor(w, v, N, x) {
      super(w, v), this.Name = w, this.Description = v, this.UsageName = N, this.PropertyReference = x, this.type = 941946838;
    }
  }
  e.IfcPropertyReferenceValue = bG;
  class lR extends WL {
    constructor(w, v, N, x, G) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.HasProperties = G, this.type = 1451395588;
    }
  }
  e.IfcPropertySet = lR;
  class VM extends JA {
    constructor(w, v, N, x, G, j, K) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.TemplateType = G, this.ApplicableEntity = j, this.HasPropertyTemplates = K, this.type = 492091185;
    }
  }
  e.IfcPropertySetTemplate = VM;
  class n$ extends eR {
    constructor(w, v, N, x) {
      super(w, v), this.Name = w, this.Description = v, this.NominalValue = N, this.Unit = x, this.type = 3650150729;
    }
  }
  e.IfcPropertySingleValue = n$;
  class nS extends eR {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v), this.Name = w, this.Description = v, this.DefiningValues = N, this.DefinedValues = x, this.Expression = G, this.DefiningUnit = j, this.DefinedUnit = K, this.CurveInterpolation = Q, this.type = 110355661;
    }
  }
  e.IfcPropertyTableValue = nS;
  class zM extends JA {
    constructor(w, v, N, x) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.type = 3521284610;
    }
  }
  e.IfcPropertyTemplate = zM;
  class sw extends TE {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.ProxyType = Q, this.Tag = he, this.type = 3219374653;
    }
  }
  e.IfcProxy = sw;
  class NG extends RM {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G), this.ProfileType = w, this.ProfileName = v, this.Position = N, this.XDim = x, this.YDim = G, this.WallThickness = j, this.InnerFilletRadius = K, this.OuterFilletRadius = Q, this.type = 2770003689;
    }
  }
  e.IfcRectangleHollowProfileDef = NG;
  class s$ extends tS {
    constructor(w, v, N, x) {
      super(w), this.Position = w, this.XLength = v, this.YLength = N, this.Height = x, this.type = 2798486643;
    }
  }
  e.IfcRectangularPyramid = s$;
  class o$ extends oR {
    constructor(w, v, N, x, G, j, K) {
      super(), this.BasisSurface = w, this.U1 = v, this.V1 = N, this.U2 = x, this.V2 = G, this.Usense = j, this.Vsense = K, this.type = 3454111270;
    }
  }
  e.IfcRectangularTrimmedSurface = o$;
  class r$ extends Z3 {
    constructor(w, v, N, x, G, j) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.DefinitionType = G, this.ReinforcementSectionDefinitions = j, this.type = 3765753017;
    }
  }
  e.IfcReinforcementDefinitionProperties = r$;
  class VI extends X5 {
    constructor(w, v, N, x, G, j) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatedObjects = G, this.RelatedObjectsType = j, this.type = 3939117080;
    }
  }
  e.IfcRelAssigns = VI;
  class DG extends VI {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G, j), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatedObjects = G, this.RelatedObjectsType = j, this.RelatingActor = K, this.ActingRole = Q, this.type = 1683148259;
    }
  }
  e.IfcRelAssignsToActor = DG;
  class l$ extends VI {
    constructor(w, v, N, x, G, j, K) {
      super(w, v, N, x, G, j), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatedObjects = G, this.RelatedObjectsType = j, this.RelatingControl = K, this.type = 2495723537;
    }
  }
  e.IfcRelAssignsToControl = l$;
  class dm extends VI {
    constructor(w, v, N, x, G, j, K) {
      super(w, v, N, x, G, j), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatedObjects = G, this.RelatedObjectsType = j, this.RelatingGroup = K, this.type = 1307041759;
    }
  }
  e.IfcRelAssignsToGroup = dm;
  class aR extends dm {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G, j, K), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatedObjects = G, this.RelatedObjectsType = j, this.RelatingGroup = K, this.Factor = Q, this.type = 1027710054;
    }
  }
  e.IfcRelAssignsToGroupByFactor = aR;
  class jM extends VI {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G, j), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatedObjects = G, this.RelatedObjectsType = j, this.RelatingProcess = K, this.QuantityInProcess = Q, this.type = 4278684876;
    }
  }
  e.IfcRelAssignsToProcess = jM;
  class CG extends VI {
    constructor(w, v, N, x, G, j, K) {
      super(w, v, N, x, G, j), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatedObjects = G, this.RelatedObjectsType = j, this.RelatingProduct = K, this.type = 2857406711;
    }
  }
  e.IfcRelAssignsToProduct = CG;
  class WM extends VI {
    constructor(w, v, N, x, G, j, K) {
      super(w, v, N, x, G, j), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatedObjects = G, this.RelatedObjectsType = j, this.RelatingResource = K, this.type = 205026976;
    }
  }
  e.IfcRelAssignsToResource = WM;
  class uR extends X5 {
    constructor(w, v, N, x, G) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatedObjects = G, this.type = 1865459582;
    }
  }
  e.IfcRelAssociates = uR;
  class a$ extends uR {
    constructor(w, v, N, x, G, j) {
      super(w, v, N, x, G), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatedObjects = G, this.RelatingApproval = j, this.type = 4095574036;
    }
  }
  e.IfcRelAssociatesApproval = a$;
  class u$ extends uR {
    constructor(w, v, N, x, G, j) {
      super(w, v, N, x, G), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatedObjects = G, this.RelatingClassification = j, this.type = 919958153;
    }
  }
  e.IfcRelAssociatesClassification = u$;
  class d$ extends uR {
    constructor(w, v, N, x, G, j, K) {
      super(w, v, N, x, G), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatedObjects = G, this.Intent = j, this.RelatingConstraint = K, this.type = 2728634034;
    }
  }
  e.IfcRelAssociatesConstraint = d$;
  class OG extends uR {
    constructor(w, v, N, x, G, j) {
      super(w, v, N, x, G), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatedObjects = G, this.RelatingDocument = j, this.type = 982818633;
    }
  }
  e.IfcRelAssociatesDocument = OG;
  class YM extends uR {
    constructor(w, v, N, x, G, j) {
      super(w, v, N, x, G), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatedObjects = G, this.RelatingLibrary = j, this.type = 3840914261;
    }
  }
  e.IfcRelAssociatesLibrary = YM;
  class qM extends uR {
    constructor(w, v, N, x, G, j) {
      super(w, v, N, x, G), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatedObjects = G, this.RelatingMaterial = j, this.type = 2655215786;
    }
  }
  e.IfcRelAssociatesMaterial = qM;
  class E0 extends X5 {
    constructor(w, v, N, x) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.type = 826625072;
    }
  }
  e.IfcRelConnects = E0;
  class o7 extends E0 {
    constructor(w, v, N, x, G, j, K) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ConnectionGeometry = G, this.RelatingElement = j, this.RelatedElement = K, this.type = 1204542856;
    }
  }
  e.IfcRelConnectsElements = o7;
  class c$ extends o7 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi) {
      super(w, v, N, x, G, j, K), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ConnectionGeometry = G, this.RelatingElement = j, this.RelatedElement = K, this.RelatingPriorities = Q, this.RelatedPriorities = he, this.RelatedConnectionType = Ze, this.RelatingConnectionType = pi, this.type = 3945020480;
    }
  }
  e.IfcRelConnectsPathElements = c$;
  class LG extends E0 {
    constructor(w, v, N, x, G, j) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatingPort = G, this.RelatedElement = j, this.type = 4201705270;
    }
  }
  e.IfcRelConnectsPortToElement = LG;
  class h$ extends E0 {
    constructor(w, v, N, x, G, j, K) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatingPort = G, this.RelatedPort = j, this.RealizingElement = K, this.type = 3190031847;
    }
  }
  e.IfcRelConnectsPorts = h$;
  class f$ extends E0 {
    constructor(w, v, N, x, G, j) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatingElement = G, this.RelatedStructuralActivity = j, this.type = 2127690289;
    }
  }
  e.IfcRelConnectsStructuralActivity = f$;
  class sS extends E0 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatingStructuralMember = G, this.RelatedStructuralConnection = j, this.AppliedCondition = K, this.AdditionalConditions = Q, this.SupportedLength = he, this.ConditionCoordinateSystem = Ze, this.type = 1638771189;
    }
  }
  e.IfcRelConnectsStructuralMember = sS;
  class I$ extends sS {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi) {
      super(w, v, N, x, G, j, K, Q, he, Ze), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatingStructuralMember = G, this.RelatedStructuralConnection = j, this.AppliedCondition = K, this.AdditionalConditions = Q, this.SupportedLength = he, this.ConditionCoordinateSystem = Ze, this.ConnectionConstraint = pi, this.type = 504942748;
    }
  }
  e.IfcRelConnectsWithEccentricity = I$;
  class zI extends o7 {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ConnectionGeometry = G, this.RelatingElement = j, this.RelatedElement = K, this.RealizingElements = Q, this.ConnectionType = he, this.type = 3678494232;
    }
  }
  e.IfcRelConnectsWithRealizingElements = zI;
  class $M extends E0 {
    constructor(w, v, N, x, G, j) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatedElements = G, this.RelatingStructure = j, this.type = 3242617779;
    }
  }
  e.IfcRelContainedInSpatialStructure = $M;
  class dR extends E0 {
    constructor(w, v, N, x, G, j) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatingBuildingElement = G, this.RelatedCoverings = j, this.type = 886880790;
    }
  }
  e.IfcRelCoversBldgElements = dR;
  class r7 extends E0 {
    constructor(w, v, N, x, G, j) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatingSpace = G, this.RelatedCoverings = j, this.type = 2802773753;
    }
  }
  e.IfcRelCoversSpaces = r7;
  class _G extends X5 {
    constructor(w, v, N, x, G, j) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatingContext = G, this.RelatedDefinitions = j, this.type = 2565941209;
    }
  }
  e.IfcRelDeclares = _G;
  class cR extends X5 {
    constructor(w, v, N, x) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.type = 2551354335;
    }
  }
  e.IfcRelDecomposes = cR;
  class Q3 extends X5 {
    constructor(w, v, N, x) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.type = 693640335;
    }
  }
  e.IfcRelDefines = Q3;
  class g0 extends Q3 {
    constructor(w, v, N, x, G, j) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatedObjects = G, this.RelatingObject = j, this.type = 1462361463;
    }
  }
  e.IfcRelDefinesByObject = g0;
  class p$ extends Q3 {
    constructor(w, v, N, x, G, j) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatedObjects = G, this.RelatingPropertyDefinition = j, this.type = 4186316022;
    }
  }
  e.IfcRelDefinesByProperties = p$;
  class m$ extends Q3 {
    constructor(w, v, N, x, G, j) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatedPropertySets = G, this.RelatingTemplate = j, this.type = 307848117;
    }
  }
  e.IfcRelDefinesByTemplate = m$;
  class y$ extends Q3 {
    constructor(w, v, N, x, G, j) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatedObjects = G, this.RelatingType = j, this.type = 781010003;
    }
  }
  e.IfcRelDefinesByType = y$;
  class xG extends E0 {
    constructor(w, v, N, x, G, j) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatingOpeningElement = G, this.RelatedBuildingElement = j, this.type = 3940055652;
    }
  }
  e.IfcRelFillsElement = xG;
  class PG extends E0 {
    constructor(w, v, N, x, G, j) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatedControlElements = G, this.RelatingFlowElement = j, this.type = 279856033;
    }
  }
  e.IfcRelFlowControlElements = PG;
  class J3 extends E0 {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatingElement = G, this.RelatedElement = j, this.InterferenceGeometry = K, this.InterferenceType = Q, this.ImpliedOrder = he, this.type = 427948657;
    }
  }
  e.IfcRelInterferesElements = J3;
  class KM extends cR {
    constructor(w, v, N, x, G, j) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatingObject = G, this.RelatedObjects = j, this.type = 3268803585;
    }
  }
  e.IfcRelNests = KM;
  class jI extends cR {
    constructor(w, v, N, x, G, j) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatingElement = G, this.RelatedFeatureElement = j, this.type = 750771296;
    }
  }
  e.IfcRelProjectsElement = jI;
  class ow extends E0 {
    constructor(w, v, N, x, G, j) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatedElements = G, this.RelatingStructure = j, this.type = 1245217292;
    }
  }
  e.IfcRelReferencedInSpatialStructure = ow;
  class X3 extends E0 {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatingProcess = G, this.RelatedProcess = j, this.TimeLag = K, this.SequenceType = Q, this.UserDefinedSequenceType = he, this.type = 4122056220;
    }
  }
  e.IfcRelSequence = X3;
  class E$ extends E0 {
    constructor(w, v, N, x, G, j) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatingSystem = G, this.RelatedBuildings = j, this.type = 366585022;
    }
  }
  e.IfcRelServicesBuildings = E$;
  class l7 extends E0 {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatingSpace = G, this.RelatedBuildingElement = j, this.ConnectionGeometry = K, this.PhysicalOrVirtualBoundary = Q, this.InternalOrExternalBoundary = he, this.type = 3451746338;
    }
  }
  e.IfcRelSpaceBoundary = l7;
  class a7 extends l7 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatingSpace = G, this.RelatedBuildingElement = j, this.ConnectionGeometry = K, this.PhysicalOrVirtualBoundary = Q, this.InternalOrExternalBoundary = he, this.ParentBoundary = Ze, this.type = 3523091289;
    }
  }
  e.IfcRelSpaceBoundary1stLevel = a7;
  class g$ extends a7 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi) {
      super(w, v, N, x, G, j, K, Q, he, Ze), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatingSpace = G, this.RelatedBuildingElement = j, this.ConnectionGeometry = K, this.PhysicalOrVirtualBoundary = Q, this.InternalOrExternalBoundary = he, this.ParentBoundary = Ze, this.CorrespondingBoundary = pi, this.type = 1521410863;
    }
  }
  e.IfcRelSpaceBoundary2ndLevel = g$;
  class Ju extends cR {
    constructor(w, v, N, x, G, j) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatingBuildingElement = G, this.RelatedOpeningElement = j, this.type = 1401173127;
    }
  }
  e.IfcRelVoidsElement = Ju;
  class w$ extends EG {
    constructor(w, v, N, x) {
      super(w, v, N), this.Transition = w, this.SameSense = v, this.ParentCurve = N, this.ParamLength = x, this.type = 816062949;
    }
  }
  e.IfcReparametrisedCompositeCurveSegment = w$;
  class MG extends K3 {
    constructor(w, v, N, x, G, j, K) {
      super(w, v, N, x, G), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.Identification = j, this.LongDescription = K, this.type = 2914609552;
    }
  }
  e.IfcResource = MG;
  class UG extends O6 {
    constructor(w, v, N, x) {
      super(w, v), this.SweptArea = w, this.Position = v, this.Axis = N, this.Angle = x, this.type = 1856042241;
    }
  }
  e.IfcRevolvedAreaSolid = UG;
  class T$ extends UG {
    constructor(w, v, N, x, G) {
      super(w, v, N, x), this.SweptArea = w, this.Position = v, this.Axis = N, this.Angle = x, this.EndSweptArea = G, this.type = 3243963512;
    }
  }
  e.IfcRevolvedAreaSolidTapered = T$;
  class ZM extends tS {
    constructor(w, v, N) {
      super(w), this.Position = w, this.Height = v, this.BottomRadius = N, this.type = 4158566097;
    }
  }
  e.IfcRightCircularCone = ZM;
  class R$ extends tS {
    constructor(w, v, N) {
      super(w), this.Position = w, this.Height = v, this.Radius = N, this.type = 3626867408;
    }
  }
  e.IfcRightCircularCylinder = R$;
  class BG extends zM {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.TemplateType = G, this.PrimaryMeasureType = j, this.SecondaryMeasureType = K, this.Enumerators = Q, this.PrimaryUnit = he, this.SecondaryUnit = Ze, this.Expression = pi, this.AccessState = Ki, this.type = 3663146110;
    }
  }
  e.IfcSimplePropertyTemplate = BG;
  class U6 extends TE {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G, j, K), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.LongName = Q, this.type = 1412071761;
    }
  }
  e.IfcSpatialElement = U6;
  class B6 extends x6 {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.type = 710998568;
    }
  }
  e.IfcSpatialElementType = B6;
  class cm extends U6 {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.LongName = Q, this.CompositionType = he, this.type = 2706606064;
    }
  }
  e.IfcSpatialStructureElement = cm;
  class u7 extends B6 {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.type = 3893378262;
    }
  }
  e.IfcSpatialStructureElementType = u7;
  class J4 extends U6 {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.LongName = Q, this.PredefinedType = he, this.type = 463610769;
    }
  }
  e.IfcSpatialZone = J4;
  class oS extends B6 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.LongName = pi, this.type = 2481509218;
    }
  }
  e.IfcSpatialZoneType = oS;
  class v$ extends tS {
    constructor(w, v) {
      super(w), this.Position = w, this.Radius = v, this.type = 451544542;
    }
  }
  e.IfcSphere = v$;
  class d7 extends iS {
    constructor(w, v) {
      super(w), this.Position = w, this.Radius = v, this.type = 4015995234;
    }
  }
  e.IfcSphericalSurface = d7;
  class hR extends TE {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.AppliedLoad = Q, this.GlobalOrLocal = he, this.type = 3544373492;
    }
  }
  e.IfcStructuralActivity = hR;
  class F6 extends TE {
    constructor(w, v, N, x, G, j, K) {
      super(w, v, N, x, G, j, K), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.type = 3136571912;
    }
  }
  e.IfcStructuralItem = F6;
  class da extends F6 {
    constructor(w, v, N, x, G, j, K) {
      super(w, v, N, x, G, j, K), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.type = 530289379;
    }
  }
  e.IfcStructuralMember = da;
  class rS extends hR {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.AppliedLoad = Q, this.GlobalOrLocal = he, this.type = 3689010777;
    }
  }
  e.IfcStructuralReaction = rS;
  class FG extends da {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.PredefinedType = Q, this.Thickness = he, this.type = 3979015343;
    }
  }
  e.IfcStructuralSurfaceMember = FG;
  class A$ extends FG {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.PredefinedType = Q, this.Thickness = he, this.type = 2218152070;
    }
  }
  e.IfcStructuralSurfaceMemberVarying = A$;
  class S$ extends rS {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.AppliedLoad = Q, this.GlobalOrLocal = he, this.PredefinedType = Ze, this.type = 603775116;
    }
  }
  e.IfcStructuralSurfaceReaction = S$;
  class b$ extends Q4 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki) {
      super(w, v, N, x, G, j, K, Q, he, Ze, pi), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.Identification = K, this.LongDescription = Q, this.ResourceType = he, this.BaseCosts = Ze, this.BaseQuantity = pi, this.PredefinedType = Ki, this.type = 4095615324;
    }
  }
  e.IfcSubContractResourceType = b$;
  class RE extends am {
    constructor(w, v, N) {
      super(), this.Curve3D = w, this.AssociatedGeometry = v, this.MasterRepresentation = N, this.type = 699246055;
    }
  }
  e.IfcSurfaceCurve = RE;
  class N$ extends O6 {
    constructor(w, v, N, x, G, j) {
      super(w, v), this.SweptArea = w, this.Position = v, this.Directrix = N, this.StartParam = x, this.EndParam = G, this.ReferenceSurface = j, this.type = 2028607225;
    }
  }
  e.IfcSurfaceCurveSweptAreaSolid = N$;
  class Gc extends Vf {
    constructor(w, v, N, x) {
      super(w, v), this.SweptCurve = w, this.Position = v, this.ExtrudedDirection = N, this.Depth = x, this.type = 2809605785;
    }
  }
  e.IfcSurfaceOfLinearExtrusion = Gc;
  class QM extends Vf {
    constructor(w, v, N) {
      super(w, v), this.SweptCurve = w, this.Position = v, this.AxisPosition = N, this.type = 4124788165;
    }
  }
  e.IfcSurfaceOfRevolution = QM;
  class D$ extends FM {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 1580310250;
    }
  }
  e.IfcSystemFurnitureElementType = D$;
  class C$ extends s7 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki, Vn) {
      super(w, v, N, x, G, j, K), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.Identification = j, this.LongDescription = K, this.Status = Q, this.WorkMethod = he, this.IsMilestone = Ze, this.Priority = pi, this.TaskTime = Ki, this.PredefinedType = Vn, this.type = 3473067441;
    }
  }
  e.IfcTask = C$;
  class O$ extends $L {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.Identification = K, this.LongDescription = Q, this.ProcessType = he, this.PredefinedType = Ze, this.WorkMethod = pi, this.type = 3206491090;
    }
  }
  e.IfcTaskType = O$;
  class JM extends DM {
    constructor(w) {
      super(), this.Coordinates = w, this.type = 2387106220;
    }
  }
  e.IfcTessellatedFaceSet = JM;
  class HG extends iS {
    constructor(w, v, N) {
      super(w), this.Position = w, this.MajorRadius = v, this.MinorRadius = N, this.type = 1935646853;
    }
  }
  e.IfcToroidalSurface = HG;
  class L$ extends zf {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 2097647324;
    }
  }
  e.IfcTransportElementType = L$;
  class _$ extends JM {
    constructor(w, v, N, x, G) {
      super(w), this.Coordinates = w, this.Normals = v, this.Closed = N, this.CoordIndex = x, this.PnIndex = G, this.type = 2916149573;
    }
  }
  e.IfcTriangulatedFaceSet = _$;
  class x$ extends Z3 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki, Vn, ks, gr, Ro) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.LiningDepth = G, this.LiningThickness = j, this.TransomThickness = K, this.MullionThickness = Q, this.FirstTransomOffset = he, this.SecondTransomOffset = Ze, this.FirstMullionOffset = pi, this.SecondMullionOffset = Ki, this.ShapeAspectStyle = Vn, this.LiningOffset = ks, this.LiningToPanelOffsetX = gr, this.LiningToPanelOffsetY = Ro, this.type = 336235671;
    }
  }
  e.IfcWindowLiningProperties = x$;
  class P$ extends Z3 {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.OperationType = G, this.PanelPosition = j, this.FrameDepth = K, this.FrameThickness = Q, this.ShapeAspectStyle = he, this.type = 512836454;
    }
  }
  e.IfcWindowPanelProperties = P$;
  class GG extends K3 {
    constructor(w, v, N, x, G, j) {
      super(w, v, N, x, G), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.TheActor = j, this.type = 2296667514;
    }
  }
  e.IfcActor = GG;
  class kG extends i7 {
    constructor(w) {
      super(w), this.Outer = w, this.type = 1635779807;
    }
  }
  e.IfcAdvancedBrep = kG;
  class lS extends kG {
    constructor(w, v) {
      super(w), this.Outer = w, this.Voids = v, this.type = 2603310189;
    }
  }
  e.IfcAdvancedBrepWithVoids = lS;
  class H6 extends TE {
    constructor(w, v, N, x, G, j, K) {
      super(w, v, N, x, G, j, K), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.type = 1674181508;
    }
  }
  e.IfcAnnotation = H6;
  class VG extends oR {
    constructor(w, v, N, x, G, j, K) {
      super(), this.UDegree = w, this.VDegree = v, this.ControlPointsList = N, this.SurfaceForm = x, this.UClosed = G, this.VClosed = j, this.SelfIntersect = K, this.type = 2887950389;
    }
  }
  e.IfcBSplineSurface = VG;
  class zG extends VG {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki) {
      super(w, v, N, x, G, j, K), this.UDegree = w, this.VDegree = v, this.ControlPointsList = N, this.SurfaceForm = x, this.UClosed = G, this.VClosed = j, this.SelfIntersect = K, this.UMultiplicities = Q, this.VMultiplicities = he, this.UKnots = Ze, this.VKnots = pi, this.KnotSpec = Ki, this.type = 167062518;
    }
  }
  e.IfcBSplineSurfaceWithKnots = zG;
  class M$ extends tS {
    constructor(w, v, N, x) {
      super(w), this.Position = w, this.XLength = v, this.YLength = N, this.ZLength = x, this.type = 1334484129;
    }
  }
  e.IfcBlock = M$;
  class U$ extends JL {
    constructor(w, v, N) {
      super(w, v, N), this.Operator = w, this.FirstOperand = v, this.SecondOperand = N, this.type = 3649129432;
    }
  }
  e.IfcBooleanClippingResult = U$;
  class aS extends am {
    constructor() {
      super(), this.type = 1260505505;
    }
  }
  e.IfcBoundedCurve = aS;
  class B$ extends cm {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.LongName = Q, this.CompositionType = he, this.ElevationOfRefHeight = Ze, this.ElevationOfTerrain = pi, this.BuildingAddress = Ki, this.type = 4031249490;
    }
  }
  e.IfcBuilding = B$;
  class ql extends zf {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.type = 1950629157;
    }
  }
  e.IfcBuildingElementType = ql;
  class jG extends cm {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.LongName = Q, this.CompositionType = he, this.Elevation = Ze, this.type = 3124254112;
    }
  }
  e.IfcBuildingStorey = jG;
  class F$ extends ql {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 2197970202;
    }
  }
  e.IfcChimneyType = F$;
  class H$ extends Ah {
    constructor(w, v, N, x, G) {
      super(w, v, N, x), this.ProfileType = w, this.ProfileName = v, this.Position = N, this.Radius = x, this.WallThickness = G, this.type = 2937912522;
    }
  }
  e.IfcCircleHollowProfileDef = H$;
  class G$ extends zf {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.type = 3893394355;
    }
  }
  e.IfcCivilElementType = G$;
  class k$ extends ql {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 300633059;
    }
  }
  e.IfcColumnType = k$;
  class V$ extends zM {
    constructor(w, v, N, x, G, j, K) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.UsageName = G, this.TemplateType = j, this.HasPropertyTemplates = K, this.type = 3875453745;
    }
  }
  e.IfcComplexPropertyTemplate = V$;
  class XM extends aS {
    constructor(w, v) {
      super(), this.Segments = w, this.SelfIntersect = v, this.type = 3732776249;
    }
  }
  e.IfcCompositeCurve = XM;
  class e9 extends XM {
    constructor(w, v) {
      super(w, v), this.Segments = w, this.SelfIntersect = v, this.type = 15328376;
    }
  }
  e.IfcCompositeCurveOnSurface = e9;
  class t9 extends am {
    constructor(w) {
      super(), this.Position = w, this.type = 2510884976;
    }
  }
  e.IfcConic = t9;
  class z$ extends Q4 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki) {
      super(w, v, N, x, G, j, K, Q, he, Ze, pi), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.Identification = K, this.LongDescription = Q, this.ResourceType = he, this.BaseCosts = Ze, this.BaseQuantity = pi, this.PredefinedType = Ki, this.type = 2185764099;
    }
  }
  e.IfcConstructionEquipmentResourceType = z$;
  class j$ extends Q4 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki) {
      super(w, v, N, x, G, j, K, Q, he, Ze, pi), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.Identification = K, this.LongDescription = Q, this.ResourceType = he, this.BaseCosts = Ze, this.BaseQuantity = pi, this.PredefinedType = Ki, this.type = 4105962743;
    }
  }
  e.IfcConstructionMaterialResourceType = j$;
  class WG extends Q4 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki) {
      super(w, v, N, x, G, j, K, Q, he, Ze, pi), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.Identification = K, this.LongDescription = Q, this.ResourceType = he, this.BaseCosts = Ze, this.BaseQuantity = pi, this.PredefinedType = Ki, this.type = 1525564444;
    }
  }
  e.IfcConstructionProductResourceType = WG;
  class X4 extends MG {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.Identification = j, this.LongDescription = K, this.Usage = Q, this.BaseCosts = he, this.BaseQuantity = Ze, this.type = 2559216714;
    }
  }
  e.IfcConstructionResource = X4;
  class rw extends K3 {
    constructor(w, v, N, x, G, j) {
      super(w, v, N, x, G), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.Identification = j, this.type = 3293443760;
    }
  }
  e.IfcControl = rw;
  class W$ extends rw {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.Identification = j, this.PredefinedType = K, this.CostValues = Q, this.CostQuantities = he, this.type = 3895139033;
    }
  }
  e.IfcCostItem = W$;
  class Y$ extends rw {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.Identification = j, this.PredefinedType = K, this.Status = Q, this.SubmittedOn = he, this.UpdateDate = Ze, this.type = 1419761937;
    }
  }
  e.IfcCostSchedule = Y$;
  class YG extends ql {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 1916426348;
    }
  }
  e.IfcCoveringType = YG;
  class q$ extends X4 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi) {
      super(w, v, N, x, G, j, K, Q, he, Ze), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.Identification = j, this.LongDescription = K, this.Usage = Q, this.BaseCosts = he, this.BaseQuantity = Ze, this.PredefinedType = pi, this.type = 3295246426;
    }
  }
  e.IfcCrewResource = q$;
  class $$ extends ql {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 1457835157;
    }
  }
  e.IfcCurtainWallType = $$;
  class K$ extends iS {
    constructor(w, v) {
      super(w), this.Position = w, this.Radius = v, this.type = 1213902940;
    }
  }
  e.IfcCylindricalSurface = K$;
  class uS extends zf {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.type = 3256556792;
    }
  }
  e.IfcDistributionElementType = uS;
  class hm extends uS {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.type = 3849074793;
    }
  }
  e.IfcDistributionFlowElementType = hm;
  class dS extends Z3 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki, Vn, ks, gr, Ro, ma) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.LiningDepth = G, this.LiningThickness = j, this.ThresholdDepth = K, this.ThresholdThickness = Q, this.TransomThickness = he, this.TransomOffset = Ze, this.LiningOffset = pi, this.ThresholdOffset = Ki, this.CasingThickness = Vn, this.CasingDepth = ks, this.ShapeAspectStyle = gr, this.LiningToPanelOffsetX = Ro, this.LiningToPanelOffsetY = ma, this.type = 2963535650;
    }
  }
  e.IfcDoorLiningProperties = dS;
  class G6 extends Z3 {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.PanelDepth = G, this.PanelOperation = j, this.PanelWidth = K, this.PanelPosition = Q, this.ShapeAspectStyle = he, this.type = 1714330368;
    }
  }
  e.IfcDoorPanelProperties = G6;
  class c7 extends ql {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki, Vn) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.OperationType = pi, this.ParameterTakesPrecedence = Ki, this.UserDefinedOperationType = Vn, this.type = 2323601079;
    }
  }
  e.IfcDoorType = c7;
  class Z$ extends AG {
    constructor(w) {
      super(w), this.Name = w, this.type = 445594917;
    }
  }
  e.IfcDraughtingPreDefinedColour = Z$;
  class qG extends n7 {
    constructor(w) {
      super(w), this.Name = w, this.type = 4006246654;
    }
  }
  e.IfcDraughtingPreDefinedCurveFont = qG;
  class ey extends TE {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G, j, K), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.type = 1758889154;
    }
  }
  e.IfcElement = ey;
  class eT extends ey {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.AssemblyPlace = he, this.PredefinedType = Ze, this.type = 4123344466;
    }
  }
  e.IfcElementAssembly = eT;
  class i9 extends zf {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 2397081782;
    }
  }
  e.IfcElementAssemblyType = i9;
  class lw extends ey {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.type = 1623761950;
    }
  }
  e.IfcElementComponent = lw;
  class vE extends zf {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.type = 2590856083;
    }
  }
  e.IfcElementComponentType = vE;
  class h7 extends t9 {
    constructor(w, v, N) {
      super(w), this.Position = w, this.SemiAxis1 = v, this.SemiAxis2 = N, this.type = 1704287377;
    }
  }
  e.IfcEllipse = h7;
  class $l extends hm {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.type = 2107101300;
    }
  }
  e.IfcEnergyConversionDeviceType = $l;
  class Q$ extends $l {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 132023988;
    }
  }
  e.IfcEngineType = Q$;
  class J$ extends $l {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 3174744832;
    }
  }
  e.IfcEvaporativeCoolerType = J$;
  class X$ extends $l {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 3390157468;
    }
  }
  e.IfcEvaporatorType = X$;
  class n9 extends s7 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi) {
      super(w, v, N, x, G, j, K), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.Identification = j, this.LongDescription = K, this.PredefinedType = Q, this.EventTriggerType = he, this.UserDefinedEventTriggerType = Ze, this.EventOccurenceTime = pi, this.type = 4148101412;
    }
  }
  e.IfcEvent = n9;
  class $G extends U6 {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.LongName = Q, this.type = 2853485674;
    }
  }
  e.IfcExternalSpatialStructureElement = $G;
  class KG extends i7 {
    constructor(w) {
      super(w), this.Outer = w, this.type = 807026263;
    }
  }
  e.IfcFacetedBrep = KG;
  class s9 extends KG {
    constructor(w, v) {
      super(w), this.Outer = w, this.Voids = v, this.type = 3737207727;
    }
  }
  e.IfcFacetedBrepWithVoids = s9;
  class eK extends lw {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 647756555;
    }
  }
  e.IfcFastener = eK;
  class tK extends vE {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 2489546625;
    }
  }
  e.IfcFastenerType = tK;
  class f7 extends ey {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.type = 2827207264;
    }
  }
  e.IfcFeatureElement = f7;
  class I7 extends f7 {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.type = 2143335405;
    }
  }
  e.IfcFeatureElementAddition = I7;
  class o9 extends f7 {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.type = 1287392070;
    }
  }
  e.IfcFeatureElementSubtraction = o9;
  class aw extends hm {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.type = 3907093117;
    }
  }
  e.IfcFlowControllerType = aw;
  class tT extends hm {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.type = 3198132628;
    }
  }
  e.IfcFlowFittingType = tT;
  class ZG extends aw {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 3815607619;
    }
  }
  e.IfcFlowMeterType = ZG;
  class p7 extends hm {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.type = 1482959167;
    }
  }
  e.IfcFlowMovingDeviceType = p7;
  class k6 extends hm {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.type = 1834744321;
    }
  }
  e.IfcFlowSegmentType = k6;
  class r9 extends hm {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.type = 1339347760;
    }
  }
  e.IfcFlowStorageDeviceType = r9;
  class w0 extends hm {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.type = 2297155007;
    }
  }
  e.IfcFlowTerminalType = w0;
  class V6 extends hm {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.type = 3009222698;
    }
  }
  e.IfcFlowTreatmentDeviceType = V6;
  class QG extends ql {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 1893162501;
    }
  }
  e.IfcFootingType = QG;
  class l9 extends ey {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.type = 263784265;
    }
  }
  e.IfcFurnishingElement = l9;
  class iK extends l9 {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 1509553395;
    }
  }
  e.IfcFurniture = iK;
  class JG extends ey {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 3493046030;
    }
  }
  e.IfcGeographicElement = JG;
  class XG extends TE {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi) {
      super(w, v, N, x, G, j, K), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.UAxes = Q, this.VAxes = he, this.WAxes = Ze, this.PredefinedType = pi, this.type = 3009204131;
    }
  }
  e.IfcGrid = XG;
  class cS extends K3 {
    constructor(w, v, N, x, G) {
      super(w, v, N, x, G), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.type = 2706460486;
    }
  }
  e.IfcGroup = cS;
  class nK extends $l {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 1251058090;
    }
  }
  e.IfcHeatExchangerType = nK;
  class hS extends $l {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 1806887404;
    }
  }
  e.IfcHumidifierType = hS;
  class sK extends aS {
    constructor(w, v, N) {
      super(), this.Points = w, this.Segments = v, this.SelfIntersect = N, this.type = 2571569899;
    }
  }
  e.IfcIndexedPolyCurve = sK;
  class hr extends V6 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 3946677679;
    }
  }
  e.IfcInterceptorType = hr;
  class oK extends RE {
    constructor(w, v, N) {
      super(w, v, N), this.Curve3D = w, this.AssociatedGeometry = v, this.MasterRepresentation = N, this.type = 3113134337;
    }
  }
  e.IfcIntersectionCurve = oK;
  class ek extends cS {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi) {
      super(w, v, N, x, G), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.PredefinedType = j, this.Jurisdiction = K, this.ResponsiblePersons = Q, this.LastUpdateDate = he, this.CurrentValue = Ze, this.OriginalValue = pi, this.type = 2391368822;
    }
  }
  e.IfcInventory = ek;
  class rK extends tT {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 4288270099;
    }
  }
  e.IfcJunctionBoxType = rK;
  class ca extends X4 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi) {
      super(w, v, N, x, G, j, K, Q, he, Ze), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.Identification = j, this.LongDescription = K, this.Usage = Q, this.BaseCosts = he, this.BaseQuantity = Ze, this.PredefinedType = pi, this.type = 3827777499;
    }
  }
  e.IfcLaborResource = ca;
  class a9 extends w0 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 1051575348;
    }
  }
  e.IfcLampType = a9;
  class lK extends w0 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 1161773419;
    }
  }
  e.IfcLightFixtureType = lK;
  class m7 extends lw {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.NominalDiameter = he, this.NominalLength = Ze, this.PredefinedType = pi, this.type = 377706215;
    }
  }
  e.IfcMechanicalFastener = m7;
  class tk extends vE {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.NominalDiameter = pi, this.NominalLength = Ki, this.type = 2108223431;
    }
  }
  e.IfcMechanicalFastenerType = tk;
  class u9 extends w0 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 1114901282;
    }
  }
  e.IfcMedicalDeviceType = u9;
  class aK extends ql {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 3181161470;
    }
  }
  e.IfcMemberType = aK;
  class uK extends $l {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 977012517;
    }
  }
  e.IfcMotorConnectionType = uK;
  class dK extends GG {
    constructor(w, v, N, x, G, j, K) {
      super(w, v, N, x, G, j), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.TheActor = j, this.PredefinedType = K, this.type = 4143007308;
    }
  }
  e.IfcOccupant = dK;
  class iT extends o9 {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 3588315303;
    }
  }
  e.IfcOpeningElement = iT;
  class uw extends iT {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 3079942009;
    }
  }
  e.IfcOpeningStandardCase = uw;
  class cK extends w0 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 2837617999;
    }
  }
  e.IfcOutletType = cK;
  class hK extends rw {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G, j), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.Identification = j, this.LifeCyclePhase = K, this.PredefinedType = Q, this.type = 2382730787;
    }
  }
  e.IfcPerformanceHistory = hK;
  class fK extends Z3 {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.OperationType = G, this.PanelPosition = j, this.FrameDepth = K, this.FrameThickness = Q, this.ShapeAspectStyle = he, this.type = 3566463478;
    }
  }
  e.IfcPermeableCoveringProperties = fK;
  class IK extends rw {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.Identification = j, this.PredefinedType = K, this.Status = Q, this.LongDescription = he, this.type = 3327091369;
    }
  }
  e.IfcPermit = IK;
  class pK extends ql {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 1158309216;
    }
  }
  e.IfcPileType = pK;
  class mK extends tT {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 804291784;
    }
  }
  e.IfcPipeFittingType = mK;
  class yK extends k6 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 4231323485;
    }
  }
  e.IfcPipeSegmentType = yK;
  class EK extends ql {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 4017108033;
    }
  }
  e.IfcPlateType = EK;
  class d9 extends JM {
    constructor(w, v, N, x) {
      super(w), this.Coordinates = w, this.Closed = v, this.Faces = N, this.PnIndex = x, this.type = 2839578677;
    }
  }
  e.IfcPolygonalFaceSet = d9;
  class gK extends aS {
    constructor(w) {
      super(), this.Points = w, this.type = 3724593414;
    }
  }
  e.IfcPolyline = gK;
  class y7 extends TE {
    constructor(w, v, N, x, G, j, K) {
      super(w, v, N, x, G, j, K), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.type = 3740093272;
    }
  }
  e.IfcPort = y7;
  class AE extends s7 {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G, j, K), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.Identification = j, this.LongDescription = K, this.PredefinedType = Q, this.type = 2744685151;
    }
  }
  e.IfcProcedure = AE;
  class wK extends rw {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.Identification = j, this.PredefinedType = K, this.Status = Q, this.LongDescription = he, this.type = 2904328755;
    }
  }
  e.IfcProjectOrder = wK;
  class TK extends I7 {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 3651124850;
    }
  }
  e.IfcProjectionElement = TK;
  class RK extends aw {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 1842657554;
    }
  }
  e.IfcProtectiveDeviceType = RK;
  class ik extends p7 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 2250791053;
    }
  }
  e.IfcPumpType = ik;
  class vK extends ql {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 2893384427;
    }
  }
  e.IfcRailingType = vK;
  class kc extends ql {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 2324767716;
    }
  }
  e.IfcRampFlightType = kc;
  class c9 extends ql {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 1469900589;
    }
  }
  e.IfcRampType = c9;
  class SE extends zG {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki, Vn) {
      super(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki), this.UDegree = w, this.VDegree = v, this.ControlPointsList = N, this.SurfaceForm = x, this.UClosed = G, this.VClosed = j, this.SelfIntersect = K, this.UMultiplicities = Q, this.VMultiplicities = he, this.UKnots = Ze, this.VKnots = pi, this.KnotSpec = Ki, this.WeightsData = Vn, this.type = 683857671;
    }
  }
  e.IfcRationalBSplineSurfaceWithKnots = SE;
  class jf extends lw {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.SteelGrade = he, this.type = 3027567501;
    }
  }
  e.IfcReinforcingElement = jf;
  class Wf extends vE {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.type = 964333572;
    }
  }
  e.IfcReinforcingElementType = Wf;
  class AK extends jf {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki, Vn, ks, gr, Ro, ma, Lu) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.SteelGrade = he, this.MeshLength = Ze, this.MeshWidth = pi, this.LongitudinalBarNominalDiameter = Ki, this.TransverseBarNominalDiameter = Vn, this.LongitudinalBarCrossSectionArea = ks, this.TransverseBarCrossSectionArea = gr, this.LongitudinalBarSpacing = Ro, this.TransverseBarSpacing = ma, this.PredefinedType = Lu, this.type = 2320036040;
    }
  }
  e.IfcReinforcingMesh = AK;
  class ha extends Wf {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki, Vn, ks, gr, Ro, ma, Lu, _T, QE) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.MeshLength = pi, this.MeshWidth = Ki, this.LongitudinalBarNominalDiameter = Vn, this.TransverseBarNominalDiameter = ks, this.LongitudinalBarCrossSectionArea = gr, this.TransverseBarCrossSectionArea = Ro, this.LongitudinalBarSpacing = ma, this.TransverseBarSpacing = Lu, this.BendingShapeCode = _T, this.BendingParameters = QE, this.type = 2310774935;
    }
  }
  e.IfcReinforcingMeshType = ha;
  class SK extends cR {
    constructor(w, v, N, x, G, j) {
      super(w, v, N, x), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.RelatingObject = G, this.RelatedObjects = j, this.type = 160246688;
    }
  }
  e.IfcRelAggregates = SK;
  class h9 extends ql {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 2781568857;
    }
  }
  e.IfcRoofType = h9;
  class bK extends w0 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 1768891740;
    }
  }
  e.IfcSanitaryTerminalType = bK;
  class NK extends RE {
    constructor(w, v, N) {
      super(w, v, N), this.Curve3D = w, this.AssociatedGeometry = v, this.MasterRepresentation = N, this.type = 2157484638;
    }
  }
  e.IfcSeamCurve = NK;
  class nk extends ql {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 4074543187;
    }
  }
  e.IfcShadingDeviceType = nk;
  class sk extends cm {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki, Vn, ks) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.LongName = Q, this.CompositionType = he, this.RefLatitude = Ze, this.RefLongitude = pi, this.RefElevation = Ki, this.LandTitleNumber = Vn, this.SiteAddress = ks, this.type = 4097777520;
    }
  }
  e.IfcSite = sk;
  class DK extends ql {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 2533589738;
    }
  }
  e.IfcSlabType = DK;
  class fS extends $l {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 1072016465;
    }
  }
  e.IfcSolarDeviceType = fS;
  class IS extends cm {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.LongName = Q, this.CompositionType = he, this.PredefinedType = Ze, this.ElevationWithFlooring = pi, this.type = 3856911033;
    }
  }
  e.IfcSpace = IS;
  class CK extends w0 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 1305183839;
    }
  }
  e.IfcSpaceHeaterType = CK;
  class OK extends u7 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.LongName = pi, this.type = 3812236995;
    }
  }
  e.IfcSpaceType = OK;
  class LK extends w0 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 3112655638;
    }
  }
  e.IfcStackTerminalType = LK;
  class E7 extends ql {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 1039846685;
    }
  }
  e.IfcStairFlightType = E7;
  class ok extends ql {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 338393293;
    }
  }
  e.IfcStairType = ok;
  class nT extends hR {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.AppliedLoad = Q, this.GlobalOrLocal = he, this.DestabilizingLoad = Ze, this.type = 682877961;
    }
  }
  e.IfcStructuralAction = nT;
  class WI extends F6 {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G, j, K), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.AppliedCondition = Q, this.type = 1179482911;
    }
  }
  e.IfcStructuralConnection = WI;
  class fR extends nT {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki) {
      super(w, v, N, x, G, j, K, Q, he, Ze), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.AppliedLoad = Q, this.GlobalOrLocal = he, this.DestabilizingLoad = Ze, this.ProjectedOrTrue = pi, this.PredefinedType = Ki, this.type = 1004757350;
    }
  }
  e.IfcStructuralCurveAction = fR;
  class _K extends WI {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.AppliedCondition = Q, this.Axis = he, this.type = 4243806635;
    }
  }
  e.IfcStructuralCurveConnection = _K;
  class z6 extends da {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.PredefinedType = Q, this.Axis = he, this.type = 214636428;
    }
  }
  e.IfcStructuralCurveMember = z6;
  class pS extends z6 {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.PredefinedType = Q, this.Axis = he, this.type = 2445595289;
    }
  }
  e.IfcStructuralCurveMemberVarying = pS;
  class f9 extends rS {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.AppliedLoad = Q, this.GlobalOrLocal = he, this.PredefinedType = Ze, this.type = 2757150158;
    }
  }
  e.IfcStructuralCurveReaction = f9;
  class Vc extends fR {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki) {
      super(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.AppliedLoad = Q, this.GlobalOrLocal = he, this.DestabilizingLoad = Ze, this.ProjectedOrTrue = pi, this.PredefinedType = Ki, this.type = 1807405624;
    }
  }
  e.IfcStructuralLinearAction = Vc;
  class mS extends cS {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.PredefinedType = j, this.ActionType = K, this.ActionSource = Q, this.Coefficient = he, this.Purpose = Ze, this.type = 1252848954;
    }
  }
  e.IfcStructuralLoadGroup = mS;
  class xK extends nT {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he, Ze), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.AppliedLoad = Q, this.GlobalOrLocal = he, this.DestabilizingLoad = Ze, this.type = 2082059205;
    }
  }
  e.IfcStructuralPointAction = xK;
  class I9 extends WI {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.AppliedCondition = Q, this.ConditionCoordinateSystem = he, this.type = 734778138;
    }
  }
  e.IfcStructuralPointConnection = I9;
  class PK extends rS {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.AppliedLoad = Q, this.GlobalOrLocal = he, this.type = 1235345126;
    }
  }
  e.IfcStructuralPointReaction = PK;
  class MK extends cS {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.TheoryType = j, this.ResultForLoadGroup = K, this.IsLinear = Q, this.type = 2986769608;
    }
  }
  e.IfcStructuralResultGroup = MK;
  class g7 extends nT {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki) {
      super(w, v, N, x, G, j, K, Q, he, Ze), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.AppliedLoad = Q, this.GlobalOrLocal = he, this.DestabilizingLoad = Ze, this.ProjectedOrTrue = pi, this.PredefinedType = Ki, this.type = 3657597509;
    }
  }
  e.IfcStructuralSurfaceAction = g7;
  class UK extends WI {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.AppliedCondition = Q, this.type = 1975003073;
    }
  }
  e.IfcStructuralSurfaceConnection = UK;
  class BK extends X4 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi) {
      super(w, v, N, x, G, j, K, Q, he, Ze), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.Identification = j, this.LongDescription = K, this.Usage = Q, this.BaseCosts = he, this.BaseQuantity = Ze, this.PredefinedType = pi, this.type = 148013059;
    }
  }
  e.IfcSubContractResource = BK;
  class bE extends f7 {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 3101698114;
    }
  }
  e.IfcSurfaceFeature = bE;
  class FK extends aw {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 2315554128;
    }
  }
  e.IfcSwitchingDeviceType = FK;
  class j6 extends cS {
    constructor(w, v, N, x, G) {
      super(w, v, N, x, G), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.type = 2254336722;
    }
  }
  e.IfcSystem = j6;
  class HK extends l9 {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 413509423;
    }
  }
  e.IfcSystemFurnitureElement = HK;
  class GK extends r9 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 5716631;
    }
  }
  e.IfcTankType = GK;
  class kK extends jf {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki, Vn, ks, gr, Ro, ma) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.SteelGrade = he, this.PredefinedType = Ze, this.NominalDiameter = pi, this.CrossSectionArea = Ki, this.TensionForce = Vn, this.PreStress = ks, this.FrictionCoefficient = gr, this.AnchorageSlip = Ro, this.MinCurvatureRadius = ma, this.type = 3824725483;
    }
  }
  e.IfcTendon = kK;
  class VK extends jf {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.SteelGrade = he, this.PredefinedType = Ze, this.type = 2347447852;
    }
  }
  e.IfcTendonAnchor = VK;
  class zK extends Wf {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 3081323446;
    }
  }
  e.IfcTendonAnchorType = zK;
  class jK extends Wf {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki, Vn) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.NominalDiameter = pi, this.CrossSectionArea = Ki, this.SheathDiameter = Vn, this.type = 2415094496;
    }
  }
  e.IfcTendonType = jK;
  class WK extends $l {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 1692211062;
    }
  }
  e.IfcTransformerType = WK;
  class YK extends ey {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 1620046519;
    }
  }
  e.IfcTransportElement = YK;
  class qK extends aS {
    constructor(w, v, N, x, G) {
      super(), this.BasisCurve = w, this.Trim1 = v, this.Trim2 = N, this.SenseAgreement = x, this.MasterRepresentation = G, this.type = 3593883385;
    }
  }
  e.IfcTrimmedCurve = qK;
  class rk extends $l {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 1600972822;
    }
  }
  e.IfcTubeBundleType = rk;
  class $K extends $l {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 1911125066;
    }
  }
  e.IfcUnitaryEquipmentType = $K;
  class W6 extends aw {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 728799441;
    }
  }
  e.IfcValveType = W6;
  class KK extends lw {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 2391383451;
    }
  }
  e.IfcVibrationIsolator = KK;
  class ZK extends vE {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 3313531582;
    }
  }
  e.IfcVibrationIsolatorType = ZK;
  class QK extends ey {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.type = 2769231204;
    }
  }
  e.IfcVirtualElement = QK;
  class JK extends o9 {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 926996030;
    }
  }
  e.IfcVoidingFeature = JK;
  class XK extends ql {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 1898987631;
    }
  }
  e.IfcWallType = XK;
  class eZ extends w0 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 1133259667;
    }
  }
  e.IfcWasteTerminalType = eZ;
  class tZ extends ql {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki, Vn) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.PartitioningType = pi, this.ParameterTakesPrecedence = Ki, this.UserDefinedPartitioningType = Vn, this.type = 4009809668;
    }
  }
  e.IfcWindowType = tZ;
  class iZ extends rw {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.Identification = j, this.WorkingTimes = K, this.ExceptionTimes = Q, this.PredefinedType = he, this.type = 4088093105;
    }
  }
  e.IfcWorkCalendar = iZ;
  class p9 extends rw {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki, Vn) {
      super(w, v, N, x, G, j), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.Identification = j, this.CreationDate = K, this.Creators = Q, this.Purpose = he, this.Duration = Ze, this.TotalFloat = pi, this.StartTime = Ki, this.FinishTime = Vn, this.type = 1028945134;
    }
  }
  e.IfcWorkControl = p9;
  class Dr extends p9 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki, Vn, ks) {
      super(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki, Vn), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.Identification = j, this.CreationDate = K, this.Creators = Q, this.Purpose = he, this.Duration = Ze, this.TotalFloat = pi, this.StartTime = Ki, this.FinishTime = Vn, this.PredefinedType = ks, this.type = 4218914973;
    }
  }
  e.IfcWorkPlan = Dr;
  class IR extends p9 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki, Vn, ks) {
      super(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki, Vn), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.Identification = j, this.CreationDate = K, this.Creators = Q, this.Purpose = he, this.Duration = Ze, this.TotalFloat = pi, this.StartTime = Ki, this.FinishTime = Vn, this.PredefinedType = ks, this.type = 3342526732;
    }
  }
  e.IfcWorkSchedule = IR;
  class dw extends j6 {
    constructor(w, v, N, x, G, j) {
      super(w, v, N, x, G), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.LongName = j, this.type = 1033361043;
    }
  }
  e.IfcZone = dw;
  class pR extends rw {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.Identification = j, this.PredefinedType = K, this.Status = Q, this.LongDescription = he, this.type = 3821786052;
    }
  }
  e.IfcActionRequest = pR;
  class w7 extends aw {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 1411407467;
    }
  }
  e.IfcAirTerminalBoxType = w7;
  class mR extends w0 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 3352864051;
    }
  }
  e.IfcAirTerminalType = mR;
  class ty extends $l {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 1871374353;
    }
  }
  e.IfcAirToAirHeatRecoveryType = ty;
  class YI extends cS {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki, Vn, ks) {
      super(w, v, N, x, G), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.Identification = j, this.OriginalValue = K, this.CurrentValue = Q, this.TotalReplacementCost = he, this.Owner = Ze, this.User = pi, this.ResponsiblePerson = Ki, this.IncorporationDate = Vn, this.DepreciatedValue = ks, this.type = 3460190687;
    }
  }
  e.IfcAsset = YI;
  class NE extends w0 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 1532957894;
    }
  }
  e.IfcAudioVisualApplianceType = NE;
  class sT extends aS {
    constructor(w, v, N, x, G) {
      super(), this.Degree = w, this.ControlPointsList = v, this.CurveForm = N, this.ClosedCurve = x, this.SelfIntersect = G, this.type = 1967976161;
    }
  }
  e.IfcBSplineCurve = sT;
  class cw extends sT {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G), this.Degree = w, this.ControlPointsList = v, this.CurveForm = N, this.ClosedCurve = x, this.SelfIntersect = G, this.KnotMultiplicities = j, this.Knots = K, this.KnotSpec = Q, this.type = 2461110595;
    }
  }
  e.IfcBSplineCurveWithKnots = cw;
  class yS extends ql {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 819618141;
    }
  }
  e.IfcBeamType = yS;
  class Y6 extends $l {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 231477066;
    }
  }
  e.IfcBoilerType = Y6;
  class hw extends e9 {
    constructor(w, v) {
      super(w, v), this.Segments = w, this.SelfIntersect = v, this.type = 1136057603;
    }
  }
  e.IfcBoundaryCurve = hw;
  class Cr extends ey {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.type = 3299480353;
    }
  }
  e.IfcBuildingElement = Cr;
  class fw extends lw {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 2979338954;
    }
  }
  e.IfcBuildingElementPart = fw;
  class Iw extends vE {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 39481116;
    }
  }
  e.IfcBuildingElementPartType = Iw;
  class q6 extends Cr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 1095909175;
    }
  }
  e.IfcBuildingElementProxy = q6;
  class T7 extends ql {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 1909888760;
    }
  }
  e.IfcBuildingElementProxyType = T7;
  class oT extends j6 {
    constructor(w, v, N, x, G, j, K) {
      super(w, v, N, x, G), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.PredefinedType = j, this.LongName = K, this.type = 1177604601;
    }
  }
  e.IfcBuildingSystem = oT;
  class rT extends $l {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 2188180465;
    }
  }
  e.IfcBurnerType = rT;
  class ES extends tT {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 395041908;
    }
  }
  e.IfcCableCarrierFittingType = ES;
  class lT extends k6 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 3293546465;
    }
  }
  e.IfcCableCarrierSegmentType = lT;
  class yR extends tT {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 2674252688;
    }
  }
  e.IfcCableFittingType = yR;
  class DE extends k6 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 1285652485;
    }
  }
  e.IfcCableSegmentType = DE;
  class $6 extends $l {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 2951183804;
    }
  }
  e.IfcChillerType = $6;
  class Xu extends Cr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 3296154744;
    }
  }
  e.IfcChimney = Xu;
  class CE extends t9 {
    constructor(w, v) {
      super(w), this.Position = w, this.Radius = v, this.type = 2611217952;
    }
  }
  e.IfcCircle = CE;
  class gS extends ey {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.type = 1677625105;
    }
  }
  e.IfcCivilElement = gS;
  class ER extends $l {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 2301859152;
    }
  }
  e.IfcCoilType = ER;
  class T0 extends Cr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 843113511;
    }
  }
  e.IfcColumn = T0;
  class iy extends T0 {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 905975707;
    }
  }
  e.IfcColumnStandardCase = iy;
  class gR extends w0 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 400855858;
    }
  }
  e.IfcCommunicationsApplianceType = gR;
  class ny extends p7 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 3850581409;
    }
  }
  e.IfcCompressorType = ny;
  class fm extends $l {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 2816379211;
    }
  }
  e.IfcCondenserType = fm;
  class fn extends X4 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi) {
      super(w, v, N, x, G, j, K, Q, he, Ze), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.Identification = j, this.LongDescription = K, this.Usage = Q, this.BaseCosts = he, this.BaseQuantity = Ze, this.PredefinedType = pi, this.type = 3898045240;
    }
  }
  e.IfcConstructionEquipmentResource = fn;
  class R7 extends X4 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi) {
      super(w, v, N, x, G, j, K, Q, he, Ze), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.Identification = j, this.LongDescription = K, this.Usage = Q, this.BaseCosts = he, this.BaseQuantity = Ze, this.PredefinedType = pi, this.type = 1060000209;
    }
  }
  e.IfcConstructionMaterialResource = R7;
  class Sh extends X4 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi) {
      super(w, v, N, x, G, j, K, Q, he, Ze), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.Identification = j, this.LongDescription = K, this.Usage = Q, this.BaseCosts = he, this.BaseQuantity = Ze, this.PredefinedType = pi, this.type = 488727124;
    }
  }
  e.IfcConstructionProductResource = Sh;
  class wR extends $l {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 335055490;
    }
  }
  e.IfcCooledBeamType = wR;
  class ms extends $l {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 2954562838;
    }
  }
  e.IfcCoolingTowerType = ms;
  class v7 extends Cr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 1973544240;
    }
  }
  e.IfcCovering = v7;
  class A7 extends Cr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 3495092785;
    }
  }
  e.IfcCurtainWall = A7;
  class Im extends aw {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 3961806047;
    }
  }
  e.IfcDamperType = Im;
  class aT extends lw {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 1335981549;
    }
  }
  e.IfcDiscreteAccessory = aT;
  class TR extends vE {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 2635815018;
    }
  }
  e.IfcDiscreteAccessoryType = TR;
  class OE extends hm {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 1599208980;
    }
  }
  e.IfcDistributionChamberElementType = OE;
  class qI extends uS {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.type = 2063403501;
    }
  }
  e.IfcDistributionControlElementType = qI;
  class $I extends ey {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.type = 1945004755;
    }
  }
  e.IfcDistributionElement = $I;
  class Or extends $I {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.type = 3040386961;
    }
  }
  e.IfcDistributionFlowElement = Or;
  class sy extends y7 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.FlowDirection = Q, this.PredefinedType = he, this.SystemType = Ze, this.type = 3041715199;
    }
  }
  e.IfcDistributionPort = sy;
  class RR extends j6 {
    constructor(w, v, N, x, G, j, K) {
      super(w, v, N, x, G), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.LongName = j, this.PredefinedType = K, this.type = 3205830791;
    }
  }
  e.IfcDistributionSystem = RR;
  class uT extends Cr {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki, Vn) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.OverallHeight = he, this.OverallWidth = Ze, this.PredefinedType = pi, this.OperationType = Ki, this.UserDefinedOperationType = Vn, this.type = 395920057;
    }
  }
  e.IfcDoor = uT;
  class zr extends uT {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki, Vn) {
      super(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki, Vn), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.OverallHeight = he, this.OverallWidth = Ze, this.PredefinedType = pi, this.OperationType = Ki, this.UserDefinedOperationType = Vn, this.type = 3242481149;
    }
  }
  e.IfcDoorStandardCase = zr;
  class K6 extends tT {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 869906466;
    }
  }
  e.IfcDuctFittingType = K6;
  class KI extends k6 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 3760055223;
    }
  }
  e.IfcDuctSegmentType = KI;
  class pw extends V6 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 2030761528;
    }
  }
  e.IfcDuctSilencerType = pw;
  class S7 extends w0 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 663422040;
    }
  }
  e.IfcElectricApplianceType = S7;
  class vR extends aw {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 2417008758;
    }
  }
  e.IfcElectricDistributionBoardType = vR;
  class pm extends r9 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 3277789161;
    }
  }
  e.IfcElectricFlowStorageDeviceType = pm;
  class LE extends $l {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 1534661035;
    }
  }
  e.IfcElectricGeneratorType = LE;
  class Yf extends $l {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 1217240411;
    }
  }
  e.IfcElectricMotorType = Yf;
  class Z6 extends aw {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 712377611;
    }
  }
  e.IfcElectricTimeControlType = Z6;
  class Lr extends Or {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.type = 1658829314;
    }
  }
  e.IfcEnergyConversionDevice = Lr;
  class _E extends Lr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 2814081492;
    }
  }
  e.IfcEngine = _E;
  class ZI extends Lr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 3747195512;
    }
  }
  e.IfcEvaporativeCooler = ZI;
  class mw extends Lr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 484807127;
    }
  }
  e.IfcEvaporator = mw;
  class mm extends $G {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.LongName = Q, this.PredefinedType = he, this.type = 1209101575;
    }
  }
  e.IfcExternalSpatialElement = mm;
  class yw extends p7 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 346874300;
    }
  }
  e.IfcFanType = yw;
  class Ew extends V6 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 1810631287;
    }
  }
  e.IfcFilterType = Ew;
  class wS extends w0 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 4222183408;
    }
  }
  e.IfcFireSuppressionTerminalType = wS;
  class Au extends Or {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.type = 2058353004;
    }
  }
  e.IfcFlowController = Au;
  class R0 extends Or {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.type = 4278956645;
    }
  }
  e.IfcFlowFitting = R0;
  class dT extends qI {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 4037862832;
    }
  }
  e.IfcFlowInstrumentType = dT;
  class AR extends Au {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 2188021234;
    }
  }
  e.IfcFlowMeter = AR;
  class qf extends Or {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.type = 3132237377;
    }
  }
  e.IfcFlowMovingDevice = qf;
  class cT extends Or {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.type = 987401354;
    }
  }
  e.IfcFlowSegment = cT;
  class QI extends Or {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.type = 707683696;
    }
  }
  e.IfcFlowStorageDevice = QI;
  class Er extends Or {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.type = 2223149337;
    }
  }
  e.IfcFlowTerminal = Er;
  class hT extends Or {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.type = 3508470533;
    }
  }
  e.IfcFlowTreatmentDevice = hT;
  class SR extends Cr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 900683007;
    }
  }
  e.IfcFooting = SR;
  class b7 extends Lr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 3319311131;
    }
  }
  e.IfcHeatExchanger = b7;
  class xE extends Lr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 2068733104;
    }
  }
  e.IfcHumidifier = xE;
  class Q6 extends hT {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 4175244083;
    }
  }
  e.IfcInterceptor = Q6;
  class TS extends R0 {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 2176052936;
    }
  }
  e.IfcJunctionBox = TS;
  class JI extends Er {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 76236018;
    }
  }
  e.IfcLamp = JI;
  class RS extends Er {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 629592764;
    }
  }
  e.IfcLightFixture = RS;
  class fT extends Er {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 1437502449;
    }
  }
  e.IfcMedicalDevice = fT;
  class J6 extends Cr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 1073191201;
    }
  }
  e.IfcMember = J6;
  class Md extends J6 {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 1911478936;
    }
  }
  e.IfcMemberStandardCase = Md;
  class bR extends Lr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 2474470126;
    }
  }
  e.IfcMotorConnection = bR;
  class m9 extends hw {
    constructor(w, v) {
      super(w, v), this.Segments = w, this.SelfIntersect = v, this.type = 144952367;
    }
  }
  e.IfcOuterBoundaryCurve = m9;
  class PE extends Er {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 3694346114;
    }
  }
  e.IfcOutlet = PE;
  class ME extends Cr {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.ConstructionType = Ze, this.type = 1687234759;
    }
  }
  e.IfcPile = ME;
  class oy extends R0 {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 310824031;
    }
  }
  e.IfcPipeFitting = oy;
  class NR extends cT {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 3612865200;
    }
  }
  e.IfcPipeSegment = NR;
  class IT extends Cr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 3171933400;
    }
  }
  e.IfcPlate = IT;
  class X6 extends IT {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 1156407060;
    }
  }
  e.IfcPlateStandardCase = X6;
  class pT extends Au {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 738039164;
    }
  }
  e.IfcProtectiveDevice = pT;
  class DR extends qI {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 655969474;
    }
  }
  e.IfcProtectiveDeviceTrippingUnitType = DR;
  class ry extends qf {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 90941305;
    }
  }
  e.IfcPump = ry;
  class mT extends Cr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 2262370178;
    }
  }
  e.IfcRailing = mT;
  class vS extends Cr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 3024970846;
    }
  }
  e.IfcRamp = vS;
  class ly extends Cr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 3283111854;
    }
  }
  e.IfcRampFlight = ly;
  class N7 extends cw {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.Degree = w, this.ControlPointsList = v, this.CurveForm = N, this.ClosedCurve = x, this.SelfIntersect = G, this.KnotMultiplicities = j, this.Knots = K, this.KnotSpec = Q, this.WeightsData = he, this.type = 1232101972;
    }
  }
  e.IfcRationalBSplineCurveWithKnots = N7;
  class ay extends jf {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki, Vn, ks) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.SteelGrade = he, this.NominalDiameter = Ze, this.CrossSectionArea = pi, this.BarLength = Ki, this.PredefinedType = Vn, this.BarSurface = ks, this.type = 979691226;
    }
  }
  e.IfcReinforcingBar = ay;
  class gw extends Wf {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki, Vn, ks, gr, Ro) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.NominalDiameter = pi, this.CrossSectionArea = Ki, this.BarLength = Vn, this.BarSurface = ks, this.BendingShapeCode = gr, this.BendingParameters = Ro, this.type = 2572171363;
    }
  }
  e.IfcReinforcingBarType = gw;
  class D7 extends Cr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 2016517767;
    }
  }
  e.IfcRoof = D7;
  class uy extends Er {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 3053780830;
    }
  }
  e.IfcSanitaryTerminal = uy;
  class UE extends qI {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 1783015770;
    }
  }
  e.IfcSensorType = UE;
  class ww extends Cr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 1329646415;
    }
  }
  e.IfcShadingDevice = ww;
  class Tw extends Cr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 1529196076;
    }
  }
  e.IfcSlab = Tw;
  class AS extends Tw {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 3127900445;
    }
  }
  e.IfcSlabElementedCase = AS;
  class BE extends Tw {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 3027962421;
    }
  }
  e.IfcSlabStandardCase = BE;
  class ym extends Lr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 3420628829;
    }
  }
  e.IfcSolarDevice = ym;
  class dy extends Er {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 1999602285;
    }
  }
  e.IfcSpaceHeater = dy;
  class C7 extends Er {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 1404847402;
    }
  }
  e.IfcStackTerminal = C7;
  class FE extends Cr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 331165859;
    }
  }
  e.IfcStair = FE;
  class O7 extends Cr {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki, Vn) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.NumberOfRisers = he, this.NumberOfTreads = Ze, this.RiserHeight = pi, this.TreadLength = Ki, this.PredefinedType = Vn, this.type = 4252922144;
    }
  }
  e.IfcStairFlight = O7;
  class cl extends j6 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.PredefinedType = j, this.OrientationOf2DPlane = K, this.LoadedBy = Q, this.HasResults = he, this.SharedPlacement = Ze, this.type = 2515109513;
    }
  }
  e.IfcStructuralAnalysisModel = cl;
  class zc extends mS {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi) {
      super(w, v, N, x, G, j, K, Q, he, Ze), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.PredefinedType = j, this.ActionType = K, this.ActionSource = Q, this.Coefficient = he, this.Purpose = Ze, this.SelfWeightCoefficients = pi, this.type = 385403989;
    }
  }
  e.IfcStructuralLoadCase = zc;
  class Ud extends g7 {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki) {
      super(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.AppliedLoad = Q, this.GlobalOrLocal = he, this.DestabilizingLoad = Ze, this.ProjectedOrTrue = pi, this.PredefinedType = Ki, this.type = 1621171031;
    }
  }
  e.IfcStructuralPlanarAction = Ud;
  class or extends Au {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 1162798199;
    }
  }
  e.IfcSwitchingDevice = or;
  class $f extends QI {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 812556717;
    }
  }
  e.IfcTank = $f;
  class eD extends Lr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 3825984169;
    }
  }
  e.IfcTransformer = eD;
  class jc extends Lr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 3026737570;
    }
  }
  e.IfcTubeBundle = jc;
  class CR extends qI {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 3179687236;
    }
  }
  e.IfcUnitaryControlElementType = CR;
  class cy extends Lr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 4292641817;
    }
  }
  e.IfcUnitaryEquipment = cy;
  class OR extends Au {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 4207607924;
    }
  }
  e.IfcValve = OR;
  class HE extends Cr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 2391406946;
    }
  }
  e.IfcWall = HE;
  class Rw extends HE {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 4156078855;
    }
  }
  e.IfcWallElementedCase = Rw;
  class hy extends HE {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 3512223829;
    }
  }
  e.IfcWallStandardCase = hy;
  class zo extends Er {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 4237592921;
    }
  }
  e.IfcWasteTerminal = zo;
  class yT extends Cr {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki, Vn) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.OverallHeight = he, this.OverallWidth = Ze, this.PredefinedType = pi, this.PartitioningType = Ki, this.UserDefinedPartitioningType = Vn, this.type = 3304561284;
    }
  }
  e.IfcWindow = yT;
  class vw extends yT {
    constructor(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki, Vn) {
      super(w, v, N, x, G, j, K, Q, he, Ze, pi, Ki, Vn), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.OverallHeight = he, this.OverallWidth = Ze, this.PredefinedType = pi, this.PartitioningType = Ki, this.UserDefinedPartitioningType = Vn, this.type = 486154966;
    }
  }
  e.IfcWindowStandardCase = vw;
  class Bd extends qI {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 2874132201;
    }
  }
  e.IfcActuatorType = Bd;
  class LR extends Er {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 1634111441;
    }
  }
  e.IfcAirTerminal = LR;
  class Aw extends Au {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 177149247;
    }
  }
  e.IfcAirTerminalBox = Aw;
  class _R extends Lr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 2056796094;
    }
  }
  e.IfcAirToAirHeatRecovery = _R;
  class tD extends qI {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 3001207471;
    }
  }
  e.IfcAlarmType = tD;
  class fy extends Er {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 277319702;
    }
  }
  e.IfcAudioVisualAppliance = fy;
  class GE extends Cr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 753842376;
    }
  }
  e.IfcBeam = GE;
  class ET extends GE {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 2906023776;
    }
  }
  e.IfcBeamStandardCase = ET;
  class gT extends Lr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 32344328;
    }
  }
  e.IfcBoiler = gT;
  class SS extends Lr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 2938176219;
    }
  }
  e.IfcBurner = SS;
  class bh extends R0 {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 635142910;
    }
  }
  e.IfcCableCarrierFitting = bh;
  class bS extends cT {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 3758799889;
    }
  }
  e.IfcCableCarrierSegment = bS;
  class Sw extends R0 {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 1051757585;
    }
  }
  e.IfcCableFitting = Sw;
  class wT extends cT {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 4217484030;
    }
  }
  e.IfcCableSegment = wT;
  class xR extends Lr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 3902619387;
    }
  }
  e.IfcChiller = xR;
  class NS extends Lr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 639361253;
    }
  }
  e.IfcCoil = NS;
  class PR extends Er {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 3221913625;
    }
  }
  e.IfcCommunicationsAppliance = PR;
  class iD extends qf {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 3571504051;
    }
  }
  e.IfcCompressor = iD;
  class nD extends Lr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 2272882330;
    }
  }
  e.IfcCondenser = nD;
  class rr extends qI {
    constructor(w, v, N, x, G, j, K, Q, he, Ze) {
      super(w, v, N, x, G, j, K, Q, he), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ApplicableOccurrence = G, this.HasPropertySets = j, this.RepresentationMaps = K, this.Tag = Q, this.ElementType = he, this.PredefinedType = Ze, this.type = 578613899;
    }
  }
  e.IfcControllerType = rr;
  class TT extends Lr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 4136498852;
    }
  }
  e.IfcCooledBeam = TT;
  class yl extends Lr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 3640358203;
    }
  }
  e.IfcCoolingTower = yl;
  class DS extends Au {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 4074379575;
    }
  }
  e.IfcDamper = DS;
  class bw extends Or {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 1052013943;
    }
  }
  e.IfcDistributionChamberElement = bw;
  class v0 extends RR {
    constructor(w, v, N, x, G, j, K) {
      super(w, v, N, x, G, j, K), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.LongName = j, this.PredefinedType = K, this.type = 562808652;
    }
  }
  e.IfcDistributionCircuit = v0;
  class Ml extends $I {
    constructor(w, v, N, x, G, j, K, Q) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.type = 1062813311;
    }
  }
  e.IfcDistributionControlElement = Ml;
  class RT extends R0 {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 342316401;
    }
  }
  e.IfcDuctFitting = RT;
  class kE extends cT {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 3518393246;
    }
  }
  e.IfcDuctSegment = kE;
  class XI extends hT {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 1360408905;
    }
  }
  e.IfcDuctSilencer = XI;
  class Kf extends Er {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 1904799276;
    }
  }
  e.IfcElectricAppliance = Kf;
  class ye extends Au {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 862014818;
    }
  }
  e.IfcElectricDistributionBoard = ye;
  class D extends QI {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 3310460725;
    }
  }
  e.IfcElectricFlowStorageDevice = D;
  class M extends Lr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 264262732;
    }
  }
  e.IfcElectricGenerator = M;
  class k extends Lr {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 402227799;
    }
  }
  e.IfcElectricMotor = k;
  class $ extends Au {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 1003880860;
    }
  }
  e.IfcElectricTimeControl = $;
  class J extends qf {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 3415622556;
    }
  }
  e.IfcFan = J;
  class ue extends hT {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 819412036;
    }
  }
  e.IfcFilter = ue;
  class Ie extends Er {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 1426591983;
    }
  }
  e.IfcFireSuppressionTerminal = Ie;
  class ve extends Ml {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 182646315;
    }
  }
  e.IfcFlowInstrument = ve;
  class Be extends Ml {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 2295281155;
    }
  }
  e.IfcProtectiveDeviceTrippingUnit = Be;
  class bt extends Ml {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 4086658281;
    }
  }
  e.IfcSensor = bt;
  class ji extends Ml {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 630975310;
    }
  }
  e.IfcUnitaryControlElement = ji;
  class xn extends Ml {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 4288193352;
    }
  }
  e.IfcActuator = xn;
  class fs extends Ml {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 3087945054;
    }
  }
  e.IfcAlarm = fs;
  class Xs extends Ml {
    constructor(w, v, N, x, G, j, K, Q, he) {
      super(w, v, N, x, G, j, K, Q), this.GlobalId = w, this.OwnerHistory = v, this.Name = N, this.Description = x, this.ObjectType = G, this.ObjectPlacement = j, this.Representation = K, this.Tag = Q, this.PredefinedType = he, this.type = 25142252;
    }
  }
  e.IfcController = Xs;
})(d || (d = {}));
TP[3] = ["IFC4X3", "IFC4X1", "IFC4X2", "IFC4X3_RC3", "IFC4X3_RC4", "IFC4X3_RC1", "IFC4X3_RC2", "IFC4X3_ADD2", "IFC4X3_ADD1"];
kF[3] = {
  3630933823: (e) => new a.IfcActorRole(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcText((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  618182010: (e) => new a.IfcAddress(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  2879124712: (e) => new a.IfcAlignmentParameterSegment((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  3633395639: (e) => new a.IfcAlignmentVerticalSegment((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new a.IfcLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new a.IfcNonNegativeLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new a.IfcLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new a.IfcRatioMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new a.IfcRatioMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  639542469: (e) => new a.IfcApplication(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new a.IfcIdentifier((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  411424972: (e) => {
    var t;
    return new a.IfcAppliedValue((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcDate((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcDate((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : ((t = e[9]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  130549933: (e) => new a.IfcApproval((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcText((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcDateTime((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcText((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7]), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 3, e[8])),
  4037036970: (e) => new a.IfcBoundaryCondition((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  1560379544: (e) => new a.IfcBoundaryEdgeCondition((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : Li(3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : Li(3, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : Li(3, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : Li(3, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : Li(3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : Li(3, e[6])),
  3367102660: (e) => new a.IfcBoundaryFaceCondition((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : Li(3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : Li(3, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : Li(3, e[3])),
  1387855156: (e) => new a.IfcBoundaryNodeCondition((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : Li(3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : Li(3, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : Li(3, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : Li(3, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : Li(3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : Li(3, e[6])),
  2069777674: (e) => new a.IfcBoundaryNodeConditionWarping((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : Li(3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : Li(3, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : Li(3, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : Li(3, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : Li(3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : Li(3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : Li(3, e[7])),
  2859738748: (e) => new a.IfcConnectionGeometry(),
  2614616156: (e) => new a.IfcConnectionPointGeometry(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1])),
  2732653382: (e) => new a.IfcConnectionSurfaceGeometry(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1])),
  775493141: (e) => new a.IfcConnectionVolumeGeometry(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1])),
  1959218052: (e) => new a.IfcConstraint(new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), e[2], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcLabel((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcDateTime((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  1785450214: (e) => new a.IfcCoordinateOperation(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1])),
  1466758467: (e) => new a.IfcCoordinateReferenceSystem(new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcIdentifier((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcIdentifier((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  602808272: (e) => {
    var t;
    return new a.IfcCostValue((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcDate((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcDate((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : ((t = e[9]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  1765591967: (e) => {
    var t;
    return new a.IfcDerivedUnit(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], e[1], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcLabel((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value));
  },
  1045800335: (e) => new a.IfcDerivedUnitElement(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new pt((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 10)),
  2949456006: (e) => new a.IfcDimensionalExponents(new pt((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 10), new pt((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 10), new pt((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 10), new pt((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 10), new pt((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 10), new pt((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 10), new pt((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 10)),
  4294318154: (e) => new a.IfcExternalInformation(),
  3200245327: (e) => new a.IfcExternalReference((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcURIReference((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcIdentifier((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  2242383968: (e) => new a.IfcExternallyDefinedHatchStyle((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcURIReference((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcIdentifier((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  1040185647: (e) => new a.IfcExternallyDefinedSurfaceStyle((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcURIReference((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcIdentifier((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  3548104201: (e) => new a.IfcExternallyDefinedTextFont((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcURIReference((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcIdentifier((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  852622518: (e) => new a.IfcGridAxis((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), new a.IfcBoolean((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  3020489413: (e) => {
    var t;
    return new a.IfcIrregularTimeSeriesValue(new a.IfcDateTime((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? Li(3, i) : null)) || []);
  },
  2655187982: (e) => new a.IfcLibraryInformation(new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcDateTime((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcURIReference((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcText((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value)),
  3452421091: (e) => new a.IfcLibraryReference((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcURIReference((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcIdentifier((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLanguageId((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5])),
  4162380809: (e) => {
    var t, i;
    return new a.IfcLightDistributionData(new a.IfcPlaneAngleMeasure((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), ((t = e[1]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new a.IfcPlaneAngleMeasure(n.value) : null)) || [], ((i = e[2]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new a.IfcLuminousIntensityDistributionMeasure(n.value) : null)) || []);
  },
  1566485204: (e) => {
    var t;
    return new a.IfcLightIntensityDistribution(e[0], ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  3057273783: (e) => new a.IfcMapConversion(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), new a.IfcLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new a.IfcLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new a.IfcLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcReal((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcReal((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcReal((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcReal((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new a.IfcReal((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value)),
  1847130766: (e) => {
    var t;
    return new a.IfcMaterialClassificationRelationship(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]));
  },
  760658860: (e) => new a.IfcMaterialDefinition(),
  248100487: (e) => new a.IfcMaterialLayer((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcNonNegativeLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLogical((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcLabel((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcText((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcInteger((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  3303938423: (e) => {
    var t;
    return new a.IfcMaterialLayerSet(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcText((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value));
  },
  1847252529: (e) => new a.IfcMaterialLayerWithOffsets((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcNonNegativeLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLogical((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcLabel((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcText((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcInteger((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), e[7], new a.IfcLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  2199411900: (e) => {
    var t;
    return new a.IfcMaterialList(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  2235152071: (e) => new a.IfcMaterialProfile((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcInteger((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value)),
  164193824: (e) => {
    var t;
    return new a.IfcMaterialProfileSet((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3]));
  },
  552965576: (e) => new a.IfcMaterialProfileWithOffsets((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcInteger((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new a.IfcLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  1507914824: (e) => new a.IfcMaterialUsageDefinition(),
  2597039031: (e) => new a.IfcMeasureWithUnit(Li(3, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1])),
  3368373690: (e) => new a.IfcMetric(new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), e[2], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcLabel((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcDateTime((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), e[7], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 3, e[9]), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 3, e[10])),
  2706619895: (e) => new a.IfcMonetaryUnit(new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  1918398963: (e) => new a.IfcNamedUnit(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), e[1]),
  3701648758: (e) => new a.IfcObjectPlacement((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0])),
  2251480897: (e) => {
    var t;
    return new a.IfcObjective(new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), e[2], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcLabel((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcDateTime((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((t = e[7]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], e[8], e[9], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new a.IfcLabel((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value));
  },
  4251960020: (e) => {
    var t, i;
    return new a.IfcOrganization((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcText((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : ((t = e[3]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[4] ?? void 0) === void 0 || e[4] === "" ? null : ((i = e[4]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || []);
  },
  1207048766: (e) => new a.IfcOwnerHistory(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), e[2], e[3], (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcTimeStamp((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), new a.IfcTimeStamp((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  2077209135: (e) => {
    var t, i, n, s, o;
    return new a.IfcPerson((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : ((t = e[3]) == null ? void 0 : t.map((r) => ((r == null ? void 0 : r.value) ?? void 0) !== void 0 && (r == null ? void 0 : r.value) !== "" ? new a.IfcLabel(r.value) : null)) || [], (e[4] ?? void 0) === void 0 || e[4] === "" ? null : ((i = e[4]) == null ? void 0 : i.map((r) => ((r == null ? void 0 : r.value) ?? void 0) !== void 0 && (r == null ? void 0 : r.value) !== "" ? new a.IfcLabel(r.value) : null)) || [], (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((n = e[5]) == null ? void 0 : n.map((r) => ((r == null ? void 0 : r.value) ?? void 0) !== void 0 && (r == null ? void 0 : r.value) !== "" ? new a.IfcLabel(r.value) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((s = e[6]) == null ? void 0 : s.map((r) => ((r == null ? void 0 : r.value) ?? void 0) !== void 0 && (r == null ? void 0 : r.value) !== "" ? new u(r.value, 3, r) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((o = e[7]) == null ? void 0 : o.map((r) => ((r == null ? void 0 : r.value) ?? void 0) !== void 0 && (r == null ? void 0 : r.value) !== "" ? new u(r.value, 3, r) : null)) || []);
  },
  101040310: (e) => {
    var t;
    return new a.IfcPersonAndOrganization(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  2483315170: (e) => new a.IfcPhysicalQuantity(new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  2226359599: (e) => new a.IfcPhysicalSimpleQuantity(new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2])),
  3355820592: (e) => {
    var t;
    return new a.IfcPostalAddress(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcLabel((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new a.IfcLabel(i.value) : null)) || [], (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new a.IfcLabel((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value));
  },
  677532197: (e) => new a.IfcPresentationItem(),
  2022622350: (e) => {
    var t;
    return new a.IfcPresentationLayerAssignment(new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcIdentifier((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value));
  },
  1304840413: (e) => {
    var t, i;
    return new a.IfcPresentationLayerWithStyle(new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcIdentifier((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new a.IfcLogical((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new a.IfcLogical((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new a.IfcLogical((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((i = e[7]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || []);
  },
  3119450353: (e) => new a.IfcPresentationStyle((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  2095639259: (e) => {
    var t;
    return new a.IfcProductRepresentation((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  3958567839: (e) => new a.IfcProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  3843373140: (e) => new a.IfcProjectedCRS(new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcIdentifier((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcIdentifier((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6])),
  986844984: (e) => new a.IfcPropertyAbstraction(),
  3710013099: (e) => {
    var t;
    return new a.IfcPropertyEnumeration(new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? Li(3, i) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]));
  },
  2044713172: (e) => new a.IfcQuantityArea(new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new a.IfcAreaMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  2093928680: (e) => new a.IfcQuantityCount(new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new a.IfcCountMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  931644368: (e) => new a.IfcQuantityLength(new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new a.IfcLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  2691318326: (e) => new a.IfcQuantityNumber(new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new a.IfcNumericMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  3252649465: (e) => new a.IfcQuantityTime(new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new a.IfcTimeMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  2405470396: (e) => new a.IfcQuantityVolume(new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new a.IfcVolumeMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  825690147: (e) => new a.IfcQuantityWeight(new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new a.IfcMassMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  3915482550: (e) => {
    var t, i, n, s;
    return new a.IfcRecurrencePattern(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : ((t = e[1]) == null ? void 0 : t.map((o) => ((o == null ? void 0 : o.value) ?? void 0) !== void 0 && (o == null ? void 0 : o.value) !== "" ? new a.IfcDayInMonthNumber(o.value) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : ((i = e[2]) == null ? void 0 : i.map((o) => ((o == null ? void 0 : o.value) ?? void 0) !== void 0 && (o == null ? void 0 : o.value) !== "" ? new a.IfcDayInWeekNumber(o.value) : null)) || [], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : ((n = e[3]) == null ? void 0 : n.map((o) => ((o == null ? void 0 : o.value) ?? void 0) !== void 0 && (o == null ? void 0 : o.value) !== "" ? new a.IfcMonthInYearNumber(o.value) : null)) || [], (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcInteger((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcInteger((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcInteger((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((s = e[7]) == null ? void 0 : s.map((o) => ((o == null ? void 0 : o.value) ?? void 0) !== void 0 && (o == null ? void 0 : o.value) !== "" ? new u(o.value, 3, o) : null)) || []);
  },
  2433181523: (e) => {
    var t;
    return new a.IfcReference((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcIdentifier((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new a.IfcInteger(i.value) : null)) || [], (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]));
  },
  1076942058: (e) => {
    var t;
    return new a.IfcRepresentation(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  3377609919: (e) => new a.IfcRepresentationContext((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  3008791417: (e) => new a.IfcRepresentationItem(),
  1660063152: (e) => new a.IfcRepresentationMap(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1])),
  2439245199: (e) => new a.IfcResourceLevelRelationship((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  2341007311: (e) => new a.IfcRoot(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  448429030: (e) => new a.IfcSIUnit(e[0], e[1], e[2]),
  1054537805: (e) => new a.IfcSchedulingTime((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), e[1], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  867548509: (e) => {
    var t;
    return new a.IfcShapeAspect(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcText((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new a.IfcLogical((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]));
  },
  3982875396: (e) => {
    var t;
    return new a.IfcShapeModel(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  4240577450: (e) => {
    var t;
    return new a.IfcShapeRepresentation(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  2273995522: (e) => new a.IfcStructuralConnectionCondition((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  2162789131: (e) => new a.IfcStructuralLoad((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  3478079324: (e) => {
    var t, i;
    return new a.IfcStructuralLoadConfiguration((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), ((t = e[1]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : (i = e[2]) == null ? void 0 : i.map((n) => (n == null ? void 0 : n.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new a.IfcLengthMeasure(s.value) : null)) || []));
  },
  609421318: (e) => new a.IfcStructuralLoadOrResult((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  2525727697: (e) => new a.IfcStructuralLoadStatic((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  3408363356: (e) => new a.IfcStructuralLoadTemperature((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcThermodynamicTemperatureMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcThermodynamicTemperatureMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcThermodynamicTemperatureMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2830218821: (e) => {
    var t;
    return new a.IfcStyleModel(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  3958052878: (e) => {
    var t;
    return new a.IfcStyledItem((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value));
  },
  3049322572: (e) => {
    var t;
    return new a.IfcStyledRepresentation(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  2934153892: (e) => {
    var t, i;
    return new a.IfcSurfaceReinforcementArea((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : ((t = e[1]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new a.IfcLengthMeasure(n.value) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : ((i = e[2]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new a.IfcLengthMeasure(n.value) : null)) || [], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcRatioMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value));
  },
  1300840506: (e) => {
    var t;
    return new a.IfcSurfaceStyle((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), e[1], ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  3303107099: (e) => new a.IfcSurfaceStyleLighting(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3])),
  1607154358: (e) => new a.IfcSurfaceStyleRefraction((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcReal((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcReal((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  846575682: (e) => new a.IfcSurfaceStyleShading(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcNormalisedRatioMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  1351298697: (e) => {
    var t;
    return new a.IfcSurfaceStyleWithTextures(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  626085974: (e) => {
    var t;
    return new a.IfcSurfaceTexture(new a.IfcBoolean((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new a.IfcBoolean((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcIdentifier((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new a.IfcIdentifier(i.value) : null)) || []);
  },
  985171141: (e) => {
    var t, i;
    return new a.IfcTable((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : ((t = e[1]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : ((i = e[2]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || []);
  },
  2043862942: (e) => new a.IfcTableColumn((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcText((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4])),
  531007025: (e) => {
    var t;
    return new a.IfcTableRow((e[0] ?? void 0) === void 0 || e[0] === "" ? null : ((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? Li(3, i) : null)) || [], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcBoolean((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value));
  },
  1549132990: (e) => new a.IfcTaskTime((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), e[1], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), e[3], (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcDuration((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcDateTime((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcDateTime((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcDateTime((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcDateTime((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new a.IfcDateTime((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new a.IfcDateTime((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new a.IfcDuration((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new a.IfcDuration((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), (e[13] ?? void 0) === void 0 || e[13] === "" ? null : new a.IfcBoolean((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value), (e[14] ?? void 0) === void 0 || e[14] === "" ? null : new a.IfcDateTime((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value), (e[15] ?? void 0) === void 0 || e[15] === "" ? null : new a.IfcDuration((e[15] ?? void 0) === void 0 || e[15] === "" ? null : e[15].value), (e[16] ?? void 0) === void 0 || e[16] === "" ? null : new a.IfcDateTime((e[16] ?? void 0) === void 0 || e[16] === "" ? null : e[16].value), (e[17] ?? void 0) === void 0 || e[17] === "" ? null : new a.IfcDateTime((e[17] ?? void 0) === void 0 || e[17] === "" ? null : e[17].value), (e[18] ?? void 0) === void 0 || e[18] === "" ? null : new a.IfcDuration((e[18] ?? void 0) === void 0 || e[18] === "" ? null : e[18].value), (e[19] ?? void 0) === void 0 || e[19] === "" ? null : new a.IfcPositiveRatioMeasure((e[19] ?? void 0) === void 0 || e[19] === "" ? null : e[19].value)),
  2771591690: (e) => new a.IfcTaskTimeRecurring((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), e[1], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), e[3], (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcDuration((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcDateTime((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcDateTime((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcDateTime((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcDateTime((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new a.IfcDateTime((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new a.IfcDateTime((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new a.IfcDuration((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new a.IfcDuration((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), (e[13] ?? void 0) === void 0 || e[13] === "" ? null : new a.IfcBoolean((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value), (e[14] ?? void 0) === void 0 || e[14] === "" ? null : new a.IfcDateTime((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value), (e[15] ?? void 0) === void 0 || e[15] === "" ? null : new a.IfcDuration((e[15] ?? void 0) === void 0 || e[15] === "" ? null : e[15].value), (e[16] ?? void 0) === void 0 || e[16] === "" ? null : new a.IfcDateTime((e[16] ?? void 0) === void 0 || e[16] === "" ? null : e[16].value), (e[17] ?? void 0) === void 0 || e[17] === "" ? null : new a.IfcDateTime((e[17] ?? void 0) === void 0 || e[17] === "" ? null : e[17].value), (e[18] ?? void 0) === void 0 || e[18] === "" ? null : new a.IfcDuration((e[18] ?? void 0) === void 0 || e[18] === "" ? null : e[18].value), (e[19] ?? void 0) === void 0 || e[19] === "" ? null : new a.IfcPositiveRatioMeasure((e[19] ?? void 0) === void 0 || e[19] === "" ? null : e[19].value), new u((e[20] ?? void 0) === void 0 || e[20] === "" ? null : e[20].value, 3, e[20])),
  912023232: (e) => {
    var t, i, n, s;
    return new a.IfcTelecomAddress(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : ((t = e[3]) == null ? void 0 : t.map((o) => ((o == null ? void 0 : o.value) ?? void 0) !== void 0 && (o == null ? void 0 : o.value) !== "" ? new a.IfcLabel(o.value) : null)) || [], (e[4] ?? void 0) === void 0 || e[4] === "" ? null : ((i = e[4]) == null ? void 0 : i.map((o) => ((o == null ? void 0 : o.value) ?? void 0) !== void 0 && (o == null ? void 0 : o.value) !== "" ? new a.IfcLabel(o.value) : null)) || [], (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((n = e[6]) == null ? void 0 : n.map((o) => ((o == null ? void 0 : o.value) ?? void 0) !== void 0 && (o == null ? void 0 : o.value) !== "" ? new a.IfcLabel(o.value) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcURIReference((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : ((s = e[8]) == null ? void 0 : s.map((o) => ((o == null ? void 0 : o.value) ?? void 0) !== void 0 && (o == null ? void 0 : o.value) !== "" ? new a.IfcURIReference(o.value) : null)) || []);
  },
  1447204868: (e) => new a.IfcTextStyle((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcBoolean((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  2636378356: (e) => new a.IfcTextStyleForDefinedFont(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1])),
  1640371178: (e) => new a.IfcTextStyleTextModel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : Li(3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcTextAlignment((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcTextDecoration((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : Li(3, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : Li(3, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcTextTransformation((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : Li(3, e[6])),
  280115917: (e) => {
    var t;
    return new a.IfcTextureCoordinate(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  1742049831: (e) => {
    var t, i;
    return new a.IfcTextureCoordinateGenerator(((t = e[0]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : ((i = e[2]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new a.IfcReal(n.value) : null)) || []);
  },
  222769930: (e) => {
    var t;
    return new a.IfcTextureCoordinateIndices(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new a.IfcPositiveInteger(i.value) : null)) || [], new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]));
  },
  1010789467: (e) => {
    var t, i;
    return new a.IfcTextureCoordinateIndicesWithVoids(((t = e[0]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new a.IfcPositiveInteger(n.value) : null)) || [], new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (i = e[2]) == null ? void 0 : i.map((n) => (n == null ? void 0 : n.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new a.IfcPositiveInteger(s.value) : null)) || []));
  },
  2552916305: (e) => {
    var t, i;
    return new a.IfcTextureMap(((t = e[0]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], ((i = e[1]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]));
  },
  1210645708: (e) => {
    var t;
    return new a.IfcTextureVertex(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new a.IfcParameterValue(i.value) : null)) || []);
  },
  3611470254: (e) => {
    var t;
    return new a.IfcTextureVertexList((t = e[0]) == null ? void 0 : t.map((i) => (i == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new a.IfcParameterValue(n.value) : null)) || []));
  },
  1199560280: (e) => new a.IfcTimePeriod(new a.IfcTime((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new a.IfcTime((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  3101149627: (e) => new a.IfcTimeSeries(new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new a.IfcDateTime((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new a.IfcDateTime((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), e[4], e[5], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7])),
  581633288: (e) => {
    var t;
    return new a.IfcTimeSeriesValue(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? Li(3, i) : null)) || []);
  },
  1377556343: (e) => new a.IfcTopologicalRepresentationItem(),
  1735638870: (e) => {
    var t;
    return new a.IfcTopologyRepresentation(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  180925521: (e) => {
    var t;
    return new a.IfcUnitAssignment(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  2799835756: (e) => new a.IfcVertex(),
  1907098498: (e) => new a.IfcVertexPoint(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0])),
  891718957: (e) => {
    var t, i;
    return new a.IfcVirtualGridIntersection(((t = e[0]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], ((i = e[1]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new a.IfcLengthMeasure(n.value) : null)) || []);
  },
  1236880293: (e) => new a.IfcWorkTime((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), e[1], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcDate((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcDate((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value)),
  3752311538: (e) => new a.IfcAlignmentCantSegment((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new a.IfcLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new a.IfcNonNegativeLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new a.IfcLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new a.IfcLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  536804194: (e) => new a.IfcAlignmentHorizontalSegment((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new a.IfcPlaneAngleMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new a.IfcLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new a.IfcLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new a.IfcNonNegativeLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcPositiveLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3869604511: (e) => {
    var t;
    return new a.IfcApprovalRelationship((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  3798115385: (e) => new a.IfcArbitraryClosedProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2])),
  1310608509: (e) => new a.IfcArbitraryOpenProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2])),
  2705031697: (e) => {
    var t;
    return new a.IfcArbitraryProfileDefWithVoids(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  616511568: (e) => {
    var t;
    return new a.IfcBlobTexture(new a.IfcBoolean((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new a.IfcBoolean((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcIdentifier((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new a.IfcIdentifier(i.value) : null)) || [], new a.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new a.IfcBinary((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value));
  },
  3150382593: (e) => new a.IfcCenterLineProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new a.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  747523909: (e) => {
    var t;
    return new a.IfcClassification((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcDate((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new a.IfcLabel((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcText((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcURIReference((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((t = e[6]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new a.IfcIdentifier(i.value) : null)) || []);
  },
  647927063: (e) => new a.IfcClassificationReference((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcURIReference((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcIdentifier((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcText((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value)),
  3285139300: (e) => {
    var t;
    return new a.IfcColourRgbList((t = e[0]) == null ? void 0 : t.map((i) => (i == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new a.IfcNormalisedRatioMeasure(n.value) : null)) || []));
  },
  3264961684: (e) => new a.IfcColourSpecification((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  1485152156: (e) => {
    var t;
    return new a.IfcCompositeProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcLabel((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value));
  },
  370225590: (e) => {
    var t;
    return new a.IfcConnectedFaceSet(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  1981873012: (e) => new a.IfcConnectionCurveGeometry(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1])),
  45288368: (e) => new a.IfcConnectionPointEccentricity(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  3050246964: (e) => new a.IfcContextDependentUnit(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), e[1], new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  2889183280: (e) => new a.IfcConversionBasedUnit(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), e[1], new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3])),
  2713554722: (e) => new a.IfcConversionBasedUnitWithOffset(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), e[1], new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3]), new a.IfcReal((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  539742890: (e) => new a.IfcCurrencyRelationship((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3]), new a.IfcPositiveRatioMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcDateTime((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6])),
  3800577675: (e) => new a.IfcCurveStyle((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : Li(3, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcBoolean((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  1105321065: (e) => {
    var t;
    return new a.IfcCurveStyleFont((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  2367409068: (e) => new a.IfcCurveStyleFontAndScaling((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), new a.IfcPositiveRatioMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  3510044353: (e) => new a.IfcCurveStyleFontPattern(new a.IfcLengthMeasure((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new a.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  3632507154: (e) => new a.IfcDerivedProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  1154170062: (e) => {
    var t;
    return new a.IfcDocumentInformation(new a.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcText((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcURIReference((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcText((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcText((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcText((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 3, e[8]), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : ((t = e[9]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new a.IfcDateTime((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new a.IfcDateTime((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new a.IfcIdentifier((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), (e[13] ?? void 0) === void 0 || e[13] === "" ? null : new a.IfcDate((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value), (e[14] ?? void 0) === void 0 || e[14] === "" ? null : new a.IfcDate((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value), e[15], e[16]);
  },
  770865208: (e) => {
    var t;
    return new a.IfcDocumentInformationRelationship((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value));
  },
  3732053477: (e) => new a.IfcDocumentReference((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcURIReference((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcIdentifier((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4])),
  3900360178: (e) => new a.IfcEdge(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1])),
  476780140: (e) => new a.IfcEdgeCurve(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new a.IfcBoolean((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  211053100: (e) => new a.IfcEventTime((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), e[1], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcDateTime((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcDateTime((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcDateTime((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcDateTime((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  297599258: (e) => {
    var t;
    return new a.IfcExtendedProperties((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  1437805879: (e) => {
    var t;
    return new a.IfcExternalReferenceRelationship((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  2556980723: (e) => {
    var t;
    return new a.IfcFace(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  1809719519: (e) => new a.IfcFaceBound(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcBoolean((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  803316827: (e) => new a.IfcFaceOuterBound(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcBoolean((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  3008276851: (e) => {
    var t;
    return new a.IfcFaceSurface(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), new a.IfcBoolean((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value));
  },
  4219587988: (e) => new a.IfcFailureConnectionCondition((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcForceMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcForceMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcForceMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcForceMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcForceMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcForceMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  738692330: (e) => {
    var t;
    return new a.IfcFillAreaStyle((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcBoolean((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value));
  },
  3448662350: (e) => new a.IfcGeometricRepresentationContext((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new a.IfcDimensionCount((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcReal((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5])),
  2453401579: (e) => new a.IfcGeometricRepresentationItem(),
  4142052618: (e) => new a.IfcGeometricRepresentationSubContext((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcPositiveRatioMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), e[4], (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value)),
  3590301190: (e) => {
    var t;
    return new a.IfcGeometricSet(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  178086475: (e) => new a.IfcGridPlacement((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2])),
  812098782: (e) => new a.IfcHalfSpaceSolid(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcBoolean((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  3905492369: (e) => {
    var t;
    return new a.IfcImageTexture(new a.IfcBoolean((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new a.IfcBoolean((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcIdentifier((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new a.IfcIdentifier(i.value) : null)) || [], new a.IfcURIReference((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value));
  },
  3570813810: (e) => {
    var t;
    return new a.IfcIndexedColourMap(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcNormalisedRatioMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new a.IfcPositiveInteger(i.value) : null)) || []);
  },
  1437953363: (e) => {
    var t;
    return new a.IfcIndexedTextureMap(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]));
  },
  2133299955: (e) => {
    var t, i;
    return new a.IfcIndexedTriangleTextureMap(((t = e[0]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : (i = e[3]) == null ? void 0 : i.map((n) => (n == null ? void 0 : n.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new a.IfcPositiveInteger(s.value) : null)) || []));
  },
  3741457305: (e) => {
    var t;
    return new a.IfcIrregularTimeSeries(new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new a.IfcDateTime((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new a.IfcDateTime((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), e[4], e[5], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7]), ((t = e[8]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  1585845231: (e) => new a.IfcLagTime((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), e[1], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), Li(3, e[3]), e[4]),
  1402838566: (e) => new a.IfcLightSource((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcNormalisedRatioMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcNormalisedRatioMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  125510826: (e) => new a.IfcLightSourceAmbient((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcNormalisedRatioMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcNormalisedRatioMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2604431987: (e) => new a.IfcLightSourceDirectional((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcNormalisedRatioMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcNormalisedRatioMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4])),
  4266656042: (e) => new a.IfcLightSourceGoniometric((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcNormalisedRatioMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcNormalisedRatioMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), new a.IfcThermodynamicTemperatureMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), new a.IfcLuminousFluxMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 3, e[9])),
  1520743889: (e) => new a.IfcLightSourcePositional((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcNormalisedRatioMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcNormalisedRatioMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), new a.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new a.IfcReal((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), new a.IfcReal((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), new a.IfcReal((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  3422422726: (e) => new a.IfcLightSourceSpot((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcNormalisedRatioMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcNormalisedRatioMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), new a.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new a.IfcReal((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), new a.IfcReal((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), new a.IfcReal((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 3, e[9]), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new a.IfcReal((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), new a.IfcPositivePlaneAngleMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), new a.IfcPositivePlaneAngleMeasure((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value)),
  388784114: (e) => new a.IfcLinearPlacement((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2])),
  2624227202: (e) => new a.IfcLocalPlacement((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1])),
  1008929658: (e) => new a.IfcLoop(),
  2347385850: (e) => new a.IfcMappedItem(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1])),
  1838606355: (e) => new a.IfcMaterial(new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  3708119e3: (e) => new a.IfcMaterialConstituent((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcNormalisedRatioMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  2852063980: (e) => {
    var t;
    return new a.IfcMaterialConstituentSet((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  2022407955: (e) => {
    var t;
    return new a.IfcMaterialDefinitionRepresentation((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3]));
  },
  1303795690: (e) => new a.IfcMaterialLayerSetUsage(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), e[1], e[2], new a.IfcLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  3079605661: (e) => new a.IfcMaterialProfileSetUsage(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcCardinalPointReference((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcPositiveLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  3404854881: (e) => new a.IfcMaterialProfileSetUsageTapering(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcCardinalPointReference((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcPositiveLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcCardinalPointReference((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  3265635763: (e) => {
    var t;
    return new a.IfcMaterialProperties((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3]));
  },
  853536259: (e) => {
    var t;
    return new a.IfcMaterialRelationship((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value));
  },
  2998442950: (e) => new a.IfcMirroredProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcLabel((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  219451334: (e) => new a.IfcObjectDefinition(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  182550632: (e) => {
    var t, i, n;
    return new a.IfcOpenCrossProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new a.IfcBoolean((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), ((t = e[3]) == null ? void 0 : t.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new a.IfcNonNegativeLengthMeasure(s.value) : null)) || [], ((i = e[4]) == null ? void 0 : i.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new a.IfcPlaneAngleMeasure(s.value) : null)) || [], (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((n = e[5]) == null ? void 0 : n.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new a.IfcLabel(s.value) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]));
  },
  2665983363: (e) => {
    var t;
    return new a.IfcOpenShell(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  1411181986: (e) => {
    var t;
    return new a.IfcOrganizationRelationship((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  1029017970: (e) => new a.IfcOrientedEdge(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcBoolean((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  2529465313: (e) => new a.IfcParameterizedProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2])),
  2519244187: (e) => {
    var t;
    return new a.IfcPath(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  3021840470: (e) => {
    var t;
    return new a.IfcPhysicalComplexQuantity(new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], new a.IfcLabel((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value));
  },
  597895409: (e) => {
    var t, i;
    return new a.IfcPixelTexture(new a.IfcBoolean((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new a.IfcBoolean((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcIdentifier((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : ((t = e[4]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new a.IfcIdentifier(n.value) : null)) || [], new a.IfcInteger((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new a.IfcInteger((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), new a.IfcInteger((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), ((i = e[8]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new a.IfcBinary(n.value) : null)) || []);
  },
  2004835150: (e) => new a.IfcPlacement(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0])),
  1663979128: (e) => new a.IfcPlanarExtent(new a.IfcLengthMeasure((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new a.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  2067069095: (e) => new a.IfcPoint(),
  2165702409: (e) => new a.IfcPointByDistanceExpression(Li(3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4])),
  4022376103: (e) => new a.IfcPointOnCurve(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcParameterValue((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  1423911732: (e) => new a.IfcPointOnSurface(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcParameterValue((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new a.IfcParameterValue((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  2924175390: (e) => {
    var t;
    return new a.IfcPolyLoop(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  2775532180: (e) => new a.IfcPolygonalBoundedHalfSpace(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcBoolean((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3])),
  3727388367: (e) => new a.IfcPreDefinedItem(new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  3778827333: (e) => new a.IfcPreDefinedProperties(),
  1775413392: (e) => new a.IfcPreDefinedTextFont(new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  673634403: (e) => {
    var t;
    return new a.IfcProductDefinitionShape((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  2802850158: (e) => {
    var t;
    return new a.IfcProfileProperties((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3]));
  },
  2598011224: (e) => new a.IfcProperty(new a.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  1680319473: (e) => new a.IfcPropertyDefinition(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  148025276: (e) => new a.IfcPropertyDependencyRelationship((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcText((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  3357820518: (e) => new a.IfcPropertySetDefinition(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  1482703590: (e) => new a.IfcPropertyTemplateDefinition(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2090586900: (e) => new a.IfcQuantitySet(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  3615266464: (e) => new a.IfcRectangleProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new a.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new a.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  3413951693: (e) => {
    var t;
    return new a.IfcRegularTimeSeries(new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new a.IfcDateTime((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new a.IfcDateTime((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), e[4], e[5], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7]), new a.IfcTimeMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), ((t = e[9]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  1580146022: (e) => new a.IfcReinforcementBarProperties(new a.IfcAreaMeasure((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), e[2], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcCountMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value)),
  478536968: (e) => new a.IfcRelationship(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2943643501: (e) => {
    var t;
    return new a.IfcResourceApprovalRelationship((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3]));
  },
  1608871552: (e) => {
    var t;
    return new a.IfcResourceConstraintRelationship((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  1042787934: (e) => new a.IfcResourceTime((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), e[1], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcDuration((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcPositiveRatioMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcDateTime((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcDateTime((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcDuration((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new a.IfcBoolean((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new a.IfcDateTime((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new a.IfcDuration((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new a.IfcPositiveRatioMeasure((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), (e[13] ?? void 0) === void 0 || e[13] === "" ? null : new a.IfcDateTime((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value), (e[14] ?? void 0) === void 0 || e[14] === "" ? null : new a.IfcDateTime((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value), (e[15] ?? void 0) === void 0 || e[15] === "" ? null : new a.IfcDuration((e[15] ?? void 0) === void 0 || e[15] === "" ? null : e[15].value), (e[16] ?? void 0) === void 0 || e[16] === "" ? null : new a.IfcPositiveRatioMeasure((e[16] ?? void 0) === void 0 || e[16] === "" ? null : e[16].value), (e[17] ?? void 0) === void 0 || e[17] === "" ? null : new a.IfcPositiveRatioMeasure((e[17] ?? void 0) === void 0 || e[17] === "" ? null : e[17].value)),
  2778083089: (e) => new a.IfcRoundedRectangleProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new a.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new a.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new a.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value)),
  2042790032: (e) => new a.IfcSectionProperties(e[0], new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2])),
  4165799628: (e) => {
    var t;
    return new a.IfcSectionReinforcementProperties(new a.IfcLengthMeasure((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new a.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), e[3], new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  1509187699: (e) => {
    var t, i;
    return new a.IfcSectionedSpine(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), ((t = e[1]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], ((i = e[2]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || []);
  },
  823603102: (e) => new a.IfcSegment(e[0]),
  4124623270: (e) => {
    var t;
    return new a.IfcShellBasedSurfaceModel(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  3692461612: (e) => new a.IfcSimpleProperty(new a.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  2609359061: (e) => new a.IfcSlippageConnectionCondition((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  723233188: (e) => new a.IfcSolidModel(),
  1595516126: (e) => new a.IfcStructuralLoadLinearForce((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLinearForceMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLinearForceMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcLinearForceMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLinearMomentMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcLinearMomentMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcLinearMomentMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  2668620305: (e) => new a.IfcStructuralLoadPlanarForce((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcPlanarForceMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcPlanarForceMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcPlanarForceMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2473145415: (e) => new a.IfcStructuralLoadSingleDisplacement((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcPlaneAngleMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcPlaneAngleMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcPlaneAngleMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  1973038258: (e) => new a.IfcStructuralLoadSingleDisplacementDistortion((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcPlaneAngleMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcPlaneAngleMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcPlaneAngleMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcCurvatureMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  1597423693: (e) => new a.IfcStructuralLoadSingleForce((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcForceMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcForceMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcForceMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcTorqueMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcTorqueMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcTorqueMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  1190533807: (e) => new a.IfcStructuralLoadSingleForceWarping((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcForceMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcForceMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcForceMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcTorqueMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcTorqueMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcTorqueMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcWarpingMomentMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  2233826070: (e) => new a.IfcSubedge(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2])),
  2513912981: (e) => new a.IfcSurface(),
  1878645084: (e) => new a.IfcSurfaceStyleRendering(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcNormalisedRatioMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : Li(3, e[7]), e[8]),
  2247615214: (e) => new a.IfcSweptAreaSolid(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1])),
  1260650574: (e) => new a.IfcSweptDiskSolid(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcPositiveLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcParameterValue((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcParameterValue((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  1096409881: (e) => new a.IfcSweptDiskSolidPolygonal(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcPositiveLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcParameterValue((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcParameterValue((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcNonNegativeLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value)),
  230924584: (e) => new a.IfcSweptSurface(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1])),
  3071757647: (e) => new a.IfcTShapeProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new a.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new a.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new a.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new a.IfcPositiveLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcNonNegativeLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcNonNegativeLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new a.IfcNonNegativeLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new a.IfcPlaneAngleMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new a.IfcPlaneAngleMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value)),
  901063453: (e) => new a.IfcTessellatedItem(),
  4282788508: (e) => new a.IfcTextLiteral(new a.IfcPresentableText((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), e[2]),
  3124975700: (e) => new a.IfcTextLiteralWithExtent(new a.IfcPresentableText((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), e[2], new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3]), new a.IfcBoxAlignment((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  1983826977: (e) => {
    var t;
    return new a.IfcTextStyleFontModel(new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new a.IfcTextFontName(i.value) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcFontStyle((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcFontVariant((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcFontWeight((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), Li(3, e[5]));
  },
  2715220739: (e) => new a.IfcTrapeziumProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new a.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new a.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new a.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new a.IfcLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  1628702193: (e) => {
    var t;
    return new a.IfcTypeObject(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  3736923433: (e) => {
    var t;
    return new a.IfcTypeProcess(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcIdentifier((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcText((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  2347495698: (e) => {
    var t, i;
    return new a.IfcTypeProduct(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value));
  },
  3698973494: (e) => {
    var t;
    return new a.IfcTypeResource(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcIdentifier((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcText((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  427810014: (e) => new a.IfcUShapeProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new a.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new a.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new a.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new a.IfcPositiveLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcNonNegativeLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcNonNegativeLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new a.IfcPlaneAngleMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value)),
  1417489154: (e) => new a.IfcVector(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  2759199220: (e) => new a.IfcVertexLoop(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0])),
  2543172580: (e) => new a.IfcZShapeProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new a.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new a.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new a.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new a.IfcPositiveLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcNonNegativeLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcNonNegativeLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  3406155212: (e) => {
    var t;
    return new a.IfcAdvancedFace(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), new a.IfcBoolean((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value));
  },
  669184980: (e) => {
    var t;
    return new a.IfcAnnotationFillArea(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  3207858831: (e) => new a.IfcAsymmetricIShapeProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new a.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new a.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new a.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new a.IfcPositiveLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcNonNegativeLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), new a.IfcPositiveLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new a.IfcPositiveLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new a.IfcNonNegativeLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new a.IfcNonNegativeLengthMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new a.IfcPlaneAngleMeasure((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), (e[13] ?? void 0) === void 0 || e[13] === "" ? null : new a.IfcNonNegativeLengthMeasure((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value), (e[14] ?? void 0) === void 0 || e[14] === "" ? null : new a.IfcPlaneAngleMeasure((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value)),
  4261334040: (e) => new a.IfcAxis1Placement(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1])),
  3125803723: (e) => new a.IfcAxis2Placement2D(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1])),
  2740243338: (e) => new a.IfcAxis2Placement3D(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2])),
  3425423356: (e) => new a.IfcAxis2PlacementLinear(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2])),
  2736907675: (e) => new a.IfcBooleanResult(e[0], new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2])),
  4182860854: (e) => new a.IfcBoundedSurface(),
  2581212453: (e) => new a.IfcBoundingBox(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new a.IfcPositiveLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new a.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2713105998: (e) => new a.IfcBoxedHalfSpace(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcBoolean((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2])),
  2898889636: (e) => new a.IfcCShapeProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new a.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new a.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new a.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new a.IfcPositiveLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcNonNegativeLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  1123145078: (e) => {
    var t;
    return new a.IfcCartesianPoint(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new a.IfcLengthMeasure(i.value) : null)) || []);
  },
  574549367: (e) => new a.IfcCartesianPointList(),
  1675464909: (e) => {
    var t, i;
    return new a.IfcCartesianPointList2D((t = e[0]) == null ? void 0 : t.map((n) => (n == null ? void 0 : n.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new a.IfcLengthMeasure(s.value) : null)) || []), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : ((i = e[1]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new a.IfcLabel(n.value) : null)) || []);
  },
  2059837836: (e) => {
    var t, i;
    return new a.IfcCartesianPointList3D((t = e[0]) == null ? void 0 : t.map((n) => (n == null ? void 0 : n.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new a.IfcLengthMeasure(s.value) : null)) || []), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : ((i = e[1]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new a.IfcLabel(n.value) : null)) || []);
  },
  59481748: (e) => new a.IfcCartesianTransformationOperator((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcReal((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  3749851601: (e) => new a.IfcCartesianTransformationOperator2D((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcReal((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  3486308946: (e) => new a.IfcCartesianTransformationOperator2DnonUniform((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcReal((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcReal((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  3331915920: (e) => new a.IfcCartesianTransformationOperator3D((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcReal((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4])),
  1416205885: (e) => new a.IfcCartesianTransformationOperator3DnonUniform((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcReal((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcReal((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcReal((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  1383045692: (e) => new a.IfcCircleProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new a.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2205249479: (e) => {
    var t;
    return new a.IfcClosedShell(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  776857604: (e) => new a.IfcColourRgb((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new a.IfcNormalisedRatioMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new a.IfcNormalisedRatioMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new a.IfcNormalisedRatioMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2542286263: (e) => {
    var t;
    return new a.IfcComplexProperty(new a.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new a.IfcIdentifier((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), ((t = e[3]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  2485617015: (e) => new a.IfcCompositeCurveSegment(e[0], new a.IfcBoolean((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2])),
  2574617495: (e) => {
    var t, i;
    return new a.IfcConstructionResourceType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcIdentifier((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcText((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : ((i = e[9]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 3, e[10]));
  },
  3419103109: (e) => {
    var t;
    return new a.IfcContext(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((t = e[7]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 3, e[8]));
  },
  1815067380: (e) => {
    var t, i;
    return new a.IfcCrewResourceType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcIdentifier((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcText((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : ((i = e[9]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 3, e[10]), e[11]);
  },
  2506170314: (e) => new a.IfcCsgPrimitive3D(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0])),
  2147822146: (e) => new a.IfcCsgSolid(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0])),
  2601014836: (e) => new a.IfcCurve(),
  2827736869: (e) => {
    var t;
    return new a.IfcCurveBoundedPlane(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  2629017746: (e) => {
    var t;
    return new a.IfcCurveBoundedSurface(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], new a.IfcBoolean((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value));
  },
  4212018352: (e) => new a.IfcCurveSegment(e[0], new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), Li(3, e[2]), Li(3, e[3]), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4])),
  32440307: (e) => {
    var t;
    return new a.IfcDirection(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new a.IfcReal(i.value) : null)) || []);
  },
  593015953: (e) => new a.IfcDirectrixCurveSweptAreaSolid(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : Li(3, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : Li(3, e[4])),
  1472233963: (e) => {
    var t;
    return new a.IfcEdgeLoop(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  1883228015: (e) => {
    var t;
    return new a.IfcElementQuantity(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  339256511: (e) => {
    var t, i;
    return new a.IfcElementType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  2777663545: (e) => new a.IfcElementarySurface(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0])),
  2835456948: (e) => new a.IfcEllipseProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new a.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new a.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  4024345920: (e) => {
    var t;
    return new a.IfcEventType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcIdentifier((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcText((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9], e[10], (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new a.IfcLabel((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value));
  },
  477187591: (e) => new a.IfcExtrudedAreaSolid(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new a.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2804161546: (e) => new a.IfcExtrudedAreaSolidTapered(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new a.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4])),
  2047409740: (e) => {
    var t;
    return new a.IfcFaceBasedSurfaceModel(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  374418227: (e) => new a.IfcFillAreaStyleHatching(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3]), new a.IfcPlaneAngleMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  315944413: (e) => {
    var t, i;
    return new a.IfcFillAreaStyleTiles(((t = e[0]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], ((i = e[1]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], new a.IfcPositiveRatioMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value));
  },
  2652556860: (e) => new a.IfcFixedReferenceSweptAreaSolid(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : Li(3, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : Li(3, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5])),
  4238390223: (e) => {
    var t, i;
    return new a.IfcFurnishingElementType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  1268542332: (e) => {
    var t, i;
    return new a.IfcFurnitureType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9], e[10]);
  },
  4095422895: (e) => {
    var t, i;
    return new a.IfcGeographicElementType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  987898635: (e) => {
    var t;
    return new a.IfcGeometricCurveSet(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  1484403080: (e) => new a.IfcIShapeProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new a.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new a.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new a.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new a.IfcPositiveLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcNonNegativeLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcNonNegativeLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new a.IfcPlaneAngleMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value)),
  178912537: (e) => {
    var t;
    return new a.IfcIndexedPolygonalFace(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new a.IfcPositiveInteger(i.value) : null)) || []);
  },
  2294589976: (e) => {
    var t, i;
    return new a.IfcIndexedPolygonalFaceWithVoids(((t = e[0]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new a.IfcPositiveInteger(n.value) : null)) || [], (i = e[1]) == null ? void 0 : i.map((n) => (n == null ? void 0 : n.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new a.IfcPositiveInteger(s.value) : null)) || []));
  },
  3465909080: (e) => {
    var t, i;
    return new a.IfcIndexedPolygonalTextureMap(((t = e[0]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), ((i = e[3]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || []);
  },
  572779678: (e) => new a.IfcLShapeProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new a.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new a.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcNonNegativeLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcNonNegativeLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcPlaneAngleMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  428585644: (e) => {
    var t, i;
    return new a.IfcLaborResourceType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcIdentifier((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcText((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : ((i = e[9]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 3, e[10]), e[11]);
  },
  1281925730: (e) => new a.IfcLine(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1])),
  1425443689: (e) => new a.IfcManifoldSolidBrep(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0])),
  3888040117: (e) => new a.IfcObject(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  590820931: (e) => new a.IfcOffsetCurve(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0])),
  3388369263: (e) => new a.IfcOffsetCurve2D(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new a.IfcLogical((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  3505215534: (e) => new a.IfcOffsetCurve3D(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new a.IfcLogical((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3])),
  2485787929: (e) => {
    var t;
    return new a.IfcOffsetCurveByDistances(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value));
  },
  1682466193: (e) => new a.IfcPcurve(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1])),
  603570806: (e) => new a.IfcPlanarBox(new a.IfcLengthMeasure((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new a.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2])),
  220341763: (e) => new a.IfcPlane(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0])),
  3381221214: (e) => {
    var t, i, n;
    return new a.IfcPolynomialCurve(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : ((t = e[1]) == null ? void 0 : t.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new a.IfcReal(s.value) : null)) || [], (e[2] ?? void 0) === void 0 || e[2] === "" ? null : ((i = e[2]) == null ? void 0 : i.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new a.IfcReal(s.value) : null)) || [], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : ((n = e[3]) == null ? void 0 : n.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new a.IfcReal(s.value) : null)) || []);
  },
  759155922: (e) => new a.IfcPreDefinedColour(new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  2559016684: (e) => new a.IfcPreDefinedCurveFont(new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  3967405729: (e) => new a.IfcPreDefinedPropertySet(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  569719735: (e) => {
    var t;
    return new a.IfcProcedureType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcIdentifier((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcText((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2945172077: (e) => new a.IfcProcess(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcText((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  4208778838: (e) => new a.IfcProduct(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6])),
  103090709: (e) => {
    var t;
    return new a.IfcProject(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((t = e[7]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 3, e[8]));
  },
  653396225: (e) => {
    var t;
    return new a.IfcProjectLibrary(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((t = e[7]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 3, e[8]));
  },
  871118103: (e) => new a.IfcPropertyBoundedValue(new a.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : Li(3, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : Li(3, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : Li(3, e[5])),
  4166981789: (e) => {
    var t;
    return new a.IfcPropertyEnumeratedValue(new a.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? Li(3, i) : null)) || [], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3]));
  },
  2752243245: (e) => {
    var t;
    return new a.IfcPropertyListValue(new a.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : ((t = e[2]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? Li(3, i) : null)) || [], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3]));
  },
  941946838: (e) => new a.IfcPropertyReferenceValue(new a.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcText((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3])),
  1451395588: (e) => {
    var t;
    return new a.IfcPropertySet(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  492091185: (e) => {
    var t;
    return new a.IfcPropertySetTemplate(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), e[4], (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), ((t = e[6]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  3650150729: (e) => new a.IfcPropertySingleValue(new a.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : Li(3, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3])),
  110355661: (e) => {
    var t, i;
    return new a.IfcPropertyTableValue(new a.IfcIdentifier((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcText((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : ((t = e[2]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? Li(3, n) : null)) || [], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : ((i = e[3]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? Li(3, n) : null)) || [], (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcText((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), e[7]);
  },
  3521284610: (e) => new a.IfcPropertyTemplate(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2770003689: (e) => new a.IfcRectangleHollowProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new a.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new a.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new a.IfcPositiveLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcNonNegativeLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcNonNegativeLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  2798486643: (e) => new a.IfcRectangularPyramid(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new a.IfcPositiveLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new a.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  3454111270: (e) => new a.IfcRectangularTrimmedSurface(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcParameterValue((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new a.IfcParameterValue((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new a.IfcParameterValue((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new a.IfcParameterValue((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new a.IfcBoolean((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new a.IfcBoolean((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  3765753017: (e) => {
    var t;
    return new a.IfcReinforcementDefinitionProperties(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  3939117080: (e) => {
    var t;
    return new a.IfcRelAssigns(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], e[5]);
  },
  1683148259: (e) => {
    var t;
    return new a.IfcRelAssignsToActor(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], e[5], new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7]));
  },
  2495723537: (e) => {
    var t;
    return new a.IfcRelAssignsToControl(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], e[5], new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]));
  },
  1307041759: (e) => {
    var t;
    return new a.IfcRelAssignsToGroup(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], e[5], new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]));
  },
  1027710054: (e) => {
    var t;
    return new a.IfcRelAssignsToGroupByFactor(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], e[5], new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), new a.IfcRatioMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value));
  },
  4278684876: (e) => {
    var t;
    return new a.IfcRelAssignsToProcess(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], e[5], new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7]));
  },
  2857406711: (e) => {
    var t;
    return new a.IfcRelAssignsToProduct(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], e[5], new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]));
  },
  205026976: (e) => {
    var t;
    return new a.IfcRelAssignsToResource(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], e[5], new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]));
  },
  1865459582: (e) => {
    var t;
    return new a.IfcRelAssociates(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  4095574036: (e) => {
    var t;
    return new a.IfcRelAssociatesApproval(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]));
  },
  919958153: (e) => {
    var t;
    return new a.IfcRelAssociatesClassification(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]));
  },
  2728634034: (e) => {
    var t;
    return new a.IfcRelAssociatesConstraint(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]));
  },
  982818633: (e) => {
    var t;
    return new a.IfcRelAssociatesDocument(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]));
  },
  3840914261: (e) => {
    var t;
    return new a.IfcRelAssociatesLibrary(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]));
  },
  2655215786: (e) => {
    var t;
    return new a.IfcRelAssociatesMaterial(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]));
  },
  1033248425: (e) => {
    var t;
    return new a.IfcRelAssociatesProfileDef(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]));
  },
  826625072: (e) => new a.IfcRelConnects(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  1204542856: (e) => new a.IfcRelConnectsElements(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6])),
  3945020480: (e) => {
    var t, i;
    return new a.IfcRelConnectsPathElements(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((t = e[7]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new a.IfcInteger(n.value) : null)) || [], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : ((i = e[8]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new a.IfcInteger(n.value) : null)) || [], e[9], e[10]);
  },
  4201705270: (e) => new a.IfcRelConnectsPortToElement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5])),
  3190031847: (e) => new a.IfcRelConnectsPorts(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6])),
  2127690289: (e) => new a.IfcRelConnectsStructuralActivity(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5])),
  1638771189: (e) => new a.IfcRelConnectsStructuralMember(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7]), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 3, e[9])),
  504942748: (e) => new a.IfcRelConnectsWithEccentricity(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7]), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 3, e[9]), new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 3, e[10])),
  3678494232: (e) => {
    var t;
    return new a.IfcRelConnectsWithRealizingElements(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), ((t = e[7]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  3242617779: (e) => {
    var t;
    return new a.IfcRelContainedInSpatialStructure(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]));
  },
  886880790: (e) => {
    var t;
    return new a.IfcRelCoversBldgElements(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  2802773753: (e) => {
    var t;
    return new a.IfcRelCoversSpaces(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  2565941209: (e) => {
    var t;
    return new a.IfcRelDeclares(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  2551354335: (e) => new a.IfcRelDecomposes(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  693640335: (e) => new a.IfcRelDefines(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  1462361463: (e) => {
    var t;
    return new a.IfcRelDefinesByObject(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]));
  },
  4186316022: (e) => {
    var t;
    return new a.IfcRelDefinesByProperties(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]));
  },
  307848117: (e) => {
    var t;
    return new a.IfcRelDefinesByTemplate(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]));
  },
  781010003: (e) => {
    var t;
    return new a.IfcRelDefinesByType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]));
  },
  3940055652: (e) => new a.IfcRelFillsElement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5])),
  279856033: (e) => {
    var t;
    return new a.IfcRelFlowControlElements(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]));
  },
  427948657: (e) => new a.IfcRelInterferesElements(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7]), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcIdentifier((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), new a.IfcLogical((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value)),
  3268803585: (e) => {
    var t;
    return new a.IfcRelNests(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  1441486842: (e) => {
    var t;
    return new a.IfcRelPositions(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  750771296: (e) => new a.IfcRelProjectsElement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5])),
  1245217292: (e) => {
    var t;
    return new a.IfcRelReferencedInSpatialStructure(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), ((t = e[4]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]));
  },
  4122056220: (e) => new a.IfcRelSequence(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), e[7], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  366585022: (e) => {
    var t;
    return new a.IfcRelServicesBuildings(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  3451746338: (e) => new a.IfcRelSpaceBoundary(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), e[7], e[8]),
  3523091289: (e) => new a.IfcRelSpaceBoundary1stLevel(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), e[7], e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 3, e[9])),
  1521410863: (e) => new a.IfcRelSpaceBoundary2ndLevel(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), e[7], e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 3, e[9]), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 3, e[10])),
  1401173127: (e) => new a.IfcRelVoidsElement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5])),
  816062949: (e) => new a.IfcReparametrisedCompositeCurveSegment(e[0], new a.IfcBoolean((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new a.IfcParameterValue((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  2914609552: (e) => new a.IfcResource(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcText((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  1856042241: (e) => new a.IfcRevolvedAreaSolid(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new a.IfcPlaneAngleMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  3243963512: (e) => new a.IfcRevolvedAreaSolidTapered(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new a.IfcPlaneAngleMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4])),
  4158566097: (e) => new a.IfcRightCircularCone(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new a.IfcPositiveLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  3626867408: (e) => new a.IfcRightCircularCylinder(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new a.IfcPositiveLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  1862484736: (e) => {
    var t;
    return new a.IfcSectionedSolid(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  1290935644: (e) => {
    var t, i;
    return new a.IfcSectionedSolidHorizontal(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), ((t = e[1]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], ((i = e[2]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || []);
  },
  1356537516: (e) => {
    var t, i;
    return new a.IfcSectionedSurface(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), ((t = e[1]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], ((i = e[2]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || []);
  },
  3663146110: (e) => new a.IfcSimplePropertyTemplate(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), e[4], (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7]), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 3, e[8]), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 3, e[9]), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new a.IfcLabel((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), e[11]),
  1412071761: (e) => new a.IfcSpatialElement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  710998568: (e) => {
    var t, i;
    return new a.IfcSpatialElementType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  2706606064: (e) => new a.IfcSpatialStructureElement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3893378262: (e) => {
    var t, i;
    return new a.IfcSpatialStructureElementType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  463610769: (e) => new a.IfcSpatialZone(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2481509218: (e) => {
    var t, i;
    return new a.IfcSpatialZoneType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new a.IfcLabel((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value));
  },
  451544542: (e) => new a.IfcSphere(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  4015995234: (e) => new a.IfcSphericalSurface(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  2735484536: (e) => new a.IfcSpiral((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0])),
  3544373492: (e) => new a.IfcStructuralActivity(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7]), e[8]),
  3136571912: (e) => new a.IfcStructuralItem(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6])),
  530289379: (e) => new a.IfcStructuralMember(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6])),
  3689010777: (e) => new a.IfcStructuralReaction(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7]), e[8]),
  3979015343: (e) => new a.IfcStructuralSurfaceMember(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), e[7], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcPositiveLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  2218152070: (e) => new a.IfcStructuralSurfaceMemberVarying(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), e[7], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcPositiveLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  603775116: (e) => new a.IfcStructuralSurfaceReaction(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7]), e[8], e[9]),
  4095615324: (e) => {
    var t, i;
    return new a.IfcSubContractResourceType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcIdentifier((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcText((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : ((i = e[9]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 3, e[10]), e[11]);
  },
  699246055: (e) => {
    var t;
    return new a.IfcSurfaceCurve(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], e[2]);
  },
  2028607225: (e) => new a.IfcSurfaceCurveSweptAreaSolid(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : Li(3, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : Li(3, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5])),
  2809605785: (e) => new a.IfcSurfaceOfLinearExtrusion(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new a.IfcLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  4124788165: (e) => new a.IfcSurfaceOfRevolution(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2])),
  1580310250: (e) => {
    var t, i;
    return new a.IfcSystemFurnitureElementType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3473067441: (e) => new a.IfcTask(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcText((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), new a.IfcBoolean((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new a.IfcInteger((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new u((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value, 3, e[11]), e[12]),
  3206491090: (e) => {
    var t;
    return new a.IfcTaskType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcIdentifier((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcText((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new a.IfcLabel((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value));
  },
  2387106220: (e) => new a.IfcTessellatedFaceSet(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcBoolean((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  782932809: (e) => new a.IfcThirdOrderPolynomialSpiral((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  1935646853: (e) => new a.IfcToroidalSurface(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new a.IfcPositiveLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  3665877780: (e) => {
    var t, i;
    return new a.IfcTransportationDeviceType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  2916149573: (e) => {
    var t, i, n;
    return new a.IfcTriangulatedFaceSet(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcBoolean((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : (t = e[2]) == null ? void 0 : t.map((s) => (s == null ? void 0 : s.map((o) => ((o == null ? void 0 : o.value) ?? void 0) !== void 0 && (o == null ? void 0 : o.value) !== "" ? new a.IfcParameterValue(o.value) : null)) || []), (i = e[3]) == null ? void 0 : i.map((s) => (s == null ? void 0 : s.map((o) => ((o == null ? void 0 : o.value) ?? void 0) !== void 0 && (o == null ? void 0 : o.value) !== "" ? new a.IfcPositiveInteger(o.value) : null)) || []), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : ((n = e[4]) == null ? void 0 : n.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new a.IfcPositiveInteger(s.value) : null)) || []);
  },
  1229763772: (e) => {
    var t, i, n, s;
    return new a.IfcTriangulatedIrregularNetwork(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcBoolean((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : (t = e[2]) == null ? void 0 : t.map((o) => (o == null ? void 0 : o.map((r) => ((r == null ? void 0 : r.value) ?? void 0) !== void 0 && (r == null ? void 0 : r.value) !== "" ? new a.IfcParameterValue(r.value) : null)) || []), (i = e[3]) == null ? void 0 : i.map((o) => (o == null ? void 0 : o.map((r) => ((r == null ? void 0 : r.value) ?? void 0) !== void 0 && (r == null ? void 0 : r.value) !== "" ? new a.IfcPositiveInteger(r.value) : null)) || []), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : ((n = e[4]) == null ? void 0 : n.map((o) => ((o == null ? void 0 : o.value) ?? void 0) !== void 0 && (o == null ? void 0 : o.value) !== "" ? new a.IfcPositiveInteger(o.value) : null)) || [], ((s = e[5]) == null ? void 0 : s.map((o) => ((o == null ? void 0 : o.value) ?? void 0) !== void 0 && (o == null ? void 0 : o.value) !== "" ? new a.IfcInteger(o.value) : null)) || []);
  },
  3651464721: (e) => {
    var t, i;
    return new a.IfcVehicleType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  336235671: (e) => new a.IfcWindowLiningProperties(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcNonNegativeLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcNonNegativeLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcNonNegativeLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcNormalisedRatioMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new a.IfcNormalisedRatioMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new a.IfcNormalisedRatioMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new a.IfcNormalisedRatioMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new u((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value, 3, e[12]), (e[13] ?? void 0) === void 0 || e[13] === "" ? null : new a.IfcLengthMeasure((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value), (e[14] ?? void 0) === void 0 || e[14] === "" ? null : new a.IfcLengthMeasure((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value), (e[15] ?? void 0) === void 0 || e[15] === "" ? null : new a.IfcLengthMeasure((e[15] ?? void 0) === void 0 || e[15] === "" ? null : e[15].value)),
  512836454: (e) => new a.IfcWindowPanelProperties(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), e[4], e[5], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcPositiveLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcPositiveLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 3, e[8])),
  2296667514: (e) => new a.IfcActor(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5])),
  1635779807: (e) => new a.IfcAdvancedBrep(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0])),
  2603310189: (e) => {
    var t;
    return new a.IfcAdvancedBrepWithVoids(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  1674181508: (e) => new a.IfcAnnotation(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), e[7]),
  2887950389: (e) => {
    var t;
    return new a.IfcBSplineSurface(new a.IfcInteger((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new a.IfcInteger((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (t = e[2]) == null ? void 0 : t.map((i) => (i == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || []), e[3], new a.IfcLogical((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new a.IfcLogical((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new a.IfcLogical((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value));
  },
  167062518: (e) => {
    var t, i, n, s, o;
    return new a.IfcBSplineSurfaceWithKnots(new a.IfcInteger((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new a.IfcInteger((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (t = e[2]) == null ? void 0 : t.map((r) => (r == null ? void 0 : r.map((l) => ((l == null ? void 0 : l.value) ?? void 0) !== void 0 && (l == null ? void 0 : l.value) !== "" ? new u(l.value, 3, l) : null)) || []), e[3], new a.IfcLogical((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new a.IfcLogical((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new a.IfcLogical((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), ((i = e[7]) == null ? void 0 : i.map((r) => ((r == null ? void 0 : r.value) ?? void 0) !== void 0 && (r == null ? void 0 : r.value) !== "" ? new a.IfcInteger(r.value) : null)) || [], ((n = e[8]) == null ? void 0 : n.map((r) => ((r == null ? void 0 : r.value) ?? void 0) !== void 0 && (r == null ? void 0 : r.value) !== "" ? new a.IfcInteger(r.value) : null)) || [], ((s = e[9]) == null ? void 0 : s.map((r) => ((r == null ? void 0 : r.value) ?? void 0) !== void 0 && (r == null ? void 0 : r.value) !== "" ? new a.IfcParameterValue(r.value) : null)) || [], ((o = e[10]) == null ? void 0 : o.map((r) => ((r == null ? void 0 : r.value) ?? void 0) !== void 0 && (r == null ? void 0 : r.value) !== "" ? new a.IfcParameterValue(r.value) : null)) || [], e[11]);
  },
  1334484129: (e) => new a.IfcBlock(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new a.IfcPositiveLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), new a.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  3649129432: (e) => new a.IfcBooleanClippingResult(e[0], new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2])),
  1260505505: (e) => new a.IfcBoundedCurve(),
  3124254112: (e) => new a.IfcBuildingStorey(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new a.IfcLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value)),
  1626504194: (e) => {
    var t, i;
    return new a.IfcBuiltElementType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  2197970202: (e) => {
    var t, i;
    return new a.IfcChimneyType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2937912522: (e) => new a.IfcCircleHollowProfileDef(e[0], (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcLabel((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), new a.IfcPositiveLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new a.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  3893394355: (e) => {
    var t, i;
    return new a.IfcCivilElementType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  3497074424: (e) => new a.IfcClothoid((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  300633059: (e) => {
    var t, i;
    return new a.IfcColumnType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3875453745: (e) => {
    var t;
    return new a.IfcComplexPropertyTemplate(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), e[5], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((t = e[6]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  3732776249: (e) => {
    var t;
    return new a.IfcCompositeCurve(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], new a.IfcLogical((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value));
  },
  15328376: (e) => {
    var t;
    return new a.IfcCompositeCurveOnSurface(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], new a.IfcLogical((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value));
  },
  2510884976: (e) => new a.IfcConic(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0])),
  2185764099: (e) => {
    var t, i;
    return new a.IfcConstructionEquipmentResourceType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcIdentifier((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcText((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : ((i = e[9]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 3, e[10]), e[11]);
  },
  4105962743: (e) => {
    var t, i;
    return new a.IfcConstructionMaterialResourceType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcIdentifier((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcText((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : ((i = e[9]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 3, e[10]), e[11]);
  },
  1525564444: (e) => {
    var t, i;
    return new a.IfcConstructionProductResourceType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcIdentifier((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcText((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : ((i = e[9]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 3, e[10]), e[11]);
  },
  2559216714: (e) => {
    var t;
    return new a.IfcConstructionResource(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcText((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7]), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : ((t = e[8]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 3, e[9]));
  },
  3293443760: (e) => new a.IfcControl(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value)),
  2000195564: (e) => new a.IfcCosineSpiral((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  3895139033: (e) => {
    var t, i;
    return new a.IfcCostItem(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), e[6], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((t = e[7]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : ((i = e[8]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || []);
  },
  1419761937: (e) => new a.IfcCostSchedule(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), e[6], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcDateTime((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new a.IfcDateTime((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value)),
  4189326743: (e) => {
    var t, i;
    return new a.IfcCourseType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1916426348: (e) => {
    var t, i;
    return new a.IfcCoveringType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3295246426: (e) => {
    var t;
    return new a.IfcCrewResource(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcText((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7]), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : ((t = e[8]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 3, e[9]), e[10]);
  },
  1457835157: (e) => {
    var t, i;
    return new a.IfcCurtainWallType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1213902940: (e) => new a.IfcCylindricalSurface(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  1306400036: (e) => {
    var t, i;
    return new a.IfcDeepFoundationType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  4234616927: (e) => new a.IfcDirectrixDerivedReferenceSweptAreaSolid(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : Li(3, e[3]), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : Li(3, e[4]), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5])),
  3256556792: (e) => {
    var t, i;
    return new a.IfcDistributionElementType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  3849074793: (e) => {
    var t, i;
    return new a.IfcDistributionFlowElementType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  2963535650: (e) => new a.IfcDoorLiningProperties(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcNonNegativeLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcPositiveLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcNonNegativeLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcNonNegativeLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new a.IfcLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new a.IfcLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new a.IfcLengthMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new a.IfcPositiveLengthMeasure((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), (e[13] ?? void 0) === void 0 || e[13] === "" ? null : new a.IfcPositiveLengthMeasure((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value), (e[14] ?? void 0) === void 0 || e[14] === "" ? null : new u((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value, 3, e[14]), (e[15] ?? void 0) === void 0 || e[15] === "" ? null : new a.IfcLengthMeasure((e[15] ?? void 0) === void 0 || e[15] === "" ? null : e[15].value), (e[16] ?? void 0) === void 0 || e[16] === "" ? null : new a.IfcLengthMeasure((e[16] ?? void 0) === void 0 || e[16] === "" ? null : e[16].value)),
  1714330368: (e) => new a.IfcDoorPanelProperties(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcPositiveLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), e[5], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcNormalisedRatioMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), e[7], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 3, e[8])),
  2323601079: (e) => {
    var t, i;
    return new a.IfcDoorType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9], e[10], (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new a.IfcBoolean((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new a.IfcLabel((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value));
  },
  445594917: (e) => new a.IfcDraughtingPreDefinedColour(new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  4006246654: (e) => new a.IfcDraughtingPreDefinedCurveFont(new a.IfcLabel((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value)),
  1758889154: (e) => new a.IfcElement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  4123344466: (e) => new a.IfcElementAssembly(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], e[9]),
  2397081782: (e) => {
    var t, i;
    return new a.IfcElementAssemblyType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1623761950: (e) => new a.IfcElementComponent(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  2590856083: (e) => {
    var t, i;
    return new a.IfcElementComponentType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  1704287377: (e) => new a.IfcEllipse(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new a.IfcPositiveLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value)),
  2107101300: (e) => {
    var t, i;
    return new a.IfcEnergyConversionDeviceType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  132023988: (e) => {
    var t, i;
    return new a.IfcEngineType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3174744832: (e) => {
    var t, i;
    return new a.IfcEvaporativeCoolerType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3390157468: (e) => {
    var t, i;
    return new a.IfcEvaporatorType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  4148101412: (e) => new a.IfcEvent(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcText((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), e[7], e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new a.IfcLabel((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 3, e[10])),
  2853485674: (e) => new a.IfcExternalSpatialStructureElement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  807026263: (e) => new a.IfcFacetedBrep(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0])),
  3737207727: (e) => {
    var t;
    return new a.IfcFacetedBrepWithVoids(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  24185140: (e) => new a.IfcFacility(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1310830890: (e) => new a.IfcFacilityPart(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], e[9]),
  4228831410: (e) => new a.IfcFacilityPartCommon(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], e[9], e[10]),
  647756555: (e) => new a.IfcFastener(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2489546625: (e) => {
    var t, i;
    return new a.IfcFastenerType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2827207264: (e) => new a.IfcFeatureElement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  2143335405: (e) => new a.IfcFeatureElementAddition(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  1287392070: (e) => new a.IfcFeatureElementSubtraction(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  3907093117: (e) => {
    var t, i;
    return new a.IfcFlowControllerType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  3198132628: (e) => {
    var t, i;
    return new a.IfcFlowFittingType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  3815607619: (e) => {
    var t, i;
    return new a.IfcFlowMeterType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1482959167: (e) => {
    var t, i;
    return new a.IfcFlowMovingDeviceType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  1834744321: (e) => {
    var t, i;
    return new a.IfcFlowSegmentType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  1339347760: (e) => {
    var t, i;
    return new a.IfcFlowStorageDeviceType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  2297155007: (e) => {
    var t, i;
    return new a.IfcFlowTerminalType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  3009222698: (e) => {
    var t, i;
    return new a.IfcFlowTreatmentDeviceType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  1893162501: (e) => {
    var t, i;
    return new a.IfcFootingType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  263784265: (e) => new a.IfcFurnishingElement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  1509553395: (e) => new a.IfcFurniture(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3493046030: (e) => new a.IfcGeographicElement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  4230923436: (e) => new a.IfcGeotechnicalElement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  1594536857: (e) => new a.IfcGeotechnicalStratum(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2898700619: (e) => {
    var t;
    return new a.IfcGradientCurve(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], new a.IfcLogical((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3]));
  },
  2706460486: (e) => new a.IfcGroup(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  1251058090: (e) => {
    var t, i;
    return new a.IfcHeatExchangerType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1806887404: (e) => {
    var t, i;
    return new a.IfcHumidifierType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2568555532: (e) => new a.IfcImpactProtectionDevice(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3948183225: (e) => {
    var t, i;
    return new a.IfcImpactProtectionDeviceType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2571569899: (e) => {
    var t;
    return new a.IfcIndexedPolyCurve(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? Li(3, i) : null)) || [], new a.IfcLogical((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value));
  },
  3946677679: (e) => {
    var t, i;
    return new a.IfcInterceptorType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3113134337: (e) => {
    var t;
    return new a.IfcIntersectionCurve(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], e[2]);
  },
  2391368822: (e) => {
    var t;
    return new a.IfcInventory(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), e[5], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((t = e[7]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcDate((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 3, e[9]), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 3, e[10]));
  },
  4288270099: (e) => {
    var t, i;
    return new a.IfcJunctionBoxType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  679976338: (e) => {
    var t, i;
    return new a.IfcKerbType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), new a.IfcBoolean((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value));
  },
  3827777499: (e) => {
    var t;
    return new a.IfcLaborResource(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcText((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7]), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : ((t = e[8]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 3, e[9]), e[10]);
  },
  1051575348: (e) => {
    var t, i;
    return new a.IfcLampType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1161773419: (e) => {
    var t, i;
    return new a.IfcLightFixtureType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2176059722: (e) => new a.IfcLinearElement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6])),
  1770583370: (e) => {
    var t, i;
    return new a.IfcLiquidTerminalType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  525669439: (e) => new a.IfcMarineFacility(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], e[9]),
  976884017: (e) => new a.IfcMarinePart(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], e[9], e[10]),
  377706215: (e) => new a.IfcMechanicalFastener(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcPositiveLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new a.IfcPositiveLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), e[10]),
  2108223431: (e) => {
    var t, i;
    return new a.IfcMechanicalFastenerType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new a.IfcPositiveLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new a.IfcPositiveLengthMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value));
  },
  1114901282: (e) => {
    var t, i;
    return new a.IfcMedicalDeviceType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3181161470: (e) => {
    var t, i;
    return new a.IfcMemberType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1950438474: (e) => {
    var t, i;
    return new a.IfcMobileTelecommunicationsApplianceType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  710110818: (e) => {
    var t, i;
    return new a.IfcMooringDeviceType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  977012517: (e) => {
    var t, i;
    return new a.IfcMotorConnectionType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  506776471: (e) => {
    var t, i;
    return new a.IfcNavigationElementType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  4143007308: (e) => new a.IfcOccupant(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), e[6]),
  3588315303: (e) => new a.IfcOpeningElement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2837617999: (e) => {
    var t, i;
    return new a.IfcOutletType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  514975943: (e) => {
    var t, i;
    return new a.IfcPavementType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2382730787: (e) => new a.IfcPerformanceHistory(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new a.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), e[7]),
  3566463478: (e) => new a.IfcPermeableCoveringProperties(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), e[4], e[5], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcPositiveLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcPositiveLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 3, e[8])),
  3327091369: (e) => new a.IfcPermit(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), e[6], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcText((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  1158309216: (e) => {
    var t, i;
    return new a.IfcPileType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  804291784: (e) => {
    var t, i;
    return new a.IfcPipeFittingType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  4231323485: (e) => {
    var t, i;
    return new a.IfcPipeSegmentType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  4017108033: (e) => {
    var t, i;
    return new a.IfcPlateType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2839578677: (e) => {
    var t, i;
    return new a.IfcPolygonalFaceSet(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new a.IfcBoolean((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), ((t = e[2]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[3] ?? void 0) === void 0 || e[3] === "" ? null : ((i = e[3]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new a.IfcPositiveInteger(n.value) : null)) || []);
  },
  3724593414: (e) => {
    var t;
    return new a.IfcPolyline(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  3740093272: (e) => new a.IfcPort(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6])),
  1946335990: (e) => new a.IfcPositioningElement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6])),
  2744685151: (e) => new a.IfcProcedure(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcText((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), e[7]),
  2904328755: (e) => new a.IfcProjectOrder(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), e[6], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcText((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  3651124850: (e) => new a.IfcProjectionElement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1842657554: (e) => {
    var t, i;
    return new a.IfcProtectiveDeviceType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2250791053: (e) => {
    var t, i;
    return new a.IfcPumpType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1763565496: (e) => {
    var t, i;
    return new a.IfcRailType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2893384427: (e) => {
    var t, i;
    return new a.IfcRailingType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3992365140: (e) => new a.IfcRailway(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], e[9]),
  1891881377: (e) => new a.IfcRailwayPart(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], e[9], e[10]),
  2324767716: (e) => {
    var t, i;
    return new a.IfcRampFlightType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1469900589: (e) => {
    var t, i;
    return new a.IfcRampType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  683857671: (e) => {
    var t, i, n, s, o, r;
    return new a.IfcRationalBSplineSurfaceWithKnots(new a.IfcInteger((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), new a.IfcInteger((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (t = e[2]) == null ? void 0 : t.map((l) => (l == null ? void 0 : l.map((c) => ((c == null ? void 0 : c.value) ?? void 0) !== void 0 && (c == null ? void 0 : c.value) !== "" ? new u(c.value, 3, c) : null)) || []), e[3], new a.IfcLogical((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), new a.IfcLogical((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new a.IfcLogical((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), ((i = e[7]) == null ? void 0 : i.map((l) => ((l == null ? void 0 : l.value) ?? void 0) !== void 0 && (l == null ? void 0 : l.value) !== "" ? new a.IfcInteger(l.value) : null)) || [], ((n = e[8]) == null ? void 0 : n.map((l) => ((l == null ? void 0 : l.value) ?? void 0) !== void 0 && (l == null ? void 0 : l.value) !== "" ? new a.IfcInteger(l.value) : null)) || [], ((s = e[9]) == null ? void 0 : s.map((l) => ((l == null ? void 0 : l.value) ?? void 0) !== void 0 && (l == null ? void 0 : l.value) !== "" ? new a.IfcParameterValue(l.value) : null)) || [], ((o = e[10]) == null ? void 0 : o.map((l) => ((l == null ? void 0 : l.value) ?? void 0) !== void 0 && (l == null ? void 0 : l.value) !== "" ? new a.IfcParameterValue(l.value) : null)) || [], e[11], (r = e[12]) == null ? void 0 : r.map((l) => (l == null ? void 0 : l.map((c) => ((c == null ? void 0 : c.value) ?? void 0) !== void 0 && (c == null ? void 0 : c.value) !== "" ? new a.IfcReal(c.value) : null)) || []));
  },
  4021432810: (e) => new a.IfcReferent(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), e[7]),
  3027567501: (e) => new a.IfcReinforcingElement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  964333572: (e) => {
    var t, i;
    return new a.IfcReinforcingElementType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  2320036040: (e) => new a.IfcReinforcingMesh(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new a.IfcPositiveLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new a.IfcPositiveLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new a.IfcPositiveLengthMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new a.IfcPositiveLengthMeasure((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), (e[13] ?? void 0) === void 0 || e[13] === "" ? null : new a.IfcAreaMeasure((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value), (e[14] ?? void 0) === void 0 || e[14] === "" ? null : new a.IfcAreaMeasure((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value), (e[15] ?? void 0) === void 0 || e[15] === "" ? null : new a.IfcPositiveLengthMeasure((e[15] ?? void 0) === void 0 || e[15] === "" ? null : e[15].value), (e[16] ?? void 0) === void 0 || e[16] === "" ? null : new a.IfcPositiveLengthMeasure((e[16] ?? void 0) === void 0 || e[16] === "" ? null : e[16].value), e[17]),
  2310774935: (e) => {
    var t, i, n;
    return new a.IfcReinforcingMeshType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new u(s.value, 3, s) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new u(s.value, 3, s) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new a.IfcPositiveLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new a.IfcPositiveLengthMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new a.IfcPositiveLengthMeasure((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), (e[13] ?? void 0) === void 0 || e[13] === "" ? null : new a.IfcPositiveLengthMeasure((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value), (e[14] ?? void 0) === void 0 || e[14] === "" ? null : new a.IfcAreaMeasure((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value), (e[15] ?? void 0) === void 0 || e[15] === "" ? null : new a.IfcAreaMeasure((e[15] ?? void 0) === void 0 || e[15] === "" ? null : e[15].value), (e[16] ?? void 0) === void 0 || e[16] === "" ? null : new a.IfcPositiveLengthMeasure((e[16] ?? void 0) === void 0 || e[16] === "" ? null : e[16].value), (e[17] ?? void 0) === void 0 || e[17] === "" ? null : new a.IfcPositiveLengthMeasure((e[17] ?? void 0) === void 0 || e[17] === "" ? null : e[17].value), (e[18] ?? void 0) === void 0 || e[18] === "" ? null : new a.IfcLabel((e[18] ?? void 0) === void 0 || e[18] === "" ? null : e[18].value), (e[19] ?? void 0) === void 0 || e[19] === "" ? null : ((n = e[19]) == null ? void 0 : n.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? Li(3, s) : null)) || []);
  },
  3818125796: (e) => {
    var t;
    return new a.IfcRelAdheresToElement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  160246688: (e) => {
    var t;
    return new a.IfcRelAggregates(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new u((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value, 3, e[4]), ((t = e[5]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || []);
  },
  146592293: (e) => new a.IfcRoad(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], e[9]),
  550521510: (e) => new a.IfcRoadPart(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], e[9], e[10]),
  2781568857: (e) => {
    var t, i;
    return new a.IfcRoofType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1768891740: (e) => {
    var t, i;
    return new a.IfcSanitaryTerminalType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2157484638: (e) => {
    var t;
    return new a.IfcSeamCurve(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], e[2]);
  },
  3649235739: (e) => new a.IfcSecondOrderPolynomialSpiral((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  544395925: (e) => {
    var t;
    return new a.IfcSegmentedReferenceCurve(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], new a.IfcLogical((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), new u((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value, 3, e[2]), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new u((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value, 3, e[3]));
  },
  1027922057: (e) => new a.IfcSeventhOrderPolynomialSpiral((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLengthMeasure((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcLengthMeasure((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcLengthMeasure((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  4074543187: (e) => {
    var t, i;
    return new a.IfcShadingDeviceType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  33720170: (e) => new a.IfcSign(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3599934289: (e) => {
    var t, i;
    return new a.IfcSignType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1894708472: (e) => {
    var t, i;
    return new a.IfcSignalType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  42703149: (e) => new a.IfcSineSpiral((e[0] ?? void 0) === void 0 || e[0] === "" ? null : new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLengthMeasure((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcLengthMeasure((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value)),
  4097777520: (e) => new a.IfcSite(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new a.IfcCompoundPlaneAngleMeasure(e[9].map((t) => t.value)), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new a.IfcCompoundPlaneAngleMeasure(e[10].map((t) => t.value)), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new a.IfcLengthMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new a.IfcLabel((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), (e[13] ?? void 0) === void 0 || e[13] === "" ? null : new u((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value, 3, e[13])),
  2533589738: (e) => {
    var t, i;
    return new a.IfcSlabType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1072016465: (e) => {
    var t, i;
    return new a.IfcSolarDeviceType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3856911033: (e) => new a.IfcSpace(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], e[9], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new a.IfcLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value)),
  1305183839: (e) => {
    var t, i;
    return new a.IfcSpaceHeaterType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3812236995: (e) => {
    var t, i;
    return new a.IfcSpaceType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new a.IfcLabel((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value));
  },
  3112655638: (e) => {
    var t, i;
    return new a.IfcStackTerminalType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1039846685: (e) => {
    var t, i;
    return new a.IfcStairFlightType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  338393293: (e) => {
    var t, i;
    return new a.IfcStairType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  682877961: (e) => new a.IfcStructuralAction(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7]), e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new a.IfcBoolean((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value)),
  1179482911: (e) => new a.IfcStructuralConnection(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7])),
  1004757350: (e) => new a.IfcStructuralCurveAction(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7]), e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new a.IfcBoolean((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), e[10], e[11]),
  4243806635: (e) => new a.IfcStructuralCurveConnection(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7]), new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 3, e[8])),
  214636428: (e) => new a.IfcStructuralCurveMember(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), e[7], new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 3, e[8])),
  2445595289: (e) => new a.IfcStructuralCurveMemberVarying(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), e[7], new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 3, e[8])),
  2757150158: (e) => new a.IfcStructuralCurveReaction(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7]), e[8], e[9]),
  1807405624: (e) => new a.IfcStructuralLinearAction(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7]), e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new a.IfcBoolean((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), e[10], e[11]),
  1252848954: (e) => new a.IfcStructuralLoadGroup(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), e[5], e[6], e[7], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcRatioMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new a.IfcLabel((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value)),
  2082059205: (e) => new a.IfcStructuralPointAction(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7]), e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new a.IfcBoolean((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value)),
  734778138: (e) => new a.IfcStructuralPointConnection(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7]), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 3, e[8])),
  1235345126: (e) => new a.IfcStructuralPointReaction(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7]), e[8]),
  2986769608: (e) => new a.IfcStructuralResultGroup(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), e[5], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), new a.IfcBoolean((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  3657597509: (e) => new a.IfcStructuralSurfaceAction(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7]), e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new a.IfcBoolean((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), e[10], e[11]),
  1975003073: (e) => new a.IfcStructuralSurfaceConnection(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7])),
  148013059: (e) => {
    var t;
    return new a.IfcSubContractResource(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcText((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7]), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : ((t = e[8]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 3, e[9]), e[10]);
  },
  3101698114: (e) => new a.IfcSurfaceFeature(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2315554128: (e) => {
    var t, i;
    return new a.IfcSwitchingDeviceType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2254336722: (e) => new a.IfcSystem(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value)),
  413509423: (e) => new a.IfcSystemFurnitureElement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  5716631: (e) => {
    var t, i;
    return new a.IfcTankType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3824725483: (e) => new a.IfcTendon(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new a.IfcPositiveLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new a.IfcAreaMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new a.IfcForceMeasure((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), (e[13] ?? void 0) === void 0 || e[13] === "" ? null : new a.IfcPressureMeasure((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value), (e[14] ?? void 0) === void 0 || e[14] === "" ? null : new a.IfcNormalisedRatioMeasure((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value), (e[15] ?? void 0) === void 0 || e[15] === "" ? null : new a.IfcPositiveLengthMeasure((e[15] ?? void 0) === void 0 || e[15] === "" ? null : e[15].value), (e[16] ?? void 0) === void 0 || e[16] === "" ? null : new a.IfcPositiveLengthMeasure((e[16] ?? void 0) === void 0 || e[16] === "" ? null : e[16].value)),
  2347447852: (e) => new a.IfcTendonAnchor(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]),
  3081323446: (e) => {
    var t, i;
    return new a.IfcTendonAnchorType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3663046924: (e) => new a.IfcTendonConduit(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]),
  2281632017: (e) => {
    var t, i;
    return new a.IfcTendonConduitType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2415094496: (e) => {
    var t, i;
    return new a.IfcTendonType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new a.IfcPositiveLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new a.IfcAreaMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new a.IfcPositiveLengthMeasure((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value));
  },
  618700268: (e) => {
    var t, i;
    return new a.IfcTrackElementType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1692211062: (e) => {
    var t, i;
    return new a.IfcTransformerType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2097647324: (e) => {
    var t, i;
    return new a.IfcTransportElementType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1953115116: (e) => new a.IfcTransportationDevice(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  3593883385: (e) => {
    var t, i;
    return new a.IfcTrimmedCurve(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), ((t = e[1]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], ((i = e[2]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], new a.IfcBoolean((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), e[4]);
  },
  1600972822: (e) => {
    var t, i;
    return new a.IfcTubeBundleType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1911125066: (e) => {
    var t, i;
    return new a.IfcUnitaryEquipmentType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  728799441: (e) => {
    var t, i;
    return new a.IfcValveType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  840318589: (e) => new a.IfcVehicle(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1530820697: (e) => new a.IfcVibrationDamper(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3956297820: (e) => {
    var t, i;
    return new a.IfcVibrationDamperType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2391383451: (e) => new a.IfcVibrationIsolator(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3313531582: (e) => {
    var t, i;
    return new a.IfcVibrationIsolatorType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2769231204: (e) => new a.IfcVirtualElement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  926996030: (e) => new a.IfcVoidingFeature(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1898987631: (e) => {
    var t, i;
    return new a.IfcWallType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1133259667: (e) => {
    var t, i;
    return new a.IfcWasteTerminalType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  4009809668: (e) => {
    var t, i;
    return new a.IfcWindowType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9], e[10], (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new a.IfcBoolean((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new a.IfcLabel((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value));
  },
  4088093105: (e) => {
    var t, i;
    return new a.IfcWorkCalendar(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((t = e[6]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((i = e[7]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], e[8]);
  },
  1028945134: (e) => {
    var t;
    return new a.IfcWorkControl(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new a.IfcDateTime((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((t = e[7]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new a.IfcDuration((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new a.IfcDuration((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), new a.IfcDateTime((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new a.IfcDateTime((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value));
  },
  4218914973: (e) => {
    var t;
    return new a.IfcWorkPlan(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new a.IfcDateTime((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((t = e[7]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new a.IfcDuration((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new a.IfcDuration((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), new a.IfcDateTime((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new a.IfcDateTime((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), e[13]);
  },
  3342526732: (e) => {
    var t;
    return new a.IfcWorkSchedule(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), new a.IfcDateTime((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((t = e[7]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new a.IfcDuration((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new a.IfcDuration((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), new a.IfcDateTime((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new a.IfcDateTime((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), e[13]);
  },
  1033361043: (e) => new a.IfcZone(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value)),
  3821786052: (e) => new a.IfcActionRequest(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), e[6], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcText((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  1411407467: (e) => {
    var t, i;
    return new a.IfcAirTerminalBoxType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3352864051: (e) => {
    var t, i;
    return new a.IfcAirTerminalType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1871374353: (e) => {
    var t, i;
    return new a.IfcAirToAirHeatRecoveryType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  4266260250: (e) => new a.IfcAlignmentCant(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), new a.IfcPositiveLengthMeasure((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  1545765605: (e) => new a.IfcAlignmentHorizontal(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6])),
  317615605: (e) => new a.IfcAlignmentSegment(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7])),
  1662888072: (e) => new a.IfcAlignmentVertical(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6])),
  3460190687: (e) => new a.IfcAsset(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7]), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new u((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value, 3, e[8]), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 3, e[9]), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new u((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value, 3, e[10]), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new u((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value, 3, e[11]), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new a.IfcDate((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), (e[13] ?? void 0) === void 0 || e[13] === "" ? null : new u((e[13] ?? void 0) === void 0 || e[13] === "" ? null : e[13].value, 3, e[13])),
  1532957894: (e) => {
    var t, i;
    return new a.IfcAudioVisualApplianceType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1967976161: (e) => {
    var t;
    return new a.IfcBSplineCurve(new a.IfcInteger((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), ((t = e[1]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], e[2], new a.IfcLogical((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new a.IfcLogical((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value));
  },
  2461110595: (e) => {
    var t, i, n;
    return new a.IfcBSplineCurveWithKnots(new a.IfcInteger((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), ((t = e[1]) == null ? void 0 : t.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new u(s.value, 3, s) : null)) || [], e[2], new a.IfcLogical((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new a.IfcLogical((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), ((i = e[5]) == null ? void 0 : i.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new a.IfcInteger(s.value) : null)) || [], ((n = e[6]) == null ? void 0 : n.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new a.IfcParameterValue(s.value) : null)) || [], e[7]);
  },
  819618141: (e) => {
    var t, i;
    return new a.IfcBeamType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3649138523: (e) => {
    var t, i;
    return new a.IfcBearingType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  231477066: (e) => {
    var t, i;
    return new a.IfcBoilerType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1136057603: (e) => {
    var t;
    return new a.IfcBoundaryCurve(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], new a.IfcLogical((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value));
  },
  644574406: (e) => new a.IfcBridge(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], e[9]),
  963979645: (e) => new a.IfcBridgePart(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], e[9], e[10]),
  4031249490: (e) => new a.IfcBuilding(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new a.IfcLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new a.IfcLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new u((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value, 3, e[11])),
  2979338954: (e) => new a.IfcBuildingElementPart(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  39481116: (e) => {
    var t, i;
    return new a.IfcBuildingElementPartType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1909888760: (e) => {
    var t, i;
    return new a.IfcBuildingElementProxyType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1177604601: (e) => new a.IfcBuildingSystem(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), e[5], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  1876633798: (e) => new a.IfcBuiltElement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  3862327254: (e) => new a.IfcBuiltSystem(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), e[5], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcLabel((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value)),
  2188180465: (e) => {
    var t, i;
    return new a.IfcBurnerType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  395041908: (e) => {
    var t, i;
    return new a.IfcCableCarrierFittingType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3293546465: (e) => {
    var t, i;
    return new a.IfcCableCarrierSegmentType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2674252688: (e) => {
    var t, i;
    return new a.IfcCableFittingType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1285652485: (e) => {
    var t, i;
    return new a.IfcCableSegmentType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3203706013: (e) => {
    var t, i;
    return new a.IfcCaissonFoundationType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2951183804: (e) => {
    var t, i;
    return new a.IfcChillerType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3296154744: (e) => new a.IfcChimney(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2611217952: (e) => new a.IfcCircle(new u((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value, 3, e[0]), new a.IfcPositiveLengthMeasure((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value)),
  1677625105: (e) => new a.IfcCivilElement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  2301859152: (e) => {
    var t, i;
    return new a.IfcCoilType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  843113511: (e) => new a.IfcColumn(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  400855858: (e) => {
    var t, i;
    return new a.IfcCommunicationsApplianceType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3850581409: (e) => {
    var t, i;
    return new a.IfcCompressorType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2816379211: (e) => {
    var t, i;
    return new a.IfcCondenserType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3898045240: (e) => {
    var t;
    return new a.IfcConstructionEquipmentResource(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcText((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7]), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : ((t = e[8]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 3, e[9]), e[10]);
  },
  1060000209: (e) => {
    var t;
    return new a.IfcConstructionMaterialResource(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcText((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7]), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : ((t = e[8]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 3, e[9]), e[10]);
  },
  488727124: (e) => {
    var t;
    return new a.IfcConstructionProductResource(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcIdentifier((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new a.IfcText((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7]), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : ((t = e[8]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 3, e[9]), e[10]);
  },
  2940368186: (e) => {
    var t, i;
    return new a.IfcConveyorSegmentType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  335055490: (e) => {
    var t, i;
    return new a.IfcCooledBeamType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2954562838: (e) => {
    var t, i;
    return new a.IfcCoolingTowerType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1502416096: (e) => new a.IfcCourse(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1973544240: (e) => new a.IfcCovering(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3495092785: (e) => new a.IfcCurtainWall(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3961806047: (e) => {
    var t, i;
    return new a.IfcDamperType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3426335179: (e) => new a.IfcDeepFoundation(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  1335981549: (e) => new a.IfcDiscreteAccessory(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2635815018: (e) => {
    var t, i;
    return new a.IfcDiscreteAccessoryType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  479945903: (e) => {
    var t, i;
    return new a.IfcDistributionBoardType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1599208980: (e) => {
    var t, i;
    return new a.IfcDistributionChamberElementType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2063403501: (e) => {
    var t, i;
    return new a.IfcDistributionControlElementType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value));
  },
  1945004755: (e) => new a.IfcDistributionElement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  3040386961: (e) => new a.IfcDistributionFlowElement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  3041715199: (e) => new a.IfcDistributionPort(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), e[7], e[8], e[9]),
  3205830791: (e) => new a.IfcDistributionSystem(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), e[6]),
  395920057: (e) => new a.IfcDoor(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcPositiveLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new a.IfcPositiveLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), e[10], e[11], (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new a.IfcLabel((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value)),
  869906466: (e) => {
    var t, i;
    return new a.IfcDuctFittingType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3760055223: (e) => {
    var t, i;
    return new a.IfcDuctSegmentType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2030761528: (e) => {
    var t, i;
    return new a.IfcDuctSilencerType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3071239417: (e) => new a.IfcEarthworksCut(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1077100507: (e) => new a.IfcEarthworksElement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  3376911765: (e) => new a.IfcEarthworksFill(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  663422040: (e) => {
    var t, i;
    return new a.IfcElectricApplianceType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2417008758: (e) => {
    var t, i;
    return new a.IfcElectricDistributionBoardType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3277789161: (e) => {
    var t, i;
    return new a.IfcElectricFlowStorageDeviceType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2142170206: (e) => {
    var t, i;
    return new a.IfcElectricFlowTreatmentDeviceType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1534661035: (e) => {
    var t, i;
    return new a.IfcElectricGeneratorType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1217240411: (e) => {
    var t, i;
    return new a.IfcElectricMotorType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  712377611: (e) => {
    var t, i;
    return new a.IfcElectricTimeControlType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1658829314: (e) => new a.IfcEnergyConversionDevice(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  2814081492: (e) => new a.IfcEngine(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3747195512: (e) => new a.IfcEvaporativeCooler(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  484807127: (e) => new a.IfcEvaporator(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1209101575: (e) => new a.IfcExternalSpatialElement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  346874300: (e) => {
    var t, i;
    return new a.IfcFanType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1810631287: (e) => {
    var t, i;
    return new a.IfcFilterType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  4222183408: (e) => {
    var t, i;
    return new a.IfcFireSuppressionTerminalType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2058353004: (e) => new a.IfcFlowController(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  4278956645: (e) => new a.IfcFlowFitting(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  4037862832: (e) => {
    var t, i;
    return new a.IfcFlowInstrumentType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  2188021234: (e) => new a.IfcFlowMeter(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3132237377: (e) => new a.IfcFlowMovingDevice(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  987401354: (e) => new a.IfcFlowSegment(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  707683696: (e) => new a.IfcFlowStorageDevice(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  2223149337: (e) => new a.IfcFlowTerminal(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  3508470533: (e) => new a.IfcFlowTreatmentDevice(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  900683007: (e) => new a.IfcFooting(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2713699986: (e) => new a.IfcGeotechnicalAssembly(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  3009204131: (e) => {
    var t, i, n;
    return new a.IfcGrid(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), ((t = e[7]) == null ? void 0 : t.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new u(s.value, 3, s) : null)) || [], ((i = e[8]) == null ? void 0 : i.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new u(s.value, 3, s) : null)) || [], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : ((n = e[9]) == null ? void 0 : n.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new u(s.value, 3, s) : null)) || [], e[10]);
  },
  3319311131: (e) => new a.IfcHeatExchanger(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2068733104: (e) => new a.IfcHumidifier(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  4175244083: (e) => new a.IfcInterceptor(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2176052936: (e) => new a.IfcJunctionBox(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2696325953: (e) => new a.IfcKerb(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), new a.IfcBoolean((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value)),
  76236018: (e) => new a.IfcLamp(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  629592764: (e) => new a.IfcLightFixture(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1154579445: (e) => new a.IfcLinearPositioningElement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6])),
  1638804497: (e) => new a.IfcLiquidTerminal(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1437502449: (e) => new a.IfcMedicalDevice(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1073191201: (e) => new a.IfcMember(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2078563270: (e) => new a.IfcMobileTelecommunicationsAppliance(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  234836483: (e) => new a.IfcMooringDevice(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2474470126: (e) => new a.IfcMotorConnection(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2182337498: (e) => new a.IfcNavigationElement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  144952367: (e) => {
    var t;
    return new a.IfcOuterBoundaryCurve(((t = e[0]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new u(i.value, 3, i) : null)) || [], new a.IfcLogical((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value));
  },
  3694346114: (e) => new a.IfcOutlet(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1383356374: (e) => new a.IfcPavement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1687234759: (e) => new a.IfcPile(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8], e[9]),
  310824031: (e) => new a.IfcPipeFitting(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3612865200: (e) => new a.IfcPipeSegment(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3171933400: (e) => new a.IfcPlate(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  738039164: (e) => new a.IfcProtectiveDevice(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  655969474: (e) => {
    var t, i;
    return new a.IfcProtectiveDeviceTrippingUnitType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  90941305: (e) => new a.IfcPump(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3290496277: (e) => new a.IfcRail(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2262370178: (e) => new a.IfcRailing(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3024970846: (e) => new a.IfcRamp(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3283111854: (e) => new a.IfcRampFlight(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1232101972: (e) => {
    var t, i, n, s;
    return new a.IfcRationalBSplineCurveWithKnots(new a.IfcInteger((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), ((t = e[1]) == null ? void 0 : t.map((o) => ((o == null ? void 0 : o.value) ?? void 0) !== void 0 && (o == null ? void 0 : o.value) !== "" ? new u(o.value, 3, o) : null)) || [], e[2], new a.IfcLogical((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), new a.IfcLogical((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), ((i = e[5]) == null ? void 0 : i.map((o) => ((o == null ? void 0 : o.value) ?? void 0) !== void 0 && (o == null ? void 0 : o.value) !== "" ? new a.IfcInteger(o.value) : null)) || [], ((n = e[6]) == null ? void 0 : n.map((o) => ((o == null ? void 0 : o.value) ?? void 0) !== void 0 && (o == null ? void 0 : o.value) !== "" ? new a.IfcParameterValue(o.value) : null)) || [], e[7], ((s = e[8]) == null ? void 0 : s.map((o) => ((o == null ? void 0 : o.value) ?? void 0) !== void 0 && (o == null ? void 0 : o.value) !== "" ? new a.IfcReal(o.value) : null)) || []);
  },
  3798194928: (e) => new a.IfcReinforcedSoil(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  979691226: (e) => new a.IfcReinforcingBar(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new a.IfcPositiveLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new a.IfcAreaMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new a.IfcPositiveLengthMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), e[12], e[13]),
  2572171363: (e) => {
    var t, i, n;
    return new a.IfcReinforcingBarType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new u(s.value, 3, s) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? new u(s.value, 3, s) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9], (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new a.IfcPositiveLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new a.IfcAreaMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new a.IfcPositiveLengthMeasure((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value), e[13], (e[14] ?? void 0) === void 0 || e[14] === "" ? null : new a.IfcLabel((e[14] ?? void 0) === void 0 || e[14] === "" ? null : e[14].value), (e[15] ?? void 0) === void 0 || e[15] === "" ? null : ((n = e[15]) == null ? void 0 : n.map((s) => ((s == null ? void 0 : s.value) ?? void 0) !== void 0 && (s == null ? void 0 : s.value) !== "" ? Li(3, s) : null)) || []);
  },
  2016517767: (e) => new a.IfcRoof(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3053780830: (e) => new a.IfcSanitaryTerminal(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1783015770: (e) => {
    var t, i;
    return new a.IfcSensorType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1329646415: (e) => new a.IfcShadingDevice(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  991950508: (e) => new a.IfcSignal(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1529196076: (e) => new a.IfcSlab(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3420628829: (e) => new a.IfcSolarDevice(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1999602285: (e) => new a.IfcSpaceHeater(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1404847402: (e) => new a.IfcStackTerminal(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  331165859: (e) => new a.IfcStair(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  4252922144: (e) => new a.IfcStairFlight(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcInteger((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new a.IfcInteger((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : new a.IfcPositiveLengthMeasure((e[10] ?? void 0) === void 0 || e[10] === "" ? null : e[10].value), (e[11] ?? void 0) === void 0 || e[11] === "" ? null : new a.IfcPositiveLengthMeasure((e[11] ?? void 0) === void 0 || e[11] === "" ? null : e[11].value), e[12]),
  2515109513: (e) => {
    var t, i;
    return new a.IfcStructuralAnalysisModel(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), e[5], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : ((t = e[7]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : ((i = e[8]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new u((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value, 3, e[9]));
  },
  385403989: (e) => {
    var t;
    return new a.IfcStructuralLoadCase(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), e[5], e[6], e[7], (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcRatioMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new a.IfcLabel((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), (e[10] ?? void 0) === void 0 || e[10] === "" ? null : ((t = e[10]) == null ? void 0 : t.map((i) => ((i == null ? void 0 : i.value) ?? void 0) !== void 0 && (i == null ? void 0 : i.value) !== "" ? new a.IfcRatioMeasure(i.value) : null)) || []);
  },
  1621171031: (e) => new a.IfcStructuralPlanarAction(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), new u((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value, 3, e[7]), e[8], (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new a.IfcBoolean((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), e[10], e[11]),
  1162798199: (e) => new a.IfcSwitchingDevice(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  812556717: (e) => new a.IfcTank(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3425753595: (e) => new a.IfcTrackElement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3825984169: (e) => new a.IfcTransformer(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1620046519: (e) => new a.IfcTransportElement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3026737570: (e) => new a.IfcTubeBundle(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3179687236: (e) => {
    var t, i;
    return new a.IfcUnitaryControlElementType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  4292641817: (e) => new a.IfcUnitaryEquipment(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  4207607924: (e) => new a.IfcValve(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2391406946: (e) => new a.IfcWall(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3512223829: (e) => new a.IfcWallStandardCase(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  4237592921: (e) => new a.IfcWasteTerminal(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3304561284: (e) => new a.IfcWindow(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcPositiveLengthMeasure((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), (e[9] ?? void 0) === void 0 || e[9] === "" ? null : new a.IfcPositiveLengthMeasure((e[9] ?? void 0) === void 0 || e[9] === "" ? null : e[9].value), e[10], e[11], (e[12] ?? void 0) === void 0 || e[12] === "" ? null : new a.IfcLabel((e[12] ?? void 0) === void 0 || e[12] === "" ? null : e[12].value)),
  2874132201: (e) => {
    var t, i;
    return new a.IfcActuatorType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  1634111441: (e) => new a.IfcAirTerminal(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  177149247: (e) => new a.IfcAirTerminalBox(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2056796094: (e) => new a.IfcAirToAirHeatRecovery(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3001207471: (e) => {
    var t, i;
    return new a.IfcAlarmType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  325726236: (e) => new a.IfcAlignment(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), e[7]),
  277319702: (e) => new a.IfcAudioVisualAppliance(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  753842376: (e) => new a.IfcBeam(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  4196446775: (e) => new a.IfcBearing(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  32344328: (e) => new a.IfcBoiler(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3314249567: (e) => new a.IfcBorehole(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  1095909175: (e) => new a.IfcBuildingElementProxy(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2938176219: (e) => new a.IfcBurner(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  635142910: (e) => new a.IfcCableCarrierFitting(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3758799889: (e) => new a.IfcCableCarrierSegment(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1051757585: (e) => new a.IfcCableFitting(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  4217484030: (e) => new a.IfcCableSegment(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3999819293: (e) => new a.IfcCaissonFoundation(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3902619387: (e) => new a.IfcChiller(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  639361253: (e) => new a.IfcCoil(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3221913625: (e) => new a.IfcCommunicationsAppliance(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3571504051: (e) => new a.IfcCompressor(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2272882330: (e) => new a.IfcCondenser(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  578613899: (e) => {
    var t, i;
    return new a.IfcControllerType(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcIdentifier((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : ((t = e[5]) == null ? void 0 : t.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[6] ?? void 0) === void 0 || e[6] === "" ? null : ((i = e[6]) == null ? void 0 : i.map((n) => ((n == null ? void 0 : n.value) ?? void 0) !== void 0 && (n == null ? void 0 : n.value) !== "" ? new u(n.value, 3, n) : null)) || [], (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcLabel((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), (e[8] ?? void 0) === void 0 || e[8] === "" ? null : new a.IfcLabel((e[8] ?? void 0) === void 0 || e[8] === "" ? null : e[8].value), e[9]);
  },
  3460952963: (e) => new a.IfcConveyorSegment(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  4136498852: (e) => new a.IfcCooledBeam(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3640358203: (e) => new a.IfcCoolingTower(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  4074379575: (e) => new a.IfcDamper(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3693000487: (e) => new a.IfcDistributionBoard(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1052013943: (e) => new a.IfcDistributionChamberElement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  562808652: (e) => new a.IfcDistributionCircuit(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new a.IfcLabel((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value), e[6]),
  1062813311: (e) => new a.IfcDistributionControlElement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  342316401: (e) => new a.IfcDuctFitting(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3518393246: (e) => new a.IfcDuctSegment(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1360408905: (e) => new a.IfcDuctSilencer(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1904799276: (e) => new a.IfcElectricAppliance(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  862014818: (e) => new a.IfcElectricDistributionBoard(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3310460725: (e) => new a.IfcElectricFlowStorageDevice(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  24726584: (e) => new a.IfcElectricFlowTreatmentDevice(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  264262732: (e) => new a.IfcElectricGenerator(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  402227799: (e) => new a.IfcElectricMotor(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1003880860: (e) => new a.IfcElectricTimeControl(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3415622556: (e) => new a.IfcFan(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  819412036: (e) => new a.IfcFilter(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  1426591983: (e) => new a.IfcFireSuppressionTerminal(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  182646315: (e) => new a.IfcFlowInstrument(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  2680139844: (e) => new a.IfcGeomodel(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  1971632696: (e) => new a.IfcGeoslice(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value)),
  2295281155: (e) => new a.IfcProtectiveDeviceTrippingUnit(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  4086658281: (e) => new a.IfcSensor(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  630975310: (e) => new a.IfcUnitaryControlElement(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  4288193352: (e) => new a.IfcActuator(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  3087945054: (e) => new a.IfcAlarm(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8]),
  25142252: (e) => new a.IfcController(new a.IfcGloballyUniqueId((e[0] ?? void 0) === void 0 || e[0] === "" ? null : e[0].value), (e[1] ?? void 0) === void 0 || e[1] === "" ? null : new u((e[1] ?? void 0) === void 0 || e[1] === "" ? null : e[1].value, 3, e[1]), (e[2] ?? void 0) === void 0 || e[2] === "" ? null : new a.IfcLabel((e[2] ?? void 0) === void 0 || e[2] === "" ? null : e[2].value), (e[3] ?? void 0) === void 0 || e[3] === "" ? null : new a.IfcText((e[3] ?? void 0) === void 0 || e[3] === "" ? null : e[3].value), (e[4] ?? void 0) === void 0 || e[4] === "" ? null : new a.IfcLabel((e[4] ?? void 0) === void 0 || e[4] === "" ? null : e[4].value), (e[5] ?? void 0) === void 0 || e[5] === "" ? null : new u((e[5] ?? void 0) === void 0 || e[5] === "" ? null : e[5].value, 3, e[5]), (e[6] ?? void 0) === void 0 || e[6] === "" ? null : new u((e[6] ?? void 0) === void 0 || e[6] === "" ? null : e[6].value, 3, e[6]), (e[7] ?? void 0) === void 0 || e[7] === "" ? null : new a.IfcIdentifier((e[7] ?? void 0) === void 0 || e[7] === "" ? null : e[7].value), e[8])
};
wP[3] = {
  618182010: [qae, Xae],
  2879124712: [PAe, MAe, BAe],
  411424972: [Iue],
  4037036970: [vH, mue, yue, Eue],
  1387855156: [vH],
  2859738748: [Aie, Lae, zW, E8, Lie],
  2614616156: [E8],
  1959218052: [tue, iue],
  1785450214: [Oae],
  1466758467: [hme],
  4294318154: [due, Rme, rue],
  3200245327: [nY, g8, sY, lue, aue, uue],
  760658860: [iY, Nae, oue, $P, bX, Cae, pL, NX, sue],
  248100487: [NX],
  2235152071: [bX],
  1507914824: [RX, bae, nue],
  1918398963: [vX, Vae, zae, Oie],
  3701648758: [x5, tme, Hae],
  2483315170: [Jr, A8, S8, b8, wle, N8, D8, C8, eue],
  2226359599: [A8, S8, b8, wle, N8, D8, C8],
  677532197: [UN, PW, qO, MW, sL, VW, wme, eA, cue, hue, fue, gH, pue, Dae, ame, Ime, Dz, UP, z2, P5, HW, nA, pme, mme, UW, EH, FW, yme, N5, a8, $ae, Kae, Zae],
  2022622350: [Jae],
  3119450353: [Tie, vie, Yae, Die],
  2095639259: [wie, PH],
  3958567839: [ZP, QP, tH, oA, n8, o8, YO, oH, l8, lH, uH, aA, zN, c8, Uae, xAe, TX, Rie, Sie, w8, bie, T8, Nie],
  986844984: [Ur, XO, jN, eL, tL, iL, nL, kW, gme, DX, CX, OX, nme, Rs, Ta, ome, Eme],
  1076942058: [R8, Cie, TH, v8, Qae],
  3377609919: [dE, BW],
  3008791417: [hL, JP, XP, e8, t8, Pg, Fg, SN, R2, Mv, j2, Mg, Ug, IN, MV, BV, zy, Sg, h5, c0, rA, vO, AO, xF, bQ, NQ, DQ, LQ, _Q, xQ, Voe, Woe, _P, MQ, tA, iA, Yoe, dA, i8, bN, DN, CN, ON, _N, iH, jg, pA, Wg, mA, s8, PP, MP, xW, nH, _5, r8, sH, rH, HN, aH, _g, GV, NO, LP, EN, xP, gX, zoe, pN, DO, OO, kg, MN, x2, Vv, bO, f4, gN, zg, gA, a4, u4, vA, u8, PQ, joe, i3, Bg, f5, mN, uA, fA, BO, GN, Yv, h4, I5, Vg, Lg, MU, oN, UQ, kN, dH, d8, qoe, gP, $O, Z1e, cH, yA, WN, YN, Koe, fH, PN, IH, $oe, wA, TA, RA, pH, m4, $N, KN, ZN, QN, yH, EA, AA, f8, cA, I8, Gae, h8, hA, BN, SA, mH, DA, p8, wN, NA, m8, VN, qN, CA, y8, IA, bA, fL, JN, wH, Wae, Qe],
  2439245199: [Gl, ad, cs, IL, XF, ui, mL, Tme, yL],
  2341007311: [fe, Zr, Fe, le, Ni, U, di, ot, lt, B, Ye, me, Og, xg, at, ns, tr, We, Yt, Ce, ri, ut, Jp, dt, Xe, Hg, Ko, Un, Ad, Vt, ct, Gg, Te, KP, SJ, So, oE, rE, lA, lE, T4, X, Ns, ge, Xr, yN, Vs, bs, Xp, ie, xae, eE, xO, PF, w4, wX, Rl, g5, w5, T5, R5, v5, b5, UF, p4, HF, hH, Mae, W2, ju, T2, xv, CV, Pv, Ky, $2, AI, _v, K2, i4, vN, Y2, Zm, Qm, q2, RO, Z2, X2, e4, s4, o4, AN, t4, NN, qm, $m, Km, Jm, e3, r3, r4, LN, hU, DV, gu, UV, CQ, Ym, J2, OV, LV, _V, xV, OQ, Fm, Hm, Gm, km, Vm, zm, jm, H0, dd, m1, YD, A1, hI, hd, p1, v1, _1, k1, j1, W1, J1, X1, KD, tI, rI, ZD, aI, QD, uI, dI, fd, T1, Z1, Id, S1, $D, M1, B1, sI, pd, y1, L1, iI, md, b1, U1, F1, oI, cI, yd, E1, R1, qD, N1, z1, Y1, Q1, nI, pI, Ed, g1, w1, D1, C1, O1, x1, P1, H1, G1, V1, q1, $1, K1, eI, lI, fI, II, mI, yI, EI, gd, eh, Vp, d5, oh, cU, G0, k0, cd, V0, Z_, z0, j0, W0, vg, Y0, q0, $0, K0, Q_, Z0, J_, fU, IU, Q0, pU, J0, b_, Rb, yU, X0, A_, i0, EU, ih, nh, X_, sh, Ag, KU, zp, wI, RU, PV, R_, v_, S_, mU, _U, FV, c5, Ng, Cg, jp, Dg, vb, Wm, uc, df, wd, cf, t3, th, n0, bg, TU, ex, Ra, O_, Hu, Gu, ku, U0, r0, LU, lh, s3, Wp, n4, Zp, Zh, Jh, tf, Xm, ac, ef, Ec, Ef, a3, d4, s0, b2, Xh, o0, D2, RI, Qh, N2, F2, l3, c4, v2, Uv, Wv, rh, a0, fC, L_, __, P_, U_, xU, l0, D_, IC, x_, M_, PU, u0, Zy, _O, Td, Q2, SO, l4, xN, eH, MF, Yg, EX, Fv, Hv, Gv, zv, qv, Kv, UO, BF, jv, sf, u3, LO, Yh, A2, M0, wU, AU, ky, jy, C_, Wy, Yy, _2, B0, OU, hf, n3, Bv, ic, nc, sc, Gy, oc, Vy, rc, Wh, lc, Aa, JD, La, Mp, dc, va, Oa, Cp, _p, Ya, $a, tu, iu, tC, nu, au, iC, Pp, nC, du, cu, cc, Ca, Xa, hc, _a, eC, ka, Va, ru, fc, Sa, Fa, su, Ic, xa, Op, za, lu, hu, pc, ba, Dp, XD, Pa, qa, Ka, eu, ou, pu, mc, Na, Da, Ma, Ua, Ba, Ha, Ga, Lp, ja, Wa, Za, Qa, Ja, xp, uu, fu, Iu, mu, yu, Up, yc, ff, o3, kv, qh, gU, $h, S2, Kh, vU, C2, nf, of, O2, L2, P2, rf, lf, SU, af, bU, NU, DU, uf, CU, M2, U2, N_, Eg, UU, If, pf, BU, mf, B2, HV, Hp, FU, kV, $v, yf, gf, d3, I4, FN, CO, PO, MO, FF, $s, Bae],
  1054537805: [ime, sme, rme, lme, AX, ume],
  3982875396: [TH, v8],
  2273995522: [_ae, kae],
  2162789131: [SX, A5, KO, S5, ZO, QO, JO, oL, GW, dme, cme],
  609421318: [SX, A5, KO, S5, ZO, QO, JO, oL, GW],
  2525727697: [A5, KO, S5, ZO, QO, JO, oL],
  2830218821: [R8],
  846575682: [a8],
  626085974: [UW, EH, FW],
  1549132990: [AX],
  280115917: [Dz, UP, z2, P5, HW],
  222769930: [UAe],
  3101149627: [Pae, Fae],
  1377556343: [h8, hA, BN, SA, mH, DA, p8, wN, NA, m8, VN, qN, CA, y8, IA, bA, fL, JN, wH],
  2799835756: [JN],
  3798115385: [T8],
  1310608509: [w8],
  3264961684: [gH],
  370225590: [IA, bA],
  2889183280: [vX],
  3632507154: [TX],
  3900360178: [VN, qN, CA],
  297599258: [Rs, Ta],
  2556980723: [wN, NA],
  1809719519: [DA],
  3008276851: [wN],
  3448662350: [dE],
  2453401579: [JP, XP, e8, t8, Pg, Fg, SN, R2, Mv, j2, Mg, Ug, IN, MV, BV, zy, Sg, h5, c0, rA, vO, AO, xF, bQ, NQ, DQ, LQ, _Q, xQ, Voe, Woe, _P, MQ, tA, iA, Yoe, dA, i8, bN, DN, CN, ON, _N, iH, jg, pA, Wg, mA, s8, PP, MP, xW, nH, _5, r8, sH, rH, HN, aH, _g, GV, NO, LP, EN, xP, gX, zoe, pN, DO, OO, kg, MN, x2, Vv, bO, f4, gN, zg, gA, a4, u4, vA, u8, PQ, joe, i3, Bg, f5, mN, uA, fA, BO, GN, Yv, h4, I5, Vg, Lg, MU, oN, UQ, kN, dH, d8, qoe, gP, $O, Z1e, cH, yA, WN, YN, Koe, fH, PN, IH, $oe, wA, TA, RA, pH, m4, $N, KN, ZN, QN, yH, EA, AA, f8, cA, I8],
  3590301190: [cA],
  812098782: [EA, AA],
  1437953363: [Dz, UP],
  1402838566: [m4, $N, KN, ZN, QN],
  1520743889: [m4],
  1008929658: [hA, BN, SA],
  3079605661: [RX],
  219451334: [W2, ju, T2, xv, CV, Pv, Ky, $2, AI, _v, K2, i4, vN, Y2, Zm, Qm, q2, RO, Z2, X2, e4, s4, o4, AN, t4, NN, qm, $m, Km, Jm, e3, r3, r4, LN, hU, DV, gu, UV, CQ, Ym, J2, OV, LV, _V, xV, OQ, Fm, Hm, Gm, km, Vm, zm, jm, H0, dd, m1, YD, A1, hI, hd, p1, v1, _1, k1, j1, W1, J1, X1, KD, tI, rI, ZD, aI, QD, uI, dI, fd, T1, Z1, Id, S1, $D, M1, B1, sI, pd, y1, L1, iI, md, b1, U1, F1, oI, cI, yd, E1, R1, qD, N1, z1, Y1, Q1, nI, pI, Ed, g1, w1, D1, C1, O1, x1, P1, H1, G1, V1, q1, $1, K1, eI, lI, fI, II, mI, yI, EI, gd, eh, Vp, d5, oh, cU, G0, k0, cd, V0, Z_, z0, j0, W0, vg, Y0, q0, $0, K0, Q_, Z0, J_, fU, IU, Q0, pU, J0, b_, Rb, yU, X0, A_, i0, EU, ih, nh, X_, sh, Ag, KU, zp, wI, RU, PV, R_, v_, S_, mU, _U, FV, c5, Ng, Cg, jp, Dg, vb, Wm, uc, df, wd, cf, t3, th, n0, bg, TU, ex, Ra, O_, Hu, Gu, ku, U0, r0, LU, lh, s3, Wp, n4, Zp, Zh, Jh, tf, Xm, ac, ef, Ec, Ef, a3, d4, s0, b2, Xh, o0, D2, RI, Qh, N2, F2, l3, c4, v2, Uv, Wv, rh, a0, fC, L_, __, P_, U_, xU, l0, D_, IC, x_, M_, PU, u0, Zy, _O, Td, Q2, SO, l4, xN, eH, MF, Yg, EX, Fv, Hv, Gv, zv, qv, Kv, UO, BF, jv, sf, u3, LO, Yh, A2, M0, wU, AU, ky, jy, C_, Wy, Yy, _2, B0, OU, hf, n3, Bv, ic, nc, sc, Gy, oc, Vy, rc, Wh, lc, Aa, JD, La, Mp, dc, va, Oa, Cp, _p, Ya, $a, tu, iu, tC, nu, au, iC, Pp, nC, du, cu, cc, Ca, Xa, hc, _a, eC, ka, Va, ru, fc, Sa, Fa, su, Ic, xa, Op, za, lu, hu, pc, ba, Dp, XD, Pa, qa, Ka, eu, ou, pu, mc, Na, Da, Ma, Ua, Ba, Ha, Ga, Lp, ja, Wa, Za, Qa, Ja, xp, uu, fu, Iu, mu, yu, Up, yc, ff, o3, kv, qh, gU, $h, S2, Kh, vU, C2, nf, of, O2, L2, P2, rf, lf, SU, af, bU, NU, DU, uf, CU, M2, U2, N_, Eg, UU, If, pf, BU, mf, B2, HV, Hp, FU, kV, $v, yf, gf, d3, I4, FN, CO, PO, MO, FF, $s],
  2529465313: [ZP, QP, tH, oA, n8, o8, YO, oH, l8, lH, uH, aA, zN, c8],
  2004835150: [$oe, wA, TA, RA],
  1663979128: [PN],
  2067069095: [yA, WN, YN, Koe],
  3727388367: [UN, PW, qO, MW, sL, VW],
  3778827333: [DX, CX, OX],
  1775413392: [sL],
  2598011224: [Ur, XO, jN, eL, tL, iL, nL, kW],
  1680319473: [eE, xO, PF, w4, wX, Rl, g5, w5, T5, R5, v5, b5, UF, p4, HF, hH],
  3357820518: [Rl, g5, w5, T5, R5, v5, b5, UF, p4, HF],
  1482703590: [eE, xO, PF, w4],
  2090586900: [p4],
  3615266464: [aA, zN],
  478536968: [fe, Zr, Fe, le, Ni, U, di, ot, lt, B, Ye, me, Og, xg, at, ns, tr, We, Yt, Ce, ri, ut, Jp, dt, Xe, Hg, Ko, Un, Ad, Vt, ct, Gg, Te, KP, SJ, So, oE, rE, lA, lE, T4, X, Ns, ge, Xr, yN, Vs, bs, Xp, ie],
  823603102: [qoe, gP, $O],
  3692461612: [XO, jN, eL, tL, iL, nL],
  723233188: [PQ, joe, i3, Bg, f5, mN, uA, fA, BO, GN, Yv, h4, I5, Vg, Lg, MU, oN, UQ, kN],
  2473145415: [S5],
  1597423693: [A5],
  2513912981: [zoe, pN, DO, OO, kg, MN, x2, Vv, bO, f4, gN, zg, gA, a4, u4, vA],
  2247615214: [Yv, h4, I5, Vg, Lg, MU, oN, UQ],
  1260650574: [BO],
  230924584: [a4, u4],
  901063453: [_g, GV, NO, LP, EN, xP],
  4282788508: [HN],
  1628702193: [Fv, Hv, Gv, zv, qv, Kv, UO, BF, jv, sf, u3, LO, Yh, A2, M0, wU, AU, ky, jy, C_, Wy, Yy, _2, B0, OU, hf, n3, Bv, ic, nc, sc, Gy, oc, Vy, rc, Wh, lc, Aa, JD, La, Mp, dc, va, Oa, Cp, _p, Ya, $a, tu, iu, tC, nu, au, iC, Pp, nC, du, cu, cc, Ca, Xa, hc, _a, eC, ka, Va, ru, fc, Sa, Fa, su, Ic, xa, Op, za, lu, hu, pc, ba, Dp, XD, Pa, qa, Ka, eu, ou, pu, mc, Na, Da, Ma, Ua, Ba, Ha, Ga, Lp, ja, Wa, Za, Qa, Ja, xp, uu, fu, Iu, mu, yu, Up, yc, ff, o3, kv, qh, gU, $h, S2, Kh, vU, C2, nf, of, O2, L2, P2, rf, lf, SU, af, bU, NU, DU, uf, CU, M2, U2, N_, Eg, UU, If, pf, BU, mf, B2, HV, Hp, FU, kV, $v, yf, gf, d3, I4, FN, CO, PO, MO, FF],
  3736923433: [CO, PO, MO],
  2347495698: [jv, sf, u3, LO, Yh, A2, M0, wU, AU, ky, jy, C_, Wy, Yy, _2, B0, OU, hf, n3, Bv, ic, nc, sc, Gy, oc, Vy, rc, Wh, lc, Aa, JD, La, Mp, dc, va, Oa, Cp, _p, Ya, $a, tu, iu, tC, nu, au, iC, Pp, nC, du, cu, cc, Ca, Xa, hc, _a, eC, ka, Va, ru, fc, Sa, Fa, su, Ic, xa, Op, za, lu, hu, pc, ba, Dp, XD, Pa, qa, Ka, eu, ou, pu, mc, Na, Da, Ma, Ua, Ba, Ha, Ga, Lp, ja, Wa, Za, Qa, Ja, xp, uu, fu, Iu, mu, yu, Up, yc, ff, o3, kv, qh, gU, $h, S2, Kh, vU, C2, nf, of, O2, L2, P2, rf, lf, SU, af, bU, NU, DU, uf, CU, M2, U2, N_, Eg, UU, If, pf, BU, mf, B2, HV, Hp, FU, kV, $v, yf, gf, d3, I4],
  3698973494: [Fv, Hv, Gv, zv, qv, Kv, UO],
  2736907675: [_5],
  4182860854: [x2, Vv, bO, f4, gN, zg],
  574549367: [PP, MP],
  59481748: [jg, pA, Wg, mA],
  3749851601: [Wg],
  3331915920: [jg],
  1383045692: [oA],
  2485617015: [gP],
  2574617495: [Fv, Hv, Gv, zv, qv, Kv],
  3419103109: [MF, Yg],
  2506170314: [bN, DN, CN, ON, _N],
  2601014836: [Pg, Fg, SN, R2, Mv, j2, Mg, Ug, IN, MV, BV, zy, Sg, h5, c0, rA, vO, AO, xF, bQ, NQ, DQ, LQ, _Q, xQ, Voe, Woe, _P, MQ, tA, iA, Yoe, dA],
  593015953: [Lg, MU, oN],
  339256511: [Yh, A2, M0, wU, AU, ky, jy, C_, Wy, Yy, _2, B0, OU, hf, n3, Bv, ic, nc, sc, Gy, oc, Vy, rc, Wh, lc, Aa, JD, La, Mp, dc, va, Oa, Cp, _p, Ya, $a, tu, iu, tC, nu, au, iC, Pp, nC, du, cu, cc, Ca, Xa, hc, _a, eC, ka, Va, ru, fc, Sa, Fa, su, Ic, xa, Op, za, lu, hu, pc, ba, Dp, XD, Pa, qa, Ka, eu, ou, pu, mc, Na, Da, Ma, Ua, Ba, Ha, Ga, Lp, ja, Wa, Za, Qa, Ja, xp, uu, fu, Iu, mu, yu, Up, yc, ff, o3, kv, qh, gU, $h, S2, Kh, vU, C2, nf, of, O2, L2, P2, rf, lf, SU, af, bU, NU, DU, uf, CU, M2, U2, N_, Eg, UU, If, pf, BU, mf, B2, HV, Hp, FU, kV, $v, yf, gf, d3],
  2777663545: [pN, DO, OO, kg],
  477187591: [I5],
  2652556860: [MU],
  4238390223: [yf, gf],
  178912537: [EN],
  1425443689: [i3, Bg, f5, mN],
  3888040117: [W2, ju, T2, xv, CV, Pv, Ky, $2, AI, _v, K2, i4, vN, Y2, Zm, Qm, q2, RO, Z2, X2, e4, s4, o4, AN, t4, NN, qm, $m, Km, Jm, e3, r3, r4, LN, hU, DV, gu, UV, CQ, Ym, J2, OV, LV, _V, xV, OQ, Fm, Hm, Gm, km, Vm, zm, jm, H0, dd, m1, YD, A1, hI, hd, p1, v1, _1, k1, j1, W1, J1, X1, KD, tI, rI, ZD, aI, QD, uI, dI, fd, T1, Z1, Id, S1, $D, M1, B1, sI, pd, y1, L1, iI, md, b1, U1, F1, oI, cI, yd, E1, R1, qD, N1, z1, Y1, Q1, nI, pI, Ed, g1, w1, D1, C1, O1, x1, P1, H1, G1, V1, q1, $1, K1, eI, lI, fI, II, mI, yI, EI, gd, eh, Vp, d5, oh, cU, G0, k0, cd, V0, Z_, z0, j0, W0, vg, Y0, q0, $0, K0, Q_, Z0, J_, fU, IU, Q0, pU, J0, b_, Rb, yU, X0, A_, i0, EU, ih, nh, X_, sh, Ag, KU, zp, wI, RU, PV, R_, v_, S_, mU, _U, FV, c5, Ng, Cg, jp, Dg, vb, Wm, uc, df, wd, cf, t3, th, n0, bg, TU, ex, Ra, O_, Hu, Gu, ku, U0, r0, LU, lh, s3, Wp, n4, Zp, Zh, Jh, tf, Xm, ac, ef, Ec, Ef, a3, d4, s0, b2, Xh, o0, D2, RI, Qh, N2, F2, l3, c4, v2, Uv, Wv, rh, a0, fC, L_, __, P_, U_, xU, l0, D_, IC, x_, M_, PU, u0, Zy, _O, Td, Q2, SO, l4, xN],
  590820931: [MQ, tA, iA],
  759155922: [qO],
  2559016684: [UN],
  3967405729: [g5, w5, T5, R5, v5, b5],
  2945172077: [Q2, SO, l4],
  4208778838: [hU, DV, gu, UV, CQ, Ym, J2, OV, LV, _V, xV, OQ, Fm, Hm, Gm, km, Vm, zm, jm, H0, dd, m1, YD, A1, hI, hd, p1, v1, _1, k1, j1, W1, J1, X1, KD, tI, rI, ZD, aI, QD, uI, dI, fd, T1, Z1, Id, S1, $D, M1, B1, sI, pd, y1, L1, iI, md, b1, U1, F1, oI, cI, yd, E1, R1, qD, N1, z1, Y1, Q1, nI, pI, Ed, g1, w1, D1, C1, O1, x1, P1, H1, G1, V1, q1, $1, K1, eI, lI, fI, II, mI, yI, EI, gd, eh, Vp, d5, oh, cU, G0, k0, cd, V0, Z_, z0, j0, W0, vg, Y0, q0, $0, K0, Q_, Z0, J_, fU, IU, Q0, pU, J0, b_, Rb, yU, X0, A_, i0, EU, ih, nh, X_, sh, Ag, KU, zp, wI, RU, PV, R_, v_, S_, mU, _U, FV, c5, Ng, Cg, jp, Dg, vb, Wm, uc, df, wd, cf, t3, th, n0, bg, TU, ex, Ra, O_, Hu, Gu, ku, U0, r0, LU, lh, s3, Wp, n4, Zp, Zh, Jh, tf, Xm, ac, ef, Ec, Ef, a3, d4, s0, b2, Xh, o0, D2, RI, Qh, N2, F2, l3, c4, v2, Uv, Wv, rh, a0, fC, L_, __, P_, U_, xU, l0, D_, IC, x_, M_, PU, u0, Zy, _O],
  3521284610: [eE, xO],
  3939117080: [Ns, ge, Xr, yN, Vs, bs, Xp],
  1307041759: [yN],
  1865459582: [SJ, So, oE, rE, lA, lE, T4],
  826625072: [Og, xg, at, ns, tr, We, Yt, Ce, ri, ut, Jp, dt, Xe, Hg, Ko, Un, Ad, Vt, ct, Gg, Te],
  1204542856: [ct, Gg],
  1638771189: [Hg],
  2551354335: [U, di, ot, lt, B],
  693640335: [fe, Zr, Fe, le],
  3451746338: [Og, xg],
  3523091289: [Og],
  2914609552: [qm, $m, Km, Jm, e3, r3, r4],
  1856042241: [Yv],
  1862484736: [PQ],
  1412071761: [v2, Uv, Wv, rh, a0, fC, L_, __, P_, U_, xU, l0, D_, IC, x_, M_, PU, u0, Zy],
  710998568: [jv, sf, u3],
  2706606064: [rh, a0, fC, L_, __, P_, U_, xU, l0, D_, IC, x_, M_, PU, u0],
  3893378262: [sf],
  2735484536: [bQ, NQ, DQ, LQ, _Q, xQ],
  3544373492: [s0, b2, Xh, o0, D2, RI, Qh, N2, F2, l3],
  3136571912: [Zh, Jh, tf, Xm, ac, ef, Ec, Ef, a3],
  530289379: [ac, ef, Ec, Ef],
  3689010777: [Qh, N2, F2],
  3979015343: [Ec],
  699246055: [vO, AO],
  2387106220: [_g, GV, NO],
  3665877780: [Hp, FU],
  2916149573: [GV],
  2296667514: [t4],
  1635779807: [f5],
  2887950389: [x2, Vv],
  167062518: [x2],
  1260505505: [R2, Mv, j2, Mg, Ug, IN, MV, BV, zy, Sg, h5, c0],
  1626504194: [qh, gU, $h, S2, Kh, vU, C2, nf, of, O2, L2, P2, rf, lf, SU, af, bU, NU, DU, uf, CU, M2, U2, N_, Eg, UU, If, pf, BU, mf, B2],
  3732776249: [MV, BV, zy, Sg, h5],
  15328376: [zy, Sg],
  2510884976: [Pg, Fg],
  2559216714: [qm, $m, Km, Jm, e3, r3],
  3293443760: [Y2, Zm, Qm, q2, RO, Z2, X2, e4, s4, o4],
  1306400036: [N_, Eg],
  3256556792: [ic, nc, sc, Gy, oc, Vy, rc, Wh, lc, Aa, JD, La, Mp, dc, va, Oa, Cp, _p, Ya, $a, tu, iu, tC, nu, au, iC, Pp, nC, du, cu, cc, Ca, Xa, hc, _a, eC, ka, Va, ru, fc, Sa, Fa, su, Ic, xa, Op, za, lu, hu, pc, ba, Dp, XD, Pa, qa, Ka, eu, ou, pu, mc, Na, Da, Ma, Ua, Ba, Ha, Ga, Lp, ja, Wa, Za, Qa, Ja, xp, uu, fu, Iu, mu, yu, Up, yc, ff],
  3849074793: [lc, Aa, JD, La, Mp, dc, va, Oa, Cp, _p, Ya, $a, tu, iu, tC, nu, au, iC, Pp, nC, du, cu, cc, Ca, Xa, hc, _a, eC, ka, Va, ru, fc, Sa, Fa, su, Ic, xa, Op, za, lu, hu, pc, ba, Dp, XD, Pa, qa, Ka, eu, ou, pu, mc, Na, Da, Ma, Ua, Ba, Ha, Ga, Lp, ja, Wa, Za, Qa, Ja, xp, uu, fu, Iu, mu, yu, Up, yc],
  1758889154: [Fm, Hm, Gm, km, Vm, zm, jm, H0, dd, m1, YD, A1, hI, hd, p1, v1, _1, k1, j1, W1, J1, X1, KD, tI, rI, ZD, aI, QD, uI, dI, fd, T1, Z1, Id, S1, $D, M1, B1, sI, pd, y1, L1, iI, md, b1, U1, F1, oI, cI, yd, E1, R1, qD, N1, z1, Y1, Q1, nI, pI, Ed, g1, w1, D1, C1, O1, x1, P1, H1, G1, V1, q1, $1, K1, eI, lI, fI, II, mI, yI, EI, gd, eh, Vp, d5, oh, cU, G0, k0, cd, V0, Z_, z0, j0, W0, vg, Y0, q0, $0, K0, Q_, Z0, J_, fU, IU, Q0, pU, J0, b_, Rb, yU, X0, A_, i0, EU, ih, nh, X_, sh, Ag, KU, zp, wI, RU, PV, R_, v_, S_, mU, _U, FV, c5, Ng, Cg, jp, Dg, vb, Wm, uc, df, wd, cf, t3, th, n0, bg, TU, ex, Ra, O_, Hu, Gu, ku, U0, r0, LU, lh, s3, Wp],
  1623761950: [th, n0, bg, TU, ex, Ra, O_, Hu, Gu, ku, U0, r0, LU, lh],
  2590856083: [Yh, A2, M0, wU, AU, ky, jy, C_, Wy, Yy, _2, B0, OU, hf],
  2107101300: [Na, Da, Ma, Ua, Ba, Ha, Ga, Lp, ja, Wa, Za, Qa, Ja, xp, uu, fu, Iu, mu, yu, Up],
  2853485674: [v2],
  807026263: [i3],
  24185140: [l0, D_, IC, x_, M_],
  1310830890: [fC, L_, __, P_, U_],
  2827207264: [Dg, vb, Wm, uc, df, wd, cf],
  2143335405: [wd],
  1287392070: [vb, Wm, uc],
  3907093117: [ba, Dp, XD, Pa, qa, Ka, eu, ou, pu],
  3198132628: [xa, Op, za, lu, hu],
  1482959167: [Sa, Fa, su],
  1834744321: [_a, eC, ka, Va, ru],
  1339347760: [Ca, Xa],
  2297155007: [va, Oa, Cp, _p, Ya, $a, tu, iu, tC, nu, au, iC, Pp, nC, du, cu],
  3009222698: [Aa, JD, La, Mp],
  263784265: [Ng, Cg],
  4230923436: [R_, v_, S_, mU, _U],
  2706460486: [W2, ju, T2, xv, CV, Pv, Ky, $2, AI, _v, K2, i4],
  2176059722: [OV, LV, _V, xV],
  3740093272: [Ym],
  1946335990: [hU, DV, gu, UV],
  3027567501: [Ra, O_, Hu, Gu, ku],
  964333572: [ky, jy, C_, Wy, Yy],
  682877961: [s0, b2, Xh, o0, D2],
  1179482911: [Zh, Jh, tf],
  1004757350: [o0],
  214636428: [ac],
  1252848954: [_v],
  3657597509: [s0],
  2254336722: [ju, T2, xv, CV, Pv, Ky],
  1953115116: [wI, RU],
  1028945134: [Zm, Qm],
  1967976161: [R2, Mv],
  2461110595: [R2],
  1136057603: [zy],
  1876633798: [oh, cU, G0, k0, cd, V0, Z_, z0, j0, W0, vg, Y0, q0, $0, K0, Q_, Z0, J_, fU, IU, Q0, pU, J0, b_, Rb, yU, X0, A_, i0, EU, ih, nh, X_, sh, Ag],
  3426335179: [A_, i0],
  2063403501: [ic, nc, sc, Gy, oc, Vy, rc],
  1945004755: [Fm, Hm, Gm, km, Vm, zm, jm, H0, dd, m1, YD, A1, hI, hd, p1, v1, _1, k1, j1, W1, J1, X1, KD, tI, rI, ZD, aI, QD, uI, dI, fd, T1, Z1, Id, S1, $D, M1, B1, sI, pd, y1, L1, iI, md, b1, U1, F1, oI, cI, yd, E1, R1, qD, N1, z1, Y1, Q1, nI, pI, Ed, g1, w1, D1, C1, O1, x1, P1, H1, G1, V1, q1, $1, K1, eI, lI, fI, II, mI, yI, EI, gd, eh],
  3040386961: [dd, m1, YD, A1, hI, hd, p1, v1, _1, k1, j1, W1, J1, X1, KD, tI, rI, ZD, aI, QD, uI, dI, fd, T1, Z1, Id, S1, $D, M1, B1, sI, pd, y1, L1, iI, md, b1, U1, F1, oI, cI, yd, E1, R1, qD, N1, z1, Y1, Q1, nI, pI, Ed, g1, w1, D1, C1, O1, x1, P1, H1, G1, V1, q1, $1, K1, eI, lI, fI, II, mI, yI, EI, gd],
  3205830791: [T2],
  1077100507: [b_, Rb],
  1658829314: [g1, w1, D1, C1, O1, x1, P1, H1, G1, V1, q1, $1, K1, eI, lI, fI, II, mI, yI, EI],
  2058353004: [E1, R1, qD, N1, z1, Y1, Q1, nI, pI],
  4278956645: [b1, U1, F1, oI, cI],
  3132237377: [y1, L1, iI],
  987401354: [S1, $D, M1, B1, sI],
  707683696: [T1, Z1],
  2223149337: [p1, v1, _1, k1, j1, W1, J1, X1, KD, tI, rI, ZD, aI, QD, uI, dI],
  3508470533: [m1, YD, A1, hI],
  2713699986: [R_, v_, S_],
  1154579445: [hU],
  2391406946: [cd],
  1062813311: [Fm, Hm, Gm, km, Vm, zm, jm]
};
_ie[3] = {
  3630933823: [["HasExternalReference", ui, 3, !0]],
  618182010: [["OfPerson", e6, 7, !0], ["OfOrganization", t6, 4, !0]],
  411424972: [["HasExternalReference", ui, 3, !0]],
  130549933: [["HasExternalReferences", ui, 3, !0], ["ApprovedObjects", T4, 5, !0], ["ApprovedResources", ad, 3, !0], ["IsRelatedWith", yL, 3, !0], ["Relates", yL, 2, !0]],
  1959218052: [["HasExternalReferences", ui, 3, !0], ["PropertiesForConstraint", Gl, 2, !0]],
  1466758467: [["HasCoordinateOperation", FO, 0, !0]],
  602808272: [["HasExternalReference", ui, 3, !0]],
  3200245327: [["ExternalReferenceForResources", ui, 2, !0]],
  2242383968: [["ExternalReferenceForResources", ui, 2, !0]],
  1040185647: [["ExternalReferenceForResources", ui, 2, !0]],
  3548104201: [["ExternalReferenceForResources", ui, 2, !0]],
  852622518: [["PartOfW", gu, 9, !0], ["PartOfV", gu, 8, !0], ["PartOfU", gu, 7, !0], ["HasIntersections", jae, 0, !0]],
  2655187982: [["LibraryInfoForObjects", oE, 5, !0], ["HasLibraryReferences", sY, 5, !0]],
  3452421091: [["ExternalReferenceForResources", ui, 2, !0], ["LibraryRefForObjects", oE, 5, !0]],
  760658860: [["AssociatedTo", So, 5, !0], ["HasExternalReferences", ui, 3, !0], ["HasProperties", Ta, 3, !0]],
  248100487: [["AssociatedTo", So, 5, !0], ["HasExternalReferences", ui, 3, !0], ["HasProperties", Ta, 3, !0], ["ToMaterialLayerSet", pL, 0, !1]],
  3303938423: [["AssociatedTo", So, 5, !0], ["HasExternalReferences", ui, 3, !0], ["HasProperties", Ta, 3, !0]],
  1847252529: [["AssociatedTo", So, 5, !0], ["HasExternalReferences", ui, 3, !0], ["HasProperties", Ta, 3, !0], ["ToMaterialLayerSet", pL, 0, !1]],
  2235152071: [["AssociatedTo", So, 5, !0], ["HasExternalReferences", ui, 3, !0], ["HasProperties", Ta, 3, !0], ["ToMaterialProfileSet", $P, 2, !1]],
  164193824: [["AssociatedTo", So, 5, !0], ["HasExternalReferences", ui, 3, !0], ["HasProperties", Ta, 3, !0]],
  552965576: [["AssociatedTo", So, 5, !0], ["HasExternalReferences", ui, 3, !0], ["HasProperties", Ta, 3, !0], ["ToMaterialProfileSet", $P, 2, !1]],
  1507914824: [["AssociatedTo", So, 5, !0]],
  3368373690: [["HasExternalReferences", ui, 3, !0], ["PropertiesForConstraint", Gl, 2, !0]],
  3701648758: [["PlacesObject", Td, 5, !0], ["ReferencedByPlacements", XQ, 0, !0]],
  2251480897: [["HasExternalReferences", ui, 3, !0], ["PropertiesForConstraint", Gl, 2, !0]],
  4251960020: [["IsRelatedBy", IL, 3, !0], ["Relates", IL, 2, !0], ["Engages", RH, 1, !0]],
  2077209135: [["EngagedIn", RH, 0, !0]],
  2483315170: [["HasExternalReferences", ui, 3, !0], ["PartOfComplex", Jr, 2, !0]],
  2226359599: [["HasExternalReferences", ui, 3, !0], ["PartOfComplex", Jr, 2, !0]],
  3355820592: [["OfPerson", e6, 7, !0], ["OfOrganization", t6, 4, !0]],
  3958567839: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  3843373140: [["HasCoordinateOperation", FO, 0, !0]],
  986844984: [["HasExternalReferences", ui, 3, !0]],
  3710013099: [["HasExternalReferences", ui, 3, !0]],
  2044713172: [["HasExternalReferences", ui, 3, !0], ["PartOfComplex", Jr, 2, !0]],
  2093928680: [["HasExternalReferences", ui, 3, !0], ["PartOfComplex", Jr, 2, !0]],
  931644368: [["HasExternalReferences", ui, 3, !0], ["PartOfComplex", Jr, 2, !0]],
  2691318326: [["HasExternalReferences", ui, 3, !0], ["PartOfComplex", Jr, 2, !0]],
  3252649465: [["HasExternalReferences", ui, 3, !0], ["PartOfComplex", Jr, 2, !0]],
  2405470396: [["HasExternalReferences", ui, 3, !0], ["PartOfComplex", Jr, 2, !0]],
  825690147: [["HasExternalReferences", ui, 3, !0], ["PartOfComplex", Jr, 2, !0]],
  1076942058: [["RepresentationMap", ah, 1, !0], ["LayerAssignments", Ke, 2, !0], ["OfProductRepresentation", wf, 2, !0]],
  3377609919: [["RepresentationsInContext", XN, 0, !0]],
  3008791417: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1660063152: [["HasShapeAspects", Qy, 4, !0], ["MapUsage", hL, 0, !0]],
  867548509: [["HasExternalReferences", ui, 3, !0]],
  3982875396: [["RepresentationMap", ah, 1, !0], ["LayerAssignments", Ke, 2, !0], ["OfProductRepresentation", wf, 2, !0], ["OfShapeAspect", Qy, 0, !0]],
  4240577450: [["RepresentationMap", ah, 1, !0], ["LayerAssignments", Ke, 2, !0], ["OfProductRepresentation", wf, 2, !0], ["OfShapeAspect", Qy, 0, !0]],
  2830218821: [["RepresentationMap", ah, 1, !0], ["LayerAssignments", Ke, 2, !0], ["OfProductRepresentation", wf, 2, !0]],
  3958052878: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3049322572: [["RepresentationMap", ah, 1, !0], ["LayerAssignments", Ke, 2, !0], ["OfProductRepresentation", wf, 2, !0]],
  626085974: [["IsMappedBy", nA, 0, !0], ["UsedInStyles", N5, 0, !0]],
  912023232: [["OfPerson", e6, 7, !0], ["OfOrganization", t6, 4, !0]],
  222769930: [["ToTexMap", Dz, 3, !1]],
  1010789467: [["ToTexMap", Dz, 3, !1]],
  3101149627: [["HasExternalReference", ui, 3, !0]],
  1377556343: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1735638870: [["RepresentationMap", ah, 1, !0], ["LayerAssignments", Ke, 2, !0], ["OfProductRepresentation", wf, 2, !0], ["OfShapeAspect", Qy, 0, !0]],
  2799835756: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1907098498: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3798115385: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  1310608509: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  2705031697: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  616511568: [["IsMappedBy", nA, 0, !0], ["UsedInStyles", N5, 0, !0]],
  3150382593: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  747523909: [["ClassificationForObjects", lE, 5, !0], ["HasReferences", g8, 3, !0]],
  647927063: [["ExternalReferenceForResources", ui, 2, !0], ["ClassificationRefForObjects", lE, 5, !0], ["HasReferences", g8, 3, !0]],
  1485152156: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  370225590: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3050246964: [["HasExternalReference", ui, 3, !0]],
  2889183280: [["HasExternalReference", ui, 3, !0]],
  2713554722: [["HasExternalReference", ui, 3, !0]],
  3632507154: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  1154170062: [["DocumentInfoForObjects", rE, 5, !0], ["HasDocumentReferences", nY, 4, !0], ["IsPointedTo", mL, 3, !0], ["IsPointer", mL, 2, !0]],
  3732053477: [["ExternalReferenceForResources", ui, 2, !0], ["DocumentRefForObjects", rE, 5, !0]],
  3900360178: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  476780140: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  297599258: [["HasExternalReferences", ui, 3, !0]],
  2556980723: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0], ["HasTextureMaps", P5, 2, !0]],
  1809719519: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  803316827: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3008276851: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0], ["HasTextureMaps", P5, 2, !0]],
  3448662350: [["RepresentationsInContext", XN, 0, !0], ["HasSubContexts", dE, 6, !0], ["HasCoordinateOperation", FO, 0, !0]],
  2453401579: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4142052618: [["RepresentationsInContext", XN, 0, !0], ["HasSubContexts", dE, 6, !0], ["HasCoordinateOperation", FO, 0, !0]],
  3590301190: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  178086475: [["PlacesObject", Td, 5, !0], ["ReferencedByPlacements", XQ, 0, !0]],
  812098782: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3905492369: [["IsMappedBy", nA, 0, !0], ["UsedInStyles", N5, 0, !0]],
  3741457305: [["HasExternalReference", ui, 3, !0]],
  1402838566: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  125510826: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2604431987: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4266656042: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1520743889: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3422422726: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  388784114: [["PlacesObject", Td, 5, !0], ["ReferencedByPlacements", XQ, 0, !0]],
  2624227202: [["PlacesObject", Td, 5, !0], ["ReferencedByPlacements", XQ, 0, !0]],
  1008929658: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2347385850: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1838606355: [["AssociatedTo", So, 5, !0], ["HasExternalReferences", ui, 3, !0], ["HasProperties", Ta, 3, !0], ["HasRepresentation", PH, 3, !0], ["IsRelatedWith", XF, 3, !0], ["RelatesTo", XF, 2, !0]],
  3708119e3: [["AssociatedTo", So, 5, !0], ["HasExternalReferences", ui, 3, !0], ["HasProperties", Ta, 3, !0], ["ToMaterialConstituentSet", iY, 2, !1]],
  2852063980: [["AssociatedTo", So, 5, !0], ["HasExternalReferences", ui, 3, !0], ["HasProperties", Ta, 3, !0]],
  1303795690: [["AssociatedTo", So, 5, !0]],
  3079605661: [["AssociatedTo", So, 5, !0]],
  3404854881: [["AssociatedTo", So, 5, !0]],
  3265635763: [["HasExternalReferences", ui, 3, !0]],
  2998442950: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  219451334: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0]],
  182550632: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  2665983363: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1029017970: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2529465313: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  2519244187: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3021840470: [["HasExternalReferences", ui, 3, !0], ["PartOfComplex", Jr, 2, !0]],
  597895409: [["IsMappedBy", nA, 0, !0], ["UsedInStyles", N5, 0, !0]],
  2004835150: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1663979128: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2067069095: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2165702409: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4022376103: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1423911732: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2924175390: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2775532180: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3778827333: [["HasExternalReferences", ui, 3, !0]],
  673634403: [["ShapeOfProduct", Td, 6, !0], ["HasShapeAspects", Qy, 4, !0]],
  2802850158: [["HasExternalReferences", ui, 3, !0]],
  2598011224: [["HasExternalReferences", ui, 3, !0], ["PartOfPset", Rl, 4, !0], ["PropertyForDependance", cs, 2, !0], ["PropertyDependsOn", cs, 3, !0], ["PartOfComplex", Ur, 3, !0], ["HasConstraints", Gl, 3, !0], ["HasApprovals", ad, 2, !0]],
  1680319473: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0]],
  3357820518: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0], ["DefinesType", $s, 5, !0], ["IsDefinedBy", Zr, 4, !0], ["DefinesOccurrence", Fe, 5, !0]],
  1482703590: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0]],
  2090586900: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0], ["DefinesType", $s, 5, !0], ["IsDefinedBy", Zr, 4, !0], ["DefinesOccurrence", Fe, 5, !0]],
  3615266464: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  3413951693: [["HasExternalReference", ui, 3, !0]],
  1580146022: [["HasExternalReferences", ui, 3, !0]],
  2778083089: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  2042790032: [["HasExternalReferences", ui, 3, !0]],
  4165799628: [["HasExternalReferences", ui, 3, !0]],
  1509187699: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  823603102: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0], ["UsingCurves", c0, 0, !0]],
  4124623270: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3692461612: [["HasExternalReferences", ui, 3, !0], ["PartOfPset", Rl, 4, !0], ["PropertyForDependance", cs, 2, !0], ["PropertyDependsOn", cs, 3, !0], ["PartOfComplex", Ur, 3, !0], ["HasConstraints", Gl, 3, !0], ["HasApprovals", ad, 2, !0]],
  723233188: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2233826070: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2513912981: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2247615214: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1260650574: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1096409881: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  230924584: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3071757647: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  901063453: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4282788508: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3124975700: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2715220739: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  1628702193: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0]],
  3736923433: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["OperatesOn", Xr, 6, !0]],
  2347495698: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3698973494: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ResourceOf", Ns, 6, !0]],
  427810014: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  1417489154: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2759199220: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2543172580: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  3406155212: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0], ["HasTextureMaps", P5, 2, !0]],
  669184980: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3207858831: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  4261334040: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3125803723: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2740243338: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3425423356: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2736907675: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4182860854: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2581212453: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2713105998: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2898889636: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  1123145078: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  574549367: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1675464909: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2059837836: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  59481748: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3749851601: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3486308946: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3331915920: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1416205885: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1383045692: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  2205249479: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2542286263: [["HasExternalReferences", ui, 3, !0], ["PartOfPset", Rl, 4, !0], ["PropertyForDependance", cs, 2, !0], ["PropertyDependsOn", cs, 3, !0], ["PartOfComplex", Ur, 3, !0], ["HasConstraints", Gl, 3, !0], ["HasApprovals", ad, 2, !0]],
  2485617015: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0], ["UsingCurves", c0, 0, !0]],
  2574617495: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ResourceOf", Ns, 6, !0]],
  3419103109: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["Declares", me, 4, !0]],
  1815067380: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ResourceOf", Ns, 6, !0]],
  2506170314: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2147822146: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2601014836: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2827736869: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2629017746: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4212018352: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0], ["UsingCurves", c0, 0, !0]],
  32440307: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  593015953: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1472233963: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1883228015: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0], ["DefinesType", $s, 5, !0], ["IsDefinedBy", Zr, 4, !0], ["DefinesOccurrence", Fe, 5, !0]],
  339256511: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2777663545: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2835456948: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  4024345920: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["OperatesOn", Xr, 6, !0]],
  477187591: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2804161546: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2047409740: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  374418227: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  315944413: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2652556860: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4238390223: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1268542332: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  4095422895: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  987898635: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1484403080: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  178912537: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0], ["ToFaceSet", _g, 2, !0], ["HasTexCoords", Q1e, 1, !0]],
  2294589976: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0], ["ToFaceSet", _g, 2, !0], ["HasTexCoords", Q1e, 1, !0]],
  572779678: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  428585644: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ResourceOf", Ns, 6, !0]],
  1281925730: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1425443689: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3888040117: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0]],
  590820931: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3388369263: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3505215534: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2485787929: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1682466193: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  603570806: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  220341763: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3381221214: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3967405729: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0], ["DefinesType", $s, 5, !0], ["IsDefinedBy", Zr, 4, !0], ["DefinesOccurrence", Fe, 5, !0]],
  569719735: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["OperatesOn", Xr, 6, !0]],
  2945172077: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsPredecessorTo", tr, 4, !0], ["IsSuccessorFrom", tr, 5, !0], ["OperatesOn", Xr, 6, !0]],
  4208778838: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0]],
  103090709: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["Declares", me, 4, !0]],
  653396225: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["Declares", me, 4, !0]],
  871118103: [["HasExternalReferences", ui, 3, !0], ["PartOfPset", Rl, 4, !0], ["PropertyForDependance", cs, 2, !0], ["PropertyDependsOn", cs, 3, !0], ["PartOfComplex", Ur, 3, !0], ["HasConstraints", Gl, 3, !0], ["HasApprovals", ad, 2, !0]],
  4166981789: [["HasExternalReferences", ui, 3, !0], ["PartOfPset", Rl, 4, !0], ["PropertyForDependance", cs, 2, !0], ["PropertyDependsOn", cs, 3, !0], ["PartOfComplex", Ur, 3, !0], ["HasConstraints", Gl, 3, !0], ["HasApprovals", ad, 2, !0]],
  2752243245: [["HasExternalReferences", ui, 3, !0], ["PartOfPset", Rl, 4, !0], ["PropertyForDependance", cs, 2, !0], ["PropertyDependsOn", cs, 3, !0], ["PartOfComplex", Ur, 3, !0], ["HasConstraints", Gl, 3, !0], ["HasApprovals", ad, 2, !0]],
  941946838: [["HasExternalReferences", ui, 3, !0], ["PartOfPset", Rl, 4, !0], ["PropertyForDependance", cs, 2, !0], ["PropertyDependsOn", cs, 3, !0], ["PartOfComplex", Ur, 3, !0], ["HasConstraints", Gl, 3, !0], ["HasApprovals", ad, 2, !0]],
  1451395588: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0], ["DefinesType", $s, 5, !0], ["IsDefinedBy", Zr, 4, !0], ["DefinesOccurrence", Fe, 5, !0]],
  492091185: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0], ["Defines", Zr, 5, !0]],
  3650150729: [["HasExternalReferences", ui, 3, !0], ["PartOfPset", Rl, 4, !0], ["PropertyForDependance", cs, 2, !0], ["PropertyDependsOn", cs, 3, !0], ["PartOfComplex", Ur, 3, !0], ["HasConstraints", Gl, 3, !0], ["HasApprovals", ad, 2, !0]],
  110355661: [["HasExternalReferences", ui, 3, !0], ["PartOfPset", Rl, 4, !0], ["PropertyForDependance", cs, 2, !0], ["PropertyDependsOn", cs, 3, !0], ["PartOfComplex", Ur, 3, !0], ["HasConstraints", Gl, 3, !0], ["HasApprovals", ad, 2, !0]],
  3521284610: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0], ["PartOfComplexTemplate", eE, 6, !0], ["PartOfPsetTemplate", w4, 6, !0]],
  2770003689: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  2798486643: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3454111270: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3765753017: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0], ["DefinesType", $s, 5, !0], ["IsDefinedBy", Zr, 4, !0], ["DefinesOccurrence", Fe, 5, !0]],
  3523091289: [["InnerBoundaries", xg, 9, !0]],
  1521410863: [["InnerBoundaries", xg, 9, !0], ["Corresponds", Og, 10, !0]],
  816062949: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0], ["UsingCurves", c0, 0, !0]],
  2914609552: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ResourceOf", Ns, 6, !0]],
  1856042241: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3243963512: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4158566097: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3626867408: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1862484736: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1290935644: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1356537516: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3663146110: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0], ["PartOfComplexTemplate", eE, 6, !0], ["PartOfPsetTemplate", w4, 6, !0]],
  1412071761: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["ContainsElements", Xe, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ReferencesElements", We, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0]],
  710998568: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2706606064: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["ContainsElements", Xe, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ReferencesElements", We, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0]],
  3893378262: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  463610769: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["ContainsElements", Xe, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ReferencesElements", We, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0]],
  2481509218: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  451544542: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4015995234: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2735484536: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3544373492: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["AssignedToStructuralItem", Un, 5, !0]],
  3136571912: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["AssignedStructuralActivity", Un, 4, !0]],
  530289379: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["AssignedStructuralActivity", Un, 4, !0], ["ConnectedBy", Ko, 4, !0]],
  3689010777: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["AssignedToStructuralItem", Un, 5, !0]],
  3979015343: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["AssignedStructuralActivity", Un, 4, !0], ["ConnectedBy", Ko, 4, !0]],
  2218152070: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["AssignedStructuralActivity", Un, 4, !0], ["ConnectedBy", Ko, 4, !0]],
  603775116: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["AssignedToStructuralItem", Un, 5, !0]],
  4095615324: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ResourceOf", Ns, 6, !0]],
  699246055: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2028607225: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2809605785: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4124788165: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1580310250: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3473067441: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsPredecessorTo", tr, 4, !0], ["IsSuccessorFrom", tr, 5, !0], ["OperatesOn", Xr, 6, !0]],
  3206491090: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["OperatesOn", Xr, 6, !0]],
  2387106220: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0], ["HasColours", eA, 0, !0], ["HasTextures", z2, 1, !0]],
  782932809: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1935646853: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3665877780: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2916149573: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0], ["HasColours", eA, 0, !0], ["HasTextures", z2, 1, !0]],
  1229763772: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0], ["HasColours", eA, 0, !0], ["HasTextures", z2, 1, !0]],
  3651464721: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  336235671: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0], ["DefinesType", $s, 5, !0], ["IsDefinedBy", Zr, 4, !0], ["DefinesOccurrence", Fe, 5, !0]],
  512836454: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0], ["DefinesType", $s, 5, !0], ["IsDefinedBy", Zr, 4, !0], ["DefinesOccurrence", Fe, 5, !0]],
  2296667514: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsActingUpon", Xp, 6, !0]],
  1635779807: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2603310189: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1674181508: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["ContainedInStructure", Xe, 4, !0]],
  2887950389: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  167062518: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1334484129: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3649129432: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1260505505: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3124254112: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["ContainsElements", Xe, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ReferencesElements", We, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0]],
  1626504194: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2197970202: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2937912522: [["HasExternalReference", ui, 3, !0], ["HasProperties", Rs, 3, !0]],
  3893394355: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3497074424: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  300633059: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3875453745: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0], ["PartOfComplexTemplate", eE, 6, !0], ["PartOfPsetTemplate", w4, 6, !0]],
  3732776249: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  15328376: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2510884976: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2185764099: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ResourceOf", Ns, 6, !0]],
  4105962743: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ResourceOf", Ns, 6, !0]],
  1525564444: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ResourceOf", Ns, 6, !0]],
  2559216714: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ResourceOf", Ns, 6, !0]],
  3293443760: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["Controls", bs, 6, !0]],
  2000195564: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3895139033: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["Controls", bs, 6, !0]],
  1419761937: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["Controls", bs, 6, !0]],
  4189326743: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1916426348: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3295246426: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ResourceOf", Ns, 6, !0]],
  1457835157: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1213902940: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1306400036: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  4234616927: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3256556792: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3849074793: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2963535650: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0], ["DefinesType", $s, 5, !0], ["IsDefinedBy", Zr, 4, !0], ["DefinesOccurrence", Fe, 5, !0]],
  1714330368: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0], ["DefinesType", $s, 5, !0], ["IsDefinedBy", Zr, 4, !0], ["DefinesOccurrence", Fe, 5, !0]],
  2323601079: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1758889154: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  4123344466: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  2397081782: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1623761950: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  2590856083: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1704287377: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2107101300: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  132023988: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3174744832: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3390157468: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  4148101412: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsPredecessorTo", tr, 4, !0], ["IsSuccessorFrom", tr, 5, !0], ["OperatesOn", Xr, 6, !0]],
  2853485674: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["ContainsElements", Xe, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ReferencesElements", We, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0]],
  807026263: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3737207727: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  24185140: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["ContainsElements", Xe, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ReferencesElements", We, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0]],
  1310830890: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["ContainsElements", Xe, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ReferencesElements", We, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0]],
  4228831410: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["ContainsElements", Xe, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ReferencesElements", We, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0]],
  647756555: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  2489546625: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2827207264: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  2143335405: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["ProjectsElements", lt, 5, !1]],
  1287392070: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["VoidsElements", ot, 5, !1]],
  3907093117: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3198132628: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3815607619: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1482959167: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1834744321: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1339347760: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2297155007: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3009222698: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1893162501: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  263784265: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  1509553395: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  3493046030: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  4230923436: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  1594536857: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  2898700619: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2706460486: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsGroupedBy", Vs, 6, !0], ["ReferencedInStructures", We, 4, !0]],
  1251058090: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1806887404: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2568555532: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  3948183225: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2571569899: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3946677679: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3113134337: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2391368822: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsGroupedBy", Vs, 6, !0], ["ReferencedInStructures", We, 4, !0]],
  4288270099: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  679976338: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3827777499: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ResourceOf", Ns, 6, !0]],
  1051575348: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1161773419: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2176059722: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0]],
  1770583370: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  525669439: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["ContainsElements", Xe, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ReferencesElements", We, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0]],
  976884017: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["ContainsElements", Xe, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ReferencesElements", We, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0]],
  377706215: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  2108223431: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1114901282: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3181161470: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1950438474: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  710110818: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  977012517: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  506776471: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  4143007308: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsActingUpon", Xp, 6, !0]],
  3588315303: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["VoidsElements", ot, 5, !1], ["HasFillings", ut, 4, !0]],
  2837617999: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  514975943: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2382730787: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["Controls", bs, 6, !0]],
  3566463478: [["HasContext", me, 5, !0], ["HasAssociations", X, 4, !0], ["DefinesType", $s, 5, !0], ["IsDefinedBy", Zr, 4, !0], ["DefinesOccurrence", Fe, 5, !0]],
  3327091369: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["Controls", bs, 6, !0]],
  1158309216: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  804291784: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  4231323485: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  4017108033: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2839578677: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0], ["HasColours", eA, 0, !0], ["HasTextures", z2, 1, !0]],
  3724593414: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3740093272: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["ContainedIn", Vt, 4, !0], ["ConnectedFrom", Ad, 5, !0], ["ConnectedTo", Ad, 4, !0]],
  1946335990: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["ContainedInStructure", Xe, 4, !0], ["Positions", Yt, 4, !0]],
  2744685151: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsPredecessorTo", tr, 4, !0], ["IsSuccessorFrom", tr, 5, !0], ["OperatesOn", Xr, 6, !0]],
  2904328755: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["Controls", bs, 6, !0]],
  3651124850: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["ProjectsElements", lt, 5, !1]],
  1842657554: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2250791053: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1763565496: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2893384427: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3992365140: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["ContainsElements", Xe, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ReferencesElements", We, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0]],
  1891881377: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["ContainsElements", Xe, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ReferencesElements", We, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0]],
  2324767716: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1469900589: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  683857671: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4021432810: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["ContainedInStructure", Xe, 4, !0], ["Positions", Yt, 4, !0]],
  3027567501: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  964333572: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2320036040: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  2310774935: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  146592293: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["ContainsElements", Xe, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ReferencesElements", We, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0]],
  550521510: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["ContainsElements", Xe, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ReferencesElements", We, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0]],
  2781568857: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1768891740: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2157484638: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3649235739: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  544395925: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1027922057: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4074543187: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  33720170: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  3599934289: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1894708472: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  42703149: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  4097777520: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["ContainsElements", Xe, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ReferencesElements", We, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0]],
  2533589738: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1072016465: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3856911033: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["ContainsElements", Xe, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ReferencesElements", We, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasCoverings", Jp, 4, !0], ["BoundedBy", at, 4, !0]],
  1305183839: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3812236995: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3112655638: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1039846685: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  338393293: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  682877961: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["AssignedToStructuralItem", Un, 5, !0]],
  1179482911: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["AssignedStructuralActivity", Un, 4, !0], ["ConnectsStructuralMembers", Ko, 5, !0]],
  1004757350: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["AssignedToStructuralItem", Un, 5, !0]],
  4243806635: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["AssignedStructuralActivity", Un, 4, !0], ["ConnectsStructuralMembers", Ko, 5, !0]],
  214636428: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["AssignedStructuralActivity", Un, 4, !0], ["ConnectedBy", Ko, 4, !0]],
  2445595289: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["AssignedStructuralActivity", Un, 4, !0], ["ConnectedBy", Ko, 4, !0]],
  2757150158: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["AssignedToStructuralItem", Un, 5, !0]],
  1807405624: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["AssignedToStructuralItem", Un, 5, !0]],
  1252848954: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsGroupedBy", Vs, 6, !0], ["ReferencedInStructures", We, 4, !0], ["SourceOfResultGroup", AI, 6, !0], ["LoadGroupFor", ju, 7, !0]],
  2082059205: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["AssignedToStructuralItem", Un, 5, !0]],
  734778138: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["AssignedStructuralActivity", Un, 4, !0], ["ConnectsStructuralMembers", Ko, 5, !0]],
  1235345126: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["AssignedToStructuralItem", Un, 5, !0]],
  2986769608: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsGroupedBy", Vs, 6, !0], ["ReferencedInStructures", We, 4, !0], ["ResultGroupFor", ju, 8, !0]],
  3657597509: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["AssignedToStructuralItem", Un, 5, !0]],
  1975003073: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["AssignedStructuralActivity", Un, 4, !0], ["ConnectsStructuralMembers", Ko, 5, !0]],
  148013059: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ResourceOf", Ns, 6, !0]],
  3101698114: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["AdheresToElement", di, 5, !1]],
  2315554128: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2254336722: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsGroupedBy", Vs, 6, !0], ["ReferencedInStructures", We, 4, !0], ["ServicesBuildings", ns, 4, !0], ["ServicesFacilities", We, 4, !0]],
  413509423: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  5716631: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3824725483: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  2347447852: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  3081323446: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3663046924: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  2281632017: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2415094496: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  618700268: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1692211062: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2097647324: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1953115116: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  3593883385: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1600972822: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1911125066: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  728799441: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  840318589: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  1530820697: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  3956297820: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2391383451: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  3313531582: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2769231204: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  926996030: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["VoidsElements", ot, 5, !1]],
  1898987631: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1133259667: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  4009809668: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  4088093105: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["Controls", bs, 6, !0]],
  1028945134: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["Controls", bs, 6, !0]],
  4218914973: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["Controls", bs, 6, !0]],
  3342526732: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["Controls", bs, 6, !0]],
  1033361043: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsGroupedBy", Vs, 6, !0], ["ReferencedInStructures", We, 4, !0], ["ServicesBuildings", ns, 4, !0], ["ServicesFacilities", We, 4, !0]],
  3821786052: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["Controls", bs, 6, !0]],
  1411407467: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3352864051: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1871374353: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  4266260250: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0]],
  1545765605: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0]],
  317615605: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0]],
  1662888072: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0]],
  3460190687: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsGroupedBy", Vs, 6, !0], ["ReferencedInStructures", We, 4, !0]],
  1532957894: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1967976161: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  2461110595: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  819618141: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3649138523: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  231477066: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1136057603: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  644574406: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["ContainsElements", Xe, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ReferencesElements", We, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0]],
  963979645: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["ContainsElements", Xe, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ReferencesElements", We, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0]],
  4031249490: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["ContainsElements", Xe, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ReferencesElements", We, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0]],
  2979338954: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  39481116: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1909888760: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1177604601: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsGroupedBy", Vs, 6, !0], ["ReferencedInStructures", We, 4, !0], ["ServicesBuildings", ns, 4, !0], ["ServicesFacilities", We, 4, !0]],
  1876633798: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  3862327254: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsGroupedBy", Vs, 6, !0], ["ReferencedInStructures", We, 4, !0], ["ServicesBuildings", ns, 4, !0], ["ServicesFacilities", We, 4, !0]],
  2188180465: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  395041908: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3293546465: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2674252688: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1285652485: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3203706013: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2951183804: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3296154744: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  2611217952: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  1677625105: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  2301859152: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  843113511: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  400855858: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3850581409: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2816379211: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3898045240: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ResourceOf", Ns, 6, !0]],
  1060000209: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ResourceOf", Ns, 6, !0]],
  488727124: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ResourceOf", Ns, 6, !0]],
  2940368186: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  335055490: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2954562838: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1502416096: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  1973544240: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["CoversSpaces", Jp, 5, !0], ["CoversElements", dt, 5, !0]],
  3495092785: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  3961806047: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3426335179: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  1335981549: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  2635815018: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  479945903: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1599208980: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2063403501: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1945004755: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0]],
  3040386961: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3041715199: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["ContainedIn", Vt, 4, !0], ["ConnectedFrom", Ad, 5, !0], ["ConnectedTo", Ad, 4, !0]],
  3205830791: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsGroupedBy", Vs, 6, !0], ["ReferencedInStructures", We, 4, !0], ["ServicesBuildings", ns, 4, !0], ["ServicesFacilities", We, 4, !0]],
  395920057: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  869906466: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3760055223: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2030761528: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3071239417: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["VoidsElements", ot, 5, !1]],
  1077100507: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  3376911765: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  663422040: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2417008758: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3277789161: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2142170206: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1534661035: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1217240411: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  712377611: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1658829314: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  2814081492: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3747195512: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  484807127: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  1209101575: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["ContainsElements", Xe, 5, !0], ["ServicedBySystems", ns, 5, !0], ["ReferencesElements", We, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["BoundedBy", at, 4, !0]],
  346874300: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1810631287: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  4222183408: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2058353004: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  4278956645: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  4037862832: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2188021234: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3132237377: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  987401354: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  707683696: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  2223149337: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3508470533: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  900683007: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  2713699986: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  3009204131: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["ContainedInStructure", Xe, 4, !0], ["Positions", Yt, 4, !0]],
  3319311131: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  2068733104: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  4175244083: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  2176052936: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  2696325953: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  76236018: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  629592764: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  1154579445: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["ContainedInStructure", Xe, 4, !0], ["Positions", Yt, 4, !0]],
  1638804497: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  1437502449: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  1073191201: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  2078563270: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  234836483: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  2474470126: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  2182337498: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  144952367: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3694346114: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  1383356374: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  1687234759: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  310824031: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3612865200: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3171933400: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  738039164: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  655969474: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  90941305: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3290496277: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  2262370178: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  3024970846: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  3283111854: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  1232101972: [["LayerAssignment", Ke, 2, !0], ["StyledByItem", Qe, 0, !0]],
  3798194928: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  979691226: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  2572171363: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  2016517767: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  3053780830: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  1783015770: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1329646415: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  991950508: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  1529196076: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  3420628829: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  1999602285: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  1404847402: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  331165859: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  4252922144: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  2515109513: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsGroupedBy", Vs, 6, !0], ["ReferencedInStructures", We, 4, !0], ["ServicesBuildings", ns, 4, !0], ["ServicesFacilities", We, 4, !0]],
  385403989: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsGroupedBy", Vs, 6, !0], ["ReferencedInStructures", We, 4, !0], ["SourceOfResultGroup", AI, 6, !0], ["LoadGroupFor", ju, 7, !0]],
  1621171031: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["AssignedToStructuralItem", Un, 5, !0]],
  1162798199: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  812556717: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3425753595: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  3825984169: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  1620046519: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  3026737570: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3179687236: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  4292641817: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  4207607924: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  2391406946: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  3512223829: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  4237592921: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3304561284: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  2874132201: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  1634111441: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  177149247: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  2056796094: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3001207471: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  325726236: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["ContainedInStructure", Xe, 4, !0], ["Positions", Yt, 4, !0]],
  277319702: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  753842376: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  4196446775: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  32344328: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3314249567: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  1095909175: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  2938176219: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  635142910: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3758799889: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  1051757585: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  4217484030: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3999819293: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  3902619387: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  639361253: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3221913625: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3571504051: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  2272882330: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  578613899: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["Types", fe, 5, !0], ["ReferencedBy", ge, 6, !0]],
  3460952963: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  4136498852: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3640358203: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  4074379575: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3693000487: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  1052013943: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  562808652: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["IsGroupedBy", Vs, 6, !0], ["ReferencedInStructures", We, 4, !0], ["ServicesBuildings", ns, 4, !0], ["ServicesFacilities", We, 4, !0]],
  1062813311: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["AssignedToFlowElement", ri, 4, !0]],
  342316401: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3518393246: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  1360408905: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  1904799276: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  862014818: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3310460725: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  24726584: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  264262732: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  402227799: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  1003880860: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  3415622556: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  819412036: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  1426591983: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["HasControlElements", ri, 5, !0]],
  182646315: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["AssignedToFlowElement", ri, 4, !0]],
  2680139844: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  1971632696: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0]],
  2295281155: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["AssignedToFlowElement", ri, 4, !0]],
  4086658281: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["AssignedToFlowElement", ri, 4, !0]],
  630975310: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["AssignedToFlowElement", ri, 4, !0]],
  4288193352: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["AssignedToFlowElement", ri, 4, !0]],
  3087945054: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["AssignedToFlowElement", ri, 4, !0]],
  25142252: [["HasAssignments", ie, 4, !0], ["Nests", B, 5, !0], ["IsNestedBy", B, 4, !0], ["HasContext", me, 5, !0], ["IsDecomposedBy", U, 4, !0], ["Decomposes", U, 5, !0], ["HasAssociations", X, 4, !0], ["IsDeclaredBy", le, 4, !0], ["Declares", le, 5, !0], ["IsTypedBy", fe, 4, !0], ["IsDefinedBy", Fe, 4, !0], ["ReferencedBy", ge, 6, !0], ["PositionedRelativeTo", Yt, 5, !0], ["ReferencedInStructures", We, 4, !0], ["FillsVoids", ut, 5, !0], ["ConnectedTo", Te, 5, !0], ["IsInterferedByElements", Ce, 5, !0], ["InterferesElements", Ce, 4, !0], ["HasProjections", lt, 4, !0], ["HasOpenings", ot, 4, !0], ["IsConnectionRealization", ct, 7, !0], ["ProvidesBoundaries", at, 5, !0], ["ConnectedFrom", Te, 6, !0], ["ContainedInStructure", Xe, 4, !0], ["HasCoverings", dt, 4, !0], ["HasSurfaceFeatures", di, 4, !0], ["HasPorts", Vt, 5, !0], ["AssignedToFlowElement", ri, 4, !0]]
};
xie[3] = {
  3630933823: (e) => new a.IfcActorRole(e[0], e[1], e[2]),
  618182010: (e) => new a.IfcAddress(e[0], e[1], e[2]),
  2879124712: (e) => new a.IfcAlignmentParameterSegment(e[0], e[1]),
  3633395639: (e) => new a.IfcAlignmentVerticalSegment(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  639542469: (e) => new a.IfcApplication(e[0], e[1], e[2], e[3]),
  411424972: (e) => new a.IfcAppliedValue(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  130549933: (e) => new a.IfcApproval(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4037036970: (e) => new a.IfcBoundaryCondition(e[0]),
  1560379544: (e) => new a.IfcBoundaryEdgeCondition(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3367102660: (e) => new a.IfcBoundaryFaceCondition(e[0], e[1], e[2], e[3]),
  1387855156: (e) => new a.IfcBoundaryNodeCondition(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2069777674: (e) => new a.IfcBoundaryNodeConditionWarping(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2859738748: (e) => new a.IfcConnectionGeometry(),
  2614616156: (e) => new a.IfcConnectionPointGeometry(e[0], e[1]),
  2732653382: (e) => new a.IfcConnectionSurfaceGeometry(e[0], e[1]),
  775493141: (e) => new a.IfcConnectionVolumeGeometry(e[0], e[1]),
  1959218052: (e) => new a.IfcConstraint(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1785450214: (e) => new a.IfcCoordinateOperation(e[0], e[1]),
  1466758467: (e) => new a.IfcCoordinateReferenceSystem(e[0], e[1], e[2], e[3]),
  602808272: (e) => new a.IfcCostValue(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1765591967: (e) => new a.IfcDerivedUnit(e[0], e[1], e[2], e[3]),
  1045800335: (e) => new a.IfcDerivedUnitElement(e[0], e[1]),
  2949456006: (e) => new a.IfcDimensionalExponents(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  4294318154: (e) => new a.IfcExternalInformation(),
  3200245327: (e) => new a.IfcExternalReference(e[0], e[1], e[2]),
  2242383968: (e) => new a.IfcExternallyDefinedHatchStyle(e[0], e[1], e[2]),
  1040185647: (e) => new a.IfcExternallyDefinedSurfaceStyle(e[0], e[1], e[2]),
  3548104201: (e) => new a.IfcExternallyDefinedTextFont(e[0], e[1], e[2]),
  852622518: (e) => new a.IfcGridAxis(e[0], e[1], e[2]),
  3020489413: (e) => new a.IfcIrregularTimeSeriesValue(e[0], e[1]),
  2655187982: (e) => new a.IfcLibraryInformation(e[0], e[1], e[2], e[3], e[4], e[5]),
  3452421091: (e) => new a.IfcLibraryReference(e[0], e[1], e[2], e[3], e[4], e[5]),
  4162380809: (e) => new a.IfcLightDistributionData(e[0], e[1], e[2]),
  1566485204: (e) => new a.IfcLightIntensityDistribution(e[0], e[1]),
  3057273783: (e) => new a.IfcMapConversion(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1847130766: (e) => new a.IfcMaterialClassificationRelationship(e[0], e[1]),
  760658860: (e) => new a.IfcMaterialDefinition(),
  248100487: (e) => new a.IfcMaterialLayer(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3303938423: (e) => new a.IfcMaterialLayerSet(e[0], e[1], e[2]),
  1847252529: (e) => new a.IfcMaterialLayerWithOffsets(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2199411900: (e) => new a.IfcMaterialList(e[0]),
  2235152071: (e) => new a.IfcMaterialProfile(e[0], e[1], e[2], e[3], e[4], e[5]),
  164193824: (e) => new a.IfcMaterialProfileSet(e[0], e[1], e[2], e[3]),
  552965576: (e) => new a.IfcMaterialProfileWithOffsets(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1507914824: (e) => new a.IfcMaterialUsageDefinition(),
  2597039031: (e) => new a.IfcMeasureWithUnit(e[0], e[1]),
  3368373690: (e) => new a.IfcMetric(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  2706619895: (e) => new a.IfcMonetaryUnit(e[0]),
  1918398963: (e) => new a.IfcNamedUnit(e[0], e[1]),
  3701648758: (e) => new a.IfcObjectPlacement(e[0]),
  2251480897: (e) => new a.IfcObjective(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  4251960020: (e) => new a.IfcOrganization(e[0], e[1], e[2], e[3], e[4]),
  1207048766: (e) => new a.IfcOwnerHistory(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2077209135: (e) => new a.IfcPerson(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  101040310: (e) => new a.IfcPersonAndOrganization(e[0], e[1], e[2]),
  2483315170: (e) => new a.IfcPhysicalQuantity(e[0], e[1]),
  2226359599: (e) => new a.IfcPhysicalSimpleQuantity(e[0], e[1], e[2]),
  3355820592: (e) => new a.IfcPostalAddress(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  677532197: (e) => new a.IfcPresentationItem(),
  2022622350: (e) => new a.IfcPresentationLayerAssignment(e[0], e[1], e[2], e[3]),
  1304840413: (e) => new a.IfcPresentationLayerWithStyle(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3119450353: (e) => new a.IfcPresentationStyle(e[0]),
  2095639259: (e) => new a.IfcProductRepresentation(e[0], e[1], e[2]),
  3958567839: (e) => new a.IfcProfileDef(e[0], e[1]),
  3843373140: (e) => new a.IfcProjectedCRS(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  986844984: (e) => new a.IfcPropertyAbstraction(),
  3710013099: (e) => new a.IfcPropertyEnumeration(e[0], e[1], e[2]),
  2044713172: (e) => new a.IfcQuantityArea(e[0], e[1], e[2], e[3], e[4]),
  2093928680: (e) => new a.IfcQuantityCount(e[0], e[1], e[2], e[3], e[4]),
  931644368: (e) => new a.IfcQuantityLength(e[0], e[1], e[2], e[3], e[4]),
  2691318326: (e) => new a.IfcQuantityNumber(e[0], e[1], e[2], e[3], e[4]),
  3252649465: (e) => new a.IfcQuantityTime(e[0], e[1], e[2], e[3], e[4]),
  2405470396: (e) => new a.IfcQuantityVolume(e[0], e[1], e[2], e[3], e[4]),
  825690147: (e) => new a.IfcQuantityWeight(e[0], e[1], e[2], e[3], e[4]),
  3915482550: (e) => new a.IfcRecurrencePattern(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2433181523: (e) => new a.IfcReference(e[0], e[1], e[2], e[3], e[4]),
  1076942058: (e) => new a.IfcRepresentation(e[0], e[1], e[2], e[3]),
  3377609919: (e) => new a.IfcRepresentationContext(e[0], e[1]),
  3008791417: (e) => new a.IfcRepresentationItem(),
  1660063152: (e) => new a.IfcRepresentationMap(e[0], e[1]),
  2439245199: (e) => new a.IfcResourceLevelRelationship(e[0], e[1]),
  2341007311: (e) => new a.IfcRoot(e[0], e[1], e[2], e[3]),
  448429030: (e) => new a.IfcSIUnit(e[0], e[1], e[2]),
  1054537805: (e) => new a.IfcSchedulingTime(e[0], e[1], e[2]),
  867548509: (e) => new a.IfcShapeAspect(e[0], e[1], e[2], e[3], e[4]),
  3982875396: (e) => new a.IfcShapeModel(e[0], e[1], e[2], e[3]),
  4240577450: (e) => new a.IfcShapeRepresentation(e[0], e[1], e[2], e[3]),
  2273995522: (e) => new a.IfcStructuralConnectionCondition(e[0]),
  2162789131: (e) => new a.IfcStructuralLoad(e[0]),
  3478079324: (e) => new a.IfcStructuralLoadConfiguration(e[0], e[1], e[2]),
  609421318: (e) => new a.IfcStructuralLoadOrResult(e[0]),
  2525727697: (e) => new a.IfcStructuralLoadStatic(e[0]),
  3408363356: (e) => new a.IfcStructuralLoadTemperature(e[0], e[1], e[2], e[3]),
  2830218821: (e) => new a.IfcStyleModel(e[0], e[1], e[2], e[3]),
  3958052878: (e) => new a.IfcStyledItem(e[0], e[1], e[2]),
  3049322572: (e) => new a.IfcStyledRepresentation(e[0], e[1], e[2], e[3]),
  2934153892: (e) => new a.IfcSurfaceReinforcementArea(e[0], e[1], e[2], e[3]),
  1300840506: (e) => new a.IfcSurfaceStyle(e[0], e[1], e[2]),
  3303107099: (e) => new a.IfcSurfaceStyleLighting(e[0], e[1], e[2], e[3]),
  1607154358: (e) => new a.IfcSurfaceStyleRefraction(e[0], e[1]),
  846575682: (e) => new a.IfcSurfaceStyleShading(e[0], e[1]),
  1351298697: (e) => new a.IfcSurfaceStyleWithTextures(e[0]),
  626085974: (e) => new a.IfcSurfaceTexture(e[0], e[1], e[2], e[3], e[4]),
  985171141: (e) => new a.IfcTable(e[0], e[1], e[2]),
  2043862942: (e) => new a.IfcTableColumn(e[0], e[1], e[2], e[3], e[4]),
  531007025: (e) => new a.IfcTableRow(e[0], e[1]),
  1549132990: (e) => new a.IfcTaskTime(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], e[17], e[18], e[19]),
  2771591690: (e) => new a.IfcTaskTimeRecurring(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], e[17], e[18], e[19], e[20]),
  912023232: (e) => new a.IfcTelecomAddress(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1447204868: (e) => new a.IfcTextStyle(e[0], e[1], e[2], e[3], e[4]),
  2636378356: (e) => new a.IfcTextStyleForDefinedFont(e[0], e[1]),
  1640371178: (e) => new a.IfcTextStyleTextModel(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  280115917: (e) => new a.IfcTextureCoordinate(e[0]),
  1742049831: (e) => new a.IfcTextureCoordinateGenerator(e[0], e[1], e[2]),
  222769930: (e) => new a.IfcTextureCoordinateIndices(e[0], e[1]),
  1010789467: (e) => new a.IfcTextureCoordinateIndicesWithVoids(e[0], e[1], e[2]),
  2552916305: (e) => new a.IfcTextureMap(e[0], e[1], e[2]),
  1210645708: (e) => new a.IfcTextureVertex(e[0]),
  3611470254: (e) => new a.IfcTextureVertexList(e[0]),
  1199560280: (e) => new a.IfcTimePeriod(e[0], e[1]),
  3101149627: (e) => new a.IfcTimeSeries(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  581633288: (e) => new a.IfcTimeSeriesValue(e[0]),
  1377556343: (e) => new a.IfcTopologicalRepresentationItem(),
  1735638870: (e) => new a.IfcTopologyRepresentation(e[0], e[1], e[2], e[3]),
  180925521: (e) => new a.IfcUnitAssignment(e[0]),
  2799835756: (e) => new a.IfcVertex(),
  1907098498: (e) => new a.IfcVertexPoint(e[0]),
  891718957: (e) => new a.IfcVirtualGridIntersection(e[0], e[1]),
  1236880293: (e) => new a.IfcWorkTime(e[0], e[1], e[2], e[3], e[4], e[5]),
  3752311538: (e) => new a.IfcAlignmentCantSegment(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  536804194: (e) => new a.IfcAlignmentHorizontalSegment(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3869604511: (e) => new a.IfcApprovalRelationship(e[0], e[1], e[2], e[3]),
  3798115385: (e) => new a.IfcArbitraryClosedProfileDef(e[0], e[1], e[2]),
  1310608509: (e) => new a.IfcArbitraryOpenProfileDef(e[0], e[1], e[2]),
  2705031697: (e) => new a.IfcArbitraryProfileDefWithVoids(e[0], e[1], e[2], e[3]),
  616511568: (e) => new a.IfcBlobTexture(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3150382593: (e) => new a.IfcCenterLineProfileDef(e[0], e[1], e[2], e[3]),
  747523909: (e) => new a.IfcClassification(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  647927063: (e) => new a.IfcClassificationReference(e[0], e[1], e[2], e[3], e[4], e[5]),
  3285139300: (e) => new a.IfcColourRgbList(e[0]),
  3264961684: (e) => new a.IfcColourSpecification(e[0]),
  1485152156: (e) => new a.IfcCompositeProfileDef(e[0], e[1], e[2], e[3]),
  370225590: (e) => new a.IfcConnectedFaceSet(e[0]),
  1981873012: (e) => new a.IfcConnectionCurveGeometry(e[0], e[1]),
  45288368: (e) => new a.IfcConnectionPointEccentricity(e[0], e[1], e[2], e[3], e[4]),
  3050246964: (e) => new a.IfcContextDependentUnit(e[0], e[1], e[2]),
  2889183280: (e) => new a.IfcConversionBasedUnit(e[0], e[1], e[2], e[3]),
  2713554722: (e) => new a.IfcConversionBasedUnitWithOffset(e[0], e[1], e[2], e[3], e[4]),
  539742890: (e) => new a.IfcCurrencyRelationship(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3800577675: (e) => new a.IfcCurveStyle(e[0], e[1], e[2], e[3], e[4]),
  1105321065: (e) => new a.IfcCurveStyleFont(e[0], e[1]),
  2367409068: (e) => new a.IfcCurveStyleFontAndScaling(e[0], e[1], e[2]),
  3510044353: (e) => new a.IfcCurveStyleFontPattern(e[0], e[1]),
  3632507154: (e) => new a.IfcDerivedProfileDef(e[0], e[1], e[2], e[3], e[4]),
  1154170062: (e) => new a.IfcDocumentInformation(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16]),
  770865208: (e) => new a.IfcDocumentInformationRelationship(e[0], e[1], e[2], e[3], e[4]),
  3732053477: (e) => new a.IfcDocumentReference(e[0], e[1], e[2], e[3], e[4]),
  3900360178: (e) => new a.IfcEdge(e[0], e[1]),
  476780140: (e) => new a.IfcEdgeCurve(e[0], e[1], e[2], e[3]),
  211053100: (e) => new a.IfcEventTime(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  297599258: (e) => new a.IfcExtendedProperties(e[0], e[1], e[2]),
  1437805879: (e) => new a.IfcExternalReferenceRelationship(e[0], e[1], e[2], e[3]),
  2556980723: (e) => new a.IfcFace(e[0]),
  1809719519: (e) => new a.IfcFaceBound(e[0], e[1]),
  803316827: (e) => new a.IfcFaceOuterBound(e[0], e[1]),
  3008276851: (e) => new a.IfcFaceSurface(e[0], e[1], e[2]),
  4219587988: (e) => new a.IfcFailureConnectionCondition(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  738692330: (e) => new a.IfcFillAreaStyle(e[0], e[1], e[2]),
  3448662350: (e) => new a.IfcGeometricRepresentationContext(e[0], e[1], e[2], e[3], e[4], e[5]),
  2453401579: (e) => new a.IfcGeometricRepresentationItem(),
  4142052618: (e) => new a.IfcGeometricRepresentationSubContext(e[0], e[1], e[2], e[3], e[4], e[5]),
  3590301190: (e) => new a.IfcGeometricSet(e[0]),
  178086475: (e) => new a.IfcGridPlacement(e[0], e[1], e[2]),
  812098782: (e) => new a.IfcHalfSpaceSolid(e[0], e[1]),
  3905492369: (e) => new a.IfcImageTexture(e[0], e[1], e[2], e[3], e[4], e[5]),
  3570813810: (e) => new a.IfcIndexedColourMap(e[0], e[1], e[2], e[3]),
  1437953363: (e) => new a.IfcIndexedTextureMap(e[0], e[1], e[2]),
  2133299955: (e) => new a.IfcIndexedTriangleTextureMap(e[0], e[1], e[2], e[3]),
  3741457305: (e) => new a.IfcIrregularTimeSeries(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1585845231: (e) => new a.IfcLagTime(e[0], e[1], e[2], e[3], e[4]),
  1402838566: (e) => new a.IfcLightSource(e[0], e[1], e[2], e[3]),
  125510826: (e) => new a.IfcLightSourceAmbient(e[0], e[1], e[2], e[3]),
  2604431987: (e) => new a.IfcLightSourceDirectional(e[0], e[1], e[2], e[3], e[4]),
  4266656042: (e) => new a.IfcLightSourceGoniometric(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1520743889: (e) => new a.IfcLightSourcePositional(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3422422726: (e) => new a.IfcLightSourceSpot(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  388784114: (e) => new a.IfcLinearPlacement(e[0], e[1], e[2]),
  2624227202: (e) => new a.IfcLocalPlacement(e[0], e[1]),
  1008929658: (e) => new a.IfcLoop(),
  2347385850: (e) => new a.IfcMappedItem(e[0], e[1]),
  1838606355: (e) => new a.IfcMaterial(e[0], e[1], e[2]),
  3708119e3: (e) => new a.IfcMaterialConstituent(e[0], e[1], e[2], e[3], e[4]),
  2852063980: (e) => new a.IfcMaterialConstituentSet(e[0], e[1], e[2]),
  2022407955: (e) => new a.IfcMaterialDefinitionRepresentation(e[0], e[1], e[2], e[3]),
  1303795690: (e) => new a.IfcMaterialLayerSetUsage(e[0], e[1], e[2], e[3], e[4]),
  3079605661: (e) => new a.IfcMaterialProfileSetUsage(e[0], e[1], e[2]),
  3404854881: (e) => new a.IfcMaterialProfileSetUsageTapering(e[0], e[1], e[2], e[3], e[4]),
  3265635763: (e) => new a.IfcMaterialProperties(e[0], e[1], e[2], e[3]),
  853536259: (e) => new a.IfcMaterialRelationship(e[0], e[1], e[2], e[3], e[4]),
  2998442950: (e) => new a.IfcMirroredProfileDef(e[0], e[1], e[2], e[3]),
  219451334: (e) => new a.IfcObjectDefinition(e[0], e[1], e[2], e[3]),
  182550632: (e) => new a.IfcOpenCrossProfileDef(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2665983363: (e) => new a.IfcOpenShell(e[0]),
  1411181986: (e) => new a.IfcOrganizationRelationship(e[0], e[1], e[2], e[3]),
  1029017970: (e) => new a.IfcOrientedEdge(e[0], e[1]),
  2529465313: (e) => new a.IfcParameterizedProfileDef(e[0], e[1], e[2]),
  2519244187: (e) => new a.IfcPath(e[0]),
  3021840470: (e) => new a.IfcPhysicalComplexQuantity(e[0], e[1], e[2], e[3], e[4], e[5]),
  597895409: (e) => new a.IfcPixelTexture(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2004835150: (e) => new a.IfcPlacement(e[0]),
  1663979128: (e) => new a.IfcPlanarExtent(e[0], e[1]),
  2067069095: (e) => new a.IfcPoint(),
  2165702409: (e) => new a.IfcPointByDistanceExpression(e[0], e[1], e[2], e[3], e[4]),
  4022376103: (e) => new a.IfcPointOnCurve(e[0], e[1]),
  1423911732: (e) => new a.IfcPointOnSurface(e[0], e[1], e[2]),
  2924175390: (e) => new a.IfcPolyLoop(e[0]),
  2775532180: (e) => new a.IfcPolygonalBoundedHalfSpace(e[0], e[1], e[2], e[3]),
  3727388367: (e) => new a.IfcPreDefinedItem(e[0]),
  3778827333: (e) => new a.IfcPreDefinedProperties(),
  1775413392: (e) => new a.IfcPreDefinedTextFont(e[0]),
  673634403: (e) => new a.IfcProductDefinitionShape(e[0], e[1], e[2]),
  2802850158: (e) => new a.IfcProfileProperties(e[0], e[1], e[2], e[3]),
  2598011224: (e) => new a.IfcProperty(e[0], e[1]),
  1680319473: (e) => new a.IfcPropertyDefinition(e[0], e[1], e[2], e[3]),
  148025276: (e) => new a.IfcPropertyDependencyRelationship(e[0], e[1], e[2], e[3], e[4]),
  3357820518: (e) => new a.IfcPropertySetDefinition(e[0], e[1], e[2], e[3]),
  1482703590: (e) => new a.IfcPropertyTemplateDefinition(e[0], e[1], e[2], e[3]),
  2090586900: (e) => new a.IfcQuantitySet(e[0], e[1], e[2], e[3]),
  3615266464: (e) => new a.IfcRectangleProfileDef(e[0], e[1], e[2], e[3], e[4]),
  3413951693: (e) => new a.IfcRegularTimeSeries(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1580146022: (e) => new a.IfcReinforcementBarProperties(e[0], e[1], e[2], e[3], e[4], e[5]),
  478536968: (e) => new a.IfcRelationship(e[0], e[1], e[2], e[3]),
  2943643501: (e) => new a.IfcResourceApprovalRelationship(e[0], e[1], e[2], e[3]),
  1608871552: (e) => new a.IfcResourceConstraintRelationship(e[0], e[1], e[2], e[3]),
  1042787934: (e) => new a.IfcResourceTime(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], e[17]),
  2778083089: (e) => new a.IfcRoundedRectangleProfileDef(e[0], e[1], e[2], e[3], e[4], e[5]),
  2042790032: (e) => new a.IfcSectionProperties(e[0], e[1], e[2]),
  4165799628: (e) => new a.IfcSectionReinforcementProperties(e[0], e[1], e[2], e[3], e[4], e[5]),
  1509187699: (e) => new a.IfcSectionedSpine(e[0], e[1], e[2]),
  823603102: (e) => new a.IfcSegment(e[0]),
  4124623270: (e) => new a.IfcShellBasedSurfaceModel(e[0]),
  3692461612: (e) => new a.IfcSimpleProperty(e[0], e[1]),
  2609359061: (e) => new a.IfcSlippageConnectionCondition(e[0], e[1], e[2], e[3]),
  723233188: (e) => new a.IfcSolidModel(),
  1595516126: (e) => new a.IfcStructuralLoadLinearForce(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2668620305: (e) => new a.IfcStructuralLoadPlanarForce(e[0], e[1], e[2], e[3]),
  2473145415: (e) => new a.IfcStructuralLoadSingleDisplacement(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1973038258: (e) => new a.IfcStructuralLoadSingleDisplacementDistortion(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1597423693: (e) => new a.IfcStructuralLoadSingleForce(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1190533807: (e) => new a.IfcStructuralLoadSingleForceWarping(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2233826070: (e) => new a.IfcSubedge(e[0], e[1], e[2]),
  2513912981: (e) => new a.IfcSurface(),
  1878645084: (e) => new a.IfcSurfaceStyleRendering(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2247615214: (e) => new a.IfcSweptAreaSolid(e[0], e[1]),
  1260650574: (e) => new a.IfcSweptDiskSolid(e[0], e[1], e[2], e[3], e[4]),
  1096409881: (e) => new a.IfcSweptDiskSolidPolygonal(e[0], e[1], e[2], e[3], e[4], e[5]),
  230924584: (e) => new a.IfcSweptSurface(e[0], e[1]),
  3071757647: (e) => new a.IfcTShapeProfileDef(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  901063453: (e) => new a.IfcTessellatedItem(),
  4282788508: (e) => new a.IfcTextLiteral(e[0], e[1], e[2]),
  3124975700: (e) => new a.IfcTextLiteralWithExtent(e[0], e[1], e[2], e[3], e[4]),
  1983826977: (e) => new a.IfcTextStyleFontModel(e[0], e[1], e[2], e[3], e[4], e[5]),
  2715220739: (e) => new a.IfcTrapeziumProfileDef(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1628702193: (e) => new a.IfcTypeObject(e[0], e[1], e[2], e[3], e[4], e[5]),
  3736923433: (e) => new a.IfcTypeProcess(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2347495698: (e) => new a.IfcTypeProduct(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3698973494: (e) => new a.IfcTypeResource(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  427810014: (e) => new a.IfcUShapeProfileDef(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1417489154: (e) => new a.IfcVector(e[0], e[1]),
  2759199220: (e) => new a.IfcVertexLoop(e[0]),
  2543172580: (e) => new a.IfcZShapeProfileDef(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3406155212: (e) => new a.IfcAdvancedFace(e[0], e[1], e[2]),
  669184980: (e) => new a.IfcAnnotationFillArea(e[0], e[1]),
  3207858831: (e) => new a.IfcAsymmetricIShapeProfileDef(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14]),
  4261334040: (e) => new a.IfcAxis1Placement(e[0], e[1]),
  3125803723: (e) => new a.IfcAxis2Placement2D(e[0], e[1]),
  2740243338: (e) => new a.IfcAxis2Placement3D(e[0], e[1], e[2]),
  3425423356: (e) => new a.IfcAxis2PlacementLinear(e[0], e[1], e[2]),
  2736907675: (e) => new a.IfcBooleanResult(e[0], e[1], e[2]),
  4182860854: (e) => new a.IfcBoundedSurface(),
  2581212453: (e) => new a.IfcBoundingBox(e[0], e[1], e[2], e[3]),
  2713105998: (e) => new a.IfcBoxedHalfSpace(e[0], e[1], e[2]),
  2898889636: (e) => new a.IfcCShapeProfileDef(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1123145078: (e) => new a.IfcCartesianPoint(e[0]),
  574549367: (e) => new a.IfcCartesianPointList(),
  1675464909: (e) => new a.IfcCartesianPointList2D(e[0], e[1]),
  2059837836: (e) => new a.IfcCartesianPointList3D(e[0], e[1]),
  59481748: (e) => new a.IfcCartesianTransformationOperator(e[0], e[1], e[2], e[3]),
  3749851601: (e) => new a.IfcCartesianTransformationOperator2D(e[0], e[1], e[2], e[3]),
  3486308946: (e) => new a.IfcCartesianTransformationOperator2DnonUniform(e[0], e[1], e[2], e[3], e[4]),
  3331915920: (e) => new a.IfcCartesianTransformationOperator3D(e[0], e[1], e[2], e[3], e[4]),
  1416205885: (e) => new a.IfcCartesianTransformationOperator3DnonUniform(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1383045692: (e) => new a.IfcCircleProfileDef(e[0], e[1], e[2], e[3]),
  2205249479: (e) => new a.IfcClosedShell(e[0]),
  776857604: (e) => new a.IfcColourRgb(e[0], e[1], e[2], e[3]),
  2542286263: (e) => new a.IfcComplexProperty(e[0], e[1], e[2], e[3]),
  2485617015: (e) => new a.IfcCompositeCurveSegment(e[0], e[1], e[2]),
  2574617495: (e) => new a.IfcConstructionResourceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  3419103109: (e) => new a.IfcContext(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1815067380: (e) => new a.IfcCrewResourceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  2506170314: (e) => new a.IfcCsgPrimitive3D(e[0]),
  2147822146: (e) => new a.IfcCsgSolid(e[0]),
  2601014836: (e) => new a.IfcCurve(),
  2827736869: (e) => new a.IfcCurveBoundedPlane(e[0], e[1], e[2]),
  2629017746: (e) => new a.IfcCurveBoundedSurface(e[0], e[1], e[2]),
  4212018352: (e) => new a.IfcCurveSegment(e[0], e[1], e[2], e[3], e[4]),
  32440307: (e) => new a.IfcDirection(e[0]),
  593015953: (e) => new a.IfcDirectrixCurveSweptAreaSolid(e[0], e[1], e[2], e[3], e[4]),
  1472233963: (e) => new a.IfcEdgeLoop(e[0]),
  1883228015: (e) => new a.IfcElementQuantity(e[0], e[1], e[2], e[3], e[4], e[5]),
  339256511: (e) => new a.IfcElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2777663545: (e) => new a.IfcElementarySurface(e[0]),
  2835456948: (e) => new a.IfcEllipseProfileDef(e[0], e[1], e[2], e[3], e[4]),
  4024345920: (e) => new a.IfcEventType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  477187591: (e) => new a.IfcExtrudedAreaSolid(e[0], e[1], e[2], e[3]),
  2804161546: (e) => new a.IfcExtrudedAreaSolidTapered(e[0], e[1], e[2], e[3], e[4]),
  2047409740: (e) => new a.IfcFaceBasedSurfaceModel(e[0]),
  374418227: (e) => new a.IfcFillAreaStyleHatching(e[0], e[1], e[2], e[3], e[4]),
  315944413: (e) => new a.IfcFillAreaStyleTiles(e[0], e[1], e[2]),
  2652556860: (e) => new a.IfcFixedReferenceSweptAreaSolid(e[0], e[1], e[2], e[3], e[4], e[5]),
  4238390223: (e) => new a.IfcFurnishingElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1268542332: (e) => new a.IfcFurnitureType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  4095422895: (e) => new a.IfcGeographicElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  987898635: (e) => new a.IfcGeometricCurveSet(e[0]),
  1484403080: (e) => new a.IfcIShapeProfileDef(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  178912537: (e) => new a.IfcIndexedPolygonalFace(e[0]),
  2294589976: (e) => new a.IfcIndexedPolygonalFaceWithVoids(e[0], e[1]),
  3465909080: (e) => new a.IfcIndexedPolygonalTextureMap(e[0], e[1], e[2], e[3]),
  572779678: (e) => new a.IfcLShapeProfileDef(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  428585644: (e) => new a.IfcLaborResourceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1281925730: (e) => new a.IfcLine(e[0], e[1]),
  1425443689: (e) => new a.IfcManifoldSolidBrep(e[0]),
  3888040117: (e) => new a.IfcObject(e[0], e[1], e[2], e[3], e[4]),
  590820931: (e) => new a.IfcOffsetCurve(e[0]),
  3388369263: (e) => new a.IfcOffsetCurve2D(e[0], e[1], e[2]),
  3505215534: (e) => new a.IfcOffsetCurve3D(e[0], e[1], e[2], e[3]),
  2485787929: (e) => new a.IfcOffsetCurveByDistances(e[0], e[1], e[2]),
  1682466193: (e) => new a.IfcPcurve(e[0], e[1]),
  603570806: (e) => new a.IfcPlanarBox(e[0], e[1], e[2]),
  220341763: (e) => new a.IfcPlane(e[0]),
  3381221214: (e) => new a.IfcPolynomialCurve(e[0], e[1], e[2], e[3]),
  759155922: (e) => new a.IfcPreDefinedColour(e[0]),
  2559016684: (e) => new a.IfcPreDefinedCurveFont(e[0]),
  3967405729: (e) => new a.IfcPreDefinedPropertySet(e[0], e[1], e[2], e[3]),
  569719735: (e) => new a.IfcProcedureType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2945172077: (e) => new a.IfcProcess(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  4208778838: (e) => new a.IfcProduct(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  103090709: (e) => new a.IfcProject(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  653396225: (e) => new a.IfcProjectLibrary(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  871118103: (e) => new a.IfcPropertyBoundedValue(e[0], e[1], e[2], e[3], e[4], e[5]),
  4166981789: (e) => new a.IfcPropertyEnumeratedValue(e[0], e[1], e[2], e[3]),
  2752243245: (e) => new a.IfcPropertyListValue(e[0], e[1], e[2], e[3]),
  941946838: (e) => new a.IfcPropertyReferenceValue(e[0], e[1], e[2], e[3]),
  1451395588: (e) => new a.IfcPropertySet(e[0], e[1], e[2], e[3], e[4]),
  492091185: (e) => new a.IfcPropertySetTemplate(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3650150729: (e) => new a.IfcPropertySingleValue(e[0], e[1], e[2], e[3]),
  110355661: (e) => new a.IfcPropertyTableValue(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3521284610: (e) => new a.IfcPropertyTemplate(e[0], e[1], e[2], e[3]),
  2770003689: (e) => new a.IfcRectangleHollowProfileDef(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2798486643: (e) => new a.IfcRectangularPyramid(e[0], e[1], e[2], e[3]),
  3454111270: (e) => new a.IfcRectangularTrimmedSurface(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3765753017: (e) => new a.IfcReinforcementDefinitionProperties(e[0], e[1], e[2], e[3], e[4], e[5]),
  3939117080: (e) => new a.IfcRelAssigns(e[0], e[1], e[2], e[3], e[4], e[5]),
  1683148259: (e) => new a.IfcRelAssignsToActor(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2495723537: (e) => new a.IfcRelAssignsToControl(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1307041759: (e) => new a.IfcRelAssignsToGroup(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1027710054: (e) => new a.IfcRelAssignsToGroupByFactor(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  4278684876: (e) => new a.IfcRelAssignsToProcess(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2857406711: (e) => new a.IfcRelAssignsToProduct(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  205026976: (e) => new a.IfcRelAssignsToResource(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1865459582: (e) => new a.IfcRelAssociates(e[0], e[1], e[2], e[3], e[4]),
  4095574036: (e) => new a.IfcRelAssociatesApproval(e[0], e[1], e[2], e[3], e[4], e[5]),
  919958153: (e) => new a.IfcRelAssociatesClassification(e[0], e[1], e[2], e[3], e[4], e[5]),
  2728634034: (e) => new a.IfcRelAssociatesConstraint(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  982818633: (e) => new a.IfcRelAssociatesDocument(e[0], e[1], e[2], e[3], e[4], e[5]),
  3840914261: (e) => new a.IfcRelAssociatesLibrary(e[0], e[1], e[2], e[3], e[4], e[5]),
  2655215786: (e) => new a.IfcRelAssociatesMaterial(e[0], e[1], e[2], e[3], e[4], e[5]),
  1033248425: (e) => new a.IfcRelAssociatesProfileDef(e[0], e[1], e[2], e[3], e[4], e[5]),
  826625072: (e) => new a.IfcRelConnects(e[0], e[1], e[2], e[3]),
  1204542856: (e) => new a.IfcRelConnectsElements(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3945020480: (e) => new a.IfcRelConnectsPathElements(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  4201705270: (e) => new a.IfcRelConnectsPortToElement(e[0], e[1], e[2], e[3], e[4], e[5]),
  3190031847: (e) => new a.IfcRelConnectsPorts(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2127690289: (e) => new a.IfcRelConnectsStructuralActivity(e[0], e[1], e[2], e[3], e[4], e[5]),
  1638771189: (e) => new a.IfcRelConnectsStructuralMember(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  504942748: (e) => new a.IfcRelConnectsWithEccentricity(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  3678494232: (e) => new a.IfcRelConnectsWithRealizingElements(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3242617779: (e) => new a.IfcRelContainedInSpatialStructure(e[0], e[1], e[2], e[3], e[4], e[5]),
  886880790: (e) => new a.IfcRelCoversBldgElements(e[0], e[1], e[2], e[3], e[4], e[5]),
  2802773753: (e) => new a.IfcRelCoversSpaces(e[0], e[1], e[2], e[3], e[4], e[5]),
  2565941209: (e) => new a.IfcRelDeclares(e[0], e[1], e[2], e[3], e[4], e[5]),
  2551354335: (e) => new a.IfcRelDecomposes(e[0], e[1], e[2], e[3]),
  693640335: (e) => new a.IfcRelDefines(e[0], e[1], e[2], e[3]),
  1462361463: (e) => new a.IfcRelDefinesByObject(e[0], e[1], e[2], e[3], e[4], e[5]),
  4186316022: (e) => new a.IfcRelDefinesByProperties(e[0], e[1], e[2], e[3], e[4], e[5]),
  307848117: (e) => new a.IfcRelDefinesByTemplate(e[0], e[1], e[2], e[3], e[4], e[5]),
  781010003: (e) => new a.IfcRelDefinesByType(e[0], e[1], e[2], e[3], e[4], e[5]),
  3940055652: (e) => new a.IfcRelFillsElement(e[0], e[1], e[2], e[3], e[4], e[5]),
  279856033: (e) => new a.IfcRelFlowControlElements(e[0], e[1], e[2], e[3], e[4], e[5]),
  427948657: (e) => new a.IfcRelInterferesElements(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3268803585: (e) => new a.IfcRelNests(e[0], e[1], e[2], e[3], e[4], e[5]),
  1441486842: (e) => new a.IfcRelPositions(e[0], e[1], e[2], e[3], e[4], e[5]),
  750771296: (e) => new a.IfcRelProjectsElement(e[0], e[1], e[2], e[3], e[4], e[5]),
  1245217292: (e) => new a.IfcRelReferencedInSpatialStructure(e[0], e[1], e[2], e[3], e[4], e[5]),
  4122056220: (e) => new a.IfcRelSequence(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  366585022: (e) => new a.IfcRelServicesBuildings(e[0], e[1], e[2], e[3], e[4], e[5]),
  3451746338: (e) => new a.IfcRelSpaceBoundary(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3523091289: (e) => new a.IfcRelSpaceBoundary1stLevel(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1521410863: (e) => new a.IfcRelSpaceBoundary2ndLevel(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1401173127: (e) => new a.IfcRelVoidsElement(e[0], e[1], e[2], e[3], e[4], e[5]),
  816062949: (e) => new a.IfcReparametrisedCompositeCurveSegment(e[0], e[1], e[2], e[3]),
  2914609552: (e) => new a.IfcResource(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1856042241: (e) => new a.IfcRevolvedAreaSolid(e[0], e[1], e[2], e[3]),
  3243963512: (e) => new a.IfcRevolvedAreaSolidTapered(e[0], e[1], e[2], e[3], e[4]),
  4158566097: (e) => new a.IfcRightCircularCone(e[0], e[1], e[2]),
  3626867408: (e) => new a.IfcRightCircularCylinder(e[0], e[1], e[2]),
  1862484736: (e) => new a.IfcSectionedSolid(e[0], e[1]),
  1290935644: (e) => new a.IfcSectionedSolidHorizontal(e[0], e[1], e[2]),
  1356537516: (e) => new a.IfcSectionedSurface(e[0], e[1], e[2]),
  3663146110: (e) => new a.IfcSimplePropertyTemplate(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1412071761: (e) => new a.IfcSpatialElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  710998568: (e) => new a.IfcSpatialElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2706606064: (e) => new a.IfcSpatialStructureElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3893378262: (e) => new a.IfcSpatialStructureElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  463610769: (e) => new a.IfcSpatialZone(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2481509218: (e) => new a.IfcSpatialZoneType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  451544542: (e) => new a.IfcSphere(e[0], e[1]),
  4015995234: (e) => new a.IfcSphericalSurface(e[0], e[1]),
  2735484536: (e) => new a.IfcSpiral(e[0]),
  3544373492: (e) => new a.IfcStructuralActivity(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3136571912: (e) => new a.IfcStructuralItem(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  530289379: (e) => new a.IfcStructuralMember(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3689010777: (e) => new a.IfcStructuralReaction(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3979015343: (e) => new a.IfcStructuralSurfaceMember(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2218152070: (e) => new a.IfcStructuralSurfaceMemberVarying(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  603775116: (e) => new a.IfcStructuralSurfaceReaction(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4095615324: (e) => new a.IfcSubContractResourceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  699246055: (e) => new a.IfcSurfaceCurve(e[0], e[1], e[2]),
  2028607225: (e) => new a.IfcSurfaceCurveSweptAreaSolid(e[0], e[1], e[2], e[3], e[4], e[5]),
  2809605785: (e) => new a.IfcSurfaceOfLinearExtrusion(e[0], e[1], e[2], e[3]),
  4124788165: (e) => new a.IfcSurfaceOfRevolution(e[0], e[1], e[2]),
  1580310250: (e) => new a.IfcSystemFurnitureElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3473067441: (e) => new a.IfcTask(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  3206491090: (e) => new a.IfcTaskType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  2387106220: (e) => new a.IfcTessellatedFaceSet(e[0], e[1]),
  782932809: (e) => new a.IfcThirdOrderPolynomialSpiral(e[0], e[1], e[2], e[3], e[4]),
  1935646853: (e) => new a.IfcToroidalSurface(e[0], e[1], e[2]),
  3665877780: (e) => new a.IfcTransportationDeviceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2916149573: (e) => new a.IfcTriangulatedFaceSet(e[0], e[1], e[2], e[3], e[4]),
  1229763772: (e) => new a.IfcTriangulatedIrregularNetwork(e[0], e[1], e[2], e[3], e[4], e[5]),
  3651464721: (e) => new a.IfcVehicleType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  336235671: (e) => new a.IfcWindowLiningProperties(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15]),
  512836454: (e) => new a.IfcWindowPanelProperties(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2296667514: (e) => new a.IfcActor(e[0], e[1], e[2], e[3], e[4], e[5]),
  1635779807: (e) => new a.IfcAdvancedBrep(e[0]),
  2603310189: (e) => new a.IfcAdvancedBrepWithVoids(e[0], e[1]),
  1674181508: (e) => new a.IfcAnnotation(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2887950389: (e) => new a.IfcBSplineSurface(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  167062518: (e) => new a.IfcBSplineSurfaceWithKnots(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1334484129: (e) => new a.IfcBlock(e[0], e[1], e[2], e[3]),
  3649129432: (e) => new a.IfcBooleanClippingResult(e[0], e[1], e[2]),
  1260505505: (e) => new a.IfcBoundedCurve(),
  3124254112: (e) => new a.IfcBuildingStorey(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1626504194: (e) => new a.IfcBuiltElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2197970202: (e) => new a.IfcChimneyType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2937912522: (e) => new a.IfcCircleHollowProfileDef(e[0], e[1], e[2], e[3], e[4]),
  3893394355: (e) => new a.IfcCivilElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3497074424: (e) => new a.IfcClothoid(e[0], e[1]),
  300633059: (e) => new a.IfcColumnType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3875453745: (e) => new a.IfcComplexPropertyTemplate(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3732776249: (e) => new a.IfcCompositeCurve(e[0], e[1]),
  15328376: (e) => new a.IfcCompositeCurveOnSurface(e[0], e[1]),
  2510884976: (e) => new a.IfcConic(e[0]),
  2185764099: (e) => new a.IfcConstructionEquipmentResourceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  4105962743: (e) => new a.IfcConstructionMaterialResourceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1525564444: (e) => new a.IfcConstructionProductResourceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  2559216714: (e) => new a.IfcConstructionResource(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3293443760: (e) => new a.IfcControl(e[0], e[1], e[2], e[3], e[4], e[5]),
  2000195564: (e) => new a.IfcCosineSpiral(e[0], e[1], e[2]),
  3895139033: (e) => new a.IfcCostItem(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1419761937: (e) => new a.IfcCostSchedule(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4189326743: (e) => new a.IfcCourseType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1916426348: (e) => new a.IfcCoveringType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3295246426: (e) => new a.IfcCrewResource(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1457835157: (e) => new a.IfcCurtainWallType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1213902940: (e) => new a.IfcCylindricalSurface(e[0], e[1]),
  1306400036: (e) => new a.IfcDeepFoundationType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4234616927: (e) => new a.IfcDirectrixDerivedReferenceSweptAreaSolid(e[0], e[1], e[2], e[3], e[4], e[5]),
  3256556792: (e) => new a.IfcDistributionElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3849074793: (e) => new a.IfcDistributionFlowElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2963535650: (e) => new a.IfcDoorLiningProperties(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16]),
  1714330368: (e) => new a.IfcDoorPanelProperties(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2323601079: (e) => new a.IfcDoorType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  445594917: (e) => new a.IfcDraughtingPreDefinedColour(e[0]),
  4006246654: (e) => new a.IfcDraughtingPreDefinedCurveFont(e[0]),
  1758889154: (e) => new a.IfcElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  4123344466: (e) => new a.IfcElementAssembly(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2397081782: (e) => new a.IfcElementAssemblyType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1623761950: (e) => new a.IfcElementComponent(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2590856083: (e) => new a.IfcElementComponentType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1704287377: (e) => new a.IfcEllipse(e[0], e[1], e[2]),
  2107101300: (e) => new a.IfcEnergyConversionDeviceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  132023988: (e) => new a.IfcEngineType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3174744832: (e) => new a.IfcEvaporativeCoolerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3390157468: (e) => new a.IfcEvaporatorType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4148101412: (e) => new a.IfcEvent(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  2853485674: (e) => new a.IfcExternalSpatialStructureElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  807026263: (e) => new a.IfcFacetedBrep(e[0]),
  3737207727: (e) => new a.IfcFacetedBrepWithVoids(e[0], e[1]),
  24185140: (e) => new a.IfcFacility(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1310830890: (e) => new a.IfcFacilityPart(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4228831410: (e) => new a.IfcFacilityPartCommon(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  647756555: (e) => new a.IfcFastener(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2489546625: (e) => new a.IfcFastenerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2827207264: (e) => new a.IfcFeatureElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2143335405: (e) => new a.IfcFeatureElementAddition(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1287392070: (e) => new a.IfcFeatureElementSubtraction(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3907093117: (e) => new a.IfcFlowControllerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3198132628: (e) => new a.IfcFlowFittingType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3815607619: (e) => new a.IfcFlowMeterType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1482959167: (e) => new a.IfcFlowMovingDeviceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1834744321: (e) => new a.IfcFlowSegmentType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1339347760: (e) => new a.IfcFlowStorageDeviceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2297155007: (e) => new a.IfcFlowTerminalType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3009222698: (e) => new a.IfcFlowTreatmentDeviceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1893162501: (e) => new a.IfcFootingType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  263784265: (e) => new a.IfcFurnishingElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1509553395: (e) => new a.IfcFurniture(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3493046030: (e) => new a.IfcGeographicElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4230923436: (e) => new a.IfcGeotechnicalElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1594536857: (e) => new a.IfcGeotechnicalStratum(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2898700619: (e) => new a.IfcGradientCurve(e[0], e[1], e[2], e[3]),
  2706460486: (e) => new a.IfcGroup(e[0], e[1], e[2], e[3], e[4]),
  1251058090: (e) => new a.IfcHeatExchangerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1806887404: (e) => new a.IfcHumidifierType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2568555532: (e) => new a.IfcImpactProtectionDevice(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3948183225: (e) => new a.IfcImpactProtectionDeviceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2571569899: (e) => new a.IfcIndexedPolyCurve(e[0], e[1], e[2]),
  3946677679: (e) => new a.IfcInterceptorType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3113134337: (e) => new a.IfcIntersectionCurve(e[0], e[1], e[2]),
  2391368822: (e) => new a.IfcInventory(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  4288270099: (e) => new a.IfcJunctionBoxType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  679976338: (e) => new a.IfcKerbType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3827777499: (e) => new a.IfcLaborResource(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1051575348: (e) => new a.IfcLampType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1161773419: (e) => new a.IfcLightFixtureType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2176059722: (e) => new a.IfcLinearElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1770583370: (e) => new a.IfcLiquidTerminalType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  525669439: (e) => new a.IfcMarineFacility(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  976884017: (e) => new a.IfcMarinePart(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  377706215: (e) => new a.IfcMechanicalFastener(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  2108223431: (e) => new a.IfcMechanicalFastenerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1114901282: (e) => new a.IfcMedicalDeviceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3181161470: (e) => new a.IfcMemberType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1950438474: (e) => new a.IfcMobileTelecommunicationsApplianceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  710110818: (e) => new a.IfcMooringDeviceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  977012517: (e) => new a.IfcMotorConnectionType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  506776471: (e) => new a.IfcNavigationElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4143007308: (e) => new a.IfcOccupant(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3588315303: (e) => new a.IfcOpeningElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2837617999: (e) => new a.IfcOutletType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  514975943: (e) => new a.IfcPavementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2382730787: (e) => new a.IfcPerformanceHistory(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3566463478: (e) => new a.IfcPermeableCoveringProperties(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3327091369: (e) => new a.IfcPermit(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1158309216: (e) => new a.IfcPileType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  804291784: (e) => new a.IfcPipeFittingType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4231323485: (e) => new a.IfcPipeSegmentType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4017108033: (e) => new a.IfcPlateType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2839578677: (e) => new a.IfcPolygonalFaceSet(e[0], e[1], e[2], e[3]),
  3724593414: (e) => new a.IfcPolyline(e[0]),
  3740093272: (e) => new a.IfcPort(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1946335990: (e) => new a.IfcPositioningElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2744685151: (e) => new a.IfcProcedure(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2904328755: (e) => new a.IfcProjectOrder(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3651124850: (e) => new a.IfcProjectionElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1842657554: (e) => new a.IfcProtectiveDeviceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2250791053: (e) => new a.IfcPumpType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1763565496: (e) => new a.IfcRailType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2893384427: (e) => new a.IfcRailingType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3992365140: (e) => new a.IfcRailway(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1891881377: (e) => new a.IfcRailwayPart(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  2324767716: (e) => new a.IfcRampFlightType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1469900589: (e) => new a.IfcRampType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  683857671: (e) => new a.IfcRationalBSplineSurfaceWithKnots(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  4021432810: (e) => new a.IfcReferent(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3027567501: (e) => new a.IfcReinforcingElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  964333572: (e) => new a.IfcReinforcingElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2320036040: (e) => new a.IfcReinforcingMesh(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], e[17]),
  2310774935: (e) => new a.IfcReinforcingMeshType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], e[17], e[18], e[19]),
  3818125796: (e) => new a.IfcRelAdheresToElement(e[0], e[1], e[2], e[3], e[4], e[5]),
  160246688: (e) => new a.IfcRelAggregates(e[0], e[1], e[2], e[3], e[4], e[5]),
  146592293: (e) => new a.IfcRoad(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  550521510: (e) => new a.IfcRoadPart(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  2781568857: (e) => new a.IfcRoofType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1768891740: (e) => new a.IfcSanitaryTerminalType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2157484638: (e) => new a.IfcSeamCurve(e[0], e[1], e[2]),
  3649235739: (e) => new a.IfcSecondOrderPolynomialSpiral(e[0], e[1], e[2], e[3]),
  544395925: (e) => new a.IfcSegmentedReferenceCurve(e[0], e[1], e[2], e[3]),
  1027922057: (e) => new a.IfcSeventhOrderPolynomialSpiral(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4074543187: (e) => new a.IfcShadingDeviceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  33720170: (e) => new a.IfcSign(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3599934289: (e) => new a.IfcSignType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1894708472: (e) => new a.IfcSignalType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  42703149: (e) => new a.IfcSineSpiral(e[0], e[1], e[2], e[3]),
  4097777520: (e) => new a.IfcSite(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13]),
  2533589738: (e) => new a.IfcSlabType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1072016465: (e) => new a.IfcSolarDeviceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3856911033: (e) => new a.IfcSpace(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1305183839: (e) => new a.IfcSpaceHeaterType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3812236995: (e) => new a.IfcSpaceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  3112655638: (e) => new a.IfcStackTerminalType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1039846685: (e) => new a.IfcStairFlightType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  338393293: (e) => new a.IfcStairType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  682877961: (e) => new a.IfcStructuralAction(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1179482911: (e) => new a.IfcStructuralConnection(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1004757350: (e) => new a.IfcStructuralCurveAction(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  4243806635: (e) => new a.IfcStructuralCurveConnection(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  214636428: (e) => new a.IfcStructuralCurveMember(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2445595289: (e) => new a.IfcStructuralCurveMemberVarying(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2757150158: (e) => new a.IfcStructuralCurveReaction(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1807405624: (e) => new a.IfcStructuralLinearAction(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1252848954: (e) => new a.IfcStructuralLoadGroup(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2082059205: (e) => new a.IfcStructuralPointAction(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  734778138: (e) => new a.IfcStructuralPointConnection(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1235345126: (e) => new a.IfcStructuralPointReaction(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2986769608: (e) => new a.IfcStructuralResultGroup(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3657597509: (e) => new a.IfcStructuralSurfaceAction(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1975003073: (e) => new a.IfcStructuralSurfaceConnection(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  148013059: (e) => new a.IfcSubContractResource(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  3101698114: (e) => new a.IfcSurfaceFeature(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2315554128: (e) => new a.IfcSwitchingDeviceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2254336722: (e) => new a.IfcSystem(e[0], e[1], e[2], e[3], e[4]),
  413509423: (e) => new a.IfcSystemFurnitureElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  5716631: (e) => new a.IfcTankType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3824725483: (e) => new a.IfcTendon(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16]),
  2347447852: (e) => new a.IfcTendonAnchor(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3081323446: (e) => new a.IfcTendonAnchorType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3663046924: (e) => new a.IfcTendonConduit(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2281632017: (e) => new a.IfcTendonConduitType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2415094496: (e) => new a.IfcTendonType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  618700268: (e) => new a.IfcTrackElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1692211062: (e) => new a.IfcTransformerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2097647324: (e) => new a.IfcTransportElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1953115116: (e) => new a.IfcTransportationDevice(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3593883385: (e) => new a.IfcTrimmedCurve(e[0], e[1], e[2], e[3], e[4]),
  1600972822: (e) => new a.IfcTubeBundleType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1911125066: (e) => new a.IfcUnitaryEquipmentType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  728799441: (e) => new a.IfcValveType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  840318589: (e) => new a.IfcVehicle(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1530820697: (e) => new a.IfcVibrationDamper(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3956297820: (e) => new a.IfcVibrationDamperType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2391383451: (e) => new a.IfcVibrationIsolator(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3313531582: (e) => new a.IfcVibrationIsolatorType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2769231204: (e) => new a.IfcVirtualElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  926996030: (e) => new a.IfcVoidingFeature(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1898987631: (e) => new a.IfcWallType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1133259667: (e) => new a.IfcWasteTerminalType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4009809668: (e) => new a.IfcWindowType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  4088093105: (e) => new a.IfcWorkCalendar(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1028945134: (e) => new a.IfcWorkControl(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  4218914973: (e) => new a.IfcWorkPlan(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13]),
  3342526732: (e) => new a.IfcWorkSchedule(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13]),
  1033361043: (e) => new a.IfcZone(e[0], e[1], e[2], e[3], e[4], e[5]),
  3821786052: (e) => new a.IfcActionRequest(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1411407467: (e) => new a.IfcAirTerminalBoxType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3352864051: (e) => new a.IfcAirTerminalType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1871374353: (e) => new a.IfcAirToAirHeatRecoveryType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4266260250: (e) => new a.IfcAlignmentCant(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1545765605: (e) => new a.IfcAlignmentHorizontal(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  317615605: (e) => new a.IfcAlignmentSegment(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1662888072: (e) => new a.IfcAlignmentVertical(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3460190687: (e) => new a.IfcAsset(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13]),
  1532957894: (e) => new a.IfcAudioVisualApplianceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1967976161: (e) => new a.IfcBSplineCurve(e[0], e[1], e[2], e[3], e[4]),
  2461110595: (e) => new a.IfcBSplineCurveWithKnots(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  819618141: (e) => new a.IfcBeamType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3649138523: (e) => new a.IfcBearingType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  231477066: (e) => new a.IfcBoilerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1136057603: (e) => new a.IfcBoundaryCurve(e[0], e[1]),
  644574406: (e) => new a.IfcBridge(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  963979645: (e) => new a.IfcBridgePart(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  4031249490: (e) => new a.IfcBuilding(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  2979338954: (e) => new a.IfcBuildingElementPart(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  39481116: (e) => new a.IfcBuildingElementPartType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1909888760: (e) => new a.IfcBuildingElementProxyType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1177604601: (e) => new a.IfcBuildingSystem(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1876633798: (e) => new a.IfcBuiltElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3862327254: (e) => new a.IfcBuiltSystem(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2188180465: (e) => new a.IfcBurnerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  395041908: (e) => new a.IfcCableCarrierFittingType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3293546465: (e) => new a.IfcCableCarrierSegmentType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2674252688: (e) => new a.IfcCableFittingType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1285652485: (e) => new a.IfcCableSegmentType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3203706013: (e) => new a.IfcCaissonFoundationType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2951183804: (e) => new a.IfcChillerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3296154744: (e) => new a.IfcChimney(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2611217952: (e) => new a.IfcCircle(e[0], e[1]),
  1677625105: (e) => new a.IfcCivilElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2301859152: (e) => new a.IfcCoilType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  843113511: (e) => new a.IfcColumn(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  400855858: (e) => new a.IfcCommunicationsApplianceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3850581409: (e) => new a.IfcCompressorType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2816379211: (e) => new a.IfcCondenserType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3898045240: (e) => new a.IfcConstructionEquipmentResource(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1060000209: (e) => new a.IfcConstructionMaterialResource(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  488727124: (e) => new a.IfcConstructionProductResource(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  2940368186: (e) => new a.IfcConveyorSegmentType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  335055490: (e) => new a.IfcCooledBeamType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2954562838: (e) => new a.IfcCoolingTowerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1502416096: (e) => new a.IfcCourse(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1973544240: (e) => new a.IfcCovering(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3495092785: (e) => new a.IfcCurtainWall(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3961806047: (e) => new a.IfcDamperType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3426335179: (e) => new a.IfcDeepFoundation(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1335981549: (e) => new a.IfcDiscreteAccessory(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2635815018: (e) => new a.IfcDiscreteAccessoryType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  479945903: (e) => new a.IfcDistributionBoardType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1599208980: (e) => new a.IfcDistributionChamberElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2063403501: (e) => new a.IfcDistributionControlElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1945004755: (e) => new a.IfcDistributionElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3040386961: (e) => new a.IfcDistributionFlowElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3041715199: (e) => new a.IfcDistributionPort(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3205830791: (e) => new a.IfcDistributionSystem(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  395920057: (e) => new a.IfcDoor(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  869906466: (e) => new a.IfcDuctFittingType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3760055223: (e) => new a.IfcDuctSegmentType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2030761528: (e) => new a.IfcDuctSilencerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3071239417: (e) => new a.IfcEarthworksCut(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1077100507: (e) => new a.IfcEarthworksElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3376911765: (e) => new a.IfcEarthworksFill(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  663422040: (e) => new a.IfcElectricApplianceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2417008758: (e) => new a.IfcElectricDistributionBoardType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3277789161: (e) => new a.IfcElectricFlowStorageDeviceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2142170206: (e) => new a.IfcElectricFlowTreatmentDeviceType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1534661035: (e) => new a.IfcElectricGeneratorType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1217240411: (e) => new a.IfcElectricMotorType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  712377611: (e) => new a.IfcElectricTimeControlType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1658829314: (e) => new a.IfcEnergyConversionDevice(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2814081492: (e) => new a.IfcEngine(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3747195512: (e) => new a.IfcEvaporativeCooler(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  484807127: (e) => new a.IfcEvaporator(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1209101575: (e) => new a.IfcExternalSpatialElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  346874300: (e) => new a.IfcFanType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1810631287: (e) => new a.IfcFilterType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4222183408: (e) => new a.IfcFireSuppressionTerminalType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2058353004: (e) => new a.IfcFlowController(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  4278956645: (e) => new a.IfcFlowFitting(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  4037862832: (e) => new a.IfcFlowInstrumentType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2188021234: (e) => new a.IfcFlowMeter(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3132237377: (e) => new a.IfcFlowMovingDevice(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  987401354: (e) => new a.IfcFlowSegment(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  707683696: (e) => new a.IfcFlowStorageDevice(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2223149337: (e) => new a.IfcFlowTerminal(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3508470533: (e) => new a.IfcFlowTreatmentDevice(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  900683007: (e) => new a.IfcFooting(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2713699986: (e) => new a.IfcGeotechnicalAssembly(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3009204131: (e) => new a.IfcGrid(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  3319311131: (e) => new a.IfcHeatExchanger(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2068733104: (e) => new a.IfcHumidifier(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4175244083: (e) => new a.IfcInterceptor(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2176052936: (e) => new a.IfcJunctionBox(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2696325953: (e) => new a.IfcKerb(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  76236018: (e) => new a.IfcLamp(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  629592764: (e) => new a.IfcLightFixture(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1154579445: (e) => new a.IfcLinearPositioningElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1638804497: (e) => new a.IfcLiquidTerminal(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1437502449: (e) => new a.IfcMedicalDevice(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1073191201: (e) => new a.IfcMember(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2078563270: (e) => new a.IfcMobileTelecommunicationsAppliance(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  234836483: (e) => new a.IfcMooringDevice(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2474470126: (e) => new a.IfcMotorConnection(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2182337498: (e) => new a.IfcNavigationElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  144952367: (e) => new a.IfcOuterBoundaryCurve(e[0], e[1]),
  3694346114: (e) => new a.IfcOutlet(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1383356374: (e) => new a.IfcPavement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1687234759: (e) => new a.IfcPile(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  310824031: (e) => new a.IfcPipeFitting(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3612865200: (e) => new a.IfcPipeSegment(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3171933400: (e) => new a.IfcPlate(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  738039164: (e) => new a.IfcProtectiveDevice(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  655969474: (e) => new a.IfcProtectiveDeviceTrippingUnitType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  90941305: (e) => new a.IfcPump(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3290496277: (e) => new a.IfcRail(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2262370178: (e) => new a.IfcRailing(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3024970846: (e) => new a.IfcRamp(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3283111854: (e) => new a.IfcRampFlight(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1232101972: (e) => new a.IfcRationalBSplineCurveWithKnots(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3798194928: (e) => new a.IfcReinforcedSoil(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  979691226: (e) => new a.IfcReinforcingBar(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13]),
  2572171363: (e) => new a.IfcReinforcingBarType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15]),
  2016517767: (e) => new a.IfcRoof(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3053780830: (e) => new a.IfcSanitaryTerminal(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1783015770: (e) => new a.IfcSensorType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1329646415: (e) => new a.IfcShadingDevice(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  991950508: (e) => new a.IfcSignal(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1529196076: (e) => new a.IfcSlab(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3420628829: (e) => new a.IfcSolarDevice(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1999602285: (e) => new a.IfcSpaceHeater(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1404847402: (e) => new a.IfcStackTerminal(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  331165859: (e) => new a.IfcStair(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4252922144: (e) => new a.IfcStairFlight(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  2515109513: (e) => new a.IfcStructuralAnalysisModel(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  385403989: (e) => new a.IfcStructuralLoadCase(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1621171031: (e) => new a.IfcStructuralPlanarAction(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1162798199: (e) => new a.IfcSwitchingDevice(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  812556717: (e) => new a.IfcTank(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3425753595: (e) => new a.IfcTrackElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3825984169: (e) => new a.IfcTransformer(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1620046519: (e) => new a.IfcTransportElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3026737570: (e) => new a.IfcTubeBundle(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3179687236: (e) => new a.IfcUnitaryControlElementType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4292641817: (e) => new a.IfcUnitaryEquipment(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4207607924: (e) => new a.IfcValve(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2391406946: (e) => new a.IfcWall(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3512223829: (e) => new a.IfcWallStandardCase(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4237592921: (e) => new a.IfcWasteTerminal(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3304561284: (e) => new a.IfcWindow(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  2874132201: (e) => new a.IfcActuatorType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1634111441: (e) => new a.IfcAirTerminal(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  177149247: (e) => new a.IfcAirTerminalBox(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2056796094: (e) => new a.IfcAirToAirHeatRecovery(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3001207471: (e) => new a.IfcAlarmType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  325726236: (e) => new a.IfcAlignment(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  277319702: (e) => new a.IfcAudioVisualAppliance(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  753842376: (e) => new a.IfcBeam(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4196446775: (e) => new a.IfcBearing(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  32344328: (e) => new a.IfcBoiler(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3314249567: (e) => new a.IfcBorehole(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1095909175: (e) => new a.IfcBuildingElementProxy(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2938176219: (e) => new a.IfcBurner(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  635142910: (e) => new a.IfcCableCarrierFitting(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3758799889: (e) => new a.IfcCableCarrierSegment(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1051757585: (e) => new a.IfcCableFitting(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4217484030: (e) => new a.IfcCableSegment(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3999819293: (e) => new a.IfcCaissonFoundation(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3902619387: (e) => new a.IfcChiller(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  639361253: (e) => new a.IfcCoil(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3221913625: (e) => new a.IfcCommunicationsAppliance(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3571504051: (e) => new a.IfcCompressor(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2272882330: (e) => new a.IfcCondenser(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  578613899: (e) => new a.IfcControllerType(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3460952963: (e) => new a.IfcConveyorSegment(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4136498852: (e) => new a.IfcCooledBeam(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3640358203: (e) => new a.IfcCoolingTower(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4074379575: (e) => new a.IfcDamper(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3693000487: (e) => new a.IfcDistributionBoard(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1052013943: (e) => new a.IfcDistributionChamberElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  562808652: (e) => new a.IfcDistributionCircuit(e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1062813311: (e) => new a.IfcDistributionControlElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  342316401: (e) => new a.IfcDuctFitting(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3518393246: (e) => new a.IfcDuctSegment(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1360408905: (e) => new a.IfcDuctSilencer(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1904799276: (e) => new a.IfcElectricAppliance(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  862014818: (e) => new a.IfcElectricDistributionBoard(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3310460725: (e) => new a.IfcElectricFlowStorageDevice(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  24726584: (e) => new a.IfcElectricFlowTreatmentDevice(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  264262732: (e) => new a.IfcElectricGenerator(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  402227799: (e) => new a.IfcElectricMotor(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1003880860: (e) => new a.IfcElectricTimeControl(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3415622556: (e) => new a.IfcFan(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  819412036: (e) => new a.IfcFilter(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1426591983: (e) => new a.IfcFireSuppressionTerminal(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  182646315: (e) => new a.IfcFlowInstrument(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2680139844: (e) => new a.IfcGeomodel(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1971632696: (e) => new a.IfcGeoslice(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2295281155: (e) => new a.IfcProtectiveDeviceTrippingUnit(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4086658281: (e) => new a.IfcSensor(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  630975310: (e) => new a.IfcUnitaryControlElement(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4288193352: (e) => new a.IfcActuator(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3087945054: (e) => new a.IfcAlarm(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  25142252: (e) => new a.IfcController(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8])
};
Pie[3] = {
  3630933823: (e) => [e.Role, e.UserDefinedRole, e.Description],
  618182010: (e) => [e.Purpose, e.Description, e.UserDefinedPurpose],
  2879124712: (e) => [e.StartTag, e.EndTag],
  3633395639: (e) => [e.StartTag, e.EndTag, e.StartDistAlong, e.HorizontalLength, e.StartHeight, e.StartGradient, e.EndGradient, e.RadiusOfCurvature, e.PredefinedType],
  639542469: (e) => [e.ApplicationDeveloper, e.Version, e.ApplicationFullName, e.ApplicationIdentifier],
  411424972: (e) => [e.Name, e.Description, ke(e.AppliedValue), e.UnitBasis, e.ApplicableDate, e.FixedUntilDate, e.Category, e.Condition, e.ArithmeticOperator, e.Components],
  130549933: (e) => [e.Identifier, e.Name, e.Description, e.TimeOfApproval, e.Status, e.Level, e.Qualifier, ke(e.RequestingApproval), ke(e.GivingApproval)],
  4037036970: (e) => [e.Name],
  1560379544: (e) => [e.Name, (e.TranslationalStiffnessByLengthX ?? void 0) === void 0 ? null : ke(e.TranslationalStiffnessByLengthX), (e.TranslationalStiffnessByLengthY ?? void 0) === void 0 ? null : ke(e.TranslationalStiffnessByLengthY), (e.TranslationalStiffnessByLengthZ ?? void 0) === void 0 ? null : ke(e.TranslationalStiffnessByLengthZ), (e.RotationalStiffnessByLengthX ?? void 0) === void 0 ? null : ke(e.RotationalStiffnessByLengthX), (e.RotationalStiffnessByLengthY ?? void 0) === void 0 ? null : ke(e.RotationalStiffnessByLengthY), (e.RotationalStiffnessByLengthZ ?? void 0) === void 0 ? null : ke(e.RotationalStiffnessByLengthZ)],
  3367102660: (e) => [e.Name, (e.TranslationalStiffnessByAreaX ?? void 0) === void 0 ? null : ke(e.TranslationalStiffnessByAreaX), (e.TranslationalStiffnessByAreaY ?? void 0) === void 0 ? null : ke(e.TranslationalStiffnessByAreaY), (e.TranslationalStiffnessByAreaZ ?? void 0) === void 0 ? null : ke(e.TranslationalStiffnessByAreaZ)],
  1387855156: (e) => [e.Name, (e.TranslationalStiffnessX ?? void 0) === void 0 ? null : ke(e.TranslationalStiffnessX), (e.TranslationalStiffnessY ?? void 0) === void 0 ? null : ke(e.TranslationalStiffnessY), (e.TranslationalStiffnessZ ?? void 0) === void 0 ? null : ke(e.TranslationalStiffnessZ), (e.RotationalStiffnessX ?? void 0) === void 0 ? null : ke(e.RotationalStiffnessX), (e.RotationalStiffnessY ?? void 0) === void 0 ? null : ke(e.RotationalStiffnessY), (e.RotationalStiffnessZ ?? void 0) === void 0 ? null : ke(e.RotationalStiffnessZ)],
  2069777674: (e) => [e.Name, (e.TranslationalStiffnessX ?? void 0) === void 0 ? null : ke(e.TranslationalStiffnessX), (e.TranslationalStiffnessY ?? void 0) === void 0 ? null : ke(e.TranslationalStiffnessY), (e.TranslationalStiffnessZ ?? void 0) === void 0 ? null : ke(e.TranslationalStiffnessZ), (e.RotationalStiffnessX ?? void 0) === void 0 ? null : ke(e.RotationalStiffnessX), (e.RotationalStiffnessY ?? void 0) === void 0 ? null : ke(e.RotationalStiffnessY), (e.RotationalStiffnessZ ?? void 0) === void 0 ? null : ke(e.RotationalStiffnessZ), (e.WarpingStiffness ?? void 0) === void 0 ? null : ke(e.WarpingStiffness)],
  2859738748: (e) => [],
  2614616156: (e) => [ke(e.PointOnRelatingElement), ke(e.PointOnRelatedElement)],
  2732653382: (e) => [ke(e.SurfaceOnRelatingElement), ke(e.SurfaceOnRelatedElement)],
  775493141: (e) => [ke(e.VolumeOnRelatingElement), ke(e.VolumeOnRelatedElement)],
  1959218052: (e) => [e.Name, e.Description, e.ConstraintGrade, e.ConstraintSource, ke(e.CreatingActor), e.CreationTime, e.UserDefinedGrade],
  1785450214: (e) => [ke(e.SourceCRS), e.TargetCRS],
  1466758467: (e) => [e.Name, e.Description, e.GeodeticDatum, e.VerticalDatum],
  602808272: (e) => [e.Name, e.Description, ke(e.AppliedValue), e.UnitBasis, e.ApplicableDate, e.FixedUntilDate, e.Category, e.Condition, e.ArithmeticOperator, e.Components],
  1765591967: (e) => [e.Elements, e.UnitType, e.UserDefinedType, e.Name],
  1045800335: (e) => [e.Unit, e.Exponent],
  2949456006: (e) => [e.LengthExponent, e.MassExponent, e.TimeExponent, e.ElectricCurrentExponent, e.ThermodynamicTemperatureExponent, e.AmountOfSubstanceExponent, e.LuminousIntensityExponent],
  4294318154: (e) => [],
  3200245327: (e) => [e.Location, e.Identification, e.Name],
  2242383968: (e) => [e.Location, e.Identification, e.Name],
  1040185647: (e) => [e.Location, e.Identification, e.Name],
  3548104201: (e) => [e.Location, e.Identification, e.Name],
  852622518: (e) => [e.AxisTag, e.AxisCurve, { type: 3, value: e.SameSense.value }],
  3020489413: (e) => [e.TimeStamp, e.ListValues.map((t) => ke(t))],
  2655187982: (e) => [e.Name, e.Version, ke(e.Publisher), e.VersionDate, e.Location, e.Description],
  3452421091: (e) => [e.Location, e.Identification, e.Name, e.Description, e.Language, e.ReferencedLibrary],
  4162380809: (e) => [e.MainPlaneAngle, e.SecondaryPlaneAngle, e.LuminousIntensity],
  1566485204: (e) => [e.LightDistributionCurve, e.DistributionData],
  3057273783: (e) => [ke(e.SourceCRS), e.TargetCRS, e.Eastings, e.Northings, e.OrthogonalHeight, e.XAxisAbscissa, e.XAxisOrdinate, e.Scale, e.ScaleY, e.ScaleZ],
  1847130766: (e) => [ke(e.MaterialClassifications), e.ClassifiedMaterial],
  760658860: (e) => [],
  248100487: (e) => [e.Material, e.LayerThickness, e.IsVentilated == null ? null : { type: 3, value: e.IsVentilated.value }, e.Name, e.Description, e.Category, e.Priority],
  3303938423: (e) => [e.MaterialLayers, e.LayerSetName, e.Description],
  1847252529: (e) => [e.Material, e.LayerThickness, e.IsVentilated == null ? null : { type: 3, value: e.IsVentilated.value }, e.Name, e.Description, e.Category, e.Priority, e.OffsetDirection, e.OffsetValues],
  2199411900: (e) => [e.Materials],
  2235152071: (e) => [e.Name, e.Description, e.Material, e.Profile, e.Priority, e.Category],
  164193824: (e) => [e.Name, e.Description, e.MaterialProfiles, e.CompositeProfile],
  552965576: (e) => [e.Name, e.Description, e.Material, e.Profile, e.Priority, e.Category, e.OffsetValues],
  1507914824: (e) => [],
  2597039031: (e) => [ke(e.ValueComponent), ke(e.UnitComponent)],
  3368373690: (e) => [e.Name, e.Description, e.ConstraintGrade, e.ConstraintSource, ke(e.CreatingActor), e.CreationTime, e.UserDefinedGrade, e.Benchmark, e.ValueSource, ke(e.DataValue), e.ReferencePath],
  2706619895: (e) => [e.Currency],
  1918398963: (e) => [e.Dimensions, e.UnitType],
  3701648758: (e) => [e.PlacementRelTo],
  2251480897: (e) => [e.Name, e.Description, e.ConstraintGrade, e.ConstraintSource, ke(e.CreatingActor), e.CreationTime, e.UserDefinedGrade, e.BenchmarkValues, e.LogicalAggregator, e.ObjectiveQualifier, e.UserDefinedQualifier],
  4251960020: (e) => [e.Identification, e.Name, e.Description, e.Roles, e.Addresses],
  1207048766: (e) => [e.OwningUser, e.OwningApplication, e.State, e.ChangeAction, e.LastModifiedDate, e.LastModifyingUser, e.LastModifyingApplication, e.CreationDate],
  2077209135: (e) => [e.Identification, e.FamilyName, e.GivenName, e.MiddleNames, e.PrefixTitles, e.SuffixTitles, e.Roles, e.Addresses],
  101040310: (e) => [e.ThePerson, e.TheOrganization, e.Roles],
  2483315170: (e) => [e.Name, e.Description],
  2226359599: (e) => [e.Name, e.Description, e.Unit],
  3355820592: (e) => [e.Purpose, e.Description, e.UserDefinedPurpose, e.InternalLocation, e.AddressLines, e.PostalBox, e.Town, e.Region, e.PostalCode, e.Country],
  677532197: (e) => [],
  2022622350: (e) => [e.Name, e.Description, ke(e.AssignedItems), e.Identifier],
  1304840413: (e) => [e.Name, e.Description, ke(e.AssignedItems), e.Identifier, { type: 3, value: e.LayerOn.value }, { type: 3, value: e.LayerFrozen.value }, { type: 3, value: e.LayerBlocked.value }, e.LayerStyles],
  3119450353: (e) => [e.Name],
  2095639259: (e) => [e.Name, e.Description, e.Representations],
  3958567839: (e) => [e.ProfileType, e.ProfileName],
  3843373140: (e) => [e.Name, e.Description, e.GeodeticDatum, e.VerticalDatum, e.MapProjection, e.MapZone, e.MapUnit],
  986844984: (e) => [],
  3710013099: (e) => [e.Name, e.EnumerationValues.map((t) => ke(t)), ke(e.Unit)],
  2044713172: (e) => [e.Name, e.Description, e.Unit, e.AreaValue, e.Formula],
  2093928680: (e) => [e.Name, e.Description, e.Unit, e.CountValue, e.Formula],
  931644368: (e) => [e.Name, e.Description, e.Unit, e.LengthValue, e.Formula],
  2691318326: (e) => [e.Name, e.Description, e.Unit, e.NumberValue, e.Formula],
  3252649465: (e) => [e.Name, e.Description, e.Unit, e.TimeValue, e.Formula],
  2405470396: (e) => [e.Name, e.Description, e.Unit, e.VolumeValue, e.Formula],
  825690147: (e) => [e.Name, e.Description, e.Unit, e.WeightValue, e.Formula],
  3915482550: (e) => [e.RecurrenceType, e.DayComponent, e.WeekdayComponent, e.MonthComponent, e.Position, e.Interval, e.Occurrences, e.TimePeriods],
  2433181523: (e) => [e.TypeIdentifier, e.AttributeIdentifier, e.InstanceName, e.ListPositions, e.InnerReference],
  1076942058: (e) => [e.ContextOfItems, e.RepresentationIdentifier, e.RepresentationType, e.Items],
  3377609919: (e) => [e.ContextIdentifier, e.ContextType],
  3008791417: (e) => [],
  1660063152: (e) => [ke(e.MappingOrigin), e.MappedRepresentation],
  2439245199: (e) => [e.Name, e.Description],
  2341007311: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description],
  448429030: (e) => [void 0, e.UnitType, e.Prefix, e.Name],
  1054537805: (e) => [e.Name, e.DataOrigin, e.UserDefinedDataOrigin],
  867548509: (e) => [e.ShapeRepresentations, e.Name, e.Description, { type: 3, value: e.ProductDefinitional.value }, ke(e.PartOfProductDefinitionShape)],
  3982875396: (e) => [e.ContextOfItems, e.RepresentationIdentifier, e.RepresentationType, e.Items],
  4240577450: (e) => [e.ContextOfItems, e.RepresentationIdentifier, e.RepresentationType, e.Items],
  2273995522: (e) => [e.Name],
  2162789131: (e) => [e.Name],
  3478079324: (e) => [e.Name, e.Values, e.Locations],
  609421318: (e) => [e.Name],
  2525727697: (e) => [e.Name],
  3408363356: (e) => [e.Name, e.DeltaTConstant, e.DeltaTY, e.DeltaTZ],
  2830218821: (e) => [e.ContextOfItems, e.RepresentationIdentifier, e.RepresentationType, e.Items],
  3958052878: (e) => [e.Item, e.Styles, e.Name],
  3049322572: (e) => [e.ContextOfItems, e.RepresentationIdentifier, e.RepresentationType, e.Items],
  2934153892: (e) => [e.Name, e.SurfaceReinforcement1, e.SurfaceReinforcement2, e.ShearReinforcement],
  1300840506: (e) => [e.Name, e.Side, ke(e.Styles)],
  3303107099: (e) => [e.DiffuseTransmissionColour, e.DiffuseReflectionColour, e.TransmissionColour, e.ReflectanceColour],
  1607154358: (e) => [e.RefractionIndex, e.DispersionFactor],
  846575682: (e) => [e.SurfaceColour, e.Transparency],
  1351298697: (e) => [e.Textures],
  626085974: (e) => [{ type: 3, value: e.RepeatS.value }, { type: 3, value: e.RepeatT.value }, e.Mode, e.TextureTransform, e.Parameter],
  985171141: (e) => [e.Name, e.Rows, e.Columns],
  2043862942: (e) => [e.Identifier, e.Name, e.Description, ke(e.Unit), e.ReferencePath],
  531007025: (e) => [(e.RowCells ?? void 0) === void 0 ? null : e.RowCells.map((t) => ke(t)), e.IsHeading == null ? null : { type: 3, value: e.IsHeading.value }],
  1549132990: (e) => [e.Name, e.DataOrigin, e.UserDefinedDataOrigin, e.DurationType, e.ScheduleDuration, e.ScheduleStart, e.ScheduleFinish, e.EarlyStart, e.EarlyFinish, e.LateStart, e.LateFinish, e.FreeFloat, e.TotalFloat, e.IsCritical == null ? null : { type: 3, value: e.IsCritical.value }, e.StatusTime, e.ActualDuration, e.ActualStart, e.ActualFinish, e.RemainingTime, e.Completion],
  2771591690: (e) => [e.Name, e.DataOrigin, e.UserDefinedDataOrigin, e.DurationType, e.ScheduleDuration, e.ScheduleStart, e.ScheduleFinish, e.EarlyStart, e.EarlyFinish, e.LateStart, e.LateFinish, e.FreeFloat, e.TotalFloat, e.IsCritical == null ? null : { type: 3, value: e.IsCritical.value }, e.StatusTime, e.ActualDuration, e.ActualStart, e.ActualFinish, e.RemainingTime, e.Completion, e.Recurrence],
  912023232: (e) => [e.Purpose, e.Description, e.UserDefinedPurpose, e.TelephoneNumbers, e.FacsimileNumbers, e.PagerNumber, e.ElectronicMailAddresses, e.WWWHomePageURL, e.MessagingIDs],
  1447204868: (e) => [e.Name, e.TextCharacterAppearance, e.TextStyle, ke(e.TextFontStyle), e.ModelOrDraughting == null ? null : { type: 3, value: e.ModelOrDraughting.value }],
  2636378356: (e) => [ke(e.Colour), ke(e.BackgroundColour)],
  1640371178: (e) => [(e.TextIndent ?? void 0) === void 0 ? null : ke(e.TextIndent), e.TextAlign, e.TextDecoration, (e.LetterSpacing ?? void 0) === void 0 ? null : ke(e.LetterSpacing), (e.WordSpacing ?? void 0) === void 0 ? null : ke(e.WordSpacing), e.TextTransform, (e.LineHeight ?? void 0) === void 0 ? null : ke(e.LineHeight)],
  280115917: (e) => [e.Maps],
  1742049831: (e) => [e.Maps, e.Mode, e.Parameter],
  222769930: (e) => [e.TexCoordIndex, e.TexCoordsOf],
  1010789467: (e) => [e.TexCoordIndex, e.TexCoordsOf, e.InnerTexCoordIndices],
  2552916305: (e) => [e.Maps, e.Vertices, e.MappedTo],
  1210645708: (e) => [e.Coordinates],
  3611470254: (e) => [e.TexCoordsList],
  1199560280: (e) => [e.StartTime, e.EndTime],
  3101149627: (e) => [e.Name, e.Description, e.StartTime, e.EndTime, e.TimeSeriesDataType, e.DataOrigin, e.UserDefinedDataOrigin, ke(e.Unit)],
  581633288: (e) => [e.ListValues.map((t) => ke(t))],
  1377556343: (e) => [],
  1735638870: (e) => [e.ContextOfItems, e.RepresentationIdentifier, e.RepresentationType, e.Items],
  180925521: (e) => [ke(e.Units)],
  2799835756: (e) => [],
  1907098498: (e) => [e.VertexGeometry],
  891718957: (e) => [e.IntersectingAxes, e.OffsetDistances],
  1236880293: (e) => [e.Name, e.DataOrigin, e.UserDefinedDataOrigin, e.RecurrencePattern, e.StartDate, e.FinishDate],
  3752311538: (e) => [e.StartTag, e.EndTag, e.StartDistAlong, e.HorizontalLength, e.StartCantLeft, e.EndCantLeft, e.StartCantRight, e.EndCantRight, e.PredefinedType],
  536804194: (e) => [e.StartTag, e.EndTag, e.StartPoint, e.StartDirection, e.StartRadiusOfCurvature, e.EndRadiusOfCurvature, e.SegmentLength, e.GravityCenterLineHeight, e.PredefinedType],
  3869604511: (e) => [e.Name, e.Description, e.RelatingApproval, e.RelatedApprovals],
  3798115385: (e) => [e.ProfileType, e.ProfileName, e.OuterCurve],
  1310608509: (e) => [e.ProfileType, e.ProfileName, e.Curve],
  2705031697: (e) => [e.ProfileType, e.ProfileName, e.OuterCurve, e.InnerCurves],
  616511568: (e) => [{ type: 3, value: e.RepeatS.value }, { type: 3, value: e.RepeatT.value }, e.Mode, e.TextureTransform, e.Parameter, e.RasterFormat, e.RasterCode],
  3150382593: (e) => [e.ProfileType, e.ProfileName, e.Curve, e.Thickness],
  747523909: (e) => [e.Source, e.Edition, e.EditionDate, e.Name, e.Description, e.Specification, e.ReferenceTokens],
  647927063: (e) => [e.Location, e.Identification, e.Name, ke(e.ReferencedSource), e.Description, e.Sort],
  3285139300: (e) => [e.ColourList],
  3264961684: (e) => [e.Name],
  1485152156: (e) => [e.ProfileType, e.ProfileName, e.Profiles, e.Label],
  370225590: (e) => [e.CfsFaces],
  1981873012: (e) => [ke(e.CurveOnRelatingElement), ke(e.CurveOnRelatedElement)],
  45288368: (e) => [ke(e.PointOnRelatingElement), ke(e.PointOnRelatedElement), e.EccentricityInX, e.EccentricityInY, e.EccentricityInZ],
  3050246964: (e) => [e.Dimensions, e.UnitType, e.Name],
  2889183280: (e) => [e.Dimensions, e.UnitType, e.Name, e.ConversionFactor],
  2713554722: (e) => [e.Dimensions, e.UnitType, e.Name, e.ConversionFactor, e.ConversionOffset],
  539742890: (e) => [e.Name, e.Description, e.RelatingMonetaryUnit, e.RelatedMonetaryUnit, e.ExchangeRate, e.RateDateTime, e.RateSource],
  3800577675: (e) => [e.Name, ke(e.CurveFont), (e.CurveWidth ?? void 0) === void 0 ? null : ke(e.CurveWidth), ke(e.CurveColour), e.ModelOrDraughting == null ? null : { type: 3, value: e.ModelOrDraughting.value }],
  1105321065: (e) => [e.Name, e.PatternList],
  2367409068: (e) => [e.Name, ke(e.CurveStyleFont), e.CurveFontScaling],
  3510044353: (e) => [e.VisibleSegmentLength, e.InvisibleSegmentLength],
  3632507154: (e) => [e.ProfileType, e.ProfileName, e.ParentProfile, e.Operator, e.Label],
  1154170062: (e) => [e.Identification, e.Name, e.Description, e.Location, e.Purpose, e.IntendedUse, e.Scope, e.Revision, ke(e.DocumentOwner), ke(e.Editors), e.CreationTime, e.LastRevisionTime, e.ElectronicFormat, e.ValidFrom, e.ValidUntil, e.Confidentiality, e.Status],
  770865208: (e) => [e.Name, e.Description, e.RelatingDocument, e.RelatedDocuments, e.RelationshipType],
  3732053477: (e) => [e.Location, e.Identification, e.Name, e.Description, e.ReferencedDocument],
  3900360178: (e) => [e.EdgeStart, e.EdgeEnd],
  476780140: (e) => [e.EdgeStart, e.EdgeEnd, e.EdgeGeometry, { type: 3, value: e.SameSense.value }],
  211053100: (e) => [e.Name, e.DataOrigin, e.UserDefinedDataOrigin, e.ActualDate, e.EarlyDate, e.LateDate, e.ScheduleDate],
  297599258: (e) => [e.Name, e.Description, e.Properties],
  1437805879: (e) => [e.Name, e.Description, e.RelatingReference, ke(e.RelatedResourceObjects)],
  2556980723: (e) => [e.Bounds],
  1809719519: (e) => [e.Bound, { type: 3, value: e.Orientation.value }],
  803316827: (e) => [e.Bound, { type: 3, value: e.Orientation.value }],
  3008276851: (e) => [e.Bounds, e.FaceSurface, { type: 3, value: e.SameSense.value }],
  4219587988: (e) => [e.Name, e.TensionFailureX, e.TensionFailureY, e.TensionFailureZ, e.CompressionFailureX, e.CompressionFailureY, e.CompressionFailureZ],
  738692330: (e) => [e.Name, ke(e.FillStyles), e.ModelOrDraughting == null ? null : { type: 3, value: e.ModelOrDraughting.value }],
  3448662350: (e) => [e.ContextIdentifier, e.ContextType, e.CoordinateSpaceDimension, e.Precision, ke(e.WorldCoordinateSystem), e.TrueNorth],
  2453401579: (e) => [],
  4142052618: (e) => [e.ContextIdentifier, e.ContextType, void 0, void 0, void 0, void 0, e.ParentContext, e.TargetScale, e.TargetView, e.UserDefinedTargetView],
  3590301190: (e) => [ke(e.Elements)],
  178086475: (e) => [e.PlacementRelTo, e.PlacementLocation, ke(e.PlacementRefDirection)],
  812098782: (e) => [e.BaseSurface, { type: 3, value: e.AgreementFlag.value }],
  3905492369: (e) => [{ type: 3, value: e.RepeatS.value }, { type: 3, value: e.RepeatT.value }, e.Mode, e.TextureTransform, e.Parameter, e.URLReference],
  3570813810: (e) => [e.MappedTo, e.Opacity, e.Colours, e.ColourIndex],
  1437953363: (e) => [e.Maps, e.MappedTo, e.TexCoords],
  2133299955: (e) => [e.Maps, e.MappedTo, e.TexCoords, e.TexCoordIndex],
  3741457305: (e) => [e.Name, e.Description, e.StartTime, e.EndTime, e.TimeSeriesDataType, e.DataOrigin, e.UserDefinedDataOrigin, ke(e.Unit), e.Values],
  1585845231: (e) => [e.Name, e.DataOrigin, e.UserDefinedDataOrigin, ke(e.LagValue), e.DurationType],
  1402838566: (e) => [e.Name, e.LightColour, e.AmbientIntensity, e.Intensity],
  125510826: (e) => [e.Name, e.LightColour, e.AmbientIntensity, e.Intensity],
  2604431987: (e) => [e.Name, e.LightColour, e.AmbientIntensity, e.Intensity, e.Orientation],
  4266656042: (e) => [e.Name, e.LightColour, e.AmbientIntensity, e.Intensity, e.Position, e.ColourAppearance, e.ColourTemperature, e.LuminousFlux, e.LightEmissionSource, ke(e.LightDistributionDataSource)],
  1520743889: (e) => [e.Name, e.LightColour, e.AmbientIntensity, e.Intensity, e.Position, e.Radius, e.ConstantAttenuation, e.DistanceAttenuation, e.QuadricAttenuation],
  3422422726: (e) => [e.Name, e.LightColour, e.AmbientIntensity, e.Intensity, e.Position, e.Radius, e.ConstantAttenuation, e.DistanceAttenuation, e.QuadricAttenuation, e.Orientation, e.ConcentrationExponent, e.SpreadAngle, e.BeamWidthAngle],
  388784114: (e) => [e.PlacementRelTo, e.RelativePlacement, e.CartesianPosition],
  2624227202: (e) => [e.PlacementRelTo, ke(e.RelativePlacement)],
  1008929658: (e) => [],
  2347385850: (e) => [e.MappingSource, e.MappingTarget],
  1838606355: (e) => [e.Name, e.Description, e.Category],
  3708119e3: (e) => [e.Name, e.Description, e.Material, e.Fraction, e.Category],
  2852063980: (e) => [e.Name, e.Description, e.MaterialConstituents],
  2022407955: (e) => [e.Name, e.Description, e.Representations, e.RepresentedMaterial],
  1303795690: (e) => [e.ForLayerSet, e.LayerSetDirection, e.DirectionSense, e.OffsetFromReferenceLine, e.ReferenceExtent],
  3079605661: (e) => [e.ForProfileSet, e.CardinalPoint, e.ReferenceExtent],
  3404854881: (e) => [e.ForProfileSet, e.CardinalPoint, e.ReferenceExtent, e.ForProfileEndSet, e.CardinalEndPoint],
  3265635763: (e) => [e.Name, e.Description, e.Properties, e.Material],
  853536259: (e) => [e.Name, e.Description, e.RelatingMaterial, e.RelatedMaterials, e.MaterialExpression],
  2998442950: (e) => [e.ProfileType, e.ProfileName, e.ParentProfile, void 0, e.Label],
  219451334: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description],
  182550632: (e) => [e.ProfileType, e.ProfileName, { type: 3, value: e.HorizontalWidths.value }, e.Widths, e.Slopes, e.Tags, e.OffsetPoint],
  2665983363: (e) => [e.CfsFaces],
  1411181986: (e) => [e.Name, e.Description, e.RelatingOrganization, e.RelatedOrganizations],
  1029017970: (e) => [void 0, void 0, e.EdgeElement, { type: 3, value: e.Orientation.value }],
  2529465313: (e) => [e.ProfileType, e.ProfileName, e.Position],
  2519244187: (e) => [e.EdgeList],
  3021840470: (e) => [e.Name, e.Description, e.HasQuantities, e.Discrimination, e.Quality, e.Usage],
  597895409: (e) => [{ type: 3, value: e.RepeatS.value }, { type: 3, value: e.RepeatT.value }, e.Mode, e.TextureTransform, e.Parameter, e.Width, e.Height, e.ColourComponents, e.Pixel],
  2004835150: (e) => [e.Location],
  1663979128: (e) => [e.SizeInX, e.SizeInY],
  2067069095: (e) => [],
  2165702409: (e) => [ke(e.DistanceAlong), e.OffsetLateral, e.OffsetVertical, e.OffsetLongitudinal, e.BasisCurve],
  4022376103: (e) => [e.BasisCurve, e.PointParameter],
  1423911732: (e) => [e.BasisSurface, e.PointParameterU, e.PointParameterV],
  2924175390: (e) => [e.Polygon],
  2775532180: (e) => [e.BaseSurface, { type: 3, value: e.AgreementFlag.value }, e.Position, e.PolygonalBoundary],
  3727388367: (e) => [e.Name],
  3778827333: (e) => [],
  1775413392: (e) => [e.Name],
  673634403: (e) => [e.Name, e.Description, e.Representations],
  2802850158: (e) => [e.Name, e.Description, e.Properties, e.ProfileDefinition],
  2598011224: (e) => [e.Name, e.Specification],
  1680319473: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description],
  148025276: (e) => [e.Name, e.Description, e.DependingProperty, e.DependantProperty, e.Expression],
  3357820518: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description],
  1482703590: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description],
  2090586900: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description],
  3615266464: (e) => [e.ProfileType, e.ProfileName, e.Position, e.XDim, e.YDim],
  3413951693: (e) => [e.Name, e.Description, e.StartTime, e.EndTime, e.TimeSeriesDataType, e.DataOrigin, e.UserDefinedDataOrigin, ke(e.Unit), e.TimeStep, e.Values],
  1580146022: (e) => [e.TotalCrossSectionArea, e.SteelGrade, e.BarSurface, e.EffectiveDepth, e.NominalBarDiameter, e.BarCount],
  478536968: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description],
  2943643501: (e) => [e.Name, e.Description, ke(e.RelatedResourceObjects), e.RelatingApproval],
  1608871552: (e) => [e.Name, e.Description, e.RelatingConstraint, ke(e.RelatedResourceObjects)],
  1042787934: (e) => [e.Name, e.DataOrigin, e.UserDefinedDataOrigin, e.ScheduleWork, e.ScheduleUsage, e.ScheduleStart, e.ScheduleFinish, e.ScheduleContour, e.LevelingDelay, e.IsOverAllocated == null ? null : { type: 3, value: e.IsOverAllocated.value }, e.StatusTime, e.ActualWork, e.ActualUsage, e.ActualStart, e.ActualFinish, e.RemainingWork, e.RemainingUsage, e.Completion],
  2778083089: (e) => [e.ProfileType, e.ProfileName, e.Position, e.XDim, e.YDim, e.RoundingRadius],
  2042790032: (e) => [e.SectionType, e.StartProfile, e.EndProfile],
  4165799628: (e) => [e.LongitudinalStartPosition, e.LongitudinalEndPosition, e.TransversePosition, e.ReinforcementRole, e.SectionDefinition, e.CrossSectionReinforcementDefinitions],
  1509187699: (e) => [e.SpineCurve, e.CrossSections, e.CrossSectionPositions],
  823603102: (e) => [e.Transition],
  4124623270: (e) => [ke(e.SbsmBoundary)],
  3692461612: (e) => [e.Name, e.Specification],
  2609359061: (e) => [e.Name, e.SlippageX, e.SlippageY, e.SlippageZ],
  723233188: (e) => [],
  1595516126: (e) => [e.Name, e.LinearForceX, e.LinearForceY, e.LinearForceZ, e.LinearMomentX, e.LinearMomentY, e.LinearMomentZ],
  2668620305: (e) => [e.Name, e.PlanarForceX, e.PlanarForceY, e.PlanarForceZ],
  2473145415: (e) => [e.Name, e.DisplacementX, e.DisplacementY, e.DisplacementZ, e.RotationalDisplacementRX, e.RotationalDisplacementRY, e.RotationalDisplacementRZ],
  1973038258: (e) => [e.Name, e.DisplacementX, e.DisplacementY, e.DisplacementZ, e.RotationalDisplacementRX, e.RotationalDisplacementRY, e.RotationalDisplacementRZ, e.Distortion],
  1597423693: (e) => [e.Name, e.ForceX, e.ForceY, e.ForceZ, e.MomentX, e.MomentY, e.MomentZ],
  1190533807: (e) => [e.Name, e.ForceX, e.ForceY, e.ForceZ, e.MomentX, e.MomentY, e.MomentZ, e.WarpingMoment],
  2233826070: (e) => [e.EdgeStart, e.EdgeEnd, e.ParentEdge],
  2513912981: (e) => [],
  1878645084: (e) => [e.SurfaceColour, e.Transparency, ke(e.DiffuseColour), ke(e.TransmissionColour), ke(e.DiffuseTransmissionColour), ke(e.ReflectionColour), ke(e.SpecularColour), (e.SpecularHighlight ?? void 0) === void 0 ? null : ke(e.SpecularHighlight), e.ReflectanceMethod],
  2247615214: (e) => [e.SweptArea, e.Position],
  1260650574: (e) => [e.Directrix, e.Radius, e.InnerRadius, e.StartParam, e.EndParam],
  1096409881: (e) => [e.Directrix, e.Radius, e.InnerRadius, e.StartParam, e.EndParam, e.FilletRadius],
  230924584: (e) => [e.SweptCurve, e.Position],
  3071757647: (e) => [e.ProfileType, e.ProfileName, e.Position, e.Depth, e.FlangeWidth, e.WebThickness, e.FlangeThickness, e.FilletRadius, e.FlangeEdgeRadius, e.WebEdgeRadius, e.WebSlope, e.FlangeSlope],
  901063453: (e) => [],
  4282788508: (e) => [e.Literal, ke(e.Placement), e.Path],
  3124975700: (e) => [e.Literal, ke(e.Placement), e.Path, e.Extent, e.BoxAlignment],
  1983826977: (e) => [e.Name, e.FontFamily, e.FontStyle, e.FontVariant, e.FontWeight, ke(e.FontSize)],
  2715220739: (e) => [e.ProfileType, e.ProfileName, e.Position, e.BottomXDim, e.TopXDim, e.YDim, e.TopXOffset],
  1628702193: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets],
  3736923433: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.Identification, e.LongDescription, e.ProcessType],
  2347495698: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag],
  3698973494: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.Identification, e.LongDescription, e.ResourceType],
  427810014: (e) => [e.ProfileType, e.ProfileName, e.Position, e.Depth, e.FlangeWidth, e.WebThickness, e.FlangeThickness, e.FilletRadius, e.EdgeRadius, e.FlangeSlope],
  1417489154: (e) => [e.Orientation, e.Magnitude],
  2759199220: (e) => [e.LoopVertex],
  2543172580: (e) => [e.ProfileType, e.ProfileName, e.Position, e.Depth, e.FlangeWidth, e.WebThickness, e.FlangeThickness, e.FilletRadius, e.EdgeRadius],
  3406155212: (e) => [e.Bounds, e.FaceSurface, { type: 3, value: e.SameSense.value }],
  669184980: (e) => [e.OuterBoundary, e.InnerBoundaries],
  3207858831: (e) => [e.ProfileType, e.ProfileName, e.Position, e.BottomFlangeWidth, e.OverallDepth, e.WebThickness, e.BottomFlangeThickness, e.BottomFlangeFilletRadius, e.TopFlangeWidth, e.TopFlangeThickness, e.TopFlangeFilletRadius, e.BottomFlangeEdgeRadius, e.BottomFlangeSlope, e.TopFlangeEdgeRadius, e.TopFlangeSlope],
  4261334040: (e) => [e.Location, e.Axis],
  3125803723: (e) => [e.Location, e.RefDirection],
  2740243338: (e) => [e.Location, e.Axis, e.RefDirection],
  3425423356: (e) => [e.Location, e.Axis, e.RefDirection],
  2736907675: (e) => [e.Operator, ke(e.FirstOperand), ke(e.SecondOperand)],
  4182860854: (e) => [],
  2581212453: (e) => [e.Corner, e.XDim, e.YDim, e.ZDim],
  2713105998: (e) => [e.BaseSurface, { type: 3, value: e.AgreementFlag.value }, e.Enclosure],
  2898889636: (e) => [e.ProfileType, e.ProfileName, e.Position, e.Depth, e.Width, e.WallThickness, e.Girth, e.InternalFilletRadius],
  1123145078: (e) => [e.Coordinates],
  574549367: (e) => [],
  1675464909: (e) => [e.CoordList, e.TagList],
  2059837836: (e) => [e.CoordList, e.TagList],
  59481748: (e) => [e.Axis1, e.Axis2, e.LocalOrigin, e.Scale],
  3749851601: (e) => [e.Axis1, e.Axis2, e.LocalOrigin, e.Scale],
  3486308946: (e) => [e.Axis1, e.Axis2, e.LocalOrigin, e.Scale, e.Scale2],
  3331915920: (e) => [e.Axis1, e.Axis2, e.LocalOrigin, e.Scale, e.Axis3],
  1416205885: (e) => [e.Axis1, e.Axis2, e.LocalOrigin, e.Scale, e.Axis3, e.Scale2, e.Scale3],
  1383045692: (e) => [e.ProfileType, e.ProfileName, e.Position, e.Radius],
  2205249479: (e) => [e.CfsFaces],
  776857604: (e) => [e.Name, e.Red, e.Green, e.Blue],
  2542286263: (e) => [e.Name, e.Specification, e.UsageName, e.HasProperties],
  2485617015: (e) => [e.Transition, { type: 3, value: e.SameSense.value }, e.ParentCurve],
  2574617495: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.Identification, e.LongDescription, e.ResourceType, e.BaseCosts, e.BaseQuantity],
  3419103109: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.LongName, e.Phase, e.RepresentationContexts, e.UnitsInContext],
  1815067380: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.Identification, e.LongDescription, e.ResourceType, e.BaseCosts, e.BaseQuantity, e.PredefinedType],
  2506170314: (e) => [e.Position],
  2147822146: (e) => [ke(e.TreeRootExpression)],
  2601014836: (e) => [],
  2827736869: (e) => [e.BasisSurface, e.OuterBoundary, e.InnerBoundaries],
  2629017746: (e) => [e.BasisSurface, e.Boundaries, { type: 3, value: e.ImplicitOuter.value }],
  4212018352: (e) => [e.Transition, e.Placement, ke(e.SegmentStart), ke(e.SegmentLength), e.ParentCurve],
  32440307: (e) => [e.DirectionRatios],
  593015953: (e) => [e.SweptArea, e.Position, e.Directrix, (e.StartParam ?? void 0) === void 0 ? null : ke(e.StartParam), (e.EndParam ?? void 0) === void 0 ? null : ke(e.EndParam)],
  1472233963: (e) => [e.EdgeList],
  1883228015: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.MethodOfMeasurement, e.Quantities],
  339256511: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  2777663545: (e) => [e.Position],
  2835456948: (e) => [e.ProfileType, e.ProfileName, e.Position, e.SemiAxis1, e.SemiAxis2],
  4024345920: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.Identification, e.LongDescription, e.ProcessType, e.PredefinedType, e.EventTriggerType, e.UserDefinedEventTriggerType],
  477187591: (e) => [e.SweptArea, e.Position, e.ExtrudedDirection, e.Depth],
  2804161546: (e) => [e.SweptArea, e.Position, e.ExtrudedDirection, e.Depth, e.EndSweptArea],
  2047409740: (e) => [e.FbsmFaces],
  374418227: (e) => [e.HatchLineAppearance, ke(e.StartOfNextHatchLine), e.PointOfReferenceHatchLine, e.PatternStart, e.HatchLineAngle],
  315944413: (e) => [e.TilingPattern, e.Tiles, e.TilingScale],
  2652556860: (e) => [e.SweptArea, e.Position, e.Directrix, (e.StartParam ?? void 0) === void 0 ? null : ke(e.StartParam), (e.EndParam ?? void 0) === void 0 ? null : ke(e.EndParam), e.FixedReference],
  4238390223: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  1268542332: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.AssemblyPlace, e.PredefinedType],
  4095422895: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  987898635: (e) => [ke(e.Elements)],
  1484403080: (e) => [e.ProfileType, e.ProfileName, e.Position, e.OverallWidth, e.OverallDepth, e.WebThickness, e.FlangeThickness, e.FilletRadius, e.FlangeEdgeRadius, e.FlangeSlope],
  178912537: (e) => [e.CoordIndex],
  2294589976: (e) => [e.CoordIndex, e.InnerCoordIndices],
  3465909080: (e) => [e.Maps, e.MappedTo, e.TexCoords, e.TexCoordIndices],
  572779678: (e) => [e.ProfileType, e.ProfileName, e.Position, e.Depth, e.Width, e.Thickness, e.FilletRadius, e.EdgeRadius, e.LegSlope],
  428585644: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.Identification, e.LongDescription, e.ResourceType, e.BaseCosts, e.BaseQuantity, e.PredefinedType],
  1281925730: (e) => [e.Pnt, e.Dir],
  1425443689: (e) => [e.Outer],
  3888040117: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType],
  590820931: (e) => [e.BasisCurve],
  3388369263: (e) => [e.BasisCurve, e.Distance, { type: 3, value: e.SelfIntersect.value }],
  3505215534: (e) => [e.BasisCurve, e.Distance, { type: 3, value: e.SelfIntersect.value }, e.RefDirection],
  2485787929: (e) => [e.BasisCurve, e.OffsetValues, e.Tag],
  1682466193: (e) => [e.BasisSurface, e.ReferenceCurve],
  603570806: (e) => [e.SizeInX, e.SizeInY, ke(e.Placement)],
  220341763: (e) => [e.Position],
  3381221214: (e) => [e.Position, e.CoefficientsX, e.CoefficientsY, e.CoefficientsZ],
  759155922: (e) => [e.Name],
  2559016684: (e) => [e.Name],
  3967405729: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description],
  569719735: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.Identification, e.LongDescription, e.ProcessType, e.PredefinedType],
  2945172077: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.LongDescription],
  4208778838: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation],
  103090709: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.LongName, e.Phase, e.RepresentationContexts, e.UnitsInContext],
  653396225: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.LongName, e.Phase, e.RepresentationContexts, e.UnitsInContext],
  871118103: (e) => [e.Name, e.Specification, (e.UpperBoundValue ?? void 0) === void 0 ? null : ke(e.UpperBoundValue), (e.LowerBoundValue ?? void 0) === void 0 ? null : ke(e.LowerBoundValue), ke(e.Unit), (e.SetPointValue ?? void 0) === void 0 ? null : ke(e.SetPointValue)],
  4166981789: (e) => [e.Name, e.Specification, (e.EnumerationValues ?? void 0) === void 0 ? null : e.EnumerationValues.map((t) => ke(t)), e.EnumerationReference],
  2752243245: (e) => [e.Name, e.Specification, (e.ListValues ?? void 0) === void 0 ? null : e.ListValues.map((t) => ke(t)), ke(e.Unit)],
  941946838: (e) => [e.Name, e.Specification, e.UsageName, ke(e.PropertyReference)],
  1451395588: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.HasProperties],
  492091185: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.TemplateType, e.ApplicableEntity, e.HasPropertyTemplates],
  3650150729: (e) => [e.Name, e.Specification, (e.NominalValue ?? void 0) === void 0 ? null : ke(e.NominalValue), ke(e.Unit)],
  110355661: (e) => [e.Name, e.Specification, (e.DefiningValues ?? void 0) === void 0 ? null : e.DefiningValues.map((t) => ke(t)), (e.DefinedValues ?? void 0) === void 0 ? null : e.DefinedValues.map((t) => ke(t)), e.Expression, ke(e.DefiningUnit), ke(e.DefinedUnit), e.CurveInterpolation],
  3521284610: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description],
  2770003689: (e) => [e.ProfileType, e.ProfileName, e.Position, e.XDim, e.YDim, e.WallThickness, e.InnerFilletRadius, e.OuterFilletRadius],
  2798486643: (e) => [e.Position, e.XLength, e.YLength, e.Height],
  3454111270: (e) => [e.BasisSurface, e.U1, e.V1, e.U2, e.V2, { type: 3, value: e.Usense.value }, { type: 3, value: e.Vsense.value }],
  3765753017: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.DefinitionType, e.ReinforcementSectionDefinitions],
  3939117080: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatedObjectsType],
  1683148259: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatedObjectsType, e.RelatingActor, e.ActingRole],
  2495723537: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatedObjectsType, e.RelatingControl],
  1307041759: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatedObjectsType, e.RelatingGroup],
  1027710054: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatedObjectsType, e.RelatingGroup, e.Factor],
  4278684876: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatedObjectsType, ke(e.RelatingProcess), e.QuantityInProcess],
  2857406711: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatedObjectsType, ke(e.RelatingProduct)],
  205026976: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatedObjectsType, ke(e.RelatingResource)],
  1865459582: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, ke(e.RelatedObjects)],
  4095574036: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, ke(e.RelatedObjects), e.RelatingApproval],
  919958153: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, ke(e.RelatedObjects), ke(e.RelatingClassification)],
  2728634034: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, ke(e.RelatedObjects), e.Intent, e.RelatingConstraint],
  982818633: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, ke(e.RelatedObjects), ke(e.RelatingDocument)],
  3840914261: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, ke(e.RelatedObjects), ke(e.RelatingLibrary)],
  2655215786: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, ke(e.RelatedObjects), ke(e.RelatingMaterial)],
  1033248425: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, ke(e.RelatedObjects), e.RelatingProfileDef],
  826625072: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description],
  1204542856: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ConnectionGeometry, e.RelatingElement, e.RelatedElement],
  3945020480: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ConnectionGeometry, e.RelatingElement, e.RelatedElement, e.RelatingPriorities, e.RelatedPriorities, e.RelatedConnectionType, e.RelatingConnectionType],
  4201705270: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingPort, e.RelatedElement],
  3190031847: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingPort, e.RelatedPort, e.RealizingElement],
  2127690289: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, ke(e.RelatingElement), e.RelatedStructuralActivity],
  1638771189: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingStructuralMember, e.RelatedStructuralConnection, e.AppliedCondition, e.AdditionalConditions, e.SupportedLength, e.ConditionCoordinateSystem],
  504942748: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingStructuralMember, e.RelatedStructuralConnection, e.AppliedCondition, e.AdditionalConditions, e.SupportedLength, e.ConditionCoordinateSystem, e.ConnectionConstraint],
  3678494232: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ConnectionGeometry, e.RelatingElement, e.RelatedElement, e.RealizingElements, e.ConnectionType],
  3242617779: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedElements, e.RelatingStructure],
  886880790: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingBuildingElement, e.RelatedCoverings],
  2802773753: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingSpace, e.RelatedCoverings],
  2565941209: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingContext, ke(e.RelatedDefinitions)],
  2551354335: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description],
  693640335: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description],
  1462361463: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatingObject],
  4186316022: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, ke(e.RelatingPropertyDefinition)],
  307848117: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedPropertySets, e.RelatingTemplate],
  781010003: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedObjects, e.RelatingType],
  3940055652: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingOpeningElement, e.RelatedBuildingElement],
  279856033: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatedControlElements, e.RelatingFlowElement],
  427948657: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, ke(e.RelatingElement), ke(e.RelatedElement), e.InterferenceGeometry, e.InterferenceSpace, e.InterferenceType, { type: 3, value: e.ImpliedOrder.value }],
  3268803585: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingObject, e.RelatedObjects],
  1441486842: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingPositioningElement, e.RelatedProducts],
  750771296: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingElement, e.RelatedFeatureElement],
  1245217292: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, ke(e.RelatedElements), e.RelatingStructure],
  4122056220: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingProcess, e.RelatedProcess, e.TimeLag, e.SequenceType, e.UserDefinedSequenceType],
  366585022: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingSystem, e.RelatedBuildings],
  3451746338: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, ke(e.RelatingSpace), e.RelatedBuildingElement, e.ConnectionGeometry, e.PhysicalOrVirtualBoundary, e.InternalOrExternalBoundary],
  3523091289: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, ke(e.RelatingSpace), e.RelatedBuildingElement, e.ConnectionGeometry, e.PhysicalOrVirtualBoundary, e.InternalOrExternalBoundary, e.ParentBoundary],
  1521410863: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, ke(e.RelatingSpace), e.RelatedBuildingElement, e.ConnectionGeometry, e.PhysicalOrVirtualBoundary, e.InternalOrExternalBoundary, e.ParentBoundary, e.CorrespondingBoundary],
  1401173127: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingBuildingElement, e.RelatedOpeningElement],
  816062949: (e) => [e.Transition, { type: 3, value: e.SameSense.value }, e.ParentCurve, e.ParamLength],
  2914609552: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.LongDescription],
  1856042241: (e) => [e.SweptArea, e.Position, e.Axis, e.Angle],
  3243963512: (e) => [e.SweptArea, e.Position, e.Axis, e.Angle, e.EndSweptArea],
  4158566097: (e) => [e.Position, e.Height, e.BottomRadius],
  3626867408: (e) => [e.Position, e.Height, e.Radius],
  1862484736: (e) => [e.Directrix, e.CrossSections],
  1290935644: (e) => [e.Directrix, e.CrossSections, e.CrossSectionPositions],
  1356537516: (e) => [e.Directrix, e.CrossSectionPositions, e.CrossSections],
  3663146110: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.TemplateType, e.PrimaryMeasureType, e.SecondaryMeasureType, e.Enumerators, ke(e.PrimaryUnit), ke(e.SecondaryUnit), e.Expression, e.AccessState],
  1412071761: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName],
  710998568: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  2706606064: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName, e.CompositionType],
  3893378262: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  463610769: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName, e.PredefinedType],
  2481509218: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType, e.LongName],
  451544542: (e) => [e.Position, e.Radius],
  4015995234: (e) => [e.Position, e.Radius],
  2735484536: (e) => [ke(e.Position)],
  3544373492: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedLoad, e.GlobalOrLocal],
  3136571912: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation],
  530289379: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation],
  3689010777: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedLoad, e.GlobalOrLocal],
  3979015343: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.PredefinedType, e.Thickness],
  2218152070: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.PredefinedType, e.Thickness],
  603775116: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedLoad, e.GlobalOrLocal, e.PredefinedType],
  4095615324: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.Identification, e.LongDescription, e.ResourceType, e.BaseCosts, e.BaseQuantity, e.PredefinedType],
  699246055: (e) => [e.Curve3D, e.AssociatedGeometry, e.MasterRepresentation],
  2028607225: (e) => [e.SweptArea, e.Position, e.Directrix, (e.StartParam ?? void 0) === void 0 ? null : ke(e.StartParam), (e.EndParam ?? void 0) === void 0 ? null : ke(e.EndParam), e.ReferenceSurface],
  2809605785: (e) => [e.SweptCurve, e.Position, e.ExtrudedDirection, e.Depth],
  4124788165: (e) => [e.SweptCurve, e.Position, e.AxisPosition],
  1580310250: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3473067441: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.LongDescription, e.Status, e.WorkMethod, { type: 3, value: e.IsMilestone.value }, e.Priority, e.TaskTime, e.PredefinedType],
  3206491090: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.Identification, e.LongDescription, e.ProcessType, e.PredefinedType, e.WorkMethod],
  2387106220: (e) => [e.Coordinates, e.Closed == null ? null : { type: 3, value: e.Closed.value }],
  782932809: (e) => [ke(e.Position), e.CubicTerm, e.QuadraticTerm, e.LinearTerm, e.ConstantTerm],
  1935646853: (e) => [e.Position, e.MajorRadius, e.MinorRadius],
  3665877780: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  2916149573: (e) => [e.Coordinates, e.Closed == null ? null : { type: 3, value: e.Closed.value }, e.Normals, e.CoordIndex, e.PnIndex],
  1229763772: (e) => [e.Coordinates, e.Closed == null ? null : { type: 3, value: e.Closed.value }, e.Normals, e.CoordIndex, e.PnIndex, e.Flags],
  3651464721: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  336235671: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.LiningDepth, e.LiningThickness, e.TransomThickness, e.MullionThickness, e.FirstTransomOffset, e.SecondTransomOffset, e.FirstMullionOffset, e.SecondMullionOffset, e.ShapeAspectStyle, e.LiningOffset, e.LiningToPanelOffsetX, e.LiningToPanelOffsetY],
  512836454: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.OperationType, e.PanelPosition, e.FrameDepth, e.FrameThickness, e.ShapeAspectStyle],
  2296667514: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, ke(e.TheActor)],
  1635779807: (e) => [e.Outer],
  2603310189: (e) => [e.Outer, e.Voids],
  1674181508: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.PredefinedType],
  2887950389: (e) => [e.UDegree, e.VDegree, e.ControlPointsList, e.SurfaceForm, { type: 3, value: e.UClosed.value }, { type: 3, value: e.VClosed.value }, { type: 3, value: e.SelfIntersect.value }],
  167062518: (e) => [e.UDegree, e.VDegree, e.ControlPointsList, e.SurfaceForm, { type: 3, value: e.UClosed.value }, { type: 3, value: e.VClosed.value }, { type: 3, value: e.SelfIntersect.value }, e.UMultiplicities, e.VMultiplicities, e.UKnots, e.VKnots, e.KnotSpec],
  1334484129: (e) => [e.Position, e.XLength, e.YLength, e.ZLength],
  3649129432: (e) => [e.Operator, ke(e.FirstOperand), ke(e.SecondOperand)],
  1260505505: (e) => [],
  3124254112: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName, e.CompositionType, e.Elevation],
  1626504194: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  2197970202: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2937912522: (e) => [e.ProfileType, e.ProfileName, e.Position, e.Radius, e.WallThickness],
  3893394355: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  3497074424: (e) => [ke(e.Position), e.ClothoidConstant],
  300633059: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3875453745: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.UsageName, e.TemplateType, e.HasPropertyTemplates],
  3732776249: (e) => [e.Segments, { type: 3, value: e.SelfIntersect.value }],
  15328376: (e) => [e.Segments, { type: 3, value: e.SelfIntersect.value }],
  2510884976: (e) => [ke(e.Position)],
  2185764099: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.Identification, e.LongDescription, e.ResourceType, e.BaseCosts, e.BaseQuantity, e.PredefinedType],
  4105962743: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.Identification, e.LongDescription, e.ResourceType, e.BaseCosts, e.BaseQuantity, e.PredefinedType],
  1525564444: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.Identification, e.LongDescription, e.ResourceType, e.BaseCosts, e.BaseQuantity, e.PredefinedType],
  2559216714: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.LongDescription, e.Usage, e.BaseCosts, e.BaseQuantity],
  3293443760: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification],
  2000195564: (e) => [ke(e.Position), e.CosineTerm, e.ConstantTerm],
  3895139033: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.PredefinedType, e.CostValues, e.CostQuantities],
  1419761937: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.PredefinedType, e.Status, e.SubmittedOn, e.UpdateDate],
  4189326743: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1916426348: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3295246426: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.LongDescription, e.Usage, e.BaseCosts, e.BaseQuantity, e.PredefinedType],
  1457835157: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1213902940: (e) => [e.Position, e.Radius],
  1306400036: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  4234616927: (e) => [e.SweptArea, e.Position, e.Directrix, (e.StartParam ?? void 0) === void 0 ? null : ke(e.StartParam), (e.EndParam ?? void 0) === void 0 ? null : ke(e.EndParam), e.FixedReference],
  3256556792: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  3849074793: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  2963535650: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.LiningDepth, e.LiningThickness, e.ThresholdDepth, e.ThresholdThickness, e.TransomThickness, e.TransomOffset, e.LiningOffset, e.ThresholdOffset, e.CasingThickness, e.CasingDepth, e.ShapeAspectStyle, e.LiningToPanelOffsetX, e.LiningToPanelOffsetY],
  1714330368: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.PanelDepth, e.PanelOperation, e.PanelWidth, e.PanelPosition, e.ShapeAspectStyle],
  2323601079: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType, e.OperationType, e.ParameterTakesPrecedence == null ? null : { type: 3, value: e.ParameterTakesPrecedence.value }, e.UserDefinedOperationType],
  445594917: (e) => [e.Name],
  4006246654: (e) => [e.Name],
  1758889154: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  4123344466: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.AssemblyPlace, e.PredefinedType],
  2397081782: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1623761950: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  2590856083: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  1704287377: (e) => [ke(e.Position), e.SemiAxis1, e.SemiAxis2],
  2107101300: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  132023988: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3174744832: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3390157468: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  4148101412: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.LongDescription, e.PredefinedType, e.EventTriggerType, e.UserDefinedEventTriggerType, e.EventOccurenceTime],
  2853485674: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName],
  807026263: (e) => [e.Outer],
  3737207727: (e) => [e.Outer, e.Voids],
  24185140: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName, e.CompositionType],
  1310830890: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName, e.CompositionType, e.UsageType],
  4228831410: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName, e.CompositionType, e.UsageType, e.PredefinedType],
  647756555: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2489546625: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2827207264: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  2143335405: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  1287392070: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  3907093117: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  3198132628: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  3815607619: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1482959167: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  1834744321: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  1339347760: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  2297155007: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  3009222698: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  1893162501: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  263784265: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  1509553395: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3493046030: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  4230923436: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  1594536857: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2898700619: (e) => [e.Segments, { type: 3, value: e.SelfIntersect.value }, e.BaseCurve, e.EndPoint],
  2706460486: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType],
  1251058090: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1806887404: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2568555532: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3948183225: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2571569899: (e) => [e.Points, (e.Segments ?? void 0) === void 0 ? null : e.Segments.map((t) => ke(t)), { type: 3, value: e.SelfIntersect.value }],
  3946677679: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3113134337: (e) => [e.Curve3D, e.AssociatedGeometry, e.MasterRepresentation],
  2391368822: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.PredefinedType, ke(e.Jurisdiction), e.ResponsiblePersons, e.LastUpdateDate, e.CurrentValue, e.OriginalValue],
  4288270099: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  679976338: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, { type: 3, value: e.Mountable.value }],
  3827777499: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.LongDescription, e.Usage, e.BaseCosts, e.BaseQuantity, e.PredefinedType],
  1051575348: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1161773419: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2176059722: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation],
  1770583370: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  525669439: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName, e.CompositionType, e.PredefinedType],
  976884017: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName, e.CompositionType, e.UsageType, e.PredefinedType],
  377706215: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.NominalDiameter, e.NominalLength, e.PredefinedType],
  2108223431: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType, e.NominalDiameter, e.NominalLength],
  1114901282: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3181161470: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1950438474: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  710110818: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  977012517: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  506776471: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  4143007308: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, ke(e.TheActor), e.PredefinedType],
  3588315303: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2837617999: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  514975943: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2382730787: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.LifeCyclePhase, e.PredefinedType],
  3566463478: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.OperationType, e.PanelPosition, e.FrameDepth, e.FrameThickness, e.ShapeAspectStyle],
  3327091369: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.PredefinedType, e.Status, e.LongDescription],
  1158309216: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  804291784: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  4231323485: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  4017108033: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2839578677: (e) => [e.Coordinates, e.Closed == null ? null : { type: 3, value: e.Closed.value }, e.Faces, e.PnIndex],
  3724593414: (e) => [e.Points],
  3740093272: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation],
  1946335990: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation],
  2744685151: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.LongDescription, e.PredefinedType],
  2904328755: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.PredefinedType, e.Status, e.LongDescription],
  3651124850: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1842657554: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2250791053: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1763565496: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2893384427: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3992365140: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName, e.CompositionType, e.PredefinedType],
  1891881377: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName, e.CompositionType, e.UsageType, e.PredefinedType],
  2324767716: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1469900589: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  683857671: (e) => [e.UDegree, e.VDegree, e.ControlPointsList, e.SurfaceForm, { type: 3, value: e.UClosed.value }, { type: 3, value: e.VClosed.value }, { type: 3, value: e.SelfIntersect.value }, e.UMultiplicities, e.VMultiplicities, e.UKnots, e.VKnots, e.KnotSpec, e.WeightsData],
  4021432810: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.PredefinedType],
  3027567501: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.SteelGrade],
  964333572: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  2320036040: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.SteelGrade, e.MeshLength, e.MeshWidth, e.LongitudinalBarNominalDiameter, e.TransverseBarNominalDiameter, e.LongitudinalBarCrossSectionArea, e.TransverseBarCrossSectionArea, e.LongitudinalBarSpacing, e.TransverseBarSpacing, e.PredefinedType],
  2310774935: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType, e.MeshLength, e.MeshWidth, e.LongitudinalBarNominalDiameter, e.TransverseBarNominalDiameter, e.LongitudinalBarCrossSectionArea, e.TransverseBarCrossSectionArea, e.LongitudinalBarSpacing, e.TransverseBarSpacing, e.BendingShapeCode, (e.BendingParameters ?? void 0) === void 0 ? null : e.BendingParameters.map((t) => ke(t))],
  3818125796: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingElement, e.RelatedSurfaceFeatures],
  160246688: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.RelatingObject, e.RelatedObjects],
  146592293: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName, e.CompositionType, e.PredefinedType],
  550521510: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName, e.CompositionType, e.UsageType, e.PredefinedType],
  2781568857: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1768891740: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2157484638: (e) => [e.Curve3D, e.AssociatedGeometry, e.MasterRepresentation],
  3649235739: (e) => [ke(e.Position), e.QuadraticTerm, e.LinearTerm, e.ConstantTerm],
  544395925: (e) => [e.Segments, { type: 3, value: e.SelfIntersect.value }, e.BaseCurve, e.EndPoint],
  1027922057: (e) => [ke(e.Position), e.SepticTerm, e.SexticTerm, e.QuinticTerm, e.QuarticTerm, e.CubicTerm, e.QuadraticTerm, e.LinearTerm, e.ConstantTerm],
  4074543187: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  33720170: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3599934289: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1894708472: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  42703149: (e) => [ke(e.Position), e.SineTerm, e.LinearTerm, e.ConstantTerm],
  4097777520: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName, e.CompositionType, e.RefLatitude, e.RefLongitude, e.RefElevation, e.LandTitleNumber, e.SiteAddress],
  2533589738: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1072016465: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3856911033: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName, e.CompositionType, e.PredefinedType, e.ElevationWithFlooring],
  1305183839: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3812236995: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType, e.LongName],
  3112655638: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1039846685: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  338393293: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  682877961: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedLoad, e.GlobalOrLocal, e.DestabilizingLoad == null ? null : { type: 3, value: e.DestabilizingLoad.value }],
  1179482911: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedCondition],
  1004757350: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedLoad, e.GlobalOrLocal, e.DestabilizingLoad == null ? null : { type: 3, value: e.DestabilizingLoad.value }, e.ProjectedOrTrue, e.PredefinedType],
  4243806635: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedCondition, e.AxisDirection],
  214636428: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.PredefinedType, e.Axis],
  2445595289: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.PredefinedType, e.Axis],
  2757150158: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedLoad, e.GlobalOrLocal, e.PredefinedType],
  1807405624: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedLoad, e.GlobalOrLocal, e.DestabilizingLoad == null ? null : { type: 3, value: e.DestabilizingLoad.value }, e.ProjectedOrTrue, e.PredefinedType],
  1252848954: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.PredefinedType, e.ActionType, e.ActionSource, e.Coefficient, e.Purpose],
  2082059205: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedLoad, e.GlobalOrLocal, e.DestabilizingLoad == null ? null : { type: 3, value: e.DestabilizingLoad.value }],
  734778138: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedCondition, e.ConditionCoordinateSystem],
  1235345126: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedLoad, e.GlobalOrLocal],
  2986769608: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.TheoryType, e.ResultForLoadGroup, { type: 3, value: e.IsLinear.value }],
  3657597509: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedLoad, e.GlobalOrLocal, e.DestabilizingLoad == null ? null : { type: 3, value: e.DestabilizingLoad.value }, e.ProjectedOrTrue, e.PredefinedType],
  1975003073: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedCondition],
  148013059: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.LongDescription, e.Usage, e.BaseCosts, e.BaseQuantity, e.PredefinedType],
  3101698114: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2315554128: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2254336722: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType],
  413509423: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  5716631: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3824725483: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.SteelGrade, e.PredefinedType, e.NominalDiameter, e.CrossSectionArea, e.TensionForce, e.PreStress, e.FrictionCoefficient, e.AnchorageSlip, e.MinCurvatureRadius],
  2347447852: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.SteelGrade, e.PredefinedType],
  3081323446: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3663046924: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.SteelGrade, e.PredefinedType],
  2281632017: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2415094496: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType, e.NominalDiameter, e.CrossSectionArea, e.SheathDiameter],
  618700268: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1692211062: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2097647324: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1953115116: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  3593883385: (e) => [e.BasisCurve, ke(e.Trim1), ke(e.Trim2), { type: 3, value: e.SenseAgreement.value }, e.MasterRepresentation],
  1600972822: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1911125066: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  728799441: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  840318589: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1530820697: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3956297820: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2391383451: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3313531582: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2769231204: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  926996030: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1898987631: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1133259667: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  4009809668: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType, e.PartitioningType, e.ParameterTakesPrecedence == null ? null : { type: 3, value: e.ParameterTakesPrecedence.value }, e.UserDefinedPartitioningType],
  4088093105: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.WorkingTimes, e.ExceptionTimes, e.PredefinedType],
  1028945134: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.CreationDate, e.Creators, e.Purpose, e.Duration, e.TotalFloat, e.StartTime, e.FinishTime],
  4218914973: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.CreationDate, e.Creators, e.Purpose, e.Duration, e.TotalFloat, e.StartTime, e.FinishTime, e.PredefinedType],
  3342526732: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.CreationDate, e.Creators, e.Purpose, e.Duration, e.TotalFloat, e.StartTime, e.FinishTime, e.PredefinedType],
  1033361043: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.LongName],
  3821786052: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.PredefinedType, e.Status, e.LongDescription],
  1411407467: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3352864051: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1871374353: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  4266260250: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.RailHeadDistance],
  1545765605: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation],
  317615605: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.DesignParameters],
  1662888072: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation],
  3460190687: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.OriginalValue, e.CurrentValue, e.TotalReplacementCost, ke(e.Owner), ke(e.User), e.ResponsiblePerson, e.IncorporationDate, e.DepreciatedValue],
  1532957894: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1967976161: (e) => [e.Degree, e.ControlPointsList, e.CurveForm, { type: 3, value: e.ClosedCurve.value }, { type: 3, value: e.SelfIntersect.value }],
  2461110595: (e) => [e.Degree, e.ControlPointsList, e.CurveForm, { type: 3, value: e.ClosedCurve.value }, { type: 3, value: e.SelfIntersect.value }, e.KnotMultiplicities, e.Knots, e.KnotSpec],
  819618141: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3649138523: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  231477066: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1136057603: (e) => [e.Segments, { type: 3, value: e.SelfIntersect.value }],
  644574406: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName, e.CompositionType, e.PredefinedType],
  963979645: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName, e.CompositionType, e.UsageType, e.PredefinedType],
  4031249490: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName, e.CompositionType, e.ElevationOfRefHeight, e.ElevationOfTerrain, e.BuildingAddress],
  2979338954: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  39481116: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1909888760: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1177604601: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.PredefinedType, e.LongName],
  1876633798: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  3862327254: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.PredefinedType, e.LongName],
  2188180465: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  395041908: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3293546465: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2674252688: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1285652485: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3203706013: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2951183804: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3296154744: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2611217952: (e) => [ke(e.Position), e.Radius],
  1677625105: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  2301859152: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  843113511: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  400855858: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3850581409: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2816379211: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3898045240: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.LongDescription, e.Usage, e.BaseCosts, e.BaseQuantity, e.PredefinedType],
  1060000209: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.LongDescription, e.Usage, e.BaseCosts, e.BaseQuantity, e.PredefinedType],
  488727124: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.Identification, e.LongDescription, e.Usage, e.BaseCosts, e.BaseQuantity, e.PredefinedType],
  2940368186: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  335055490: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2954562838: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1502416096: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1973544240: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3495092785: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3961806047: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3426335179: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  1335981549: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2635815018: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  479945903: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1599208980: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2063403501: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType],
  1945004755: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  3040386961: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  3041715199: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.FlowDirection, e.PredefinedType, e.SystemType],
  3205830791: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.LongName, e.PredefinedType],
  395920057: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.OverallHeight, e.OverallWidth, e.PredefinedType, e.OperationType, e.UserDefinedOperationType],
  869906466: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3760055223: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2030761528: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3071239417: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1077100507: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  3376911765: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  663422040: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2417008758: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3277789161: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2142170206: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1534661035: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1217240411: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  712377611: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1658829314: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  2814081492: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3747195512: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  484807127: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1209101575: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.LongName, e.PredefinedType],
  346874300: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1810631287: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  4222183408: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2058353004: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  4278956645: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  4037862832: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  2188021234: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3132237377: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  987401354: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  707683696: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  2223149337: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  3508470533: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  900683007: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2713699986: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  3009204131: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.UAxes, e.VAxes, e.WAxes, e.PredefinedType],
  3319311131: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2068733104: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  4175244083: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2176052936: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2696325953: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, { type: 3, value: e.Mountable.value }],
  76236018: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  629592764: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1154579445: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation],
  1638804497: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1437502449: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1073191201: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2078563270: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  234836483: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2474470126: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2182337498: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  144952367: (e) => [e.Segments, { type: 3, value: e.SelfIntersect.value }],
  3694346114: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1383356374: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1687234759: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType, e.ConstructionType],
  310824031: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3612865200: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3171933400: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  738039164: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  655969474: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  90941305: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3290496277: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2262370178: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3024970846: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3283111854: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1232101972: (e) => [e.Degree, e.ControlPointsList, e.CurveForm, { type: 3, value: e.ClosedCurve.value }, { type: 3, value: e.SelfIntersect.value }, e.KnotMultiplicities, e.Knots, e.KnotSpec, e.WeightsData],
  3798194928: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  979691226: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.SteelGrade, e.NominalDiameter, e.CrossSectionArea, e.BarLength, e.PredefinedType, e.BarSurface],
  2572171363: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType, e.NominalDiameter, e.CrossSectionArea, e.BarLength, e.BarSurface, e.BendingShapeCode, (e.BendingParameters ?? void 0) === void 0 ? null : e.BendingParameters.map((t) => ke(t))],
  2016517767: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3053780830: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1783015770: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1329646415: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  991950508: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1529196076: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3420628829: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1999602285: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1404847402: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  331165859: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  4252922144: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.NumberOfRisers, e.NumberOfTreads, e.RiserHeight, e.TreadLength, e.PredefinedType],
  2515109513: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.PredefinedType, e.OrientationOf2DPlane, e.LoadedBy, e.HasResults, e.SharedPlacement],
  385403989: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.PredefinedType, e.ActionType, e.ActionSource, e.Coefficient, e.Purpose, e.SelfWeightCoefficients],
  1621171031: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.AppliedLoad, e.GlobalOrLocal, e.DestabilizingLoad == null ? null : { type: 3, value: e.DestabilizingLoad.value }, e.ProjectedOrTrue, e.PredefinedType],
  1162798199: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  812556717: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3425753595: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3825984169: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1620046519: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3026737570: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3179687236: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  4292641817: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  4207607924: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2391406946: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3512223829: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  4237592921: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3304561284: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.OverallHeight, e.OverallWidth, e.PredefinedType, e.PartitioningType, e.UserDefinedPartitioningType],
  2874132201: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  1634111441: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  177149247: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2056796094: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3001207471: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  325726236: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.PredefinedType],
  277319702: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  753842376: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  4196446775: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  32344328: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3314249567: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  1095909175: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2938176219: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  635142910: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3758799889: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1051757585: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  4217484030: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3999819293: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3902619387: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  639361253: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3221913625: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3571504051: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2272882330: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  578613899: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ApplicableOccurrence, e.HasPropertySets, e.RepresentationMaps, e.Tag, e.ElementType, e.PredefinedType],
  3460952963: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  4136498852: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3640358203: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  4074379575: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3693000487: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1052013943: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  562808652: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.LongName, e.PredefinedType],
  1062813311: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  342316401: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3518393246: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1360408905: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1904799276: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  862014818: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3310460725: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  24726584: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  264262732: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  402227799: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1003880860: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3415622556: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  819412036: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  1426591983: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  182646315: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  2680139844: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  1971632696: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag],
  2295281155: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  4086658281: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  630975310: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  4288193352: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  3087945054: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType],
  25142252: (e) => [e.GlobalId, e.OwnerHistory, e.Name, e.Description, e.ObjectType, e.ObjectPlacement, e.Representation, e.Tag, e.PredefinedType]
};
AH[3] = {
  3699917729: (e) => new a.IfcAbsorbedDoseMeasure(e),
  4182062534: (e) => new a.IfcAccelerationMeasure(e),
  360377573: (e) => new a.IfcAmountOfSubstanceMeasure(e),
  632304761: (e) => new a.IfcAngularVelocityMeasure(e),
  3683503648: (e) => new a.IfcArcIndex(e.map((t) => t.value)),
  1500781891: (e) => new a.IfcAreaDensityMeasure(e),
  2650437152: (e) => new a.IfcAreaMeasure(e),
  2314439260: (e) => new a.IfcBinary(e),
  2735952531: (e) => new a.IfcBoolean(e),
  1867003952: (e) => new a.IfcBoxAlignment(e),
  1683019596: (e) => new a.IfcCardinalPointReference(e),
  2991860651: (e) => new a.IfcComplexNumber(e.map((t) => t.value)),
  3812528620: (e) => new a.IfcCompoundPlaneAngleMeasure(e.map((t) => t.value)),
  3238673880: (e) => new a.IfcContextDependentMeasure(e),
  1778710042: (e) => new a.IfcCountMeasure(e),
  94842927: (e) => new a.IfcCurvatureMeasure(e),
  937566702: (e) => new a.IfcDate(e),
  2195413836: (e) => new a.IfcDateTime(e),
  86635668: (e) => new a.IfcDayInMonthNumber(e),
  3701338814: (e) => new a.IfcDayInWeekNumber(e),
  1514641115: (e) => new a.IfcDescriptiveMeasure(e),
  4134073009: (e) => new a.IfcDimensionCount(e),
  524656162: (e) => new a.IfcDoseEquivalentMeasure(e),
  2541165894: (e) => new a.IfcDuration(e),
  69416015: (e) => new a.IfcDynamicViscosityMeasure(e),
  1827137117: (e) => new a.IfcElectricCapacitanceMeasure(e),
  3818826038: (e) => new a.IfcElectricChargeMeasure(e),
  2093906313: (e) => new a.IfcElectricConductanceMeasure(e),
  3790457270: (e) => new a.IfcElectricCurrentMeasure(e),
  2951915441: (e) => new a.IfcElectricResistanceMeasure(e),
  2506197118: (e) => new a.IfcElectricVoltageMeasure(e),
  2078135608: (e) => new a.IfcEnergyMeasure(e),
  1102727119: (e) => new a.IfcFontStyle(e),
  2715512545: (e) => new a.IfcFontVariant(e),
  2590844177: (e) => new a.IfcFontWeight(e),
  1361398929: (e) => new a.IfcForceMeasure(e),
  3044325142: (e) => new a.IfcFrequencyMeasure(e),
  3064340077: (e) => new a.IfcGloballyUniqueId(e),
  3113092358: (e) => new a.IfcHeatFluxDensityMeasure(e),
  1158859006: (e) => new a.IfcHeatingValueMeasure(e),
  983778844: (e) => new a.IfcIdentifier(e),
  3358199106: (e) => new a.IfcIlluminanceMeasure(e),
  2679005408: (e) => new a.IfcInductanceMeasure(e),
  1939436016: (e) => new a.IfcInteger(e),
  3809634241: (e) => new a.IfcIntegerCountRateMeasure(e),
  3686016028: (e) => new a.IfcIonConcentrationMeasure(e),
  3192672207: (e) => new a.IfcIsothermalMoistureCapacityMeasure(e),
  2054016361: (e) => new a.IfcKinematicViscosityMeasure(e),
  3258342251: (e) => new a.IfcLabel(e),
  1275358634: (e) => new a.IfcLanguageId(e),
  1243674935: (e) => new a.IfcLengthMeasure(e),
  1774176899: (e) => new a.IfcLineIndex(e.map((t) => t.value)),
  191860431: (e) => new a.IfcLinearForceMeasure(e),
  2128979029: (e) => new a.IfcLinearMomentMeasure(e),
  1307019551: (e) => new a.IfcLinearStiffnessMeasure(e),
  3086160713: (e) => new a.IfcLinearVelocityMeasure(e),
  503418787: (e) => new a.IfcLogical(e),
  2095003142: (e) => new a.IfcLuminousFluxMeasure(e),
  2755797622: (e) => new a.IfcLuminousIntensityDistributionMeasure(e),
  151039812: (e) => new a.IfcLuminousIntensityMeasure(e),
  286949696: (e) => new a.IfcMagneticFluxDensityMeasure(e),
  2486716878: (e) => new a.IfcMagneticFluxMeasure(e),
  1477762836: (e) => new a.IfcMassDensityMeasure(e),
  4017473158: (e) => new a.IfcMassFlowRateMeasure(e),
  3124614049: (e) => new a.IfcMassMeasure(e),
  3531705166: (e) => new a.IfcMassPerLengthMeasure(e),
  3341486342: (e) => new a.IfcModulusOfElasticityMeasure(e),
  2173214787: (e) => new a.IfcModulusOfLinearSubgradeReactionMeasure(e),
  1052454078: (e) => new a.IfcModulusOfRotationalSubgradeReactionMeasure(e),
  1753493141: (e) => new a.IfcModulusOfSubgradeReactionMeasure(e),
  3177669450: (e) => new a.IfcMoistureDiffusivityMeasure(e),
  1648970520: (e) => new a.IfcMolecularWeightMeasure(e),
  3114022597: (e) => new a.IfcMomentOfInertiaMeasure(e),
  2615040989: (e) => new a.IfcMonetaryMeasure(e),
  765770214: (e) => new a.IfcMonthInYearNumber(e),
  525895558: (e) => new a.IfcNonNegativeLengthMeasure(e),
  2095195183: (e) => new a.IfcNormalisedRatioMeasure(e),
  2395907400: (e) => new a.IfcNumericMeasure(e),
  929793134: (e) => new a.IfcPHMeasure(e),
  2260317790: (e) => new a.IfcParameterValue(e),
  2642773653: (e) => new a.IfcPlanarForceMeasure(e),
  4042175685: (e) => new a.IfcPlaneAngleMeasure(e),
  1790229001: (e) => new a.IfcPositiveInteger(e),
  2815919920: (e) => new a.IfcPositiveLengthMeasure(e),
  3054510233: (e) => new a.IfcPositivePlaneAngleMeasure(e),
  1245737093: (e) => new a.IfcPositiveRatioMeasure(e),
  1364037233: (e) => new a.IfcPowerMeasure(e),
  2169031380: (e) => new a.IfcPresentableText(e),
  3665567075: (e) => new a.IfcPressureMeasure(e),
  2798247006: (e) => new a.IfcPropertySetDefinitionSet(e.map((t) => t.value)),
  3972513137: (e) => new a.IfcRadioActivityMeasure(e),
  96294661: (e) => new a.IfcRatioMeasure(e),
  200335297: (e) => new a.IfcReal(e),
  2133746277: (e) => new a.IfcRotationalFrequencyMeasure(e),
  1755127002: (e) => new a.IfcRotationalMassMeasure(e),
  3211557302: (e) => new a.IfcRotationalStiffnessMeasure(e),
  3467162246: (e) => new a.IfcSectionModulusMeasure(e),
  2190458107: (e) => new a.IfcSectionalAreaIntegralMeasure(e),
  408310005: (e) => new a.IfcShearModulusMeasure(e),
  3471399674: (e) => new a.IfcSolidAngleMeasure(e),
  4157543285: (e) => new a.IfcSoundPowerLevelMeasure(e),
  846465480: (e) => new a.IfcSoundPowerMeasure(e),
  3457685358: (e) => new a.IfcSoundPressureLevelMeasure(e),
  993287707: (e) => new a.IfcSoundPressureMeasure(e),
  3477203348: (e) => new a.IfcSpecificHeatCapacityMeasure(e),
  2757832317: (e) => new a.IfcSpecularExponent(e),
  361837227: (e) => new a.IfcSpecularRoughness(e),
  58845555: (e) => new a.IfcTemperatureGradientMeasure(e),
  1209108979: (e) => new a.IfcTemperatureRateOfChangeMeasure(e),
  2801250643: (e) => new a.IfcText(e),
  1460886941: (e) => new a.IfcTextAlignment(e),
  3490877962: (e) => new a.IfcTextDecoration(e),
  603696268: (e) => new a.IfcTextFontName(e),
  296282323: (e) => new a.IfcTextTransformation(e),
  232962298: (e) => new a.IfcThermalAdmittanceMeasure(e),
  2645777649: (e) => new a.IfcThermalConductivityMeasure(e),
  2281867870: (e) => new a.IfcThermalExpansionCoefficientMeasure(e),
  857959152: (e) => new a.IfcThermalResistanceMeasure(e),
  2016195849: (e) => new a.IfcThermalTransmittanceMeasure(e),
  743184107: (e) => new a.IfcThermodynamicTemperatureMeasure(e),
  4075327185: (e) => new a.IfcTime(e),
  2726807636: (e) => new a.IfcTimeMeasure(e),
  2591213694: (e) => new a.IfcTimeStamp(e),
  1278329552: (e) => new a.IfcTorqueMeasure(e),
  950732822: (e) => new a.IfcURIReference(e),
  3345633955: (e) => new a.IfcVaporPermeabilityMeasure(e),
  3458127941: (e) => new a.IfcVolumeMeasure(e),
  2593997549: (e) => new a.IfcVolumetricFlowRateMeasure(e),
  51269191: (e) => new a.IfcWarpingConstantMeasure(e),
  1718600412: (e) => new a.IfcWarpingMomentMeasure(e)
};
var a;
((e) => {
  class t extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCABSORBEDDOSEMEASURE";
    }
  }
  e.IfcAbsorbedDoseMeasure = t;
  class i extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCACCELERATIONMEASURE";
    }
  }
  e.IfcAccelerationMeasure = i;
  class n extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCAMOUNTOFSUBSTANCEMEASURE";
    }
  }
  e.IfcAmountOfSubstanceMeasure = n;
  class s extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCANGULARVELOCITYMEASURE";
    }
  }
  e.IfcAngularVelocityMeasure = s;
  class o {
    constructor(E) {
      this.value = E, this.type = 5;
    }
  }
  e.IfcArcIndex = o;
  class r extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCAREADENSITYMEASURE";
    }
  }
  e.IfcAreaDensityMeasure = r;
  class l extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCAREAMEASURE";
    }
  }
  e.IfcAreaMeasure = l;
  class c extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCBINARY";
    }
  }
  e.IfcBinary = c;
  class h {
    constructor(E) {
      this.type = 3, this.name = "IFCBOOLEAN", this.value = E;
    }
  }
  e.IfcBoolean = h;
  class I {
    constructor(E) {
      this.value = E, this.type = 1, this.name = "IFCBOXALIGNMENT";
    }
  }
  e.IfcBoxAlignment = I;
  class p extends pt {
    constructor() {
      super(...arguments), this.type = 10, this.name = "IFCCARDINALPOINTREFERENCE";
    }
  }
  e.IfcCardinalPointReference = p;
  class y {
    constructor(E) {
      this.value = E, this.type = 4;
    }
  }
  e.IfcComplexNumber = y;
  class m {
    constructor(E) {
      this.value = E, this.type = 10;
    }
  }
  e.IfcCompoundPlaneAngleMeasure = m;
  class A extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCCONTEXTDEPENDENTMEASURE";
    }
  }
  e.IfcContextDependentMeasure = A;
  class C extends pt {
    constructor() {
      super(...arguments), this.type = 10, this.name = "IFCCOUNTMEASURE";
    }
  }
  e.IfcCountMeasure = C;
  class O extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCCURVATUREMEASURE";
    }
  }
  e.IfcCurvatureMeasure = O;
  class R {
    constructor(E) {
      this.value = E, this.type = 1, this.name = "IFCDATE";
    }
  }
  e.IfcDate = R;
  class F {
    constructor(E) {
      this.value = E, this.type = 1, this.name = "IFCDATETIME";
    }
  }
  e.IfcDateTime = F;
  class L extends pt {
    constructor() {
      super(...arguments), this.type = 10, this.name = "IFCDAYINMONTHNUMBER";
    }
  }
  e.IfcDayInMonthNumber = L;
  class P extends pt {
    constructor() {
      super(...arguments), this.type = 10, this.name = "IFCDAYINWEEKNUMBER";
    }
  }
  e.IfcDayInWeekNumber = P;
  class z {
    constructor(E) {
      this.value = E, this.type = 1, this.name = "IFCDESCRIPTIVEMEASURE";
    }
  }
  e.IfcDescriptiveMeasure = z;
  class W extends pt {
    constructor() {
      super(...arguments), this.type = 10, this.name = "IFCDIMENSIONCOUNT";
    }
  }
  e.IfcDimensionCount = W;
  class re extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCDOSEEQUIVALENTMEASURE";
    }
  }
  e.IfcDoseEquivalentMeasure = re;
  class ce {
    constructor(E) {
      this.value = E, this.type = 1, this.name = "IFCDURATION";
    }
  }
  e.IfcDuration = ce;
  class te extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCDYNAMICVISCOSITYMEASURE";
    }
  }
  e.IfcDynamicViscosityMeasure = te;
  class ee extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCELECTRICCAPACITANCEMEASURE";
    }
  }
  e.IfcElectricCapacitanceMeasure = ee;
  class Ne extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCELECTRICCHARGEMEASURE";
    }
  }
  e.IfcElectricChargeMeasure = Ne;
  class Ae extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCELECTRICCONDUCTANCEMEASURE";
    }
  }
  e.IfcElectricConductanceMeasure = Ae;
  class Oe extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCELECTRICCURRENTMEASURE";
    }
  }
  e.IfcElectricCurrentMeasure = Oe;
  class pe extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCELECTRICRESISTANCEMEASURE";
    }
  }
  e.IfcElectricResistanceMeasure = pe;
  class je extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCELECTRICVOLTAGEMEASURE";
    }
  }
  e.IfcElectricVoltageMeasure = je;
  class Ve extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCENERGYMEASURE";
    }
  }
  e.IfcEnergyMeasure = Ve;
  class $e {
    constructor(E) {
      this.value = E, this.type = 1, this.name = "IFCFONTSTYLE";
    }
  }
  e.IfcFontStyle = $e;
  class vt {
    constructor(E) {
      this.value = E, this.type = 1, this.name = "IFCFONTVARIANT";
    }
  }
  e.IfcFontVariant = vt;
  class Rt {
    constructor(E) {
      this.value = E, this.type = 1, this.name = "IFCFONTWEIGHT";
    }
  }
  e.IfcFontWeight = Rt;
  class ze extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCFORCEMEASURE";
    }
  }
  e.IfcForceMeasure = ze;
  class mt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCFREQUENCYMEASURE";
    }
  }
  e.IfcFrequencyMeasure = mt;
  class Et {
    constructor(E) {
      this.value = E, this.type = 1, this.name = "IFCGLOBALLYUNIQUEID";
    }
  }
  e.IfcGloballyUniqueId = Et;
  class it extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCHEATFLUXDENSITYMEASURE";
    }
  }
  e.IfcHeatFluxDensityMeasure = it;
  class Dt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCHEATINGVALUEMEASURE";
    }
  }
  e.IfcHeatingValueMeasure = Dt;
  class Ct {
    constructor(E) {
      this.value = E, this.type = 1, this.name = "IFCIDENTIFIER";
    }
  }
  e.IfcIdentifier = Ct;
  class Kt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCILLUMINANCEMEASURE";
    }
  }
  e.IfcIlluminanceMeasure = Kt;
  class Zt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCINDUCTANCEMEASURE";
    }
  }
  e.IfcInductanceMeasure = Zt;
  class Xt extends pt {
    constructor() {
      super(...arguments), this.type = 10, this.name = "IFCINTEGER";
    }
  }
  e.IfcInteger = Xt;
  class gi extends pt {
    constructor() {
      super(...arguments), this.type = 10, this.name = "IFCINTEGERCOUNTRATEMEASURE";
    }
  }
  e.IfcIntegerCountRateMeasure = gi;
  class Wt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCIONCONCENTRATIONMEASURE";
    }
  }
  e.IfcIonConcentrationMeasure = Wt;
  class Di extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCISOTHERMALMOISTURECAPACITYMEASURE";
    }
  }
  e.IfcIsothermalMoistureCapacityMeasure = Di;
  class ni extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCKINEMATICVISCOSITYMEASURE";
    }
  }
  e.IfcKinematicViscosityMeasure = ni;
  class Ci {
    constructor(E) {
      this.value = E, this.type = 1, this.name = "IFCLABEL";
    }
  }
  e.IfcLabel = Ci;
  class Se {
    constructor(E) {
      this.value = E, this.type = 1, this.name = "IFCLANGUAGEID";
    }
  }
  e.IfcLanguageId = Se;
  class si extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCLENGTHMEASURE";
    }
  }
  e.IfcLengthMeasure = si;
  class Mt {
    constructor(E) {
      this.value = E, this.type = 5;
    }
  }
  e.IfcLineIndex = Mt;
  class ft extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCLINEARFORCEMEASURE";
    }
  }
  e.IfcLinearForceMeasure = ft;
  class rt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCLINEARMOMENTMEASURE";
    }
  }
  e.IfcLinearMomentMeasure = rt;
  class Tt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCLINEARSTIFFNESSMEASURE";
    }
  }
  e.IfcLinearStiffnessMeasure = Tt;
  class jt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCLINEARVELOCITYMEASURE";
    }
  }
  e.IfcLinearVelocityMeasure = jt;
  class Jt {
    constructor(E) {
      this.type = 3, this.name = "IFCLOGICAL", this.value = E;
    }
  }
  e.IfcLogical = Jt;
  class $t extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCLUMINOUSFLUXMEASURE";
    }
  }
  e.IfcLuminousFluxMeasure = $t;
  class ht extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCLUMINOUSINTENSITYDISTRIBUTIONMEASURE";
    }
  }
  e.IfcLuminousIntensityDistributionMeasure = ht;
  class Me extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCLUMINOUSINTENSITYMEASURE";
    }
  }
  e.IfcLuminousIntensityMeasure = Me;
  class gt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMAGNETICFLUXDENSITYMEASURE";
    }
  }
  e.IfcMagneticFluxDensityMeasure = gt;
  class yt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMAGNETICFLUXMEASURE";
    }
  }
  e.IfcMagneticFluxMeasure = yt;
  class Ut extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMASSDENSITYMEASURE";
    }
  }
  e.IfcMassDensityMeasure = Ut;
  class Ht extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMASSFLOWRATEMEASURE";
    }
  }
  e.IfcMassFlowRateMeasure = Ht;
  class wi extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMASSMEASURE";
    }
  }
  e.IfcMassMeasure = wi;
  class bi extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMASSPERLENGTHMEASURE";
    }
  }
  e.IfcMassPerLengthMeasure = bi;
  class Hi extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMODULUSOFELASTICITYMEASURE";
    }
  }
  e.IfcModulusOfElasticityMeasure = Hi;
  class Wi extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMODULUSOFLINEARSUBGRADEREACTIONMEASURE";
    }
  }
  e.IfcModulusOfLinearSubgradeReactionMeasure = Wi;
  class hi extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMODULUSOFROTATIONALSUBGRADEREACTIONMEASURE";
    }
  }
  e.IfcModulusOfRotationalSubgradeReactionMeasure = hi;
  class Ji extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMODULUSOFSUBGRADEREACTIONMEASURE";
    }
  }
  e.IfcModulusOfSubgradeReactionMeasure = Ji;
  class Sn extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMOISTUREDIFFUSIVITYMEASURE";
    }
  }
  e.IfcMoistureDiffusivityMeasure = Sn;
  class nn extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMOLECULARWEIGHTMEASURE";
    }
  }
  e.IfcMolecularWeightMeasure = nn;
  class Yi extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMOMENTOFINERTIAMEASURE";
    }
  }
  e.IfcMomentOfInertiaMeasure = Yi;
  class Pi extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCMONETARYMEASURE";
    }
  }
  e.IfcMonetaryMeasure = Pi;
  class kt extends pt {
    constructor() {
      super(...arguments), this.type = 10, this.name = "IFCMONTHINYEARNUMBER";
    }
  }
  e.IfcMonthInYearNumber = kt;
  class sn extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCNONNEGATIVELENGTHMEASURE";
    }
  }
  e.IfcNonNegativeLengthMeasure = sn;
  class Fi extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCNORMALISEDRATIOMEASURE";
    }
  }
  e.IfcNormalisedRatioMeasure = Fi;
  class tn extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCNUMERICMEASURE";
    }
  }
  e.IfcNumericMeasure = tn;
  class Gi extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCPHMEASURE";
    }
  }
  e.IfcPHMeasure = Gi;
  class yi extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCPARAMETERVALUE";
    }
  }
  e.IfcParameterValue = yi;
  class bn extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCPLANARFORCEMEASURE";
    }
  }
  e.IfcPlanarForceMeasure = bn;
  class ln extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCPLANEANGLEMEASURE";
    }
  }
  e.IfcPlaneAngleMeasure = ln;
  class No extends pt {
    constructor() {
      super(...arguments), this.type = 10, this.name = "IFCPOSITIVEINTEGER";
    }
  }
  e.IfcPositiveInteger = No;
  class Bs extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCPOSITIVELENGTHMEASURE";
    }
  }
  e.IfcPositiveLengthMeasure = Bs;
  class os extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCPOSITIVEPLANEANGLEMEASURE";
    }
  }
  e.IfcPositivePlaneAngleMeasure = os;
  class vl extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCPOSITIVERATIOMEASURE";
    }
  }
  e.IfcPositiveRatioMeasure = vl;
  class zl extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCPOWERMEASURE";
    }
  }
  e.IfcPowerMeasure = zl;
  class Wu {
    constructor(E) {
      this.value = E, this.type = 1, this.name = "IFCPRESENTABLETEXT";
    }
  }
  e.IfcPresentableText = Wu;
  class jl extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCPRESSUREMEASURE";
    }
  }
  e.IfcPressureMeasure = jl;
  class Yu {
    constructor(E) {
      this.value = E, this.type = 5;
    }
  }
  e.IfcPropertySetDefinitionSet = Yu;
  class bd extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCRADIOACTIVITYMEASURE";
    }
  }
  e.IfcRadioActivityMeasure = bd;
  class I0 extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCRATIOMEASURE";
    }
  }
  e.IfcRatioMeasure = I0;
  class Gt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCREAL";
    }
  }
  e.IfcReal = Gt;
  class Vi extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCROTATIONALFREQUENCYMEASURE";
    }
  }
  e.IfcRotationalFrequencyMeasure = Vi;
  class _i extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCROTATIONALMASSMEASURE";
    }
  }
  e.IfcRotationalMassMeasure = _i;
  class $n extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCROTATIONALSTIFFNESSMEASURE";
    }
  }
  e.IfcRotationalStiffnessMeasure = $n;
  class Os extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCSECTIONMODULUSMEASURE";
    }
  }
  e.IfcSectionModulusMeasure = Os;
  class Ai extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCSECTIONALAREAINTEGRALMEASURE";
    }
  }
  e.IfcSectionalAreaIntegralMeasure = Ai;
  class As extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCSHEARMODULUSMEASURE";
    }
  }
  e.IfcShearModulusMeasure = As;
  class Es extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCSOLIDANGLEMEASURE";
    }
  }
  e.IfcSolidAngleMeasure = Es;
  class mr extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCSOUNDPOWERLEVELMEASURE";
    }
  }
  e.IfcSoundPowerLevelMeasure = mr;
  class Je extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCSOUNDPOWERMEASURE";
    }
  }
  e.IfcSoundPowerMeasure = Je;
  class no extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCSOUNDPRESSURELEVELMEASURE";
    }
  }
  e.IfcSoundPressureLevelMeasure = no;
  class It extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCSOUNDPRESSUREMEASURE";
    }
  }
  e.IfcSoundPressureMeasure = It;
  class Qt extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCSPECIFICHEATCAPACITYMEASURE";
    }
  }
  e.IfcSpecificHeatCapacityMeasure = Qt;
  class ci extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCSPECULAREXPONENT";
    }
  }
  e.IfcSpecularExponent = ci;
  class ai extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCSPECULARROUGHNESS";
    }
  }
  e.IfcSpecularRoughness = ai;
  class ei extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCTEMPERATUREGRADIENTMEASURE";
    }
  }
  e.IfcTemperatureGradientMeasure = ei;
  class Si extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCTEMPERATURERATEOFCHANGEMEASURE";
    }
  }
  e.IfcTemperatureRateOfChangeMeasure = Si;
  class mn {
    constructor(E) {
      this.value = E, this.type = 1, this.name = "IFCTEXT";
    }
  }
  e.IfcText = mn;
  class wn {
    constructor(E) {
      this.value = E, this.type = 1, this.name = "IFCTEXTALIGNMENT";
    }
  }
  e.IfcTextAlignment = wn;
  class Nn {
    constructor(E) {
      this.value = E, this.type = 1, this.name = "IFCTEXTDECORATION";
    }
  }
  e.IfcTextDecoration = Nn;
  class Kn {
    constructor(E) {
      this.value = E, this.type = 1, this.name = "IFCTEXTFONTNAME";
    }
  }
  e.IfcTextFontName = Kn;
  class is {
    constructor(E) {
      this.value = E, this.type = 1, this.name = "IFCTEXTTRANSFORMATION";
    }
  }
  e.IfcTextTransformation = is;
  class jn extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCTHERMALADMITTANCEMEASURE";
    }
  }
  e.IfcThermalAdmittanceMeasure = jn;
  class _s extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCTHERMALCONDUCTIVITYMEASURE";
    }
  }
  e.IfcThermalConductivityMeasure = _s;
  class yo extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCTHERMALEXPANSIONCOEFFICIENTMEASURE";
    }
  }
  e.IfcThermalExpansionCoefficientMeasure = yo;
  class Qo extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCTHERMALRESISTANCEMEASURE";
    }
  }
  e.IfcThermalResistanceMeasure = Qo;
  class so extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCTHERMALTRANSMITTANCEMEASURE";
    }
  }
  e.IfcThermalTransmittanceMeasure = so;
  class Eo extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCTHERMODYNAMICTEMPERATUREMEASURE";
    }
  }
  e.IfcThermodynamicTemperatureMeasure = Eo;
  class Yn {
    constructor(E) {
      this.value = E, this.type = 1, this.name = "IFCTIME";
    }
  }
  e.IfcTime = Yn;
  class Jo extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCTIMEMEASURE";
    }
  }
  e.IfcTimeMeasure = Jo;
  class xs extends pt {
    constructor() {
      super(...arguments), this.type = 10, this.name = "IFCTIMESTAMP";
    }
  }
  e.IfcTimeStamp = xs;
  class Gr extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCTORQUEMEASURE";
    }
  }
  e.IfcTorqueMeasure = Gr;
  class sa {
    constructor(E) {
      this.value = E, this.type = 1, this.name = "IFCURIREFERENCE";
    }
  }
  e.IfcURIReference = sa;
  class yr extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCVAPORPERMEABILITYMEASURE";
    }
  }
  e.IfcVaporPermeabilityMeasure = yr;
  class nr extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCVOLUMEMEASURE";
    }
  }
  e.IfcVolumeMeasure = nr;
  class Ws extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCVOLUMETRICFLOWRATEMEASURE";
    }
  }
  e.IfcVolumetricFlowRateMeasure = Ws;
  class ul extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCWARPINGCONSTANTMEASURE";
    }
  }
  e.IfcWarpingConstantMeasure = ul;
  class ur extends pt {
    constructor() {
      super(...arguments), this.type = 4, this.name = "IFCWARPINGMOMENTMEASURE";
    }
  }
  e.IfcWarpingMomentMeasure = ur;
  const A0 = class A0 {
  };
  A0.EMAIL = { type: 3, value: "EMAIL" }, A0.FAX = { type: 3, value: "FAX" }, A0.PHONE = { type: 3, value: "PHONE" }, A0.POST = { type: 3, value: "POST" }, A0.VERBAL = { type: 3, value: "VERBAL" }, A0.USERDEFINED = { type: 3, value: "USERDEFINED" }, A0.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let ao = A0;
  e.IfcActionRequestTypeEnum = ao;
  const Wo = class Wo {
  };
  Wo.BRAKES = { type: 3, value: "BRAKES" }, Wo.BUOYANCY = { type: 3, value: "BUOYANCY" }, Wo.COMPLETION_G1 = { type: 3, value: "COMPLETION_G1" }, Wo.CREEP = { type: 3, value: "CREEP" }, Wo.CURRENT = { type: 3, value: "CURRENT" }, Wo.DEAD_LOAD_G = { type: 3, value: "DEAD_LOAD_G" }, Wo.EARTHQUAKE_E = { type: 3, value: "EARTHQUAKE_E" }, Wo.ERECTION = { type: 3, value: "ERECTION" }, Wo.FIRE = { type: 3, value: "FIRE" }, Wo.ICE = { type: 3, value: "ICE" }, Wo.IMPACT = { type: 3, value: "IMPACT" }, Wo.IMPULSE = { type: 3, value: "IMPULSE" }, Wo.LACK_OF_FIT = { type: 3, value: "LACK_OF_FIT" }, Wo.LIVE_LOAD_Q = { type: 3, value: "LIVE_LOAD_Q" }, Wo.PRESTRESSING_P = { type: 3, value: "PRESTRESSING_P" }, Wo.PROPPING = { type: 3, value: "PROPPING" }, Wo.RAIN = { type: 3, value: "RAIN" }, Wo.SETTLEMENT_U = { type: 3, value: "SETTLEMENT_U" }, Wo.SHRINKAGE = { type: 3, value: "SHRINKAGE" }, Wo.SNOW_S = { type: 3, value: "SNOW_S" }, Wo.SYSTEM_IMPERFECTION = { type: 3, value: "SYSTEM_IMPERFECTION" }, Wo.TEMPERATURE_T = { type: 3, value: "TEMPERATURE_T" }, Wo.TRANSPORT = { type: 3, value: "TRANSPORT" }, Wo.WAVE = { type: 3, value: "WAVE" }, Wo.WIND_W = { type: 3, value: "WIND_W" }, Wo.USERDEFINED = { type: 3, value: "USERDEFINED" }, Wo.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let kr = Wo;
  e.IfcActionSourceTypeEnum = kr;
  const Oh = class Oh {
  };
  Oh.EXTRAORDINARY_A = { type: 3, value: "EXTRAORDINARY_A" }, Oh.PERMANENT_G = { type: 3, value: "PERMANENT_G" }, Oh.VARIABLE_Q = { type: 3, value: "VARIABLE_Q" }, Oh.USERDEFINED = { type: 3, value: "USERDEFINED" }, Oh.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let oa = Oh;
  e.IfcActionTypeEnum = oa;
  const Yc = class Yc {
  };
  Yc.ELECTRICACTUATOR = { type: 3, value: "ELECTRICACTUATOR" }, Yc.HANDOPERATEDACTUATOR = { type: 3, value: "HANDOPERATEDACTUATOR" }, Yc.HYDRAULICACTUATOR = { type: 3, value: "HYDRAULICACTUATOR" }, Yc.PNEUMATICACTUATOR = { type: 3, value: "PNEUMATICACTUATOR" }, Yc.THERMOSTATICACTUATOR = { type: 3, value: "THERMOSTATICACTUATOR" }, Yc.USERDEFINED = { type: 3, value: "USERDEFINED" }, Yc.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Po = Yc;
  e.IfcActuatorTypeEnum = Po;
  const Ey = class Ey {
  };
  Ey.DISTRIBUTIONPOINT = { type: 3, value: "DISTRIBUTIONPOINT" }, Ey.HOME = { type: 3, value: "HOME" }, Ey.OFFICE = { type: 3, value: "OFFICE" }, Ey.SITE = { type: 3, value: "SITE" }, Ey.USERDEFINED = { type: 3, value: "USERDEFINED" };
  let NI = Ey;
  e.IfcAddressTypeEnum = NI;
  const qE = class qE {
  };
  qE.CONSTANTFLOW = { type: 3, value: "CONSTANTFLOW" }, qE.VARIABLEFLOWPRESSUREDEPENDANT = { type: 3, value: "VARIABLEFLOWPRESSUREDEPENDANT" }, qE.VARIABLEFLOWPRESSUREINDEPENDANT = { type: 3, value: "VARIABLEFLOWPRESSUREINDEPENDANT" }, qE.USERDEFINED = { type: 3, value: "USERDEFINED" }, qE.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Tc = qE;
  e.IfcAirTerminalBoxTypeEnum = Tc;
  const Lh = class Lh {
  };
  Lh.DIFFUSER = { type: 3, value: "DIFFUSER" }, Lh.GRILLE = { type: 3, value: "GRILLE" }, Lh.LOUVRE = { type: 3, value: "LOUVRE" }, Lh.REGISTER = { type: 3, value: "REGISTER" }, Lh.USERDEFINED = { type: 3, value: "USERDEFINED" }, Lh.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let bf = Lh;
  e.IfcAirTerminalTypeEnum = bf;
  const Du = class Du {
  };
  Du.FIXEDPLATECOUNTERFLOWEXCHANGER = { type: 3, value: "FIXEDPLATECOUNTERFLOWEXCHANGER" }, Du.FIXEDPLATECROSSFLOWEXCHANGER = { type: 3, value: "FIXEDPLATECROSSFLOWEXCHANGER" }, Du.FIXEDPLATEPARALLELFLOWEXCHANGER = { type: 3, value: "FIXEDPLATEPARALLELFLOWEXCHANGER" }, Du.HEATPIPE = { type: 3, value: "HEATPIPE" }, Du.ROTARYWHEEL = { type: 3, value: "ROTARYWHEEL" }, Du.RUNAROUNDCOILLOOP = { type: 3, value: "RUNAROUNDCOILLOOP" }, Du.THERMOSIPHONCOILTYPEHEATEXCHANGERS = { type: 3, value: "THERMOSIPHONCOILTYPEHEATEXCHANGERS" }, Du.THERMOSIPHONSEALEDTUBEHEATEXCHANGERS = { type: 3, value: "THERMOSIPHONSEALEDTUBEHEATEXCHANGERS" }, Du.TWINTOWERENTHALPYRECOVERYLOOPS = { type: 3, value: "TWINTOWERENTHALPYRECOVERYLOOPS" }, Du.USERDEFINED = { type: 3, value: "USERDEFINED" }, Du.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Rc = Du;
  e.IfcAirToAirHeatRecoveryTypeEnum = Rc;
  const pa = class pa {
  };
  pa.BELL = { type: 3, value: "BELL" }, pa.BREAKGLASSBUTTON = { type: 3, value: "BREAKGLASSBUTTON" }, pa.LIGHT = { type: 3, value: "LIGHT" }, pa.MANUALPULLBOX = { type: 3, value: "MANUALPULLBOX" }, pa.RAILWAYCROCODILE = { type: 3, value: "RAILWAYCROCODILE" }, pa.RAILWAYDETONATOR = { type: 3, value: "RAILWAYDETONATOR" }, pa.SIREN = { type: 3, value: "SIREN" }, pa.WHISTLE = { type: 3, value: "WHISTLE" }, pa.USERDEFINED = { type: 3, value: "USERDEFINED" }, pa.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Sr = pa;
  e.IfcAlarmTypeEnum = Sr;
  const kd = class kd {
  };
  kd.BLOSSCURVE = { type: 3, value: "BLOSSCURVE" }, kd.CONSTANTCANT = { type: 3, value: "CONSTANTCANT" }, kd.COSINECURVE = { type: 3, value: "COSINECURVE" }, kd.HELMERTCURVE = { type: 3, value: "HELMERTCURVE" }, kd.LINEARTRANSITION = { type: 3, value: "LINEARTRANSITION" }, kd.SINECURVE = { type: 3, value: "SINECURVE" }, kd.VIENNESEBEND = { type: 3, value: "VIENNESEBEND" };
  let ra = kd;
  e.IfcAlignmentCantSegmentTypeEnum = ra;
  const vm = class vm {
  };
  vm.BLOSSCURVE = { type: 3, value: "BLOSSCURVE" }, vm.CIRCULARARC = { type: 3, value: "CIRCULARARC" }, vm.CLOTHOID = { type: 3, value: "CLOTHOID" }, vm.COSINECURVE = { type: 3, value: "COSINECURVE" }, vm.CUBIC = { type: 3, value: "CUBIC" }, vm.HELMERTCURVE = { type: 3, value: "HELMERTCURVE" }, vm.LINE = { type: 3, value: "LINE" }, vm.SINECURVE = { type: 3, value: "SINECURVE" }, vm.VIENNESEBEND = { type: 3, value: "VIENNESEBEND" };
  let Ls = vm;
  e.IfcAlignmentHorizontalSegmentTypeEnum = Ls;
  const op = class op {
  };
  op.USERDEFINED = { type: 3, value: "USERDEFINED" }, op.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let vc = op;
  e.IfcAlignmentTypeEnum = vc;
  const qR = class qR {
  };
  qR.CIRCULARARC = { type: 3, value: "CIRCULARARC" }, qR.CLOTHOID = { type: 3, value: "CLOTHOID" }, qR.CONSTANTGRADIENT = { type: 3, value: "CONSTANTGRADIENT" }, qR.PARABOLICARC = { type: 3, value: "PARABOLICARC" };
  let la = qR;
  e.IfcAlignmentVerticalSegmentTypeEnum = la;
  const _r = class _r {
  };
  _r.IN_PLANE_LOADING_2D = { type: 3, value: "IN_PLANE_LOADING_2D" }, _r.LOADING_3D = { type: 3, value: "LOADING_3D" }, _r.OUT_PLANE_LOADING_2D = { type: 3, value: "OUT_PLANE_LOADING_2D" }, _r.USERDEFINED = { type: 3, value: "USERDEFINED" }, _r.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Nf = _r;
  e.IfcAnalysisModelTypeEnum = Nf;
  const Kl = class Kl {
  };
  Kl.FIRST_ORDER_THEORY = { type: 3, value: "FIRST_ORDER_THEORY" }, Kl.FULL_NONLINEAR_THEORY = { type: 3, value: "FULL_NONLINEAR_THEORY" }, Kl.SECOND_ORDER_THEORY = { type: 3, value: "SECOND_ORDER_THEORY" }, Kl.THIRD_ORDER_THEORY = { type: 3, value: "THIRD_ORDER_THEORY" }, Kl.USERDEFINED = { type: 3, value: "USERDEFINED" }, Kl.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let DI = Kl;
  e.IfcAnalysisTheoryTypeEnum = DI;
  const jr = class jr {
  };
  jr.ASBUILTAREA = { type: 3, value: "ASBUILTAREA" }, jr.ASBUILTLINE = { type: 3, value: "ASBUILTLINE" }, jr.ASBUILTPOINT = { type: 3, value: "ASBUILTPOINT" }, jr.ASSUMEDAREA = { type: 3, value: "ASSUMEDAREA" }, jr.ASSUMEDLINE = { type: 3, value: "ASSUMEDLINE" }, jr.ASSUMEDPOINT = { type: 3, value: "ASSUMEDPOINT" }, jr.NON_PHYSICAL_SIGNAL = { type: 3, value: "NON_PHYSICAL_SIGNAL" }, jr.SUPERELEVATIONEVENT = { type: 3, value: "SUPERELEVATIONEVENT" }, jr.WIDTHEVENT = { type: 3, value: "WIDTHEVENT" }, jr.USERDEFINED = { type: 3, value: "USERDEFINED" }, jr.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Df = jr;
  e.IfcAnnotationTypeEnum = Df;
  const Mo = class Mo {
  };
  Mo.ADD = { type: 3, value: "ADD" }, Mo.DIVIDE = { type: 3, value: "DIVIDE" }, Mo.MULTIPLY = { type: 3, value: "MULTIPLY" }, Mo.SUBTRACT = { type: 3, value: "SUBTRACT" };
  let dl = Mo;
  e.IfcArithmeticOperatorEnum = dl;
  const S0 = class S0 {
  };
  S0.FACTORY = { type: 3, value: "FACTORY" }, S0.SITE = { type: 3, value: "SITE" }, S0.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ac = S0;
  e.IfcAssemblyPlaceEnum = Ac;
  const Vd = class Vd {
  };
  Vd.AMPLIFIER = { type: 3, value: "AMPLIFIER" }, Vd.CAMERA = { type: 3, value: "CAMERA" }, Vd.COMMUNICATIONTERMINAL = { type: 3, value: "COMMUNICATIONTERMINAL" }, Vd.DISPLAY = { type: 3, value: "DISPLAY" }, Vd.MICROPHONE = { type: 3, value: "MICROPHONE" }, Vd.PLAYER = { type: 3, value: "PLAYER" }, Vd.PROJECTOR = { type: 3, value: "PROJECTOR" }, Vd.RECEIVER = { type: 3, value: "RECEIVER" }, Vd.RECORDINGEQUIPMENT = { type: 3, value: "RECORDINGEQUIPMENT" }, Vd.SPEAKER = { type: 3, value: "SPEAKER" }, Vd.SWITCHER = { type: 3, value: "SWITCHER" }, Vd.TELEPHONE = { type: 3, value: "TELEPHONE" }, Vd.TUNER = { type: 3, value: "TUNER" }, Vd.USERDEFINED = { type: 3, value: "USERDEFINED" }, Vd.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Sc = Vd;
  e.IfcAudioVisualApplianceTypeEnum = Sc;
  const er = class er {
  };
  er.CIRCULAR_ARC = { type: 3, value: "CIRCULAR_ARC" }, er.ELLIPTIC_ARC = { type: 3, value: "ELLIPTIC_ARC" }, er.HYPERBOLIC_ARC = { type: 3, value: "HYPERBOLIC_ARC" }, er.PARABOLIC_ARC = { type: 3, value: "PARABOLIC_ARC" }, er.POLYLINE_FORM = { type: 3, value: "POLYLINE_FORM" }, er.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" };
  let CI = er;
  e.IfcBSplineCurveForm = CI;
  const zd = class zd {
  };
  zd.CONICAL_SURF = { type: 3, value: "CONICAL_SURF" }, zd.CYLINDRICAL_SURF = { type: 3, value: "CYLINDRICAL_SURF" }, zd.GENERALISED_CONE = { type: 3, value: "GENERALISED_CONE" }, zd.PLANE_SURF = { type: 3, value: "PLANE_SURF" }, zd.QUADRIC_SURF = { type: 3, value: "QUADRIC_SURF" }, zd.RULED_SURF = { type: 3, value: "RULED_SURF" }, zd.SPHERICAL_SURF = { type: 3, value: "SPHERICAL_SURF" }, zd.SURF_OF_LINEAR_EXTRUSION = { type: 3, value: "SURF_OF_LINEAR_EXTRUSION" }, zd.SURF_OF_REVOLUTION = { type: 3, value: "SURF_OF_REVOLUTION" }, zd.TOROIDAL_SURF = { type: 3, value: "TOROIDAL_SURF" }, zd.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" };
  let go = zd;
  e.IfcBSplineSurfaceForm = go;
  const Cu = class Cu {
  };
  Cu.BEAM = { type: 3, value: "BEAM" }, Cu.CORNICE = { type: 3, value: "CORNICE" }, Cu.DIAPHRAGM = { type: 3, value: "DIAPHRAGM" }, Cu.EDGEBEAM = { type: 3, value: "EDGEBEAM" }, Cu.GIRDER_SEGMENT = { type: 3, value: "GIRDER_SEGMENT" }, Cu.HATSTONE = { type: 3, value: "HATSTONE" }, Cu.HOLLOWCORE = { type: 3, value: "HOLLOWCORE" }, Cu.JOIST = { type: 3, value: "JOIST" }, Cu.LINTEL = { type: 3, value: "LINTEL" }, Cu.PIERCAP = { type: 3, value: "PIERCAP" }, Cu.SPANDREL = { type: 3, value: "SPANDREL" }, Cu.T_BEAM = { type: 3, value: "T_BEAM" }, Cu.USERDEFINED = { type: 3, value: "USERDEFINED" }, Cu.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Cf = Cu;
  e.IfcBeamTypeEnum = Cf;
  const jd = class jd {
  };
  jd.FIXED_MOVEMENT = { type: 3, value: "FIXED_MOVEMENT" }, jd.FREE_MOVEMENT = { type: 3, value: "FREE_MOVEMENT" }, jd.GUIDED_LONGITUDINAL = { type: 3, value: "GUIDED_LONGITUDINAL" }, jd.GUIDED_TRANSVERSAL = { type: 3, value: "GUIDED_TRANSVERSAL" }, jd.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let bc = jd;
  e.IfcBearingTypeDisplacementEnum = bc;
  const qc = class qc {
  };
  qc.CYLINDRICAL = { type: 3, value: "CYLINDRICAL" }, qc.DISK = { type: 3, value: "DISK" }, qc.ELASTOMERIC = { type: 3, value: "ELASTOMERIC" }, qc.GUIDE = { type: 3, value: "GUIDE" }, qc.POT = { type: 3, value: "POT" }, qc.ROCKER = { type: 3, value: "ROCKER" }, qc.ROLLER = { type: 3, value: "ROLLER" }, qc.SPHERICAL = { type: 3, value: "SPHERICAL" }, qc.USERDEFINED = { type: 3, value: "USERDEFINED" }, qc.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let OI = qc;
  e.IfcBearingTypeEnum = OI;
  const _h = class _h {
  };
  _h.EQUALTO = { type: 3, value: "EQUALTO" }, _h.GREATERTHAN = { type: 3, value: "GREATERTHAN" }, _h.GREATERTHANOREQUALTO = { type: 3, value: "GREATERTHANOREQUALTO" }, _h.INCLUDEDIN = { type: 3, value: "INCLUDEDIN" }, _h.INCLUDES = { type: 3, value: "INCLUDES" }, _h.LESSTHAN = { type: 3, value: "LESSTHAN" }, _h.LESSTHANOREQUALTO = { type: 3, value: "LESSTHANOREQUALTO" }, _h.NOTEQUALTO = { type: 3, value: "NOTEQUALTO" }, _h.NOTINCLUDEDIN = { type: 3, value: "NOTINCLUDEDIN" }, _h.NOTINCLUDES = { type: 3, value: "NOTINCLUDES" };
  let Of = _h;
  e.IfcBenchmarkEnum = Of;
  const Hw = class Hw {
  };
  Hw.STEAM = { type: 3, value: "STEAM" }, Hw.WATER = { type: 3, value: "WATER" }, Hw.USERDEFINED = { type: 3, value: "USERDEFINED" }, Hw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let xt = Hw;
  e.IfcBoilerTypeEnum = xt;
  const gy = class gy {
  };
  gy.DIFFERENCE = { type: 3, value: "DIFFERENCE" }, gy.INTERSECTION = { type: 3, value: "INTERSECTION" }, gy.UNION = { type: 3, value: "UNION" };
  let li = gy;
  e.IfcBooleanOperator = li;
  const Ul = class Ul {
  };
  Ul.ABUTMENT = { type: 3, value: "ABUTMENT" }, Ul.DECK = { type: 3, value: "DECK" }, Ul.DECK_SEGMENT = { type: 3, value: "DECK_SEGMENT" }, Ul.FOUNDATION = { type: 3, value: "FOUNDATION" }, Ul.PIER = { type: 3, value: "PIER" }, Ul.PIER_SEGMENT = { type: 3, value: "PIER_SEGMENT" }, Ul.PYLON = { type: 3, value: "PYLON" }, Ul.SUBSTRUCTURE = { type: 3, value: "SUBSTRUCTURE" }, Ul.SUPERSTRUCTURE = { type: 3, value: "SUPERSTRUCTURE" }, Ul.SURFACESTRUCTURE = { type: 3, value: "SURFACESTRUCTURE" }, Ul.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ul.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let qi = Ul;
  e.IfcBridgePartTypeEnum = qi;
  const b0 = class b0 {
  };
  b0.ARCHED = { type: 3, value: "ARCHED" }, b0.CABLE_STAYED = { type: 3, value: "CABLE_STAYED" }, b0.CANTILEVER = { type: 3, value: "CANTILEVER" }, b0.CULVERT = { type: 3, value: "CULVERT" }, b0.FRAMEWORK = { type: 3, value: "FRAMEWORK" }, b0.GIRDER = { type: 3, value: "GIRDER" }, b0.SUSPENSION = { type: 3, value: "SUSPENSION" }, b0.TRUSS = { type: 3, value: "TRUSS" }, b0.USERDEFINED = { type: 3, value: "USERDEFINED" }, b0.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let un = b0;
  e.IfcBridgeTypeEnum = un;
  const xh = class xh {
  };
  xh.APRON = { type: 3, value: "APRON" }, xh.ARMOURUNIT = { type: 3, value: "ARMOURUNIT" }, xh.INSULATION = { type: 3, value: "INSULATION" }, xh.PRECASTPANEL = { type: 3, value: "PRECASTPANEL" }, xh.SAFETYCAGE = { type: 3, value: "SAFETYCAGE" }, xh.USERDEFINED = { type: 3, value: "USERDEFINED" }, xh.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Mn = xh;
  e.IfcBuildingElementPartTypeEnum = Mn;
  const Zl = class Zl {
  };
  Zl.COMPLEX = { type: 3, value: "COMPLEX" }, Zl.ELEMENT = { type: 3, value: "ELEMENT" }, Zl.PARTIAL = { type: 3, value: "PARTIAL" }, Zl.USERDEFINED = { type: 3, value: "USERDEFINED" }, Zl.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Pn = Zl;
  e.IfcBuildingElementProxyTypeEnum = Pn;
  const $c = class $c {
  };
  $c.EROSIONPREVENTION = { type: 3, value: "EROSIONPREVENTION" }, $c.FENESTRATION = { type: 3, value: "FENESTRATION" }, $c.FOUNDATION = { type: 3, value: "FOUNDATION" }, $c.LOADBEARING = { type: 3, value: "LOADBEARING" }, $c.OUTERSHELL = { type: 3, value: "OUTERSHELL" }, $c.PRESTRESSING = { type: 3, value: "PRESTRESSING" }, $c.REINFORCING = { type: 3, value: "REINFORCING" }, $c.SHADING = { type: 3, value: "SHADING" }, $c.TRANSPORT = { type: 3, value: "TRANSPORT" }, $c.USERDEFINED = { type: 3, value: "USERDEFINED" }, $c.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let ws = $c;
  e.IfcBuildingSystemTypeEnum = ws;
  const El = class El {
  };
  El.EROSIONPREVENTION = { type: 3, value: "EROSIONPREVENTION" }, El.FENESTRATION = { type: 3, value: "FENESTRATION" }, El.FOUNDATION = { type: 3, value: "FOUNDATION" }, El.LOADBEARING = { type: 3, value: "LOADBEARING" }, El.MOORING = { type: 3, value: "MOORING" }, El.OUTERSHELL = { type: 3, value: "OUTERSHELL" }, El.PRESTRESSING = { type: 3, value: "PRESTRESSING" }, El.RAILWAYLINE = { type: 3, value: "RAILWAYLINE" }, El.RAILWAYTRACK = { type: 3, value: "RAILWAYTRACK" }, El.REINFORCING = { type: 3, value: "REINFORCING" }, El.SHADING = { type: 3, value: "SHADING" }, El.TRACKCIRCUIT = { type: 3, value: "TRACKCIRCUIT" }, El.TRANSPORT = { type: 3, value: "TRANSPORT" }, El.USERDEFINED = { type: 3, value: "USERDEFINED" }, El.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ys = El;
  e.IfcBuiltSystemTypeEnum = Ys;
  const $E = class $E {
  };
  $E.USERDEFINED = { type: 3, value: "USERDEFINED" }, $E.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ss = $E;
  e.IfcBurnerTypeEnum = Ss;
  const Ph = class Ph {
  };
  Ph.BEND = { type: 3, value: "BEND" }, Ph.CONNECTOR = { type: 3, value: "CONNECTOR" }, Ph.CROSS = { type: 3, value: "CROSS" }, Ph.JUNCTION = { type: 3, value: "JUNCTION" }, Ph.TEE = { type: 3, value: "TEE" }, Ph.TRANSITION = { type: 3, value: "TRANSITION" }, Ph.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ph.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let dr = Ph;
  e.IfcCableCarrierFittingTypeEnum = dr;
  const Mh = class Mh {
  };
  Mh.CABLEBRACKET = { type: 3, value: "CABLEBRACKET" }, Mh.CABLELADDERSEGMENT = { type: 3, value: "CABLELADDERSEGMENT" }, Mh.CABLETRAYSEGMENT = { type: 3, value: "CABLETRAYSEGMENT" }, Mh.CABLETRUNKINGSEGMENT = { type: 3, value: "CABLETRUNKINGSEGMENT" }, Mh.CATENARYWIRE = { type: 3, value: "CATENARYWIRE" }, Mh.CONDUITSEGMENT = { type: 3, value: "CONDUITSEGMENT" }, Mh.DROPPER = { type: 3, value: "DROPPER" }, Mh.USERDEFINED = { type: 3, value: "USERDEFINED" }, Mh.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Vr = Mh;
  e.IfcCableCarrierSegmentTypeEnum = Vr;
  const rp = class rp {
  };
  rp.CONNECTOR = { type: 3, value: "CONNECTOR" }, rp.ENTRY = { type: 3, value: "ENTRY" }, rp.EXIT = { type: 3, value: "EXIT" }, rp.FANOUT = { type: 3, value: "FANOUT" }, rp.JUNCTION = { type: 3, value: "JUNCTION" }, rp.TRANSITION = { type: 3, value: "TRANSITION" }, rp.USERDEFINED = { type: 3, value: "USERDEFINED" }, rp.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let _l = rp;
  e.IfcCableFittingTypeEnum = _l;
  const Wd = class Wd {
  };
  Wd.BUSBARSEGMENT = { type: 3, value: "BUSBARSEGMENT" }, Wd.CABLESEGMENT = { type: 3, value: "CABLESEGMENT" }, Wd.CONDUCTORSEGMENT = { type: 3, value: "CONDUCTORSEGMENT" }, Wd.CONTACTWIRESEGMENT = { type: 3, value: "CONTACTWIRESEGMENT" }, Wd.CORESEGMENT = { type: 3, value: "CORESEGMENT" }, Wd.FIBERSEGMENT = { type: 3, value: "FIBERSEGMENT" }, Wd.FIBERTUBE = { type: 3, value: "FIBERTUBE" }, Wd.OPTICALCABLESEGMENT = { type: 3, value: "OPTICALCABLESEGMENT" }, Wd.STITCHWIRE = { type: 3, value: "STITCHWIRE" }, Wd.WIREPAIRSEGMENT = { type: 3, value: "WIREPAIRSEGMENT" }, Wd.USERDEFINED = { type: 3, value: "USERDEFINED" }, Wd.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let p0 = Wd;
  e.IfcCableSegmentTypeEnum = p0;
  const CT = class CT {
  };
  CT.CAISSON = { type: 3, value: "CAISSON" }, CT.WELL = { type: 3, value: "WELL" }, CT.USERDEFINED = { type: 3, value: "USERDEFINED" }, CT.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Lf = CT;
  e.IfcCaissonFoundationTypeEnum = Lf;
  const Kc = class Kc {
  };
  Kc.ADDED = { type: 3, value: "ADDED" }, Kc.DELETED = { type: 3, value: "DELETED" }, Kc.MODIFIED = { type: 3, value: "MODIFIED" }, Kc.NOCHANGE = { type: 3, value: "NOCHANGE" }, Kc.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let _f = Kc;
  e.IfcChangeActionEnum = _f;
  const KE = class KE {
  };
  KE.AIRCOOLED = { type: 3, value: "AIRCOOLED" }, KE.HEATRECOVERY = { type: 3, value: "HEATRECOVERY" }, KE.WATERCOOLED = { type: 3, value: "WATERCOOLED" }, KE.USERDEFINED = { type: 3, value: "USERDEFINED" }, KE.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let xf = KE;
  e.IfcChillerTypeEnum = xf;
  const Am = class Am {
  };
  Am.USERDEFINED = { type: 3, value: "USERDEFINED" }, Am.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let aa = Am;
  e.IfcChimneyTypeEnum = aa;
  const lp = class lp {
  };
  lp.DXCOOLINGCOIL = { type: 3, value: "DXCOOLINGCOIL" }, lp.ELECTRICHEATINGCOIL = { type: 3, value: "ELECTRICHEATINGCOIL" }, lp.GASHEATINGCOIL = { type: 3, value: "GASHEATINGCOIL" }, lp.HYDRONICCOIL = { type: 3, value: "HYDRONICCOIL" }, lp.STEAMHEATINGCOIL = { type: 3, value: "STEAMHEATINGCOIL" }, lp.WATERCOOLINGCOIL = { type: 3, value: "WATERCOOLINGCOIL" }, lp.WATERHEATINGCOIL = { type: 3, value: "WATERHEATINGCOIL" }, lp.USERDEFINED = { type: 3, value: "USERDEFINED" }, lp.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ih = lp;
  e.IfcCoilTypeEnum = Ih;
  const Ql = class Ql {
  };
  Ql.COLUMN = { type: 3, value: "COLUMN" }, Ql.PIERSTEM = { type: 3, value: "PIERSTEM" }, Ql.PIERSTEM_SEGMENT = { type: 3, value: "PIERSTEM_SEGMENT" }, Ql.PILASTER = { type: 3, value: "PILASTER" }, Ql.STANDCOLUMN = { type: 3, value: "STANDCOLUMN" }, Ql.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ql.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let ph = Ql;
  e.IfcColumnTypeEnum = ph;
  const lr = class lr {
  };
  lr.ANTENNA = { type: 3, value: "ANTENNA" }, lr.AUTOMATON = { type: 3, value: "AUTOMATON" }, lr.COMPUTER = { type: 3, value: "COMPUTER" }, lr.FAX = { type: 3, value: "FAX" }, lr.GATEWAY = { type: 3, value: "GATEWAY" }, lr.INTELLIGENTPERIPHERAL = { type: 3, value: "INTELLIGENTPERIPHERAL" }, lr.IPNETWORKEQUIPMENT = { type: 3, value: "IPNETWORKEQUIPMENT" }, lr.LINESIDEELECTRONICUNIT = { type: 3, value: "LINESIDEELECTRONICUNIT" }, lr.MODEM = { type: 3, value: "MODEM" }, lr.NETWORKAPPLIANCE = { type: 3, value: "NETWORKAPPLIANCE" }, lr.NETWORKBRIDGE = { type: 3, value: "NETWORKBRIDGE" }, lr.NETWORKHUB = { type: 3, value: "NETWORKHUB" }, lr.OPTICALLINETERMINAL = { type: 3, value: "OPTICALLINETERMINAL" }, lr.OPTICALNETWORKUNIT = { type: 3, value: "OPTICALNETWORKUNIT" }, lr.PRINTER = { type: 3, value: "PRINTER" }, lr.RADIOBLOCKCENTER = { type: 3, value: "RADIOBLOCKCENTER" }, lr.REPEATER = { type: 3, value: "REPEATER" }, lr.ROUTER = { type: 3, value: "ROUTER" }, lr.SCANNER = { type: 3, value: "SCANNER" }, lr.TELECOMMAND = { type: 3, value: "TELECOMMAND" }, lr.TELEPHONYEXCHANGE = { type: 3, value: "TELEPHONYEXCHANGE" }, lr.TRANSITIONCOMPONENT = { type: 3, value: "TRANSITIONCOMPONENT" }, lr.TRANSPONDER = { type: 3, value: "TRANSPONDER" }, lr.TRANSPORTEQUIPMENT = { type: 3, value: "TRANSPORTEQUIPMENT" }, lr.USERDEFINED = { type: 3, value: "USERDEFINED" }, lr.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let m0 = lr;
  e.IfcCommunicationsApplianceTypeEnum = m0;
  const Gw = class Gw {
  };
  Gw.P_COMPLEX = { type: 3, value: "P_COMPLEX" }, Gw.Q_COMPLEX = { type: 3, value: "Q_COMPLEX" };
  let Nc = Gw;
  e.IfcComplexPropertyTemplateTypeEnum = Nc;
  const Jl = class Jl {
  };
  Jl.BOOSTER = { type: 3, value: "BOOSTER" }, Jl.DYNAMIC = { type: 3, value: "DYNAMIC" }, Jl.HERMETIC = { type: 3, value: "HERMETIC" }, Jl.OPENTYPE = { type: 3, value: "OPENTYPE" }, Jl.RECIPROCATING = { type: 3, value: "RECIPROCATING" }, Jl.ROLLINGPISTON = { type: 3, value: "ROLLINGPISTON" }, Jl.ROTARY = { type: 3, value: "ROTARY" }, Jl.ROTARYVANE = { type: 3, value: "ROTARYVANE" }, Jl.SCROLL = { type: 3, value: "SCROLL" }, Jl.SEMIHERMETIC = { type: 3, value: "SEMIHERMETIC" }, Jl.SINGLESCREW = { type: 3, value: "SINGLESCREW" }, Jl.SINGLESTAGE = { type: 3, value: "SINGLESTAGE" }, Jl.TROCHOIDAL = { type: 3, value: "TROCHOIDAL" }, Jl.TWINSCREW = { type: 3, value: "TWINSCREW" }, Jl.WELDEDSHELLHERMETIC = { type: 3, value: "WELDEDSHELLHERMETIC" }, Jl.USERDEFINED = { type: 3, value: "USERDEFINED" }, Jl.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Nd = Jl;
  e.IfcCompressorTypeEnum = Nd;
  const Zc = class Zc {
  };
  Zc.AIRCOOLED = { type: 3, value: "AIRCOOLED" }, Zc.EVAPORATIVECOOLED = { type: 3, value: "EVAPORATIVECOOLED" }, Zc.WATERCOOLED = { type: 3, value: "WATERCOOLED" }, Zc.WATERCOOLEDBRAZEDPLATE = { type: 3, value: "WATERCOOLEDBRAZEDPLATE" }, Zc.WATERCOOLEDSHELLCOIL = { type: 3, value: "WATERCOOLEDSHELLCOIL" }, Zc.WATERCOOLEDSHELLTUBE = { type: 3, value: "WATERCOOLEDSHELLTUBE" }, Zc.WATERCOOLEDTUBEINTUBE = { type: 3, value: "WATERCOOLEDTUBEINTUBE" }, Zc.USERDEFINED = { type: 3, value: "USERDEFINED" }, Zc.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Dd = Zc;
  e.IfcCondenserTypeEnum = Dd;
  const Sm = class Sm {
  };
  Sm.ATEND = { type: 3, value: "ATEND" }, Sm.ATPATH = { type: 3, value: "ATPATH" }, Sm.ATSTART = { type: 3, value: "ATSTART" }, Sm.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Dc = Sm;
  e.IfcConnectionTypeEnum = Dc;
  const ZE = class ZE {
  };
  ZE.ADVISORY = { type: 3, value: "ADVISORY" }, ZE.HARD = { type: 3, value: "HARD" }, ZE.SOFT = { type: 3, value: "SOFT" }, ZE.USERDEFINED = { type: 3, value: "USERDEFINED" }, ZE.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Cc = ZE;
  e.IfcConstraintEnum = Cc;
  const Yd = class Yd {
  };
  Yd.DEMOLISHING = { type: 3, value: "DEMOLISHING" }, Yd.EARTHMOVING = { type: 3, value: "EARTHMOVING" }, Yd.ERECTING = { type: 3, value: "ERECTING" }, Yd.HEATING = { type: 3, value: "HEATING" }, Yd.LIGHTING = { type: 3, value: "LIGHTING" }, Yd.PAVING = { type: 3, value: "PAVING" }, Yd.PUMPING = { type: 3, value: "PUMPING" }, Yd.TRANSPORTING = { type: 3, value: "TRANSPORTING" }, Yd.USERDEFINED = { type: 3, value: "USERDEFINED" }, Yd.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let mh = Yd;
  e.IfcConstructionEquipmentResourceTypeEnum = mh;
  const Uh = class Uh {
  };
  Uh.AGGREGATES = { type: 3, value: "AGGREGATES" }, Uh.CONCRETE = { type: 3, value: "CONCRETE" }, Uh.DRYWALL = { type: 3, value: "DRYWALL" }, Uh.FUEL = { type: 3, value: "FUEL" }, Uh.GYPSUM = { type: 3, value: "GYPSUM" }, Uh.MASONRY = { type: 3, value: "MASONRY" }, Uh.METAL = { type: 3, value: "METAL" }, Uh.PLASTIC = { type: 3, value: "PLASTIC" }, Uh.WOOD = { type: 3, value: "WOOD" }, Uh.USERDEFINED = { type: 3, value: "USERDEFINED" }, Uh.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Go = Uh;
  e.IfcConstructionMaterialResourceTypeEnum = Go;
  const OT = class OT {
  };
  OT.ASSEMBLY = { type: 3, value: "ASSEMBLY" }, OT.FORMWORK = { type: 3, value: "FORMWORK" }, OT.USERDEFINED = { type: 3, value: "USERDEFINED" }, OT.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Oc = OT;
  e.IfcConstructionProductResourceTypeEnum = Oc;
  const co = class co {
  };
  co.FLOATING = { type: 3, value: "FLOATING" }, co.MULTIPOSITION = { type: 3, value: "MULTIPOSITION" }, co.PROGRAMMABLE = { type: 3, value: "PROGRAMMABLE" }, co.PROPORTIONAL = { type: 3, value: "PROPORTIONAL" }, co.TWOPOSITION = { type: 3, value: "TWOPOSITION" }, co.USERDEFINED = { type: 3, value: "USERDEFINED" }, co.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Lc = co;
  e.IfcControllerTypeEnum = Lc;
  const Qc = class Qc {
  };
  Qc.BELTCONVEYOR = { type: 3, value: "BELTCONVEYOR" }, Qc.BUCKETCONVEYOR = { type: 3, value: "BUCKETCONVEYOR" }, Qc.CHUTECONVEYOR = { type: 3, value: "CHUTECONVEYOR" }, Qc.SCREWCONVEYOR = { type: 3, value: "SCREWCONVEYOR" }, Qc.USERDEFINED = { type: 3, value: "USERDEFINED" }, Qc.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let _c = Qc;
  e.IfcConveyorSegmentTypeEnum = _c;
  const bm = class bm {
  };
  bm.ACTIVE = { type: 3, value: "ACTIVE" }, bm.PASSIVE = { type: 3, value: "PASSIVE" }, bm.USERDEFINED = { type: 3, value: "USERDEFINED" }, bm.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let xc = bm;
  e.IfcCooledBeamTypeEnum = xc;
  const xr = class xr {
  };
  xr.MECHANICALFORCEDDRAFT = { type: 3, value: "MECHANICALFORCEDDRAFT" }, xr.MECHANICALINDUCEDDRAFT = { type: 3, value: "MECHANICALINDUCEDDRAFT" }, xr.NATURALDRAFT = { type: 3, value: "NATURALDRAFT" }, xr.USERDEFINED = { type: 3, value: "USERDEFINED" }, xr.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Cd = xr;
  e.IfcCoolingTowerTypeEnum = Cd;
  const $R = class $R {
  };
  $R.USERDEFINED = { type: 3, value: "USERDEFINED" }, $R.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let xl = $R;
  e.IfcCostItemTypeEnum = xl;
  const qd = class qd {
  };
  qd.BUDGET = { type: 3, value: "BUDGET" }, qd.COSTPLAN = { type: 3, value: "COSTPLAN" }, qd.ESTIMATE = { type: 3, value: "ESTIMATE" }, qd.PRICEDBILLOFQUANTITIES = { type: 3, value: "PRICEDBILLOFQUANTITIES" }, qd.SCHEDULEOFRATES = { type: 3, value: "SCHEDULEOFRATES" }, qd.TENDER = { type: 3, value: "TENDER" }, qd.UNPRICEDBILLOFQUANTITIES = { type: 3, value: "UNPRICEDBILLOFQUANTITIES" }, qd.USERDEFINED = { type: 3, value: "USERDEFINED" }, qd.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let yh = qd;
  e.IfcCostScheduleTypeEnum = yh;
  const Ou = class Ou {
  };
  Ou.ARMOUR = { type: 3, value: "ARMOUR" }, Ou.BALLASTBED = { type: 3, value: "BALLASTBED" }, Ou.CORE = { type: 3, value: "CORE" }, Ou.FILTER = { type: 3, value: "FILTER" }, Ou.PAVEMENT = { type: 3, value: "PAVEMENT" }, Ou.PROTECTION = { type: 3, value: "PROTECTION" }, Ou.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ou.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Eh = Ou;
  e.IfcCourseTypeEnum = Eh;
  const Al = class Al {
  };
  Al.CEILING = { type: 3, value: "CEILING" }, Al.CLADDING = { type: 3, value: "CLADDING" }, Al.COPING = { type: 3, value: "COPING" }, Al.FLOORING = { type: 3, value: "FLOORING" }, Al.INSULATION = { type: 3, value: "INSULATION" }, Al.MEMBRANE = { type: 3, value: "MEMBRANE" }, Al.MOLDING = { type: 3, value: "MOLDING" }, Al.ROOFING = { type: 3, value: "ROOFING" }, Al.SKIRTINGBOARD = { type: 3, value: "SKIRTINGBOARD" }, Al.SLEEVING = { type: 3, value: "SLEEVING" }, Al.TOPPING = { type: 3, value: "TOPPING" }, Al.WRAPPING = { type: 3, value: "WRAPPING" }, Al.USERDEFINED = { type: 3, value: "USERDEFINED" }, Al.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let LI = Al;
  e.IfcCoveringTypeEnum = LI;
  const ed = class ed {
  };
  ed.OFFICE = { type: 3, value: "OFFICE" }, ed.SITE = { type: 3, value: "SITE" }, ed.USERDEFINED = { type: 3, value: "USERDEFINED" }, ed.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Pf = ed;
  e.IfcCrewResourceTypeEnum = Pf;
  const kw = class kw {
  };
  kw.USERDEFINED = { type: 3, value: "USERDEFINED" }, kw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Bi = kw;
  e.IfcCurtainWallTypeEnum = Bi;
  const ap = class ap {
  };
  ap.LINEAR = { type: 3, value: "LINEAR" }, ap.LOG_LINEAR = { type: 3, value: "LOG_LINEAR" }, ap.LOG_LOG = { type: 3, value: "LOG_LOG" }, ap.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let qu = ap;
  e.IfcCurveInterpolationEnum = qu;
  const gl = class gl {
  };
  gl.BACKDRAFTDAMPER = { type: 3, value: "BACKDRAFTDAMPER" }, gl.BALANCINGDAMPER = { type: 3, value: "BALANCINGDAMPER" }, gl.BLASTDAMPER = { type: 3, value: "BLASTDAMPER" }, gl.CONTROLDAMPER = { type: 3, value: "CONTROLDAMPER" }, gl.FIREDAMPER = { type: 3, value: "FIREDAMPER" }, gl.FIRESMOKEDAMPER = { type: 3, value: "FIRESMOKEDAMPER" }, gl.FUMEHOODEXHAUST = { type: 3, value: "FUMEHOODEXHAUST" }, gl.GRAVITYDAMPER = { type: 3, value: "GRAVITYDAMPER" }, gl.GRAVITYRELIEFDAMPER = { type: 3, value: "GRAVITYRELIEFDAMPER" }, gl.RELIEFDAMPER = { type: 3, value: "RELIEFDAMPER" }, gl.SMOKEDAMPER = { type: 3, value: "SMOKEDAMPER" }, gl.USERDEFINED = { type: 3, value: "USERDEFINED" }, gl.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ru = gl;
  e.IfcDamperTypeEnum = Ru;
  const wy = class wy {
  };
  wy.MEASURED = { type: 3, value: "MEASURED" }, wy.PREDICTED = { type: 3, value: "PREDICTED" }, wy.SIMULATED = { type: 3, value: "SIMULATED" }, wy.USERDEFINED = { type: 3, value: "USERDEFINED" }, wy.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Pc = wy;
  e.IfcDataOriginEnum = Pc;
  const kn = class kn {
  };
  kn.ACCELERATIONUNIT = { type: 3, value: "ACCELERATIONUNIT" }, kn.ANGULARVELOCITYUNIT = { type: 3, value: "ANGULARVELOCITYUNIT" }, kn.AREADENSITYUNIT = { type: 3, value: "AREADENSITYUNIT" }, kn.COMPOUNDPLANEANGLEUNIT = { type: 3, value: "COMPOUNDPLANEANGLEUNIT" }, kn.CURVATUREUNIT = { type: 3, value: "CURVATUREUNIT" }, kn.DYNAMICVISCOSITYUNIT = { type: 3, value: "DYNAMICVISCOSITYUNIT" }, kn.HEATFLUXDENSITYUNIT = { type: 3, value: "HEATFLUXDENSITYUNIT" }, kn.HEATINGVALUEUNIT = { type: 3, value: "HEATINGVALUEUNIT" }, kn.INTEGERCOUNTRATEUNIT = { type: 3, value: "INTEGERCOUNTRATEUNIT" }, kn.IONCONCENTRATIONUNIT = { type: 3, value: "IONCONCENTRATIONUNIT" }, kn.ISOTHERMALMOISTURECAPACITYUNIT = { type: 3, value: "ISOTHERMALMOISTURECAPACITYUNIT" }, kn.KINEMATICVISCOSITYUNIT = { type: 3, value: "KINEMATICVISCOSITYUNIT" }, kn.LINEARFORCEUNIT = { type: 3, value: "LINEARFORCEUNIT" }, kn.LINEARMOMENTUNIT = { type: 3, value: "LINEARMOMENTUNIT" }, kn.LINEARSTIFFNESSUNIT = { type: 3, value: "LINEARSTIFFNESSUNIT" }, kn.LINEARVELOCITYUNIT = { type: 3, value: "LINEARVELOCITYUNIT" }, kn.LUMINOUSINTENSITYDISTRIBUTIONUNIT = { type: 3, value: "LUMINOUSINTENSITYDISTRIBUTIONUNIT" }, kn.MASSDENSITYUNIT = { type: 3, value: "MASSDENSITYUNIT" }, kn.MASSFLOWRATEUNIT = { type: 3, value: "MASSFLOWRATEUNIT" }, kn.MASSPERLENGTHUNIT = { type: 3, value: "MASSPERLENGTHUNIT" }, kn.MODULUSOFELASTICITYUNIT = { type: 3, value: "MODULUSOFELASTICITYUNIT" }, kn.MODULUSOFLINEARSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFLINEARSUBGRADEREACTIONUNIT" }, kn.MODULUSOFROTATIONALSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFROTATIONALSUBGRADEREACTIONUNIT" }, kn.MODULUSOFSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFSUBGRADEREACTIONUNIT" }, kn.MOISTUREDIFFUSIVITYUNIT = { type: 3, value: "MOISTUREDIFFUSIVITYUNIT" }, kn.MOLECULARWEIGHTUNIT = { type: 3, value: "MOLECULARWEIGHTUNIT" }, kn.MOMENTOFINERTIAUNIT = { type: 3, value: "MOMENTOFINERTIAUNIT" }, kn.PHUNIT = { type: 3, value: "PHUNIT" }, kn.PLANARFORCEUNIT = { type: 3, value: "PLANARFORCEUNIT" }, kn.ROTATIONALFREQUENCYUNIT = { type: 3, value: "ROTATIONALFREQUENCYUNIT" }, kn.ROTATIONALMASSUNIT = { type: 3, value: "ROTATIONALMASSUNIT" }, kn.ROTATIONALSTIFFNESSUNIT = { type: 3, value: "ROTATIONALSTIFFNESSUNIT" }, kn.SECTIONAREAINTEGRALUNIT = { type: 3, value: "SECTIONAREAINTEGRALUNIT" }, kn.SECTIONMODULUSUNIT = { type: 3, value: "SECTIONMODULUSUNIT" }, kn.SHEARMODULUSUNIT = { type: 3, value: "SHEARMODULUSUNIT" }, kn.SOUNDPOWERLEVELUNIT = { type: 3, value: "SOUNDPOWERLEVELUNIT" }, kn.SOUNDPOWERUNIT = { type: 3, value: "SOUNDPOWERUNIT" }, kn.SOUNDPRESSURELEVELUNIT = { type: 3, value: "SOUNDPRESSURELEVELUNIT" }, kn.SOUNDPRESSUREUNIT = { type: 3, value: "SOUNDPRESSUREUNIT" }, kn.SPECIFICHEATCAPACITYUNIT = { type: 3, value: "SPECIFICHEATCAPACITYUNIT" }, kn.TEMPERATUREGRADIENTUNIT = { type: 3, value: "TEMPERATUREGRADIENTUNIT" }, kn.TEMPERATURERATEOFCHANGEUNIT = { type: 3, value: "TEMPERATURERATEOFCHANGEUNIT" }, kn.THERMALADMITTANCEUNIT = { type: 3, value: "THERMALADMITTANCEUNIT" }, kn.THERMALCONDUCTANCEUNIT = { type: 3, value: "THERMALCONDUCTANCEUNIT" }, kn.THERMALEXPANSIONCOEFFICIENTUNIT = { type: 3, value: "THERMALEXPANSIONCOEFFICIENTUNIT" }, kn.THERMALRESISTANCEUNIT = { type: 3, value: "THERMALRESISTANCEUNIT" }, kn.THERMALTRANSMITTANCEUNIT = { type: 3, value: "THERMALTRANSMITTANCEUNIT" }, kn.TORQUEUNIT = { type: 3, value: "TORQUEUNIT" }, kn.VAPORPERMEABILITYUNIT = { type: 3, value: "VAPORPERMEABILITYUNIT" }, kn.VOLUMETRICFLOWRATEUNIT = { type: 3, value: "VOLUMETRICFLOWRATEUNIT" }, kn.WARPINGCONSTANTUNIT = { type: 3, value: "WARPINGCONSTANTUNIT" }, kn.WARPINGMOMENTUNIT = { type: 3, value: "WARPINGMOMENTUNIT" }, kn.USERDEFINED = { type: 3, value: "USERDEFINED" };
  let Od = kn;
  e.IfcDerivedUnitEnum = Od;
  const LT = class LT {
  };
  LT.NEGATIVE = { type: 3, value: "NEGATIVE" }, LT.POSITIVE = { type: 3, value: "POSITIVE" };
  let gh = LT;
  e.IfcDirectionSenseEnum = gh;
  const Pr = class Pr {
  };
  Pr.ANCHORPLATE = { type: 3, value: "ANCHORPLATE" }, Pr.BIRDPROTECTION = { type: 3, value: "BIRDPROTECTION" }, Pr.BRACKET = { type: 3, value: "BRACKET" }, Pr.CABLEARRANGER = { type: 3, value: "CABLEARRANGER" }, Pr.ELASTIC_CUSHION = { type: 3, value: "ELASTIC_CUSHION" }, Pr.EXPANSION_JOINT_DEVICE = { type: 3, value: "EXPANSION_JOINT_DEVICE" }, Pr.FILLER = { type: 3, value: "FILLER" }, Pr.FLASHING = { type: 3, value: "FLASHING" }, Pr.INSULATOR = { type: 3, value: "INSULATOR" }, Pr.LOCK = { type: 3, value: "LOCK" }, Pr.PANEL_STRENGTHENING = { type: 3, value: "PANEL_STRENGTHENING" }, Pr.POINTMACHINEMOUNTINGDEVICE = { type: 3, value: "POINTMACHINEMOUNTINGDEVICE" }, Pr.POINT_MACHINE_LOCKING_DEVICE = { type: 3, value: "POINT_MACHINE_LOCKING_DEVICE" }, Pr.RAILBRACE = { type: 3, value: "RAILBRACE" }, Pr.RAILPAD = { type: 3, value: "RAILPAD" }, Pr.RAIL_LUBRICATION = { type: 3, value: "RAIL_LUBRICATION" }, Pr.RAIL_MECHANICAL_EQUIPMENT = { type: 3, value: "RAIL_MECHANICAL_EQUIPMENT" }, Pr.SHOE = { type: 3, value: "SHOE" }, Pr.SLIDINGCHAIR = { type: 3, value: "SLIDINGCHAIR" }, Pr.SOUNDABSORPTION = { type: 3, value: "SOUNDABSORPTION" }, Pr.TENSIONINGEQUIPMENT = { type: 3, value: "TENSIONINGEQUIPMENT" }, Pr.USERDEFINED = { type: 3, value: "USERDEFINED" }, Pr.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Mc = Pr;
  e.IfcDiscreteAccessoryTypeEnum = Mc;
  const Xf = class Xf {
  };
  Xf.CONSUMERUNIT = { type: 3, value: "CONSUMERUNIT" }, Xf.DISPATCHINGBOARD = { type: 3, value: "DISPATCHINGBOARD" }, Xf.DISTRIBUTIONBOARD = { type: 3, value: "DISTRIBUTIONBOARD" }, Xf.DISTRIBUTIONFRAME = { type: 3, value: "DISTRIBUTIONFRAME" }, Xf.MOTORCONTROLCENTRE = { type: 3, value: "MOTORCONTROLCENTRE" }, Xf.SWITCHBOARD = { type: 3, value: "SWITCHBOARD" }, Xf.USERDEFINED = { type: 3, value: "USERDEFINED" }, Xf.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Uc = Xf;
  e.IfcDistributionBoardTypeEnum = Uc;
  const de = class de {
  };
  de.FORMEDDUCT = { type: 3, value: "FORMEDDUCT" }, de.INSPECTIONCHAMBER = { type: 3, value: "INSPECTIONCHAMBER" }, de.INSPECTIONPIT = { type: 3, value: "INSPECTIONPIT" }, de.MANHOLE = { type: 3, value: "MANHOLE" }, de.METERCHAMBER = { type: 3, value: "METERCHAMBER" }, de.SUMP = { type: 3, value: "SUMP" }, de.TRENCH = { type: 3, value: "TRENCH" }, de.VALVECHAMBER = { type: 3, value: "VALVECHAMBER" }, de.USERDEFINED = { type: 3, value: "USERDEFINED" }, de.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let $u = de;
  e.IfcDistributionChamberElementTypeEnum = $u;
  const w = class w {
  };
  w.CABLE = { type: 3, value: "CABLE" }, w.CABLECARRIER = { type: 3, value: "CABLECARRIER" }, w.DUCT = { type: 3, value: "DUCT" }, w.PIPE = { type: 3, value: "PIPE" }, w.WIRELESS = { type: 3, value: "WIRELESS" }, w.USERDEFINED = { type: 3, value: "USERDEFINED" }, w.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let ua = w;
  e.IfcDistributionPortTypeEnum = ua;
  const v = class v {
  };
  v.AIRCONDITIONING = { type: 3, value: "AIRCONDITIONING" }, v.AUDIOVISUAL = { type: 3, value: "AUDIOVISUAL" }, v.CATENARY_SYSTEM = { type: 3, value: "CATENARY_SYSTEM" }, v.CHEMICAL = { type: 3, value: "CHEMICAL" }, v.CHILLEDWATER = { type: 3, value: "CHILLEDWATER" }, v.COMMUNICATION = { type: 3, value: "COMMUNICATION" }, v.COMPRESSEDAIR = { type: 3, value: "COMPRESSEDAIR" }, v.CONDENSERWATER = { type: 3, value: "CONDENSERWATER" }, v.CONTROL = { type: 3, value: "CONTROL" }, v.CONVEYING = { type: 3, value: "CONVEYING" }, v.DATA = { type: 3, value: "DATA" }, v.DISPOSAL = { type: 3, value: "DISPOSAL" }, v.DOMESTICCOLDWATER = { type: 3, value: "DOMESTICCOLDWATER" }, v.DOMESTICHOTWATER = { type: 3, value: "DOMESTICHOTWATER" }, v.DRAINAGE = { type: 3, value: "DRAINAGE" }, v.EARTHING = { type: 3, value: "EARTHING" }, v.ELECTRICAL = { type: 3, value: "ELECTRICAL" }, v.ELECTROACOUSTIC = { type: 3, value: "ELECTROACOUSTIC" }, v.EXHAUST = { type: 3, value: "EXHAUST" }, v.FIREPROTECTION = { type: 3, value: "FIREPROTECTION" }, v.FIXEDTRANSMISSIONNETWORK = { type: 3, value: "FIXEDTRANSMISSIONNETWORK" }, v.FUEL = { type: 3, value: "FUEL" }, v.GAS = { type: 3, value: "GAS" }, v.HAZARDOUS = { type: 3, value: "HAZARDOUS" }, v.HEATING = { type: 3, value: "HEATING" }, v.LIGHTING = { type: 3, value: "LIGHTING" }, v.LIGHTNINGPROTECTION = { type: 3, value: "LIGHTNINGPROTECTION" }, v.MOBILENETWORK = { type: 3, value: "MOBILENETWORK" }, v.MONITORINGSYSTEM = { type: 3, value: "MONITORINGSYSTEM" }, v.MUNICIPALSOLIDWASTE = { type: 3, value: "MUNICIPALSOLIDWASTE" }, v.OIL = { type: 3, value: "OIL" }, v.OPERATIONAL = { type: 3, value: "OPERATIONAL" }, v.OPERATIONALTELEPHONYSYSTEM = { type: 3, value: "OPERATIONALTELEPHONYSYSTEM" }, v.OVERHEAD_CONTACTLINE_SYSTEM = { type: 3, value: "OVERHEAD_CONTACTLINE_SYSTEM" }, v.POWERGENERATION = { type: 3, value: "POWERGENERATION" }, v.RAINWATER = { type: 3, value: "RAINWATER" }, v.REFRIGERATION = { type: 3, value: "REFRIGERATION" }, v.RETURN_CIRCUIT = { type: 3, value: "RETURN_CIRCUIT" }, v.SECURITY = { type: 3, value: "SECURITY" }, v.SEWAGE = { type: 3, value: "SEWAGE" }, v.SIGNAL = { type: 3, value: "SIGNAL" }, v.STORMWATER = { type: 3, value: "STORMWATER" }, v.TELEPHONE = { type: 3, value: "TELEPHONE" }, v.TV = { type: 3, value: "TV" }, v.VACUUM = { type: 3, value: "VACUUM" }, v.VENT = { type: 3, value: "VENT" }, v.VENTILATION = { type: 3, value: "VENTILATION" }, v.WASTEWATER = { type: 3, value: "WASTEWATER" }, v.WATERSUPPLY = { type: 3, value: "WATERSUPPLY" }, v.USERDEFINED = { type: 3, value: "USERDEFINED" }, v.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Bc = v;
  e.IfcDistributionSystemEnum = Bc;
  const N = class N {
  };
  N.CONFIDENTIAL = { type: 3, value: "CONFIDENTIAL" }, N.PERSONAL = { type: 3, value: "PERSONAL" }, N.PUBLIC = { type: 3, value: "PUBLIC" }, N.RESTRICTED = { type: 3, value: "RESTRICTED" }, N.USERDEFINED = { type: 3, value: "USERDEFINED" }, N.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Fc = N;
  e.IfcDocumentConfidentialityEnum = Fc;
  const x = class x {
  };
  x.DRAFT = { type: 3, value: "DRAFT" }, x.FINAL = { type: 3, value: "FINAL" }, x.FINALDRAFT = { type: 3, value: "FINALDRAFT" }, x.REVISION = { type: 3, value: "REVISION" }, x.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let y0 = x;
  e.IfcDocumentStatusEnum = y0;
  const G = class G {
  };
  G.DOUBLE_ACTING = { type: 3, value: "DOUBLE_ACTING" }, G.FIXEDPANEL = { type: 3, value: "FIXEDPANEL" }, G.FOLDING = { type: 3, value: "FOLDING" }, G.REVOLVING = { type: 3, value: "REVOLVING" }, G.ROLLINGUP = { type: 3, value: "ROLLINGUP" }, G.SLIDING = { type: 3, value: "SLIDING" }, G.SWINGING = { type: 3, value: "SWINGING" }, G.USERDEFINED = { type: 3, value: "USERDEFINED" }, G.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Wl = G;
  e.IfcDoorPanelOperationEnum = Wl;
  const j = class j {
  };
  j.LEFT = { type: 3, value: "LEFT" }, j.MIDDLE = { type: 3, value: "MIDDLE" }, j.RIGHT = { type: 3, value: "RIGHT" }, j.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Mf = j;
  e.IfcDoorPanelPositionEnum = Mf;
  const K = class K {
  };
  K.ALUMINIUM = { type: 3, value: "ALUMINIUM" }, K.ALUMINIUM_PLASTIC = { type: 3, value: "ALUMINIUM_PLASTIC" }, K.ALUMINIUM_WOOD = { type: 3, value: "ALUMINIUM_WOOD" }, K.HIGH_GRADE_STEEL = { type: 3, value: "HIGH_GRADE_STEEL" }, K.PLASTIC = { type: 3, value: "PLASTIC" }, K.STEEL = { type: 3, value: "STEEL" }, K.WOOD = { type: 3, value: "WOOD" }, K.USERDEFINED = { type: 3, value: "USERDEFINED" }, K.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let m3 = K;
  e.IfcDoorStyleConstructionEnum = m3;
  const Q = class Q {
  };
  Q.DOUBLE_DOOR_DOUBLE_SWING = { type: 3, value: "DOUBLE_DOOR_DOUBLE_SWING" }, Q.DOUBLE_DOOR_FOLDING = { type: 3, value: "DOUBLE_DOOR_FOLDING" }, Q.DOUBLE_DOOR_SINGLE_SWING = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING" }, Q.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT" }, Q.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT" }, Q.DOUBLE_DOOR_SLIDING = { type: 3, value: "DOUBLE_DOOR_SLIDING" }, Q.DOUBLE_SWING_LEFT = { type: 3, value: "DOUBLE_SWING_LEFT" }, Q.DOUBLE_SWING_RIGHT = { type: 3, value: "DOUBLE_SWING_RIGHT" }, Q.FOLDING_TO_LEFT = { type: 3, value: "FOLDING_TO_LEFT" }, Q.FOLDING_TO_RIGHT = { type: 3, value: "FOLDING_TO_RIGHT" }, Q.REVOLVING = { type: 3, value: "REVOLVING" }, Q.ROLLINGUP = { type: 3, value: "ROLLINGUP" }, Q.SINGLE_SWING_LEFT = { type: 3, value: "SINGLE_SWING_LEFT" }, Q.SINGLE_SWING_RIGHT = { type: 3, value: "SINGLE_SWING_RIGHT" }, Q.SLIDING_TO_LEFT = { type: 3, value: "SLIDING_TO_LEFT" }, Q.SLIDING_TO_RIGHT = { type: 3, value: "SLIDING_TO_RIGHT" }, Q.USERDEFINED = { type: 3, value: "USERDEFINED" }, Q.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let y3 = Q;
  e.IfcDoorStyleOperationEnum = y3;
  const he = class he {
  };
  he.BOOM_BARRIER = { type: 3, value: "BOOM_BARRIER" }, he.DOOR = { type: 3, value: "DOOR" }, he.GATE = { type: 3, value: "GATE" }, he.TRAPDOOR = { type: 3, value: "TRAPDOOR" }, he.TURNSTILE = { type: 3, value: "TURNSTILE" }, he.USERDEFINED = { type: 3, value: "USERDEFINED" }, he.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let ko = he;
  e.IfcDoorTypeEnum = ko;
  const Ze = class Ze {
  };
  Ze.DOUBLE_PANEL_DOUBLE_SWING = { type: 3, value: "DOUBLE_PANEL_DOUBLE_SWING" }, Ze.DOUBLE_PANEL_FOLDING = { type: 3, value: "DOUBLE_PANEL_FOLDING" }, Ze.DOUBLE_PANEL_LIFTING_VERTICAL = { type: 3, value: "DOUBLE_PANEL_LIFTING_VERTICAL" }, Ze.DOUBLE_PANEL_SINGLE_SWING = { type: 3, value: "DOUBLE_PANEL_SINGLE_SWING" }, Ze.DOUBLE_PANEL_SINGLE_SWING_OPPOSITE_LEFT = { type: 3, value: "DOUBLE_PANEL_SINGLE_SWING_OPPOSITE_LEFT" }, Ze.DOUBLE_PANEL_SINGLE_SWING_OPPOSITE_RIGHT = { type: 3, value: "DOUBLE_PANEL_SINGLE_SWING_OPPOSITE_RIGHT" }, Ze.DOUBLE_PANEL_SLIDING = { type: 3, value: "DOUBLE_PANEL_SLIDING" }, Ze.DOUBLE_SWING_LEFT = { type: 3, value: "DOUBLE_SWING_LEFT" }, Ze.DOUBLE_SWING_RIGHT = { type: 3, value: "DOUBLE_SWING_RIGHT" }, Ze.FOLDING_TO_LEFT = { type: 3, value: "FOLDING_TO_LEFT" }, Ze.FOLDING_TO_RIGHT = { type: 3, value: "FOLDING_TO_RIGHT" }, Ze.LIFTING_HORIZONTAL = { type: 3, value: "LIFTING_HORIZONTAL" }, Ze.LIFTING_VERTICAL_LEFT = { type: 3, value: "LIFTING_VERTICAL_LEFT" }, Ze.LIFTING_VERTICAL_RIGHT = { type: 3, value: "LIFTING_VERTICAL_RIGHT" }, Ze.REVOLVING_HORIZONTAL = { type: 3, value: "REVOLVING_HORIZONTAL" }, Ze.REVOLVING_VERTICAL = { type: 3, value: "REVOLVING_VERTICAL" }, Ze.ROLLINGUP = { type: 3, value: "ROLLINGUP" }, Ze.SINGLE_SWING_LEFT = { type: 3, value: "SINGLE_SWING_LEFT" }, Ze.SINGLE_SWING_RIGHT = { type: 3, value: "SINGLE_SWING_RIGHT" }, Ze.SLIDING_TO_LEFT = { type: 3, value: "SLIDING_TO_LEFT" }, Ze.SLIDING_TO_RIGHT = { type: 3, value: "SLIDING_TO_RIGHT" }, Ze.SWING_FIXED_LEFT = { type: 3, value: "SWING_FIXED_LEFT" }, Ze.SWING_FIXED_RIGHT = { type: 3, value: "SWING_FIXED_RIGHT" }, Ze.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ze.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let E3 = Ze;
  e.IfcDoorTypeOperationEnum = E3;
  const pi = class pi {
  };
  pi.BEND = { type: 3, value: "BEND" }, pi.CONNECTOR = { type: 3, value: "CONNECTOR" }, pi.ENTRY = { type: 3, value: "ENTRY" }, pi.EXIT = { type: 3, value: "EXIT" }, pi.JUNCTION = { type: 3, value: "JUNCTION" }, pi.OBSTRUCTION = { type: 3, value: "OBSTRUCTION" }, pi.TRANSITION = { type: 3, value: "TRANSITION" }, pi.USERDEFINED = { type: 3, value: "USERDEFINED" }, pi.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let _I = pi;
  e.IfcDuctFittingTypeEnum = _I;
  const Ki = class Ki {
  };
  Ki.FLEXIBLESEGMENT = { type: 3, value: "FLEXIBLESEGMENT" }, Ki.RIGIDSEGMENT = { type: 3, value: "RIGIDSEGMENT" }, Ki.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ki.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let g3 = Ki;
  e.IfcDuctSegmentTypeEnum = g3;
  const Vn = class Vn {
  };
  Vn.FLATOVAL = { type: 3, value: "FLATOVAL" }, Vn.RECTANGULAR = { type: 3, value: "RECTANGULAR" }, Vn.ROUND = { type: 3, value: "ROUND" }, Vn.USERDEFINED = { type: 3, value: "USERDEFINED" }, Vn.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let w3 = Vn;
  e.IfcDuctSilencerTypeEnum = w3;
  const ks = class ks {
  };
  ks.BASE_EXCAVATION = { type: 3, value: "BASE_EXCAVATION" }, ks.CUT = { type: 3, value: "CUT" }, ks.DREDGING = { type: 3, value: "DREDGING" }, ks.EXCAVATION = { type: 3, value: "EXCAVATION" }, ks.OVEREXCAVATION = { type: 3, value: "OVEREXCAVATION" }, ks.PAVEMENTMILLING = { type: 3, value: "PAVEMENTMILLING" }, ks.STEPEXCAVATION = { type: 3, value: "STEPEXCAVATION" }, ks.TOPSOILREMOVAL = { type: 3, value: "TOPSOILREMOVAL" }, ks.TRENCH = { type: 3, value: "TRENCH" }, ks.USERDEFINED = { type: 3, value: "USERDEFINED" }, ks.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let xI = ks;
  e.IfcEarthworksCutTypeEnum = xI;
  const gr = class gr {
  };
  gr.BACKFILL = { type: 3, value: "BACKFILL" }, gr.COUNTERWEIGHT = { type: 3, value: "COUNTERWEIGHT" }, gr.EMBANKMENT = { type: 3, value: "EMBANKMENT" }, gr.SLOPEFILL = { type: 3, value: "SLOPEFILL" }, gr.SUBGRADE = { type: 3, value: "SUBGRADE" }, gr.SUBGRADEBED = { type: 3, value: "SUBGRADEBED" }, gr.TRANSITIONSECTION = { type: 3, value: "TRANSITIONSECTION" }, gr.USERDEFINED = { type: 3, value: "USERDEFINED" }, gr.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let T3 = gr;
  e.IfcEarthworksFillTypeEnum = T3;
  const Ro = class Ro {
  };
  Ro.DISHWASHER = { type: 3, value: "DISHWASHER" }, Ro.ELECTRICCOOKER = { type: 3, value: "ELECTRICCOOKER" }, Ro.FREESTANDINGELECTRICHEATER = { type: 3, value: "FREESTANDINGELECTRICHEATER" }, Ro.FREESTANDINGFAN = { type: 3, value: "FREESTANDINGFAN" }, Ro.FREESTANDINGWATERCOOLER = { type: 3, value: "FREESTANDINGWATERCOOLER" }, Ro.FREESTANDINGWATERHEATER = { type: 3, value: "FREESTANDINGWATERHEATER" }, Ro.FREEZER = { type: 3, value: "FREEZER" }, Ro.FRIDGE_FREEZER = { type: 3, value: "FRIDGE_FREEZER" }, Ro.HANDDRYER = { type: 3, value: "HANDDRYER" }, Ro.KITCHENMACHINE = { type: 3, value: "KITCHENMACHINE" }, Ro.MICROWAVE = { type: 3, value: "MICROWAVE" }, Ro.PHOTOCOPIER = { type: 3, value: "PHOTOCOPIER" }, Ro.REFRIGERATOR = { type: 3, value: "REFRIGERATOR" }, Ro.TUMBLEDRYER = { type: 3, value: "TUMBLEDRYER" }, Ro.VENDINGMACHINE = { type: 3, value: "VENDINGMACHINE" }, Ro.WASHINGMACHINE = { type: 3, value: "WASHINGMACHINE" }, Ro.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ro.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let wh = Ro;
  e.IfcElectricApplianceTypeEnum = wh;
  const ma = class ma {
  };
  ma.CONSUMERUNIT = { type: 3, value: "CONSUMERUNIT" }, ma.DISTRIBUTIONBOARD = { type: 3, value: "DISTRIBUTIONBOARD" }, ma.MOTORCONTROLCENTRE = { type: 3, value: "MOTORCONTROLCENTRE" }, ma.SWITCHBOARD = { type: 3, value: "SWITCHBOARD" }, ma.USERDEFINED = { type: 3, value: "USERDEFINED" }, ma.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let R3 = ma;
  e.IfcElectricDistributionBoardTypeEnum = R3;
  const Lu = class Lu {
  };
  Lu.BATTERY = { type: 3, value: "BATTERY" }, Lu.CAPACITOR = { type: 3, value: "CAPACITOR" }, Lu.CAPACITORBANK = { type: 3, value: "CAPACITORBANK" }, Lu.COMPENSATOR = { type: 3, value: "COMPENSATOR" }, Lu.HARMONICFILTER = { type: 3, value: "HARMONICFILTER" }, Lu.INDUCTOR = { type: 3, value: "INDUCTOR" }, Lu.INDUCTORBANK = { type: 3, value: "INDUCTORBANK" }, Lu.RECHARGER = { type: 3, value: "RECHARGER" }, Lu.UPS = { type: 3, value: "UPS" }, Lu.USERDEFINED = { type: 3, value: "USERDEFINED" }, Lu.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Qs = Lu;
  e.IfcElectricFlowStorageDeviceTypeEnum = Qs;
  const _T = class _T {
  };
  _T.ELECTRONICFILTER = { type: 3, value: "ELECTRONICFILTER" }, _T.USERDEFINED = { type: 3, value: "USERDEFINED" }, _T.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let v3 = _T;
  e.IfcElectricFlowTreatmentDeviceTypeEnum = v3;
  const QE = class QE {
  };
  QE.CHP = { type: 3, value: "CHP" }, QE.ENGINEGENERATOR = { type: 3, value: "ENGINEGENERATOR" }, QE.STANDALONE = { type: 3, value: "STANDALONE" }, QE.USERDEFINED = { type: 3, value: "USERDEFINED" }, QE.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Uf = QE;
  e.IfcElectricGeneratorTypeEnum = Uf;
  const KR = class KR {
  };
  KR.DC = { type: 3, value: "DC" }, KR.INDUCTION = { type: 3, value: "INDUCTION" }, KR.POLYPHASE = { type: 3, value: "POLYPHASE" }, KR.RELUCTANCESYNCHRONOUS = { type: 3, value: "RELUCTANCESYNCHRONOUS" }, KR.SYNCHRONOUS = { type: 3, value: "SYNCHRONOUS" }, KR.USERDEFINED = { type: 3, value: "USERDEFINED" }, KR.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ku = KR;
  e.IfcElectricMotorTypeEnum = Ku;
  const v9 = class v9 {
  };
  v9.RELAY = { type: 3, value: "RELAY" }, v9.TIMECLOCK = { type: 3, value: "TIMECLOCK" }, v9.TIMEDELAY = { type: 3, value: "TIMEDELAY" }, v9.USERDEFINED = { type: 3, value: "USERDEFINED" }, v9.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let PI = v9;
  e.IfcElectricTimeControlTypeEnum = PI;
  const Wr = class Wr {
  };
  Wr.ABUTMENT = { type: 3, value: "ABUTMENT" }, Wr.ACCESSORY_ASSEMBLY = { type: 3, value: "ACCESSORY_ASSEMBLY" }, Wr.ARCH = { type: 3, value: "ARCH" }, Wr.BEAM_GRID = { type: 3, value: "BEAM_GRID" }, Wr.BRACED_FRAME = { type: 3, value: "BRACED_FRAME" }, Wr.CROSS_BRACING = { type: 3, value: "CROSS_BRACING" }, Wr.DECK = { type: 3, value: "DECK" }, Wr.DILATATIONPANEL = { type: 3, value: "DILATATIONPANEL" }, Wr.ENTRANCEWORKS = { type: 3, value: "ENTRANCEWORKS" }, Wr.GIRDER = { type: 3, value: "GIRDER" }, Wr.GRID = { type: 3, value: "GRID" }, Wr.MAST = { type: 3, value: "MAST" }, Wr.PIER = { type: 3, value: "PIER" }, Wr.PYLON = { type: 3, value: "PYLON" }, Wr.RAIL_MECHANICAL_EQUIPMENT_ASSEMBLY = { type: 3, value: "RAIL_MECHANICAL_EQUIPMENT_ASSEMBLY" }, Wr.REINFORCEMENT_UNIT = { type: 3, value: "REINFORCEMENT_UNIT" }, Wr.RIGID_FRAME = { type: 3, value: "RIGID_FRAME" }, Wr.SHELTER = { type: 3, value: "SHELTER" }, Wr.SIGNALASSEMBLY = { type: 3, value: "SIGNALASSEMBLY" }, Wr.SLAB_FIELD = { type: 3, value: "SLAB_FIELD" }, Wr.SUMPBUSTER = { type: 3, value: "SUMPBUSTER" }, Wr.SUPPORTINGASSEMBLY = { type: 3, value: "SUPPORTINGASSEMBLY" }, Wr.SUSPENSIONASSEMBLY = { type: 3, value: "SUSPENSIONASSEMBLY" }, Wr.TRACKPANEL = { type: 3, value: "TRACKPANEL" }, Wr.TRACTION_SWITCHING_ASSEMBLY = { type: 3, value: "TRACTION_SWITCHING_ASSEMBLY" }, Wr.TRAFFIC_CALMING_DEVICE = { type: 3, value: "TRAFFIC_CALMING_DEVICE" }, Wr.TRUSS = { type: 3, value: "TRUSS" }, Wr.TURNOUTPANEL = { type: 3, value: "TURNOUTPANEL" }, Wr.USERDEFINED = { type: 3, value: "USERDEFINED" }, Wr.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Bf = Wr;
  e.IfcElementAssemblyTypeEnum = Bf;
  const sZ = class sZ {
  };
  sZ.COMPLEX = { type: 3, value: "COMPLEX" }, sZ.ELEMENT = { type: 3, value: "ELEMENT" }, sZ.PARTIAL = { type: 3, value: "PARTIAL" };
  let A3 = sZ;
  e.IfcElementCompositionEnum = A3;
  const yk = class yk {
  };
  yk.EXTERNALCOMBUSTION = { type: 3, value: "EXTERNALCOMBUSTION" }, yk.INTERNALCOMBUSTION = { type: 3, value: "INTERNALCOMBUSTION" }, yk.USERDEFINED = { type: 3, value: "USERDEFINED" }, yk.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Hc = yk;
  e.IfcEngineTypeEnum = Hc;
  const Vw = class Vw {
  };
  Vw.DIRECTEVAPORATIVEAIRWASHER = { type: 3, value: "DIRECTEVAPORATIVEAIRWASHER" }, Vw.DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER" }, Vw.DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER" }, Vw.DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER" }, Vw.DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER" }, Vw.INDIRECTDIRECTCOMBINATION = { type: 3, value: "INDIRECTDIRECTCOMBINATION" }, Vw.INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER = { type: 3, value: "INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER" }, Vw.INDIRECTEVAPORATIVEPACKAGEAIRCOOLER = { type: 3, value: "INDIRECTEVAPORATIVEPACKAGEAIRCOOLER" }, Vw.INDIRECTEVAPORATIVEWETCOIL = { type: 3, value: "INDIRECTEVAPORATIVEWETCOIL" }, Vw.USERDEFINED = { type: 3, value: "USERDEFINED" }, Vw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let tm = Vw;
  e.IfcEvaporativeCoolerTypeEnum = tm;
  const zS = class zS {
  };
  zS.DIRECTEXPANSION = { type: 3, value: "DIRECTEXPANSION" }, zS.DIRECTEXPANSIONBRAZEDPLATE = { type: 3, value: "DIRECTEXPANSIONBRAZEDPLATE" }, zS.DIRECTEXPANSIONSHELLANDTUBE = { type: 3, value: "DIRECTEXPANSIONSHELLANDTUBE" }, zS.DIRECTEXPANSIONTUBEINTUBE = { type: 3, value: "DIRECTEXPANSIONTUBEINTUBE" }, zS.FLOODEDSHELLANDTUBE = { type: 3, value: "FLOODEDSHELLANDTUBE" }, zS.SHELLANDCOIL = { type: 3, value: "SHELLANDCOIL" }, zS.USERDEFINED = { type: 3, value: "USERDEFINED" }, zS.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let hs = zS;
  e.IfcEvaporatorTypeEnum = hs;
  const $7 = class $7 {
  };
  $7.EVENTCOMPLEX = { type: 3, value: "EVENTCOMPLEX" }, $7.EVENTMESSAGE = { type: 3, value: "EVENTMESSAGE" }, $7.EVENTRULE = { type: 3, value: "EVENTRULE" }, $7.EVENTTIME = { type: 3, value: "EVENTTIME" }, $7.USERDEFINED = { type: 3, value: "USERDEFINED" }, $7.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let S3 = $7;
  e.IfcEventTriggerTypeEnum = S3;
  const A9 = class A9 {
  };
  A9.ENDEVENT = { type: 3, value: "ENDEVENT" }, A9.INTERMEDIATEEVENT = { type: 3, value: "INTERMEDIATEEVENT" }, A9.STARTEVENT = { type: 3, value: "STARTEVENT" }, A9.USERDEFINED = { type: 3, value: "USERDEFINED" }, A9.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let b3 = A9;
  e.IfcEventTypeEnum = b3;
  const K7 = class K7 {
  };
  K7.EXTERNAL = { type: 3, value: "EXTERNAL" }, K7.EXTERNAL_EARTH = { type: 3, value: "EXTERNAL_EARTH" }, K7.EXTERNAL_FIRE = { type: 3, value: "EXTERNAL_FIRE" }, K7.EXTERNAL_WATER = { type: 3, value: "EXTERNAL_WATER" }, K7.USERDEFINED = { type: 3, value: "USERDEFINED" }, K7.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let N3 = K7;
  e.IfcExternalSpatialElementTypeEnum = N3;
  const xT = class xT {
  };
  xT.ABOVEGROUND = { type: 3, value: "ABOVEGROUND" }, xT.BELOWGROUND = { type: 3, value: "BELOWGROUND" }, xT.JUNCTION = { type: 3, value: "JUNCTION" }, xT.LEVELCROSSING = { type: 3, value: "LEVELCROSSING" }, xT.SEGMENT = { type: 3, value: "SEGMENT" }, xT.SUBSTRUCTURE = { type: 3, value: "SUBSTRUCTURE" }, xT.SUPERSTRUCTURE = { type: 3, value: "SUPERSTRUCTURE" }, xT.TERMINAL = { type: 3, value: "TERMINAL" }, xT.USERDEFINED = { type: 3, value: "USERDEFINED" }, xT.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let D3 = xT;
  e.IfcFacilityPartCommonTypeEnum = D3;
  const Z7 = class Z7 {
  };
  Z7.LATERAL = { type: 3, value: "LATERAL" }, Z7.LONGITUDINAL = { type: 3, value: "LONGITUDINAL" }, Z7.REGION = { type: 3, value: "REGION" }, Z7.VERTICAL = { type: 3, value: "VERTICAL" }, Z7.USERDEFINED = { type: 3, value: "USERDEFINED" }, Z7.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let C3 = Z7;
  e.IfcFacilityUsageEnum = C3;
  const ZR = class ZR {
  };
  ZR.CENTRIFUGALAIRFOIL = { type: 3, value: "CENTRIFUGALAIRFOIL" }, ZR.CENTRIFUGALBACKWARDINCLINEDCURVED = { type: 3, value: "CENTRIFUGALBACKWARDINCLINEDCURVED" }, ZR.CENTRIFUGALFORWARDCURVED = { type: 3, value: "CENTRIFUGALFORWARDCURVED" }, ZR.CENTRIFUGALRADIAL = { type: 3, value: "CENTRIFUGALRADIAL" }, ZR.PROPELLORAXIAL = { type: 3, value: "PROPELLORAXIAL" }, ZR.TUBEAXIAL = { type: 3, value: "TUBEAXIAL" }, ZR.VANEAXIAL = { type: 3, value: "VANEAXIAL" }, ZR.USERDEFINED = { type: 3, value: "USERDEFINED" }, ZR.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let MI = ZR;
  e.IfcFanTypeEnum = MI;
  const S9 = class S9 {
  };
  S9.GLUE = { type: 3, value: "GLUE" }, S9.MORTAR = { type: 3, value: "MORTAR" }, S9.WELD = { type: 3, value: "WELD" }, S9.USERDEFINED = { type: 3, value: "USERDEFINED" }, S9.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let st = S9;
  e.IfcFastenerTypeEnum = st;
  const jS = class jS {
  };
  jS.AIRPARTICLEFILTER = { type: 3, value: "AIRPARTICLEFILTER" }, jS.COMPRESSEDAIRFILTER = { type: 3, value: "COMPRESSEDAIRFILTER" }, jS.ODORFILTER = { type: 3, value: "ODORFILTER" }, jS.OILFILTER = { type: 3, value: "OILFILTER" }, jS.STRAINER = { type: 3, value: "STRAINER" }, jS.WATERFILTER = { type: 3, value: "WATERFILTER" }, jS.USERDEFINED = { type: 3, value: "USERDEFINED" }, jS.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ld = jS;
  e.IfcFilterTypeEnum = Ld;
  const WS = class WS {
  };
  WS.BREECHINGINLET = { type: 3, value: "BREECHINGINLET" }, WS.FIREHYDRANT = { type: 3, value: "FIREHYDRANT" }, WS.FIREMONITOR = { type: 3, value: "FIREMONITOR" }, WS.HOSEREEL = { type: 3, value: "HOSEREEL" }, WS.SPRINKLER = { type: 3, value: "SPRINKLER" }, WS.SPRINKLERDEFLECTOR = { type: 3, value: "SPRINKLERDEFLECTOR" }, WS.USERDEFINED = { type: 3, value: "USERDEFINED" }, WS.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let O3 = WS;
  e.IfcFireSuppressionTerminalTypeEnum = O3;
  const Ek = class Ek {
  };
  Ek.SINK = { type: 3, value: "SINK" }, Ek.SOURCE = { type: 3, value: "SOURCE" }, Ek.SOURCEANDSINK = { type: 3, value: "SOURCEANDSINK" }, Ek.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let UI = Ek;
  e.IfcFlowDirectionEnum = UI;
  const JE = class JE {
  };
  JE.AMMETER = { type: 3, value: "AMMETER" }, JE.COMBINED = { type: 3, value: "COMBINED" }, JE.FREQUENCYMETER = { type: 3, value: "FREQUENCYMETER" }, JE.PHASEANGLEMETER = { type: 3, value: "PHASEANGLEMETER" }, JE.POWERFACTORMETER = { type: 3, value: "POWERFACTORMETER" }, JE.PRESSUREGAUGE = { type: 3, value: "PRESSUREGAUGE" }, JE.THERMOMETER = { type: 3, value: "THERMOMETER" }, JE.VOLTMETER = { type: 3, value: "VOLTMETER" }, JE.VOLTMETER_PEAK = { type: 3, value: "VOLTMETER_PEAK" }, JE.VOLTMETER_RMS = { type: 3, value: "VOLTMETER_RMS" }, JE.USERDEFINED = { type: 3, value: "USERDEFINED" }, JE.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ff = JE;
  e.IfcFlowInstrumentTypeEnum = Ff;
  const Q7 = class Q7 {
  };
  Q7.ENERGYMETER = { type: 3, value: "ENERGYMETER" }, Q7.GASMETER = { type: 3, value: "GASMETER" }, Q7.OILMETER = { type: 3, value: "OILMETER" }, Q7.WATERMETER = { type: 3, value: "WATERMETER" }, Q7.USERDEFINED = { type: 3, value: "USERDEFINED" }, Q7.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let L3 = Q7;
  e.IfcFlowMeterTypeEnum = L3;
  const AD = class AD {
  };
  AD.CAISSON_FOUNDATION = { type: 3, value: "CAISSON_FOUNDATION" }, AD.FOOTING_BEAM = { type: 3, value: "FOOTING_BEAM" }, AD.PAD_FOOTING = { type: 3, value: "PAD_FOOTING" }, AD.PILE_CAP = { type: 3, value: "PILE_CAP" }, AD.STRIP_FOOTING = { type: 3, value: "STRIP_FOOTING" }, AD.USERDEFINED = { type: 3, value: "USERDEFINED" }, AD.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let _3 = AD;
  e.IfcFootingTypeEnum = _3;
  const PT = class PT {
  };
  PT.BED = { type: 3, value: "BED" }, PT.CHAIR = { type: 3, value: "CHAIR" }, PT.DESK = { type: 3, value: "DESK" }, PT.FILECABINET = { type: 3, value: "FILECABINET" }, PT.SHELF = { type: 3, value: "SHELF" }, PT.SOFA = { type: 3, value: "SOFA" }, PT.TABLE = { type: 3, value: "TABLE" }, PT.TECHNICALCABINET = { type: 3, value: "TECHNICALCABINET" }, PT.USERDEFINED = { type: 3, value: "USERDEFINED" }, PT.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let x3 = PT;
  e.IfcFurnitureTypeEnum = x3;
  const b9 = class b9 {
  };
  b9.SOIL_BORING_POINT = { type: 3, value: "SOIL_BORING_POINT" }, b9.TERRAIN = { type: 3, value: "TERRAIN" }, b9.VEGETATION = { type: 3, value: "VEGETATION" }, b9.USERDEFINED = { type: 3, value: "USERDEFINED" }, b9.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let BI = b9;
  e.IfcGeographicElementTypeEnum = BI;
  const QR = class QR {
  };
  QR.ELEVATION_VIEW = { type: 3, value: "ELEVATION_VIEW" }, QR.GRAPH_VIEW = { type: 3, value: "GRAPH_VIEW" }, QR.MODEL_VIEW = { type: 3, value: "MODEL_VIEW" }, QR.PLAN_VIEW = { type: 3, value: "PLAN_VIEW" }, QR.REFLECTED_PLAN_VIEW = { type: 3, value: "REFLECTED_PLAN_VIEW" }, QR.SECTION_VIEW = { type: 3, value: "SECTION_VIEW" }, QR.SKETCH_VIEW = { type: 3, value: "SKETCH_VIEW" }, QR.USERDEFINED = { type: 3, value: "USERDEFINED" }, QR.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let P3 = QR;
  e.IfcGeometricProjectionEnum = P3;
  const N9 = class N9 {
  };
  N9.SOLID = { type: 3, value: "SOLID" }, N9.VOID = { type: 3, value: "VOID" }, N9.WATER = { type: 3, value: "WATER" }, N9.USERDEFINED = { type: 3, value: "USERDEFINED" }, N9.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let M3 = N9;
  e.IfcGeotechnicalStratumTypeEnum = M3;
  const Yie = class Yie {
  };
  Yie.GLOBAL_COORDS = { type: 3, value: "GLOBAL_COORDS" }, Yie.LOCAL_COORDS = { type: 3, value: "LOCAL_COORDS" };
  let U3 = Yie;
  e.IfcGlobalOrLocalEnum = U3;
  const J7 = class J7 {
  };
  J7.IRREGULAR = { type: 3, value: "IRREGULAR" }, J7.RADIAL = { type: 3, value: "RADIAL" }, J7.RECTANGULAR = { type: 3, value: "RECTANGULAR" }, J7.TRIANGULAR = { type: 3, value: "TRIANGULAR" }, J7.USERDEFINED = { type: 3, value: "USERDEFINED" }, J7.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let B3 = J7;
  e.IfcGridTypeEnum = B3;
  const D9 = class D9 {
  };
  D9.PLATE = { type: 3, value: "PLATE" }, D9.SHELLANDTUBE = { type: 3, value: "SHELLANDTUBE" }, D9.TURNOUTHEATING = { type: 3, value: "TURNOUTHEATING" }, D9.USERDEFINED = { type: 3, value: "USERDEFINED" }, D9.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let FI = D9;
  e.IfcHeatExchangerTypeEnum = FI;
  const up = class up {
  };
  up.ADIABATICAIRWASHER = { type: 3, value: "ADIABATICAIRWASHER" }, up.ADIABATICATOMIZING = { type: 3, value: "ADIABATICATOMIZING" }, up.ADIABATICCOMPRESSEDAIRNOZZLE = { type: 3, value: "ADIABATICCOMPRESSEDAIRNOZZLE" }, up.ADIABATICPAN = { type: 3, value: "ADIABATICPAN" }, up.ADIABATICRIGIDMEDIA = { type: 3, value: "ADIABATICRIGIDMEDIA" }, up.ADIABATICULTRASONIC = { type: 3, value: "ADIABATICULTRASONIC" }, up.ADIABATICWETTEDELEMENT = { type: 3, value: "ADIABATICWETTEDELEMENT" }, up.ASSISTEDBUTANE = { type: 3, value: "ASSISTEDBUTANE" }, up.ASSISTEDELECTRIC = { type: 3, value: "ASSISTEDELECTRIC" }, up.ASSISTEDNATURALGAS = { type: 3, value: "ASSISTEDNATURALGAS" }, up.ASSISTEDPROPANE = { type: 3, value: "ASSISTEDPROPANE" }, up.ASSISTEDSTEAM = { type: 3, value: "ASSISTEDSTEAM" }, up.STEAMINJECTION = { type: 3, value: "STEAMINJECTION" }, up.USERDEFINED = { type: 3, value: "USERDEFINED" }, up.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let HI = up;
  e.IfcHumidifierTypeEnum = HI;
  const X7 = class X7 {
  };
  X7.BUMPER = { type: 3, value: "BUMPER" }, X7.CRASHCUSHION = { type: 3, value: "CRASHCUSHION" }, X7.DAMPINGSYSTEM = { type: 3, value: "DAMPINGSYSTEM" }, X7.FENDER = { type: 3, value: "FENDER" }, X7.USERDEFINED = { type: 3, value: "USERDEFINED" }, X7.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let F3 = X7;
  e.IfcImpactProtectionDeviceTypeEnum = F3;
  const e_ = class e_ {
  };
  e_.CYCLONIC = { type: 3, value: "CYCLONIC" }, e_.GREASE = { type: 3, value: "GREASE" }, e_.OIL = { type: 3, value: "OIL" }, e_.PETROL = { type: 3, value: "PETROL" }, e_.USERDEFINED = { type: 3, value: "USERDEFINED" }, e_.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let H3 = e_;
  e.IfcInterceptorTypeEnum = H3;
  const t_ = class t_ {
  };
  t_.EXTERNAL = { type: 3, value: "EXTERNAL" }, t_.EXTERNAL_EARTH = { type: 3, value: "EXTERNAL_EARTH" }, t_.EXTERNAL_FIRE = { type: 3, value: "EXTERNAL_FIRE" }, t_.EXTERNAL_WATER = { type: 3, value: "EXTERNAL_WATER" }, t_.INTERNAL = { type: 3, value: "INTERNAL" }, t_.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let G3 = t_;
  e.IfcInternalOrExternalEnum = G3;
  const C9 = class C9 {
  };
  C9.ASSETINVENTORY = { type: 3, value: "ASSETINVENTORY" }, C9.FURNITUREINVENTORY = { type: 3, value: "FURNITUREINVENTORY" }, C9.SPACEINVENTORY = { type: 3, value: "SPACEINVENTORY" }, C9.USERDEFINED = { type: 3, value: "USERDEFINED" }, C9.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let k3 = C9;
  e.IfcInventoryTypeEnum = k3;
  const gk = class gk {
  };
  gk.DATA = { type: 3, value: "DATA" }, gk.POWER = { type: 3, value: "POWER" }, gk.USERDEFINED = { type: 3, value: "USERDEFINED" }, gk.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let im = gk;
  e.IfcJunctionBoxTypeEnum = im;
  const wk = class wk {
  };
  wk.PIECEWISE_BEZIER_KNOTS = { type: 3, value: "PIECEWISE_BEZIER_KNOTS" }, wk.QUASI_UNIFORM_KNOTS = { type: 3, value: "QUASI_UNIFORM_KNOTS" }, wk.UNIFORM_KNOTS = { type: 3, value: "UNIFORM_KNOTS" }, wk.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" };
  let Hf = wk;
  e.IfcKnotType = Hf;
  const td = class td {
  };
  td.ADMINISTRATION = { type: 3, value: "ADMINISTRATION" }, td.CARPENTRY = { type: 3, value: "CARPENTRY" }, td.CLEANING = { type: 3, value: "CLEANING" }, td.CONCRETE = { type: 3, value: "CONCRETE" }, td.DRYWALL = { type: 3, value: "DRYWALL" }, td.ELECTRIC = { type: 3, value: "ELECTRIC" }, td.FINISHING = { type: 3, value: "FINISHING" }, td.FLOORING = { type: 3, value: "FLOORING" }, td.GENERAL = { type: 3, value: "GENERAL" }, td.HVAC = { type: 3, value: "HVAC" }, td.LANDSCAPING = { type: 3, value: "LANDSCAPING" }, td.MASONRY = { type: 3, value: "MASONRY" }, td.PAINTING = { type: 3, value: "PAINTING" }, td.PAVING = { type: 3, value: "PAVING" }, td.PLUMBING = { type: 3, value: "PLUMBING" }, td.ROOFING = { type: 3, value: "ROOFING" }, td.SITEGRADING = { type: 3, value: "SITEGRADING" }, td.STEELWORK = { type: 3, value: "STEELWORK" }, td.SURVEYING = { type: 3, value: "SURVEYING" }, td.USERDEFINED = { type: 3, value: "USERDEFINED" }, td.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Gf = td;
  e.IfcLaborResourceTypeEnum = Gf;
  const zw = class zw {
  };
  zw.COMPACTFLUORESCENT = { type: 3, value: "COMPACTFLUORESCENT" }, zw.FLUORESCENT = { type: 3, value: "FLUORESCENT" }, zw.HALOGEN = { type: 3, value: "HALOGEN" }, zw.HIGHPRESSUREMERCURY = { type: 3, value: "HIGHPRESSUREMERCURY" }, zw.HIGHPRESSURESODIUM = { type: 3, value: "HIGHPRESSURESODIUM" }, zw.LED = { type: 3, value: "LED" }, zw.METALHALIDE = { type: 3, value: "METALHALIDE" }, zw.OLED = { type: 3, value: "OLED" }, zw.TUNGSTENFILAMENT = { type: 3, value: "TUNGSTENFILAMENT" }, zw.USERDEFINED = { type: 3, value: "USERDEFINED" }, zw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let V3 = zw;
  e.IfcLampTypeEnum = V3;
  const oZ = class oZ {
  };
  oZ.AXIS1 = { type: 3, value: "AXIS1" }, oZ.AXIS2 = { type: 3, value: "AXIS2" }, oZ.AXIS3 = { type: 3, value: "AXIS3" };
  let Zu = oZ;
  e.IfcLayerSetDirectionEnum = Zu;
  const Tk = class Tk {
  };
  Tk.TYPE_A = { type: 3, value: "TYPE_A" }, Tk.TYPE_B = { type: 3, value: "TYPE_B" }, Tk.TYPE_C = { type: 3, value: "TYPE_C" }, Tk.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let kf = Tk;
  e.IfcLightDistributionCurveEnum = kf;
  const jw = class jw {
  };
  jw.COMPACTFLUORESCENT = { type: 3, value: "COMPACTFLUORESCENT" }, jw.FLUORESCENT = { type: 3, value: "FLUORESCENT" }, jw.HIGHPRESSUREMERCURY = { type: 3, value: "HIGHPRESSUREMERCURY" }, jw.HIGHPRESSURESODIUM = { type: 3, value: "HIGHPRESSURESODIUM" }, jw.LIGHTEMITTINGDIODE = { type: 3, value: "LIGHTEMITTINGDIODE" }, jw.LOWPRESSURESODIUM = { type: 3, value: "LOWPRESSURESODIUM" }, jw.LOWVOLTAGEHALOGEN = { type: 3, value: "LOWVOLTAGEHALOGEN" }, jw.MAINVOLTAGEHALOGEN = { type: 3, value: "MAINVOLTAGEHALOGEN" }, jw.METALHALIDE = { type: 3, value: "METALHALIDE" }, jw.TUNGSTENFILAMENT = { type: 3, value: "TUNGSTENFILAMENT" }, jw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let nm = jw;
  e.IfcLightEmissionSourceEnum = nm;
  const O9 = class O9 {
  };
  O9.DIRECTIONSOURCE = { type: 3, value: "DIRECTIONSOURCE" }, O9.POINTSOURCE = { type: 3, value: "POINTSOURCE" }, O9.SECURITYLIGHTING = { type: 3, value: "SECURITYLIGHTING" }, O9.USERDEFINED = { type: 3, value: "USERDEFINED" }, O9.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let sm = O9;
  e.IfcLightFixtureTypeEnum = sm;
  const Rk = class Rk {
  };
  Rk.HOSEREEL = { type: 3, value: "HOSEREEL" }, Rk.LOADINGARM = { type: 3, value: "LOADINGARM" }, Rk.USERDEFINED = { type: 3, value: "USERDEFINED" }, Rk.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let z3 = Rk;
  e.IfcLiquidTerminalTypeEnum = z3;
  const L9 = class L9 {
  };
  L9.LOAD_CASE = { type: 3, value: "LOAD_CASE" }, L9.LOAD_COMBINATION = { type: 3, value: "LOAD_COMBINATION" }, L9.LOAD_GROUP = { type: 3, value: "LOAD_GROUP" }, L9.USERDEFINED = { type: 3, value: "USERDEFINED" }, L9.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let _d = L9;
  e.IfcLoadGroupTypeEnum = _d;
  const _9 = class _9 {
  };
  _9.LOGICALAND = { type: 3, value: "LOGICALAND" }, _9.LOGICALNOTAND = { type: 3, value: "LOGICALNOTAND" }, _9.LOGICALNOTOR = { type: 3, value: "LOGICALNOTOR" }, _9.LOGICALOR = { type: 3, value: "LOGICALOR" }, _9.LOGICALXOR = { type: 3, value: "LOGICALXOR" };
  let om = _9;
  e.IfcLogicalOperatorEnum = om;
  const id = class id {
  };
  id.BARRIERBEACH = { type: 3, value: "BARRIERBEACH" }, id.BREAKWATER = { type: 3, value: "BREAKWATER" }, id.CANAL = { type: 3, value: "CANAL" }, id.DRYDOCK = { type: 3, value: "DRYDOCK" }, id.FLOATINGDOCK = { type: 3, value: "FLOATINGDOCK" }, id.HYDROLIFT = { type: 3, value: "HYDROLIFT" }, id.JETTY = { type: 3, value: "JETTY" }, id.LAUNCHRECOVERY = { type: 3, value: "LAUNCHRECOVERY" }, id.MARINEDEFENCE = { type: 3, value: "MARINEDEFENCE" }, id.NAVIGATIONALCHANNEL = { type: 3, value: "NAVIGATIONALCHANNEL" }, id.PORT = { type: 3, value: "PORT" }, id.QUAY = { type: 3, value: "QUAY" }, id.REVETMENT = { type: 3, value: "REVETMENT" }, id.SHIPLIFT = { type: 3, value: "SHIPLIFT" }, id.SHIPLOCK = { type: 3, value: "SHIPLOCK" }, id.SHIPYARD = { type: 3, value: "SHIPYARD" }, id.SLIPWAY = { type: 3, value: "SLIPWAY" }, id.WATERWAY = { type: 3, value: "WATERWAY" }, id.WATERWAYSHIPLIFT = { type: 3, value: "WATERWAYSHIPLIFT" }, id.USERDEFINED = { type: 3, value: "USERDEFINED" }, id.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Z = id;
  e.IfcMarineFacilityTypeEnum = Z;
  const Sl = class Sl {
  };
  Sl.ABOVEWATERLINE = { type: 3, value: "ABOVEWATERLINE" }, Sl.ANCHORAGE = { type: 3, value: "ANCHORAGE" }, Sl.APPROACHCHANNEL = { type: 3, value: "APPROACHCHANNEL" }, Sl.BELOWWATERLINE = { type: 3, value: "BELOWWATERLINE" }, Sl.BERTHINGSTRUCTURE = { type: 3, value: "BERTHINGSTRUCTURE" }, Sl.CHAMBER = { type: 3, value: "CHAMBER" }, Sl.CILL_LEVEL = { type: 3, value: "CILL_LEVEL" }, Sl.COPELEVEL = { type: 3, value: "COPELEVEL" }, Sl.CORE = { type: 3, value: "CORE" }, Sl.CREST = { type: 3, value: "CREST" }, Sl.GATEHEAD = { type: 3, value: "GATEHEAD" }, Sl.GUDINGSTRUCTURE = { type: 3, value: "GUDINGSTRUCTURE" }, Sl.HIGHWATERLINE = { type: 3, value: "HIGHWATERLINE" }, Sl.LANDFIELD = { type: 3, value: "LANDFIELD" }, Sl.LEEWARDSIDE = { type: 3, value: "LEEWARDSIDE" }, Sl.LOWWATERLINE = { type: 3, value: "LOWWATERLINE" }, Sl.MANUFACTURING = { type: 3, value: "MANUFACTURING" }, Sl.NAVIGATIONALAREA = { type: 3, value: "NAVIGATIONALAREA" }, Sl.PROTECTION = { type: 3, value: "PROTECTION" }, Sl.SHIPTRANSFER = { type: 3, value: "SHIPTRANSFER" }, Sl.STORAGEAREA = { type: 3, value: "STORAGEAREA" }, Sl.VEHICLESERVICING = { type: 3, value: "VEHICLESERVICING" }, Sl.WATERFIELD = { type: 3, value: "WATERFIELD" }, Sl.WEATHERSIDE = { type: 3, value: "WEATHERSIDE" }, Sl.USERDEFINED = { type: 3, value: "USERDEFINED" }, Sl.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let ae = Sl;
  e.IfcMarinePartTypeEnum = ae;
  const Bh = class Bh {
  };
  Bh.ANCHORBOLT = { type: 3, value: "ANCHORBOLT" }, Bh.BOLT = { type: 3, value: "BOLT" }, Bh.CHAIN = { type: 3, value: "CHAIN" }, Bh.COUPLER = { type: 3, value: "COUPLER" }, Bh.DOWEL = { type: 3, value: "DOWEL" }, Bh.NAIL = { type: 3, value: "NAIL" }, Bh.NAILPLATE = { type: 3, value: "NAILPLATE" }, Bh.RAILFASTENING = { type: 3, value: "RAILFASTENING" }, Bh.RAILJOINT = { type: 3, value: "RAILJOINT" }, Bh.RIVET = { type: 3, value: "RIVET" }, Bh.ROPE = { type: 3, value: "ROPE" }, Bh.SCREW = { type: 3, value: "SCREW" }, Bh.SHEARCONNECTOR = { type: 3, value: "SHEARCONNECTOR" }, Bh.STAPLE = { type: 3, value: "STAPLE" }, Bh.STUDSHEARCONNECTOR = { type: 3, value: "STUDSHEARCONNECTOR" }, Bh.USERDEFINED = { type: 3, value: "USERDEFINED" }, Bh.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Re = Bh;
  e.IfcMechanicalFastenerTypeEnum = Re;
  const SD = class SD {
  };
  SD.AIRSTATION = { type: 3, value: "AIRSTATION" }, SD.FEEDAIRUNIT = { type: 3, value: "FEEDAIRUNIT" }, SD.OXYGENGENERATOR = { type: 3, value: "OXYGENGENERATOR" }, SD.OXYGENPLANT = { type: 3, value: "OXYGENPLANT" }, SD.VACUUMSTATION = { type: 3, value: "VACUUMSTATION" }, SD.USERDEFINED = { type: 3, value: "USERDEFINED" }, SD.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ue = SD;
  e.IfcMedicalDeviceTypeEnum = Ue;
  const nd = class nd {
  };
  nd.ARCH_SEGMENT = { type: 3, value: "ARCH_SEGMENT" }, nd.BRACE = { type: 3, value: "BRACE" }, nd.CHORD = { type: 3, value: "CHORD" }, nd.COLLAR = { type: 3, value: "COLLAR" }, nd.MEMBER = { type: 3, value: "MEMBER" }, nd.MULLION = { type: 3, value: "MULLION" }, nd.PLATE = { type: 3, value: "PLATE" }, nd.POST = { type: 3, value: "POST" }, nd.PURLIN = { type: 3, value: "PURLIN" }, nd.RAFTER = { type: 3, value: "RAFTER" }, nd.STAY_CABLE = { type: 3, value: "STAY_CABLE" }, nd.STIFFENING_RIB = { type: 3, value: "STIFFENING_RIB" }, nd.STRINGER = { type: 3, value: "STRINGER" }, nd.STRUCTURALCABLE = { type: 3, value: "STRUCTURALCABLE" }, nd.STRUT = { type: 3, value: "STRUT" }, nd.STUD = { type: 3, value: "STUD" }, nd.SUSPENDER = { type: 3, value: "SUSPENDER" }, nd.SUSPENSION_CABLE = { type: 3, value: "SUSPENSION_CABLE" }, nd.TIEBAR = { type: 3, value: "TIEBAR" }, nd.USERDEFINED = { type: 3, value: "USERDEFINED" }, nd.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let nt = nd;
  e.IfcMemberTypeEnum = nt;
  const dp = class dp {
  };
  dp.ACCESSPOINT = { type: 3, value: "ACCESSPOINT" }, dp.BASEBANDUNIT = { type: 3, value: "BASEBANDUNIT" }, dp.BASETRANSCEIVERSTATION = { type: 3, value: "BASETRANSCEIVERSTATION" }, dp.E_UTRAN_NODE_B = { type: 3, value: "E_UTRAN_NODE_B" }, dp.GATEWAY_GPRS_SUPPORT_NODE = { type: 3, value: "GATEWAY_GPRS_SUPPORT_NODE" }, dp.MASTERUNIT = { type: 3, value: "MASTERUNIT" }, dp.MOBILESWITCHINGCENTER = { type: 3, value: "MOBILESWITCHINGCENTER" }, dp.MSCSERVER = { type: 3, value: "MSCSERVER" }, dp.PACKETCONTROLUNIT = { type: 3, value: "PACKETCONTROLUNIT" }, dp.REMOTERADIOUNIT = { type: 3, value: "REMOTERADIOUNIT" }, dp.REMOTEUNIT = { type: 3, value: "REMOTEUNIT" }, dp.SERVICE_GPRS_SUPPORT_NODE = { type: 3, value: "SERVICE_GPRS_SUPPORT_NODE" }, dp.SUBSCRIBERSERVER = { type: 3, value: "SUBSCRIBERSERVER" }, dp.USERDEFINED = { type: 3, value: "USERDEFINED" }, dp.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let At = dp;
  e.IfcMobileTelecommunicationsApplianceTypeEnum = At;
  const bD = class bD {
  };
  bD.BOLLARD = { type: 3, value: "BOLLARD" }, bD.LINETENSIONER = { type: 3, value: "LINETENSIONER" }, bD.MAGNETICDEVICE = { type: 3, value: "MAGNETICDEVICE" }, bD.MOORINGHOOKS = { type: 3, value: "MOORINGHOOKS" }, bD.VACUUMDEVICE = { type: 3, value: "VACUUMDEVICE" }, bD.USERDEFINED = { type: 3, value: "USERDEFINED" }, bD.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Lt = bD;
  e.IfcMooringDeviceTypeEnum = Lt;
  const x9 = class x9 {
  };
  x9.BELTDRIVE = { type: 3, value: "BELTDRIVE" }, x9.COUPLING = { type: 3, value: "COUPLING" }, x9.DIRECTDRIVE = { type: 3, value: "DIRECTDRIVE" }, x9.USERDEFINED = { type: 3, value: "USERDEFINED" }, x9.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let _t = x9;
  e.IfcMotorConnectionTypeEnum = _t;
  const vk = class vk {
  };
  vk.BEACON = { type: 3, value: "BEACON" }, vk.BUOY = { type: 3, value: "BUOY" }, vk.USERDEFINED = { type: 3, value: "USERDEFINED" }, vk.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let oi = vk;
  e.IfcNavigationElementTypeEnum = oi;
  const YS = class YS {
  };
  YS.ACTOR = { type: 3, value: "ACTOR" }, YS.CONTROL = { type: 3, value: "CONTROL" }, YS.GROUP = { type: 3, value: "GROUP" }, YS.PROCESS = { type: 3, value: "PROCESS" }, YS.PRODUCT = { type: 3, value: "PRODUCT" }, YS.PROJECT = { type: 3, value: "PROJECT" }, YS.RESOURCE = { type: 3, value: "RESOURCE" }, YS.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let mi = YS;
  e.IfcObjectTypeEnum = mi;
  const Ty = class Ty {
  };
  Ty.CODECOMPLIANCE = { type: 3, value: "CODECOMPLIANCE" }, Ty.CODEWAIVER = { type: 3, value: "CODEWAIVER" }, Ty.DESIGNINTENT = { type: 3, value: "DESIGNINTENT" }, Ty.EXTERNAL = { type: 3, value: "EXTERNAL" }, Ty.HEALTHANDSAFETY = { type: 3, value: "HEALTHANDSAFETY" }, Ty.MERGECONFLICT = { type: 3, value: "MERGECONFLICT" }, Ty.MODELVIEW = { type: 3, value: "MODELVIEW" }, Ty.PARAMETER = { type: 3, value: "PARAMETER" }, Ty.REQUIREMENT = { type: 3, value: "REQUIREMENT" }, Ty.SPECIFICATION = { type: 3, value: "SPECIFICATION" }, Ty.TRIGGERCONDITION = { type: 3, value: "TRIGGERCONDITION" }, Ty.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ty.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let zi = Ty;
  e.IfcObjectiveEnum = zi;
  const JR = class JR {
  };
  JR.ASSIGNEE = { type: 3, value: "ASSIGNEE" }, JR.ASSIGNOR = { type: 3, value: "ASSIGNOR" }, JR.LESSEE = { type: 3, value: "LESSEE" }, JR.LESSOR = { type: 3, value: "LESSOR" }, JR.LETTINGAGENT = { type: 3, value: "LETTINGAGENT" }, JR.OWNER = { type: 3, value: "OWNER" }, JR.TENANT = { type: 3, value: "TENANT" }, JR.USERDEFINED = { type: 3, value: "USERDEFINED" }, JR.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let yn = JR;
  e.IfcOccupantTypeEnum = yn;
  const Ak = class Ak {
  };
  Ak.OPENING = { type: 3, value: "OPENING" }, Ak.RECESS = { type: 3, value: "RECESS" }, Ak.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ak.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Xi = Ak;
  e.IfcOpeningElementTypeEnum = Xi;
  const ND = class ND {
  };
  ND.AUDIOVISUALOUTLET = { type: 3, value: "AUDIOVISUALOUTLET" }, ND.COMMUNICATIONSOUTLET = { type: 3, value: "COMMUNICATIONSOUTLET" }, ND.DATAOUTLET = { type: 3, value: "DATAOUTLET" }, ND.POWEROUTLET = { type: 3, value: "POWEROUTLET" }, ND.TELEPHONEOUTLET = { type: 3, value: "TELEPHONEOUTLET" }, ND.USERDEFINED = { type: 3, value: "USERDEFINED" }, ND.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let rn = ND;
  e.IfcOutletTypeEnum = rn;
  const Sk = class Sk {
  };
  Sk.FLEXIBLE = { type: 3, value: "FLEXIBLE" }, Sk.RIGID = { type: 3, value: "RIGID" }, Sk.USERDEFINED = { type: 3, value: "USERDEFINED" }, Sk.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Fn = Sk;
  e.IfcPavementTypeEnum = Fn;
  const qie = class qie {
  };
  qie.USERDEFINED = { type: 3, value: "USERDEFINED" }, qie.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ps = qie;
  e.IfcPerformanceHistoryTypeEnum = Ps;
  const P9 = class P9 {
  };
  P9.GRILL = { type: 3, value: "GRILL" }, P9.LOUVER = { type: 3, value: "LOUVER" }, P9.SCREEN = { type: 3, value: "SCREEN" }, P9.USERDEFINED = { type: 3, value: "USERDEFINED" }, P9.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Fs = P9;
  e.IfcPermeableCoveringOperationEnum = Fs;
  const M9 = class M9 {
  };
  M9.ACCESS = { type: 3, value: "ACCESS" }, M9.BUILDING = { type: 3, value: "BUILDING" }, M9.WORK = { type: 3, value: "WORK" }, M9.USERDEFINED = { type: 3, value: "USERDEFINED" }, M9.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let uo = M9;
  e.IfcPermitTypeEnum = uo;
  const rZ = class rZ {
  };
  rZ.PHYSICAL = { type: 3, value: "PHYSICAL" }, rZ.VIRTUAL = { type: 3, value: "VIRTUAL" }, rZ.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ui = rZ;
  e.IfcPhysicalOrVirtualEnum = Ui;
  const i_ = class i_ {
  };
  i_.CAST_IN_PLACE = { type: 3, value: "CAST_IN_PLACE" }, i_.COMPOSITE = { type: 3, value: "COMPOSITE" }, i_.PRECAST_CONCRETE = { type: 3, value: "PRECAST_CONCRETE" }, i_.PREFAB_STEEL = { type: 3, value: "PREFAB_STEEL" }, i_.USERDEFINED = { type: 3, value: "USERDEFINED" }, i_.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Rn = i_;
  e.IfcPileConstructionEnum = Rn;
  const qS = class qS {
  };
  qS.BORED = { type: 3, value: "BORED" }, qS.COHESION = { type: 3, value: "COHESION" }, qS.DRIVEN = { type: 3, value: "DRIVEN" }, qS.FRICTION = { type: 3, value: "FRICTION" }, qS.JETGROUTING = { type: 3, value: "JETGROUTING" }, qS.SUPPORT = { type: 3, value: "SUPPORT" }, qS.USERDEFINED = { type: 3, value: "USERDEFINED" }, qS.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Vo = qS;
  e.IfcPileTypeEnum = Vo;
  const XR = class XR {
  };
  XR.BEND = { type: 3, value: "BEND" }, XR.CONNECTOR = { type: 3, value: "CONNECTOR" }, XR.ENTRY = { type: 3, value: "ENTRY" }, XR.EXIT = { type: 3, value: "EXIT" }, XR.JUNCTION = { type: 3, value: "JUNCTION" }, XR.OBSTRUCTION = { type: 3, value: "OBSTRUCTION" }, XR.TRANSITION = { type: 3, value: "TRANSITION" }, XR.USERDEFINED = { type: 3, value: "USERDEFINED" }, XR.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Do = XR;
  e.IfcPipeFittingTypeEnum = Do;
  const DD = class DD {
  };
  DD.CULVERT = { type: 3, value: "CULVERT" }, DD.FLEXIBLESEGMENT = { type: 3, value: "FLEXIBLESEGMENT" }, DD.GUTTER = { type: 3, value: "GUTTER" }, DD.RIGIDSEGMENT = { type: 3, value: "RIGIDSEGMENT" }, DD.SPOOL = { type: 3, value: "SPOOL" }, DD.USERDEFINED = { type: 3, value: "USERDEFINED" }, DD.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Pl = DD;
  e.IfcPipeSegmentTypeEnum = Pl;
  const Ww = class Ww {
  };
  Ww.BASE_PLATE = { type: 3, value: "BASE_PLATE" }, Ww.COVER_PLATE = { type: 3, value: "COVER_PLATE" }, Ww.CURTAIN_PANEL = { type: 3, value: "CURTAIN_PANEL" }, Ww.FLANGE_PLATE = { type: 3, value: "FLANGE_PLATE" }, Ww.GUSSET_PLATE = { type: 3, value: "GUSSET_PLATE" }, Ww.SHEET = { type: 3, value: "SHEET" }, Ww.SPLICE_PLATE = { type: 3, value: "SPLICE_PLATE" }, Ww.STIFFENER_PLATE = { type: 3, value: "STIFFENER_PLATE" }, Ww.WEB_PLATE = { type: 3, value: "WEB_PLATE" }, Ww.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ww.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let cr = Ww;
  e.IfcPlateTypeEnum = cr;
  const lZ = class lZ {
  };
  lZ.CURVE3D = { type: 3, value: "CURVE3D" }, lZ.PCURVE_S1 = { type: 3, value: "PCURVE_S1" }, lZ.PCURVE_S2 = { type: 3, value: "PCURVE_S2" };
  let S4 = lZ;
  e.IfcPreferredSurfaceCurveRepresentation = S4;
  const ev = class ev {
  };
  ev.ADVICE_CAUTION = { type: 3, value: "ADVICE_CAUTION" }, ev.ADVICE_NOTE = { type: 3, value: "ADVICE_NOTE" }, ev.ADVICE_WARNING = { type: 3, value: "ADVICE_WARNING" }, ev.CALIBRATION = { type: 3, value: "CALIBRATION" }, ev.DIAGNOSTIC = { type: 3, value: "DIAGNOSTIC" }, ev.SHUTDOWN = { type: 3, value: "SHUTDOWN" }, ev.STARTUP = { type: 3, value: "STARTUP" }, ev.USERDEFINED = { type: 3, value: "USERDEFINED" }, ev.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let b4 = ev;
  e.IfcProcedureTypeEnum = b4;
  const $ie = class $ie {
  };
  $ie.AREA = { type: 3, value: "AREA" }, $ie.CURVE = { type: 3, value: "CURVE" };
  let IE = $ie;
  e.IfcProfileTypeEnum = IE;
  const CD = class CD {
  };
  CD.CHANGEORDER = { type: 3, value: "CHANGEORDER" }, CD.MAINTENANCEWORKORDER = { type: 3, value: "MAINTENANCEWORKORDER" }, CD.MOVEORDER = { type: 3, value: "MOVEORDER" }, CD.PURCHASEORDER = { type: 3, value: "PURCHASEORDER" }, CD.WORKORDER = { type: 3, value: "WORKORDER" }, CD.USERDEFINED = { type: 3, value: "USERDEFINED" }, CD.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let N4 = CD;
  e.IfcProjectOrderTypeEnum = N4;
  const Kie = class Kie {
  };
  Kie.PROJECTED_LENGTH = { type: 3, value: "PROJECTED_LENGTH" }, Kie.TRUE_LENGTH = { type: 3, value: "TRUE_LENGTH" };
  let D4 = Kie;
  e.IfcProjectedOrTrueLengthEnum = D4;
  const bk = class bk {
  };
  bk.BLISTER = { type: 3, value: "BLISTER" }, bk.DEVIATOR = { type: 3, value: "DEVIATOR" }, bk.USERDEFINED = { type: 3, value: "USERDEFINED" }, bk.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let C4 = bk;
  e.IfcProjectionElementTypeEnum = C4;
  const MT = class MT {
  };
  MT.PSET_MATERIALDRIVEN = { type: 3, value: "PSET_MATERIALDRIVEN" }, MT.PSET_OCCURRENCEDRIVEN = { type: 3, value: "PSET_OCCURRENCEDRIVEN" }, MT.PSET_PERFORMANCEDRIVEN = { type: 3, value: "PSET_PERFORMANCEDRIVEN" }, MT.PSET_PROFILEDRIVEN = { type: 3, value: "PSET_PROFILEDRIVEN" }, MT.PSET_TYPEDRIVENONLY = { type: 3, value: "PSET_TYPEDRIVENONLY" }, MT.PSET_TYPEDRIVENOVERRIDE = { type: 3, value: "PSET_TYPEDRIVENOVERRIDE" }, MT.QTO_OCCURRENCEDRIVEN = { type: 3, value: "QTO_OCCURRENCEDRIVEN" }, MT.QTO_TYPEDRIVENONLY = { type: 3, value: "QTO_TYPEDRIVENONLY" }, MT.QTO_TYPEDRIVENOVERRIDE = { type: 3, value: "QTO_TYPEDRIVENOVERRIDE" }, MT.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let O4 = MT;
  e.IfcPropertySetTemplateTypeEnum = O4;
  const n_ = class n_ {
  };
  n_.ELECTROMAGNETIC = { type: 3, value: "ELECTROMAGNETIC" }, n_.ELECTRONIC = { type: 3, value: "ELECTRONIC" }, n_.RESIDUALCURRENT = { type: 3, value: "RESIDUALCURRENT" }, n_.THERMAL = { type: 3, value: "THERMAL" }, n_.USERDEFINED = { type: 3, value: "USERDEFINED" }, n_.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let k5 = n_;
  e.IfcProtectiveDeviceTrippingUnitTypeEnum = k5;
  const XE = class XE {
  };
  XE.ANTI_ARCING_DEVICE = { type: 3, value: "ANTI_ARCING_DEVICE" }, XE.CIRCUITBREAKER = { type: 3, value: "CIRCUITBREAKER" }, XE.EARTHINGSWITCH = { type: 3, value: "EARTHINGSWITCH" }, XE.EARTHLEAKAGECIRCUITBREAKER = { type: 3, value: "EARTHLEAKAGECIRCUITBREAKER" }, XE.FUSEDISCONNECTOR = { type: 3, value: "FUSEDISCONNECTOR" }, XE.RESIDUALCURRENTCIRCUITBREAKER = { type: 3, value: "RESIDUALCURRENTCIRCUITBREAKER" }, XE.RESIDUALCURRENTSWITCH = { type: 3, value: "RESIDUALCURRENTSWITCH" }, XE.SPARKGAP = { type: 3, value: "SPARKGAP" }, XE.VARISTOR = { type: 3, value: "VARISTOR" }, XE.VOLTAGELIMITER = { type: 3, value: "VOLTAGELIMITER" }, XE.USERDEFINED = { type: 3, value: "USERDEFINED" }, XE.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let V5 = XE;
  e.IfcProtectiveDeviceTypeEnum = V5;
  const tv = class tv {
  };
  tv.CIRCULATOR = { type: 3, value: "CIRCULATOR" }, tv.ENDSUCTION = { type: 3, value: "ENDSUCTION" }, tv.SPLITCASE = { type: 3, value: "SPLITCASE" }, tv.SUBMERSIBLEPUMP = { type: 3, value: "SUBMERSIBLEPUMP" }, tv.SUMPPUMP = { type: 3, value: "SUMPPUMP" }, tv.VERTICALINLINE = { type: 3, value: "VERTICALINLINE" }, tv.VERTICALTURBINE = { type: 3, value: "VERTICALTURBINE" }, tv.USERDEFINED = { type: 3, value: "USERDEFINED" }, tv.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let L4 = tv;
  e.IfcPumpTypeEnum = L4;
  const $S = class $S {
  };
  $S.BLADE = { type: 3, value: "BLADE" }, $S.CHECKRAIL = { type: 3, value: "CHECKRAIL" }, $S.GUARDRAIL = { type: 3, value: "GUARDRAIL" }, $S.RACKRAIL = { type: 3, value: "RACKRAIL" }, $S.RAIL = { type: 3, value: "RAIL" }, $S.STOCKRAIL = { type: 3, value: "STOCKRAIL" }, $S.USERDEFINED = { type: 3, value: "USERDEFINED" }, $S.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let _4 = $S;
  e.IfcRailTypeEnum = _4;
  const s_ = class s_ {
  };
  s_.BALUSTRADE = { type: 3, value: "BALUSTRADE" }, s_.FENCE = { type: 3, value: "FENCE" }, s_.GUARDRAIL = { type: 3, value: "GUARDRAIL" }, s_.HANDRAIL = { type: 3, value: "HANDRAIL" }, s_.USERDEFINED = { type: 3, value: "USERDEFINED" }, s_.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let z5 = s_;
  e.IfcRailingTypeEnum = z5;
  const UT = class UT {
  };
  UT.DILATATIONSUPERSTRUCTURE = { type: 3, value: "DILATATIONSUPERSTRUCTURE" }, UT.LINESIDESTRUCTURE = { type: 3, value: "LINESIDESTRUCTURE" }, UT.LINESIDESTRUCTUREPART = { type: 3, value: "LINESIDESTRUCTUREPART" }, UT.PLAINTRACKSUPERSTRUCTURE = { type: 3, value: "PLAINTRACKSUPERSTRUCTURE" }, UT.SUPERSTRUCTURE = { type: 3, value: "SUPERSTRUCTURE" }, UT.TRACKSTRUCTURE = { type: 3, value: "TRACKSTRUCTURE" }, UT.TRACKSTRUCTUREPART = { type: 3, value: "TRACKSTRUCTUREPART" }, UT.TURNOUTSUPERSTRUCTURE = { type: 3, value: "TURNOUTSUPERSTRUCTURE" }, UT.USERDEFINED = { type: 3, value: "USERDEFINED" }, UT.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let j5 = UT;
  e.IfcRailwayPartTypeEnum = j5;
  const Zie = class Zie {
  };
  Zie.USERDEFINED = { type: 3, value: "USERDEFINED" }, Zie.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let x4 = Zie;
  e.IfcRailwayTypeEnum = x4;
  const Nk = class Nk {
  };
  Nk.SPIRAL = { type: 3, value: "SPIRAL" }, Nk.STRAIGHT = { type: 3, value: "STRAIGHT" }, Nk.USERDEFINED = { type: 3, value: "USERDEFINED" }, Nk.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let j3 = Nk;
  e.IfcRampFlightTypeEnum = j3;
  const KS = class KS {
  };
  KS.HALF_TURN_RAMP = { type: 3, value: "HALF_TURN_RAMP" }, KS.QUARTER_TURN_RAMP = { type: 3, value: "QUARTER_TURN_RAMP" }, KS.SPIRAL_RAMP = { type: 3, value: "SPIRAL_RAMP" }, KS.STRAIGHT_RUN_RAMP = { type: 3, value: "STRAIGHT_RUN_RAMP" }, KS.TWO_QUARTER_TURN_RAMP = { type: 3, value: "TWO_QUARTER_TURN_RAMP" }, KS.TWO_STRAIGHT_RUN_RAMP = { type: 3, value: "TWO_STRAIGHT_RUN_RAMP" }, KS.USERDEFINED = { type: 3, value: "USERDEFINED" }, KS.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let $g = KS;
  e.IfcRampTypeEnum = $g;
  const ZS = class ZS {
  };
  ZS.BY_DAY_COUNT = { type: 3, value: "BY_DAY_COUNT" }, ZS.BY_WEEKDAY_COUNT = { type: 3, value: "BY_WEEKDAY_COUNT" }, ZS.DAILY = { type: 3, value: "DAILY" }, ZS.MONTHLY_BY_DAY_OF_MONTH = { type: 3, value: "MONTHLY_BY_DAY_OF_MONTH" }, ZS.MONTHLY_BY_POSITION = { type: 3, value: "MONTHLY_BY_POSITION" }, ZS.WEEKLY = { type: 3, value: "WEEKLY" }, ZS.YEARLY_BY_DAY_OF_MONTH = { type: 3, value: "YEARLY_BY_DAY_OF_MONTH" }, ZS.YEARLY_BY_POSITION = { type: 3, value: "YEARLY_BY_POSITION" };
  let pE = ZS;
  e.IfcRecurrenceTypeEnum = pE;
  const BT = class BT {
  };
  BT.BOUNDARY = { type: 3, value: "BOUNDARY" }, BT.INTERSECTION = { type: 3, value: "INTERSECTION" }, BT.KILOPOINT = { type: 3, value: "KILOPOINT" }, BT.LANDMARK = { type: 3, value: "LANDMARK" }, BT.MILEPOINT = { type: 3, value: "MILEPOINT" }, BT.POSITION = { type: 3, value: "POSITION" }, BT.REFERENCEMARKER = { type: 3, value: "REFERENCEMARKER" }, BT.STATION = { type: 3, value: "STATION" }, BT.USERDEFINED = { type: 3, value: "USERDEFINED" }, BT.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let mE = BT;
  e.IfcReferentTypeEnum = mE;
  const Yw = class Yw {
  };
  Yw.BLINN = { type: 3, value: "BLINN" }, Yw.FLAT = { type: 3, value: "FLAT" }, Yw.GLASS = { type: 3, value: "GLASS" }, Yw.MATT = { type: 3, value: "MATT" }, Yw.METAL = { type: 3, value: "METAL" }, Yw.MIRROR = { type: 3, value: "MIRROR" }, Yw.PHONG = { type: 3, value: "PHONG" }, Yw.PHYSICAL = { type: 3, value: "PHYSICAL" }, Yw.PLASTIC = { type: 3, value: "PLASTIC" }, Yw.STRAUSS = { type: 3, value: "STRAUSS" }, Yw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Kg = Yw;
  e.IfcReflectanceMethodEnum = Kg;
  const QS = class QS {
  };
  QS.DYNAMICALLYCOMPACTED = { type: 3, value: "DYNAMICALLYCOMPACTED" }, QS.GROUTED = { type: 3, value: "GROUTED" }, QS.REPLACED = { type: 3, value: "REPLACED" }, QS.ROLLERCOMPACTED = { type: 3, value: "ROLLERCOMPACTED" }, QS.SURCHARGEPRELOADED = { type: 3, value: "SURCHARGEPRELOADED" }, QS.VERTICALLYDRAINED = { type: 3, value: "VERTICALLYDRAINED" }, QS.USERDEFINED = { type: 3, value: "USERDEFINED" }, QS.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let W5 = QS;
  e.IfcReinforcedSoilTypeEnum = W5;
  const FT = class FT {
  };
  FT.ANCHORING = { type: 3, value: "ANCHORING" }, FT.EDGE = { type: 3, value: "EDGE" }, FT.LIGATURE = { type: 3, value: "LIGATURE" }, FT.MAIN = { type: 3, value: "MAIN" }, FT.PUNCHING = { type: 3, value: "PUNCHING" }, FT.RING = { type: 3, value: "RING" }, FT.SHEAR = { type: 3, value: "SHEAR" }, FT.STUD = { type: 3, value: "STUD" }, FT.USERDEFINED = { type: 3, value: "USERDEFINED" }, FT.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Th = FT;
  e.IfcReinforcingBarRoleEnum = Th;
  const Qie = class Qie {
  };
  Qie.PLAIN = { type: 3, value: "PLAIN" }, Qie.TEXTURED = { type: 3, value: "TEXTURED" };
  let yE = Qie;
  e.IfcReinforcingBarSurfaceEnum = yE;
  const qw = class qw {
  };
  qw.ANCHORING = { type: 3, value: "ANCHORING" }, qw.EDGE = { type: 3, value: "EDGE" }, qw.LIGATURE = { type: 3, value: "LIGATURE" }, qw.MAIN = { type: 3, value: "MAIN" }, qw.PUNCHING = { type: 3, value: "PUNCHING" }, qw.RING = { type: 3, value: "RING" }, qw.SHEAR = { type: 3, value: "SHEAR" }, qw.SPACEBAR = { type: 3, value: "SPACEBAR" }, qw.STUD = { type: 3, value: "STUD" }, qw.USERDEFINED = { type: 3, value: "USERDEFINED" }, qw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let EE = qw;
  e.IfcReinforcingBarTypeEnum = EE;
  const Jie = class Jie {
  };
  Jie.USERDEFINED = { type: 3, value: "USERDEFINED" }, Jie.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let P4 = Jie;
  e.IfcReinforcingMeshTypeEnum = P4;
  const bl = class bl {
  };
  bl.BICYCLECROSSING = { type: 3, value: "BICYCLECROSSING" }, bl.BUS_STOP = { type: 3, value: "BUS_STOP" }, bl.CARRIAGEWAY = { type: 3, value: "CARRIAGEWAY" }, bl.CENTRALISLAND = { type: 3, value: "CENTRALISLAND" }, bl.CENTRALRESERVE = { type: 3, value: "CENTRALRESERVE" }, bl.HARDSHOULDER = { type: 3, value: "HARDSHOULDER" }, bl.INTERSECTION = { type: 3, value: "INTERSECTION" }, bl.LAYBY = { type: 3, value: "LAYBY" }, bl.PARKINGBAY = { type: 3, value: "PARKINGBAY" }, bl.PASSINGBAY = { type: 3, value: "PASSINGBAY" }, bl.PEDESTRIAN_CROSSING = { type: 3, value: "PEDESTRIAN_CROSSING" }, bl.RAILWAYCROSSING = { type: 3, value: "RAILWAYCROSSING" }, bl.REFUGEISLAND = { type: 3, value: "REFUGEISLAND" }, bl.ROADSEGMENT = { type: 3, value: "ROADSEGMENT" }, bl.ROADSIDE = { type: 3, value: "ROADSIDE" }, bl.ROADSIDEPART = { type: 3, value: "ROADSIDEPART" }, bl.ROADWAYPLATEAU = { type: 3, value: "ROADWAYPLATEAU" }, bl.ROUNDABOUT = { type: 3, value: "ROUNDABOUT" }, bl.SHOULDER = { type: 3, value: "SHOULDER" }, bl.SIDEWALK = { type: 3, value: "SIDEWALK" }, bl.SOFTSHOULDER = { type: 3, value: "SOFTSHOULDER" }, bl.TOLLPLAZA = { type: 3, value: "TOLLPLAZA" }, bl.TRAFFICISLAND = { type: 3, value: "TRAFFICISLAND" }, bl.TRAFFICLANE = { type: 3, value: "TRAFFICLANE" }, bl.USERDEFINED = { type: 3, value: "USERDEFINED" }, bl.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let M4 = bl;
  e.IfcRoadPartTypeEnum = M4;
  const Xie = class Xie {
  };
  Xie.USERDEFINED = { type: 3, value: "USERDEFINED" }, Xie.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let U4 = Xie;
  e.IfcRoadTypeEnum = U4;
  const ya = class ya {
  };
  ya.ARCHITECT = { type: 3, value: "ARCHITECT" }, ya.BUILDINGOPERATOR = { type: 3, value: "BUILDINGOPERATOR" }, ya.BUILDINGOWNER = { type: 3, value: "BUILDINGOWNER" }, ya.CIVILENGINEER = { type: 3, value: "CIVILENGINEER" }, ya.CLIENT = { type: 3, value: "CLIENT" }, ya.COMMISSIONINGENGINEER = { type: 3, value: "COMMISSIONINGENGINEER" }, ya.CONSTRUCTIONMANAGER = { type: 3, value: "CONSTRUCTIONMANAGER" }, ya.CONSULTANT = { type: 3, value: "CONSULTANT" }, ya.CONTRACTOR = { type: 3, value: "CONTRACTOR" }, ya.COSTENGINEER = { type: 3, value: "COSTENGINEER" }, ya.ELECTRICALENGINEER = { type: 3, value: "ELECTRICALENGINEER" }, ya.ENGINEER = { type: 3, value: "ENGINEER" }, ya.FACILITIESMANAGER = { type: 3, value: "FACILITIESMANAGER" }, ya.FIELDCONSTRUCTIONMANAGER = { type: 3, value: "FIELDCONSTRUCTIONMANAGER" }, ya.MANUFACTURER = { type: 3, value: "MANUFACTURER" }, ya.MECHANICALENGINEER = { type: 3, value: "MECHANICALENGINEER" }, ya.OWNER = { type: 3, value: "OWNER" }, ya.PROJECTMANAGER = { type: 3, value: "PROJECTMANAGER" }, ya.RESELLER = { type: 3, value: "RESELLER" }, ya.STRUCTURALENGINEER = { type: 3, value: "STRUCTURALENGINEER" }, ya.SUBCONTRACTOR = { type: 3, value: "SUBCONTRACTOR" }, ya.SUPPLIER = { type: 3, value: "SUPPLIER" }, ya.USERDEFINED = { type: 3, value: "USERDEFINED" };
  let Zg = ya;
  e.IfcRoleEnum = Zg;
  const cp = class cp {
  };
  cp.BARREL_ROOF = { type: 3, value: "BARREL_ROOF" }, cp.BUTTERFLY_ROOF = { type: 3, value: "BUTTERFLY_ROOF" }, cp.DOME_ROOF = { type: 3, value: "DOME_ROOF" }, cp.FLAT_ROOF = { type: 3, value: "FLAT_ROOF" }, cp.FREEFORM = { type: 3, value: "FREEFORM" }, cp.GABLE_ROOF = { type: 3, value: "GABLE_ROOF" }, cp.GAMBREL_ROOF = { type: 3, value: "GAMBREL_ROOF" }, cp.HIPPED_GABLE_ROOF = { type: 3, value: "HIPPED_GABLE_ROOF" }, cp.HIP_ROOF = { type: 3, value: "HIP_ROOF" }, cp.MANSARD_ROOF = { type: 3, value: "MANSARD_ROOF" }, cp.PAVILION_ROOF = { type: 3, value: "PAVILION_ROOF" }, cp.RAINBOW_ROOF = { type: 3, value: "RAINBOW_ROOF" }, cp.SHED_ROOF = { type: 3, value: "SHED_ROOF" }, cp.USERDEFINED = { type: 3, value: "USERDEFINED" }, cp.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Qg = cp;
  e.IfcRoofTypeEnum = Qg;
  const e1 = class e1 {
  };
  e1.ATTO = { type: 3, value: "ATTO" }, e1.CENTI = { type: 3, value: "CENTI" }, e1.DECA = { type: 3, value: "DECA" }, e1.DECI = { type: 3, value: "DECI" }, e1.EXA = { type: 3, value: "EXA" }, e1.FEMTO = { type: 3, value: "FEMTO" }, e1.GIGA = { type: 3, value: "GIGA" }, e1.HECTO = { type: 3, value: "HECTO" }, e1.KILO = { type: 3, value: "KILO" }, e1.MEGA = { type: 3, value: "MEGA" }, e1.MICRO = { type: 3, value: "MICRO" }, e1.MILLI = { type: 3, value: "MILLI" }, e1.NANO = { type: 3, value: "NANO" }, e1.PETA = { type: 3, value: "PETA" }, e1.PICO = { type: 3, value: "PICO" }, e1.TERA = { type: 3, value: "TERA" };
  let B4 = e1;
  e.IfcSIPrefix = B4;
  const Yr = class Yr {
  };
  Yr.AMPERE = { type: 3, value: "AMPERE" }, Yr.BECQUEREL = { type: 3, value: "BECQUEREL" }, Yr.CANDELA = { type: 3, value: "CANDELA" }, Yr.COULOMB = { type: 3, value: "COULOMB" }, Yr.CUBIC_METRE = { type: 3, value: "CUBIC_METRE" }, Yr.DEGREE_CELSIUS = { type: 3, value: "DEGREE_CELSIUS" }, Yr.FARAD = { type: 3, value: "FARAD" }, Yr.GRAM = { type: 3, value: "GRAM" }, Yr.GRAY = { type: 3, value: "GRAY" }, Yr.HENRY = { type: 3, value: "HENRY" }, Yr.HERTZ = { type: 3, value: "HERTZ" }, Yr.JOULE = { type: 3, value: "JOULE" }, Yr.KELVIN = { type: 3, value: "KELVIN" }, Yr.LUMEN = { type: 3, value: "LUMEN" }, Yr.LUX = { type: 3, value: "LUX" }, Yr.METRE = { type: 3, value: "METRE" }, Yr.MOLE = { type: 3, value: "MOLE" }, Yr.NEWTON = { type: 3, value: "NEWTON" }, Yr.OHM = { type: 3, value: "OHM" }, Yr.PASCAL = { type: 3, value: "PASCAL" }, Yr.RADIAN = { type: 3, value: "RADIAN" }, Yr.SECOND = { type: 3, value: "SECOND" }, Yr.SIEMENS = { type: 3, value: "SIEMENS" }, Yr.SIEVERT = { type: 3, value: "SIEVERT" }, Yr.SQUARE_METRE = { type: 3, value: "SQUARE_METRE" }, Yr.STERADIAN = { type: 3, value: "STERADIAN" }, Yr.TESLA = { type: 3, value: "TESLA" }, Yr.VOLT = { type: 3, value: "VOLT" }, Yr.WATT = { type: 3, value: "WATT" }, Yr.WEBER = { type: 3, value: "WEBER" };
  let F4 = Yr;
  e.IfcSIUnitName = F4;
  const eg = class eg {
  };
  eg.BATH = { type: 3, value: "BATH" }, eg.BIDET = { type: 3, value: "BIDET" }, eg.CISTERN = { type: 3, value: "CISTERN" }, eg.SANITARYFOUNTAIN = { type: 3, value: "SANITARYFOUNTAIN" }, eg.SHOWER = { type: 3, value: "SHOWER" }, eg.SINK = { type: 3, value: "SINK" }, eg.TOILETPAN = { type: 3, value: "TOILETPAN" }, eg.URINAL = { type: 3, value: "URINAL" }, eg.WASHHANDBASIN = { type: 3, value: "WASHHANDBASIN" }, eg.WCSEAT = { type: 3, value: "WCSEAT" }, eg.USERDEFINED = { type: 3, value: "USERDEFINED" }, eg.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let H4 = eg;
  e.IfcSanitaryTerminalTypeEnum = H4;
  const ene = class ene {
  };
  ene.TAPERED = { type: 3, value: "TAPERED" }, ene.UNIFORM = { type: 3, value: "UNIFORM" };
  let Jg = ene;
  e.IfcSectionTypeEnum = Jg;
  const ar = class ar {
  };
  ar.CO2SENSOR = { type: 3, value: "CO2SENSOR" }, ar.CONDUCTANCESENSOR = { type: 3, value: "CONDUCTANCESENSOR" }, ar.CONTACTSENSOR = { type: 3, value: "CONTACTSENSOR" }, ar.COSENSOR = { type: 3, value: "COSENSOR" }, ar.EARTHQUAKESENSOR = { type: 3, value: "EARTHQUAKESENSOR" }, ar.FIRESENSOR = { type: 3, value: "FIRESENSOR" }, ar.FLOWSENSOR = { type: 3, value: "FLOWSENSOR" }, ar.FOREIGNOBJECTDETECTIONSENSOR = { type: 3, value: "FOREIGNOBJECTDETECTIONSENSOR" }, ar.FROSTSENSOR = { type: 3, value: "FROSTSENSOR" }, ar.GASSENSOR = { type: 3, value: "GASSENSOR" }, ar.HEATSENSOR = { type: 3, value: "HEATSENSOR" }, ar.HUMIDITYSENSOR = { type: 3, value: "HUMIDITYSENSOR" }, ar.IDENTIFIERSENSOR = { type: 3, value: "IDENTIFIERSENSOR" }, ar.IONCONCENTRATIONSENSOR = { type: 3, value: "IONCONCENTRATIONSENSOR" }, ar.LEVELSENSOR = { type: 3, value: "LEVELSENSOR" }, ar.LIGHTSENSOR = { type: 3, value: "LIGHTSENSOR" }, ar.MOISTURESENSOR = { type: 3, value: "MOISTURESENSOR" }, ar.MOVEMENTSENSOR = { type: 3, value: "MOVEMENTSENSOR" }, ar.OBSTACLESENSOR = { type: 3, value: "OBSTACLESENSOR" }, ar.PHSENSOR = { type: 3, value: "PHSENSOR" }, ar.PRESSURESENSOR = { type: 3, value: "PRESSURESENSOR" }, ar.RADIATIONSENSOR = { type: 3, value: "RADIATIONSENSOR" }, ar.RADIOACTIVITYSENSOR = { type: 3, value: "RADIOACTIVITYSENSOR" }, ar.RAINSENSOR = { type: 3, value: "RAINSENSOR" }, ar.SMOKESENSOR = { type: 3, value: "SMOKESENSOR" }, ar.SNOWDEPTHSENSOR = { type: 3, value: "SNOWDEPTHSENSOR" }, ar.SOUNDSENSOR = { type: 3, value: "SOUNDSENSOR" }, ar.TEMPERATURESENSOR = { type: 3, value: "TEMPERATURESENSOR" }, ar.TRAINSENSOR = { type: 3, value: "TRAINSENSOR" }, ar.TURNOUTCLOSURESENSOR = { type: 3, value: "TURNOUTCLOSURESENSOR" }, ar.WHEELSENSOR = { type: 3, value: "WHEELSENSOR" }, ar.WINDSENSOR = { type: 3, value: "WINDSENSOR" }, ar.USERDEFINED = { type: 3, value: "USERDEFINED" }, ar.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let G4 = ar;
  e.IfcSensorTypeEnum = G4;
  const o_ = class o_ {
  };
  o_.FINISH_FINISH = { type: 3, value: "FINISH_FINISH" }, o_.FINISH_START = { type: 3, value: "FINISH_START" }, o_.START_FINISH = { type: 3, value: "START_FINISH" }, o_.START_START = { type: 3, value: "START_START" }, o_.USERDEFINED = { type: 3, value: "USERDEFINED" }, o_.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let k4 = o_;
  e.IfcSequenceEnum = k4;
  const U9 = class U9 {
  };
  U9.AWNING = { type: 3, value: "AWNING" }, U9.JALOUSIE = { type: 3, value: "JALOUSIE" }, U9.SHUTTER = { type: 3, value: "SHUTTER" }, U9.USERDEFINED = { type: 3, value: "USERDEFINED" }, U9.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Y5 = U9;
  e.IfcShadingDeviceTypeEnum = Y5;
  const B9 = class B9 {
  };
  B9.MARKER = { type: 3, value: "MARKER" }, B9.MIRROR = { type: 3, value: "MIRROR" }, B9.PICTORAL = { type: 3, value: "PICTORAL" }, B9.USERDEFINED = { type: 3, value: "USERDEFINED" }, B9.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let rm = B9;
  e.IfcSignTypeEnum = rm;
  const F9 = class F9 {
  };
  F9.AUDIO = { type: 3, value: "AUDIO" }, F9.MIXED = { type: 3, value: "MIXED" }, F9.VISUAL = { type: 3, value: "VISUAL" }, F9.USERDEFINED = { type: 3, value: "USERDEFINED" }, F9.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let V4 = F9;
  e.IfcSignalTypeEnum = V4;
  const Ry = class Ry {
  };
  Ry.P_BOUNDEDVALUE = { type: 3, value: "P_BOUNDEDVALUE" }, Ry.P_ENUMERATEDVALUE = { type: 3, value: "P_ENUMERATEDVALUE" }, Ry.P_LISTVALUE = { type: 3, value: "P_LISTVALUE" }, Ry.P_REFERENCEVALUE = { type: 3, value: "P_REFERENCEVALUE" }, Ry.P_SINGLEVALUE = { type: 3, value: "P_SINGLEVALUE" }, Ry.P_TABLEVALUE = { type: 3, value: "P_TABLEVALUE" }, Ry.Q_AREA = { type: 3, value: "Q_AREA" }, Ry.Q_COUNT = { type: 3, value: "Q_COUNT" }, Ry.Q_LENGTH = { type: 3, value: "Q_LENGTH" }, Ry.Q_NUMBER = { type: 3, value: "Q_NUMBER" }, Ry.Q_TIME = { type: 3, value: "Q_TIME" }, Ry.Q_VOLUME = { type: 3, value: "Q_VOLUME" }, Ry.Q_WEIGHT = { type: 3, value: "Q_WEIGHT" };
  let Y = Ry;
  e.IfcSimplePropertyTemplateTypeEnum = Y;
  const $w = class $w {
  };
  $w.APPROACH_SLAB = { type: 3, value: "APPROACH_SLAB" }, $w.BASESLAB = { type: 3, value: "BASESLAB" }, $w.FLOOR = { type: 3, value: "FLOOR" }, $w.LANDING = { type: 3, value: "LANDING" }, $w.PAVING = { type: 3, value: "PAVING" }, $w.ROOF = { type: 3, value: "ROOF" }, $w.SIDEWALK = { type: 3, value: "SIDEWALK" }, $w.TRACKSLAB = { type: 3, value: "TRACKSLAB" }, $w.WEARING = { type: 3, value: "WEARING" }, $w.USERDEFINED = { type: 3, value: "USERDEFINED" }, $w.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let oe = $w;
  e.IfcSlabTypeEnum = oe;
  const Dk = class Dk {
  };
  Dk.SOLARCOLLECTOR = { type: 3, value: "SOLARCOLLECTOR" }, Dk.SOLARPANEL = { type: 3, value: "SOLARPANEL" }, Dk.USERDEFINED = { type: 3, value: "USERDEFINED" }, Dk.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let we = Dk;
  e.IfcSolarDeviceTypeEnum = we;
  const Ck = class Ck {
  };
  Ck.CONVECTOR = { type: 3, value: "CONVECTOR" }, Ck.RADIATOR = { type: 3, value: "RADIATOR" }, Ck.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ck.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Pe = Ck;
  e.IfcSpaceHeaterTypeEnum = Pe;
  const JS = class JS {
  };
  JS.BERTH = { type: 3, value: "BERTH" }, JS.EXTERNAL = { type: 3, value: "EXTERNAL" }, JS.GFA = { type: 3, value: "GFA" }, JS.INTERNAL = { type: 3, value: "INTERNAL" }, JS.PARKING = { type: 3, value: "PARKING" }, JS.SPACE = { type: 3, value: "SPACE" }, JS.USERDEFINED = { type: 3, value: "USERDEFINED" }, JS.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let et = JS;
  e.IfcSpaceTypeEnum = et;
  const tg = class tg {
  };
  tg.CONSTRUCTION = { type: 3, value: "CONSTRUCTION" }, tg.FIRESAFETY = { type: 3, value: "FIRESAFETY" }, tg.INTERFERENCE = { type: 3, value: "INTERFERENCE" }, tg.LIGHTING = { type: 3, value: "LIGHTING" }, tg.OCCUPANCY = { type: 3, value: "OCCUPANCY" }, tg.RESERVATION = { type: 3, value: "RESERVATION" }, tg.SECURITY = { type: 3, value: "SECURITY" }, tg.THERMAL = { type: 3, value: "THERMAL" }, tg.TRANSPORT = { type: 3, value: "TRANSPORT" }, tg.VENTILATION = { type: 3, value: "VENTILATION" }, tg.USERDEFINED = { type: 3, value: "USERDEFINED" }, tg.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let wt = tg;
  e.IfcSpatialZoneTypeEnum = wt;
  const H9 = class H9 {
  };
  H9.BIRDCAGE = { type: 3, value: "BIRDCAGE" }, H9.COWL = { type: 3, value: "COWL" }, H9.RAINWATERHOPPER = { type: 3, value: "RAINWATERHOPPER" }, H9.USERDEFINED = { type: 3, value: "USERDEFINED" }, H9.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let St = H9;
  e.IfcStackTerminalTypeEnum = St;
  const OD = class OD {
  };
  OD.CURVED = { type: 3, value: "CURVED" }, OD.FREEFORM = { type: 3, value: "FREEFORM" }, OD.SPIRAL = { type: 3, value: "SPIRAL" }, OD.STRAIGHT = { type: 3, value: "STRAIGHT" }, OD.WINDER = { type: 3, value: "WINDER" }, OD.USERDEFINED = { type: 3, value: "USERDEFINED" }, OD.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Ot = OD;
  e.IfcStairFlightTypeEnum = Ot;
  const Fh = class Fh {
  };
  Fh.CURVED_RUN_STAIR = { type: 3, value: "CURVED_RUN_STAIR" }, Fh.DOUBLE_RETURN_STAIR = { type: 3, value: "DOUBLE_RETURN_STAIR" }, Fh.HALF_TURN_STAIR = { type: 3, value: "HALF_TURN_STAIR" }, Fh.HALF_WINDING_STAIR = { type: 3, value: "HALF_WINDING_STAIR" }, Fh.LADDER = { type: 3, value: "LADDER" }, Fh.QUARTER_TURN_STAIR = { type: 3, value: "QUARTER_TURN_STAIR" }, Fh.QUARTER_WINDING_STAIR = { type: 3, value: "QUARTER_WINDING_STAIR" }, Fh.SPIRAL_STAIR = { type: 3, value: "SPIRAL_STAIR" }, Fh.STRAIGHT_RUN_STAIR = { type: 3, value: "STRAIGHT_RUN_STAIR" }, Fh.THREE_QUARTER_TURN_STAIR = { type: 3, value: "THREE_QUARTER_TURN_STAIR" }, Fh.THREE_QUARTER_WINDING_STAIR = { type: 3, value: "THREE_QUARTER_WINDING_STAIR" }, Fh.TWO_CURVED_RUN_STAIR = { type: 3, value: "TWO_CURVED_RUN_STAIR" }, Fh.TWO_QUARTER_TURN_STAIR = { type: 3, value: "TWO_QUARTER_TURN_STAIR" }, Fh.TWO_QUARTER_WINDING_STAIR = { type: 3, value: "TWO_QUARTER_WINDING_STAIR" }, Fh.TWO_STRAIGHT_RUN_STAIR = { type: 3, value: "TWO_STRAIGHT_RUN_STAIR" }, Fh.USERDEFINED = { type: 3, value: "USERDEFINED" }, Fh.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let ii = Fh;
  e.IfcStairTypeEnum = ii;
  const G9 = class G9 {
  };
  G9.LOCKED = { type: 3, value: "LOCKED" }, G9.READONLY = { type: 3, value: "READONLY" }, G9.READONLYLOCKED = { type: 3, value: "READONLYLOCKED" }, G9.READWRITE = { type: 3, value: "READWRITE" }, G9.READWRITELOCKED = { type: 3, value: "READWRITELOCKED" };
  let Ei = G9;
  e.IfcStateEnum = Ei;
  const iv = class iv {
  };
  iv.CONST = { type: 3, value: "CONST" }, iv.DISCRETE = { type: 3, value: "DISCRETE" }, iv.EQUIDISTANT = { type: 3, value: "EQUIDISTANT" }, iv.LINEAR = { type: 3, value: "LINEAR" }, iv.PARABOLA = { type: 3, value: "PARABOLA" }, iv.POLYGONAL = { type: 3, value: "POLYGONAL" }, iv.SINUS = { type: 3, value: "SINUS" }, iv.USERDEFINED = { type: 3, value: "USERDEFINED" }, iv.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Qi = iv;
  e.IfcStructuralCurveActivityTypeEnum = Qi;
  const LD = class LD {
  };
  LD.CABLE = { type: 3, value: "CABLE" }, LD.COMPRESSION_MEMBER = { type: 3, value: "COMPRESSION_MEMBER" }, LD.PIN_JOINED_MEMBER = { type: 3, value: "PIN_JOINED_MEMBER" }, LD.RIGID_JOINED_MEMBER = { type: 3, value: "RIGID_JOINED_MEMBER" }, LD.TENSION_MEMBER = { type: 3, value: "TENSION_MEMBER" }, LD.USERDEFINED = { type: 3, value: "USERDEFINED" }, LD.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let vn = LD;
  e.IfcStructuralCurveMemberTypeEnum = vn;
  const r_ = class r_ {
  };
  r_.BILINEAR = { type: 3, value: "BILINEAR" }, r_.CONST = { type: 3, value: "CONST" }, r_.DISCRETE = { type: 3, value: "DISCRETE" }, r_.ISOCONTOUR = { type: 3, value: "ISOCONTOUR" }, r_.USERDEFINED = { type: 3, value: "USERDEFINED" }, r_.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let cn = r_;
  e.IfcStructuralSurfaceActivityTypeEnum = cn;
  const k9 = class k9 {
  };
  k9.BENDING_ELEMENT = { type: 3, value: "BENDING_ELEMENT" }, k9.MEMBRANE_ELEMENT = { type: 3, value: "MEMBRANE_ELEMENT" }, k9.SHELL = { type: 3, value: "SHELL" }, k9.USERDEFINED = { type: 3, value: "USERDEFINED" }, k9.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let hn = k9;
  e.IfcStructuralSurfaceMemberTypeEnum = hn;
  const Ok = class Ok {
  };
  Ok.PURCHASE = { type: 3, value: "PURCHASE" }, Ok.WORK = { type: 3, value: "WORK" }, Ok.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ok.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Zn = Ok;
  e.IfcSubContractResourceTypeEnum = Zn;
  const vy = class vy {
  };
  vy.DEFECT = { type: 3, value: "DEFECT" }, vy.HATCHMARKING = { type: 3, value: "HATCHMARKING" }, vy.LINEMARKING = { type: 3, value: "LINEMARKING" }, vy.MARK = { type: 3, value: "MARK" }, vy.NONSKIDSURFACING = { type: 3, value: "NONSKIDSURFACING" }, vy.PAVEMENTSURFACEMARKING = { type: 3, value: "PAVEMENTSURFACEMARKING" }, vy.RUMBLESTRIP = { type: 3, value: "RUMBLESTRIP" }, vy.SYMBOLMARKING = { type: 3, value: "SYMBOLMARKING" }, vy.TAG = { type: 3, value: "TAG" }, vy.TRANSVERSERUMBLESTRIP = { type: 3, value: "TRANSVERSERUMBLESTRIP" }, vy.TREATMENT = { type: 3, value: "TREATMENT" }, vy.USERDEFINED = { type: 3, value: "USERDEFINED" }, vy.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Js = vy;
  e.IfcSurfaceFeatureTypeEnum = Js;
  const aZ = class aZ {
  };
  aZ.BOTH = { type: 3, value: "BOTH" }, aZ.NEGATIVE = { type: 3, value: "NEGATIVE" }, aZ.POSITIVE = { type: 3, value: "POSITIVE" };
  let wo = aZ;
  e.IfcSurfaceSide = wo;
  const Ay = class Ay {
  };
  Ay.CONTACTOR = { type: 3, value: "CONTACTOR" }, Ay.DIMMERSWITCH = { type: 3, value: "DIMMERSWITCH" }, Ay.EMERGENCYSTOP = { type: 3, value: "EMERGENCYSTOP" }, Ay.KEYPAD = { type: 3, value: "KEYPAD" }, Ay.MOMENTARYSWITCH = { type: 3, value: "MOMENTARYSWITCH" }, Ay.RELAY = { type: 3, value: "RELAY" }, Ay.SELECTORSWITCH = { type: 3, value: "SELECTORSWITCH" }, Ay.STARTER = { type: 3, value: "STARTER" }, Ay.START_AND_STOP_EQUIPMENT = { type: 3, value: "START_AND_STOP_EQUIPMENT" }, Ay.SWITCHDISCONNECTOR = { type: 3, value: "SWITCHDISCONNECTOR" }, Ay.TOGGLESWITCH = { type: 3, value: "TOGGLESWITCH" }, Ay.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ay.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let To = Ay;
  e.IfcSwitchingDeviceTypeEnum = To;
  const V9 = class V9 {
  };
  V9.PANEL = { type: 3, value: "PANEL" }, V9.SUBRACK = { type: 3, value: "SUBRACK" }, V9.WORKSURFACE = { type: 3, value: "WORKSURFACE" }, V9.USERDEFINED = { type: 3, value: "USERDEFINED" }, V9.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Mi = V9;
  e.IfcSystemFurnitureElementTypeEnum = Mi;
  const HT = class HT {
  };
  HT.BASIN = { type: 3, value: "BASIN" }, HT.BREAKPRESSURE = { type: 3, value: "BREAKPRESSURE" }, HT.EXPANSION = { type: 3, value: "EXPANSION" }, HT.FEEDANDEXPANSION = { type: 3, value: "FEEDANDEXPANSION" }, HT.OILRETENTIONTRAY = { type: 3, value: "OILRETENTIONTRAY" }, HT.PRESSUREVESSEL = { type: 3, value: "PRESSUREVESSEL" }, HT.STORAGE = { type: 3, value: "STORAGE" }, HT.VESSEL = { type: 3, value: "VESSEL" }, HT.USERDEFINED = { type: 3, value: "USERDEFINED" }, HT.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Dn = HT;
  e.IfcTankTypeEnum = Dn;
  const uZ = class uZ {
  };
  uZ.ELAPSEDTIME = { type: 3, value: "ELAPSEDTIME" }, uZ.WORKTIME = { type: 3, value: "WORKTIME" }, uZ.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let nl = uZ;
  e.IfcTaskDurationEnum = nl;
  const Ea = class Ea {
  };
  Ea.ADJUSTMENT = { type: 3, value: "ADJUSTMENT" }, Ea.ATTENDANCE = { type: 3, value: "ATTENDANCE" }, Ea.CALIBRATION = { type: 3, value: "CALIBRATION" }, Ea.CONSTRUCTION = { type: 3, value: "CONSTRUCTION" }, Ea.DEMOLITION = { type: 3, value: "DEMOLITION" }, Ea.DISMANTLE = { type: 3, value: "DISMANTLE" }, Ea.DISPOSAL = { type: 3, value: "DISPOSAL" }, Ea.EMERGENCY = { type: 3, value: "EMERGENCY" }, Ea.INSPECTION = { type: 3, value: "INSPECTION" }, Ea.INSTALLATION = { type: 3, value: "INSTALLATION" }, Ea.LOGISTIC = { type: 3, value: "LOGISTIC" }, Ea.MAINTENANCE = { type: 3, value: "MAINTENANCE" }, Ea.MOVE = { type: 3, value: "MOVE" }, Ea.OPERATION = { type: 3, value: "OPERATION" }, Ea.REMOVAL = { type: 3, value: "REMOVAL" }, Ea.RENOVATION = { type: 3, value: "RENOVATION" }, Ea.SAFETY = { type: 3, value: "SAFETY" }, Ea.SHUTDOWN = { type: 3, value: "SHUTDOWN" }, Ea.STARTUP = { type: 3, value: "STARTUP" }, Ea.TESTING = { type: 3, value: "TESTING" }, Ea.TROUBLESHOOTING = { type: 3, value: "TROUBLESHOOTING" }, Ea.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ea.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let sr = Ea;
  e.IfcTaskTypeEnum = sr;
  const z9 = class z9 {
  };
  z9.COUPLER = { type: 3, value: "COUPLER" }, z9.FIXED_END = { type: 3, value: "FIXED_END" }, z9.TENSIONING_END = { type: 3, value: "TENSIONING_END" }, z9.USERDEFINED = { type: 3, value: "USERDEFINED" }, z9.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Yl = z9;
  e.IfcTendonAnchorTypeEnum = Yl;
  const _D = class _D {
  };
  _D.COUPLER = { type: 3, value: "COUPLER" }, _D.DIABOLO = { type: 3, value: "DIABOLO" }, _D.DUCT = { type: 3, value: "DUCT" }, _D.GROUTING_DUCT = { type: 3, value: "GROUTING_DUCT" }, _D.TRUMPET = { type: 3, value: "TRUMPET" }, _D.USERDEFINED = { type: 3, value: "USERDEFINED" }, _D.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let sl = _D;
  e.IfcTendonConduitTypeEnum = sl;
  const l_ = class l_ {
  };
  l_.BAR = { type: 3, value: "BAR" }, l_.COATED = { type: 3, value: "COATED" }, l_.STRAND = { type: 3, value: "STRAND" }, l_.WIRE = { type: 3, value: "WIRE" }, l_.USERDEFINED = { type: 3, value: "USERDEFINED" }, l_.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let VA = l_;
  e.IfcTendonTypeEnum = VA;
  const Lk = class Lk {
  };
  Lk.DOWN = { type: 3, value: "DOWN" }, Lk.LEFT = { type: 3, value: "LEFT" }, Lk.RIGHT = { type: 3, value: "RIGHT" }, Lk.UP = { type: 3, value: "UP" };
  let h6 = Lk;
  e.IfcTextPath = h6;
  const xD = class xD {
  };
  xD.CONTINUOUS = { type: 3, value: "CONTINUOUS" }, xD.DISCRETE = { type: 3, value: "DISCRETE" }, xD.DISCRETEBINARY = { type: 3, value: "DISCRETEBINARY" }, xD.PIECEWISEBINARY = { type: 3, value: "PIECEWISEBINARY" }, xD.PIECEWISECONSTANT = { type: 3, value: "PIECEWISECONSTANT" }, xD.PIECEWISECONTINUOUS = { type: 3, value: "PIECEWISECONTINUOUS" }, xD.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let f6 = xD;
  e.IfcTimeSeriesDataTypeEnum = f6;
  const GT = class GT {
  };
  GT.BLOCKINGDEVICE = { type: 3, value: "BLOCKINGDEVICE" }, GT.DERAILER = { type: 3, value: "DERAILER" }, GT.FROG = { type: 3, value: "FROG" }, GT.HALF_SET_OF_BLADES = { type: 3, value: "HALF_SET_OF_BLADES" }, GT.SLEEPER = { type: 3, value: "SLEEPER" }, GT.SPEEDREGULATOR = { type: 3, value: "SPEEDREGULATOR" }, GT.TRACKENDOFALIGNMENT = { type: 3, value: "TRACKENDOFALIGNMENT" }, GT.VEHICLESTOP = { type: 3, value: "VEHICLESTOP" }, GT.USERDEFINED = { type: 3, value: "USERDEFINED" }, GT.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let RL = GT;
  e.IfcTrackElementTypeEnum = RL;
  const nv = class nv {
  };
  nv.CHOPPER = { type: 3, value: "CHOPPER" }, nv.COMBINED = { type: 3, value: "COMBINED" }, nv.CURRENT = { type: 3, value: "CURRENT" }, nv.FREQUENCY = { type: 3, value: "FREQUENCY" }, nv.INVERTER = { type: 3, value: "INVERTER" }, nv.RECTIFIER = { type: 3, value: "RECTIFIER" }, nv.VOLTAGE = { type: 3, value: "VOLTAGE" }, nv.USERDEFINED = { type: 3, value: "USERDEFINED" }, nv.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let vL = nv;
  e.IfcTransformerTypeEnum = vL;
  const _k = class _k {
  };
  _k.CONTINUOUS = { type: 3, value: "CONTINUOUS" }, _k.CONTSAMEGRADIENT = { type: 3, value: "CONTSAMEGRADIENT" }, _k.CONTSAMEGRADIENTSAMECURVATURE = { type: 3, value: "CONTSAMEGRADIENTSAMECURVATURE" }, _k.DISCONTINUOUS = { type: 3, value: "DISCONTINUOUS" };
  let G8 = _k;
  e.IfcTransitionCode = G8;
  const XS = class XS {
  };
  XS.CRANEWAY = { type: 3, value: "CRANEWAY" }, XS.ELEVATOR = { type: 3, value: "ELEVATOR" }, XS.ESCALATOR = { type: 3, value: "ESCALATOR" }, XS.HAULINGGEAR = { type: 3, value: "HAULINGGEAR" }, XS.LIFTINGGEAR = { type: 3, value: "LIFTINGGEAR" }, XS.MOVINGWALKWAY = { type: 3, value: "MOVINGWALKWAY" }, XS.USERDEFINED = { type: 3, value: "USERDEFINED" }, XS.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let k8 = XS;
  e.IfcTransportElementTypeEnum = k8;
  const dZ = class dZ {
  };
  dZ.CARTESIAN = { type: 3, value: "CARTESIAN" }, dZ.PARAMETER = { type: 3, value: "PARAMETER" }, dZ.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" };
  let V8 = dZ;
  e.IfcTrimmingPreference = V8;
  const cZ = class cZ {
  };
  cZ.FINNED = { type: 3, value: "FINNED" }, cZ.USERDEFINED = { type: 3, value: "USERDEFINED" }, cZ.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let z8 = cZ;
  e.IfcTubeBundleTypeEnum = z8;
  const qr = class qr {
  };
  qr.ABSORBEDDOSEUNIT = { type: 3, value: "ABSORBEDDOSEUNIT" }, qr.AMOUNTOFSUBSTANCEUNIT = { type: 3, value: "AMOUNTOFSUBSTANCEUNIT" }, qr.AREAUNIT = { type: 3, value: "AREAUNIT" }, qr.DOSEEQUIVALENTUNIT = { type: 3, value: "DOSEEQUIVALENTUNIT" }, qr.ELECTRICCAPACITANCEUNIT = { type: 3, value: "ELECTRICCAPACITANCEUNIT" }, qr.ELECTRICCHARGEUNIT = { type: 3, value: "ELECTRICCHARGEUNIT" }, qr.ELECTRICCONDUCTANCEUNIT = { type: 3, value: "ELECTRICCONDUCTANCEUNIT" }, qr.ELECTRICCURRENTUNIT = { type: 3, value: "ELECTRICCURRENTUNIT" }, qr.ELECTRICRESISTANCEUNIT = { type: 3, value: "ELECTRICRESISTANCEUNIT" }, qr.ELECTRICVOLTAGEUNIT = { type: 3, value: "ELECTRICVOLTAGEUNIT" }, qr.ENERGYUNIT = { type: 3, value: "ENERGYUNIT" }, qr.FORCEUNIT = { type: 3, value: "FORCEUNIT" }, qr.FREQUENCYUNIT = { type: 3, value: "FREQUENCYUNIT" }, qr.ILLUMINANCEUNIT = { type: 3, value: "ILLUMINANCEUNIT" }, qr.INDUCTANCEUNIT = { type: 3, value: "INDUCTANCEUNIT" }, qr.LENGTHUNIT = { type: 3, value: "LENGTHUNIT" }, qr.LUMINOUSFLUXUNIT = { type: 3, value: "LUMINOUSFLUXUNIT" }, qr.LUMINOUSINTENSITYUNIT = { type: 3, value: "LUMINOUSINTENSITYUNIT" }, qr.MAGNETICFLUXDENSITYUNIT = { type: 3, value: "MAGNETICFLUXDENSITYUNIT" }, qr.MAGNETICFLUXUNIT = { type: 3, value: "MAGNETICFLUXUNIT" }, qr.MASSUNIT = { type: 3, value: "MASSUNIT" }, qr.PLANEANGLEUNIT = { type: 3, value: "PLANEANGLEUNIT" }, qr.POWERUNIT = { type: 3, value: "POWERUNIT" }, qr.PRESSUREUNIT = { type: 3, value: "PRESSUREUNIT" }, qr.RADIOACTIVITYUNIT = { type: 3, value: "RADIOACTIVITYUNIT" }, qr.SOLIDANGLEUNIT = { type: 3, value: "SOLIDANGLEUNIT" }, qr.THERMODYNAMICTEMPERATUREUNIT = { type: 3, value: "THERMODYNAMICTEMPERATUREUNIT" }, qr.TIMEUNIT = { type: 3, value: "TIMEUNIT" }, qr.VOLUMEUNIT = { type: 3, value: "VOLUMEUNIT" }, qr.USERDEFINED = { type: 3, value: "USERDEFINED" };
  let z4 = qr;
  e.IfcUnitEnum = z4;
  const ig = class ig {
  };
  ig.ALARMPANEL = { type: 3, value: "ALARMPANEL" }, ig.BASESTATIONCONTROLLER = { type: 3, value: "BASESTATIONCONTROLLER" }, ig.COMBINED = { type: 3, value: "COMBINED" }, ig.CONTROLPANEL = { type: 3, value: "CONTROLPANEL" }, ig.GASDETECTIONPANEL = { type: 3, value: "GASDETECTIONPANEL" }, ig.HUMIDISTAT = { type: 3, value: "HUMIDISTAT" }, ig.INDICATORPANEL = { type: 3, value: "INDICATORPANEL" }, ig.MIMICPANEL = { type: 3, value: "MIMICPANEL" }, ig.THERMOSTAT = { type: 3, value: "THERMOSTAT" }, ig.WEATHERSTATION = { type: 3, value: "WEATHERSTATION" }, ig.USERDEFINED = { type: 3, value: "USERDEFINED" }, ig.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Rh = ig;
  e.IfcUnitaryControlElementTypeEnum = Rh;
  const PD = class PD {
  };
  PD.AIRCONDITIONINGUNIT = { type: 3, value: "AIRCONDITIONINGUNIT" }, PD.AIRHANDLER = { type: 3, value: "AIRHANDLER" }, PD.DEHUMIDIFIER = { type: 3, value: "DEHUMIDIFIER" }, PD.ROOFTOPUNIT = { type: 3, value: "ROOFTOPUNIT" }, PD.SPLITSYSTEM = { type: 3, value: "SPLITSYSTEM" }, PD.USERDEFINED = { type: 3, value: "USERDEFINED" }, PD.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let j8 = PD;
  e.IfcUnitaryEquipmentTypeEnum = j8;
  const ga = class ga {
  };
  ga.AIRRELEASE = { type: 3, value: "AIRRELEASE" }, ga.ANTIVACUUM = { type: 3, value: "ANTIVACUUM" }, ga.CHANGEOVER = { type: 3, value: "CHANGEOVER" }, ga.CHECK = { type: 3, value: "CHECK" }, ga.COMMISSIONING = { type: 3, value: "COMMISSIONING" }, ga.DIVERTING = { type: 3, value: "DIVERTING" }, ga.DOUBLECHECK = { type: 3, value: "DOUBLECHECK" }, ga.DOUBLEREGULATING = { type: 3, value: "DOUBLEREGULATING" }, ga.DRAWOFFCOCK = { type: 3, value: "DRAWOFFCOCK" }, ga.FAUCET = { type: 3, value: "FAUCET" }, ga.FLUSHING = { type: 3, value: "FLUSHING" }, ga.GASCOCK = { type: 3, value: "GASCOCK" }, ga.GASTAP = { type: 3, value: "GASTAP" }, ga.ISOLATING = { type: 3, value: "ISOLATING" }, ga.MIXING = { type: 3, value: "MIXING" }, ga.PRESSUREREDUCING = { type: 3, value: "PRESSUREREDUCING" }, ga.PRESSURERELIEF = { type: 3, value: "PRESSURERELIEF" }, ga.REGULATING = { type: 3, value: "REGULATING" }, ga.SAFETYCUTOFF = { type: 3, value: "SAFETYCUTOFF" }, ga.STEAMTRAP = { type: 3, value: "STEAMTRAP" }, ga.STOPCOCK = { type: 3, value: "STOPCOCK" }, ga.USERDEFINED = { type: 3, value: "USERDEFINED" }, ga.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let q5 = ga;
  e.IfcValveTypeEnum = q5;
  const sv = class sv {
  };
  sv.CARGO = { type: 3, value: "CARGO" }, sv.ROLLINGSTOCK = { type: 3, value: "ROLLINGSTOCK" }, sv.VEHICLE = { type: 3, value: "VEHICLE" }, sv.VEHICLEAIR = { type: 3, value: "VEHICLEAIR" }, sv.VEHICLEMARINE = { type: 3, value: "VEHICLEMARINE" }, sv.VEHICLETRACKED = { type: 3, value: "VEHICLETRACKED" }, sv.VEHICLEWHEELED = { type: 3, value: "VEHICLEWHEELED" }, sv.USERDEFINED = { type: 3, value: "USERDEFINED" }, sv.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let zA = sv;
  e.IfcVehicleTypeEnum = zA;
  const eb = class eb {
  };
  eb.AXIAL_YIELD = { type: 3, value: "AXIAL_YIELD" }, eb.BENDING_YIELD = { type: 3, value: "BENDING_YIELD" }, eb.FRICTION = { type: 3, value: "FRICTION" }, eb.RUBBER = { type: 3, value: "RUBBER" }, eb.SHEAR_YIELD = { type: 3, value: "SHEAR_YIELD" }, eb.VISCOUS = { type: 3, value: "VISCOUS" }, eb.USERDEFINED = { type: 3, value: "USERDEFINED" }, eb.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let W8 = eb;
  e.IfcVibrationDamperTypeEnum = W8;
  const j9 = class j9 {
  };
  j9.BASE = { type: 3, value: "BASE" }, j9.COMPRESSION = { type: 3, value: "COMPRESSION" }, j9.SPRING = { type: 3, value: "SPRING" }, j9.USERDEFINED = { type: 3, value: "USERDEFINED" }, j9.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let I6 = j9;
  e.IfcVibrationIsolatorTypeEnum = I6;
  const W9 = class W9 {
  };
  W9.BOUNDARY = { type: 3, value: "BOUNDARY" }, W9.CLEARANCE = { type: 3, value: "CLEARANCE" }, W9.PROVISIONFORVOID = { type: 3, value: "PROVISIONFORVOID" }, W9.USERDEFINED = { type: 3, value: "USERDEFINED" }, W9.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let AL = W9;
  e.IfcVirtualElementTypeEnum = AL;
  const tb = class tb {
  };
  tb.CHAMFER = { type: 3, value: "CHAMFER" }, tb.CUTOUT = { type: 3, value: "CUTOUT" }, tb.EDGE = { type: 3, value: "EDGE" }, tb.HOLE = { type: 3, value: "HOLE" }, tb.MITER = { type: 3, value: "MITER" }, tb.NOTCH = { type: 3, value: "NOTCH" }, tb.USERDEFINED = { type: 3, value: "USERDEFINED" }, tb.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Y8 = tb;
  e.IfcVoidingFeatureTypeEnum = Y8;
  const Sy = class Sy {
  };
  Sy.ELEMENTEDWALL = { type: 3, value: "ELEMENTEDWALL" }, Sy.MOVABLE = { type: 3, value: "MOVABLE" }, Sy.PARAPET = { type: 3, value: "PARAPET" }, Sy.PARTITIONING = { type: 3, value: "PARTITIONING" }, Sy.PLUMBINGWALL = { type: 3, value: "PLUMBINGWALL" }, Sy.POLYGONAL = { type: 3, value: "POLYGONAL" }, Sy.RETAININGWALL = { type: 3, value: "RETAININGWALL" }, Sy.SHEAR = { type: 3, value: "SHEAR" }, Sy.SOLIDWALL = { type: 3, value: "SOLIDWALL" }, Sy.STANDARD = { type: 3, value: "STANDARD" }, Sy.WAVEWALL = { type: 3, value: "WAVEWALL" }, Sy.USERDEFINED = { type: 3, value: "USERDEFINED" }, Sy.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let j4 = Sy;
  e.IfcWallTypeEnum = j4;
  const ov = class ov {
  };
  ov.FLOORTRAP = { type: 3, value: "FLOORTRAP" }, ov.FLOORWASTE = { type: 3, value: "FLOORWASTE" }, ov.GULLYSUMP = { type: 3, value: "GULLYSUMP" }, ov.GULLYTRAP = { type: 3, value: "GULLYTRAP" }, ov.ROOFDRAIN = { type: 3, value: "ROOFDRAIN" }, ov.WASTEDISPOSALUNIT = { type: 3, value: "WASTEDISPOSALUNIT" }, ov.WASTETRAP = { type: 3, value: "WASTETRAP" }, ov.USERDEFINED = { type: 3, value: "USERDEFINED" }, ov.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let q8 = ov;
  e.IfcWasteTerminalTypeEnum = q8;
  const Nm = class Nm {
  };
  Nm.BOTTOMHUNG = { type: 3, value: "BOTTOMHUNG" }, Nm.FIXEDCASEMENT = { type: 3, value: "FIXEDCASEMENT" }, Nm.OTHEROPERATION = { type: 3, value: "OTHEROPERATION" }, Nm.PIVOTHORIZONTAL = { type: 3, value: "PIVOTHORIZONTAL" }, Nm.PIVOTVERTICAL = { type: 3, value: "PIVOTVERTICAL" }, Nm.REMOVABLECASEMENT = { type: 3, value: "REMOVABLECASEMENT" }, Nm.SIDEHUNGLEFTHAND = { type: 3, value: "SIDEHUNGLEFTHAND" }, Nm.SIDEHUNGRIGHTHAND = { type: 3, value: "SIDEHUNGRIGHTHAND" }, Nm.SLIDINGHORIZONTAL = { type: 3, value: "SLIDINGHORIZONTAL" }, Nm.SLIDINGVERTICAL = { type: 3, value: "SLIDINGVERTICAL" }, Nm.TILTANDTURNLEFTHAND = { type: 3, value: "TILTANDTURNLEFTHAND" }, Nm.TILTANDTURNRIGHTHAND = { type: 3, value: "TILTANDTURNRIGHTHAND" }, Nm.TOPHUNG = { type: 3, value: "TOPHUNG" }, Nm.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let p6 = Nm;
  e.IfcWindowPanelOperationEnum = p6;
  const a_ = class a_ {
  };
  a_.BOTTOM = { type: 3, value: "BOTTOM" }, a_.LEFT = { type: 3, value: "LEFT" }, a_.MIDDLE = { type: 3, value: "MIDDLE" }, a_.RIGHT = { type: 3, value: "RIGHT" }, a_.TOP = { type: 3, value: "TOP" }, a_.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let $8 = a_;
  e.IfcWindowPanelPositionEnum = $8;
  const ib = class ib {
  };
  ib.ALUMINIUM = { type: 3, value: "ALUMINIUM" }, ib.ALUMINIUM_WOOD = { type: 3, value: "ALUMINIUM_WOOD" }, ib.HIGH_GRADE_STEEL = { type: 3, value: "HIGH_GRADE_STEEL" }, ib.OTHER_CONSTRUCTION = { type: 3, value: "OTHER_CONSTRUCTION" }, ib.PLASTIC = { type: 3, value: "PLASTIC" }, ib.STEEL = { type: 3, value: "STEEL" }, ib.WOOD = { type: 3, value: "WOOD" }, ib.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let vh = ib;
  e.IfcWindowStyleConstructionEnum = vh;
  const Kw = class Kw {
  };
  Kw.DOUBLE_PANEL_HORIZONTAL = { type: 3, value: "DOUBLE_PANEL_HORIZONTAL" }, Kw.DOUBLE_PANEL_VERTICAL = { type: 3, value: "DOUBLE_PANEL_VERTICAL" }, Kw.SINGLE_PANEL = { type: 3, value: "SINGLE_PANEL" }, Kw.TRIPLE_PANEL_BOTTOM = { type: 3, value: "TRIPLE_PANEL_BOTTOM" }, Kw.TRIPLE_PANEL_HORIZONTAL = { type: 3, value: "TRIPLE_PANEL_HORIZONTAL" }, Kw.TRIPLE_PANEL_LEFT = { type: 3, value: "TRIPLE_PANEL_LEFT" }, Kw.TRIPLE_PANEL_RIGHT = { type: 3, value: "TRIPLE_PANEL_RIGHT" }, Kw.TRIPLE_PANEL_TOP = { type: 3, value: "TRIPLE_PANEL_TOP" }, Kw.TRIPLE_PANEL_VERTICAL = { type: 3, value: "TRIPLE_PANEL_VERTICAL" }, Kw.USERDEFINED = { type: 3, value: "USERDEFINED" }, Kw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let jA = Kw;
  e.IfcWindowStyleOperationEnum = jA;
  const Y9 = class Y9 {
  };
  Y9.LIGHTDOME = { type: 3, value: "LIGHTDOME" }, Y9.SKYLIGHT = { type: 3, value: "SKYLIGHT" }, Y9.WINDOW = { type: 3, value: "WINDOW" }, Y9.USERDEFINED = { type: 3, value: "USERDEFINED" }, Y9.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let m6 = Y9;
  e.IfcWindowTypeEnum = m6;
  const Zw = class Zw {
  };
  Zw.DOUBLE_PANEL_HORIZONTAL = { type: 3, value: "DOUBLE_PANEL_HORIZONTAL" }, Zw.DOUBLE_PANEL_VERTICAL = { type: 3, value: "DOUBLE_PANEL_VERTICAL" }, Zw.SINGLE_PANEL = { type: 3, value: "SINGLE_PANEL" }, Zw.TRIPLE_PANEL_BOTTOM = { type: 3, value: "TRIPLE_PANEL_BOTTOM" }, Zw.TRIPLE_PANEL_HORIZONTAL = { type: 3, value: "TRIPLE_PANEL_HORIZONTAL" }, Zw.TRIPLE_PANEL_LEFT = { type: 3, value: "TRIPLE_PANEL_LEFT" }, Zw.TRIPLE_PANEL_RIGHT = { type: 3, value: "TRIPLE_PANEL_RIGHT" }, Zw.TRIPLE_PANEL_TOP = { type: 3, value: "TRIPLE_PANEL_TOP" }, Zw.TRIPLE_PANEL_VERTICAL = { type: 3, value: "TRIPLE_PANEL_VERTICAL" }, Zw.USERDEFINED = { type: 3, value: "USERDEFINED" }, Zw.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let K8 = Zw;
  e.IfcWindowTypePartitioningEnum = K8;
  const q9 = class q9 {
  };
  q9.FIRSTSHIFT = { type: 3, value: "FIRSTSHIFT" }, q9.SECONDSHIFT = { type: 3, value: "SECONDSHIFT" }, q9.THIRDSHIFT = { type: 3, value: "THIRDSHIFT" }, q9.USERDEFINED = { type: 3, value: "USERDEFINED" }, q9.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Z8 = q9;
  e.IfcWorkCalendarTypeEnum = Z8;
  const $9 = class $9 {
  };
  $9.ACTUAL = { type: 3, value: "ACTUAL" }, $9.BASELINE = { type: 3, value: "BASELINE" }, $9.PLANNED = { type: 3, value: "PLANNED" }, $9.USERDEFINED = { type: 3, value: "USERDEFINED" }, $9.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let SL = $9;
  e.IfcWorkPlanTypeEnum = SL;
  const K9 = class K9 {
  };
  K9.ACTUAL = { type: 3, value: "ACTUAL" }, K9.BASELINE = { type: 3, value: "BASELINE" }, K9.PLANNED = { type: 3, value: "PLANNED" }, K9.USERDEFINED = { type: 3, value: "USERDEFINED" }, K9.NOTDEFINED = { type: 3, value: "NOTDEFINED" };
  let Q8 = K9;
  e.IfcWorkScheduleTypeEnum = Q8;
  class pY extends qt {
    constructor(E, g, T) {
      super(), this.Role = E, this.UserDefinedRole = g, this.Description = T, this.type = 3630933823;
    }
  }
  e.IfcActorRole = pY;
  class y6 extends qt {
    constructor(E, g, T) {
      super(), this.Purpose = E, this.Description = g, this.UserDefinedPurpose = T, this.type = 618182010;
    }
  }
  e.IfcAddress = y6;
  class bL extends qt {
    constructor(E, g) {
      super(), this.StartTag = E, this.EndTag = g, this.type = 2879124712;
    }
  }
  e.IfcAlignmentParameterSegment = bL;
  class mY extends bL {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g), this.StartTag = E, this.EndTag = g, this.StartDistAlong = T, this.HorizontalLength = b, this.StartHeight = _, this.StartGradient = H, this.EndGradient = V, this.RadiusOfCurvature = q, this.PredefinedType = se, this.type = 3633395639;
    }
  }
  e.IfcAlignmentVerticalSegment = mY;
  class yY extends qt {
    constructor(E, g, T, b) {
      super(), this.ApplicationDeveloper = E, this.Version = g, this.ApplicationFullName = T, this.ApplicationIdentifier = b, this.type = 639542469;
    }
  }
  e.IfcApplication = yY;
  class E6 extends qt {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(), this.Name = E, this.Description = g, this.AppliedValue = T, this.UnitBasis = b, this.ApplicableDate = _, this.FixedUntilDate = H, this.Category = V, this.Condition = q, this.ArithmeticOperator = se, this.Components = qe, this.type = 411424972;
    }
  }
  e.IfcAppliedValue = E6;
  class J8 extends qt {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(), this.Identifier = E, this.Name = g, this.Description = T, this.TimeOfApproval = b, this.Status = _, this.Level = H, this.Qualifier = V, this.RequestingApproval = q, this.GivingApproval = se, this.type = 130549933;
    }
  }
  e.IfcApproval = J8;
  class NL extends qt {
    constructor(E) {
      super(), this.Name = E, this.type = 4037036970;
    }
  }
  e.IfcBoundaryCondition = NL;
  class X8 extends NL {
    constructor(E, g, T, b, _, H, V) {
      super(E), this.Name = E, this.TranslationalStiffnessByLengthX = g, this.TranslationalStiffnessByLengthY = T, this.TranslationalStiffnessByLengthZ = b, this.RotationalStiffnessByLengthX = _, this.RotationalStiffnessByLengthY = H, this.RotationalStiffnessByLengthZ = V, this.type = 1560379544;
    }
  }
  e.IfcBoundaryEdgeCondition = X8;
  class BH extends NL {
    constructor(E, g, T, b) {
      super(E), this.Name = E, this.TranslationalStiffnessByAreaX = g, this.TranslationalStiffnessByAreaY = T, this.TranslationalStiffnessByAreaZ = b, this.type = 3367102660;
    }
  }
  e.IfcBoundaryFaceCondition = BH;
  class WA extends NL {
    constructor(E, g, T, b, _, H, V) {
      super(E), this.Name = E, this.TranslationalStiffnessX = g, this.TranslationalStiffnessY = T, this.TranslationalStiffnessZ = b, this.RotationalStiffnessX = _, this.RotationalStiffnessY = H, this.RotationalStiffnessZ = V, this.type = 1387855156;
    }
  }
  e.IfcBoundaryNodeCondition = WA;
  class EY extends WA {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V), this.Name = E, this.TranslationalStiffnessX = g, this.TranslationalStiffnessY = T, this.TranslationalStiffnessZ = b, this.RotationalStiffnessX = _, this.RotationalStiffnessY = H, this.RotationalStiffnessZ = V, this.WarpingStiffness = q, this.type = 2069777674;
    }
  }
  e.IfcBoundaryNodeConditionWarping = EY;
  class $5 extends qt {
    constructor() {
      super(), this.type = 2859738748;
    }
  }
  e.IfcConnectionGeometry = $5;
  class W3 extends $5 {
    constructor(E, g) {
      super(), this.PointOnRelatingElement = E, this.PointOnRelatedElement = g, this.type = 2614616156;
    }
  }
  e.IfcConnectionPointGeometry = W3;
  class gY extends $5 {
    constructor(E, g) {
      super(), this.SurfaceOnRelatingElement = E, this.SurfaceOnRelatedElement = g, this.type = 2732653382;
    }
  }
  e.IfcConnectionSurfaceGeometry = gY;
  class xd extends $5 {
    constructor(E, g) {
      super(), this.VolumeOnRelatingElement = E, this.VolumeOnRelatedElement = g, this.type = 775493141;
    }
  }
  e.IfcConnectionVolumeGeometry = xd;
  class DL extends qt {
    constructor(E, g, T, b, _, H, V) {
      super(), this.Name = E, this.Description = g, this.ConstraintGrade = T, this.ConstraintSource = b, this.CreatingActor = _, this.CreationTime = H, this.UserDefinedGrade = V, this.type = 1959218052;
    }
  }
  e.IfcConstraint = DL;
  class FH extends qt {
    constructor(E, g) {
      super(), this.SourceCRS = E, this.TargetCRS = g, this.type = 1785450214;
    }
  }
  e.IfcCoordinateOperation = FH;
  class W4 extends qt {
    constructor(E, g, T, b) {
      super(), this.Name = E, this.Description = g, this.GeodeticDatum = T, this.VerticalDatum = b, this.type = 1466758467;
    }
  }
  e.IfcCoordinateReferenceSystem = W4;
  class wY extends E6 {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se, qe), this.Name = E, this.Description = g, this.AppliedValue = T, this.UnitBasis = b, this.ApplicableDate = _, this.FixedUntilDate = H, this.Category = V, this.Condition = q, this.ArithmeticOperator = se, this.Components = qe, this.type = 602808272;
    }
  }
  e.IfcCostValue = wY;
  class Xg extends qt {
    constructor(E, g, T, b) {
      super(), this.Elements = E, this.UnitType = g, this.UserDefinedType = T, this.Name = b, this.type = 1765591967;
    }
  }
  e.IfcDerivedUnit = Xg;
  class Y4 extends qt {
    constructor(E, g) {
      super(), this.Unit = E, this.Exponent = g, this.type = 1045800335;
    }
  }
  e.IfcDerivedUnitElement = Y4;
  class HH extends qt {
    constructor(E, g, T, b, _, H, V) {
      super(), this.LengthExponent = E, this.MassExponent = g, this.TimeExponent = T, this.ElectricCurrentExponent = b, this.ThermodynamicTemperatureExponent = _, this.AmountOfSubstanceExponent = H, this.LuminousIntensityExponent = V, this.type = 2949456006;
    }
  }
  e.IfcDimensionalExponents = HH;
  class GI extends qt {
    constructor() {
      super(), this.type = 4294318154;
    }
  }
  e.IfcExternalInformation = GI;
  class K5 extends qt {
    constructor(E, g, T) {
      super(), this.Location = E, this.Identification = g, this.Name = T, this.type = 3200245327;
    }
  }
  e.IfcExternalReference = K5;
  class GH extends K5 {
    constructor(E, g, T) {
      super(E, g, T), this.Location = E, this.Identification = g, this.Name = T, this.type = 2242383968;
    }
  }
  e.IfcExternallyDefinedHatchStyle = GH;
  class kH extends K5 {
    constructor(E, g, T) {
      super(E, g, T), this.Location = E, this.Identification = g, this.Name = T, this.type = 1040185647;
    }
  }
  e.IfcExternallyDefinedSurfaceStyle = kH;
  class TY extends K5 {
    constructor(E, g, T) {
      super(E, g, T), this.Location = E, this.Identification = g, this.Name = T, this.type = 3548104201;
    }
  }
  e.IfcExternallyDefinedTextFont = TY;
  class RY extends qt {
    constructor(E, g, T) {
      super(), this.AxisTag = E, this.AxisCurve = g, this.SameSense = T, this.type = 852622518;
    }
  }
  e.IfcGridAxis = RY;
  class vY extends qt {
    constructor(E, g) {
      super(), this.TimeStamp = E, this.ListValues = g, this.type = 3020489413;
    }
  }
  e.IfcIrregularTimeSeriesValue = vY;
  class AY extends GI {
    constructor(E, g, T, b, _, H) {
      super(), this.Name = E, this.Version = g, this.Publisher = T, this.VersionDate = b, this.Location = _, this.Description = H, this.type = 2655187982;
    }
  }
  e.IfcLibraryInformation = AY;
  class VH extends K5 {
    constructor(E, g, T, b, _, H) {
      super(E, g, T), this.Location = E, this.Identification = g, this.Name = T, this.Description = b, this.Language = _, this.ReferencedLibrary = H, this.type = 3452421091;
    }
  }
  e.IfcLibraryReference = VH;
  class SY extends qt {
    constructor(E, g, T) {
      super(), this.MainPlaneAngle = E, this.SecondaryPlaneAngle = g, this.LuminousIntensity = T, this.type = 4162380809;
    }
  }
  e.IfcLightDistributionData = SY;
  class YA extends qt {
    constructor(E, g) {
      super(), this.LightDistributionCurve = E, this.DistributionData = g, this.type = 1566485204;
    }
  }
  e.IfcLightIntensityDistribution = YA;
  class zH extends FH {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g), this.SourceCRS = E, this.TargetCRS = g, this.Eastings = T, this.Northings = b, this.OrthogonalHeight = _, this.XAxisAbscissa = H, this.XAxisOrdinate = V, this.Scale = q, this.ScaleY = se, this.ScaleZ = qe, this.type = 3057273783;
    }
  }
  e.IfcMapConversion = zH;
  class g6 extends qt {
    constructor(E, g) {
      super(), this.MaterialClassifications = E, this.ClassifiedMaterial = g, this.type = 1847130766;
    }
  }
  e.IfcMaterialClassificationRelationship = g6;
  class q4 extends qt {
    constructor() {
      super(), this.type = 760658860;
    }
  }
  e.IfcMaterialDefinition = q4;
  class Y3 extends q4 {
    constructor(E, g, T, b, _, H, V) {
      super(), this.Material = E, this.LayerThickness = g, this.IsVentilated = T, this.Name = b, this.Description = _, this.Category = H, this.Priority = V, this.type = 248100487;
    }
  }
  e.IfcMaterialLayer = Y3;
  class CL extends q4 {
    constructor(E, g, T) {
      super(), this.MaterialLayers = E, this.LayerSetName = g, this.Description = T, this.type = 3303938423;
    }
  }
  e.IfcMaterialLayerSet = CL;
  class bY extends Y3 {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V), this.Material = E, this.LayerThickness = g, this.IsVentilated = T, this.Name = b, this.Description = _, this.Category = H, this.Priority = V, this.OffsetDirection = q, this.OffsetValues = se, this.type = 1847252529;
    }
  }
  e.IfcMaterialLayerWithOffsets = bY;
  class qA extends qt {
    constructor(E) {
      super(), this.Materials = E, this.type = 2199411900;
    }
  }
  e.IfcMaterialList = qA;
  class jH extends q4 {
    constructor(E, g, T, b, _, H) {
      super(), this.Name = E, this.Description = g, this.Material = T, this.Profile = b, this.Priority = _, this.Category = H, this.type = 2235152071;
    }
  }
  e.IfcMaterialProfile = jH;
  class eM extends q4 {
    constructor(E, g, T, b) {
      super(), this.Name = E, this.Description = g, this.MaterialProfiles = T, this.CompositeProfile = b, this.type = 164193824;
    }
  }
  e.IfcMaterialProfileSet = eM;
  class tM extends jH {
    constructor(E, g, T, b, _, H, V) {
      super(E, g, T, b, _, H), this.Name = E, this.Description = g, this.Material = T, this.Profile = b, this.Priority = _, this.Category = H, this.OffsetValues = V, this.type = 552965576;
    }
  }
  e.IfcMaterialProfileWithOffsets = tM;
  class w6 extends qt {
    constructor() {
      super(), this.type = 1507914824;
    }
  }
  e.IfcMaterialUsageDefinition = w6;
  class iM extends qt {
    constructor(E, g) {
      super(), this.ValueComponent = E, this.UnitComponent = g, this.type = 2597039031;
    }
  }
  e.IfcMeasureWithUnit = iM;
  class NY extends DL {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi) {
      super(E, g, T, b, _, H, V), this.Name = E, this.Description = g, this.ConstraintGrade = T, this.ConstraintSource = b, this.CreatingActor = _, this.CreationTime = H, this.UserDefinedGrade = V, this.Benchmark = q, this.ValueSource = se, this.DataValue = qe, this.ReferencePath = vi, this.type = 3368373690;
    }
  }
  e.IfcMetric = NY;
  class nM extends qt {
    constructor(E) {
      super(), this.Currency = E, this.type = 2706619895;
    }
  }
  e.IfcMonetaryUnit = nM;
  class q3 extends qt {
    constructor(E, g) {
      super(), this.Dimensions = E, this.UnitType = g, this.type = 1918398963;
    }
  }
  e.IfcNamedUnit = q3;
  class OL extends qt {
    constructor(E) {
      super(), this.PlacementRelTo = E, this.type = 3701648758;
    }
  }
  e.IfcObjectPlacement = OL;
  class WH extends DL {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi) {
      super(E, g, T, b, _, H, V), this.Name = E, this.Description = g, this.ConstraintGrade = T, this.ConstraintSource = b, this.CreatingActor = _, this.CreationTime = H, this.UserDefinedGrade = V, this.BenchmarkValues = q, this.LogicalAggregator = se, this.ObjectiveQualifier = qe, this.UserDefinedQualifier = vi, this.type = 2251480897;
    }
  }
  e.IfcObjective = WH;
  class $4 extends qt {
    constructor(E, g, T, b, _) {
      super(), this.Identification = E, this.Name = g, this.Description = T, this.Roles = b, this.Addresses = _, this.type = 4251960020;
    }
  }
  e.IfcOrganization = $4;
  class DY extends qt {
    constructor(E, g, T, b, _, H, V, q) {
      super(), this.OwningUser = E, this.OwningApplication = g, this.State = T, this.ChangeAction = b, this.LastModifiedDate = _, this.LastModifyingUser = H, this.LastModifyingApplication = V, this.CreationDate = q, this.type = 1207048766;
    }
  }
  e.IfcOwnerHistory = DY;
  class CY extends qt {
    constructor(E, g, T, b, _, H, V, q) {
      super(), this.Identification = E, this.FamilyName = g, this.GivenName = T, this.MiddleNames = b, this.PrefixTitles = _, this.SuffixTitles = H, this.Roles = V, this.Addresses = q, this.type = 2077209135;
    }
  }
  e.IfcPerson = CY;
  class YH extends qt {
    constructor(E, g, T) {
      super(), this.ThePerson = E, this.TheOrganization = g, this.Roles = T, this.type = 101040310;
    }
  }
  e.IfcPersonAndOrganization = YH;
  class sM extends qt {
    constructor(E, g) {
      super(), this.Name = E, this.Description = g, this.type = 2483315170;
    }
  }
  e.IfcPhysicalQuantity = sM;
  class K4 extends sM {
    constructor(E, g, T) {
      super(E, g), this.Name = E, this.Description = g, this.Unit = T, this.type = 2226359599;
    }
  }
  e.IfcPhysicalSimpleQuantity = K4;
  class qH extends y6 {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T), this.Purpose = E, this.Description = g, this.UserDefinedPurpose = T, this.InternalLocation = b, this.AddressLines = _, this.PostalBox = H, this.Town = V, this.Region = q, this.PostalCode = se, this.Country = qe, this.type = 3355820592;
    }
  }
  e.IfcPostalAddress = qH;
  class Pd extends qt {
    constructor() {
      super(), this.type = 677532197;
    }
  }
  e.IfcPresentationItem = Pd;
  class gE extends qt {
    constructor(E, g, T, b) {
      super(), this.Name = E, this.Description = g, this.AssignedItems = T, this.Identifier = b, this.type = 2022622350;
    }
  }
  e.IfcPresentationLayerAssignment = gE;
  class OY extends gE {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b), this.Name = E, this.Description = g, this.AssignedItems = T, this.Identifier = b, this.LayerOn = _, this.LayerFrozen = H, this.LayerBlocked = V, this.LayerStyles = q, this.type = 1304840413;
    }
  }
  e.IfcPresentationLayerWithStyle = OY;
  class $A extends qt {
    constructor(E) {
      super(), this.Name = E, this.type = 3119450353;
    }
  }
  e.IfcPresentationStyle = $A;
  class oM extends qt {
    constructor(E, g, T) {
      super(), this.Name = E, this.Description = g, this.Representations = T, this.type = 2095639259;
    }
  }
  e.IfcProductRepresentation = oM;
  class ew extends qt {
    constructor(E, g) {
      super(), this.ProfileType = E, this.ProfileName = g, this.type = 3958567839;
    }
  }
  e.IfcProfileDef = ew;
  class $H extends W4 {
    constructor(E, g, T, b, _, H, V) {
      super(E, g, T, b), this.Name = E, this.Description = g, this.GeodeticDatum = T, this.VerticalDatum = b, this.MapProjection = _, this.MapZone = H, this.MapUnit = V, this.type = 3843373140;
    }
  }
  e.IfcProjectedCRS = $H;
  class T6 extends qt {
    constructor() {
      super(), this.type = 986844984;
    }
  }
  e.IfcPropertyAbstraction = T6;
  class LY extends T6 {
    constructor(E, g, T) {
      super(), this.Name = E, this.EnumerationValues = g, this.Unit = T, this.type = 3710013099;
    }
  }
  e.IfcPropertyEnumeration = LY;
  class _Y extends K4 {
    constructor(E, g, T, b, _) {
      super(E, g, T), this.Name = E, this.Description = g, this.Unit = T, this.AreaValue = b, this.Formula = _, this.type = 2044713172;
    }
  }
  e.IfcQuantityArea = _Y;
  class xY extends K4 {
    constructor(E, g, T, b, _) {
      super(E, g, T), this.Name = E, this.Description = g, this.Unit = T, this.CountValue = b, this.Formula = _, this.type = 2093928680;
    }
  }
  e.IfcQuantityCount = xY;
  class LL extends K4 {
    constructor(E, g, T, b, _) {
      super(E, g, T), this.Name = E, this.Description = g, this.Unit = T, this.LengthValue = b, this.Formula = _, this.type = 931644368;
    }
  }
  e.IfcQuantityLength = LL;
  class PY extends K4 {
    constructor(E, g, T, b, _) {
      super(E, g, T), this.Name = E, this.Description = g, this.Unit = T, this.NumberValue = b, this.Formula = _, this.type = 2691318326;
    }
  }
  e.IfcQuantityNumber = PY;
  class MY extends K4 {
    constructor(E, g, T, b, _) {
      super(E, g, T), this.Name = E, this.Description = g, this.Unit = T, this.TimeValue = b, this.Formula = _, this.type = 3252649465;
    }
  }
  e.IfcQuantityTime = MY;
  class rM extends K4 {
    constructor(E, g, T, b, _) {
      super(E, g, T), this.Name = E, this.Description = g, this.Unit = T, this.VolumeValue = b, this.Formula = _, this.type = 2405470396;
    }
  }
  e.IfcQuantityVolume = rM;
  class UY extends K4 {
    constructor(E, g, T, b, _) {
      super(E, g, T), this.Name = E, this.Description = g, this.Unit = T, this.WeightValue = b, this.Formula = _, this.type = 825690147;
    }
  }
  e.IfcQuantityWeight = UY;
  class BY extends qt {
    constructor(E, g, T, b, _, H, V, q) {
      super(), this.RecurrenceType = E, this.DayComponent = g, this.WeekdayComponent = T, this.MonthComponent = b, this.Position = _, this.Interval = H, this.Occurrences = V, this.TimePeriods = q, this.type = 3915482550;
    }
  }
  e.IfcRecurrencePattern = BY;
  class lM extends qt {
    constructor(E, g, T, b, _) {
      super(), this.TypeIdentifier = E, this.AttributeIdentifier = g, this.InstanceName = T, this.ListPositions = b, this.InnerReference = _, this.type = 2433181523;
    }
  }
  e.IfcReference = lM;
  class aM extends qt {
    constructor(E, g, T, b) {
      super(), this.ContextOfItems = E, this.RepresentationIdentifier = g, this.RepresentationType = T, this.Items = b, this.type = 1076942058;
    }
  }
  e.IfcRepresentation = aM;
  class tw extends qt {
    constructor(E, g) {
      super(), this.ContextIdentifier = E, this.ContextType = g, this.type = 3377609919;
    }
  }
  e.IfcRepresentationContext = tw;
  class R6 extends qt {
    constructor() {
      super(), this.type = 3008791417;
    }
  }
  e.IfcRepresentationItem = R6;
  class FY extends qt {
    constructor(E, g) {
      super(), this.MappingOrigin = E, this.MappedRepresentation = g, this.type = 1660063152;
    }
  }
  e.IfcRepresentationMap = FY;
  class $3 extends qt {
    constructor(E, g) {
      super(), this.Name = E, this.Description = g, this.type = 2439245199;
    }
  }
  e.IfcResourceLevelRelationship = $3;
  class _L extends qt {
    constructor(E, g, T, b) {
      super(), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.type = 2341007311;
    }
  }
  e.IfcRoot = _L;
  class HY extends q3 {
    constructor(E, g, T) {
      super(new u(0), E), this.UnitType = E, this.Prefix = g, this.Name = T, this.type = 448429030;
    }
  }
  e.IfcSIUnit = HY;
  class iw extends qt {
    constructor(E, g, T) {
      super(), this.Name = E, this.DataOrigin = g, this.UserDefinedDataOrigin = T, this.type = 1054537805;
    }
  }
  e.IfcSchedulingTime = iw;
  class GY extends qt {
    constructor(E, g, T, b, _) {
      super(), this.ShapeRepresentations = E, this.Name = g, this.Description = T, this.ProductDefinitional = b, this.PartOfProductDefinitionShape = _, this.type = 867548509;
    }
  }
  e.IfcShapeAspect = GY;
  class xL extends aM {
    constructor(E, g, T, b) {
      super(E, g, T, b), this.ContextOfItems = E, this.RepresentationIdentifier = g, this.RepresentationType = T, this.Items = b, this.type = 3982875396;
    }
  }
  e.IfcShapeModel = xL;
  class uM extends xL {
    constructor(E, g, T, b) {
      super(E, g, T, b), this.ContextOfItems = E, this.RepresentationIdentifier = g, this.RepresentationType = T, this.Items = b, this.type = 4240577450;
    }
  }
  e.IfcShapeRepresentation = uM;
  class PL extends qt {
    constructor(E) {
      super(), this.Name = E, this.type = 2273995522;
    }
  }
  e.IfcStructuralConnectionCondition = PL;
  class dM extends qt {
    constructor(E) {
      super(), this.Name = E, this.type = 2162789131;
    }
  }
  e.IfcStructuralLoad = dM;
  class kY extends dM {
    constructor(E, g, T) {
      super(E), this.Name = E, this.Values = g, this.Locations = T, this.type = 3478079324;
    }
  }
  e.IfcStructuralLoadConfiguration = kY;
  class cM extends dM {
    constructor(E) {
      super(E), this.Name = E, this.type = 609421318;
    }
  }
  e.IfcStructuralLoadOrResult = cM;
  class KA extends cM {
    constructor(E) {
      super(E), this.Name = E, this.type = 2525727697;
    }
  }
  e.IfcStructuralLoadStatic = KA;
  class VY extends KA {
    constructor(E, g, T, b) {
      super(E), this.Name = E, this.DeltaTConstant = g, this.DeltaTY = T, this.DeltaTZ = b, this.type = 3408363356;
    }
  }
  e.IfcStructuralLoadTemperature = VY;
  class hM extends aM {
    constructor(E, g, T, b) {
      super(E, g, T, b), this.ContextOfItems = E, this.RepresentationIdentifier = g, this.RepresentationType = T, this.Items = b, this.type = 2830218821;
    }
  }
  e.IfcStyleModel = hM;
  class KH extends R6 {
    constructor(E, g, T) {
      super(), this.Item = E, this.Styles = g, this.Name = T, this.type = 3958052878;
    }
  }
  e.IfcStyledItem = KH;
  class ML extends hM {
    constructor(E, g, T, b) {
      super(E, g, T, b), this.ContextOfItems = E, this.RepresentationIdentifier = g, this.RepresentationType = T, this.Items = b, this.type = 3049322572;
    }
  }
  e.IfcStyledRepresentation = ML;
  class br extends cM {
    constructor(E, g, T, b) {
      super(E), this.Name = E, this.SurfaceReinforcement1 = g, this.SurfaceReinforcement2 = T, this.ShearReinforcement = b, this.type = 2934153892;
    }
  }
  e.IfcSurfaceReinforcementArea = br;
  class zY extends $A {
    constructor(E, g, T) {
      super(E), this.Name = E, this.Side = g, this.Styles = T, this.type = 1300840506;
    }
  }
  e.IfcSurfaceStyle = zY;
  class ZH extends Pd {
    constructor(E, g, T, b) {
      super(), this.DiffuseTransmissionColour = E, this.DiffuseReflectionColour = g, this.TransmissionColour = T, this.ReflectanceColour = b, this.type = 3303107099;
    }
  }
  e.IfcSurfaceStyleLighting = ZH;
  class QH extends Pd {
    constructor(E, g) {
      super(), this.RefractionIndex = E, this.DispersionFactor = g, this.type = 1607154358;
    }
  }
  e.IfcSurfaceStyleRefraction = QH;
  class UL extends Pd {
    constructor(E, g) {
      super(), this.SurfaceColour = E, this.Transparency = g, this.type = 846575682;
    }
  }
  e.IfcSurfaceStyleShading = UL;
  class jY extends Pd {
    constructor(E) {
      super(), this.Textures = E, this.type = 1351298697;
    }
  }
  e.IfcSurfaceStyleWithTextures = jY;
  class BL extends Pd {
    constructor(E, g, T, b, _) {
      super(), this.RepeatS = E, this.RepeatT = g, this.Mode = T, this.TextureTransform = b, this.Parameter = _, this.type = 626085974;
    }
  }
  e.IfcSurfaceTexture = BL;
  class WY extends qt {
    constructor(E, g, T) {
      super(), this.Name = E, this.Rows = g, this.Columns = T, this.type = 985171141;
    }
  }
  e.IfcTable = WY;
  class v6 extends qt {
    constructor(E, g, T, b, _) {
      super(), this.Identifier = E, this.Name = g, this.Description = T, this.Unit = b, this.ReferencePath = _, this.type = 2043862942;
    }
  }
  e.IfcTableColumn = v6;
  class YY extends qt {
    constructor(E, g) {
      super(), this.RowCells = E, this.IsHeading = g, this.type = 531007025;
    }
  }
  e.IfcTableRow = YY;
  class fM extends iw {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In, gs, $r, $d, N0, Dm, nb, xk, Pk) {
      super(E, g, T), this.Name = E, this.DataOrigin = g, this.UserDefinedDataOrigin = T, this.DurationType = b, this.ScheduleDuration = _, this.ScheduleStart = H, this.ScheduleFinish = V, this.EarlyStart = q, this.EarlyFinish = se, this.LateStart = qe, this.LateFinish = vi, this.FreeFloat = In, this.TotalFloat = gs, this.IsCritical = $r, this.StatusTime = $d, this.ActualDuration = N0, this.ActualStart = Dm, this.ActualFinish = nb, this.RemainingTime = xk, this.Completion = Pk, this.type = 1549132990;
    }
  }
  e.IfcTaskTime = fM;
  class qY extends fM {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In, gs, $r, $d, N0, Dm, nb, xk, Pk, K6e) {
      super(E, g, T, b, _, H, V, q, se, qe, vi, In, gs, $r, $d, N0, Dm, nb, xk, Pk), this.Name = E, this.DataOrigin = g, this.UserDefinedDataOrigin = T, this.DurationType = b, this.ScheduleDuration = _, this.ScheduleStart = H, this.ScheduleFinish = V, this.EarlyStart = q, this.EarlyFinish = se, this.LateStart = qe, this.LateFinish = vi, this.FreeFloat = In, this.TotalFloat = gs, this.IsCritical = $r, this.StatusTime = $d, this.ActualDuration = N0, this.ActualStart = Dm, this.ActualFinish = nb, this.RemainingTime = xk, this.Completion = Pk, this.Recurrence = K6e, this.type = 2771591690;
    }
  }
  e.IfcTaskTimeRecurring = qY;
  class JH extends y6 {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T), this.Purpose = E, this.Description = g, this.UserDefinedPurpose = T, this.TelephoneNumbers = b, this.FacsimileNumbers = _, this.PagerNumber = H, this.ElectronicMailAddresses = V, this.WWWHomePageURL = q, this.MessagingIDs = se, this.type = 912023232;
    }
  }
  e.IfcTelecomAddress = JH;
  class $Y extends $A {
    constructor(E, g, T, b, _) {
      super(E), this.Name = E, this.TextCharacterAppearance = g, this.TextStyle = T, this.TextFontStyle = b, this.ModelOrDraughting = _, this.type = 1447204868;
    }
  }
  e.IfcTextStyle = $Y;
  class FL extends Pd {
    constructor(E, g) {
      super(), this.Colour = E, this.BackgroundColour = g, this.type = 2636378356;
    }
  }
  e.IfcTextStyleForDefinedFont = FL;
  class HL extends Pd {
    constructor(E, g, T, b, _, H, V) {
      super(), this.TextIndent = E, this.TextAlign = g, this.TextDecoration = T, this.LetterSpacing = b, this.WordSpacing = _, this.TextTransform = H, this.LineHeight = V, this.type = 1640371178;
    }
  }
  e.IfcTextStyleTextModel = HL;
  class GL extends Pd {
    constructor(E) {
      super(), this.Maps = E, this.type = 280115917;
    }
  }
  e.IfcTextureCoordinate = GL;
  class IM extends GL {
    constructor(E, g, T) {
      super(E), this.Maps = E, this.Mode = g, this.Parameter = T, this.type = 1742049831;
    }
  }
  e.IfcTextureCoordinateGenerator = IM;
  class XH extends qt {
    constructor(E, g) {
      super(), this.TexCoordIndex = E, this.TexCoordsOf = g, this.type = 222769930;
    }
  }
  e.IfcTextureCoordinateIndices = XH;
  class kL extends XH {
    constructor(E, g, T) {
      super(E, g), this.TexCoordIndex = E, this.TexCoordsOf = g, this.InnerTexCoordIndices = T, this.type = 1010789467;
    }
  }
  e.IfcTextureCoordinateIndicesWithVoids = kL;
  class pM extends GL {
    constructor(E, g, T) {
      super(E), this.Maps = E, this.Vertices = g, this.MappedTo = T, this.type = 2552916305;
    }
  }
  e.IfcTextureMap = pM;
  class KY extends Pd {
    constructor(E) {
      super(), this.Coordinates = E, this.type = 1210645708;
    }
  }
  e.IfcTextureVertex = KY;
  class eG extends Pd {
    constructor(E) {
      super(), this.TexCoordsList = E, this.type = 3611470254;
    }
  }
  e.IfcTextureVertexList = eG;
  class kI extends qt {
    constructor(E, g) {
      super(), this.StartTime = E, this.EndTime = g, this.type = 1199560280;
    }
  }
  e.IfcTimePeriod = kI;
  class mM extends qt {
    constructor(E, g, T, b, _, H, V, q) {
      super(), this.Name = E, this.Description = g, this.StartTime = T, this.EndTime = b, this.TimeSeriesDataType = _, this.DataOrigin = H, this.UserDefinedDataOrigin = V, this.Unit = q, this.type = 3101149627;
    }
  }
  e.IfcTimeSeries = mM;
  class tG extends qt {
    constructor(E) {
      super(), this.ListValues = E, this.type = 581633288;
    }
  }
  e.IfcTimeSeriesValue = tG;
  class Xo extends R6 {
    constructor() {
      super(), this.type = 1377556343;
    }
  }
  e.IfcTopologicalRepresentationItem = Xo;
  class VL extends xL {
    constructor(E, g, T, b) {
      super(E, g, T, b), this.ContextOfItems = E, this.RepresentationIdentifier = g, this.RepresentationType = T, this.Items = b, this.type = 1735638870;
    }
  }
  e.IfcTopologyRepresentation = VL;
  class yM extends qt {
    constructor(E) {
      super(), this.Units = E, this.type = 180925521;
    }
  }
  e.IfcUnitAssignment = yM;
  class A6 extends Xo {
    constructor() {
      super(), this.type = 2799835756;
    }
  }
  e.IfcVertex = A6;
  class EM extends A6 {
    constructor(E) {
      super(), this.VertexGeometry = E, this.type = 1907098498;
    }
  }
  e.IfcVertexPoint = EM;
  class ZY extends qt {
    constructor(E, g) {
      super(), this.IntersectingAxes = E, this.OffsetDistances = g, this.type = 891718957;
    }
  }
  e.IfcVirtualGridIntersection = ZY;
  class QY extends iw {
    constructor(E, g, T, b, _, H) {
      super(E, g, T), this.Name = E, this.DataOrigin = g, this.UserDefinedDataOrigin = T, this.RecurrencePattern = b, this.StartDate = _, this.FinishDate = H, this.type = 1236880293;
    }
  }
  e.IfcWorkTime = QY;
  class iG extends bL {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g), this.StartTag = E, this.EndTag = g, this.StartDistAlong = T, this.HorizontalLength = b, this.StartCantLeft = _, this.EndCantLeft = H, this.StartCantRight = V, this.EndCantRight = q, this.PredefinedType = se, this.type = 3752311538;
    }
  }
  e.IfcAlignmentCantSegment = iG;
  class nG extends bL {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g), this.StartTag = E, this.EndTag = g, this.StartPoint = T, this.StartDirection = b, this.StartRadiusOfCurvature = _, this.EndRadiusOfCurvature = H, this.SegmentLength = V, this.GravityCenterLineHeight = q, this.PredefinedType = se, this.type = 536804194;
    }
  }
  e.IfcAlignmentHorizontalSegment = nG;
  class sG extends $3 {
    constructor(E, g, T, b) {
      super(E, g), this.Name = E, this.Description = g, this.RelatingApproval = T, this.RelatedApprovals = b, this.type = 3869604511;
    }
  }
  e.IfcApprovalRelationship = sG;
  class oG extends ew {
    constructor(E, g, T) {
      super(E, g), this.ProfileType = E, this.ProfileName = g, this.OuterCurve = T, this.type = 3798115385;
    }
  }
  e.IfcArbitraryClosedProfileDef = oG;
  class ZA extends ew {
    constructor(E, g, T) {
      super(E, g), this.ProfileType = E, this.ProfileName = g, this.Curve = T, this.type = 1310608509;
    }
  }
  e.IfcArbitraryOpenProfileDef = ZA;
  class JY extends oG {
    constructor(E, g, T, b) {
      super(E, g, T), this.ProfileType = E, this.ProfileName = g, this.OuterCurve = T, this.InnerCurves = b, this.type = 2705031697;
    }
  }
  e.IfcArbitraryProfileDefWithVoids = JY;
  class XY extends BL {
    constructor(E, g, T, b, _, H, V) {
      super(E, g, T, b, _), this.RepeatS = E, this.RepeatT = g, this.Mode = T, this.TextureTransform = b, this.Parameter = _, this.RasterFormat = H, this.RasterCode = V, this.type = 616511568;
    }
  }
  e.IfcBlobTexture = XY;
  class rG extends ZA {
    constructor(E, g, T, b) {
      super(E, g, T), this.ProfileType = E, this.ProfileName = g, this.Curve = T, this.Thickness = b, this.type = 3150382593;
    }
  }
  e.IfcCenterLineProfileDef = rG;
  class lG extends GI {
    constructor(E, g, T, b, _, H, V) {
      super(), this.Source = E, this.Edition = g, this.EditionDate = T, this.Name = b, this.Description = _, this.Specification = H, this.ReferenceTokens = V, this.type = 747523909;
    }
  }
  e.IfcClassification = lG;
  class eq extends K5 {
    constructor(E, g, T, b, _, H) {
      super(E, g, T), this.Location = E, this.Identification = g, this.Name = T, this.ReferencedSource = b, this.Description = _, this.Sort = H, this.type = 647927063;
    }
  }
  e.IfcClassificationReference = eq;
  class tq extends Pd {
    constructor(E) {
      super(), this.ColourList = E, this.type = 3285139300;
    }
  }
  e.IfcColourRgbList = tq;
  class Qu extends Pd {
    constructor(E) {
      super(), this.Name = E, this.type = 3264961684;
    }
  }
  e.IfcColourSpecification = Qu;
  class iq extends ew {
    constructor(E, g, T, b) {
      super(E, g), this.ProfileType = E, this.ProfileName = g, this.Profiles = T, this.Label = b, this.type = 1485152156;
    }
  }
  e.IfcCompositeProfileDef = iq;
  class gM extends Xo {
    constructor(E) {
      super(), this.CfsFaces = E, this.type = 370225590;
    }
  }
  e.IfcConnectedFaceSet = gM;
  class wM extends $5 {
    constructor(E, g) {
      super(), this.CurveOnRelatingElement = E, this.CurveOnRelatedElement = g, this.type = 1981873012;
    }
  }
  e.IfcConnectionCurveGeometry = wM;
  class nq extends W3 {
    constructor(E, g, T, b, _) {
      super(E, g), this.PointOnRelatingElement = E, this.PointOnRelatedElement = g, this.EccentricityInX = T, this.EccentricityInY = b, this.EccentricityInZ = _, this.type = 45288368;
    }
  }
  e.IfcConnectionPointEccentricity = nq;
  class sq extends q3 {
    constructor(E, g, T) {
      super(E, g), this.Dimensions = E, this.UnitType = g, this.Name = T, this.type = 3050246964;
    }
  }
  e.IfcContextDependentUnit = sq;
  class Z5 extends q3 {
    constructor(E, g, T, b) {
      super(E, g), this.Dimensions = E, this.UnitType = g, this.Name = T, this.ConversionFactor = b, this.type = 2889183280;
    }
  }
  e.IfcConversionBasedUnit = Z5;
  class aG extends Z5 {
    constructor(E, g, T, b, _) {
      super(E, g, T, b), this.Dimensions = E, this.UnitType = g, this.Name = T, this.ConversionFactor = b, this.ConversionOffset = _, this.type = 2713554722;
    }
  }
  e.IfcConversionBasedUnitWithOffset = aG;
  class oq extends $3 {
    constructor(E, g, T, b, _, H, V) {
      super(E, g), this.Name = E, this.Description = g, this.RelatingMonetaryUnit = T, this.RelatedMonetaryUnit = b, this.ExchangeRate = _, this.RateDateTime = H, this.RateSource = V, this.type = 539742890;
    }
  }
  e.IfcCurrencyRelationship = oq;
  class rq extends $A {
    constructor(E, g, T, b, _) {
      super(E), this.Name = E, this.CurveFont = g, this.CurveWidth = T, this.CurveColour = b, this.ModelOrDraughting = _, this.type = 3800577675;
    }
  }
  e.IfcCurveStyle = rq;
  class lq extends Pd {
    constructor(E, g) {
      super(), this.Name = E, this.PatternList = g, this.type = 1105321065;
    }
  }
  e.IfcCurveStyleFont = lq;
  class aq extends Pd {
    constructor(E, g, T) {
      super(), this.Name = E, this.CurveStyleFont = g, this.CurveFontScaling = T, this.type = 2367409068;
    }
  }
  e.IfcCurveStyleFontAndScaling = aq;
  class Z4 extends Pd {
    constructor(E, g) {
      super(), this.VisibleSegmentLength = E, this.InvisibleSegmentLength = g, this.type = 3510044353;
    }
  }
  e.IfcCurveStyleFontPattern = Z4;
  class uG extends ew {
    constructor(E, g, T, b, _) {
      super(E, g), this.ProfileType = E, this.ProfileName = g, this.ParentProfile = T, this.Operator = b, this.Label = _, this.type = 3632507154;
    }
  }
  e.IfcDerivedProfileDef = uG;
  class uq extends GI {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In, gs, $r, $d, N0, Dm) {
      super(), this.Identification = E, this.Name = g, this.Description = T, this.Location = b, this.Purpose = _, this.IntendedUse = H, this.Scope = V, this.Revision = q, this.DocumentOwner = se, this.Editors = qe, this.CreationTime = vi, this.LastRevisionTime = In, this.ElectronicFormat = gs, this.ValidFrom = $r, this.ValidUntil = $d, this.Confidentiality = N0, this.Status = Dm, this.type = 1154170062;
    }
  }
  e.IfcDocumentInformation = uq;
  class dq extends $3 {
    constructor(E, g, T, b, _) {
      super(E, g), this.Name = E, this.Description = g, this.RelatingDocument = T, this.RelatedDocuments = b, this.RelationshipType = _, this.type = 770865208;
    }
  }
  e.IfcDocumentInformationRelationship = dq;
  class lm extends K5 {
    constructor(E, g, T, b, _) {
      super(E, g, T), this.Location = E, this.Identification = g, this.Name = T, this.Description = b, this.ReferencedDocument = _, this.type = 3732053477;
    }
  }
  e.IfcDocumentReference = lm;
  class zL extends Xo {
    constructor(E, g) {
      super(), this.EdgeStart = E, this.EdgeEnd = g, this.type = 3900360178;
    }
  }
  e.IfcEdge = zL;
  class dG extends zL {
    constructor(E, g, T, b) {
      super(E, g), this.EdgeStart = E, this.EdgeEnd = g, this.EdgeGeometry = T, this.SameSense = b, this.type = 476780140;
    }
  }
  e.IfcEdgeCurve = dG;
  class cq extends iw {
    constructor(E, g, T, b, _, H, V) {
      super(E, g, T), this.Name = E, this.DataOrigin = g, this.UserDefinedDataOrigin = T, this.ActualDate = b, this.EarlyDate = _, this.LateDate = H, this.ScheduleDate = V, this.type = 211053100;
    }
  }
  e.IfcEventTime = cq;
  class Q5 extends T6 {
    constructor(E, g, T) {
      super(), this.Name = E, this.Description = g, this.Properties = T, this.type = 297599258;
    }
  }
  e.IfcExtendedProperties = Q5;
  class cG extends $3 {
    constructor(E, g, T, b) {
      super(E, g), this.Name = E, this.Description = g, this.RelatingReference = T, this.RelatedResourceObjects = b, this.type = 1437805879;
    }
  }
  e.IfcExternalReferenceRelationship = cG;
  class QA extends Xo {
    constructor(E) {
      super(), this.Bounds = E, this.type = 2556980723;
    }
  }
  e.IfcFace = QA;
  class hG extends Xo {
    constructor(E, g) {
      super(), this.Bound = E, this.Orientation = g, this.type = 1809719519;
    }
  }
  e.IfcFaceBound = hG;
  class hq extends hG {
    constructor(E, g) {
      super(E, g), this.Bound = E, this.Orientation = g, this.type = 803316827;
    }
  }
  e.IfcFaceOuterBound = hq;
  class S6 extends QA {
    constructor(E, g, T) {
      super(E), this.Bounds = E, this.FaceSurface = g, this.SameSense = T, this.type = 3008276851;
    }
  }
  e.IfcFaceSurface = S6;
  class fq extends PL {
    constructor(E, g, T, b, _, H, V) {
      super(E), this.Name = E, this.TensionFailureX = g, this.TensionFailureY = T, this.TensionFailureZ = b, this.CompressionFailureX = _, this.CompressionFailureY = H, this.CompressionFailureZ = V, this.type = 4219587988;
    }
  }
  e.IfcFailureConnectionCondition = fq;
  class J5 extends $A {
    constructor(E, g, T) {
      super(E), this.Name = E, this.FillStyles = g, this.ModelOrDraughting = T, this.type = 738692330;
    }
  }
  e.IfcFillAreaStyle = J5;
  class b6 extends tw {
    constructor(E, g, T, b, _, H) {
      super(E, g), this.ContextIdentifier = E, this.ContextType = g, this.CoordinateSpaceDimension = T, this.Precision = b, this.WorldCoordinateSystem = _, this.TrueNorth = H, this.type = 3448662350;
    }
  }
  e.IfcGeometricRepresentationContext = b6;
  class Nr extends R6 {
    constructor() {
      super(), this.type = 2453401579;
    }
  }
  e.IfcGeometricRepresentationItem = Nr;
  class Iq extends b6 {
    constructor(E, g, T, b, _, H) {
      super(E, g, new W(0), null, new u(0), null), this.ContextIdentifier = E, this.ContextType = g, this.ParentContext = T, this.TargetScale = b, this.TargetView = _, this.UserDefinedTargetView = H, this.type = 4142052618;
    }
  }
  e.IfcGeometricRepresentationSubContext = Iq;
  class TM extends Nr {
    constructor(E) {
      super(), this.Elements = E, this.type = 3590301190;
    }
  }
  e.IfcGeometricSet = TM;
  class jL extends OL {
    constructor(E, g, T) {
      super(E), this.PlacementRelTo = E, this.PlacementLocation = g, this.PlacementRefDirection = T, this.type = 178086475;
    }
  }
  e.IfcGridPlacement = jL;
  class N6 extends Nr {
    constructor(E, g) {
      super(), this.BaseSurface = E, this.AgreementFlag = g, this.type = 812098782;
    }
  }
  e.IfcHalfSpaceSolid = N6;
  class pq extends BL {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b, _), this.RepeatS = E, this.RepeatT = g, this.Mode = T, this.TextureTransform = b, this.Parameter = _, this.URLReference = H, this.type = 3905492369;
    }
  }
  e.IfcImageTexture = pq;
  class WL extends Pd {
    constructor(E, g, T, b) {
      super(), this.MappedTo = E, this.Opacity = g, this.Colours = T, this.ColourIndex = b, this.type = 3570813810;
    }
  }
  e.IfcIndexedColourMap = WL;
  class JA extends GL {
    constructor(E, g, T) {
      super(E), this.Maps = E, this.MappedTo = g, this.TexCoords = T, this.type = 1437953363;
    }
  }
  e.IfcIndexedTextureMap = JA;
  class D6 extends JA {
    constructor(E, g, T, b) {
      super(E, g, T), this.Maps = E, this.MappedTo = g, this.TexCoords = T, this.TexCoordIndex = b, this.type = 2133299955;
    }
  }
  e.IfcIndexedTriangleTextureMap = D6;
  class RM extends mM {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.Name = E, this.Description = g, this.StartTime = T, this.EndTime = b, this.TimeSeriesDataType = _, this.DataOrigin = H, this.UserDefinedDataOrigin = V, this.Unit = q, this.Values = se, this.type = 3741457305;
    }
  }
  e.IfcIrregularTimeSeries = RM;
  class mq extends iw {
    constructor(E, g, T, b, _) {
      super(E, g, T), this.Name = E, this.DataOrigin = g, this.UserDefinedDataOrigin = T, this.LagValue = b, this.DurationType = _, this.type = 1585845231;
    }
  }
  e.IfcLagTime = mq;
  class C6 extends Nr {
    constructor(E, g, T, b) {
      super(), this.Name = E, this.LightColour = g, this.AmbientIntensity = T, this.Intensity = b, this.type = 1402838566;
    }
  }
  e.IfcLightSource = C6;
  class X5 extends C6 {
    constructor(E, g, T, b) {
      super(E, g, T, b), this.Name = E, this.LightColour = g, this.AmbientIntensity = T, this.Intensity = b, this.type = 125510826;
    }
  }
  e.IfcLightSourceAmbient = X5;
  class yq extends C6 {
    constructor(E, g, T, b, _) {
      super(E, g, T, b), this.Name = E, this.LightColour = g, this.AmbientIntensity = T, this.Intensity = b, this.Orientation = _, this.type = 2604431987;
    }
  }
  e.IfcLightSourceDirectional = yq;
  class Eq extends C6 {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b), this.Name = E, this.LightColour = g, this.AmbientIntensity = T, this.Intensity = b, this.Position = _, this.ColourAppearance = H, this.ColourTemperature = V, this.LuminousFlux = q, this.LightEmissionSource = se, this.LightDistributionDataSource = qe, this.type = 4266656042;
    }
  }
  e.IfcLightSourceGoniometric = Eq;
  class fG extends C6 {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b), this.Name = E, this.LightColour = g, this.AmbientIntensity = T, this.Intensity = b, this.Position = _, this.Radius = H, this.ConstantAttenuation = V, this.DistanceAttenuation = q, this.QuadricAttenuation = se, this.type = 1520743889;
    }
  }
  e.IfcLightSourcePositional = fG;
  class vM extends fG {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In, gs) {
      super(E, g, T, b, _, H, V, q, se), this.Name = E, this.LightColour = g, this.AmbientIntensity = T, this.Intensity = b, this.Position = _, this.Radius = H, this.ConstantAttenuation = V, this.DistanceAttenuation = q, this.QuadricAttenuation = se, this.Orientation = qe, this.ConcentrationExponent = vi, this.SpreadAngle = In, this.BeamWidthAngle = gs, this.type = 3422422726;
    }
  }
  e.IfcLightSourceSpot = vM;
  class gq extends OL {
    constructor(E, g, T) {
      super(E), this.PlacementRelTo = E, this.RelativePlacement = g, this.CartesianPosition = T, this.type = 388784114;
    }
  }
  e.IfcLinearPlacement = gq;
  class wq extends OL {
    constructor(E, g) {
      super(E), this.PlacementRelTo = E, this.RelativePlacement = g, this.type = 2624227202;
    }
  }
  e.IfcLocalPlacement = wq;
  class YL extends Xo {
    constructor() {
      super(), this.type = 1008929658;
    }
  }
  e.IfcLoop = YL;
  class Tq extends R6 {
    constructor(E, g) {
      super(), this.MappingSource = E, this.MappingTarget = g, this.type = 2347385850;
    }
  }
  e.IfcMappedItem = Tq;
  class eR extends q4 {
    constructor(E, g, T) {
      super(), this.Name = E, this.Description = g, this.Category = T, this.type = 1838606355;
    }
  }
  e.IfcMaterial = eR;
  class Rq extends q4 {
    constructor(E, g, T, b, _) {
      super(), this.Name = E, this.Description = g, this.Material = T, this.Fraction = b, this.Category = _, this.type = 3708119e3;
    }
  }
  e.IfcMaterialConstituent = Rq;
  class XA extends q4 {
    constructor(E, g, T) {
      super(), this.Name = E, this.Description = g, this.MaterialConstituents = T, this.type = 2852063980;
    }
  }
  e.IfcMaterialConstituentSet = XA;
  class AM extends oM {
    constructor(E, g, T, b) {
      super(E, g, T), this.Name = E, this.Description = g, this.Representations = T, this.RepresentedMaterial = b, this.type = 2022407955;
    }
  }
  e.IfcMaterialDefinitionRepresentation = AM;
  class vq extends w6 {
    constructor(E, g, T, b, _) {
      super(), this.ForLayerSet = E, this.LayerSetDirection = g, this.DirectionSense = T, this.OffsetFromReferenceLine = b, this.ReferenceExtent = _, this.type = 1303795690;
    }
  }
  e.IfcMaterialLayerSetUsage = vq;
  class SM extends w6 {
    constructor(E, g, T) {
      super(), this.ForProfileSet = E, this.CardinalPoint = g, this.ReferenceExtent = T, this.type = 3079605661;
    }
  }
  e.IfcMaterialProfileSetUsage = SM;
  class Aq extends SM {
    constructor(E, g, T, b, _) {
      super(E, g, T), this.ForProfileSet = E, this.CardinalPoint = g, this.ReferenceExtent = T, this.ForProfileEndSet = b, this.CardinalEndPoint = _, this.type = 3404854881;
    }
  }
  e.IfcMaterialProfileSetUsageTapering = Aq;
  class IG extends Q5 {
    constructor(E, g, T, b) {
      super(E, g, T), this.Name = E, this.Description = g, this.Properties = T, this.Material = b, this.type = 3265635763;
    }
  }
  e.IfcMaterialProperties = IG;
  class bM extends $3 {
    constructor(E, g, T, b, _) {
      super(E, g), this.Name = E, this.Description = g, this.RelatingMaterial = T, this.RelatedMaterials = b, this.MaterialExpression = _, this.type = 853536259;
    }
  }
  e.IfcMaterialRelationship = bM;
  class pG extends uG {
    constructor(E, g, T, b) {
      super(E, g, T, new u(0), b), this.ProfileType = E, this.ProfileName = g, this.ParentProfile = T, this.Label = b, this.type = 2998442950;
    }
  }
  e.IfcMirroredProfileDef = pG;
  class tR extends _L {
    constructor(E, g, T, b) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.type = 219451334;
    }
  }
  e.IfcObjectDefinition = tR;
  class mG extends ew {
    constructor(E, g, T, b, _, H, V) {
      super(E, g), this.ProfileType = E, this.ProfileName = g, this.HorizontalWidths = T, this.Widths = b, this.Slopes = _, this.Tags = H, this.OffsetPoint = V, this.type = 182550632;
    }
  }
  e.IfcOpenCrossProfileDef = mG;
  class O6 extends gM {
    constructor(E) {
      super(E), this.CfsFaces = E, this.type = 2665983363;
    }
  }
  e.IfcOpenShell = O6;
  class NM extends $3 {
    constructor(E, g, T, b) {
      super(E, g), this.Name = E, this.Description = g, this.RelatingOrganization = T, this.RelatedOrganizations = b, this.type = 1411181986;
    }
  }
  e.IfcOrganizationRelationship = NM;
  class Sq extends zL {
    constructor(E, g) {
      super(new u(0), new u(0)), this.EdgeElement = E, this.Orientation = g, this.type = 1029017970;
    }
  }
  e.IfcOrientedEdge = Sq;
  class Vf extends ew {
    constructor(E, g, T) {
      super(E, g), this.ProfileType = E, this.ProfileName = g, this.Position = T, this.type = 2529465313;
    }
  }
  e.IfcParameterizedProfileDef = Vf;
  class bq extends Xo {
    constructor(E) {
      super(), this.EdgeList = E, this.type = 2519244187;
    }
  }
  e.IfcPath = bq;
  class DM extends sM {
    constructor(E, g, T, b, _, H) {
      super(E, g), this.Name = E, this.Description = g, this.HasQuantities = T, this.Discrimination = b, this.Quality = _, this.Usage = H, this.type = 3021840470;
    }
  }
  e.IfcPhysicalComplexQuantity = DM;
  class iR extends BL {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _), this.RepeatS = E, this.RepeatT = g, this.Mode = T, this.TextureTransform = b, this.Parameter = _, this.Width = H, this.Height = V, this.ColourComponents = q, this.Pixel = se, this.type = 597895409;
    }
  }
  e.IfcPixelTexture = iR;
  class L6 extends Nr {
    constructor(E) {
      super(), this.Location = E, this.type = 2004835150;
    }
  }
  e.IfcPlacement = L6;
  class nR extends Nr {
    constructor(E, g) {
      super(), this.SizeInX = E, this.SizeInY = g, this.type = 1663979128;
    }
  }
  e.IfcPlanarExtent = nR;
  class _6 extends Nr {
    constructor() {
      super(), this.type = 2067069095;
    }
  }
  e.IfcPoint = _6;
  class qL extends _6 {
    constructor(E, g, T, b, _) {
      super(), this.DistanceAlong = E, this.OffsetLateral = g, this.OffsetVertical = T, this.OffsetLongitudinal = b, this.BasisCurve = _, this.type = 2165702409;
    }
  }
  e.IfcPointByDistanceExpression = qL;
  class $L extends _6 {
    constructor(E, g) {
      super(), this.BasisCurve = E, this.PointParameter = g, this.type = 4022376103;
    }
  }
  e.IfcPointOnCurve = $L;
  class x6 extends _6 {
    constructor(E, g, T) {
      super(), this.BasisSurface = E, this.PointParameterU = g, this.PointParameterV = T, this.type = 1423911732;
    }
  }
  e.IfcPointOnSurface = x6;
  class yG extends YL {
    constructor(E) {
      super(), this.Polygon = E, this.type = 2924175390;
    }
  }
  e.IfcPolyLoop = yG;
  class Nq extends N6 {
    constructor(E, g, T, b) {
      super(E, g), this.BaseSurface = E, this.AgreementFlag = g, this.Position = T, this.PolygonalBoundary = b, this.type = 2775532180;
    }
  }
  e.IfcPolygonalBoundedHalfSpace = Nq;
  class KL extends Pd {
    constructor(E) {
      super(), this.Name = E, this.type = 3727388367;
    }
  }
  e.IfcPreDefinedItem = KL;
  class ZL extends T6 {
    constructor() {
      super(), this.type = 3778827333;
    }
  }
  e.IfcPreDefinedProperties = ZL;
  class QL extends KL {
    constructor(E) {
      super(E), this.Name = E, this.type = 1775413392;
    }
  }
  e.IfcPreDefinedTextFont = QL;
  class Dq extends oM {
    constructor(E, g, T) {
      super(E, g, T), this.Name = E, this.Description = g, this.Representations = T, this.type = 673634403;
    }
  }
  e.IfcProductDefinitionShape = Dq;
  class Cq extends Q5 {
    constructor(E, g, T, b) {
      super(E, g, T), this.Name = E, this.Description = g, this.Properties = T, this.ProfileDefinition = b, this.type = 2802850158;
    }
  }
  e.IfcProfileProperties = Cq;
  class CM extends T6 {
    constructor(E, g) {
      super(), this.Name = E, this.Specification = g, this.type = 2598011224;
    }
  }
  e.IfcProperty = CM;
  class OM extends _L {
    constructor(E, g, T, b) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.type = 1680319473;
    }
  }
  e.IfcPropertyDefinition = OM;
  class sR extends $3 {
    constructor(E, g, T, b, _) {
      super(E, g), this.Name = E, this.Description = g, this.DependingProperty = T, this.DependantProperty = b, this.Expression = _, this.type = 148025276;
    }
  }
  e.IfcPropertyDependencyRelationship = sR;
  class P6 extends OM {
    constructor(E, g, T, b) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.type = 3357820518;
    }
  }
  e.IfcPropertySetDefinition = P6;
  class LM extends OM {
    constructor(E, g, T, b) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.type = 1482703590;
    }
  }
  e.IfcPropertyTemplateDefinition = LM;
  class JL extends P6 {
    constructor(E, g, T, b) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.type = 2090586900;
    }
  }
  e.IfcQuantitySet = JL;
  class oR extends Vf {
    constructor(E, g, T, b, _) {
      super(E, g, T), this.ProfileType = E, this.ProfileName = g, this.Position = T, this.XDim = b, this.YDim = _, this.type = 3615266464;
    }
  }
  e.IfcRectangleProfileDef = oR;
  class Oq extends mM {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q), this.Name = E, this.Description = g, this.StartTime = T, this.EndTime = b, this.TimeSeriesDataType = _, this.DataOrigin = H, this.UserDefinedDataOrigin = V, this.Unit = q, this.TimeStep = se, this.Values = qe, this.type = 3413951693;
    }
  }
  e.IfcRegularTimeSeries = Oq;
  class Lq extends ZL {
    constructor(E, g, T, b, _, H) {
      super(), this.TotalCrossSectionArea = E, this.SteelGrade = g, this.BarSurface = T, this.EffectiveDepth = b, this.NominalBarDiameter = _, this.BarCount = H, this.type = 1580146022;
    }
  }
  e.IfcReinforcementBarProperties = Lq;
  class rR extends _L {
    constructor(E, g, T, b) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.type = 478536968;
    }
  }
  e.IfcRelationship = rR;
  class _q extends $3 {
    constructor(E, g, T, b) {
      super(E, g), this.Name = E, this.Description = g, this.RelatedResourceObjects = T, this.RelatingApproval = b, this.type = 2943643501;
    }
  }
  e.IfcResourceApprovalRelationship = _q;
  class _M extends $3 {
    constructor(E, g, T, b) {
      super(E, g), this.Name = E, this.Description = g, this.RelatingConstraint = T, this.RelatedResourceObjects = b, this.type = 1608871552;
    }
  }
  e.IfcResourceConstraintRelationship = _M;
  class xM extends iw {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In, gs, $r, $d, N0, Dm, nb) {
      super(E, g, T), this.Name = E, this.DataOrigin = g, this.UserDefinedDataOrigin = T, this.ScheduleWork = b, this.ScheduleUsage = _, this.ScheduleStart = H, this.ScheduleFinish = V, this.ScheduleContour = q, this.LevelingDelay = se, this.IsOverAllocated = qe, this.StatusTime = vi, this.ActualWork = In, this.ActualUsage = gs, this.ActualStart = $r, this.ActualFinish = $d, this.RemainingWork = N0, this.RemainingUsage = Dm, this.Completion = nb, this.type = 1042787934;
    }
  }
  e.IfcResourceTime = xM;
  class xq extends oR {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b, _), this.ProfileType = E, this.ProfileName = g, this.Position = T, this.XDim = b, this.YDim = _, this.RoundingRadius = H, this.type = 2778083089;
    }
  }
  e.IfcRoundedRectangleProfileDef = xq;
  class PM extends ZL {
    constructor(E, g, T) {
      super(), this.SectionType = E, this.StartProfile = g, this.EndProfile = T, this.type = 2042790032;
    }
  }
  e.IfcSectionProperties = PM;
  class MM extends ZL {
    constructor(E, g, T, b, _, H) {
      super(), this.LongitudinalStartPosition = E, this.LongitudinalEndPosition = g, this.TransversePosition = T, this.ReinforcementRole = b, this.SectionDefinition = _, this.CrossSectionReinforcementDefinitions = H, this.type = 4165799628;
    }
  }
  e.IfcSectionReinforcementProperties = MM;
  class Pq extends Nr {
    constructor(E, g, T) {
      super(), this.SpineCurve = E, this.CrossSections = g, this.CrossSectionPositions = T, this.type = 1509187699;
    }
  }
  e.IfcSectionedSpine = Pq;
  class XL extends Nr {
    constructor(E) {
      super(), this.Transition = E, this.type = 823603102;
    }
  }
  e.IfcSegment = XL;
  class UM extends Nr {
    constructor(E) {
      super(), this.SbsmBoundary = E, this.type = 4124623270;
    }
  }
  e.IfcShellBasedSurfaceModel = UM;
  class Ah extends CM {
    constructor(E, g) {
      super(E, g), this.Name = E, this.Specification = g, this.type = 3692461612;
    }
  }
  e.IfcSimpleProperty = Ah;
  class Mq extends PL {
    constructor(E, g, T, b) {
      super(E), this.Name = E, this.SlippageX = g, this.SlippageY = T, this.SlippageZ = b, this.type = 2609359061;
    }
  }
  e.IfcSlippageConnectionCondition = Mq;
  class eS extends Nr {
    constructor() {
      super(), this.type = 723233188;
    }
  }
  e.IfcSolidModel = eS;
  class Uq extends KA {
    constructor(E, g, T, b, _, H, V) {
      super(E), this.Name = E, this.LinearForceX = g, this.LinearForceY = T, this.LinearForceZ = b, this.LinearMomentX = _, this.LinearMomentY = H, this.LinearMomentZ = V, this.type = 1595516126;
    }
  }
  e.IfcStructuralLoadLinearForce = Uq;
  class EG extends KA {
    constructor(E, g, T, b) {
      super(E), this.Name = E, this.PlanarForceX = g, this.PlanarForceY = T, this.PlanarForceZ = b, this.type = 2668620305;
    }
  }
  e.IfcStructuralLoadPlanarForce = EG;
  class Q4 extends KA {
    constructor(E, g, T, b, _, H, V) {
      super(E), this.Name = E, this.DisplacementX = g, this.DisplacementY = T, this.DisplacementZ = b, this.RotationalDisplacementRX = _, this.RotationalDisplacementRY = H, this.RotationalDisplacementRZ = V, this.type = 2473145415;
    }
  }
  e.IfcStructuralLoadSingleDisplacement = Q4;
  class M6 extends Q4 {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V), this.Name = E, this.DisplacementX = g, this.DisplacementY = T, this.DisplacementZ = b, this.RotationalDisplacementRX = _, this.RotationalDisplacementRY = H, this.RotationalDisplacementRZ = V, this.Distortion = q, this.type = 1973038258;
    }
  }
  e.IfcStructuralLoadSingleDisplacementDistortion = M6;
  class wE extends KA {
    constructor(E, g, T, b, _, H, V) {
      super(E), this.Name = E, this.ForceX = g, this.ForceY = T, this.ForceZ = b, this.MomentX = _, this.MomentY = H, this.MomentZ = V, this.type = 1597423693;
    }
  }
  e.IfcStructuralLoadSingleForce = wE;
  class tS extends wE {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V), this.Name = E, this.ForceX = g, this.ForceY = T, this.ForceZ = b, this.MomentX = _, this.MomentY = H, this.MomentZ = V, this.WarpingMoment = q, this.type = 1190533807;
    }
  }
  e.IfcStructuralLoadSingleForceWarping = tS;
  class Bq extends zL {
    constructor(E, g, T) {
      super(E, g), this.EdgeStart = E, this.EdgeEnd = g, this.ParentEdge = T, this.type = 2233826070;
    }
  }
  e.IfcSubedge = Bq;
  class am extends Nr {
    constructor() {
      super(), this.type = 2513912981;
    }
  }
  e.IfcSurface = am;
  class Fq extends UL {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g), this.SurfaceColour = E, this.Transparency = g, this.DiffuseColour = T, this.TransmissionColour = b, this.DiffuseTransmissionColour = _, this.ReflectionColour = H, this.SpecularColour = V, this.SpecularHighlight = q, this.ReflectanceMethod = se, this.type = 1878645084;
    }
  }
  e.IfcSurfaceStyleRendering = Fq;
  class e7 extends eS {
    constructor(E, g) {
      super(), this.SweptArea = E, this.Position = g, this.type = 2247615214;
    }
  }
  e.IfcSweptAreaSolid = e7;
  class gG extends eS {
    constructor(E, g, T, b, _) {
      super(), this.Directrix = E, this.Radius = g, this.InnerRadius = T, this.StartParam = b, this.EndParam = _, this.type = 1260650574;
    }
  }
  e.IfcSweptDiskSolid = gG;
  class Hq extends gG {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b, _), this.Directrix = E, this.Radius = g, this.InnerRadius = T, this.StartParam = b, this.EndParam = _, this.FilletRadius = H, this.type = 1096409881;
    }
  }
  e.IfcSweptDiskSolidPolygonal = Hq;
  class nw extends am {
    constructor(E, g) {
      super(), this.SweptCurve = E, this.Position = g, this.type = 230924584;
    }
  }
  e.IfcSweptSurface = nw;
  class wG extends Vf {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In) {
      super(E, g, T), this.ProfileType = E, this.ProfileName = g, this.Position = T, this.Depth = b, this.FlangeWidth = _, this.WebThickness = H, this.FlangeThickness = V, this.FilletRadius = q, this.FlangeEdgeRadius = se, this.WebEdgeRadius = qe, this.WebSlope = vi, this.FlangeSlope = In, this.type = 3071757647;
    }
  }
  e.IfcTShapeProfileDef = wG;
  class zf extends Nr {
    constructor() {
      super(), this.type = 901063453;
    }
  }
  e.IfcTessellatedItem = zf;
  class iS extends Nr {
    constructor(E, g, T) {
      super(), this.Literal = E, this.Placement = g, this.Path = T, this.type = 4282788508;
    }
  }
  e.IfcTextLiteral = iS;
  class Gq extends iS {
    constructor(E, g, T, b, _) {
      super(E, g, T), this.Literal = E, this.Placement = g, this.Path = T, this.Extent = b, this.BoxAlignment = _, this.type = 3124975700;
    }
  }
  e.IfcTextLiteralWithExtent = Gq;
  class kq extends QL {
    constructor(E, g, T, b, _, H) {
      super(E), this.Name = E, this.FontFamily = g, this.FontStyle = T, this.FontVariant = b, this.FontWeight = _, this.FontSize = H, this.type = 1983826977;
    }
  }
  e.IfcTextStyleFontModel = kq;
  class TG extends Vf {
    constructor(E, g, T, b, _, H, V) {
      super(E, g, T), this.ProfileType = E, this.ProfileName = g, this.Position = T, this.BottomXDim = b, this.TopXDim = _, this.YDim = H, this.TopXOffset = V, this.type = 2715220739;
    }
  }
  e.IfcTrapeziumProfileDef = TG;
  class t7 extends tR {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.type = 1628702193;
    }
  }
  e.IfcTypeObject = t7;
  class um extends t7 {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.Identification = V, this.LongDescription = q, this.ProcessType = se, this.type = 3736923433;
    }
  }
  e.IfcTypeProcess = um;
  class BM extends t7 {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.type = 2347495698;
    }
  }
  e.IfcTypeProduct = BM;
  class RG extends t7 {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.Identification = V, this.LongDescription = q, this.ResourceType = se, this.type = 3698973494;
    }
  }
  e.IfcTypeResource = RG;
  class Vq extends Vf {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T), this.ProfileType = E, this.ProfileName = g, this.Position = T, this.Depth = b, this.FlangeWidth = _, this.WebThickness = H, this.FlangeThickness = V, this.FilletRadius = q, this.EdgeRadius = se, this.FlangeSlope = qe, this.type = 427810014;
    }
  }
  e.IfcUShapeProfileDef = Vq;
  class FM extends Nr {
    constructor(E, g) {
      super(), this.Orientation = E, this.Magnitude = g, this.type = 1417489154;
    }
  }
  e.IfcVector = FM;
  class zq extends YL {
    constructor(E) {
      super(), this.LoopVertex = E, this.type = 2759199220;
    }
  }
  e.IfcVertexLoop = zq;
  class jq extends Vf {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T), this.ProfileType = E, this.ProfileName = g, this.Position = T, this.Depth = b, this.FlangeWidth = _, this.WebThickness = H, this.FlangeThickness = V, this.FilletRadius = q, this.EdgeRadius = se, this.type = 2543172580;
    }
  }
  e.IfcZShapeProfileDef = jq;
  class Wq extends S6 {
    constructor(E, g, T) {
      super(E, g, T), this.Bounds = E, this.FaceSurface = g, this.SameSense = T, this.type = 3406155212;
    }
  }
  e.IfcAdvancedFace = Wq;
  class Yq extends Nr {
    constructor(E, g) {
      super(), this.OuterBoundary = E, this.InnerBoundaries = g, this.type = 669184980;
    }
  }
  e.IfcAnnotationFillArea = Yq;
  class vu extends Vf {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In, gs, $r, $d) {
      super(E, g, T), this.ProfileType = E, this.ProfileName = g, this.Position = T, this.BottomFlangeWidth = b, this.OverallDepth = _, this.WebThickness = H, this.BottomFlangeThickness = V, this.BottomFlangeFilletRadius = q, this.TopFlangeWidth = se, this.TopFlangeThickness = qe, this.TopFlangeFilletRadius = vi, this.BottomFlangeEdgeRadius = In, this.BottomFlangeSlope = gs, this.TopFlangeEdgeRadius = $r, this.TopFlangeSlope = $d, this.type = 3207858831;
    }
  }
  e.IfcAsymmetricIShapeProfileDef = vu;
  class HM extends L6 {
    constructor(E, g) {
      super(E), this.Location = E, this.Axis = g, this.type = 4261334040;
    }
  }
  e.IfcAxis1Placement = HM;
  class qq extends L6 {
    constructor(E, g) {
      super(E), this.Location = E, this.RefDirection = g, this.type = 3125803723;
    }
  }
  e.IfcAxis2Placement2D = qq;
  class $q extends L6 {
    constructor(E, g, T) {
      super(E), this.Location = E, this.Axis = g, this.RefDirection = T, this.type = 2740243338;
    }
  }
  e.IfcAxis2Placement3D = $q;
  class Kq extends L6 {
    constructor(E, g, T) {
      super(E), this.Location = E, this.Axis = g, this.RefDirection = T, this.type = 3425423356;
    }
  }
  e.IfcAxis2PlacementLinear = Kq;
  class i7 extends Nr {
    constructor(E, g, T) {
      super(), this.Operator = E, this.FirstOperand = g, this.SecondOperand = T, this.type = 2736907675;
    }
  }
  e.IfcBooleanResult = i7;
  class K3 extends am {
    constructor() {
      super(), this.type = 4182860854;
    }
  }
  e.IfcBoundedSurface = K3;
  class vG extends Nr {
    constructor(E, g, T, b) {
      super(), this.Corner = E, this.XDim = g, this.YDim = T, this.ZDim = b, this.type = 2581212453;
    }
  }
  e.IfcBoundingBox = vG;
  class Zq extends N6 {
    constructor(E, g, T) {
      super(E, g), this.BaseSurface = E, this.AgreementFlag = g, this.Enclosure = T, this.type = 2713105998;
    }
  }
  e.IfcBoxedHalfSpace = Zq;
  class Qq extends Vf {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T), this.ProfileType = E, this.ProfileName = g, this.Position = T, this.Depth = b, this.Width = _, this.WallThickness = H, this.Girth = V, this.InternalFilletRadius = q, this.type = 2898889636;
    }
  }
  e.IfcCShapeProfileDef = Qq;
  class Jq extends _6 {
    constructor(E) {
      super(), this.Coordinates = E, this.type = 1123145078;
    }
  }
  e.IfcCartesianPoint = Jq;
  class GM extends Nr {
    constructor() {
      super(), this.type = 574549367;
    }
  }
  e.IfcCartesianPointList = GM;
  class AG extends GM {
    constructor(E, g) {
      super(), this.CoordList = E, this.TagList = g, this.type = 1675464909;
    }
  }
  e.IfcCartesianPointList2D = AG;
  class n7 extends GM {
    constructor(E, g) {
      super(), this.CoordList = E, this.TagList = g, this.type = 2059837836;
    }
  }
  e.IfcCartesianPointList3D = n7;
  class Z3 extends Nr {
    constructor(E, g, T, b) {
      super(), this.Axis1 = E, this.Axis2 = g, this.LocalOrigin = T, this.Scale = b, this.type = 59481748;
    }
  }
  e.IfcCartesianTransformationOperator = Z3;
  class kM extends Z3 {
    constructor(E, g, T, b) {
      super(E, g, T, b), this.Axis1 = E, this.Axis2 = g, this.LocalOrigin = T, this.Scale = b, this.type = 3749851601;
    }
  }
  e.IfcCartesianTransformationOperator2D = kM;
  class s7 extends kM {
    constructor(E, g, T, b, _) {
      super(E, g, T, b), this.Axis1 = E, this.Axis2 = g, this.LocalOrigin = T, this.Scale = b, this.Scale2 = _, this.type = 3486308946;
    }
  }
  e.IfcCartesianTransformationOperator2DnonUniform = s7;
  class TE extends Z3 {
    constructor(E, g, T, b, _) {
      super(E, g, T, b), this.Axis1 = E, this.Axis2 = g, this.LocalOrigin = T, this.Scale = b, this.Axis3 = _, this.type = 3331915920;
    }
  }
  e.IfcCartesianTransformationOperator3D = TE;
  class Xq extends TE {
    constructor(E, g, T, b, _, H, V) {
      super(E, g, T, b, _), this.Axis1 = E, this.Axis2 = g, this.LocalOrigin = T, this.Scale = b, this.Axis3 = _, this.Scale2 = H, this.Scale3 = V, this.type = 1416205885;
    }
  }
  e.IfcCartesianTransformationOperator3DnonUniform = Xq;
  class SG extends Vf {
    constructor(E, g, T, b) {
      super(E, g, T), this.ProfileType = E, this.ProfileName = g, this.Position = T, this.Radius = b, this.type = 1383045692;
    }
  }
  e.IfcCircleProfileDef = SG;
  class e$ extends gM {
    constructor(E) {
      super(E), this.CfsFaces = E, this.type = 2205249479;
    }
  }
  e.IfcClosedShell = e$;
  class t$ extends Qu {
    constructor(E, g, T, b) {
      super(E), this.Name = E, this.Red = g, this.Green = T, this.Blue = b, this.type = 776857604;
    }
  }
  e.IfcColourRgb = t$;
  class i$ extends CM {
    constructor(E, g, T, b) {
      super(E, g), this.Name = E, this.Specification = g, this.UsageName = T, this.HasProperties = b, this.type = 2542286263;
    }
  }
  e.IfcComplexProperty = i$;
  class bG extends XL {
    constructor(E, g, T) {
      super(E), this.Transition = E, this.SameSense = g, this.ParentCurve = T, this.type = 2485617015;
    }
  }
  e.IfcCompositeCurveSegment = bG;
  class lR extends RG {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.Identification = V, this.LongDescription = q, this.ResourceType = se, this.BaseCosts = qe, this.BaseQuantity = vi, this.type = 2574617495;
    }
  }
  e.IfcConstructionResourceType = lR;
  class VM extends tR {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.LongName = H, this.Phase = V, this.RepresentationContexts = q, this.UnitsInContext = se, this.type = 3419103109;
    }
  }
  e.IfcContext = VM;
  class n$ extends lR {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In) {
      super(E, g, T, b, _, H, V, q, se, qe, vi), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.Identification = V, this.LongDescription = q, this.ResourceType = se, this.BaseCosts = qe, this.BaseQuantity = vi, this.PredefinedType = In, this.type = 1815067380;
    }
  }
  e.IfcCrewResourceType = n$;
  class nS extends Nr {
    constructor(E) {
      super(), this.Position = E, this.type = 2506170314;
    }
  }
  e.IfcCsgPrimitive3D = nS;
  class zM extends eS {
    constructor(E) {
      super(), this.TreeRootExpression = E, this.type = 2147822146;
    }
  }
  e.IfcCsgSolid = zM;
  class sw extends Nr {
    constructor() {
      super(), this.type = 2601014836;
    }
  }
  e.IfcCurve = sw;
  class NG extends K3 {
    constructor(E, g, T) {
      super(), this.BasisSurface = E, this.OuterBoundary = g, this.InnerBoundaries = T, this.type = 2827736869;
    }
  }
  e.IfcCurveBoundedPlane = NG;
  class s$ extends K3 {
    constructor(E, g, T) {
      super(), this.BasisSurface = E, this.Boundaries = g, this.ImplicitOuter = T, this.type = 2629017746;
    }
  }
  e.IfcCurveBoundedSurface = s$;
  class o$ extends XL {
    constructor(E, g, T, b, _) {
      super(E), this.Transition = E, this.Placement = g, this.SegmentStart = T, this.SegmentLength = b, this.ParentCurve = _, this.type = 4212018352;
    }
  }
  e.IfcCurveSegment = o$;
  class r$ extends Nr {
    constructor(E) {
      super(), this.DirectionRatios = E, this.type = 32440307;
    }
  }
  e.IfcDirection = r$;
  class VI extends e7 {
    constructor(E, g, T, b, _) {
      super(E, g), this.SweptArea = E, this.Position = g, this.Directrix = T, this.StartParam = b, this.EndParam = _, this.type = 593015953;
    }
  }
  e.IfcDirectrixCurveSweptAreaSolid = VI;
  class DG extends YL {
    constructor(E) {
      super(), this.EdgeList = E, this.type = 1472233963;
    }
  }
  e.IfcEdgeLoop = DG;
  class l$ extends JL {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.MethodOfMeasurement = _, this.Quantities = H, this.type = 1883228015;
    }
  }
  e.IfcElementQuantity = l$;
  class dm extends BM {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.type = 339256511;
    }
  }
  e.IfcElementType = dm;
  class aR extends am {
    constructor(E) {
      super(), this.Position = E, this.type = 2777663545;
    }
  }
  e.IfcElementarySurface = aR;
  class jM extends Vf {
    constructor(E, g, T, b, _) {
      super(E, g, T), this.ProfileType = E, this.ProfileName = g, this.Position = T, this.SemiAxis1 = b, this.SemiAxis2 = _, this.type = 2835456948;
    }
  }
  e.IfcEllipseProfileDef = jM;
  class CG extends um {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.Identification = V, this.LongDescription = q, this.ProcessType = se, this.PredefinedType = qe, this.EventTriggerType = vi, this.UserDefinedEventTriggerType = In, this.type = 4024345920;
    }
  }
  e.IfcEventType = CG;
  class WM extends e7 {
    constructor(E, g, T, b) {
      super(E, g), this.SweptArea = E, this.Position = g, this.ExtrudedDirection = T, this.Depth = b, this.type = 477187591;
    }
  }
  e.IfcExtrudedAreaSolid = WM;
  class uR extends WM {
    constructor(E, g, T, b, _) {
      super(E, g, T, b), this.SweptArea = E, this.Position = g, this.ExtrudedDirection = T, this.Depth = b, this.EndSweptArea = _, this.type = 2804161546;
    }
  }
  e.IfcExtrudedAreaSolidTapered = uR;
  class a$ extends Nr {
    constructor(E) {
      super(), this.FbsmFaces = E, this.type = 2047409740;
    }
  }
  e.IfcFaceBasedSurfaceModel = a$;
  class u$ extends Nr {
    constructor(E, g, T, b, _) {
      super(), this.HatchLineAppearance = E, this.StartOfNextHatchLine = g, this.PointOfReferenceHatchLine = T, this.PatternStart = b, this.HatchLineAngle = _, this.type = 374418227;
    }
  }
  e.IfcFillAreaStyleHatching = u$;
  class d$ extends Nr {
    constructor(E, g, T) {
      super(), this.TilingPattern = E, this.Tiles = g, this.TilingScale = T, this.type = 315944413;
    }
  }
  e.IfcFillAreaStyleTiles = d$;
  class OG extends VI {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b, _), this.SweptArea = E, this.Position = g, this.Directrix = T, this.StartParam = b, this.EndParam = _, this.FixedReference = H, this.type = 2652556860;
    }
  }
  e.IfcFixedReferenceSweptAreaSolid = OG;
  class YM extends dm {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.type = 4238390223;
    }
  }
  e.IfcFurnishingElementType = YM;
  class qM extends YM {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.AssemblyPlace = qe, this.PredefinedType = vi, this.type = 1268542332;
    }
  }
  e.IfcFurnitureType = qM;
  class E0 extends dm {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 4095422895;
    }
  }
  e.IfcGeographicElementType = E0;
  class o7 extends TM {
    constructor(E) {
      super(E), this.Elements = E, this.type = 987898635;
    }
  }
  e.IfcGeometricCurveSet = o7;
  class c$ extends Vf {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T), this.ProfileType = E, this.ProfileName = g, this.Position = T, this.OverallWidth = b, this.OverallDepth = _, this.WebThickness = H, this.FlangeThickness = V, this.FilletRadius = q, this.FlangeEdgeRadius = se, this.FlangeSlope = qe, this.type = 1484403080;
    }
  }
  e.IfcIShapeProfileDef = c$;
  class LG extends zf {
    constructor(E) {
      super(), this.CoordIndex = E, this.type = 178912537;
    }
  }
  e.IfcIndexedPolygonalFace = LG;
  class h$ extends LG {
    constructor(E, g) {
      super(E), this.CoordIndex = E, this.InnerCoordIndices = g, this.type = 2294589976;
    }
  }
  e.IfcIndexedPolygonalFaceWithVoids = h$;
  class f$ extends JA {
    constructor(E, g, T, b) {
      super(E, g, T), this.Maps = E, this.MappedTo = g, this.TexCoords = T, this.TexCoordIndices = b, this.type = 3465909080;
    }
  }
  e.IfcIndexedPolygonalTextureMap = f$;
  class sS extends Vf {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T), this.ProfileType = E, this.ProfileName = g, this.Position = T, this.Depth = b, this.Width = _, this.Thickness = H, this.FilletRadius = V, this.EdgeRadius = q, this.LegSlope = se, this.type = 572779678;
    }
  }
  e.IfcLShapeProfileDef = sS;
  class I$ extends lR {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In) {
      super(E, g, T, b, _, H, V, q, se, qe, vi), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.Identification = V, this.LongDescription = q, this.ResourceType = se, this.BaseCosts = qe, this.BaseQuantity = vi, this.PredefinedType = In, this.type = 428585644;
    }
  }
  e.IfcLaborResourceType = I$;
  class zI extends sw {
    constructor(E, g) {
      super(), this.Pnt = E, this.Dir = g, this.type = 1281925730;
    }
  }
  e.IfcLine = zI;
  class $M extends eS {
    constructor(E) {
      super(), this.Outer = E, this.type = 1425443689;
    }
  }
  e.IfcManifoldSolidBrep = $M;
  class dR extends tR {
    constructor(E, g, T, b, _) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.type = 3888040117;
    }
  }
  e.IfcObject = dR;
  class r7 extends sw {
    constructor(E) {
      super(), this.BasisCurve = E, this.type = 590820931;
    }
  }
  e.IfcOffsetCurve = r7;
  class _G extends r7 {
    constructor(E, g, T) {
      super(E), this.BasisCurve = E, this.Distance = g, this.SelfIntersect = T, this.type = 3388369263;
    }
  }
  e.IfcOffsetCurve2D = _G;
  class cR extends r7 {
    constructor(E, g, T, b) {
      super(E), this.BasisCurve = E, this.Distance = g, this.SelfIntersect = T, this.RefDirection = b, this.type = 3505215534;
    }
  }
  e.IfcOffsetCurve3D = cR;
  class Q3 extends r7 {
    constructor(E, g, T) {
      super(E), this.BasisCurve = E, this.OffsetValues = g, this.Tag = T, this.type = 2485787929;
    }
  }
  e.IfcOffsetCurveByDistances = Q3;
  class g0 extends sw {
    constructor(E, g) {
      super(), this.BasisSurface = E, this.ReferenceCurve = g, this.type = 1682466193;
    }
  }
  e.IfcPcurve = g0;
  class p$ extends nR {
    constructor(E, g, T) {
      super(E, g), this.SizeInX = E, this.SizeInY = g, this.Placement = T, this.type = 603570806;
    }
  }
  e.IfcPlanarBox = p$;
  class m$ extends aR {
    constructor(E) {
      super(E), this.Position = E, this.type = 220341763;
    }
  }
  e.IfcPlane = m$;
  class y$ extends sw {
    constructor(E, g, T, b) {
      super(), this.Position = E, this.CoefficientsX = g, this.CoefficientsY = T, this.CoefficientsZ = b, this.type = 3381221214;
    }
  }
  e.IfcPolynomialCurve = y$;
  class xG extends KL {
    constructor(E) {
      super(E), this.Name = E, this.type = 759155922;
    }
  }
  e.IfcPreDefinedColour = xG;
  class PG extends KL {
    constructor(E) {
      super(E), this.Name = E, this.type = 2559016684;
    }
  }
  e.IfcPreDefinedCurveFont = PG;
  class J3 extends P6 {
    constructor(E, g, T, b) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.type = 3967405729;
    }
  }
  e.IfcPreDefinedPropertySet = J3;
  class KM extends um {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.Identification = V, this.LongDescription = q, this.ProcessType = se, this.PredefinedType = qe, this.type = 569719735;
    }
  }
  e.IfcProcedureType = KM;
  class jI extends dR {
    constructor(E, g, T, b, _, H, V) {
      super(E, g, T, b, _), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.Identification = H, this.LongDescription = V, this.type = 2945172077;
    }
  }
  e.IfcProcess = jI;
  class ow extends dR {
    constructor(E, g, T, b, _, H, V) {
      super(E, g, T, b, _), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.type = 4208778838;
    }
  }
  e.IfcProduct = ow;
  class X3 extends VM {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.LongName = H, this.Phase = V, this.RepresentationContexts = q, this.UnitsInContext = se, this.type = 103090709;
    }
  }
  e.IfcProject = X3;
  class E$ extends VM {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.LongName = H, this.Phase = V, this.RepresentationContexts = q, this.UnitsInContext = se, this.type = 653396225;
    }
  }
  e.IfcProjectLibrary = E$;
  class l7 extends Ah {
    constructor(E, g, T, b, _, H) {
      super(E, g), this.Name = E, this.Specification = g, this.UpperBoundValue = T, this.LowerBoundValue = b, this.Unit = _, this.SetPointValue = H, this.type = 871118103;
    }
  }
  e.IfcPropertyBoundedValue = l7;
  class a7 extends Ah {
    constructor(E, g, T, b) {
      super(E, g), this.Name = E, this.Specification = g, this.EnumerationValues = T, this.EnumerationReference = b, this.type = 4166981789;
    }
  }
  e.IfcPropertyEnumeratedValue = a7;
  class g$ extends Ah {
    constructor(E, g, T, b) {
      super(E, g), this.Name = E, this.Specification = g, this.ListValues = T, this.Unit = b, this.type = 2752243245;
    }
  }
  e.IfcPropertyListValue = g$;
  class Ju extends Ah {
    constructor(E, g, T, b) {
      super(E, g), this.Name = E, this.Specification = g, this.UsageName = T, this.PropertyReference = b, this.type = 941946838;
    }
  }
  e.IfcPropertyReferenceValue = Ju;
  class w$ extends P6 {
    constructor(E, g, T, b, _) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.HasProperties = _, this.type = 1451395588;
    }
  }
  e.IfcPropertySet = w$;
  class MG extends LM {
    constructor(E, g, T, b, _, H, V) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.TemplateType = _, this.ApplicableEntity = H, this.HasPropertyTemplates = V, this.type = 492091185;
    }
  }
  e.IfcPropertySetTemplate = MG;
  class UG extends Ah {
    constructor(E, g, T, b) {
      super(E, g), this.Name = E, this.Specification = g, this.NominalValue = T, this.Unit = b, this.type = 3650150729;
    }
  }
  e.IfcPropertySingleValue = UG;
  class T$ extends Ah {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g), this.Name = E, this.Specification = g, this.DefiningValues = T, this.DefinedValues = b, this.Expression = _, this.DefiningUnit = H, this.DefinedUnit = V, this.CurveInterpolation = q, this.type = 110355661;
    }
  }
  e.IfcPropertyTableValue = T$;
  class ZM extends LM {
    constructor(E, g, T, b) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.type = 3521284610;
    }
  }
  e.IfcPropertyTemplate = ZM;
  class R$ extends oR {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _), this.ProfileType = E, this.ProfileName = g, this.Position = T, this.XDim = b, this.YDim = _, this.WallThickness = H, this.InnerFilletRadius = V, this.OuterFilletRadius = q, this.type = 2770003689;
    }
  }
  e.IfcRectangleHollowProfileDef = R$;
  class BG extends nS {
    constructor(E, g, T, b) {
      super(E), this.Position = E, this.XLength = g, this.YLength = T, this.Height = b, this.type = 2798486643;
    }
  }
  e.IfcRectangularPyramid = BG;
  class U6 extends K3 {
    constructor(E, g, T, b, _, H, V) {
      super(), this.BasisSurface = E, this.U1 = g, this.V1 = T, this.U2 = b, this.V2 = _, this.Usense = H, this.Vsense = V, this.type = 3454111270;
    }
  }
  e.IfcRectangularTrimmedSurface = U6;
  class B6 extends J3 {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.DefinitionType = _, this.ReinforcementSectionDefinitions = H, this.type = 3765753017;
    }
  }
  e.IfcReinforcementDefinitionProperties = B6;
  class cm extends rR {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatedObjects = _, this.RelatedObjectsType = H, this.type = 3939117080;
    }
  }
  e.IfcRelAssigns = cm;
  class u7 extends cm {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatedObjects = _, this.RelatedObjectsType = H, this.RelatingActor = V, this.ActingRole = q, this.type = 1683148259;
    }
  }
  e.IfcRelAssignsToActor = u7;
  class J4 extends cm {
    constructor(E, g, T, b, _, H, V) {
      super(E, g, T, b, _, H), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatedObjects = _, this.RelatedObjectsType = H, this.RelatingControl = V, this.type = 2495723537;
    }
  }
  e.IfcRelAssignsToControl = J4;
  class oS extends cm {
    constructor(E, g, T, b, _, H, V) {
      super(E, g, T, b, _, H), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatedObjects = _, this.RelatedObjectsType = H, this.RelatingGroup = V, this.type = 1307041759;
    }
  }
  e.IfcRelAssignsToGroup = oS;
  class v$ extends oS {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatedObjects = _, this.RelatedObjectsType = H, this.RelatingGroup = V, this.Factor = q, this.type = 1027710054;
    }
  }
  e.IfcRelAssignsToGroupByFactor = v$;
  class d7 extends cm {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatedObjects = _, this.RelatedObjectsType = H, this.RelatingProcess = V, this.QuantityInProcess = q, this.type = 4278684876;
    }
  }
  e.IfcRelAssignsToProcess = d7;
  class hR extends cm {
    constructor(E, g, T, b, _, H, V) {
      super(E, g, T, b, _, H), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatedObjects = _, this.RelatedObjectsType = H, this.RelatingProduct = V, this.type = 2857406711;
    }
  }
  e.IfcRelAssignsToProduct = hR;
  class F6 extends cm {
    constructor(E, g, T, b, _, H, V) {
      super(E, g, T, b, _, H), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatedObjects = _, this.RelatedObjectsType = H, this.RelatingResource = V, this.type = 205026976;
    }
  }
  e.IfcRelAssignsToResource = F6;
  class da extends rR {
    constructor(E, g, T, b, _) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatedObjects = _, this.type = 1865459582;
    }
  }
  e.IfcRelAssociates = da;
  class rS extends da {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b, _), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatedObjects = _, this.RelatingApproval = H, this.type = 4095574036;
    }
  }
  e.IfcRelAssociatesApproval = rS;
  class FG extends da {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b, _), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatedObjects = _, this.RelatingClassification = H, this.type = 919958153;
    }
  }
  e.IfcRelAssociatesClassification = FG;
  class A$ extends da {
    constructor(E, g, T, b, _, H, V) {
      super(E, g, T, b, _), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatedObjects = _, this.Intent = H, this.RelatingConstraint = V, this.type = 2728634034;
    }
  }
  e.IfcRelAssociatesConstraint = A$;
  class S$ extends da {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b, _), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatedObjects = _, this.RelatingDocument = H, this.type = 982818633;
    }
  }
  e.IfcRelAssociatesDocument = S$;
  class b$ extends da {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b, _), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatedObjects = _, this.RelatingLibrary = H, this.type = 3840914261;
    }
  }
  e.IfcRelAssociatesLibrary = b$;
  class RE extends da {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b, _), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatedObjects = _, this.RelatingMaterial = H, this.type = 2655215786;
    }
  }
  e.IfcRelAssociatesMaterial = RE;
  class N$ extends da {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b, _), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatedObjects = _, this.RelatingProfileDef = H, this.type = 1033248425;
    }
  }
  e.IfcRelAssociatesProfileDef = N$;
  class Gc extends rR {
    constructor(E, g, T, b) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.type = 826625072;
    }
  }
  e.IfcRelConnects = Gc;
  class QM extends Gc {
    constructor(E, g, T, b, _, H, V) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ConnectionGeometry = _, this.RelatingElement = H, this.RelatedElement = V, this.type = 1204542856;
    }
  }
  e.IfcRelConnectsElements = QM;
  class D$ extends QM {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi) {
      super(E, g, T, b, _, H, V), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ConnectionGeometry = _, this.RelatingElement = H, this.RelatedElement = V, this.RelatingPriorities = q, this.RelatedPriorities = se, this.RelatedConnectionType = qe, this.RelatingConnectionType = vi, this.type = 3945020480;
    }
  }
  e.IfcRelConnectsPathElements = D$;
  class C$ extends Gc {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatingPort = _, this.RelatedElement = H, this.type = 4201705270;
    }
  }
  e.IfcRelConnectsPortToElement = C$;
  class O$ extends Gc {
    constructor(E, g, T, b, _, H, V) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatingPort = _, this.RelatedPort = H, this.RealizingElement = V, this.type = 3190031847;
    }
  }
  e.IfcRelConnectsPorts = O$;
  class JM extends Gc {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatingElement = _, this.RelatedStructuralActivity = H, this.type = 2127690289;
    }
  }
  e.IfcRelConnectsStructuralActivity = JM;
  class HG extends Gc {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatingStructuralMember = _, this.RelatedStructuralConnection = H, this.AppliedCondition = V, this.AdditionalConditions = q, this.SupportedLength = se, this.ConditionCoordinateSystem = qe, this.type = 1638771189;
    }
  }
  e.IfcRelConnectsStructuralMember = HG;
  class L$ extends HG {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi) {
      super(E, g, T, b, _, H, V, q, se, qe), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatingStructuralMember = _, this.RelatedStructuralConnection = H, this.AppliedCondition = V, this.AdditionalConditions = q, this.SupportedLength = se, this.ConditionCoordinateSystem = qe, this.ConnectionConstraint = vi, this.type = 504942748;
    }
  }
  e.IfcRelConnectsWithEccentricity = L$;
  class _$ extends QM {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ConnectionGeometry = _, this.RelatingElement = H, this.RelatedElement = V, this.RealizingElements = q, this.ConnectionType = se, this.type = 3678494232;
    }
  }
  e.IfcRelConnectsWithRealizingElements = _$;
  class x$ extends Gc {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatedElements = _, this.RelatingStructure = H, this.type = 3242617779;
    }
  }
  e.IfcRelContainedInSpatialStructure = x$;
  class P$ extends Gc {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatingBuildingElement = _, this.RelatedCoverings = H, this.type = 886880790;
    }
  }
  e.IfcRelCoversBldgElements = P$;
  class GG extends Gc {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatingSpace = _, this.RelatedCoverings = H, this.type = 2802773753;
    }
  }
  e.IfcRelCoversSpaces = GG;
  class kG extends rR {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatingContext = _, this.RelatedDefinitions = H, this.type = 2565941209;
    }
  }
  e.IfcRelDeclares = kG;
  class lS extends rR {
    constructor(E, g, T, b) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.type = 2551354335;
    }
  }
  e.IfcRelDecomposes = lS;
  class H6 extends rR {
    constructor(E, g, T, b) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.type = 693640335;
    }
  }
  e.IfcRelDefines = H6;
  class VG extends H6 {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatedObjects = _, this.RelatingObject = H, this.type = 1462361463;
    }
  }
  e.IfcRelDefinesByObject = VG;
  class zG extends H6 {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatedObjects = _, this.RelatingPropertyDefinition = H, this.type = 4186316022;
    }
  }
  e.IfcRelDefinesByProperties = zG;
  class M$ extends H6 {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatedPropertySets = _, this.RelatingTemplate = H, this.type = 307848117;
    }
  }
  e.IfcRelDefinesByTemplate = M$;
  class U$ extends H6 {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatedObjects = _, this.RelatingType = H, this.type = 781010003;
    }
  }
  e.IfcRelDefinesByType = U$;
  class aS extends Gc {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatingOpeningElement = _, this.RelatedBuildingElement = H, this.type = 3940055652;
    }
  }
  e.IfcRelFillsElement = aS;
  class B$ extends Gc {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatedControlElements = _, this.RelatingFlowElement = H, this.type = 279856033;
    }
  }
  e.IfcRelFlowControlElements = B$;
  class ql extends Gc {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatingElement = _, this.RelatedElement = H, this.InterferenceGeometry = V, this.InterferenceSpace = q, this.InterferenceType = se, this.ImpliedOrder = qe, this.type = 427948657;
    }
  }
  e.IfcRelInterferesElements = ql;
  class jG extends lS {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatingObject = _, this.RelatedObjects = H, this.type = 3268803585;
    }
  }
  e.IfcRelNests = jG;
  class F$ extends Gc {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatingPositioningElement = _, this.RelatedProducts = H, this.type = 1441486842;
    }
  }
  e.IfcRelPositions = F$;
  class H$ extends lS {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatingElement = _, this.RelatedFeatureElement = H, this.type = 750771296;
    }
  }
  e.IfcRelProjectsElement = H$;
  class G$ extends Gc {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatedElements = _, this.RelatingStructure = H, this.type = 1245217292;
    }
  }
  e.IfcRelReferencedInSpatialStructure = G$;
  class k$ extends Gc {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatingProcess = _, this.RelatedProcess = H, this.TimeLag = V, this.SequenceType = q, this.UserDefinedSequenceType = se, this.type = 4122056220;
    }
  }
  e.IfcRelSequence = k$;
  class V$ extends Gc {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatingSystem = _, this.RelatedBuildings = H, this.type = 366585022;
    }
  }
  e.IfcRelServicesBuildings = V$;
  class XM extends Gc {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatingSpace = _, this.RelatedBuildingElement = H, this.ConnectionGeometry = V, this.PhysicalOrVirtualBoundary = q, this.InternalOrExternalBoundary = se, this.type = 3451746338;
    }
  }
  e.IfcRelSpaceBoundary = XM;
  class e9 extends XM {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatingSpace = _, this.RelatedBuildingElement = H, this.ConnectionGeometry = V, this.PhysicalOrVirtualBoundary = q, this.InternalOrExternalBoundary = se, this.ParentBoundary = qe, this.type = 3523091289;
    }
  }
  e.IfcRelSpaceBoundary1stLevel = e9;
  class t9 extends e9 {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi) {
      super(E, g, T, b, _, H, V, q, se, qe), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatingSpace = _, this.RelatedBuildingElement = H, this.ConnectionGeometry = V, this.PhysicalOrVirtualBoundary = q, this.InternalOrExternalBoundary = se, this.ParentBoundary = qe, this.CorrespondingBoundary = vi, this.type = 1521410863;
    }
  }
  e.IfcRelSpaceBoundary2ndLevel = t9;
  class z$ extends lS {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatingBuildingElement = _, this.RelatedOpeningElement = H, this.type = 1401173127;
    }
  }
  e.IfcRelVoidsElement = z$;
  class j$ extends bG {
    constructor(E, g, T, b) {
      super(E, g, T), this.Transition = E, this.SameSense = g, this.ParentCurve = T, this.ParamLength = b, this.type = 816062949;
    }
  }
  e.IfcReparametrisedCompositeCurveSegment = j$;
  class WG extends dR {
    constructor(E, g, T, b, _, H, V) {
      super(E, g, T, b, _), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.Identification = H, this.LongDescription = V, this.type = 2914609552;
    }
  }
  e.IfcResource = WG;
  class X4 extends e7 {
    constructor(E, g, T, b) {
      super(E, g), this.SweptArea = E, this.Position = g, this.Axis = T, this.Angle = b, this.type = 1856042241;
    }
  }
  e.IfcRevolvedAreaSolid = X4;
  class rw extends X4 {
    constructor(E, g, T, b, _) {
      super(E, g, T, b), this.SweptArea = E, this.Position = g, this.Axis = T, this.Angle = b, this.EndSweptArea = _, this.type = 3243963512;
    }
  }
  e.IfcRevolvedAreaSolidTapered = rw;
  class W$ extends nS {
    constructor(E, g, T) {
      super(E), this.Position = E, this.Height = g, this.BottomRadius = T, this.type = 4158566097;
    }
  }
  e.IfcRightCircularCone = W$;
  class Y$ extends nS {
    constructor(E, g, T) {
      super(E), this.Position = E, this.Height = g, this.Radius = T, this.type = 3626867408;
    }
  }
  e.IfcRightCircularCylinder = Y$;
  class YG extends eS {
    constructor(E, g) {
      super(), this.Directrix = E, this.CrossSections = g, this.type = 1862484736;
    }
  }
  e.IfcSectionedSolid = YG;
  class q$ extends YG {
    constructor(E, g, T) {
      super(E, g), this.Directrix = E, this.CrossSections = g, this.CrossSectionPositions = T, this.type = 1290935644;
    }
  }
  e.IfcSectionedSolidHorizontal = q$;
  class $$ extends am {
    constructor(E, g, T) {
      super(), this.Directrix = E, this.CrossSectionPositions = g, this.CrossSections = T, this.type = 1356537516;
    }
  }
  e.IfcSectionedSurface = $$;
  class K$ extends ZM {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.TemplateType = _, this.PrimaryMeasureType = H, this.SecondaryMeasureType = V, this.Enumerators = q, this.PrimaryUnit = se, this.SecondaryUnit = qe, this.Expression = vi, this.AccessState = In, this.type = 3663146110;
    }
  }
  e.IfcSimplePropertyTemplate = K$;
  class uS extends ow {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.LongName = q, this.type = 1412071761;
    }
  }
  e.IfcSpatialElement = uS;
  class hm extends BM {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.type = 710998568;
    }
  }
  e.IfcSpatialElementType = hm;
  class dS extends uS {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.LongName = q, this.CompositionType = se, this.type = 2706606064;
    }
  }
  e.IfcSpatialStructureElement = dS;
  class G6 extends hm {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.type = 3893378262;
    }
  }
  e.IfcSpatialStructureElementType = G6;
  class c7 extends uS {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.LongName = q, this.PredefinedType = se, this.type = 463610769;
    }
  }
  e.IfcSpatialZone = c7;
  class Z$ extends hm {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.LongName = vi, this.type = 2481509218;
    }
  }
  e.IfcSpatialZoneType = Z$;
  class qG extends nS {
    constructor(E, g) {
      super(E), this.Position = E, this.Radius = g, this.type = 451544542;
    }
  }
  e.IfcSphere = qG;
  class ey extends aR {
    constructor(E, g) {
      super(E), this.Position = E, this.Radius = g, this.type = 4015995234;
    }
  }
  e.IfcSphericalSurface = ey;
  class eT extends sw {
    constructor(E) {
      super(), this.Position = E, this.type = 2735484536;
    }
  }
  e.IfcSpiral = eT;
  class i9 extends ow {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.AppliedLoad = q, this.GlobalOrLocal = se, this.type = 3544373492;
    }
  }
  e.IfcStructuralActivity = i9;
  class lw extends ow {
    constructor(E, g, T, b, _, H, V) {
      super(E, g, T, b, _, H, V), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.type = 3136571912;
    }
  }
  e.IfcStructuralItem = lw;
  class vE extends lw {
    constructor(E, g, T, b, _, H, V) {
      super(E, g, T, b, _, H, V), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.type = 530289379;
    }
  }
  e.IfcStructuralMember = vE;
  class h7 extends i9 {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.AppliedLoad = q, this.GlobalOrLocal = se, this.type = 3689010777;
    }
  }
  e.IfcStructuralReaction = h7;
  class $l extends vE {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.PredefinedType = q, this.Thickness = se, this.type = 3979015343;
    }
  }
  e.IfcStructuralSurfaceMember = $l;
  class Q$ extends $l {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.PredefinedType = q, this.Thickness = se, this.type = 2218152070;
    }
  }
  e.IfcStructuralSurfaceMemberVarying = Q$;
  class J$ extends h7 {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.AppliedLoad = q, this.GlobalOrLocal = se, this.PredefinedType = qe, this.type = 603775116;
    }
  }
  e.IfcStructuralSurfaceReaction = J$;
  class X$ extends lR {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In) {
      super(E, g, T, b, _, H, V, q, se, qe, vi), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.Identification = V, this.LongDescription = q, this.ResourceType = se, this.BaseCosts = qe, this.BaseQuantity = vi, this.PredefinedType = In, this.type = 4095615324;
    }
  }
  e.IfcSubContractResourceType = X$;
  class n9 extends sw {
    constructor(E, g, T) {
      super(), this.Curve3D = E, this.AssociatedGeometry = g, this.MasterRepresentation = T, this.type = 699246055;
    }
  }
  e.IfcSurfaceCurve = n9;
  class $G extends VI {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b, _), this.SweptArea = E, this.Position = g, this.Directrix = T, this.StartParam = b, this.EndParam = _, this.ReferenceSurface = H, this.type = 2028607225;
    }
  }
  e.IfcSurfaceCurveSweptAreaSolid = $G;
  class KG extends nw {
    constructor(E, g, T, b) {
      super(E, g), this.SweptCurve = E, this.Position = g, this.ExtrudedDirection = T, this.Depth = b, this.type = 2809605785;
    }
  }
  e.IfcSurfaceOfLinearExtrusion = KG;
  class s9 extends nw {
    constructor(E, g, T) {
      super(E, g), this.SweptCurve = E, this.Position = g, this.AxisPosition = T, this.type = 4124788165;
    }
  }
  e.IfcSurfaceOfRevolution = s9;
  class eK extends YM {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1580310250;
    }
  }
  e.IfcSystemFurnitureElementType = eK;
  class tK extends jI {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In, gs) {
      super(E, g, T, b, _, H, V), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.Identification = H, this.LongDescription = V, this.Status = q, this.WorkMethod = se, this.IsMilestone = qe, this.Priority = vi, this.TaskTime = In, this.PredefinedType = gs, this.type = 3473067441;
    }
  }
  e.IfcTask = tK;
  class f7 extends um {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.Identification = V, this.LongDescription = q, this.ProcessType = se, this.PredefinedType = qe, this.WorkMethod = vi, this.type = 3206491090;
    }
  }
  e.IfcTaskType = f7;
  class I7 extends zf {
    constructor(E, g) {
      super(), this.Coordinates = E, this.Closed = g, this.type = 2387106220;
    }
  }
  e.IfcTessellatedFaceSet = I7;
  class o9 extends eT {
    constructor(E, g, T, b, _) {
      super(E), this.Position = E, this.CubicTerm = g, this.QuadraticTerm = T, this.LinearTerm = b, this.ConstantTerm = _, this.type = 782932809;
    }
  }
  e.IfcThirdOrderPolynomialSpiral = o9;
  class aw extends aR {
    constructor(E, g, T) {
      super(E), this.Position = E, this.MajorRadius = g, this.MinorRadius = T, this.type = 1935646853;
    }
  }
  e.IfcToroidalSurface = aw;
  class tT extends dm {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.type = 3665877780;
    }
  }
  e.IfcTransportationDeviceType = tT;
  class ZG extends I7 {
    constructor(E, g, T, b, _) {
      super(E, g), this.Coordinates = E, this.Closed = g, this.Normals = T, this.CoordIndex = b, this.PnIndex = _, this.type = 2916149573;
    }
  }
  e.IfcTriangulatedFaceSet = ZG;
  class p7 extends ZG {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b, _), this.Coordinates = E, this.Closed = g, this.Normals = T, this.CoordIndex = b, this.PnIndex = _, this.Flags = H, this.type = 1229763772;
    }
  }
  e.IfcTriangulatedIrregularNetwork = p7;
  class k6 extends tT {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 3651464721;
    }
  }
  e.IfcVehicleType = k6;
  class r9 extends J3 {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In, gs, $r, $d, N0) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.LiningDepth = _, this.LiningThickness = H, this.TransomThickness = V, this.MullionThickness = q, this.FirstTransomOffset = se, this.SecondTransomOffset = qe, this.FirstMullionOffset = vi, this.SecondMullionOffset = In, this.ShapeAspectStyle = gs, this.LiningOffset = $r, this.LiningToPanelOffsetX = $d, this.LiningToPanelOffsetY = N0, this.type = 336235671;
    }
  }
  e.IfcWindowLiningProperties = r9;
  class w0 extends J3 {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.OperationType = _, this.PanelPosition = H, this.FrameDepth = V, this.FrameThickness = q, this.ShapeAspectStyle = se, this.type = 512836454;
    }
  }
  e.IfcWindowPanelProperties = w0;
  class V6 extends dR {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b, _), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.TheActor = H, this.type = 2296667514;
    }
  }
  e.IfcActor = V6;
  class QG extends $M {
    constructor(E) {
      super(E), this.Outer = E, this.type = 1635779807;
    }
  }
  e.IfcAdvancedBrep = QG;
  class l9 extends QG {
    constructor(E, g) {
      super(E), this.Outer = E, this.Voids = g, this.type = 2603310189;
    }
  }
  e.IfcAdvancedBrepWithVoids = l9;
  class iK extends ow {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.PredefinedType = q, this.type = 1674181508;
    }
  }
  e.IfcAnnotation = iK;
  class JG extends K3 {
    constructor(E, g, T, b, _, H, V) {
      super(), this.UDegree = E, this.VDegree = g, this.ControlPointsList = T, this.SurfaceForm = b, this.UClosed = _, this.VClosed = H, this.SelfIntersect = V, this.type = 2887950389;
    }
  }
  e.IfcBSplineSurface = JG;
  class XG extends JG {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In) {
      super(E, g, T, b, _, H, V), this.UDegree = E, this.VDegree = g, this.ControlPointsList = T, this.SurfaceForm = b, this.UClosed = _, this.VClosed = H, this.SelfIntersect = V, this.UMultiplicities = q, this.VMultiplicities = se, this.UKnots = qe, this.VKnots = vi, this.KnotSpec = In, this.type = 167062518;
    }
  }
  e.IfcBSplineSurfaceWithKnots = XG;
  class cS extends nS {
    constructor(E, g, T, b) {
      super(E), this.Position = E, this.XLength = g, this.YLength = T, this.ZLength = b, this.type = 1334484129;
    }
  }
  e.IfcBlock = cS;
  class nK extends i7 {
    constructor(E, g, T) {
      super(E, g, T), this.Operator = E, this.FirstOperand = g, this.SecondOperand = T, this.type = 3649129432;
    }
  }
  e.IfcBooleanClippingResult = nK;
  class hS extends sw {
    constructor() {
      super(), this.type = 1260505505;
    }
  }
  e.IfcBoundedCurve = hS;
  class sK extends dS {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.LongName = q, this.CompositionType = se, this.Elevation = qe, this.type = 3124254112;
    }
  }
  e.IfcBuildingStorey = sK;
  class hr extends dm {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.type = 1626504194;
    }
  }
  e.IfcBuiltElementType = hr;
  class oK extends hr {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 2197970202;
    }
  }
  e.IfcChimneyType = oK;
  class ek extends SG {
    constructor(E, g, T, b, _) {
      super(E, g, T, b), this.ProfileType = E, this.ProfileName = g, this.Position = T, this.Radius = b, this.WallThickness = _, this.type = 2937912522;
    }
  }
  e.IfcCircleHollowProfileDef = ek;
  class rK extends dm {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.type = 3893394355;
    }
  }
  e.IfcCivilElementType = rK;
  class ca extends eT {
    constructor(E, g) {
      super(E), this.Position = E, this.ClothoidConstant = g, this.type = 3497074424;
    }
  }
  e.IfcClothoid = ca;
  class a9 extends hr {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 300633059;
    }
  }
  e.IfcColumnType = a9;
  class lK extends ZM {
    constructor(E, g, T, b, _, H, V) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.UsageName = _, this.TemplateType = H, this.HasPropertyTemplates = V, this.type = 3875453745;
    }
  }
  e.IfcComplexPropertyTemplate = lK;
  class m7 extends hS {
    constructor(E, g) {
      super(), this.Segments = E, this.SelfIntersect = g, this.type = 3732776249;
    }
  }
  e.IfcCompositeCurve = m7;
  class tk extends m7 {
    constructor(E, g) {
      super(E, g), this.Segments = E, this.SelfIntersect = g, this.type = 15328376;
    }
  }
  e.IfcCompositeCurveOnSurface = tk;
  class u9 extends sw {
    constructor(E) {
      super(), this.Position = E, this.type = 2510884976;
    }
  }
  e.IfcConic = u9;
  class aK extends lR {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In) {
      super(E, g, T, b, _, H, V, q, se, qe, vi), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.Identification = V, this.LongDescription = q, this.ResourceType = se, this.BaseCosts = qe, this.BaseQuantity = vi, this.PredefinedType = In, this.type = 2185764099;
    }
  }
  e.IfcConstructionEquipmentResourceType = aK;
  class uK extends lR {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In) {
      super(E, g, T, b, _, H, V, q, se, qe, vi), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.Identification = V, this.LongDescription = q, this.ResourceType = se, this.BaseCosts = qe, this.BaseQuantity = vi, this.PredefinedType = In, this.type = 4105962743;
    }
  }
  e.IfcConstructionMaterialResourceType = uK;
  class dK extends lR {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In) {
      super(E, g, T, b, _, H, V, q, se, qe, vi), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.Identification = V, this.LongDescription = q, this.ResourceType = se, this.BaseCosts = qe, this.BaseQuantity = vi, this.PredefinedType = In, this.type = 1525564444;
    }
  }
  e.IfcConstructionProductResourceType = dK;
  class iT extends WG {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.Identification = H, this.LongDescription = V, this.Usage = q, this.BaseCosts = se, this.BaseQuantity = qe, this.type = 2559216714;
    }
  }
  e.IfcConstructionResource = iT;
  class uw extends dR {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b, _), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.Identification = H, this.type = 3293443760;
    }
  }
  e.IfcControl = uw;
  class cK extends eT {
    constructor(E, g, T) {
      super(E), this.Position = E, this.CosineTerm = g, this.ConstantTerm = T, this.type = 2000195564;
    }
  }
  e.IfcCosineSpiral = cK;
  class hK extends uw {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.Identification = H, this.PredefinedType = V, this.CostValues = q, this.CostQuantities = se, this.type = 3895139033;
    }
  }
  e.IfcCostItem = hK;
  class fK extends uw {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.Identification = H, this.PredefinedType = V, this.Status = q, this.SubmittedOn = se, this.UpdateDate = qe, this.type = 1419761937;
    }
  }
  e.IfcCostSchedule = fK;
  class IK extends hr {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 4189326743;
    }
  }
  e.IfcCourseType = IK;
  class pK extends hr {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1916426348;
    }
  }
  e.IfcCoveringType = pK;
  class mK extends iT {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi) {
      super(E, g, T, b, _, H, V, q, se, qe), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.Identification = H, this.LongDescription = V, this.Usage = q, this.BaseCosts = se, this.BaseQuantity = qe, this.PredefinedType = vi, this.type = 3295246426;
    }
  }
  e.IfcCrewResource = mK;
  class yK extends hr {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1457835157;
    }
  }
  e.IfcCurtainWallType = yK;
  class EK extends aR {
    constructor(E, g) {
      super(E), this.Position = E, this.Radius = g, this.type = 1213902940;
    }
  }
  e.IfcCylindricalSurface = EK;
  class d9 extends hr {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.type = 1306400036;
    }
  }
  e.IfcDeepFoundationType = d9;
  class gK extends OG {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b, _, H), this.SweptArea = E, this.Position = g, this.Directrix = T, this.StartParam = b, this.EndParam = _, this.FixedReference = H, this.type = 4234616927;
    }
  }
  e.IfcDirectrixDerivedReferenceSweptAreaSolid = gK;
  class y7 extends dm {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.type = 3256556792;
    }
  }
  e.IfcDistributionElementType = y7;
  class AE extends y7 {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.type = 3849074793;
    }
  }
  e.IfcDistributionFlowElementType = AE;
  class wK extends J3 {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In, gs, $r, $d, N0, Dm) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.LiningDepth = _, this.LiningThickness = H, this.ThresholdDepth = V, this.ThresholdThickness = q, this.TransomThickness = se, this.TransomOffset = qe, this.LiningOffset = vi, this.ThresholdOffset = In, this.CasingThickness = gs, this.CasingDepth = $r, this.ShapeAspectStyle = $d, this.LiningToPanelOffsetX = N0, this.LiningToPanelOffsetY = Dm, this.type = 2963535650;
    }
  }
  e.IfcDoorLiningProperties = wK;
  class TK extends J3 {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.PanelDepth = _, this.PanelOperation = H, this.PanelWidth = V, this.PanelPosition = q, this.ShapeAspectStyle = se, this.type = 1714330368;
    }
  }
  e.IfcDoorPanelProperties = TK;
  class RK extends hr {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In, gs) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.OperationType = vi, this.ParameterTakesPrecedence = In, this.UserDefinedOperationType = gs, this.type = 2323601079;
    }
  }
  e.IfcDoorType = RK;
  class ik extends xG {
    constructor(E) {
      super(E), this.Name = E, this.type = 445594917;
    }
  }
  e.IfcDraughtingPreDefinedColour = ik;
  class vK extends PG {
    constructor(E) {
      super(E), this.Name = E, this.type = 4006246654;
    }
  }
  e.IfcDraughtingPreDefinedCurveFont = vK;
  class kc extends ow {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.type = 1758889154;
    }
  }
  e.IfcElement = kc;
  class c9 extends kc {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.AssemblyPlace = se, this.PredefinedType = qe, this.type = 4123344466;
    }
  }
  e.IfcElementAssembly = c9;
  class SE extends dm {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 2397081782;
    }
  }
  e.IfcElementAssemblyType = SE;
  class jf extends kc {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.type = 1623761950;
    }
  }
  e.IfcElementComponent = jf;
  class Wf extends dm {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.type = 2590856083;
    }
  }
  e.IfcElementComponentType = Wf;
  class AK extends u9 {
    constructor(E, g, T) {
      super(E), this.Position = E, this.SemiAxis1 = g, this.SemiAxis2 = T, this.type = 1704287377;
    }
  }
  e.IfcEllipse = AK;
  class ha extends AE {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.type = 2107101300;
    }
  }
  e.IfcEnergyConversionDeviceType = ha;
  class SK extends ha {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 132023988;
    }
  }
  e.IfcEngineType = SK;
  class h9 extends ha {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 3174744832;
    }
  }
  e.IfcEvaporativeCoolerType = h9;
  class bK extends ha {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 3390157468;
    }
  }
  e.IfcEvaporatorType = bK;
  class NK extends jI {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi) {
      super(E, g, T, b, _, H, V), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.Identification = H, this.LongDescription = V, this.PredefinedType = q, this.EventTriggerType = se, this.UserDefinedEventTriggerType = qe, this.EventOccurenceTime = vi, this.type = 4148101412;
    }
  }
  e.IfcEvent = NK;
  class nk extends uS {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.LongName = q, this.type = 2853485674;
    }
  }
  e.IfcExternalSpatialStructureElement = nk;
  class sk extends $M {
    constructor(E) {
      super(E), this.Outer = E, this.type = 807026263;
    }
  }
  e.IfcFacetedBrep = sk;
  class DK extends sk {
    constructor(E, g) {
      super(E), this.Outer = E, this.Voids = g, this.type = 3737207727;
    }
  }
  e.IfcFacetedBrepWithVoids = DK;
  class fS extends dS {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.LongName = q, this.CompositionType = se, this.type = 24185140;
    }
  }
  e.IfcFacility = fS;
  class IS extends dS {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.LongName = q, this.CompositionType = se, this.UsageType = qe, this.type = 1310830890;
    }
  }
  e.IfcFacilityPart = IS;
  class CK extends IS {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi) {
      super(E, g, T, b, _, H, V, q, se, qe), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.LongName = q, this.CompositionType = se, this.UsageType = qe, this.PredefinedType = vi, this.type = 4228831410;
    }
  }
  e.IfcFacilityPartCommon = CK;
  class OK extends jf {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 647756555;
    }
  }
  e.IfcFastener = OK;
  class LK extends Wf {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 2489546625;
    }
  }
  e.IfcFastenerType = LK;
  class E7 extends kc {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.type = 2827207264;
    }
  }
  e.IfcFeatureElement = E7;
  class ok extends E7 {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.type = 2143335405;
    }
  }
  e.IfcFeatureElementAddition = ok;
  class nT extends E7 {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.type = 1287392070;
    }
  }
  e.IfcFeatureElementSubtraction = nT;
  class WI extends AE {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.type = 3907093117;
    }
  }
  e.IfcFlowControllerType = WI;
  class fR extends AE {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.type = 3198132628;
    }
  }
  e.IfcFlowFittingType = fR;
  class _K extends WI {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 3815607619;
    }
  }
  e.IfcFlowMeterType = _K;
  class z6 extends AE {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.type = 1482959167;
    }
  }
  e.IfcFlowMovingDeviceType = z6;
  class pS extends AE {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.type = 1834744321;
    }
  }
  e.IfcFlowSegmentType = pS;
  class f9 extends AE {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.type = 1339347760;
    }
  }
  e.IfcFlowStorageDeviceType = f9;
  class Vc extends AE {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.type = 2297155007;
    }
  }
  e.IfcFlowTerminalType = Vc;
  class mS extends AE {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.type = 3009222698;
    }
  }
  e.IfcFlowTreatmentDeviceType = mS;
  class xK extends hr {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1893162501;
    }
  }
  e.IfcFootingType = xK;
  class I9 extends kc {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.type = 263784265;
    }
  }
  e.IfcFurnishingElement = I9;
  class PK extends I9 {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 1509553395;
    }
  }
  e.IfcFurniture = PK;
  class MK extends kc {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3493046030;
    }
  }
  e.IfcGeographicElement = MK;
  class g7 extends kc {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.type = 4230923436;
    }
  }
  e.IfcGeotechnicalElement = g7;
  class UK extends g7 {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 1594536857;
    }
  }
  e.IfcGeotechnicalStratum = UK;
  class BK extends m7 {
    constructor(E, g, T, b) {
      super(E, g), this.Segments = E, this.SelfIntersect = g, this.BaseCurve = T, this.EndPoint = b, this.type = 2898700619;
    }
  }
  e.IfcGradientCurve = BK;
  class bE extends dR {
    constructor(E, g, T, b, _) {
      super(E, g, T, b, _), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.type = 2706460486;
    }
  }
  e.IfcGroup = bE;
  class FK extends ha {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1251058090;
    }
  }
  e.IfcHeatExchangerType = FK;
  class j6 extends ha {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1806887404;
    }
  }
  e.IfcHumidifierType = j6;
  class HK extends jf {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 2568555532;
    }
  }
  e.IfcImpactProtectionDevice = HK;
  class GK extends Wf {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 3948183225;
    }
  }
  e.IfcImpactProtectionDeviceType = GK;
  class kK extends hS {
    constructor(E, g, T) {
      super(), this.Points = E, this.Segments = g, this.SelfIntersect = T, this.type = 2571569899;
    }
  }
  e.IfcIndexedPolyCurve = kK;
  class VK extends mS {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 3946677679;
    }
  }
  e.IfcInterceptorType = VK;
  class zK extends n9 {
    constructor(E, g, T) {
      super(E, g, T), this.Curve3D = E, this.AssociatedGeometry = g, this.MasterRepresentation = T, this.type = 3113134337;
    }
  }
  e.IfcIntersectionCurve = zK;
  class jK extends bE {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi) {
      super(E, g, T, b, _), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.PredefinedType = H, this.Jurisdiction = V, this.ResponsiblePersons = q, this.LastUpdateDate = se, this.CurrentValue = qe, this.OriginalValue = vi, this.type = 2391368822;
    }
  }
  e.IfcInventory = jK;
  class WK extends fR {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 4288270099;
    }
  }
  e.IfcJunctionBoxType = WK;
  class YK extends hr {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.Mountable = qe, this.type = 679976338;
    }
  }
  e.IfcKerbType = YK;
  class qK extends iT {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi) {
      super(E, g, T, b, _, H, V, q, se, qe), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.Identification = H, this.LongDescription = V, this.Usage = q, this.BaseCosts = se, this.BaseQuantity = qe, this.PredefinedType = vi, this.type = 3827777499;
    }
  }
  e.IfcLaborResource = qK;
  class rk extends Vc {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1051575348;
    }
  }
  e.IfcLampType = rk;
  class $K extends Vc {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1161773419;
    }
  }
  e.IfcLightFixtureType = $K;
  class W6 extends ow {
    constructor(E, g, T, b, _, H, V) {
      super(E, g, T, b, _, H, V), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.type = 2176059722;
    }
  }
  e.IfcLinearElement = W6;
  class KK extends Vc {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1770583370;
    }
  }
  e.IfcLiquidTerminalType = KK;
  class ZK extends fS {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.LongName = q, this.CompositionType = se, this.PredefinedType = qe, this.type = 525669439;
    }
  }
  e.IfcMarineFacility = ZK;
  class QK extends IS {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi) {
      super(E, g, T, b, _, H, V, q, se, qe), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.LongName = q, this.CompositionType = se, this.UsageType = qe, this.PredefinedType = vi, this.type = 976884017;
    }
  }
  e.IfcMarinePart = QK;
  class JK extends jf {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.NominalDiameter = se, this.NominalLength = qe, this.PredefinedType = vi, this.type = 377706215;
    }
  }
  e.IfcMechanicalFastener = JK;
  class XK extends Wf {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.NominalDiameter = vi, this.NominalLength = In, this.type = 2108223431;
    }
  }
  e.IfcMechanicalFastenerType = XK;
  class eZ extends Vc {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1114901282;
    }
  }
  e.IfcMedicalDeviceType = eZ;
  class tZ extends hr {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 3181161470;
    }
  }
  e.IfcMemberType = tZ;
  class iZ extends Vc {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1950438474;
    }
  }
  e.IfcMobileTelecommunicationsApplianceType = iZ;
  class p9 extends hr {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 710110818;
    }
  }
  e.IfcMooringDeviceType = p9;
  class Dr extends ha {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 977012517;
    }
  }
  e.IfcMotorConnectionType = Dr;
  class IR extends hr {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 506776471;
    }
  }
  e.IfcNavigationElementType = IR;
  class dw extends V6 {
    constructor(E, g, T, b, _, H, V) {
      super(E, g, T, b, _, H), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.TheActor = H, this.PredefinedType = V, this.type = 4143007308;
    }
  }
  e.IfcOccupant = dw;
  class pR extends nT {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3588315303;
    }
  }
  e.IfcOpeningElement = pR;
  class w7 extends Vc {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 2837617999;
    }
  }
  e.IfcOutletType = w7;
  class mR extends hr {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 514975943;
    }
  }
  e.IfcPavementType = mR;
  class ty extends uw {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.Identification = H, this.LifeCyclePhase = V, this.PredefinedType = q, this.type = 2382730787;
    }
  }
  e.IfcPerformanceHistory = ty;
  class YI extends J3 {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.OperationType = _, this.PanelPosition = H, this.FrameDepth = V, this.FrameThickness = q, this.ShapeAspectStyle = se, this.type = 3566463478;
    }
  }
  e.IfcPermeableCoveringProperties = YI;
  class NE extends uw {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.Identification = H, this.PredefinedType = V, this.Status = q, this.LongDescription = se, this.type = 3327091369;
    }
  }
  e.IfcPermit = NE;
  class sT extends d9 {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1158309216;
    }
  }
  e.IfcPileType = sT;
  class cw extends fR {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 804291784;
    }
  }
  e.IfcPipeFittingType = cw;
  class yS extends pS {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 4231323485;
    }
  }
  e.IfcPipeSegmentType = yS;
  class Y6 extends hr {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 4017108033;
    }
  }
  e.IfcPlateType = Y6;
  class hw extends I7 {
    constructor(E, g, T, b) {
      super(E, g), this.Coordinates = E, this.Closed = g, this.Faces = T, this.PnIndex = b, this.type = 2839578677;
    }
  }
  e.IfcPolygonalFaceSet = hw;
  class Cr extends hS {
    constructor(E) {
      super(), this.Points = E, this.type = 3724593414;
    }
  }
  e.IfcPolyline = Cr;
  class fw extends ow {
    constructor(E, g, T, b, _, H, V) {
      super(E, g, T, b, _, H, V), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.type = 3740093272;
    }
  }
  e.IfcPort = fw;
  class Iw extends ow {
    constructor(E, g, T, b, _, H, V) {
      super(E, g, T, b, _, H, V), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.type = 1946335990;
    }
  }
  e.IfcPositioningElement = Iw;
  class q6 extends jI {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.Identification = H, this.LongDescription = V, this.PredefinedType = q, this.type = 2744685151;
    }
  }
  e.IfcProcedure = q6;
  class T7 extends uw {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.Identification = H, this.PredefinedType = V, this.Status = q, this.LongDescription = se, this.type = 2904328755;
    }
  }
  e.IfcProjectOrder = T7;
  class oT extends ok {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3651124850;
    }
  }
  e.IfcProjectionElement = oT;
  class rT extends WI {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1842657554;
    }
  }
  e.IfcProtectiveDeviceType = rT;
  class ES extends z6 {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 2250791053;
    }
  }
  e.IfcPumpType = ES;
  class lT extends hr {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1763565496;
    }
  }
  e.IfcRailType = lT;
  class yR extends hr {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 2893384427;
    }
  }
  e.IfcRailingType = yR;
  class DE extends fS {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.LongName = q, this.CompositionType = se, this.PredefinedType = qe, this.type = 3992365140;
    }
  }
  e.IfcRailway = DE;
  class $6 extends IS {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi) {
      super(E, g, T, b, _, H, V, q, se, qe), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.LongName = q, this.CompositionType = se, this.UsageType = qe, this.PredefinedType = vi, this.type = 1891881377;
    }
  }
  e.IfcRailwayPart = $6;
  class Xu extends hr {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 2324767716;
    }
  }
  e.IfcRampFlightType = Xu;
  class CE extends hr {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1469900589;
    }
  }
  e.IfcRampType = CE;
  class gS extends XG {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In, gs) {
      super(E, g, T, b, _, H, V, q, se, qe, vi, In), this.UDegree = E, this.VDegree = g, this.ControlPointsList = T, this.SurfaceForm = b, this.UClosed = _, this.VClosed = H, this.SelfIntersect = V, this.UMultiplicities = q, this.VMultiplicities = se, this.UKnots = qe, this.VKnots = vi, this.KnotSpec = In, this.WeightsData = gs, this.type = 683857671;
    }
  }
  e.IfcRationalBSplineSurfaceWithKnots = gS;
  class ER extends Iw {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.PredefinedType = q, this.type = 4021432810;
    }
  }
  e.IfcReferent = ER;
  class T0 extends jf {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.SteelGrade = se, this.type = 3027567501;
    }
  }
  e.IfcReinforcingElement = T0;
  class iy extends Wf {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.type = 964333572;
    }
  }
  e.IfcReinforcingElementType = iy;
  class gR extends T0 {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In, gs, $r, $d, N0, Dm, nb) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.SteelGrade = se, this.MeshLength = qe, this.MeshWidth = vi, this.LongitudinalBarNominalDiameter = In, this.TransverseBarNominalDiameter = gs, this.LongitudinalBarCrossSectionArea = $r, this.TransverseBarCrossSectionArea = $d, this.LongitudinalBarSpacing = N0, this.TransverseBarSpacing = Dm, this.PredefinedType = nb, this.type = 2320036040;
    }
  }
  e.IfcReinforcingMesh = gR;
  class ny extends iy {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In, gs, $r, $d, N0, Dm, nb, xk, Pk) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.MeshLength = vi, this.MeshWidth = In, this.LongitudinalBarNominalDiameter = gs, this.TransverseBarNominalDiameter = $r, this.LongitudinalBarCrossSectionArea = $d, this.TransverseBarCrossSectionArea = N0, this.LongitudinalBarSpacing = Dm, this.TransverseBarSpacing = nb, this.BendingShapeCode = xk, this.BendingParameters = Pk, this.type = 2310774935;
    }
  }
  e.IfcReinforcingMeshType = ny;
  class fm extends lS {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatingElement = _, this.RelatedSurfaceFeatures = H, this.type = 3818125796;
    }
  }
  e.IfcRelAdheresToElement = fm;
  class fn extends lS {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.RelatingObject = _, this.RelatedObjects = H, this.type = 160246688;
    }
  }
  e.IfcRelAggregates = fn;
  class R7 extends fS {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.LongName = q, this.CompositionType = se, this.PredefinedType = qe, this.type = 146592293;
    }
  }
  e.IfcRoad = R7;
  class Sh extends IS {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi) {
      super(E, g, T, b, _, H, V, q, se, qe), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.LongName = q, this.CompositionType = se, this.UsageType = qe, this.PredefinedType = vi, this.type = 550521510;
    }
  }
  e.IfcRoadPart = Sh;
  class wR extends hr {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 2781568857;
    }
  }
  e.IfcRoofType = wR;
  class ms extends Vc {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1768891740;
    }
  }
  e.IfcSanitaryTerminalType = ms;
  class v7 extends n9 {
    constructor(E, g, T) {
      super(E, g, T), this.Curve3D = E, this.AssociatedGeometry = g, this.MasterRepresentation = T, this.type = 2157484638;
    }
  }
  e.IfcSeamCurve = v7;
  class A7 extends eT {
    constructor(E, g, T, b) {
      super(E), this.Position = E, this.QuadraticTerm = g, this.LinearTerm = T, this.ConstantTerm = b, this.type = 3649235739;
    }
  }
  e.IfcSecondOrderPolynomialSpiral = A7;
  class Im extends m7 {
    constructor(E, g, T, b) {
      super(E, g), this.Segments = E, this.SelfIntersect = g, this.BaseCurve = T, this.EndPoint = b, this.type = 544395925;
    }
  }
  e.IfcSegmentedReferenceCurve = Im;
  class aT extends eT {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E), this.Position = E, this.SepticTerm = g, this.SexticTerm = T, this.QuinticTerm = b, this.QuarticTerm = _, this.CubicTerm = H, this.QuadraticTerm = V, this.LinearTerm = q, this.ConstantTerm = se, this.type = 1027922057;
    }
  }
  e.IfcSeventhOrderPolynomialSpiral = aT;
  class TR extends hr {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 4074543187;
    }
  }
  e.IfcShadingDeviceType = TR;
  class OE extends jf {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 33720170;
    }
  }
  e.IfcSign = OE;
  class qI extends Wf {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 3599934289;
    }
  }
  e.IfcSignType = qI;
  class $I extends Vc {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1894708472;
    }
  }
  e.IfcSignalType = $I;
  class Or extends eT {
    constructor(E, g, T, b) {
      super(E), this.Position = E, this.SineTerm = g, this.LinearTerm = T, this.ConstantTerm = b, this.type = 42703149;
    }
  }
  e.IfcSineSpiral = Or;
  class sy extends dS {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In, gs, $r) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.LongName = q, this.CompositionType = se, this.RefLatitude = qe, this.RefLongitude = vi, this.RefElevation = In, this.LandTitleNumber = gs, this.SiteAddress = $r, this.type = 4097777520;
    }
  }
  e.IfcSite = sy;
  class RR extends hr {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 2533589738;
    }
  }
  e.IfcSlabType = RR;
  class uT extends ha {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1072016465;
    }
  }
  e.IfcSolarDeviceType = uT;
  class zr extends dS {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.LongName = q, this.CompositionType = se, this.PredefinedType = qe, this.ElevationWithFlooring = vi, this.type = 3856911033;
    }
  }
  e.IfcSpace = zr;
  class K6 extends Vc {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1305183839;
    }
  }
  e.IfcSpaceHeaterType = K6;
  class KI extends G6 {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.LongName = vi, this.type = 3812236995;
    }
  }
  e.IfcSpaceType = KI;
  class pw extends Vc {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 3112655638;
    }
  }
  e.IfcStackTerminalType = pw;
  class S7 extends hr {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1039846685;
    }
  }
  e.IfcStairFlightType = S7;
  class vR extends hr {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 338393293;
    }
  }
  e.IfcStairType = vR;
  class pm extends i9 {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.AppliedLoad = q, this.GlobalOrLocal = se, this.DestabilizingLoad = qe, this.type = 682877961;
    }
  }
  e.IfcStructuralAction = pm;
  class LE extends lw {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.AppliedCondition = q, this.type = 1179482911;
    }
  }
  e.IfcStructuralConnection = LE;
  class Yf extends pm {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In) {
      super(E, g, T, b, _, H, V, q, se, qe), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.AppliedLoad = q, this.GlobalOrLocal = se, this.DestabilizingLoad = qe, this.ProjectedOrTrue = vi, this.PredefinedType = In, this.type = 1004757350;
    }
  }
  e.IfcStructuralCurveAction = Yf;
  class Z6 extends LE {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.AppliedCondition = q, this.AxisDirection = se, this.type = 4243806635;
    }
  }
  e.IfcStructuralCurveConnection = Z6;
  class Lr extends vE {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.PredefinedType = q, this.Axis = se, this.type = 214636428;
    }
  }
  e.IfcStructuralCurveMember = Lr;
  class _E extends Lr {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.PredefinedType = q, this.Axis = se, this.type = 2445595289;
    }
  }
  e.IfcStructuralCurveMemberVarying = _E;
  class ZI extends h7 {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.AppliedLoad = q, this.GlobalOrLocal = se, this.PredefinedType = qe, this.type = 2757150158;
    }
  }
  e.IfcStructuralCurveReaction = ZI;
  class mw extends Yf {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In) {
      super(E, g, T, b, _, H, V, q, se, qe, vi, In), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.AppliedLoad = q, this.GlobalOrLocal = se, this.DestabilizingLoad = qe, this.ProjectedOrTrue = vi, this.PredefinedType = In, this.type = 1807405624;
    }
  }
  e.IfcStructuralLinearAction = mw;
  class mm extends bE {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.PredefinedType = H, this.ActionType = V, this.ActionSource = q, this.Coefficient = se, this.Purpose = qe, this.type = 1252848954;
    }
  }
  e.IfcStructuralLoadGroup = mm;
  class yw extends pm {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se, qe), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.AppliedLoad = q, this.GlobalOrLocal = se, this.DestabilizingLoad = qe, this.type = 2082059205;
    }
  }
  e.IfcStructuralPointAction = yw;
  class Ew extends LE {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.AppliedCondition = q, this.ConditionCoordinateSystem = se, this.type = 734778138;
    }
  }
  e.IfcStructuralPointConnection = Ew;
  class wS extends h7 {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.AppliedLoad = q, this.GlobalOrLocal = se, this.type = 1235345126;
    }
  }
  e.IfcStructuralPointReaction = wS;
  class Au extends bE {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.TheoryType = H, this.ResultForLoadGroup = V, this.IsLinear = q, this.type = 2986769608;
    }
  }
  e.IfcStructuralResultGroup = Au;
  class R0 extends pm {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In) {
      super(E, g, T, b, _, H, V, q, se, qe), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.AppliedLoad = q, this.GlobalOrLocal = se, this.DestabilizingLoad = qe, this.ProjectedOrTrue = vi, this.PredefinedType = In, this.type = 3657597509;
    }
  }
  e.IfcStructuralSurfaceAction = R0;
  class dT extends LE {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.AppliedCondition = q, this.type = 1975003073;
    }
  }
  e.IfcStructuralSurfaceConnection = dT;
  class AR extends iT {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi) {
      super(E, g, T, b, _, H, V, q, se, qe), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.Identification = H, this.LongDescription = V, this.Usage = q, this.BaseCosts = se, this.BaseQuantity = qe, this.PredefinedType = vi, this.type = 148013059;
    }
  }
  e.IfcSubContractResource = AR;
  class qf extends E7 {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3101698114;
    }
  }
  e.IfcSurfaceFeature = qf;
  class cT extends WI {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 2315554128;
    }
  }
  e.IfcSwitchingDeviceType = cT;
  class QI extends bE {
    constructor(E, g, T, b, _) {
      super(E, g, T, b, _), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.type = 2254336722;
    }
  }
  e.IfcSystem = QI;
  class Er extends I9 {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 413509423;
    }
  }
  e.IfcSystemFurnitureElement = Er;
  class hT extends f9 {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 5716631;
    }
  }
  e.IfcTankType = hT;
  class SR extends T0 {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In, gs, $r, $d, N0, Dm) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.SteelGrade = se, this.PredefinedType = qe, this.NominalDiameter = vi, this.CrossSectionArea = In, this.TensionForce = gs, this.PreStress = $r, this.FrictionCoefficient = $d, this.AnchorageSlip = N0, this.MinCurvatureRadius = Dm, this.type = 3824725483;
    }
  }
  e.IfcTendon = SR;
  class b7 extends T0 {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.SteelGrade = se, this.PredefinedType = qe, this.type = 2347447852;
    }
  }
  e.IfcTendonAnchor = b7;
  class xE extends iy {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 3081323446;
    }
  }
  e.IfcTendonAnchorType = xE;
  class Q6 extends T0 {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.SteelGrade = se, this.PredefinedType = qe, this.type = 3663046924;
    }
  }
  e.IfcTendonConduit = Q6;
  class TS extends iy {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 2281632017;
    }
  }
  e.IfcTendonConduitType = TS;
  class JI extends iy {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In, gs) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.NominalDiameter = vi, this.CrossSectionArea = In, this.SheathDiameter = gs, this.type = 2415094496;
    }
  }
  e.IfcTendonType = JI;
  class RS extends hr {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 618700268;
    }
  }
  e.IfcTrackElementType = RS;
  class fT extends ha {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1692211062;
    }
  }
  e.IfcTransformerType = fT;
  class J6 extends tT {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 2097647324;
    }
  }
  e.IfcTransportElementType = J6;
  class Md extends kc {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.type = 1953115116;
    }
  }
  e.IfcTransportationDevice = Md;
  class bR extends hS {
    constructor(E, g, T, b, _) {
      super(), this.BasisCurve = E, this.Trim1 = g, this.Trim2 = T, this.SenseAgreement = b, this.MasterRepresentation = _, this.type = 3593883385;
    }
  }
  e.IfcTrimmedCurve = bR;
  class m9 extends ha {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1600972822;
    }
  }
  e.IfcTubeBundleType = m9;
  class PE extends ha {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1911125066;
    }
  }
  e.IfcUnitaryEquipmentType = PE;
  class ME extends WI {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 728799441;
    }
  }
  e.IfcValveType = ME;
  class oy extends Md {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 840318589;
    }
  }
  e.IfcVehicle = oy;
  class NR extends jf {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 1530820697;
    }
  }
  e.IfcVibrationDamper = NR;
  class IT extends Wf {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 3956297820;
    }
  }
  e.IfcVibrationDamperType = IT;
  class X6 extends jf {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 2391383451;
    }
  }
  e.IfcVibrationIsolator = X6;
  class pT extends Wf {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 3313531582;
    }
  }
  e.IfcVibrationIsolatorType = pT;
  class DR extends kc {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 2769231204;
    }
  }
  e.IfcVirtualElement = DR;
  class ry extends nT {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 926996030;
    }
  }
  e.IfcVoidingFeature = ry;
  class mT extends hr {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1898987631;
    }
  }
  e.IfcWallType = mT;
  class vS extends Vc {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1133259667;
    }
  }
  e.IfcWasteTerminalType = vS;
  class ly extends hr {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In, gs) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.PartitioningType = vi, this.ParameterTakesPrecedence = In, this.UserDefinedPartitioningType = gs, this.type = 4009809668;
    }
  }
  e.IfcWindowType = ly;
  class N7 extends uw {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.Identification = H, this.WorkingTimes = V, this.ExceptionTimes = q, this.PredefinedType = se, this.type = 4088093105;
    }
  }
  e.IfcWorkCalendar = N7;
  class ay extends uw {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In, gs) {
      super(E, g, T, b, _, H), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.Identification = H, this.CreationDate = V, this.Creators = q, this.Purpose = se, this.Duration = qe, this.TotalFloat = vi, this.StartTime = In, this.FinishTime = gs, this.type = 1028945134;
    }
  }
  e.IfcWorkControl = ay;
  class gw extends ay {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In, gs, $r) {
      super(E, g, T, b, _, H, V, q, se, qe, vi, In, gs), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.Identification = H, this.CreationDate = V, this.Creators = q, this.Purpose = se, this.Duration = qe, this.TotalFloat = vi, this.StartTime = In, this.FinishTime = gs, this.PredefinedType = $r, this.type = 4218914973;
    }
  }
  e.IfcWorkPlan = gw;
  class D7 extends ay {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In, gs, $r) {
      super(E, g, T, b, _, H, V, q, se, qe, vi, In, gs), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.Identification = H, this.CreationDate = V, this.Creators = q, this.Purpose = se, this.Duration = qe, this.TotalFloat = vi, this.StartTime = In, this.FinishTime = gs, this.PredefinedType = $r, this.type = 3342526732;
    }
  }
  e.IfcWorkSchedule = D7;
  class uy extends QI {
    constructor(E, g, T, b, _, H) {
      super(E, g, T, b, _), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.LongName = H, this.type = 1033361043;
    }
  }
  e.IfcZone = uy;
  class UE extends uw {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.Identification = H, this.PredefinedType = V, this.Status = q, this.LongDescription = se, this.type = 3821786052;
    }
  }
  e.IfcActionRequest = UE;
  class ww extends WI {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1411407467;
    }
  }
  e.IfcAirTerminalBoxType = ww;
  class Tw extends Vc {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 3352864051;
    }
  }
  e.IfcAirTerminalType = Tw;
  class AS extends ha {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1871374353;
    }
  }
  e.IfcAirToAirHeatRecoveryType = AS;
  class BE extends W6 {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.RailHeadDistance = q, this.type = 4266260250;
    }
  }
  e.IfcAlignmentCant = BE;
  class ym extends W6 {
    constructor(E, g, T, b, _, H, V) {
      super(E, g, T, b, _, H, V), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.type = 1545765605;
    }
  }
  e.IfcAlignmentHorizontal = ym;
  class dy extends W6 {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.DesignParameters = q, this.type = 317615605;
    }
  }
  e.IfcAlignmentSegment = dy;
  class C7 extends W6 {
    constructor(E, g, T, b, _, H, V) {
      super(E, g, T, b, _, H, V), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.type = 1662888072;
    }
  }
  e.IfcAlignmentVertical = C7;
  class FE extends bE {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In, gs, $r) {
      super(E, g, T, b, _), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.Identification = H, this.OriginalValue = V, this.CurrentValue = q, this.TotalReplacementCost = se, this.Owner = qe, this.User = vi, this.ResponsiblePerson = In, this.IncorporationDate = gs, this.DepreciatedValue = $r, this.type = 3460190687;
    }
  }
  e.IfcAsset = FE;
  class O7 extends Vc {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1532957894;
    }
  }
  e.IfcAudioVisualApplianceType = O7;
  class cl extends hS {
    constructor(E, g, T, b, _) {
      super(), this.Degree = E, this.ControlPointsList = g, this.CurveForm = T, this.ClosedCurve = b, this.SelfIntersect = _, this.type = 1967976161;
    }
  }
  e.IfcBSplineCurve = cl;
  class zc extends cl {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _), this.Degree = E, this.ControlPointsList = g, this.CurveForm = T, this.ClosedCurve = b, this.SelfIntersect = _, this.KnotMultiplicities = H, this.Knots = V, this.KnotSpec = q, this.type = 2461110595;
    }
  }
  e.IfcBSplineCurveWithKnots = zc;
  class Ud extends hr {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 819618141;
    }
  }
  e.IfcBeamType = Ud;
  class or extends hr {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 3649138523;
    }
  }
  e.IfcBearingType = or;
  class $f extends ha {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 231477066;
    }
  }
  e.IfcBoilerType = $f;
  class eD extends tk {
    constructor(E, g) {
      super(E, g), this.Segments = E, this.SelfIntersect = g, this.type = 1136057603;
    }
  }
  e.IfcBoundaryCurve = eD;
  class jc extends fS {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.LongName = q, this.CompositionType = se, this.PredefinedType = qe, this.type = 644574406;
    }
  }
  e.IfcBridge = jc;
  class CR extends IS {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi) {
      super(E, g, T, b, _, H, V, q, se, qe), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.LongName = q, this.CompositionType = se, this.UsageType = qe, this.PredefinedType = vi, this.type = 963979645;
    }
  }
  e.IfcBridgePart = CR;
  class cy extends fS {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.LongName = q, this.CompositionType = se, this.ElevationOfRefHeight = qe, this.ElevationOfTerrain = vi, this.BuildingAddress = In, this.type = 4031249490;
    }
  }
  e.IfcBuilding = cy;
  class OR extends jf {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 2979338954;
    }
  }
  e.IfcBuildingElementPart = OR;
  class HE extends Wf {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 39481116;
    }
  }
  e.IfcBuildingElementPartType = HE;
  class Rw extends hr {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1909888760;
    }
  }
  e.IfcBuildingElementProxyType = Rw;
  class hy extends QI {
    constructor(E, g, T, b, _, H, V) {
      super(E, g, T, b, _), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.PredefinedType = H, this.LongName = V, this.type = 1177604601;
    }
  }
  e.IfcBuildingSystem = hy;
  class zo extends kc {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.type = 1876633798;
    }
  }
  e.IfcBuiltElement = zo;
  class yT extends QI {
    constructor(E, g, T, b, _, H, V) {
      super(E, g, T, b, _), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.PredefinedType = H, this.LongName = V, this.type = 3862327254;
    }
  }
  e.IfcBuiltSystem = yT;
  class vw extends ha {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 2188180465;
    }
  }
  e.IfcBurnerType = vw;
  class Bd extends fR {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 395041908;
    }
  }
  e.IfcCableCarrierFittingType = Bd;
  class LR extends pS {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 3293546465;
    }
  }
  e.IfcCableCarrierSegmentType = LR;
  class Aw extends fR {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 2674252688;
    }
  }
  e.IfcCableFittingType = Aw;
  class _R extends pS {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1285652485;
    }
  }
  e.IfcCableSegmentType = _R;
  class tD extends d9 {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 3203706013;
    }
  }
  e.IfcCaissonFoundationType = tD;
  class fy extends ha {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 2951183804;
    }
  }
  e.IfcChillerType = fy;
  class GE extends zo {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3296154744;
    }
  }
  e.IfcChimney = GE;
  class ET extends u9 {
    constructor(E, g) {
      super(E), this.Position = E, this.Radius = g, this.type = 2611217952;
    }
  }
  e.IfcCircle = ET;
  class gT extends kc {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.type = 1677625105;
    }
  }
  e.IfcCivilElement = gT;
  class SS extends ha {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 2301859152;
    }
  }
  e.IfcCoilType = SS;
  class bh extends zo {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 843113511;
    }
  }
  e.IfcColumn = bh;
  class bS extends Vc {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 400855858;
    }
  }
  e.IfcCommunicationsApplianceType = bS;
  class Sw extends z6 {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 3850581409;
    }
  }
  e.IfcCompressorType = Sw;
  class wT extends ha {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 2816379211;
    }
  }
  e.IfcCondenserType = wT;
  class xR extends iT {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi) {
      super(E, g, T, b, _, H, V, q, se, qe), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.Identification = H, this.LongDescription = V, this.Usage = q, this.BaseCosts = se, this.BaseQuantity = qe, this.PredefinedType = vi, this.type = 3898045240;
    }
  }
  e.IfcConstructionEquipmentResource = xR;
  class NS extends iT {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi) {
      super(E, g, T, b, _, H, V, q, se, qe), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.Identification = H, this.LongDescription = V, this.Usage = q, this.BaseCosts = se, this.BaseQuantity = qe, this.PredefinedType = vi, this.type = 1060000209;
    }
  }
  e.IfcConstructionMaterialResource = NS;
  class PR extends iT {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi) {
      super(E, g, T, b, _, H, V, q, se, qe), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.Identification = H, this.LongDescription = V, this.Usage = q, this.BaseCosts = se, this.BaseQuantity = qe, this.PredefinedType = vi, this.type = 488727124;
    }
  }
  e.IfcConstructionProductResource = PR;
  class iD extends pS {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 2940368186;
    }
  }
  e.IfcConveyorSegmentType = iD;
  class nD extends ha {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 335055490;
    }
  }
  e.IfcCooledBeamType = nD;
  class rr extends ha {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 2954562838;
    }
  }
  e.IfcCoolingTowerType = rr;
  class TT extends zo {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 1502416096;
    }
  }
  e.IfcCourse = TT;
  class yl extends zo {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 1973544240;
    }
  }
  e.IfcCovering = yl;
  class DS extends zo {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3495092785;
    }
  }
  e.IfcCurtainWall = DS;
  class bw extends WI {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 3961806047;
    }
  }
  e.IfcDamperType = bw;
  class v0 extends zo {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.type = 3426335179;
    }
  }
  e.IfcDeepFoundation = v0;
  class Ml extends jf {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 1335981549;
    }
  }
  e.IfcDiscreteAccessory = Ml;
  class RT extends Wf {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 2635815018;
    }
  }
  e.IfcDiscreteAccessoryType = RT;
  class kE extends WI {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 479945903;
    }
  }
  e.IfcDistributionBoardType = kE;
  class XI extends AE {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1599208980;
    }
  }
  e.IfcDistributionChamberElementType = XI;
  class Kf extends y7 {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.type = 2063403501;
    }
  }
  e.IfcDistributionControlElementType = Kf;
  class ye extends kc {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.type = 1945004755;
    }
  }
  e.IfcDistributionElement = ye;
  class D extends ye {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.type = 3040386961;
    }
  }
  e.IfcDistributionFlowElement = D;
  class M extends fw {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.FlowDirection = q, this.PredefinedType = se, this.SystemType = qe, this.type = 3041715199;
    }
  }
  e.IfcDistributionPort = M;
  class k extends QI {
    constructor(E, g, T, b, _, H, V) {
      super(E, g, T, b, _), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.LongName = H, this.PredefinedType = V, this.type = 3205830791;
    }
  }
  e.IfcDistributionSystem = k;
  class $ extends zo {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In, gs) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.OverallHeight = se, this.OverallWidth = qe, this.PredefinedType = vi, this.OperationType = In, this.UserDefinedOperationType = gs, this.type = 395920057;
    }
  }
  e.IfcDoor = $;
  class J extends fR {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 869906466;
    }
  }
  e.IfcDuctFittingType = J;
  class ue extends pS {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 3760055223;
    }
  }
  e.IfcDuctSegmentType = ue;
  class Ie extends mS {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 2030761528;
    }
  }
  e.IfcDuctSilencerType = Ie;
  class ve extends nT {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3071239417;
    }
  }
  e.IfcEarthworksCut = ve;
  class Be extends zo {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.type = 1077100507;
    }
  }
  e.IfcEarthworksElement = Be;
  class bt extends Be {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3376911765;
    }
  }
  e.IfcEarthworksFill = bt;
  class ji extends Vc {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 663422040;
    }
  }
  e.IfcElectricApplianceType = ji;
  class xn extends WI {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 2417008758;
    }
  }
  e.IfcElectricDistributionBoardType = xn;
  class fs extends f9 {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 3277789161;
    }
  }
  e.IfcElectricFlowStorageDeviceType = fs;
  class Xs extends mS {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 2142170206;
    }
  }
  e.IfcElectricFlowTreatmentDeviceType = Xs;
  class jo extends ha {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1534661035;
    }
  }
  e.IfcElectricGeneratorType = jo;
  class Gs extends ha {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1217240411;
    }
  }
  e.IfcElectricMotorType = Gs;
  class Su extends WI {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 712377611;
    }
  }
  e.IfcElectricTimeControlType = Su;
  class Co extends D {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.type = 1658829314;
    }
  }
  e.IfcEnergyConversionDevice = Co;
  class Zf extends Co {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 2814081492;
    }
  }
  e.IfcEngine = Zf;
  class Em extends Co {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3747195512;
    }
  }
  e.IfcEvaporativeCooler = Em;
  class ep extends Co {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 484807127;
    }
  }
  e.IfcEvaporator = ep;
  class Fd extends nk {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.LongName = q, this.PredefinedType = se, this.type = 1209101575;
    }
  }
  e.IfcExternalSpatialElement = Fd;
  class Nh extends z6 {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 346874300;
    }
  }
  e.IfcFanType = Nh;
  class MR extends mS {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1810631287;
    }
  }
  e.IfcFilterType = MR;
  class vT extends Vc {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 4222183408;
    }
  }
  e.IfcFireSuppressionTerminalType = vT;
  class Dh extends D {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.type = 2058353004;
    }
  }
  e.IfcFlowController = Dh;
  class VE extends D {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.type = 4278956645;
    }
  }
  e.IfcFlowFitting = VE;
  class tp extends Kf {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 4037862832;
    }
  }
  e.IfcFlowInstrumentType = tp;
  class CS extends Dh {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 2188021234;
    }
  }
  e.IfcFlowMeter = CS;
  class Qf extends D {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.type = 3132237377;
    }
  }
  e.IfcFlowMovingDevice = Qf;
  class ip extends D {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.type = 987401354;
    }
  }
  e.IfcFlowSegment = ip;
  class gm extends D {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.type = 707683696;
    }
  }
  e.IfcFlowStorageDevice = gm;
  class bu extends D {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.type = 2223149337;
    }
  }
  e.IfcFlowTerminal = bu;
  class UR extends D {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.type = 3508470533;
    }
  }
  e.IfcFlowTreatmentDevice = UR;
  class L7 extends zo {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 900683007;
    }
  }
  e.IfcFooting = L7;
  class zE extends g7 {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.type = 2713699986;
    }
  }
  e.IfcGeotechnicalAssembly = zE;
  class AT extends Iw {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi) {
      super(E, g, T, b, _, H, V), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.UAxes = q, this.VAxes = se, this.WAxes = qe, this.PredefinedType = vi, this.type = 3009204131;
    }
  }
  e.IfcGrid = AT;
  class lk extends Co {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3319311131;
    }
  }
  e.IfcHeatExchanger = lk;
  class OS extends Co {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 2068733104;
    }
  }
  e.IfcHumidifier = OS;
  class LS extends UR {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 4175244083;
    }
  }
  e.IfcInterceptor = LS;
  class BR extends VE {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 2176052936;
    }
  }
  e.IfcJunctionBox = BR;
  class _S extends zo {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.Mountable = se, this.type = 2696325953;
    }
  }
  e.IfcKerb = _S;
  class sD extends bu {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 76236018;
    }
  }
  e.IfcLamp = sD;
  class oD extends bu {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 629592764;
    }
  }
  e.IfcLightFixture = oD;
  class y9 extends Iw {
    constructor(E, g, T, b, _, H, V) {
      super(E, g, T, b, _, H, V), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.type = 1154579445;
    }
  }
  e.IfcLinearPositioningElement = y9;
  class Nw extends bu {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 1638804497;
    }
  }
  e.IfcLiquidTerminal = Nw;
  class _7 extends bu {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 1437502449;
    }
  }
  e.IfcMedicalDevice = _7;
  class Jf extends zo {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 1073191201;
    }
  }
  e.IfcMember = Jf;
  class ak extends bu {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 2078563270;
    }
  }
  e.IfcMobileTelecommunicationsAppliance = ak;
  class Wc extends zo {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 234836483;
    }
  }
  e.IfcMooringDevice = Wc;
  class Dw extends Co {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 2474470126;
    }
  }
  e.IfcMotorConnection = Dw;
  class x7 extends zo {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 2182337498;
    }
  }
  e.IfcNavigationElement = x7;
  class rD extends eD {
    constructor(E, g) {
      super(E, g), this.Segments = E, this.SelfIntersect = g, this.type = 144952367;
    }
  }
  e.IfcOuterBoundaryCurve = rD;
  class jE extends bu {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3694346114;
    }
  }
  e.IfcOutlet = jE;
  class Iy extends zo {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 1383356374;
    }
  }
  e.IfcPavement = Iy;
  class P7 extends v0 {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.ConstructionType = qe, this.type = 1687234759;
    }
  }
  e.IfcPile = P7;
  class FR extends VE {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 310824031;
    }
  }
  e.IfcPipeFitting = FR;
  class M7 extends ip {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3612865200;
    }
  }
  e.IfcPipeSegment = M7;
  class lD extends zo {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3171933400;
    }
  }
  e.IfcPlate = lD;
  class uk extends Dh {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 738039164;
    }
  }
  e.IfcProtectiveDevice = uk;
  class Cw extends Kf {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 655969474;
    }
  }
  e.IfcProtectiveDeviceTrippingUnitType = Cw;
  class wm extends Qf {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 90941305;
    }
  }
  e.IfcPump = wm;
  class U7 extends zo {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3290496277;
    }
  }
  e.IfcRail = U7;
  class dk extends zo {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 2262370178;
    }
  }
  e.IfcRailing = dk;
  class B7 extends zo {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3024970846;
    }
  }
  e.IfcRamp = B7;
  class np extends zo {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3283111854;
    }
  }
  e.IfcRampFlight = np;
  class aD extends zc {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.Degree = E, this.ControlPointsList = g, this.CurveForm = T, this.ClosedCurve = b, this.SelfIntersect = _, this.KnotMultiplicities = H, this.Knots = V, this.KnotSpec = q, this.WeightsData = se, this.type = 1232101972;
    }
  }
  e.IfcRationalBSplineCurveWithKnots = aD;
  class ds extends Be {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3798194928;
    }
  }
  e.IfcReinforcedSoil = ds;
  class ck extends T0 {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In, gs, $r) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.SteelGrade = se, this.NominalDiameter = qe, this.CrossSectionArea = vi, this.BarLength = In, this.PredefinedType = gs, this.BarSurface = $r, this.type = 979691226;
    }
  }
  e.IfcReinforcingBar = ck;
  class uD extends iy {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In, gs, $r, $d, N0) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.NominalDiameter = vi, this.CrossSectionArea = In, this.BarLength = gs, this.BarSurface = $r, this.BendingShapeCode = $d, this.BendingParameters = N0, this.type = 2572171363;
    }
  }
  e.IfcReinforcingBarType = uD;
  class WE extends zo {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 2016517767;
    }
  }
  e.IfcRoof = WE;
  class xS extends bu {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3053780830;
    }
  }
  e.IfcSanitaryTerminal = xS;
  class Us extends Kf {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 1783015770;
    }
  }
  e.IfcSensorType = Us;
  class PS extends zo {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 1329646415;
    }
  }
  e.IfcShadingDevice = PS;
  class dD extends bu {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 991950508;
    }
  }
  e.IfcSignal = dD;
  class Ow extends zo {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 1529196076;
    }
  }
  e.IfcSlab = Ow;
  class F7 extends Co {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3420628829;
    }
  }
  e.IfcSolarDevice = F7;
  class Lw extends bu {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 1999602285;
    }
  }
  e.IfcSpaceHeater = Lw;
  class Hd extends bu {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 1404847402;
    }
  }
  e.IfcStackTerminal = Hd;
  class cD extends zo {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 331165859;
    }
  }
  e.IfcStair = cD;
  class Nu extends zo {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In, gs) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.NumberOfRisers = se, this.NumberOfTreads = qe, this.RiserHeight = vi, this.TreadLength = In, this.PredefinedType = gs, this.type = 4252922144;
    }
  }
  e.IfcStairFlight = Nu;
  class _w extends QI {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.PredefinedType = H, this.OrientationOf2DPlane = V, this.LoadedBy = q, this.HasResults = se, this.SharedPlacement = qe, this.type = 2515109513;
    }
  }
  e.IfcStructuralAnalysisModel = _w;
  class H7 extends mm {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi) {
      super(E, g, T, b, _, H, V, q, se, qe), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.PredefinedType = H, this.ActionType = V, this.ActionSource = q, this.Coefficient = se, this.Purpose = qe, this.SelfWeightCoefficients = vi, this.type = 385403989;
    }
  }
  e.IfcStructuralLoadCase = H7;
  class hD extends R0 {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In) {
      super(E, g, T, b, _, H, V, q, se, qe, vi, In), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.AppliedLoad = q, this.GlobalOrLocal = se, this.DestabilizingLoad = qe, this.ProjectedOrTrue = vi, this.PredefinedType = In, this.type = 1621171031;
    }
  }
  e.IfcStructuralPlanarAction = hD;
  class Gd extends Dh {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 1162798199;
    }
  }
  e.IfcSwitchingDevice = Gd;
  class MS extends gm {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 812556717;
    }
  }
  e.IfcTank = MS;
  class HR extends zo {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3425753595;
    }
  }
  e.IfcTrackElement = HR;
  class fD extends Co {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3825984169;
    }
  }
  e.IfcTransformer = fD;
  class GR extends Md {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 1620046519;
    }
  }
  e.IfcTransportElement = GR;
  class ID extends Co {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3026737570;
    }
  }
  e.IfcTubeBundle = ID;
  class py extends Kf {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 3179687236;
    }
  }
  e.IfcUnitaryControlElementType = py;
  class E9 extends Co {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 4292641817;
    }
  }
  e.IfcUnitaryEquipment = E9;
  class G7 extends Dh {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 4207607924;
    }
  }
  e.IfcValve = G7;
  class Tm extends zo {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 2391406946;
    }
  }
  e.IfcWall = Tm;
  class ST extends Tm {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3512223829;
    }
  }
  e.IfcWallStandardCase = ST;
  class US extends bu {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 4237592921;
    }
  }
  e.IfcWasteTerminal = US;
  class pD extends zo {
    constructor(E, g, T, b, _, H, V, q, se, qe, vi, In, gs) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.OverallHeight = se, this.OverallWidth = qe, this.PredefinedType = vi, this.PartitioningType = In, this.UserDefinedPartitioningType = gs, this.type = 3304561284;
    }
  }
  e.IfcWindow = pD;
  class BS extends Kf {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 2874132201;
    }
  }
  e.IfcActuatorType = BS;
  class xw extends bu {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 1634111441;
    }
  }
  e.IfcAirTerminal = xw;
  class mD extends Dh {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 177149247;
    }
  }
  e.IfcAirTerminalBox = mD;
  class bT extends Co {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 2056796094;
    }
  }
  e.IfcAirToAirHeatRecovery = bT;
  class kR extends Kf {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 3001207471;
    }
  }
  e.IfcAlarmType = kR;
  class k7 extends y9 {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.PredefinedType = q, this.type = 325726236;
    }
  }
  e.IfcAlignment = k7;
  class YE extends bu {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 277319702;
    }
  }
  e.IfcAudioVisualAppliance = YE;
  class FS extends zo {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 753842376;
    }
  }
  e.IfcBeam = FS;
  class VR extends zo {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 4196446775;
    }
  }
  e.IfcBearing = VR;
  class Pw extends Co {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 32344328;
    }
  }
  e.IfcBoiler = Pw;
  class g9 extends zE {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.type = 3314249567;
    }
  }
  e.IfcBorehole = g9;
  class Mw extends zo {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 1095909175;
    }
  }
  e.IfcBuildingElementProxy = Mw;
  class hk extends Co {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 2938176219;
    }
  }
  e.IfcBurner = hk;
  class HS extends VE {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 635142910;
    }
  }
  e.IfcCableCarrierFitting = HS;
  class V7 extends ip {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3758799889;
    }
  }
  e.IfcCableCarrierSegment = V7;
  class Ch extends VE {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 1051757585;
    }
  }
  e.IfcCableFitting = Ch;
  class GS extends ip {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 4217484030;
    }
  }
  e.IfcCableSegment = GS;
  class kS extends v0 {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3999819293;
    }
  }
  e.IfcCaissonFoundation = kS;
  class yD extends Co {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3902619387;
    }
  }
  e.IfcChiller = yD;
  class z7 extends Co {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 639361253;
    }
  }
  e.IfcCoil = z7;
  class j7 extends bu {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3221913625;
    }
  }
  e.IfcCommunicationsAppliance = j7;
  class fa extends Qf {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3571504051;
    }
  }
  e.IfcCompressor = fa;
  class my extends Co {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 2272882330;
    }
  }
  e.IfcCondenser = my;
  class w9 extends Kf {
    constructor(E, g, T, b, _, H, V, q, se, qe) {
      super(E, g, T, b, _, H, V, q, se), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ApplicableOccurrence = _, this.HasPropertySets = H, this.RepresentationMaps = V, this.Tag = q, this.ElementType = se, this.PredefinedType = qe, this.type = 578613899;
    }
  }
  e.IfcControllerType = w9;
  class W7 extends ip {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3460952963;
    }
  }
  e.IfcConveyorSegment = W7;
  class yy extends Co {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 4136498852;
    }
  }
  e.IfcCooledBeam = yy;
  class ED extends Co {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3640358203;
    }
  }
  e.IfcCoolingTower = ED;
  class gD extends Dh {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 4074379575;
    }
  }
  e.IfcDamper = gD;
  class wD extends Dh {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3693000487;
    }
  }
  e.IfcDistributionBoard = wD;
  class Rm extends D {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 1052013943;
    }
  }
  e.IfcDistributionChamberElement = Rm;
  class zR extends k {
    constructor(E, g, T, b, _, H, V) {
      super(E, g, T, b, _, H, V), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.LongName = H, this.PredefinedType = V, this.type = 562808652;
    }
  }
  e.IfcDistributionCircuit = zR;
  class Ia extends ye {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.type = 1062813311;
    }
  }
  e.IfcDistributionControlElement = Ia;
  class TD extends VE {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 342316401;
    }
  }
  e.IfcDuctFitting = TD;
  class nZ extends ip {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3518393246;
    }
  }
  e.IfcDuctSegment = nZ;
  class NT extends UR {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 1360408905;
    }
  }
  e.IfcDuctSilencer = NT;
  class sp extends bu {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 1904799276;
    }
  }
  e.IfcElectricAppliance = sp;
  class Uw extends Dh {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 862014818;
    }
  }
  e.IfcElectricDistributionBoard = Uw;
  class Y7 extends gm {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3310460725;
    }
  }
  e.IfcElectricFlowStorageDevice = Y7;
  class jR extends UR {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 24726584;
    }
  }
  e.IfcElectricFlowTreatmentDevice = jR;
  class fk extends Co {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 264262732;
    }
  }
  e.IfcElectricGenerator = fk;
  class RD extends Co {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 402227799;
    }
  }
  e.IfcElectricMotor = RD;
  class vD extends Dh {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 1003880860;
    }
  }
  e.IfcElectricTimeControl = vD;
  class T9 extends Qf {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3415622556;
    }
  }
  e.IfcFan = T9;
  class VS extends UR {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 819412036;
    }
  }
  e.IfcFilter = VS;
  class DT extends bu {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 1426591983;
    }
  }
  e.IfcFireSuppressionTerminal = DT;
  class Bw extends Ia {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 182646315;
    }
  }
  e.IfcFlowInstrument = Bw;
  class WR extends zE {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.type = 2680139844;
    }
  }
  e.IfcGeomodel = WR;
  class q7 extends zE {
    constructor(E, g, T, b, _, H, V, q) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.type = 1971632696;
    }
  }
  e.IfcGeoslice = q7;
  class R9 extends Ia {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 2295281155;
    }
  }
  e.IfcProtectiveDeviceTrippingUnit = R9;
  class Fw extends Ia {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 4086658281;
    }
  }
  e.IfcSensor = Fw;
  class Ik extends Ia {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 630975310;
    }
  }
  e.IfcUnitaryControlElement = Ik;
  class YR extends Ia {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 4288193352;
    }
  }
  e.IfcActuator = YR;
  class pk extends Ia {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 3087945054;
    }
  }
  e.IfcAlarm = pk;
  class mk extends Ia {
    constructor(E, g, T, b, _, H, V, q, se) {
      super(E, g, T, b, _, H, V, q), this.GlobalId = E, this.OwnerHistory = g, this.Name = T, this.Description = b, this.ObjectType = _, this.ObjectPlacement = H, this.Representation = V, this.Tag = q, this.PredefinedType = se, this.type = 25142252;
    }
  }
  e.IfcController = mk;
})(a || (a = {}));
var lb = {
  aggregates: {
    name: U,
    relating: "RelatingObject",
    related: "RelatedObjects",
    key: "children"
  },
  spatial: {
    name: Xe,
    relating: "RelatingStructure",
    related: "RelatedElements",
    key: "children"
  },
  psets: {
    name: Fe,
    relating: "RelatingPropertyDefinition",
    related: "RelatedObjects",
    key: "IsDefinedBy"
  },
  materials: {
    name: So,
    relating: "RelatingMaterial",
    related: "RelatedObjects",
    key: "HasAssociations"
  },
  type: {
    name: fe,
    relating: "RelatingType",
    related: "RelatedObjects",
    key: "IsDefinedBy"
  }
}, pSe = class mSe {
  /** @ignore */
  constructor(t) {
    this.api = t;
  }
  /**
   * 
   * @param modelID model handle
   * @param id  expressID of IfcElement
   * @param recursive default false, if true get all nested properties recursively
   * @param inverse default false, if true get all inverse properties recursively
   * @returns IfcElement
   */
  async getItemProperties(t, i, n = !1, s = !1) {
    return this.api.GetLine(t, i, n, s);
  }
  /**
   * Get IfcPropertySets of IfcElements
   * @param modelID model handle
   * @param elementID expressID of IfcElement, default 0 (all psets in model)
   * @param recursive default false, if true get all nested properties recursively
   * @returns array of IfcElements inheriting from IfcPropertySetDefinition
   */
  async getPropertySets(t, i = 0, n = !1, s = !1) {
    if (s) {
      let o = await this.getTypeProperties(t, i, !1), r = [];
      for (let l of o) r.push(...await this.getPropertySets(t, l.expressID, n));
      return r;
    } else return await this.getRelatedProperties(t, i, lb.psets, n);
  }
  /**
   * Set IfcRelDefinesByProperties relations of IfcElements and IfcPropertySets
   * @param modelID model handle
   * @param elementID expressID or array of expressIDs of IfcElements
   * @param psetID expressID or array of expressIDs of IfcPropertySets
   * @returns true if success or false if error
   */
  async setPropertySets(t, i, n) {
    return this.setItemProperties(t, i, n, lb.psets);
  }
  /**
   * Get TypeObject of IfcElements
   * @param modelID model handle
   * @param elementID expressID of IfcElement, default 0 (all type objects in model)
   * @param recursive default false, if true get all nested properties of the type object recursively
   * @returns array of objects inheriting from IfcTypeObject
   */
  async getTypeProperties(t, i = 0, n = !1) {
    return this.api.GetModelSchema(t) == "IFC2X3" ? await this.getRelatedProperties(t, i, lb.type, n) : await this.getRelatedProperties(t, i, { ...lb.type, key: "IsTypedBy" }, n);
  }
  /**
   * Get materials of IfcElement
   * @param modelID model handle
   * @param elementID expressID of IfcElement, default 0 (all materials in model)
   * @param recursive default false, if true get all nested properties recursively
   * @returns array of IfcElements inheriting from IfcMaterialDefinition
   */
  async getMaterialsProperties(t, i = 0, n = !1, s = !1) {
    if (s) {
      let o = await this.getTypeProperties(t, i, !1), r = [];
      for (let l of o) r.push(...await this.getMaterialsProperties(t, l.expressID, n));
      return r;
    } else return await this.getRelatedProperties(t, i, lb.materials, n);
  }
  /**
   * Set IfcRelAssociatesMaterial relations of IfcElements and IfcMaterialDefinitions
   * @param modelID model handle
   * @param elementID expressID or array of expressIDs of IfcElements
   * @param materialID expressID or array of expressIDs of IfcMaterialDefinitions
   * @returns true if success or false if error
   */
  async setMaterialsProperties(t, i, n) {
    return this.setItemProperties(t, i, n, lb.materials);
  }
  /**
   * Get Spatial Structure of IfcProject
   * @param modelID model handle
   * @param includeProperties default false
   * @returns IfcProject as Node
   */
  async getSpatialStructure(t, i = !1) {
    const n = await this.getSpatialTreeChunks(t), o = (await this.api.GetLineIDsWithType(t, Yg)).get(0), r = mSe.newIfcProject(o);
    return await this.getSpatialNode(t, r, n, i), r;
  }
  async getRelatedProperties(t, i, n, s = !1) {
    const o = [];
    let r = null;
    if (i !== 0)
      r = await this.api.GetLine(t, i, !1, !0, n.key)[n.key];
    else {
      let l = this.api.GetLineIDsWithType(t, n.name);
      r = [];
      for (let c = 0; c < l.size(); ++c)
        r.push({ value: l.get(c) });
    }
    if (r == null) return o;
    Array.isArray(r) || (r = [r]);
    for (let l = 0; l < r.length; l++) {
      let c = await this.api.GetLine(t, r[l].value, !1, !1)[n.relating];
      if (c != null) {
        Array.isArray(c) || (c = [c]);
        for (let h = 0; h < c.length; h++)
          o.push(await this.api.GetLine(t, c[h].value, s));
      }
    }
    return o;
  }
  async getChunks(t, i, n) {
    const s = await this.api.GetLineIDsWithType(t, n.name, !0);
    for (let o = 0; o < s.size(); o++) {
      const r = await this.api.GetLine(t, s.get(o), !1);
      this.saveChunk(i, n, r);
    }
  }
  static newIfcProject(t) {
    return {
      expressID: t,
      type: "IFCPROJECT",
      children: []
    };
  }
  async getSpatialNode(t, i, n, s) {
    await this.getChildren(t, i, n, lb.aggregates, s), await this.getChildren(t, i, n, lb.spatial, s);
  }
  async getChildren(t, i, n, s, o) {
    const r = n[i.expressID];
    if (r == null) return;
    const l = s.key, c = [];
    for (let h = 0; h < r.length; h++) {
      const I = r[h];
      let p = this.newNode(I, this.api.GetLineType(t, I));
      o && (p = { ...await this.getItemProperties(t, p.expressID), ...p }), await this.getSpatialNode(t, p, n, o), c.push(p);
    }
    i[l] = c;
  }
  newNode(t, i) {
    return {
      expressID: t,
      type: this.api.GetNameFromTypeCode(i),
      children: []
    };
  }
  async getSpatialTreeChunks(t) {
    const i = {};
    return await this.getChunks(t, i, lb.aggregates), await this.getChunks(t, i, lb.spatial), i;
  }
  saveChunk(t, i, n) {
    const s = n[i.relating].value, o = n[i.related].map((r) => r.value);
    t[s] == null ? t[s] = o : t[s] = t[s].concat(o);
  }
  async setItemProperties(t, i, n, s) {
    Array.isArray(i) || (i = [i]), Array.isArray(n) || (n = [n]);
    let o = 0;
    const r = [], l = [];
    for (const h of i) {
      const I = await this.api.GetLine(t, h, !1, !0);
      I[s.key] && l.push(I);
    }
    if (l.length < 1) return !1;
    const c = this.api.GetLineIDsWithType(t, s.name);
    for (let h = 0; h < c.size(); ++h) {
      const I = await this.api.GetLine(t, c.get(h));
      if (n.includes(Number(I[s.relating].value)) && (r.push(I), o++), o == n.length) break;
    }
    for (const h of l) {
      for (const I of r)
        h[s.key].some((p) => p.value === I.expressID) || h[s.key].push({ type: 5, value: I.expressID }), I[s.related].some((p) => p.value === h.expressID) || (I[s.related].push({ type: 5, value: h.expressID }), this.api.WriteLine(t, I));
      this.api.WriteLine(t, h);
    }
    return !0;
  }
}, Mie = /* @__PURE__ */ ((e) => (e[e.LOG_LEVEL_DEBUG = 1] = "LOG_LEVEL_DEBUG", e[e.LOG_LEVEL_WARN = 3] = "LOG_LEVEL_WARN", e[e.LOG_LEVEL_ERROR = 4] = "LOG_LEVEL_ERROR", e[e.LOG_LEVEL_OFF = 6] = "LOG_LEVEL_OFF", e))(Mie || {}), IW, ab = (IW = class {
  static setLogLevel(t) {
    this.logLevel = t;
  }
  static log(t, ...i) {
    this.logLevel <= 4 && console.log(t, ...i);
  }
  static debug(t, ...i) {
    this.logLevel <= 1 && console.trace("DEBUG: ", t, ...i);
  }
  static warn(t, ...i) {
    this.logLevel <= 3 && console.warn("WARN: ", t, ...i);
  }
  static error(t, ...i) {
    this.logLevel <= 4 && console.error("ERROR: ", t, ...i);
  }
}, IW.logLevel = 4, IW), Qk, eJ;
if (typeof document < "u") {
  const e = document.currentScript;
  (e == null ? void 0 : e.src) !== void 0 && (eJ = e.src.substring(0, e.src.lastIndexOf("/") + 1));
}
var Gje = 0, jT = 1, kje = 2, Vje = 3, zje = 4, jje = 5, Wje = 6, Yje = 7, qje = 8, $je = 9, Kje = 10;
function Zje() {
  return (/* @__PURE__ */ new Date()).getTime();
}
var jW = class {
  constructor() {
    this.wasmModule = void 0, this.wasmPath = "", this.isWasmPathAbsolute = !1, this.modelSchemaList = [], this.modelSchemaNameList = [], this.ifcGuidMap = /* @__PURE__ */ new Map(), this.deletedLines = /* @__PURE__ */ new Map(), this.properties = new pSe(this);
  }
  /**
   * Initializes the WASM module (WebIFCWasm), required before using any other functionality.
   *
   * @param customLocateFileHandler An optional locateFile function that let's
   * you override the path from which the wasm module is loaded.
   */
  async Init(e, t = !1) {
    if (!Qk)
      if (typeof self < "u" && self.crossOriginIsolated && !t)
        try {
          Qk = yke();
        } catch {
          Qk = Kge();
        }
      else Qk = Kge();
    if (Qk && this.wasmModule == null) {
      let i = (n, s) => n.endsWith(".wasm") ? this.isWasmPathAbsolute ? this.wasmPath + n : (eJ !== void 0 ? eJ : s) + this.wasmPath + n : (eJ !== void 0 ? eJ : s) + n;
      this.wasmModule = await Qk({ noInitialRun: !0, locateFile: e || i }), this.SetLogLevel(
        4
        /* LOG_LEVEL_ERROR */
      );
    } else
      ab.error("Could not find wasm module at './web-ifc' from web-ifc-api.ts");
  }
  /**
     * Opens a set of models and returns model IDs 
     * @param dataSets Array of Buffers containing IFC data (bytes)
     * @param settings Settings for loading the model @see LoaderSettings
  * @returns Array of model IDs
    */
  OpenModels(e, t) {
    let i = {
      MEMORY_LIMIT: 2147483648,
      ...t
    };
    i.MEMORY_LIMIT = i.MEMORY_LIMIT / e.length;
    let n = [];
    for (let s of e) n.push(this.OpenModel(s, i));
    return n;
  }
  CreateSettings(e) {
    return {
      COORDINATE_TO_ORIGIN: !1,
      CIRCLE_SEGMENTS: 12,
      TAPE_SIZE: 67108864,
      MEMORY_LIMIT: 2147483648,
      LINEWRITER_BUFFER: 1e4,
      ...e
    };
  }
  LookupSchemaId(e) {
    for (var t = 0; t < TP.length; t++)
      if (typeof TP[t] < "u") {
        for (var i = 0; i < TP[t].length; i++)
          if (TP[t][i] == e) return t;
      }
    return -1;
  }
  /**
     * Opens a model and returns a modelID number
     * @param data Buffer containing IFC data (bytes)
     * @param settings Settings for loading the model @see LoaderSettings
  * @returns ModelID or -1 if model fails to open
    */
  OpenModel(e, t) {
    let i = this.CreateSettings(t), n = this.wasmModule.OpenModel(i, (o, r, l) => {
      let c = Math.min(e.byteLength - r, l), h = this.wasmModule.HEAPU8.subarray(o, o + c), I = e.subarray(r, r + c);
      return h.set(I), c;
    });
    this.deletedLines.set(n, /* @__PURE__ */ new Set());
    var s = this.GetHeaderLine(n, pre).arguments[0][0].value;
    return this.modelSchemaList[n] = this.LookupSchemaId(s), this.modelSchemaNameList[n] = s, this.modelSchemaList[n] == -1 ? (ab.error("Unsupported Schema:" + s), this.CloseModel(n), -1) : (ab.debug("Parsing Model using " + s + " Schema"), n);
  }
  /**
   * Opens a model and returns a modelID number
   * @param callback a function of signature (offset:number, size: number) => Uint8Array that will retrieve the IFC data
   * @param settings Settings for loading the model @see LoaderSettings
   * @returns ModelID or -1 if model fails to open
  */
  OpenModelFromCallback(e, t) {
    let i = this.CreateSettings(t), n = this.wasmModule.OpenModel(i, (o, r, l) => {
      let c = e(r, l), h = Math.min(c.byteLength, l);
      return this.wasmModule.HEAPU8.subarray(o, o + h).set(c), h;
    });
    this.deletedLines.set(n, /* @__PURE__ */ new Set());
    var s = this.GetHeaderLine(n, pre).arguments[0][0].value;
    return this.modelSchemaList[n] = this.LookupSchemaId(s), this.modelSchemaNameList[n] = s, this.modelSchemaList[n] == -1 ? (ab.error("Unsupported Schema:" + s), this.CloseModel(n), -1) : (ab.debug("Parsing Model using " + s + " Schema"), n);
  }
  /**
     * Fetches the ifc schema version of a given model
     * @param modelID Model ID
  * @returns IFC Schema version
    */
  GetModelSchema(e) {
    return this.modelSchemaNameList[e];
  }
  /**
     * Creates a new model and returns a modelID number
     * @param schema ifc schema version
  * @returns ModelID
    */
  CreateModel(e, t) {
    var I, p, y;
    let i = this.CreateSettings(t), n = this.wasmModule.CreateModel(i);
    if (this.modelSchemaList[n] = this.LookupSchemaId(e.schema), this.modelSchemaNameList[n] = e.schema, this.modelSchemaList[n] == -1)
      return ab.error("Unsupported Schema:" + e.schema), this.CloseModel(n), -1;
    this.deletedLines.set(n, /* @__PURE__ */ new Set());
    const s = e.name || "web-ifc-model-" + n + ".ifc", o = (/* @__PURE__ */ new Date()).toISOString().slice(0, 19), r = ((I = e.description) == null ? void 0 : I.map((m) => ({ type: jT, value: m }))) || [{ type: jT, value: "ViewDefinition [CoordinationView]" }], l = ((p = e.authors) == null ? void 0 : p.map((m) => ({ type: jT, value: m }))) || [null], c = ((y = e.organizations) == null ? void 0 : y.map((m) => ({ type: jT, value: m }))) || [null], h = e.authorization ? { type: jT, value: e.authorization } : null;
    return this.wasmModule.WriteHeaderLine(n, vme, [
      r,
      { type: jT, value: "2;1" }
    ]), this.wasmModule.WriteHeaderLine(n, Ame, [
      { type: jT, value: s },
      { type: jT, value: o },
      l,
      c,
      { type: jT, value: "thatopen/web-ifc-api" },
      { type: jT, value: "thatopen/web-ifc-api" },
      h
    ]), this.wasmModule.WriteHeaderLine(n, pre, [[{ type: jT, value: e.schema }]]), n;
  }
  /**
   * Saves a model to a Buffer
   * @param modelID Model ID
   * @returns Buffer containing the model data
   */
  SaveModel(e) {
    let t = new Uint8Array(0);
    return this.wasmModule.SaveModel(e, (i, n) => {
      let s = t.byteLength, o = this.wasmModule.HEAPU8.subarray(i, i + n), r = new Uint8Array(s + n);
      r.set(t), r.set(o, s), t = r;
    }), t;
  }
  /**
   * Saves a model to a Buffer
   * @param modelID Model ID
   * @returns Buffer containing the model data
   */
  SaveModelToCallback(e, t) {
    this.wasmModule.SaveModel(e, (i, n) => {
      let s = this.wasmModule.HEAPU8.subarray(i, i + n), o = new Uint8Array(n);
      o.set(s), t(o);
    });
  }
  /**
  * Retrieves the geometry of an element
  * @param modelID Model handle retrieved by OpenModel
  * @param geometryExpressID express ID of the element
  * @returns Geometry of the element as a list of vertices and indices
  */
  GetGeometry(e, t) {
    return this.wasmModule.GetGeometry(e, t);
  }
  CreateAABB() {
    return this.wasmModule.CreateAABB();
  }
  CreateExtrusion() {
    return this.wasmModule.CreateExtrusion();
  }
  CreateSweep() {
    return this.wasmModule.CreateSweep();
  }
  CreateCircularSweep() {
    return this.wasmModule.CreateCircularSweep();
  }
  CreateRevolution() {
    return this.wasmModule.CreateRevolution();
  }
  CreateCylindricalRevolution() {
    return this.wasmModule.CreateCylindricalRevolution();
  }
  CreateParabola() {
    return this.wasmModule.CreateParabola();
  }
  CreateClothoid() {
    return this.wasmModule.CreateClothoid();
  }
  CreateArc() {
    return this.wasmModule.CreateArc();
  }
  CreateAlignment() {
    return this.wasmModule.CreateAlignment();
  }
  CreateBooleanOperator() {
    return this.wasmModule.CreateBooleanOperator();
  }
  CreateProfile() {
    return this.wasmModule.CreateProfile();
  }
  /**
   * Gets the header information required by the user
   * @param modelID Model handle retrieved by OpenModel
   * @param headerType Type of header data you want to retrieve
   * ifc.FILE_NAME, ifc.FILE_DESCRIPTION or ifc.FILE_SCHEMA
   * @returns An object with parameters ID, type and arguments
   */
  GetHeaderLine(e, t) {
    return this.wasmModule.GetHeaderLine(e, t);
  }
  /**
   * Gets the list of all ifcTypes contained in the model
   * @param modelID Model handle retrieved by OpenModel
   * @returns Array of objects containing typeID and typeName
   */
  GetAllTypesOfModel(e) {
    let t = [];
    const i = Object.keys(kF[this.modelSchemaList[e]]).map((n) => parseInt(n));
    for (let n = 0; n < i.length; n++)
      this.GetLineIDsWithType(e, i[n]).size() > 0 && t.push({ typeID: i[n], typeName: this.wasmModule.GetNameFromTypeCode(i[n]) });
    return t;
  }
  /**
   * Gets the ifc line data for a given express ID
   * @param modelID Model handle retrieved by OpenModel
   * @param expressID express ID of the line
   * @param flatten recursively flatten the line, default false
   * @param inverse get the inverse properties of the line, default false
   * @param inversePropKey filters out all other properties from a inverse search, for a increase in performance. Default null
   * @returns lineObject
   */
  GetLine(e, t, i = !1, n = !1, s = null) {
    return this.GetLines(e, [t], i, n, s)[0];
  }
  /**
   * Gets the ifc line data for a given express ID
   * @param modelID Model handle retrieved by OpenModel
   * @param a list of expressID express ID of the line
   * @param flatten recursively flatten the line, default false
   * @param inverse get the inverse properties of the line, default false
   * @param inversePropKey filters out all other properties from a inverse search, for a increase in performance. Default null
   * @returns lineObject
   */
  GetLines(e, t, i = !1, n = !1, s = null) {
    let o = [], r = this.GetRawLinesData(e, t), l = 0;
    for (const c of r) {
      let h;
      try {
        h = kF[this.modelSchemaList[e]][c.type](c.arguments), h.expressID = c.ID;
      } catch (p) {
        if (ab.error("Invalid IFC Line:" + t[l]), c.ID)
          throw p;
        continue;
      }
      i && this.FlattenLine(e, h);
      let I = _ie[this.modelSchemaList[e]][c.type];
      if (n && I != null)
        for (let p of I) {
          if (s && p[0] !== s) continue;
          p[3] ? h[p[0]] = [] : h[p[0]] = null;
          let y = [p[1]];
          typeof wP[this.modelSchemaList[e]][p[1]] < "u" && (y = y.concat(wP[this.modelSchemaList[e]][p[1]]));
          let m = this.wasmModule.GetInversePropertyForItem(e, c.ID, y, p[2], p[3]);
          if (!p[3] && m.size() > 0)
            i ? h[p[0]] = this.GetLine(e, m.get(0)) : h[p[0]] = { type: 5, value: m.get(0) };
          else
            for (let A = 0; A < m.size(); A++)
              i ? h[p[0]].push(this.GetLine(e, m.get(A))) : h[p[0]].push({ type: 5, value: m.get(A) });
        }
      o.push(h), l++;
    }
    return o;
  }
  /**
   * Gets the next unused expressID
   * @param modelID Model handle retrieved by OpenModel
   * @param expressID Starting expressID value 
   * @returns The next unused expressID starting from the value provided
   */
  GetNextExpressID(e, t) {
    return this.wasmModule.GetNextExpressID(e, t);
  }
  /**
   * Creates a new ifc entity
   * @param modelID Model handle retrieved by OpenModel
   * @param type Type code
   * @param args Arguments required by the entity
   * @returns An object contining the parameters of the new entity
   */
  CreateIfcEntity(e, t, ...i) {
    return xie[this.modelSchemaList[e]][t](i);
  }
  /**
   * Creates a new ifc globally unqiue ID
   * @param modelID Model handle retrieved by OpenModel
   * @returns An randomly generated globally unique ID
   */
  CreateIFCGloballyUniqueId(e) {
    const t = this.wasmModule.GenerateGuid(e);
    return AH[this.modelSchemaList[e]][_Ae](t);
  }
  /**
   * Creates a new ifc type i.e. IfcLabel, IfcReal, ...
   * @param modelID Model handle retrieved by OpenModel
   * @param type Type code
   * @param value Type value
   * @returns An object with the parameters of the type
   */
  CreateIfcType(e, t, i) {
    return AH[this.modelSchemaList[e]][t](i);
  }
  /**
   * Gets the name from a type code
   * @param type Code
   * @returns Name
   */
  GetNameFromTypeCode(e) {
    return this.wasmModule.GetNameFromTypeCode(e);
  }
  /**
   * Gets the type code  from a name code
   * @param name
   * @returns type code
   */
  GetTypeCodeFromName(e) {
    return this.wasmModule.GetTypeCodeFromName(e);
  }
  /**
   * Evaluates if a type is subtype of IfcElement 
   * @param type Type code
   * @returns True if subtype of Ifcelement, False if it is not subtype
   */
  IsIfcElement(e) {
    return this.wasmModule.IsIfcElement(e);
  }
  /**
   * Returns a list with all entity types that are present in the current schema
   * @param modelID Model handle retrieved by OpenModel
   * @returns Array of type codes
   */
  GetIfcEntityList(e) {
    return Object.keys(kF[this.modelSchemaList[e]]).map((t) => parseInt(t));
  }
  /**
   * Deletes an IFC line from the model
   * @param modelID Model handle retrieved by OpenModel
   * @param expressID express ID of the line to remove
   */
  DeleteLine(e, t) {
    this.wasmModule.RemoveLine(e, t), this.deletedLines.get(e).add(t);
  }
  /**
      * Writes a line to the model, can be used to write new lines or to update existing lines
      * @param modelID Model handle retrieved by OpenModel
      * @param lineObject array of line object to write
      */
  WriteLines(e, t) {
    for (let i of t) this.WriteLine(e, i);
  }
  /**
  * Writes a set of line to the model, can be used to write new lines or to update existing lines
  * @param modelID Model handle retrieved by OpenModel
  * @param lineObject line object to write
  */
  WriteLine(e, t) {
    if (t.expressID != -1 && this.deletedLines.get(e).has(t.expressID)) {
      ab.error("Cannot re-use deleted express ID");
      return;
    }
    if (t.expressID != -1 && t.expressID <= this.GetMaxExpressID(e) && this.GetLineType(e, t.expressID) != t.type && this.GetLineType(e, t.expressID) != 0) {
      ab.error("Cannot change type of existing IFC Line");
      return;
    }
    let i;
    for (i in t) {
      const s = t[i];
      if (s && s.expressID !== void 0)
        this.WriteLine(e, s), t[i] = new u(s.expressID);
      else if (Array.isArray(s) && s.length > 0)
        for (let o = 0; o < s.length; o++)
          s[o].expressID !== void 0 && (this.WriteLine(e, s[o]), t[i][o] = new u(s[o].expressID));
    }
    (t.expressID === void 0 || t.expressID < 0) && (t.expressID = this.GetMaxExpressID(e) + 1);
    let n = {
      ID: t.expressID,
      type: t.type,
      arguments: Pie[this.modelSchemaList[e]][t.type](t)
    };
    this.WriteRawLineData(e, n);
  }
  /** @ignore */
  FlattenLine(e, t) {
    Object.keys(t).forEach((i) => {
      let n = t[i];
      if (n && n.type === 5)
        n.value && (t[i] = this.GetLine(e, n.value, !0));
      else if (Array.isArray(n) && n.length > 0 && n[0] && n[0].type === 5)
        for (let s = 0; s < n.length; s++)
          n[s].value && (t[i][s] = this.GetLine(e, n[s].value, !0));
    });
  }
  /** @ignore */
  GetRawLinesData(e, t) {
    return this.wasmModule.GetLines(e, t);
  }
  /** @ignore */
  GetRawLineData(e, t) {
    return this.GetRawLinesData(e, [t])[0];
  }
  /** @ignore */
  WriteRawLineData(e, t) {
    this.wasmModule.WriteLine(e, t.ID, t.type, t.arguments);
  }
  /** @ignore */
  WriteRawLinesData(e, t) {
    for (let i of t) this.wasmModule.WriteLine(e, i.ID, i.type, i.arguments);
  }
  /**
   * Get all line IDs of a specific ifc type
   * @param modelID model ID
   * @param type ifc type, @see IfcEntities
   * @param includeInherited if true, also returns all inherited types 
   * @returns vector of line IDs
   */
  GetLineIDsWithType(e, t, i = !1) {
    let n = [];
    n.push(t), i && typeof wP[this.modelSchemaList[e]][t] < "u" && (n = n.concat(wP[this.modelSchemaList[e]][t]));
    let s = this.wasmModule.GetLineIDsWithType(e, n);
    return s[Symbol.iterator] = function* () {
      for (let o = 0; o < s.size(); o++) yield s.get(o);
    }, s;
  }
  /**
   * Get all line IDs of a model
   * @param modelID model ID
   * @returns vector of all line IDs
   */
  GetAllLines(e) {
    let t = this.wasmModule.GetAllLines(e);
    return t[Symbol.iterator] = function* () {
      for (let i = 0; i < t.size(); i++) yield t.get(i);
    }, t;
  }
  /**
   * Returns all crossSections in 2D contained in IFCSECTIONEDSOLID, IFCSECTIONEDSURFACE, IFCSECTIONEDSOLIDHORIZONTAL (IFC4x3 or superior) 
   * @param modelID model ID
   * @returns Lists with the cross sections curves as sets of points
   */
  GetAllCrossSections2D(e) {
    const t = this.wasmModule.GetAllCrossSections(e, 2), i = [];
    for (let n = 0; n < t.size(); n++) {
      const s = t.get(n), o = [], r = [];
      for (let c = 0; c < s.curves.size(); c++) {
        const h = s.curves.get(c), I = [];
        for (let y = 0; y < h.points.size(); y++) {
          const m = h.points.get(y), A = { x: m.x, y: m.y, z: m.z };
          I.push(A);
        }
        const p = { points: I, userData: [], arcSegments: [] };
        o.push(p), r.push(s.expressID.get(c));
      }
      const l = { FlatCoordinationMatrix: this.GetCoordinationMatrix(e), curves: o, expressID: r };
      i.push(l);
    }
    return i;
  }
  /**
   * Returns all crossSections in 3D contained in IFCSECTIONEDSOLID, IFCSECTIONEDSURFACE, IFCSECTIONEDSOLIDHORIZONTAL (IFC4x3 or superior) 
   * @param modelID model ID
   * @returns Lists with the cross sections curves as sets of points
   */
  GetAllCrossSections3D(e) {
    const t = this.wasmModule.GetAllCrossSections(e, 3), i = [];
    for (let n = 0; n < t.size(); n++) {
      const s = t.get(n), o = [], r = [];
      for (let c = 0; c < s.curves.size(); c++) {
        const h = s.curves.get(c), I = [];
        for (let y = 0; y < h.points.size(); y++) {
          const m = h.points.get(y), A = { x: m.x, y: m.y, z: m.z };
          I.push(A);
        }
        const p = { points: I, userData: [], arcSegments: [] };
        o.push(p), r.push(s.expressID.get(c));
      }
      const l = { FlatCoordinationMatrix: this.GetCoordinationMatrix(e), curves: o, expressID: r };
      i.push(l);
    }
    return i;
  }
  /**
   * Returns all alignments contained in the IFC model (IFC4x3 or superior)
   * @param modelID model ID
   * @returns Lists with horizontal and vertical curves as sets of points
   */
  GetAllAlignments(e) {
    const t = this.wasmModule.GetAllAlignments(e), i = [];
    for (let n = 0; n < t.size(); n++) {
      const s = t.get(n), o = [];
      for (let h = 0; h < s.Horizontal.curves.size(); h++) {
        const I = s.Horizontal.curves.get(h), p = [];
        for (let A = 0; A < I.points.size(); A++) {
          const C = I.points.get(A), O = { x: C.x, y: C.y };
          p.push(O);
        }
        const y = [];
        for (let A = 0; A < I.userData.size(); A++) {
          const C = I.userData.get(A);
          y.push(C);
        }
        const m = { points: p, data: y };
        o.push(m);
      }
      const r = [];
      for (let h = 0; h < s.Vertical.curves.size(); h++) {
        const I = s.Vertical.curves.get(h), p = [];
        for (let A = 0; A < I.points.size(); A++) {
          const C = I.points.get(A), O = { x: C.x, y: C.y };
          p.push(O);
        }
        const y = [];
        for (let A = 0; A < I.userData.size(); A++) {
          const C = I.userData.get(A);
          y.push(C);
        }
        const m = { points: p, data: y };
        r.push(m);
      }
      const l = [];
      for (let h = 0; h < s.Absolute.curves.size(); h++) {
        const I = s.Absolute.curves.get(h), p = [];
        for (let A = 0; A < I.points.size(); A++) {
          const C = I.points.get(A), O = { x: C.x, y: C.y, z: C.z };
          p.push(O);
        }
        const y = [];
        for (let A = 0; A < I.userData.size(); A++) {
          const C = I.userData.get(A);
          y.push(C);
        }
        const m = { points: p, data: y };
        l.push(m);
      }
      const c = {
        FlatCoordinationMatrix: this.GetCoordinationMatrix(e),
        horizontal: o,
        vertical: r,
        curve3D: l
      };
      i.push(c);
    }
    return i;
  }
  /**
   * Set the transformation matrix
   * @param modelID model ID
   * @param transformationMatrix transformation matrix, flat 4x4 matrix as array[16] 
   */
  SetGeometryTransformation(e, t) {
    if (t.length != 16)
      throw new Error(`invalid matrix size: ${t.length}`);
    this.wasmModule.SetGeometryTransformation(e, t);
  }
  /**
   * Get the coordination matrix
   * @param modelID model ID
   * @returns flat 4x4 matrix as array[16]
   */
  GetCoordinationMatrix(e) {
    return this.wasmModule.GetCoordinationMatrix(e);
  }
  GetVertexArray(e, t) {
    return this.getSubArray(this.wasmModule.HEAPF32, e, t);
  }
  GetIndexArray(e, t) {
    return this.getSubArray(this.wasmModule.HEAPU32, e, t);
  }
  getSubArray(e, t, i) {
    return e.subarray(t / 4, t / 4 + i).slice(0);
  }
  /**
   * Closes a model and frees all related memory
   * @param modelID Model handle retrieved by OpenModel, model must be closed after use
  */
  CloseModel(e) {
    this.ifcGuidMap.delete(e), this.wasmModule.CloseModel(e);
  }
  /**
   * Closes all models and frees all related memory. Please note that after calling this you must call Init() again to ensure web-ifc is in a working state.
  */
  Dispose() {
    this.ifcGuidMap.clear(), this.wasmModule.CloseAllModels(), this.wasmModule = void 0;
  }
  /**
  * Streams meshes of a model with specific express id
  * @param modelID Model handle retrieved by OpenModel
     * @param expressIDs expressIDs of elements to stream
  * @param meshCallback callback function that is called for each mesh
  */
  StreamMeshes(e, t, i) {
    this.wasmModule.StreamMeshes(e, t, i);
  }
  /**
   * Streams all meshes of a model
   * @param modelID Model handle retrieved by OpenModel
   * @param meshCallback callback function that is called for each mesh
   */
  StreamAllMeshes(e, t) {
    this.wasmModule.StreamAllMeshes(e, t);
  }
  /**
   * Streams all meshes of a model with a specific ifc type
   * @param modelID Model handle retrieved by OpenModel
   * @param types types of elements to stream
   * @param meshCallback callback function that is called for each mesh
   */
  StreamAllMeshesWithTypes(e, t, i) {
    this.wasmModule.StreamAllMeshesWithTypes(e, t, i);
  }
  /**
     * Checks if a specific model ID is open or closed
     * @param modelID Model handle retrieved by OpenModel
  * @returns true if model is open, false if model is closed
    */
  IsModelOpen(e) {
    return this.wasmModule.IsModelOpen(e);
  }
  /**
     * Load all geometry in a model
     * @param modelID Model handle retrieved by OpenModel
  * @returns Vector of FlatMesh objects
    */
  LoadAllGeometry(e) {
    let t = this.wasmModule.LoadAllGeometry(e);
    return t[Symbol.iterator] = function* () {
      for (let i = 0; i < t.size(); i++) yield t.get(i);
    }, t;
  }
  /**
     * Load geometry for a single element
     * @param modelID Model handle retrieved by OpenModel
  * @param expressID ExpressID of the element
  * @returns FlatMesh object
    */
  GetFlatMesh(e, t) {
    return this.wasmModule.GetFlatMesh(e, t);
  }
  /**
  * Returns the maximum ExpressID value in the IFC file, ex.- #9999999
  * @param modelID Model handle retrieved by OpenModel
  * @returns Express numerical value
  */
  GetMaxExpressID(e) {
    return this.wasmModule.GetMaxExpressID(e);
  }
  /**
  * Returns the type of a given ifc entity in the fiule.
  * @param modelID Model handle retrieved by OpenModel
  * @param expressID Line Number
  * @returns IFC Type Code
  */
  GetLineType(e, t) {
    return this.wasmModule.GetLineType(e, t);
  }
  /**
  * Returns the version number of web-ifc
  * @returns The current version number as a string
  */
  GetVersion() {
    return this.wasmModule.GetVersion();
  }
  /**
  * Looks up an entities express ID from its GlobalID.
  * @param modelID Model handle retrieved by OpenModel
  * @param guid GobalID to be looked up
  * @returns expressID numerical value
  */
  GetExpressIdFromGuid(e, t) {
    var i;
    return this.ifcGuidMap.has(e) || this.CreateIfcGuidToExpressIdMapping(e), (i = this.ifcGuidMap.get(e)) == null ? void 0 : i.get(t);
  }
  /**
   * Looks up an entities GlobalID from its ExpressID.
   * @param modelID Model handle retrieved by OpenModel
   * @param expressID express ID to be looked up
   * @returns globalID string value
   */
  GetGuidFromExpressId(e, t) {
    var i;
    return this.ifcGuidMap.has(e) || this.CreateIfcGuidToExpressIdMapping(e), (i = this.ifcGuidMap.get(e)) == null ? void 0 : i.get(t);
  }
  /** @ignore */
  CreateIfcGuidToExpressIdMapping(e) {
    const t = /* @__PURE__ */ new Map();
    let i = this.GetIfcEntityList(e);
    for (const n of i) {
      if (!this.IsIfcElement(n)) continue;
      const s = this.GetLineIDsWithType(e, n), o = s.size();
      for (let r = 0; r < o; r++) {
        const l = s.get(r), c = this.GetLine(e, l);
        try {
          if ("GlobalId" in c) {
            const h = c.GlobalId.value;
            t.set(l, h), t.set(h, l);
          }
        } catch {
          continue;
        }
      }
    }
    this.ifcGuidMap.set(e, t);
  }
  /**
   * Sets the path to the wasm file
   * @param path path to the wasm file
   * @param absolute if true, path is absolute, otherwise it is relative to executing script
   */
  SetWasmPath(e, t = !1) {
    this.wasmPath = e, this.isWasmPathAbsolute = t;
  }
  /**
   * Sets the log level
   * @param level Log level to set
   */
  SetLogLevel(e) {
    ab.setLogLevel(e), this.wasmModule.SetLogLevel(e);
  }
  /**
   * Encodes test using IFC Encoding
   * @text the text to encode
   * @returns the text encoded 
   */
  EncodeText(e) {
    return this.wasmModule.EncodeText(e);
  }
  /**
  * Decodes test using IFC Encoding
  * @text the text to decode
  * @returns the text decoded 
  */
  DecodeText(e) {
    return this.wasmModule.DecodeText(e);
  }
  /**
  * Resets the Cached IFC Data - useful when changing the geometry of a model
  * @param modelID Model handle retrieved by OpenModel
  */
  ResetCache(e) {
    return this.wasmModule.DecodeText(e);
  }
};
const Qje = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Constructors: xie,
  EMPTY: Wje,
  ENUM: Vje,
  FILE_DESCRIPTION: vme,
  FILE_NAME: Ame,
  FILE_SCHEMA: pre,
  FromRawLineData: kF,
  Handle: u,
  IFC2DCOMPOSITECURVE: WV,
  get IFC2X3() {
    return f;
  },
  get IFC4() {
    return d;
  },
  get IFC4X3() {
    return a;
  },
  IFCABSORBEDDOSEMEASURE: zze,
  IFCACCELERATIONMEASURE: Vze,
  IFCACTIONREQUEST: Y2,
  IFCACTOR: NN,
  IFCACTORROLE: Hje,
  IFCACTUATOR: Gm,
  IFCACTUATORTYPE: sc,
  IFCADDRESS: Fje,
  IFCADVANCEDBREP: mN,
  IFCADVANCEDBREPWITHVOIDS: f5,
  IFCADVANCEDFACE: wN,
  IFCAIRTERMINAL: j1,
  IFCAIRTERMINALBOX: z1,
  IFCAIRTERMINALBOXTYPE: qa,
  IFCAIRTERMINALTYPE: Ya,
  IFCAIRTOAIRHEATRECOVERY: V1,
  IFCAIRTOAIRHEATRECOVERYTYPE: Wa,
  IFCALARM: Hm,
  IFCALARMTYPE: nc,
  IFCALIGNMENT: hU,
  IFCALIGNMENTCANT: xV,
  IFCALIGNMENTCANTSEGMENT: MAe,
  IFCALIGNMENTHORIZONTAL: _V,
  IFCALIGNMENTHORIZONTALSEGMENT: PAe,
  IFCALIGNMENTPARAMETERSEGMENT: jze,
  IFCALIGNMENTSEGMENT: LV,
  IFCALIGNMENTVERTICAL: OV,
  IFCALIGNMENTVERTICALSEGMENT: BAe,
  IFCAMOUNTOFSUBSTANCEMEASURE: kze,
  IFCANGULARDIMENSION: GQ,
  IFCANGULARVELOCITYMEASURE: Gze,
  IFCANNOTATION: Zp,
  IFCANNOTATIONCURVEOCCURRENCE: tre,
  IFCANNOTATIONFILLAREA: sH,
  IFCANNOTATIONFILLAREAOCCURRENCE: ere,
  IFCANNOTATIONOCCURRENCE: uIe,
  IFCANNOTATIONSURFACE: Cz,
  IFCANNOTATIONSURFACEOCCURRENCE: dre,
  IFCANNOTATIONSYMBOLOCCURRENCE: ure,
  IFCANNOTATIONTEXTOCCURRENCE: are,
  IFCAPPLICATION: Bje,
  IFCAPPLIEDVALUE: Uje,
  IFCAPPLIEDVALUERELATIONSHIP: zU,
  IFCAPPROVAL: Mje,
  IFCAPPROVALACTORRELATIONSHIP: hSe,
  IFCAPPROVALPROPERTYRELATIONSHIP: Pje,
  IFCAPPROVALRELATIONSHIP: yL,
  IFCARBITRARYCLOSEDPROFILEDEF: Nie,
  IFCARBITRARYOPENPROFILEDEF: bie,
  IFCARBITRARYPROFILEDEFWITHVOIDS: T8,
  IFCARCINDEX: Mke,
  IFCAREADENSITYMEASURE: Pke,
  IFCAREAMEASURE: Hze,
  IFCASSET: W2,
  IFCASYMMETRICISHAPEPROFILEDEF: YO,
  IFCAUDIOVISUALAPPLIANCE: k1,
  IFCAUDIOVISUALAPPLIANCETYPE: _p,
  IFCAXIS1PLACEMENT: RA,
  IFCAXIS2PLACEMENT2D: TA,
  IFCAXIS2PLACEMENT3D: wA,
  IFCAXIS2PLACEMENTLINEAR: $oe,
  IFCBEAM: G0,
  IFCBEAMSTANDARDCASE: pC,
  IFCBEAMTYPE: $h,
  IFCBEARING: cU,
  IFCBEARINGTYPE: gU,
  IFCBEZIERCURVE: jV,
  IFCBINARY: xke,
  IFCBLOBTEXTURE: FW,
  IFCBLOCK: bN,
  IFCBOILER: G1,
  IFCBOILERTYPE: ja,
  IFCBOOLEAN: Fze,
  IFCBOOLEANCLIPPINGRESULT: _5,
  IFCBOOLEANRESULT: r8,
  IFCBOREHOLE: S_,
  IFCBOUNDARYCONDITION: xje,
  IFCBOUNDARYCURVE: Sg,
  IFCBOUNDARYEDGECONDITION: Eue,
  IFCBOUNDARYFACECONDITION: yue,
  IFCBOUNDARYNODECONDITION: mue,
  IFCBOUNDARYNODECONDITIONWARPING: vH,
  IFCBOUNDEDCURVE: rA,
  IFCBOUNDEDSURFACE: gA,
  IFCBOUNDINGBOX: nH,
  IFCBOXALIGNMENT: Bze,
  IFCBOXEDHALFSPACE: EA,
  IFCBRIDGE: D_,
  IFCBRIDGEPART: fC,
  IFCBSPLINECURVE: j2,
  IFCBSPLINECURVEWITHKNOTS: Mv,
  IFCBSPLINESURFACE: bO,
  IFCBSPLINESURFACEWITHKNOTS: Vv,
  IFCBUILDING: l0,
  IFCBUILDINGELEMENT: Zv,
  IFCBUILDINGELEMENTCOMPONENT: GU,
  IFCBUILDINGELEMENTPART: n0,
  IFCBUILDINGELEMENTPARTTYPE: A2,
  IFCBUILDINGELEMENTPROXY: oh,
  IFCBUILDINGELEMENTPROXYTYPE: qh,
  IFCBUILDINGELEMENTTYPE: Qv,
  IFCBUILDINGSTOREY: u0,
  IFCBUILDINGSYSTEM: Pv,
  IFCBUILTELEMENT: KU,
  IFCBUILTELEMENTTYPE: HV,
  IFCBUILTSYSTEM: CV,
  IFCBURNER: H1,
  IFCBURNERTYPE: Lp,
  IFCCABLECARRIERFITTING: F1,
  IFCCABLECARRIERFITTINGTYPE: za,
  IFCCABLECARRIERSEGMENT: B1,
  IFCCABLECARRIERSEGMENTTYPE: Va,
  IFCCABLEFITTING: U1,
  IFCCABLEFITTINGTYPE: Op,
  IFCCABLESEGMENT: M1,
  IFCCABLESEGMENTTYPE: ka,
  IFCCAISSONFOUNDATION: A_,
  IFCCAISSONFOUNDATIONTYPE: N_,
  IFCCALENDARDATE: _je,
  IFCCARDINALPOINTREFERENCE: _ke,
  IFCCARTESIANPOINT: yA,
  IFCCARTESIANPOINTLIST: xW,
  IFCCARTESIANPOINTLIST2D: MP,
  IFCCARTESIANPOINTLIST3D: PP,
  IFCCARTESIANTRANSFORMATIONOPERATOR: s8,
  IFCCARTESIANTRANSFORMATIONOPERATOR2D: mA,
  IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM: Wg,
  IFCCARTESIANTRANSFORMATIONOPERATOR3D: pA,
  IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM: jg,
  IFCCENTERLINEPROFILEDEF: w8,
  IFCCHAMFEREDGEFEATURE: oC,
  IFCCHILLER: P1,
  IFCCHILLERTYPE: Ga,
  IFCCHIMNEY: Ag,
  IFCCHIMNEYTYPE: B2,
  IFCCIRCLE: Pg,
  IFCCIRCLEHOLLOWPROFILEDEF: oA,
  IFCCIRCLEPROFILEDEF: n8,
  IFCCIVILELEMENT: d5,
  IFCCIVILELEMENTTYPE: kv,
  IFCCLASSIFICATION: Rme,
  IFCCLASSIFICATIONITEM: cSe,
  IFCCLASSIFICATIONITEMRELATIONSHIP: hIe,
  IFCCLASSIFICATIONNOTATION: Lje,
  IFCCLASSIFICATIONNOTATIONFACET: Oje,
  IFCCLASSIFICATIONREFERENCE: g8,
  IFCCLOSEDSHELL: IA,
  IFCCLOTHOID: _Q,
  IFCCOIL: x1,
  IFCCOILTYPE: Ha,
  IFCCOLOURRGB: gH,
  IFCCOLOURRGBLIST: Dae,
  IFCCOLOURSPECIFICATION: pue,
  IFCCOLUMN: sh,
  IFCCOLUMNSTANDARDCASE: vC,
  IFCCOLUMNTYPE: mf,
  IFCCOMMUNICATIONSAPPLIANCE: _1,
  IFCCOMMUNICATIONSAPPLIANCETYPE: Cp,
  IFCCOMPLEXNUMBER: Uze,
  IFCCOMPLEXPROPERTY: Ur,
  IFCCOMPLEXPROPERTYTEMPLATE: eE,
  IFCCOMPOSITECURVE: c0,
  IFCCOMPOSITECURVEONSURFACE: h5,
  IFCCOMPOSITECURVESEGMENT: $O,
  IFCCOMPOSITEPROFILEDEF: Sie,
  IFCCOMPOUNDPLANEANGLEMEASURE: Mze,
  IFCCOMPRESSOR: L1,
  IFCCOMPRESSORTYPE: Fa,
  IFCCONDENSER: O1,
  IFCCONDENSERTYPE: Ba,
  IFCCONDITION: HQ,
  IFCCONDITIONCRITERION: FQ,
  IFCCONIC: SN,
  IFCCONNECTEDFACESET: fL,
  IFCCONNECTIONCURVEGEOMETRY: Aie,
  IFCCONNECTIONGEOMETRY: dSe,
  IFCCONNECTIONPOINTECCENTRICITY: E8,
  IFCCONNECTIONPOINTGEOMETRY: Lie,
  IFCCONNECTIONPORTGEOMETRY: uSe,
  IFCCONNECTIONSURFACEGEOMETRY: zW,
  IFCCONNECTIONVOLUMEGEOMETRY: Lae,
  IFCCONSTRAINT: Cje,
  IFCCONSTRAINTAGGREGATIONRELATIONSHIP: VU,
  IFCCONSTRAINTCLASSIFICATIONRELATIONSHIP: Ire,
  IFCCONSTRAINTRELATIONSHIP: kU,
  IFCCONSTRUCTIONEQUIPMENTRESOURCE: Km,
  IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE: Gv,
  IFCCONSTRUCTIONMATERIALRESOURCE: $m,
  IFCCONSTRUCTIONMATERIALRESOURCETYPE: Hv,
  IFCCONSTRUCTIONPRODUCTRESOURCE: qm,
  IFCCONSTRUCTIONPRODUCTRESOURCETYPE: Fv,
  IFCCONSTRUCTIONRESOURCE: r4,
  IFCCONSTRUCTIONRESOURCETYPE: UO,
  IFCCONTEXT: EX,
  IFCCONTEXTDEPENDENTMEASURE: Pze,
  IFCCONTEXTDEPENDENTUNIT: zae,
  IFCCONTROL: AN,
  IFCCONTROLLER: Fm,
  IFCCONTROLLERTYPE: ic,
  IFCCONVERSIONBASEDUNIT: Vae,
  IFCCONVERSIONBASEDUNITWITHOFFSET: vX,
  IFCCONVEYORSEGMENT: $D,
  IFCCONVEYORSEGMENTTYPE: eC,
  IFCCOOLEDBEAM: C1,
  IFCCOOLEDBEAMTYPE: Ua,
  IFCCOOLINGTOWER: D1,
  IFCCOOLINGTOWERTYPE: Ma,
  IFCCOORDINATEDUNIVERSALTIMEOFFSET: Dje,
  IFCCOORDINATEOPERATION: FO,
  IFCCOORDINATEREFERENCESYSTEM: ije,
  IFCCOSINESPIRAL: LQ,
  IFCCOSTITEM: o4,
  IFCCOSTSCHEDULE: s4,
  IFCCOSTVALUE: Iue,
  IFCCOUNTMEASURE: xze,
  IFCCOURSE: X_,
  IFCCOURSETYPE: BU,
  IFCCOVERING: nh,
  IFCCOVERINGTYPE: pf,
  IFCCRANERAILASHAPEPROFILEDEF: iIe,
  IFCCRANERAILFSHAPEPROFILEDEF: tIe,
  IFCCREWRESOURCE: r3,
  IFCCREWRESOURCETYPE: Kv,
  IFCCSGPRIMITIVE3D: iH,
  IFCCSGSOLID: fA,
  IFCCSHAPEPROFILEDEF: o8,
  IFCCURRENCYRELATIONSHIP: Tme,
  IFCCURTAINWALL: ih,
  IFCCURTAINWALLTYPE: If,
  IFCCURVATUREMEASURE: _ze,
  IFCCURVE: i8,
  IFCCURVEBOUNDEDPLANE: zg,
  IFCCURVEBOUNDEDSURFACE: gN,
  IFCCURVESEGMENT: qoe,
  IFCCURVESTYLE: vie,
  IFCCURVESTYLEFONT: fue,
  IFCCURVESTYLEFONTANDSCALING: hue,
  IFCCURVESTYLEFONTPATTERN: cue,
  IFCCYLINDRICALSURFACE: pN,
  IFCDAMPER: N1,
  IFCDAMPERTYPE: Pa,
  IFCDATE: Lke,
  IFCDATEANDTIME: Nje,
  IFCDATETIME: Oke,
  IFCDAYINMONTHNUMBER: Lze,
  IFCDAYINWEEKNUMBER: Cke,
  IFCDAYLIGHTSAVINGHOUR: Oze,
  IFCDEEPFOUNDATION: EU,
  IFCDEEPFOUNDATIONTYPE: UU,
  IFCDEFINEDSYMBOL: eIe,
  IFCDERIVEDPROFILEDEF: Rie,
  IFCDERIVEDUNIT: aSe,
  IFCDERIVEDUNITELEMENT: bje,
  IFCDESCRIPTIVEMEASURE: Cze,
  IFCDIAMETERDIMENSION: BQ,
  IFCDIMENSIONALEXPONENTS: Sje,
  IFCDIMENSIONCALLOUTRELATIONSHIP: jAe,
  IFCDIMENSIONCOUNT: Dze,
  IFCDIMENSIONCURVE: JQ,
  IFCDIMENSIONCURVEDIRECTEDCALLOUT: Zoe,
  IFCDIMENSIONCURVETERMINATOR: KV,
  IFCDIMENSIONPAIR: zAe,
  IFCDIRECTION: t8,
  IFCDIRECTRIXCURVESWEPTAREASOLID: UQ,
  IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID: MU,
  IFCDISCRETEACCESSORY: th,
  IFCDISCRETEACCESSORYTYPE: Yh,
  IFCDISTRIBUTIONBOARD: qD,
  IFCDISTRIBUTIONBOARDTYPE: XD,
  IFCDISTRIBUTIONCHAMBERELEMENT: dd,
  IFCDISTRIBUTIONCHAMBERELEMENTTYPE: lc,
  IFCDISTRIBUTIONCIRCUIT: T2,
  IFCDISTRIBUTIONCONTROLELEMENT: H0,
  IFCDISTRIBUTIONCONTROLELEMENTTYPE: Wh,
  IFCDISTRIBUTIONELEMENT: Vp,
  IFCDISTRIBUTIONELEMENTTYPE: o3,
  IFCDISTRIBUTIONFLOWELEMENT: eh,
  IFCDISTRIBUTIONFLOWELEMENTTYPE: ff,
  IFCDISTRIBUTIONPORT: Ym,
  IFCDISTRIBUTIONSYSTEM: xv,
  IFCDOCUMENTELECTRONICFORMAT: Aje,
  IFCDOCUMENTINFORMATION: due,
  IFCDOCUMENTINFORMATIONRELATIONSHIP: mL,
  IFCDOCUMENTREFERENCE: nY,
  IFCDOOR: X0,
  IFCDOORLININGPROPERTIES: T5,
  IFCDOORPANELPROPERTIES: w5,
  IFCDOORSTANDARDCASE: RC,
  IFCDOORSTYLE: GO,
  IFCDOORTYPE: U2,
  IFCDOSEEQUIVALENTMEASURE: Nze,
  IFCDRAUGHTINGCALLOUT: X1e,
  IFCDRAUGHTINGCALLOUTRELATIONSHIP: Dy,
  IFCDRAUGHTINGPREDEFINEDCOLOUR: qO,
  IFCDRAUGHTINGPREDEFINEDCURVEFONT: UN,
  IFCDRAUGHTINGPREDEFINEDTEXTFONT: aIe,
  IFCDUCTFITTING: b1,
  IFCDUCTFITTINGTYPE: xa,
  IFCDUCTSEGMENT: S1,
  IFCDUCTSEGMENTTYPE: _a,
  IFCDUCTSILENCER: A1,
  IFCDUCTSILENCERTYPE: La,
  IFCDURATION: Dke,
  IFCDYNAMICVISCOSITYMEASURE: bze,
  IFCEARTHWORKSCUT: vb,
  IFCEARTHWORKSELEMENT: yU,
  IFCEARTHWORKSFILL: Rb,
  IFCEDGE: y8,
  IFCEDGECURVE: CA,
  IFCEDGEFEATURE: B_,
  IFCEDGELOOP: hA,
  IFCELECTRICALBASEPROPERTIES: ZQ,
  IFCELECTRICALCIRCUIT: zV,
  IFCELECTRICALELEMENT: VV,
  IFCELECTRICAPPLIANCE: v1,
  IFCELECTRICAPPLIANCETYPE: Oa,
  IFCELECTRICCAPACITANCEMEASURE: Sze,
  IFCELECTRICCHARGEMEASURE: Aze,
  IFCELECTRICCONDUCTANCEMEASURE: vze,
  IFCELECTRICCURRENTMEASURE: Rze,
  IFCELECTRICDISTRIBUTIONBOARD: R1,
  IFCELECTRICDISTRIBUTIONBOARDTYPE: Dp,
  IFCELECTRICDISTRIBUTIONPOINT: sC,
  IFCELECTRICFLOWSTORAGEDEVICE: T1,
  IFCELECTRICFLOWSTORAGEDEVICETYPE: Ca,
  IFCELECTRICFLOWTREATMENTDEVICE: YD,
  IFCELECTRICFLOWTREATMENTDEVICETYPE: JD,
  IFCELECTRICGENERATOR: w1,
  IFCELECTRICGENERATORTYPE: Da,
  IFCELECTRICHEATERTYPE: lC,
  IFCELECTRICMOTOR: g1,
  IFCELECTRICMOTORTYPE: Na,
  IFCELECTRICRESISTANCEMEASURE: Tze,
  IFCELECTRICTIMECONTROL: E1,
  IFCELECTRICTIMECONTROLTYPE: ba,
  IFCELECTRICVOLTAGEMEASURE: wze,
  IFCELEMENT: n4,
  IFCELEMENTARYSURFACE: MN,
  IFCELEMENTASSEMBLY: Wp,
  IFCELEMENTASSEMBLYTYPE: Bv,
  IFCELEMENTCOMPONENT: s3,
  IFCELEMENTCOMPONENTTYPE: n3,
  IFCELEMENTQUANTITY: p4,
  IFCELEMENTTYPE: I4,
  IFCELLIPSE: Fg,
  IFCELLIPSEPROFILEDEF: tH,
  IFCENERGYCONVERSIONDEVICE: gd,
  IFCENERGYCONVERSIONDEVICETYPE: yc,
  IFCENERGYMEASURE: gze,
  IFCENERGYPROPERTIES: Xoe,
  IFCENGINE: EI,
  IFCENGINETYPE: Up,
  IFCENVIRONMENTALIMPACTVALUE: lSe,
  IFCEQUIPMENTELEMENT: $V,
  IFCEQUIPMENTSTANDARD: KQ,
  IFCEVAPORATIVECOOLER: yI,
  IFCEVAPORATIVECOOLERTYPE: yu,
  IFCEVAPORATOR: mI,
  IFCEVAPORATORTYPE: mu,
  IFCEVENT: SO,
  IFCEVENTTIME: rme,
  IFCEVENTTYPE: MO,
  IFCEXTENDEDMATERIALPROPERTIES: VAe,
  IFCEXTENDEDPROPERTIES: ome,
  IFCEXTERNALINFORMATION: tje,
  IFCEXTERNALLYDEFINEDHATCHSTYLE: uue,
  IFCEXTERNALLYDEFINEDSURFACESTYLE: aue,
  IFCEXTERNALLYDEFINEDSYMBOL: rSe,
  IFCEXTERNALLYDEFINEDTEXTFONT: lue,
  IFCEXTERNALREFERENCE: vje,
  IFCEXTERNALREFERENCERELATIONSHIP: ui,
  IFCEXTERNALSPATIALELEMENT: v2,
  IFCEXTERNALSPATIALSTRUCTUREELEMENT: Uv,
  IFCEXTRUDEDAREASOLID: Vg,
  IFCEXTRUDEDAREASOLIDTAPERED: I5,
  IFCFACE: m8,
  IFCFACEBASEDSURFACEMODEL: e8,
  IFCFACEBOUND: p8,
  IFCFACEOUTERBOUND: DA,
  IFCFACESURFACE: NA,
  IFCFACETEDBREP: Bg,
  IFCFACETEDBREPWITHVOIDS: i3,
  IFCFACILITY: PU,
  IFCFACILITYPART: xU,
  IFCFACILITYPARTCOMMON: U_,
  IFCFAILURECONNECTIONCONDITION: kae,
  IFCFAN: y1,
  IFCFANTYPE: Sa,
  IFCFASTENER: lh,
  IFCFASTENERTYPE: hf,
  IFCFEATUREELEMENT: t3,
  IFCFEATUREELEMENTADDITION: cf,
  IFCFEATUREELEMENTSUBTRACTION: df,
  IFCFILLAREASTYLE: Tie,
  IFCFILLAREASTYLEHATCHING: XP,
  IFCFILLAREASTYLETILES: JP,
  IFCFILLAREASTYLETILESYMBOLWITHSTYLE: J1e,
  IFCFILTER: m1,
  IFCFILTERTYPE: Aa,
  IFCFIRESUPPRESSIONTERMINAL: p1,
  IFCFIRESUPPRESSIONTERMINALTYPE: va,
  IFCFIXEDREFERENCESWEPTAREASOLID: oN,
  IFCFLOWCONTROLLER: Ed,
  IFCFLOWCONTROLLERTYPE: mc,
  IFCFLOWFITTING: yd,
  IFCFLOWFITTINGTYPE: pc,
  IFCFLOWINSTRUMENT: jm,
  IFCFLOWINSTRUMENTTYPE: rc,
  IFCFLOWMETER: pI,
  IFCFLOWMETERTYPE: pu,
  IFCFLOWMOVINGDEVICE: md,
  IFCFLOWMOVINGDEVICETYPE: Ic,
  IFCFLOWSEGMENT: pd,
  IFCFLOWSEGMENTTYPE: fc,
  IFCFLOWSTORAGEDEVICE: Id,
  IFCFLOWSTORAGEDEVICETYPE: hc,
  IFCFLOWTERMINAL: fd,
  IFCFLOWTERMINALTYPE: cc,
  IFCFLOWTREATMENTDEVICE: hd,
  IFCFLOWTREATMENTDEVICETYPE: dc,
  IFCFLUIDFLOWPROPERTIES: Joe,
  IFCFONTSTYLE: Eze,
  IFCFONTVARIANT: yze,
  IFCFONTWEIGHT: mze,
  IFCFOOTING: J0,
  IFCFOOTINGTYPE: M2,
  IFCFORCEMEASURE: pze,
  IFCFREQUENCYMEASURE: Ize,
  IFCFUELPROPERTIES: kAe,
  IFCFURNISHINGELEMENT: jp,
  IFCFURNISHINGELEMENTTYPE: d3,
  IFCFURNITURE: Cg,
  IFCFURNITURESTANDARD: $Q,
  IFCFURNITURETYPE: gf,
  IFCGASTERMINALTYPE: aC,
  IFCGENERALMATERIALPROPERTIES: GAe,
  IFCGENERALPROFILEPROPERTIES: HAe,
  IFCGEOGRAPHICELEMENT: c5,
  IFCGEOGRAPHICELEMENTTYPE: $v,
  IFCGEOMETRICCURVESET: cA,
  IFCGEOMETRICREPRESENTATIONCONTEXT: BW,
  IFCGEOMETRICREPRESENTATIONITEM: Gae,
  IFCGEOMETRICREPRESENTATIONSUBCONTEXT: dE,
  IFCGEOMETRICSET: I8,
  IFCGEOMODEL: v_,
  IFCGEOSLICE: R_,
  IFCGEOTECHNICALASSEMBLY: mU,
  IFCGEOTECHNICALELEMENT: FV,
  IFCGEOTECHNICALSTRATUM: _U,
  IFCGLOBALLYUNIQUEID: _Ae,
  IFCGRADIENTCURVE: BV,
  IFCGRID: gu,
  IFCGRIDAXIS: Rje,
  IFCGRIDPLACEMENT: Hae,
  IFCGROUP: vN,
  IFCHALFSPACESOLID: f8,
  IFCHEATEXCHANGER: II,
  IFCHEATEXCHANGERTYPE: Iu,
  IFCHEATFLUXDENSITYMEASURE: fze,
  IFCHEATINGVALUEMEASURE: hze,
  IFCHOURINDAY: cze,
  IFCHUMIDIFIER: fI,
  IFCHUMIDIFIERTYPE: fu,
  IFCHYGROSCOPICMATERIALPROPERTIES: FAe,
  IFCIDENTIFIER: dze,
  IFCILLUMINANCEMEASURE: uze,
  IFCIMAGETEXTURE: EH,
  IFCIMPACTPROTECTIONDEVICE: LU,
  IFCIMPACTPROTECTIONDEVICETYPE: OU,
  IFCINDEXEDCOLOURMAP: eA,
  IFCINDEXEDPOLYCURVE: IN,
  IFCINDEXEDPOLYGONALFACE: xP,
  IFCINDEXEDPOLYGONALFACEWITHVOIDS: EN,
  IFCINDEXEDPOLYGONALTEXTUREMAP: Dz,
  IFCINDEXEDTEXTUREMAP: z2,
  IFCINDEXEDTRIANGLETEXTUREMAP: UP,
  IFCINDUCTANCEMEASURE: aze,
  IFCINTEGER: lze,
  IFCINTEGERCOUNTRATEMEASURE: rze,
  IFCINTERCEPTOR: hI,
  IFCINTERCEPTORTYPE: Mp,
  IFCINTERSECTIONCURVE: AO,
  IFCINVENTORY: i4,
  IFCIONCONCENTRATIONMEASURE: oze,
  IFCIRREGULARTIMESERIES: Fae,
  IFCIRREGULARTIMESERIESVALUE: Tje,
  IFCISHAPEPROFILEDEF: QP,
  IFCISOTHERMALMOISTURECAPACITYMEASURE: sze,
  IFCJUNCTIONBOX: cI,
  IFCJUNCTIONBOXTYPE: hu,
  IFCKERB: pU,
  IFCKERBTYPE: CU,
  IFCKINEMATICVISCOSITYMEASURE: nze,
  IFCLABEL: ize,
  IFCLABORRESOURCE: e3,
  IFCLABORRESOURCETYPE: qv,
  IFCLAGTIME: sme,
  IFCLAMP: dI,
  IFCLAMPTYPE: cu,
  IFCLANGUAGEID: Nke,
  IFCLENGTHMEASURE: tze,
  IFCLIBRARYINFORMATION: rue,
  IFCLIBRARYREFERENCE: sY,
  IFCLIGHTDISTRIBUTIONDATA: wje,
  IFCLIGHTFIXTURE: uI,
  IFCLIGHTFIXTURETYPE: du,
  IFCLIGHTINTENSITYDISTRIBUTION: gje,
  IFCLIGHTSOURCE: yH,
  IFCLIGHTSOURCEAMBIENT: QN,
  IFCLIGHTSOURCEDIRECTIONAL: ZN,
  IFCLIGHTSOURCEGONIOMETRIC: KN,
  IFCLIGHTSOURCEPOSITIONAL: $N,
  IFCLIGHTSOURCESPOT: m4,
  IFCLINE: dA,
  IFCLINEARDIMENSION: qQ,
  IFCLINEARELEMENT: OQ,
  IFCLINEARFORCEMEASURE: eze,
  IFCLINEARMOMENTMEASURE: XVe,
  IFCLINEARPLACEMENT: tme,
  IFCLINEARPOSITIONINGELEMENT: DV,
  IFCLINEARSTIFFNESSMEASURE: JVe,
  IFCLINEARVELOCITYMEASURE: QVe,
  IFCLINEINDEX: bke,
  IFCLIQUIDTERMINAL: QD,
  IFCLIQUIDTERMINALTYPE: nC,
  IFCLOCALPLACEMENT: x5,
  IFCLOCALTIME: Eje,
  IFCLOGICAL: ZVe,
  IFCLOOP: mH,
  IFCLSHAPEPROFILEDEF: ZP,
  IFCLUMINOUSFLUXMEASURE: KVe,
  IFCLUMINOUSINTENSITYDISTRIBUTIONMEASURE: $Ve,
  IFCLUMINOUSINTENSITYMEASURE: qVe,
  IFCMAGNETICFLUXDENSITYMEASURE: YVe,
  IFCMAGNETICFLUXMEASURE: WVe,
  IFCMANIFOLDSOLIDBREP: uA,
  IFCMAPCONVERSION: Oae,
  IFCMAPPEDITEM: hL,
  IFCMARINEFACILITY: M_,
  IFCMARINEPART: P_,
  IFCMASSDENSITYMEASURE: jVe,
  IFCMASSFLOWRATEMEASURE: zVe,
  IFCMASSMEASURE: VVe,
  IFCMASSPERLENGTHMEASURE: kVe,
  IFCMATERIAL: oue,
  IFCMATERIALCLASSIFICATIONRELATIONSHIP: oSe,
  IFCMATERIALCONSTITUENT: Nae,
  IFCMATERIALCONSTITUENTSET: iY,
  IFCMATERIALDEFINITION: eje,
  IFCMATERIALDEFINITIONREPRESENTATION: PH,
  IFCMATERIALLAYER: sue,
  IFCMATERIALLAYERSET: pL,
  IFCMATERIALLAYERSETUSAGE: nue,
  IFCMATERIALLAYERWITHOFFSETS: NX,
  IFCMATERIALLIST: sSe,
  IFCMATERIALPROFILE: Cae,
  IFCMATERIALPROFILESET: $P,
  IFCMATERIALPROFILESETUSAGE: bae,
  IFCMATERIALPROFILESETUSAGETAPERING: RX,
  IFCMATERIALPROFILEWITHOFFSETS: bX,
  IFCMATERIALPROPERTIES: Ta,
  IFCMATERIALRELATIONSHIP: XF,
  IFCMATERIALUSAGEDEFINITION: Xze,
  IFCMEASUREWITHUNIT: yje,
  IFCMECHANICALCONCRETEMATERIALPROPERTIES: lIe,
  IFCMECHANICALFASTENER: r0,
  IFCMECHANICALFASTENERTYPE: B0,
  IFCMECHANICALMATERIALPROPERTIES: nSe,
  IFCMECHANICALSTEELMATERIALPROPERTIES: cIe,
  IFCMEDICALDEVICE: aI,
  IFCMEDICALDEVICETYPE: Pp,
  IFCMEMBER: Q0,
  IFCMEMBERSTANDARDCASE: TC,
  IFCMEMBERTYPE: uf,
  IFCMETRIC: iue,
  IFCMINUTEINHOUR: GVe,
  IFCMIRROREDPROFILEDEF: TX,
  IFCMOBILETELECOMMUNICATIONSAPPLIANCE: ZD,
  IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE: iC,
  IFCMODULUSOFELASTICITYMEASURE: HVe,
  IFCMODULUSOFLINEARSUBGRADEREACTIONMEASURE: FVe,
  IFCMODULUSOFROTATIONALSUBGRADEREACTIONMEASURE: BVe,
  IFCMODULUSOFSUBGRADEREACTIONMEASURE: UVe,
  IFCMOISTUREDIFFUSIVITYMEASURE: MVe,
  IFCMOLECULARWEIGHTMEASURE: PVe,
  IFCMOMENTOFINERTIAMEASURE: xVe,
  IFCMONETARYMEASURE: _Ve,
  IFCMONETARYUNIT: iSe,
  IFCMONTHINYEARNUMBER: LVe,
  IFCMOORINGDEVICE: IU,
  IFCMOORINGDEVICETYPE: DU,
  IFCMOTORCONNECTION: lI,
  IFCMOTORCONNECTIONTYPE: uu,
  IFCMOVE: qV,
  IFCNAMEDUNIT: tSe,
  IFCNAVIGATIONELEMENT: fU,
  IFCNAVIGATIONELEMENTTYPE: NU,
  IFCNONNEGATIVELENGTHMEASURE: Ske,
  IFCNORMALISEDRATIOMEASURE: OVe,
  IFCNUMERICMEASURE: CVe,
  IFCOBJECT: eH,
  IFCOBJECTDEFINITION: Bae,
  IFCOBJECTIVE: tue,
  IFCOBJECTPLACEMENT: XQ,
  IFCOCCUPANT: t4,
  IFCOFFSETCURVE: Yoe,
  IFCOFFSETCURVE2D: iA,
  IFCOFFSETCURVE3D: tA,
  IFCOFFSETCURVEBYDISTANCES: MQ,
  IFCONEDIRECTIONREPEATFACTOR: rIe,
  IFCOPENCROSSPROFILEDEF: xAe,
  IFCOPENINGELEMENT: uc,
  IFCOPENINGSTANDARDCASE: gb,
  IFCOPENSHELL: bA,
  IFCOPTICALMATERIALPROPERTIES: eSe,
  IFCORDERACTION: YV,
  IFCORGANIZATION: t6,
  IFCORGANIZATIONRELATIONSHIP: IL,
  IFCORIENTEDEDGE: qN,
  IFCOUTERBOUNDARYCURVE: zy,
  IFCOUTLET: rI,
  IFCOUTLETTYPE: au,
  IFCOWNERHISTORY: mje,
  IFCPARAMETERIZEDPROFILEDEF: Uae,
  IFCPARAMETERVALUE: NVe,
  IFCPATH: h8,
  IFCPAVEMENT: J_,
  IFCPAVEMENTTYPE: bU,
  IFCPCURVE: _P,
  IFCPERFORMANCEHISTORY: e4,
  IFCPERMEABLECOVERINGPROPERTIES: g5,
  IFCPERMIT: X2,
  IFCPERSON: e6,
  IFCPERSONANDORGANIZATION: RH,
  IFCPHMEASURE: DVe,
  IFCPHYSICALCOMPLEXQUANTITY: Jr,
  IFCPHYSICALQUANTITY: pje,
  IFCPHYSICALSIMPLEQUANTITY: eue,
  IFCPILE: i0,
  IFCPILETYPE: Eg,
  IFCPIPEFITTING: oI,
  IFCPIPEFITTINGTYPE: lu,
  IFCPIPESEGMENT: sI,
  IFCPIPESEGMENTTYPE: ru,
  IFCPIXELTEXTURE: UW,
  IFCPLACEMENT: pH,
  IFCPLANARBOX: PN,
  IFCPLANAREXTENT: IH,
  IFCPLANARFORCEMEASURE: bVe,
  IFCPLANE: kg,
  IFCPLANEANGLEMEASURE: SVe,
  IFCPLATE: Z0,
  IFCPLATESTANDARDCASE: wC,
  IFCPLATETYPE: af,
  IFCPOINT: fH,
  IFCPOINTBYDISTANCEEXPRESSION: Koe,
  IFCPOINTONCURVE: YN,
  IFCPOINTONSURFACE: WN,
  IFCPOLYGONALBOUNDEDHALFSPACE: AA,
  IFCPOLYGONALFACESET: _g,
  IFCPOLYLINE: Ug,
  IFCPOLYLOOP: SA,
  IFCPOLYNOMIALCURVE: Woe,
  IFCPORT: J2,
  IFCPOSITIONINGELEMENT: CQ,
  IFCPOSITIVEINTEGER: Ake,
  IFCPOSITIVELENGTHMEASURE: AVe,
  IFCPOSITIVEPLANEANGLEMEASURE: vVe,
  IFCPOSITIVERATIOMEASURE: RVe,
  IFCPOSTALADDRESS: Xae,
  IFCPOWERMEASURE: TVe,
  IFCPREDEFINEDCOLOUR: MW,
  IFCPREDEFINEDCURVEFONT: PW,
  IFCPREDEFINEDDIMENSIONSYMBOL: oIe,
  IFCPREDEFINEDITEM: wme,
  IFCPREDEFINEDPOINTMARKERSYMBOL: sIe,
  IFCPREDEFINEDPROPERTIES: nme,
  IFCPREDEFINEDPROPERTYSET: UF,
  IFCPREDEFINEDSYMBOL: XAe,
  IFCPREDEFINEDTERMINATORSYMBOL: dIe,
  IFCPREDEFINEDTEXTFONT: VW,
  IFCPRESENTABLETEXT: wVe,
  IFCPRESENTATIONITEM: Jze,
  IFCPRESENTATIONLAYERASSIGNMENT: Ke,
  IFCPRESENTATIONLAYERWITHSTYLE: Jae,
  IFCPRESENTATIONSTYLE: Ije,
  IFCPRESENTATIONSTYLEASSIGNMENT: JAe,
  IFCPRESSUREMEASURE: gVe,
  IFCPROCEDURE: Q2,
  IFCPROCEDURETYPE: PO,
  IFCPROCESS: xN,
  IFCPRODUCT: Td,
  IFCPRODUCTDEFINITIONSHAPE: wie,
  IFCPRODUCTREPRESENTATION: wf,
  IFCPRODUCTSOFCOMBUSTIONPROPERTIES: QAe,
  IFCPROFILEDEF: ZAe,
  IFCPROFILEPROPERTIES: Rs,
  IFCPROJECT: Yg,
  IFCPROJECTEDCRS: hme,
  IFCPROJECTIONCURVE: QQ,
  IFCPROJECTIONELEMENT: wd,
  IFCPROJECTLIBRARY: MF,
  IFCPROJECTORDER: Z2,
  IFCPROJECTORDERRECORD: YQ,
  IFCPROPERTY: gme,
  IFCPROPERTYABSTRACTION: Qze,
  IFCPROPERTYBOUNDEDVALUE: nL,
  IFCPROPERTYCONSTRAINTRELATIONSHIP: fre,
  IFCPROPERTYDEFINITION: Mae,
  IFCPROPERTYDEPENDENCYRELATIONSHIP: cs,
  IFCPROPERTYENUMERATEDVALUE: iL,
  IFCPROPERTYENUMERATION: Eme,
  IFCPROPERTYLISTVALUE: tL,
  IFCPROPERTYREFERENCEVALUE: eL,
  IFCPROPERTYSET: Rl,
  IFCPROPERTYSETDEFINITION: hH,
  IFCPROPERTYSETDEFINITIONSET: vke,
  IFCPROPERTYSETTEMPLATE: w4,
  IFCPROPERTYSINGLEVALUE: jN,
  IFCPROPERTYTABLEVALUE: XO,
  IFCPROPERTYTEMPLATE: PF,
  IFCPROPERTYTEMPLATEDEFINITION: wX,
  IFCPROTECTIVEDEVICE: nI,
  IFCPROTECTIVEDEVICETRIPPINGUNIT: zm,
  IFCPROTECTIVEDEVICETRIPPINGUNITTYPE: Vy,
  IFCPROTECTIVEDEVICETYPE: ou,
  IFCPROXY: HO,
  IFCPUMP: iI,
  IFCPUMPTYPE: su,
  IFCQUANTITYAREA: C8,
  IFCQUANTITYCOUNT: D8,
  IFCQUANTITYLENGTH: N8,
  IFCQUANTITYNUMBER: wle,
  IFCQUANTITYSET: HF,
  IFCQUANTITYTIME: b8,
  IFCQUANTITYVOLUME: S8,
  IFCQUANTITYWEIGHT: A8,
  IFCRADIOACTIVITYMEASURE: EVe,
  IFCRADIUSDIMENSION: WQ,
  IFCRAIL: Q_,
  IFCRAILING: K0,
  IFCRAILINGTYPE: lf,
  IFCRAILTYPE: SU,
  IFCRAILWAY: x_,
  IFCRAILWAYPART: __,
  IFCRAMP: $0,
  IFCRAMPFLIGHT: q0,
  IFCRAMPFLIGHTTYPE: rf,
  IFCRAMPTYPE: P2,
  IFCRATIOMEASURE: yVe,
  IFCRATIONALBEZIERCURVE: HU,
  IFCRATIONALBSPLINECURVEWITHKNOTS: R2,
  IFCRATIONALBSPLINESURFACEWITHKNOTS: x2,
  IFCREAL: mVe,
  IFCRECTANGLEHOLLOWPROFILEDEF: aA,
  IFCRECTANGLEPROFILEDEF: c8,
  IFCRECTANGULARPYRAMID: _N,
  IFCRECTANGULARTRIMMEDSURFACE: f4,
  IFCRECURRENCEPATTERN: Zze,
  IFCREFERENCE: Kze,
  IFCREFERENCESVALUEDOCUMENT: hre,
  IFCREFERENT: UV,
  IFCREGULARTIMESERIES: Pae,
  IFCREINFORCEDSOIL: b_,
  IFCREINFORCEMENTBARPROPERTIES: OX,
  IFCREINFORCEMENTDEFINITIONPROPERTIES: b5,
  IFCREINFORCINGBAR: Ra,
  IFCREINFORCINGBARTYPE: ky,
  IFCREINFORCINGELEMENT: U0,
  IFCREINFORCINGELEMENTTYPE: _2,
  IFCREINFORCINGMESH: ku,
  IFCREINFORCINGMESHTYPE: Yy,
  IFCRELADHERESTOELEMENT: di,
  IFCRELAGGREGATES: U,
  IFCRELASSIGNS: ie,
  IFCRELASSIGNSTASKS: lB,
  IFCRELASSIGNSTOACTOR: Xp,
  IFCRELASSIGNSTOCONTROL: bs,
  IFCRELASSIGNSTOGROUP: Vs,
  IFCRELASSIGNSTOGROUPBYFACTOR: yN,
  IFCRELASSIGNSTOPROCESS: Xr,
  IFCRELASSIGNSTOPRODUCT: ge,
  IFCRELASSIGNSTOPROJECTORDER: uz,
  IFCRELASSIGNSTORESOURCE: Ns,
  IFCRELASSOCIATES: X,
  IFCRELASSOCIATESAPPLIEDVALUE: NJ,
  IFCRELASSOCIATESAPPROVAL: T4,
  IFCRELASSOCIATESCLASSIFICATION: lE,
  IFCRELASSOCIATESCONSTRAINT: lA,
  IFCRELASSOCIATESDOCUMENT: rE,
  IFCRELASSOCIATESLIBRARY: oE,
  IFCRELASSOCIATESMATERIAL: So,
  IFCRELASSOCIATESPROFILEDEF: SJ,
  IFCRELASSOCIATESPROFILEPROPERTIES: bJ,
  IFCRELATIONSHIP: xae,
  IFCRELAXATION: fje,
  IFCRELCONNECTS: KP,
  IFCRELCONNECTSELEMENTS: Te,
  IFCRELCONNECTSPATHELEMENTS: Gg,
  IFCRELCONNECTSPORTS: Ad,
  IFCRELCONNECTSPORTTOELEMENT: Vt,
  IFCRELCONNECTSSTRUCTURALACTIVITY: Un,
  IFCRELCONNECTSSTRUCTURALELEMENT: Hn,
  IFCRELCONNECTSSTRUCTURALMEMBER: Ko,
  IFCRELCONNECTSWITHECCENTRICITY: Hg,
  IFCRELCONNECTSWITHREALIZINGELEMENTS: ct,
  IFCRELCONTAINEDINSPATIALSTRUCTURE: Xe,
  IFCRELCOVERSBLDGELEMENTS: dt,
  IFCRELCOVERSSPACES: Jp,
  IFCRELDECLARES: me,
  IFCRELDECOMPOSES: Ye,
  IFCRELDEFINES: Ni,
  IFCRELDEFINESBYOBJECT: le,
  IFCRELDEFINESBYPROPERTIES: Fe,
  IFCRELDEFINESBYTEMPLATE: Zr,
  IFCRELDEFINESBYTYPE: fe,
  IFCRELFILLSELEMENT: ut,
  IFCRELFLOWCONTROLELEMENTS: ri,
  IFCRELINTERACTIONREQUIREMENTS: GF,
  IFCRELINTERFERESELEMENTS: Ce,
  IFCRELNESTS: B,
  IFCRELOCCUPIESSPACES: az,
  IFCRELOVERRIDESPROPERTIES: lz,
  IFCRELPOSITIONS: Yt,
  IFCRELPROJECTSELEMENT: lt,
  IFCRELREFERENCEDINSPATIALSTRUCTURE: We,
  IFCRELSCHEDULESCOSTITEMS: rz,
  IFCRELSEQUENCE: tr,
  IFCRELSERVICESBUILDINGS: ns,
  IFCRELSPACEBOUNDARY: at,
  IFCRELSPACEBOUNDARY1STLEVEL: xg,
  IFCRELSPACEBOUNDARY2NDLEVEL: Og,
  IFCRELVOIDSELEMENT: ot,
  IFCREPARAMETRISEDCOMPOSITECURVESEGMENT: gP,
  IFCREPRESENTATION: XN,
  IFCREPRESENTATIONCONTEXT: hje,
  IFCREPRESENTATIONITEM: cje,
  IFCREPRESENTATIONMAP: ah,
  IFCRESOURCE: LN,
  IFCRESOURCEAPPROVALRELATIONSHIP: ad,
  IFCRESOURCECONSTRAINTRELATIONSHIP: Gl,
  IFCRESOURCELEVELRELATIONSHIP: $ze,
  IFCRESOURCETIME: ime,
  IFCREVOLVEDAREASOLID: h4,
  IFCREVOLVEDAREASOLIDTAPERED: Yv,
  IFCRIBPLATEPROFILEPROPERTIES: KAe,
  IFCRIGHTCIRCULARCONE: ON,
  IFCRIGHTCIRCULARCYLINDER: CN,
  IFCROAD: IC,
  IFCROADPART: L_,
  IFCROOF: Y0,
  IFCROOFTYPE: L2,
  IFCROOT: dje,
  IFCROTATIONALFREQUENCYMEASURE: pVe,
  IFCROTATIONALMASSMEASURE: IVe,
  IFCROTATIONALSTIFFNESSMEASURE: fVe,
  IFCROUNDEDEDGEFEATURE: rC,
  IFCROUNDEDRECTANGLEPROFILEDEF: zN,
  IFCSANITARYTERMINAL: tI,
  IFCSANITARYTERMINALTYPE: nu,
  IFCSCHEDULETIMECONTROL: jQ,
  IFCSCHEDULINGTIME: qze,
  IFCSEAMCURVE: vO,
  IFCSECONDINMINUTE: hVe,
  IFCSECONDORDERPOLYNOMIALSPIRAL: DQ,
  IFCSECTIONALAREAINTEGRALMEASURE: dVe,
  IFCSECTIONEDSOLID: joe,
  IFCSECTIONEDSOLIDHORIZONTAL: PQ,
  IFCSECTIONEDSPINE: cH,
  IFCSECTIONEDSURFACE: zoe,
  IFCSECTIONMODULUSMEASURE: cVe,
  IFCSECTIONPROPERTIES: CX,
  IFCSECTIONREINFORCEMENTPROPERTIES: DX,
  IFCSEGMENT: Z1e,
  IFCSEGMENTEDREFERENCECURVE: MV,
  IFCSENSOR: Vm,
  IFCSENSORTYPE: oc,
  IFCSERVICELIFE: zQ,
  IFCSERVICELIFEFACTOR: lre,
  IFCSEVENTHORDERPOLYNOMIALSPIRAL: NQ,
  IFCSHADINGDEVICE: vg,
  IFCSHADINGDEVICETYPE: O2,
  IFCSHAPEASPECT: Qy,
  IFCSHAPEMODEL: Qae,
  IFCSHAPEREPRESENTATION: v8,
  IFCSHEARMODULUSMEASURE: uVe,
  IFCSHELLBASEDSURFACEMODEL: d8,
  IFCSIGN: ex,
  IFCSIGNAL: KD,
  IFCSIGNALTYPE: tC,
  IFCSIGNTYPE: AU,
  IFCSIMPLEPROPERTY: kW,
  IFCSIMPLEPROPERTYTEMPLATE: xO,
  IFCSINESPIRAL: bQ,
  IFCSITE: a0,
  IFCSIUNIT: Oie,
  IFCSLAB: W0,
  IFCSLABELEMENTEDCASE: gC,
  IFCSLABSTANDARDCASE: EC,
  IFCSLABTYPE: of,
  IFCSLIPPAGECONNECTIONCONDITION: _ae,
  IFCSOLARDEVICE: eI,
  IFCSOLARDEVICETYPE: xp,
  IFCSOLIDANGLEMEASURE: aVe,
  IFCSOLIDMODEL: dH,
  IFCSOUNDPOWERLEVELMEASURE: Rke,
  IFCSOUNDPOWERMEASURE: lVe,
  IFCSOUNDPRESSURELEVELMEASURE: Tke,
  IFCSOUNDPRESSUREMEASURE: rVe,
  IFCSOUNDPROPERTIES: rre,
  IFCSOUNDVALUE: ore,
  IFCSPACE: rh,
  IFCSPACEHEATER: X1,
  IFCSPACEHEATERTYPE: iu,
  IFCSPACEPROGRAM: VQ,
  IFCSPACETHERMALLOADPROPERTIES: sre,
  IFCSPACETYPE: sf,
  IFCSPATIALELEMENT: _O,
  IFCSPATIALELEMENTTYPE: LO,
  IFCSPATIALSTRUCTUREELEMENT: Zy,
  IFCSPATIALSTRUCTUREELEMENTTYPE: u3,
  IFCSPATIALZONE: Wv,
  IFCSPATIALZONETYPE: jv,
  IFCSPECIFICHEATCAPACITYMEASURE: oVe,
  IFCSPECULAREXPONENT: sVe,
  IFCSPECULARROUGHNESS: nVe,
  IFCSPHERE: DN,
  IFCSPHERICALSURFACE: OO,
  IFCSPIRAL: Voe,
  IFCSTACKTERMINAL: J1,
  IFCSTACKTERMINALTYPE: tu,
  IFCSTAIR: j0,
  IFCSTAIRFLIGHT: z0,
  IFCSTAIRFLIGHTTYPE: nf,
  IFCSTAIRTYPE: C2,
  IFCSTRUCTURALACTION: RI,
  IFCSTRUCTURALACTIVITY: c4,
  IFCSTRUCTURALANALYSISMODEL: ju,
  IFCSTRUCTURALCONNECTION: Xm,
  IFCSTRUCTURALCONNECTIONCONDITION: uje,
  IFCSTRUCTURALCURVEACTION: D2,
  IFCSTRUCTURALCURVECONNECTION: tf,
  IFCSTRUCTURALCURVEMEMBER: ef,
  IFCSTRUCTURALCURVEMEMBERVARYING: ac,
  IFCSTRUCTURALCURVEREACTION: N2,
  IFCSTRUCTURALITEM: d4,
  IFCSTRUCTURALLINEARACTION: o0,
  IFCSTRUCTURALLINEARACTIONVARYING: H_,
  IFCSTRUCTURALLOAD: aje,
  IFCSTRUCTURALLOADCASE: _v,
  IFCSTRUCTURALLOADCONFIGURATION: cme,
  IFCSTRUCTURALLOADGROUP: K2,
  IFCSTRUCTURALLOADLINEARFORCE: JO,
  IFCSTRUCTURALLOADORRESULT: dme,
  IFCSTRUCTURALLOADPLANARFORCE: QO,
  IFCSTRUCTURALLOADSINGLEDISPLACEMENT: ZO,
  IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION: S5,
  IFCSTRUCTURALLOADSINGLEFORCE: KO,
  IFCSTRUCTURALLOADSINGLEFORCEWARPING: A5,
  IFCSTRUCTURALLOADSTATIC: GW,
  IFCSTRUCTURALLOADTEMPERATURE: oL,
  IFCSTRUCTURALMEMBER: a3,
  IFCSTRUCTURALPLANARACTION: s0,
  IFCSTRUCTURALPLANARACTIONVARYING: F_,
  IFCSTRUCTURALPOINTACTION: Xh,
  IFCSTRUCTURALPOINTCONNECTION: Jh,
  IFCSTRUCTURALPOINTREACTION: Qh,
  IFCSTRUCTURALPROFILEPROPERTIES: nIe,
  IFCSTRUCTURALREACTION: l3,
  IFCSTRUCTURALRESULTGROUP: AI,
  IFCSTRUCTURALSTEELPROFILEPROPERTIES: nre,
  IFCSTRUCTURALSURFACEACTION: b2,
  IFCSTRUCTURALSURFACECONNECTION: Zh,
  IFCSTRUCTURALSURFACEMEMBER: Ef,
  IFCSTRUCTURALSURFACEMEMBERVARYING: Ec,
  IFCSTRUCTURALSURFACEREACTION: F2,
  IFCSTRUCTUREDDIMENSIONCALLOUT: Qoe,
  IFCSTYLEDITEM: Qe,
  IFCSTYLEDREPRESENTATION: R8,
  IFCSTYLEMODEL: Cie,
  IFCSUBCONTRACTRESOURCE: Jm,
  IFCSUBCONTRACTRESOURCETYPE: zv,
  IFCSUBEDGE: VN,
  IFCSURFACE: u8,
  IFCSURFACECURVE: xF,
  IFCSURFACECURVESWEPTAREASOLID: Lg,
  IFCSURFACEFEATURE: Dg,
  IFCSURFACEOFLINEAREXTRUSION: u4,
  IFCSURFACEOFREVOLUTION: a4,
  IFCSURFACEREINFORCEMENTAREA: SX,
  IFCSURFACESTYLE: Die,
  IFCSURFACESTYLELIGHTING: Zae,
  IFCSURFACESTYLEREFRACTION: Kae,
  IFCSURFACESTYLERENDERING: a8,
  IFCSURFACESTYLESHADING: $ae,
  IFCSURFACESTYLEWITHTEXTURES: N5,
  IFCSURFACETEXTURE: yme,
  IFCSWEPTAREASOLID: kN,
  IFCSWEPTDISKSOLID: GN,
  IFCSWEPTDISKSOLIDPOLYGONAL: BO,
  IFCSWEPTSURFACE: vA,
  IFCSWITCHINGDEVICE: Q1,
  IFCSWITCHINGDEVICETYPE: eu,
  IFCSYMBOLSTYLE: $Ae,
  IFCSYSTEM: $2,
  IFCSYSTEMFURNITUREELEMENT: Ng,
  IFCSYSTEMFURNITUREELEMENTTYPE: yf,
  IFCTABLE: qAe,
  IFCTABLECOLUMN: Yze,
  IFCTABLEROW: lje,
  IFCTANK: Z1,
  IFCTANKTYPE: Xa,
  IFCTASK: l4,
  IFCTASKTIME: ume,
  IFCTASKTIMERECURRING: AX,
  IFCTASKTYPE: CO,
  IFCTELECOMADDRESS: qae,
  IFCTEMPERATUREGRADIENTMEASURE: iVe,
  IFCTEMPERATURERATEOFCHANGEMEASURE: wke,
  IFCTENDON: Gu,
  IFCTENDONANCHOR: Hu,
  IFCTENDONANCHORTYPE: Wy,
  IFCTENDONCONDUIT: O_,
  IFCTENDONCONDUITTYPE: C_,
  IFCTENDONTYPE: jy,
  IFCTERMINATORSYMBOL: dz,
  IFCTESSELLATEDFACESET: LP,
  IFCTESSELLATEDITEM: gX,
  IFCTEXT: tVe,
  IFCTEXTALIGNMENT: eVe,
  IFCTEXTDECORATION: Xke,
  IFCTEXTFONTNAME: Jke,
  IFCTEXTLITERAL: aH,
  IFCTEXTLITERALWITHEXTENT: HN,
  IFCTEXTSTYLE: Yae,
  IFCTEXTSTYLEFONTMODEL: sL,
  IFCTEXTSTYLEFORDEFINEDFONT: mme,
  IFCTEXTSTYLETEXTMODEL: pme,
  IFCTEXTSTYLEWITHBOXCHARACTERISTICS: rje,
  IFCTEXTTRANSFORMATION: Qke,
  IFCTEXTURECOORDINATE: nA,
  IFCTEXTURECOORDINATEGENERATOR: HW,
  IFCTEXTURECOORDINATEINDICES: Q1e,
  IFCTEXTURECOORDINATEINDICESWITHVOIDS: UAe,
  IFCTEXTUREMAP: P5,
  IFCTEXTUREVERTEX: Ime,
  IFCTEXTUREVERTEXLIST: ame,
  IFCTHERMALADMITTANCEMEASURE: Zke,
  IFCTHERMALCONDUCTIVITYMEASURE: Kke,
  IFCTHERMALEXPANSIONCOEFFICIENTMEASURE: $ke,
  IFCTHERMALMATERIALPROPERTIES: YAe,
  IFCTHERMALRESISTANCEMEASURE: qke,
  IFCTHERMALTRANSMITTANCEMEASURE: Yke,
  IFCTHERMODYNAMICTEMPERATUREMEASURE: Wke,
  IFCTHIRDORDERPOLYNOMIALSPIRAL: xQ,
  IFCTIME: gke,
  IFCTIMEMEASURE: jke,
  IFCTIMEPERIOD: Wze,
  IFCTIMESERIES: oje,
  IFCTIMESERIESREFERENCERELATIONSHIP: cre,
  IFCTIMESERIESSCHEDULE: kQ,
  IFCTIMESERIESVALUE: sje,
  IFCTIMESTAMP: zke,
  IFCTOPOLOGICALREPRESENTATIONITEM: Wae,
  IFCTOPOLOGYREPRESENTATION: TH,
  IFCTOROIDALSURFACE: DO,
  IFCTORQUEMEASURE: Vke,
  IFCTRACKELEMENT: Z_,
  IFCTRACKELEMENTTYPE: vU,
  IFCTRANSFORMER: K1,
  IFCTRANSFORMERTYPE: Ja,
  IFCTRANSPORTATIONDEVICE: PV,
  IFCTRANSPORTATIONDEVICETYPE: kV,
  IFCTRANSPORTELEMENT: wI,
  IFCTRANSPORTELEMENTTYPE: Hp,
  IFCTRAPEZIUMPROFILEDEF: lH,
  IFCTRIANGULATEDFACESET: NO,
  IFCTRIANGULATEDIRREGULARNETWORK: GV,
  IFCTRIMMEDCURVE: Mg,
  IFCTSHAPEPROFILEDEF: uH,
  IFCTUBEBUNDLE: $1,
  IFCTUBEBUNDLETYPE: Qa,
  IFCTWODIRECTIONREPEATFACTOR: ire,
  IFCTYPEOBJECT: $s,
  IFCTYPEPROCESS: FF,
  IFCTYPEPRODUCT: FN,
  IFCTYPERESOURCE: BF,
  IFCUNITARYCONTROLELEMENT: km,
  IFCUNITARYCONTROLELEMENTTYPE: Gy,
  IFCUNITARYEQUIPMENT: q1,
  IFCUNITARYEQUIPMENTTYPE: Za,
  IFCUNITASSIGNMENT: fme,
  IFCURIREFERENCE: Eke,
  IFCUSHAPEPROFILEDEF: l8,
  IFCVALVE: Y1,
  IFCVALVETYPE: Ka,
  IFCVAPORPERMEABILITYMEASURE: kke,
  IFCVECTOR: rH,
  IFCVEHICLE: RU,
  IFCVEHICLETYPE: FU,
  IFCVERTEX: wH,
  IFCVERTEXBASEDTEXTUREMAP: nje,
  IFCVERTEXLOOP: BN,
  IFCVERTEXPOINT: JN,
  IFCVIBRATIONDAMPER: TU,
  IFCVIBRATIONDAMPERTYPE: wU,
  IFCVIBRATIONISOLATOR: bg,
  IFCVIBRATIONISOLATORTYPE: M0,
  IFCVIRTUALELEMENT: zp,
  IFCVIRTUALGRIDINTERSECTION: jae,
  IFCVOIDINGFEATURE: Wm,
  IFCVOLUMEMEASURE: Gke,
  IFCVOLUMETRICFLOWRATEMEASURE: Hke,
  IFCWALL: V0,
  IFCWALLELEMENTEDCASE: yC,
  IFCWALLSTANDARDCASE: cd,
  IFCWALLTYPE: Kh,
  IFCWARPINGCONSTANTMEASURE: Fke,
  IFCWARPINGMOMENTMEASURE: Bke,
  IFCWASTETERMINAL: W1,
  IFCWASTETERMINALTYPE: $a,
  IFCWATERPROPERTIES: WAe,
  IFCWINDOW: k0,
  IFCWINDOWLININGPROPERTIES: v5,
  IFCWINDOWPANELPROPERTIES: R5,
  IFCWINDOWSTANDARDCASE: mC,
  IFCWINDOWSTYLE: kO,
  IFCWINDOWTYPE: S2,
  IFCWORKCALENDAR: RO,
  IFCWORKCONTROL: q2,
  IFCWORKPLAN: Qm,
  IFCWORKSCHEDULE: Zm,
  IFCWORKTIME: lme,
  IFCYEARNUMBER: Uke,
  IFCZONE: Ky,
  IFCZSHAPEPROFILEDEF: oH,
  INTEGER: Kje,
  IfcAPI: jW,
  IfcLineObject: qt,
  InheritanceDef: wP,
  InversePropertyDef: _ie,
  LABEL: kje,
  LINE_END: $je,
  LogLevel: Mie,
  NumberHandle: pt,
  Properties: pSe,
  REAL: zje,
  REF: jje,
  SET_BEGIN: Yje,
  SET_END: qje,
  STRING: jT,
  SchemaNames: TP,
  Schemas: ISe,
  ToRawLineData: Pie,
  TypeInitialisers: AH,
  UNKNOWN: Gje,
  logical: fSe,
  ms: Zje
}, Symbol.toStringTag, { value: "Module" }));
var Zge, DJ, Qb, YT, Jb, ZV, Ab, CJ, tJ, I1, qT, jh, Bu, oo, pg, s5, Uy, Sp, rN, bp, Xb, eN, o5, tN, aB, yg, iJ, mre, fIe, cz, tx, Tle, r5, IIe, ySe, hz, OJ, Rle, uC, G_, AC, ix, yre, $de, ESe, LJ, vle, nJ, Ere, ta, wa, gre, Kde, QV, sJ, EO, RP, Ale, pIe, Jje = Object.defineProperty, De = (e, t, i) => (((n, s, o) => {
  s in n ? Jje(n, s, { enumerable: !0, configurable: !0, writable: !0, value: o }) : n[s] = o;
})(e, typeof t != "symbol" ? t + "" : t, i), i), Sme = (e, t, i) => {
  if (!t.has(e)) throw TypeError("Cannot " + i);
}, Bt = (e, t, i) => (Sme(e, t, "read from private field"), i ? i.call(e) : t.get(e)), qs = (e, t, i) => {
  if (t.has(e)) throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, i);
}, Ts = (e, t, i, n) => (Sme(e, t, "write to private field"), t.set(e, i), i), mIe = (e, t, i, n) => ({ set _(s) {
  Ts(e, t, s);
}, get _() {
  return Bt(e, t, n);
} }), Qn = (e, t, i) => (Sme(e, t, "access private method"), i);
const Oz = { 950732822: "IFCURIREFERENCE", 4075327185: "IFCTIME", 1209108979: "IFCTEMPERATURERATEOFCHANGEMEASURE", 3457685358: "IFCSOUNDPRESSURELEVELMEASURE", 4157543285: "IFCSOUNDPOWERLEVELMEASURE", 2798247006: "IFCPROPERTYSETDEFINITIONSET", 1790229001: "IFCPOSITIVEINTEGER", 525895558: "IFCNONNEGATIVELENGTHMEASURE", 1774176899: "IFCLINEINDEX", 1275358634: "IFCLANGUAGEID", 2541165894: "IFCDURATION", 3701338814: "IFCDAYINWEEKNUMBER", 2195413836: "IFCDATETIME", 937566702: "IFCDATE", 1683019596: "IFCCARDINALPOINTREFERENCE", 2314439260: "IFCBINARY", 1500781891: "IFCAREADENSITYMEASURE", 3683503648: "IFCARCINDEX", 4065007721: "IFCYEARNUMBER", 1718600412: "IFCWARPINGMOMENTMEASURE", 51269191: "IFCWARPINGCONSTANTMEASURE", 2593997549: "IFCVOLUMETRICFLOWRATEMEASURE", 3458127941: "IFCVOLUMEMEASURE", 3345633955: "IFCVAPORPERMEABILITYMEASURE", 1278329552: "IFCTORQUEMEASURE", 2591213694: "IFCTIMESTAMP", 2726807636: "IFCTIMEMEASURE", 743184107: "IFCTHERMODYNAMICTEMPERATUREMEASURE", 2016195849: "IFCTHERMALTRANSMITTANCEMEASURE", 857959152: "IFCTHERMALRESISTANCEMEASURE", 2281867870: "IFCTHERMALEXPANSIONCOEFFICIENTMEASURE", 2645777649: "IFCTHERMALCONDUCTIVITYMEASURE", 232962298: "IFCTHERMALADMITTANCEMEASURE", 296282323: "IFCTEXTTRANSFORMATION", 603696268: "IFCTEXTFONTNAME", 3490877962: "IFCTEXTDECORATION", 1460886941: "IFCTEXTALIGNMENT", 2801250643: "IFCTEXT", 58845555: "IFCTEMPERATUREGRADIENTMEASURE", 361837227: "IFCSPECULARROUGHNESS", 2757832317: "IFCSPECULAREXPONENT", 3477203348: "IFCSPECIFICHEATCAPACITYMEASURE", 993287707: "IFCSOUNDPRESSUREMEASURE", 846465480: "IFCSOUNDPOWERMEASURE", 3471399674: "IFCSOLIDANGLEMEASURE", 408310005: "IFCSHEARMODULUSMEASURE", 2190458107: "IFCSECTIONALAREAINTEGRALMEASURE", 3467162246: "IFCSECTIONMODULUSMEASURE", 2766185779: "IFCSECONDINMINUTE", 3211557302: "IFCROTATIONALSTIFFNESSMEASURE", 1755127002: "IFCROTATIONALMASSMEASURE", 2133746277: "IFCROTATIONALFREQUENCYMEASURE", 200335297: "IFCREAL", 96294661: "IFCRATIOMEASURE", 3972513137: "IFCRADIOACTIVITYMEASURE", 3665567075: "IFCPRESSUREMEASURE", 2169031380: "IFCPRESENTABLETEXT", 1364037233: "IFCPOWERMEASURE", 1245737093: "IFCPOSITIVERATIOMEASURE", 3054510233: "IFCPOSITIVEPLANEANGLEMEASURE", 2815919920: "IFCPOSITIVELENGTHMEASURE", 4042175685: "IFCPLANEANGLEMEASURE", 2642773653: "IFCPLANARFORCEMEASURE", 2260317790: "IFCPARAMETERVALUE", 929793134: "IFCPHMEASURE", 2395907400: "IFCNUMERICMEASURE", 2095195183: "IFCNORMALISEDRATIOMEASURE", 765770214: "IFCMONTHINYEARNUMBER", 2615040989: "IFCMONETARYMEASURE", 3114022597: "IFCMOMENTOFINERTIAMEASURE", 1648970520: "IFCMOLECULARWEIGHTMEASURE", 3177669450: "IFCMOISTUREDIFFUSIVITYMEASURE", 1753493141: "IFCMODULUSOFSUBGRADEREACTIONMEASURE", 1052454078: "IFCMODULUSOFROTATIONALSUBGRADEREACTIONMEASURE", 2173214787: "IFCMODULUSOFLINEARSUBGRADEREACTIONMEASURE", 3341486342: "IFCMODULUSOFELASTICITYMEASURE", 102610177: "IFCMINUTEINHOUR", 3531705166: "IFCMASSPERLENGTHMEASURE", 3124614049: "IFCMASSMEASURE", 4017473158: "IFCMASSFLOWRATEMEASURE", 1477762836: "IFCMASSDENSITYMEASURE", 2486716878: "IFCMAGNETICFLUXMEASURE", 286949696: "IFCMAGNETICFLUXDENSITYMEASURE", 151039812: "IFCLUMINOUSINTENSITYMEASURE", 2755797622: "IFCLUMINOUSINTENSITYDISTRIBUTIONMEASURE", 2095003142: "IFCLUMINOUSFLUXMEASURE", 503418787: "IFCLOGICAL", 3086160713: "IFCLINEARVELOCITYMEASURE", 1307019551: "IFCLINEARSTIFFNESSMEASURE", 2128979029: "IFCLINEARMOMENTMEASURE", 191860431: "IFCLINEARFORCEMEASURE", 1243674935: "IFCLENGTHMEASURE", 3258342251: "IFCLABEL", 2054016361: "IFCKINEMATICVISCOSITYMEASURE", 3192672207: "IFCISOTHERMALMOISTURECAPACITYMEASURE", 3686016028: "IFCIONCONCENTRATIONMEASURE", 3809634241: "IFCINTEGERCOUNTRATEMEASURE", 1939436016: "IFCINTEGER", 2679005408: "IFCINDUCTANCEMEASURE", 3358199106: "IFCILLUMINANCEMEASURE", 983778844: "IFCIDENTIFIER", 2589826445: "IFCHOURINDAY", 1158859006: "IFCHEATINGVALUEMEASURE", 3113092358: "IFCHEATFLUXDENSITYMEASURE", 3064340077: "IFCGLOBALLYUNIQUEID", 3044325142: "IFCFREQUENCYMEASURE", 1361398929: "IFCFORCEMEASURE", 2590844177: "IFCFONTWEIGHT", 2715512545: "IFCFONTVARIANT", 1102727119: "IFCFONTSTYLE", 2078135608: "IFCENERGYMEASURE", 2506197118: "IFCELECTRICVOLTAGEMEASURE", 2951915441: "IFCELECTRICRESISTANCEMEASURE", 3790457270: "IFCELECTRICCURRENTMEASURE", 2093906313: "IFCELECTRICCONDUCTANCEMEASURE", 3818826038: "IFCELECTRICCHARGEMEASURE", 1827137117: "IFCELECTRICCAPACITANCEMEASURE", 69416015: "IFCDYNAMICVISCOSITYMEASURE", 524656162: "IFCDOSEEQUIVALENTMEASURE", 4134073009: "IFCDIMENSIONCOUNT", 1514641115: "IFCDESCRIPTIVEMEASURE", 300323983: "IFCDAYLIGHTSAVINGHOUR", 86635668: "IFCDAYINMONTHNUMBER", 94842927: "IFCCURVATUREMEASURE", 1778710042: "IFCCOUNTMEASURE", 3238673880: "IFCCONTEXTDEPENDENTMEASURE", 3812528620: "IFCCOMPOUNDPLANEANGLEMEASURE", 2991860651: "IFCCOMPLEXNUMBER", 1867003952: "IFCBOXALIGNMENT", 2735952531: "IFCBOOLEAN", 2650437152: "IFCAREAMEASURE", 632304761: "IFCANGULARVELOCITYMEASURE", 360377573: "IFCAMOUNTOFSUBSTANCEMEASURE", 4182062534: "IFCACCELERATIONMEASURE", 3699917729: "IFCABSORBEDDOSEMEASURE", 1971632696: "IFCGEOSLICE", 2680139844: "IFCGEOMODEL", 24726584: "IFCELECTRICFLOWTREATMENTDEVICE", 3693000487: "IFCDISTRIBUTIONBOARD", 3460952963: "IFCCONVEYORSEGMENT", 3999819293: "IFCCAISSONFOUNDATION", 3314249567: "IFCBOREHOLE", 4196446775: "IFCBEARING", 325726236: "IFCALIGNMENT", 3425753595: "IFCTRACKELEMENT", 991950508: "IFCSIGNAL", 3798194928: "IFCREINFORCEDSOIL", 3290496277: "IFCRAIL", 1383356374: "IFCPAVEMENT", 2182337498: "IFCNAVIGATIONELEMENT", 234836483: "IFCMOORINGDEVICE", 2078563270: "IFCMOBILETELECOMMUNICATIONSAPPLIANCE", 1638804497: "IFCLIQUIDTERMINAL", 1154579445: "IFCLINEARPOSITIONINGELEMENT", 2696325953: "IFCKERB", 2713699986: "IFCGEOTECHNICALASSEMBLY", 2142170206: "IFCELECTRICFLOWTREATMENTDEVICETYPE", 3376911765: "IFCEARTHWORKSFILL", 1077100507: "IFCEARTHWORKSELEMENT", 3071239417: "IFCEARTHWORKSCUT", 479945903: "IFCDISTRIBUTIONBOARDTYPE", 3426335179: "IFCDEEPFOUNDATION", 1502416096: "IFCCOURSE", 2940368186: "IFCCONVEYORSEGMENTTYPE", 3203706013: "IFCCAISSONFOUNDATIONTYPE", 3862327254: "IFCBUILTSYSTEM", 1876633798: "IFCBUILTELEMENT", 963979645: "IFCBRIDGEPART", 644574406: "IFCBRIDGE", 3649138523: "IFCBEARINGTYPE", 1662888072: "IFCALIGNMENTVERTICAL", 317615605: "IFCALIGNMENTSEGMENT", 1545765605: "IFCALIGNMENTHORIZONTAL", 4266260250: "IFCALIGNMENTCANT", 3956297820: "IFCVIBRATIONDAMPERTYPE", 1530820697: "IFCVIBRATIONDAMPER", 840318589: "IFCVEHICLE", 1953115116: "IFCTRANSPORTATIONDEVICE", 618700268: "IFCTRACKELEMENTTYPE", 2281632017: "IFCTENDONCONDUITTYPE", 3663046924: "IFCTENDONCONDUIT", 42703149: "IFCSINESPIRAL", 1894708472: "IFCSIGNALTYPE", 3599934289: "IFCSIGNTYPE", 33720170: "IFCSIGN", 1027922057: "IFCSEVENTHORDERPOLYNOMIALSPIRAL", 544395925: "IFCSEGMENTEDREFERENCECURVE", 3649235739: "IFCSECONDORDERPOLYNOMIALSPIRAL", 550521510: "IFCROADPART", 146592293: "IFCROAD", 3818125796: "IFCRELADHERESTOELEMENT", 4021432810: "IFCREFERENT", 1891881377: "IFCRAILWAYPART", 3992365140: "IFCRAILWAY", 1763565496: "IFCRAILTYPE", 1946335990: "IFCPOSITIONINGELEMENT", 514975943: "IFCPAVEMENTTYPE", 506776471: "IFCNAVIGATIONELEMENTTYPE", 710110818: "IFCMOORINGDEVICETYPE", 1950438474: "IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE", 976884017: "IFCMARINEPART", 525669439: "IFCMARINEFACILITY", 1770583370: "IFCLIQUIDTERMINALTYPE", 2176059722: "IFCLINEARELEMENT", 679976338: "IFCKERBTYPE", 3948183225: "IFCIMPACTPROTECTIONDEVICETYPE", 2568555532: "IFCIMPACTPROTECTIONDEVICE", 2898700619: "IFCGRADIENTCURVE", 1594536857: "IFCGEOTECHNICALSTRATUM", 4230923436: "IFCGEOTECHNICALELEMENT", 4228831410: "IFCFACILITYPARTCOMMON", 1310830890: "IFCFACILITYPART", 24185140: "IFCFACILITY", 4234616927: "IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID", 1306400036: "IFCDEEPFOUNDATIONTYPE", 4189326743: "IFCCOURSETYPE", 2000195564: "IFCCOSINESPIRAL", 3497074424: "IFCCLOTHOID", 1626504194: "IFCBUILTELEMENTTYPE", 3651464721: "IFCVEHICLETYPE", 1229763772: "IFCTRIANGULATEDIRREGULARNETWORK", 3665877780: "IFCTRANSPORTATIONDEVICETYPE", 782932809: "IFCTHIRDORDERPOLYNOMIALSPIRAL", 2735484536: "IFCSPIRAL", 1356537516: "IFCSECTIONEDSURFACE", 1290935644: "IFCSECTIONEDSOLIDHORIZONTAL", 1862484736: "IFCSECTIONEDSOLID", 1441486842: "IFCRELPOSITIONS", 1033248425: "IFCRELASSOCIATESPROFILEDEF", 3381221214: "IFCPOLYNOMIALCURVE", 2485787929: "IFCOFFSETCURVEBYDISTANCES", 590820931: "IFCOFFSETCURVE", 3465909080: "IFCINDEXEDPOLYGONALTEXTUREMAP", 593015953: "IFCDIRECTRIXCURVESWEPTAREASOLID", 4212018352: "IFCCURVESEGMENT", 3425423356: "IFCAXIS2PLACEMENTLINEAR", 823603102: "IFCSEGMENT", 2165702409: "IFCPOINTBYDISTANCEEXPRESSION", 182550632: "IFCOPENCROSSPROFILEDEF", 388784114: "IFCLINEARPLACEMENT", 536804194: "IFCALIGNMENTHORIZONTALSEGMENT", 3752311538: "IFCALIGNMENTCANTSEGMENT", 1010789467: "IFCTEXTURECOORDINATEINDICESWITHVOIDS", 222769930: "IFCTEXTURECOORDINATEINDICES", 2691318326: "IFCQUANTITYNUMBER", 3633395639: "IFCALIGNMENTVERTICALSEGMENT", 2879124712: "IFCALIGNMENTPARAMETERSEGMENT", 25142252: "IFCCONTROLLER", 3087945054: "IFCALARM", 4288193352: "IFCACTUATOR", 630975310: "IFCUNITARYCONTROLELEMENT", 4086658281: "IFCSENSOR", 2295281155: "IFCPROTECTIVEDEVICETRIPPINGUNIT", 182646315: "IFCFLOWINSTRUMENT", 1426591983: "IFCFIRESUPPRESSIONTERMINAL", 819412036: "IFCFILTER", 3415622556: "IFCFAN", 1003880860: "IFCELECTRICTIMECONTROL", 402227799: "IFCELECTRICMOTOR", 264262732: "IFCELECTRICGENERATOR", 3310460725: "IFCELECTRICFLOWSTORAGEDEVICE", 862014818: "IFCELECTRICDISTRIBUTIONBOARD", 1904799276: "IFCELECTRICAPPLIANCE", 1360408905: "IFCDUCTSILENCER", 3518393246: "IFCDUCTSEGMENT", 342316401: "IFCDUCTFITTING", 562808652: "IFCDISTRIBUTIONCIRCUIT", 4074379575: "IFCDAMPER", 3640358203: "IFCCOOLINGTOWER", 4136498852: "IFCCOOLEDBEAM", 2272882330: "IFCCONDENSER", 3571504051: "IFCCOMPRESSOR", 3221913625: "IFCCOMMUNICATIONSAPPLIANCE", 639361253: "IFCCOIL", 3902619387: "IFCCHILLER", 4217484030: "IFCCABLESEGMENT", 1051757585: "IFCCABLEFITTING", 3758799889: "IFCCABLECARRIERSEGMENT", 635142910: "IFCCABLECARRIERFITTING", 2938176219: "IFCBURNER", 32344328: "IFCBOILER", 2906023776: "IFCBEAMSTANDARDCASE", 277319702: "IFCAUDIOVISUALAPPLIANCE", 2056796094: "IFCAIRTOAIRHEATRECOVERY", 177149247: "IFCAIRTERMINALBOX", 1634111441: "IFCAIRTERMINAL", 486154966: "IFCWINDOWSTANDARDCASE", 4237592921: "IFCWASTETERMINAL", 4156078855: "IFCWALLELEMENTEDCASE", 4207607924: "IFCVALVE", 4292641817: "IFCUNITARYEQUIPMENT", 3179687236: "IFCUNITARYCONTROLELEMENTTYPE", 3026737570: "IFCTUBEBUNDLE", 3825984169: "IFCTRANSFORMER", 812556717: "IFCTANK", 1162798199: "IFCSWITCHINGDEVICE", 385403989: "IFCSTRUCTURALLOADCASE", 1404847402: "IFCSTACKTERMINAL", 1999602285: "IFCSPACEHEATER", 3420628829: "IFCSOLARDEVICE", 3027962421: "IFCSLABSTANDARDCASE", 3127900445: "IFCSLABELEMENTEDCASE", 1329646415: "IFCSHADINGDEVICE", 3053780830: "IFCSANITARYTERMINAL", 2572171363: "IFCREINFORCINGBARTYPE", 1232101972: "IFCRATIONALBSPLINECURVEWITHKNOTS", 90941305: "IFCPUMP", 655969474: "IFCPROTECTIVEDEVICETRIPPINGUNITTYPE", 738039164: "IFCPROTECTIVEDEVICE", 1156407060: "IFCPLATESTANDARDCASE", 3612865200: "IFCPIPESEGMENT", 310824031: "IFCPIPEFITTING", 3694346114: "IFCOUTLET", 144952367: "IFCOUTERBOUNDARYCURVE", 2474470126: "IFCMOTORCONNECTION", 1911478936: "IFCMEMBERSTANDARDCASE", 1437502449: "IFCMEDICALDEVICE", 629592764: "IFCLIGHTFIXTURE", 76236018: "IFCLAMP", 2176052936: "IFCJUNCTIONBOX", 4175244083: "IFCINTERCEPTOR", 2068733104: "IFCHUMIDIFIER", 3319311131: "IFCHEATEXCHANGER", 2188021234: "IFCFLOWMETER", 1209101575: "IFCEXTERNALSPATIALELEMENT", 484807127: "IFCEVAPORATOR", 3747195512: "IFCEVAPORATIVECOOLER", 2814081492: "IFCENGINE", 2417008758: "IFCELECTRICDISTRIBUTIONBOARDTYPE", 3242481149: "IFCDOORSTANDARDCASE", 3205830791: "IFCDISTRIBUTIONSYSTEM", 400855858: "IFCCOMMUNICATIONSAPPLIANCETYPE", 905975707: "IFCCOLUMNSTANDARDCASE", 1677625105: "IFCCIVILELEMENT", 3296154744: "IFCCHIMNEY", 2674252688: "IFCCABLEFITTINGTYPE", 2188180465: "IFCBURNERTYPE", 1177604601: "IFCBUILDINGSYSTEM", 39481116: "IFCBUILDINGELEMENTPARTTYPE", 1136057603: "IFCBOUNDARYCURVE", 2461110595: "IFCBSPLINECURVEWITHKNOTS", 1532957894: "IFCAUDIOVISUALAPPLIANCETYPE", 4088093105: "IFCWORKCALENDAR", 4009809668: "IFCWINDOWTYPE", 926996030: "IFCVOIDINGFEATURE", 2391383451: "IFCVIBRATIONISOLATOR", 2415094496: "IFCTENDONTYPE", 3081323446: "IFCTENDONANCHORTYPE", 413509423: "IFCSYSTEMFURNITUREELEMENT", 3101698114: "IFCSURFACEFEATURE", 3657597509: "IFCSTRUCTURALSURFACEACTION", 2757150158: "IFCSTRUCTURALCURVEREACTION", 1004757350: "IFCSTRUCTURALCURVEACTION", 338393293: "IFCSTAIRTYPE", 1072016465: "IFCSOLARDEVICETYPE", 4074543187: "IFCSHADINGDEVICETYPE", 2157484638: "IFCSEAMCURVE", 2781568857: "IFCROOFTYPE", 2310774935: "IFCREINFORCINGMESHTYPE", 964333572: "IFCREINFORCINGELEMENTTYPE", 683857671: "IFCRATIONALBSPLINESURFACEWITHKNOTS", 1469900589: "IFCRAMPTYPE", 2839578677: "IFCPOLYGONALFACESET", 1158309216: "IFCPILETYPE", 3079942009: "IFCOPENINGSTANDARDCASE", 1114901282: "IFCMEDICALDEVICETYPE", 3113134337: "IFCINTERSECTIONCURVE", 3946677679: "IFCINTERCEPTORTYPE", 2571569899: "IFCINDEXEDPOLYCURVE", 3493046030: "IFCGEOGRAPHICELEMENT", 1509553395: "IFCFURNITURE", 1893162501: "IFCFOOTINGTYPE", 2853485674: "IFCEXTERNALSPATIALSTRUCTUREELEMENT", 4148101412: "IFCEVENT", 132023988: "IFCENGINETYPE", 2397081782: "IFCELEMENTASSEMBLYTYPE", 2323601079: "IFCDOORTYPE", 1213902940: "IFCCYLINDRICALSURFACE", 1525564444: "IFCCONSTRUCTIONPRODUCTRESOURCETYPE", 4105962743: "IFCCONSTRUCTIONMATERIALRESOURCETYPE", 2185764099: "IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE", 15328376: "IFCCOMPOSITECURVEONSURFACE", 3875453745: "IFCCOMPLEXPROPERTYTEMPLATE", 3893394355: "IFCCIVILELEMENTTYPE", 2197970202: "IFCCHIMNEYTYPE", 167062518: "IFCBSPLINESURFACEWITHKNOTS", 2887950389: "IFCBSPLINESURFACE", 2603310189: "IFCADVANCEDBREPWITHVOIDS", 1635779807: "IFCADVANCEDBREP", 2916149573: "IFCTRIANGULATEDFACESET", 1935646853: "IFCTOROIDALSURFACE", 2387106220: "IFCTESSELLATEDFACESET", 3206491090: "IFCTASKTYPE", 699246055: "IFCSURFACECURVE", 4095615324: "IFCSUBCONTRACTRESOURCETYPE", 603775116: "IFCSTRUCTURALSURFACEREACTION", 4015995234: "IFCSPHERICALSURFACE", 2481509218: "IFCSPATIALZONETYPE", 463610769: "IFCSPATIALZONE", 710998568: "IFCSPATIALELEMENTTYPE", 1412071761: "IFCSPATIALELEMENT", 3663146110: "IFCSIMPLEPROPERTYTEMPLATE", 3243963512: "IFCREVOLVEDAREASOLIDTAPERED", 816062949: "IFCREPARAMETRISEDCOMPOSITECURVESEGMENT", 1521410863: "IFCRELSPACEBOUNDARY2NDLEVEL", 3523091289: "IFCRELSPACEBOUNDARY1STLEVEL", 427948657: "IFCRELINTERFERESELEMENTS", 307848117: "IFCRELDEFINESBYTEMPLATE", 1462361463: "IFCRELDEFINESBYOBJECT", 2565941209: "IFCRELDECLARES", 1027710054: "IFCRELASSIGNSTOGROUPBYFACTOR", 3521284610: "IFCPROPERTYTEMPLATE", 492091185: "IFCPROPERTYSETTEMPLATE", 653396225: "IFCPROJECTLIBRARY", 569719735: "IFCPROCEDURETYPE", 3967405729: "IFCPREDEFINEDPROPERTYSET", 1682466193: "IFCPCURVE", 428585644: "IFCLABORRESOURCETYPE", 2294589976: "IFCINDEXEDPOLYGONALFACEWITHVOIDS", 178912537: "IFCINDEXEDPOLYGONALFACE", 4095422895: "IFCGEOGRAPHICELEMENTTYPE", 2652556860: "IFCFIXEDREFERENCESWEPTAREASOLID", 2804161546: "IFCEXTRUDEDAREASOLIDTAPERED", 4024345920: "IFCEVENTTYPE", 2629017746: "IFCCURVEBOUNDEDSURFACE", 1815067380: "IFCCREWRESOURCETYPE", 3419103109: "IFCCONTEXT", 2574617495: "IFCCONSTRUCTIONRESOURCETYPE", 2059837836: "IFCCARTESIANPOINTLIST3D", 1675464909: "IFCCARTESIANPOINTLIST2D", 574549367: "IFCCARTESIANPOINTLIST", 3406155212: "IFCADVANCEDFACE", 3698973494: "IFCTYPERESOURCE", 3736923433: "IFCTYPEPROCESS", 901063453: "IFCTESSELLATEDITEM", 1096409881: "IFCSWEPTDISKSOLIDPOLYGONAL", 1042787934: "IFCRESOURCETIME", 1608871552: "IFCRESOURCECONSTRAINTRELATIONSHIP", 2943643501: "IFCRESOURCEAPPROVALRELATIONSHIP", 2090586900: "IFCQUANTITYSET", 1482703590: "IFCPROPERTYTEMPLATEDEFINITION", 3778827333: "IFCPREDEFINEDPROPERTIES", 2998442950: "IFCMIRROREDPROFILEDEF", 853536259: "IFCMATERIALRELATIONSHIP", 3404854881: "IFCMATERIALPROFILESETUSAGETAPERING", 3079605661: "IFCMATERIALPROFILESETUSAGE", 2852063980: "IFCMATERIALCONSTITUENTSET", 3708119e3: "IFCMATERIALCONSTITUENT", 1585845231: "IFCLAGTIME", 2133299955: "IFCINDEXEDTRIANGLETEXTUREMAP", 1437953363: "IFCINDEXEDTEXTUREMAP", 3570813810: "IFCINDEXEDCOLOURMAP", 1437805879: "IFCEXTERNALREFERENCERELATIONSHIP", 297599258: "IFCEXTENDEDPROPERTIES", 211053100: "IFCEVENTTIME", 2713554722: "IFCCONVERSIONBASEDUNITWITHOFFSET", 3285139300: "IFCCOLOURRGBLIST", 1236880293: "IFCWORKTIME", 1199560280: "IFCTIMEPERIOD", 3611470254: "IFCTEXTUREVERTEXLIST", 2771591690: "IFCTASKTIMERECURRING", 1549132990: "IFCTASKTIME", 2043862942: "IFCTABLECOLUMN", 2934153892: "IFCSURFACEREINFORCEMENTAREA", 609421318: "IFCSTRUCTURALLOADORRESULT", 3478079324: "IFCSTRUCTURALLOADCONFIGURATION", 1054537805: "IFCSCHEDULINGTIME", 2439245199: "IFCRESOURCELEVELRELATIONSHIP", 2433181523: "IFCREFERENCE", 3915482550: "IFCRECURRENCEPATTERN", 986844984: "IFCPROPERTYABSTRACTION", 3843373140: "IFCPROJECTEDCRS", 677532197: "IFCPRESENTATIONITEM", 1507914824: "IFCMATERIALUSAGEDEFINITION", 552965576: "IFCMATERIALPROFILEWITHOFFSETS", 164193824: "IFCMATERIALPROFILESET", 2235152071: "IFCMATERIALPROFILE", 1847252529: "IFCMATERIALLAYERWITHOFFSETS", 760658860: "IFCMATERIALDEFINITION", 3057273783: "IFCMAPCONVERSION", 4294318154: "IFCEXTERNALINFORMATION", 1466758467: "IFCCOORDINATEREFERENCESYSTEM", 1785450214: "IFCCOORDINATEOPERATION", 775493141: "IFCCONNECTIONVOLUMEGEOMETRY", 979691226: "IFCREINFORCINGBAR", 3700593921: "IFCELECTRICDISTRIBUTIONPOINT", 1062813311: "IFCDISTRIBUTIONCONTROLELEMENT", 1052013943: "IFCDISTRIBUTIONCHAMBERELEMENT", 578613899: "IFCCONTROLLERTYPE", 2454782716: "IFCCHAMFEREDGEFEATURE", 753842376: "IFCBEAM", 3001207471: "IFCALARMTYPE", 2874132201: "IFCACTUATORTYPE", 3304561284: "IFCWINDOW", 3512223829: "IFCWALLSTANDARDCASE", 2391406946: "IFCWALL", 3313531582: "IFCVIBRATIONISOLATORTYPE", 2347447852: "IFCTENDONANCHOR", 3824725483: "IFCTENDON", 2515109513: "IFCSTRUCTURALANALYSISMODEL", 4252922144: "IFCSTAIRFLIGHT", 331165859: "IFCSTAIR", 1529196076: "IFCSLAB", 1783015770: "IFCSENSORTYPE", 1376911519: "IFCROUNDEDEDGEFEATURE", 2016517767: "IFCROOF", 2320036040: "IFCREINFORCINGMESH", 3027567501: "IFCREINFORCINGELEMENT", 3055160366: "IFCRATIONALBEZIERCURVE", 3283111854: "IFCRAMPFLIGHT", 3024970846: "IFCRAMP", 2262370178: "IFCRAILING", 3171933400: "IFCPLATE", 1687234759: "IFCPILE", 1073191201: "IFCMEMBER", 900683007: "IFCFOOTING", 3508470533: "IFCFLOWTREATMENTDEVICE", 2223149337: "IFCFLOWTERMINAL", 707683696: "IFCFLOWSTORAGEDEVICE", 987401354: "IFCFLOWSEGMENT", 3132237377: "IFCFLOWMOVINGDEVICE", 4037862832: "IFCFLOWINSTRUMENTTYPE", 4278956645: "IFCFLOWFITTING", 2058353004: "IFCFLOWCONTROLLER", 4222183408: "IFCFIRESUPPRESSIONTERMINALTYPE", 1810631287: "IFCFILTERTYPE", 346874300: "IFCFANTYPE", 1658829314: "IFCENERGYCONVERSIONDEVICE", 857184966: "IFCELECTRICALELEMENT", 1634875225: "IFCELECTRICALCIRCUIT", 712377611: "IFCELECTRICTIMECONTROLTYPE", 1217240411: "IFCELECTRICMOTORTYPE", 1365060375: "IFCELECTRICHEATERTYPE", 1534661035: "IFCELECTRICGENERATORTYPE", 3277789161: "IFCELECTRICFLOWSTORAGEDEVICETYPE", 663422040: "IFCELECTRICAPPLIANCETYPE", 855621170: "IFCEDGEFEATURE", 2030761528: "IFCDUCTSILENCERTYPE", 3760055223: "IFCDUCTSEGMENTTYPE", 869906466: "IFCDUCTFITTINGTYPE", 395920057: "IFCDOOR", 3041715199: "IFCDISTRIBUTIONPORT", 3040386961: "IFCDISTRIBUTIONFLOWELEMENT", 1945004755: "IFCDISTRIBUTIONELEMENT", 2063403501: "IFCDISTRIBUTIONCONTROLELEMENTTYPE", 1599208980: "IFCDISTRIBUTIONCHAMBERELEMENTTYPE", 2635815018: "IFCDISCRETEACCESSORYTYPE", 1335981549: "IFCDISCRETEACCESSORY", 4147604152: "IFCDIAMETERDIMENSION", 3961806047: "IFCDAMPERTYPE", 3495092785: "IFCCURTAINWALL", 1973544240: "IFCCOVERING", 2954562838: "IFCCOOLINGTOWERTYPE", 335055490: "IFCCOOLEDBEAMTYPE", 488727124: "IFCCONSTRUCTIONPRODUCTRESOURCE", 1060000209: "IFCCONSTRUCTIONMATERIALRESOURCE", 3898045240: "IFCCONSTRUCTIONEQUIPMENTRESOURCE", 1163958913: "IFCCONDITIONCRITERION", 2188551683: "IFCCONDITION", 2816379211: "IFCCONDENSERTYPE", 3850581409: "IFCCOMPRESSORTYPE", 843113511: "IFCCOLUMN", 2301859152: "IFCCOILTYPE", 2611217952: "IFCCIRCLE", 2951183804: "IFCCHILLERTYPE", 1285652485: "IFCCABLESEGMENTTYPE", 3293546465: "IFCCABLECARRIERSEGMENTTYPE", 395041908: "IFCCABLECARRIERFITTINGTYPE", 1909888760: "IFCBUILDINGELEMENTPROXYTYPE", 1095909175: "IFCBUILDINGELEMENTPROXY", 2979338954: "IFCBUILDINGELEMENTPART", 52481810: "IFCBUILDINGELEMENTCOMPONENT", 3299480353: "IFCBUILDINGELEMENT", 231477066: "IFCBOILERTYPE", 1916977116: "IFCBEZIERCURVE", 819618141: "IFCBEAMTYPE", 1967976161: "IFCBSPLINECURVE", 3460190687: "IFCASSET", 2470393545: "IFCANGULARDIMENSION", 1871374353: "IFCAIRTOAIRHEATRECOVERYTYPE", 3352864051: "IFCAIRTERMINALTYPE", 1411407467: "IFCAIRTERMINALBOXTYPE", 3821786052: "IFCACTIONREQUEST", 1213861670: "IFC2DCOMPOSITECURVE", 1033361043: "IFCZONE", 3342526732: "IFCWORKSCHEDULE", 4218914973: "IFCWORKPLAN", 1028945134: "IFCWORKCONTROL", 1133259667: "IFCWASTETERMINALTYPE", 1898987631: "IFCWALLTYPE", 2769231204: "IFCVIRTUALELEMENT", 728799441: "IFCVALVETYPE", 1911125066: "IFCUNITARYEQUIPMENTTYPE", 1600972822: "IFCTUBEBUNDLETYPE", 3593883385: "IFCTRIMMEDCURVE", 1620046519: "IFCTRANSPORTELEMENT", 1692211062: "IFCTRANSFORMERTYPE", 1637806684: "IFCTIMESERIESSCHEDULE", 5716631: "IFCTANKTYPE", 2254336722: "IFCSYSTEM", 2315554128: "IFCSWITCHINGDEVICETYPE", 148013059: "IFCSUBCONTRACTRESOURCE", 1975003073: "IFCSTRUCTURALSURFACECONNECTION", 2986769608: "IFCSTRUCTURALRESULTGROUP", 1235345126: "IFCSTRUCTURALPOINTREACTION", 734778138: "IFCSTRUCTURALPOINTCONNECTION", 2082059205: "IFCSTRUCTURALPOINTACTION", 3987759626: "IFCSTRUCTURALPLANARACTIONVARYING", 1621171031: "IFCSTRUCTURALPLANARACTION", 1252848954: "IFCSTRUCTURALLOADGROUP", 1721250024: "IFCSTRUCTURALLINEARACTIONVARYING", 1807405624: "IFCSTRUCTURALLINEARACTION", 2445595289: "IFCSTRUCTURALCURVEMEMBERVARYING", 214636428: "IFCSTRUCTURALCURVEMEMBER", 4243806635: "IFCSTRUCTURALCURVECONNECTION", 1179482911: "IFCSTRUCTURALCONNECTION", 682877961: "IFCSTRUCTURALACTION", 1039846685: "IFCSTAIRFLIGHTTYPE", 3112655638: "IFCSTACKTERMINALTYPE", 3812236995: "IFCSPACETYPE", 652456506: "IFCSPACEPROGRAM", 1305183839: "IFCSPACEHEATERTYPE", 3856911033: "IFCSPACE", 2533589738: "IFCSLABTYPE", 4097777520: "IFCSITE", 4105383287: "IFCSERVICELIFE", 3517283431: "IFCSCHEDULETIMECONTROL", 1768891740: "IFCSANITARYTERMINALTYPE", 2863920197: "IFCRELASSIGNSTASKS", 160246688: "IFCRELAGGREGATES", 2324767716: "IFCRAMPFLIGHTTYPE", 2893384427: "IFCRAILINGTYPE", 3248260540: "IFCRADIUSDIMENSION", 2250791053: "IFCPUMPTYPE", 1842657554: "IFCPROTECTIVEDEVICETYPE", 3651124850: "IFCPROJECTIONELEMENT", 3642467123: "IFCPROJECTORDERRECORD", 2904328755: "IFCPROJECTORDER", 2744685151: "IFCPROCEDURE", 3740093272: "IFCPORT", 3724593414: "IFCPOLYLINE", 4017108033: "IFCPLATETYPE", 4231323485: "IFCPIPESEGMENTTYPE", 804291784: "IFCPIPEFITTINGTYPE", 3327091369: "IFCPERMIT", 2382730787: "IFCPERFORMANCEHISTORY", 2837617999: "IFCOUTLETTYPE", 3425660407: "IFCORDERACTION", 3588315303: "IFCOPENINGELEMENT", 4143007308: "IFCOCCUPANT", 1916936684: "IFCMOVE", 977012517: "IFCMOTORCONNECTIONTYPE", 3181161470: "IFCMEMBERTYPE", 2108223431: "IFCMECHANICALFASTENERTYPE", 377706215: "IFCMECHANICALFASTENER", 2506943328: "IFCLINEARDIMENSION", 1161773419: "IFCLIGHTFIXTURETYPE", 1051575348: "IFCLAMPTYPE", 3827777499: "IFCLABORRESOURCE", 4288270099: "IFCJUNCTIONBOXTYPE", 2391368822: "IFCINVENTORY", 1806887404: "IFCHUMIDIFIERTYPE", 1251058090: "IFCHEATEXCHANGERTYPE", 2706460486: "IFCGROUP", 3009204131: "IFCGRID", 200128114: "IFCGASTERMINALTYPE", 814719939: "IFCFURNITURESTANDARD", 263784265: "IFCFURNISHINGELEMENT", 3009222698: "IFCFLOWTREATMENTDEVICETYPE", 2297155007: "IFCFLOWTERMINALTYPE", 1339347760: "IFCFLOWSTORAGEDEVICETYPE", 1834744321: "IFCFLOWSEGMENTTYPE", 1482959167: "IFCFLOWMOVINGDEVICETYPE", 3815607619: "IFCFLOWMETERTYPE", 3198132628: "IFCFLOWFITTINGTYPE", 3907093117: "IFCFLOWCONTROLLERTYPE", 1287392070: "IFCFEATUREELEMENTSUBTRACTION", 2143335405: "IFCFEATUREELEMENTADDITION", 2827207264: "IFCFEATUREELEMENT", 2489546625: "IFCFASTENERTYPE", 647756555: "IFCFASTENER", 3737207727: "IFCFACETEDBREPWITHVOIDS", 807026263: "IFCFACETEDBREP", 3390157468: "IFCEVAPORATORTYPE", 3174744832: "IFCEVAPORATIVECOOLERTYPE", 3272907226: "IFCEQUIPMENTSTANDARD", 1962604670: "IFCEQUIPMENTELEMENT", 2107101300: "IFCENERGYCONVERSIONDEVICETYPE", 1704287377: "IFCELLIPSE", 2590856083: "IFCELEMENTCOMPONENTTYPE", 1623761950: "IFCELEMENTCOMPONENT", 4123344466: "IFCELEMENTASSEMBLY", 1758889154: "IFCELEMENT", 360485395: "IFCELECTRICALBASEPROPERTIES", 3849074793: "IFCDISTRIBUTIONFLOWELEMENTTYPE", 3256556792: "IFCDISTRIBUTIONELEMENTTYPE", 681481545: "IFCDIMENSIONCURVEDIRECTEDCALLOUT", 1457835157: "IFCCURTAINWALLTYPE", 3295246426: "IFCCREWRESOURCE", 1916426348: "IFCCOVERINGTYPE", 1419761937: "IFCCOSTSCHEDULE", 3895139033: "IFCCOSTITEM", 3293443760: "IFCCONTROL", 2559216714: "IFCCONSTRUCTIONRESOURCE", 2510884976: "IFCCONIC", 3732776249: "IFCCOMPOSITECURVE", 300633059: "IFCCOLUMNTYPE", 2937912522: "IFCCIRCLEHOLLOWPROFILEDEF", 3124254112: "IFCBUILDINGSTOREY", 1950629157: "IFCBUILDINGELEMENTTYPE", 4031249490: "IFCBUILDING", 1260505505: "IFCBOUNDEDCURVE", 3649129432: "IFCBOOLEANCLIPPINGRESULT", 1334484129: "IFCBLOCK", 3207858831: "IFCASYMMETRICISHAPEPROFILEDEF", 1674181508: "IFCANNOTATION", 2296667514: "IFCACTOR", 2097647324: "IFCTRANSPORTELEMENTTYPE", 3473067441: "IFCTASK", 1580310250: "IFCSYSTEMFURNITUREELEMENTTYPE", 4124788165: "IFCSURFACEOFREVOLUTION", 2809605785: "IFCSURFACEOFLINEAREXTRUSION", 2028607225: "IFCSURFACECURVESWEPTAREASOLID", 4070609034: "IFCSTRUCTUREDDIMENSIONCALLOUT", 2218152070: "IFCSTRUCTURALSURFACEMEMBERVARYING", 3979015343: "IFCSTRUCTURALSURFACEMEMBER", 3689010777: "IFCSTRUCTURALREACTION", 530289379: "IFCSTRUCTURALMEMBER", 3136571912: "IFCSTRUCTURALITEM", 3544373492: "IFCSTRUCTURALACTIVITY", 451544542: "IFCSPHERE", 3893378262: "IFCSPATIALSTRUCTUREELEMENTTYPE", 2706606064: "IFCSPATIALSTRUCTUREELEMENT", 3626867408: "IFCRIGHTCIRCULARCYLINDER", 4158566097: "IFCRIGHTCIRCULARCONE", 1856042241: "IFCREVOLVEDAREASOLID", 2914609552: "IFCRESOURCE", 1401173127: "IFCRELVOIDSELEMENT", 3451746338: "IFCRELSPACEBOUNDARY", 366585022: "IFCRELSERVICESBUILDINGS", 4122056220: "IFCRELSEQUENCE", 1058617721: "IFCRELSCHEDULESCOSTITEMS", 1245217292: "IFCRELREFERENCEDINSPATIALSTRUCTURE", 750771296: "IFCRELPROJECTSELEMENT", 202636808: "IFCRELOVERRIDESPROPERTIES", 2051452291: "IFCRELOCCUPIESSPACES", 3268803585: "IFCRELNESTS", 4189434867: "IFCRELINTERACTIONREQUIREMENTS", 279856033: "IFCRELFLOWCONTROLELEMENTS", 3940055652: "IFCRELFILLSELEMENT", 781010003: "IFCRELDEFINESBYTYPE", 4186316022: "IFCRELDEFINESBYPROPERTIES", 693640335: "IFCRELDEFINES", 2551354335: "IFCRELDECOMPOSES", 2802773753: "IFCRELCOVERSSPACES", 886880790: "IFCRELCOVERSBLDGELEMENTS", 3242617779: "IFCRELCONTAINEDINSPATIALSTRUCTURE", 3678494232: "IFCRELCONNECTSWITHREALIZINGELEMENTS", 504942748: "IFCRELCONNECTSWITHECCENTRICITY", 1638771189: "IFCRELCONNECTSSTRUCTURALMEMBER", 3912681535: "IFCRELCONNECTSSTRUCTURALELEMENT", 2127690289: "IFCRELCONNECTSSTRUCTURALACTIVITY", 3190031847: "IFCRELCONNECTSPORTS", 4201705270: "IFCRELCONNECTSPORTTOELEMENT", 3945020480: "IFCRELCONNECTSPATHELEMENTS", 1204542856: "IFCRELCONNECTSELEMENTS", 826625072: "IFCRELCONNECTS", 2851387026: "IFCRELASSOCIATESPROFILEPROPERTIES", 2655215786: "IFCRELASSOCIATESMATERIAL", 3840914261: "IFCRELASSOCIATESLIBRARY", 982818633: "IFCRELASSOCIATESDOCUMENT", 2728634034: "IFCRELASSOCIATESCONSTRAINT", 919958153: "IFCRELASSOCIATESCLASSIFICATION", 4095574036: "IFCRELASSOCIATESAPPROVAL", 1327628568: "IFCRELASSOCIATESAPPLIEDVALUE", 1865459582: "IFCRELASSOCIATES", 205026976: "IFCRELASSIGNSTORESOURCE", 3372526763: "IFCRELASSIGNSTOPROJECTORDER", 2857406711: "IFCRELASSIGNSTOPRODUCT", 4278684876: "IFCRELASSIGNSTOPROCESS", 1307041759: "IFCRELASSIGNSTOGROUP", 2495723537: "IFCRELASSIGNSTOCONTROL", 1683148259: "IFCRELASSIGNSTOACTOR", 3939117080: "IFCRELASSIGNS", 3454111270: "IFCRECTANGULARTRIMMEDSURFACE", 2798486643: "IFCRECTANGULARPYRAMID", 2770003689: "IFCRECTANGLEHOLLOWPROFILEDEF", 3219374653: "IFCPROXY", 1451395588: "IFCPROPERTYSET", 4194566429: "IFCPROJECTIONCURVE", 103090709: "IFCPROJECT", 4208778838: "IFCPRODUCT", 2945172077: "IFCPROCESS", 220341763: "IFCPLANE", 603570806: "IFCPLANARBOX", 3566463478: "IFCPERMEABLECOVERINGPROPERTIES", 3505215534: "IFCOFFSETCURVE3D", 3388369263: "IFCOFFSETCURVE2D", 3888040117: "IFCOBJECT", 1425443689: "IFCMANIFOLDSOLIDBREP", 1281925730: "IFCLINE", 572779678: "IFCLSHAPEPROFILEDEF", 1484403080: "IFCISHAPEPROFILEDEF", 987898635: "IFCGEOMETRICCURVESET", 1268542332: "IFCFURNITURETYPE", 4238390223: "IFCFURNISHINGELEMENTTYPE", 3455213021: "IFCFLUIDFLOWPROPERTIES", 315944413: "IFCFILLAREASTYLETILES", 4203026998: "IFCFILLAREASTYLETILESYMBOLWITHSTYLE", 374418227: "IFCFILLAREASTYLEHATCHING", 2047409740: "IFCFACEBASEDSURFACEMODEL", 477187591: "IFCEXTRUDEDAREASOLID", 80994333: "IFCENERGYPROPERTIES", 2835456948: "IFCELLIPSEPROFILEDEF", 2777663545: "IFCELEMENTARYSURFACE", 339256511: "IFCELEMENTTYPE", 1883228015: "IFCELEMENTQUANTITY", 1472233963: "IFCEDGELOOP", 4006246654: "IFCDRAUGHTINGPREDEFINEDCURVEFONT", 445594917: "IFCDRAUGHTINGPREDEFINEDCOLOUR", 3073041342: "IFCDRAUGHTINGCALLOUT", 526551008: "IFCDOORSTYLE", 1714330368: "IFCDOORPANELPROPERTIES", 2963535650: "IFCDOORLININGPROPERTIES", 32440307: "IFCDIRECTION", 4054601972: "IFCDIMENSIONCURVETERMINATOR", 606661476: "IFCDIMENSIONCURVE", 693772133: "IFCDEFINEDSYMBOL", 2827736869: "IFCCURVEBOUNDEDPLANE", 2601014836: "IFCCURVE", 2147822146: "IFCCSGSOLID", 2506170314: "IFCCSGPRIMITIVE3D", 194851669: "IFCCRANERAILFSHAPEPROFILEDEF", 4133800736: "IFCCRANERAILASHAPEPROFILEDEF", 2485617015: "IFCCOMPOSITECURVESEGMENT", 2205249479: "IFCCLOSEDSHELL", 1383045692: "IFCCIRCLEPROFILEDEF", 1416205885: "IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM", 3331915920: "IFCCARTESIANTRANSFORMATIONOPERATOR3D", 3486308946: "IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM", 3749851601: "IFCCARTESIANTRANSFORMATIONOPERATOR2D", 59481748: "IFCCARTESIANTRANSFORMATIONOPERATOR", 1123145078: "IFCCARTESIANPOINT", 2898889636: "IFCCSHAPEPROFILEDEF", 2713105998: "IFCBOXEDHALFSPACE", 2581212453: "IFCBOUNDINGBOX", 4182860854: "IFCBOUNDEDSURFACE", 2736907675: "IFCBOOLEANRESULT", 2740243338: "IFCAXIS2PLACEMENT3D", 3125803723: "IFCAXIS2PLACEMENT2D", 4261334040: "IFCAXIS1PLACEMENT", 1302238472: "IFCANNOTATIONSURFACE", 2265737646: "IFCANNOTATIONFILLAREAOCCURRENCE", 669184980: "IFCANNOTATIONFILLAREA", 3288037868: "IFCANNOTATIONCURVEOCCURRENCE", 2543172580: "IFCZSHAPEPROFILEDEF", 1299126871: "IFCWINDOWSTYLE", 512836454: "IFCWINDOWPANELPROPERTIES", 336235671: "IFCWINDOWLININGPROPERTIES", 2759199220: "IFCVERTEXLOOP", 1417489154: "IFCVECTOR", 427810014: "IFCUSHAPEPROFILEDEF", 2347495698: "IFCTYPEPRODUCT", 1628702193: "IFCTYPEOBJECT", 1345879162: "IFCTWODIRECTIONREPEATFACTOR", 2715220739: "IFCTRAPEZIUMPROFILEDEF", 3124975700: "IFCTEXTLITERALWITHEXTENT", 4282788508: "IFCTEXTLITERAL", 3028897424: "IFCTERMINATORSYMBOL", 3071757647: "IFCTSHAPEPROFILEDEF", 230924584: "IFCSWEPTSURFACE", 1260650574: "IFCSWEPTDISKSOLID", 2247615214: "IFCSWEPTAREASOLID", 1878645084: "IFCSURFACESTYLERENDERING", 2513912981: "IFCSURFACE", 2233826070: "IFCSUBEDGE", 3653947884: "IFCSTRUCTURALSTEELPROFILEPROPERTIES", 3843319758: "IFCSTRUCTURALPROFILEPROPERTIES", 1190533807: "IFCSTRUCTURALLOADSINGLEFORCEWARPING", 1597423693: "IFCSTRUCTURALLOADSINGLEFORCE", 1973038258: "IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION", 2473145415: "IFCSTRUCTURALLOADSINGLEDISPLACEMENT", 2668620305: "IFCSTRUCTURALLOADPLANARFORCE", 1595516126: "IFCSTRUCTURALLOADLINEARFORCE", 390701378: "IFCSPACETHERMALLOADPROPERTIES", 1202362311: "IFCSOUNDVALUE", 2485662743: "IFCSOUNDPROPERTIES", 723233188: "IFCSOLIDMODEL", 2609359061: "IFCSLIPPAGECONNECTIONCONDITION", 4124623270: "IFCSHELLBASEDSURFACEMODEL", 2411513650: "IFCSERVICELIFEFACTOR", 1509187699: "IFCSECTIONEDSPINE", 2778083089: "IFCROUNDEDRECTANGLEPROFILEDEF", 478536968: "IFCRELATIONSHIP", 3765753017: "IFCREINFORCEMENTDEFINITIONPROPERTIES", 3413951693: "IFCREGULARTIMESERIES", 3615266464: "IFCRECTANGLEPROFILEDEF", 110355661: "IFCPROPERTYTABLEVALUE", 3650150729: "IFCPROPERTYSINGLEVALUE", 3357820518: "IFCPROPERTYSETDEFINITION", 941946838: "IFCPROPERTYREFERENCEVALUE", 2752243245: "IFCPROPERTYLISTVALUE", 4166981789: "IFCPROPERTYENUMERATEDVALUE", 1680319473: "IFCPROPERTYDEFINITION", 871118103: "IFCPROPERTYBOUNDEDVALUE", 673634403: "IFCPRODUCTDEFINITIONSHAPE", 179317114: "IFCPREDEFINEDPOINTMARKERSYMBOL", 433424934: "IFCPREDEFINEDDIMENSIONSYMBOL", 2559016684: "IFCPREDEFINEDCURVEFONT", 759155922: "IFCPREDEFINEDCOLOUR", 2775532180: "IFCPOLYGONALBOUNDEDHALFSPACE", 2924175390: "IFCPOLYLOOP", 1423911732: "IFCPOINTONSURFACE", 4022376103: "IFCPOINTONCURVE", 2067069095: "IFCPOINT", 1663979128: "IFCPLANAREXTENT", 2004835150: "IFCPLACEMENT", 597895409: "IFCPIXELTEXTURE", 3021840470: "IFCPHYSICALCOMPLEXQUANTITY", 2519244187: "IFCPATH", 2529465313: "IFCPARAMETERIZEDPROFILEDEF", 1029017970: "IFCORIENTEDEDGE", 2665983363: "IFCOPENSHELL", 2833995503: "IFCONEDIRECTIONREPEATFACTOR", 219451334: "IFCOBJECTDEFINITION", 1430189142: "IFCMECHANICALCONCRETEMATERIALPROPERTIES", 2022407955: "IFCMATERIALDEFINITIONREPRESENTATION", 2347385850: "IFCMAPPEDITEM", 1008929658: "IFCLOOP", 2624227202: "IFCLOCALPLACEMENT", 3422422726: "IFCLIGHTSOURCESPOT", 1520743889: "IFCLIGHTSOURCEPOSITIONAL", 4266656042: "IFCLIGHTSOURCEGONIOMETRIC", 2604431987: "IFCLIGHTSOURCEDIRECTIONAL", 125510826: "IFCLIGHTSOURCEAMBIENT", 1402838566: "IFCLIGHTSOURCE", 3741457305: "IFCIRREGULARTIMESERIES", 3905492369: "IFCIMAGETEXTURE", 2445078500: "IFCHYGROSCOPICMATERIALPROPERTIES", 812098782: "IFCHALFSPACESOLID", 178086475: "IFCGRIDPLACEMENT", 3590301190: "IFCGEOMETRICSET", 4142052618: "IFCGEOMETRICREPRESENTATIONSUBCONTEXT", 2453401579: "IFCGEOMETRICREPRESENTATIONITEM", 3448662350: "IFCGEOMETRICREPRESENTATIONCONTEXT", 1446786286: "IFCGENERALPROFILEPROPERTIES", 803998398: "IFCGENERALMATERIALPROPERTIES", 3857492461: "IFCFUELPROPERTIES", 738692330: "IFCFILLAREASTYLE", 4219587988: "IFCFAILURECONNECTIONCONDITION", 3008276851: "IFCFACESURFACE", 803316827: "IFCFACEOUTERBOUND", 1809719519: "IFCFACEBOUND", 2556980723: "IFCFACE", 1860660968: "IFCEXTENDEDMATERIALPROPERTIES", 476780140: "IFCEDGECURVE", 3900360178: "IFCEDGE", 4170525392: "IFCDRAUGHTINGPREDEFINEDTEXTFONT", 3732053477: "IFCDOCUMENTREFERENCE", 1694125774: "IFCDIMENSIONPAIR", 2273265877: "IFCDIMENSIONCALLOUTRELATIONSHIP", 3632507154: "IFCDERIVEDPROFILEDEF", 3800577675: "IFCCURVESTYLE", 2889183280: "IFCCONVERSIONBASEDUNIT", 3050246964: "IFCCONTEXTDEPENDENTUNIT", 45288368: "IFCCONNECTIONPOINTECCENTRICITY", 1981873012: "IFCCONNECTIONCURVEGEOMETRY", 370225590: "IFCCONNECTEDFACESET", 1485152156: "IFCCOMPOSITEPROFILEDEF", 2542286263: "IFCCOMPLEXPROPERTY", 776857604: "IFCCOLOURRGB", 647927063: "IFCCLASSIFICATIONREFERENCE", 3150382593: "IFCCENTERLINEPROFILEDEF", 616511568: "IFCBLOBTEXTURE", 2705031697: "IFCARBITRARYPROFILEDEFWITHVOIDS", 1310608509: "IFCARBITRARYOPENPROFILEDEF", 3798115385: "IFCARBITRARYCLOSEDPROFILEDEF", 2297822566: "IFCANNOTATIONTEXTOCCURRENCE", 3612888222: "IFCANNOTATIONSYMBOLOCCURRENCE", 962685235: "IFCANNOTATIONSURFACEOCCURRENCE", 2442683028: "IFCANNOTATIONOCCURRENCE", 1065908215: "IFCWATERPROPERTIES", 891718957: "IFCVIRTUALGRIDINTERSECTION", 1907098498: "IFCVERTEXPOINT", 3304826586: "IFCVERTEXBASEDTEXTUREMAP", 2799835756: "IFCVERTEX", 180925521: "IFCUNITASSIGNMENT", 1735638870: "IFCTOPOLOGYREPRESENTATION", 1377556343: "IFCTOPOLOGICALREPRESENTATIONITEM", 581633288: "IFCTIMESERIESVALUE", 1718945513: "IFCTIMESERIESREFERENCERELATIONSHIP", 3101149627: "IFCTIMESERIES", 3317419933: "IFCTHERMALMATERIALPROPERTIES", 1210645708: "IFCTEXTUREVERTEX", 2552916305: "IFCTEXTUREMAP", 1742049831: "IFCTEXTURECOORDINATEGENERATOR", 280115917: "IFCTEXTURECOORDINATE", 1484833681: "IFCTEXTSTYLEWITHBOXCHARACTERISTICS", 1640371178: "IFCTEXTSTYLETEXTMODEL", 2636378356: "IFCTEXTSTYLEFORDEFINEDFONT", 1983826977: "IFCTEXTSTYLEFONTMODEL", 1447204868: "IFCTEXTSTYLE", 912023232: "IFCTELECOMADDRESS", 531007025: "IFCTABLEROW", 985171141: "IFCTABLE", 1290481447: "IFCSYMBOLSTYLE", 626085974: "IFCSURFACETEXTURE", 1351298697: "IFCSURFACESTYLEWITHTEXTURES", 846575682: "IFCSURFACESTYLESHADING", 1607154358: "IFCSURFACESTYLEREFRACTION", 3303107099: "IFCSURFACESTYLELIGHTING", 1300840506: "IFCSURFACESTYLE", 3049322572: "IFCSTYLEDREPRESENTATION", 3958052878: "IFCSTYLEDITEM", 2830218821: "IFCSTYLEMODEL", 3408363356: "IFCSTRUCTURALLOADTEMPERATURE", 2525727697: "IFCSTRUCTURALLOADSTATIC", 2162789131: "IFCSTRUCTURALLOAD", 2273995522: "IFCSTRUCTURALCONNECTIONCONDITION", 3692461612: "IFCSIMPLEPROPERTY", 4240577450: "IFCSHAPEREPRESENTATION", 3982875396: "IFCSHAPEMODEL", 867548509: "IFCSHAPEASPECT", 4165799628: "IFCSECTIONREINFORCEMENTPROPERTIES", 2042790032: "IFCSECTIONPROPERTIES", 448429030: "IFCSIUNIT", 2341007311: "IFCROOT", 3679540991: "IFCRIBPLATEPROFILEPROPERTIES", 1660063152: "IFCREPRESENTATIONMAP", 3008791417: "IFCREPRESENTATIONITEM", 3377609919: "IFCREPRESENTATIONCONTEXT", 1076942058: "IFCREPRESENTATION", 1222501353: "IFCRELAXATION", 1580146022: "IFCREINFORCEMENTBARPROPERTIES", 2692823254: "IFCREFERENCESVALUEDOCUMENT", 825690147: "IFCQUANTITYWEIGHT", 2405470396: "IFCQUANTITYVOLUME", 3252649465: "IFCQUANTITYTIME", 931644368: "IFCQUANTITYLENGTH", 2093928680: "IFCQUANTITYCOUNT", 2044713172: "IFCQUANTITYAREA", 3710013099: "IFCPROPERTYENUMERATION", 148025276: "IFCPROPERTYDEPENDENCYRELATIONSHIP", 3896028662: "IFCPROPERTYCONSTRAINTRELATIONSHIP", 2598011224: "IFCPROPERTY", 2802850158: "IFCPROFILEPROPERTIES", 3958567839: "IFCPROFILEDEF", 2267347899: "IFCPRODUCTSOFCOMBUSTIONPROPERTIES", 2095639259: "IFCPRODUCTREPRESENTATION", 2417041796: "IFCPRESENTATIONSTYLEASSIGNMENT", 3119450353: "IFCPRESENTATIONSTYLE", 1304840413: "IFCPRESENTATIONLAYERWITHSTYLE", 2022622350: "IFCPRESENTATIONLAYERASSIGNMENT", 1775413392: "IFCPREDEFINEDTEXTFONT", 3213052703: "IFCPREDEFINEDTERMINATORSYMBOL", 990879717: "IFCPREDEFINEDSYMBOL", 3727388367: "IFCPREDEFINEDITEM", 3355820592: "IFCPOSTALADDRESS", 2226359599: "IFCPHYSICALSIMPLEQUANTITY", 2483315170: "IFCPHYSICALQUANTITY", 101040310: "IFCPERSONANDORGANIZATION", 2077209135: "IFCPERSON", 1207048766: "IFCOWNERHISTORY", 1411181986: "IFCORGANIZATIONRELATIONSHIP", 4251960020: "IFCORGANIZATION", 1227763645: "IFCOPTICALMATERIALPROPERTIES", 2251480897: "IFCOBJECTIVE", 3701648758: "IFCOBJECTPLACEMENT", 1918398963: "IFCNAMEDUNIT", 2706619895: "IFCMONETARYUNIT", 3368373690: "IFCMETRIC", 677618848: "IFCMECHANICALSTEELMATERIALPROPERTIES", 4256014907: "IFCMECHANICALMATERIALPROPERTIES", 2597039031: "IFCMEASUREWITHUNIT", 3265635763: "IFCMATERIALPROPERTIES", 2199411900: "IFCMATERIALLIST", 1303795690: "IFCMATERIALLAYERSETUSAGE", 3303938423: "IFCMATERIALLAYERSET", 248100487: "IFCMATERIALLAYER", 1847130766: "IFCMATERIALCLASSIFICATIONRELATIONSHIP", 1838606355: "IFCMATERIAL", 30780891: "IFCLOCALTIME", 1566485204: "IFCLIGHTINTENSITYDISTRIBUTION", 4162380809: "IFCLIGHTDISTRIBUTIONDATA", 3452421091: "IFCLIBRARYREFERENCE", 2655187982: "IFCLIBRARYINFORMATION", 3020489413: "IFCIRREGULARTIMESERIESVALUE", 852622518: "IFCGRIDAXIS", 3548104201: "IFCEXTERNALLYDEFINEDTEXTFONT", 3207319532: "IFCEXTERNALLYDEFINEDSYMBOL", 1040185647: "IFCEXTERNALLYDEFINEDSURFACESTYLE", 2242383968: "IFCEXTERNALLYDEFINEDHATCHSTYLE", 3200245327: "IFCEXTERNALREFERENCE", 1648886627: "IFCENVIRONMENTALIMPACTVALUE", 3796139169: "IFCDRAUGHTINGCALLOUTRELATIONSHIP", 770865208: "IFCDOCUMENTINFORMATIONRELATIONSHIP", 1154170062: "IFCDOCUMENTINFORMATION", 1376555844: "IFCDOCUMENTELECTRONICFORMAT", 2949456006: "IFCDIMENSIONALEXPONENTS", 1045800335: "IFCDERIVEDUNITELEMENT", 1765591967: "IFCDERIVEDUNIT", 1072939445: "IFCDATEANDTIME", 3510044353: "IFCCURVESTYLEFONTPATTERN", 2367409068: "IFCCURVESTYLEFONTANDSCALING", 1105321065: "IFCCURVESTYLEFONT", 539742890: "IFCCURRENCYRELATIONSHIP", 602808272: "IFCCOSTVALUE", 1065062679: "IFCCOORDINATEDUNIVERSALTIMEOFFSET", 347226245: "IFCCONSTRAINTRELATIONSHIP", 613356794: "IFCCONSTRAINTCLASSIFICATIONRELATIONSHIP", 1658513725: "IFCCONSTRAINTAGGREGATIONRELATIONSHIP", 1959218052: "IFCCONSTRAINT", 2732653382: "IFCCONNECTIONSURFACEGEOMETRY", 4257277454: "IFCCONNECTIONPORTGEOMETRY", 2614616156: "IFCCONNECTIONPOINTGEOMETRY", 2859738748: "IFCCONNECTIONGEOMETRY", 3264961684: "IFCCOLOURSPECIFICATION", 3639012971: "IFCCLASSIFICATIONNOTATIONFACET", 938368621: "IFCCLASSIFICATIONNOTATION", 1098599126: "IFCCLASSIFICATIONITEMRELATIONSHIP", 1767535486: "IFCCLASSIFICATIONITEM", 747523909: "IFCCLASSIFICATION", 622194075: "IFCCALENDARDATE", 2069777674: "IFCBOUNDARYNODECONDITIONWARPING", 1387855156: "IFCBOUNDARYNODECONDITION", 3367102660: "IFCBOUNDARYFACECONDITION", 1560379544: "IFCBOUNDARYEDGECONDITION", 4037036970: "IFCBOUNDARYCONDITION", 3869604511: "IFCAPPROVALRELATIONSHIP", 390851274: "IFCAPPROVALPROPERTYRELATIONSHIP", 2080292479: "IFCAPPROVALACTORRELATIONSHIP", 130549933: "IFCAPPROVAL", 1110488051: "IFCAPPLIEDVALUERELATIONSHIP", 411424972: "IFCAPPLIEDVALUE", 639542469: "IFCAPPLICATION", 618182010: "IFCADDRESS", 3630933823: "IFCACTORROLE", 599546466: "FILE_DESCRIPTION", 1390159747: "FILE_NAME", 1109904537: "FILE_SCHEMA" };
class Bp {
  constructor() {
    De(this, "enabled", !0), De(this, "trigger", ((t) => {
      if (!this.enabled) return;
      const i = this.handlers.slice(0);
      for (const n of i) n(t);
    })), De(this, "handlers", []);
  }
  add(t) {
    this.handlers.push(t);
  }
  remove(t) {
    this.handlers = this.handlers.filter(((i) => i !== t));
  }
  reset() {
    this.handlers.length = 0;
  }
}
class f0 extends Map {
  constructor(t) {
    super(t), De(this, "onBeforeSet", new Bp()), De(this, "onItemSet", new Bp()), De(this, "onItemUpdated", new Bp()), De(this, "onBeforeDelete", new Bp()), De(this, "onItemDeleted", new Bp()), De(this, "onCleared", new Bp()), De(this, "guard", (() => !0)), De(this, "deleteGuard", (() => !0)), De(this, "updateGuard", (() => !0));
  }
  set eventsEnabled(t) {
    this.onItemSet.enabled = t, this.onItemUpdated.enabled = t, this.onItemDeleted.enabled = t, this.onBeforeDelete.enabled = t, this.onCleared.enabled = t;
  }
  clear() {
    for (const [t, i] of this) this.onBeforeDelete.trigger({ key: t, value: i });
    super.clear(), this.onCleared.trigger();
  }
  set(t, i) {
    const n = this.has(t);
    if (!(this.guard ?? (() => !0))(t, i)) return this;
    n || this.onBeforeSet.trigger({ key: t, value: i });
    const s = super.set(t, i);
    return n ? (this.onItemUpdated || (this.onItemUpdated = new Bp()), this.onItemUpdated.trigger({ key: t, value: i })) : (this.onItemSet || (this.onItemSet = new Bp()), this.onItemSet.trigger({ key: t, value: i })), s;
  }
  delete(t) {
    const i = this.get(t);
    if (!i || !this.deleteGuard(t, i)) return !1;
    this.onBeforeDelete.trigger({ key: t, value: i });
    const n = super.delete(t);
    return n && this.onItemDeleted.trigger(t), n;
  }
  getKey(t) {
    for (const [i, n] of this) if (n === t) return i;
  }
  add(t) {
    const i = Eie.generateUUID().toLowerCase();
    return this.set(i, t), i;
  }
  update(t) {
    const i = this.getKey(t);
    i && this.updateGuard(i, t) && this.set(i, t);
  }
  deleteIf(t) {
    for (const [i, n] of this) t(n, i) && this.delete(i);
  }
  replaceKey(t, i, n = !1) {
    const s = this.get(t);
    return s ? !(this.get(i) && !n) && (this.eventsEnabled = !1, this.delete(t), this.eventsEnabled = !0, this.set(i, s), !0) : !1;
  }
  dispose() {
    this.clear(), this.onItemSet.reset(), this.onItemDeleted.reset(), this.onItemUpdated.reset(), this.onCleared.reset(), this.onBeforeDelete.reset();
  }
}
class OA extends Set {
  constructor(t) {
    super(t), De(this, "onUpdated", new Bp()), De(this, "onItemAdded", new Bp()), De(this, "onBeforeDelete", new Bp()), De(this, "onItemDeleted", new Bp()), De(this, "onCleared", new Bp()), De(this, "guard", (() => !0)), De(this, "deleteGuard", (() => !0));
  }
  set eventsEnabled(t) {
    this.onUpdated.enabled = t, this.onItemAdded.enabled = t, this.onItemDeleted.enabled = t, this.onBeforeDelete.enabled = t, this.onCleared.enabled = t;
  }
  clear() {
    for (const t of this) this.onBeforeDelete.trigger(t);
    super.clear(), this.onCleared.trigger(), this.onUpdated.trigger();
  }
  add(...t) {
    for (const i of t)
      this.has(i) || (this.guard ?? (() => !0))(i) && (super.add(i), this.onItemAdded || (this.onItemAdded = new Bp()), this.onItemAdded.trigger(i));
    return this.onUpdated || (this.onUpdated = new Bp()), this.onUpdated.trigger(), this;
  }
  delete(t) {
    if (!this.has(t) || !this.deleteGuard(t)) return !1;
    this.onBeforeDelete.trigger(t);
    const i = super.delete(t);
    return i && (this.onItemDeleted.trigger(), this.onUpdated.trigger()), i;
  }
  deleteIf(t) {
    for (const i of this) t(i) && this.delete(i);
  }
  getIndex(t) {
    let i = 0;
    for (const n of this) {
      if (n === t) return i;
      i++;
    }
    return -1;
  }
  dispose() {
    this.clear(), this.onItemAdded.reset(), this.onItemDeleted.reset(), this.onCleared.reset(), this.onBeforeDelete.reset(), this.onUpdated.reset();
  }
}
const nx = new Int32Array(2), Qge = new Float32Array(nx.buffer), Jge = new Float64Array(nx.buffer), Jne = new Uint16Array(new Uint8Array([1, 0]).buffer)[0] === 1;
var yIe, Xne;
(Xne = yIe || (yIe = {}))[Xne.UTF8_BYTES = 1] = "UTF8_BYTES", Xne[Xne.UTF16_STRING = 2] = "UTF16_STRING";
class LX {
  constructor(t) {
    this.bytes_ = t, this.position_ = 0, this.text_decoder_ = new TextDecoder();
  }
  static allocate(t) {
    return new LX(new Uint8Array(t));
  }
  clear() {
    this.position_ = 0;
  }
  bytes() {
    return this.bytes_;
  }
  position() {
    return this.position_;
  }
  setPosition(t) {
    this.position_ = t;
  }
  capacity() {
    return this.bytes_.length;
  }
  readInt8(t) {
    return this.readUint8(t) << 24 >> 24;
  }
  readUint8(t) {
    return this.bytes_[t];
  }
  readInt16(t) {
    return this.readUint16(t) << 16 >> 16;
  }
  readUint16(t) {
    return this.bytes_[t] | this.bytes_[t + 1] << 8;
  }
  readInt32(t) {
    return this.bytes_[t] | this.bytes_[t + 1] << 8 | this.bytes_[t + 2] << 16 | this.bytes_[t + 3] << 24;
  }
  readUint32(t) {
    return this.readInt32(t) >>> 0;
  }
  readInt64(t) {
    return BigInt.asIntN(64, BigInt(this.readUint32(t)) + (BigInt(this.readUint32(t + 4)) << BigInt(32)));
  }
  readUint64(t) {
    return BigInt.asUintN(64, BigInt(this.readUint32(t)) + (BigInt(this.readUint32(t + 4)) << BigInt(32)));
  }
  readFloat32(t) {
    return nx[0] = this.readInt32(t), Qge[0];
  }
  readFloat64(t) {
    return nx[Jne ? 0 : 1] = this.readInt32(t), nx[Jne ? 1 : 0] = this.readInt32(t + 4), Jge[0];
  }
  writeInt8(t, i) {
    this.bytes_[t] = i;
  }
  writeUint8(t, i) {
    this.bytes_[t] = i;
  }
  writeInt16(t, i) {
    this.bytes_[t] = i, this.bytes_[t + 1] = i >> 8;
  }
  writeUint16(t, i) {
    this.bytes_[t] = i, this.bytes_[t + 1] = i >> 8;
  }
  writeInt32(t, i) {
    this.bytes_[t] = i, this.bytes_[t + 1] = i >> 8, this.bytes_[t + 2] = i >> 16, this.bytes_[t + 3] = i >> 24;
  }
  writeUint32(t, i) {
    this.bytes_[t] = i, this.bytes_[t + 1] = i >> 8, this.bytes_[t + 2] = i >> 16, this.bytes_[t + 3] = i >> 24;
  }
  writeInt64(t, i) {
    this.writeInt32(t, Number(BigInt.asIntN(32, i))), this.writeInt32(t + 4, Number(BigInt.asIntN(32, i >> BigInt(32))));
  }
  writeUint64(t, i) {
    this.writeUint32(t, Number(BigInt.asUintN(32, i))), this.writeUint32(t + 4, Number(BigInt.asUintN(32, i >> BigInt(32))));
  }
  writeFloat32(t, i) {
    Qge[0] = i, this.writeInt32(t, nx[0]);
  }
  writeFloat64(t, i) {
    Jge[0] = i, this.writeInt32(t, nx[Jne ? 0 : 1]), this.writeInt32(t + 4, nx[Jne ? 1 : 0]);
  }
  getBufferIdentifier() {
    if (this.bytes_.length < this.position_ + 4 + 4) throw new Error("FlatBuffers: ByteBuffer is too short to contain an identifier.");
    let t = "";
    for (let i = 0; i < 4; i++) t += String.fromCharCode(this.readInt8(this.position_ + 4 + i));
    return t;
  }
  __offset(t, i) {
    const n = t - this.readInt32(t);
    return i < this.readInt16(n) ? this.readInt16(n + i) : 0;
  }
  __union(t, i) {
    return t.bb_pos = i + this.readInt32(i), t.bb = this, t;
  }
  __string(t, i) {
    t += this.readInt32(t);
    const n = this.readInt32(t);
    t += 4;
    const s = this.bytes_.subarray(t, t + n);
    return i === yIe.UTF8_BYTES ? s : this.text_decoder_.decode(s);
  }
  __union_with_string(t, i) {
    return typeof t == "string" ? this.__string(i) : this.__union(t, i);
  }
  __indirect(t) {
    return t + this.readInt32(t);
  }
  __vector(t) {
    return t + this.readInt32(t) + 4;
  }
  __vector_len(t) {
    return this.readInt32(t + this.readInt32(t));
  }
  __has_identifier(t) {
    if (t.length != 4) throw new Error("FlatBuffers: file identifier must be length 4");
    for (let i = 0; i < 4; i++) if (t.charCodeAt(i) != this.readInt8(this.position() + 4 + i)) return !1;
    return !0;
  }
  createScalarList(t, i) {
    const n = [];
    for (let s = 0; s < i; ++s) {
      const o = t(s);
      o !== null && n.push(o);
    }
    return n;
  }
  createObjList(t, i) {
    const n = [];
    for (let s = 0; s < i; ++s) {
      const o = t(s);
      o !== null && n.push(o.unpack());
    }
    return n;
  }
}
class Uie {
  constructor(t) {
    let i;
    this.minalign = 1, this.vtable = null, this.vtable_in_use = 0, this.isNested = !1, this.object_start = 0, this.vtables = [], this.vector_num_elems = 0, this.force_defaults = !1, this.string_maps = null, this.text_encoder = new TextEncoder(), i = t || 1024, this.bb = LX.allocate(i), this.space = i;
  }
  clear() {
    this.bb.clear(), this.space = this.bb.capacity(), this.minalign = 1, this.vtable = null, this.vtable_in_use = 0, this.isNested = !1, this.object_start = 0, this.vtables = [], this.vector_num_elems = 0, this.force_defaults = !1, this.string_maps = null;
  }
  forceDefaults(t) {
    this.force_defaults = t;
  }
  dataBuffer() {
    return this.bb;
  }
  asUint8Array() {
    return this.bb.bytes().subarray(this.bb.position(), this.bb.position() + this.offset());
  }
  prep(t, i) {
    t > this.minalign && (this.minalign = t);
    const n = 1 + ~(this.bb.capacity() - this.space + i) & t - 1;
    for (; this.space < n + t + i; ) {
      const s = this.bb.capacity();
      this.bb = Uie.growByteBuffer(this.bb), this.space += this.bb.capacity() - s;
    }
    this.pad(n);
  }
  pad(t) {
    for (let i = 0; i < t; i++) this.bb.writeInt8(--this.space, 0);
  }
  writeInt8(t) {
    this.bb.writeInt8(this.space -= 1, t);
  }
  writeInt16(t) {
    this.bb.writeInt16(this.space -= 2, t);
  }
  writeInt32(t) {
    this.bb.writeInt32(this.space -= 4, t);
  }
  writeInt64(t) {
    this.bb.writeInt64(this.space -= 8, t);
  }
  writeFloat32(t) {
    this.bb.writeFloat32(this.space -= 4, t);
  }
  writeFloat64(t) {
    this.bb.writeFloat64(this.space -= 8, t);
  }
  addInt8(t) {
    this.prep(1, 0), this.writeInt8(t);
  }
  addInt16(t) {
    this.prep(2, 0), this.writeInt16(t);
  }
  addInt32(t) {
    this.prep(4, 0), this.writeInt32(t);
  }
  addInt64(t) {
    this.prep(8, 0), this.writeInt64(t);
  }
  addFloat32(t) {
    this.prep(4, 0), this.writeFloat32(t);
  }
  addFloat64(t) {
    this.prep(8, 0), this.writeFloat64(t);
  }
  addFieldInt8(t, i, n) {
    (this.force_defaults || i != n) && (this.addInt8(i), this.slot(t));
  }
  addFieldInt16(t, i, n) {
    (this.force_defaults || i != n) && (this.addInt16(i), this.slot(t));
  }
  addFieldInt32(t, i, n) {
    (this.force_defaults || i != n) && (this.addInt32(i), this.slot(t));
  }
  addFieldInt64(t, i, n) {
    (this.force_defaults || i !== n) && (this.addInt64(i), this.slot(t));
  }
  addFieldFloat32(t, i, n) {
    (this.force_defaults || i != n) && (this.addFloat32(i), this.slot(t));
  }
  addFieldFloat64(t, i, n) {
    (this.force_defaults || i != n) && (this.addFloat64(i), this.slot(t));
  }
  addFieldOffset(t, i, n) {
    (this.force_defaults || i != n) && (this.addOffset(i), this.slot(t));
  }
  addFieldStruct(t, i, n) {
    i != n && (this.nested(i), this.slot(t));
  }
  nested(t) {
    if (t != this.offset()) throw new TypeError("FlatBuffers: struct must be serialized inline.");
  }
  notNested() {
    if (this.isNested) throw new TypeError("FlatBuffers: object serialization must not be nested.");
  }
  slot(t) {
    this.vtable !== null && (this.vtable[t] = this.offset());
  }
  offset() {
    return this.bb.capacity() - this.space;
  }
  static growByteBuffer(t) {
    const i = t.capacity();
    if (3221225472 & i) throw new Error("FlatBuffers: cannot grow buffer beyond 2 gigabytes.");
    const n = i << 1, s = LX.allocate(n);
    return s.setPosition(n - i), s.bytes().set(t.bytes(), n - i), s;
  }
  addOffset(t) {
    this.prep(4, 0), this.writeInt32(this.offset() - t + 4);
  }
  startObject(t) {
    this.notNested(), this.vtable == null && (this.vtable = []), this.vtable_in_use = t;
    for (let i = 0; i < t; i++) this.vtable[i] = 0;
    this.isNested = !0, this.object_start = this.offset();
  }
  endObject() {
    if (this.vtable == null || !this.isNested) throw new Error("FlatBuffers: endObject called without startObject");
    this.addInt32(0);
    const t = this.offset();
    let i = this.vtable_in_use - 1;
    for (; i >= 0 && this.vtable[i] == 0; i--) ;
    const n = i + 1;
    for (; i >= 0; i--) this.addInt16(this.vtable[i] != 0 ? t - this.vtable[i] : 0);
    this.addInt16(t - this.object_start);
    const s = 2 * (n + 2);
    this.addInt16(s);
    let o = 0;
    const r = this.space;
    e: for (i = 0; i < this.vtables.length; i++) {
      const l = this.bb.capacity() - this.vtables[i];
      if (s == this.bb.readInt16(l)) {
        for (let c = 2; c < s; c += 2) if (this.bb.readInt16(r + c) != this.bb.readInt16(l + c)) continue e;
        o = this.vtables[i];
        break;
      }
    }
    return o ? (this.space = this.bb.capacity() - t, this.bb.writeInt32(this.space, o - t)) : (this.vtables.push(this.offset()), this.bb.writeInt32(this.bb.capacity() - t, this.offset() - t)), this.isNested = !1, t;
  }
  finish(t, i, n) {
    const s = n ? 4 : 0;
    if (i) {
      const o = i;
      if (this.prep(this.minalign, 8 + s), o.length != 4) throw new TypeError("FlatBuffers: file identifier must be length 4");
      for (let r = 3; r >= 0; r--) this.writeInt8(o.charCodeAt(r));
    }
    this.prep(this.minalign, 4 + s), this.addOffset(t), s && this.addInt32(this.bb.capacity() - this.space), this.bb.setPosition(this.space);
  }
  finishSizePrefixed(t, i) {
    this.finish(t, i, !0);
  }
  requiredField(t, i) {
    const n = this.bb.capacity() - t, s = n - this.bb.readInt32(n);
    if (!(i < this.bb.readInt16(s) && this.bb.readInt16(s + i) != 0)) throw new TypeError("FlatBuffers: field " + i + " must be set");
  }
  startVector(t, i, n) {
    this.notNested(), this.vector_num_elems = i, this.prep(4, t * i), this.prep(n, t * i);
  }
  endVector() {
    return this.writeInt32(this.vector_num_elems), this.offset();
  }
  createSharedString(t) {
    if (!t) return 0;
    if (this.string_maps || (this.string_maps = /* @__PURE__ */ new Map()), this.string_maps.has(t)) return this.string_maps.get(t);
    const i = this.createString(t);
    return this.string_maps.set(t, i), i;
  }
  createString(t) {
    if (t == null) return 0;
    let i;
    return i = t instanceof Uint8Array ? t : this.text_encoder.encode(t), this.addInt8(0), this.startVector(1, i.length, 1), this.bb.setPosition(this.space -= i.length), this.bb.bytes().set(i, this.space), this.endVector();
  }
  createByteVector(t) {
    return t == null ? 0 : (this.startVector(1, t.length, 1), this.bb.setPosition(this.space -= t.length), this.bb.bytes().set(t, this.space), this.endVector());
  }
  createObjectOffset(t) {
    return t === null ? 0 : typeof t == "string" ? this.createString(t) : t.pack(this);
  }
  createObjectOffsetList(t) {
    const i = [];
    for (let n = 0; n < t.length; ++n) {
      const s = t[n];
      if (s === null) throw new TypeError("FlatBuffers: Argument for createObjectOffsetList cannot contain null.");
      i.push(this.createObjectOffset(s));
    }
    return i;
  }
  createStructOffsetList(t, i) {
    return i(this, t.length), this.createObjectOffsetList(t.slice().reverse()), this.endVector();
  }
}
/*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */
function oY(e) {
  let t = e.length;
  for (; --t >= 0; ) e[t] = 0;
}
const EIe = 256, gSe = 286, _J = 30, xJ = 15, gIe = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]), wre = new Uint8Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]), Xje = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]), Xge = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), dC = new Array(576);
oY(dC);
const oJ = new Array(60);
oY(oJ);
const _X = new Array(512);
oY(_X);
const PJ = new Array(256);
oY(PJ);
const bme = new Array(29);
oY(bme);
const Sle = new Array(_J);
function Zde(e, t, i, n, s) {
  this.static_tree = e, this.extra_bits = t, this.extra_base = i, this.elems = n, this.max_length = s, this.has_stree = e && e.length;
}
let ewe, twe, iwe;
function Qde(e, t) {
  this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
}
oY(Sle);
const wSe = (e) => e < 256 ? _X[e] : _X[256 + (e >>> 7)], xX = (e, t) => {
  e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
}, gg = (e, t, i) => {
  e.bi_valid > 16 - i ? (e.bi_buf |= t << e.bi_valid & 65535, xX(e, e.bi_buf), e.bi_buf = t >> 16 - e.bi_valid, e.bi_valid += i - 16) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += i);
}, lN = (e, t, i) => {
  gg(e, i[2 * t], i[2 * t + 1]);
}, TSe = (e, t) => {
  let i = 0;
  do
    i |= 1 & e, e >>>= 1, i <<= 1;
  while (--t > 0);
  return i >>> 1;
}, RSe = (e, t, i) => {
  const n = new Array(16);
  let s, o, r = 0;
  for (s = 1; s <= xJ; s++) r = r + i[s - 1] << 1, n[s] = r;
  for (o = 0; o <= t; o++) {
    let l = e[2 * o + 1];
    l !== 0 && (e[2 * o] = TSe(n[l]++, l));
  }
}, nwe = (e) => {
  let t;
  for (t = 0; t < gSe; t++) e.dyn_ltree[2 * t] = 0;
  for (t = 0; t < _J; t++) e.dyn_dtree[2 * t] = 0;
  for (t = 0; t < 19; t++) e.bl_tree[2 * t] = 0;
  e.dyn_ltree[512] = 1, e.opt_len = e.static_len = 0, e.sym_next = e.matches = 0;
}, vSe = (e) => {
  e.bi_valid > 8 ? xX(e, e.bi_buf) : e.bi_valid > 0 && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
}, swe = (e, t, i, n) => {
  const s = 2 * t, o = 2 * i;
  return e[s] < e[o] || e[s] === e[o] && n[t] <= n[i];
}, Jde = (e, t, i) => {
  const n = e.heap[i];
  let s = i << 1;
  for (; s <= e.heap_len && (s < e.heap_len && swe(t, e.heap[s + 1], e.heap[s], e.depth) && s++, !swe(t, n, e.heap[s], e.depth)); ) e.heap[i] = e.heap[s], i = s, s <<= 1;
  e.heap[i] = n;
}, owe = (e, t, i) => {
  let n, s, o, r, l = 0;
  if (e.sym_next !== 0) do
    n = 255 & e.pending_buf[e.sym_buf + l++], n += (255 & e.pending_buf[e.sym_buf + l++]) << 8, s = e.pending_buf[e.sym_buf + l++], n === 0 ? lN(e, s, t) : (o = PJ[s], lN(e, o + EIe + 1, t), r = gIe[o], r !== 0 && (s -= bme[o], gg(e, s, r)), n--, o = wSe(n), lN(e, o, i), r = wre[o], r !== 0 && (n -= Sle[o], gg(e, n, r)));
  while (l < e.sym_next);
  lN(e, 256, t);
}, Xde = (e, t) => {
  const i = t.dyn_tree, n = t.stat_desc.static_tree, s = t.stat_desc.has_stree, o = t.stat_desc.elems;
  let r, l, c, h = -1;
  for (e.heap_len = 0, e.heap_max = 573, r = 0; r < o; r++) i[2 * r] !== 0 ? (e.heap[++e.heap_len] = h = r, e.depth[r] = 0) : i[2 * r + 1] = 0;
  for (; e.heap_len < 2; ) c = e.heap[++e.heap_len] = h < 2 ? ++h : 0, i[2 * c] = 1, e.depth[c] = 0, e.opt_len--, s && (e.static_len -= n[2 * c + 1]);
  for (t.max_code = h, r = e.heap_len >> 1; r >= 1; r--) Jde(e, i, r);
  c = o;
  do
    r = e.heap[1], e.heap[1] = e.heap[e.heap_len--], Jde(e, i, 1), l = e.heap[1], e.heap[--e.heap_max] = r, e.heap[--e.heap_max] = l, i[2 * c] = i[2 * r] + i[2 * l], e.depth[c] = (e.depth[r] >= e.depth[l] ? e.depth[r] : e.depth[l]) + 1, i[2 * r + 1] = i[2 * l + 1] = c, e.heap[1] = c++, Jde(e, i, 1);
  while (e.heap_len >= 2);
  e.heap[--e.heap_max] = e.heap[1], ((I, p) => {
    const y = p.dyn_tree, m = p.max_code, A = p.stat_desc.static_tree, C = p.stat_desc.has_stree, O = p.stat_desc.extra_bits, R = p.stat_desc.extra_base, F = p.stat_desc.max_length;
    let L, P, z, W, re, ce, te = 0;
    for (W = 0; W <= xJ; W++) I.bl_count[W] = 0;
    for (y[2 * I.heap[I.heap_max] + 1] = 0, L = I.heap_max + 1; L < 573; L++) P = I.heap[L], W = y[2 * y[2 * P + 1] + 1] + 1, W > F && (W = F, te++), y[2 * P + 1] = W, P > m || (I.bl_count[W]++, re = 0, P >= R && (re = O[P - R]), ce = y[2 * P], I.opt_len += ce * (W + re), C && (I.static_len += ce * (A[2 * P + 1] + re)));
    if (te !== 0) {
      do {
        for (W = F - 1; I.bl_count[W] === 0; ) W--;
        I.bl_count[W]--, I.bl_count[W + 1] += 2, I.bl_count[F]--, te -= 2;
      } while (te > 0);
      for (W = F; W !== 0; W--) for (P = I.bl_count[W]; P !== 0; ) z = I.heap[--L], z > m || (y[2 * z + 1] !== W && (I.opt_len += (W - y[2 * z + 1]) * y[2 * z], y[2 * z + 1] = W), P--);
    }
  })(e, t), RSe(i, h, e.bl_count);
}, rwe = (e, t, i) => {
  let n, s, o = -1, r = t[1], l = 0, c = 7, h = 4;
  for (r === 0 && (c = 138, h = 3), t[2 * (i + 1) + 1] = 65535, n = 0; n <= i; n++) s = r, r = t[2 * (n + 1) + 1], ++l < c && s === r || (l < h ? e.bl_tree[2 * s] += l : s !== 0 ? (s !== o && e.bl_tree[2 * s]++, e.bl_tree[32]++) : l <= 10 ? e.bl_tree[34]++ : e.bl_tree[36]++, l = 0, o = s, r === 0 ? (c = 138, h = 3) : s === r ? (c = 6, h = 3) : (c = 7, h = 4));
}, lwe = (e, t, i) => {
  let n, s, o = -1, r = t[1], l = 0, c = 7, h = 4;
  for (r === 0 && (c = 138, h = 3), n = 0; n <= i; n++) if (s = r, r = t[2 * (n + 1) + 1], !(++l < c && s === r)) {
    if (l < h) do
      lN(e, s, e.bl_tree);
    while (--l != 0);
    else s !== 0 ? (s !== o && (lN(e, s, e.bl_tree), l--), lN(e, 16, e.bl_tree), gg(e, l - 3, 2)) : l <= 10 ? (lN(e, 17, e.bl_tree), gg(e, l - 3, 3)) : (lN(e, 18, e.bl_tree), gg(e, l - 11, 7));
    l = 0, o = s, r === 0 ? (c = 138, h = 3) : s === r ? (c = 6, h = 3) : (c = 7, h = 4);
  }
};
let awe = !1;
const uwe = (e, t, i, n) => {
  gg(e, 0 + (n ? 1 : 0), 3), vSe(e), xX(e, i), xX(e, ~i), i && e.pending_buf.set(e.window.subarray(t, t + i), e.pending), e.pending += i;
};
var eWe = { _tr_init: (e) => {
  awe || ((() => {
    let t, i, n, s, o;
    const r = new Array(16);
    for (n = 0, s = 0; s < 28; s++) for (bme[s] = n, t = 0; t < 1 << gIe[s]; t++) PJ[n++] = s;
    for (PJ[n - 1] = s, o = 0, s = 0; s < 16; s++) for (Sle[s] = o, t = 0; t < 1 << wre[s]; t++) _X[o++] = s;
    for (o >>= 7; s < _J; s++) for (Sle[s] = o << 7, t = 0; t < 1 << wre[s] - 7; t++) _X[256 + o++] = s;
    for (i = 0; i <= xJ; i++) r[i] = 0;
    for (t = 0; t <= 143; ) dC[2 * t + 1] = 8, t++, r[8]++;
    for (; t <= 255; ) dC[2 * t + 1] = 9, t++, r[9]++;
    for (; t <= 279; ) dC[2 * t + 1] = 7, t++, r[7]++;
    for (; t <= 287; ) dC[2 * t + 1] = 8, t++, r[8]++;
    for (RSe(dC, 287, r), t = 0; t < _J; t++) oJ[2 * t + 1] = 5, oJ[2 * t] = TSe(t, 5);
    ewe = new Zde(dC, gIe, 257, gSe, xJ), twe = new Zde(oJ, wre, 0, _J, xJ), iwe = new Zde(new Array(0), Xje, 0, 19, 7);
  })(), awe = !0), e.l_desc = new Qde(e.dyn_ltree, ewe), e.d_desc = new Qde(e.dyn_dtree, twe), e.bl_desc = new Qde(e.bl_tree, iwe), e.bi_buf = 0, e.bi_valid = 0, nwe(e);
}, _tr_stored_block: uwe, _tr_flush_block: (e, t, i, n) => {
  let s, o, r = 0;
  e.level > 0 ? (e.strm.data_type === 2 && (e.strm.data_type = ((l) => {
    let c, h = 4093624447;
    for (c = 0; c <= 31; c++, h >>>= 1) if (1 & h && l.dyn_ltree[2 * c] !== 0) return 0;
    if (l.dyn_ltree[18] !== 0 || l.dyn_ltree[20] !== 0 || l.dyn_ltree[26] !== 0) return 1;
    for (c = 32; c < EIe; c++) if (l.dyn_ltree[2 * c] !== 0) return 1;
    return 0;
  })(e)), Xde(e, e.l_desc), Xde(e, e.d_desc), r = ((l) => {
    let c;
    for (rwe(l, l.dyn_ltree, l.l_desc.max_code), rwe(l, l.dyn_dtree, l.d_desc.max_code), Xde(l, l.bl_desc), c = 18; c >= 3 && l.bl_tree[2 * Xge[c] + 1] === 0; c--) ;
    return l.opt_len += 3 * (c + 1) + 5 + 5 + 4, c;
  })(e), s = e.opt_len + 3 + 7 >>> 3, o = e.static_len + 3 + 7 >>> 3, o <= s && (s = o)) : s = o = i + 5, i + 4 <= s && t !== -1 ? uwe(e, t, i, n) : e.strategy === 4 || o === s ? (gg(e, 2 + (n ? 1 : 0), 3), owe(e, dC, oJ)) : (gg(e, 4 + (n ? 1 : 0), 3), ((l, c, h, I) => {
    let p;
    for (gg(l, c - 257, 5), gg(l, h - 1, 5), gg(l, I - 4, 4), p = 0; p < I; p++) gg(l, l.bl_tree[2 * Xge[p] + 1], 3);
    lwe(l, l.dyn_ltree, c - 1), lwe(l, l.dyn_dtree, h - 1);
  })(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, r + 1), owe(e, e.dyn_ltree, e.dyn_dtree)), nwe(e), n && vSe(e);
}, _tr_tally: (e, t, i) => (e.pending_buf[e.sym_buf + e.sym_next++] = t, e.pending_buf[e.sym_buf + e.sym_next++] = t >> 8, e.pending_buf[e.sym_buf + e.sym_next++] = i, t === 0 ? e.dyn_ltree[2 * i]++ : (e.matches++, t--, e.dyn_ltree[2 * (PJ[i] + EIe + 1)]++, e.dyn_dtree[2 * wSe(t)]++), e.sym_next === e.sym_end), _tr_align: (e) => {
  gg(e, 2, 3), lN(e, 256, dC), ((t) => {
    t.bi_valid === 16 ? (xX(t, t.bi_buf), t.bi_buf = 0, t.bi_valid = 0) : t.bi_valid >= 8 && (t.pending_buf[t.pending++] = 255 & t.bi_buf, t.bi_buf >>= 8, t.bi_valid -= 8);
  })(e);
} }, MJ = (e, t, i, n) => {
  let s = 65535 & e, o = e >>> 16 & 65535, r = 0;
  for (; i !== 0; ) {
    r = i > 2e3 ? 2e3 : i, i -= r;
    do
      s = s + t[n++] | 0, o = o + s | 0;
    while (--r);
    s %= 65521, o %= 65521;
  }
  return s | o << 16;
};
const tWe = new Uint32Array((() => {
  let e, t = [];
  for (var i = 0; i < 256; i++) {
    e = i;
    for (var n = 0; n < 8; n++) e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
    t[i] = e;
  }
  return t;
})());
var h1 = (e, t, i, n) => {
  const s = tWe, o = n + i;
  e ^= -1;
  for (let r = n; r < o; r++) e = e >>> 8 ^ s[255 & (e ^ t[r])];
  return ~e;
}, SH = { 2: "need dictionary", 1: "stream end", 0: "", "-1": "file error", "-2": "stream error", "-3": "data error", "-4": "insufficient memory", "-5": "buffer error", "-6": "incompatible version" }, Bie = { Z_NO_FLUSH: 0, Z_PARTIAL_FLUSH: 1, Z_SYNC_FLUSH: 2, Z_FULL_FLUSH: 3, Z_FINISH: 4, Z_BLOCK: 5, Z_TREES: 6, Z_OK: 0, Z_STREAM_END: 1, Z_NEED_DICT: 2, Z_ERRNO: -1, Z_STREAM_ERROR: -2, Z_DATA_ERROR: -3, Z_MEM_ERROR: -4, Z_BUF_ERROR: -5, Z_NO_COMPRESSION: 0, Z_BEST_SPEED: 1, Z_BEST_COMPRESSION: 9, Z_DEFAULT_COMPRESSION: -1, Z_FILTERED: 1, Z_HUFFMAN_ONLY: 2, Z_RLE: 3, Z_FIXED: 4, Z_DEFAULT_STRATEGY: 0, Z_BINARY: 0, Z_TEXT: 1, Z_UNKNOWN: 2, Z_DEFLATED: 8 };
const { _tr_init: iWe, _tr_stored_block: wIe, _tr_flush_block: nWe, _tr_tally: BP, _tr_align: sWe } = eWe, { Z_NO_FLUSH: FP, Z_PARTIAL_FLUSH: oWe, Z_FULL_FLUSH: rWe, Z_FINISH: p5, Z_BLOCK: dwe, Z_OK: mp, Z_STREAM_END: cwe, Z_STREAM_ERROR: Sb, Z_DATA_ERROR: lWe, Z_BUF_ERROR: ece, Z_DEFAULT_COMPRESSION: aWe, Z_FILTERED: uWe, Z_HUFFMAN_ONLY: ese, Z_RLE: dWe, Z_FIXED: cWe, Z_DEFAULT_STRATEGY: hWe, Z_UNKNOWN: fWe, Z_DEFLATED: ble } = Bie, uB = 258, i6 = 262, Lz = 42, ZU = 113, rJ = 666, QU = (e, t) => (e.msg = SH[t], t), hwe = (e) => 2 * e - (e > 4 ? 9 : 0), dx = (e) => {
  let t = e.length;
  for (; --t >= 0; ) e[t] = 0;
}, IWe = (e) => {
  let t, i, n, s = e.w_size;
  t = e.hash_size, n = t;
  do
    i = e.head[--n], e.head[n] = i >= s ? i - s : 0;
  while (--t);
  t = s, n = t;
  do
    i = e.prev[--n], e.prev[n] = i >= s ? i - s : 0;
  while (--t);
};
let HP = (e, t, i) => (t << e.hash_shift ^ i) & e.hash_mask;
const i2 = (e) => {
  const t = e.state;
  let i = t.pending;
  i > e.avail_out && (i = e.avail_out), i !== 0 && (e.output.set(t.pending_buf.subarray(t.pending_out, t.pending_out + i), e.next_out), e.next_out += i, t.pending_out += i, e.total_out += i, e.avail_out -= i, t.pending -= i, t.pending === 0 && (t.pending_out = 0));
}, H2 = (e, t) => {
  nWe(e, e.block_start >= 0 ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, i2(e.strm);
}, ol = (e, t) => {
  e.pending_buf[e.pending++] = t;
}, NZ = (e, t) => {
  e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
}, TIe = (e, t, i, n) => {
  let s = e.avail_in;
  return s > n && (s = n), s === 0 ? 0 : (e.avail_in -= s, t.set(e.input.subarray(e.next_in, e.next_in + s), i), e.state.wrap === 1 ? e.adler = MJ(e.adler, t, s, i) : e.state.wrap === 2 && (e.adler = h1(e.adler, t, s, i)), e.next_in += s, e.total_in += s, s);
}, ASe = (e, t) => {
  let i, n, s = e.max_chain_length, o = e.strstart, r = e.prev_length, l = e.nice_match;
  const c = e.strstart > e.w_size - i6 ? e.strstart - (e.w_size - i6) : 0, h = e.window, I = e.w_mask, p = e.prev, y = e.strstart + uB;
  let m = h[o + r - 1], A = h[o + r];
  e.prev_length >= e.good_match && (s >>= 2), l > e.lookahead && (l = e.lookahead);
  do
    if (i = t, h[i + r] === A && h[i + r - 1] === m && h[i] === h[o] && h[++i] === h[o + 1]) {
      o += 2, i++;
      do
        ;
      while (h[++o] === h[++i] && h[++o] === h[++i] && h[++o] === h[++i] && h[++o] === h[++i] && h[++o] === h[++i] && h[++o] === h[++i] && h[++o] === h[++i] && h[++o] === h[++i] && o < y);
      if (n = uB - (y - o), o = y - uB, n > r) {
        if (e.match_start = t, r = n, n >= l) break;
        m = h[o + r - 1], A = h[o + r];
      }
    }
  while ((t = p[t & I]) > c && --s != 0);
  return r <= e.lookahead ? r : e.lookahead;
}, fz = (e) => {
  const t = e.w_size;
  let i, n, s;
  do {
    if (n = e.window_size - e.lookahead - e.strstart, e.strstart >= t + (t - i6) && (e.window.set(e.window.subarray(t, t + t - n), 0), e.match_start -= t, e.strstart -= t, e.block_start -= t, e.insert > e.strstart && (e.insert = e.strstart), IWe(e), n += t), e.strm.avail_in === 0) break;
    if (i = TIe(e.strm, e.window, e.strstart + e.lookahead, n), e.lookahead += i, e.lookahead + e.insert >= 3) for (s = e.strstart - e.insert, e.ins_h = e.window[s], e.ins_h = HP(e, e.ins_h, e.window[s + 1]); e.insert && (e.ins_h = HP(e, e.ins_h, e.window[s + 3 - 1]), e.prev[s & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = s, s++, e.insert--, !(e.lookahead + e.insert < 3)); ) ;
  } while (e.lookahead < i6 && e.strm.avail_in !== 0);
}, SSe = (e, t) => {
  let i, n, s, o = e.pending_buf_size - 5 > e.w_size ? e.w_size : e.pending_buf_size - 5, r = 0, l = e.strm.avail_in;
  do {
    if (i = 65535, s = e.bi_valid + 42 >> 3, e.strm.avail_out < s || (s = e.strm.avail_out - s, n = e.strstart - e.block_start, i > n + e.strm.avail_in && (i = n + e.strm.avail_in), i > s && (i = s), i < o && (i === 0 && t !== p5 || t === FP || i !== n + e.strm.avail_in))) break;
    r = t === p5 && i === n + e.strm.avail_in ? 1 : 0, wIe(e, 0, 0, r), e.pending_buf[e.pending - 4] = i, e.pending_buf[e.pending - 3] = i >> 8, e.pending_buf[e.pending - 2] = ~i, e.pending_buf[e.pending - 1] = ~i >> 8, i2(e.strm), n && (n > i && (n = i), e.strm.output.set(e.window.subarray(e.block_start, e.block_start + n), e.strm.next_out), e.strm.next_out += n, e.strm.avail_out -= n, e.strm.total_out += n, e.block_start += n, i -= n), i && (TIe(e.strm, e.strm.output, e.strm.next_out, i), e.strm.next_out += i, e.strm.avail_out -= i, e.strm.total_out += i);
  } while (r === 0);
  return l -= e.strm.avail_in, l && (l >= e.w_size ? (e.matches = 2, e.window.set(e.strm.input.subarray(e.strm.next_in - e.w_size, e.strm.next_in), 0), e.strstart = e.w_size, e.insert = e.strstart) : (e.window_size - e.strstart <= l && (e.strstart -= e.w_size, e.window.set(e.window.subarray(e.w_size, e.w_size + e.strstart), 0), e.matches < 2 && e.matches++, e.insert > e.strstart && (e.insert = e.strstart)), e.window.set(e.strm.input.subarray(e.strm.next_in - l, e.strm.next_in), e.strstart), e.strstart += l, e.insert += l > e.w_size - e.insert ? e.w_size - e.insert : l), e.block_start = e.strstart), e.high_water < e.strstart && (e.high_water = e.strstart), r ? 4 : t !== FP && t !== p5 && e.strm.avail_in === 0 && e.strstart === e.block_start ? 2 : (s = e.window_size - e.strstart, e.strm.avail_in > s && e.block_start >= e.w_size && (e.block_start -= e.w_size, e.strstart -= e.w_size, e.window.set(e.window.subarray(e.w_size, e.w_size + e.strstart), 0), e.matches < 2 && e.matches++, s += e.w_size, e.insert > e.strstart && (e.insert = e.strstart)), s > e.strm.avail_in && (s = e.strm.avail_in), s && (TIe(e.strm, e.window, e.strstart, s), e.strstart += s, e.insert += s > e.w_size - e.insert ? e.w_size - e.insert : s), e.high_water < e.strstart && (e.high_water = e.strstart), s = e.bi_valid + 42 >> 3, s = e.pending_buf_size - s > 65535 ? 65535 : e.pending_buf_size - s, o = s > e.w_size ? e.w_size : s, n = e.strstart - e.block_start, (n >= o || (n || t === p5) && t !== FP && e.strm.avail_in === 0 && n <= s) && (i = n > s ? s : n, r = t === p5 && e.strm.avail_in === 0 && i === n ? 1 : 0, wIe(e, e.block_start, i, r), e.block_start += i, i2(e.strm)), r ? 3 : 1);
}, tce = (e, t) => {
  let i, n;
  for (; ; ) {
    if (e.lookahead < i6) {
      if (fz(e), e.lookahead < i6 && t === FP) return 1;
      if (e.lookahead === 0) break;
    }
    if (i = 0, e.lookahead >= 3 && (e.ins_h = HP(e, e.ins_h, e.window[e.strstart + 3 - 1]), i = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), i !== 0 && e.strstart - i <= e.w_size - i6 && (e.match_length = ASe(e, i)), e.match_length >= 3) if (n = BP(e, e.strstart - e.match_start, e.match_length - 3), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= 3) {
      e.match_length--;
      do
        e.strstart++, e.ins_h = HP(e, e.ins_h, e.window[e.strstart + 3 - 1]), i = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart;
      while (--e.match_length != 0);
      e.strstart++;
    } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = HP(e, e.ins_h, e.window[e.strstart + 1]);
    else n = BP(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
    if (n && (H2(e, !1), e.strm.avail_out === 0)) return 1;
  }
  return e.insert = e.strstart < 2 ? e.strstart : 2, t === p5 ? (H2(e, !0), e.strm.avail_out === 0 ? 3 : 4) : e.sym_next && (H2(e, !1), e.strm.avail_out === 0) ? 1 : 2;
}, Jk = (e, t) => {
  let i, n, s;
  for (; ; ) {
    if (e.lookahead < i6) {
      if (fz(e), e.lookahead < i6 && t === FP) return 1;
      if (e.lookahead === 0) break;
    }
    if (i = 0, e.lookahead >= 3 && (e.ins_h = HP(e, e.ins_h, e.window[e.strstart + 3 - 1]), i = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = 2, i !== 0 && e.prev_length < e.max_lazy_match && e.strstart - i <= e.w_size - i6 && (e.match_length = ASe(e, i), e.match_length <= 5 && (e.strategy === uWe || e.match_length === 3 && e.strstart - e.match_start > 4096) && (e.match_length = 2)), e.prev_length >= 3 && e.match_length <= e.prev_length) {
      s = e.strstart + e.lookahead - 3, n = BP(e, e.strstart - 1 - e.prev_match, e.prev_length - 3), e.lookahead -= e.prev_length - 1, e.prev_length -= 2;
      do
        ++e.strstart <= s && (e.ins_h = HP(e, e.ins_h, e.window[e.strstart + 3 - 1]), i = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart);
      while (--e.prev_length != 0);
      if (e.match_available = 0, e.match_length = 2, e.strstart++, n && (H2(e, !1), e.strm.avail_out === 0)) return 1;
    } else if (e.match_available) {
      if (n = BP(e, 0, e.window[e.strstart - 1]), n && H2(e, !1), e.strstart++, e.lookahead--, e.strm.avail_out === 0) return 1;
    } else e.match_available = 1, e.strstart++, e.lookahead--;
  }
  return e.match_available && (n = BP(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < 2 ? e.strstart : 2, t === p5 ? (H2(e, !0), e.strm.avail_out === 0 ? 3 : 4) : e.sym_next && (H2(e, !1), e.strm.avail_out === 0) ? 1 : 2;
};
function ub(e, t, i, n, s) {
  this.good_length = e, this.max_lazy = t, this.nice_length = i, this.max_chain = n, this.func = s;
}
const lJ = [new ub(0, 0, 0, 0, SSe), new ub(4, 4, 8, 4, tce), new ub(4, 5, 16, 8, tce), new ub(4, 6, 32, 32, tce), new ub(4, 4, 16, 16, Jk), new ub(8, 16, 32, 32, Jk), new ub(8, 16, 128, 128, Jk), new ub(8, 32, 128, 256, Jk), new ub(32, 128, 258, 1024, Jk), new ub(32, 258, 258, 4096, Jk)];
function pWe() {
  this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = ble, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new Uint16Array(1146), this.dyn_dtree = new Uint16Array(122), this.bl_tree = new Uint16Array(78), dx(this.dyn_ltree), dx(this.dyn_dtree), dx(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new Uint16Array(16), this.heap = new Uint16Array(573), dx(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new Uint16Array(573), dx(this.depth), this.sym_buf = 0, this.lit_bufsize = 0, this.sym_next = 0, this.sym_end = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
}
const aJ = (e) => {
  if (!e) return 1;
  const t = e.state;
  return !t || t.strm !== e || t.status !== Lz && t.status !== 57 && t.status !== 69 && t.status !== 73 && t.status !== 91 && t.status !== 103 && t.status !== ZU && t.status !== rJ ? 1 : 0;
}, bSe = (e) => {
  if (aJ(e)) return QU(e, Sb);
  e.total_in = e.total_out = 0, e.data_type = fWe;
  const t = e.state;
  return t.pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap === 2 ? 57 : t.wrap ? Lz : ZU, e.adler = t.wrap === 2 ? 0 : 1, t.last_flush = -2, iWe(t), mp;
}, NSe = (e) => {
  const t = bSe(e);
  var i;
  return t === mp && ((i = e.state).window_size = 2 * i.w_size, dx(i.head), i.max_lazy_match = lJ[i.level].max_lazy, i.good_match = lJ[i.level].good_length, i.nice_match = lJ[i.level].nice_length, i.max_chain_length = lJ[i.level].max_chain, i.strstart = 0, i.block_start = 0, i.lookahead = 0, i.insert = 0, i.match_length = i.prev_length = 2, i.match_available = 0, i.ins_h = 0), t;
}, fwe = (e, t, i, n, s, o) => {
  if (!e) return Sb;
  let r = 1;
  if (t === aWe && (t = 6), n < 0 ? (r = 0, n = -n) : n > 15 && (r = 2, n -= 16), s < 1 || s > 9 || i !== ble || n < 8 || n > 15 || t < 0 || t > 9 || o < 0 || o > cWe || n === 8 && r !== 1) return QU(e, Sb);
  n === 8 && (n = 9);
  const l = new pWe();
  return e.state = l, l.strm = e, l.status = Lz, l.wrap = r, l.gzhead = null, l.w_bits = n, l.w_size = 1 << l.w_bits, l.w_mask = l.w_size - 1, l.hash_bits = s + 7, l.hash_size = 1 << l.hash_bits, l.hash_mask = l.hash_size - 1, l.hash_shift = ~~((l.hash_bits + 3 - 1) / 3), l.window = new Uint8Array(2 * l.w_size), l.head = new Uint16Array(l.hash_size), l.prev = new Uint16Array(l.w_size), l.lit_bufsize = 1 << s + 6, l.pending_buf_size = 4 * l.lit_bufsize, l.pending_buf = new Uint8Array(l.pending_buf_size), l.sym_buf = l.lit_bufsize, l.sym_end = 3 * (l.lit_bufsize - 1), l.level = t, l.strategy = o, l.method = i, NSe(e);
};
var UJ = { deflateInit: (e, t) => fwe(e, t, ble, 15, 8, hWe), deflateInit2: fwe, deflateReset: NSe, deflateResetKeep: bSe, deflateSetHeader: (e, t) => aJ(e) || e.state.wrap !== 2 ? Sb : (e.state.gzhead = t, mp), deflate: (e, t) => {
  if (aJ(e) || t > dwe || t < 0) return e ? QU(e, Sb) : Sb;
  const i = e.state;
  if (!e.output || e.avail_in !== 0 && !e.input || i.status === rJ && t !== p5) return QU(e, e.avail_out === 0 ? ece : Sb);
  const n = i.last_flush;
  if (i.last_flush = t, i.pending !== 0) {
    if (i2(e), e.avail_out === 0) return i.last_flush = -1, mp;
  } else if (e.avail_in === 0 && hwe(t) <= hwe(n) && t !== p5) return QU(e, ece);
  if (i.status === rJ && e.avail_in !== 0) return QU(e, ece);
  if (i.status === Lz && i.wrap === 0 && (i.status = ZU), i.status === Lz) {
    let s = ble + (i.w_bits - 8 << 4) << 8, o = -1;
    if (o = i.strategy >= ese || i.level < 2 ? 0 : i.level < 6 ? 1 : i.level === 6 ? 2 : 3, s |= o << 6, i.strstart !== 0 && (s |= 32), s += 31 - s % 31, NZ(i, s), i.strstart !== 0 && (NZ(i, e.adler >>> 16), NZ(i, 65535 & e.adler)), e.adler = 1, i.status = ZU, i2(e), i.pending !== 0) return i.last_flush = -1, mp;
  }
  if (i.status === 57) {
    if (e.adler = 0, ol(i, 31), ol(i, 139), ol(i, 8), i.gzhead) ol(i, (i.gzhead.text ? 1 : 0) + (i.gzhead.hcrc ? 2 : 0) + (i.gzhead.extra ? 4 : 0) + (i.gzhead.name ? 8 : 0) + (i.gzhead.comment ? 16 : 0)), ol(i, 255 & i.gzhead.time), ol(i, i.gzhead.time >> 8 & 255), ol(i, i.gzhead.time >> 16 & 255), ol(i, i.gzhead.time >> 24 & 255), ol(i, i.level === 9 ? 2 : i.strategy >= ese || i.level < 2 ? 4 : 0), ol(i, 255 & i.gzhead.os), i.gzhead.extra && i.gzhead.extra.length && (ol(i, 255 & i.gzhead.extra.length), ol(i, i.gzhead.extra.length >> 8 & 255)), i.gzhead.hcrc && (e.adler = h1(e.adler, i.pending_buf, i.pending, 0)), i.gzindex = 0, i.status = 69;
    else if (ol(i, 0), ol(i, 0), ol(i, 0), ol(i, 0), ol(i, 0), ol(i, i.level === 9 ? 2 : i.strategy >= ese || i.level < 2 ? 4 : 0), ol(i, 3), i.status = ZU, i2(e), i.pending !== 0) return i.last_flush = -1, mp;
  }
  if (i.status === 69) {
    if (i.gzhead.extra) {
      let s = i.pending, o = (65535 & i.gzhead.extra.length) - i.gzindex;
      for (; i.pending + o > i.pending_buf_size; ) {
        let l = i.pending_buf_size - i.pending;
        if (i.pending_buf.set(i.gzhead.extra.subarray(i.gzindex, i.gzindex + l), i.pending), i.pending = i.pending_buf_size, i.gzhead.hcrc && i.pending > s && (e.adler = h1(e.adler, i.pending_buf, i.pending - s, s)), i.gzindex += l, i2(e), i.pending !== 0) return i.last_flush = -1, mp;
        s = 0, o -= l;
      }
      let r = new Uint8Array(i.gzhead.extra);
      i.pending_buf.set(r.subarray(i.gzindex, i.gzindex + o), i.pending), i.pending += o, i.gzhead.hcrc && i.pending > s && (e.adler = h1(e.adler, i.pending_buf, i.pending - s, s)), i.gzindex = 0;
    }
    i.status = 73;
  }
  if (i.status === 73) {
    if (i.gzhead.name) {
      let s, o = i.pending;
      do {
        if (i.pending === i.pending_buf_size) {
          if (i.gzhead.hcrc && i.pending > o && (e.adler = h1(e.adler, i.pending_buf, i.pending - o, o)), i2(e), i.pending !== 0) return i.last_flush = -1, mp;
          o = 0;
        }
        s = i.gzindex < i.gzhead.name.length ? 255 & i.gzhead.name.charCodeAt(i.gzindex++) : 0, ol(i, s);
      } while (s !== 0);
      i.gzhead.hcrc && i.pending > o && (e.adler = h1(e.adler, i.pending_buf, i.pending - o, o)), i.gzindex = 0;
    }
    i.status = 91;
  }
  if (i.status === 91) {
    if (i.gzhead.comment) {
      let s, o = i.pending;
      do {
        if (i.pending === i.pending_buf_size) {
          if (i.gzhead.hcrc && i.pending > o && (e.adler = h1(e.adler, i.pending_buf, i.pending - o, o)), i2(e), i.pending !== 0) return i.last_flush = -1, mp;
          o = 0;
        }
        s = i.gzindex < i.gzhead.comment.length ? 255 & i.gzhead.comment.charCodeAt(i.gzindex++) : 0, ol(i, s);
      } while (s !== 0);
      i.gzhead.hcrc && i.pending > o && (e.adler = h1(e.adler, i.pending_buf, i.pending - o, o));
    }
    i.status = 103;
  }
  if (i.status === 103) {
    if (i.gzhead.hcrc) {
      if (i.pending + 2 > i.pending_buf_size && (i2(e), i.pending !== 0)) return i.last_flush = -1, mp;
      ol(i, 255 & e.adler), ol(i, e.adler >> 8 & 255), e.adler = 0;
    }
    if (i.status = ZU, i2(e), i.pending !== 0) return i.last_flush = -1, mp;
  }
  if (e.avail_in !== 0 || i.lookahead !== 0 || t !== FP && i.status !== rJ) {
    let s = i.level === 0 ? SSe(i, t) : i.strategy === ese ? ((o, r) => {
      let l;
      for (; ; ) {
        if (o.lookahead === 0 && (fz(o), o.lookahead === 0)) {
          if (r === FP) return 1;
          break;
        }
        if (o.match_length = 0, l = BP(o, 0, o.window[o.strstart]), o.lookahead--, o.strstart++, l && (H2(o, !1), o.strm.avail_out === 0)) return 1;
      }
      return o.insert = 0, r === p5 ? (H2(o, !0), o.strm.avail_out === 0 ? 3 : 4) : o.sym_next && (H2(o, !1), o.strm.avail_out === 0) ? 1 : 2;
    })(i, t) : i.strategy === dWe ? ((o, r) => {
      let l, c, h, I;
      const p = o.window;
      for (; ; ) {
        if (o.lookahead <= uB) {
          if (fz(o), o.lookahead <= uB && r === FP) return 1;
          if (o.lookahead === 0) break;
        }
        if (o.match_length = 0, o.lookahead >= 3 && o.strstart > 0 && (h = o.strstart - 1, c = p[h], c === p[++h] && c === p[++h] && c === p[++h])) {
          I = o.strstart + uB;
          do
            ;
          while (c === p[++h] && c === p[++h] && c === p[++h] && c === p[++h] && c === p[++h] && c === p[++h] && c === p[++h] && c === p[++h] && h < I);
          o.match_length = uB - (I - h), o.match_length > o.lookahead && (o.match_length = o.lookahead);
        }
        if (o.match_length >= 3 ? (l = BP(o, 1, o.match_length - 3), o.lookahead -= o.match_length, o.strstart += o.match_length, o.match_length = 0) : (l = BP(o, 0, o.window[o.strstart]), o.lookahead--, o.strstart++), l && (H2(o, !1), o.strm.avail_out === 0)) return 1;
      }
      return o.insert = 0, r === p5 ? (H2(o, !0), o.strm.avail_out === 0 ? 3 : 4) : o.sym_next && (H2(o, !1), o.strm.avail_out === 0) ? 1 : 2;
    })(i, t) : lJ[i.level].func(i, t);
    if (s !== 3 && s !== 4 || (i.status = rJ), s === 1 || s === 3) return e.avail_out === 0 && (i.last_flush = -1), mp;
    if (s === 2 && (t === oWe ? sWe(i) : t !== dwe && (wIe(i, 0, 0, !1), t === rWe && (dx(i.head), i.lookahead === 0 && (i.strstart = 0, i.block_start = 0, i.insert = 0))), i2(e), e.avail_out === 0)) return i.last_flush = -1, mp;
  }
  return t !== p5 ? mp : i.wrap <= 0 ? cwe : (i.wrap === 2 ? (ol(i, 255 & e.adler), ol(i, e.adler >> 8 & 255), ol(i, e.adler >> 16 & 255), ol(i, e.adler >> 24 & 255), ol(i, 255 & e.total_in), ol(i, e.total_in >> 8 & 255), ol(i, e.total_in >> 16 & 255), ol(i, e.total_in >> 24 & 255)) : (NZ(i, e.adler >>> 16), NZ(i, 65535 & e.adler)), i2(e), i.wrap > 0 && (i.wrap = -i.wrap), i.pending !== 0 ? mp : cwe);
}, deflateEnd: (e) => {
  if (aJ(e)) return Sb;
  const t = e.state.status;
  return e.state = null, t === ZU ? QU(e, lWe) : mp;
}, deflateSetDictionary: (e, t) => {
  let i = t.length;
  if (aJ(e)) return Sb;
  const n = e.state, s = n.wrap;
  if (s === 2 || s === 1 && n.status !== Lz || n.lookahead) return Sb;
  if (s === 1 && (e.adler = MJ(e.adler, t, i, 0)), n.wrap = 0, i >= n.w_size) {
    s === 0 && (dx(n.head), n.strstart = 0, n.block_start = 0, n.insert = 0);
    let c = new Uint8Array(n.w_size);
    c.set(t.subarray(i - n.w_size, i), 0), t = c, i = n.w_size;
  }
  const o = e.avail_in, r = e.next_in, l = e.input;
  for (e.avail_in = i, e.next_in = 0, e.input = t, fz(n); n.lookahead >= 3; ) {
    let c = n.strstart, h = n.lookahead - 2;
    do
      n.ins_h = HP(n, n.ins_h, n.window[c + 3 - 1]), n.prev[c & n.w_mask] = n.head[n.ins_h], n.head[n.ins_h] = c, c++;
    while (--h);
    n.strstart = c, n.lookahead = 2, fz(n);
  }
  return n.strstart += n.lookahead, n.block_start = n.strstart, n.insert = n.lookahead, n.lookahead = 0, n.match_length = n.prev_length = 2, n.match_available = 0, e.next_in = r, e.input = l, e.avail_in = o, n.wrap = s, mp;
}, deflateInfo: "pako deflate (from Nodeca project)" };
const mWe = (e, t) => Object.prototype.hasOwnProperty.call(e, t);
var DSe = function(e) {
  const t = Array.prototype.slice.call(arguments, 1);
  for (; t.length; ) {
    const i = t.shift();
    if (i) {
      if (typeof i != "object") throw new TypeError(i + "must be non-object");
      for (const n in i) mWe(i, n) && (e[n] = i[n]);
    }
  }
  return e;
}, CSe = (e) => {
  let t = 0;
  for (let n = 0, s = e.length; n < s; n++) t += e[n].length;
  const i = new Uint8Array(t);
  for (let n = 0, s = 0, o = e.length; n < o; n++) {
    let r = e[n];
    i.set(r, s), s += r.length;
  }
  return i;
};
let OSe = !0;
try {
  String.fromCharCode.apply(null, new Uint8Array(1));
} catch {
  OSe = !1;
}
const PX = new Uint8Array(256);
for (let e = 0; e < 256; e++) PX[e] = e >= 252 ? 6 : e >= 248 ? 5 : e >= 240 ? 4 : e >= 224 ? 3 : e >= 192 ? 2 : 1;
PX[254] = PX[254] = 1;
var Nme = (e) => {
  if (typeof TextEncoder == "function" && TextEncoder.prototype.encode) return new TextEncoder().encode(e);
  let t, i, n, s, o, r = e.length, l = 0;
  for (s = 0; s < r; s++) i = e.charCodeAt(s), (64512 & i) == 55296 && s + 1 < r && (n = e.charCodeAt(s + 1), (64512 & n) == 56320 && (i = 65536 + (i - 55296 << 10) + (n - 56320), s++)), l += i < 128 ? 1 : i < 2048 ? 2 : i < 65536 ? 3 : 4;
  for (t = new Uint8Array(l), o = 0, s = 0; o < l; s++) i = e.charCodeAt(s), (64512 & i) == 55296 && s + 1 < r && (n = e.charCodeAt(s + 1), (64512 & n) == 56320 && (i = 65536 + (i - 55296 << 10) + (n - 56320), s++)), i < 128 ? t[o++] = i : i < 2048 ? (t[o++] = 192 | i >>> 6, t[o++] = 128 | 63 & i) : i < 65536 ? (t[o++] = 224 | i >>> 12, t[o++] = 128 | i >>> 6 & 63, t[o++] = 128 | 63 & i) : (t[o++] = 240 | i >>> 18, t[o++] = 128 | i >>> 12 & 63, t[o++] = 128 | i >>> 6 & 63, t[o++] = 128 | 63 & i);
  return t;
}, yWe = (e, t) => {
  const i = t || e.length;
  if (typeof TextDecoder == "function" && TextDecoder.prototype.decode) return new TextDecoder().decode(e.subarray(0, t));
  let n, s;
  const o = new Array(2 * i);
  for (s = 0, n = 0; n < i; ) {
    let r = e[n++];
    if (r < 128) {
      o[s++] = r;
      continue;
    }
    let l = PX[r];
    if (l > 4) o[s++] = 65533, n += l - 1;
    else {
      for (r &= l === 2 ? 31 : l === 3 ? 15 : 7; l > 1 && n < i; ) r = r << 6 | 63 & e[n++], l--;
      l > 1 ? o[s++] = 65533 : r < 65536 ? o[s++] = r : (r -= 65536, o[s++] = 55296 | r >> 10 & 1023, o[s++] = 56320 | 1023 & r);
    }
  }
  return ((r, l) => {
    if (l < 65534 && r.subarray && OSe) return String.fromCharCode.apply(null, r.length === l ? r : r.subarray(0, l));
    let c = "";
    for (let h = 0; h < l; h++) c += String.fromCharCode(r[h]);
    return c;
  })(o, s);
}, EWe = (e, t) => {
  (t = t || e.length) > e.length && (t = e.length);
  let i = t - 1;
  for (; i >= 0 && (192 & e[i]) == 128; ) i--;
  return i < 0 || i === 0 ? t : i + PX[e[i]] > t ? i : t;
}, LSe = function() {
  this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
};
const _Se = Object.prototype.toString, { Z_NO_FLUSH: gWe, Z_SYNC_FLUSH: wWe, Z_FULL_FLUSH: TWe, Z_FINISH: RWe, Z_OK: Nle, Z_STREAM_END: vWe, Z_DEFAULT_COMPRESSION: AWe, Z_DEFAULT_STRATEGY: SWe, Z_DEFLATED: bWe } = Bie;
function BJ(e) {
  this.options = DSe({ level: AWe, method: bWe, chunkSize: 16384, windowBits: 15, memLevel: 8, strategy: SWe }, e || {});
  let t = this.options;
  t.raw && t.windowBits > 0 ? t.windowBits = -t.windowBits : t.gzip && t.windowBits > 0 && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new LSe(), this.strm.avail_out = 0;
  let i = UJ.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
  if (i !== Nle) throw new Error(SH[i]);
  if (t.header && UJ.deflateSetHeader(this.strm, t.header), t.dictionary) {
    let n;
    if (n = typeof t.dictionary == "string" ? Nme(t.dictionary) : _Se.call(t.dictionary) === "[object ArrayBuffer]" ? new Uint8Array(t.dictionary) : t.dictionary, i = UJ.deflateSetDictionary(this.strm, n), i !== Nle) throw new Error(SH[i]);
    this._dict_set = !0;
  }
}
function ice(e, t) {
  const i = new BJ(t);
  if (i.push(e, !0), i.err) throw i.msg || SH[i.err];
  return i.result;
}
BJ.prototype.push = function(e, t) {
  const i = this.strm, n = this.options.chunkSize;
  let s, o;
  if (this.ended) return !1;
  for (o = t === ~~t ? t : t === !0 ? RWe : gWe, typeof e == "string" ? i.input = Nme(e) : _Se.call(e) === "[object ArrayBuffer]" ? i.input = new Uint8Array(e) : i.input = e, i.next_in = 0, i.avail_in = i.input.length; ; ) if (i.avail_out === 0 && (i.output = new Uint8Array(n), i.next_out = 0, i.avail_out = n), (o === wWe || o === TWe) && i.avail_out <= 6) this.onData(i.output.subarray(0, i.next_out)), i.avail_out = 0;
  else {
    if (s = UJ.deflate(i, o), s === vWe) return i.next_out > 0 && this.onData(i.output.subarray(0, i.next_out)), s = UJ.deflateEnd(this.strm), this.onEnd(s), this.ended = !0, s === Nle;
    if (i.avail_out !== 0) {
      if (o > 0 && i.next_out > 0) this.onData(i.output.subarray(0, i.next_out)), i.avail_out = 0;
      else if (i.avail_in === 0) break;
    } else this.onData(i.output);
  }
  return !0;
}, BJ.prototype.onData = function(e) {
  this.chunks.push(e);
}, BJ.prototype.onEnd = function(e) {
  e === Nle && (this.result = CSe(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
};
var NWe = { Deflate: BJ, deflate: ice, deflateRaw: function(e, t) {
  return (t = t || {}).raw = !0, ice(e, t);
}, gzip: function(e, t) {
  return (t = t || {}).gzip = !0, ice(e, t);
} };
const tse = 16209;
var DWe = function(e, t) {
  let i, n, s, o, r, l, c, h, I, p, y, m, A, C, O, R, F, L, P, z, W, re, ce, te;
  const ee = e.state;
  i = e.next_in, ce = e.input, n = i + (e.avail_in - 5), s = e.next_out, te = e.output, o = s - (t - e.avail_out), r = s + (e.avail_out - 257), l = ee.dmax, c = ee.wsize, h = ee.whave, I = ee.wnext, p = ee.window, y = ee.hold, m = ee.bits, A = ee.lencode, C = ee.distcode, O = (1 << ee.lenbits) - 1, R = (1 << ee.distbits) - 1;
  e: do {
    m < 15 && (y += ce[i++] << m, m += 8, y += ce[i++] << m, m += 8), F = A[y & O];
    t: for (; ; ) {
      if (L = F >>> 24, y >>>= L, m -= L, L = F >>> 16 & 255, L === 0) te[s++] = 65535 & F;
      else {
        if (!(16 & L)) {
          if (64 & L) {
            if (32 & L) {
              ee.mode = 16191;
              break e;
            }
            e.msg = "invalid literal/length code", ee.mode = tse;
            break e;
          }
          F = A[(65535 & F) + (y & (1 << L) - 1)];
          continue t;
        }
        for (P = 65535 & F, L &= 15, L && (m < L && (y += ce[i++] << m, m += 8), P += y & (1 << L) - 1, y >>>= L, m -= L), m < 15 && (y += ce[i++] << m, m += 8, y += ce[i++] << m, m += 8), F = C[y & R]; ; ) {
          if (L = F >>> 24, y >>>= L, m -= L, L = F >>> 16 & 255, 16 & L) {
            if (z = 65535 & F, L &= 15, m < L && (y += ce[i++] << m, m += 8, m < L && (y += ce[i++] << m, m += 8)), z += y & (1 << L) - 1, z > l) {
              e.msg = "invalid distance too far back", ee.mode = tse;
              break e;
            }
            if (y >>>= L, m -= L, L = s - o, z > L) {
              if (L = z - L, L > h && ee.sane) {
                e.msg = "invalid distance too far back", ee.mode = tse;
                break e;
              }
              if (W = 0, re = p, I === 0) {
                if (W += c - L, L < P) {
                  P -= L;
                  do
                    te[s++] = p[W++];
                  while (--L);
                  W = s - z, re = te;
                }
              } else if (I < L) {
                if (W += c + I - L, L -= I, L < P) {
                  P -= L;
                  do
                    te[s++] = p[W++];
                  while (--L);
                  if (W = 0, I < P) {
                    L = I, P -= L;
                    do
                      te[s++] = p[W++];
                    while (--L);
                    W = s - z, re = te;
                  }
                }
              } else if (W += I - L, L < P) {
                P -= L;
                do
                  te[s++] = p[W++];
                while (--L);
                W = s - z, re = te;
              }
              for (; P > 2; ) te[s++] = re[W++], te[s++] = re[W++], te[s++] = re[W++], P -= 3;
              P && (te[s++] = re[W++], P > 1 && (te[s++] = re[W++]));
            } else {
              W = s - z;
              do
                te[s++] = te[W++], te[s++] = te[W++], te[s++] = te[W++], P -= 3;
              while (P > 2);
              P && (te[s++] = te[W++], P > 1 && (te[s++] = te[W++]));
            }
            break;
          }
          if (64 & L) {
            e.msg = "invalid distance code", ee.mode = tse;
            break e;
          }
          F = C[(65535 & F) + (y & (1 << L) - 1)];
        }
      }
      break;
    }
  } while (i < n && s < r);
  P = m >> 3, i -= P, m -= P << 3, y &= (1 << m) - 1, e.next_in = i, e.next_out = s, e.avail_in = i < n ? n - i + 5 : 5 - (i - n), e.avail_out = s < r ? r - s + 257 : 257 - (s - r), ee.hold = y, ee.bits = m;
};
const ise = 15, CWe = new Uint16Array([3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0]), OWe = new Uint8Array([16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78]), LWe = new Uint16Array([1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0]), _We = new Uint8Array([16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64]);
var FJ = (e, t, i, n, s, o, r, l) => {
  const c = l.bits;
  let h, I, p, y, m, A, C = 0, O = 0, R = 0, F = 0, L = 0, P = 0, z = 0, W = 0, re = 0, ce = 0, te = null;
  const ee = new Uint16Array(16), Ne = new Uint16Array(16);
  let Ae, Oe, pe, je = null;
  for (C = 0; C <= ise; C++) ee[C] = 0;
  for (O = 0; O < n; O++) ee[t[i + O]]++;
  for (L = c, F = ise; F >= 1 && ee[F] === 0; F--) ;
  if (L > F && (L = F), F === 0) return s[o++] = 20971520, s[o++] = 20971520, l.bits = 1, 0;
  for (R = 1; R < F && ee[R] === 0; R++) ;
  for (L < R && (L = R), W = 1, C = 1; C <= ise; C++) if (W <<= 1, W -= ee[C], W < 0) return -1;
  if (W > 0 && (e === 0 || F !== 1)) return -1;
  for (Ne[1] = 0, C = 1; C < ise; C++) Ne[C + 1] = Ne[C] + ee[C];
  for (O = 0; O < n; O++) t[i + O] !== 0 && (r[Ne[t[i + O]]++] = O);
  if (e === 0 ? (te = je = r, A = 20) : e === 1 ? (te = CWe, je = OWe, A = 257) : (te = LWe, je = _We, A = 0), ce = 0, O = 0, C = R, m = o, P = L, z = 0, p = -1, re = 1 << L, y = re - 1, e === 1 && re > 852 || e === 2 && re > 592) return 1;
  for (; ; ) {
    Ae = C - z, r[O] + 1 < A ? (Oe = 0, pe = r[O]) : r[O] >= A ? (Oe = je[r[O] - A], pe = te[r[O] - A]) : (Oe = 96, pe = 0), h = 1 << C - z, I = 1 << P, R = I;
    do
      I -= h, s[m + (ce >> z) + I] = Ae << 24 | Oe << 16 | pe;
    while (I !== 0);
    for (h = 1 << C - 1; ce & h; ) h >>= 1;
    if (h !== 0 ? (ce &= h - 1, ce += h) : ce = 0, O++, --ee[C] == 0) {
      if (C === F) break;
      C = t[i + r[O]];
    }
    if (C > L && (ce & y) !== p) {
      for (z === 0 && (z = L), m += R, P = C - z, W = 1 << P; P + z < F && (W -= ee[P + z], !(W <= 0)); ) P++, W <<= 1;
      if (re += 1 << P, e === 1 && re > 852 || e === 2 && re > 592) return 1;
      p = ce & y, s[p] = L << 24 | P << 16 | m - o;
    }
  }
  return ce !== 0 && (s[m + ce] = C - z << 24 | 64 << 16), l.bits = L, 0;
};
const { Z_FINISH: Iwe, Z_BLOCK: xWe, Z_TREES: nse, Z_OK: JU, Z_STREAM_END: PWe, Z_NEED_DICT: MWe, Z_STREAM_ERROR: l5, Z_DATA_ERROR: pwe, Z_MEM_ERROR: mwe, Z_BUF_ERROR: UWe, Z_DEFLATED: ywe } = Bie, gue = 16180, sse = 16190, GD = 16191, nce = 16192, sce = 16194, ose = 16199, rse = 16200, oce = 16206, _u = 16209, Ewe = (e) => (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
function BWe() {
  this.strm = null, this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Uint16Array(320), this.work = new Uint16Array(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
}
const dB = (e) => {
  if (!e) return 1;
  const t = e.state;
  return !t || t.strm !== e || t.mode < gue || t.mode > 16211 ? 1 : 0;
}, xSe = (e) => {
  if (dB(e)) return l5;
  const t = e.state;
  return e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = gue, t.last = 0, t.havedict = 0, t.flags = -1, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new Int32Array(852), t.distcode = t.distdyn = new Int32Array(592), t.sane = 1, t.back = -1, JU;
}, PSe = (e) => {
  if (dB(e)) return l5;
  const t = e.state;
  return t.wsize = 0, t.whave = 0, t.wnext = 0, xSe(e);
}, MSe = (e, t) => {
  let i;
  if (dB(e)) return l5;
  const n = e.state;
  return t < 0 ? (i = 0, t = -t) : (i = 5 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || t > 15) ? l5 : (n.window !== null && n.wbits !== t && (n.window = null), n.wrap = i, n.wbits = t, PSe(e));
}, gwe = (e, t) => {
  if (!e) return l5;
  const i = new BWe();
  e.state = i, i.strm = e, i.window = null, i.mode = gue;
  const n = MSe(e, t);
  return n !== JU && (e.state = null), n;
};
let rce, lce, wwe = !0;
const FWe = (e) => {
  if (wwe) {
    rce = new Int32Array(512), lce = new Int32Array(32);
    let t = 0;
    for (; t < 144; ) e.lens[t++] = 8;
    for (; t < 256; ) e.lens[t++] = 9;
    for (; t < 280; ) e.lens[t++] = 7;
    for (; t < 288; ) e.lens[t++] = 8;
    for (FJ(1, e.lens, 0, 288, rce, 0, e.work, { bits: 9 }), t = 0; t < 32; ) e.lens[t++] = 5;
    FJ(2, e.lens, 0, 32, lce, 0, e.work, { bits: 5 }), wwe = !1;
  }
  e.lencode = rce, e.lenbits = 9, e.distcode = lce, e.distbits = 5;
}, Twe = (e, t, i, n) => {
  let s;
  const o = e.state;
  return o.window === null && (o.wsize = 1 << o.wbits, o.wnext = 0, o.whave = 0, o.window = new Uint8Array(o.wsize)), n >= o.wsize ? (o.window.set(t.subarray(i - o.wsize, i), 0), o.wnext = 0, o.whave = o.wsize) : (s = o.wsize - o.wnext, s > n && (s = n), o.window.set(t.subarray(i - n, i - n + s), o.wnext), (n -= s) ? (o.window.set(t.subarray(i - n, i), 0), o.wnext = n, o.whave = o.wsize) : (o.wnext += s, o.wnext === o.wsize && (o.wnext = 0), o.whave < o.wsize && (o.whave += s))), 0;
};
var DC = { inflateReset: PSe, inflateReset2: MSe, inflateResetKeep: xSe, inflateInit: (e) => gwe(e, 15), inflateInit2: gwe, inflate: (e, t) => {
  let i, n, s, o, r, l, c, h, I, p, y, m, A, C, O, R, F, L, P, z, W, re, ce = 0;
  const te = new Uint8Array(4);
  let ee, Ne;
  const Ae = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
  if (dB(e) || !e.output || !e.input && e.avail_in !== 0) return l5;
  i = e.state, i.mode === GD && (i.mode = nce), r = e.next_out, s = e.output, c = e.avail_out, o = e.next_in, n = e.input, l = e.avail_in, h = i.hold, I = i.bits, p = l, y = c, re = JU;
  e: for (; ; ) switch (i.mode) {
    case gue:
      if (i.wrap === 0) {
        i.mode = nce;
        break;
      }
      for (; I < 16; ) {
        if (l === 0) break e;
        l--, h += n[o++] << I, I += 8;
      }
      if (2 & i.wrap && h === 35615) {
        i.wbits === 0 && (i.wbits = 15), i.check = 0, te[0] = 255 & h, te[1] = h >>> 8 & 255, i.check = h1(i.check, te, 2, 0), h = 0, I = 0, i.mode = 16181;
        break;
      }
      if (i.head && (i.head.done = !1), !(1 & i.wrap) || (((255 & h) << 8) + (h >> 8)) % 31) {
        e.msg = "incorrect header check", i.mode = _u;
        break;
      }
      if ((15 & h) !== ywe) {
        e.msg = "unknown compression method", i.mode = _u;
        break;
      }
      if (h >>>= 4, I -= 4, W = 8 + (15 & h), i.wbits === 0 && (i.wbits = W), W > 15 || W > i.wbits) {
        e.msg = "invalid window size", i.mode = _u;
        break;
      }
      i.dmax = 1 << i.wbits, i.flags = 0, e.adler = i.check = 1, i.mode = 512 & h ? 16189 : GD, h = 0, I = 0;
      break;
    case 16181:
      for (; I < 16; ) {
        if (l === 0) break e;
        l--, h += n[o++] << I, I += 8;
      }
      if (i.flags = h, (255 & i.flags) !== ywe) {
        e.msg = "unknown compression method", i.mode = _u;
        break;
      }
      if (57344 & i.flags) {
        e.msg = "unknown header flags set", i.mode = _u;
        break;
      }
      i.head && (i.head.text = h >> 8 & 1), 512 & i.flags && 4 & i.wrap && (te[0] = 255 & h, te[1] = h >>> 8 & 255, i.check = h1(i.check, te, 2, 0)), h = 0, I = 0, i.mode = 16182;
    case 16182:
      for (; I < 32; ) {
        if (l === 0) break e;
        l--, h += n[o++] << I, I += 8;
      }
      i.head && (i.head.time = h), 512 & i.flags && 4 & i.wrap && (te[0] = 255 & h, te[1] = h >>> 8 & 255, te[2] = h >>> 16 & 255, te[3] = h >>> 24 & 255, i.check = h1(i.check, te, 4, 0)), h = 0, I = 0, i.mode = 16183;
    case 16183:
      for (; I < 16; ) {
        if (l === 0) break e;
        l--, h += n[o++] << I, I += 8;
      }
      i.head && (i.head.xflags = 255 & h, i.head.os = h >> 8), 512 & i.flags && 4 & i.wrap && (te[0] = 255 & h, te[1] = h >>> 8 & 255, i.check = h1(i.check, te, 2, 0)), h = 0, I = 0, i.mode = 16184;
    case 16184:
      if (1024 & i.flags) {
        for (; I < 16; ) {
          if (l === 0) break e;
          l--, h += n[o++] << I, I += 8;
        }
        i.length = h, i.head && (i.head.extra_len = h), 512 & i.flags && 4 & i.wrap && (te[0] = 255 & h, te[1] = h >>> 8 & 255, i.check = h1(i.check, te, 2, 0)), h = 0, I = 0;
      } else i.head && (i.head.extra = null);
      i.mode = 16185;
    case 16185:
      if (1024 & i.flags && (m = i.length, m > l && (m = l), m && (i.head && (W = i.head.extra_len - i.length, i.head.extra || (i.head.extra = new Uint8Array(i.head.extra_len)), i.head.extra.set(n.subarray(o, o + m), W)), 512 & i.flags && 4 & i.wrap && (i.check = h1(i.check, n, m, o)), l -= m, o += m, i.length -= m), i.length)) break e;
      i.length = 0, i.mode = 16186;
    case 16186:
      if (2048 & i.flags) {
        if (l === 0) break e;
        m = 0;
        do
          W = n[o + m++], i.head && W && i.length < 65536 && (i.head.name += String.fromCharCode(W));
        while (W && m < l);
        if (512 & i.flags && 4 & i.wrap && (i.check = h1(i.check, n, m, o)), l -= m, o += m, W) break e;
      } else i.head && (i.head.name = null);
      i.length = 0, i.mode = 16187;
    case 16187:
      if (4096 & i.flags) {
        if (l === 0) break e;
        m = 0;
        do
          W = n[o + m++], i.head && W && i.length < 65536 && (i.head.comment += String.fromCharCode(W));
        while (W && m < l);
        if (512 & i.flags && 4 & i.wrap && (i.check = h1(i.check, n, m, o)), l -= m, o += m, W) break e;
      } else i.head && (i.head.comment = null);
      i.mode = 16188;
    case 16188:
      if (512 & i.flags) {
        for (; I < 16; ) {
          if (l === 0) break e;
          l--, h += n[o++] << I, I += 8;
        }
        if (4 & i.wrap && h !== (65535 & i.check)) {
          e.msg = "header crc mismatch", i.mode = _u;
          break;
        }
        h = 0, I = 0;
      }
      i.head && (i.head.hcrc = i.flags >> 9 & 1, i.head.done = !0), e.adler = i.check = 0, i.mode = GD;
      break;
    case 16189:
      for (; I < 32; ) {
        if (l === 0) break e;
        l--, h += n[o++] << I, I += 8;
      }
      e.adler = i.check = Ewe(h), h = 0, I = 0, i.mode = sse;
    case sse:
      if (i.havedict === 0) return e.next_out = r, e.avail_out = c, e.next_in = o, e.avail_in = l, i.hold = h, i.bits = I, MWe;
      e.adler = i.check = 1, i.mode = GD;
    case GD:
      if (t === xWe || t === nse) break e;
    case nce:
      if (i.last) {
        h >>>= 7 & I, I -= 7 & I, i.mode = oce;
        break;
      }
      for (; I < 3; ) {
        if (l === 0) break e;
        l--, h += n[o++] << I, I += 8;
      }
      switch (i.last = 1 & h, h >>>= 1, I -= 1, 3 & h) {
        case 0:
          i.mode = 16193;
          break;
        case 1:
          if (FWe(i), i.mode = ose, t === nse) {
            h >>>= 2, I -= 2;
            break e;
          }
          break;
        case 2:
          i.mode = 16196;
          break;
        case 3:
          e.msg = "invalid block type", i.mode = _u;
      }
      h >>>= 2, I -= 2;
      break;
    case 16193:
      for (h >>>= 7 & I, I -= 7 & I; I < 32; ) {
        if (l === 0) break e;
        l--, h += n[o++] << I, I += 8;
      }
      if ((65535 & h) != (h >>> 16 ^ 65535)) {
        e.msg = "invalid stored block lengths", i.mode = _u;
        break;
      }
      if (i.length = 65535 & h, h = 0, I = 0, i.mode = sce, t === nse) break e;
    case sce:
      i.mode = 16195;
    case 16195:
      if (m = i.length, m) {
        if (m > l && (m = l), m > c && (m = c), m === 0) break e;
        s.set(n.subarray(o, o + m), r), l -= m, o += m, c -= m, r += m, i.length -= m;
        break;
      }
      i.mode = GD;
      break;
    case 16196:
      for (; I < 14; ) {
        if (l === 0) break e;
        l--, h += n[o++] << I, I += 8;
      }
      if (i.nlen = 257 + (31 & h), h >>>= 5, I -= 5, i.ndist = 1 + (31 & h), h >>>= 5, I -= 5, i.ncode = 4 + (15 & h), h >>>= 4, I -= 4, i.nlen > 286 || i.ndist > 30) {
        e.msg = "too many length or distance symbols", i.mode = _u;
        break;
      }
      i.have = 0, i.mode = 16197;
    case 16197:
      for (; i.have < i.ncode; ) {
        for (; I < 3; ) {
          if (l === 0) break e;
          l--, h += n[o++] << I, I += 8;
        }
        i.lens[Ae[i.have++]] = 7 & h, h >>>= 3, I -= 3;
      }
      for (; i.have < 19; ) i.lens[Ae[i.have++]] = 0;
      if (i.lencode = i.lendyn, i.lenbits = 7, ee = { bits: i.lenbits }, re = FJ(0, i.lens, 0, 19, i.lencode, 0, i.work, ee), i.lenbits = ee.bits, re) {
        e.msg = "invalid code lengths set", i.mode = _u;
        break;
      }
      i.have = 0, i.mode = 16198;
    case 16198:
      for (; i.have < i.nlen + i.ndist; ) {
        for (; ce = i.lencode[h & (1 << i.lenbits) - 1], O = ce >>> 24, R = ce >>> 16 & 255, F = 65535 & ce, !(O <= I); ) {
          if (l === 0) break e;
          l--, h += n[o++] << I, I += 8;
        }
        if (F < 16) h >>>= O, I -= O, i.lens[i.have++] = F;
        else {
          if (F === 16) {
            for (Ne = O + 2; I < Ne; ) {
              if (l === 0) break e;
              l--, h += n[o++] << I, I += 8;
            }
            if (h >>>= O, I -= O, i.have === 0) {
              e.msg = "invalid bit length repeat", i.mode = _u;
              break;
            }
            W = i.lens[i.have - 1], m = 3 + (3 & h), h >>>= 2, I -= 2;
          } else if (F === 17) {
            for (Ne = O + 3; I < Ne; ) {
              if (l === 0) break e;
              l--, h += n[o++] << I, I += 8;
            }
            h >>>= O, I -= O, W = 0, m = 3 + (7 & h), h >>>= 3, I -= 3;
          } else {
            for (Ne = O + 7; I < Ne; ) {
              if (l === 0) break e;
              l--, h += n[o++] << I, I += 8;
            }
            h >>>= O, I -= O, W = 0, m = 11 + (127 & h), h >>>= 7, I -= 7;
          }
          if (i.have + m > i.nlen + i.ndist) {
            e.msg = "invalid bit length repeat", i.mode = _u;
            break;
          }
          for (; m--; ) i.lens[i.have++] = W;
        }
      }
      if (i.mode === _u) break;
      if (i.lens[256] === 0) {
        e.msg = "invalid code -- missing end-of-block", i.mode = _u;
        break;
      }
      if (i.lenbits = 9, ee = { bits: i.lenbits }, re = FJ(1, i.lens, 0, i.nlen, i.lencode, 0, i.work, ee), i.lenbits = ee.bits, re) {
        e.msg = "invalid literal/lengths set", i.mode = _u;
        break;
      }
      if (i.distbits = 6, i.distcode = i.distdyn, ee = { bits: i.distbits }, re = FJ(2, i.lens, i.nlen, i.ndist, i.distcode, 0, i.work, ee), i.distbits = ee.bits, re) {
        e.msg = "invalid distances set", i.mode = _u;
        break;
      }
      if (i.mode = ose, t === nse) break e;
    case ose:
      i.mode = rse;
    case rse:
      if (l >= 6 && c >= 258) {
        e.next_out = r, e.avail_out = c, e.next_in = o, e.avail_in = l, i.hold = h, i.bits = I, DWe(e, y), r = e.next_out, s = e.output, c = e.avail_out, o = e.next_in, n = e.input, l = e.avail_in, h = i.hold, I = i.bits, i.mode === GD && (i.back = -1);
        break;
      }
      for (i.back = 0; ce = i.lencode[h & (1 << i.lenbits) - 1], O = ce >>> 24, R = ce >>> 16 & 255, F = 65535 & ce, !(O <= I); ) {
        if (l === 0) break e;
        l--, h += n[o++] << I, I += 8;
      }
      if (R && !(240 & R)) {
        for (L = O, P = R, z = F; ce = i.lencode[z + ((h & (1 << L + P) - 1) >> L)], O = ce >>> 24, R = ce >>> 16 & 255, F = 65535 & ce, !(L + O <= I); ) {
          if (l === 0) break e;
          l--, h += n[o++] << I, I += 8;
        }
        h >>>= L, I -= L, i.back += L;
      }
      if (h >>>= O, I -= O, i.back += O, i.length = F, R === 0) {
        i.mode = 16205;
        break;
      }
      if (32 & R) {
        i.back = -1, i.mode = GD;
        break;
      }
      if (64 & R) {
        e.msg = "invalid literal/length code", i.mode = _u;
        break;
      }
      i.extra = 15 & R, i.mode = 16201;
    case 16201:
      if (i.extra) {
        for (Ne = i.extra; I < Ne; ) {
          if (l === 0) break e;
          l--, h += n[o++] << I, I += 8;
        }
        i.length += h & (1 << i.extra) - 1, h >>>= i.extra, I -= i.extra, i.back += i.extra;
      }
      i.was = i.length, i.mode = 16202;
    case 16202:
      for (; ce = i.distcode[h & (1 << i.distbits) - 1], O = ce >>> 24, R = ce >>> 16 & 255, F = 65535 & ce, !(O <= I); ) {
        if (l === 0) break e;
        l--, h += n[o++] << I, I += 8;
      }
      if (!(240 & R)) {
        for (L = O, P = R, z = F; ce = i.distcode[z + ((h & (1 << L + P) - 1) >> L)], O = ce >>> 24, R = ce >>> 16 & 255, F = 65535 & ce, !(L + O <= I); ) {
          if (l === 0) break e;
          l--, h += n[o++] << I, I += 8;
        }
        h >>>= L, I -= L, i.back += L;
      }
      if (h >>>= O, I -= O, i.back += O, 64 & R) {
        e.msg = "invalid distance code", i.mode = _u;
        break;
      }
      i.offset = F, i.extra = 15 & R, i.mode = 16203;
    case 16203:
      if (i.extra) {
        for (Ne = i.extra; I < Ne; ) {
          if (l === 0) break e;
          l--, h += n[o++] << I, I += 8;
        }
        i.offset += h & (1 << i.extra) - 1, h >>>= i.extra, I -= i.extra, i.back += i.extra;
      }
      if (i.offset > i.dmax) {
        e.msg = "invalid distance too far back", i.mode = _u;
        break;
      }
      i.mode = 16204;
    case 16204:
      if (c === 0) break e;
      if (m = y - c, i.offset > m) {
        if (m = i.offset - m, m > i.whave && i.sane) {
          e.msg = "invalid distance too far back", i.mode = _u;
          break;
        }
        m > i.wnext ? (m -= i.wnext, A = i.wsize - m) : A = i.wnext - m, m > i.length && (m = i.length), C = i.window;
      } else C = s, A = r - i.offset, m = i.length;
      m > c && (m = c), c -= m, i.length -= m;
      do
        s[r++] = C[A++];
      while (--m);
      i.length === 0 && (i.mode = rse);
      break;
    case 16205:
      if (c === 0) break e;
      s[r++] = i.length, c--, i.mode = rse;
      break;
    case oce:
      if (i.wrap) {
        for (; I < 32; ) {
          if (l === 0) break e;
          l--, h |= n[o++] << I, I += 8;
        }
        if (y -= c, e.total_out += y, i.total += y, 4 & i.wrap && y && (e.adler = i.check = i.flags ? h1(i.check, s, y, r - y) : MJ(i.check, s, y, r - y)), y = c, 4 & i.wrap && (i.flags ? h : Ewe(h)) !== i.check) {
          e.msg = "incorrect data check", i.mode = _u;
          break;
        }
        h = 0, I = 0;
      }
      i.mode = 16207;
    case 16207:
      if (i.wrap && i.flags) {
        for (; I < 32; ) {
          if (l === 0) break e;
          l--, h += n[o++] << I, I += 8;
        }
        if (4 & i.wrap && h !== (4294967295 & i.total)) {
          e.msg = "incorrect length check", i.mode = _u;
          break;
        }
        h = 0, I = 0;
      }
      i.mode = 16208;
    case 16208:
      re = PWe;
      break e;
    case _u:
      re = pwe;
      break e;
    case 16210:
      return mwe;
    default:
      return l5;
  }
  return e.next_out = r, e.avail_out = c, e.next_in = o, e.avail_in = l, i.hold = h, i.bits = I, (i.wsize || y !== e.avail_out && i.mode < _u && (i.mode < oce || t !== Iwe)) && Twe(e, e.output, e.next_out, y - e.avail_out), p -= e.avail_in, y -= e.avail_out, e.total_in += p, e.total_out += y, i.total += y, 4 & i.wrap && y && (e.adler = i.check = i.flags ? h1(i.check, s, y, e.next_out - y) : MJ(i.check, s, y, e.next_out - y)), e.data_type = i.bits + (i.last ? 64 : 0) + (i.mode === GD ? 128 : 0) + (i.mode === ose || i.mode === sce ? 256 : 0), (p === 0 && y === 0 || t === Iwe) && re === JU && (re = UWe), re;
}, inflateEnd: (e) => {
  if (dB(e)) return l5;
  let t = e.state;
  return t.window && (t.window = null), e.state = null, JU;
}, inflateGetHeader: (e, t) => {
  if (dB(e)) return l5;
  const i = e.state;
  return 2 & i.wrap ? (i.head = t, t.done = !1, JU) : l5;
}, inflateSetDictionary: (e, t) => {
  const i = t.length;
  let n, s, o;
  return dB(e) ? l5 : (n = e.state, n.wrap !== 0 && n.mode !== sse ? l5 : n.mode === sse && (s = 1, s = MJ(s, t, i, 0), s !== n.check) ? pwe : (o = Twe(e, t, i, i), o ? (n.mode = 16210, mwe) : (n.havedict = 1, JU)));
}, inflateInfo: "pako inflate (from Nodeca project)" }, HWe = function() {
  this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
};
const USe = Object.prototype.toString, { Z_NO_FLUSH: GWe, Z_FINISH: kWe, Z_OK: HJ, Z_STREAM_END: ace, Z_NEED_DICT: uce, Z_STREAM_ERROR: VWe, Z_DATA_ERROR: Rwe, Z_MEM_ERROR: zWe } = Bie;
function GJ(e) {
  this.options = DSe({ chunkSize: 65536, windowBits: 15, to: "" }, e || {});
  const t = this.options;
  t.raw && t.windowBits >= 0 && t.windowBits < 16 && (t.windowBits = -t.windowBits, t.windowBits === 0 && (t.windowBits = -15)), !(t.windowBits >= 0 && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), t.windowBits > 15 && t.windowBits < 48 && (15 & t.windowBits || (t.windowBits |= 15)), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new LSe(), this.strm.avail_out = 0;
  let i = DC.inflateInit2(this.strm, t.windowBits);
  if (i !== HJ) throw new Error(SH[i]);
  if (this.header = new HWe(), DC.inflateGetHeader(this.strm, this.header), t.dictionary && (typeof t.dictionary == "string" ? t.dictionary = Nme(t.dictionary) : USe.call(t.dictionary) === "[object ArrayBuffer]" && (t.dictionary = new Uint8Array(t.dictionary)), t.raw && (i = DC.inflateSetDictionary(this.strm, t.dictionary), i !== HJ))) throw new Error(SH[i]);
}
function dce(e, t) {
  const i = new GJ(t);
  if (i.push(e), i.err) throw i.msg || SH[i.err];
  return i.result;
}
GJ.prototype.push = function(e, t) {
  const i = this.strm, n = this.options.chunkSize, s = this.options.dictionary;
  let o, r, l;
  if (this.ended) return !1;
  for (r = t === ~~t ? t : t === !0 ? kWe : GWe, USe.call(e) === "[object ArrayBuffer]" ? i.input = new Uint8Array(e) : i.input = e, i.next_in = 0, i.avail_in = i.input.length; ; ) {
    for (i.avail_out === 0 && (i.output = new Uint8Array(n), i.next_out = 0, i.avail_out = n), o = DC.inflate(i, r), o === uce && s && (o = DC.inflateSetDictionary(i, s), o === HJ ? o = DC.inflate(i, r) : o === Rwe && (o = uce)); i.avail_in > 0 && o === ace && i.state.wrap > 0 && e[i.next_in] !== 0; ) DC.inflateReset(i), o = DC.inflate(i, r);
    switch (o) {
      case VWe:
      case Rwe:
      case uce:
      case zWe:
        return this.onEnd(o), this.ended = !0, !1;
    }
    if (l = i.avail_out, i.next_out && (i.avail_out === 0 || o === ace)) if (this.options.to === "string") {
      let c = EWe(i.output, i.next_out), h = i.next_out - c, I = yWe(i.output, c);
      i.next_out = h, i.avail_out = n - h, h && i.output.set(i.output.subarray(c, c + h), 0), this.onData(I);
    } else this.onData(i.output.length === i.next_out ? i.output : i.output.subarray(0, i.next_out));
    if (o !== HJ || l !== 0) {
      if (o === ace) return o = DC.inflateEnd(this.strm), this.onEnd(o), this.ended = !0, !0;
      if (i.avail_in === 0) break;
    }
  }
  return !0;
}, GJ.prototype.onData = function(e) {
  this.chunks.push(e);
}, GJ.prototype.onEnd = function(e) {
  e === HJ && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = CSe(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
};
var jWe = { Inflate: GJ, inflate: dce, inflateRaw: function(e, t) {
  return (t = t || {}).raw = !0, dce(e, t);
}, ungzip: dce };
const { Deflate: WWe, deflate: YWe, deflateRaw: qWe, gzip: $We } = NWe, { Inflate: KWe, inflate: ZWe, inflateRaw: QWe, ungzip: JWe } = jWe;
var Dle = { Deflate: WWe, deflate: YWe, deflateRaw: qWe, gzip: $We, Inflate: KWe, inflate: ZWe, inflateRaw: QWe, ungzip: JWe, constants: Bie };
class Jy {
  constructor() {
    De(this, "bb", null), De(this, "bb_pos", 0);
  }
  __init(t, i) {
    return this.bb_pos = t, this.bb = i, this;
  }
  static getRootAsAttribute(t, i) {
    return (i || new Jy()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsAttribute(t, i) {
    return t.setPosition(t.position() + 4), (i || new Jy()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  data(t, i) {
    const n = this.bb.__offset(this.bb_pos, 4);
    return n ? this.bb.__string(this.bb.__vector(this.bb_pos + n) + 4 * t, i) : null;
  }
  dataLength() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  static startAttribute(t) {
    t.startObject(1);
  }
  static addData(t, i) {
    t.addFieldOffset(0, i, 0);
  }
  static createDataVector(t, i) {
    t.startVector(4, i.length, 4);
    for (let n = i.length - 1; n >= 0; n--) t.addOffset(i[n]);
    return t.endVector();
  }
  static startDataVector(t, i) {
    t.startVector(4, i, 4);
  }
  static endAttribute(t) {
    const i = t.endObject();
    return t.requiredField(i, 4), i;
  }
  static createAttribute(t, i) {
    return Jy.startAttribute(t), Jy.addData(t, i), Jy.endAttribute(t);
  }
}
class Rf {
  constructor() {
    De(this, "bb", null), De(this, "bb_pos", 0);
  }
  __init(t, i) {
    return this.bb_pos = t, this.bb = i, this;
  }
  x() {
    return this.bb.readFloat32(this.bb_pos);
  }
  mutate_x(t) {
    return this.bb.writeFloat32(this.bb_pos + 0, t), !0;
  }
  y() {
    return this.bb.readFloat32(this.bb_pos + 4);
  }
  mutate_y(t) {
    return this.bb.writeFloat32(this.bb_pos + 4, t), !0;
  }
  z() {
    return this.bb.readFloat32(this.bb_pos + 8);
  }
  mutate_z(t) {
    return this.bb.writeFloat32(this.bb_pos + 8, t), !0;
  }
  static sizeOf() {
    return 12;
  }
  static createFloatVector(t, i, n, s) {
    return t.prep(4, 12), t.writeFloat32(s), t.writeFloat32(n), t.writeFloat32(i), t.offset();
  }
}
class rY {
  constructor() {
    De(this, "bb", null), De(this, "bb_pos", 0);
  }
  __init(t, i) {
    return this.bb_pos = t, this.bb = i, this;
  }
  aperture() {
    return this.bb.readFloat32(this.bb_pos);
  }
  mutate_aperture(t) {
    return this.bb.writeFloat32(this.bb_pos + 0, t), !0;
  }
  position(t) {
    return (t || new Rf()).__init(this.bb_pos + 4, this.bb);
  }
  radius() {
    return this.bb.readFloat32(this.bb_pos + 16);
  }
  mutate_radius(t) {
    return this.bb.writeFloat32(this.bb_pos + 16, t), !0;
  }
  xDirection(t) {
    return (t || new Rf()).__init(this.bb_pos + 20, this.bb);
  }
  yDirection(t) {
    return (t || new Rf()).__init(this.bb_pos + 32, this.bb);
  }
  static sizeOf() {
    return 44;
  }
  static createCircleCurve(t, i, n, s, o, r, l, c, h, I, p, y) {
    return t.prep(4, 44), t.prep(4, 12), t.writeFloat32(y), t.writeFloat32(p), t.writeFloat32(I), t.prep(4, 12), t.writeFloat32(h), t.writeFloat32(c), t.writeFloat32(l), t.writeFloat32(r), t.prep(4, 12), t.writeFloat32(o), t.writeFloat32(s), t.writeFloat32(n), t.writeFloat32(i), t.offset();
  }
}
class Fie {
  constructor() {
    De(this, "bb", null), De(this, "bb_pos", 0);
  }
  __init(t, i) {
    return this.bb_pos = t, this.bb = i, this;
  }
  p1(t) {
    return (t || new Rf()).__init(this.bb_pos, this.bb);
  }
  p2(t) {
    return (t || new Rf()).__init(this.bb_pos + 12, this.bb);
  }
  static sizeOf() {
    return 24;
  }
  static createWire(t, i, n, s, o, r, l) {
    return t.prep(4, 24), t.prep(4, 12), t.writeFloat32(l), t.writeFloat32(r), t.writeFloat32(o), t.prep(4, 12), t.writeFloat32(s), t.writeFloat32(n), t.writeFloat32(i), t.offset();
  }
}
class k2 {
  constructor() {
    De(this, "bb", null), De(this, "bb_pos", 0);
  }
  __init(t, i) {
    return this.bb_pos = t, this.bb = i, this;
  }
  static getRootAsWireSet(t, i) {
    return (i || new k2()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsWireSet(t, i) {
    return t.setPosition(t.position() + 4), (i || new k2()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  ps(t, i) {
    const n = this.bb.__offset(this.bb_pos, 4);
    return n ? (i || new Rf()).__init(this.bb.__vector(this.bb_pos + n) + 12 * t, this.bb) : null;
  }
  psLength() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  static startWireSet(t) {
    t.startObject(1);
  }
  static addPs(t, i) {
    t.addFieldOffset(0, i, 0);
  }
  static startPsVector(t, i) {
    t.startVector(12, i, 4);
  }
  static endWireSet(t) {
    return t.endObject();
  }
  static createWireSet(t, i) {
    return k2.startWireSet(t), k2.addPs(t, i), k2.endWireSet(t);
  }
}
class Ds {
  constructor() {
    De(this, "bb", null), De(this, "bb_pos", 0);
  }
  __init(t, i) {
    return this.bb_pos = t, this.bb = i, this;
  }
  static getRootAsAxis(t, i) {
    return (i || new Ds()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsAxis(t, i) {
    return t.setPosition(t.position() + 4), (i || new Ds()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  wires(t, i) {
    const n = this.bb.__offset(this.bb_pos, 4);
    return n ? (i || new Fie()).__init(this.bb.__vector(this.bb_pos + n) + 24 * t, this.bb) : null;
  }
  wiresLength() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  order(t) {
    const i = this.bb.__offset(this.bb_pos, 6);
    return i ? this.bb.readUint32(this.bb.__vector(this.bb_pos + i) + 4 * t) : 0;
  }
  orderLength() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  orderArray() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + t), this.bb.__vector_len(this.bb_pos + t)) : null;
  }
  parts(t) {
    const i = this.bb.__offset(this.bb_pos, 8);
    return i ? this.bb.readInt8(this.bb.__vector(this.bb_pos + i) + t) : 0;
  }
  partsLength() {
    const t = this.bb.__offset(this.bb_pos, 8);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  partsArray() {
    const t = this.bb.__offset(this.bb_pos, 8);
    return t ? new Int8Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + t), this.bb.__vector_len(this.bb_pos + t)) : null;
  }
  wireSets(t, i) {
    const n = this.bb.__offset(this.bb_pos, 10);
    return n ? (i || new k2()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + n) + 4 * t), this.bb) : null;
  }
  wireSetsLength() {
    const t = this.bb.__offset(this.bb_pos, 10);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  circleCurves(t, i) {
    const n = this.bb.__offset(this.bb_pos, 12);
    return n ? (i || new rY()).__init(this.bb.__vector(this.bb_pos + n) + 44 * t, this.bb) : null;
  }
  circleCurvesLength() {
    const t = this.bb.__offset(this.bb_pos, 12);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  static startAxis(t) {
    t.startObject(5);
  }
  static addWires(t, i) {
    t.addFieldOffset(0, i, 0);
  }
  static startWiresVector(t, i) {
    t.startVector(24, i, 4);
  }
  static addOrder(t, i) {
    t.addFieldOffset(1, i, 0);
  }
  static createOrderVector(t, i) {
    t.startVector(4, i.length, 4);
    for (let n = i.length - 1; n >= 0; n--) t.addInt32(i[n]);
    return t.endVector();
  }
  static startOrderVector(t, i) {
    t.startVector(4, i, 4);
  }
  static addParts(t, i) {
    t.addFieldOffset(2, i, 0);
  }
  static createPartsVector(t, i) {
    t.startVector(1, i.length, 1);
    for (let n = i.length - 1; n >= 0; n--) t.addInt8(i[n]);
    return t.endVector();
  }
  static startPartsVector(t, i) {
    t.startVector(1, i, 1);
  }
  static addWireSets(t, i) {
    t.addFieldOffset(3, i, 0);
  }
  static createWireSetsVector(t, i) {
    t.startVector(4, i.length, 4);
    for (let n = i.length - 1; n >= 0; n--) t.addOffset(i[n]);
    return t.endVector();
  }
  static startWireSetsVector(t, i) {
    t.startVector(4, i, 4);
  }
  static addCircleCurves(t, i) {
    t.addFieldOffset(4, i, 0);
  }
  static startCircleCurvesVector(t, i) {
    t.startVector(44, i, 4);
  }
  static endAxis(t) {
    const i = t.endObject();
    return t.requiredField(i, 4), t.requiredField(i, 6), t.requiredField(i, 8), t.requiredField(i, 10), t.requiredField(i, 12), i;
  }
  static createAxis(t, i, n, s, o, r) {
    return Ds.startAxis(t), Ds.addWires(t, i), Ds.addOrder(t, n), Ds.addParts(t, s), Ds.addWireSets(t, o), Ds.addCircleCurves(t, r), Ds.endAxis(t);
  }
}
var ec = ((e) => (e[e.NONE = 0] = "NONE", e[e.WIRE = 1] = "WIRE", e[e.WIRE_SET = 2] = "WIRE_SET", e[e.CIRCLE_CURVE = 3] = "CIRCLE_CURVE", e))(ec || {});
class Gp {
  constructor() {
    De(this, "bb", null), De(this, "bb_pos", 0);
  }
  __init(t, i) {
    return this.bb_pos = t, this.bb = i, this;
  }
  static getRootAsBigShellHole(t, i) {
    return (i || new Gp()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsBigShellHole(t, i) {
    return t.setPosition(t.position() + 4), (i || new Gp()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  indices(t) {
    const i = this.bb.__offset(this.bb_pos, 4);
    return i ? this.bb.readUint32(this.bb.__vector(this.bb_pos + i) + 4 * t) : 0;
  }
  indicesLength() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  indicesArray() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + t), this.bb.__vector_len(this.bb_pos + t)) : null;
  }
  profileId() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? this.bb.readUint16(this.bb_pos + t) : 0;
  }
  mutate_profile_id(t) {
    const i = this.bb.__offset(this.bb_pos, 6);
    return i !== 0 && (this.bb.writeUint16(this.bb_pos + i, t), !0);
  }
  static startBigShellHole(t) {
    t.startObject(2);
  }
  static addIndices(t, i) {
    t.addFieldOffset(0, i, 0);
  }
  static createIndicesVector(t, i) {
    t.startVector(4, i.length, 4);
    for (let n = i.length - 1; n >= 0; n--) t.addInt32(i[n]);
    return t.endVector();
  }
  static startIndicesVector(t, i) {
    t.startVector(4, i, 4);
  }
  static addProfileId(t, i) {
    t.addFieldInt16(1, i, 0);
  }
  static endBigShellHole(t) {
    const i = t.endObject();
    return t.requiredField(i, 4), i;
  }
  static createBigShellHole(t, i, n) {
    return Gp.startBigShellHole(t), Gp.addIndices(t, i), Gp.addProfileId(t, n), Gp.endBigShellHole(t);
  }
}
class Yp {
  constructor() {
    De(this, "bb", null), De(this, "bb_pos", 0);
  }
  __init(t, i) {
    return this.bb_pos = t, this.bb = i, this;
  }
  static getRootAsBigShellProfile(t, i) {
    return (i || new Yp()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsBigShellProfile(t, i) {
    return t.setPosition(t.position() + 4), (i || new Yp()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  indices(t) {
    const i = this.bb.__offset(this.bb_pos, 4);
    return i ? this.bb.readUint32(this.bb.__vector(this.bb_pos + i) + 4 * t) : 0;
  }
  indicesLength() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  indicesArray() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + t), this.bb.__vector_len(this.bb_pos + t)) : null;
  }
  static startBigShellProfile(t) {
    t.startObject(1);
  }
  static addIndices(t, i) {
    t.addFieldOffset(0, i, 0);
  }
  static createIndicesVector(t, i) {
    t.startVector(4, i.length, 4);
    for (let n = i.length - 1; n >= 0; n--) t.addInt32(i[n]);
    return t.endVector();
  }
  static startIndicesVector(t, i) {
    t.startVector(4, i, 4);
  }
  static endBigShellProfile(t) {
    const i = t.endObject();
    return t.requiredField(i, 4), i;
  }
  static createBigShellProfile(t, i) {
    return Yp.startBigShellProfile(t), Yp.addIndices(t, i), Yp.endBigShellProfile(t);
  }
}
class BSe {
  constructor() {
    De(this, "bb", null), De(this, "bb_pos", 0);
  }
  __init(t, i) {
    return this.bb_pos = t, this.bb = i, this;
  }
  min(t) {
    return (t || new Rf()).__init(this.bb_pos, this.bb);
  }
  max(t) {
    return (t || new Rf()).__init(this.bb_pos + 12, this.bb);
  }
  static sizeOf() {
    return 24;
  }
  static createBoundingBox(t, i, n, s, o, r, l) {
    return t.prep(4, 24), t.prep(4, 12), t.writeFloat32(l), t.writeFloat32(r), t.writeFloat32(o), t.prep(4, 12), t.writeFloat32(s), t.writeFloat32(n), t.writeFloat32(i), t.offset();
  }
}
class pl {
  constructor() {
    De(this, "bb", null), De(this, "bb_pos", 0);
  }
  __init(t, i) {
    return this.bb_pos = t, this.bb = i, this;
  }
  static getRootAsCircleExtrusion(t, i) {
    return (i || new pl()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsCircleExtrusion(t, i) {
    return t.setPosition(t.position() + 4), (i || new pl()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  radius(t) {
    const i = this.bb.__offset(this.bb_pos, 4);
    return i ? this.bb.readFloat64(this.bb.__vector(this.bb_pos + i) + 8 * t) : 0;
  }
  radiusLength() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  radiusArray() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? new Float64Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + t), this.bb.__vector_len(this.bb_pos + t)) : null;
  }
  axes(t, i) {
    const n = this.bb.__offset(this.bb_pos, 6);
    return n ? (i || new Ds()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + n) + 4 * t), this.bb) : null;
  }
  axesLength() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  static startCircleExtrusion(t) {
    t.startObject(2);
  }
  static addRadius(t, i) {
    t.addFieldOffset(0, i, 0);
  }
  static createRadiusVector(t, i) {
    t.startVector(8, i.length, 8);
    for (let n = i.length - 1; n >= 0; n--) t.addFloat64(i[n]);
    return t.endVector();
  }
  static startRadiusVector(t, i) {
    t.startVector(8, i, 8);
  }
  static addAxes(t, i) {
    t.addFieldOffset(1, i, 0);
  }
  static createAxesVector(t, i) {
    t.startVector(4, i.length, 4);
    for (let n = i.length - 1; n >= 0; n--) t.addOffset(i[n]);
    return t.endVector();
  }
  static startAxesVector(t, i) {
    t.startVector(4, i, 4);
  }
  static endCircleExtrusion(t) {
    const i = t.endObject();
    return t.requiredField(i, 4), t.requiredField(i, 6), i;
  }
  static createCircleExtrusion(t, i, n) {
    return pl.startCircleExtrusion(t), pl.addRadius(t, i), pl.addAxes(t, n), pl.endCircleExtrusion(t);
  }
}
class FSe {
  constructor() {
    De(this, "bb", null), De(this, "bb_pos", 0);
  }
  __init(t, i) {
    return this.bb_pos = t, this.bb = i, this;
  }
  x() {
    return this.bb.readFloat64(this.bb_pos);
  }
  mutate_x(t) {
    return this.bb.writeFloat64(this.bb_pos + 0, t), !0;
  }
  y() {
    return this.bb.readFloat64(this.bb_pos + 8);
  }
  mutate_y(t) {
    return this.bb.writeFloat64(this.bb_pos + 8, t), !0;
  }
  z() {
    return this.bb.readFloat64(this.bb_pos + 16);
  }
  mutate_z(t) {
    return this.bb.writeFloat64(this.bb_pos + 16, t), !0;
  }
  static sizeOf() {
    return 24;
  }
  static createDoubleVector(t, i, n, s) {
    return t.prep(8, 24), t.writeFloat64(s), t.writeFloat64(n), t.writeFloat64(i), t.offset();
  }
}
class Iz {
  constructor() {
    De(this, "bb", null), De(this, "bb_pos", 0);
  }
  __init(t, i) {
    return this.bb_pos = t, this.bb = i, this;
  }
  r() {
    return this.bb.readUint8(this.bb_pos);
  }
  mutate_r(t) {
    return this.bb.writeUint8(this.bb_pos + 0, t), !0;
  }
  g() {
    return this.bb.readUint8(this.bb_pos + 1);
  }
  mutate_g(t) {
    return this.bb.writeUint8(this.bb_pos + 1, t), !0;
  }
  b() {
    return this.bb.readUint8(this.bb_pos + 2);
  }
  mutate_b(t) {
    return this.bb.writeUint8(this.bb_pos + 2, t), !0;
  }
  a() {
    return this.bb.readUint8(this.bb_pos + 3);
  }
  mutate_a(t) {
    return this.bb.writeUint8(this.bb_pos + 3, t), !0;
  }
  renderedFaces() {
    return this.bb.readInt8(this.bb_pos + 4);
  }
  mutate_rendered_faces(t) {
    return this.bb.writeInt8(this.bb_pos + 4, t), !0;
  }
  stroke() {
    return this.bb.readInt8(this.bb_pos + 5);
  }
  mutate_stroke(t) {
    return this.bb.writeInt8(this.bb_pos + 5, t), !0;
  }
  static sizeOf() {
    return 6;
  }
  static createMaterial(t, i, n, s, o, r, l) {
    return t.prep(1, 6), t.writeInt8(l), t.writeInt8(r), t.writeInt8(o), t.writeInt8(s), t.writeInt8(n), t.writeInt8(i), t.offset();
  }
}
class iN {
  constructor() {
    De(this, "bb", null), De(this, "bb_pos", 0);
  }
  __init(t, i) {
    return this.bb_pos = t, this.bb = i, this;
  }
  id() {
    return this.bb.readUint32(this.bb_pos);
  }
  mutate_id(t) {
    return this.bb.writeUint32(this.bb_pos + 0, t), !0;
  }
  bbox(t) {
    return (t || new BSe()).__init(this.bb_pos + 4, this.bb);
  }
  representationClass() {
    return this.bb.readInt8(this.bb_pos + 28);
  }
  mutate_representation_class(t) {
    return this.bb.writeInt8(this.bb_pos + 28, t), !0;
  }
  static sizeOf() {
    return 32;
  }
  static createRepresentation(t, i, n, s, o, r, l, c, h) {
    return t.prep(4, 32), t.pad(3), t.writeInt8(h), t.prep(4, 24), t.prep(4, 12), t.writeFloat32(c), t.writeFloat32(l), t.writeFloat32(r), t.prep(4, 12), t.writeFloat32(o), t.writeFloat32(s), t.writeFloat32(n), t.writeInt32(i), t.offset();
  }
}
class lY {
  constructor() {
    De(this, "bb", null), De(this, "bb_pos", 0);
  }
  __init(t, i) {
    return this.bb_pos = t, this.bb = i, this;
  }
  item() {
    return this.bb.readUint32(this.bb_pos);
  }
  mutate_item(t) {
    return this.bb.writeUint32(this.bb_pos + 0, t), !0;
  }
  material() {
    return this.bb.readUint32(this.bb_pos + 4);
  }
  mutate_material(t) {
    return this.bb.writeUint32(this.bb_pos + 4, t), !0;
  }
  representation() {
    return this.bb.readUint32(this.bb_pos + 8);
  }
  mutate_representation(t) {
    return this.bb.writeUint32(this.bb_pos + 8, t), !0;
  }
  localTransform() {
    return this.bb.readUint32(this.bb_pos + 12);
  }
  mutate_local_transform(t) {
    return this.bb.writeUint32(this.bb_pos + 12, t), !0;
  }
  static sizeOf() {
    return 16;
  }
  static createSample(t, i, n, s, o) {
    return t.prep(4, 16), t.writeInt32(o), t.writeInt32(s), t.writeInt32(n), t.writeInt32(i), t.offset();
  }
}
class kp {
  constructor() {
    De(this, "bb", null), De(this, "bb_pos", 0);
  }
  __init(t, i) {
    return this.bb_pos = t, this.bb = i, this;
  }
  static getRootAsShellHole(t, i) {
    return (i || new kp()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsShellHole(t, i) {
    return t.setPosition(t.position() + 4), (i || new kp()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  indices(t) {
    const i = this.bb.__offset(this.bb_pos, 4);
    return i ? this.bb.readUint16(this.bb.__vector(this.bb_pos + i) + 2 * t) : 0;
  }
  indicesLength() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  indicesArray() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? new Uint16Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + t), this.bb.__vector_len(this.bb_pos + t)) : null;
  }
  profileId() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? this.bb.readUint16(this.bb_pos + t) : 0;
  }
  mutate_profile_id(t) {
    const i = this.bb.__offset(this.bb_pos, 6);
    return i !== 0 && (this.bb.writeUint16(this.bb_pos + i, t), !0);
  }
  static startShellHole(t) {
    t.startObject(2);
  }
  static addIndices(t, i) {
    t.addFieldOffset(0, i, 0);
  }
  static createIndicesVector(t, i) {
    t.startVector(2, i.length, 2);
    for (let n = i.length - 1; n >= 0; n--) t.addInt16(i[n]);
    return t.endVector();
  }
  static startIndicesVector(t, i) {
    t.startVector(2, i, 2);
  }
  static addProfileId(t, i) {
    t.addFieldInt16(1, i, 0);
  }
  static endShellHole(t) {
    const i = t.endObject();
    return t.requiredField(i, 4), i;
  }
  static createShellHole(t, i, n) {
    return kp.startShellHole(t), kp.addIndices(t, i), kp.addProfileId(t, n), kp.endShellHole(t);
  }
}
class qp {
  constructor() {
    De(this, "bb", null), De(this, "bb_pos", 0);
  }
  __init(t, i) {
    return this.bb_pos = t, this.bb = i, this;
  }
  static getRootAsShellProfile(t, i) {
    return (i || new qp()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsShellProfile(t, i) {
    return t.setPosition(t.position() + 4), (i || new qp()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  indices(t) {
    const i = this.bb.__offset(this.bb_pos, 4);
    return i ? this.bb.readUint16(this.bb.__vector(this.bb_pos + i) + 2 * t) : 0;
  }
  indicesLength() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  indicesArray() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? new Uint16Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + t), this.bb.__vector_len(this.bb_pos + t)) : null;
  }
  static startShellProfile(t) {
    t.startObject(1);
  }
  static addIndices(t, i) {
    t.addFieldOffset(0, i, 0);
  }
  static createIndicesVector(t, i) {
    t.startVector(2, i.length, 2);
    for (let n = i.length - 1; n >= 0; n--) t.addInt16(i[n]);
    return t.endVector();
  }
  static startIndicesVector(t, i) {
    t.startVector(2, i, 2);
  }
  static endShellProfile(t) {
    const i = t.endObject();
    return t.requiredField(i, 4), i;
  }
  static createShellProfile(t, i) {
    return qp.startShellProfile(t), qp.addIndices(t, i), qp.endShellProfile(t);
  }
}
var F0 = ((e) => (e[e.NONE = 0] = "NONE", e[e.BIG = 1] = "BIG", e))(F0 || {});
class Fo {
  constructor() {
    De(this, "bb", null), De(this, "bb_pos", 0);
  }
  __init(t, i) {
    return this.bb_pos = t, this.bb = i, this;
  }
  static getRootAsShell(t, i) {
    return (i || new Fo()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsShell(t, i) {
    return t.setPosition(t.position() + 4), (i || new Fo()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  profiles(t, i) {
    const n = this.bb.__offset(this.bb_pos, 4);
    return n ? (i || new qp()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + n) + 4 * t), this.bb) : null;
  }
  profilesLength() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  holes(t, i) {
    const n = this.bb.__offset(this.bb_pos, 6);
    return n ? (i || new kp()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + n) + 4 * t), this.bb) : null;
  }
  holesLength() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  points(t, i) {
    const n = this.bb.__offset(this.bb_pos, 8);
    return n ? (i || new Rf()).__init(this.bb.__vector(this.bb_pos + n) + 12 * t, this.bb) : null;
  }
  pointsLength() {
    const t = this.bb.__offset(this.bb_pos, 8);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  bigProfiles(t, i) {
    const n = this.bb.__offset(this.bb_pos, 10);
    return n ? (i || new Yp()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + n) + 4 * t), this.bb) : null;
  }
  bigProfilesLength() {
    const t = this.bb.__offset(this.bb_pos, 10);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  bigHoles(t, i) {
    const n = this.bb.__offset(this.bb_pos, 12);
    return n ? (i || new Gp()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + n) + 4 * t), this.bb) : null;
  }
  bigHolesLength() {
    const t = this.bb.__offset(this.bb_pos, 12);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  type() {
    const t = this.bb.__offset(this.bb_pos, 14);
    return t ? this.bb.readInt8(this.bb_pos + t) : F0.NONE;
  }
  mutate_type(t) {
    const i = this.bb.__offset(this.bb_pos, 14);
    return i !== 0 && (this.bb.writeInt8(this.bb_pos + i, t), !0);
  }
  profilesFaceIds(t) {
    const i = this.bb.__offset(this.bb_pos, 16);
    return i ? this.bb.readUint16(this.bb.__vector(this.bb_pos + i) + 2 * t) : 0;
  }
  profilesFaceIdsLength() {
    const t = this.bb.__offset(this.bb_pos, 16);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  profilesFaceIdsArray() {
    const t = this.bb.__offset(this.bb_pos, 16);
    return t ? new Uint16Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + t), this.bb.__vector_len(this.bb_pos + t)) : null;
  }
  static startShell(t) {
    t.startObject(7);
  }
  static addProfiles(t, i) {
    t.addFieldOffset(0, i, 0);
  }
  static createProfilesVector(t, i) {
    t.startVector(4, i.length, 4);
    for (let n = i.length - 1; n >= 0; n--) t.addOffset(i[n]);
    return t.endVector();
  }
  static startProfilesVector(t, i) {
    t.startVector(4, i, 4);
  }
  static addHoles(t, i) {
    t.addFieldOffset(1, i, 0);
  }
  static createHolesVector(t, i) {
    t.startVector(4, i.length, 4);
    for (let n = i.length - 1; n >= 0; n--) t.addOffset(i[n]);
    return t.endVector();
  }
  static startHolesVector(t, i) {
    t.startVector(4, i, 4);
  }
  static addPoints(t, i) {
    t.addFieldOffset(2, i, 0);
  }
  static startPointsVector(t, i) {
    t.startVector(12, i, 4);
  }
  static addBigProfiles(t, i) {
    t.addFieldOffset(3, i, 0);
  }
  static createBigProfilesVector(t, i) {
    t.startVector(4, i.length, 4);
    for (let n = i.length - 1; n >= 0; n--) t.addOffset(i[n]);
    return t.endVector();
  }
  static startBigProfilesVector(t, i) {
    t.startVector(4, i, 4);
  }
  static addBigHoles(t, i) {
    t.addFieldOffset(4, i, 0);
  }
  static createBigHolesVector(t, i) {
    t.startVector(4, i.length, 4);
    for (let n = i.length - 1; n >= 0; n--) t.addOffset(i[n]);
    return t.endVector();
  }
  static startBigHolesVector(t, i) {
    t.startVector(4, i, 4);
  }
  static addType(t, i) {
    t.addFieldInt8(5, i, F0.NONE);
  }
  static addProfilesFaceIds(t, i) {
    t.addFieldOffset(6, i, 0);
  }
  static createProfilesFaceIdsVector(t, i) {
    t.startVector(2, i.length, 2);
    for (let n = i.length - 1; n >= 0; n--) t.addInt16(i[n]);
    return t.endVector();
  }
  static startProfilesFaceIdsVector(t, i) {
    t.startVector(2, i, 2);
  }
  static endShell(t) {
    const i = t.endObject();
    return t.requiredField(i, 4), t.requiredField(i, 6), t.requiredField(i, 8), t.requiredField(i, 10), t.requiredField(i, 12), t.requiredField(i, 16), i;
  }
  static createShell(t, i, n, s, o, r, l, c) {
    return Fo.startShell(t), Fo.addProfiles(t, i), Fo.addHoles(t, n), Fo.addPoints(t, s), Fo.addBigProfiles(t, o), Fo.addBigHoles(t, r), Fo.addType(t, l), Fo.addProfilesFaceIds(t, c), Fo.endShell(t);
  }
}
class M5 {
  constructor() {
    De(this, "bb", null), De(this, "bb_pos", 0);
  }
  __init(t, i) {
    return this.bb_pos = t, this.bb = i, this;
  }
  position(t) {
    return (t || new FSe()).__init(this.bb_pos, this.bb);
  }
  xDirection(t) {
    return (t || new Rf()).__init(this.bb_pos + 24, this.bb);
  }
  yDirection(t) {
    return (t || new Rf()).__init(this.bb_pos + 36, this.bb);
  }
  static sizeOf() {
    return 48;
  }
  static createTransform(t, i, n, s, o, r, l, c, h, I) {
    return t.prep(8, 48), t.prep(4, 12), t.writeFloat32(I), t.writeFloat32(h), t.writeFloat32(c), t.prep(4, 12), t.writeFloat32(l), t.writeFloat32(r), t.writeFloat32(o), t.prep(8, 24), t.writeFloat64(s), t.writeFloat64(n), t.writeFloat64(i), t.offset();
  }
}
class $i {
  constructor() {
    De(this, "bb", null), De(this, "bb_pos", 0);
  }
  __init(t, i) {
    return this.bb_pos = t, this.bb = i, this;
  }
  static getRootAsMeshes(t, i) {
    return (i || new $i()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsMeshes(t, i) {
    return t.setPosition(t.position() + 4), (i || new $i()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  coordinates(t) {
    const i = this.bb.__offset(this.bb_pos, 4);
    return i ? (t || new M5()).__init(this.bb_pos + i, this.bb) : null;
  }
  meshesItems(t) {
    const i = this.bb.__offset(this.bb_pos, 6);
    return i ? this.bb.readUint32(this.bb.__vector(this.bb_pos + i) + 4 * t) : 0;
  }
  meshesItemsLength() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  meshesItemsArray() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + t), this.bb.__vector_len(this.bb_pos + t)) : null;
  }
  samples(t, i) {
    const n = this.bb.__offset(this.bb_pos, 8);
    return n ? (i || new lY()).__init(this.bb.__vector(this.bb_pos + n) + 16 * t, this.bb) : null;
  }
  samplesLength() {
    const t = this.bb.__offset(this.bb_pos, 8);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  representations(t, i) {
    const n = this.bb.__offset(this.bb_pos, 10);
    return n ? (i || new iN()).__init(this.bb.__vector(this.bb_pos + n) + 32 * t, this.bb) : null;
  }
  representationsLength() {
    const t = this.bb.__offset(this.bb_pos, 10);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  materials(t, i) {
    const n = this.bb.__offset(this.bb_pos, 12);
    return n ? (i || new Iz()).__init(this.bb.__vector(this.bb_pos + n) + 6 * t, this.bb) : null;
  }
  materialsLength() {
    const t = this.bb.__offset(this.bb_pos, 12);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  circleExtrusions(t, i) {
    const n = this.bb.__offset(this.bb_pos, 14);
    return n ? (i || new pl()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + n) + 4 * t), this.bb) : null;
  }
  circleExtrusionsLength() {
    const t = this.bb.__offset(this.bb_pos, 14);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  shells(t, i) {
    const n = this.bb.__offset(this.bb_pos, 16);
    return n ? (i || new Fo()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + n) + 4 * t), this.bb) : null;
  }
  shellsLength() {
    const t = this.bb.__offset(this.bb_pos, 16);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  localTransforms(t, i) {
    const n = this.bb.__offset(this.bb_pos, 18);
    return n ? (i || new M5()).__init(this.bb.__vector(this.bb_pos + n) + 48 * t, this.bb) : null;
  }
  localTransformsLength() {
    const t = this.bb.__offset(this.bb_pos, 18);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  globalTransforms(t, i) {
    const n = this.bb.__offset(this.bb_pos, 20);
    return n ? (i || new M5()).__init(this.bb.__vector(this.bb_pos + n) + 48 * t, this.bb) : null;
  }
  globalTransformsLength() {
    const t = this.bb.__offset(this.bb_pos, 20);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  materialIds(t) {
    const i = this.bb.__offset(this.bb_pos, 22);
    return i ? this.bb.readUint32(this.bb.__vector(this.bb_pos + i) + 4 * t) : 0;
  }
  materialIdsLength() {
    const t = this.bb.__offset(this.bb_pos, 22);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  materialIdsArray() {
    const t = this.bb.__offset(this.bb_pos, 22);
    return t ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + t), this.bb.__vector_len(this.bb_pos + t)) : null;
  }
  representationIds(t) {
    const i = this.bb.__offset(this.bb_pos, 24);
    return i ? this.bb.readUint32(this.bb.__vector(this.bb_pos + i) + 4 * t) : 0;
  }
  representationIdsLength() {
    const t = this.bb.__offset(this.bb_pos, 24);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  representationIdsArray() {
    const t = this.bb.__offset(this.bb_pos, 24);
    return t ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + t), this.bb.__vector_len(this.bb_pos + t)) : null;
  }
  sampleIds(t) {
    const i = this.bb.__offset(this.bb_pos, 26);
    return i ? this.bb.readUint32(this.bb.__vector(this.bb_pos + i) + 4 * t) : 0;
  }
  sampleIdsLength() {
    const t = this.bb.__offset(this.bb_pos, 26);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  sampleIdsArray() {
    const t = this.bb.__offset(this.bb_pos, 26);
    return t ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + t), this.bb.__vector_len(this.bb_pos + t)) : null;
  }
  localTransformIds(t) {
    const i = this.bb.__offset(this.bb_pos, 28);
    return i ? this.bb.readUint32(this.bb.__vector(this.bb_pos + i) + 4 * t) : 0;
  }
  localTransformIdsLength() {
    const t = this.bb.__offset(this.bb_pos, 28);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  localTransformIdsArray() {
    const t = this.bb.__offset(this.bb_pos, 28);
    return t ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + t), this.bb.__vector_len(this.bb_pos + t)) : null;
  }
  globalTransformIds(t) {
    const i = this.bb.__offset(this.bb_pos, 30);
    return i ? this.bb.readUint32(this.bb.__vector(this.bb_pos + i) + 4 * t) : 0;
  }
  globalTransformIdsLength() {
    const t = this.bb.__offset(this.bb_pos, 30);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  globalTransformIdsArray() {
    const t = this.bb.__offset(this.bb_pos, 30);
    return t ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + t), this.bb.__vector_len(this.bb_pos + t)) : null;
  }
  static startMeshes(t) {
    t.startObject(14);
  }
  static addCoordinates(t, i) {
    t.addFieldStruct(0, i, 0);
  }
  static addMeshesItems(t, i) {
    t.addFieldOffset(1, i, 0);
  }
  static createMeshesItemsVector(t, i) {
    t.startVector(4, i.length, 4);
    for (let n = i.length - 1; n >= 0; n--) t.addInt32(i[n]);
    return t.endVector();
  }
  static startMeshesItemsVector(t, i) {
    t.startVector(4, i, 4);
  }
  static addSamples(t, i) {
    t.addFieldOffset(2, i, 0);
  }
  static startSamplesVector(t, i) {
    t.startVector(16, i, 4);
  }
  static addRepresentations(t, i) {
    t.addFieldOffset(3, i, 0);
  }
  static startRepresentationsVector(t, i) {
    t.startVector(32, i, 4);
  }
  static addMaterials(t, i) {
    t.addFieldOffset(4, i, 0);
  }
  static startMaterialsVector(t, i) {
    t.startVector(6, i, 1);
  }
  static addCircleExtrusions(t, i) {
    t.addFieldOffset(5, i, 0);
  }
  static createCircleExtrusionsVector(t, i) {
    t.startVector(4, i.length, 4);
    for (let n = i.length - 1; n >= 0; n--) t.addOffset(i[n]);
    return t.endVector();
  }
  static startCircleExtrusionsVector(t, i) {
    t.startVector(4, i, 4);
  }
  static addShells(t, i) {
    t.addFieldOffset(6, i, 0);
  }
  static createShellsVector(t, i) {
    t.startVector(4, i.length, 4);
    for (let n = i.length - 1; n >= 0; n--) t.addOffset(i[n]);
    return t.endVector();
  }
  static startShellsVector(t, i) {
    t.startVector(4, i, 4);
  }
  static addLocalTransforms(t, i) {
    t.addFieldOffset(7, i, 0);
  }
  static startLocalTransformsVector(t, i) {
    t.startVector(48, i, 8);
  }
  static addGlobalTransforms(t, i) {
    t.addFieldOffset(8, i, 0);
  }
  static startGlobalTransformsVector(t, i) {
    t.startVector(48, i, 8);
  }
  static addMaterialIds(t, i) {
    t.addFieldOffset(9, i, 0);
  }
  static createMaterialIdsVector(t, i) {
    t.startVector(4, i.length, 4);
    for (let n = i.length - 1; n >= 0; n--) t.addInt32(i[n]);
    return t.endVector();
  }
  static startMaterialIdsVector(t, i) {
    t.startVector(4, i, 4);
  }
  static addRepresentationIds(t, i) {
    t.addFieldOffset(10, i, 0);
  }
  static createRepresentationIdsVector(t, i) {
    t.startVector(4, i.length, 4);
    for (let n = i.length - 1; n >= 0; n--) t.addInt32(i[n]);
    return t.endVector();
  }
  static startRepresentationIdsVector(t, i) {
    t.startVector(4, i, 4);
  }
  static addSampleIds(t, i) {
    t.addFieldOffset(11, i, 0);
  }
  static createSampleIdsVector(t, i) {
    t.startVector(4, i.length, 4);
    for (let n = i.length - 1; n >= 0; n--) t.addInt32(i[n]);
    return t.endVector();
  }
  static startSampleIdsVector(t, i) {
    t.startVector(4, i, 4);
  }
  static addLocalTransformIds(t, i) {
    t.addFieldOffset(12, i, 0);
  }
  static createLocalTransformIdsVector(t, i) {
    t.startVector(4, i.length, 4);
    for (let n = i.length - 1; n >= 0; n--) t.addInt32(i[n]);
    return t.endVector();
  }
  static startLocalTransformIdsVector(t, i) {
    t.startVector(4, i, 4);
  }
  static addGlobalTransformIds(t, i) {
    t.addFieldOffset(13, i, 0);
  }
  static createGlobalTransformIdsVector(t, i) {
    t.startVector(4, i.length, 4);
    for (let n = i.length - 1; n >= 0; n--) t.addInt32(i[n]);
    return t.endVector();
  }
  static startGlobalTransformIdsVector(t, i) {
    t.startVector(4, i, 4);
  }
  static endMeshes(t) {
    const i = t.endObject();
    return t.requiredField(i, 4), t.requiredField(i, 6), t.requiredField(i, 8), t.requiredField(i, 10), t.requiredField(i, 12), t.requiredField(i, 14), t.requiredField(i, 16), t.requiredField(i, 18), t.requiredField(i, 20), i;
  }
  static createMeshes(t, i, n, s, o, r, l, c, h, I, p, y, m, A, C) {
    return $i.startMeshes(t), $i.addCoordinates(t, i), $i.addMeshesItems(t, n), $i.addSamples(t, s), $i.addRepresentations(t, o), $i.addMaterials(t, r), $i.addCircleExtrusions(t, l), $i.addShells(t, c), $i.addLocalTransforms(t, h), $i.addGlobalTransforms(t, I), $i.addMaterialIds(t, p), $i.addRepresentationIds(t, y), $i.addSampleIds(t, m), $i.addLocalTransformIds(t, A), $i.addGlobalTransformIds(t, C), $i.endMeshes(t);
  }
}
class Jv {
  constructor() {
    De(this, "bb", null), De(this, "bb_pos", 0);
  }
  __init(t, i) {
    return this.bb_pos = t, this.bb = i, this;
  }
  static getRootAsRelation(t, i) {
    return (i || new Jv()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsRelation(t, i) {
    return t.setPosition(t.position() + 4), (i || new Jv()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  data(t, i) {
    const n = this.bb.__offset(this.bb_pos, 4);
    return n ? this.bb.__string(this.bb.__vector(this.bb_pos + n) + 4 * t, i) : null;
  }
  dataLength() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  static startRelation(t) {
    t.startObject(1);
  }
  static addData(t, i) {
    t.addFieldOffset(0, i, 0);
  }
  static createDataVector(t, i) {
    t.startVector(4, i.length, 4);
    for (let n = i.length - 1; n >= 0; n--) t.addOffset(i[n]);
    return t.endVector();
  }
  static startDataVector(t, i) {
    t.startVector(4, i, 4);
  }
  static endRelation(t) {
    const i = t.endObject();
    return t.requiredField(i, 4), i;
  }
  static createRelation(t, i) {
    return Jv.startRelation(t), Jv.addData(t, i), Jv.endRelation(t);
  }
}
class lo {
  constructor() {
    De(this, "bb", null), De(this, "bb_pos", 0);
  }
  __init(t, i) {
    return this.bb_pos = t, this.bb = i, this;
  }
  static getRootAsSpatialStructure(t, i) {
    return (i || new lo()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsSpatialStructure(t, i) {
    return t.setPosition(t.position() + 4), (i || new lo()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  localId() {
    const t = this.bb.__offset(this.bb_pos, 4);
    return t ? this.bb.readUint32(this.bb_pos + t) : null;
  }
  mutate_local_id(t) {
    const i = this.bb.__offset(this.bb_pos, 4);
    return i !== 0 && (this.bb.writeUint32(this.bb_pos + i, t), !0);
  }
  category(t) {
    const i = this.bb.__offset(this.bb_pos, 6);
    return i ? this.bb.__string(this.bb_pos + i, t) : null;
  }
  children(t, i) {
    const n = this.bb.__offset(this.bb_pos, 8);
    return n ? (i || new lo()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + n) + 4 * t), this.bb) : null;
  }
  childrenLength() {
    const t = this.bb.__offset(this.bb_pos, 8);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  static startSpatialStructure(t) {
    t.startObject(3);
  }
  static addLocalId(t, i) {
    t.addFieldInt32(0, i, null);
  }
  static addCategory(t, i) {
    t.addFieldOffset(1, i, 0);
  }
  static addChildren(t, i) {
    t.addFieldOffset(2, i, 0);
  }
  static createChildrenVector(t, i) {
    t.startVector(4, i.length, 4);
    for (let n = i.length - 1; n >= 0; n--) t.addOffset(i[n]);
    return t.endVector();
  }
  static startChildrenVector(t, i) {
    t.startVector(4, i, 4);
  }
  static endSpatialStructure(t) {
    return t.endObject();
  }
  static createSpatialStructure(t, i, n, s) {
    return lo.startSpatialStructure(t), i !== null && lo.addLocalId(t, i), lo.addCategory(t, n), lo.addChildren(t, s), lo.endSpatialStructure(t);
  }
}
class Cn {
  constructor() {
    De(this, "bb", null), De(this, "bb_pos", 0);
  }
  __init(t, i) {
    return this.bb_pos = t, this.bb = i, this;
  }
  static getRootAsModel(t, i) {
    return (i || new Cn()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static getSizePrefixedRootAsModel(t, i) {
    return t.setPosition(t.position() + 4), (i || new Cn()).__init(t.readInt32(t.position()) + t.position(), t);
  }
  static bufferHasIdentifier(t) {
    return t.__has_identifier("0001");
  }
  metadata(t) {
    const i = this.bb.__offset(this.bb_pos, 4);
    return i ? this.bb.__string(this.bb_pos + i, t) : null;
  }
  guids(t, i) {
    const n = this.bb.__offset(this.bb_pos, 6);
    return n ? this.bb.__string(this.bb.__vector(this.bb_pos + n) + 4 * t, i) : null;
  }
  guidsLength() {
    const t = this.bb.__offset(this.bb_pos, 6);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  guidsItems(t) {
    const i = this.bb.__offset(this.bb_pos, 8);
    return i ? this.bb.readUint32(this.bb.__vector(this.bb_pos + i) + 4 * t) : 0;
  }
  guidsItemsLength() {
    const t = this.bb.__offset(this.bb_pos, 8);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  guidsItemsArray() {
    const t = this.bb.__offset(this.bb_pos, 8);
    return t ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + t), this.bb.__vector_len(this.bb_pos + t)) : null;
  }
  maxLocalId() {
    const t = this.bb.__offset(this.bb_pos, 10);
    return t ? this.bb.readUint32(this.bb_pos + t) : 0;
  }
  mutate_max_local_id(t) {
    const i = this.bb.__offset(this.bb_pos, 10);
    return i !== 0 && (this.bb.writeUint32(this.bb_pos + i, t), !0);
  }
  localIds(t) {
    const i = this.bb.__offset(this.bb_pos, 12);
    return i ? this.bb.readUint32(this.bb.__vector(this.bb_pos + i) + 4 * t) : 0;
  }
  localIdsLength() {
    const t = this.bb.__offset(this.bb_pos, 12);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  localIdsArray() {
    const t = this.bb.__offset(this.bb_pos, 12);
    return t ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + t), this.bb.__vector_len(this.bb_pos + t)) : null;
  }
  categories(t, i) {
    const n = this.bb.__offset(this.bb_pos, 14);
    return n ? this.bb.__string(this.bb.__vector(this.bb_pos + n) + 4 * t, i) : null;
  }
  categoriesLength() {
    const t = this.bb.__offset(this.bb_pos, 14);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  meshes(t) {
    const i = this.bb.__offset(this.bb_pos, 16);
    return i ? (t || new $i()).__init(this.bb.__indirect(this.bb_pos + i), this.bb) : null;
  }
  attributes(t, i) {
    const n = this.bb.__offset(this.bb_pos, 18);
    return n ? (i || new Jy()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + n) + 4 * t), this.bb) : null;
  }
  attributesLength() {
    const t = this.bb.__offset(this.bb_pos, 18);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  relations(t, i) {
    const n = this.bb.__offset(this.bb_pos, 20);
    return n ? (i || new Jv()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + n) + 4 * t), this.bb) : null;
  }
  relationsLength() {
    const t = this.bb.__offset(this.bb_pos, 20);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  relationsItems(t) {
    const i = this.bb.__offset(this.bb_pos, 22);
    return i ? this.bb.readInt32(this.bb.__vector(this.bb_pos + i) + 4 * t) : 0;
  }
  relationsItemsLength() {
    const t = this.bb.__offset(this.bb_pos, 22);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  relationsItemsArray() {
    const t = this.bb.__offset(this.bb_pos, 22);
    return t ? new Int32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + t), this.bb.__vector_len(this.bb_pos + t)) : null;
  }
  guid(t) {
    const i = this.bb.__offset(this.bb_pos, 24);
    return i ? this.bb.__string(this.bb_pos + i, t) : null;
  }
  spatialStructure(t) {
    const i = this.bb.__offset(this.bb_pos, 26);
    return i ? (t || new lo()).__init(this.bb.__indirect(this.bb_pos + i), this.bb) : null;
  }
  uniqueAttributes(t, i) {
    const n = this.bb.__offset(this.bb_pos, 28);
    return n ? this.bb.__string(this.bb.__vector(this.bb_pos + n) + 4 * t, i) : null;
  }
  uniqueAttributesLength() {
    const t = this.bb.__offset(this.bb_pos, 28);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  relationNames(t, i) {
    const n = this.bb.__offset(this.bb_pos, 30);
    return n ? this.bb.__string(this.bb.__vector(this.bb_pos + n) + 4 * t, i) : null;
  }
  relationNamesLength() {
    const t = this.bb.__offset(this.bb_pos, 30);
    return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
  }
  static startModel(t) {
    t.startObject(14);
  }
  static addMetadata(t, i) {
    t.addFieldOffset(0, i, 0);
  }
  static addGuids(t, i) {
    t.addFieldOffset(1, i, 0);
  }
  static createGuidsVector(t, i) {
    t.startVector(4, i.length, 4);
    for (let n = i.length - 1; n >= 0; n--) t.addOffset(i[n]);
    return t.endVector();
  }
  static startGuidsVector(t, i) {
    t.startVector(4, i, 4);
  }
  static addGuidsItems(t, i) {
    t.addFieldOffset(2, i, 0);
  }
  static createGuidsItemsVector(t, i) {
    t.startVector(4, i.length, 4);
    for (let n = i.length - 1; n >= 0; n--) t.addInt32(i[n]);
    return t.endVector();
  }
  static startGuidsItemsVector(t, i) {
    t.startVector(4, i, 4);
  }
  static addMaxLocalId(t, i) {
    t.addFieldInt32(3, i, 0);
  }
  static addLocalIds(t, i) {
    t.addFieldOffset(4, i, 0);
  }
  static createLocalIdsVector(t, i) {
    t.startVector(4, i.length, 4);
    for (let n = i.length - 1; n >= 0; n--) t.addInt32(i[n]);
    return t.endVector();
  }
  static startLocalIdsVector(t, i) {
    t.startVector(4, i, 4);
  }
  static addCategories(t, i) {
    t.addFieldOffset(5, i, 0);
  }
  static createCategoriesVector(t, i) {
    t.startVector(4, i.length, 4);
    for (let n = i.length - 1; n >= 0; n--) t.addOffset(i[n]);
    return t.endVector();
  }
  static startCategoriesVector(t, i) {
    t.startVector(4, i, 4);
  }
  static addMeshes(t, i) {
    t.addFieldOffset(6, i, 0);
  }
  static addAttributes(t, i) {
    t.addFieldOffset(7, i, 0);
  }
  static createAttributesVector(t, i) {
    t.startVector(4, i.length, 4);
    for (let n = i.length - 1; n >= 0; n--) t.addOffset(i[n]);
    return t.endVector();
  }
  static startAttributesVector(t, i) {
    t.startVector(4, i, 4);
  }
  static addRelations(t, i) {
    t.addFieldOffset(8, i, 0);
  }
  static createRelationsVector(t, i) {
    t.startVector(4, i.length, 4);
    for (let n = i.length - 1; n >= 0; n--) t.addOffset(i[n]);
    return t.endVector();
  }
  static startRelationsVector(t, i) {
    t.startVector(4, i, 4);
  }
  static addRelationsItems(t, i) {
    t.addFieldOffset(9, i, 0);
  }
  static createRelationsItemsVector(t, i) {
    t.startVector(4, i.length, 4);
    for (let n = i.length - 1; n >= 0; n--) t.addInt32(i[n]);
    return t.endVector();
  }
  static startRelationsItemsVector(t, i) {
    t.startVector(4, i, 4);
  }
  static addGuid(t, i) {
    t.addFieldOffset(10, i, 0);
  }
  static addSpatialStructure(t, i) {
    t.addFieldOffset(11, i, 0);
  }
  static addUniqueAttributes(t, i) {
    t.addFieldOffset(12, i, 0);
  }
  static createUniqueAttributesVector(t, i) {
    t.startVector(4, i.length, 4);
    for (let n = i.length - 1; n >= 0; n--) t.addOffset(i[n]);
    return t.endVector();
  }
  static startUniqueAttributesVector(t, i) {
    t.startVector(4, i, 4);
  }
  static addRelationNames(t, i) {
    t.addFieldOffset(13, i, 0);
  }
  static createRelationNamesVector(t, i) {
    t.startVector(4, i.length, 4);
    for (let n = i.length - 1; n >= 0; n--) t.addOffset(i[n]);
    return t.endVector();
  }
  static startRelationNamesVector(t, i) {
    t.startVector(4, i, 4);
  }
  static endModel(t) {
    const i = t.endObject();
    return t.requiredField(i, 6), t.requiredField(i, 8), t.requiredField(i, 12), t.requiredField(i, 14), t.requiredField(i, 16), t.requiredField(i, 24), i;
  }
  static finishModelBuffer(t, i) {
    t.finish(i, "0001");
  }
  static finishSizePrefixedModelBuffer(t, i) {
    t.finish(i, "0001", !0);
  }
}
var Dme = ((e) => (e[e.ONE = 0] = "ONE", e[e.TWO = 1] = "TWO", e))(Dme || {}), Mr = ((e) => (e[e.NONE = 0] = "NONE", e[e.SHELL = 1] = "SHELL", e[e.CIRCLE_EXTRUSION = 2] = "CIRCLE_EXTRUSION", e))(Mr || {}), XWe = ((e) => (e[e.DEFAULT = 0] = "DEFAULT", e))(XWe || {}), gn = ((e) => (e[e.CREATE_MATERIAL = 0] = "CREATE_MATERIAL", e[e.CREATE_REPRESENTATION = 1] = "CREATE_REPRESENTATION", e[e.CREATE_SAMPLE = 2] = "CREATE_SAMPLE", e[e.CREATE_GLOBAL_TRANSFORM = 3] = "CREATE_GLOBAL_TRANSFORM", e[e.CREATE_LOCAL_TRANSFORM = 4] = "CREATE_LOCAL_TRANSFORM", e[e.CREATE_ITEM = 5] = "CREATE_ITEM", e[e.CREATE_RELATION = 6] = "CREATE_RELATION", e[e.UPDATE_MATERIAL = 7] = "UPDATE_MATERIAL", e[e.UPDATE_REPRESENTATION = 8] = "UPDATE_REPRESENTATION", e[e.UPDATE_SAMPLE = 9] = "UPDATE_SAMPLE", e[e.UPDATE_GLOBAL_TRANSFORM = 10] = "UPDATE_GLOBAL_TRANSFORM", e[e.UPDATE_LOCAL_TRANSFORM = 11] = "UPDATE_LOCAL_TRANSFORM", e[e.UPDATE_ITEM = 12] = "UPDATE_ITEM", e[e.UPDATE_MAX_LOCAL_ID = 13] = "UPDATE_MAX_LOCAL_ID", e[e.UPDATE_RELATION = 14] = "UPDATE_RELATION", e[e.UPDATE_METADATA = 15] = "UPDATE_METADATA", e[e.UPDATE_SPATIAL_STRUCTURE = 16] = "UPDATE_SPATIAL_STRUCTURE", e[e.DELETE_MATERIAL = 17] = "DELETE_MATERIAL", e[e.DELETE_REPRESENTATION = 18] = "DELETE_REPRESENTATION", e[e.DELETE_SAMPLE = 19] = "DELETE_SAMPLE", e[e.DELETE_GLOBAL_TRANSFORM = 20] = "DELETE_GLOBAL_TRANSFORM", e[e.DELETE_LOCAL_TRANSFORM = 21] = "DELETE_LOCAL_TRANSFORM", e[e.DELETE_ITEM = 22] = "DELETE_ITEM", e[e.DELETE_RELATION = 23] = "DELETE_RELATION", e))(gn || {});
function uJ(e, t) {
  const i = e.position, n = e.xDirection, s = e.yDirection;
  return M5.createTransform(t, i[0], i[1], i[2], n[0], n[1], n[2], s[0], s[1], s[2]);
}
function cce(e, t) {
  const i = t.position(), n = t.xDirection(), s = t.yDirection();
  return M5.createTransform(e, i.x(), i.y(), i.z(), n.x(), n.y(), n.z(), s.x(), s.y(), s.z());
}
function eYe(e, t) {
  return Rf.createFloatVector(e, t.x(), t.y(), t.z());
}
function hce(e, t) {
  const i = t.type, n = [], s = [], o = [], r = [], l = t.points.length;
  Fo.startPointsVector(e, l);
  for (let A = 0; A < l; A++) {
    const C = l - 1 - A, O = t.points[C];
    Rf.createFloatVector(e, O[0], O[1], O[2]);
  }
  const c = e.endVector();
  for (const [, A] of t.profiles) {
    const C = qp.createIndicesVector(e, A), O = qp.createShellProfile(e, C);
    n.push(O);
  }
  const h = Fo.createProfilesVector(e, n);
  for (const [A, C] of t.holes) for (const O of C) {
    const R = kp.createIndicesVector(e, O), F = kp.createShellHole(e, R, A);
    s.push(F);
  }
  const I = Fo.createHolesVector(e, s);
  for (const [, A] of t.bigProfiles) {
    const C = Yp.createIndicesVector(e, A), O = Yp.createBigShellProfile(e, C);
    o.push(O);
  }
  const p = Fo.createBigProfilesVector(e, o);
  for (const [A, C] of t.bigHoles) for (const O of C) {
    const R = Gp.createIndicesVector(e, O), F = Gp.createBigShellHole(e, R, A);
    r.push(F);
  }
  const y = Fo.createBigHolesVector(e, r), m = Fo.createProfilesFaceIdsVector(e, t.profilesFaceIds);
  return Fo.createShell(e, h, I, c, p, y, i, m);
}
function tYe(e, t) {
  const i = t.type(), n = [], s = [], o = [], r = [], l = t.pointsLength();
  Fo.startPointsVector(e, l);
  for (let F = 0; F < l; F++) {
    const L = l - 1 - F;
    eYe(e, t.points(L));
  }
  const c = e.endVector(), h = t.profilesLength();
  for (let F = 0; F < h; F++) {
    const L = t.profiles(F).indicesArray(), P = qp.createIndicesVector(e, L), z = qp.createShellProfile(e, P);
    n.push(z);
  }
  const I = Fo.createProfilesVector(e, n), p = t.holesLength();
  for (let F = 0; F < p; F++) {
    const L = t.holes(F), P = L.indicesArray(), z = L.profileId(), W = kp.createIndicesVector(e, P), re = kp.createShellHole(e, W, z);
    s.push(re);
  }
  const y = Fo.createHolesVector(e, s), m = t.bigProfilesLength();
  for (let F = 0; F < m; F++) {
    const L = t.bigProfiles(F).indicesArray(), P = Yp.createIndicesVector(e, L), z = Yp.createBigShellProfile(e, P);
    o.push(z);
  }
  const A = Fo.createBigProfilesVector(e, o), C = t.bigHolesLength();
  for (let F = 0; F < C; F++) {
    const L = t.bigHoles(F), P = L.indicesArray(), z = L.profileId(), W = Gp.createIndicesVector(e, P), re = Gp.createBigShellHole(e, W, z);
    r.push(re);
  }
  const O = Fo.createBigHolesVector(e, r), R = Fo.createProfilesFaceIdsVector(e, t.profilesFaceIdsArray() || []);
  return Fo.createShell(e, I, y, c, A, O, i, R);
}
function iYe(e, t) {
  const i = t.radiusArray(), n = pl.createRadiusVector(e, i), s = t.axesLength(), o = [];
  for (let l = 0; l < s; l++) {
    const c = t.axes(l), h = c.circleCurvesLength();
    Ds.startCircleCurvesVector(e, h);
    for (let L = 0; L < h; L++) {
      const P = h - 1 - L, z = c.circleCurves(P), W = z.position(), re = z.radius(), ce = z.aperture(), te = z.xDirection(), ee = z.yDirection(), Ne = W.x(), Ae = W.y(), Oe = W.z(), pe = te.x(), je = te.y(), Ve = te.z(), $e = ee.x(), vt = ee.y(), Rt = ee.z();
      rY.createCircleCurve(e, ce, Ne, Ae, Oe, re, pe, je, Ve, $e, vt, Rt);
    }
    const I = e.endVector(), p = c.wiresLength();
    Ds.startWiresVector(e, p);
    for (let L = 0; L < p; L++) {
      const P = p - 1 - L, z = c.wires(P), W = z.p1(), re = z.p2();
      Fie.createWire(e, W.x(), W.y(), W.z(), re.x(), re.y(), re.z());
    }
    const y = e.endVector();
    Ds.startWireSetsVector(e, 0);
    const m = e.endVector(), A = c.orderArray(), C = Ds.createOrderVector(e, A), O = Array.from(c.partsArray()), R = Ds.createPartsVector(e, O);
    Ds.startAxis(e), Ds.addCircleCurves(e, I), Ds.addOrder(e, C), Ds.addWires(e, y), Ds.addWireSets(e, m), Ds.addParts(e, R);
    const F = Ds.endAxis(e);
    o.push(F);
  }
  const r = pl.createAxesVector(e, o);
  return pl.startCircleExtrusion(e), pl.addAxes(e, r), pl.addRadius(e, n), pl.endCircleExtrusion(e);
}
function fce(e, t) {
  const i = t.radius, n = pl.createRadiusVector(e, i), s = [];
  for (const r of t.axes) {
    const l = r.circleCurves.length;
    Ds.startCircleCurvesVector(e, l);
    for (const O of r.circleCurves) rY.createCircleCurve(e, O.aperture, O.position[0], O.position[1], O.position[2], O.radius, O.xDirection[0], O.xDirection[1], O.xDirection[2], O.yDirection[0], O.yDirection[1], O.yDirection[2]);
    const c = e.endVector(), h = r.wires.length;
    Ds.startWiresVector(e, h);
    for (const O of r.wires) Fie.createWire(e, O[0], O[1], O[2], O[3], O[4], O[5]);
    const I = e.endVector(), p = [];
    for (const O of r.wireSets) {
      k2.startPsVector(e, O.length / 3);
      for (let L = 0; L < O.length - 2; L += 3) Rf.createFloatVector(e, O[L], O[L + 1], O[L + 2]);
      const R = e.endVector();
      k2.startWireSet(e), k2.addPs(e, R);
      const F = k2.endWireSet(e);
      p.push(F);
    }
    const y = Ds.createWireSetsVector(e, p), m = Ds.createOrderVector(e, r.order), A = Ds.createPartsVector(e, r.parts);
    Ds.startAxis(e), Ds.addCircleCurves(e, c), Ds.addOrder(e, m), Ds.addWires(e, I), Ds.addWireSets(e, y), Ds.addParts(e, A);
    const C = Ds.endAxis(e);
    s.push(C);
  }
  const o = pl.createAxesVector(e, s);
  return pl.startCircleExtrusion(e), pl.addAxes(e, o), pl.addRadius(e, n), pl.endCircleExtrusion(e);
}
function HSe(e, t) {
  if (!t) return null;
  const i = t.childrenLength(), n = [];
  for (let l = 0; l < i; l++) {
    const c = HSe(e, t.children(l));
    c !== null && n.push(c);
  }
  const s = lo.createChildrenVector(e, n), o = t.localId(), r = t.category();
  if (o !== null) return lo.startSpatialStructure(e), lo.addLocalId(e, o), lo.addChildren(e, s), lo.endSpatialStructure(e);
  if (r !== null) {
    const l = e.createSharedString(r);
    return lo.startSpatialStructure(e), lo.addCategory(e, l), lo.addChildren(e, s), lo.endSpatialStructure(e);
  }
  throw new Error("Spatial structure must have a local id or a category");
}
function GSe(e, t) {
  const i = t.children ?? [], n = i ? i.length : 0, s = [];
  for (let c = 0; c < n; c++) {
    const h = GSe(e, i[c]);
    h !== null && s.push(h);
  }
  const o = lo.createChildrenVector(e, s), r = t.localId, l = t.category;
  if (r !== null) return lo.startSpatialStructure(e), lo.addLocalId(e, r), lo.addChildren(e, o), lo.endSpatialStructure(e);
  if (l !== null) {
    const c = e.createSharedString(l);
    return lo.startSpatialStructure(e), lo.addCategory(e, c), lo.addChildren(e, o), lo.endSpatialStructure(e);
  }
  throw new Error("Spatial structure must have a local id or a category");
}
function Ice(e, t, i, n, s, o) {
  if (!t.has(i)) throw new Error("Invalid sample: item id not found");
  if (!t.has(n)) throw new Error("Invalid sample: mat id not found");
  if (!t.has(s)) throw new Error("Invalid sample: repr id not found");
  if (!t.has(o)) throw new Error("Invalid sample: lt id not found");
  const r = t.get(i), l = t.get(n), c = t.get(s), h = t.get(o);
  lY.createSample(e, r, l, c, h);
}
function vwe(e) {
  const t = new Uie(1024);
  $i.startGlobalTransformsVector(t, 0);
  const i = t.endVector(), n = $i.createShellsVector(t, []);
  $i.startRepresentationsVector(t, 0);
  const s = t.endVector();
  $i.startSamplesVector(t, 0);
  const o = t.endVector();
  $i.startLocalTransformsVector(t, 0);
  const r = t.endVector();
  $i.startMaterialsVector(t, 0);
  const l = t.endVector(), c = $i.createCircleExtrusionsVector(t, []), h = $i.createMeshesItemsVector(t, []), I = $i.createRepresentationIdsVector(t, []), p = $i.createSampleIdsVector(t, []), y = $i.createMaterialIdsVector(t, []), m = $i.createLocalTransformIdsVector(t, []), A = $i.createGlobalTransformIdsVector(t, []);
  $i.startMeshes(t);
  const C = uJ({ position: [0, 0, 0], xDirection: [1, 0, 0], yDirection: [0, 1, 0] }, t);
  $i.addCoordinates(t, C), $i.addGlobalTransforms(t, i), $i.addShells(t, n), $i.addRepresentations(t, s), $i.addSamples(t, o), $i.addLocalTransforms(t, r), $i.addMaterials(t, l), $i.addCircleExtrusions(t, c), $i.addMeshesItems(t, h), $i.addRepresentationIds(t, I), $i.addSampleIds(t, p), $i.addMaterialIds(t, y), $i.addLocalTransformIds(t, m), $i.addGlobalTransformIds(t, A);
  const O = $i.endMeshes(t), R = t.createString("{}"), F = Cn.createAttributesVector(t, []), L = Cn.createUniqueAttributesVector(t, []), P = Cn.createRelationNamesVector(t, []), z = Cn.createLocalIdsVector(t, []), W = Cn.createCategoriesVector(t, []), re = Cn.createRelationsItemsVector(t, []), ce = Cn.createRelationsVector(t, []), te = Cn.createGuidsItemsVector(t, []), ee = Cn.createGuidsVector(t, []), Ne = t.createString(Eie.generateUUID());
  Cn.startModel(t), Cn.addMeshes(t, O), Cn.addMetadata(t, R), Cn.addAttributes(t, F), Cn.addUniqueAttributes(t, L), Cn.addRelationNames(t, P), Cn.addLocalIds(t, z), Cn.addCategories(t, W), Cn.addRelationsItems(t, re), Cn.addRelations(t, ce), Cn.addGuidsItems(t, te), Cn.addGuids(t, ee), Cn.addGuid(t, Ne), Cn.addMaxLocalId(t, 1);
  const Ae = Cn.endModel(t);
  t.finish(Ae);
  const Oe = t.asUint8Array();
  return t.clear(), e.raw ? Oe : Dle.deflate(Oe);
}
function Awe(e, t, i, n, s) {
  for (const o of e) o.type !== gn.UPDATE_SAMPLE && o.type !== gn.DELETE_SAMPLE || t.add(o.localId);
  for (let o = 0; o < i.sampleIdsLength(); o++) {
    const r = i.sampleIds(o);
    if (t.has(r)) {
      const l = i.samples(o).item(), c = i.meshesItems(l), h = n.localIds(c);
      s.add(h);
    }
  }
}
const pce = "-DELTA-MODEL-";
function Swe(e) {
  return { item: e.item(), localTransform: e.localTransform(), material: e.material(), representation: e.representation() };
}
function DZ(e) {
  const t = e.position(), i = e.xDirection(), n = e.yDirection();
  return { position: [t.x(), t.y(), t.z()], xDirection: [i.x(), i.y(), i.z()], yDirection: [n.x(), n.y(), n.z()] };
}
function mce(e) {
  return { r: e.r(), g: e.g(), b: e.b(), a: e.a(), renderedFaces: e.renderedFaces(), stroke: e.stroke() };
}
function lse(e) {
  const t = e.bbox(), i = t.min(), n = t.max();
  return { id: e.id(), bbox: [i.x(), i.y(), i.z(), n.x(), n.y(), n.z()], representationClass: e.representationClass() };
}
function yce(e) {
  const t = [];
  for (let l = 0; l < e.pointsLength(); l++) {
    const c = e.points(l);
    t.push([c.x(), c.y(), c.z()]);
  }
  const i = /* @__PURE__ */ new Map();
  for (let l = 0; l < e.profilesLength(); l++) {
    const c = e.profiles(l), h = Array.from(c.indicesArray() || []);
    i.set(l, h);
  }
  const n = /* @__PURE__ */ new Map();
  for (let l = 0; l < e.holesLength(); l++) {
    const c = e.holes(l), h = Array.from(c.indicesArray() || []), I = c.profileId();
    n.has(I) || n.set(I, []), n.get(I).push(h);
  }
  const s = /* @__PURE__ */ new Map();
  for (let l = 0; l < e.bigProfilesLength(); l++) {
    const c = e.bigProfiles(l), h = Array.from(c.indicesArray() || []);
    s.set(l, h);
  }
  const o = /* @__PURE__ */ new Map();
  for (let l = 0; l < e.bigHolesLength(); l++) {
    const c = e.bigHoles(l), h = Array.from(c.indicesArray() || []), I = c.profileId();
    o.has(I) || o.set(I, []), o.get(I).push(h);
  }
  const r = Array.from(e.profilesFaceIdsArray() || []);
  return { points: t, profiles: i, holes: n, bigProfiles: s, bigHoles: o, type: e.type(), profilesFaceIds: r };
}
function nYe(e) {
  const t = { radius: [], axes: [] }, i = e.radiusArray();
  t.radius = Array.from(i);
  const n = e.axesLength();
  for (let s = 0; s < n; s++) {
    const o = e.axes(s), r = o.wiresLength(), l = [];
    for (let O = 0; O < r; O++) {
      const R = o.wires(O), F = R.p1(), L = R.p2();
      l.push([F.x(), F.y(), F.z(), L.x(), L.y(), L.z()]);
    }
    const c = o.orderLength(), h = [];
    for (let O = 0; O < c; O++) h.push(o.order(O));
    const I = o.partsLength(), p = [];
    for (let O = 0; O < I; O++) p.push(o.parts(O));
    const y = o.wireSetsLength(), m = [];
    for (let O = 0; O < y; O++) {
      const R = o.wireSets(O), F = R.psLength(), L = [];
      for (let P = 0; P < F; P++) {
        const z = R.ps(P);
        L.push(z.x(), z.y(), z.z());
      }
      m.push(L);
    }
    const A = o.circleCurvesLength(), C = [];
    for (let O = 0; O < A; O++) {
      const R = o.circleCurves(O), F = R.aperture(), L = R.position(), P = L.x(), z = L.y(), W = L.z(), re = R.radius(), ce = R.xDirection(), te = ce.x(), ee = ce.y(), Ne = ce.z(), Ae = R.yDirection(), Oe = Ae.x(), pe = Ae.y(), je = Ae.z();
      C.push({ aperture: F, position: [P, z, W], radius: re, xDirection: [te, ee, Ne], yDirection: [Oe, pe, je] });
    }
    t.axes.push({ wires: l, order: h, parts: p, wireSets: m, circleCurves: C });
  }
  return t;
}
function sYe(e, t, i) {
  const n = e[t];
  if (typeof n == "string") {
    const s = i.get(n);
    if (s === void 0) throw new Error(`Malformed request: temp id ${e[t]} not found`);
    e[t] = s;
  }
}
function ase(e, t, i) {
  const n = e[t];
  if (typeof n == "string") {
    const s = i.get(n);
    if (s === void 0) throw new Error(`Malformed request: temp id ${e[t]} not found`);
    e[t] = s;
  }
}
function oYe(e, t, i) {
  const n = e[t];
  if (typeof n == "string") {
    const s = i.get(n);
    if (s === void 0) throw new Error(`Malformed request: temp id ${e[t]} not found`);
    e[t] = s;
  }
}
class Yo {
}
De(Yo, "edit", (function(e, t, i) {
  const n = e.meshes(), s = (i == null ? void 0 : i.raw) ?? !1, o = (i == null ? void 0 : i.delta) ?? !1;
  let r = /* @__PURE__ */ new Set(), l = /* @__PURE__ */ new Set(), c = /* @__PURE__ */ new Set(), h = /* @__PURE__ */ new Set(), I = /* @__PURE__ */ new Set(), p = /* @__PURE__ */ new Set(), y = /* @__PURE__ */ new Set(), m = /* @__PURE__ */ new Set(), A = 0, C = 0, O = 0, R = 0, F = 0, L = 0, P = 0;
  if (o) {
    const xt = (function(li, qi) {
      const un = /* @__PURE__ */ new Set(), Mn = /* @__PURE__ */ new Set(), Pn = /* @__PURE__ */ new Set(), ws = /* @__PURE__ */ new Set(), Ys = /* @__PURE__ */ new Set(), Ss = /* @__PURE__ */ new Set(), dr = /* @__PURE__ */ new Set(), Vr = /* @__PURE__ */ new Set();
      let _l = !1, p0 = 0, Lf = 0, _f = 0, xf = 0, aa = 0, Ih = 0, ph = 0;
      const m0 = /* @__PURE__ */ new Set(), Nc = /* @__PURE__ */ new Set(), Nd = /* @__PURE__ */ new Set(), Dd = /* @__PURE__ */ new Set(), Dc = /* @__PURE__ */ new Set(), Cc = /* @__PURE__ */ new Set(), mh = /* @__PURE__ */ new Set(), Go = li.meshes(), Oc = new Set(Go.globalTransformIdsArray()), Lc = new Set(Go.localTransformIdsArray()), _c = new Set(Go.materialIdsArray()), xc = new Set(Go.representationIdsArray()), Cd = new Set(li.localIdsArray()), xl = new Set(Go.sampleIdsArray()), yh = /* @__PURE__ */ new Set();
      for (const Bi of qi) Bi.type === gn.CREATE_SAMPLE && (_l = !0), Bi.type !== gn.UPDATE_LOCAL_TRANSFORM ? Bi.type !== gn.UPDATE_MATERIAL ? Bi.type !== gn.UPDATE_REPRESENTATION ? Bi.type !== gn.UPDATE_ITEM ? Bi.type !== gn.CREATE_GLOBAL_TRANSFORM ? Bi.type !== gn.UPDATE_GLOBAL_TRANSFORM ? Bi.type !== gn.UPDATE_SAMPLE ? Bi.type !== gn.CREATE_SAMPLE || (yh.add(Bi.localId), Oc.has(Bi.data.item) && Mn.add(Bi.data.item), Lc.has(Bi.data.localTransform) && Nd.add(Bi.data.localTransform), _c.has(Bi.data.material) && Dd.add(Bi.data.material), xc.has(Bi.data.representation) && Dc.add(Bi.data.representation)) : (yh.has(Bi.localId) || ws.add(Bi.localId), Oc.has(Bi.data.item) && Mn.add(Bi.data.item), Lc.has(Bi.data.localTransform) && Nd.add(Bi.data.localTransform), _c.has(Bi.data.material) && Dd.add(Bi.data.material), xc.has(Bi.data.representation) && Dc.add(Bi.data.representation)) : (Mn.add(Bi.localId), Cd.has(Bi.data.itemId) && un.add(Bi.data.itemId)) : Cd.has(Bi.data.itemId) && un.add(Bi.data.itemId) : un.add(Bi.localId) : Ss.add(Bi.localId) : Ys.add(Bi.localId) : Pn.add(Bi.localId);
      const Eh = /* @__PURE__ */ new Set();
      for (const Bi of qi) Bi.type !== gn.DELETE_GLOBAL_TRANSFORM ? Bi.type !== gn.DELETE_LOCAL_TRANSFORM ? Bi.type !== gn.DELETE_SAMPLE ? Bi.type !== gn.DELETE_MATERIAL ? Bi.type !== gn.DELETE_REPRESENTATION ? Bi.type !== gn.DELETE_ITEM || un.delete(Bi.localId) : (Ss.delete(Bi.localId), Eh.add(Bi.localId), xc.has(Bi.localId) || aa++) : (Ys.delete(Bi.localId), _c.has(Bi.localId) || xf++) : (ws.delete(Bi.localId), m0.add(Bi.localId), xl.has(Bi.localId) || _f++) : (Pn.delete(Bi.localId), Lc.has(Bi.localId) || Lf++) : (Mn.delete(Bi.localId), Oc.has(Bi.localId) || p0++);
      const LI = Yo.getRepresentations(li, Eh);
      for (const [, Bi] of LI) if (Bi.representationClass === Mr.SHELL) Ih++;
      else {
        if (Bi.representationClass !== Mr.CIRCLE_EXTRUSION) throw new Error("Unsupported representation class");
        ph++;
      }
      for (const Bi of qi) if (Bi.type === gn.CREATE_REPRESENTATION && Eh.has(Bi.localId)) if (Bi.data.representationClass === Mr.SHELL) Ih++;
      else {
        if (Bi.data.representationClass !== Mr.CIRCLE_EXTRUSION) throw new Error("Unsupported representation class");
        ph++;
      }
      for (let Bi = 0; Bi < Go.samplesLength(); Bi++) {
        const qu = Go.samples(Bi), Ru = qu.item(), Pc = qu.localTransform(), Od = qu.material(), gh = qu.representation(), Mc = Go.globalTransformIds(Ru), Uc = Go.localTransformIds(Pc), $u = Go.materialIds(Od), ua = Go.representationIds(gh), Bc = Go.meshesItems(Ru), Fc = li.localIds(Bc);
        (Mn.has(Mc) || Pn.has(Uc) || Ys.has($u) || Ss.has(ua) || un.has(Fc)) && Cd.has(Fc) && un.add(Fc);
      }
      for (let Bi = 0; Bi < Go.samplesLength(); Bi++) {
        const qu = Go.sampleIds(Bi);
        if (m0.has(qu)) continue;
        const Ru = Go.samples(Bi), Pc = Ru.item(), Od = Ru.localTransform(), gh = Ru.material(), Mc = Ru.representation(), Uc = Go.globalTransformIds(Pc), $u = Go.localTransformIds(Od), ua = Go.materialIds(gh), Bc = Go.representationIds(Mc), Fc = Go.meshesItems(Pc), y0 = li.localIds(Fc);
        (Mn.has(Uc) || Pn.has($u) || Ys.has(ua) || Ss.has(Bc) || un.has(y0)) && (Oc.has(Uc) && Nc.add(Uc), Lc.has($u) && Nd.add($u), _c.has(ua) && Dd.add(ua), xc.has(Bc) && Dc.add(Bc), Cd.has(y0) && mh.add(y0), Cc.add(qu));
      }
      Oc.clear(), Lc.clear(), _c.clear(), xc.clear(), Cd.clear(), xl.clear();
      for (const Bi of Nc) Mn.add(Bi);
      for (const Bi of Nd) Pn.add(Bi);
      for (const Bi of Dd) Ys.add(Bi);
      for (const Bi of Dc) Ss.add(Bi);
      for (const Bi of Cc) ws.add(Bi);
      for (const Bi of mh) un.add(Bi);
      Nc.clear(), Nd.clear(), Dd.clear(), Dc.clear(), Cc.clear(), mh.clear();
      const Pf = Yo.getGeometryIndicesFromRepresentations(li, Ss);
      for (const Bi of Pf.shellsIndices) dr.add(Bi);
      for (const Bi of Pf.rebarsIndices) Vr.add(Bi);
      return { itemIds: un, globalTranforms: Mn, localTransforms: Pn, samples: ws, materials: Ys, representations: Ss, shells: dr, circleExtrusions: Vr, detaDeletedGts: p0, detaDeletedLts: Lf, detaDeletedSamples: _f, detaDeletedMaterials: xf, detaDeletedRepresentations: aa, detaDeletedShells: Ih, detaDeletedCircleExtrusions: ph, createNewSample: _l };
    })(e, t);
    if (r = xt.itemIds, l = xt.globalTranforms, c = xt.localTransforms, h = xt.samples, I = xt.materials, p = xt.representations, y = xt.shells, m = xt.circleExtrusions, A = xt.detaDeletedGts, C = xt.detaDeletedLts, O = xt.detaDeletedSamples, R = xt.detaDeletedMaterials, F = xt.detaDeletedRepresentations, L = xt.detaDeletedShells, P = xt.detaDeletedCircleExtrusions, !xt.createNewSample && r.size === 0 && l.size === 0 && c.size === 0 && h.size === 0 && I.size === 0 && p.size === 0 && y.size === 0 && m.size === 0) {
      const li = /* @__PURE__ */ new Set();
      return Awe(t, /* @__PURE__ */ new Set(), n, e, li), { model: vwe({ raw: s }), items: Array.from(li) };
    }
  }
  const z = /* @__PURE__ */ new Map(), W = /* @__PURE__ */ new Map(), re = /* @__PURE__ */ new Map(), ce = /* @__PURE__ */ new Map(), te = /* @__PURE__ */ new Map(), ee = /* @__PURE__ */ new Map(), Ne = /* @__PURE__ */ new Map(), Ae = /* @__PURE__ */ new Map(), Oe = /* @__PURE__ */ new Map();
  let pe = null, je = null;
  const Ve = /* @__PURE__ */ new Map(), $e = /* @__PURE__ */ new Map(), vt = /* @__PURE__ */ new Map(), Rt = /* @__PURE__ */ new Map(), ze = /* @__PURE__ */ new Map(), mt = /* @__PURE__ */ new Map(), Et = /* @__PURE__ */ new Map(), it = /* @__PURE__ */ new Map(), Dt = /* @__PURE__ */ new Map(), Ct = /* @__PURE__ */ new Set(), Kt = /* @__PURE__ */ new Set(), Zt = /* @__PURE__ */ new Set(), Xt = /* @__PURE__ */ new Set(), gi = /* @__PURE__ */ new Set(), Wt = /* @__PURE__ */ new Set(), Di = /* @__PURE__ */ new Set(), ni = /* @__PURE__ */ new Set(), Ci = /* @__PURE__ */ new Set(), Se = new Set(n.materialIdsArray()), si = new Set(n.representationIdsArray()), Mt = new Set(n.sampleIdsArray()), ft = new Set(n.globalTransformIdsArray()), rt = new Set(n.localTransformIdsArray()), Tt = new Set(e.localIdsArray());
  let jt = e.maxLocalId();
  for (const xt of t) if (xt.type !== gn.UPDATE_MATERIAL) if (xt.type !== gn.UPDATE_REPRESENTATION) if (xt.type !== gn.UPDATE_SAMPLE) if (xt.type !== gn.UPDATE_GLOBAL_TRANSFORM) if (xt.type !== gn.UPDATE_LOCAL_TRANSFORM) if (xt.type !== gn.UPDATE_ITEM) if (xt.type !== gn.UPDATE_RELATION) if (xt.type !== gn.UPDATE_METADATA) if (xt.type !== gn.UPDATE_SPATIAL_STRUCTURE) if (xt.type !== gn.CREATE_MATERIAL) if (xt.type !== gn.CREATE_REPRESENTATION) if (xt.type !== gn.CREATE_SAMPLE) if (xt.type !== gn.CREATE_GLOBAL_TRANSFORM) if (xt.type !== gn.CREATE_LOCAL_TRANSFORM) {
    if (xt.type === gn.CREATE_ITEM) {
      const li = xt.localId;
      if (Tt.has(li)) continue;
      it.set(li, xt.data);
    }
    if (xt.type === gn.CREATE_RELATION) {
      const li = xt.localId;
      Dt.set(li, xt.data);
    }
    xt.type !== gn.DELETE_MATERIAL ? xt.type !== gn.DELETE_REPRESENTATION ? xt.type !== gn.DELETE_SAMPLE ? xt.type !== gn.DELETE_GLOBAL_TRANSFORM ? xt.type !== gn.DELETE_LOCAL_TRANSFORM ? xt.type !== gn.DELETE_ITEM ? xt.type !== gn.UPDATE_MAX_LOCAL_ID ? xt.type !== gn.DELETE_RELATION || Ci.add(xt.localId) : jt = xt.localId : ni.add(xt.localId) : Di.add(xt.localId) : Wt.add(xt.localId) : Kt.add(xt.localId) : Zt.add(xt.localId) : Ct.add(xt.localId);
  } else {
    const li = xt.localId;
    if (rt.has(li)) continue;
    Et.set(li, xt.data);
  }
  else {
    const li = xt.localId;
    if (ft.has(li)) continue;
    mt.set(li, xt.data);
  }
  else {
    const li = xt.localId;
    if (Mt.has(li)) continue;
    ze.set(li, xt.data);
  }
  else {
    const li = xt.localId;
    if (si.has(li)) continue;
    $e.set(li, xt.data), xt.data.representationClass === Mr.SHELL ? vt.set(li, xt.data.geometry) : xt.data.representationClass === Mr.CIRCLE_EXTRUSION && Rt.set(li, xt.data.geometry);
  }
  else {
    const li = xt.localId;
    if (Se.has(li)) continue;
    Ve.set(li, xt.data);
  }
  else je = xt.data;
  else pe = xt.data;
  else Oe.set(xt.localId, xt.data);
  else Ae.set(xt.localId, xt.data);
  else te.set(xt.localId, xt.data);
  else ce.set(xt.localId, xt.data);
  else re.set(xt.localId, xt.data);
  else W.set(xt.localId, xt.data);
  else z.set(xt.localId, xt.data);
  for (let xt = 0; xt < n.representationsLength(); xt++) {
    const li = n.representations(xt), qi = li.id(), un = n.representationIds(xt);
    if (o && !p.has(un)) continue;
    if (Zt.has(un)) {
      if (li.representationClass() === Mr.SHELL) Xt.add(qi);
      else {
        if (li.representationClass() !== Mr.CIRCLE_EXTRUSION) throw new Error("Representation class is not supported");
        gi.add(qi);
      }
      continue;
    }
    if (!W.has(un)) continue;
    const Mn = li.representationClass();
    if (Mn === Mr.SHELL) ee.set(qi, un);
    else {
      if (Mn !== Mr.CIRCLE_EXTRUSION) throw new Error("Representation class is not supported");
      Ne.set(qi, un);
    }
  }
  Se.clear(), si.clear(), Mt.clear(), ft.clear(), rt.clear(), Tt.clear();
  const Jt = n.materialsLength(), $t = o ? I.size : Jt, ht = o ? R : Ct.size, Me = $t + Ve.size - ht, gt = n.representationsLength(), yt = o ? p.size : gt, Ut = o ? F : Zt.size, Ht = yt + $e.size - Ut, wi = n.shellsLength(), bi = o ? y.size : wi, Hi = o ? L : Xt.size, Wi = bi + vt.size - Hi, hi = n.circleExtrusionsLength(), Ji = o ? m.size : hi, Sn = o ? P : gi.size, nn = Ji + Rt.size - Sn, Yi = n.samplesLength(), Pi = o ? h.size : Yi, kt = o ? O : Kt.size, sn = Pi + ze.size - kt, Fi = n.globalTransformsLength(), tn = o ? l.size : Fi, Gi = o ? A : Wt.size, yi = tn + mt.size - Gi, bn = n.localTransformsLength(), ln = o ? c.size : bn, No = o ? C : Di.size, Bs = ln + Et.size - No;
  if (yi < 0 || Ht < 0 || sn < 0 || Bs < 0 || Me < 0 || Wi < 0 || nn < 0) throw new Error("Invalid number of elements");
  const os = /* @__PURE__ */ new Map(), vl = [], zl = [], Wu = [], jl = [], Yu = [], bd = [], I0 = [];
  let Gt = 0;
  for (let xt = 0; xt < n.globalTransformsLength(); xt++) {
    const li = n.globalTransformIds(xt);
    if (!Wt.has(li) && (!o || l.has(li))) {
      if (os.has(li)) throw new Error("Local id already exists");
      os.set(li, Gt++), jl.push(li);
    }
  }
  for (const [xt] of mt) if (!Wt.has(xt)) {
    if (os.has(xt)) throw new Error("Local id already exists");
    os.set(xt, Gt++), jl.push(xt);
  }
  let Vi = 0;
  for (let xt = 0; xt < n.materialIdsLength(); xt++) {
    const li = n.materialIds(xt);
    if (!Ct.has(li) && (!o || I.has(li))) {
      if (os.has(li)) throw new Error("Local id already exists");
      os.set(li, Vi++), vl.push(li);
    }
  }
  for (const [xt] of Ve) if (!Ct.has(xt)) {
    if (os.has(xt)) throw new Error("Local id already exists");
    os.set(xt, Vi++), vl.push(xt);
  }
  let _i = 0;
  for (let xt = 0; xt < n.localTransformIdsLength(); xt++) {
    const li = n.localTransformIds(xt);
    if (!Di.has(li) && (!o || c.has(li))) {
      if (os.has(li)) throw new Error("Local id already exists");
      os.set(li, _i++), bd.push(li);
    }
  }
  for (const [xt] of Et) if (!Di.has(xt)) {
    if (os.has(xt)) throw new Error("Local id already exists");
    os.set(xt, _i++), bd.push(xt);
  }
  let $n = 0;
  for (let xt = 0; xt < n.representationIdsLength(); xt++) {
    const li = n.representationIds(xt);
    if (!Zt.has(li) && (!o || p.has(li))) {
      if (os.has(li)) throw new Error("Local id already exists");
      os.set(li, $n++), zl.push(li);
    }
  }
  for (const [xt] of $e) if (!Zt.has(xt)) {
    if (os.has(xt)) throw new Error("Local id already exists");
    os.set(xt, $n++), zl.push(xt);
  }
  for (let xt = 0; xt < n.sampleIdsLength(); xt++) {
    const li = n.sampleIds(xt);
    Kt.has(li) || o && !h.has(li) || Wu.push(li);
  }
  for (const [xt] of ze) Kt.has(xt) || Wu.push(xt);
  let Os = 0;
  for (let xt = 0; xt < e.localIdsLength(); xt++) {
    const li = e.localIds(xt);
    ni.has(li) || o && !r.has(li) || (os.set(li, Os++), I0.push(li));
  }
  for (const [xt] of it) ni.has(xt) || (os.set(xt, Os++), I0.push(xt));
  const Ai = new Uie(1024);
  $i.startGlobalTransformsVector(Ai, yi);
  const As = Array.from(mt.keys());
  for (let xt = 0; xt < As.length; xt++) {
    const li = As[As.length - 1 - xt], qi = ce.has(li) ? ce.get(li) : mt.get(li);
    if (!qi) throw new Error(`Global transform not found: ${li}`);
    if (Wt.has(li)) continue;
    const un = qi.itemId;
    if (!os.has(un)) throw new Error("Item id not found for global transform");
    const Mn = os.get(un);
    Yu.unshift(Mn), uJ(qi, Ai);
  }
  As.length = 0;
  for (let xt = 0; xt < Fi; xt++) {
    const li = Fi - 1 - xt, qi = n.globalTransforms(li), un = n.globalTransformIds(li);
    if (!Wt.has(un) && !(o && !l.has(un)))
      if (ce.has(un)) {
        const Mn = ce.get(un), Pn = Mn.itemId;
        if (!os.has(Pn)) throw new Error(`Item id not found for global transform: ${un}`);
        const ws = os.get(Pn);
        Yu.unshift(ws), uJ(Mn, Ai);
      } else {
        const Mn = n.meshesItems(li), Pn = e.localIds(Mn);
        if (!os.has(Pn)) throw new Error(`Item id not found for global transform: ${un}`);
        const ws = os.get(Pn);
        Yu.unshift(ws), cce(Ai, qi);
      }
  }
  const Es = Ai.endVector(), mr = [];
  for (let xt = 0; xt < wi; xt++) {
    if (Xt.has(xt) || o && !y.has(xt)) continue;
    if (ee.has(xt)) {
      const un = ee.get(xt), Mn = W.get(un).geometry, Pn = hce(Ai, Mn);
      mr.push(Pn);
      continue;
    }
    const li = n.shells(xt), qi = tYe(Ai, li);
    mr.push(qi);
  }
  for (const [xt] of vt) {
    if (Zt.has(xt)) continue;
    let li = 0;
    if (ee.has(xt)) {
      const qi = ee.get(xt), un = W.get(qi).geometry;
      li = hce(Ai, un);
    } else {
      const qi = vt.get(xt);
      li = hce(Ai, qi);
    }
    mr.push(li);
  }
  const Je = $i.createShellsVector(Ai, mr), no = [];
  for (let xt = 0; xt < hi; xt++) {
    if (gi.has(xt) || o && !m.has(xt)) continue;
    if (Ne.has(xt)) {
      const un = Ne.get(xt), Mn = W.get(un).geometry, Pn = fce(Ai, Mn);
      no.push(Pn);
      continue;
    }
    const li = n.circleExtrusions(xt), qi = iYe(Ai, li);
    no.push(qi);
  }
  for (const [xt] of Rt) {
    if (gi.has(xt)) continue;
    let li = 0;
    if (Ne.has(xt)) {
      const qi = Ne.get(xt), un = W.get(qi).geometry;
      li = fce(Ai, un);
    } else {
      const qi = Rt.get(xt);
      li = fce(Ai, qi);
    }
    no.push(li);
  }
  const It = $i.createCircleExtrusionsVector(Ai, no);
  $i.startRepresentationsVector(Ai, Ht);
  const Qt = Array.from($e.keys());
  let ci = Wi - 1, ai = nn - 1;
  for (let xt = 0; xt < Qt.length; xt++) {
    const li = Qt[Qt.length - 1 - xt];
    if (Zt.has(li)) continue;
    const qi = W.has(li) ? W.get(li) : $e.get(li);
    if (!qi) throw new Error(`Representation not found: ${li}`);
    const un = qi.bbox, Mn = qi.representationClass;
    let Pn = 0;
    if (qi.representationClass === Mr.SHELL) Pn = ci--;
    else {
      if (qi.representationClass !== Mr.CIRCLE_EXTRUSION) throw new Error("Representation class is not supported");
      Pn = ai--;
    }
    iN.createRepresentation(Ai, Pn, un[0], un[1], un[2], un[3], un[4], un[5], Mn);
  }
  Qt.length = 0;
  for (let xt = 0; xt < gt; xt++) {
    const li = gt - 1 - xt, qi = n.representations(li), un = n.representationIds(li);
    if (!Zt.has(un) && !(o && !p.has(un)))
      if (W.has(un)) {
        const Mn = W.get(un), Pn = Mn.bbox;
        let ws = 0;
        if (Mn.representationClass === Mr.SHELL) ws = ci--;
        else {
          if (Mn.representationClass !== Mr.CIRCLE_EXTRUSION) throw new Error("Representation class is not supported");
          ws = ai--;
        }
        const Ys = Mn.representationClass;
        iN.createRepresentation(Ai, ws, Pn[0], Pn[1], Pn[2], Pn[3], Pn[4], Pn[5], Ys);
      } else {
        const Mn = qi.bbox();
        let Pn = 0;
        if (qi.representationClass() === Mr.SHELL) Pn = ci--;
        else {
          if (qi.representationClass() !== Mr.CIRCLE_EXTRUSION) throw new Error("Representation class is not supported");
          Pn = ai--;
        }
        const ws = qi.representationClass(), Ys = Mn.min(), Ss = Mn.max();
        iN.createRepresentation(Ai, Pn, Ys.x(), Ys.y(), Ys.z(), Ss.x(), Ss.y(), Ss.z(), ws);
      }
  }
  const ei = Ai.endVector();
  $i.startSamplesVector(Ai, sn);
  const Si = Array.from(ze.keys());
  for (let xt = 0; xt < Si.length; xt++) {
    const li = Si[Si.length - 1 - xt];
    if (Kt.has(li)) continue;
    const qi = re.has(li) ? re.get(li) : ze.get(li);
    if (!qi) throw new Error(`Sample not found: ${li}`);
    if (Ct.has(qi.material)) throw new Error(`Material to delete found in sample ${li}`);
    if (Zt.has(qi.representation)) throw new Error(`Representation to delete found in sample ${li}`);
    const un = qi.item, Mn = qi.material, Pn = qi.representation, ws = qi.localTransform;
    Ice(Ai, os, un, Mn, Pn, ws);
  }
  Si.length = 0;
  for (let xt = 0; xt < Yi; xt++) {
    const li = Yi - 1 - xt, qi = n.samples(li), un = n.sampleIds(li);
    if (Kt.has(un) || o && !h.has(un)) continue;
    if (re.has(un)) {
      const Ss = re.get(un), dr = Ss.item, Vr = Ss.material, _l = Ss.representation, p0 = Ss.localTransform;
      Ice(Ai, os, dr, Vr, _l, p0);
      continue;
    }
    const Mn = n.globalTransformIds(qi.item()), Pn = n.materialIds(qi.material()), ws = n.representationIds(qi.representation()), Ys = n.localTransformIds(qi.localTransform());
    if (Ct.has(Pn)) throw new Error(`Material to delete found in sample ${un}`);
    Ice(Ai, os, Mn, Pn, ws, Ys);
  }
  const mn = Ai.endVector();
  $i.startLocalTransformsVector(Ai, Bs);
  const wn = Array.from(Et.keys());
  for (let xt = 0; xt < wn.length; xt++) {
    const li = wn[wn.length - 1 - xt];
    if (Di.has(li)) continue;
    const qi = te.has(li) ? te.get(li) : Et.get(li);
    if (!qi) throw new Error(`Local transform not found: ${li}`);
    uJ(qi, Ai);
  }
  wn.length = 0;
  for (let xt = 0; xt < bn; xt++) {
    const li = bn - 1 - xt, qi = n.localTransforms(li), un = n.localTransformIds(li), Mn = te.has(un);
    !Di.has(un) && (!o || c.has(un)) && (Mn ? uJ(te.get(un), Ai) : cce(Ai, qi));
  }
  const Nn = Ai.endVector();
  $i.startMaterialsVector(Ai, Me);
  const Kn = Array.from(Ve.keys());
  for (let xt = 0; xt < Kn.length; xt++) {
    const li = Kn[Kn.length - 1 - xt];
    if (Ct.has(li)) continue;
    const qi = z.has(li) ? z.get(li) : Ve.get(li);
    if (!qi) throw new Error(`Material not found: ${li}`);
    const un = qi.r, Mn = qi.g, Pn = qi.b, ws = qi.a, Ys = qi.stroke, Ss = qi.renderedFaces;
    Iz.createMaterial(Ai, un, Mn, Pn, ws, Ss, Ys);
  }
  Kn.length = 0;
  for (let xt = 0; xt < Jt; xt++) {
    const li = Jt - 1 - xt, qi = n.materials(li), un = n.materialIds(li);
    if (Ct.has(un) || o && !I.has(un)) continue;
    const Mn = z.has(un), Pn = z.get(un), ws = Mn ? Pn.r : qi.r(), Ys = Mn ? Pn.g : qi.g(), Ss = Mn ? Pn.b : qi.b(), dr = Mn ? Pn.a : qi.a(), Vr = Mn ? Pn.stroke : qi.stroke(), _l = Mn ? Pn.renderedFaces : qi.renderedFaces();
    Iz.createMaterial(Ai, ws, Ys, Ss, dr, _l, Vr);
  }
  const is = Ai.endVector(), jn = $i.createMeshesItemsVector(Ai, Yu), _s = $i.createRepresentationIdsVector(Ai, zl), yo = $i.createSampleIdsVector(Ai, Wu), Qo = $i.createMaterialIdsVector(Ai, vl), so = $i.createLocalTransformIdsVector(Ai, bd), Eo = $i.createGlobalTransformIdsVector(Ai, jl);
  $i.startMeshes(Ai);
  const Yn = n.coordinates(), Jo = cce(Ai, Yn);
  $i.addCoordinates(Ai, Jo), $i.addGlobalTransforms(Ai, Es), $i.addShells(Ai, Je), $i.addRepresentations(Ai, ei), $i.addSamples(Ai, mn), $i.addLocalTransforms(Ai, Nn), $i.addMaterials(Ai, is), $i.addCircleExtrusions(Ai, It), $i.addMeshesItems(Ai, jn), $i.addRepresentationIds(Ai, _s), $i.addSampleIds(Ai, yo), $i.addMaterialIds(Ai, Qo), $i.addLocalTransformIds(Ai, so), $i.addGlobalTransformIds(Ai, Eo);
  const xs = $i.endMeshes(Ai);
  let Gr;
  if (pe) {
    const xt = JSON.stringify(pe);
    Gr = Ai.createString(xt);
  } else {
    const xt = e.metadata();
    Gr = Ai.createString(xt);
  }
  const sa = e.attributesLength(), yr = [], nr = /* @__PURE__ */ new Set(), Ws = [], ul = [], ur = [], ao = /* @__PURE__ */ new Map();
  for (let xt = 0; xt < e.guidsItemsLength(); xt++) {
    const li = e.guidsItems(xt);
    ao.set(li, xt);
  }
  for (let xt = 0; xt < sa; xt++) {
    const li = e.localIds(xt);
    if (ni.has(li)) continue;
    const qi = e.attributes(xt), un = [];
    if (Ae.has(li)) {
      const ws = Ae.get(li);
      Ws.push(Ai.createSharedString(ws.category)), ws.guid && (ul.push(Ai.createSharedString(ws.guid)), ur.push(li));
      for (const Ys in ws.data) {
        const { value: Ss, type: dr } = ws.data[Ys], Vr = JSON.stringify([Ys, Ss, dr]);
        nr.add(Vr);
        const _l = Ai.createSharedString(Vr);
        un.push(_l);
      }
    } else {
      const ws = e.categories(xt);
      Ws.push(Ai.createSharedString(ws));
      const Ys = ao.get(li);
      if (Ys !== void 0) {
        const dr = e.guids(Ys);
        ul.push(Ai.createSharedString(dr)), ur.push(li);
      }
      const Ss = qi.dataLength();
      for (let dr = 0; dr < Ss; dr++) {
        const Vr = qi.data(dr);
        nr.add(Vr);
        const _l = Ai.createSharedString(Vr);
        un.push(_l);
      }
    }
    const Mn = Jy.createDataVector(Ai, un), Pn = Jy.createAttribute(Ai, Mn);
    yr.push(Pn);
  }
  for (const [xt, li] of it) {
    if (ni.has(xt)) continue;
    Ws.push(Ai.createSharedString(li.category)), li.guid && (console.log(li.guid), ul.push(Ai.createSharedString(li.guid)), ur.push(xt));
    const qi = [];
    for (const Pn in li.data) {
      const { value: ws, type: Ys } = li.data[Pn], Ss = JSON.stringify([Pn, ws, Ys]);
      nr.add(Ss);
      const dr = Ai.createSharedString(Ss);
      qi.push(dr);
    }
    const un = Jy.createDataVector(Ai, qi), Mn = Jy.createAttribute(Ai, un);
    yr.push(Mn);
  }
  const kr = Cn.createAttributesVector(Ai, yr), oa = [];
  for (const xt of nr) {
    const li = Ai.createSharedString(xt);
    oa.push(li);
  }
  const Po = Cn.createUniqueAttributesVector(Ai, oa), NI = e.relationNamesLength(), Tc = [];
  for (let xt = 0; xt < NI; xt++) {
    const li = e.relationNames(xt), qi = Ai.createSharedString(li);
    Tc.push(qi);
  }
  const bf = Cn.createRelationNamesVector(Ai, Tc), Rc = Cn.createLocalIdsVector(Ai, I0), Sr = Cn.createCategoriesVector(Ai, Ws), ra = [], Ls = [], vc = /* @__PURE__ */ new Set(), la = e.relationsItemsLength(), Nf = (xt) => {
    const li = [];
    for (const Mn in xt.data) {
      const Pn = xt.data[Mn].filter(((Ys) => !ni.has(Ys)));
      if (!Pn.length) continue;
      const ws = Ai.createSharedString(JSON.stringify([Mn, ...Pn]));
      li.push(ws);
    }
    const qi = Jv.createDataVector(Ai, li), un = Jv.createRelation(Ai, qi);
    ra.push(un);
  };
  for (let xt = 0; xt < la; xt++) {
    const li = e.relationsItems(xt);
    if (vc.add(li), ni.has(li) || Ci.has(li) || !os.has(li)) continue;
    let qi;
    if (Oe.has(li)) qi = Oe.get(li);
    else {
      const un = e.relations(xt);
      qi = Yo.getRelationData(un);
    }
    Nf(qi), Ls.push(li);
  }
  for (const [xt, li] of Dt) {
    if (ni.has(xt) || Ci.has(xt) || vc.has(xt)) continue;
    let qi;
    qi = Oe.has(xt) ? Oe.get(xt) : li, Nf(qi), Ls.push(xt);
  }
  vc.clear();
  const DI = Cn.createRelationsVector(Ai, ra), Df = Cn.createRelationsItemsVector(Ai, Ls), dl = Cn.createGuidsItemsVector(Ai, ur), Ac = Cn.createGuidsVector(Ai, ul);
  let Sc = null;
  if (je) Sc = GSe(Ai, je);
  else {
    const xt = e.spatialStructure();
    Sc = HSe(Ai, xt);
  }
  const CI = e.guid(), go = Ai.createString(CI);
  Cn.startModel(Ai), Cn.addMeshes(Ai, xs), Cn.addMetadata(Ai, Gr), Cn.addAttributes(Ai, kr), Cn.addUniqueAttributes(Ai, Po), Cn.addRelationNames(Ai, bf), Cn.addLocalIds(Ai, Rc), Cn.addCategories(Ai, Sr), Cn.addRelationsItems(Ai, Df), Cn.addRelations(Ai, DI), Cn.addGuidsItems(Ai, dl), Cn.addGuids(Ai, Ac), Sc !== null && Cn.addSpatialStructure(Ai, Sc), Cn.addGuid(Ai, go), Cn.addMaxLocalId(Ai, jt);
  const Cf = Cn.endModel(Ai);
  Ai.finish(Cf);
  const bc = Ai.asUint8Array();
  Ai.clear();
  const OI = s ? bc : Dle.deflate(bc), Of = new Set(I0);
  return Awe(t, new Set(Wu), n, e, Of), { model: OI, items: Array.from(Of) };
})), De(Yo, "solveIds", (function(e, t) {
  const i = /* @__PURE__ */ new Map(), n = [];
  for (const s of e) {
    if (s.localId !== void 0) continue;
    const o = t++;
    s.tempId && i.set(s.tempId, o), s.localId = o, n.push(o);
  }
  for (const s of e) if (s.type !== gn.UPDATE_SAMPLE && s.type !== gn.CREATE_SAMPLE) s.type !== gn.UPDATE_GLOBAL_TRANSFORM && s.type !== gn.CREATE_GLOBAL_TRANSFORM ? oYe(s, "localId", i) : sYe(s.data, "itemId", i);
  else {
    const o = s.data;
    ase(o, "item", i), ase(o, "material", i), ase(o, "representation", i), ase(o, "localTransform", i);
  }
  return i.clear(), n;
})), De(Yo, "newModel", vwe), De(Yo, "applyChangesToRawData", (function(e, t, i, n) {
  const s = gn[`CREATE_${i}`], o = gn[`UPDATE_${i}`], r = gn[`DELETE_${i}`];
  if (e) for (const l of e) if (l.type !== s && l.type !== o) l.type === r && t.delete(l.localId);
  else {
    if (n && !n.has(l.localId)) continue;
    t.set(l.localId, l.data);
  }
})), De(Yo, "applyChangesToSpecialData", (function(e, t) {
  const i = gn[`UPDATE_${t}`];
  if (e) for (let n = e.length - 1; n >= 0; n--) {
    const s = e[n];
    if (s.type === i) return JSON.parse(JSON.stringify(s.data));
  }
  return null;
})), De(Yo, "applyChangesToIds", (function(e, t, i, n) {
  const s = new Set(t), o = gn[`DELETE_${i}`], r = gn[`CREATE_${i}`];
  if (e) {
    for (const l of e) l.type !== o ? n && l.type === r && s.add(l.localId) : s.delete(l.localId);
    return Array.from(s);
  }
  return t;
})), De(Yo, "getModelFromBuffer", (function(e, t) {
  const i = new LX(t ? e : Dle.inflate(e));
  return Cn.getRootAsModel(i);
})), De(Yo, "getSampleData", Swe), De(Yo, "getTransformData", DZ), De(Yo, "getRelationData", (function(e) {
  const t = { data: {} }, i = e.dataLength();
  for (let n = 0; n < i; n++) {
    const s = e.data(n), [o, ...r] = JSON.parse(s);
    t.data[o] = r;
  }
  return t;
})), De(Yo, "getMaterialData", mce), De(Yo, "getRepresentationData", lse), De(Yo, "getShellData", yce), De(Yo, "getMaterialsIds", (function(e) {
  return e.meshes().materialIdsArray() || [];
})), De(Yo, "getMaterials", (function(e, t) {
  const i = e.meshes(), n = t || i.materialIdsArray(), s = new Set(n), o = new Iz(), r = /* @__PURE__ */ new Map();
  for (let l = 0; l < i.materialsLength(); l++) {
    const c = i.materialIds(l);
    if (!s.has(c)) continue;
    i.materials(l, o);
    const h = mce(o);
    r.set(c, h);
  }
  return r;
})), De(Yo, "getRepresentationsIds", (function(e) {
  return e.meshes().representationIdsArray() || [];
})), De(Yo, "getRepresentations", (function(e, t) {
  const i = e.meshes(), n = t || i.representationIdsArray(), s = new Set(n), o = /* @__PURE__ */ new Map(), r = new iN();
  for (let l = 0; l < i.representationsLength(); l++) {
    const c = i.representationIds(l);
    if (!s.has(c)) continue;
    i.representations(l, r);
    const h = lse(r);
    if (h.representationClass === Mr.SHELL) {
      const I = yce(i.shells(h.id));
      h.geometry = I;
    } else if (h.representationClass === Mr.CIRCLE_EXTRUSION) {
      const I = nYe(i.circleExtrusions(h.id));
      h.geometry = I;
    }
    o.set(c, h);
  }
  return o;
})), De(Yo, "getLocalTransformsIds", (function(e) {
  return e.meshes().localTransformIdsArray() || [];
})), De(Yo, "getLocalTransforms", (function(e, t) {
  const i = e.meshes(), n = t || i.localTransformIdsArray(), s = new Set(n), o = /* @__PURE__ */ new Map(), r = new M5();
  for (let l = 0; l < i.localTransformsLength(); l++) {
    const c = i.localTransformIds(l);
    if (!s.has(c)) continue;
    i.localTransforms(l, r);
    const h = DZ(r);
    o.set(c, h);
  }
  return o;
})), De(Yo, "getGlobalTransformsIds", (function(e) {
  return e.meshes().globalTransformIdsArray() || [];
})), De(Yo, "getGlobalTransforms", (function(e, t) {
  const i = e.meshes();
  let n = null;
  n = t ? new Set(t) : new Set(i.globalTransformIdsArray());
  const s = /* @__PURE__ */ new Map(), o = new M5(), r = i.globalTransformsLength();
  for (let l = 0; l < r; l++) {
    i.globalTransforms(l, o);
    const c = i.globalTransformIds(l), h = i.meshesItems(l), I = e.localIds(h);
    if (!n.has(c)) continue;
    const p = DZ(o);
    s.set(c, { ...p, itemId: I });
  }
  return s;
})), De(Yo, "getSamplesIds", (function(e) {
  return e.meshes().sampleIdsArray() || [];
})), De(Yo, "getSamples", (function(e, t) {
  const i = e.meshes(), n = t || i.sampleIdsArray(), s = new Set(n), o = /* @__PURE__ */ new Map(), r = new lY();
  for (let l = 0; l < i.samplesLength(); l++) {
    const c = i.sampleIds(l);
    if (!s.has(c)) continue;
    i.samples(l, r);
    const h = Swe(r);
    h.item = i.globalTransformIds(h.item), h.material = i.materialIds(h.material), h.representation = i.representationIds(h.representation), h.localTransform = i.localTransformIds(h.localTransform), o.set(c, h);
  }
  return o;
})), De(Yo, "getItemsIds", (function(e) {
  return e.localIdsArray();
})), De(Yo, "getItems", (function(e, t) {
  let i = /* @__PURE__ */ new Set();
  if (t) i = new Set(t);
  else for (let s = 0; s < e.localIdsLength(); s++) i.add(s);
  const n = /* @__PURE__ */ new Map();
  for (const s of i) {
    const o = e.localIds(s), r = e.categories(s), l = e.guids(s), c = e.attributes(s), h = {};
    for (let I = 0; I < c.dataLength(); I++) {
      const p = c.data(I), [y, m, A] = JSON.parse(p);
      h[y] = { value: m, type: A };
    }
    n.set(o, { data: h, category: r, guid: l });
  }
  return n;
})), De(Yo, "getGlobalTranformsIdsOfItems", (function(e, t) {
  const i = e.meshes(), n = new Set(t), s = /* @__PURE__ */ new Set();
  for (let o = 0; o < i.meshesItemsLength(); o++) {
    const r = i.meshesItems(o), l = e.localIds(r);
    n.has(l) && s.add(i.globalTransformIds(o));
  }
  return Array.from(s);
})), De(Yo, "getElementsData", (function(e, t) {
  const i = e.data, n = i.meshes(), s = {}, o = new Set(t), r = new M5(), l = new Iz(), c = new iN(), h = new Fo();
  for (let y = 0; y < n.samplesLength(); y++) {
    const m = n.samples(y), A = m.item(), C = n.meshesItems(A), O = i.localIds(C);
    if (!o.has(O)) continue;
    s[O] || (s[O] = { samples: {}, localTransforms: {}, globalTransforms: {}, representations: {}, materials: {} });
    const R = s[O], F = m.localTransform(), L = m.material(), P = m.representation(), z = n.sampleIds(y), W = n.globalTransformIds(A), re = n.localTransformIds(F), ce = n.materialIds(L), te = n.representationIds(P);
    R.samples[z] = { item: W, localTransform: re, material: ce, representation: te }, n.localTransforms(F, r), R.localTransforms[re] = DZ(r), n.globalTransforms(A, r);
    const ee = DZ(r);
    R.globalTransforms[W] = { ...ee, itemId: O }, n.materials(L, l), R.materials[ce] = mce(l), n.representations(P, c);
    const Ne = lse(c);
    if (Ne.representationClass === Mr.SHELL) {
      n.shells(Ne.id, h);
      const Ae = yce(h);
      Ne.geometry = Ae;
    }
    R.representations[te] = Ne;
  }
  const I = /* @__PURE__ */ new Map();
  for (let y = 0; y < i.relationsItemsLength(); y++) {
    const m = i.relationsItems(y);
    I.set(m, y);
  }
  const p = /* @__PURE__ */ new Map();
  for (let y = 0; y < i.localIdsLength(); y++) {
    const m = i.localIds(y);
    p.set(m, y);
  }
  return s;
})), De(Yo, "getGeometryIndicesFromRepresentations", (function(e, t) {
  const i = e.meshes(), n = t || i.representationIdsArray(), s = new Set(n), o = new iN(), r = /* @__PURE__ */ new Set(), l = /* @__PURE__ */ new Set();
  for (let c = 0; c < i.representationsLength(); c++) {
    const h = i.representationIds(c);
    if (!s.has(h)) continue;
    i.representations(c, o);
    const I = lse(o);
    if (I.representationClass === Mr.SHELL) r.add(I.id);
    else {
      if (I.representationClass !== Mr.CIRCLE_EXTRUSION) throw new Error("Rebars not supported yet");
      l.add(I.id);
    }
  }
  return { shellsIndices: r, rebarsIndices: l };
})), De(Yo, "getRootModelId", (function(e) {
  return e.includes(pce) ? e.substring(0, e.indexOf(pce)) : e;
})), De(Yo, "getSerializedAttributes", (function(e) {
  const t = [];
  for (const i in e) {
    if (i[0] === "_") continue;
    const n = e[i];
    if (Array.isArray(n)) continue;
    const s = n.value, o = n.type, r = JSON.stringify([i, s, o]);
    t.push(r);
  }
  return t;
})), De(Yo, "itemDataToRawItemData", (function(e) {
  const t = e._category;
  if (!t) throw new Error("Category is required");
  const i = t.value, n = e._guid, s = {};
  for (const o in e) {
    if (o[0] === "_") continue;
    const r = e[o];
    Array.isArray(r) || (s[o] = r);
  }
  return { data: s, category: i, guid: n ? n.value : void 0 };
})), De(Yo, "DELTA_MODEL_ID", pce);
class rYe {
  constructor(t, i, n, s) {
    De(this, "x"), De(this, "y"), De(this, "z"), De(this, "hash"), De(this, "id"), this.x = _o.round(t[3 * i], s), this.y = _o.round(t[3 * i + 1], s), this.z = _o.round(t[3 * i + 2], s), this.hash = `${this.x}/${this.y}/${this.z}`, this.id = n;
  }
}
class lYe {
  constructor(t) {
    De(this, "list", /* @__PURE__ */ new Map()), De(this, "tempV1", new Ge()), De(this, "tempV2", new Ge()), De(this, "tempV3", new Ge()), De(this, "precission"), this.precission = t;
  }
  create(t, i) {
    const n = new rYe(t, i, this.list.size, this.precission);
    return this.list.has(n.hash) || this.list.set(n.hash, n), this.list.get(n.hash);
  }
  get() {
    return Array.from(this.list.values()).map(((t) => [t.x, t.y, t.z]));
  }
  isValidTriangle(t, i, n, s) {
    this.tempV1.set(t[3 * i], t[3 * i + 1], t[3 * i + 2]), this.tempV2.set(t[3 * n], t[3 * n + 1], t[3 * n + 2]), this.tempV3.set(t[3 * s], t[3 * s + 1], t[3 * s + 2]);
    const o = 1 / this.precission * 10, r = this.tempV1.distanceTo(this.tempV2) > o, l = this.tempV1.distanceTo(this.tempV3) > o, c = this.tempV2.distanceTo(this.tempV3) > o;
    return r && l && c;
  }
}
class aYe {
  constructor(t, i) {
    De(this, "edges", /* @__PURE__ */ new Map()), De(this, "openEdges", /* @__PURE__ */ new Set()), De(this, "id"), De(this, "plane"), this.id = t, this.plane = i;
  }
  add(t) {
    if (this.edges.size !== 0) for (const i of t) this.openEdges.has(i.hash) ? this.openEdges.delete(i.hash) : this.openEdges.add(i.hash), this.edges.set(i.hash, i);
    else for (const i of t) this.openEdges.add(i.hash), this.edges.set(i.hash, i);
  }
  match(t, i) {
    if (i.id !== this.plane.id) return !1;
    for (const n of t) if (this.openEdges.has(n.hash)) return !0;
    return !1;
  }
  getOpenEdges() {
    const t = [];
    for (const i of this.openEdges) t.push(this.edges.get(i));
    return t;
  }
  merge(t) {
    for (const [i, n] of t.edges) this.edges.set(i, n);
    for (const i of t.openEdges) this.openEdges.has(i) ? this.openEdges.delete(i) : this.openEdges.add(i);
  }
}
class uYe {
  constructor() {
    De(this, "list", /* @__PURE__ */ new Map()), De(this, "nextFaceID", 0);
  }
  add(t, i) {
    const n = this.match(t, i);
    if (n.length === 0) {
      const s = this.nextFaceID++, o = new aYe(s, i);
      return o.add(t), void this.list.set(o.id, o);
    }
    if (n.length !== 1) {
      if (n.length > 1) {
        const s = this.list.get(n[0]);
        s.add(t);
        for (let o = 1; o < n.length; o++) {
          const r = n[o], l = this.list.get(r);
          s.merge(l), this.list.delete(r);
        }
      }
    } else
      this.list.get(n[0]).add(t);
  }
  match(t, i) {
    let n = [];
    for (const s of this.list.values()) s.match(t, i) && n.push(s.id);
    return n;
  }
}
class kJ {
  constructor(t, i) {
    De(this, "p1"), De(this, "p2"), De(this, "hash"), this.p1 = t, this.p2 = i;
    const n = [this.p1, this.p2];
    n.sort(((s, o) => s.x - o.x || s.y - o.y || s.z - o.z)), this.hash = `${n[0].hash}_${n[1].hash}`;
  }
}
let dYe = class {
  constructor(e) {
    De(this, "closed", !1), De(this, "openStartPoint", null), De(this, "openEndPoint", null), De(this, "plane"), De(this, "orderedPoints", []), this.plane = e;
  }
  getEdges(e = !1) {
    const t = [];
    if (e) for (let i = this.orderedPoints.length - 1; i > 0; i--) t.push(new kJ(this.orderedPoints[i], this.orderedPoints[i - 1]));
    else for (let i = 0; i < this.orderedPoints.length - 1; i++) t.push(new kJ(this.orderedPoints[i], this.orderedPoints[i + 1]));
    return t;
  }
  getIndices() {
    return this.orderedPoints.map(((e) => e.id));
  }
  add(e) {
    if (this.orderedPoints.length === 0) return this.openStartPoint = e.p1.hash, this.openEndPoint = e.p2.hash, void this.orderedPoints.push(e.p1, e.p2);
    const t = this.match(e);
    if (t === 0) throw new Error("Fragments: Edge doesn't match with any open point");
    if (t > 2) throw new Error("Fragments: Edge matches with more than 2 open points");
    if (t === 2) return this.closed = !0, this.openEndPoint = null, void (this.openStartPoint = null);
    this.openStartPoint === e.p1.hash ? (this.orderedPoints.unshift(e.p2), this.openStartPoint = e.p2.hash) : this.openEndPoint === e.p1.hash ? (this.orderedPoints.push(e.p2), this.openEndPoint = e.p2.hash) : this.openStartPoint === e.p2.hash ? (this.orderedPoints.unshift(e.p1), this.openStartPoint = e.p1.hash) : this.openEndPoint === e.p2.hash && (this.orderedPoints.push(e.p1), this.openEndPoint = e.p1.hash);
  }
  match(e) {
    if (this.closed) return 0;
    let t = 0;
    return this.openStartPoint === e.p1.hash && t++, this.openStartPoint === e.p2.hash && t++, this.openEndPoint === e.p1.hash && t++, this.openEndPoint === e.p2.hash && t++, t;
  }
  merge(e) {
    if (e.closed || this.closed) throw new Error("Fragments: Cannot merge closed profiles");
    if (e.openStartPoint === this.openEndPoint && e.openEndPoint === this.openStartPoint) throw new Error("Fragments: Cannot merge profiles that close each other");
    if (e.openEndPoint === this.openEndPoint && e.openStartPoint === this.openStartPoint) throw new Error("Fragments: Cannot merge profiles that close each other");
    let t = !1;
    e.openEndPoint !== this.openStartPoint && e.openEndPoint !== this.openEndPoint || (t = !0);
    const i = e.getEdges(t);
    for (const n of i) this.add(n);
  }
  getArea() {
    const e = this.orderedPoints.map(((c) => [c.x, c.y, c.z]));
    let t = 0, i = 1;
    const n = Math.abs(this.plane.normal.x), s = Math.abs(this.plane.normal.y), o = Math.abs(this.plane.normal.z);
    n >= s && n >= o ? (t = 1, i = 2) : s >= n && s >= o ? (t = 0, i = 2) : (t = 0, i = 1);
    const r = [];
    for (const c of e) r.push(new us(c[t], c[i]));
    let l = 0;
    for (let c = 0, h = r.length; c < h; c++)
      l += r[c].x * r[c === r.length - 1 ? 0 : c + 1].y * 0.5, l -= r[c === r.length - 1 ? 0 : c + 1].x * r[c].y * 0.5;
    return Math.abs(l);
  }
};
class cYe {
  constructor(t) {
    De(this, "list", /* @__PURE__ */ new Map()), De(this, "plane"), De(this, "nextProfileID", 0), this.plane = t;
  }
  add(t) {
    const i = this.match(t);
    if (i.length === 0) {
      const n = this.nextProfileID++, s = new dYe(this.plane);
      return s.add(t), void this.list.set(n, s);
    }
    if (i.length !== 1) {
      if (i.length > 1) {
        const n = this.list.get(i[0]);
        n.add(t);
        const s = this.list.get(i[1]);
        n.merge(s), this.list.delete(i[1]);
      }
    } else
      this.list.get(i[0]).add(t);
  }
  getProfiles() {
    let t = null, i = 0;
    for (const [o, r] of this.list) {
      const l = r.getArea();
      l > i && (i = l, t = o);
    }
    if (t === null) return null;
    const n = this.list.get(t).getIndices(), s = [];
    for (const [o, r] of this.list) o !== t && s.push(r.getIndices());
    return { profile: n, holes: s };
  }
  match(t) {
    const i = [];
    for (const [n, s] of this.list) s.match(t) > 0 && i.push(n);
    return i;
  }
}
class hYe {
  constructor(t, i, n) {
    De(this, "normal"), De(this, "constant"), De(this, "id"), De(this, "faces", []);
    const s = _o.round(t.normal.x, n), o = _o.round(t.normal.y, n), r = _o.round(t.normal.z, n), l = _o.round(t.constant, i);
    this.normal = new Ge(s, o, r), this.constant = l;
    const c = "||";
    this.id = `${s}${c}${o}${c}${r}${c}${l}`;
  }
}
const kSe = class RIe {
  static round(t, i) {
    return Math.round(t * i) / i;
  }
  static getAABB(t) {
    let i = Number.POSITIVE_INFINITY, n = Number.POSITIVE_INFINITY, s = Number.POSITIVE_INFINITY, o = Number.NEGATIVE_INFINITY, r = Number.NEGATIVE_INFINITY, l = Number.NEGATIVE_INFINITY;
    for (let c = 0; c < t.length; c += 3) {
      const h = t[c], I = t[c + 1], p = t[c + 2];
      h < i && (i = h), I < n && (n = I), p < s && (s = p), h > o && (o = h), I > r && (r = I), p > l && (l = p);
    }
    return { min: { x: i, y: n, z: s }, max: { x: o, y: r, z: l } };
  }
  static transformFromMatrix(t, i = { position: [0, 0, 0], xDirection: [1, 0, 0], yDirection: [0, 1, 0] }) {
    const n = t.elements[12], s = t.elements[13], o = t.elements[14], r = t.elements[0], l = t.elements[1], c = t.elements[2], h = t.elements[4], I = t.elements[5], p = t.elements[6];
    return i.position[0] = n, i.position[1] = s, i.position[2] = o, i.xDirection[0] = r, i.xDirection[1] = l, i.xDirection[2] = c, i.yDirection[0] = h, i.yDirection[1] = I, i.yDirection[2] = p, i;
  }
  static matrixFromTransform(t) {
    const i = new Ln(), [n, s, o] = t.position, [r, l, c] = t.xDirection, [h, I, p] = t.yDirection, y = new Ge(r, l, c), m = new Ge(h, I, p), { x: A, y: C, z: O } = y.cross(m);
    return i.fromArray([r, l, c, 0, h, I, p, 0, A, C, O, 0, n, s, o, 1]), i;
  }
  static bboxFromCircleExtrusion(t) {
    const i = new Zs(), n = [];
    for (const s of t.axes) for (const o of s.wires) for (let r = 0; r < o.length - 2; r += 3) {
      const l = o[r], c = o[r + 1], h = o[r + 2];
      n.push(new Ge(l, c, h));
    }
    return i.setFromPoints(n), [i.min.x, i.min.y, i.min.z, i.max.x, i.max.y, i.max.z];
  }
  static representationFromGeometry(t, i = { bbox: [0, 0, 0, 0, 0, 0], representationClass: Mr.SHELL, geometry: { points: [], type: F0.NONE, profiles: /* @__PURE__ */ new Map(), holes: /* @__PURE__ */ new Map(), bigHoles: /* @__PURE__ */ new Map(), bigProfiles: /* @__PURE__ */ new Map(), profilesFaceIds: [] } }, n = { threshold: 3e3, precision: 1e6, normalPrecision: 1e7, planePrecision: 1e3, faceThreshold: 0.6, forceTransparentSpaces: !0 }) {
    const s = t.getAttribute("position").array, o = t.getAttribute("normal").array, r = t.index.array, l = RIe.getShellData({ position: s, normals: o, index: r, raw: !1, settings: n }), { min: c, max: h } = l.bbox;
    if (i.bbox = [c.x, c.y, c.z, h.x, h.y, h.z], i.representationClass === Mr.CIRCLE_EXTRUSION) throw new Error("Circle extrusions can't be represented as shells");
    const I = i.geometry, p = l.points, y = p.length > RIe.ushortMaxValue;
    return I.type = y ? F0.BIG : F0.NONE, I.points = p, I.profilesFaceIds = l.profilesFaceIds, y ? (I.profiles = /* @__PURE__ */ new Map(), I.holes = /* @__PURE__ */ new Map(), I.bigHoles = l.holes, I.bigProfiles = l.profiles) : (I.profiles = l.profiles, I.holes = l.holes, I.bigHoles = /* @__PURE__ */ new Map(), I.bigProfiles = /* @__PURE__ */ new Map()), i;
  }
  static getRawShellData(t, i, n, s, o) {
    var r;
    const l = /* @__PURE__ */ new Map(), c = /* @__PURE__ */ new Map(), h = (y, m, A) => {
      const C = `${y},${m},${A}`;
      if (l.has(C)) return l.get(C)[0];
      const O = l.size;
      return l.set(C, [O, y, m, A]), O;
    };
    for (let y = 0; y < t.length - 2; y += 3) {
      const m = t[y], A = t[y + 1], C = t[y + 2], O = i[3 * m], R = i[3 * m + 1], F = i[3 * m + 2], L = i[3 * A], P = i[3 * A + 1], z = i[3 * A + 2], W = i[3 * C], re = i[3 * C + 1], ce = i[3 * C + 2], te = h(O, R, F), ee = h(L, P, z), Ne = h(W, re, ce);
      c.set(c.size, [te, ee, Ne]);
    }
    const I = [];
    for (const [, [, y, m, A]] of l) I.push([y, m, A]);
    const p = { bbox: n, type: Mr.SHELL, profiles: c, holes: /* @__PURE__ */ new Map(), points: I, profilesFaceIds: [] };
    if (o && ((r = s.categoryFaceThresholds) != null && r.has(o))) this.computeShellFaceIds(p, s, o);
    else for (let y = 0; y < c.size; y++) p.profilesFaceIds.push(0);
    return p;
  }
  static getShellData(t) {
    const { position: i, normals: n, index: s, raw: o, settings: r, category: l } = t, { threshold: c, precision: h, normalPrecision: I, planePrecision: p } = r, y = i.length / 3 > c, m = this.getAABB(i);
    if (m.min.x === 0 && m.min.y === 0 && m.min.z === 0 && m.max.x === 0 && m.max.y === 0 && m.max.z === 0) throw new Error("Fragments: Bbox is not valid");
    if (o || y) return this.getRawShellData(s, i, m, r, l);
    const A = new tl(), C = new Ge(), O = new Ge(), R = /* @__PURE__ */ new Map();
    for (let Ae = 0; Ae < s.length - 2; Ae += 3) {
      const Oe = s[Ae];
      C.set(n[3 * Oe], n[3 * Oe + 1], n[3 * Oe + 2]), O.set(i[3 * Oe], i[3 * Oe + 1], i[3 * Oe + 2]), A.setFromNormalAndCoplanarPoint(C, O);
      const pe = new hYe(A, p, I);
      R.has(pe.id) || R.set(pe.id, pe), R.get(pe.id).faces.push(Ae);
    }
    const F = new lYe(h), L = new uYe();
    for (const [, Ae] of R) for (const Oe of Ae.faces) {
      const pe = s[Oe], je = s[Oe + 1], Ve = s[Oe + 2];
      if (!F.isValidTriangle(i, pe, je, Ve)) continue;
      const $e = F.create(i, pe), vt = F.create(i, je), Rt = F.create(i, Ve), ze = [new kJ($e, vt), new kJ(vt, Rt), new kJ(Rt, $e)];
      L.add(ze, Ae);
    }
    const P = /* @__PURE__ */ new Map(), z = /* @__PURE__ */ new Map();
    let W = 0;
    for (const [, Ae] of L.list) {
      const Oe = new cYe(Ae.plane), pe = Ae.getOpenEdges();
      if (pe.length === 0) return this.getRawShellData(s, i, m, r, l);
      for (const Ve of pe) Oe.add(Ve);
      const je = Oe.getProfiles();
      P.set(W, (je == null ? void 0 : je.profile) || []), z.set(W, (je == null ? void 0 : je.holes) || []), W++;
    }
    let re = 0;
    const ce = /* @__PURE__ */ new Map(), te = /* @__PURE__ */ new Map();
    for (const [Ae, Oe] of P) Oe.length && (ce.set(Ae, re), te.set(re, Oe), re++);
    const ee = /* @__PURE__ */ new Map();
    for (const [Ae, Oe] of z) if (Oe.length) {
      const pe = ce.get(Ae);
      ee.set(pe, Oe);
    }
    const Ne = { bbox: m, type: Mr.SHELL, profiles: te, holes: ee, points: F.get(), profilesFaceIds: [] };
    return this.computeShellFaceIds(Ne, r, l), Ne;
  }
  static computeShellFaceIds(t, i, n) {
    var s;
    let o = i.faceThreshold;
    n && ((s = i.categoryFaceThresholds) != null && s.has(n)) && (o = i.categoryFaceThresholds.get(n));
    const r = /* @__PURE__ */ new Map();
    let l = 0;
    const c = /* @__PURE__ */ new Map(), h = /* @__PURE__ */ new Map(), I = /* @__PURE__ */ new Map(), p = new Ge(), y = new Ge(), m = new Ge(), A = new Ge(), C = new wc(), O = t.profiles.size;
    for (let F = 0; F < O; F++) {
      const L = t.profiles.get(F), P = L.length;
      for (let ce = 0; ce < P; ce++) {
        const te = L[ce], ee = ce === P - 1 ? L[0] : L[ce + 1], Ne = Math.min(te, ee), Ae = Math.max(te, ee), Oe = Ne + this.makeDecimal(Ae);
        h.has(F) ? h.get(F).push(Oe) : h.set(F, [Oe]), c.has(Oe) ? c.get(Oe).push(F) : c.set(Oe, [F]);
      }
      let z = 0, W = 1, re = 2;
      for (; re < P; ) {
        const ce = L[z], te = L[W], ee = L[re];
        if (p.set(t.points[ce][0], t.points[ce][1], t.points[ce][2]), y.set(t.points[te][0], t.points[te][1], t.points[te][2]), m.set(t.points[ee][0], t.points[ee][1], t.points[ee][2]), C.set(p, y, m), C.getNormal(A), A.x !== 0 || A.y !== 0 || A.z !== 0) break;
        z++, W++, re++;
      }
      I.set(F, [A.x, A.y, A.z]);
    }
    for (const [F, L] of h) {
      let P = r.get(F);
      P === void 0 && (P = l++, r.set(F, P));
      const [z, W, re] = I.get(F);
      for (const ce of L) {
        const te = c.get(ce);
        for (const ee of te) {
          if (ee === F) continue;
          const [Ne, Ae, Oe] = I.get(ee), pe = Math.abs(z * Ne + W * Ae + re * Oe) < o;
          if (r.has(ee)) {
            if (!pe) {
              const je = r.get(ee);
              for (const [Ve, $e] of r) $e === je && r.set(Ve, P);
            }
          } else {
            const je = pe ? l++ : P;
            r.set(ee, je);
          }
        }
      }
    }
    for (let F = 0; F < t.profiles.size; F++) if (!r.has(F)) throw new Error(`Face id not found for profile ${F}`);
    const R = Array.from(r.keys()).sort(((F, L) => F - L));
    for (const F of R) {
      const L = r.get(F);
      t.profilesFaceIds.push(L);
    }
  }
  static makeDecimal(t) {
    let i = 1;
    for (; i <= t; ) i *= 10;
    return t / i;
  }
};
De(kSe, "ushortMaxValue", 65e3);
let _o = kSe;
class vIe {
  static getAbsolutePlacement(t, i, n = this.getUnitsFactor(t)) {
    const s = i.ObjectPlacement.value, o = t.GetLine(0, s), r = new Ln();
    r.identity(), this.getAbsolutePlacementRecursively(t, o, r, n);
    const l = new Ln();
    return l.makeRotationX(-Math.PI / 2), r.premultiply(l), r;
  }
  static getUnitsFactor(t) {
    var i, n, s, o;
    const r = t.GetLineIDsWithType(0, fme);
    let l = 1;
    if (r.size() === 0) return l;
    for (let c = 0; c < r.size(); c++) {
      const h = r.get(c), I = t.GetLine(0, h);
      for (const p of I.Units) {
        const y = t.GetLine(0, p.value);
        if (((i = y.UnitType) == null ? void 0 : i.value) !== "LENGTHUNIT") continue;
        let m = 1, A = 1;
        y.Name.value === "METRE" && (A = 1), y.Name.value === "FOOT" && (A = 0.3048), ((n = y.Prefix) == null ? void 0 : n.value) === "MILLI" ? m = 1e-3 : ((s = y.Prefix) == null ? void 0 : s.value) === "CENTI" ? m = 0.01 : ((o = y.Prefix) == null ? void 0 : o.value) === "DECI" && (m = 0.1), l = A * m;
      }
    }
    return l;
  }
  static getAbsolutePlacementRecursively(t, i, n, s) {
    const o = i.RelativePlacement.value, r = t.GetLine(0, o), l = r.Location.value, c = r.Axis, h = r.RefDirection, I = new Ge(0, 0, 0), p = new Ge(0, 0, 1), y = new Ge(1, 0, 0), m = t.GetLine(0, l);
    if (m) {
      const [F, L, P] = m.Coordinates;
      I.x = F.value * s, I.y = L.value * s, I.z = P.value * s;
    }
    if (c) {
      const F = t.GetLine(0, c.value), [L, P, z] = F.DirectionRatios;
      p.x = L.value, p.y = P.value, p.z = z.value;
    }
    if (h) {
      const F = t.GetLine(0, h.value), [L, P, z] = F.DirectionRatios;
      y.x = L.value, y.y = P.value, y.z = z.value;
    }
    const A = p.clone().cross(y), C = new Ln();
    if (C.fromArray([y.x, y.y, y.z, 0, A.x, A.y, A.z, 0, p.x, p.y, p.z, 0, I.x, I.y, I.z, 1]), n.premultiply(C), !i.PlacementRelTo || !i.PlacementRelTo.value) return;
    const O = i.PlacementRelTo.value, R = t.GetLine(0, O);
    this.getAbsolutePlacementRecursively(t, R, n, s);
  }
}
const fYe = /* @__PURE__ */ new Set([yA, xW, MP, PP, Nie, t8, TA, YO, wA, x5, v8, c8, Ug, kg, Vg, a8, Die, Zae, Kae, a8, $ae, N5, JAe, R8, pA, jg, gH, Dae, Qe, zg, zW, wie, BW, dE, SA, DA, m8, p8, IA, Bg, i3, ah, hL, T8, c0, $O, Pg, Fg, oA, aA, dA, QP, BW, dE, vie, UN, I8, n8, AA, e8, fL, Mg, bA, d8, f8, _5, cA, fue, cue, mN, f5, wN, bie, RA, r8, _5, Sg, rA, gA, EA, o8, s8, mA, Wg, w8, LP, pue, h5, Sie, fL, Aie, dSe, E8, Lie, zW, Lae, fA, i8, gN, hue, pN, Rie, y8, CA, hA, I5, NA, Tie, XP, JP, EH, eA, IN, xP, EN, z2, UP, ZP, vA, tme, x5, uA, Oae, hL, _P, h8, _g, ZAe, u8, Cie, l8]), IYe = /* @__PURE__ */ new Map([[di, { forRelating: "HasSurfaceFeatures", forRelated: "AdheresToElement" }], [Yt, { forRelating: "Positions", forRelated: "PositionedRelativeTo" }], [SJ, { forRelating: "AssociatedTo", forRelated: "HasAssociations" }], [Og, { forRelating: "BoundedBy", forRelated: "ProvidesBoundaries" }], [xg, { forRelating: "BoundedBy", forRelated: "ProvidesBoundaries" }], [Ce, { forRelating: "InterferesElements", forRelated: "IsInterferedByElements" }], [Zr, { forRelating: "Defines", forRelated: "IsDefinedBy" }], [le, { forRelating: "Declares", forRelated: "IsDeclaredBy" }], [me, { forRelating: "Declares", forRelated: "HasContext" }], [yN, { forRelating: "IsGroupedBy", forRelated: "HasAssignments" }], [lB, { forRelating: "Controls", forRelated: "HasAssignments" }], [U, { forRelating: "IsDecomposedBy", forRelated: "Decomposes" }], [ot, { forRelating: "HasOpenings", forRelated: "VoidsElements" }], [at, { forRelating: "BoundedBy", forRelated: "ProvidesBoundaries" }], [ns, { forRelating: "ServicesBuildings", forRelated: "ServicedBySystems" }], [tr, { forRelating: "IsPredecessorTo", forRelated: "IsSuccessorFrom" }], [rz, { forRelating: "ReferencedBy", forRelated: "HasAssignments" }], [We, { forRelating: "ReferencesElements", forRelated: "ReferencedInStructures" }], [lt, { forRelating: "HasProjections", forRelated: "ProjectsElements" }], [lz, { forRelating: "DefinesOccurrence", forRelated: "IsDefinedBy" }], [az, { forRelating: "IsActingUpon", forRelated: "HasAssignments" }], [B, { forRelating: "IsNestedBy", forRelated: "Nests" }], [GF, { forRelating: "HasInteractionReqsTo", forRelated: "HasInteractionReqsFrom" }], [ri, { forRelating: "HasControlElements", forRelated: "AssignedToFlowElement" }], [ut, { forRelating: "HasFillings", forRelated: "FillsVoids" }], [fe, { forRelating: "Types", forRelated: "IsTypedBy" }], [Fe, { forRelating: "DefinesOccurrence", forRelated: "IsDefinedBy" }], [Ni, { forRelating: "DefinesOccurrence", forRelated: "IsDefinedBy" }], [Ye, { forRelating: "IsDecomposedBy", forRelated: "Decomposes" }], [Jp, { forRelating: "HasCoverings", forRelated: "CoversSpaces" }], [dt, { forRelating: "HasCoverings", forRelated: "CoversElements" }], [Xe, { forRelating: "ContainsElements", forRelated: "ContainedInStructure" }], [ct, { forRelating: "ConnectedTo", forRelated: "ConnectedFrom" }], [Hg, { forRelating: "ConnectedBy", forRelated: "ConnectsStructuralMembers" }], [Ko, { forRelating: "ConnectedBy", forRelated: "ConnectsStructuralMembers" }], [Hn, { forRelating: "HasStructuralMember", forRelated: "ReferencesElement" }], [Un, { forRelating: "AssignedStructuralActivity", forRelated: "AssignedToStructuralItem" }], [Ad, { forRelating: "ConnectedTo", forRelated: "ConnectedFrom" }], [Vt, { forRelating: "ContainedIn", forRelated: "HasPorts" }], [Gg, { forRelating: "ConnectedTo", forRelated: "ConnectedFrom" }], [Te, { forRelating: "ConnectedTo", forRelated: "ConnectedFrom" }], [KP, { forRelating: "ConnectedTo", forRelated: "ConnectedFrom" }], [bJ, { forRelating: "AssociatedTo", forRelated: "HasAssociations" }], [So, { forRelating: "AssociatedTo", forRelated: "HasAssociations" }], [oE, { forRelating: "LibraryInfoForObjects", forRelated: "HasAssociations" }], [rE, { forRelating: "DocumentInfoForObjects", forRelated: "DocumentRefForObjects" }], [lA, { forRelating: "AssociatedTo", forRelated: "HasAssociations" }], [lE, { forRelating: "HasReferences", forRelated: "ClassificationRefForObjects" }], [T4, { forRelating: "ApprovedObjects", forRelated: "HasAssociations" }], [NJ, { forRelating: "AssociatedTo", forRelated: "HasAssociations" }], [X, { forRelating: "AssociatedTo", forRelated: "HasAssociations" }], [Ns, { forRelating: "ResourceOf", forRelated: "HasAssignments" }], [uz, { forRelating: "ReferencedBy", forRelated: "HasAssignments" }], [ge, { forRelating: "ReferencedBy", forRelated: "HasAssignments" }], [Xr, { forRelating: "OperatesOn", forRelated: "HasAssignments" }], [Vs, { forRelating: "IsGroupedBy", forRelated: "HasAssignments" }], [bs, { forRelating: "Controls", forRelated: "HasAssignments" }], [Xp, { forRelating: "IsActingUpon", forRelated: "HasAssignments" }], [ie, { forRelating: "ReferencedBy", forRelated: "HasAssignments" }]]), WW = 65536;
var tE = ((e) => (e[e.LINE = 0] = "LINE", e[e.SHELL = 1] = "SHELL", e))(tE || {}), tc = ((e) => (e[e.UPDATE = 0] = "UPDATE", e[e.CREATE = 1] = "CREATE", e[e.DELETE = 2] = "DELETE", e[e.FINISH = 3] = "FINISH", e))(tc || {}), Bo = ((e) => (e[e.GEOMETRY = 0] = "GEOMETRY", e[e.WIRES = 1] = "WIRES", e[e.INVISIBLE = 2] = "INVISIBLE", e))(Bo || {}), LA = ((e) => (e[e.CREATE_MODEL = 0] = "CREATE_MODEL", e[e.DELETE_MODEL = 1] = "DELETE_MODEL", e[e.EXECUTE = 2] = "EXECUTE", e[e.RAYCAST = 3] = "RAYCAST", e[e.FETCH_BOXES = 4] = "FETCH_BOXES", e[e.REFRESH_VIEW = 5] = "REFRESH_VIEW", e[e.RECOMPUTE_MESHES = 6] = "RECOMPUTE_MESHES", e[e.CREATE_MATERIAL = 7] = "CREATE_MATERIAL", e[e.THROW_ERROR = 8] = "THROW_ERROR", e))(LA || {}), AIe = ((e) => (e[e.VISIBLE = 0] = "VISIBLE", e))(AIe || {}), k_ = ((e) => (e[e.POINT = 0] = "POINT", e[e.LINE = 1] = "LINE", e[e.FACE = 2] = "FACE", e))(k_ || {});
const pYe = "ThatOpenAlignment", mYe = "ThatOpenGrid";
var aN = ((e) => (e[e.NONE = 0] = "NONE", e[e.LINES = 1] = "LINES", e[e.CLOTHOID = 2] = "CLOTHOID", e[e.ELLIPSE_ARC = 3] = "ELLIPSE_ARC", e[e.PARABOLA = 4] = "PARABOLA", e))(aN || {}), Tre = ((e) => (e[e.DEFAULT = 0] = "DEFAULT", e[e.ALL_VISIBLE = 1] = "ALL_VISIBLE", e[e.ALL_GEOMETRY = 2] = "ALL_GEOMETRY", e))(Tre || {});
class MX {
  static containedInParallelPlanes(t, i) {
    let n = !0;
    for (const s of t) {
      const o = s.distanceToPoint(i);
      n = n && o >= 0;
    }
    return n;
  }
  static collides(t, i, n) {
    for (const s of i)
      if (this.getPointDistance(s, n, t) < 0) return !1;
    return !0;
  }
  static getPointDistance(t, i, n) {
    const s = t.normal;
    for (const o of this.dimensions) {
      const r = s[o] >= 0 !== i;
      this.tempPoint[o] = r ? n.max[o] : n.min[o];
    }
    return t.distanceToPoint(this.tempPoint);
  }
}
De(MX, "tempPoint", new Ge()), De(MX, "dimensions", ["x", "y", "z"]);
class VF {
  static transform(t, i, n = new cL()) {
    for (let s = 0; s < n.planes.length; s++) {
      const o = n.planes[s], r = t.planes[s];
      o.copy(r), o.applyMatrix4(i);
    }
    return n;
  }
  static isIncluded(t, i) {
    return MX.collides(t, i, !0);
  }
  static collides(t, i) {
    return MX.collides(t, i, !1);
  }
}
function yYe(e, t, i = 2) {
  const n = t && t.length, s = n ? t[0] * i : e.length;
  let o = bwe(e, 0, s, i, !0);
  const r = [];
  if (!o || o.next === o.prev) return r;
  let l, c, h;
  if (n && (o = (function(I, p, y, m) {
    const A = [];
    for (let C = 0, O = p.length; C < O; C++) {
      const R = bwe(I, p[C] * m, C < O - 1 ? p[C + 1] * m : I.length, m, !1);
      R === R.next && (R.steiner = !0), A.push(SYe(R));
    }
    A.sort(RYe);
    for (let C = 0; C < A.length; C++) y = vYe(A[C], y);
    return y;
  })(e, t, o, i)), e.length > 80 * i) {
    l = 1 / 0, c = 1 / 0;
    let I = -1 / 0, p = -1 / 0;
    for (let y = i; y < s; y += i) {
      const m = e[y], A = e[y + 1];
      m < l && (l = m), A < c && (c = A), m > I && (I = m), A > p && (p = A);
    }
    h = Math.max(I - l, p - c), h = h !== 0 ? 32767 / h : 0;
  }
  return UX(o, r, i, l, c, h, 0), r;
}
function bwe(e, t, i, n, s) {
  let o;
  if (s === (function(r, l, c, h) {
    let I = 0;
    for (let p = l, y = c - h; p < c; p += h) I += (r[y] - r[p]) * (r[p + 1] + r[y + 1]), y = p;
    return I;
  })(e, t, i, n) > 0) for (let r = t; r < i; r += n) o = Nwe(r / n | 0, e[r], e[r + 1], o);
  else for (let r = i - n; r >= t; r -= n) o = Nwe(r / n | 0, e[r], e[r + 1], o);
  return o && YW(o, o.next) && (FX(o), o = o.next), o;
}
function bH(e, t) {
  if (!e) return e;
  t || (t = e);
  let i, n = e;
  do
    if (i = !1, n.steiner || !YW(n, n.next) && Rd(n.prev, n, n.next) !== 0) n = n.next;
    else {
      if (FX(n), n = t = n.prev, n === n.next) break;
      i = !0;
    }
  while (i || n !== t);
  return t;
}
function UX(e, t, i, n, s, o, r) {
  if (!e) return;
  !r && o && (function(c, h, I, p) {
    let y = c;
    do
      y.z === 0 && (y.z = SIe(y.x, y.y, h, I, p)), y.prevZ = y.prev, y.nextZ = y.next, y = y.next;
    while (y !== c);
    y.prevZ.nextZ = null, y.prevZ = null, (function(m) {
      let A, C = 1;
      do {
        let O, R = m;
        m = null;
        let F = null;
        for (A = 0; R; ) {
          A++;
          let L = R, P = 0;
          for (let W = 0; W < C && (P++, L = L.nextZ, L); W++) ;
          let z = C;
          for (; P > 0 || z > 0 && L; ) P !== 0 && (z === 0 || !L || R.z <= L.z) ? (O = R, R = R.nextZ, P--) : (O = L, L = L.nextZ, z--), F ? F.nextZ = O : m = O, O.prevZ = F, F = O;
          R = L;
        }
        F.nextZ = null, C *= 2;
      } while (A > 1);
    })(y);
  })(e, n, s, o);
  let l = e;
  for (; e.prev !== e.next; ) {
    const c = e.prev, h = e.next;
    if (o ? gYe(e, n, s, o) : EYe(e)) t.push(c.i, e.i, h.i), FX(e), e = h.next, l = h.next;
    else if ((e = h) === l) {
      r ? r === 1 ? UX(e = wYe(bH(e), t), t, i, n, s, o, 2) : r === 2 && TYe(e, t, i, n, s, o) : UX(bH(e), t, i, n, s, o, 1);
      break;
    }
  }
}
function EYe(e) {
  const t = e.prev, i = e, n = e.next;
  if (Rd(t, i, n) >= 0) return !1;
  const s = t.x, o = i.x, r = n.x, l = t.y, c = i.y, h = n.y, I = Math.min(s, o, r), p = Math.min(l, c, h), y = Math.max(s, o, r), m = Math.max(l, c, h);
  let A = n.next;
  for (; A !== t; ) {
    if (A.x >= I && A.x <= y && A.y >= p && A.y <= m && dJ(s, l, o, c, r, h, A.x, A.y) && Rd(A.prev, A, A.next) >= 0) return !1;
    A = A.next;
  }
  return !0;
}
function gYe(e, t, i, n) {
  const s = e.prev, o = e, r = e.next;
  if (Rd(s, o, r) >= 0) return !1;
  const l = s.x, c = o.x, h = r.x, I = s.y, p = o.y, y = r.y, m = Math.min(l, c, h), A = Math.min(I, p, y), C = Math.max(l, c, h), O = Math.max(I, p, y), R = SIe(m, A, t, i, n), F = SIe(C, O, t, i, n);
  let L = e.prevZ, P = e.nextZ;
  for (; L && L.z >= R && P && P.z <= F; ) {
    if (L.x >= m && L.x <= C && L.y >= A && L.y <= O && L !== s && L !== r && dJ(l, I, c, p, h, y, L.x, L.y) && Rd(L.prev, L, L.next) >= 0 || (L = L.prevZ, P.x >= m && P.x <= C && P.y >= A && P.y <= O && P !== s && P !== r && dJ(l, I, c, p, h, y, P.x, P.y) && Rd(P.prev, P, P.next) >= 0)) return !1;
    P = P.nextZ;
  }
  for (; L && L.z >= R; ) {
    if (L.x >= m && L.x <= C && L.y >= A && L.y <= O && L !== s && L !== r && dJ(l, I, c, p, h, y, L.x, L.y) && Rd(L.prev, L, L.next) >= 0) return !1;
    L = L.prevZ;
  }
  for (; P && P.z <= F; ) {
    if (P.x >= m && P.x <= C && P.y >= A && P.y <= O && P !== s && P !== r && dJ(l, I, c, p, h, y, P.x, P.y) && Rd(P.prev, P, P.next) >= 0) return !1;
    P = P.nextZ;
  }
  return !0;
}
function wYe(e, t) {
  let i = e;
  do {
    const n = i.prev, s = i.next.next;
    !YW(n, s) && zSe(n, i, i.next, s) && BX(n, s) && BX(s, n) && (t.push(n.i, i.i, s.i), FX(i), FX(i.next), i = e = s), i = i.next;
  } while (i !== e);
  return bH(i);
}
function TYe(e, t, i, n, s, o) {
  let r = e;
  do {
    let l = r.next.next;
    for (; l !== r.prev; ) {
      if (r.i !== l.i && bYe(r, l)) {
        let c = jSe(r, l);
        return r = bH(r, r.next), c = bH(c, c.next), UX(r, t, i, n, s, o, 0), void UX(c, t, i, n, s, o, 0);
      }
      l = l.next;
    }
    r = r.next;
  } while (r !== e);
}
function RYe(e, t) {
  let i = e.x - t.x;
  return i === 0 && (i = e.y - t.y, i === 0) && (i = (e.next.y - e.y) / (e.next.x - e.x) - (t.next.y - t.y) / (t.next.x - t.x)), i;
}
function vYe(e, t) {
  const i = (function(s, o) {
    let r = o;
    const l = s.x, c = s.y;
    let h, I = -1 / 0;
    if (YW(s, r)) return r;
    do {
      if (YW(s, r.next)) return r.next;
      if (c <= r.y && c >= r.next.y && r.next.y !== r.y) {
        const C = r.x + (c - r.y) * (r.next.x - r.x) / (r.next.y - r.y);
        if (C <= l && C > I && (I = C, h = r.x < r.next.x ? r : r.next, C === l)) return h;
      }
      r = r.next;
    } while (r !== o);
    if (!h) return null;
    const p = h, y = h.x, m = h.y;
    let A = 1 / 0;
    r = h;
    do {
      if (l >= r.x && r.x >= y && l !== r.x && VSe(c < m ? l : I, c, y, m, c < m ? I : l, c, r.x, r.y)) {
        const C = Math.abs(c - r.y) / (l - r.x);
        BX(r, s) && (C < A || C === A && (r.x > h.x || r.x === h.x && AYe(h, r))) && (h = r, A = C);
      }
      r = r.next;
    } while (r !== p);
    return h;
  })(e, t);
  if (!i) return t;
  const n = jSe(i, e);
  return bH(n, n.next), bH(i, i.next);
}
function AYe(e, t) {
  return Rd(e.prev, e, t.prev) < 0 && Rd(t.next, e, e.next) < 0;
}
function SIe(e, t, i, n, s) {
  return (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = (e - i) * s | 0) | e << 8)) | e << 4)) | e << 2)) | e << 1)) | (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = (t - n) * s | 0) | t << 8)) | t << 4)) | t << 2)) | t << 1)) << 1;
}
function SYe(e) {
  let t = e, i = e;
  do
    (t.x < i.x || t.x === i.x && t.y < i.y) && (i = t), t = t.next;
  while (t !== e);
  return i;
}
function VSe(e, t, i, n, s, o, r, l) {
  return (s - r) * (t - l) >= (e - r) * (o - l) && (e - r) * (n - l) >= (i - r) * (t - l) && (i - r) * (o - l) >= (s - r) * (n - l);
}
function dJ(e, t, i, n, s, o, r, l) {
  return !(e === r && t === l) && VSe(e, t, i, n, s, o, r, l);
}
function bYe(e, t) {
  return e.next.i !== t.i && e.prev.i !== t.i && !(function(i, n) {
    let s = i;
    do {
      if (s.i !== i.i && s.next.i !== i.i && s.i !== n.i && s.next.i !== n.i && zSe(s, s.next, i, n)) return !0;
      s = s.next;
    } while (s !== i);
    return !1;
  })(e, t) && (BX(e, t) && BX(t, e) && (function(i, n) {
    let s = i, o = !1;
    const r = (i.x + n.x) / 2, l = (i.y + n.y) / 2;
    do
      s.y > l != s.next.y > l && s.next.y !== s.y && r < (s.next.x - s.x) * (l - s.y) / (s.next.y - s.y) + s.x && (o = !o), s = s.next;
    while (s !== i);
    return o;
  })(e, t) && (Rd(e.prev, e, t.prev) || Rd(e, t.prev, t)) || YW(e, t) && Rd(e.prev, e, e.next) > 0 && Rd(t.prev, t, t.next) > 0);
}
function Rd(e, t, i) {
  return (t.y - e.y) * (i.x - t.x) - (t.x - e.x) * (i.y - t.y);
}
function YW(e, t) {
  return e.x === t.x && e.y === t.y;
}
function zSe(e, t, i, n) {
  const s = dse(Rd(e, t, i)), o = dse(Rd(e, t, n)), r = dse(Rd(i, n, e)), l = dse(Rd(i, n, t));
  return s !== o && r !== l || !(s !== 0 || !use(e, i, t)) || !(o !== 0 || !use(e, n, t)) || !(r !== 0 || !use(i, e, n)) || !(l !== 0 || !use(i, t, n));
}
function use(e, t, i) {
  return t.x <= Math.max(e.x, i.x) && t.x >= Math.min(e.x, i.x) && t.y <= Math.max(e.y, i.y) && t.y >= Math.min(e.y, i.y);
}
function dse(e) {
  return e > 0 ? 1 : e < 0 ? -1 : 0;
}
function BX(e, t) {
  return Rd(e.prev, e, e.next) < 0 ? Rd(e, t, e.next) >= 0 && Rd(e, e.prev, t) >= 0 : Rd(e, t, e.prev) < 0 || Rd(e, e.next, t) < 0;
}
function jSe(e, t) {
  const i = bIe(e.i, e.x, e.y), n = bIe(t.i, t.x, t.y), s = e.next, o = t.prev;
  return e.next = t, t.prev = e, i.next = s, s.prev = i, n.next = i, i.prev = n, o.next = n, n.prev = o, n;
}
function Nwe(e, t, i, n) {
  const s = bIe(e, t, i);
  return n ? (s.next = n.next, s.prev = n, n.next.prev = s, n.next = s) : (s.prev = s, s.next = s), s;
}
function FX(e) {
  e.next.prev = e.prev, e.prev.next = e.next, e.prevZ && (e.prevZ.nextZ = e.nextZ), e.nextZ && (e.nextZ.prevZ = e.prevZ);
}
function bIe(e, t, i) {
  return { i: e, x: t, y: i, prev: null, next: null, z: 0, prevZ: null, nextZ: null, steiner: !1 };
}
class NYe {
  constructor() {
    De(this, "int"), De(this, "float"), De(this, "buffer"), De(this, "s1", 4), De(this, "s2", 8);
    const { intBuffer: t, floatBuffer: i, buffer: n } = this.newBuffers();
    this.int = t, this.float = i, this.buffer = n;
  }
  newBuffers() {
    const t = new Int32Array(1), i = t.buffer;
    return { intBuffer: t, floatBuffer: new Float32Array(i), buffer: new Uint8Array(i) };
  }
}
class NIe {
  static check(t) {
    const i = Number.isInteger(t), n = t < this._max, s = t > this._min;
    return i && n && s;
  }
}
De(NIe, "_max", 2147483647), De(NIe, "_min", -2147483648);
const WSe = class YSe {
  constructor() {
    De(this, "_core", new NYe()), De(this, "_handlers"), De(this, "_result", -1), De(this, "handleObject", ((t) => {
      const i = Object.keys(t);
      for (const n of i) t.hasOwnProperty(n) && this.compute(t[n]);
    })), De(this, "handleString", ((t) => {
      const i = t.length;
      for (let n = 0; n < i; ++n) {
        const s = t.codePointAt(n);
        this._core.int[0] = s, this.update();
      }
    })), De(this, "handleBoolean", ((t) => {
      this._core.int[0] = t ? 1 : 0, this.update();
    })), De(this, "handleNumber", ((t) => {
      (NIe.check(t) ? this._core.int : this._core.float)[0] = t, this.update();
    })), this._handlers = this.newHandlers();
  }
  get value() {
    return ~this._result;
  }
  fromMaterialData(t) {
    const { modelId: i, objectClass: n, currentLod: s, templateId: o, ...r } = t;
    this.reset(), this.compute(i), this.compute(n), this.compute(r), this.compute(s), this.compute(o !== void 0);
  }
  generate(t) {
    this.reset();
    for (const i of t) this.compute(i);
    return this.value;
  }
  compute(t) {
    return this.getHandler(t)(t), this;
  }
  reset() {
    return this._result = -1, this;
  }
  getHandler(t) {
    const i = typeof t, n = this._handlers[i];
    if (!n) throw new Error("Fragments: Unsupported input type");
    return n;
  }
  newHandlers() {
    return { number: this.handleNumber, boolean: this.handleBoolean, string: this.handleString, object: this.handleObject };
  }
  update() {
    for (let t = 0; t < this._core.s1; ++t) {
      this._result ^= this._core.buffer[t];
      for (let i = 0; i < this._core.s2; ++i) 1 & this._result ? this._result = this._result >> 1 ^ YSe._polynomial : this._result >>= 1;
    }
  }
};
De(WSe, "_polynomial", 2197175160);
let Cme = WSe;
const Rre = class vre {
  constructor(t, i) {
    De(this, "_first"), this._first = this.newData(t, i);
  }
  static getComplementary(t, i) {
    let n = 0;
    const s = t.position.length;
    n = this.makeBufferComplementary(s, t, n, i), n !== 1 / 0 && i(n, 1 / 0);
  }
  static get(t, i, n, s) {
    const { filtered: o, position: r, size: l } = this.getData(t, n);
    return this.setAllBufferData(o, i, r, l, s), { position: r, size: l };
  }
  fullOf(t) {
    const i = this._first.following, n = this._first.data;
    return i === null && n === t;
  }
  update(t, i) {
    const n = this.getBufferData(t);
    if (n.data !== i) {
      const { a: s, c: o, b: r } = this.newBuffers(t, n, i);
      this.setupInputData(n, s, o), this.setupUpdateBuffers(s, r, o);
    }
  }
  size(t) {
    let i = 0, n = this._first;
    for (; n !== null; )
      this.doesFilterPass(t, n) && i++, n = n.following;
    return i;
  }
  static setAllBufferData(t, i, n, s, o) {
    for (let r = 0; r < t.length; ++r) {
      const l = t[r];
      this.transform(l, i), this.setBuffers(n, s, r), o && o(r, l.data);
    }
  }
  static makeBufferComplementary(t, i, n, s) {
    for (let o = 0; o < t; ++o) {
      const r = this.getBuffers(i, o), { position: l, size: c } = r;
      l > n && s(n, l - n), n = l + c;
    }
    return n;
  }
  static setBuffers(t, i, n) {
    t[n] = this._tempData.position;
    const s = this._tempData.size === 1 / 0;
    i[n] = s ? this._inf : this._tempData.size;
  }
  add(t, i, n) {
    if (!vre._stash.length) return this.newData(i, n, t);
    const s = vre._stash.pop();
    if (!s) throw new Error("Fragments: No stash found");
    return s.position = t, s.size = i, s.data = n, s;
  }
  remove(t) {
    t && (t.following = null, t.past = null, vre._stash.push(t));
  }
  static getData(t, i) {
    const n = t.filter(i), s = n.length;
    return { filtered: n, position: new Uint32Array(s), size: new Uint32Array(s) };
  }
  filter(t) {
    const i = [];
    let n = this._first;
    for (; n !== null; )
      this.doesFilterPass(t, n) && i.push(n), n = n.following;
    return i;
  }
  static transform(t, i) {
    const n = this.getTempData(), s = t.position + t.size, o = s === i.length;
    if (n.position = i[t.position], o) n.size = 1 / 0;
    else {
      const r = i[s];
      n.size = r - n.position;
    }
    return n;
  }
  static getBuffers(t, i) {
    const n = t.position[i];
    let s;
    return s = t.size[i] === this._inf ? 1 / 0 : t.size[i], { position: n, size: s };
  }
  static getTempData() {
    return this._tempData ? this._tempData : { position: 0, size: 0 };
  }
  doesFilterPass(t, i) {
    return !t || t(i.data);
  }
  setupUpdateBuffers(t, i, n) {
    this.chainBuffers(t, i, n), this.setupFirstBuffer(t, i), this.setupLastBuffer(n, i), this.setupMiddleBufferStart(i), this.setupMiddleBufferEnd(i);
  }
  setupMiddleBufferEnd(t) {
    var i;
    if (((i = t.following) == null ? void 0 : i.data) === t.data) {
      if (!t.following) return;
      const n = t.following.size + t.size, s = t.following.following;
      t.size = n, this.remove(t.following), t.following = s, t.following && (t.following.past = t);
    }
  }
  setupFirstBuffer(t, i) {
    t.size || (t.past ? t.past.following = i : this._first = i, i.past = t.past, this.remove(t));
  }
  setupMiddleBufferStart(t) {
    var i;
    if (((i = t.past) == null ? void 0 : i.data) === t.data) {
      if (!t.past) return;
      t.size = t.past.size + t.size, t.position = t.past.position;
      const n = t.past.past;
      this.remove(t.past), t.past = n, t.past ? t.past.following = t : this._first = t;
    }
  }
  chainBuffers(t, i, n) {
    t.following = i, i.past = t, i.following = n, n.past = i;
  }
  setupLastBuffer(t, i) {
    t.size || (t.following && (t.following.past = i), i.following = t.following, this.remove(t));
  }
  newBuffers(t, i, n) {
    const s = t - i.position, o = this.add(i.position, s, i.data), r = this.add(t, 1, n), l = i.size - o.size - 1;
    return { a: o, c: this.add(t + 1, l, i.data), b: r };
  }
  setupInputData(t, i, n) {
    t.past ? (t.past.following = i, i.past = t.past) : this._first = i, t.following && (t.following.past = n, n.following = t.following), this.remove(t);
  }
  newData(t, i, n = 0) {
    return { position: n, size: t, past: null, following: null, data: i };
  }
  getBufferData(t) {
    let i = this._first;
    for (; ; ) {
      const n = i === null, s = i.position <= t, o = t < i.position + i.size;
      if (n || s && o) return i;
      i = i.following;
    }
  }
};
De(Rre, "_stash", []), De(Rre, "_tempData", { position: 0, size: 0 }), De(Rre, "_inf", 4294967295);
let cJ = Rre;
class Cv {
  static fixNumber(t) {
    return Number.isNaN(t) ? 0 : Number.isFinite(t) ? t : 0;
  }
  static forEach(t, i) {
    if (Array.isArray(t)) {
      let n = 0;
      for (const s of t) i(s, n++);
    } else i(t, 0);
  }
}
class qSe {
  static estimateCapacity() {
    const t = this.capacityFactor, i = window.screen.width, n = window.screen.height, s = window.devicePixelRatio;
    return Math.trunc(i * n * s * s * t);
  }
}
De(qSe, "capacityFactor", 200);
class Ece {
  static check(t, i, n) {
    const s = this.get(n);
    return !!(t[i] & s);
  }
  static apply(t, i, n, s) {
    const o = this.get(n);
    s ? t[i] |= o : t[i] &= ~o;
  }
  static checkMemory(t) {
    if (t > WW) throw new Error("Fragments: Memory overflow!");
  }
  static get(t) {
    return 1 << t;
  }
}
class _z {
  static parseMaterial(t) {
    const i = t.r() / 255, n = t.g() / 255, s = t.b() / 255, o = t.a() / 255, r = t.a() < 255;
    return { color: new Xn().setRGB(i, n, s, Hy), renderedFaces: t.renderedFaces(), opacity: o, transparent: r, localId: void 0 };
  }
  static parseBox(t, i) {
    this.getBox(t, i, "min"), this.getBox(t, i, "max");
  }
  static parseTransform(t, i) {
    return this.getVector(t, "position", this._doubleVector), this.getVector(t, "xDirection", this._floatVector), this.getVector(t, "yDirection", this._floatVector), this.computeZVector(), this.setTransform(i), i;
  }
  static setTransform(t) {
    const { x: i, y: n, z: s } = this._temp.xDirection, { x: o, y: r, z: l } = this._temp.yDirection, { x: c, y: h, z: I } = this._temp.zDirection, { x: p, y, z: m } = this._temp.position;
    t.set(i, o, c, p, n, r, h, y, s, l, I, m, 0, 0, 0, 1);
  }
  static getBox(t, i, n) {
    t[n](this._floatVector);
    const s = this._floatVector.x(), o = this._floatVector.y(), r = this._floatVector.z();
    i[n].x = Cv.fixNumber(s), i[n].y = Cv.fixNumber(o), i[n].z = Cv.fixNumber(r);
  }
  static getVector(t, i, n) {
    t[i](n);
    const s = this._temp[i], o = n.x(), r = n.y(), l = n.z();
    s.x = Cv.fixNumber(o), s.y = Cv.fixNumber(r), s.z = Cv.fixNumber(l);
  }
  static computeZVector() {
    this._temp.zDirection.crossVectors(this._temp.xDirection, this._temp.yDirection);
  }
}
De(_z, "_temp", { position: new Ge(), xDirection: new Ge(), yDirection: new Ge(), zDirection: new Ge() }), De(_z, "_doubleVector", new FSe()), De(_z, "_floatVector", new Rf());
const og = class {
  static get(e, t, i) {
    this.fetchSampleTransform(e, t), this.fetchItemTransform(e, t), i.multiplyMatrices(this._item, this._sample);
  }
  static getBox(e, t) {
    e.bbox(this._box), _z.parseBox(this._box, t);
  }
  static getBoxData(e) {
    this._min.copy(e.min), this._max.copy(e.max), this._center.addVectors(this._min, this._max), this._center.divideScalar(2), e.getSize(this._distance);
  }
  static boxSize(e) {
    return this.getBoxData(e), this.applyTransformer(), this._edge.start = this._min.clone(), this._edge.end = this._max.clone(), this._edge;
  }
  static applyTransformer() {
    const { x: e, y: t, z: i } = this._distance, n = Math.max(e, t, i);
    e === n ? this._transformers.x() : t === n ? this._transformers.y() : this._transformers.z();
  }
  static fetchItemTransform(e, t) {
    const i = e.item();
    t.globalTransforms(i, this._transform), _z.parseTransform(this._transform, this._item);
  }
  static fetchSampleTransform(e, t) {
    const i = e.localTransform();
    t.localTransforms(i, this._transform), _z.parseTransform(this._transform, this._sample);
  }
  static setBoxZ() {
    this._min.set(this._center.x, this._center.y, this._min.z), this._max.set(this._center.x, this._center.y, this._max.z);
  }
  static setBoxY() {
    this._min.set(this._center.x, this._min.y, this._center.z), this._max.set(this._center.x, this._max.y, this._center.z);
  }
  static setBoxX() {
    this._min.set(this._min.x, this._center.y, this._center.z), this._max.set(this._max.x, this._center.y, this._center.z);
  }
};
De(og, "_transform", new M5()), De(og, "_min", new Ge()), De(og, "_max", new Ge()), De(og, "_center", new Ge()), De(og, "_distance", new Ge()), De(og, "_edge", new gc()), De(og, "_item", new Ln()), De(og, "_sample", new Ln()), De(og, "_box", new BSe()), De(og, "_transformers", { x: () => og.setBoxX(), y: () => og.setBoxY(), z: () => og.setBoxZ() });
let pz = og;
class $Se {
  static getWidth(t) {
    return t.getSize(this._temp.vector), this._temp.vector.x > this._temp.vector.y && this._temp.vector.set(this._temp.vector.y, this._temp.vector.x, this._temp.vector.z), this._temp.vector.y > this._temp.vector.z && this._temp.vector.set(this._temp.vector.x, this._temp.vector.z, this._temp.vector.y), this._temp.vector.x > this._temp.vector.y && this._temp.vector.set(this._temp.vector.y, this._temp.vector.x, this._temp.vector.z), this._temp.vector.y;
  }
}
De($Se, "_temp", { vector: new Ge() });
class KSe {
  static getEarcutDimensions(t) {
    const i = Math.abs(t.x), n = Math.abs(t.y), s = Math.abs(t.z);
    return s > i && s > n ? t.z > 0 ? [0, 1] : [1, 0] : n > i && n > s ? t.y > 0 ? [2, 0] : [0, 2] : t.x > 0 ? [1, 2] : [2, 1];
  }
}
const Dwe = new Zs(), cse = new Ge();
class ZSe extends SAe {
  constructor() {
    super(), this.isLineSegmentsGeometry = !0, this.type = "LineSegmentsGeometry", this.setIndex([0, 2, 1, 2, 3, 1, 2, 4, 3, 4, 5, 3, 4, 6, 5, 6, 7, 5]), this.setAttribute("position", new al([-1, 2, 0, 1, 2, 0, -1, 1, 0, 1, 1, 0, -1, 0, 0, 1, 0, 0, -1, -1, 0, 1, -1, 0], 3)), this.setAttribute("uv", new al([-1, 2, 1, 2, -1, 1, 1, 1, -1, -1, 1, -1, -1, -2, 1, -2], 2));
  }
  applyMatrix4(t) {
    const i = this.attributes.instanceStart, n = this.attributes.instanceEnd;
    return i !== void 0 && (i.applyMatrix4(t), n.applyMatrix4(t), i.needsUpdate = !0), this.boundingBox !== null && this.computeBoundingBox(), this.boundingSphere !== null && this.computeBoundingSphere(), this;
  }
  setPositions(t) {
    let i;
    t instanceof Float32Array ? i = t : Array.isArray(t) && (i = new Float32Array(t));
    const n = new gle(i, 6, 1);
    return this.setAttribute("instanceStart", new fN(n, 3, 0)), this.setAttribute("instanceEnd", new fN(n, 3, 3)), this.instanceCount = this.attributes.instanceStart.count, this.computeBoundingBox(), this.computeBoundingSphere(), this;
  }
  setColors(t) {
    let i;
    t instanceof Float32Array ? i = t : Array.isArray(t) && (i = new Float32Array(t));
    const n = new gle(i, 6, 1);
    return this.setAttribute("instanceColorStart", new fN(n, 3, 0)), this.setAttribute("instanceColorEnd", new fN(n, 3, 3)), this;
  }
  fromWireframeGeometry(t) {
    return this.setPositions(t.attributes.position.array), this;
  }
  fromEdgesGeometry(t) {
    return this.setPositions(t.attributes.position.array), this;
  }
  fromMesh(t) {
    return this.fromWireframeGeometry(new TUe(t.geometry)), this;
  }
  fromLineSegments(t) {
    const i = t.geometry;
    return this.setPositions(i.attributes.position.array), this;
  }
  computeBoundingBox() {
    this.boundingBox === null && (this.boundingBox = new Zs());
    const t = this.attributes.instanceStart, i = this.attributes.instanceEnd;
    t !== void 0 && i !== void 0 && (this.boundingBox.setFromBufferAttribute(t), Dwe.setFromBufferAttribute(i), this.boundingBox.union(Dwe));
  }
  computeBoundingSphere() {
    this.boundingSphere === null && (this.boundingSphere = new f3()), this.boundingBox === null && this.computeBoundingBox();
    const t = this.attributes.instanceStart, i = this.attributes.instanceEnd;
    if (t !== void 0 && i !== void 0) {
      const n = this.boundingSphere.center;
      this.boundingBox.getCenter(n);
      let s = 0;
      for (let o = 0, r = t.count; o < r; o++) cse.fromBufferAttribute(t, o), s = Math.max(s, n.distanceToSquared(cse)), cse.fromBufferAttribute(i, o), s = Math.max(s, n.distanceToSquared(cse));
      this.boundingSphere.radius = Math.sqrt(s), isNaN(this.boundingSphere.radius) && console.error("THREE.LineSegmentsGeometry.computeBoundingSphere(): Computed radius is NaN. The instanced position data is likely to have NaN values.", this);
    }
  }
  toJSON() {
  }
}
An.line = { worldUnits: { value: 1 }, linewidth: { value: 1 }, resolution: { value: new us(1, 1) }, dashOffset: { value: 0 }, dashScale: { value: 1 }, dashSize: { value: 1 }, gapSize: { value: 1 } }, Rg.line = { uniforms: vae.merge([An.common, An.fog, An.line]), vertexShader: `
		#include <common>
		#include <color_pars_vertex>
		#include <fog_pars_vertex>
		#include <logdepthbuf_pars_vertex>
		#include <clipping_planes_pars_vertex>

		uniform float linewidth;
		uniform vec2 resolution;

		attribute vec3 instanceStart;
		attribute vec3 instanceEnd;

		attribute vec3 instanceColorStart;
		attribute vec3 instanceColorEnd;

		#ifdef WORLD_UNITS

			varying vec4 worldPos;
			varying vec3 worldStart;
			varying vec3 worldEnd;

			#ifdef USE_DASH

				varying vec2 vUv;

			#endif

		#else

			varying vec2 vUv;

		#endif

		#ifdef USE_DASH

			uniform float dashScale;
			attribute float instanceDistanceStart;
			attribute float instanceDistanceEnd;
			varying float vLineDistance;

		#endif

		void trimSegment( const in vec4 start, inout vec4 end ) {

			// trim end segment so it terminates between the camera plane and the near plane

			// conservative estimate of the near plane
			float a = projectionMatrix[ 2 ][ 2 ]; // 3nd entry in 3th column
			float b = projectionMatrix[ 3 ][ 2 ]; // 3nd entry in 4th column
			float nearEstimate = - 0.5 * b / a;

			float alpha = ( nearEstimate - start.z ) / ( end.z - start.z );

			end.xyz = mix( start.xyz, end.xyz, alpha );

		}

		void main() {

			#ifdef USE_COLOR

				vColor.xyz = ( position.y < 0.5 ) ? instanceColorStart : instanceColorEnd;

			#endif

			#ifdef USE_DASH

				vLineDistance = ( position.y < 0.5 ) ? dashScale * instanceDistanceStart : dashScale * instanceDistanceEnd;
				vUv = uv;

			#endif

			float aspect = resolution.x / resolution.y;

			// camera space
			vec4 start = modelViewMatrix * vec4( instanceStart, 1.0 );
			vec4 end = modelViewMatrix * vec4( instanceEnd, 1.0 );

			#ifdef WORLD_UNITS

				worldStart = start.xyz;
				worldEnd = end.xyz;

			#else

				vUv = uv;

			#endif

			// special case for perspective projection, and segments that terminate either in, or behind, the camera plane
			// clearly the gpu firmware has a way of addressing this issue when projecting into ndc space
			// but we need to perform ndc-space calculations in the shader, so we must address this issue directly
			// perhaps there is a more elegant solution -- WestLangley

			bool perspective = ( projectionMatrix[ 2 ][ 3 ] == - 1.0 ); // 4th entry in the 3rd column

			if ( perspective ) {

				if ( start.z < 0.0 && end.z >= 0.0 ) {

					trimSegment( start, end );

				} else if ( end.z < 0.0 && start.z >= 0.0 ) {

					trimSegment( end, start );

				}

			}

			// clip space
			vec4 clipStart = projectionMatrix * start;
			vec4 clipEnd = projectionMatrix * end;

			// ndc space
			vec3 ndcStart = clipStart.xyz / clipStart.w;
			vec3 ndcEnd = clipEnd.xyz / clipEnd.w;

			// direction
			vec2 dir = ndcEnd.xy - ndcStart.xy;

			// account for clip-space aspect ratio
			dir.x *= aspect;
			dir = normalize( dir );

			#ifdef WORLD_UNITS

				vec3 worldDir = normalize( end.xyz - start.xyz );
				vec3 tmpFwd = normalize( mix( start.xyz, end.xyz, 0.5 ) );
				vec3 worldUp = normalize( cross( worldDir, tmpFwd ) );
				vec3 worldFwd = cross( worldDir, worldUp );
				worldPos = position.y < 0.5 ? start: end;

				// height offset
				float hw = linewidth * 0.5;
				worldPos.xyz += position.x < 0.0 ? hw * worldUp : - hw * worldUp;

				// don't extend the line if we're rendering dashes because we
				// won't be rendering the endcaps
				#ifndef USE_DASH

					// cap extension
					worldPos.xyz += position.y < 0.5 ? - hw * worldDir : hw * worldDir;

					// add width to the box
					worldPos.xyz += worldFwd * hw;

					// endcaps
					if ( position.y > 1.0 || position.y < 0.0 ) {

						worldPos.xyz -= worldFwd * 2.0 * hw;

					}

				#endif

				// project the worldpos
				vec4 clip = projectionMatrix * worldPos;

				// shift the depth of the projected points so the line
				// segments overlap neatly
				vec3 clipPose = ( position.y < 0.5 ) ? ndcStart : ndcEnd;
				clip.z = clipPose.z * clip.w;

			#else

				vec2 offset = vec2( dir.y, - dir.x );
				// undo aspect ratio adjustment
				dir.x /= aspect;
				offset.x /= aspect;

				// sign flip
				if ( position.x < 0.0 ) offset *= - 1.0;

				// endcaps
				if ( position.y < 0.0 ) {

					offset += - dir;

				} else if ( position.y > 1.0 ) {

					offset += dir;

				}

				// adjust for linewidth
				offset *= linewidth;

				// adjust for clip-space to screen-space conversion // maybe resolution should be based on viewport ...
				offset /= resolution.y;

				// select end
				vec4 clip = ( position.y < 0.5 ) ? clipStart : clipEnd;

				// back to clip space
				offset *= clip.w;

				clip.xy += offset;

			#endif

			gl_Position = clip;

			vec4 mvPosition = ( position.y < 0.5 ) ? start : end; // this is an approximation

			#include <logdepthbuf_vertex>
			#include <clipping_planes_vertex>
			#include <fog_vertex>

		}
		`, fragmentShader: `
		uniform vec3 diffuse;
		uniform float opacity;
		uniform float linewidth;

		#ifdef USE_DASH

			uniform float dashOffset;
			uniform float dashSize;
			uniform float gapSize;

		#endif

		varying float vLineDistance;

		#ifdef WORLD_UNITS

			varying vec4 worldPos;
			varying vec3 worldStart;
			varying vec3 worldEnd;

			#ifdef USE_DASH

				varying vec2 vUv;

			#endif

		#else

			varying vec2 vUv;

		#endif

		#include <common>
		#include <color_pars_fragment>
		#include <fog_pars_fragment>
		#include <logdepthbuf_pars_fragment>
		#include <clipping_planes_pars_fragment>

		vec2 closestLineToLine(vec3 p1, vec3 p2, vec3 p3, vec3 p4) {

			float mua;
			float mub;

			vec3 p13 = p1 - p3;
			vec3 p43 = p4 - p3;

			vec3 p21 = p2 - p1;

			float d1343 = dot( p13, p43 );
			float d4321 = dot( p43, p21 );
			float d1321 = dot( p13, p21 );
			float d4343 = dot( p43, p43 );
			float d2121 = dot( p21, p21 );

			float denom = d2121 * d4343 - d4321 * d4321;

			float numer = d1343 * d4321 - d1321 * d4343;

			mua = numer / denom;
			mua = clamp( mua, 0.0, 1.0 );
			mub = ( d1343 + d4321 * ( mua ) ) / d4343;
			mub = clamp( mub, 0.0, 1.0 );

			return vec2( mua, mub );

		}

		void main() {

			#include <clipping_planes_fragment>

			#ifdef USE_DASH

				if ( vUv.y < - 1.0 || vUv.y > 1.0 ) discard; // discard endcaps

				if ( mod( vLineDistance + dashOffset, dashSize + gapSize ) > dashSize ) discard; // todo - FIX

			#endif

			float alpha = opacity;

			#ifdef WORLD_UNITS

				// Find the closest points on the view ray and the line segment
				vec3 rayEnd = normalize( worldPos.xyz ) * 1e5;
				vec3 lineDir = worldEnd - worldStart;
				vec2 params = closestLineToLine( worldStart, worldEnd, vec3( 0.0, 0.0, 0.0 ), rayEnd );

				vec3 p1 = worldStart + lineDir * params.x;
				vec3 p2 = rayEnd * params.y;
				vec3 delta = p1 - p2;
				float len = length( delta );
				float norm = len / linewidth;

				#ifndef USE_DASH

					#ifdef USE_ALPHA_TO_COVERAGE

						float dnorm = fwidth( norm );
						alpha = 1.0 - smoothstep( 0.5 - dnorm, 0.5 + dnorm, norm );

					#else

						if ( norm > 0.5 ) {

							discard;

						}

					#endif

				#endif

			#else

				#ifdef USE_ALPHA_TO_COVERAGE

					// artifacts appear on some hardware if a derivative is taken within a conditional
					float a = vUv.x;
					float b = ( vUv.y > 0.0 ) ? vUv.y - 1.0 : vUv.y + 1.0;
					float len2 = a * a + b * b;
					float dlen = fwidth( len2 );

					if ( abs( vUv.y ) > 1.0 ) {

						alpha = 1.0 - smoothstep( 1.0 - dlen, 1.0 + dlen, len2 );

					}

				#else

					if ( abs( vUv.y ) > 1.0 ) {

						float a = vUv.x;
						float b = ( vUv.y > 0.0 ) ? vUv.y - 1.0 : vUv.y + 1.0;
						float len2 = a * a + b * b;

						if ( len2 > 1.0 ) discard;

					}

				#endif

			#endif

			vec4 diffuseColor = vec4( diffuse, alpha );

			#include <logdepthbuf_fragment>
			#include <color_fragment>

			gl_FragColor = vec4( diffuseColor.rgb, alpha );

			#include <tonemapping_fragment>
			#include <colorspace_fragment>
			#include <fog_fragment>
			#include <premultiplied_alpha_fragment>

		}
		` };
class XU extends BA {
  constructor(t) {
    super({ type: "LineMaterial", uniforms: vae.clone(Rg.line.uniforms), vertexShader: Rg.line.vertexShader, fragmentShader: Rg.line.fragmentShader, clipping: !0 }), this.isLineMaterial = !0, this.setValues(t);
  }
  get color() {
    return this.uniforms.diffuse.value;
  }
  set color(t) {
    this.uniforms.diffuse.value = t;
  }
  get worldUnits() {
    return "WORLD_UNITS" in this.defines;
  }
  set worldUnits(t) {
    t === !0 ? this.defines.WORLD_UNITS = "" : delete this.defines.WORLD_UNITS;
  }
  get linewidth() {
    return this.uniforms.linewidth.value;
  }
  set linewidth(t) {
    this.uniforms.linewidth && (this.uniforms.linewidth.value = t);
  }
  get dashed() {
    return "USE_DASH" in this.defines;
  }
  set dashed(t) {
    t === !0 !== this.dashed && (this.needsUpdate = !0), t === !0 ? this.defines.USE_DASH = "" : delete this.defines.USE_DASH;
  }
  get dashScale() {
    return this.uniforms.dashScale.value;
  }
  set dashScale(t) {
    this.uniforms.dashScale.value = t;
  }
  get dashSize() {
    return this.uniforms.dashSize.value;
  }
  set dashSize(t) {
    this.uniforms.dashSize.value = t;
  }
  get dashOffset() {
    return this.uniforms.dashOffset.value;
  }
  set dashOffset(t) {
    this.uniforms.dashOffset.value = t;
  }
  get gapSize() {
    return this.uniforms.gapSize.value;
  }
  set gapSize(t) {
    this.uniforms.gapSize.value = t;
  }
  get opacity() {
    return this.uniforms.opacity.value;
  }
  set opacity(t) {
    this.uniforms && (this.uniforms.opacity.value = t);
  }
  get resolution() {
    return this.uniforms.resolution.value;
  }
  set resolution(t) {
    this.uniforms.resolution.value.copy(t);
  }
  get alphaToCoverage() {
    return "USE_ALPHA_TO_COVERAGE" in this.defines;
  }
  set alphaToCoverage(t) {
    this.defines && (t === !0 !== this.alphaToCoverage && (this.needsUpdate = !0), t === !0 ? this.defines.USE_ALPHA_TO_COVERAGE = "" : delete this.defines.USE_ALPHA_TO_COVERAGE);
  }
}
const gce = new Ol(), Cwe = new Ge(), Owe = new Ge(), fp = new Ol(), Ip = new Ol(), db = new Ol(), wce = new Ge(), Tce = new Ln(), pp = new gc(), Lwe = new Ge(), hse = new Zs(), fse = new f3(), cb = new Ol();
let hb, eB;
function _we(e, t, i) {
  return cb.set(0, 0, -t, 1).applyMatrix4(e.projectionMatrix), cb.multiplyScalar(1 / cb.w), cb.x = eB / i.width, cb.y = eB / i.height, cb.applyMatrix4(e.projectionMatrixInverse), cb.multiplyScalar(1 / cb.w), Math.abs(Math.max(cb.x, cb.y));
}
class DYe extends En {
  constructor(t = new ZSe(), i = new XU({ color: 16777215 * Math.random() })) {
    super(t, i), this.isLineSegments2 = !0, this.type = "LineSegments2";
  }
  computeLineDistances() {
    const t = this.geometry, i = t.attributes.instanceStart, n = t.attributes.instanceEnd, s = new Float32Array(2 * i.count);
    for (let r = 0, l = 0, c = i.count; r < c; r++, l += 2) Cwe.fromBufferAttribute(i, r), Owe.fromBufferAttribute(n, r), s[l] = l === 0 ? 0 : s[l - 1], s[l + 1] = s[l] + Cwe.distanceTo(Owe);
    const o = new gle(s, 2, 1);
    return t.setAttribute("instanceDistanceStart", new fN(o, 1, 0)), t.setAttribute("instanceDistanceEnd", new fN(o, 1, 1)), this;
  }
  raycast(t, i) {
    const n = this.material.worldUnits, s = t.camera;
    s !== null || n || console.error('LineSegments2: "Raycaster.camera" needs to be set in order to raycast against LineSegments2 while worldUnits is set to false.');
    const o = t.params.Line2 !== void 0 && t.params.Line2.threshold || 0;
    hb = t.ray;
    const r = this.matrixWorld, l = this.geometry, c = this.material;
    let h, I;
    eB = c.linewidth + o, l.boundingSphere === null && l.computeBoundingSphere(), fse.copy(l.boundingSphere).applyMatrix4(r), n ? h = 0.5 * eB : h = _we(s, Math.max(s.near, fse.distanceToPoint(hb.origin)), c.resolution), fse.radius += h, hb.intersectsSphere(fse) !== !1 && (l.boundingBox === null && l.computeBoundingBox(), hse.copy(l.boundingBox).applyMatrix4(r), n ? I = 0.5 * eB : I = _we(s, Math.max(s.near, hse.distanceToPoint(hb.origin)), c.resolution), hse.expandByScalar(I), hb.intersectsBox(hse) !== !1 && (n ? (function(p, y) {
      const m = p.matrixWorld, A = p.geometry, C = A.attributes.instanceStart, O = A.attributes.instanceEnd;
      for (let R = 0, F = Math.min(A.instanceCount, C.count); R < F; R++) {
        pp.start.fromBufferAttribute(C, R), pp.end.fromBufferAttribute(O, R), pp.applyMatrix4(m);
        const L = new Ge(), P = new Ge();
        hb.distanceSqToSegment(pp.start, pp.end, P, L), P.distanceTo(L) < 0.5 * eB && y.push({ point: P, pointOnLine: L, distance: hb.origin.distanceTo(P), object: p, face: null, faceIndex: R, uv: null, uv1: null });
      }
    })(this, i) : (function(p, y, m) {
      const A = y.projectionMatrix, C = p.material.resolution, O = p.matrixWorld, R = p.geometry, F = R.attributes.instanceStart, L = R.attributes.instanceEnd, P = Math.min(R.instanceCount, F.count), z = -y.near;
      hb.at(1, db), db.w = 1, db.applyMatrix4(y.matrixWorldInverse), db.applyMatrix4(A), db.multiplyScalar(1 / db.w), db.x *= C.x / 2, db.y *= C.y / 2, db.z = 0, wce.copy(db), Tce.multiplyMatrices(y.matrixWorldInverse, O);
      for (let W = 0, re = P; W < re; W++) {
        if (fp.fromBufferAttribute(F, W), Ip.fromBufferAttribute(L, W), fp.w = 1, Ip.w = 1, fp.applyMatrix4(Tce), Ip.applyMatrix4(Tce), fp.z > z && Ip.z > z) continue;
        if (fp.z > z) {
          const Ae = fp.z - Ip.z, Oe = (fp.z - z) / Ae;
          fp.lerp(Ip, Oe);
        } else if (Ip.z > z) {
          const Ae = Ip.z - fp.z, Oe = (Ip.z - z) / Ae;
          Ip.lerp(fp, Oe);
        }
        fp.applyMatrix4(A), Ip.applyMatrix4(A), fp.multiplyScalar(1 / fp.w), Ip.multiplyScalar(1 / Ip.w), fp.x *= C.x / 2, fp.y *= C.y / 2, Ip.x *= C.x / 2, Ip.y *= C.y / 2, pp.start.copy(fp), pp.start.z = 0, pp.end.copy(Ip), pp.end.z = 0;
        const ce = pp.closestPointToPointParameter(wce, !0);
        pp.at(ce, Lwe);
        const te = Eie.lerp(fp.z, Ip.z, ce), ee = te >= -1 && te <= 1, Ne = wce.distanceTo(Lwe) < 0.5 * eB;
        if (ee && Ne) {
          pp.start.fromBufferAttribute(F, W), pp.end.fromBufferAttribute(L, W), pp.start.applyMatrix4(O), pp.end.applyMatrix4(O);
          const Ae = new Ge(), Oe = new Ge();
          hb.distanceSqToSegment(pp.start, pp.end, Oe, Ae), m.push({ point: Oe, pointOnLine: Ae, distance: hb.origin.distanceTo(Oe), object: p, face: null, faceIndex: W, uv: null, uv1: null });
        }
      }
    })(this, s, i)));
  }
  onBeforeRender(t) {
    const i = this.material.uniforms;
    i && i.resolution && (t.getViewport(gce), this.material.uniforms.resolution.value.set(gce.z, gce.w));
  }
}
class QSe extends ZSe {
  constructor() {
    super(), this.isLineGeometry = !0, this.type = "LineGeometry";
  }
  setPositions(t) {
    const i = t.length - 3, n = new Float32Array(2 * i);
    for (let s = 0; s < i; s += 3) n[2 * s] = t[s], n[2 * s + 1] = t[s + 1], n[2 * s + 2] = t[s + 2], n[2 * s + 3] = t[s + 3], n[2 * s + 4] = t[s + 4], n[2 * s + 5] = t[s + 5];
    return super.setPositions(n), this;
  }
  setColors(t) {
    const i = t.length - 3, n = new Float32Array(2 * i);
    for (let s = 0; s < i; s += 3) n[2 * s] = t[s], n[2 * s + 1] = t[s + 1], n[2 * s + 2] = t[s + 2], n[2 * s + 3] = t[s + 3], n[2 * s + 4] = t[s + 4], n[2 * s + 5] = t[s + 5];
    return super.setColors(n), this;
  }
  setFromPoints(t) {
    const i = t.length - 1, n = new Float32Array(6 * i);
    for (let s = 0; s < i; s++) n[6 * s] = t[s].x, n[6 * s + 1] = t[s].y, n[6 * s + 2] = t[s].z || 0, n[6 * s + 3] = t[s + 1].x, n[6 * s + 4] = t[s + 1].y, n[6 * s + 5] = t[s + 1].z || 0;
    return super.setPositions(n), this;
  }
  fromLine(t) {
    const i = t.geometry;
    return this.setPositions(i.attributes.position.array), this;
  }
}
class CYe extends DYe {
  constructor(t = new QSe(), i = new XU({ color: 16777215 * Math.random() })) {
    super(t, i), this.isLine2 = !0, this.type = "Line2";
  }
}
class OYe {
  constructor(t) {
    De(this, "model"), De(this, "_endpointsMaterials", { interior: new Y1e({ color: 15658734, size: 8, sizeAttenuation: !1, depthTest: !1 }), exterior: new Y1e({ color: 16777215, size: 16, sizeAttenuation: !1, depthTest: !1 }) }), De(this, "_absoluteAlignments", new E5()), De(this, "_horizontalAlignments", new E5()), De(this, "_verticalAlignments", new E5()), De(this, "_alignmentMaterials", /* @__PURE__ */ new Map([[aN.NONE, new XU({ color: 16777215, linewidth: 5, depthTest: !1 })], [aN.LINES, new XU({ color: 16711935, linewidth: 5, depthTest: !1 })], [aN.CLOTHOID, new XU({ color: 16711680, linewidth: 5, depthTest: !1 })], [aN.ELLIPSE_ARC, new XU({ color: 65535, linewidth: 5, depthTest: !1 })], [aN.PARABOLA, new XU({ color: 255, linewidth: 5, depthTest: !1 })]])), this.model = t;
  }
  async getAlignments() {
    return this._absoluteAlignments.children.length || await this.constructAlignments(), this._absoluteAlignments;
  }
  async getHorizontalAlignments() {
    return this._horizontalAlignments.children.length || await this.constructAlignments(), this._horizontalAlignments;
  }
  async getVerticalAlignments() {
    return this._verticalAlignments.children.length || await this.constructAlignments(), this._verticalAlignments;
  }
  async getAlignmentStyles() {
    return { ...this._alignmentMaterials, ...this._endpointsMaterials };
  }
  async constructAlignments() {
    const t = await this.model.threads.invoke(this.model.modelId, "getAlignments");
    for (const i of t) this.constructLine(i.absolute, this._absoluteAlignments), this.constructLine(i.horizontal, this._horizontalAlignments), this.constructLine(i.vertical, this._verticalAlignments);
  }
  constructLine(t, i) {
    if (!t.length) return;
    const n = [], s = [], o = new E5();
    i.add(o);
    const r = t[0].points, l = t[t.length - 1].points;
    s.push(l[0], l[1], l[2]), s.push(r[r.length - 3], r[r.length - 2], r[r.length - 1]);
    for (const I of t) {
      const p = I.points;
      n.push(p[0], p[1], p[2]), n.push(p[p.length - 3], p[p.length - 2], p[p.length - 1]);
      const y = new QSe();
      y.setPositions(p);
      const m = this._alignmentMaterials.get(I.type), A = new CYe(y, m);
      o.add(A), A.renderOrder = 1, A.userData.points = p;
    }
    const { interior: c, exterior: h } = this._endpointsMaterials;
    this.constructPoints(n, c, o), this.constructPoints(s, h, o);
  }
  constructPoints(t, i, n) {
    const s = new wUe(), o = new Vl(), r = new Float32Array(t), l = new zu(r, 3);
    o.setAttribute("position", l), s.geometry = o, s.material = i, n.add(s), s.renderOrder = 2;
  }
  dispose() {
    this._absoluteAlignments.removeFromParent();
    for (const t of this._absoluteAlignments.children) {
      const i = t;
      i.geometry.dispose(), i.geometry = void 0, i.material = void 0;
    }
    for (const t of Object.values(this._alignmentMaterials)) t.dispose();
    this._alignmentMaterials = {};
  }
}
class LYe {
  async setup(t, i, n, s, o) {
    const r = this.getCreateModelMessage(t, n, s, o), l = this.formatModelData(n), c = await t.threads.fetch(r, l);
    this.updateBox(i, c);
  }
  formatModelData(t) {
    if (t instanceof ArrayBuffer) return [t];
  }
  updateBox(t, i) {
    t.min.copy(i.boundingBox.min), t.max.copy(i.boundingBox.max);
  }
  getCreateModelMessage(t, i, n, s) {
    return { class: LA.CREATE_MODEL, modelId: t.modelId, modelData: i, raw: n, config: s };
  }
}
class _Ye {
  async getBoxes(t, i) {
    const n = this.getIndividualBoxesIds(i), s = this.getBoxRequest(t, n), o = await t.threads.fetch(s);
    return this.getAllBoxes(o, t);
  }
  async getMergedBox(t, i) {
    const n = this.getBoxRequest(t, [i]), { boxes: s } = await t.threads.fetch(n), [o] = s;
    return this.getAbsoluteBox(o, t);
  }
  getAbsoluteBox(t, i) {
    const n = new Zs();
    return n.copy(t), n.applyMatrix4(i.object.matrixWorld), n;
  }
  getIndividualBoxesIds(t) {
    if (!t) return;
    const i = [];
    for (const n of t) i.push([n]);
    return i;
  }
  getAllBoxes(t, i) {
    const n = t.boxes, s = [];
    for (const o of n) {
      const r = new Zs();
      r.copy(o), r.applyMatrix4(i.object.matrixWorld), s.push(r);
    }
    return s;
  }
  getBoxRequest(t, i) {
    return { class: LA.FETCH_BOXES, modelId: t.modelId, localIds: i };
  }
}
class xYe {
  constructor() {
    De(this, "_coordinationMatrices", /* @__PURE__ */ new Map());
  }
  async getCoordinationMatrix(t) {
    let i = this._coordinationMatrices.get(t.modelId);
    if (i) return i;
    i = new Ln(), this._coordinationMatrices.set(t.modelId, i);
    const [n, s, o, r, l, c, h, I, p] = await this.getCoordinates(t), y = new Ge(r, l, c), m = new Ge(h, I, p), A = new Ge().crossVectors(y, m);
    return i.set(r, h, A.x, n, l, I, A.y, s, c, p, A.z, o, 0, 0, 0, 1), i;
  }
  async getCoordinates(t) {
    const i = t.modelId;
    return t.threads.invoke(i, "getCoordinates");
  }
  async getPositions(t, i) {
    const n = [i], s = await t.threads.invoke(t.modelId, "getPositions", n);
    return this.getAbsolutePositions(s, t);
  }
  getAbsolutePositions(t, i) {
    const n = [];
    for (const s of t) {
      const { x: o, y: r, z: l } = s, c = new Ge(o, r, l);
      c.applyMatrix4(i.object.matrixWorld), n.push(c);
    }
    return n;
  }
}
class PYe extends Map {
  constructor(t, i) {
    super(i), De(this, "tracker", null), De(this, "localId"), De(this, "guard", (() => !0)), this.localId = t;
  }
  get object() {
    const t = {};
    for (const [i, n] of this.entries()) t[i] = n.value;
    return t;
  }
  set(t, i) {
    if (!(this.guard ?? (() => !0))(t, i)) return this;
    const n = i.type !== void 0 ? i : { value: i.value, type: this.getType(t) };
    if (!this.tracker) return super.set(t, n);
    if (this.localId === null) return console.warn("Item attributes are missing a valid localId. Changes can't be tracked."), super.set(t, n);
    let s = this.tracker.get(this.localId);
    return s || (s = { type: "modified", added: {}, deleted: [], modified: {} }, this.tracker.set(this.localId, s)), s.type === "added" ? s.data[t] = n : s.type === "modified" && (this.has(t) ? s.modified[t] = n : s.deleted.includes(t) ? (s.deleted = s.deleted.filter(((o) => o !== t)), s.modified[t] = n) : s.added[t] = n), super.set(t, n);
  }
  setValue(t, i) {
    return this.set(t, { value: i, type: this.getType(t) });
  }
  setType(t, i) {
    const n = this.getValue(t);
    return n ? this.set(t, { value: n, type: i }) : this;
  }
  delete(t) {
    if (!this.tracker) return super.delete(t);
    const i = this.get("localId");
    if (i === void 0 || typeof i != "number") return console.warn("Item attributes are missing a valid localId. Changes can't be tracked."), t !== "localId" && super.delete(t);
    if (t === "localId" || !this.has(t)) return !1;
    let n = this.tracker.get(i);
    return n || (n = { type: "modified", added: {}, deleted: [], modified: {} }, this.tracker.set(i, n)), n.type === "added" ? delete n.data[t] : n.type === "modified" && (t in n.added ? delete n.added[t] : (t in n.modified && delete n.modified[t], n.deleted.push(t))), super.delete(t);
  }
  getValue(t) {
    const i = this.get(t);
    return i ? i.value : null;
  }
  getType(t) {
    var i;
    return (i = this.get(t)) == null ? void 0 : i.type;
  }
}
class MYe extends Map {
  constructor(t, i) {
    super(i), De(this, "tracker", null), De(this, "localId"), De(this, "guard", (() => !0)), De(this, "onItemsRequested", null), this.localId = t;
  }
  get itemChanges() {
    if (!this.tracker) return null;
    if (!this.localId) return console.warn("Item relations can't be tracked."), null;
    let t = this.tracker.get(this.localId);
    return t || (t = { type: "modified", added: {}, deleted: /* @__PURE__ */ new Set(), removed: {}, modified: {} }, this.tracker.set(this.localId, t)), t;
  }
  set(t, i) {
    const n = this.has(t);
    if (!(this.guard ?? (() => !0))(t, i)) return this;
    const s = this.itemChanges;
    return s ? (n ? s.modified[t] = i : s.added[t] = i, super.set(t, i)) : super.set(t, i);
  }
  add(t, i) {
    var n;
    const s = this.has(t);
    let o = this.get(t);
    if (!o) return o = /* @__PURE__ */ new Set([i]), this.set(t, o), !0;
    if (!o || o.has(i)) return !1;
    const r = this.itemChanges;
    if (!r) return o.add(i), !0;
    if (s) if ((n = r.removed[t]) != null && n.has(i)) r.removed[t].delete(i), r.removed[t].size === 0 && delete r.removed[t];
    else {
      let l = r.modified[t];
      l || (l = /* @__PURE__ */ new Set(), r.modified[t] = l), l.add(i);
    }
    else {
      let l = r.added[t];
      l || (l = /* @__PURE__ */ new Set(), r.added[t] = l), l.add(i);
    }
    return o.add(i), !0;
  }
  remove(t, i) {
    var n;
    const s = this.get(t);
    if (!s || !s.has(i)) return !1;
    const o = this.itemChanges;
    if (!o) return s.delete(i);
    if ((n = o.modified[t]) != null && n.has(i)) o.modified[t].delete(i), o.modified[t].size === 0 && delete o.modified[t];
    else {
      let r = o.removed[t];
      r || (r = /* @__PURE__ */ new Set(), o.removed[t] = r), r.add(i);
    }
    return s.delete(i);
  }
  delete(t) {
    if (!this.has(t)) return !1;
    const i = this.itemChanges;
    return i ? (i.deleted.add(t), super.delete(t)) : super.delete(t);
  }
  async getItems(t) {
    if (!this.onItemsRequested) return null;
    const i = this.get(t);
    return i ? await this.onItemsRequested([...i]) : null;
  }
}
class UYe {
  constructor(t, i) {
    De(this, "model"), De(this, "localId"), De(this, "_indices", null), De(this, "_transform", null), De(this, "_normals", null), De(this, "_positions", null), De(this, "_vertices", null), De(this, "_triangles", null), De(this, "_position", null), De(this, "_box", null), this.model = t, this.localId = i;
  }
  async get() {
    const [t] = await this.model.threads.invoke(this.model.modelId, "getItemsGeometry", [[this.localId]]);
    for (const i of t) {
      i.transform = new Ln().fromArray(i.transform.elements);
      const { indices: n, normals: s, positions: o, transform: r } = i;
      this._indices || (this._indices = []), this._normals || (this._normals = []), this._positions || (this._positions = []), this._transform || (this._transform = []), this._indices.push(n), this._normals.push(s), this._positions.push(o), this._transform.push(r);
    }
    return t;
  }
  async getIndices() {
    return this._indices !== null || await this.get(), this._indices;
  }
  async getTransform() {
    return this._transform !== null || await this.get(), this._transform;
  }
  async getNormals() {
    return this._normals !== null || await this.get(), this._normals;
  }
  async getPositions() {
    return this._positions !== null || await this.get(), this._positions;
  }
  async getVertices() {
    if (this._vertices) return this._vertices;
    const t = await this.getPositions(), i = await this.getTransform();
    if (!t || !i) return this._vertices;
    this._vertices = [];
    for (let n = 0; n < t.length; n++) {
      const s = t[n], o = i[n];
      if (!s || !o) continue;
      const r = [];
      this._vertices.push(r);
      const l = Object.keys(s).length / 3, c = [];
      for (let h = 0; h < l; h++) {
        const I = s[3 * h], p = s[3 * h + 1], y = s[3 * h + 2];
        if (typeof I != "number" || typeof p != "number" || typeof y != "number") continue;
        const m = `${I},${p},${y}`;
        if (c.includes(m)) continue;
        c.push(m);
        const A = new Ge(I, p, y);
        A.applyMatrix4(o), r.push(A);
      }
    }
    return this._vertices;
  }
  async getTriangles() {
    if (this._triangles) return this._triangles;
    const t = await this.getIndices(), i = await this.getPositions(), n = await this.getTransform();
    if (!t || !i || !n) return this._triangles;
    this._triangles = [];
    for (let s = 0; s < t.length; s++) {
      const o = t[s], r = i[s], l = n[s];
      if (!o || !r || !l) continue;
      const c = [];
      this._triangles.push(c);
      for (let h = 0; h < o.length; h += 3) {
        const I = o[h], p = o[h + 1], y = o[h + 2], m = new Ge(r[3 * I], r[3 * I + 1], r[3 * I + 2]), A = new Ge(r[3 * p], r[3 * p + 1], r[3 * p + 2]), C = new Ge(r[3 * y], r[3 * y + 1], r[3 * y + 2]);
        m.applyMatrix4(l), A.applyMatrix4(l), C.applyMatrix4(l), c.push(new wc(m, A, C));
      }
    }
    return this._triangles;
  }
  async getPosition() {
    if (!this._position) {
      if (this.localId === null) return null;
      this._position = await this.model.getPositions([this.localId]);
    }
    return this._position;
  }
  async getBox() {
    if (!this._box) {
      if (this.localId === null) return null;
      this._box = await this.model.getBoxes([this.localId]);
    }
    return this._box;
  }
  async setVisibility(t) {
    await this.model.setVisible([this.localId], t);
  }
  async getVisibility() {
    const [t] = await this.model.getVisible([this.localId]);
    return t;
  }
}
class BYe {
  constructor(t, i) {
    De(this, "model"), De(this, "_localId", null), De(this, "_attributes", null), De(this, "_relations", null), De(this, "_guid", null), De(this, "_category", null), De(this, "_geometry", null), this.model = t, typeof i == "number" && (this._localId = i), typeof i == "string" && (this._guid = i);
  }
  async getLocalId() {
    if (!this._localId) {
      if (!this._guid) throw new Error("Fragments: Item localId couldn't be get.");
      [this._localId] = await this.model.threads.invoke(this.model.modelId, "getLocalIdsByGuids", [[this._guid]]);
    }
    return this._localId;
  }
  async getAttributes() {
    if (this._attributes) return this._attributes;
    const t = await this.getLocalId();
    if (t === null) return null;
    const i = await this.model.threads.invoke(this.model.modelId, "getItemAttributes", [t]);
    if (this._attributes = new PYe(t), !i) {
      const s = this.model.attrsChanges.get(t);
      if (!s || s.type !== "added") return null;
      this._attributes.localId = t;
      for (const [o, r] of Object.entries(s.data)) this._attributes.set(o, r);
      return this._attributes;
    }
    const n = this.model.attrsChanges.get(t);
    if (n && n.type === "modified") for (const [s, o] of Object.entries(n.added)) this._attributes.set(s, o);
    for (const s in i) {
      const { value: o, type: r } = i[s];
      (n == null ? void 0 : n.type) === "modified" && n.deleted.includes(s) || ((n == null ? void 0 : n.type) === "modified" && s in n.modified ? this._attributes.set(s, n.modified[s]) : this._attributes.set(s, { value: o, type: r }));
    }
    return this._attributes.tracker = this.model.attrsChanges, this._attributes;
  }
  async getRelations() {
    if (this._relations) return this._relations;
    const t = await this.getLocalId();
    if (t === null) return null;
    const i = await this.model.threads.invoke(this.model.modelId, "getItemRelations", [t]);
    if (!i) return null;
    this._relations = new MYe(t), this._relations.onItemsRequested = async (s) => {
      const o = [];
      for (const r of s) {
        const l = this.model.getItem(r);
        l && o.push(l);
      }
      return o;
    };
    const n = this.model.relsChanges.get(t);
    if (n && n.type === "modified") for (const [s, o] of Object.entries(n.added)) this._relations.set(s, o);
    for (const [s, o] of Object.entries(i)) if ((n == null ? void 0 : n.type) !== "modified" || !n.deleted.has(s)) if ((n == null ? void 0 : n.type) === "modified" && s in n.modified) {
      const r = /* @__PURE__ */ new Set([...n.modified[s], ...o]);
      this._relations.set(s, new Set(r));
    } else this._relations.set(s, new Set(o));
    return this._relations.tracker = this.model.relsChanges, this._relations;
  }
  async getGuid() {
    if (!this._guid) {
      const t = await this.getLocalId();
      if (t === null) return null;
      [this._guid] = await this.model.threads.invoke(this.model.modelId, "getGuidsByLocalIds", [[t]]);
    }
    return this._guid;
  }
  async getCategory() {
    if (!this._category) {
      const t = await this.getLocalId();
      if (t === null) return null;
      this._category = await this.model.threads.invoke(this.model.modelId, "getItemCategory", [t]);
    }
    return this._category;
  }
  async getGeometry() {
    if (this._geometry) return this._geometry;
    const t = await this.getLocalId();
    return t === null ? null : new UYe(this.model, t);
  }
  async getData(t = []) {
    var i;
    const n = await this.getLocalId();
    if (n == null) return {};
    t.push(n);
    const s = (i = await this.getAttributes()) == null ? void 0 : i.object, o = await this.getRelations(), r = {};
    if (o) for (const l of o.keys()) {
      const c = [];
      r[l] = c;
      const h = await o.getItems(l);
      if (h) for (const I of h) {
        const p = await I.getLocalId();
        if (!p || t.find(((m) => m === p)) !== void 0) continue;
        t.push(p);
        const y = await I.getData(t);
        y && c.push(y);
      }
    }
    return { ...s, ...r };
  }
}
class FYe {
  getItem(t, i) {
    return new BYe(t, i);
  }
  async getItemsData(t, i, n) {
    return t.threads.invoke(t.modelId, "getItemsData", [i, n]);
  }
  async getItemsChildren(t, i) {
    return t.threads.invoke(t.modelId, "getItemsChildren", [i]);
  }
}
class HYe {
  constructor() {
    De(this, "getClippingPlanesEvent", (() => [])), De(this, "currentCamera", null), De(this, "_tempMatrix", new Ln()), De(this, "_tempVec", new Ge()), De(this, "_tempFrustum", new cL()), De(this, "_updateCameraPositionEvent", (() => {
    })), De(this, "_updateCameraFrustumEvent", (() => {
    })), De(this, "_updateFOVEvent", (() => {
    })), De(this, "_updateOrthoSizeEvent", (() => {
    }));
  }
  async refreshView(t, i) {
    const n = this.setup(i, t), s = VF.transform(this._tempFrustum, this._tempMatrix), o = this.newViewRequest(s, n, t);
    await t.threads.fetch(o);
  }
  useCamera(t) {
    const i = new Ln();
    this.setCameraPosition(t), this.setCameraFrustum(t, i), this.setFov(t), this.setOrtho(), this.currentCamera = t;
  }
  async setLodMode(t, i) {
    return t.threads.invoke(t.modelId, "setLodMode", [i]);
  }
  getOrthoSize() {
    let t = this._updateOrthoSizeEvent();
    return t && (t *= this._tempMatrix.getMaxScaleOnAxis()), t;
  }
  setup(t, i) {
    return t.requests.clean(i.modelId), this._tempMatrix.copy(i.object.matrixWorld).invert(), this._updateCameraPositionEvent(this._tempVec), this._updateCameraFrustumEvent(this._tempFrustum), this._updateFOVEvent();
  }
  newViewRequest(t, i, n) {
    const s = this.newView(t, i, n), o = {};
    return o.class = LA.REFRESH_VIEW, o.modelId = n.modelId, o.cameraFrustum = t, o.view = s, o;
  }
  newView(t, i, n) {
    const s = {};
    return s.cameraFrustum = t, s.cameraPosition = this._tempVec.applyMatrix4(this._tempMatrix), s.fov = i, s.orthogonalDimension = this.getOrthoSize(), s.viewSize = Math.max(window.innerWidth, window.innerHeight), s.graphicThreshold = qSe.estimateCapacity(), s.graphicQuality = -1.5 * n.graphicsQuality + 2, s.clippingPlanes = this.getPlanes(), s.modelPlacement = n.object.matrixWorld, s;
  }
  setOrtho() {
    this._updateOrthoSizeEvent = () => {
    };
  }
  setFov(t) {
    this._updateFOVEvent = () => {
      if (t instanceof Tg) return t.fov;
    };
  }
  getPlanes() {
    const t = [], i = this.getClippingPlanesEvent();
    for (const n of i) {
      const s = n.clone();
      s.applyMatrix4(this._tempMatrix), t.push(s);
    }
    return t;
  }
  setCameraPosition(t) {
    this._updateCameraPositionEvent = (i) => {
      i.copy(t.position);
    };
  }
  setCameraFrustum(t, i) {
    this._updateCameraFrustumEvent = (n) => {
      t.updateProjectionMatrix(), t.updateWorldMatrix(!0, !0);
      const { projectionMatrix: s, matrixWorldInverse: o } = t;
      i.multiplyMatrices(s, o), n.setFromProjectionMatrix(i);
    };
  }
}
class GYe {
  constructor() {
    De(this, "_caster", new Aae()), De(this, "_ray", new MA()), De(this, "_frustum", new cL()), De(this, "_inverseTransform", new Ln()), De(this, "_t", new tl()), De(this, "_r", new tl()), De(this, "_b", new tl()), De(this, "_l", new tl()), De(this, "_n", new tl()), De(this, "_f", new tl()), De(this, "_tl", new Ge()), De(this, "_tr", new Ge()), De(this, "_bl", new Ge()), De(this, "_br", new Ge()), De(this, "_tln", new Ge()), De(this, "_brn", new Ge()), De(this, "_tlp", new us()), De(this, "_brp", new us()), De(this, "distance", 10);
  }
  async raycast(t, i) {
    const { frustum: n, ray: s } = this.getRayAndFrustum(i), o = this.getRequest(t, n, s);
    if (!o) return null;
    const r = await t.threads.fetch(o);
    if (r.results && r.results.length) {
      const [l] = r.results;
      return this.getResult({ hit: l, frustum: n, ray: s, model: t });
    }
    return null;
  }
  async raycastAll(t, i) {
    const { frustum: n, ray: s } = this.getRayAndFrustum(i), o = this.getRequest(t, n, s);
    if (!o) return null;
    o.returnAll = !0;
    const r = [], l = await t.threads.fetch(o);
    if (l.results && l.results.length) {
      for (const c of l.results) r.push(this.getResult({ hit: c, frustum: n, ray: s, model: t }));
      return r;
    }
    return null;
  }
  async rectangleRaycast(t, i, n) {
    const s = this.getFrustum(n), o = this.getRequest(t, s);
    if (!o) return null;
    o.fullyIncluded = n.fullyIncluded;
    const r = await t.threads.fetch(o);
    return r.localIds && r.localIds.length ? this.newRectangleCastResponse(r, i) : null;
  }
  async raycastWithSnapping(t, i) {
    const { frustum: n, ray: s } = this.getRayAndFrustum(i), o = this.getRequest(t, n, s);
    if (!o) return null;
    o.snappingClass = i.snappingClasses;
    const r = await t.threads.fetch(o);
    return r.results ? this.newRaycastSnapResult(r, n, s, t) : null;
  }
  screenRectToFrustum(t, i, n, s) {
    return this.screenToCast(t, n, this._tlp), this.screenToCast(i, n, this._brp), this.setVectors(s), this.setPlanes(s), this.newFrustum();
  }
  screenToCasterPoint(t, i, n) {
    const s = this.screenToCast(t, i);
    return this._caster.setFromCamera(s, n), this._caster.ray.clone();
  }
  setPlanes(t) {
    this.setBasePoints(), t.getWorldDirection(this._n.normal), this.setEnds(t);
  }
  setVectors(t) {
    this.setVector(this._tl, this._tlp, this._tlp, 1, t), this.setVector(this._tr, this._brp, this._tlp, 1, t), this.setVector(this._bl, this._tlp, this._brp, 1, t), this.setVector(this._br, this._brp, this._brp, 1, t), this.setVector(this._tln, this._tlp, this._tlp, 0, t), this.setVector(this._brn, this._brp, this._brp, 0, t);
  }
  newFrustum() {
    return new cL(this._t, this._b, this._l, this._r, this._f, this._n);
  }
  setEnds(t) {
    t instanceof eY ? (this._n.constant = t.near, this._f.constant = t.far) : (this._n.constant = t.position.length(), this._f.constant = 1 / 0), this._f.normal = this._n.normal;
  }
  screenToCast(t, i, n = new us()) {
    const s = i.getBoundingClientRect(), o = s.width / i.clientWidth, r = s.height / i.clientHeight, l = (t.x - s.left) / o, c = (t.y - s.top) / r;
    return n.x = l / i.clientWidth * 2 - 1, n.y = -c / i.clientHeight * 2 + 1, n;
  }
  setVector(t, i, n, s, o) {
    t.set(i.x, n.y, s), t.unproject(o);
  }
  setPlane(t, i, n, s) {
    t.setFromCoplanarPoints(i, n, s);
  }
  setBasePoints() {
    this.setPlane(this._t, this._tln, this._tl, this._tr), this.setPlane(this._r, this._brn, this._tr, this._br), this.setPlane(this._b, this._brn, this._br, this._bl), this.setPlane(this._l, this._tln, this._bl, this._tl);
  }
  setupRay(t, i) {
    t && (this._ray.copy(t), this._ray.applyMatrix4(this._inverseTransform), i.ray = this._ray);
  }
  setupMatrix(t) {
    this._inverseTransform.copy(t.matrixWorld), this._inverseTransform.invert();
  }
  getRequest(t, i, n) {
    const { object: s, box: o, modelId: r } = t;
    return i.intersectsBox(o) ? this.newCastRequest(s, r, n, i) : null;
  }
  getRayAndFrustum(t) {
    this.updateCamera(t.camera);
    const { bottomLeft: i, topRight: n } = this.getCorners(t.mouse);
    return { ray: this.screenToCasterPoint(t.mouse, t.dom, t.camera), frustum: this.screenRectToFrustum(i, n, t.dom, t.camera) };
  }
  getFrustum(t) {
    return this.updateCamera(t.camera), this.screenRectToFrustum(t.topLeft, t.bottomRight, t.dom, t.camera);
  }
  getCorners(t) {
    return { bottomLeft: t.clone().subScalar(this.distance), topRight: t.clone().addScalar(this.distance) };
  }
  getResult(t) {
    const { hit: i, frustum: n, ray: s, model: o } = t, r = {};
    return this.setPoint(o, i, r), this.setNormal(o, i, r), this.setDistance(o, i, r), this.setRayDistance(o, i, r), this.setBasicHitData(o, i, r, s, n), this.setSnapEdge(o, i, r, "snappedEdgeP1"), this.setSnapEdge(o, i, r, "snappedEdgeP2"), r.facePoints = i.facePoints, r.faceIndices = i.faceIndices, r;
  }
  updateCamera(t) {
    t.updateProjectionMatrix(), t.updateWorldMatrix(!0, !0);
  }
  newCastRequest(t, i, n, s) {
    this.setupMatrix(t);
    const o = {};
    return o.class = LA.RAYCAST, o.modelId = i, this.setupRay(n, o), VF.transform(s, this._inverseTransform, this._frustum), o.frustum = this._frustum, o;
  }
  setSnapEdge(t, i, n, s) {
    if (i[s]) {
      const o = new Ge();
      o.copy(i[s]), o.applyMatrix4(t.object.matrixWorld), n[s] = o;
    } else n[s] = void 0;
  }
  setNormal(t, i, n) {
    if (i.normal) {
      const s = new Ge();
      return s.copy(i.normal), s.transformDirection(t.object.matrixWorld), s.normalize(), void (n.normal = s);
    }
    n.normal = void 0;
  }
  setDistance(t, i, n) {
    const s = Math.sqrt(i.cameraSquaredDistance), o = t.object.matrixWorld.getMaxScaleOnAxis();
    n.distance = s * o;
  }
  setPoint(t, i, n) {
    const s = new Ge();
    s.copy(i.point), s.applyMatrix4(t.object.matrixWorld), n.point = s;
  }
  newRaycastSnapResult(t, i, n, s) {
    const o = [];
    for (const r of t.results) {
      const l = this.getResult({ hit: r, frustum: i, ray: n, model: s });
      o.push(l);
    }
    return o;
  }
  newRectangleCastResponse(t, i) {
    return { localIds: t.localIds, fragments: i.list.get(t.modelId) };
  }
  setRayDistance(t, i, n) {
    if (i.raySquaredDistance === void 0) n.rayDistance = void 0;
    else {
      const s = t.object.matrixWorld.getMaxScaleOnAxis(), o = Math.sqrt(i.raySquaredDistance);
      n.rayDistance = o * s;
    }
  }
  setBasicHitData(t, i, n, s, o) {
    n.itemId = i.itemId, n.localId = i.localId, n.object = t.object, n.fragments = t, n.ray = s, n.frustum = o, n.representationClass = i.representationClass, n.snappingClass = i.snappingClass;
  }
}
class kYe {
  async resetVisible(t) {
    await t.threads.invoke(t.modelId, "resetVisible");
  }
  async getItemsByVisibility(t, i) {
    return t.threads.invoke(t.modelId, "getItemsByVisibility", [i]);
  }
  async getVisible(t, i) {
    return t.threads.invoke(t.modelId, "getVisible", [i]);
  }
}
class Cle {
}
De(Cle, "vertex", `
            #include <common>
            #include <clipping_planes_pars_vertex>

            attribute float itemFilter;
            uniform vec2 lodSize;
            attribute vec3 itemFirst;
            attribute vec3 itemLast;

            float lodWidth = 2.0;
            
            void cutLodLine(const in vec4 first, inout vec4 second ) {
                float projValue1 = projectionMatrix[2][2];
                float projValue2 = projectionMatrix[3][2];
                float approxResult = -(projValue2 / projValue1) / 2.0;
                float diff1 = approxResult - first.z;
                float diff2 = second.z - first.z;
                float cutFilter = diff1 / diff2;
                second.xyz = mix(first.xyz, second.xyz, cutFilter);
            }
                
            void main() {
                if (itemFilter == 0.0) {
                    gl_Position = vec4(0,0,0,0);
                    return;
                }

                vec4 rawFirst = vec4(itemFirst, 1.0);
                vec4 rawLast = vec4(itemLast, 1.0);
                vec4 first = modelViewMatrix * rawFirst;
                vec4 last = modelViewMatrix * rawLast;
                
                bool lodPerspective = projectionMatrix[2][3] == -1.0;
                if (lodPerspective) {
                    bool firstCut = first.z < 0.0 && last.z >= 0.0;
                    bool lastCut = last.z < 0.0 && first.z >= 0.0;
                    if (firstCut) {
                        cutLodLine( first, last );
                    } else if (lastCut) {
                        cutLodLine( last, first );
                    }
                }

                vec4 firstCut = projectionMatrix * first;
                vec4 lastCut = projectionMatrix * last;
                vec3 firstNdc = firstCut.xyz / firstCut.w;
                vec3 lastNdc = lastCut.xyz / lastCut.w;

                vec2 lodOrientation = lastNdc.xy - firstNdc.xy;

                float lodRatio = lodSize.x / lodSize.y;
                lodOrientation.x *= lodRatio;
                lodOrientation = normalize(lodOrientation);
                
                vec2 lodDistance = vec2(lodOrientation.y, - lodOrientation.x);
                lodOrientation.x /= lodRatio;
                lodDistance.x /= lodRatio;

                if (position.x < 0.0) { 
                    lodDistance *= - 1.0;
                }

                if (position.y < 0.0) {
                    lodDistance += -lodOrientation;
                } else if (position.y > 1.0) {
                    lodDistance += lodOrientation;
                }

                lodDistance *= lodWidth;
                lodDistance /= lodSize.y;

                bool isFirst = position.y < 0.5;
                vec4 lodPosition = isFirst ? firstCut : lastCut;
                lodDistance *= lodPosition.w;
                lodPosition.xy += lodDistance;
                gl_Position = lodPosition;

                vec4 mvPosition = isFirst ? first : last;
                #include <clipping_planes_vertex>
            }
    `), De(Cle, "fragment", `
            #include <common>
            #include <clipping_planes_pars_fragment>

            uniform vec3 lodColor;
            uniform float lodOpacity;

            void main() {
                #include <clipping_planes_fragment>
                gl_FragColor = vec4(lodColor, lodOpacity);
                #include <colorspace_fragment>
            }
    `);
const hJ = class V_ {
  static setupLodMeshResize(t) {
    t.onBeforeRender = (i) => {
      i.getSize(t.material[0].lodSize);
    };
  }
  static setupLodAttributes(t) {
    t.setIndex(V_.indices), t.setAttribute("position", V_.vertices);
  }
  static setLodBuffer(t, i, n) {
    let s = t.getItemFirst(), o = t.getItemLast(), r = this.setItemFirst(t, s, i, o);
    ({ itemFirst: s, dataBuffer: r, itemLast: o } = this.resetAttributes(s, r, i, o)), this.setupFinish(n, r), t.setAttribute("itemFirst", s), t.setAttribute("itemLast", o);
  }
  static setLodVisibility(t, i) {
    const n = this.setupItemFilter(t);
    this.applyVisibilityState(t, i, n), n.needsUpdate = !0;
  }
  static getInterAttribute(t, i) {
    return t.getAttribute(i);
  }
  static computeLodSphere(t) {
    if (!t.boundingSphere) return;
    const i = t.getItemFirst();
    if (i) {
      const n = V_.getLodMidPoint(t, i), s = V_.getLodRadius(n, i);
      t.boundingSphere.radius = s;
    }
  }
  static newLodMaterialParams(t) {
    const i = { lodColor: { value: new Xn(t.color) }, lodSize: { value: new us(1, 1) }, lodOpacity: { value: t.opacity ?? 1 } };
    return { uniforms: vae.merge([An.common, i]), transparent: t.transparent ?? !1, vertexShader: Cle.vertex, fragmentShader: Cle.fragment };
  }
  static setLodFilter(t, i) {
    const n = t.getItemFilter(), s = n.array;
    for (let o = 0; o < i.position.length; ++o) {
      const r = i.position[o] / 2, l = i.size[o] / 2;
      l === 4294967295 ? s.fill(1, r) : s.fill(1, r, r + l);
    }
    n.needsUpdate = !0;
  }
  static getInstancedAttribute(t, i) {
    return t.getAttribute(i);
  }
  static computeLodBox(t) {
    if (!t.boundingBox) return;
    const i = t.getItemFirst();
    if (i) {
      const n = i.data.array;
      t.boundingBox.setFromArray(n);
    } else t.boundingBox.makeEmpty();
  }
  static setDataBuffer(t, i, n) {
    return (t = i.data).array = n, t.needsUpdate = !0, t;
  }
  static disposeAllData(t) {
    delete t.attributes.itemFilter, delete t.attributes.position, t.index = null, t.dispose(), V_.setupLodAttributes(t);
  }
  static setItemFirst(t, i, n, s) {
    let o = null;
    return i && (n.length === i.data.array.length ? o = this.setDataBuffer(o, i, n) : (i = void 0, this.disposeAllData(t))), o;
  }
  static setupFinish(t, i) {
    t && (i.onUploadCallback = t);
  }
  static resetAttributes(t, i, n, s) {
    return t || (i = new gle(n, 6, 1), t = new fN(i, 3, 0), s = new fN(i, 3, 3)), { itemFirst: t, dataBuffer: i, itemLast: s };
  }
  static setupItemFilter(t) {
    const i = t.getItemFirst().count;
    let n = t.getItemFilter();
    return n ? n.array.fill(0) : (n = new W1e(new Uint8Array(i), 1), t.setAttribute("itemFilter", n)), n;
  }
  static applyVisibilityState(t, i, n) {
    i !== !0 ? i && this.setLodFilter(t, i) : n.array.fill(1);
  }
  static getLodMidPoint(t, i) {
    const n = t.boundingSphere.center;
    return this.tempBox.setFromArray(i.data.array), this.tempBox.getCenter(n), n;
  }
  static getLodRadius(t, i) {
    let n = 0;
    const s = i.data.array.length;
    for (let o = 0; o < s; o += 3) {
      const r = i.data.array;
      V_.tempVec.fromArray(r, o);
      const l = t.distanceToSquared(V_.tempVec);
      n = Math.max(n, l);
    }
    return Math.sqrt(n);
  }
};
De(hJ, "tempVec", new Ge()), De(hJ, "tempBox", new Zs()), De(hJ, "vertices", new al([-1, 2, 0, 1, 2, 0, -1, 1, 0, 1, 1, 0, -1, 0, 0, 1, 0, 0, -1, -1, 0, 1, -1, 0], 3)), De(hJ, "indices", new iUe([0, 2, 1, 2, 3, 1, 2, 4, 3, 4, 5, 3, 4, 6, 5, 6, 7, 5], 1));
let Ov = hJ;
class xwe extends En {
  constructor(t, i) {
    super(t, i), De(this, "geometry"), De(this, "material"), this.geometry = t, this.material = i, Ov.setupLodMeshResize(this);
  }
}
class VYe extends SAe {
  constructor() {
    super(), De(this, "isLODGeometry", !0), Ov.setupLodAttributes(this);
  }
  isFiltered() {
    return !!this.getItemFilter();
  }
  computeBoundingBox() {
    this.boundingBox || (this.boundingBox = new Zs()), Ov.computeLodBox(this);
  }
  applyMatrix4(t) {
    return this.applyTransformToBuffers(t), this.updateBounds(), this;
  }
  computeBoundingSphere() {
    this.boundingSphere || (this.boundingSphere = new f3()), Ov.computeLodSphere(this);
  }
  getItemFilter() {
    return Ov.getInstancedAttribute(this, "itemFilter");
  }
  getItemLast() {
    return Ov.getInterAttribute(this, "itemLast");
  }
  getItemFirst() {
    return Ov.getInterAttribute(this, "itemFirst");
  }
  applyTransformToBuffers(t) {
    this.getItemFirst().applyMatrix4(t), this.getItemLast().applyMatrix4(t);
  }
  updateBounds() {
    this.boundingBox && this.computeBoundingBox(), this.boundingSphere && this.computeBoundingSphere();
  }
}
class zYe extends BA {
  constructor(t) {
    super(Ov.newLodMaterialParams(t)), De(this, "isLodMaterial", !0), De(this, "isLineMaterial", !0), this.clipping = !0, this.lights = !1, this.needsUpdate = !0;
  }
  get lodSize() {
    return this.uniforms.lodSize.value;
  }
  set lodColor(t) {
    this.uniforms.lodColor.value = t;
  }
  set lodSize(t) {
    this.uniforms.lodSize.value.copy(t);
  }
  get lodColor() {
    return this.uniforms.lodColor.value;
  }
}
class Ome {
  constructor() {
    De(this, "list", new f0()), De(this, "_modelMaterialMapping", /* @__PURE__ */ new Map()), De(this, "_definitions", /* @__PURE__ */ new Map()), De(this, "_idGenerator", new Cme()), De(this, "white", 4294967295);
  }
  static resetColors(t) {
    for (const i of t) {
      if (!i || !i.color) continue;
      const { color: n } = i;
      if (n.isColor) continue;
      const { r: s, g: o, b: r } = n;
      i.color = new Xn().setRGB(s, o, r, Hy);
    }
  }
  dispose(t) {
    this._definitions.delete(t);
    const i = this._modelMaterialMapping.get(t);
    if (i) {
      for (const n of i) {
        const s = this.list.get(n);
        s && (s.dispose(), this.list.delete(n));
      }
      this._modelMaterialMapping.delete(t);
    }
  }
  get(t, i) {
    const { modelId: n, objectClass: s, currentLod: o, templateId: r } = i;
    if (!n || s === void 0 || o === void 0) throw new Error("Fragments: material definition information is missing to create the material.");
    this._idGenerator.fromMaterialData({ modelId: n, objectClass: s, currentLod: o, templateId: r, ...t });
    const { value: l } = this._idGenerator;
    return this.getUniqueMaterial(l, t, i);
  }
  addDefinitions(t, i) {
    const n = this._definitions.get(t);
    n ? n.push(...i) : this._definitions.set(t, i);
  }
  createHighlights(t, i) {
    const { tileData: { highlightData: n, highlightIds: s }, modelId: o, material: r } = i, { geometry: l } = t, c = t.material.slice(0, 2), h = /* @__PURE__ */ new Map(), I = this._definitions.get(o);
    if (!I) return c;
    for (let p = 0; p < n.position.length; p++) {
      const y = s[p];
      this.processHighlight(h, y, I, r, i, c);
      const m = n.position[p], A = n.size[p], C = A === this.white ? 1 / 0 : A;
      l.addGroup(m, C, h.get(s[p]));
    }
    return c;
  }
  getFromRequest(t) {
    const { material: i, modelId: n } = t, s = this._definitions.get(n), o = s == null ? void 0 : s[i];
    if (!o) throw new Error(`Fragments: Missing mesh material for index ${i}`);
    return this.get(o, t);
  }
  newLODMaterial(t, i) {
    const { data: n } = t, s = new Xn(n.color);
    i.currentLod === Bo.WIRES && s.multiplyScalar(0.85);
    const o = { color: s, ...this.getParameters(n) }, r = new zYe(o);
    return r.userData = { customId: n.customId }, r;
  }
  getParameters(t) {
    const { opacity: i, transparent: n } = t;
    return { opacity: i, transparent: n || i < 1, clipIntersection: !1 };
  }
  new(t, i) {
    const { objectClass: n, templateId: s } = i;
    let o;
    if (n === tE.SHELL) o = new vAe({ color: t.color, transparent: t.opacity < 1, opacity: t.opacity, userData: { customId: t.customId, localId: t.localId }, depthTest: t.depthTest ?? !0, depthWrite: t.depthWrite ?? !0, side: t.renderedFaces === 1 ? $y : xA });
    else {
      if (n !== tE.LINE) throw new Error("Fragments: Unsupported object class");
      o = this.newLODMaterial({ data: t, instancing: s !== void 0 }, i);
    }
    return o;
  }
  addMaterialToModel(t, i) {
    let n = this._modelMaterialMapping.get(t);
    n || (n = /* @__PURE__ */ new Set(), this._modelMaterialMapping.set(t, n)), n.add(i);
  }
  processHighlight(t, i, n, s, o, r) {
    if (!t.has(i)) {
      const l = n[s], c = n[i], { preserveOriginalMaterial: h, ...I } = c, p = { ...l };
      h ? (I.color !== void 0 && (p.color = I.color), I.opacity !== void 0 && (p.opacity = I.opacity), I.transparent !== void 0 && (p.transparent = I.transparent), I.renderedFaces !== void 0 && (p.renderedFaces = I.renderedFaces), I.depthTest !== void 0 && (p.depthTest = I.depthTest)) : Object.assign(p, I);
      const y = this.get(p, o);
      r.push(y), t.set(i, r.length - 1);
    }
  }
  getUniqueMaterial(t, i, n) {
    const s = n.modelId, o = this.list.get(t);
    if (o) return o;
    const r = this.new(i, n);
    return this.list.set(t, r), this.addMaterialToModel(s, t), this.list.get(t);
  }
}
let jYe = class {
  async getHighlight(t, i) {
    const n = await t.threads.invoke(t.modelId, "getHighlight", [i]);
    return Ome.resetColors(n), n;
  }
  async highlight(t, i, n) {
    await t.threads.invoke(t.modelId, "highlight", [i, n]);
  }
  async setColor(t, i, n) {
    await t.threads.invoke(t.modelId, "setColor", [i, n]);
  }
  async resetColor(t, i) {
    await t.threads.invoke(t.modelId, "resetColor", [i]);
  }
  async setOpacity(t, i, n) {
    await t.threads.invoke(t.modelId, "setOpacity", [i, n]);
  }
  async resetOpacity(t, i) {
    await t.threads.invoke(t.modelId, "resetOpacity", [i]);
  }
  async getHighlightItemIds(t) {
    return t.threads.invoke(t.modelId, "getHighlightItemIds");
  }
  async resetHighlight(t, i) {
    await t.threads.invoke(t.modelId, "resetHighlight", [i]);
  }
};
class WYe {
  async getSection(t, i, n) {
    const s = [i, n];
    return await t.threads.invoke(t.modelId, "getSection", s);
  }
}
class YYe {
  async dispose(t, i, n, s) {
    i.list.delete(t.modelId), await this.requestModelDelete(t), t.threads.delete(t.modelId), t.object.removeFromParent(), this.deleteAllTiles(t), i.materials.dispose(t.modelId), n.dispose(), s.dispose();
  }
  async getBuffer(t, i) {
    return t.threads.invoke(t.modelId, "getBuffer", [i]);
  }
  async getCategories(t) {
    return t.threads.invoke(t.modelId, "getCategories");
  }
  async getMaxLocalId(t) {
    return t.threads.invoke(t.modelId, "getMaxLocalId");
  }
  async getLocalIdsByGuids(t, i) {
    return t.threads.invoke(t.modelId, "getLocalIdsByGuids", [i]);
  }
  async getSpatialStructure(t) {
    return t.threads.invoke(t.modelId, "getSpatialStructure");
  }
  async getItemsWithGeometry(t) {
    return (await t.threads.invoke(t.modelId, "getItemsWithGeometry", [])).map(((i) => t.getItem(i)));
  }
  async getItemsWithGeometryCategories(t) {
    return t.threads.invoke(t.modelId, "getItemsWithGeometryCategories", []);
  }
  async getItemsIdsWithGeometry(t) {
    return t.threads.invoke(t.modelId, "getItemsWithGeometry", []);
  }
  async getItemsOfCategories(t, i) {
    const n = [i];
    return await t.threads.invoke(t.modelId, "getItemsOfCategories", n);
  }
  async getItemsByQuery(t, i, n) {
    const s = [i, n];
    return await t.threads.invoke(t.modelId, "getItemsByQuery", s);
  }
  async getMetadata(t) {
    return t.threads.invoke(t.modelId, "getMetadata", []);
  }
  async getGuidsByLocalIds(t, i) {
    return t.threads.invoke(t.modelId, "getGuidsByLocalIds", [i]);
  }
  async requestModelDelete(t) {
    await t.threads.fetch({ class: LA.DELETE_MODEL, modelId: t.modelId });
  }
  deleteAllTiles(t) {
    for (const [i] of t.tiles) t.tiles.delete(i);
  }
}
class qYe {
  async getSequenced(t, i, n, s) {
    const o = [i, n, s];
    return await t.threads.invoke(t.modelId, "getSequenced", o);
  }
}
class $Ye {
  constructor(t, i) {
    De(this, "_deltaModels", {}), De(this, "_fragments"), De(this, "_connection"), this._fragments = t, this._connection = i;
  }
  async edit(t, i, n = { removeRedo: !0 }) {
    const s = this._fragments.models.list.get(t);
    if (!s) throw new Error(`Model ${t} not found`);
    const o = this._deltaModels[t] || [];
    this._deltaModels[t] = null, n.removeRedo && s._setRequests({ undoneRequests: [] });
    const { deltaModelBuffer: r, ids: l } = await s._edit(i);
    for (let I = 0; I < i.length; I++) i[I].localId === void 0 && (i[I].localId = l[I]);
    const c = await this.load(r, s);
    this._deltaModels[t] = [c], s.deltaModelId = c.modelId;
    const h = [];
    for (const I of o) h.push(I.dispose());
    return await Promise.all(h), l;
  }
  async save(t) {
    const i = this._fragments.models.list.get(t);
    if (!i) return console.log(`Model ${t} not found`), null;
    const n = i.object.parent, s = await i._getRequests(), o = i.camera || void 0, r = await i._save();
    await i.dispose();
    const l = await this._fragments.load(r, { modelId: t, raw: !0, camera: o });
    return await l._setRequests({ undoneRequests: s.undoneRequests }), n && n.add(l.object), s;
  }
  async reset(t) {
    const i = this._fragments.models.list.get(t);
    i ? (await i._reset(), await this.disposeDeltaModels(t)) : console.log(`Model ${t} not found`);
  }
  async getRequests(t) {
    const i = this._fragments.models.list.get(t);
    if (!i) throw new Error(`Model ${t} not found`);
    return i._getRequests();
  }
  async selectRequest(t, i) {
    const n = this._fragments.models.list.get(t);
    if (!n) throw new Error(`Model ${t} not found`);
    return n._selectRequest(i);
  }
  async _update(t) {
    const i = this._deltaModels[t];
    if (i) {
      const n = [];
      for (const s of i) n.push(s._refreshView());
      await Promise.all(n);
    }
  }
  async disposeDeltaModels(t) {
    const i = this._deltaModels[t];
    if (i) {
      for (const n of i) await n.dispose();
      this._deltaModels[t] = [];
    }
  }
  async load(t, i) {
    const n = Yo.DELTA_MODEL_ID, s = `${i.modelId}${n}${performance.now()}`, o = new XSe(s, this._fragments.models, this._connection, this._fragments.editor);
    o._setDeltaModel(i.modelId), o.frozen = !0, o.graphicsQuality = this._fragments.settings.graphicsQuality;
    try {
      this._fragments.models.list.set(o.modelId, o), await o._setup(t, !0), i.object.add(o.object);
    } catch (l) {
      throw this._fragments.models.list.delete(o.modelId), l;
    }
    const r = i.camera;
    return r && o.useCamera(r), o.frozen = !1, o;
  }
}
class KYe {
  constructor(t) {
    De(this, "_nextTempIds", {}), De(this, "_requests", {}), De(this, "_fragments"), this._fragments = t;
  }
  getRequests(t) {
    const i = this.getModelRequests(t);
    this._requests[t] = this.newRequests();
    const { create: n, update: s, remove: o, relations: { create: r, update: l, remove: c } } = i, h = Object.values(n), I = Object.values(s), p = [...Object.values(o), ...h, ...I, ...Object.values(r), ...Object.values(l), ...Object.values(c)];
    return p.length > 0 ? p : null;
  }
  createMaterial(t, i) {
    const n = this.getNextTempId(t), s = { r: 255 * i.color.r, g: 255 * i.color.g, b: 255 * i.color.b, a: 255 * i.opacity, renderedFaces: i.side === $y ? 1 : 0, stroke: 0 };
    return this.addRequest(t, n, "create", { type: gn.CREATE_MATERIAL, tempId: n, data: s }), n;
  }
  createLocalTransform(t, i) {
    const n = this.getNextTempId(t), s = _o.transformFromMatrix(i);
    return this.addRequest(t, n, "create", { type: gn.CREATE_LOCAL_TRANSFORM, tempId: n, data: s }), n;
  }
  createShell(t, i) {
    const n = this.getNextTempId(t), s = _o.representationFromGeometry(i);
    return this.addRequest(t, n, "create", { type: gn.CREATE_REPRESENTATION, tempId: n, data: s }), n;
  }
  createCircleExtrusion(t, i) {
    const n = _o.bboxFromCircleExtrusion(i), s = this.getNextTempId(t);
    return this.addRequest(t, s, "create", { type: gn.CREATE_REPRESENTATION, tempId: s, data: { representationClass: Mr.CIRCLE_EXTRUSION, bbox: n, geometry: i } }), s;
  }
  createGlobalTransform(t, i, n) {
    const s = this.getNextTempId(t), o = _o.transformFromMatrix(i);
    return this.addRequest(t, s, "create", { type: gn.CREATE_GLOBAL_TRANSFORM, tempId: s, data: { itemId: n, ...o } }), s;
  }
  createSample(t, i) {
    const { localTransform: n, representation: s, material: o, globalTransform: r } = i, l = this.getNextTempId(t);
    return this.addRequest(t, l, "create", { type: gn.CREATE_SAMPLE, tempId: l, data: { localTransform: n, representation: s, material: o, item: r } }), l;
  }
  createItem(t, i) {
    const n = this.getNextTempId(t);
    return this.addRequest(t, n, "create", { type: gn.CREATE_ITEM, tempId: n, data: i }), n;
  }
  setItem(t, i) {
    const n = i._localId;
    if (!n) throw new Error("No local id provided for the item to set");
    const s = n.value, o = Yo.itemDataToRawItemData(i);
    this.addRequest(t, n.value, "update", { type: gn.UPDATE_ITEM, localId: s, data: o });
  }
  async relate(t, i, n, s) {
    const o = this._fragments.models.list.get(t);
    if (!o) throw new Error(`Model ${t} not found`);
    const r = (await o.getRelations([i])).get(i);
    if (r) {
      if (r.data[n]) {
        const l = new Set(r.data[n]);
        for (const c of s) l.add(c);
        r.data[n] = Array.from(l);
      } else r.data[n] = s;
      this.addRelationRequest(t, i, "update", { type: gn.UPDATE_RELATION, localId: i, data: r });
    } else this.addRelationRequest(t, i, "create", { type: gn.CREATE_RELATION, localId: i, data: { data: { [n]: s } } });
  }
  async unrelate(t, i, n, s) {
    const o = this._fragments.models.list.get(t);
    if (!o) throw new Error(`Model ${t} not found`);
    const r = (await o.getRelations([i])).get(i);
    if (!r || !r.data[n]) return;
    const l = new Set(r.data[n]);
    for (const c of s) l.delete(c);
    r.data[n] = Array.from(l), this.addRelationRequest(t, i, "update", { type: gn.UPDATE_RELATION, localId: i, data: r });
  }
  async get(t, i) {
    const n = this._fragments.models.list.get(t);
    if (!n) throw new Error(`Model ${t} not found`);
    return n._getElements(i);
  }
  async create(t, i) {
    for (const l of i) {
      const { attributes: c, samples: h, globalTransform: I } = l, p = this.getNextTempId(t), y = Yo.itemDataToRawItemData(c);
      this.addRequest(t, p, "create", { type: gn.CREATE_ITEM, tempId: p, data: y });
      const m = this.createGlobalTransform(t, I, p);
      for (const A of h) {
        const { localTransform: C, representation: O, material: R } = A;
        let F, L, P;
        F = typeof C != "number" && typeof C != "string" ? this.createLocalTransform(t, C) : C, L = typeof O != "number" && typeof O != "string" ? this.createShell(t, O) : O, P = typeof R != "number" && typeof R != "string" ? this.createMaterial(t, R) : R, this.createSample(t, { localTransform: F, representation: L, material: P, globalTransform: m });
      }
    }
    const n = this.getRequests(t);
    if (!n) return console.log("Something went wrong, no requests sent"), null;
    const s = [];
    for (let l = 0; l < n.length; l++) n[l].type === gn.CREATE_ITEM && s.push(l);
    const o = await this._fragments.editor.edit(t, n), r = s.map(((l) => o[l]));
    return this.get(t, r);
  }
  delete(t, i) {
    for (const n of i) {
      n.delete();
      const s = n.getRequests();
      if (s) for (const o of s) {
        const r = o.localId;
        r && this.addRequest(t, r, "remove", o);
      }
    }
  }
  async applyChanges(t, i = []) {
    const n = [];
    for (const o of i) {
      const r = o.getRequests();
      r && n.push(...r);
    }
    const s = this.getRequests(t);
    return s && n.push(...s), n.length > 0 ? this._fragments.editor.edit(t, n) : [];
  }
  async deleteData(t, i) {
    const n = this._fragments.models.list.get(t);
    if (!n) throw new Error(`Model ${t} not found`);
    const s = i.filterInUse ?? !0, { itemIds: o, materialIds: r, localTransformIds: l, representationIds: c, sampleIds: h } = i, I = /* @__PURE__ */ new Set(), p = /* @__PURE__ */ new Set(), y = /* @__PURE__ */ new Set(), m = /* @__PURE__ */ new Set();
    if (s) {
      const A = await n.getSamples();
      for (const C of A.values()) I.add(C.material), p.add(C.localTransform), y.add(C.item), m.add(C.representation);
    }
    if (r) for (const A of r) s && I.has(A) ? console.log(`Material ${A} is used, skipping`) : this.isBeingCreated(t, A) ? delete this._requests[t].create[A] : this.addRequest(t, A, "remove", { type: gn.DELETE_MATERIAL, localId: A });
    if (l) for (const A of l) s && p.has(A) ? console.log(`Local transform ${A} is used, skipping`) : this.isBeingCreated(t, A) ? delete this._requests[t].create[A] : this.addRequest(t, A, "remove", { type: gn.DELETE_LOCAL_TRANSFORM, localId: A });
    if (c) for (const A of c) s && m.has(A) ? console.log(`Representation ${A} is used, skipping`) : this.isBeingCreated(t, A) ? delete this._requests[t].create[A] : this.addRequest(t, A, "remove", { type: gn.DELETE_REPRESENTATION, localId: A });
    if (h) for (const A of h) this.isBeingCreated(t, A) ? delete this._requests[t].create[A] : this.addRequest(t, A, "remove", { type: gn.DELETE_SAMPLE, localId: A });
    if (o) for (const A of o) this.isBeingCreated(t, A) ? delete this._requests[t].create[A] : this.addRequest(t, A, "remove", { type: gn.DELETE_ITEM, localId: A });
  }
  getNextTempId(t) {
    return this._nextTempIds[t] || (this._nextTempIds[t] = 0), (this._nextTempIds[t]++).toString();
  }
  addRelationRequest(t, i, n, s) {
    this.getModelRequests(t).relations[n][i] = s;
  }
  addRequest(t, i, n, s) {
    this.getModelRequests(t)[n][i] = s;
  }
  getModelRequests(t) {
    return this._requests[t] || (this._requests[t] = this.newRequests()), this._requests[t];
  }
  isBeingCreated(t, i) {
    return this._requests[t] ? this._requests[t].create[i] !== void 0 : !1;
  }
  newRequests() {
    return { update: {}, create: {}, remove: {}, relations: { create: {}, update: {}, remove: {} } };
  }
}
class ZYe {
  constructor(t, i) {
    De(this, "onEdit", new Bp()), De(this, "_editHelper"), De(this, "_elementsHelper"), this._editHelper = new $Ye(t, i), this._elementsHelper = new KYe(t);
  }
  async edit(t, i, n = { removeRedo: !0 }) {
    const s = await this._editHelper.edit(t, i, n);
    return this.onEdit.trigger(), s;
  }
  async save(t) {
    return this._editHelper.save(t);
  }
  async reset(t) {
    await this._editHelper.reset(t);
  }
  async getModelRequests(t) {
    return this._editHelper.getRequests(t);
  }
  async selectRequest(t, i) {
    return this._editHelper.selectRequest(t, i);
  }
  clearElementsRequests(t) {
    return this._elementsHelper.getRequests(t);
  }
  createMaterial(t, i) {
    return this._elementsHelper.createMaterial(t, i);
  }
  createLocalTransform(t, i) {
    return this._elementsHelper.createLocalTransform(t, i);
  }
  createShell(t, i) {
    return this._elementsHelper.createShell(t, i);
  }
  createCircleExtrusion(t, i) {
    return this._elementsHelper.createCircleExtrusion(t, i);
  }
  createGlobalTransform(t, i, n) {
    return this._elementsHelper.createGlobalTransform(t, i, n);
  }
  createSample(t, i) {
    return this._elementsHelper.createSample(t, i);
  }
  createItem(t, i) {
    return this._elementsHelper.createItem(t, i);
  }
  setItem(t, i) {
    return this._elementsHelper.setItem(t, i);
  }
  async relate(t, i, n, s) {
    return this._elementsHelper.relate(t, i, n, s);
  }
  async unrelate(t, i, n, s) {
    return this._elementsHelper.unrelate(t, i, n, s);
  }
  async getElements(t, i) {
    return this._elementsHelper.get(t, i);
  }
  async createElements(t, i) {
    return this._elementsHelper.create(t, i);
  }
  deleteElements(t, i) {
    return this._elementsHelper.delete(t, i);
  }
  async applyChanges(t, i = []) {
    return this._elementsHelper.applyChanges(t, i);
  }
  async deleteData(t, i) {
    return this._elementsHelper.deleteData(t, i);
  }
  async _update(t) {
    await this._editHelper._update(t);
  }
}
class QYe {
  constructor(t, i, n) {
    De(this, "localId"), De(this, "model"), De(this, "core"), De(this, "config", { data: { attributesDefault: !0, relations: { IsDefinedBy: { attributes: !0, relations: !0 }, DefinesOcurrence: { attributes: !1, relations: !1 } } } }), De(this, "updateRequests", {}), De(this, "createRequests", {}), De(this, "removeRequests", {}), De(this, "_elementChanged", !1), this.localId = t, this.core = i, this.model = n;
  }
  get elementChanged() {
    return this._elementChanged;
  }
  getRequests() {
    const t = Object.values(this.createRequests);
    this.createRequests = {};
    const i = Object.values(this.updateRequests);
    this.updateRequests = {};
    const n = Object.values(this.removeRequests);
    this.removeRequests = {};
    const s = [...n, ...t, ...i];
    return s.length > 0 ? s : null;
  }
  delete() {
    this.createRequests[this.localId] ? delete this.createRequests[this.localId] : this.removeRequests[this.localId] = { type: gn.DELETE_ITEM, localId: this.localId };
    for (const t in this.core.samples) {
      const i = this.core.samples[t], n = parseInt(t, 10);
      this.createRequests[i.localTransform] ? delete this.createRequests[i.localTransform] : this.removeRequests[i.localTransform] = { type: gn.DELETE_LOCAL_TRANSFORM, localId: i.localTransform }, this.createRequests[i.representation] ? delete this.createRequests[i.representation] : this.removeRequests[i.representation] = { type: gn.DELETE_REPRESENTATION, localId: i.representation }, this.createRequests[i.material] ? delete this.createRequests[i.material] : this.removeRequests[i.material] = { type: gn.DELETE_MATERIAL, localId: i.material }, this.createRequests[i.item] ? delete this.createRequests[i.item] : this.removeRequests[i.item] = { type: gn.DELETE_GLOBAL_TRANSFORM, localId: i.item }, this.createRequests[n] ? delete this.createRequests[n] : this.removeRequests[n] = { type: gn.DELETE_SAMPLE, localId: n };
    }
  }
  async getData() {
    return (await this.model.getItemsData([this.localId], this.config.data))[0];
  }
  getGlobalTransformId() {
    return parseInt(Object.keys(this.core.globalTransforms)[0], 10);
  }
  disposeMeshes(t, i) {
    const n = (i == null ? void 0 : i.disposeGeometry) ?? !0, s = (i == null ? void 0 : i.disposeMaterial) ?? !0;
    t.removeFromParent(), t.traverse(((o) => {
      o instanceof En && (n && o.geometry.dispose(), s && o.material.dispose());
    }));
  }
  async getMeshes() {
    const t = new E5(), i = Object.values(this.core.globalTransforms)[0], n = _o.matrixFromTransform(i);
    t.applyMatrix4(n);
    const s = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), r = Object.keys(this.core.representations).map(Number), l = await this.model.getGeometries(r), c = /* @__PURE__ */ new Map();
    for (const h of l) {
      const I = h.representationId;
      c.set(I, h);
    }
    for (const h in this.core.samples) {
      const I = parseInt(h, 10), p = this.core.samples[I], y = c.get(p.representation);
      if (!y) throw new Error(`No geometry found for representation ${p.representation}`);
      const { indices: m, positions: A, normals: C } = y;
      if (!m || !A || !C) continue;
      if (!s.has(p.material)) {
        const { r: W, g: re, b: ce, a: te } = this.core.materials[p.material], ee = new Xn().setRGB(W / 255, re / 255, ce / 255, Hy), Ne = new vAe({ color: ee, transparent: !0, opacity: te / 255 });
        Ne.userData.localId = p.material, s.set(p.material, Ne);
      }
      const O = s.get(p.material), R = this.core.localTransforms[p.localTransform], F = _o.matrixFromTransform(R);
      if (!o.has(p.representation)) {
        const W = new Vl();
        W.setIndex(Array.from(m)), W.setAttribute("position", new zu(A, 3)), W.setAttribute("normal", new zu(C, 3)), W.userData.localId = p.representation, o.set(p.representation, W);
      }
      const L = o.get(p.representation), P = new E5();
      P.userData.localId = p.localTransform, t.add(P), P.applyMatrix4(F);
      const z = new En(L, O);
      z.userData.sampleId = I, P.add(z);
    }
    return t;
  }
  async setMeshes(t) {
    const i = await this.getMeshes();
    let n = !0;
    t.updateMatrix();
    const s = 1e3;
    for (let p = 0; p < t.matrix.elements.length; p++)
      if (Math.trunc(t.matrix.elements[p] * s) / s !== Math.trunc(i.matrix.elements[p] * s) / s) {
        n = !1;
        break;
      }
    if (!n) {
      const p = parseInt(Object.keys(this.core.globalTransforms)[0], 10), y = this.core.globalTransforms[p];
      _o.transformFromMatrix(t.matrix, y), this._elementChanged = !0, this.updateRequests[p] = { type: gn.UPDATE_GLOBAL_TRANSFORM, localId: p, data: y };
    }
    const o = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
    i.traverse(((p) => {
      p instanceof En && o.set(p.material.userData.localId, p.material);
    })), t.traverse(((p) => {
      p instanceof En && r.set(p.material.userData.localId, p.material);
    }));
    for (const [p, y] of o) {
      const m = r.get(p);
      if (!m) continue;
      const A = y.color.r, C = y.color.g, O = y.color.b, R = y.opacity, F = m.color.r, L = m.color.g, P = m.color.b, z = m.opacity, W = this.core.materials[p];
      W.r = 255 * F, W.g = 255 * L, W.b = 255 * P, W.a = 255 * z, A === F && C === L && O === P && R === z || (this._elementChanged = !0, this.updateRequests[p] = { type: gn.UPDATE_MATERIAL, localId: p, data: W });
    }
    o.clear(), r.clear();
    const l = /* @__PURE__ */ new Map(), c = /* @__PURE__ */ new Map();
    for (const p of t.children) p.updateMatrix(), c.set(p.userData.localId, p.matrix);
    for (const p of i.children) l.set(p.userData.localId, p.matrix);
    for (const [p, y] of l) {
      const m = c.get(p);
      if (m && !y.equals(m)) {
        const A = this.core.localTransforms[p];
        _o.transformFromMatrix(m, A), this._elementChanged = !0, this.updateRequests[p] = { type: gn.UPDATE_LOCAL_TRANSFORM, localId: p, data: A };
      }
    }
    l.clear(), c.clear();
    const h = /* @__PURE__ */ new Map(), I = /* @__PURE__ */ new Map();
    t.traverse(((p) => {
      if (p instanceof En) {
        const y = p.geometry;
        I.set(y.userData.localId, y);
      }
    })), i.traverse(((p) => {
      if (p instanceof En) {
        const y = p.geometry;
        h.set(y.userData.localId, y);
      }
    }));
    for (const [p, y] of h) {
      const m = this.core.representations[p];
      if (m.representationClass === Mr.CIRCLE_EXTRUSION) continue;
      const A = I.get(p);
      if (!A) continue;
      let C = !0;
      const O = y.getAttribute("position"), R = A.getAttribute("position");
      if (O && R) if (O.count === R.count) {
        for (let F = 0; F < O.array.length; F++) if (O.array[F] !== R.array[F]) {
          C = !1;
          break;
        }
      } else C = !1;
      C || (_o.representationFromGeometry(A, m), this._elementChanged = !0, this.updateRequests[p] = { type: gn.UPDATE_REPRESENTATION, localId: p, data: m });
    }
  }
  createSamples(t) {
    for (const i of t) {
      const n = Math.trunc(performance.now());
      this.core.samples[n] = i, this.createRequests[n] = { type: gn.CREATE_SAMPLE, data: i };
    }
  }
  deleteSamples(t) {
    this._elementChanged = !0;
    for (const i of t)
      Object.keys(this.core.samples).length !== 1 && (delete this.core.samples[i], delete this.updateRequests[i], this.createRequests[i] ? delete this.createRequests[i] : this.removeRequests[i] = { type: gn.DELETE_SAMPLE, localId: i });
  }
  async updateSamples() {
    const t = new Set(Object.keys(this.core.materials).map(Number)), i = new Set(Object.keys(this.core.localTransforms).map(Number)), n = new Set(Object.keys(this.core.globalTransforms).map(Number)), s = new Set(Object.keys(this.core.representations).map(Number)), o = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), l = /* @__PURE__ */ new Set(), c = /* @__PURE__ */ new Set(), h = /* @__PURE__ */ new Set();
    for (const A in this.core.samples) {
      const C = parseInt(A, 10), O = this.core.samples[C];
      t.delete(O.material), n.delete(O.item), i.delete(O.localTransform), s.delete(O.representation), this.core.materials[O.material] || (h.add(C), o.add(O.material)), this.core.globalTransforms[O.item] || (h.add(C), r.add(O.item)), this.core.localTransforms[O.localTransform] || (h.add(C), l.add(O.localTransform)), this.core.representations[O.representation] || (h.add(C), c.add(O.representation));
    }
    for (const A of t) delete this.core.materials[A];
    for (const A of n) delete this.core.globalTransforms[A];
    for (const A of i) delete this.core.localTransforms[A];
    for (const A of s) delete this.core.representations[A];
    let I = /* @__PURE__ */ new Map();
    o.size && (I = await this.model.getMaterials(o));
    let p = /* @__PURE__ */ new Map();
    r.size && (p = await this.model.getGlobalTransforms(r));
    let y = /* @__PURE__ */ new Map();
    l.size && (y = await this.model.getLocalTransforms(l));
    let m = /* @__PURE__ */ new Map();
    c.size && (m = await this.model.getRepresentations(c));
    for (const [A, C] of I) this.core.materials[A] = C;
    for (const [A, C] of p) this.core.globalTransforms[A] = C;
    for (const [A, C] of y) this.core.localTransforms[A] = C;
    for (const [A, C] of m) this.core.representations[A] = C;
    for (const A of h) this.createRequests[A] ? this.createRequests[A].data = this.core.samples[A] : (this._elementChanged = !0, this.updateRequests[A] = { type: gn.UPDATE_SAMPLE, localId: A, data: this.core.samples[A] });
  }
}
class JYe {
  async edit(t, i) {
    return t.threads.invoke(t.modelId, "edit", [i]);
  }
  async reset(t) {
    return t.threads.invoke(t.modelId, "reset", []);
  }
  async save(t) {
    return t.threads.invoke(t.modelId, "save", []);
  }
  async getItemsGeometry(t, i, n) {
    const s = await t.threads.invoke(t.modelId, "getItemsGeometry", [i, n]), o = t.deltaModelId;
    if (!o) return s;
    const r = await t.threads.invoke(o, "getItemsGeometry", [i]), l = /* @__PURE__ */ new Map();
    for (const c of s) {
      const h = c[0].localId;
      l.set(h, c);
    }
    for (const c of r) {
      const h = c[0].localId;
      l.set(h, c);
    }
    return Array.from(l.values());
  }
  async getGeometries(t, i) {
    const n = await t.threads.invoke(t.modelId, "getGeometries", [i]), s = t.deltaModelId;
    if (!s) return n;
    const o = await t.threads.invoke(s, "getGeometries", [i]), r = /* @__PURE__ */ new Map();
    for (const l of n) {
      const c = l.representationId;
      r.set(c, l);
    }
    for (const l of o) {
      const c = l.representationId;
      r.set(c, l);
    }
    return Array.from(r.values());
  }
  async getMaterialsIds(t) {
    return t.threads.invoke(t.modelId, "getMaterialsIds", []);
  }
  async getMaterials(t, i) {
    return t.threads.invoke(t.modelId, "getMaterials", [i]);
  }
  async getSamplesIds(t) {
    return t.threads.invoke(t.modelId, "getSamplesIds", []);
  }
  async getSamples(t, i) {
    return t.threads.invoke(t.modelId, "getSamples", [i]);
  }
  async getRepresentationsIds(t) {
    return t.threads.invoke(t.modelId, "getRepresentationsIds", []);
  }
  async getRepresentations(t, i) {
    return t.threads.invoke(t.modelId, "getRepresentations", [i]);
  }
  async getLocalTransformsIds(t) {
    return t.threads.invoke(t.modelId, "getLocalTransformsIds", []);
  }
  async getLocalTransforms(t, i) {
    return t.threads.invoke(t.modelId, "getLocalTransforms", [i]);
  }
  async getGlobalTransformsIds(t) {
    return t.threads.invoke(t.modelId, "getGlobalTransformsIds", []);
  }
  async getGlobalTransforms(t, i) {
    return t.threads.invoke(t.modelId, "getGlobalTransforms", [i]);
  }
  async getItemsIds(t) {
    return t.threads.invoke(t.modelId, "getItemsIds", []);
  }
  async getItems(t, i) {
    return t.threads.invoke(t.modelId, "getItems", [i]);
  }
  async getRelations(t, i) {
    return t.threads.invoke(t.modelId, "getRelations", [i]);
  }
  async getGlobalTranformsIdsOfItems(t, i) {
    return await t.threads.invoke(t.modelId, "getGlobalTranformsIdsOfItems", [i]);
  }
  async getEditedElements(t) {
    return t.deltaModelId ? t.threads.invoke(t.deltaModelId, "getItemsWithGeometry", []) : [];
  }
  async getElements(t, i) {
    const n = await t.threads.invoke(t.modelId, "getElementsData", [i]);
    if (t.deltaModelId) {
      const o = await t.threads.invoke(t.deltaModelId, "getElementsData", [i]);
      for (const r in o) n[r] = o[r];
    }
    const s = [];
    for (const o in n) {
      const r = new QYe(Number(o), n[o], t);
      s.push(r);
    }
    return s;
  }
  async getRequests(t) {
    return t.threads.invoke(t.modelId, "getRequests", []);
  }
  async setRequests(t, i) {
    return t.threads.invoke(t.modelId, "setRequests", [i]);
  }
  async selectRequest(t, i) {
    return t.threads.invoke(t.modelId, "selectRequest", [i]);
  }
}
class XYe {
  constructor(t) {
    De(this, "model"), De(this, "_grids", new E5()), De(this, "_gridMaterial", new AUe({ color: 16777215, linewidth: 5, depthTest: !1, dashSize: 1, gapSize: 0.3 })), this.model = t;
  }
  async getGrids() {
    return this._grids.children.length || await this.constructGrids(), this._grids;
  }
  async constructGrids() {
    const t = await this.model.threads.invoke(this.model.modelId, "getGrids"), i = new Ln();
    for (const n of t) {
      const s = new E5();
      this._grids.add(s), s.userData.id = n.id, i.fromArray(n.transform), s.applyMatrix4(i), this.getGridAxis(n, s, "uAxes"), this.getGridAxis(n, s, "vAxes"), this.getGridAxis(n, s, "wAxes"), this._grids.add(s);
    }
  }
  getGridAxis(t, i, n) {
    for (const { curve: s, tag: o } of t[n]) {
      const [r, l, c, h] = s, I = new Vl();
      I.setAttribute("position", new zu(new Float32Array([r, l, 0, c, h, 0]), 3));
      const p = new fv(I, this._gridMaterial);
      p.userData.tag = o, p.computeLineDistances(), p.renderOrder = 1, i.add(p);
    }
  }
  dispose() {
    this._grids.removeFromParent();
    for (const t of this._grids.children) {
      const i = t;
      i.geometry.dispose(), i.geometry = void 0, i.material = void 0;
    }
    this._gridMaterial.dispose(), this._gridMaterial = void 0;
  }
}
const JSe = class DIe {
  constructor(t, i, n, s) {
    De(this, "attrsChanges", /* @__PURE__ */ new Map()), De(this, "relsChanges", /* @__PURE__ */ new Map()), De(this, "threads"), De(this, "tiles", new f0()), De(this, "object", new wu()), De(this, "graphicsQuality", 0), De(this, "deltaModelId", null), De(this, "_boxManager", new _Ye()), De(this, "_itemsManager", new FYe()), De(this, "_coordinatesManager", new xYe()), De(this, "_setupManager", new LYe()), De(this, "_viewManager", new HYe()), De(this, "_raycastManager", new GYe()), De(this, "_visibilityManager", new kYe()), De(this, "_highlightManager", new jYe()), De(this, "_sectionManager", new WYe()), De(this, "_dataManager", new YYe()), De(this, "_sequenceManager", new qYe()), De(this, "_bbox", new Zs()), De(this, "_alignmentsManager"), De(this, "_gridsManager"), De(this, "_meshManager"), De(this, "_editManager", new JYe()), De(this, "_editor"), De(this, "_isProcessing", !1), De(this, "_isLoaded", !1), De(this, "_frozen", !1), De(this, "_isSetup", !1), De(this, "_parentModelId", null), this.object.name = t, this.object.up.set(0, 0, 1), this._meshManager = i, this.threads = n, this._editor = s, this._alignmentsManager = new OYe(this), this._gridsManager = new XYe(this), this.tiles.onItemSet.add((({ value: o }) => this.object.add(o))), this.tiles.onBeforeDelete.add((({ value: o }) => {
      this.object.remove(o), o.geometry.dispose(), Cv.forEach(o.material, ((r) => r.dispose()));
    }));
  }
  get modelId() {
    return this.object.name;
  }
  get box() {
    return this._bbox.clone().applyMatrix4(this.object.matrixWorld);
  }
  get isBusy() {
    const t = this._meshManager.requests.arePending;
    return !this._isLoaded || this._isProcessing || t;
  }
  get frozen() {
    return !!this._frozen;
  }
  set frozen(t) {
    t !== this._frozen && (this._frozen = t, t || this._refreshView());
  }
  get getClippingPlanesEvent() {
    return this._viewManager.getClippingPlanesEvent;
  }
  set getClippingPlanesEvent(t) {
    this._viewManager.getClippingPlanesEvent = t;
  }
  get camera() {
    return this._viewManager.currentCamera;
  }
  get isDeltaModel() {
    return this.object.userData[DIe._deltaModelId];
  }
  get parentModelId() {
    return this._parentModelId;
  }
  async dispose() {
    this._isLoaded = !1, await this._dataManager.dispose(this, this._meshManager, this._alignmentsManager, this._gridsManager);
  }
  async getSpatialStructure() {
    return this._dataManager.getSpatialStructure(this);
  }
  async getLocalIdsByGuids(t) {
    return this._dataManager.getLocalIdsByGuids(this, t);
  }
  async getCategories() {
    return this._dataManager.getCategories(this);
  }
  async getItemsWithGeometryCategories() {
    return this._dataManager.getItemsWithGeometryCategories(this);
  }
  async getItemsWithGeometry() {
    return this._dataManager.getItemsWithGeometry(this);
  }
  async getItemsIdsWithGeometry() {
    return this._dataManager.getItemsIdsWithGeometry(this);
  }
  async getMetadata() {
    return this._dataManager.getMetadata(this);
  }
  async getGuidsByLocalIds(t) {
    return this._dataManager.getGuidsByLocalIds(this, t);
  }
  async getBuffer(t = !1) {
    return this._dataManager.getBuffer(this, t);
  }
  async getItemsOfCategories(t) {
    return this._dataManager.getItemsOfCategories(this, t);
  }
  async getGuids() {
    return await this.threads.invoke(this.modelId, "getGuids", []);
  }
  async getLocalIds() {
    return await this.threads.invoke(this.modelId, "getLocalIds", []);
  }
  async getItemsByQuery(t, i) {
    return this._dataManager.getItemsByQuery(this, t, i);
  }
  async getItemsMaterialDefinition(t) {
    return await this.threads.invoke(this.modelId, "getItemsMaterialDefinition", [t]);
  }
  async getItemsGeometry(t, i = Bo.GEOMETRY) {
    return this._editManager.getItemsGeometry(this, t, i);
  }
  async getGeometries(t) {
    return this._editManager.getGeometries(this, t);
  }
  async getItemsVolume(t) {
    return await this.threads.invoke(this.modelId, "getItemsVolume", [t]);
  }
  async getAttributeNames() {
    return await this.threads.invoke(this.modelId, "getAttributeNames", []);
  }
  async getAttributeValues() {
    return await this.threads.invoke(this.modelId, "getAttributeValues", []);
  }
  async getAttributesUniqueValues(t) {
    return await this.threads.invoke(this.modelId, "getAttributesUniqueValues", [t]);
  }
  async getAttributeTypes() {
    return await this.threads.invoke(this.modelId, "getAttributeTypes", []);
  }
  async getRelationNames() {
    return await this.threads.invoke(this.modelId, "getRelationNames", []);
  }
  async getMaxLocalId() {
    return this._dataManager.getMaxLocalId(this);
  }
  getItem(t) {
    return this._itemsManager.getItem(this, t);
  }
  async getItemsChildren(t) {
    return this._itemsManager.getItemsChildren(this, t);
  }
  async getItemsData(t, i) {
    return this._itemsManager.getItemsData(this, t, i);
  }
  async getPositions(t) {
    return this._coordinatesManager.getPositions(this, t);
  }
  async getCoordinates() {
    return this._coordinatesManager.getCoordinates(this);
  }
  async getCoordinationMatrix() {
    return this._coordinatesManager.getCoordinationMatrix(this);
  }
  async getMergedBox(t) {
    return this._boxManager.getMergedBox(this, t);
  }
  async getBoxes(t) {
    return this._boxManager.getBoxes(this, t);
  }
  async getAlignments() {
    return this._alignmentsManager.getAlignments();
  }
  async getHorizontalAlignments() {
    return this._alignmentsManager.getHorizontalAlignments();
  }
  async getVerticalAlignments() {
    return this._alignmentsManager.getVerticalAlignments();
  }
  getAlignmentStyles() {
    return this._alignmentsManager.getAlignmentStyles();
  }
  async getGrids() {
    return this._gridsManager.getGrids();
  }
  useCamera(t) {
    this._viewManager.useCamera(t);
  }
  async setLodMode(t) {
    return this._viewManager.setLodMode(this, t);
  }
  async rectangleRaycast(t) {
    return this._raycastManager.rectangleRaycast(this, this._meshManager, t);
  }
  async raycast(t) {
    return this._raycastManager.raycast(this, t);
  }
  async raycastAll(t) {
    return this._raycastManager.raycastAll(this, t);
  }
  async raycastWithSnapping(t) {
    return this._raycastManager.raycastWithSnapping(this, t);
  }
  async setVisible(t, i) {
    const n = [t, i];
    await this.threads.invoke(this.modelId, "setVisible", n);
  }
  async toggleVisible(t) {
    const i = [t];
    await this.threads.invoke(this.modelId, "toggleVisible", i);
  }
  async getItemsByVisibility(t) {
    return this._visibilityManager.getItemsByVisibility(this, t);
  }
  async getVisible(t) {
    return this._visibilityManager.getVisible(this, t);
  }
  async resetVisible() {
    return this._visibilityManager.resetVisible(this);
  }
  async highlight(t, i) {
    return this._highlightManager.highlight(this, t, i);
  }
  async setColor(t, i) {
    return this._highlightManager.setColor(this, t, i);
  }
  async resetColor(t) {
    return this._highlightManager.resetColor(this, t);
  }
  async setOpacity(t, i) {
    return this._highlightManager.setOpacity(this, t, i);
  }
  async resetOpacity(t) {
    return this._highlightManager.resetOpacity(this, t);
  }
  async getHighlight(t) {
    return this._highlightManager.getHighlight(this, t);
  }
  async resetHighlight(t) {
    return this._highlightManager.resetHighlight(this, t);
  }
  async getHighlightItemIds() {
    return this._highlightManager.getHighlightItemIds(this);
  }
  async getSection(t, i) {
    return this._sectionManager.getSection(this, t, i);
  }
  async getMaterialsIds() {
    return this._editManager.getMaterialsIds(this);
  }
  async getMaterials(t) {
    return this._editManager.getMaterials(this, t);
  }
  async getRepresentationsIds() {
    return this._editManager.getRepresentationsIds(this);
  }
  async getRepresentations(t) {
    return this._editManager.getRepresentations(this, t);
  }
  async getLocalTransformsIds() {
    return this._editManager.getLocalTransformsIds(this);
  }
  async getLocalTransforms(t) {
    return this._editManager.getLocalTransforms(this, t);
  }
  async getGlobalTransformsIds() {
    return this._editManager.getGlobalTransformsIds(this);
  }
  async getGlobalTransforms(t) {
    return this._editManager.getGlobalTransforms(this, t);
  }
  async getSamplesIds() {
    return this._editManager.getSamplesIds(this);
  }
  async getSamples(t) {
    return this._editManager.getSamples(this, t);
  }
  async getItemsIds() {
    return this._editManager.getItemsIds(this);
  }
  async getItems(t) {
    return this._editManager.getItems(this, t);
  }
  async getRelations(t) {
    return this._editManager.getRelations(this, t);
  }
  async getGlobalTranformsIdsOfItems(t) {
    return this._editManager.getGlobalTranformsIdsOfItems(this, t);
  }
  async getEditedElements() {
    return this._editManager.getEditedElements(this);
  }
  async getSequenced(t, i, n) {
    return this._sequenceManager.getSequenced(this, t, i, n);
  }
  async handleRequest(t) {
    await this._meshManager.requests.handleRequest(this._meshManager, t);
  }
  async _getElements(t) {
    return this._editManager.getElements(this, t);
  }
  _finishProcessing() {
    this._isProcessing = !1;
  }
  _setDeltaModel(t) {
    this.object.userData[DIe._deltaModelId] = !0, this._parentModelId = t;
  }
  async _refreshView() {
    if (this.frozen) return;
    this._isProcessing = !0;
    const t = this._viewManager.refreshView(this, this._meshManager), i = this._editor._update(this.modelId);
    await Promise.all([t, i]);
  }
  async _setup(t, i, n) {
    this._isSetup || (await this._setupManager.setup(this, this._bbox, t, i, n), this._isLoaded = !0, this._isProcessing = !0, this._isSetup = !0);
  }
  async _edit(t) {
    return this._editManager.edit(this, t);
  }
  async _reset() {
    return this._editManager.reset(this);
  }
  async _save() {
    return this._editManager.save(this);
  }
  async _getRequests() {
    return this._editManager.getRequests(this);
  }
  async _setRequests(t) {
    return this._editManager.setRequests(this, t);
  }
  async _selectRequest(t) {
    return this._editManager.selectRequest(this, t);
  }
};
De(JSe, "_deltaModelId", "isDeltaModel");
let XSe = JSe;
class eqe {
  constructor() {
    De(this, "list", []), De(this, "onFinish", (() => {
    }));
  }
  get arePending() {
    return this.list.length > 0;
  }
  async handleRequest(t, i) {
    if (i.class === LA.RECOMPUTE_MESHES) this.add(i.list), i.list = void 0;
    else if (i.class === LA.CREATE_MATERIAL) {
      const { materialDefinitions: n, modelId: s } = i;
      Ome.resetColors(n), t.materials.addDefinitions(s, n), i.materialDefinitions = void 0;
    } else i.class === LA.THROW_ERROR && console.error(i);
  }
  add(t) {
    for (const i of t) this.insert(i) || this.list.push(i), i.tileRequestClass === tc.FINISH && this.onFinish();
  }
  clean(t) {
    const i = this.list.filter(((n) => n.modelId !== t || n.tileRequestClass !== tc.FINISH));
    this.list = i;
  }
  insert(t) {
    const { modelId: i, tileId: n, tileRequestClass: s, tileData: o } = t;
    if (n === void 0) return !1;
    if (s === tc.DELETE) {
      const r = this.list.filter(((l) => !((l.tileRequestClass === tc.CREATE || l.tileRequestClass === tc.DELETE) && l.modelId === i && l.tileId === n)));
      this.list = r;
    }
    if (s === tc.CREATE) {
      const r = this.list.filter(((l) => !(l.tileRequestClass === tc.CREATE && l.modelId === i && l.tileId === n)));
      this.list = r;
    }
    if (s === tc.UPDATE) {
      const r = this.list.find(((l) => l.modelId === i && l.tileId === n));
      if (r) return r.tileRequestClass !== tc.CREATE && r.tileRequestClass !== tc.UPDATE || (r.tileData = o), !0;
    }
    return !1;
  }
}
class tqe {
  constructor(t) {
    De(this, "_materials"), De(this, "white", 4294967295), this._materials = t;
  }
  createMesh(t, i) {
    const n = this._materials.getFromRequest(i);
    if (!("isLodMaterial" in n) || !n.isLodMaterial) throw new Error("Fragments: material is not an instance of LodMaterial.");
    const { positions: s } = i;
    if (!s) throw new Error("Fragments: no positions provided to create the LOD mesh.");
    const o = new VYe(), r = this.deleteAttributeEvent(t);
    return Ov.setLodBuffer(o, s, r), new xwe(o, [n]);
  }
  updateVisibility(t, i) {
    const { geometry: n } = t, { visibilityData: s, highlightData: o } = i;
    Ov.setLodVisibility(n, s), o ? (Ov.setLodFilter(n, o), cJ.getComplementary(o, ((r, l) => {
      n.addGroup(r, l, 0);
    }))) : n.addGroup(0, 1 / 0, 0);
  }
  processMesh(t, i) {
    const { geometry: n } = t, { tileData: { visibilityData: s }, currentLod: o } = i;
    if (o === Bo.WIRES && t instanceof xwe) this.updateVisibility(t, i.tileData);
    else if (s && s.position.length > 0) for (let r = 0; r < s.position.length; ++r) {
      const l = s.size[r] === this.white, c = s.position[r], h = l ? 1 / 0 : s.size[r];
      n.addGroup(c, h, 0);
    }
  }
  deleteAttributeEvent(t) {
    return function() {
      delete this.array;
    };
  }
}
class iqe {
  constructor(t) {
    De(this, "list", new f0()), De(this, "materials", new Ome()), De(this, "lod", new tqe(this.materials)), De(this, "requests", new eqe()), De(this, "updateThreshold", 4), De(this, "_updateFinished", !0), De(this, "_onUpdate"), this._onUpdate = t, this.requests.onFinish = () => this._updateFinished = !0;
  }
  async forceUpdateFinish(t = 200, i = 500) {
    let n = !1;
    for (; !n; ) await new Promise(((s) => {
      this._updateFinished = !1;
      const o = setInterval((() => {
        this.update(), this._updateFinished && (clearInterval(o), s());
      }), t);
    })), await new Promise(((s) => {
      setTimeout(s, i);
    })), n = this._updateFinished;
  }
  update() {
    const t = performance.now();
    for (; this.requests.arePending; ) {
      const i = this.requests.list.shift();
      if (i && (this.processTileRequest(i), this._onUpdate(), performance.now() - t > this.updateThreshold)) return;
    }
  }
  setTileData(t, i) {
    const { tileId: n, itemId: s, matrix: o, aabb: r } = i;
    this.setMeshData(t, n, s, o), this.setupBoundings(t, r), this.updateStatus(t, i);
  }
  processTileRequest(t) {
    const { tileRequestClass: i, tileId: n, modelId: s } = t, o = this.list.get(s);
    if (o) if (i === tc.CREATE) {
      if (t.objectClass === void 0) return;
      const r = this.create(t);
      this.setTileData(r, t), o.tiles.set(r.userData.tileId, r);
    } else if (i === tc.DELETE) o.tiles.delete(n);
    else if (i === tc.UPDATE) {
      const r = o.tiles.get(n);
      r && this.updateStatus(r, t);
    } else i === tc.FINISH && o._finishProcessing();
  }
  createMesh(t) {
    const { indices: i, positions: n, normals: s, itemIds: o, faceIds: r } = t, l = new Vl();
    this.setIndex(l, i), this.setPositions(n, l), this.setNormals(s, l), this.setItemIds(o, l), this.setFaceIds(r, l);
    const c = this.materials.getFromRequest(t);
    return new En(l, [c]);
  }
  setupBoundings(t, i) {
    const { geometry: n } = t, s = new Zs().copy(i), o = new f3();
    s.getBoundingSphere(o), n.boundingBox = s, n.boundingSphere = o;
  }
  create(t) {
    if (t.objectClass === tE.SHELL) return this.createMesh(t);
    if (t.objectClass === tE.LINE) {
      const i = new Vl();
      return this.lod.createMesh(i, t);
    }
    throw new Error(`Fragments: object class ${t.objectClass} is not supported.`);
  }
  updateStatus(t, i) {
    const { tileData: { highlightData: n }, currentLod: s } = i, { geometry: o } = t;
    if (o.clearGroups(), this.lod.processMesh(t, i), !n || s === Bo.WIRES) return;
    const r = this.materials.createHighlights(t, i);
    t.material = r;
  }
  cleanAttributeMemory(t, i) {
    t.attributes[i].onUpload(this.deleteAttribute(t));
  }
  setPositions(t, i) {
    if (!t) throw new Error("Fragments: no positions provided to create the mesh.");
    i.setAttribute("position", new zu(t, 3)), this.cleanAttributeMemory(i, "position");
  }
  setFaceIds(t, i) {
    t && (i.setAttribute("color", new zu(t, 3)), this.cleanAttributeMemory(i, "color"));
  }
  setIndex(t, i) {
    if (!i) throw new Error("Fragments: no indices provided to create the mesh.");
    t.setIndex(new zu(i, 1)), t.index.onUpload(this.deleteAttribute(t));
  }
  setNormals(t, i) {
    t && i.setAttribute("normal", new zu(t, 3, !0)), this.cleanAttributeMemory(i, "normal");
  }
  setItemIds(t, i) {
    t && (i.setAttribute("id", new zu(t, 1, !1)), this.cleanAttributeMemory(i, "id"));
  }
  deleteAttribute(t) {
    return function() {
      delete this.array;
    };
  }
  setMeshData(t, i, n, s) {
    t.userData = { tileId: i, itemId: n }, t.matrixAutoUpdate = !1, t.applyMatrix4(s), t.matrix.copy(s);
  }
}
class nqe {
  constructor() {
    De(this, "_list", /* @__PURE__ */ new Map()), De(this, "_communicationKey", 0);
  }
  setupInput(t) {
    t.requestId = this._communicationKey++;
  }
  set(t, i, n) {
    const s = this.newHandler(i, n);
    this._list.set(t, s);
  }
  run(t) {
    const i = this._list.get(t.requestId);
    this._list.delete(t.requestId), i(t);
  }
  newHandler(t, i) {
    return (n) => {
      n.errorInfo ? t(n.errorInfo) : i(n);
    };
  }
}
class f1 {
  static newThread(t) {
    return new Worker(t, { type: "module" });
  }
  static newUpdater(t, i) {
    return setInterval(t, i);
  }
  static getMeshComputeRequest(t, i) {
    return { class: LA.RECOMPUTE_MESHES, modelId: t, list: i };
  }
  static planeSet(t) {
    const i = [];
    for (const n of t) {
      const s = this.array(n.normal), o = n.constant, r = new tl(s, o);
      i.push(r);
    }
    return i;
  }
  static data(t) {
    var i, n;
    if ((t == null ? void 0 : t.elements) !== void 0) return f1.transform(t);
    if ((t == null ? void 0 : t.origin) !== void 0 && (t == null ? void 0 : t.direction) !== void 0) return f1.beam(t);
    if ((t == null ? void 0 : t.planes) !== void 0) return f1.frustum(t);
    const s = (t == null ? void 0 : t.normal) !== void 0, o = (t == null ? void 0 : t.constant) !== void 0;
    if (s && o) return f1.plane(t);
    const r = ((i = t[0]) == null ? void 0 : i.normal) !== void 0, l = ((n = t[0]) == null ? void 0 : n.constant) !== void 0;
    if (r && l) return f1.planeSet(t);
    const c = (t == null ? void 0 : t.x) !== void 0, h = (t == null ? void 0 : t.y) !== void 0, I = (t == null ? void 0 : t.z) !== void 0;
    return c && h && I ? f1.array(t) : t;
  }
  static getExecuteRequest(t, i, n) {
    const s = Array.from(n);
    return { class: LA.EXECUTE, modelId: t, function: i, parameters: s };
  }
  static plane(t) {
    const i = this.array(t.normal), n = t.constant;
    return new tl(i, n);
  }
  static getRequestContent(t) {
    const i = [];
    for (const n of t.list) f1.setupCreateRequest(n, i), f1.setupUpdateRequest(n, i);
    return i;
  }
  static array(t) {
    const i = new Ge();
    return i.set(t.x, t.y, t.z), i;
  }
  static cleanRequests(t) {
    const i = [], n = f1;
    for (const s of t)
      n.isFinishRequest(s) || i.push(s);
    return i;
  }
  static frustum(t) {
    const i = this.planeSet(t.planes), [n, s, o, r, l, c] = i;
    return new cL(n, s, o, r, l, c);
  }
  static beam(t) {
    const i = this.array(t.origin), n = this.array(t.direction);
    return new MA(i, n);
  }
  static transform(t) {
    const i = new Ln();
    return i.copy(t), i;
  }
  static deleteUpdater(t) {
    clearInterval(t);
  }
  static areCoresAvailable(t) {
    const i = f1.getCpuCapacity();
    return t < Math.max(i, 2);
  }
  static isFinishRequest(t) {
    return t.tileRequestClass === tc.FINISH;
  }
  static setupUpdateRequest(t, i) {
    t.tileRequestClass === tc.UPDATE && this.addAllTileData(t, i);
  }
  static getCpuCapacity() {
    var t;
    return (t = globalThis.navigator) != null && t.hardwareConcurrency ? navigator.hardwareConcurrency - 3 : 0;
  }
  static addAllTileData(t, i) {
    this.addRequestTileData(t, i, "visibilityData"), this.addRequestTileData(t, i, "highlightData", ["highlightIds"]);
  }
  static addRequestContent(t, i, n) {
    if (!i[t]) return;
    const s = i[t].buffer;
    n.push(s);
  }
  static addRequestTileData(t, i, n, s = []) {
    const o = t.tileData[n];
    if (o) {
      i.push(o.position.buffer), i.push(o.size.buffer);
      for (const r of s) i.push(t.tileData[r].buffer);
    }
  }
  static setupCreateRequest(t, i) {
    if (t.tileRequestClass !== tc.CREATE) return;
    const n = this.getCreateRequestIds();
    for (const s of n) this.addRequestContent(s, t, i);
    this.addAllTileData(t, i);
  }
  static getCreateRequestIds() {
    return ["positions", "indices", "normals", "itemIds"];
  }
}
class sqe {
  constructor(t) {
    De(this, "_handlers", new nqe()), De(this, "_handleInput"), De(this, "_port"), De(this, "onInput", ((i) => {
      i.data.toMainThread ? this._handlers.run(i.data) : this.manageInput(i.data);
    })), this._handleInput = t;
  }
  fetchMeshCompute(t, i) {
    const n = f1, s = n.getMeshComputeRequest(t, i), o = n.getRequestContent(s);
    this.fetch(s, o);
  }
  fetch(t, i) {
    return this._handlers.setupInput(t), new Promise(((n, s) => {
      this._handlers.set(t.requestId, s, n), this.executeConnection(t, i);
    }));
  }
  init(t) {
    this._port = t, this.initConnection(t);
  }
  initConnection(t) {
    t.onmessage = this.onInput;
  }
  async fetchConnection(t) {
    if (!this._port) throw new Error("Fragments: Connection not initialized");
    return this._port;
  }
  async executeConnection(t, i) {
    (await this.fetchConnection(t)).postMessage(t, i);
  }
  async manageOutput(t) {
    const i = await this.fetchConnection(t);
    t.toMainThread = !0, i.postMessage(t);
  }
  async manageConnection(t) {
    try {
      await this._handleInput(t);
    } catch (i) {
      t.errorInfo = i.toString(), console.error(i);
    }
  }
  async manageInput(t) {
    await this.manageConnection(t), await this.manageOutput(t);
  }
}
class oqe {
  constructor(t) {
    De(this, "_modelThread", /* @__PURE__ */ new Map()), De(this, "_threadsModelAmount", /* @__PURE__ */ new Map()), De(this, "_threadPort", /* @__PURE__ */ new Map()), De(this, "_threadPath"), De(this, "_placeholder"), this._placeholder = {}, this._threadPath = t;
  }
  get path() {
    return this._threadPath;
  }
  usePlaceholder(t) {
    this._modelThread.set(t, this._placeholder);
  }
  getAmount(t) {
    return this._threadsModelAmount.get(t);
  }
  getThread(t) {
    return this._modelThread.get(t);
  }
  getAndCheckThread(t) {
    const i = this._modelThread.get(t);
    if (i === this._placeholder) throw new Error("Fragments: Error fetching thread!");
    return i;
  }
  set(t, i) {
    this._modelThread.set(t, i);
  }
  deleteModel(t) {
    const i = this.getThreadSafe(t), n = this.getAmountSafe(i) - 1;
    this.setAmount(i, n), this._modelThread.delete(t);
  }
  getThreadSafe(t) {
    const i = this.getThread(t);
    if (!i) throw new Error(`Fragments: Thread for model ${t} not found`);
    return i;
  }
  deleteThread(t) {
    this._threadsModelAmount.delete(t), this._threadPort.delete(t), t.terminate();
  }
  getThreadAmount() {
    return this._threadsModelAmount.size;
  }
  balanceThreadLoad(t) {
    const { lessBusyThread: i, modelAmount: n } = this.getLessBusyThread();
    return this._threadsModelAmount.set(i, n + 1), this._modelThread.set(t.modelId, i), this._threadPort.get(i);
  }
  getAmountSafe(t) {
    const i = this.getAmount(t);
    if (!i) throw new Error(`Fragments: Amount for thread ${t} not found`);
    return i;
  }
  setPort(t, i) {
    this._threadPort.set(t, i);
  }
  setAmount(t, i) {
    this._threadsModelAmount.set(t, i);
  }
  getPort(t) {
    return this._threadPort.get(t);
  }
  getLessBusyThread() {
    let t = Number.MAX_VALUE, i = this._threadsModelAmount.keys().next().value;
    for (const [n, s] of this._threadsModelAmount) s < t && (t = s, i = n);
    return { lessBusyThread: i, modelAmount: t };
  }
}
class rqe extends sqe {
  constructor(t, i) {
    super(t), De(this, "_data"), this._data = new oqe(i);
  }
  delete(t) {
    const i = this._data.getThreadSafe(t), n = this._data.getAmountSafe(i) - 1;
    this._data.deleteModel(t), n === 0 && this._data.deleteThread(i);
  }
  async invoke(t, i, n = []) {
    const s = f1.getExecuteRequest(t, i, n);
    return (await this.fetch(s)).result;
  }
  async fetchConnection(t) {
    const i = this._data.getAndCheckThread(t.modelId);
    return i ? this._data.getPort(i) : this.setupNewThread(t);
  }
  setupNewThread(t) {
    const i = f1;
    this._data.usePlaceholder(t.modelId);
    const n = this._data.getThreadAmount();
    return i.areCoresAvailable(n) ? this.newThread(t, this._data.path) : this._data.balanceThreadLoad(t);
  }
  setupThread(t) {
    const i = new MessageChannel(), n = i.port1, s = i.port2;
    this.initConnection(n), this._data.setPort(t, n), t.postMessage(s, [s]);
  }
  newThread(t, i) {
    const n = f1.newThread(i);
    return this.setupThread(n), this._data.setAmount(n, 1), this._data.set(t.modelId, n), this._data.getPort(n);
  }
}
const lqe = 32;
new Array(lqe).fill().map((() => ({ count: 0, bounds: new Float32Array(6), rightCacheBounds: new Float32Array(6), leftCacheBounds: new Float32Array(6), candidate: 0 })));
class rL {
  constructor() {
    this.min = 1 / 0, this.max = -1 / 0;
  }
  setFromPointsField(t, i) {
    let n = 1 / 0, s = -1 / 0;
    for (let o = 0, r = t.length; o < r; o++) {
      const l = t[o][i];
      n = l < n ? l : n, s = l > s ? l : s;
    }
    this.min = n, this.max = s;
  }
  setFromPoints(t, i) {
    let n = 1 / 0, s = -1 / 0;
    for (let o = 0, r = i.length; o < r; o++) {
      const l = i[o], c = t.dot(l);
      n = c < n ? c : n, s = c > s ? c : s;
    }
    this.min = n, this.max = s;
  }
  isSeparated(t) {
    return this.min > t.max || t.min > this.max;
  }
}
rL.prototype.setFromBox = (function() {
  const e = new Ge();
  return function(t, i) {
    const n = i.min, s = i.max;
    let o = 1 / 0, r = -1 / 0;
    for (let l = 0; l <= 1; l++) for (let c = 0; c <= 1; c++) for (let h = 0; h <= 1; h++) {
      e.x = n.x * l + s.x * (1 - l), e.y = n.y * c + s.y * (1 - c), e.z = n.z * h + s.z * (1 - h);
      const I = t.dot(e);
      o = Math.min(I, o), r = Math.max(I, r);
    }
    this.min = o, this.max = r;
  };
})();
const aqe = (function() {
  const e = new Ge(), t = new Ge(), i = new Ge();
  return function(n, s, o) {
    const r = n.start, l = e, c = s.start, h = t;
    i.subVectors(r, c), e.subVectors(n.end, n.start), t.subVectors(s.end, s.start);
    const I = i.dot(h), p = h.dot(l), y = h.dot(h), m = i.dot(l), A = l.dot(l) * y - p * p;
    let C, O;
    C = A !== 0 ? (I * p - m * y) / A : 0, O = (I + C * p) / y, o.x = C, o.y = O;
  };
})(), CIe = (function() {
  const e = new us(), t = new Ge(), i = new Ge();
  return function(n, s, o, r) {
    aqe(n, s, e);
    let l = e.x, c = e.y;
    if (l >= 0 && l <= 1 && c >= 0 && c <= 1) return n.at(l, o), void s.at(c, r);
    if (l >= 0 && l <= 1) return c < 0 ? s.at(0, r) : s.at(1, r), void n.closestPointToPoint(r, !0, o);
    if (c >= 0 && c <= 1) return l < 0 ? n.at(0, o) : n.at(1, o), void s.closestPointToPoint(o, !0, r);
    {
      let h, I;
      h = l < 0 ? n.start : n.end, I = c < 0 ? s.start : s.end;
      const p = t, y = i;
      return n.closestPointToPoint(I, !0, t), s.closestPointToPoint(h, !0, i), p.distanceToSquared(I) <= y.distanceToSquared(h) ? (o.copy(p), void r.copy(I)) : (o.copy(h), void r.copy(y));
    }
  };
})(), uqe = (function() {
  const e = new Ge(), t = new Ge(), i = new tl(), n = new gc();
  return function(s, o) {
    const { radius: r, center: l } = s, { a: c, b: h, c: I } = o;
    if (n.start = c, n.end = h, n.closestPointToPoint(l, !0, e).distanceTo(l) <= r || (n.start = c, n.end = I, n.closestPointToPoint(l, !0, e).distanceTo(l) <= r) || (n.start = h, n.end = I, n.closestPointToPoint(l, !0, e).distanceTo(l) <= r)) return !0;
    const p = o.getPlane(i);
    if (Math.abs(p.distanceToPoint(l)) <= r) {
      const y = p.projectPoint(l, t);
      if (o.containsPoint(y)) return !0;
    }
    return !1;
  };
})();
function Rce(e) {
  return Math.abs(e) < 1e-15;
}
class Xv extends wc {
  constructor(...t) {
    super(...t), this.isExtendedTriangle = !0, this.satAxes = new Array(4).fill().map((() => new Ge())), this.satBounds = new Array(4).fill().map((() => new rL())), this.points = [this.a, this.b, this.c], this.sphere = new f3(), this.plane = new tl(), this.needsUpdate = !0;
  }
  intersectsSphere(t) {
    return uqe(t, this);
  }
  update() {
    const t = this.a, i = this.b, n = this.c, s = this.points, o = this.satAxes, r = this.satBounds, l = o[0], c = r[0];
    this.getNormal(l), c.setFromPoints(l, s);
    const h = o[1], I = r[1];
    h.subVectors(t, i), I.setFromPoints(h, s);
    const p = o[2], y = r[2];
    p.subVectors(i, n), y.setFromPoints(p, s);
    const m = o[3], A = r[3];
    m.subVectors(n, t), A.setFromPoints(m, s), this.sphere.setFromPoints(this.points), this.plane.setFromNormalAndCoplanarPoint(l, t), this.needsUpdate = !1;
  }
}
Xv.prototype.closestPointToSegment = (function() {
  const e = new Ge(), t = new Ge(), i = new gc();
  return function(n, s = null, o = null) {
    const { start: r, end: l } = n, c = this.points;
    let h, I = 1 / 0;
    for (let p = 0; p < 3; p++) {
      const y = (p + 1) % 3;
      i.start.copy(c[p]), i.end.copy(c[y]), CIe(i, n, e, t), h = e.distanceToSquared(t), h < I && (I = h, s && s.copy(e), o && o.copy(t));
    }
    return this.closestPointToPoint(r, e), h = r.distanceToSquared(e), h < I && (I = h, s && s.copy(e), o && o.copy(r)), this.closestPointToPoint(l, e), h = l.distanceToSquared(e), h < I && (I = h, s && s.copy(e), o && o.copy(l)), Math.sqrt(I);
  };
})(), Xv.prototype.intersectsTriangle = (function() {
  const e = new Xv(), t = new Array(3), i = new Array(3), n = new rL(), s = new rL(), o = new Ge(), r = new Ge(), l = new Ge(), c = new Ge(), h = new Ge(), I = new gc(), p = new gc(), y = new gc(), m = new Ge();
  function A(C, O, R) {
    const F = C.points;
    let L = 0, P = -1;
    for (let z = 0; z < 3; z++) {
      const { start: W, end: re } = I;
      W.copy(F[z]), re.copy(F[(z + 1) % 3]), I.delta(r);
      const ce = Rce(O.distanceToPoint(W));
      if (Rce(O.normal.dot(r)) && ce) {
        R.copy(I), L = 2;
        break;
      }
      const te = O.intersectLine(I, m);
      if (!te && ce && m.copy(W), (te || ce) && !Rce(m.distanceTo(re))) {
        if (L <= 1)
          (L === 1 ? R.start : R.end).copy(m), ce && (P = L);
        else if (L >= 2) {
          (P === 1 ? R.start : R.end).copy(m), L = 2;
          break;
        }
        if (L++, L === 2 && P === -1) break;
      }
    }
    return L;
  }
  return function(C, O = null, R = !1) {
    this.needsUpdate && this.update(), C.isExtendedTriangle ? C.needsUpdate && C.update() : (e.copy(C), e.update(), C = e);
    const F = this.plane, L = C.plane;
    if (Math.abs(F.normal.dot(L.normal)) > 1 - 1e-10) {
      const P = this.satBounds, z = this.satAxes;
      i[0] = C.a, i[1] = C.b, i[2] = C.c;
      for (let ce = 0; ce < 4; ce++) {
        const te = P[ce], ee = z[ce];
        if (n.setFromPoints(ee, i), te.isSeparated(n)) return !1;
      }
      const W = C.satBounds, re = C.satAxes;
      t[0] = this.a, t[1] = this.b, t[2] = this.c;
      for (let ce = 0; ce < 4; ce++) {
        const te = W[ce], ee = re[ce];
        if (n.setFromPoints(ee, t), te.isSeparated(n)) return !1;
      }
      for (let ce = 0; ce < 4; ce++) {
        const te = z[ce];
        for (let ee = 0; ee < 4; ee++) {
          const Ne = re[ee];
          if (o.crossVectors(te, Ne), n.setFromPoints(o, t), s.setFromPoints(o, i), n.isSeparated(s)) return !1;
        }
      }
      return O && (R || console.warn("ExtendedTriangle.intersectsTriangle: Triangles are coplanar which does not support an output edge. Setting edge to 0, 0, 0."), O.start.set(0, 0, 0), O.end.set(0, 0, 0)), !0;
    }
    {
      const P = A(this, L, p);
      if (P === 1 && C.containsPoint(p.end)) return O && (O.start.copy(p.end), O.end.copy(p.end)), !0;
      if (P !== 2) return !1;
      const z = A(C, F, y);
      if (z === 1 && this.containsPoint(y.end)) return O && (O.start.copy(y.end), O.end.copy(y.end)), !0;
      if (z !== 2) return !1;
      if (p.delta(l), y.delta(c), l.dot(c) < 0) {
        let ee = y.start;
        y.start = y.end, y.end = ee;
      }
      const W = p.start.dot(l), re = p.end.dot(l), ce = y.start.dot(l), te = y.end.dot(l);
      return (W === te || ce === re || re < ce != W < te) && (O && (h.subVectors(p.start, y.start), h.dot(l) > 0 ? O.start.copy(p.start) : O.start.copy(y.start), h.subVectors(p.end, y.end), h.dot(l) < 0 ? O.end.copy(p.end) : O.end.copy(y.end)), !0);
    }
  };
})(), Xv.prototype.distanceToPoint = (function() {
  const e = new Ge();
  return function(t) {
    return this.closestPointToPoint(t, e), t.distanceTo(e);
  };
})(), Xv.prototype.distanceToTriangle = (function() {
  const e = new Ge(), t = new Ge(), i = ["a", "b", "c"], n = new gc(), s = new gc();
  return function(o, r = null, l = null) {
    const c = r || l ? n : null;
    if (this.intersectsTriangle(o, c)) return (r || l) && (r && c.getCenter(r), l && c.getCenter(l)), 0;
    let h = 1 / 0;
    for (let I = 0; I < 3; I++) {
      let p;
      const y = i[I], m = o[y];
      this.closestPointToPoint(m, e), p = m.distanceToSquared(e), p < h && (h = p, r && r.copy(e), l && l.copy(m));
      const A = this[y];
      o.closestPointToPoint(A, e), p = A.distanceToSquared(e), p < h && (h = p, r && r.copy(A), l && l.copy(e));
    }
    for (let I = 0; I < 3; I++) {
      const p = i[I], y = i[(I + 1) % 3];
      n.set(this[p], this[y]);
      for (let m = 0; m < 3; m++) {
        const A = i[m], C = i[(m + 1) % 3];
        s.set(o[A], o[C]), CIe(n, s, e, t);
        const O = e.distanceToSquared(t);
        O < h && (h = O, r && r.copy(e), l && l.copy(t));
      }
    }
    return Math.sqrt(h);
  };
})();
class qy {
  constructor(t, i, n) {
    this.isOrientedBox = !0, this.min = new Ge(), this.max = new Ge(), this.matrix = new Ln(), this.invMatrix = new Ln(), this.points = new Array(8).fill().map((() => new Ge())), this.satAxes = new Array(3).fill().map((() => new Ge())), this.satBounds = new Array(3).fill().map((() => new rL())), this.alignedSatBounds = new Array(3).fill().map((() => new rL())), this.needsUpdate = !1, t && this.min.copy(t), i && this.max.copy(i), n && this.matrix.copy(n);
  }
  set(t, i, n) {
    this.min.copy(t), this.max.copy(i), this.matrix.copy(n), this.needsUpdate = !0;
  }
  copy(t) {
    this.min.copy(t.min), this.max.copy(t.max), this.matrix.copy(t.matrix), this.needsUpdate = !0;
  }
}
qy.prototype.update = /* @__PURE__ */ (function() {
  return function() {
    const e = this.matrix, t = this.min, i = this.max, n = this.points;
    for (let c = 0; c <= 1; c++) for (let h = 0; h <= 1; h++) for (let I = 0; I <= 1; I++) {
      const p = n[1 * c | 2 * h | 4 * I];
      p.x = c ? i.x : t.x, p.y = h ? i.y : t.y, p.z = I ? i.z : t.z, p.applyMatrix4(e);
    }
    const s = this.satBounds, o = this.satAxes, r = n[0];
    for (let c = 0; c < 3; c++) {
      const h = o[c], I = s[c], p = n[1 << c];
      h.subVectors(r, p), I.setFromPoints(h, n);
    }
    const l = this.alignedSatBounds;
    l[0].setFromPointsField(n, "x"), l[1].setFromPointsField(n, "y"), l[2].setFromPointsField(n, "z"), this.invMatrix.copy(this.matrix).invert(), this.needsUpdate = !1;
  };
})(), qy.prototype.intersectsBox = (function() {
  const e = new rL();
  return function(t) {
    this.needsUpdate && this.update();
    const i = t.min, n = t.max, s = this.satBounds, o = this.satAxes, r = this.alignedSatBounds;
    if (e.min = i.x, e.max = n.x, r[0].isSeparated(e) || (e.min = i.y, e.max = n.y, r[1].isSeparated(e)) || (e.min = i.z, e.max = n.z, r[2].isSeparated(e))) return !1;
    for (let l = 0; l < 3; l++) {
      const c = o[l], h = s[l];
      if (e.setFromBox(c, t), h.isSeparated(e)) return !1;
    }
    return !0;
  };
})(), qy.prototype.intersectsTriangle = (function() {
  const e = new Xv(), t = new Array(3), i = new rL(), n = new rL(), s = new Ge();
  return function(o) {
    this.needsUpdate && this.update(), o.isExtendedTriangle ? o.needsUpdate && o.update() : (e.copy(o), e.update(), o = e);
    const r = this.satBounds, l = this.satAxes;
    t[0] = o.a, t[1] = o.b, t[2] = o.c;
    for (let p = 0; p < 3; p++) {
      const y = r[p], m = l[p];
      if (i.setFromPoints(m, t), y.isSeparated(i)) return !1;
    }
    const c = o.satBounds, h = o.satAxes, I = this.points;
    for (let p = 0; p < 3; p++) {
      const y = c[p], m = h[p];
      if (i.setFromPoints(m, I), y.isSeparated(i)) return !1;
    }
    for (let p = 0; p < 3; p++) {
      const y = l[p];
      for (let m = 0; m < 4; m++) {
        const A = h[m];
        if (s.crossVectors(y, A), i.setFromPoints(s, t), n.setFromPoints(s, I), i.isSeparated(n)) return !1;
      }
    }
    return !0;
  };
})(), qy.prototype.closestPointToPoint = /* @__PURE__ */ (function() {
  return function(e, t) {
    return this.needsUpdate && this.update(), t.copy(e).applyMatrix4(this.invMatrix).clamp(this.min, this.max).applyMatrix4(this.matrix), t;
  };
})(), qy.prototype.distanceToPoint = (function() {
  const e = new Ge();
  return function(t) {
    return this.closestPointToPoint(t, e), t.distanceTo(e);
  };
})(), qy.prototype.distanceToBox = (function() {
  const e = ["x", "y", "z"], t = new Array(12).fill().map((() => new gc())), i = new Array(12).fill().map((() => new gc())), n = new Ge(), s = new Ge();
  return function(o, r = 0, l = null, c = null) {
    if (this.needsUpdate && this.update(), this.intersectsBox(o)) return (l || c) && (o.getCenter(s), this.closestPointToPoint(s, n), o.closestPointToPoint(n, s), l && l.copy(n), c && c.copy(s)), 0;
    const h = r * r, I = o.min, p = o.max, y = this.points;
    let m = 1 / 0;
    for (let C = 0; C < 8; C++) {
      const O = y[C];
      s.copy(O).clamp(I, p);
      const R = O.distanceToSquared(s);
      if (R < m && (m = R, l && l.copy(O), c && c.copy(s), R < h)) return Math.sqrt(R);
    }
    let A = 0;
    for (let C = 0; C < 3; C++) for (let O = 0; O <= 1; O++) for (let R = 0; R <= 1; R++) {
      const F = (C + 1) % 3, L = (C + 2) % 3, P = 1 << C | O << F | R << L, z = y[O << F | R << L], W = y[P];
      t[A].set(z, W);
      const re = e[C], ce = e[F], te = e[L], ee = i[A], Ne = ee.start, Ae = ee.end;
      Ne[re] = I[re], Ne[ce] = O ? I[ce] : p[ce], Ne[te] = R ? I[te] : p[ce], Ae[re] = p[re], Ae[ce] = O ? I[ce] : p[ce], Ae[te] = R ? I[te] : p[ce], A++;
    }
    for (let C = 0; C <= 1; C++) for (let O = 0; O <= 1; O++) for (let R = 0; R <= 1; R++) {
      s.x = C ? p.x : I.x, s.y = O ? p.y : I.y, s.z = R ? p.z : I.z, this.closestPointToPoint(s, n);
      const F = s.distanceToSquared(n);
      if (F < m && (m = F, l && l.copy(n), c && c.copy(s), F < h)) return Math.sqrt(F);
    }
    for (let C = 0; C < 12; C++) {
      const O = t[C];
      for (let R = 0; R < 12; R++) {
        const F = i[R];
        CIe(O, F, n, s);
        const L = n.distanceToSquared(s);
        if (L < m && (m = L, l && l.copy(n), c && c.copy(s), L < h)) return Math.sqrt(L);
      }
    }
    return Math.sqrt(m);
  };
})();
class dqe {
  constructor(t) {
    this._getNewPrimitive = t, this._primitives = [];
  }
  getPrimitive() {
    const t = this._primitives;
    return t.length === 0 ? this._getNewPrimitive() : t.pop();
  }
  releasePrimitive(t) {
    this._primitives.push(t);
  }
}
class cqe extends dqe {
  constructor() {
    super((() => new Xv()));
  }
}
new cqe();
const ebe = new class {
  constructor() {
    this.float32Array = null, this.uint16Array = null, this.uint32Array = null;
    const e = [];
    let t = null;
    this.setBuffer = (i) => {
      t && e.push(t), t = i, this.float32Array = new Float32Array(i), this.uint16Array = new Uint16Array(i), this.uint32Array = new Uint32Array(i);
    }, this.clearBuffer = () => {
      t = null, this.float32Array = null, this.uint16Array = null, this.uint32Array = null, e.length !== 0 && this.setBuffer(e.pop());
    };
  }
}();
new Ge();
new Ge();
new Ge();
new Ge();
new Ge();
new us();
new us();
new us();
new Ge();
new Ge();
new Ge();
new Ge();
new Zs();
new Ge();
new Ge();
new Zs();
new Xv();
new Xv();
new Ln();
new qy();
new qy();
new Ln();
new qy();
new qy();
new Ge();
new Ge();
new Ge();
new Ge();
new Ge();
new Ge();
new Zs();
new Xv();
new Xv();
new Ln();
new qy();
new qy();
new Ln();
new qy();
new qy();
new Ge();
new Ge();
new Ge();
new Ge();
new ebe.constructor();
new ebe.constructor();
new Zs();
new Zs();
new Zs();
new Zs();
new qy();
new Zs();
new MA();
new Ln();
class tbe {
  constructor(t, i) {
    De(this, "meshes"), De(this, "_templateController", new zqe()), De(this, "_meshIds", /* @__PURE__ */ new Set()), De(this, "_idGenerator", new Cme()), De(this, "_modelCode"), this.meshes = i, this._modelCode = this.getModelCode(t);
  }
  dispose() {
    XV.delete(this._meshIds);
  }
  useMesh(t, i, n) {
    const s = this.meshCode(t, n);
    XV.lockIn(i), this._templateController.add(s, i);
  }
  getMesh(t, i) {
    const n = this.meshCode(t, i);
    return XV.get(n) ?? this._templateController.get(n);
  }
  saveMesh(t, i, n) {
    Cv.forEach(i, XV.updateMeshMemory);
    const s = this.meshCode(t, n);
    XV.add(s, i), this._meshIds.add(s);
  }
  meshCode(t, i) {
    const n = [this._modelCode, this.getRepresentation(), i, t];
    return this._idGenerator.generate(n);
  }
  getModelCode(t) {
    return this._idGenerator.generate([t]);
  }
}
const VJ = 32767;
var cB = ((e) => (e[e.NONE = 0] = "NONE", e[e.AABB = 1] = "AABB", e[e.CUSTOM = 2] = "CUSTOM", e))(cB || {});
const rg = class dv {
  static getProfile(t, i, n) {
    return t.type() === F0.BIG ? t.bigProfiles(i, n) : t.profiles(i, n);
  }
  static getPoints(t) {
    const i = new Float32Array(3 * t.pointsLength());
    for (let n = 0; n < t.pointsLength(); n++) t.points(n, this._tempPoint), i[3 * n] = this._tempPoint.x(), i[3 * n + 1] = this._tempPoint.y(), i[3 * n + 2] = this._tempPoint.z();
    return i;
  }
  static getProfileIndices(t, i) {
    const n = t.type() === F0.BIG, s = { outer: [], inners: [] }, o = n ? t.bigHolesLength() : t.holesLength(), r = n ? "bigHoles" : "holes", l = dv.getProfile(t, i);
    s.outer = Array.from(l.indicesArray());
    for (let c = 0; c < o; c++) {
      const h = t[r](c);
      if (h.profileId() === i) {
        const I = Array.from(h.indicesArray());
        s.inners.push(I);
      }
    }
    return s;
  }
  static getHole(t, i, n) {
    return t.type() === F0.BIG ? t.bigHoles(i, n) : t.holes(i, n);
  }
  static getProfilesLength(t) {
    return t.type() === F0.BIG ? t.bigProfilesLength() : t.profilesLength();
  }
  static getHolesLength(t) {
    return t.type() === F0.BIG ? t.bigHolesLength() : t.holesLength();
  }
  static getShell(t, i) {
    return t.shells(i, this._shell);
  }
  static point(t, i, n) {
    t instanceof Fo && t.points(i, this._tempPoint);
    const s = this._tempPoint.x(), o = this._tempPoint.y(), r = this._tempPoint.z();
    n.set(s, o, r);
  }
  static getNormalsOfShellProfile(t, i) {
    const n = dv.getProfilesLength(t);
    for (let s = 0; s < n; s++) {
      const o = dv.getProfile(t, s), r = this.fetchNormalsOfProfile(t, o);
      i.push(r);
    }
    return i;
  }
  static computeNormalsAvg(t, i, n, s) {
    this.setupNormalBuffer(t);
    const o = n[i];
    for (let r = 0; r < t.length; r++) {
      const l = t[r], c = s.get(l);
      this.aggregateNormals(c, n, o), this.computeAvgNormal(r);
    }
    return this._normalBuffer;
  }
  static getBuffer(t) {
    const i = t.bb, n = i.__offset(t.bb_pos, 8), s = 3 * t.pointsLength(), o = i.__vector(t.bb_pos + n), r = i.bytes().buffer;
    return new Float32Array(r, o, s);
  }
  static getPointsShell(t) {
    return this._pointsByProfile.clear(), this.fetchAllPointsByProfile(t), dv.fetchAllPointsByHole(t), this._pointsByProfile;
  }
  static addNormals(t, i, n) {
    for (const s of t) {
      const o = i[s];
      n.dot(o) > this._faceThreshold && this._tempNormal.add(o);
    }
  }
  static setupNormalBuffer(t) {
    const i = 3 * t.length;
    this._normalBuffer.length < i && (this._normalBuffer = new Int16Array(i));
  }
  static fetchNormalsOfProfile(t, i) {
    const n = i.indicesLength();
    return this.isTooSmall(t, n) ? new Ge(1, 0, 0) : this.computeProfileNormal(n, i, t);
  }
  static fetchAllPointsByHole(t) {
    const i = dv.getHolesLength(t), n = this.getTempHole(t);
    for (let s = 0; s < i; s++) {
      dv.getHole(t, s, n);
      const o = n.profileId(), r = n.indicesLength();
      for (let l = 0; l < r; l++) {
        const c = n.indices(l);
        dv.savePointByProfile(c, o);
      }
    }
  }
  static computeProfileNormal(t, i, n) {
    this._v3.set(0, 0, 0);
    for (let o = 0; o < t; o++) this.fetchPointsForNormal(o, t, i, n), this.computeProfilePointNormal();
    const s = this._v3.clone();
    return s.normalize(), s;
  }
  static computeProfilePointNormal() {
    const t = this._v1.x - this._v2.x, i = this._v1.y - this._v2.y, n = this._v1.z - this._v2.z, s = this._v1.x + this._v2.x, o = this._v1.y + this._v2.y, r = this._v1.z + this._v2.z;
    this._v3.x += i * r, this._v3.y += n * s, this._v3.z += t * o;
  }
  static aggregateNormals(t, i, n) {
    if (this._tempNormal.set(0, 0, 0), !t || !t.length) return void this._tempNormal.set(1, 0, 0);
    if (t.length === 1) {
      const s = t[0];
      this._tempNormal = i[s].clone();
    } else dv.addNormals(t, i, n);
  }
  static fetchPointsForNormal(t, i, n, s) {
    const o = (t + 1) % i, r = n.indices(t), l = n.indices(o);
    this.point(s, r, this._v1), this.point(s, l, this._v2);
  }
  static savePointByProfile(t, i) {
    this._pointsByProfile.has(t) || this._pointsByProfile.set(t, []), this._pointsByProfile.get(t).push(i);
  }
  static isTooSmall(t, i) {
    return t.pointsLength() <= 2 || i <= 2;
  }
  static fetchAllPointsByProfile(t) {
    const i = this.getProfilesLength(t), n = this.getTempProfile(t);
    for (let s = 0; s < i; s++) {
      dv.getProfile(t, s, n);
      const o = n.indicesLength();
      for (let r = 0; r < o; r++) {
        const l = n.indices(r);
        dv.savePointByProfile(l, s);
      }
    }
  }
  static computeAvgNormal(t) {
    this._tempNormal.normalize(), this._tempNormal.multiplyScalar(VJ), this._tempNormal.toArray(this._normalBuffer, 3 * t);
  }
  static getTempProfile(t) {
    return t.type() === F0.BIG ? this._bigShellProfile : this._shellProfile;
  }
  static getTempHole(t) {
    return t.type() === F0.BIG ? this._bigShellHole : this._shellHole;
  }
};
De(rg, "_faceThreshold", Math.cos(Math.PI / 8)), De(rg, "_shell", new Fo()), De(rg, "_normalBuffer", new Int16Array()), De(rg, "_tempNormal", new Ge()), De(rg, "_tempPoint", new Rf()), De(rg, "_shellProfile", new qp()), De(rg, "_bigShellProfile", new Yp()), De(rg, "_shellHole", new kp()), De(rg, "_bigShellHole", new Gp()), De(rg, "_pointsByProfile", /* @__PURE__ */ new Map()), De(rg, "_v1", new Ge()), De(rg, "_v2", new Ge()), De(rg, "_v3", new Ge());
let Br = rg;
class hqe {
  constructor() {
    De(this, "_shellHole", new kp()), De(this, "_bigShellHole", new Gp()), De(this, "holePoints", 0), De(this, "profilePoints", 0), De(this, "triangleAmount", 0), De(this, "indexCount", 0), De(this, "meshes", []), De(this, "_shellProfile", new qp()), De(this, "_bigShellProfile", new Yp());
  }
  newMeshTemplate(t) {
    return this.getIsEmpty(t) ? { objectClass: tE.SHELL } : (this.reset(!0), this.processShell(t), this.getResult());
  }
  manageDataLeft() {
    this.getIsDataLeft() && this.setMesh();
  }
  getIsEmpty(t) {
    return Br.getProfilesLength(t) === 0;
  }
  processShellHoles(t, i) {
    let n = !1;
    const s = Br.getHolesLength(t), o = this.getTempHole(t);
    for (let r = 0; r < s; r++)
      Br.getHole(t, r, o), o.profileId() === i && (this.updateBuffers(t, n), n = !0);
    this.manageFoundHoles(t, n);
  }
  newMesh() {
    return { objectClass: tE.SHELL, indexCount: 3 * this.triangleAmount, positionCount: 3 * (this.holePoints + this.profilePoints), normalCount: 3 * (this.holePoints + this.profilePoints) };
  }
  reset(t) {
    this.holePoints = 0, this.profilePoints = 0, this.triangleAmount = 0, t && (this.meshes = void 0);
  }
  getIsDataLeft() {
    const t = this.triangleAmount > 0, i = this.holePoints > 0, n = this.profilePoints > 0;
    return t || i || n;
  }
  processShell(t) {
    const i = Br.getProfilesLength(t), n = this.getTempProfile(t);
    for (let s = 0; s < i; s++) Br.getProfile(t, s, n), this.indexCount = n.indicesLength(), this.profilePoints += this.indexCount, this.processShellHoles(t, s), this.manageMemory();
    this.manageDataLeft();
  }
  manageFoundHoles(t, i) {
    const n = this.getTempProfile(t).indicesLength();
    i ? this.triangleAmount += n : n > 2 && (this.triangleAmount += n - 2);
  }
  getResult() {
    const t = this.meshes;
    return this.meshes = void 0, t;
  }
  manageMemory() {
    this.holePoints + this.profilePoints + this.indexCount > WW && this.setMesh();
  }
  updateBuffers(t, i) {
    const n = this.getTempHole(t);
    this.holePoints += n.indicesLength(), this.triangleAmount += n.indicesLength(), i && (this.triangleAmount += 2);
  }
  setMesh() {
    const t = this.newMesh();
    this.meshes ? Array.isArray(this.meshes) ? this.meshes.push(t) : this.meshes = [this.meshes, t] : this.meshes = t, this.reset(!1);
  }
  getTempProfile(t) {
    return t.type() === F0.BIG ? this._bigShellProfile : this._shellProfile;
  }
  getTempHole(t) {
    return t.type() === F0.BIG ? this._bigShellHole : this._shellHole;
  }
}
var OIe = ((e) => (e[e.four = 4] = "four", e[e.three = 3] = "three", e))(OIe || {});
function fqe(e, t, i, n, s, o) {
  const r = t && t.length, l = r ? t[0] * i : e.length;
  let c, h, I, p = Pwe(e, 0, l, i, !0, n, s);
  if (p && p.next !== p.prev) {
    if (r && (p = (function(y, m, A, C, O, R) {
      const F = [];
      for (let L = 0, P = m.length; L < P; L++) {
        const z = Pwe(y, m[L] * C, L < P - 1 ? m[L + 1] * C : y.length, C, !1, O, R);
        z === z.next && (z.steiner = !0), F.push(Tqe(z));
      }
      F.sort(Eqe);
      for (let L = 0; L < F.length; L++) A = O8(A = gqe(F[L], A), A.next);
      return A;
    })(e, t, p, i, n, s)), e.length > 80 * i) {
      let y = e[n], m = e[s];
      c = y, h = m;
      for (let A = i; A < l; A += i) {
        const C = e[A + n], O = e[A + s];
        C < c && (c = C), O < h && (h = O), C > y && (y = C), O > m && (m = O);
      }
      I = Math.max(y - c, m - h), I = I !== 0 ? 1 / I : 0;
    }
    HX(p, o, i, c, h, I);
  }
}
function Pwe(e, t, i, n, s, o, r) {
  let l, c, h;
  if (s === (function(I, p, y, m, A, C) {
    let O = 0;
    for (let R = p, F = y - m; R < y; R += m) O += (I[F + A] - I[R + A]) * (I[R + C] + I[F + C]), F = R;
    return O;
  })(e, t, i, n, o, r) > 0) for (h = t; h < i; h += n) l = Mwe(h, e[h + o], e[h + r], l);
  else for (h = i - n; h >= t; h -= n) l = Mwe(h, e[h + o], e[h + r], l);
  return l && wue(l, l.next) && (c = l.next, kX(l), l = c), l;
}
function O8(e, t) {
  if (!e) return e;
  t || (t = e);
  let i, n, s = e;
  do
    if (i = !1, s.steiner || !wue(s, s.next) && vd(s.prev, s, s.next) !== 0) s = s.next;
    else {
      if (n = s.prev, kX(s), s = t = n, s === s.next) break;
      i = !0;
    }
  while (i || s !== t);
  return t;
}
function HX(e, t, i, n, s, o, r) {
  !r && o && (function(c, h, I, p) {
    let y = c;
    do
      y.z === null && (y.z = LIe(y.x, y.y, h, I, p)), y.prevZ = y.prev, y.nextZ = y.next, y = y.next;
    while (y !== c);
    y.prevZ.nextZ = null, y.prevZ = null, (function(m) {
      let A, C = 1;
      do {
        let O, R = m;
        m = null;
        let F = null;
        for (A = 0; R; ) {
          A++;
          let L = R, P = 0;
          for (let W = 0; W < C && (P++, L = L.nextZ, L); W++) ;
          let z = C;
          for (; P > 0 || z > 0 && L; ) P !== 0 && (z === 0 || !L || R.z <= L.z) ? (O = R, R = R.nextZ, P--) : (O = L, L = L.nextZ, z--), F ? F.nextZ = O : m = O, O.prevZ = F, F = O;
          R = L;
        }
        F.nextZ = null, C *= 2;
      } while (A > 1);
    })(y);
  })(e, n, s, o);
  let l = e;
  for (; e.prev !== e.next; ) {
    const c = e.prev, h = e.next;
    if (o ? pqe(e, n, s, o) : Iqe(e)) t(c.i / i, e.i / i, h.i / i), kX(e), e = h.next, l = h.next;
    else if ((e = h) === l) {
      r ? r === 1 ? HX(e = mqe(O8(e), t, i), t, i, n, s, o, 2) : r === 2 && yqe(e, t, i, n, s, o) : HX(O8(e), t, i, n, s, o, 1);
      break;
    }
  }
}
function Iqe(e) {
  const t = e.prev, i = e, n = e.next;
  if (vd(t, i, n) >= 0) return !1;
  let s = e.next.next;
  for (; s !== e.prev; ) {
    if (mz(t.x, t.y, i.x, i.y, n.x, n.y, s.x, s.y) && vd(s.prev, s, s.next) >= 0) return !1;
    s = s.next;
  }
  return !0;
}
function pqe(e, t, i, n) {
  const s = e.prev, o = e, r = e.next;
  if (vd(s, o, r) >= 0) return !1;
  const l = Math.min(s.x, o.x, r.x), c = Math.min(s.y, o.y, r.y), h = Math.max(s.x, o.x, r.x), I = Math.max(s.y, o.y, r.y), p = LIe(l, c, t, i, n), y = LIe(h, I, t, i, n);
  let m = e.prevZ, A = e.nextZ;
  for (; m && m.z >= p && A && A.z <= y; ) {
    if (m !== e.prev && m !== e.next && mz(s.x, s.y, o.x, o.y, r.x, r.y, m.x, m.y) && vd(m.prev, m, m.next) >= 0 || (m = m.prevZ, A !== e.prev && A !== e.next && mz(s.x, s.y, o.x, o.y, r.x, r.y, A.x, A.y) && vd(A.prev, A, A.next) >= 0)) return !1;
    A = A.nextZ;
  }
  for (; m && m.z >= p; ) {
    if (m !== e.prev && m !== e.next && mz(s.x, s.y, o.x, o.y, r.x, r.y, m.x, m.y) && vd(m.prev, m, m.next) >= 0) return !1;
    m = m.prevZ;
  }
  for (; A && A.z <= y; ) {
    if (A !== e.prev && A !== e.next && mz(s.x, s.y, o.x, o.y, r.x, r.y, A.x, A.y) && vd(A.prev, A, A.next) >= 0) return !1;
    A = A.nextZ;
  }
  return !0;
}
function mqe(e, t, i) {
  let n = e;
  do {
    const s = n.prev, o = n.next.next;
    !wue(s, o) && ibe(s, n, n.next, o) && GX(s, o) && GX(o, s) && (t(s.i / i, n.i / i, o.i / i), kX(n.next), kX(n), n = e = o), n = n.next;
  } while (n !== e);
  return O8(n);
}
function yqe(e, t, i, n, s, o) {
  let r = e;
  do {
    let l = r.next.next;
    for (; l !== r.prev; ) {
      if (r.i !== l.i && Rqe(r, l)) {
        let c = nbe(r, l);
        return r = O8(r, r.next), c = O8(c, c.next), HX(r, t, i, n, s, o), void HX(c, t, i, n, s, o);
      }
      l = l.next;
    }
    r = r.next;
  } while (r !== e);
}
function Eqe(e, t) {
  return e.x - t.x;
}
function gqe(e, t) {
  const i = (function(o, r) {
    let l = r;
    const c = o.x, h = o.y;
    let I, p = -1 / 0;
    do {
      if (h <= l.y && h >= l.next.y && l.next.y !== l.y) {
        const O = l.x + (h - l.y) * (l.next.x - l.x) / (l.next.y - l.y);
        if (O <= c && O > p) {
          if (p = O, O === c) {
            if (h === l.y) return l;
            if (h === l.next.y) return l.next;
          }
          I = l.x < l.next.x ? l : l.next;
        }
      }
      l = l.next;
    } while (l !== r);
    if (!I) return null;
    if (c === p) return I;
    const y = I, m = I.x, A = I.y;
    let C = 1 / 0;
    l = I;
    do {
      if (c >= l.x && l.x >= m && c !== l.x && mz(h < A ? c : p, h, m, A, h < A ? p : c, h, l.x, l.y)) {
        const O = Math.abs(h - l.y) / (c - l.x);
        GX(l, o) && (O < C || O === C && (l.x > I.x || l.x === I.x && wqe(I, l))) && (I = l, C = O);
      }
      l = l.next;
    } while (l !== y);
    return I;
  })(e, t);
  if (!i) return t;
  const n = nbe(i, e), s = O8(i, i.next);
  return O8(n, n.next), t === t.next || i === t ? s : t;
}
function wqe(e, t) {
  return vd(e.prev, e, t.prev) < 0 && vd(t.next, e, e.next) < 0;
}
function LIe(e, t, i, n, s) {
  return (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = 32767 * (e - i) * s) | e << 8)) | e << 4)) | e << 2)) | e << 1)) | (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = 32767 * (t - n) * s) | t << 8)) | t << 4)) | t << 2)) | t << 1)) << 1;
}
function Tqe(e) {
  let t = e, i = e;
  do
    (t.x < i.x || t.x === i.x && t.y < i.y) && (i = t), t = t.next;
  while (t !== e);
  return i;
}
function mz(e, t, i, n, s, o, r, l) {
  return (s - r) * (t - l) - (e - r) * (o - l) >= 0 && (e - r) * (n - l) - (i - r) * (t - l) >= 0 && (i - r) * (o - l) - (s - r) * (n - l) >= 0;
}
function Rqe(e, t) {
  return e.next.i !== t.i && e.prev.i !== t.i && !(function(i, n) {
    let s = i;
    do {
      if (s.i !== i.i && s.next.i !== i.i && s.i !== n.i && s.next.i !== n.i && ibe(s, s.next, i, n)) return !0;
      s = s.next;
    } while (s !== i);
    return !1;
  })(e, t) && (GX(e, t) && GX(t, e) && (function(i, n) {
    let s = i, o = !1;
    const r = (i.x + n.x) / 2, l = (i.y + n.y) / 2;
    do
      s.y > l != s.next.y > l && s.next.y !== s.y && r < (s.next.x - s.x) * (l - s.y) / (s.next.y - s.y) + s.x && (o = !o), s = s.next;
    while (s !== i);
    return o;
  })(e, t) && (vd(e.prev, e, t.prev) || vd(e, t.prev, t)) || wue(e, t) && vd(e.prev, e, e.next) > 0 && vd(t.prev, t, t.next) > 0);
}
function vd(e, t, i) {
  return (t.y - e.y) * (i.x - t.x) - (t.x - e.x) * (i.y - t.y);
}
function wue(e, t) {
  return e.x === t.x && e.y === t.y;
}
function ibe(e, t, i, n) {
  const s = pse(vd(e, t, i)), o = pse(vd(e, t, n)), r = pse(vd(i, n, e)), l = pse(vd(i, n, t));
  return s !== o && r !== l || !(s !== 0 || !Ise(e, i, t)) || !(o !== 0 || !Ise(e, n, t)) || !(r !== 0 || !Ise(i, e, n)) || !(l !== 0 || !Ise(i, t, n));
}
function Ise(e, t, i) {
  return t.x <= Math.max(e.x, i.x) && t.x >= Math.min(e.x, i.x) && t.y <= Math.max(e.y, i.y) && t.y >= Math.min(e.y, i.y);
}
function pse(e) {
  return e > 0 ? 1 : e < 0 ? -1 : 0;
}
function GX(e, t) {
  return vd(e.prev, e, e.next) < 0 ? vd(e, t, e.next) >= 0 && vd(e, e.prev, t) >= 0 : vd(e, t, e.prev) < 0 || vd(e, e.next, t) < 0;
}
function nbe(e, t) {
  const i = _Ie(e.i, e.x, e.y), n = _Ie(t.i, t.x, t.y), s = e.next, o = t.prev;
  return e.next = t, t.prev = e, i.next = s, s.prev = i, n.next = i, i.prev = n, o.next = n, n.prev = o, n;
}
function Mwe(e, t, i, n) {
  const s = _Ie(e, t, i);
  return n ? (s.next = n.next, s.prev = n, n.next.prev = s, n.next = s) : (s.prev = s, s.next = s), s;
}
function kX(e) {
  e.next.prev = e.prev, e.prev.next = e.next, e.prevZ && (e.prevZ.nextZ = e.nextZ), e.nextZ && (e.nextZ.prevZ = e.prevZ), e.next = e, e.prev = e;
}
function _Ie(e, t, i) {
  return { i: e, x: t, y: i, prev: null, next: null, z: null, prevZ: null, nextZ: null, steiner: !1 };
}
const sbe = class xIe {
  static create(t, i, n, s, o, r, l, c) {
    const h = t.length, I = l.verticesAmount;
    xIe.processBuffers(h, t, o, l, i, n);
    const p = o.positionBuffer, y = (l.verticesAmount - I) / 3;
    this.processNormals(p, this._tempVec, y, I), this.triangulate(r, s, h, o, l, I), this.setFaceId(I, l, o, c);
  }
  static setFaceId(t, i, n, s) {
    const o = t / 3, r = i.verticesAmount / 3;
    for (let l = o; l < r; l++) n.faceIdBuffer[l] = s;
  }
  static getVertices(t, i, n) {
    const s = t.positionBuffer.buffer, o = 4 * i, r = n.verticesAmount - i;
    return new Float32Array(s, o, r);
  }
  static getEvent(t, i, n) {
    return (s, o, r) => {
      const l = t.indexBuffer;
      l[i.indices++] = s + n / 3, l[i.indices++] = o + n / 3, l[i.indices++] = r + n / 3;
    };
  }
  static processBuffers(t, i, n, s, o, r) {
    for (let l = 0; l < t; l++) this.processPositionBuffer(n, i, l, s, o), this.processNormalbuffer(n, r, l, s), this.updateBufferData(s);
  }
  static getHoles(t, i, n, s, o) {
    if (t && t.has(i)) {
      const r = t.get(i), l = [];
      for (const c of r.indices) l.push(c + n);
      return this.setHolesBuffers(s, r, o), l;
    }
  }
  static setHolesBuffers(t, i, n) {
    const s = t.positionBuffer, o = t.normalBuffer;
    s.set(i.points, n.verticesAmount);
    const r = i.points.length;
    n.verticesAmount += r, n.vertices += r / 3, o.set(i.normals, n.normalsAmount), n.normalsAmount += r;
  }
  static updateBufferData(t) {
    t.vertices += 1, t.verticesAmount += 3, t.normalsAmount += 3;
  }
  static processPositionBuffer(t, i, n, s, o) {
    const r = t.positionBuffer;
    for (let l = 0; l < 3; l++) {
      const c = 3 * i[n];
      r[s.verticesAmount + l] = o[c + l];
    }
  }
  static triangulate(t, i, n, s, o, r) {
    const l = this.getHoles(t, i, n, s, o), c = xIe.getVertices(s, r, o), h = KSe.getEarcutDimensions(this._tempVec), I = this.getEvent(s, o, r);
    fqe(c, l, 3, h[0], h[1], I);
  }
  static processNormals(t, i, n, s = 0) {
    i.set(0, 0, 0);
    for (let o = 0; o < n; o++) {
      const r = s + 3 * o, l = s + 3 * ((o + 1) % n), c = t[r + 0], h = t[l + 0], I = t[r + 1], p = t[l + 1], y = t[r + 2], m = t[l + 2];
      i.x += (I - p) * (y + m), i.y += (y - m) * (c + h), i.z += (c - h) * (I + p);
    }
    i.normalize();
  }
  static processNormalbuffer(t, i, n, s) {
    const o = t.normalBuffer, r = 3 * n, l = i[r], c = i[r + 1], h = i[r + 2];
    o.set([l, c, h], s.normalsAmount);
  }
};
De(sbe, "_tempVec", new Ge());
let obe = sbe;
const Hh = class {
  static create(e, t, i, n, s, o, r) {
    this.setAllVectors(e, t), this.getIsConvex() ? this.processConvexFace4(s, o, i, r) : obe.create(e, t, i, n, s, void 0, o, r);
  }
  static setAllVectors(e, t) {
    this.setVector(e, t, this.a, 0), this.setVector(e, t, this.b, 1), this.setVector(e, t, this.c, 2), this.setVector(e, t, this.d, 3), this.getCrossVectors();
  }
  static processConvexFace4(e, t, i, n) {
    this.processIndices(e, t), this.processPoints(e, t), this.processNormal(e, t, i), this.setFaceId(e, t, n), this.updateData(t);
  }
  static setFaceId(e, t, i) {
    const n = e.faceIdBuffer;
    for (let s = t.vertices; s < t.vertices + 4; s++) n[s] = i;
  }
  static getIsConvex() {
    return this.h.dot(this.i) > 0;
  }
  static getCrossVectors() {
    this.e.copy(this.b), this.f.copy(this.c), this.g.copy(this.d), this.e.sub(this.a), this.f.sub(this.a), this.g.sub(this.a), this.h.crossVectors(this.e, this.f), this.i.crossVectors(this.f, this.g);
  }
  static updateData(e) {
    e.normalsAmount += this.totalIncrease, e.vertices += this.vertexIncrease, e.verticesAmount += this.totalIncrease;
  }
  static processPoints(e, t) {
    let i = 0;
    const n = e.positionBuffer, s = t.verticesAmount;
    for (let o = 0; o < this.vertexIncrease; o++) {
      const r = this._vecs[o];
      n[s + i++] = r.x, n[s + i++] = r.y, n[s + i++] = r.z;
    }
  }
  static setVector(e, t, i, n) {
    const s = 3 * e[n], o = t[s], r = t[s + 1], l = t[s + 2];
    i.set(o, r, l);
  }
  static processNormal(e, t, i) {
    const n = e.normalBuffer, s = t.normalsAmount;
    for (let o = 0; o < this.totalIncrease; o++) n[s + o] = i[o];
  }
  static processIndices(e, t) {
    const i = e.indexBuffer;
    for (let n = 0; n < this.indexIncrease; n++) {
      const s = this._convexIndices[n];
      i[t.indices + n] = t.vertices + s;
    }
    t.indices += this.indexIncrease;
  }
};
De(Hh, "a", new Ge()), De(Hh, "b", new Ge()), De(Hh, "c", new Ge()), De(Hh, "d", new Ge()), De(Hh, "e", new Ge()), De(Hh, "f", new Ge()), De(Hh, "g", new Ge()), De(Hh, "h", new Ge()), De(Hh, "i", new Ge()), De(Hh, "_vecs", [Hh.a, Hh.b, Hh.c, Hh.d]), De(Hh, "_convexIndices", [0, 1, 3, 3, 1, 2]), De(Hh, "totalIncrease", 12), De(Hh, "indexIncrease", 6), De(Hh, "vertexIncrease", 4);
let vqe = Hh;
const PIe = class Are {
  static create(t, i, n, s, o, r) {
    this.setFaceIds(o, s, r), this.setIndices(s, o), this.setPoints(t, s, o, i), this.setNormals(s, o, n), this.updateData(o);
  }
  static setFaceIds(t, i, n) {
    const s = t.verticesAmount / 3, o = s + 3;
    for (let r = s; r < o; r++) i.faceIdBuffer[r] = n;
  }
  static setNormals(t, i, n) {
    const s = t.normalBuffer;
    for (let o = 0; o < this.totalIncrease; o++) s[i.normalsAmount + o] = n[o];
  }
  static setPoints(t, i, n, s) {
    let o = 0;
    const r = i.positionBuffer;
    for (let l = 0; l < this.vertexIncrease; l++) {
      const c = t[l] * this.vertexIncrease;
      for (let h = 0; h < this.vertexIncrease; h++) r[n.verticesAmount + o] = s[c + h], o++;
    }
  }
  static setIndices(t, i) {
    const n = t.indexBuffer;
    for (let s = 0; s < this.vertexIncrease; s++) n[i.indices + s] = i.vertices + s;
    i.indices += this.vertexIncrease;
  }
  static updateData(t) {
    t.normalsAmount += Are.totalIncrease, t.vertices += Are.vertexIncrease, t.verticesAmount += Are.totalIncrease;
  }
};
De(PIe, "vertexIncrease", 3), De(PIe, "totalIncrease", 9);
let Aqe = PIe;
class Sqe {
  constructor() {
    De(this, "point", new Rf()), De(this, "_shellHole", new kp()), De(this, "_bigShellHole", new Gp()), De(this, "interiorProfiles", /* @__PURE__ */ new Map()), De(this, "normalsAvgInterior", new Int16Array()), De(this, "_pointsPerProfile", /* @__PURE__ */ new Map()), De(this, "_shellProfile", new qp()), De(this, "_bigShellProfile", new Yp()), De(this, "_normalsAvg", new Int16Array()), De(this, "_normals", []), De(this, "_indices", 0), De(this, "_sizes", { vertices: 0, indices: 0, verticesAmount: 0, normalsAmount: 0, normals: 0 }), De(this, "_tileData"), De(this, "_faceIdPerProfile", /* @__PURE__ */ new Map()), De(this, "nextBuffer", ((t) => {
      this.setTileData(t), this.initializeIndices(), this.initializePositions(), this.initializeNormals(), this.initializeFaceIds(), this.initializeSizes(), this._indices++;
    }));
  }
  construct(t, i) {
    this.resetConstructData(i), this.getPointsPerWire(t);
    const n = Br.getBuffer(t);
    this.newShellInteriorProfiles(t), this.constructShell(t, n, i), this._tileData = void 0;
  }
  getIntProfileNormalsAvg(t, i) {
    const n = this.getTempHole(t).indicesArray();
    this.normalsAvgInterior = Br.computeNormalsAvg(n, i, this._normals, this._pointsPerProfile);
  }
  saveInteriorProfile(t) {
    const i = this.getTempHole(t).profileId();
    if (this.interiorProfiles.has(i)) return this.saveExistingInteriorProfile(i), i;
    const n = this.getNewIntProfileData();
    return this.interiorProfiles.set(i, n), i;
  }
  computeNormalsAvg(t, i, n) {
    if (!this.isShell(t)) return;
    const s = this._normals, o = this._pointsPerProfile;
    this._normalsAvg = Br.computeNormalsAvg(i, n, s, o);
  }
  isShell(t) {
    return t instanceof Fo;
  }
  getPointsPerWire(t) {
    this.isShell(t) && (Br.getNormalsOfShellProfile(t, this._normals), this._pointsPerProfile = Br.getPointsShell(t));
  }
  getIndices(t, i) {
    const n = this.getTempProfile(t);
    return Br.getProfile(t, i, n), n.indicesArray();
  }
  resetConstructData(t) {
    this._indices = 0, this._tileData = void 0, this.nextBuffer(t), this._normals.length = 0;
  }
  initializeIndices() {
    const t = this._tileData.indexCount;
    this._tileData.indexBuffer = new Uint16Array(t);
  }
  constructFace4(t, i, n) {
    const s = this._faceIdPerProfile.get(n);
    vqe.create(t, i, this._normalsAvg, n, this._tileData, this._sizes, s);
  }
  initializeSizes() {
    this._sizes.vertices = 0, this._sizes.indices = 0, this._sizes.verticesAmount = 0, this._sizes.normalsAmount = 0, this._sizes.normals = 0;
  }
  getInteriorProfileBuffer(t, i) {
    const n = this.getTempHole(t).indicesLength();
    if (this.isShell(t)) for (let s = 0; s < n; s++) this.getIntProfilePoints(s, t, i), this.getIntProfileNormals(i, s);
  }
  constructProfile(t, i, n, s) {
    const o = this.getTempProfile(i).indicesLength(), r = !this.interiorProfiles.has(t);
    if (o === OIe.three && r) return void this.constructFace3(n, s, t);
    o === OIe.four && r ? this.constructFace4(n, s, t) : this.constructFaceX(n, s, t);
  }
  getIntProfileNormals(t, i) {
    const n = 3 * i, s = this.normalsAvgInterior[n], o = this.normalsAvgInterior[n + 1], r = this.normalsAvgInterior[n + 2];
    t.normals.push(s, o, r);
  }
  saveExistingInteriorProfile(t) {
    const i = this.interiorProfiles.get(t), n = i.points.length / 3;
    i.indices.push(n), this.interiorProfiles.set(t, i);
  }
  getNewIntProfileData() {
    return { indices: [0], points: [], normals: [] };
  }
  constructFace3(t, i, n) {
    const s = this._faceIdPerProfile.get(n);
    Aqe.create(t, i, this._normalsAvg, this._tileData, this._sizes, s);
  }
  getIntProfilePoints(t, i, n) {
    const s = this.getTempHole(i).indices(t);
    i.points(s, this.point);
    const o = this.point.x(), r = this.point.y(), l = this.point.z();
    n.points.push(o, r, l);
  }
  manageMemory(t, i) {
    const n = this.getTempProfile(t).indicesLength();
    this._sizes.verticesAmount / 3 + n > WW && this.nextBuffer(i);
  }
  initializeFaceIds() {
    const t = this._tileData.positionCount;
    this._tileData.faceIdBuffer = new Uint32Array(t / 3);
  }
  getNextFaceId() {
    return 4294967295 * Math.random();
  }
  newShellInteriorProfiles(t) {
    this.interiorProfiles.clear();
    const i = Br.getHolesLength(t), n = this.getTempHole(t);
    for (let s = 0; s < i; s++) {
      Br.getHole(t, s, n);
      const o = this.saveInteriorProfile(t), r = this.interiorProfiles.get(o);
      this.getIntProfileNormalsAvg(t, o), this.getInteriorProfileBuffer(t, r);
    }
    return this.interiorProfiles;
  }
  initializePositions() {
    const t = this._tileData.positionCount;
    this._tileData.positionBuffer = new Float32Array(t);
  }
  initializeNormals() {
    const t = this._tileData.normalCount;
    this._tileData.normalBuffer = new Int16Array(t);
  }
  setTileData(t) {
    Array.isArray(t) ? this._tileData = t[this._indices] : this._tileData = t;
  }
  constructShell(t, i, n) {
    this.getFaceIds(t);
    const s = Br.getProfilesLength(t);
    for (let o = 0; o < s; o++) {
      const r = this.getIndices(t, o);
      this.computeNormalsAvg(t, r, o), this.constructProfile(o, t, r, i), this.manageMemory(t, n);
    }
  }
  constructFaceX(t, i, n) {
    const s = this._faceIdPerProfile.get(n);
    obe.create(t, i, this._normalsAvg, n, this._tileData, this.interiorProfiles, this._sizes, s);
  }
  getTempProfile(t) {
    return t.type() === F0.BIG ? this._bigShellProfile : this._shellProfile;
  }
  getTempHole(t) {
    return t.type() === F0.BIG ? this._bigShellHole : this._shellHole;
  }
  getFaceIds(t) {
    this._faceIdPerProfile.clear();
    const i = t.profilesFaceIdsArray(), n = /* @__PURE__ */ new Map();
    if (i && i.length > 0) for (let s = 0; s < i.length; s++) {
      const o = i[s];
      n.has(o) || n.set(o, this.getNextFaceId());
      const r = n.get(o);
      this._faceIdPerProfile.set(s, r);
    }
    else for (let s = 0; s < t.profilesLength(); s++) this._faceIdPerProfile.set(s, this.getNextFaceId());
  }
}
class bqe {
  constructor(t) {
    De(this, "a", new Ge()), De(this, "b", new Ge()), De(this, "c", new Ge()), De(this, "d", new Ge()), De(this, "e", new Ge()), De(this, "f", new Ge()), De(this, "g", new Ge()), De(this, "h", new Ge()), De(this, "i", new Ge()), De(this, "j", new Ge()), De(this, "k", new Ge()), De(this, "tempTriangle", new wc()), De(this, "tempPlane", new tl()), De(this, "includedVertices", []), De(this, "interiorProfiles", /* @__PURE__ */ new Map()), De(this, "_meshes"), this._meshes = t;
  }
  faceRaycast(t, i) {
    const n = Br.getShell(this._meshes, t);
    this.resetData(), this.getInteriorProfiles(n);
    const s = Br.getBuffer(n);
    return this.processAllCollisions(n, s, i), this.includedVertices;
  }
  resetVectors() {
    this.a.set(0, 0, 0), this.b.set(0, 0, 0), this.c.set(0, 0, 0), this.d.set(0, 0, 0);
  }
  resetData() {
    this.includedVertices.length = 0, this.interiorProfiles.clear();
  }
  getInteriorProfiles(t) {
    const i = Br.getHolesLength(t);
    for (let n = 0; n < i; n++) {
      const s = Br.getHole(t, n).profileId();
      this.interiorProfiles.has(s) || this.interiorProfiles.set(s, []), this.interiorProfiles.get(s).push(n);
    }
  }
  processTriangle(t, i, n) {
    const s = 3 * t[0], o = 3 * t[1], r = 3 * t[2];
    this.saveTriPoint(this.e, i, s), this.saveTriPoint(this.f, i, o), this.saveTriPoint(this.g, i, r);
    const l = this.triangleHit(n);
    if (l) {
      const c = this.getTriangleBuffer(i, t);
      l.facePoints = c.points, l.faceIndices = c.indices, this.includedVertices.push(l);
    }
  }
  processAllCollisions(t, i, n) {
    const s = Br.getProfilesLength(t);
    for (let o = 0; o < s; o++) {
      this.resetVectors();
      const r = this.getIndices(t, o);
      this.getValidCollision(r, i, n, o, t) && this.processCollision(t, o, i, r);
    }
  }
  saveTriPoint(t, i, n) {
    const s = i[n], o = i[n + 1], r = i[n + 2];
    t.set(s, o, r);
  }
  getIndices(t, i) {
    return Br.getProfile(t, i).indicesArray();
  }
  getIsTriangle(t) {
    return t.length === 3;
  }
  getNormal() {
    this.tempTriangle.a = this.e, this.tempTriangle.b = this.f, this.tempTriangle.c = this.g;
    const t = new Ge();
    return this.tempTriangle.getNormal(t), t;
  }
  isHole(t, i, n) {
    if (this.interiorProfiles.has(t)) {
      const s = this.interiorProfiles.get(t);
      return this.holeContains(s, i, n);
    }
    return !1;
  }
  computeNormal(t, i) {
    this.d.set(0, 0, 0);
    const n = i.length;
    for (let s = 0; s < n; s++) {
      const o = (s + 1) % n, r = 3 * i[s], l = 3 * i[o];
      this.processNormal(t, r, l);
    }
    this.d.normalize();
  }
  holeContains(t, i, n) {
    const s = t.length;
    for (let o = 0; o < s; o++) {
      const r = Br.getHole(i, t[o]).indicesArray();
      if (this.polygonContains(n, r)) return !0;
    }
    return !1;
  }
  triangleHit(t) {
    const i = this.e, n = this.f, s = this.g;
    if (!t.intersectTriangle(i, n, s, !1, this.h)) return;
    const o = this.getNormal();
    return { point: this.h.clone(), normal: o };
  }
  getValidCollision(t, i, n, s, o) {
    return this.getIsTriangle(t) ? (this.processTriangle(t, i, n), !1) : this.getCollidesPlane(t, i, n) ? !this.isHole(s, o, i) : !1;
  }
  processCollision(t, i, n, s) {
    if (!this.polygonContains(n, s)) return;
    const o = this.b.clone(), r = this.tempPlane.normal.clone(), l = this.getFaceBuffer(t, i, n);
    this.includedVertices.push({ point: o, normal: r, facePoints: l.points, faceIndices: l.indices });
  }
  newOrthoNormalBasis() {
    const t = this.tempPlane.normal, i = this.j, n = this.i;
    if (Math.abs(t.x) >= Math.abs(t.y)) {
      const s = 1 / Math.sqrt(t.x * t.x + t.z * t.z), o = -t.z * s, r = 0, l = t.x * s;
      i.set(o, r, l);
      const c = t.y * i.z, h = t.z * i.x - t.x * i.z, I = -t.y * i.x;
      n.set(c, h, I);
    } else {
      const s = 1 / Math.sqrt(t.y * t.y + t.z * t.z), o = 0, r = t.z * s, l = -t.y * s;
      i.set(o, r, l);
      const c = t.y * i.z - t.z * i.y, h = -t.x * i.z, I = t.x * i.y;
      n.set(c, h, I);
    }
    i.normalize(), n.normalize();
  }
  polygonContains(t, i) {
    let n = !1;
    this.newOrthoNormalBasis(), this.setPolyContainVec(i, t);
    let s = this.k.dot(this.i), o = this.k.dot(this.j);
    for (let r = 0; r < i.length; r++) {
      const l = 3 * i[r], c = t[l], h = t[l + 1], I = t[l + 2];
      this.k.set(c, h, I), this.k.sub(this.b);
      const p = this.k.dot(this.i), y = this.k.dot(this.j);
      y > 0 != o > 0 && (s - p) * -y / (o - y) + p > 0 && (n = !n), s = p, o = y;
    }
    return n;
  }
  processNormal(t, i, n) {
    const s = t[i + 0], o = t[n + 0], r = t[i + 1], l = t[n + 1], c = t[i + 2], h = t[n + 2];
    this.d.x += (r - l) * (c + h), this.d.y += (c - h) * (s + o), this.d.z += (s - o) * (r + l);
  }
  getCollidesPlane(t, i, n) {
    const s = 3 * t[0], o = i[s], r = i[s + 1], l = i[s + 2];
    return this.a.set(o, r, l), this.computeNormal(i, t), this.tempPlane.setFromNormalAndCoplanarPoint(this.d, this.a), n.intersectPlane(this.tempPlane, this.b);
  }
  setPolyContainVec(t, i) {
    const n = 3 * t[t.length - 1], s = i[n], o = i[n + 1], r = i[n + 2];
    this.k.set(s, o, r), this.k.sub(this.b);
  }
  getTriangleBuffer(t, i) {
    const n = [], s = [];
    for (let o = 0; o < i.length; o++) {
      const r = 3 * i[o];
      n.push(t[r], t[r + 1], t[r + 2]), s.push(o);
    }
    return { points: new Float32Array(n), indices: s };
  }
  getFaceBuffer(t, i, n) {
    const s = Br.getProfileIndices(t, i), { outer: o, inners: r } = s, l = [];
    for (let F = 0; F < o.length; F++) {
      const L = 3 * o[F];
      l.push(n[L], n[L + 1], n[L + 2]);
    }
    const c = [];
    for (let F = 0; F < r.length; F++) {
      const L = r[F];
      c.push(l.length / 3);
      for (let P = 0; P < L.length; P++) {
        const z = 3 * L[P];
        l.push(n[z], n[z + 1], n[z + 2]);
      }
    }
    const h = new Ge(), I = new Ge(), p = new Ge();
    h.set(l[0], l[1], l[2]), I.set(l[3], l[4], l[5]), p.set(l[6], l[7], l[8]);
    const y = new wc();
    y.set(h, I, p);
    const m = new Ge();
    y.getNormal(m);
    const [A, C] = KSe.getEarcutDimensions(m), O = [];
    for (let F = 0; F < l.length; F += 3) {
      const L = [l[F], l[F + 1], l[F + 2]];
      O.push(L[A], L[C]);
    }
    const R = yYe(O, c);
    return { points: new Float32Array(l), indices: R };
  }
}
class Nqe {
  constructor(t) {
    De(this, "_meshes"), De(this, "_minAngle", Math.PI / 32), De(this, "_shellProfile", new qp()), De(this, "_bigShellProfile", new Yp()), De(this, "_tempV1", new Ge()), De(this, "_tempV2", new Ge()), De(this, "_tempPoint", new Ge()), De(this, "_normals", []), De(this, "_pointsByProfile", /* @__PURE__ */ new Map()), De(this, "_shell", new Fo()), De(this, "_result", []), this._meshes = t;
  }
  lineRaycast(t, i, n) {
    return this.resetData(t), this.lineRaycastItems(i, n), this._result;
  }
  lineRaycastItems(t, i) {
    const n = Br.getProfilesLength(this._shell);
    for (let s = 0; s < n; s++) {
      const o = this.getTempProfile(this._shell);
      Br.getProfile(this._shell, s, o), this.lineRaycastProfile(t, i, s);
    }
  }
  resetData(t) {
    this._shell = Br.getShell(this._meshes, t), this._normals.length = 0, Br.getNormalsOfShellProfile(this._shell, this._normals), this._pointsByProfile = Br.getPointsShell(this._shell), this._result = [];
  }
  lineRaycastProfile(t, i, n) {
    const s = this.getTempProfile(this._shell), o = s.indicesLength();
    for (let r = 0; r < o; r++) {
      const l = s.indices(r), c = this.getSecondIndex(r, o);
      this.cast(l, c, t, i, n) && this.saveResult(n);
    }
  }
  isInvalidAngle(t, i, n) {
    const s = this.getProfile(t, i, n);
    if (!s.length) return !0;
    const o = this._normals[s[0]], r = this._normals[n];
    return o.dot(r) > Math.cos(this._minAngle);
  }
  getProfile(t, i, n) {
    const s = this._pointsByProfile.get(t), o = this._pointsByProfile.get(i), r = [];
    for (const l of s) o.indexOf(l) !== -1 && l !== n && r.push(l);
    return r;
  }
  cast(t, i, n, s, o) {
    return Br.point(this._shell, t, this._tempV1), Br.point(this._shell, i, this._tempV2), this.raycastSegment(n), s.containsPoint(this._tempPoint) ? !this.isInvalidAngle(t, i, o) : !1;
  }
  saveResult(t) {
    const i = this._tempV1.clone(), n = this._tempV2.clone(), s = this._normals[t], o = this._tempPoint.clone();
    this._result.push({ point: o, normal: s, snappedEdgeP1: i, snappedEdgeP2: n });
  }
  getSecondIndex(t, i) {
    const n = t === i - 1, s = this.getTempProfile(this._shell);
    return n ? s.indices(0) : s.indices(t + 1);
  }
  raycastSegment(t) {
    t.distanceSqToSegment(this._tempV1, this._tempV2, void 0, this._tempPoint);
  }
  getTempProfile(t) {
    return t.type() === F0.BIG ? this._bigShellProfile : this._shellProfile;
  }
}
class Dqe {
  constructor(t) {
    De(this, "_meshes"), De(this, "_tempVec", new Ge()), this._meshes = t;
  }
  pointRaycast(t, i) {
    const n = Br.getShell(this._meshes, t), s = [];
    return this.cast(n, i, s), s;
  }
  cast(t, i, n) {
    const s = t.pointsLength();
    for (let o = 0; o < s; o++) {
      if (Br.point(t, o, this._tempVec), !i.containsPoint(this._tempVec)) continue;
      const r = this._tempVec.clone();
      n.push({ point: r });
    }
  }
}
class Cqe extends tbe {
  constructor() {
    super(...arguments), De(this, "_lodClass", cB.AABB), De(this, "_objectClass", tE.SHELL), De(this, "_representationClass", Mr.SHELL), De(this, "_templates", new hqe()), De(this, "_constructor", new Sqe()), De(this, "_faceRaycaster", new bqe(this.meshes)), De(this, "_lineRaycaster", new Nqe(this.meshes)), De(this, "_pointRaycaster", new Dqe(this.meshes));
  }
  fetchMeshes(t, i) {
    const n = this.getMesh(t, Bo.GEOMETRY);
    return this.constructMesh(n, i, t), n;
  }
  newMeshTemplate(t) {
    return this._templates.newMeshTemplate(t);
  }
  lineRaycast(t, i, n) {
    return this._lineRaycaster.lineRaycast(t, i, n);
  }
  faceRaycast(t, i) {
    return this._faceRaycaster.faceRaycast(t, i);
  }
  raycast(t, i) {
    return this._faceRaycaster.faceRaycast(t, i);
  }
  pointRaycast(t, i, n) {
    return this._pointRaycaster.pointRaycast(t, n);
  }
  setupTemplates() {
    for (let t = 0, i = this.meshes.shellsLength(); t < i; t++) {
      const n = Br.getShell(this.meshes, t);
      this.useMesh(t, this.newMeshTemplate(n), Bo.GEOMETRY);
    }
  }
  getRepresentation() {
    return this._representationClass;
  }
  getObjectClass() {
    return this._objectClass;
  }
  getLodClass() {
    return this._lodClass;
  }
  isVoidMesh(t) {
    return Array.isArray(t) ? t[0].positionBuffer === void 0 : t.positionBuffer === void 0;
  }
  constructMesh(t, i, n) {
    if (!this.isVoidMesh(t) || !i) return;
    const s = Br.getShell(this.meshes, n);
    this._constructor.construct(s, t), this.saveMesh(n, t, Bo.GEOMETRY);
  }
}
class ho {
  static circleCurve3Divisions(t) {
    const i = t.aperture() * t.radius() * 4, n = Math.round(i);
    return Math.min(Math.max(n, 4), 32);
  }
  static traverseCircleCurve(t, i, n) {
    const s = t.circleCurvesLength();
    for (let o = 0; o < s; o++) {
      this.getAllCircleCurveData(t, o);
      const r = n(this._circleCurve);
      this._circlePoints.length = r - 2, this.getCircleCurveMids(r), this.getNewCircleCurveData(), i(this._circleP1, this._circlePoints, this._circleP2);
    }
  }
  static traverseWireSets(t, i) {
    const n = t.wireSetsLength();
    for (let s = 0; s < n; s++) t.wireSets(s, this._wireSet), this.traverseWireSetWires(i);
  }
  static raycastCircleExtr(t, i, n, s) {
    const o = i.distanceTo(t);
    return this.setupCircleExtrusionAxes(i, t), this.setupCircleExtrusionTransform(t, s), this.setupCircleExtrusionRay(n), this.computeCircleExtrusionRaycast(o, s);
  }
  static traverseWires(t, i) {
    const n = t.wiresLength();
    for (let s = 0; s < n; s++) t.wires(s, this._wire), this.setWire(), i(this._wireP1, this._wireP2);
  }
  static getNewCircleCurveData() {
    this._circleP2.copy(this._circleP1);
    const t = this._circleCurve.aperture(), i = this._circleCurve.radius();
    this._circleP2.applyAxisAngle(this._circleOrientation, t), this._circleP2.multiplyScalar(i), this._circleP2.add(this._circleOrigin), this._circleP1.multiplyScalar(i), this._circleP1.add(this._circleOrigin);
  }
  static setWire() {
    this.setWirePoint("p1", this._wireP1), this.setWirePoint("p2", this._wireP2);
  }
  static getCircleCurveMids(t) {
    const i = this._circlePoints.length;
    for (let n = 0; n < i; n++) this._circlePoints[n] = this.newCirclePoint(n, t);
  }
  static newCirclePoint(t, i) {
    const n = i - 1, s = t + 1, o = new Ge();
    o.copy(this._circleP1);
    const r = this._circleCurve.radius(), l = this._circleCurve.aperture() * s / n;
    return o.applyAxisAngle(this._circleOrientation, l), o.multiplyScalar(r), o.add(this._circleOrigin), o;
  }
  static getAllCircleCurveData(t, i) {
    t.circleCurves(i, this._circleCurve), this.getCircleCurveData(this._circleOrigin, "position"), this.getCircleCurveData(this._circleOrientation, "xDirection"), this.getCircleCurveData(this._circleP1, "yDirection");
  }
  static setWirePoint(t, i) {
    this._wire[t](this._floats);
    const n = this._floats.x(), s = this._floats.y(), o = this._floats.z();
    i.set(n, s, o);
  }
  static getCircleCurveData(t, i) {
    const n = this._circleCurve[i]();
    this.getVectorData(n, t);
  }
  static getVectorData(t, i) {
    const n = t.x(), s = t.y(), o = t.z();
    i.set(n, s, o);
  }
  static traverseWireSetWires(t) {
    const i = this._wireSet.psLength() - 1;
    for (let n = 0; n < i; n++) this.getWiresetPoint(this._currentWireSetPoint, n), this.getWiresetPoint(this._nextWireSetPoint, n + 1), t(this._currentWireSetPoint, this._nextWireSetPoint);
  }
  static getWiresetPoint(t, i) {
    const n = this._wireSet.ps(i);
    this.getVectorData(n, t);
  }
  static setupCircleExtrusionTransform(t, i) {
    this._ceTransform.identity(), this._ceTransform.makeBasis(this._ceAxisX, this._ceAxisY, this._ceAxisZ), this._ceTransform.setPosition(t), this._ceSize.set(i, i, i), this._ceTransform.scale(this._ceSize);
  }
  static computeCircleExtrusionRaycastFactors() {
    const t = this._ceRay.direction, i = this._ceRay.origin, n = t.x * t.x + t.y * t.y, s = 2 * i.x * t.x + 2 * i.y * t.y, o = 4 * n * (i.x * i.x + i.y * i.y - 1), r = s * s;
    if (o > r) return null;
    const l = 2 * n, c = Math.sqrt(r - o);
    return { factorA: (-s + c) / l, factorB: (-s - c) / l };
  }
  static computeCircleExtrusionRaycast(t, i) {
    const n = this.computeCircleExtrusionRaycastFactors();
    if (n === null) return [];
    const { factorA: s, factorB: o } = n;
    return this._ceInverseTransform.transpose(), this._ceRaycastPoints = [], this.computeCircleExtrusionRaycastPoints(s, t, i), this.computeCircleExtrusionRaycastPoints(o, t, i), this._ceRaycastPoints;
  }
  static setupCircleExtrusionRay(t) {
    this._ceInverseTransform.copy(this._ceTransform), this._ceInverseTransform.invert(), this._ceRay.copy(t), this._ceRay.applyMatrix4(this._ceInverseTransform);
  }
  static computeCircleExtrusionRaycastPoints(t, i, n) {
    if (!this.checkIfCircleExtrusionClashes(t, i, n)) return;
    this._ceRaycastPoint.applyMatrix4(this._ceTransform);
    const s = this._ceRaycastPoint.clone();
    this._ceRaycastPoints.push({ point: s });
  }
  static setupCircleExtrusionAxes(t, i) {
    this._ceAxisZ.copy(t), this._ceAxisZ.sub(i), this._ceAxisZ.normalize(), this.computeNormal(this._ceAxisZ, this._ceAxisX), this._ceAxisY.crossVectors(this._ceAxisZ, this._ceAxisX);
  }
  static computeNormal(t, i) {
    const n = t.dot(this._ceAbsoluteX), s = Math.abs(n) > 0.9 ? this._ceAbsoluteZ : this._ceAbsoluteX;
    i.crossVectors(t, s), i.normalize();
  }
  static setupCircleExtrusionRaycastPoint(t) {
    this._ceRaycastPoint.copy(this._ceRay.direction), this._ceRaycastPoint.normalize(), this._ceRaycastPoint.multiplyScalar(t), this._ceRaycastPoint.add(this._ceRay.origin);
  }
  static checkIfCircleExtrusionClashes(t, i, n) {
    this.setupCircleExtrusionRaycastPoint(t);
    const s = i / n, o = this._ceRaycastPoint.z;
    return o >= 0 && o <= s;
  }
}
De(ho, "_floats", new Rf()), De(ho, "_wire", new Fie()), De(ho, "_wireSet", new k2()), De(ho, "_circleCurve", new rY()), De(ho, "_wireP1", new Ge()), De(ho, "_wireP2", new Ge()), De(ho, "_circleP1", new Ge()), De(ho, "_circleP2", new Ge()), De(ho, "_circleOrigin", new Ge()), De(ho, "_circleOrientation", new Ge()), De(ho, "_currentWireSetPoint", new Ge()), De(ho, "_nextWireSetPoint", new Ge()), De(ho, "_ceAxisZ", new Ge()), De(ho, "_ceAxisY", new Ge()), De(ho, "_ceAxisX", new Ge()), De(ho, "_ceRaycastPoint", new Ge()), De(ho, "_ceSize", new Ge()), De(ho, "_ceAbsoluteX", new Ge(0, 0, 1)), De(ho, "_ceAbsoluteZ", new Ge(1, 0, 0)), De(ho, "_circlePoints", []), De(ho, "_ceTransform", new Ln()), De(ho, "_ceInverseTransform", new Ln()), De(ho, "_ceRay", new MA()), De(ho, "_ceRaycastPoints", []);
const Zd = class JV {
  static newPaths(t, i) {
    const n = JV.newPathData();
    return this.fetchCircleCurveData(t, n), this.fetchCircleCurveMids(i, n, t), this.fetchCircleCurveEnds(n, t), this.fetchCircleCurveCuts(n), n.cuts;
  }
  static getAxisPartSize(t, i, n) {
    const s = t.parts(i), o = t.order(i), r = JV.getAxisPartData(s, n, t, o);
    return JV.fetchAxisPartSize(n, r), this._axisPartSize;
  }
  static vertexLength(t, i = 200) {
    const n = Math.round(t * i), s = Math.max(n, JV._minSize);
    return Math.min(s, JV._maxSize);
  }
  static setPathVertices(t) {
    const i = this.circleCurvePoints, n = !i, s = i && i.length !== t;
    if (n || s) {
      this.circleCurvePoints = [];
      for (let o = 0; o < t; o++) {
        const r = 2 * Math.PI * o / t, l = Math.sin(r), c = Math.cos(r), h = new Ge(l, c, 0);
        this.circleCurvePoints.push(h);
      }
    }
  }
  static fetchCircleCurveEnds(t, i) {
    t.last.copy(t.first), t.last.applyAxisAngle(t.axis, i.aperture()), t.last.multiplyScalar(i.radius()), t.last.add(t.center), t.first.multiplyScalar(i.radius()), t.first.add(t.center);
  }
  static getAxisPartData(t, i, n, s) {
    return { [ec.WIRE]: this.getAxisPartWireData, [ec.WIRE_SET]: this.getAxisPartWireSetData, [ec.CIRCLE_CURVE]: this.getAxisPartCircleCurveData }[t](n, s, i);
  }
  static newEmptyAxisPartData() {
    return { indices: 0, points: 0, faces: 0, links: 0 };
  }
  static fetchCircleCurveMids(t, i, n) {
    const s = t - 2;
    for (let o = 0; o < s; o++) {
      const r = new Ge();
      r.copy(i.first);
      const l = n.aperture() * (o + 1) / (t - 1);
      r.applyAxisAngle(i.axis, l), r.multiplyScalar(n.radius()), r.add(i.center), i.mids[o] = r;
    }
  }
  static validSize(t, i, n) {
    return WW >= t + i + n;
  }
  static fetchCircleCurveCuts(t) {
    t.cuts.push(t.first), t.cuts.push(...t.mids), t.cuts.push(t.last);
  }
  static fetchCircleCurveData(t, i) {
    const n = t.position();
    i.center.set(n.x(), n.y(), n.z());
    const s = t.xDirection();
    i.axis.set(s.x(), s.y(), s.z());
    const o = t.yDirection();
    i.first.set(o.x(), o.y(), o.z());
  }
  static newPathData() {
    return { axis: new Ge(), cuts: [], center: new Ge(), last: new Ge(), first: new Ge(), mids: [] };
  }
  static fetchAxisPartSize(t, i) {
    const n = t - 2, s = i.faces * n * 3, o = i.links * t * this._wireSize;
    this._axisPartSize.verticesLength = i.points, this._axisPartSize.indicesLength = i.indices + s + o;
  }
};
De(Zd, "up", new Ge(0, 0, 1)), De(Zd, "circleCurves", []), De(Zd, "circleCurvePoints"), De(Zd, "temp", { circleExtrusion: new pl(), circleCurve: new rY(), wireSet: new k2(), axis: new Ds(), rotation: new gI(), vector: new Ge() }), De(Zd, "_wireSize", 6), De(Zd, "_minSize", 6), De(Zd, "_maxSize", 30), De(Zd, "_axisPartSize", { verticesLength: 0, indicesLength: 0 }), De(Zd, "getAxisPartWireSetData", ((e, t, i) => {
  const n = Zd.newEmptyAxisPartData();
  e.wireSets(t, Zd.temp.wireSet);
  const s = Zd.temp.wireSet.psLength() - 1;
  return n.points = 2 * s * i, n.indices = Zd._wireSize * s * i, n.faces = 2 * s, n;
})), De(Zd, "getAxisPartWireData", ((e, t, i) => {
  const n = Zd.newEmptyAxisPartData();
  return n.points = 2 * i, n.indices = Zd._wireSize * i, n.faces = 2, n;
})), De(Zd, "getAxisPartCircleCurveData", ((e, t, i) => {
  const n = Zd.newEmptyAxisPartData();
  e.circleCurves(t, Zd.temp.circleCurve);
  const s = ho.circleCurve3Divisions(Zd.temp.circleCurve), o = i * s;
  n.points = o;
  const r = i * (s - 1), l = Zd._wireSize * r;
  return n.indices = l, n.faces = 2, n.links = 2, n;
}));
let Tn = Zd;
class Oqe {
  constructor() {
    De(this, "_minLinkDistance", 1e-8), De(this, "_first", new Ge()), De(this, "_last", new Ge()), De(this, "_currentPoint"), De(this, "_currentIndex"), De(this, "_v1", new Ge()), De(this, "_v2", new Ge()), De(this, "_v3", new Ge()), De(this, "_v4", new Ge()), De(this, "_tempLine", new gc()), De(this, "_total", 0), De(this, "_closest", 0), De(this, "_result", 0);
  }
  newTemplate(t, i, n) {
    const s = t.radius(i), o = t.axes(i, Tn.temp.axis), r = Tn.vertexLength(s);
    let l = n[n.length - 1];
    const c = o.orderLength();
    for (let h = 0; h < c; h++) l = this.generateTemplate(o, h, r, l, n);
  }
  construct(t, i) {
    const n = {};
    let s = 0;
    for (let o = 0, r = t.axesLength(); o < r; o++) {
      const l = t.radius(o);
      t.axes(o, Tn.temp.axis);
      const c = Tn.vertexLength(l);
      s = this.constructVce(c, n, void 0, s, 0, i, l);
    }
  }
  getTemplateCreationData(t, i, n) {
    const s = !t;
    let o = !1;
    if (!s) {
      const r = t.positionCount / 3, l = i.verticesLength;
      o = Tn.validSize(r, l, n);
    }
    return { isStart: s, fits: o };
  }
  generateTemplate(t, i, n, s, o) {
    const r = Tn.getAxisPartSize(t, i, n), { isStart: l, fits: c } = this.getTemplateCreationData(s, r, n);
    return (l || !c) && (s = this.newTemplateData(), o.push(s), this.savePrevious(l, i, n, s)), s.positionCount += 3 * r.verticesLength, s.normalCount += 3 * r.verticesLength, s.indexCount += r.indicesLength, s;
  }
  savePrevious(t, i, n, s) {
    if (!t && i !== 0) {
      const o = 3 * (n - 2);
      s.positionCount += 3 * n, s.normalCount += 3 * n, s.indexCount += o;
    }
  }
  constructNewVce(t, i, n, s, o, r, l) {
    const c = !t;
    let h = !1;
    if (!c) {
      const I = i.verticesLength;
      h = Tn.validSize(n, I, s);
    }
    if (c || !h) {
      t = o[r++], this.setupNewVceBuffers(t);
      const I = this._currentPoint;
      if (n = this.clearOffset(n), !c && l !== 0) {
        const p = o[r - 2];
        this.getClone(p, t, I, s), n += s;
      }
    }
    return { data: t, pointAmount: n, position: r };
  }
  constructVce(t, i, n, s, o, r, l) {
    const c = Tn.temp.axis.orderLength();
    for (let h = 0; h < c; h++) {
      const I = Tn.temp.axis, p = Tn.getAxisPartSize(I, h, t);
      this.setupLink(h, i), { data: n, pointAmount: s, position: o } = this.constructNewVce(n, p, s, t, r, o, h), this.newAxisPart(Tn.temp.axis, h, n, l, t, i), s += p.verticesLength;
    }
    return s;
  }
  newTemplateData() {
    return { objectClass: tE.SHELL, indexCount: 0, positionCount: 0, normalCount: 0 };
  }
  setupNewVceBuffers(t) {
    t.positionBuffer = new Float32Array(t.positionCount), t.normalBuffer = new Int16Array(t.normalCount), t.indexBuffer = new Uint16Array(t.indexCount);
  }
  clearOffset(t) {
    return this._currentPoint = 0, this._currentIndex = 0, 0;
  }
  getClone(t, i, n, s) {
    for (let o = -3 * s; o < 0; o++) {
      const r = i.positionBuffer, l = t.positionBuffer, c = i.normalBuffer, h = t.normalBuffer;
      r[this._currentPoint] = l[n + o], c[this._currentPoint] = h[n + o], this._currentPoint++;
    }
  }
  manageAxisPartCreation(t, i, n, s, o, r, l) {
    if (t !== ec.CIRCLE_CURVE) if (t !== ec.WIRE_SET) {
      if (t === ec.WIRE) {
        const c = i.wires(n);
        this.newWire(c, s, o, r, l);
      }
    } else {
      const c = i.wireSets(n);
      this.newWireSet(c, s, o, r, l);
    }
    else {
      const c = i.circleCurves(n);
      this.newCircleCurve(c, s, o, r, l);
    }
  }
  newWireSetStart(t, i, n, s) {
    t === 1 ? this.linkStart(i, n, s, this._first, ec.WIRE_SET) : this.newPathOrderData(i, n);
  }
  newWireSet(t, i, n, s, o) {
    for (let r = 1, l = t.psLength(); r < l; r++) {
      const c = Tn.temp.rotation;
      this.getWireSetPoints(t, r), this.setWireSetVector(), this.newPath(this._first, i, c, n, s), this.newWireSetStart(r, n, s, o), this.newPath(this._last, i, c, n, s), this.fillWireSetData(r, l, o, n, s), this.linkPaths(n, s);
    }
  }
  fillWireSetData(t, i, n, s, o) {
    t !== i - 1 || n.last ? this.newPathOrderData(s, o, !0) : (n.placement = this._last, n.axisClass = ec.WIRE_SET);
  }
  setWireSetVector() {
    Tn.temp.vector.copy(this._last), Tn.temp.vector.sub(this._first), Tn.temp.vector.normalize(), Tn.temp.rotation.setFromUnitVectors(Tn.up, Tn.temp.vector);
  }
  newCircleCurveBody(t, i, n, s) {
    const o = t - 2;
    for (let r = 0; r < o; r++) {
      const l = Tn.circleCurves[r], c = Tn.circleCurves[r + 1], h = Tn.circleCurves[r + 2], I = Tn.temp.vector;
      I.copy(h), I.sub(l), I.normalize(), Tn.temp.rotation.setFromUnitVectors(Tn.up, I), this.newPath(c, i, Tn.temp.rotation, n, s), this.linkPaths(n, s, !0);
    }
  }
  newCircleCurveFinish(t, i, n, s, o) {
    const r = t - 2, l = t - 1, c = Tn.circleCurves[r], h = Tn.circleCurves[l], I = Tn.temp.vector;
    I.copy(h), I.sub(c), I.normalize(), Tn.temp.rotation.setFromUnitVectors(Tn.up, I), this.newPath(h, i, Tn.temp.rotation, n, s), o.last ? this.newPathOrderData(n, s, !0) : (o.placement = Tn.circleCurves[l], o.axisClass = ec.CIRCLE_CURVE);
  }
  setupLink(t, i) {
    t === 0 && (i.first = !0), t === Tn.temp.axis.orderLength() - 1 && (i.last = !0);
  }
  newCircleCurveStart(t, i, n, s) {
    const o = Tn.circleCurves[0], r = Tn.circleCurves[1], l = Tn.temp.vector;
    l.copy(r), l.sub(o), l.normalize(), Tn.temp.rotation.setFromUnitVectors(Tn.up, l), this.newPath(o, t, Tn.temp.rotation, i, n);
    const c = ec.CIRCLE_CURVE;
    this.linkStart(i, n, s, o, c);
  }
  getWireSetPoints(t, i) {
    const n = t.ps(i - 1);
    this._first.set(n.x(), n.y(), n.z());
    const s = t.ps(i);
    this._last.set(s.x(), s.y(), s.z());
  }
  finishWire(t, i, n, s) {
    this.newPath(this._last, t, Tn.temp.rotation, i, n), s.last ? this.newPathOrderData(i, n, !0) : (s.placement = this._last, s.axisClass = ec.WIRE), this.linkPaths(i, n);
  }
  linkPaths(t, i, n = !1) {
    const s = i, { p1: o, p2: r, p3: l } = this.getPathPositions(s, n, t), c = t.indexBuffer;
    for (let h = 0; h < s; h++) {
      const I = (h + 1) % s, { i3: p, i4: y, i1: m, i2: A } = this.getLinkPathIndices(l, h, o, s, I, r);
      c[this._currentIndex++] = p, c[this._currentIndex++] = y, c[this._currentIndex++] = m, c[this._currentIndex++] = m, c[this._currentIndex++] = y, c[this._currentIndex++] = A;
    }
  }
  startWire(t, i, n, s) {
    this.newPath(this._first, t, Tn.temp.rotation, i, n);
    const o = ec.WIRE;
    this.linkStart(i, n, s, this._first, o);
  }
  setupWireVectors() {
    const t = Tn.temp.vector;
    t.copy(this._last), t.sub(this._first), t.normalize(), Tn.temp.rotation.setFromUnitVectors(Tn.up, t);
  }
  getLinkPathIndices(t, i, n, s, o, r) {
    let l = 0, c = 0, h = 0, I = 0;
    return l = t + i >= n ? t + i - s : t + i, c = t + o >= n ? t + o - s : t + o, h = r + i >= n + s ? r + i - s : r + i, I = r + o >= n + s ? r + o - s : r + o, { i3: h, i4: I, i1: l, i2: c };
  }
  fetchWirePoints(t) {
    const i = t.p1(), n = t.p2();
    this._first.set(i.x(), i.y(), i.z()), this._last.set(n.x(), n.y(), n.z());
  }
  findLinkedVertex(t, i, n, s, o) {
    for (let r = t; r < i; r++) {
      this.point(r, n, this._v1);
      const l = r - s + o, c = l >= t ? l - s : l;
      this.point(c, n, this._v2);
      const h = l + 1 >= t ? l + 1 - s : l + 1;
      this.point(h, n, this._v3), this._tempLine.set(this._v2, this._v3), this._tempLine.closestPointToPoint(this._v1, !0, this._v4), this._total += this._v4.distanceTo(this._v1);
    }
  }
  newPath(t, i, n, s, o) {
    Tn.setPathVertices(o);
    for (let r = 0; r < o; r++) this.setPathPosition(r, i, n, t, s), this.setPathNormal(r, n, s), this._currentPoint += 3;
  }
  linkStart(t, i, n, s, o) {
    if (n.first) return void this.newPathOrderData(t, i);
    const r = ec.CIRCLE_CURVE, l = n.axisClass === r || o === r, c = n.placement.distanceToSquared(s) < this._minLinkDistance;
    if (!l || !c) return this.newPathOrderData(t, i, !0, !0), void this.newPathOrderData(t, i);
    this.linkPaths(t, i, !0);
  }
  setPathPosition(t, i, n, s, o) {
    const r = Tn.temp.vector;
    r.copy(Tn.circleCurvePoints[t]), r.multiplyScalar(i), r.applyQuaternion(n), r.add(s);
    const l = o.positionBuffer, c = this._currentPoint, h = this._currentPoint + 1, I = this._currentPoint + 2;
    l[c] = r.x, l[h] = r.y, l[I] = r.z;
  }
  newWire(t, i, n, s, o) {
    this.fetchWirePoints(t), this.setupWireVectors(), this.startWire(i, n, s, o), this.finishWire(i, n, s, o);
  }
  newCircleCurve(t, i, n, s, o) {
    const r = ho.circleCurve3Divisions(t);
    Tn.circleCurves = Tn.newPaths(t, r), this.newCircleCurveStart(i, n, s, o), this.newCircleCurveBody(r, i, n, s), this.newCircleCurveFinish(r, i, n, s, o), this.linkPaths(n, s, !0);
  }
  newPathOrderData(t, i, n = !1, s = !1) {
    const o = i - 2, r = t.indexBuffer;
    for (let l = 0; l < o; l++) {
      const c = this._currentPoint / 3, h = i * (s ? 2 : 1), I = c - h;
      r[this._currentIndex] = I, this._currentIndex++;
      const p = c + l + (n ? 2 : 1) - h;
      r[this._currentIndex] = p, this._currentIndex++;
      const y = c + l + (n ? 1 : 2) - h;
      r[this._currentIndex] = y, this._currentIndex++;
    }
  }
  getPathPositions(t, i, n) {
    const s = this._currentPoint / 3 - t, o = s;
    let r = s - t;
    return i && (r = this.fetchLinkedVertex(s, n, t)), { p3: r, p1: s, p2: o };
  }
  newAxisPart(t, i, n, s, o, r) {
    const l = t.parts(i), c = t.order(i);
    this.manageAxisPartCreation(l, t, c, s, n, o, r), r.first = !1, r.last = !1;
  }
  fetchLinkedVertex(t, i, n) {
    this._closest = Number.MAX_VALUE;
    for (let s = 0; s < n; s++) {
      this._total = 0;
      const o = t + n;
      this.findLinkedVertex(t, o, i, n, s), this._total < this._closest && (this._closest = this._total, this._result = t - n + s + 1);
    }
    return this._result;
  }
  setPathNormal(t, i, n) {
    const s = Tn.temp.vector, o = Tn.circleCurvePoints[t];
    s.copy(o), s.applyQuaternion(i);
    const r = n.normalBuffer, l = this._currentPoint, c = this._currentPoint + 1, h = this._currentPoint + 2;
    r[l] = s.x * VJ, r[c] = s.y * VJ, r[h] = s.z * VJ;
  }
  point(t, i, n) {
    const s = i.positionBuffer, o = 3 * t + 1, r = 3 * t + 2, l = s[3 * t], c = s[o], h = s[r];
    return n.set(l, c, h), n;
  }
}
class Lqe {
  constructor(t) {
    De(this, "_meshes"), De(this, "_results", []), De(this, "_circleExtrusion", new pl()), De(this, "_axis", new Ds()), this._meshes = t;
  }
  raycast(t, i) {
    this._results.length = 0, this._meshes.circleExtrusions(t, this._circleExtrusion);
    for (let n = 0, s = this._circleExtrusion.axesLength(); n < s; n++) {
      this._circleExtrusion.axes(n, this._axis);
      const o = this._circleExtrusion.radius(n);
      this.traverseAllCurves(i, o);
    }
    return this._results;
  }
  getTraverseWiresEvent(t, i) {
    return (n, s) => {
      this.castCurveExtrusion(n, s, t, i);
    };
  }
  castCurveExtrusion(t, i, n, s) {
    const o = ho.raycastCircleExtr(t, i, n, s);
    for (const r of o) this._results.push(r);
  }
  getTraverseCircleCurveEvent(t, i) {
    return (n, s, o) => {
      const r = s[0];
      this.castCurveExtrusion(n, r, t, i);
      for (let c = 0; c < s.length; c++) {
        if (c === 0) continue;
        const h = s[c - 1], I = s[c];
        this.castCurveExtrusion(h, I, t, i);
      }
      const l = s[s.length - 1];
      this.castCurveExtrusion(l, o, t, i);
    };
  }
  traverseAllCurves(t, i) {
    const n = this.getTraverseWiresEvent(t, i);
    ho.traverseWires(this._axis, n);
    const s = this.getTraverseCircleCurveEvent(t, i), o = ho.circleCurve3Divisions;
    ho.traverseCircleCurve(this._axis, s, o);
    const r = this.getTraverseWiresEvent(t, i);
    ho.traverseWireSets(this._axis, r);
  }
}
class _qe {
  constructor(t) {
    De(this, "_meshes"), De(this, "_found", []), De(this, "_circleExtrusion", new pl()), De(this, "_axis", new Ds()), De(this, "_wirePoint", new Ge()), this._meshes = t;
  }
  lineRaycast(t, i) {
    this._found.length = 0, this._meshes.circleExtrusions(t, this._circleExtrusion);
    const n = this._circleExtrusion.axesLength();
    for (let s = 0; s < n; s++) this._circleExtrusion.axes(s, this._axis), this.processLineRaycast(s, i);
    return this._found;
  }
  wireSetRaycast(t, i) {
    const n = this._axis;
    ho.traverseWireSets(n, ((s, o) => {
      this.cylinderRaycast(s, o, t, i);
    }));
  }
  exclusiveCylinderRaycast(t, i) {
    const n = this._axis, s = this.getCylinderRaycastEvent(t, i);
    ho.traverseWires(n, s);
  }
  processLineRaycast(t, i) {
    const n = this._circleExtrusion.radius(t);
    this.exclusiveCylinderRaycast(i, n), this.circleCurveRaycast(i, n), this.wireSetRaycast(i, n);
  }
  getCylinderRaycastEvent(t, i) {
    return (n, s) => {
      this.cylinderRaycast(n, s, t, i);
    };
  }
  processCircleCurveBody(t, i, n) {
    for (let s = 0; s < t.length; s++) {
      if (s === 0) continue;
      const o = t[s], r = t[s - 1];
      this.cylinderRaycast(r, o, i, n);
    }
  }
  getCircleCurveRaycastEvent(t, i) {
    return (n, s, o) => {
      this.cylinderRaycast(n, s[0], t, i), this.processCircleCurveBody(s, t, i);
      const r = s[s.length - 1];
      this.cylinderRaycast(r, o, t, i);
    };
  }
  fetchCylinderRaycastResult(t, i, n) {
    t.distanceSqToSegment(i, n, void 0, this._wirePoint);
    const s = this.newResult(i, n);
    this._found.push(s);
  }
  circleCurveRaycast(t, i) {
    const n = ho.circleCurve3Divisions, s = this.getCircleCurveRaycastEvent(t, i);
    ho.traverseCircleCurve(this._axis, s, n);
  }
  newResult(t, i) {
    return { point: this._wirePoint.clone(), raySquaredDistance: void 0, snappedEdgeP1: t.clone(), snappedEdgeP2: i.clone() };
  }
  cylinderRaycast(t, i, n, s) {
    const o = ho.raycastCircleExtr(t, i, n, s);
    for (const r of o) r.point && this.fetchCylinderRaycastResult(n, t, i);
  }
}
class xqe {
  constructor(t) {
    De(this, "_meshes"), De(this, "_results", []), De(this, "_circleExtrusion", new pl()), De(this, "_axis", new Ds()), De(this, "_normal", new Ge()), De(this, "_point", new Ge()), De(this, "_plane", new tl()), this._meshes = t;
  }
  pointRaycast(t, i) {
    return this._results.length = 0, this._meshes.circleExtrusions(t, this._circleExtrusion), this.traverseAllCircleExtrusions(i), this.getCleanResults();
  }
  fetchOrientation(t, i) {
    Tn.temp.vector.copy(t), Tn.temp.vector.sub(i), Tn.temp.vector.normalize(), Tn.temp.rotation.setFromUnitVectors(Tn.up, Tn.temp.vector);
  }
  getTraverseWiresEvent(t, i) {
    return (n, s) => {
      this.fetchOrientation(n, s);
      const o = this.raycastCutCircleExtrusion(n, t, i), r = this.raycastCutCircleExtrusion(s, t, i);
      this._results.push(o, r);
    };
  }
  traverseAllCircleExtrusions(t) {
    const i = this._circleExtrusion.axesLength();
    for (let n = 0; n < i; n++) {
      this._circleExtrusion.axes(n, this._axis);
      const s = this._circleExtrusion.radius(n), o = Tn.vertexLength(s);
      Tn.setPathVertices(o), this.traverseAllCurves(t, s);
    }
  }
  setupCuttedCircleExtrusion(t) {
    this._normal.set(0, 0, 1), this._normal.applyQuaternion(Tn.temp.rotation), this._plane.setFromNormalAndCoplanarPoint(this._normal, t);
  }
  getTraverseCircleCurveEvent(t, i) {
    return (n, s, o) => {
      this.fetchOrientation(n, s[0]);
      const r = this.raycastCutCircleExtrusion(n, t, i), l = s[s.length - 1];
      this.fetchOrientation(l, o);
      const c = this.raycastCutCircleExtrusion(o, t, i);
      this._results.push(r, c);
    };
  }
  computeCutCircleExtrCast(t, i, n) {
    if (n.intersectPlane(this._plane, this._point), this._point.distanceTo(t) <= i)
      return { point: t.clone() };
  }
  raycastCutCircleExtrusion(t, i, n) {
    if (this.setupCuttedCircleExtrusion(t), i.intersectsPlane(this._plane)) return this.computeCutCircleExtrCast(t, n, i);
  }
  getCleanResults() {
    const t = [];
    for (const i of this._results) i && t.push(i);
    return t;
  }
  traverseAllCurves(t, i) {
    const n = this.getTraverseWiresEvent(t, i);
    ho.traverseWires(this._axis, n);
    const s = this.getTraverseCircleCurveEvent(t, i), o = ho.circleCurve3Divisions;
    ho.traverseCircleCurve(this._axis, s, o);
    const r = this.getTraverseWiresEvent(t, i);
    ho.traverseWireSets(this._axis, r);
  }
}
class Pqe {
  constructor() {
    De(this, "_currentElement", 0), De(this, "_wireSize", 6), De(this, "newCircleCurveLod", ((t, i, n) => {
      const s = this.newCircleCurveLodPath(t, i), o = n.positionBuffer;
      for (let r = 1; r < s; r++) {
        const l = Tn.circleCurves[r - 1], c = Tn.circleCurves[r];
        this.newWire(o, l, c);
      }
    })), De(this, "newWireSetLod", ((t, i, n) => {
      const s = t.wireSets(i), o = s.psLength(), r = n.positionBuffer;
      for (let l = 1; l < o; l++) {
        const c = s.ps(l - 1), h = s.ps(l);
        this.newWire(r, c, h);
      }
    })), De(this, "newWireTemplate", ((t, i) => {
      i.positionCount += this._wireSize;
    })), De(this, "newWireSetTemplate", ((t, i) => {
      const n = Tn.temp.axis.wireSets(t, Tn.temp.wireSet).psLength() - 1;
      i.positionCount += this._wireSize * n;
    })), De(this, "newWireLod", ((t, i, n) => {
      const s = t.wires(i), o = s.p1(), r = s.p2(), l = n.positionBuffer;
      this.newWire(l, o, r);
    })), De(this, "newCircleCurveTemplate", ((t, i) => {
      const n = Tn.temp.axis.circleCurves(t, Tn.temp.circleCurve), s = ho.circleCurve3Divisions(n);
      i.positionCount += this._wireSize * (s - 1);
    }));
  }
  construct(t, i) {
    this._currentElement = 0, i.positionBuffer = new Float32Array(i.positionCount);
    for (let n = 0, s = t.axesLength(); n < s; n++) t.axes(n, Tn.temp.axis), this.constructLod(i);
    return i;
  }
  constructCircleExtrusionLod(t, i) {
    const n = Tn.temp.axis, s = n.parts(t), o = n.order(t);
    this.getLodConstructor(s)(n, o, i);
  }
  newCircleCurveLodPath(t, i) {
    const n = t.circleCurves(i), s = ho.circleCurve3Divisions(n);
    return Tn.circleCurves = Tn.newPaths(n, s), s;
  }
  selectNextWire() {
    this._currentElement += this._wireSize;
  }
  getAxisPartVertexSize(t, i) {
    const n = Tn.temp.axis, s = n.parts(t), o = n.order(t);
    this.getTemplateConstructor(s)(o, i);
  }
  getIndices() {
    return { i1: this._currentElement, i2: this._currentElement + 1, i3: this._currentElement + 2, i4: this._currentElement + 3, i5: this._currentElement + 4, i6: this._currentElement + 5 };
  }
  setAxisTemplate(t, i) {
    Tn.temp.circleExtrusion.axes(t, Tn.temp.axis);
    const n = Tn.temp.axis.partsLength();
    for (let s = 0; s < n; s++) this.getAxisPartVertexSize(s, i);
    this.setAxisThickness(i, t);
  }
  constructLod(t) {
    const i = Tn.temp.axis.orderLength();
    for (let n = 0; n < i; n++) this.constructCircleExtrusionLod(n, t);
  }
  getLodConstructor(t) {
    return { [ec.WIRE]: this.newWireLod, [ec.WIRE_SET]: this.newWireSetLod, [ec.CIRCLE_CURVE]: this.newCircleCurveLod }[t];
  }
  newTemplate() {
    const t = Tn.temp.circleExtrusion, i = this.newTemplateData(), n = t.axesLength();
    for (let s = 0; s < n; s++) this.setAxisTemplate(s, i);
    return i;
  }
  setAxisThickness(t, i) {
    const n = t.lodThickness, s = Tn.temp.circleExtrusion.radius(i);
    t.lodThickness = Math.max(n, s);
  }
  newTemplateData() {
    return { objectClass: tE.LINE, lod: Bo.WIRES, lodThickness: 0, positionCount: 0 };
  }
  getTemplateConstructor(t) {
    return { [ec.WIRE]: this.newWireTemplate, [ec.WIRE_SET]: this.newWireSetTemplate, [ec.CIRCLE_CURVE]: this.newCircleCurveTemplate }[t];
  }
  newWire(t, i, n) {
    const s = i instanceof Ge ? i.x : i.x(), o = i instanceof Ge ? i.y : i.y(), r = i instanceof Ge ? i.z : i.z(), l = n instanceof Ge ? n.x : n.x(), c = n instanceof Ge ? n.y : n.y(), h = n instanceof Ge ? n.z : n.z(), { i1: I, i2: p, i3: y, i4: m, i5: A, i6: C } = this.getIndices();
    t[I] = s, t[p] = o, t[y] = r, t[m] = l, t[A] = c, t[C] = h, this.selectNextWire();
  }
}
class Mqe extends tbe {
  constructor() {
    super(...arguments), De(this, "_vceConstructor", new Oqe()), De(this, "_lodConstructor", new Pqe()), De(this, "_vceRaycaster", new Lqe(this.meshes)), De(this, "_vceLineRaycaster", new _qe(this.meshes)), De(this, "_vcePointRaycaster", new xqe(this.meshes)), De(this, "_representationClass", Mr.CIRCLE_EXTRUSION), De(this, "_objectClass", tE.LINE), De(this, "lodClass", cB.CUSTOM);
  }
  setupTemplates() {
    const t = this.meshes.circleExtrusionsLength();
    for (let i = 0; i < t; i++) this.newCircleExtrusionTemplate(i);
  }
  fetchLod(t, i) {
    const n = this.getMesh(t, Bo.WIRES);
    return this.generateLodIfNeeded(t, i, n), n;
  }
  fetchMeshes(t, i) {
    const n = this.getMesh(t, Bo.GEOMETRY);
    return this.generateMeshesIfNeeded(t, i, n), n;
  }
  raycast(t, i) {
    return this._vceRaycaster.raycast(t, i);
  }
  faceRaycast() {
    return [];
  }
  pointRaycast(t, i) {
    return this._vcePointRaycaster.pointRaycast(t, i);
  }
  lineRaycast(t, i) {
    return this._vceLineRaycaster.lineRaycast(t, i);
  }
  getObjectClass() {
    return this._objectClass;
  }
  getRepresentation() {
    return this._representationClass;
  }
  getLodClass() {
    return this.lodClass;
  }
  newMeshes(t, i) {
    this.meshes.circleExtrusions(t, Tn.temp.circleExtrusion);
    const n = Tn.temp.circleExtrusion;
    this._vceConstructor.construct(n, i), this.saveMesh(t, i, Bo.GEOMETRY);
  }
  generateMeshesIfNeeded(t, i, n) {
    if (n.length === 0) return;
    const s = !!n.length, o = !n[0].positionBuffer;
    i && o && s && this.newMeshes(t, n);
  }
  newCircleExtrusionTemplate(t) {
    const i = [];
    this.meshes.circleExtrusions(t, Tn.temp.circleExtrusion);
    const n = Tn.temp.circleExtrusion, s = n.axesLength();
    for (let r = 0; r < s; r++) this._vceConstructor.newTemplate(n, r, i);
    const o = this._lodConstructor.newTemplate();
    this.useMesh(t, i, Bo.GEOMETRY), this.useMesh(t, o, Bo.WIRES);
  }
  generateLodIfNeeded(t, i, n) {
    !n.positionBuffer && i && (this.meshes.circleExtrusions(t, Tn.temp.circleExtrusion), this._lodConstructor.construct(Tn.temp.circleExtrusion, n), this.saveMesh(t, n, Bo.WIRES));
  }
}
class Uqe {
  constructor(t) {
    De(this, "size"), De(this, "_data"), De(this, "_highlightData"), this.size = t, this._data = new Uint8Array(t), this._highlightData = new Uint16Array(t), this._data.fill(1);
  }
  getHighlight(t) {
    return this._highlightData[t];
  }
  setHighlight(t, i) {
    Ece.checkMemory(i), this._highlightData[t] = i;
  }
  clearHighlight() {
    this._highlightData.fill(0);
  }
  visible(t) {
    return Ece.check(this._data, t, AIe.VISIBLE);
  }
  setVisible(t, i) {
    Ece.apply(this._data, t, AIe.VISIBLE, i);
  }
  clearVisible() {
    this._data.fill(1);
  }
}
class Bqe {
  constructor(t, i) {
    De(this, "_rate", 64), De(this, "_updater"), De(this, "_modelId"), De(this, "_threshold", 16), De(this, "_connection"), De(this, "_list", []), De(this, "refresh", (() => {
      if (this._list.length) {
        const n = this._list;
        this._connection.fetchMeshCompute(this._modelId, n), this._list = [];
      }
    })), this._modelId = t, this._connection = i, this._updater = f1.newUpdater(this.refresh, this._rate);
  }
  get needsRefresh() {
    return this._list.length > this._threshold;
  }
  dispose() {
    f1.deleteUpdater(this._updater);
  }
  clean() {
    this._list = f1.cleanRequests(this._list);
  }
  process(t) {
    this._list.push(t), this.needsRefresh && this.refresh();
  }
}
class Fqe {
  constructor(t, i, n, s) {
    De(this, "_meshes"), De(this, "_model"), De(this, "_boxes"), De(this, "_tiles"), De(this, "_items"), De(this, "_edgeThreshold", 8), De(this, "_raycastMultiplier", 32), De(this, "_maxDuration", 512), De(this, "_precission", 1e-3), De(this, "_temp", { sample: new lY(), representation: new iN(), tempPlane: new tl(), ray: new MA(), frustum: new cL(), m1: new Ln(), m2: new Ln(), m3: new Ln(), v1: new Ge(), planes: [] }), this._model = t, this._boxes = i, this._tiles = n, this._items = s, this._meshes = t.meshes();
  }
  static cast(t, i, n, s, o) {
    const r = i.id();
    return o === k_.FACE ? t.faceRaycast(r, n, s) : o === k_.LINE ? t.lineRaycast(r, n, s) : o === k_.POINT ? t.pointRaycast(r, n, s) : o === void 0 ? t.raycast(r, n, s) : void 0;
  }
  raycast(t, i, n, s) {
    const o = { ray: t, frustum: i, planes: n, returnAll: s }, r = this.castBox(i, n);
    return r.length ? this.computeRaycastList(r, o) : null;
  }
  snapRaycast(t, i, n, s) {
    const o = [], r = { ray: t, frustum: i, planes: s }, l = this.raycast(t, i, s);
    return l ? (this.getSnaps(l, r, n, o), l.normal ? this.filterOnFront(o) : o) : this.snapCastEdges(r, n);
  }
  rectangleRaycast(t, i, n) {
    const s = this._boxes.lookup;
    if (!s) return [];
    const o = s.collideFrustum(i, t, n), r = this.filterVisible(o);
    return this.localIdsFromItemIds(r);
  }
  snapCastEdges(t, i) {
    const n = [], s = i.includes(k_.POINT), o = i.includes(k_.LINE);
    return (s || o) && this.computeEdgesCast(t, i, n), this.addDistanceToEdgeResult(n, t.ray), n;
  }
  filterVisible(t) {
    const i = [];
    for (const n of t) {
      this._meshes.samples(n, this._temp.sample);
      const s = this._temp.sample.item();
      this._items.visible(s) && i.push(n);
    }
    return i;
  }
  computeSnaps(t, i, n, s) {
    for (const o of t)
      if (this.isValidSnap(o)) {
        const r = { snap: o, ...i }, l = this.castSample(n, r);
        for (const c of l) s.push(c);
      }
  }
  computeEdgesCast(t, i, n) {
    const s = this.getRawEdges(t), o = performance.now();
    for (const r of s)
      if (this.fetchSampleData(r), this.computeSnaps(i, t, r, n), this.isTimeExceeded(o)) break;
  }
  addDistanceToEdgeResult(t, i) {
    for (const n of t) {
      const s = n.point;
      n.raySquaredDistance = i.distanceSqToPoint(s);
    }
  }
  getRawEdges(t) {
    const i = this.castBox(t.frustum, t.planes);
    return i.length <= this._edgeThreshold ? i : this.sortBoxes(t.ray, i, this._edgeThreshold);
  }
  sortBoxes(t, i, n) {
    const s = [], o = new Ge(), r = t.origin;
    for (let c = 0; c < i.length; c++) {
      const h = i[c], I = this._boxes.get(h);
      t.intersectBox(I, o);
      const p = o.distanceToSquared(r);
      s.push(p);
    }
    const l = this.dataSort(i, s);
    return n && l.length > n && l.splice(n), l;
  }
  castBox(t, i) {
    const n = this._boxes.lookup;
    if (!n) return [];
    if (t instanceof MA) {
      const o = n.collideRay(i, t);
      return this.filterVisible(o);
    }
    const s = n.collideFrustum(i, t);
    return this.filterVisible(s);
  }
  dataSort(t, i) {
    const n = Array.from(t.keys()).sort(((o, r) => i[o] - i[r])), s = [];
    for (const o of n) {
      const r = t[o];
      s.push(r);
    }
    return s;
  }
  localIdsFromItemIds(t) {
    const i = /* @__PURE__ */ new Set();
    for (const n of t) {
      this._meshes.samples(n, this._temp.sample);
      const s = this._temp.sample.item(), o = this._meshes.meshesItems(s);
      if (o === null) continue;
      const r = this._model.localIds(o);
      r !== null && i.add(r);
    }
    return Array.from(i);
  }
  getNearest(t) {
    let i = t[0];
    for (let n = 1; n < t.length; n++) {
      const s = t[n];
      if (i.raySquaredDistance && s.raySquaredDistance) {
        const o = this.getNearScore(i);
        this.getNearScore(s) < o && (i = s);
      } else s.cameraSquaredDistance < i.cameraSquaredDistance && (i = s);
    }
    return i;
  }
  getEdges(t, i, n) {
    const s = this.snapCastEdges(t, i);
    if (s) for (const o of s) n.push(o);
  }
  getNearScore(t) {
    const i = this._raycastMultiplier;
    return t.raySquaredDistance * i + t.cameraSquaredDistance;
  }
  setupSampleCastData(t) {
    pz.get(this._temp.sample, this._meshes, this._temp.m1), this._temp.m2.copy(this._temp.m1).invert(), this._temp.ray.copy(t.ray).applyMatrix4(this._temp.m2), VF.transform(t.frustum, this._temp.m2, this._temp.frustum);
  }
  addLocalId(t) {
    if (!t) return;
    const i = this._meshes.meshesItems(t.itemId);
    i !== null && (t.localId = this._model.localIds(i));
  }
  fetchSampleData(t) {
    this._meshes.samples(t, this._temp.sample);
    const i = this._temp.sample.representation();
    this._meshes.representations(i, this._temp.representation);
  }
  computeRaycastList(t, i) {
    const n = Array.from(new Set(t)), s = this.sortBoxes(i.ray, n), o = this.castBox(i.ray, i.planes), r = this.findAll(s, o, i);
    if (r.length) {
      if (i.returnAll) {
        for (const c of r) this.addLocalId(c);
        return r;
      }
      const l = this.getNearest(r);
      return this.addLocalId(l), l;
    }
    return null;
  }
  formatRaycastResult(t, i, n) {
    for (const s of t) {
      if (s.point.applyMatrix4(this._temp.m1), s.normal && s.normal.transformDirection(this._temp.m1), "facePoints" in s) {
        const r = this._meshes.samples(i, this._temp.sample);
        pz.get(r, this._meshes, this._temp.m3);
        for (let l = 0; l < s.facePoints.length; l += 3) {
          const c = s.facePoints[l], h = s.facePoints[l + 1], I = s.facePoints[l + 2];
          this._temp.v1.set(c, h, I), this._temp.v1.applyMatrix4(this._temp.m3), s.facePoints[l] = this._temp.v1.x, s.facePoints[l + 1] = this._temp.v1.y, s.facePoints[l + 2] = this._temp.v1.z;
        }
      }
      s.sampleId = i, s.itemId = this._temp.sample.item();
      const o = n.ray.origin.distanceToSquared(s.point);
      s.cameraSquaredDistance = o, s.snappingClass || (s.snappingClass = n.snap), s.snappedEdgeP1 && s.snappedEdgeP1.applyMatrix4(this._temp.m1), s.snappedEdgeP2 && s.snappedEdgeP2.applyMatrix4(this._temp.m1);
    }
  }
  findAll(t, i, n) {
    const s = [], o = performance.now();
    for (const r of t) {
      if (this.fetchSampleData(r), !i.includes(r)) continue;
      const l = this.castSample(r, n);
      for (const c of l) s.push(c);
      if (this.isTimeExceeded(o)) break;
    }
    return s;
  }
  isTimeExceeded(t) {
    return performance.now() - t > this._maxDuration;
  }
  getFilteredSampleCast(t) {
    const i = this._tiles.raycast(this._temp.representation, this._temp.ray, this._temp.frustum, t.snap);
    if (this._temp.planes.length === 0) return i;
    const n = [];
    if (i) for (const s of i) {
      const o = this._temp.planes, r = s.point;
      MX.containedInParallelPlanes(o, r) && n.push(s);
    }
    return n;
  }
  getSnaps(t, i, n, s) {
    this.fetchSampleData(t.sampleId), t.normal && (this.setCastSide(t, i.ray), this.setCastPlane(t)), this.getFaces(n, i, t, s), this.getEdges(i, n, s);
    for (const o of s) this.addLocalId(o);
  }
  filterOnFront(t) {
    const i = [];
    for (const n of t)
      this._temp.tempPlane.distanceToPoint(n.point) >= 0 && i.push(n);
    return i;
  }
  setCastSide(t, i) {
    const n = t.point.clone().sub(i.origin);
    t.normal.dot(n) > 0 && t.normal.negate();
  }
  getFaces(t, i, n, s) {
    for (const o of t) {
      const r = { snap: o, ...i }, l = this.castSample(n.sampleId, r);
      for (const c of l) s.push(c);
    }
  }
  setCastPlane(t) {
    const i = this._temp.tempPlane, n = t.point.clone(), s = t.normal.clone();
    s.multiplyScalar(this._precission), n.sub(s), i.setFromNormalAndCoplanarPoint(t.normal, n);
  }
  castSample(t, i) {
    this.setupSampleCastData(i), this.setupPlanesForSampleCast(i);
    const n = this.getFilteredSampleCast(i);
    return n && this.formatRaycastResult(n, t, i), n;
  }
  isValidSnap(t) {
    const i = t === k_.LINE, n = t === k_.POINT;
    return i || n;
  }
  transform(t, i) {
    const n = [];
    if (t) for (const s of t) {
      const o = new tl().copy(s);
      o.applyMatrix4(i), n.push(o);
    }
    return n;
  }
  setupPlanesForSampleCast(t) {
    if (this._temp.planes.length = 0, t.planes && t.planes.length > 0) {
      const i = this.transform(t.planes, this._temp.m2);
      for (const n of i) this._temp.planes.push(n);
    }
  }
}
const xz = typeof performance == "object" && performance && typeof performance.now == "function" ? performance : Date, Uwe = /* @__PURE__ */ new Set(), MIe = typeof process == "object" && process ? process : {}, rbe = (e, t, i, n) => {
  typeof MIe.emitWarning == "function" ? MIe.emitWarning(e, t, i, n) : console.error(`[${i}] ${t}: ${e}`);
};
let Ole = globalThis.AbortController, Bwe = globalThis.AbortSignal;
if (Ole === void 0) {
  Bwe = class {
    constructor() {
      De(this, "onabort"), De(this, "_onabort", []), De(this, "reason"), De(this, "aborted", !1);
    }
    addEventListener(i, n) {
      this._onabort.push(n);
    }
  }, Ole = class {
    constructor() {
      De(this, "signal", new Bwe()), t();
    }
    abort(i) {
      var n, s;
      if (!this.signal.aborted) {
        this.signal.reason = i, this.signal.aborted = !0;
        for (const o of this.signal._onabort) o(i);
        (s = (n = this.signal).onabort) == null || s.call(n, i);
      }
    }
  };
  let e = ((Zge = MIe.env) == null ? void 0 : Zge.LRU_CACHE_IGNORE_AC_WARNING) !== "1";
  const t = () => {
    e && (e = !1, rbe("AbortController is not defined. If using lru-cache in node 14, load an AbortController polyfill from the `node-abort-controller` package. A minimal polyfill is provided for use by LRUCache.fetch(), but it should not be relied upon in other contexts (eg, passing it to other APIs that use AbortController/AbortSignal might have undesirable effects). You may disable this with LRU_CACHE_IGNORE_AC_WARNING=1 in the env.", "NO_ABORT_CONTROLLER", "ENOTSUP", t));
  };
}
const cx = (e) => e && e === Math.floor(e) && e > 0 && isFinite(e), lbe = (e) => cx(e) ? e <= Math.pow(2, 8) ? Uint8Array : e <= Math.pow(2, 16) ? Uint16Array : e <= Math.pow(2, 32) ? Uint32Array : e <= Number.MAX_SAFE_INTEGER ? Sre : null : null;
class Sre extends Array {
  constructor(t) {
    super(t), this.fill(0);
  }
}
const abe = class fJ {
  constructor(t, i) {
    if (De(this, "heap"), De(this, "length"), !Bt(fJ, DJ)) throw new TypeError("instantiate Stack using Stack.create(n)");
    this.heap = new i(t), this.length = 0;
  }
  static create(t) {
    const i = lbe(t);
    if (!i) return [];
    Ts(fJ, DJ, !0);
    const n = new fJ(t, i);
    return Ts(fJ, DJ, !1), n;
  }
  push(t) {
    this.heap[this.length++] = t;
  }
  pop() {
    return this.heap[--this.length];
  }
};
DJ = /* @__PURE__ */ new WeakMap(), qs(abe, DJ, !1);
let Hqe = abe;
const Gqe = class ube {
  constructor(t) {
    qs(this, mre), qs(this, IIe), qs(this, uC), qs(this, AC), qs(this, yre), qs(this, LJ), qs(this, nJ), qs(this, ta), qs(this, gre), qs(this, QV), qs(this, EO), qs(this, Ale), qs(this, Qb, void 0), qs(this, YT, void 0), qs(this, Jb, void 0), qs(this, ZV, void 0), qs(this, Ab, void 0), qs(this, CJ, void 0), qs(this, tJ, void 0), De(this, "ttl"), De(this, "ttlResolution"), De(this, "ttlAutopurge"), De(this, "updateAgeOnGet"), De(this, "updateAgeOnHas"), De(this, "allowStale"), De(this, "noDisposeOnSet"), De(this, "noUpdateTTL"), De(this, "maxEntrySize"), De(this, "sizeCalculation"), De(this, "noDeleteOnFetchRejection"), De(this, "noDeleteOnStaleGet"), De(this, "allowStaleOnFetchAbort"), De(this, "allowStaleOnFetchRejection"), De(this, "ignoreFetchAbort"), qs(this, I1, void 0), qs(this, qT, void 0), qs(this, jh, void 0), qs(this, Bu, void 0), qs(this, oo, void 0), qs(this, pg, void 0), qs(this, s5, void 0), qs(this, Uy, void 0), qs(this, Sp, void 0), qs(this, rN, void 0), qs(this, bp, void 0), qs(this, Xb, void 0), qs(this, eN, void 0), qs(this, o5, void 0), qs(this, tN, void 0), qs(this, aB, void 0), qs(this, yg, void 0), qs(this, iJ, void 0), qs(this, cz, (() => {
    })), qs(this, tx, (() => {
    })), qs(this, Tle, (() => {
    })), qs(this, r5, (() => !1)), qs(this, hz, ((te) => {
    })), qs(this, OJ, ((te, ee, Ne) => {
    })), qs(this, Rle, ((te, ee, Ne, Ae) => {
      if (Ne || Ae) throw new TypeError("cannot set size without setting maxSize or maxEntrySize on cache");
      return 0;
    })), De(this, ESe, "LRUCache");
    const { max: i = 0, ttl: n, ttlResolution: s = 1, ttlAutopurge: o, updateAgeOnGet: r, updateAgeOnHas: l, allowStale: c, dispose: h, onInsert: I, disposeAfter: p, noDisposeOnSet: y, noUpdateTTL: m, maxSize: A = 0, maxEntrySize: C = 0, sizeCalculation: O, fetchMethod: R, memoMethod: F, noDeleteOnFetchRejection: L, noDeleteOnStaleGet: P, allowStaleOnFetchRejection: z, allowStaleOnFetchAbort: W, ignoreFetchAbort: re } = t;
    if (i !== 0 && !cx(i)) throw new TypeError("max option must be a nonnegative integer");
    const ce = i ? lbe(i) : Array;
    if (!ce) throw new Error("invalid max value: " + i);
    if (Ts(this, Qb, i), Ts(this, YT, A), this.maxEntrySize = C || Bt(this, YT), this.sizeCalculation = O, this.sizeCalculation) {
      if (!Bt(this, YT) && !this.maxEntrySize) throw new TypeError("cannot set sizeCalculation without setting maxSize or maxEntrySize");
      if (typeof this.sizeCalculation != "function") throw new TypeError("sizeCalculation set to non-function");
    }
    if (F !== void 0 && typeof F != "function") throw new TypeError("memoMethod must be a function if defined");
    if (Ts(this, tJ, F), R !== void 0 && typeof R != "function") throw new TypeError("fetchMethod must be a function if specified");
    if (Ts(this, CJ, R), Ts(this, aB, !!R), Ts(this, jh, /* @__PURE__ */ new Map()), Ts(this, Bu, new Array(i).fill(void 0)), Ts(this, oo, new Array(i).fill(void 0)), Ts(this, pg, new ce(i)), Ts(this, s5, new ce(i)), Ts(this, Uy, 0), Ts(this, Sp, 0), Ts(this, rN, Hqe.create(i)), Ts(this, I1, 0), Ts(this, qT, 0), typeof h == "function" && Ts(this, Jb, h), typeof I == "function" && Ts(this, ZV, I), typeof p == "function" ? (Ts(this, Ab, p), Ts(this, bp, [])) : (Ts(this, Ab, void 0), Ts(this, bp, void 0)), Ts(this, tN, !!Bt(this, Jb)), Ts(this, iJ, !!Bt(this, ZV)), Ts(this, yg, !!Bt(this, Ab)), this.noDisposeOnSet = !!y, this.noUpdateTTL = !!m, this.noDeleteOnFetchRejection = !!L, this.allowStaleOnFetchRejection = !!z, this.allowStaleOnFetchAbort = !!W, this.ignoreFetchAbort = !!re, this.maxEntrySize !== 0) {
      if (Bt(this, YT) !== 0 && !cx(Bt(this, YT))) throw new TypeError("maxSize must be a positive integer if specified");
      if (!cx(this.maxEntrySize)) throw new TypeError("maxEntrySize must be a positive integer if specified");
      Qn(this, IIe, ySe).call(this);
    }
    if (this.allowStale = !!c, this.noDeleteOnStaleGet = !!P, this.updateAgeOnGet = !!r, this.updateAgeOnHas = !!l, this.ttlResolution = cx(s) || s === 0 ? s : 1, this.ttlAutopurge = !!o, this.ttl = n || 0, this.ttl) {
      if (!cx(this.ttl)) throw new TypeError("ttl must be a positive integer if specified");
      Qn(this, mre, fIe).call(this);
    }
    if (Bt(this, Qb) === 0 && this.ttl === 0 && Bt(this, YT) === 0) throw new TypeError("At least one of max, maxSize, or ttl is required");
    if (!this.ttlAutopurge && !Bt(this, Qb) && !Bt(this, YT)) {
      const te = "LRU_CACHE_UNBOUNDED";
      ((ee) => !Uwe.has(ee))(te) && (Uwe.add(te), rbe("TTL caching without ttlAutopurge, max, or maxSize can result in unbounded memory consumption.", "UnboundedCacheWarning", te, ube));
    }
  }
  static unsafeExposeInternals(t) {
    return { starts: Bt(t, eN), ttls: Bt(t, o5), sizes: Bt(t, Xb), keyMap: Bt(t, jh), keyList: Bt(t, Bu), valList: Bt(t, oo), next: Bt(t, pg), prev: Bt(t, s5), get head() {
      return Bt(t, Uy);
    }, get tail() {
      return Bt(t, Sp);
    }, free: Bt(t, rN), isBackgroundFetch: (i) => {
      var n;
      return Qn(n = t, ta, wa).call(n, i);
    }, backgroundFetch: (i, n, s, o) => {
      var r;
      return Qn(r = t, nJ, Ere).call(r, i, n, s, o);
    }, moveToTail: (i) => {
      var n;
      return Qn(n = t, QV, sJ).call(n, i);
    }, indexes: (i) => {
      var n;
      return Qn(n = t, uC, G_).call(n, i);
    }, rindexes: (i) => {
      var n;
      return Qn(n = t, AC, ix).call(n, i);
    }, isStale: (i) => {
      var n;
      return Bt(n = t, r5).call(n, i);
    } };
  }
  get max() {
    return Bt(this, Qb);
  }
  get maxSize() {
    return Bt(this, YT);
  }
  get calculatedSize() {
    return Bt(this, qT);
  }
  get size() {
    return Bt(this, I1);
  }
  get fetchMethod() {
    return Bt(this, CJ);
  }
  get memoMethod() {
    return Bt(this, tJ);
  }
  get dispose() {
    return Bt(this, Jb);
  }
  get onInsert() {
    return Bt(this, ZV);
  }
  get disposeAfter() {
    return Bt(this, Ab);
  }
  getRemainingTTL(t) {
    return Bt(this, jh).has(t) ? 1 / 0 : 0;
  }
  *entries() {
    for (const t of Qn(this, uC, G_).call(this)) Bt(this, oo)[t] === void 0 || Bt(this, Bu)[t] === void 0 || Qn(this, ta, wa).call(this, Bt(this, oo)[t]) || (yield [Bt(this, Bu)[t], Bt(this, oo)[t]]);
  }
  *rentries() {
    for (const t of Qn(this, AC, ix).call(this)) Bt(this, oo)[t] === void 0 || Bt(this, Bu)[t] === void 0 || Qn(this, ta, wa).call(this, Bt(this, oo)[t]) || (yield [Bt(this, Bu)[t], Bt(this, oo)[t]]);
  }
  *keys() {
    for (const t of Qn(this, uC, G_).call(this)) {
      const i = Bt(this, Bu)[t];
      i === void 0 || Qn(this, ta, wa).call(this, Bt(this, oo)[t]) || (yield i);
    }
  }
  *rkeys() {
    for (const t of Qn(this, AC, ix).call(this)) {
      const i = Bt(this, Bu)[t];
      i === void 0 || Qn(this, ta, wa).call(this, Bt(this, oo)[t]) || (yield i);
    }
  }
  *values() {
    for (const t of Qn(this, uC, G_).call(this))
      Bt(this, oo)[t] === void 0 || Qn(this, ta, wa).call(this, Bt(this, oo)[t]) || (yield Bt(this, oo)[t]);
  }
  *rvalues() {
    for (const t of Qn(this, AC, ix).call(this))
      Bt(this, oo)[t] === void 0 || Qn(this, ta, wa).call(this, Bt(this, oo)[t]) || (yield Bt(this, oo)[t]);
  }
  [Symbol.iterator]() {
    return this.entries();
  }
  find(t, i = {}) {
    for (const n of Qn(this, uC, G_).call(this)) {
      const s = Bt(this, oo)[n], o = Qn(this, ta, wa).call(this, s) ? s.__staleWhileFetching : s;
      if (o !== void 0 && t(o, Bt(this, Bu)[n], this)) return this.get(Bt(this, Bu)[n], i);
    }
  }
  forEach(t, i = this) {
    for (const n of Qn(this, uC, G_).call(this)) {
      const s = Bt(this, oo)[n], o = Qn(this, ta, wa).call(this, s) ? s.__staleWhileFetching : s;
      o !== void 0 && t.call(i, o, Bt(this, Bu)[n], this);
    }
  }
  rforEach(t, i = this) {
    for (const n of Qn(this, AC, ix).call(this)) {
      const s = Bt(this, oo)[n], o = Qn(this, ta, wa).call(this, s) ? s.__staleWhileFetching : s;
      o !== void 0 && t.call(i, o, Bt(this, Bu)[n], this);
    }
  }
  purgeStale() {
    let t = !1;
    for (const i of Qn(this, AC, ix).call(this, { allowStale: !0 })) Bt(this, r5).call(this, i) && (Qn(this, EO, RP).call(this, Bt(this, Bu)[i], "expire"), t = !0);
    return t;
  }
  info(t) {
    const i = Bt(this, jh).get(t);
    if (i === void 0) return;
    const n = Bt(this, oo)[i], s = Qn(this, ta, wa).call(this, n) ? n.__staleWhileFetching : n;
    if (s === void 0) return;
    const o = { value: s };
    if (Bt(this, o5) && Bt(this, eN)) {
      const r = Bt(this, o5)[i], l = Bt(this, eN)[i];
      if (r && l) {
        const c = r - (xz.now() - l);
        o.ttl = c, o.start = Date.now();
      }
    }
    return Bt(this, Xb) && (o.size = Bt(this, Xb)[i]), o;
  }
  dump() {
    const t = [];
    for (const i of Qn(this, uC, G_).call(this, { allowStale: !0 })) {
      const n = Bt(this, Bu)[i], s = Bt(this, oo)[i], o = Qn(this, ta, wa).call(this, s) ? s.__staleWhileFetching : s;
      if (o === void 0 || n === void 0) continue;
      const r = { value: o };
      if (Bt(this, o5) && Bt(this, eN)) {
        r.ttl = Bt(this, o5)[i];
        const l = xz.now() - Bt(this, eN)[i];
        r.start = Math.floor(Date.now() - l);
      }
      Bt(this, Xb) && (r.size = Bt(this, Xb)[i]), t.unshift([n, r]);
    }
    return t;
  }
  load(t) {
    this.clear();
    for (const [i, n] of t) {
      if (n.start) {
        const s = Date.now() - n.start;
        n.start = xz.now() - s;
      }
      this.set(i, n.value, n);
    }
  }
  set(t, i, n = {}) {
    var s, o, r, l, c, h, I;
    if (i === void 0) return this.delete(t), this;
    const { ttl: p = this.ttl, start: y, noDisposeOnSet: m = this.noDisposeOnSet, sizeCalculation: A = this.sizeCalculation, status: C } = n;
    let { noUpdateTTL: O = this.noUpdateTTL } = n;
    const R = Bt(this, Rle).call(this, t, i, n.size || 0, A);
    if (this.maxEntrySize && R > this.maxEntrySize) return C && (C.set = "miss", C.maxEntrySizeExceeded = !0), Qn(this, EO, RP).call(this, t, "set"), this;
    let F = Bt(this, I1) === 0 ? void 0 : Bt(this, jh).get(t);
    if (F === void 0) F = Bt(this, I1) === 0 ? Bt(this, Sp) : Bt(this, rN).length !== 0 ? Bt(this, rN).pop() : Bt(this, I1) === Bt(this, Qb) ? Qn(this, LJ, vle).call(this, !1) : Bt(this, I1), Bt(this, Bu)[F] = t, Bt(this, oo)[F] = i, Bt(this, jh).set(t, F), Bt(this, pg)[Bt(this, Sp)] = F, Bt(this, s5)[F] = Bt(this, Sp), Ts(this, Sp, F), mIe(this, I1)._++, Bt(this, OJ).call(this, F, R, C), C && (C.set = "add"), O = !1, Bt(this, iJ) && ((s = Bt(this, ZV)) == null || s.call(this, i, t, "add"));
    else {
      Qn(this, QV, sJ).call(this, F);
      const L = Bt(this, oo)[F];
      if (i !== L) {
        if (Bt(this, aB) && Qn(this, ta, wa).call(this, L)) {
          L.__abortController.abort(new Error("replaced"));
          const { __staleWhileFetching: P } = L;
          P === void 0 || m || (Bt(this, tN) && ((o = Bt(this, Jb)) == null || o.call(this, P, t, "set")), Bt(this, yg) && ((r = Bt(this, bp)) == null || r.push([P, t, "set"])));
        } else m || (Bt(this, tN) && ((l = Bt(this, Jb)) == null || l.call(this, L, t, "set")), Bt(this, yg) && ((c = Bt(this, bp)) == null || c.push([L, t, "set"])));
        if (Bt(this, hz).call(this, F), Bt(this, OJ).call(this, F, R, C), Bt(this, oo)[F] = i, C) {
          C.set = "replace";
          const P = L && Qn(this, ta, wa).call(this, L) ? L.__staleWhileFetching : L;
          P !== void 0 && (C.oldValue = P);
        }
      } else C && (C.set = "update");
      Bt(this, iJ) && ((h = this.onInsert) == null || h.call(this, i, t, i === L ? "update" : "replace"));
    }
    if (p === 0 || Bt(this, o5) || Qn(this, mre, fIe).call(this), Bt(this, o5) && (O || Bt(this, Tle).call(this, F, p, y), C && Bt(this, tx).call(this, C, F)), !m && Bt(this, yg) && Bt(this, bp)) {
      const L = Bt(this, bp);
      let P;
      for (; P = L == null ? void 0 : L.shift(); ) (I = Bt(this, Ab)) == null || I.call(this, ...P);
    }
    return this;
  }
  pop() {
    var t;
    try {
      for (; Bt(this, I1); ) {
        const i = Bt(this, oo)[Bt(this, Uy)];
        if (Qn(this, LJ, vle).call(this, !0), Qn(this, ta, wa).call(this, i)) {
          if (i.__staleWhileFetching) return i.__staleWhileFetching;
        } else if (i !== void 0) return i;
      }
    } finally {
      if (Bt(this, yg) && Bt(this, bp)) {
        const i = Bt(this, bp);
        let n;
        for (; n = i == null ? void 0 : i.shift(); ) (t = Bt(this, Ab)) == null || t.call(this, ...n);
      }
    }
  }
  has(t, i = {}) {
    const { updateAgeOnHas: n = this.updateAgeOnHas, status: s } = i, o = Bt(this, jh).get(t);
    if (o !== void 0) {
      const r = Bt(this, oo)[o];
      if (Qn(this, ta, wa).call(this, r) && r.__staleWhileFetching === void 0) return !1;
      if (!Bt(this, r5).call(this, o)) return n && Bt(this, cz).call(this, o), s && (s.has = "hit", Bt(this, tx).call(this, s, o)), !0;
      s && (s.has = "stale", Bt(this, tx).call(this, s, o));
    } else s && (s.has = "miss");
    return !1;
  }
  peek(t, i = {}) {
    const { allowStale: n = this.allowStale } = i, s = Bt(this, jh).get(t);
    if (s === void 0 || !n && Bt(this, r5).call(this, s)) return;
    const o = Bt(this, oo)[s];
    return Qn(this, ta, wa).call(this, o) ? o.__staleWhileFetching : o;
  }
  async fetch(t, i = {}) {
    const { allowStale: n = this.allowStale, updateAgeOnGet: s = this.updateAgeOnGet, noDeleteOnStaleGet: o = this.noDeleteOnStaleGet, ttl: r = this.ttl, noDisposeOnSet: l = this.noDisposeOnSet, size: c = 0, sizeCalculation: h = this.sizeCalculation, noUpdateTTL: I = this.noUpdateTTL, noDeleteOnFetchRejection: p = this.noDeleteOnFetchRejection, allowStaleOnFetchRejection: y = this.allowStaleOnFetchRejection, ignoreFetchAbort: m = this.ignoreFetchAbort, allowStaleOnFetchAbort: A = this.allowStaleOnFetchAbort, context: C, forceRefresh: O = !1, status: R, signal: F } = i;
    if (!Bt(this, aB)) return R && (R.fetch = "get"), this.get(t, { allowStale: n, updateAgeOnGet: s, noDeleteOnStaleGet: o, status: R });
    const L = { allowStale: n, updateAgeOnGet: s, noDeleteOnStaleGet: o, ttl: r, noDisposeOnSet: l, size: c, sizeCalculation: h, noUpdateTTL: I, noDeleteOnFetchRejection: p, allowStaleOnFetchRejection: y, allowStaleOnFetchAbort: A, ignoreFetchAbort: m, status: R, signal: F };
    let P = Bt(this, jh).get(t);
    if (P === void 0) {
      R && (R.fetch = "miss");
      const z = Qn(this, nJ, Ere).call(this, t, P, L, C);
      return z.__returned = z;
    }
    {
      const z = Bt(this, oo)[P];
      if (Qn(this, ta, wa).call(this, z)) {
        const te = n && z.__staleWhileFetching !== void 0;
        return R && (R.fetch = "inflight", te && (R.returnedStale = !0)), te ? z.__staleWhileFetching : z.__returned = z;
      }
      const W = Bt(this, r5).call(this, P);
      if (!O && !W) return R && (R.fetch = "hit"), Qn(this, QV, sJ).call(this, P), s && Bt(this, cz).call(this, P), R && Bt(this, tx).call(this, R, P), z;
      const re = Qn(this, nJ, Ere).call(this, t, P, L, C), ce = re.__staleWhileFetching !== void 0 && n;
      return R && (R.fetch = W ? "stale" : "refresh", ce && W && (R.returnedStale = !0)), ce ? re.__staleWhileFetching : re.__returned = re;
    }
  }
  async forceFetch(t, i = {}) {
    const n = await this.fetch(t, i);
    if (n === void 0) throw new Error("fetch() returned undefined");
    return n;
  }
  memo(t, i = {}) {
    const n = Bt(this, tJ);
    if (!n) throw new Error("no memoMethod provided to constructor");
    const { context: s, forceRefresh: o, ...r } = i, l = this.get(t, r);
    if (!o && l !== void 0) return l;
    const c = n(t, l, { options: r, context: s });
    return this.set(t, c, r), c;
  }
  get(t, i = {}) {
    const { allowStale: n = this.allowStale, updateAgeOnGet: s = this.updateAgeOnGet, noDeleteOnStaleGet: o = this.noDeleteOnStaleGet, status: r } = i, l = Bt(this, jh).get(t);
    if (l !== void 0) {
      const c = Bt(this, oo)[l], h = Qn(this, ta, wa).call(this, c);
      return r && Bt(this, tx).call(this, r, l), Bt(this, r5).call(this, l) ? (r && (r.get = "stale"), h ? (r && n && c.__staleWhileFetching !== void 0 && (r.returnedStale = !0), n ? c.__staleWhileFetching : void 0) : (o || Qn(this, EO, RP).call(this, t, "expire"), r && n && (r.returnedStale = !0), n ? c : void 0)) : (r && (r.get = "hit"), h ? c.__staleWhileFetching : (Qn(this, QV, sJ).call(this, l), s && Bt(this, cz).call(this, l), c));
    }
    r && (r.get = "miss");
  }
  delete(t) {
    return Qn(this, EO, RP).call(this, t, "delete");
  }
  clear() {
    return Qn(this, Ale, pIe).call(this, "delete");
  }
};
ESe = Symbol.toStringTag, Qb = /* @__PURE__ */ new WeakMap(), YT = /* @__PURE__ */ new WeakMap(), Jb = /* @__PURE__ */ new WeakMap(), ZV = /* @__PURE__ */ new WeakMap(), Ab = /* @__PURE__ */ new WeakMap(), CJ = /* @__PURE__ */ new WeakMap(), tJ = /* @__PURE__ */ new WeakMap(), I1 = /* @__PURE__ */ new WeakMap(), qT = /* @__PURE__ */ new WeakMap(), jh = /* @__PURE__ */ new WeakMap(), Bu = /* @__PURE__ */ new WeakMap(), oo = /* @__PURE__ */ new WeakMap(), pg = /* @__PURE__ */ new WeakMap(), s5 = /* @__PURE__ */ new WeakMap(), Uy = /* @__PURE__ */ new WeakMap(), Sp = /* @__PURE__ */ new WeakMap(), rN = /* @__PURE__ */ new WeakMap(), bp = /* @__PURE__ */ new WeakMap(), Xb = /* @__PURE__ */ new WeakMap(), eN = /* @__PURE__ */ new WeakMap(), o5 = /* @__PURE__ */ new WeakMap(), tN = /* @__PURE__ */ new WeakMap(), aB = /* @__PURE__ */ new WeakMap(), yg = /* @__PURE__ */ new WeakMap(), iJ = /* @__PURE__ */ new WeakMap(), mre = /* @__PURE__ */ new WeakSet(), fIe = function() {
  const e = new Sre(Bt(this, Qb)), t = new Sre(Bt(this, Qb));
  Ts(this, o5, e), Ts(this, eN, t), Ts(this, Tle, ((s, o, r = xz.now()) => {
    if (t[s] = o !== 0 ? r : 0, e[s] = o, o !== 0 && this.ttlAutopurge) {
      const l = setTimeout((() => {
        Bt(this, r5).call(this, s) && Qn(this, EO, RP).call(this, Bt(this, Bu)[s], "expire");
      }), o + 1);
      l.unref && l.unref();
    }
  })), Ts(this, cz, ((s) => {
    t[s] = e[s] !== 0 ? xz.now() : 0;
  })), Ts(this, tx, ((s, o) => {
    if (e[o]) {
      const r = e[o], l = t[o];
      if (!r || !l) return;
      s.ttl = r, s.start = l, s.now = i || n();
      const c = s.now - l;
      s.remainingTTL = r - c;
    }
  }));
  let i = 0;
  const n = () => {
    const s = xz.now();
    if (this.ttlResolution > 0) {
      i = s;
      const o = setTimeout((() => i = 0), this.ttlResolution);
      o.unref && o.unref();
    }
    return s;
  };
  this.getRemainingTTL = (s) => {
    const o = Bt(this, jh).get(s);
    if (o === void 0) return 0;
    const r = e[o], l = t[o];
    return !r || !l ? 1 / 0 : r - ((i || n()) - l);
  }, Ts(this, r5, ((s) => {
    const o = t[s], r = e[s];
    return !!r && !!o && (i || n()) - o > r;
  }));
}, cz = /* @__PURE__ */ new WeakMap(), tx = /* @__PURE__ */ new WeakMap(), Tle = /* @__PURE__ */ new WeakMap(), r5 = /* @__PURE__ */ new WeakMap(), IIe = /* @__PURE__ */ new WeakSet(), ySe = function() {
  const e = new Sre(Bt(this, Qb));
  Ts(this, qT, 0), Ts(this, Xb, e), Ts(this, hz, ((t) => {
    Ts(this, qT, Bt(this, qT) - e[t]), e[t] = 0;
  })), Ts(this, Rle, ((t, i, n, s) => {
    if (Qn(this, ta, wa).call(this, i)) return 0;
    if (!cx(n)) {
      if (!s) throw new TypeError("invalid size value (must be positive integer). When maxSize or maxEntrySize is used, sizeCalculation or size must be set.");
      if (typeof s != "function") throw new TypeError("sizeCalculation must be a function");
      if (n = s(i, t), !cx(n)) throw new TypeError("sizeCalculation return invalid (expect positive integer)");
    }
    return n;
  })), Ts(this, OJ, ((t, i, n) => {
    if (e[t] = i, Bt(this, YT)) {
      const s = Bt(this, YT) - e[t];
      for (; Bt(this, qT) > s; ) Qn(this, LJ, vle).call(this, !0);
    }
    Ts(this, qT, Bt(this, qT) + e[t]), n && (n.entrySize = i, n.totalCalculatedSize = Bt(this, qT));
  }));
}, hz = /* @__PURE__ */ new WeakMap(), OJ = /* @__PURE__ */ new WeakMap(), Rle = /* @__PURE__ */ new WeakMap(), uC = /* @__PURE__ */ new WeakSet(), G_ = function* ({ allowStale: e = this.allowStale } = {}) {
  if (Bt(this, I1)) for (let t = Bt(this, Sp); Qn(this, yre, $de).call(this, t) && (!e && Bt(this, r5).call(this, t) || (yield t), t !== Bt(this, Uy)); ) t = Bt(this, s5)[t];
}, AC = /* @__PURE__ */ new WeakSet(), ix = function* ({ allowStale: e = this.allowStale } = {}) {
  if (Bt(this, I1)) for (let t = Bt(this, Uy); Qn(this, yre, $de).call(this, t) && (!e && Bt(this, r5).call(this, t) || (yield t), t !== Bt(this, Sp)); ) t = Bt(this, pg)[t];
}, yre = /* @__PURE__ */ new WeakSet(), $de = function(e) {
  return e !== void 0 && Bt(this, jh).get(Bt(this, Bu)[e]) === e;
}, LJ = /* @__PURE__ */ new WeakSet(), vle = function(e) {
  var t, i;
  const n = Bt(this, Uy), s = Bt(this, Bu)[n], o = Bt(this, oo)[n];
  return Bt(this, aB) && Qn(this, ta, wa).call(this, o) ? o.__abortController.abort(new Error("evicted")) : (Bt(this, tN) || Bt(this, yg)) && (Bt(this, tN) && ((t = Bt(this, Jb)) == null || t.call(this, o, s, "evict")), Bt(this, yg) && ((i = Bt(this, bp)) == null || i.push([o, s, "evict"]))), Bt(this, hz).call(this, n), e && (Bt(this, Bu)[n] = void 0, Bt(this, oo)[n] = void 0, Bt(this, rN).push(n)), Bt(this, I1) === 1 ? (Ts(this, Uy, Ts(this, Sp, 0)), Bt(this, rN).length = 0) : Ts(this, Uy, Bt(this, pg)[n]), Bt(this, jh).delete(s), mIe(this, I1)._--, n;
}, nJ = /* @__PURE__ */ new WeakSet(), Ere = function(e, t, i, n) {
  const s = t === void 0 ? void 0 : Bt(this, oo)[t];
  if (Qn(this, ta, wa).call(this, s)) return s;
  const o = new Ole(), { signal: r } = i;
  r == null || r.addEventListener("abort", (() => o.abort(r.reason)), { signal: o.signal });
  const l = { signal: o.signal, options: i, context: n }, c = (y, m = !1) => {
    const { aborted: A } = o.signal, C = i.ignoreFetchAbort && y !== void 0;
    if (i.status && (A && !m ? (i.status.fetchAborted = !0, i.status.fetchError = o.signal.reason, C && (i.status.fetchAbortIgnored = !0)) : i.status.fetchResolved = !0), A && !C && !m) return h(o.signal.reason);
    const O = I;
    return Bt(this, oo)[t] === I && (y === void 0 ? O.__staleWhileFetching ? Bt(this, oo)[t] = O.__staleWhileFetching : Qn(this, EO, RP).call(this, e, "fetch") : (i.status && (i.status.fetchUpdated = !0), this.set(e, y, l.options))), y;
  }, h = (y) => {
    const { aborted: m } = o.signal, A = m && i.allowStaleOnFetchAbort, C = A || i.allowStaleOnFetchRejection, O = C || i.noDeleteOnFetchRejection, R = I;
    if (Bt(this, oo)[t] === I && (!O || R.__staleWhileFetching === void 0 ? Qn(this, EO, RP).call(this, e, "fetch") : A || (Bt(this, oo)[t] = R.__staleWhileFetching)), C) return i.status && R.__staleWhileFetching !== void 0 && (i.status.returnedStale = !0), R.__staleWhileFetching;
    if (R.__returned === R) throw y;
  };
  i.status && (i.status.fetchDispatched = !0);
  const I = new Promise(((y, m) => {
    var A;
    const C = (A = Bt(this, CJ)) == null ? void 0 : A.call(this, e, s, l);
    C && C instanceof Promise && C.then(((O) => y(O === void 0 ? void 0 : O)), m), o.signal.addEventListener("abort", (() => {
      i.ignoreFetchAbort && !i.allowStaleOnFetchAbort || (y(void 0), i.allowStaleOnFetchAbort && (y = (O) => c(O, !0)));
    }));
  })).then(c, ((y) => (i.status && (i.status.fetchRejected = !0, i.status.fetchError = y), h(y)))), p = Object.assign(I, { __abortController: o, __staleWhileFetching: s, __returned: void 0 });
  return t === void 0 ? (this.set(e, p, { ...l.options, status: void 0 }), t = Bt(this, jh).get(e)) : Bt(this, oo)[t] = p, p;
}, ta = /* @__PURE__ */ new WeakSet(), wa = function(e) {
  if (!Bt(this, aB)) return !1;
  const t = e;
  return !!t && t instanceof Promise && t.hasOwnProperty("__staleWhileFetching") && t.__abortController instanceof Ole;
}, gre = /* @__PURE__ */ new WeakSet(), Kde = function(e, t) {
  Bt(this, s5)[t] = e, Bt(this, pg)[e] = t;
}, QV = /* @__PURE__ */ new WeakSet(), sJ = function(e) {
  e !== Bt(this, Sp) && (e === Bt(this, Uy) ? Ts(this, Uy, Bt(this, pg)[e]) : Qn(this, gre, Kde).call(this, Bt(this, s5)[e], Bt(this, pg)[e]), Qn(this, gre, Kde).call(this, Bt(this, Sp), e), Ts(this, Sp, e));
}, EO = /* @__PURE__ */ new WeakSet(), RP = function(e, t) {
  var i, n, s, o;
  let r = !1;
  if (Bt(this, I1) !== 0) {
    const l = Bt(this, jh).get(e);
    if (l !== void 0) if (r = !0, Bt(this, I1) === 1) Qn(this, Ale, pIe).call(this, t);
    else {
      Bt(this, hz).call(this, l);
      const c = Bt(this, oo)[l];
      if (Qn(this, ta, wa).call(this, c) ? c.__abortController.abort(new Error("deleted")) : (Bt(this, tN) || Bt(this, yg)) && (Bt(this, tN) && ((i = Bt(this, Jb)) == null || i.call(this, c, e, t)), Bt(this, yg) && ((n = Bt(this, bp)) == null || n.push([c, e, t]))), Bt(this, jh).delete(e), Bt(this, Bu)[l] = void 0, Bt(this, oo)[l] = void 0, l === Bt(this, Sp)) Ts(this, Sp, Bt(this, s5)[l]);
      else if (l === Bt(this, Uy)) Ts(this, Uy, Bt(this, pg)[l]);
      else {
        const h = Bt(this, s5)[l];
        Bt(this, pg)[h] = Bt(this, pg)[l];
        const I = Bt(this, pg)[l];
        Bt(this, s5)[I] = Bt(this, s5)[l];
      }
      mIe(this, I1)._--, Bt(this, rN).push(l);
    }
  }
  if (Bt(this, yg) && ((s = Bt(this, bp)) != null && s.length)) {
    const l = Bt(this, bp);
    let c;
    for (; c = l == null ? void 0 : l.shift(); ) (o = Bt(this, Ab)) == null || o.call(this, ...c);
  }
  return r;
}, Ale = /* @__PURE__ */ new WeakSet(), pIe = function(e) {
  var t, i, n;
  for (const s of Qn(this, AC, ix).call(this, { allowStale: !0 })) {
    const o = Bt(this, oo)[s];
    if (Qn(this, ta, wa).call(this, o)) o.__abortController.abort(new Error("deleted"));
    else {
      const r = Bt(this, Bu)[s];
      Bt(this, tN) && ((t = Bt(this, Jb)) == null || t.call(this, o, r, e)), Bt(this, yg) && ((i = Bt(this, bp)) == null || i.push([o, r, e]));
    }
  }
  if (Bt(this, jh).clear(), Bt(this, oo).fill(void 0), Bt(this, Bu).fill(void 0), Bt(this, o5) && Bt(this, eN) && (Bt(this, o5).fill(0), Bt(this, eN).fill(0)), Bt(this, Xb) && Bt(this, Xb).fill(0), Ts(this, Uy, 0), Ts(this, Sp, 0), Bt(this, rN).length = 0, Ts(this, qT, 0), Ts(this, I1, 0), Bt(this, yg) && Bt(this, bp)) {
    const s = Bt(this, bp);
    let o;
    for (; o = s == null ? void 0 : s.shift(); ) (n = Bt(this, Ab)) == null || n.call(this, ...o);
  }
};
let kqe = Gqe;
const cC = class {
  static get(e) {
    return this._meshes.get(e);
  }
  static lockIn(e) {
    Object.seal(e);
  }
  static add(e, t) {
    this._meshes.set(e, t);
  }
  static delete(e) {
    for (const t of e) this._meshes.delete(t);
  }
  static setCapacity(e) {
    e !== this._capacity && (this._meshes.clear(), this._meshes = this.setupMeshes(e), this._capacity = e);
  }
  static setupMeshes(e) {
    const t = Math.max(e ?? this.computeCapacity(), 1), i = this.getSizeCalculationEvent();
    return new kqe({ maxSize: t, sizeCalculation: i });
  }
  static computeCapacity() {
    const e = globalThis.navigator && "deviceMemory" in globalThis.navigator ? globalThis.navigator.deviceMemory : null, t = e !== null ? e : 2, i = this.oneHundredMb * t;
    return Math.trunc(i);
  }
  static getDataSetMemory(e) {
    let t = 0;
    for (const i of e) t += i.usedMemory;
    return Math.max(t, 1);
  }
  static getSizeCalculationEvent() {
    return (e) => Array.isArray(e) ? this.getDataSetMemory(e) : Math.max(e.usedMemory, 1);
  }
};
De(cC, "oneHundredMb", 1e8), De(cC, "_meshes", cC.setupMeshes()), De(cC, "_capacity"), De(cC, "_memoryAttributes", ["positionBuffer", "indexBuffer", "normalBuffer"]), De(cC, "updateMeshMemory", ((e) => {
  e.usedMemory = 0;
  for (const t of cC._memoryAttributes) e.usedMemory !== void 0 && e[t] && (e.usedMemory += e[t].byteLength);
  cC.lockIn(e);
}));
let XV = cC;
const Vqe = class bre {
  constructor(t) {
    De(this, "meshes"), De(this, "tilesUpdated", !1), De(this, "_sampleAmount"), De(this, "_tileDimension"), De(this, "_tileBySample"), De(this, "_lodBySample"), De(this, "_virtualMeshes", /* @__PURE__ */ new Map()), De(this, "_meshConnection"), De(this, "_samples"), De(this, "_tileIdGenerator", new Cme()), De(this, "_tiles", /* @__PURE__ */ new Map()), De(this, "_tilesChanged", /* @__PURE__ */ new Set()), De(this, "_sizeByTile", /* @__PURE__ */ new Map()), De(this, "_samplesDimensions"), De(this, "_sampleLodClass"), De(this, "_sampleLodState"), De(this, "_sampleLodSize"), De(this, "_boxes"), De(this, "_items"), De(this, "_materials"), De(this, "_modelId"), De(this, "_lastView", { rotation: new Ge(), location: new Ge() }), De(this, "_params", { updateTime: 16, updateSamples: 64, updateviewOrientation: 8 * Math.PI / 180, updateViewPosition: 256, smallTileSize: 0.32, mediumTileSize: 4, smallObjectSize: 2, smallScreenSize: 2, mediumScreenSize: 4, largeScreenSize: 16, tempTileDataSize: 6, tileIdIncrement: 1, tileSizeMultiplier: 10, minTileDimension: 32, tileDimensionFactor: 8 }), De(this, "_temp", { sample: new lY(), representation: new iN(), vector: new Ge(), matrix: new Ln(), transform: new Ln(), boundingBox: new Zs(), sampleGeometry: {}, box: new Zs(), raycastPoints: [], tileData: { positionCount: this._params.tempTileDataSize, objectClass: tE.LINE, positionBuffer: new Float32Array(this._params.tempTileDataSize) }, tileCenter: new Ge(), tile: { objectClass: tE.LINE, positionCount: 6 }, viewDimension: 0, pastFieldOfview: 0 }), De(this, "_currentSample", 0), De(this, "_virtualPlanes", []), De(this, "_changedSamples", 0), De(this, "_virtualView"), De(this, "_lodMode", Tre.DEFAULT), this._modelId = t.modelId, this._boxes = t.boxes, this._items = t.items, this._materials = t.materials, this._meshConnection = new Bqe(t.modelId, t.connection), this.meshes = t.model.meshes(), this._sampleAmount = this.meshes.samplesLength(), this._samples = new Uqe(this._sampleAmount), this._samplesDimensions = new Int32Array(this._sampleAmount), this._sampleLodClass = new Uint8Array(this._sampleAmount), this._sampleLodState = new Uint8Array(this._sampleAmount), this._sampleLodSize = new Float32Array(this._sampleAmount), this._tileDimension = this.computeTileSize(), this._tileBySample = new Array(this._sampleAmount), this._lodBySample = new Array(this._sampleAmount), this.init();
  }
  restart() {
    this.resetUpdateProcess(), this._meshConnection.clean();
  }
  fetchSample(t, i) {
    this.fetchSampleAndRepresentation(t);
    const n = this.fetchCurrentMesh(), s = this.sampleTemplate(t);
    return s.geometries = this.sampleGeoms(s, i, n), s;
  }
  fetchGeometry(t) {
    return this.meshes.representations(t, this._temp.representation), this.fetchCurrentMesh().fetchMeshes(t, !0);
  }
  dispose() {
    this._meshConnection.dispose();
    for (const [, t] of this._virtualMeshes) t.dispose();
  }
  generate() {
    for (const [, t] of this._virtualMeshes) t.setupTemplates();
    for (let t = 0; t < this._sampleAmount; t++) this.generateSampleInTiles(t);
    this.setupTileVisibilityAndHighlight();
  }
  setupView(t) {
    this._virtualView = t, XV.setCapacity(t.meshThreshold), this.restart(), this.updateOrientationIfNeeded(), this.updatePositionIfNeeded(), this.setupViewPlanes();
  }
  updateVirtualMeshes(t) {
    if (t && this._virtualView) {
      for (const i of t) this.updateItem(i);
      this.restart();
    }
  }
  getSampleTransform(t) {
    return this.fetchSampleAndRepresentation(t), this.sampleTemplate(t).transform;
  }
  async update(t) {
    this.updateTiles(t), this.notifyUpdateFinished();
    for (const i of this._tilesChanged) {
      const n = this._tiles.get(i);
      this._meshConnection.process({ tileRequestClass: tc.UPDATE, modelId: this._modelId, tileId: i, objectClass: n.objectClass, material: n.materialId, tileData: this.getTileData(n), currentLod: n.lod });
    }
    this._tilesChanged.clear();
  }
  raycast(t, i, n, s) {
    this._temp.raycastPoints = [];
    const o = t.representationClass(), r = this._virtualMeshes.get(o);
    return this.manageRaycast(r, t, i, n, s), this._temp.raycastPoints;
  }
  setLodMode(t) {
    this._lodMode = t, this.restart();
  }
  init() {
    const t = new Cqe(this._modelId, this.meshes), i = t.getRepresentation();
    this._virtualMeshes.set(i, t);
    const n = new Mqe(this._modelId, this.meshes), s = n.getRepresentation();
    this._virtualMeshes.set(s, n), this.processSamplesDimension(), this.fetchSampleLodSize();
  }
  initSampleLod(t) {
    this.fetchSampleAndRepresentation(t);
    const i = this.fetchCurrentMesh();
    this._sampleLodClass[t] = i.getLodClass(), this._sampleLodState[t] = Bo.INVISIBLE;
  }
  fetchSampleAndRepresentation(t) {
    this.meshes.samples(t, this._temp.sample), this.meshes.representations(this._temp.sample.representation(), this._temp.representation);
  }
  fetchCurrentMesh() {
    const t = this._temp.representation.representationClass();
    return this._virtualMeshes.get(t);
  }
  fetchCurrentMaterial() {
    const t = this._temp.sample.material();
    return this._materials[t];
  }
  fetchSampleLodSize() {
    for (let t = 0; t < this._sampleAmount; t++) this.initSampleLod(t), pz.getBox(this._temp.representation, this._temp.box), this._sampleLodSize[t] = $Se.getWidth(this._temp.box);
  }
  setupTileVisibilityAndHighlight() {
    for (const [, t] of this._tiles) t.visibilities = new cJ(t.size, !1), t.highlights = new cJ(t.size, 0);
  }
  addLodToTile(t, i, n) {
    t.getLodClass() !== cB.AABB ? t.getLodClass() === cB.CUSTOM && this.addCustomLodToTile(t, i, n) : this.addBoxLodToTile(i, n);
  }
  addBoxLodToTile(t, i) {
    this._lodBySample[t] = this.lodTileAppendSample(t, i);
  }
  notifyUpdateFinished() {
    const t = !this.tilesUpdated;
    this._changedSamples >= this._sampleAmount && t && (this._meshConnection.process({ tileRequestClass: tc.FINISH, modelId: this._modelId }), this.tilesUpdated = !0);
  }
  updatePositionIfNeeded() {
    const t = this._params.updateViewPosition, i = this._virtualView.cameraPosition;
    i.distanceToSquared(this._lastView.location) > t && (this._currentSample = 0, this._lastView.location.copy(i));
  }
  updateCurrentSample() {
    this._currentSample++, this._currentSample >= this._sampleAmount && (this._currentSample = 0), this._changedSamples++;
  }
  processSamplesDimension() {
    for (let t = 0; t < this._sampleAmount; t++) this._samplesDimensions[t] = t;
    this._samplesDimensions.sort(((t, i) => this._boxes.dimensionOf(i) - this._boxes.dimensionOf(t)));
  }
  setupViewPlanes() {
    this._virtualPlanes = [];
    for (const t of this._virtualView.cameraFrustum.planes) this._virtualPlanes.push(t);
    if (this._virtualView.clippingPlanes) for (const t of this._virtualView.clippingPlanes) this._virtualPlanes.push(t);
  }
  updateOrientationIfNeeded() {
    const t = this.getCurrentViewOrientation(), i = this._params.updateviewOrientation;
    t.angleTo(this._lastView.rotation) > i && (this._currentSample = 0, this._lastView.rotation.copy(t));
  }
  getCurrentViewOrientation() {
    return this._virtualView.cameraFrustum.planes[4].normal;
  }
  resetUpdateProcess() {
    this._changedSamples = 0, this.tilesUpdated = !1;
  }
  manageRaycast(t, i, n, s, o) {
    const r = Fqe.cast(t, i, n, s, o);
    if (r) for (const l of r) l.representationClass = t.getObjectClass(), this._temp.raycastPoints.push(l);
  }
  setTileShellBuffer(t) {
    t.usedMemory !== void 0 && t.objectClass === tE.SHELL && (t.ids = new Float32Array(t.positionCount / 3), t.usedMemory += t.ids.byteLength);
  }
  getTileWhenSamplePut(t, i, n) {
    let s = this._tiles.get(t);
    if (s === void 0) {
      const o = i.lod || Bo.GEOMETRY;
      s = this.newTile(i.objectClass, n, o), this._tiles.set(t, s);
    }
    return s;
  }
  getPerspTrueDim(t, i) {
    const n = Math.PI / 180;
    return i * Math.tan(0.5 * t * n);
  }
  getTileHighlight(t, i) {
    let n, s;
    const o = t.highlights;
    if (!o) return { highlightData: void 0, highlightIds: void 0 };
    const r = o.size(((l) => l !== 0));
    if (r > 0) {
      s = new Uint16Array(r);
      const l = (h) => h !== 0, c = (h, I) => s[h] = I;
      n = cJ.get(o, i, l, c);
    }
    return { highlightData: n, highlightIds: s };
  }
  setupTileSampleAttributes(t, i, n, s) {
    const o = 3 * t.vertexLocation[i];
    for (let r = 0; r < n.positionBuffer.length; r += 3) this._temp.vector.fromArray(n.positionBuffer, r), this._temp.vector.applyMatrix4(this._temp.matrix), this._temp.vector.toArray(t.positionBuffer, o + r);
    if (t.normalBuffer) {
      const r = 3 * t.vertexLocation[i];
      for (let l = 0; l < n.normalBuffer.length; l += 3) this._temp.vector.fromArray(n.normalBuffer, l), this._temp.vector.transformDirection(this._temp.matrix), this._temp.vector.multiplyScalar(VJ), this._temp.vector.toArray(t.normalBuffer, r + l);
    }
    if (t.indexBuffer) {
      const r = t.indexLocation[i], l = t.vertexLocation[i];
      for (let c = 0; c < n.indexCount; c++) {
        const h = n.indexBuffer[c] + l;
        t.indexBuffer[c + r] = h;
      }
    }
    if (t.faceIdBuffer && n.faceIdBuffer) {
      const r = 100 * s.sample, l = t.vertexLocation[i], c = l + n.positionCount / 3;
      for (let h = l; h < c; h++) t.faceIdBuffer[h] = n.faceIdBuffer[h - l] + r;
    }
    if (n.objectClass === tE.SHELL) {
      const r = t.vertexLocation[i], l = r + n.positionCount / 3;
      t.ids.fill(this.itemId(s.sample), r, l);
    }
  }
  getTileVisibility(t, i) {
    if (!t.visibilities) throw new Error("Fragments: Malformed tile!");
    if (!t.visibilities.fullOf(!1))
      return cJ.get(t.visibilities, i, ((n) => n));
  }
  memoryOverflow() {
    return bre._graphicMemoryConsumed > this._virtualView.graphicThreshold;
  }
  updateMesh(t) {
    let i = this.fetchLodLevel(t);
    const n = this._sampleLodState[t];
    i = this.hideHighlightedLods(i, t), i !== n ? this.updateVisible(n, i, t) : this.updateSampleIfSeen(i, t);
  }
  tileLoadSample(t, i, n) {
    const s = t.sampleLocation.get(i.sample), o = this.getSampleGeometries(i, n);
    this.setupTileLocation(t, o, i), this.fetchSampleTransform(t, i), this.setupTileSampleAttributes(t, s, o, i);
  }
  updateSampleIfSeen(t, i) {
    t !== Bo.INVISIBLE && this.updateSample(i, t);
  }
  hideHighlightedLods(t, i) {
    return t === Bo.WIRES && this._samples.getHighlight(i) && (t = Bo.INVISIBLE), t;
  }
  updateVisible(t, i, n) {
    t !== Bo.INVISIBLE && this.makeSampleInvisible(n, t);
    const s = i !== Bo.INVISIBLE;
    s && this.updateSample(n, i), this._samples.setVisible(n, s), this._sampleLodState[n] = i;
  }
  makeInvisibleFromTile(t, i) {
    const n = this._tiles.get(t);
    this.updateTileData(n, i, !1, 0), this.deleteTileIfNeeded(n, t);
  }
  updateSample(t, i) {
    const n = this.itemId(t), s = this._items.visible(n), o = this._items.getHighlight(n);
    this.hasChanged(t, i, s, o) && this.setSample(t, s, o, i);
  }
  hasHighlightChanged(t, i) {
    return i !== this._samples.getHighlight(t);
  }
  hasVisibleChanged(t, i) {
    return i !== this._samples.visible(t);
  }
  newTile(t, i, n) {
    const s = { notVirtual: !1 };
    return s.materialId = i, s.indexLocation = [], s.box = new Zs(), s.objectClass = t, s.lod = n, s.normalCount = 0, s.indexCount = 0, s.vertexLocation = [], s.size = 0, s.geometriesLocation = [], s.positionCount = 0, s.sampleLocation = /* @__PURE__ */ new Map(), s.faceIdBuffer = new Uint32Array(0), s;
  }
  createLod(t) {
    const i = pz.boxSize(t), n = this._temp.tileData.positionBuffer;
    if (!n) throw new Error("Fragments: Malformed tiles!");
    return n[0] = i.start.x, n[1] = i.start.y, n[2] = i.start.z, n[3] = i.end.x, n[4] = i.end.y, n[5] = i.end.z, this._temp.tileData;
  }
  sampleTemplate(t) {
    const i = this._temp.sample, n = this._temp.representation;
    pz.get(i, this.meshes, this._temp.transform), pz.getBox(n, this._temp.boundingBox), this._temp.sampleGeometry.sample = t;
    const s = i.material();
    this._temp.sampleGeometry.material = this._materials[s], this._temp.sampleGeometry.transform = this._temp.transform, this._temp.sampleGeometry.aabb = this._temp.boundingBox, delete this._temp.sampleGeometry.geometries;
    const o = this._temp.sample.representation(), r = this.meshes.representationIds(o);
    return this._temp.sampleGeometry.representationId = r, this._temp.sampleGeometry;
  }
  makeSampleInvisible(t, i) {
    const n = this.getTileIds(t, i);
    n && Cv.forEach(n, ((s) => this.makeInvisibleFromTile(s, t)));
  }
  setSample(t, i, n, s) {
    this._samples.setVisible(t, i), this._samples.setHighlight(t, n);
    const o = this.getTileIds(t, s);
    o !== void 0 && Cv.forEach(o, ((r) => {
      this.updateTile(r, t, n, n === 0);
    }));
  }
  getTileIds(t, i) {
    return i === Bo.GEOMETRY ? this._tileBySample[t] : this._lodBySample[t];
  }
  addBasicTileData(t, i, n) {
    t.sampleLocation.set(i, t.size), t.size++, t.geometriesLocation.push(n), t.indexLocation.push(t.indexCount || 0), t.vertexLocation.push((t.positionCount || 0) / 3);
  }
  buildNewVirtualTile(t, i) {
    this.constructTile(t), this.loadTile(i, t), t.notVirtual = !0, delete t.indexBuffer, delete t.positionBuffer, delete t.normalBuffer, delete t.faceIdBuffer, delete t.ids;
  }
  deleteTileIfNeeded(t, i) {
    if (this.getShouldDeleteTile(t)) return this.deleteGeometry(i), t.notVirtual = !1, void (bre._graphicMemoryConsumed -= t.usedMemory);
    this._tilesChanged.add(i);
  }
  getShouldDeleteTile(t) {
    if (!t.visibilities || !t.highlights) throw new Error("Fragments: Malformed tile!");
    const i = t.visibilities.fullOf(!1), n = t.highlights.fullOf(0), s = this.memoryOverflow();
    return i && n && s;
  }
  checkTileMemoryOverflow(t, i) {
    const n = this._tiles.get(t);
    return (n ? n.positionCount : 0) + i.positionCount > WW;
  }
  updateTileData(t, i, n, s) {
    if (!t.visibilities || !t.highlights) throw new Error("Fragments: Malformed tile!");
    const o = t.sampleLocation.get(i);
    t.visibilities.update(o, n), t.highlights.update(o, s);
  }
  getKeepUpdating(t, i) {
    const n = this._params.updateTime, s = this._params.updateSamples, o = t < this._sampleAmount, r = performance.now() - i;
    return o && (r < n || t < s);
  }
  computeTileSize() {
    const t = this._boxes.fullBox.getSize(this._temp.vector), i = Math.max(t.x, t.y, t.z) / this._params.tileDimensionFactor, n = Math.ceil(i);
    return Math.max(this._params.minTileDimension, n);
  }
  newTileId(t, i, n) {
    this.logBufferOverflowIfNeeded(n);
    const s = n.lod || Bo.GEOMETRY, o = this.generateTileCode(t, i, n, s), r = this._sizeByTile.get(o) || 1;
    let l = o + r - 1;
    return this.checkTileMemoryOverflow(l, n) && (l += this._params.tileIdIncrement, this._sizeByTile.set(o, r + 1)), l;
  }
  logBufferOverflowIfNeeded(t) {
    t.positionCount / 3 > WW && console.log("Fragments: Buffer overflow");
  }
  fetchLodLevel(t) {
    if (this._lodMode === Tre.ALL_VISIBLE) return Bo.GEOMETRY;
    const i = this._boxes.get(t);
    if (!VF.collides(i, this._virtualPlanes)) return Bo.INVISIBLE;
    this.meshes.samples(t, this._temp.sample);
    const n = this._temp.sample.item();
    if (!this._items.visible(n)) return Bo.INVISIBLE;
    const s = this._virtualView.graphicQuality, o = this._boxes.dimensionOf(t), r = i.distanceToPoint(this._virtualView.cameraPosition), l = this.screenSize(o, r), c = o < this._params.smallObjectSize, h = !c, I = this._params.smallScreenSize * s, p = this._params.mediumScreenSize * s, y = this._params.largeScreenSize * s, m = l < p, A = c && l < y, C = h && m;
    if (c && m || h && l < I) return Bo.INVISIBLE;
    if (this._lodMode === Tre.ALL_GEOMETRY) return Bo.GEOMETRY;
    if (A || C) return Bo.WIRES;
    const O = this._sampleLodSize[t];
    return this.screenSize(O, r) < Math.max(p, this._params.mediumScreenSize) ? Bo.WIRES : Bo.GEOMETRY;
  }
  generateTileCode(t, i, n, s) {
    this._tileIdGenerator.reset(), this.processTileDataId(n, i, s);
    const o = this.processTileSpatialId(t, s);
    return this.processTileDimensionId(o), this._tileIdGenerator.value;
  }
  processTileDataId(t, i, n) {
    this._tileIdGenerator.compute(t.objectClass !== void 0 ? t.objectClass : 0), this._tileIdGenerator.compute(i), this._tileIdGenerator.compute(n);
  }
  deleteGeometry(t) {
    this._meshConnection.process({ tileRequestClass: tc.DELETE, modelId: this._modelId, tileId: t });
  }
  processTileSpatialId(t, i) {
    const n = this._temp.tileCenter.x, s = this._temp.tileCenter.y, o = this._temp.tileCenter.z, r = this._boxes.get(t);
    r.getCenter(this._temp.tileCenter);
    const l = this.getTileDimension(i), c = n - n % l, h = s - s % l, I = o - o % l;
    return this._tileIdGenerator.compute(c), this._tileIdGenerator.compute(h), this._tileIdGenerator.compute(I), r;
  }
  addCustomLodToTile(t, i, n) {
    const s = this.meshData(t, !1, Bo.WIRES);
    this._sampleLodSize[i] = s.lodThickness || 0, this._lodBySample[i] = this.putSampleInTiles(i, n, s);
  }
  getTileLocations(t) {
    return t.indexCount ? t.indexLocation : t.vertexLocation;
  }
  getTileDimension(t) {
    let i = this._tileDimension;
    return t === Bo.GEOMETRY && (i *= this._params.tileSizeMultiplier), i;
  }
  processTileDimensionId(t) {
    const i = this.getTileDimensionClass(t);
    this._tileIdGenerator.compute(i);
  }
  tileAppend(t, i, n, s) {
    this.addBasicTileData(t, n, s), this.tileAppendAttribute(t, i, "indexCount", !1), this.tileAppendAttribute(t, i, "positionCount", !1), this.tileAppendAttribute(t, i, "normalCount", !1), this.tileAppendAttribute(t, i, "materialId", !0);
  }
  putSampleInTiles(t, i, n) {
    let s;
    return Cv.forEach(n, ((o, r) => {
      const l = this.newTileId(t, i, o);
      s = this.getTileIdsWhenSamplePut(s, l);
      const c = this.getTileWhenSamplePut(l, o, i);
      this.tileAppend(c, o, t, r);
    })), s;
  }
  hasLodChanged(t, i) {
    return i !== this._sampleLodState[t];
  }
  getTileIdsWhenSamplePut(t, i) {
    return t === void 0 ? t = i : typeof t == "number" ? t !== i && (t = [t, i]) : t.includes(i) || t.push(i), t;
  }
  updateTile(t, i, n, s) {
    const o = this._tiles.get(t);
    this.updateTileData(o, i, s, n), o.notVirtual ? this._tilesChanged.add(t) : this.buildNewVirtualTile(o, t);
  }
  getLodTileWhenPutSample(t, i) {
    let n = this._tiles.get(t);
    if (!n) {
      const s = this._temp.tile.objectClass;
      n = this.newTile(s, i, Bo.WIRES), this._tiles.set(t, n);
    }
    return n;
  }
  lodTileAppendSample(t, i) {
    const n = Bo.WIRES, s = this._temp.tile, o = this.generateTileCode(t, i, s, n), r = this.getLodTileWhenPutSample(o, i);
    return this.tileAppend(r, s, t, 0), o;
  }
  addSampleToTile(t, i, n) {
    const s = this.meshData(t, !1, Bo.GEOMETRY);
    this._tileBySample[i] = this.putSampleInTiles(i, n, s);
  }
  setTileBuffer(t, i, n) {
    if (t.usedMemory === void 0) return;
    const s = t[`${i}Count`];
    if (s > 0) {
      const o = n ? new Uint16Array(s) : new Int16Array(s);
      t[`${i}Buffer`] = o, t.usedMemory += o.byteLength;
    }
  }
  updateTiles(t) {
    const i = this._changedSamples < this._sampleAmount;
    if (this._virtualView === void 0 || !i) return;
    let n = !0, s = 0;
    for (; n; ) {
      const o = this._samplesDimensions[this._currentSample];
      this.updateMesh(o), this.updateCurrentSample(), s++, n = this.getKeepUpdating(s, t);
    }
  }
  sampleGeoms(t, i, n) {
    return n.getLodClass() === cB.AABB && i === Bo.WIRES ? this.createLod(t.aabb) : this.meshData(n, !0, i);
  }
  generateSampleInTiles(t) {
    this.fetchSampleAndRepresentation(t);
    const i = this.fetchCurrentMaterial(), n = this.fetchCurrentMesh();
    this.addSampleToTile(n, t, i), this.addLodToTile(n, t, i);
  }
  buildSampleInTile(t, i, n, s, o) {
    const r = t.geometriesLocation[i];
    if (this.tileLoadSample(t, n, r), s) {
      const l = this._boxes.get(o);
      this._temp.vector.copy(t.location), this._temp.vector.negate(), l.translate(this._temp.vector), t.box.union(l);
    }
  }
  getSampleGeometries(t, i) {
    return Array.isArray(t.geometries) ? t.geometries[i] : t.geometries;
  }
  constructTile(t) {
    t.positionBuffer === void 0 && (t.positionBuffer = new Float32Array(t.positionCount), t.usedMemory = t.positionBuffer.byteLength, this.setTileBuffer(t, "index", !0), this.setTileBuffer(t, "normal", !1), this.setTileShellBuffer(t), t.faceIdBuffer = new Uint32Array(t.positionCount / 3), t.usedMemory += t.faceIdBuffer.byteLength);
    const i = !t.location;
    for (const [n, s] of t.sampleLocation) {
      const o = this.fetchSample(n, t.lod);
      o && o.geometries && this.buildSampleInTile(t, s, o, i, n);
    }
  }
  fetchSampleTransform(t, i) {
    this._temp.vector.copy(t.location), this._temp.vector.negate(), this._temp.matrix.identity(), this._temp.matrix.setPosition(this._temp.vector), this._temp.matrix.multiply(i.transform);
  }
  hasChanged(t, i, n, s) {
    const o = this.hasLodChanged(t, i), r = this.hasVisibleChanged(t, n), l = this.hasHighlightChanged(t, s);
    return o || r || l;
  }
  setupTileLocation(t, i, n) {
    if (t.location) return;
    const s = new Ge();
    s.fromArray(i.positionBuffer), s.applyMatrix4(n.transform), t.location = s;
  }
  getTileData(t) {
    const i = this.getTileLocations(t), n = this.getTileVisibility(t, i), s = this.getTileHighlight(t, i), { highlightData: o, highlightIds: r } = s;
    return { visibilityData: n, highlightData: o, highlightIds: r };
  }
  updateMemoryOnTileLoad(t) {
    bre._graphicMemoryConsumed += t.usedMemory;
  }
  fetchTileMatrixOnLoad(t) {
    t.location && (this._temp.matrix.identity(), this._temp.matrix.setPosition(t.location));
  }
  updateItem(t) {
    const i = this._boxes.sampleOf(t);
    if (i) for (const n of i) this.updateMesh(n);
  }
  screenSize(t, i) {
    return t / this.getViewDimension(i) * this._virtualView.viewSize;
  }
  getTileDimensionClass(t) {
    const i = t.min.distanceToSquared(t.max), n = this._params.smallTileSize;
    return i > this._params.mediumTileSize ? 2 : i > n ? 1 : 0;
  }
  getViewDimension(t) {
    if (this._virtualView.orthogonalDimension) return this._virtualView.orthogonalDimension;
    const i = this._virtualView.fov;
    return i !== this._temp.pastFieldOfview && (this._temp.viewDimension = this.getPerspTrueDim(i, 1), this._temp.pastFieldOfview = i), t * this._temp.viewDimension;
  }
  loadTile(t, i) {
    const n = this.getTileData(i);
    this.fetchTileMatrixOnLoad(i);
    const s = this.getFaceIds(i);
    this._meshConnection.process({ tileRequestClass: tc.CREATE, modelId: this._modelId, objectClass: i.objectClass, tileId: t, itemId: void 0, tileData: n, indices: i.indexBuffer, positions: i.positionBuffer, normals: i.normalBuffer, faceIds: s, itemIds: i.ids, material: i.materialId, matrix: this._temp.matrix.clone(), aabb: i.box.clone(), currentLod: i.lod }), this.updateMemoryOnTileLoad(i);
  }
  getFaceIds(t) {
    const i = new Xn(), n = t.faceIdBuffer, s = new Float32Array(3 * n.length);
    for (let o = 0; o < n.length; o++) {
      const r = n[o];
      i.set(0 + r), s[3 * o] = i.r, s[3 * o + 1] = i.g, s[3 * o + 2] = i.b;
    }
    return s;
  }
  meshData(t, i, n) {
    const s = this._temp.representation.id(), o = t.getLodClass() === cB.CUSTOM, r = n === Bo.WIRES;
    return o && r ? t.fetchLod(s, i) : t.fetchMeshes(s, i);
  }
  tileAppendAttribute(t, i, n, s) {
    i[n] !== void 0 && (s ? t[n] = i[n] : t[n] += i[n]);
  }
  itemId(t) {
    return this.meshes.samples(t, this._temp.sample), this._temp.sample.item();
  }
};
De(Vqe, "_graphicMemoryConsumed", 0);
class zqe {
  constructor() {
    De(this, "_templates", /* @__PURE__ */ new Map());
  }
  add(t, i) {
    this._templates.set(t, i);
  }
  get(t) {
    const i = this._templates.get(t);
    return Array.isArray(i) ? this.getTemplateSet(i) : { ...i };
  }
  getTemplateSet(t) {
    const i = [];
    for (const n of t) {
      const s = { ...n };
      i.push(s);
    }
    return i;
  }
}
const dbe = class yb {
  constructor(t, i) {
    De(this, "_dataBuffer"), De(this, "_dataPosition"), this._dataBuffer = i || this.getDefaultData(), this._dataPosition = t || yb._data.defaultPosition;
  }
  set(t) {
    let i = 0;
    for (const n of yb._data.points) for (const s of yb._data.coords) {
      const o = this.getPosition(s, n), r = t[i++];
      this.setValue(o, r);
    }
  }
  get(t, i) {
    const n = this.getPosition(t, i);
    return this._dataBuffer[n];
  }
  clone(t) {
    for (const i of yb._data.points) for (const n of yb._data.coords) {
      const s = this.getPosition(n, i), o = t.get(n, i);
      this.setValue(s, o);
    }
  }
  combine(t, i) {
    for (const n of yb._data.points) for (const s of yb._data.coords) this.save(s, n, t, i);
  }
  setValue(t, i) {
    this._dataBuffer[t] = i;
  }
  getDefaultData() {
    return new Float64Array(yb._data.size);
  }
  getPosition(t, i) {
    return yb._data[i][t] + this._dataPosition;
  }
  save(t, i, n, s) {
    const o = this.getPosition(t, i), r = n.get(t, i), l = s.get(t, i), c = Math[i](r, l);
    this.setValue(o, c);
  }
};
De(dbe, "_data", { size: 6, defaultPosition: 0, min: { x: 0, y: 2, z: 4 }, max: { x: 1, y: 3, z: 5 }, coords: ["x", "y", "z"], points: ["min", "max"] });
let Nre = dbe;
const cbe = class Dre {
  constructor(t, i) {
    De(this, "box"), De(this, "data", 0), this.box = new Nre(t, i);
  }
  get size() {
    return this.data * Dre._data.factor;
  }
  get isPoint() {
    return this.data >= Dre._data.threshold;
  }
  transform(t, i, n) {
    n || (t *= Dre._data.factor), this.data = t, this.box.clone(i);
  }
};
De(cbe, "_data", { threshold: 0, factor: -1 });
let jqe = cbe;
class Wqe {
  constructor(t) {
    De(this, "_boxes"), De(this, "_min", new Ge()), De(this, "_max", new Ge()), this._boxes = t;
  }
  inflate(t) {
    const i = this._boxes.fullBox.min, n = this.getVector(t, i, "min"), s = this.getVector(t, i, "max");
    return new Zs(n, s);
  }
  deflate(t, i) {
    this.read(t);
    const n = [];
    n.push(this._min.x, this._min.y, this._min.z), n.push(this._max.x, this._max.y, this._max.z), i.set(n);
  }
  getVector(t, i, n) {
    const s = t.get("x", n) + i.x, o = t.get("y", n) + i.y, r = t.get("z", n) + i.z;
    return new Ge(s, o, r);
  }
  read(t) {
    const { min: i } = this._boxes.fullBox;
    this._min.subVectors(t.min, i), this._max.subVectors(t.max, i);
  }
}
class Yqe {
  constructor(t, i) {
    De(this, "_data"), De(this, "_compressor"), this._data = i, this._compressor = t;
  }
  frustumCollide(t, i, n = !1) {
    const s = this.getFrustumPlanes(i, t), o = this.getFrustumOnCollide(s), r = this.getFrustumOnIncludes(s), l = this.newDefaultCallback(!0);
    return this.collide(o, r, l, n);
  }
  rayCollide(t, i) {
    const n = this.getRayOnCollide(i), s = this.newDefaultCallback(!1), o = this.getRayOnSeen(t);
    return this.collide(n, s, o);
  }
  addPoint(t, i, n, s) {
    t ? s && i.push(this.getPointData(n)) : i.push(this.getPointData(n));
  }
  getPointData(t) {
    return this.getPoint(t).data;
  }
  getBounds(t) {
    const i = this.getPoint(t);
    return this._compressor.inflate(i.box);
  }
  isPoint(t) {
    return this.getPoint(t).isPoint;
  }
  newDefaultCallback(t) {
    return (i) => t;
  }
  groupSize(t) {
    return this.getPoint(t).size;
  }
  getPoint(t) {
    return this._data.points[t];
  }
  getRayOnSeen(t) {
    let i = this.newDefaultCallback(!0);
    return (t == null ? void 0 : t.length) > 0 && (i = (n) => VF.collides(n, t)), i;
  }
  getRayOnCollide(t) {
    return (i) => t.intersectsBox(i);
  }
  collide(t, i, n, s = !1) {
    const o = this._data.points.length, r = [];
    let l = 0;
    const c = (I, p) => {
      const y = l + this.groupSize(l);
      for (; l < y; l++)
        this.isPoint(l) && n(I) && (s ? p && this.savePoint(l, r) : this.savePoint(l, r));
    }, h = () => {
      const I = this.getBounds(l), p = i(I), y = this.isPoint(l), m = p || t(I);
      y && m && n(I) && this.addPoint(s, r, l, p), m || y ? (l++, p && !y && c(I, p)) : l += this.groupSize(l);
    };
    for (; l < o; ) h();
    return r;
  }
  getFrustumOnIncludes(t) {
    return (i) => VF.isIncluded(i, t);
  }
  getFrustumOnCollide(t) {
    return (i) => VF.collides(i, t);
  }
  getFrustumPlanes(t, i) {
    const n = [];
    for (const s of t.planes) n.push(s);
    if (i) for (const s of i) n.push(s);
    return n;
  }
  savePoint(t, i) {
    const n = this.getPoint(t);
    i.push(n.data);
  }
}
class qqe {
  constructor(t) {
    De(this, "_boxes"), De(this, "_total", new Ge()), De(this, "_change", new Ge()), De(this, "_average", new Ge()), De(this, "_tempCenterVector", new Ge()), De(this, "_tempVectors", { x: new Ge(), y: new Ge(), z: new Ge() }), this._boxes = t;
  }
  sort(t, i, n) {
    this.average(this._average, t, i, n), this.getDataToTotal(i, n, t);
    let s = this.anySort(i, n, t);
    return s = this.adjust(n, i, s), Math.round(s);
  }
  anySort(t, i, n) {
    return this._total.x > this._total.y ? this._total.x > this._total.z ? this.sortDim("x", this._average.x, t, i, n) : this.sortDim("z", this._average.z, t, i, n) : this._total.y > this._total.z ? this.sortDim("y", this._average.y, t, i, n) : this.sortDim("z", this._average.z, t, i, n);
  }
  getDataToTotal(t, i, n) {
    this._total.set(0, 0, 0);
    for (let s = t; s < i; s++) {
      this._boxes.get(n[s]).getCenter(this._change).sub(this._average);
      const o = this._change.multiply(this._change);
      this._total.add(o);
    }
  }
  sortDim(t, i, n, s, o) {
    let r = n;
    for (let l = n; l < s; l++)
      this.getValue(o, l, t) > i && (this.exchange(l, r, o), r++);
    return r;
  }
  exchange(t, i, n) {
    const s = n[t];
    n[t] = n[i], n[i] = s;
  }
  getValue(t, i, n) {
    const s = this.getBox(t, i), o = this._tempVectors[n];
    return s.getCenter(o)[n];
  }
  average(t, i, n, s) {
    const o = this.getBox(i, n);
    return o.getCenter(t), this.aggregate(n, s, i, o, t), t.divideScalar(s - n);
  }
  aggregate(t, i, n, s, o) {
    for (let r = t + 1; r < i; r++) {
      const l = n[r], c = this._boxes.get(l).getCenter(this._tempCenterVector);
      o.add(c);
    }
  }
  adjust(t, i, n) {
    const s = (i + t) / 2, o = (t - i) / 3;
    return (n <= i + o || n >= t - 1 - o) && (n = s), n;
  }
  getBox(t, i) {
    const n = t[i];
    return this._boxes.get(n);
  }
}
class $qe {
  constructor(t, i, n) {
    De(this, "_data"), De(this, "_compressor"), De(this, "_boxes"), De(this, "_sorter"), this._data = n, this._compressor = i, this._boxes = t, this._sorter = new qqe(t);
  }
  make(t, i, n = 0, s = 0, o = 0, r = 0) {
    const l = n - s;
    return l === 1 ? this.makePoint(t, s, i, r) : l === 2 ? this.makeGroup3(r, t, s, i) : this.makeGroup(o, t, s, n, r, i);
  }
  makeGroup3(t, i, n, s) {
    const o = this.makeBox(t + 1, i, n), r = this.makeBox(t + 2, i, n + 1);
    return s.combine(o, r), this.newGroup(t, 3, s), 3;
  }
  makeGroup(t, i, n, s, o, r) {
    const l = this._data.limits.primary[t], c = this._data.limits.secondary[t], h = this._sorter.sort(i, n, s), I = this.make(i, l, h, n, t + 1, o + 1), p = o + I + 1, y = this.make(i, c, s, h, t + 1, p);
    r.combine(l, c);
    const m = I + y + 1;
    return this.newGroup(o, m, r), m;
  }
  makeBox(t, i, n) {
    const s = this._data.points[t].box, o = i[n], r = this._boxes.get(o);
    return this._compressor.deflate(r, s), this.set(t, o), s;
  }
  makePoint(t, i, n, s) {
    const o = this._boxes.get(t[i]);
    return this._compressor.deflate(o, n), this.newPoint(s, t[i], n), 1;
  }
  newGroup(t, i, n) {
    this.get(t).transform(i, n, !1);
  }
  get(t) {
    return this._data.points[t];
  }
  newPoint(t, i, n) {
    this.get(t).transform(i, n, !0);
  }
  set(t, i) {
    this.get(t).data = i;
  }
}
const Fwe = class Cre {
  constructor(t) {
    De(this, "_compressor"), De(this, "_collider"), De(this, "_maker"), De(this, "_data"), De(this, "_boxes"), this._boxes = t, this._compressor = new Wqe(t), this._data = this.getData(), this._collider = new Yqe(this._compressor, this._data), this._maker = new $qe(this._boxes, this._compressor, this._data), this.initData();
  }
  collideFrustum(t, i, n = !1) {
    return this._collider.frustumCollide(t, i, n);
  }
  collideRay(t, i) {
    return this._collider.rayCollide(t, i);
  }
  setupLimits() {
    for (let t = 0; t < Cre._limitThreshold; t++) this._data.limits.primary.push(new Nre()), this._data.limits.secondary.push(new Nre());
  }
  getPointBuffer() {
    const t = this._boxes.getCount(), i = new Uint32Array(t);
    for (let n = 0; n < i.length; n++) i[n] = n;
    return i;
  }
  getPointsAmount(t) {
    return 2 * t.length - 1;
  }
  initData() {
    const t = this.getPointBuffer(), i = this.getPointsAmount(t), n = i * Cre._boxSize, s = new Float64Array(n);
    for (let r = 0; r < i; r++) {
      const l = r * Cre._boxSize, c = new jqe(l, s);
      this._data.points.push(c);
    }
    this.setupLimits();
    const o = new Nre();
    this._maker.make(t, o, t.length);
  }
  getData() {
    return { points: [], limits: { primary: [], secondary: [] } };
  }
};
De(Fwe, "_boxSize", 6), De(Fwe, "_limitThreshold", 32);
class Kqe {
  constructor(t) {
    De(this, "onModelLoaded", new Bp()), De(this, "models"), De(this, "settings", { autoCoordinate: !0, maxUpdateRate: 100, graphicsQuality: 0, forceUpdateRate: 200, forceUpdateBuffer: 200 }), De(this, "baseCoordinates", null), De(this, "editor"), De(this, "_connection"), De(this, "_isDisposed", !1), De(this, "_autoRedrawInterval", null), De(this, "_lastUpdate", 0);
    const i = this.newRequestEvent(), n = this.newUpdateEvent();
    this._connection = new rqe(i, t), this.editor = new ZYe(this, this._connection), this.models = new iqe(n), this.models.list.onItemDeleted.add((() => {
      this.models.list.size === 0 && (this.baseCoordinates = null);
    }));
  }
  async load(t, i) {
    const n = new XSe(i.modelId, this.models, this._connection, this.editor);
    i.userData && (n.object.userData = i.userData), n.frozen = !0, n.graphicsQuality = this.settings.graphicsQuality;
    try {
      if (this.models.list.set(n.modelId, n), await n._setup(t, i.raw, i.virtualModelConfig), this.settings.autoCoordinate) {
        const o = await n.getCoordinates();
        if (this.baseCoordinates === null) this.baseCoordinates = o;
        else {
          const [r, l, c] = o, [h, I, p] = this.baseCoordinates, y = new Ge(h - r, I - l, p - c);
          n.object.position.add(y);
        }
      }
    } catch (o) {
      throw this.models.list.delete(n.modelId), o;
    }
    const { camera: s } = i;
    return s && n.useCamera(s), n.frozen = !1, this.onModelLoaded.trigger(n), n;
  }
  async dispose() {
    this._isDisposed = !0;
    const t = Array.from(this.models.list.values()), i = [];
    for (const n of t) i.push(n.dispose());
    await Promise.all(i), this.onModelLoaded.reset();
  }
  async disposeModel(t) {
    const i = this.models.list.get(t);
    i && await i.dispose();
  }
  async update(t = !1) {
    if (this._isDisposed) return;
    const i = performance.now();
    if (i - this._lastUpdate < this.settings.maxUpdateRate) return;
    this._lastUpdate = i;
    const n = [];
    for (const s of this.models.list.values()) n.push(s._refreshView());
    await Promise.all(n), t ? await this.models.forceUpdateFinish(this.settings.forceUpdateRate, this.settings.forceUpdateBuffer) : this.models.update();
  }
  async manageRequest(t) {
    const i = this.models.list.get(t.modelId);
    i && await i.handleRequest(t);
  }
  newUpdateEvent() {
    return () => {
      this._autoRedrawInterval && clearTimeout(this._autoRedrawInterval);
      const t = this.settings.maxUpdateRate + 1;
      this._autoRedrawInterval = setTimeout((() => {
        this.update();
      }), t);
    };
  }
  newRequestEvent() {
    return (t) => {
      this.manageRequest(t);
    };
  }
}
class Zqe {
  constructor(t, i) {
    De(this, "_lengthUnitsFactor", 1), De(this, "_attributesOffsets", []), De(this, "_relationsMap", {}), De(this, "_guids", []), De(this, "_guidsItems", []), De(this, "_uniqueAttributes", /* @__PURE__ */ new Set()), De(this, "_uniqueRelNames", /* @__PURE__ */ new Set()), De(this, "_maxLocalID", 0), De(this, "_ifcApi", null), De(this, "wasm", { path: "/node_modules/web-ifc/", absolute: !1 }), De(this, "webIfcSettings", {}), De(this, "expressIDs", []), De(this, "classes", []), this._serializer = t, this._builder = i;
  }
  async getIfcApi() {
    if (!this._ifcApi) {
      const t = new jW();
      t.SetWasmPath(this.wasm.path, this.wasm.absolute), await t.Init(), t.SetLogLevel(Mie.LOG_LEVEL_OFF), this._ifcApi = t;
    }
    return this._ifcApi;
  }
  async getSchema(t = 0) {
    const i = (await this.getIfcApi()).GetModelSchema(t);
    if (!i) throw new Error("Fragments: IFC Schema not found");
    return i.startsWith("IFC2X3") ? "IFC2X3" : i.startsWith("IFC4") && i.replace("IFC4", "") === "" ? "IFC4" : i.startsWith("IFC4X") ? "IFC4X3" : i;
  }
  async process(t) {
    var i, n, s;
    const o = await this.getIfcApi();
    if (this._maxLocalID = t.maxLocalID + 1, t.readFromCallback) o.OpenModelFromCallback(t.readCallback, this.webIfcSettings);
    else {
      if (!t.bytes) throw new Error("Fragments: No data provided");
      await o.OpenModel(t.bytes, this.webIfcSettings);
    }
    this._serializer.replaceStoreyElevation && await this.setLengthUnitsFactor();
    const r = o.GetAllTypesOfModel(0).map(((Oe) => Oe.typeID)), l = await this.getSchema();
    if (!Qje[l]) throw new Error("Fragments: Model schema not recognized.");
    const c = t.geometryProcessedLocalIDs;
    await this.processItems(c);
    const h = new Set(c);
    (i = t.progressCallback) == null || i.call(t, 0.6, { process: "attributes", state: "start", entitiesProcessed: c.length });
    const I = /* @__PURE__ */ new Set([...this._serializer.classes.abstract, ...this._serializer.classes.elements]), p = r.filter(((Oe) => I.has(Oe))), y = 0.15 / p.length;
    for (const [Oe, pe] of p.entries()) {
      const je = o.GetLineIDsWithType(0, pe);
      if (je.size() === 0) continue;
      const Ve = [];
      for (let $e = 0; $e < je.size(); $e++) {
        const vt = je.get($e);
        h.has(vt) || Ve.push(vt);
      }
      Ve.length !== 0 && (await this.processItems(Ve), (n = t.progressCallback) == null || n.call(t, y * (Oe + 1) + 0.6, { process: "attributes", state: Oe + 1 === p.length ? "finish" : "inProgress", class: Oz[pe], entitiesProcessed: Ve.length }));
    }
    const m = t.alignments;
    m && this.processCustomItems(m, pYe);
    const A = t.grids;
    A && this.processCustomItems(A, mYe);
    const C = /* @__PURE__ */ new Set([...this._serializer.relations.keys()]), O = r.filter(((Oe) => C.has(Oe))), R = 0.15 / O.length;
    for (const [Oe, pe] of O.entries()) {
      const je = Oe === 0 ? "start" : Oe + 1 === O.length ? "finish" : "inProgress";
      await this.processRelations([pe]), (s = t.progressCallback) == null || s.call(t, R * (Oe + 1) + 0.75, { process: "relations", state: je, class: Oz[pe] });
    }
    const { relIndicesVector: F, relsVector: L } = this.getRelationsVector(), { guidsVector: P, guidsItemsVector: z } = this.getGuidsVector(), W = await this.getMetadataOffset(), re = this.getAttributesVector(), ce = this.getUniqueAttributesVector(), te = this.getRelNamesVector(), ee = Cn.createLocalIdsVector(this._builder, this.expressIDs), Ne = this.getCategoriesVector(), Ae = await this.getSpatialStructureOffset();
    return this.clean(), { relIndicesVector: F, relsVector: L, guidsVector: P, guidsItemsVector: z, metadataOffset: W, attributesVector: re, localIdsVector: ee, categoriesVector: Ne, spatialStrutureOffset: Ae, uniqueAttributesVector: ce, relNamesVector: te, newMaxLocalID: this._maxLocalID };
  }
  async processItems(t) {
    const i = await this.getIfcApi();
    for (let n = 0; n < t.length; n++) {
      const s = t[n];
      try {
        const o = i.GetLine(0, s);
        if (!o) continue;
        const r = Oz[o.type];
        this.classes.push(r), this.expressIDs.push(s), await this.serializeAttributes(s, o);
      } catch (o) {
        console.log(`Problem reading properties for ${s}. If many items are problematic, it may be a problem with the category you are trying to process. You can remove it and try again.`), console.log(o), await new Promise(((r) => {
          setTimeout(r, 100);
        }));
        continue;
      }
    }
  }
  async processCustomItems(t, i) {
    for (const n of t) {
      const s = this._maxLocalID++, o = JSON.stringify(n), r = "data", l = "UNDEFINED", c = JSON.stringify([r, o, l]), h = this._builder.createSharedString(c);
      this._serializer.includeUniqueAttributes && this._uniqueAttributes.add(c);
      const I = Jy.createDataVector(this._builder, [h]), p = Jy.createAttribute(this._builder, I);
      this.classes.push(i), this.expressIDs.push(s), this._attributesOffsets.push(p);
    }
  }
  addRelation(t, i, n) {
    this._relationsMap[t] || (this._relationsMap[t] = {}), this._relationsMap[t][i] || (this._relationsMap[t][i] = []);
    for (const s of n) this._relationsMap[t][i].push(s);
    this._serializer.includeRelationNames && this._uniqueRelNames.add(i);
  }
  async getAbsoluteElevation(t, i) {
    const n = await this.getIfcApi(), s = n.GetLine(0, t);
    let o, r;
    s != null && s.RelativePlacement && "value" in s.RelativePlacement && typeof s.RelativePlacement.value == "number" && (o = n.GetLine(0, s.RelativePlacement.value)), o != null && o.Location && "value" in o.Location && typeof o.Location.value == "number" && (r = n.GetLine(0, o.Location.value)), r != null && r.Coordinates && Array.isArray(r.Coordinates) && "value" in r.Coordinates[2] && typeof r.Coordinates[2].value == "number" && (i.value += r.Coordinates[2].value), s != null && s.PlacementRelTo && "value" in s.PlacementRelTo && typeof s.PlacementRelTo.value == "number" && await this.getAbsoluteElevation(s.PlacementRelTo.value, i);
  }
  async setLengthUnitsFactor() {
    const t = await this.getIfcApi();
    this._lengthUnitsFactor = vIe.getUnitsFactor(t);
  }
  async serializeAttributes(t, i) {
    const n = [];
    let s = null;
    if (this._serializer.replaceSiteElevation && i.type && typeof i.type == "number" && i.type === a0 && i.ObjectPlacement && "value" in i.ObjectPlacement && typeof i.ObjectPlacement.value == "number") {
      const l = { value: 0 };
      await this.getAbsoluteElevation(i.ObjectPlacement.value, l), i.RefElevation = new a.IfcLengthMeasure(l.value * this._lengthUnitsFactor);
    }
    if (this._serializer.replaceStoreyElevation && i.type && typeof i.type == "number" && i.type === u0 && i.ObjectPlacement && "value" in i.ObjectPlacement && typeof i.ObjectPlacement.value == "number") {
      const l = { value: 0 };
      await this.getAbsoluteElevation(i.ObjectPlacement.value, l), i.Elevation = new a.IfcLengthMeasure(l.value * this._lengthUnitsFactor);
    }
    for (const [l, c] of Object.entries(i)) {
      if (typeof c == "number" || typeof c == "boolean" || this._serializer.attributesToExclude.has(l) || c == null) continue;
      if (Array.isArray(c)) {
        const p = c.filter(((m) => m.type !== 5));
        if (p.length > 0) {
          const m = [l, p.map(((R) => R.value))], A = "name" in p[0] && p[0].name ? p[0].name : p[0].constructor.name.toUpperCase();
          m.push(A !== "OBJECT" ? A : "UNDEFINED");
          const C = JSON.stringify(m), O = this._builder.createSharedString(C);
          n.push(O);
        }
        const y = c.filter(((m) => m.type === 5)).map(((m) => m.value));
        this.addRelation(t, l, y);
        continue;
      }
      const { value: h, type: I } = c;
      if (I === 5) {
        if (typeof h != "number") continue;
        this.addRelation(t, l, [h]);
      } else {
        if (l === "GlobalId" && typeof h == "string") {
          s = h;
          continue;
        }
        const p = [l, h], y = "name" in c && c.name ? c.name : c.constructor.name.toUpperCase();
        p.push(y !== "OBJECT" ? y : "UNDEFINED");
        const m = JSON.stringify(p), A = this._builder.createSharedString(m);
        n.push(A), this._serializer.includeUniqueAttributes && this._uniqueAttributes.add(m);
      }
    }
    const o = Jy.createDataVector(this._builder, n), r = Jy.createAttribute(this._builder, o);
    this._attributesOffsets.push(r), s && (this._guids.push(s), this._guidsItems.push(t));
  }
  getAttributesVector() {
    return Cn.createAttributesVector(this._builder, this._attributesOffsets);
  }
  getUniqueAttributesVector() {
    const t = [];
    for (const i of this._uniqueAttributes) {
      const n = this._builder.createSharedString(i);
      t.push(n);
    }
    return Cn.createUniqueAttributesVector(this._builder, t);
  }
  getRelNamesVector() {
    const t = [];
    for (const i of this._uniqueRelNames) {
      const n = this._builder.createSharedString(i);
      t.push(n);
    }
    return Cn.createRelationNamesVector(this._builder, t);
  }
  getGuidsVector() {
    const t = [];
    for (const i of this._guids) {
      const n = this._builder.createString(i);
      t.push(n);
    }
    return { guidsVector: Cn.createGuidsVector(this._builder, t), guidsItemsVector: Cn.createGuidsItemsVector(this._builder, this._guidsItems) };
  }
  async processRelations(t) {
    const i = await this.getIfcApi();
    for (const n of t) {
      const s = this._serializer.relations.get(n);
      if (!s) continue;
      const { forRelating: o, forRelated: r } = s, l = i.GetLineIDsWithType(0, n);
      if (l.size() !== 0) for (let c = 0; c < l.size(); c++) {
        const h = l.get(c);
        try {
          const I = i.GetLine(0, h);
          if (!I) continue;
          const p = Object.keys(I), y = p.find(((R) => R.startsWith("Relating"))), m = p.find(((R) => R.startsWith("Related")));
          if (!y || !m) continue;
          const A = I[y].value, C = I[m];
          let O = [];
          O = Array.isArray(C) ? C.map((({ value: R }) => R)) : [C.value], this.addRelation(A, o, O);
          for (const R of O) this.addRelation(R, r, [A]);
        } catch (I) {
          console.log(`Problem reading relations for ${h}`), console.log(I), await new Promise(((p) => {
            setTimeout(p, 100);
          }));
          continue;
        }
      }
    }
  }
  getRelationsVector(t = !1) {
    const i = [], n = [];
    for (const [o, r] of Object.entries(this._relationsMap)) {
      if (t && !this.expressIDs.includes(Number(o))) continue;
      const l = [];
      for (const [I, p] of Object.entries(r)) {
        let y = p;
        if (t && (y = p.filter(((C) => this.expressIDs.includes(C))), y.length === 0)) continue;
        const m = JSON.stringify([I, ...y]), A = this._builder.createSharedString(m);
        l.push(A);
      }
      if (t && l.length === 0) continue;
      n.push(Number(o));
      const c = Jv.createDataVector(this._builder, l), h = Jv.createRelation(this._builder, c);
      i.push(h);
    }
    const s = Cn.createRelationsVector(this._builder, i);
    return { relIndicesVector: Cn.createRelationsItemsVector(this._builder, n), relsVector: s };
  }
  getCategoriesVector() {
    const t = this.classes.map(((i) => this._builder.createSharedString(i)));
    return Cn.createCategoriesVector(this._builder, t);
  }
  async getMetadataOffset() {
    const t = await this.getIfcApi(), i = t.GetModelSchema(0), n = t.GetHeaderLine(0, Ame), s = t.GetHeaderLine(0, vme), o = [];
    this.getMetadataRecursively(n.arguments, o);
    const r = [];
    this.getMetadataRecursively(s.arguments, r);
    const l = { schema: i, names: o, descriptions: r };
    return this._builder.createString(JSON.stringify(l));
  }
  getMetadataRecursively(t, i) {
    for (const n of t) n != null && (Array.isArray(n) && this.getMetadataRecursively(n, i), "value" in n && typeof n.value == "string" && i.push(n.value));
  }
  getEntityDecomposition(t, i) {
    var n;
    const s = [];
    for (const r of i) {
      const l = (n = this._relationsMap[t]) == null ? void 0 : n[r];
      if (!l) continue;
      const c = {};
      for (const h of l) {
        const I = this.expressIDs.indexOf(h);
        if (I === -1) continue;
        const p = this.classes[I];
        p && (c[p] || (c[p] = []), c[p].push(h));
      }
      for (const h in c) {
        const I = c[h].map(((A) => this.getEntityDecomposition(A, i))), p = lo.createChildrenVector(this._builder, I), y = this._builder.createSharedString(h);
        lo.startSpatialStructure(this._builder), lo.addCategory(this._builder, y), lo.addChildren(this._builder, p);
        const m = lo.endSpatialStructure(this._builder);
        s.push(m);
      }
    }
    const o = lo.createChildrenVector(this._builder, s);
    return lo.startSpatialStructure(this._builder), lo.addLocalId(this._builder, t), lo.addChildren(this._builder, o), lo.endSpatialStructure(this._builder);
  }
  async getSpatialStructureOffset() {
    const t = await this.getIfcApi(), i = Yg, n = [...t.GetLineIDsWithType(0, i)].map(((r) => this.getEntityDecomposition(r, ["IsDecomposedBy", "ContainsElements"]))), s = this._builder.createSharedString("IFCPROJECT"), o = lo.createChildrenVector(this._builder, n);
    return lo.startSpatialStructure(this._builder), lo.addCategory(this._builder, s), lo.addChildren(this._builder, o), lo.endSpatialStructure(this._builder);
  }
  clean() {
    var t;
    (t = this._ifcApi) == null || t.Dispose(), this._ifcApi = null, this._guids = [], this._guidsItems = [], this._attributesOffsets = [], this._relationsMap = {}, this._uniqueAttributes.clear(), this._uniqueRelNames.clear(), this.expressIDs = [], this.classes = [];
  }
}
class Qqe {
  read(t) {
    try {
      const i = t.GetAllAlignments(0), n = [];
      for (const s of i) {
        const o = { absolute: [], horizontal: [], vertical: [] };
        n.push(o);
        let r = 0;
        for (let l = 0; l < s.horizontal.length; l++) {
          const c = s.curve3D[0].points, h = s.horizontal[l], I = [], p = [], y = this.getCurveType(h.data[1]), m = [], A = [];
          for (const C of h.points) {
            const { x: O, y: R, z: F } = c[r++];
            m.push([O, R, F]), A.push([C.x, C.y]);
          }
          for (const [C, O, R] of m) I.push(C, O, R);
          for (const [C, O] of A) p.push(C, 0, -O);
          o.absolute.push({ points: I, type: y }), o.horizontal.push({ points: p, type: y });
        }
        for (let l = 0; l < s.vertical.length; l++) {
          const c = s.vertical[l], h = [], I = this.getCurveType(c.data[1]), p = [];
          for (const y of c.points) p.push([y.x, y.y]);
          for (const [y, m] of p) h.push(y, m, 0);
          o.vertical.push({ points: h, type: I });
        }
      }
      return n;
    } catch (i) {
      return console.error(i), [];
    }
  }
  getCurveType(t) {
    if (t.includes("CIRCULARARC")) return aN.ELLIPSE_ARC;
    if (t.includes("LINE") || t.includes("GRADIENT")) return aN.LINES;
    if (t.includes("CLOTHOID")) return aN.CLOTHOID;
    if (t.includes("PARABOLICARC")) return aN.PARABOLA;
    throw new Error(`Fragments: Unknown curve type: ${t}`);
  }
}
class Jqe {
  read(t) {
    try {
      const i = [], n = t.GetCoordinationMatrix(0), s = new Ln();
      s.fromArray(n);
      const o = vIe.getUnitsFactor(t), r = t.GetLineIDsWithType(0, gu), l = r.size();
      for (let c = 0; c < l; c++) {
        const h = r.get(c), I = t.GetLine(0, h), p = vIe.getAbsolutePlacement(t, I, o);
        p.premultiply(s);
        const y = { id: h, transform: p.elements, uAxes: [], vAxes: [], wAxes: [] };
        i.push(y), this.getGridAxes(I, t, o, "UAxes", "uAxes", y), this.getGridAxes(I, t, o, "VAxes", "vAxes", y), this.getGridAxes(I, t, o, "WAxes", "wAxes", y);
      }
      return i;
    } catch (i) {
      return console.error(i), [];
    }
  }
  getGridAxes(t, i, n, s, o, r) {
    if (t[s]) for (const l of t[s]) {
      const c = i.GetLine(0, l.value), h = c.AxisCurve.value, I = i.GetLine(0, h), p = { tag: c.AxisTag.value, curve: [] };
      if (!I.Points) continue;
      const y = I.Points.value;
      if (!y) continue;
      const m = i.GetLine(0, y);
      if (m.CoordList) for (const A of m.CoordList) for (const C of A) {
        const O = C.value * n;
        p.curve.push(O);
      }
      r[o].push(p);
    }
  }
}
class Xqe {
  constructor(t) {
    De(this, "_ifcAPI", null), De(this, "wasm", { path: "../../../../node_modules/web-ifc/", absolute: !1 }), De(this, "webIfcSettings", {}), De(this, "_tempObject1", new wu()), De(this, "_tempObject2", new wu()), De(this, "_tempMatrix1", new Ln()), De(this, "_previousGeometries", /* @__PURE__ */ new Map()), De(this, "_previousGeometriesIDs", /* @__PURE__ */ new Map()), De(this, "_previousGeometriesScales", /* @__PURE__ */ new Map()), De(this, "_previousLocalTransforms", /* @__PURE__ */ new Map()), De(this, "_problematicGeometries", /* @__PURE__ */ new Set()), De(this, "_problematicGeometriesHashes", /* @__PURE__ */ new Set()), De(this, "_coordinatesInitialized", !1), De(this, "_civilReader", new Qqe()), De(this, "_gridReader", new Jqe()), De(this, "_nextId", 0), De(this, "_rawCategories", /* @__PURE__ */ new Set([Rb, vb])), De(this, "scene", null), De(this, "isolatedMeshes", null), De(this, "onElementLoaded", (() => {
    })), De(this, "onGeometryLoaded", (() => {
    })), De(this, "onLocalTransformLoaded", (() => {
    })), De(this, "onNextIdFound", (() => {
    })), De(this, "onCoordinatesLoaded", (() => {
    })), De(this, "onAlignmentsLoaded", (() => {
    })), De(this, "onGridsLoaded", (() => {
    })), this._serializer = t;
  }
  async load(t) {
    var i, n, s;
    (i = t.progressCallback) == null || i.call(t, 0, { process: "conversion", state: "start" }), this._previousGeometriesIDs.clear(), this._ifcAPI = new jW(), this._ifcAPI.SetWasmPath(this.wasm.path, this.wasm.absolute), await this._ifcAPI.Init();
    let o = 0;
    if (t.readFromCallback && t.readCallback) o = this._ifcAPI.OpenModelFromCallback(t.readCallback, this.webIfcSettings);
    else {
      if (!t.bytes) throw new Error("Fragments: No data provided");
      o = await this._ifcAPI.OpenModel(t.bytes, this.webIfcSettings);
    }
    this._ifcAPI.SetLogLevel(Mie.LOG_LEVEL_OFF), this._nextId = this._ifcAPI.GetMaxExpressID(o) + 1, this.onLocalTransformLoaded({ id: 0, data: [0, 0, 0, 1, 0, 0, 0, 1, 0] });
    const r = new Ge();
    let l = 0;
    const c = (p) => {
      if (this._ifcAPI === null) throw new Error("Fragments: IfcAPI not initialized");
      if (!this._coordinatesInitialized) {
        const Ne = this._ifcAPI.GetCoordinationMatrix(o);
        this._tempMatrix1.fromArray(Ne);
        const Ae = this.decompose(this._tempMatrix1);
        this.onCoordinatesLoaded(Ae), this._coordinatesInitialized = !0;
      }
      const y = this._ifcAPI.GetLine(0, p.expressID), m = { id: p.expressID, type: y.type, guid: y.GlobalId.value, geometries: [] }, A = p.geometries.size(), C = p.geometries.get(0).flatTransformation, { transformWithoutScale: O } = this.removeScale(C), R = this._serializer.distanceThreshold;
      if (R !== null && (r.set(0, 0, 0), r.applyMatrix4(O), r.x > R || r.y > R || r.z > R)) return void console.log(`Fragments: Object ${m.id} is more than ${R} meters away from the origin and will be skipped.`);
      for (let Ne = 0; Ne < A; Ne++) m.type === Ra ? this.loadCircleExtrusionGeometry(o, m, p, Ne, O.elements) : this.loadShellGeometry(o, m, p, Ne, O.elements, l);
      const { dxx: F, dxy: L, dxz: P, dyx: z, dyy: W, dyz: re, px: ce, py: te, pz: ee } = this.decompose(O);
      m.geometries.length > 0 && this.onElementLoaded({ element: m, position: [ce, te, ee], xDirection: [F, L, P], yDirection: [z, W, re] });
    };
    if ((n = this.isolatedMeshes) != null && n.size) this._ifcAPI.StreamMeshes(o, Array.from(this.isolatedMeshes), c);
    else {
      const p = this._ifcAPI.GetAllTypesOfModel(o).map(((m) => m.typeID)).filter(((m) => this._serializer.classes.elements.has(m)));
      p.includes(Zp) && (p.splice(p.indexOf(Zp), 1), p.push(Zp));
      const y = 0.5 / p.length;
      for (const [m, A] of p.entries()) {
        l = A;
        const C = m === 0 ? "start" : m + 1 === p.length ? "finish" : "inProgress", O = this._ifcAPI.GetLineIDsWithType(o, A), R = [];
        for (let F = 0; F < O.size(); F++) R.push(O.get(F));
        R.length > 0 && (this._ifcAPI.StreamMeshes(o, R, c), (s = t.progressCallback) == null || s.call(t, y * (m + 1), { process: "geometries", state: C, class: Oz[A], entitiesProcessed: R.length }));
      }
    }
    const h = this._civilReader.read(this._ifcAPI);
    this.onAlignmentsLoaded(h);
    const I = this._gridReader.read(this._ifcAPI);
    this.onGridsLoaded(I), this.onNextIdFound(this._nextId), this._ifcAPI.Dispose(), this._ifcAPI = null, this._ifcAPI = new jW(), this._ifcAPI.SetWasmPath(this.wasm.path, this.wasm.absolute), await this._ifcAPI.Init(), this._previousGeometries.clear(), this._previousGeometriesIDs.clear(), this._previousGeometriesScales.clear(), this._nextId = 0, this._previousLocalTransforms.clear(), this._problematicGeometries.clear(), this._problematicGeometriesHashes.clear();
  }
  loadCircleExtrusionGeometry(t, i, n, s, o) {
    if (this._ifcAPI === null) throw new Error("Fragments: IfcAPI not initialized");
    const r = n.geometries.get(s), l = r.flatTransformation, { units: c } = this.removeScale(l), { x: h, y: I, z: p, w: y } = r.color, m = { id: r.geometryExpressID, color: [h, I, p, y], localTransformID: null };
    i.geometries.push(m);
    const { transformWithoutScale: A } = this.removeScale(r.flatTransformation);
    if (this._previousGeometriesIDs.has(m.id)) return this.getLocalTransform(o, A, m), void (m.id = this._previousGeometriesIDs.get(m.id));
    this.getLocalTransform(o, A, m);
    const C = this._ifcAPI.GetGeometry(t, m.id), O = C.GetSweptDiskSolid(), R = [], F = [], L = O.axis.size();
    for (let Ae = 0; Ae < L; Ae++) {
      const Oe = O.axis.get(Ae), pe = [];
      for (let Ve = 0; Ve < Oe.arcSegments.size(); Ve++) pe.push(Oe.arcSegments.get(Ve));
      R.push(pe);
      const je = [];
      for (let Ve = 0; Ve < Oe.points.size(); Ve++) {
        const $e = Oe.points.get(Ve);
        je.push({ x: $e.x * c.x, y: $e.y * c.y, z: $e.z * c.z });
      }
      F.push(je);
    }
    const P = [], z = [], W = [], re = [];
    for (let Ae = 0; Ae < F.length; Ae++) {
      const Oe = F[Ae], pe = R[Ae], je = Oe.length;
      for (let Ve = 0; Ve < je - 1; Ve++) {
        let $e = -1, vt = -1;
        for (let Rt = 0; Rt < pe.length; Rt += 2) if (pe[Rt] === Ve) {
          $e = Ve, vt = pe[Rt + 1];
          break;
        }
        if ($e === -1) {
          const Rt = [], ze = Oe[Ve], mt = Oe[Ve + 1], Et = ze.x, it = ze.y, Dt = ze.z, Ct = mt.x, Kt = mt.y, Zt = mt.z;
          P.push(W.length), Rt.push(Et, it, Dt, Ct, Kt, Zt), W.push(Rt), z.push(ec.WIRE);
        } else {
          const Rt = [], ze = $e, mt = Math.round(($e + vt) / 2), Et = vt, it = Oe[ze], Dt = Oe[mt], Ct = Oe[Et], Kt = this.computeCircleCurveProperties(it, Dt, Ct), Zt = it.x - Kt.center.x, Xt = it.y - Kt.center.y, gi = it.z - Kt.center.z;
          let Wt = Math.sqrt(Zt * Zt + Xt * Xt + gi * gi);
          Wt === 0 && (Wt = 1);
          const Di = Zt / Wt, ni = Xt / Wt, Ci = gi / Wt, Se = Dt.x - Kt.center.x, si = Dt.y - Kt.center.y, Mt = Dt.z - Kt.center.z;
          let ft = Math.sqrt(Se * Se + si * si + Mt * Mt);
          ft === 0 && (ft = 1);
          const rt = Se / ft, Tt = si / ft, jt = Mt / ft;
          let Jt = this.crossProduct({ x: Di, y: ni, z: Ci }, { x: rt, y: Tt, z: jt });
          Wt = Math.sqrt(Jt.x * Jt.x + Jt.y * Jt.y + Jt.z * Jt.z), Wt === 0 && (Wt = 1), Jt = { x: Jt.x / Wt, y: Jt.y / Wt, z: Jt.z / Wt }, P.push(re.length), Rt.push(Kt.center.x, Kt.center.y, Kt.center.z, Kt.radius, Kt.angle, Di, ni, Ci, Jt.x, Jt.y, Jt.z), re.push(Rt), z.push(ec.CIRCLE_CURVE), Ve = Et - 1;
        }
      }
    }
    const ce = this.getGeometryBuffers(t, r);
    if (ce === null) return console.log(`Fragments: Zero length geometry: ${m.id}`), i.geometries.pop(), void this._problematicGeometries.add(m.id);
    const { position: te } = ce;
    for (let Ae = 0; Ae < te.length - 2; Ae += 3) te[Ae] *= c.x, te[Ae + 1] *= c.y, te[Ae + 2] *= c.z;
    const ee = _o.getAABB(te), Ne = O.profileRadius * c.x;
    this._previousGeometriesIDs.set(m.id, m.id), this.onGeometryLoaded({ id: m.id, geometry: { type: Mr.CIRCLE_EXTRUSION, indicesArray: P, typesArray: z, segments: W, circleCurveData: re, radius: Ne, bbox: ee } }), C.delete();
  }
  loadShellGeometry(t, i, n, s, o, r) {
    if (this._ifcAPI === null) throw new Error("Fragments: IfcAPI not initialized");
    const l = n.geometries.get(s), c = l.flatTransformation, { units: h } = this.removeScale(c);
    if (this._problematicGeometries.has(l.geometryExpressID)) return void console.log(`Fragments: Problematic geometry: ${l.geometryExpressID}`);
    const { x: I, y: p, z: y } = l.color;
    let m = l.color.w;
    this._serializer.geometryProcessSettings.forceTransparentSpaces && r === rh && m === 1 && (m = 0.5);
    const A = { id: l.geometryExpressID, color: [I, p, y, m], localTransformID: null };
    i.geometries.push(A);
    const { transformWithoutScale: C } = this.removeScale(l.flatTransformation);
    if (this._previousGeometriesIDs.has(A.id)) {
      const Ct = this.getScaleHash(h);
      if (this._previousGeometriesScales.get(A.id) === Ct) return this.getLocalTransform(o, C, A), void (A.id = this._previousGeometriesIDs.get(A.id));
      const Kt = this._nextId++;
      this._previousGeometriesScales.set(Kt, Ct), A.id = Kt;
    }
    const O = this.getGeometryBuffers(t, l);
    if (O === null) return console.log(`Fragments: Zero length geometry: ${A.id}`), i.geometries.pop(), void this._problematicGeometries.add(A.id);
    const { position: R, normals: F, index: L } = O;
    for (let Ct = 0; Ct < R.length - 2; Ct += 3) R[Ct] *= h.x, R[Ct + 1] *= h.y, R[Ct + 2] *= h.z;
    const P = R.length / 3, z = L.length / 3;
    let W = 0, re = 0;
    const ce = new wc(), te = new Ge(), ee = new Ge(), Ne = new Ge(), Ae = this.getVolume(L, R), Oe = new Ge();
    for (let Ct = 0; Ct < L.length - 2; Ct += 3) {
      const Kt = L[Ct], Zt = L[Ct + 1], Xt = L[Ct + 2];
      te.set(R[3 * Kt], R[3 * Kt + 1], R[3 * Kt + 2]), ee.set(R[3 * Zt], R[3 * Zt + 1], R[3 * Zt + 2]), Ne.set(R[3 * Xt], R[3 * Xt + 1], R[3 * Xt + 2]), Oe.add(te), Oe.add(ee), Oe.add(Ne), ce.set(te, ee, Ne);
      const gi = ce.getArea();
      gi > W && (W = gi), re += gi;
    }
    Oe.divideScalar(L.length), te.set(R[0], R[1], R[2]), ee.set(R[3], R[4], R[5]), Ne.set(R[6], R[7], R[8]);
    const pe = 1e4, je = _o.round(re, pe), Ve = _o.round(W, pe), $e = _o.round(Ae, pe), vt = _o.round(te.x, pe), Rt = _o.round(te.y, pe), ze = _o.round(te.z, pe), mt = `${P}-${z}-${je}-${Ve}-${$e}-${_o.round(Oe.x, pe)}-${_o.round(Oe.x, pe)}-${_o.round(Oe.x, pe)}-${vt}-${Rt}-${ze}`;
    if (this._problematicGeometriesHashes.has(mt)) return console.log(`Fragments: Problematic geometry: ${A.id}`), i.geometries.pop(), this._problematicGeometries.add(A.id), void this._problematicGeometriesHashes.add(mt);
    const Et = !this._previousGeometries.has(mt), it = A.id;
    if (Et) this._previousGeometries.set(mt, it), this._previousGeometriesIDs.set(it, it);
    else {
      const Ct = this._previousGeometries.get(mt);
      if (Ct === void 0) throw new Error("Fragments: Previous geometry not found");
      this._previousGeometriesIDs.set(it, Ct), A.id = Ct;
    }
    this.getLocalTransform(o, C, A);
    const Dt = this._rawCategories.has(i.type);
    if (Et) try {
      const Ct = _o.getShellData({ position: R, normals: F, index: L, raw: Dt, settings: this._serializer.geometryProcessSettings, category: r });
      this.onGeometryLoaded({ id: A.id, geometry: Ct });
    } catch {
      console.log(`Fragments: Problematic geometry: ${A.id}`), i.geometries.pop(), this._problematicGeometries.add(A.id), this._problematicGeometriesHashes.add(mt);
    }
  }
  getScaleHash(t) {
    return `${t.x}-${t.y}-${t.z}`;
  }
  getLocalTransform(t, i, n) {
    this._tempObject1.position.set(0, 0, 0), this._tempObject1.rotation.set(0, 0, 0), this._tempObject1.scale.set(1, 1, 1), this._tempObject1.updateMatrix(), this._tempMatrix1.fromArray(t), this._tempObject1.applyMatrix4(this._tempMatrix1), this._tempObject2.position.set(0, 0, 0), this._tempObject2.rotation.set(0, 0, 0), this._tempObject2.scale.set(1, 1, 1), this._tempObject2.updateMatrix(), this._tempObject2.applyMatrix4(i), this._tempObject1.attach(this._tempObject2);
    const { px: s, py: o, pz: r, dxx: l, dxy: c, dxz: h, dyx: I, dyy: p, dyz: y } = this.decompose(this._tempObject2.matrix);
    if (this._tempObject2.removeFromParent(), !(s === 0 && o === 0 && r === 0 && l === 1 && c === 0 && h === 0 && I === 0 && p === 1 && y === 0)) {
      const m = `${s}-${o}-${r}-${l}-${c}-${h}-${I}-${p}-${y}`, A = this._previousLocalTransforms.get(m);
      if (A) n.localTransformID = A.id;
      else {
        const C = { id: this._previousLocalTransforms.size + 1, data: [s, o, r, l, c, h, I, p, y] };
        this._previousLocalTransforms.set(m, C), n.localTransformID = C.id, this.onLocalTransformLoaded(C);
      }
    }
  }
  removeScale(t) {
    const i = new Ln().fromArray(t), n = new Ge(), s = new gI(), o = new Ge();
    i.decompose(n, s, o);
    const r = o, l = new Ln();
    return l.compose(n, s, new Ge(1, 1, 1)), { units: r, transformWithoutScale: l };
  }
  decompose(t) {
    return { dxx: _o.round(t.elements[0], 1e3), dxy: _o.round(t.elements[1], 1e3), dxz: _o.round(t.elements[2], 1e3), dyx: _o.round(t.elements[4], 1e5), dyy: _o.round(t.elements[5], 1e5), dyz: _o.round(t.elements[6], 1e5), dzx: _o.round(t.elements[8], 1e5), dzy: _o.round(t.elements[9], 1e5), dzz: _o.round(t.elements[10], 1e5), px: _o.round(t.elements[12], 1e5), py: _o.round(t.elements[13], 1e5), pz: _o.round(t.elements[14], 1e5) };
  }
  getVolume(t, i) {
    let n = 0;
    const s = new Ge(), o = new Ge(), r = new Ge();
    for (let l = 0; l < t.length - 2; l += 3) {
      const c = 3 * t[l], h = 3 * t[l + 1], I = 3 * t[l + 2];
      s.set(i[c], i[c + 1], i[c + 2]), o.set(i[h], i[h + 1], i[h + 2]), r.set(i[I], i[I + 1], i[I + 2]), n += this.getSignedVolumeOfTriangle(s, o, r);
    }
    return Math.abs(n);
  }
  getSignedVolumeOfTriangle(t, i, n) {
    return 1 / 6 * (-(n.x * i.y * t.z) + i.x * n.y * t.z + n.x * t.y * i.z - t.x * n.y * i.z - i.x * t.y * n.z + t.x * i.y * n.z);
  }
  getGeometryBuffers(t, i) {
    if (!this._ifcAPI) throw new Error("Fragments: IfcAPI not initialized");
    const n = this._ifcAPI.GetGeometry(t, i.geometryExpressID), s = this._ifcAPI.GetIndexArray(n.GetIndexData(), n.GetIndexDataSize()), o = this._ifcAPI.GetVertexArray(n.GetVertexData(), n.GetVertexDataSize());
    if (s.length === 0 || o.length === 0) return n.delete(), null;
    const r = new Float32Array(o.length / 2), l = new Float32Array(o.length / 2);
    for (let c = 0; c < o.length; c += 6) r[c / 2] = o[c], r[c / 2 + 1] = o[c + 1], r[c / 2 + 2] = o[c + 2], l[c / 2] = o[c + 3], l[c / 2 + 1] = o[c + 4], l[c / 2 + 2] = o[c + 5];
    return n.delete(), { position: r, normals: l, index: s };
  }
  crossProduct(t, i) {
    return { x: t.y * i.z - t.z * i.y, y: t.z * i.x - t.x * i.z, z: t.x * i.y - t.y * i.x };
  }
  computeCircleCurveProperties(t, i, n) {
    function s(C, O) {
      return { x: C.x - O.x, y: C.y - O.y, z: C.z - O.z };
    }
    function o(C) {
      return Math.sqrt(C.x * C.x + C.y * C.y + C.z * C.z);
    }
    const r = s(i, t), l = s(n, i), c = this.crossProduct(r, l), h = (function(C, O, R) {
      const F = O.x - C.x, L = O.y - C.y, P = O.z - C.z, z = R.x - C.x, W = R.y - C.y, re = R.z - C.z, ce = 0.5 * (F ** 2 + L ** 2 + P ** 2), te = 0.5 * (z ** 2 + W ** 2 + re ** 2), ee = F * W - L * z, Ne = L * re - P * W, Ae = P * z - F * re, Oe = ce * z - te * F, pe = ce * W - te * L, je = ce * re - te * P, Ve = ee ** 2 + Ne ** 2 + Ae ** 2;
      if (Ve === 0) throw new Error("Fragments: Points are collinear, no unique circle exists.");
      return { x: C.x + (ee * pe - Ae * je) / Ve, y: C.y + (Ne * je - ee * Oe) / Ve, z: C.z + (Ae * Oe - Ne * pe) / Ve };
    })(t, i, n), I = s(t, h), p = s(n, h), y = o(s(h, t)), m = s(t, h), A = o(m);
    return m.x /= A, m.y /= A, m.z /= A, { center: h, radius: y, normal: c, initialTangent: m, angle: 180 * Math.acos((I.x * p.x + I.y * p.y + I.z * p.z) / (o(I) * o(p))) / Math.PI };
  }
}
class e$e {
  constructor(t) {
    De(this, "wasm", { path: "../../../../node_modules/web-ifc/", absolute: !1 }), De(this, "webIfcSettings", {}), De(this, "_serializer"), this._serializer = t;
  }
  async process(t) {
    const { builder: i } = t;
    let n = 0;
    const s = [];
    let o = { dxx: 1, dxy: 0, dxz: 0, dyx: 0, dyy: 1, dyz: 0, px: 0, py: 0, pz: 0 };
    const r = [], l = [], c = [], h = [], I = [], p = /* @__PURE__ */ new Map(), y = /* @__PURE__ */ new Map(), m = /* @__PURE__ */ new Map(), A = new Xqe(this._serializer);
    A.wasm = this.wasm, A.webIfcSettings = this.webIfcSettings, A.onGeometryLoaded = (Wt) => {
      r.push(Wt);
    }, A.onElementLoaded = (Wt) => {
      h.push(Wt);
    }, A.onLocalTransformLoaded = (Wt) => {
      I.push(Wt);
    }, A.onCoordinatesLoaded = (Wt) => {
      o = Wt;
    }, A.onNextIdFound = (Wt) => {
      n = Wt;
    }, A.onAlignmentsLoaded = (Wt) => {
      for (const Di of Wt) l.push(Di);
    }, A.onGridsLoaded = (Wt) => {
      for (const Di of Wt) c.push(Di);
    }, await A.load(t);
    const C = [];
    let O = 0;
    $i.startGlobalTransformsVector(i, h.length);
    const R = [], F = /* @__PURE__ */ new Map(), L = [];
    for (let Wt = 0; Wt < h.length; Wt++) {
      const Di = h[h.length - 1 - Wt];
      C.push(O++);
      const { position: ni, xDirection: Ci, yDirection: Se } = Di, [si, Mt, ft] = ni, [rt, Tt, jt] = Ci, [Jt, $t, ht] = Se;
      s.push(h[Wt].element.id);
      const Me = h.length - 1 - Wt, gt = Di.element.type, yt = Oz[gt];
      F.has(yt) || F.set(yt, F.size), R.unshift(n++), M5.createTransform(i, si, Mt, ft, rt, Tt, jt, Jt, $t, ht), F.get(yt), L.unshift(Di.element.id), p.set(Di.element.id, Me);
    }
    const P = i.endVector(), z = [];
    for (let Wt = 0; Wt < r.length; Wt++) {
      const Di = r[Wt];
      if (Di.geometry.type !== Mr.SHELL) continue;
      const { points: ni, profiles: Ci, holes: Se, profilesFaceIds: si } = Di.geometry, Mt = ni.length > _o.ushortMaxValue, ft = Mt ? F0.BIG : F0.NONE;
      Fo.startPointsVector(i, ni.length);
      for (let wi = 0; wi < ni.length; wi++) {
        const [bi, Hi, Wi] = ni[ni.length - 1 - wi];
        Rf.createFloatVector(i, bi, Hi, Wi);
      }
      const rt = i.endVector(), Tt = [], jt = [], Jt = [], $t = [];
      for (const [, wi] of Ci) {
        if (Mt) {
          const Wi = Yp.createIndicesVector(i, wi), hi = Yp.createBigShellProfile(i, Wi);
          Jt.push(hi);
          continue;
        }
        const bi = qp.createIndicesVector(i, wi), Hi = qp.createShellProfile(i, bi);
        Tt.push(Hi);
      }
      const ht = Fo.createBigProfilesVector(i, Jt), Me = Fo.createProfilesVector(i, Tt);
      for (const [wi, bi] of Se) if (Mt) for (const Hi of bi) {
        const Wi = Gp.createIndicesVector(i, Hi), hi = Gp.createBigShellHole(i, Wi, wi);
        $t.push(hi);
      }
      else for (const Hi of bi) {
        const Wi = kp.createIndicesVector(i, Hi), hi = kp.createShellHole(i, Wi, wi);
        jt.push(hi);
      }
      const gt = Fo.createBigHolesVector(i, $t), yt = Fo.createHolesVector(i, jt), Ut = Fo.createProfilesFaceIdsVector(i, si), Ht = Fo.createShell(i, Me, yt, rt, ht, gt, ft, Ut);
      z.push(Ht);
    }
    const W = $i.createShellsVector(i, z), re = [];
    for (let Wt = 0; Wt < r.length; Wt++) {
      const Di = r[Wt];
      if (Di.geometry.type !== Mr.CIRCLE_EXTRUSION) continue;
      const ni = [], { radius: Ci, indicesArray: Se, typesArray: si, segments: Mt, circleCurveData: ft } = Di.geometry;
      Ds.startCircleCurvesVector(i, ft.length);
      for (let Ut = 0; Ut < ft.length; Ut++) {
        const [Ht, wi, bi, Hi, Wi, hi, Ji, Sn, nn, Yi, Pi] = ft[Ut];
        rY.createCircleCurve(i, Wi / 360 * 2 * Math.PI, Ht, wi, bi, Hi, nn, Yi, Pi, hi, Ji, Sn);
      }
      const rt = i.endVector();
      Ds.startWiresVector(i, Mt.length);
      for (let Ut = 0; Ut < Mt.length; Ut++) {
        const [Ht, wi, bi, Hi, Wi, hi] = Mt[Ut];
        Fie.createWire(i, Ht, wi, bi, Hi, Wi, hi);
      }
      const Tt = i.endVector(), jt = Ds.createOrderVector(i, Se), Jt = Ds.createPartsVector(i, si);
      Ds.startWireSetsVector(i, 0);
      const $t = i.endVector();
      Ds.startAxis(i), Ds.addCircleCurves(i, rt), Ds.addOrder(i, jt), Ds.addWires(i, Tt), Ds.addWireSets(i, $t), Ds.addParts(i, Jt);
      const ht = Ds.endAxis(i);
      ni.push(ht);
      const Me = pl.createAxesVector(i, ni), gt = pl.createRadiusVector(i, [Ci]);
      pl.startCircleExtrusion(i), pl.addAxes(i, Me), pl.addRadius(i, gt);
      const yt = pl.endCircleExtrusion(i);
      re.push(yt);
    }
    const ce = $i.createCircleExtrusionsVector(i, re), te = [];
    $i.startRepresentationsVector(i, r.length);
    const ee = /* @__PURE__ */ new Map();
    for (let Wt = 0; Wt < r.length; Wt++) {
      const Di = r.length - 1 - Wt, ni = r[Di].geometry.type;
      let Ci = ee.get(ni);
      Ci === void 0 && (Ci = -1), ee.set(ni, Ci + 1);
    }
    const Ne = new Ge(), Ae = new Ge();
    for (let Wt = 0; Wt < r.length; Wt++) {
      const Di = r.length - 1 - Wt, ni = r[Di], { bbox: Ci } = ni.geometry;
      y.set(ni.id, Di);
      const Se = ni.geometry.type, si = ee.get(Se);
      if (si === void 0) throw new Error("Fragments: Malformed geometry definition");
      ee.set(Se, si - 1), Ne.set(Ci.min.x, Ci.min.y, Ci.min.z), Ae.set(Ci.max.x, Ci.max.y, Ci.max.z), Ne.distanceTo(Ae) > 999999 && (console.log(`Infinity bounding box: ${ni.id}`), Ci.min.x = 0, Ci.min.y = 0, Ci.min.z = 0, Ci.max.x = 0.1, Ci.max.y = 0.1, Ci.max.z = 0.1), te.unshift(n++), iN.createRepresentation(i, si, Ci.min.x, Ci.min.y, Ci.min.z, Ci.max.x, Ci.max.y, Ci.max.z, ni.geometry.type);
    }
    const Oe = i.endVector();
    let pe = 0;
    for (const Wt of h) for (const Di of Wt.element.geometries) {
      const ni = Di.color.toString();
      if (!m.has(ni)) {
        const Ci = Di.color.map(((Se) => 255 * Se));
        m.set(ni, { id: pe++, color: Ci });
      }
    }
    $i.startMaterialsVector(i, m.size);
    const je = [], Ve = Array.from(m.keys());
    for (let Wt = 0; Wt < Ve.length; Wt++) {
      const Di = Ve[Ve.length - 1 - Wt], { color: ni } = m.get(Di), [Ci, Se, si, Mt] = ni;
      je.push(n++), Iz.createMaterial(i, Ci, Se, si, Mt, Dme.ONE, 0);
    }
    const $e = i.endVector();
    let vt = 0;
    for (const Wt of h) vt += Wt.element.geometries.length;
    $i.startSamplesVector(i, vt);
    const Rt = [];
    for (let Wt = 0; Wt < h.length; Wt++) {
      const Di = h[h.length - 1 - Wt], ni = p.get(Di.element.id), Ci = Di.element.geometries;
      for (let Se = 0; Se < Ci.length; Se++) {
        const si = Ci[Ci.length - Se - 1], Mt = y.get(si.id), ft = m.get(si.color.toString()).id, rt = si.localTransformID || 0;
        Rt.push(n++), lY.createSample(i, ni, ft, Mt, rt);
      }
    }
    const ze = i.endVector();
    $i.startLocalTransformsVector(i, I.length);
    const mt = [];
    for (let Wt = 0; Wt < I.length; Wt++) {
      const Di = I[I.length - 1 - Wt], [ni, Ci, Se, si, Mt, ft, rt, Tt, jt] = Di.data;
      mt.push(n++), M5.createTransform(i, ni, Ci, Se, si, Mt, ft, rt, Tt, jt);
    }
    const Et = i.endVector(), it = $i.createMeshesItemsVector(i, C), Dt = $i.createRepresentationIdsVector(i, te), Ct = $i.createSampleIdsVector(i, Rt), Kt = $i.createMaterialIdsVector(i, je), Zt = $i.createLocalTransformIdsVector(i, mt), Xt = $i.createGlobalTransformIdsVector(i, R), gi = M5.createTransform(i, o.px, o.py, o.pz, o.dxx, o.dxy, o.dxz, o.dyx, o.dyy, o.dyz);
    return $i.startMeshes(i), $i.addCoordinates(i, gi), $i.addGlobalTransforms(i, P), $i.addShells(i, W), $i.addRepresentations(i, Oe), $i.addSamples(i, ze), $i.addLocalTransforms(i, Et), $i.addMaterials(i, $e), $i.addCircleExtrusions(i, ce), $i.addMeshesItems(i, it), $i.addRepresentationIds(i, Dt), $i.addSampleIds(i, Ct), $i.addMaterialIds(i, Kt), $i.addLocalTransformIds(i, Zt), $i.addGlobalTransformIds(i, Xt), { modelMesh: $i.endMeshes(i), localIDs: s, maxLocalID: n, alignments: l, grids: c };
  }
}
const CZ = { base: /* @__PURE__ */ new Set([Yg, a0, l0, u0]), units: /* @__PURE__ */ new Set([fme, Oie, tSe, aSe, iSe]), materials: /* @__PURE__ */ new Set([oue, sSe, Nae, iY, sue, pL, nue, Cae, $P, bae]), properties: /* @__PURE__ */ new Set([Rl, jN, p4, C8, D8, N8, wle, b8, S8, A8]), elements: /* @__PURE__ */ new Set([Yg, a0, l0, u0, rh, Zp, Fm, G1, dI, iI, z1, jm, jp, w1, k1, oI, j0, b1, r0, X0, g1, Ng, mI, mC, uI, km, F1, x1, lh, Id, nI, G0, Z1, m1, sh, R1, J0, vC, Wm, Ra, pd, E1, U1, dd, H0, Q0, oh, wC, Q1, vg, th, A1, J1, p1, aI, Cg, W0, wI, j1, gd, d5, i0, v1, TC, Vp, nh, X1, Y0, V1, Ed, fI, cI, pI, fd, K0, O1, zm, ku, Hu, bg, V0, lI, zp, EI, pC, H1, n0, $0, $1, EC, eh, tI, gb, Hm, Dg, gC, md, Z0, _1, RC, q0, Ag, k0, T1, II, y1, eI, c5, ih, hd, cd, S1, L1, sI, D1, wd, rI, yI, B1, Gu, K1, P1, N1, Vm, Wp, C1, yC, hI, Y1, M1, W1, z0, yd, Gm, q1, gu, KU, X_, vb, Rb, Z_, Q_, ex, J_, IC, fC]) };
class t$e {
  constructor() {
    De(this, "_builder", null), De(this, "wasm", { path: "/node_modules/web-ifc/", absolute: !1 }), De(this, "webIfcSettings", { COORDINATE_TO_ORIGIN: !0 }), De(this, "attributesToExclude", /* @__PURE__ */ new Set(["Representation", "ObjectPlacement", "CompositionType", "OwnerHistory"])), De(this, "geometryProcessSettings", { threshold: 3e3, precision: 1e6, normalPrecision: 1e7, planePrecision: 1e3, faceThreshold: 0.6, forceTransparentSpaces: !0 }), De(this, "relations", /* @__PURE__ */ new Map([[Fe, { forRelating: "DefinesOcurrence", forRelated: "IsDefinedBy" }], [So, { forRelated: "HasAssociations", forRelating: "AssociatedTo" }], [U, { forRelated: "Decomposes", forRelating: "IsDecomposedBy" }], [Xe, { forRelated: "ContainedInStructure", forRelating: "ContainsElements" }]])), De(this, "classes", { elements: new OA([...CZ.elements]), abstract: new OA([...CZ.base, ...CZ.materials, ...CZ.properties, ...CZ.units]) }), De(this, "includeUniqueAttributes", !1), De(this, "includeRelationNames", !1), De(this, "replaceStoreyElevation", !0), De(this, "replaceSiteElevation", !0), De(this, "distanceThreshold", 1e5);
  }
  get builder() {
    if (!this._builder) throw new Error("Fragments: Builder not initialized");
    return this._builder;
  }
  async process(t) {
    var i;
    this._builder = new Uie(1024);
    const n = new e$e(this);
    n.wasm = this.wasm, n.webIfcSettings = this.webIfcSettings;
    const s = { ...t, builder: this.builder }, o = await n.process(s), { modelMesh: r, maxLocalID: l, localIDs: c, alignments: h, grids: I } = o, p = new Zqe(this, this.builder);
    p.wasm = this.wasm, p.webIfcSettings = this.webIfcSettings;
    const y = { ...t, geometryProcessedLocalIDs: c, alignments: h, grids: I, maxLocalID: l }, m = await p.process(y), { relIndicesVector: A, relsVector: C, guidsVector: O, guidsItemsVector: R, metadataOffset: F, localIdsVector: L, spatialStrutureOffset: P, attributesVector: z, categoriesVector: W, uniqueAttributesVector: re, relNamesVector: ce, newMaxLocalID: te } = m, ee = t.id ?? Eie.generateUUID(), Ne = this.builder.createString(ee);
    Cn.startModel(this.builder), Cn.addMeshes(this.builder, r), Cn.addMetadata(this.builder, F), Cn.addAttributes(this.builder, z), Cn.addUniqueAttributes(this.builder, re), Cn.addRelationNames(this.builder, ce), Cn.addLocalIds(this.builder, L), Cn.addCategories(this.builder, W), Cn.addRelationsItems(this.builder, A), Cn.addRelations(this.builder, C), Cn.addGuidsItems(this.builder, R), Cn.addGuids(this.builder, O), Cn.addSpatialStructure(this.builder, P), Cn.addGuid(this.builder, Ne), Cn.addMaxLocalId(this.builder, te);
    const Ae = Cn.endModel(this.builder);
    this.builder.finish(Ae);
    const Oe = this.builder.asUint8Array();
    this.clean();
    const pe = t.raw ? Oe : Dle.deflate(Oe);
    return (i = t.progressCallback) == null || i.call(t, 1, { process: "conversion", state: "finish" }), pe;
  }
  addAllAttributes() {
    for (const t in Oz) {
      const i = parseInt(t, 10);
      fYe.has(i) || this.classes.abstract.add(i);
    }
  }
  addAllRelations() {
    this.relations = new Map(IYe);
  }
  clean() {
    var t;
    (t = this._builder) == null || t.clear(), this._builder = null;
  }
}
var i$e = ((e) => (e[e.H = 0] = "H", e[e.C = 1] = "C", e[e.Z = 2] = "Z", e[e.T = 3] = "T", e[e.L = 4] = "L", e))(i$e || {});
class n$e {
  constructor(t) {
    De(this, "core"), this.core = t.CreateProfile();
  }
  get(t, i) {
    const n = i.type ?? 0, s = i.width ?? 0.2, o = i.depth ?? 0.2, r = i.thickness ?? 2e-3, l = i.flangeThickness ?? 2e-3, c = i.hasFillet ?? !1, h = i.filletRadius ?? 1e-3, I = i.radius ?? 0.01, p = i.slope ?? 1e-3, y = i.circleSegments ?? 20, m = new t.wasmModule.DoubleVector(), A = i.placement ?? new Ln().identity();
    for (const O of A.elements) m.push_back(O);
    const C = this.core;
    return C.SetValues(n, s, o, r, l, c, h, I, p, y, m), C.GetBuffers();
  }
}
De(n$e, "map", /* @__PURE__ */ new Map([["H", 0], ["C", 1], ["Z", 2], ["T", 3], ["L", 4]]));
var s$e = Object.defineProperty, o$e = (e, t, i) => t in e ? s$e(e, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[t] = i, tt = (e, t, i) => (o$e(e, typeof t != "symbol" ? t + "" : t, i), i);
let es = class {
  constructor() {
    tt(this, "enabled", !0), tt(this, "trigger", (t) => {
      if (!this.enabled)
        return;
      const i = this.handlers.slice(0);
      for (const n of i)
        n(t);
    }), tt(this, "handlers", []);
  }
  /**
   * Add a callback to this event instance.
   * @param handler - the callback to be added to this event.
   */
  add(t) {
    this.handlers.push(t);
  }
  /**
   * Removes a callback from this event instance.
   * @param handler - the callback to be removed from this event.
   */
  remove(t) {
    this.handlers = this.handlers.filter((i) => i !== t);
  }
  /** Gets rid of all the suscribed events. */
  reset() {
    this.handlers.length = 0;
  }
};
class Lme {
  constructor(t) {
    tt(this, "isDisposeable", () => "dispose" in this && "onDisposed" in this), tt(this, "isResizeable", () => "resize" in this && "getSize" in this), tt(this, "isUpdateable", () => "onAfterUpdate" in this && "onBeforeUpdate" in this && "update" in this), tt(this, "isHideable", () => "visible" in this), tt(this, "isConfigurable", () => "setup" in this && "config" in this && "onSetup" in this), tt(this, "isSerializable", () => "import" in this && "export" in this), this.components = t;
  }
}
class bI extends Lme {
}
class _me extends Lme {
  constructor(t) {
    super(t), tt(this, "worlds", new f0()), tt(this, "onWorldChanged", new es()), tt(this, "_currentWorld", null), this.onWorldChanged.add(({ world: i, action: n }) => {
      n === "removed" && this.worlds.delete(i.uuid);
    });
  }
  /**
   * The current world this item is associated with. It can be null if no world is currently active.
   */
  set currentWorld(t) {
    this._currentWorld = t;
  }
  get currentWorld() {
    return this._currentWorld;
  }
}
class r$e extends _me {
  constructor() {
    super(...arguments), tt(this, "hasCameraControls", () => "controls" in this);
  }
}
class l$e extends _me {
  constructor() {
    super(...arguments), tt(this, "onAfterUpdate", new es()), tt(this, "onBeforeUpdate", new es()), tt(this, "onDisposed", new es()), tt(this, "onResize", new es()), tt(this, "onClippingPlanesUpdated", new es()), tt(this, "clippingPlanes", []);
  }
  /**
   * Updates the clipping planes and triggers the `onClippingPlanesUpdated` event.
   *
   * @remarks
   * This method is typically called when there is a change to the list of clipping planes
   * used by the active renderer.
   */
  updateClippingPlanes() {
    this.onClippingPlanesUpdated.trigger();
  }
  /**
   * Sets or removes a clipping plane from the renderer.
   *
   * @param active - A boolean indicating whether the clipping plane should be active or not.
   * @param plane - The clipping plane to be added or removed.
   * @param isLocal - An optional boolean indicating whether the clipping plane is local to the object. If not provided, it defaults to `false`.
   *
   * @remarks
   * This method adds or removes a clipping plane from the `clippingPlanes` array.
   * If `active` is `true` and the plane is not already in the array, it is added.
   * If `active` is `false` and the plane is in the array, it is removed.
   * The `three.clippingPlanes` property is then updated to reflect the current state of the `clippingPlanes` array,
   * excluding any planes marked as local.
   */
  setPlane(t, i, n) {
    i.isLocal = n;
    const s = this.clippingPlanes.indexOf(i);
    t && s === -1 ? this.clippingPlanes.push(i) : !t && s > -1 && this.clippingPlanes.splice(s, 1), this.three.clippingPlanes = this.clippingPlanes.filter(
      (o) => !o.isLocal
    );
  }
}
const hbe = class UIe extends bI {
  constructor(t) {
    super(t), tt(this, "_disposedComponents", /* @__PURE__ */ new Set()), tt(this, "enabled", !0), t.add(UIe.uuid, this);
  }
  // TODO: Remove this?
  /**
   * Return the UUIDs of all disposed components.
   */
  get() {
    return this._disposedComponents;
  }
  /**
   * Removes a mesh, its geometry and its materials from memory. If you are
   * using any of these in other parts of the application, make sure that you
   * remove them from the mesh before disposing it.
   *
   * @param object - the [object](https://threejs.org/docs/#api/en/core/Object3D)
   * to remove.
   *
   * @param materials - whether to dispose the materials of the mesh.
   *
   * @param recursive - whether to recursively dispose the children of the mesh.
   */
  destroy(t, i = !0, n = !0) {
    t.removeFromParent();
    const s = t;
    s.dispose && s.dispose(), this.disposeGeometryAndMaterials(t, i), n && s.children && s.children.length && this.disposeChildren(s), t.children.length = 0;
  }
  /**
   * Disposes a geometry from memory.
   *
   * @param geometry - the
   * [geometry](https://threejs.org/docs/#api/en/core/BufferGeometry)
   * to remove.
   */
  disposeGeometry(t) {
    t.boundsTree && t.disposeBoundsTree && t.disposeBoundsTree(), t.dispose();
  }
  disposeGeometryAndMaterials(t, i) {
    const n = t;
    n.geometry && this.disposeGeometry(n.geometry), i && n.material && UIe.disposeMaterial(n), n.material = [], n.geometry = null;
  }
  disposeChildren(t) {
    for (const i of t.children)
      this.destroy(i);
  }
  static disposeMaterial(t) {
    if (t.material)
      if (Array.isArray(t.material))
        for (const i of t.material)
          i.dispose();
      else
        t.material.dispose();
  }
};
tt(hbe, "uuid", "76e9cd8e-ad8f-4753-9ef6-cbc60f7247fe");
let Tue = hbe;
class a$e extends _me {
  constructor(t) {
    super(t), tt(this, "onDisposed", new es()), tt(this, "directionalLights", /* @__PURE__ */ new Map()), tt(this, "ambientLights", /* @__PURE__ */ new Map());
  }
  /** {@link Disposable.dispose} */
  dispose() {
    const t = this.components.get(Tue);
    for (const i of this.three.children) {
      const n = i;
      n.geometry && t.destroy(n);
    }
    this.deleteAllLights(), this.three.children = [], this.onDisposed.trigger(), this.onDisposed.reset();
  }
  deleteAllLights() {
    for (const [, t] of this.directionalLights)
      t.removeFromParent(), t.target.removeFromParent(), t.dispose();
    this.directionalLights.clear();
    for (const [, t] of this.ambientLights)
      t.removeFromParent(), t.dispose();
    this.ambientLights.clear();
  }
}
const xme = class i1 {
  // Copied from three.js source
  // Original source: http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
  static create() {
    const t = Math.random() * 4294967295 | 0, i = Math.random() * 4294967295 | 0, n = Math.random() * 4294967295 | 0, s = Math.random() * 4294967295 | 0;
    return `${i1._lut[t & 255] + i1._lut[t >> 8 & 255] + i1._lut[t >> 16 & 255] + i1._lut[t >> 24 & 255]}-${i1._lut[i & 255]}${i1._lut[i >> 8 & 255]}-${i1._lut[i >> 16 & 15 | 64]}${i1._lut[i >> 24 & 255]}-${i1._lut[n & 63 | 128]}${i1._lut[n >> 8 & 255]}-${i1._lut[n >> 16 & 255]}${i1._lut[n >> 24 & 255]}${i1._lut[s & 255]}${i1._lut[s >> 8 & 255]}${i1._lut[s >> 16 & 255]}${i1._lut[s >> 24 & 255]}`.toLowerCase();
  }
  static validate(t) {
    if (!i1._pattern.test(t))
      throw new Error(
        `${t} is not a valid UUID v4.

- If you're the tool creator, you can take one from https://www.uuidgenerator.net/.

- If you're using a platform tool, verify the uuid isn't misspelled or contact the tool creator.`
      );
  }
};
tt(xme, "_pattern", /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-4[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/);
tt(xme, "_lut", [
  "00",
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "0a",
  "0b",
  "0c",
  "0d",
  "0e",
  "0f",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "1a",
  "1b",
  "1c",
  "1d",
  "1e",
  "1f",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "2a",
  "2b",
  "2c",
  "2d",
  "2e",
  "2f",
  "30",
  "31",
  "32",
  "33",
  "34",
  "35",
  "36",
  "37",
  "38",
  "39",
  "3a",
  "3b",
  "3c",
  "3d",
  "3e",
  "3f",
  "40",
  "41",
  "42",
  "43",
  "44",
  "45",
  "46",
  "47",
  "48",
  "49",
  "4a",
  "4b",
  "4c",
  "4d",
  "4e",
  "4f",
  "50",
  "51",
  "52",
  "53",
  "54",
  "55",
  "56",
  "57",
  "58",
  "59",
  "5a",
  "5b",
  "5c",
  "5d",
  "5e",
  "5f",
  "60",
  "61",
  "62",
  "63",
  "64",
  "65",
  "66",
  "67",
  "68",
  "69",
  "6a",
  "6b",
  "6c",
  "6d",
  "6e",
  "6f",
  "70",
  "71",
  "72",
  "73",
  "74",
  "75",
  "76",
  "77",
  "78",
  "79",
  "7a",
  "7b",
  "7c",
  "7d",
  "7e",
  "7f",
  "80",
  "81",
  "82",
  "83",
  "84",
  "85",
  "86",
  "87",
  "88",
  "89",
  "8a",
  "8b",
  "8c",
  "8d",
  "8e",
  "8f",
  "90",
  "91",
  "92",
  "93",
  "94",
  "95",
  "96",
  "97",
  "98",
  "99",
  "9a",
  "9b",
  "9c",
  "9d",
  "9e",
  "9f",
  "a0",
  "a1",
  "a2",
  "a3",
  "a4",
  "a5",
  "a6",
  "a7",
  "a8",
  "a9",
  "aa",
  "ab",
  "ac",
  "ad",
  "ae",
  "af",
  "b0",
  "b1",
  "b2",
  "b3",
  "b4",
  "b5",
  "b6",
  "b7",
  "b8",
  "b9",
  "ba",
  "bb",
  "bc",
  "bd",
  "be",
  "bf",
  "c0",
  "c1",
  "c2",
  "c3",
  "c4",
  "c5",
  "c6",
  "c7",
  "c8",
  "c9",
  "ca",
  "cb",
  "cc",
  "cd",
  "ce",
  "cf",
  "d0",
  "d1",
  "d2",
  "d3",
  "d4",
  "d5",
  "d6",
  "d7",
  "d8",
  "d9",
  "da",
  "db",
  "dc",
  "dd",
  "de",
  "df",
  "e0",
  "e1",
  "e2",
  "e3",
  "e4",
  "e5",
  "e6",
  "e7",
  "e8",
  "e9",
  "ea",
  "eb",
  "ec",
  "ed",
  "ee",
  "ef",
  "f0",
  "f1",
  "f2",
  "f3",
  "f4",
  "f5",
  "f6",
  "f7",
  "f8",
  "f9",
  "fa",
  "fb",
  "fc",
  "fd",
  "fe",
  "ff"
]);
let y4 = xme;
var mse = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function u$e(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var fbe = {}, Rue = {};
(function(e) {
  const t = ":A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", i = t + "\\-.\\d\\u00B7\\u0300-\\u036F\\u203F-\\u2040", n = "[" + t + "][" + i + "]*", s = new RegExp("^" + n + "$"), o = function(l, c) {
    const h = [];
    let I = c.exec(l);
    for (; I; ) {
      const p = [];
      p.startIndex = c.lastIndex - I[0].length;
      const y = I.length;
      for (let m = 0; m < y; m++)
        p.push(I[m]);
      h.push(p), I = c.exec(l);
    }
    return h;
  }, r = function(l) {
    const c = s.exec(l);
    return !(c === null || typeof c > "u");
  };
  e.isExist = function(l) {
    return typeof l < "u";
  }, e.isEmptyObject = function(l) {
    return Object.keys(l).length === 0;
  }, e.merge = function(l, c, h) {
    if (c) {
      const I = Object.keys(c), p = I.length;
      for (let y = 0; y < p; y++)
        h === "strict" ? l[I[y]] = [c[I[y]]] : l[I[y]] = c[I[y]];
    }
  }, e.getValue = function(l) {
    return e.isExist(l) ? l : "";
  }, e.isName = r, e.getAllMatches = o, e.nameRegexp = n;
})(Rue);
const Pme = Rue, d$e = {
  allowBooleanAttributes: !1,
  //A tag can have attributes without any value
  unpairedTags: []
};
fbe.validate = function(e, t) {
  t = Object.assign({}, d$e, t);
  const i = [];
  let n = !1, s = !1;
  e[0] === "\uFEFF" && (e = e.substr(1));
  for (let o = 0; o < e.length; o++)
    if (e[o] === "<" && e[o + 1] === "?") {
      if (o += 2, o = Gwe(e, o), o.err)
        return o;
    } else if (e[o] === "<") {
      let r = o;
      if (o++, e[o] === "!") {
        o = kwe(e, o);
        continue;
      } else {
        let l = !1;
        e[o] === "/" && (l = !0, o++);
        let c = "";
        for (; o < e.length && e[o] !== ">" && e[o] !== " " && e[o] !== "	" && e[o] !== `
` && e[o] !== "\r"; o++)
          c += e[o];
        if (c = c.trim(), c[c.length - 1] === "/" && (c = c.substring(0, c.length - 1), o--), !E$e(c)) {
          let p;
          return c.trim().length === 0 ? p = "Invalid space after '<'." : p = "Tag '" + c + "' is an invalid name.", t0("InvalidTag", p, Cy(e, o));
        }
        const h = f$e(e, o);
        if (h === !1)
          return t0("InvalidAttr", "Attributes for '" + c + "' have open quote.", Cy(e, o));
        let I = h.value;
        if (o = h.index, I[I.length - 1] === "/") {
          const p = o - I.length;
          I = I.substring(0, I.length - 1);
          const y = Vwe(I, t);
          if (y === !0)
            n = !0;
          else
            return t0(y.err.code, y.err.msg, Cy(e, p + y.err.line));
        } else if (l)
          if (h.tagClosed) {
            if (I.trim().length > 0)
              return t0("InvalidTag", "Closing tag '" + c + "' can't have attributes or invalid starting.", Cy(e, r));
            if (i.length === 0)
              return t0("InvalidTag", "Closing tag '" + c + "' has not been opened.", Cy(e, r));
            {
              const p = i.pop();
              if (c !== p.tagName) {
                let y = Cy(e, p.tagStartPos);
                return t0(
                  "InvalidTag",
                  "Expected closing tag '" + p.tagName + "' (opened in line " + y.line + ", col " + y.col + ") instead of closing tag '" + c + "'.",
                  Cy(e, r)
                );
              }
              i.length == 0 && (s = !0);
            }
          } else return t0("InvalidTag", "Closing tag '" + c + "' doesn't have proper closing.", Cy(e, o));
        else {
          const p = Vwe(I, t);
          if (p !== !0)
            return t0(p.err.code, p.err.msg, Cy(e, o - I.length + p.err.line));
          if (s === !0)
            return t0("InvalidXml", "Multiple possible root nodes found.", Cy(e, o));
          t.unpairedTags.indexOf(c) !== -1 || i.push({ tagName: c, tagStartPos: r }), n = !0;
        }
        for (o++; o < e.length; o++)
          if (e[o] === "<")
            if (e[o + 1] === "!") {
              o++, o = kwe(e, o);
              continue;
            } else if (e[o + 1] === "?") {
              if (o = Gwe(e, ++o), o.err)
                return o;
            } else
              break;
          else if (e[o] === "&") {
            const p = m$e(e, o);
            if (p == -1)
              return t0("InvalidChar", "char '&' is not expected.", Cy(e, o));
            o = p;
          } else if (s === !0 && !Hwe(e[o]))
            return t0("InvalidXml", "Extra text at the end", Cy(e, o));
        e[o] === "<" && o--;
      }
    } else {
      if (Hwe(e[o]))
        continue;
      return t0("InvalidChar", "char '" + e[o] + "' is not expected.", Cy(e, o));
    }
  if (n) {
    if (i.length == 1)
      return t0("InvalidTag", "Unclosed tag '" + i[0].tagName + "'.", Cy(e, i[0].tagStartPos));
    if (i.length > 0)
      return t0("InvalidXml", "Invalid '" + JSON.stringify(i.map((o) => o.tagName), null, 4).replace(/\r?\n/g, "") + "' found.", { line: 1, col: 1 });
  } else return t0("InvalidXml", "Start tag expected.", 1);
  return !0;
};
function Hwe(e) {
  return e === " " || e === "	" || e === `
` || e === "\r";
}
function Gwe(e, t) {
  const i = t;
  for (; t < e.length; t++)
    if (e[t] == "?" || e[t] == " ") {
      const n = e.substr(i, t - i);
      if (t > 5 && n === "xml")
        return t0("InvalidXml", "XML declaration allowed only at the start of the document.", Cy(e, t));
      if (e[t] == "?" && e[t + 1] == ">") {
        t++;
        break;
      } else
        continue;
    }
  return t;
}
function kwe(e, t) {
  if (e.length > t + 5 && e[t + 1] === "-" && e[t + 2] === "-") {
    for (t += 3; t < e.length; t++)
      if (e[t] === "-" && e[t + 1] === "-" && e[t + 2] === ">") {
        t += 2;
        break;
      }
  } else if (e.length > t + 8 && e[t + 1] === "D" && e[t + 2] === "O" && e[t + 3] === "C" && e[t + 4] === "T" && e[t + 5] === "Y" && e[t + 6] === "P" && e[t + 7] === "E") {
    let i = 1;
    for (t += 8; t < e.length; t++)
      if (e[t] === "<")
        i++;
      else if (e[t] === ">" && (i--, i === 0))
        break;
  } else if (e.length > t + 9 && e[t + 1] === "[" && e[t + 2] === "C" && e[t + 3] === "D" && e[t + 4] === "A" && e[t + 5] === "T" && e[t + 6] === "A" && e[t + 7] === "[") {
    for (t += 8; t < e.length; t++)
      if (e[t] === "]" && e[t + 1] === "]" && e[t + 2] === ">") {
        t += 2;
        break;
      }
  }
  return t;
}
const c$e = '"', h$e = "'";
function f$e(e, t) {
  let i = "", n = "", s = !1;
  for (; t < e.length; t++) {
    if (e[t] === c$e || e[t] === h$e)
      n === "" ? n = e[t] : n !== e[t] || (n = "");
    else if (e[t] === ">" && n === "") {
      s = !0;
      break;
    }
    i += e[t];
  }
  return n !== "" ? !1 : {
    value: i,
    index: t,
    tagClosed: s
  };
}
const I$e = new RegExp(`(\\s*)([^\\s=]+)(\\s*=)?(\\s*(['"])(([\\s\\S])*?)\\5)?`, "g");
function Vwe(e, t) {
  const i = Pme.getAllMatches(e, I$e), n = {};
  for (let s = 0; s < i.length; s++) {
    if (i[s][1].length === 0)
      return t0("InvalidAttr", "Attribute '" + i[s][2] + "' has no space in starting.", OZ(i[s]));
    if (i[s][3] !== void 0 && i[s][4] === void 0)
      return t0("InvalidAttr", "Attribute '" + i[s][2] + "' is without value.", OZ(i[s]));
    if (i[s][3] === void 0 && !t.allowBooleanAttributes)
      return t0("InvalidAttr", "boolean attribute '" + i[s][2] + "' is not allowed.", OZ(i[s]));
    const o = i[s][2];
    if (!y$e(o))
      return t0("InvalidAttr", "Attribute '" + o + "' is an invalid name.", OZ(i[s]));
    if (!n.hasOwnProperty(o))
      n[o] = 1;
    else
      return t0("InvalidAttr", "Attribute '" + o + "' is repeated.", OZ(i[s]));
  }
  return !0;
}
function p$e(e, t) {
  let i = /\d/;
  for (e[t] === "x" && (t++, i = /[\da-fA-F]/); t < e.length; t++) {
    if (e[t] === ";")
      return t;
    if (!e[t].match(i))
      break;
  }
  return -1;
}
function m$e(e, t) {
  if (t++, e[t] === ";")
    return -1;
  if (e[t] === "#")
    return t++, p$e(e, t);
  let i = 0;
  for (; t < e.length; t++, i++)
    if (!(e[t].match(/\w/) && i < 20)) {
      if (e[t] === ";")
        break;
      return -1;
    }
  return t;
}
function t0(e, t, i) {
  return {
    err: {
      code: e,
      msg: t,
      line: i.line || i,
      col: i.col
    }
  };
}
function y$e(e) {
  return Pme.isName(e);
}
function E$e(e) {
  return Pme.isName(e);
}
function Cy(e, t) {
  const i = e.substring(0, t).split(/\r?\n/);
  return {
    line: i.length,
    // column number is last line's length + 1, because column numbering starts at 1:
    col: i[i.length - 1].length + 1
  };
}
function OZ(e) {
  return e.startIndex + e[1].length;
}
var Mme = {};
const Ibe = {
  preserveOrder: !1,
  attributeNamePrefix: "@_",
  attributesGroupName: !1,
  textNodeName: "#text",
  ignoreAttributes: !0,
  removeNSPrefix: !1,
  // remove NS from tag name or attribute name if true
  allowBooleanAttributes: !1,
  //a tag can have attributes without any value
  //ignoreRootElement : false,
  parseTagValue: !0,
  parseAttributeValue: !1,
  trimValues: !0,
  //Trim string values of tag and attributes
  cdataPropName: !1,
  numberParseOptions: {
    hex: !0,
    leadingZeros: !0,
    eNotation: !0
  },
  tagValueProcessor: function(e, t) {
    return t;
  },
  attributeValueProcessor: function(e, t) {
    return t;
  },
  stopNodes: [],
  //nested tags will not be parsed even for errors
  alwaysCreateTextNode: !1,
  isArray: () => !1,
  commentPropName: !1,
  unpairedTags: [],
  processEntities: !0,
  htmlEntities: !1,
  ignoreDeclaration: !1,
  ignorePiTags: !1,
  transformTagName: !1,
  transformAttributeName: !1,
  updateTag: function(e, t, i) {
    return e;
  }
  // skipEmptyListItem: false
}, g$e = function(e) {
  return Object.assign({}, Ibe, e);
};
Mme.buildOptions = g$e;
Mme.defaultOptions = Ibe;
class w$e {
  constructor(t) {
    this.tagname = t, this.child = [], this[":@"] = {};
  }
  add(t, i) {
    t === "__proto__" && (t = "#__proto__"), this.child.push({ [t]: i });
  }
  addChild(t) {
    t.tagname === "__proto__" && (t.tagname = "#__proto__"), t[":@"] && Object.keys(t[":@"]).length > 0 ? this.child.push({ [t.tagname]: t.child, ":@": t[":@"] }) : this.child.push({ [t.tagname]: t.child });
  }
}
var T$e = w$e;
const R$e = Rue;
function v$e(e, t) {
  const i = {};
  if (e[t + 3] === "O" && e[t + 4] === "C" && e[t + 5] === "T" && e[t + 6] === "Y" && e[t + 7] === "P" && e[t + 8] === "E") {
    t = t + 9;
    let n = 1, s = !1, o = !1, r = "";
    for (; t < e.length; t++)
      if (e[t] === "<" && !o) {
        if (s && b$e(e, t))
          t += 7, [entityName, val, t] = A$e(e, t + 1), val.indexOf("&") === -1 && (i[O$e(entityName)] = {
            regx: RegExp(`&${entityName};`, "g"),
            val
          });
        else if (s && N$e(e, t))
          t += 8;
        else if (s && D$e(e, t))
          t += 8;
        else if (s && C$e(e, t))
          t += 9;
        else if (S$e)
          o = !0;
        else
          throw new Error("Invalid DOCTYPE");
        n++, r = "";
      } else if (e[t] === ">") {
        if (o ? e[t - 1] === "-" && e[t - 2] === "-" && (o = !1, n--) : n--, n === 0)
          break;
      } else e[t] === "[" ? s = !0 : r += e[t];
    if (n !== 0)
      throw new Error("Unclosed DOCTYPE");
  } else
    throw new Error("Invalid Tag instead of DOCTYPE");
  return { entities: i, i: t };
}
function A$e(e, t) {
  let i = "";
  for (; t < e.length && e[t] !== "'" && e[t] !== '"'; t++)
    i += e[t];
  if (i = i.trim(), i.indexOf(" ") !== -1)
    throw new Error("External entites are not supported");
  const n = e[t++];
  let s = "";
  for (; t < e.length && e[t] !== n; t++)
    s += e[t];
  return [i, s, t];
}
function S$e(e, t) {
  return e[t + 1] === "!" && e[t + 2] === "-" && e[t + 3] === "-";
}
function b$e(e, t) {
  return e[t + 1] === "!" && e[t + 2] === "E" && e[t + 3] === "N" && e[t + 4] === "T" && e[t + 5] === "I" && e[t + 6] === "T" && e[t + 7] === "Y";
}
function N$e(e, t) {
  return e[t + 1] === "!" && e[t + 2] === "E" && e[t + 3] === "L" && e[t + 4] === "E" && e[t + 5] === "M" && e[t + 6] === "E" && e[t + 7] === "N" && e[t + 8] === "T";
}
function D$e(e, t) {
  return e[t + 1] === "!" && e[t + 2] === "A" && e[t + 3] === "T" && e[t + 4] === "T" && e[t + 5] === "L" && e[t + 6] === "I" && e[t + 7] === "S" && e[t + 8] === "T";
}
function C$e(e, t) {
  return e[t + 1] === "!" && e[t + 2] === "N" && e[t + 3] === "O" && e[t + 4] === "T" && e[t + 5] === "A" && e[t + 6] === "T" && e[t + 7] === "I" && e[t + 8] === "O" && e[t + 9] === "N";
}
function O$e(e) {
  if (R$e.isName(e))
    return e;
  throw new Error(`Invalid entity name ${e}`);
}
var L$e = v$e;
const _$e = /^[-+]?0x[a-fA-F0-9]+$/, x$e = /^([\-\+])?(0*)([0-9]*(\.[0-9]*)?)$/, P$e = {
  hex: !0,
  // oct: false,
  leadingZeros: !0,
  decimalPoint: ".",
  eNotation: !0
  //skipLike: /regex/
};
function M$e(e, t = {}) {
  if (t = Object.assign({}, P$e, t), !e || typeof e != "string")
    return e;
  let i = e.trim();
  if (t.skipLike !== void 0 && t.skipLike.test(i))
    return e;
  if (e === "0")
    return 0;
  if (t.hex && _$e.test(i))
    return B$e(i, 16);
  if (i.search(/[eE]/) !== -1) {
    const n = i.match(/^([-\+])?(0*)([0-9]*(\.[0-9]*)?[eE][-\+]?[0-9]+)$/);
    if (n) {
      if (t.leadingZeros)
        i = (n[1] || "") + n[3];
      else if (!(n[2] === "0" && n[3][0] === "."))
        return e;
      return t.eNotation ? Number(i) : e;
    } else
      return e;
  } else {
    const n = x$e.exec(i);
    if (n) {
      const s = n[1], o = n[2];
      let r = U$e(n[3]);
      if (!t.leadingZeros && o.length > 0 && s && i[2] !== ".")
        return e;
      if (!t.leadingZeros && o.length > 0 && !s && i[1] !== ".")
        return e;
      if (t.leadingZeros && o === e)
        return 0;
      {
        const l = Number(i), c = "" + l;
        return c.search(/[eE]/) !== -1 ? t.eNotation ? l : e : i.indexOf(".") !== -1 ? c === "0" && r === "" || c === r || s && c === "-" + r ? l : e : o ? r === c || s + r === c ? l : e : i === c || i === s + c ? l : e;
      }
    } else
      return e;
  }
}
function U$e(e) {
  return e && e.indexOf(".") !== -1 && (e = e.replace(/0+$/, ""), e === "." ? e = "0" : e[0] === "." ? e = "0" + e : e[e.length - 1] === "." && (e = e.substr(0, e.length - 1))), e;
}
function B$e(e, t) {
  if (parseInt)
    return parseInt(e, t);
  if (Number.parseInt)
    return Number.parseInt(e, t);
  if (window && window.parseInt)
    return window.parseInt(e, t);
  throw new Error("parseInt, Number.parseInt, window.parseInt are not supported");
}
var F$e = M$e;
const pbe = Rue, LZ = T$e, H$e = L$e, G$e = F$e;
let k$e = class {
  constructor(t) {
    this.options = t, this.currentNode = null, this.tagsNodeStack = [], this.docTypeEntities = {}, this.lastEntities = {
      apos: { regex: /&(apos|#39|#x27);/g, val: "'" },
      gt: { regex: /&(gt|#62|#x3E);/g, val: ">" },
      lt: { regex: /&(lt|#60|#x3C);/g, val: "<" },
      quot: { regex: /&(quot|#34|#x22);/g, val: '"' }
    }, this.ampEntity = { regex: /&(amp|#38|#x26);/g, val: "&" }, this.htmlEntities = {
      space: { regex: /&(nbsp|#160);/g, val: " " },
      // "lt" : { regex: /&(lt|#60);/g, val: "<" },
      // "gt" : { regex: /&(gt|#62);/g, val: ">" },
      // "amp" : { regex: /&(amp|#38);/g, val: "&" },
      // "quot" : { regex: /&(quot|#34);/g, val: "\"" },
      // "apos" : { regex: /&(apos|#39);/g, val: "'" },
      cent: { regex: /&(cent|#162);/g, val: "¢" },
      pound: { regex: /&(pound|#163);/g, val: "£" },
      yen: { regex: /&(yen|#165);/g, val: "¥" },
      euro: { regex: /&(euro|#8364);/g, val: "€" },
      copyright: { regex: /&(copy|#169);/g, val: "©" },
      reg: { regex: /&(reg|#174);/g, val: "®" },
      inr: { regex: /&(inr|#8377);/g, val: "₹" },
      num_dec: { regex: /&#([0-9]{1,7});/g, val: (i, n) => String.fromCharCode(Number.parseInt(n, 10)) },
      num_hex: { regex: /&#x([0-9a-fA-F]{1,6});/g, val: (i, n) => String.fromCharCode(Number.parseInt(n, 16)) }
    }, this.addExternalEntities = V$e, this.parseXml = q$e, this.parseTextData = z$e, this.resolveNameSpace = j$e, this.buildAttributesMap = Y$e, this.isItStopNode = Q$e, this.replaceEntitiesValue = K$e, this.readStopNodeData = X$e, this.saveTextToParentTag = Z$e, this.addChild = $$e;
  }
};
function V$e(e) {
  const t = Object.keys(e);
  for (let i = 0; i < t.length; i++) {
    const n = t[i];
    this.lastEntities[n] = {
      regex: new RegExp("&" + n + ";", "g"),
      val: e[n]
    };
  }
}
function z$e(e, t, i, n, s, o, r) {
  if (e !== void 0 && (this.options.trimValues && !n && (e = e.trim()), e.length > 0)) {
    r || (e = this.replaceEntitiesValue(e));
    const l = this.options.tagValueProcessor(t, e, i, s, o);
    return l == null ? e : typeof l != typeof e || l !== e ? l : this.options.trimValues ? FIe(e, this.options.parseTagValue, this.options.numberParseOptions) : e.trim() === e ? FIe(e, this.options.parseTagValue, this.options.numberParseOptions) : e;
  }
}
function j$e(e) {
  if (this.options.removeNSPrefix) {
    const t = e.split(":"), i = e.charAt(0) === "/" ? "/" : "";
    if (t[0] === "xmlns")
      return "";
    t.length === 2 && (e = i + t[1]);
  }
  return e;
}
const W$e = new RegExp(`([^\\s=]+)\\s*(=\\s*(['"])([\\s\\S]*?)\\3)?`, "gm");
function Y$e(e, t, i) {
  if (!this.options.ignoreAttributes && typeof e == "string") {
    const n = pbe.getAllMatches(e, W$e), s = n.length, o = {};
    for (let r = 0; r < s; r++) {
      const l = this.resolveNameSpace(n[r][1]);
      let c = n[r][4], h = this.options.attributeNamePrefix + l;
      if (l.length)
        if (this.options.transformAttributeName && (h = this.options.transformAttributeName(h)), h === "__proto__" && (h = "#__proto__"), c !== void 0) {
          this.options.trimValues && (c = c.trim()), c = this.replaceEntitiesValue(c);
          const I = this.options.attributeValueProcessor(l, c, t);
          I == null ? o[h] = c : typeof I != typeof c || I !== c ? o[h] = I : o[h] = FIe(
            c,
            this.options.parseAttributeValue,
            this.options.numberParseOptions
          );
        } else this.options.allowBooleanAttributes && (o[h] = !0);
    }
    if (!Object.keys(o).length)
      return;
    if (this.options.attributesGroupName) {
      const r = {};
      return r[this.options.attributesGroupName] = o, r;
    }
    return o;
  }
}
const q$e = function(e) {
  e = e.replace(/\r\n?/g, `
`);
  const t = new LZ("!xml");
  let i = t, n = "", s = "";
  for (let o = 0; o < e.length; o++)
    if (e[o] === "<")
      if (e[o + 1] === "/") {
        const l = hB(e, ">", o, "Closing Tag is not closed.");
        let c = e.substring(o + 2, l).trim();
        if (this.options.removeNSPrefix) {
          const p = c.indexOf(":");
          p !== -1 && (c = c.substr(p + 1));
        }
        this.options.transformTagName && (c = this.options.transformTagName(c)), i && (n = this.saveTextToParentTag(n, i, s));
        const h = s.substring(s.lastIndexOf(".") + 1);
        if (c && this.options.unpairedTags.indexOf(c) !== -1)
          throw new Error(`Unpaired tag can not be used as closing tag: </${c}>`);
        let I = 0;
        h && this.options.unpairedTags.indexOf(h) !== -1 ? (I = s.lastIndexOf(".", s.lastIndexOf(".") - 1), this.tagsNodeStack.pop()) : I = s.lastIndexOf("."), s = s.substring(0, I), i = this.tagsNodeStack.pop(), n = "", o = l;
      } else if (e[o + 1] === "?") {
        let l = BIe(e, o, !1, "?>");
        if (!l)
          throw new Error("Pi Tag is not closed.");
        if (n = this.saveTextToParentTag(n, i, s), !(this.options.ignoreDeclaration && l.tagName === "?xml" || this.options.ignorePiTags)) {
          const c = new LZ(l.tagName);
          c.add(this.options.textNodeName, ""), l.tagName !== l.tagExp && l.attrExpPresent && (c[":@"] = this.buildAttributesMap(l.tagExp, s, l.tagName)), this.addChild(i, c, s);
        }
        o = l.closeIndex + 1;
      } else if (e.substr(o + 1, 3) === "!--") {
        const l = hB(e, "-->", o + 4, "Comment is not closed.");
        if (this.options.commentPropName) {
          const c = e.substring(o + 4, l - 2);
          n = this.saveTextToParentTag(n, i, s), i.add(this.options.commentPropName, [{ [this.options.textNodeName]: c }]);
        }
        o = l;
      } else if (e.substr(o + 1, 2) === "!D") {
        const l = H$e(e, o);
        this.docTypeEntities = l.entities, o = l.i;
      } else if (e.substr(o + 1, 2) === "![") {
        const l = hB(e, "]]>", o, "CDATA is not closed.") - 2, c = e.substring(o + 9, l);
        n = this.saveTextToParentTag(n, i, s);
        let h = this.parseTextData(c, i.tagname, s, !0, !1, !0, !0);
        h == null && (h = ""), this.options.cdataPropName ? i.add(this.options.cdataPropName, [{ [this.options.textNodeName]: c }]) : i.add(this.options.textNodeName, h), o = l + 2;
      } else {
        let l = BIe(e, o, this.options.removeNSPrefix), c = l.tagName;
        const h = l.rawTagName;
        let I = l.tagExp, p = l.attrExpPresent, y = l.closeIndex;
        this.options.transformTagName && (c = this.options.transformTagName(c)), i && n && i.tagname !== "!xml" && (n = this.saveTextToParentTag(n, i, s, !1));
        const m = i;
        if (m && this.options.unpairedTags.indexOf(m.tagname) !== -1 && (i = this.tagsNodeStack.pop(), s = s.substring(0, s.lastIndexOf("."))), c !== t.tagname && (s += s ? "." + c : c), this.isItStopNode(this.options.stopNodes, s, c)) {
          let A = "";
          if (I.length > 0 && I.lastIndexOf("/") === I.length - 1)
            c[c.length - 1] === "/" ? (c = c.substr(0, c.length - 1), s = s.substr(0, s.length - 1), I = c) : I = I.substr(0, I.length - 1), o = l.closeIndex;
          else if (this.options.unpairedTags.indexOf(c) !== -1)
            o = l.closeIndex;
          else {
            const O = this.readStopNodeData(e, h, y + 1);
            if (!O)
              throw new Error(`Unexpected end of ${h}`);
            o = O.i, A = O.tagContent;
          }
          const C = new LZ(c);
          c !== I && p && (C[":@"] = this.buildAttributesMap(I, s, c)), A && (A = this.parseTextData(A, c, s, !0, p, !0, !0)), s = s.substr(0, s.lastIndexOf(".")), C.add(this.options.textNodeName, A), this.addChild(i, C, s);
        } else {
          if (I.length > 0 && I.lastIndexOf("/") === I.length - 1) {
            c[c.length - 1] === "/" ? (c = c.substr(0, c.length - 1), s = s.substr(0, s.length - 1), I = c) : I = I.substr(0, I.length - 1), this.options.transformTagName && (c = this.options.transformTagName(c));
            const A = new LZ(c);
            c !== I && p && (A[":@"] = this.buildAttributesMap(I, s, c)), this.addChild(i, A, s), s = s.substr(0, s.lastIndexOf("."));
          } else {
            const A = new LZ(c);
            this.tagsNodeStack.push(i), c !== I && p && (A[":@"] = this.buildAttributesMap(I, s, c)), this.addChild(i, A, s), i = A;
          }
          n = "", o = y;
        }
      }
    else
      n += e[o];
  return t.child;
};
function $$e(e, t, i) {
  const n = this.options.updateTag(t.tagname, i, t[":@"]);
  n === !1 || (typeof n == "string" && (t.tagname = n), e.addChild(t));
}
const K$e = function(e) {
  if (this.options.processEntities) {
    for (let t in this.docTypeEntities) {
      const i = this.docTypeEntities[t];
      e = e.replace(i.regx, i.val);
    }
    for (let t in this.lastEntities) {
      const i = this.lastEntities[t];
      e = e.replace(i.regex, i.val);
    }
    if (this.options.htmlEntities)
      for (let t in this.htmlEntities) {
        const i = this.htmlEntities[t];
        e = e.replace(i.regex, i.val);
      }
    e = e.replace(this.ampEntity.regex, this.ampEntity.val);
  }
  return e;
};
function Z$e(e, t, i, n) {
  return e && (n === void 0 && (n = Object.keys(t.child).length === 0), e = this.parseTextData(
    e,
    t.tagname,
    i,
    !1,
    t[":@"] ? Object.keys(t[":@"]).length !== 0 : !1,
    n
  ), e !== void 0 && e !== "" && t.add(this.options.textNodeName, e), e = ""), e;
}
function Q$e(e, t, i) {
  const n = "*." + i;
  for (const s in e) {
    const o = e[s];
    if (n === o || t === o)
      return !0;
  }
  return !1;
}
function J$e(e, t, i = ">") {
  let n, s = "";
  for (let o = t; o < e.length; o++) {
    let r = e[o];
    if (n)
      r === n && (n = "");
    else if (r === '"' || r === "'")
      n = r;
    else if (r === i[0])
      if (i[1]) {
        if (e[o + 1] === i[1])
          return {
            data: s,
            index: o
          };
      } else
        return {
          data: s,
          index: o
        };
    else r === "	" && (r = " ");
    s += r;
  }
}
function hB(e, t, i, n) {
  const s = e.indexOf(t, i);
  if (s === -1)
    throw new Error(n);
  return s + t.length - 1;
}
function BIe(e, t, i, n = ">") {
  const s = J$e(e, t + 1, n);
  if (!s)
    return;
  let o = s.data;
  const r = s.index, l = o.search(/\s/);
  let c = o, h = !0;
  l !== -1 && (c = o.substring(0, l), o = o.substring(l + 1).trimStart());
  const I = c;
  if (i) {
    const p = c.indexOf(":");
    p !== -1 && (c = c.substr(p + 1), h = c !== s.data.substr(p + 1));
  }
  return {
    tagName: c,
    tagExp: o,
    closeIndex: r,
    attrExpPresent: h,
    rawTagName: I
  };
}
function X$e(e, t, i) {
  const n = i;
  let s = 1;
  for (; i < e.length; i++)
    if (e[i] === "<")
      if (e[i + 1] === "/") {
        const o = hB(e, ">", i, `${t} is not closed`);
        if (e.substring(i + 2, o).trim() === t && (s--, s === 0))
          return {
            tagContent: e.substring(n, i),
            i: o
          };
        i = o;
      } else if (e[i + 1] === "?")
        i = hB(e, "?>", i + 1, "StopNode is not closed.");
      else if (e.substr(i + 1, 3) === "!--")
        i = hB(e, "-->", i + 3, "StopNode is not closed.");
      else if (e.substr(i + 1, 2) === "![")
        i = hB(e, "]]>", i, "StopNode is not closed.") - 2;
      else {
        const o = BIe(e, i, ">");
        o && ((o && o.tagName) === t && o.tagExp[o.tagExp.length - 1] !== "/" && s++, i = o.closeIndex);
      }
}
function FIe(e, t, i) {
  if (t && typeof e == "string") {
    const n = e.trim();
    return n === "true" ? !0 : n === "false" ? !1 : G$e(e, i);
  } else
    return pbe.isExist(e) ? e : "";
}
var eKe = k$e, mbe = {};
function tKe(e, t) {
  return ybe(e, t);
}
function ybe(e, t, i) {
  let n;
  const s = {};
  for (let o = 0; o < e.length; o++) {
    const r = e[o], l = iKe(r);
    let c = "";
    if (i === void 0 ? c = l : c = i + "." + l, l === t.textNodeName)
      n === void 0 ? n = r[l] : n += "" + r[l];
    else {
      if (l === void 0)
        continue;
      if (r[l]) {
        let h = ybe(r[l], t, c);
        const I = sKe(h, t);
        r[":@"] ? nKe(h, r[":@"], c, t) : Object.keys(h).length === 1 && h[t.textNodeName] !== void 0 && !t.alwaysCreateTextNode ? h = h[t.textNodeName] : Object.keys(h).length === 0 && (t.alwaysCreateTextNode ? h[t.textNodeName] = "" : h = ""), s[l] !== void 0 && s.hasOwnProperty(l) ? (Array.isArray(s[l]) || (s[l] = [s[l]]), s[l].push(h)) : t.isArray(l, c, I) ? s[l] = [h] : s[l] = h;
      }
    }
  }
  return typeof n == "string" ? n.length > 0 && (s[t.textNodeName] = n) : n !== void 0 && (s[t.textNodeName] = n), s;
}
function iKe(e) {
  const t = Object.keys(e);
  for (let i = 0; i < t.length; i++) {
    const n = t[i];
    if (n !== ":@")
      return n;
  }
}
function nKe(e, t, i, n) {
  if (t) {
    const s = Object.keys(t), o = s.length;
    for (let r = 0; r < o; r++) {
      const l = s[r];
      n.isArray(l, i + "." + l, !0, !0) ? e[l] = [t[l]] : e[l] = t[l];
    }
  }
}
function sKe(e, t) {
  const { textNodeName: i } = t, n = Object.keys(e).length;
  return !!(n === 0 || n === 1 && (e[i] || typeof e[i] == "boolean" || e[i] === 0));
}
mbe.prettify = tKe;
const { buildOptions: oKe } = Mme, rKe = eKe, { prettify: lKe } = mbe, aKe = fbe;
let uKe = class {
  constructor(t) {
    this.externalEntities = {}, this.options = oKe(t);
  }
  /**
   * Parse XML dats to JS object 
   * @param {string|Buffer} xmlData 
   * @param {boolean|Object} validationOption 
   */
  parse(t, i) {
    if (typeof t != "string")
      if (t.toString)
        t = t.toString();
      else
        throw new Error("XML data is accepted in String or Bytes[] form.");
    if (i) {
      i === !0 && (i = {});
      const o = aKe.validate(t, i);
      if (o !== !0)
        throw Error(`${o.err.msg}:${o.err.line}:${o.err.col}`);
    }
    const n = new rKe(this.options);
    n.addExternalEntities(this.externalEntities);
    const s = n.parseXml(t);
    return this.options.preserveOrder || s === void 0 ? s : lKe(s, this.options);
  }
  /**
   * Add Entity which is not by default supported by this library
   * @param {string} key 
   * @param {string} value 
   */
  addEntity(t, i) {
    if (i.indexOf("&") !== -1)
      throw new Error("Entity value can't have '&'");
    if (t.indexOf("&") !== -1 || t.indexOf(";") !== -1)
      throw new Error("An entity must be set without '&' and ';'. Eg. use '#xD' for '&#xD;'");
    if (i === "&")
      throw new Error("An entity with value '&' is not permitted");
    this.externalEntities[t] = i;
  }
};
var dKe = uKe;
const cKe = `
`;
function hKe(e, t) {
  let i = "";
  return t.format && t.indentBy.length > 0 && (i = cKe), Ebe(e, t, "", i);
}
function Ebe(e, t, i, n) {
  let s = "", o = !1;
  for (let r = 0; r < e.length; r++) {
    const l = e[r], c = fKe(l);
    if (c === void 0)
      continue;
    let h = "";
    if (i.length === 0 ? h = c : h = `${i}.${c}`, c === t.textNodeName) {
      let A = l[c];
      IKe(h, t) || (A = t.tagValueProcessor(c, A), A = gbe(A, t)), o && (s += n), s += A, o = !1;
      continue;
    } else if (c === t.cdataPropName) {
      o && (s += n), s += `<![CDATA[${l[c][0][t.textNodeName]}]]>`, o = !1;
      continue;
    } else if (c === t.commentPropName) {
      s += n + `<!--${l[c][0][t.textNodeName]}-->`, o = !0;
      continue;
    } else if (c[0] === "?") {
      const A = zwe(l[":@"], t), C = c === "?xml" ? "" : n;
      let O = l[c][0][t.textNodeName];
      O = O.length !== 0 ? " " + O : "", s += C + `<${c}${O}${A}?>`, o = !0;
      continue;
    }
    let I = n;
    I !== "" && (I += t.indentBy);
    const p = zwe(l[":@"], t), y = n + `<${c}${p}`, m = Ebe(l[c], t, h, I);
    t.unpairedTags.indexOf(c) !== -1 ? t.suppressUnpairedNode ? s += y + ">" : s += y + "/>" : (!m || m.length === 0) && t.suppressEmptyNode ? s += y + "/>" : m && m.endsWith(">") ? s += y + `>${m}${n}</${c}>` : (s += y + ">", m && n !== "" && (m.includes("/>") || m.includes("</")) ? s += n + t.indentBy + m + n : s += m, s += `</${c}>`), o = !0;
  }
  return s;
}
function fKe(e) {
  const t = Object.keys(e);
  for (let i = 0; i < t.length; i++) {
    const n = t[i];
    if (e.hasOwnProperty(n) && n !== ":@")
      return n;
  }
}
function zwe(e, t) {
  let i = "";
  if (e && !t.ignoreAttributes)
    for (let n in e) {
      if (!e.hasOwnProperty(n))
        continue;
      let s = t.attributeValueProcessor(n, e[n]);
      s = gbe(s, t), s === !0 && t.suppressBooleanAttributes ? i += ` ${n.substr(t.attributeNamePrefix.length)}` : i += ` ${n.substr(t.attributeNamePrefix.length)}="${s}"`;
    }
  return i;
}
function IKe(e, t) {
  e = e.substr(0, e.length - t.textNodeName.length - 1);
  let i = e.substr(e.lastIndexOf(".") + 1);
  for (let n in t.stopNodes)
    if (t.stopNodes[n] === e || t.stopNodes[n] === "*." + i)
      return !0;
  return !1;
}
function gbe(e, t) {
  if (e && e.length > 0 && t.processEntities)
    for (let i = 0; i < t.entities.length; i++) {
      const n = t.entities[i];
      e = e.replace(n.regex, n.val);
    }
  return e;
}
var pKe = hKe;
const mKe = pKe, yKe = {
  attributeNamePrefix: "@_",
  attributesGroupName: !1,
  textNodeName: "#text",
  ignoreAttributes: !0,
  cdataPropName: !1,
  format: !1,
  indentBy: "  ",
  suppressEmptyNode: !1,
  suppressUnpairedNode: !0,
  suppressBooleanAttributes: !0,
  tagValueProcessor: function(e, t) {
    return t;
  },
  attributeValueProcessor: function(e, t) {
    return t;
  },
  preserveOrder: !1,
  commentPropName: !1,
  unpairedTags: [],
  entities: [
    { regex: new RegExp("&", "g"), val: "&amp;" },
    //it must be on top
    { regex: new RegExp(">", "g"), val: "&gt;" },
    { regex: new RegExp("<", "g"), val: "&lt;" },
    { regex: new RegExp("'", "g"), val: "&apos;" },
    { regex: new RegExp('"', "g"), val: "&quot;" }
  ],
  processEntities: !0,
  stopNodes: [],
  // transformTagName: false,
  // transformAttributeName: false,
  oneListGroup: !1
};
function B8(e) {
  this.options = Object.assign({}, yKe, e), this.options.ignoreAttributes || this.options.attributesGroupName ? this.isAttribute = function() {
    return !1;
  } : (this.attrPrefixLen = this.options.attributeNamePrefix.length, this.isAttribute = wKe), this.processTextOrObjNode = EKe, this.options.format ? (this.indentate = gKe, this.tagEndChar = `>
`, this.newLine = `
`) : (this.indentate = function() {
    return "";
  }, this.tagEndChar = ">", this.newLine = "");
}
B8.prototype.build = function(e) {
  return this.options.preserveOrder ? mKe(e, this.options) : (Array.isArray(e) && this.options.arrayNodeName && this.options.arrayNodeName.length > 1 && (e = {
    [this.options.arrayNodeName]: e
  }), this.j2x(e, 0).val);
};
B8.prototype.j2x = function(e, t) {
  let i = "", n = "";
  for (let s in e)
    if (Object.prototype.hasOwnProperty.call(e, s))
      if (typeof e[s] > "u")
        this.isAttribute(s) && (n += "");
      else if (e[s] === null)
        this.isAttribute(s) ? n += "" : s[0] === "?" ? n += this.indentate(t) + "<" + s + "?" + this.tagEndChar : n += this.indentate(t) + "<" + s + "/" + this.tagEndChar;
      else if (e[s] instanceof Date)
        n += this.buildTextValNode(e[s], s, "", t);
      else if (typeof e[s] != "object") {
        const o = this.isAttribute(s);
        if (o)
          i += this.buildAttrPairStr(o, "" + e[s]);
        else if (s === this.options.textNodeName) {
          let r = this.options.tagValueProcessor(s, "" + e[s]);
          n += this.replaceEntitiesValue(r);
        } else
          n += this.buildTextValNode(e[s], s, "", t);
      } else if (Array.isArray(e[s])) {
        const o = e[s].length;
        let r = "", l = "";
        for (let c = 0; c < o; c++) {
          const h = e[s][c];
          if (!(typeof h > "u"))
            if (h === null)
              s[0] === "?" ? n += this.indentate(t) + "<" + s + "?" + this.tagEndChar : n += this.indentate(t) + "<" + s + "/" + this.tagEndChar;
            else if (typeof h == "object")
              if (this.options.oneListGroup) {
                const I = this.j2x(h, t + 1);
                r += I.val, this.options.attributesGroupName && h.hasOwnProperty(this.options.attributesGroupName) && (l += I.attrStr);
              } else
                r += this.processTextOrObjNode(h, s, t);
            else if (this.options.oneListGroup) {
              let I = this.options.tagValueProcessor(s, h);
              I = this.replaceEntitiesValue(I), r += I;
            } else
              r += this.buildTextValNode(h, s, "", t);
        }
        this.options.oneListGroup && (r = this.buildObjectNode(r, s, l, t)), n += r;
      } else if (this.options.attributesGroupName && s === this.options.attributesGroupName) {
        const o = Object.keys(e[s]), r = o.length;
        for (let l = 0; l < r; l++)
          i += this.buildAttrPairStr(o[l], "" + e[s][o[l]]);
      } else
        n += this.processTextOrObjNode(e[s], s, t);
  return { attrStr: i, val: n };
};
B8.prototype.buildAttrPairStr = function(e, t) {
  return t = this.options.attributeValueProcessor(e, "" + t), t = this.replaceEntitiesValue(t), this.options.suppressBooleanAttributes && t === "true" ? " " + e : " " + e + '="' + t + '"';
};
function EKe(e, t, i) {
  const n = this.j2x(e, i + 1);
  return e[this.options.textNodeName] !== void 0 && Object.keys(e).length === 1 ? this.buildTextValNode(e[this.options.textNodeName], t, n.attrStr, i) : this.buildObjectNode(n.val, t, n.attrStr, i);
}
B8.prototype.buildObjectNode = function(e, t, i, n) {
  if (e === "")
    return t[0] === "?" ? this.indentate(n) + "<" + t + i + "?" + this.tagEndChar : this.indentate(n) + "<" + t + i + this.closeTag(t) + this.tagEndChar;
  {
    let s = "</" + t + this.tagEndChar, o = "";
    return t[0] === "?" && (o = "?", s = ""), (i || i === "") && e.indexOf("<") === -1 ? this.indentate(n) + "<" + t + i + o + ">" + e + s : this.options.commentPropName !== !1 && t === this.options.commentPropName && o.length === 0 ? this.indentate(n) + `<!--${e}-->` + this.newLine : this.indentate(n) + "<" + t + i + o + this.tagEndChar + e + this.indentate(n) + s;
  }
};
B8.prototype.closeTag = function(e) {
  let t = "";
  return this.options.unpairedTags.indexOf(e) !== -1 ? this.options.suppressUnpairedNode || (t = "/") : this.options.suppressEmptyNode ? t = "/" : t = `></${e}`, t;
};
B8.prototype.buildTextValNode = function(e, t, i, n) {
  if (this.options.cdataPropName !== !1 && t === this.options.cdataPropName)
    return this.indentate(n) + `<![CDATA[${e}]]>` + this.newLine;
  if (this.options.commentPropName !== !1 && t === this.options.commentPropName)
    return this.indentate(n) + `<!--${e}-->` + this.newLine;
  if (t[0] === "?")
    return this.indentate(n) + "<" + t + i + "?" + this.tagEndChar;
  {
    let s = this.options.tagValueProcessor(t, e);
    return s = this.replaceEntitiesValue(s), s === "" ? this.indentate(n) + "<" + t + i + this.closeTag(t) + this.tagEndChar : this.indentate(n) + "<" + t + i + ">" + s + "</" + t + this.tagEndChar;
  }
};
B8.prototype.replaceEntitiesValue = function(e) {
  if (e && e.length > 0 && this.options.processEntities)
    for (let t = 0; t < this.options.entities.length; t++) {
      const i = this.options.entities[t];
      e = e.replace(i.regex, i.val);
    }
  return e;
};
function gKe(e) {
  return this.options.indentBy.repeat(e);
}
function wKe(e) {
  return e.startsWith(this.options.attributeNamePrefix) && e !== this.options.textNodeName ? e.substr(this.attrPrefixLen) : !1;
}
var TKe = B8;
const RKe = dKe, vKe = TKe;
var vue = {
  XMLParser: RKe,
  XMLBuilder: vKe
};
class Aue {
}
tt(Aue, "parser", new vue.XMLParser({
  allowBooleanAttributes: !0,
  attributeNamePrefix: "",
  ignoreAttributes: !1,
  ignoreDeclaration: !0,
  ignorePiTags: !0,
  numberParseOptions: { leadingZeros: !0, hex: !0 },
  parseAttributeValue: !0,
  preserveOrder: !1,
  processEntities: !1,
  removeNSPrefix: !0,
  trimValues: !0
}));
tt(Aue, "builder", new vue.XMLBuilder({
  attributeNamePrefix: "$",
  ignoreAttributes: !1,
  suppressBooleanAttributes: !1
}));
class TI {
  /**
   * Creates a new ModelIdMap from the union of multiple ModelIdMaps.
   * @param maps - An array of ModelIdMaps to join.
   * @returns A new ModelIdMap containing all model identifiers and localIds from all input maps.
   */
  static join(t) {
    const i = {};
    for (const n of t)
      for (const s in n)
        if (!i[s])
          i[s] = new Set(n[s]);
        else
          for (const o of n[s])
            i[s].add(o);
    return i;
  }
  /**
   * Creates a new ModelIdMap from the intersection of multiple ModelIdMaps.
   * @param maps - An array of ModelIdMaps.
   * @returns A new ModelIdMap containing only model identifiers and localIds present in all input maps.
   */
  static intersect(t) {
    if (t.length === 0)
      return {};
    let i = TI.clone(t[0]);
    for (let n = 1; n < t.length; n++) {
      const s = t[n], o = {};
      for (const r in i)
        if (s[r]) {
          const l = /* @__PURE__ */ new Set();
          for (const c of i[r])
            s[r].has(c) && l.add(c);
          l.size > 0 && (o[r] = l);
        }
      i = o;
    }
    return i;
  }
  /**
   * Creates a deep clone of a ModelIdMap.
   * @param source - The ModelIdMap to clone.
   * @returns A new ModelIdMap with the same model identifiers and localIds as the original.
   */
  static clone(t) {
    const i = {};
    for (const n in t)
      i[n] = new Set(t[n]);
    return i;
  }
  /**
   * Remove all entries from one ModelIdMap to another.
   * @param target - The ModelIdMap to subtract from.
   * @param source - The ModelIdMap to subtract.
   */
  static remove(t, i, n = !1) {
    n && (t = TI.clone(t));
    for (const s in i)
      if (t[s]) {
        for (const o of i[s])
          t[s].delete(o);
        t[s].size === 0 && delete t[s];
      }
  }
  /**
   * Adds all entries from one ModelIdMap to another.
   * @param target - The ModelIdMap to add to.
   * @param source - The ModelIdMap to add from.
   */
  static add(t, i, n = !1) {
    n && (t = TI.clone(t));
    for (const s in i)
      if (!t[s])
        t[s] = new Set(i[s]);
      else
        for (const o of i[s])
          t[s].add(o);
  }
  static append(t, i, ...n) {
    let s = t[i];
    s || (s = /* @__PURE__ */ new Set(), t[i] = s);
    for (const o of n)
      s.add(o);
  }
  /**
   * Checks if two ModelIdMaps are equal.
   * @param a - The first ModelIdMap.
   * @param b - The second ModelIdMap.
   * @returns True if the ModelIdMaps are equal, false otherwise.
   */
  static isEqual(t, i) {
    const n = Object.keys(t), s = Object.keys(i);
    if (n.length !== s.length)
      return !1;
    for (const o of n) {
      if (!i[o] || t[o].size !== i[o].size)
        return !1;
      for (const r of t[o])
        if (!i[o].has(r))
          return !1;
    }
    return !0;
  }
  /**
   * Checks if a ModelIdMap is empty.
   * @param map - The ModelIdMap to check.
   * @returns True if the ModelIdMap is empty, false otherwise.
   */
  static isEmpty(t) {
    return Object.values(t).reduce(
      (n, s) => n + s.size,
      0
    ) === 0;
  }
  /**
   * Converts a ModelIdMap into a plain JavaScript object with array values.
   * @param map - The ModelIdMap to convert.
   * @returns A plain JavaScript object where each key (model ID) maps to an array of local IDs.
   */
  static toRaw(t) {
    const i = {};
    for (const n in t)
      i[n] = Array.from(t[n]);
    return i;
  }
  /**
   * Creates a ModelIdMap from a plain JavaScript object with array values.
   * @param raw - A plain JavaScript object where each key (model ID) maps to an array of local IDs.
   * @returns A ModelIdMap.
   */
  static fromRaw(t) {
    const i = {};
    for (const n in t)
      i[n] = new Set(t[n]);
    return i;
  }
}
class vce {
  static isEntry(t) {
    return (/* @__PURE__ */ new Set([
      "Boolean",
      "Color",
      "Text",
      "Number",
      "Select",
      "Vector3",
      "TextSet",
      "None"
    ])).has(t.type);
  }
  static copySchema(t, i = {}) {
    for (const n in t) {
      const s = t[n];
      this.isEntry(s) ? i[n] = this.copyEntry(s) : (i[n] = {}, this.copySchema(s, i[n]));
    }
    return i;
  }
  static copyEntry(t) {
    if (t.type === "Boolean") {
      const i = t;
      return {
        type: i.type,
        value: i.value
      };
    }
    if (t.type === "Color") {
      const i = t;
      return {
        type: i.type,
        value: i.value.clone()
      };
    }
    if (t.type === "Text") {
      const i = t;
      return {
        type: i.type,
        value: i.value
      };
    }
    if (t.type === "Number") {
      const i = t;
      return {
        type: i.type,
        value: i.value,
        min: i.min,
        max: i.max,
        interpolable: i.interpolable
      };
    }
    if (t.type === "Select") {
      const i = t;
      return {
        type: i.type,
        value: i.value,
        multiple: i.multiple,
        options: new Set(i.options)
      };
    }
    if (t.type === "Vector3") {
      const i = t;
      return {
        type: i.type,
        value: i.value.clone()
      };
    }
    if (t.type === "TextSet") {
      const i = t;
      return {
        type: i.type,
        value: new Set(i.value)
      };
    }
    if (t.type === "None") {
      const i = t;
      return {
        type: i.type,
        value: i.value
      };
    }
    throw new Error("Invalid entry!");
  }
}
class Hie {
  constructor(t, i, n, s) {
    tt(this, "_component"), tt(this, "name"), tt(this, "uuid"), this._component = t, this.name = n, this.uuid = s ?? y4.create(), i.get(Sue).list.set(this.uuid, this);
  }
  get controls() {
    return vce.copySchema(this._config);
  }
  set(t) {
    for (const i in t)
      if (i in this) {
        const n = i;
        this[n] = t[i].value;
      }
  }
  export(t = this._config, i = {}) {
    for (const n in t) {
      const s = t[n];
      if (vce.isEntry(s))
        if (s.type === "Color") {
          const { r, g: l, b: c } = s.value;
          i[n] = { ...s, value: { r, g: l, b: c } };
        } else if (s.type === "Vector3") {
          const { x: r, y: l, z: c } = s.value;
          i[n] = { ...s, value: { x: r, y: l, z: c } };
        } else if (s.type === "TextSet") {
          const r = Array.from(s.value);
          i[n] = { ...s, value: r };
        } else if (s.type === "Select") {
          const r = Array.from(s.options);
          i[n] = { ...s, options: r };
        } else
          i[n] = { ...s };
      else
        i[n] = {}, this.export(s, i[n]);
    }
    return i;
  }
  import(t, i = {}, n = !0) {
    for (const s in t) {
      const o = t[s];
      if (vce.isEntry(o))
        if (o.type === "Color") {
          const { r: l, g: c, b: h } = o.value;
          i[s] = { ...o, value: new Xn(l, c, h) };
        } else if (o.type === "Vector3") {
          const { x: l, y: c, z: h } = o.value;
          i[s] = { ...o, value: new Ge(l, c, h) };
        } else o.type === "TextSet" ? i[s] = { ...o, value: new Set(o.value) } : o.type === "Select" ? i[s] = { ...o, options: new Set(o.options) } : i[s] = { ...o };
      else
        i[s] = {}, this.import(o, i[s], !1);
    }
    n && this.set(i);
  }
}
const wbe = class Tbe extends bI {
  constructor(t) {
    super(t), tt(this, "list", new f0()), tt(this, "enabled", !0), t.add(Tbe.uuid, this);
  }
};
tt(wbe, "uuid", "b8c764e0-6b24-4e77-9a32-35fa728ee5b4");
let Sue = wbe;
class Rbe {
  constructor(t) {
    tt(this, "_event"), tt(this, "_position", new us()), tt(this, "onDisposed", new es()), tt(this, "updateMouseInfo", (i) => {
      this._event = i;
    }), this.dom = t, this.setupEvents(!0);
  }
  /**
   * The real position of the mouse or touch of the Three.js canvas.
   */
  get position() {
    return this.updatePosition(!1), this._position.clone();
  }
  /**
   * The raw position of the mouse or touch of the Three.js canvas.
   */
  get rawPosition() {
    return this.updatePosition(!0), this._position.clone();
  }
  /** {@link Disposable.dispose} */
  dispose() {
    this.setupEvents(!1), this.onDisposed.trigger(), this.onDisposed.reset();
  }
  updatePosition(t) {
    if (this._event) {
      const i = this.dom.getBoundingClientRect();
      this._position.x = this.getPositionX(i, this._event, t), this._position.y = this.getPositionY(i, this._event, t);
    }
  }
  getPositionY(t, i, n) {
    const s = this.getDataObject(i);
    return n ? s.clientY : -((s.clientY - t.top) / (t.bottom - t.top)) * 2 + 1;
  }
  getPositionX(t, i, n) {
    const s = this.getDataObject(i);
    return n ? s.clientX : (s.clientX - t.left) / (t.right - t.left) * 2 - 1;
  }
  getDataObject(t) {
    return t instanceof MouseEvent ? t : t.touches[0];
  }
  setupEvents(t) {
    t ? (this.dom.addEventListener("pointermove", this.updateMouseInfo), this.dom.addEventListener("touchstart", this.updateMouseInfo)) : (this.dom.removeEventListener("pointermove", this.updateMouseInfo), this.dom.removeEventListener("touchstart", this.updateMouseInfo));
  }
}
const vbe = class Abe extends bI {
  constructor(t) {
    super(t), tt(this, "onDisposed", new es()), tt(this, "onBeforeDispose", new es()), tt(this, "onFragmentsLoaded", new es()), tt(this, "baseCoordinationModel", ""), tt(this, "baseCoordinationMatrix", new Ln()), tt(this, "enabled", !0), tt(this, "_core"), this.components.add(Abe.uuid, this);
  }
  get initialized() {
    return !!this._core;
  }
  /**
   * Map containing all loaded fragment models.
   * The key is the group's unique identifier, and the value is the model itself.
   */
  get list() {
    return this.core.models.list;
  }
  get core() {
    if (!this._core)
      throw new Error("FragmentsManager not initialized. Call init() first.");
    return this._core;
  }
  get _hasCoordinationModel() {
    return this.baseCoordinationModel !== "";
  }
  /** {@link Disposable.dispose} */
  dispose() {
    this.onBeforeDispose.trigger(), this._core && (this.core.dispose(), this._core = void 0), this.baseCoordinationModel = "", this.onFragmentsLoaded.reset(), this.onDisposed.trigger(), this.onDisposed.reset();
  }
  init(t) {
    this._core = new Kqe(t), this.core.onModelLoaded.add(async () => {
      if (this._hasCoordinationModel)
        return;
      const i = [...this.list.values()][0];
      i && (this.baseCoordinationModel = i.modelId, this.baseCoordinationMatrix = await i.getCoordinationMatrix());
    }), this.list.onItemDeleted.add(() => {
      this.list.size > 0 || (this.baseCoordinationModel = "", this.baseCoordinationMatrix = new Ln());
    });
  }
  async raycast(t) {
    const i = [];
    for (const o of this.core.models.list.values())
      if (t.snappingClasses && t.snappingClasses.length > 0) {
        const r = await o.raycastWithSnapping(
          t
        );
        if (r && r.length > 0)
          i.push(r[0]);
        else {
          const l = await o.raycast(t);
          l && i.push(l);
        }
      } else {
        const r = await o.raycast(t);
        r && i.push(r);
      }
    if (await Promise.all(i), i.length === 0)
      return;
    let n = i[0], s = n.distance;
    for (let o = 1; o < i.length; o++)
      i[o].distance < s && (s = i[o].distance, n = i[o]);
    return n;
  }
  async getPositions(t) {
    const i = [], n = async (o, r) => {
      const l = await o.getPositions(r);
      for (const c of l)
        i.push(c);
    }, s = [];
    for (const o in t) {
      const r = this.core.models.list.get(o);
      r && s.push(n(r, Array.from(t[o])));
    }
    return await Promise.all(s), i;
  }
  async getBBoxes(t) {
    const i = [], n = async (o, r) => {
      const l = await o.getBoxes(r);
      if (l)
        for (const c of l)
          i.push(c);
    }, s = [];
    for (const o in t) {
      const r = this.core.models.list.get(o);
      r && s.push(n(r, Array.from(t[o])));
    }
    return await Promise.all(s), i;
  }
  async highlight(t, i) {
    await this.forEachModel(i, "highlight", t);
  }
  /**
   * Retrieves data for specified items from multiple models.
   *
   * @param items A map of model IDs to an array of local IDs, specifying which items to retrieve data for.
   * @param config Optional configuration for data retrieval.
   * @returns A record mapping model IDs to an array of item data.
   */
  async getData(t, i) {
    const n = {};
    for (const [s, o] of Object.entries(t)) {
      const r = this.list.get(s);
      if (!r)
        continue;
      if (o.size === 0) {
        n[s] = [];
        continue;
      }
      const l = await r.getItemsData([...o], i);
      n[s] = l;
    }
    return n;
  }
  async resetHighlight(t) {
    await this.forEachModel(t, "resetHighlight");
  }
  async forEachModel(t, i, ...n) {
    const s = {};
    if (t)
      for (const r in t) {
        const l = t[r];
        s[r] = Array.from(l);
      }
    else
      for (const r of this.core.models.list.keys())
        s[r] = void 0;
    const o = [];
    for (const r in s) {
      const l = this.core.models.list.get(r);
      if (l) {
        const c = s[r], h = l[i](c, ...n);
        o.push(h);
      }
    }
    await Promise.all(o);
  }
  /**
   * Converts a collection of IFC GUIDs to a fragmentIdMap.
   *
   * @param guids - An iterable collection of global IDs to be converted to a fragment ID map.
   *
   * @returns A fragment ID map, where the keys are fragment IDs and the values are the corresponding express IDs.
   */
  async guidsToModelIdMap(t) {
    const i = {};
    for (const [n, s] of this.list) {
      const o = (await s.getLocalIdsByGuids([...t])).filter(
        (r) => r !== null
      );
      i[n] = new Set(o);
    }
    return i;
  }
  /**
   * Converts a fragment ID map to a collection of GUIDs.
   *
   * @param modelIdMap - A ModelIdMap to be converted to a collection of GUIDs.
   *
   * @returns An array of GUIDs.
   */
  async modelIdMapToGuids(t) {
    const i = [];
    for (const [n, s] of Object.entries(t)) {
      const o = this.list.get(n);
      if (!o)
        continue;
      const r = (await o.getGuidsByLocalIds([...s])).filter(
        (l) => l !== null
      );
      i.push(...r);
    }
    return i;
  }
  // /**
  //  * Applies coordinate transformation to the provided models.
  //  * If no models are provided, all groups are used.
  //  * The first model in the list becomes the base model for coordinate transformation.
  //  * All other models are then transformed to match the base model's coordinate system.
  //  *
  //  * @param models - The models to apply coordinate transformation to.
  //  * If not provided, all models are used.
  //  */
  // coordinate(models = Array.from(this.groups.values())) {
  //   const isFirstModel = this.baseCoordinationModel.length === 0;
  //   if (isFirstModel) {
  //     const first = models.pop();
  //     if (!first) {
  //       return;
  //     }
  //     this.baseCoordinationModel = first.uuid;
  //     this.baseCoordinationMatrix = first.coordinationMatrix.clone();
  //   }
  //   if (!models.length) {
  //     return;
  //   }
  //   for (const model of models) {
  //     if (model.coordinationMatrix.equals(this.baseCoordinationMatrix)) {
  //       continue;
  //     }
  //     model.position.set(0, 0, 0);
  //     model.rotation.set(0, 0, 0);
  //     model.scale.set(1, 1, 1);
  //     model.updateMatrix();
  //     this.applyBaseCoordinateSystem(model, model.coordinationMatrix);
  //   }
  // }
  /**
   * Applies the base coordinate system to the provided object.
   *
   * This function takes an object and its original coordinate system as input.
   * It then inverts the original coordinate system and applies the base coordinate system
   * to the object. This ensures that the object's position, rotation, and scale are
   * transformed to match the base coordinate system (which is taken from the first model loaded).
   *
   * @param object - The object to which the base coordinate system will be applied.
   * This should be an instance of THREE.Object3D.
   *
   * @param originalCoordinateSystem - The original coordinate system of the object.
   * This should be a THREE.Matrix4 representing the object's transformation matrix.
   */
  applyBaseCoordinateSystem(t, i) {
    const n = new Ln();
    return i && n.copy(i.clone()).invert(), n.multiply(this.baseCoordinationMatrix), t.applyMatrix4(n), n;
  }
};
tt(vbe, "uuid", "fef46874-46a3-461b-8c44-2922ab77c806");
let Io = vbe;
class AKe {
  constructor() {
    tt(this, "wasm", {
      path: "",
      absolute: !1,
      logLevel: Mie.LOG_LEVEL_OFF
    }), tt(this, "webIfc", {
      COORDINATE_TO_ORIGIN: !0
      // OPTIMIZE_PROFILES: true,
    }), tt(this, "autoSetWasm", !0), tt(this, "customLocateFileHandler", null);
  }
}
const Sbe = class HIe extends bI {
  constructor(t) {
    super(t), tt(this, "onDisposed", new es()), tt(this, "onIfcStartedLoading", new es()), tt(this, "onIfcImporterInitialized", new es()), tt(this, "onSetup", new es()), tt(this, "settings", new AKe()), tt(this, "webIfc", new jW()), tt(this, "enabled", !0), this.components.add(HIe.uuid, this);
  }
  /** {@link Disposable.dispose} */
  dispose() {
    this.webIfc = null, this.onDisposed.trigger(HIe.uuid), this.onDisposed.reset();
  }
  /**
   * Sets up the IfcLoader component with the provided configuration.
   *
   * @param config - Optional configuration settings for the IfcLoader.
   * If not provided, the existing settings will be used.
   *
   * @returns A Promise that resolves when the setup process is completed.
   *
   * @remarks
   * If the `autoSetWasm` option is enabled in the configuration,
   * the method will automatically set the WASM paths for the Web-IFC library.
   *
   * @example
   * ```typescript
   * const ifcLoader = new IfcLoader(components);
   * await ifcLoader.setup({ autoSetWasm: true });
   * ```
   */
  async setup(t) {
    this.settings = { ...this.settings, ...t }, this.settings.autoSetWasm && await this.autoSetWasm(), this.onSetup.trigger();
  }
  /**
   * Loads an IFC file and processes it for 3D visualization.
   *
   * @param data - The Uint8Array containing the IFC file data.
   * @param coordinate - Boolean indicating whether to coordinate the loaded IFC data. Default is true.
   * @param name - Name for the fragments model.
   * @param config - Optional extra data for loading the IFC.
   *
   * @returns A Promise that resolves to the FragmentsModel containing the loaded and processed IFC data.
   *
   * @example
   * ```typescript
   * const ifcLoader = components.get(IfcLoader);
   * const model = await ifcLoader.load(ifcData);
   * ```
   */
  async load(t, i, n, s) {
    const o = this.components.get(Io);
    if (!o.initialized)
      throw new Error("You need to initialize fragments first.");
    this.settings.autoSetWasm && await this.autoSetWasm(), o.core.settings.autoCoordinate = i;
    const r = new t$e();
    r.wasm.path = this.settings.wasm.path, r.wasm.absolute = this.settings.wasm.absolute, r.webIfcSettings = this.settings.webIfc, this.onIfcImporterInitialized.trigger(r), s != null && s.instanceCallback && s.instanceCallback(r);
    const l = await r.process({
      ...s == null ? void 0 : s.processData,
      bytes: t
    });
    return await o.core.load(l, {
      modelId: n,
      userData: s == null ? void 0 : s.userData
    });
  }
  /**
   * Reads an IFC file and initializes the Web-IFC library.
   *
   * @param data - The Uint8Array containing the IFC file data.
   *
   * @returns A Promise that resolves when the IFC file is opened and initialized.
   *
   * @remarks
   * This method sets the WASM path and initializes the Web-IFC library based on the provided settings.
   * It also opens the IFC model using the provided data and settings.
   *
   * @example
   * ```typescript
   * const ifcLoader = components.get(IfcLoader);
   * await ifcLoader.readIfcFile(ifcData);
   * ```
   */
  async readIfcFile(t) {
    const { path: i, absolute: n, logLevel: s } = this.settings.wasm;
    return this.webIfc.SetWasmPath(i, n), await this.webIfc.Init(this.settings.customLocateFileHandler || void 0), s && this.webIfc.SetLogLevel(s), this.webIfc.OpenModel(t, this.settings.webIfc);
  }
  /**
   * Cleans up the IfcLoader component by resetting the Web-IFC library,
   * clearing the visited fragments and fragment instances maps, and creating a new instance of the Web-IFC library.
   *
   * @remarks
   * This method is called automatically after using the .load() method, so usually you don't need to use it manually.
   *
   * @example
   * ```typescript
   * const ifcLoader = components.get(IfcLoader);
   * ifcLoader.cleanUp();
   * ```
   */
  cleanUp() {
    try {
      this.webIfc.Dispose();
    } catch {
      console.log("Web-ifc wasn't disposed.");
    }
    this.webIfc = null, this.webIfc = new jW();
  }
  async autoSetWasm() {
    const t = await fetch(
      `https://unpkg.com/@thatopen/components@${Gme.release}/package.json`
    );
    if (!t.ok) {
      console.warn(
        "Couldn't get openbim-components package.json. Set wasm settings manually."
      );
      return;
    }
    const i = await t.json();
    if (!("web-ifc" in i.peerDependencies))
      console.warn(
        "Couldn't get web-ifc from peer dependencies in openbim-components. Set wasm settings manually."
      );
    else {
      const n = i.peerDependencies["web-ifc"];
      this.settings.wasm.path = `https://unpkg.com/web-ifc@${n}/`, this.settings.wasm.absolute = !0;
    }
  }
};
tt(Sbe, "uuid", "a659add7-1418-4771-a0d6-7d4d438e4624");
let jwe = Sbe;
const bbe = class Nbe extends bI {
  constructor(t) {
    super(t), tt(this, "enabled", !0), this.components.add(Nbe.uuid, this);
  }
  /**
   * Sets the visibility of fragment items within the 3D scene.
   * If no `modelIdMap` parameter is provided, all fragments will be set to the specified visibility.
   * If it is provided, only the specified fragment items will be affected.
   *
   * @param visible - The visibility state to set for the items.
   * @param modelIdMap - An optional map of modelIds and their corresponding itemIds to be affected.
   * If not provided, all fragment items will be affected.
   */
  async set(t, i) {
    const n = this.components.get(Io), s = [];
    if (i)
      for (const [o, r] of Object.entries(i)) {
        const l = n.list.get(o);
        l && s.push(l.setVisible([...r], t));
      }
    else
      for (const o of n.list.values())
        s.push(o.setVisible(void 0, t));
    await Promise.all(s), await n.core.update(!0);
  }
  /**
   * Isolates fragments within the 3D scene by hiding all other fragments and showing only the specified ones.
   * It calls the `set` method twice: first to hide all fragments, and then to show only the specified ones.
   *
   * @param modelIdMap - A map of model IDs and their corresponding itemIds to be isolated.
   */
  async isolate(t) {
    await Promise.all([
      this.set(!1),
      // Hides all fragments
      this.set(!0, t)
      // Shows only the specified fragments
    ]);
  }
  /**
   * Toggles the visibility of specified items in the fragments.
   *
   * @param modelIdMap - An object where the keys are model IDs and the values are arrays of local IDs representing the fragments to be toggled.
   * @returns A promise that resolves when all visibility toggles and the core update are complete.
   */
  async toggle(t) {
    const i = [], n = this.components.get(Io);
    for (const [s, o] of Object.entries(t)) {
      const r = n.list.get(s);
      r && i.push(r.toggleVisible([...o]));
    }
    await Promise.all(i), await n.core.update(!0);
  }
  /**
   * Asynchronously retrieves a map of model IDs to their corresponding item IDs based on visibility state.
   *
   * @param state - The visibility state to filter items by.
   * @param modelIds - Optional array of model IDs to filter the items. If not provided, all models will be considered.
   * @returns A promise that resolves to a ModelIdMap record where the keys are model IDs and the values are arrays of item IDs that match the visibility state.
   */
  async getVisibilityMap(t, i) {
    const n = [], s = [], o = this.components.get(Io);
    if (i)
      for (const c of i) {
        const h = o.list.get(c);
        h && (n.push(h.modelId), s.push(h.getItemsByVisibility(t)));
      }
    else
      for (const c of o.list.values())
        n.push(c.modelId), s.push(c.getItemsByVisibility(t));
    const r = await Promise.all(s), l = {};
    for (const [c, h] of n.entries())
      l[h] = r[c];
    return l;
  }
};
tt(bbe, "uuid", "dd9ccf2d-8a21-4821-b7f6-2949add16a29");
let SKe = bbe;
const Dbe = class GIe extends bI {
  constructor(t) {
    super(t), tt(this, "enabled", !0), tt(this, "onDisposed", new es()), tt(this, "list", new OA()), this.components.add(GIe.uuid, this);
  }
  /** {@link Disposable.dispose} */
  dispose(t = !0) {
    this.list.clear(), this.onDisposed.trigger(GIe.uuid), t && (this.onDisposed.reset(), this.list.eventsEnabled = !1, this.list.dispose());
  }
  /**
   * Combines all bounding boxes in the `list` property into a single bounding box.
   *
   * @returns A `THREE.Box3` instance representing the union of all bounding boxes in the `list`.
   */
  get() {
    const t = new Zs();
    for (const i of this.list)
      t.union(i);
    return t;
  }
  /**
   * Asynchronously adds bounding boxes to the list by merging boxes from models
   * specified in the provided `ModelIdMap`.
   *
   * @param items - A map where keys are model IDs and values are arrays of local IDs
   *                representing specific parts of the models to include in the bounding box.
   */
  async addFromModelIdMap(t) {
    const i = this.components.get(Io), n = new Zs();
    for (const [s, o] of Object.entries(t)) {
      const r = i.list.get(s);
      if (!r)
        continue;
      const l = await r.getMergedBox([...o]);
      n.union(l);
    }
    this.list.add(n);
  }
  /**
   * Adds bounding boxes from models to the current list based on optional filtering criteria.
   *
   * @param modelIds - An optional array of regular expressions used to filter models by their IDs.
   *                   If provided, only models whose IDs match at least one of the regular expressions
   *                   will have their bounding boxes added to the list. If not, all models will be used.
   */
  addFromModels(t) {
    const i = this.components.get(Io);
    for (const [n, s] of i.list)
      t && !t.some((o) => o.test(n)) || this.list.add(s.box);
  }
  /**
   * Calculates and returns the center point of the bounding box derived from the provided model ID map.
   *
   * @param modelIdMap - A mapping of model IDs and localIds used to generate the bounding box.
   * @returns A `THREE.Vector3` object representing the center point of the bounding box.
   */
  async getCenter(t) {
    this.list.clear(), await this.addFromModelIdMap(t);
    const i = this.get();
    this.list.clear();
    const n = new Ge();
    return i.getCenter(n), n;
  }
  /**
   * Calculates the camera orientation and position based on the specified orientation
   * and an optional offset factor.
   *
   * @param orientation - Specifies the direction of the camera relative to the bounding box.
   * @param offsetFactor - A multiplier applied to the distance between the camera and the bounding box.
   *                       Defaults to `1`.
   * @returns An object containing:
   *          - `position`: A `THREE.Vector3` representing the calculated camera position.
   *          - `target`: A `THREE.Vector3` representing the center of the bounding box, which the camera should target.
   */
  async getCameraOrientation(t, i = 1) {
    const n = this.components.get(Io);
    this.list.clear();
    for (const [h, I] of n.list)
      this.list.add(I.box);
    const s = this.get();
    this.list.clear();
    const o = new Ge();
    s.getCenter(o);
    const r = new Ge();
    s.getSize(r);
    const l = Math.max(r.x, r.y, r.z) * i, c = new Ge();
    switch (t) {
      case "front":
        c.set(o.x, o.y, o.z + l);
        break;
      case "back":
        c.set(o.x, o.y, o.z - l);
        break;
      case "left":
        c.set(o.x - l, o.y, o.z);
        break;
      case "right":
        c.set(o.x + l, o.y, o.z);
        break;
      case "top":
        c.set(o.x, o.y + l, o.z);
        break;
      case "bottom":
        c.set(o.x, o.y - l, o.z);
        break;
      default:
        c.set(o.x, o.y, o.z + l);
    }
    return { position: c, target: o };
  }
};
tt(Dbe, "uuid", "d1444724-dba6-4cdd-a0c7-68ee1450d166");
let Cbe = Dbe;
class bKe {
  constructor(t, i) {
    tt(this, "name", "Query"), tt(this, "customData", {}), tt(this, "_components"), tt(this, "_queries", []), tt(this, "_aggregation", "exclusive"), tt(this, "result", null), tt(this, "cache", !0), tt(this, "serializeQueryParameters", (n) => {
      var s;
      return {
        categories: (s = n.categories) == null ? void 0 : s.map((r) => r.source),
        attributes: n.attributes ? {
          aggregation: n.attributes.aggregation,
          queries: n.attributes.queries.map(
            this.serializeAttributeQuery
          )
        } : void 0,
        relation: n.relation ? {
          name: n.relation.name,
          query: n.relation.query ? this.serializeQueryParameters(n.relation.query) : void 0
        } : void 0
      };
    }), tt(this, "deserializeQueryParameters", (n) => {
      var s;
      return {
        categories: (s = n.categories) == null ? void 0 : s.map((r) => new RegExp(r)),
        attributes: n.attributes ? {
          aggregation: n.attributes.aggregation,
          queries: n.attributes.queries.map(
            this.deserializeAttributeQuery
          )
        } : void 0,
        relation: n.relation ? {
          name: n.relation.name,
          query: n.relation.query ? this.deserializeQueryParameters(n.relation.query) : void 0
        } : void 0
      };
    }), this._components = t, this.queries = i;
  }
  /**
   * The query parameters used to find items.
   */
  set queries(t) {
    this._queries = t, this.clearCache();
  }
  get queries() {
    return this._queries;
  }
  /**
   * Sets the aggregation value (AND/OR) for the query and resets the cache if the new value differs.
   */
  set aggregation(t) {
    t !== this._aggregation && this.clearCache(), this._aggregation = t;
  }
  get aggregation() {
    return this._aggregation;
  }
  /**
   * Executes the finder query to retrieve items based on the configured query and optional model IDs.
   *
   * @param config - Optional configuration object.
   * @param config.modelIds - Optional array of model IDs to filter the search.
   * @param config.force - Optional boolean to force a new search, bypassing the cache. Defaults to `false`.
   * @returns A promise that resolves to a `ModelIdMap` containing the search results.
   */
  async test(t) {
    const { modelIds: i, force: n } = { force: !1, ...t };
    if (this.result && !n)
      return this.result;
    const o = await this._components.get(zJ).getItems(this.queries, {
      modelIds: i,
      aggregation: this.aggregation
    });
    return this.cache && (this.result = o), o;
  }
  /**
   * Clears the cached result of the query, forcing a re-evaluation on the next access.
   */
  clearCache() {
    this.result = null;
  }
  serializeAttributeQuery(t) {
    let i;
    return Array.isArray(t.value) ? i = t.value.map((s) => s.source) : t.value instanceof RegExp ? i = t.value.source : i = t.value, {
      name: t.name.source,
      value: i,
      type: t.type instanceof RegExp ? t.type.source : t.type,
      negate: t.negate,
      itemIds: t.itemIds
    };
  }
  /**
   * Serializes the finder query into a JSON-compatible format.
   * Converts regular expressions to strings.
   *
   * @returns A `SerializedFinderQuery` object representing the serialized query.
   */
  toJSON() {
    return {
      guid: this._components.get(zJ).list.getKey(this) ?? y4.create(),
      name: this.name,
      customData: this.customData,
      queries: this.queries.map(this.serializeQueryParameters),
      aggregation: this.aggregation,
      cache: this.cache
    };
  }
  deserializeAttributeQuery(t) {
    let i;
    return Array.isArray(t.value) ? i = t.value.map((s) => new RegExp(s)) : typeof t.value == "string" ? i = new RegExp(t.value) : i = t.value, {
      name: new RegExp(t.name),
      value: i,
      type: t.type ? new RegExp(t.type) : void 0,
      negate: t.negate,
      itemIds: t.itemIds
    };
  }
  /**
   * Deserializes a JSON object into a `FinderQuery` instance.
   *
   * @param data - A `SerializedFinderQuery` object representing the serialized query.
   * @returns A `FinderQuery` instance.
   */
  fromJSON(t) {
    return this.name = t.name, this.customData = t.customData, this.aggregation = t.aggregation, this.cache = t.cache, this.queries = t.queries.map(this.deserializeQueryParameters), this;
  }
}
const Obe = class Lbe extends bI {
  constructor(t) {
    super(t), tt(this, "enabled", !0), tt(this, "list", new f0()), t.add(Lbe.uuid, this);
  }
  // private clearCache() {
  //   for (const [, finderQuery] of this.list) {
  //     finderQuery.clearCache();
  //   }
  // }
  /**
   * Retrieves items from specified models based on a query.
   *
   * @param queries - The query parameters to filter items.
   * @param modelIds - Optional array of model IDs to include in the search. If not provided, all models are searched.
   * @returns A map of model IDs to sets of item IDs that match the query.
   */
  async getItems(t, i) {
    let n;
    if (i) {
      const { modelIds: c, items: h } = i;
      if (h) {
        const I = Object.keys(h);
        I.length > 0 && (n = I.map((p) => new RegExp(`^${p}$`)));
      } else c && (n = c);
    }
    const s = (i == null ? void 0 : i.aggregation) ?? "exclusive", o = this.components.get(Io), r = await Promise.all(
      t.map(async (c) => {
        const h = {};
        return await Promise.all(
          Array.from(o.list).map(async ([I, p]) => {
            var y;
            if (n && !n.some((C) => C.test(I)))
              return;
            const m = (y = i == null ? void 0 : i.items) == null ? void 0 : y[I], A = await p.getItemsByQuery(c, { localIds: m ? [...m] : void 0 });
            h[I] = new Set(A);
          })
        ), h;
      })
    );
    return s === "inclusive" ? TI.join(r) : TI.intersect(r);
  }
  /**
   * Creates a new FinderQuery instance and adds it to the list of queries.
   *
   * @param name - The name of the query.
   * @param queries - The queries to use.
   * @returns The newly created FinderQuery instance.
   */
  create(t, i) {
    const n = new bKe(this.components, i);
    return this.list.set(t, n), n;
  }
  /**
   * Adds queries based on categories from items that have geometry.
   *
   * @param modelIds - An optional array of model IDs to filter fragments. If not provided, all fragments are processed.
   * @returns An array with the categories used to create the queries
   */
  async addFromCategories(t) {
    const i = /* @__PURE__ */ new Set(), n = this.components.get(Io);
    for (const [s, o] of n.list) {
      if (t && !t.some((c) => c.test(s)))
        continue;
      const r = (await o.getItemsWithGeometryCategories()).filter(
        (c) => c !== null
      ), l = new Set(r);
      for (const c of l)
        this.list.has(c) || (this.create(c, [{ categories: [new RegExp(`^${c}$`)] }]), i.add(c));
    }
    return [...i];
  }
  /**
   * Imports a list of `FinderQuery` instances from a `SerializationResult` containing serialized finder query data.
   *
   * @param result - The `SerializationResult` containing the serialized `SerializedFinderQuery` data.
   * @returns An array of `FinderQuery` instances created from the serialized data. Returns an empty array if the input data is null or undefined.
   */
  import(t) {
    const { data: i } = t, n = [];
    if (!i)
      return n;
    for (const s of i) {
      const o = this.create(s.guid, []);
      o.fromJSON(s), n.push(o);
    }
    return n;
  }
  /**
   * Serializes the ItemsFinder's data into a format suitable for export.
   *
   * @returns An object containing an array of serialized finder queries.
   */
  export() {
    const t = [];
    for (const [i, n] of this.list.entries()) {
      const o = {
        ...n.toJSON(),
        name: i
      };
      t.push(o);
    }
    return { data: t };
  }
};
tt(Obe, "uuid", "0da7ad77-f734-42ca-942f-a074adfd1e3a");
let zJ = Obe;
const NKe = class _be extends bI {
  constructor(t) {
    super(t), tt(this, "enabled", !0), tt(this, "onDisposed", new es()), tt(this, "list", new f0()), tt(this, "defaultSaveFunction", (n) => "value" in n.Name ? n.Name.value : null), tt(this, "onBeforeFragmentsDispose", async (n) => {
      const { key: s, value: o } = n, r = await o.getLocalIds(), l = { [s]: new Set(r) };
      this.removeItems(l);
    }), t.add(_be.uuid, this), this.setupEvents(), t.get(Io).list.onBeforeDelete.add(this.onBeforeFragmentsDispose);
  }
  setupEvents() {
    this.list.onBeforeDelete.add(({ value: t }) => t.dispose());
  }
  getClassificationGroups(t) {
    let i = this.list.get(t);
    return i || (i = new f0(), this.list.set(t, i)), i;
  }
  getModelItems(t, i, n) {
    const { map: s } = this.getGroupData(t, i);
    let o = s[n];
    return o || (o = /* @__PURE__ */ new Set(), s[n] = o), o;
  }
  /**
   * Retrieves data associated with a specific group within a classification.
   * If the group data does not exist, it creates a new entry.
   *
   * @param classification - The classification string.
   * @param group - The group string within the classification.
   * @returns The data object associated with the group, containing a map and a `get` method.
   */
  getGroupData(t, i) {
    const n = this.components.get(zJ), s = this.getClassificationGroups(t);
    let o = s.get(i);
    return o || (o = {
      map: {},
      // TODO: Evaluate if this is the best option for this
      get() {
        return new Promise((r) => {
          if (!o) {
            r({});
            return;
          }
          if (o.query) {
            const { name: l, config: c } = o.query, h = n.list.get(l);
            if (!h)
              throw new Error(
                "Classifier: the query name associated with the group doesn't exist in the ItemsFinder component"
              );
            h.test(c).then((I) => {
              if (!o) {
                r({});
                return;
              }
              const p = TI.join([I, o.map]);
              r(p);
            });
          } else
            r(o.map);
        });
      }
    }, s.set(i, o)), o;
  }
  /**
   * Aggregates items based on a classification and query, applying a provided function to each item.
   *
   * @param classification - The classification string used to categorize the items.
   * @param query - The query parameters used to find items.
   * @param config - Optional configuration for data and item processing.
   * @param config.data - Optional data configuration to pass to the item retrieval.
   * @param config.aggregationCallback - Optional function to apply to each item; defaults to `this.defaultSaveFunction` if not provided.
   *                       This function receives the item data and a register function to associate item local IDs with names.
   *                       If no function is provided, the default save function is used.
   *
   * @remarks
   * The `register` function within the `config.func` allows associating item local IDs with a given name under the specified classification.
   * It is used to keep track of which items belong to which classification.
   */
  async aggregateItems(t, i, n) {
    const s = (n == null ? void 0 : n.data) ?? void 0, o = (n == null ? void 0 : n.aggregationCallback) ?? this.defaultSaveFunction, r = this.components.get(Io), c = await this.components.get(zJ).getItems([i], {
      modelIds: n == null ? void 0 : n.modelIds
    });
    for (const [h, I] of Object.entries(c)) {
      const p = r.list.get(h);
      if (!p)
        continue;
      const y = (A, ...C) => {
        const O = this.getModelItems(t, A, h);
        for (const R of C)
          O.add(R);
      }, m = await p.getItemsData([...I], s);
      for (const A of m)
        o(A, y);
    }
  }
  /**
   * Adds items to a specific group within a classification.
   *
   * @param classification - The classification to which the group belongs.
   * @param group - The group to which the items will be added.
   * @param items - A map of model IDs to add to the group.
   */
  addGroupItems(t, i, n) {
    const { map: s } = this.getGroupData(t, i);
    TI.add(s, n);
  }
  /**
   * Sets the query for a specific group within a classification.
   *
   * @param classification - The classification to target.
   * @param group - The group within the classification to target.
   * @param query - The query to set for the group.
   */
  setGroupQuery(t, i, n) {
    const s = this.getGroupData(t, i);
    s.query = n;
  }
  /**
   * Asynchronously finds a set of ModelIdMaps based on the provided classification data.
   * @param data An object with classifications as keys and an array of groups as values.
   * @returns A promise that resolves to a ModelIdMap representing the intersection of all ModelIdMaps found.
   */
  async find(t) {
    const i = [];
    for (const [s, o] of Object.entries(t)) {
      const r = [], l = this.list.get(s);
      if (!l)
        continue;
      for (const h of o) {
        const I = l.get(h);
        if (!I)
          continue;
        const p = await I.get();
        r.push(p);
      }
      const c = TI.join(r);
      i.push(c);
    }
    return TI.intersect(i);
  }
  /**
   * From the items passing the query, use the specified relation to create groupings
   * This method retrieves and processes related items, applying a custom aggregation callback to register
   * relations between items based on their attributes and local IDs.
   *
   * @param classification - The classification type used to filter items.
   * @param query - Query parameters for filtering items, defined by `FRAGS.ItemsQueryParams`.
   * @param relation - The type of relation to aggregate (e.g., "ContainedInStructure", "HasAssociations").
   * @param config - Optional configuration for the aggregation process.
   * @returns A promise that resolves when the aggregation process is complete.
   * @remarks
   * - The `aggregationCallback` function processes each item and registers relations based on the item's
   *   attribute value and the local ID of its relations.
   * - Items without the specified attribute or relations are ignored during aggregation.
   */
  async aggregateItemRelations(t, i, n, s) {
    const o = (s == null ? void 0 : s.attribute) ?? "Name", r = {
      relations: {
        [n]: { attributes: !0, relations: !1 }
      }
    };
    await this.aggregateItems(t, i, {
      modelIds: s == null ? void 0 : s.modelIds,
      data: r,
      aggregationCallback: (l, c) => {
        if (!(l != null && l[o]))
          return;
        const h = l[o];
        if (!("value" in h))
          return;
        const I = l[n];
        if (Array.isArray(I))
          for (const p of I)
            "value" in p._localId && c(h.value, p._localId.value);
      }
    });
  }
  /**
   * Asynchronously processes and adds classifications by IfcBuildingStorey.
   * @param config - Optional configuration for adding classifications.
   * @returns A promise that resolves once the storeys have been processed and added.
   */
  async byIfcBuildingStorey(t) {
    await this.aggregateItemRelations(
      (t == null ? void 0 : t.classificationName) ?? "Storeys",
      { categories: [/BUILDINGSTOREY/] },
      "ContainsElements",
      { modelIds: t == null ? void 0 : t.modelIds }
    );
  }
  /**
   * Asynchronously processes and adds classifications by category.
   * @param config - Optional configuration for adding classifications.
   * @returns A promise that resolves once the categories have been processed and added.
   */
  async byCategory(t) {
    const n = await this.components.get(zJ).addFromCategories(t == null ? void 0 : t.modelIds);
    for (const s of n)
      this.setGroupQuery((t == null ? void 0 : t.classificationName) ?? "Categories", s, {
        name: s
      });
  }
  /** {@link Disposable.dispose} */
  dispose() {
    this.list.clear(), this.components.get(Io).list.onBeforeDelete.remove(this.onBeforeFragmentsDispose), this.onDisposed.trigger();
  }
  /**
   * Removes items from the classifier based on the provided model ID map and configuration.
   *
   * @param modelIdMap - A map containing model IDs to be removed.
   * @param config - Optional configuration for removing items.s.
   * @remarks If no configuration is provided, items will be removed from all classifications
   */
  removeItems(t, i) {
    if (i && i.classificationName) {
      const n = this.list.get(i.classificationName);
      if (!n || i.groupName && !n.get(i.groupName))
        return;
      for (const [, s] of n)
        TI.remove(s.map, t);
      return;
    }
    for (const [, n] of this.list.entries())
      for (const [, s] of n)
        TI.remove(s.map, t);
  }
  /**
   * Asynchronously processes models based on the provided configuration and updates classification groups.
   *
   * @param config - Optional configuration for adding classifications. Contains the following properties.
   * @returns A promise that resolves when the processing is complete.
   */
  async byModel(t) {
    const i = this.components.get(Io), n = (t == null ? void 0 : t.classificationName) ?? "Models";
    for (const [s, o] of i.list) {
      if (t && t.modelIds && !t.modelIds.some((c) => c.test(s)))
        continue;
      const r = await o.getItemsIdsWithGeometry(), l = { [s]: new Set(r) };
      this.getGroupData(n, s), this.addGroupItems(n, s, l);
    }
  }
  // /**
  //  * Exports the computed classification to persists them and import them back
  //  * later for faster loading.
  //  */
  // export() {
  //   const exported: ExportedClassification = {};
  //   for (const systemName in this.list) {
  //     exported[systemName] = {};
  //     const system = this.list[systemName];
  //     for (const groupName in system) {
  //       const group = system[groupName];
  //       exported[systemName][groupName] = {
  //         map: FRAGS.FragmentUtils.export(group.map),
  //         name: group.name,
  //         id: group.id,
  //       };
  //     }
  //   }
  //   return exported;
  // }
  // /**
  //  * Imports a classification previously exported with .export().
  //  * @param data the serialized classification to import.
  //  */
  // import(data: ExportedClassification) {
  //   for (const systemName in data) {
  //     if (!this.list[systemName]) {
  //       this.list[systemName] = {};
  //     }
  //     const system = data[systemName];
  //     for (const groupName in system) {
  //       const group = system[groupName];
  //       this.list[systemName][groupName] = {
  //         map: FRAGS.FragmentUtils.import(group.map),
  //         name: group.name,
  //         id: group.id,
  //       };
  //     }
  //   }
  //
};
tt(NKe, "uuid", "e25a7f3c-46c4-4a14-9d3d-5115f24ebeb7");
class DKe {
  constructor(t, i) {
    tt(this, "enabled", !0), tt(this, "components"), tt(this, "onDisposed", new es()), tt(this, "mouse"), tt(this, "world"), tt(this, "debugMode", !1), tt(this, "colorToModelId", /* @__PURE__ */ new Map()), tt(this, "modelIdToColor", /* @__PURE__ */ new Map()), tt(this, "renderTarget"), tt(this, "renderTargetSize", new us()), tt(this, "debugCanvas"), tt(this, "debugContainer"), tt(this, "colorMaterials", /* @__PURE__ */ new Map()), tt(this, "originalMaterials", /* @__PURE__ */ new Map()), tt(this, "originalLodColors", /* @__PURE__ */ new Map()), tt(this, "colorsNeedUpdate", !0);
    const n = i.renderer;
    if (!n)
      throw new Error("A renderer is needed for the FastModelPicker to work!");
    this.world = i, this.mouse = new Rbe(n.three.domElement), this.components = t, this.setupRenderTarget(), this.setupFragmentListeners();
  }
  /**
   * Sets up listeners for fragment model changes.
   */
  setupFragmentListeners() {
    const t = this.components.get(Io);
    t.list.onItemSet.add(() => {
      this.colorsNeedUpdate = !0;
    }), t.list.onItemDeleted.add(() => {
      this.colorsNeedUpdate = !0;
    });
  }
  /**
   * Sets up the render target for color-coded picking.
   */
  setupRenderTarget() {
    const i = this.world.renderer.three.getSize(new us());
    this.renderTargetSize.copy(i), this.renderTarget = new qP(i.x, i.y), this.renderTarget.texture.format = y5, this.renderTarget.texture.type = PA, this.debugMode && this.setupDebugCanvas(), this.world.renderer.onResize.add((n) => {
      this.renderTargetSize.copy(n), this.renderTarget.setSize(n.x, n.y), this.debugCanvas && (this.debugCanvas.width = n.x, this.debugCanvas.height = n.y);
    });
  }
  /**
   * Sets up the debug canvas for visualization.
   */
  setupDebugCanvas() {
    if (this.debugCanvas)
      return;
    const t = this.world.renderer.three.getSize(new us());
    this.debugContainer = document.createElement("div"), this.debugContainer.style.position = "fixed", this.debugContainer.style.top = "10px", this.debugContainer.style.right = "10px", this.debugContainer.style.width = "300px", this.debugContainer.style.height = "300px", this.debugContainer.style.border = "2px solid #fff", this.debugContainer.style.backgroundColor = "#000", this.debugContainer.style.zIndex = "10000", this.debugContainer.style.pointerEvents = "none", this.debugCanvas = document.createElement("canvas"), this.debugCanvas.width = t.x, this.debugCanvas.height = t.y, this.debugCanvas.style.width = "100%", this.debugCanvas.style.height = "100%", this.debugCanvas.style.imageRendering = "pixelated", this.debugContainer.appendChild(this.debugCanvas), document.body.appendChild(this.debugContainer);
  }
  /**
   * Generates a deterministic color for a model based on its ID.
   * This ensures the same model always gets the same color.
   */
  generateColorForModel(t) {
    let i = 0;
    for (let l = 0; l < t.length; l++)
      i = (i << 5) - i + t.charCodeAt(l), i &= i;
    let n = Math.abs(i) % 16777215;
    n === 0 && (n = 1);
    const s = n >> 16 & 255 || 1, o = n >> 8 & 255 || 1, r = n & 255 || 1;
    return new Xn(s / 255, o / 255, r / 255);
  }
  /**
   * Converts a color to a numeric ID.
   */
  colorToId(t) {
    const i = Math.round(t.r * 255), n = Math.round(t.g * 255), s = Math.round(t.b * 255);
    return i << 16 | n << 8 | s;
  }
  /**
   * Assigns unique colors to all fragment models.
   * Colors are deterministic based on model ID, so the same model always gets the same color.
   */
  assignColors() {
    const t = this.components.get(Io);
    if (t.initialized) {
      if (!this.colorsNeedUpdate) {
        const i = new Set(t.list.keys()), n = new Set(this.modelIdToColor.keys());
        (i.size !== n.size || [...i].some((s) => !n.has(s))) && (this.colorsNeedUpdate = !0);
      }
      if (this.colorsNeedUpdate) {
        this.colorToModelId.clear(), this.modelIdToColor.clear();
        for (const i of this.colorMaterials.values())
          i.dispose();
        this.colorMaterials.clear();
        for (const [i] of t.list) {
          const n = this.generateColorForModel(i), s = this.colorToId(n);
          this.colorToModelId.set(s, i), this.modelIdToColor.set(i, n);
          const o = new U8({
            color: n,
            depthTest: !0,
            depthWrite: !0
          });
          this.colorMaterials.set(i, o);
        }
        this.colorsNeedUpdate = !1;
      }
    }
  }
  /**
   * Applies color materials to fragment models.
   */
  applyColorMaterials() {
    const t = this.components.get(Io);
    if (t.initialized)
      for (const [i, n] of t.list) {
        const s = this.colorMaterials.get(i);
        s && n.object.traverse((o) => {
          if (o instanceof En) {
            if ("isLODGeometry" in o.geometry) {
              const l = o.material[0].uniforms.lodColor;
              this.originalLodColors.has(l) || this.originalLodColors.set(l, l.value), l.value = s.color;
              return;
            }
            this.originalMaterials.has(o) || this.originalMaterials.set(o, o.material), o.material = s;
          }
        });
      }
  }
  /**
   * Restores original materials to fragment models.
   */
  restoreOriginalMaterials() {
    for (const [t, i] of this.originalMaterials)
      t.material = i;
    for (const [t, i] of this.originalLodColors)
      t.value = i;
    this.originalMaterials.clear();
  }
  /**
   * Renders the scene with color-coded models.
   */
  renderColorCoded() {
    if (!this.renderTarget || !this.world.renderer)
      throw new Error("Render target not initialized!");
    const t = this.world.renderer.three, i = this.world.scene.three, n = this.world.camera.three, s = t.getRenderTarget(), o = t.autoClear, r = new Xn(), l = t.getClearAlpha();
    t.getClearColor(r), this.applyColorMaterials(), t.setRenderTarget(this.renderTarget), t.autoClear = !0, t.setClearColor(0, 1), t.clear(!0, !0, !1), t.render(i, n), t.setRenderTarget(s), t.autoClear = o, t.setClearColor(r, l), this.restoreOriginalMaterials(), this.debugMode && this.debugCanvas && this.updateDebugCanvas();
  }
  /**
   * Updates the debug canvas with the color-coded render.
   */
  updateDebugCanvas() {
    if (!this.debugCanvas || !this.renderTarget || !this.world.renderer)
      return;
    const t = this.world.renderer.three, i = this.renderTargetSize, n = new Uint8Array(i.x * i.y * 4);
    t.readRenderTargetPixels(
      this.renderTarget,
      0,
      0,
      i.x,
      i.y,
      n
    );
    const s = this.debugCanvas.getContext("2d");
    if (!s)
      return;
    const o = s.createImageData(i.x, i.y), r = i.x * 4;
    for (let l = 0; l < i.y; l++) {
      const c = l, h = i.y - 1 - l, I = c * r, p = h * r;
      o.data.set(
        n.subarray(I, I + r),
        p
      );
    }
    s.putImageData(o, 0, 0);
  }
  /**
   * Gets the model ID at the given screen position.
   *
   * @param position - Optional screen position. If not provided, uses current mouse position.
   * @returns The model ID at the position, or null if no model is found.
   */
  async getModelAt(t) {
    if (!this.renderTarget || !this.world.renderer)
      throw new Error("Render target not initialized!");
    const i = this.components.get(Io);
    if (!i.initialized || i.list.size === 0)
      return null;
    this.assignColors(), this.renderColorCoded();
    const n = t || this.mouse.position, s = this.renderTargetSize, o = Math.floor((n.x + 1) * 0.5 * s.x), r = Math.floor((n.y + 1) * 0.5 * (s.y - 1)), l = Math.max(0, Math.min(s.x - 1, o)), c = Math.max(0, Math.min(s.y - 1, r)), h = this.world.renderer.three, I = new Uint8Array(4);
    h.readRenderTargetPixels(
      this.renderTarget,
      l,
      c,
      1,
      1,
      I
    );
    const p = I[0], y = I[1], m = I[2], A = p << 16 | y << 8 | m;
    return this.colorToModelId.get(A) || null;
  }
  /**
   * Enables or disables debug mode.
   * When enabled, shows a canvas with the color-coded render.
   */
  setDebugMode(t) {
    this.debugMode = t, t ? this.setupDebugCanvas() : this.removeDebugCanvas();
  }
  /**
   * Removes the debug canvas.
   */
  removeDebugCanvas() {
    this.debugContainer && (this.debugContainer.remove(), this.debugContainer = void 0, this.debugCanvas = void 0);
  }
  /** {@link Disposable.dispose} */
  dispose() {
    this.mouse.dispose(), this.removeDebugCanvas();
    for (const t of this.colorMaterials.values())
      t.dispose();
    this.colorMaterials.clear(), this.renderTarget && this.renderTarget.dispose(), this.colorToModelId.clear(), this.modelIdToColor.clear(), this.originalMaterials.clear(), this.originalLodColors.clear(), this.onDisposed.trigger(), this.onDisposed.reset();
  }
}
const xbe = class Pbe extends bI {
  constructor(t) {
    super(t), tt(this, "enabled", !0), tt(this, "list", /* @__PURE__ */ new Map()), tt(this, "onDisposed", new es()), t.add(Pbe.uuid, this);
  }
  /**
   * Retrieves a FastModelPicker instance for the given world.
   * If a FastModelPicker instance already exists for the world, it will be returned.
   * Otherwise, a new FastModelPicker instance will be created and added to the list.
   *
   * @param world - The world for which to retrieve or create a FastModelPicker instance.
   * @returns The FastModelPicker instance for the given world.
   */
  get(t) {
    if (this.list.has(t.uuid))
      return this.list.get(t.uuid);
    const i = new DKe(this.components, t);
    return this.list.set(t.uuid, i), t.onDisposed.add(() => {
      this.delete(t);
    }), i;
  }
  /**
   * Deletes the FastModelPicker instance associated with the given world.
   * If a FastModelPicker instance exists for the given world, it will be disposed and removed from the list.
   *
   * @param world - The world for which to delete the FastModelPicker instance.
   * @returns {void}
   */
  delete(t) {
    const i = this.list.get(t.uuid);
    i && i.dispose(), this.list.delete(t.uuid);
  }
  /** {@link Disposable.dispose} */
  dispose() {
    for (const [t, i] of this.list)
      i.dispose();
    this.list.clear(), this.onDisposed.trigger();
  }
};
tt(xbe, "uuid", "4a82430c-7ff2-49ea-9401-60807502dad6");
let CKe = xbe;
class OKe {
  constructor(t, i) {
    tt(this, "enabled", !0), tt(this, "components"), tt(this, "onDisposed", new es()), tt(this, "mouse"), tt(this, "three", new Aae()), tt(this, "world"), tt(this, "useFastModelPicking", !1);
    const n = i.renderer;
    if (!n)
      throw new Error("A renderer is needed for the raycaster to work!");
    this.world = i, this.mouse = new Rbe(n.three.domElement), this.components = t;
  }
  /** {@link Disposable.dispose} */
  dispose() {
    this.mouse.dispose(), this.onDisposed.trigger(), this.onDisposed.reset();
  }
  castRayToObjects(t = Array.from(this.world.meshes), i = this.mouse.position) {
    if (!this.world)
      throw new Error("A world is needed to cast rays!");
    const n = this.world.camera.three;
    return this.three.setFromCamera(i, n), this.intersect(t);
  }
  /**
   * Throws a ray from the camera to the mouse or touch event point and returns
   * the first item found. This also takes into account the clipping planes
   * used by the renderer.
   *
   * @param items - the [meshes](https://threejs.org/docs/#api/en/objects/Mesh)
   * to query. If not provided, it will query all the meshes stored in
   * {@link Components.meshes}.
   * @param position - the screen position to use for raycasting. If not provided,
   * the last pointer (mouse/touch) position will be used.
   */
  async castRay(t) {
    const i = t == null ? void 0 : t.snappingClasses, n = (t == null ? void 0 : t.items) ?? Array.from(this.world.meshes), s = (t == null ? void 0 : t.position) ?? this.mouse.position;
    if (!this.world)
      throw new Error("A world is needed to cast rays!");
    const o = this.world.camera.three, r = this.components.get(Io), l = this.world.renderer.three.domElement, c = this.mouse.rawPosition;
    let h = null;
    if (r.initialized) {
      if (this.useFastModelPicking) {
        const m = await this.components.get(CKe).get(this.world).getModelAt(s);
        if (m) {
          const A = r.list.get(m);
          if (A)
            if (i && i.length > 0) {
              const C = await A.raycastWithSnapping({
                camera: o,
                dom: l,
                mouse: c,
                snappingClasses: i
              });
              C && C.length > 0 ? h = C[0] : h = await A.raycast({
                camera: o,
                dom: l,
                mouse: c
              });
            } else
              h = await A.raycast({
                camera: o,
                dom: l,
                mouse: c
              });
        }
      } else
        h = await r.raycast({
          camera: o,
          dom: l,
          mouse: c,
          snappingClasses: i
        });
      if (n.length === 0)
        return h;
    }
    this.three.setFromCamera(s, o);
    const I = this.intersect(n);
    return h ? I && I.distance < h.distance ? I : h : I;
  }
  /**
   * Casts a ray from a given origin in a given direction and returns the first item found.
   * This method also takes into account the clipping planes used by the renderer.
   *
   * @param origin - The origin of the ray.
   * @param direction - The direction of the ray.
   * @param items - The meshes to query. If not provided, it will query all the meshes stored in {@link World.meshes}.
   * @returns The first intersection found or `null` if no intersection was found.
   */
  castRayFromVector(t, i, n = Array.from(this.world.meshes)) {
    return this.three.set(t, i), this.intersect(n);
  }
  intersect(t = Array.from(this.world.meshes)) {
    const i = this.three.intersectObjects(t), n = this.filterClippingPlanes(i);
    return n.length > 0 ? n[0] : null;
  }
  filterClippingPlanes(t) {
    if (!this.world.renderer)
      throw new Error("Renderer not found!");
    const i = this.world.renderer.three;
    if (!i.clippingPlanes)
      return t;
    const n = i.clippingPlanes;
    return t.length <= 0 || !n || (n == null ? void 0 : n.length) <= 0 ? t : t.filter(
      (s) => n.every((o) => o.distanceToPoint(s.point) > 0)
    );
  }
}
const Mbe = class Ube extends bI {
  constructor(t) {
    super(t), tt(this, "enabled", !0), tt(this, "list", /* @__PURE__ */ new Map()), tt(this, "onDisposed", new es()), t.add(Ube.uuid, this);
  }
  /**
   * Retrieves a SimpleRaycaster instance for the given world.
   * If a SimpleRaycaster instance already exists for the world, it will be returned.
   * Otherwise, a new SimpleRaycaster instance will be created and added to the list.
   *
   * @param world - The world for which to retrieve or create a SimpleRaycaster instance.
   * @returns The SimpleRaycaster instance for the given world.
   */
  get(t) {
    if (this.list.has(t.uuid))
      return this.list.get(t.uuid);
    const i = new OKe(this.components, t);
    return this.list.set(t.uuid, i), t.onDisposed.add(() => {
      this.delete(t);
    }), i;
  }
  /**
   * Deletes the SimpleRaycaster instance associated with the given world.
   * If a SimpleRaycaster instance exists for the given world, it will be disposed and removed from the list.
   *
   * @param world - The world for which to delete the SimpleRaycaster instance.
   * @returns {void}
   */
  delete(t) {
    const i = this.list.get(t.uuid);
    i && i.dispose(), this.list.delete(t.uuid);
  }
  /** {@link Disposable.dispose} */
  dispose() {
    for (const [t, i] of this.list)
      i.dispose();
    this.list.clear(), this.onDisposed.trigger();
  }
};
tt(Mbe, "uuid", "d5d8bdf0-db25-4952-b951-b643af207ace");
let kIe = Mbe;
class LKe extends Lme {
  constructor() {
    super(...arguments), tt(this, "onCameraChanged", new es()), tt(this, "meshes", /* @__PURE__ */ new Set()), tt(this, "onAfterUpdate", new es()), tt(this, "onBeforeUpdate", new es()), tt(this, "onDisposed", new es()), tt(this, "isDisposing", !1), tt(this, "enabled", !0), tt(this, "_dynamicAnchor", !1), tt(this, "uuid", y4.create()), tt(this, "name"), tt(this, "_scene"), tt(this, "_camera"), tt(this, "_renderer", null), tt(this, "onPointerDown", async (t) => {
      if (!this.camera.hasCameraControls())
        throw new Error(
          "World: can't set dynamic anchor if the camera doesn't have controls."
        );
      const n = await this.components.get(kIe).get(this).castRay();
      n && n.point && t.button === 0 && this.camera.controls.setOrbitPoint(
        n.point.x,
        n.point.y,
        n.point.z
      );
    }), tt(this, "_defaultCamera");
  }
  set dynamicAnchor(t) {
    var i;
    const n = (i = this.renderer) == null ? void 0 : i.three.domElement.parentElement;
    if (!n)
      throw new Error(
        "World: the renderer must have a parentElement to set dynamic anchoring."
      );
    t ? (this.camera.controls && (this.camera.controls.minDistance = 0.01), n.addEventListener("pointerdown", this.onPointerDown)) : n.removeEventListener("pointerdown", this.onPointerDown);
  }
  get dynamicAnchor() {
    return this._dynamicAnchor;
  }
  get defaultCamera() {
    if (!this._defaultCamera)
      throw new Error("World: there is no default camera defined.");
    return this._defaultCamera;
  }
  set defaultCamera(t) {
    this._defaultCamera = t;
  }
  /**
   * Getter for the scene. If no scene is initialized, it throws an error.
   * @returns The current scene.
   */
  get scene() {
    if (!this._scene)
      throw new Error("No scene initialized!");
    return this._scene;
  }
  /**
   * Setter for the scene. It sets the current scene, adds the world to the scene's worlds set,
   * sets the current world in the scene, and triggers the scene's onWorldChanged event with the added action.
   * @param scene - The new scene to be set.
   */
  set scene(t) {
    this._scene = t, t.worlds.set(this.uuid, this), t.currentWorld = this, t.onWorldChanged.trigger({ world: this, action: "added" });
  }
  /**
   * Getter for the camera. If no camera is initialized, it throws an error.
   * @returns The current camera.
   */
  get camera() {
    if (!this._camera)
      throw new Error("No camera initialized!");
    return this._camera;
  }
  /**
   * Setter for the camera. It sets the current camera, adds the world to the camera's worlds set,
   * sets the current world in the camera, and triggers the camera's onWorldChanged event with the added action.
   * @param camera - The new camera to be set.
   */
  set camera(t) {
    this._camera || (this.defaultCamera = t), this._camera = t, t.currentWorld = this, this.onCameraChanged.trigger(t);
  }
  /**
   * Getter for the renderer.
   * @returns The current renderer or null if no renderer is set. Some worlds don't need a renderer to work (when your mail goal is not to display a 3D viewport to the user).
   */
  get renderer() {
    return this._renderer;
  }
  /**
   * Setter for the renderer. It sets the current renderer, adds the world to the renderer's worlds set,
   * sets the current world in the renderer, and triggers the renderer's onWorldChanged event with the added action.
   * If a new renderer is set, it also triggers the onWorldChanged event with the removed action for the old renderer.
   * @param renderer - The new renderer to be set or null to remove the current renderer.
   */
  set renderer(t) {
    this._renderer = t, t && (t.worlds.set(this.uuid, this), t.currentWorld = this, t.onWorldChanged.trigger({ world: this, action: "added" }));
  }
  useDefaultCamera() {
    this.camera = this.defaultCamera;
  }
  /** {@link Updateable.update} */
  update(t) {
    this.enabled && (!this._scene || !this._camera || (this.scene.currentWorld = this, this.camera.currentWorld = this, this.renderer && (this.renderer.currentWorld = this), this.onBeforeUpdate.trigger(), this.scene.isUpdateable() && this.scene.update(t), this.camera.isUpdateable() && this.camera.update(t), this.renderer && this.renderer.update(t), this.onAfterUpdate.trigger()));
  }
  /** {@link Disposable.dispose} */
  dispose(t = !0) {
    if (this.enabled = !1, this.isDisposing = !0, this.scene.onWorldChanged.trigger({ world: this, action: "removed" }), this.camera.onWorldChanged.trigger({ world: this, action: "removed" }), this.renderer && this.renderer.onWorldChanged.trigger({ world: this, action: "removed" }), t) {
      const n = this.components.get(Tue);
      this.scene.dispose(), this.camera.isDisposeable() && this.camera.dispose(), this.renderer && this.renderer.dispose();
      for (const s of this.meshes)
        n.destroy(s);
      this.meshes.clear();
    }
    this._scene = null, this._camera = null, this._renderer = null, this.components.get(Ume).list.delete(this.uuid), this.onDisposed.trigger(), this.onDisposed.reset();
  }
}
class _Ke {
  constructor(t, i) {
    tt(this, "_list"), tt(this, "_scene"), this._list = t, this._scene = i;
  }
  get color() {
    return this._list.directionalLight.color.value;
  }
  set color(t) {
    this._list.directionalLight.color.value = t;
    for (const [, i] of this._scene.directionalLights)
      i.color.copy(t);
  }
  get intensity() {
    return this._list.directionalLight.intensity.value;
  }
  set intensity(t) {
    this._list.directionalLight.intensity.value = t;
    for (const [, i] of this._scene.directionalLights)
      i.intensity = t;
  }
  get position() {
    return this._list.directionalLight.position.value.clone();
  }
  set position(t) {
    this._list.directionalLight.position.value = t;
    for (const [, i] of this._scene.directionalLights)
      i.position.copy(t);
  }
}
class xKe {
  constructor(t, i) {
    tt(this, "_list"), tt(this, "_scene"), this._list = t, this._scene = i;
  }
  get color() {
    return this._list.ambientLight.color.value;
  }
  set color(t) {
    this._list.ambientLight.color.value = t;
    for (const [, i] of this._scene.ambientLights)
      i.color.copy(t);
  }
  get intensity() {
    return this._list.ambientLight.intensity.value;
  }
  set intensity(t) {
    this._list.ambientLight.intensity.value = t;
    for (const [, i] of this._scene.ambientLights)
      i.intensity = t;
  }
}
class PKe extends Hie {
  constructor() {
    super(...arguments), tt(this, "_config", {
      backgroundColor: {
        value: new Xn(),
        type: "Color"
      },
      ambientLight: {
        color: {
          type: "Color",
          value: new Xn()
        },
        intensity: {
          type: "Number",
          interpolable: !0,
          min: 0,
          max: 10,
          value: 2
        }
      },
      directionalLight: {
        color: {
          type: "Color",
          value: new Xn()
        },
        intensity: {
          type: "Number",
          interpolable: !0,
          min: 0,
          max: 10,
          value: 2
        },
        position: {
          type: "Vector3",
          value: new Ge()
        }
      }
    }), tt(this, "ambientLight", new xKe(this._config, this._component)), tt(this, "directionalLight", new _Ke(this._config, this._component));
  }
  get backgroundColor() {
    return this._config.backgroundColor.value;
  }
  set backgroundColor(t) {
    this._config.backgroundColor.value = t, this._component.three.background = t;
  }
}
class MKe extends a$e {
  constructor(t) {
    super(t), tt(this, "onSetup", new es()), tt(this, "isSetup", !1), tt(this, "three"), tt(this, "config", new PKe(this, this.components, "Scene")), tt(this, "_defaultConfig", {
      backgroundColor: new Xn(2107698),
      directionalLight: {
        color: new Xn("white"),
        intensity: 1.5,
        position: new Ge(5, 10, 3)
      },
      ambientLight: {
        color: new Xn("white"),
        intensity: 1
      }
    }), this.three = new cUe(), this.three.background = new Xn(2107698);
  }
  /** {@link Configurable.setup} */
  setup(t) {
    const i = { ...this._defaultConfig, ...t };
    this.config.backgroundColor = i.backgroundColor;
    const n = i.ambientLight;
    this.config.ambientLight.color = n.color, this.config.ambientLight.intensity = n.intensity;
    const s = i.directionalLight;
    this.config.directionalLight.color = s.color, this.config.directionalLight.intensity = s.intensity, this.config.directionalLight.position = s.position, this.deleteAllLights();
    const { color: o, intensity: r } = this.config.directionalLight, l = new NUe(o, r);
    l.position.copy(s.position);
    const { color: c, intensity: h } = this.config.directionalLight, I = new DUe(c, h);
    this.three.add(l, I), this.directionalLights.set(l.uuid, l), this.ambientLights.set(I.uuid, I), this.isSetup = !0, this.onSetup.trigger();
  }
  dispose() {
    super.dispose(), this.components.get(Sue).list.delete(this.config.uuid);
  }
}
class UKe extends l$e {
  /**
   * Constructor for the SimpleRenderer class.
   *
   * @param components - The components instance.
   * @param container - The HTML container where the THREE.js canvas will be rendered.
   * @param parameters - Optional parameters for the THREE.js WebGLRenderer.
   */
  constructor(t, i, n) {
    super(t), tt(this, "enabled", !0), tt(this, "container"), tt(this, "three"), tt(this, "mode", 1), tt(this, "needsUpdate", !1), tt(this, "_canvas"), tt(this, "_parameters"), tt(this, "_resizeObserver", null), tt(this, "onContainerUpdated", new es()), tt(this, "_resizing", !1), tt(this, "resize", (r) => {
      if (this._resizing)
        return;
      this._resizing = !0, this.onContainerUpdated.trigger();
      const l = r ? r.x : this.container.clientWidth, c = r ? r.y : this.container.clientHeight;
      this.three.setSize(l, c), this.onResize.trigger(new us(l, c)), this._resizing = !1;
    }), tt(this, "resizeEvent", () => {
      this.resize();
    }), tt(this, "onContextLost", (r) => {
      r.preventDefault(), this.enabled = !1;
    }), tt(this, "onContextBack", () => {
      this.three.setRenderTarget(null), this.three.dispose(), this.three = new $ge({
        canvas: this._canvas,
        antialias: !0,
        alpha: !0,
        ...this._parameters
      }), this.enabled = !0;
    }), this.container = i, this._parameters = n, this.three = new $ge({
      antialias: !0,
      alpha: !0,
      ...n
    }), this.three.setPixelRatio(Math.min(window.devicePixelRatio, 2)), this.setupRenderer(), this.setupEvents(!0), this.resize(), this._canvas = this.three.domElement;
    const s = this.three.getContext(), { canvas: o } = s;
    o.addEventListener("webglcontextlost", this.onContextLost, !1), o.addEventListener("webglcontextrestored", this.onContextBack, !1);
  }
  /** {@link Updateable.update} */
  update() {
    if (!this.enabled || !this.currentWorld || this.mode === 0 && !this.needsUpdate)
      return;
    this.needsUpdate = !1, this.onBeforeUpdate.trigger(this);
    const t = this.currentWorld.scene.three, i = this.currentWorld.camera.three;
    this.three.render(t, i), this.onAfterUpdate.trigger(this);
  }
  /** {@link Disposable.dispose} */
  dispose() {
    this.enabled = !1, this.setupEvents(!1), this.three.domElement.remove(), this.three.forceContextLoss(), this.three.dispose(), this.onResize.reset(), this.onAfterUpdate.reset(), this.onBeforeUpdate.reset(), this.onDisposed.trigger(), this.onDisposed.reset();
  }
  /** {@link Resizeable.getSize}. */
  getSize() {
    return new us(
      this.three.domElement.clientWidth,
      this.three.domElement.clientHeight
    );
  }
  /**
   * Sets up and manages the event listeners for the renderer.
   *
   * @param active - A boolean indicating whether to activate or deactivate the event listeners.
   *
   * @throws Will throw an error if the renderer does not have an HTML container.
   */
  setupEvents(t) {
    const i = this.three.domElement.parentElement;
    if (!i)
      throw new Error("This renderer needs to have an HTML container!");
    this._resizeObserver && (this._resizeObserver.disconnect(), this._resizeObserver = null), window.removeEventListener("resize", this.resizeEvent), t && (this._resizeObserver = new ResizeObserver(this.resizeEvent), this._resizeObserver.observe(i), window.addEventListener("resize", this.resizeEvent));
  }
  setupRenderer() {
    this.three.localClippingEnabled = !0, this.container && this.container.appendChild(this.three.domElement), this.onContainerUpdated.trigger();
  }
}
/*!
 * camera-controls
 * https://github.com/yomotsu/camera-controls
 * (c) 2017 @yomotsu
 * Released under the MIT License.
 */
const sd = {
  LEFT: 1,
  RIGHT: 2,
  MIDDLE: 4
}, Ti = Object.freeze({
  NONE: 0,
  ROTATE: 1,
  TRUCK: 2,
  SCREEN_PAN: 4,
  OFFSET: 8,
  DOLLY: 16,
  ZOOM: 32,
  TOUCH_ROTATE: 64,
  TOUCH_TRUCK: 128,
  TOUCH_SCREEN_PAN: 256,
  TOUCH_OFFSET: 512,
  TOUCH_DOLLY: 1024,
  TOUCH_ZOOM: 2048,
  TOUCH_DOLLY_TRUCK: 4096,
  TOUCH_DOLLY_SCREEN_PAN: 8192,
  TOUCH_DOLLY_OFFSET: 16384,
  TOUCH_DOLLY_ROTATE: 32768,
  TOUCH_ZOOM_TRUCK: 65536,
  TOUCH_ZOOM_OFFSET: 131072,
  TOUCH_ZOOM_SCREEN_PAN: 262144,
  TOUCH_ZOOM_ROTATE: 524288
}), Xk = {
  NONE: 0,
  IN: 1,
  OUT: -1
};
function iU(e) {
  return e.isPerspectiveCamera;
}
function z_(e) {
  return e.isOrthographicCamera;
}
const eV = Math.PI * 2, Wwe = Math.PI / 2, Bbe = 1e-5, _Z = Math.PI / 180;
function cv(e, t, i) {
  return Math.max(t, Math.min(i, e));
}
function Xl(e, t = Bbe) {
  return Math.abs(e) < t;
}
function Il(e, t, i = Bbe) {
  return Xl(e - t, i);
}
function Ywe(e, t) {
  return Math.round(e / t) * t;
}
function xZ(e) {
  return isFinite(e) ? e : e < 0 ? -Number.MAX_VALUE : Number.MAX_VALUE;
}
function PZ(e) {
  return Math.abs(e) < Number.MAX_VALUE ? e : e * (1 / 0);
}
function yse(e, t, i, n, s = 1 / 0, o) {
  n = Math.max(1e-4, n);
  const r = 2 / n, l = r * o, c = 1 / (1 + l + 0.48 * l * l + 0.235 * l * l * l);
  let h = e - t;
  const I = t, p = s * n;
  h = cv(h, -p, p), t = e - h;
  const y = (i.value + r * h) * o;
  i.value = (i.value - r * y) * c;
  let m = t + (h + y) * c;
  return I - e > 0 == m > I && (m = I, i.value = (m - I) / o), m;
}
function qwe(e, t, i, n, s = 1 / 0, o, r) {
  n = Math.max(1e-4, n);
  const l = 2 / n, c = l * o, h = 1 / (1 + c + 0.48 * c * c + 0.235 * c * c * c);
  let I = t.x, p = t.y, y = t.z, m = e.x - I, A = e.y - p, C = e.z - y;
  const O = I, R = p, F = y, L = s * n, P = L * L, z = m * m + A * A + C * C;
  if (z > P) {
    const je = Math.sqrt(z);
    m = m / je * L, A = A / je * L, C = C / je * L;
  }
  I = e.x - m, p = e.y - A, y = e.z - C;
  const W = (i.x + l * m) * o, re = (i.y + l * A) * o, ce = (i.z + l * C) * o;
  i.x = (i.x - l * W) * h, i.y = (i.y - l * re) * h, i.z = (i.z - l * ce) * h, r.x = I + (m + W) * h, r.y = p + (A + re) * h, r.z = y + (C + ce) * h;
  const te = O - e.x, ee = R - e.y, Ne = F - e.z, Ae = r.x - O, Oe = r.y - R, pe = r.z - F;
  return te * Ae + ee * Oe + Ne * pe > 0 && (r.x = O, r.y = R, r.z = F, i.x = (r.x - O) / o, i.y = (r.y - R) / o, i.z = (r.z - F) / o), r;
}
function Ace(e, t) {
  t.set(0, 0), e.forEach((i) => {
    t.x += i.clientX, t.y += i.clientY;
  }), t.x /= e.length, t.y /= e.length;
}
function Sce(e, t) {
  return z_(e) ? (console.warn(`${t} is not supported in OrthographicCamera`), !0) : !1;
}
class BKe {
  constructor() {
    this._listeners = {};
  }
  /**
   * Adds the specified event listener.
   * @param type event name
   * @param listener handler function
   * @category Methods
   */
  addEventListener(t, i) {
    const n = this._listeners;
    n[t] === void 0 && (n[t] = []), n[t].indexOf(i) === -1 && n[t].push(i);
  }
  /**
   * Presence of the specified event listener.
   * @param type event name
   * @param listener handler function
   * @category Methods
   */
  hasEventListener(t, i) {
    const n = this._listeners;
    return n[t] !== void 0 && n[t].indexOf(i) !== -1;
  }
  /**
   * Removes the specified event listener
   * @param type event name
   * @param listener handler function
   * @category Methods
   */
  removeEventListener(t, i) {
    const s = this._listeners[t];
    if (s !== void 0) {
      const o = s.indexOf(i);
      o !== -1 && s.splice(o, 1);
    }
  }
  /**
   * Removes all event listeners
   * @param type event name
   * @category Methods
   */
  removeAllEventListeners(t) {
    if (!t) {
      this._listeners = {};
      return;
    }
    Array.isArray(this._listeners[t]) && (this._listeners[t].length = 0);
  }
  /**
   * Fire an event type.
   * @param event DispatcherEvent
   * @category Methods
   */
  dispatchEvent(t) {
    const n = this._listeners[t.type];
    if (n !== void 0) {
      t.target = this;
      const s = n.slice(0);
      for (let o = 0, r = s.length; o < r; o++)
        s[o].call(this, t);
    }
  }
}
var bce;
const FKe = "2.10.1", Ese = 1 / 8, HKe = /Mac/.test((bce = globalThis == null ? void 0 : globalThis.navigator) === null || bce === void 0 ? void 0 : bce.platform);
let Hs, $we, gse, Nce, ng, vo, Kr, tV, MZ, fb, Ib, nU, Kwe, Zwe, zT, UZ, iV, Qwe, Dce, Jwe, Cce, Oce, wse;
class c3 extends BKe {
  /**
       * Injects THREE as the dependency. You can then proceed to use CameraControls.
       *
       * e.g
       * ```javascript
       * CameraControls.install( { THREE: THREE } );
       * ```
       *
       * Note: If you do not wish to use enter three.js to reduce file size(tree-shaking for example), make a subset to install.
       *
       * ```js
       * import {
       * 	Vector2,
       * 	Vector3,
       * 	Vector4,
       * 	Quaternion,
       * 	Matrix4,
       * 	Spherical,
       * 	Box3,
       * 	Sphere,
       * 	Raycaster,
       * 	MathUtils,
       * } from 'three';
       *
       * const subsetOfTHREE = {
       * 	Vector2   : Vector2,
       * 	Vector3   : Vector3,
       * 	Vector4   : Vector4,
       * 	Quaternion: Quaternion,
       * 	Matrix4   : Matrix4,
       * 	Spherical : Spherical,
       * 	Box3      : Box3,
       * 	Sphere    : Sphere,
       * 	Raycaster : Raycaster,
       * };
  
       * CameraControls.install( { THREE: subsetOfTHREE } );
       * ```
       * @category Statics
       */
  static install(t) {
    Hs = t.THREE, $we = Object.freeze(new Hs.Vector3(0, 0, 0)), gse = Object.freeze(new Hs.Vector3(0, 1, 0)), Nce = Object.freeze(new Hs.Vector3(0, 0, 1)), ng = new Hs.Vector2(), vo = new Hs.Vector3(), Kr = new Hs.Vector3(), tV = new Hs.Vector3(), MZ = new Hs.Vector3(), fb = new Hs.Vector3(), Ib = new Hs.Vector3(), nU = new Hs.Vector3(), Kwe = new Hs.Vector3(), Zwe = new Hs.Vector3(), zT = new Hs.Spherical(), UZ = new Hs.Spherical(), iV = new Hs.Box3(), Qwe = new Hs.Box3(), Dce = new Hs.Sphere(), Jwe = new Hs.Quaternion(), Cce = new Hs.Quaternion(), Oce = new Hs.Matrix4(), wse = new Hs.Raycaster();
  }
  /**
   * list all ACTIONs
   * @category Statics
   */
  static get ACTION() {
    return Ti;
  }
  /**
   * @deprecated Use `cameraControls.mouseButtons.left = CameraControls.ACTION.SCREEN_PAN` instead.
   */
  set verticalDragToForward(t) {
    console.warn("camera-controls: `verticalDragToForward` was removed. Use `mouseButtons.left = CameraControls.ACTION.SCREEN_PAN` instead.");
  }
  /**
   * Creates a `CameraControls` instance.
   *
   * Note:
   * You **must install** three.js before using camera-controls. see [#install](#install)
   * Not doing so will lead to runtime errors (`undefined` references to THREE).
   *
   * e.g.
   * ```
   * CameraControls.install( { THREE } );
   * const cameraControls = new CameraControls( camera, domElement );
   * ```
   *
   * @param camera A `THREE.PerspectiveCamera` or `THREE.OrthographicCamera` to be controlled.
   * @param domElement A `HTMLElement` for the draggable area, usually `renderer.domElement`.
   * @category Constructor
   */
  constructor(t, i) {
    super(), this.minPolarAngle = 0, this.maxPolarAngle = Math.PI, this.minAzimuthAngle = -1 / 0, this.maxAzimuthAngle = 1 / 0, this.minDistance = Number.EPSILON, this.maxDistance = 1 / 0, this.infinityDolly = !1, this.minZoom = 0.01, this.maxZoom = 1 / 0, this.smoothTime = 0.25, this.draggingSmoothTime = 0.125, this.maxSpeed = 1 / 0, this.azimuthRotateSpeed = 1, this.polarRotateSpeed = 1, this.dollySpeed = 1, this.dollyDragInverted = !1, this.truckSpeed = 2, this.dollyToCursor = !1, this.dragToOffset = !1, this.boundaryFriction = 0, this.restThreshold = 0.01, this.colliderMeshes = [], this.cancel = () => {
    }, this._enabled = !0, this._state = Ti.NONE, this._viewport = null, this._changedDolly = 0, this._changedZoom = 0, this._hasRested = !0, this._boundaryEnclosesCamera = !1, this._needsUpdate = !0, this._updatedLastTime = !1, this._elementRect = new DOMRect(), this._isDragging = !1, this._dragNeedsUpdate = !0, this._activePointers = [], this._lockedPointer = null, this._interactiveArea = new DOMRect(0, 0, 1, 1), this._isUserControllingRotate = !1, this._isUserControllingDolly = !1, this._isUserControllingTruck = !1, this._isUserControllingOffset = !1, this._isUserControllingZoom = !1, this._lastDollyDirection = Xk.NONE, this._thetaVelocity = { value: 0 }, this._phiVelocity = { value: 0 }, this._radiusVelocity = { value: 0 }, this._targetVelocity = new Hs.Vector3(), this._focalOffsetVelocity = new Hs.Vector3(), this._zoomVelocity = { value: 0 }, this._truckInternal = (R, F, L, P) => {
      let z, W;
      if (iU(this._camera)) {
        const re = vo.copy(this._camera.position).sub(this._target), ce = this._camera.getEffectiveFOV() * _Z, te = re.length() * Math.tan(ce * 0.5);
        z = this.truckSpeed * R * te / this._elementRect.height, W = this.truckSpeed * F * te / this._elementRect.height;
      } else if (z_(this._camera)) {
        const re = this._camera;
        z = this.truckSpeed * R * (re.right - re.left) / re.zoom / this._elementRect.width, W = this.truckSpeed * F * (re.top - re.bottom) / re.zoom / this._elementRect.height;
      } else
        return;
      P ? (L ? this.setFocalOffset(this._focalOffsetEnd.x + z, this._focalOffsetEnd.y, this._focalOffsetEnd.z, !0) : this.truck(z, 0, !0), this.forward(-W, !0)) : L ? this.setFocalOffset(this._focalOffsetEnd.x + z, this._focalOffsetEnd.y + W, this._focalOffsetEnd.z, !0) : this.truck(z, W, !0);
    }, this._rotateInternal = (R, F) => {
      const L = eV * this.azimuthRotateSpeed * R / this._elementRect.height, P = eV * this.polarRotateSpeed * F / this._elementRect.height;
      this.rotate(L, P, !0);
    }, this._dollyInternal = (R, F, L) => {
      const P = Math.pow(0.95, -R * this.dollySpeed), z = this._sphericalEnd.radius, W = this._sphericalEnd.radius * P, re = cv(W, this.minDistance, this.maxDistance), ce = re - W;
      this.infinityDolly && this.dollyToCursor ? this._dollyToNoClamp(W, !0) : this.infinityDolly && !this.dollyToCursor ? (this.dollyInFixed(ce, !0), this._dollyToNoClamp(re, !0)) : this._dollyToNoClamp(re, !0), this.dollyToCursor && (this._changedDolly += (this.infinityDolly ? W : re) - z, this._dollyControlCoord.set(F, L)), this._lastDollyDirection = Math.sign(-R);
    }, this._zoomInternal = (R, F, L) => {
      const P = Math.pow(0.95, R * this.dollySpeed), z = this._zoom, W = this._zoom * P;
      this.zoomTo(W, !0), this.dollyToCursor && (this._changedZoom += W - z, this._dollyControlCoord.set(F, L));
    }, typeof Hs > "u" && console.error("camera-controls: `THREE` is undefined. You must first run `CameraControls.install( { THREE: THREE } )`. Check the docs for further information."), this._camera = t, this._yAxisUpSpace = new Hs.Quaternion().setFromUnitVectors(this._camera.up, gse), this._yAxisUpSpaceInverse = this._yAxisUpSpace.clone().invert(), this._state = Ti.NONE, this._target = new Hs.Vector3(), this._targetEnd = this._target.clone(), this._focalOffset = new Hs.Vector3(), this._focalOffsetEnd = this._focalOffset.clone(), this._spherical = new Hs.Spherical().setFromVector3(vo.copy(this._camera.position).applyQuaternion(this._yAxisUpSpace)), this._sphericalEnd = this._spherical.clone(), this._lastDistance = this._spherical.radius, this._zoom = this._camera.zoom, this._zoomEnd = this._zoom, this._lastZoom = this._zoom, this._nearPlaneCorners = [
      new Hs.Vector3(),
      new Hs.Vector3(),
      new Hs.Vector3(),
      new Hs.Vector3()
    ], this._updateNearPlaneCorners(), this._boundary = new Hs.Box3(new Hs.Vector3(-1 / 0, -1 / 0, -1 / 0), new Hs.Vector3(1 / 0, 1 / 0, 1 / 0)), this._cameraUp0 = this._camera.up.clone(), this._target0 = this._target.clone(), this._position0 = this._camera.position.clone(), this._zoom0 = this._zoom, this._focalOffset0 = this._focalOffset.clone(), this._dollyControlCoord = new Hs.Vector2(), this.mouseButtons = {
      left: Ti.ROTATE,
      middle: Ti.DOLLY,
      right: Ti.TRUCK,
      wheel: iU(this._camera) ? Ti.DOLLY : z_(this._camera) ? Ti.ZOOM : Ti.NONE
    }, this.touches = {
      one: Ti.TOUCH_ROTATE,
      two: iU(this._camera) ? Ti.TOUCH_DOLLY_TRUCK : z_(this._camera) ? Ti.TOUCH_ZOOM_TRUCK : Ti.NONE,
      three: Ti.TOUCH_TRUCK
    };
    const n = new Hs.Vector2(), s = new Hs.Vector2(), o = new Hs.Vector2(), r = (R) => {
      if (!this._enabled || !this._domElement)
        return;
      if (this._interactiveArea.left !== 0 || this._interactiveArea.top !== 0 || this._interactiveArea.width !== 1 || this._interactiveArea.height !== 1) {
        const P = this._domElement.getBoundingClientRect(), z = R.clientX / P.width, W = R.clientY / P.height;
        if (z < this._interactiveArea.left || z > this._interactiveArea.right || W < this._interactiveArea.top || W > this._interactiveArea.bottom)
          return;
      }
      const F = R.pointerType !== "mouse" ? null : (R.buttons & sd.LEFT) === sd.LEFT ? sd.LEFT : (R.buttons & sd.MIDDLE) === sd.MIDDLE ? sd.MIDDLE : (R.buttons & sd.RIGHT) === sd.RIGHT ? sd.RIGHT : null;
      if (F !== null) {
        const P = this._findPointerByMouseButton(F);
        P && this._disposePointer(P);
      }
      if ((R.buttons & sd.LEFT) === sd.LEFT && this._lockedPointer)
        return;
      const L = {
        pointerId: R.pointerId,
        clientX: R.clientX,
        clientY: R.clientY,
        deltaX: 0,
        deltaY: 0,
        mouseButton: F
      };
      this._activePointers.push(L), this._domElement.ownerDocument.removeEventListener("pointermove", l, { passive: !1 }), this._domElement.ownerDocument.removeEventListener("pointerup", c), this._domElement.ownerDocument.addEventListener("pointermove", l, { passive: !1 }), this._domElement.ownerDocument.addEventListener("pointerup", c), this._isDragging = !0, y(R);
    }, l = (R) => {
      R.cancelable && R.preventDefault();
      const F = R.pointerId, L = this._lockedPointer || this._findPointerById(F);
      if (L) {
        if (L.clientX = R.clientX, L.clientY = R.clientY, L.deltaX = R.movementX, L.deltaY = R.movementY, this._state = 0, R.pointerType === "touch")
          switch (this._activePointers.length) {
            case 1:
              this._state = this.touches.one;
              break;
            case 2:
              this._state = this.touches.two;
              break;
            case 3:
              this._state = this.touches.three;
              break;
          }
        else
          (!this._isDragging && this._lockedPointer || this._isDragging && (R.buttons & sd.LEFT) === sd.LEFT) && (this._state = this._state | this.mouseButtons.left), this._isDragging && (R.buttons & sd.MIDDLE) === sd.MIDDLE && (this._state = this._state | this.mouseButtons.middle), this._isDragging && (R.buttons & sd.RIGHT) === sd.RIGHT && (this._state = this._state | this.mouseButtons.right);
        m();
      }
    }, c = (R) => {
      const F = this._findPointerById(R.pointerId);
      if (!(F && F === this._lockedPointer)) {
        if (F && this._disposePointer(F), R.pointerType === "touch")
          switch (this._activePointers.length) {
            case 0:
              this._state = Ti.NONE;
              break;
            case 1:
              this._state = this.touches.one;
              break;
            case 2:
              this._state = this.touches.two;
              break;
            case 3:
              this._state = this.touches.three;
              break;
          }
        else
          this._state = Ti.NONE;
        A();
      }
    };
    let h = -1;
    const I = (R) => {
      if (!this._domElement || !this._enabled || this.mouseButtons.wheel === Ti.NONE)
        return;
      if (this._interactiveArea.left !== 0 || this._interactiveArea.top !== 0 || this._interactiveArea.width !== 1 || this._interactiveArea.height !== 1) {
        const W = this._domElement.getBoundingClientRect(), re = R.clientX / W.width, ce = R.clientY / W.height;
        if (re < this._interactiveArea.left || re > this._interactiveArea.right || ce < this._interactiveArea.top || ce > this._interactiveArea.bottom)
          return;
      }
      if (R.preventDefault(), this.dollyToCursor || this.mouseButtons.wheel === Ti.ROTATE || this.mouseButtons.wheel === Ti.TRUCK) {
        const W = performance.now();
        h - W < 1e3 && this._getClientRect(this._elementRect), h = W;
      }
      const F = HKe ? -1 : -3, L = R.deltaMode === 1 || R.ctrlKey ? R.deltaY / F : R.deltaY / (F * 10), P = this.dollyToCursor ? (R.clientX - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0, z = this.dollyToCursor ? (R.clientY - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0;
      switch (this.mouseButtons.wheel) {
        case Ti.ROTATE: {
          this._rotateInternal(R.deltaX, R.deltaY), this._isUserControllingRotate = !0;
          break;
        }
        case Ti.TRUCK: {
          this._truckInternal(R.deltaX, R.deltaY, !1, !1), this._isUserControllingTruck = !0;
          break;
        }
        case Ti.SCREEN_PAN: {
          this._truckInternal(R.deltaX, R.deltaY, !1, !0), this._isUserControllingTruck = !0;
          break;
        }
        case Ti.OFFSET: {
          this._truckInternal(R.deltaX, R.deltaY, !0, !1), this._isUserControllingOffset = !0;
          break;
        }
        case Ti.DOLLY: {
          this._dollyInternal(-L, P, z), this._isUserControllingDolly = !0;
          break;
        }
        case Ti.ZOOM: {
          this._zoomInternal(-L, P, z), this._isUserControllingZoom = !0;
          break;
        }
      }
      this.dispatchEvent({ type: "control" });
    }, p = (R) => {
      if (!(!this._domElement || !this._enabled)) {
        if (this.mouseButtons.right === c3.ACTION.NONE) {
          const F = R instanceof PointerEvent ? R.pointerId : 0, L = this._findPointerById(F);
          L && this._disposePointer(L), this._domElement.ownerDocument.removeEventListener("pointermove", l, { passive: !1 }), this._domElement.ownerDocument.removeEventListener("pointerup", c);
          return;
        }
        R.preventDefault();
      }
    }, y = (R) => {
      if (!this._enabled)
        return;
      if (Ace(this._activePointers, ng), this._getClientRect(this._elementRect), n.copy(ng), s.copy(ng), this._activePointers.length >= 2) {
        const L = ng.x - this._activePointers[1].clientX, P = ng.y - this._activePointers[1].clientY, z = Math.sqrt(L * L + P * P);
        o.set(0, z);
        const W = (this._activePointers[0].clientX + this._activePointers[1].clientX) * 0.5, re = (this._activePointers[0].clientY + this._activePointers[1].clientY) * 0.5;
        s.set(W, re);
      }
      if (this._state = 0, !R)
        this._lockedPointer && (this._state = this._state | this.mouseButtons.left);
      else if ("pointerType" in R && R.pointerType === "touch")
        switch (this._activePointers.length) {
          case 1:
            this._state = this.touches.one;
            break;
          case 2:
            this._state = this.touches.two;
            break;
          case 3:
            this._state = this.touches.three;
            break;
        }
      else
        !this._lockedPointer && (R.buttons & sd.LEFT) === sd.LEFT && (this._state = this._state | this.mouseButtons.left), (R.buttons & sd.MIDDLE) === sd.MIDDLE && (this._state = this._state | this.mouseButtons.middle), (R.buttons & sd.RIGHT) === sd.RIGHT && (this._state = this._state | this.mouseButtons.right);
      ((this._state & Ti.ROTATE) === Ti.ROTATE || (this._state & Ti.TOUCH_ROTATE) === Ti.TOUCH_ROTATE || (this._state & Ti.TOUCH_DOLLY_ROTATE) === Ti.TOUCH_DOLLY_ROTATE || (this._state & Ti.TOUCH_ZOOM_ROTATE) === Ti.TOUCH_ZOOM_ROTATE) && (this._sphericalEnd.theta = this._spherical.theta, this._sphericalEnd.phi = this._spherical.phi, this._thetaVelocity.value = 0, this._phiVelocity.value = 0), ((this._state & Ti.TRUCK) === Ti.TRUCK || (this._state & Ti.SCREEN_PAN) === Ti.SCREEN_PAN || (this._state & Ti.TOUCH_TRUCK) === Ti.TOUCH_TRUCK || (this._state & Ti.TOUCH_SCREEN_PAN) === Ti.TOUCH_SCREEN_PAN || (this._state & Ti.TOUCH_DOLLY_TRUCK) === Ti.TOUCH_DOLLY_TRUCK || (this._state & Ti.TOUCH_DOLLY_SCREEN_PAN) === Ti.TOUCH_DOLLY_SCREEN_PAN || (this._state & Ti.TOUCH_ZOOM_TRUCK) === Ti.TOUCH_ZOOM_TRUCK || (this._state & Ti.TOUCH_ZOOM_SCREEN_PAN) === Ti.TOUCH_DOLLY_SCREEN_PAN) && (this._targetEnd.copy(this._target), this._targetVelocity.set(0, 0, 0)), ((this._state & Ti.DOLLY) === Ti.DOLLY || (this._state & Ti.TOUCH_DOLLY) === Ti.TOUCH_DOLLY || (this._state & Ti.TOUCH_DOLLY_TRUCK) === Ti.TOUCH_DOLLY_TRUCK || (this._state & Ti.TOUCH_DOLLY_SCREEN_PAN) === Ti.TOUCH_DOLLY_SCREEN_PAN || (this._state & Ti.TOUCH_DOLLY_OFFSET) === Ti.TOUCH_DOLLY_OFFSET || (this._state & Ti.TOUCH_DOLLY_ROTATE) === Ti.TOUCH_DOLLY_ROTATE) && (this._sphericalEnd.radius = this._spherical.radius, this._radiusVelocity.value = 0), ((this._state & Ti.ZOOM) === Ti.ZOOM || (this._state & Ti.TOUCH_ZOOM) === Ti.TOUCH_ZOOM || (this._state & Ti.TOUCH_ZOOM_TRUCK) === Ti.TOUCH_ZOOM_TRUCK || (this._state & Ti.TOUCH_ZOOM_SCREEN_PAN) === Ti.TOUCH_ZOOM_SCREEN_PAN || (this._state & Ti.TOUCH_ZOOM_OFFSET) === Ti.TOUCH_ZOOM_OFFSET || (this._state & Ti.TOUCH_ZOOM_ROTATE) === Ti.TOUCH_ZOOM_ROTATE) && (this._zoomEnd = this._zoom, this._zoomVelocity.value = 0), ((this._state & Ti.OFFSET) === Ti.OFFSET || (this._state & Ti.TOUCH_OFFSET) === Ti.TOUCH_OFFSET || (this._state & Ti.TOUCH_DOLLY_OFFSET) === Ti.TOUCH_DOLLY_OFFSET || (this._state & Ti.TOUCH_ZOOM_OFFSET) === Ti.TOUCH_ZOOM_OFFSET) && (this._focalOffsetEnd.copy(this._focalOffset), this._focalOffsetVelocity.set(0, 0, 0)), this.dispatchEvent({ type: "controlstart" });
    }, m = () => {
      if (!this._enabled || !this._dragNeedsUpdate)
        return;
      this._dragNeedsUpdate = !1, Ace(this._activePointers, ng);
      const F = this._domElement && this._domElement.ownerDocument.pointerLockElement === this._domElement ? this._lockedPointer || this._activePointers[0] : null, L = F ? -F.deltaX : s.x - ng.x, P = F ? -F.deltaY : s.y - ng.y;
      if (s.copy(ng), ((this._state & Ti.ROTATE) === Ti.ROTATE || (this._state & Ti.TOUCH_ROTATE) === Ti.TOUCH_ROTATE || (this._state & Ti.TOUCH_DOLLY_ROTATE) === Ti.TOUCH_DOLLY_ROTATE || (this._state & Ti.TOUCH_ZOOM_ROTATE) === Ti.TOUCH_ZOOM_ROTATE) && (this._rotateInternal(L, P), this._isUserControllingRotate = !0), (this._state & Ti.DOLLY) === Ti.DOLLY || (this._state & Ti.ZOOM) === Ti.ZOOM) {
        const z = this.dollyToCursor ? (n.x - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0, W = this.dollyToCursor ? (n.y - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0, re = this.dollyDragInverted ? -1 : 1;
        (this._state & Ti.DOLLY) === Ti.DOLLY ? (this._dollyInternal(re * P * Ese, z, W), this._isUserControllingDolly = !0) : (this._zoomInternal(re * P * Ese, z, W), this._isUserControllingZoom = !0);
      }
      if ((this._state & Ti.TOUCH_DOLLY) === Ti.TOUCH_DOLLY || (this._state & Ti.TOUCH_ZOOM) === Ti.TOUCH_ZOOM || (this._state & Ti.TOUCH_DOLLY_TRUCK) === Ti.TOUCH_DOLLY_TRUCK || (this._state & Ti.TOUCH_ZOOM_TRUCK) === Ti.TOUCH_ZOOM_TRUCK || (this._state & Ti.TOUCH_DOLLY_SCREEN_PAN) === Ti.TOUCH_DOLLY_SCREEN_PAN || (this._state & Ti.TOUCH_ZOOM_SCREEN_PAN) === Ti.TOUCH_ZOOM_SCREEN_PAN || (this._state & Ti.TOUCH_DOLLY_OFFSET) === Ti.TOUCH_DOLLY_OFFSET || (this._state & Ti.TOUCH_ZOOM_OFFSET) === Ti.TOUCH_ZOOM_OFFSET || (this._state & Ti.TOUCH_DOLLY_ROTATE) === Ti.TOUCH_DOLLY_ROTATE || (this._state & Ti.TOUCH_ZOOM_ROTATE) === Ti.TOUCH_ZOOM_ROTATE) {
        const z = ng.x - this._activePointers[1].clientX, W = ng.y - this._activePointers[1].clientY, re = Math.sqrt(z * z + W * W), ce = o.y - re;
        o.set(0, re);
        const te = this.dollyToCursor ? (s.x - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0, ee = this.dollyToCursor ? (s.y - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0;
        (this._state & Ti.TOUCH_DOLLY) === Ti.TOUCH_DOLLY || (this._state & Ti.TOUCH_DOLLY_ROTATE) === Ti.TOUCH_DOLLY_ROTATE || (this._state & Ti.TOUCH_DOLLY_TRUCK) === Ti.TOUCH_DOLLY_TRUCK || (this._state & Ti.TOUCH_DOLLY_SCREEN_PAN) === Ti.TOUCH_DOLLY_SCREEN_PAN || (this._state & Ti.TOUCH_DOLLY_OFFSET) === Ti.TOUCH_DOLLY_OFFSET ? (this._dollyInternal(ce * Ese, te, ee), this._isUserControllingDolly = !0) : (this._zoomInternal(ce * Ese, te, ee), this._isUserControllingZoom = !0);
      }
      ((this._state & Ti.TRUCK) === Ti.TRUCK || (this._state & Ti.TOUCH_TRUCK) === Ti.TOUCH_TRUCK || (this._state & Ti.TOUCH_DOLLY_TRUCK) === Ti.TOUCH_DOLLY_TRUCK || (this._state & Ti.TOUCH_ZOOM_TRUCK) === Ti.TOUCH_ZOOM_TRUCK) && (this._truckInternal(L, P, !1, !1), this._isUserControllingTruck = !0), ((this._state & Ti.SCREEN_PAN) === Ti.SCREEN_PAN || (this._state & Ti.TOUCH_SCREEN_PAN) === Ti.TOUCH_SCREEN_PAN || (this._state & Ti.TOUCH_DOLLY_SCREEN_PAN) === Ti.TOUCH_DOLLY_SCREEN_PAN || (this._state & Ti.TOUCH_ZOOM_SCREEN_PAN) === Ti.TOUCH_ZOOM_SCREEN_PAN) && (this._truckInternal(L, P, !1, !0), this._isUserControllingTruck = !0), ((this._state & Ti.OFFSET) === Ti.OFFSET || (this._state & Ti.TOUCH_OFFSET) === Ti.TOUCH_OFFSET || (this._state & Ti.TOUCH_DOLLY_OFFSET) === Ti.TOUCH_DOLLY_OFFSET || (this._state & Ti.TOUCH_ZOOM_OFFSET) === Ti.TOUCH_ZOOM_OFFSET) && (this._truckInternal(L, P, !0, !1), this._isUserControllingOffset = !0), this.dispatchEvent({ type: "control" });
    }, A = () => {
      Ace(this._activePointers, ng), s.copy(ng), this._dragNeedsUpdate = !1, (this._activePointers.length === 0 || this._activePointers.length === 1 && this._activePointers[0] === this._lockedPointer) && (this._isDragging = !1), this._activePointers.length === 0 && this._domElement && (this._domElement.ownerDocument.removeEventListener("pointermove", l, { passive: !1 }), this._domElement.ownerDocument.removeEventListener("pointerup", c), this.dispatchEvent({ type: "controlend" }));
    };
    this.lockPointer = () => {
      !this._enabled || !this._domElement || (this.cancel(), this._lockedPointer = {
        pointerId: -1,
        clientX: 0,
        clientY: 0,
        deltaX: 0,
        deltaY: 0,
        mouseButton: null
      }, this._activePointers.push(this._lockedPointer), this._domElement.ownerDocument.removeEventListener("pointermove", l, { passive: !1 }), this._domElement.ownerDocument.removeEventListener("pointerup", c), this._domElement.requestPointerLock(), this._domElement.ownerDocument.addEventListener("pointerlockchange", C), this._domElement.ownerDocument.addEventListener("pointerlockerror", O), this._domElement.ownerDocument.addEventListener("pointermove", l, { passive: !1 }), this._domElement.ownerDocument.addEventListener("pointerup", c), y());
    }, this.unlockPointer = () => {
      var R, F, L;
      this._lockedPointer !== null && (this._disposePointer(this._lockedPointer), this._lockedPointer = null), (R = this._domElement) === null || R === void 0 || R.ownerDocument.exitPointerLock(), (F = this._domElement) === null || F === void 0 || F.ownerDocument.removeEventListener("pointerlockchange", C), (L = this._domElement) === null || L === void 0 || L.ownerDocument.removeEventListener("pointerlockerror", O), this.cancel();
    };
    const C = () => {
      this._domElement && this._domElement.ownerDocument.pointerLockElement === this._domElement || this.unlockPointer();
    }, O = () => {
      this.unlockPointer();
    };
    this._addAllEventListeners = (R) => {
      this._domElement = R, this._domElement.style.touchAction = "none", this._domElement.style.userSelect = "none", this._domElement.style.webkitUserSelect = "none", this._domElement.addEventListener("pointerdown", r), this._domElement.addEventListener("pointercancel", c), this._domElement.addEventListener("wheel", I, { passive: !1 }), this._domElement.addEventListener("contextmenu", p);
    }, this._removeAllEventListeners = () => {
      this._domElement && (this._domElement.style.touchAction = "", this._domElement.style.userSelect = "", this._domElement.style.webkitUserSelect = "", this._domElement.removeEventListener("pointerdown", r), this._domElement.removeEventListener("pointercancel", c), this._domElement.removeEventListener("wheel", I, { passive: !1 }), this._domElement.removeEventListener("contextmenu", p), this._domElement.ownerDocument.removeEventListener("pointermove", l, { passive: !1 }), this._domElement.ownerDocument.removeEventListener("pointerup", c), this._domElement.ownerDocument.removeEventListener("pointerlockchange", C), this._domElement.ownerDocument.removeEventListener("pointerlockerror", O));
    }, this.cancel = () => {
      this._state !== Ti.NONE && (this._state = Ti.NONE, this._activePointers.length = 0, A());
    }, i && this.connect(i), this.update(0);
  }
  /**
   * The camera to be controlled
   * @category Properties
   */
  get camera() {
    return this._camera;
  }
  set camera(t) {
    this._camera = t, this.updateCameraUp(), this._camera.updateProjectionMatrix(), this._updateNearPlaneCorners(), this._needsUpdate = !0;
  }
  /**
   * Whether or not the controls are enabled.
   * `false` to disable user dragging/touch-move, but all methods works.
   * @category Properties
   */
  get enabled() {
    return this._enabled;
  }
  set enabled(t) {
    this._enabled = t, this._domElement && (t ? (this._domElement.style.touchAction = "none", this._domElement.style.userSelect = "none", this._domElement.style.webkitUserSelect = "none") : (this.cancel(), this._domElement.style.touchAction = "", this._domElement.style.userSelect = "", this._domElement.style.webkitUserSelect = ""));
  }
  /**
   * Returns `true` if the controls are active updating.
   * readonly value.
   * @category Properties
   */
  get active() {
    return !this._hasRested;
  }
  /**
   * Getter for the current `ACTION`.
   * readonly value.
   * @category Properties
   */
  get currentAction() {
    return this._state;
  }
  /**
   * get/set Current distance.
   * @category Properties
   */
  get distance() {
    return this._spherical.radius;
  }
  set distance(t) {
    this._spherical.radius === t && this._sphericalEnd.radius === t || (this._spherical.radius = t, this._sphericalEnd.radius = t, this._needsUpdate = !0);
  }
  // horizontal angle
  /**
   * get/set the azimuth angle (horizontal) in radians.
   * Every 360 degrees turn is added to `.azimuthAngle` value, which is accumulative.
   * @category Properties
   */
  get azimuthAngle() {
    return this._spherical.theta;
  }
  set azimuthAngle(t) {
    this._spherical.theta === t && this._sphericalEnd.theta === t || (this._spherical.theta = t, this._sphericalEnd.theta = t, this._needsUpdate = !0);
  }
  // vertical angle
  /**
   * get/set the polar angle (vertical) in radians.
   * @category Properties
   */
  get polarAngle() {
    return this._spherical.phi;
  }
  set polarAngle(t) {
    this._spherical.phi === t && this._sphericalEnd.phi === t || (this._spherical.phi = t, this._sphericalEnd.phi = t, this._needsUpdate = !0);
  }
  /**
   * Whether camera position should be enclosed in the boundary or not.
   * @category Properties
   */
  get boundaryEnclosesCamera() {
    return this._boundaryEnclosesCamera;
  }
  set boundaryEnclosesCamera(t) {
    this._boundaryEnclosesCamera = t, this._needsUpdate = !0;
  }
  /**
   * Set drag-start, touches and wheel enable area in the domElement.
   * each values are between `0` and `1` inclusive, where `0` is left/top and `1` is right/bottom of the screen.
   * e.g. `{ x: 0, y: 0, width: 1, height: 1 }` for entire area.
   * @category Properties
   */
  set interactiveArea(t) {
    this._interactiveArea.width = cv(t.width, 0, 1), this._interactiveArea.height = cv(t.height, 0, 1), this._interactiveArea.x = cv(t.x, 0, 1 - this._interactiveArea.width), this._interactiveArea.y = cv(t.y, 0, 1 - this._interactiveArea.height);
  }
  /**
   * Adds the specified event listener.
   * Applicable event types (which is `K`) are:
   * | Event name          | Timing |
   * | ------------------- | ------ |
   * | `'controlstart'`    | When the user starts to control the camera via mouse / touches. ¹ |
   * | `'control'`         | When the user controls the camera (dragging). |
   * | `'controlend'`      | When the user ends to control the camera. ¹ |
   * | `'transitionstart'` | When any kind of transition starts, either user control or using a method with `enableTransition = true` |
   * | `'update'`          | When the camera position is updated. |
   * | `'wake'`            | When the camera starts moving. |
   * | `'rest'`            | When the camera movement is below `.restThreshold` ². |
   * | `'sleep'`           | When the camera end moving. |
   *
   * 1. `mouseButtons.wheel` (Mouse wheel control) does not emit `'controlstart'` and `'controlend'`. `mouseButtons.wheel` uses scroll-event internally, and scroll-event happens intermittently. That means "start" and "end" cannot be detected.
   * 2. Due to damping, `sleep` will usually fire a few seconds after the camera _appears_ to have stopped moving. If you want to do something (e.g. enable UI, perform another transition) at the point when the camera has stopped, you probably want the `rest` event. This can be fine tuned using the `.restThreshold` parameter. See the [Rest and Sleep Example](https://yomotsu.github.io/camera-controls/examples/rest-and-sleep.html).
   *
   * e.g.
   * ```
   * cameraControl.addEventListener( 'controlstart', myCallbackFunction );
   * ```
   * @param type event name
   * @param listener handler function
   * @category Methods
   */
  addEventListener(t, i) {
    super.addEventListener(t, i);
  }
  /**
   * Removes the specified event listener
   * e.g.
   * ```
   * cameraControl.addEventListener( 'controlstart', myCallbackFunction );
   * ```
   * @param type event name
   * @param listener handler function
   * @category Methods
   */
  removeEventListener(t, i) {
    super.removeEventListener(t, i);
  }
  /**
   * Rotate azimuthal angle(horizontal) and polar angle(vertical).
   * Every value is added to the current value.
   * @param azimuthAngle Azimuth rotate angle. In radian.
   * @param polarAngle Polar rotate angle. In radian.
   * @param enableTransition Whether to move smoothly or immediately
   * @category Methods
   */
  rotate(t, i, n = !1) {
    return this.rotateTo(this._sphericalEnd.theta + t, this._sphericalEnd.phi + i, n);
  }
  /**
   * Rotate azimuthal angle(horizontal) to the given angle and keep the same polar angle(vertical) target.
   *
   * e.g.
   * ```
   * cameraControls.rotateAzimuthTo( 30 * THREE.MathUtils.DEG2RAD, true );
   * ```
   * @param azimuthAngle Azimuth rotate angle. In radian.
   * @param enableTransition Whether to move smoothly or immediately
   * @category Methods
   */
  rotateAzimuthTo(t, i = !1) {
    return this.rotateTo(t, this._sphericalEnd.phi, i);
  }
  /**
   * Rotate polar angle(vertical) to the given angle and keep the same azimuthal angle(horizontal) target.
   *
   * e.g.
   * ```
   * cameraControls.rotatePolarTo( 30 * THREE.MathUtils.DEG2RAD, true );
   * ```
   * @param polarAngle Polar rotate angle. In radian.
   * @param enableTransition Whether to move smoothly or immediately
   * @category Methods
   */
  rotatePolarTo(t, i = !1) {
    return this.rotateTo(this._sphericalEnd.theta, t, i);
  }
  /**
   * Rotate azimuthal angle(horizontal) and polar angle(vertical) to the given angle.
   * Camera view will rotate over the orbit pivot absolutely:
   *
   * azimuthAngle
   * ```
   *       0º
   *         \
   * 90º -----+----- -90º
   *           \
   *           180º
   * ```
   * | direction | angle                  |
   * | --------- | ---------------------- |
   * | front     | 0º                     |
   * | left      | 90º (`Math.PI / 2`)    |
   * | right     | -90º (`- Math.PI / 2`) |
   * | back      | 180º (`Math.PI`)       |
   *
   * polarAngle
   * ```
   *     180º
   *      |
   *      90º
   *      |
   *      0º
   * ```
   * | direction            | angle                  |
   * | -------------------- | ---------------------- |
   * | top/sky              | 180º (`Math.PI`)       |
   * | horizontal from view | 90º (`Math.PI / 2`)    |
   * | bottom/floor         | 0º                     |
   *
   * @param azimuthAngle Azimuth rotate angle to. In radian.
   * @param polarAngle Polar rotate angle to. In radian.
   * @param enableTransition  Whether to move smoothly or immediately
   * @category Methods
   */
  rotateTo(t, i, n = !1) {
    this._isUserControllingRotate = !1;
    const s = cv(t, this.minAzimuthAngle, this.maxAzimuthAngle), o = cv(i, this.minPolarAngle, this.maxPolarAngle);
    this._sphericalEnd.theta = s, this._sphericalEnd.phi = o, this._sphericalEnd.makeSafe(), this._needsUpdate = !0, n || (this._spherical.theta = this._sphericalEnd.theta, this._spherical.phi = this._sphericalEnd.phi);
    const r = !n || Il(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) && Il(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold);
    return this._createOnRestPromise(r);
  }
  /**
   * Dolly in/out camera position.
   * @param distance Distance of dollyIn. Negative number for dollyOut.
   * @param enableTransition Whether to move smoothly or immediately.
   * @category Methods
   */
  dolly(t, i = !1) {
    return this.dollyTo(this._sphericalEnd.radius - t, i);
  }
  /**
   * Dolly in/out camera position to given distance.
   * @param distance Distance of dolly.
   * @param enableTransition Whether to move smoothly or immediately.
   * @category Methods
   */
  dollyTo(t, i = !1) {
    return this._isUserControllingDolly = !1, this._lastDollyDirection = Xk.NONE, this._changedDolly = 0, this._dollyToNoClamp(cv(t, this.minDistance, this.maxDistance), i);
  }
  _dollyToNoClamp(t, i = !1) {
    const n = this._sphericalEnd.radius;
    if (this.colliderMeshes.length >= 1) {
      const r = this._collisionTest(), l = Il(r, this._spherical.radius);
      if (!(n > t) && l)
        return Promise.resolve();
      this._sphericalEnd.radius = Math.min(t, r);
    } else
      this._sphericalEnd.radius = t;
    this._needsUpdate = !0, i || (this._spherical.radius = this._sphericalEnd.radius);
    const o = !i || Il(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
    return this._createOnRestPromise(o);
  }
  /**
   * Dolly in, but does not change the distance between the target and the camera, and moves the target position instead.
   * Specify a negative value for dolly out.
   * @param distance Distance of dolly.
   * @param enableTransition Whether to move smoothly or immediately.
   * @category Methods
   */
  dollyInFixed(t, i = !1) {
    this._targetEnd.add(this._getCameraDirection(MZ).multiplyScalar(t)), i || this._target.copy(this._targetEnd);
    const n = !i || Il(this._target.x, this._targetEnd.x, this.restThreshold) && Il(this._target.y, this._targetEnd.y, this.restThreshold) && Il(this._target.z, this._targetEnd.z, this.restThreshold);
    return this._createOnRestPromise(n);
  }
  /**
   * Zoom in/out camera. The value is added to camera zoom.
   * Limits set with `.minZoom` and `.maxZoom`
   * @param zoomStep zoom scale
   * @param enableTransition Whether to move smoothly or immediately
   * @category Methods
   */
  zoom(t, i = !1) {
    return this.zoomTo(this._zoomEnd + t, i);
  }
  /**
   * Zoom in/out camera to given scale. The value overwrites camera zoom.
   * Limits set with .minZoom and .maxZoom
   * @param zoom
   * @param enableTransition
   * @category Methods
   */
  zoomTo(t, i = !1) {
    this._isUserControllingZoom = !1, this._zoomEnd = cv(t, this.minZoom, this.maxZoom), this._needsUpdate = !0, i || (this._zoom = this._zoomEnd);
    const n = !i || Il(this._zoom, this._zoomEnd, this.restThreshold);
    return this._changedZoom = 0, this._createOnRestPromise(n);
  }
  /**
   * @deprecated `pan()` has been renamed to `truck()`
   * @category Methods
   */
  pan(t, i, n = !1) {
    return console.warn("`pan` has been renamed to `truck`"), this.truck(t, i, n);
  }
  /**
   * Truck and pedestal camera using current azimuthal angle
   * @param x Horizontal translate amount
   * @param y Vertical translate amount
   * @param enableTransition Whether to move smoothly or immediately
   * @category Methods
   */
  truck(t, i, n = !1) {
    this._camera.updateMatrix(), fb.setFromMatrixColumn(this._camera.matrix, 0), Ib.setFromMatrixColumn(this._camera.matrix, 1), fb.multiplyScalar(t), Ib.multiplyScalar(-i);
    const s = vo.copy(fb).add(Ib), o = Kr.copy(this._targetEnd).add(s);
    return this.moveTo(o.x, o.y, o.z, n);
  }
  /**
   * Move forward / backward.
   * @param distance Amount to move forward / backward. Negative value to move backward
   * @param enableTransition Whether to move smoothly or immediately
   * @category Methods
   */
  forward(t, i = !1) {
    vo.setFromMatrixColumn(this._camera.matrix, 0), vo.crossVectors(this._camera.up, vo), vo.multiplyScalar(t);
    const n = Kr.copy(this._targetEnd).add(vo);
    return this.moveTo(n.x, n.y, n.z, i);
  }
  /**
   * Move up / down.
   * @param height Amount to move up / down. Negative value to move down
   * @param enableTransition Whether to move smoothly or immediately
   * @category Methods
   */
  elevate(t, i = !1) {
    return vo.copy(this._camera.up).multiplyScalar(t), this.moveTo(this._targetEnd.x + vo.x, this._targetEnd.y + vo.y, this._targetEnd.z + vo.z, i);
  }
  /**
   * Move target position to given point.
   * @param x x coord to move center position
   * @param y y coord to move center position
   * @param z z coord to move center position
   * @param enableTransition Whether to move smoothly or immediately
   * @category Methods
   */
  moveTo(t, i, n, s = !1) {
    this._isUserControllingTruck = !1;
    const o = vo.set(t, i, n).sub(this._targetEnd);
    this._encloseToBoundary(this._targetEnd, o, this.boundaryFriction), this._needsUpdate = !0, s || this._target.copy(this._targetEnd);
    const r = !s || Il(this._target.x, this._targetEnd.x, this.restThreshold) && Il(this._target.y, this._targetEnd.y, this.restThreshold) && Il(this._target.z, this._targetEnd.z, this.restThreshold);
    return this._createOnRestPromise(r);
  }
  /**
   * Look in the given point direction.
   * @param x point x.
   * @param y point y.
   * @param z point z.
   * @param enableTransition Whether to move smoothly or immediately.
   * @returns Transition end promise
   * @category Methods
   */
  lookInDirectionOf(t, i, n, s = !1) {
    const l = vo.set(t, i, n).sub(this._targetEnd).normalize().multiplyScalar(-this._sphericalEnd.radius).add(this._targetEnd);
    return this.setPosition(l.x, l.y, l.z, s);
  }
  /**
   * Fit the viewport to the box or the bounding box of the object, using the nearest axis. paddings are in unit.
   * set `cover: true` to fill enter screen.
   * e.g.
   * ```
   * cameraControls.fitToBox( myMesh );
   * ```
   * @param box3OrObject Axis aligned bounding box to fit the view.
   * @param enableTransition Whether to move smoothly or immediately.
   * @param options | `<object>` { cover: boolean, paddingTop: number, paddingLeft: number, paddingBottom: number, paddingRight: number }
   * @returns Transition end promise
   * @category Methods
   */
  fitToBox(t, i, { cover: n = !1, paddingLeft: s = 0, paddingRight: o = 0, paddingBottom: r = 0, paddingTop: l = 0 } = {}) {
    const c = [], h = t.isBox3 ? iV.copy(t) : iV.setFromObject(t);
    h.isEmpty() && (console.warn("camera-controls: fitTo() cannot be used with an empty box. Aborting"), Promise.resolve());
    const I = Ywe(this._sphericalEnd.theta, Wwe), p = Ywe(this._sphericalEnd.phi, Wwe);
    c.push(this.rotateTo(I, p, i));
    const y = vo.setFromSpherical(this._sphericalEnd).normalize(), m = Jwe.setFromUnitVectors(y, Nce), A = Il(Math.abs(y.y), 1);
    A && m.multiply(Cce.setFromAxisAngle(gse, I)), m.multiply(this._yAxisUpSpaceInverse);
    const C = Qwe.makeEmpty();
    Kr.copy(h.min).applyQuaternion(m), C.expandByPoint(Kr), Kr.copy(h.min).setX(h.max.x).applyQuaternion(m), C.expandByPoint(Kr), Kr.copy(h.min).setY(h.max.y).applyQuaternion(m), C.expandByPoint(Kr), Kr.copy(h.max).setZ(h.min.z).applyQuaternion(m), C.expandByPoint(Kr), Kr.copy(h.min).setZ(h.max.z).applyQuaternion(m), C.expandByPoint(Kr), Kr.copy(h.max).setY(h.min.y).applyQuaternion(m), C.expandByPoint(Kr), Kr.copy(h.max).setX(h.min.x).applyQuaternion(m), C.expandByPoint(Kr), Kr.copy(h.max).applyQuaternion(m), C.expandByPoint(Kr), C.min.x -= s, C.min.y -= r, C.max.x += o, C.max.y += l, m.setFromUnitVectors(Nce, y), A && m.premultiply(Cce.invert()), m.premultiply(this._yAxisUpSpace);
    const O = C.getSize(vo), R = C.getCenter(Kr).applyQuaternion(m);
    if (iU(this._camera)) {
      const F = this.getDistanceToFitBox(O.x, O.y, O.z, n);
      c.push(this.moveTo(R.x, R.y, R.z, i)), c.push(this.dollyTo(F, i)), c.push(this.setFocalOffset(0, 0, 0, i));
    } else if (z_(this._camera)) {
      const F = this._camera, L = F.right - F.left, P = F.top - F.bottom, z = n ? Math.max(L / O.x, P / O.y) : Math.min(L / O.x, P / O.y);
      c.push(this.moveTo(R.x, R.y, R.z, i)), c.push(this.zoomTo(z, i)), c.push(this.setFocalOffset(0, 0, 0, i));
    }
    return Promise.all(c);
  }
  /**
   * Fit the viewport to the sphere or the bounding sphere of the object.
   * @param sphereOrMesh
   * @param enableTransition
   * @category Methods
   */
  fitToSphere(t, i) {
    const n = [], o = "isObject3D" in t ? c3.createBoundingSphere(t, Dce) : Dce.copy(t);
    if (n.push(this.moveTo(o.center.x, o.center.y, o.center.z, i)), iU(this._camera)) {
      const r = this.getDistanceToFitSphere(o.radius);
      n.push(this.dollyTo(r, i));
    } else if (z_(this._camera)) {
      const r = this._camera.right - this._camera.left, l = this._camera.top - this._camera.bottom, c = 2 * o.radius, h = Math.min(r / c, l / c);
      n.push(this.zoomTo(h, i));
    }
    return n.push(this.setFocalOffset(0, 0, 0, i)), Promise.all(n);
  }
  /**
   * Look at the `target` from the `position`.
   * @param positionX
   * @param positionY
   * @param positionZ
   * @param targetX
   * @param targetY
   * @param targetZ
   * @param enableTransition
   * @category Methods
   */
  setLookAt(t, i, n, s, o, r, l = !1) {
    this._isUserControllingRotate = !1, this._isUserControllingDolly = !1, this._isUserControllingTruck = !1, this._lastDollyDirection = Xk.NONE, this._changedDolly = 0;
    const c = Kr.set(s, o, r), h = vo.set(t, i, n);
    this._targetEnd.copy(c), this._sphericalEnd.setFromVector3(h.sub(c).applyQuaternion(this._yAxisUpSpace)), this.normalizeRotations(), this._needsUpdate = !0, l || (this._target.copy(this._targetEnd), this._spherical.copy(this._sphericalEnd));
    const I = !l || Il(this._target.x, this._targetEnd.x, this.restThreshold) && Il(this._target.y, this._targetEnd.y, this.restThreshold) && Il(this._target.z, this._targetEnd.z, this.restThreshold) && Il(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) && Il(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold) && Il(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
    return this._createOnRestPromise(I);
  }
  /**
   * Similar to setLookAt, but it interpolates between two states.
   * @param positionAX
   * @param positionAY
   * @param positionAZ
   * @param targetAX
   * @param targetAY
   * @param targetAZ
   * @param positionBX
   * @param positionBY
   * @param positionBZ
   * @param targetBX
   * @param targetBY
   * @param targetBZ
   * @param t
   * @param enableTransition
   * @category Methods
   */
  lerpLookAt(t, i, n, s, o, r, l, c, h, I, p, y, m, A = !1) {
    this._isUserControllingRotate = !1, this._isUserControllingDolly = !1, this._isUserControllingTruck = !1, this._lastDollyDirection = Xk.NONE, this._changedDolly = 0;
    const C = vo.set(s, o, r), O = Kr.set(t, i, n);
    zT.setFromVector3(O.sub(C).applyQuaternion(this._yAxisUpSpace));
    const R = tV.set(I, p, y), F = Kr.set(l, c, h);
    UZ.setFromVector3(F.sub(R).applyQuaternion(this._yAxisUpSpace)), this._targetEnd.copy(C.lerp(R, m));
    const L = UZ.theta - zT.theta, P = UZ.phi - zT.phi, z = UZ.radius - zT.radius;
    this._sphericalEnd.set(zT.radius + z * m, zT.phi + P * m, zT.theta + L * m), this.normalizeRotations(), this._needsUpdate = !0, A || (this._target.copy(this._targetEnd), this._spherical.copy(this._sphericalEnd));
    const W = !A || Il(this._target.x, this._targetEnd.x, this.restThreshold) && Il(this._target.y, this._targetEnd.y, this.restThreshold) && Il(this._target.z, this._targetEnd.z, this.restThreshold) && Il(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) && Il(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold) && Il(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
    return this._createOnRestPromise(W);
  }
  /**
   * Set angle and distance by given position.
   * An alias of `setLookAt()`, without target change. Thus keep gazing at the current target
   * @param positionX
   * @param positionY
   * @param positionZ
   * @param enableTransition
   * @category Methods
   */
  setPosition(t, i, n, s = !1) {
    return this.setLookAt(t, i, n, this._targetEnd.x, this._targetEnd.y, this._targetEnd.z, s);
  }
  /**
   * Set the target position where gaze at.
   * An alias of `setLookAt()`, without position change. Thus keep the same position.
   * @param targetX
   * @param targetY
   * @param targetZ
   * @param enableTransition
   * @category Methods
   */
  setTarget(t, i, n, s = !1) {
    const o = this.getPosition(vo), r = this.setLookAt(o.x, o.y, o.z, t, i, n, s);
    return this._sphericalEnd.phi = cv(this._sphericalEnd.phi, this.minPolarAngle, this.maxPolarAngle), r;
  }
  /**
   * Set focal offset using the screen parallel coordinates. z doesn't affect in Orthographic as with Dolly.
   * @param x
   * @param y
   * @param z
   * @param enableTransition
   * @category Methods
   */
  setFocalOffset(t, i, n, s = !1) {
    this._isUserControllingOffset = !1, this._focalOffsetEnd.set(t, i, n), this._needsUpdate = !0, s || this._focalOffset.copy(this._focalOffsetEnd);
    const o = !s || Il(this._focalOffset.x, this._focalOffsetEnd.x, this.restThreshold) && Il(this._focalOffset.y, this._focalOffsetEnd.y, this.restThreshold) && Il(this._focalOffset.z, this._focalOffsetEnd.z, this.restThreshold);
    return this._createOnRestPromise(o);
  }
  /**
   * Set orbit point without moving the camera.
   * SHOULD NOT RUN DURING ANIMATIONS. `setOrbitPoint()` will immediately fix the positions.
   * @param targetX
   * @param targetY
   * @param targetZ
   * @category Methods
   */
  setOrbitPoint(t, i, n) {
    this._camera.updateMatrixWorld(), fb.setFromMatrixColumn(this._camera.matrixWorldInverse, 0), Ib.setFromMatrixColumn(this._camera.matrixWorldInverse, 1), nU.setFromMatrixColumn(this._camera.matrixWorldInverse, 2);
    const s = vo.set(t, i, n), o = s.distanceTo(this._camera.position), r = s.sub(this._camera.position);
    fb.multiplyScalar(r.x), Ib.multiplyScalar(r.y), nU.multiplyScalar(r.z), vo.copy(fb).add(Ib).add(nU), vo.z = vo.z + o, this.dollyTo(o, !1), this.setFocalOffset(-vo.x, vo.y, -vo.z, !1), this.moveTo(t, i, n, !1);
  }
  /**
   * Set the boundary box that encloses the target of the camera. box3 is in THREE.Box3
   * @param box3
   * @category Methods
   */
  setBoundary(t) {
    if (!t) {
      this._boundary.min.set(-1 / 0, -1 / 0, -1 / 0), this._boundary.max.set(1 / 0, 1 / 0, 1 / 0), this._needsUpdate = !0;
      return;
    }
    this._boundary.copy(t), this._boundary.clampPoint(this._targetEnd, this._targetEnd), this._needsUpdate = !0;
  }
  /**
   * Set (or unset) the current viewport.
   * Set this when you want to use renderer viewport and .dollyToCursor feature at the same time.
   * @param viewportOrX
   * @param y
   * @param width
   * @param height
   * @category Methods
   */
  setViewport(t, i, n, s) {
    if (t === null) {
      this._viewport = null;
      return;
    }
    this._viewport = this._viewport || new Hs.Vector4(), typeof t == "number" ? this._viewport.set(t, i, n, s) : this._viewport.copy(t);
  }
  /**
   * Calculate the distance to fit the box.
   * @param width box width
   * @param height box height
   * @param depth box depth
   * @returns distance
   * @category Methods
   */
  getDistanceToFitBox(t, i, n, s = !1) {
    if (Sce(this._camera, "getDistanceToFitBox"))
      return this._spherical.radius;
    const o = t / i, r = this._camera.getEffectiveFOV() * _Z, l = this._camera.aspect;
    return ((s ? o > l : o < l) ? i : t / l) * 0.5 / Math.tan(r * 0.5) + n * 0.5;
  }
  /**
   * Calculate the distance to fit the sphere.
   * @param radius sphere radius
   * @returns distance
   * @category Methods
   */
  getDistanceToFitSphere(t) {
    if (Sce(this._camera, "getDistanceToFitSphere"))
      return this._spherical.radius;
    const i = this._camera.getEffectiveFOV() * _Z, n = Math.atan(Math.tan(i * 0.5) * this._camera.aspect) * 2, s = 1 < this._camera.aspect ? i : n;
    return t / Math.sin(s * 0.5);
  }
  /**
   * Returns the orbit center position, where the camera looking at.
   * @param out The receiving Vector3 instance to copy the result
   * @param receiveEndValue Whether receive the transition end coords or current. default is `true`
   * @category Methods
   */
  getTarget(t, i = !0) {
    return (t && t.isVector3 ? t : new Hs.Vector3()).copy(i ? this._targetEnd : this._target);
  }
  /**
   * Returns the camera position.
   * @param out The receiving Vector3 instance to copy the result
   * @param receiveEndValue Whether receive the transition end coords or current. default is `true`
   * @category Methods
   */
  getPosition(t, i = !0) {
    return (t && t.isVector3 ? t : new Hs.Vector3()).setFromSpherical(i ? this._sphericalEnd : this._spherical).applyQuaternion(this._yAxisUpSpaceInverse).add(i ? this._targetEnd : this._target);
  }
  /**
   * Returns the spherical coordinates of the orbit.
   * @param out The receiving Spherical instance to copy the result
   * @param receiveEndValue Whether receive the transition end coords or current. default is `true`
   * @category Methods
   */
  getSpherical(t, i = !0) {
    return (t || new Hs.Spherical()).copy(i ? this._sphericalEnd : this._spherical);
  }
  /**
   * Returns the focal offset, which is how much the camera appears to be translated in screen parallel coordinates.
   * @param out The receiving Vector3 instance to copy the result
   * @param receiveEndValue Whether receive the transition end coords or current. default is `true`
   * @category Methods
   */
  getFocalOffset(t, i = !0) {
    return (t && t.isVector3 ? t : new Hs.Vector3()).copy(i ? this._focalOffsetEnd : this._focalOffset);
  }
  /**
   * Normalize camera azimuth angle rotation between 0 and 360 degrees.
   * @category Methods
   */
  normalizeRotations() {
    this._sphericalEnd.theta = this._sphericalEnd.theta % eV, this._sphericalEnd.theta < 0 && (this._sphericalEnd.theta += eV), this._spherical.theta += eV * Math.round((this._sphericalEnd.theta - this._spherical.theta) / eV);
  }
  /**
   * stop all transitions.
   */
  stop() {
    this._focalOffset.copy(this._focalOffsetEnd), this._target.copy(this._targetEnd), this._spherical.copy(this._sphericalEnd), this._zoom = this._zoomEnd;
  }
  /**
   * Reset all rotation and position to defaults.
   * @param enableTransition
   * @category Methods
   */
  reset(t = !1) {
    if (!Il(this._camera.up.x, this._cameraUp0.x) || !Il(this._camera.up.y, this._cameraUp0.y) || !Il(this._camera.up.z, this._cameraUp0.z)) {
      this._camera.up.copy(this._cameraUp0);
      const n = this.getPosition(vo);
      this.updateCameraUp(), this.setPosition(n.x, n.y, n.z);
    }
    const i = [
      this.setLookAt(this._position0.x, this._position0.y, this._position0.z, this._target0.x, this._target0.y, this._target0.z, t),
      this.setFocalOffset(this._focalOffset0.x, this._focalOffset0.y, this._focalOffset0.z, t),
      this.zoomTo(this._zoom0, t)
    ];
    return Promise.all(i);
  }
  /**
   * Set current camera position as the default position.
   * @category Methods
   */
  saveState() {
    this._cameraUp0.copy(this._camera.up), this.getTarget(this._target0), this.getPosition(this._position0), this._zoom0 = this._zoom, this._focalOffset0.copy(this._focalOffset);
  }
  /**
   * Sync camera-up direction.
   * When camera-up vector is changed, `.updateCameraUp()` must be called.
   * @category Methods
   */
  updateCameraUp() {
    this._yAxisUpSpace.setFromUnitVectors(this._camera.up, gse), this._yAxisUpSpaceInverse.copy(this._yAxisUpSpace).invert();
  }
  /**
   * Apply current camera-up direction to the camera.
   * The orbit system will be re-initialized with the current position.
   * @category Methods
   */
  applyCameraUp() {
    const t = vo.subVectors(this._target, this._camera.position).normalize(), i = Kr.crossVectors(t, this._camera.up);
    this._camera.up.crossVectors(i, t).normalize(), this._camera.updateMatrixWorld();
    const n = this.getPosition(vo);
    this.updateCameraUp(), this.setPosition(n.x, n.y, n.z);
  }
  /**
   * Update camera position and directions.
   * This should be called in your tick loop every time, and returns true if re-rendering is needed.
   * @param delta
   * @returns updated
   * @category Methods
   */
  update(t) {
    const i = this._sphericalEnd.theta - this._spherical.theta, n = this._sphericalEnd.phi - this._spherical.phi, s = this._sphericalEnd.radius - this._spherical.radius, o = Kwe.subVectors(this._targetEnd, this._target), r = Zwe.subVectors(this._focalOffsetEnd, this._focalOffset), l = this._zoomEnd - this._zoom;
    if (Xl(i))
      this._thetaVelocity.value = 0, this._spherical.theta = this._sphericalEnd.theta;
    else {
      const p = this._isUserControllingRotate ? this.draggingSmoothTime : this.smoothTime;
      this._spherical.theta = yse(this._spherical.theta, this._sphericalEnd.theta, this._thetaVelocity, p, 1 / 0, t), this._needsUpdate = !0;
    }
    if (Xl(n))
      this._phiVelocity.value = 0, this._spherical.phi = this._sphericalEnd.phi;
    else {
      const p = this._isUserControllingRotate ? this.draggingSmoothTime : this.smoothTime;
      this._spherical.phi = yse(this._spherical.phi, this._sphericalEnd.phi, this._phiVelocity, p, 1 / 0, t), this._needsUpdate = !0;
    }
    if (Xl(s))
      this._radiusVelocity.value = 0, this._spherical.radius = this._sphericalEnd.radius;
    else {
      const p = this._isUserControllingDolly ? this.draggingSmoothTime : this.smoothTime;
      this._spherical.radius = yse(this._spherical.radius, this._sphericalEnd.radius, this._radiusVelocity, p, this.maxSpeed, t), this._needsUpdate = !0;
    }
    if (Xl(o.x) && Xl(o.y) && Xl(o.z))
      this._targetVelocity.set(0, 0, 0), this._target.copy(this._targetEnd);
    else {
      const p = this._isUserControllingTruck ? this.draggingSmoothTime : this.smoothTime;
      qwe(this._target, this._targetEnd, this._targetVelocity, p, this.maxSpeed, t, this._target), this._needsUpdate = !0;
    }
    if (Xl(r.x) && Xl(r.y) && Xl(r.z))
      this._focalOffsetVelocity.set(0, 0, 0), this._focalOffset.copy(this._focalOffsetEnd);
    else {
      const p = this._isUserControllingOffset ? this.draggingSmoothTime : this.smoothTime;
      qwe(this._focalOffset, this._focalOffsetEnd, this._focalOffsetVelocity, p, this.maxSpeed, t, this._focalOffset), this._needsUpdate = !0;
    }
    if (Xl(l))
      this._zoomVelocity.value = 0, this._zoom = this._zoomEnd;
    else {
      const p = this._isUserControllingZoom ? this.draggingSmoothTime : this.smoothTime;
      this._zoom = yse(this._zoom, this._zoomEnd, this._zoomVelocity, p, 1 / 0, t);
    }
    if (this.dollyToCursor) {
      if (iU(this._camera) && this._changedDolly !== 0) {
        const p = this._spherical.radius - this._lastDistance, y = this._camera, m = this._getCameraDirection(MZ), A = vo.copy(m).cross(y.up).normalize();
        A.lengthSq() === 0 && (A.x = 1);
        const C = Kr.crossVectors(A, m), O = this._sphericalEnd.radius * Math.tan(y.getEffectiveFOV() * _Z * 0.5), F = (this._sphericalEnd.radius - p - this._sphericalEnd.radius) / this._sphericalEnd.radius, L = tV.copy(this._targetEnd).add(A.multiplyScalar(this._dollyControlCoord.x * O * y.aspect)).add(C.multiplyScalar(this._dollyControlCoord.y * O)), P = vo.copy(this._targetEnd).lerp(L, F), z = this._lastDollyDirection === Xk.IN && this._spherical.radius <= this.minDistance, W = this._lastDollyDirection === Xk.OUT && this.maxDistance <= this._spherical.radius;
        if (this.infinityDolly && (z || W)) {
          this._sphericalEnd.radius -= p, this._spherical.radius -= p;
          const ce = Kr.copy(m).multiplyScalar(-p);
          P.add(ce);
        }
        this._boundary.clampPoint(P, P);
        const re = Kr.subVectors(P, this._targetEnd);
        this._targetEnd.copy(P), this._target.add(re), this._changedDolly -= p, Xl(this._changedDolly) && (this._changedDolly = 0);
      } else if (z_(this._camera) && this._changedZoom !== 0) {
        const p = this._zoom - this._lastZoom, y = this._camera, m = vo.set(this._dollyControlCoord.x, this._dollyControlCoord.y, (y.near + y.far) / (y.near - y.far)).unproject(y), A = Kr.set(0, 0, -1).applyQuaternion(y.quaternion), C = tV.copy(m).add(A.multiplyScalar(-m.dot(y.up))), R = -(this._zoom - p - this._zoom) / this._zoom, F = this._getCameraDirection(MZ), L = this._targetEnd.dot(F), P = vo.copy(this._targetEnd).lerp(C, R), z = P.dot(F), W = F.multiplyScalar(z - L);
        P.sub(W), this._boundary.clampPoint(P, P);
        const re = Kr.subVectors(P, this._targetEnd);
        this._targetEnd.copy(P), this._target.add(re), this._changedZoom -= p, Xl(this._changedZoom) && (this._changedZoom = 0);
      }
    }
    this._camera.zoom !== this._zoom && (this._camera.zoom = this._zoom, this._camera.updateProjectionMatrix(), this._updateNearPlaneCorners(), this._needsUpdate = !0), this._dragNeedsUpdate = !0;
    const c = this._collisionTest();
    this._spherical.radius = Math.min(this._spherical.radius, c), this._spherical.makeSafe(), this._camera.position.setFromSpherical(this._spherical).applyQuaternion(this._yAxisUpSpaceInverse).add(this._target), this._camera.lookAt(this._target), (!Xl(this._focalOffset.x) || !Xl(this._focalOffset.y) || !Xl(this._focalOffset.z)) && (fb.setFromMatrixColumn(this._camera.matrix, 0), Ib.setFromMatrixColumn(this._camera.matrix, 1), nU.setFromMatrixColumn(this._camera.matrix, 2), fb.multiplyScalar(this._focalOffset.x), Ib.multiplyScalar(-this._focalOffset.y), nU.multiplyScalar(this._focalOffset.z), vo.copy(fb).add(Ib).add(nU), this._camera.position.add(vo), this._camera.updateMatrixWorld()), this._boundaryEnclosesCamera && this._encloseToBoundary(this._camera.position.copy(this._target), vo.setFromSpherical(this._spherical).applyQuaternion(this._yAxisUpSpaceInverse), 1);
    const I = this._needsUpdate;
    return I && !this._updatedLastTime ? (this._hasRested = !1, this.dispatchEvent({ type: "wake" }), this.dispatchEvent({ type: "update" })) : I ? (this.dispatchEvent({ type: "update" }), Xl(i, this.restThreshold) && Xl(n, this.restThreshold) && Xl(s, this.restThreshold) && Xl(o.x, this.restThreshold) && Xl(o.y, this.restThreshold) && Xl(o.z, this.restThreshold) && Xl(r.x, this.restThreshold) && Xl(r.y, this.restThreshold) && Xl(r.z, this.restThreshold) && Xl(l, this.restThreshold) && !this._hasRested && (this._hasRested = !0, this.dispatchEvent({ type: "rest" }))) : !I && this._updatedLastTime && this.dispatchEvent({ type: "sleep" }), this._lastDistance = this._spherical.radius, this._lastZoom = this._zoom, this._updatedLastTime = I, this._needsUpdate = !1, I;
  }
  /**
   * Get all state in JSON string
   * @category Methods
   */
  toJSON() {
    return JSON.stringify({
      enabled: this._enabled,
      minDistance: this.minDistance,
      maxDistance: xZ(this.maxDistance),
      minZoom: this.minZoom,
      maxZoom: xZ(this.maxZoom),
      minPolarAngle: this.minPolarAngle,
      maxPolarAngle: xZ(this.maxPolarAngle),
      minAzimuthAngle: xZ(this.minAzimuthAngle),
      maxAzimuthAngle: xZ(this.maxAzimuthAngle),
      smoothTime: this.smoothTime,
      draggingSmoothTime: this.draggingSmoothTime,
      dollySpeed: this.dollySpeed,
      truckSpeed: this.truckSpeed,
      dollyToCursor: this.dollyToCursor,
      target: this._targetEnd.toArray(),
      position: vo.setFromSpherical(this._sphericalEnd).add(this._targetEnd).toArray(),
      zoom: this._zoomEnd,
      focalOffset: this._focalOffsetEnd.toArray(),
      target0: this._target0.toArray(),
      position0: this._position0.toArray(),
      zoom0: this._zoom0,
      focalOffset0: this._focalOffset0.toArray()
    });
  }
  /**
   * Reproduce the control state with JSON. enableTransition is where anim or not in a boolean.
   * @param json
   * @param enableTransition
   * @category Methods
   */
  fromJSON(t, i = !1) {
    const n = JSON.parse(t);
    this.enabled = n.enabled, this.minDistance = n.minDistance, this.maxDistance = PZ(n.maxDistance), this.minZoom = n.minZoom, this.maxZoom = PZ(n.maxZoom), this.minPolarAngle = n.minPolarAngle, this.maxPolarAngle = PZ(n.maxPolarAngle), this.minAzimuthAngle = PZ(n.minAzimuthAngle), this.maxAzimuthAngle = PZ(n.maxAzimuthAngle), this.smoothTime = n.smoothTime, this.draggingSmoothTime = n.draggingSmoothTime, this.dollySpeed = n.dollySpeed, this.truckSpeed = n.truckSpeed, this.dollyToCursor = n.dollyToCursor, this._target0.fromArray(n.target0), this._position0.fromArray(n.position0), this._zoom0 = n.zoom0, this._focalOffset0.fromArray(n.focalOffset0), this.moveTo(n.target[0], n.target[1], n.target[2], i), zT.setFromVector3(vo.fromArray(n.position).sub(this._targetEnd).applyQuaternion(this._yAxisUpSpace)), this.rotateTo(zT.theta, zT.phi, i), this.dollyTo(zT.radius, i), this.zoomTo(n.zoom, i), this.setFocalOffset(n.focalOffset[0], n.focalOffset[1], n.focalOffset[2], i), this._needsUpdate = !0;
  }
  /**
   * Attach all internal event handlers to enable drag control.
   * @category Methods
   */
  connect(t) {
    if (this._domElement) {
      console.warn("camera-controls is already connected.");
      return;
    }
    t.setAttribute("data-camera-controls-version", FKe), this._addAllEventListeners(t), this._getClientRect(this._elementRect);
  }
  /**
   * Detach all internal event handlers to disable drag control.
   */
  disconnect() {
    this.cancel(), this._removeAllEventListeners(), this._domElement && (this._domElement.removeAttribute("data-camera-controls-version"), this._domElement = void 0);
  }
  /**
   * Dispose the cameraControls instance itself, remove all eventListeners.
   * @category Methods
   */
  dispose() {
    this.removeAllEventListeners(), this.disconnect();
  }
  // it's okay to expose public though
  _getTargetDirection(t) {
    return t.setFromSpherical(this._spherical).divideScalar(this._spherical.radius).applyQuaternion(this._yAxisUpSpaceInverse);
  }
  // it's okay to expose public though
  _getCameraDirection(t) {
    return this._getTargetDirection(t).negate();
  }
  _findPointerById(t) {
    return this._activePointers.find((i) => i.pointerId === t);
  }
  _findPointerByMouseButton(t) {
    return this._activePointers.find((i) => i.mouseButton === t);
  }
  _disposePointer(t) {
    this._activePointers.splice(this._activePointers.indexOf(t), 1);
  }
  _encloseToBoundary(t, i, n) {
    const s = i.lengthSq();
    if (s === 0)
      return t;
    const o = Kr.copy(i).add(t), l = this._boundary.clampPoint(o, tV).sub(o), c = l.lengthSq();
    if (c === 0)
      return t.add(i);
    if (c === s)
      return t;
    if (n === 0)
      return t.add(i).add(l);
    {
      const h = 1 + n * c / i.dot(l);
      return t.add(Kr.copy(i).multiplyScalar(h)).add(l.multiplyScalar(1 - n));
    }
  }
  _updateNearPlaneCorners() {
    if (iU(this._camera)) {
      const t = this._camera, i = t.near, n = t.getEffectiveFOV() * _Z, s = Math.tan(n * 0.5) * i, o = s * t.aspect;
      this._nearPlaneCorners[0].set(-o, -s, 0), this._nearPlaneCorners[1].set(o, -s, 0), this._nearPlaneCorners[2].set(o, s, 0), this._nearPlaneCorners[3].set(-o, s, 0);
    } else if (z_(this._camera)) {
      const t = this._camera, i = 1 / t.zoom, n = t.left * i, s = t.right * i, o = t.top * i, r = t.bottom * i;
      this._nearPlaneCorners[0].set(n, o, 0), this._nearPlaneCorners[1].set(s, o, 0), this._nearPlaneCorners[2].set(s, r, 0), this._nearPlaneCorners[3].set(n, r, 0);
    }
  }
  // lateUpdate
  _collisionTest() {
    let t = 1 / 0;
    if (!(this.colliderMeshes.length >= 1) || Sce(this._camera, "_collisionTest"))
      return t;
    const n = this._getTargetDirection(MZ);
    Oce.lookAt($we, n, this._camera.up);
    for (let s = 0; s < 4; s++) {
      const o = Kr.copy(this._nearPlaneCorners[s]);
      o.applyMatrix4(Oce);
      const r = tV.addVectors(this._target, o);
      wse.set(r, n), wse.far = this._spherical.radius + 1;
      const l = wse.intersectObjects(this.colliderMeshes);
      l.length !== 0 && l[0].distance < t && (t = l[0].distance);
    }
    return t;
  }
  /**
   * Get its client rect and package into given `DOMRect` .
   */
  _getClientRect(t) {
    if (!this._domElement)
      return;
    const i = this._domElement.getBoundingClientRect();
    return t.x = i.left, t.y = i.top, this._viewport ? (t.x += this._viewport.x, t.y += i.height - this._viewport.w - this._viewport.y, t.width = this._viewport.z, t.height = this._viewport.w) : (t.width = i.width, t.height = i.height), t;
  }
  _createOnRestPromise(t) {
    return t ? Promise.resolve() : (this._hasRested = !1, this.dispatchEvent({ type: "transitionstart" }), new Promise((i) => {
      const n = () => {
        this.removeEventListener("rest", n), i();
      };
      this.addEventListener("rest", n);
    }));
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _addAllEventListeners(t) {
  }
  _removeAllEventListeners() {
  }
  /**
   * backward compatible
   * @deprecated use smoothTime (in seconds) instead
   * @category Properties
   */
  get dampingFactor() {
    return console.warn(".dampingFactor has been deprecated. use smoothTime (in seconds) instead."), 0;
  }
  /**
   * backward compatible
   * @deprecated use smoothTime (in seconds) instead
   * @category Properties
   */
  set dampingFactor(t) {
    console.warn(".dampingFactor has been deprecated. use smoothTime (in seconds) instead.");
  }
  /**
   * backward compatible
   * @deprecated use draggingSmoothTime (in seconds) instead
   * @category Properties
   */
  get draggingDampingFactor() {
    return console.warn(".draggingDampingFactor has been deprecated. use draggingSmoothTime (in seconds) instead."), 0;
  }
  /**
   * backward compatible
   * @deprecated use draggingSmoothTime (in seconds) instead
   * @category Properties
   */
  set draggingDampingFactor(t) {
    console.warn(".draggingDampingFactor has been deprecated. use draggingSmoothTime (in seconds) instead.");
  }
  static createBoundingSphere(t, i = new Hs.Sphere()) {
    const n = i, s = n.center;
    iV.makeEmpty(), t.traverseVisible((r) => {
      r.isMesh && iV.expandByObject(r);
    }), iV.getCenter(s);
    let o = 0;
    return t.traverseVisible((r) => {
      if (!r.isMesh)
        return;
      const l = r;
      if (!l.geometry)
        return;
      const c = l.geometry.clone();
      c.applyMatrix4(l.matrixWorld);
      const I = c.attributes.position;
      for (let p = 0, y = I.count; p < y; p++)
        vo.fromBufferAttribute(I, p), o = Math.max(o, s.distanceToSquared(vo));
    }), n.radius = Math.sqrt(o), n;
  }
}
class qW extends r$e {
  constructor(t) {
    super(t), tt(this, "onBeforeUpdate", new es()), tt(this, "onAfterUpdate", new es()), tt(this, "onAspectUpdated", new es()), tt(this, "onDisposed", new es()), tt(this, "three"), tt(this, "_allControls", /* @__PURE__ */ new Map()), tt(this, "updateAspect", () => {
      var i;
      if (!(!this.currentWorld || !this.currentWorld.renderer)) {
        if (this.three instanceof eY) {
          this.onAspectUpdated.trigger();
          return;
        }
        if ((i = this.currentWorld.renderer) != null && i.isResizeable()) {
          const n = this.currentWorld.renderer.getSize();
          this.three.aspect = n.width / n.height, this.three.updateProjectionMatrix(), this.onAspectUpdated.trigger();
        }
      }
    }), this.three = this.setupCamera(), this.setupEvents(!0), this.worlds.onItemSet.add(({ value: i }) => {
      const n = this.newCameraControls();
      this._allControls.set(i.uuid, n);
    }), this.worlds.onBeforeDelete.add(({ value: i }) => {
      const n = this._allControls.get(i.uuid);
      n && (n.dispose(), this._allControls.delete(i.uuid));
    });
  }
  /**
   * The object that controls the camera. An instance of
   * [yomotsu's cameracontrols](https://github.com/yomotsu/camera-controls).
   * Transforming the camera directly will have no effect: you need to use this
   * object to move, rotate, look at objects, etc.
   */
  get controls() {
    if (!this.currentWorld)
      throw new Error("This camera needs a world to work!");
    const t = this._allControls.get(this.currentWorld.uuid);
    if (!t)
      throw new Error("Controls not found!");
    return t;
  }
  /**
   * Getter for the enabled state of the camera controls.
   * If the current world is null, it returns false.
   * Otherwise, it returns the enabled state of the camera controls.
   *
   * @returns {boolean} The enabled state of the camera controls.
   */
  get enabled() {
    return this.currentWorld === null ? !1 : this.controls.enabled;
  }
  /**
   * Setter for the enabled state of the camera controls.
   * If the current world is not null, it sets the enabled state of the camera controls to the provided value.
   *
   * @param {boolean} enabled - The new enabled state of the camera controls.
   */
  set enabled(t) {
    this.currentWorld !== null && (this.controls.enabled = t);
  }
  set currentWorld(t) {
    if (super.currentWorld = t, !t)
      return;
    this.worlds.get(t.uuid) || this.worlds.set(t.uuid, t);
  }
  get currentWorld() {
    return this._currentWorld;
  }
  /** {@link Disposable.dispose} */
  dispose() {
    this.setupEvents(!1), this.onAspectUpdated.reset(), this.onBeforeUpdate.reset(), this.onAfterUpdate.reset(), this.three.removeFromParent(), this.onDisposed.trigger(), this.onDisposed.reset();
    for (const [t, i] of this._allControls)
      i.dispose();
    this.worlds.clear();
  }
  async fitToItems(t) {
    const i = await this.getItemsBounding(t);
    await this.controls.fitToSphere(i, !0);
  }
  async setOrbitToItems(t) {
    const i = await this.getItemsBounding(t);
    this.controls.setOrbitPoint(
      i.center.x,
      i.center.y,
      i.center.z
    );
  }
  /** {@link Updateable.update} */
  update(t) {
    this.enabled && (this.onBeforeUpdate.trigger(this), this.controls.update(t), this.onAfterUpdate.trigger(this));
  }
  async getItemsBounding(t) {
    const i = this.components.get(Io), n = this.components.get(Cbe);
    n.list.clear();
    const s = new f3();
    if (t)
      await n.addFromModelIdMap(t);
    else
      for (const [, o] of i.list)
        n.list.add(o.box);
    return n.get().getBoundingSphere(s), n.list.clear(), s;
  }
  setupCamera() {
    const t = window.innerWidth / window.innerHeight, i = new Tg(60, t, 1, 1e3);
    return i.position.set(50, 50, 50), i.lookAt(new Ge(0, 0, 0)), i;
  }
  newCameraControls() {
    if (!this.currentWorld)
      throw new Error("This camera needs a world to work!");
    if (!this.currentWorld.renderer)
      throw new Error("This camera needs a renderer to work!");
    c3.install({ THREE: qW.getSubsetOfThree() });
    const { domElement: t } = this.currentWorld.renderer.three, i = new c3(this.three, t);
    return i.smoothTime = 0.2, i.dollyToCursor = !0, i.infinityDolly = !0, i.minDistance = 6, i;
  }
  setupEvents(t) {
    t ? window.addEventListener("resize", this.updateAspect) : window.removeEventListener("resize", this.updateAspect);
  }
  static getSubsetOfThree() {
    return {
      MOUSE: xMe,
      Vector2: us,
      Vector3: Ge,
      Vector4: Ol,
      Quaternion: gI,
      Matrix4: Ln,
      Spherical: LUe,
      Box3: Zs,
      Sphere: f3,
      Raycaster: Aae,
      MathUtils: Eie
    };
  }
}
const Fbe = class Hbe extends bI {
  constructor(t) {
    super(t), tt(this, "onAfterUpdate", new es()), tt(this, "onBeforeUpdate", new es()), tt(this, "onDisposed", new es()), tt(this, "list", new f0()), tt(this, "enabled", !0), t.add(Hbe.uuid, this);
  }
  /**
   * Creates a new instance of a SimpleWorld and adds it to the list of worlds.
   *
   * @template T - The type of the scene, extending from BaseScene. Defaults to BaseScene.
   * @template U - The type of the camera, extending from BaseCamera. Defaults to BaseCamera.
   * @template S - The type of the renderer, extending from BaseRenderer. Defaults to BaseRenderer.
   *
   * @throws {Error} - Throws an error if a world with the same UUID already exists in the list.
   */
  create() {
    const t = new LKe(this.components), i = t.uuid;
    if (this.list.has(i))
      throw new Error("There is already a world with this name!");
    return this.list.set(i, t), t;
  }
  /**
   * Deletes a world from the list of worlds.
   *
   * @param {World} world - The world to be deleted.
   *
   * @throws {Error} - Throws an error if the provided world is not found in the list.
   */
  delete(t) {
    if (!this.list.has(t.uuid))
      throw new Error("The provided world is not found in the list!");
    this.list.delete(t.uuid), t.dispose();
  }
  /**
   * Disposes of the Worlds component and all its managed worlds.
   * This method sets the enabled flag to false, disposes of all worlds, clears the list,
   * and triggers the onDisposed event.
   */
  dispose() {
    this.enabled = !1;
    for (const [t, i] of this.list)
      i.dispose();
    this.list.clear(), this.onDisposed.trigger();
  }
  /** {@link Updateable.update} */
  update(t) {
    if (this.enabled)
      for (const [i, n] of this.list)
        n.update(t);
  }
};
tt(Fbe, "uuid", "fdb61dc4-2ec1-4966-b83d-54ea795fad4a");
let Ume = Fbe;
class GKe extends Hie {
  constructor() {
    super(...arguments), tt(this, "_config", {
      visible: {
        value: !0,
        type: "Boolean"
      },
      color: {
        value: new Xn(),
        type: "Color"
      },
      primarySize: {
        type: "Number",
        interpolable: !0,
        value: 1,
        min: 0,
        max: 1e3
      },
      secondarySize: {
        type: "Number",
        interpolable: !0,
        value: 10,
        min: 0,
        max: 1e3
      },
      distance: {
        type: "Number",
        interpolable: !0,
        value: 500,
        min: 0,
        max: 500
      }
    });
  }
  /**
   * Whether the grid is visible or not.
   */
  get visible() {
    return this._config.visible.value;
  }
  /**
   * Whether the grid is visible or not.
   */
  set visible(t) {
    this._config.visible.value = t, this._component.visible = t;
  }
  /**
   * The color of the grid lines.
   */
  get color() {
    return this._config.color.value;
  }
  /**
   * The color of the grid lines.
   */
  set color(t) {
    this._config.color.value = t, this._component.material.uniforms.uColor.value = t, this._component.material.uniformsNeedUpdate = !0;
  }
  /**
   * The size of the primary grid lines.
   */
  get primarySize() {
    return this._config.primarySize.value;
  }
  /**
   * The size of the primary grid lines.
   */
  set primarySize(t) {
    this._config.primarySize.value = t, this._component.material.uniforms.uSize1.value = t, this._component.material.uniformsNeedUpdate = !0;
  }
  /**
   * The size of the secondary grid lines.
   */
  get secondarySize() {
    return this._config.secondarySize.value;
  }
  /**
   * The size of the secondary grid lines.
   */
  set secondarySize(t) {
    this._config.secondarySize.value = t, this._component.material.uniforms.uSize2.value = t, this._component.material.uniformsNeedUpdate = !0;
  }
  /**
   * The distance at which the grid lines start to fade away.
   */
  get distance() {
    return this._config.distance.value;
  }
  /**
   * The distance at which the grid lines start to fade away.
   */
  set distance(t) {
    this._config.distance.value = t, this._component.material.uniforms.uDistance.value = t, this._component.material.uniformsNeedUpdate = !0;
  }
}
class kKe {
  constructor(t, i) {
    tt(this, "onDisposed", new es()), tt(this, "onSetup", new es()), tt(this, "isSetup", !1), tt(this, "world"), tt(this, "components"), tt(this, "config"), tt(this, "_defaultConfig", {
      visible: !0,
      color: new Xn(12303291),
      primarySize: 1,
      secondarySize: 10,
      distance: 500
    }), tt(this, "three"), tt(this, "_fade", 3), tt(this, "updateZoom", () => {
      this.world.camera instanceof qW && (this.material.uniforms.uZoom.value = this.world.camera.three.zoom);
    }), this.world = i;
    const { color: n, primarySize: s, secondarySize: o, distance: r } = this._defaultConfig;
    this.components = t, this.config = new GKe(this, this.components, "Grid");
    const l = new xH(2, 2, 1, 1), c = new BA({
      side: $y,
      uniforms: {
        uSize1: {
          value: s
        },
        uSize2: {
          value: o
        },
        uColor: {
          value: n
        },
        uDistance: {
          value: r
        },
        uFade: {
          value: this._fade
        },
        uZoom: {
          value: 1
        }
      },
      transparent: !0,
      vertexShader: `
            
            varying vec3 worldPosition;
            
            uniform float uDistance;
            
            void main() {
            
                    vec3 pos = position.xzy * uDistance;
                    pos.xz += cameraPosition.xz;
                    
                    worldPosition = pos;
                    
                    gl_Position = projectionMatrix * modelViewMatrix * vec4(pos, 1.0);
            
            }
            `,
      fragmentShader: `
            
            varying vec3 worldPosition;
            
            uniform float uZoom;
            uniform float uFade;
            uniform float uSize1;
            uniform float uSize2;
            uniform vec3 uColor;
            uniform float uDistance;
                
                
                
                float getGrid(float size) {
                
                    vec2 r = worldPosition.xz / size;
                    
                    
                    vec2 grid = abs(fract(r - 0.5) - 0.5) / fwidth(r);
                    float line = min(grid.x, grid.y);
                    
                
                    return 1.0 - min(line, 1.0);
                }
                
            void main() {
            
                    
                    float d = 1.0 - min(distance(cameraPosition.xz, worldPosition.xz) / uDistance, 1.0);
                    
                    float g1 = getGrid(uSize1);
                    float g2 = getGrid(uSize2);
                    
                    // Ortho camera fades the grid away when zooming out
                    float minZoom = step(0.2, uZoom);
                    float zoomFactor = pow(min(uZoom, 1.), 2.) * minZoom;
                    
                    gl_FragColor = vec4(uColor.rgb, mix(g2, g1, g1) * pow(d, uFade));
                    gl_FragColor.a = mix(0.5 * gl_FragColor.a, gl_FragColor.a, g2) * zoomFactor;
                    
                    if ( gl_FragColor.a <= 0.0 ) discard;
                    
            
            }
            
            `,
      extensions: {
        derivatives: !0
      }
    });
    this.three = new En(l, c), this.three.frustumCulled = !1, i.scene.three.add(this.three), this.setupEvents(!0);
  }
  /** {@link Hideable.visible} */
  get visible() {
    return this.three.visible;
  }
  /** {@link Hideable.visible} */
  set visible(t) {
    this.three.visible = t, t ? this.world.scene.three.add(this.three) : this.three.removeFromParent();
  }
  /** The material of the grid. */
  get material() {
    return this.three.material;
  }
  /**
   * Whether the grid should fade away with distance. Recommended to be true for
   * perspective cameras and false for orthographic cameras.
   */
  get fade() {
    return this._fade === 3;
  }
  /**
   * Whether the grid should fade away with distance. Recommended to be true for
   * perspective cameras and false for orthographic cameras.
   */
  set fade(t) {
    this._fade = t ? 3 : 0, this.material.uniforms.uFade.value = this._fade;
  }
  /** {@link Configurable.setup} */
  setup(t) {
    const i = { ...this._defaultConfig, ...t };
    this.config.visible = !0, this.config.color = i.color, this.config.primarySize = i.primarySize, this.config.secondarySize = i.secondarySize, this.config.distance = i.distance, this.isSetup = !0, this.onSetup.trigger();
  }
  /** {@link Disposable.dispose} */
  dispose() {
    this.setupEvents(!1), this.components.get(Sue).list.delete(this.config.uuid), this.components.get(Tue).destroy(this.three), this.onDisposed.trigger(), this.onDisposed.reset(), this.world = null, this.components = null;
  }
  setupEvents(t) {
    if (this.world.isDisposing || !(this.world.camera instanceof qW))
      return;
    const i = this.world.camera.controls;
    t ? i.addEventListener("update", this.updateZoom) : i.removeEventListener("update", this.updateZoom);
  }
}
const VKe = class Gbe extends bI {
  constructor(t) {
    super(t), tt(this, "list", /* @__PURE__ */ new Map()), tt(this, "onDisposed", new es()), tt(this, "enabled", !0), t.add(Gbe.uuid, this);
  }
  /**
   * Creates a new grid for the given world.
   * Throws an error if a grid already exists for the world.
   *
   * @param world - The world to create the grid for.
   * @returns The newly created grid.
   *
   * @throws Will throw an error if a grid already exists for the given world.
   */
  create(t) {
    if (this.list.has(t.uuid))
      throw new Error("This world already has a grid!");
    const i = new kKe(this.components, t);
    return this.list.set(t.uuid, i), t.onDisposed.add(() => {
      this.delete(t);
    }), i;
  }
  /**
   * Deletes the grid associated with the given world.
   * If a grid does not exist for the given world, this method does nothing.
   *
   * @param world - The world for which to delete the grid.
   *
   * @remarks
   * This method will dispose of the grid and remove it from the internal list.
   * If the world is disposed before calling this method, the grid will be automatically deleted.
   */
  delete(t) {
    const i = this.list.get(t.uuid);
    i && i.dispose(), this.list.delete(t.uuid);
  }
  /** {@link Disposable.dispose} */
  dispose() {
    for (const [t, i] of this.list)
      i.dispose();
    this.list.clear(), this.onDisposed.trigger(), this.onDisposed.reset();
  }
};
tt(VKe, "uuid", "d1e814d5-b81c-4452-87a2-f039375e0489");
const kbe = 0, zKe = 1, jKe = 2, Xwe = 2, Lce = 1.25, e2e = 1, Ore = 32, bue = 65535, WKe = Math.pow(2, -24), _ce = Symbol("SKIP_GENERATION");
function YKe(e) {
  return e.index ? e.index.count : e.attributes.position.count;
}
function aY(e) {
  return YKe(e) / 3;
}
function qKe(e, t = ArrayBuffer) {
  return e > 65535 ? new Uint32Array(new t(4 * e)) : new Uint16Array(new t(2 * e));
}
function $Ke(e, t) {
  if (!e.index) {
    const i = e.attributes.position.count, n = t.useSharedArrayBuffer ? SharedArrayBuffer : ArrayBuffer, s = qKe(i, n);
    e.setIndex(new zu(s, 1));
    for (let o = 0; o < i; o++)
      s[o] = o;
  }
}
function Vbe(e) {
  const t = aY(e), i = e.drawRange, n = i.start / 3, s = (i.start + i.count) / 3, o = Math.max(0, n), r = Math.min(t, s) - o;
  return [{
    offset: Math.floor(o),
    count: Math.floor(r)
  }];
}
function zbe(e) {
  if (!e.groups || !e.groups.length)
    return Vbe(e);
  const t = [], i = /* @__PURE__ */ new Set(), n = e.drawRange, s = n.start / 3, o = (n.start + n.count) / 3;
  for (const l of e.groups) {
    const c = l.start / 3, h = (l.start + l.count) / 3;
    i.add(Math.max(s, c)), i.add(Math.min(o, h));
  }
  const r = Array.from(i.values()).sort((l, c) => l - c);
  for (let l = 0; l < r.length - 1; l++) {
    const c = r[l], h = r[l + 1];
    t.push({
      offset: Math.floor(c),
      count: Math.floor(h - c)
    });
  }
  return t;
}
function KKe(e) {
  if (e.groups.length === 0)
    return !1;
  const t = aY(e), i = zbe(e).sort((o, r) => o.offset - r.offset), n = i[i.length - 1];
  n.count = Math.min(t - n.offset, n.count);
  let s = 0;
  return i.forEach(({ count: o }) => s += o), t !== s;
}
function ud(e, t, i) {
  return i.min.x = t[e], i.min.y = t[e + 1], i.min.z = t[e + 2], i.max.x = t[e + 3], i.max.y = t[e + 4], i.max.z = t[e + 5], i;
}
function ZKe(e) {
  e[0] = e[1] = e[2] = 1 / 0, e[3] = e[4] = e[5] = -1 / 0;
}
function t2e(e) {
  let t = -1, i = -1 / 0;
  for (let n = 0; n < 3; n++) {
    const s = e[n + 3] - e[n];
    s > i && (i = s, t = n);
  }
  return t;
}
function i2e(e, t) {
  t.set(e);
}
function n2e(e, t, i) {
  let n, s;
  for (let o = 0; o < 3; o++) {
    const r = o + 3;
    n = e[o], s = t[o], i[o] = n < s ? n : s, n = e[r], s = t[r], i[r] = n > s ? n : s;
  }
}
function Tse(e, t, i) {
  for (let n = 0; n < 3; n++) {
    const s = t[e + 2 * n], o = t[e + 2 * n + 1], r = s - o, l = s + o;
    r < i[n] && (i[n] = r), l > i[n + 3] && (i[n + 3] = l);
  }
}
function BZ(e) {
  const t = e[3] - e[0], i = e[4] - e[1], n = e[5] - e[2];
  return 2 * (t * i + i * n + n * t);
}
function xce(e, t, i, n, s = null) {
  let o = 1 / 0, r = 1 / 0, l = 1 / 0, c = -1 / 0, h = -1 / 0, I = -1 / 0, p = 1 / 0, y = 1 / 0, m = 1 / 0, A = -1 / 0, C = -1 / 0, O = -1 / 0;
  const R = s !== null;
  for (let F = t * 6, L = (t + i) * 6; F < L; F += 6) {
    const P = e[F + 0], z = e[F + 1], W = P - z, re = P + z;
    W < o && (o = W), re > c && (c = re), R && P < p && (p = P), R && P > A && (A = P);
    const ce = e[F + 2], te = e[F + 3], ee = ce - te, Ne = ce + te;
    ee < r && (r = ee), Ne > h && (h = Ne), R && ce < y && (y = ce), R && ce > C && (C = ce);
    const Ae = e[F + 4], Oe = e[F + 5], pe = Ae - Oe, je = Ae + Oe;
    pe < l && (l = pe), je > I && (I = je), R && Ae < m && (m = Ae), R && Ae > O && (O = Ae);
  }
  n[0] = o, n[1] = r, n[2] = l, n[3] = c, n[4] = h, n[5] = I, R && (s[0] = p, s[1] = y, s[2] = m, s[3] = A, s[4] = C, s[5] = O);
}
function QKe(e, t, i, n) {
  let s = 1 / 0, o = 1 / 0, r = 1 / 0, l = -1 / 0, c = -1 / 0, h = -1 / 0;
  for (let I = t * 6, p = (t + i) * 6; I < p; I += 6) {
    const y = e[I + 0];
    y < s && (s = y), y > l && (l = y);
    const m = e[I + 2];
    m < o && (o = m), m > c && (c = m);
    const A = e[I + 4];
    A < r && (r = A), A > h && (h = A);
  }
  n[0] = s, n[1] = o, n[2] = r, n[3] = l, n[4] = c, n[5] = h;
}
function JKe(e, t) {
  ZKe(t);
  const i = e.attributes.position, n = e.index ? e.index.array : null, s = aY(e), o = new Float32Array(s * 6), r = i.normalized, l = i.array, c = i.offset || 0;
  let h = 3;
  i.isInterleavedBufferAttribute && (h = i.data.stride);
  const I = ["getX", "getY", "getZ"];
  for (let p = 0; p < s; p++) {
    const y = p * 3, m = p * 6;
    let A = y + 0, C = y + 1, O = y + 2;
    n && (A = n[A], C = n[C], O = n[O]), r || (A = A * h + c, C = C * h + c, O = O * h + c);
    for (let R = 0; R < 3; R++) {
      let F, L, P;
      r ? (F = i[I[R]](A), L = i[I[R]](C), P = i[I[R]](O)) : (F = l[A + R], L = l[C + R], P = l[O + R]);
      let z = F;
      L < z && (z = L), P < z && (z = P);
      let W = F;
      L > W && (W = L), P > W && (W = P);
      const re = (W - z) / 2, ce = R * 2;
      o[m + ce + 0] = z + re, o[m + ce + 1] = re + (Math.abs(z) + re) * WKe, z < t[R] && (t[R] = z), W > t[R + 3] && (t[R + 3] = W);
    }
  }
  return o;
}
const hC = 32, XKe = (e, t) => e.candidate - t.candidate, p_ = new Array(hC).fill().map(() => ({
  count: 0,
  bounds: new Float32Array(6),
  rightCacheBounds: new Float32Array(6),
  leftCacheBounds: new Float32Array(6),
  candidate: 0
})), Rse = new Float32Array(6);
function eZe(e, t, i, n, s, o) {
  let r = -1, l = 0;
  if (o === kbe)
    r = t2e(t), r !== -1 && (l = (t[r] + t[r + 3]) / 2);
  else if (o === zKe)
    r = t2e(e), r !== -1 && (l = tZe(i, n, s, r));
  else if (o === jKe) {
    const c = BZ(e);
    let h = Lce * s;
    const I = n * 6, p = (n + s) * 6;
    for (let y = 0; y < 3; y++) {
      const m = t[y], O = (t[y + 3] - m) / hC;
      if (s < hC / 4) {
        const R = [...p_];
        R.length = s;
        let F = 0;
        for (let P = I; P < p; P += 6, F++) {
          const z = R[F];
          z.candidate = i[P + 2 * y], z.count = 0;
          const {
            bounds: W,
            leftCacheBounds: re,
            rightCacheBounds: ce
          } = z;
          for (let te = 0; te < 3; te++)
            ce[te] = 1 / 0, ce[te + 3] = -1 / 0, re[te] = 1 / 0, re[te + 3] = -1 / 0, W[te] = 1 / 0, W[te + 3] = -1 / 0;
          Tse(P, i, W);
        }
        R.sort(XKe);
        let L = s;
        for (let P = 0; P < L; P++) {
          const z = R[P];
          for (; P + 1 < L && R[P + 1].candidate === z.candidate; )
            R.splice(P + 1, 1), L--;
        }
        for (let P = I; P < p; P += 6) {
          const z = i[P + 2 * y];
          for (let W = 0; W < L; W++) {
            const re = R[W];
            z >= re.candidate ? Tse(P, i, re.rightCacheBounds) : (Tse(P, i, re.leftCacheBounds), re.count++);
          }
        }
        for (let P = 0; P < L; P++) {
          const z = R[P], W = z.count, re = s - z.count, ce = z.leftCacheBounds, te = z.rightCacheBounds;
          let ee = 0;
          W !== 0 && (ee = BZ(ce) / c);
          let Ne = 0;
          re !== 0 && (Ne = BZ(te) / c);
          const Ae = e2e + Lce * (ee * W + Ne * re);
          Ae < h && (r = y, h = Ae, l = z.candidate);
        }
      } else {
        for (let L = 0; L < hC; L++) {
          const P = p_[L];
          P.count = 0, P.candidate = m + O + L * O;
          const z = P.bounds;
          for (let W = 0; W < 3; W++)
            z[W] = 1 / 0, z[W + 3] = -1 / 0;
        }
        for (let L = I; L < p; L += 6) {
          let W = ~~((i[L + 2 * y] - m) / O);
          W >= hC && (W = hC - 1);
          const re = p_[W];
          re.count++, Tse(L, i, re.bounds);
        }
        const R = p_[hC - 1];
        i2e(R.bounds, R.rightCacheBounds);
        for (let L = hC - 2; L >= 0; L--) {
          const P = p_[L], z = p_[L + 1];
          n2e(P.bounds, z.rightCacheBounds, P.rightCacheBounds);
        }
        let F = 0;
        for (let L = 0; L < hC - 1; L++) {
          const P = p_[L], z = P.count, W = P.bounds, ce = p_[L + 1].rightCacheBounds;
          z !== 0 && (F === 0 ? i2e(W, Rse) : n2e(W, Rse, Rse)), F += z;
          let te = 0, ee = 0;
          F !== 0 && (te = BZ(Rse) / c);
          const Ne = s - F;
          Ne !== 0 && (ee = BZ(ce) / c);
          const Ae = e2e + Lce * (te * F + ee * Ne);
          Ae < h && (r = y, h = Ae, l = P.candidate);
        }
      }
    }
  } else
    console.warn(`MeshBVH: Invalid build strategy value ${o} used.`);
  return { axis: r, pos: l };
}
function tZe(e, t, i, n) {
  let s = 0;
  for (let o = t, r = t + i; o < r; o++)
    s += e[o * 6 + n * 2];
  return s / i;
}
class vse {
  constructor() {
  }
}
function iZe(e, t, i, n, s, o) {
  let r = n, l = n + s - 1;
  const c = o.pos, h = o.axis * 2;
  for (; ; ) {
    for (; r <= l && i[r * 6 + h] < c; )
      r++;
    for (; r <= l && i[l * 6 + h] >= c; )
      l--;
    if (r < l) {
      for (let I = 0; I < 3; I++) {
        let p = t[r * 3 + I];
        t[r * 3 + I] = t[l * 3 + I], t[l * 3 + I] = p;
      }
      for (let I = 0; I < 6; I++) {
        let p = i[r * 6 + I];
        i[r * 6 + I] = i[l * 6 + I], i[l * 6 + I] = p;
      }
      r++, l--;
    } else
      return r;
  }
}
function nZe(e, t, i, n, s, o) {
  let r = n, l = n + s - 1;
  const c = o.pos, h = o.axis * 2;
  for (; ; ) {
    for (; r <= l && i[r * 6 + h] < c; )
      r++;
    for (; r <= l && i[l * 6 + h] >= c; )
      l--;
    if (r < l) {
      let I = e[r];
      e[r] = e[l], e[l] = I;
      for (let p = 0; p < 6; p++) {
        let y = i[r * 6 + p];
        i[r * 6 + p] = i[l * 6 + p], i[l * 6 + p] = y;
      }
      r++, l--;
    } else
      return r;
  }
}
function sZe(e, t) {
  const i = (e.index ? e.index.count : e.attributes.position.count) / 3, n = i > 2 ** 16, s = n ? 4 : 2, o = t ? new SharedArrayBuffer(i * s) : new ArrayBuffer(i * s), r = n ? new Uint32Array(o) : new Uint16Array(o);
  for (let l = 0, c = r.length; l < c; l++)
    r[l] = l;
  return r;
}
function oZe(e, t) {
  const i = e.geometry, n = i.index ? i.index.array : null, s = t.maxDepth, o = t.verbose, r = t.maxLeafTris, l = t.strategy, c = t.onProgress, h = aY(i), I = e._indirectBuffer;
  let p = !1;
  const y = new Float32Array(6), m = new Float32Array(6), A = JKe(i, y), C = t.indirect ? nZe : iZe, O = [], R = t.indirect ? Vbe(i) : zbe(i);
  if (R.length === 1) {
    const P = R[0], z = new vse();
    z.boundingData = y, QKe(A, P.offset, P.count, m), L(z, P.offset, P.count, m), O.push(z);
  } else
    for (let P of R) {
      const z = new vse();
      z.boundingData = new Float32Array(6), xce(A, P.offset, P.count, z.boundingData, m), L(z, P.offset, P.count, m), O.push(z);
    }
  return O;
  function F(P) {
    c && c(P / h);
  }
  function L(P, z, W, re = null, ce = 0) {
    if (!p && ce >= s && (p = !0, o && (console.warn(`MeshBVH: Max depth of ${s} reached when generating BVH. Consider increasing maxDepth.`), console.warn(i))), W <= r || ce >= s)
      return F(z + W), P.offset = z, P.count = W, P;
    const te = eZe(P.boundingData, re, A, z, W, l);
    if (te.axis === -1)
      return F(z + W), P.offset = z, P.count = W, P;
    const ee = C(I, n, A, z, W, te);
    if (ee === z || ee === z + W)
      F(z + W), P.offset = z, P.count = W;
    else {
      P.splitAxis = te.axis;
      const Ne = new vse(), Ae = z, Oe = ee - z;
      P.left = Ne, Ne.boundingData = new Float32Array(6), xce(A, Ae, Oe, Ne.boundingData, m), L(Ne, Ae, Oe, m, ce + 1);
      const pe = new vse(), je = ee, Ve = W - Oe;
      P.right = pe, pe.boundingData = new Float32Array(6), xce(A, je, Ve, pe.boundingData, m), L(pe, je, Ve, m, ce + 1);
    }
    return P;
  }
}
function rZe(e, t) {
  const i = e.geometry;
  t.indirect && (e._indirectBuffer = sZe(i, t.useSharedArrayBuffer), KKe(i) && !t.verbose && console.warn(
    'MeshBVH: Provided geometry contains groups that do not fully span the vertex contents while using the "indirect" option. BVH may incorrectly report intersections on unrendered portions of the geometry.'
  )), e._indirectBuffer || $Ke(i, t);
  const n = oZe(e, t);
  let s, o, r;
  const l = [], c = t.useSharedArrayBuffer ? SharedArrayBuffer : ArrayBuffer;
  for (let p = 0; p < n.length; p++) {
    const y = n[p];
    let m = h(y);
    const A = new c(Ore * m);
    s = new Float32Array(A), o = new Uint32Array(A), r = new Uint16Array(A), I(0, y), l.push(A);
  }
  e._roots = l;
  return;
  function h(p) {
    return p.count ? 1 : 1 + h(p.left) + h(p.right);
  }
  function I(p, y) {
    const m = p / 4, A = p / 2, C = !!y.count, O = y.boundingData;
    for (let R = 0; R < 6; R++)
      s[m + R] = O[R];
    if (C) {
      const R = y.offset, F = y.count;
      return o[m + 6] = R, r[A + 14] = F, r[A + 15] = bue, p + Ore;
    } else {
      const R = y.left, F = y.right, L = y.splitAxis;
      let P;
      if (P = I(p + Ore, R), P / 4 > Math.pow(2, 32))
        throw new Error("MeshBVH: Cannot store child pointer greater than 32 bits.");
      return o[m + 6] = P / 4, P = I(P, F), o[m + 7] = L, P;
    }
  }
}
class EL {
  constructor() {
    this.min = 1 / 0, this.max = -1 / 0;
  }
  setFromPointsField(t, i) {
    let n = 1 / 0, s = -1 / 0;
    for (let o = 0, r = t.length; o < r; o++) {
      const c = t[o][i];
      n = c < n ? c : n, s = c > s ? c : s;
    }
    this.min = n, this.max = s;
  }
  setFromPoints(t, i) {
    let n = 1 / 0, s = -1 / 0;
    for (let o = 0, r = i.length; o < r; o++) {
      const l = i[o], c = t.dot(l);
      n = c < n ? c : n, s = c > s ? c : s;
    }
    this.min = n, this.max = s;
  }
  isSeparated(t) {
    return this.min > t.max || t.min > this.max;
  }
}
EL.prototype.setFromBox = (function() {
  const e = new Ge();
  return function(i, n) {
    const s = n.min, o = n.max;
    let r = 1 / 0, l = -1 / 0;
    for (let c = 0; c <= 1; c++)
      for (let h = 0; h <= 1; h++)
        for (let I = 0; I <= 1; I++) {
          e.x = s.x * c + o.x * (1 - c), e.y = s.y * h + o.y * (1 - h), e.z = s.z * I + o.z * (1 - I);
          const p = i.dot(e);
          r = Math.min(p, r), l = Math.max(p, l);
        }
    this.min = r, this.max = l;
  };
})();
const lZe = (function() {
  const e = new Ge(), t = new Ge(), i = new Ge();
  return function(s, o, r) {
    const l = s.start, c = e, h = o.start, I = t;
    i.subVectors(l, h), e.subVectors(s.end, s.start), t.subVectors(o.end, o.start);
    const p = i.dot(I), y = I.dot(c), m = I.dot(I), A = i.dot(c), O = c.dot(c) * m - y * y;
    let R, F;
    O !== 0 ? R = (p * y - A * m) / O : R = 0, F = (p + R * y) / m, r.x = R, r.y = F;
  };
})(), Bme = (function() {
  const e = new us(), t = new Ge(), i = new Ge();
  return function(s, o, r, l) {
    lZe(s, o, e);
    let c = e.x, h = e.y;
    if (c >= 0 && c <= 1 && h >= 0 && h <= 1) {
      s.at(c, r), o.at(h, l);
      return;
    } else if (c >= 0 && c <= 1) {
      h < 0 ? o.at(0, l) : o.at(1, l), s.closestPointToPoint(l, !0, r);
      return;
    } else if (h >= 0 && h <= 1) {
      c < 0 ? s.at(0, r) : s.at(1, r), o.closestPointToPoint(r, !0, l);
      return;
    } else {
      let I;
      c < 0 ? I = s.start : I = s.end;
      let p;
      h < 0 ? p = o.start : p = o.end;
      const y = t, m = i;
      if (s.closestPointToPoint(p, !0, t), o.closestPointToPoint(I, !0, i), y.distanceToSquared(p) <= m.distanceToSquared(I)) {
        r.copy(y), l.copy(p);
        return;
      } else {
        r.copy(I), l.copy(m);
        return;
      }
    }
  };
})(), aZe = (function() {
  const e = new Ge(), t = new Ge(), i = new tl(), n = new gc();
  return function(o, r) {
    const { radius: l, center: c } = o, { a: h, b: I, c: p } = r;
    if (n.start = h, n.end = I, n.closestPointToPoint(c, !0, e).distanceTo(c) <= l || (n.start = h, n.end = p, n.closestPointToPoint(c, !0, e).distanceTo(c) <= l) || (n.start = I, n.end = p, n.closestPointToPoint(c, !0, e).distanceTo(c) <= l))
      return !0;
    const C = r.getPlane(i);
    if (Math.abs(C.distanceToPoint(c)) <= l) {
      const R = C.projectPoint(c, t);
      if (r.containsPoint(R))
        return !0;
    }
    return !1;
  };
})(), uZe = 1e-15;
function Pce(e) {
  return Math.abs(e) < uZe;
}
class FA extends wc {
  constructor(...t) {
    super(...t), this.isExtendedTriangle = !0, this.satAxes = new Array(4).fill().map(() => new Ge()), this.satBounds = new Array(4).fill().map(() => new EL()), this.points = [this.a, this.b, this.c], this.sphere = new f3(), this.plane = new tl(), this.needsUpdate = !0;
  }
  intersectsSphere(t) {
    return aZe(t, this);
  }
  update() {
    const t = this.a, i = this.b, n = this.c, s = this.points, o = this.satAxes, r = this.satBounds, l = o[0], c = r[0];
    this.getNormal(l), c.setFromPoints(l, s);
    const h = o[1], I = r[1];
    h.subVectors(t, i), I.setFromPoints(h, s);
    const p = o[2], y = r[2];
    p.subVectors(i, n), y.setFromPoints(p, s);
    const m = o[3], A = r[3];
    m.subVectors(n, t), A.setFromPoints(m, s), this.sphere.setFromPoints(this.points), this.plane.setFromNormalAndCoplanarPoint(l, t), this.needsUpdate = !1;
  }
}
FA.prototype.closestPointToSegment = (function() {
  const e = new Ge(), t = new Ge(), i = new gc();
  return function(s, o = null, r = null) {
    const { start: l, end: c } = s, h = this.points;
    let I, p = 1 / 0;
    for (let y = 0; y < 3; y++) {
      const m = (y + 1) % 3;
      i.start.copy(h[y]), i.end.copy(h[m]), Bme(i, s, e, t), I = e.distanceToSquared(t), I < p && (p = I, o && o.copy(e), r && r.copy(t));
    }
    return this.closestPointToPoint(l, e), I = l.distanceToSquared(e), I < p && (p = I, o && o.copy(e), r && r.copy(l)), this.closestPointToPoint(c, e), I = c.distanceToSquared(e), I < p && (p = I, o && o.copy(e), r && r.copy(c)), Math.sqrt(p);
  };
})();
FA.prototype.intersectsTriangle = (function() {
  const e = new FA(), t = new Array(3), i = new Array(3), n = new EL(), s = new EL(), o = new Ge(), r = new Ge(), l = new Ge(), c = new Ge(), h = new Ge(), I = new gc(), p = new gc(), y = new gc(), m = new Ge();
  function A(C, O, R) {
    const F = C.points;
    let L = 0, P = -1;
    for (let z = 0; z < 3; z++) {
      const { start: W, end: re } = I;
      W.copy(F[z]), re.copy(F[(z + 1) % 3]), I.delta(r);
      const ce = Pce(O.distanceToPoint(W));
      if (Pce(O.normal.dot(r)) && ce) {
        R.copy(I), L = 2;
        break;
      }
      const te = O.intersectLine(I, m);
      if (!te && ce && m.copy(W), (te || ce) && !Pce(m.distanceTo(re))) {
        if (L <= 1)
          (L === 1 ? R.start : R.end).copy(m), ce && (P = L);
        else if (L >= 2) {
          (P === 1 ? R.start : R.end).copy(m), L = 2;
          break;
        }
        if (L++, L === 2 && P === -1)
          break;
      }
    }
    return L;
  }
  return function(O, R = null, F = !1) {
    this.needsUpdate && this.update(), O.isExtendedTriangle ? O.needsUpdate && O.update() : (e.copy(O), e.update(), O = e);
    const L = this.plane, P = O.plane;
    if (Math.abs(L.normal.dot(P.normal)) > 1 - 1e-10) {
      const z = this.satBounds, W = this.satAxes;
      i[0] = O.a, i[1] = O.b, i[2] = O.c;
      for (let te = 0; te < 4; te++) {
        const ee = z[te], Ne = W[te];
        if (n.setFromPoints(Ne, i), ee.isSeparated(n))
          return !1;
      }
      const re = O.satBounds, ce = O.satAxes;
      t[0] = this.a, t[1] = this.b, t[2] = this.c;
      for (let te = 0; te < 4; te++) {
        const ee = re[te], Ne = ce[te];
        if (n.setFromPoints(Ne, t), ee.isSeparated(n))
          return !1;
      }
      for (let te = 0; te < 4; te++) {
        const ee = W[te];
        for (let Ne = 0; Ne < 4; Ne++) {
          const Ae = ce[Ne];
          if (o.crossVectors(ee, Ae), n.setFromPoints(o, t), s.setFromPoints(o, i), n.isSeparated(s))
            return !1;
        }
      }
      return R && (F || console.warn("ExtendedTriangle.intersectsTriangle: Triangles are coplanar which does not support an output edge. Setting edge to 0, 0, 0."), R.start.set(0, 0, 0), R.end.set(0, 0, 0)), !0;
    } else {
      const z = A(this, P, p);
      if (z === 1 && O.containsPoint(p.end))
        return R && (R.start.copy(p.end), R.end.copy(p.end)), !0;
      if (z !== 2)
        return !1;
      const W = A(O, L, y);
      if (W === 1 && this.containsPoint(y.end))
        return R && (R.start.copy(y.end), R.end.copy(y.end)), !0;
      if (W !== 2)
        return !1;
      if (p.delta(l), y.delta(c), l.dot(c) < 0) {
        let Oe = y.start;
        y.start = y.end, y.end = Oe;
      }
      const re = p.start.dot(l), ce = p.end.dot(l), te = y.start.dot(l), ee = y.end.dot(l), Ne = ce < te, Ae = re < ee;
      return re !== ee && te !== ce && Ne === Ae ? !1 : (R && (h.subVectors(p.start, y.start), h.dot(l) > 0 ? R.start.copy(p.start) : R.start.copy(y.start), h.subVectors(p.end, y.end), h.dot(l) < 0 ? R.end.copy(p.end) : R.end.copy(y.end)), !0);
    }
  };
})();
FA.prototype.distanceToPoint = (function() {
  const e = new Ge();
  return function(i) {
    return this.closestPointToPoint(i, e), i.distanceTo(e);
  };
})();
FA.prototype.distanceToTriangle = (function() {
  const e = new Ge(), t = new Ge(), i = ["a", "b", "c"], n = new gc(), s = new gc();
  return function(r, l = null, c = null) {
    const h = l || c ? n : null;
    if (this.intersectsTriangle(r, h))
      return (l || c) && (l && h.getCenter(l), c && h.getCenter(c)), 0;
    let I = 1 / 0;
    for (let p = 0; p < 3; p++) {
      let y;
      const m = i[p], A = r[m];
      this.closestPointToPoint(A, e), y = A.distanceToSquared(e), y < I && (I = y, l && l.copy(e), c && c.copy(A));
      const C = this[m];
      r.closestPointToPoint(C, e), y = C.distanceToSquared(e), y < I && (I = y, l && l.copy(C), c && c.copy(e));
    }
    for (let p = 0; p < 3; p++) {
      const y = i[p], m = i[(p + 1) % 3];
      n.set(this[y], this[m]);
      for (let A = 0; A < 3; A++) {
        const C = i[A], O = i[(A + 1) % 3];
        s.set(r[C], r[O]), Bme(n, s, e, t);
        const R = e.distanceToSquared(t);
        R < I && (I = R, l && l.copy(e), c && c.copy(t));
      }
    }
    return Math.sqrt(I);
  };
})();
class fE {
  constructor(t, i, n) {
    this.isOrientedBox = !0, this.min = new Ge(), this.max = new Ge(), this.matrix = new Ln(), this.invMatrix = new Ln(), this.points = new Array(8).fill().map(() => new Ge()), this.satAxes = new Array(3).fill().map(() => new Ge()), this.satBounds = new Array(3).fill().map(() => new EL()), this.alignedSatBounds = new Array(3).fill().map(() => new EL()), this.needsUpdate = !1, t && this.min.copy(t), i && this.max.copy(i), n && this.matrix.copy(n);
  }
  set(t, i, n) {
    this.min.copy(t), this.max.copy(i), this.matrix.copy(n), this.needsUpdate = !0;
  }
  copy(t) {
    this.min.copy(t.min), this.max.copy(t.max), this.matrix.copy(t.matrix), this.needsUpdate = !0;
  }
}
fE.prototype.update = /* @__PURE__ */ (function() {
  return function() {
    const t = this.matrix, i = this.min, n = this.max, s = this.points;
    for (let h = 0; h <= 1; h++)
      for (let I = 0; I <= 1; I++)
        for (let p = 0; p <= 1; p++) {
          const y = 1 * h | 2 * I | 4 * p, m = s[y];
          m.x = h ? n.x : i.x, m.y = I ? n.y : i.y, m.z = p ? n.z : i.z, m.applyMatrix4(t);
        }
    const o = this.satBounds, r = this.satAxes, l = s[0];
    for (let h = 0; h < 3; h++) {
      const I = r[h], p = o[h], y = 1 << h, m = s[y];
      I.subVectors(l, m), p.setFromPoints(I, s);
    }
    const c = this.alignedSatBounds;
    c[0].setFromPointsField(s, "x"), c[1].setFromPointsField(s, "y"), c[2].setFromPointsField(s, "z"), this.invMatrix.copy(this.matrix).invert(), this.needsUpdate = !1;
  };
})();
fE.prototype.intersectsBox = (function() {
  const e = new EL();
  return function(i) {
    this.needsUpdate && this.update();
    const n = i.min, s = i.max, o = this.satBounds, r = this.satAxes, l = this.alignedSatBounds;
    if (e.min = n.x, e.max = s.x, l[0].isSeparated(e) || (e.min = n.y, e.max = s.y, l[1].isSeparated(e)) || (e.min = n.z, e.max = s.z, l[2].isSeparated(e)))
      return !1;
    for (let c = 0; c < 3; c++) {
      const h = r[c], I = o[c];
      if (e.setFromBox(h, i), I.isSeparated(e))
        return !1;
    }
    return !0;
  };
})();
fE.prototype.intersectsTriangle = (function() {
  const e = new FA(), t = new Array(3), i = new EL(), n = new EL(), s = new Ge();
  return function(r) {
    this.needsUpdate && this.update(), r.isExtendedTriangle ? r.needsUpdate && r.update() : (e.copy(r), e.update(), r = e);
    const l = this.satBounds, c = this.satAxes;
    t[0] = r.a, t[1] = r.b, t[2] = r.c;
    for (let y = 0; y < 3; y++) {
      const m = l[y], A = c[y];
      if (i.setFromPoints(A, t), m.isSeparated(i))
        return !1;
    }
    const h = r.satBounds, I = r.satAxes, p = this.points;
    for (let y = 0; y < 3; y++) {
      const m = h[y], A = I[y];
      if (i.setFromPoints(A, p), m.isSeparated(i))
        return !1;
    }
    for (let y = 0; y < 3; y++) {
      const m = c[y];
      for (let A = 0; A < 4; A++) {
        const C = I[A];
        if (s.crossVectors(m, C), i.setFromPoints(s, t), n.setFromPoints(s, p), i.isSeparated(n))
          return !1;
      }
    }
    return !0;
  };
})();
fE.prototype.closestPointToPoint = /* @__PURE__ */ (function() {
  return function(t, i) {
    return this.needsUpdate && this.update(), i.copy(t).applyMatrix4(this.invMatrix).clamp(this.min, this.max).applyMatrix4(this.matrix), i;
  };
})();
fE.prototype.distanceToPoint = (function() {
  const e = new Ge();
  return function(i) {
    return this.closestPointToPoint(i, e), i.distanceTo(e);
  };
})();
fE.prototype.distanceToBox = (function() {
  const e = ["x", "y", "z"], t = new Array(12).fill().map(() => new gc()), i = new Array(12).fill().map(() => new gc()), n = new Ge(), s = new Ge();
  return function(r, l = 0, c = null, h = null) {
    if (this.needsUpdate && this.update(), this.intersectsBox(r))
      return (c || h) && (r.getCenter(s), this.closestPointToPoint(s, n), r.closestPointToPoint(n, s), c && c.copy(n), h && h.copy(s)), 0;
    const I = l * l, p = r.min, y = r.max, m = this.points;
    let A = 1 / 0;
    for (let O = 0; O < 8; O++) {
      const R = m[O];
      s.copy(R).clamp(p, y);
      const F = R.distanceToSquared(s);
      if (F < A && (A = F, c && c.copy(R), h && h.copy(s), F < I))
        return Math.sqrt(F);
    }
    let C = 0;
    for (let O = 0; O < 3; O++)
      for (let R = 0; R <= 1; R++)
        for (let F = 0; F <= 1; F++) {
          const L = (O + 1) % 3, P = (O + 2) % 3, z = R << L | F << P, W = 1 << O | R << L | F << P, re = m[z], ce = m[W];
          t[C].set(re, ce);
          const ee = e[O], Ne = e[L], Ae = e[P], Oe = i[C], pe = Oe.start, je = Oe.end;
          pe[ee] = p[ee], pe[Ne] = R ? p[Ne] : y[Ne], pe[Ae] = F ? p[Ae] : y[Ne], je[ee] = y[ee], je[Ne] = R ? p[Ne] : y[Ne], je[Ae] = F ? p[Ae] : y[Ne], C++;
        }
    for (let O = 0; O <= 1; O++)
      for (let R = 0; R <= 1; R++)
        for (let F = 0; F <= 1; F++) {
          s.x = O ? y.x : p.x, s.y = R ? y.y : p.y, s.z = F ? y.z : p.z, this.closestPointToPoint(s, n);
          const L = s.distanceToSquared(n);
          if (L < A && (A = L, c && c.copy(n), h && h.copy(s), L < I))
            return Math.sqrt(L);
        }
    for (let O = 0; O < 12; O++) {
      const R = t[O];
      for (let F = 0; F < 12; F++) {
        const L = i[F];
        Bme(R, L, n, s);
        const P = n.distanceToSquared(s);
        if (P < A && (A = P, c && c.copy(n), h && h.copy(s), P < I))
          return Math.sqrt(P);
      }
    }
    return Math.sqrt(A);
  };
})();
class Fme {
  constructor(t) {
    this._getNewPrimitive = t, this._primitives = [];
  }
  getPrimitive() {
    const t = this._primitives;
    return t.length === 0 ? this._getNewPrimitive() : t.pop();
  }
  releasePrimitive(t) {
    this._primitives.push(t);
  }
}
class dZe extends Fme {
  constructor() {
    super(() => new FA());
  }
}
const D5 = /* @__PURE__ */ new dZe();
function V2(e, t) {
  return t[e + 15] === 65535;
}
function E4(e, t) {
  return t[e + 6];
}
function C5(e, t) {
  return t[e + 14];
}
function O5(e) {
  return e + 8;
}
function L5(e, t) {
  return t[e + 6];
}
function jbe(e, t) {
  return t[e + 7];
}
class cZe {
  constructor() {
    this.float32Array = null, this.uint16Array = null, this.uint32Array = null;
    const t = [];
    let i = null;
    this.setBuffer = (n) => {
      i && t.push(i), i = n, this.float32Array = new Float32Array(n), this.uint16Array = new Uint16Array(n), this.uint32Array = new Uint32Array(n);
    }, this.clearBuffer = () => {
      i = null, this.float32Array = null, this.uint16Array = null, this.uint32Array = null, t.length !== 0 && this.setBuffer(t.pop());
    };
  }
}
const Tu = new cZe();
let vP, yz;
const nV = [], Ase = /* @__PURE__ */ new Fme(() => new Zs());
function hZe(e, t, i, n, s, o) {
  vP = Ase.getPrimitive(), yz = Ase.getPrimitive(), nV.push(vP, yz), Tu.setBuffer(e._roots[t]);
  const r = VIe(0, e.geometry, i, n, s, o);
  Tu.clearBuffer(), Ase.releasePrimitive(vP), Ase.releasePrimitive(yz), nV.pop(), nV.pop();
  const l = nV.length;
  return l > 0 && (yz = nV[l - 1], vP = nV[l - 2]), r;
}
function VIe(e, t, i, n, s = null, o = 0, r = 0) {
  const { float32Array: l, uint16Array: c, uint32Array: h } = Tu;
  let I = e * 2;
  if (V2(I, c)) {
    const y = E4(e, h), m = C5(I, c);
    return ud(e, l, vP), n(y, m, !1, r, o + e, vP);
  } else {
    let y = function(Ae) {
      const { uint16Array: Oe, uint32Array: pe } = Tu;
      let je = Ae * 2;
      for (; !V2(je, Oe); )
        Ae = O5(Ae), je = Ae * 2;
      return E4(Ae, pe);
    }, m = function(Ae) {
      const { uint16Array: Oe, uint32Array: pe } = Tu;
      let je = Ae * 2;
      for (; !V2(je, Oe); )
        Ae = L5(Ae, pe), je = Ae * 2;
      return E4(Ae, pe) + C5(je, Oe);
    };
    const A = O5(e), C = L5(e, h);
    let O = A, R = C, F, L, P, z;
    if (s && (P = vP, z = yz, ud(O, l, P), ud(R, l, z), F = s(P), L = s(z), L < F)) {
      O = C, R = A;
      const Ae = F;
      F = L, L = Ae, P = z;
    }
    P || (P = vP, ud(O, l, P));
    const W = V2(O * 2, c), re = i(P, W, F, r + 1, o + O);
    let ce;
    if (re === Xwe) {
      const Ae = y(O), pe = m(O) - Ae;
      ce = n(Ae, pe, !0, r + 1, o + O, P);
    } else
      ce = re && VIe(
        O,
        t,
        i,
        n,
        s,
        o,
        r + 1
      );
    if (ce)
      return !0;
    z = yz, ud(R, l, z);
    const te = V2(R * 2, c), ee = i(z, te, L, r + 1, o + R);
    let Ne;
    if (ee === Xwe) {
      const Ae = y(R), pe = m(R) - Ae;
      Ne = n(Ae, pe, !0, r + 1, o + R, z);
    } else
      Ne = ee && VIe(
        R,
        t,
        i,
        n,
        s,
        o,
        r + 1
      );
    return !!Ne;
  }
}
const FZ = /* @__PURE__ */ new Ge(), Mce = /* @__PURE__ */ new Ge();
function fZe(e, t, i = {}, n = 0, s = 1 / 0) {
  const o = n * n, r = s * s;
  let l = 1 / 0, c = null;
  if (e.shapecast(
    {
      boundsTraverseOrder: (I) => (FZ.copy(t).clamp(I.min, I.max), FZ.distanceToSquared(t)),
      intersectsBounds: (I, p, y) => y < l && y < r,
      intersectsTriangle: (I, p) => {
        I.closestPointToPoint(t, FZ);
        const y = t.distanceToSquared(FZ);
        return y < l && (Mce.copy(FZ), l = y, c = p), y < o;
      }
    }
  ), l === 1 / 0)
    return null;
  const h = Math.sqrt(l);
  return i.point ? i.point.copy(Mce) : i.point = Mce.clone(), i.distance = h, i.faceIndex = c, i;
}
const sV = /* @__PURE__ */ new Ge(), oV = /* @__PURE__ */ new Ge(), rV = /* @__PURE__ */ new Ge(), Sse = /* @__PURE__ */ new us(), bse = /* @__PURE__ */ new us(), Nse = /* @__PURE__ */ new us(), s2e = /* @__PURE__ */ new Ge(), o2e = /* @__PURE__ */ new Ge(), r2e = /* @__PURE__ */ new Ge(), Dse = /* @__PURE__ */ new Ge();
function IZe(e, t, i, n, s, o) {
  let r;
  return o === nE ? r = e.intersectTriangle(n, i, t, !0, s) : r = e.intersectTriangle(t, i, n, o !== $y, s), r === null ? null : {
    distance: e.origin.distanceTo(s),
    point: s.clone()
  };
}
function pZe(e, t, i, n, s, o, r, l, c) {
  sV.fromBufferAttribute(t, o), oV.fromBufferAttribute(t, r), rV.fromBufferAttribute(t, l);
  const h = IZe(e, sV, oV, rV, Dse, c);
  if (h) {
    n && (Sse.fromBufferAttribute(n, o), bse.fromBufferAttribute(n, r), Nse.fromBufferAttribute(n, l), h.uv = wc.getInterpolation(Dse, sV, oV, rV, Sse, bse, Nse, new us())), s && (Sse.fromBufferAttribute(s, o), bse.fromBufferAttribute(s, r), Nse.fromBufferAttribute(s, l), h.uv1 = wc.getInterpolation(Dse, sV, oV, rV, Sse, bse, Nse, new us())), i && (s2e.fromBufferAttribute(i, o), o2e.fromBufferAttribute(i, r), r2e.fromBufferAttribute(i, l), h.normal = wc.getInterpolation(Dse, sV, oV, rV, s2e, o2e, r2e, new Ge()), h.normal.dot(e.direction) > 0 && h.normal.multiplyScalar(-1));
    const I = {
      a: o,
      b: r,
      c: l,
      normal: new Ge(),
      materialIndex: 0
    };
    wc.getNormal(sV, oV, rV, I.normal), h.face = I, h.faceIndex = o;
  }
  return h;
}
function Nue(e, t, i, n, s) {
  const o = n * 3;
  let r = o + 0, l = o + 1, c = o + 2;
  const h = e.index;
  e.index && (r = h.getX(r), l = h.getX(l), c = h.getX(c));
  const { position: I, normal: p, uv: y, uv1: m } = e.attributes, A = pZe(i, I, p, y, m, r, l, c, t);
  return A ? (A.faceIndex = n, s && s.push(A), A) : null;
}
function dh(e, t, i, n) {
  const s = e.a, o = e.b, r = e.c;
  let l = t, c = t + 1, h = t + 2;
  i && (l = i.getX(l), c = i.getX(c), h = i.getX(h)), s.x = n.getX(l), s.y = n.getY(l), s.z = n.getZ(l), o.x = n.getX(c), o.y = n.getY(c), o.z = n.getZ(c), r.x = n.getX(h), r.y = n.getY(h), r.z = n.getZ(h);
}
function mZe(e, t, i, n, s, o) {
  const { geometry: r, _indirectBuffer: l } = e;
  for (let c = n, h = n + s; c < h; c++)
    Nue(r, t, i, c, o);
}
function yZe(e, t, i, n, s) {
  const { geometry: o, _indirectBuffer: r } = e;
  let l = 1 / 0, c = null;
  for (let h = n, I = n + s; h < I; h++) {
    let p;
    p = Nue(o, t, i, h), p && p.distance < l && (c = p, l = p.distance);
  }
  return c;
}
function EZe(e, t, i, n, s, o, r) {
  const { geometry: l } = i, { index: c } = l, h = l.attributes.position;
  for (let I = e, p = t + e; I < p; I++) {
    let y;
    if (y = I, dh(r, y * 3, c, h), r.needsUpdate = !0, n(r, y, s, o))
      return !0;
  }
  return !1;
}
function gZe(e, t = null) {
  t && Array.isArray(t) && (t = new Set(t));
  const i = e.geometry, n = i.index ? i.index.array : null, s = i.attributes.position;
  let o, r, l, c, h = 0;
  const I = e._roots;
  for (let y = 0, m = I.length; y < m; y++)
    o = I[y], r = new Uint32Array(o), l = new Uint16Array(o), c = new Float32Array(o), p(0, h), h += o.byteLength;
  function p(y, m, A = !1) {
    const C = y * 2;
    if (l[C + 15] === bue) {
      const R = r[y + 6], F = l[C + 14];
      let L = 1 / 0, P = 1 / 0, z = 1 / 0, W = -1 / 0, re = -1 / 0, ce = -1 / 0;
      for (let te = 3 * R, ee = 3 * (R + F); te < ee; te++) {
        let Ne = n[te];
        const Ae = s.getX(Ne), Oe = s.getY(Ne), pe = s.getZ(Ne);
        Ae < L && (L = Ae), Ae > W && (W = Ae), Oe < P && (P = Oe), Oe > re && (re = Oe), pe < z && (z = pe), pe > ce && (ce = pe);
      }
      return c[y + 0] !== L || c[y + 1] !== P || c[y + 2] !== z || c[y + 3] !== W || c[y + 4] !== re || c[y + 5] !== ce ? (c[y + 0] = L, c[y + 1] = P, c[y + 2] = z, c[y + 3] = W, c[y + 4] = re, c[y + 5] = ce, !0) : !1;
    } else {
      const R = y + 8, F = r[y + 6], L = R + m, P = F + m;
      let z = A, W = !1, re = !1;
      t ? z || (W = t.has(L), re = t.has(P), z = !W && !re) : (W = !0, re = !0);
      const ce = z || W, te = z || re;
      let ee = !1;
      ce && (ee = p(R, m, z));
      let Ne = !1;
      te && (Ne = p(F, m, z));
      const Ae = ee || Ne;
      if (Ae)
        for (let Oe = 0; Oe < 3; Oe++) {
          const pe = R + Oe, je = F + Oe, Ve = c[pe], $e = c[pe + 3], vt = c[je], Rt = c[je + 3];
          c[y + Oe] = Ve < vt ? Ve : vt, c[y + Oe + 3] = $e > Rt ? $e : Rt;
        }
      return Ae;
    }
  }
}
const l2e = /* @__PURE__ */ new Zs();
function L8(e, t, i, n) {
  return ud(e, t, l2e), i.intersectBox(l2e, n);
}
function wZe(e, t, i, n, s, o) {
  const { geometry: r, _indirectBuffer: l } = e;
  for (let c = n, h = n + s; c < h; c++) {
    let I = l ? l[c] : c;
    Nue(r, t, i, I, o);
  }
}
function TZe(e, t, i, n, s) {
  const { geometry: o, _indirectBuffer: r } = e;
  let l = 1 / 0, c = null;
  for (let h = n, I = n + s; h < I; h++) {
    let p;
    p = Nue(o, t, i, r ? r[h] : h), p && p.distance < l && (c = p, l = p.distance);
  }
  return c;
}
function RZe(e, t, i, n, s, o, r) {
  const { geometry: l } = i, { index: c } = l, h = l.attributes.position;
  for (let I = e, p = t + e; I < p; I++) {
    let y;
    if (y = i.resolveTriangleIndex(I), dh(r, y * 3, c, h), r.needsUpdate = !0, n(r, y, s, o))
      return !0;
  }
  return !1;
}
const a2e = /* @__PURE__ */ new Ge();
function vZe(e, t, i, n, s) {
  Tu.setBuffer(e._roots[t]), zIe(0, e, i, n, s), Tu.clearBuffer();
}
function zIe(e, t, i, n, s) {
  const { float32Array: o, uint16Array: r, uint32Array: l } = Tu, c = e * 2;
  if (V2(c, r)) {
    const I = E4(e, l), p = C5(c, r);
    mZe(t, i, n, I, p, s);
  } else {
    const I = O5(e);
    L8(I, o, n, a2e) && zIe(I, t, i, n, s);
    const p = L5(e, l);
    L8(p, o, n, a2e) && zIe(p, t, i, n, s);
  }
}
const u2e = /* @__PURE__ */ new Ge(), AZe = ["x", "y", "z"];
function SZe(e, t, i, n) {
  Tu.setBuffer(e._roots[t]);
  const s = jIe(0, e, i, n);
  return Tu.clearBuffer(), s;
}
function jIe(e, t, i, n) {
  const { float32Array: s, uint16Array: o, uint32Array: r } = Tu;
  let l = e * 2;
  if (V2(l, o)) {
    const h = E4(e, r), I = C5(l, o);
    return yZe(t, i, n, h, I);
  } else {
    const h = jbe(e, r), I = AZe[h], y = n.direction[I] >= 0;
    let m, A;
    y ? (m = O5(e), A = L5(e, r)) : (m = L5(e, r), A = O5(e));
    const O = L8(m, s, n, u2e) ? jIe(m, t, i, n) : null;
    if (O) {
      const L = O.point[I];
      if (y ? L <= s[A + h] : (
        // min bounding data
        L >= s[A + h + 3]
      ))
        return O;
    }
    const F = L8(A, s, n, u2e) ? jIe(A, t, i, n) : null;
    return O && F ? O.distance <= F.distance ? O : F : O || F || null;
  }
}
const Cse = /* @__PURE__ */ new Zs(), lV = /* @__PURE__ */ new FA(), aV = /* @__PURE__ */ new FA(), HZ = /* @__PURE__ */ new Ln(), d2e = /* @__PURE__ */ new fE(), Ose = /* @__PURE__ */ new fE();
function bZe(e, t, i, n) {
  Tu.setBuffer(e._roots[t]);
  const s = WIe(0, e, i, n);
  return Tu.clearBuffer(), s;
}
function WIe(e, t, i, n, s = null) {
  const { float32Array: o, uint16Array: r, uint32Array: l } = Tu;
  let c = e * 2;
  if (s === null && (i.boundingBox || i.computeBoundingBox(), d2e.set(i.boundingBox.min, i.boundingBox.max, n), s = d2e), V2(c, r)) {
    const I = t.geometry, p = I.index, y = I.attributes.position, m = i.index, A = i.attributes.position, C = E4(e, l), O = C5(c, r);
    if (HZ.copy(n).invert(), i.boundsTree)
      return ud(e, o, Ose), Ose.matrix.copy(HZ), Ose.needsUpdate = !0, i.boundsTree.shapecast({
        intersectsBounds: (F) => Ose.intersectsBox(F),
        intersectsTriangle: (F) => {
          F.a.applyMatrix4(n), F.b.applyMatrix4(n), F.c.applyMatrix4(n), F.needsUpdate = !0;
          for (let L = C * 3, P = (O + C) * 3; L < P; L += 3)
            if (dh(aV, L, p, y), aV.needsUpdate = !0, F.intersectsTriangle(aV))
              return !0;
          return !1;
        }
      });
    for (let R = C * 3, F = (O + C) * 3; R < F; R += 3) {
      dh(lV, R, p, y), lV.a.applyMatrix4(HZ), lV.b.applyMatrix4(HZ), lV.c.applyMatrix4(HZ), lV.needsUpdate = !0;
      for (let L = 0, P = m.count; L < P; L += 3)
        if (dh(aV, L, m, A), aV.needsUpdate = !0, lV.intersectsTriangle(aV))
          return !0;
    }
  } else {
    const I = e + 8, p = l[e + 6];
    return ud(I, o, Cse), !!(s.intersectsBox(Cse) && WIe(I, t, i, n, s) || (ud(p, o, Cse), s.intersectsBox(Cse) && WIe(p, t, i, n, s)));
  }
}
const Lse = /* @__PURE__ */ new Ln(), Uce = /* @__PURE__ */ new fE(), GZ = /* @__PURE__ */ new fE(), NZe = /* @__PURE__ */ new Ge(), DZe = /* @__PURE__ */ new Ge(), CZe = /* @__PURE__ */ new Ge(), OZe = /* @__PURE__ */ new Ge();
function LZe(e, t, i, n = {}, s = {}, o = 0, r = 1 / 0) {
  t.boundingBox || t.computeBoundingBox(), Uce.set(t.boundingBox.min, t.boundingBox.max, i), Uce.needsUpdate = !0;
  const l = e.geometry, c = l.attributes.position, h = l.index, I = t.attributes.position, p = t.index, y = D5.getPrimitive(), m = D5.getPrimitive();
  let A = NZe, C = DZe, O = null, R = null;
  s && (O = CZe, R = OZe);
  let F = 1 / 0, L = null, P = null;
  return Lse.copy(i).invert(), GZ.matrix.copy(Lse), e.shapecast(
    {
      boundsTraverseOrder: (z) => Uce.distanceToBox(z),
      intersectsBounds: (z, W, re) => re < F && re < r ? (W && (GZ.min.copy(z.min), GZ.max.copy(z.max), GZ.needsUpdate = !0), !0) : !1,
      intersectsRange: (z, W) => {
        if (t.boundsTree)
          return t.boundsTree.shapecast({
            boundsTraverseOrder: (ce) => GZ.distanceToBox(ce),
            intersectsBounds: (ce, te, ee) => ee < F && ee < r,
            intersectsRange: (ce, te) => {
              for (let ee = ce, Ne = ce + te; ee < Ne; ee++) {
                dh(m, 3 * ee, p, I), m.a.applyMatrix4(i), m.b.applyMatrix4(i), m.c.applyMatrix4(i), m.needsUpdate = !0;
                for (let Ae = z, Oe = z + W; Ae < Oe; Ae++) {
                  dh(y, 3 * Ae, h, c), y.needsUpdate = !0;
                  const pe = y.distanceToTriangle(m, A, O);
                  if (pe < F && (C.copy(A), R && R.copy(O), F = pe, L = Ae, P = ee), pe < o)
                    return !0;
                }
              }
            }
          });
        {
          const re = aY(t);
          for (let ce = 0, te = re; ce < te; ce++) {
            dh(m, 3 * ce, p, I), m.a.applyMatrix4(i), m.b.applyMatrix4(i), m.c.applyMatrix4(i), m.needsUpdate = !0;
            for (let ee = z, Ne = z + W; ee < Ne; ee++) {
              dh(y, 3 * ee, h, c), y.needsUpdate = !0;
              const Ae = y.distanceToTriangle(m, A, O);
              if (Ae < F && (C.copy(A), R && R.copy(O), F = Ae, L = ee, P = ce), Ae < o)
                return !0;
            }
          }
        }
      }
    }
  ), D5.releasePrimitive(y), D5.releasePrimitive(m), F === 1 / 0 ? null : (n.point ? n.point.copy(C) : n.point = C.clone(), n.distance = F, n.faceIndex = L, s && (s.point ? s.point.copy(R) : s.point = R.clone(), s.point.applyMatrix4(Lse), C.applyMatrix4(Lse), s.distance = C.sub(s.point).length(), s.faceIndex = P), n);
}
function _Ze(e, t = null) {
  t && Array.isArray(t) && (t = new Set(t));
  const i = e.geometry, n = i.index ? i.index.array : null, s = i.attributes.position;
  let o, r, l, c, h = 0;
  const I = e._roots;
  for (let y = 0, m = I.length; y < m; y++)
    o = I[y], r = new Uint32Array(o), l = new Uint16Array(o), c = new Float32Array(o), p(0, h), h += o.byteLength;
  function p(y, m, A = !1) {
    const C = y * 2;
    if (l[C + 15] === bue) {
      const R = r[y + 6], F = l[C + 14];
      let L = 1 / 0, P = 1 / 0, z = 1 / 0, W = -1 / 0, re = -1 / 0, ce = -1 / 0;
      for (let te = R, ee = R + F; te < ee; te++) {
        const Ne = 3 * e.resolveTriangleIndex(te);
        for (let Ae = 0; Ae < 3; Ae++) {
          let Oe = Ne + Ae;
          Oe = n ? n[Oe] : Oe;
          const pe = s.getX(Oe), je = s.getY(Oe), Ve = s.getZ(Oe);
          pe < L && (L = pe), pe > W && (W = pe), je < P && (P = je), je > re && (re = je), Ve < z && (z = Ve), Ve > ce && (ce = Ve);
        }
      }
      return c[y + 0] !== L || c[y + 1] !== P || c[y + 2] !== z || c[y + 3] !== W || c[y + 4] !== re || c[y + 5] !== ce ? (c[y + 0] = L, c[y + 1] = P, c[y + 2] = z, c[y + 3] = W, c[y + 4] = re, c[y + 5] = ce, !0) : !1;
    } else {
      const R = y + 8, F = r[y + 6], L = R + m, P = F + m;
      let z = A, W = !1, re = !1;
      t ? z || (W = t.has(L), re = t.has(P), z = !W && !re) : (W = !0, re = !0);
      const ce = z || W, te = z || re;
      let ee = !1;
      ce && (ee = p(R, m, z));
      let Ne = !1;
      te && (Ne = p(F, m, z));
      const Ae = ee || Ne;
      if (Ae)
        for (let Oe = 0; Oe < 3; Oe++) {
          const pe = R + Oe, je = F + Oe, Ve = c[pe], $e = c[pe + 3], vt = c[je], Rt = c[je + 3];
          c[y + Oe] = Ve < vt ? Ve : vt, c[y + Oe + 3] = $e > Rt ? $e : Rt;
        }
      return Ae;
    }
  }
}
const c2e = /* @__PURE__ */ new Ge();
function xZe(e, t, i, n, s) {
  Tu.setBuffer(e._roots[t]), YIe(0, e, i, n, s), Tu.clearBuffer();
}
function YIe(e, t, i, n, s) {
  const { float32Array: o, uint16Array: r, uint32Array: l } = Tu, c = e * 2;
  if (V2(c, r)) {
    const I = E4(e, l), p = C5(c, r);
    wZe(t, i, n, I, p, s);
  } else {
    const I = O5(e);
    L8(I, o, n, c2e) && YIe(I, t, i, n, s);
    const p = L5(e, l);
    L8(p, o, n, c2e) && YIe(p, t, i, n, s);
  }
}
const h2e = /* @__PURE__ */ new Ge(), PZe = ["x", "y", "z"];
function MZe(e, t, i, n) {
  Tu.setBuffer(e._roots[t]);
  const s = qIe(0, e, i, n);
  return Tu.clearBuffer(), s;
}
function qIe(e, t, i, n) {
  const { float32Array: s, uint16Array: o, uint32Array: r } = Tu;
  let l = e * 2;
  if (V2(l, o)) {
    const h = E4(e, r), I = C5(l, o);
    return TZe(t, i, n, h, I);
  } else {
    const h = jbe(e, r), I = PZe[h], y = n.direction[I] >= 0;
    let m, A;
    y ? (m = O5(e), A = L5(e, r)) : (m = L5(e, r), A = O5(e));
    const O = L8(m, s, n, h2e) ? qIe(m, t, i, n) : null;
    if (O) {
      const L = O.point[I];
      if (y ? L <= s[A + h] : (
        // min bounding data
        L >= s[A + h + 3]
      ))
        return O;
    }
    const F = L8(A, s, n, h2e) ? qIe(A, t, i, n) : null;
    return O && F ? O.distance <= F.distance ? O : F : O || F || null;
  }
}
const _se = /* @__PURE__ */ new Zs(), uV = /* @__PURE__ */ new FA(), dV = /* @__PURE__ */ new FA(), kZ = /* @__PURE__ */ new Ln(), f2e = /* @__PURE__ */ new fE(), xse = /* @__PURE__ */ new fE();
function UZe(e, t, i, n) {
  Tu.setBuffer(e._roots[t]);
  const s = $Ie(0, e, i, n);
  return Tu.clearBuffer(), s;
}
function $Ie(e, t, i, n, s = null) {
  const { float32Array: o, uint16Array: r, uint32Array: l } = Tu;
  let c = e * 2;
  if (s === null && (i.boundingBox || i.computeBoundingBox(), f2e.set(i.boundingBox.min, i.boundingBox.max, n), s = f2e), V2(c, r)) {
    const I = t.geometry, p = I.index, y = I.attributes.position, m = i.index, A = i.attributes.position, C = E4(e, l), O = C5(c, r);
    if (kZ.copy(n).invert(), i.boundsTree)
      return ud(e, o, xse), xse.matrix.copy(kZ), xse.needsUpdate = !0, i.boundsTree.shapecast({
        intersectsBounds: (F) => xse.intersectsBox(F),
        intersectsTriangle: (F) => {
          F.a.applyMatrix4(n), F.b.applyMatrix4(n), F.c.applyMatrix4(n), F.needsUpdate = !0;
          for (let L = C, P = O + C; L < P; L++)
            if (dh(dV, 3 * t.resolveTriangleIndex(L), p, y), dV.needsUpdate = !0, F.intersectsTriangle(dV))
              return !0;
          return !1;
        }
      });
    for (let R = C, F = O + C; R < F; R++) {
      const L = t.resolveTriangleIndex(R);
      dh(uV, 3 * L, p, y), uV.a.applyMatrix4(kZ), uV.b.applyMatrix4(kZ), uV.c.applyMatrix4(kZ), uV.needsUpdate = !0;
      for (let P = 0, z = m.count; P < z; P += 3)
        if (dh(dV, P, m, A), dV.needsUpdate = !0, uV.intersectsTriangle(dV))
          return !0;
    }
  } else {
    const I = e + 8, p = l[e + 6];
    return ud(I, o, _se), !!(s.intersectsBox(_se) && $Ie(I, t, i, n, s) || (ud(p, o, _se), s.intersectsBox(_se) && $Ie(p, t, i, n, s)));
  }
}
const Pse = /* @__PURE__ */ new Ln(), Bce = /* @__PURE__ */ new fE(), VZ = /* @__PURE__ */ new fE(), BZe = /* @__PURE__ */ new Ge(), FZe = /* @__PURE__ */ new Ge(), HZe = /* @__PURE__ */ new Ge(), GZe = /* @__PURE__ */ new Ge();
function kZe(e, t, i, n = {}, s = {}, o = 0, r = 1 / 0) {
  t.boundingBox || t.computeBoundingBox(), Bce.set(t.boundingBox.min, t.boundingBox.max, i), Bce.needsUpdate = !0;
  const l = e.geometry, c = l.attributes.position, h = l.index, I = t.attributes.position, p = t.index, y = D5.getPrimitive(), m = D5.getPrimitive();
  let A = BZe, C = FZe, O = null, R = null;
  s && (O = HZe, R = GZe);
  let F = 1 / 0, L = null, P = null;
  return Pse.copy(i).invert(), VZ.matrix.copy(Pse), e.shapecast(
    {
      boundsTraverseOrder: (z) => Bce.distanceToBox(z),
      intersectsBounds: (z, W, re) => re < F && re < r ? (W && (VZ.min.copy(z.min), VZ.max.copy(z.max), VZ.needsUpdate = !0), !0) : !1,
      intersectsRange: (z, W) => {
        if (t.boundsTree) {
          const re = t.boundsTree;
          return re.shapecast({
            boundsTraverseOrder: (ce) => VZ.distanceToBox(ce),
            intersectsBounds: (ce, te, ee) => ee < F && ee < r,
            intersectsRange: (ce, te) => {
              for (let ee = ce, Ne = ce + te; ee < Ne; ee++) {
                const Ae = re.resolveTriangleIndex(ee);
                dh(m, 3 * Ae, p, I), m.a.applyMatrix4(i), m.b.applyMatrix4(i), m.c.applyMatrix4(i), m.needsUpdate = !0;
                for (let Oe = z, pe = z + W; Oe < pe; Oe++) {
                  const je = e.resolveTriangleIndex(Oe);
                  dh(y, 3 * je, h, c), y.needsUpdate = !0;
                  const Ve = y.distanceToTriangle(m, A, O);
                  if (Ve < F && (C.copy(A), R && R.copy(O), F = Ve, L = Oe, P = ee), Ve < o)
                    return !0;
                }
              }
            }
          });
        } else {
          const re = aY(t);
          for (let ce = 0, te = re; ce < te; ce++) {
            dh(m, 3 * ce, p, I), m.a.applyMatrix4(i), m.b.applyMatrix4(i), m.c.applyMatrix4(i), m.needsUpdate = !0;
            for (let ee = z, Ne = z + W; ee < Ne; ee++) {
              const Ae = e.resolveTriangleIndex(ee);
              dh(y, 3 * Ae, h, c), y.needsUpdate = !0;
              const Oe = y.distanceToTriangle(m, A, O);
              if (Oe < F && (C.copy(A), R && R.copy(O), F = Oe, L = ee, P = ce), Oe < o)
                return !0;
            }
          }
        }
      }
    }
  ), D5.releasePrimitive(y), D5.releasePrimitive(m), F === 1 / 0 ? null : (n.point ? n.point.copy(C) : n.point = C.clone(), n.distance = F, n.faceIndex = L, s && (s.point ? s.point.copy(R) : s.point = R.clone(), s.point.applyMatrix4(Pse), C.applyMatrix4(Pse), s.distance = C.sub(s.point).length(), s.faceIndex = P), n);
}
function VZe() {
  return typeof SharedArrayBuffer < "u";
}
const jJ = new Tu.constructor(), Lle = new Tu.constructor(), sx = new Fme(() => new Zs()), cV = new Zs(), hV = new Zs(), Fce = new Zs(), Hce = new Zs();
let Gce = !1;
function zZe(e, t, i, n) {
  if (Gce)
    throw new Error("MeshBVH: Recursive calls to bvhcast not supported.");
  Gce = !0;
  const s = e._roots, o = t._roots;
  let r, l = 0, c = 0;
  const h = new Ln().copy(i).invert();
  for (let I = 0, p = s.length; I < p; I++) {
    jJ.setBuffer(s[I]), c = 0;
    const y = sx.getPrimitive();
    ud(0, jJ.float32Array, y), y.applyMatrix4(h);
    for (let m = 0, A = o.length; m < A && (Lle.setBuffer(o[I]), r = hv(
      0,
      0,
      i,
      h,
      n,
      l,
      c,
      0,
      0,
      y
    ), Lle.clearBuffer(), c += o[m].length, !r); m++)
      ;
    if (sx.releasePrimitive(y), jJ.clearBuffer(), l += s[I].length, r)
      break;
  }
  return Gce = !1, r;
}
function hv(e, t, i, n, s, o = 0, r = 0, l = 0, c = 0, h = null, I = !1) {
  let p, y;
  I ? (p = Lle, y = jJ) : (p = jJ, y = Lle);
  const m = p.float32Array, A = p.uint32Array, C = p.uint16Array, O = y.float32Array, R = y.uint32Array, F = y.uint16Array, L = e * 2, P = t * 2, z = V2(L, C), W = V2(P, F);
  let re = !1;
  if (W && z)
    I ? re = s(
      E4(t, R),
      C5(t * 2, F),
      E4(e, A),
      C5(e * 2, C),
      c,
      r + t,
      l,
      o + e
    ) : re = s(
      E4(e, A),
      C5(e * 2, C),
      E4(t, R),
      C5(t * 2, F),
      l,
      o + e,
      c,
      r + t
    );
  else if (W) {
    const ce = sx.getPrimitive();
    ud(t, O, ce), ce.applyMatrix4(i);
    const te = O5(e), ee = L5(e, A);
    ud(te, m, cV), ud(ee, m, hV);
    const Ne = ce.intersectsBox(cV), Ae = ce.intersectsBox(hV);
    re = Ne && hv(
      t,
      te,
      n,
      i,
      s,
      r,
      o,
      c,
      l + 1,
      ce,
      !I
    ) || Ae && hv(
      t,
      ee,
      n,
      i,
      s,
      r,
      o,
      c,
      l + 1,
      ce,
      !I
    ), sx.releasePrimitive(ce);
  } else {
    const ce = O5(t), te = L5(t, R);
    ud(ce, O, Fce), ud(te, O, Hce);
    const ee = h.intersectsBox(Fce), Ne = h.intersectsBox(Hce);
    if (ee && Ne)
      re = hv(
        e,
        ce,
        i,
        n,
        s,
        o,
        r,
        l,
        c + 1,
        h,
        I
      ) || hv(
        e,
        te,
        i,
        n,
        s,
        o,
        r,
        l,
        c + 1,
        h,
        I
      );
    else if (ee)
      if (z)
        re = hv(
          e,
          ce,
          i,
          n,
          s,
          o,
          r,
          l,
          c + 1,
          h,
          I
        );
      else {
        const Ae = sx.getPrimitive();
        Ae.copy(Fce).applyMatrix4(i);
        const Oe = O5(e), pe = L5(e, A);
        ud(Oe, m, cV), ud(pe, m, hV);
        const je = Ae.intersectsBox(cV), Ve = Ae.intersectsBox(hV);
        re = je && hv(
          ce,
          Oe,
          n,
          i,
          s,
          r,
          o,
          c,
          l + 1,
          Ae,
          !I
        ) || Ve && hv(
          ce,
          pe,
          n,
          i,
          s,
          r,
          o,
          c,
          l + 1,
          Ae,
          !I
        ), sx.releasePrimitive(Ae);
      }
    else if (Ne)
      if (z)
        re = hv(
          e,
          te,
          i,
          n,
          s,
          o,
          r,
          l,
          c + 1,
          h,
          I
        );
      else {
        const Ae = sx.getPrimitive();
        Ae.copy(Hce).applyMatrix4(i);
        const Oe = O5(e), pe = L5(e, A);
        ud(Oe, m, cV), ud(pe, m, hV);
        const je = Ae.intersectsBox(cV), Ve = Ae.intersectsBox(hV);
        re = je && hv(
          te,
          Oe,
          n,
          i,
          s,
          r,
          o,
          c,
          l + 1,
          Ae,
          !I
        ) || Ve && hv(
          te,
          pe,
          n,
          i,
          s,
          r,
          o,
          c,
          l + 1,
          Ae,
          !I
        ), sx.releasePrimitive(Ae);
      }
  }
  return re;
}
const Mse = /* @__PURE__ */ new fE(), I2e = /* @__PURE__ */ new Zs();
class Hme {
  static serialize(t, i = {}) {
    i = {
      cloneBuffers: !0,
      ...i
    };
    const n = t.geometry, s = t._roots, o = t._indirectBuffer, r = n.getIndex();
    let l;
    return i.cloneBuffers ? l = {
      roots: s.map((c) => c.slice()),
      index: r.array.slice(),
      indirectBuffer: o ? o.slice() : null
    } : l = {
      roots: s,
      index: r.array,
      indirectBuffer: o
    }, l;
  }
  static deserialize(t, i, n = {}) {
    n = {
      setIndex: !0,
      indirect: !!t.indirectBuffer,
      ...n
    };
    const { index: s, roots: o, indirectBuffer: r } = t, l = new Hme(i, { ...n, [_ce]: !0 });
    if (l._roots = o, l._indirectBuffer = r || null, n.setIndex) {
      const c = i.getIndex();
      if (c === null) {
        const h = new zu(t.index, 1, !1);
        i.setIndex(h);
      } else c.array !== s && (c.array.set(s), c.needsUpdate = !0);
    }
    return l;
  }
  get indirect() {
    return !!this._indirectBuffer;
  }
  constructor(t, i = {}) {
    if (t.isBufferGeometry) {
      if (t.index && t.index.isInterleavedBufferAttribute)
        throw new Error("MeshBVH: InterleavedBufferAttribute is not supported for the index attribute.");
    } else throw new Error("MeshBVH: Only BufferGeometries are supported.");
    if (i = Object.assign({
      strategy: kbe,
      maxDepth: 40,
      maxLeafTris: 10,
      verbose: !0,
      useSharedArrayBuffer: !1,
      setBoundingBox: !0,
      onProgress: null,
      indirect: !1,
      // undocumented options
      // Whether to skip generating the tree. Used for deserialization.
      [_ce]: !1
    }, i), i.useSharedArrayBuffer && !VZe())
      throw new Error("MeshBVH: SharedArrayBuffer is not available.");
    this.geometry = t, this._roots = null, this._indirectBuffer = null, i[_ce] || (rZe(this, i), !t.boundingBox && i.setBoundingBox && (t.boundingBox = this.getBoundingBox(new Zs())));
    const { _indirectBuffer: n } = this;
    this.resolveTriangleIndex = i.indirect ? (s) => n[s] : (s) => s;
  }
  refit(t = null) {
    return (this.indirect ? _Ze : gZe)(this, t);
  }
  traverse(t, i = 0) {
    const n = this._roots[i], s = new Uint32Array(n), o = new Uint16Array(n);
    r(0);
    function r(l, c = 0) {
      const h = l * 2, I = o[h + 15] === bue;
      if (I) {
        const p = s[l + 6], y = o[h + 14];
        t(c, I, new Float32Array(n, l * 4, 6), p, y);
      } else {
        const p = l + Ore / 4, y = s[l + 6], m = s[l + 7];
        t(c, I, new Float32Array(n, l * 4, 6), m) || (r(p, c + 1), r(y, c + 1));
      }
    }
  }
  /* Core Cast Functions */
  raycast(t, i = xA) {
    const n = this._roots, s = this.geometry, o = [], r = i.isMaterial, l = Array.isArray(i), c = s.groups, h = r ? i.side : i, I = this.indirect ? xZe : vZe;
    for (let p = 0, y = n.length; p < y; p++) {
      const m = l ? i[c[p].materialIndex].side : h, A = o.length;
      if (I(this, p, m, t, o), l) {
        const C = c[p].materialIndex;
        for (let O = A, R = o.length; O < R; O++)
          o[O].face.materialIndex = C;
      }
    }
    return o;
  }
  raycastFirst(t, i = xA) {
    const n = this._roots, s = this.geometry, o = i.isMaterial, r = Array.isArray(i);
    let l = null;
    const c = s.groups, h = o ? i.side : i, I = this.indirect ? MZe : SZe;
    for (let p = 0, y = n.length; p < y; p++) {
      const m = r ? i[c[p].materialIndex].side : h, A = I(this, p, m, t);
      A != null && (l == null || A.distance < l.distance) && (l = A, r && (A.face.materialIndex = c[p].materialIndex));
    }
    return l;
  }
  intersectsGeometry(t, i) {
    let n = !1;
    const s = this._roots, o = this.indirect ? UZe : bZe;
    for (let r = 0, l = s.length; r < l && (n = o(this, r, t, i), !n); r++)
      ;
    return n;
  }
  shapecast(t) {
    const i = D5.getPrimitive(), n = this.indirect ? RZe : EZe;
    let {
      boundsTraverseOrder: s,
      intersectsBounds: o,
      intersectsRange: r,
      intersectsTriangle: l
    } = t;
    if (r && l) {
      const p = r;
      r = (y, m, A, C, O) => p(y, m, A, C, O) ? !0 : n(y, m, this, l, A, C, i);
    } else r || (l ? r = (p, y, m, A) => n(p, y, this, l, m, A, i) : r = (p, y, m) => m);
    let c = !1, h = 0;
    const I = this._roots;
    for (let p = 0, y = I.length; p < y; p++) {
      const m = I[p];
      if (c = hZe(this, p, o, r, s, h), c)
        break;
      h += m.byteLength;
    }
    return D5.releasePrimitive(i), c;
  }
  bvhcast(t, i, n) {
    let {
      intersectsRanges: s,
      intersectsTriangles: o
    } = n;
    const r = D5.getPrimitive(), l = this.geometry.index, c = this.geometry.attributes.position, h = this.indirect ? (A) => {
      const C = this.resolveTriangleIndex(A);
      dh(r, C * 3, l, c);
    } : (A) => {
      dh(r, A * 3, l, c);
    }, I = D5.getPrimitive(), p = t.geometry.index, y = t.geometry.attributes.position, m = t.indirect ? (A) => {
      const C = t.resolveTriangleIndex(A);
      dh(I, C * 3, p, y);
    } : (A) => {
      dh(I, A * 3, p, y);
    };
    if (o) {
      const A = (C, O, R, F, L, P, z, W) => {
        for (let re = R, ce = R + F; re < ce; re++) {
          m(re), I.a.applyMatrix4(i), I.b.applyMatrix4(i), I.c.applyMatrix4(i), I.needsUpdate = !0;
          for (let te = C, ee = C + O; te < ee; te++)
            if (h(te), r.needsUpdate = !0, o(r, I, te, re, L, P, z, W))
              return !0;
        }
        return !1;
      };
      if (s) {
        const C = s;
        s = function(O, R, F, L, P, z, W, re) {
          return C(O, R, F, L, P, z, W, re) ? !0 : A(O, R, F, L, P, z, W, re);
        };
      } else
        s = A;
    }
    return zZe(this, t, i, s);
  }
  /* Derived Cast Functions */
  intersectsBox(t, i) {
    return Mse.set(t.min, t.max, i), Mse.needsUpdate = !0, this.shapecast(
      {
        intersectsBounds: (n) => Mse.intersectsBox(n),
        intersectsTriangle: (n) => Mse.intersectsTriangle(n)
      }
    );
  }
  intersectsSphere(t) {
    return this.shapecast(
      {
        intersectsBounds: (i) => t.intersectsBox(i),
        intersectsTriangle: (i) => i.intersectsSphere(t)
      }
    );
  }
  closestPointToGeometry(t, i, n = {}, s = {}, o = 0, r = 1 / 0) {
    return (this.indirect ? kZe : LZe)(
      this,
      t,
      i,
      n,
      s,
      o,
      r
    );
  }
  closestPointToPoint(t, i = {}, n = 0, s = 1 / 0) {
    return fZe(
      this,
      t,
      i,
      n,
      s
    );
  }
  getBoundingBox(t) {
    return t.makeEmpty(), this._roots.forEach((n) => {
      ud(0, new Float32Array(n), I2e), t.union(I2e);
    }), t;
  }
}
function p2e(e, t, i) {
  return e === null || (e.point.applyMatrix4(t.matrixWorld), e.distance = e.point.distanceTo(i.ray.origin), e.object = t, e.distance < i.near || e.distance > i.far) ? null : e;
}
const kce = /* @__PURE__ */ new MA(), m2e = /* @__PURE__ */ new Ln(), jZe = En.prototype.raycast;
function WZe(e, t) {
  if (this.geometry.boundsTree) {
    if (this.material === void 0)
      return;
    m2e.copy(this.matrixWorld).invert(), kce.copy(e.ray).applyMatrix4(m2e);
    const i = this.geometry.boundsTree;
    if (e.firstHitOnly === !0) {
      const n = p2e(i.raycastFirst(kce, this.material), this, e);
      n && t.push(n);
    } else {
      const n = i.raycast(kce, this.material);
      for (let s = 0, o = n.length; s < o; s++) {
        const r = p2e(n[s], this, e);
        r && t.push(r);
      }
    }
  } else
    jZe.call(this, e, t);
}
function YZe(e) {
  return this.boundsTree = new Hme(this, e), this.boundsTree;
}
function qZe() {
  this.boundsTree = null;
}
const Wbe = class Ybe {
  constructor() {
    tt(this, "onDisposed", new es()), tt(this, "list", new f0()), tt(this, "enabled", !1), tt(this, "_clock"), tt(this, "onInit", new es()), tt(this, "update", () => {
      if (!this.enabled)
        return;
      const t = this._clock.getDelta();
      for (const [i, n] of this.list)
        n.enabled && n.isUpdateable() && n.update(t);
      requestAnimationFrame(this.update);
    }), this._clock = new OUe(), Ybe.setupBVH();
  }
  /**
   * Adds a component to the list of components.
   * Throws an error if a component with the same UUID already exists.
   *
   * @param uuid - The unique identifier of the component.
   * @param instance - The instance of the component to be added.
   *
   * @throws Will throw an error if a component with the same UUID already exists.
   */
  add(t, i) {
    if (this.list.has(t))
      throw new Error(
        "You're trying to add a component that already exists in the components instance. Use Components.get() instead."
      );
    y4.validate(t), this.list.set(t, i);
  }
  /**
   * Retrieves a component instance by its constructor function.
   * If the component does not exist in the list, it will be created and added.
   *
   * @template U - The type of the component to retrieve.
   * @param Component - The constructor function of the component to retrieve.
   *
   * @returns The instance of the requested component.
   *
   * @throws Will throw an error if a component with the same UUID already exists.
   */
  get(t) {
    var i;
    const n = t.uuid;
    if (!this.list.has(n)) {
      const s = new t(this);
      return (i = s.isDisposeable) != null && i.call(s) && s.onDisposed.add(() => this.list.delete(n)), this.list.has(n) || this.add(n, s), s;
    }
    return this.list.get(n);
  }
  /**
   * Initializes the Components instance.
   * This method starts the animation loop, sets the enabled flag to true,
   * and calls the update method.
   */
  init() {
    this.enabled = !0;
    for (const [t, i] of this.list.entries())
      i.enabled = !0;
    this._clock.start(), this.update(), this.onInit.trigger();
  }
  /**
   * Disposes the memory of all the components and tools of this instance of
   * the library. A memory leak will be created if:
   *
   * - An instance of the library ends up out of scope and this function isn't
   * called. This is especially relevant in Single Page Applications (React,
   * Angular, Vue, etc).
   *
   * - Any of the objects of this instance (meshes, geometries,materials, etc) is
   * referenced by a reference type (object or array).
   *
   * You can learn more about how Three.js handles memory leaks
   * [here](https://threejs.org/docs/#manual/en/introduction/How-to-dispose-of-objects).
   *
   */
  dispose() {
    this.enabled = !1;
    let t;
    for (const [i, n] of this.list) {
      if (n.enabled = !1, i === Io.uuid) {
        t = n;
        continue;
      }
      n.isDisposeable() && n.dispose();
    }
    t == null || t.dispose(), this._clock.stop(), this.onDisposed.trigger();
  }
  static setupBVH() {
    Vl.prototype.computeBoundsTree = YZe, Vl.prototype.disposeBoundsTree = qZe, En.prototype.raycast = WZe;
  }
};
tt(Wbe, "release", "2.4.3");
let Gme = Wbe;
class $Ze {
  constructor(t) {
    tt(this, "enabled", !1), tt(this, "id", "FirstPerson"), this.camera = t;
  }
  /** {@link NavigationMode.set} */
  set(t) {
    if (this.enabled = t, t) {
      if (this.camera.projection.current !== "Perspective") {
        this.camera.set("Orbit");
        return;
      }
      this.setupFirstPersonCamera();
    }
  }
  setupFirstPersonCamera() {
    const t = this.camera.controls, i = new Ge();
    t.distance--, t.getPosition(i), t.minDistance = 1, t.maxDistance = 1, t.distance = 1, t.moveTo(
      i.x,
      i.y,
      i.z
    ), t.truckSpeed = 50, t.mouseButtons.wheel = c3.ACTION.DOLLY, t.touches.two = c3.ACTION.TOUCH_ZOOM_TRUCK;
  }
}
class KZe {
  constructor(t) {
    tt(this, "enabled", !0), tt(this, "id", "Orbit"), this.camera = t, this.activateOrbitControls();
  }
  /** {@link NavigationMode.set} */
  set(t) {
    this.enabled = t, t && this.activateOrbitControls();
  }
  activateOrbitControls() {
    const t = this.camera.controls;
    t.minDistance = 1, t.maxDistance = 300;
    const i = new Ge();
    t.getPosition(i);
    const n = i.length();
    t.distance = n, t.truckSpeed = 2;
    const { rotation: s } = this.camera.three, o = new Ge(0, 0, -1).applyEuler(s), r = i.addScaledVector(o, n);
    t.moveTo(r.x, r.y, r.z);
  }
}
class ZZe {
  constructor(t) {
    tt(this, "enabled", !1), tt(this, "id", "Plan"), tt(this, "mouseAction1"), tt(this, "mouseAction2"), tt(this, "mouseInitialized", !1), tt(this, "defaultAzimuthSpeed"), tt(this, "defaultPolarSpeed"), this.camera = t, this.defaultAzimuthSpeed = t.controls.azimuthRotateSpeed, this.defaultPolarSpeed = t.controls.polarRotateSpeed;
  }
  /** {@link NavigationMode.set} */
  set(t) {
    this.enabled = t;
    const i = this.camera.controls;
    i.azimuthRotateSpeed = t ? 0 : this.defaultAzimuthSpeed, i.polarRotateSpeed = t ? 0 : this.defaultPolarSpeed, this.mouseInitialized || (this.mouseAction1 = i.touches.one, this.mouseAction2 = i.touches.two, this.mouseInitialized = !0), t ? (i.mouseButtons.left = c3.ACTION.TRUCK, i.touches.one = c3.ACTION.TOUCH_TRUCK, i.touches.two = c3.ACTION.TOUCH_ZOOM) : (i.mouseButtons.left = c3.ACTION.ROTATE, i.touches.one = this.mouseAction1, i.touches.two = this.mouseAction2);
  }
}
class QZe {
  constructor(t) {
    tt(this, "onChanged", new es()), tt(this, "current", "Perspective"), tt(this, "camera"), tt(this, "matchOrthoDistanceEnabled", !1), tt(this, "_component"), tt(this, "_previousDistance", -1), this._component = t, this.camera = t.three;
  }
  /**
   * Sets the {@link CameraProjection} of the {@link OrthoPerspectiveCamera}.
   *
   * @param projection - the new projection to set. If it is the current projection,
   * it will have no effect.
   */
  async set(t) {
    this.current !== t && (t === "Orthographic" ? this.setOrthoCamera() : await this.setPerspectiveCamera(), this.onChanged.trigger(this.camera));
  }
  /**
   * Changes the current {@link CameraProjection} from Ortographic to Perspective
   * and vice versa.
   */
  async toggle() {
    const i = this.current === "Perspective" ? "Orthographic" : "Perspective";
    await this.set(i);
  }
  setOrthoCamera() {
    if (this._component.mode === null || this._component.mode.id === "FirstPerson")
      return;
    this._previousDistance = this._component.controls.distance, this._component.controls.distance = 200;
    const t = this.getPerspectiveDims();
    if (!t)
      return;
    const { width: i, height: n } = t;
    this.setupOrthoCamera(n, i), this.camera = this._component.threeOrtho, this.current = "Orthographic";
  }
  getPerspectiveDims() {
    const t = this._component.currentWorld;
    if (!t || !t.renderer)
      return null;
    const i = new Ge();
    this._component.threePersp.getWorldDirection(i);
    const n = new Ge();
    this._component.controls.getTarget(n);
    const o = n.clone().sub(this._component.threePersp.position).dot(i), r = t.renderer.getSize(), l = r.x / r.y, c = this._component.threePersp, h = o * 2 * Math.atan(c.fov * (Math.PI / 180) / 2);
    return { width: h * l, height: h };
  }
  setupOrthoCamera(t, i) {
    this._component.controls.mouseButtons.wheel = c3.ACTION.ZOOM, this._component.controls.mouseButtons.middle = c3.ACTION.ZOOM;
    const n = this._component.threePersp, s = this._component.threeOrtho;
    s.zoom = 1, s.left = i / -2, s.right = i / 2, s.top = t / 2, s.bottom = t / -2, s.updateProjectionMatrix(), s.position.copy(n.position), s.quaternion.copy(n.quaternion), this._component.controls.camera = s;
  }
  getDistance() {
    const t = this._component.threePersp, i = this._component.threeOrtho;
    return (i.top - i.bottom) / i.zoom / (2 * Math.atan(t.fov * (Math.PI / 180) / 2));
  }
  async setPerspectiveCamera() {
    this._component.controls.mouseButtons.wheel = c3.ACTION.DOLLY, this._component.controls.mouseButtons.middle = c3.ACTION.DOLLY;
    const t = this._component.threePersp, i = this._component.threeOrtho;
    t.position.copy(i.position), t.quaternion.copy(i.quaternion), this._component.controls.mouseButtons.wheel = c3.ACTION.DOLLY, this.matchOrthoDistanceEnabled ? this._component.controls.distance = this.getDistance() : this._component.controls.distance = this._previousDistance, await this._component.controls.zoomTo(1), t.updateProjectionMatrix(), this._component.controls.camera = t, this.camera = t, this.current = "Perspective";
  }
}
class qbe extends qW {
  constructor(t) {
    super(t), tt(this, "projection"), tt(this, "threeOrtho"), tt(this, "threePersp"), tt(this, "_userInputButtons", {}), tt(this, "_frustumSize", 50), tt(this, "_navigationModes", /* @__PURE__ */ new Map()), tt(this, "_mode", null), tt(this, "previousSize", null), this.threePersp = this.three, this.threeOrtho = this.newOrthoCamera(), this.projection = new QZe(this), this.onAspectUpdated.add(() => {
      this.setOrthoPerspCameraAspect();
    }), this.projection.onChanged.add(
      (i) => {
        this.three = i, this.updateAspect();
      }
    ), this.worlds.onItemSet.add(() => {
      this._navigationModes.clear(), this._navigationModes.set("Orbit", new KZe(this)), this._navigationModes.set("FirstPerson", new $Ze(this)), this._navigationModes.set("Plan", new ZZe(this)), this._mode = this._navigationModes.get("Orbit"), this.mode.set(!0, { preventTargetAdjustment: !0 }), this.currentWorld && this.currentWorld.renderer && (this.previousSize = this.currentWorld.renderer.getSize().clone());
    }), this.worlds.onItemDeleted.add(() => {
      this._navigationModes.clear();
    });
  }
  /**
   * Getter for the current navigation mode.
   * Throws an error if the mode is not found or the camera is not initialized.
   *
   * @returns {NavigationMode} The current navigation mode.
   *
   * @throws {Error} Throws an error if the mode is not found or the camera is not initialized.
   */
  get mode() {
    if (!this._mode)
      throw new Error("Mode not found, camera not initialized");
    return this._mode;
  }
  /** {@link Disposable.dispose} */
  dispose() {
    super.dispose(), this.threeOrtho.removeFromParent();
  }
  /**
   * Sets a new {@link NavigationMode} and disables the previous one.
   *
   * @param mode - The {@link NavigationMode} to set.
   */
  set(t) {
    if (this.mode !== null && this.mode.id !== t) {
      if (this.mode.set(!1), !this._navigationModes.has(t))
        throw new Error("The specified mode does not exist!");
      this._mode = this._navigationModes.get(t), this.mode.set(!0);
    }
  }
  /**
   * Make the camera view fit all the specified meshes.
   *
   * @param meshes the meshes to fit. If it is not defined, it will
   * evaluate {@link Components.meshes}.
   * @param offset the distance to the fit object
   */
  async fit(t, i = 1.5) {
    if (!this.enabled)
      return;
    const n = Number.MAX_VALUE, s = Number.MIN_VALUE, o = new Ge(n, n, n), r = new Ge(s, s, s);
    for (const m of t) {
      const A = new Zs().setFromObject(m);
      A.min.x < o.x && (o.x = A.min.x), A.min.y < o.y && (o.y = A.min.y), A.min.z < o.z && (o.z = A.min.z), A.max.x > r.x && (r.x = A.max.x), A.max.y > r.y && (r.y = A.max.y), A.max.z > r.z && (r.z = A.max.z);
    }
    const l = new Zs(o, r), c = this.components.get(Io);
    if (c.initialized)
      for (const [, m] of c.list) {
        const A = m.box;
        A.min.x < o.x && (o.x = A.min.x), A.min.y < o.y && (o.y = A.min.y), A.min.z < o.z && (o.z = A.min.z), A.max.x > r.x && (r.x = A.max.x), A.max.y > r.y && (r.y = A.max.y), A.max.z > r.z && (r.z = A.max.z);
      }
    const h = new Ge();
    l.getSize(h);
    const I = new Ge();
    l.getCenter(I);
    const p = Math.max(h.x, h.y, h.z) * i, y = new f3(I, p);
    await this.controls.fitToSphere(y, !0);
  }
  /**
   * Allows or prevents all user input.
   *
   * @param active - whether to enable or disable user inputs.
   */
  setUserInput(t) {
    t ? this.enableUserInput() : this.disableUserInput();
  }
  /**
   * Adds a custom {@link NavigationMode} to the camera that can be used using the {@link OrthoPerspectiveCamera.set} method.
   *
   * @param mode - The custom {@link NavigationMode} to add.
   */
  addCustomNavigationMode(t) {
    this._navigationModes.set(t.id, t);
  }
  disableUserInput() {
    this._userInputButtons.left = this.controls.mouseButtons.left, this._userInputButtons.right = this.controls.mouseButtons.right, this._userInputButtons.middle = this.controls.mouseButtons.middle, this._userInputButtons.wheel = this.controls.mouseButtons.wheel, this.controls.mouseButtons.left = 0, this.controls.mouseButtons.right = 0, this.controls.mouseButtons.middle = 0, this.controls.mouseButtons.wheel = 0;
  }
  enableUserInput() {
    Object.keys(this._userInputButtons).length !== 0 && (this.controls.mouseButtons.left = this._userInputButtons.left, this.controls.mouseButtons.right = this._userInputButtons.right, this.controls.mouseButtons.middle = this._userInputButtons.middle, this.controls.mouseButtons.wheel = this._userInputButtons.wheel);
  }
  newOrthoCamera() {
    const t = window.innerWidth / window.innerHeight;
    return new eY(
      this._frustumSize * t / -2,
      this._frustumSize * t / 2,
      this._frustumSize / 2,
      this._frustumSize / -2,
      0.1,
      1e3
    );
  }
  setOrthoPerspCameraAspect() {
    if (!this.currentWorld || !this.currentWorld.renderer || !this.previousSize)
      return;
    const t = this.currentWorld.renderer.getSize(), i = this.threeOrtho.top, n = this.threeOrtho.right, s = t.y / this.previousSize.y, o = t.x / this.previousSize.x, r = i * s, l = n * o;
    this.threeOrtho.left = -l, this.threeOrtho.right = l, this.threeOrtho.top = r, this.threeOrtho.bottom = -r, this.threeOrtho.updateProjectionMatrix(), this.previousSize.copy(t);
  }
}
function Use(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var $be = { exports: {} };
/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/
(function(e, t) {
  (function(i) {
    e.exports = i();
  })(function() {
    return (function i(n, s, o) {
      function r(h, I) {
        if (!s[h]) {
          if (!n[h]) {
            var p = typeof Use == "function" && Use;
            if (!I && p)
              return p(h, !0);
            if (l)
              return l(h, !0);
            var y = new Error("Cannot find module '" + h + "'");
            throw y.code = "MODULE_NOT_FOUND", y;
          }
          var m = s[h] = { exports: {} };
          n[h][0].call(m.exports, function(A) {
            var C = n[h][1][A];
            return r(C || A);
          }, m, m.exports, i, n, s, o);
        }
        return s[h].exports;
      }
      for (var l = typeof Use == "function" && Use, c = 0; c < o.length; c++)
        r(o[c]);
      return r;
    })({ 1: [function(i, n, s) {
      var o = i("./utils"), r = i("./support"), l = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
      s.encode = function(c) {
        for (var h, I, p, y, m, A, C, O = [], R = 0, F = c.length, L = F, P = o.getTypeOf(c) !== "string"; R < c.length; )
          L = F - R, p = P ? (h = c[R++], I = R < F ? c[R++] : 0, R < F ? c[R++] : 0) : (h = c.charCodeAt(R++), I = R < F ? c.charCodeAt(R++) : 0, R < F ? c.charCodeAt(R++) : 0), y = h >> 2, m = (3 & h) << 4 | I >> 4, A = 1 < L ? (15 & I) << 2 | p >> 6 : 64, C = 2 < L ? 63 & p : 64, O.push(l.charAt(y) + l.charAt(m) + l.charAt(A) + l.charAt(C));
        return O.join("");
      }, s.decode = function(c) {
        var h, I, p, y, m, A, C = 0, O = 0, R = "data:";
        if (c.substr(0, R.length) === R)
          throw new Error("Invalid base64 input, it looks like a data url.");
        var F, L = 3 * (c = c.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
        if (c.charAt(c.length - 1) === l.charAt(64) && L--, c.charAt(c.length - 2) === l.charAt(64) && L--, L % 1 != 0)
          throw new Error("Invalid base64 input, bad content length.");
        for (F = r.uint8array ? new Uint8Array(0 | L) : new Array(0 | L); C < c.length; )
          h = l.indexOf(c.charAt(C++)) << 2 | (y = l.indexOf(c.charAt(C++))) >> 4, I = (15 & y) << 4 | (m = l.indexOf(c.charAt(C++))) >> 2, p = (3 & m) << 6 | (A = l.indexOf(c.charAt(C++))), F[O++] = h, m !== 64 && (F[O++] = I), A !== 64 && (F[O++] = p);
        return F;
      };
    }, { "./support": 30, "./utils": 32 }], 2: [function(i, n, s) {
      var o = i("./external"), r = i("./stream/DataWorker"), l = i("./stream/Crc32Probe"), c = i("./stream/DataLengthProbe");
      function h(I, p, y, m, A) {
        this.compressedSize = I, this.uncompressedSize = p, this.crc32 = y, this.compression = m, this.compressedContent = A;
      }
      h.prototype = { getContentWorker: function() {
        var I = new r(o.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new c("data_length")), p = this;
        return I.on("end", function() {
          if (this.streamInfo.data_length !== p.uncompressedSize)
            throw new Error("Bug : uncompressed data size mismatch");
        }), I;
      }, getCompressedWorker: function() {
        return new r(o.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
      } }, h.createWorkerFrom = function(I, p, y) {
        return I.pipe(new l()).pipe(new c("uncompressedSize")).pipe(p.compressWorker(y)).pipe(new c("compressedSize")).withStreamInfo("compression", p);
      }, n.exports = h;
    }, { "./external": 6, "./stream/Crc32Probe": 25, "./stream/DataLengthProbe": 26, "./stream/DataWorker": 27 }], 3: [function(i, n, s) {
      var o = i("./stream/GenericWorker");
      s.STORE = { magic: "\0\0", compressWorker: function() {
        return new o("STORE compression");
      }, uncompressWorker: function() {
        return new o("STORE decompression");
      } }, s.DEFLATE = i("./flate");
    }, { "./flate": 7, "./stream/GenericWorker": 28 }], 4: [function(i, n, s) {
      var o = i("./utils"), r = (function() {
        for (var l, c = [], h = 0; h < 256; h++) {
          l = h;
          for (var I = 0; I < 8; I++)
            l = 1 & l ? 3988292384 ^ l >>> 1 : l >>> 1;
          c[h] = l;
        }
        return c;
      })();
      n.exports = function(l, c) {
        return l !== void 0 && l.length ? o.getTypeOf(l) !== "string" ? (function(h, I, p, y) {
          var m = r, A = y + p;
          h ^= -1;
          for (var C = y; C < A; C++)
            h = h >>> 8 ^ m[255 & (h ^ I[C])];
          return -1 ^ h;
        })(0 | c, l, l.length, 0) : (function(h, I, p, y) {
          var m = r, A = y + p;
          h ^= -1;
          for (var C = y; C < A; C++)
            h = h >>> 8 ^ m[255 & (h ^ I.charCodeAt(C))];
          return -1 ^ h;
        })(0 | c, l, l.length, 0) : 0;
      };
    }, { "./utils": 32 }], 5: [function(i, n, s) {
      s.base64 = !1, s.binary = !1, s.dir = !1, s.createFolders = !0, s.date = null, s.compression = null, s.compressionOptions = null, s.comment = null, s.unixPermissions = null, s.dosPermissions = null;
    }, {}], 6: [function(i, n, s) {
      var o = null;
      o = typeof Promise < "u" ? Promise : i("lie"), n.exports = { Promise: o };
    }, { lie: 37 }], 7: [function(i, n, s) {
      var o = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Uint32Array < "u", r = i("pako"), l = i("./utils"), c = i("./stream/GenericWorker"), h = o ? "uint8array" : "array";
      function I(p, y) {
        c.call(this, "FlateWorker/" + p), this._pako = null, this._pakoAction = p, this._pakoOptions = y, this.meta = {};
      }
      s.magic = "\b\0", l.inherits(I, c), I.prototype.processChunk = function(p) {
        this.meta = p.meta, this._pako === null && this._createPako(), this._pako.push(l.transformTo(h, p.data), !1);
      }, I.prototype.flush = function() {
        c.prototype.flush.call(this), this._pako === null && this._createPako(), this._pako.push([], !0);
      }, I.prototype.cleanUp = function() {
        c.prototype.cleanUp.call(this), this._pako = null;
      }, I.prototype._createPako = function() {
        this._pako = new r[this._pakoAction]({ raw: !0, level: this._pakoOptions.level || -1 });
        var p = this;
        this._pako.onData = function(y) {
          p.push({ data: y, meta: p.meta });
        };
      }, s.compressWorker = function(p) {
        return new I("Deflate", p);
      }, s.uncompressWorker = function() {
        return new I("Inflate", {});
      };
    }, { "./stream/GenericWorker": 28, "./utils": 32, pako: 38 }], 8: [function(i, n, s) {
      function o(m, A) {
        var C, O = "";
        for (C = 0; C < A; C++)
          O += String.fromCharCode(255 & m), m >>>= 8;
        return O;
      }
      function r(m, A, C, O, R, F) {
        var L, P, z = m.file, W = m.compression, re = F !== h.utf8encode, ce = l.transformTo("string", F(z.name)), te = l.transformTo("string", h.utf8encode(z.name)), ee = z.comment, Ne = l.transformTo("string", F(ee)), Ae = l.transformTo("string", h.utf8encode(ee)), Oe = te.length !== z.name.length, pe = Ae.length !== ee.length, je = "", Ve = "", $e = "", vt = z.dir, Rt = z.date, ze = { crc32: 0, compressedSize: 0, uncompressedSize: 0 };
        A && !C || (ze.crc32 = m.crc32, ze.compressedSize = m.compressedSize, ze.uncompressedSize = m.uncompressedSize);
        var mt = 0;
        A && (mt |= 8), re || !Oe && !pe || (mt |= 2048);
        var Et = 0, it = 0;
        vt && (Et |= 16), R === "UNIX" ? (it = 798, Et |= (function(Ct, Kt) {
          var Zt = Ct;
          return Ct || (Zt = Kt ? 16893 : 33204), (65535 & Zt) << 16;
        })(z.unixPermissions, vt)) : (it = 20, Et |= (function(Ct) {
          return 63 & (Ct || 0);
        })(z.dosPermissions)), L = Rt.getUTCHours(), L <<= 6, L |= Rt.getUTCMinutes(), L <<= 5, L |= Rt.getUTCSeconds() / 2, P = Rt.getUTCFullYear() - 1980, P <<= 4, P |= Rt.getUTCMonth() + 1, P <<= 5, P |= Rt.getUTCDate(), Oe && (Ve = o(1, 1) + o(I(ce), 4) + te, je += "up" + o(Ve.length, 2) + Ve), pe && ($e = o(1, 1) + o(I(Ne), 4) + Ae, je += "uc" + o($e.length, 2) + $e);
        var Dt = "";
        return Dt += `
\0`, Dt += o(mt, 2), Dt += W.magic, Dt += o(L, 2), Dt += o(P, 2), Dt += o(ze.crc32, 4), Dt += o(ze.compressedSize, 4), Dt += o(ze.uncompressedSize, 4), Dt += o(ce.length, 2), Dt += o(je.length, 2), { fileRecord: p.LOCAL_FILE_HEADER + Dt + ce + je, dirRecord: p.CENTRAL_FILE_HEADER + o(it, 2) + Dt + o(Ne.length, 2) + "\0\0\0\0" + o(Et, 4) + o(O, 4) + ce + je + Ne };
      }
      var l = i("../utils"), c = i("../stream/GenericWorker"), h = i("../utf8"), I = i("../crc32"), p = i("../signature");
      function y(m, A, C, O) {
        c.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = A, this.zipPlatform = C, this.encodeFileName = O, this.streamFiles = m, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
      }
      l.inherits(y, c), y.prototype.push = function(m) {
        var A = m.meta.percent || 0, C = this.entriesCount, O = this._sources.length;
        this.accumulate ? this.contentBuffer.push(m) : (this.bytesWritten += m.data.length, c.prototype.push.call(this, { data: m.data, meta: { currentFile: this.currentFile, percent: C ? (A + 100 * (C - O - 1)) / C : 100 } }));
      }, y.prototype.openedSource = function(m) {
        this.currentSourceOffset = this.bytesWritten, this.currentFile = m.file.name;
        var A = this.streamFiles && !m.file.dir;
        if (A) {
          var C = r(m, A, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
          this.push({ data: C.fileRecord, meta: { percent: 0 } });
        } else
          this.accumulate = !0;
      }, y.prototype.closedSource = function(m) {
        this.accumulate = !1;
        var A = this.streamFiles && !m.file.dir, C = r(m, A, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
        if (this.dirRecords.push(C.dirRecord), A)
          this.push({ data: (function(O) {
            return p.DATA_DESCRIPTOR + o(O.crc32, 4) + o(O.compressedSize, 4) + o(O.uncompressedSize, 4);
          })(m), meta: { percent: 100 } });
        else
          for (this.push({ data: C.fileRecord, meta: { percent: 0 } }); this.contentBuffer.length; )
            this.push(this.contentBuffer.shift());
        this.currentFile = null;
      }, y.prototype.flush = function() {
        for (var m = this.bytesWritten, A = 0; A < this.dirRecords.length; A++)
          this.push({ data: this.dirRecords[A], meta: { percent: 100 } });
        var C = this.bytesWritten - m, O = (function(R, F, L, P, z) {
          var W = l.transformTo("string", z(P));
          return p.CENTRAL_DIRECTORY_END + "\0\0\0\0" + o(R, 2) + o(R, 2) + o(F, 4) + o(L, 4) + o(W.length, 2) + W;
        })(this.dirRecords.length, C, m, this.zipComment, this.encodeFileName);
        this.push({ data: O, meta: { percent: 100 } });
      }, y.prototype.prepareNextSource = function() {
        this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
      }, y.prototype.registerPrevious = function(m) {
        this._sources.push(m);
        var A = this;
        return m.on("data", function(C) {
          A.processChunk(C);
        }), m.on("end", function() {
          A.closedSource(A.previous.streamInfo), A._sources.length ? A.prepareNextSource() : A.end();
        }), m.on("error", function(C) {
          A.error(C);
        }), this;
      }, y.prototype.resume = function() {
        return !!c.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
      }, y.prototype.error = function(m) {
        var A = this._sources;
        if (!c.prototype.error.call(this, m))
          return !1;
        for (var C = 0; C < A.length; C++)
          try {
            A[C].error(m);
          } catch {
          }
        return !0;
      }, y.prototype.lock = function() {
        c.prototype.lock.call(this);
        for (var m = this._sources, A = 0; A < m.length; A++)
          m[A].lock();
      }, n.exports = y;
    }, { "../crc32": 4, "../signature": 23, "../stream/GenericWorker": 28, "../utf8": 31, "../utils": 32 }], 9: [function(i, n, s) {
      var o = i("../compressions"), r = i("./ZipFileWorker");
      s.generateWorker = function(l, c, h) {
        var I = new r(c.streamFiles, h, c.platform, c.encodeFileName), p = 0;
        try {
          l.forEach(function(y, m) {
            p++;
            var A = (function(F, L) {
              var P = F || L, z = o[P];
              if (!z)
                throw new Error(P + " is not a valid compression method !");
              return z;
            })(m.options.compression, c.compression), C = m.options.compressionOptions || c.compressionOptions || {}, O = m.dir, R = m.date;
            m._compressWorker(A, C).withStreamInfo("file", { name: y, dir: O, date: R, comment: m.comment || "", unixPermissions: m.unixPermissions, dosPermissions: m.dosPermissions }).pipe(I);
          }), I.entriesCount = p;
        } catch (y) {
          I.error(y);
        }
        return I;
      };
    }, { "../compressions": 3, "./ZipFileWorker": 8 }], 10: [function(i, n, s) {
      function o() {
        if (!(this instanceof o))
          return new o();
        if (arguments.length)
          throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
        this.files = /* @__PURE__ */ Object.create(null), this.comment = null, this.root = "", this.clone = function() {
          var r = new o();
          for (var l in this)
            typeof this[l] != "function" && (r[l] = this[l]);
          return r;
        };
      }
      (o.prototype = i("./object")).loadAsync = i("./load"), o.support = i("./support"), o.defaults = i("./defaults"), o.version = "3.10.1", o.loadAsync = function(r, l) {
        return new o().loadAsync(r, l);
      }, o.external = i("./external"), n.exports = o;
    }, { "./defaults": 5, "./external": 6, "./load": 11, "./object": 15, "./support": 30 }], 11: [function(i, n, s) {
      var o = i("./utils"), r = i("./external"), l = i("./utf8"), c = i("./zipEntries"), h = i("./stream/Crc32Probe"), I = i("./nodejsUtils");
      function p(y) {
        return new r.Promise(function(m, A) {
          var C = y.decompressed.getContentWorker().pipe(new h());
          C.on("error", function(O) {
            A(O);
          }).on("end", function() {
            C.streamInfo.crc32 !== y.decompressed.crc32 ? A(new Error("Corrupted zip : CRC32 mismatch")) : m();
          }).resume();
        });
      }
      n.exports = function(y, m) {
        var A = this;
        return m = o.extend(m || {}, { base64: !1, checkCRC32: !1, optimizedBinaryString: !1, createFolders: !1, decodeFileName: l.utf8decode }), I.isNode && I.isStream(y) ? r.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : o.prepareContent("the loaded zip file", y, !0, m.optimizedBinaryString, m.base64).then(function(C) {
          var O = new c(m);
          return O.load(C), O;
        }).then(function(C) {
          var O = [r.Promise.resolve(C)], R = C.files;
          if (m.checkCRC32)
            for (var F = 0; F < R.length; F++)
              O.push(p(R[F]));
          return r.Promise.all(O);
        }).then(function(C) {
          for (var O = C.shift(), R = O.files, F = 0; F < R.length; F++) {
            var L = R[F], P = L.fileNameStr, z = o.resolve(L.fileNameStr);
            A.file(z, L.decompressed, { binary: !0, optimizedBinaryString: !0, date: L.date, dir: L.dir, comment: L.fileCommentStr.length ? L.fileCommentStr : null, unixPermissions: L.unixPermissions, dosPermissions: L.dosPermissions, createFolders: m.createFolders }), L.dir || (A.file(z).unsafeOriginalName = P);
          }
          return O.zipComment.length && (A.comment = O.zipComment), A;
        });
      };
    }, { "./external": 6, "./nodejsUtils": 14, "./stream/Crc32Probe": 25, "./utf8": 31, "./utils": 32, "./zipEntries": 33 }], 12: [function(i, n, s) {
      var o = i("../utils"), r = i("../stream/GenericWorker");
      function l(c, h) {
        r.call(this, "Nodejs stream input adapter for " + c), this._upstreamEnded = !1, this._bindStream(h);
      }
      o.inherits(l, r), l.prototype._bindStream = function(c) {
        var h = this;
        (this._stream = c).pause(), c.on("data", function(I) {
          h.push({ data: I, meta: { percent: 0 } });
        }).on("error", function(I) {
          h.isPaused ? this.generatedError = I : h.error(I);
        }).on("end", function() {
          h.isPaused ? h._upstreamEnded = !0 : h.end();
        });
      }, l.prototype.pause = function() {
        return !!r.prototype.pause.call(this) && (this._stream.pause(), !0);
      }, l.prototype.resume = function() {
        return !!r.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
      }, n.exports = l;
    }, { "../stream/GenericWorker": 28, "../utils": 32 }], 13: [function(i, n, s) {
      var o = i("readable-stream").Readable;
      function r(l, c, h) {
        o.call(this, c), this._helper = l;
        var I = this;
        l.on("data", function(p, y) {
          I.push(p) || I._helper.pause(), h && h(y);
        }).on("error", function(p) {
          I.emit("error", p);
        }).on("end", function() {
          I.push(null);
        });
      }
      i("../utils").inherits(r, o), r.prototype._read = function() {
        this._helper.resume();
      }, n.exports = r;
    }, { "../utils": 32, "readable-stream": 16 }], 14: [function(i, n, s) {
      n.exports = { isNode: typeof Buffer < "u", newBufferFrom: function(o, r) {
        if (Buffer.from && Buffer.from !== Uint8Array.from)
          return Buffer.from(o, r);
        if (typeof o == "number")
          throw new Error('The "data" argument must not be a number');
        return new Buffer(o, r);
      }, allocBuffer: function(o) {
        if (Buffer.alloc)
          return Buffer.alloc(o);
        var r = new Buffer(o);
        return r.fill(0), r;
      }, isBuffer: function(o) {
        return Buffer.isBuffer(o);
      }, isStream: function(o) {
        return o && typeof o.on == "function" && typeof o.pause == "function" && typeof o.resume == "function";
      } };
    }, {}], 15: [function(i, n, s) {
      function o(z, W, re) {
        var ce, te = l.getTypeOf(W), ee = l.extend(re || {}, I);
        ee.date = ee.date || /* @__PURE__ */ new Date(), ee.compression !== null && (ee.compression = ee.compression.toUpperCase()), typeof ee.unixPermissions == "string" && (ee.unixPermissions = parseInt(ee.unixPermissions, 8)), ee.unixPermissions && 16384 & ee.unixPermissions && (ee.dir = !0), ee.dosPermissions && 16 & ee.dosPermissions && (ee.dir = !0), ee.dir && (z = R(z)), ee.createFolders && (ce = O(z)) && F.call(this, ce, !0);
        var Ne = te === "string" && ee.binary === !1 && ee.base64 === !1;
        re && re.binary !== void 0 || (ee.binary = !Ne), (W instanceof p && W.uncompressedSize === 0 || ee.dir || !W || W.length === 0) && (ee.base64 = !1, ee.binary = !0, W = "", ee.compression = "STORE", te = "string");
        var Ae = null;
        Ae = W instanceof p || W instanceof c ? W : A.isNode && A.isStream(W) ? new C(z, W) : l.prepareContent(z, W, ee.binary, ee.optimizedBinaryString, ee.base64);
        var Oe = new y(z, Ae, ee);
        this.files[z] = Oe;
      }
      var r = i("./utf8"), l = i("./utils"), c = i("./stream/GenericWorker"), h = i("./stream/StreamHelper"), I = i("./defaults"), p = i("./compressedObject"), y = i("./zipObject"), m = i("./generate"), A = i("./nodejsUtils"), C = i("./nodejs/NodejsStreamInputAdapter"), O = function(z) {
        z.slice(-1) === "/" && (z = z.substring(0, z.length - 1));
        var W = z.lastIndexOf("/");
        return 0 < W ? z.substring(0, W) : "";
      }, R = function(z) {
        return z.slice(-1) !== "/" && (z += "/"), z;
      }, F = function(z, W) {
        return W = W !== void 0 ? W : I.createFolders, z = R(z), this.files[z] || o.call(this, z, null, { dir: !0, createFolders: W }), this.files[z];
      };
      function L(z) {
        return Object.prototype.toString.call(z) === "[object RegExp]";
      }
      var P = { load: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, forEach: function(z) {
        var W, re, ce;
        for (W in this.files)
          ce = this.files[W], (re = W.slice(this.root.length, W.length)) && W.slice(0, this.root.length) === this.root && z(re, ce);
      }, filter: function(z) {
        var W = [];
        return this.forEach(function(re, ce) {
          z(re, ce) && W.push(ce);
        }), W;
      }, file: function(z, W, re) {
        if (arguments.length !== 1)
          return z = this.root + z, o.call(this, z, W, re), this;
        if (L(z)) {
          var ce = z;
          return this.filter(function(ee, Ne) {
            return !Ne.dir && ce.test(ee);
          });
        }
        var te = this.files[this.root + z];
        return te && !te.dir ? te : null;
      }, folder: function(z) {
        if (!z)
          return this;
        if (L(z))
          return this.filter(function(te, ee) {
            return ee.dir && z.test(te);
          });
        var W = this.root + z, re = F.call(this, W), ce = this.clone();
        return ce.root = re.name, ce;
      }, remove: function(z) {
        z = this.root + z;
        var W = this.files[z];
        if (W || (z.slice(-1) !== "/" && (z += "/"), W = this.files[z]), W && !W.dir)
          delete this.files[z];
        else
          for (var re = this.filter(function(te, ee) {
            return ee.name.slice(0, z.length) === z;
          }), ce = 0; ce < re.length; ce++)
            delete this.files[re[ce].name];
        return this;
      }, generate: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, generateInternalStream: function(z) {
        var W, re = {};
        try {
          if ((re = l.extend(z || {}, { streamFiles: !1, compression: "STORE", compressionOptions: null, type: "", platform: "DOS", comment: null, mimeType: "application/zip", encodeFileName: r.utf8encode })).type = re.type.toLowerCase(), re.compression = re.compression.toUpperCase(), re.type === "binarystring" && (re.type = "string"), !re.type)
            throw new Error("No output type specified.");
          l.checkSupport(re.type), re.platform !== "darwin" && re.platform !== "freebsd" && re.platform !== "linux" && re.platform !== "sunos" || (re.platform = "UNIX"), re.platform === "win32" && (re.platform = "DOS");
          var ce = re.comment || this.comment || "";
          W = m.generateWorker(this, re, ce);
        } catch (te) {
          (W = new c("error")).error(te);
        }
        return new h(W, re.type || "string", re.mimeType);
      }, generateAsync: function(z, W) {
        return this.generateInternalStream(z).accumulate(W);
      }, generateNodeStream: function(z, W) {
        return (z = z || {}).type || (z.type = "nodebuffer"), this.generateInternalStream(z).toNodejsStream(W);
      } };
      n.exports = P;
    }, { "./compressedObject": 2, "./defaults": 5, "./generate": 9, "./nodejs/NodejsStreamInputAdapter": 12, "./nodejsUtils": 14, "./stream/GenericWorker": 28, "./stream/StreamHelper": 29, "./utf8": 31, "./utils": 32, "./zipObject": 35 }], 16: [function(i, n, s) {
      n.exports = i("stream");
    }, { stream: void 0 }], 17: [function(i, n, s) {
      var o = i("./DataReader");
      function r(l) {
        o.call(this, l);
        for (var c = 0; c < this.data.length; c++)
          l[c] = 255 & l[c];
      }
      i("../utils").inherits(r, o), r.prototype.byteAt = function(l) {
        return this.data[this.zero + l];
      }, r.prototype.lastIndexOfSignature = function(l) {
        for (var c = l.charCodeAt(0), h = l.charCodeAt(1), I = l.charCodeAt(2), p = l.charCodeAt(3), y = this.length - 4; 0 <= y; --y)
          if (this.data[y] === c && this.data[y + 1] === h && this.data[y + 2] === I && this.data[y + 3] === p)
            return y - this.zero;
        return -1;
      }, r.prototype.readAndCheckSignature = function(l) {
        var c = l.charCodeAt(0), h = l.charCodeAt(1), I = l.charCodeAt(2), p = l.charCodeAt(3), y = this.readData(4);
        return c === y[0] && h === y[1] && I === y[2] && p === y[3];
      }, r.prototype.readData = function(l) {
        if (this.checkOffset(l), l === 0)
          return [];
        var c = this.data.slice(this.zero + this.index, this.zero + this.index + l);
        return this.index += l, c;
      }, n.exports = r;
    }, { "../utils": 32, "./DataReader": 18 }], 18: [function(i, n, s) {
      var o = i("../utils");
      function r(l) {
        this.data = l, this.length = l.length, this.index = 0, this.zero = 0;
      }
      r.prototype = { checkOffset: function(l) {
        this.checkIndex(this.index + l);
      }, checkIndex: function(l) {
        if (this.length < this.zero + l || l < 0)
          throw new Error("End of data reached (data length = " + this.length + ", asked index = " + l + "). Corrupted zip ?");
      }, setIndex: function(l) {
        this.checkIndex(l), this.index = l;
      }, skip: function(l) {
        this.setIndex(this.index + l);
      }, byteAt: function() {
      }, readInt: function(l) {
        var c, h = 0;
        for (this.checkOffset(l), c = this.index + l - 1; c >= this.index; c--)
          h = (h << 8) + this.byteAt(c);
        return this.index += l, h;
      }, readString: function(l) {
        return o.transformTo("string", this.readData(l));
      }, readData: function() {
      }, lastIndexOfSignature: function() {
      }, readAndCheckSignature: function() {
      }, readDate: function() {
        var l = this.readInt(4);
        return new Date(Date.UTC(1980 + (l >> 25 & 127), (l >> 21 & 15) - 1, l >> 16 & 31, l >> 11 & 31, l >> 5 & 63, (31 & l) << 1));
      } }, n.exports = r;
    }, { "../utils": 32 }], 19: [function(i, n, s) {
      var o = i("./Uint8ArrayReader");
      function r(l) {
        o.call(this, l);
      }
      i("../utils").inherits(r, o), r.prototype.readData = function(l) {
        this.checkOffset(l);
        var c = this.data.slice(this.zero + this.index, this.zero + this.index + l);
        return this.index += l, c;
      }, n.exports = r;
    }, { "../utils": 32, "./Uint8ArrayReader": 21 }], 20: [function(i, n, s) {
      var o = i("./DataReader");
      function r(l) {
        o.call(this, l);
      }
      i("../utils").inherits(r, o), r.prototype.byteAt = function(l) {
        return this.data.charCodeAt(this.zero + l);
      }, r.prototype.lastIndexOfSignature = function(l) {
        return this.data.lastIndexOf(l) - this.zero;
      }, r.prototype.readAndCheckSignature = function(l) {
        return l === this.readData(4);
      }, r.prototype.readData = function(l) {
        this.checkOffset(l);
        var c = this.data.slice(this.zero + this.index, this.zero + this.index + l);
        return this.index += l, c;
      }, n.exports = r;
    }, { "../utils": 32, "./DataReader": 18 }], 21: [function(i, n, s) {
      var o = i("./ArrayReader");
      function r(l) {
        o.call(this, l);
      }
      i("../utils").inherits(r, o), r.prototype.readData = function(l) {
        if (this.checkOffset(l), l === 0)
          return new Uint8Array(0);
        var c = this.data.subarray(this.zero + this.index, this.zero + this.index + l);
        return this.index += l, c;
      }, n.exports = r;
    }, { "../utils": 32, "./ArrayReader": 17 }], 22: [function(i, n, s) {
      var o = i("../utils"), r = i("../support"), l = i("./ArrayReader"), c = i("./StringReader"), h = i("./NodeBufferReader"), I = i("./Uint8ArrayReader");
      n.exports = function(p) {
        var y = o.getTypeOf(p);
        return o.checkSupport(y), y !== "string" || r.uint8array ? y === "nodebuffer" ? new h(p) : r.uint8array ? new I(o.transformTo("uint8array", p)) : new l(o.transformTo("array", p)) : new c(p);
      };
    }, { "../support": 30, "../utils": 32, "./ArrayReader": 17, "./NodeBufferReader": 19, "./StringReader": 20, "./Uint8ArrayReader": 21 }], 23: [function(i, n, s) {
      s.LOCAL_FILE_HEADER = "PK", s.CENTRAL_FILE_HEADER = "PK", s.CENTRAL_DIRECTORY_END = "PK", s.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x07", s.ZIP64_CENTRAL_DIRECTORY_END = "PK", s.DATA_DESCRIPTOR = "PK\x07\b";
    }, {}], 24: [function(i, n, s) {
      var o = i("./GenericWorker"), r = i("../utils");
      function l(c) {
        o.call(this, "ConvertWorker to " + c), this.destType = c;
      }
      r.inherits(l, o), l.prototype.processChunk = function(c) {
        this.push({ data: r.transformTo(this.destType, c.data), meta: c.meta });
      }, n.exports = l;
    }, { "../utils": 32, "./GenericWorker": 28 }], 25: [function(i, n, s) {
      var o = i("./GenericWorker"), r = i("../crc32");
      function l() {
        o.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
      }
      i("../utils").inherits(l, o), l.prototype.processChunk = function(c) {
        this.streamInfo.crc32 = r(c.data, this.streamInfo.crc32 || 0), this.push(c);
      }, n.exports = l;
    }, { "../crc32": 4, "../utils": 32, "./GenericWorker": 28 }], 26: [function(i, n, s) {
      var o = i("../utils"), r = i("./GenericWorker");
      function l(c) {
        r.call(this, "DataLengthProbe for " + c), this.propName = c, this.withStreamInfo(c, 0);
      }
      o.inherits(l, r), l.prototype.processChunk = function(c) {
        if (c) {
          var h = this.streamInfo[this.propName] || 0;
          this.streamInfo[this.propName] = h + c.data.length;
        }
        r.prototype.processChunk.call(this, c);
      }, n.exports = l;
    }, { "../utils": 32, "./GenericWorker": 28 }], 27: [function(i, n, s) {
      var o = i("../utils"), r = i("./GenericWorker");
      function l(c) {
        r.call(this, "DataWorker");
        var h = this;
        this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, c.then(function(I) {
          h.dataIsReady = !0, h.data = I, h.max = I && I.length || 0, h.type = o.getTypeOf(I), h.isPaused || h._tickAndRepeat();
        }, function(I) {
          h.error(I);
        });
      }
      o.inherits(l, r), l.prototype.cleanUp = function() {
        r.prototype.cleanUp.call(this), this.data = null;
      }, l.prototype.resume = function() {
        return !!r.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, o.delay(this._tickAndRepeat, [], this)), !0);
      }, l.prototype._tickAndRepeat = function() {
        this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (o.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
      }, l.prototype._tick = function() {
        if (this.isPaused || this.isFinished)
          return !1;
        var c = null, h = Math.min(this.max, this.index + 16384);
        if (this.index >= this.max)
          return this.end();
        switch (this.type) {
          case "string":
            c = this.data.substring(this.index, h);
            break;
          case "uint8array":
            c = this.data.subarray(this.index, h);
            break;
          case "array":
          case "nodebuffer":
            c = this.data.slice(this.index, h);
        }
        return this.index = h, this.push({ data: c, meta: { percent: this.max ? this.index / this.max * 100 : 0 } });
      }, n.exports = l;
    }, { "../utils": 32, "./GenericWorker": 28 }], 28: [function(i, n, s) {
      function o(r) {
        this.name = r || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = { data: [], end: [], error: [] }, this.previous = null;
      }
      o.prototype = { push: function(r) {
        this.emit("data", r);
      }, end: function() {
        if (this.isFinished)
          return !1;
        this.flush();
        try {
          this.emit("end"), this.cleanUp(), this.isFinished = !0;
        } catch (r) {
          this.emit("error", r);
        }
        return !0;
      }, error: function(r) {
        return !this.isFinished && (this.isPaused ? this.generatedError = r : (this.isFinished = !0, this.emit("error", r), this.previous && this.previous.error(r), this.cleanUp()), !0);
      }, on: function(r, l) {
        return this._listeners[r].push(l), this;
      }, cleanUp: function() {
        this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
      }, emit: function(r, l) {
        if (this._listeners[r])
          for (var c = 0; c < this._listeners[r].length; c++)
            this._listeners[r][c].call(this, l);
      }, pipe: function(r) {
        return r.registerPrevious(this);
      }, registerPrevious: function(r) {
        if (this.isLocked)
          throw new Error("The stream '" + this + "' has already been used.");
        this.streamInfo = r.streamInfo, this.mergeStreamInfo(), this.previous = r;
        var l = this;
        return r.on("data", function(c) {
          l.processChunk(c);
        }), r.on("end", function() {
          l.end();
        }), r.on("error", function(c) {
          l.error(c);
        }), this;
      }, pause: function() {
        return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
      }, resume: function() {
        if (!this.isPaused || this.isFinished)
          return !1;
        var r = this.isPaused = !1;
        return this.generatedError && (this.error(this.generatedError), r = !0), this.previous && this.previous.resume(), !r;
      }, flush: function() {
      }, processChunk: function(r) {
        this.push(r);
      }, withStreamInfo: function(r, l) {
        return this.extraStreamInfo[r] = l, this.mergeStreamInfo(), this;
      }, mergeStreamInfo: function() {
        for (var r in this.extraStreamInfo)
          Object.prototype.hasOwnProperty.call(this.extraStreamInfo, r) && (this.streamInfo[r] = this.extraStreamInfo[r]);
      }, lock: function() {
        if (this.isLocked)
          throw new Error("The stream '" + this + "' has already been used.");
        this.isLocked = !0, this.previous && this.previous.lock();
      }, toString: function() {
        var r = "Worker " + this.name;
        return this.previous ? this.previous + " -> " + r : r;
      } }, n.exports = o;
    }, {}], 29: [function(i, n, s) {
      var o = i("../utils"), r = i("./ConvertWorker"), l = i("./GenericWorker"), c = i("../base64"), h = i("../support"), I = i("../external"), p = null;
      if (h.nodestream)
        try {
          p = i("../nodejs/NodejsStreamOutputAdapter");
        } catch {
        }
      function y(A, C) {
        return new I.Promise(function(O, R) {
          var F = [], L = A._internalType, P = A._outputType, z = A._mimeType;
          A.on("data", function(W, re) {
            F.push(W), C && C(re);
          }).on("error", function(W) {
            F = [], R(W);
          }).on("end", function() {
            try {
              var W = (function(re, ce, te) {
                switch (re) {
                  case "blob":
                    return o.newBlob(o.transformTo("arraybuffer", ce), te);
                  case "base64":
                    return c.encode(ce);
                  default:
                    return o.transformTo(re, ce);
                }
              })(P, (function(re, ce) {
                var te, ee = 0, Ne = null, Ae = 0;
                for (te = 0; te < ce.length; te++)
                  Ae += ce[te].length;
                switch (re) {
                  case "string":
                    return ce.join("");
                  case "array":
                    return Array.prototype.concat.apply([], ce);
                  case "uint8array":
                    for (Ne = new Uint8Array(Ae), te = 0; te < ce.length; te++)
                      Ne.set(ce[te], ee), ee += ce[te].length;
                    return Ne;
                  case "nodebuffer":
                    return Buffer.concat(ce);
                  default:
                    throw new Error("concat : unsupported type '" + re + "'");
                }
              })(L, F), z);
              O(W);
            } catch (re) {
              R(re);
            }
            F = [];
          }).resume();
        });
      }
      function m(A, C, O) {
        var R = C;
        switch (C) {
          case "blob":
          case "arraybuffer":
            R = "uint8array";
            break;
          case "base64":
            R = "string";
        }
        try {
          this._internalType = R, this._outputType = C, this._mimeType = O, o.checkSupport(R), this._worker = A.pipe(new r(R)), A.lock();
        } catch (F) {
          this._worker = new l("error"), this._worker.error(F);
        }
      }
      m.prototype = { accumulate: function(A) {
        return y(this, A);
      }, on: function(A, C) {
        var O = this;
        return A === "data" ? this._worker.on(A, function(R) {
          C.call(O, R.data, R.meta);
        }) : this._worker.on(A, function() {
          o.delay(C, arguments, O);
        }), this;
      }, resume: function() {
        return o.delay(this._worker.resume, [], this._worker), this;
      }, pause: function() {
        return this._worker.pause(), this;
      }, toNodejsStream: function(A) {
        if (o.checkSupport("nodestream"), this._outputType !== "nodebuffer")
          throw new Error(this._outputType + " is not supported by this method");
        return new p(this, { objectMode: this._outputType !== "nodebuffer" }, A);
      } }, n.exports = m;
    }, { "../base64": 1, "../external": 6, "../nodejs/NodejsStreamOutputAdapter": 13, "../support": 30, "../utils": 32, "./ConvertWorker": 24, "./GenericWorker": 28 }], 30: [function(i, n, s) {
      if (s.base64 = !0, s.array = !0, s.string = !0, s.arraybuffer = typeof ArrayBuffer < "u" && typeof Uint8Array < "u", s.nodebuffer = typeof Buffer < "u", s.uint8array = typeof Uint8Array < "u", typeof ArrayBuffer > "u")
        s.blob = !1;
      else {
        var o = new ArrayBuffer(0);
        try {
          s.blob = new Blob([o], { type: "application/zip" }).size === 0;
        } catch {
          try {
            var r = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
            r.append(o), s.blob = r.getBlob("application/zip").size === 0;
          } catch {
            s.blob = !1;
          }
        }
      }
      try {
        s.nodestream = !!i("readable-stream").Readable;
      } catch {
        s.nodestream = !1;
      }
    }, { "readable-stream": 16 }], 31: [function(i, n, s) {
      for (var o = i("./utils"), r = i("./support"), l = i("./nodejsUtils"), c = i("./stream/GenericWorker"), h = new Array(256), I = 0; I < 256; I++)
        h[I] = 252 <= I ? 6 : 248 <= I ? 5 : 240 <= I ? 4 : 224 <= I ? 3 : 192 <= I ? 2 : 1;
      h[254] = h[254] = 1;
      function p() {
        c.call(this, "utf-8 decode"), this.leftOver = null;
      }
      function y() {
        c.call(this, "utf-8 encode");
      }
      s.utf8encode = function(m) {
        return r.nodebuffer ? l.newBufferFrom(m, "utf-8") : (function(A) {
          var C, O, R, F, L, P = A.length, z = 0;
          for (F = 0; F < P; F++)
            (64512 & (O = A.charCodeAt(F))) == 55296 && F + 1 < P && (64512 & (R = A.charCodeAt(F + 1))) == 56320 && (O = 65536 + (O - 55296 << 10) + (R - 56320), F++), z += O < 128 ? 1 : O < 2048 ? 2 : O < 65536 ? 3 : 4;
          for (C = r.uint8array ? new Uint8Array(z) : new Array(z), F = L = 0; L < z; F++)
            (64512 & (O = A.charCodeAt(F))) == 55296 && F + 1 < P && (64512 & (R = A.charCodeAt(F + 1))) == 56320 && (O = 65536 + (O - 55296 << 10) + (R - 56320), F++), O < 128 ? C[L++] = O : (O < 2048 ? C[L++] = 192 | O >>> 6 : (O < 65536 ? C[L++] = 224 | O >>> 12 : (C[L++] = 240 | O >>> 18, C[L++] = 128 | O >>> 12 & 63), C[L++] = 128 | O >>> 6 & 63), C[L++] = 128 | 63 & O);
          return C;
        })(m);
      }, s.utf8decode = function(m) {
        return r.nodebuffer ? o.transformTo("nodebuffer", m).toString("utf-8") : (function(A) {
          var C, O, R, F, L = A.length, P = new Array(2 * L);
          for (C = O = 0; C < L; )
            if ((R = A[C++]) < 128)
              P[O++] = R;
            else if (4 < (F = h[R]))
              P[O++] = 65533, C += F - 1;
            else {
              for (R &= F === 2 ? 31 : F === 3 ? 15 : 7; 1 < F && C < L; )
                R = R << 6 | 63 & A[C++], F--;
              1 < F ? P[O++] = 65533 : R < 65536 ? P[O++] = R : (R -= 65536, P[O++] = 55296 | R >> 10 & 1023, P[O++] = 56320 | 1023 & R);
            }
          return P.length !== O && (P.subarray ? P = P.subarray(0, O) : P.length = O), o.applyFromCharCode(P);
        })(m = o.transformTo(r.uint8array ? "uint8array" : "array", m));
      }, o.inherits(p, c), p.prototype.processChunk = function(m) {
        var A = o.transformTo(r.uint8array ? "uint8array" : "array", m.data);
        if (this.leftOver && this.leftOver.length) {
          if (r.uint8array) {
            var C = A;
            (A = new Uint8Array(C.length + this.leftOver.length)).set(this.leftOver, 0), A.set(C, this.leftOver.length);
          } else
            A = this.leftOver.concat(A);
          this.leftOver = null;
        }
        var O = (function(F, L) {
          var P;
          for ((L = L || F.length) > F.length && (L = F.length), P = L - 1; 0 <= P && (192 & F[P]) == 128; )
            P--;
          return P < 0 || P === 0 ? L : P + h[F[P]] > L ? P : L;
        })(A), R = A;
        O !== A.length && (r.uint8array ? (R = A.subarray(0, O), this.leftOver = A.subarray(O, A.length)) : (R = A.slice(0, O), this.leftOver = A.slice(O, A.length))), this.push({ data: s.utf8decode(R), meta: m.meta });
      }, p.prototype.flush = function() {
        this.leftOver && this.leftOver.length && (this.push({ data: s.utf8decode(this.leftOver), meta: {} }), this.leftOver = null);
      }, s.Utf8DecodeWorker = p, o.inherits(y, c), y.prototype.processChunk = function(m) {
        this.push({ data: s.utf8encode(m.data), meta: m.meta });
      }, s.Utf8EncodeWorker = y;
    }, { "./nodejsUtils": 14, "./stream/GenericWorker": 28, "./support": 30, "./utils": 32 }], 32: [function(i, n, s) {
      var o = i("./support"), r = i("./base64"), l = i("./nodejsUtils"), c = i("./external");
      function h(C) {
        return C;
      }
      function I(C, O) {
        for (var R = 0; R < C.length; ++R)
          O[R] = 255 & C.charCodeAt(R);
        return O;
      }
      i("setimmediate"), s.newBlob = function(C, O) {
        s.checkSupport("blob");
        try {
          return new Blob([C], { type: O });
        } catch {
          try {
            var R = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
            return R.append(C), R.getBlob(O);
          } catch {
            throw new Error("Bug : can't construct the Blob.");
          }
        }
      };
      var p = { stringifyByChunk: function(C, O, R) {
        var F = [], L = 0, P = C.length;
        if (P <= R)
          return String.fromCharCode.apply(null, C);
        for (; L < P; )
          O === "array" || O === "nodebuffer" ? F.push(String.fromCharCode.apply(null, C.slice(L, Math.min(L + R, P)))) : F.push(String.fromCharCode.apply(null, C.subarray(L, Math.min(L + R, P)))), L += R;
        return F.join("");
      }, stringifyByChar: function(C) {
        for (var O = "", R = 0; R < C.length; R++)
          O += String.fromCharCode(C[R]);
        return O;
      }, applyCanBeUsed: { uint8array: (function() {
        try {
          return o.uint8array && String.fromCharCode.apply(null, new Uint8Array(1)).length === 1;
        } catch {
          return !1;
        }
      })(), nodebuffer: (function() {
        try {
          return o.nodebuffer && String.fromCharCode.apply(null, l.allocBuffer(1)).length === 1;
        } catch {
          return !1;
        }
      })() } };
      function y(C) {
        var O = 65536, R = s.getTypeOf(C), F = !0;
        if (R === "uint8array" ? F = p.applyCanBeUsed.uint8array : R === "nodebuffer" && (F = p.applyCanBeUsed.nodebuffer), F)
          for (; 1 < O; )
            try {
              return p.stringifyByChunk(C, R, O);
            } catch {
              O = Math.floor(O / 2);
            }
        return p.stringifyByChar(C);
      }
      function m(C, O) {
        for (var R = 0; R < C.length; R++)
          O[R] = C[R];
        return O;
      }
      s.applyFromCharCode = y;
      var A = {};
      A.string = { string: h, array: function(C) {
        return I(C, new Array(C.length));
      }, arraybuffer: function(C) {
        return A.string.uint8array(C).buffer;
      }, uint8array: function(C) {
        return I(C, new Uint8Array(C.length));
      }, nodebuffer: function(C) {
        return I(C, l.allocBuffer(C.length));
      } }, A.array = { string: y, array: h, arraybuffer: function(C) {
        return new Uint8Array(C).buffer;
      }, uint8array: function(C) {
        return new Uint8Array(C);
      }, nodebuffer: function(C) {
        return l.newBufferFrom(C);
      } }, A.arraybuffer = { string: function(C) {
        return y(new Uint8Array(C));
      }, array: function(C) {
        return m(new Uint8Array(C), new Array(C.byteLength));
      }, arraybuffer: h, uint8array: function(C) {
        return new Uint8Array(C);
      }, nodebuffer: function(C) {
        return l.newBufferFrom(new Uint8Array(C));
      } }, A.uint8array = { string: y, array: function(C) {
        return m(C, new Array(C.length));
      }, arraybuffer: function(C) {
        return C.buffer;
      }, uint8array: h, nodebuffer: function(C) {
        return l.newBufferFrom(C);
      } }, A.nodebuffer = { string: y, array: function(C) {
        return m(C, new Array(C.length));
      }, arraybuffer: function(C) {
        return A.nodebuffer.uint8array(C).buffer;
      }, uint8array: function(C) {
        return m(C, new Uint8Array(C.length));
      }, nodebuffer: h }, s.transformTo = function(C, O) {
        if (O = O || "", !C)
          return O;
        s.checkSupport(C);
        var R = s.getTypeOf(O);
        return A[R][C](O);
      }, s.resolve = function(C) {
        for (var O = C.split("/"), R = [], F = 0; F < O.length; F++) {
          var L = O[F];
          L === "." || L === "" && F !== 0 && F !== O.length - 1 || (L === ".." ? R.pop() : R.push(L));
        }
        return R.join("/");
      }, s.getTypeOf = function(C) {
        return typeof C == "string" ? "string" : Object.prototype.toString.call(C) === "[object Array]" ? "array" : o.nodebuffer && l.isBuffer(C) ? "nodebuffer" : o.uint8array && C instanceof Uint8Array ? "uint8array" : o.arraybuffer && C instanceof ArrayBuffer ? "arraybuffer" : void 0;
      }, s.checkSupport = function(C) {
        if (!o[C.toLowerCase()])
          throw new Error(C + " is not supported by this platform");
      }, s.MAX_VALUE_16BITS = 65535, s.MAX_VALUE_32BITS = -1, s.pretty = function(C) {
        var O, R, F = "";
        for (R = 0; R < (C || "").length; R++)
          F += "\\x" + ((O = C.charCodeAt(R)) < 16 ? "0" : "") + O.toString(16).toUpperCase();
        return F;
      }, s.delay = function(C, O, R) {
        setImmediate(function() {
          C.apply(R || null, O || []);
        });
      }, s.inherits = function(C, O) {
        function R() {
        }
        R.prototype = O.prototype, C.prototype = new R();
      }, s.extend = function() {
        var C, O, R = {};
        for (C = 0; C < arguments.length; C++)
          for (O in arguments[C])
            Object.prototype.hasOwnProperty.call(arguments[C], O) && R[O] === void 0 && (R[O] = arguments[C][O]);
        return R;
      }, s.prepareContent = function(C, O, R, F, L) {
        return c.Promise.resolve(O).then(function(P) {
          return o.blob && (P instanceof Blob || ["[object File]", "[object Blob]"].indexOf(Object.prototype.toString.call(P)) !== -1) && typeof FileReader < "u" ? new c.Promise(function(z, W) {
            var re = new FileReader();
            re.onload = function(ce) {
              z(ce.target.result);
            }, re.onerror = function(ce) {
              W(ce.target.error);
            }, re.readAsArrayBuffer(P);
          }) : P;
        }).then(function(P) {
          var z = s.getTypeOf(P);
          return z ? (z === "arraybuffer" ? P = s.transformTo("uint8array", P) : z === "string" && (L ? P = r.decode(P) : R && F !== !0 && (P = (function(W) {
            return I(W, o.uint8array ? new Uint8Array(W.length) : new Array(W.length));
          })(P))), P) : c.Promise.reject(new Error("Can't read the data of '" + C + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
        });
      };
    }, { "./base64": 1, "./external": 6, "./nodejsUtils": 14, "./support": 30, setimmediate: 54 }], 33: [function(i, n, s) {
      var o = i("./reader/readerFor"), r = i("./utils"), l = i("./signature"), c = i("./zipEntry"), h = i("./support");
      function I(p) {
        this.files = [], this.loadOptions = p;
      }
      I.prototype = { checkSignature: function(p) {
        if (!this.reader.readAndCheckSignature(p)) {
          this.reader.index -= 4;
          var y = this.reader.readString(4);
          throw new Error("Corrupted zip or bug: unexpected signature (" + r.pretty(y) + ", expected " + r.pretty(p) + ")");
        }
      }, isSignature: function(p, y) {
        var m = this.reader.index;
        this.reader.setIndex(p);
        var A = this.reader.readString(4) === y;
        return this.reader.setIndex(m), A;
      }, readBlockEndOfCentral: function() {
        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
        var p = this.reader.readData(this.zipCommentLength), y = h.uint8array ? "uint8array" : "array", m = r.transformTo(y, p);
        this.zipComment = this.loadOptions.decodeFileName(m);
      }, readBlockZip64EndOfCentral: function() {
        this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
        for (var p, y, m, A = this.zip64EndOfCentralSize - 44; 0 < A; )
          p = this.reader.readInt(2), y = this.reader.readInt(4), m = this.reader.readData(y), this.zip64ExtensibleData[p] = { id: p, length: y, value: m };
      }, readBlockZip64EndOfCentralLocator: function() {
        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount)
          throw new Error("Multi-volumes zip are not supported");
      }, readLocalFiles: function() {
        var p, y;
        for (p = 0; p < this.files.length; p++)
          y = this.files[p], this.reader.setIndex(y.localHeaderOffset), this.checkSignature(l.LOCAL_FILE_HEADER), y.readLocalPart(this.reader), y.handleUTF8(), y.processAttributes();
      }, readCentralDir: function() {
        var p;
        for (this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(l.CENTRAL_FILE_HEADER); )
          (p = new c({ zip64: this.zip64 }, this.loadOptions)).readCentralPart(this.reader), this.files.push(p);
        if (this.centralDirRecords !== this.files.length && this.centralDirRecords !== 0 && this.files.length === 0)
          throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
      }, readEndOfCentral: function() {
        var p = this.reader.lastIndexOfSignature(l.CENTRAL_DIRECTORY_END);
        if (p < 0)
          throw this.isSignature(0, l.LOCAL_FILE_HEADER) ? new Error("Corrupted zip: can't find end of central directory") : new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
        this.reader.setIndex(p);
        var y = p;
        if (this.checkSignature(l.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === r.MAX_VALUE_16BITS || this.diskWithCentralDirStart === r.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === r.MAX_VALUE_16BITS || this.centralDirRecords === r.MAX_VALUE_16BITS || this.centralDirSize === r.MAX_VALUE_32BITS || this.centralDirOffset === r.MAX_VALUE_32BITS) {
          if (this.zip64 = !0, (p = this.reader.lastIndexOfSignature(l.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0)
            throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
          if (this.reader.setIndex(p), this.checkSignature(l.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, l.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(l.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0))
            throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
          this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(l.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
        }
        var m = this.centralDirOffset + this.centralDirSize;
        this.zip64 && (m += 20, m += 12 + this.zip64EndOfCentralSize);
        var A = y - m;
        if (0 < A)
          this.isSignature(y, l.CENTRAL_FILE_HEADER) || (this.reader.zero = A);
        else if (A < 0)
          throw new Error("Corrupted zip: missing " + Math.abs(A) + " bytes.");
      }, prepareReader: function(p) {
        this.reader = o(p);
      }, load: function(p) {
        this.prepareReader(p), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
      } }, n.exports = I;
    }, { "./reader/readerFor": 22, "./signature": 23, "./support": 30, "./utils": 32, "./zipEntry": 34 }], 34: [function(i, n, s) {
      var o = i("./reader/readerFor"), r = i("./utils"), l = i("./compressedObject"), c = i("./crc32"), h = i("./utf8"), I = i("./compressions"), p = i("./support");
      function y(m, A) {
        this.options = m, this.loadOptions = A;
      }
      y.prototype = { isEncrypted: function() {
        return (1 & this.bitFlag) == 1;
      }, useUTF8: function() {
        return (2048 & this.bitFlag) == 2048;
      }, readLocalPart: function(m) {
        var A, C;
        if (m.skip(22), this.fileNameLength = m.readInt(2), C = m.readInt(2), this.fileName = m.readData(this.fileNameLength), m.skip(C), this.compressedSize === -1 || this.uncompressedSize === -1)
          throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
        if ((A = (function(O) {
          for (var R in I)
            if (Object.prototype.hasOwnProperty.call(I, R) && I[R].magic === O)
              return I[R];
          return null;
        })(this.compressionMethod)) === null)
          throw new Error("Corrupted zip : compression " + r.pretty(this.compressionMethod) + " unknown (inner file : " + r.transformTo("string", this.fileName) + ")");
        this.decompressed = new l(this.compressedSize, this.uncompressedSize, this.crc32, A, m.readData(this.compressedSize));
      }, readCentralPart: function(m) {
        this.versionMadeBy = m.readInt(2), m.skip(2), this.bitFlag = m.readInt(2), this.compressionMethod = m.readString(2), this.date = m.readDate(), this.crc32 = m.readInt(4), this.compressedSize = m.readInt(4), this.uncompressedSize = m.readInt(4);
        var A = m.readInt(2);
        if (this.extraFieldsLength = m.readInt(2), this.fileCommentLength = m.readInt(2), this.diskNumberStart = m.readInt(2), this.internalFileAttributes = m.readInt(2), this.externalFileAttributes = m.readInt(4), this.localHeaderOffset = m.readInt(4), this.isEncrypted())
          throw new Error("Encrypted zip are not supported");
        m.skip(A), this.readExtraFields(m), this.parseZIP64ExtraField(m), this.fileComment = m.readData(this.fileCommentLength);
      }, processAttributes: function() {
        this.unixPermissions = null, this.dosPermissions = null;
        var m = this.versionMadeBy >> 8;
        this.dir = !!(16 & this.externalFileAttributes), m == 0 && (this.dosPermissions = 63 & this.externalFileAttributes), m == 3 && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || this.fileNameStr.slice(-1) !== "/" || (this.dir = !0);
      }, parseZIP64ExtraField: function() {
        if (this.extraFields[1]) {
          var m = o(this.extraFields[1].value);
          this.uncompressedSize === r.MAX_VALUE_32BITS && (this.uncompressedSize = m.readInt(8)), this.compressedSize === r.MAX_VALUE_32BITS && (this.compressedSize = m.readInt(8)), this.localHeaderOffset === r.MAX_VALUE_32BITS && (this.localHeaderOffset = m.readInt(8)), this.diskNumberStart === r.MAX_VALUE_32BITS && (this.diskNumberStart = m.readInt(4));
        }
      }, readExtraFields: function(m) {
        var A, C, O, R = m.index + this.extraFieldsLength;
        for (this.extraFields || (this.extraFields = {}); m.index + 4 < R; )
          A = m.readInt(2), C = m.readInt(2), O = m.readData(C), this.extraFields[A] = { id: A, length: C, value: O };
        m.setIndex(R);
      }, handleUTF8: function() {
        var m = p.uint8array ? "uint8array" : "array";
        if (this.useUTF8())
          this.fileNameStr = h.utf8decode(this.fileName), this.fileCommentStr = h.utf8decode(this.fileComment);
        else {
          var A = this.findExtraFieldUnicodePath();
          if (A !== null)
            this.fileNameStr = A;
          else {
            var C = r.transformTo(m, this.fileName);
            this.fileNameStr = this.loadOptions.decodeFileName(C);
          }
          var O = this.findExtraFieldUnicodeComment();
          if (O !== null)
            this.fileCommentStr = O;
          else {
            var R = r.transformTo(m, this.fileComment);
            this.fileCommentStr = this.loadOptions.decodeFileName(R);
          }
        }
      }, findExtraFieldUnicodePath: function() {
        var m = this.extraFields[28789];
        if (m) {
          var A = o(m.value);
          return A.readInt(1) !== 1 || c(this.fileName) !== A.readInt(4) ? null : h.utf8decode(A.readData(m.length - 5));
        }
        return null;
      }, findExtraFieldUnicodeComment: function() {
        var m = this.extraFields[25461];
        if (m) {
          var A = o(m.value);
          return A.readInt(1) !== 1 || c(this.fileComment) !== A.readInt(4) ? null : h.utf8decode(A.readData(m.length - 5));
        }
        return null;
      } }, n.exports = y;
    }, { "./compressedObject": 2, "./compressions": 3, "./crc32": 4, "./reader/readerFor": 22, "./support": 30, "./utf8": 31, "./utils": 32 }], 35: [function(i, n, s) {
      function o(A, C, O) {
        this.name = A, this.dir = O.dir, this.date = O.date, this.comment = O.comment, this.unixPermissions = O.unixPermissions, this.dosPermissions = O.dosPermissions, this._data = C, this._dataBinary = O.binary, this.options = { compression: O.compression, compressionOptions: O.compressionOptions };
      }
      var r = i("./stream/StreamHelper"), l = i("./stream/DataWorker"), c = i("./utf8"), h = i("./compressedObject"), I = i("./stream/GenericWorker");
      o.prototype = { internalStream: function(A) {
        var C = null, O = "string";
        try {
          if (!A)
            throw new Error("No output type specified.");
          var R = (O = A.toLowerCase()) === "string" || O === "text";
          O !== "binarystring" && O !== "text" || (O = "string"), C = this._decompressWorker();
          var F = !this._dataBinary;
          F && !R && (C = C.pipe(new c.Utf8EncodeWorker())), !F && R && (C = C.pipe(new c.Utf8DecodeWorker()));
        } catch (L) {
          (C = new I("error")).error(L);
        }
        return new r(C, O, "");
      }, async: function(A, C) {
        return this.internalStream(A).accumulate(C);
      }, nodeStream: function(A, C) {
        return this.internalStream(A || "nodebuffer").toNodejsStream(C);
      }, _compressWorker: function(A, C) {
        if (this._data instanceof h && this._data.compression.magic === A.magic)
          return this._data.getCompressedWorker();
        var O = this._decompressWorker();
        return this._dataBinary || (O = O.pipe(new c.Utf8EncodeWorker())), h.createWorkerFrom(O, A, C);
      }, _decompressWorker: function() {
        return this._data instanceof h ? this._data.getContentWorker() : this._data instanceof I ? this._data : new l(this._data);
      } };
      for (var p = ["asText", "asBinary", "asNodeBuffer", "asUint8Array", "asArrayBuffer"], y = function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, m = 0; m < p.length; m++)
        o.prototype[p[m]] = y;
      n.exports = o;
    }, { "./compressedObject": 2, "./stream/DataWorker": 27, "./stream/GenericWorker": 28, "./stream/StreamHelper": 29, "./utf8": 31 }], 36: [function(i, n, s) {
      (function(o) {
        var r, l, c = o.MutationObserver || o.WebKitMutationObserver;
        if (c) {
          var h = 0, I = new c(A), p = o.document.createTextNode("");
          I.observe(p, { characterData: !0 }), r = function() {
            p.data = h = ++h % 2;
          };
        } else if (o.setImmediate || o.MessageChannel === void 0)
          r = "document" in o && "onreadystatechange" in o.document.createElement("script") ? function() {
            var C = o.document.createElement("script");
            C.onreadystatechange = function() {
              A(), C.onreadystatechange = null, C.parentNode.removeChild(C), C = null;
            }, o.document.documentElement.appendChild(C);
          } : function() {
            setTimeout(A, 0);
          };
        else {
          var y = new o.MessageChannel();
          y.port1.onmessage = A, r = function() {
            y.port2.postMessage(0);
          };
        }
        var m = [];
        function A() {
          var C, O;
          l = !0;
          for (var R = m.length; R; ) {
            for (O = m, m = [], C = -1; ++C < R; )
              O[C]();
            R = m.length;
          }
          l = !1;
        }
        n.exports = function(C) {
          m.push(C) !== 1 || l || r();
        };
      }).call(this, typeof mse < "u" ? mse : typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, {}], 37: [function(i, n, s) {
      var o = i("immediate");
      function r() {
      }
      var l = {}, c = ["REJECTED"], h = ["FULFILLED"], I = ["PENDING"];
      function p(R) {
        if (typeof R != "function")
          throw new TypeError("resolver must be a function");
        this.state = I, this.queue = [], this.outcome = void 0, R !== r && C(this, R);
      }
      function y(R, F, L) {
        this.promise = R, typeof F == "function" && (this.onFulfilled = F, this.callFulfilled = this.otherCallFulfilled), typeof L == "function" && (this.onRejected = L, this.callRejected = this.otherCallRejected);
      }
      function m(R, F, L) {
        o(function() {
          var P;
          try {
            P = F(L);
          } catch (z) {
            return l.reject(R, z);
          }
          P === R ? l.reject(R, new TypeError("Cannot resolve promise with itself")) : l.resolve(R, P);
        });
      }
      function A(R) {
        var F = R && R.then;
        if (R && (typeof R == "object" || typeof R == "function") && typeof F == "function")
          return function() {
            F.apply(R, arguments);
          };
      }
      function C(R, F) {
        var L = !1;
        function P(re) {
          L || (L = !0, l.reject(R, re));
        }
        function z(re) {
          L || (L = !0, l.resolve(R, re));
        }
        var W = O(function() {
          F(z, P);
        });
        W.status === "error" && P(W.value);
      }
      function O(R, F) {
        var L = {};
        try {
          L.value = R(F), L.status = "success";
        } catch (P) {
          L.status = "error", L.value = P;
        }
        return L;
      }
      (n.exports = p).prototype.finally = function(R) {
        if (typeof R != "function")
          return this;
        var F = this.constructor;
        return this.then(function(L) {
          return F.resolve(R()).then(function() {
            return L;
          });
        }, function(L) {
          return F.resolve(R()).then(function() {
            throw L;
          });
        });
      }, p.prototype.catch = function(R) {
        return this.then(null, R);
      }, p.prototype.then = function(R, F) {
        if (typeof R != "function" && this.state === h || typeof F != "function" && this.state === c)
          return this;
        var L = new this.constructor(r);
        return this.state !== I ? m(L, this.state === h ? R : F, this.outcome) : this.queue.push(new y(L, R, F)), L;
      }, y.prototype.callFulfilled = function(R) {
        l.resolve(this.promise, R);
      }, y.prototype.otherCallFulfilled = function(R) {
        m(this.promise, this.onFulfilled, R);
      }, y.prototype.callRejected = function(R) {
        l.reject(this.promise, R);
      }, y.prototype.otherCallRejected = function(R) {
        m(this.promise, this.onRejected, R);
      }, l.resolve = function(R, F) {
        var L = O(A, F);
        if (L.status === "error")
          return l.reject(R, L.value);
        var P = L.value;
        if (P)
          C(R, P);
        else {
          R.state = h, R.outcome = F;
          for (var z = -1, W = R.queue.length; ++z < W; )
            R.queue[z].callFulfilled(F);
        }
        return R;
      }, l.reject = function(R, F) {
        R.state = c, R.outcome = F;
        for (var L = -1, P = R.queue.length; ++L < P; )
          R.queue[L].callRejected(F);
        return R;
      }, p.resolve = function(R) {
        return R instanceof this ? R : l.resolve(new this(r), R);
      }, p.reject = function(R) {
        var F = new this(r);
        return l.reject(F, R);
      }, p.all = function(R) {
        var F = this;
        if (Object.prototype.toString.call(R) !== "[object Array]")
          return this.reject(new TypeError("must be an array"));
        var L = R.length, P = !1;
        if (!L)
          return this.resolve([]);
        for (var z = new Array(L), W = 0, re = -1, ce = new this(r); ++re < L; )
          te(R[re], re);
        return ce;
        function te(ee, Ne) {
          F.resolve(ee).then(function(Ae) {
            z[Ne] = Ae, ++W !== L || P || (P = !0, l.resolve(ce, z));
          }, function(Ae) {
            P || (P = !0, l.reject(ce, Ae));
          });
        }
      }, p.race = function(R) {
        var F = this;
        if (Object.prototype.toString.call(R) !== "[object Array]")
          return this.reject(new TypeError("must be an array"));
        var L = R.length, P = !1;
        if (!L)
          return this.resolve([]);
        for (var z = -1, W = new this(r); ++z < L; )
          re = R[z], F.resolve(re).then(function(ce) {
            P || (P = !0, l.resolve(W, ce));
          }, function(ce) {
            P || (P = !0, l.reject(W, ce));
          });
        var re;
        return W;
      };
    }, { immediate: 36 }], 38: [function(i, n, s) {
      var o = {};
      (0, i("./lib/utils/common").assign)(o, i("./lib/deflate"), i("./lib/inflate"), i("./lib/zlib/constants")), n.exports = o;
    }, { "./lib/deflate": 39, "./lib/inflate": 40, "./lib/utils/common": 41, "./lib/zlib/constants": 44 }], 39: [function(i, n, s) {
      var o = i("./zlib/deflate"), r = i("./utils/common"), l = i("./utils/strings"), c = i("./zlib/messages"), h = i("./zlib/zstream"), I = Object.prototype.toString, p = 0, y = -1, m = 0, A = 8;
      function C(R) {
        if (!(this instanceof C))
          return new C(R);
        this.options = r.assign({ level: y, method: A, chunkSize: 16384, windowBits: 15, memLevel: 8, strategy: m, to: "" }, R || {});
        var F = this.options;
        F.raw && 0 < F.windowBits ? F.windowBits = -F.windowBits : F.gzip && 0 < F.windowBits && F.windowBits < 16 && (F.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new h(), this.strm.avail_out = 0;
        var L = o.deflateInit2(this.strm, F.level, F.method, F.windowBits, F.memLevel, F.strategy);
        if (L !== p)
          throw new Error(c[L]);
        if (F.header && o.deflateSetHeader(this.strm, F.header), F.dictionary) {
          var P;
          if (P = typeof F.dictionary == "string" ? l.string2buf(F.dictionary) : I.call(F.dictionary) === "[object ArrayBuffer]" ? new Uint8Array(F.dictionary) : F.dictionary, (L = o.deflateSetDictionary(this.strm, P)) !== p)
            throw new Error(c[L]);
          this._dict_set = !0;
        }
      }
      function O(R, F) {
        var L = new C(F);
        if (L.push(R, !0), L.err)
          throw L.msg || c[L.err];
        return L.result;
      }
      C.prototype.push = function(R, F) {
        var L, P, z = this.strm, W = this.options.chunkSize;
        if (this.ended)
          return !1;
        P = F === ~~F ? F : F === !0 ? 4 : 0, typeof R == "string" ? z.input = l.string2buf(R) : I.call(R) === "[object ArrayBuffer]" ? z.input = new Uint8Array(R) : z.input = R, z.next_in = 0, z.avail_in = z.input.length;
        do {
          if (z.avail_out === 0 && (z.output = new r.Buf8(W), z.next_out = 0, z.avail_out = W), (L = o.deflate(z, P)) !== 1 && L !== p)
            return this.onEnd(L), !(this.ended = !0);
          z.avail_out !== 0 && (z.avail_in !== 0 || P !== 4 && P !== 2) || (this.options.to === "string" ? this.onData(l.buf2binstring(r.shrinkBuf(z.output, z.next_out))) : this.onData(r.shrinkBuf(z.output, z.next_out)));
        } while ((0 < z.avail_in || z.avail_out === 0) && L !== 1);
        return P === 4 ? (L = o.deflateEnd(this.strm), this.onEnd(L), this.ended = !0, L === p) : P !== 2 || (this.onEnd(p), !(z.avail_out = 0));
      }, C.prototype.onData = function(R) {
        this.chunks.push(R);
      }, C.prototype.onEnd = function(R) {
        R === p && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = r.flattenChunks(this.chunks)), this.chunks = [], this.err = R, this.msg = this.strm.msg;
      }, s.Deflate = C, s.deflate = O, s.deflateRaw = function(R, F) {
        return (F = F || {}).raw = !0, O(R, F);
      }, s.gzip = function(R, F) {
        return (F = F || {}).gzip = !0, O(R, F);
      };
    }, { "./utils/common": 41, "./utils/strings": 42, "./zlib/deflate": 46, "./zlib/messages": 51, "./zlib/zstream": 53 }], 40: [function(i, n, s) {
      var o = i("./zlib/inflate"), r = i("./utils/common"), l = i("./utils/strings"), c = i("./zlib/constants"), h = i("./zlib/messages"), I = i("./zlib/zstream"), p = i("./zlib/gzheader"), y = Object.prototype.toString;
      function m(C) {
        if (!(this instanceof m))
          return new m(C);
        this.options = r.assign({ chunkSize: 16384, windowBits: 0, to: "" }, C || {});
        var O = this.options;
        O.raw && 0 <= O.windowBits && O.windowBits < 16 && (O.windowBits = -O.windowBits, O.windowBits === 0 && (O.windowBits = -15)), !(0 <= O.windowBits && O.windowBits < 16) || C && C.windowBits || (O.windowBits += 32), 15 < O.windowBits && O.windowBits < 48 && (15 & O.windowBits) == 0 && (O.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new I(), this.strm.avail_out = 0;
        var R = o.inflateInit2(this.strm, O.windowBits);
        if (R !== c.Z_OK)
          throw new Error(h[R]);
        this.header = new p(), o.inflateGetHeader(this.strm, this.header);
      }
      function A(C, O) {
        var R = new m(O);
        if (R.push(C, !0), R.err)
          throw R.msg || h[R.err];
        return R.result;
      }
      m.prototype.push = function(C, O) {
        var R, F, L, P, z, W, re = this.strm, ce = this.options.chunkSize, te = this.options.dictionary, ee = !1;
        if (this.ended)
          return !1;
        F = O === ~~O ? O : O === !0 ? c.Z_FINISH : c.Z_NO_FLUSH, typeof C == "string" ? re.input = l.binstring2buf(C) : y.call(C) === "[object ArrayBuffer]" ? re.input = new Uint8Array(C) : re.input = C, re.next_in = 0, re.avail_in = re.input.length;
        do {
          if (re.avail_out === 0 && (re.output = new r.Buf8(ce), re.next_out = 0, re.avail_out = ce), (R = o.inflate(re, c.Z_NO_FLUSH)) === c.Z_NEED_DICT && te && (W = typeof te == "string" ? l.string2buf(te) : y.call(te) === "[object ArrayBuffer]" ? new Uint8Array(te) : te, R = o.inflateSetDictionary(this.strm, W)), R === c.Z_BUF_ERROR && ee === !0 && (R = c.Z_OK, ee = !1), R !== c.Z_STREAM_END && R !== c.Z_OK)
            return this.onEnd(R), !(this.ended = !0);
          re.next_out && (re.avail_out !== 0 && R !== c.Z_STREAM_END && (re.avail_in !== 0 || F !== c.Z_FINISH && F !== c.Z_SYNC_FLUSH) || (this.options.to === "string" ? (L = l.utf8border(re.output, re.next_out), P = re.next_out - L, z = l.buf2string(re.output, L), re.next_out = P, re.avail_out = ce - P, P && r.arraySet(re.output, re.output, L, P, 0), this.onData(z)) : this.onData(r.shrinkBuf(re.output, re.next_out)))), re.avail_in === 0 && re.avail_out === 0 && (ee = !0);
        } while ((0 < re.avail_in || re.avail_out === 0) && R !== c.Z_STREAM_END);
        return R === c.Z_STREAM_END && (F = c.Z_FINISH), F === c.Z_FINISH ? (R = o.inflateEnd(this.strm), this.onEnd(R), this.ended = !0, R === c.Z_OK) : F !== c.Z_SYNC_FLUSH || (this.onEnd(c.Z_OK), !(re.avail_out = 0));
      }, m.prototype.onData = function(C) {
        this.chunks.push(C);
      }, m.prototype.onEnd = function(C) {
        C === c.Z_OK && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = r.flattenChunks(this.chunks)), this.chunks = [], this.err = C, this.msg = this.strm.msg;
      }, s.Inflate = m, s.inflate = A, s.inflateRaw = function(C, O) {
        return (O = O || {}).raw = !0, A(C, O);
      }, s.ungzip = A;
    }, { "./utils/common": 41, "./utils/strings": 42, "./zlib/constants": 44, "./zlib/gzheader": 47, "./zlib/inflate": 49, "./zlib/messages": 51, "./zlib/zstream": 53 }], 41: [function(i, n, s) {
      var o = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
      s.assign = function(c) {
        for (var h = Array.prototype.slice.call(arguments, 1); h.length; ) {
          var I = h.shift();
          if (I) {
            if (typeof I != "object")
              throw new TypeError(I + "must be non-object");
            for (var p in I)
              I.hasOwnProperty(p) && (c[p] = I[p]);
          }
        }
        return c;
      }, s.shrinkBuf = function(c, h) {
        return c.length === h ? c : c.subarray ? c.subarray(0, h) : (c.length = h, c);
      };
      var r = { arraySet: function(c, h, I, p, y) {
        if (h.subarray && c.subarray)
          c.set(h.subarray(I, I + p), y);
        else
          for (var m = 0; m < p; m++)
            c[y + m] = h[I + m];
      }, flattenChunks: function(c) {
        var h, I, p, y, m, A;
        for (h = p = 0, I = c.length; h < I; h++)
          p += c[h].length;
        for (A = new Uint8Array(p), h = y = 0, I = c.length; h < I; h++)
          m = c[h], A.set(m, y), y += m.length;
        return A;
      } }, l = { arraySet: function(c, h, I, p, y) {
        for (var m = 0; m < p; m++)
          c[y + m] = h[I + m];
      }, flattenChunks: function(c) {
        return [].concat.apply([], c);
      } };
      s.setTyped = function(c) {
        c ? (s.Buf8 = Uint8Array, s.Buf16 = Uint16Array, s.Buf32 = Int32Array, s.assign(s, r)) : (s.Buf8 = Array, s.Buf16 = Array, s.Buf32 = Array, s.assign(s, l));
      }, s.setTyped(o);
    }, {}], 42: [function(i, n, s) {
      var o = i("./common"), r = !0, l = !0;
      try {
        String.fromCharCode.apply(null, [0]);
      } catch {
        r = !1;
      }
      try {
        String.fromCharCode.apply(null, new Uint8Array(1));
      } catch {
        l = !1;
      }
      for (var c = new o.Buf8(256), h = 0; h < 256; h++)
        c[h] = 252 <= h ? 6 : 248 <= h ? 5 : 240 <= h ? 4 : 224 <= h ? 3 : 192 <= h ? 2 : 1;
      function I(p, y) {
        if (y < 65537 && (p.subarray && l || !p.subarray && r))
          return String.fromCharCode.apply(null, o.shrinkBuf(p, y));
        for (var m = "", A = 0; A < y; A++)
          m += String.fromCharCode(p[A]);
        return m;
      }
      c[254] = c[254] = 1, s.string2buf = function(p) {
        var y, m, A, C, O, R = p.length, F = 0;
        for (C = 0; C < R; C++)
          (64512 & (m = p.charCodeAt(C))) == 55296 && C + 1 < R && (64512 & (A = p.charCodeAt(C + 1))) == 56320 && (m = 65536 + (m - 55296 << 10) + (A - 56320), C++), F += m < 128 ? 1 : m < 2048 ? 2 : m < 65536 ? 3 : 4;
        for (y = new o.Buf8(F), C = O = 0; O < F; C++)
          (64512 & (m = p.charCodeAt(C))) == 55296 && C + 1 < R && (64512 & (A = p.charCodeAt(C + 1))) == 56320 && (m = 65536 + (m - 55296 << 10) + (A - 56320), C++), m < 128 ? y[O++] = m : (m < 2048 ? y[O++] = 192 | m >>> 6 : (m < 65536 ? y[O++] = 224 | m >>> 12 : (y[O++] = 240 | m >>> 18, y[O++] = 128 | m >>> 12 & 63), y[O++] = 128 | m >>> 6 & 63), y[O++] = 128 | 63 & m);
        return y;
      }, s.buf2binstring = function(p) {
        return I(p, p.length);
      }, s.binstring2buf = function(p) {
        for (var y = new o.Buf8(p.length), m = 0, A = y.length; m < A; m++)
          y[m] = p.charCodeAt(m);
        return y;
      }, s.buf2string = function(p, y) {
        var m, A, C, O, R = y || p.length, F = new Array(2 * R);
        for (m = A = 0; m < R; )
          if ((C = p[m++]) < 128)
            F[A++] = C;
          else if (4 < (O = c[C]))
            F[A++] = 65533, m += O - 1;
          else {
            for (C &= O === 2 ? 31 : O === 3 ? 15 : 7; 1 < O && m < R; )
              C = C << 6 | 63 & p[m++], O--;
            1 < O ? F[A++] = 65533 : C < 65536 ? F[A++] = C : (C -= 65536, F[A++] = 55296 | C >> 10 & 1023, F[A++] = 56320 | 1023 & C);
          }
        return I(F, A);
      }, s.utf8border = function(p, y) {
        var m;
        for ((y = y || p.length) > p.length && (y = p.length), m = y - 1; 0 <= m && (192 & p[m]) == 128; )
          m--;
        return m < 0 || m === 0 ? y : m + c[p[m]] > y ? m : y;
      };
    }, { "./common": 41 }], 43: [function(i, n, s) {
      n.exports = function(o, r, l, c) {
        for (var h = 65535 & o | 0, I = o >>> 16 & 65535 | 0, p = 0; l !== 0; ) {
          for (l -= p = 2e3 < l ? 2e3 : l; I = I + (h = h + r[c++] | 0) | 0, --p; )
            ;
          h %= 65521, I %= 65521;
        }
        return h | I << 16 | 0;
      };
    }, {}], 44: [function(i, n, s) {
      n.exports = { Z_NO_FLUSH: 0, Z_PARTIAL_FLUSH: 1, Z_SYNC_FLUSH: 2, Z_FULL_FLUSH: 3, Z_FINISH: 4, Z_BLOCK: 5, Z_TREES: 6, Z_OK: 0, Z_STREAM_END: 1, Z_NEED_DICT: 2, Z_ERRNO: -1, Z_STREAM_ERROR: -2, Z_DATA_ERROR: -3, Z_BUF_ERROR: -5, Z_NO_COMPRESSION: 0, Z_BEST_SPEED: 1, Z_BEST_COMPRESSION: 9, Z_DEFAULT_COMPRESSION: -1, Z_FILTERED: 1, Z_HUFFMAN_ONLY: 2, Z_RLE: 3, Z_FIXED: 4, Z_DEFAULT_STRATEGY: 0, Z_BINARY: 0, Z_TEXT: 1, Z_UNKNOWN: 2, Z_DEFLATED: 8 };
    }, {}], 45: [function(i, n, s) {
      var o = (function() {
        for (var r, l = [], c = 0; c < 256; c++) {
          r = c;
          for (var h = 0; h < 8; h++)
            r = 1 & r ? 3988292384 ^ r >>> 1 : r >>> 1;
          l[c] = r;
        }
        return l;
      })();
      n.exports = function(r, l, c, h) {
        var I = o, p = h + c;
        r ^= -1;
        for (var y = h; y < p; y++)
          r = r >>> 8 ^ I[255 & (r ^ l[y])];
        return -1 ^ r;
      };
    }, {}], 46: [function(i, n, s) {
      var o, r = i("../utils/common"), l = i("./trees"), c = i("./adler32"), h = i("./crc32"), I = i("./messages"), p = 0, y = 4, m = 0, A = -2, C = -1, O = 4, R = 2, F = 8, L = 9, P = 286, z = 30, W = 19, re = 2 * P + 1, ce = 15, te = 3, ee = 258, Ne = ee + te + 1, Ae = 42, Oe = 113, pe = 1, je = 2, Ve = 3, $e = 4;
      function vt(Se, si) {
        return Se.msg = I[si], si;
      }
      function Rt(Se) {
        return (Se << 1) - (4 < Se ? 9 : 0);
      }
      function ze(Se) {
        for (var si = Se.length; 0 <= --si; )
          Se[si] = 0;
      }
      function mt(Se) {
        var si = Se.state, Mt = si.pending;
        Mt > Se.avail_out && (Mt = Se.avail_out), Mt !== 0 && (r.arraySet(Se.output, si.pending_buf, si.pending_out, Mt, Se.next_out), Se.next_out += Mt, si.pending_out += Mt, Se.total_out += Mt, Se.avail_out -= Mt, si.pending -= Mt, si.pending === 0 && (si.pending_out = 0));
      }
      function Et(Se, si) {
        l._tr_flush_block(Se, 0 <= Se.block_start ? Se.block_start : -1, Se.strstart - Se.block_start, si), Se.block_start = Se.strstart, mt(Se.strm);
      }
      function it(Se, si) {
        Se.pending_buf[Se.pending++] = si;
      }
      function Dt(Se, si) {
        Se.pending_buf[Se.pending++] = si >>> 8 & 255, Se.pending_buf[Se.pending++] = 255 & si;
      }
      function Ct(Se, si) {
        var Mt, ft, rt = Se.max_chain_length, Tt = Se.strstart, jt = Se.prev_length, Jt = Se.nice_match, $t = Se.strstart > Se.w_size - Ne ? Se.strstart - (Se.w_size - Ne) : 0, ht = Se.window, Me = Se.w_mask, gt = Se.prev, yt = Se.strstart + ee, Ut = ht[Tt + jt - 1], Ht = ht[Tt + jt];
        Se.prev_length >= Se.good_match && (rt >>= 2), Jt > Se.lookahead && (Jt = Se.lookahead);
        do
          if (ht[(Mt = si) + jt] === Ht && ht[Mt + jt - 1] === Ut && ht[Mt] === ht[Tt] && ht[++Mt] === ht[Tt + 1]) {
            Tt += 2, Mt++;
            do
              ;
            while (ht[++Tt] === ht[++Mt] && ht[++Tt] === ht[++Mt] && ht[++Tt] === ht[++Mt] && ht[++Tt] === ht[++Mt] && ht[++Tt] === ht[++Mt] && ht[++Tt] === ht[++Mt] && ht[++Tt] === ht[++Mt] && ht[++Tt] === ht[++Mt] && Tt < yt);
            if (ft = ee - (yt - Tt), Tt = yt - ee, jt < ft) {
              if (Se.match_start = si, Jt <= (jt = ft))
                break;
              Ut = ht[Tt + jt - 1], Ht = ht[Tt + jt];
            }
          }
        while ((si = gt[si & Me]) > $t && --rt != 0);
        return jt <= Se.lookahead ? jt : Se.lookahead;
      }
      function Kt(Se) {
        var si, Mt, ft, rt, Tt, jt, Jt, $t, ht, Me, gt = Se.w_size;
        do {
          if (rt = Se.window_size - Se.lookahead - Se.strstart, Se.strstart >= gt + (gt - Ne)) {
            for (r.arraySet(Se.window, Se.window, gt, gt, 0), Se.match_start -= gt, Se.strstart -= gt, Se.block_start -= gt, si = Mt = Se.hash_size; ft = Se.head[--si], Se.head[si] = gt <= ft ? ft - gt : 0, --Mt; )
              ;
            for (si = Mt = gt; ft = Se.prev[--si], Se.prev[si] = gt <= ft ? ft - gt : 0, --Mt; )
              ;
            rt += gt;
          }
          if (Se.strm.avail_in === 0)
            break;
          if (jt = Se.strm, Jt = Se.window, $t = Se.strstart + Se.lookahead, ht = rt, Me = void 0, Me = jt.avail_in, ht < Me && (Me = ht), Mt = Me === 0 ? 0 : (jt.avail_in -= Me, r.arraySet(Jt, jt.input, jt.next_in, Me, $t), jt.state.wrap === 1 ? jt.adler = c(jt.adler, Jt, Me, $t) : jt.state.wrap === 2 && (jt.adler = h(jt.adler, Jt, Me, $t)), jt.next_in += Me, jt.total_in += Me, Me), Se.lookahead += Mt, Se.lookahead + Se.insert >= te)
            for (Tt = Se.strstart - Se.insert, Se.ins_h = Se.window[Tt], Se.ins_h = (Se.ins_h << Se.hash_shift ^ Se.window[Tt + 1]) & Se.hash_mask; Se.insert && (Se.ins_h = (Se.ins_h << Se.hash_shift ^ Se.window[Tt + te - 1]) & Se.hash_mask, Se.prev[Tt & Se.w_mask] = Se.head[Se.ins_h], Se.head[Se.ins_h] = Tt, Tt++, Se.insert--, !(Se.lookahead + Se.insert < te)); )
              ;
        } while (Se.lookahead < Ne && Se.strm.avail_in !== 0);
      }
      function Zt(Se, si) {
        for (var Mt, ft; ; ) {
          if (Se.lookahead < Ne) {
            if (Kt(Se), Se.lookahead < Ne && si === p)
              return pe;
            if (Se.lookahead === 0)
              break;
          }
          if (Mt = 0, Se.lookahead >= te && (Se.ins_h = (Se.ins_h << Se.hash_shift ^ Se.window[Se.strstart + te - 1]) & Se.hash_mask, Mt = Se.prev[Se.strstart & Se.w_mask] = Se.head[Se.ins_h], Se.head[Se.ins_h] = Se.strstart), Mt !== 0 && Se.strstart - Mt <= Se.w_size - Ne && (Se.match_length = Ct(Se, Mt)), Se.match_length >= te)
            if (ft = l._tr_tally(Se, Se.strstart - Se.match_start, Se.match_length - te), Se.lookahead -= Se.match_length, Se.match_length <= Se.max_lazy_match && Se.lookahead >= te) {
              for (Se.match_length--; Se.strstart++, Se.ins_h = (Se.ins_h << Se.hash_shift ^ Se.window[Se.strstart + te - 1]) & Se.hash_mask, Mt = Se.prev[Se.strstart & Se.w_mask] = Se.head[Se.ins_h], Se.head[Se.ins_h] = Se.strstart, --Se.match_length != 0; )
                ;
              Se.strstart++;
            } else
              Se.strstart += Se.match_length, Se.match_length = 0, Se.ins_h = Se.window[Se.strstart], Se.ins_h = (Se.ins_h << Se.hash_shift ^ Se.window[Se.strstart + 1]) & Se.hash_mask;
          else
            ft = l._tr_tally(Se, 0, Se.window[Se.strstart]), Se.lookahead--, Se.strstart++;
          if (ft && (Et(Se, !1), Se.strm.avail_out === 0))
            return pe;
        }
        return Se.insert = Se.strstart < te - 1 ? Se.strstart : te - 1, si === y ? (Et(Se, !0), Se.strm.avail_out === 0 ? Ve : $e) : Se.last_lit && (Et(Se, !1), Se.strm.avail_out === 0) ? pe : je;
      }
      function Xt(Se, si) {
        for (var Mt, ft, rt; ; ) {
          if (Se.lookahead < Ne) {
            if (Kt(Se), Se.lookahead < Ne && si === p)
              return pe;
            if (Se.lookahead === 0)
              break;
          }
          if (Mt = 0, Se.lookahead >= te && (Se.ins_h = (Se.ins_h << Se.hash_shift ^ Se.window[Se.strstart + te - 1]) & Se.hash_mask, Mt = Se.prev[Se.strstart & Se.w_mask] = Se.head[Se.ins_h], Se.head[Se.ins_h] = Se.strstart), Se.prev_length = Se.match_length, Se.prev_match = Se.match_start, Se.match_length = te - 1, Mt !== 0 && Se.prev_length < Se.max_lazy_match && Se.strstart - Mt <= Se.w_size - Ne && (Se.match_length = Ct(Se, Mt), Se.match_length <= 5 && (Se.strategy === 1 || Se.match_length === te && 4096 < Se.strstart - Se.match_start) && (Se.match_length = te - 1)), Se.prev_length >= te && Se.match_length <= Se.prev_length) {
            for (rt = Se.strstart + Se.lookahead - te, ft = l._tr_tally(Se, Se.strstart - 1 - Se.prev_match, Se.prev_length - te), Se.lookahead -= Se.prev_length - 1, Se.prev_length -= 2; ++Se.strstart <= rt && (Se.ins_h = (Se.ins_h << Se.hash_shift ^ Se.window[Se.strstart + te - 1]) & Se.hash_mask, Mt = Se.prev[Se.strstart & Se.w_mask] = Se.head[Se.ins_h], Se.head[Se.ins_h] = Se.strstart), --Se.prev_length != 0; )
              ;
            if (Se.match_available = 0, Se.match_length = te - 1, Se.strstart++, ft && (Et(Se, !1), Se.strm.avail_out === 0))
              return pe;
          } else if (Se.match_available) {
            if ((ft = l._tr_tally(Se, 0, Se.window[Se.strstart - 1])) && Et(Se, !1), Se.strstart++, Se.lookahead--, Se.strm.avail_out === 0)
              return pe;
          } else
            Se.match_available = 1, Se.strstart++, Se.lookahead--;
        }
        return Se.match_available && (ft = l._tr_tally(Se, 0, Se.window[Se.strstart - 1]), Se.match_available = 0), Se.insert = Se.strstart < te - 1 ? Se.strstart : te - 1, si === y ? (Et(Se, !0), Se.strm.avail_out === 0 ? Ve : $e) : Se.last_lit && (Et(Se, !1), Se.strm.avail_out === 0) ? pe : je;
      }
      function gi(Se, si, Mt, ft, rt) {
        this.good_length = Se, this.max_lazy = si, this.nice_length = Mt, this.max_chain = ft, this.func = rt;
      }
      function Wt() {
        this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = F, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new r.Buf16(2 * re), this.dyn_dtree = new r.Buf16(2 * (2 * z + 1)), this.bl_tree = new r.Buf16(2 * (2 * W + 1)), ze(this.dyn_ltree), ze(this.dyn_dtree), ze(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new r.Buf16(ce + 1), this.heap = new r.Buf16(2 * P + 1), ze(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new r.Buf16(2 * P + 1), ze(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
      }
      function Di(Se) {
        var si;
        return Se && Se.state ? (Se.total_in = Se.total_out = 0, Se.data_type = R, (si = Se.state).pending = 0, si.pending_out = 0, si.wrap < 0 && (si.wrap = -si.wrap), si.status = si.wrap ? Ae : Oe, Se.adler = si.wrap === 2 ? 0 : 1, si.last_flush = p, l._tr_init(si), m) : vt(Se, A);
      }
      function ni(Se) {
        var si = Di(Se);
        return si === m && (function(Mt) {
          Mt.window_size = 2 * Mt.w_size, ze(Mt.head), Mt.max_lazy_match = o[Mt.level].max_lazy, Mt.good_match = o[Mt.level].good_length, Mt.nice_match = o[Mt.level].nice_length, Mt.max_chain_length = o[Mt.level].max_chain, Mt.strstart = 0, Mt.block_start = 0, Mt.lookahead = 0, Mt.insert = 0, Mt.match_length = Mt.prev_length = te - 1, Mt.match_available = 0, Mt.ins_h = 0;
        })(Se.state), si;
      }
      function Ci(Se, si, Mt, ft, rt, Tt) {
        if (!Se)
          return A;
        var jt = 1;
        if (si === C && (si = 6), ft < 0 ? (jt = 0, ft = -ft) : 15 < ft && (jt = 2, ft -= 16), rt < 1 || L < rt || Mt !== F || ft < 8 || 15 < ft || si < 0 || 9 < si || Tt < 0 || O < Tt)
          return vt(Se, A);
        ft === 8 && (ft = 9);
        var Jt = new Wt();
        return (Se.state = Jt).strm = Se, Jt.wrap = jt, Jt.gzhead = null, Jt.w_bits = ft, Jt.w_size = 1 << Jt.w_bits, Jt.w_mask = Jt.w_size - 1, Jt.hash_bits = rt + 7, Jt.hash_size = 1 << Jt.hash_bits, Jt.hash_mask = Jt.hash_size - 1, Jt.hash_shift = ~~((Jt.hash_bits + te - 1) / te), Jt.window = new r.Buf8(2 * Jt.w_size), Jt.head = new r.Buf16(Jt.hash_size), Jt.prev = new r.Buf16(Jt.w_size), Jt.lit_bufsize = 1 << rt + 6, Jt.pending_buf_size = 4 * Jt.lit_bufsize, Jt.pending_buf = new r.Buf8(Jt.pending_buf_size), Jt.d_buf = 1 * Jt.lit_bufsize, Jt.l_buf = 3 * Jt.lit_bufsize, Jt.level = si, Jt.strategy = Tt, Jt.method = Mt, ni(Se);
      }
      o = [new gi(0, 0, 0, 0, function(Se, si) {
        var Mt = 65535;
        for (Mt > Se.pending_buf_size - 5 && (Mt = Se.pending_buf_size - 5); ; ) {
          if (Se.lookahead <= 1) {
            if (Kt(Se), Se.lookahead === 0 && si === p)
              return pe;
            if (Se.lookahead === 0)
              break;
          }
          Se.strstart += Se.lookahead, Se.lookahead = 0;
          var ft = Se.block_start + Mt;
          if ((Se.strstart === 0 || Se.strstart >= ft) && (Se.lookahead = Se.strstart - ft, Se.strstart = ft, Et(Se, !1), Se.strm.avail_out === 0) || Se.strstart - Se.block_start >= Se.w_size - Ne && (Et(Se, !1), Se.strm.avail_out === 0))
            return pe;
        }
        return Se.insert = 0, si === y ? (Et(Se, !0), Se.strm.avail_out === 0 ? Ve : $e) : (Se.strstart > Se.block_start && (Et(Se, !1), Se.strm.avail_out), pe);
      }), new gi(4, 4, 8, 4, Zt), new gi(4, 5, 16, 8, Zt), new gi(4, 6, 32, 32, Zt), new gi(4, 4, 16, 16, Xt), new gi(8, 16, 32, 32, Xt), new gi(8, 16, 128, 128, Xt), new gi(8, 32, 128, 256, Xt), new gi(32, 128, 258, 1024, Xt), new gi(32, 258, 258, 4096, Xt)], s.deflateInit = function(Se, si) {
        return Ci(Se, si, F, 15, 8, 0);
      }, s.deflateInit2 = Ci, s.deflateReset = ni, s.deflateResetKeep = Di, s.deflateSetHeader = function(Se, si) {
        return Se && Se.state ? Se.state.wrap !== 2 ? A : (Se.state.gzhead = si, m) : A;
      }, s.deflate = function(Se, si) {
        var Mt, ft, rt, Tt;
        if (!Se || !Se.state || 5 < si || si < 0)
          return Se ? vt(Se, A) : A;
        if (ft = Se.state, !Se.output || !Se.input && Se.avail_in !== 0 || ft.status === 666 && si !== y)
          return vt(Se, Se.avail_out === 0 ? -5 : A);
        if (ft.strm = Se, Mt = ft.last_flush, ft.last_flush = si, ft.status === Ae)
          if (ft.wrap === 2)
            Se.adler = 0, it(ft, 31), it(ft, 139), it(ft, 8), ft.gzhead ? (it(ft, (ft.gzhead.text ? 1 : 0) + (ft.gzhead.hcrc ? 2 : 0) + (ft.gzhead.extra ? 4 : 0) + (ft.gzhead.name ? 8 : 0) + (ft.gzhead.comment ? 16 : 0)), it(ft, 255 & ft.gzhead.time), it(ft, ft.gzhead.time >> 8 & 255), it(ft, ft.gzhead.time >> 16 & 255), it(ft, ft.gzhead.time >> 24 & 255), it(ft, ft.level === 9 ? 2 : 2 <= ft.strategy || ft.level < 2 ? 4 : 0), it(ft, 255 & ft.gzhead.os), ft.gzhead.extra && ft.gzhead.extra.length && (it(ft, 255 & ft.gzhead.extra.length), it(ft, ft.gzhead.extra.length >> 8 & 255)), ft.gzhead.hcrc && (Se.adler = h(Se.adler, ft.pending_buf, ft.pending, 0)), ft.gzindex = 0, ft.status = 69) : (it(ft, 0), it(ft, 0), it(ft, 0), it(ft, 0), it(ft, 0), it(ft, ft.level === 9 ? 2 : 2 <= ft.strategy || ft.level < 2 ? 4 : 0), it(ft, 3), ft.status = Oe);
          else {
            var jt = F + (ft.w_bits - 8 << 4) << 8;
            jt |= (2 <= ft.strategy || ft.level < 2 ? 0 : ft.level < 6 ? 1 : ft.level === 6 ? 2 : 3) << 6, ft.strstart !== 0 && (jt |= 32), jt += 31 - jt % 31, ft.status = Oe, Dt(ft, jt), ft.strstart !== 0 && (Dt(ft, Se.adler >>> 16), Dt(ft, 65535 & Se.adler)), Se.adler = 1;
          }
        if (ft.status === 69)
          if (ft.gzhead.extra) {
            for (rt = ft.pending; ft.gzindex < (65535 & ft.gzhead.extra.length) && (ft.pending !== ft.pending_buf_size || (ft.gzhead.hcrc && ft.pending > rt && (Se.adler = h(Se.adler, ft.pending_buf, ft.pending - rt, rt)), mt(Se), rt = ft.pending, ft.pending !== ft.pending_buf_size)); )
              it(ft, 255 & ft.gzhead.extra[ft.gzindex]), ft.gzindex++;
            ft.gzhead.hcrc && ft.pending > rt && (Se.adler = h(Se.adler, ft.pending_buf, ft.pending - rt, rt)), ft.gzindex === ft.gzhead.extra.length && (ft.gzindex = 0, ft.status = 73);
          } else
            ft.status = 73;
        if (ft.status === 73)
          if (ft.gzhead.name) {
            rt = ft.pending;
            do {
              if (ft.pending === ft.pending_buf_size && (ft.gzhead.hcrc && ft.pending > rt && (Se.adler = h(Se.adler, ft.pending_buf, ft.pending - rt, rt)), mt(Se), rt = ft.pending, ft.pending === ft.pending_buf_size)) {
                Tt = 1;
                break;
              }
              Tt = ft.gzindex < ft.gzhead.name.length ? 255 & ft.gzhead.name.charCodeAt(ft.gzindex++) : 0, it(ft, Tt);
            } while (Tt !== 0);
            ft.gzhead.hcrc && ft.pending > rt && (Se.adler = h(Se.adler, ft.pending_buf, ft.pending - rt, rt)), Tt === 0 && (ft.gzindex = 0, ft.status = 91);
          } else
            ft.status = 91;
        if (ft.status === 91)
          if (ft.gzhead.comment) {
            rt = ft.pending;
            do {
              if (ft.pending === ft.pending_buf_size && (ft.gzhead.hcrc && ft.pending > rt && (Se.adler = h(Se.adler, ft.pending_buf, ft.pending - rt, rt)), mt(Se), rt = ft.pending, ft.pending === ft.pending_buf_size)) {
                Tt = 1;
                break;
              }
              Tt = ft.gzindex < ft.gzhead.comment.length ? 255 & ft.gzhead.comment.charCodeAt(ft.gzindex++) : 0, it(ft, Tt);
            } while (Tt !== 0);
            ft.gzhead.hcrc && ft.pending > rt && (Se.adler = h(Se.adler, ft.pending_buf, ft.pending - rt, rt)), Tt === 0 && (ft.status = 103);
          } else
            ft.status = 103;
        if (ft.status === 103 && (ft.gzhead.hcrc ? (ft.pending + 2 > ft.pending_buf_size && mt(Se), ft.pending + 2 <= ft.pending_buf_size && (it(ft, 255 & Se.adler), it(ft, Se.adler >> 8 & 255), Se.adler = 0, ft.status = Oe)) : ft.status = Oe), ft.pending !== 0) {
          if (mt(Se), Se.avail_out === 0)
            return ft.last_flush = -1, m;
        } else if (Se.avail_in === 0 && Rt(si) <= Rt(Mt) && si !== y)
          return vt(Se, -5);
        if (ft.status === 666 && Se.avail_in !== 0)
          return vt(Se, -5);
        if (Se.avail_in !== 0 || ft.lookahead !== 0 || si !== p && ft.status !== 666) {
          var Jt = ft.strategy === 2 ? (function($t, ht) {
            for (var Me; ; ) {
              if ($t.lookahead === 0 && (Kt($t), $t.lookahead === 0)) {
                if (ht === p)
                  return pe;
                break;
              }
              if ($t.match_length = 0, Me = l._tr_tally($t, 0, $t.window[$t.strstart]), $t.lookahead--, $t.strstart++, Me && (Et($t, !1), $t.strm.avail_out === 0))
                return pe;
            }
            return $t.insert = 0, ht === y ? (Et($t, !0), $t.strm.avail_out === 0 ? Ve : $e) : $t.last_lit && (Et($t, !1), $t.strm.avail_out === 0) ? pe : je;
          })(ft, si) : ft.strategy === 3 ? (function($t, ht) {
            for (var Me, gt, yt, Ut, Ht = $t.window; ; ) {
              if ($t.lookahead <= ee) {
                if (Kt($t), $t.lookahead <= ee && ht === p)
                  return pe;
                if ($t.lookahead === 0)
                  break;
              }
              if ($t.match_length = 0, $t.lookahead >= te && 0 < $t.strstart && (gt = Ht[yt = $t.strstart - 1]) === Ht[++yt] && gt === Ht[++yt] && gt === Ht[++yt]) {
                Ut = $t.strstart + ee;
                do
                  ;
                while (gt === Ht[++yt] && gt === Ht[++yt] && gt === Ht[++yt] && gt === Ht[++yt] && gt === Ht[++yt] && gt === Ht[++yt] && gt === Ht[++yt] && gt === Ht[++yt] && yt < Ut);
                $t.match_length = ee - (Ut - yt), $t.match_length > $t.lookahead && ($t.match_length = $t.lookahead);
              }
              if ($t.match_length >= te ? (Me = l._tr_tally($t, 1, $t.match_length - te), $t.lookahead -= $t.match_length, $t.strstart += $t.match_length, $t.match_length = 0) : (Me = l._tr_tally($t, 0, $t.window[$t.strstart]), $t.lookahead--, $t.strstart++), Me && (Et($t, !1), $t.strm.avail_out === 0))
                return pe;
            }
            return $t.insert = 0, ht === y ? (Et($t, !0), $t.strm.avail_out === 0 ? Ve : $e) : $t.last_lit && (Et($t, !1), $t.strm.avail_out === 0) ? pe : je;
          })(ft, si) : o[ft.level].func(ft, si);
          if (Jt !== Ve && Jt !== $e || (ft.status = 666), Jt === pe || Jt === Ve)
            return Se.avail_out === 0 && (ft.last_flush = -1), m;
          if (Jt === je && (si === 1 ? l._tr_align(ft) : si !== 5 && (l._tr_stored_block(ft, 0, 0, !1), si === 3 && (ze(ft.head), ft.lookahead === 0 && (ft.strstart = 0, ft.block_start = 0, ft.insert = 0))), mt(Se), Se.avail_out === 0))
            return ft.last_flush = -1, m;
        }
        return si !== y ? m : ft.wrap <= 0 ? 1 : (ft.wrap === 2 ? (it(ft, 255 & Se.adler), it(ft, Se.adler >> 8 & 255), it(ft, Se.adler >> 16 & 255), it(ft, Se.adler >> 24 & 255), it(ft, 255 & Se.total_in), it(ft, Se.total_in >> 8 & 255), it(ft, Se.total_in >> 16 & 255), it(ft, Se.total_in >> 24 & 255)) : (Dt(ft, Se.adler >>> 16), Dt(ft, 65535 & Se.adler)), mt(Se), 0 < ft.wrap && (ft.wrap = -ft.wrap), ft.pending !== 0 ? m : 1);
      }, s.deflateEnd = function(Se) {
        var si;
        return Se && Se.state ? (si = Se.state.status) !== Ae && si !== 69 && si !== 73 && si !== 91 && si !== 103 && si !== Oe && si !== 666 ? vt(Se, A) : (Se.state = null, si === Oe ? vt(Se, -3) : m) : A;
      }, s.deflateSetDictionary = function(Se, si) {
        var Mt, ft, rt, Tt, jt, Jt, $t, ht, Me = si.length;
        if (!Se || !Se.state || (Tt = (Mt = Se.state).wrap) === 2 || Tt === 1 && Mt.status !== Ae || Mt.lookahead)
          return A;
        for (Tt === 1 && (Se.adler = c(Se.adler, si, Me, 0)), Mt.wrap = 0, Me >= Mt.w_size && (Tt === 0 && (ze(Mt.head), Mt.strstart = 0, Mt.block_start = 0, Mt.insert = 0), ht = new r.Buf8(Mt.w_size), r.arraySet(ht, si, Me - Mt.w_size, Mt.w_size, 0), si = ht, Me = Mt.w_size), jt = Se.avail_in, Jt = Se.next_in, $t = Se.input, Se.avail_in = Me, Se.next_in = 0, Se.input = si, Kt(Mt); Mt.lookahead >= te; ) {
          for (ft = Mt.strstart, rt = Mt.lookahead - (te - 1); Mt.ins_h = (Mt.ins_h << Mt.hash_shift ^ Mt.window[ft + te - 1]) & Mt.hash_mask, Mt.prev[ft & Mt.w_mask] = Mt.head[Mt.ins_h], Mt.head[Mt.ins_h] = ft, ft++, --rt; )
            ;
          Mt.strstart = ft, Mt.lookahead = te - 1, Kt(Mt);
        }
        return Mt.strstart += Mt.lookahead, Mt.block_start = Mt.strstart, Mt.insert = Mt.lookahead, Mt.lookahead = 0, Mt.match_length = Mt.prev_length = te - 1, Mt.match_available = 0, Se.next_in = Jt, Se.input = $t, Se.avail_in = jt, Mt.wrap = Tt, m;
      }, s.deflateInfo = "pako deflate (from Nodeca project)";
    }, { "../utils/common": 41, "./adler32": 43, "./crc32": 45, "./messages": 51, "./trees": 52 }], 47: [function(i, n, s) {
      n.exports = function() {
        this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
      };
    }, {}], 48: [function(i, n, s) {
      n.exports = function(o, r) {
        var l, c, h, I, p, y, m, A, C, O, R, F, L, P, z, W, re, ce, te, ee, Ne, Ae, Oe, pe, je;
        l = o.state, c = o.next_in, pe = o.input, h = c + (o.avail_in - 5), I = o.next_out, je = o.output, p = I - (r - o.avail_out), y = I + (o.avail_out - 257), m = l.dmax, A = l.wsize, C = l.whave, O = l.wnext, R = l.window, F = l.hold, L = l.bits, P = l.lencode, z = l.distcode, W = (1 << l.lenbits) - 1, re = (1 << l.distbits) - 1;
        e:
          do {
            L < 15 && (F += pe[c++] << L, L += 8, F += pe[c++] << L, L += 8), ce = P[F & W];
            t:
              for (; ; ) {
                if (F >>>= te = ce >>> 24, L -= te, (te = ce >>> 16 & 255) === 0)
                  je[I++] = 65535 & ce;
                else {
                  if (!(16 & te)) {
                    if ((64 & te) == 0) {
                      ce = P[(65535 & ce) + (F & (1 << te) - 1)];
                      continue t;
                    }
                    if (32 & te) {
                      l.mode = 12;
                      break e;
                    }
                    o.msg = "invalid literal/length code", l.mode = 30;
                    break e;
                  }
                  ee = 65535 & ce, (te &= 15) && (L < te && (F += pe[c++] << L, L += 8), ee += F & (1 << te) - 1, F >>>= te, L -= te), L < 15 && (F += pe[c++] << L, L += 8, F += pe[c++] << L, L += 8), ce = z[F & re];
                  i:
                    for (; ; ) {
                      if (F >>>= te = ce >>> 24, L -= te, !(16 & (te = ce >>> 16 & 255))) {
                        if ((64 & te) == 0) {
                          ce = z[(65535 & ce) + (F & (1 << te) - 1)];
                          continue i;
                        }
                        o.msg = "invalid distance code", l.mode = 30;
                        break e;
                      }
                      if (Ne = 65535 & ce, L < (te &= 15) && (F += pe[c++] << L, (L += 8) < te && (F += pe[c++] << L, L += 8)), m < (Ne += F & (1 << te) - 1)) {
                        o.msg = "invalid distance too far back", l.mode = 30;
                        break e;
                      }
                      if (F >>>= te, L -= te, (te = I - p) < Ne) {
                        if (C < (te = Ne - te) && l.sane) {
                          o.msg = "invalid distance too far back", l.mode = 30;
                          break e;
                        }
                        if (Oe = R, (Ae = 0) === O) {
                          if (Ae += A - te, te < ee) {
                            for (ee -= te; je[I++] = R[Ae++], --te; )
                              ;
                            Ae = I - Ne, Oe = je;
                          }
                        } else if (O < te) {
                          if (Ae += A + O - te, (te -= O) < ee) {
                            for (ee -= te; je[I++] = R[Ae++], --te; )
                              ;
                            if (Ae = 0, O < ee) {
                              for (ee -= te = O; je[I++] = R[Ae++], --te; )
                                ;
                              Ae = I - Ne, Oe = je;
                            }
                          }
                        } else if (Ae += O - te, te < ee) {
                          for (ee -= te; je[I++] = R[Ae++], --te; )
                            ;
                          Ae = I - Ne, Oe = je;
                        }
                        for (; 2 < ee; )
                          je[I++] = Oe[Ae++], je[I++] = Oe[Ae++], je[I++] = Oe[Ae++], ee -= 3;
                        ee && (je[I++] = Oe[Ae++], 1 < ee && (je[I++] = Oe[Ae++]));
                      } else {
                        for (Ae = I - Ne; je[I++] = je[Ae++], je[I++] = je[Ae++], je[I++] = je[Ae++], 2 < (ee -= 3); )
                          ;
                        ee && (je[I++] = je[Ae++], 1 < ee && (je[I++] = je[Ae++]));
                      }
                      break;
                    }
                }
                break;
              }
          } while (c < h && I < y);
        c -= ee = L >> 3, F &= (1 << (L -= ee << 3)) - 1, o.next_in = c, o.next_out = I, o.avail_in = c < h ? h - c + 5 : 5 - (c - h), o.avail_out = I < y ? y - I + 257 : 257 - (I - y), l.hold = F, l.bits = L;
      };
    }, {}], 49: [function(i, n, s) {
      var o = i("../utils/common"), r = i("./adler32"), l = i("./crc32"), c = i("./inffast"), h = i("./inftrees"), I = 1, p = 2, y = 0, m = -2, A = 1, C = 852, O = 592;
      function R(Ae) {
        return (Ae >>> 24 & 255) + (Ae >>> 8 & 65280) + ((65280 & Ae) << 8) + ((255 & Ae) << 24);
      }
      function F() {
        this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new o.Buf16(320), this.work = new o.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
      }
      function L(Ae) {
        var Oe;
        return Ae && Ae.state ? (Oe = Ae.state, Ae.total_in = Ae.total_out = Oe.total = 0, Ae.msg = "", Oe.wrap && (Ae.adler = 1 & Oe.wrap), Oe.mode = A, Oe.last = 0, Oe.havedict = 0, Oe.dmax = 32768, Oe.head = null, Oe.hold = 0, Oe.bits = 0, Oe.lencode = Oe.lendyn = new o.Buf32(C), Oe.distcode = Oe.distdyn = new o.Buf32(O), Oe.sane = 1, Oe.back = -1, y) : m;
      }
      function P(Ae) {
        var Oe;
        return Ae && Ae.state ? ((Oe = Ae.state).wsize = 0, Oe.whave = 0, Oe.wnext = 0, L(Ae)) : m;
      }
      function z(Ae, Oe) {
        var pe, je;
        return Ae && Ae.state ? (je = Ae.state, Oe < 0 ? (pe = 0, Oe = -Oe) : (pe = 1 + (Oe >> 4), Oe < 48 && (Oe &= 15)), Oe && (Oe < 8 || 15 < Oe) ? m : (je.window !== null && je.wbits !== Oe && (je.window = null), je.wrap = pe, je.wbits = Oe, P(Ae))) : m;
      }
      function W(Ae, Oe) {
        var pe, je;
        return Ae ? (je = new F(), (Ae.state = je).window = null, (pe = z(Ae, Oe)) !== y && (Ae.state = null), pe) : m;
      }
      var re, ce, te = !0;
      function ee(Ae) {
        if (te) {
          var Oe;
          for (re = new o.Buf32(512), ce = new o.Buf32(32), Oe = 0; Oe < 144; )
            Ae.lens[Oe++] = 8;
          for (; Oe < 256; )
            Ae.lens[Oe++] = 9;
          for (; Oe < 280; )
            Ae.lens[Oe++] = 7;
          for (; Oe < 288; )
            Ae.lens[Oe++] = 8;
          for (h(I, Ae.lens, 0, 288, re, 0, Ae.work, { bits: 9 }), Oe = 0; Oe < 32; )
            Ae.lens[Oe++] = 5;
          h(p, Ae.lens, 0, 32, ce, 0, Ae.work, { bits: 5 }), te = !1;
        }
        Ae.lencode = re, Ae.lenbits = 9, Ae.distcode = ce, Ae.distbits = 5;
      }
      function Ne(Ae, Oe, pe, je) {
        var Ve, $e = Ae.state;
        return $e.window === null && ($e.wsize = 1 << $e.wbits, $e.wnext = 0, $e.whave = 0, $e.window = new o.Buf8($e.wsize)), je >= $e.wsize ? (o.arraySet($e.window, Oe, pe - $e.wsize, $e.wsize, 0), $e.wnext = 0, $e.whave = $e.wsize) : (je < (Ve = $e.wsize - $e.wnext) && (Ve = je), o.arraySet($e.window, Oe, pe - je, Ve, $e.wnext), (je -= Ve) ? (o.arraySet($e.window, Oe, pe - je, je, 0), $e.wnext = je, $e.whave = $e.wsize) : ($e.wnext += Ve, $e.wnext === $e.wsize && ($e.wnext = 0), $e.whave < $e.wsize && ($e.whave += Ve))), 0;
      }
      s.inflateReset = P, s.inflateReset2 = z, s.inflateResetKeep = L, s.inflateInit = function(Ae) {
        return W(Ae, 15);
      }, s.inflateInit2 = W, s.inflate = function(Ae, Oe) {
        var pe, je, Ve, $e, vt, Rt, ze, mt, Et, it, Dt, Ct, Kt, Zt, Xt, gi, Wt, Di, ni, Ci, Se, si, Mt, ft, rt = 0, Tt = new o.Buf8(4), jt = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
        if (!Ae || !Ae.state || !Ae.output || !Ae.input && Ae.avail_in !== 0)
          return m;
        (pe = Ae.state).mode === 12 && (pe.mode = 13), vt = Ae.next_out, Ve = Ae.output, ze = Ae.avail_out, $e = Ae.next_in, je = Ae.input, Rt = Ae.avail_in, mt = pe.hold, Et = pe.bits, it = Rt, Dt = ze, si = y;
        e:
          for (; ; )
            switch (pe.mode) {
              case A:
                if (pe.wrap === 0) {
                  pe.mode = 13;
                  break;
                }
                for (; Et < 16; ) {
                  if (Rt === 0)
                    break e;
                  Rt--, mt += je[$e++] << Et, Et += 8;
                }
                if (2 & pe.wrap && mt === 35615) {
                  Tt[pe.check = 0] = 255 & mt, Tt[1] = mt >>> 8 & 255, pe.check = l(pe.check, Tt, 2, 0), Et = mt = 0, pe.mode = 2;
                  break;
                }
                if (pe.flags = 0, pe.head && (pe.head.done = !1), !(1 & pe.wrap) || (((255 & mt) << 8) + (mt >> 8)) % 31) {
                  Ae.msg = "incorrect header check", pe.mode = 30;
                  break;
                }
                if ((15 & mt) != 8) {
                  Ae.msg = "unknown compression method", pe.mode = 30;
                  break;
                }
                if (Et -= 4, Se = 8 + (15 & (mt >>>= 4)), pe.wbits === 0)
                  pe.wbits = Se;
                else if (Se > pe.wbits) {
                  Ae.msg = "invalid window size", pe.mode = 30;
                  break;
                }
                pe.dmax = 1 << Se, Ae.adler = pe.check = 1, pe.mode = 512 & mt ? 10 : 12, Et = mt = 0;
                break;
              case 2:
                for (; Et < 16; ) {
                  if (Rt === 0)
                    break e;
                  Rt--, mt += je[$e++] << Et, Et += 8;
                }
                if (pe.flags = mt, (255 & pe.flags) != 8) {
                  Ae.msg = "unknown compression method", pe.mode = 30;
                  break;
                }
                if (57344 & pe.flags) {
                  Ae.msg = "unknown header flags set", pe.mode = 30;
                  break;
                }
                pe.head && (pe.head.text = mt >> 8 & 1), 512 & pe.flags && (Tt[0] = 255 & mt, Tt[1] = mt >>> 8 & 255, pe.check = l(pe.check, Tt, 2, 0)), Et = mt = 0, pe.mode = 3;
              case 3:
                for (; Et < 32; ) {
                  if (Rt === 0)
                    break e;
                  Rt--, mt += je[$e++] << Et, Et += 8;
                }
                pe.head && (pe.head.time = mt), 512 & pe.flags && (Tt[0] = 255 & mt, Tt[1] = mt >>> 8 & 255, Tt[2] = mt >>> 16 & 255, Tt[3] = mt >>> 24 & 255, pe.check = l(pe.check, Tt, 4, 0)), Et = mt = 0, pe.mode = 4;
              case 4:
                for (; Et < 16; ) {
                  if (Rt === 0)
                    break e;
                  Rt--, mt += je[$e++] << Et, Et += 8;
                }
                pe.head && (pe.head.xflags = 255 & mt, pe.head.os = mt >> 8), 512 & pe.flags && (Tt[0] = 255 & mt, Tt[1] = mt >>> 8 & 255, pe.check = l(pe.check, Tt, 2, 0)), Et = mt = 0, pe.mode = 5;
              case 5:
                if (1024 & pe.flags) {
                  for (; Et < 16; ) {
                    if (Rt === 0)
                      break e;
                    Rt--, mt += je[$e++] << Et, Et += 8;
                  }
                  pe.length = mt, pe.head && (pe.head.extra_len = mt), 512 & pe.flags && (Tt[0] = 255 & mt, Tt[1] = mt >>> 8 & 255, pe.check = l(pe.check, Tt, 2, 0)), Et = mt = 0;
                } else
                  pe.head && (pe.head.extra = null);
                pe.mode = 6;
              case 6:
                if (1024 & pe.flags && (Rt < (Ct = pe.length) && (Ct = Rt), Ct && (pe.head && (Se = pe.head.extra_len - pe.length, pe.head.extra || (pe.head.extra = new Array(pe.head.extra_len)), o.arraySet(pe.head.extra, je, $e, Ct, Se)), 512 & pe.flags && (pe.check = l(pe.check, je, Ct, $e)), Rt -= Ct, $e += Ct, pe.length -= Ct), pe.length))
                  break e;
                pe.length = 0, pe.mode = 7;
              case 7:
                if (2048 & pe.flags) {
                  if (Rt === 0)
                    break e;
                  for (Ct = 0; Se = je[$e + Ct++], pe.head && Se && pe.length < 65536 && (pe.head.name += String.fromCharCode(Se)), Se && Ct < Rt; )
                    ;
                  if (512 & pe.flags && (pe.check = l(pe.check, je, Ct, $e)), Rt -= Ct, $e += Ct, Se)
                    break e;
                } else
                  pe.head && (pe.head.name = null);
                pe.length = 0, pe.mode = 8;
              case 8:
                if (4096 & pe.flags) {
                  if (Rt === 0)
                    break e;
                  for (Ct = 0; Se = je[$e + Ct++], pe.head && Se && pe.length < 65536 && (pe.head.comment += String.fromCharCode(Se)), Se && Ct < Rt; )
                    ;
                  if (512 & pe.flags && (pe.check = l(pe.check, je, Ct, $e)), Rt -= Ct, $e += Ct, Se)
                    break e;
                } else
                  pe.head && (pe.head.comment = null);
                pe.mode = 9;
              case 9:
                if (512 & pe.flags) {
                  for (; Et < 16; ) {
                    if (Rt === 0)
                      break e;
                    Rt--, mt += je[$e++] << Et, Et += 8;
                  }
                  if (mt !== (65535 & pe.check)) {
                    Ae.msg = "header crc mismatch", pe.mode = 30;
                    break;
                  }
                  Et = mt = 0;
                }
                pe.head && (pe.head.hcrc = pe.flags >> 9 & 1, pe.head.done = !0), Ae.adler = pe.check = 0, pe.mode = 12;
                break;
              case 10:
                for (; Et < 32; ) {
                  if (Rt === 0)
                    break e;
                  Rt--, mt += je[$e++] << Et, Et += 8;
                }
                Ae.adler = pe.check = R(mt), Et = mt = 0, pe.mode = 11;
              case 11:
                if (pe.havedict === 0)
                  return Ae.next_out = vt, Ae.avail_out = ze, Ae.next_in = $e, Ae.avail_in = Rt, pe.hold = mt, pe.bits = Et, 2;
                Ae.adler = pe.check = 1, pe.mode = 12;
              case 12:
                if (Oe === 5 || Oe === 6)
                  break e;
              case 13:
                if (pe.last) {
                  mt >>>= 7 & Et, Et -= 7 & Et, pe.mode = 27;
                  break;
                }
                for (; Et < 3; ) {
                  if (Rt === 0)
                    break e;
                  Rt--, mt += je[$e++] << Et, Et += 8;
                }
                switch (pe.last = 1 & mt, Et -= 1, 3 & (mt >>>= 1)) {
                  case 0:
                    pe.mode = 14;
                    break;
                  case 1:
                    if (ee(pe), pe.mode = 20, Oe !== 6)
                      break;
                    mt >>>= 2, Et -= 2;
                    break e;
                  case 2:
                    pe.mode = 17;
                    break;
                  case 3:
                    Ae.msg = "invalid block type", pe.mode = 30;
                }
                mt >>>= 2, Et -= 2;
                break;
              case 14:
                for (mt >>>= 7 & Et, Et -= 7 & Et; Et < 32; ) {
                  if (Rt === 0)
                    break e;
                  Rt--, mt += je[$e++] << Et, Et += 8;
                }
                if ((65535 & mt) != (mt >>> 16 ^ 65535)) {
                  Ae.msg = "invalid stored block lengths", pe.mode = 30;
                  break;
                }
                if (pe.length = 65535 & mt, Et = mt = 0, pe.mode = 15, Oe === 6)
                  break e;
              case 15:
                pe.mode = 16;
              case 16:
                if (Ct = pe.length) {
                  if (Rt < Ct && (Ct = Rt), ze < Ct && (Ct = ze), Ct === 0)
                    break e;
                  o.arraySet(Ve, je, $e, Ct, vt), Rt -= Ct, $e += Ct, ze -= Ct, vt += Ct, pe.length -= Ct;
                  break;
                }
                pe.mode = 12;
                break;
              case 17:
                for (; Et < 14; ) {
                  if (Rt === 0)
                    break e;
                  Rt--, mt += je[$e++] << Et, Et += 8;
                }
                if (pe.nlen = 257 + (31 & mt), mt >>>= 5, Et -= 5, pe.ndist = 1 + (31 & mt), mt >>>= 5, Et -= 5, pe.ncode = 4 + (15 & mt), mt >>>= 4, Et -= 4, 286 < pe.nlen || 30 < pe.ndist) {
                  Ae.msg = "too many length or distance symbols", pe.mode = 30;
                  break;
                }
                pe.have = 0, pe.mode = 18;
              case 18:
                for (; pe.have < pe.ncode; ) {
                  for (; Et < 3; ) {
                    if (Rt === 0)
                      break e;
                    Rt--, mt += je[$e++] << Et, Et += 8;
                  }
                  pe.lens[jt[pe.have++]] = 7 & mt, mt >>>= 3, Et -= 3;
                }
                for (; pe.have < 19; )
                  pe.lens[jt[pe.have++]] = 0;
                if (pe.lencode = pe.lendyn, pe.lenbits = 7, Mt = { bits: pe.lenbits }, si = h(0, pe.lens, 0, 19, pe.lencode, 0, pe.work, Mt), pe.lenbits = Mt.bits, si) {
                  Ae.msg = "invalid code lengths set", pe.mode = 30;
                  break;
                }
                pe.have = 0, pe.mode = 19;
              case 19:
                for (; pe.have < pe.nlen + pe.ndist; ) {
                  for (; gi = (rt = pe.lencode[mt & (1 << pe.lenbits) - 1]) >>> 16 & 255, Wt = 65535 & rt, !((Xt = rt >>> 24) <= Et); ) {
                    if (Rt === 0)
                      break e;
                    Rt--, mt += je[$e++] << Et, Et += 8;
                  }
                  if (Wt < 16)
                    mt >>>= Xt, Et -= Xt, pe.lens[pe.have++] = Wt;
                  else {
                    if (Wt === 16) {
                      for (ft = Xt + 2; Et < ft; ) {
                        if (Rt === 0)
                          break e;
                        Rt--, mt += je[$e++] << Et, Et += 8;
                      }
                      if (mt >>>= Xt, Et -= Xt, pe.have === 0) {
                        Ae.msg = "invalid bit length repeat", pe.mode = 30;
                        break;
                      }
                      Se = pe.lens[pe.have - 1], Ct = 3 + (3 & mt), mt >>>= 2, Et -= 2;
                    } else if (Wt === 17) {
                      for (ft = Xt + 3; Et < ft; ) {
                        if (Rt === 0)
                          break e;
                        Rt--, mt += je[$e++] << Et, Et += 8;
                      }
                      Et -= Xt, Se = 0, Ct = 3 + (7 & (mt >>>= Xt)), mt >>>= 3, Et -= 3;
                    } else {
                      for (ft = Xt + 7; Et < ft; ) {
                        if (Rt === 0)
                          break e;
                        Rt--, mt += je[$e++] << Et, Et += 8;
                      }
                      Et -= Xt, Se = 0, Ct = 11 + (127 & (mt >>>= Xt)), mt >>>= 7, Et -= 7;
                    }
                    if (pe.have + Ct > pe.nlen + pe.ndist) {
                      Ae.msg = "invalid bit length repeat", pe.mode = 30;
                      break;
                    }
                    for (; Ct--; )
                      pe.lens[pe.have++] = Se;
                  }
                }
                if (pe.mode === 30)
                  break;
                if (pe.lens[256] === 0) {
                  Ae.msg = "invalid code -- missing end-of-block", pe.mode = 30;
                  break;
                }
                if (pe.lenbits = 9, Mt = { bits: pe.lenbits }, si = h(I, pe.lens, 0, pe.nlen, pe.lencode, 0, pe.work, Mt), pe.lenbits = Mt.bits, si) {
                  Ae.msg = "invalid literal/lengths set", pe.mode = 30;
                  break;
                }
                if (pe.distbits = 6, pe.distcode = pe.distdyn, Mt = { bits: pe.distbits }, si = h(p, pe.lens, pe.nlen, pe.ndist, pe.distcode, 0, pe.work, Mt), pe.distbits = Mt.bits, si) {
                  Ae.msg = "invalid distances set", pe.mode = 30;
                  break;
                }
                if (pe.mode = 20, Oe === 6)
                  break e;
              case 20:
                pe.mode = 21;
              case 21:
                if (6 <= Rt && 258 <= ze) {
                  Ae.next_out = vt, Ae.avail_out = ze, Ae.next_in = $e, Ae.avail_in = Rt, pe.hold = mt, pe.bits = Et, c(Ae, Dt), vt = Ae.next_out, Ve = Ae.output, ze = Ae.avail_out, $e = Ae.next_in, je = Ae.input, Rt = Ae.avail_in, mt = pe.hold, Et = pe.bits, pe.mode === 12 && (pe.back = -1);
                  break;
                }
                for (pe.back = 0; gi = (rt = pe.lencode[mt & (1 << pe.lenbits) - 1]) >>> 16 & 255, Wt = 65535 & rt, !((Xt = rt >>> 24) <= Et); ) {
                  if (Rt === 0)
                    break e;
                  Rt--, mt += je[$e++] << Et, Et += 8;
                }
                if (gi && (240 & gi) == 0) {
                  for (Di = Xt, ni = gi, Ci = Wt; gi = (rt = pe.lencode[Ci + ((mt & (1 << Di + ni) - 1) >> Di)]) >>> 16 & 255, Wt = 65535 & rt, !(Di + (Xt = rt >>> 24) <= Et); ) {
                    if (Rt === 0)
                      break e;
                    Rt--, mt += je[$e++] << Et, Et += 8;
                  }
                  mt >>>= Di, Et -= Di, pe.back += Di;
                }
                if (mt >>>= Xt, Et -= Xt, pe.back += Xt, pe.length = Wt, gi === 0) {
                  pe.mode = 26;
                  break;
                }
                if (32 & gi) {
                  pe.back = -1, pe.mode = 12;
                  break;
                }
                if (64 & gi) {
                  Ae.msg = "invalid literal/length code", pe.mode = 30;
                  break;
                }
                pe.extra = 15 & gi, pe.mode = 22;
              case 22:
                if (pe.extra) {
                  for (ft = pe.extra; Et < ft; ) {
                    if (Rt === 0)
                      break e;
                    Rt--, mt += je[$e++] << Et, Et += 8;
                  }
                  pe.length += mt & (1 << pe.extra) - 1, mt >>>= pe.extra, Et -= pe.extra, pe.back += pe.extra;
                }
                pe.was = pe.length, pe.mode = 23;
              case 23:
                for (; gi = (rt = pe.distcode[mt & (1 << pe.distbits) - 1]) >>> 16 & 255, Wt = 65535 & rt, !((Xt = rt >>> 24) <= Et); ) {
                  if (Rt === 0)
                    break e;
                  Rt--, mt += je[$e++] << Et, Et += 8;
                }
                if ((240 & gi) == 0) {
                  for (Di = Xt, ni = gi, Ci = Wt; gi = (rt = pe.distcode[Ci + ((mt & (1 << Di + ni) - 1) >> Di)]) >>> 16 & 255, Wt = 65535 & rt, !(Di + (Xt = rt >>> 24) <= Et); ) {
                    if (Rt === 0)
                      break e;
                    Rt--, mt += je[$e++] << Et, Et += 8;
                  }
                  mt >>>= Di, Et -= Di, pe.back += Di;
                }
                if (mt >>>= Xt, Et -= Xt, pe.back += Xt, 64 & gi) {
                  Ae.msg = "invalid distance code", pe.mode = 30;
                  break;
                }
                pe.offset = Wt, pe.extra = 15 & gi, pe.mode = 24;
              case 24:
                if (pe.extra) {
                  for (ft = pe.extra; Et < ft; ) {
                    if (Rt === 0)
                      break e;
                    Rt--, mt += je[$e++] << Et, Et += 8;
                  }
                  pe.offset += mt & (1 << pe.extra) - 1, mt >>>= pe.extra, Et -= pe.extra, pe.back += pe.extra;
                }
                if (pe.offset > pe.dmax) {
                  Ae.msg = "invalid distance too far back", pe.mode = 30;
                  break;
                }
                pe.mode = 25;
              case 25:
                if (ze === 0)
                  break e;
                if (Ct = Dt - ze, pe.offset > Ct) {
                  if ((Ct = pe.offset - Ct) > pe.whave && pe.sane) {
                    Ae.msg = "invalid distance too far back", pe.mode = 30;
                    break;
                  }
                  Kt = Ct > pe.wnext ? (Ct -= pe.wnext, pe.wsize - Ct) : pe.wnext - Ct, Ct > pe.length && (Ct = pe.length), Zt = pe.window;
                } else
                  Zt = Ve, Kt = vt - pe.offset, Ct = pe.length;
                for (ze < Ct && (Ct = ze), ze -= Ct, pe.length -= Ct; Ve[vt++] = Zt[Kt++], --Ct; )
                  ;
                pe.length === 0 && (pe.mode = 21);
                break;
              case 26:
                if (ze === 0)
                  break e;
                Ve[vt++] = pe.length, ze--, pe.mode = 21;
                break;
              case 27:
                if (pe.wrap) {
                  for (; Et < 32; ) {
                    if (Rt === 0)
                      break e;
                    Rt--, mt |= je[$e++] << Et, Et += 8;
                  }
                  if (Dt -= ze, Ae.total_out += Dt, pe.total += Dt, Dt && (Ae.adler = pe.check = pe.flags ? l(pe.check, Ve, Dt, vt - Dt) : r(pe.check, Ve, Dt, vt - Dt)), Dt = ze, (pe.flags ? mt : R(mt)) !== pe.check) {
                    Ae.msg = "incorrect data check", pe.mode = 30;
                    break;
                  }
                  Et = mt = 0;
                }
                pe.mode = 28;
              case 28:
                if (pe.wrap && pe.flags) {
                  for (; Et < 32; ) {
                    if (Rt === 0)
                      break e;
                    Rt--, mt += je[$e++] << Et, Et += 8;
                  }
                  if (mt !== (4294967295 & pe.total)) {
                    Ae.msg = "incorrect length check", pe.mode = 30;
                    break;
                  }
                  Et = mt = 0;
                }
                pe.mode = 29;
              case 29:
                si = 1;
                break e;
              case 30:
                si = -3;
                break e;
              case 31:
                return -4;
              case 32:
              default:
                return m;
            }
        return Ae.next_out = vt, Ae.avail_out = ze, Ae.next_in = $e, Ae.avail_in = Rt, pe.hold = mt, pe.bits = Et, (pe.wsize || Dt !== Ae.avail_out && pe.mode < 30 && (pe.mode < 27 || Oe !== 4)) && Ne(Ae, Ae.output, Ae.next_out, Dt - Ae.avail_out) ? (pe.mode = 31, -4) : (it -= Ae.avail_in, Dt -= Ae.avail_out, Ae.total_in += it, Ae.total_out += Dt, pe.total += Dt, pe.wrap && Dt && (Ae.adler = pe.check = pe.flags ? l(pe.check, Ve, Dt, Ae.next_out - Dt) : r(pe.check, Ve, Dt, Ae.next_out - Dt)), Ae.data_type = pe.bits + (pe.last ? 64 : 0) + (pe.mode === 12 ? 128 : 0) + (pe.mode === 20 || pe.mode === 15 ? 256 : 0), (it == 0 && Dt === 0 || Oe === 4) && si === y && (si = -5), si);
      }, s.inflateEnd = function(Ae) {
        if (!Ae || !Ae.state)
          return m;
        var Oe = Ae.state;
        return Oe.window && (Oe.window = null), Ae.state = null, y;
      }, s.inflateGetHeader = function(Ae, Oe) {
        var pe;
        return Ae && Ae.state ? (2 & (pe = Ae.state).wrap) == 0 ? m : ((pe.head = Oe).done = !1, y) : m;
      }, s.inflateSetDictionary = function(Ae, Oe) {
        var pe, je = Oe.length;
        return Ae && Ae.state ? (pe = Ae.state).wrap !== 0 && pe.mode !== 11 ? m : pe.mode === 11 && r(1, Oe, je, 0) !== pe.check ? -3 : Ne(Ae, Oe, je, je) ? (pe.mode = 31, -4) : (pe.havedict = 1, y) : m;
      }, s.inflateInfo = "pako inflate (from Nodeca project)";
    }, { "../utils/common": 41, "./adler32": 43, "./crc32": 45, "./inffast": 48, "./inftrees": 50 }], 50: [function(i, n, s) {
      var o = i("../utils/common"), r = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0], l = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78], c = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0], h = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];
      n.exports = function(I, p, y, m, A, C, O, R) {
        var F, L, P, z, W, re, ce, te, ee, Ne = R.bits, Ae = 0, Oe = 0, pe = 0, je = 0, Ve = 0, $e = 0, vt = 0, Rt = 0, ze = 0, mt = 0, Et = null, it = 0, Dt = new o.Buf16(16), Ct = new o.Buf16(16), Kt = null, Zt = 0;
        for (Ae = 0; Ae <= 15; Ae++)
          Dt[Ae] = 0;
        for (Oe = 0; Oe < m; Oe++)
          Dt[p[y + Oe]]++;
        for (Ve = Ne, je = 15; 1 <= je && Dt[je] === 0; je--)
          ;
        if (je < Ve && (Ve = je), je === 0)
          return A[C++] = 20971520, A[C++] = 20971520, R.bits = 1, 0;
        for (pe = 1; pe < je && Dt[pe] === 0; pe++)
          ;
        for (Ve < pe && (Ve = pe), Ae = Rt = 1; Ae <= 15; Ae++)
          if (Rt <<= 1, (Rt -= Dt[Ae]) < 0)
            return -1;
        if (0 < Rt && (I === 0 || je !== 1))
          return -1;
        for (Ct[1] = 0, Ae = 1; Ae < 15; Ae++)
          Ct[Ae + 1] = Ct[Ae] + Dt[Ae];
        for (Oe = 0; Oe < m; Oe++)
          p[y + Oe] !== 0 && (O[Ct[p[y + Oe]]++] = Oe);
        if (re = I === 0 ? (Et = Kt = O, 19) : I === 1 ? (Et = r, it -= 257, Kt = l, Zt -= 257, 256) : (Et = c, Kt = h, -1), Ae = pe, W = C, vt = Oe = mt = 0, P = -1, z = (ze = 1 << ($e = Ve)) - 1, I === 1 && 852 < ze || I === 2 && 592 < ze)
          return 1;
        for (; ; ) {
          for (ce = Ae - vt, ee = O[Oe] < re ? (te = 0, O[Oe]) : O[Oe] > re ? (te = Kt[Zt + O[Oe]], Et[it + O[Oe]]) : (te = 96, 0), F = 1 << Ae - vt, pe = L = 1 << $e; A[W + (mt >> vt) + (L -= F)] = ce << 24 | te << 16 | ee | 0, L !== 0; )
            ;
          for (F = 1 << Ae - 1; mt & F; )
            F >>= 1;
          if (F !== 0 ? (mt &= F - 1, mt += F) : mt = 0, Oe++, --Dt[Ae] == 0) {
            if (Ae === je)
              break;
            Ae = p[y + O[Oe]];
          }
          if (Ve < Ae && (mt & z) !== P) {
            for (vt === 0 && (vt = Ve), W += pe, Rt = 1 << ($e = Ae - vt); $e + vt < je && !((Rt -= Dt[$e + vt]) <= 0); )
              $e++, Rt <<= 1;
            if (ze += 1 << $e, I === 1 && 852 < ze || I === 2 && 592 < ze)
              return 1;
            A[P = mt & z] = Ve << 24 | $e << 16 | W - C | 0;
          }
        }
        return mt !== 0 && (A[W + mt] = Ae - vt << 24 | 64 << 16 | 0), R.bits = Ve, 0;
      };
    }, { "../utils/common": 41 }], 51: [function(i, n, s) {
      n.exports = { 2: "need dictionary", 1: "stream end", 0: "", "-1": "file error", "-2": "stream error", "-3": "data error", "-4": "insufficient memory", "-5": "buffer error", "-6": "incompatible version" };
    }, {}], 52: [function(i, n, s) {
      var o = i("../utils/common"), r = 0, l = 1;
      function c(rt) {
        for (var Tt = rt.length; 0 <= --Tt; )
          rt[Tt] = 0;
      }
      var h = 0, I = 29, p = 256, y = p + 1 + I, m = 30, A = 19, C = 2 * y + 1, O = 15, R = 16, F = 7, L = 256, P = 16, z = 17, W = 18, re = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0], ce = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13], te = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7], ee = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], Ne = new Array(2 * (y + 2));
      c(Ne);
      var Ae = new Array(2 * m);
      c(Ae);
      var Oe = new Array(512);
      c(Oe);
      var pe = new Array(256);
      c(pe);
      var je = new Array(I);
      c(je);
      var Ve, $e, vt, Rt = new Array(m);
      function ze(rt, Tt, jt, Jt, $t) {
        this.static_tree = rt, this.extra_bits = Tt, this.extra_base = jt, this.elems = Jt, this.max_length = $t, this.has_stree = rt && rt.length;
      }
      function mt(rt, Tt) {
        this.dyn_tree = rt, this.max_code = 0, this.stat_desc = Tt;
      }
      function Et(rt) {
        return rt < 256 ? Oe[rt] : Oe[256 + (rt >>> 7)];
      }
      function it(rt, Tt) {
        rt.pending_buf[rt.pending++] = 255 & Tt, rt.pending_buf[rt.pending++] = Tt >>> 8 & 255;
      }
      function Dt(rt, Tt, jt) {
        rt.bi_valid > R - jt ? (rt.bi_buf |= Tt << rt.bi_valid & 65535, it(rt, rt.bi_buf), rt.bi_buf = Tt >> R - rt.bi_valid, rt.bi_valid += jt - R) : (rt.bi_buf |= Tt << rt.bi_valid & 65535, rt.bi_valid += jt);
      }
      function Ct(rt, Tt, jt) {
        Dt(rt, jt[2 * Tt], jt[2 * Tt + 1]);
      }
      function Kt(rt, Tt) {
        for (var jt = 0; jt |= 1 & rt, rt >>>= 1, jt <<= 1, 0 < --Tt; )
          ;
        return jt >>> 1;
      }
      function Zt(rt, Tt, jt) {
        var Jt, $t, ht = new Array(O + 1), Me = 0;
        for (Jt = 1; Jt <= O; Jt++)
          ht[Jt] = Me = Me + jt[Jt - 1] << 1;
        for ($t = 0; $t <= Tt; $t++) {
          var gt = rt[2 * $t + 1];
          gt !== 0 && (rt[2 * $t] = Kt(ht[gt]++, gt));
        }
      }
      function Xt(rt) {
        var Tt;
        for (Tt = 0; Tt < y; Tt++)
          rt.dyn_ltree[2 * Tt] = 0;
        for (Tt = 0; Tt < m; Tt++)
          rt.dyn_dtree[2 * Tt] = 0;
        for (Tt = 0; Tt < A; Tt++)
          rt.bl_tree[2 * Tt] = 0;
        rt.dyn_ltree[2 * L] = 1, rt.opt_len = rt.static_len = 0, rt.last_lit = rt.matches = 0;
      }
      function gi(rt) {
        8 < rt.bi_valid ? it(rt, rt.bi_buf) : 0 < rt.bi_valid && (rt.pending_buf[rt.pending++] = rt.bi_buf), rt.bi_buf = 0, rt.bi_valid = 0;
      }
      function Wt(rt, Tt, jt, Jt) {
        var $t = 2 * Tt, ht = 2 * jt;
        return rt[$t] < rt[ht] || rt[$t] === rt[ht] && Jt[Tt] <= Jt[jt];
      }
      function Di(rt, Tt, jt) {
        for (var Jt = rt.heap[jt], $t = jt << 1; $t <= rt.heap_len && ($t < rt.heap_len && Wt(Tt, rt.heap[$t + 1], rt.heap[$t], rt.depth) && $t++, !Wt(Tt, Jt, rt.heap[$t], rt.depth)); )
          rt.heap[jt] = rt.heap[$t], jt = $t, $t <<= 1;
        rt.heap[jt] = Jt;
      }
      function ni(rt, Tt, jt) {
        var Jt, $t, ht, Me, gt = 0;
        if (rt.last_lit !== 0)
          for (; Jt = rt.pending_buf[rt.d_buf + 2 * gt] << 8 | rt.pending_buf[rt.d_buf + 2 * gt + 1], $t = rt.pending_buf[rt.l_buf + gt], gt++, Jt === 0 ? Ct(rt, $t, Tt) : (Ct(rt, (ht = pe[$t]) + p + 1, Tt), (Me = re[ht]) !== 0 && Dt(rt, $t -= je[ht], Me), Ct(rt, ht = Et(--Jt), jt), (Me = ce[ht]) !== 0 && Dt(rt, Jt -= Rt[ht], Me)), gt < rt.last_lit; )
            ;
        Ct(rt, L, Tt);
      }
      function Ci(rt, Tt) {
        var jt, Jt, $t, ht = Tt.dyn_tree, Me = Tt.stat_desc.static_tree, gt = Tt.stat_desc.has_stree, yt = Tt.stat_desc.elems, Ut = -1;
        for (rt.heap_len = 0, rt.heap_max = C, jt = 0; jt < yt; jt++)
          ht[2 * jt] !== 0 ? (rt.heap[++rt.heap_len] = Ut = jt, rt.depth[jt] = 0) : ht[2 * jt + 1] = 0;
        for (; rt.heap_len < 2; )
          ht[2 * ($t = rt.heap[++rt.heap_len] = Ut < 2 ? ++Ut : 0)] = 1, rt.depth[$t] = 0, rt.opt_len--, gt && (rt.static_len -= Me[2 * $t + 1]);
        for (Tt.max_code = Ut, jt = rt.heap_len >> 1; 1 <= jt; jt--)
          Di(rt, ht, jt);
        for ($t = yt; jt = rt.heap[1], rt.heap[1] = rt.heap[rt.heap_len--], Di(rt, ht, 1), Jt = rt.heap[1], rt.heap[--rt.heap_max] = jt, rt.heap[--rt.heap_max] = Jt, ht[2 * $t] = ht[2 * jt] + ht[2 * Jt], rt.depth[$t] = (rt.depth[jt] >= rt.depth[Jt] ? rt.depth[jt] : rt.depth[Jt]) + 1, ht[2 * jt + 1] = ht[2 * Jt + 1] = $t, rt.heap[1] = $t++, Di(rt, ht, 1), 2 <= rt.heap_len; )
          ;
        rt.heap[--rt.heap_max] = rt.heap[1], (function(Ht, wi) {
          var bi, Hi, Wi, hi, Ji, Sn, nn = wi.dyn_tree, Yi = wi.max_code, Pi = wi.stat_desc.static_tree, kt = wi.stat_desc.has_stree, sn = wi.stat_desc.extra_bits, Fi = wi.stat_desc.extra_base, tn = wi.stat_desc.max_length, Gi = 0;
          for (hi = 0; hi <= O; hi++)
            Ht.bl_count[hi] = 0;
          for (nn[2 * Ht.heap[Ht.heap_max] + 1] = 0, bi = Ht.heap_max + 1; bi < C; bi++)
            tn < (hi = nn[2 * nn[2 * (Hi = Ht.heap[bi]) + 1] + 1] + 1) && (hi = tn, Gi++), nn[2 * Hi + 1] = hi, Yi < Hi || (Ht.bl_count[hi]++, Ji = 0, Fi <= Hi && (Ji = sn[Hi - Fi]), Sn = nn[2 * Hi], Ht.opt_len += Sn * (hi + Ji), kt && (Ht.static_len += Sn * (Pi[2 * Hi + 1] + Ji)));
          if (Gi !== 0) {
            do {
              for (hi = tn - 1; Ht.bl_count[hi] === 0; )
                hi--;
              Ht.bl_count[hi]--, Ht.bl_count[hi + 1] += 2, Ht.bl_count[tn]--, Gi -= 2;
            } while (0 < Gi);
            for (hi = tn; hi !== 0; hi--)
              for (Hi = Ht.bl_count[hi]; Hi !== 0; )
                Yi < (Wi = Ht.heap[--bi]) || (nn[2 * Wi + 1] !== hi && (Ht.opt_len += (hi - nn[2 * Wi + 1]) * nn[2 * Wi], nn[2 * Wi + 1] = hi), Hi--);
          }
        })(rt, Tt), Zt(ht, Ut, rt.bl_count);
      }
      function Se(rt, Tt, jt) {
        var Jt, $t, ht = -1, Me = Tt[1], gt = 0, yt = 7, Ut = 4;
        for (Me === 0 && (yt = 138, Ut = 3), Tt[2 * (jt + 1) + 1] = 65535, Jt = 0; Jt <= jt; Jt++)
          $t = Me, Me = Tt[2 * (Jt + 1) + 1], ++gt < yt && $t === Me || (gt < Ut ? rt.bl_tree[2 * $t] += gt : $t !== 0 ? ($t !== ht && rt.bl_tree[2 * $t]++, rt.bl_tree[2 * P]++) : gt <= 10 ? rt.bl_tree[2 * z]++ : rt.bl_tree[2 * W]++, ht = $t, Ut = (gt = 0) === Me ? (yt = 138, 3) : $t === Me ? (yt = 6, 3) : (yt = 7, 4));
      }
      function si(rt, Tt, jt) {
        var Jt, $t, ht = -1, Me = Tt[1], gt = 0, yt = 7, Ut = 4;
        for (Me === 0 && (yt = 138, Ut = 3), Jt = 0; Jt <= jt; Jt++)
          if ($t = Me, Me = Tt[2 * (Jt + 1) + 1], !(++gt < yt && $t === Me)) {
            if (gt < Ut)
              for (; Ct(rt, $t, rt.bl_tree), --gt != 0; )
                ;
            else
              $t !== 0 ? ($t !== ht && (Ct(rt, $t, rt.bl_tree), gt--), Ct(rt, P, rt.bl_tree), Dt(rt, gt - 3, 2)) : gt <= 10 ? (Ct(rt, z, rt.bl_tree), Dt(rt, gt - 3, 3)) : (Ct(rt, W, rt.bl_tree), Dt(rt, gt - 11, 7));
            ht = $t, Ut = (gt = 0) === Me ? (yt = 138, 3) : $t === Me ? (yt = 6, 3) : (yt = 7, 4);
          }
      }
      c(Rt);
      var Mt = !1;
      function ft(rt, Tt, jt, Jt) {
        Dt(rt, (h << 1) + (Jt ? 1 : 0), 3), (function($t, ht, Me, gt) {
          gi($t), it($t, Me), it($t, ~Me), o.arraySet($t.pending_buf, $t.window, ht, Me, $t.pending), $t.pending += Me;
        })(rt, Tt, jt);
      }
      s._tr_init = function(rt) {
        Mt || ((function() {
          var Tt, jt, Jt, $t, ht, Me = new Array(O + 1);
          for ($t = Jt = 0; $t < I - 1; $t++)
            for (je[$t] = Jt, Tt = 0; Tt < 1 << re[$t]; Tt++)
              pe[Jt++] = $t;
          for (pe[Jt - 1] = $t, $t = ht = 0; $t < 16; $t++)
            for (Rt[$t] = ht, Tt = 0; Tt < 1 << ce[$t]; Tt++)
              Oe[ht++] = $t;
          for (ht >>= 7; $t < m; $t++)
            for (Rt[$t] = ht << 7, Tt = 0; Tt < 1 << ce[$t] - 7; Tt++)
              Oe[256 + ht++] = $t;
          for (jt = 0; jt <= O; jt++)
            Me[jt] = 0;
          for (Tt = 0; Tt <= 143; )
            Ne[2 * Tt + 1] = 8, Tt++, Me[8]++;
          for (; Tt <= 255; )
            Ne[2 * Tt + 1] = 9, Tt++, Me[9]++;
          for (; Tt <= 279; )
            Ne[2 * Tt + 1] = 7, Tt++, Me[7]++;
          for (; Tt <= 287; )
            Ne[2 * Tt + 1] = 8, Tt++, Me[8]++;
          for (Zt(Ne, y + 1, Me), Tt = 0; Tt < m; Tt++)
            Ae[2 * Tt + 1] = 5, Ae[2 * Tt] = Kt(Tt, 5);
          Ve = new ze(Ne, re, p + 1, y, O), $e = new ze(Ae, ce, 0, m, O), vt = new ze(new Array(0), te, 0, A, F);
        })(), Mt = !0), rt.l_desc = new mt(rt.dyn_ltree, Ve), rt.d_desc = new mt(rt.dyn_dtree, $e), rt.bl_desc = new mt(rt.bl_tree, vt), rt.bi_buf = 0, rt.bi_valid = 0, Xt(rt);
      }, s._tr_stored_block = ft, s._tr_flush_block = function(rt, Tt, jt, Jt) {
        var $t, ht, Me = 0;
        0 < rt.level ? (rt.strm.data_type === 2 && (rt.strm.data_type = (function(gt) {
          var yt, Ut = 4093624447;
          for (yt = 0; yt <= 31; yt++, Ut >>>= 1)
            if (1 & Ut && gt.dyn_ltree[2 * yt] !== 0)
              return r;
          if (gt.dyn_ltree[18] !== 0 || gt.dyn_ltree[20] !== 0 || gt.dyn_ltree[26] !== 0)
            return l;
          for (yt = 32; yt < p; yt++)
            if (gt.dyn_ltree[2 * yt] !== 0)
              return l;
          return r;
        })(rt)), Ci(rt, rt.l_desc), Ci(rt, rt.d_desc), Me = (function(gt) {
          var yt;
          for (Se(gt, gt.dyn_ltree, gt.l_desc.max_code), Se(gt, gt.dyn_dtree, gt.d_desc.max_code), Ci(gt, gt.bl_desc), yt = A - 1; 3 <= yt && gt.bl_tree[2 * ee[yt] + 1] === 0; yt--)
            ;
          return gt.opt_len += 3 * (yt + 1) + 5 + 5 + 4, yt;
        })(rt), $t = rt.opt_len + 3 + 7 >>> 3, (ht = rt.static_len + 3 + 7 >>> 3) <= $t && ($t = ht)) : $t = ht = jt + 5, jt + 4 <= $t && Tt !== -1 ? ft(rt, Tt, jt, Jt) : rt.strategy === 4 || ht === $t ? (Dt(rt, 2 + (Jt ? 1 : 0), 3), ni(rt, Ne, Ae)) : (Dt(rt, 4 + (Jt ? 1 : 0), 3), (function(gt, yt, Ut, Ht) {
          var wi;
          for (Dt(gt, yt - 257, 5), Dt(gt, Ut - 1, 5), Dt(gt, Ht - 4, 4), wi = 0; wi < Ht; wi++)
            Dt(gt, gt.bl_tree[2 * ee[wi] + 1], 3);
          si(gt, gt.dyn_ltree, yt - 1), si(gt, gt.dyn_dtree, Ut - 1);
        })(rt, rt.l_desc.max_code + 1, rt.d_desc.max_code + 1, Me + 1), ni(rt, rt.dyn_ltree, rt.dyn_dtree)), Xt(rt), Jt && gi(rt);
      }, s._tr_tally = function(rt, Tt, jt) {
        return rt.pending_buf[rt.d_buf + 2 * rt.last_lit] = Tt >>> 8 & 255, rt.pending_buf[rt.d_buf + 2 * rt.last_lit + 1] = 255 & Tt, rt.pending_buf[rt.l_buf + rt.last_lit] = 255 & jt, rt.last_lit++, Tt === 0 ? rt.dyn_ltree[2 * jt]++ : (rt.matches++, Tt--, rt.dyn_ltree[2 * (pe[jt] + p + 1)]++, rt.dyn_dtree[2 * Et(Tt)]++), rt.last_lit === rt.lit_bufsize - 1;
      }, s._tr_align = function(rt) {
        Dt(rt, 2, 3), Ct(rt, L, Ne), (function(Tt) {
          Tt.bi_valid === 16 ? (it(Tt, Tt.bi_buf), Tt.bi_buf = 0, Tt.bi_valid = 0) : 8 <= Tt.bi_valid && (Tt.pending_buf[Tt.pending++] = 255 & Tt.bi_buf, Tt.bi_buf >>= 8, Tt.bi_valid -= 8);
        })(rt);
      };
    }, { "../utils/common": 41 }], 53: [function(i, n, s) {
      n.exports = function() {
        this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
      };
    }, {}], 54: [function(i, n, s) {
      (function(o) {
        (function(r, l) {
          if (!r.setImmediate) {
            var c, h, I, p, y = 1, m = {}, A = !1, C = r.document, O = Object.getPrototypeOf && Object.getPrototypeOf(r);
            O = O && O.setTimeout ? O : r, c = {}.toString.call(r.process) === "[object process]" ? function(P) {
              process.nextTick(function() {
                F(P);
              });
            } : (function() {
              if (r.postMessage && !r.importScripts) {
                var P = !0, z = r.onmessage;
                return r.onmessage = function() {
                  P = !1;
                }, r.postMessage("", "*"), r.onmessage = z, P;
              }
            })() ? (p = "setImmediate$" + Math.random() + "$", r.addEventListener ? r.addEventListener("message", L, !1) : r.attachEvent("onmessage", L), function(P) {
              r.postMessage(p + P, "*");
            }) : r.MessageChannel ? ((I = new MessageChannel()).port1.onmessage = function(P) {
              F(P.data);
            }, function(P) {
              I.port2.postMessage(P);
            }) : C && "onreadystatechange" in C.createElement("script") ? (h = C.documentElement, function(P) {
              var z = C.createElement("script");
              z.onreadystatechange = function() {
                F(P), z.onreadystatechange = null, h.removeChild(z), z = null;
              }, h.appendChild(z);
            }) : function(P) {
              setTimeout(F, 0, P);
            }, O.setImmediate = function(P) {
              typeof P != "function" && (P = new Function("" + P));
              for (var z = new Array(arguments.length - 1), W = 0; W < z.length; W++)
                z[W] = arguments[W + 1];
              var re = { callback: P, args: z };
              return m[y] = re, c(y), y++;
            }, O.clearImmediate = R;
          }
          function R(P) {
            delete m[P];
          }
          function F(P) {
            if (A)
              setTimeout(F, 0, P);
            else {
              var z = m[P];
              if (z) {
                A = !0;
                try {
                  (function(W) {
                    var re = W.callback, ce = W.args;
                    switch (ce.length) {
                      case 0:
                        re();
                        break;
                      case 1:
                        re(ce[0]);
                        break;
                      case 2:
                        re(ce[0], ce[1]);
                        break;
                      case 3:
                        re(ce[0], ce[1], ce[2]);
                        break;
                      default:
                        re.apply(l, ce);
                    }
                  })(z);
                } finally {
                  R(P), A = !1;
                }
              }
            }
          }
          function L(P) {
            P.source === r && typeof P.data == "string" && P.data.indexOf(p) === 0 && F(+P.data.slice(p.length));
          }
        })(typeof self > "u" ? o === void 0 ? this : o : self);
      }).call(this, typeof mse < "u" ? mse : typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, {}] }, {}, [10])(10);
  });
})($be);
var JZe = $be.exports;
const y2e = /* @__PURE__ */ u$e(JZe);
class KIe {
  /**
   * Constructs a new BCF Topic Comment instance.
   * @param components - The Components instance.
   * @param text - The initial comment text.
   */
  constructor(t, i) {
    tt(this, "date", /* @__PURE__ */ new Date()), tt(this, "author"), tt(this, "guid", y4.create()), tt(this, "viewpoint"), tt(this, "modifiedAuthor"), tt(this, "modifiedDate"), tt(this, "topic"), tt(this, "_components"), tt(this, "_comment", ""), this._components = t, this._comment = i;
    const n = this._components.get(c1);
    this.author = n.config.author;
  }
  /**
   * Sets the comment text and updates the modified date and author.
   * The author will be the one defined in BCFTopics.config.author
   * @param value - The new comment text.
   */
  set comment(t) {
    var i;
    const n = this._components.get(c1);
    this._comment = t, this.modifiedDate = /* @__PURE__ */ new Date(), this.modifiedAuthor = n.config.author, (i = this.topic) == null || i.comments.set(this.guid, this);
  }
  /**
   * Gets the comment text.
   * @returns The comment text.
   */
  get comment() {
    return this._comment;
  }
  toJSON() {
    var t, i;
    const n = {
      guid: this.guid,
      date: this.date.toISOString(),
      author: this.author,
      comment: this.comment,
      topic_guid: (t = this.topic) == null ? void 0 : t.guid,
      viewpoint_guid: this.viewpoint,
      modified_date: (i = this.modifiedDate) == null ? void 0 : i.toISOString(),
      modified_author: this.modifiedAuthor
    };
    for (const [s, o] of Object.entries(n))
      o === void 0 && delete n[s];
    return n;
  }
}
const Kbe = class j_ {
  /**
   * Initializes a new instance of the `Topic` class representing a BCF (BIM Collaboration Format) topic.
   * It provides methods and properties to manage and serialize BCF topics.
   *
   * @remarks
   * The default creationUser is the one set in BCFTopics.config.author
   * It should not be created manually. Better use BCFTopics.create().
   *
   * @param components - The `Components` instance that provides access to other components and services.
   */
  constructor(t) {
    tt(this, "guid", y4.create()), tt(this, "title", j_.default.title), tt(this, "creationDate", /* @__PURE__ */ new Date()), tt(this, "creationAuthor", ""), tt(this, "viewpoints", new OA()), tt(this, "relatedTopics", new OA()), tt(this, "comments", new f0()), tt(this, "documentReferences", new OA()), tt(this, "customData", {}), tt(this, "description"), tt(this, "serverAssignedId"), tt(this, "dueDate"), tt(this, "modifiedAuthor"), tt(this, "modifiedDate"), tt(this, "index"), tt(this, "_type", j_.default.type), tt(this, "_status", j_.default.status), tt(this, "_priority", j_.default.priority), tt(this, "_stage", j_.default.stage), tt(this, "_assignedTo", j_.default.assignedTo), tt(this, "_labels", j_.default.labels ?? /* @__PURE__ */ new Set()), tt(this, "_components"), this._components = t;
    const i = t.get(c1);
    this.creationAuthor = i.config.author, this.relatedTopics.guard = (n) => n !== this.guid;
  }
  set type(t) {
    const i = this._components.get(c1), { strict: n, types: s } = i.config;
    (!n || s.has(t)) && (this._type = t);
  }
  get type() {
    return this._type;
  }
  set status(t) {
    const i = this._components.get(c1), { strict: n, statuses: s } = i.config;
    (!n || s.has(t)) && (this._status = t);
  }
  get status() {
    return this._status;
  }
  set priority(t) {
    const i = this._components.get(c1);
    if (t) {
      const { strict: n, priorities: s } = i.config;
      if (!(n ? s.has(t) : !0))
        return;
      this._priority = t;
    } else
      this._priority = t;
  }
  get priority() {
    return this._priority;
  }
  set stage(t) {
    const i = this._components.get(c1);
    if (t) {
      const { strict: n, stages: s } = i.config;
      if (!(n ? s.has(t) : !0))
        return;
      this._stage = t;
    } else
      this._stage = t;
  }
  get stage() {
    return this._stage;
  }
  set assignedTo(t) {
    const i = this._components.get(c1);
    if (t) {
      const { strict: n, users: s } = i.config;
      if (!(n ? s.has(t) : !0))
        return;
      this._assignedTo = t;
    } else
      this._assignedTo = t;
  }
  get assignedTo() {
    return this._assignedTo;
  }
  set labels(t) {
    const i = this._components.get(c1), { strict: n, labels: s } = i.config;
    if (n) {
      const o = /* @__PURE__ */ new Set();
      for (const r of t)
        (!n || s.has(r)) && o.add(r);
      this._labels = o;
    } else
      this._labels = t;
  }
  get labels() {
    return this._labels;
  }
  get _managerVersion() {
    return this._components.get(c1).config.version;
  }
  /**
   * Sets properties of the BCF Topic based on the provided data.
   *
   * @remarks
   * This method iterates over the provided `data` object and updates the corresponding properties of the BCF Topic.
   * It skips the `guid` property as it should not be modified.
   *
   * @param data - An object containing the properties to be updated.
   * @returns The topic
   *
   * @example
   * ```typescript
   * const topic = new Topic(components);
   * topic.set({
   *   title: "New BCF Topic Title",
   *   description: "This is a new description.",
   *   status: "Resolved",
   * });
   * ```
   */
  set(t) {
    const i = t, n = this;
    for (const o in t) {
      if (o === "guid")
        continue;
      const r = i[o];
      o in this && (n[o] = r);
    }
    return this._components.get(c1).list.set(this.guid, this), this;
  }
  /**
   * Creates a new comment associated with the current topic.
   *
   * @param text - The text content of the comment.
   * @param viewpoint - (Optional) The viewpoint associated with the comment.
   *
   * @returns The newly created comment.
   *
   * @example
   * ```typescript
   * const viewpoint = viewpoints.create(world); // Created with an instance of Viewpoints
   * const topic = topics.create(); // Created with an instance of BCFTopics
   * topic.viewpoints.add(viewpoint);
   * const comment = topic.createComment("This is a new comment", viewpoint);
   * ```
   */
  createComment(t, i) {
    const n = new KIe(this._components, t);
    return n.viewpoint = i, n.topic = this, this.comments.set(n.guid, n), n;
  }
  createLabelTags() {
    const t = [...this.labels];
    if (this._components.get(c1).config.exportCustomDataAsLabels)
      for (const n in this.customData) {
        const s = this.customData[n];
        typeof s == "string" && t.push(s);
      }
    return t;
  }
  createCommentTags() {
    return [...this.comments.values()].map((t) => {
      var i;
      return {
        $Guid: t.guid,
        Date: t.date.toISOString(),
        Author: t.author,
        Comment: t.comment,
        ModifiedAuthor: t.modifiedAuthor,
        ModifiedDate: (i = t.modifiedDate) == null ? void 0 : i.toISOString(),
        Viewpoint: t.viewpoint ? { $Guid: t.viewpoint } : void 0
      };
    });
  }
  createViewpointTags() {
    const t = this._components.get(VO);
    return [...this.viewpoints].map((n) => t.list.get(n)).filter((n) => n).map((n) => {
      const s = {
        $Guid: n.guid,
        Viewpoint: `${n.title ?? n.guid}.bcfv`
      };
      if (t.snapshots.get(n.snapshot)) {
        const r = t.getSnapshotExtension(
          n.snapshot
        );
        s.Snapshot = `${n.snapshot}.${r}`;
      }
      return s;
    });
  }
  createRelatedTopicTags() {
    return [...this.relatedTopics].map((t) => ({ $Guid: t }));
  }
  createDocumentReferencesTag(t = this._managerVersion) {
    const i = [];
    if (!(t === "3" || t === "2.1"))
      return i;
    const n = this._components.get(c1);
    for (const s of this.documentReferences) {
      const o = n.documents.get(s);
      if (!o)
        continue;
      let r = {
        $Guid: y4.create(),
        Description: o.description
      };
      t === "2.1" && (r = {
        ...r,
        $isExternal: o.type === "external" ? !0 : void 0,
        ReferencedDocument: o.type === "external" ? o.url : `../${o.fileName}`
      }), t === "3" && (r = {
        ...r,
        DocumentGuid: o.type === "internal" ? s : void 0,
        Url: o.type === "external" ? o.url : void 0
      }), Object.keys(r).length > 0 && i.push(r);
    }
    return i;
  }
  toJSON() {
    var t, i;
    const n = {
      guid: this.guid,
      server_assigned_id: this.serverAssignedId,
      topic_type: this.type,
      topic_status: this.status,
      title: this.title,
      priority: this.priority,
      index: this.index,
      labels: [...this.labels],
      creation_date: this.creationDate.toISOString(),
      creation_author: this.creationAuthor,
      modified_date: (t = this.modifiedDate) == null ? void 0 : t.toISOString(),
      modified_author: this.modifiedAuthor,
      assigned_to: this.assignedTo,
      stage: this.stage,
      description: this.description,
      due_date: (i = this.dueDate) == null ? void 0 : i.toISOString(),
      comments: [...this.comments].map(([r, l]) => l.toJSON()),
      relatedTopics: [...this.relatedTopics].map((r) => ({ related_topic_guid: r }))
    }, s = this._components.get(VO);
    for (const r of this.viewpoints) {
      const l = s.list.get(r);
      l && (n.viewpoints || (n.viewpoints = []), n.viewpoints.push(l.toJSON()));
    }
    const o = this._components.get(c1);
    for (const r of this.documentReferences) {
      const l = o.documents.get(r);
      l && (n.document_references || (n.document_references = []), l.type === "external" ? n.document_references.push({
        guid: y4.create(),
        // TODO: this is for sure incorrect!
        description: l.description,
        url: l.url
      }) : n.document_references.push({
        guid: y4.create(),
        // TODO: this is for sure incorrect!
        description: l.description,
        document_guid: r
      }));
    }
    for (const [r, l] of Object.entries(n))
      (l === void 0 || Array.isArray(l) && l.length === 0) && delete n[r];
    return n;
  }
  /**
   * Serializes the BCF Topic instance into an XML string representation based on the official schema.
   *
   * @remarks
   * This method constructs an XML string based on the properties of the BCF Topic instance.
   * It includes the topic's guid, type, status, creation date, creation author, priority, index,
   * modified date, modified author, due date, assigned to, description, stage, labels, related topics,
   * comments, and viewpoints.
   *
   * @returns A string representing the XML serialization of the BCF Topic.
   *
   * @example
   * ```typescript
   * const topic = bcfTopics.create(); // Created with an instance of BCFTopics
   * const xml = topic.serialize();
   * console.log(xml);
   * ```
   */
  serialize() {
    var t, i;
    const n = this._managerVersion, s = {
      $Guid: this.guid,
      $TopicType: this.type,
      $TopicStatus: this.status,
      $ServerAssignedId: this.serverAssignedId,
      Title: this.title,
      CreationAuthor: this.creationAuthor,
      CreationDate: this.creationDate.toISOString(),
      Priority: this.priority,
      Index: n === "2.1" ? this.index : void 0,
      ModifiedDate: (t = this.modifiedDate) == null ? void 0 : t.toISOString(),
      ModifiedAuthor: this.modifiedAuthor,
      DueDate: (i = this.dueDate) == null ? void 0 : i.toISOString(),
      AssignedTo: this.assignedTo,
      Description: this.description,
      Stage: this.stage,
      DocumentReferences: n === "3" ? { DocumentReference: this.createDocumentReferencesTag(n) } : void 0,
      RelatedTopics: n === "3" ? { RelatedTopic: this.createRelatedTopicTags() } : void 0,
      RelatedTopic: n === "2.1" ? this.createRelatedTopicTags() : void 0,
      Labels: n === "3" ? { Label: this.createLabelTags() } : void 0,
      Viewpoints: n === "3" ? { ViewPoint: this.createViewpointTags() } : void 0,
      Comments: n === "3" ? { Comment: this.createCommentTags() } : void 0
    };
    n === "2.1" && (s.Labels = this.createLabelTags(), s.DocumentReference = this.createDocumentReferencesTag(n));
    const o = {
      Markup: { Topic: s }
    };
    return n === "2.1" && (o.Markup.Viewpoints = this.createViewpointTags(), o.Markup.Comment = this.createCommentTags()), `<?xml version="1.0" encoding="UTF-8"?>
    ${Aue.builder.build(o)}`;
  }
};
tt(Kbe, "default", {
  title: "BCF Topic",
  type: "Issue",
  status: "Active"
});
let E2e = Kbe;
const XZe = (e, t) => {
  if (t.trim() === "")
    return;
  const i = c1.xmlParser.parse(t).Extensions;
  if (!i)
    return;
  const { Priorities: n, TopicStatuses: s, TopicTypes: o, Users: r } = i;
  if (n && n.Priority) {
    const l = Array.isArray(n.Priority) ? n.Priority : [n.Priority];
    for (const c of l)
      e.config.priorities.add(c);
  }
  if (s && s.TopicStatus) {
    const l = Array.isArray(s.TopicStatus) ? s.TopicStatus : [s.TopicStatus];
    for (const c of l)
      e.config.statuses.add(c);
  }
  if (o && o.TopicType) {
    const l = Array.isArray(o.TopicType) ? o.TopicType : [o.TopicType];
    for (const c of l)
      e.config.types.add(c);
  }
  if (r && r.User) {
    const l = Array.isArray(r.User) ? r.User : [r.User];
    for (const c of l)
      e.config.users.add(c);
  }
};
class eQe extends Hie {
  constructor() {
    super(...arguments), tt(this, "_config", {
      version: {
        type: "Select",
        options: /* @__PURE__ */ new Set(["2.1", "3"]),
        multiple: !1,
        value: ""
      },
      author: {
        type: "Text",
        value: ""
      },
      types: {
        type: "TextSet",
        value: /* @__PURE__ */ new Set()
      },
      statuses: {
        type: "TextSet",
        value: /* @__PURE__ */ new Set()
      },
      priorities: {
        type: "TextSet",
        value: /* @__PURE__ */ new Set()
      },
      labels: {
        type: "TextSet",
        value: /* @__PURE__ */ new Set()
      },
      stages: {
        type: "TextSet",
        value: /* @__PURE__ */ new Set()
      },
      users: {
        type: "TextSet",
        value: /* @__PURE__ */ new Set()
      },
      includeSelectionTag: {
        type: "Boolean",
        value: !1
      },
      updateExtensionsOnImport: {
        type: "Boolean",
        value: !1
      },
      strict: {
        type: "Boolean",
        value: !1
      },
      includeAllExtensionsOnExport: {
        type: "Boolean",
        value: !1
      },
      fallbackVersionOnImport: {
        type: "Select",
        multiple: !1,
        options: /* @__PURE__ */ new Set(["2.1", "3"]),
        value: ""
      },
      ignoreIncompleteTopicsOnImport: {
        type: "Boolean",
        value: !1
      },
      exportCustomDataAsLabels: {
        type: "Boolean",
        value: !1
      }
    });
  }
  get version() {
    return this._config.version.value;
  }
  set version(t) {
    this._config.version.value = t;
  }
  get author() {
    return this._config.author.value;
  }
  set author(t) {
    this._config.author.value = t;
  }
  get types() {
    return this._config.types.value;
  }
  set types(t) {
    this._config.types.value = t;
  }
  get statuses() {
    return this._config.statuses.value;
  }
  set statuses(t) {
    this._config.statuses.value = t;
  }
  get priorities() {
    return this._config.priorities.value;
  }
  set priorities(t) {
    this._config.priorities.value = t;
  }
  get labels() {
    return this._config.labels.value;
  }
  set labels(t) {
    this._config.labels.value = t;
  }
  get stages() {
    return this._config.stages.value;
  }
  set stages(t) {
    this._config.stages.value = t;
  }
  get users() {
    return this._config.users.value;
  }
  set users(t) {
    this._config.users.value = t;
  }
  get includeSelectionTag() {
    return this._config.includeSelectionTag.value;
  }
  set includeSelectionTag(t) {
    this._config.includeSelectionTag.value = t;
  }
  get updateExtensionsOnImport() {
    return this._config.updateExtensionsOnImport.value;
  }
  set updateExtensionsOnImport(t) {
    this._config.updateExtensionsOnImport.value = t;
  }
  get strict() {
    return this._config.strict.value;
  }
  set strict(t) {
    this._config.strict.value = t;
  }
  get includeAllExtensionsOnExport() {
    return this._config.includeAllExtensionsOnExport.value;
  }
  set includeAllExtensionsOnExport(t) {
    this._config.includeAllExtensionsOnExport.value = t;
  }
  get fallbackVersionOnImport() {
    return this._config.fallbackVersionOnImport.value;
  }
  set fallbackVersionOnImport(t) {
    this._config.fallbackVersionOnImport.value = t;
  }
  get ignoreIncompleteTopicsOnImport() {
    return this._config.ignoreIncompleteTopicsOnImport.value;
  }
  set ignoreIncompleteTopicsOnImport(t) {
    this._config.ignoreIncompleteTopicsOnImport.value = t;
  }
  get exportCustomDataAsLabels() {
    return this._config.exportCustomDataAsLabels.value;
  }
  set exportCustomDataAsLabels(t) {
    this._config.exportCustomDataAsLabels.value = t;
  }
}
const kme = class IJ extends bI {
  constructor() {
    super(...arguments), tt(this, "enabled", !1), tt(this, "_defaultConfig", {
      author: "jhon.doe@example.com",
      version: "2.1",
      types: /* @__PURE__ */ new Set([
        "Clash",
        "Failure",
        "Fault",
        "Inquiry",
        "Issue",
        "Remark",
        "Request"
      ]),
      statuses: /* @__PURE__ */ new Set(["Active", "In Progress", "Done", "In Review", "Closed"]),
      priorities: /* @__PURE__ */ new Set(["On hold", "Minor", "Normal", "Major", "Critical"]),
      labels: /* @__PURE__ */ new Set(),
      stages: /* @__PURE__ */ new Set(),
      users: /* @__PURE__ */ new Set(),
      includeSelectionTag: !1,
      updateExtensionsOnImport: !0,
      strict: !1,
      includeAllExtensionsOnExport: !0,
      fallbackVersionOnImport: "2.1",
      ignoreIncompleteTopicsOnImport: !1,
      exportCustomDataAsLabels: !1
    }), tt(this, "config", new eQe(
      this,
      this.components,
      "BCF Topics",
      IJ.uuid
    )), tt(this, "list", new f0()), tt(this, "documents", new f0()), tt(this, "onSetup", new es()), tt(this, "isSetup", !1), tt(this, "onBCFImported", new es()), tt(this, "onDisposed", new es());
  }
  setup(t) {
    if (this.isSetup)
      return;
    const i = { ...this._defaultConfig, ...t };
    this.config.version = i.version, this.config.author = i.author, this.config.types = i.types, this.config.statuses = i.statuses, this.config.priorities = i.priorities, this.config.labels = i.labels, this.config.stages = i.stages, this.config.users = i.users, this.config.includeSelectionTag = i.includeSelectionTag, this.config.updateExtensionsOnImport = i.updateExtensionsOnImport, this.config.strict = i.strict, this.config.includeAllExtensionsOnExport = i.includeAllExtensionsOnExport, this.config.fallbackVersionOnImport = i.fallbackVersionOnImport || "", this.config.ignoreIncompleteTopicsOnImport = i.ignoreIncompleteTopicsOnImport, this.isSetup = !0, this.enabled = !0, this.onSetup.trigger();
  }
  /**
   * Creates a new BCFTopic instance and adds it to the list.
   *
   * @param data - Optional partial BCFTopic object to initialize the new topic with.
   * If not provided, default values will be used.
   * @returns The newly created BCFTopic instance.
   */
  create(t) {
    const i = new E2e(this.components);
    return t ? (i.guid = t.guid ?? i.guid, i.set(t)) : this.list.set(i.guid, i), i;
  }
  /**
   * Disposes of the BCFTopics component and triggers the onDisposed event.
   *
   * @remarks
   * This method clears the list of topics and triggers the onDisposed event.
   * It also resets the onDisposed event listener.
   */
  dispose() {
    this.list.dispose(), this.onDisposed.trigger(), this.onDisposed.reset();
  }
  /**
   * Retrieves the unique set of topic types used across all topics.
   *
   * @returns A Set containing the unique topic types.
   */
  get usedTypes() {
    const t = [...this.list].map(([i, n]) => n.type);
    return new Set(t);
  }
  /**
   * Retrieves the unique set of topic statuses used across all topics.
   *
   * @returns A Set containing the unique topic statuses.
   */
  get usedStatuses() {
    const t = [...this.list].map(([i, n]) => n.status);
    return new Set(t);
  }
  /**
   * Retrieves the unique set of topic priorities used across all topics.
   *
   * @returns A Set containing the unique topic priorities.
   * Note: This method filters out any null or undefined priorities.
   */
  get usedPriorities() {
    const t = [...this.list].map(([i, n]) => n.priority).filter((i) => i);
    return new Set(t);
  }
  /**
   * Retrieves the unique set of topic stages used across all topics.
   *
   * @returns A Set containing the unique topic stages.
   * Note: This method filters out any null or undefined stages.
   */
  get usedStages() {
    const t = [...this.list].map(([i, n]) => n.stage).filter((i) => i);
    return new Set(t);
  }
  /**
   * Retrieves the unique set of users associated with topics.
   *
   * @returns A Set containing the unique users.
   * Note: This method collects users from the creation author, assigned to, modified author, and comment authors.
   */
  get usedUsers() {
    const t = [];
    for (const [i, n] of this.list) {
      t.push(n.creationAuthor), n.assignedTo && t.push(n.assignedTo), n.modifiedAuthor && t.push(n.modifiedAuthor);
      for (const [s, o] of n.comments)
        t.push(o.author), o.modifiedAuthor && t.push(o.modifiedAuthor);
    }
    return new Set(t);
  }
  /**
   * Retrieves the unique set of labels used across all topics.
   *
   * @returns A Set containing the unique labels.
   */
  get usedLabels() {
    const t = [];
    for (const [i, n] of this.list)
      t.push(...n.labels);
    return new Set(t);
  }
  /**
   * Updates the set of extensions (types, statuses, priorities, labels, stages, users) based on the current topics.
   * This method iterates through each topic in the list and adds its properties to the corresponding sets in the config.
   */
  updateExtensions() {
    for (const [t, i] of this.list) {
      for (const n of i.labels)
        this.config.labels.add(n);
      this.config.types.add(i.type), i.priority && this.config.priorities.add(i.priority), i.stage && this.config.stages.add(i.stage), this.config.statuses.add(i.status), this.config.users.add(i.creationAuthor), i.assignedTo && this.config.users.add(i.assignedTo), i.modifiedAuthor && this.config.users.add(i.modifiedAuthor);
      for (const [n, s] of i.comments)
        this.config.users.add(s.author), s.modifiedAuthor && this.config.users.add(s.modifiedAuthor);
    }
  }
  /**
   * Updates the references to viewpoints in the topics.
   * This function iterates through each topic and checks if the viewpoints exist in the viewpoints list.
   * If a viewpoint does not exist, it is removed from the topic's viewpoints.
   */
  updateViewpointReferences() {
    const t = this.components.get(VO);
    for (const [i, n] of this.list)
      for (const s of n.viewpoints)
        t.list.has(s) || n.viewpoints.delete(s);
  }
  /**
   * Exports the given topics to a BCF (Building Collaboration Format) zip file.
   *
   * @param topics - The topics to export. Defaults to all topics in the list.
   * @returns A promise that resolves to a Blob containing the exported BCF zip file.
   */
  async export(t = this.list.values()) {
    const i = new y2e();
    i.file(
      "bcf.version",
      `<?xml version="1.0" encoding="UTF-8"?>
    <Version VersionId="${this.config.version}" xsi:noNamespaceSchemaLocation="https://raw.githubusercontent.com/buildingSMART/BCF-XML/release_3_0/Schemas/version.xsd"
    xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">
    </Version>`
    );
    for (const [o, r] of this.documents.entries())
      r.type !== "external" && i.file(
        this.config.version === "2.1" ? r.fileName : `documents/${o}`,
        r.data
      );
    if (this.config.version === "3") {
      const o = [];
      for (const [r, l] of this.documents.entries()) {
        const { type: c, description: h } = l;
        c !== "external" && o.push(`<Document Guid="${r}">
        <Filename>${l.fileName}</Filename>
        ${h ? `<Description>${h}</Description>` : ""}
      </Document>`);
      }
      o.length > 0 && i.file(
        "documents.xml",
        `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
  <DocumentInfo xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="documents.xsd">
    <Documents>
      ${o.join(`
`)}
    </Documents>
  </DocumentInfo>`
      );
    }
    i.file("bcf.extensions", this.serializeExtensions());
    const n = this.components.get(VO);
    for (const o of t) {
      const r = i.folder(o.guid);
      r.file("markup.bcf", o.serialize());
      for (const l of o.viewpoints) {
        const c = n.list.get(l);
        if (!c)
          continue;
        const h = c.title ?? c.guid;
        r.file(
          `${h}.bcfv`,
          await c.serialize()
        );
        const I = n.snapshots.get(c.snapshot);
        if (!I)
          continue;
        const p = I ? c.snapshot : c.guid, y = n.getSnapshotExtension(
          c.snapshot
        );
        r.file(
          `${p}.${y}`,
          I,
          {
            binary: !0
          }
        );
      }
    }
    return await i.generateAsync({ type: "blob" });
  }
  serializeExtensions() {
    const t = [...this.config.types].map((l) => `<TopicType>${l}</TopicType>`).join(`
`), i = [...this.config.statuses].map((l) => `<TopicStatus>${l}</TopicStatus>`).join(`
`), n = [...this.config.priorities].map((l) => `<Priority>${l}</Priority>`).join(`
`), s = [...this.config.labels].map((l) => `<TopicLabel>${l}</TopicLabel>`).join(`
`), o = [...this.config.stages].map((l) => `<Stage>${l}</Stage>`).join(`
`), r = [...this.config.users].map((l) => `<User>${l}</User>`).join(`
`);
    return `
      <?xml version="1.0" encoding="UTF-8"?>
      <Extensions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:noNamespaceSchemaLocation="your-schema-location.xsd">
        ${t.length !== 0 ? `<TopicTypes>
${t}
</TopicTypes>` : ""}
        ${i.length !== 0 ? `<TopicStatuses>
${i}
</TopicStatuses>` : ""}
        ${n.length !== 0 ? `<Priorities>
${n}
</Priorities>` : ""}
        ${s.length !== 0 ? `<TopicLabels>
${s}
</TopicLabels>` : ""}
        ${o.length !== 0 ? `<Stages>
${o}
</Stages>` : ""}
        ${r.length !== 0 ? `<Users>
${r}
</Users>` : ""}
      </Extensions>
    `;
  }
  processMarkupComment(t) {
    const {
      Guid: i,
      Date: n,
      Author: s,
      Comment: o,
      Viewpoint: r
    } = t;
    if (!(i && n && s && (KIe || r)))
      return null;
    const l = new KIe(this.components, o ?? "");
    return l.guid = i, l.date = new Date(n), l.author = s, l.viewpoint = r == null ? void 0 : r.Guid, l.modifiedAuthor = t.ModifiedAuthor, l.modifiedDate = t.ModifiedDate ? new Date(t.ModifiedDate) : void 0, l;
  }
  getMarkupComments(t, i) {
    var n;
    let s;
    if (i === "2.1" && (s = t.Comment), i === "3" && (s = (n = t.Topic.Comments) == null ? void 0 : n.Comment), !s)
      return [];
    s = Array.isArray(s) ? s : [s];
    const o = s.map((l) => this.processMarkupComment(l)).filter((l) => l);
    return Array.isArray(o) ? o : [o];
  }
  getMarkupLabels(t, i) {
    var n;
    let s;
    return i === "2.1" && (s = t.Topic.Labels), i === "3" && (s = (n = t.Topic.Labels) == null ? void 0 : n.Label), s ? Array.isArray(s) ? s : [s] : [];
  }
  getMarkupViewpoints(t, i) {
    var n;
    let s;
    return i === "2.1" && (s = t.Viewpoints), i === "3" && (s = (n = t.Topic.Viewpoints) == null ? void 0 : n.ViewPoint), s ? (s = Array.isArray(s) ? s : [s], s) : [];
  }
  getMarkupRelatedTopics(t, i) {
    var n;
    let s;
    return i === "2.1" && (s = t.Topic.RelatedTopic), i === "3" && (s = (n = t.Topic.RelatedTopics) == null ? void 0 : n.RelatedTopic), s ? (Array.isArray(s) ? s : [s]).map((r) => r.Guid) : [];
  }
  getMarkupDocumentReferences(t, i) {
    var n;
    let s;
    return i === "2.1" && (s = t.Topic.DocumentReference), i === "3" && (s = (n = t.Topic.DocumentReferences) == null ? void 0 : n.DocumentReference), s ? Array.isArray(s) ? s : [s] : [];
  }
  /**
   * Loads BCF (Building Collaboration Format) data into the engine.
   *
   * @param world - The default world where the viewpoints are going to be created.
   * @param data - The BCF data to load.
   *
   * @returns A promise that resolves to an object containing the created viewpoints and topics.
   *
   * @throws An error if the BCF version is not supported.
   */
  async load(t) {
    var i, n, s;
    const {
      fallbackVersionOnImport: o,
      ignoreIncompleteTopicsOnImport: r,
      updateExtensionsOnImport: l
    } = this.config, c = new y2e();
    await c.loadAsync(t);
    const h = Object.values(c.files);
    let I = o;
    const p = h.find((L) => L.name.endsWith(".version"));
    if (p) {
      const L = await p.async("string"), P = IJ.xmlParser.parse(L).Version.VersionId;
      I = String(P);
    }
    if (!(I && (I === "2.1" || I === "3")))
      throw new Error(`BCFTopics: ${I} is not supported.`);
    const y = h.find(
      (L) => L.name.endsWith(".extensions")
    );
    if (l && y) {
      const L = await y.async("string");
      XZe(this, L);
    }
    const m = [], A = this.components.get(VO), C = h.filter((L) => L.name.endsWith(".bcfv"));
    for (const L of C) {
      const P = await L.async("string"), z = IJ.xmlParser.parse(P).VisualizationInfo;
      if (!z) {
        console.warn("Missing VisualizationInfo in Viewpoint");
        continue;
      }
      const W = {}, {
        Guid: re,
        ClippingPlanes: ce,
        Components: te,
        OrthogonalCamera: ee,
        PerspectiveCamera: Ne
      } = z;
      if (re && (W.guid = re), te) {
        const Oe = {
          selection: [],
          coloring: [],
          visibility: {
            default_visibility: !1,
            exceptions: [],
            view_setup_hints: {
              spaces_visible: !1,
              space_boundaries_visible: !1,
              openings_visible: !1
            }
          }
        };
        W.components = Oe;
        const { Selection: pe, Visibility: je } = te;
        if (pe && pe.Component) {
          const vt = Array.isArray(pe.Component) ? pe.Component : [pe.Component];
          Oe.selection = vt.map((Rt) => Rt.IfcGuid ? { ifc_guid: Rt.IfcGuid } : null).filter((Rt) => Rt !== null);
        }
        if (je && "DefaultVisibility" in je && (Oe.visibility.default_visibility = je.DefaultVisibility), je && je.Exceptions && "Component" in je.Exceptions) {
          const { Component: vt } = je.Exceptions, Rt = Array.isArray(vt) ? vt : [vt];
          Oe.visibility.exceptions = Rt.map((ze) => ze.IfcGuid ? { ifc_guid: ze.IfcGuid } : null).filter((ze) => ze !== null);
        }
        let Ve;
        I === "2.1" && (Ve = te.ViewSetupHints), I === "3" && (Ve = (i = te.Visibility) == null ? void 0 : i.ViewSetupHints), Ve && ("OpeningsVisible" in Ve && (Oe.visibility.view_setup_hints.openings_visible = Ve.OpeningsVisible), "SpacesVisible" in Ve && (Oe.visibility.view_setup_hints.spaces_visible = Ve.SpacesVisible), "SpaceBoundariesVisible" in Ve && (Oe.visibility.view_setup_hints.space_boundaries_visible = Ve.SpaceBoundariesVisible));
        const { Coloring: $e } = te;
        if ($e && $e.Color) {
          const vt = Array.isArray($e.Color) ? $e.Color : [$e.Color];
          for (const Rt of vt) {
            const { Color: ze, Component: mt } = Rt;
            if (!(ze.length === 6 || ze.length === 8))
              continue;
            const Et = ze.length === 6 ? ze : ze.slice(2), Dt = (Array.isArray(mt) ? mt : [mt]).map((Ct) => Ct.IfcGuid ? { ifc_guid: Ct.IfcGuid } : null).filter((Ct) => Ct !== null);
            Oe.coloring.push({
              color: Et,
              components: Dt
            });
          }
        }
      }
      if (ee || Ne) {
        const Oe = z.PerspectiveCamera ?? z.OrthogonalCamera, { CameraViewPoint: pe, CameraDirection: je } = Oe, Ve = new Ge(
          Number(pe.X),
          Number(pe.Z),
          Number(-pe.Y)
        ), $e = new Ge(
          Number(je.X),
          Number(je.Z),
          Number(-je.Y)
        ), vt = {
          camera_view_point: { x: Ve.x, y: Ve.y, z: Ve.z },
          camera_direction: { x: $e.x, y: $e.y, z: $e.z },
          aspect_ratio: "AspectRatio" in Oe ? Oe.AspectRatio : 1,
          // TODO: Better define camera_up_vector
          camera_up_vector: {
            x: 0,
            y: 0,
            z: 0
          }
        };
        "ViewToWorldScale" in Oe && (W.orthogonal_camera = {
          ...vt,
          view_to_world_scale: Oe.ViewToWorldScale
        }), "FieldOfView" in Oe && (W.perspective_camera = {
          ...vt,
          field_of_view: Oe.FieldOfView
        });
      }
      if (ce) {
        const pe = (Array.isArray(ce.ClippingPlane) ? ce.ClippingPlane : [ce.ClippingPlane]).map(
          ({ Location: je, Direction: Ve }) => ({
            location: { x: je.x, y: je.y, z: je.z },
            direction: { x: Ve.x, y: Ve.y, z: Ve.z }
          })
        );
        W.clipping_planes = pe;
      }
      const Ae = new Qbe(this.components, W);
      m.push(Ae);
    }
    const O = {}, R = [], F = h.filter((L) => L.name.endsWith(".bcf"));
    for (const L of F) {
      const P = await L.async("string"), z = IJ.xmlParser.parse(P).Markup, W = z.Topic, {
        Guid: re,
        TopicType: ce,
        TopicStatus: te,
        Title: ee,
        CreationDate: Ne,
        CreationAuthor: Ae
      } = W;
      if (r && !(re && ce && te && ee && Ne && Ae))
        continue;
      const Oe = new E2e(this.components);
      Oe.guid = re ?? Oe.guid;
      const pe = this.getMarkupRelatedTopics(z, I);
      O[Oe.guid] = new Set(pe), Oe.type = ce ?? Oe.type, Oe.status = te ?? Oe.status, Oe.title = ee ?? Oe.title, Oe.creationDate = Ne ? new Date(Ne) : Oe.creationDate, Oe.creationAuthor = Ae ?? Oe.creationAuthor, Oe.serverAssignedId = W.ServerAssignedId, Oe.priority = W.Priority, Oe.index = W.Index, Oe.modifiedDate = W.ModifiedDate ? new Date(W.ModifiedDate) : void 0, Oe.modifiedAuthor = W.ModifiedAuthor, Oe.dueDate = W.DueDate ? new Date(W.DueDate) : void 0, Oe.assignedTo = W.AssignedTo, Oe.description = W.Description, Oe.stage = W.Stage;
      const je = this.getMarkupLabels(z, I);
      for (const Et of je)
        Oe.labels.add(Et);
      const Ve = this.getMarkupComments(z, I);
      for (const Et of Ve)
        Oe.comments.set(Et.guid, Et);
      const $e = this.getMarkupViewpoints(z, I);
      for (const Et of $e) {
        if (!(Et && Et.Guid))
          continue;
        const it = A.list.get(Et.Guid);
        if (!it)
          continue;
        Oe.viewpoints.add(it.guid);
        const Dt = `${Oe.guid}/${Et.Snapshot}`, Ct = h.find(({ name: Kt }) => Kt === Dt);
        if (Ct) {
          const Kt = await Ct.async("arraybuffer"), Zt = new Uint8Array(Kt);
          A.snapshots.set(it.guid, Zt), it.snapshot = it.guid ?? null;
        }
      }
      const vt = this.getMarkupDocumentReferences(
        z,
        I
      ), Rt = h.find((Et) => Et.name === "documents.xml");
      let ze = [];
      const mt = await (Rt == null ? void 0 : Rt.async("string"));
      if (mt) {
        const Et = (s = (n = Aue.parser.parse(mt).DocumentInfo) == null ? void 0 : n.Documents) == null ? void 0 : s.Document;
        ze = Array.isArray(Et) ? Et : [Et];
      }
      for (const Et of vt) {
        const {
          Description: it,
          // From 3.0
          DocumentGuid: Dt,
          Url: Ct,
          // From 2.1
          isExternal: Kt,
          ReferencedDocument: Zt
        } = Et;
        if (Dt && ze.length > 0) {
          const Xt = ze.find(
            ({ Guid: Ci }) => Ci === Dt
          ), gi = h.find(
            (Ci) => Ci.name.endsWith(Dt)
          ), Wt = await (gi == null ? void 0 : gi.async("uint8array"));
          if (!(Xt && Wt))
            continue;
          const { Description: Di, Filename: ni } = Xt;
          this.documents.set(Dt, {
            type: "internal",
            fileName: ni,
            description: Di,
            data: Wt
          }), Oe.documentReferences.add(Dt);
        }
        if (Ct) {
          const Xt = this.documents.add({
            type: "external",
            url: Ct,
            description: it
          });
          Oe.documentReferences.add(Xt);
        }
        if (Zt) {
          let Xt = null;
          if (Kt)
            Xt = this.documents.add({
              type: "external",
              url: Zt,
              description: it
            });
          else {
            const gi = Zt.split("/"), Wt = gi[gi.length - 1], Di = h.find((Ci) => Ci.name.endsWith(Wt)), ni = await (Di == null ? void 0 : Di.async("uint8array"));
            if (!ni)
              continue;
            Xt = this.documents.add({
              type: "internal",
              fileName: Wt,
              data: ni,
              description: it
            });
          }
          Oe.documentReferences.add(Xt);
        }
      }
      this.list.set(Oe.guid, Oe), R.push(Oe);
    }
    for (const L in O) {
      const P = this.list.get(L);
      if (!P)
        continue;
      const z = O[L];
      for (const W of z)
        P.relatedTopics.add(W);
    }
    return this.onBCFImported.trigger(R), { viewpoints: m, topics: R };
  }
};
tt(kme, "uuid", "de977976-e4f6-4e4f-a01a-204727839802");
tt(kme, "xmlParser", new vue.XMLParser({
  allowBooleanAttributes: !0,
  attributeNamePrefix: "",
  ignoreAttributes: !1,
  ignoreDeclaration: !0,
  ignorePiTags: !0,
  numberParseOptions: { leadingZeros: !0, hex: !0 },
  parseAttributeValue: !0,
  preserveOrder: !1,
  processEntities: !1,
  removeNSPrefix: !0,
  trimValues: !0
}));
let c1 = kme;
const sU = new Aae(), Um = new Ge(), m_ = new Ge(), Pu = new gI(), g2e = {
  X: new Ge(1, 0, 0),
  Y: new Ge(0, 1, 0),
  Z: new Ge(0, 0, 1)
}, Vce = { type: "change" }, w2e = { type: "mouseDown", mode: null }, T2e = { type: "mouseUp", mode: null }, R2e = { type: "objectChange" };
class tQe extends xUe {
  /**
   * Constructs a new controls instance.
   *
   * @param {Camera} camera - The camera of the rendered scene.
   * @param {?HTMLDOMElement} domElement - The HTML element used for event listeners.
   */
  constructor(t, i = null) {
    super(void 0, i);
    const n = new lQe(this);
    this._root = n;
    const s = new aQe();
    this._gizmo = s, n.add(s);
    const o = new uQe();
    this._plane = o, n.add(o);
    const r = this;
    function l(L, P) {
      let z = P;
      Object.defineProperty(r, L, {
        get: function() {
          return z !== void 0 ? z : P;
        },
        set: function(W) {
          z !== W && (z = W, o[L] = W, s[L] = W, r.dispatchEvent({ type: L + "-changed", value: W }), r.dispatchEvent(Vce));
        }
      }), r[L] = P, o[L] = P, s[L] = P;
    }
    l("camera", t), l("object", void 0), l("enabled", !0), l("axis", null), l("mode", "translate"), l("translationSnap", null), l("rotationSnap", null), l("scaleSnap", null), l("space", "world"), l("size", 1), l("dragging", !1), l("showX", !0), l("showY", !0), l("showZ", !0), l("minX", -1 / 0), l("maxX", 1 / 0), l("minY", -1 / 0), l("maxY", 1 / 0), l("minZ", -1 / 0), l("maxZ", 1 / 0);
    const c = new Ge(), h = new Ge(), I = new gI(), p = new gI(), y = new Ge(), m = new gI(), A = new Ge(), C = new Ge(), O = new Ge(), R = 0, F = new Ge();
    l("worldPosition", c), l("worldPositionStart", h), l("worldQuaternion", I), l("worldQuaternionStart", p), l("cameraPosition", y), l("cameraQuaternion", m), l("pointStart", A), l("pointEnd", C), l("rotationAxis", O), l("rotationAngle", R), l("eye", F), this._offset = new Ge(), this._startNorm = new Ge(), this._endNorm = new Ge(), this._cameraScale = new Ge(), this._parentPosition = new Ge(), this._parentQuaternion = new gI(), this._parentQuaternionInv = new gI(), this._parentScale = new Ge(), this._worldScaleStart = new Ge(), this._worldQuaternionInv = new gI(), this._worldScale = new Ge(), this._positionStart = new Ge(), this._quaternionStart = new gI(), this._scaleStart = new Ge(), this._getPointer = iQe.bind(this), this._onPointerDown = sQe.bind(this), this._onPointerHover = nQe.bind(this), this._onPointerMove = oQe.bind(this), this._onPointerUp = rQe.bind(this), i !== null && this.connect(i);
  }
  connect(t) {
    super.connect(t), this.domElement.addEventListener("pointerdown", this._onPointerDown), this.domElement.addEventListener("pointermove", this._onPointerHover), this.domElement.addEventListener("pointerup", this._onPointerUp), this.domElement.style.touchAction = "none";
  }
  disconnect() {
    this.domElement.removeEventListener("pointerdown", this._onPointerDown), this.domElement.removeEventListener("pointermove", this._onPointerHover), this.domElement.removeEventListener("pointermove", this._onPointerMove), this.domElement.removeEventListener("pointerup", this._onPointerUp), this.domElement.style.touchAction = "auto";
  }
  /**
   * Returns the visual representation of the controls. Add the helper to your scene to
   * visually transform the attached  3D object.
   *
   * @return {TransformControlsRoot} The helper.
   */
  getHelper() {
    return this._root;
  }
  pointerHover(t) {
    if (this.object === void 0 || this.dragging === !0)
      return;
    t !== null && sU.setFromCamera(t, this.camera);
    const i = zce(this._gizmo.picker[this.mode], sU);
    i ? this.axis = i.object.name : this.axis = null;
  }
  pointerDown(t) {
    if (!(this.object === void 0 || this.dragging === !0 || t != null && t.button !== 0) && this.axis !== null) {
      t !== null && sU.setFromCamera(t, this.camera);
      const i = zce(this._plane, sU, !0);
      i && (this.object.updateMatrixWorld(), this.object.parent.updateMatrixWorld(), this._positionStart.copy(this.object.position), this._quaternionStart.copy(this.object.quaternion), this._scaleStart.copy(this.object.scale), this.object.matrixWorld.decompose(this.worldPositionStart, this.worldQuaternionStart, this._worldScaleStart), this.pointStart.copy(i.point).sub(this.worldPositionStart)), this.dragging = !0, w2e.mode = this.mode, this.dispatchEvent(w2e);
    }
  }
  pointerMove(t) {
    const i = this.axis, n = this.mode, s = this.object;
    let o = this.space;
    if (n === "scale" ? o = "local" : (i === "E" || i === "XYZE" || i === "XYZ") && (o = "world"), s === void 0 || i === null || this.dragging === !1 || t !== null && t.button !== -1)
      return;
    t !== null && sU.setFromCamera(t, this.camera);
    const r = zce(this._plane, sU, !0);
    if (r) {
      if (this.pointEnd.copy(r.point).sub(this.worldPositionStart), n === "translate")
        this._offset.copy(this.pointEnd).sub(this.pointStart), o === "local" && i !== "XYZ" && this._offset.applyQuaternion(this._worldQuaternionInv), i.indexOf("X") === -1 && (this._offset.x = 0), i.indexOf("Y") === -1 && (this._offset.y = 0), i.indexOf("Z") === -1 && (this._offset.z = 0), o === "local" && i !== "XYZ" ? this._offset.applyQuaternion(this._quaternionStart).divide(this._parentScale) : this._offset.applyQuaternion(this._parentQuaternionInv).divide(this._parentScale), s.position.copy(this._offset).add(this._positionStart), this.translationSnap && (o === "local" && (s.position.applyQuaternion(Pu.copy(this._quaternionStart).invert()), i.search("X") !== -1 && (s.position.x = Math.round(s.position.x / this.translationSnap) * this.translationSnap), i.search("Y") !== -1 && (s.position.y = Math.round(s.position.y / this.translationSnap) * this.translationSnap), i.search("Z") !== -1 && (s.position.z = Math.round(s.position.z / this.translationSnap) * this.translationSnap), s.position.applyQuaternion(this._quaternionStart)), o === "world" && (s.parent && s.position.add(Um.setFromMatrixPosition(s.parent.matrixWorld)), i.search("X") !== -1 && (s.position.x = Math.round(s.position.x / this.translationSnap) * this.translationSnap), i.search("Y") !== -1 && (s.position.y = Math.round(s.position.y / this.translationSnap) * this.translationSnap), i.search("Z") !== -1 && (s.position.z = Math.round(s.position.z / this.translationSnap) * this.translationSnap), s.parent && s.position.sub(Um.setFromMatrixPosition(s.parent.matrixWorld)))), s.position.x = Math.max(this.minX, Math.min(this.maxX, s.position.x)), s.position.y = Math.max(this.minY, Math.min(this.maxY, s.position.y)), s.position.z = Math.max(this.minZ, Math.min(this.maxZ, s.position.z));
      else if (n === "scale") {
        if (i.search("XYZ") !== -1) {
          let l = this.pointEnd.length() / this.pointStart.length();
          this.pointEnd.dot(this.pointStart) < 0 && (l *= -1), m_.set(l, l, l);
        } else
          Um.copy(this.pointStart), m_.copy(this.pointEnd), Um.applyQuaternion(this._worldQuaternionInv), m_.applyQuaternion(this._worldQuaternionInv), m_.divide(Um), i.search("X") === -1 && (m_.x = 1), i.search("Y") === -1 && (m_.y = 1), i.search("Z") === -1 && (m_.z = 1);
        s.scale.copy(this._scaleStart).multiply(m_), this.scaleSnap && (i.search("X") !== -1 && (s.scale.x = Math.round(s.scale.x / this.scaleSnap) * this.scaleSnap || this.scaleSnap), i.search("Y") !== -1 && (s.scale.y = Math.round(s.scale.y / this.scaleSnap) * this.scaleSnap || this.scaleSnap), i.search("Z") !== -1 && (s.scale.z = Math.round(s.scale.z / this.scaleSnap) * this.scaleSnap || this.scaleSnap));
      } else if (n === "rotate") {
        this._offset.copy(this.pointEnd).sub(this.pointStart);
        const l = 20 / this.worldPosition.distanceTo(Um.setFromMatrixPosition(this.camera.matrixWorld));
        let c = !1;
        i === "XYZE" ? (this.rotationAxis.copy(this._offset).cross(this.eye).normalize(), this.rotationAngle = this._offset.dot(Um.copy(this.rotationAxis).cross(this.eye)) * l) : (i === "X" || i === "Y" || i === "Z") && (this.rotationAxis.copy(g2e[i]), Um.copy(g2e[i]), o === "local" && Um.applyQuaternion(this.worldQuaternion), Um.cross(this.eye), Um.length() === 0 ? c = !0 : this.rotationAngle = this._offset.dot(Um.normalize()) * l), (i === "E" || c) && (this.rotationAxis.copy(this.eye), this.rotationAngle = this.pointEnd.angleTo(this.pointStart), this._startNorm.copy(this.pointStart).normalize(), this._endNorm.copy(this.pointEnd).normalize(), this.rotationAngle *= this._endNorm.cross(this._startNorm).dot(this.eye) < 0 ? 1 : -1), this.rotationSnap && (this.rotationAngle = Math.round(this.rotationAngle / this.rotationSnap) * this.rotationSnap), o === "local" && i !== "E" && i !== "XYZE" ? (s.quaternion.copy(this._quaternionStart), s.quaternion.multiply(Pu.setFromAxisAngle(this.rotationAxis, this.rotationAngle)).normalize()) : (this.rotationAxis.applyQuaternion(this._parentQuaternionInv), s.quaternion.copy(Pu.setFromAxisAngle(this.rotationAxis, this.rotationAngle)), s.quaternion.multiply(this._quaternionStart).normalize());
      }
      this.dispatchEvent(Vce), this.dispatchEvent(R2e);
    }
  }
  pointerUp(t) {
    t !== null && t.button !== 0 || (this.dragging && this.axis !== null && (T2e.mode = this.mode, this.dispatchEvent(T2e)), this.dragging = !1, this.axis = null);
  }
  dispose() {
    this.disconnect(), this._root.dispose();
  }
  /**
   * Sets the 3D object that should be transformed and ensures the controls UI is visible.
   *
   * @param {Object3D} object -  The 3D object that should be transformed.
   * @return {TransformControls} A reference to this controls.
   */
  attach(t) {
    return this.object = t, this._root.visible = !0, this;
  }
  /**
   * Removes the current 3D object from the controls and makes the helper UI invisible.
   *
   * @return {TransformControls} A reference to this controls.
   */
  detach() {
    return this.object = void 0, this.axis = null, this._root.visible = !1, this;
  }
  /**
   * Resets the object's position, rotation and scale to when the current transform began.
   */
  reset() {
    this.enabled && this.dragging && (this.object.position.copy(this._positionStart), this.object.quaternion.copy(this._quaternionStart), this.object.scale.copy(this._scaleStart), this.dispatchEvent(Vce), this.dispatchEvent(R2e), this.pointStart.copy(this.pointEnd));
  }
  /**
   * Returns the raycaster that is used for user interaction. This object is shared between all
   * instances of `TransformControls`.
   *
   * @returns {Raycaster} The internal raycaster.
   */
  getRaycaster() {
    return sU;
  }
  /**
   * Returns the transformation mode.
   *
   * @returns {'translate'|'rotate'|'scale'} The transformation mode.
   */
  getMode() {
    return this.mode;
  }
  /**
   * Sets the given transformation mode.
   *
   * @param {'translate'|'rotate'|'scale'} mode - The transformation mode to set.
   */
  setMode(t) {
    this.mode = t;
  }
  /**
   * Sets the translation snap.
   *
   * @param {?number} translationSnap - The translation snap to set.
   */
  setTranslationSnap(t) {
    this.translationSnap = t;
  }
  /**
   * Sets the rotation snap.
   *
   * @param {?number} rotationSnap - The rotation snap to set.
   */
  setRotationSnap(t) {
    this.rotationSnap = t;
  }
  /**
   * Sets the scale snap.
   *
   * @param {?number} scaleSnap - The scale snap to set.
   */
  setScaleSnap(t) {
    this.scaleSnap = t;
  }
  /**
   * Sets the size of the helper UI.
   *
   * @param {number} size - The size to set.
   */
  setSize(t) {
    this.size = t;
  }
  /**
   * Sets the coordinate space in which transformations are applied.
   *
   * @param {'world'|'local'} space - The space to set.
   */
  setSpace(t) {
    this.space = t;
  }
}
function iQe(e) {
  if (this.domElement.ownerDocument.pointerLockElement)
    return {
      x: 0,
      y: 0,
      button: e.button
    };
  {
    const t = this.domElement.getBoundingClientRect();
    return {
      x: (e.clientX - t.left) / t.width * 2 - 1,
      y: -(e.clientY - t.top) / t.height * 2 + 1,
      button: e.button
    };
  }
}
function nQe(e) {
  if (this.enabled)
    switch (e.pointerType) {
      case "mouse":
      case "pen":
        this.pointerHover(this._getPointer(e));
        break;
    }
}
function sQe(e) {
  this.enabled && (document.pointerLockElement || this.domElement.setPointerCapture(e.pointerId), this.domElement.addEventListener("pointermove", this._onPointerMove), this.pointerHover(this._getPointer(e)), this.pointerDown(this._getPointer(e)));
}
function oQe(e) {
  this.enabled && this.pointerMove(this._getPointer(e));
}
function rQe(e) {
  this.enabled && (this.domElement.releasePointerCapture(e.pointerId), this.domElement.removeEventListener("pointermove", this._onPointerMove), this.pointerUp(this._getPointer(e)));
}
function zce(e, t, i) {
  const n = t.intersectObject(e, !0);
  for (let s = 0; s < n.length; s++)
    if (n[s].object.visible || i)
      return n[s];
  return !1;
}
const Bse = new UA(), Fl = new Ge(0, 1, 0), v2e = new Ge(0, 0, 0), A2e = new Ln(), Fse = new gI(), Lre = new gI(), pb = new Ge(), S2e = new Ln(), pJ = new Ge(1, 0, 0), jU = new Ge(0, 1, 0), mJ = new Ge(0, 0, 1), Hse = new Ge(), zZ = new Ge(), jZ = new Ge();
class lQe extends wu {
  constructor(t) {
    super(), this.isTransformControlsRoot = !0, this.controls = t, this.visible = !1;
  }
  // updateMatrixWorld updates key transformation variables
  updateMatrixWorld(t) {
    const i = this.controls;
    i.object !== void 0 && (i.object.updateMatrixWorld(), i.object.parent === null ? console.error("TransformControls: The attached 3D object must be a part of the scene graph.") : i.object.parent.matrixWorld.decompose(i._parentPosition, i._parentQuaternion, i._parentScale), i.object.matrixWorld.decompose(i.worldPosition, i.worldQuaternion, i._worldScale), i._parentQuaternionInv.copy(i._parentQuaternion).invert(), i._worldQuaternionInv.copy(i.worldQuaternion).invert()), i.camera.updateMatrixWorld(), i.camera.matrixWorld.decompose(i.cameraPosition, i.cameraQuaternion, i._cameraScale), i.camera.isOrthographicCamera ? i.camera.getWorldDirection(i.eye).negate() : i.eye.copy(i.cameraPosition).sub(i.worldPosition).normalize(), super.updateMatrixWorld(t);
  }
  dispose() {
    this.traverse(function(t) {
      t.geometry && t.geometry.dispose(), t.material && t.material.dispose();
    });
  }
}
class aQe extends wu {
  constructor() {
    super(), this.isTransformControlsGizmo = !0, this.type = "TransformControlsGizmo";
    const t = new U8({
      depthTest: !1,
      depthWrite: !1,
      fog: !1,
      toneMapped: !1,
      transparent: !0
    }), i = new gie({
      depthTest: !1,
      depthWrite: !1,
      fog: !1,
      toneMapped: !1,
      transparent: !0
    }), n = t.clone();
    n.opacity = 0.15;
    const s = i.clone();
    s.opacity = 0.5;
    const o = t.clone();
    o.color.setHex(16711680);
    const r = t.clone();
    r.color.setHex(65280);
    const l = t.clone();
    l.color.setHex(255);
    const c = t.clone();
    c.color.setHex(16711680), c.opacity = 0.5;
    const h = t.clone();
    h.color.setHex(65280), h.opacity = 0.5;
    const I = t.clone();
    I.color.setHex(255), I.opacity = 0.5;
    const p = t.clone();
    p.opacity = 0.25;
    const y = t.clone();
    y.color.setHex(16776960), y.opacity = 0.25, t.clone().color.setHex(16776960);
    const A = t.clone();
    A.color.setHex(7895160);
    const C = new yp(0, 0.04, 0.1, 12);
    C.translate(0, 0.05, 0);
    const O = new L0(0.08, 0.08, 0.08);
    O.translate(0, 0.04, 0);
    const R = new Vl();
    R.setAttribute("position", new al([0, 0, 0, 1, 0, 0], 3));
    const F = new yp(75e-4, 75e-4, 0.5, 3);
    F.translate(0, 0.25, 0);
    function L(je, Ve) {
      const $e = new qU(je, 75e-4, 3, 64, Ve * Math.PI * 2);
      return $e.rotateY(Math.PI / 2), $e.rotateX(Math.PI / 2), $e;
    }
    function P() {
      const je = new Vl();
      return je.setAttribute("position", new al([0, 0, 0, 1, 1, 1], 3)), je;
    }
    const z = {
      X: [
        [new En(C, o), [0.5, 0, 0], [0, 0, -Math.PI / 2]],
        [new En(C, o), [-0.5, 0, 0], [0, 0, Math.PI / 2]],
        [new En(F, o), [0, 0, 0], [0, 0, -Math.PI / 2]]
      ],
      Y: [
        [new En(C, r), [0, 0.5, 0]],
        [new En(C, r), [0, -0.5, 0], [Math.PI, 0, 0]],
        [new En(F, r)]
      ],
      Z: [
        [new En(C, l), [0, 0, 0.5], [Math.PI / 2, 0, 0]],
        [new En(C, l), [0, 0, -0.5], [-Math.PI / 2, 0, 0]],
        [new En(F, l), null, [Math.PI / 2, 0, 0]]
      ],
      XYZ: [
        [new En(new sz(0.1, 0), p.clone()), [0, 0, 0]]
      ],
      XY: [
        [new En(new L0(0.15, 0.15, 0.01), I.clone()), [0.15, 0.15, 0]]
      ],
      YZ: [
        [new En(new L0(0.15, 0.15, 0.01), c.clone()), [0, 0.15, 0.15], [0, Math.PI / 2, 0]]
      ],
      XZ: [
        [new En(new L0(0.15, 0.15, 0.01), h.clone()), [0.15, 0, 0.15], [-Math.PI / 2, 0, 0]]
      ]
    }, W = {
      X: [
        [new En(new yp(0.2, 0, 0.6, 4), n), [0.3, 0, 0], [0, 0, -Math.PI / 2]],
        [new En(new yp(0.2, 0, 0.6, 4), n), [-0.3, 0, 0], [0, 0, Math.PI / 2]]
      ],
      Y: [
        [new En(new yp(0.2, 0, 0.6, 4), n), [0, 0.3, 0]],
        [new En(new yp(0.2, 0, 0.6, 4), n), [0, -0.3, 0], [0, 0, Math.PI]]
      ],
      Z: [
        [new En(new yp(0.2, 0, 0.6, 4), n), [0, 0, 0.3], [Math.PI / 2, 0, 0]],
        [new En(new yp(0.2, 0, 0.6, 4), n), [0, 0, -0.3], [-Math.PI / 2, 0, 0]]
      ],
      XYZ: [
        [new En(new sz(0.2, 0), n)]
      ],
      XY: [
        [new En(new L0(0.2, 0.2, 0.01), n), [0.15, 0.15, 0]]
      ],
      YZ: [
        [new En(new L0(0.2, 0.2, 0.01), n), [0, 0.15, 0.15], [0, Math.PI / 2, 0]]
      ],
      XZ: [
        [new En(new L0(0.2, 0.2, 0.01), n), [0.15, 0, 0.15], [-Math.PI / 2, 0, 0]]
      ]
    }, re = {
      START: [
        [new En(new sz(0.01, 2), s), null, null, null, "helper"]
      ],
      END: [
        [new En(new sz(0.01, 2), s), null, null, null, "helper"]
      ],
      DELTA: [
        [new fv(P(), s), null, null, null, "helper"]
      ],
      X: [
        [new fv(R, s.clone()), [-1e3, 0, 0], null, [1e6, 1, 1], "helper"]
      ],
      Y: [
        [new fv(R, s.clone()), [0, -1e3, 0], [0, 0, Math.PI / 2], [1e6, 1, 1], "helper"]
      ],
      Z: [
        [new fv(R, s.clone()), [0, 0, -1e3], [0, -Math.PI / 2, 0], [1e6, 1, 1], "helper"]
      ]
    }, ce = {
      XYZE: [
        [new En(L(0.5, 1), A), null, [0, Math.PI / 2, 0]]
      ],
      X: [
        [new En(L(0.5, 0.5), o)]
      ],
      Y: [
        [new En(L(0.5, 0.5), r), null, [0, 0, -Math.PI / 2]]
      ],
      Z: [
        [new En(L(0.5, 0.5), l), null, [0, Math.PI / 2, 0]]
      ],
      E: [
        [new En(L(0.75, 1), y), null, [0, Math.PI / 2, 0]]
      ]
    }, te = {
      AXIS: [
        [new fv(R, s.clone()), [-1e3, 0, 0], null, [1e6, 1, 1], "helper"]
      ]
    }, ee = {
      XYZE: [
        [new En(new Xpe(0.25, 10, 8), n)]
      ],
      X: [
        [new En(new qU(0.5, 0.1, 4, 24), n), [0, 0, 0], [0, -Math.PI / 2, -Math.PI / 2]]
      ],
      Y: [
        [new En(new qU(0.5, 0.1, 4, 24), n), [0, 0, 0], [Math.PI / 2, 0, 0]]
      ],
      Z: [
        [new En(new qU(0.5, 0.1, 4, 24), n), [0, 0, 0], [0, 0, -Math.PI / 2]]
      ],
      E: [
        [new En(new qU(0.75, 0.1, 2, 24), n)]
      ]
    }, Ne = {
      X: [
        [new En(O, o), [0.5, 0, 0], [0, 0, -Math.PI / 2]],
        [new En(F, o), [0, 0, 0], [0, 0, -Math.PI / 2]],
        [new En(O, o), [-0.5, 0, 0], [0, 0, Math.PI / 2]]
      ],
      Y: [
        [new En(O, r), [0, 0.5, 0]],
        [new En(F, r)],
        [new En(O, r), [0, -0.5, 0], [0, 0, Math.PI]]
      ],
      Z: [
        [new En(O, l), [0, 0, 0.5], [Math.PI / 2, 0, 0]],
        [new En(F, l), [0, 0, 0], [Math.PI / 2, 0, 0]],
        [new En(O, l), [0, 0, -0.5], [-Math.PI / 2, 0, 0]]
      ],
      XY: [
        [new En(new L0(0.15, 0.15, 0.01), I), [0.15, 0.15, 0]]
      ],
      YZ: [
        [new En(new L0(0.15, 0.15, 0.01), c), [0, 0.15, 0.15], [0, Math.PI / 2, 0]]
      ],
      XZ: [
        [new En(new L0(0.15, 0.15, 0.01), h), [0.15, 0, 0.15], [-Math.PI / 2, 0, 0]]
      ],
      XYZ: [
        [new En(new L0(0.1, 0.1, 0.1), p.clone())]
      ]
    }, Ae = {
      X: [
        [new En(new yp(0.2, 0, 0.6, 4), n), [0.3, 0, 0], [0, 0, -Math.PI / 2]],
        [new En(new yp(0.2, 0, 0.6, 4), n), [-0.3, 0, 0], [0, 0, Math.PI / 2]]
      ],
      Y: [
        [new En(new yp(0.2, 0, 0.6, 4), n), [0, 0.3, 0]],
        [new En(new yp(0.2, 0, 0.6, 4), n), [0, -0.3, 0], [0, 0, Math.PI]]
      ],
      Z: [
        [new En(new yp(0.2, 0, 0.6, 4), n), [0, 0, 0.3], [Math.PI / 2, 0, 0]],
        [new En(new yp(0.2, 0, 0.6, 4), n), [0, 0, -0.3], [-Math.PI / 2, 0, 0]]
      ],
      XY: [
        [new En(new L0(0.2, 0.2, 0.01), n), [0.15, 0.15, 0]]
      ],
      YZ: [
        [new En(new L0(0.2, 0.2, 0.01), n), [0, 0.15, 0.15], [0, Math.PI / 2, 0]]
      ],
      XZ: [
        [new En(new L0(0.2, 0.2, 0.01), n), [0.15, 0, 0.15], [-Math.PI / 2, 0, 0]]
      ],
      XYZ: [
        [new En(new L0(0.2, 0.2, 0.2), n), [0, 0, 0]]
      ]
    }, Oe = {
      X: [
        [new fv(R, s.clone()), [-1e3, 0, 0], null, [1e6, 1, 1], "helper"]
      ],
      Y: [
        [new fv(R, s.clone()), [0, -1e3, 0], [0, 0, Math.PI / 2], [1e6, 1, 1], "helper"]
      ],
      Z: [
        [new fv(R, s.clone()), [0, 0, -1e3], [0, -Math.PI / 2, 0], [1e6, 1, 1], "helper"]
      ]
    };
    function pe(je) {
      const Ve = new wu();
      for (const $e in je)
        for (let vt = je[$e].length; vt--; ) {
          const Rt = je[$e][vt][0].clone(), ze = je[$e][vt][1], mt = je[$e][vt][2], Et = je[$e][vt][3], it = je[$e][vt][4];
          Rt.name = $e, Rt.tag = it, ze && Rt.position.set(ze[0], ze[1], ze[2]), mt && Rt.rotation.set(mt[0], mt[1], mt[2]), Et && Rt.scale.set(Et[0], Et[1], Et[2]), Rt.updateMatrix();
          const Dt = Rt.geometry.clone();
          Dt.applyMatrix4(Rt.matrix), Rt.geometry = Dt, Rt.renderOrder = 1 / 0, Rt.position.set(0, 0, 0), Rt.rotation.set(0, 0, 0), Rt.scale.set(1, 1, 1), Ve.add(Rt);
        }
      return Ve;
    }
    this.gizmo = {}, this.picker = {}, this.helper = {}, this.add(this.gizmo.translate = pe(z)), this.add(this.gizmo.rotate = pe(ce)), this.add(this.gizmo.scale = pe(Ne)), this.add(this.picker.translate = pe(W)), this.add(this.picker.rotate = pe(ee)), this.add(this.picker.scale = pe(Ae)), this.add(this.helper.translate = pe(re)), this.add(this.helper.rotate = pe(te)), this.add(this.helper.scale = pe(Oe)), this.picker.translate.visible = !1, this.picker.rotate.visible = !1, this.picker.scale.visible = !1;
  }
  // updateMatrixWorld will update transformations and appearance of individual handles
  updateMatrixWorld(t) {
    const n = (this.mode === "scale" ? "local" : this.space) === "local" ? this.worldQuaternion : Lre;
    this.gizmo.translate.visible = this.mode === "translate", this.gizmo.rotate.visible = this.mode === "rotate", this.gizmo.scale.visible = this.mode === "scale", this.helper.translate.visible = this.mode === "translate", this.helper.rotate.visible = this.mode === "rotate", this.helper.scale.visible = this.mode === "scale";
    let s = [];
    s = s.concat(this.picker[this.mode].children), s = s.concat(this.gizmo[this.mode].children), s = s.concat(this.helper[this.mode].children);
    for (let o = 0; o < s.length; o++) {
      const r = s[o];
      r.visible = !0, r.rotation.set(0, 0, 0), r.position.copy(this.worldPosition);
      let l;
      if (this.camera.isOrthographicCamera ? l = (this.camera.top - this.camera.bottom) / this.camera.zoom : l = this.worldPosition.distanceTo(this.cameraPosition) * Math.min(1.9 * Math.tan(Math.PI * this.camera.fov / 360) / this.camera.zoom, 7), r.scale.set(1, 1, 1).multiplyScalar(l * this.size / 4), r.tag === "helper") {
        r.visible = !1, r.name === "AXIS" ? (r.visible = !!this.axis, this.axis === "X" && (Pu.setFromEuler(Bse.set(0, 0, 0)), r.quaternion.copy(n).multiply(Pu), Math.abs(Fl.copy(pJ).applyQuaternion(n).dot(this.eye)) > 0.9 && (r.visible = !1)), this.axis === "Y" && (Pu.setFromEuler(Bse.set(0, 0, Math.PI / 2)), r.quaternion.copy(n).multiply(Pu), Math.abs(Fl.copy(jU).applyQuaternion(n).dot(this.eye)) > 0.9 && (r.visible = !1)), this.axis === "Z" && (Pu.setFromEuler(Bse.set(0, Math.PI / 2, 0)), r.quaternion.copy(n).multiply(Pu), Math.abs(Fl.copy(mJ).applyQuaternion(n).dot(this.eye)) > 0.9 && (r.visible = !1)), this.axis === "XYZE" && (Pu.setFromEuler(Bse.set(0, Math.PI / 2, 0)), Fl.copy(this.rotationAxis), r.quaternion.setFromRotationMatrix(A2e.lookAt(v2e, Fl, jU)), r.quaternion.multiply(Pu), r.visible = this.dragging), this.axis === "E" && (r.visible = !1)) : r.name === "START" ? (r.position.copy(this.worldPositionStart), r.visible = this.dragging) : r.name === "END" ? (r.position.copy(this.worldPosition), r.visible = this.dragging) : r.name === "DELTA" ? (r.position.copy(this.worldPositionStart), r.quaternion.copy(this.worldQuaternionStart), Um.set(1e-10, 1e-10, 1e-10).add(this.worldPositionStart).sub(this.worldPosition).multiplyScalar(-1), Um.applyQuaternion(this.worldQuaternionStart.clone().invert()), r.scale.copy(Um), r.visible = this.dragging) : (r.quaternion.copy(n), this.dragging ? r.position.copy(this.worldPositionStart) : r.position.copy(this.worldPosition), this.axis && (r.visible = this.axis.search(r.name) !== -1));
        continue;
      }
      r.quaternion.copy(n), this.mode === "translate" || this.mode === "scale" ? (r.name === "X" && Math.abs(Fl.copy(pJ).applyQuaternion(n).dot(this.eye)) > 0.99 && (r.scale.set(1e-10, 1e-10, 1e-10), r.visible = !1), r.name === "Y" && Math.abs(Fl.copy(jU).applyQuaternion(n).dot(this.eye)) > 0.99 && (r.scale.set(1e-10, 1e-10, 1e-10), r.visible = !1), r.name === "Z" && Math.abs(Fl.copy(mJ).applyQuaternion(n).dot(this.eye)) > 0.99 && (r.scale.set(1e-10, 1e-10, 1e-10), r.visible = !1), r.name === "XY" && Math.abs(Fl.copy(mJ).applyQuaternion(n).dot(this.eye)) < 0.2 && (r.scale.set(1e-10, 1e-10, 1e-10), r.visible = !1), r.name === "YZ" && Math.abs(Fl.copy(pJ).applyQuaternion(n).dot(this.eye)) < 0.2 && (r.scale.set(1e-10, 1e-10, 1e-10), r.visible = !1), r.name === "XZ" && Math.abs(Fl.copy(jU).applyQuaternion(n).dot(this.eye)) < 0.2 && (r.scale.set(1e-10, 1e-10, 1e-10), r.visible = !1)) : this.mode === "rotate" && (Fse.copy(n), Fl.copy(this.eye).applyQuaternion(Pu.copy(n).invert()), r.name.search("E") !== -1 && r.quaternion.setFromRotationMatrix(A2e.lookAt(this.eye, v2e, jU)), r.name === "X" && (Pu.setFromAxisAngle(pJ, Math.atan2(-Fl.y, Fl.z)), Pu.multiplyQuaternions(Fse, Pu), r.quaternion.copy(Pu)), r.name === "Y" && (Pu.setFromAxisAngle(jU, Math.atan2(Fl.x, Fl.z)), Pu.multiplyQuaternions(Fse, Pu), r.quaternion.copy(Pu)), r.name === "Z" && (Pu.setFromAxisAngle(mJ, Math.atan2(Fl.y, Fl.x)), Pu.multiplyQuaternions(Fse, Pu), r.quaternion.copy(Pu))), r.visible = r.visible && (r.name.indexOf("X") === -1 || this.showX), r.visible = r.visible && (r.name.indexOf("Y") === -1 || this.showY), r.visible = r.visible && (r.name.indexOf("Z") === -1 || this.showZ), r.visible = r.visible && (r.name.indexOf("E") === -1 || this.showX && this.showY && this.showZ), r.material._color = r.material._color || r.material.color.clone(), r.material._opacity = r.material._opacity || r.material.opacity, r.material.color.copy(r.material._color), r.material.opacity = r.material._opacity, this.enabled && this.axis && (r.name === this.axis || this.axis.split("").some(function(c) {
        return r.name === c;
      })) && (r.material.color.setHex(16776960), r.material.opacity = 1);
    }
    super.updateMatrixWorld(t);
  }
}
class uQe extends En {
  constructor() {
    super(
      new xH(1e5, 1e5, 2, 2),
      new U8({ visible: !1, wireframe: !0, side: $y, transparent: !0, opacity: 0.1, toneMapped: !1 })
    ), this.isTransformControlsPlane = !0, this.type = "TransformControlsPlane";
  }
  updateMatrixWorld(t) {
    let i = this.space;
    switch (this.position.copy(this.worldPosition), this.mode === "scale" && (i = "local"), Hse.copy(pJ).applyQuaternion(i === "local" ? this.worldQuaternion : Lre), zZ.copy(jU).applyQuaternion(i === "local" ? this.worldQuaternion : Lre), jZ.copy(mJ).applyQuaternion(i === "local" ? this.worldQuaternion : Lre), Fl.copy(zZ), this.mode) {
      case "translate":
      case "scale":
        switch (this.axis) {
          case "X":
            Fl.copy(this.eye).cross(Hse), pb.copy(Hse).cross(Fl);
            break;
          case "Y":
            Fl.copy(this.eye).cross(zZ), pb.copy(zZ).cross(Fl);
            break;
          case "Z":
            Fl.copy(this.eye).cross(jZ), pb.copy(jZ).cross(Fl);
            break;
          case "XY":
            pb.copy(jZ);
            break;
          case "YZ":
            pb.copy(Hse);
            break;
          case "XZ":
            Fl.copy(jZ), pb.copy(zZ);
            break;
          case "XYZ":
          case "E":
            pb.set(0, 0, 0);
            break;
        }
        break;
      case "rotate":
      default:
        pb.set(0, 0, 0);
    }
    pb.length() === 0 ? this.quaternion.copy(this.cameraQuaternion) : (S2e.lookAt(Um.set(0, 0, 0), pb, Fl), this.quaternion.setFromRotationMatrix(S2e)), super.updateMatrixWorld(t);
  }
}
class Vme {
  constructor(t, i, n, s, o, r = 5, l = !0) {
    if (tt(this, "onDraggingStarted", new es()), tt(this, "onDraggingEnded", new es()), tt(this, "onDisposed", new es()), tt(this, "normal"), tt(this, "origin"), tt(this, "three", new tl()), tt(this, "components"), tt(this, "world"), tt(this, "type", "default"), tt(this, "_title", "Clipping Plane"), tt(this, "_helper"), tt(this, "_visible", !0), tt(this, "_enabled", !0), tt(this, "_controlsActive", !1), tt(this, "_arrowBoundBox", new En()), tt(this, "_planeMesh"), tt(this, "_controls"), tt(this, "_hiddenMaterial", new U8({
      visible: !1
    })), tt(this, "_visibilityBeforeDisabled", !0), tt(this, "notifyManager", () => {
      const c = this.components.get(ez), h = c.list.getKey(this);
      h && c.list.set(h, this);
    }), tt(this, "update", () => {
      this._enabled && this.three.setFromNormalAndCoplanarPoint(
        this.normal,
        this._helper.position
      );
    }), tt(this, "changeDrag", (c) => {
      this._visible = !c.value, this.preventCameraMovement(), this.notifyDraggingChanged(c);
    }), this.components = t, this.world = i, !i.renderer)
      throw new Error("The given world must have a renderer!");
    this.normal = s, this.origin = n, i.renderer.setPlane(!0, this.three), this._planeMesh = Vme.newPlaneMesh(r, o), this._helper = this.newHelper(), this._controls = this.newTransformControls(), this.three.setFromNormalAndCoplanarPoint(s, n), l && this.toggleControls(!0);
  }
  set title(t) {
    this._title = t, this.notifyManager();
  }
  get title() {
    return this._title;
  }
  /**
   * Getter for the enabled state of the clipping plane.
   * @returns {boolean} The current enabled state.
   */
  get enabled() {
    return this._enabled;
  }
  /**
   * Setter for the enabled state of the clipping plane.
   * Updates the clipping plane state in the renderer and throws an error if no renderer is found.
   * @param {boolean} state - The new enabled state.
   */
  set enabled(t) {
    if (!this.world.isDisposing) {
      if (!this.world.renderer)
        throw new Error("No renderer found for clipping plane!");
      this._enabled = t, t ? this.visible = this._visibilityBeforeDisabled : (this._visibilityBeforeDisabled = this.visible, this.visible = !1), this.world.renderer.setPlane(t, this.three), this.notifyManager();
    }
  }
  /** {@link Hideable.visible } */
  get visible() {
    return this._visible;
  }
  /** {@link Hideable.visible } */
  set visible(t) {
    this._visible = t, this._controls.getHelper().visible = t, this._helper.visible = t, this.toggleControls(t), this.notifyManager();
  }
  /** The meshes used for raycasting */
  get meshes() {
    return [this._planeMesh, this._arrowBoundBox];
  }
  /** The material of the clipping plane representation. */
  get planeMaterial() {
    return this._planeMesh.material;
  }
  /** The material of the clipping plane representation. */
  set planeMaterial(t) {
    this._planeMesh.material = t;
  }
  /** The size of the clipping plane representation. */
  get size() {
    return this._planeMesh.scale.x;
  }
  /** Sets the size of the clipping plane representation. */
  set size(t) {
    this._planeMesh.scale.set(t, t, t);
  }
  /**
   * Getter for the helper object of the clipping plane.
   * The helper object is a THREE.Object3D that contains the clipping plane mesh and other related objects.
   * It is used for positioning, rotating, and scaling the clipping plane in the 3D scene.
   *
   * @returns {THREE.Object3D} The helper object of the clipping plane.
   */
  get helper() {
    return this._helper;
  }
  /**
   * Getter for the transform controls of the clipping plane.
   * The controls allow interactive manipulation (translation, rotation, etc.) of the clipping plane.
   *
   * @returns {TransformControls} The transform controls of the clipping plane.
   */
  get controls() {
    return this._controls;
  }
  /**
   * Sets the clipping plane's normal and origin from the given normal and point.
   * This method resets the clipping plane's state, updates the normal and origin,
   * and positions the helper object accordingly.
   *
   * @param normal - The new normal vector for the clipping plane.
   * @param point - The new origin point for the clipping plane.
   *
   * @returns {void}
   */
  setFromNormalAndCoplanarPoint(t, i) {
    this.reset(), this.normal.equals(t) || (this.normal.copy(t), this._helper.lookAt(t)), this.origin.copy(i), this._helper.position.copy(i), this._helper.updateMatrix(), this.update();
  }
  /** {@link Disposable.dispose} */
  dispose() {
    this._enabled = !1, this.onDraggingStarted.reset(), this.onDraggingEnded.reset(), this._helper.removeFromParent(), this.world.renderer && this.world.renderer.setPlane(!1, this.three), this._arrowBoundBox.removeFromParent(), this._arrowBoundBox.geometry.dispose(), this._planeMesh.geometry.dispose(), this._controls.getHelper().removeFromParent(), this._controls.dispose(), this.onDisposed.trigger(), this.onDisposed.reset();
  }
  reset() {
    const t = new Ge(1, 0, 0), i = new Ge();
    this.normal.equals(t) || (this.normal.copy(t), this._helper.lookAt(t)), this.origin.copy(i), this._helper.position.copy(i), this._helper.updateMatrix();
  }
  toggleControls(t) {
    if (t) {
      if (this._controlsActive)
        return;
      this._controls.addEventListener("change", this.update), this._controls.addEventListener("dragging-changed", this.changeDrag);
    } else
      this._controls.removeEventListener("change", this.update), this._controls.removeEventListener("dragging-changed", this.changeDrag);
    this._controlsActive = t;
  }
  newTransformControls() {
    if (!this.world.renderer)
      throw new Error("No renderer found for clipping plane!");
    const t = this.world.camera.three, i = this.world.renderer.three.domElement, n = new tQe(t, i);
    return this.initializeControls(n), this.world.scene.three.add(n.getHelper()), n;
  }
  initializeControls(t) {
    t.attach(this._helper), t.showX = !1, t.showY = !1, t.setSpace("local"), this.createArrowBoundingBox(), t.getHelper().children[0].children[0].add(this._arrowBoundBox);
  }
  createArrowBoundingBox() {
    this._arrowBoundBox.geometry = new yp(0.18, 0.18, 1.2), this._arrowBoundBox.material = this._hiddenMaterial, this._arrowBoundBox.rotateX(Math.PI / 2), this._arrowBoundBox.updateMatrix(), this._arrowBoundBox.geometry.applyMatrix4(this._arrowBoundBox.matrix);
  }
  notifyDraggingChanged(t) {
    t.value ? this.onDraggingStarted.trigger() : this.onDraggingEnded.trigger();
  }
  preventCameraMovement() {
    this.world.camera.enabled = this._visible;
  }
  newHelper() {
    const t = new wu();
    return t.lookAt(this.normal), t.position.copy(this.origin), this._planeMesh.position.z += 0.01, t.add(this._planeMesh), this.world.scene.three.add(t), t;
  }
  static newPlaneMesh(t, i) {
    const n = new xH(1), s = new En(n, i);
    return s.scale.set(t, t, t), s;
  }
}
class dQe extends Hie {
  constructor() {
    super(...arguments), tt(this, "_config", {
      enabled: {
        value: !0,
        type: "Boolean"
      },
      visible: {
        value: !0,
        type: "Boolean"
      },
      color: {
        value: new Xn(),
        type: "Color"
      },
      opacity: {
        type: "Number",
        interpolable: !0,
        value: 1,
        min: 0,
        max: 1
      },
      size: {
        type: "Number",
        interpolable: !0,
        value: 2,
        min: 0,
        max: 100
      }
    });
  }
  get enabled() {
    return this._config.enabled.value;
  }
  set enabled(t) {
    this._config.enabled.value = t, this._component.enabled = t;
  }
  get visible() {
    return this._config.visible.value;
  }
  set visible(t) {
    this._config.visible.value = t, this._component.visible = t;
  }
  get color() {
    return this._config.color.value;
  }
  set color(t) {
    this._config.color.value = t, this._component.material.color.copy(t);
  }
  get opacity() {
    return this._config.opacity.value;
  }
  set opacity(t) {
    this._config.opacity.value = t, this._component.material.opacity = t;
  }
  get size() {
    return this._config.size.value;
  }
  set size(t) {
    this._config.size.value = t, this._component.size = t;
  }
}
const Zbe = class _re extends bI {
  constructor(t) {
    super(t), tt(this, "onSetup", new es()), tt(this, "onBeforeDrag", new es()), tt(this, "onAfterDrag", new es()), tt(this, "onBeforeCreate", new es()), tt(this, "onBeforeCancel", new es()), tt(this, "onAfterCancel", new es()), tt(this, "onBeforeDelete", new es()), tt(this, "onAfterCreate", new es()), tt(this, "onAfterDelete", new es()), tt(this, "onDisposed", new es()), tt(this, "isSetup", !1), tt(this, "orthogonalY", !1), tt(this, "toleranceOrthogonalY", 0.7), tt(this, "Type", Vme), tt(this, "list", new f0()), tt(this, "config", new dQe(
      this,
      this.components,
      "Clipper",
      _re.uuid
    )), tt(this, "_defaultConfig", {
      color: new Xn(12255487),
      opacity: 0.2,
      size: 2
    }), tt(this, "_material", new U8({
      color: 12255487,
      side: $y,
      transparent: !0,
      opacity: 0.2
    })), tt(this, "_size", 5), tt(this, "_enabled", !1), tt(this, "_visible", !0), tt(this, "onStateChanged", new es()), tt(this, "_onStartDragging", () => {
      this.onBeforeDrag.trigger();
    }), tt(this, "_onEndDragging", () => {
      this.onAfterDrag.trigger();
    }), this.components.add(_re.uuid, this), this.setEvents();
  }
  /** {@link Component.enabled} */
  get enabled() {
    return this._enabled;
  }
  /** {@link Component.enabled} */
  set enabled(t) {
    this._enabled = t, this.onStateChanged.trigger(["enabled"]);
  }
  /** {@link Hideable.visible } */
  get visible() {
    return this._visible;
  }
  /** {@link Hideable.visible } */
  set visible(t) {
    this._visible = t;
    for (const [i, n] of this.list)
      n.visible = t;
    this.onStateChanged.trigger(["visibility"]);
  }
  /** The material of the clipping plane representation. */
  get material() {
    return this._material;
  }
  /** The material of the clipping plane representation. */
  set material(t) {
    this._material = t;
    for (const [i, n] of this.list)
      n.planeMaterial = t;
    this.onStateChanged.trigger(["material"]);
  }
  /** The size of the geometric representation of the clippings planes. */
  get size() {
    return this._size;
  }
  /** The size of the geometric representation of the clippings planes. */
  set size(t) {
    this._size = t;
    for (const [i, n] of this.list)
      n.size = t;
    this.onStateChanged.trigger(["size"]);
  }
  setEvents() {
    this.list.onBeforeDelete.add(({ value: t }) => {
      if (!t.world.renderer)
        throw new Error("Renderer not found for this plane's world!");
      t.world.renderer.setPlane(!1, t.three), t.dispose(), this.updateMaterialsAndPlanes(), this.onAfterDelete.trigger(t);
    });
  }
  /** {@link Disposable.dispose} */
  dispose() {
    this._enabled = !1, this.components.get(Sue).list.delete(this.config.uuid), this.list.clear(), this._material.dispose(), this.onBeforeCreate.reset(), this.onBeforeCancel.reset(), this.onBeforeDelete.reset(), this.onBeforeDrag.reset(), this.onAfterCreate.reset(), this.onAfterCancel.reset(), this.onAfterDelete.reset(), this.onAfterDrag.reset(), this.onDisposed.trigger(_re.uuid), this.onDisposed.reset();
  }
  /** {@link Createable.create} */
  async create(t) {
    const s = await this.components.get(kIe).get(t).castRay();
    return s ? this.createPlaneFromIntersection(t, s) : null;
  }
  /**
   * Creates a plane in a certain place and with a certain orientation,
   * without the need of the mouse.
   *
   * @param world - the world where this plane should be created.
   * @param normal - the orientation of the clipping plane.
   * @param point - the position of the clipping plane.
   * navigation.
   */
  createFromNormalAndCoplanarPoint(t, i, n) {
    const s = this.newPlane(t, n, i);
    return this.updateMaterialsAndPlanes(), s;
  }
  /**
   * {@link Createable.delete}
   *
   * @param world - the world where the plane to delete is.
   * @param planeId - the plane to delete. If undefined, the first plane
   * found under the cursor will be deleted.
   */
  async delete(t, i) {
    if (!i) {
      const n = await this.pickPlane(t);
      if (!n)
        return;
      i = this.list.getKey(n);
    }
    i && this.list.delete(i);
  }
  /**
   * Deletes all the existing clipping planes.
   *
   * @param types - the types of planes to be deleted. If not provided, all planes will be deleted.
   */
  deleteAll(t) {
    for (const [i, n] of this.list)
      (!t || t.has(n.type)) && this.list.delete(i);
  }
  /** {@link Configurable.setup} */
  setup(t) {
    const i = { ...this._defaultConfig, ...t };
    this.config.color = i.color, this.config.opacity = i.opacity, this.config.size = i.size, this.isSetup = !0, this.onSetup.trigger();
  }
  // private deletePlane(plane: SimplePlane) {
  //   const index = this.list.indexOf(plane);
  //   if (index !== -1) {
  //     this.list.splice(index, 1);
  //     if (!plane.world.renderer) {
  //       throw new Error("Renderer not found for this plane's world!");
  //     }
  //     plane.world.renderer.setPlane(false, plane.three);
  //     plane.dispose();
  //     this.updateMaterialsAndPlanes();
  //     this.onAfterDelete.trigger(plane);
  //   }
  // }
  async pickPlane(t) {
    const n = this.components.get(kIe).get(t), s = this.getAllPlaneMeshes(), o = await n.castRay({ items: s });
    if (o) {
      const r = o.object;
      return [...this.list.values()].find((l) => l.meshes.includes(r));
    }
  }
  getAllPlaneMeshes() {
    const t = [];
    for (const [i, n] of this.list)
      t.push(...n.meshes);
    return t;
  }
  createPlaneFromIntersection(t, i) {
    var n;
    if (!t.renderer)
      throw new Error("The given world must have a renderer!");
    const s = i.point.distanceTo(new Ge(0, 0, 0)), o = i.normal || ((n = i.face) == null ? void 0 : n.normal);
    if (!s || !o)
      return null;
    const r = this.getWorldNormal(i, o), l = this.newPlane(t, i.point, r.negate()), c = this.list.get(l);
    return c.visible = this._visible, c.size = this._size, t.renderer.setPlane(!0, c.three), this.updateMaterialsAndPlanes(), c;
  }
  getWorldNormal(t, i) {
    const n = t.object;
    let s = t.object.matrixWorld.clone();
    if (n instanceof pUe && t.instanceId !== void 0) {
      const c = new Ln();
      n.getMatrixAt(t.instanceId, c), s = c.multiply(s);
    }
    const r = new fo().getNormalMatrix(s), l = i.clone().applyMatrix3(r).normalize();
    return this.normalizePlaneDirectionY(l), l;
  }
  normalizePlaneDirectionY(t) {
    this.orthogonalY && (t.y > this.toleranceOrthogonalY && (t.x = 0, t.y = 1, t.z = 0), t.y < -this.toleranceOrthogonalY && (t.x = 0, t.y = -1, t.z = 0));
  }
  newPlane(t, i, n) {
    const s = new this.Type(
      this.components,
      t,
      i,
      n,
      this._material
    );
    s.onDraggingStarted.add(this._onStartDragging), s.onDraggingEnded.add(this._onEndDragging);
    const o = y4.create();
    return this.list.set(o, s), this.onAfterCreate.trigger(s), o;
  }
  updateMaterialsAndPlanes() {
    const t = this.components.get(Ume);
    for (const [i, n] of t.list) {
      if (!n.renderer)
        continue;
      n.renderer.updateClippingPlanes();
      const { clippingPlanes: s } = n.renderer;
      for (const o of n.meshes)
        if (o.material)
          if (Array.isArray(o.material))
            for (const r of o.material)
              r.clippingPlanes = s;
          else
            o.material.clippingPlanes = s;
    }
  }
};
tt(Zbe, "uuid", "66290bc5-18c4-4cd1-9379-2e17a0617611");
let ez = Zbe;
class Qbe {
  constructor(t, i) {
    tt(this, "title"), tt(this, "guid", y4.create()), tt(this, "clippingPlanes", new OA()), tt(this, "camera", {
      aspect_ratio: 1,
      field_of_view: 60,
      camera_direction: { x: 0, y: 0, z: 0 },
      camera_view_point: { x: 0, y: 0, z: 0 },
      camera_up_vector: { x: 0, y: 1, z: 0 }
    }), tt(this, "customData", {}), tt(this, "exceptionComponents", new OA()), tt(this, "selectionComponents", new OA()), tt(this, "componentColors", new f0()), tt(this, "spacesVisible", !1), tt(this, "spaceBoundariesVisible", !1), tt(this, "openingsVisible", !1), tt(this, "defaultVisibility", !0), tt(this, "snapshot", this.guid), tt(this, "_components"), tt(this, "_world", null), tt(this, "notifyUpdate", () => {
      this._components.get(VO).list.set(this.guid, this);
    }), this._components = t, i && (this.guid = i.guid ?? this.guid, this.set(i)), this.setEvents();
  }
  async getSelectionMap() {
    return await this._components.get(Io).guidsToModelIdMap([
      ...this.selectionComponents
    ]);
  }
  async getExceptionMap() {
    return await this._components.get(Io).guidsToModelIdMap([
      ...this.exceptionComponents
    ]);
  }
  /**
   * Retrieves the projection type of the viewpoint's camera.
   *
   * @returns A string representing the projection type of the viewpoint's camera.
   *          It can be either 'Perspective' or 'Orthographic'.
   */
  get projection() {
    return "field_of_view" in this.camera ? "Perspective" : "Orthographic";
  }
  /**
   * Retrieves the position vector of the viewpoint's camera.
   *
   * @returns A THREE.Vector3 representing the position of the viewpoint's camera.
   */
  get position() {
    const t = this._components.get(Io), { camera_view_point: i } = this.camera, { x: n, y: s, z: o } = i, r = new Ge(n, s, o);
    return t.applyBaseCoordinateSystem(r, new Ln()), r;
  }
  /**
   * Sets the position of the viewpoint's camera.
   * @param value - The new position for the viewpoint's camera.
   */
  set position(t) {
    const i = t.clone(), n = this._components.get(Io);
    t.clone().applyMatrix4(n.baseCoordinationMatrix.clone().invert()), this.camera.camera_view_point = {
      x: i.x,
      y: i.y,
      z: i.z
    };
  }
  /**
   * Retrieves the direction vector of the viewpoint's camera.
   * @returns A THREE.Vector3 representing the direction of the viewpoint's camera.
   */
  get direction() {
    const { camera_direction: t } = this.camera, { x: i, y: n, z: s } = t;
    return new Ge(i, n, s);
  }
  /**
   * Represents the world in which the viewpoint will take effect.
   */
  set world(t) {
    this._world = t;
  }
  get world() {
    return this._world;
  }
  get _managerVersion() {
    return this._components.get(c1).config.version;
  }
  /**
   * Retrieves the list of BCF topics associated with the current viewpoint.
   *
   * @remarks
   * This function retrieves the BCFTopics manager from the components,
   * then filters the list of topics to find those associated with the current viewpoint.
   *
   * @returns An array of BCF topics associated with the current viewpoint.
   */
  get topics() {
    return [...this._components.get(c1).list.values()].filter(
      (s) => s.viewpoints.has(this.guid)
    );
  }
  // TODO: Remove the notifyUpdate when needed
  setEvents() {
    this.selectionComponents.onUpdated.add(this.notifyUpdate), this.exceptionComponents.onUpdated.add(this.notifyUpdate), this.clippingPlanes.onUpdated.add(this.notifyUpdate), this.componentColors.onItemSet.add(this.notifyUpdate), this.componentColors.onItemDeleted.add(this.notifyUpdate), this.componentColors.onItemUpdated.add(this.notifyUpdate), this.componentColors.onCleared.add(this.notifyUpdate);
  }
  /**
   * Fully replace the properties of the viewpoint with the provided data.
   * The properties not included will remain unchanged.
   *
   * @remarks The guid will be ommited as it shouldn't change after it has been initially set.
   *
   * @param data - An object containing the properties to be set.
   */
  set(t) {
    this.title = t.title;
    const {
      components: i,
      perspective_camera: n,
      orthogonal_camera: s,
      clipping_planes: o
    } = t;
    if (i) {
      const { selection: r, visibility: l, coloring: c } = i;
      if (r) {
        this.selectionComponents.clear();
        for (const { ifc_guid: h } of r)
          h && this.selectionComponents.add(h);
      }
      if (l) {
        const { default_visibility: h, exceptions: I, view_setup_hints: p } = l;
        if (h !== void 0 && (this.defaultVisibility = h), I) {
          this.exceptionComponents.clear();
          for (const { ifc_guid: y } of I)
            y && this.exceptionComponents.add(y);
        }
        if (p) {
          const { spaces_visible: y, space_boundaries_visible: m, openings_visible: A } = p;
          y !== void 0 && (this.spacesVisible = y), m !== void 0 && (this.spaceBoundariesVisible = m), A !== void 0 && (this.openingsVisible = A);
        }
      }
      if (c) {
        this.componentColors.clear();
        for (const h of c) {
          const { color: I, components: p } = h, y = p.map((m) => m.ifc_guid).filter((m) => m !== null);
          this.componentColors.set(I, y);
        }
      }
    }
    if ((n || s) && (this.camera = n ?? s), o && this.world) {
      const r = this._components.get(ez);
      for (const l of o) {
        const { location: c, direction: h } = l, I = new Ge(
          c.x,
          c.z,
          -c.y
        ), p = new Ge(
          h.x,
          h.z,
          -h.y
        ), y = r.createFromNormalAndCoplanarPoint(
          this.world,
          p,
          I
        );
        this.clippingPlanes.add(y), r.list.get(y).enabled = !1, r.list.get(y).visible = !1;
      }
    }
    this.notifyUpdate();
  }
  /**
   * Sets the viewpoint of the camera in the world.
   *
   * @remarks
   * This function calculates the target position based on the viewpoint information.
   * It sets the visibility of the viewpoint components and then applies the viewpoint using the camera's controls.
   *
   * @param transition - Indicates whether the camera movement should have a transition effect.
   *                      Default value is `true`.
   *
   * @throws An error if the world's camera does not have camera controls.
   *
   * @returns A Promise that resolves when the camera has been set.
   */
  async go(t) {
    if (!this.world)
      return;
    const { camera: i } = this.world;
    if (!(i instanceof qbe))
      throw new Error(
        "Viewpoint: the world's camera component must be of type OrthoPerspectiveCamera to switch between perspective and orthographic projections."
      );
    const { transition: n, applyClippings: s, applyVisibility: o, clippingsVisibility: r } = {
      transition: !0,
      applyClippings: !0,
      applyVisibility: !0,
      clippingsVisibility: !0,
      ...t
    };
    i.projection.set(this.projection);
    const l = new Ge(
      this.camera.camera_view_point.x,
      this.camera.camera_view_point.y,
      this.camera.camera_view_point.z
    ), c = new Ge(
      this.camera.camera_direction.x,
      this.camera.camera_direction.y,
      this.camera.camera_direction.z
    );
    if (l.equals(new Ge()) && c.equals(new Ge()))
      return;
    const h = this.position, I = this.direction, p = 80, y = {
      x: h.x + I.x * p,
      y: h.y + I.y * p,
      z: h.z + I.z * p
    }, m = [];
    s && this.setClippingState(!0), o && m.push(this.applyVisibility()), this.setClippingVisibility(r), m.push(
      i.controls.setLookAt(
        h.x,
        h.y,
        h.z,
        y.x,
        y.y,
        y.z,
        n
      )
    ), await Promise.all(m);
  }
  /**
   * Updates the camera settings of the viewpoint based on the current world's camera and renderer.
   * @returns A boolean indicating if the camera data was updated or not.
   */
  async updateCamera(t = !0) {
    return new Promise((i) => {
      if (!this.world) {
        i(!1);
        return;
      }
      const { camera: n, renderer: s } = this.world;
      if (!s)
        throw new Error("Viewpoint: the world needs to have a renderer!");
      if (!n.hasCameraControls())
        throw new Error("Viewpoint: world's camera need camera controls!");
      const o = new Ge();
      n.controls.getPosition(o);
      const r = n.three, l = new Ge(0, 0, -1).applyEuler(
        r.rotation
      ), { width: c, height: h } = s.getSize();
      let I = c / h;
      Number.isNaN(I) && (I = 1);
      const p = this._components.get(Io);
      o.applyMatrix4(p.baseCoordinationMatrix.clone().invert());
      const y = {
        aspect_ratio: I,
        camera_view_point: { x: o.x, y: o.y, z: o.z },
        camera_direction: { x: l.x, y: l.y, z: l.z },
        camera_up_vector: { x: 0, y: 1, z: 0 }
      };
      if (r instanceof Tg ? this.camera = {
        ...y,
        field_of_view: r.fov
      } : r instanceof eY && (this.camera = {
        ...y,
        view_to_world_scale: r.top - r.bottom
      }), t) {
        const m = this._components.get(VO), A = s.three.domElement;
        s.three.render(this.world.scene.three, n.three), A.toBlob(async (C) => {
          if (C) {
            const O = await C.arrayBuffer(), R = new Uint8Array(O);
            m.snapshots.set(this.guid, R);
          }
          this.notifyUpdate(), i(!0);
        });
      } else
        this.notifyUpdate(), i(!0);
    });
  }
  /**
   * Captures a snapshot of the current viewpoint and stores it in the snapshots manager.
   */
  takeSnapshot() {
    return new Promise((t) => {
      if (!this.world) {
        t(!1);
        return;
      }
      const { camera: i, renderer: n } = this.world;
      if (!n)
        throw new Error("Viewpoint: the world needs to have a renderer!");
      const s = this._components.get(VO), o = n.three.domElement;
      n.three.render(this.world.scene.three, i.three), o.toBlob(async (r) => {
        if (r) {
          const l = await r.arrayBuffer(), c = new Uint8Array(l);
          s.snapshots.set(this.guid, c);
        }
        this.notifyUpdate(), t(!0);
      });
    });
  }
  /**
   * Updates the collection of clipping planes by clearing the current set and adding enabled planes
   * from the associated `Clipper` component.
   */
  updateClippingPlanes() {
    this.clippingPlanes.clear();
    const t = this._components.get(ez);
    for (const [i, n] of t.list)
      n.enabled && this.clippingPlanes.add(i);
  }
  /**
   * Applies visibility settings to components based on default visibility, exceptions, and selections.
   *
   * This method adjusts the visibility of components using the `Hider` instance. It ensures that:
   * - The default visibility is applied to all components.
   * - Exceptions are handled to override the default visibility.
   * - Selected components are always visible.
   */
  async applyVisibility() {
    const t = this._components.get(SKe);
    t.set(this.defaultVisibility);
    const i = await this.getExceptionMap();
    t.set(!this.defaultVisibility, i);
    const n = await this.getSelectionMap();
    t.set(!0, n);
  }
  // TODO: Analyze how this works along with the Highlighter
  /**
   * Asynchronously sets the colorization state for the viewpoint's components.
   * When the state is true, it applies the defined component colors to the corresponding fragments.
   * When the state is false, it resets the highlight for the corresponding fragments.
   *
   * @param state - A boolean indicating whether to apply or reset the colorization.
   *                If true, the components will be colorized. If false, the colorization will be reset.
   * @returns A Promise that resolves when all colorization or reset operations are complete.
   * @remarks Be careful when using this method along with the Highlighter as it can cause unwanted results
   */
  async setColorizationState(t) {
    const i = this._components.get(Io), n = [];
    if (t)
      for (const [s, o] of this.componentColors) {
        const r = `#${s}`, l = await i.guidsToModelIdMap(o);
        for (const [c, h] of Object.entries(l)) {
          const I = i.list.get(c);
          I && n.push(
            I.highlight([...h], {
              customId: r,
              color: new Xn(r),
              renderedFaces: Dme.ONE,
              opacity: 1,
              transparent: !1
            })
          );
        }
      }
    else
      for (const [s, o] of this.componentColors) {
        const r = await i.guidsToModelIdMap(o);
        for (const [l, c] of Object.entries(r)) {
          const h = i.list.get(l);
          h && n.push(h.resetHighlight([...c]));
        }
      }
    n.push(i.core.update(!0)), await Promise.all(n);
  }
  /**
   * Sets the enabled state of all clipping planes associated with this viewpoint.
   * @param state A boolean indicating whether the clipping planes should be enabled or disabled.
   */
  setClippingState(t) {
    const i = this._components.get(ez);
    for (const [n, s] of i.list)
      s.enabled = t && this.clippingPlanes.has(n);
  }
  /**
   * Sets the visibility of all clipping planes associated with this viewpoint.
   *
   * @param visibility - A boolean indicating whether the clipping planes should be visible (`true`) or hidden (`false`).
   */
  setClippingVisibility(t) {
    const i = this._components.get(ez);
    for (const n of this.clippingPlanes) {
      const s = i.list.get(n);
      s && (s.visible = t);
    }
  }
  async createComponentTags(t) {
    var i;
    const n = this._components.get(Io), s = this._components.get(c1);
    let o = "";
    if (s.config.includeSelectionTag) {
      const r = t === "selection" ? await this.getSelectionMap() : await this.getExceptionMap();
      for (const l in r) {
        const c = n.list.get(l);
        if (!c)
          continue;
        const h = r[l];
        for (const I of h) {
          const p = c.getItem(I), y = await p.getGuid();
          if (!y)
            continue;
          const m = (i = await p.getAttributes()) == null ? void 0 : i.getValue("Tag");
          let A = null;
          m && (A = `AuthoringToolId="${m}"`), o += `
<Component IfcGuid="${y}" ${A ?? ""} />`;
        }
      }
    } else
      o = [...this.selectionComponents].map((r) => `<Component IfcGuid="${r}" />`).join(`
`);
    return o;
  }
  createColorTags() {
    let t = "";
    for (const [i, n] of this.componentColors.entries()) {
      const s = n.map((o) => `
<Component IfcGuid="${o}" />`).join(`
`);
      t += `<Color Color="${i}">
${s}
</Color>`;
    }
    return t.length !== 0 ? `<Coloring>
${t}
</Coloring>` : "<Coloring />";
  }
  /**
   * Converts the current viewpoint instance into a JSON representation compliant with the BCFViewpoint format.
   *
   * @returns A BCF API JSON complaint object representing the viewpoint, including its GUID, components,
   * visibility settings, clipping planes, camera configuration, and snapshot data.
   */
  toJSON() {
    const t = this._components.get(ez), i = {
      guid: this.guid,
      components: {
        selection: [...this.selectionComponents].map((o) => ({ ifc_guid: o, authoring_tool_id: null })),
        coloring: [...this.componentColors].map(([o, r]) => ({
          color: o,
          components: r.map((l) => ({ ifc_guid: l, authoring_tool_id: null }))
        })),
        visibility: {
          default_visibility: this.defaultVisibility,
          exceptions: [...this.exceptionComponents].map((o) => ({ ifc_guid: o, authoring_tool_id: null })),
          view_setup_hints: {
            spaces_visible: this.spacesVisible,
            space_boundaries_visible: this.spaceBoundariesVisible,
            openings_visible: this.openingsVisible
          }
        }
      },
      clipping_planes: [...this.clippingPlanes].map((o) => {
        const r = t.list.get(o);
        if (!r)
          return null;
        const l = r._controls.worldPosition ?? r.origin, { normal: c } = r;
        return {
          location: { x: l.x, y: -l.z, z: l.y },
          direction: { x: c.x, y: -c.z, z: c.y }
        };
      }).filter((o) => o !== null)
    };
    "field_of_view" in this.camera ? i.perspective_camera = this.camera : i.orthogonal_camera = this.camera;
    const n = this._components.get(VO), s = n.snapshots.get(this.snapshot);
    if (s) {
      const o = s.toString(), r = btoa(o), l = n.getSnapshotExtension(this.snapshot);
      i.snapshot = { snapshot_type: l, snapshot_data: r };
    }
    return i;
  }
  /**
   * Serializes the viewpoint into a buildingSMART compliant XML string for export.
   *
   * @param version - The version of the BCF Manager to use for serialization.
   *                   If not provided, the current version of the manager will be used.
   *
   * @returns A Promise that resolves to an XML string representing the viewpoint.
   *          The XML string follows the BCF VisualizationInfo schema.
   *
   * @throws An error if the world's camera does not have camera controls.
   * @throws An error if the world's renderer is not available.
   */
  async serialize(t = this._managerVersion) {
    const i = this._components.get(Io), n = this.position;
    n.applyMatrix4(i.baseCoordinationMatrix.clone().invert());
    const s = this.direction;
    s.normalize();
    const o = new Ln().makeRotationX(Math.PI / 2), r = s.clone().applyMatrix4(o);
    r.normalize();
    const l = `<CameraViewPoint>
      <X>${n.x}</X>
      <Y>${-n.z}</Y>
      <Z>${n.y}</Z>
    </CameraViewPoint>`, c = `<CameraDirection>
      <X>${s.x}</X>
      <Y>${-s.z}</Y>
      <Z>${s.y}</Z>
    </CameraDirection>`, h = `<CameraUpVector>
      <X>${r.x}</X>
      <Y>${-r.z}</Y>
      <Z>${r.y}</Z>
    </CameraUpVector>`, I = `<AspectRatio>${this.camera.aspect_ratio}</AspectRatio>`;
    let p = "";
    "view_to_world_scale" in this.camera ? p = `<OrthogonalCamera>
        ${l}
        ${c}
        ${h}
        ${I}
        <ViewToWorldScale>${this.camera.view_to_world_scale}</ViewToWorldScale>
      </OrthogonalCamera>` : "field_of_view" in this.camera && (p = `<PerspectiveCamera>
        ${l}
        ${c}
        ${h}
        ${I}
        <FieldOfView>${this.camera.field_of_view}</FieldOfView>
      </PerspectiveCamera>`);
    const y = `<ViewSetupHints SpacesVisible="${this.spacesVisible ?? !1}" SpaceBoundariesVisible="${this.spaceBoundariesVisible ?? !1}" OpeningsVisible="${this.openingsVisible ?? !1}" />`, m = (await this.createComponentTags("selection")).trim(), A = (await this.createComponentTags("exception")).trim(), C = this.createColorTags();
    return `<?xml version="1.0" encoding="UTF-8"?>
    <VisualizationInfo Guid="${this.guid}">
      <Components>
        ${t === "2.1" ? y : ""}
        ${m.length !== 0 ? `<Selection>${m}</Selection>` : ""}
        <Visibility DefaultVisibility="${this.defaultVisibility}">
          ${t === "3" ? y : ""}
          ${A.length !== 0 ? `<Exceptions>${A}</Exceptions>` : ""}
        </Visibility>
        ${C}
      </Components>
      ${p}
    </VisualizationInfo>`;
  }
}
class cQe extends Hie {
  constructor() {
    super(...arguments), tt(this, "_config", {
      overwriteColors: {
        value: !1,
        type: "Boolean"
      }
    });
  }
  get overwriteColors() {
    return this._config.overwriteColors.value;
  }
  set overwriteColors(t) {
    this._config.overwriteColors.value = t;
  }
}
const Jbe = class ZIe extends bI {
  constructor(t) {
    super(t), tt(this, "enabled", !0), tt(this, "world", null), tt(this, "list", new f0()), tt(this, "snapshots", new f0()), tt(this, "isSetup", !1), tt(this, "onSetup", new es()), tt(this, "config", new cQe(
      this,
      this.components,
      "Viewpoints",
      ZIe.uuid
    )), tt(this, "onDisposed", new es()), t.add(ZIe.uuid, this);
  }
  /**
   * Creates a new Viewpoint instance and adds it to the list.
   *
   * @param data - Optional partial data for the Viewpoint. If not provided, default data will be used.
   *
   * @returns The newly created Viewpoint instance.
   */
  create(t) {
    const i = new Qbe(this.components, t);
    return i.world = this.world, t || this.list.set(i.guid, i), i;
  }
  /**
   * Determines the file extension of a snapshot based on its header bytes.
   *
   * @param name - The name of the snapshot from the list to retrieve its extension.
   * @returns The file extension as a string. Defaults to "jpeg" if the snapshot
   *          does not exist or the header bytes do not match known formats.
   */
  getSnapshotExtension(t) {
    let i = "jpeg";
    const n = this.snapshots.get(t);
    if (!n)
      return i;
    const s = n.subarray(0, 4);
    let o = "";
    for (let r = 0; r < s.length; r++)
      o += s[r].toString(16);
    return o.startsWith("89504e47") && (i = "png"), o.startsWith("ffd8ffe") && (i = "jpeg"), i;
  }
  setup() {
  }
  /**
   * Disposes of the Viewpoints component and its associated resources.
   *
   * This method is responsible for cleaning up any resources held by the Viewpoints component,
   * such as disposing of the DataMap of Viewpoint instances and triggering and resetting the
   * onDisposed event.
   */
  dispose() {
    this.list.dispose(), this.onDisposed.trigger(), this.onDisposed.reset();
  }
};
tt(Jbe, "uuid", "ee867824-a796-408d-8aa0-4e5962a83c66");
let VO = Jbe;
class b2e {
  constructor(t, i) {
    tt(this, "_components"), tt(this, "_cameraOffset", 10), tt(this, "_planeHelper"), tt(this, "_farPlaneHelper"), tt(this, "_cameraHelper"), tt(this, "onStateChanged", new es()), tt(this, "onUpdated", new es()), tt(this, "onDisposed", new es()), tt(this, "camera"), tt(this, "plane", new tl()), tt(this, "farPlane", new tl()), tt(this, "id", y4.create()), tt(this, "_open", !1), tt(this, "_range", hQe.defaultRange), tt(this, "_world", null), tt(this, "_helpersVisible", !1), tt(this, "_planesEnabled", !1), this._components = t, this.camera = new qbe(this._components);
    const { threeOrtho: n } = this.camera;
    if (i != null && i.id && (this.id = i.id), i != null && i.normal && (i != null && i.point)) {
      const { normal: s, point: o } = i;
      this.plane.setFromNormalAndCoplanarPoint(s, o);
    }
    this._cameraHelper = new _Ue(n), this._planeHelper = new Rge(this.plane, 50), this._farPlaneHelper = new Rge(this.farPlane, 50), this.farPlaneHelperColor = new Xn("blue"), this.update();
  }
  get _planeNormalOpposite() {
    return this.plane.normal.clone().negate();
  }
  get _planePosition() {
    return this.plane.normal.clone().multiplyScalar(-this.plane.constant);
  }
  get _cameraPosition() {
    return this._planePosition.addScaledVector(
      this._planeNormalOpposite,
      this._cameraOffset
    );
  }
  set open(t) {
    this._open = t, this.onStateChanged.trigger(["open"]);
  }
  get open() {
    return this._open;
  }
  set planeHelperColor(t) {
    !Array.isArray(this._planeHelper.material) && "color" in this._planeHelper.material && this._planeHelper.material.color instanceof Xn && (this._planeHelper.material.color = t);
  }
  set farPlaneHelperColor(t) {
    !Array.isArray(this._farPlaneHelper.material) && "color" in this._farPlaneHelper.material && this._farPlaneHelper.material.color instanceof Xn && (this._farPlaneHelper.material.color = t);
  }
  set range(t) {
    this._range = t, this.update();
  }
  get range() {
    return this._range;
  }
  set distance(t) {
    this.plane.constant = t, this.update();
  }
  get distance() {
    return this.plane.constant;
  }
  set world(t) {
    this._world = t, this.camera.currentWorld = t, t && (this.camera.projection.set("Orthographic"), this.camera.set("Plan"), this.camera.controls.dollySpeed = 6, this.camera.controls.restThreshold = 5e-3, this.update());
  }
  get world() {
    return this._world;
  }
  set helpersVisible(t) {
    if (!t) {
      this._helpersVisible = t, this._planeHelper.removeFromParent(), this._farPlaneHelper.removeFromParent(), this._cameraHelper.removeFromParent();
      return;
    }
    this.world && (this._helpersVisible = t, this.world.scene.three.add(
      this._planeHelper,
      this._farPlaneHelper
      // this._cameraHelper,
    ));
  }
  get helpersVisible() {
    return this._helpersVisible;
  }
  // for debugging purposes
  // Section the model based on the planes
  // without using the camera
  set planesEnabled(t) {
    const { world: i } = this;
    if (!i)
      return;
    const { renderer: n } = i;
    n && (n.setPlane(t, this.plane), n.setPlane(t, this.farPlane), this._planesEnabled = t);
  }
  get planesEnabled() {
    return this._planesEnabled;
  }
  dispose() {
    this.helpersVisible = !1;
    const t = this._components.get(Tue);
    t.destroy(this._planeHelper), t.destroy(this._farPlaneHelper), t.destroy(this._cameraHelper), this.camera.dispose(), this.onDisposed.trigger();
  }
  // update based on changes made to this.plane
  update() {
    if (this.world) {
      const t = this._cameraPosition, i = this._planePosition;
      this.camera.controls.setLookAt(
        t.x,
        t.y,
        t.z,
        i.x,
        i.y,
        i.z,
        !1
      );
    }
    this.farPlane.normal.copy(this._planeNormalOpposite), this.farPlane.constant = this.range - this.plane.constant, this.onUpdated.trigger();
  }
  flip() {
    this.plane.normal.negate(), this.update();
  }
}
const zme = class Xbe extends bI {
  constructor(t) {
    super(t), tt(this, "list", new f0()), tt(this, "enabled", !0), tt(this, "world", null), tt(this, "_fragmentsUpdateEvent", () => {
      this.components.get(Io).core.update(!0);
    }), t.add(Xbe.uuid, this), this.setupEvents();
  }
  /**
   * Determines whether there are any open views in this component's list.
   */
  get hasOpenViews() {
    return [...this.list.values()].some((t) => t.open);
  }
  setupEvents() {
    this.list.onBeforeDelete.add(({ key: t, value: i }) => {
      i.open && this.close(t), i.dispose();
    });
  }
  /**
   * Creates a new view with the specified normal vector, point, and optional configuration.
   *
   * @param normal - The normal vector defining the orientation of the view.
   * @param point - The point in space where the view is centered.
   * @param config - Optional configuration for the view creation.
   * @returns The newly created `View` instance.
   * @remarks The created view will be added to the component's list data map.
   */
  create(t, i, n) {
    const s = new b2e(this.components, { id: n == null ? void 0 : n.id, normal: t, point: i });
    return s.world = (n == null ? void 0 : n.world) ?? this.world, this.list.set(s.id, s), s;
  }
  /**
   * Creates a new view from the specified plane and optional configuration.
   *
   * @param plane - The `THREE.Plane` object representing the plane to create the view from.
   * @param config - Optional configuration for creating the view.
   * @returns The newly created `View` instance.
   * @remarks The created view will be added to the component's list data map.
   */
  createFromPlane(t, i) {
    const n = new b2e(this.components, { id: i == null ? void 0 : i.id });
    return n.plane.copy(t), n.update(), n.world = (i == null ? void 0 : i.world) ?? this.world, this.list.set(n.id, n), n;
  }
  /**
   * Creates views from IFC storeys based on the provided configuration.
   * This method iterates through the fragments of the model, filters storeys
   * based on the configuration, and generates views for each storey.
   *
   * @param config - Optional configuration for creating views from IFC storeys.
   * @returns A promise that resolves to an array of `View` objects created from the IFC storeys.
   *
   * @remarks Each IfcBuilsingStorey is represented as a plane in 3D space, with its elevation adjusted by the `offset`. The created views will be added to the component's list data map.
   */
  async createFromIfcStoreys(t) {
    const i = [], n = this.components.get(Io), s = (t == null ? void 0 : t.offset) === void 0 ? 0.25 : t.offset;
    for (const [o, r] of n.list) {
      if (t && t.modelIds && !t.modelIds.some((p) => p.test(o)))
        continue;
      const l = Object.values(
        await r.getItemsOfCategories([/BUILDINGSTOREY/])
      ).flat();
      if (l.length === 0)
        continue;
      const c = await r.getItemsData(l), [, h] = await r.getCoordinates(), I = new Ge(0, -1, 0);
      for (const p of c) {
        if (!("value" in p.Name && "value" in p.Elevation))
          continue;
        const { value: y } = p.Name;
        if (t != null && t.storeyNames && !t.storeyNames.some((O) => O.test(y)))
          continue;
        const m = p.Elevation.value + h + s, A = new tl(I, m), C = this.createFromPlane(A, {
          id: y,
          world: t == null ? void 0 : t.world
        });
        i.push(C);
      }
    }
    return i;
  }
  /**
   * Creates views representing the front, back, left, and right sides of bounding boxes for specified models or a combined bounding box of all models.
   *
   * @param config - Optional configuration object for creating bounding views.
   * @returns A promise that resolves to an array of `View` objects created from the boundings.
   * @remarks The method calculates bounding boxes for the specified models, optionally combines them into a single bounding box, and creates views for the planes representing the bounding box sides.
   */
  createElevations(t) {
    const i = [], n = this.components.get(Io), s = (t == null ? void 0 : t.combine) === void 0 ? !1 : t.combine, o = (t == null ? void 0 : t.namingCallback) ?? ((l) => ({
      front: `${s ? "Front" : `${l}: Front`}`,
      back: `${s ? "Back" : `${l}: Back`}`,
      left: `${s ? "Left" : `${l}: Left`}`,
      right: `${s ? "Right" : `${l}: Right`}`
    }));
    let r = [];
    for (const [l, c] of n.list)
      t && t.modelIds && !t.modelIds.some((h) => h.test(l)) || r.push({ id: l, box: c.box });
    if (s) {
      const l = this.components.get(Cbe);
      l.list.clear(), l.list.add(...r.map((h) => h.box)), r = [{ id: "combined", box: l.get() }];
    }
    for (const { id: l, box: c } of r) {
      const { min: h, max: I } = c, p = Math.abs(I.x - h.x), y = Math.abs(I.z - h.z), m = new Ge();
      c.getCenter(m);
      const A = new tl(new Ge(0, 0, -1), I.z), C = new tl(new Ge(0, 0, 1), -h.z), O = new tl(new Ge(-1, 0, 0), I.x), R = new tl(new Ge(1, 0, 0), -h.x), {
        front: F,
        back: L,
        left: P,
        right: z
      } = o(l), W = this.createFromPlane(A, {
        id: F,
        world: t == null ? void 0 : t.world
      });
      W.range = y;
      const re = this.createFromPlane(C, {
        id: L,
        world: t == null ? void 0 : t.world
      });
      re.range = y;
      const ce = this.createFromPlane(O, {
        id: P,
        world: t == null ? void 0 : t.world
      });
      ce.range = p;
      const te = this.createFromPlane(R, {
        id: z,
        world: t == null ? void 0 : t.world
      });
      te.range = p, i.push(W, re, ce, te);
    }
    return i;
  }
  /**
   * Opens a view by its unique identifier. Ensures that no more than one view
   * is opened in the same world at a time. If the view is already open, the method
   * returns without performing any action.
   *
   * @param id - The unique identifier of the view to open.
   * @remarks This method changes world camera to use the view's.
   */
  open(t) {
    const i = this.list.get(t);
    if (!i)
      throw new Error(`Views: the view with id ${t} doesn't exist.`);
    if (i.open)
      return;
    const { world: n } = i;
    if (!n)
      throw new Error(`Views: no world found for view with id ${t}.`);
    const { renderer: s } = n;
    if (!s)
      throw new Error(
        `Views: no renderer found for world with id ${n.uuid}.`
      );
    for (const [, o] of this.list)
      o.world === n && this.close(o.id);
    s.setPlane(!0, i.plane), s.setPlane(!0, i.farPlane), i.camera.controls.addEventListener("rest", this._fragmentsUpdateEvent), n.camera = i.camera, i.open = !0;
  }
  /**
   * Closes a view by its unique identifier and performs necessary cleanup operations.
   *
   * @param id - The unique identifier of the view to be closed. If not provided, all opened views across worlds will be closed.
   * @remarks This method resets the world to use its default camera.
   */
  close(t) {
    let i;
    if (t ? i = this.list.get(t) : i = [...this.list.values()].find((o) => o.open), t && !i)
      throw new Error(`Views: the view with id ${t} doesn't exist.`);
    if (!i || !i.open)
      return;
    const { world: n } = i;
    if (!n)
      throw new Error(`Views: no world found for view with id ${t}.`);
    const { renderer: s } = n;
    if (!s)
      throw new Error(
        `Views: no renderer found for world with id ${n.uuid}.`
      );
    s.setPlane(!1, i.plane), s.setPlane(!1, i.farPlane), i.camera.controls.removeEventListener(
      "rest",
      this._fragmentsUpdateEvent
    ), n.useDefaultCamera(), i.open = !1;
  }
};
tt(zme, "uuid", "fb22f1f5-6598-4664-a11d-de8963ae420f");
tt(zme, "defaultRange", 15);
let hQe = zme;
class uY {
  constructor(t) {
    tt(this, "cardinality", "required"), tt(this, "instructions"), tt(this, "evalRequirement", (i, n, s, o) => {
      const r = {
        parameter: s,
        currentValue: i,
        requiredValue: n,
        pass: !1
      };
      o && this.addCheckResult(r, o);
      let l = !1;
      if (n.type === "simple" && (l = i === n.parameter), n.type === "enumeration" && (l = n.parameter.includes(i)), n.type === "pattern" && (l = new RegExp(n.parameter).test(String(i))), n.type === "length") {
        const { min: c, length: h, max: I } = n.parameter;
        h !== void 0 && (l = String(i).length === h), c !== void 0 && (l = String(i).length >= c), I !== void 0 && (l = String(i).length <= I);
      }
      if (n.type === "bounds" && typeof i == "number") {
        const { min: c, minInclusive: h, max: I, maxInclusive: p } = n.parameter;
        let y = !0, m = !0;
        c !== void 0 && (y = h ? i >= c : i > c), I !== void 0 && (m = p ? i <= I : i < I), l = y && m;
      }
      return this.cardinality === "prohibited" && (l = !l), this.cardinality === "optional" && (l = !0), r.pass = l, r.pass;
    }), this._components = t;
  }
  addCheckResult(t, i) {
    const n = i.findIndex(
      ({ parameter: s }) => s === t.parameter
    );
    n !== -1 ? i[n] = t : i.push(t);
  }
  getItemChecks(t, i, n, s) {
    if (!("value" in n._localId && typeof n._localId.value == "number"))
      return null;
    let o = t.get(i);
    o || (o = new f0(), t.set(i, o));
    let r = o.get(n._localId.value);
    if (r && s && !r.pass)
      return null;
    if (!r) {
      const h = [];
      r = {
        guid: Array.isArray(n._guid) ? void 0 : n._guid.value,
        pass: !1,
        checks: h
      }, Object.defineProperty(r, "pass", {
        get: () => h.every(({ pass: I }) => I)
      }), o.set(n._localId.value, r);
    }
    const l = [], c = {
      facetType: this.facetType,
      cardinality: this.cardinality,
      checks: l,
      pass: !1
    };
    return Object.defineProperty(c, "pass", {
      get: () => l.every(({ pass: h }) => h)
    }), r.checks.push(c), c.checks;
  }
}
const n6 = (e, t) => {
  let i = "";
  if (!t)
    return i;
  if (t.type === "simple" && (i = `<simpleValue>${t.parameter}</simpleValue>`), t.type === "enumeration" && (i = `<xs:restriction base="xs:string">
    ${t.parameter.map((o) => `<xs:enumeration value="${o}" />`).join(`
`)}
    </xs:restriction>`), t.type === "pattern" && (i = `<xs:restriction base="xs:string">
      <xs:pattern value="${t.parameter}" />
    </xs:restriction>`), t.type === "bounds") {
    const { min: s, minInclusive: o, max: r, maxInclusive: l } = t.parameter;
    let c = "";
    s !== void 0 && (c = `<xs:min${o ? "Inclusive" : "Exclusive"} value="${s}">`);
    let h = "";
    r !== void 0 && (h = `<xs:max${l ? "Inclusive" : "Exclusive"} value="${r}">`), i = `<xs:restriction base="xs:double">
      ${c}
      ${h}
    </xs:restriction>`;
  }
  if (t.type === "length") {
    const { length: s, min: o, max: r } = t.parameter;
    let l = "";
    s !== void 0 && o === void 0 && r === void 0 && (l = `<xs:length value="${s}" />`);
    let c = "";
    o !== void 0 && s === void 0 && (c = `<xs:minLength value="${o}" />`);
    let h = "";
    r !== void 0 && s === void 0 && (h = `<xs:maxLength value="${r}" />`), i = `<xs:restriction base="xs:string">
      ${l}
      ${c}
      ${h}
    </xs:restriction>`;
  }
  return `<${e[0].toLowerCase() + e.slice(1)}>
    ${i}
  </${e[0].toLowerCase() + e.slice(1)}>`;
};
class fQe extends uY {
  constructor(t, i) {
    super(t), tt(this, "facetType", "Attribute"), tt(this, "name"), tt(this, "value"), this.name = i;
  }
  serialize(t) {
    const i = n6("Name", this.name), n = n6("Value", this.value);
    let s = "";
    return t === "requirement" && (s += `cardinality="${this.cardinality}"`, s += this.instructions ? `instructions="${this.instructions}"` : ""), `<attribute ${s}>
  ${i}
  ${n}
</attribute>`;
  }
  // This can be very ineficcient as we do not have an easy way to get an entity based on an attribute
  // Right now, all entities must be iterated.
  // When the new IfcEntitiesFinder comes, this can become easier.
  // This may be greatly increase in performance if the applicability has any of the other facets and this is applied the latest
  async getEntities() {
  }
  // async getEntities(
  //   model: FRAGS.FragmentsGroup,
  //   collector: FRAGS.IfcProperties = {},
  // ) {
  //   return [];
  //   // for (const expressID in model) {
  //   //   if (collector[expressID]) continue;
  //   //   const entity = model[expressID];
  //   //   // Check if the attribute exists
  //   //   const attribute = entity[this.name];
  //   //   const attributeExists = !!attribute;
  //   //   // Check if the attribute value matches
  //   //   let valueMatches = true;
  //   //   if (attributeExists && this.value && this.value.value) {
  //   //     if (this.value.type === "simpleValue") {
  //   //       valueMatches = attribute.value === this.value.value;
  //   //     }
  //   //     if (this.value.type === "restriction") {
  //   //       const regex = new RegExp(this.value.value);
  //   //       valueMatches = regex.test(attribute.value);
  //   //     }
  //   //   }
  //   //   if (attributeExists && valueMatches) {
  //   //     collector[entity.expressID] = entity;
  //   //   }
  //   // }
  // }
  // https://github.com/buildingSMART/IDS/tree/development/Documentation/ImplementersDocumentation/TestCases/attribute
  // Test cases from buildingSMART repo have been tested and they all match with the expected result
  // All invalid cases have been treated as failures
  // FragmentsGroup do not hold some of the entities used in the tests
  async test(t, i, n = { skipIfFails: !0 }) {
    const s = this._components.get(Io);
    for (const [o, r] of Object.entries(t)) {
      const l = s.list.get(o);
      if (!l)
        continue;
      const c = await l.getItemsData([...r]);
      for (const h of c) {
        const I = this.getItemChecks(
          i,
          o,
          h,
          n.skipIfFails
        );
        if (!I)
          continue;
        const y = Object.keys(h).filter((A) => {
          const C = this.evalRequirement(A, this.name, "Name");
          if (!C)
            return !1;
          const O = h[A];
          return Array.isArray(O) ? !0 : O === null || O.value === null ? this.cardinality === "optional" || this.cardinality === "prohibited" : Array.isArray(O.value) && O.value.length === 0 || typeof O.value == "string" && O.value.trim() === "" ? !1 : C;
        }), m = y.length > 0;
        if (I.push({
          parameter: "Name",
          currentValue: m ? y[0] : null,
          requiredValue: this.name,
          pass: this.cardinality === "prohibited" ? !m : m
        }), this.value)
          if (y[0]) {
            const A = h[y[0]];
            Array.isArray(A) ? I.push({
              parameter: "Value",
              currentValue: null,
              requiredValue: this.value,
              pass: this.cardinality === "prohibited"
            }) : Array.isArray(A.value) ? I.push({
              parameter: "Value",
              currentValue: null,
              requiredValue: this.value,
              pass: this.cardinality === "prohibited"
            }) : this.evalRequirement(
              A.value,
              this.value,
              "Value",
              I
            );
          } else
            I.push({
              parameter: "Value",
              currentValue: null,
              requiredValue: this.value,
              pass: this.cardinality === "prohibited"
            });
      }
    }
  }
}
class IQe extends uY {
  constructor(t, i) {
    super(t), tt(this, "facetType", "Classification"), tt(this, "system"), tt(this, "value"), tt(this, "uri"), this.system = i;
  }
  serialize(t) {
    const i = n6("System", this.system), n = n6("Value", this.value);
    let s = "";
    return t === "requirement" && (s += `cardinality="${this.cardinality}"`, s += this.uri ? `uri=${this.uri}` : "", s += this.instructions ? `instructions="${this.instructions}"` : ""), `<classification ${s}>
  ${i}
  ${n}
</classification>`;
  }
  async getEntities(t, i) {
  }
  async test(t, i) {
  }
  // private async processReferencedSource(
  //   model: FRAGS.FragmentsGroup,
  //   attrs: Record<string, any>,
  // ) {
  //   const sourceID = attrs.ReferencedSource?.value;
  //   if (!sourceID) return null;
  //   const sourceAttrs = await model.getProperties(sourceID);
  //   if (!sourceAttrs) return null;
  //   if (sourceAttrs.type === WEBIFC.IFCCLASSIFICATIONREFERENCE) {
  //     sourceAttrs.ReferencedSource = await this.processReferencedSource(
  //       model,
  //       sourceAttrs,
  //     );
  //   }
  //   return sourceAttrs;
  // }
  // private async getSystems(model: FRAGS.FragmentsGroup, expressID: number) {
  //   const result: Record<string, any>[] = [];
  //   const indexer = this._components.get(IfcRelationsIndexer);
  //   const ocurrenceAssociations = indexer.getEntityRelations(
  //     model,
  //     expressID,
  //     "HasAssociations",
  //   );
  //   if (ocurrenceAssociations) {
  //     for (const id of ocurrenceAssociations) {
  //       const attrs = await model.getProperties(id);
  //       if (!attrs) continue;
  //       if (attrs.type === WEBIFC.IFCCLASSIFICATION) {
  //         result.push(attrs);
  //       }
  //       if (attrs.type === WEBIFC.IFCCLASSIFICATIONREFERENCE) {
  //         attrs.ReferencedSource = await this.processReferencedSource(
  //           model,
  //           attrs,
  //         );
  //         if (attrs.ReferencedSource) result.push(attrs);
  //       }
  //     }
  //   }
  //   // As occurence classifications prevail over type clasifications
  //   // the classification systems used by the occurrence are get
  //   // so type classifications are not included
  //   const occurrenceSystems = result
  //     .map((attrs) => {
  //       if (attrs.type === WEBIFC.IFCCLASSIFICATION) {
  //         return attrs.Name?.value;
  //       }
  //       if (attrs.type === WEBIFC.IFCCLASSIFICATIONREFERENCE) {
  //         return attrs.ReferencedSource?.Name?.value;
  //       }
  //       return null;
  //     })
  //     .filter((name) => name);
  //   const types = indexer.getEntityRelations(model, expressID, "IsTypedBy");
  //   if (!(types && types[0])) return result;
  //   const type = types[0];
  //   const typeAssociations = indexer.getEntityRelations(
  //     model,
  //     type,
  //     "HasAssociations",
  //   );
  //   if (typeAssociations) {
  //     for (const id of typeAssociations) {
  //       const attrs = await model.getProperties(id);
  //       if (!attrs) continue;
  //       if (attrs.type === WEBIFC.IFCCLASSIFICATION) {
  //         if (occurrenceSystems.includes(attrs.Name?.value)) continue;
  //         result.push(attrs);
  //       }
  //       if (attrs.type === WEBIFC.IFCCLASSIFICATIONREFERENCE) {
  //         attrs.ReferencedSource = await this.processReferencedSource(
  //           model,
  //           attrs,
  //         );
  //         if (attrs.ReferencedSource) result.push(attrs);
  //       }
  //     }
  //   }
  //   return result;
  // }
  // private getSystemName(attrs: Record<string, any>): string | null {
  //   if (attrs.type === WEBIFC.IFCCLASSIFICATION) {
  //     return attrs.Name?.value;
  //   }
  //   if (attrs.type === WEBIFC.IFCCLASSIFICATIONREFERENCE) {
  //     if (attrs.ReferencedSource?.type === WEBIFC.IFCCLASSIFICATIONREFERENCE) {
  //       return this.getSystemName(attrs.ReferencedSource);
  //     }
  //     if (attrs.ReferencedSource?.type === WEBIFC.IFCCLASSIFICATION) {
  //       return attrs.ReferencedSource.Name?.value;
  //     }
  //   }
  //   return null;
  // }
  // private getAllReferenceIdentifications(attrs: Record<string, any>) {
  //   if (attrs.type !== WEBIFC.IFCCLASSIFICATIONREFERENCE) return null;
  //   const identifications: string[] = [];
  //   if (attrs.Identification) identifications.push(attrs.Identification.value);
  //   if (attrs.ReferencedSource) {
  //     const identification = this.getAllReferenceIdentifications(
  //       attrs.ReferencedSource,
  //     );
  //     if (identification) identifications.push(...identification);
  //   }
  //   return identifications;
  // }
  // private evalSystem(attrs: Record<string, any>, checks?: IDSCheck[]) {
  //   const name = this.getSystemName(attrs);
  //   return this.evalRequirement(name, this.system, "System", checks);
  // }
  // private evalValue(attrs: any, checks?: IDSCheck[]) {
  //   if (!this.value) return true;
  //   const identifications = this.getAllReferenceIdentifications(attrs);
  //   if (!identifications) return false;
  //   const identifier = identifications.find((id) => {
  //     if (!this.value) return false;
  //     return this.evalRequirement(id, this.value, "Value");
  //   });
  //   if (checks) {
  //     this.addCheckResult(
  //       {
  //         parameter: "Value",
  //         currentValue: identifier ?? null,
  //         requiredValue: this.value,
  //         pass: !!identifier,
  //       },
  //       checks,
  //     );
  //   }
  //   return !!identifier;
  // }
  // private evalURI(attrs: any, checks?: IDSCheck[]) {
  //   if (!this.uri) return true;
  //   const result = this.evalRequirement(
  //     attrs.Location?.value,
  //     {
  //       type: "simple",
  //       parameter: this.uri,
  //     },
  //     "URI",
  //     checks,
  //   );
  //   return result;
  // }
}
class QIe extends uY {
  constructor(t, i) {
    super(t), tt(this, "facetType", "Entity"), tt(this, "name"), tt(this, "predefinedType"), this.name = i;
  }
  serialize(t) {
    const i = n6("Name", this.name), n = n6("Name", this.predefinedType);
    let s = "";
    return t === "requirement" && (s += `cardinality="${this.cardinality}"`, s += this.instructions ? `instructions="${this.instructions}"` : ""), `<entity ${s}>
  ${i}
  ${n}
</entity>`;
  }
  async getEntities(t, i) {
    const n = this._components.get(Io), s = /* @__PURE__ */ new Map();
    for (const [r, l] of n.list) {
      if (!t.find((I) => I.test(r)))
        continue;
      const h = await l.getCategories();
      for (const I of h) {
        if (!await this.evalName(I))
          continue;
        let y = s.get(r);
        y || (y = [], s.set(r, y)), y.push(I);
      }
    }
    const o = {};
    if (await Promise.all(
      Array.from(s.entries()).map(
        async ([r, l]) => {
          const c = n.list.get(r);
          if (!c)
            return;
          const h = l.map(
            (y) => new RegExp(`^${y}$`)
          ), I = await c.getItemsOfCategories(h), p = Object.values(I).flat();
          o[r] = new Set(p);
        }
      )
    ), !this.predefinedType) {
      TI.add(i, o);
      return;
    }
    for (const [r, l] of Object.entries(o)) {
      const c = n.list.get(r);
      if (!c)
        continue;
      const h = await c.getItemsData([...l]);
      for (const I of h) {
        if (!("value" in I._localId))
          continue;
        await this.evalPredefinedType(
          r,
          I
        ) && TI.append(i, r, I._localId.value);
      }
    }
  }
  async test(t, i, n) {
    const s = this._components.get(Io);
    for (const [o, r] of Object.entries(t)) {
      const l = s.list.get(o);
      if (!l)
        continue;
      const c = await l.getItemsData([...r]);
      for (const h of c) {
        if (!("value" in h._category))
          continue;
        const I = this.getItemChecks(
          i,
          o,
          h,
          n.skipIfFails
        );
        I && (await this.evalName(h._category.value, I), await this.evalPredefinedType(o, h, I));
      }
    }
  }
  async evalName(t, i) {
    return this.evalRequirement(t, this.name, "Name", i);
  }
  async evalPredefinedType(t, i, n) {
    if (!this.predefinedType || !("value" in i.PredefinedType))
      return null;
    const s = typeof this.predefinedType.parameter == "string" && this.predefinedType.parameter === "USERDEFINED";
    let o = i.PredefinedType.value;
    if (o === "USERDEFINED" && !s) {
      const c = Object.keys(i).find((h) => /^((?!Predefined).)*Type$/.test(h));
      if (c) {
        const h = i[c];
        "value" in h && (o = h.value);
      } else
        o = "USERDEFINED";
    }
    if (!o) {
      const c = this._components.get(Io).list.get(t);
      if (c && "value" in i._localId) {
        const [h] = await c.getItemsData([i._localId.value], {
          relations: { IsTypedBy: { attributes: !0, relations: !1 } }
        });
        if (Array.isArray(h.IsTypedBy)) {
          const I = h.IsTypedBy[0];
          if (I && "value" in I.PredefinedType && (o = I.PredefinedType.value, o === "USERDEFINED" && !s)) {
            const y = Object.keys(I).find(
              (m) => /^((?!Predefined).)*Type$/.test(m)
            );
            if (y) {
              const m = I[y];
              "value" in m && (o = m.value);
            } else
              o = "USERDEFINED";
          }
        }
      }
    }
    return this.evalRequirement(
      o,
      this.predefinedType,
      "PredefinedType",
      n
    );
  }
}
class pQe extends uY {
  constructor(t, i, n) {
    super(t), tt(this, "facetType", "Property"), tt(this, "propertySet"), tt(this, "baseName"), tt(this, "value"), tt(this, "dataType"), tt(this, "uri"), tt(this, "_unsupportedTypes", [
      "IFCCOMPLEXPROPERTY",
      "IFCPHYSICALCOMPLEXQUANTITY"
    ]), this.propertySet = i, this.baseName = n;
  }
  serialize(t) {
    const i = n6("PropertySet", this.propertySet), n = n6("BaseName", this.baseName), s = n6("Value", this.value), o = this.dataType ? `dataType=${this.dataType}` : "";
    let r = "";
    return t === "requirement" && (r += `cardinality="${this.cardinality}"`, r += this.uri ? `uri=${this.uri}` : "", r += this.instructions ? `instructions="${this.instructions}"` : ""), `<property ${o} ${r}>
  ${i}
  ${n}
  ${s}
</property>`;
  }
  async getEntities(t, i) {
    const n = this._components.get(Io);
    for (const [s, o] of n.list) {
      if (!t.find((I) => I.test(s)))
        continue;
      const l = await o.getItemsOfCategories([
        /PROPERTYSET/,
        /ELEMENTQUANTITY/
      ]), c = Object.values(l).flat();
      if (c.length === 0)
        continue;
      const h = await o.getItemsData(c, {
        relations: {
          HasProperties: { attributes: !0, relations: !1 },
          DefinesOcurrence: { attributes: !0, relations: !1 }
        }
      });
      for (const I of h) {
        if (!("value" in I._localId && "value" in I._category && "value" in I.Name && Array.isArray(I.DefinesOcurrence)) || !this.evalRequirement(
          I.Name.value,
          this.propertySet,
          "PropertySet"
        ))
          continue;
        let y;
        if (I._category.value === "IFCPROPERTYSET" && (y = "HasProperties"), I._category.value === "IFCELEMENTQUANTITY" && (y = "Quantities"), !y)
          continue;
        const m = I[y];
        if (Array.isArray(m))
          for (const A of m) {
            const C = Object.keys(A), O = C.find((P) => /Name/.test(P));
            if (!(O && "value" in A[O]))
              continue;
            const R = A[O];
            if (!("value" in R) || !this.evalRequirement(
              R.value,
              this.baseName,
              "BaseName"
            ))
              continue;
            if (this.value) {
              const P = C.find((re) => /Value/.test(re));
              if (!P)
                continue;
              const z = A[P];
              if (!("value" in z) || !this.evalRequirement(
                z.value,
                this.value,
                "Value"
              ))
                continue;
            }
            const L = I.DefinesOcurrence.map((P) => "value" in P._localId && typeof P._localId.value == "number" ? P._localId.value : null).filter((P) => P !== null);
            TI.append(i, s, ...L);
          }
      }
    }
  }
  async test(t, i, n = { skipIfFails: !0 }) {
    const s = this._components.get(Io);
    for (const [o, r] of Object.entries(t)) {
      const l = s.list.get(o);
      if (!l)
        continue;
      const c = await l.getItemsData([...r], {
        relations: {
          IsDefinedBy: { attributes: !0, relations: !0 },
          IsTypedBy: { attributes: !0, relations: !1 },
          HasPropertySets: { attributes: !0, relations: !0 },
          DefinesOcurrence: { attributes: !1, relations: !1 }
        }
      });
      for (const h of c) {
        const I = this.getItemChecks(
          i,
          o,
          h,
          n.skipIfFails
        );
        if (!I)
          continue;
        const y = (await this.getPsets(h)).filter((m) => !("value" in m.Name) || !this.evalRequirement(
          m.Name.value,
          this.propertySet,
          "PropertySet"
        ) ? !1 : (I.push({
          currentValue: m.Name.value,
          parameter: "PropertySet",
          pass: !0,
          requiredValue: this.propertySet
        }), !0));
        if (y.length === 0) {
          I.push({
            currentValue: null,
            parameter: "PropertySet",
            pass: !1,
            requiredValue: this.propertySet
          });
          continue;
        }
        for (const m of y) {
          const A = this.getPropertyListName(m);
          if (!A)
            continue;
          const C = m[A];
          if (!Array.isArray(C)) {
            I.push({
              currentValue: null,
              parameter: "BaseName",
              pass: !1,
              requiredValue: this.baseName
            });
            continue;
          }
          const O = C.filter((R) => !("value" in R._category && "value" in R.Name) || this._unsupportedTypes.includes(R._category.value) || !this.evalRequirement(
            R.Name.value,
            this.baseName,
            "BaseName"
          ) ? !1 : (I.push({
            currentValue: R.Name.value,
            parameter: "BaseName",
            pass: !0,
            requiredValue: this.baseName
          }), !0));
          if (O.length === 0) {
            I.push({
              currentValue: null,
              parameter: "BaseName",
              pass: !1,
              requiredValue: this.baseName
            });
            continue;
          }
          for (const R of O)
            this.evalValue(R, I), this.evalDataType(R, I), this.evalURI();
        }
      }
    }
  }
  getPropertyListName(t) {
    let i;
    return "value" in t._category && (t._category.value === "IFCPROPERTYSET" && (i = "HasProperties"), t._category.value === "IFCELEMENTQUANTITY" && (i = "Quantities")), i;
  }
  getValueKey(t) {
    return Object.keys(t).find(
      (i) => /Value/.test(i) || /Values/.test(i)
    );
  }
  getTypePsets(t) {
    if (!Array.isArray(t.IsTypedBy))
      return [];
    const [i] = t.IsTypedBy;
    return i && Array.isArray(i.HasPropertySets) ? i.HasPropertySets : [];
  }
  async getPsets(t) {
    const i = this.getTypePsets(t);
    if (!Array.isArray(t.IsDefinedBy))
      return i;
    const n = [];
    for (const s of t.IsDefinedBy) {
      if (!("value" in s.Name))
        continue;
      const o = s.Name.value, r = this.getPropertyListName(s);
      if (!(o && r))
        continue;
      const l = i.find((c) => "value" in c.Name ? c.Name.value === o : !1);
      if (l && Array.isArray(l.HasProperties) && Array.isArray(s.HasProperties))
        for (const c of l.HasProperties) {
          if (!("value" in c.Name))
            continue;
          const h = c.Name.value;
          s.HasProperties.find((p) => "value" in p.Name ? p.Name.value === h : !1) || s.HasProperties.push(c);
        }
      n.push(s);
    }
    return n;
  }
  // IFCPROPERTYBOUNDEDVALUE are not supported yet
  // IFCPROPERTYTABLEVALUE are not supported yet
  // TODO: Work must to be done to convert numerical value units to IDS-nominated standard units https://github.com/buildingSMART/IDS/blob/development/Documentation/UserManual/units.md
  evalValue(t, i) {
    const n = this.getValueKey(t), s = t[n];
    if (!("value" in s))
      return !1;
    if (this.value) {
      if (!n)
        return i == null || i.push({
          parameter: "Value",
          currentValue: null,
          pass: !1,
          requiredValue: this.value
        }), !1;
      const o = structuredClone(this.value);
      return s.type === "IFCLABEL" && o.type === "simple" && (o.parameter = String(o.parameter)), this.evalRequirement(
        s.value,
        o,
        "Value",
        i
      );
    }
    return n && typeof s.value == "string" && s.value.trim() === "" ? (i == null || i.push({
      parameter: "Value",
      currentValue: "",
      pass: !1,
      requiredValue: this.value
    }), !1) : !0;
  }
  evalDataType(t, i) {
    if (!this.dataType)
      return !0;
    const n = this.getValueKey(t);
    if (!(n && "value" in t[n]))
      return i == null || i.push({
        parameter: "DataType",
        currentValue: null,
        pass: !1,
        requiredValue: this.dataType
      }), !1;
    const s = t[n];
    return this.evalRequirement(
      s.type ?? null,
      {
        type: "simple",
        parameter: this.dataType
      },
      "DataType",
      i
    );
  }
  evalURI() {
    return !0;
  }
}
class mQe extends uY {
  constructor() {
    super(...arguments), tt(this, "_ifcMaterialEntities", [
      /^IFCMATERIALLAYERSETUSAGE$/,
      /^IFCMATERIALCONSTITUENTSET$/,
      /^IFCMATERIAL$/,
      /^IFCMATERIALLIST$/
    ]), tt(this, "facetType", "Material"), tt(this, "value"), tt(this, "uri");
  }
  serialize(t) {
    if (!(this.value && this.uri))
      return "<material />";
    const i = n6("Value", this.value);
    let n = "";
    return t === "requirement" && (n += `cardinality="${this.cardinality}"`, n += this.uri ? `uri=${this.uri}` : "", n += this.instructions ? `instructions="${this.instructions}"` : ""), `<material ${n}>
  ${i}
</material>`;
  }
  async getEntities(t, i) {
    const n = this._components.get(Io);
    for (const [s, o] of n.list) {
      if (!t.find((I) => I.test(s)))
        continue;
      const l = await o.getItemsOfCategories(this._ifcMaterialEntities), c = Object.values(l).flat();
      if (c.length === 0)
        continue;
      const h = await o.getItemsData(c, {
        relations: {
          AssociatedTo: { attributes: !0, relations: !1 },
          MaterialConstituents: { attributes: !0, relations: !0 },
          ForLayerSet: { attributes: !0, relations: !0 },
          MaterialLayers: { attributes: !0, relations: !0 },
          Materials: { attributes: !0, relations: !1 }
        }
      });
      for (const I of h) {
        if (!("value" in I._localId && "value" in I._category && Array.isArray(I.AssociatedTo)) || !this.hasValidMaterial(I))
          continue;
        const y = I.AssociatedTo.map((m) => "value" in m._localId && m._localId.value ? m._localId.value : null).filter((m) => m !== null);
        TI.append(i, s, ...y);
      }
    }
  }
  async test(t, i, n = { skipIfFails: !0 }) {
    const s = this._components.get(Io);
    for (const [o, r] of Object.entries(t)) {
      const l = s.list.get(o);
      if (!l)
        continue;
      const c = await l.getItemsData([[...r][0]], {
        relations: {
          AssociatedTo: { attributes: !1, relations: !1 },
          HasAssociations: { attributes: !0, relations: !0 },
          MaterialConstituents: { attributes: !0, relations: !0 },
          ForLayerSet: { attributes: !0, relations: !0 },
          MaterialLayers: { attributes: !0, relations: !0 },
          Materials: { attributes: !0, relations: !1 }
        }
      });
      for (const h of c) {
        const I = this.getItemChecks(
          i,
          o,
          h,
          n.skipIfFails
        );
        if (I) {
          if (!Array.isArray(h.HasAssociations)) {
            I.push({
              parameter: null,
              currentValue: null,
              requiredValue: this.value,
              pass: !1
            });
            continue;
          }
          for (const p of h.HasAssociations) {
            if (!this._ifcMaterialEntities.some((m) => "value" in p._category ? m.test(p._category.value) : !1))
              continue;
            if (this.hasValidMaterial(p, I))
              break;
          }
        }
      }
    }
  }
  hasValidMaterial(t, i) {
    let n = !1;
    if ("value" in t._category && t._category.value === "IFCMATERIAL")
      this.evalValue(t, i) && (n = !0);
    else
      for (const [s, o] of Object.entries(t))
        if ([
          "ForLayerSet",
          "MaterialLayers",
          "Material",
          "MaterialConstituents",
          "Materials"
        ].includes(s) && Array.isArray(o)) {
          for (const r of o)
            if ("value" in r._category && r._category.value === "IFCMATERIAL") {
              if (this.evalValue(r, i)) {
                n = !0;
                break;
              }
            } else if (this.hasValidMaterial(r)) {
              n = !0;
              break;
            }
        }
    return n;
  }
  evalValue(t, i) {
    if (!this.value)
      return i == null || i.push({
        parameter: null,
        currentValue: t.Name && "value" in t.Name ? t.Name.value : null,
        pass: !0
      }), !0;
    if (!("value" in t._category && t._category.value === "IFCMATERIAL"))
      return null;
    let n = !1;
    return t.Name && "value" in t.Name && (n = this.evalRequirement(
      t.Name.value,
      this.value,
      "Value",
      i
    )), n || (t.Category && "value" in t.Category && (n = this.evalRequirement(
      t.Category.value,
      this.value,
      "Value",
      i
    )), n);
  }
}
class yQe extends uY {
  constructor(t, i) {
    super(t), tt(this, "facetType", "PartOf"), tt(this, "_entityFacet"), tt(this, "_entity"), tt(this, "relation"), tt(this, "cardinality", "required"), this._entity = i, this._entityFacet = new QIe(t, i.name), this._entityFacet.predefinedType = i.predefinedType;
  }
  set entity(t) {
    this._entity = t;
    const { name: i, predefinedType: n } = t;
    this._entityFacet = new QIe(this._components, i), this._entityFacet.predefinedType = n;
  }
  get entity() {
    return this._entity;
  }
  serialize() {
    return "";
  }
  async getEntities(t, i) {
  }
  async test(t) {
  }
}
class EQe {
  constructor(t, i, n) {
    tt(this, "name"), tt(this, "ifcVersion", /* @__PURE__ */ new Set()), tt(this, "identifier", y4.create()), tt(this, "description"), tt(this, "instructions"), tt(this, "requirementsDescription"), tt(this, "applicability", new OA()), tt(this, "requirements", new OA()), tt(this, "components"), this.components = t, this.name = i;
    for (const s of n)
      this.ifcVersion.add(s);
  }
  set(t) {
    const i = t, n = this;
    for (const o in t) {
      if (o === "identifier")
        continue;
      const r = i[o];
      o in this && (n[o] = r);
    }
    return this.components.get(gQe).list.set(this.identifier, this), this;
  }
  /**
   * Tests the model to test against the specification's requirements.
   *
   * @param modelId - The modelId of the model to be tested.
   * @returns An array representing the test results.
   * If no requirements are defined for the specification, an empty array is returned.
   */
  async test(t, i = { skipIfFails: !0 }) {
    const n = new f0();
    if (this.requirements.size === 0)
      return n;
    const s = {}, o = [];
    for (const l of this.applicability)
      o.push(l.getEntities(t, s));
    await Promise.all(o);
    const r = [];
    for (const l of this.requirements)
      r.push(l.test(s, n, i));
    return await Promise.all(r), n;
  }
  /**
   * Serializes the IDSSpecification instance into XML format.
   *
   * @remarks This method is not meant to be used directly. It is used by the IDSSpecifications component.
   *
   * @returns The XML representation of the IDSSpecification.
   */
  serialize() {
    const t = `name="${this.name}"`, i = this.identifier ? `identifier="${this.identifier}"` : "", n = this.description ? `description="${this.description}"` : "", s = this.instructions ? `instructions="${this.instructions}"` : "";
    return `<specification ifcVersion="${[...this.ifcVersion].join(" ")}" ${t} ${i} ${n} ${s}>
      <applicability minOccurs="1" maxOccurs="unbounded">
        ${[...this.applicability].map((r) => r.serialize("applicability")).join(`
`)}
      </applicability>
      <requirements>
        ${[...this.requirements].map((r) => r.serialize("requirement")).join(`
`)}
      </requirements>
    </specification>`;
  }
}
const U5 = (e) => {
  if (!e)
    return;
  const t = {};
  if ("simpleValue" in e && (t.type = "simple", t.parameter = e.simpleValue), "restriction" in e) {
    const i = e.restriction, n = Object.keys(i);
    if ("pattern" in i && (t.type = "pattern", t.parameter = i.pattern.value), "enumeration" in i) {
      t.type = "enumeration";
      const s = i.enumeration.map(
        ({ value: o }) => i.base.includes("string") ? String(o) : i.base.includes("integer") || i.base.includes("double") ? Number(o) : o
      );
      t.parameter = s;
    }
    if (n.some(
      (s) => [
        "minInclusive",
        "minExclusive",
        "maxInclusive",
        "maxExclusive"
      ].includes(s)
    )) {
      t.type = "bounds";
      const s = {}, o = n.find((l) => l.includes("min")), r = n.find((l) => l.includes("max"));
      o && (s.minInclusive = o === "minInclusive", s.min = i[o].value), r && (s.maxInclusive = r === "maxInclusive", s.max = i[r].value), t.parameter = s;
    }
    if (n.some((s) => ["minLength", "length", "maxLength"].includes(s))) {
      t.type = "length";
      const s = {};
      i.length !== void 0 && (s.length = i.length.value), i.minLength !== void 0 && (s.min = i.minLength.value), i.maxLength !== void 0 && (s.max = i.maxLength.value), t.parameter = s;
    }
  }
  if (t.parameter !== void 0)
    return t;
}, N2e = (e, t) => {
  const i = [];
  for (const n of t) {
    const s = n.name, o = U5(s);
    if (!o)
      continue;
    const r = new QIe(e, o);
    n.cardinality && (r.cardinality = n.cardinality), r.predefinedType = U5(n.predefinedType), r.instructions = n.instructions, i.push(r);
  }
  return i;
}, D2e = (e, t) => {
  const i = [];
  for (const n of t) {
    const s = n.name, o = U5(s);
    if (!o)
      continue;
    const r = new fQe(e, o);
    n.cardinality && (r.cardinality = n.cardinality), r.value = U5(n.value), r.instructions = n.instructions, i.push(r);
  }
  return i;
}, C2e = (e, t) => {
  const i = [];
  for (const n of t) {
    const s = new mQe(e);
    n.cardinality && (s.cardinality = n.cardinality);
    const o = U5(n.value);
    (o == null ? void 0 : o.type) === "enumeration" && Array.isArray(o.parameter) && (o.parameter = o.parameter.map(String)), s.value = o, s.uri = n.uri, s.instructions = n.instructions, i.push(s);
  }
  return i;
}, O2e = (e, t) => {
  const i = [];
  for (const n of t) {
    const s = n.propertySet, o = n.baseName, r = U5(s), l = U5(o);
    if (!(l && r))
      continue;
    const c = new pQe(e, r, l);
    n.cardinality && (c.cardinality = n.cardinality);
    const h = U5(n.value);
    c.value = h, c.dataType = n.dataType, c.uri = n.uri, c.instructions = n.instructions, i.push(c);
  }
  return i;
}, L2e = (e, t) => {
  const i = [];
  for (const n of t) {
    const s = n.system, o = U5(s);
    if (!o)
      continue;
    const r = new IQe(e, o);
    n.cardinality && (r.cardinality = n.cardinality);
    const l = U5(n.value);
    (l == null ? void 0 : l.type) === "simple" && (l.parameter = String(l.parameter)), (l == null ? void 0 : l.type) === "enumeration" && Array.isArray(l.parameter) && (l.parameter = l.parameter.map(String)), r.value = l, r.uri = n.uri, r.instructions = n.instructions, i.push(r);
  }
  return i;
}, _2e = (e, t) => {
  const i = [];
  for (const n of t) {
    const s = U5(n.entity.name);
    if (!s)
      continue;
    const o = U5(
      n.entity.predefinedType
    ), r = new yQe(e, {
      name: s,
      predefinedType: o
    });
    r.relation = n.relation, n.cardinality && (r.cardinality = n.cardinality), r.instructions = n.instructions, i.push(r);
  }
  return i;
}, jme = class JIe extends bI {
  constructor(t) {
    super(t), tt(this, "enabled", !0), tt(this, "IDSInfo"), tt(this, "list", new f0()), t.add(JIe.uuid, this);
  }
  /**
   * Processes the results of an IDS check and categorizes the items into passing and failing.
   *
   * @param result - An `IDSCheckResult` object containing the check results for various model IDs.
   * @returns An object containing two `ModelIdMap` objects:
   *          - `pass`: A ModelIdMap representing items that passed the check.
   *          - `fail`: A ModelIdMap representing items that failed the check.
   */
  getModelIdMap(t) {
    const i = {}, n = {};
    for (const [s, o] of t) {
      const l = [...o].filter(([, I]) => I.pass).map(([I]) => I);
      TI.append(i, s, ...l);
      const h = [...o].filter(([, I]) => !I.pass).map(([I]) => I);
      TI.append(n, s, ...h);
    }
    return { pass: i, fail: n };
  }
  /**
   * Creates a new IDSSpecification instance and adds it to the list.
   *
   * @param name - The name of the IDSSpecification.
   * @param ifcVersion - An array of IfcVersion values that the specification supports.
   *
   * @returns The newly created IDSSpecification instance.
   */
  create(t, i, n) {
    const s = new EQe(
      this.components,
      t,
      i
    );
    return n && (s.identifier = n), this.list.set(s.identifier, s), s;
  }
  /**
   * Parses and processes an XML string containing Information Delivery Specification (IDS) data.
   * It creates IDSSpecification instances based on the parsed data and returns them in an array.
   * Also, the instances are added to the list array.
   *
   * @param data - The XML string to parse.
   *
   * @returns An array of IDSSpecification instances created from the parsed data.
   */
  load(t) {
    const i = [], n = JIe.xmlParser.parse(t).ids, { specifications: s, info: o } = n;
    if (this.IDSInfo = { ...o }, s && s.specification) {
      const r = Array.isArray(s.specification) ? s.specification : [s.specification];
      for (const l of r) {
        const { name: c, ifcVersion: h, description: I, instructions: p, identifier: y } = l;
        if (!(c && h))
          continue;
        const m = [], A = [], { applicability: C, requirements: O } = l;
        if (C) {
          const { maxOccurs: L, ...P } = C, z = Array.isArray(P) ? P : [P];
          for (const W of z)
            for (const re in W) {
              const ce = Array.isArray(W[re]) ? W[re] : [W[re]];
              if (re === "entity") {
                const te = N2e(this.components, ce);
                m.push(...te);
              }
              if (re === "attribute") {
                const te = D2e(this.components, ce);
                m.push(...te);
              }
              if (re === "material") {
                const te = C2e(this.components, ce);
                m.push(...te);
              }
              if (re === "classification") {
                const te = L2e(
                  this.components,
                  ce
                );
                m.push(...te);
              }
              if (re === "property") {
                const te = O2e(this.components, ce);
                m.push(...te);
              }
              if (re === "partOf") {
                const te = _2e(this.components, ce);
                m.push(...te);
              }
            }
        }
        let R;
        if (O) {
          const { maxOccurs: L, ...P } = O;
          R = O.description;
          const z = Array.isArray(P) ? P : [P];
          for (const W of z)
            for (const re in W) {
              const ce = Array.isArray(W[re]) ? W[re] : [W[re]];
              if (re === "entity") {
                const te = N2e(this.components, ce);
                A.push(...te);
              }
              if (re === "attribute") {
                const te = D2e(this.components, ce);
                A.push(...te);
              }
              if (re === "material") {
                const te = C2e(this.components, ce);
                A.push(...te);
              }
              if (re === "classification") {
                const te = L2e(
                  this.components,
                  ce
                );
                A.push(...te);
              }
              if (re === "property") {
                const te = O2e(this.components, ce);
                A.push(...te);
              }
              if (re === "partOf") {
                const te = _2e(this.components, ce);
                A.push(...te);
              }
            }
        }
        const F = this.create(
          c,
          h.split(/\s+/),
          y
        );
        F.description = I, F.instructions = p, F.requirementsDescription = R, F.applicability.add(...m), F.requirements.add(...A), i.push(F);
      }
    }
    return i;
  }
  /**
   * Exports the IDSSpecifications data into an XML string.
   *
   * @param info - The metadata information for the exported XML.
   * @param specifications - An optional iterable of IDSSpecification instances to export.
   * If not provided, all specifications in the list will be exported.
   *
   * @returns A string containing the exported IDSSpecifications data in XML format.
   */
  export(t, i = this.list.values()) {
    const n = i ?? this.list;
    return `<ids xmlns:xs="http://www.w3.org/2001/XMLSchema" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://standards.buildingsmart.org/IDS http://standards.buildingsmart.org/IDS/1.0/ids.xsd" xmlns:ids="http://standards.buildingsmart.org/IDS">
  <!-- Made with That Open Engine ${Gme.release} (https://github.com/thatopen/engine_components) -->
  <info>
    <title>${t.title}</title>
    ${t.copyright ? `<copyright>${t.copyright}</copyright>` : ""}
    ${t.version ? `<version>${t.version}</version>` : ""}
    ${t.description ? `<description>${t.description}</description>` : ""}
    ${t.author ? `<author>${t.author}</author>` : ""}
    ${t.date ? `<date>${t.date.toISOString().split("T")[0]}</date>` : ""}
    ${t.purpose ? `<purpose>${t.purpose}</purpose>` : ""}
    ${t.milestone ? `<milestone>${t.milestone}</milestone>` : ""}
  </info>
  <specifications>
    ${[...n].map((o) => o.serialize()).join(`
`)}
  </specifications>
</ids>`;
  }
};
tt(jme, "uuid", "9f0b9f78-9b2e-481a-b766-2fbfd01f342c");
tt(jme, "xmlParser", new vue.XMLParser({
  allowBooleanAttributes: !0,
  attributeNamePrefix: "",
  ignoreAttributes: !1,
  ignoreDeclaration: !0,
  ignorePiTags: !0,
  numberParseOptions: { leadingZeros: !0, hex: !0 },
  parseAttributeValue: !0,
  preserveOrder: !1,
  processEntities: !1,
  removeNSPrefix: !0,
  trimValues: !0
}));
let gQe = jme;
const wQe = class eNe extends bI {
  constructor(t) {
    super(t), tt(this, "enabled", !0), t.add(eNe.uuid, this);
  }
  /**
   * Utility method to calculate the distance from a point to a line segment.
   *
   * @param point - The point from which to calculate the distance.
   * @param lineStart - The start point of the line segment.
   * @param lineEnd - The end point of the line segment.
   * @param clamp - If true, the distance will be clamped to the line segment's length.
   * @returns The distance from the point to the line segment.
   */
  static distanceFromPointToLine(t, i, n, s = !1) {
    const o = new gc(), r = new Ge();
    return o.set(i, n), o.closestPointToPoint(t, s, r), r.distanceTo(t);
  }
  // /**
  //  * Method to get the face of a mesh that contains a given triangle index.
  //  * It also returns the edges of the found face and their indices.
  //  *
  //  * @param mesh - The mesh to get the face from. It must be indexed.
  //  * @param triangleIndex - The index of the triangle within the mesh.
  //  * @param instance - The instance of the mesh (optional).
  //  * @returns An object containing the edges of the found face and their indices, or null if no face was found.
  //  */
  // getFace(
  //   mesh: THREE.InstancedMesh | THREE.Mesh,
  //   triangleIndex: number,
  //   instance?: number,
  // ) {
  //   if (!mesh.geometry.index) {
  //     throw new Error("Geometry must be indexed!");
  //   }
  //   const allEdges = new Map<string, MeasureEdge>();
  //   const indices = mesh.geometry.index.array;
  //   // Find out the raycasted face plane
  //   const { plane: targetPlane } = this.getFaceData(
  //     triangleIndex,
  //     instance,
  //     mesh,
  //   );
  //   // Get the face where the given triangle belongs
  //   const coplanarFacesIndices: {
  //     index: number;
  //     edges: { id: string; distance: number; points: THREE.Vector3[] }[];
  //   }[] = [];
  //   for (let faceIndex = 0; faceIndex < indices.length / 3; faceIndex++) {
  //     const { plane, edges } = this.getFaceData(faceIndex, instance, mesh);
  //     if (plane.equals(targetPlane)) {
  //       coplanarFacesIndices.push({ index: faceIndex, edges });
  //       for (const { id, points, distance } of edges) {
  //         allEdges.set(id, { points, distance });
  //       }
  //     }
  //   }
  //   // Now, let's get all faces (groups of adjacent triangles)
  //   // To visualize this, draw all possible cases on paper, it's easy
  //   let nextFaceID = 0;
  //   const edgeFaceMap = new Map<string, number>();
  //   const faceEdgesMap = new Map<
  //     number,
  //     { edges: Set<string>; indices: Set<number> }
  //   >();
  //   for (const { index, edges } of coplanarFacesIndices) {
  //     const commonEdgesFaces = new Map<string, number>();
  //     for (const { id: edge } of edges) {
  //       if (edgeFaceMap.has(edge)) {
  //         const commonFace = edgeFaceMap.get(edge) as number;
  //         commonEdgesFaces.set(edge, commonFace);
  //       }
  //     }
  //     const edgesIDs = edges.map((edge) => edge.id);
  //     // Triangle is isolated, just create a new face
  //     if (!commonEdgesFaces.size) {
  //       const faceID = nextFaceID++;
  //       for (const { id: edge } of edges) {
  //         edgeFaceMap.set(edge, faceID);
  //       }
  //       faceEdgesMap.set(faceID, {
  //         edges: new Set(edgesIDs),
  //         indices: new Set([index]),
  //       });
  //       continue;
  //     }
  //     // Triangle has common edges with existing faces
  //     let firstFaceID: number | null = null;
  //     const otherFaces = new Set<number>();
  //     const edgesToAdd = new Set(edgesIDs);
  //     // First, remove all common edges
  //     for (const [edge, faceID] of commonEdgesFaces) {
  //       if (firstFaceID === null) {
  //         firstFaceID = faceID;
  //       } else if (faceID !== firstFaceID) {
  //         otherFaces.add(faceID);
  //       }
  //       edgeFaceMap.delete(edge);
  //       const { edges: foundFaceEdges } = faceEdgesMap.get(faceID)!;
  //       foundFaceEdges.delete(edge);
  //       edgesToAdd.delete(edge);
  //     }
  //     // If we hadn't found a face, we wouldn't be here
  //     if (firstFaceID === null) {
  //       throw new Error("Error computing face!");
  //     }
  //     // Now, let's merge this triangle with the first face
  //     const firstFace = faceEdgesMap.get(firstFaceID)!;
  //     const { indices: firstFaceIndices } = firstFace;
  //     firstFaceIndices.add(index);
  //     for (const edge of edgesToAdd) {
  //       edgeFaceMap.set(edge, firstFaceID);
  //       const { edges: firstFaceEdges } = firstFace;
  //       firstFaceEdges.add(edge);
  //     }
  //     // Finally, if there were other faces in common
  //     // merge them with the first one
  //     for (const faceID of otherFaces) {
  //       const otherFace = faceEdgesMap.get(faceID)!;
  //       const { edges: otherEdges, indices: otherIndices } = otherFace;
  //       const firstFace = faceEdgesMap.get(firstFaceID)!;
  //       const { edges: firstEdges, indices: firstIndices } = firstFace;
  //       for (const edge of otherEdges) {
  //         firstEdges.add(edge);
  //         edgeFaceMap.set(edge, firstFaceID);
  //       }
  //       for (const index of otherIndices) {
  //         firstIndices.add(index);
  //       }
  //       faceEdgesMap.delete(faceID);
  //     }
  //   }
  //   for (const [_faceID, { indices, edges }] of faceEdgesMap) {
  //     if (indices.has(triangleIndex)) {
  //       const foundEdges: MeasureEdge[] = [];
  //       for (const edgeID of edges) {
  //         const foundEdge = allEdges.get(edgeID)!;
  //         foundEdges.push(foundEdge);
  //       }
  //       return { edges: foundEdges, indices };
  //     }
  //   }
  //   return null;
  // }
  // /**
  //  * Method to get the vertices and normal of a mesh face at a given index.
  //  * It also applies instance transformation if provided.
  //  *
  //  * @param mesh - The mesh to get the face from. It must be indexed.
  //  * @param faceIndex - The index of the face within the mesh.
  //  * @param instance - The instance of the mesh (optional).
  //  * @returns An object containing the vertices and normal of the face.
  //  * @throws Will throw an error if the geometry is not indexed.
  //  */
  // getVerticesAndNormal(
  //   mesh: THREE.Mesh | THREE.InstancedMesh,
  //   faceIndex: number,
  //   instance: number | undefined,
  // ) {
  //   if (!mesh.geometry.index) {
  //     throw new Error("Geometry must be indexed!");
  //   }
  //   const indices = mesh.geometry.index.array;
  //   const pos = mesh.geometry.attributes.position.array;
  //   const nor = mesh.geometry.attributes.normal.array;
  //   const i1 = indices[faceIndex * 3] * 3;
  //   const i2 = indices[faceIndex * 3 + 1] * 3;
  //   const i3 = indices[faceIndex * 3 + 2] * 3;
  //   const p1 = new THREE.Vector3(pos[i1], pos[i1 + 1], pos[i1 + 2]);
  //   const p2 = new THREE.Vector3(pos[i2], pos[i2 + 1], pos[i2 + 2]);
  //   const p3 = new THREE.Vector3(pos[i3], pos[i3 + 1], pos[i3 + 2]);
  //   const n1 = new THREE.Vector3(nor[i1], nor[i1 + 1], nor[i1 + 2]);
  //   const n2 = new THREE.Vector3(nor[i2], nor[i2 + 1], nor[i2 + 2]);
  //   const n3 = new THREE.Vector3(nor[i3], nor[i3 + 1], nor[i3 + 2]);
  //   const averageNx = (n1.x + n2.x + n3.x) / 3;
  //   const averageNy = (n1.y + n2.y + n3.y) / 3;
  //   const averageNz = (n1.z + n2.z + n3.z) / 3;
  //   const faceNormal = new THREE.Vector3(averageNx, averageNy, averageNz);
  //   // Apply instance transformation to vertex and normal
  //   if (instance !== undefined && mesh instanceof THREE.InstancedMesh) {
  //     const transform = new THREE.Matrix4();
  //     mesh.getMatrixAt(instance, transform);
  //     const rotation = new THREE.Matrix4();
  //     rotation.extractRotation(transform);
  //     faceNormal.applyMatrix4(rotation);
  //     p1.applyMatrix4(transform);
  //     p2.applyMatrix4(transform);
  //     p3.applyMatrix4(transform);
  //   }
  //   return { p1, p2, p3, faceNormal };
  // }
  /**
   * Method to round the vector's components to a specified number of decimal places.
   * This is used to ensure numerical precision in edge detection.
   *
   * @param vector - The vector to round.
   * @returns The vector with rounded components.
   */
  round(t) {
    t.x = Math.trunc(t.x * 1e3) / 1e3, t.y = Math.trunc(t.y * 1e3) / 1e3, t.z = Math.trunc(t.z * 1e3) / 1e3;
  }
  /**
   * @deprecated Use {@link getItemsVolume} instead.
   *
   * Calculates the volume of a set of items.
   */
  async getVolumeFromFragments(t) {
    return console.warn(
      "getVolumeFromFragments is deprecated. Use getItemsVolume instead."
    ), this.getItemsVolume(t);
  }
  /**
   * Calculates the total volume of items for a given map of model IDs to local IDs.
   * @param modelIdMap A map where the key is the model ID and the value is an array of local IDs.
   * @returns A promise that resolves to the total volume of the specified items.
   */
  async getItemsVolume(t) {
    let i = 0;
    const n = this.components.get(Io);
    for (const [s, o] of Object.entries(t)) {
      const r = n.list.get(s);
      r && (i += await r.getItemsVolume([...o]));
    }
    return i;
  }
  // private getFaceData(
  //   faceIndex: number,
  //   instance: number | undefined,
  //   mesh: THREE.Mesh | THREE.InstancedMesh,
  // ) {
  //   const found = this.getVerticesAndNormal(mesh, faceIndex, instance);
  //   const { p1, p2, p3, faceNormal } = found;
  //   // Round numbers to make sure numerical precision
  //   // doesn't affect edge detection
  //   this.round(p1);
  //   this.round(p2);
  //   this.round(p3);
  //   this.round(faceNormal);
  //   // To make sure the edge AB === the edge BA
  //   const vertices = [
  //     { id: `${p1.x}|${p1.y}|${p1.z}`, value: p1 },
  //     { id: `${p2.x}|${p2.y}|${p2.z}`, value: p2 },
  //     { id: `${p3.x}|${p3.y}|${p3.z}`, value: p3 },
  //   ];
  //   vertices.sort((a, b) => {
  //     if (a.id < b.id) {
  //       return -1;
  //     }
  //     if (a.id > b.id) {
  //       return 1;
  //     }
  //     return 0;
  //   });
  //   const [
  //     { id: id1, value: v1 },
  //     { id: id2, value: v2 },
  //     { id: id3, value: v3 },
  //   ] = vertices;
  //   // Create IDs to identify the edges
  //   const edges = [
  //     {
  //       id: `${id1}|${id2}`,
  //       distance: v1.distanceTo(v2),
  //       points: [v1, v2],
  //     },
  //     {
  //       id: `${id2}|${id3}`,
  //       distance: v2.distanceTo(v3),
  //       points: [v2, v3],
  //     },
  //     {
  //       id: `${id1}|${id3}`,
  //       distance: v1.distanceTo(v3),
  //       points: [v1, v3],
  //     },
  //   ];
  //   const plane = new THREE.Plane();
  //   plane.setFromNormalAndCoplanarPoint(faceNormal, p1);
  //   plane.constant = Math.round(plane.constant * 10) / 10;
  //   return { plane, edges };
  // }
  /**
   * Converts a value from one unit to another for length, area, or volume without using external libraries.
   *
   * @param value - The value to convert.
   * @param fromUnit - The unit of the input value (e.g., "m", "cm", "mm" for lengths; "m2", "cm2" for areas; "m3", "cm3" for volumes).
   * @param toUnit - The unit to convert to (e.g., "cm", "mm", "m" for lengths; "cm2", "m2" for areas; "cm3", "m3" for volumes).
   * @param precision - The number of decimal places to round the result to, as number between 0 and 5. (default is 2).
   * @throws {Error} If the rounding value is not a valid integer or is out of range (0-5).
   * @returns The converted value rounded to the specified precision.
   */
  static convertUnits(t, i, n, s = 2) {
    const o = {
      // Length
      m: 1,
      cm: 0.01,
      mm: 1e-3,
      km: 1e3,
      // Area
      m2: 1,
      cm2: 1e-4,
      mm2: 1e-6,
      km2: 1e6,
      // Volume
      m3: 1,
      cm3: 1e-6,
      mm3: 1e-9,
      km3: 1e9
    };
    if (!o[i] || !o[n])
      throw new Error("Invalid units provided for conversion.");
    if (!Number.isInteger(s) || s < 0 || s > 5)
      throw new Error("Precision must be an integer between 0 and 5.");
    let r = o[i] / o[n];
    const l = t * r, c = 10 ** s;
    return Math.round(l * c) / c;
  }
};
tt(wQe, "uuid", "267ca032-672f-4cb0-afa9-d24e904f39d6");
function TQe({ fileUrl: e, containerRef: t }) {
  const [i, n] = Is(null), [s, o] = Is(
    null
  ), [r, l] = Is(!0), [c, h] = Is(null), [I, p] = Is(0), [y, m] = Is(
    "downloading"
  ), [A, C] = Is(!1), [O, R] = Is(null), F = io(!1), L = io(!1);
  return J4e(() => F.current || !t.current ? void 0 : ((async () => {
    var z, W, re, ce;
    F.current = !0;
    try {
      l(!0), h(null), m("downloading"), p(0);
      const te = new Gme(), Ne = te.get(Ume).create();
      Ne.scene = new MKe(te), Ne.scene.setup(), Ne.scene.three.background = new Xn("#ffffff"), Ne.renderer = new UKe(te, t.current), Ne.camera = new qW(te), te.init();
      const pe = await (await fetch("https://thatopen.github.io/engine_fragment/resources/worker.mjs")).blob(), je = new File([pe], "worker.mjs", {
        type: "text/javascript"
      }), Ve = URL.createObjectURL(je), $e = te.get(Io);
      (z = $e.init) == null || z.call($e, Ve), (ce = (re = (W = $e.list) == null ? void 0 : W.onItemSet) == null ? void 0 : re.add) == null || ce.call(re, ({ value: Rt }) => {
        var mt, Et, it;
        const ze = Rt;
        (mt = ze.useCamera) == null || mt.call(ze, Ne.camera.three), ze.object && Ne.scene.three.add(ze.object), setTimeout(() => {
          Ne.camera.controls.setLookAt(100, 70, 100, 0, 0, 0);
        }, 100), (it = (Et = $e.core) == null ? void 0 : Et.update) == null || it.call(Et, !0);
      }), Ne.camera.controls.addEventListener("rest", () => {
        var Rt, ze;
        (ze = (Rt = $e.core) == null ? void 0 : Rt.update) == null || ze.call(Rt, !0);
      }), await te.get(jwe).setup({
        autoSetWasm: !1,
        wasm: {
          path: "https://unpkg.com/web-ifc@0.0.69/",
          absolute: !0
        }
      }), n(te), o(Ne);
    } catch (te) {
      h(te instanceof Error ? te : new Error("Failed to initialize viewer")), l(!1);
    }
  })(), () => {
    if (s)
      try {
        s.dispose();
      } catch (z) {
        console.warn("[IFC] Error disposing world:", z);
      }
  }), [t, s]), vr(() => {
    if (!i || !s || !e || L.current)
      return;
    (async () => {
      var z;
      if (!L.current) {
        L.current = !0;
        try {
          m("downloading"), p(0);
          const W = await fetch(e);
          if (!W.ok)
            throw new Error(`Failed to fetch IFC file: ${W.statusText}`);
          const re = W.headers.get("Content-Length"), ce = re ? parseInt(re, 10) : 0;
          if (ce > 0) {
            const $e = ce / 1048576;
            R(Math.round($e * 10) / 10), $e >= 30 && C(!0);
          }
          if (!W.body)
            throw new Error("Response body is null");
          const te = W.body.getReader(), ee = [];
          let Ne = 0;
          for (; ; ) {
            const { done: $e, value: vt } = await te.read();
            if ($e)
              break;
            if (ee.push(vt), Ne += vt.length, ce > 0) {
              const Rt = Math.round(Ne / ce * 100);
              p(Rt);
            }
          }
          const Ae = ee.reduce(($e, vt) => $e + vt.length, 0), Oe = new Uint8Array(Ae);
          let pe = 0;
          for (const $e of ee)
            Oe.set($e, pe), pe += $e.length;
          m("loading");
          const je = i.get(jwe);
          await new Promise(($e) => setTimeout($e, 100));
          const Ve = await ((z = je.load) == null ? void 0 : z.call(je, Oe, !1, "example"));
          Ve != null && Ve.object && s.scene.three.add(Ve.object), m("complete"), l(!1);
        } catch (W) {
          h(W instanceof Error ? W : new Error("Failed to load IFC file")), l(!1);
        } finally {
          L.current = !1;
        }
      }
    })();
  }, [i, s, e]), {
    components: i,
    world: s,
    loading: r,
    error: c,
    downloadProgress: I,
    currentStep: y,
    isLargeFile: A,
    fileSizeMB: O
  };
}
const RQe = ({
  downloadProgress: e,
  currentStep: t,
  isLargeFile: i = !1
}) => {
  const { t: n } = M8(), s = Math.round(e), o = 28, r = 2 * Math.PI * o, l = r - e / 100 * r, c = () => {
    switch (t) {
      case "downloading":
        return n("ifc.loading.downloading");
      case "loading":
        return n("ifc.loading.loading_model");
      default:
        return n("ifc.loading.complete");
    }
  };
  return /* @__PURE__ */ He.jsxs("div", { className: "fc:flex fc:flex-col fc:items-center fc:justify-center fc:h-full fc:w-full", children: [
    t === "downloading" ? /* @__PURE__ */ He.jsxs("div", { className: "fc:relative", children: [
      /* @__PURE__ */ He.jsxs("svg", { width: "80", height: "80", className: "fc:transform fc:-rotate-90", children: [
        /* @__PURE__ */ He.jsx("circle", { cx: "40", cy: "40", r: o, stroke: "#e5e7eb", strokeWidth: "4", fill: "none" }),
        /* @__PURE__ */ He.jsx(
          "circle",
          {
            cx: "40",
            cy: "40",
            r: o,
            stroke: "#3b82f6",
            strokeWidth: "4",
            fill: "none",
            strokeDasharray: r,
            strokeDashoffset: l,
            strokeLinecap: "round",
            className: "fc:transition-all fc:duration-300 fc:ease-out"
          }
        )
      ] }),
      /* @__PURE__ */ He.jsx("div", { className: "fc:absolute fc:inset-0 fc:flex fc:items-center fc:justify-center", children: /* @__PURE__ */ He.jsxs("span", { className: "fc:text-base fc:font-medium fc:text-gray-900", children: [
        s,
        "%"
      ] }) })
    ] }) : /* @__PURE__ */ He.jsx("div", { className: "fc:relative", children: /* @__PURE__ */ He.jsx(jF, { size: "large" }) }),
    /* @__PURE__ */ He.jsx("p", { className: "fc:mt-4 fc:text-sm fc:text-gray-700", children: c() }),
    i && /* @__PURE__ */ He.jsx("div", { className: "fc:mt-4 fc:p-3 fc:bg-amber-50 fc:border fc:border-amber-200 fc:rounded-lg fc:max-w-md", children: /* @__PURE__ */ He.jsxs("div", { className: "fc:flex fc:items-center", children: [
      /* @__PURE__ */ He.jsx(
        "svg",
        {
          className: "fc:h-4 fc:w-4 fc:text-amber-400 fc:mr-2 fc:flex-shrink-0",
          viewBox: "0 0 20 20",
          fill: "currentColor",
          children: /* @__PURE__ */ He.jsx(
            "path",
            {
              fillRule: "evenodd",
              d: "M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z",
              clipRule: "evenodd"
            }
          )
        }
      ),
      /* @__PURE__ */ He.jsx("p", { className: "fc:text-xs fc:text-amber-700", children: n("ifc.warning.large_file") })
    ] }) })
  ] });
}, iut = ({ fileUrl: e, loadingElement: t }) => {
  const i = io(null), { t: n } = M8(), { loading: s, error: o, downloadProgress: r, currentStep: l, isLargeFile: c } = TQe({
    fileUrl: e,
    containerRef: i
  });
  if (o)
    return /* @__PURE__ */ He.jsx("div", { className: "fc:flex fc:h-full fc:items-center fc:justify-center", children: /* @__PURE__ */ He.jsxs("div", { className: "fc:text-center", children: [
      /* @__PURE__ */ He.jsx("p", { className: "fc:text-red-500", children: n("ifc.error.loading") }),
      /* @__PURE__ */ He.jsx("p", { className: "fc:text-gray-600", children: o.message })
    ] }) });
  const h = t ?? /* @__PURE__ */ He.jsx(
    RQe,
    {
      downloadProgress: r,
      currentStep: l,
      isLargeFile: c
    }
  );
  return /* @__PURE__ */ He.jsxs("div", { className: "fc:relative fc:h-full fc:w-full", children: [
    /* @__PURE__ */ He.jsx("div", { ref: i, className: "fc:h-full fc:w-full" }),
    s && /* @__PURE__ */ He.jsx("div", { className: "fc:absolute fc:inset-0 fc:z-10 fc:flex fc:items-center fc:justify-center fc:bg-white fc:bg-opacity-80", children: h })
  ] });
}, nut = ({ fileUrl: e, className: t = "" }) => {
  const [i, n] = Is(!0), [s, o] = Is(null), [r, l] = Is(null);
  return vr(() => {
    const c = new AbortController();
    let h = null;
    return e && (async () => {
      try {
        n(!0), o(null), l(null);
        const p = await fetch(e, { signal: c.signal });
        if (!p.ok)
          throw new Error(`Failed to load HTML: ${p.statusText}`);
        const y = await p.text(), m = new Blob([y], { type: "text/html;charset=utf-8" }), A = URL.createObjectURL(m);
        h = A, l(A);
      } catch (p) {
        if (c.signal.aborted)
          return;
        o(p instanceof Error ? p.message : "Failed to load HTML content");
      } finally {
        n(!1);
      }
    })(), () => {
      c.abort(), h && URL.revokeObjectURL(h);
    };
  }, [e]), s ? /* @__PURE__ */ He.jsx("div", { className: "flex items-center justify-center h-full w-full", children: /* @__PURE__ */ He.jsxs("div", { className: "text-center", children: [
    /* @__PURE__ */ He.jsx("p", { className: "text-red-600 font-semibold mb-2", children: "Error loading HTML" }),
    /* @__PURE__ */ He.jsx("p", { className: "text-gray-600 text-sm", children: s })
  ] }) }) : /* @__PURE__ */ He.jsxs("div", { className: `w-full h-full relative bg-white ${t}`, children: [
    i && /* @__PURE__ */ He.jsx("div", { className: "absolute inset-0 z-10", children: /* @__PURE__ */ He.jsx(JCe, { title: "Loading HTML content..." }) }),
    r && /* @__PURE__ */ He.jsx(
      "iframe",
      {
        src: r,
        title: "HTML Document Viewer",
        className: "w-full h-full border-0",
        style: { minHeight: "100%" },
        sandbox: "allow-scripts allow-forms allow-popups",
        onLoad: () => n(!1)
      }
    )
  ] });
};
function vQe(e) {
  return Sd({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "rect", attr: { x: "3", y: "4", width: "18", height: "18", rx: "2", ry: "2" }, child: [] }, { tag: "line", attr: { x1: "16", y1: "2", x2: "16", y2: "6" }, child: [] }, { tag: "line", attr: { x1: "8", y1: "2", x2: "8", y2: "6" }, child: [] }, { tag: "line", attr: { x1: "3", y1: "10", x2: "21", y2: "10" }, child: [] }] })(e);
}
function tNe(e) {
  return Sd({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "polyline", attr: { points: "6 9 12 15 18 9" }, child: [] }] })(e);
}
function AQe(e) {
  return Sd({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "polyline", attr: { points: "15 18 9 12 15 6" }, child: [] }] })(e);
}
function SQe(e) {
  return Sd({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "polyline", attr: { points: "9 18 15 12 9 6" }, child: [] }] })(e);
}
function iNe(e) {
  return Sd({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "polyline", attr: { points: "18 15 12 9 6 15" }, child: [] }] })(e);
}
function bQe(e) {
  return Sd({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "circle", attr: { cx: "12", cy: "12", r: "10" }, child: [] }, { tag: "polyline", attr: { points: "12 6 12 12 16 14" }, child: [] }] })(e);
}
function NQe(e) {
  return Sd({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" }, child: [] }, { tag: "circle", attr: { cx: "9", cy: "7", r: "4" }, child: [] }, { tag: "path", attr: { d: "M23 21v-2a4 4 0 0 0-3-3.87" }, child: [] }, { tag: "path", attr: { d: "M16 3.13a4 4 0 0 1 0 7.75" }, child: [] }] })(e);
}
function DQe(e) {
  return Sd({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "line", attr: { x1: "18", y1: "6", x2: "6", y2: "18" }, child: [] }, { tag: "line", attr: { x1: "6", y1: "6", x2: "18", y2: "18" }, child: [] }] })(e);
}
const x2e = (e) => {
  const t = /Z$|[+-]\d{2}:?\d{2}$/.test(e);
  return new Date(t ? e : `${e}Z`);
}, Wme = (e) => {
  const t = new Date(e), i = t.getDay(), n = t.getDate() - i;
  return t.setDate(n), t;
}, CQe = (e) => {
  const t = new Date(e), i = t.getDay(), n = t.getDate() + (6 - i);
  return t.setDate(n), t;
}, OQe = (e, t) => {
  switch (t) {
    case "month":
      return e.toLocaleDateString("en-US", { month: "long", year: "numeric" });
    case "week":
      const i = Wme(e), n = CQe(e);
      return `${i.toLocaleDateString("en-US", { month: "short", day: "numeric" })} - ${n.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}`;
    case "day":
      return e.toLocaleDateString("en-US", {
        weekday: "long",
        month: "long",
        day: "numeric",
        year: "numeric"
      });
    default:
      return e.toLocaleDateString();
  }
}, LQe = (e) => {
  const t = e.getFullYear(), i = e.getMonth(), n = /* @__PURE__ */ new Date();
  n.setHours(0, 0, 0, 0);
  const s = new Date(t, i, 1), o = Wme(s), r = [];
  for (let l = 0; l < 42; l++) {
    const c = new Date(o);
    c.setDate(o.getDate() + l);
    const h = c.getMonth() === i, I = c.getTime() === n.getTime();
    r.push({
      date: c,
      isCurrentMonth: h,
      isToday: I,
      events: []
    });
  }
  return r;
}, _Qe = (e) => {
  const t = Wme(e), i = [], n = /* @__PURE__ */ new Date();
  n.setHours(0, 0, 0, 0);
  for (let s = 0; s < 7; s++) {
    const o = new Date(t);
    o.setDate(t.getDate() + s);
    const r = o.getTime() === n.getTime();
    i.push({
      date: o,
      isCurrentMonth: !0,
      isToday: r,
      events: []
    });
  }
  return i;
}, Yme = (e, t) => t.filter((i) => {
  const n = new Date(i.startTime);
  return n.getFullYear() === e.getFullYear() && n.getMonth() === e.getMonth() && n.getDate() === e.getDate();
}), AP = (e) => e.toLocaleTimeString("en-US", {
  hour: "numeric",
  minute: "2-digit",
  hour12: !0
}), xQe = ({ currentDate: e, events: t, onEventClick: i }) => {
  const { t: n } = M8(), s = Vu(() => Yme(e, t), [e, t]), o = On(
    (l, c) => {
      (l.key === "Enter" || l.key === " ") && (l.preventDefault(), i == null || i(c));
    },
    [i]
  ), r = Vu(
    () => e.toLocaleDateString("en-US", {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric"
    }),
    [e]
  );
  return /* @__PURE__ */ He.jsxs("div", { className: "h-full flex flex-col", children: [
    /* @__PURE__ */ He.jsx("div", { className: "bg-white p-4", children: /* @__PURE__ */ He.jsx("h3", { className: "text-lg font-semibold text-gray-900 mb-4", children: n("calendar.view-titles.daily") }) }),
    /* @__PURE__ */ He.jsxs("div", { className: "flex-1 bg-white p-6", children: [
      /* @__PURE__ */ He.jsx("div", { className: "bg-day-light-3 rounded-lg p-6 mb-6 text-center", children: /* @__PURE__ */ He.jsx("h2", { className: "text-2xl font-semibold text-gray-900 mb-2", children: r }) }),
      s.length > 0 ? /* @__PURE__ */ He.jsx("div", { className: "space-y-4", children: s.map((l) => /* @__PURE__ */ He.jsxs(
        "div",
        {
          className: "bg-black-50 border border-gray-200 rounded-lg p-4 cursor-pointer hover:bg-black-100 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-200",
          role: "button",
          tabIndex: 0,
          "aria-label": `Event: ${l.title} from ${AP(l.startTime)} to ${AP(l.endTime)}`,
          onClick: () => i == null ? void 0 : i(l),
          onKeyDown: (c) => o(c, l),
          children: [
            /* @__PURE__ */ He.jsxs("div", { className: "flex items-center justify-between mb-2", children: [
              /* @__PURE__ */ He.jsx("h4", { className: "text-lg font-semibold text-gray-900", children: l.title }),
              /* @__PURE__ */ He.jsxs("span", { className: "text-sm text-gray-600", children: [
                AP(l.startTime),
                " - ",
                AP(l.endTime)
              ] })
            ] }),
            l.attendeeCount && /* @__PURE__ */ He.jsxs("div", { className: "flex items-center space-x-1 text-sm text-gray-600", children: [
              /* @__PURE__ */ He.jsx("span", { children: "👥" }),
              /* @__PURE__ */ He.jsxs("span", { children: [
                l.attendeeCount,
                " ",
                l.attendeeCount === 1 ? n("calendar.event-details.attendee") : n("calendar.event-details.attendees")
              ] })
            ] }),
            l.description && /* @__PURE__ */ He.jsx("p", { className: "text-sm text-gray-600 mt-2", children: l.description })
          ]
        },
        l.id
      )) }) : /* @__PURE__ */ He.jsxs("div", { className: "text-center py-12", children: [
        /* @__PURE__ */ He.jsx("div", { className: "text-gray-400 text-lg mb-2", children: "📅" }),
        /* @__PURE__ */ He.jsx("h3", { className: "text-lg font-semibold text-gray-900 mb-2", children: n("calendar.empty-states.no-meetings-today") }),
        /* @__PURE__ */ He.jsx("p", { className: "text-gray-600", children: n("calendar.empty-states.schedule-clear") })
      ] })
    ] })
  ] });
}, P2e = ({
  currentDate: e,
  events: t,
  onDateClick: i,
  onEventClick: n
}) => {
  const { t: s } = M8(), o = Vu(() => LQe(e), [e]), r = Vu(
    () => [
      s("calendar.weekdays.sun"),
      s("calendar.weekdays.mon"),
      s("calendar.weekdays.tue"),
      s("calendar.weekdays.wed"),
      s("calendar.weekdays.thu"),
      s("calendar.weekdays.fri"),
      s("calendar.weekdays.sat")
    ],
    [s]
  ), l = On(
    (h, I) => {
      (h.key === "Enter" || h.key === " ") && (h.preventDefault(), i == null || i(I));
    },
    [i]
  ), c = On(
    (h, I) => {
      (h.key === "Enter" || h.key === " ") && (h.preventDefault(), h.stopPropagation(), n == null || n(I));
    },
    [n]
  );
  return /* @__PURE__ */ He.jsxs("div", { className: "h-full flex flex-col bg-gray-50", children: [
    /* @__PURE__ */ He.jsx("div", { className: "bg-white p-6 border-b border-gray-200", children: /* @__PURE__ */ He.jsx("h3", { className: "text-xl font-semibold text-gray-900", children: s("calendar.view-titles.monthly") }) }),
    /* @__PURE__ */ He.jsx("div", { className: "flex-1 bg-gray-50 overflow-auto", children: /* @__PURE__ */ He.jsx("div", { className: "bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden", children: /* @__PURE__ */ He.jsxs("div", { className: "w-full min-w-[800px]", children: [
      /* @__PURE__ */ He.jsx(
        "div",
        {
          className: "grid gap-0 border-b border-gray-200",
          style: { gridTemplateColumns: "repeat(7, 1fr)" },
          children: r.map((h) => /* @__PURE__ */ He.jsx(
            "div",
            {
              className: "min-w-0 bg-gray-50 p-4 text-center border-r border-gray-200 last:border-r-0",
              children: /* @__PURE__ */ He.jsx("span", { className: "text-sm font-medium text-gray-600", children: h })
            },
            h
          ))
        }
      ),
      /* @__PURE__ */ He.jsx(
        "div",
        {
          className: "grid gap-0 bg-white",
          style: {
            gridTemplateColumns: "repeat(7, 1fr)",
            gridTemplateRows: "repeat(6, 1fr)",
            height: "600px"
          },
          children: o.map((h) => {
            const I = Yme(h.date, t);
            return /* @__PURE__ */ He.jsxs(
              "div",
              {
                className: `min-w-0 p-3 cursor-pointer border-r border-b border-gray-200 last:border-r-0 hover:bg-gray-50 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-inset flex flex-col ${h.isCurrentMonth ? "bg-white" : "text-gray-400 bg-gray-50"}`,
                style: { height: "100px" },
                role: "button",
                tabIndex: 0,
                "aria-label": `Calendar date ${h.date.toLocaleDateString()}`,
                onClick: () => i == null ? void 0 : i(h.date),
                onKeyDown: (p) => l(p, h.date),
                children: [
                  /* @__PURE__ */ He.jsx("div", { className: "flex justify-start items-start mb-2 flex-shrink-0", children: /* @__PURE__ */ He.jsx(
                    "span",
                    {
                      className: `text-sm font-semibold ${h.isToday ? "bg-gray-600 text-white w-6 h-6 rounded-full flex items-center justify-center text-xs" : h.isCurrentMonth ? "text-gray-900" : "text-gray-400"}`,
                      children: h.date.getDate()
                    }
                  ) }),
                  /* @__PURE__ */ He.jsxs("div", { className: "space-y-1 flex-1 overflow-hidden", children: [
                    I.slice(0, 2).map((p) => /* @__PURE__ */ He.jsx(
                      "div",
                      {
                        className: "bg-black-50 border-l-2 border-gray-400 text-gray-900 text-xs p-1 rounded-r cursor-pointer hover:bg-gray-100 transition-colors focus:outline-none focus:ring-1 focus:ring-black-500 truncate",
                        role: "button",
                        tabIndex: 0,
                        "aria-label": `Event: ${p.title} at ${AP(p.startTime)}`,
                        onClick: (y) => {
                          y.stopPropagation(), n == null || n(p);
                        },
                        onKeyDown: (y) => c(y, p),
                        children: /* @__PURE__ */ He.jsxs("div", { className: "flex items-center space-x-1", children: [
                          /* @__PURE__ */ He.jsx("span", { className: "font-medium text-xs truncate", children: AP(p.startTime) }),
                          /* @__PURE__ */ He.jsx("span", { className: "text-xs truncate", children: p.title })
                        ] })
                      },
                      p.id
                    )),
                    I.length > 2 && /* @__PURE__ */ He.jsxs("div", { className: "text-xs text-gray-500 pl-1 truncate", children: [
                      "+",
                      I.length - 2,
                      " ",
                      s("calendar.empty-states.more-events")
                    ] })
                  ] })
                ]
              },
              h.date.toISOString()
            );
          })
        }
      )
    ] }) }) })
  ] });
}, PQe = ({
  currentDate: e,
  events: t,
  onDateClick: i,
  onEventClick: n
}) => {
  const { t: s } = M8(), o = Vu(() => _Qe(e), [e]), r = Vu(
    () => [
      s("calendar.weekdays.sun"),
      s("calendar.weekdays.mon"),
      s("calendar.weekdays.tue"),
      s("calendar.weekdays.wed"),
      s("calendar.weekdays.thu"),
      s("calendar.weekdays.fri"),
      s("calendar.weekdays.sat")
    ],
    [s]
  ), l = On(
    (h, I) => {
      (h.key === "Enter" || h.key === " ") && (h.preventDefault(), i == null || i(I));
    },
    [i]
  ), c = On(
    (h, I) => {
      (h.key === "Enter" || h.key === " ") && (h.preventDefault(), h.stopPropagation(), n == null || n(I));
    },
    [n]
  );
  return /* @__PURE__ */ He.jsxs("div", { className: "h-full flex flex-col bg-gray-50", children: [
    /* @__PURE__ */ He.jsx("div", { className: "bg-white p-6 border-b border-gray-200", children: /* @__PURE__ */ He.jsx("h3", { className: "text-xl font-semibold text-gray-900", children: s("calendar.view-titles.weekly") }) }),
    /* @__PURE__ */ He.jsx("div", { className: "flex-1 bg-gray-50 overflow-auto", children: /* @__PURE__ */ He.jsx("div", { className: "bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden", children: /* @__PURE__ */ He.jsxs("div", { className: "w-full min-w-[800px]", children: [
      /* @__PURE__ */ He.jsx(
        "div",
        {
          className: "grid gap-0 border-b border-gray-200",
          style: { gridTemplateColumns: "repeat(7, 1fr)" },
          children: o.map((h, I) => /* @__PURE__ */ He.jsxs(
            "div",
            {
              className: "min-w-0 bg-gray-50 px-4 py-4 text-center border-r border-gray-200 last:border-r-0",
              children: [
                /* @__PURE__ */ He.jsx("div", { className: "text-sm font-medium text-gray-600 mb-1", children: r[I] }),
                /* @__PURE__ */ He.jsx(
                  "div",
                  {
                    className: `text-xl font-semibold ${h.isToday ? "bg-gray-600 text-white w-8 h-8 rounded-full flex items-center justify-center mx-auto" : "text-gray-900"}`,
                    children: h.date.getDate()
                  }
                )
              ]
            },
            `header-${h.date.toISOString()}`
          ))
        }
      ),
      /* @__PURE__ */ He.jsx(
        "div",
        {
          className: "grid gap-0 bg-white",
          style: {
            gridTemplateColumns: "repeat(7, 1fr)",
            minHeight: "600px"
          },
          children: o.map((h) => {
            const I = Yme(h.date, t);
            return /* @__PURE__ */ He.jsx(
              "div",
              {
                className: "min-w-0 bg-white p-4 cursor-pointer hover:bg-gray-50 transition-colors border-r border-gray-200 last:border-r-0 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-inset overflow-y-auto",
                style: { minHeight: "600px" },
                role: "button",
                tabIndex: 0,
                "aria-label": `Calendar date ${h.date.toLocaleDateString()}`,
                onClick: () => i == null ? void 0 : i(h.date),
                onKeyDown: (p) => l(p, h.date),
                children: /* @__PURE__ */ He.jsx("div", { className: "space-y-3", children: I.map((p) => /* @__PURE__ */ He.jsxs(
                  "div",
                  {
                    className: "bg-gray-50 border-l-4 border-gray-400 text-gray-900 text-sm p-3 rounded-r cursor-pointer hover:bg-gray-100 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500",
                    role: "button",
                    tabIndex: 0,
                    "aria-label": `Event: ${p.title} at ${AP(p.startTime)}`,
                    onClick: (y) => {
                      y.stopPropagation(), n == null || n(p);
                    },
                    onKeyDown: (y) => c(y, p),
                    children: [
                      /* @__PURE__ */ He.jsx("div", { className: "font-medium text-sm mb-1", children: AP(p.startTime) }),
                      /* @__PURE__ */ He.jsx("div", { className: "text-sm font-medium truncate", children: p.title })
                    ]
                  },
                  p.id
                )) })
              },
              h.date.toISOString()
            );
          })
        }
      )
    ] }) }) })
  ] });
}, sut = ({ events: e = [], onEventClick: t, onDateClick: i }) => {
  const { t: n } = M8(), [s, o] = Is(/* @__PURE__ */ new Date()), [r, l] = Is("month"), c = Vu(() => ["day", "week", "month"], []), h = On(
    (C) => {
      const O = new Date(s);
      switch (r) {
        case "month":
          O.setMonth(O.getMonth() + C);
          break;
        case "week":
          O.setDate(O.getDate() + C * 7);
          break;
        case "day":
          O.setDate(O.getDate() + C);
          break;
      }
      o(O);
    },
    [s, r]
  ), I = On(() => h(-1), [h]), p = On(() => h(1), [h]), y = On(() => {
    o(/* @__PURE__ */ new Date());
  }, []), m = Vu(
    () => ({
      currentDate: s,
      events: e,
      onDateClick: i,
      onEventClick: t
    }),
    [s, e, i, t]
  ), A = On(() => {
    switch (r) {
      case "month":
        return /* @__PURE__ */ He.jsx(P2e, { ...m });
      case "week":
        return /* @__PURE__ */ He.jsx(PQe, { ...m });
      case "day":
        return /* @__PURE__ */ He.jsx(xQe, { ...m });
      default:
        return /* @__PURE__ */ He.jsx(P2e, { ...m });
    }
  }, [r, m]);
  return /* @__PURE__ */ He.jsxs("div", { className: "h-full flex flex-col bg-background", children: [
    /* @__PURE__ */ He.jsxs("div", { className: "flex items-center p-6 border-b border-gray-200", children: [
      /* @__PURE__ */ He.jsx("div", { className: "flex-1", children: /* @__PURE__ */ He.jsx("h1", { className: "text-2xl font-semibold text-gray-900", children: n("calendar.title") }) }),
      /* @__PURE__ */ He.jsx("div", { className: "flex items-center space-x-1 bg-day-light-3 rounded-lg p-1", children: c.map((C) => /* @__PURE__ */ He.jsx(
        "button",
        {
          onClick: () => l(C),
          className: `px-4 py-2 text-sm font-medium rounded-md transition-colors ${r === C ? "bg-white text-gray-900 shadow-sm" : "text-gray-600 hover:text-gray-900"}`,
          children: n(`calendar.views.${C}`)
        },
        C
      )) }),
      /* @__PURE__ */ He.jsxs("div", { className: "flex-1 flex items-center justify-end space-x-4", children: [
        /* @__PURE__ */ He.jsxs("div", { className: "flex items-center space-x-4", children: [
          /* @__PURE__ */ He.jsx(
            "button",
            {
              onClick: I,
              className: "p-2 hover:bg-day-light-3 rounded-md transition-colors",
              children: /* @__PURE__ */ He.jsx(AQe, { className: "w-5 h-5 text-gray-600" })
            }
          ),
          /* @__PURE__ */ He.jsx("h2", { className: "text-xl font-semibold text-gray-900 min-w-[200px] text-center", children: OQe(s, r) }),
          /* @__PURE__ */ He.jsx(
            "button",
            {
              onClick: p,
              className: "p-2 hover:bg-day-light-3 rounded-md transition-colors",
              children: /* @__PURE__ */ He.jsx(SQe, { className: "w-5 h-5 text-gray-600" })
            }
          )
        ] }),
        /* @__PURE__ */ He.jsx(
          "button",
          {
            onClick: y,
            className: "px-4 py-2 text-sm font-medium text-gray-600 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 hover:text-gray-900 transition-colors",
            children: n("calendar.navigation.today")
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ He.jsx("div", { className: "flex-1 overflow-auto bg-white p-6 border-1 border-day-light-2", children: A() })
  ] });
}, M2e = {
  en: {
    locale: "en-US",
    uses24Hour: !1
    // US prefers 12-hour format
  },
  de: {
    locale: "de-DE",
    uses24Hour: !0
    // Germany uses 24-hour format
  },
  fr: {
    locale: "fr-FR",
    uses24Hour: !0
    // France uses 24-hour format
  },
  es: {
    locale: "es-ES",
    uses24Hour: !0
    // Spain uses 24-hour format
  },
  nb: {
    locale: "nb-NO",
    // Norwegian Bokmål
    uses24Hour: !0
    // Norway uses 24-hour format
  },
  nn: {
    locale: "nn-NO",
    // Norwegian Nynorsk
    uses24Hour: !0
    // Norway uses 24-hour format
  },
  sv: {
    locale: "sv-SE",
    // Swedish
    uses24Hour: !0
    // Sweden uses 24-hour format
  },
  ja: {
    locale: "ja-JP",
    // Japanese
    uses24Hour: !0
    // Japan uses 24-hour format
  },
  vi: {
    locale: "vi-VN",
    // Vietnamese
    uses24Hour: !0
    // Vietnam uses 24-hour format
  }
}, nNe = (e) => {
  const t = e in M2e ? e : "en";
  return M2e[t];
}, MQe = (e, t) => {
  const i = nNe(t);
  return e.toLocaleTimeString(i.locale, {
    hour: "numeric",
    minute: "2-digit",
    hour12: !i.uses24Hour
    // Use 12-hour format only for locales that prefer it
  });
}, UQe = (e, t) => {
  const i = nNe(t);
  return e.toLocaleDateString(i.locale, {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric"
  });
}, out = ({ event: e, onClose: t }) => {
  const { t: i, language: n } = M8(), s = On(
    (I) => MQe(I, n),
    [n]
  ), o = On(
    (I) => UQe(I, n),
    [n]
  ), r = Vu(
    () => s(e.startTime),
    [s, e.startTime]
  ), l = Vu(
    () => s(e.endTime),
    [s, e.endTime]
  ), c = Vu(
    () => o(e.startTime),
    [o, e.startTime]
  ), h = Vu(
    () => Math.round((e.endTime.getTime() - e.startTime.getTime()) / (1e3 * 60)),
    [e.startTime, e.endTime]
  );
  return /* @__PURE__ */ He.jsx(
    "div",
    {
      className: "fixed inset-0 bg-transparent flex items-center justify-center z-50",
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": "modal-title",
      children: /* @__PURE__ */ He.jsxs("div", { className: "bg-white rounded-lg shadow-xl border border-gray-300 max-w-md w-full mx-4 max-h-[90vh] overflow-y-auto", children: [
        /* @__PURE__ */ He.jsxs("div", { className: "flex items-center justify-between p-6 border-b border-gray-200", children: [
          /* @__PURE__ */ He.jsx("h2", { id: "modal-title", className: "text-xl font-semibold text-gray-900", children: i("calendar.event-details.title") }),
          /* @__PURE__ */ He.jsx(
            "button",
            {
              onClick: t,
              className: "p-1 hover:bg-gray-100 rounded-full transition-colors cursor-pointer",
              "aria-label": i("calendar.event-details.close"),
              children: /* @__PURE__ */ He.jsx(DQe, { className: "w-5 h-5 text-gray-500" })
            }
          )
        ] }),
        /* @__PURE__ */ He.jsxs("div", { className: "p-6 space-y-4", children: [
          /* @__PURE__ */ He.jsx("div", { children: /* @__PURE__ */ He.jsx("h3", { className: "text-lg font-medium text-gray-900 mb-2", children: e.title }) }),
          /* @__PURE__ */ He.jsxs("div", { className: "flex items-start space-x-3", children: [
            /* @__PURE__ */ He.jsx(vQe, { className: "w-5 h-5 text-gray-400 mt-0.5" }),
            /* @__PURE__ */ He.jsxs("div", { children: [
              /* @__PURE__ */ He.jsx("p", { className: "text-sm font-medium text-gray-900", children: c }),
              /* @__PURE__ */ He.jsxs("p", { className: "text-sm text-gray-600", children: [
                r,
                " - ",
                l
              ] })
            ] })
          ] }),
          /* @__PURE__ */ He.jsxs("div", { className: "flex items-center space-x-3", children: [
            /* @__PURE__ */ He.jsx(bQe, { className: "w-5 h-5 text-gray-400" }),
            /* @__PURE__ */ He.jsxs("span", { className: "text-sm text-gray-600", children: [
              h,
              " ",
              i("calendar.event-details.minutes")
            ] })
          ] }),
          e.attendeeCount && /* @__PURE__ */ He.jsxs("div", { className: "flex items-center space-x-3", children: [
            /* @__PURE__ */ He.jsx(NQe, { className: "w-5 h-5 text-gray-400" }),
            /* @__PURE__ */ He.jsxs("span", { className: "text-sm text-gray-600", children: [
              e.attendeeCount,
              " ",
              e.attendeeCount === 1 ? i("calendar.event-details.attendee") : i("calendar.event-details.attendees")
            ] })
          ] }),
          e.description && /* @__PURE__ */ He.jsxs("div", { children: [
            /* @__PURE__ */ He.jsx("h4", { className: "text-sm font-medium text-gray-900 mb-2", children: i("calendar.event-details.description") }),
            /* @__PURE__ */ He.jsx("p", { className: "text-sm text-gray-600 leading-relaxed", children: e.description })
          ] })
        ] })
      ] })
    }
  );
}, rut = (e) => e.map((t) => ({
  id: t.id,
  title: t.title,
  startTime: x2e(t.scheduledStartTime),
  endTime: x2e(t.scheduledEndTime),
  attendeeCount: t.attendeeCount,
  description: t.description || `Organized by: ${t.organizerEmail}`
}));
var jce, U2e;
function BQe() {
  return U2e || (U2e = 1, jce = (t, i, n, s, o) => {
    const r = o - s;
    if (r === 0) return [];
    const l = n * Math.cos(s) + t, c = n * Math.sin(s) + i, h = n * Math.cos(o) + t, I = n * Math.sin(o) + i, p = Math.abs(r) <= Math.PI ? "0" : "1", y = r < 0 ? "0" : "1";
    return [
      ["M", l, c],
      ["A", n, n, 0, p, y, h, I]
    ];
  }), jce;
}
var FQe = BQe();
const HQe = /* @__PURE__ */ rie(FQe);
function _le(e) {
  return e * Math.PI / 180;
}
function sNe(e, t, i) {
  return e > i ? i : e < t ? t : e;
}
function Due(e, t) {
  return t / 100 * e;
}
function oNe(e, t) {
  return e + t / 2;
}
function rNe(e, t) {
  const i = _le(e);
  return {
    dx: t * Math.cos(i),
    dy: t * Math.sin(i)
  };
}
function lNe(e) {
  return typeof e == "number";
}
function xle(e, t) {
  return typeof e == "function" ? (
    // @ts-expect-error: cannot find a way to type 2nd prop arg as anything-but-function
    e(t)
  ) : e;
}
function GQe(e) {
  let t = 0;
  for (let i = 0; i < e.length; i++)
    t += e[i].value;
  return t;
}
function kQe({ data: e, lengthAngle: t, totalValue: i, paddingAngle: n, startAngle: s }) {
  const o = i || GQe(e), r = sNe(t, -360, 360), l = Math.abs(r) === 360 ? e.length : e.length - 1, c = Math.abs(n) * Math.sign(t), h = c * l, I = r - h;
  let p = 0;
  const y = [];
  for (let m = 0; m < e.length; m++) {
    const A = e[m], C = o === 0 ? 0 : A.value / o * 100, O = Due(I, C), R = p + s;
    p = p + O + c, y.push(Object.assign({
      percentage: C,
      startAngle: R,
      degrees: O
    }, A));
  }
  return y;
}
function VQe({ renderLabel: e, labelProps: t }) {
  const i = e(t);
  if (typeof i == "string" || typeof i == "number") {
    const { dataEntry: n, dataIndex: s, ...o } = t;
    return Ms.createElement("text", { dominantBaseline: "central", ...o }, i);
  }
  return Ms.isValidElement(i) ? i : null;
}
function zQe(e) {
  return Math.round((e + Number.EPSILON) * 1e14) / 1e14;
}
function jQe({ labelPosition: e, lineWidth: t, labelHorizontalShift: i }) {
  const n = zQe(i);
  if (n === 0)
    return "middle";
  if (e > 100)
    return n > 0 ? "start" : "end";
  const s = 100 - t;
  return e < s ? n > 0 ? "end" : "start" : "middle";
}
function WQe(e, t) {
  return e.map((i, n) => {
    const s = xle(t.segmentsShift, n) ?? 0, o = Due(t.radius, t.labelPosition) + s, { dx: r, dy: l } = rNe(oNe(i.startAngle, i.degrees), o);
    return {
      x: t.center[0],
      y: t.center[1],
      dx: r,
      dy: l,
      textAnchor: jQe({
        labelPosition: t.labelPosition,
        lineWidth: t.lineWidth,
        labelHorizontalShift: r
      }),
      dataEntry: i,
      dataIndex: n,
      style: xle(t.labelStyle, n)
    };
  });
}
function YQe(e, t) {
  const { label: i } = t;
  if (i)
    return WQe(e, t).map((n, s) => Ms.createElement(VQe, { key: `label-${n.dataEntry.key || s}`, renderLabel: i, labelProps: n }));
}
function qQe(e, t, i, n, s) {
  const o = sNe(n, -359.999, 359.999);
  return HQe(
    e,
    t,
    // center X and Y
    s,
    _le(i),
    _le(i + o)
  ).map((r) => r.join(" ")).join(" ");
}
function B2e({ cx: e, cy: t, lengthAngle: i, lineWidth: n, radius: s, shift: o = 0, reveal: r, rounded: l, startAngle: c, title: h, ...I }) {
  const p = s - n / 2, { dx: y, dy: m } = rNe(oNe(c, i), o), A = qQe(e + y, t + m, c, i, p);
  let C, O;
  if (lNe(r)) {
    const R = _le(p) * i;
    C = Math.abs(R), O = C - Due(C, r);
  }
  return Ms.createElement("path", { d: A, fill: "none", strokeWidth: n, strokeDasharray: C, strokeDashoffset: O, strokeLinecap: l ? "round" : void 0, ...I }, h && Ms.createElement("title", null, h));
}
function $Qe(e, t, i) {
  let n = `stroke-dashoffset ${e}ms ${t}`;
  return i && i.transition && (n = `${n},${i.transition}`), {
    transition: n
  };
}
function KQe({ reveal: e, animate: t }) {
  return t && !lNe(e) ? 100 : e;
}
function fV(e, t) {
  return e && ((i) => {
    e(i, t);
  });
}
function ZQe(e, t, i) {
  const n = i ?? KQe(t), { radius: s, center: [o, r] } = t, l = Due(s, t.lineWidth), c = e.map((h, I) => {
    const p = xle(t.segmentsStyle, I);
    return Ms.createElement(B2e, { cx: o, cy: r, key: h.key || I, lengthAngle: h.degrees, lineWidth: l, radius: s, rounded: t.rounded, reveal: n, shift: xle(t.segmentsShift, I), startAngle: h.startAngle, title: h.title, style: Object.assign({}, p, t.animate && $Qe(t.animationDuration, t.animationEasing, p)), stroke: h.color, tabIndex: t.segmentsTabIndex, onBlur: fV(t.onBlur, I), onClick: fV(t.onClick, I), onFocus: fV(t.onFocus, I), onKeyDown: fV(t.onKeyDown, I), onMouseOver: fV(t.onMouseOver, I), onMouseOut: fV(t.onMouseOut, I) });
  });
  return t.background && c.unshift(Ms.createElement(B2e, { cx: o, cy: r, key: "bg", lengthAngle: t.lengthAngle, lineWidth: l, radius: s, rounded: t.rounded, startAngle: t.startAngle, stroke: t.background })), c;
}
const Wce = {
  animationDuration: 500,
  animationEasing: "ease-out",
  center: [50, 50],
  data: [],
  labelPosition: 50,
  lengthAngle: 360,
  lineWidth: 100,
  paddingAngle: 0,
  radius: 50,
  startAngle: 0,
  viewBoxSize: [100, 100]
};
function QQe(e) {
  const t = Object.assign({}, Wce, e);
  let i;
  for (i in Wce)
    e[i] === void 0 && (t[i] = Wce[i]);
  return t;
}
function JQe(e) {
  const t = QQe(e), [i, n] = Is(t.animate ? 0 : null);
  vr(() => {
    t.animate && n(null);
  }, []);
  const s = kQe(t);
  return Ms.createElement(
    "svg",
    { viewBox: `0 0 ${t.viewBoxSize[0]} ${t.viewBoxSize[1]}`, width: "100%", height: "100%", className: t.className, style: t.style },
    ZQe(s, t, i),
    YQe(s, t),
    t.children
  );
}
const XQe = ({
  data: e,
  className: t,
  style: i,
  showPercentage: n = !0
}) => /* @__PURE__ */ He.jsx("div", { className: Gn("fc:flex fc:flex-col fc:justify-center fc:gap-3", t), style: i, children: e.map((s) => /* @__PURE__ */ He.jsxs(
  "div",
  {
    className: "fc:flex fc:flex-row fc:items-center fc:gap-2 fc:justify-start",
    children: [
      /* @__PURE__ */ He.jsx(
        "div",
        {
          className: "fc:w-4 fc:h-4 fc:rounded-sm fc:flex-shrink-0",
          style: {
            backgroundColor: s.color
          }
        }
      ),
      /* @__PURE__ */ He.jsxs("div", { className: "fc:text-sm fc:text-gray-700 dark:fc:text-gray-300", children: [
        /* @__PURE__ */ He.jsx("span", { className: "fc:font-medium", children: s.title }),
        n && /* @__PURE__ */ He.jsxs("span", { className: "fc:ml-1 fc:text-gray-500 dark:fc:text-gray-400", children: [
          "(",
          s.value,
          "%)"
        ] })
      ] })
    ]
  },
  s.title
)) }), lut = ({
  data: e,
  animate: t = !0,
  animationDuration: i = 1200,
  lineWidth: n = 40,
  paddingAngle: s = 2,
  centerLabel: o,
  showLegend: r = !0,
  className: l,
  containerStyle: c,
  legendStyle: h
}) => {
  const I = Vu(() => e.filter((C) => !!C.value), [e]), p = Vu(() => I.length === 1, [I.length]);
  if (Vu(() => I.length === 0, [I.length]))
    return null;
  const m = /* @__PURE__ */ He.jsx("div", { className: "fc:min-w-[50px] fc:max-w-[200px] fc:w-full", children: /* @__PURE__ */ He.jsx(
    JQe,
    {
      data: I,
      lineWidth: n,
      animate: t,
      animationDuration: i,
      label: o ? () => o : void 0,
      labelStyle: o ? {
        fontSize: o.length > 10 ? "7px" : o.length > 6 ? "8px" : "9px",
        fontFamily: "Inter, system-ui, sans-serif",
        fill: "#374151",
        textAnchor: "middle",
        dominantBaseline: "middle",
        maxWidth: "80px",
        wordBreak: "break-word"
      } : void 0,
      labelPosition: 0,
      paddingAngle: p ? 0 : s
    }
  ) }), A = r && /* @__PURE__ */ He.jsx(XQe, { data: e, style: h, className: "fc:sm:ml-6" });
  return /* @__PURE__ */ He.jsxs(
    "div",
    {
      className: Gn(
        "fc:flex fc:flex-col fc:items-center fc:justify-center fc:gap-4",
        "fc:sm:flex-row fc:sm:justify-around",
        l
      ),
      style: c,
      children: [
        A,
        m
      ]
    }
  );
};
function F2e(e) {
  const t = [], i = String(e || "");
  let n = i.indexOf(","), s = 0, o = !1;
  for (; !o; ) {
    n === -1 && (n = i.length, o = !0);
    const r = i.slice(s, n).trim();
    (r || !o) && t.push(r), s = n + 1, n = i.indexOf(",", s);
  }
  return t;
}
function aNe(e, t) {
  const i = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (i.padRight ? " " : "") + "," + (i.padLeft === !1 ? "" : " ")
  ).trim();
}
const eJe = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, tJe = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, iJe = {};
function H2e(e, t) {
  return (iJe.jsx ? tJe : eJe).test(e);
}
const nJe = /[ \t\n\f\r]/g;
function sJe(e) {
  return typeof e == "object" ? e.type === "text" ? G2e(e.value) : !1 : G2e(e);
}
function G2e(e) {
  return e.replace(nJe, "") === "";
}
class Gie {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(t, i, n) {
    this.normal = i, this.property = t, n && (this.space = n);
  }
}
Gie.prototype.normal = {};
Gie.prototype.property = {};
Gie.prototype.space = void 0;
function uNe(e, t) {
  const i = {}, n = {};
  for (const s of e)
    Object.assign(i, s.property), Object.assign(n, s.normal);
  return new Gie(i, n, t);
}
function VX(e) {
  return e.toLowerCase();
}
class qg {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(t, i) {
    this.attribute = i, this.property = t;
  }
}
qg.prototype.attribute = "";
qg.prototype.booleanish = !1;
qg.prototype.boolean = !1;
qg.prototype.commaOrSpaceSeparated = !1;
qg.prototype.commaSeparated = !1;
qg.prototype.defined = !1;
qg.prototype.mustUseProperty = !1;
qg.prototype.number = !1;
qg.prototype.overloadedBoolean = !1;
qg.prototype.property = "";
qg.prototype.spaceSeparated = !1;
qg.prototype.space = void 0;
let oJe = 0;
const Ao = MH(), _0 = MH(), XIe = MH(), dn = MH(), ia = MH(), Pz = MH(), Xw = MH();
function MH() {
  return 2 ** ++oJe;
}
const epe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: Ao,
  booleanish: _0,
  commaOrSpaceSeparated: Xw,
  commaSeparated: Pz,
  number: dn,
  overloadedBoolean: XIe,
  spaceSeparated: ia
}, Symbol.toStringTag, { value: "Module" })), Yce = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(epe)
);
class qme extends qg {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(t, i, n, s) {
    let o = -1;
    if (super(t, i), k2e(this, "space", s), typeof n == "number")
      for (; ++o < Yce.length; ) {
        const r = Yce[o];
        k2e(this, Yce[o], (n & epe[r]) === epe[r]);
      }
  }
}
qme.prototype.defined = !0;
function k2e(e, t, i) {
  i && (e[t] = i);
}
function dY(e) {
  const t = {}, i = {};
  for (const [n, s] of Object.entries(e.properties)) {
    const o = new qme(
      n,
      e.transform(e.attributes || {}, n),
      s,
      e.space
    );
    e.mustUseProperty && e.mustUseProperty.includes(n) && (o.mustUseProperty = !0), t[n] = o, i[VX(n)] = n, i[VX(o.attribute)] = n;
  }
  return new Gie(t, i, e.space);
}
const dNe = dY({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: _0,
    ariaAutoComplete: null,
    ariaBusy: _0,
    ariaChecked: _0,
    ariaColCount: dn,
    ariaColIndex: dn,
    ariaColSpan: dn,
    ariaControls: ia,
    ariaCurrent: null,
    ariaDescribedBy: ia,
    ariaDetails: null,
    ariaDisabled: _0,
    ariaDropEffect: ia,
    ariaErrorMessage: null,
    ariaExpanded: _0,
    ariaFlowTo: ia,
    ariaGrabbed: _0,
    ariaHasPopup: null,
    ariaHidden: _0,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: ia,
    ariaLevel: dn,
    ariaLive: null,
    ariaModal: _0,
    ariaMultiLine: _0,
    ariaMultiSelectable: _0,
    ariaOrientation: null,
    ariaOwns: ia,
    ariaPlaceholder: null,
    ariaPosInSet: dn,
    ariaPressed: _0,
    ariaReadOnly: _0,
    ariaRelevant: null,
    ariaRequired: _0,
    ariaRoleDescription: ia,
    ariaRowCount: dn,
    ariaRowIndex: dn,
    ariaRowSpan: dn,
    ariaSelected: _0,
    ariaSetSize: dn,
    ariaSort: null,
    ariaValueMax: dn,
    ariaValueMin: dn,
    ariaValueNow: dn,
    ariaValueText: null,
    role: null
  },
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  }
});
function cNe(e, t) {
  return t in e ? e[t] : t;
}
function hNe(e, t) {
  return cNe(e, t.toLowerCase());
}
const rJe = dY({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: Pz,
    acceptCharset: ia,
    accessKey: ia,
    action: null,
    allow: null,
    allowFullScreen: Ao,
    allowPaymentRequest: Ao,
    allowUserMedia: Ao,
    alt: null,
    as: null,
    async: Ao,
    autoCapitalize: null,
    autoComplete: ia,
    autoFocus: Ao,
    autoPlay: Ao,
    blocking: ia,
    capture: null,
    charSet: null,
    checked: Ao,
    cite: null,
    className: ia,
    cols: dn,
    colSpan: null,
    content: null,
    contentEditable: _0,
    controls: Ao,
    controlsList: ia,
    coords: dn | Pz,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: Ao,
    defer: Ao,
    dir: null,
    dirName: null,
    disabled: Ao,
    download: XIe,
    draggable: _0,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: Ao,
    formTarget: null,
    headers: ia,
    height: dn,
    hidden: XIe,
    high: dn,
    href: null,
    hrefLang: null,
    htmlFor: ia,
    httpEquiv: ia,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: Ao,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: Ao,
    itemId: null,
    itemProp: ia,
    itemRef: ia,
    itemScope: Ao,
    itemType: ia,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: Ao,
    low: dn,
    manifest: null,
    max: null,
    maxLength: dn,
    media: null,
    method: null,
    min: null,
    minLength: dn,
    multiple: Ao,
    muted: Ao,
    name: null,
    nonce: null,
    noModule: Ao,
    noValidate: Ao,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: Ao,
    optimum: dn,
    pattern: null,
    ping: ia,
    placeholder: null,
    playsInline: Ao,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: Ao,
    referrerPolicy: null,
    rel: ia,
    required: Ao,
    reversed: Ao,
    rows: dn,
    rowSpan: dn,
    sandbox: ia,
    scope: null,
    scoped: Ao,
    seamless: Ao,
    selected: Ao,
    shadowRootClonable: Ao,
    shadowRootDelegatesFocus: Ao,
    shadowRootMode: null,
    shape: null,
    size: dn,
    sizes: null,
    slot: null,
    span: dn,
    spellCheck: _0,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: dn,
    step: null,
    style: null,
    tabIndex: dn,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: Ao,
    useMap: null,
    value: _0,
    width: dn,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: ia,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: dn,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: dn,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: Ao,
    // Lists. Use CSS to reduce space between items instead
    declare: Ao,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: dn,
    // `<img>` and `<object>`
    leftMargin: dn,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: dn,
    // `<body>`
    marginWidth: dn,
    // `<body>`
    noResize: Ao,
    // `<frame>`
    noHref: Ao,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: Ao,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: Ao,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: dn,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: _0,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: dn,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: dn,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: Ao,
    disableRemotePlayback: Ao,
    prefix: null,
    property: null,
    results: dn,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: hNe
}), lJe = dY({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: Xw,
    accentHeight: dn,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: dn,
    amplitude: dn,
    arabicForm: null,
    ascent: dn,
    attributeName: null,
    attributeType: null,
    azimuth: dn,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: dn,
    by: null,
    calcMode: null,
    capHeight: dn,
    className: ia,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: dn,
    diffuseConstant: dn,
    direction: null,
    display: null,
    dur: null,
    divisor: dn,
    dominantBaseline: null,
    download: Ao,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: dn,
    enableBackground: null,
    end: null,
    event: null,
    exponent: dn,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: dn,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: Pz,
    g2: Pz,
    glyphName: Pz,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: dn,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: dn,
    horizOriginX: dn,
    horizOriginY: dn,
    id: null,
    ideographic: dn,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: dn,
    k: dn,
    k1: dn,
    k2: dn,
    k3: dn,
    k4: dn,
    kernelMatrix: Xw,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: dn,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: dn,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: dn,
    overlineThickness: dn,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: dn,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: ia,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: dn,
    pointsAtY: dn,
    pointsAtZ: dn,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Xw,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Xw,
    rev: Xw,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Xw,
    requiredFeatures: Xw,
    requiredFonts: Xw,
    requiredFormats: Xw,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: dn,
    specularExponent: dn,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: dn,
    strikethroughThickness: dn,
    string: null,
    stroke: null,
    strokeDashArray: Xw,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: dn,
    strokeOpacity: dn,
    strokeWidth: null,
    style: null,
    surfaceScale: dn,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Xw,
    tabIndex: dn,
    tableValues: null,
    target: null,
    targetX: dn,
    targetY: dn,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Xw,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: dn,
    underlineThickness: dn,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: dn,
    values: null,
    vAlphabetic: dn,
    vMathematical: dn,
    vectorEffect: null,
    vHanging: dn,
    vIdeographic: dn,
    version: null,
    vertAdvY: dn,
    vertOriginX: dn,
    vertOriginY: dn,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: dn,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: cNe
}), fNe = dY({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  }
}), INe = dY({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: hNe
}), pNe = dY({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  }
}), aJe = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, uJe = /[A-Z]/g, V2e = /-[a-z]/g, dJe = /^data[-\w.:]+$/i;
function Cue(e, t) {
  const i = VX(t);
  let n = t, s = qg;
  if (i in e.normal)
    return e.property[e.normal[i]];
  if (i.length > 4 && i.slice(0, 4) === "data" && dJe.test(t)) {
    if (t.charAt(4) === "-") {
      const o = t.slice(5).replace(V2e, hJe);
      n = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = t.slice(4);
      if (!V2e.test(o)) {
        let r = o.replace(uJe, cJe);
        r.charAt(0) !== "-" && (r = "-" + r), t = "data" + r;
      }
    }
    s = qme;
  }
  return new s(n, t);
}
function cJe(e) {
  return "-" + e.toLowerCase();
}
function hJe(e) {
  return e.charAt(1).toUpperCase();
}
const kie = uNe([dNe, rJe, fNe, INe, pNe], "html"), F8 = uNe([dNe, lJe, fNe, INe, pNe], "svg");
function z2e(e) {
  const t = String(e || "").trim();
  return t ? t.split(/[ \t\n\r\f]+/g) : [];
}
function mNe(e) {
  return e.join(" ").trim();
}
var IV = {}, qce, j2e;
function fJe() {
  if (j2e) return qce;
  j2e = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, t = /\n/g, i = /^\s*/, n = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, s = /^:\s*/, o = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, r = /^[;\s]*/, l = /^\s+|\s+$/g, c = `
`, h = "/", I = "*", p = "", y = "comment", m = "declaration";
  function A(O, R) {
    if (typeof O != "string")
      throw new TypeError("First argument must be a string");
    if (!O) return [];
    R = R || {};
    var F = 1, L = 1;
    function P(pe) {
      var je = pe.match(t);
      je && (F += je.length);
      var Ve = pe.lastIndexOf(c);
      L = ~Ve ? pe.length - Ve : L + pe.length;
    }
    function z() {
      var pe = { line: F, column: L };
      return function(je) {
        return je.position = new W(pe), te(), je;
      };
    }
    function W(pe) {
      this.start = pe, this.end = { line: F, column: L }, this.source = R.source;
    }
    W.prototype.content = O;
    function re(pe) {
      var je = new Error(
        R.source + ":" + F + ":" + L + ": " + pe
      );
      if (je.reason = pe, je.filename = R.source, je.line = F, je.column = L, je.source = O, !R.silent) throw je;
    }
    function ce(pe) {
      var je = pe.exec(O);
      if (je) {
        var Ve = je[0];
        return P(Ve), O = O.slice(Ve.length), je;
      }
    }
    function te() {
      ce(i);
    }
    function ee(pe) {
      var je;
      for (pe = pe || []; je = Ne(); )
        je !== !1 && pe.push(je);
      return pe;
    }
    function Ne() {
      var pe = z();
      if (!(h != O.charAt(0) || I != O.charAt(1))) {
        for (var je = 2; p != O.charAt(je) && (I != O.charAt(je) || h != O.charAt(je + 1)); )
          ++je;
        if (je += 2, p === O.charAt(je - 1))
          return re("End of comment missing");
        var Ve = O.slice(2, je - 2);
        return L += 2, P(Ve), O = O.slice(je), L += 2, pe({
          type: y,
          comment: Ve
        });
      }
    }
    function Ae() {
      var pe = z(), je = ce(n);
      if (je) {
        if (Ne(), !ce(s)) return re("property missing ':'");
        var Ve = ce(o), $e = pe({
          type: m,
          property: C(je[0].replace(e, p)),
          value: Ve ? C(Ve[0].replace(e, p)) : p
        });
        return ce(r), $e;
      }
    }
    function Oe() {
      var pe = [];
      ee(pe);
      for (var je; je = Ae(); )
        je !== !1 && (pe.push(je), ee(pe));
      return pe;
    }
    return te(), Oe();
  }
  function C(O) {
    return O ? O.replace(l, p) : p;
  }
  return qce = A, qce;
}
var W2e;
function IJe() {
  if (W2e) return IV;
  W2e = 1;
  var e = IV && IV.__importDefault || function(n) {
    return n && n.__esModule ? n : { default: n };
  };
  Object.defineProperty(IV, "__esModule", { value: !0 }), IV.default = i;
  const t = e(fJe());
  function i(n, s) {
    let o = null;
    if (!n || typeof n != "string")
      return o;
    const r = (0, t.default)(n), l = typeof s == "function";
    return r.forEach((c) => {
      if (c.type !== "declaration")
        return;
      const { property: h, value: I } = c;
      l ? s(h, I, c) : I && (o = o || {}, o[h] = I);
    }), o;
  }
  return IV;
}
var WZ = {}, Y2e;
function pJe() {
  if (Y2e) return WZ;
  Y2e = 1, Object.defineProperty(WZ, "__esModule", { value: !0 }), WZ.camelCase = void 0;
  var e = /^--[a-zA-Z0-9_-]+$/, t = /-([a-z])/g, i = /^[^-]+$/, n = /^-(webkit|moz|ms|o|khtml)-/, s = /^-(ms)-/, o = function(h) {
    return !h || i.test(h) || e.test(h);
  }, r = function(h, I) {
    return I.toUpperCase();
  }, l = function(h, I) {
    return "".concat(I, "-");
  }, c = function(h, I) {
    return I === void 0 && (I = {}), o(h) ? h : (h = h.toLowerCase(), I.reactCompat ? h = h.replace(s, l) : h = h.replace(n, l), h.replace(t, r));
  };
  return WZ.camelCase = c, WZ;
}
var YZ, q2e;
function mJe() {
  if (q2e) return YZ;
  q2e = 1;
  var e = YZ && YZ.__importDefault || function(s) {
    return s && s.__esModule ? s : { default: s };
  }, t = e(IJe()), i = pJe();
  function n(s, o) {
    var r = {};
    return !s || typeof s != "string" || (0, t.default)(s, function(l, c) {
      l && c && (r[(0, i.camelCase)(l, o)] = c);
    }), r;
  }
  return n.default = n, YZ = n, YZ;
}
var yJe = mJe();
const EJe = /* @__PURE__ */ rie(yJe), Oue = yNe("end"), d6 = yNe("start");
function yNe(e) {
  return t;
  function t(i) {
    const n = i && i.position && i.position[e] || {};
    if (typeof n.line == "number" && n.line > 0 && typeof n.column == "number" && n.column > 0)
      return {
        line: n.line,
        column: n.column,
        offset: typeof n.offset == "number" && n.offset > -1 ? n.offset : void 0
      };
  }
}
function gJe(e) {
  const t = d6(e), i = Oue(e);
  if (t && i)
    return { start: t, end: i };
}
function WJ(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? $2e(e.position) : "start" in e || "end" in e ? $2e(e) : "line" in e || "column" in e ? tpe(e) : "";
}
function tpe(e) {
  return K2e(e && e.line) + ":" + K2e(e && e.column);
}
function $2e(e) {
  return tpe(e && e.start) + "-" + tpe(e && e.end);
}
function K2e(e) {
  return e && typeof e == "number" ? e : 1;
}
class I3 extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(t, i, n) {
    super(), typeof i == "string" && (n = i, i = void 0);
    let s = "", o = {}, r = !1;
    if (i && ("line" in i && "column" in i ? o = { place: i } : "start" in i && "end" in i ? o = { place: i } : "type" in i ? o = {
      ancestors: [i],
      place: i.position
    } : o = { ...i }), typeof t == "string" ? s = t : !o.cause && t && (r = !0, s = t.message, o.cause = t), !o.ruleId && !o.source && typeof n == "string") {
      const c = n.indexOf(":");
      c === -1 ? o.ruleId = n : (o.source = n.slice(0, c), o.ruleId = n.slice(c + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const c = o.ancestors[o.ancestors.length - 1];
      c && (o.place = c.position);
    }
    const l = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file = "", this.message = s, this.line = l ? l.line : void 0, this.name = WJ(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = r && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual = void 0, this.expected = void 0, this.note = void 0, this.url = void 0;
  }
}
I3.prototype.file = "";
I3.prototype.name = "";
I3.prototype.reason = "";
I3.prototype.message = "";
I3.prototype.stack = "";
I3.prototype.column = void 0;
I3.prototype.line = void 0;
I3.prototype.ancestors = void 0;
I3.prototype.cause = void 0;
I3.prototype.fatal = void 0;
I3.prototype.place = void 0;
I3.prototype.ruleId = void 0;
I3.prototype.source = void 0;
const $me = {}.hasOwnProperty, wJe = /* @__PURE__ */ new Map(), TJe = /[A-Z]/g, RJe = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), vJe = /* @__PURE__ */ new Set(["td", "th"]), ENe = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function AJe(e, t) {
  if (!t || t.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const i = t.filePath || void 0;
  let n;
  if (t.development) {
    if (typeof t.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    n = _Je(i, t.jsxDEV);
  } else {
    if (typeof t.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof t.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    n = LJe(i, t.jsx, t.jsxs);
  }
  const s = {
    Fragment: t.Fragment,
    ancestors: [],
    components: t.components || {},
    create: n,
    elementAttributeNameCase: t.elementAttributeNameCase || "react",
    evaluater: t.createEvaluater ? t.createEvaluater() : void 0,
    filePath: i,
    ignoreInvalidStyle: t.ignoreInvalidStyle || !1,
    passKeys: t.passKeys !== !1,
    passNode: t.passNode || !1,
    schema: t.space === "svg" ? F8 : kie,
    stylePropertyNameCase: t.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: t.tableCellAlignToStyle !== !1
  }, o = gNe(s, e, void 0);
  return o && typeof o != "string" ? o : s.create(
    e,
    s.Fragment,
    { children: o || void 0 },
    void 0
  );
}
function gNe(e, t, i) {
  if (t.type === "element")
    return SJe(e, t, i);
  if (t.type === "mdxFlowExpression" || t.type === "mdxTextExpression")
    return bJe(e, t);
  if (t.type === "mdxJsxFlowElement" || t.type === "mdxJsxTextElement")
    return DJe(e, t, i);
  if (t.type === "mdxjsEsm")
    return NJe(e, t);
  if (t.type === "root")
    return CJe(e, t, i);
  if (t.type === "text")
    return OJe(e, t);
}
function SJe(e, t, i) {
  const n = e.schema;
  let s = n;
  t.tagName.toLowerCase() === "svg" && n.space === "html" && (s = F8, e.schema = s), e.ancestors.push(t);
  const o = TNe(e, t.tagName, !1), r = xJe(e, t);
  let l = Zme(e, t);
  return RJe.has(t.tagName) && (l = l.filter(function(c) {
    return typeof c == "string" ? !sJe(c) : !0;
  })), wNe(e, r, o, t), Kme(r, l), e.ancestors.pop(), e.schema = n, e.create(t, o, r, i);
}
function bJe(e, t) {
  if (t.data && t.data.estree && e.evaluater) {
    const n = t.data.estree.body[0];
    return n.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(n.expression);
  }
  zX(e, t.position);
}
function NJe(e, t) {
  if (t.data && t.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(t.data.estree)
    );
  zX(e, t.position);
}
function DJe(e, t, i) {
  const n = e.schema;
  let s = n;
  t.name === "svg" && n.space === "html" && (s = F8, e.schema = s), e.ancestors.push(t);
  const o = t.name === null ? e.Fragment : TNe(e, t.name, !0), r = PJe(e, t), l = Zme(e, t);
  return wNe(e, r, o, t), Kme(r, l), e.ancestors.pop(), e.schema = n, e.create(t, o, r, i);
}
function CJe(e, t, i) {
  const n = {};
  return Kme(n, Zme(e, t)), e.create(t, e.Fragment, n, i);
}
function OJe(e, t) {
  return t.value;
}
function wNe(e, t, i, n) {
  typeof i != "string" && i !== e.Fragment && e.passNode && (t.node = n);
}
function Kme(e, t) {
  if (t.length > 0) {
    const i = t.length > 1 ? t : t[0];
    i && (e.children = i);
  }
}
function LJe(e, t, i) {
  return n;
  function n(s, o, r, l) {
    const h = Array.isArray(r.children) ? i : t;
    return l ? h(o, r, l) : h(o, r);
  }
}
function _Je(e, t) {
  return i;
  function i(n, s, o, r) {
    const l = Array.isArray(o.children), c = d6(n);
    return t(
      s,
      o,
      r,
      l,
      {
        columnNumber: c ? c.column - 1 : void 0,
        fileName: e,
        lineNumber: c ? c.line : void 0
      },
      void 0
    );
  }
}
function xJe(e, t) {
  const i = {};
  let n, s;
  for (s in t.properties)
    if (s !== "children" && $me.call(t.properties, s)) {
      const o = MJe(e, s, t.properties[s]);
      if (o) {
        const [r, l] = o;
        e.tableCellAlignToStyle && r === "align" && typeof l == "string" && vJe.has(t.tagName) ? n = l : i[r] = l;
      }
    }
  if (n) {
    const o = (
      /** @type {Style} */
      i.style || (i.style = {})
    );
    o[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = n;
  }
  return i;
}
function PJe(e, t) {
  const i = {};
  for (const n of t.attributes)
    if (n.type === "mdxJsxExpressionAttribute")
      if (n.data && n.data.estree && e.evaluater) {
        const o = n.data.estree.body[0];
        o.type;
        const r = o.expression;
        r.type;
        const l = r.properties[0];
        l.type, Object.assign(
          i,
          e.evaluater.evaluateExpression(l.argument)
        );
      } else
        zX(e, t.position);
    else {
      const s = n.name;
      let o;
      if (n.value && typeof n.value == "object")
        if (n.value.data && n.value.data.estree && e.evaluater) {
          const l = n.value.data.estree.body[0];
          l.type, o = e.evaluater.evaluateExpression(l.expression);
        } else
          zX(e, t.position);
      else
        o = n.value === null ? !0 : n.value;
      i[s] = /** @type {Props[keyof Props]} */
      o;
    }
  return i;
}
function Zme(e, t) {
  const i = [];
  let n = -1;
  const s = e.passKeys ? /* @__PURE__ */ new Map() : wJe;
  for (; ++n < t.children.length; ) {
    const o = t.children[n];
    let r;
    if (e.passKeys) {
      const c = o.type === "element" ? o.tagName : o.type === "mdxJsxFlowElement" || o.type === "mdxJsxTextElement" ? o.name : void 0;
      if (c) {
        const h = s.get(c) || 0;
        r = c + "-" + h, s.set(c, h + 1);
      }
    }
    const l = gNe(e, o, r);
    l !== void 0 && i.push(l);
  }
  return i;
}
function MJe(e, t, i) {
  const n = Cue(e.schema, t);
  if (!(i == null || typeof i == "number" && Number.isNaN(i))) {
    if (Array.isArray(i) && (i = n.commaSeparated ? aNe(i) : mNe(i)), n.property === "style") {
      let s = typeof i == "object" ? i : UJe(e, String(i));
      return e.stylePropertyNameCase === "css" && (s = BJe(s)), ["style", s];
    }
    return [
      e.elementAttributeNameCase === "react" && n.space ? aJe[n.property] || n.property : n.attribute,
      i
    ];
  }
}
function UJe(e, t) {
  try {
    return EJe(t, { reactCompat: !0 });
  } catch (i) {
    if (e.ignoreInvalidStyle)
      return {};
    const n = (
      /** @type {Error} */
      i
    ), s = new I3("Cannot parse `style` attribute", {
      ancestors: e.ancestors,
      cause: n,
      ruleId: "style",
      source: "hast-util-to-jsx-runtime"
    });
    throw s.file = e.filePath || void 0, s.url = ENe + "#cannot-parse-style-attribute", s;
  }
}
function TNe(e, t, i) {
  let n;
  if (!i)
    n = { type: "Literal", value: t };
  else if (t.includes(".")) {
    const s = t.split(".");
    let o = -1, r;
    for (; ++o < s.length; ) {
      const l = H2e(s[o]) ? { type: "Identifier", name: s[o] } : { type: "Literal", value: s[o] };
      r = r ? {
        type: "MemberExpression",
        object: r,
        property: l,
        computed: !!(o && l.type === "Literal"),
        optional: !1
      } : l;
    }
    n = r;
  } else
    n = H2e(t) && !/^[a-z]/.test(t) ? { type: "Identifier", name: t } : { type: "Literal", value: t };
  if (n.type === "Literal") {
    const s = (
      /** @type {string | number} */
      n.value
    );
    return $me.call(e.components, s) ? e.components[s] : s;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(n);
  zX(e);
}
function zX(e, t) {
  const i = new I3(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: t,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw i.file = e.filePath || void 0, i.url = ENe + "#cannot-handle-mdx-estrees-without-createevaluater", i;
}
function BJe(e) {
  const t = {};
  let i;
  for (i in e)
    $me.call(e, i) && (t[FJe(i)] = e[i]);
  return t;
}
function FJe(e) {
  let t = e.replace(TJe, HJe);
  return t.slice(0, 3) === "ms-" && (t = "-" + t), t;
}
function HJe(e) {
  return "-" + e.toLowerCase();
}
const $ce = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, GJe = {};
function Qme(e, t) {
  const i = GJe, n = typeof i.includeImageAlt == "boolean" ? i.includeImageAlt : !0, s = typeof i.includeHtml == "boolean" ? i.includeHtml : !0;
  return RNe(e, n, s);
}
function RNe(e, t, i) {
  if (kJe(e)) {
    if ("value" in e)
      return e.type === "html" && !i ? "" : e.value;
    if (t && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return Z2e(e.children, t, i);
  }
  return Array.isArray(e) ? Z2e(e, t, i) : "";
}
function Z2e(e, t, i) {
  const n = [];
  let s = -1;
  for (; ++s < e.length; )
    n[s] = RNe(e[s], t, i);
  return n.join("");
}
function kJe(e) {
  return !!(e && typeof e == "object");
}
const Q2e = document.createElement("i");
function Jme(e) {
  const t = "&" + e + ";";
  Q2e.innerHTML = t;
  const i = Q2e.textContent;
  return i.charCodeAt(i.length - 1) === 59 && e !== "semi" || i === t ? !1 : i;
}
function R4(e, t, i, n) {
  const s = e.length;
  let o = 0, r;
  if (t < 0 ? t = -t > s ? 0 : s + t : t = t > s ? s : t, i = i > 0 ? i : 0, n.length < 1e4)
    r = Array.from(n), r.unshift(t, i), e.splice(...r);
  else
    for (i && e.splice(t, i); o < n.length; )
      r = n.slice(o, o + 1e4), r.unshift(t, 0), e.splice(...r), o += 1e4, t += 1e4;
}
function a5(e, t) {
  return e.length > 0 ? (R4(e, e.length, 0, t), e) : t;
}
const J2e = {}.hasOwnProperty;
function vNe(e) {
  const t = {};
  let i = -1;
  for (; ++i < e.length; )
    VJe(t, e[i]);
  return t;
}
function VJe(e, t) {
  let i;
  for (i in t) {
    const s = (J2e.call(e, i) ? e[i] : void 0) || (e[i] = {}), o = t[i];
    let r;
    if (o)
      for (r in o) {
        J2e.call(s, r) || (s[r] = []);
        const l = o[r];
        zJe(
          // @ts-expect-error Looks like a list.
          s[r],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function zJe(e, t) {
  let i = -1;
  const n = [];
  for (; ++i < t.length; )
    (t[i].add === "after" ? e : n).push(t[i]);
  R4(e, 0, 0, n);
}
function ANe(e, t) {
  const i = Number.parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    i < 9 || i === 11 || i > 13 && i < 32 || // Control character (DEL) of C0, and C1 controls.
    i > 126 && i < 160 || // Lone high surrogates and low surrogates.
    i > 55295 && i < 57344 || // Noncharacters.
    i > 64975 && i < 65008 || /* eslint-disable no-bitwise */
    (i & 65535) === 65535 || (i & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    i > 1114111 ? "�" : String.fromCodePoint(i)
  );
}
function _A(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Xy = H8(/[A-Za-z]/), h3 = H8(/[\dA-Za-z]/), jJe = H8(/[#-'*+\--9=?A-Z^-~]/);
function Ple(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const ipe = H8(/\d/), WJe = H8(/[\dA-Fa-f]/), YJe = H8(/[!-/:-@[-`{-~]/);
function vs(e) {
  return e !== null && e < -2;
}
function kl(e) {
  return e !== null && (e < 0 || e === 32);
}
function ir(e) {
  return e === -2 || e === -1 || e === 32;
}
const Lue = H8(new RegExp("\\p{P}|\\p{S}", "u")), NH = H8(/\s/);
function H8(e) {
  return t;
  function t(i) {
    return i !== null && i > -1 && e.test(String.fromCharCode(i));
  }
}
function cY(e) {
  const t = [];
  let i = -1, n = 0, s = 0;
  for (; ++i < e.length; ) {
    const o = e.charCodeAt(i);
    let r = "";
    if (o === 37 && h3(e.charCodeAt(i + 1)) && h3(e.charCodeAt(i + 2)))
      s = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (r = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const l = e.charCodeAt(i + 1);
      o < 56320 && l > 56319 && l < 57344 ? (r = String.fromCharCode(o, l), s = 1) : r = "�";
    } else
      r = String.fromCharCode(o);
    r && (t.push(e.slice(n, i), encodeURIComponent(r)), n = i + s + 1, r = ""), s && (i += s, s = 0);
  }
  return t.join("") + e.slice(n);
}
function Ar(e, t, i, n) {
  const s = n ? n - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return r;
  function r(c) {
    return ir(c) ? (e.enter(i), l(c)) : t(c);
  }
  function l(c) {
    return ir(c) && o++ < s ? (e.consume(c), l) : (e.exit(i), t(c));
  }
}
const qJe = {
  tokenize: $Je
};
function $Je(e) {
  const t = e.attempt(this.parser.constructs.contentInitial, n, s);
  let i;
  return t;
  function n(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), Ar(e, t, "linePrefix");
  }
  function s(l) {
    return e.enter("paragraph"), o(l);
  }
  function o(l) {
    const c = e.enter("chunkText", {
      contentType: "text",
      previous: i
    });
    return i && (i.next = c), i = c, r(l);
  }
  function r(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return vs(l) ? (e.consume(l), e.exit("chunkText"), o) : (e.consume(l), r);
  }
}
const KJe = {
  tokenize: ZJe
}, X2e = {
  tokenize: QJe
};
function ZJe(e) {
  const t = this, i = [];
  let n = 0, s, o, r;
  return l;
  function l(L) {
    if (n < i.length) {
      const P = i[n];
      return t.containerState = P[1], e.attempt(P[0].continuation, c, h)(L);
    }
    return h(L);
  }
  function c(L) {
    if (n++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, s && F();
      const P = t.events.length;
      let z = P, W;
      for (; z--; )
        if (t.events[z][0] === "exit" && t.events[z][1].type === "chunkFlow") {
          W = t.events[z][1].end;
          break;
        }
      R(n);
      let re = P;
      for (; re < t.events.length; )
        t.events[re][1].end = {
          ...W
        }, re++;
      return R4(t.events, z + 1, 0, t.events.slice(P)), t.events.length = re, h(L);
    }
    return l(L);
  }
  function h(L) {
    if (n === i.length) {
      if (!s)
        return y(L);
      if (s.currentConstruct && s.currentConstruct.concrete)
        return A(L);
      t.interrupt = !!(s.currentConstruct && !s._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(X2e, I, p)(L);
  }
  function I(L) {
    return s && F(), R(n), y(L);
  }
  function p(L) {
    return t.parser.lazy[t.now().line] = n !== i.length, r = t.now().offset, A(L);
  }
  function y(L) {
    return t.containerState = {}, e.attempt(X2e, m, A)(L);
  }
  function m(L) {
    return n++, i.push([t.currentConstruct, t.containerState]), y(L);
  }
  function A(L) {
    if (L === null) {
      s && F(), R(0), e.consume(L);
      return;
    }
    return s = s || t.parser.flow(t.now()), e.enter("chunkFlow", {
      _tokenizer: s,
      contentType: "flow",
      previous: o
    }), C(L);
  }
  function C(L) {
    if (L === null) {
      O(e.exit("chunkFlow"), !0), R(0), e.consume(L);
      return;
    }
    return vs(L) ? (e.consume(L), O(e.exit("chunkFlow")), n = 0, t.interrupt = void 0, l) : (e.consume(L), C);
  }
  function O(L, P) {
    const z = t.sliceStream(L);
    if (P && z.push(null), L.previous = o, o && (o.next = L), o = L, s.defineSkip(L.start), s.write(z), t.parser.lazy[L.start.line]) {
      let W = s.events.length;
      for (; W--; )
        if (
          // The token starts before the line ending…
          s.events[W][1].start.offset < r && // …and either is not ended yet…
          (!s.events[W][1].end || // …or ends after it.
          s.events[W][1].end.offset > r)
        )
          return;
      const re = t.events.length;
      let ce = re, te, ee;
      for (; ce--; )
        if (t.events[ce][0] === "exit" && t.events[ce][1].type === "chunkFlow") {
          if (te) {
            ee = t.events[ce][1].end;
            break;
          }
          te = !0;
        }
      for (R(n), W = re; W < t.events.length; )
        t.events[W][1].end = {
          ...ee
        }, W++;
      R4(t.events, ce + 1, 0, t.events.slice(re)), t.events.length = W;
    }
  }
  function R(L) {
    let P = i.length;
    for (; P-- > L; ) {
      const z = i[P];
      t.containerState = z[1], z[0].exit.call(t, e);
    }
    i.length = L;
  }
  function F() {
    s.write([null]), o = void 0, s = void 0, t.containerState._closeFlow = void 0;
  }
}
function QJe(e, t, i) {
  return Ar(e, e.attempt(this.parser.constructs.document, t, i), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function $W(e) {
  if (e === null || kl(e) || NH(e))
    return 1;
  if (Lue(e))
    return 2;
}
function _ue(e, t, i) {
  const n = [];
  let s = -1;
  for (; ++s < e.length; ) {
    const o = e[s].resolveAll;
    o && !n.includes(o) && (t = o(t, i), n.push(o));
  }
  return t;
}
const npe = {
  name: "attention",
  resolveAll: JJe,
  tokenize: XJe
};
function JJe(e, t) {
  let i = -1, n, s, o, r, l, c, h, I;
  for (; ++i < e.length; )
    if (e[i][0] === "enter" && e[i][1].type === "attentionSequence" && e[i][1]._close) {
      for (n = i; n--; )
        if (e[n][0] === "exit" && e[n][1].type === "attentionSequence" && e[n][1]._open && // If the markers are the same:
        t.sliceSerialize(e[n][1]).charCodeAt(0) === t.sliceSerialize(e[i][1]).charCodeAt(0)) {
          if ((e[n][1]._close || e[i][1]._open) && (e[i][1].end.offset - e[i][1].start.offset) % 3 && !((e[n][1].end.offset - e[n][1].start.offset + e[i][1].end.offset - e[i][1].start.offset) % 3))
            continue;
          c = e[n][1].end.offset - e[n][1].start.offset > 1 && e[i][1].end.offset - e[i][1].start.offset > 1 ? 2 : 1;
          const p = {
            ...e[n][1].end
          }, y = {
            ...e[i][1].start
          };
          e4e(p, -c), e4e(y, c), r = {
            type: c > 1 ? "strongSequence" : "emphasisSequence",
            start: p,
            end: {
              ...e[n][1].end
            }
          }, l = {
            type: c > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[i][1].start
            },
            end: y
          }, o = {
            type: c > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[n][1].end
            },
            end: {
              ...e[i][1].start
            }
          }, s = {
            type: c > 1 ? "strong" : "emphasis",
            start: {
              ...r.start
            },
            end: {
              ...l.end
            }
          }, e[n][1].end = {
            ...r.start
          }, e[i][1].start = {
            ...l.end
          }, h = [], e[n][1].end.offset - e[n][1].start.offset && (h = a5(h, [["enter", e[n][1], t], ["exit", e[n][1], t]])), h = a5(h, [["enter", s, t], ["enter", r, t], ["exit", r, t], ["enter", o, t]]), h = a5(h, _ue(t.parser.constructs.insideSpan.null, e.slice(n + 1, i), t)), h = a5(h, [["exit", o, t], ["enter", l, t], ["exit", l, t], ["exit", s, t]]), e[i][1].end.offset - e[i][1].start.offset ? (I = 2, h = a5(h, [["enter", e[i][1], t], ["exit", e[i][1], t]])) : I = 0, R4(e, n - 1, i - n + 3, h), i = n + h.length - I - 2;
          break;
        }
    }
  for (i = -1; ++i < e.length; )
    e[i][1].type === "attentionSequence" && (e[i][1].type = "data");
  return e;
}
function XJe(e, t) {
  const i = this.parser.constructs.attentionMarkers.null, n = this.previous, s = $W(n);
  let o;
  return r;
  function r(c) {
    return o = c, e.enter("attentionSequence"), l(c);
  }
  function l(c) {
    if (c === o)
      return e.consume(c), l;
    const h = e.exit("attentionSequence"), I = $W(c), p = !I || I === 2 && s || i.includes(c), y = !s || s === 2 && I || i.includes(n);
    return h._open = !!(o === 42 ? p : p && (s || !y)), h._close = !!(o === 42 ? y : y && (I || !p)), t(c);
  }
}
function e4e(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const eXe = {
  name: "autolink",
  tokenize: tXe
};
function tXe(e, t, i) {
  let n = 0;
  return s;
  function s(m) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(m), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(m) {
    return Xy(m) ? (e.consume(m), r) : m === 64 ? i(m) : h(m);
  }
  function r(m) {
    return m === 43 || m === 45 || m === 46 || h3(m) ? (n = 1, l(m)) : h(m);
  }
  function l(m) {
    return m === 58 ? (e.consume(m), n = 0, c) : (m === 43 || m === 45 || m === 46 || h3(m)) && n++ < 32 ? (e.consume(m), l) : (n = 0, h(m));
  }
  function c(m) {
    return m === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(m), e.exit("autolinkMarker"), e.exit("autolink"), t) : m === null || m === 32 || m === 60 || Ple(m) ? i(m) : (e.consume(m), c);
  }
  function h(m) {
    return m === 64 ? (e.consume(m), I) : jJe(m) ? (e.consume(m), h) : i(m);
  }
  function I(m) {
    return h3(m) ? p(m) : i(m);
  }
  function p(m) {
    return m === 46 ? (e.consume(m), n = 0, I) : m === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(m), e.exit("autolinkMarker"), e.exit("autolink"), t) : y(m);
  }
  function y(m) {
    if ((m === 45 || h3(m)) && n++ < 63) {
      const A = m === 45 ? y : p;
      return e.consume(m), A;
    }
    return i(m);
  }
}
const Vie = {
  partial: !0,
  tokenize: iXe
};
function iXe(e, t, i) {
  return n;
  function n(o) {
    return ir(o) ? Ar(e, s, "linePrefix")(o) : s(o);
  }
  function s(o) {
    return o === null || vs(o) ? t(o) : i(o);
  }
}
const SNe = {
  continuation: {
    tokenize: sXe
  },
  exit: oXe,
  name: "blockQuote",
  tokenize: nXe
};
function nXe(e, t, i) {
  const n = this;
  return s;
  function s(r) {
    if (r === 62) {
      const l = n.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(r), e.exit("blockQuoteMarker"), o;
    }
    return i(r);
  }
  function o(r) {
    return ir(r) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(r), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(r));
  }
}
function sXe(e, t, i) {
  const n = this;
  return s;
  function s(r) {
    return ir(r) ? Ar(e, o, "linePrefix", n.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(r) : o(r);
  }
  function o(r) {
    return e.attempt(SNe, t, i)(r);
  }
}
function oXe(e) {
  e.exit("blockQuote");
}
const bNe = {
  name: "characterEscape",
  tokenize: rXe
};
function rXe(e, t, i) {
  return n;
  function n(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), s;
  }
  function s(o) {
    return YJe(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : i(o);
  }
}
const NNe = {
  name: "characterReference",
  tokenize: lXe
};
function lXe(e, t, i) {
  const n = this;
  let s = 0, o, r;
  return l;
  function l(p) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(p), e.exit("characterReferenceMarker"), c;
  }
  function c(p) {
    return p === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(p), e.exit("characterReferenceMarkerNumeric"), h) : (e.enter("characterReferenceValue"), o = 31, r = h3, I(p));
  }
  function h(p) {
    return p === 88 || p === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(p), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, r = WJe, I) : (e.enter("characterReferenceValue"), o = 7, r = ipe, I(p));
  }
  function I(p) {
    if (p === 59 && s) {
      const y = e.exit("characterReferenceValue");
      return r === h3 && !Jme(n.sliceSerialize(y)) ? i(p) : (e.enter("characterReferenceMarker"), e.consume(p), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
    }
    return r(p) && s++ < o ? (e.consume(p), I) : i(p);
  }
}
const t4e = {
  partial: !0,
  tokenize: uXe
}, i4e = {
  concrete: !0,
  name: "codeFenced",
  tokenize: aXe
};
function aXe(e, t, i) {
  const n = this, s = {
    partial: !0,
    tokenize: z
  };
  let o = 0, r = 0, l;
  return c;
  function c(W) {
    return h(W);
  }
  function h(W) {
    const re = n.events[n.events.length - 1];
    return o = re && re[1].type === "linePrefix" ? re[2].sliceSerialize(re[1], !0).length : 0, l = W, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), I(W);
  }
  function I(W) {
    return W === l ? (r++, e.consume(W), I) : r < 3 ? i(W) : (e.exit("codeFencedFenceSequence"), ir(W) ? Ar(e, p, "whitespace")(W) : p(W));
  }
  function p(W) {
    return W === null || vs(W) ? (e.exit("codeFencedFence"), n.interrupt ? t(W) : e.check(t4e, C, P)(W)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), y(W));
  }
  function y(W) {
    return W === null || vs(W) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), p(W)) : ir(W) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), Ar(e, m, "whitespace")(W)) : W === 96 && W === l ? i(W) : (e.consume(W), y);
  }
  function m(W) {
    return W === null || vs(W) ? p(W) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), A(W));
  }
  function A(W) {
    return W === null || vs(W) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), p(W)) : W === 96 && W === l ? i(W) : (e.consume(W), A);
  }
  function C(W) {
    return e.attempt(s, P, O)(W);
  }
  function O(W) {
    return e.enter("lineEnding"), e.consume(W), e.exit("lineEnding"), R;
  }
  function R(W) {
    return o > 0 && ir(W) ? Ar(e, F, "linePrefix", o + 1)(W) : F(W);
  }
  function F(W) {
    return W === null || vs(W) ? e.check(t4e, C, P)(W) : (e.enter("codeFlowValue"), L(W));
  }
  function L(W) {
    return W === null || vs(W) ? (e.exit("codeFlowValue"), F(W)) : (e.consume(W), L);
  }
  function P(W) {
    return e.exit("codeFenced"), t(W);
  }
  function z(W, re, ce) {
    let te = 0;
    return ee;
    function ee(je) {
      return W.enter("lineEnding"), W.consume(je), W.exit("lineEnding"), Ne;
    }
    function Ne(je) {
      return W.enter("codeFencedFence"), ir(je) ? Ar(W, Ae, "linePrefix", n.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(je) : Ae(je);
    }
    function Ae(je) {
      return je === l ? (W.enter("codeFencedFenceSequence"), Oe(je)) : ce(je);
    }
    function Oe(je) {
      return je === l ? (te++, W.consume(je), Oe) : te >= r ? (W.exit("codeFencedFenceSequence"), ir(je) ? Ar(W, pe, "whitespace")(je) : pe(je)) : ce(je);
    }
    function pe(je) {
      return je === null || vs(je) ? (W.exit("codeFencedFence"), re(je)) : ce(je);
    }
  }
}
function uXe(e, t, i) {
  const n = this;
  return s;
  function s(r) {
    return r === null ? i(r) : (e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), o);
  }
  function o(r) {
    return n.parser.lazy[n.now().line] ? i(r) : t(r);
  }
}
const Kce = {
  name: "codeIndented",
  tokenize: cXe
}, dXe = {
  partial: !0,
  tokenize: hXe
};
function cXe(e, t, i) {
  const n = this;
  return s;
  function s(h) {
    return e.enter("codeIndented"), Ar(e, o, "linePrefix", 5)(h);
  }
  function o(h) {
    const I = n.events[n.events.length - 1];
    return I && I[1].type === "linePrefix" && I[2].sliceSerialize(I[1], !0).length >= 4 ? r(h) : i(h);
  }
  function r(h) {
    return h === null ? c(h) : vs(h) ? e.attempt(dXe, r, c)(h) : (e.enter("codeFlowValue"), l(h));
  }
  function l(h) {
    return h === null || vs(h) ? (e.exit("codeFlowValue"), r(h)) : (e.consume(h), l);
  }
  function c(h) {
    return e.exit("codeIndented"), t(h);
  }
}
function hXe(e, t, i) {
  const n = this;
  return s;
  function s(r) {
    return n.parser.lazy[n.now().line] ? i(r) : vs(r) ? (e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), s) : Ar(e, o, "linePrefix", 5)(r);
  }
  function o(r) {
    const l = n.events[n.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? t(r) : vs(r) ? s(r) : i(r);
  }
}
const fXe = {
  name: "codeText",
  previous: pXe,
  resolve: IXe,
  tokenize: mXe
};
function IXe(e) {
  let t = e.length - 4, i = 3, n, s;
  if ((e[i][1].type === "lineEnding" || e[i][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (n = i; ++n < t; )
      if (e[n][1].type === "codeTextData") {
        e[i][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", i += 2, t -= 2;
        break;
      }
  }
  for (n = i - 1, t++; ++n <= t; )
    s === void 0 ? n !== t && e[n][1].type !== "lineEnding" && (s = n) : (n === t || e[n][1].type === "lineEnding") && (e[s][1].type = "codeTextData", n !== s + 2 && (e[s][1].end = e[n - 1][1].end, e.splice(s + 2, n - s - 2), t -= n - s - 2, n = s + 2), s = void 0);
  return e;
}
function pXe(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function mXe(e, t, i) {
  let n = 0, s, o;
  return r;
  function r(p) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(p);
  }
  function l(p) {
    return p === 96 ? (e.consume(p), n++, l) : (e.exit("codeTextSequence"), c(p));
  }
  function c(p) {
    return p === null ? i(p) : p === 32 ? (e.enter("space"), e.consume(p), e.exit("space"), c) : p === 96 ? (o = e.enter("codeTextSequence"), s = 0, I(p)) : vs(p) ? (e.enter("lineEnding"), e.consume(p), e.exit("lineEnding"), c) : (e.enter("codeTextData"), h(p));
  }
  function h(p) {
    return p === null || p === 32 || p === 96 || vs(p) ? (e.exit("codeTextData"), c(p)) : (e.consume(p), h);
  }
  function I(p) {
    return p === 96 ? (e.consume(p), s++, I) : s === n ? (e.exit("codeTextSequence"), e.exit("codeText"), t(p)) : (o.type = "codeTextData", h(p));
  }
}
class yXe {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(t) {
    this.left = t ? [...t] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(t) {
    if (t < 0 || t >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + t + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return t < this.left.length ? this.left[t] : this.right[this.right.length - t + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(t, i) {
    const n = i ?? Number.POSITIVE_INFINITY;
    return n < this.left.length ? this.left.slice(t, n) : t > this.left.length ? this.right.slice(this.right.length - n + this.left.length, this.right.length - t + this.left.length).reverse() : this.left.slice(t).concat(this.right.slice(this.right.length - n + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(t, i, n) {
    const s = i || 0;
    this.setCursor(Math.trunc(t));
    const o = this.right.splice(this.right.length - s, Number.POSITIVE_INFINITY);
    return n && qZ(this.left, n), o.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(t) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(t);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(t) {
    this.setCursor(Number.POSITIVE_INFINITY), qZ(this.left, t);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(t) {
    this.setCursor(0), this.right.push(t);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(t) {
    this.setCursor(0), qZ(this.right, t.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(t) {
    if (!(t === this.left.length || t > this.left.length && this.right.length === 0 || t < 0 && this.left.length === 0))
      if (t < this.left.length) {
        const i = this.left.splice(t, Number.POSITIVE_INFINITY);
        qZ(this.right, i.reverse());
      } else {
        const i = this.right.splice(this.left.length + this.right.length - t, Number.POSITIVE_INFINITY);
        qZ(this.left, i.reverse());
      }
  }
}
function qZ(e, t) {
  let i = 0;
  if (t.length < 1e4)
    e.push(...t);
  else
    for (; i < t.length; )
      e.push(...t.slice(i, i + 1e4)), i += 1e4;
}
function DNe(e) {
  const t = {};
  let i = -1, n, s, o, r, l, c, h;
  const I = new yXe(e);
  for (; ++i < I.length; ) {
    for (; i in t; )
      i = t[i];
    if (n = I.get(i), i && n[1].type === "chunkFlow" && I.get(i - 1)[1].type === "listItemPrefix" && (c = n[1]._tokenizer.events, o = 0, o < c.length && c[o][1].type === "lineEndingBlank" && (o += 2), o < c.length && c[o][1].type === "content"))
      for (; ++o < c.length && c[o][1].type !== "content"; )
        c[o][1].type === "chunkText" && (c[o][1]._isInFirstContentOfListItem = !0, o++);
    if (n[0] === "enter")
      n[1].contentType && (Object.assign(t, EXe(I, i)), i = t[i], h = !0);
    else if (n[1]._container) {
      for (o = i, s = void 0; o--; )
        if (r = I.get(o), r[1].type === "lineEnding" || r[1].type === "lineEndingBlank")
          r[0] === "enter" && (s && (I.get(s)[1].type = "lineEndingBlank"), r[1].type = "lineEnding", s = o);
        else if (!(r[1].type === "linePrefix" || r[1].type === "listItemIndent")) break;
      s && (n[1].end = {
        ...I.get(s)[1].start
      }, l = I.slice(s, i), l.unshift(n), I.splice(s, i - s + 1, l));
    }
  }
  return R4(e, 0, Number.POSITIVE_INFINITY, I.slice(0)), !h;
}
function EXe(e, t) {
  const i = e.get(t)[1], n = e.get(t)[2];
  let s = t - 1;
  const o = [];
  let r = i._tokenizer;
  r || (r = n.parser[i.contentType](i.start), i._contentTypeTextTrailing && (r._contentTypeTextTrailing = !0));
  const l = r.events, c = [], h = {};
  let I, p, y = -1, m = i, A = 0, C = 0;
  const O = [C];
  for (; m; ) {
    for (; e.get(++s)[1] !== m; )
      ;
    o.push(s), m._tokenizer || (I = n.sliceStream(m), m.next || I.push(null), p && r.defineSkip(m.start), m._isInFirstContentOfListItem && (r._gfmTasklistFirstContentOfListItem = !0), r.write(I), m._isInFirstContentOfListItem && (r._gfmTasklistFirstContentOfListItem = void 0)), p = m, m = m.next;
  }
  for (m = i; ++y < l.length; )
    // Find a void token that includes a break.
    l[y][0] === "exit" && l[y - 1][0] === "enter" && l[y][1].type === l[y - 1][1].type && l[y][1].start.line !== l[y][1].end.line && (C = y + 1, O.push(C), m._tokenizer = void 0, m.previous = void 0, m = m.next);
  for (r.events = [], m ? (m._tokenizer = void 0, m.previous = void 0) : O.pop(), y = O.length; y--; ) {
    const R = l.slice(O[y], O[y + 1]), F = o.pop();
    c.push([F, F + R.length - 1]), e.splice(F, 2, R);
  }
  for (c.reverse(), y = -1; ++y < c.length; )
    h[A + c[y][0]] = A + c[y][1], A += c[y][1] - c[y][0] - 1;
  return h;
}
const gXe = {
  resolve: TXe,
  tokenize: RXe
}, wXe = {
  partial: !0,
  tokenize: vXe
};
function TXe(e) {
  return DNe(e), e;
}
function RXe(e, t) {
  let i;
  return n;
  function n(l) {
    return e.enter("content"), i = e.enter("chunkContent", {
      contentType: "content"
    }), s(l);
  }
  function s(l) {
    return l === null ? o(l) : vs(l) ? e.check(wXe, r, o)(l) : (e.consume(l), s);
  }
  function o(l) {
    return e.exit("chunkContent"), e.exit("content"), t(l);
  }
  function r(l) {
    return e.consume(l), e.exit("chunkContent"), i.next = e.enter("chunkContent", {
      contentType: "content",
      previous: i
    }), i = i.next, s;
  }
}
function vXe(e, t, i) {
  const n = this;
  return s;
  function s(r) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), Ar(e, o, "linePrefix");
  }
  function o(r) {
    if (r === null || vs(r))
      return i(r);
    const l = n.events[n.events.length - 1];
    return !n.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? t(r) : e.interrupt(n.parser.constructs.flow, i, t)(r);
  }
}
function CNe(e, t, i, n, s, o, r, l, c) {
  const h = c || Number.POSITIVE_INFINITY;
  let I = 0;
  return p;
  function p(R) {
    return R === 60 ? (e.enter(n), e.enter(s), e.enter(o), e.consume(R), e.exit(o), y) : R === null || R === 32 || R === 41 || Ple(R) ? i(R) : (e.enter(n), e.enter(r), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), C(R));
  }
  function y(R) {
    return R === 62 ? (e.enter(o), e.consume(R), e.exit(o), e.exit(s), e.exit(n), t) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), m(R));
  }
  function m(R) {
    return R === 62 ? (e.exit("chunkString"), e.exit(l), y(R)) : R === null || R === 60 || vs(R) ? i(R) : (e.consume(R), R === 92 ? A : m);
  }
  function A(R) {
    return R === 60 || R === 62 || R === 92 ? (e.consume(R), m) : m(R);
  }
  function C(R) {
    return !I && (R === null || R === 41 || kl(R)) ? (e.exit("chunkString"), e.exit(l), e.exit(r), e.exit(n), t(R)) : I < h && R === 40 ? (e.consume(R), I++, C) : R === 41 ? (e.consume(R), I--, C) : R === null || R === 32 || R === 40 || Ple(R) ? i(R) : (e.consume(R), R === 92 ? O : C);
  }
  function O(R) {
    return R === 40 || R === 41 || R === 92 ? (e.consume(R), C) : C(R);
  }
}
function ONe(e, t, i, n, s, o) {
  const r = this;
  let l = 0, c;
  return h;
  function h(m) {
    return e.enter(n), e.enter(s), e.consume(m), e.exit(s), e.enter(o), I;
  }
  function I(m) {
    return l > 999 || m === null || m === 91 || m === 93 && !c || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    m === 94 && !l && "_hiddenFootnoteSupport" in r.parser.constructs ? i(m) : m === 93 ? (e.exit(o), e.enter(s), e.consume(m), e.exit(s), e.exit(n), t) : vs(m) ? (e.enter("lineEnding"), e.consume(m), e.exit("lineEnding"), I) : (e.enter("chunkString", {
      contentType: "string"
    }), p(m));
  }
  function p(m) {
    return m === null || m === 91 || m === 93 || vs(m) || l++ > 999 ? (e.exit("chunkString"), I(m)) : (e.consume(m), c || (c = !ir(m)), m === 92 ? y : p);
  }
  function y(m) {
    return m === 91 || m === 92 || m === 93 ? (e.consume(m), l++, p) : p(m);
  }
}
function LNe(e, t, i, n, s, o) {
  let r;
  return l;
  function l(y) {
    return y === 34 || y === 39 || y === 40 ? (e.enter(n), e.enter(s), e.consume(y), e.exit(s), r = y === 40 ? 41 : y, c) : i(y);
  }
  function c(y) {
    return y === r ? (e.enter(s), e.consume(y), e.exit(s), e.exit(n), t) : (e.enter(o), h(y));
  }
  function h(y) {
    return y === r ? (e.exit(o), c(r)) : y === null ? i(y) : vs(y) ? (e.enter("lineEnding"), e.consume(y), e.exit("lineEnding"), Ar(e, h, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), I(y));
  }
  function I(y) {
    return y === r || y === null || vs(y) ? (e.exit("chunkString"), h(y)) : (e.consume(y), y === 92 ? p : I);
  }
  function p(y) {
    return y === r || y === 92 ? (e.consume(y), I) : I(y);
  }
}
function YJ(e, t) {
  let i;
  return n;
  function n(s) {
    return vs(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), i = !0, n) : ir(s) ? Ar(e, n, i ? "linePrefix" : "lineSuffix")(s) : t(s);
  }
}
const AXe = {
  name: "definition",
  tokenize: bXe
}, SXe = {
  partial: !0,
  tokenize: NXe
};
function bXe(e, t, i) {
  const n = this;
  let s;
  return o;
  function o(m) {
    return e.enter("definition"), r(m);
  }
  function r(m) {
    return ONe.call(
      n,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      i,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(m);
  }
  function l(m) {
    return s = _A(n.sliceSerialize(n.events[n.events.length - 1][1]).slice(1, -1)), m === 58 ? (e.enter("definitionMarker"), e.consume(m), e.exit("definitionMarker"), c) : i(m);
  }
  function c(m) {
    return kl(m) ? YJ(e, h)(m) : h(m);
  }
  function h(m) {
    return CNe(
      e,
      I,
      // Note: we don’t need to reset the way `markdown-rs` does.
      i,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(m);
  }
  function I(m) {
    return e.attempt(SXe, p, p)(m);
  }
  function p(m) {
    return ir(m) ? Ar(e, y, "whitespace")(m) : y(m);
  }
  function y(m) {
    return m === null || vs(m) ? (e.exit("definition"), n.parser.defined.push(s), t(m)) : i(m);
  }
}
function NXe(e, t, i) {
  return n;
  function n(l) {
    return kl(l) ? YJ(e, s)(l) : i(l);
  }
  function s(l) {
    return LNe(e, o, i, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(l);
  }
  function o(l) {
    return ir(l) ? Ar(e, r, "whitespace")(l) : r(l);
  }
  function r(l) {
    return l === null || vs(l) ? t(l) : i(l);
  }
}
const DXe = {
  name: "hardBreakEscape",
  tokenize: CXe
};
function CXe(e, t, i) {
  return n;
  function n(o) {
    return e.enter("hardBreakEscape"), e.consume(o), s;
  }
  function s(o) {
    return vs(o) ? (e.exit("hardBreakEscape"), t(o)) : i(o);
  }
}
const OXe = {
  name: "headingAtx",
  resolve: LXe,
  tokenize: _Xe
};
function LXe(e, t) {
  let i = e.length - 2, n = 3, s, o;
  return e[n][1].type === "whitespace" && (n += 2), i - 2 > n && e[i][1].type === "whitespace" && (i -= 2), e[i][1].type === "atxHeadingSequence" && (n === i - 1 || i - 4 > n && e[i - 2][1].type === "whitespace") && (i -= n + 1 === i ? 2 : 4), i > n && (s = {
    type: "atxHeadingText",
    start: e[n][1].start,
    end: e[i][1].end
  }, o = {
    type: "chunkText",
    start: e[n][1].start,
    end: e[i][1].end,
    contentType: "text"
  }, R4(e, n, i - n + 1, [["enter", s, t], ["enter", o, t], ["exit", o, t], ["exit", s, t]])), e;
}
function _Xe(e, t, i) {
  let n = 0;
  return s;
  function s(I) {
    return e.enter("atxHeading"), o(I);
  }
  function o(I) {
    return e.enter("atxHeadingSequence"), r(I);
  }
  function r(I) {
    return I === 35 && n++ < 6 ? (e.consume(I), r) : I === null || kl(I) ? (e.exit("atxHeadingSequence"), l(I)) : i(I);
  }
  function l(I) {
    return I === 35 ? (e.enter("atxHeadingSequence"), c(I)) : I === null || vs(I) ? (e.exit("atxHeading"), t(I)) : ir(I) ? Ar(e, l, "whitespace")(I) : (e.enter("atxHeadingText"), h(I));
  }
  function c(I) {
    return I === 35 ? (e.consume(I), c) : (e.exit("atxHeadingSequence"), l(I));
  }
  function h(I) {
    return I === null || I === 35 || kl(I) ? (e.exit("atxHeadingText"), l(I)) : (e.consume(I), h);
  }
}
const xXe = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], n4e = ["pre", "script", "style", "textarea"], PXe = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: BXe,
  tokenize: FXe
}, MXe = {
  partial: !0,
  tokenize: GXe
}, UXe = {
  partial: !0,
  tokenize: HXe
};
function BXe(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function FXe(e, t, i) {
  const n = this;
  let s, o, r, l, c;
  return h;
  function h(it) {
    return I(it);
  }
  function I(it) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(it), p;
  }
  function p(it) {
    return it === 33 ? (e.consume(it), y) : it === 47 ? (e.consume(it), o = !0, C) : it === 63 ? (e.consume(it), s = 3, n.interrupt ? t : ze) : Xy(it) ? (e.consume(it), r = String.fromCharCode(it), O) : i(it);
  }
  function y(it) {
    return it === 45 ? (e.consume(it), s = 2, m) : it === 91 ? (e.consume(it), s = 5, l = 0, A) : Xy(it) ? (e.consume(it), s = 4, n.interrupt ? t : ze) : i(it);
  }
  function m(it) {
    return it === 45 ? (e.consume(it), n.interrupt ? t : ze) : i(it);
  }
  function A(it) {
    const Dt = "CDATA[";
    return it === Dt.charCodeAt(l++) ? (e.consume(it), l === Dt.length ? n.interrupt ? t : Ae : A) : i(it);
  }
  function C(it) {
    return Xy(it) ? (e.consume(it), r = String.fromCharCode(it), O) : i(it);
  }
  function O(it) {
    if (it === null || it === 47 || it === 62 || kl(it)) {
      const Dt = it === 47, Ct = r.toLowerCase();
      return !Dt && !o && n4e.includes(Ct) ? (s = 1, n.interrupt ? t(it) : Ae(it)) : xXe.includes(r.toLowerCase()) ? (s = 6, Dt ? (e.consume(it), R) : n.interrupt ? t(it) : Ae(it)) : (s = 7, n.interrupt && !n.parser.lazy[n.now().line] ? i(it) : o ? F(it) : L(it));
    }
    return it === 45 || h3(it) ? (e.consume(it), r += String.fromCharCode(it), O) : i(it);
  }
  function R(it) {
    return it === 62 ? (e.consume(it), n.interrupt ? t : Ae) : i(it);
  }
  function F(it) {
    return ir(it) ? (e.consume(it), F) : ee(it);
  }
  function L(it) {
    return it === 47 ? (e.consume(it), ee) : it === 58 || it === 95 || Xy(it) ? (e.consume(it), P) : ir(it) ? (e.consume(it), L) : ee(it);
  }
  function P(it) {
    return it === 45 || it === 46 || it === 58 || it === 95 || h3(it) ? (e.consume(it), P) : z(it);
  }
  function z(it) {
    return it === 61 ? (e.consume(it), W) : ir(it) ? (e.consume(it), z) : L(it);
  }
  function W(it) {
    return it === null || it === 60 || it === 61 || it === 62 || it === 96 ? i(it) : it === 34 || it === 39 ? (e.consume(it), c = it, re) : ir(it) ? (e.consume(it), W) : ce(it);
  }
  function re(it) {
    return it === c ? (e.consume(it), c = null, te) : it === null || vs(it) ? i(it) : (e.consume(it), re);
  }
  function ce(it) {
    return it === null || it === 34 || it === 39 || it === 47 || it === 60 || it === 61 || it === 62 || it === 96 || kl(it) ? z(it) : (e.consume(it), ce);
  }
  function te(it) {
    return it === 47 || it === 62 || ir(it) ? L(it) : i(it);
  }
  function ee(it) {
    return it === 62 ? (e.consume(it), Ne) : i(it);
  }
  function Ne(it) {
    return it === null || vs(it) ? Ae(it) : ir(it) ? (e.consume(it), Ne) : i(it);
  }
  function Ae(it) {
    return it === 45 && s === 2 ? (e.consume(it), Ve) : it === 60 && s === 1 ? (e.consume(it), $e) : it === 62 && s === 4 ? (e.consume(it), mt) : it === 63 && s === 3 ? (e.consume(it), ze) : it === 93 && s === 5 ? (e.consume(it), Rt) : vs(it) && (s === 6 || s === 7) ? (e.exit("htmlFlowData"), e.check(MXe, Et, Oe)(it)) : it === null || vs(it) ? (e.exit("htmlFlowData"), Oe(it)) : (e.consume(it), Ae);
  }
  function Oe(it) {
    return e.check(UXe, pe, Et)(it);
  }
  function pe(it) {
    return e.enter("lineEnding"), e.consume(it), e.exit("lineEnding"), je;
  }
  function je(it) {
    return it === null || vs(it) ? Oe(it) : (e.enter("htmlFlowData"), Ae(it));
  }
  function Ve(it) {
    return it === 45 ? (e.consume(it), ze) : Ae(it);
  }
  function $e(it) {
    return it === 47 ? (e.consume(it), r = "", vt) : Ae(it);
  }
  function vt(it) {
    if (it === 62) {
      const Dt = r.toLowerCase();
      return n4e.includes(Dt) ? (e.consume(it), mt) : Ae(it);
    }
    return Xy(it) && r.length < 8 ? (e.consume(it), r += String.fromCharCode(it), vt) : Ae(it);
  }
  function Rt(it) {
    return it === 93 ? (e.consume(it), ze) : Ae(it);
  }
  function ze(it) {
    return it === 62 ? (e.consume(it), mt) : it === 45 && s === 2 ? (e.consume(it), ze) : Ae(it);
  }
  function mt(it) {
    return it === null || vs(it) ? (e.exit("htmlFlowData"), Et(it)) : (e.consume(it), mt);
  }
  function Et(it) {
    return e.exit("htmlFlow"), t(it);
  }
}
function HXe(e, t, i) {
  const n = this;
  return s;
  function s(r) {
    return vs(r) ? (e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), o) : i(r);
  }
  function o(r) {
    return n.parser.lazy[n.now().line] ? i(r) : t(r);
  }
}
function GXe(e, t, i) {
  return n;
  function n(s) {
    return e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), e.attempt(Vie, t, i);
  }
}
const kXe = {
  name: "htmlText",
  tokenize: VXe
};
function VXe(e, t, i) {
  const n = this;
  let s, o, r;
  return l;
  function l(ze) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(ze), c;
  }
  function c(ze) {
    return ze === 33 ? (e.consume(ze), h) : ze === 47 ? (e.consume(ze), z) : ze === 63 ? (e.consume(ze), L) : Xy(ze) ? (e.consume(ze), ce) : i(ze);
  }
  function h(ze) {
    return ze === 45 ? (e.consume(ze), I) : ze === 91 ? (e.consume(ze), o = 0, A) : Xy(ze) ? (e.consume(ze), F) : i(ze);
  }
  function I(ze) {
    return ze === 45 ? (e.consume(ze), m) : i(ze);
  }
  function p(ze) {
    return ze === null ? i(ze) : ze === 45 ? (e.consume(ze), y) : vs(ze) ? (r = p, $e(ze)) : (e.consume(ze), p);
  }
  function y(ze) {
    return ze === 45 ? (e.consume(ze), m) : p(ze);
  }
  function m(ze) {
    return ze === 62 ? Ve(ze) : ze === 45 ? y(ze) : p(ze);
  }
  function A(ze) {
    const mt = "CDATA[";
    return ze === mt.charCodeAt(o++) ? (e.consume(ze), o === mt.length ? C : A) : i(ze);
  }
  function C(ze) {
    return ze === null ? i(ze) : ze === 93 ? (e.consume(ze), O) : vs(ze) ? (r = C, $e(ze)) : (e.consume(ze), C);
  }
  function O(ze) {
    return ze === 93 ? (e.consume(ze), R) : C(ze);
  }
  function R(ze) {
    return ze === 62 ? Ve(ze) : ze === 93 ? (e.consume(ze), R) : C(ze);
  }
  function F(ze) {
    return ze === null || ze === 62 ? Ve(ze) : vs(ze) ? (r = F, $e(ze)) : (e.consume(ze), F);
  }
  function L(ze) {
    return ze === null ? i(ze) : ze === 63 ? (e.consume(ze), P) : vs(ze) ? (r = L, $e(ze)) : (e.consume(ze), L);
  }
  function P(ze) {
    return ze === 62 ? Ve(ze) : L(ze);
  }
  function z(ze) {
    return Xy(ze) ? (e.consume(ze), W) : i(ze);
  }
  function W(ze) {
    return ze === 45 || h3(ze) ? (e.consume(ze), W) : re(ze);
  }
  function re(ze) {
    return vs(ze) ? (r = re, $e(ze)) : ir(ze) ? (e.consume(ze), re) : Ve(ze);
  }
  function ce(ze) {
    return ze === 45 || h3(ze) ? (e.consume(ze), ce) : ze === 47 || ze === 62 || kl(ze) ? te(ze) : i(ze);
  }
  function te(ze) {
    return ze === 47 ? (e.consume(ze), Ve) : ze === 58 || ze === 95 || Xy(ze) ? (e.consume(ze), ee) : vs(ze) ? (r = te, $e(ze)) : ir(ze) ? (e.consume(ze), te) : Ve(ze);
  }
  function ee(ze) {
    return ze === 45 || ze === 46 || ze === 58 || ze === 95 || h3(ze) ? (e.consume(ze), ee) : Ne(ze);
  }
  function Ne(ze) {
    return ze === 61 ? (e.consume(ze), Ae) : vs(ze) ? (r = Ne, $e(ze)) : ir(ze) ? (e.consume(ze), Ne) : te(ze);
  }
  function Ae(ze) {
    return ze === null || ze === 60 || ze === 61 || ze === 62 || ze === 96 ? i(ze) : ze === 34 || ze === 39 ? (e.consume(ze), s = ze, Oe) : vs(ze) ? (r = Ae, $e(ze)) : ir(ze) ? (e.consume(ze), Ae) : (e.consume(ze), pe);
  }
  function Oe(ze) {
    return ze === s ? (e.consume(ze), s = void 0, je) : ze === null ? i(ze) : vs(ze) ? (r = Oe, $e(ze)) : (e.consume(ze), Oe);
  }
  function pe(ze) {
    return ze === null || ze === 34 || ze === 39 || ze === 60 || ze === 61 || ze === 96 ? i(ze) : ze === 47 || ze === 62 || kl(ze) ? te(ze) : (e.consume(ze), pe);
  }
  function je(ze) {
    return ze === 47 || ze === 62 || kl(ze) ? te(ze) : i(ze);
  }
  function Ve(ze) {
    return ze === 62 ? (e.consume(ze), e.exit("htmlTextData"), e.exit("htmlText"), t) : i(ze);
  }
  function $e(ze) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(ze), e.exit("lineEnding"), vt;
  }
  function vt(ze) {
    return ir(ze) ? Ar(e, Rt, "linePrefix", n.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(ze) : Rt(ze);
  }
  function Rt(ze) {
    return e.enter("htmlTextData"), r(ze);
  }
}
const Xme = {
  name: "labelEnd",
  resolveAll: YXe,
  resolveTo: qXe,
  tokenize: $Xe
}, zXe = {
  tokenize: KXe
}, jXe = {
  tokenize: ZXe
}, WXe = {
  tokenize: QXe
};
function YXe(e) {
  let t = -1;
  const i = [];
  for (; ++t < e.length; ) {
    const n = e[t][1];
    if (i.push(e[t]), n.type === "labelImage" || n.type === "labelLink" || n.type === "labelEnd") {
      const s = n.type === "labelImage" ? 4 : 2;
      n.type = "data", t += s;
    }
  }
  return e.length !== i.length && R4(e, 0, e.length, i), e;
}
function qXe(e, t) {
  let i = e.length, n = 0, s, o, r, l;
  for (; i--; )
    if (s = e[i][1], o) {
      if (s.type === "link" || s.type === "labelLink" && s._inactive)
        break;
      e[i][0] === "enter" && s.type === "labelLink" && (s._inactive = !0);
    } else if (r) {
      if (e[i][0] === "enter" && (s.type === "labelImage" || s.type === "labelLink") && !s._balanced && (o = i, s.type !== "labelLink")) {
        n = 2;
        break;
      }
    } else s.type === "labelEnd" && (r = i);
  const c = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, h = {
    type: "label",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[r][1].end
    }
  }, I = {
    type: "labelText",
    start: {
      ...e[o + n + 2][1].end
    },
    end: {
      ...e[r - 2][1].start
    }
  };
  return l = [["enter", c, t], ["enter", h, t]], l = a5(l, e.slice(o + 1, o + n + 3)), l = a5(l, [["enter", I, t]]), l = a5(l, _ue(t.parser.constructs.insideSpan.null, e.slice(o + n + 4, r - 3), t)), l = a5(l, [["exit", I, t], e[r - 2], e[r - 1], ["exit", h, t]]), l = a5(l, e.slice(r + 1)), l = a5(l, [["exit", c, t]]), R4(e, o, e.length, l), e;
}
function $Xe(e, t, i) {
  const n = this;
  let s = n.events.length, o, r;
  for (; s--; )
    if ((n.events[s][1].type === "labelImage" || n.events[s][1].type === "labelLink") && !n.events[s][1]._balanced) {
      o = n.events[s][1];
      break;
    }
  return l;
  function l(y) {
    return o ? o._inactive ? p(y) : (r = n.parser.defined.includes(_A(n.sliceSerialize({
      start: o.end,
      end: n.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(y), e.exit("labelMarker"), e.exit("labelEnd"), c) : i(y);
  }
  function c(y) {
    return y === 40 ? e.attempt(zXe, I, r ? I : p)(y) : y === 91 ? e.attempt(jXe, I, r ? h : p)(y) : r ? I(y) : p(y);
  }
  function h(y) {
    return e.attempt(WXe, I, p)(y);
  }
  function I(y) {
    return t(y);
  }
  function p(y) {
    return o._balanced = !0, i(y);
  }
}
function KXe(e, t, i) {
  return n;
  function n(p) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(p), e.exit("resourceMarker"), s;
  }
  function s(p) {
    return kl(p) ? YJ(e, o)(p) : o(p);
  }
  function o(p) {
    return p === 41 ? I(p) : CNe(e, r, l, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(p);
  }
  function r(p) {
    return kl(p) ? YJ(e, c)(p) : I(p);
  }
  function l(p) {
    return i(p);
  }
  function c(p) {
    return p === 34 || p === 39 || p === 40 ? LNe(e, h, i, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(p) : I(p);
  }
  function h(p) {
    return kl(p) ? YJ(e, I)(p) : I(p);
  }
  function I(p) {
    return p === 41 ? (e.enter("resourceMarker"), e.consume(p), e.exit("resourceMarker"), e.exit("resource"), t) : i(p);
  }
}
function ZXe(e, t, i) {
  const n = this;
  return s;
  function s(l) {
    return ONe.call(n, e, o, r, "reference", "referenceMarker", "referenceString")(l);
  }
  function o(l) {
    return n.parser.defined.includes(_A(n.sliceSerialize(n.events[n.events.length - 1][1]).slice(1, -1))) ? t(l) : i(l);
  }
  function r(l) {
    return i(l);
  }
}
function QXe(e, t, i) {
  return n;
  function n(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), s;
  }
  function s(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), t) : i(o);
  }
}
const JXe = {
  name: "labelStartImage",
  resolveAll: Xme.resolveAll,
  tokenize: XXe
};
function XXe(e, t, i) {
  const n = this;
  return s;
  function s(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), o;
  }
  function o(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), r) : i(l);
  }
  function r(l) {
    return l === 94 && "_hiddenFootnoteSupport" in n.parser.constructs ? i(l) : t(l);
  }
}
const eet = {
  name: "labelStartLink",
  resolveAll: Xme.resolveAll,
  tokenize: tet
};
function tet(e, t, i) {
  const n = this;
  return s;
  function s(r) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(r), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(r) {
    return r === 94 && "_hiddenFootnoteSupport" in n.parser.constructs ? i(r) : t(r);
  }
}
const Zce = {
  name: "lineEnding",
  tokenize: iet
};
function iet(e, t) {
  return i;
  function i(n) {
    return e.enter("lineEnding"), e.consume(n), e.exit("lineEnding"), Ar(e, t, "linePrefix");
  }
}
const xre = {
  name: "thematicBreak",
  tokenize: net
};
function net(e, t, i) {
  let n = 0, s;
  return o;
  function o(h) {
    return e.enter("thematicBreak"), r(h);
  }
  function r(h) {
    return s = h, l(h);
  }
  function l(h) {
    return h === s ? (e.enter("thematicBreakSequence"), c(h)) : n >= 3 && (h === null || vs(h)) ? (e.exit("thematicBreak"), t(h)) : i(h);
  }
  function c(h) {
    return h === s ? (e.consume(h), n++, c) : (e.exit("thematicBreakSequence"), ir(h) ? Ar(e, l, "whitespace")(h) : l(h));
  }
}
const lg = {
  continuation: {
    tokenize: aet
  },
  exit: det,
  name: "list",
  tokenize: ret
}, set = {
  partial: !0,
  tokenize: cet
}, oet = {
  partial: !0,
  tokenize: uet
};
function ret(e, t, i) {
  const n = this, s = n.events[n.events.length - 1];
  let o = s && s[1].type === "linePrefix" ? s[2].sliceSerialize(s[1], !0).length : 0, r = 0;
  return l;
  function l(m) {
    const A = n.containerState.type || (m === 42 || m === 43 || m === 45 ? "listUnordered" : "listOrdered");
    if (A === "listUnordered" ? !n.containerState.marker || m === n.containerState.marker : ipe(m)) {
      if (n.containerState.type || (n.containerState.type = A, e.enter(A, {
        _container: !0
      })), A === "listUnordered")
        return e.enter("listItemPrefix"), m === 42 || m === 45 ? e.check(xre, i, h)(m) : h(m);
      if (!n.interrupt || m === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), c(m);
    }
    return i(m);
  }
  function c(m) {
    return ipe(m) && ++r < 10 ? (e.consume(m), c) : (!n.interrupt || r < 2) && (n.containerState.marker ? m === n.containerState.marker : m === 41 || m === 46) ? (e.exit("listItemValue"), h(m)) : i(m);
  }
  function h(m) {
    return e.enter("listItemMarker"), e.consume(m), e.exit("listItemMarker"), n.containerState.marker = n.containerState.marker || m, e.check(
      Vie,
      // Can’t be empty when interrupting.
      n.interrupt ? i : I,
      e.attempt(set, y, p)
    );
  }
  function I(m) {
    return n.containerState.initialBlankLine = !0, o++, y(m);
  }
  function p(m) {
    return ir(m) ? (e.enter("listItemPrefixWhitespace"), e.consume(m), e.exit("listItemPrefixWhitespace"), y) : i(m);
  }
  function y(m) {
    return n.containerState.size = o + n.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(m);
  }
}
function aet(e, t, i) {
  const n = this;
  return n.containerState._closeFlow = void 0, e.check(Vie, s, o);
  function s(l) {
    return n.containerState.furtherBlankLines = n.containerState.furtherBlankLines || n.containerState.initialBlankLine, Ar(e, t, "listItemIndent", n.containerState.size + 1)(l);
  }
  function o(l) {
    return n.containerState.furtherBlankLines || !ir(l) ? (n.containerState.furtherBlankLines = void 0, n.containerState.initialBlankLine = void 0, r(l)) : (n.containerState.furtherBlankLines = void 0, n.containerState.initialBlankLine = void 0, e.attempt(oet, t, r)(l));
  }
  function r(l) {
    return n.containerState._closeFlow = !0, n.interrupt = void 0, Ar(e, e.attempt(lg, t, i), "linePrefix", n.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
  }
}
function uet(e, t, i) {
  const n = this;
  return Ar(e, s, "listItemIndent", n.containerState.size + 1);
  function s(o) {
    const r = n.events[n.events.length - 1];
    return r && r[1].type === "listItemIndent" && r[2].sliceSerialize(r[1], !0).length === n.containerState.size ? t(o) : i(o);
  }
}
function det(e) {
  e.exit(this.containerState.type);
}
function cet(e, t, i) {
  const n = this;
  return Ar(e, s, "listItemPrefixWhitespace", n.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function s(o) {
    const r = n.events[n.events.length - 1];
    return !ir(o) && r && r[1].type === "listItemPrefixWhitespace" ? t(o) : i(o);
  }
}
const s4e = {
  name: "setextUnderline",
  resolveTo: het,
  tokenize: fet
};
function het(e, t) {
  let i = e.length, n, s, o;
  for (; i--; )
    if (e[i][0] === "enter") {
      if (e[i][1].type === "content") {
        n = i;
        break;
      }
      e[i][1].type === "paragraph" && (s = i);
    } else
      e[i][1].type === "content" && e.splice(i, 1), !o && e[i][1].type === "definition" && (o = i);
  const r = {
    type: "setextHeading",
    start: {
      ...e[n][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[s][1].type = "setextHeadingText", o ? (e.splice(s, 0, ["enter", r, t]), e.splice(o + 1, 0, ["exit", e[n][1], t]), e[n][1].end = {
    ...e[o][1].end
  }) : e[n][1] = r, e.push(["exit", r, t]), e;
}
function fet(e, t, i) {
  const n = this;
  let s;
  return o;
  function o(h) {
    let I = n.events.length, p;
    for (; I--; )
      if (n.events[I][1].type !== "lineEnding" && n.events[I][1].type !== "linePrefix" && n.events[I][1].type !== "content") {
        p = n.events[I][1].type === "paragraph";
        break;
      }
    return !n.parser.lazy[n.now().line] && (n.interrupt || p) ? (e.enter("setextHeadingLine"), s = h, r(h)) : i(h);
  }
  function r(h) {
    return e.enter("setextHeadingLineSequence"), l(h);
  }
  function l(h) {
    return h === s ? (e.consume(h), l) : (e.exit("setextHeadingLineSequence"), ir(h) ? Ar(e, c, "lineSuffix")(h) : c(h));
  }
  function c(h) {
    return h === null || vs(h) ? (e.exit("setextHeadingLine"), t(h)) : i(h);
  }
}
const Iet = {
  tokenize: pet
};
function pet(e) {
  const t = this, i = e.attempt(
    // Try to parse a blank line.
    Vie,
    n,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, s, Ar(e, e.attempt(this.parser.constructs.flow, s, e.attempt(gXe, s)), "linePrefix"))
  );
  return i;
  function n(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), t.currentConstruct = void 0, i;
  }
  function s(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), t.currentConstruct = void 0, i;
  }
}
const met = {
  resolveAll: xNe()
}, yet = _Ne("string"), Eet = _Ne("text");
function _Ne(e) {
  return {
    resolveAll: xNe(e === "text" ? get : void 0),
    tokenize: t
  };
  function t(i) {
    const n = this, s = this.parser.constructs[e], o = i.attempt(s, r, l);
    return r;
    function r(I) {
      return h(I) ? o(I) : l(I);
    }
    function l(I) {
      if (I === null) {
        i.consume(I);
        return;
      }
      return i.enter("data"), i.consume(I), c;
    }
    function c(I) {
      return h(I) ? (i.exit("data"), o(I)) : (i.consume(I), c);
    }
    function h(I) {
      if (I === null)
        return !0;
      const p = s[I];
      let y = -1;
      if (p)
        for (; ++y < p.length; ) {
          const m = p[y];
          if (!m.previous || m.previous.call(n, n.previous))
            return !0;
        }
      return !1;
    }
  }
}
function xNe(e) {
  return t;
  function t(i, n) {
    let s = -1, o;
    for (; ++s <= i.length; )
      o === void 0 ? i[s] && i[s][1].type === "data" && (o = s, s++) : (!i[s] || i[s][1].type !== "data") && (s !== o + 2 && (i[o][1].end = i[s - 1][1].end, i.splice(o + 2, s - o - 2), s = o + 2), o = void 0);
    return e ? e(i, n) : i;
  }
}
function get(e, t) {
  let i = 0;
  for (; ++i <= e.length; )
    if ((i === e.length || e[i][1].type === "lineEnding") && e[i - 1][1].type === "data") {
      const n = e[i - 1][1], s = t.sliceStream(n);
      let o = s.length, r = -1, l = 0, c;
      for (; o--; ) {
        const h = s[o];
        if (typeof h == "string") {
          for (r = h.length; h.charCodeAt(r - 1) === 32; )
            l++, r--;
          if (r) break;
          r = -1;
        } else if (h === -2)
          c = !0, l++;
        else if (h !== -1) {
          o++;
          break;
        }
      }
      if (t._contentTypeTextTrailing && i === e.length && (l = 0), l) {
        const h = {
          type: i === e.length || c || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: o ? r : n.start._bufferIndex + r,
            _index: n.start._index + o,
            line: n.end.line,
            column: n.end.column - l,
            offset: n.end.offset - l
          },
          end: {
            ...n.end
          }
        };
        n.end = {
          ...h.start
        }, n.start.offset === n.end.offset ? Object.assign(n, h) : (e.splice(i, 0, ["enter", h, t], ["exit", h, t]), i += 2);
      }
      i++;
    }
  return e;
}
const wet = {
  42: lg,
  43: lg,
  45: lg,
  48: lg,
  49: lg,
  50: lg,
  51: lg,
  52: lg,
  53: lg,
  54: lg,
  55: lg,
  56: lg,
  57: lg,
  62: SNe
}, Tet = {
  91: AXe
}, Ret = {
  [-2]: Kce,
  [-1]: Kce,
  32: Kce
}, vet = {
  35: OXe,
  42: xre,
  45: [s4e, xre],
  60: PXe,
  61: s4e,
  95: xre,
  96: i4e,
  126: i4e
}, Aet = {
  38: NNe,
  92: bNe
}, bet = {
  [-5]: Zce,
  [-4]: Zce,
  [-3]: Zce,
  33: JXe,
  38: NNe,
  42: npe,
  60: [eXe, kXe],
  91: eet,
  92: [DXe, bNe],
  93: Xme,
  95: npe,
  96: fXe
}, Net = {
  null: [npe, met]
}, Det = {
  null: [42, 95]
}, Cet = {
  null: []
}, Oet = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: Det,
  contentInitial: Tet,
  disable: Cet,
  document: wet,
  flow: vet,
  flowInitial: Ret,
  insideSpan: Net,
  string: Aet,
  text: bet
}, Symbol.toStringTag, { value: "Module" }));
function Let(e, t, i) {
  let n = {
    _bufferIndex: -1,
    _index: 0,
    line: i && i.line || 1,
    column: i && i.column || 1,
    offset: i && i.offset || 0
  };
  const s = {}, o = [];
  let r = [], l = [];
  const c = {
    attempt: re(z),
    check: re(W),
    consume: F,
    enter: L,
    exit: P,
    interrupt: re(W, {
      interrupt: !0
    })
  }, h = {
    code: null,
    containerState: {},
    defineSkip: C,
    events: [],
    now: A,
    parser: e,
    previous: null,
    sliceSerialize: y,
    sliceStream: m,
    write: p
  };
  let I = t.tokenize.call(h, c);
  return t.resolveAll && o.push(t), h;
  function p(Ne) {
    return r = a5(r, Ne), O(), r[r.length - 1] !== null ? [] : (ce(t, 0), h.events = _ue(o, h.events, h), h.events);
  }
  function y(Ne, Ae) {
    return xet(m(Ne), Ae);
  }
  function m(Ne) {
    return _et(r, Ne);
  }
  function A() {
    const {
      _bufferIndex: Ne,
      _index: Ae,
      line: Oe,
      column: pe,
      offset: je
    } = n;
    return {
      _bufferIndex: Ne,
      _index: Ae,
      line: Oe,
      column: pe,
      offset: je
    };
  }
  function C(Ne) {
    s[Ne.line] = Ne.column, ee();
  }
  function O() {
    let Ne;
    for (; n._index < r.length; ) {
      const Ae = r[n._index];
      if (typeof Ae == "string")
        for (Ne = n._index, n._bufferIndex < 0 && (n._bufferIndex = 0); n._index === Ne && n._bufferIndex < Ae.length; )
          R(Ae.charCodeAt(n._bufferIndex));
      else
        R(Ae);
    }
  }
  function R(Ne) {
    I = I(Ne);
  }
  function F(Ne) {
    vs(Ne) ? (n.line++, n.column = 1, n.offset += Ne === -3 ? 2 : 1, ee()) : Ne !== -1 && (n.column++, n.offset++), n._bufferIndex < 0 ? n._index++ : (n._bufferIndex++, n._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    r[n._index].length && (n._bufferIndex = -1, n._index++)), h.previous = Ne;
  }
  function L(Ne, Ae) {
    const Oe = Ae || {};
    return Oe.type = Ne, Oe.start = A(), h.events.push(["enter", Oe, h]), l.push(Oe), Oe;
  }
  function P(Ne) {
    const Ae = l.pop();
    return Ae.end = A(), h.events.push(["exit", Ae, h]), Ae;
  }
  function z(Ne, Ae) {
    ce(Ne, Ae.from);
  }
  function W(Ne, Ae) {
    Ae.restore();
  }
  function re(Ne, Ae) {
    return Oe;
    function Oe(pe, je, Ve) {
      let $e, vt, Rt, ze;
      return Array.isArray(pe) ? (
        /* c8 ignore next 1 */
        Et(pe)
      ) : "tokenize" in pe ? (
        // Looks like a construct.
        Et([
          /** @type {Construct} */
          pe
        ])
      ) : mt(pe);
      function mt(Kt) {
        return Zt;
        function Zt(Xt) {
          const gi = Xt !== null && Kt[Xt], Wt = Xt !== null && Kt.null, Di = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(gi) ? gi : gi ? [gi] : [],
            ...Array.isArray(Wt) ? Wt : Wt ? [Wt] : []
          ];
          return Et(Di)(Xt);
        }
      }
      function Et(Kt) {
        return $e = Kt, vt = 0, Kt.length === 0 ? Ve : it(Kt[vt]);
      }
      function it(Kt) {
        return Zt;
        function Zt(Xt) {
          return ze = te(), Rt = Kt, Kt.partial || (h.currentConstruct = Kt), Kt.name && h.parser.constructs.disable.null.includes(Kt.name) ? Ct() : Kt.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            Ae ? Object.assign(Object.create(h), Ae) : h,
            c,
            Dt,
            Ct
          )(Xt);
        }
      }
      function Dt(Kt) {
        return Ne(Rt, ze), je;
      }
      function Ct(Kt) {
        return ze.restore(), ++vt < $e.length ? it($e[vt]) : Ve;
      }
    }
  }
  function ce(Ne, Ae) {
    Ne.resolveAll && !o.includes(Ne) && o.push(Ne), Ne.resolve && R4(h.events, Ae, h.events.length - Ae, Ne.resolve(h.events.slice(Ae), h)), Ne.resolveTo && (h.events = Ne.resolveTo(h.events, h));
  }
  function te() {
    const Ne = A(), Ae = h.previous, Oe = h.currentConstruct, pe = h.events.length, je = Array.from(l);
    return {
      from: pe,
      restore: Ve
    };
    function Ve() {
      n = Ne, h.previous = Ae, h.currentConstruct = Oe, h.events.length = pe, l = je, ee();
    }
  }
  function ee() {
    n.line in s && n.column < 2 && (n.column = s[n.line], n.offset += s[n.line] - 1);
  }
}
function _et(e, t) {
  const i = t.start._index, n = t.start._bufferIndex, s = t.end._index, o = t.end._bufferIndex;
  let r;
  if (i === s)
    r = [e[i].slice(n, o)];
  else {
    if (r = e.slice(i, s), n > -1) {
      const l = r[0];
      typeof l == "string" ? r[0] = l.slice(n) : r.shift();
    }
    o > 0 && r.push(e[s].slice(0, o));
  }
  return r;
}
function xet(e, t) {
  let i = -1;
  const n = [];
  let s;
  for (; ++i < e.length; ) {
    const o = e[i];
    let r;
    if (typeof o == "string")
      r = o;
    else switch (o) {
      case -5: {
        r = "\r";
        break;
      }
      case -4: {
        r = `
`;
        break;
      }
      case -3: {
        r = `\r
`;
        break;
      }
      case -2: {
        r = t ? " " : "	";
        break;
      }
      case -1: {
        if (!t && s) continue;
        r = " ";
        break;
      }
      default:
        r = String.fromCharCode(o);
    }
    s = o === -2, n.push(r);
  }
  return n.join("");
}
function Pet(e) {
  const n = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      vNe([Oet, ...(e || {}).extensions || []])
    ),
    content: s(qJe),
    defined: [],
    document: s(KJe),
    flow: s(Iet),
    lazy: {},
    string: s(yet),
    text: s(Eet)
  };
  return n;
  function s(o) {
    return r;
    function r(l) {
      return Let(n, o, l);
    }
  }
}
function Met(e) {
  for (; !DNe(e); )
    ;
  return e;
}
const o4e = /[\0\t\n\r]/g;
function Uet() {
  let e = 1, t = "", i = !0, n;
  return s;
  function s(o, r, l) {
    const c = [];
    let h, I, p, y, m;
    for (o = t + (typeof o == "string" ? o.toString() : new TextDecoder(r || void 0).decode(o)), p = 0, t = "", i && (o.charCodeAt(0) === 65279 && p++, i = void 0); p < o.length; ) {
      if (o4e.lastIndex = p, h = o4e.exec(o), y = h && h.index !== void 0 ? h.index : o.length, m = o.charCodeAt(y), !h) {
        t = o.slice(p);
        break;
      }
      if (m === 10 && p === y && n)
        c.push(-3), n = void 0;
      else
        switch (n && (c.push(-5), n = void 0), p < y && (c.push(o.slice(p, y)), e += y - p), m) {
          case 0: {
            c.push(65533), e++;
            break;
          }
          case 9: {
            for (I = Math.ceil(e / 4) * 4, c.push(-2); e++ < I; ) c.push(-1);
            break;
          }
          case 10: {
            c.push(-4), e = 1;
            break;
          }
          default:
            n = !0, e = 1;
        }
      p = y + 1;
    }
    return l && (n && c.push(-5), t && c.push(t), c.push(null)), c;
  }
}
const Bet = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function Fet(e) {
  return e.replace(Bet, Het);
}
function Het(e, t, i) {
  if (t)
    return t;
  if (i.charCodeAt(0) === 35) {
    const s = i.charCodeAt(1), o = s === 120 || s === 88;
    return ANe(i.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return Jme(i) || e;
}
const PNe = {}.hasOwnProperty;
function Get(e, t, i) {
  return typeof t != "string" && (i = t, t = void 0), ket(i)(Met(Pet(i).document().write(Uet()(e, t, !0))));
}
function ket(e) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(Tt),
      autolinkProtocol: te,
      autolinkEmail: te,
      atxHeading: o(si),
      blockQuote: o(Wt),
      characterEscape: te,
      characterReference: te,
      codeFenced: o(Di),
      codeFencedFenceInfo: r,
      codeFencedFenceMeta: r,
      codeIndented: o(Di, r),
      codeText: o(ni, r),
      codeTextData: te,
      data: te,
      codeFlowValue: te,
      definition: o(Ci),
      definitionDestinationString: r,
      definitionLabelString: r,
      definitionTitleString: r,
      emphasis: o(Se),
      hardBreakEscape: o(Mt),
      hardBreakTrailing: o(Mt),
      htmlFlow: o(ft, r),
      htmlFlowData: te,
      htmlText: o(ft, r),
      htmlTextData: te,
      image: o(rt),
      label: r,
      link: o(Tt),
      listItem: o(Jt),
      listItemValue: y,
      listOrdered: o(jt, p),
      listUnordered: o(jt),
      paragraph: o($t),
      reference: it,
      referenceString: r,
      resourceDestinationString: r,
      resourceTitleString: r,
      setextHeading: o(si),
      strong: o(ht),
      thematicBreak: o(gt)
    },
    exit: {
      atxHeading: c(),
      atxHeadingSequence: z,
      autolink: c(),
      autolinkEmail: gi,
      autolinkProtocol: Xt,
      blockQuote: c(),
      characterEscapeValue: ee,
      characterReferenceMarkerHexadecimal: Ct,
      characterReferenceMarkerNumeric: Ct,
      characterReferenceValue: Kt,
      characterReference: Zt,
      codeFenced: c(O),
      codeFencedFence: C,
      codeFencedFenceInfo: m,
      codeFencedFenceMeta: A,
      codeFlowValue: ee,
      codeIndented: c(R),
      codeText: c(je),
      codeTextData: ee,
      data: ee,
      definition: c(),
      definitionDestinationString: P,
      definitionLabelString: F,
      definitionTitleString: L,
      emphasis: c(),
      hardBreakEscape: c(Ae),
      hardBreakTrailing: c(Ae),
      htmlFlow: c(Oe),
      htmlFlowData: ee,
      htmlText: c(pe),
      htmlTextData: ee,
      image: c($e),
      label: Rt,
      labelText: vt,
      lineEnding: Ne,
      link: c(Ve),
      listItem: c(),
      listOrdered: c(),
      listUnordered: c(),
      paragraph: c(),
      referenceString: Dt,
      resourceDestinationString: ze,
      resourceTitleString: mt,
      resource: Et,
      setextHeading: c(ce),
      setextHeadingLineSequence: re,
      setextHeadingText: W,
      strong: c(),
      thematicBreak: c()
    }
  };
  MNe(t, (e || {}).mdastExtensions || []);
  const i = {};
  return n;
  function n(yt) {
    let Ut = {
      type: "root",
      children: []
    };
    const Ht = {
      stack: [Ut],
      tokenStack: [],
      config: t,
      enter: l,
      exit: h,
      buffer: r,
      resume: I,
      data: i
    }, wi = [];
    let bi = -1;
    for (; ++bi < yt.length; )
      if (yt[bi][1].type === "listOrdered" || yt[bi][1].type === "listUnordered")
        if (yt[bi][0] === "enter")
          wi.push(bi);
        else {
          const Hi = wi.pop();
          bi = s(yt, Hi, bi);
        }
    for (bi = -1; ++bi < yt.length; ) {
      const Hi = t[yt[bi][0]];
      PNe.call(Hi, yt[bi][1].type) && Hi[yt[bi][1].type].call(Object.assign({
        sliceSerialize: yt[bi][2].sliceSerialize
      }, Ht), yt[bi][1]);
    }
    if (Ht.tokenStack.length > 0) {
      const Hi = Ht.tokenStack[Ht.tokenStack.length - 1];
      (Hi[1] || r4e).call(Ht, void 0, Hi[0]);
    }
    for (Ut.position = {
      start: y_(yt.length > 0 ? yt[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: y_(yt.length > 0 ? yt[yt.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, bi = -1; ++bi < t.transforms.length; )
      Ut = t.transforms[bi](Ut) || Ut;
    return Ut;
  }
  function s(yt, Ut, Ht) {
    let wi = Ut - 1, bi = -1, Hi = !1, Wi, hi, Ji, Sn;
    for (; ++wi <= Ht; ) {
      const nn = yt[wi];
      switch (nn[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          nn[0] === "enter" ? bi++ : bi--, Sn = void 0;
          break;
        }
        case "lineEndingBlank": {
          nn[0] === "enter" && (Wi && !Sn && !bi && !Ji && (Ji = wi), Sn = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          Sn = void 0;
      }
      if (!bi && nn[0] === "enter" && nn[1].type === "listItemPrefix" || bi === -1 && nn[0] === "exit" && (nn[1].type === "listUnordered" || nn[1].type === "listOrdered")) {
        if (Wi) {
          let Yi = wi;
          for (hi = void 0; Yi--; ) {
            const Pi = yt[Yi];
            if (Pi[1].type === "lineEnding" || Pi[1].type === "lineEndingBlank") {
              if (Pi[0] === "exit") continue;
              hi && (yt[hi][1].type = "lineEndingBlank", Hi = !0), Pi[1].type = "lineEnding", hi = Yi;
            } else if (!(Pi[1].type === "linePrefix" || Pi[1].type === "blockQuotePrefix" || Pi[1].type === "blockQuotePrefixWhitespace" || Pi[1].type === "blockQuoteMarker" || Pi[1].type === "listItemIndent")) break;
          }
          Ji && (!hi || Ji < hi) && (Wi._spread = !0), Wi.end = Object.assign({}, hi ? yt[hi][1].start : nn[1].end), yt.splice(hi || wi, 0, ["exit", Wi, nn[2]]), wi++, Ht++;
        }
        if (nn[1].type === "listItemPrefix") {
          const Yi = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, nn[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          Wi = Yi, yt.splice(wi, 0, ["enter", Yi, nn[2]]), wi++, Ht++, Ji = void 0, Sn = !0;
        }
      }
    }
    return yt[Ut][1]._spread = Hi, Ht;
  }
  function o(yt, Ut) {
    return Ht;
    function Ht(wi) {
      l.call(this, yt(wi), wi), Ut && Ut.call(this, wi);
    }
  }
  function r() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(yt, Ut, Ht) {
    this.stack[this.stack.length - 1].children.push(yt), this.stack.push(yt), this.tokenStack.push([Ut, Ht || void 0]), yt.position = {
      start: y_(Ut.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function c(yt) {
    return Ut;
    function Ut(Ht) {
      yt && yt.call(this, Ht), h.call(this, Ht);
    }
  }
  function h(yt, Ut) {
    const Ht = this.stack.pop(), wi = this.tokenStack.pop();
    if (wi)
      wi[0].type !== yt.type && (Ut ? Ut.call(this, yt, wi[0]) : (wi[1] || r4e).call(this, yt, wi[0]));
    else throw new Error("Cannot close `" + yt.type + "` (" + WJ({
      start: yt.start,
      end: yt.end
    }) + "): it’s not open");
    Ht.position.end = y_(yt.end);
  }
  function I() {
    return Qme(this.stack.pop());
  }
  function p() {
    this.data.expectingFirstListItemValue = !0;
  }
  function y(yt) {
    if (this.data.expectingFirstListItemValue) {
      const Ut = this.stack[this.stack.length - 2];
      Ut.start = Number.parseInt(this.sliceSerialize(yt), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function m() {
    const yt = this.resume(), Ut = this.stack[this.stack.length - 1];
    Ut.lang = yt;
  }
  function A() {
    const yt = this.resume(), Ut = this.stack[this.stack.length - 1];
    Ut.meta = yt;
  }
  function C() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function O() {
    const yt = this.resume(), Ut = this.stack[this.stack.length - 1];
    Ut.value = yt.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function R() {
    const yt = this.resume(), Ut = this.stack[this.stack.length - 1];
    Ut.value = yt.replace(/(\r?\n|\r)$/g, "");
  }
  function F(yt) {
    const Ut = this.resume(), Ht = this.stack[this.stack.length - 1];
    Ht.label = Ut, Ht.identifier = _A(this.sliceSerialize(yt)).toLowerCase();
  }
  function L() {
    const yt = this.resume(), Ut = this.stack[this.stack.length - 1];
    Ut.title = yt;
  }
  function P() {
    const yt = this.resume(), Ut = this.stack[this.stack.length - 1];
    Ut.url = yt;
  }
  function z(yt) {
    const Ut = this.stack[this.stack.length - 1];
    if (!Ut.depth) {
      const Ht = this.sliceSerialize(yt).length;
      Ut.depth = Ht;
    }
  }
  function W() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function re(yt) {
    const Ut = this.stack[this.stack.length - 1];
    Ut.depth = this.sliceSerialize(yt).codePointAt(0) === 61 ? 1 : 2;
  }
  function ce() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function te(yt) {
    const Ht = this.stack[this.stack.length - 1].children;
    let wi = Ht[Ht.length - 1];
    (!wi || wi.type !== "text") && (wi = Me(), wi.position = {
      start: y_(yt.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, Ht.push(wi)), this.stack.push(wi);
  }
  function ee(yt) {
    const Ut = this.stack.pop();
    Ut.value += this.sliceSerialize(yt), Ut.position.end = y_(yt.end);
  }
  function Ne(yt) {
    const Ut = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const Ht = Ut.children[Ut.children.length - 1];
      Ht.position.end = y_(yt.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && t.canContainEols.includes(Ut.type) && (te.call(this, yt), ee.call(this, yt));
  }
  function Ae() {
    this.data.atHardBreak = !0;
  }
  function Oe() {
    const yt = this.resume(), Ut = this.stack[this.stack.length - 1];
    Ut.value = yt;
  }
  function pe() {
    const yt = this.resume(), Ut = this.stack[this.stack.length - 1];
    Ut.value = yt;
  }
  function je() {
    const yt = this.resume(), Ut = this.stack[this.stack.length - 1];
    Ut.value = yt;
  }
  function Ve() {
    const yt = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const Ut = this.data.referenceType || "shortcut";
      yt.type += "Reference", yt.referenceType = Ut, delete yt.url, delete yt.title;
    } else
      delete yt.identifier, delete yt.label;
    this.data.referenceType = void 0;
  }
  function $e() {
    const yt = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const Ut = this.data.referenceType || "shortcut";
      yt.type += "Reference", yt.referenceType = Ut, delete yt.url, delete yt.title;
    } else
      delete yt.identifier, delete yt.label;
    this.data.referenceType = void 0;
  }
  function vt(yt) {
    const Ut = this.sliceSerialize(yt), Ht = this.stack[this.stack.length - 2];
    Ht.label = Fet(Ut), Ht.identifier = _A(Ut).toLowerCase();
  }
  function Rt() {
    const yt = this.stack[this.stack.length - 1], Ut = this.resume(), Ht = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, Ht.type === "link") {
      const wi = yt.children;
      Ht.children = wi;
    } else
      Ht.alt = Ut;
  }
  function ze() {
    const yt = this.resume(), Ut = this.stack[this.stack.length - 1];
    Ut.url = yt;
  }
  function mt() {
    const yt = this.resume(), Ut = this.stack[this.stack.length - 1];
    Ut.title = yt;
  }
  function Et() {
    this.data.inReference = void 0;
  }
  function it() {
    this.data.referenceType = "collapsed";
  }
  function Dt(yt) {
    const Ut = this.resume(), Ht = this.stack[this.stack.length - 1];
    Ht.label = Ut, Ht.identifier = _A(this.sliceSerialize(yt)).toLowerCase(), this.data.referenceType = "full";
  }
  function Ct(yt) {
    this.data.characterReferenceType = yt.type;
  }
  function Kt(yt) {
    const Ut = this.sliceSerialize(yt), Ht = this.data.characterReferenceType;
    let wi;
    Ht ? (wi = ANe(Ut, Ht === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : wi = Jme(Ut);
    const bi = this.stack[this.stack.length - 1];
    bi.value += wi;
  }
  function Zt(yt) {
    const Ut = this.stack.pop();
    Ut.position.end = y_(yt.end);
  }
  function Xt(yt) {
    ee.call(this, yt);
    const Ut = this.stack[this.stack.length - 1];
    Ut.url = this.sliceSerialize(yt);
  }
  function gi(yt) {
    ee.call(this, yt);
    const Ut = this.stack[this.stack.length - 1];
    Ut.url = "mailto:" + this.sliceSerialize(yt);
  }
  function Wt() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function Di() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function ni() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function Ci() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Se() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function si() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function Mt() {
    return {
      type: "break"
    };
  }
  function ft() {
    return {
      type: "html",
      value: ""
    };
  }
  function rt() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Tt() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function jt(yt) {
    return {
      type: "list",
      ordered: yt.type === "listOrdered",
      start: null,
      spread: yt._spread,
      children: []
    };
  }
  function Jt(yt) {
    return {
      type: "listItem",
      spread: yt._spread,
      checked: null,
      children: []
    };
  }
  function $t() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function ht() {
    return {
      type: "strong",
      children: []
    };
  }
  function Me() {
    return {
      type: "text",
      value: ""
    };
  }
  function gt() {
    return {
      type: "thematicBreak"
    };
  }
}
function y_(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function MNe(e, t) {
  let i = -1;
  for (; ++i < t.length; ) {
    const n = t[i];
    Array.isArray(n) ? MNe(e, n) : Vet(e, n);
  }
}
function Vet(e, t) {
  let i;
  for (i in t)
    if (PNe.call(t, i))
      switch (i) {
        case "canContainEols": {
          const n = t[i];
          n && e[i].push(...n);
          break;
        }
        case "transforms": {
          const n = t[i];
          n && e[i].push(...n);
          break;
        }
        case "enter":
        case "exit": {
          const n = t[i];
          n && Object.assign(e[i], n);
          break;
        }
      }
}
function r4e(e, t) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + WJ({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + t.type + "`, " + WJ({
    start: t.start,
    end: t.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + t.type + "`, " + WJ({
    start: t.start,
    end: t.end
  }) + ") is still open");
}
function zet(e) {
  const t = this;
  t.parser = i;
  function i(n) {
    return Get(n, {
      ...t.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: t.data("micromarkExtensions") || [],
      mdastExtensions: t.data("fromMarkdownExtensions") || []
    });
  }
}
function jet(e, t) {
  const i = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(t), !0)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function Wet(e, t) {
  const i = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(t, i), [e.applyData(t, i), { type: "text", value: `
` }];
}
function Yet(e, t) {
  const i = t.value ? t.value + `
` : "", n = {}, s = t.lang ? t.lang.split(/\s+/) : [];
  s.length > 0 && (n.className = ["language-" + s[0]]);
  let o = {
    type: "element",
    tagName: "code",
    properties: n,
    children: [{ type: "text", value: i }]
  };
  return t.meta && (o.data = { meta: t.meta }), e.patch(t, o), o = e.applyData(t, o), o = { type: "element", tagName: "pre", properties: {}, children: [o] }, e.patch(t, o), o;
}
function qet(e, t) {
  const i = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function $et(e, t) {
  const i = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function Ket(e, t) {
  const i = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", n = String(t.identifier).toUpperCase(), s = cY(n.toLowerCase()), o = e.footnoteOrder.indexOf(n);
  let r, l = e.footnoteCounts.get(n);
  l === void 0 ? (l = 0, e.footnoteOrder.push(n), r = e.footnoteOrder.length) : r = o + 1, l += 1, e.footnoteCounts.set(n, l);
  const c = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + i + "fn-" + s,
      id: i + "fnref-" + s + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(r) }]
  };
  e.patch(t, c);
  const h = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [c]
  };
  return e.patch(t, h), e.applyData(t, h);
}
function Zet(e, t) {
  const i = {
    type: "element",
    tagName: "h" + t.depth,
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function Qet(e, t) {
  if (e.options.allowDangerousHtml) {
    const i = { type: "raw", value: t.value };
    return e.patch(t, i), e.applyData(t, i);
  }
}
function UNe(e, t) {
  const i = t.referenceType;
  let n = "]";
  if (i === "collapsed" ? n += "[]" : i === "full" && (n += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference")
    return [{ type: "text", value: "![" + t.alt + n }];
  const s = e.all(t), o = s[0];
  o && o.type === "text" ? o.value = "[" + o.value : s.unshift({ type: "text", value: "[" });
  const r = s[s.length - 1];
  return r && r.type === "text" ? r.value += n : s.push({ type: "text", value: n }), s;
}
function Jet(e, t) {
  const i = String(t.identifier).toUpperCase(), n = e.definitionById.get(i);
  if (!n)
    return UNe(e, t);
  const s = { src: cY(n.url || ""), alt: t.alt };
  n.title !== null && n.title !== void 0 && (s.title = n.title);
  const o = { type: "element", tagName: "img", properties: s, children: [] };
  return e.patch(t, o), e.applyData(t, o);
}
function Xet(e, t) {
  const i = { src: cY(t.url) };
  t.alt !== null && t.alt !== void 0 && (i.alt = t.alt), t.title !== null && t.title !== void 0 && (i.title = t.title);
  const n = { type: "element", tagName: "img", properties: i, children: [] };
  return e.patch(t, n), e.applyData(t, n);
}
function ett(e, t) {
  const i = { type: "text", value: t.value.replace(/\r?\n|\r/g, " ") };
  e.patch(t, i);
  const n = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [i]
  };
  return e.patch(t, n), e.applyData(t, n);
}
function ttt(e, t) {
  const i = String(t.identifier).toUpperCase(), n = e.definitionById.get(i);
  if (!n)
    return UNe(e, t);
  const s = { href: cY(n.url || "") };
  n.title !== null && n.title !== void 0 && (s.title = n.title);
  const o = {
    type: "element",
    tagName: "a",
    properties: s,
    children: e.all(t)
  };
  return e.patch(t, o), e.applyData(t, o);
}
function itt(e, t) {
  const i = { href: cY(t.url) };
  t.title !== null && t.title !== void 0 && (i.title = t.title);
  const n = {
    type: "element",
    tagName: "a",
    properties: i,
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function ntt(e, t, i) {
  const n = e.all(t), s = i ? stt(i) : BNe(t), o = {}, r = [];
  if (typeof t.checked == "boolean") {
    const I = n[0];
    let p;
    I && I.type === "element" && I.tagName === "p" ? p = I : (p = { type: "element", tagName: "p", properties: {}, children: [] }, n.unshift(p)), p.children.length > 0 && p.children.unshift({ type: "text", value: " " }), p.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: t.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < n.length; ) {
    const I = n[l];
    (s || l !== 0 || I.type !== "element" || I.tagName !== "p") && r.push({ type: "text", value: `
` }), I.type === "element" && I.tagName === "p" && !s ? r.push(...I.children) : r.push(I);
  }
  const c = n[n.length - 1];
  c && (s || c.type !== "element" || c.tagName !== "p") && r.push({ type: "text", value: `
` });
  const h = { type: "element", tagName: "li", properties: o, children: r };
  return e.patch(t, h), e.applyData(t, h);
}
function stt(e) {
  let t = !1;
  if (e.type === "list") {
    t = e.spread || !1;
    const i = e.children;
    let n = -1;
    for (; !t && ++n < i.length; )
      t = BNe(i[n]);
  }
  return t;
}
function BNe(e) {
  const t = e.spread;
  return t ?? e.children.length > 1;
}
function ott(e, t) {
  const i = {}, n = e.all(t);
  let s = -1;
  for (typeof t.start == "number" && t.start !== 1 && (i.start = t.start); ++s < n.length; ) {
    const r = n[s];
    if (r.type === "element" && r.tagName === "li" && r.properties && Array.isArray(r.properties.className) && r.properties.className.includes("task-list-item")) {
      i.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: t.ordered ? "ol" : "ul",
    properties: i,
    children: e.wrap(n, !0)
  };
  return e.patch(t, o), e.applyData(t, o);
}
function rtt(e, t) {
  const i = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function ltt(e, t) {
  const i = { type: "root", children: e.wrap(e.all(t)) };
  return e.patch(t, i), e.applyData(t, i);
}
function att(e, t) {
  const i = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function utt(e, t) {
  const i = e.all(t), n = i.shift(), s = [];
  if (n) {
    const r = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([n], !0)
    };
    e.patch(t.children[0], r), s.push(r);
  }
  if (i.length > 0) {
    const r = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(i, !0)
    }, l = d6(t.children[1]), c = Oue(t.children[t.children.length - 1]);
    l && c && (r.position = { start: l, end: c }), s.push(r);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(s, !0)
  };
  return e.patch(t, o), e.applyData(t, o);
}
function dtt(e, t, i) {
  const n = i ? i.children : void 0, o = (n ? n.indexOf(t) : 1) === 0 ? "th" : "td", r = i && i.type === "table" ? i.align : void 0, l = r ? r.length : t.children.length;
  let c = -1;
  const h = [];
  for (; ++c < l; ) {
    const p = t.children[c], y = {}, m = r ? r[c] : void 0;
    m && (y.align = m);
    let A = { type: "element", tagName: o, properties: y, children: [] };
    p && (A.children = e.all(p), e.patch(p, A), A = e.applyData(p, A)), h.push(A);
  }
  const I = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(h, !0)
  };
  return e.patch(t, I), e.applyData(t, I);
}
function ctt(e, t) {
  const i = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, i), e.applyData(t, i);
}
const l4e = 9, a4e = 32;
function htt(e) {
  const t = String(e), i = /\r?\n|\r/g;
  let n = i.exec(t), s = 0;
  const o = [];
  for (; n; )
    o.push(
      u4e(t.slice(s, n.index), s > 0, !0),
      n[0]
    ), s = n.index + n[0].length, n = i.exec(t);
  return o.push(u4e(t.slice(s), s > 0, !1)), o.join("");
}
function u4e(e, t, i) {
  let n = 0, s = e.length;
  if (t) {
    let o = e.codePointAt(n);
    for (; o === l4e || o === a4e; )
      n++, o = e.codePointAt(n);
  }
  if (i) {
    let o = e.codePointAt(s - 1);
    for (; o === l4e || o === a4e; )
      s--, o = e.codePointAt(s - 1);
  }
  return s > n ? e.slice(n, s) : "";
}
function ftt(e, t) {
  const i = { type: "text", value: htt(String(t.value)) };
  return e.patch(t, i), e.applyData(t, i);
}
function Itt(e, t) {
  const i = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(t, i), e.applyData(t, i);
}
const ptt = {
  blockquote: jet,
  break: Wet,
  code: Yet,
  delete: qet,
  emphasis: $et,
  footnoteReference: Ket,
  heading: Zet,
  html: Qet,
  imageReference: Jet,
  image: Xet,
  inlineCode: ett,
  linkReference: ttt,
  link: itt,
  listItem: ntt,
  list: ott,
  paragraph: rtt,
  // @ts-expect-error: root is different, but hard to type.
  root: ltt,
  strong: att,
  table: utt,
  tableCell: ctt,
  tableRow: dtt,
  text: ftt,
  thematicBreak: Itt,
  toml: Gse,
  yaml: Gse,
  definition: Gse,
  footnoteDefinition: Gse
};
function Gse() {
}
const FNe = -1, xue = 0, qJ = 1, Mle = 2, e3e = 3, t3e = 4, i3e = 5, n3e = 6, HNe = 7, GNe = 8, d4e = typeof self == "object" ? self : globalThis, mtt = (e, t) => {
  const i = (s, o) => (e.set(o, s), s), n = (s) => {
    if (e.has(s))
      return e.get(s);
    const [o, r] = t[s];
    switch (o) {
      case xue:
      case FNe:
        return i(r, s);
      case qJ: {
        const l = i([], s);
        for (const c of r)
          l.push(n(c));
        return l;
      }
      case Mle: {
        const l = i({}, s);
        for (const [c, h] of r)
          l[n(c)] = n(h);
        return l;
      }
      case e3e:
        return i(new Date(r), s);
      case t3e: {
        const { source: l, flags: c } = r;
        return i(new RegExp(l, c), s);
      }
      case i3e: {
        const l = i(/* @__PURE__ */ new Map(), s);
        for (const [c, h] of r)
          l.set(n(c), n(h));
        return l;
      }
      case n3e: {
        const l = i(/* @__PURE__ */ new Set(), s);
        for (const c of r)
          l.add(n(c));
        return l;
      }
      case HNe: {
        const { name: l, message: c } = r;
        return i(new d4e[l](c), s);
      }
      case GNe:
        return i(BigInt(r), s);
      case "BigInt":
        return i(Object(BigInt(r)), s);
      case "ArrayBuffer":
        return i(new Uint8Array(r).buffer, r);
      case "DataView": {
        const { buffer: l } = new Uint8Array(r);
        return i(new DataView(l), r);
      }
    }
    return i(new d4e[o](r), s);
  };
  return n;
}, c4e = (e) => mtt(/* @__PURE__ */ new Map(), e)(0), pV = "", { toString: ytt } = {}, { keys: Ett } = Object, $Z = (e) => {
  const t = typeof e;
  if (t !== "object" || !e)
    return [xue, t];
  const i = ytt.call(e).slice(8, -1);
  switch (i) {
    case "Array":
      return [qJ, pV];
    case "Object":
      return [Mle, pV];
    case "Date":
      return [e3e, pV];
    case "RegExp":
      return [t3e, pV];
    case "Map":
      return [i3e, pV];
    case "Set":
      return [n3e, pV];
    case "DataView":
      return [qJ, i];
  }
  return i.includes("Array") ? [qJ, i] : i.includes("Error") ? [HNe, i] : [Mle, i];
}, kse = ([e, t]) => e === xue && (t === "function" || t === "symbol"), gtt = (e, t, i, n) => {
  const s = (r, l) => {
    const c = n.push(r) - 1;
    return i.set(l, c), c;
  }, o = (r) => {
    if (i.has(r))
      return i.get(r);
    let [l, c] = $Z(r);
    switch (l) {
      case xue: {
        let I = r;
        switch (c) {
          case "bigint":
            l = GNe, I = r.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + c);
            I = null;
            break;
          case "undefined":
            return s([FNe], r);
        }
        return s([l, I], r);
      }
      case qJ: {
        if (c) {
          let y = r;
          return c === "DataView" ? y = new Uint8Array(r.buffer) : c === "ArrayBuffer" && (y = new Uint8Array(r)), s([c, [...y]], r);
        }
        const I = [], p = s([l, I], r);
        for (const y of r)
          I.push(o(y));
        return p;
      }
      case Mle: {
        if (c)
          switch (c) {
            case "BigInt":
              return s([c, r.toString()], r);
            case "Boolean":
            case "Number":
            case "String":
              return s([c, r.valueOf()], r);
          }
        if (t && "toJSON" in r)
          return o(r.toJSON());
        const I = [], p = s([l, I], r);
        for (const y of Ett(r))
          (e || !kse($Z(r[y]))) && I.push([o(y), o(r[y])]);
        return p;
      }
      case e3e:
        return s([l, r.toISOString()], r);
      case t3e: {
        const { source: I, flags: p } = r;
        return s([l, { source: I, flags: p }], r);
      }
      case i3e: {
        const I = [], p = s([l, I], r);
        for (const [y, m] of r)
          (e || !(kse($Z(y)) || kse($Z(m)))) && I.push([o(y), o(m)]);
        return p;
      }
      case n3e: {
        const I = [], p = s([l, I], r);
        for (const y of r)
          (e || !kse($Z(y))) && I.push(o(y));
        return p;
      }
    }
    const { message: h } = r;
    return s([l, { name: c, message: h }], r);
  };
  return o;
}, h4e = (e, { json: t, lossy: i } = {}) => {
  const n = [];
  return gtt(!(t || i), !!t, /* @__PURE__ */ new Map(), n)(e), n;
}, KW = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, t) => t && ("json" in t || "lossy" in t) ? c4e(h4e(e, t)) : structuredClone(e)
) : (e, t) => c4e(h4e(e, t));
function wtt(e, t) {
  const i = [{ type: "text", value: "↩" }];
  return t > 1 && i.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(t) }]
  }), i;
}
function Ttt(e, t) {
  return "Back to reference " + (e + 1) + (t > 1 ? "-" + t : "");
}
function Rtt(e) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", i = e.options.footnoteBackContent || wtt, n = e.options.footnoteBackLabel || Ttt, s = e.options.footnoteLabel || "Footnotes", o = e.options.footnoteLabelTagName || "h2", r = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let c = -1;
  for (; ++c < e.footnoteOrder.length; ) {
    const h = e.footnoteById.get(
      e.footnoteOrder[c]
    );
    if (!h)
      continue;
    const I = e.all(h), p = String(h.identifier).toUpperCase(), y = cY(p.toLowerCase());
    let m = 0;
    const A = [], C = e.footnoteCounts.get(p);
    for (; C !== void 0 && ++m <= C; ) {
      A.length > 0 && A.push({ type: "text", value: " " });
      let F = typeof i == "string" ? i : i(c, m);
      typeof F == "string" && (F = { type: "text", value: F }), A.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + t + "fnref-" + y + (m > 1 ? "-" + m : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof n == "string" ? n : n(c, m),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(F) ? F : [F]
      });
    }
    const O = I[I.length - 1];
    if (O && O.type === "element" && O.tagName === "p") {
      const F = O.children[O.children.length - 1];
      F && F.type === "text" ? F.value += " " : O.children.push({ type: "text", value: " " }), O.children.push(...A);
    } else
      I.push(...A);
    const R = {
      type: "element",
      tagName: "li",
      properties: { id: t + "fn-" + y },
      children: e.wrap(I, !0)
    };
    e.patch(h, R), l.push(R);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: o,
          properties: {
            ...KW(r),
            id: "footnote-label"
          },
          children: [{ type: "text", value: s }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const Pue = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(e) {
    if (e == null)
      return btt;
    if (typeof e == "function")
      return Mue(e);
    if (typeof e == "object")
      return Array.isArray(e) ? vtt(e) : (
        // Cast because `ReadonlyArray` goes into the above but `isArray`
        // narrows to `Array`.
        Att(
          /** @type {Props} */
          e
        )
      );
    if (typeof e == "string")
      return Stt(e);
    throw new Error("Expected function, string, or object as test");
  })
);
function vtt(e) {
  const t = [];
  let i = -1;
  for (; ++i < e.length; )
    t[i] = Pue(e[i]);
  return Mue(n);
  function n(...s) {
    let o = -1;
    for (; ++o < t.length; )
      if (t[o].apply(this, s)) return !0;
    return !1;
  }
}
function Att(e) {
  const t = (
    /** @type {Record<string, unknown>} */
    e
  );
  return Mue(i);
  function i(n) {
    const s = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      n
    );
    let o;
    for (o in e)
      if (s[o] !== t[o]) return !1;
    return !0;
  }
}
function Stt(e) {
  return Mue(t);
  function t(i) {
    return i && i.type === e;
  }
}
function Mue(e) {
  return t;
  function t(i, n, s) {
    return !!(Ntt(i) && e.call(
      this,
      i,
      typeof n == "number" ? n : void 0,
      s || void 0
    ));
  }
}
function btt() {
  return !0;
}
function Ntt(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const kNe = [], Dtt = !0, spe = !1, Ctt = "skip";
function VNe(e, t, i, n) {
  let s;
  typeof t == "function" && typeof i != "function" ? (n = i, i = t) : s = t;
  const o = Pue(s), r = n ? -1 : 1;
  l(e, void 0, [])();
  function l(c, h, I) {
    const p = (
      /** @type {Record<string, unknown>} */
      c && typeof c == "object" ? c : {}
    );
    if (typeof p.type == "string") {
      const m = (
        // `hast`
        typeof p.tagName == "string" ? p.tagName : (
          // `xast`
          typeof p.name == "string" ? p.name : void 0
        )
      );
      Object.defineProperty(y, "name", {
        value: "node (" + (c.type + (m ? "<" + m + ">" : "")) + ")"
      });
    }
    return y;
    function y() {
      let m = kNe, A, C, O;
      if ((!t || o(c, h, I[I.length - 1] || void 0)) && (m = Ott(i(c, I)), m[0] === spe))
        return m;
      if ("children" in c && c.children) {
        const R = (
          /** @type {UnistParent} */
          c
        );
        if (R.children && m[0] !== Ctt)
          for (C = (n ? R.children.length : -1) + r, O = I.concat(R); C > -1 && C < R.children.length; ) {
            const F = R.children[C];
            if (A = l(F, C, O)(), A[0] === spe)
              return A;
            C = typeof A[1] == "number" ? A[1] : C + r;
          }
      }
      return m;
    }
  }
}
function Ott(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [Dtt, e] : e == null ? kNe : [e];
}
function Uue(e, t, i, n) {
  let s, o, r;
  typeof t == "function" && typeof i != "function" ? (o = void 0, r = t, s = i) : (o = t, r = i, s = n), VNe(e, o, l, s);
  function l(c, h) {
    const I = h[h.length - 1], p = I ? I.children.indexOf(c) : void 0;
    return r(c, p, I);
  }
}
const ope = {}.hasOwnProperty, Ltt = {};
function _tt(e, t) {
  const i = t || Ltt, n = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), r = { ...ptt, ...i.handlers }, l = {
    all: h,
    applyData: Ptt,
    definitionById: n,
    footnoteById: s,
    footnoteCounts: o,
    footnoteOrder: [],
    handlers: r,
    one: c,
    options: i,
    patch: xtt,
    wrap: Utt
  };
  return Uue(e, function(I) {
    if (I.type === "definition" || I.type === "footnoteDefinition") {
      const p = I.type === "definition" ? n : s, y = String(I.identifier).toUpperCase();
      p.has(y) || p.set(y, I);
    }
  }), l;
  function c(I, p) {
    const y = I.type, m = l.handlers[y];
    if (ope.call(l.handlers, y) && m)
      return m(l, I, p);
    if (l.options.passThrough && l.options.passThrough.includes(y)) {
      if ("children" in I) {
        const { children: C, ...O } = I, R = KW(O);
        return R.children = l.all(I), R;
      }
      return KW(I);
    }
    return (l.options.unknownHandler || Mtt)(l, I, p);
  }
  function h(I) {
    const p = [];
    if ("children" in I) {
      const y = I.children;
      let m = -1;
      for (; ++m < y.length; ) {
        const A = l.one(y[m], I);
        if (A) {
          if (m && y[m - 1].type === "break" && (!Array.isArray(A) && A.type === "text" && (A.value = f4e(A.value)), !Array.isArray(A) && A.type === "element")) {
            const C = A.children[0];
            C && C.type === "text" && (C.value = f4e(C.value));
          }
          Array.isArray(A) ? p.push(...A) : p.push(A);
        }
      }
    }
    return p;
  }
}
function xtt(e, t) {
  e.position && (t.position = gJe(e));
}
function Ptt(e, t) {
  let i = t;
  if (e && e.data) {
    const n = e.data.hName, s = e.data.hChildren, o = e.data.hProperties;
    if (typeof n == "string")
      if (i.type === "element")
        i.tagName = n;
      else {
        const r = "children" in i ? i.children : [i];
        i = { type: "element", tagName: n, properties: {}, children: r };
      }
    i.type === "element" && o && Object.assign(i.properties, KW(o)), "children" in i && i.children && s !== null && s !== void 0 && (i.children = s);
  }
  return i;
}
function Mtt(e, t) {
  const i = t.data || {}, n = "value" in t && !(ope.call(i, "hProperties") || ope.call(i, "hChildren")) ? { type: "text", value: t.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Utt(e, t) {
  const i = [];
  let n = -1;
  for (t && i.push({ type: "text", value: `
` }); ++n < e.length; )
    n && i.push({ type: "text", value: `
` }), i.push(e[n]);
  return t && e.length > 0 && i.push({ type: "text", value: `
` }), i;
}
function f4e(e) {
  let t = 0, i = e.charCodeAt(t);
  for (; i === 9 || i === 32; )
    t++, i = e.charCodeAt(t);
  return e.slice(t);
}
function I4e(e, t) {
  const i = _tt(e, t), n = i.one(e, void 0), s = Rtt(i), o = Array.isArray(n) ? { type: "root", children: n } : n || { type: "root", children: [] };
  return s && o.children.push({ type: "text", value: `
` }, s), o;
}
function Btt(e, t) {
  return e && "run" in e ? async function(i, n) {
    const s = (
      /** @type {HastRoot} */
      I4e(i, { file: n, ...t })
    );
    await e.run(s, n);
  } : function(i, n) {
    return (
      /** @type {HastRoot} */
      I4e(i, { file: n, ...e || t })
    );
  };
}
function p4e(e) {
  if (e)
    throw e;
}
var Qce, m4e;
function Ftt() {
  if (m4e) return Qce;
  m4e = 1;
  var e = Object.prototype.hasOwnProperty, t = Object.prototype.toString, i = Object.defineProperty, n = Object.getOwnPropertyDescriptor, s = function(h) {
    return typeof Array.isArray == "function" ? Array.isArray(h) : t.call(h) === "[object Array]";
  }, o = function(h) {
    if (!h || t.call(h) !== "[object Object]")
      return !1;
    var I = e.call(h, "constructor"), p = h.constructor && h.constructor.prototype && e.call(h.constructor.prototype, "isPrototypeOf");
    if (h.constructor && !I && !p)
      return !1;
    var y;
    for (y in h)
      ;
    return typeof y > "u" || e.call(h, y);
  }, r = function(h, I) {
    i && I.name === "__proto__" ? i(h, I.name, {
      enumerable: !0,
      configurable: !0,
      value: I.newValue,
      writable: !0
    }) : h[I.name] = I.newValue;
  }, l = function(h, I) {
    if (I === "__proto__")
      if (e.call(h, I)) {
        if (n)
          return n(h, I).value;
      } else return;
    return h[I];
  };
  return Qce = function c() {
    var h, I, p, y, m, A, C = arguments[0], O = 1, R = arguments.length, F = !1;
    for (typeof C == "boolean" && (F = C, C = arguments[1] || {}, O = 2), (C == null || typeof C != "object" && typeof C != "function") && (C = {}); O < R; ++O)
      if (h = arguments[O], h != null)
        for (I in h)
          p = l(C, I), y = l(h, I), C !== y && (F && y && (o(y) || (m = s(y))) ? (m ? (m = !1, A = p && s(p) ? p : []) : A = p && o(p) ? p : {}, r(C, { name: I, newValue: c(F, A, y) })) : typeof y < "u" && r(C, { name: I, newValue: y }));
    return C;
  }, Qce;
}
var Htt = Ftt();
const Jce = /* @__PURE__ */ rie(Htt);
function rpe(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function Gtt() {
  const e = [], t = { run: i, use: n };
  return t;
  function i(...s) {
    let o = -1;
    const r = s.pop();
    if (typeof r != "function")
      throw new TypeError("Expected function as last argument, not " + r);
    l(null, ...s);
    function l(c, ...h) {
      const I = e[++o];
      let p = -1;
      if (c) {
        r(c);
        return;
      }
      for (; ++p < s.length; )
        (h[p] === null || h[p] === void 0) && (h[p] = s[p]);
      s = h, I ? ktt(I, l)(...h) : r(null, ...h);
    }
  }
  function n(s) {
    if (typeof s != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + s
      );
    return e.push(s), t;
  }
}
function ktt(e, t) {
  let i;
  return n;
  function n(...r) {
    const l = e.length > r.length;
    let c;
    l && r.push(s);
    try {
      c = e.apply(this, r);
    } catch (h) {
      const I = (
        /** @type {Error} */
        h
      );
      if (l && i)
        throw I;
      return s(I);
    }
    l || (c && c.then && typeof c.then == "function" ? c.then(o, s) : c instanceof Error ? s(c) : o(c));
  }
  function s(r, ...l) {
    i || (i = !0, t(r, ...l));
  }
  function o(r) {
    s(null, r);
  }
}
const wb = { basename: Vtt, dirname: ztt, extname: jtt, join: Wtt, sep: "/" };
function Vtt(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  zie(e);
  let i = 0, n = -1, s = e.length, o;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; s--; )
      if (e.codePointAt(s) === 47) {
        if (o) {
          i = s + 1;
          break;
        }
      } else n < 0 && (o = !0, n = s + 1);
    return n < 0 ? "" : e.slice(i, n);
  }
  if (t === e)
    return "";
  let r = -1, l = t.length - 1;
  for (; s--; )
    if (e.codePointAt(s) === 47) {
      if (o) {
        i = s + 1;
        break;
      }
    } else
      r < 0 && (o = !0, r = s + 1), l > -1 && (e.codePointAt(s) === t.codePointAt(l--) ? l < 0 && (n = s) : (l = -1, n = r));
  return i === n ? n = r : n < 0 && (n = e.length), e.slice(i, n);
}
function ztt(e) {
  if (zie(e), e.length === 0)
    return ".";
  let t = -1, i = e.length, n;
  for (; --i; )
    if (e.codePointAt(i) === 47) {
      if (n) {
        t = i;
        break;
      }
    } else n || (n = !0);
  return t < 0 ? e.codePointAt(0) === 47 ? "/" : "." : t === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, t);
}
function jtt(e) {
  zie(e);
  let t = e.length, i = -1, n = 0, s = -1, o = 0, r;
  for (; t--; ) {
    const l = e.codePointAt(t);
    if (l === 47) {
      if (r) {
        n = t + 1;
        break;
      }
      continue;
    }
    i < 0 && (r = !0, i = t + 1), l === 46 ? s < 0 ? s = t : o !== 1 && (o = 1) : s > -1 && (o = -1);
  }
  return s < 0 || i < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && s === i - 1 && s === n + 1 ? "" : e.slice(s, i);
}
function Wtt(...e) {
  let t = -1, i;
  for (; ++t < e.length; )
    zie(e[t]), e[t] && (i = i === void 0 ? e[t] : i + "/" + e[t]);
  return i === void 0 ? "." : Ytt(i);
}
function Ytt(e) {
  zie(e);
  const t = e.codePointAt(0) === 47;
  let i = qtt(e, !t);
  return i.length === 0 && !t && (i = "."), i.length > 0 && e.codePointAt(e.length - 1) === 47 && (i += "/"), t ? "/" + i : i;
}
function qtt(e, t) {
  let i = "", n = 0, s = -1, o = 0, r = -1, l, c;
  for (; ++r <= e.length; ) {
    if (r < e.length)
      l = e.codePointAt(r);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(s === r - 1 || o === 1)) if (s !== r - 1 && o === 2) {
        if (i.length < 2 || n !== 2 || i.codePointAt(i.length - 1) !== 46 || i.codePointAt(i.length - 2) !== 46) {
          if (i.length > 2) {
            if (c = i.lastIndexOf("/"), c !== i.length - 1) {
              c < 0 ? (i = "", n = 0) : (i = i.slice(0, c), n = i.length - 1 - i.lastIndexOf("/")), s = r, o = 0;
              continue;
            }
          } else if (i.length > 0) {
            i = "", n = 0, s = r, o = 0;
            continue;
          }
        }
        t && (i = i.length > 0 ? i + "/.." : "..", n = 2);
      } else
        i.length > 0 ? i += "/" + e.slice(s + 1, r) : i = e.slice(s + 1, r), n = r - s - 1;
      s = r, o = 0;
    } else l === 46 && o > -1 ? o++ : o = -1;
  }
  return i;
}
function zie(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const $tt = { cwd: Ktt };
function Ktt() {
  return "/";
}
function lpe(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function Ztt(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!lpe(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return Qtt(e);
}
function Qtt(e) {
  if (e.hostname !== "") {
    const n = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw n.code = "ERR_INVALID_FILE_URL_HOST", n;
  }
  const t = e.pathname;
  let i = -1;
  for (; ++i < t.length; )
    if (t.codePointAt(i) === 37 && t.codePointAt(i + 1) === 50) {
      const n = t.codePointAt(i + 2);
      if (n === 70 || n === 102) {
        const s = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw s.code = "ERR_INVALID_FILE_URL_PATH", s;
      }
    }
  return decodeURIComponent(t);
}
const Xce = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class zNe {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let i;
    t ? lpe(t) ? i = { path: t } : typeof t == "string" || Jtt(t) ? i = { value: t } : i = t : i = {}, this.cwd = "cwd" in i ? "" : $tt.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let n = -1;
    for (; ++n < Xce.length; ) {
      const o = Xce[n];
      o in i && i[o] !== void 0 && i[o] !== null && (this[o] = o === "history" ? [...i[o]] : i[o]);
    }
    let s;
    for (s in i)
      Xce.includes(s) || (this[s] = i[s]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? wb.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(t) {
    t0e(t, "basename"), e0e(t, "basename"), this.path = wb.join(this.dirname || "", t);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? wb.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(t) {
    y4e(this.basename, "dirname"), this.path = wb.join(t || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? wb.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(t) {
    if (e0e(t, "extname"), y4e(this.dirname, "extname"), t) {
      if (t.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = wb.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(t) {
    lpe(t) && (t = Ztt(t)), t0e(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? wb.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(t) {
    t0e(t, "stem"), e0e(t, "stem"), this.path = wb.join(this.dirname || "", t + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, i, n) {
    const s = this.message(t, i, n);
    throw s.fatal = !0, s;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, i, n) {
    const s = this.message(t, i, n);
    return s.fatal = void 0, s;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, i, n) {
    const s = new I3(
      // @ts-expect-error: the overloads are fine.
      t,
      i,
      n
    );
    return this.path && (s.name = this.path + ":" + s.name, s.file = this.path), s.fatal = !1, this.messages.push(s), s;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(t || void 0).decode(this.value);
  }
}
function e0e(e, t) {
  if (e && e.includes(wb.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + wb.sep + "`"
    );
}
function t0e(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function y4e(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function Jtt(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const Xtt = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(e) {
    const n = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), s = n[e], o = function() {
      return s.apply(o, arguments);
    };
    return Object.setPrototypeOf(o, n), o;
  })
), eit = {}.hasOwnProperty;
class s3e extends Xtt {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = Gtt();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const t = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new s3e()
    );
    let i = -1;
    for (; ++i < this.attachers.length; ) {
      const n = this.attachers[i];
      t.use(...n);
    }
    return t.data(Jce(!0, {}, this.namespace)), t;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(t, i) {
    return typeof t == "string" ? arguments.length === 2 ? (s0e("data", this.frozen), this.namespace[t] = i, this) : eit.call(this.namespace, t) && this.namespace[t] || void 0 : t ? (s0e("data", this.frozen), this.namespace = t, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const t = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [i, ...n] = this.attachers[this.freezeIndex];
      if (n[0] === !1)
        continue;
      n[0] === !0 && (n[0] = void 0);
      const s = i.call(t, ...n);
      typeof s == "function" && this.transformers.use(s);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(t) {
    this.freeze();
    const i = Vse(t), n = this.parser || this.Parser;
    return i0e("parse", n), n(String(i), i);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(t, i) {
    const n = this;
    return this.freeze(), i0e("process", this.parser || this.Parser), n0e("process", this.compiler || this.Compiler), i ? s(void 0, i) : new Promise(s);
    function s(o, r) {
      const l = Vse(t), c = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        n.parse(l)
      );
      n.run(c, l, function(I, p, y) {
        if (I || !p || !y)
          return h(I);
        const m = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          p
        ), A = n.stringify(m, y);
        nit(A) ? y.value = A : y.result = A, h(
          I,
          /** @type {VFileWithOutput<CompileResult>} */
          y
        );
      });
      function h(I, p) {
        I || !p ? r(I) : o ? o(p) : i(void 0, p);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(t) {
    let i = !1, n;
    return this.freeze(), i0e("processSync", this.parser || this.Parser), n0e("processSync", this.compiler || this.Compiler), this.process(t, s), g4e("processSync", "process", i), n;
    function s(o, r) {
      i = !0, p4e(o), n = r;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(t, i, n) {
    E4e(t), this.freeze();
    const s = this.transformers;
    return !n && typeof i == "function" && (n = i, i = void 0), n ? o(void 0, n) : new Promise(o);
    function o(r, l) {
      const c = Vse(i);
      s.run(t, c, h);
      function h(I, p, y) {
        const m = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          p || t
        );
        I ? l(I) : r ? r(m) : n(void 0, m, y);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(t, i) {
    let n = !1, s;
    return this.run(t, i, o), g4e("runSync", "run", n), s;
    function o(r, l) {
      p4e(r), s = l, n = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(t, i) {
    this.freeze();
    const n = Vse(i), s = this.compiler || this.Compiler;
    return n0e("stringify", s), E4e(t), s(t, n);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(t, ...i) {
    const n = this.attachers, s = this.namespace;
    if (s0e("use", this.frozen), t != null) if (typeof t == "function")
      c(t, i);
    else if (typeof t == "object")
      Array.isArray(t) ? l(t) : r(t);
    else
      throw new TypeError("Expected usable value, not `" + t + "`");
    return this;
    function o(h) {
      if (typeof h == "function")
        c(h, []);
      else if (typeof h == "object")
        if (Array.isArray(h)) {
          const [I, ...p] = (
            /** @type {PluginTuple<Array<unknown>>} */
            h
          );
          c(I, p);
        } else
          r(h);
      else
        throw new TypeError("Expected usable value, not `" + h + "`");
    }
    function r(h) {
      if (!("plugins" in h) && !("settings" in h))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(h.plugins), h.settings && (s.settings = Jce(!0, s.settings, h.settings));
    }
    function l(h) {
      let I = -1;
      if (h != null) if (Array.isArray(h))
        for (; ++I < h.length; ) {
          const p = h[I];
          o(p);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + h + "`");
    }
    function c(h, I) {
      let p = -1, y = -1;
      for (; ++p < n.length; )
        if (n[p][0] === h) {
          y = p;
          break;
        }
      if (y === -1)
        n.push([h, ...I]);
      else if (I.length > 0) {
        let [m, ...A] = I;
        const C = n[y][1];
        rpe(C) && rpe(m) && (m = Jce(!0, C, m)), n[y] = [h, m, ...A];
      }
    }
  }
}
const tit = new s3e().freeze();
function i0e(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function n0e(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function s0e(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function E4e(e) {
  if (!rpe(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function g4e(e, t, i) {
  if (!i)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function Vse(e) {
  return iit(e) ? e : new zNe(e);
}
function iit(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function nit(e) {
  return typeof e == "string" || sit(e);
}
function sit(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const oit = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", w4e = [], T4e = { allowDangerousHtml: !0 }, rit = /^(https?|ircs?|mailto|xmpp)$/i, lit = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function ait(e) {
  const t = uit(e), i = dit(e);
  return cit(t.runSync(t.parse(i), i), e);
}
function uit(e) {
  const t = e.rehypePlugins || w4e, i = e.remarkPlugins || w4e, n = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...T4e } : T4e;
  return tit().use(zet).use(i).use(Btt, n).use(t);
}
function dit(e) {
  const t = e.children || "", i = new zNe();
  return typeof t == "string" && (i.value = t), i;
}
function cit(e, t) {
  const i = t.allowedElements, n = t.allowElement, s = t.components, o = t.disallowedElements, r = t.skipHtml, l = t.unwrapDisallowed, c = t.urlTransform || hit;
  for (const I of lit)
    Object.hasOwn(t, I.from) && ("" + I.from + (I.to ? "use `" + I.to + "` instead" : "remove it") + oit + I.id, void 0);
  return t.className && (e = {
    type: "element",
    tagName: "div",
    properties: { className: t.className },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      e.type === "root" ? e.children : [e]
    )
  }), Uue(e, h), AJe(e, {
    Fragment: He.Fragment,
    // @ts-expect-error
    // React components are allowed to return numbers,
    // but not according to the types in hast-util-to-jsx-runtime
    components: s,
    ignoreInvalidStyle: !0,
    jsx: He.jsx,
    jsxs: He.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function h(I, p, y) {
    if (I.type === "raw" && y && typeof p == "number")
      return r ? y.children.splice(p, 1) : y.children[p] = { type: "text", value: I.value }, p;
    if (I.type === "element") {
      let m;
      for (m in $ce)
        if (Object.hasOwn($ce, m) && Object.hasOwn(I.properties, m)) {
          const A = I.properties[m], C = $ce[m];
          (C === null || C.includes(I.tagName)) && (I.properties[m] = c(String(A || ""), m, I));
        }
    }
    if (I.type === "element") {
      let m = i ? !i.includes(I.tagName) : o ? o.includes(I.tagName) : !1;
      if (!m && n && typeof p == "number" && (m = !n(I, p, y)), m && y && typeof p == "number")
        return l && I.children ? y.children.splice(p, 1, ...I.children) : y.children.splice(p, 1), p;
    }
  }
}
function hit(e) {
  const t = e.indexOf(":"), i = e.indexOf("?"), n = e.indexOf("#"), s = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    t === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    s !== -1 && t > s || i !== -1 && t > i || n !== -1 && t > n || // It is a protocol, it should be allowed.
    rit.test(e.slice(0, t)) ? e : ""
  );
}
const R4e = /[#.]/g;
function fit(e, t) {
  const i = e || "", n = {};
  let s = 0, o, r;
  for (; s < i.length; ) {
    R4e.lastIndex = s;
    const l = R4e.exec(i), c = i.slice(s, l ? l.index : i.length);
    c && (o ? o === "#" ? n.id = c : Array.isArray(n.className) ? n.className.push(c) : n.className = [c] : r = c, s += c.length), l && (o = l[0], s++);
  }
  return {
    type: "element",
    // @ts-expect-error: tag name is parsed.
    tagName: r || t || "div",
    properties: n,
    children: []
  };
}
function jNe(e, t, i) {
  const n = i ? yit(i) : void 0;
  function s(o, r, ...l) {
    let c;
    if (o == null) {
      c = { type: "root", children: [] };
      const h = (
        /** @type {Child} */
        r
      );
      l.unshift(h);
    } else {
      c = fit(o, t);
      const h = c.tagName.toLowerCase(), I = n ? n.get(h) : void 0;
      if (c.tagName = I || h, Iit(r))
        l.unshift(r);
      else
        for (const [p, y] of Object.entries(r))
          pit(e, c.properties, p, y);
    }
    for (const h of l)
      ape(c.children, h);
    return c.type === "element" && c.tagName === "template" && (c.content = { type: "root", children: c.children }, c.children = []), c;
  }
  return s;
}
function Iit(e) {
  if (e === null || typeof e != "object" || Array.isArray(e))
    return !0;
  if (typeof e.type != "string") return !1;
  const t = (
    /** @type {Record<string, unknown>} */
    e
  ), i = Object.keys(e);
  for (const n of i) {
    const s = t[n];
    if (s && typeof s == "object") {
      if (!Array.isArray(s)) return !0;
      const o = (
        /** @type {ReadonlyArray<unknown>} */
        s
      );
      for (const r of o)
        if (typeof r != "number" && typeof r != "string")
          return !0;
    }
  }
  return !!("children" in e && Array.isArray(e.children));
}
function pit(e, t, i, n) {
  const s = Cue(e, i);
  let o;
  if (n != null) {
    if (typeof n == "number") {
      if (Number.isNaN(n)) return;
      o = n;
    } else typeof n == "boolean" ? o = n : typeof n == "string" ? s.spaceSeparated ? o = z2e(n) : s.commaSeparated ? o = F2e(n) : s.commaOrSpaceSeparated ? o = z2e(F2e(n).join(" ")) : o = v4e(s, s.property, n) : Array.isArray(n) ? o = [...n] : o = s.property === "style" ? mit(n) : String(n);
    if (Array.isArray(o)) {
      const r = [];
      for (const l of o)
        r.push(
          /** @type {number | string} */
          v4e(s, s.property, l)
        );
      o = r;
    }
    s.property === "className" && Array.isArray(t.className) && (o = t.className.concat(
      /** @type {Array<number | string> | number | string} */
      o
    )), t[s.property] = o;
  }
}
function ape(e, t) {
  if (t != null) if (typeof t == "number" || typeof t == "string")
    e.push({ type: "text", value: String(t) });
  else if (Array.isArray(t))
    for (const i of t)
      ape(e, i);
  else if (typeof t == "object" && "type" in t)
    t.type === "root" ? ape(e, t.children) : e.push(t);
  else
    throw new Error("Expected node, nodes, or string, got `" + t + "`");
}
function v4e(e, t, i) {
  if (typeof i == "string") {
    if (e.number && i && !Number.isNaN(Number(i)))
      return Number(i);
    if ((e.boolean || e.overloadedBoolean) && (i === "" || VX(i) === VX(t)))
      return !0;
  }
  return i;
}
function mit(e) {
  const t = [];
  for (const [i, n] of Object.entries(e))
    t.push([i, n].join(": "));
  return t.join("; ");
}
function yit(e) {
  const t = /* @__PURE__ */ new Map();
  for (const i of e)
    t.set(i.toLowerCase(), i);
  return t;
}
const Eit = [
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "solidColor",
  "textArea",
  "textPath"
], git = jNe(kie, "div"), wit = jNe(F8, "g", Eit);
function Tit(e) {
  const t = String(e), i = [];
  return { toOffset: s, toPoint: n };
  function n(o) {
    if (typeof o == "number" && o > -1 && o <= t.length) {
      let r = 0;
      for (; ; ) {
        let l = i[r];
        if (l === void 0) {
          const c = A4e(t, i[r - 1]);
          l = c === -1 ? t.length + 1 : c + 1, i[r] = l;
        }
        if (l > o)
          return {
            line: r + 1,
            column: o - (r > 0 ? i[r - 1] : 0) + 1,
            offset: o
          };
        r++;
      }
    }
  }
  function s(o) {
    if (o && typeof o.line == "number" && typeof o.column == "number" && !Number.isNaN(o.line) && !Number.isNaN(o.column)) {
      for (; i.length < o.line; ) {
        const l = i[i.length - 1], c = A4e(t, l), h = c === -1 ? t.length + 1 : c + 1;
        if (l === h) break;
        i.push(h);
      }
      const r = (o.line > 1 ? i[o.line - 2] : 0) + o.column - 1;
      if (r < i[o.line - 1]) return r;
    }
  }
}
function A4e(e, t) {
  const i = e.indexOf("\r", t), n = e.indexOf(`
`, t);
  return n === -1 ? i : i === -1 || i + 1 === n ? n : i < n ? i : n;
}
const fB = {
  html: "http://www.w3.org/1999/xhtml",
  mathml: "http://www.w3.org/1998/Math/MathML",
  svg: "http://www.w3.org/2000/svg",
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
}, WNe = {}.hasOwnProperty, Rit = Object.prototype;
function vit(e, t) {
  const i = t || {};
  return o3e(
    {
      file: i.file || void 0,
      location: !1,
      schema: i.space === "svg" ? F8 : kie,
      verbose: i.verbose || !1
    },
    e
  );
}
function o3e(e, t) {
  let i;
  switch (t.nodeName) {
    case "#comment": {
      const n = (
        /** @type {DefaultTreeAdapterMap['commentNode']} */
        t
      );
      return i = { type: "comment", value: n.data }, Pre(e, n, i), i;
    }
    case "#document":
    case "#document-fragment": {
      const n = (
        /** @type {DefaultTreeAdapterMap['document'] | DefaultTreeAdapterMap['documentFragment']} */
        t
      ), s = "mode" in n ? n.mode === "quirks" || n.mode === "limited-quirks" : !1;
      if (i = {
        type: "root",
        children: YNe(e, t.childNodes),
        data: { quirksMode: s }
      }, e.file && e.location) {
        const o = String(e.file), r = Tit(o), l = r.toPoint(0), c = r.toPoint(o.length);
        i.position = { start: l, end: c };
      }
      return i;
    }
    case "#documentType": {
      const n = (
        /** @type {DefaultTreeAdapterMap['documentType']} */
        t
      );
      return i = { type: "doctype" }, Pre(e, n, i), i;
    }
    case "#text": {
      const n = (
        /** @type {DefaultTreeAdapterMap['textNode']} */
        t
      );
      return i = { type: "text", value: n.value }, Pre(e, n, i), i;
    }
    // Element.
    default:
      return i = Ait(
        e,
        /** @type {DefaultTreeAdapterMap['element']} */
        t
      ), i;
  }
}
function YNe(e, t) {
  let i = -1;
  const n = [];
  for (; ++i < t.length; ) {
    const s = (
      /** @type {RootContent} */
      o3e(e, t[i])
    );
    n.push(s);
  }
  return n;
}
function Ait(e, t) {
  const i = e.schema;
  e.schema = t.namespaceURI === fB.svg ? F8 : kie;
  let n = -1;
  const s = {};
  for (; ++n < t.attrs.length; ) {
    const l = t.attrs[n], c = (l.prefix ? l.prefix + ":" : "") + l.name;
    WNe.call(Rit, c) || (s[c] = l.value);
  }
  const r = (e.schema.space === "svg" ? wit : git)(t.tagName, s, YNe(e, t.childNodes));
  if (Pre(e, t, r), r.tagName === "template") {
    const l = (
      /** @type {DefaultTreeAdapterMap['template']} */
      t
    ), c = l.sourceCodeLocation, h = c && c.startTag && Ez(c.startTag), I = c && c.endTag && Ez(c.endTag), p = (
      /** @type {Root} */
      o3e(e, l.content)
    );
    h && I && e.file && (p.position = { start: h.end, end: I.start }), r.content = p;
  }
  return e.schema = i, r;
}
function Pre(e, t, i) {
  if ("sourceCodeLocation" in t && t.sourceCodeLocation && e.file) {
    const n = Sit(e, i, t.sourceCodeLocation);
    n && (e.location = !0, i.position = n);
  }
}
function Sit(e, t, i) {
  const n = Ez(i);
  if (t.type === "element") {
    const s = t.children[t.children.length - 1];
    if (n && !i.endTag && s && s.position && s.position.end && (n.end = Object.assign({}, s.position.end)), e.verbose) {
      const o = {};
      let r;
      if (i.attrs)
        for (r in i.attrs)
          WNe.call(i.attrs, r) && (o[Cue(e.schema, r).property] = Ez(
            i.attrs[r]
          ));
      i.startTag;
      const l = Ez(i.startTag), c = i.endTag ? Ez(i.endTag) : void 0, h = { opening: l };
      c && (h.closing = c), h.properties = o, t.data = { position: h };
    }
  }
  return n;
}
function Ez(e) {
  const t = S4e({
    line: e.startLine,
    column: e.startCol,
    offset: e.startOffset
  }), i = S4e({
    line: e.endLine,
    column: e.endCol,
    offset: e.endOffset
  });
  return t || i ? { start: t, end: i } : void 0;
}
function S4e(e) {
  return e.line && e.column ? e : void 0;
}
const b4e = {}.hasOwnProperty;
function qNe(e, t) {
  const i = t || {};
  function n(s, ...o) {
    let r = n.invalid;
    const l = n.handlers;
    if (s && b4e.call(s, e)) {
      const c = String(s[e]);
      r = b4e.call(l, c) ? l[c] : n.unknown;
    }
    if (r)
      return r.call(this, s, ...o);
  }
  return n.handlers = i.handlers || {}, n.invalid = i.invalid, n.unknown = i.unknown, n;
}
const bit = {}, Nit = {}.hasOwnProperty, $Ne = qNe("type", { handlers: { root: Cit, element: Pit, text: _it, comment: xit, doctype: Lit } });
function Dit(e, t) {
  const n = (t || bit).space;
  return $Ne(e, n === "svg" ? F8 : kie);
}
function Cit(e, t) {
  const i = {
    nodeName: "#document",
    // @ts-expect-error: `parse5` uses enums, which are actually strings.
    mode: (e.data || {}).quirksMode ? "quirks" : "no-quirks",
    childNodes: []
  };
  return i.childNodes = r3e(e.children, i, t), hY(e, i), i;
}
function Oit(e, t) {
  const i = { nodeName: "#document-fragment", childNodes: [] };
  return i.childNodes = r3e(e.children, i, t), hY(e, i), i;
}
function Lit(e) {
  const t = {
    nodeName: "#documentType",
    name: "html",
    publicId: "",
    systemId: "",
    parentNode: null
  };
  return hY(e, t), t;
}
function _it(e) {
  const t = {
    nodeName: "#text",
    value: e.value,
    parentNode: null
  };
  return hY(e, t), t;
}
function xit(e) {
  const t = {
    nodeName: "#comment",
    data: e.value,
    parentNode: null
  };
  return hY(e, t), t;
}
function Pit(e, t) {
  const i = t;
  let n = i;
  e.type === "element" && e.tagName.toLowerCase() === "svg" && i.space === "html" && (n = F8);
  const s = [];
  let o;
  if (e.properties) {
    for (o in e.properties)
      if (o !== "children" && Nit.call(e.properties, o)) {
        const c = Mit(
          n,
          o,
          e.properties[o]
        );
        c && s.push(c);
      }
  }
  const r = n.space, l = {
    nodeName: e.tagName,
    tagName: e.tagName,
    attrs: s,
    // @ts-expect-error: `parse5` types are wrong.
    namespaceURI: fB[r],
    childNodes: [],
    parentNode: null
  };
  return l.childNodes = r3e(e.children, l, n), hY(e, l), e.tagName === "template" && e.content && (l.content = Oit(e.content, n)), l;
}
function Mit(e, t, i) {
  const n = Cue(e, t);
  if (i === !1 || i === null || i === void 0 || typeof i == "number" && Number.isNaN(i) || !i && n.boolean)
    return;
  Array.isArray(i) && (i = n.commaSeparated ? aNe(i) : mNe(i));
  const s = {
    name: n.attribute,
    value: i === !0 ? "" : String(i)
  };
  if (n.space && n.space !== "html" && n.space !== "svg") {
    const o = s.name.indexOf(":");
    o < 0 ? s.prefix = "" : (s.name = s.name.slice(o + 1), s.prefix = n.attribute.slice(0, o)), s.namespace = fB[n.space];
  }
  return s;
}
function r3e(e, t, i) {
  let n = -1;
  const s = [];
  if (e)
    for (; ++n < e.length; ) {
      const o = $Ne(e[n], i);
      o.parentNode = t, s.push(o);
    }
  return s;
}
function hY(e, t) {
  const i = e.position;
  i && i.start && i.end && (i.start.offset, i.end.offset, t.sourceCodeLocation = {
    startLine: i.start.line,
    startCol: i.start.column,
    startOffset: i.start.offset,
    endLine: i.end.line,
    endCol: i.end.column,
    endOffset: i.end.offset
  });
}
const Uit = [
  "area",
  "base",
  "basefont",
  "bgsound",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "image",
  "img",
  "input",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
], Bit = /* @__PURE__ */ new Set([
  65534,
  65535,
  131070,
  131071,
  196606,
  196607,
  262142,
  262143,
  327678,
  327679,
  393214,
  393215,
  458750,
  458751,
  524286,
  524287,
  589822,
  589823,
  655358,
  655359,
  720894,
  720895,
  786430,
  786431,
  851966,
  851967,
  917502,
  917503,
  983038,
  983039,
  1048574,
  1048575,
  1114110,
  1114111
]), xu = "�";
var Nt;
(function(e) {
  e[e.EOF = -1] = "EOF", e[e.NULL = 0] = "NULL", e[e.TABULATION = 9] = "TABULATION", e[e.CARRIAGE_RETURN = 13] = "CARRIAGE_RETURN", e[e.LINE_FEED = 10] = "LINE_FEED", e[e.FORM_FEED = 12] = "FORM_FEED", e[e.SPACE = 32] = "SPACE", e[e.EXCLAMATION_MARK = 33] = "EXCLAMATION_MARK", e[e.QUOTATION_MARK = 34] = "QUOTATION_MARK", e[e.AMPERSAND = 38] = "AMPERSAND", e[e.APOSTROPHE = 39] = "APOSTROPHE", e[e.HYPHEN_MINUS = 45] = "HYPHEN_MINUS", e[e.SOLIDUS = 47] = "SOLIDUS", e[e.DIGIT_0 = 48] = "DIGIT_0", e[e.DIGIT_9 = 57] = "DIGIT_9", e[e.SEMICOLON = 59] = "SEMICOLON", e[e.LESS_THAN_SIGN = 60] = "LESS_THAN_SIGN", e[e.EQUALS_SIGN = 61] = "EQUALS_SIGN", e[e.GREATER_THAN_SIGN = 62] = "GREATER_THAN_SIGN", e[e.QUESTION_MARK = 63] = "QUESTION_MARK", e[e.LATIN_CAPITAL_A = 65] = "LATIN_CAPITAL_A", e[e.LATIN_CAPITAL_Z = 90] = "LATIN_CAPITAL_Z", e[e.RIGHT_SQUARE_BRACKET = 93] = "RIGHT_SQUARE_BRACKET", e[e.GRAVE_ACCENT = 96] = "GRAVE_ACCENT", e[e.LATIN_SMALL_A = 97] = "LATIN_SMALL_A", e[e.LATIN_SMALL_Z = 122] = "LATIN_SMALL_Z";
})(Nt || (Nt = {}));
const sg = {
  DASH_DASH: "--",
  CDATA_START: "[CDATA[",
  DOCTYPE: "doctype",
  SCRIPT: "script",
  PUBLIC: "public",
  SYSTEM: "system"
};
function KNe(e) {
  return e >= 55296 && e <= 57343;
}
function Fit(e) {
  return e >= 56320 && e <= 57343;
}
function Hit(e, t) {
  return (e - 55296) * 1024 + 9216 + t;
}
function ZNe(e) {
  return e !== 32 && e !== 10 && e !== 13 && e !== 9 && e !== 12 && e >= 1 && e <= 31 || e >= 127 && e <= 159;
}
function QNe(e) {
  return e >= 64976 && e <= 65007 || Bit.has(e);
}
var Oi;
(function(e) {
  e.controlCharacterInInputStream = "control-character-in-input-stream", e.noncharacterInInputStream = "noncharacter-in-input-stream", e.surrogateInInputStream = "surrogate-in-input-stream", e.nonVoidHtmlElementStartTagWithTrailingSolidus = "non-void-html-element-start-tag-with-trailing-solidus", e.endTagWithAttributes = "end-tag-with-attributes", e.endTagWithTrailingSolidus = "end-tag-with-trailing-solidus", e.unexpectedSolidusInTag = "unexpected-solidus-in-tag", e.unexpectedNullCharacter = "unexpected-null-character", e.unexpectedQuestionMarkInsteadOfTagName = "unexpected-question-mark-instead-of-tag-name", e.invalidFirstCharacterOfTagName = "invalid-first-character-of-tag-name", e.unexpectedEqualsSignBeforeAttributeName = "unexpected-equals-sign-before-attribute-name", e.missingEndTagName = "missing-end-tag-name", e.unexpectedCharacterInAttributeName = "unexpected-character-in-attribute-name", e.unknownNamedCharacterReference = "unknown-named-character-reference", e.missingSemicolonAfterCharacterReference = "missing-semicolon-after-character-reference", e.unexpectedCharacterAfterDoctypeSystemIdentifier = "unexpected-character-after-doctype-system-identifier", e.unexpectedCharacterInUnquotedAttributeValue = "unexpected-character-in-unquoted-attribute-value", e.eofBeforeTagName = "eof-before-tag-name", e.eofInTag = "eof-in-tag", e.missingAttributeValue = "missing-attribute-value", e.missingWhitespaceBetweenAttributes = "missing-whitespace-between-attributes", e.missingWhitespaceAfterDoctypePublicKeyword = "missing-whitespace-after-doctype-public-keyword", e.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers = "missing-whitespace-between-doctype-public-and-system-identifiers", e.missingWhitespaceAfterDoctypeSystemKeyword = "missing-whitespace-after-doctype-system-keyword", e.missingQuoteBeforeDoctypePublicIdentifier = "missing-quote-before-doctype-public-identifier", e.missingQuoteBeforeDoctypeSystemIdentifier = "missing-quote-before-doctype-system-identifier", e.missingDoctypePublicIdentifier = "missing-doctype-public-identifier", e.missingDoctypeSystemIdentifier = "missing-doctype-system-identifier", e.abruptDoctypePublicIdentifier = "abrupt-doctype-public-identifier", e.abruptDoctypeSystemIdentifier = "abrupt-doctype-system-identifier", e.cdataInHtmlContent = "cdata-in-html-content", e.incorrectlyOpenedComment = "incorrectly-opened-comment", e.eofInScriptHtmlCommentLikeText = "eof-in-script-html-comment-like-text", e.eofInDoctype = "eof-in-doctype", e.nestedComment = "nested-comment", e.abruptClosingOfEmptyComment = "abrupt-closing-of-empty-comment", e.eofInComment = "eof-in-comment", e.incorrectlyClosedComment = "incorrectly-closed-comment", e.eofInCdata = "eof-in-cdata", e.absenceOfDigitsInNumericCharacterReference = "absence-of-digits-in-numeric-character-reference", e.nullCharacterReference = "null-character-reference", e.surrogateCharacterReference = "surrogate-character-reference", e.characterReferenceOutsideUnicodeRange = "character-reference-outside-unicode-range", e.controlCharacterReference = "control-character-reference", e.noncharacterCharacterReference = "noncharacter-character-reference", e.missingWhitespaceBeforeDoctypeName = "missing-whitespace-before-doctype-name", e.missingDoctypeName = "missing-doctype-name", e.invalidCharacterSequenceAfterDoctypeName = "invalid-character-sequence-after-doctype-name", e.duplicateAttribute = "duplicate-attribute", e.nonConformingDoctype = "non-conforming-doctype", e.missingDoctype = "missing-doctype", e.misplacedDoctype = "misplaced-doctype", e.endTagWithoutMatchingOpenElement = "end-tag-without-matching-open-element", e.closingOfElementWithOpenChildElements = "closing-of-element-with-open-child-elements", e.disallowedContentInNoscriptInHead = "disallowed-content-in-noscript-in-head", e.openElementsLeftAfterEof = "open-elements-left-after-eof", e.abandonedHeadElementChild = "abandoned-head-element-child", e.misplacedStartTagForHeadElement = "misplaced-start-tag-for-head-element", e.nestedNoscriptInHead = "nested-noscript-in-head", e.eofInElementThatCanContainOnlyText = "eof-in-element-that-can-contain-only-text";
})(Oi || (Oi = {}));
const Git = 65536;
class kit {
  constructor(t) {
    this.handler = t, this.html = "", this.pos = -1, this.lastGapPos = -2, this.gapStack = [], this.skipNextNewLine = !1, this.lastChunkWritten = !1, this.endOfChunkHit = !1, this.bufferWaterline = Git, this.isEol = !1, this.lineStartPos = 0, this.droppedBufferSize = 0, this.line = 1, this.lastErrOffset = -1;
  }
  /** The column on the current line. If we just saw a gap (eg. a surrogate pair), return the index before. */
  get col() {
    return this.pos - this.lineStartPos + +(this.lastGapPos !== this.pos);
  }
  get offset() {
    return this.droppedBufferSize + this.pos;
  }
  getError(t, i) {
    const { line: n, col: s, offset: o } = this, r = s + i, l = o + i;
    return {
      code: t,
      startLine: n,
      endLine: n,
      startCol: r,
      endCol: r,
      startOffset: l,
      endOffset: l
    };
  }
  _err(t) {
    this.handler.onParseError && this.lastErrOffset !== this.offset && (this.lastErrOffset = this.offset, this.handler.onParseError(this.getError(t, 0)));
  }
  _addGap() {
    this.gapStack.push(this.lastGapPos), this.lastGapPos = this.pos;
  }
  _processSurrogate(t) {
    if (this.pos !== this.html.length - 1) {
      const i = this.html.charCodeAt(this.pos + 1);
      if (Fit(i))
        return this.pos++, this._addGap(), Hit(t, i);
    } else if (!this.lastChunkWritten)
      return this.endOfChunkHit = !0, Nt.EOF;
    return this._err(Oi.surrogateInInputStream), t;
  }
  willDropParsedChunk() {
    return this.pos > this.bufferWaterline;
  }
  dropParsedChunk() {
    this.willDropParsedChunk() && (this.html = this.html.substring(this.pos), this.lineStartPos -= this.pos, this.droppedBufferSize += this.pos, this.pos = 0, this.lastGapPos = -2, this.gapStack.length = 0);
  }
  write(t, i) {
    this.html.length > 0 ? this.html += t : this.html = t, this.endOfChunkHit = !1, this.lastChunkWritten = i;
  }
  insertHtmlAtCurrentPos(t) {
    this.html = this.html.substring(0, this.pos + 1) + t + this.html.substring(this.pos + 1), this.endOfChunkHit = !1;
  }
  startsWith(t, i) {
    if (this.pos + t.length > this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, !1;
    if (i)
      return this.html.startsWith(t, this.pos);
    for (let n = 0; n < t.length; n++)
      if ((this.html.charCodeAt(this.pos + n) | 32) !== t.charCodeAt(n))
        return !1;
    return !0;
  }
  peek(t) {
    const i = this.pos + t;
    if (i >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, Nt.EOF;
    const n = this.html.charCodeAt(i);
    return n === Nt.CARRIAGE_RETURN ? Nt.LINE_FEED : n;
  }
  advance() {
    if (this.pos++, this.isEol && (this.isEol = !1, this.line++, this.lineStartPos = this.pos), this.pos >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, Nt.EOF;
    let t = this.html.charCodeAt(this.pos);
    return t === Nt.CARRIAGE_RETURN ? (this.isEol = !0, this.skipNextNewLine = !0, Nt.LINE_FEED) : t === Nt.LINE_FEED && (this.isEol = !0, this.skipNextNewLine) ? (this.line--, this.skipNextNewLine = !1, this._addGap(), this.advance()) : (this.skipNextNewLine = !1, KNe(t) && (t = this._processSurrogate(t)), this.handler.onParseError === null || t > 31 && t < 127 || t === Nt.LINE_FEED || t === Nt.CARRIAGE_RETURN || t > 159 && t < 64976 || this._checkForProblematicCharacters(t), t);
  }
  _checkForProblematicCharacters(t) {
    ZNe(t) ? this._err(Oi.controlCharacterInInputStream) : QNe(t) && this._err(Oi.noncharacterInInputStream);
  }
  retreat(t) {
    for (this.pos -= t; this.pos < this.lastGapPos; )
      this.lastGapPos = this.gapStack.pop(), this.pos--;
    this.isEol = !1;
  }
}
var $o;
(function(e) {
  e[e.CHARACTER = 0] = "CHARACTER", e[e.NULL_CHARACTER = 1] = "NULL_CHARACTER", e[e.WHITESPACE_CHARACTER = 2] = "WHITESPACE_CHARACTER", e[e.START_TAG = 3] = "START_TAG", e[e.END_TAG = 4] = "END_TAG", e[e.COMMENT = 5] = "COMMENT", e[e.DOCTYPE = 6] = "DOCTYPE", e[e.EOF = 7] = "EOF", e[e.HIBERNATION = 8] = "HIBERNATION";
})($o || ($o = {}));
function JNe(e, t) {
  for (let i = e.attrs.length - 1; i >= 0; i--)
    if (e.attrs[i].name === t)
      return e.attrs[i].value;
  return null;
}
const Vit = /* @__PURE__ */ new Uint16Array(
  // prettier-ignore
  /* @__PURE__ */ 'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map((e) => e.charCodeAt(0))
), zit = /* @__PURE__ */ new Map([
  [0, 65533],
  // C1 Unicode control character reference replacements
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]);
function jit(e) {
  var t;
  return e >= 55296 && e <= 57343 || e > 1114111 ? 65533 : (t = zit.get(e)) !== null && t !== void 0 ? t : e;
}
var vI;
(function(e) {
  e[e.NUM = 35] = "NUM", e[e.SEMI = 59] = "SEMI", e[e.EQUALS = 61] = "EQUALS", e[e.ZERO = 48] = "ZERO", e[e.NINE = 57] = "NINE", e[e.LOWER_A = 97] = "LOWER_A", e[e.LOWER_F = 102] = "LOWER_F", e[e.LOWER_X = 120] = "LOWER_X", e[e.LOWER_Z = 122] = "LOWER_Z", e[e.UPPER_A = 65] = "UPPER_A", e[e.UPPER_F = 70] = "UPPER_F", e[e.UPPER_Z = 90] = "UPPER_Z";
})(vI || (vI = {}));
const Wit = 32;
var SP;
(function(e) {
  e[e.VALUE_LENGTH = 49152] = "VALUE_LENGTH", e[e.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", e[e.JUMP_TABLE = 127] = "JUMP_TABLE";
})(SP || (SP = {}));
function upe(e) {
  return e >= vI.ZERO && e <= vI.NINE;
}
function Yit(e) {
  return e >= vI.UPPER_A && e <= vI.UPPER_F || e >= vI.LOWER_A && e <= vI.LOWER_F;
}
function qit(e) {
  return e >= vI.UPPER_A && e <= vI.UPPER_Z || e >= vI.LOWER_A && e <= vI.LOWER_Z || upe(e);
}
function $it(e) {
  return e === vI.EQUALS || qit(e);
}
var n1;
(function(e) {
  e[e.EntityStart = 0] = "EntityStart", e[e.NumericStart = 1] = "NumericStart", e[e.NumericDecimal = 2] = "NumericDecimal", e[e.NumericHex = 3] = "NumericHex", e[e.NamedEntity = 4] = "NamedEntity";
})(n1 || (n1 = {}));
var gO;
(function(e) {
  e[e.Legacy = 0] = "Legacy", e[e.Strict = 1] = "Strict", e[e.Attribute = 2] = "Attribute";
})(gO || (gO = {}));
class Kit {
  constructor(t, i, n) {
    this.decodeTree = t, this.emitCodePoint = i, this.errors = n, this.state = n1.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = gO.Strict;
  }
  /** Resets the instance to make it reusable. */
  startEntity(t) {
    this.decodeMode = t, this.state = n1.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(t, i) {
    switch (this.state) {
      case n1.EntityStart:
        return t.charCodeAt(i) === vI.NUM ? (this.state = n1.NumericStart, this.consumed += 1, this.stateNumericStart(t, i + 1)) : (this.state = n1.NamedEntity, this.stateNamedEntity(t, i));
      case n1.NumericStart:
        return this.stateNumericStart(t, i);
      case n1.NumericDecimal:
        return this.stateNumericDecimal(t, i);
      case n1.NumericHex:
        return this.stateNumericHex(t, i);
      case n1.NamedEntity:
        return this.stateNamedEntity(t, i);
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericStart(t, i) {
    return i >= t.length ? -1 : (t.charCodeAt(i) | Wit) === vI.LOWER_X ? (this.state = n1.NumericHex, this.consumed += 1, this.stateNumericHex(t, i + 1)) : (this.state = n1.NumericDecimal, this.stateNumericDecimal(t, i));
  }
  addToNumericResult(t, i, n, s) {
    if (i !== n) {
      const o = n - i;
      this.result = this.result * Math.pow(s, o) + Number.parseInt(t.substr(i, o), s), this.consumed += o;
    }
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(t, i) {
    const n = i;
    for (; i < t.length; ) {
      const s = t.charCodeAt(i);
      if (upe(s) || Yit(s))
        i += 1;
      else
        return this.addToNumericResult(t, n, i, 16), this.emitNumericEntity(s, 3);
    }
    return this.addToNumericResult(t, n, i, 16), -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(t, i) {
    const n = i;
    for (; i < t.length; ) {
      const s = t.charCodeAt(i);
      if (upe(s))
        i += 1;
      else
        return this.addToNumericResult(t, n, i, 10), this.emitNumericEntity(s, 2);
    }
    return this.addToNumericResult(t, n, i, 10), -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(t, i) {
    var n;
    if (this.consumed <= i)
      return (n = this.errors) === null || n === void 0 || n.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (t === vI.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === gO.Strict)
      return 0;
    return this.emitCodePoint(jit(this.result), this.consumed), this.errors && (t !== vI.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(t, i) {
    const { decodeTree: n } = this;
    let s = n[this.treeIndex], o = (s & SP.VALUE_LENGTH) >> 14;
    for (; i < t.length; i++, this.excess++) {
      const r = t.charCodeAt(i);
      if (this.treeIndex = Zit(n, s, this.treeIndex + Math.max(1, o), r), this.treeIndex < 0)
        return this.result === 0 || // If we are parsing an attribute
        this.decodeMode === gO.Attribute && // We shouldn't have consumed any characters after the entity,
        (o === 0 || // And there should be no invalid characters.
        $it(r)) ? 0 : this.emitNotTerminatedNamedEntity();
      if (s = n[this.treeIndex], o = (s & SP.VALUE_LENGTH) >> 14, o !== 0) {
        if (r === vI.SEMI)
          return this.emitNamedEntityData(this.treeIndex, o, this.consumed + this.excess);
        this.decodeMode !== gO.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
      }
    }
    return -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var t;
    const { result: i, decodeTree: n } = this, s = (n[i] & SP.VALUE_LENGTH) >> 14;
    return this.emitNamedEntityData(i, s, this.consumed), (t = this.errors) === null || t === void 0 || t.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(t, i, n) {
    const { decodeTree: s } = this;
    return this.emitCodePoint(i === 1 ? s[t] & ~SP.VALUE_LENGTH : s[t + 1], n), i === 3 && this.emitCodePoint(s[t + 2], n), n;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  end() {
    var t;
    switch (this.state) {
      case n1.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== gO.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      // Otherwise, emit a numeric entity if we have one.
      case n1.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case n1.NumericHex:
        return this.emitNumericEntity(0, 3);
      case n1.NumericStart:
        return (t = this.errors) === null || t === void 0 || t.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      case n1.EntityStart:
        return 0;
    }
  }
}
function Zit(e, t, i, n) {
  const s = (t & SP.BRANCH_LENGTH) >> 7, o = t & SP.JUMP_TABLE;
  if (s === 0)
    return o !== 0 && n === o ? i : -1;
  if (o) {
    const c = n - o;
    return c < 0 || c >= s ? -1 : e[i + c] - 1;
  }
  let r = i, l = r + s - 1;
  for (; r <= l; ) {
    const c = r + l >>> 1, h = e[c];
    if (h < n)
      r = c + 1;
    else if (h > n)
      l = c - 1;
    else
      return e[c + s];
  }
  return -1;
}
var en;
(function(e) {
  e.HTML = "http://www.w3.org/1999/xhtml", e.MATHML = "http://www.w3.org/1998/Math/MathML", e.SVG = "http://www.w3.org/2000/svg", e.XLINK = "http://www.w3.org/1999/xlink", e.XML = "http://www.w3.org/XML/1998/namespace", e.XMLNS = "http://www.w3.org/2000/xmlns/";
})(en || (en = {}));
var zF;
(function(e) {
  e.TYPE = "type", e.ACTION = "action", e.ENCODING = "encoding", e.PROMPT = "prompt", e.NAME = "name", e.COLOR = "color", e.FACE = "face", e.SIZE = "size";
})(zF || (zF = {}));
var u5;
(function(e) {
  e.NO_QUIRKS = "no-quirks", e.QUIRKS = "quirks", e.LIMITED_QUIRKS = "limited-quirks";
})(u5 || (u5 = {}));
var fi;
(function(e) {
  e.A = "a", e.ADDRESS = "address", e.ANNOTATION_XML = "annotation-xml", e.APPLET = "applet", e.AREA = "area", e.ARTICLE = "article", e.ASIDE = "aside", e.B = "b", e.BASE = "base", e.BASEFONT = "basefont", e.BGSOUND = "bgsound", e.BIG = "big", e.BLOCKQUOTE = "blockquote", e.BODY = "body", e.BR = "br", e.BUTTON = "button", e.CAPTION = "caption", e.CENTER = "center", e.CODE = "code", e.COL = "col", e.COLGROUP = "colgroup", e.DD = "dd", e.DESC = "desc", e.DETAILS = "details", e.DIALOG = "dialog", e.DIR = "dir", e.DIV = "div", e.DL = "dl", e.DT = "dt", e.EM = "em", e.EMBED = "embed", e.FIELDSET = "fieldset", e.FIGCAPTION = "figcaption", e.FIGURE = "figure", e.FONT = "font", e.FOOTER = "footer", e.FOREIGN_OBJECT = "foreignObject", e.FORM = "form", e.FRAME = "frame", e.FRAMESET = "frameset", e.H1 = "h1", e.H2 = "h2", e.H3 = "h3", e.H4 = "h4", e.H5 = "h5", e.H6 = "h6", e.HEAD = "head", e.HEADER = "header", e.HGROUP = "hgroup", e.HR = "hr", e.HTML = "html", e.I = "i", e.IMG = "img", e.IMAGE = "image", e.INPUT = "input", e.IFRAME = "iframe", e.KEYGEN = "keygen", e.LABEL = "label", e.LI = "li", e.LINK = "link", e.LISTING = "listing", e.MAIN = "main", e.MALIGNMARK = "malignmark", e.MARQUEE = "marquee", e.MATH = "math", e.MENU = "menu", e.META = "meta", e.MGLYPH = "mglyph", e.MI = "mi", e.MO = "mo", e.MN = "mn", e.MS = "ms", e.MTEXT = "mtext", e.NAV = "nav", e.NOBR = "nobr", e.NOFRAMES = "noframes", e.NOEMBED = "noembed", e.NOSCRIPT = "noscript", e.OBJECT = "object", e.OL = "ol", e.OPTGROUP = "optgroup", e.OPTION = "option", e.P = "p", e.PARAM = "param", e.PLAINTEXT = "plaintext", e.PRE = "pre", e.RB = "rb", e.RP = "rp", e.RT = "rt", e.RTC = "rtc", e.RUBY = "ruby", e.S = "s", e.SCRIPT = "script", e.SEARCH = "search", e.SECTION = "section", e.SELECT = "select", e.SOURCE = "source", e.SMALL = "small", e.SPAN = "span", e.STRIKE = "strike", e.STRONG = "strong", e.STYLE = "style", e.SUB = "sub", e.SUMMARY = "summary", e.SUP = "sup", e.TABLE = "table", e.TBODY = "tbody", e.TEMPLATE = "template", e.TEXTAREA = "textarea", e.TFOOT = "tfoot", e.TD = "td", e.TH = "th", e.THEAD = "thead", e.TITLE = "title", e.TR = "tr", e.TRACK = "track", e.TT = "tt", e.U = "u", e.UL = "ul", e.SVG = "svg", e.VAR = "var", e.WBR = "wbr", e.XMP = "xmp";
})(fi || (fi = {}));
var Ee;
(function(e) {
  e[e.UNKNOWN = 0] = "UNKNOWN", e[e.A = 1] = "A", e[e.ADDRESS = 2] = "ADDRESS", e[e.ANNOTATION_XML = 3] = "ANNOTATION_XML", e[e.APPLET = 4] = "APPLET", e[e.AREA = 5] = "AREA", e[e.ARTICLE = 6] = "ARTICLE", e[e.ASIDE = 7] = "ASIDE", e[e.B = 8] = "B", e[e.BASE = 9] = "BASE", e[e.BASEFONT = 10] = "BASEFONT", e[e.BGSOUND = 11] = "BGSOUND", e[e.BIG = 12] = "BIG", e[e.BLOCKQUOTE = 13] = "BLOCKQUOTE", e[e.BODY = 14] = "BODY", e[e.BR = 15] = "BR", e[e.BUTTON = 16] = "BUTTON", e[e.CAPTION = 17] = "CAPTION", e[e.CENTER = 18] = "CENTER", e[e.CODE = 19] = "CODE", e[e.COL = 20] = "COL", e[e.COLGROUP = 21] = "COLGROUP", e[e.DD = 22] = "DD", e[e.DESC = 23] = "DESC", e[e.DETAILS = 24] = "DETAILS", e[e.DIALOG = 25] = "DIALOG", e[e.DIR = 26] = "DIR", e[e.DIV = 27] = "DIV", e[e.DL = 28] = "DL", e[e.DT = 29] = "DT", e[e.EM = 30] = "EM", e[e.EMBED = 31] = "EMBED", e[e.FIELDSET = 32] = "FIELDSET", e[e.FIGCAPTION = 33] = "FIGCAPTION", e[e.FIGURE = 34] = "FIGURE", e[e.FONT = 35] = "FONT", e[e.FOOTER = 36] = "FOOTER", e[e.FOREIGN_OBJECT = 37] = "FOREIGN_OBJECT", e[e.FORM = 38] = "FORM", e[e.FRAME = 39] = "FRAME", e[e.FRAMESET = 40] = "FRAMESET", e[e.H1 = 41] = "H1", e[e.H2 = 42] = "H2", e[e.H3 = 43] = "H3", e[e.H4 = 44] = "H4", e[e.H5 = 45] = "H5", e[e.H6 = 46] = "H6", e[e.HEAD = 47] = "HEAD", e[e.HEADER = 48] = "HEADER", e[e.HGROUP = 49] = "HGROUP", e[e.HR = 50] = "HR", e[e.HTML = 51] = "HTML", e[e.I = 52] = "I", e[e.IMG = 53] = "IMG", e[e.IMAGE = 54] = "IMAGE", e[e.INPUT = 55] = "INPUT", e[e.IFRAME = 56] = "IFRAME", e[e.KEYGEN = 57] = "KEYGEN", e[e.LABEL = 58] = "LABEL", e[e.LI = 59] = "LI", e[e.LINK = 60] = "LINK", e[e.LISTING = 61] = "LISTING", e[e.MAIN = 62] = "MAIN", e[e.MALIGNMARK = 63] = "MALIGNMARK", e[e.MARQUEE = 64] = "MARQUEE", e[e.MATH = 65] = "MATH", e[e.MENU = 66] = "MENU", e[e.META = 67] = "META", e[e.MGLYPH = 68] = "MGLYPH", e[e.MI = 69] = "MI", e[e.MO = 70] = "MO", e[e.MN = 71] = "MN", e[e.MS = 72] = "MS", e[e.MTEXT = 73] = "MTEXT", e[e.NAV = 74] = "NAV", e[e.NOBR = 75] = "NOBR", e[e.NOFRAMES = 76] = "NOFRAMES", e[e.NOEMBED = 77] = "NOEMBED", e[e.NOSCRIPT = 78] = "NOSCRIPT", e[e.OBJECT = 79] = "OBJECT", e[e.OL = 80] = "OL", e[e.OPTGROUP = 81] = "OPTGROUP", e[e.OPTION = 82] = "OPTION", e[e.P = 83] = "P", e[e.PARAM = 84] = "PARAM", e[e.PLAINTEXT = 85] = "PLAINTEXT", e[e.PRE = 86] = "PRE", e[e.RB = 87] = "RB", e[e.RP = 88] = "RP", e[e.RT = 89] = "RT", e[e.RTC = 90] = "RTC", e[e.RUBY = 91] = "RUBY", e[e.S = 92] = "S", e[e.SCRIPT = 93] = "SCRIPT", e[e.SEARCH = 94] = "SEARCH", e[e.SECTION = 95] = "SECTION", e[e.SELECT = 96] = "SELECT", e[e.SOURCE = 97] = "SOURCE", e[e.SMALL = 98] = "SMALL", e[e.SPAN = 99] = "SPAN", e[e.STRIKE = 100] = "STRIKE", e[e.STRONG = 101] = "STRONG", e[e.STYLE = 102] = "STYLE", e[e.SUB = 103] = "SUB", e[e.SUMMARY = 104] = "SUMMARY", e[e.SUP = 105] = "SUP", e[e.TABLE = 106] = "TABLE", e[e.TBODY = 107] = "TBODY", e[e.TEMPLATE = 108] = "TEMPLATE", e[e.TEXTAREA = 109] = "TEXTAREA", e[e.TFOOT = 110] = "TFOOT", e[e.TD = 111] = "TD", e[e.TH = 112] = "TH", e[e.THEAD = 113] = "THEAD", e[e.TITLE = 114] = "TITLE", e[e.TR = 115] = "TR", e[e.TRACK = 116] = "TRACK", e[e.TT = 117] = "TT", e[e.U = 118] = "U", e[e.UL = 119] = "UL", e[e.SVG = 120] = "SVG", e[e.VAR = 121] = "VAR", e[e.WBR = 122] = "WBR", e[e.XMP = 123] = "XMP";
})(Ee || (Ee = {}));
const Qit = /* @__PURE__ */ new Map([
  [fi.A, Ee.A],
  [fi.ADDRESS, Ee.ADDRESS],
  [fi.ANNOTATION_XML, Ee.ANNOTATION_XML],
  [fi.APPLET, Ee.APPLET],
  [fi.AREA, Ee.AREA],
  [fi.ARTICLE, Ee.ARTICLE],
  [fi.ASIDE, Ee.ASIDE],
  [fi.B, Ee.B],
  [fi.BASE, Ee.BASE],
  [fi.BASEFONT, Ee.BASEFONT],
  [fi.BGSOUND, Ee.BGSOUND],
  [fi.BIG, Ee.BIG],
  [fi.BLOCKQUOTE, Ee.BLOCKQUOTE],
  [fi.BODY, Ee.BODY],
  [fi.BR, Ee.BR],
  [fi.BUTTON, Ee.BUTTON],
  [fi.CAPTION, Ee.CAPTION],
  [fi.CENTER, Ee.CENTER],
  [fi.CODE, Ee.CODE],
  [fi.COL, Ee.COL],
  [fi.COLGROUP, Ee.COLGROUP],
  [fi.DD, Ee.DD],
  [fi.DESC, Ee.DESC],
  [fi.DETAILS, Ee.DETAILS],
  [fi.DIALOG, Ee.DIALOG],
  [fi.DIR, Ee.DIR],
  [fi.DIV, Ee.DIV],
  [fi.DL, Ee.DL],
  [fi.DT, Ee.DT],
  [fi.EM, Ee.EM],
  [fi.EMBED, Ee.EMBED],
  [fi.FIELDSET, Ee.FIELDSET],
  [fi.FIGCAPTION, Ee.FIGCAPTION],
  [fi.FIGURE, Ee.FIGURE],
  [fi.FONT, Ee.FONT],
  [fi.FOOTER, Ee.FOOTER],
  [fi.FOREIGN_OBJECT, Ee.FOREIGN_OBJECT],
  [fi.FORM, Ee.FORM],
  [fi.FRAME, Ee.FRAME],
  [fi.FRAMESET, Ee.FRAMESET],
  [fi.H1, Ee.H1],
  [fi.H2, Ee.H2],
  [fi.H3, Ee.H3],
  [fi.H4, Ee.H4],
  [fi.H5, Ee.H5],
  [fi.H6, Ee.H6],
  [fi.HEAD, Ee.HEAD],
  [fi.HEADER, Ee.HEADER],
  [fi.HGROUP, Ee.HGROUP],
  [fi.HR, Ee.HR],
  [fi.HTML, Ee.HTML],
  [fi.I, Ee.I],
  [fi.IMG, Ee.IMG],
  [fi.IMAGE, Ee.IMAGE],
  [fi.INPUT, Ee.INPUT],
  [fi.IFRAME, Ee.IFRAME],
  [fi.KEYGEN, Ee.KEYGEN],
  [fi.LABEL, Ee.LABEL],
  [fi.LI, Ee.LI],
  [fi.LINK, Ee.LINK],
  [fi.LISTING, Ee.LISTING],
  [fi.MAIN, Ee.MAIN],
  [fi.MALIGNMARK, Ee.MALIGNMARK],
  [fi.MARQUEE, Ee.MARQUEE],
  [fi.MATH, Ee.MATH],
  [fi.MENU, Ee.MENU],
  [fi.META, Ee.META],
  [fi.MGLYPH, Ee.MGLYPH],
  [fi.MI, Ee.MI],
  [fi.MO, Ee.MO],
  [fi.MN, Ee.MN],
  [fi.MS, Ee.MS],
  [fi.MTEXT, Ee.MTEXT],
  [fi.NAV, Ee.NAV],
  [fi.NOBR, Ee.NOBR],
  [fi.NOFRAMES, Ee.NOFRAMES],
  [fi.NOEMBED, Ee.NOEMBED],
  [fi.NOSCRIPT, Ee.NOSCRIPT],
  [fi.OBJECT, Ee.OBJECT],
  [fi.OL, Ee.OL],
  [fi.OPTGROUP, Ee.OPTGROUP],
  [fi.OPTION, Ee.OPTION],
  [fi.P, Ee.P],
  [fi.PARAM, Ee.PARAM],
  [fi.PLAINTEXT, Ee.PLAINTEXT],
  [fi.PRE, Ee.PRE],
  [fi.RB, Ee.RB],
  [fi.RP, Ee.RP],
  [fi.RT, Ee.RT],
  [fi.RTC, Ee.RTC],
  [fi.RUBY, Ee.RUBY],
  [fi.S, Ee.S],
  [fi.SCRIPT, Ee.SCRIPT],
  [fi.SEARCH, Ee.SEARCH],
  [fi.SECTION, Ee.SECTION],
  [fi.SELECT, Ee.SELECT],
  [fi.SOURCE, Ee.SOURCE],
  [fi.SMALL, Ee.SMALL],
  [fi.SPAN, Ee.SPAN],
  [fi.STRIKE, Ee.STRIKE],
  [fi.STRONG, Ee.STRONG],
  [fi.STYLE, Ee.STYLE],
  [fi.SUB, Ee.SUB],
  [fi.SUMMARY, Ee.SUMMARY],
  [fi.SUP, Ee.SUP],
  [fi.TABLE, Ee.TABLE],
  [fi.TBODY, Ee.TBODY],
  [fi.TEMPLATE, Ee.TEMPLATE],
  [fi.TEXTAREA, Ee.TEXTAREA],
  [fi.TFOOT, Ee.TFOOT],
  [fi.TD, Ee.TD],
  [fi.TH, Ee.TH],
  [fi.THEAD, Ee.THEAD],
  [fi.TITLE, Ee.TITLE],
  [fi.TR, Ee.TR],
  [fi.TRACK, Ee.TRACK],
  [fi.TT, Ee.TT],
  [fi.U, Ee.U],
  [fi.UL, Ee.UL],
  [fi.SVG, Ee.SVG],
  [fi.VAR, Ee.VAR],
  [fi.WBR, Ee.WBR],
  [fi.XMP, Ee.XMP]
]);
function fY(e) {
  var t;
  return (t = Qit.get(e)) !== null && t !== void 0 ? t : Ee.UNKNOWN;
}
const on = Ee, Jit = {
  [en.HTML]: /* @__PURE__ */ new Set([
    on.ADDRESS,
    on.APPLET,
    on.AREA,
    on.ARTICLE,
    on.ASIDE,
    on.BASE,
    on.BASEFONT,
    on.BGSOUND,
    on.BLOCKQUOTE,
    on.BODY,
    on.BR,
    on.BUTTON,
    on.CAPTION,
    on.CENTER,
    on.COL,
    on.COLGROUP,
    on.DD,
    on.DETAILS,
    on.DIR,
    on.DIV,
    on.DL,
    on.DT,
    on.EMBED,
    on.FIELDSET,
    on.FIGCAPTION,
    on.FIGURE,
    on.FOOTER,
    on.FORM,
    on.FRAME,
    on.FRAMESET,
    on.H1,
    on.H2,
    on.H3,
    on.H4,
    on.H5,
    on.H6,
    on.HEAD,
    on.HEADER,
    on.HGROUP,
    on.HR,
    on.HTML,
    on.IFRAME,
    on.IMG,
    on.INPUT,
    on.LI,
    on.LINK,
    on.LISTING,
    on.MAIN,
    on.MARQUEE,
    on.MENU,
    on.META,
    on.NAV,
    on.NOEMBED,
    on.NOFRAMES,
    on.NOSCRIPT,
    on.OBJECT,
    on.OL,
    on.P,
    on.PARAM,
    on.PLAINTEXT,
    on.PRE,
    on.SCRIPT,
    on.SECTION,
    on.SELECT,
    on.SOURCE,
    on.STYLE,
    on.SUMMARY,
    on.TABLE,
    on.TBODY,
    on.TD,
    on.TEMPLATE,
    on.TEXTAREA,
    on.TFOOT,
    on.TH,
    on.THEAD,
    on.TITLE,
    on.TR,
    on.TRACK,
    on.UL,
    on.WBR,
    on.XMP
  ]),
  [en.MATHML]: /* @__PURE__ */ new Set([on.MI, on.MO, on.MN, on.MS, on.MTEXT, on.ANNOTATION_XML]),
  [en.SVG]: /* @__PURE__ */ new Set([on.TITLE, on.FOREIGN_OBJECT, on.DESC]),
  [en.XLINK]: /* @__PURE__ */ new Set(),
  [en.XML]: /* @__PURE__ */ new Set(),
  [en.XMLNS]: /* @__PURE__ */ new Set()
}, dpe = /* @__PURE__ */ new Set([on.H1, on.H2, on.H3, on.H4, on.H5, on.H6]);
fi.STYLE, fi.SCRIPT, fi.XMP, fi.IFRAME, fi.NOEMBED, fi.NOFRAMES, fi.PLAINTEXT;
var Pt;
(function(e) {
  e[e.DATA = 0] = "DATA", e[e.RCDATA = 1] = "RCDATA", e[e.RAWTEXT = 2] = "RAWTEXT", e[e.SCRIPT_DATA = 3] = "SCRIPT_DATA", e[e.PLAINTEXT = 4] = "PLAINTEXT", e[e.TAG_OPEN = 5] = "TAG_OPEN", e[e.END_TAG_OPEN = 6] = "END_TAG_OPEN", e[e.TAG_NAME = 7] = "TAG_NAME", e[e.RCDATA_LESS_THAN_SIGN = 8] = "RCDATA_LESS_THAN_SIGN", e[e.RCDATA_END_TAG_OPEN = 9] = "RCDATA_END_TAG_OPEN", e[e.RCDATA_END_TAG_NAME = 10] = "RCDATA_END_TAG_NAME", e[e.RAWTEXT_LESS_THAN_SIGN = 11] = "RAWTEXT_LESS_THAN_SIGN", e[e.RAWTEXT_END_TAG_OPEN = 12] = "RAWTEXT_END_TAG_OPEN", e[e.RAWTEXT_END_TAG_NAME = 13] = "RAWTEXT_END_TAG_NAME", e[e.SCRIPT_DATA_LESS_THAN_SIGN = 14] = "SCRIPT_DATA_LESS_THAN_SIGN", e[e.SCRIPT_DATA_END_TAG_OPEN = 15] = "SCRIPT_DATA_END_TAG_OPEN", e[e.SCRIPT_DATA_END_TAG_NAME = 16] = "SCRIPT_DATA_END_TAG_NAME", e[e.SCRIPT_DATA_ESCAPE_START = 17] = "SCRIPT_DATA_ESCAPE_START", e[e.SCRIPT_DATA_ESCAPE_START_DASH = 18] = "SCRIPT_DATA_ESCAPE_START_DASH", e[e.SCRIPT_DATA_ESCAPED = 19] = "SCRIPT_DATA_ESCAPED", e[e.SCRIPT_DATA_ESCAPED_DASH = 20] = "SCRIPT_DATA_ESCAPED_DASH", e[e.SCRIPT_DATA_ESCAPED_DASH_DASH = 21] = "SCRIPT_DATA_ESCAPED_DASH_DASH", e[e.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN = 22] = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN", e[e.SCRIPT_DATA_ESCAPED_END_TAG_OPEN = 23] = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN", e[e.SCRIPT_DATA_ESCAPED_END_TAG_NAME = 24] = "SCRIPT_DATA_ESCAPED_END_TAG_NAME", e[e.SCRIPT_DATA_DOUBLE_ESCAPE_START = 25] = "SCRIPT_DATA_DOUBLE_ESCAPE_START", e[e.SCRIPT_DATA_DOUBLE_ESCAPED = 26] = "SCRIPT_DATA_DOUBLE_ESCAPED", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_DASH = 27] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH = 28] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN = 29] = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN", e[e.SCRIPT_DATA_DOUBLE_ESCAPE_END = 30] = "SCRIPT_DATA_DOUBLE_ESCAPE_END", e[e.BEFORE_ATTRIBUTE_NAME = 31] = "BEFORE_ATTRIBUTE_NAME", e[e.ATTRIBUTE_NAME = 32] = "ATTRIBUTE_NAME", e[e.AFTER_ATTRIBUTE_NAME = 33] = "AFTER_ATTRIBUTE_NAME", e[e.BEFORE_ATTRIBUTE_VALUE = 34] = "BEFORE_ATTRIBUTE_VALUE", e[e.ATTRIBUTE_VALUE_DOUBLE_QUOTED = 35] = "ATTRIBUTE_VALUE_DOUBLE_QUOTED", e[e.ATTRIBUTE_VALUE_SINGLE_QUOTED = 36] = "ATTRIBUTE_VALUE_SINGLE_QUOTED", e[e.ATTRIBUTE_VALUE_UNQUOTED = 37] = "ATTRIBUTE_VALUE_UNQUOTED", e[e.AFTER_ATTRIBUTE_VALUE_QUOTED = 38] = "AFTER_ATTRIBUTE_VALUE_QUOTED", e[e.SELF_CLOSING_START_TAG = 39] = "SELF_CLOSING_START_TAG", e[e.BOGUS_COMMENT = 40] = "BOGUS_COMMENT", e[e.MARKUP_DECLARATION_OPEN = 41] = "MARKUP_DECLARATION_OPEN", e[e.COMMENT_START = 42] = "COMMENT_START", e[e.COMMENT_START_DASH = 43] = "COMMENT_START_DASH", e[e.COMMENT = 44] = "COMMENT", e[e.COMMENT_LESS_THAN_SIGN = 45] = "COMMENT_LESS_THAN_SIGN", e[e.COMMENT_LESS_THAN_SIGN_BANG = 46] = "COMMENT_LESS_THAN_SIGN_BANG", e[e.COMMENT_LESS_THAN_SIGN_BANG_DASH = 47] = "COMMENT_LESS_THAN_SIGN_BANG_DASH", e[e.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH = 48] = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH", e[e.COMMENT_END_DASH = 49] = "COMMENT_END_DASH", e[e.COMMENT_END = 50] = "COMMENT_END", e[e.COMMENT_END_BANG = 51] = "COMMENT_END_BANG", e[e.DOCTYPE = 52] = "DOCTYPE", e[e.BEFORE_DOCTYPE_NAME = 53] = "BEFORE_DOCTYPE_NAME", e[e.DOCTYPE_NAME = 54] = "DOCTYPE_NAME", e[e.AFTER_DOCTYPE_NAME = 55] = "AFTER_DOCTYPE_NAME", e[e.AFTER_DOCTYPE_PUBLIC_KEYWORD = 56] = "AFTER_DOCTYPE_PUBLIC_KEYWORD", e[e.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER = 57] = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER", e[e.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED = 58] = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED", e[e.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED = 59] = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED", e[e.AFTER_DOCTYPE_PUBLIC_IDENTIFIER = 60] = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER", e[e.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS = 61] = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS", e[e.AFTER_DOCTYPE_SYSTEM_KEYWORD = 62] = "AFTER_DOCTYPE_SYSTEM_KEYWORD", e[e.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER = 63] = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER", e[e.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED = 64] = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED", e[e.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED = 65] = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED", e[e.AFTER_DOCTYPE_SYSTEM_IDENTIFIER = 66] = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER", e[e.BOGUS_DOCTYPE = 67] = "BOGUS_DOCTYPE", e[e.CDATA_SECTION = 68] = "CDATA_SECTION", e[e.CDATA_SECTION_BRACKET = 69] = "CDATA_SECTION_BRACKET", e[e.CDATA_SECTION_END = 70] = "CDATA_SECTION_END", e[e.CHARACTER_REFERENCE = 71] = "CHARACTER_REFERENCE", e[e.AMBIGUOUS_AMPERSAND = 72] = "AMBIGUOUS_AMPERSAND";
})(Pt || (Pt = {}));
const d0 = {
  DATA: Pt.DATA,
  RCDATA: Pt.RCDATA,
  RAWTEXT: Pt.RAWTEXT,
  SCRIPT_DATA: Pt.SCRIPT_DATA,
  PLAINTEXT: Pt.PLAINTEXT,
  CDATA_SECTION: Pt.CDATA_SECTION
};
function Xit(e) {
  return e >= Nt.DIGIT_0 && e <= Nt.DIGIT_9;
}
function yJ(e) {
  return e >= Nt.LATIN_CAPITAL_A && e <= Nt.LATIN_CAPITAL_Z;
}
function ent(e) {
  return e >= Nt.LATIN_SMALL_A && e <= Nt.LATIN_SMALL_Z;
}
function W_(e) {
  return ent(e) || yJ(e);
}
function N4e(e) {
  return W_(e) || Xit(e);
}
function zse(e) {
  return e + 32;
}
function XNe(e) {
  return e === Nt.SPACE || e === Nt.LINE_FEED || e === Nt.TABULATION || e === Nt.FORM_FEED;
}
function D4e(e) {
  return XNe(e) || e === Nt.SOLIDUS || e === Nt.GREATER_THAN_SIGN;
}
function tnt(e) {
  return e === Nt.NULL ? Oi.nullCharacterReference : e > 1114111 ? Oi.characterReferenceOutsideUnicodeRange : KNe(e) ? Oi.surrogateCharacterReference : QNe(e) ? Oi.noncharacterCharacterReference : ZNe(e) || e === Nt.CARRIAGE_RETURN ? Oi.controlCharacterReference : null;
}
class int {
  constructor(t, i) {
    this.options = t, this.handler = i, this.paused = !1, this.inLoop = !1, this.inForeignNode = !1, this.lastStartTagName = "", this.active = !1, this.state = Pt.DATA, this.returnState = Pt.DATA, this.entityStartPos = 0, this.consumedAfterSnapshot = -1, this.currentCharacterToken = null, this.currentToken = null, this.currentAttr = { name: "", value: "" }, this.preprocessor = new kit(i), this.currentLocation = this.getCurrentLocation(-1), this.entityDecoder = new Kit(Vit, (n, s) => {
      this.preprocessor.pos = this.entityStartPos + s - 1, this._flushCodePointConsumedAsCharacterReference(n);
    }, i.onParseError ? {
      missingSemicolonAfterCharacterReference: () => {
        this._err(Oi.missingSemicolonAfterCharacterReference, 1);
      },
      absenceOfDigitsInNumericCharacterReference: (n) => {
        this._err(Oi.absenceOfDigitsInNumericCharacterReference, this.entityStartPos - this.preprocessor.pos + n);
      },
      validateNumericCharacterReference: (n) => {
        const s = tnt(n);
        s && this._err(s, 1);
      }
    } : void 0);
  }
  //Errors
  _err(t, i = 0) {
    var n, s;
    (s = (n = this.handler).onParseError) === null || s === void 0 || s.call(n, this.preprocessor.getError(t, i));
  }
  // NOTE: `offset` may never run across line boundaries.
  getCurrentLocation(t) {
    return this.options.sourceCodeLocationInfo ? {
      startLine: this.preprocessor.line,
      startCol: this.preprocessor.col - t,
      startOffset: this.preprocessor.offset - t,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    } : null;
  }
  _runParsingLoop() {
    if (!this.inLoop) {
      for (this.inLoop = !0; this.active && !this.paused; ) {
        this.consumedAfterSnapshot = 0;
        const t = this._consume();
        this._ensureHibernation() || this._callState(t);
      }
      this.inLoop = !1;
    }
  }
  //API
  pause() {
    this.paused = !0;
  }
  resume(t) {
    if (!this.paused)
      throw new Error("Parser was already resumed");
    this.paused = !1, !this.inLoop && (this._runParsingLoop(), this.paused || t == null || t());
  }
  write(t, i, n) {
    this.active = !0, this.preprocessor.write(t, i), this._runParsingLoop(), this.paused || n == null || n();
  }
  insertHtmlAtCurrentPos(t) {
    this.active = !0, this.preprocessor.insertHtmlAtCurrentPos(t), this._runParsingLoop();
  }
  //Hibernation
  _ensureHibernation() {
    return this.preprocessor.endOfChunkHit ? (this.preprocessor.retreat(this.consumedAfterSnapshot), this.consumedAfterSnapshot = 0, this.active = !1, !0) : !1;
  }
  //Consumption
  _consume() {
    return this.consumedAfterSnapshot++, this.preprocessor.advance();
  }
  _advanceBy(t) {
    this.consumedAfterSnapshot += t;
    for (let i = 0; i < t; i++)
      this.preprocessor.advance();
  }
  _consumeSequenceIfMatch(t, i) {
    return this.preprocessor.startsWith(t, i) ? (this._advanceBy(t.length - 1), !0) : !1;
  }
  //Token creation
  _createStartTagToken() {
    this.currentToken = {
      type: $o.START_TAG,
      tagName: "",
      tagID: Ee.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(1)
    };
  }
  _createEndTagToken() {
    this.currentToken = {
      type: $o.END_TAG,
      tagName: "",
      tagID: Ee.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(2)
    };
  }
  _createCommentToken(t) {
    this.currentToken = {
      type: $o.COMMENT,
      data: "",
      location: this.getCurrentLocation(t)
    };
  }
  _createDoctypeToken(t) {
    this.currentToken = {
      type: $o.DOCTYPE,
      name: t,
      forceQuirks: !1,
      publicId: null,
      systemId: null,
      location: this.currentLocation
    };
  }
  _createCharacterToken(t, i) {
    this.currentCharacterToken = {
      type: t,
      chars: i,
      location: this.currentLocation
    };
  }
  //Tag attributes
  _createAttr(t) {
    this.currentAttr = {
      name: t,
      value: ""
    }, this.currentLocation = this.getCurrentLocation(0);
  }
  _leaveAttrName() {
    var t, i;
    const n = this.currentToken;
    if (JNe(n, this.currentAttr.name) === null) {
      if (n.attrs.push(this.currentAttr), n.location && this.currentLocation) {
        const s = (t = (i = n.location).attrs) !== null && t !== void 0 ? t : i.attrs = /* @__PURE__ */ Object.create(null);
        s[this.currentAttr.name] = this.currentLocation, this._leaveAttrValue();
      }
    } else
      this._err(Oi.duplicateAttribute);
  }
  _leaveAttrValue() {
    this.currentLocation && (this.currentLocation.endLine = this.preprocessor.line, this.currentLocation.endCol = this.preprocessor.col, this.currentLocation.endOffset = this.preprocessor.offset);
  }
  //Token emission
  prepareToken(t) {
    this._emitCurrentCharacterToken(t.location), this.currentToken = null, t.location && (t.location.endLine = this.preprocessor.line, t.location.endCol = this.preprocessor.col + 1, t.location.endOffset = this.preprocessor.offset + 1), this.currentLocation = this.getCurrentLocation(-1);
  }
  emitCurrentTagToken() {
    const t = this.currentToken;
    this.prepareToken(t), t.tagID = fY(t.tagName), t.type === $o.START_TAG ? (this.lastStartTagName = t.tagName, this.handler.onStartTag(t)) : (t.attrs.length > 0 && this._err(Oi.endTagWithAttributes), t.selfClosing && this._err(Oi.endTagWithTrailingSolidus), this.handler.onEndTag(t)), this.preprocessor.dropParsedChunk();
  }
  emitCurrentComment(t) {
    this.prepareToken(t), this.handler.onComment(t), this.preprocessor.dropParsedChunk();
  }
  emitCurrentDoctype(t) {
    this.prepareToken(t), this.handler.onDoctype(t), this.preprocessor.dropParsedChunk();
  }
  _emitCurrentCharacterToken(t) {
    if (this.currentCharacterToken) {
      switch (t && this.currentCharacterToken.location && (this.currentCharacterToken.location.endLine = t.startLine, this.currentCharacterToken.location.endCol = t.startCol, this.currentCharacterToken.location.endOffset = t.startOffset), this.currentCharacterToken.type) {
        case $o.CHARACTER: {
          this.handler.onCharacter(this.currentCharacterToken);
          break;
        }
        case $o.NULL_CHARACTER: {
          this.handler.onNullCharacter(this.currentCharacterToken);
          break;
        }
        case $o.WHITESPACE_CHARACTER: {
          this.handler.onWhitespaceCharacter(this.currentCharacterToken);
          break;
        }
      }
      this.currentCharacterToken = null;
    }
  }
  _emitEOFToken() {
    const t = this.getCurrentLocation(0);
    t && (t.endLine = t.startLine, t.endCol = t.startCol, t.endOffset = t.startOffset), this._emitCurrentCharacterToken(t), this.handler.onEof({ type: $o.EOF, location: t }), this.active = !1;
  }
  //Characters emission
  //OPTIMIZATION: The specification uses only one type of character token (one token per character).
  //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
  //If we have a sequence of characters that belong to the same group, the parser can process it
  //as a single solid character token.
  //So, there are 3 types of character tokens in parse5:
  //1)TokenType.NULL_CHARACTER - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
  //2)TokenType.WHITESPACE_CHARACTER - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
  //3)TokenType.CHARACTER - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
  _appendCharToCurrentCharacterToken(t, i) {
    if (this.currentCharacterToken)
      if (this.currentCharacterToken.type === t) {
        this.currentCharacterToken.chars += i;
        return;
      } else
        this.currentLocation = this.getCurrentLocation(0), this._emitCurrentCharacterToken(this.currentLocation), this.preprocessor.dropParsedChunk();
    this._createCharacterToken(t, i);
  }
  _emitCodePoint(t) {
    const i = XNe(t) ? $o.WHITESPACE_CHARACTER : t === Nt.NULL ? $o.NULL_CHARACTER : $o.CHARACTER;
    this._appendCharToCurrentCharacterToken(i, String.fromCodePoint(t));
  }
  //NOTE: used when we emit characters explicitly.
  //This is always for non-whitespace and non-null characters, which allows us to avoid additional checks.
  _emitChars(t) {
    this._appendCharToCurrentCharacterToken($o.CHARACTER, t);
  }
  // Character reference helpers
  _startCharacterReference() {
    this.returnState = this.state, this.state = Pt.CHARACTER_REFERENCE, this.entityStartPos = this.preprocessor.pos, this.entityDecoder.startEntity(this._isCharacterReferenceInAttribute() ? gO.Attribute : gO.Legacy);
  }
  _isCharacterReferenceInAttribute() {
    return this.returnState === Pt.ATTRIBUTE_VALUE_DOUBLE_QUOTED || this.returnState === Pt.ATTRIBUTE_VALUE_SINGLE_QUOTED || this.returnState === Pt.ATTRIBUTE_VALUE_UNQUOTED;
  }
  _flushCodePointConsumedAsCharacterReference(t) {
    this._isCharacterReferenceInAttribute() ? this.currentAttr.value += String.fromCodePoint(t) : this._emitCodePoint(t);
  }
  // Calling states this way turns out to be much faster than any other approach.
  _callState(t) {
    switch (this.state) {
      case Pt.DATA: {
        this._stateData(t);
        break;
      }
      case Pt.RCDATA: {
        this._stateRcdata(t);
        break;
      }
      case Pt.RAWTEXT: {
        this._stateRawtext(t);
        break;
      }
      case Pt.SCRIPT_DATA: {
        this._stateScriptData(t);
        break;
      }
      case Pt.PLAINTEXT: {
        this._statePlaintext(t);
        break;
      }
      case Pt.TAG_OPEN: {
        this._stateTagOpen(t);
        break;
      }
      case Pt.END_TAG_OPEN: {
        this._stateEndTagOpen(t);
        break;
      }
      case Pt.TAG_NAME: {
        this._stateTagName(t);
        break;
      }
      case Pt.RCDATA_LESS_THAN_SIGN: {
        this._stateRcdataLessThanSign(t);
        break;
      }
      case Pt.RCDATA_END_TAG_OPEN: {
        this._stateRcdataEndTagOpen(t);
        break;
      }
      case Pt.RCDATA_END_TAG_NAME: {
        this._stateRcdataEndTagName(t);
        break;
      }
      case Pt.RAWTEXT_LESS_THAN_SIGN: {
        this._stateRawtextLessThanSign(t);
        break;
      }
      case Pt.RAWTEXT_END_TAG_OPEN: {
        this._stateRawtextEndTagOpen(t);
        break;
      }
      case Pt.RAWTEXT_END_TAG_NAME: {
        this._stateRawtextEndTagName(t);
        break;
      }
      case Pt.SCRIPT_DATA_LESS_THAN_SIGN: {
        this._stateScriptDataLessThanSign(t);
        break;
      }
      case Pt.SCRIPT_DATA_END_TAG_OPEN: {
        this._stateScriptDataEndTagOpen(t);
        break;
      }
      case Pt.SCRIPT_DATA_END_TAG_NAME: {
        this._stateScriptDataEndTagName(t);
        break;
      }
      case Pt.SCRIPT_DATA_ESCAPE_START: {
        this._stateScriptDataEscapeStart(t);
        break;
      }
      case Pt.SCRIPT_DATA_ESCAPE_START_DASH: {
        this._stateScriptDataEscapeStartDash(t);
        break;
      }
      case Pt.SCRIPT_DATA_ESCAPED: {
        this._stateScriptDataEscaped(t);
        break;
      }
      case Pt.SCRIPT_DATA_ESCAPED_DASH: {
        this._stateScriptDataEscapedDash(t);
        break;
      }
      case Pt.SCRIPT_DATA_ESCAPED_DASH_DASH: {
        this._stateScriptDataEscapedDashDash(t);
        break;
      }
      case Pt.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataEscapedLessThanSign(t);
        break;
      }
      case Pt.SCRIPT_DATA_ESCAPED_END_TAG_OPEN: {
        this._stateScriptDataEscapedEndTagOpen(t);
        break;
      }
      case Pt.SCRIPT_DATA_ESCAPED_END_TAG_NAME: {
        this._stateScriptDataEscapedEndTagName(t);
        break;
      }
      case Pt.SCRIPT_DATA_DOUBLE_ESCAPE_START: {
        this._stateScriptDataDoubleEscapeStart(t);
        break;
      }
      case Pt.SCRIPT_DATA_DOUBLE_ESCAPED: {
        this._stateScriptDataDoubleEscaped(t);
        break;
      }
      case Pt.SCRIPT_DATA_DOUBLE_ESCAPED_DASH: {
        this._stateScriptDataDoubleEscapedDash(t);
        break;
      }
      case Pt.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH: {
        this._stateScriptDataDoubleEscapedDashDash(t);
        break;
      }
      case Pt.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataDoubleEscapedLessThanSign(t);
        break;
      }
      case Pt.SCRIPT_DATA_DOUBLE_ESCAPE_END: {
        this._stateScriptDataDoubleEscapeEnd(t);
        break;
      }
      case Pt.BEFORE_ATTRIBUTE_NAME: {
        this._stateBeforeAttributeName(t);
        break;
      }
      case Pt.ATTRIBUTE_NAME: {
        this._stateAttributeName(t);
        break;
      }
      case Pt.AFTER_ATTRIBUTE_NAME: {
        this._stateAfterAttributeName(t);
        break;
      }
      case Pt.BEFORE_ATTRIBUTE_VALUE: {
        this._stateBeforeAttributeValue(t);
        break;
      }
      case Pt.ATTRIBUTE_VALUE_DOUBLE_QUOTED: {
        this._stateAttributeValueDoubleQuoted(t);
        break;
      }
      case Pt.ATTRIBUTE_VALUE_SINGLE_QUOTED: {
        this._stateAttributeValueSingleQuoted(t);
        break;
      }
      case Pt.ATTRIBUTE_VALUE_UNQUOTED: {
        this._stateAttributeValueUnquoted(t);
        break;
      }
      case Pt.AFTER_ATTRIBUTE_VALUE_QUOTED: {
        this._stateAfterAttributeValueQuoted(t);
        break;
      }
      case Pt.SELF_CLOSING_START_TAG: {
        this._stateSelfClosingStartTag(t);
        break;
      }
      case Pt.BOGUS_COMMENT: {
        this._stateBogusComment(t);
        break;
      }
      case Pt.MARKUP_DECLARATION_OPEN: {
        this._stateMarkupDeclarationOpen(t);
        break;
      }
      case Pt.COMMENT_START: {
        this._stateCommentStart(t);
        break;
      }
      case Pt.COMMENT_START_DASH: {
        this._stateCommentStartDash(t);
        break;
      }
      case Pt.COMMENT: {
        this._stateComment(t);
        break;
      }
      case Pt.COMMENT_LESS_THAN_SIGN: {
        this._stateCommentLessThanSign(t);
        break;
      }
      case Pt.COMMENT_LESS_THAN_SIGN_BANG: {
        this._stateCommentLessThanSignBang(t);
        break;
      }
      case Pt.COMMENT_LESS_THAN_SIGN_BANG_DASH: {
        this._stateCommentLessThanSignBangDash(t);
        break;
      }
      case Pt.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH: {
        this._stateCommentLessThanSignBangDashDash(t);
        break;
      }
      case Pt.COMMENT_END_DASH: {
        this._stateCommentEndDash(t);
        break;
      }
      case Pt.COMMENT_END: {
        this._stateCommentEnd(t);
        break;
      }
      case Pt.COMMENT_END_BANG: {
        this._stateCommentEndBang(t);
        break;
      }
      case Pt.DOCTYPE: {
        this._stateDoctype(t);
        break;
      }
      case Pt.BEFORE_DOCTYPE_NAME: {
        this._stateBeforeDoctypeName(t);
        break;
      }
      case Pt.DOCTYPE_NAME: {
        this._stateDoctypeName(t);
        break;
      }
      case Pt.AFTER_DOCTYPE_NAME: {
        this._stateAfterDoctypeName(t);
        break;
      }
      case Pt.AFTER_DOCTYPE_PUBLIC_KEYWORD: {
        this._stateAfterDoctypePublicKeyword(t);
        break;
      }
      case Pt.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateBeforeDoctypePublicIdentifier(t);
        break;
      }
      case Pt.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypePublicIdentifierDoubleQuoted(t);
        break;
      }
      case Pt.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypePublicIdentifierSingleQuoted(t);
        break;
      }
      case Pt.AFTER_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateAfterDoctypePublicIdentifier(t);
        break;
      }
      case Pt.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS: {
        this._stateBetweenDoctypePublicAndSystemIdentifiers(t);
        break;
      }
      case Pt.AFTER_DOCTYPE_SYSTEM_KEYWORD: {
        this._stateAfterDoctypeSystemKeyword(t);
        break;
      }
      case Pt.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateBeforeDoctypeSystemIdentifier(t);
        break;
      }
      case Pt.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypeSystemIdentifierDoubleQuoted(t);
        break;
      }
      case Pt.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypeSystemIdentifierSingleQuoted(t);
        break;
      }
      case Pt.AFTER_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateAfterDoctypeSystemIdentifier(t);
        break;
      }
      case Pt.BOGUS_DOCTYPE: {
        this._stateBogusDoctype(t);
        break;
      }
      case Pt.CDATA_SECTION: {
        this._stateCdataSection(t);
        break;
      }
      case Pt.CDATA_SECTION_BRACKET: {
        this._stateCdataSectionBracket(t);
        break;
      }
      case Pt.CDATA_SECTION_END: {
        this._stateCdataSectionEnd(t);
        break;
      }
      case Pt.CHARACTER_REFERENCE: {
        this._stateCharacterReference();
        break;
      }
      case Pt.AMBIGUOUS_AMPERSAND: {
        this._stateAmbiguousAmpersand(t);
        break;
      }
      default:
        throw new Error("Unknown state");
    }
  }
  // State machine
  // Data state
  //------------------------------------------------------------------
  _stateData(t) {
    switch (t) {
      case Nt.LESS_THAN_SIGN: {
        this.state = Pt.TAG_OPEN;
        break;
      }
      case Nt.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case Nt.NULL: {
        this._err(Oi.unexpectedNullCharacter), this._emitCodePoint(t);
        break;
      }
      case Nt.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  //  RCDATA state
  //------------------------------------------------------------------
  _stateRcdata(t) {
    switch (t) {
      case Nt.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case Nt.LESS_THAN_SIGN: {
        this.state = Pt.RCDATA_LESS_THAN_SIGN;
        break;
      }
      case Nt.NULL: {
        this._err(Oi.unexpectedNullCharacter), this._emitChars(xu);
        break;
      }
      case Nt.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // RAWTEXT state
  //------------------------------------------------------------------
  _stateRawtext(t) {
    switch (t) {
      case Nt.LESS_THAN_SIGN: {
        this.state = Pt.RAWTEXT_LESS_THAN_SIGN;
        break;
      }
      case Nt.NULL: {
        this._err(Oi.unexpectedNullCharacter), this._emitChars(xu);
        break;
      }
      case Nt.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Script data state
  //------------------------------------------------------------------
  _stateScriptData(t) {
    switch (t) {
      case Nt.LESS_THAN_SIGN: {
        this.state = Pt.SCRIPT_DATA_LESS_THAN_SIGN;
        break;
      }
      case Nt.NULL: {
        this._err(Oi.unexpectedNullCharacter), this._emitChars(xu);
        break;
      }
      case Nt.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // PLAINTEXT state
  //------------------------------------------------------------------
  _statePlaintext(t) {
    switch (t) {
      case Nt.NULL: {
        this._err(Oi.unexpectedNullCharacter), this._emitChars(xu);
        break;
      }
      case Nt.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Tag open state
  //------------------------------------------------------------------
  _stateTagOpen(t) {
    if (W_(t))
      this._createStartTagToken(), this.state = Pt.TAG_NAME, this._stateTagName(t);
    else
      switch (t) {
        case Nt.EXCLAMATION_MARK: {
          this.state = Pt.MARKUP_DECLARATION_OPEN;
          break;
        }
        case Nt.SOLIDUS: {
          this.state = Pt.END_TAG_OPEN;
          break;
        }
        case Nt.QUESTION_MARK: {
          this._err(Oi.unexpectedQuestionMarkInsteadOfTagName), this._createCommentToken(1), this.state = Pt.BOGUS_COMMENT, this._stateBogusComment(t);
          break;
        }
        case Nt.EOF: {
          this._err(Oi.eofBeforeTagName), this._emitChars("<"), this._emitEOFToken();
          break;
        }
        default:
          this._err(Oi.invalidFirstCharacterOfTagName), this._emitChars("<"), this.state = Pt.DATA, this._stateData(t);
      }
  }
  // End tag open state
  //------------------------------------------------------------------
  _stateEndTagOpen(t) {
    if (W_(t))
      this._createEndTagToken(), this.state = Pt.TAG_NAME, this._stateTagName(t);
    else
      switch (t) {
        case Nt.GREATER_THAN_SIGN: {
          this._err(Oi.missingEndTagName), this.state = Pt.DATA;
          break;
        }
        case Nt.EOF: {
          this._err(Oi.eofBeforeTagName), this._emitChars("</"), this._emitEOFToken();
          break;
        }
        default:
          this._err(Oi.invalidFirstCharacterOfTagName), this._createCommentToken(2), this.state = Pt.BOGUS_COMMENT, this._stateBogusComment(t);
      }
  }
  // Tag name state
  //------------------------------------------------------------------
  _stateTagName(t) {
    const i = this.currentToken;
    switch (t) {
      case Nt.SPACE:
      case Nt.LINE_FEED:
      case Nt.TABULATION:
      case Nt.FORM_FEED: {
        this.state = Pt.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case Nt.SOLIDUS: {
        this.state = Pt.SELF_CLOSING_START_TAG;
        break;
      }
      case Nt.GREATER_THAN_SIGN: {
        this.state = Pt.DATA, this.emitCurrentTagToken();
        break;
      }
      case Nt.NULL: {
        this._err(Oi.unexpectedNullCharacter), i.tagName += xu;
        break;
      }
      case Nt.EOF: {
        this._err(Oi.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        i.tagName += String.fromCodePoint(yJ(t) ? zse(t) : t);
    }
  }
  // RCDATA less-than sign state
  //------------------------------------------------------------------
  _stateRcdataLessThanSign(t) {
    t === Nt.SOLIDUS ? this.state = Pt.RCDATA_END_TAG_OPEN : (this._emitChars("<"), this.state = Pt.RCDATA, this._stateRcdata(t));
  }
  // RCDATA end tag open state
  //------------------------------------------------------------------
  _stateRcdataEndTagOpen(t) {
    W_(t) ? (this.state = Pt.RCDATA_END_TAG_NAME, this._stateRcdataEndTagName(t)) : (this._emitChars("</"), this.state = Pt.RCDATA, this._stateRcdata(t));
  }
  handleSpecialEndTag(t) {
    if (!this.preprocessor.startsWith(this.lastStartTagName, !1))
      return !this._ensureHibernation();
    this._createEndTagToken();
    const i = this.currentToken;
    switch (i.tagName = this.lastStartTagName, this.preprocessor.peek(this.lastStartTagName.length)) {
      case Nt.SPACE:
      case Nt.LINE_FEED:
      case Nt.TABULATION:
      case Nt.FORM_FEED:
        return this._advanceBy(this.lastStartTagName.length), this.state = Pt.BEFORE_ATTRIBUTE_NAME, !1;
      case Nt.SOLIDUS:
        return this._advanceBy(this.lastStartTagName.length), this.state = Pt.SELF_CLOSING_START_TAG, !1;
      case Nt.GREATER_THAN_SIGN:
        return this._advanceBy(this.lastStartTagName.length), this.emitCurrentTagToken(), this.state = Pt.DATA, !1;
      default:
        return !this._ensureHibernation();
    }
  }
  // RCDATA end tag name state
  //------------------------------------------------------------------
  _stateRcdataEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = Pt.RCDATA, this._stateRcdata(t));
  }
  // RAWTEXT less-than sign state
  //------------------------------------------------------------------
  _stateRawtextLessThanSign(t) {
    t === Nt.SOLIDUS ? this.state = Pt.RAWTEXT_END_TAG_OPEN : (this._emitChars("<"), this.state = Pt.RAWTEXT, this._stateRawtext(t));
  }
  // RAWTEXT end tag open state
  //------------------------------------------------------------------
  _stateRawtextEndTagOpen(t) {
    W_(t) ? (this.state = Pt.RAWTEXT_END_TAG_NAME, this._stateRawtextEndTagName(t)) : (this._emitChars("</"), this.state = Pt.RAWTEXT, this._stateRawtext(t));
  }
  // RAWTEXT end tag name state
  //------------------------------------------------------------------
  _stateRawtextEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = Pt.RAWTEXT, this._stateRawtext(t));
  }
  // Script data less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataLessThanSign(t) {
    switch (t) {
      case Nt.SOLIDUS: {
        this.state = Pt.SCRIPT_DATA_END_TAG_OPEN;
        break;
      }
      case Nt.EXCLAMATION_MARK: {
        this.state = Pt.SCRIPT_DATA_ESCAPE_START, this._emitChars("<!");
        break;
      }
      default:
        this._emitChars("<"), this.state = Pt.SCRIPT_DATA, this._stateScriptData(t);
    }
  }
  // Script data end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEndTagOpen(t) {
    W_(t) ? (this.state = Pt.SCRIPT_DATA_END_TAG_NAME, this._stateScriptDataEndTagName(t)) : (this._emitChars("</"), this.state = Pt.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = Pt.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data escape start state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStart(t) {
    t === Nt.HYPHEN_MINUS ? (this.state = Pt.SCRIPT_DATA_ESCAPE_START_DASH, this._emitChars("-")) : (this.state = Pt.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data escape start dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStartDash(t) {
    t === Nt.HYPHEN_MINUS ? (this.state = Pt.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-")) : (this.state = Pt.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data escaped state
  //------------------------------------------------------------------
  _stateScriptDataEscaped(t) {
    switch (t) {
      case Nt.HYPHEN_MINUS: {
        this.state = Pt.SCRIPT_DATA_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case Nt.LESS_THAN_SIGN: {
        this.state = Pt.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case Nt.NULL: {
        this._err(Oi.unexpectedNullCharacter), this._emitChars(xu);
        break;
      }
      case Nt.EOF: {
        this._err(Oi.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Script data escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDash(t) {
    switch (t) {
      case Nt.HYPHEN_MINUS: {
        this.state = Pt.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case Nt.LESS_THAN_SIGN: {
        this.state = Pt.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case Nt.NULL: {
        this._err(Oi.unexpectedNullCharacter), this.state = Pt.SCRIPT_DATA_ESCAPED, this._emitChars(xu);
        break;
      }
      case Nt.EOF: {
        this._err(Oi.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = Pt.SCRIPT_DATA_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDashDash(t) {
    switch (t) {
      case Nt.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case Nt.LESS_THAN_SIGN: {
        this.state = Pt.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case Nt.GREATER_THAN_SIGN: {
        this.state = Pt.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case Nt.NULL: {
        this._err(Oi.unexpectedNullCharacter), this.state = Pt.SCRIPT_DATA_ESCAPED, this._emitChars(xu);
        break;
      }
      case Nt.EOF: {
        this._err(Oi.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = Pt.SCRIPT_DATA_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataEscapedLessThanSign(t) {
    t === Nt.SOLIDUS ? this.state = Pt.SCRIPT_DATA_ESCAPED_END_TAG_OPEN : W_(t) ? (this._emitChars("<"), this.state = Pt.SCRIPT_DATA_DOUBLE_ESCAPE_START, this._stateScriptDataDoubleEscapeStart(t)) : (this._emitChars("<"), this.state = Pt.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data escaped end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagOpen(t) {
    W_(t) ? (this.state = Pt.SCRIPT_DATA_ESCAPED_END_TAG_NAME, this._stateScriptDataEscapedEndTagName(t)) : (this._emitChars("</"), this.state = Pt.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data escaped end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = Pt.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data double escape start state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeStart(t) {
    if (this.preprocessor.startsWith(sg.SCRIPT, !1) && D4e(this.preprocessor.peek(sg.SCRIPT.length))) {
      this._emitCodePoint(t);
      for (let i = 0; i < sg.SCRIPT.length; i++)
        this._emitCodePoint(this._consume());
      this.state = Pt.SCRIPT_DATA_DOUBLE_ESCAPED;
    } else this._ensureHibernation() || (this.state = Pt.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data double escaped state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscaped(t) {
    switch (t) {
      case Nt.HYPHEN_MINUS: {
        this.state = Pt.SCRIPT_DATA_DOUBLE_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case Nt.LESS_THAN_SIGN: {
        this.state = Pt.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case Nt.NULL: {
        this._err(Oi.unexpectedNullCharacter), this._emitChars(xu);
        break;
      }
      case Nt.EOF: {
        this._err(Oi.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Script data double escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDash(t) {
    switch (t) {
      case Nt.HYPHEN_MINUS: {
        this.state = Pt.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case Nt.LESS_THAN_SIGN: {
        this.state = Pt.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case Nt.NULL: {
        this._err(Oi.unexpectedNullCharacter), this.state = Pt.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(xu);
        break;
      }
      case Nt.EOF: {
        this._err(Oi.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = Pt.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data double escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDashDash(t) {
    switch (t) {
      case Nt.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case Nt.LESS_THAN_SIGN: {
        this.state = Pt.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case Nt.GREATER_THAN_SIGN: {
        this.state = Pt.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case Nt.NULL: {
        this._err(Oi.unexpectedNullCharacter), this.state = Pt.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(xu);
        break;
      }
      case Nt.EOF: {
        this._err(Oi.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = Pt.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data double escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedLessThanSign(t) {
    t === Nt.SOLIDUS ? (this.state = Pt.SCRIPT_DATA_DOUBLE_ESCAPE_END, this._emitChars("/")) : (this.state = Pt.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(t));
  }
  // Script data double escape end state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeEnd(t) {
    if (this.preprocessor.startsWith(sg.SCRIPT, !1) && D4e(this.preprocessor.peek(sg.SCRIPT.length))) {
      this._emitCodePoint(t);
      for (let i = 0; i < sg.SCRIPT.length; i++)
        this._emitCodePoint(this._consume());
      this.state = Pt.SCRIPT_DATA_ESCAPED;
    } else this._ensureHibernation() || (this.state = Pt.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(t));
  }
  // Before attribute name state
  //------------------------------------------------------------------
  _stateBeforeAttributeName(t) {
    switch (t) {
      case Nt.SPACE:
      case Nt.LINE_FEED:
      case Nt.TABULATION:
      case Nt.FORM_FEED:
        break;
      case Nt.SOLIDUS:
      case Nt.GREATER_THAN_SIGN:
      case Nt.EOF: {
        this.state = Pt.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(t);
        break;
      }
      case Nt.EQUALS_SIGN: {
        this._err(Oi.unexpectedEqualsSignBeforeAttributeName), this._createAttr("="), this.state = Pt.ATTRIBUTE_NAME;
        break;
      }
      default:
        this._createAttr(""), this.state = Pt.ATTRIBUTE_NAME, this._stateAttributeName(t);
    }
  }
  // Attribute name state
  //------------------------------------------------------------------
  _stateAttributeName(t) {
    switch (t) {
      case Nt.SPACE:
      case Nt.LINE_FEED:
      case Nt.TABULATION:
      case Nt.FORM_FEED:
      case Nt.SOLIDUS:
      case Nt.GREATER_THAN_SIGN:
      case Nt.EOF: {
        this._leaveAttrName(), this.state = Pt.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(t);
        break;
      }
      case Nt.EQUALS_SIGN: {
        this._leaveAttrName(), this.state = Pt.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case Nt.QUOTATION_MARK:
      case Nt.APOSTROPHE:
      case Nt.LESS_THAN_SIGN: {
        this._err(Oi.unexpectedCharacterInAttributeName), this.currentAttr.name += String.fromCodePoint(t);
        break;
      }
      case Nt.NULL: {
        this._err(Oi.unexpectedNullCharacter), this.currentAttr.name += xu;
        break;
      }
      default:
        this.currentAttr.name += String.fromCodePoint(yJ(t) ? zse(t) : t);
    }
  }
  // After attribute name state
  //------------------------------------------------------------------
  _stateAfterAttributeName(t) {
    switch (t) {
      case Nt.SPACE:
      case Nt.LINE_FEED:
      case Nt.TABULATION:
      case Nt.FORM_FEED:
        break;
      case Nt.SOLIDUS: {
        this.state = Pt.SELF_CLOSING_START_TAG;
        break;
      }
      case Nt.EQUALS_SIGN: {
        this.state = Pt.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case Nt.GREATER_THAN_SIGN: {
        this.state = Pt.DATA, this.emitCurrentTagToken();
        break;
      }
      case Nt.EOF: {
        this._err(Oi.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._createAttr(""), this.state = Pt.ATTRIBUTE_NAME, this._stateAttributeName(t);
    }
  }
  // Before attribute value state
  //------------------------------------------------------------------
  _stateBeforeAttributeValue(t) {
    switch (t) {
      case Nt.SPACE:
      case Nt.LINE_FEED:
      case Nt.TABULATION:
      case Nt.FORM_FEED:
        break;
      case Nt.QUOTATION_MARK: {
        this.state = Pt.ATTRIBUTE_VALUE_DOUBLE_QUOTED;
        break;
      }
      case Nt.APOSTROPHE: {
        this.state = Pt.ATTRIBUTE_VALUE_SINGLE_QUOTED;
        break;
      }
      case Nt.GREATER_THAN_SIGN: {
        this._err(Oi.missingAttributeValue), this.state = Pt.DATA, this.emitCurrentTagToken();
        break;
      }
      default:
        this.state = Pt.ATTRIBUTE_VALUE_UNQUOTED, this._stateAttributeValueUnquoted(t);
    }
  }
  // Attribute value (double-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueDoubleQuoted(t) {
    switch (t) {
      case Nt.QUOTATION_MARK: {
        this.state = Pt.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case Nt.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case Nt.NULL: {
        this._err(Oi.unexpectedNullCharacter), this.currentAttr.value += xu;
        break;
      }
      case Nt.EOF: {
        this._err(Oi.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  // Attribute value (single-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueSingleQuoted(t) {
    switch (t) {
      case Nt.APOSTROPHE: {
        this.state = Pt.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case Nt.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case Nt.NULL: {
        this._err(Oi.unexpectedNullCharacter), this.currentAttr.value += xu;
        break;
      }
      case Nt.EOF: {
        this._err(Oi.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  // Attribute value (unquoted) state
  //------------------------------------------------------------------
  _stateAttributeValueUnquoted(t) {
    switch (t) {
      case Nt.SPACE:
      case Nt.LINE_FEED:
      case Nt.TABULATION:
      case Nt.FORM_FEED: {
        this._leaveAttrValue(), this.state = Pt.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case Nt.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case Nt.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = Pt.DATA, this.emitCurrentTagToken();
        break;
      }
      case Nt.NULL: {
        this._err(Oi.unexpectedNullCharacter), this.currentAttr.value += xu;
        break;
      }
      case Nt.QUOTATION_MARK:
      case Nt.APOSTROPHE:
      case Nt.LESS_THAN_SIGN:
      case Nt.EQUALS_SIGN:
      case Nt.GRAVE_ACCENT: {
        this._err(Oi.unexpectedCharacterInUnquotedAttributeValue), this.currentAttr.value += String.fromCodePoint(t);
        break;
      }
      case Nt.EOF: {
        this._err(Oi.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  // After attribute value (quoted) state
  //------------------------------------------------------------------
  _stateAfterAttributeValueQuoted(t) {
    switch (t) {
      case Nt.SPACE:
      case Nt.LINE_FEED:
      case Nt.TABULATION:
      case Nt.FORM_FEED: {
        this._leaveAttrValue(), this.state = Pt.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case Nt.SOLIDUS: {
        this._leaveAttrValue(), this.state = Pt.SELF_CLOSING_START_TAG;
        break;
      }
      case Nt.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = Pt.DATA, this.emitCurrentTagToken();
        break;
      }
      case Nt.EOF: {
        this._err(Oi.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(Oi.missingWhitespaceBetweenAttributes), this.state = Pt.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(t);
    }
  }
  // Self-closing start tag state
  //------------------------------------------------------------------
  _stateSelfClosingStartTag(t) {
    switch (t) {
      case Nt.GREATER_THAN_SIGN: {
        const i = this.currentToken;
        i.selfClosing = !0, this.state = Pt.DATA, this.emitCurrentTagToken();
        break;
      }
      case Nt.EOF: {
        this._err(Oi.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(Oi.unexpectedSolidusInTag), this.state = Pt.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(t);
    }
  }
  // Bogus comment state
  //------------------------------------------------------------------
  _stateBogusComment(t) {
    const i = this.currentToken;
    switch (t) {
      case Nt.GREATER_THAN_SIGN: {
        this.state = Pt.DATA, this.emitCurrentComment(i);
        break;
      }
      case Nt.EOF: {
        this.emitCurrentComment(i), this._emitEOFToken();
        break;
      }
      case Nt.NULL: {
        this._err(Oi.unexpectedNullCharacter), i.data += xu;
        break;
      }
      default:
        i.data += String.fromCodePoint(t);
    }
  }
  // Markup declaration open state
  //------------------------------------------------------------------
  _stateMarkupDeclarationOpen(t) {
    this._consumeSequenceIfMatch(sg.DASH_DASH, !0) ? (this._createCommentToken(sg.DASH_DASH.length + 1), this.state = Pt.COMMENT_START) : this._consumeSequenceIfMatch(sg.DOCTYPE, !1) ? (this.currentLocation = this.getCurrentLocation(sg.DOCTYPE.length + 1), this.state = Pt.DOCTYPE) : this._consumeSequenceIfMatch(sg.CDATA_START, !0) ? this.inForeignNode ? this.state = Pt.CDATA_SECTION : (this._err(Oi.cdataInHtmlContent), this._createCommentToken(sg.CDATA_START.length + 1), this.currentToken.data = "[CDATA[", this.state = Pt.BOGUS_COMMENT) : this._ensureHibernation() || (this._err(Oi.incorrectlyOpenedComment), this._createCommentToken(2), this.state = Pt.BOGUS_COMMENT, this._stateBogusComment(t));
  }
  // Comment start state
  //------------------------------------------------------------------
  _stateCommentStart(t) {
    switch (t) {
      case Nt.HYPHEN_MINUS: {
        this.state = Pt.COMMENT_START_DASH;
        break;
      }
      case Nt.GREATER_THAN_SIGN: {
        this._err(Oi.abruptClosingOfEmptyComment), this.state = Pt.DATA;
        const i = this.currentToken;
        this.emitCurrentComment(i);
        break;
      }
      default:
        this.state = Pt.COMMENT, this._stateComment(t);
    }
  }
  // Comment start dash state
  //------------------------------------------------------------------
  _stateCommentStartDash(t) {
    const i = this.currentToken;
    switch (t) {
      case Nt.HYPHEN_MINUS: {
        this.state = Pt.COMMENT_END;
        break;
      }
      case Nt.GREATER_THAN_SIGN: {
        this._err(Oi.abruptClosingOfEmptyComment), this.state = Pt.DATA, this.emitCurrentComment(i);
        break;
      }
      case Nt.EOF: {
        this._err(Oi.eofInComment), this.emitCurrentComment(i), this._emitEOFToken();
        break;
      }
      default:
        i.data += "-", this.state = Pt.COMMENT, this._stateComment(t);
    }
  }
  // Comment state
  //------------------------------------------------------------------
  _stateComment(t) {
    const i = this.currentToken;
    switch (t) {
      case Nt.HYPHEN_MINUS: {
        this.state = Pt.COMMENT_END_DASH;
        break;
      }
      case Nt.LESS_THAN_SIGN: {
        i.data += "<", this.state = Pt.COMMENT_LESS_THAN_SIGN;
        break;
      }
      case Nt.NULL: {
        this._err(Oi.unexpectedNullCharacter), i.data += xu;
        break;
      }
      case Nt.EOF: {
        this._err(Oi.eofInComment), this.emitCurrentComment(i), this._emitEOFToken();
        break;
      }
      default:
        i.data += String.fromCodePoint(t);
    }
  }
  // Comment less-than sign state
  //------------------------------------------------------------------
  _stateCommentLessThanSign(t) {
    const i = this.currentToken;
    switch (t) {
      case Nt.EXCLAMATION_MARK: {
        i.data += "!", this.state = Pt.COMMENT_LESS_THAN_SIGN_BANG;
        break;
      }
      case Nt.LESS_THAN_SIGN: {
        i.data += "<";
        break;
      }
      default:
        this.state = Pt.COMMENT, this._stateComment(t);
    }
  }
  // Comment less-than sign bang state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBang(t) {
    t === Nt.HYPHEN_MINUS ? this.state = Pt.COMMENT_LESS_THAN_SIGN_BANG_DASH : (this.state = Pt.COMMENT, this._stateComment(t));
  }
  // Comment less-than sign bang dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDash(t) {
    t === Nt.HYPHEN_MINUS ? this.state = Pt.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH : (this.state = Pt.COMMENT_END_DASH, this._stateCommentEndDash(t));
  }
  // Comment less-than sign bang dash dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDashDash(t) {
    t !== Nt.GREATER_THAN_SIGN && t !== Nt.EOF && this._err(Oi.nestedComment), this.state = Pt.COMMENT_END, this._stateCommentEnd(t);
  }
  // Comment end dash state
  //------------------------------------------------------------------
  _stateCommentEndDash(t) {
    const i = this.currentToken;
    switch (t) {
      case Nt.HYPHEN_MINUS: {
        this.state = Pt.COMMENT_END;
        break;
      }
      case Nt.EOF: {
        this._err(Oi.eofInComment), this.emitCurrentComment(i), this._emitEOFToken();
        break;
      }
      default:
        i.data += "-", this.state = Pt.COMMENT, this._stateComment(t);
    }
  }
  // Comment end state
  //------------------------------------------------------------------
  _stateCommentEnd(t) {
    const i = this.currentToken;
    switch (t) {
      case Nt.GREATER_THAN_SIGN: {
        this.state = Pt.DATA, this.emitCurrentComment(i);
        break;
      }
      case Nt.EXCLAMATION_MARK: {
        this.state = Pt.COMMENT_END_BANG;
        break;
      }
      case Nt.HYPHEN_MINUS: {
        i.data += "-";
        break;
      }
      case Nt.EOF: {
        this._err(Oi.eofInComment), this.emitCurrentComment(i), this._emitEOFToken();
        break;
      }
      default:
        i.data += "--", this.state = Pt.COMMENT, this._stateComment(t);
    }
  }
  // Comment end bang state
  //------------------------------------------------------------------
  _stateCommentEndBang(t) {
    const i = this.currentToken;
    switch (t) {
      case Nt.HYPHEN_MINUS: {
        i.data += "--!", this.state = Pt.COMMENT_END_DASH;
        break;
      }
      case Nt.GREATER_THAN_SIGN: {
        this._err(Oi.incorrectlyClosedComment), this.state = Pt.DATA, this.emitCurrentComment(i);
        break;
      }
      case Nt.EOF: {
        this._err(Oi.eofInComment), this.emitCurrentComment(i), this._emitEOFToken();
        break;
      }
      default:
        i.data += "--!", this.state = Pt.COMMENT, this._stateComment(t);
    }
  }
  // DOCTYPE state
  //------------------------------------------------------------------
  _stateDoctype(t) {
    switch (t) {
      case Nt.SPACE:
      case Nt.LINE_FEED:
      case Nt.TABULATION:
      case Nt.FORM_FEED: {
        this.state = Pt.BEFORE_DOCTYPE_NAME;
        break;
      }
      case Nt.GREATER_THAN_SIGN: {
        this.state = Pt.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(t);
        break;
      }
      case Nt.EOF: {
        this._err(Oi.eofInDoctype), this._createDoctypeToken(null);
        const i = this.currentToken;
        i.forceQuirks = !0, this.emitCurrentDoctype(i), this._emitEOFToken();
        break;
      }
      default:
        this._err(Oi.missingWhitespaceBeforeDoctypeName), this.state = Pt.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(t);
    }
  }
  // Before DOCTYPE name state
  //------------------------------------------------------------------
  _stateBeforeDoctypeName(t) {
    if (yJ(t))
      this._createDoctypeToken(String.fromCharCode(zse(t))), this.state = Pt.DOCTYPE_NAME;
    else
      switch (t) {
        case Nt.SPACE:
        case Nt.LINE_FEED:
        case Nt.TABULATION:
        case Nt.FORM_FEED:
          break;
        case Nt.NULL: {
          this._err(Oi.unexpectedNullCharacter), this._createDoctypeToken(xu), this.state = Pt.DOCTYPE_NAME;
          break;
        }
        case Nt.GREATER_THAN_SIGN: {
          this._err(Oi.missingDoctypeName), this._createDoctypeToken(null);
          const i = this.currentToken;
          i.forceQuirks = !0, this.emitCurrentDoctype(i), this.state = Pt.DATA;
          break;
        }
        case Nt.EOF: {
          this._err(Oi.eofInDoctype), this._createDoctypeToken(null);
          const i = this.currentToken;
          i.forceQuirks = !0, this.emitCurrentDoctype(i), this._emitEOFToken();
          break;
        }
        default:
          this._createDoctypeToken(String.fromCodePoint(t)), this.state = Pt.DOCTYPE_NAME;
      }
  }
  // DOCTYPE name state
  //------------------------------------------------------------------
  _stateDoctypeName(t) {
    const i = this.currentToken;
    switch (t) {
      case Nt.SPACE:
      case Nt.LINE_FEED:
      case Nt.TABULATION:
      case Nt.FORM_FEED: {
        this.state = Pt.AFTER_DOCTYPE_NAME;
        break;
      }
      case Nt.GREATER_THAN_SIGN: {
        this.state = Pt.DATA, this.emitCurrentDoctype(i);
        break;
      }
      case Nt.NULL: {
        this._err(Oi.unexpectedNullCharacter), i.name += xu;
        break;
      }
      case Nt.EOF: {
        this._err(Oi.eofInDoctype), i.forceQuirks = !0, this.emitCurrentDoctype(i), this._emitEOFToken();
        break;
      }
      default:
        i.name += String.fromCodePoint(yJ(t) ? zse(t) : t);
    }
  }
  // After DOCTYPE name state
  //------------------------------------------------------------------
  _stateAfterDoctypeName(t) {
    const i = this.currentToken;
    switch (t) {
      case Nt.SPACE:
      case Nt.LINE_FEED:
      case Nt.TABULATION:
      case Nt.FORM_FEED:
        break;
      case Nt.GREATER_THAN_SIGN: {
        this.state = Pt.DATA, this.emitCurrentDoctype(i);
        break;
      }
      case Nt.EOF: {
        this._err(Oi.eofInDoctype), i.forceQuirks = !0, this.emitCurrentDoctype(i), this._emitEOFToken();
        break;
      }
      default:
        this._consumeSequenceIfMatch(sg.PUBLIC, !1) ? this.state = Pt.AFTER_DOCTYPE_PUBLIC_KEYWORD : this._consumeSequenceIfMatch(sg.SYSTEM, !1) ? this.state = Pt.AFTER_DOCTYPE_SYSTEM_KEYWORD : this._ensureHibernation() || (this._err(Oi.invalidCharacterSequenceAfterDoctypeName), i.forceQuirks = !0, this.state = Pt.BOGUS_DOCTYPE, this._stateBogusDoctype(t));
    }
  }
  // After DOCTYPE public keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicKeyword(t) {
    const i = this.currentToken;
    switch (t) {
      case Nt.SPACE:
      case Nt.LINE_FEED:
      case Nt.TABULATION:
      case Nt.FORM_FEED: {
        this.state = Pt.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case Nt.QUOTATION_MARK: {
        this._err(Oi.missingWhitespaceAfterDoctypePublicKeyword), i.publicId = "", this.state = Pt.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case Nt.APOSTROPHE: {
        this._err(Oi.missingWhitespaceAfterDoctypePublicKeyword), i.publicId = "", this.state = Pt.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case Nt.GREATER_THAN_SIGN: {
        this._err(Oi.missingDoctypePublicIdentifier), i.forceQuirks = !0, this.state = Pt.DATA, this.emitCurrentDoctype(i);
        break;
      }
      case Nt.EOF: {
        this._err(Oi.eofInDoctype), i.forceQuirks = !0, this.emitCurrentDoctype(i), this._emitEOFToken();
        break;
      }
      default:
        this._err(Oi.missingQuoteBeforeDoctypePublicIdentifier), i.forceQuirks = !0, this.state = Pt.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Before DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypePublicIdentifier(t) {
    const i = this.currentToken;
    switch (t) {
      case Nt.SPACE:
      case Nt.LINE_FEED:
      case Nt.TABULATION:
      case Nt.FORM_FEED:
        break;
      case Nt.QUOTATION_MARK: {
        i.publicId = "", this.state = Pt.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case Nt.APOSTROPHE: {
        i.publicId = "", this.state = Pt.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case Nt.GREATER_THAN_SIGN: {
        this._err(Oi.missingDoctypePublicIdentifier), i.forceQuirks = !0, this.state = Pt.DATA, this.emitCurrentDoctype(i);
        break;
      }
      case Nt.EOF: {
        this._err(Oi.eofInDoctype), i.forceQuirks = !0, this.emitCurrentDoctype(i), this._emitEOFToken();
        break;
      }
      default:
        this._err(Oi.missingQuoteBeforeDoctypePublicIdentifier), i.forceQuirks = !0, this.state = Pt.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // DOCTYPE public identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierDoubleQuoted(t) {
    const i = this.currentToken;
    switch (t) {
      case Nt.QUOTATION_MARK: {
        this.state = Pt.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case Nt.NULL: {
        this._err(Oi.unexpectedNullCharacter), i.publicId += xu;
        break;
      }
      case Nt.GREATER_THAN_SIGN: {
        this._err(Oi.abruptDoctypePublicIdentifier), i.forceQuirks = !0, this.emitCurrentDoctype(i), this.state = Pt.DATA;
        break;
      }
      case Nt.EOF: {
        this._err(Oi.eofInDoctype), i.forceQuirks = !0, this.emitCurrentDoctype(i), this._emitEOFToken();
        break;
      }
      default:
        i.publicId += String.fromCodePoint(t);
    }
  }
  // DOCTYPE public identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierSingleQuoted(t) {
    const i = this.currentToken;
    switch (t) {
      case Nt.APOSTROPHE: {
        this.state = Pt.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case Nt.NULL: {
        this._err(Oi.unexpectedNullCharacter), i.publicId += xu;
        break;
      }
      case Nt.GREATER_THAN_SIGN: {
        this._err(Oi.abruptDoctypePublicIdentifier), i.forceQuirks = !0, this.emitCurrentDoctype(i), this.state = Pt.DATA;
        break;
      }
      case Nt.EOF: {
        this._err(Oi.eofInDoctype), i.forceQuirks = !0, this.emitCurrentDoctype(i), this._emitEOFToken();
        break;
      }
      default:
        i.publicId += String.fromCodePoint(t);
    }
  }
  // After DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicIdentifier(t) {
    const i = this.currentToken;
    switch (t) {
      case Nt.SPACE:
      case Nt.LINE_FEED:
      case Nt.TABULATION:
      case Nt.FORM_FEED: {
        this.state = Pt.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS;
        break;
      }
      case Nt.GREATER_THAN_SIGN: {
        this.state = Pt.DATA, this.emitCurrentDoctype(i);
        break;
      }
      case Nt.QUOTATION_MARK: {
        this._err(Oi.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), i.systemId = "", this.state = Pt.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case Nt.APOSTROPHE: {
        this._err(Oi.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), i.systemId = "", this.state = Pt.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case Nt.EOF: {
        this._err(Oi.eofInDoctype), i.forceQuirks = !0, this.emitCurrentDoctype(i), this._emitEOFToken();
        break;
      }
      default:
        this._err(Oi.missingQuoteBeforeDoctypeSystemIdentifier), i.forceQuirks = !0, this.state = Pt.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Between DOCTYPE public and system identifiers state
  //------------------------------------------------------------------
  _stateBetweenDoctypePublicAndSystemIdentifiers(t) {
    const i = this.currentToken;
    switch (t) {
      case Nt.SPACE:
      case Nt.LINE_FEED:
      case Nt.TABULATION:
      case Nt.FORM_FEED:
        break;
      case Nt.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(i), this.state = Pt.DATA;
        break;
      }
      case Nt.QUOTATION_MARK: {
        i.systemId = "", this.state = Pt.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case Nt.APOSTROPHE: {
        i.systemId = "", this.state = Pt.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case Nt.EOF: {
        this._err(Oi.eofInDoctype), i.forceQuirks = !0, this.emitCurrentDoctype(i), this._emitEOFToken();
        break;
      }
      default:
        this._err(Oi.missingQuoteBeforeDoctypeSystemIdentifier), i.forceQuirks = !0, this.state = Pt.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // After DOCTYPE system keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemKeyword(t) {
    const i = this.currentToken;
    switch (t) {
      case Nt.SPACE:
      case Nt.LINE_FEED:
      case Nt.TABULATION:
      case Nt.FORM_FEED: {
        this.state = Pt.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case Nt.QUOTATION_MARK: {
        this._err(Oi.missingWhitespaceAfterDoctypeSystemKeyword), i.systemId = "", this.state = Pt.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case Nt.APOSTROPHE: {
        this._err(Oi.missingWhitespaceAfterDoctypeSystemKeyword), i.systemId = "", this.state = Pt.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case Nt.GREATER_THAN_SIGN: {
        this._err(Oi.missingDoctypeSystemIdentifier), i.forceQuirks = !0, this.state = Pt.DATA, this.emitCurrentDoctype(i);
        break;
      }
      case Nt.EOF: {
        this._err(Oi.eofInDoctype), i.forceQuirks = !0, this.emitCurrentDoctype(i), this._emitEOFToken();
        break;
      }
      default:
        this._err(Oi.missingQuoteBeforeDoctypeSystemIdentifier), i.forceQuirks = !0, this.state = Pt.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Before DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypeSystemIdentifier(t) {
    const i = this.currentToken;
    switch (t) {
      case Nt.SPACE:
      case Nt.LINE_FEED:
      case Nt.TABULATION:
      case Nt.FORM_FEED:
        break;
      case Nt.QUOTATION_MARK: {
        i.systemId = "", this.state = Pt.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case Nt.APOSTROPHE: {
        i.systemId = "", this.state = Pt.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case Nt.GREATER_THAN_SIGN: {
        this._err(Oi.missingDoctypeSystemIdentifier), i.forceQuirks = !0, this.state = Pt.DATA, this.emitCurrentDoctype(i);
        break;
      }
      case Nt.EOF: {
        this._err(Oi.eofInDoctype), i.forceQuirks = !0, this.emitCurrentDoctype(i), this._emitEOFToken();
        break;
      }
      default:
        this._err(Oi.missingQuoteBeforeDoctypeSystemIdentifier), i.forceQuirks = !0, this.state = Pt.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // DOCTYPE system identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierDoubleQuoted(t) {
    const i = this.currentToken;
    switch (t) {
      case Nt.QUOTATION_MARK: {
        this.state = Pt.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case Nt.NULL: {
        this._err(Oi.unexpectedNullCharacter), i.systemId += xu;
        break;
      }
      case Nt.GREATER_THAN_SIGN: {
        this._err(Oi.abruptDoctypeSystemIdentifier), i.forceQuirks = !0, this.emitCurrentDoctype(i), this.state = Pt.DATA;
        break;
      }
      case Nt.EOF: {
        this._err(Oi.eofInDoctype), i.forceQuirks = !0, this.emitCurrentDoctype(i), this._emitEOFToken();
        break;
      }
      default:
        i.systemId += String.fromCodePoint(t);
    }
  }
  // DOCTYPE system identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierSingleQuoted(t) {
    const i = this.currentToken;
    switch (t) {
      case Nt.APOSTROPHE: {
        this.state = Pt.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case Nt.NULL: {
        this._err(Oi.unexpectedNullCharacter), i.systemId += xu;
        break;
      }
      case Nt.GREATER_THAN_SIGN: {
        this._err(Oi.abruptDoctypeSystemIdentifier), i.forceQuirks = !0, this.emitCurrentDoctype(i), this.state = Pt.DATA;
        break;
      }
      case Nt.EOF: {
        this._err(Oi.eofInDoctype), i.forceQuirks = !0, this.emitCurrentDoctype(i), this._emitEOFToken();
        break;
      }
      default:
        i.systemId += String.fromCodePoint(t);
    }
  }
  // After DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemIdentifier(t) {
    const i = this.currentToken;
    switch (t) {
      case Nt.SPACE:
      case Nt.LINE_FEED:
      case Nt.TABULATION:
      case Nt.FORM_FEED:
        break;
      case Nt.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(i), this.state = Pt.DATA;
        break;
      }
      case Nt.EOF: {
        this._err(Oi.eofInDoctype), i.forceQuirks = !0, this.emitCurrentDoctype(i), this._emitEOFToken();
        break;
      }
      default:
        this._err(Oi.unexpectedCharacterAfterDoctypeSystemIdentifier), this.state = Pt.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Bogus DOCTYPE state
  //------------------------------------------------------------------
  _stateBogusDoctype(t) {
    const i = this.currentToken;
    switch (t) {
      case Nt.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(i), this.state = Pt.DATA;
        break;
      }
      case Nt.NULL: {
        this._err(Oi.unexpectedNullCharacter);
        break;
      }
      case Nt.EOF: {
        this.emitCurrentDoctype(i), this._emitEOFToken();
        break;
      }
    }
  }
  // CDATA section state
  //------------------------------------------------------------------
  _stateCdataSection(t) {
    switch (t) {
      case Nt.RIGHT_SQUARE_BRACKET: {
        this.state = Pt.CDATA_SECTION_BRACKET;
        break;
      }
      case Nt.EOF: {
        this._err(Oi.eofInCdata), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // CDATA section bracket state
  //------------------------------------------------------------------
  _stateCdataSectionBracket(t) {
    t === Nt.RIGHT_SQUARE_BRACKET ? this.state = Pt.CDATA_SECTION_END : (this._emitChars("]"), this.state = Pt.CDATA_SECTION, this._stateCdataSection(t));
  }
  // CDATA section end state
  //------------------------------------------------------------------
  _stateCdataSectionEnd(t) {
    switch (t) {
      case Nt.GREATER_THAN_SIGN: {
        this.state = Pt.DATA;
        break;
      }
      case Nt.RIGHT_SQUARE_BRACKET: {
        this._emitChars("]");
        break;
      }
      default:
        this._emitChars("]]"), this.state = Pt.CDATA_SECTION, this._stateCdataSection(t);
    }
  }
  // Character reference state
  //------------------------------------------------------------------
  _stateCharacterReference() {
    let t = this.entityDecoder.write(this.preprocessor.html, this.preprocessor.pos);
    if (t < 0)
      if (this.preprocessor.lastChunkWritten)
        t = this.entityDecoder.end();
      else {
        this.active = !1, this.preprocessor.pos = this.preprocessor.html.length - 1, this.consumedAfterSnapshot = 0, this.preprocessor.endOfChunkHit = !0;
        return;
      }
    t === 0 ? (this.preprocessor.pos = this.entityStartPos, this._flushCodePointConsumedAsCharacterReference(Nt.AMPERSAND), this.state = !this._isCharacterReferenceInAttribute() && N4e(this.preprocessor.peek(1)) ? Pt.AMBIGUOUS_AMPERSAND : this.returnState) : this.state = this.returnState;
  }
  // Ambiguos ampersand state
  //------------------------------------------------------------------
  _stateAmbiguousAmpersand(t) {
    N4e(t) ? this._flushCodePointConsumedAsCharacterReference(t) : (t === Nt.SEMICOLON && this._err(Oi.unknownNamedCharacterReference), this.state = this.returnState, this._callState(t));
  }
}
const e6e = /* @__PURE__ */ new Set([Ee.DD, Ee.DT, Ee.LI, Ee.OPTGROUP, Ee.OPTION, Ee.P, Ee.RB, Ee.RP, Ee.RT, Ee.RTC]), C4e = /* @__PURE__ */ new Set([
  ...e6e,
  Ee.CAPTION,
  Ee.COLGROUP,
  Ee.TBODY,
  Ee.TD,
  Ee.TFOOT,
  Ee.TH,
  Ee.THEAD,
  Ee.TR
]), Ule = /* @__PURE__ */ new Set([
  Ee.APPLET,
  Ee.CAPTION,
  Ee.HTML,
  Ee.MARQUEE,
  Ee.OBJECT,
  Ee.TABLE,
  Ee.TD,
  Ee.TEMPLATE,
  Ee.TH
]), nnt = /* @__PURE__ */ new Set([...Ule, Ee.OL, Ee.UL]), snt = /* @__PURE__ */ new Set([...Ule, Ee.BUTTON]), O4e = /* @__PURE__ */ new Set([Ee.ANNOTATION_XML, Ee.MI, Ee.MN, Ee.MO, Ee.MS, Ee.MTEXT]), L4e = /* @__PURE__ */ new Set([Ee.DESC, Ee.FOREIGN_OBJECT, Ee.TITLE]), ont = /* @__PURE__ */ new Set([Ee.TR, Ee.TEMPLATE, Ee.HTML]), rnt = /* @__PURE__ */ new Set([Ee.TBODY, Ee.TFOOT, Ee.THEAD, Ee.TEMPLATE, Ee.HTML]), lnt = /* @__PURE__ */ new Set([Ee.TABLE, Ee.TEMPLATE, Ee.HTML]), ant = /* @__PURE__ */ new Set([Ee.TD, Ee.TH]);
class unt {
  get currentTmplContentOrNode() {
    return this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : this.current;
  }
  constructor(t, i, n) {
    this.treeAdapter = i, this.handler = n, this.items = [], this.tagIDs = [], this.stackTop = -1, this.tmplCount = 0, this.currentTagId = Ee.UNKNOWN, this.current = t;
  }
  //Index of element
  _indexOf(t) {
    return this.items.lastIndexOf(t, this.stackTop);
  }
  //Update current element
  _isInTemplate() {
    return this.currentTagId === Ee.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === en.HTML;
  }
  _updateCurrentElement() {
    this.current = this.items[this.stackTop], this.currentTagId = this.tagIDs[this.stackTop];
  }
  //Mutations
  push(t, i) {
    this.stackTop++, this.items[this.stackTop] = t, this.current = t, this.tagIDs[this.stackTop] = i, this.currentTagId = i, this._isInTemplate() && this.tmplCount++, this.handler.onItemPush(t, i, !0);
  }
  pop() {
    const t = this.current;
    this.tmplCount > 0 && this._isInTemplate() && this.tmplCount--, this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(t, !0);
  }
  replace(t, i) {
    const n = this._indexOf(t);
    this.items[n] = i, n === this.stackTop && (this.current = i);
  }
  insertAfter(t, i, n) {
    const s = this._indexOf(t) + 1;
    this.items.splice(s, 0, i), this.tagIDs.splice(s, 0, n), this.stackTop++, s === this.stackTop && this._updateCurrentElement(), this.current && this.currentTagId !== void 0 && this.handler.onItemPush(this.current, this.currentTagId, s === this.stackTop);
  }
  popUntilTagNamePopped(t) {
    let i = this.stackTop + 1;
    do
      i = this.tagIDs.lastIndexOf(t, i - 1);
    while (i > 0 && this.treeAdapter.getNamespaceURI(this.items[i]) !== en.HTML);
    this.shortenToLength(Math.max(i, 0));
  }
  shortenToLength(t) {
    for (; this.stackTop >= t; ) {
      const i = this.current;
      this.tmplCount > 0 && this._isInTemplate() && (this.tmplCount -= 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(i, this.stackTop < t);
    }
  }
  popUntilElementPopped(t) {
    const i = this._indexOf(t);
    this.shortenToLength(Math.max(i, 0));
  }
  popUntilPopped(t, i) {
    const n = this._indexOfTagNames(t, i);
    this.shortenToLength(Math.max(n, 0));
  }
  popUntilNumberedHeaderPopped() {
    this.popUntilPopped(dpe, en.HTML);
  }
  popUntilTableCellPopped() {
    this.popUntilPopped(ant, en.HTML);
  }
  popAllUpToHtmlElement() {
    this.tmplCount = 0, this.shortenToLength(1);
  }
  _indexOfTagNames(t, i) {
    for (let n = this.stackTop; n >= 0; n--)
      if (t.has(this.tagIDs[n]) && this.treeAdapter.getNamespaceURI(this.items[n]) === i)
        return n;
    return -1;
  }
  clearBackTo(t, i) {
    const n = this._indexOfTagNames(t, i);
    this.shortenToLength(n + 1);
  }
  clearBackToTableContext() {
    this.clearBackTo(lnt, en.HTML);
  }
  clearBackToTableBodyContext() {
    this.clearBackTo(rnt, en.HTML);
  }
  clearBackToTableRowContext() {
    this.clearBackTo(ont, en.HTML);
  }
  remove(t) {
    const i = this._indexOf(t);
    i >= 0 && (i === this.stackTop ? this.pop() : (this.items.splice(i, 1), this.tagIDs.splice(i, 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(t, !1)));
  }
  //Search
  tryPeekProperlyNestedBodyElement() {
    return this.stackTop >= 1 && this.tagIDs[1] === Ee.BODY ? this.items[1] : null;
  }
  contains(t) {
    return this._indexOf(t) > -1;
  }
  getCommonAncestor(t) {
    const i = this._indexOf(t) - 1;
    return i >= 0 ? this.items[i] : null;
  }
  isRootHtmlElementCurrent() {
    return this.stackTop === 0 && this.tagIDs[0] === Ee.HTML;
  }
  //Element in scope
  hasInDynamicScope(t, i) {
    for (let n = this.stackTop; n >= 0; n--) {
      const s = this.tagIDs[n];
      switch (this.treeAdapter.getNamespaceURI(this.items[n])) {
        case en.HTML: {
          if (s === t)
            return !0;
          if (i.has(s))
            return !1;
          break;
        }
        case en.SVG: {
          if (L4e.has(s))
            return !1;
          break;
        }
        case en.MATHML: {
          if (O4e.has(s))
            return !1;
          break;
        }
      }
    }
    return !0;
  }
  hasInScope(t) {
    return this.hasInDynamicScope(t, Ule);
  }
  hasInListItemScope(t) {
    return this.hasInDynamicScope(t, nnt);
  }
  hasInButtonScope(t) {
    return this.hasInDynamicScope(t, snt);
  }
  hasNumberedHeaderInScope() {
    for (let t = this.stackTop; t >= 0; t--) {
      const i = this.tagIDs[t];
      switch (this.treeAdapter.getNamespaceURI(this.items[t])) {
        case en.HTML: {
          if (dpe.has(i))
            return !0;
          if (Ule.has(i))
            return !1;
          break;
        }
        case en.SVG: {
          if (L4e.has(i))
            return !1;
          break;
        }
        case en.MATHML: {
          if (O4e.has(i))
            return !1;
          break;
        }
      }
    }
    return !0;
  }
  hasInTableScope(t) {
    for (let i = this.stackTop; i >= 0; i--)
      if (this.treeAdapter.getNamespaceURI(this.items[i]) === en.HTML)
        switch (this.tagIDs[i]) {
          case t:
            return !0;
          case Ee.TABLE:
          case Ee.HTML:
            return !1;
        }
    return !0;
  }
  hasTableBodyContextInTableScope() {
    for (let t = this.stackTop; t >= 0; t--)
      if (this.treeAdapter.getNamespaceURI(this.items[t]) === en.HTML)
        switch (this.tagIDs[t]) {
          case Ee.TBODY:
          case Ee.THEAD:
          case Ee.TFOOT:
            return !0;
          case Ee.TABLE:
          case Ee.HTML:
            return !1;
        }
    return !0;
  }
  hasInSelectScope(t) {
    for (let i = this.stackTop; i >= 0; i--)
      if (this.treeAdapter.getNamespaceURI(this.items[i]) === en.HTML)
        switch (this.tagIDs[i]) {
          case t:
            return !0;
          case Ee.OPTION:
          case Ee.OPTGROUP:
            break;
          default:
            return !1;
        }
    return !0;
  }
  //Implied end tags
  generateImpliedEndTags() {
    for (; this.currentTagId !== void 0 && e6e.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsThoroughly() {
    for (; this.currentTagId !== void 0 && C4e.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsWithExclusion(t) {
    for (; this.currentTagId !== void 0 && this.currentTagId !== t && C4e.has(this.currentTagId); )
      this.pop();
  }
}
const o0e = 3;
var nN;
(function(e) {
  e[e.Marker = 0] = "Marker", e[e.Element = 1] = "Element";
})(nN || (nN = {}));
const _4e = { type: nN.Marker };
class dnt {
  constructor(t) {
    this.treeAdapter = t, this.entries = [], this.bookmark = null;
  }
  //Noah Ark's condition
  //OPTIMIZATION: at first we try to find possible candidates for exclusion using
  //lightweight heuristics without thorough attributes check.
  _getNoahArkConditionCandidates(t, i) {
    const n = [], s = i.length, o = this.treeAdapter.getTagName(t), r = this.treeAdapter.getNamespaceURI(t);
    for (let l = 0; l < this.entries.length; l++) {
      const c = this.entries[l];
      if (c.type === nN.Marker)
        break;
      const { element: h } = c;
      if (this.treeAdapter.getTagName(h) === o && this.treeAdapter.getNamespaceURI(h) === r) {
        const I = this.treeAdapter.getAttrList(h);
        I.length === s && n.push({ idx: l, attrs: I });
      }
    }
    return n;
  }
  _ensureNoahArkCondition(t) {
    if (this.entries.length < o0e)
      return;
    const i = this.treeAdapter.getAttrList(t), n = this._getNoahArkConditionCandidates(t, i);
    if (n.length < o0e)
      return;
    const s = new Map(i.map((r) => [r.name, r.value]));
    let o = 0;
    for (let r = 0; r < n.length; r++) {
      const l = n[r];
      l.attrs.every((c) => s.get(c.name) === c.value) && (o += 1, o >= o0e && this.entries.splice(l.idx, 1));
    }
  }
  //Mutations
  insertMarker() {
    this.entries.unshift(_4e);
  }
  pushElement(t, i) {
    this._ensureNoahArkCondition(t), this.entries.unshift({
      type: nN.Element,
      element: t,
      token: i
    });
  }
  insertElementAfterBookmark(t, i) {
    const n = this.entries.indexOf(this.bookmark);
    this.entries.splice(n, 0, {
      type: nN.Element,
      element: t,
      token: i
    });
  }
  removeEntry(t) {
    const i = this.entries.indexOf(t);
    i !== -1 && this.entries.splice(i, 1);
  }
  /**
   * Clears the list of formatting elements up to the last marker.
   *
   * @see https://html.spec.whatwg.org/multipage/parsing.html#clear-the-list-of-active-formatting-elements-up-to-the-last-marker
   */
  clearToLastMarker() {
    const t = this.entries.indexOf(_4e);
    t === -1 ? this.entries.length = 0 : this.entries.splice(0, t + 1);
  }
  //Search
  getElementEntryInScopeWithTagName(t) {
    const i = this.entries.find((n) => n.type === nN.Marker || this.treeAdapter.getTagName(n.element) === t);
    return i && i.type === nN.Element ? i : null;
  }
  getElementEntry(t) {
    return this.entries.find((i) => i.type === nN.Element && i.element === t);
  }
}
const Y_ = {
  //Node construction
  createDocument() {
    return {
      nodeName: "#document",
      mode: u5.NO_QUIRKS,
      childNodes: []
    };
  },
  createDocumentFragment() {
    return {
      nodeName: "#document-fragment",
      childNodes: []
    };
  },
  createElement(e, t, i) {
    return {
      nodeName: e,
      tagName: e,
      attrs: i,
      namespaceURI: t,
      childNodes: [],
      parentNode: null
    };
  },
  createCommentNode(e) {
    return {
      nodeName: "#comment",
      data: e,
      parentNode: null
    };
  },
  createTextNode(e) {
    return {
      nodeName: "#text",
      value: e,
      parentNode: null
    };
  },
  //Tree mutation
  appendChild(e, t) {
    e.childNodes.push(t), t.parentNode = e;
  },
  insertBefore(e, t, i) {
    const n = e.childNodes.indexOf(i);
    e.childNodes.splice(n, 0, t), t.parentNode = e;
  },
  setTemplateContent(e, t) {
    e.content = t;
  },
  getTemplateContent(e) {
    return e.content;
  },
  setDocumentType(e, t, i, n) {
    const s = e.childNodes.find((o) => o.nodeName === "#documentType");
    if (s)
      s.name = t, s.publicId = i, s.systemId = n;
    else {
      const o = {
        nodeName: "#documentType",
        name: t,
        publicId: i,
        systemId: n,
        parentNode: null
      };
      Y_.appendChild(e, o);
    }
  },
  setDocumentMode(e, t) {
    e.mode = t;
  },
  getDocumentMode(e) {
    return e.mode;
  },
  detachNode(e) {
    if (e.parentNode) {
      const t = e.parentNode.childNodes.indexOf(e);
      e.parentNode.childNodes.splice(t, 1), e.parentNode = null;
    }
  },
  insertText(e, t) {
    if (e.childNodes.length > 0) {
      const i = e.childNodes[e.childNodes.length - 1];
      if (Y_.isTextNode(i)) {
        i.value += t;
        return;
      }
    }
    Y_.appendChild(e, Y_.createTextNode(t));
  },
  insertTextBefore(e, t, i) {
    const n = e.childNodes[e.childNodes.indexOf(i) - 1];
    n && Y_.isTextNode(n) ? n.value += t : Y_.insertBefore(e, Y_.createTextNode(t), i);
  },
  adoptAttributes(e, t) {
    const i = new Set(e.attrs.map((n) => n.name));
    for (let n = 0; n < t.length; n++)
      i.has(t[n].name) || e.attrs.push(t[n]);
  },
  //Tree traversing
  getFirstChild(e) {
    return e.childNodes[0];
  },
  getChildNodes(e) {
    return e.childNodes;
  },
  getParentNode(e) {
    return e.parentNode;
  },
  getAttrList(e) {
    return e.attrs;
  },
  //Node data
  getTagName(e) {
    return e.tagName;
  },
  getNamespaceURI(e) {
    return e.namespaceURI;
  },
  getTextNodeContent(e) {
    return e.value;
  },
  getCommentNodeContent(e) {
    return e.data;
  },
  getDocumentTypeNodeName(e) {
    return e.name;
  },
  getDocumentTypeNodePublicId(e) {
    return e.publicId;
  },
  getDocumentTypeNodeSystemId(e) {
    return e.systemId;
  },
  //Node types
  isTextNode(e) {
    return e.nodeName === "#text";
  },
  isCommentNode(e) {
    return e.nodeName === "#comment";
  },
  isDocumentTypeNode(e) {
    return e.nodeName === "#documentType";
  },
  isElementNode(e) {
    return Object.prototype.hasOwnProperty.call(e, "tagName");
  },
  // Source code location
  setNodeSourceCodeLocation(e, t) {
    e.sourceCodeLocation = t;
  },
  getNodeSourceCodeLocation(e) {
    return e.sourceCodeLocation;
  },
  updateNodeSourceCodeLocation(e, t) {
    e.sourceCodeLocation = { ...e.sourceCodeLocation, ...t };
  }
}, t6e = "html", cnt = "about:legacy-compat", hnt = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd", i6e = [
  "+//silmaril//dtd html pro v0r11 19970101//",
  "-//as//dtd html 3.0 aswedit + extensions//",
  "-//advasoft ltd//dtd html 3.0 aswedit + extensions//",
  "-//ietf//dtd html 2.0 level 1//",
  "-//ietf//dtd html 2.0 level 2//",
  "-//ietf//dtd html 2.0 strict level 1//",
  "-//ietf//dtd html 2.0 strict level 2//",
  "-//ietf//dtd html 2.0 strict//",
  "-//ietf//dtd html 2.0//",
  "-//ietf//dtd html 2.1e//",
  "-//ietf//dtd html 3.0//",
  "-//ietf//dtd html 3.2 final//",
  "-//ietf//dtd html 3.2//",
  "-//ietf//dtd html 3//",
  "-//ietf//dtd html level 0//",
  "-//ietf//dtd html level 1//",
  "-//ietf//dtd html level 2//",
  "-//ietf//dtd html level 3//",
  "-//ietf//dtd html strict level 0//",
  "-//ietf//dtd html strict level 1//",
  "-//ietf//dtd html strict level 2//",
  "-//ietf//dtd html strict level 3//",
  "-//ietf//dtd html strict//",
  "-//ietf//dtd html//",
  "-//metrius//dtd metrius presentational//",
  "-//microsoft//dtd internet explorer 2.0 html strict//",
  "-//microsoft//dtd internet explorer 2.0 html//",
  "-//microsoft//dtd internet explorer 2.0 tables//",
  "-//microsoft//dtd internet explorer 3.0 html strict//",
  "-//microsoft//dtd internet explorer 3.0 html//",
  "-//microsoft//dtd internet explorer 3.0 tables//",
  "-//netscape comm. corp.//dtd html//",
  "-//netscape comm. corp.//dtd strict html//",
  "-//o'reilly and associates//dtd html 2.0//",
  "-//o'reilly and associates//dtd html extended 1.0//",
  "-//o'reilly and associates//dtd html extended relaxed 1.0//",
  "-//sq//dtd html 2.0 hotmetal + extensions//",
  "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//",
  "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//",
  "-//spyglass//dtd html 2.0 extended//",
  "-//sun microsystems corp.//dtd hotjava html//",
  "-//sun microsystems corp.//dtd hotjava strict html//",
  "-//w3c//dtd html 3 1995-03-24//",
  "-//w3c//dtd html 3.2 draft//",
  "-//w3c//dtd html 3.2 final//",
  "-//w3c//dtd html 3.2//",
  "-//w3c//dtd html 3.2s draft//",
  "-//w3c//dtd html 4.0 frameset//",
  "-//w3c//dtd html 4.0 transitional//",
  "-//w3c//dtd html experimental 19960712//",
  "-//w3c//dtd html experimental 970421//",
  "-//w3c//dtd w3 html//",
  "-//w3o//dtd w3 html 3.0//",
  "-//webtechs//dtd mozilla html 2.0//",
  "-//webtechs//dtd mozilla html//"
], fnt = [
  ...i6e,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
], Int = /* @__PURE__ */ new Set([
  "-//w3o//dtd w3 html strict 3.0//en//",
  "-/w3c/dtd html 4.0 transitional/en",
  "html"
]), n6e = ["-//w3c//dtd xhtml 1.0 frameset//", "-//w3c//dtd xhtml 1.0 transitional//"], pnt = [
  ...n6e,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
];
function x4e(e, t) {
  return t.some((i) => e.startsWith(i));
}
function mnt(e) {
  return e.name === t6e && e.publicId === null && (e.systemId === null || e.systemId === cnt);
}
function ynt(e) {
  if (e.name !== t6e)
    return u5.QUIRKS;
  const { systemId: t } = e;
  if (t && t.toLowerCase() === hnt)
    return u5.QUIRKS;
  let { publicId: i } = e;
  if (i !== null) {
    if (i = i.toLowerCase(), Int.has(i))
      return u5.QUIRKS;
    let n = t === null ? fnt : i6e;
    if (x4e(i, n))
      return u5.QUIRKS;
    if (n = t === null ? n6e : pnt, x4e(i, n))
      return u5.LIMITED_QUIRKS;
  }
  return u5.NO_QUIRKS;
}
const P4e = {
  TEXT_HTML: "text/html",
  APPLICATION_XML: "application/xhtml+xml"
}, Ent = "definitionurl", gnt = "definitionURL", wnt = new Map([
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map((e) => [e.toLowerCase(), e])), Tnt = /* @__PURE__ */ new Map([
  ["xlink:actuate", { prefix: "xlink", name: "actuate", namespace: en.XLINK }],
  ["xlink:arcrole", { prefix: "xlink", name: "arcrole", namespace: en.XLINK }],
  ["xlink:href", { prefix: "xlink", name: "href", namespace: en.XLINK }],
  ["xlink:role", { prefix: "xlink", name: "role", namespace: en.XLINK }],
  ["xlink:show", { prefix: "xlink", name: "show", namespace: en.XLINK }],
  ["xlink:title", { prefix: "xlink", name: "title", namespace: en.XLINK }],
  ["xlink:type", { prefix: "xlink", name: "type", namespace: en.XLINK }],
  ["xml:lang", { prefix: "xml", name: "lang", namespace: en.XML }],
  ["xml:space", { prefix: "xml", name: "space", namespace: en.XML }],
  ["xmlns", { prefix: "", name: "xmlns", namespace: en.XMLNS }],
  ["xmlns:xlink", { prefix: "xmlns", name: "xlink", namespace: en.XMLNS }]
]), Rnt = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map((e) => [e.toLowerCase(), e])), vnt = /* @__PURE__ */ new Set([
  Ee.B,
  Ee.BIG,
  Ee.BLOCKQUOTE,
  Ee.BODY,
  Ee.BR,
  Ee.CENTER,
  Ee.CODE,
  Ee.DD,
  Ee.DIV,
  Ee.DL,
  Ee.DT,
  Ee.EM,
  Ee.EMBED,
  Ee.H1,
  Ee.H2,
  Ee.H3,
  Ee.H4,
  Ee.H5,
  Ee.H6,
  Ee.HEAD,
  Ee.HR,
  Ee.I,
  Ee.IMG,
  Ee.LI,
  Ee.LISTING,
  Ee.MENU,
  Ee.META,
  Ee.NOBR,
  Ee.OL,
  Ee.P,
  Ee.PRE,
  Ee.RUBY,
  Ee.S,
  Ee.SMALL,
  Ee.SPAN,
  Ee.STRONG,
  Ee.STRIKE,
  Ee.SUB,
  Ee.SUP,
  Ee.TABLE,
  Ee.TT,
  Ee.U,
  Ee.UL,
  Ee.VAR
]);
function Ant(e) {
  const t = e.tagID;
  return t === Ee.FONT && e.attrs.some(({ name: n }) => n === zF.COLOR || n === zF.SIZE || n === zF.FACE) || vnt.has(t);
}
function s6e(e) {
  for (let t = 0; t < e.attrs.length; t++)
    if (e.attrs[t].name === Ent) {
      e.attrs[t].name = gnt;
      break;
    }
}
function o6e(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const i = wnt.get(e.attrs[t].name);
    i != null && (e.attrs[t].name = i);
  }
}
function l3e(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const i = Tnt.get(e.attrs[t].name);
    i && (e.attrs[t].prefix = i.prefix, e.attrs[t].name = i.name, e.attrs[t].namespace = i.namespace);
  }
}
function Snt(e) {
  const t = Rnt.get(e.tagName);
  t != null && (e.tagName = t, e.tagID = fY(e.tagName));
}
function bnt(e, t) {
  return t === en.MATHML && (e === Ee.MI || e === Ee.MO || e === Ee.MN || e === Ee.MS || e === Ee.MTEXT);
}
function Nnt(e, t, i) {
  if (t === en.MATHML && e === Ee.ANNOTATION_XML) {
    for (let n = 0; n < i.length; n++)
      if (i[n].name === zF.ENCODING) {
        const s = i[n].value.toLowerCase();
        return s === P4e.TEXT_HTML || s === P4e.APPLICATION_XML;
      }
  }
  return t === en.SVG && (e === Ee.FOREIGN_OBJECT || e === Ee.DESC || e === Ee.TITLE);
}
function Dnt(e, t, i, n) {
  return (!n || n === en.HTML) && Nnt(e, t, i) || (!n || n === en.MATHML) && bnt(e, t);
}
const Cnt = "hidden", Ont = 8, Lnt = 3;
var zt;
(function(e) {
  e[e.INITIAL = 0] = "INITIAL", e[e.BEFORE_HTML = 1] = "BEFORE_HTML", e[e.BEFORE_HEAD = 2] = "BEFORE_HEAD", e[e.IN_HEAD = 3] = "IN_HEAD", e[e.IN_HEAD_NO_SCRIPT = 4] = "IN_HEAD_NO_SCRIPT", e[e.AFTER_HEAD = 5] = "AFTER_HEAD", e[e.IN_BODY = 6] = "IN_BODY", e[e.TEXT = 7] = "TEXT", e[e.IN_TABLE = 8] = "IN_TABLE", e[e.IN_TABLE_TEXT = 9] = "IN_TABLE_TEXT", e[e.IN_CAPTION = 10] = "IN_CAPTION", e[e.IN_COLUMN_GROUP = 11] = "IN_COLUMN_GROUP", e[e.IN_TABLE_BODY = 12] = "IN_TABLE_BODY", e[e.IN_ROW = 13] = "IN_ROW", e[e.IN_CELL = 14] = "IN_CELL", e[e.IN_SELECT = 15] = "IN_SELECT", e[e.IN_SELECT_IN_TABLE = 16] = "IN_SELECT_IN_TABLE", e[e.IN_TEMPLATE = 17] = "IN_TEMPLATE", e[e.AFTER_BODY = 18] = "AFTER_BODY", e[e.IN_FRAMESET = 19] = "IN_FRAMESET", e[e.AFTER_FRAMESET = 20] = "AFTER_FRAMESET", e[e.AFTER_AFTER_BODY = 21] = "AFTER_AFTER_BODY", e[e.AFTER_AFTER_FRAMESET = 22] = "AFTER_AFTER_FRAMESET";
})(zt || (zt = {}));
const _nt = {
  startLine: -1,
  startCol: -1,
  startOffset: -1,
  endLine: -1,
  endCol: -1,
  endOffset: -1
}, r6e = /* @__PURE__ */ new Set([Ee.TABLE, Ee.TBODY, Ee.TFOOT, Ee.THEAD, Ee.TR]), M4e = {
  scriptingEnabled: !0,
  sourceCodeLocationInfo: !1,
  treeAdapter: Y_,
  onParseError: null
};
class U4e {
  constructor(t, i, n = null, s = null) {
    this.fragmentContext = n, this.scriptHandler = s, this.currentToken = null, this.stopped = !1, this.insertionMode = zt.INITIAL, this.originalInsertionMode = zt.INITIAL, this.headElement = null, this.formElement = null, this.currentNotInHTML = !1, this.tmplInsertionModeStack = [], this.pendingCharacterTokens = [], this.hasNonWhitespacePendingCharacterToken = !1, this.framesetOk = !0, this.skipNextNewLine = !1, this.fosterParentingEnabled = !1, this.options = {
      ...M4e,
      ...t
    }, this.treeAdapter = this.options.treeAdapter, this.onParseError = this.options.onParseError, this.onParseError && (this.options.sourceCodeLocationInfo = !0), this.document = i ?? this.treeAdapter.createDocument(), this.tokenizer = new int(this.options, this), this.activeFormattingElements = new dnt(this.treeAdapter), this.fragmentContextID = n ? fY(this.treeAdapter.getTagName(n)) : Ee.UNKNOWN, this._setContextModes(n ?? this.document, this.fragmentContextID), this.openElements = new unt(this.document, this.treeAdapter, this);
  }
  // API
  static parse(t, i) {
    const n = new this(i);
    return n.tokenizer.write(t, !0), n.document;
  }
  static getFragmentParser(t, i) {
    const n = {
      ...M4e,
      ...i
    };
    t ?? (t = n.treeAdapter.createElement(fi.TEMPLATE, en.HTML, []));
    const s = n.treeAdapter.createElement("documentmock", en.HTML, []), o = new this(n, s, t);
    return o.fragmentContextID === Ee.TEMPLATE && o.tmplInsertionModeStack.unshift(zt.IN_TEMPLATE), o._initTokenizerForFragmentParsing(), o._insertFakeRootElement(), o._resetInsertionMode(), o._findFormInFragmentContext(), o;
  }
  getFragment() {
    const t = this.treeAdapter.getFirstChild(this.document), i = this.treeAdapter.createDocumentFragment();
    return this._adoptNodes(t, i), i;
  }
  //Errors
  /** @internal */
  _err(t, i, n) {
    var s;
    if (!this.onParseError)
      return;
    const o = (s = t.location) !== null && s !== void 0 ? s : _nt, r = {
      code: i,
      startLine: o.startLine,
      startCol: o.startCol,
      startOffset: o.startOffset,
      endLine: n ? o.startLine : o.endLine,
      endCol: n ? o.startCol : o.endCol,
      endOffset: n ? o.startOffset : o.endOffset
    };
    this.onParseError(r);
  }
  //Stack events
  /** @internal */
  onItemPush(t, i, n) {
    var s, o;
    (o = (s = this.treeAdapter).onItemPush) === null || o === void 0 || o.call(s, t), n && this.openElements.stackTop > 0 && this._setContextModes(t, i);
  }
  /** @internal */
  onItemPop(t, i) {
    var n, s;
    if (this.options.sourceCodeLocationInfo && this._setEndLocation(t, this.currentToken), (s = (n = this.treeAdapter).onItemPop) === null || s === void 0 || s.call(n, t, this.openElements.current), i) {
      let o, r;
      this.openElements.stackTop === 0 && this.fragmentContext ? (o = this.fragmentContext, r = this.fragmentContextID) : { current: o, currentTagId: r } = this.openElements, this._setContextModes(o, r);
    }
  }
  _setContextModes(t, i) {
    const n = t === this.document || t && this.treeAdapter.getNamespaceURI(t) === en.HTML;
    this.currentNotInHTML = !n, this.tokenizer.inForeignNode = !n && t !== void 0 && i !== void 0 && !this._isIntegrationPoint(i, t);
  }
  /** @protected */
  _switchToTextParsing(t, i) {
    this._insertElement(t, en.HTML), this.tokenizer.state = i, this.originalInsertionMode = this.insertionMode, this.insertionMode = zt.TEXT;
  }
  switchToPlaintextParsing() {
    this.insertionMode = zt.TEXT, this.originalInsertionMode = zt.IN_BODY, this.tokenizer.state = d0.PLAINTEXT;
  }
  //Fragment parsing
  /** @protected */
  _getAdjustedCurrentElement() {
    return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
  }
  /** @protected */
  _findFormInFragmentContext() {
    let t = this.fragmentContext;
    for (; t; ) {
      if (this.treeAdapter.getTagName(t) === fi.FORM) {
        this.formElement = t;
        break;
      }
      t = this.treeAdapter.getParentNode(t);
    }
  }
  _initTokenizerForFragmentParsing() {
    if (!(!this.fragmentContext || this.treeAdapter.getNamespaceURI(this.fragmentContext) !== en.HTML))
      switch (this.fragmentContextID) {
        case Ee.TITLE:
        case Ee.TEXTAREA: {
          this.tokenizer.state = d0.RCDATA;
          break;
        }
        case Ee.STYLE:
        case Ee.XMP:
        case Ee.IFRAME:
        case Ee.NOEMBED:
        case Ee.NOFRAMES:
        case Ee.NOSCRIPT: {
          this.tokenizer.state = d0.RAWTEXT;
          break;
        }
        case Ee.SCRIPT: {
          this.tokenizer.state = d0.SCRIPT_DATA;
          break;
        }
        case Ee.PLAINTEXT: {
          this.tokenizer.state = d0.PLAINTEXT;
          break;
        }
      }
  }
  //Tree mutation
  /** @protected */
  _setDocumentType(t) {
    const i = t.name || "", n = t.publicId || "", s = t.systemId || "";
    if (this.treeAdapter.setDocumentType(this.document, i, n, s), t.location) {
      const r = this.treeAdapter.getChildNodes(this.document).find((l) => this.treeAdapter.isDocumentTypeNode(l));
      r && this.treeAdapter.setNodeSourceCodeLocation(r, t.location);
    }
  }
  /** @protected */
  _attachElementToTree(t, i) {
    if (this.options.sourceCodeLocationInfo) {
      const n = i && {
        ...i,
        startTag: i
      };
      this.treeAdapter.setNodeSourceCodeLocation(t, n);
    }
    if (this._shouldFosterParentOnInsertion())
      this._fosterParentElement(t);
    else {
      const n = this.openElements.currentTmplContentOrNode;
      this.treeAdapter.appendChild(n ?? this.document, t);
    }
  }
  /**
   * For self-closing tags. Add an element to the tree, but skip adding it
   * to the stack.
   */
  /** @protected */
  _appendElement(t, i) {
    const n = this.treeAdapter.createElement(t.tagName, i, t.attrs);
    this._attachElementToTree(n, t.location);
  }
  /** @protected */
  _insertElement(t, i) {
    const n = this.treeAdapter.createElement(t.tagName, i, t.attrs);
    this._attachElementToTree(n, t.location), this.openElements.push(n, t.tagID);
  }
  /** @protected */
  _insertFakeElement(t, i) {
    const n = this.treeAdapter.createElement(t, en.HTML, []);
    this._attachElementToTree(n, null), this.openElements.push(n, i);
  }
  /** @protected */
  _insertTemplate(t) {
    const i = this.treeAdapter.createElement(t.tagName, en.HTML, t.attrs), n = this.treeAdapter.createDocumentFragment();
    this.treeAdapter.setTemplateContent(i, n), this._attachElementToTree(i, t.location), this.openElements.push(i, t.tagID), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(n, null);
  }
  /** @protected */
  _insertFakeRootElement() {
    const t = this.treeAdapter.createElement(fi.HTML, en.HTML, []);
    this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(t, null), this.treeAdapter.appendChild(this.openElements.current, t), this.openElements.push(t, Ee.HTML);
  }
  /** @protected */
  _appendCommentNode(t, i) {
    const n = this.treeAdapter.createCommentNode(t.data);
    this.treeAdapter.appendChild(i, n), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(n, t.location);
  }
  /** @protected */
  _insertCharacters(t) {
    let i, n;
    if (this._shouldFosterParentOnInsertion() ? ({ parent: i, beforeElement: n } = this._findFosterParentingLocation(), n ? this.treeAdapter.insertTextBefore(i, t.chars, n) : this.treeAdapter.insertText(i, t.chars)) : (i = this.openElements.currentTmplContentOrNode, this.treeAdapter.insertText(i, t.chars)), !t.location)
      return;
    const s = this.treeAdapter.getChildNodes(i), o = n ? s.lastIndexOf(n) : s.length, r = s[o - 1];
    if (this.treeAdapter.getNodeSourceCodeLocation(r)) {
      const { endLine: c, endCol: h, endOffset: I } = t.location;
      this.treeAdapter.updateNodeSourceCodeLocation(r, { endLine: c, endCol: h, endOffset: I });
    } else this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(r, t.location);
  }
  /** @protected */
  _adoptNodes(t, i) {
    for (let n = this.treeAdapter.getFirstChild(t); n; n = this.treeAdapter.getFirstChild(t))
      this.treeAdapter.detachNode(n), this.treeAdapter.appendChild(i, n);
  }
  /** @protected */
  _setEndLocation(t, i) {
    if (this.treeAdapter.getNodeSourceCodeLocation(t) && i.location) {
      const n = i.location, s = this.treeAdapter.getTagName(t), o = (
        // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
        // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
        i.type === $o.END_TAG && s === i.tagName ? {
          endTag: { ...n },
          endLine: n.endLine,
          endCol: n.endCol,
          endOffset: n.endOffset
        } : {
          endLine: n.startLine,
          endCol: n.startCol,
          endOffset: n.startOffset
        }
      );
      this.treeAdapter.updateNodeSourceCodeLocation(t, o);
    }
  }
  //Token processing
  shouldProcessStartTagTokenInForeignContent(t) {
    if (!this.currentNotInHTML)
      return !1;
    let i, n;
    return this.openElements.stackTop === 0 && this.fragmentContext ? (i = this.fragmentContext, n = this.fragmentContextID) : { current: i, currentTagId: n } = this.openElements, t.tagID === Ee.SVG && this.treeAdapter.getTagName(i) === fi.ANNOTATION_XML && this.treeAdapter.getNamespaceURI(i) === en.MATHML ? !1 : (
      // Check that `current` is not an integration point for HTML or MathML elements.
      this.tokenizer.inForeignNode || // If it _is_ an integration point, then we might have to check that it is not an HTML
      // integration point.
      (t.tagID === Ee.MGLYPH || t.tagID === Ee.MALIGNMARK) && n !== void 0 && !this._isIntegrationPoint(n, i, en.HTML)
    );
  }
  /** @protected */
  _processToken(t) {
    switch (t.type) {
      case $o.CHARACTER: {
        this.onCharacter(t);
        break;
      }
      case $o.NULL_CHARACTER: {
        this.onNullCharacter(t);
        break;
      }
      case $o.COMMENT: {
        this.onComment(t);
        break;
      }
      case $o.DOCTYPE: {
        this.onDoctype(t);
        break;
      }
      case $o.START_TAG: {
        this._processStartTag(t);
        break;
      }
      case $o.END_TAG: {
        this.onEndTag(t);
        break;
      }
      case $o.EOF: {
        this.onEof(t);
        break;
      }
      case $o.WHITESPACE_CHARACTER: {
        this.onWhitespaceCharacter(t);
        break;
      }
    }
  }
  //Integration points
  /** @protected */
  _isIntegrationPoint(t, i, n) {
    const s = this.treeAdapter.getNamespaceURI(i), o = this.treeAdapter.getAttrList(i);
    return Dnt(t, s, o, n);
  }
  //Active formatting elements reconstruction
  /** @protected */
  _reconstructActiveFormattingElements() {
    const t = this.activeFormattingElements.entries.length;
    if (t) {
      const i = this.activeFormattingElements.entries.findIndex((s) => s.type === nN.Marker || this.openElements.contains(s.element)), n = i === -1 ? t - 1 : i - 1;
      for (let s = n; s >= 0; s--) {
        const o = this.activeFormattingElements.entries[s];
        this._insertElement(o.token, this.treeAdapter.getNamespaceURI(o.element)), o.element = this.openElements.current;
      }
    }
  }
  //Close elements
  /** @protected */
  _closeTableCell() {
    this.openElements.generateImpliedEndTags(), this.openElements.popUntilTableCellPopped(), this.activeFormattingElements.clearToLastMarker(), this.insertionMode = zt.IN_ROW;
  }
  /** @protected */
  _closePElement() {
    this.openElements.generateImpliedEndTagsWithExclusion(Ee.P), this.openElements.popUntilTagNamePopped(Ee.P);
  }
  //Insertion modes
  /** @protected */
  _resetInsertionMode() {
    for (let t = this.openElements.stackTop; t >= 0; t--)
      switch (t === 0 && this.fragmentContext ? this.fragmentContextID : this.openElements.tagIDs[t]) {
        case Ee.TR: {
          this.insertionMode = zt.IN_ROW;
          return;
        }
        case Ee.TBODY:
        case Ee.THEAD:
        case Ee.TFOOT: {
          this.insertionMode = zt.IN_TABLE_BODY;
          return;
        }
        case Ee.CAPTION: {
          this.insertionMode = zt.IN_CAPTION;
          return;
        }
        case Ee.COLGROUP: {
          this.insertionMode = zt.IN_COLUMN_GROUP;
          return;
        }
        case Ee.TABLE: {
          this.insertionMode = zt.IN_TABLE;
          return;
        }
        case Ee.BODY: {
          this.insertionMode = zt.IN_BODY;
          return;
        }
        case Ee.FRAMESET: {
          this.insertionMode = zt.IN_FRAMESET;
          return;
        }
        case Ee.SELECT: {
          this._resetInsertionModeForSelect(t);
          return;
        }
        case Ee.TEMPLATE: {
          this.insertionMode = this.tmplInsertionModeStack[0];
          return;
        }
        case Ee.HTML: {
          this.insertionMode = this.headElement ? zt.AFTER_HEAD : zt.BEFORE_HEAD;
          return;
        }
        case Ee.TD:
        case Ee.TH: {
          if (t > 0) {
            this.insertionMode = zt.IN_CELL;
            return;
          }
          break;
        }
        case Ee.HEAD: {
          if (t > 0) {
            this.insertionMode = zt.IN_HEAD;
            return;
          }
          break;
        }
      }
    this.insertionMode = zt.IN_BODY;
  }
  /** @protected */
  _resetInsertionModeForSelect(t) {
    if (t > 0)
      for (let i = t - 1; i > 0; i--) {
        const n = this.openElements.tagIDs[i];
        if (n === Ee.TEMPLATE)
          break;
        if (n === Ee.TABLE) {
          this.insertionMode = zt.IN_SELECT_IN_TABLE;
          return;
        }
      }
    this.insertionMode = zt.IN_SELECT;
  }
  //Foster parenting
  /** @protected */
  _isElementCausesFosterParenting(t) {
    return r6e.has(t);
  }
  /** @protected */
  _shouldFosterParentOnInsertion() {
    return this.fosterParentingEnabled && this.openElements.currentTagId !== void 0 && this._isElementCausesFosterParenting(this.openElements.currentTagId);
  }
  /** @protected */
  _findFosterParentingLocation() {
    for (let t = this.openElements.stackTop; t >= 0; t--) {
      const i = this.openElements.items[t];
      switch (this.openElements.tagIDs[t]) {
        case Ee.TEMPLATE: {
          if (this.treeAdapter.getNamespaceURI(i) === en.HTML)
            return { parent: this.treeAdapter.getTemplateContent(i), beforeElement: null };
          break;
        }
        case Ee.TABLE: {
          const n = this.treeAdapter.getParentNode(i);
          return n ? { parent: n, beforeElement: i } : { parent: this.openElements.items[t - 1], beforeElement: null };
        }
      }
    }
    return { parent: this.openElements.items[0], beforeElement: null };
  }
  /** @protected */
  _fosterParentElement(t) {
    const i = this._findFosterParentingLocation();
    i.beforeElement ? this.treeAdapter.insertBefore(i.parent, t, i.beforeElement) : this.treeAdapter.appendChild(i.parent, t);
  }
  //Special elements
  /** @protected */
  _isSpecialElement(t, i) {
    const n = this.treeAdapter.getNamespaceURI(t);
    return Jit[n].has(i);
  }
  /** @internal */
  onCharacter(t) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      aot(this, t);
      return;
    }
    switch (this.insertionMode) {
      case zt.INITIAL: {
        KZ(this, t);
        break;
      }
      case zt.BEFORE_HTML: {
        $J(this, t);
        break;
      }
      case zt.BEFORE_HEAD: {
        KJ(this, t);
        break;
      }
      case zt.IN_HEAD: {
        ZJ(this, t);
        break;
      }
      case zt.IN_HEAD_NO_SCRIPT: {
        QJ(this, t);
        break;
      }
      case zt.AFTER_HEAD: {
        JJ(this, t);
        break;
      }
      case zt.IN_BODY:
      case zt.IN_CAPTION:
      case zt.IN_CELL:
      case zt.IN_TEMPLATE: {
        a6e(this, t);
        break;
      }
      case zt.TEXT:
      case zt.IN_SELECT:
      case zt.IN_SELECT_IN_TABLE: {
        this._insertCharacters(t);
        break;
      }
      case zt.IN_TABLE:
      case zt.IN_TABLE_BODY:
      case zt.IN_ROW: {
        r0e(this, t);
        break;
      }
      case zt.IN_TABLE_TEXT: {
        I6e(this, t);
        break;
      }
      case zt.IN_COLUMN_GROUP: {
        Ble(this, t);
        break;
      }
      case zt.AFTER_BODY: {
        Fle(this, t);
        break;
      }
      case zt.AFTER_AFTER_BODY: {
        Mre(this, t);
        break;
      }
    }
  }
  /** @internal */
  onNullCharacter(t) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      lot(this, t);
      return;
    }
    switch (this.insertionMode) {
      case zt.INITIAL: {
        KZ(this, t);
        break;
      }
      case zt.BEFORE_HTML: {
        $J(this, t);
        break;
      }
      case zt.BEFORE_HEAD: {
        KJ(this, t);
        break;
      }
      case zt.IN_HEAD: {
        ZJ(this, t);
        break;
      }
      case zt.IN_HEAD_NO_SCRIPT: {
        QJ(this, t);
        break;
      }
      case zt.AFTER_HEAD: {
        JJ(this, t);
        break;
      }
      case zt.TEXT: {
        this._insertCharacters(t);
        break;
      }
      case zt.IN_TABLE:
      case zt.IN_TABLE_BODY:
      case zt.IN_ROW: {
        r0e(this, t);
        break;
      }
      case zt.IN_COLUMN_GROUP: {
        Ble(this, t);
        break;
      }
      case zt.AFTER_BODY: {
        Fle(this, t);
        break;
      }
      case zt.AFTER_AFTER_BODY: {
        Mre(this, t);
        break;
      }
    }
  }
  /** @internal */
  onComment(t) {
    if (this.skipNextNewLine = !1, this.currentNotInHTML) {
      cpe(this, t);
      return;
    }
    switch (this.insertionMode) {
      case zt.INITIAL:
      case zt.BEFORE_HTML:
      case zt.BEFORE_HEAD:
      case zt.IN_HEAD:
      case zt.IN_HEAD_NO_SCRIPT:
      case zt.AFTER_HEAD:
      case zt.IN_BODY:
      case zt.IN_TABLE:
      case zt.IN_CAPTION:
      case zt.IN_COLUMN_GROUP:
      case zt.IN_TABLE_BODY:
      case zt.IN_ROW:
      case zt.IN_CELL:
      case zt.IN_SELECT:
      case zt.IN_SELECT_IN_TABLE:
      case zt.IN_TEMPLATE:
      case zt.IN_FRAMESET:
      case zt.AFTER_FRAMESET: {
        cpe(this, t);
        break;
      }
      case zt.IN_TABLE_TEXT: {
        ZZ(this, t);
        break;
      }
      case zt.AFTER_BODY: {
        Hnt(this, t);
        break;
      }
      case zt.AFTER_AFTER_BODY:
      case zt.AFTER_AFTER_FRAMESET: {
        Gnt(this, t);
        break;
      }
    }
  }
  /** @internal */
  onDoctype(t) {
    switch (this.skipNextNewLine = !1, this.insertionMode) {
      case zt.INITIAL: {
        knt(this, t);
        break;
      }
      case zt.BEFORE_HEAD:
      case zt.IN_HEAD:
      case zt.IN_HEAD_NO_SCRIPT:
      case zt.AFTER_HEAD: {
        this._err(t, Oi.misplacedDoctype);
        break;
      }
      case zt.IN_TABLE_TEXT: {
        ZZ(this, t);
        break;
      }
    }
  }
  /** @internal */
  onStartTag(t) {
    this.skipNextNewLine = !1, this.currentToken = t, this._processStartTag(t), t.selfClosing && !t.ackSelfClosing && this._err(t, Oi.nonVoidHtmlElementStartTagWithTrailingSolidus);
  }
  /**
   * Processes a given start tag.
   *
   * `onStartTag` checks if a self-closing tag was recognized. When a token
   * is moved inbetween multiple insertion modes, this check for self-closing
   * could lead to false positives. To avoid this, `_processStartTag` is used
   * for nested calls.
   *
   * @param token The token to process.
   * @protected
   */
  _processStartTag(t) {
    this.shouldProcessStartTagTokenInForeignContent(t) ? uot(this, t) : this._startTagOutsideForeignContent(t);
  }
  /** @protected */
  _startTagOutsideForeignContent(t) {
    switch (this.insertionMode) {
      case zt.INITIAL: {
        KZ(this, t);
        break;
      }
      case zt.BEFORE_HTML: {
        Vnt(this, t);
        break;
      }
      case zt.BEFORE_HEAD: {
        jnt(this, t);
        break;
      }
      case zt.IN_HEAD: {
        kA(this, t);
        break;
      }
      case zt.IN_HEAD_NO_SCRIPT: {
        qnt(this, t);
        break;
      }
      case zt.AFTER_HEAD: {
        Knt(this, t);
        break;
      }
      case zt.IN_BODY: {
        p3(this, t);
        break;
      }
      case zt.IN_TABLE: {
        ZW(this, t);
        break;
      }
      case zt.IN_TABLE_TEXT: {
        ZZ(this, t);
        break;
      }
      case zt.IN_CAPTION: {
        Wst(this, t);
        break;
      }
      case zt.IN_COLUMN_GROUP: {
        d3e(this, t);
        break;
      }
      case zt.IN_TABLE_BODY: {
        Hue(this, t);
        break;
      }
      case zt.IN_ROW: {
        Gue(this, t);
        break;
      }
      case zt.IN_CELL: {
        $st(this, t);
        break;
      }
      case zt.IN_SELECT: {
        y6e(this, t);
        break;
      }
      case zt.IN_SELECT_IN_TABLE: {
        Zst(this, t);
        break;
      }
      case zt.IN_TEMPLATE: {
        Jst(this, t);
        break;
      }
      case zt.AFTER_BODY: {
        eot(this, t);
        break;
      }
      case zt.IN_FRAMESET: {
        tot(this, t);
        break;
      }
      case zt.AFTER_FRAMESET: {
        not(this, t);
        break;
      }
      case zt.AFTER_AFTER_BODY: {
        oot(this, t);
        break;
      }
      case zt.AFTER_AFTER_FRAMESET: {
        rot(this, t);
        break;
      }
    }
  }
  /** @internal */
  onEndTag(t) {
    this.skipNextNewLine = !1, this.currentToken = t, this.currentNotInHTML ? dot(this, t) : this._endTagOutsideForeignContent(t);
  }
  /** @protected */
  _endTagOutsideForeignContent(t) {
    switch (this.insertionMode) {
      case zt.INITIAL: {
        KZ(this, t);
        break;
      }
      case zt.BEFORE_HTML: {
        znt(this, t);
        break;
      }
      case zt.BEFORE_HEAD: {
        Wnt(this, t);
        break;
      }
      case zt.IN_HEAD: {
        Ynt(this, t);
        break;
      }
      case zt.IN_HEAD_NO_SCRIPT: {
        $nt(this, t);
        break;
      }
      case zt.AFTER_HEAD: {
        Znt(this, t);
        break;
      }
      case zt.IN_BODY: {
        Fue(this, t);
        break;
      }
      case zt.TEXT: {
        Mst(this, t);
        break;
      }
      case zt.IN_TABLE: {
        jX(this, t);
        break;
      }
      case zt.IN_TABLE_TEXT: {
        ZZ(this, t);
        break;
      }
      case zt.IN_CAPTION: {
        Yst(this, t);
        break;
      }
      case zt.IN_COLUMN_GROUP: {
        qst(this, t);
        break;
      }
      case zt.IN_TABLE_BODY: {
        hpe(this, t);
        break;
      }
      case zt.IN_ROW: {
        m6e(this, t);
        break;
      }
      case zt.IN_CELL: {
        Kst(this, t);
        break;
      }
      case zt.IN_SELECT: {
        E6e(this, t);
        break;
      }
      case zt.IN_SELECT_IN_TABLE: {
        Qst(this, t);
        break;
      }
      case zt.IN_TEMPLATE: {
        Xst(this, t);
        break;
      }
      case zt.AFTER_BODY: {
        w6e(this, t);
        break;
      }
      case zt.IN_FRAMESET: {
        iot(this, t);
        break;
      }
      case zt.AFTER_FRAMESET: {
        sot(this, t);
        break;
      }
      case zt.AFTER_AFTER_BODY: {
        Mre(this, t);
        break;
      }
    }
  }
  /** @internal */
  onEof(t) {
    switch (this.insertionMode) {
      case zt.INITIAL: {
        KZ(this, t);
        break;
      }
      case zt.BEFORE_HTML: {
        $J(this, t);
        break;
      }
      case zt.BEFORE_HEAD: {
        KJ(this, t);
        break;
      }
      case zt.IN_HEAD: {
        ZJ(this, t);
        break;
      }
      case zt.IN_HEAD_NO_SCRIPT: {
        QJ(this, t);
        break;
      }
      case zt.AFTER_HEAD: {
        JJ(this, t);
        break;
      }
      case zt.IN_BODY:
      case zt.IN_TABLE:
      case zt.IN_CAPTION:
      case zt.IN_COLUMN_GROUP:
      case zt.IN_TABLE_BODY:
      case zt.IN_ROW:
      case zt.IN_CELL:
      case zt.IN_SELECT:
      case zt.IN_SELECT_IN_TABLE: {
        h6e(this, t);
        break;
      }
      case zt.TEXT: {
        Ust(this, t);
        break;
      }
      case zt.IN_TABLE_TEXT: {
        ZZ(this, t);
        break;
      }
      case zt.IN_TEMPLATE: {
        g6e(this, t);
        break;
      }
      case zt.AFTER_BODY:
      case zt.IN_FRAMESET:
      case zt.AFTER_FRAMESET:
      case zt.AFTER_AFTER_BODY:
      case zt.AFTER_AFTER_FRAMESET: {
        u3e(this, t);
        break;
      }
    }
  }
  /** @internal */
  onWhitespaceCharacter(t) {
    if (this.skipNextNewLine && (this.skipNextNewLine = !1, t.chars.charCodeAt(0) === Nt.LINE_FEED)) {
      if (t.chars.length === 1)
        return;
      t.chars = t.chars.substr(1);
    }
    if (this.tokenizer.inForeignNode) {
      this._insertCharacters(t);
      return;
    }
    switch (this.insertionMode) {
      case zt.IN_HEAD:
      case zt.IN_HEAD_NO_SCRIPT:
      case zt.AFTER_HEAD:
      case zt.TEXT:
      case zt.IN_COLUMN_GROUP:
      case zt.IN_SELECT:
      case zt.IN_SELECT_IN_TABLE:
      case zt.IN_FRAMESET:
      case zt.AFTER_FRAMESET: {
        this._insertCharacters(t);
        break;
      }
      case zt.IN_BODY:
      case zt.IN_CAPTION:
      case zt.IN_CELL:
      case zt.IN_TEMPLATE:
      case zt.AFTER_BODY:
      case zt.AFTER_AFTER_BODY:
      case zt.AFTER_AFTER_FRAMESET: {
        l6e(this, t);
        break;
      }
      case zt.IN_TABLE:
      case zt.IN_TABLE_BODY:
      case zt.IN_ROW: {
        r0e(this, t);
        break;
      }
      case zt.IN_TABLE_TEXT: {
        f6e(this, t);
        break;
      }
    }
  }
}
function xnt(e, t) {
  let i = e.activeFormattingElements.getElementEntryInScopeWithTagName(t.tagName);
  return i ? e.openElements.contains(i.element) ? e.openElements.hasInScope(t.tagID) || (i = null) : (e.activeFormattingElements.removeEntry(i), i = null) : c6e(e, t), i;
}
function Pnt(e, t) {
  let i = null, n = e.openElements.stackTop;
  for (; n >= 0; n--) {
    const s = e.openElements.items[n];
    if (s === t.element)
      break;
    e._isSpecialElement(s, e.openElements.tagIDs[n]) && (i = s);
  }
  return i || (e.openElements.shortenToLength(Math.max(n, 0)), e.activeFormattingElements.removeEntry(t)), i;
}
function Mnt(e, t, i) {
  let n = t, s = e.openElements.getCommonAncestor(t);
  for (let o = 0, r = s; r !== i; o++, r = s) {
    s = e.openElements.getCommonAncestor(r);
    const l = e.activeFormattingElements.getElementEntry(r), c = l && o >= Lnt;
    !l || c ? (c && e.activeFormattingElements.removeEntry(l), e.openElements.remove(r)) : (r = Unt(e, l), n === t && (e.activeFormattingElements.bookmark = l), e.treeAdapter.detachNode(n), e.treeAdapter.appendChild(r, n), n = r);
  }
  return n;
}
function Unt(e, t) {
  const i = e.treeAdapter.getNamespaceURI(t.element), n = e.treeAdapter.createElement(t.token.tagName, i, t.token.attrs);
  return e.openElements.replace(t.element, n), t.element = n, n;
}
function Bnt(e, t, i) {
  const n = e.treeAdapter.getTagName(t), s = fY(n);
  if (e._isElementCausesFosterParenting(s))
    e._fosterParentElement(i);
  else {
    const o = e.treeAdapter.getNamespaceURI(t);
    s === Ee.TEMPLATE && o === en.HTML && (t = e.treeAdapter.getTemplateContent(t)), e.treeAdapter.appendChild(t, i);
  }
}
function Fnt(e, t, i) {
  const n = e.treeAdapter.getNamespaceURI(i.element), { token: s } = i, o = e.treeAdapter.createElement(s.tagName, n, s.attrs);
  e._adoptNodes(t, o), e.treeAdapter.appendChild(t, o), e.activeFormattingElements.insertElementAfterBookmark(o, s), e.activeFormattingElements.removeEntry(i), e.openElements.remove(i.element), e.openElements.insertAfter(t, o, s.tagID);
}
function a3e(e, t) {
  for (let i = 0; i < Ont; i++) {
    const n = xnt(e, t);
    if (!n)
      break;
    const s = Pnt(e, n);
    if (!s)
      break;
    e.activeFormattingElements.bookmark = n;
    const o = Mnt(e, s, n.element), r = e.openElements.getCommonAncestor(n.element);
    e.treeAdapter.detachNode(o), r && Bnt(e, r, o), Fnt(e, s, n);
  }
}
function cpe(e, t) {
  e._appendCommentNode(t, e.openElements.currentTmplContentOrNode);
}
function Hnt(e, t) {
  e._appendCommentNode(t, e.openElements.items[0]);
}
function Gnt(e, t) {
  e._appendCommentNode(t, e.document);
}
function u3e(e, t) {
  if (e.stopped = !0, t.location) {
    const i = e.fragmentContext ? 0 : 2;
    for (let n = e.openElements.stackTop; n >= i; n--)
      e._setEndLocation(e.openElements.items[n], t);
    if (!e.fragmentContext && e.openElements.stackTop >= 0) {
      const n = e.openElements.items[0], s = e.treeAdapter.getNodeSourceCodeLocation(n);
      if (s && !s.endTag && (e._setEndLocation(n, t), e.openElements.stackTop >= 1)) {
        const o = e.openElements.items[1], r = e.treeAdapter.getNodeSourceCodeLocation(o);
        r && !r.endTag && e._setEndLocation(o, t);
      }
    }
  }
}
function knt(e, t) {
  e._setDocumentType(t);
  const i = t.forceQuirks ? u5.QUIRKS : ynt(t);
  mnt(t) || e._err(t, Oi.nonConformingDoctype), e.treeAdapter.setDocumentMode(e.document, i), e.insertionMode = zt.BEFORE_HTML;
}
function KZ(e, t) {
  e._err(t, Oi.missingDoctype, !0), e.treeAdapter.setDocumentMode(e.document, u5.QUIRKS), e.insertionMode = zt.BEFORE_HTML, e._processToken(t);
}
function Vnt(e, t) {
  t.tagID === Ee.HTML ? (e._insertElement(t, en.HTML), e.insertionMode = zt.BEFORE_HEAD) : $J(e, t);
}
function znt(e, t) {
  const i = t.tagID;
  (i === Ee.HTML || i === Ee.HEAD || i === Ee.BODY || i === Ee.BR) && $J(e, t);
}
function $J(e, t) {
  e._insertFakeRootElement(), e.insertionMode = zt.BEFORE_HEAD, e._processToken(t);
}
function jnt(e, t) {
  switch (t.tagID) {
    case Ee.HTML: {
      p3(e, t);
      break;
    }
    case Ee.HEAD: {
      e._insertElement(t, en.HTML), e.headElement = e.openElements.current, e.insertionMode = zt.IN_HEAD;
      break;
    }
    default:
      KJ(e, t);
  }
}
function Wnt(e, t) {
  const i = t.tagID;
  i === Ee.HEAD || i === Ee.BODY || i === Ee.HTML || i === Ee.BR ? KJ(e, t) : e._err(t, Oi.endTagWithoutMatchingOpenElement);
}
function KJ(e, t) {
  e._insertFakeElement(fi.HEAD, Ee.HEAD), e.headElement = e.openElements.current, e.insertionMode = zt.IN_HEAD, e._processToken(t);
}
function kA(e, t) {
  switch (t.tagID) {
    case Ee.HTML: {
      p3(e, t);
      break;
    }
    case Ee.BASE:
    case Ee.BASEFONT:
    case Ee.BGSOUND:
    case Ee.LINK:
    case Ee.META: {
      e._appendElement(t, en.HTML), t.ackSelfClosing = !0;
      break;
    }
    case Ee.TITLE: {
      e._switchToTextParsing(t, d0.RCDATA);
      break;
    }
    case Ee.NOSCRIPT: {
      e.options.scriptingEnabled ? e._switchToTextParsing(t, d0.RAWTEXT) : (e._insertElement(t, en.HTML), e.insertionMode = zt.IN_HEAD_NO_SCRIPT);
      break;
    }
    case Ee.NOFRAMES:
    case Ee.STYLE: {
      e._switchToTextParsing(t, d0.RAWTEXT);
      break;
    }
    case Ee.SCRIPT: {
      e._switchToTextParsing(t, d0.SCRIPT_DATA);
      break;
    }
    case Ee.TEMPLATE: {
      e._insertTemplate(t), e.activeFormattingElements.insertMarker(), e.framesetOk = !1, e.insertionMode = zt.IN_TEMPLATE, e.tmplInsertionModeStack.unshift(zt.IN_TEMPLATE);
      break;
    }
    case Ee.HEAD: {
      e._err(t, Oi.misplacedStartTagForHeadElement);
      break;
    }
    default:
      ZJ(e, t);
  }
}
function Ynt(e, t) {
  switch (t.tagID) {
    case Ee.HEAD: {
      e.openElements.pop(), e.insertionMode = zt.AFTER_HEAD;
      break;
    }
    case Ee.BODY:
    case Ee.BR:
    case Ee.HTML: {
      ZJ(e, t);
      break;
    }
    case Ee.TEMPLATE: {
      UH(e, t);
      break;
    }
    default:
      e._err(t, Oi.endTagWithoutMatchingOpenElement);
  }
}
function UH(e, t) {
  e.openElements.tmplCount > 0 ? (e.openElements.generateImpliedEndTagsThoroughly(), e.openElements.currentTagId !== Ee.TEMPLATE && e._err(t, Oi.closingOfElementWithOpenChildElements), e.openElements.popUntilTagNamePopped(Ee.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e.tmplInsertionModeStack.shift(), e._resetInsertionMode()) : e._err(t, Oi.endTagWithoutMatchingOpenElement);
}
function ZJ(e, t) {
  e.openElements.pop(), e.insertionMode = zt.AFTER_HEAD, e._processToken(t);
}
function qnt(e, t) {
  switch (t.tagID) {
    case Ee.HTML: {
      p3(e, t);
      break;
    }
    case Ee.BASEFONT:
    case Ee.BGSOUND:
    case Ee.HEAD:
    case Ee.LINK:
    case Ee.META:
    case Ee.NOFRAMES:
    case Ee.STYLE: {
      kA(e, t);
      break;
    }
    case Ee.NOSCRIPT: {
      e._err(t, Oi.nestedNoscriptInHead);
      break;
    }
    default:
      QJ(e, t);
  }
}
function $nt(e, t) {
  switch (t.tagID) {
    case Ee.NOSCRIPT: {
      e.openElements.pop(), e.insertionMode = zt.IN_HEAD;
      break;
    }
    case Ee.BR: {
      QJ(e, t);
      break;
    }
    default:
      e._err(t, Oi.endTagWithoutMatchingOpenElement);
  }
}
function QJ(e, t) {
  const i = t.type === $o.EOF ? Oi.openElementsLeftAfterEof : Oi.disallowedContentInNoscriptInHead;
  e._err(t, i), e.openElements.pop(), e.insertionMode = zt.IN_HEAD, e._processToken(t);
}
function Knt(e, t) {
  switch (t.tagID) {
    case Ee.HTML: {
      p3(e, t);
      break;
    }
    case Ee.BODY: {
      e._insertElement(t, en.HTML), e.framesetOk = !1, e.insertionMode = zt.IN_BODY;
      break;
    }
    case Ee.FRAMESET: {
      e._insertElement(t, en.HTML), e.insertionMode = zt.IN_FRAMESET;
      break;
    }
    case Ee.BASE:
    case Ee.BASEFONT:
    case Ee.BGSOUND:
    case Ee.LINK:
    case Ee.META:
    case Ee.NOFRAMES:
    case Ee.SCRIPT:
    case Ee.STYLE:
    case Ee.TEMPLATE:
    case Ee.TITLE: {
      e._err(t, Oi.abandonedHeadElementChild), e.openElements.push(e.headElement, Ee.HEAD), kA(e, t), e.openElements.remove(e.headElement);
      break;
    }
    case Ee.HEAD: {
      e._err(t, Oi.misplacedStartTagForHeadElement);
      break;
    }
    default:
      JJ(e, t);
  }
}
function Znt(e, t) {
  switch (t.tagID) {
    case Ee.BODY:
    case Ee.HTML:
    case Ee.BR: {
      JJ(e, t);
      break;
    }
    case Ee.TEMPLATE: {
      UH(e, t);
      break;
    }
    default:
      e._err(t, Oi.endTagWithoutMatchingOpenElement);
  }
}
function JJ(e, t) {
  e._insertFakeElement(fi.BODY, Ee.BODY), e.insertionMode = zt.IN_BODY, Bue(e, t);
}
function Bue(e, t) {
  switch (t.type) {
    case $o.CHARACTER: {
      a6e(e, t);
      break;
    }
    case $o.WHITESPACE_CHARACTER: {
      l6e(e, t);
      break;
    }
    case $o.COMMENT: {
      cpe(e, t);
      break;
    }
    case $o.START_TAG: {
      p3(e, t);
      break;
    }
    case $o.END_TAG: {
      Fue(e, t);
      break;
    }
    case $o.EOF: {
      h6e(e, t);
      break;
    }
  }
}
function l6e(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t);
}
function a6e(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t), e.framesetOk = !1;
}
function Qnt(e, t) {
  e.openElements.tmplCount === 0 && e.treeAdapter.adoptAttributes(e.openElements.items[0], t.attrs);
}
function Jnt(e, t) {
  const i = e.openElements.tryPeekProperlyNestedBodyElement();
  i && e.openElements.tmplCount === 0 && (e.framesetOk = !1, e.treeAdapter.adoptAttributes(i, t.attrs));
}
function Xnt(e, t) {
  const i = e.openElements.tryPeekProperlyNestedBodyElement();
  e.framesetOk && i && (e.treeAdapter.detachNode(i), e.openElements.popAllUpToHtmlElement(), e._insertElement(t, en.HTML), e.insertionMode = zt.IN_FRAMESET);
}
function est(e, t) {
  e.openElements.hasInButtonScope(Ee.P) && e._closePElement(), e._insertElement(t, en.HTML);
}
function tst(e, t) {
  e.openElements.hasInButtonScope(Ee.P) && e._closePElement(), e.openElements.currentTagId !== void 0 && dpe.has(e.openElements.currentTagId) && e.openElements.pop(), e._insertElement(t, en.HTML);
}
function ist(e, t) {
  e.openElements.hasInButtonScope(Ee.P) && e._closePElement(), e._insertElement(t, en.HTML), e.skipNextNewLine = !0, e.framesetOk = !1;
}
function nst(e, t) {
  const i = e.openElements.tmplCount > 0;
  (!e.formElement || i) && (e.openElements.hasInButtonScope(Ee.P) && e._closePElement(), e._insertElement(t, en.HTML), i || (e.formElement = e.openElements.current));
}
function sst(e, t) {
  e.framesetOk = !1;
  const i = t.tagID;
  for (let n = e.openElements.stackTop; n >= 0; n--) {
    const s = e.openElements.tagIDs[n];
    if (i === Ee.LI && s === Ee.LI || (i === Ee.DD || i === Ee.DT) && (s === Ee.DD || s === Ee.DT)) {
      e.openElements.generateImpliedEndTagsWithExclusion(s), e.openElements.popUntilTagNamePopped(s);
      break;
    }
    if (s !== Ee.ADDRESS && s !== Ee.DIV && s !== Ee.P && e._isSpecialElement(e.openElements.items[n], s))
      break;
  }
  e.openElements.hasInButtonScope(Ee.P) && e._closePElement(), e._insertElement(t, en.HTML);
}
function ost(e, t) {
  e.openElements.hasInButtonScope(Ee.P) && e._closePElement(), e._insertElement(t, en.HTML), e.tokenizer.state = d0.PLAINTEXT;
}
function rst(e, t) {
  e.openElements.hasInScope(Ee.BUTTON) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(Ee.BUTTON)), e._reconstructActiveFormattingElements(), e._insertElement(t, en.HTML), e.framesetOk = !1;
}
function lst(e, t) {
  const i = e.activeFormattingElements.getElementEntryInScopeWithTagName(fi.A);
  i && (a3e(e, t), e.openElements.remove(i.element), e.activeFormattingElements.removeEntry(i)), e._reconstructActiveFormattingElements(), e._insertElement(t, en.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function ast(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, en.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function ust(e, t) {
  e._reconstructActiveFormattingElements(), e.openElements.hasInScope(Ee.NOBR) && (a3e(e, t), e._reconstructActiveFormattingElements()), e._insertElement(t, en.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function dst(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, en.HTML), e.activeFormattingElements.insertMarker(), e.framesetOk = !1;
}
function cst(e, t) {
  e.treeAdapter.getDocumentMode(e.document) !== u5.QUIRKS && e.openElements.hasInButtonScope(Ee.P) && e._closePElement(), e._insertElement(t, en.HTML), e.framesetOk = !1, e.insertionMode = zt.IN_TABLE;
}
function u6e(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, en.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function d6e(e) {
  const t = JNe(e, zF.TYPE);
  return t != null && t.toLowerCase() === Cnt;
}
function hst(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, en.HTML), d6e(t) || (e.framesetOk = !1), t.ackSelfClosing = !0;
}
function fst(e, t) {
  e._appendElement(t, en.HTML), t.ackSelfClosing = !0;
}
function Ist(e, t) {
  e.openElements.hasInButtonScope(Ee.P) && e._closePElement(), e._appendElement(t, en.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function pst(e, t) {
  t.tagName = fi.IMG, t.tagID = Ee.IMG, u6e(e, t);
}
function mst(e, t) {
  e._insertElement(t, en.HTML), e.skipNextNewLine = !0, e.tokenizer.state = d0.RCDATA, e.originalInsertionMode = e.insertionMode, e.framesetOk = !1, e.insertionMode = zt.TEXT;
}
function yst(e, t) {
  e.openElements.hasInButtonScope(Ee.P) && e._closePElement(), e._reconstructActiveFormattingElements(), e.framesetOk = !1, e._switchToTextParsing(t, d0.RAWTEXT);
}
function Est(e, t) {
  e.framesetOk = !1, e._switchToTextParsing(t, d0.RAWTEXT);
}
function B4e(e, t) {
  e._switchToTextParsing(t, d0.RAWTEXT);
}
function gst(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, en.HTML), e.framesetOk = !1, e.insertionMode = e.insertionMode === zt.IN_TABLE || e.insertionMode === zt.IN_CAPTION || e.insertionMode === zt.IN_TABLE_BODY || e.insertionMode === zt.IN_ROW || e.insertionMode === zt.IN_CELL ? zt.IN_SELECT_IN_TABLE : zt.IN_SELECT;
}
function wst(e, t) {
  e.openElements.currentTagId === Ee.OPTION && e.openElements.pop(), e._reconstructActiveFormattingElements(), e._insertElement(t, en.HTML);
}
function Tst(e, t) {
  e.openElements.hasInScope(Ee.RUBY) && e.openElements.generateImpliedEndTags(), e._insertElement(t, en.HTML);
}
function Rst(e, t) {
  e.openElements.hasInScope(Ee.RUBY) && e.openElements.generateImpliedEndTagsWithExclusion(Ee.RTC), e._insertElement(t, en.HTML);
}
function vst(e, t) {
  e._reconstructActiveFormattingElements(), s6e(t), l3e(t), t.selfClosing ? e._appendElement(t, en.MATHML) : e._insertElement(t, en.MATHML), t.ackSelfClosing = !0;
}
function Ast(e, t) {
  e._reconstructActiveFormattingElements(), o6e(t), l3e(t), t.selfClosing ? e._appendElement(t, en.SVG) : e._insertElement(t, en.SVG), t.ackSelfClosing = !0;
}
function F4e(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, en.HTML);
}
function p3(e, t) {
  switch (t.tagID) {
    case Ee.I:
    case Ee.S:
    case Ee.B:
    case Ee.U:
    case Ee.EM:
    case Ee.TT:
    case Ee.BIG:
    case Ee.CODE:
    case Ee.FONT:
    case Ee.SMALL:
    case Ee.STRIKE:
    case Ee.STRONG: {
      ast(e, t);
      break;
    }
    case Ee.A: {
      lst(e, t);
      break;
    }
    case Ee.H1:
    case Ee.H2:
    case Ee.H3:
    case Ee.H4:
    case Ee.H5:
    case Ee.H6: {
      tst(e, t);
      break;
    }
    case Ee.P:
    case Ee.DL:
    case Ee.OL:
    case Ee.UL:
    case Ee.DIV:
    case Ee.DIR:
    case Ee.NAV:
    case Ee.MAIN:
    case Ee.MENU:
    case Ee.ASIDE:
    case Ee.CENTER:
    case Ee.FIGURE:
    case Ee.FOOTER:
    case Ee.HEADER:
    case Ee.HGROUP:
    case Ee.DIALOG:
    case Ee.DETAILS:
    case Ee.ADDRESS:
    case Ee.ARTICLE:
    case Ee.SEARCH:
    case Ee.SECTION:
    case Ee.SUMMARY:
    case Ee.FIELDSET:
    case Ee.BLOCKQUOTE:
    case Ee.FIGCAPTION: {
      est(e, t);
      break;
    }
    case Ee.LI:
    case Ee.DD:
    case Ee.DT: {
      sst(e, t);
      break;
    }
    case Ee.BR:
    case Ee.IMG:
    case Ee.WBR:
    case Ee.AREA:
    case Ee.EMBED:
    case Ee.KEYGEN: {
      u6e(e, t);
      break;
    }
    case Ee.HR: {
      Ist(e, t);
      break;
    }
    case Ee.RB:
    case Ee.RTC: {
      Tst(e, t);
      break;
    }
    case Ee.RT:
    case Ee.RP: {
      Rst(e, t);
      break;
    }
    case Ee.PRE:
    case Ee.LISTING: {
      ist(e, t);
      break;
    }
    case Ee.XMP: {
      yst(e, t);
      break;
    }
    case Ee.SVG: {
      Ast(e, t);
      break;
    }
    case Ee.HTML: {
      Qnt(e, t);
      break;
    }
    case Ee.BASE:
    case Ee.LINK:
    case Ee.META:
    case Ee.STYLE:
    case Ee.TITLE:
    case Ee.SCRIPT:
    case Ee.BGSOUND:
    case Ee.BASEFONT:
    case Ee.TEMPLATE: {
      kA(e, t);
      break;
    }
    case Ee.BODY: {
      Jnt(e, t);
      break;
    }
    case Ee.FORM: {
      nst(e, t);
      break;
    }
    case Ee.NOBR: {
      ust(e, t);
      break;
    }
    case Ee.MATH: {
      vst(e, t);
      break;
    }
    case Ee.TABLE: {
      cst(e, t);
      break;
    }
    case Ee.INPUT: {
      hst(e, t);
      break;
    }
    case Ee.PARAM:
    case Ee.TRACK:
    case Ee.SOURCE: {
      fst(e, t);
      break;
    }
    case Ee.IMAGE: {
      pst(e, t);
      break;
    }
    case Ee.BUTTON: {
      rst(e, t);
      break;
    }
    case Ee.APPLET:
    case Ee.OBJECT:
    case Ee.MARQUEE: {
      dst(e, t);
      break;
    }
    case Ee.IFRAME: {
      Est(e, t);
      break;
    }
    case Ee.SELECT: {
      gst(e, t);
      break;
    }
    case Ee.OPTION:
    case Ee.OPTGROUP: {
      wst(e, t);
      break;
    }
    case Ee.NOEMBED:
    case Ee.NOFRAMES: {
      B4e(e, t);
      break;
    }
    case Ee.FRAMESET: {
      Xnt(e, t);
      break;
    }
    case Ee.TEXTAREA: {
      mst(e, t);
      break;
    }
    case Ee.NOSCRIPT: {
      e.options.scriptingEnabled ? B4e(e, t) : F4e(e, t);
      break;
    }
    case Ee.PLAINTEXT: {
      ost(e, t);
      break;
    }
    case Ee.COL:
    case Ee.TH:
    case Ee.TD:
    case Ee.TR:
    case Ee.HEAD:
    case Ee.FRAME:
    case Ee.TBODY:
    case Ee.TFOOT:
    case Ee.THEAD:
    case Ee.CAPTION:
    case Ee.COLGROUP:
      break;
    default:
      F4e(e, t);
  }
}
function Sst(e, t) {
  if (e.openElements.hasInScope(Ee.BODY) && (e.insertionMode = zt.AFTER_BODY, e.options.sourceCodeLocationInfo)) {
    const i = e.openElements.tryPeekProperlyNestedBodyElement();
    i && e._setEndLocation(i, t);
  }
}
function bst(e, t) {
  e.openElements.hasInScope(Ee.BODY) && (e.insertionMode = zt.AFTER_BODY, w6e(e, t));
}
function Nst(e, t) {
  const i = t.tagID;
  e.openElements.hasInScope(i) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(i));
}
function Dst(e) {
  const t = e.openElements.tmplCount > 0, { formElement: i } = e;
  t || (e.formElement = null), (i || t) && e.openElements.hasInScope(Ee.FORM) && (e.openElements.generateImpliedEndTags(), t ? e.openElements.popUntilTagNamePopped(Ee.FORM) : i && e.openElements.remove(i));
}
function Cst(e) {
  e.openElements.hasInButtonScope(Ee.P) || e._insertFakeElement(fi.P, Ee.P), e._closePElement();
}
function Ost(e) {
  e.openElements.hasInListItemScope(Ee.LI) && (e.openElements.generateImpliedEndTagsWithExclusion(Ee.LI), e.openElements.popUntilTagNamePopped(Ee.LI));
}
function Lst(e, t) {
  const i = t.tagID;
  e.openElements.hasInScope(i) && (e.openElements.generateImpliedEndTagsWithExclusion(i), e.openElements.popUntilTagNamePopped(i));
}
function _st(e) {
  e.openElements.hasNumberedHeaderInScope() && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilNumberedHeaderPopped());
}
function xst(e, t) {
  const i = t.tagID;
  e.openElements.hasInScope(i) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(i), e.activeFormattingElements.clearToLastMarker());
}
function Pst(e) {
  e._reconstructActiveFormattingElements(), e._insertFakeElement(fi.BR, Ee.BR), e.openElements.pop(), e.framesetOk = !1;
}
function c6e(e, t) {
  const i = t.tagName, n = t.tagID;
  for (let s = e.openElements.stackTop; s > 0; s--) {
    const o = e.openElements.items[s], r = e.openElements.tagIDs[s];
    if (n === r && (n !== Ee.UNKNOWN || e.treeAdapter.getTagName(o) === i)) {
      e.openElements.generateImpliedEndTagsWithExclusion(n), e.openElements.stackTop >= s && e.openElements.shortenToLength(s);
      break;
    }
    if (e._isSpecialElement(o, r))
      break;
  }
}
function Fue(e, t) {
  switch (t.tagID) {
    case Ee.A:
    case Ee.B:
    case Ee.I:
    case Ee.S:
    case Ee.U:
    case Ee.EM:
    case Ee.TT:
    case Ee.BIG:
    case Ee.CODE:
    case Ee.FONT:
    case Ee.NOBR:
    case Ee.SMALL:
    case Ee.STRIKE:
    case Ee.STRONG: {
      a3e(e, t);
      break;
    }
    case Ee.P: {
      Cst(e);
      break;
    }
    case Ee.DL:
    case Ee.UL:
    case Ee.OL:
    case Ee.DIR:
    case Ee.DIV:
    case Ee.NAV:
    case Ee.PRE:
    case Ee.MAIN:
    case Ee.MENU:
    case Ee.ASIDE:
    case Ee.BUTTON:
    case Ee.CENTER:
    case Ee.FIGURE:
    case Ee.FOOTER:
    case Ee.HEADER:
    case Ee.HGROUP:
    case Ee.DIALOG:
    case Ee.ADDRESS:
    case Ee.ARTICLE:
    case Ee.DETAILS:
    case Ee.SEARCH:
    case Ee.SECTION:
    case Ee.SUMMARY:
    case Ee.LISTING:
    case Ee.FIELDSET:
    case Ee.BLOCKQUOTE:
    case Ee.FIGCAPTION: {
      Nst(e, t);
      break;
    }
    case Ee.LI: {
      Ost(e);
      break;
    }
    case Ee.DD:
    case Ee.DT: {
      Lst(e, t);
      break;
    }
    case Ee.H1:
    case Ee.H2:
    case Ee.H3:
    case Ee.H4:
    case Ee.H5:
    case Ee.H6: {
      _st(e);
      break;
    }
    case Ee.BR: {
      Pst(e);
      break;
    }
    case Ee.BODY: {
      Sst(e, t);
      break;
    }
    case Ee.HTML: {
      bst(e, t);
      break;
    }
    case Ee.FORM: {
      Dst(e);
      break;
    }
    case Ee.APPLET:
    case Ee.OBJECT:
    case Ee.MARQUEE: {
      xst(e, t);
      break;
    }
    case Ee.TEMPLATE: {
      UH(e, t);
      break;
    }
    default:
      c6e(e, t);
  }
}
function h6e(e, t) {
  e.tmplInsertionModeStack.length > 0 ? g6e(e, t) : u3e(e, t);
}
function Mst(e, t) {
  var i;
  t.tagID === Ee.SCRIPT && ((i = e.scriptHandler) === null || i === void 0 || i.call(e, e.openElements.current)), e.openElements.pop(), e.insertionMode = e.originalInsertionMode;
}
function Ust(e, t) {
  e._err(t, Oi.eofInElementThatCanContainOnlyText), e.openElements.pop(), e.insertionMode = e.originalInsertionMode, e.onEof(t);
}
function r0e(e, t) {
  if (e.openElements.currentTagId !== void 0 && r6e.has(e.openElements.currentTagId))
    switch (e.pendingCharacterTokens.length = 0, e.hasNonWhitespacePendingCharacterToken = !1, e.originalInsertionMode = e.insertionMode, e.insertionMode = zt.IN_TABLE_TEXT, t.type) {
      case $o.CHARACTER: {
        I6e(e, t);
        break;
      }
      case $o.WHITESPACE_CHARACTER: {
        f6e(e, t);
        break;
      }
    }
  else
    jie(e, t);
}
function Bst(e, t) {
  e.openElements.clearBackToTableContext(), e.activeFormattingElements.insertMarker(), e._insertElement(t, en.HTML), e.insertionMode = zt.IN_CAPTION;
}
function Fst(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, en.HTML), e.insertionMode = zt.IN_COLUMN_GROUP;
}
function Hst(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(fi.COLGROUP, Ee.COLGROUP), e.insertionMode = zt.IN_COLUMN_GROUP, d3e(e, t);
}
function Gst(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, en.HTML), e.insertionMode = zt.IN_TABLE_BODY;
}
function kst(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(fi.TBODY, Ee.TBODY), e.insertionMode = zt.IN_TABLE_BODY, Hue(e, t);
}
function Vst(e, t) {
  e.openElements.hasInTableScope(Ee.TABLE) && (e.openElements.popUntilTagNamePopped(Ee.TABLE), e._resetInsertionMode(), e._processStartTag(t));
}
function zst(e, t) {
  d6e(t) ? e._appendElement(t, en.HTML) : jie(e, t), t.ackSelfClosing = !0;
}
function jst(e, t) {
  !e.formElement && e.openElements.tmplCount === 0 && (e._insertElement(t, en.HTML), e.formElement = e.openElements.current, e.openElements.pop());
}
function ZW(e, t) {
  switch (t.tagID) {
    case Ee.TD:
    case Ee.TH:
    case Ee.TR: {
      kst(e, t);
      break;
    }
    case Ee.STYLE:
    case Ee.SCRIPT:
    case Ee.TEMPLATE: {
      kA(e, t);
      break;
    }
    case Ee.COL: {
      Hst(e, t);
      break;
    }
    case Ee.FORM: {
      jst(e, t);
      break;
    }
    case Ee.TABLE: {
      Vst(e, t);
      break;
    }
    case Ee.TBODY:
    case Ee.TFOOT:
    case Ee.THEAD: {
      Gst(e, t);
      break;
    }
    case Ee.INPUT: {
      zst(e, t);
      break;
    }
    case Ee.CAPTION: {
      Bst(e, t);
      break;
    }
    case Ee.COLGROUP: {
      Fst(e, t);
      break;
    }
    default:
      jie(e, t);
  }
}
function jX(e, t) {
  switch (t.tagID) {
    case Ee.TABLE: {
      e.openElements.hasInTableScope(Ee.TABLE) && (e.openElements.popUntilTagNamePopped(Ee.TABLE), e._resetInsertionMode());
      break;
    }
    case Ee.TEMPLATE: {
      UH(e, t);
      break;
    }
    case Ee.BODY:
    case Ee.CAPTION:
    case Ee.COL:
    case Ee.COLGROUP:
    case Ee.HTML:
    case Ee.TBODY:
    case Ee.TD:
    case Ee.TFOOT:
    case Ee.TH:
    case Ee.THEAD:
    case Ee.TR:
      break;
    default:
      jie(e, t);
  }
}
function jie(e, t) {
  const i = e.fosterParentingEnabled;
  e.fosterParentingEnabled = !0, Bue(e, t), e.fosterParentingEnabled = i;
}
function f6e(e, t) {
  e.pendingCharacterTokens.push(t);
}
function I6e(e, t) {
  e.pendingCharacterTokens.push(t), e.hasNonWhitespacePendingCharacterToken = !0;
}
function ZZ(e, t) {
  let i = 0;
  if (e.hasNonWhitespacePendingCharacterToken)
    for (; i < e.pendingCharacterTokens.length; i++)
      jie(e, e.pendingCharacterTokens[i]);
  else
    for (; i < e.pendingCharacterTokens.length; i++)
      e._insertCharacters(e.pendingCharacterTokens[i]);
  e.insertionMode = e.originalInsertionMode, e._processToken(t);
}
const p6e = /* @__PURE__ */ new Set([Ee.CAPTION, Ee.COL, Ee.COLGROUP, Ee.TBODY, Ee.TD, Ee.TFOOT, Ee.TH, Ee.THEAD, Ee.TR]);
function Wst(e, t) {
  const i = t.tagID;
  p6e.has(i) ? e.openElements.hasInTableScope(Ee.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(Ee.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = zt.IN_TABLE, ZW(e, t)) : p3(e, t);
}
function Yst(e, t) {
  const i = t.tagID;
  switch (i) {
    case Ee.CAPTION:
    case Ee.TABLE: {
      e.openElements.hasInTableScope(Ee.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(Ee.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = zt.IN_TABLE, i === Ee.TABLE && jX(e, t));
      break;
    }
    case Ee.BODY:
    case Ee.COL:
    case Ee.COLGROUP:
    case Ee.HTML:
    case Ee.TBODY:
    case Ee.TD:
    case Ee.TFOOT:
    case Ee.TH:
    case Ee.THEAD:
    case Ee.TR:
      break;
    default:
      Fue(e, t);
  }
}
function d3e(e, t) {
  switch (t.tagID) {
    case Ee.HTML: {
      p3(e, t);
      break;
    }
    case Ee.COL: {
      e._appendElement(t, en.HTML), t.ackSelfClosing = !0;
      break;
    }
    case Ee.TEMPLATE: {
      kA(e, t);
      break;
    }
    default:
      Ble(e, t);
  }
}
function qst(e, t) {
  switch (t.tagID) {
    case Ee.COLGROUP: {
      e.openElements.currentTagId === Ee.COLGROUP && (e.openElements.pop(), e.insertionMode = zt.IN_TABLE);
      break;
    }
    case Ee.TEMPLATE: {
      UH(e, t);
      break;
    }
    case Ee.COL:
      break;
    default:
      Ble(e, t);
  }
}
function Ble(e, t) {
  e.openElements.currentTagId === Ee.COLGROUP && (e.openElements.pop(), e.insertionMode = zt.IN_TABLE, e._processToken(t));
}
function Hue(e, t) {
  switch (t.tagID) {
    case Ee.TR: {
      e.openElements.clearBackToTableBodyContext(), e._insertElement(t, en.HTML), e.insertionMode = zt.IN_ROW;
      break;
    }
    case Ee.TH:
    case Ee.TD: {
      e.openElements.clearBackToTableBodyContext(), e._insertFakeElement(fi.TR, Ee.TR), e.insertionMode = zt.IN_ROW, Gue(e, t);
      break;
    }
    case Ee.CAPTION:
    case Ee.COL:
    case Ee.COLGROUP:
    case Ee.TBODY:
    case Ee.TFOOT:
    case Ee.THEAD: {
      e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = zt.IN_TABLE, ZW(e, t));
      break;
    }
    default:
      ZW(e, t);
  }
}
function hpe(e, t) {
  const i = t.tagID;
  switch (t.tagID) {
    case Ee.TBODY:
    case Ee.TFOOT:
    case Ee.THEAD: {
      e.openElements.hasInTableScope(i) && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = zt.IN_TABLE);
      break;
    }
    case Ee.TABLE: {
      e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = zt.IN_TABLE, jX(e, t));
      break;
    }
    case Ee.BODY:
    case Ee.CAPTION:
    case Ee.COL:
    case Ee.COLGROUP:
    case Ee.HTML:
    case Ee.TD:
    case Ee.TH:
    case Ee.TR:
      break;
    default:
      jX(e, t);
  }
}
function Gue(e, t) {
  switch (t.tagID) {
    case Ee.TH:
    case Ee.TD: {
      e.openElements.clearBackToTableRowContext(), e._insertElement(t, en.HTML), e.insertionMode = zt.IN_CELL, e.activeFormattingElements.insertMarker();
      break;
    }
    case Ee.CAPTION:
    case Ee.COL:
    case Ee.COLGROUP:
    case Ee.TBODY:
    case Ee.TFOOT:
    case Ee.THEAD:
    case Ee.TR: {
      e.openElements.hasInTableScope(Ee.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = zt.IN_TABLE_BODY, Hue(e, t));
      break;
    }
    default:
      ZW(e, t);
  }
}
function m6e(e, t) {
  switch (t.tagID) {
    case Ee.TR: {
      e.openElements.hasInTableScope(Ee.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = zt.IN_TABLE_BODY);
      break;
    }
    case Ee.TABLE: {
      e.openElements.hasInTableScope(Ee.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = zt.IN_TABLE_BODY, hpe(e, t));
      break;
    }
    case Ee.TBODY:
    case Ee.TFOOT:
    case Ee.THEAD: {
      (e.openElements.hasInTableScope(t.tagID) || e.openElements.hasInTableScope(Ee.TR)) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = zt.IN_TABLE_BODY, hpe(e, t));
      break;
    }
    case Ee.BODY:
    case Ee.CAPTION:
    case Ee.COL:
    case Ee.COLGROUP:
    case Ee.HTML:
    case Ee.TD:
    case Ee.TH:
      break;
    default:
      jX(e, t);
  }
}
function $st(e, t) {
  const i = t.tagID;
  p6e.has(i) ? (e.openElements.hasInTableScope(Ee.TD) || e.openElements.hasInTableScope(Ee.TH)) && (e._closeTableCell(), Gue(e, t)) : p3(e, t);
}
function Kst(e, t) {
  const i = t.tagID;
  switch (i) {
    case Ee.TD:
    case Ee.TH: {
      e.openElements.hasInTableScope(i) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(i), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = zt.IN_ROW);
      break;
    }
    case Ee.TABLE:
    case Ee.TBODY:
    case Ee.TFOOT:
    case Ee.THEAD:
    case Ee.TR: {
      e.openElements.hasInTableScope(i) && (e._closeTableCell(), m6e(e, t));
      break;
    }
    case Ee.BODY:
    case Ee.CAPTION:
    case Ee.COL:
    case Ee.COLGROUP:
    case Ee.HTML:
      break;
    default:
      Fue(e, t);
  }
}
function y6e(e, t) {
  switch (t.tagID) {
    case Ee.HTML: {
      p3(e, t);
      break;
    }
    case Ee.OPTION: {
      e.openElements.currentTagId === Ee.OPTION && e.openElements.pop(), e._insertElement(t, en.HTML);
      break;
    }
    case Ee.OPTGROUP: {
      e.openElements.currentTagId === Ee.OPTION && e.openElements.pop(), e.openElements.currentTagId === Ee.OPTGROUP && e.openElements.pop(), e._insertElement(t, en.HTML);
      break;
    }
    case Ee.HR: {
      e.openElements.currentTagId === Ee.OPTION && e.openElements.pop(), e.openElements.currentTagId === Ee.OPTGROUP && e.openElements.pop(), e._appendElement(t, en.HTML), t.ackSelfClosing = !0;
      break;
    }
    case Ee.INPUT:
    case Ee.KEYGEN:
    case Ee.TEXTAREA:
    case Ee.SELECT: {
      e.openElements.hasInSelectScope(Ee.SELECT) && (e.openElements.popUntilTagNamePopped(Ee.SELECT), e._resetInsertionMode(), t.tagID !== Ee.SELECT && e._processStartTag(t));
      break;
    }
    case Ee.SCRIPT:
    case Ee.TEMPLATE: {
      kA(e, t);
      break;
    }
  }
}
function E6e(e, t) {
  switch (t.tagID) {
    case Ee.OPTGROUP: {
      e.openElements.stackTop > 0 && e.openElements.currentTagId === Ee.OPTION && e.openElements.tagIDs[e.openElements.stackTop - 1] === Ee.OPTGROUP && e.openElements.pop(), e.openElements.currentTagId === Ee.OPTGROUP && e.openElements.pop();
      break;
    }
    case Ee.OPTION: {
      e.openElements.currentTagId === Ee.OPTION && e.openElements.pop();
      break;
    }
    case Ee.SELECT: {
      e.openElements.hasInSelectScope(Ee.SELECT) && (e.openElements.popUntilTagNamePopped(Ee.SELECT), e._resetInsertionMode());
      break;
    }
    case Ee.TEMPLATE: {
      UH(e, t);
      break;
    }
  }
}
function Zst(e, t) {
  const i = t.tagID;
  i === Ee.CAPTION || i === Ee.TABLE || i === Ee.TBODY || i === Ee.TFOOT || i === Ee.THEAD || i === Ee.TR || i === Ee.TD || i === Ee.TH ? (e.openElements.popUntilTagNamePopped(Ee.SELECT), e._resetInsertionMode(), e._processStartTag(t)) : y6e(e, t);
}
function Qst(e, t) {
  const i = t.tagID;
  i === Ee.CAPTION || i === Ee.TABLE || i === Ee.TBODY || i === Ee.TFOOT || i === Ee.THEAD || i === Ee.TR || i === Ee.TD || i === Ee.TH ? e.openElements.hasInTableScope(i) && (e.openElements.popUntilTagNamePopped(Ee.SELECT), e._resetInsertionMode(), e.onEndTag(t)) : E6e(e, t);
}
function Jst(e, t) {
  switch (t.tagID) {
    // First, handle tags that can start without a mode change
    case Ee.BASE:
    case Ee.BASEFONT:
    case Ee.BGSOUND:
    case Ee.LINK:
    case Ee.META:
    case Ee.NOFRAMES:
    case Ee.SCRIPT:
    case Ee.STYLE:
    case Ee.TEMPLATE:
    case Ee.TITLE: {
      kA(e, t);
      break;
    }
    // Re-process the token in the appropriate mode
    case Ee.CAPTION:
    case Ee.COLGROUP:
    case Ee.TBODY:
    case Ee.TFOOT:
    case Ee.THEAD: {
      e.tmplInsertionModeStack[0] = zt.IN_TABLE, e.insertionMode = zt.IN_TABLE, ZW(e, t);
      break;
    }
    case Ee.COL: {
      e.tmplInsertionModeStack[0] = zt.IN_COLUMN_GROUP, e.insertionMode = zt.IN_COLUMN_GROUP, d3e(e, t);
      break;
    }
    case Ee.TR: {
      e.tmplInsertionModeStack[0] = zt.IN_TABLE_BODY, e.insertionMode = zt.IN_TABLE_BODY, Hue(e, t);
      break;
    }
    case Ee.TD:
    case Ee.TH: {
      e.tmplInsertionModeStack[0] = zt.IN_ROW, e.insertionMode = zt.IN_ROW, Gue(e, t);
      break;
    }
    default:
      e.tmplInsertionModeStack[0] = zt.IN_BODY, e.insertionMode = zt.IN_BODY, p3(e, t);
  }
}
function Xst(e, t) {
  t.tagID === Ee.TEMPLATE && UH(e, t);
}
function g6e(e, t) {
  e.openElements.tmplCount > 0 ? (e.openElements.popUntilTagNamePopped(Ee.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e.tmplInsertionModeStack.shift(), e._resetInsertionMode(), e.onEof(t)) : u3e(e, t);
}
function eot(e, t) {
  t.tagID === Ee.HTML ? p3(e, t) : Fle(e, t);
}
function w6e(e, t) {
  var i;
  if (t.tagID === Ee.HTML) {
    if (e.fragmentContext || (e.insertionMode = zt.AFTER_AFTER_BODY), e.options.sourceCodeLocationInfo && e.openElements.tagIDs[0] === Ee.HTML) {
      e._setEndLocation(e.openElements.items[0], t);
      const n = e.openElements.items[1];
      n && !(!((i = e.treeAdapter.getNodeSourceCodeLocation(n)) === null || i === void 0) && i.endTag) && e._setEndLocation(n, t);
    }
  } else
    Fle(e, t);
}
function Fle(e, t) {
  e.insertionMode = zt.IN_BODY, Bue(e, t);
}
function tot(e, t) {
  switch (t.tagID) {
    case Ee.HTML: {
      p3(e, t);
      break;
    }
    case Ee.FRAMESET: {
      e._insertElement(t, en.HTML);
      break;
    }
    case Ee.FRAME: {
      e._appendElement(t, en.HTML), t.ackSelfClosing = !0;
      break;
    }
    case Ee.NOFRAMES: {
      kA(e, t);
      break;
    }
  }
}
function iot(e, t) {
  t.tagID === Ee.FRAMESET && !e.openElements.isRootHtmlElementCurrent() && (e.openElements.pop(), !e.fragmentContext && e.openElements.currentTagId !== Ee.FRAMESET && (e.insertionMode = zt.AFTER_FRAMESET));
}
function not(e, t) {
  switch (t.tagID) {
    case Ee.HTML: {
      p3(e, t);
      break;
    }
    case Ee.NOFRAMES: {
      kA(e, t);
      break;
    }
  }
}
function sot(e, t) {
  t.tagID === Ee.HTML && (e.insertionMode = zt.AFTER_AFTER_FRAMESET);
}
function oot(e, t) {
  t.tagID === Ee.HTML ? p3(e, t) : Mre(e, t);
}
function Mre(e, t) {
  e.insertionMode = zt.IN_BODY, Bue(e, t);
}
function rot(e, t) {
  switch (t.tagID) {
    case Ee.HTML: {
      p3(e, t);
      break;
    }
    case Ee.NOFRAMES: {
      kA(e, t);
      break;
    }
  }
}
function lot(e, t) {
  t.chars = xu, e._insertCharacters(t);
}
function aot(e, t) {
  e._insertCharacters(t), e.framesetOk = !1;
}
function T6e(e) {
  for (; e.treeAdapter.getNamespaceURI(e.openElements.current) !== en.HTML && e.openElements.currentTagId !== void 0 && !e._isIntegrationPoint(e.openElements.currentTagId, e.openElements.current); )
    e.openElements.pop();
}
function uot(e, t) {
  if (Ant(t))
    T6e(e), e._startTagOutsideForeignContent(t);
  else {
    const i = e._getAdjustedCurrentElement(), n = e.treeAdapter.getNamespaceURI(i);
    n === en.MATHML ? s6e(t) : n === en.SVG && (Snt(t), o6e(t)), l3e(t), t.selfClosing ? e._appendElement(t, n) : e._insertElement(t, n), t.ackSelfClosing = !0;
  }
}
function dot(e, t) {
  if (t.tagID === Ee.P || t.tagID === Ee.BR) {
    T6e(e), e._endTagOutsideForeignContent(t);
    return;
  }
  for (let i = e.openElements.stackTop; i > 0; i--) {
    const n = e.openElements.items[i];
    if (e.treeAdapter.getNamespaceURI(n) === en.HTML) {
      e._endTagOutsideForeignContent(t);
      break;
    }
    const s = e.treeAdapter.getTagName(n);
    if (s.toLowerCase() === t.tagName) {
      t.tagName = s, e.openElements.shortenToLength(i);
      break;
    }
  }
}
fi.AREA, fi.BASE, fi.BASEFONT, fi.BGSOUND, fi.BR, fi.COL, fi.EMBED, fi.FRAME, fi.HR, fi.IMG, fi.INPUT, fi.KEYGEN, fi.LINK, fi.META, fi.PARAM, fi.SOURCE, fi.TRACK, fi.WBR;
const cot = /<(\/?)(iframe|noembed|noframes|plaintext|script|style|textarea|title|xmp)(?=[\t\n\f\r />])/gi, hot = /* @__PURE__ */ new Set([
  "mdxFlowExpression",
  "mdxJsxFlowElement",
  "mdxJsxTextElement",
  "mdxTextExpression",
  "mdxjsEsm"
]), H4e = { sourceCodeLocationInfo: !0, scriptingEnabled: !1 };
function R6e(e, t) {
  const i = Rot(e), n = qNe("type", {
    handlers: { root: fot, element: Iot, text: pot, comment: A6e, doctype: mot, raw: Eot },
    unknown: got
  }), s = {
    parser: i ? new U4e(H4e) : U4e.getFragmentParser(void 0, H4e),
    handle(l) {
      n(l, s);
    },
    stitches: !1,
    options: t || {}
  };
  n(e, s), IY(s, d6());
  const o = i ? s.parser.document : s.parser.getFragment(), r = vit(o, {
    // To do: support `space`?
    file: s.options.file
  });
  return s.stitches && Uue(r, "comment", function(l, c, h) {
    const I = (
      /** @type {Stitch} */
      /** @type {unknown} */
      l
    );
    if (I.value.stitch && h && c !== void 0) {
      const p = h.children;
      return p[c] = I.value.stitch, c;
    }
  }), r.type === "root" && r.children.length === 1 && r.children[0].type === e.type ? r.children[0] : r;
}
function v6e(e, t) {
  let i = -1;
  if (e)
    for (; ++i < e.length; )
      t.handle(e[i]);
}
function fot(e, t) {
  v6e(e.children, t);
}
function Iot(e, t) {
  wot(e, t), v6e(e.children, t), Tot(e, t);
}
function pot(e, t) {
  t.parser.tokenizer.state > 4 && (t.parser.tokenizer.state = 0);
  const i = {
    type: $o.CHARACTER,
    chars: e.value,
    location: Wie(e)
  };
  IY(t, d6(e)), t.parser.currentToken = i, t.parser._processToken(t.parser.currentToken);
}
function mot(e, t) {
  const i = {
    type: $o.DOCTYPE,
    name: "html",
    forceQuirks: !1,
    publicId: "",
    systemId: "",
    location: Wie(e)
  };
  IY(t, d6(e)), t.parser.currentToken = i, t.parser._processToken(t.parser.currentToken);
}
function yot(e, t) {
  t.stitches = !0;
  const i = vot(e);
  if ("children" in e && "children" in i) {
    const n = (
      /** @type {Root} */
      R6e({ type: "root", children: e.children }, t.options)
    );
    i.children = n.children;
  }
  A6e({ type: "comment", value: { stitch: i } }, t);
}
function A6e(e, t) {
  const i = e.value, n = {
    type: $o.COMMENT,
    data: i,
    location: Wie(e)
  };
  IY(t, d6(e)), t.parser.currentToken = n, t.parser._processToken(t.parser.currentToken);
}
function Eot(e, t) {
  if (t.parser.tokenizer.preprocessor.html = "", t.parser.tokenizer.preprocessor.pos = -1, t.parser.tokenizer.preprocessor.lastGapPos = -2, t.parser.tokenizer.preprocessor.gapStack = [], t.parser.tokenizer.preprocessor.skipNextNewLine = !1, t.parser.tokenizer.preprocessor.lastChunkWritten = !1, t.parser.tokenizer.preprocessor.endOfChunkHit = !1, t.parser.tokenizer.preprocessor.isEol = !1, S6e(t, d6(e)), t.parser.tokenizer.write(
    t.options.tagfilter ? e.value.replace(cot, "&lt;$1$2") : e.value,
    !1
  ), t.parser.tokenizer._runParsingLoop(), t.parser.tokenizer.state === 72 || // @ts-expect-error: removed.
  t.parser.tokenizer.state === 78) {
    t.parser.tokenizer.preprocessor.lastChunkWritten = !0;
    const i = t.parser.tokenizer._consume();
    t.parser.tokenizer._callState(i);
  }
}
function got(e, t) {
  const i = (
    /** @type {Nodes} */
    e
  );
  if (t.options.passThrough && t.options.passThrough.includes(i.type))
    yot(i, t);
  else {
    let n = "";
    throw hot.has(i.type) && (n = ". It looks like you are using MDX nodes with `hast-util-raw` (or `rehype-raw`). If you use this because you are using remark or rehype plugins that inject `'html'` nodes, then please raise an issue with that plugin, as its a bad and slow idea. If you use this because you are using markdown syntax, then you have to configure this utility (or plugin) to pass through these nodes (see `passThrough` in docs), but you can also migrate to use the MDX syntax"), new Error("Cannot compile `" + i.type + "` node" + n);
  }
}
function IY(e, t) {
  S6e(e, t);
  const i = e.parser.tokenizer.currentCharacterToken;
  i && i.location && (i.location.endLine = e.parser.tokenizer.preprocessor.line, i.location.endCol = e.parser.tokenizer.preprocessor.col + 1, i.location.endOffset = e.parser.tokenizer.preprocessor.offset + 1, e.parser.currentToken = i, e.parser._processToken(e.parser.currentToken)), e.parser.tokenizer.paused = !1, e.parser.tokenizer.inLoop = !1, e.parser.tokenizer.active = !1, e.parser.tokenizer.returnState = d0.DATA, e.parser.tokenizer.charRefCode = -1, e.parser.tokenizer.consumedAfterSnapshot = -1, e.parser.tokenizer.currentLocation = null, e.parser.tokenizer.currentCharacterToken = null, e.parser.tokenizer.currentToken = null, e.parser.tokenizer.currentAttr = { name: "", value: "" };
}
function S6e(e, t) {
  if (t && t.offset !== void 0) {
    const i = {
      startLine: t.line,
      startCol: t.column,
      startOffset: t.offset,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    };
    e.parser.tokenizer.preprocessor.lineStartPos = -t.column + 1, e.parser.tokenizer.preprocessor.droppedBufferSize = t.offset, e.parser.tokenizer.preprocessor.line = t.line, e.parser.tokenizer.currentLocation = i;
  }
}
function wot(e, t) {
  const i = e.tagName.toLowerCase();
  if (t.parser.tokenizer.state === d0.PLAINTEXT) return;
  IY(t, d6(e));
  const n = t.parser.openElements.current;
  let s = "namespaceURI" in n ? n.namespaceURI : fB.html;
  s === fB.html && i === "svg" && (s = fB.svg);
  const o = Dit(
    // Shallow clone to not delve into `children`: we only need the attributes.
    { ...e, children: [] },
    { space: s === fB.svg ? "svg" : "html" }
  ), r = {
    type: $o.START_TAG,
    tagName: i,
    tagID: fY(i),
    // We always send start and end tags.
    selfClosing: !1,
    ackSelfClosing: !1,
    // Always element.
    /* c8 ignore next */
    attrs: "attrs" in o ? o.attrs : [],
    location: Wie(e)
  };
  t.parser.currentToken = r, t.parser._processToken(t.parser.currentToken), t.parser.tokenizer.lastStartTagName = i;
}
function Tot(e, t) {
  const i = e.tagName.toLowerCase();
  if (!t.parser.tokenizer.inForeignNode && Uit.includes(i) || t.parser.tokenizer.state === d0.PLAINTEXT) return;
  IY(t, Oue(e));
  const n = {
    type: $o.END_TAG,
    tagName: i,
    tagID: fY(i),
    selfClosing: !1,
    ackSelfClosing: !1,
    attrs: [],
    location: Wie(e)
  };
  t.parser.currentToken = n, t.parser._processToken(t.parser.currentToken), // Current element is closed.
  i === t.parser.tokenizer.lastStartTagName && // `<textarea>` and `<title>`
  (t.parser.tokenizer.state === d0.RCDATA || // `<iframe>`, `<noembed>`, `<noframes>`, `<style>`, `<xmp>`
  t.parser.tokenizer.state === d0.RAWTEXT || // `<script>`
  t.parser.tokenizer.state === d0.SCRIPT_DATA) && (t.parser.tokenizer.state = d0.DATA);
}
function Rot(e) {
  const t = e.type === "root" ? e.children[0] : e;
  return !!(t && (t.type === "doctype" || t.type === "element" && t.tagName.toLowerCase() === "html"));
}
function Wie(e) {
  const t = d6(e) || {
    line: void 0,
    column: void 0,
    offset: void 0
  }, i = Oue(e) || {
    line: void 0,
    column: void 0,
    offset: void 0
  };
  return {
    startLine: t.line,
    startCol: t.column,
    startOffset: t.offset,
    endLine: i.line,
    endCol: i.column,
    endOffset: i.offset
  };
}
function vot(e) {
  return "children" in e ? KW({ ...e, children: [] }) : KW(e);
}
function Aot(e) {
  return function(t, i) {
    return (
      /** @type {Root} */
      R6e(t, { ...e, file: i })
    );
  };
}
function G4e(e, t) {
  const i = String(e);
  if (typeof t != "string")
    throw new TypeError("Expected character");
  let n = 0, s = i.indexOf(t);
  for (; s !== -1; )
    n++, s = i.indexOf(t, s + t.length);
  return n;
}
function Sot(e) {
  if (typeof e != "string")
    throw new TypeError("Expected a string");
  return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
function bot(e, t, i) {
  const s = Pue((i || {}).ignore || []), o = Not(t);
  let r = -1;
  for (; ++r < o.length; )
    VNe(e, "text", l);
  function l(h, I) {
    let p = -1, y;
    for (; ++p < I.length; ) {
      const m = I[p], A = y ? y.children : void 0;
      if (s(
        m,
        A ? A.indexOf(m) : void 0,
        y
      ))
        return;
      y = m;
    }
    if (y)
      return c(h, I);
  }
  function c(h, I) {
    const p = I[I.length - 1], y = o[r][0], m = o[r][1];
    let A = 0;
    const O = p.children.indexOf(h);
    let R = !1, F = [];
    y.lastIndex = 0;
    let L = y.exec(h.value);
    for (; L; ) {
      const P = L.index, z = {
        index: L.index,
        input: L.input,
        stack: [...I, h]
      };
      let W = m(...L, z);
      if (typeof W == "string" && (W = W.length > 0 ? { type: "text", value: W } : void 0), W === !1 ? y.lastIndex = P + 1 : (A !== P && F.push({
        type: "text",
        value: h.value.slice(A, P)
      }), Array.isArray(W) ? F.push(...W) : W && F.push(W), A = P + L[0].length, R = !0), !y.global)
        break;
      L = y.exec(h.value);
    }
    return R ? (A < h.value.length && F.push({ type: "text", value: h.value.slice(A) }), p.children.splice(O, 1, ...F)) : F = [h], O + F.length;
  }
}
function Not(e) {
  const t = [];
  if (!Array.isArray(e))
    throw new TypeError("Expected find and replace tuple or list of tuples");
  const i = !e[0] || Array.isArray(e[0]) ? e : [e];
  let n = -1;
  for (; ++n < i.length; ) {
    const s = i[n];
    t.push([Dot(s[0]), Cot(s[1])]);
  }
  return t;
}
function Dot(e) {
  return typeof e == "string" ? new RegExp(Sot(e), "g") : e;
}
function Cot(e) {
  return typeof e == "function" ? e : function() {
    return e;
  };
}
const l0e = "phrasing", a0e = ["autolink", "link", "image", "label"];
function Oot() {
  return {
    transforms: [Bot],
    enter: {
      literalAutolink: _ot,
      literalAutolinkEmail: u0e,
      literalAutolinkHttp: u0e,
      literalAutolinkWww: u0e
    },
    exit: {
      literalAutolink: Uot,
      literalAutolinkEmail: Mot,
      literalAutolinkHttp: xot,
      literalAutolinkWww: Pot
    }
  };
}
function Lot() {
  return {
    unsafe: [
      {
        character: "@",
        before: "[+\\-.\\w]",
        after: "[\\-.\\w]",
        inConstruct: l0e,
        notInConstruct: a0e
      },
      {
        character: ".",
        before: "[Ww]",
        after: "[\\-.\\w]",
        inConstruct: l0e,
        notInConstruct: a0e
      },
      {
        character: ":",
        before: "[ps]",
        after: "\\/",
        inConstruct: l0e,
        notInConstruct: a0e
      }
    ]
  };
}
function _ot(e) {
  this.enter({ type: "link", title: null, url: "", children: [] }, e);
}
function u0e(e) {
  this.config.enter.autolinkProtocol.call(this, e);
}
function xot(e) {
  this.config.exit.autolinkProtocol.call(this, e);
}
function Pot(e) {
  this.config.exit.data.call(this, e);
  const t = this.stack[this.stack.length - 1];
  t.type, t.url = "http://" + this.sliceSerialize(e);
}
function Mot(e) {
  this.config.exit.autolinkEmail.call(this, e);
}
function Uot(e) {
  this.exit(e);
}
function Bot(e) {
  bot(
    e,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, Fot],
      [new RegExp("(?<=^|\\s|\\p{P}|\\p{S})([-.\\w+]+)@([-\\w]+(?:\\.[-\\w]+)+)", "gu"), Hot]
    ],
    { ignore: ["link", "linkReference"] }
  );
}
function Fot(e, t, i, n, s) {
  let o = "";
  if (!b6e(s) || (/^w/i.test(t) && (i = t + i, t = "", o = "http://"), !Got(i)))
    return !1;
  const r = kot(i + n);
  if (!r[0]) return !1;
  const l = {
    type: "link",
    title: null,
    url: o + t + r[0],
    children: [{ type: "text", value: t + r[0] }]
  };
  return r[1] ? [l, { type: "text", value: r[1] }] : l;
}
function Hot(e, t, i, n) {
  return (
    // Not an expected previous character.
    !b6e(n, !0) || // Label ends in not allowed character.
    /[-\d_]$/.test(i) ? !1 : {
      type: "link",
      title: null,
      url: "mailto:" + t + "@" + i,
      children: [{ type: "text", value: t + "@" + i }]
    }
  );
}
function Got(e) {
  const t = e.split(".");
  return !(t.length < 2 || t[t.length - 1] && (/_/.test(t[t.length - 1]) || !/[a-zA-Z\d]/.test(t[t.length - 1])) || t[t.length - 2] && (/_/.test(t[t.length - 2]) || !/[a-zA-Z\d]/.test(t[t.length - 2])));
}
function kot(e) {
  const t = /[!"&'),.:;<>?\]}]+$/.exec(e);
  if (!t)
    return [e, void 0];
  e = e.slice(0, t.index);
  let i = t[0], n = i.indexOf(")");
  const s = G4e(e, "(");
  let o = G4e(e, ")");
  for (; n !== -1 && s > o; )
    e += i.slice(0, n + 1), i = i.slice(n + 1), n = i.indexOf(")"), o++;
  return [e, i];
}
function b6e(e, t) {
  const i = e.input.charCodeAt(e.index - 1);
  return (e.index === 0 || NH(i) || Lue(i)) && // If it’s an email, the previous character should not be a slash.
  (!t || i !== 47);
}
N6e.peek = Zot;
function Vot() {
  this.buffer();
}
function zot(e) {
  this.enter({ type: "footnoteReference", identifier: "", label: "" }, e);
}
function jot() {
  this.buffer();
}
function Wot(e) {
  this.enter(
    { type: "footnoteDefinition", identifier: "", label: "", children: [] },
    e
  );
}
function Yot(e) {
  const t = this.resume(), i = this.stack[this.stack.length - 1];
  i.type, i.identifier = _A(
    this.sliceSerialize(e)
  ).toLowerCase(), i.label = t;
}
function qot(e) {
  this.exit(e);
}
function $ot(e) {
  const t = this.resume(), i = this.stack[this.stack.length - 1];
  i.type, i.identifier = _A(
    this.sliceSerialize(e)
  ).toLowerCase(), i.label = t;
}
function Kot(e) {
  this.exit(e);
}
function Zot() {
  return "[";
}
function N6e(e, t, i, n) {
  const s = i.createTracker(n);
  let o = s.move("[^");
  const r = i.enter("footnoteReference"), l = i.enter("reference");
  return o += s.move(
    i.safe(i.associationId(e), { after: "]", before: o })
  ), l(), r(), o += s.move("]"), o;
}
function Qot() {
  return {
    enter: {
      gfmFootnoteCallString: Vot,
      gfmFootnoteCall: zot,
      gfmFootnoteDefinitionLabelString: jot,
      gfmFootnoteDefinition: Wot
    },
    exit: {
      gfmFootnoteCallString: Yot,
      gfmFootnoteCall: qot,
      gfmFootnoteDefinitionLabelString: $ot,
      gfmFootnoteDefinition: Kot
    }
  };
}
function Jot(e) {
  let t = !1;
  return e && e.firstLineBlank && (t = !0), {
    handlers: { footnoteDefinition: i, footnoteReference: N6e },
    // This is on by default already.
    unsafe: [{ character: "[", inConstruct: ["label", "phrasing", "reference"] }]
  };
  function i(n, s, o, r) {
    const l = o.createTracker(r);
    let c = l.move("[^");
    const h = o.enter("footnoteDefinition"), I = o.enter("label");
    return c += l.move(
      o.safe(o.associationId(n), { before: c, after: "]" })
    ), I(), c += l.move("]:"), n.children && n.children.length > 0 && (l.shift(4), c += l.move(
      (t ? `
` : " ") + o.indentLines(
        o.containerFlow(n, l.current()),
        t ? D6e : Xot
      )
    )), h(), c;
  }
}
function Xot(e, t, i) {
  return t === 0 ? e : D6e(e, t, i);
}
function D6e(e, t, i) {
  return (i ? "" : "    ") + e;
}
const ert = [
  "autolink",
  "destinationLiteral",
  "destinationRaw",
  "reference",
  "titleQuote",
  "titleApostrophe"
];
C6e.peek = ort;
function trt() {
  return {
    canContainEols: ["delete"],
    enter: { strikethrough: nrt },
    exit: { strikethrough: srt }
  };
}
function irt() {
  return {
    unsafe: [
      {
        character: "~",
        inConstruct: "phrasing",
        notInConstruct: ert
      }
    ],
    handlers: { delete: C6e }
  };
}
function nrt(e) {
  this.enter({ type: "delete", children: [] }, e);
}
function srt(e) {
  this.exit(e);
}
function C6e(e, t, i, n) {
  const s = i.createTracker(n), o = i.enter("strikethrough");
  let r = s.move("~~");
  return r += i.containerPhrasing(e, {
    ...s.current(),
    before: r,
    after: "~"
  }), r += s.move("~~"), o(), r;
}
function ort() {
  return "~";
}
function rrt(e) {
  return e.length;
}
function lrt(e, t) {
  const i = t || {}, n = (i.align || []).concat(), s = i.stringLength || rrt, o = [], r = [], l = [], c = [];
  let h = 0, I = -1;
  for (; ++I < e.length; ) {
    const C = [], O = [];
    let R = -1;
    for (e[I].length > h && (h = e[I].length); ++R < e[I].length; ) {
      const F = art(e[I][R]);
      if (i.alignDelimiters !== !1) {
        const L = s(F);
        O[R] = L, (c[R] === void 0 || L > c[R]) && (c[R] = L);
      }
      C.push(F);
    }
    r[I] = C, l[I] = O;
  }
  let p = -1;
  if (typeof n == "object" && "length" in n)
    for (; ++p < h; )
      o[p] = k4e(n[p]);
  else {
    const C = k4e(n);
    for (; ++p < h; )
      o[p] = C;
  }
  p = -1;
  const y = [], m = [];
  for (; ++p < h; ) {
    const C = o[p];
    let O = "", R = "";
    C === 99 ? (O = ":", R = ":") : C === 108 ? O = ":" : C === 114 && (R = ":");
    let F = i.alignDelimiters === !1 ? 1 : Math.max(
      1,
      c[p] - O.length - R.length
    );
    const L = O + "-".repeat(F) + R;
    i.alignDelimiters !== !1 && (F = O.length + F + R.length, F > c[p] && (c[p] = F), m[p] = F), y[p] = L;
  }
  r.splice(1, 0, y), l.splice(1, 0, m), I = -1;
  const A = [];
  for (; ++I < r.length; ) {
    const C = r[I], O = l[I];
    p = -1;
    const R = [];
    for (; ++p < h; ) {
      const F = C[p] || "";
      let L = "", P = "";
      if (i.alignDelimiters !== !1) {
        const z = c[p] - (O[p] || 0), W = o[p];
        W === 114 ? L = " ".repeat(z) : W === 99 ? z % 2 ? (L = " ".repeat(z / 2 + 0.5), P = " ".repeat(z / 2 - 0.5)) : (L = " ".repeat(z / 2), P = L) : P = " ".repeat(z);
      }
      i.delimiterStart !== !1 && !p && R.push("|"), i.padding !== !1 && // Don’t add the opening space if we’re not aligning and the cell is
      // empty: there will be a closing space.
      !(i.alignDelimiters === !1 && F === "") && (i.delimiterStart !== !1 || p) && R.push(" "), i.alignDelimiters !== !1 && R.push(L), R.push(F), i.alignDelimiters !== !1 && R.push(P), i.padding !== !1 && R.push(" "), (i.delimiterEnd !== !1 || p !== h - 1) && R.push("|");
    }
    A.push(
      i.delimiterEnd === !1 ? R.join("").replace(/ +$/, "") : R.join("")
    );
  }
  return A.join(`
`);
}
function art(e) {
  return e == null ? "" : String(e);
}
function k4e(e) {
  const t = typeof e == "string" ? e.codePointAt(0) : 0;
  return t === 67 || t === 99 ? 99 : t === 76 || t === 108 ? 108 : t === 82 || t === 114 ? 114 : 0;
}
function urt(e, t, i, n) {
  const s = i.enter("blockquote"), o = i.createTracker(n);
  o.move("> "), o.shift(2);
  const r = i.indentLines(
    i.containerFlow(e, o.current()),
    drt
  );
  return s(), r;
}
function drt(e, t, i) {
  return ">" + (i ? "" : " ") + e;
}
function crt(e, t) {
  return V4e(e, t.inConstruct, !0) && !V4e(e, t.notInConstruct, !1);
}
function V4e(e, t, i) {
  if (typeof t == "string" && (t = [t]), !t || t.length === 0)
    return i;
  let n = -1;
  for (; ++n < t.length; )
    if (e.includes(t[n]))
      return !0;
  return !1;
}
function z4e(e, t, i, n) {
  let s = -1;
  for (; ++s < i.unsafe.length; )
    if (i.unsafe[s].character === `
` && crt(i.stack, i.unsafe[s]))
      return /[ \t]/.test(n.before) ? "" : " ";
  return `\\
`;
}
function hrt(e, t) {
  const i = String(e);
  let n = i.indexOf(t), s = n, o = 0, r = 0;
  if (typeof t != "string")
    throw new TypeError("Expected substring");
  for (; n !== -1; )
    n === s ? ++o > r && (r = o) : o = 1, s = n + t.length, n = i.indexOf(t, s);
  return r;
}
function frt(e, t) {
  return !!(t.options.fences === !1 && e.value && // If there’s no info…
  !e.lang && // And there’s a non-whitespace character…
  /[^ \r\n]/.test(e.value) && // And the value doesn’t start or end in a blank…
  !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(e.value));
}
function Irt(e) {
  const t = e.options.fence || "`";
  if (t !== "`" && t !== "~")
    throw new Error(
      "Cannot serialize code with `" + t + "` for `options.fence`, expected `` ` `` or `~`"
    );
  return t;
}
function prt(e, t, i, n) {
  const s = Irt(i), o = e.value || "", r = s === "`" ? "GraveAccent" : "Tilde";
  if (frt(e, i)) {
    const p = i.enter("codeIndented"), y = i.indentLines(o, mrt);
    return p(), y;
  }
  const l = i.createTracker(n), c = s.repeat(Math.max(hrt(o, s) + 1, 3)), h = i.enter("codeFenced");
  let I = l.move(c);
  if (e.lang) {
    const p = i.enter(`codeFencedLang${r}`);
    I += l.move(
      i.safe(e.lang, {
        before: I,
        after: " ",
        encode: ["`"],
        ...l.current()
      })
    ), p();
  }
  if (e.lang && e.meta) {
    const p = i.enter(`codeFencedMeta${r}`);
    I += l.move(" "), I += l.move(
      i.safe(e.meta, {
        before: I,
        after: `
`,
        encode: ["`"],
        ...l.current()
      })
    ), p();
  }
  return I += l.move(`
`), o && (I += l.move(o + `
`)), I += l.move(c), h(), I;
}
function mrt(e, t, i) {
  return (i ? "" : "    ") + e;
}
function c3e(e) {
  const t = e.options.quote || '"';
  if (t !== '"' && t !== "'")
    throw new Error(
      "Cannot serialize title with `" + t + "` for `options.quote`, expected `\"`, or `'`"
    );
  return t;
}
function yrt(e, t, i, n) {
  const s = c3e(i), o = s === '"' ? "Quote" : "Apostrophe", r = i.enter("definition");
  let l = i.enter("label");
  const c = i.createTracker(n);
  let h = c.move("[");
  return h += c.move(
    i.safe(i.associationId(e), {
      before: h,
      after: "]",
      ...c.current()
    })
  ), h += c.move("]: "), l(), // If there’s no url, or…
  !e.url || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (l = i.enter("destinationLiteral"), h += c.move("<"), h += c.move(
    i.safe(e.url, { before: h, after: ">", ...c.current() })
  ), h += c.move(">")) : (l = i.enter("destinationRaw"), h += c.move(
    i.safe(e.url, {
      before: h,
      after: e.title ? " " : `
`,
      ...c.current()
    })
  )), l(), e.title && (l = i.enter(`title${o}`), h += c.move(" " + s), h += c.move(
    i.safe(e.title, {
      before: h,
      after: s,
      ...c.current()
    })
  ), h += c.move(s), l()), r(), h;
}
function Ert(e) {
  const t = e.options.emphasis || "*";
  if (t !== "*" && t !== "_")
    throw new Error(
      "Cannot serialize emphasis with `" + t + "` for `options.emphasis`, expected `*`, or `_`"
    );
  return t;
}
function WX(e) {
  return "&#x" + e.toString(16).toUpperCase() + ";";
}
function Hle(e, t, i) {
  const n = $W(e), s = $W(t);
  return n === void 0 ? s === void 0 ? (
    // Letter inside:
    // we have to encode *both* letters for `_` as it is looser.
    // it already forms for `*` (and GFMs `~`).
    i === "_" ? { inside: !0, outside: !0 } : { inside: !1, outside: !1 }
  ) : s === 1 ? (
    // Whitespace inside: encode both (letter, whitespace).
    { inside: !0, outside: !0 }
  ) : (
    // Punctuation inside: encode outer (letter)
    { inside: !1, outside: !0 }
  ) : n === 1 ? s === void 0 ? (
    // Letter inside: already forms.
    { inside: !1, outside: !1 }
  ) : s === 1 ? (
    // Whitespace inside: encode both (whitespace).
    { inside: !0, outside: !0 }
  ) : (
    // Punctuation inside: already forms.
    { inside: !1, outside: !1 }
  ) : s === void 0 ? (
    // Letter inside: already forms.
    { inside: !1, outside: !1 }
  ) : s === 1 ? (
    // Whitespace inside: encode inner (whitespace).
    { inside: !0, outside: !1 }
  ) : (
    // Punctuation inside: already forms.
    { inside: !1, outside: !1 }
  );
}
O6e.peek = grt;
function O6e(e, t, i, n) {
  const s = Ert(i), o = i.enter("emphasis"), r = i.createTracker(n), l = r.move(s);
  let c = r.move(
    i.containerPhrasing(e, {
      after: s,
      before: l,
      ...r.current()
    })
  );
  const h = c.charCodeAt(0), I = Hle(
    n.before.charCodeAt(n.before.length - 1),
    h,
    s
  );
  I.inside && (c = WX(h) + c.slice(1));
  const p = c.charCodeAt(c.length - 1), y = Hle(n.after.charCodeAt(0), p, s);
  y.inside && (c = c.slice(0, -1) + WX(p));
  const m = r.move(s);
  return o(), i.attentionEncodeSurroundingInfo = {
    after: y.outside,
    before: I.outside
  }, l + c + m;
}
function grt(e, t, i) {
  return i.options.emphasis || "*";
}
function wrt(e, t) {
  let i = !1;
  return Uue(e, function(n) {
    if ("value" in n && /\r?\n|\r/.test(n.value) || n.type === "break")
      return i = !0, spe;
  }), !!((!e.depth || e.depth < 3) && Qme(e) && (t.options.setext || i));
}
function Trt(e, t, i, n) {
  const s = Math.max(Math.min(6, e.depth || 1), 1), o = i.createTracker(n);
  if (wrt(e, i)) {
    const I = i.enter("headingSetext"), p = i.enter("phrasing"), y = i.containerPhrasing(e, {
      ...o.current(),
      before: `
`,
      after: `
`
    });
    return p(), I(), y + `
` + (s === 1 ? "=" : "-").repeat(
      // The whole size…
      y.length - // Minus the position of the character after the last EOL (or
      // 0 if there is none)…
      (Math.max(y.lastIndexOf("\r"), y.lastIndexOf(`
`)) + 1)
    );
  }
  const r = "#".repeat(s), l = i.enter("headingAtx"), c = i.enter("phrasing");
  o.move(r + " ");
  let h = i.containerPhrasing(e, {
    before: "# ",
    after: `
`,
    ...o.current()
  });
  return /^[\t ]/.test(h) && (h = WX(h.charCodeAt(0)) + h.slice(1)), h = h ? r + " " + h : r, i.options.closeAtx && (h += " " + r), c(), l(), h;
}
L6e.peek = Rrt;
function L6e(e) {
  return e.value || "";
}
function Rrt() {
  return "<";
}
_6e.peek = vrt;
function _6e(e, t, i, n) {
  const s = c3e(i), o = s === '"' ? "Quote" : "Apostrophe", r = i.enter("image");
  let l = i.enter("label");
  const c = i.createTracker(n);
  let h = c.move("![");
  return h += c.move(
    i.safe(e.alt, { before: h, after: "]", ...c.current() })
  ), h += c.move("]("), l(), // If there’s no url but there is a title…
  !e.url && e.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (l = i.enter("destinationLiteral"), h += c.move("<"), h += c.move(
    i.safe(e.url, { before: h, after: ">", ...c.current() })
  ), h += c.move(">")) : (l = i.enter("destinationRaw"), h += c.move(
    i.safe(e.url, {
      before: h,
      after: e.title ? " " : ")",
      ...c.current()
    })
  )), l(), e.title && (l = i.enter(`title${o}`), h += c.move(" " + s), h += c.move(
    i.safe(e.title, {
      before: h,
      after: s,
      ...c.current()
    })
  ), h += c.move(s), l()), h += c.move(")"), r(), h;
}
function vrt() {
  return "!";
}
x6e.peek = Art;
function x6e(e, t, i, n) {
  const s = e.referenceType, o = i.enter("imageReference");
  let r = i.enter("label");
  const l = i.createTracker(n);
  let c = l.move("![");
  const h = i.safe(e.alt, {
    before: c,
    after: "]",
    ...l.current()
  });
  c += l.move(h + "]["), r();
  const I = i.stack;
  i.stack = [], r = i.enter("reference");
  const p = i.safe(i.associationId(e), {
    before: c,
    after: "]",
    ...l.current()
  });
  return r(), i.stack = I, o(), s === "full" || !h || h !== p ? c += l.move(p + "]") : s === "shortcut" ? c = c.slice(0, -1) : c += l.move("]"), c;
}
function Art() {
  return "!";
}
P6e.peek = Srt;
function P6e(e, t, i) {
  let n = e.value || "", s = "`", o = -1;
  for (; new RegExp("(^|[^`])" + s + "([^`]|$)").test(n); )
    s += "`";
  for (/[^ \r\n]/.test(n) && (/^[ \r\n]/.test(n) && /[ \r\n]$/.test(n) || /^`|`$/.test(n)) && (n = " " + n + " "); ++o < i.unsafe.length; ) {
    const r = i.unsafe[o], l = i.compilePattern(r);
    let c;
    if (r.atBreak)
      for (; c = l.exec(n); ) {
        let h = c.index;
        n.charCodeAt(h) === 10 && n.charCodeAt(h - 1) === 13 && h--, n = n.slice(0, h) + " " + n.slice(c.index + 1);
      }
  }
  return s + n + s;
}
function Srt() {
  return "`";
}
function M6e(e, t) {
  const i = Qme(e);
  return !!(!t.options.resourceLink && // If there’s a url…
  e.url && // And there’s a no title…
  !e.title && // And the content of `node` is a single text node…
  e.children && e.children.length === 1 && e.children[0].type === "text" && // And if the url is the same as the content…
  (i === e.url || "mailto:" + i === e.url) && // And that starts w/ a protocol…
  /^[a-z][a-z+.-]+:/i.test(e.url) && // And that doesn’t contain ASCII control codes (character escapes and
  // references don’t work), space, or angle brackets…
  !/[\0- <>\u007F]/.test(e.url));
}
U6e.peek = brt;
function U6e(e, t, i, n) {
  const s = c3e(i), o = s === '"' ? "Quote" : "Apostrophe", r = i.createTracker(n);
  let l, c;
  if (M6e(e, i)) {
    const I = i.stack;
    i.stack = [], l = i.enter("autolink");
    let p = r.move("<");
    return p += r.move(
      i.containerPhrasing(e, {
        before: p,
        after: ">",
        ...r.current()
      })
    ), p += r.move(">"), l(), i.stack = I, p;
  }
  l = i.enter("link"), c = i.enter("label");
  let h = r.move("[");
  return h += r.move(
    i.containerPhrasing(e, {
      before: h,
      after: "](",
      ...r.current()
    })
  ), h += r.move("]("), c(), // If there’s no url but there is a title…
  !e.url && e.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (c = i.enter("destinationLiteral"), h += r.move("<"), h += r.move(
    i.safe(e.url, { before: h, after: ">", ...r.current() })
  ), h += r.move(">")) : (c = i.enter("destinationRaw"), h += r.move(
    i.safe(e.url, {
      before: h,
      after: e.title ? " " : ")",
      ...r.current()
    })
  )), c(), e.title && (c = i.enter(`title${o}`), h += r.move(" " + s), h += r.move(
    i.safe(e.title, {
      before: h,
      after: s,
      ...r.current()
    })
  ), h += r.move(s), c()), h += r.move(")"), l(), h;
}
function brt(e, t, i) {
  return M6e(e, i) ? "<" : "[";
}
B6e.peek = Nrt;
function B6e(e, t, i, n) {
  const s = e.referenceType, o = i.enter("linkReference");
  let r = i.enter("label");
  const l = i.createTracker(n);
  let c = l.move("[");
  const h = i.containerPhrasing(e, {
    before: c,
    after: "]",
    ...l.current()
  });
  c += l.move(h + "]["), r();
  const I = i.stack;
  i.stack = [], r = i.enter("reference");
  const p = i.safe(i.associationId(e), {
    before: c,
    after: "]",
    ...l.current()
  });
  return r(), i.stack = I, o(), s === "full" || !h || h !== p ? c += l.move(p + "]") : s === "shortcut" ? c = c.slice(0, -1) : c += l.move("]"), c;
}
function Nrt() {
  return "[";
}
function h3e(e) {
  const t = e.options.bullet || "*";
  if (t !== "*" && t !== "+" && t !== "-")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bullet`, expected `*`, `+`, or `-`"
    );
  return t;
}
function Drt(e) {
  const t = h3e(e), i = e.options.bulletOther;
  if (!i)
    return t === "*" ? "-" : "*";
  if (i !== "*" && i !== "+" && i !== "-")
    throw new Error(
      "Cannot serialize items with `" + i + "` for `options.bulletOther`, expected `*`, `+`, or `-`"
    );
  if (i === t)
    throw new Error(
      "Expected `bullet` (`" + t + "`) and `bulletOther` (`" + i + "`) to be different"
    );
  return i;
}
function Crt(e) {
  const t = e.options.bulletOrdered || ".";
  if (t !== "." && t !== ")")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bulletOrdered`, expected `.` or `)`"
    );
  return t;
}
function F6e(e) {
  const t = e.options.rule || "*";
  if (t !== "*" && t !== "-" && t !== "_")
    throw new Error(
      "Cannot serialize rules with `" + t + "` for `options.rule`, expected `*`, `-`, or `_`"
    );
  return t;
}
function Ort(e, t, i, n) {
  const s = i.enter("list"), o = i.bulletCurrent;
  let r = e.ordered ? Crt(i) : h3e(i);
  const l = e.ordered ? r === "." ? ")" : "." : Drt(i);
  let c = t && i.bulletLastUsed ? r === i.bulletLastUsed : !1;
  if (!e.ordered) {
    const I = e.children ? e.children[0] : void 0;
    if (
      // Bullet could be used as a thematic break marker:
      (r === "*" || r === "-") && // Empty first list item:
      I && (!I.children || !I.children[0]) && // Directly in two other list items:
      i.stack[i.stack.length - 1] === "list" && i.stack[i.stack.length - 2] === "listItem" && i.stack[i.stack.length - 3] === "list" && i.stack[i.stack.length - 4] === "listItem" && // That are each the first child.
      i.indexStack[i.indexStack.length - 1] === 0 && i.indexStack[i.indexStack.length - 2] === 0 && i.indexStack[i.indexStack.length - 3] === 0 && (c = !0), F6e(i) === r && I
    ) {
      let p = -1;
      for (; ++p < e.children.length; ) {
        const y = e.children[p];
        if (y && y.type === "listItem" && y.children && y.children[0] && y.children[0].type === "thematicBreak") {
          c = !0;
          break;
        }
      }
    }
  }
  c && (r = l), i.bulletCurrent = r;
  const h = i.containerFlow(e, n);
  return i.bulletLastUsed = r, i.bulletCurrent = o, s(), h;
}
function Lrt(e) {
  const t = e.options.listItemIndent || "one";
  if (t !== "tab" && t !== "one" && t !== "mixed")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`"
    );
  return t;
}
function _rt(e, t, i, n) {
  const s = Lrt(i);
  let o = i.bulletCurrent || h3e(i);
  t && t.type === "list" && t.ordered && (o = (typeof t.start == "number" && t.start > -1 ? t.start : 1) + (i.options.incrementListMarker === !1 ? 0 : t.children.indexOf(e)) + o);
  let r = o.length + 1;
  (s === "tab" || s === "mixed" && (t && t.type === "list" && t.spread || e.spread)) && (r = Math.ceil(r / 4) * 4);
  const l = i.createTracker(n);
  l.move(o + " ".repeat(r - o.length)), l.shift(r);
  const c = i.enter("listItem"), h = i.indentLines(
    i.containerFlow(e, l.current()),
    I
  );
  return c(), h;
  function I(p, y, m) {
    return y ? (m ? "" : " ".repeat(r)) + p : (m ? o : o + " ".repeat(r - o.length)) + p;
  }
}
function xrt(e, t, i, n) {
  const s = i.enter("paragraph"), o = i.enter("phrasing"), r = i.containerPhrasing(e, n);
  return o(), s(), r;
}
const Prt = (
  /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */
  Pue([
    "break",
    "delete",
    "emphasis",
    // To do: next major: removed since footnotes were added to GFM.
    "footnote",
    "footnoteReference",
    "image",
    "imageReference",
    "inlineCode",
    // Enabled by `mdast-util-math`:
    "inlineMath",
    "link",
    "linkReference",
    // Enabled by `mdast-util-mdx`:
    "mdxJsxTextElement",
    // Enabled by `mdast-util-mdx`:
    "mdxTextExpression",
    "strong",
    "text",
    // Enabled by `mdast-util-directive`:
    "textDirective"
  ])
);
function Mrt(e, t, i, n) {
  return (e.children.some(function(r) {
    return Prt(r);
  }) ? i.containerPhrasing : i.containerFlow).call(i, e, n);
}
function Urt(e) {
  const t = e.options.strong || "*";
  if (t !== "*" && t !== "_")
    throw new Error(
      "Cannot serialize strong with `" + t + "` for `options.strong`, expected `*`, or `_`"
    );
  return t;
}
H6e.peek = Brt;
function H6e(e, t, i, n) {
  const s = Urt(i), o = i.enter("strong"), r = i.createTracker(n), l = r.move(s + s);
  let c = r.move(
    i.containerPhrasing(e, {
      after: s,
      before: l,
      ...r.current()
    })
  );
  const h = c.charCodeAt(0), I = Hle(
    n.before.charCodeAt(n.before.length - 1),
    h,
    s
  );
  I.inside && (c = WX(h) + c.slice(1));
  const p = c.charCodeAt(c.length - 1), y = Hle(n.after.charCodeAt(0), p, s);
  y.inside && (c = c.slice(0, -1) + WX(p));
  const m = r.move(s + s);
  return o(), i.attentionEncodeSurroundingInfo = {
    after: y.outside,
    before: I.outside
  }, l + c + m;
}
function Brt(e, t, i) {
  return i.options.strong || "*";
}
function Frt(e, t, i, n) {
  return i.safe(e.value, n);
}
function Hrt(e) {
  const t = e.options.ruleRepetition || 3;
  if (t < 3)
    throw new Error(
      "Cannot serialize rules with repetition `" + t + "` for `options.ruleRepetition`, expected `3` or more"
    );
  return t;
}
function Grt(e, t, i) {
  const n = (F6e(i) + (i.options.ruleSpaces ? " " : "")).repeat(Hrt(i));
  return i.options.ruleSpaces ? n.slice(0, -1) : n;
}
const G6e = {
  blockquote: urt,
  break: z4e,
  code: prt,
  definition: yrt,
  emphasis: O6e,
  hardBreak: z4e,
  heading: Trt,
  html: L6e,
  image: _6e,
  imageReference: x6e,
  inlineCode: P6e,
  link: U6e,
  linkReference: B6e,
  list: Ort,
  listItem: _rt,
  paragraph: xrt,
  root: Mrt,
  strong: H6e,
  text: Frt,
  thematicBreak: Grt
};
function krt() {
  return {
    enter: {
      table: Vrt,
      tableData: j4e,
      tableHeader: j4e,
      tableRow: jrt
    },
    exit: {
      codeText: Wrt,
      table: zrt,
      tableData: d0e,
      tableHeader: d0e,
      tableRow: d0e
    }
  };
}
function Vrt(e) {
  const t = e._align;
  this.enter(
    {
      type: "table",
      align: t.map(function(i) {
        return i === "none" ? null : i;
      }),
      children: []
    },
    e
  ), this.data.inTable = !0;
}
function zrt(e) {
  this.exit(e), this.data.inTable = void 0;
}
function jrt(e) {
  this.enter({ type: "tableRow", children: [] }, e);
}
function d0e(e) {
  this.exit(e);
}
function j4e(e) {
  this.enter({ type: "tableCell", children: [] }, e);
}
function Wrt(e) {
  let t = this.resume();
  this.data.inTable && (t = t.replace(/\\([\\|])/g, Yrt));
  const i = this.stack[this.stack.length - 1];
  i.type, i.value = t, this.exit(e);
}
function Yrt(e, t) {
  return t === "|" ? t : e;
}
function qrt(e) {
  const t = e || {}, i = t.tableCellPadding, n = t.tablePipeAlign, s = t.stringLength, o = i ? " " : "|";
  return {
    unsafe: [
      { character: "\r", inConstruct: "tableCell" },
      { character: `
`, inConstruct: "tableCell" },
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      { atBreak: !0, character: "|", after: "[	 :-]" },
      // A pipe in a cell must be encoded.
      { character: "|", inConstruct: "tableCell" },
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      { atBreak: !0, character: ":", after: "-" },
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      { atBreak: !0, character: "-", after: "[:|-]" }
    ],
    handlers: {
      inlineCode: y,
      table: r,
      tableCell: c,
      tableRow: l
    }
  };
  function r(m, A, C, O) {
    return h(I(m, C, O), m.align);
  }
  function l(m, A, C, O) {
    const R = p(m, C, O), F = h([R]);
    return F.slice(0, F.indexOf(`
`));
  }
  function c(m, A, C, O) {
    const R = C.enter("tableCell"), F = C.enter("phrasing"), L = C.containerPhrasing(m, {
      ...O,
      before: o,
      after: o
    });
    return F(), R(), L;
  }
  function h(m, A) {
    return lrt(m, {
      align: A,
      // @ts-expect-error: `markdown-table` types should support `null`.
      alignDelimiters: n,
      // @ts-expect-error: `markdown-table` types should support `null`.
      padding: i,
      // @ts-expect-error: `markdown-table` types should support `null`.
      stringLength: s
    });
  }
  function I(m, A, C) {
    const O = m.children;
    let R = -1;
    const F = [], L = A.enter("table");
    for (; ++R < O.length; )
      F[R] = p(O[R], A, C);
    return L(), F;
  }
  function p(m, A, C) {
    const O = m.children;
    let R = -1;
    const F = [], L = A.enter("tableRow");
    for (; ++R < O.length; )
      F[R] = c(O[R], m, A, C);
    return L(), F;
  }
  function y(m, A, C) {
    let O = G6e.inlineCode(m, A, C);
    return C.stack.includes("tableCell") && (O = O.replace(/\|/g, "\\$&")), O;
  }
}
function $rt() {
  return {
    exit: {
      taskListCheckValueChecked: W4e,
      taskListCheckValueUnchecked: W4e,
      paragraph: Zrt
    }
  };
}
function Krt() {
  return {
    unsafe: [{ atBreak: !0, character: "-", after: "[:|-]" }],
    handlers: { listItem: Qrt }
  };
}
function W4e(e) {
  const t = this.stack[this.stack.length - 2];
  t.type, t.checked = e.type === "taskListCheckValueChecked";
}
function Zrt(e) {
  const t = this.stack[this.stack.length - 2];
  if (t && t.type === "listItem" && typeof t.checked == "boolean") {
    const i = this.stack[this.stack.length - 1];
    i.type;
    const n = i.children[0];
    if (n && n.type === "text") {
      const s = t.children;
      let o = -1, r;
      for (; ++o < s.length; ) {
        const l = s[o];
        if (l.type === "paragraph") {
          r = l;
          break;
        }
      }
      r === i && (n.value = n.value.slice(1), n.value.length === 0 ? i.children.shift() : i.position && n.position && typeof n.position.start.offset == "number" && (n.position.start.column++, n.position.start.offset++, i.position.start = Object.assign({}, n.position.start)));
    }
  }
  this.exit(e);
}
function Qrt(e, t, i, n) {
  const s = e.children[0], o = typeof e.checked == "boolean" && s && s.type === "paragraph", r = "[" + (e.checked ? "x" : " ") + "] ", l = i.createTracker(n);
  o && l.move(r);
  let c = G6e.listItem(e, t, i, {
    ...n,
    ...l.current()
  });
  return o && (c = c.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, h)), c;
  function h(I) {
    return I + r;
  }
}
function Jrt() {
  return [
    Oot(),
    Qot(),
    trt(),
    krt(),
    $rt()
  ];
}
function Xrt(e) {
  return {
    extensions: [
      Lot(),
      Jot(e),
      irt(),
      qrt(e),
      Krt()
    ]
  };
}
const elt = {
  tokenize: rlt,
  partial: !0
}, k6e = {
  tokenize: llt,
  partial: !0
}, V6e = {
  tokenize: alt,
  partial: !0
}, z6e = {
  tokenize: ult,
  partial: !0
}, tlt = {
  tokenize: dlt,
  partial: !0
}, j6e = {
  name: "wwwAutolink",
  tokenize: slt,
  previous: Y6e
}, W6e = {
  name: "protocolAutolink",
  tokenize: olt,
  previous: q6e
}, TL = {
  name: "emailAutolink",
  tokenize: nlt,
  previous: $6e
}, c6 = {};
function ilt() {
  return {
    text: c6
  };
}
let oU = 48;
for (; oU < 123; )
  c6[oU] = TL, oU++, oU === 58 ? oU = 65 : oU === 91 && (oU = 97);
c6[43] = TL;
c6[45] = TL;
c6[46] = TL;
c6[95] = TL;
c6[72] = [TL, W6e];
c6[104] = [TL, W6e];
c6[87] = [TL, j6e];
c6[119] = [TL, j6e];
function nlt(e, t, i) {
  const n = this;
  let s, o;
  return r;
  function r(p) {
    return !fpe(p) || !$6e.call(n, n.previous) || f3e(n.events) ? i(p) : (e.enter("literalAutolink"), e.enter("literalAutolinkEmail"), l(p));
  }
  function l(p) {
    return fpe(p) ? (e.consume(p), l) : p === 64 ? (e.consume(p), c) : i(p);
  }
  function c(p) {
    return p === 46 ? e.check(tlt, I, h)(p) : p === 45 || p === 95 || h3(p) ? (o = !0, e.consume(p), c) : I(p);
  }
  function h(p) {
    return e.consume(p), s = !0, c;
  }
  function I(p) {
    return o && s && Xy(n.previous) ? (e.exit("literalAutolinkEmail"), e.exit("literalAutolink"), t(p)) : i(p);
  }
}
function slt(e, t, i) {
  const n = this;
  return s;
  function s(r) {
    return r !== 87 && r !== 119 || !Y6e.call(n, n.previous) || f3e(n.events) ? i(r) : (e.enter("literalAutolink"), e.enter("literalAutolinkWww"), e.check(elt, e.attempt(k6e, e.attempt(V6e, o), i), i)(r));
  }
  function o(r) {
    return e.exit("literalAutolinkWww"), e.exit("literalAutolink"), t(r);
  }
}
function olt(e, t, i) {
  const n = this;
  let s = "", o = !1;
  return r;
  function r(p) {
    return (p === 72 || p === 104) && q6e.call(n, n.previous) && !f3e(n.events) ? (e.enter("literalAutolink"), e.enter("literalAutolinkHttp"), s += String.fromCodePoint(p), e.consume(p), l) : i(p);
  }
  function l(p) {
    if (Xy(p) && s.length < 5)
      return s += String.fromCodePoint(p), e.consume(p), l;
    if (p === 58) {
      const y = s.toLowerCase();
      if (y === "http" || y === "https")
        return e.consume(p), c;
    }
    return i(p);
  }
  function c(p) {
    return p === 47 ? (e.consume(p), o ? h : (o = !0, c)) : i(p);
  }
  function h(p) {
    return p === null || Ple(p) || kl(p) || NH(p) || Lue(p) ? i(p) : e.attempt(k6e, e.attempt(V6e, I), i)(p);
  }
  function I(p) {
    return e.exit("literalAutolinkHttp"), e.exit("literalAutolink"), t(p);
  }
}
function rlt(e, t, i) {
  let n = 0;
  return s;
  function s(r) {
    return (r === 87 || r === 119) && n < 3 ? (n++, e.consume(r), s) : r === 46 && n === 3 ? (e.consume(r), o) : i(r);
  }
  function o(r) {
    return r === null ? i(r) : t(r);
  }
}
function llt(e, t, i) {
  let n, s, o;
  return r;
  function r(h) {
    return h === 46 || h === 95 ? e.check(z6e, c, l)(h) : h === null || kl(h) || NH(h) || h !== 45 && Lue(h) ? c(h) : (o = !0, e.consume(h), r);
  }
  function l(h) {
    return h === 95 ? n = !0 : (s = n, n = void 0), e.consume(h), r;
  }
  function c(h) {
    return s || n || !o ? i(h) : t(h);
  }
}
function alt(e, t) {
  let i = 0, n = 0;
  return s;
  function s(r) {
    return r === 40 ? (i++, e.consume(r), s) : r === 41 && n < i ? o(r) : r === 33 || r === 34 || r === 38 || r === 39 || r === 41 || r === 42 || r === 44 || r === 46 || r === 58 || r === 59 || r === 60 || r === 63 || r === 93 || r === 95 || r === 126 ? e.check(z6e, t, o)(r) : r === null || kl(r) || NH(r) ? t(r) : (e.consume(r), s);
  }
  function o(r) {
    return r === 41 && n++, e.consume(r), s;
  }
}
function ult(e, t, i) {
  return n;
  function n(l) {
    return l === 33 || l === 34 || l === 39 || l === 41 || l === 42 || l === 44 || l === 46 || l === 58 || l === 59 || l === 63 || l === 95 || l === 126 ? (e.consume(l), n) : l === 38 ? (e.consume(l), o) : l === 93 ? (e.consume(l), s) : (
      // `<` is an end.
      l === 60 || // So is whitespace.
      l === null || kl(l) || NH(l) ? t(l) : i(l)
    );
  }
  function s(l) {
    return l === null || l === 40 || l === 91 || kl(l) || NH(l) ? t(l) : n(l);
  }
  function o(l) {
    return Xy(l) ? r(l) : i(l);
  }
  function r(l) {
    return l === 59 ? (e.consume(l), n) : Xy(l) ? (e.consume(l), r) : i(l);
  }
}
function dlt(e, t, i) {
  return n;
  function n(o) {
    return e.consume(o), s;
  }
  function s(o) {
    return h3(o) ? i(o) : t(o);
  }
}
function Y6e(e) {
  return e === null || e === 40 || e === 42 || e === 95 || e === 91 || e === 93 || e === 126 || kl(e);
}
function q6e(e) {
  return !Xy(e);
}
function $6e(e) {
  return !(e === 47 || fpe(e));
}
function fpe(e) {
  return e === 43 || e === 45 || e === 46 || e === 95 || h3(e);
}
function f3e(e) {
  let t = e.length, i = !1;
  for (; t--; ) {
    const n = e[t][1];
    if ((n.type === "labelLink" || n.type === "labelImage") && !n._balanced) {
      i = !0;
      break;
    }
    if (n._gfmAutolinkLiteralWalkedInto) {
      i = !1;
      break;
    }
  }
  return e.length > 0 && !i && (e[e.length - 1][1]._gfmAutolinkLiteralWalkedInto = !0), i;
}
const clt = {
  tokenize: glt,
  partial: !0
};
function hlt() {
  return {
    document: {
      91: {
        name: "gfmFootnoteDefinition",
        tokenize: mlt,
        continuation: {
          tokenize: ylt
        },
        exit: Elt
      }
    },
    text: {
      91: {
        name: "gfmFootnoteCall",
        tokenize: plt
      },
      93: {
        name: "gfmPotentialFootnoteCall",
        add: "after",
        tokenize: flt,
        resolveTo: Ilt
      }
    }
  };
}
function flt(e, t, i) {
  const n = this;
  let s = n.events.length;
  const o = n.parser.gfmFootnotes || (n.parser.gfmFootnotes = []);
  let r;
  for (; s--; ) {
    const c = n.events[s][1];
    if (c.type === "labelImage") {
      r = c;
      break;
    }
    if (c.type === "gfmFootnoteCall" || c.type === "labelLink" || c.type === "label" || c.type === "image" || c.type === "link")
      break;
  }
  return l;
  function l(c) {
    if (!r || !r._balanced)
      return i(c);
    const h = _A(n.sliceSerialize({
      start: r.end,
      end: n.now()
    }));
    return h.codePointAt(0) !== 94 || !o.includes(h.slice(1)) ? i(c) : (e.enter("gfmFootnoteCallLabelMarker"), e.consume(c), e.exit("gfmFootnoteCallLabelMarker"), t(c));
  }
}
function Ilt(e, t) {
  let i = e.length;
  for (; i--; )
    if (e[i][1].type === "labelImage" && e[i][0] === "enter") {
      e[i][1];
      break;
    }
  e[i + 1][1].type = "data", e[i + 3][1].type = "gfmFootnoteCallLabelMarker";
  const n = {
    type: "gfmFootnoteCall",
    start: Object.assign({}, e[i + 3][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, s = {
    type: "gfmFootnoteCallMarker",
    start: Object.assign({}, e[i + 3][1].end),
    end: Object.assign({}, e[i + 3][1].end)
  };
  s.end.column++, s.end.offset++, s.end._bufferIndex++;
  const o = {
    type: "gfmFootnoteCallString",
    start: Object.assign({}, s.end),
    end: Object.assign({}, e[e.length - 1][1].start)
  }, r = {
    type: "chunkString",
    contentType: "string",
    start: Object.assign({}, o.start),
    end: Object.assign({}, o.end)
  }, l = [
    // Take the `labelImageMarker` (now `data`, the `!`)
    e[i + 1],
    e[i + 2],
    ["enter", n, t],
    // The `[`
    e[i + 3],
    e[i + 4],
    // The `^`.
    ["enter", s, t],
    ["exit", s, t],
    // Everything in between.
    ["enter", o, t],
    ["enter", r, t],
    ["exit", r, t],
    ["exit", o, t],
    // The ending (`]`, properly parsed and labelled).
    e[e.length - 2],
    e[e.length - 1],
    ["exit", n, t]
  ];
  return e.splice(i, e.length - i + 1, ...l), e;
}
function plt(e, t, i) {
  const n = this, s = n.parser.gfmFootnotes || (n.parser.gfmFootnotes = []);
  let o = 0, r;
  return l;
  function l(p) {
    return e.enter("gfmFootnoteCall"), e.enter("gfmFootnoteCallLabelMarker"), e.consume(p), e.exit("gfmFootnoteCallLabelMarker"), c;
  }
  function c(p) {
    return p !== 94 ? i(p) : (e.enter("gfmFootnoteCallMarker"), e.consume(p), e.exit("gfmFootnoteCallMarker"), e.enter("gfmFootnoteCallString"), e.enter("chunkString").contentType = "string", h);
  }
  function h(p) {
    if (
      // Too long.
      o > 999 || // Closing brace with nothing.
      p === 93 && !r || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      p === null || p === 91 || kl(p)
    )
      return i(p);
    if (p === 93) {
      e.exit("chunkString");
      const y = e.exit("gfmFootnoteCallString");
      return s.includes(_A(n.sliceSerialize(y))) ? (e.enter("gfmFootnoteCallLabelMarker"), e.consume(p), e.exit("gfmFootnoteCallLabelMarker"), e.exit("gfmFootnoteCall"), t) : i(p);
    }
    return kl(p) || (r = !0), o++, e.consume(p), p === 92 ? I : h;
  }
  function I(p) {
    return p === 91 || p === 92 || p === 93 ? (e.consume(p), o++, h) : h(p);
  }
}
function mlt(e, t, i) {
  const n = this, s = n.parser.gfmFootnotes || (n.parser.gfmFootnotes = []);
  let o, r = 0, l;
  return c;
  function c(A) {
    return e.enter("gfmFootnoteDefinition")._container = !0, e.enter("gfmFootnoteDefinitionLabel"), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(A), e.exit("gfmFootnoteDefinitionLabelMarker"), h;
  }
  function h(A) {
    return A === 94 ? (e.enter("gfmFootnoteDefinitionMarker"), e.consume(A), e.exit("gfmFootnoteDefinitionMarker"), e.enter("gfmFootnoteDefinitionLabelString"), e.enter("chunkString").contentType = "string", I) : i(A);
  }
  function I(A) {
    if (
      // Too long.
      r > 999 || // Closing brace with nothing.
      A === 93 && !l || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      A === null || A === 91 || kl(A)
    )
      return i(A);
    if (A === 93) {
      e.exit("chunkString");
      const C = e.exit("gfmFootnoteDefinitionLabelString");
      return o = _A(n.sliceSerialize(C)), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(A), e.exit("gfmFootnoteDefinitionLabelMarker"), e.exit("gfmFootnoteDefinitionLabel"), y;
    }
    return kl(A) || (l = !0), r++, e.consume(A), A === 92 ? p : I;
  }
  function p(A) {
    return A === 91 || A === 92 || A === 93 ? (e.consume(A), r++, I) : I(A);
  }
  function y(A) {
    return A === 58 ? (e.enter("definitionMarker"), e.consume(A), e.exit("definitionMarker"), s.includes(o) || s.push(o), Ar(e, m, "gfmFootnoteDefinitionWhitespace")) : i(A);
  }
  function m(A) {
    return t(A);
  }
}
function ylt(e, t, i) {
  return e.check(Vie, t, e.attempt(clt, t, i));
}
function Elt(e) {
  e.exit("gfmFootnoteDefinition");
}
function glt(e, t, i) {
  const n = this;
  return Ar(e, s, "gfmFootnoteDefinitionIndent", 5);
  function s(o) {
    const r = n.events[n.events.length - 1];
    return r && r[1].type === "gfmFootnoteDefinitionIndent" && r[2].sliceSerialize(r[1], !0).length === 4 ? t(o) : i(o);
  }
}
function wlt(e) {
  let i = (e || {}).singleTilde;
  const n = {
    name: "strikethrough",
    tokenize: o,
    resolveAll: s
  };
  return i == null && (i = !0), {
    text: {
      126: n
    },
    insideSpan: {
      null: [n]
    },
    attentionMarkers: {
      null: [126]
    }
  };
  function s(r, l) {
    let c = -1;
    for (; ++c < r.length; )
      if (r[c][0] === "enter" && r[c][1].type === "strikethroughSequenceTemporary" && r[c][1]._close) {
        let h = c;
        for (; h--; )
          if (r[h][0] === "exit" && r[h][1].type === "strikethroughSequenceTemporary" && r[h][1]._open && // If the sizes are the same:
          r[c][1].end.offset - r[c][1].start.offset === r[h][1].end.offset - r[h][1].start.offset) {
            r[c][1].type = "strikethroughSequence", r[h][1].type = "strikethroughSequence";
            const I = {
              type: "strikethrough",
              start: Object.assign({}, r[h][1].start),
              end: Object.assign({}, r[c][1].end)
            }, p = {
              type: "strikethroughText",
              start: Object.assign({}, r[h][1].end),
              end: Object.assign({}, r[c][1].start)
            }, y = [["enter", I, l], ["enter", r[h][1], l], ["exit", r[h][1], l], ["enter", p, l]], m = l.parser.constructs.insideSpan.null;
            m && R4(y, y.length, 0, _ue(m, r.slice(h + 1, c), l)), R4(y, y.length, 0, [["exit", p, l], ["enter", r[c][1], l], ["exit", r[c][1], l], ["exit", I, l]]), R4(r, h - 1, c - h + 3, y), c = h + y.length - 2;
            break;
          }
      }
    for (c = -1; ++c < r.length; )
      r[c][1].type === "strikethroughSequenceTemporary" && (r[c][1].type = "data");
    return r;
  }
  function o(r, l, c) {
    const h = this.previous, I = this.events;
    let p = 0;
    return y;
    function y(A) {
      return h === 126 && I[I.length - 1][1].type !== "characterEscape" ? c(A) : (r.enter("strikethroughSequenceTemporary"), m(A));
    }
    function m(A) {
      const C = $W(h);
      if (A === 126)
        return p > 1 ? c(A) : (r.consume(A), p++, m);
      if (p < 2 && !i) return c(A);
      const O = r.exit("strikethroughSequenceTemporary"), R = $W(A);
      return O._open = !R || R === 2 && !!C, O._close = !C || C === 2 && !!R, l(A);
    }
  }
}
class Tlt {
  /**
   * Create a new edit map.
   */
  constructor() {
    this.map = [];
  }
  /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */
  add(t, i, n) {
    Rlt(this, t, i, n);
  }
  // To do: add this when moving to `micromark`.
  // /**
  //  * Create an edit: but insert `add` before existing additions.
  //  *
  //  * @param {number} index
  //  * @param {number} remove
  //  * @param {Array<Event>} add
  //  * @returns {undefined}
  //  */
  // addBefore(index, remove, add) {
  //   addImplementation(this, index, remove, add, true)
  // }
  /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */
  consume(t) {
    if (this.map.sort(function(o, r) {
      return o[0] - r[0];
    }), this.map.length === 0)
      return;
    let i = this.map.length;
    const n = [];
    for (; i > 0; )
      i -= 1, n.push(t.slice(this.map[i][0] + this.map[i][1]), this.map[i][2]), t.length = this.map[i][0];
    n.push(t.slice()), t.length = 0;
    let s = n.pop();
    for (; s; ) {
      for (const o of s)
        t.push(o);
      s = n.pop();
    }
    this.map.length = 0;
  }
}
function Rlt(e, t, i, n) {
  let s = 0;
  if (!(i === 0 && n.length === 0)) {
    for (; s < e.map.length; ) {
      if (e.map[s][0] === t) {
        e.map[s][1] += i, e.map[s][2].push(...n);
        return;
      }
      s += 1;
    }
    e.map.push([t, i, n]);
  }
}
function vlt(e, t) {
  let i = !1;
  const n = [];
  for (; t < e.length; ) {
    const s = e[t];
    if (i) {
      if (s[0] === "enter")
        s[1].type === "tableContent" && n.push(e[t + 1][1].type === "tableDelimiterMarker" ? "left" : "none");
      else if (s[1].type === "tableContent") {
        if (e[t - 1][1].type === "tableDelimiterMarker") {
          const o = n.length - 1;
          n[o] = n[o] === "left" ? "center" : "right";
        }
      } else if (s[1].type === "tableDelimiterRow")
        break;
    } else s[0] === "enter" && s[1].type === "tableDelimiterRow" && (i = !0);
    t += 1;
  }
  return n;
}
function Alt() {
  return {
    flow: {
      null: {
        name: "table",
        tokenize: Slt,
        resolveAll: blt
      }
    }
  };
}
function Slt(e, t, i) {
  const n = this;
  let s = 0, o = 0, r;
  return l;
  function l(ee) {
    let Ne = n.events.length - 1;
    for (; Ne > -1; ) {
      const pe = n.events[Ne][1].type;
      if (pe === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
      pe === "linePrefix") Ne--;
      else break;
    }
    const Ae = Ne > -1 ? n.events[Ne][1].type : null, Oe = Ae === "tableHead" || Ae === "tableRow" ? W : c;
    return Oe === W && n.parser.lazy[n.now().line] ? i(ee) : Oe(ee);
  }
  function c(ee) {
    return e.enter("tableHead"), e.enter("tableRow"), h(ee);
  }
  function h(ee) {
    return ee === 124 || (r = !0, o += 1), I(ee);
  }
  function I(ee) {
    return ee === null ? i(ee) : vs(ee) ? o > 1 ? (o = 0, n.interrupt = !0, e.exit("tableRow"), e.enter("lineEnding"), e.consume(ee), e.exit("lineEnding"), m) : i(ee) : ir(ee) ? Ar(e, I, "whitespace")(ee) : (o += 1, r && (r = !1, s += 1), ee === 124 ? (e.enter("tableCellDivider"), e.consume(ee), e.exit("tableCellDivider"), r = !0, I) : (e.enter("data"), p(ee)));
  }
  function p(ee) {
    return ee === null || ee === 124 || kl(ee) ? (e.exit("data"), I(ee)) : (e.consume(ee), ee === 92 ? y : p);
  }
  function y(ee) {
    return ee === 92 || ee === 124 ? (e.consume(ee), p) : p(ee);
  }
  function m(ee) {
    return n.interrupt = !1, n.parser.lazy[n.now().line] ? i(ee) : (e.enter("tableDelimiterRow"), r = !1, ir(ee) ? Ar(e, A, "linePrefix", n.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(ee) : A(ee));
  }
  function A(ee) {
    return ee === 45 || ee === 58 ? O(ee) : ee === 124 ? (r = !0, e.enter("tableCellDivider"), e.consume(ee), e.exit("tableCellDivider"), C) : z(ee);
  }
  function C(ee) {
    return ir(ee) ? Ar(e, O, "whitespace")(ee) : O(ee);
  }
  function O(ee) {
    return ee === 58 ? (o += 1, r = !0, e.enter("tableDelimiterMarker"), e.consume(ee), e.exit("tableDelimiterMarker"), R) : ee === 45 ? (o += 1, R(ee)) : ee === null || vs(ee) ? P(ee) : z(ee);
  }
  function R(ee) {
    return ee === 45 ? (e.enter("tableDelimiterFiller"), F(ee)) : z(ee);
  }
  function F(ee) {
    return ee === 45 ? (e.consume(ee), F) : ee === 58 ? (r = !0, e.exit("tableDelimiterFiller"), e.enter("tableDelimiterMarker"), e.consume(ee), e.exit("tableDelimiterMarker"), L) : (e.exit("tableDelimiterFiller"), L(ee));
  }
  function L(ee) {
    return ir(ee) ? Ar(e, P, "whitespace")(ee) : P(ee);
  }
  function P(ee) {
    return ee === 124 ? A(ee) : ee === null || vs(ee) ? !r || s !== o ? z(ee) : (e.exit("tableDelimiterRow"), e.exit("tableHead"), t(ee)) : z(ee);
  }
  function z(ee) {
    return i(ee);
  }
  function W(ee) {
    return e.enter("tableRow"), re(ee);
  }
  function re(ee) {
    return ee === 124 ? (e.enter("tableCellDivider"), e.consume(ee), e.exit("tableCellDivider"), re) : ee === null || vs(ee) ? (e.exit("tableRow"), t(ee)) : ir(ee) ? Ar(e, re, "whitespace")(ee) : (e.enter("data"), ce(ee));
  }
  function ce(ee) {
    return ee === null || ee === 124 || kl(ee) ? (e.exit("data"), re(ee)) : (e.consume(ee), ee === 92 ? te : ce);
  }
  function te(ee) {
    return ee === 92 || ee === 124 ? (e.consume(ee), ce) : ce(ee);
  }
}
function blt(e, t) {
  let i = -1, n = !0, s = 0, o = [0, 0, 0, 0], r = [0, 0, 0, 0], l = !1, c = 0, h, I, p;
  const y = new Tlt();
  for (; ++i < e.length; ) {
    const m = e[i], A = m[1];
    m[0] === "enter" ? A.type === "tableHead" ? (l = !1, c !== 0 && (Y4e(y, t, c, h, I), I = void 0, c = 0), h = {
      type: "table",
      start: Object.assign({}, A.start),
      // Note: correct end is set later.
      end: Object.assign({}, A.end)
    }, y.add(i, 0, [["enter", h, t]])) : A.type === "tableRow" || A.type === "tableDelimiterRow" ? (n = !0, p = void 0, o = [0, 0, 0, 0], r = [0, i + 1, 0, 0], l && (l = !1, I = {
      type: "tableBody",
      start: Object.assign({}, A.start),
      // Note: correct end is set later.
      end: Object.assign({}, A.end)
    }, y.add(i, 0, [["enter", I, t]])), s = A.type === "tableDelimiterRow" ? 2 : I ? 3 : 1) : s && (A.type === "data" || A.type === "tableDelimiterMarker" || A.type === "tableDelimiterFiller") ? (n = !1, r[2] === 0 && (o[1] !== 0 && (r[0] = r[1], p = jse(y, t, o, s, void 0, p), o = [0, 0, 0, 0]), r[2] = i)) : A.type === "tableCellDivider" && (n ? n = !1 : (o[1] !== 0 && (r[0] = r[1], p = jse(y, t, o, s, void 0, p)), o = r, r = [o[1], i, 0, 0])) : A.type === "tableHead" ? (l = !0, c = i) : A.type === "tableRow" || A.type === "tableDelimiterRow" ? (c = i, o[1] !== 0 ? (r[0] = r[1], p = jse(y, t, o, s, i, p)) : r[1] !== 0 && (p = jse(y, t, r, s, i, p)), s = 0) : s && (A.type === "data" || A.type === "tableDelimiterMarker" || A.type === "tableDelimiterFiller") && (r[3] = i);
  }
  for (c !== 0 && Y4e(y, t, c, h, I), y.consume(t.events), i = -1; ++i < t.events.length; ) {
    const m = t.events[i];
    m[0] === "enter" && m[1].type === "table" && (m[1]._align = vlt(t.events, i));
  }
  return e;
}
function jse(e, t, i, n, s, o) {
  const r = n === 1 ? "tableHeader" : n === 2 ? "tableDelimiter" : "tableData", l = "tableContent";
  i[0] !== 0 && (o.end = Object.assign({}, tz(t.events, i[0])), e.add(i[0], 0, [["exit", o, t]]));
  const c = tz(t.events, i[1]);
  if (o = {
    type: r,
    start: Object.assign({}, c),
    // Note: correct end is set later.
    end: Object.assign({}, c)
  }, e.add(i[1], 0, [["enter", o, t]]), i[2] !== 0) {
    const h = tz(t.events, i[2]), I = tz(t.events, i[3]), p = {
      type: l,
      start: Object.assign({}, h),
      end: Object.assign({}, I)
    };
    if (e.add(i[2], 0, [["enter", p, t]]), n !== 2) {
      const y = t.events[i[2]], m = t.events[i[3]];
      if (y[1].end = Object.assign({}, m[1].end), y[1].type = "chunkText", y[1].contentType = "text", i[3] > i[2] + 1) {
        const A = i[2] + 1, C = i[3] - i[2] - 1;
        e.add(A, C, []);
      }
    }
    e.add(i[3] + 1, 0, [["exit", p, t]]);
  }
  return s !== void 0 && (o.end = Object.assign({}, tz(t.events, s)), e.add(s, 0, [["exit", o, t]]), o = void 0), o;
}
function Y4e(e, t, i, n, s) {
  const o = [], r = tz(t.events, i);
  s && (s.end = Object.assign({}, r), o.push(["exit", s, t])), n.end = Object.assign({}, r), o.push(["exit", n, t]), e.add(i + 1, 0, o);
}
function tz(e, t) {
  const i = e[t], n = i[0] === "enter" ? "start" : "end";
  return i[1][n];
}
const Nlt = {
  name: "tasklistCheck",
  tokenize: Clt
};
function Dlt() {
  return {
    text: {
      91: Nlt
    }
  };
}
function Clt(e, t, i) {
  const n = this;
  return s;
  function s(c) {
    return (
      // Exit if there’s stuff before.
      n.previous !== null || // Exit if not in the first content that is the first child of a list
      // item.
      !n._gfmTasklistFirstContentOfListItem ? i(c) : (e.enter("taskListCheck"), e.enter("taskListCheckMarker"), e.consume(c), e.exit("taskListCheckMarker"), o)
    );
  }
  function o(c) {
    return kl(c) ? (e.enter("taskListCheckValueUnchecked"), e.consume(c), e.exit("taskListCheckValueUnchecked"), r) : c === 88 || c === 120 ? (e.enter("taskListCheckValueChecked"), e.consume(c), e.exit("taskListCheckValueChecked"), r) : i(c);
  }
  function r(c) {
    return c === 93 ? (e.enter("taskListCheckMarker"), e.consume(c), e.exit("taskListCheckMarker"), e.exit("taskListCheck"), l) : i(c);
  }
  function l(c) {
    return vs(c) ? t(c) : ir(c) ? e.check({
      tokenize: Olt
    }, t, i)(c) : i(c);
  }
}
function Olt(e, t, i) {
  return Ar(e, n, "whitespace");
  function n(s) {
    return s === null ? i(s) : t(s);
  }
}
function Llt(e) {
  return vNe([
    ilt(),
    hlt(),
    wlt(e),
    Alt(),
    Dlt()
  ]);
}
const _lt = {};
function xlt(e) {
  const t = (
    /** @type {Processor<Root>} */
    this
  ), i = e || _lt, n = t.data(), s = n.micromarkExtensions || (n.micromarkExtensions = []), o = n.fromMarkdownExtensions || (n.fromMarkdownExtensions = []), r = n.toMarkdownExtensions || (n.toMarkdownExtensions = []);
  s.push(Llt(i)), o.push(Jrt()), r.push(Xrt(i));
}
const aut = ({ content: e, className: t = "" }) => /* @__PURE__ */ He.jsx(
  ait,
  {
    className: `markdown-preview overflow-x-auto ${t}`,
    remarkPlugins: [xlt],
    rehypePlugins: [Aot],
    components: {
      // Custom styling for tables
      table: ({ children: i, ...n }) => /* @__PURE__ */ He.jsx("table", { className: "min-w-full border-collapse border border-gray-300 my-4", ...n, children: i }),
      thead: ({ children: i, ...n }) => /* @__PURE__ */ He.jsx("thead", { className: "bg-gray-100", ...n, children: i }),
      th: ({ children: i, ...n }) => /* @__PURE__ */ He.jsx("th", { className: "border border-gray-300 px-4 py-2 text-left font-semibold", ...n, children: i }),
      td: ({ children: i, ...n }) => /* @__PURE__ */ He.jsx("td", { className: "border border-gray-300 px-4 py-2", ...n, children: i }),
      // Custom styling for other elements
      h1: ({ children: i, ...n }) => /* @__PURE__ */ He.jsx("h1", { className: "text-2xl font-bold mt-6 mb-4", ...n, children: i }),
      h2: ({ children: i, ...n }) => /* @__PURE__ */ He.jsx("h2", { className: "text-xl font-semibold mt-5 mb-3", ...n, children: i }),
      h3: ({ children: i, ...n }) => /* @__PURE__ */ He.jsx("h3", { className: "text-lg font-semibold mt-4 mb-2", ...n, children: i }),
      p: ({ children: i, ...n }) => /* @__PURE__ */ He.jsx("p", { className: "mb-3", ...n, children: i }),
      a: ({ children: i, ...n }) => /* @__PURE__ */ He.jsx(
        "a",
        {
          className: "text-brand-default underline",
          target: "_blank",
          rel: "noopener noreferrer",
          ...n,
          children: i
        }
      ),
      ul: ({ children: i, ...n }) => /* @__PURE__ */ He.jsx("ul", { className: "list-disc ml-6 mb-3", ...n, children: i }),
      ol: ({ children: i, ...n }) => /* @__PURE__ */ He.jsx("ol", { className: "list-decimal ml-6 mb-3", ...n, children: i }),
      li: ({ children: i, ...n }) => /* @__PURE__ */ He.jsx("li", { className: "mb-1", ...n, children: i }),
      code: (i) => {
        const { inline: n, ...s } = i;
        return n ? /* @__PURE__ */ He.jsx("code", { className: "bg-gray-100 px-1 py-0.5 rounded text-sm font-mono", ...s, children: i.children }) : /* @__PURE__ */ He.jsx(
          "code",
          {
            className: "block bg-gray-100 p-3 rounded text-sm font-mono overflow-x-auto",
            ...s,
            children: i.children
          }
        );
      },
      blockquote: ({ children: i, ...n }) => /* @__PURE__ */ He.jsx("blockquote", { className: "border-l-4 border-gray-300 pl-4 italic my-4", ...n, children: i })
    },
    children: e
  }
), uut = ({
  label: e,
  defaultOpen: t = !1,
  className: i,
  children: n
}) => {
  const [s, o] = Is(t);
  return /* @__PURE__ */ He.jsxs("div", { className: Gn(i), children: [
    /* @__PURE__ */ He.jsxs(
      "button",
      {
        onClick: () => o(!s),
        className: "fc:flex fc:items-center fc:gap-1 fc:text-xs fc:text-day-neutral-subtle fc:font-medium fc:mb-2 fc:cursor-pointer fc:hover:text-day-neutral-default fc:transition-colors",
        children: [
          s ? /* @__PURE__ */ He.jsx(xCe, { size: 12 }) : /* @__PURE__ */ He.jsx(PCe, { size: 12 }),
          e
        ]
      }
    ),
    s && /* @__PURE__ */ He.jsx("div", { className: "fc:space-y-2", children: n })
  ] });
}, dut = cE(function({
  isOpen: t,
  direction: i = "down",
  align: n = "right",
  header: s,
  footer: o,
  scrollable: r,
  width: l,
  children: c,
  className: h,
  ...I
}, p) {
  return t ? /* @__PURE__ */ He.jsxs(
    "div",
    {
      ref: p,
      role: "menu",
      tabIndex: -1,
      className: Gn(
        "fc:absolute fc:bg-white fc:border fc:border-day-light-2 fc:rounded-lg fc:shadow-xl fc:z-50",
        n === "left" ? "fc:left-0" : "fc:right-0",
        l || "fc:w-40",
        i === "up" ? "fc:bottom-full fc:mb-1" : "fc:top-full fc:mt-1",
        h
      ),
      ...I,
      children: [
        s && /* @__PURE__ */ He.jsx("div", { className: "fc:p-2 fc:border-b fc:border-day-light-3 fc:text-xs fc:font-medium fc:text-day-neutral-subtle", children: s }),
        /* @__PURE__ */ He.jsx("div", { className: Gn("fc:py-1", r && "fc:max-h-48 fc:overflow-y-auto"), children: c }),
        o && /* @__PURE__ */ He.jsx("div", { className: "fc:border-t fc:border-day-light-3 fc:p-2", children: o })
      ]
    }
  ) : null;
}), cut = cE(function({ children: t, className: i, selected: n = !1, disabled: s = !1, icon: o, ...r }, l) {
  return /* @__PURE__ */ He.jsxs(
    "button",
    {
      ref: l,
      type: "button",
      role: "menuitem",
      "aria-current": n || void 0,
      disabled: s,
      className: Gn(
        "fc:w-full fc:text-left fc:px-3 fc:py-2 fc:text-sm fc:transition-colors",
        "fc:focus:outline-hidden fc:focus:bg-day-light-4",
        {
          "fc:bg-day-light-4 fc:font-medium": n,
          "fc:hover:bg-day-light-5": !s && !n,
          "fc:cursor-not-allowed fc:opacity-50": s,
          "fc:cursor-pointer": !s
        },
        i
      ),
      ...r,
      children: [
        o && /* @__PURE__ */ He.jsx("span", { className: "fc:mr-2 fc:inline-flex fc:items-center", children: o }),
        t
      ]
    }
  );
}), hut = ({
  options: e,
  selectedValues: t,
  onChange: i,
  placeholder: n,
  emptyText: s = "No options available",
  className: o
}) => {
  const [r, l] = Is(!1), c = io(null), I = `${Z4e()}-listbox`, p = rTe({
    containerRef: c,
    isOpen: r,
    dropdownHeight: 200
  }), y = On(() => {
    l(!1);
  }, []);
  lie({
    ref: c,
    onClickOutside: y,
    enabled: r
  });
  const m = On(() => {
    l((L) => !L);
  }, []), A = On(
    (L) => {
      const P = t.includes(L);
      i(P ? t.filter((z) => z !== L) : [...t, L]);
    },
    [t, i]
  ), C = On(
    (L) => {
      L.key === "Enter" || L.key === " " ? (L.preventDefault(), m()) : L.key === "Escape" && l(!1);
    },
    [m]
  ), O = On(
    (L, P) => {
      (L.key === "Enter" || L.key === " ") && (L.preventDefault(), A(P));
    },
    [A]
  ), R = t.length > 0 ? `${n} (${t.length})` : n, F = r ? BCe : UCe;
  return /* @__PURE__ */ He.jsxs("div", { className: Gn("fc:relative", o), ref: c, children: [
    /* @__PURE__ */ He.jsxs(
      "button",
      {
        type: "button",
        role: "combobox",
        "aria-expanded": r,
        "aria-haspopup": "listbox",
        "aria-controls": I,
        className: Gn(
          "fc:flex fc:items-center fc:justify-between fc:w-full fc:px-3 fc:py-2 fc:text-sm",
          "fc:bg-white fc:border fc:rounded fc:cursor-pointer",
          "fc:hover:border-day-light-1 fc:transition-colors",
          r ? "fc:border-day-light-1 fc:ring-1 fc:ring-day-light-3" : "fc:border-day-light-2"
        ),
        onClick: m,
        onKeyDown: C,
        children: [
          /* @__PURE__ */ He.jsx(
            "span",
            {
              className: Gn(
                "fc:truncate",
                t.length === 0 && "fc:text-day-neutral-subtle"
              ),
              children: R
            }
          ),
          /* @__PURE__ */ He.jsx(F, { className: "fc:w-3 fc:h-3 fc:ml-2 fc:text-day-neutral-subtle fc:flex-shrink-0" })
        ]
      }
    ),
    r && /* @__PURE__ */ He.jsx(
      "div",
      {
        id: I,
        role: "listbox",
        "aria-label": n,
        "aria-multiselectable": "true",
        className: Gn(
          "fc:absolute fc:left-0 fc:right-0 fc:z-50 fc:bg-white fc:border fc:border-day-light-2 fc:rounded fc:shadow-lg",
          "fc:max-h-48 fc:overflow-y-auto",
          p === "up" ? "fc:bottom-full fc:mb-1" : "fc:top-full fc:mt-1"
        ),
        children: e.length === 0 ? /* @__PURE__ */ He.jsx("div", { className: "fc:px-3 fc:py-2 fc:text-sm fc:text-day-neutral-subtle", children: s }) : e.map((L) => {
          const P = t.includes(L.value);
          return /* @__PURE__ */ He.jsxs(
            "div",
            {
              role: "option",
              "aria-selected": P,
              tabIndex: 0,
              className: Gn(
                "fc:flex fc:items-center fc:gap-3 fc:px-3 fc:py-2 fc:cursor-pointer",
                "fc:hover:bg-day-light-5 fc:transition-colors",
                P && "fc:bg-day-light-5"
              ),
              onClick: () => A(L.value),
              onKeyDown: (z) => O(z, L.value),
              children: [
                /* @__PURE__ */ He.jsx(
                  "div",
                  {
                    className: Gn(
                      "fc:flex fc:items-center fc:justify-center fc:w-5 fc:h-5 fc:border fc:rounded",
                      "fc:flex-shrink-0 fc:transition-colors",
                      P ? "fc:bg-day-neutral-dark fc:border-day-neutral-dark fc:text-white" : "fc:bg-white fc:border-day-light-2"
                    ),
                    children: P && /* @__PURE__ */ He.jsx(MCe, { className: "fc:w-3 fc:h-3" })
                  }
                ),
                /* @__PURE__ */ He.jsx("span", { className: "fc:text-sm fc:truncate", children: L.label })
              ]
            },
            L.value
          );
        })
      }
    )
  ] });
}, fut = ({
  items: e,
  selectedItem: t,
  searchQuery: i,
  onSearchChange: n,
  onSelect: s,
  onClear: o,
  isLoading: r = !1,
  isError: l = !1,
  errorMessage: c,
  placeholder: h = "Search...",
  noResultsMessage: I = "No results found",
  loadingMessage: p = "Loading..."
}) => {
  const [y, m] = Is(!1), A = io(null), C = On(() => {
    m(!1);
  }, []);
  lie({ ref: A, onClickOutside: C, enabled: y });
  const O = On(
    (P) => {
      n(P.target.value), m(!0);
    },
    [n]
  ), R = On(() => {
    m(!0);
  }, []), F = On(
    (P) => {
      P.disabled || (s(P), m(!1));
    },
    [s]
  ), L = y && i.length > 0 && !l;
  return /* @__PURE__ */ He.jsxs("div", { className: "fc:relative fc:w-full", ref: A, children: [
    t !== null ? /* @__PURE__ */ He.jsxs(
      "div",
      {
        className: Gn(
          "fc:w-full fc:flex fc:items-center fc:justify-between",
          "fc:border fc:border-day-light-2 fc:rounded fc:px-3 fc:py-1",
          "fc:bg-white fc:text-day-neutral-dark"
        ),
        children: [
          /* @__PURE__ */ He.jsx("span", { className: "fc:flex-1 fc:min-w-0 fc:text-sm fc:truncate", children: t.sublabel ? `${t.label} (${t.sublabel})` : t.label }),
          /* @__PURE__ */ He.jsx(
            SCe,
            {
              onClick: o,
              ariaLabel: "Clear selection",
              size: 16,
              className: "fc:ml-2 fc:shrink-0"
            }
          )
        ]
      }
    ) : /* @__PURE__ */ He.jsxs(
      "div",
      {
        className: Gn(
          "fc:w-full fc:flex fc:items-center",
          "fc:border fc:border-day-light-2 fc:rounded fc:bg-white",
          "fc:hover:border-day-neutral-subtle"
        ),
        children: [
          /* @__PURE__ */ He.jsx(
            "input",
            {
              type: "text",
              value: i,
              onChange: O,
              onFocus: R,
              placeholder: h,
              className: "fc:flex-1 fc:min-w-0 fc:px-3 fc:py-1 fc:text-sm fc:bg-transparent fc:outline-none fc:text-day-neutral-dark fc:placeholder-day-neutral-subtle"
            }
          ),
          /* @__PURE__ */ He.jsx("div", { className: "fc:shrink-0 fc:px-2 fc:text-day-neutral-subtle fc:pointer-events-none", children: y ? /* @__PURE__ */ He.jsx(iNe, { size: 12 }) : /* @__PURE__ */ He.jsx(tNe, { size: 12 }) })
        ]
      }
    ),
    l && c && /* @__PURE__ */ He.jsx("p", { className: "fc:mt-1 fc:text-sm fc:text-error-dark", children: c }),
    L && /* @__PURE__ */ He.jsx(
      "div",
      {
        className: Gn(
          "fc:absolute fc:z-50 fc:w-full fc:bg-white",
          "fc:border fc:border-day-light-2 fc:rounded fc:shadow-lg",
          "fc:top-full fc:mt-1"
        ),
        children: /* @__PURE__ */ He.jsx("div", { className: "fc:overflow-y-auto fc:max-h-[250px]", children: r ? /* @__PURE__ */ He.jsxs("div", { className: "fc:flex fc:items-center fc:gap-2 fc:px-3 fc:py-2 fc:text-sm fc:text-day-neutral-subtle", children: [
          /* @__PURE__ */ He.jsx(jF, { size: "xsmall" }),
          /* @__PURE__ */ He.jsx("span", { children: p })
        ] }) : e.length === 0 ? /* @__PURE__ */ He.jsx("div", { className: "fc:px-3 fc:py-2 fc:text-sm fc:text-day-neutral-subtle", children: I }) : e.map((P) => /* @__PURE__ */ He.jsx(
          "button",
          {
            type: "button",
            disabled: P.disabled,
            title: P.disabled ? P.disabledTitle : void 0,
            className: Gn(
              "fc:w-full fc:text-left fc:px-3 fc:py-2 fc:text-sm",
              P.disabled ? "fc:opacity-50 fc:cursor-not-allowed" : "fc:cursor-pointer fc:hover:bg-day-light-3"
            ),
            onClick: () => F(P),
            children: P.sublabel ? /* @__PURE__ */ He.jsxs(He.Fragment, { children: [
              /* @__PURE__ */ He.jsx("span", { className: "fc:font-medium", children: P.sublabel }),
              " — ",
              P.label,
              P.disabled && P.disabledTitle && /* @__PURE__ */ He.jsxs("span", { className: "fc:ml-1 fc:text-day-neutral-subtle", children: [
                "(",
                P.disabledTitle,
                ")"
              ] })
            ] }) : /* @__PURE__ */ He.jsxs(He.Fragment, { children: [
              P.label,
              P.disabled && P.disabledTitle && /* @__PURE__ */ He.jsxs("span", { className: "fc:ml-1 fc:text-day-neutral-subtle", children: [
                "(",
                P.disabledTitle,
                ")"
              ] })
            ] })
          },
          P.key
        )) })
      }
    )
  ] });
}, Iut = ({
  items: e,
  value: t,
  onChange: i,
  isLoading: n = !1,
  isError: s = !1,
  errorMessage: o,
  isDisabled: r = !1,
  placeholder: l = "Select...",
  loadingMessage: c = "Loading..."
}) => {
  const [h, I] = Is(!1), p = io(null), y = r || n || s, m = On(() => {
    I(!1);
  }, []);
  lie({ ref: p, onClickOutside: m, enabled: h });
  const A = On(() => {
    y || I((L) => !L);
  }, [y]), C = On(
    (L) => {
      L.disabled || (i(L.key), I(!1));
    },
    [i]
  ), O = e.find((L) => L.key === t), R = n ? c : O ? O.sublabel ? `${O.label} (${O.sublabel})` : O.label : l, F = !n && !O;
  return /* @__PURE__ */ He.jsxs("div", { className: "fc:relative fc:w-full", ref: p, children: [
    /* @__PURE__ */ He.jsxs(
      "button",
      {
        type: "button",
        onClick: A,
        disabled: y,
        className: Gn(
          "fc:w-full fc:flex fc:items-center fc:justify-between",
          "fc:border fc:border-day-light-2 fc:rounded fc:px-3 fc:py-1 fc:text-sm",
          y ? "fc:bg-day-light-3 fc:text-day-neutral-subtle fc:cursor-not-allowed" : "fc:bg-white fc:text-day-neutral-dark fc:cursor-pointer fc:hover:border-day-neutral-subtle"
        ),
        children: [
          /* @__PURE__ */ He.jsxs("div", { className: "fc:flex fc:items-center fc:gap-2 fc:min-w-0", children: [
            n && /* @__PURE__ */ He.jsx(jF, { size: "xsmall" }),
            /* @__PURE__ */ He.jsx("span", { className: Gn("fc:truncate", F && "fc:text-day-neutral-subtle"), children: R })
          ] }),
          /* @__PURE__ */ He.jsx("div", { className: "fc:shrink-0 fc:ml-2", children: h ? /* @__PURE__ */ He.jsx(iNe, { size: 12 }) : /* @__PURE__ */ He.jsx(tNe, { size: 12 }) })
        ]
      }
    ),
    s && o && /* @__PURE__ */ He.jsx("p", { className: "fc:mt-1 fc:text-sm fc:text-error-dark", children: o }),
    h && !y && e.length > 0 && /* @__PURE__ */ He.jsx(
      "div",
      {
        className: Gn(
          "fc:absolute fc:z-50 fc:w-full fc:bg-white",
          "fc:border fc:border-day-light-2 fc:rounded fc:shadow-lg",
          "fc:top-full fc:mt-1"
        ),
        children: /* @__PURE__ */ He.jsx("div", { className: "fc:overflow-y-auto fc:max-h-[250px]", children: e.map((L) => /* @__PURE__ */ He.jsx(
          "button",
          {
            type: "button",
            disabled: L.disabled,
            title: L.disabled ? L.disabledTitle : void 0,
            className: Gn(
              "fc:w-full fc:text-left fc:px-3 fc:py-2 fc:text-sm",
              L.disabled ? "fc:opacity-50 fc:cursor-not-allowed" : "fc:cursor-pointer fc:hover:bg-day-light-3",
              L.key === t && !L.disabled && "fc:bg-day-light-3 fc:font-medium"
            ),
            onClick: () => C(L),
            children: L.sublabel ? /* @__PURE__ */ He.jsxs(He.Fragment, { children: [
              /* @__PURE__ */ He.jsx("span", { className: "fc:font-medium", children: L.sublabel }),
              " — ",
              L.label,
              L.disabled && L.disabledTitle && /* @__PURE__ */ He.jsxs("span", { className: "fc:ml-1 fc:text-day-neutral-subtle", children: [
                "(",
                L.disabledTitle,
                ")"
              ] })
            ] }) : /* @__PURE__ */ He.jsxs(He.Fragment, { children: [
              L.label,
              L.disabled && L.disabledTitle && /* @__PURE__ */ He.jsxs("span", { className: "fc:ml-1 fc:text-day-neutral-subtle", children: [
                "(",
                L.disabledTitle,
                ")"
              ] })
            ] })
          },
          L.key
        )) })
      }
    )
  ] });
}, put = () => {
  const { t: e } = M8();
  return /* @__PURE__ */ He.jsx("span", { className: "fc:inline-flex fc:items-center fc:px-2 fc:py-0.5 fc:rounded fc:text-xs fc:font-semibold fc:tracking-wide fc:bg-brand-default fc:text-neutral-on-brand fc:uppercase fc:self-center", children: e("common.beta") });
};
export {
  jlt as AttendeesInput,
  put as BetaBadge,
  P3e as Button,
  Blt as ButtonGroup,
  sut as Calendar,
  p0e as Checkbox,
  SCe as CloseButton,
  uut as CollapsibleSection,
  fut as Combobox,
  qlt as CustomSelect,
  lat as DEFAULT_PAGE_SIZE,
  klt as DatePicker,
  sat as Dialog,
  dut as DropdownMenu,
  zlt as DurationPicker,
  Klt as EmptySpace,
  out as EventDetailsModal,
  Wlt as FileInput,
  aat as FileUpload,
  nut as HTMLViewer,
  iut as IfcViewer,
  s6 as Label,
  JCe as LoadingArea,
  aut as MarkdownPreview,
  cut as MenuItem,
  z3e as MessagePanel,
  y0e as MessagePanelTypes,
  hut as MultiSelectDropdown,
  oat as MultipleCheckbox,
  $lt as MultipleRadioButton,
  Glt as NumberInput,
  sOe as Pagination,
  Yat as PdfViewer,
  lut as PieChart,
  nat as Popup,
  bP as Position,
  oTe as RadioButton,
  uat as Search,
  Iut as SelectMenu,
  rat as Skeleton,
  jF as Spinner,
  iat as Tab,
  Qlt as Table,
  Jlt as TableBody,
  Xlt as TableDataCell,
  eat as TableHead,
  tat as TableHeaderCell,
  XCe as TableRow,
  Ylt as TextArea,
  Hlt as TextInput,
  Vlt as TimePicker,
  bCe as TimePickerVariant,
  Flt as ToggleButtonGroup,
  BEe as facadeLanguageManager,
  Ult as t,
  rut as transformMeetingsToCalendarEvents,
  lie as useClickOutside,
  rTe as useDropdownDirection,
  Zlt as useSteps
};
